(function () {

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire25b9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire25b9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9qak9", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.6.4
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-03-08T15:28Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.6.4", // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    var Sizzle = /*!
 * Sizzle CSS Selector Engine v2.3.10
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2023-02-14
 */ function(window1) {
        var i, support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, // Local document vars
        setDocument, document, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, // Instance-specific data
        expando = "sizzle" + 1 * new Date(), preferredDoc = window1.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, // Instance methods
        hasOwn = {}.hasOwnProperty, arr = [], pop = arr.pop, pushNative = arr.push, push = arr.push, slice = arr.slice, // Use a stripped-down indexOf as it's faster than native
        // https://jsperf.com/thor-indexof-vs-for/5
        indexOf = function(list, elem) {
            var i = 0, len = list.length;
            for(; i < len; i++){
                if (list[i] === elem) return i;
            }
            return -1;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // http://www.w3.org/TR/css3-selectors/#whitespace
        whitespace = "[\\x20\\t\\r\\n\\f]", // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5]
        // or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            "ID": new RegExp("^#(" + identifier + ")"),
            "CLASS": new RegExp("^\\.(" + identifier + ")"),
            "TAG": new RegExp("^(" + identifier + "|[*])"),
            "ATTR": new RegExp("^" + attributes),
            "PSEUDO": new RegExp("^" + pseudos),
            "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            "bool": new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rhtml = /HTML$/i, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            return nonHex ? // Strip the backslash prefix from a non-hex escape sequence
            nonHex : // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // CSS string/identifier serialization
        // https://drafts.csswg.org/cssom/#common-serializing-idioms
        rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, fcssescape = function(ch, asCodePoint) {
            if (asCodePoint) {
                // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                if (ch === "\0") return "\uFFFD";
                // Control characters and (dependent upon position) numbers get escaped as code points
                return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
            }
            // Other potentially-special ASCII characters get backslash-escaped
            return "\\" + ch;
        }, // Used for iframes
        // See setDocument()
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android<4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: arr.length ? // Leverage slice if possible
                function(target, els) {
                    pushNative.apply(target, slice.call(els));
                } : // Support: IE<9
                // Otherwise append directly
                function(target, els) {
                    var j = target.length, i = 0;
                    // Can't trust NodeList.length
                    while(target[j++] = els[i++]);
                    target.length = j - 1;
                }
            };
        }
        function Sizzle(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE, Opera, Webkit
                                // TODO: identify versions
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        results.push(elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE, Opera, Webkit
                            // TODO: identify versions
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
                                results.push(elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (support.qsa && !nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector)) && // Support: IE 8 only
                    // Exclude object elements
                    (nodeType !== 1 || context.nodeName.toLowerCase() !== "object")) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            if (newContext !== context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = nid.replace(rcssescape, fcssescape);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrim, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */ function addHandle(attrs, handler) {
            var arr = attrs.split("|"), i = arr.length;
            while(i--)Expr.attrHandle[arr[i]] = handler;
        }
        /**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */ function siblingCheck(a, b) {
            var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;
            // Use IE sourceIndex if available on both nodes
            if (diff) return diff;
            // Check if b follows a
            if (cur) while(cur = cur.nextSibling){
                if (cur === b) return -1;
            }
            return a ? 1 : -1;
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return name === "input" && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return (name === "input" || name === "button") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        /* jshint -W018 */ elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        // Expose support vars for convenience
        support = Sizzle.support = {};
        /**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */ isXML = Sizzle.isXML = function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Support: IE <=8
            // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
            // https://bugs.jquery.com/ticket/4833
            return !rhtml.test(namespace || docElem && docElem.nodeName || "HTML");
        };
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ setDocument = Sizzle.setDocument = function(node) {
            var hasCompare, subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            docElem = document.documentElement;
            documentIsHTML = !isXML(document);
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
                // Support: IE 11, Edge
                if (subWindow.addEventListener) subWindow.addEventListener("unload", unloadHandler, false);
                else if (subWindow.attachEvent) subWindow.attachEvent("onunload", unloadHandler);
            }
            // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
            // Safari 4 - 5 only, Opera <=11.6 - 12.x only
            // IE/Edge & older browsers don't support the :scope pseudo-class.
            // Support: Safari 6.0 only
            // Safari 6.0 supports :scope but it's an alias of :root there.
            support.scope = assert(function(el) {
                docElem.appendChild(el).appendChild(document.createElement("div"));
                return typeof el.querySelectorAll !== "undefined" && !el.querySelectorAll(":scope fieldset div").length;
            });
            // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Make sure the the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            /* Attributes
	---------------------------------------------------------------------- */ // Support: IE<8
            // Verify that getAttribute really returns attributes and not properties
            // (excepting IE8 booleans)
            support.attributes = assert(function(el) {
                el.className = "i";
                return !el.getAttribute("className");
            });
            /* getElement(s)By*
	---------------------------------------------------------------------- */ // Check if getElementsByTagName("*") returns only elements
            support.getElementsByTagName = assert(function(el) {
                el.appendChild(document.createComment(""));
                return !el.getElementsByTagName("*").length;
            });
            // Support: IE<9
            support.getElementsByClassName = rnative.test(document.getElementsByClassName);
            // Support: IE<10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                docElem.appendChild(el).id = expando;
                return !document.getElementsByName || !document.getElementsByName(expando).length;
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find["TAG"] = support.getElementsByTagName ? function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else if (support.qsa) return context.querySelectorAll(tag);
            } : function(tag, context) {
                var elem, tmp = [], i = 0, // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                results = context.getElementsByTagName(tag);
                // Filter out possible comments
                if (tag === "*") {
                    while(elem = results[i++])if (elem.nodeType === 1) tmp.push(elem);
                    return tmp;
                }
                return results;
            };
            // Class
            Expr.find["CLASS"] = support.getElementsByClassName && function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
            rbuggyMatches = [];
            // qSa(:focus) reports false when true (Chrome 21)
            // We allow this because of a bug in IE8/9 that throws an error
            // whenever `document.activeElement` is accessed on an iframe
            // So, we allow :focus to pass through QSA all the time to avoid the IE error
            // See https://bugs.jquery.com/ticket/13378
            rbuggyQSA = [];
            if (support.qsa = rnative.test(document.querySelectorAll)) {
                // Build QSA regex
                // Regex strategy adopted from Diego Perini
                assert(function(el) {
                    var input;
                    // Select is set to empty string on purpose
                    // This is to test IE's treatment of not explicitly
                    // setting a boolean content attribute,
                    // since its presence should be enough
                    // https://bugs.jquery.com/ticket/12359
                    docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
                    // Support: IE8, Opera 11-12.16
                    // Nothing should be selected when empty strings follow ^= or $= or *=
                    // The test attribute must be unknown in Opera but "safe" for WinRT
                    // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                    if (el.querySelectorAll("[msallowcapture^='']").length) rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                    // Support: IE8
                    // Boolean attributes and "value" are not treated correctly
                    if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                    // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                    if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                    // Support: IE 11+, Edge 15 - 18+
                    // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                    // Adding a temporary attribute to the document before the selection works
                    // around the issue.
                    // Interestingly, IE 10 & older don't seem to have the issue.
                    input = document.createElement("input");
                    input.setAttribute("name", "");
                    el.appendChild(input);
                    if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
                    // Webkit/Opera - :checked should return selected option elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    // IE8 throws error here and will not see later tests
                    if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                    // Support: Safari 8+, iOS 8+
                    // https://bugs.webkit.org/show_bug.cgi?id=136851
                    // In-page `selector#id sibling-combinator selector` fails
                    if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                    // Support: Firefox <=3.6 - 5 only
                    // Old Firefox doesn't throw on a badly-escaped identifier.
                    el.querySelectorAll("\\\f");
                    rbuggyQSA.push("[\\r\\n\\f]");
                });
                assert(function(el) {
                    el.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                    // Support: Windows 8 Native Apps
                    // The type and name attributes are restricted during .innerHTML assignment
                    var input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    el.appendChild(input).setAttribute("name", "D");
                    // Support: IE8
                    // Enforce case-sensitivity of name attribute
                    if (el.querySelectorAll("[name=d]").length) rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                    // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                    // IE8 throws error here and will not see later tests
                    if (el.querySelectorAll(":enabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: IE9-11+
                    // IE's :disabled selector does not pick up the children of disabled fieldsets
                    docElem.appendChild(el).disabled = true;
                    if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: Opera 10 - 11 only
                    // Opera 10-11 does not throw on post-comma invalid pseudos
                    el.querySelectorAll("*,:x");
                    rbuggyQSA.push(",.*:");
                });
            }
            if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) assert(function(el) {
                // Check to see if it's possible to do matchesSelector
                // on a disconnected node (IE 9)
                support.disconnectedMatch = matches.call(el, "*");
                // This should fail with an exception
                // Gecko does not error, returns false instead
                matches.call(el, "[s!='']:x");
                rbuggyMatches.push("!=", pseudos);
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
            /* Contains
	---------------------------------------------------------------------- */ hasCompare = rnative.test(docElem.compareDocumentPosition);
            // Element contains another
            // Purposefully self-exclusive
            // As in, an element does not contain itself
            contains = hasCompare || rnative.test(docElem.contains) ? function(a, b) {
                // Support: IE <9 only
                // IE doesn't have `contains` on `document` so we need to check for
                // `documentElement` presence.
                // We need to fall back to `a` when `documentElement` is missing
                // as `ownerDocument` of elements within `<template/>` may have
                // a null one - a default behavior of all modern browsers.
                var adown = a.nodeType === 9 && a.documentElement || a, bup = b && b.parentNode;
                return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
            } : function(a, b) {
                if (b) while(b = b.parentNode){
                    if (b === a) return true;
                }
                return false;
            };
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = hasCompare ? function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a == document || a.ownerDocument == preferredDoc && contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b == document || b.ownerDocument == preferredDoc && contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            } : function(a, b) {
                // Exit early if the nodes are identical
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [
                    a
                ], bp = [
                    b
                ];
                // Parentless nodes are either documents or disconnected
                if (!aup || !bup) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                /* eslint-disable eqeqeq */ return a == document ? -1 : b == document ? 1 : /* eslint-enable eqeqeq */ aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                else if (aup === bup) return siblingCheck(a, b);
                // Otherwise we need full lists of their ancestors for comparison
                cur = a;
                while(cur = cur.parentNode)ap.unshift(cur);
                cur = b;
                while(cur = cur.parentNode)bp.unshift(cur);
                // Walk down the tree looking for a discrepancy
                while(ap[i] === bp[i])i++;
                return i ? // Do a sibling check if the nodes have a common ancestor
                siblingCheck(ap[i], bp[i]) : // Otherwise nodes in our document sort first
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                /* eslint-disable eqeqeq */ ap[i] == preferredDoc ? -1 : bp[i] == preferredDoc ? 1 : /* eslint-enable eqeqeq */ 0;
            };
            return document;
        };
        Sizzle.matches = function(expr, elements) {
            return Sizzle(expr, null, null, elements);
        };
        Sizzle.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (support.matchesSelector && documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return Sizzle(expr, document, null, [
                elem
            ]).length > 0;
        };
        Sizzle.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return contains(context, elem);
        };
        Sizzle.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (jQuery #13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        };
        Sizzle.escape = function(sel) {
            return (sel + "").replace(rcssescape, fcssescape);
        };
        Sizzle.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ Sizzle.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            hasDuplicate = !support.detectDuplicates;
            sortInput = !support.sortStable && results.slice(0);
            results.sort(sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)results.splice(duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        /**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */ getText = Sizzle.getText = function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += getText(node);
            else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                // Use textContent for elements
                // innerText usage removed for consistency of new lines (jQuery #11153)
                if (typeof elem.textContent === "string") return elem.textContent;
                else // Traverse its children
                for(elem = elem.firstChild; elem; elem = elem.nextSibling)ret += getText(elem);
            } else if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        };
        Expr = Sizzle.selectors = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                "ATTR": function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                "CHILD": function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) Sizzle.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) Sizzle.error(match[0]);
                    return match;
                },
                "PSEUDO": function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr["CHILD"].test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                "TAG": function(nodeNameSelector) {
                    var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                    };
                },
                "CLASS": function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                "ATTR": function(name, operator, check) {
                    return function(elem) {
                        var result = Sizzle.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        /* eslint-disable max-len */ return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
                    /* eslint-enable max-len */ };
                },
                "CHILD": function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, uniqueCache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                // ...in a gzip-friendly way
                                node = parent;
                                outerCache = node[expando] || (node[expando] = {});
                                // Support: IE <9 only
                                // Defend against cloned attroperties (jQuery gh-1709)
                                uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                cache = uniqueCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    uniqueCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    // ...in a gzip-friendly way
                                    node = elem;
                                    outerCache = node[expando] || (node[expando] = {});
                                    // Support: IE <9 only
                                    // Defend against cloned attroperties (jQuery gh-1709)
                                    uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                    cache = uniqueCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            // Support: IE <9 only
                                            // Defend against cloned attroperties (jQuery gh-1709)
                                            uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                            uniqueCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                "PSEUDO": function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // http://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as Sizzle does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                "not": markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrim, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element (issue #299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                "has": markFunction(function(selector) {
                    return function(elem) {
                        return Sizzle(selector, elem).length > 0;
                    };
                }),
                "contains": markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || getText(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // http://www.w3.org/TR/selectors/#lang-pseudo
                "lang": markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) Sizzle.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                "target": function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                "root": function(elem) {
                    return elem === docElem;
                },
                "focus": function(elem) {
                    return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                "enabled": createDisabledPseudo(false),
                "disabled": createDisabledPseudo(true),
                "checked": function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    var nodeName = elem.nodeName.toLowerCase();
                    return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
                },
                "selected": function(elem) {
                    // Accessing this property makes selected-by-default
                    // options in Safari work properly
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                "empty": function(elem) {
                    // http://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                "parent": function(elem) {
                    return !Expr.pseudos["empty"](elem);
                },
                // Element/input types
                "header": function(elem) {
                    return rheader.test(elem.nodeName);
                },
                "input": function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                "button": function(elem) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && elem.type === "button" || name === "button";
                },
                "text": function(elem) {
                    var attr;
                    return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                "first": createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                "last": createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                "eq": createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                "even": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "odd": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "lt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument > length ? length : argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "gt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos["nth"] = Expr.pseudos["eq"];
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        tokenize = Sizzle.tokenize = function(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrim, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        };
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, uniqueCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        // Support: IE <9 only
                        // Defend against cloned attroperties (jQuery gh-1709)
                        uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
                        if (skip && skip === elem.nodeName.toLowerCase()) elem = elem[dir] || elem;
                        else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            uniqueCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)Sizzle(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                [] : // ...otherwise use results directly
                results : matcherIn;
                // Find primary matches
                if (matcher) matcher(matcherIn, matcherOut, context, xml);
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element (issue #299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find["TAG"]("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: IE<9, Safari
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            results.push(elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) Sizzle.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        compile = Sizzle.compile = function(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        };
        /**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ select = Sizzle.select = function(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        };
        // One-time assignments
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Support: Chrome 14-35+
        // Always assume duplicates if they aren't passed to the comparison function
        support.detectDuplicates = !!hasDuplicate;
        // Initialize against the default document
        setDocument();
        // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        // Support: IE<8
        // Prevent attribute/property "interpolation"
        // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
        if (!assert(function(el) {
            el.innerHTML = "<a href='#'></a>";
            return el.firstChild.getAttribute("href") === "#";
        })) addHandle("type|href|height|width", function(elem, name, isXML) {
            if (!isXML) return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
        });
        // Support: IE<9
        // Use defaultValue in place of getAttribute("value")
        if (!support.attributes || !assert(function(el) {
            el.innerHTML = "<input/>";
            el.firstChild.setAttribute("value", "");
            return el.firstChild.getAttribute("value") === "";
        })) addHandle("value", function(elem, _name, isXML) {
            if (!isXML && elem.nodeName.toLowerCase() === "input") return elem.defaultValue;
        });
        // Support: IE<9
        // Use getAttributeNode to fetch booleans when getAttribute lies
        if (!assert(function(el) {
            return el.getAttribute("disabled") == null;
        })) addHandle(booleans, function(elem, name, isXML) {
            var val;
            if (!isXML) return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        });
        return Sizzle;
    }(window1);
    jQuery.find = Sizzle;
    jQuery.expr = Sizzle.selectors;
    // Deprecated
    jQuery.expr[":"] = jQuery.expr.pseudos;
    jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
    jQuery.text = Sizzle.getText;
    jQuery.isXMLDoc = Sizzle.isXML;
    jQuery.contains = Sizzle.contains;
    jQuery.escapeSelector = Sizzle.escape;
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to Sizzle
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.stackTrace);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the stack, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getStackHook) process.stackTrace = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    jQuery.Deferred.exceptionHook = function(error, stack) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    // Support: IE <=9 - 11+
    // focus() and blur() are asynchronous, except when they are no-op.
    // So expect focus to be synchronous when the element is already active,
    // and blur to be synchronous when the element is not already active.
    // (focus and blur are always synchronous in other supported browsers,
    // this just defines when we can count on it).
    function expectSync(elem, type) {
        return elem === safeActiveElement() === (type === "focus");
    }
    // Support: IE <=9 only
    // Accessing document.activeElement can throw unexpectedly
    // https://bugs.jquery.com/ticket/13393
    function safeActiveElement() {
        try {
            return document.activeElement;
        } catch (err) {}
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", returnTrue);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, expectSync) {
        // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
        if (!expectSync) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var notAsync, result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    // Saved data should be false in such cases, but might be a leftover capture object
                    // from an async native handler (gh-4350)
                    if (!saved.length) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        // Support: IE <=9 - 11+
                        // focus() and blur() are asynchronous
                        notAsync = expectSync(this, type);
                        this[type]();
                        result = dataPriv.get(this, type);
                        if (saved !== result || notAsync) dataPriv.set(this, type, false);
                        else result = {};
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            // Support: Chrome 86+
                            // In Chrome, if an element having a focusout handler is blurred by
                            // clicking outside of it, it invokes the handler synchronously. If
                            // that handler calls `.remove()` on the element, the data is cleared,
                            // leaving `result` undefined. We need to guard against this.
                            return result && result.value;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering the
                    // native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved.length) {
                    // ...and capture the result
                    dataPriv.set(this, type, {
                        value: jQuery.event.trigger(// Support: IE <=9 - 11+
                        // Extend with the prototype to reset the above stopImmediatePropagation()
                        jQuery.extend(saved[0], jQuery.Event.prototype), saved.slice(1), this)
                    });
                    // Abort handling of the native event
                    event.stopImmediatePropagation();
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, expectSync);
                // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Reenable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is display: block
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            if (box === "margin") delta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            "animationIterationCount": true,
            "columnCount": true,
            "fillOpacity": true,
            "flexGrow": true,
            "flexShrink": true,
            "fontWeight": true,
            "gridArea": true,
            "gridColumn": true,
            "gridColumnEnd": true,
            "gridColumnStart": true,
            "gridRow": true,
            "gridRowEnd": true,
            "gridRowStart": true,
            "lineHeight": true,
            "opacity": true,
            "order": true,
            "orphans": true,
            "widows": true,
            "zIndex": true,
            "zoom": true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    support.focusin = "onfocusin" in window1;
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    // Support: Firefox <=44
    // Firefox doesn't have focus(in | out) events
    // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
    //
    // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
    // focus(in | out) events fire after focus & blur events,
    // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
    // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
    if (!support.focusin) jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(orig, fix) {
        // Attach a single capturing handler on the document while someone wants focusin/focusout
        var handler = function(event) {
            jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
        };
        jQuery.event.special[fix] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix);
                if (!attaches) doc.addEventListener(orig, handler, true);
                dataPriv.access(doc, fix, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix) - 1;
                if (!attaches) {
                    doc.removeEventListener(orig, handler, true);
                    dataPriv.remove(doc, fix);
                } else dataPriv.access(doc, fix, attaches);
            }
        };
    });
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("4X8V9", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});

});

parcelRegister("EHlDu", function(module, exports) {


/*! DataTables 1.12.1
 * ©2008-2022 SpryMedia Ltd - datatables.net/license
 */ /**
 * @summary     DataTables
 * @description Paginate, search and order HTML tables
 * @version     1.12.1
 * @author      SpryMedia Ltd
 * @contact     www.datatables.net
 * @copyright   SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net
 */ /*jslint evil: true, undef: true, browser: true */ /*globals $,require,jQuery,define,_selector_run,_selector_opts,_selector_first,_selector_row_indexes,_ext,_Api,_api_register,_api_registerPlural,_re_new_lines,_re_html,_re_formatted_numeric,_re_escape_regex,_empty,_intVal,_numToDecimal,_isNumber,_isHtml,_htmlNumeric,_pluck,_pluck_order,_range,_stripHtml,_unique,_fnBuildAjax,_fnAjaxUpdate,_fnAjaxParameters,_fnAjaxUpdateDraw,_fnAjaxDataSrc,_fnAddColumn,_fnColumnOptions,_fnAdjustColumnSizing,_fnVisibleToColumnIndex,_fnColumnIndexToVisible,_fnVisbleColumns,_fnGetColumns,_fnColumnTypes,_fnApplyColumnDefs,_fnHungarianMap,_fnCamelToHungarian,_fnLanguageCompat,_fnBrowserDetect,_fnAddData,_fnAddTr,_fnNodeToDataIndex,_fnNodeToColumnIndex,_fnGetCellData,_fnSetCellData,_fnSplitObjNotation,_fnGetObjectDataFn,_fnSetObjectDataFn,_fnGetDataMaster,_fnClearTable,_fnDeleteIndex,_fnInvalidate,_fnGetRowElements,_fnCreateTr,_fnBuildHead,_fnDrawHead,_fnDraw,_fnReDraw,_fnAddOptionsHtml,_fnDetectHeader,_fnGetUniqueThs,_fnFeatureHtmlFilter,_fnFilterComplete,_fnFilterCustom,_fnFilterColumn,_fnFilter,_fnFilterCreateSearch,_fnEscapeRegex,_fnFilterData,_fnFeatureHtmlInfo,_fnUpdateInfo,_fnInfoMacros,_fnInitialise,_fnInitComplete,_fnLengthChange,_fnFeatureHtmlLength,_fnFeatureHtmlPaginate,_fnPageChange,_fnFeatureHtmlProcessing,_fnProcessingDisplay,_fnFeatureHtmlTable,_fnScrollDraw,_fnApplyToChildren,_fnCalculateColumnWidths,_fnThrottle,_fnConvertToWidth,_fnGetWidestNode,_fnGetMaxLenString,_fnStringToCss,_fnSortFlatten,_fnSort,_fnSortAria,_fnSortListener,_fnSortAttachListener,_fnSortingClasses,_fnSortData,_fnSaveState,_fnLoadState,_fnSettingsFromNode,_fnLog,_fnMap,_fnBindAction,_fnCallbackReg,_fnCallbackFire,_fnLengthOverflow,_fnRenderer,_fnDataSource,_fnRowAttributes*/ (function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD
    define([
        "jquery"
    ], function($) {
        return factory($, window, document);
    });
    else // CommonJS
    module.exports = function(root, $) {
        if (!root) // CommonJS environments without a window global must pass a
        // root. This will give an error otherwise
        root = window;
        if (!$) $ = typeof window !== "undefined" ? (parcelRequire("9qak9")) : (parcelRequire("9qak9"))(root);
        return factory($, root, root.document);
    };
})(function($, window1, document1, undefined) {
    "use strict";
    var DataTable = function(selector, options) {
        // When creating with `new`, create a new DataTable, returning the API instance
        if (this instanceof DataTable) return $(selector).DataTable(options);
        else // Argument switching
        options = selector;
        /**
		 * Perform a jQuery selector action on the table's TR elements (from the tbody) and
		 * return the resulting jQuery object.
		 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
		 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
		 *  @param {string} [oOpts.filter=none] Select TR elements that meet the current filter
		 *    criterion ("applied") or all TR elements (i.e. no filter).
		 *  @param {string} [oOpts.order=current] Order of the TR elements in the processed array.
		 *    Can be either 'current', whereby the current sorting of the table is used, or
		 *    'original' whereby the original order the data was read into the table is used.
		 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
		 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
		 *    'current' and filter is 'applied', regardless of what they might be given as.
		 *  @returns {object} jQuery object, filtered by the given selector.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Highlight every second row
		 *      oTable.$('tr:odd').css('backgroundColor', 'blue');
		 *    } );
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Filter to rows with 'Webkit' in them, add a background colour and then
		 *      // remove the filter, thus highlighting the 'Webkit' rows only.
		 *      oTable.fnFilter('Webkit');
		 *      oTable.$('tr', {"search": "applied"}).css('backgroundColor', 'blue');
		 *      oTable.fnFilter('');
		 *    } );
		 */ this.$ = function(sSelector, oOpts) {
            return this.api(true).$(sSelector, oOpts);
        };
        /**
		 * Almost identical to $ in operation, but in this case returns the data for the matched
		 * rows - as such, the jQuery selector used should match TR row nodes or TD/TH cell nodes
		 * rather than any descendants, so the data can be obtained for the row/cell. If matching
		 * rows are found, the data returned is the original data array/object that was used to
		 * create the row (or a generated array if from a DOM source).
		 *
		 * This method is often useful in-combination with $ where both functions are given the
		 * same parameters and the array indexes will match identically.
		 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
		 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
		 *  @param {string} [oOpts.filter=none] Select elements that meet the current filter
		 *    criterion ("applied") or all elements (i.e. no filter).
		 *  @param {string} [oOpts.order=current] Order of the data in the processed array.
		 *    Can be either 'current', whereby the current sorting of the table is used, or
		 *    'original' whereby the original order the data was read into the table is used.
		 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
		 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
		 *    'current' and filter is 'applied', regardless of what they might be given as.
		 *  @returns {array} Data for the matched elements. If any elements, as a result of the
		 *    selector, were not TR, TD or TH elements in the DataTable, they will have a null
		 *    entry in the array.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Get the data from the first row in the table
		 *      var data = oTable._('tr:first');
		 *
		 *      // Do something useful with the data
		 *      alert( "First cell is: "+data[0] );
		 *    } );
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Filter to 'Webkit' and get all data for
		 *      oTable.fnFilter('Webkit');
		 *      var data = oTable._('tr', {"search": "applied"});
		 *
		 *      // Do something with the data
		 *      alert( data.length+" rows matched the search" );
		 *    } );
		 */ this._ = function(sSelector, oOpts) {
            return this.api(true).rows(sSelector, oOpts).data();
        };
        /**
		 * Create a DataTables Api instance, with the currently selected tables for
		 * the Api's context.
		 * @param {boolean} [traditional=false] Set the API instance's context to be
		 *   only the table referred to by the `DataTable.ext.iApiIndex` option, as was
		 *   used in the API presented by DataTables 1.9- (i.e. the traditional mode),
		 *   or if all tables captured in the jQuery object should be used.
		 * @return {DataTables.Api}
		 */ this.api = function(traditional) {
            return traditional ? new _Api(_fnSettingsFromNode(this[_ext.iApiIndex])) : new _Api(this);
        };
        /**
		 * Add a single new row or multiple rows of data to the table. Please note
		 * that this is suitable for client-side processing only - if you are using
		 * server-side processing (i.e. "bServerSide": true), then to add data, you
		 * must add it to the data source, i.e. the server-side, through an Ajax call.
		 *  @param {array|object} data The data to be added to the table. This can be:
		 *    <ul>
		 *      <li>1D array of data - add a single row with the data provided</li>
		 *      <li>2D array of arrays - add multiple rows in a single call</li>
		 *      <li>object - data object when using <i>mData</i></li>
		 *      <li>array of objects - multiple data objects when using <i>mData</i></li>
		 *    </ul>
		 *  @param {bool} [redraw=true] redraw the table or not
		 *  @returns {array} An array of integers, representing the list of indexes in
		 *    <i>aoData</i> ({@link DataTable.models.oSettings}) that have been added to
		 *    the table.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    // Global var for counter
		 *    var giCount = 2;
		 *
		 *    $(document).ready(function() {
		 *      $('#example').dataTable();
		 *    } );
		 *
		 *    function fnClickAddRow() {
		 *      $('#example').dataTable().fnAddData( [
		 *        giCount+".1",
		 *        giCount+".2",
		 *        giCount+".3",
		 *        giCount+".4" ]
		 *      );
		 *
		 *      giCount++;
		 *    }
		 */ this.fnAddData = function(data, redraw) {
            var api = this.api(true);
            /* Check if we want to add multiple rows or not */ var rows = Array.isArray(data) && (Array.isArray(data[0]) || $.isPlainObject(data[0])) ? api.rows.add(data) : api.row.add(data);
            if (redraw === undefined || redraw) api.draw();
            return rows.flatten().toArray();
        };
        /**
		 * This function will make DataTables recalculate the column sizes, based on the data
		 * contained in the table and the sizes applied to the columns (in the DOM, CSS or
		 * through the sWidth parameter). This can be useful when the width of the table's
		 * parent element changes (for example a window resize).
		 *  @param {boolean} [bRedraw=true] Redraw the table or not, you will typically want to
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable( {
		 *        "sScrollY": "200px",
		 *        "bPaginate": false
		 *      } );
		 *
		 *      $(window).on('resize', function () {
		 *        oTable.fnAdjustColumnSizing();
		 *      } );
		 *    } );
		 */ this.fnAdjustColumnSizing = function(bRedraw) {
            var api = this.api(true).columns.adjust();
            var settings = api.settings()[0];
            var scroll = settings.oScroll;
            if (bRedraw === undefined || bRedraw) api.draw(false);
            else if (scroll.sX !== "" || scroll.sY !== "") /* If not redrawing, but scrolling, we want to apply the new column sizes anyway */ _fnScrollDraw(settings);
        };
        /**
		 * Quickly and simply clear a table
		 *  @param {bool} [bRedraw=true] redraw the table or not
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Immediately 'nuke' the current rows (perhaps waiting for an Ajax callback...)
		 *      oTable.fnClearTable();
		 *    } );
		 */ this.fnClearTable = function(bRedraw) {
            var api = this.api(true).clear();
            if (bRedraw === undefined || bRedraw) api.draw();
        };
        /**
		 * The exact opposite of 'opening' a row, this function will close any rows which
		 * are currently 'open'.
		 *  @param {node} nTr the table row to 'close'
		 *  @returns {int} 0 on success, or 1 if failed (can't find the row)
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable;
		 *
		 *      // 'open' an information row when a row is clicked on
		 *      $('#example tbody tr').click( function () {
		 *        if ( oTable.fnIsOpen(this) ) {
		 *          oTable.fnClose( this );
		 *        } else {
		 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
		 *        }
		 *      } );
		 *
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */ this.fnClose = function(nTr) {
            this.api(true).row(nTr).child.hide();
        };
        /**
		 * Remove a row for the table
		 *  @param {mixed} target The index of the row from aoData to be deleted, or
		 *    the TR element you want to delete
		 *  @param {function|null} [callBack] Callback function
		 *  @param {bool} [redraw=true] Redraw the table or not
		 *  @returns {array} The row that was deleted
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Immediately remove the first row
		 *      oTable.fnDeleteRow( 0 );
		 *    } );
		 */ this.fnDeleteRow = function(target, callback, redraw) {
            var api = this.api(true);
            var rows = api.rows(target);
            var settings = rows.settings()[0];
            var data = settings.aoData[rows[0][0]];
            rows.remove();
            if (callback) callback.call(this, settings, data);
            if (redraw === undefined || redraw) api.draw();
            return data;
        };
        /**
		 * Restore the table to it's original state in the DOM by removing all of DataTables
		 * enhancements, alterations to the DOM structure of the table and event listeners.
		 *  @param {boolean} [remove=false] Completely remove the table from the DOM
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      // This example is fairly pointless in reality, but shows how fnDestroy can be used
		 *      var oTable = $('#example').dataTable();
		 *      oTable.fnDestroy();
		 *    } );
		 */ this.fnDestroy = function(remove) {
            this.api(true).destroy(remove);
        };
        /**
		 * Redraw the table
		 *  @param {bool} [complete=true] Re-filter and resort (if enabled) the table before the draw.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Re-draw the table - you wouldn't want to do it here, but it's an example :-)
		 *      oTable.fnDraw();
		 *    } );
		 */ this.fnDraw = function(complete) {
            // Note that this isn't an exact match to the old call to _fnDraw - it takes
            // into account the new data, but can hold position.
            this.api(true).draw(complete);
        };
        /**
		 * Filter the input based on data
		 *  @param {string} sInput String to filter the table on
		 *  @param {int|null} [iColumn] Column to limit filtering to
		 *  @param {bool} [bRegex=false] Treat as regular expression or not
		 *  @param {bool} [bSmart=true] Perform smart filtering or not
		 *  @param {bool} [bShowGlobal=true] Show the input global filter in it's input box(es)
		 *  @param {bool} [bCaseInsensitive=true] Do case-insensitive matching (true) or not (false)
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Sometime later - filter...
		 *      oTable.fnFilter( 'test string' );
		 *    } );
		 */ this.fnFilter = function(sInput, iColumn, bRegex, bSmart, bShowGlobal, bCaseInsensitive) {
            var api = this.api(true);
            if (iColumn === null || iColumn === undefined) api.search(sInput, bRegex, bSmart, bCaseInsensitive);
            else api.column(iColumn).search(sInput, bRegex, bSmart, bCaseInsensitive);
            api.draw();
        };
        /**
		 * Get the data for the whole table, an individual row or an individual cell based on the
		 * provided parameters.
		 *  @param {int|node} [src] A TR row node, TD/TH cell node or an integer. If given as
		 *    a TR node then the data source for the whole row will be returned. If given as a
		 *    TD/TH cell node then iCol will be automatically calculated and the data for the
		 *    cell returned. If given as an integer, then this is treated as the aoData internal
		 *    data index for the row (see fnGetPosition) and the data for that row used.
		 *  @param {int} [col] Optional column index that you want the data of.
		 *  @returns {array|object|string} If mRow is undefined, then the data for all rows is
		 *    returned. If mRow is defined, just data for that row, and is iCol is
		 *    defined, only data for the designated cell is returned.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    // Row data
		 *    $(document).ready(function() {
		 *      oTable = $('#example').dataTable();
		 *
		 *      oTable.$('tr').click( function () {
		 *        var data = oTable.fnGetData( this );
		 *        // ... do something with the array / object of data for the row
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Individual cell data
		 *    $(document).ready(function() {
		 *      oTable = $('#example').dataTable();
		 *
		 *      oTable.$('td').click( function () {
		 *        var sData = oTable.fnGetData( this );
		 *        alert( 'The cell clicked on had the value of '+sData );
		 *      } );
		 *    } );
		 */ this.fnGetData = function(src, col) {
            var api = this.api(true);
            if (src !== undefined) {
                var type = src.nodeName ? src.nodeName.toLowerCase() : "";
                return col !== undefined || type == "td" || type == "th" ? api.cell(src, col).data() : api.row(src).data() || null;
            }
            return api.data().toArray();
        };
        /**
		 * Get an array of the TR nodes that are used in the table's body. Note that you will
		 * typically want to use the '$' API method in preference to this as it is more
		 * flexible.
		 *  @param {int} [iRow] Optional row index for the TR element you want
		 *  @returns {array|node} If iRow is undefined, returns an array of all TR elements
		 *    in the table's body, or iRow is defined, just the TR element requested.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Get the nodes from the table
		 *      var nNodes = oTable.fnGetNodes( );
		 *    } );
		 */ this.fnGetNodes = function(iRow) {
            var api = this.api(true);
            return iRow !== undefined ? api.row(iRow).node() : api.rows().nodes().flatten().toArray();
        };
        /**
		 * Get the array indexes of a particular cell from it's DOM element
		 * and column index including hidden columns
		 *  @param {node} node this can either be a TR, TD or TH in the table's body
		 *  @returns {int} If nNode is given as a TR, then a single index is returned, or
		 *    if given as a cell, an array of [row index, column index (visible),
		 *    column index (all)] is given.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      $('#example tbody td').click( function () {
		 *        // Get the position of the current data from the node
		 *        var aPos = oTable.fnGetPosition( this );
		 *
		 *        // Get the data array for this row
		 *        var aData = oTable.fnGetData( aPos[0] );
		 *
		 *        // Update the data array and return the value
		 *        aData[ aPos[1] ] = 'clicked';
		 *        this.innerHTML = 'clicked';
		 *      } );
		 *
		 *      // Init DataTables
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */ this.fnGetPosition = function(node) {
            var api = this.api(true);
            var nodeName = node.nodeName.toUpperCase();
            if (nodeName == "TR") return api.row(node).index();
            else if (nodeName == "TD" || nodeName == "TH") {
                var cell = api.cell(node).index();
                return [
                    cell.row,
                    cell.columnVisible,
                    cell.column
                ];
            }
            return null;
        };
        /**
		 * Check to see if a row is 'open' or not.
		 *  @param {node} nTr the table row to check
		 *  @returns {boolean} true if the row is currently open, false otherwise
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable;
		 *
		 *      // 'open' an information row when a row is clicked on
		 *      $('#example tbody tr').click( function () {
		 *        if ( oTable.fnIsOpen(this) ) {
		 *          oTable.fnClose( this );
		 *        } else {
		 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
		 *        }
		 *      } );
		 *
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */ this.fnIsOpen = function(nTr) {
            return this.api(true).row(nTr).child.isShown();
        };
        /**
		 * This function will place a new row directly after a row which is currently
		 * on display on the page, with the HTML contents that is passed into the
		 * function. This can be used, for example, to ask for confirmation that a
		 * particular record should be deleted.
		 *  @param {node} nTr The table row to 'open'
		 *  @param {string|node|jQuery} mHtml The HTML to put into the row
		 *  @param {string} sClass Class to give the new TD cell
		 *  @returns {node} The row opened. Note that if the table row passed in as the
		 *    first parameter, is not found in the table, this method will silently
		 *    return.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable;
		 *
		 *      // 'open' an information row when a row is clicked on
		 *      $('#example tbody tr').click( function () {
		 *        if ( oTable.fnIsOpen(this) ) {
		 *          oTable.fnClose( this );
		 *        } else {
		 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
		 *        }
		 *      } );
		 *
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */ this.fnOpen = function(nTr, mHtml, sClass) {
            return this.api(true).row(nTr).child(mHtml, sClass).show().child()[0];
        };
        /**
		 * Change the pagination - provides the internal logic for pagination in a simple API
		 * function. With this function you can have a DataTables table go to the next,
		 * previous, first or last pages.
		 *  @param {string|int} mAction Paging action to take: "first", "previous", "next" or "last"
		 *    or page number to jump to (integer), note that page 0 is the first page.
		 *  @param {bool} [bRedraw=true] Redraw the table or not
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      oTable.fnPageChange( 'next' );
		 *    } );
		 */ this.fnPageChange = function(mAction, bRedraw) {
            var api = this.api(true).page(mAction);
            if (bRedraw === undefined || bRedraw) api.draw(false);
        };
        /**
		 * Show a particular column
		 *  @param {int} iCol The column whose display should be changed
		 *  @param {bool} bShow Show (true) or hide (false) the column
		 *  @param {bool} [bRedraw=true] Redraw the table or not
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Hide the second column after initialisation
		 *      oTable.fnSetColumnVis( 1, false );
		 *    } );
		 */ this.fnSetColumnVis = function(iCol, bShow, bRedraw) {
            var api = this.api(true).column(iCol).visible(bShow);
            if (bRedraw === undefined || bRedraw) api.columns.adjust().draw();
        };
        /**
		 * Get the settings for a particular table for external manipulation
		 *  @returns {object} DataTables settings object. See
		 *    {@link DataTable.models.oSettings}
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      var oSettings = oTable.fnSettings();
		 *
		 *      // Show an example parameter from the settings
		 *      alert( oSettings._iDisplayStart );
		 *    } );
		 */ this.fnSettings = function() {
            return _fnSettingsFromNode(this[_ext.iApiIndex]);
        };
        /**
		 * Sort the table by a particular column
		 *  @param {int} iCol the data index to sort on. Note that this will not match the
		 *    'display index' if you have hidden data entries
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Sort immediately with columns 0 and 1
		 *      oTable.fnSort( [ [0,'asc'], [1,'asc'] ] );
		 *    } );
		 */ this.fnSort = function(aaSort) {
            this.api(true).order(aaSort).draw();
        };
        /**
		 * Attach a sort listener to an element for a given column
		 *  @param {node} nNode the element to attach the sort listener to
		 *  @param {int} iColumn the column that a click on this node will sort on
		 *  @param {function} [fnCallback] callback function when sort is run
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Sort on column 1, when 'sorter' is clicked on
		 *      oTable.fnSortListener( document.getElementById('sorter'), 1 );
		 *    } );
		 */ this.fnSortListener = function(nNode, iColumn, fnCallback) {
            this.api(true).order.listener(nNode, iColumn, fnCallback);
        };
        /**
		 * Update a table cell or row - this method will accept either a single value to
		 * update the cell with, an array of values with one element for each column or
		 * an object in the same format as the original data source. The function is
		 * self-referencing in order to make the multi column updates easier.
		 *  @param {object|array|string} mData Data to update the cell/row with
		 *  @param {node|int} mRow TR element you want to update or the aoData index
		 *  @param {int} [iColumn] The column to update, give as null or undefined to
		 *    update a whole row.
		 *  @param {bool} [bRedraw=true] Redraw the table or not
		 *  @param {bool} [bAction=true] Perform pre-draw actions or not
		 *  @returns {int} 0 on success, 1 on error
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      oTable.fnUpdate( 'Example update', 0, 0 ); // Single cell
		 *      oTable.fnUpdate( ['a', 'b', 'c', 'd', 'e'], $('tbody tr')[0] ); // Row
		 *    } );
		 */ this.fnUpdate = function(mData, mRow, iColumn, bRedraw, bAction) {
            var api = this.api(true);
            if (iColumn === undefined || iColumn === null) api.row(mRow).data(mData);
            else api.cell(mRow, iColumn).data(mData);
            if (bAction === undefined || bAction) api.columns.adjust();
            if (bRedraw === undefined || bRedraw) api.draw();
            return 0;
        };
        /**
		 * Provide a common method for plug-ins to check the version of DataTables being used, in order
		 * to ensure compatibility.
		 *  @param {string} sVersion Version string to check for, in the format "X.Y.Z". Note that the
		 *    formats "X" and "X.Y" are also acceptable.
		 *  @returns {boolean} true if this version of DataTables is greater or equal to the required
		 *    version, or false if this version of DataTales is not suitable
		 *  @method
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      alert( oTable.fnVersionCheck( '1.9.0' ) );
		 *    } );
		 */ this.fnVersionCheck = _ext.fnVersionCheck;
        var _that = this;
        var emptyInit = options === undefined;
        var len = this.length;
        if (emptyInit) options = {};
        this.oApi = this.internal = _ext.internal;
        // Extend with old style plug-in API methods
        for(var fn in DataTable.ext.internal)if (fn) this[fn] = _fnExternApiFunc(fn);
        this.each(function() {
            // For each initialisation we want to give it a clean initialisation
            // object that can be bashed around
            var o = {};
            var oInit = len > 1 ? _fnExtend(o, options, true) : options;
            /*global oInit,_that,emptyInit*/ var i = 0, iLen, j, jLen, k, kLen;
            var sId = this.getAttribute("id");
            var bInitHandedOff = false;
            var defaults = DataTable.defaults;
            var $this = $(this);
            /* Sanity check */ if (this.nodeName.toLowerCase() != "table") {
                _fnLog(null, 0, "Non-table node initialisation (" + this.nodeName + ")", 2);
                return;
            }
            /* Backwards compatibility for the defaults */ _fnCompatOpts(defaults);
            _fnCompatCols(defaults.column);
            /* Convert the camel-case defaults to Hungarian */ _fnCamelToHungarian(defaults, defaults, true);
            _fnCamelToHungarian(defaults.column, defaults.column, true);
            /* Setting up the initialisation object */ _fnCamelToHungarian(defaults, $.extend(oInit, $this.data()), true);
            /* Check to see if we are re-initialising a table */ var allSettings = DataTable.settings;
            for(i = 0, iLen = allSettings.length; i < iLen; i++){
                var s = allSettings[i];
                /* Base check on table node */ if (s.nTable == this || s.nTHead && s.nTHead.parentNode == this || s.nTFoot && s.nTFoot.parentNode == this) {
                    var bRetrieve = oInit.bRetrieve !== undefined ? oInit.bRetrieve : defaults.bRetrieve;
                    var bDestroy = oInit.bDestroy !== undefined ? oInit.bDestroy : defaults.bDestroy;
                    if (emptyInit || bRetrieve) return s.oInstance;
                    else if (bDestroy) {
                        s.oInstance.fnDestroy();
                        break;
                    } else {
                        _fnLog(s, 0, "Cannot reinitialise DataTable", 3);
                        return;
                    }
                }
                /* If the element we are initialising has the same ID as a table which was previously
				 * initialised, but the table nodes don't match (from before) then we destroy the old
				 * instance by simply deleting it. This is under the assumption that the table has been
				 * destroyed by other methods. Anyone using non-id selectors will need to do this manually
				 */ if (s.sTableId == this.id) {
                    allSettings.splice(i, 1);
                    break;
                }
            }
            /* Ensure the table has an ID - required for accessibility */ if (sId === null || sId === "") {
                sId = "DataTables_Table_" + DataTable.ext._unique++;
                this.id = sId;
            }
            /* Create the settings object for this table and set some of the default parameters */ var oSettings = $.extend(true, {}, DataTable.models.oSettings, {
                "sDestroyWidth": $this[0].style.width,
                "sInstance": sId,
                "sTableId": sId
            });
            oSettings.nTable = this;
            oSettings.oApi = _that.internal;
            oSettings.oInit = oInit;
            allSettings.push(oSettings);
            // Need to add the instance after the instance after the settings object has been added
            // to the settings array, so we can self reference the table instance if more than one
            oSettings.oInstance = _that.length === 1 ? _that : $this.dataTable();
            // Backwards compatibility, before we apply all the defaults
            _fnCompatOpts(oInit);
            _fnLanguageCompat(oInit.oLanguage);
            // If the length menu is given, but the init display length is not, use the length menu
            if (oInit.aLengthMenu && !oInit.iDisplayLength) oInit.iDisplayLength = Array.isArray(oInit.aLengthMenu[0]) ? oInit.aLengthMenu[0][0] : oInit.aLengthMenu[0];
            // Apply the defaults and init options to make a single init object will all
            // options defined from defaults and instance options.
            oInit = _fnExtend($.extend(true, {}, defaults), oInit);
            // Map the initialisation options onto the settings object
            _fnMap(oSettings.oFeatures, oInit, [
                "bPaginate",
                "bLengthChange",
                "bFilter",
                "bSort",
                "bSortMulti",
                "bInfo",
                "bProcessing",
                "bAutoWidth",
                "bSortClasses",
                "bServerSide",
                "bDeferRender"
            ]);
            _fnMap(oSettings, oInit, [
                "asStripeClasses",
                "ajax",
                "fnServerData",
                "fnFormatNumber",
                "sServerMethod",
                "aaSorting",
                "aaSortingFixed",
                "aLengthMenu",
                "sPaginationType",
                "sAjaxSource",
                "sAjaxDataProp",
                "iStateDuration",
                "sDom",
                "bSortCellsTop",
                "iTabIndex",
                "fnStateLoadCallback",
                "fnStateSaveCallback",
                "renderer",
                "searchDelay",
                "rowId",
                [
                    "iCookieDuration",
                    "iStateDuration"
                ],
                [
                    "oSearch",
                    "oPreviousSearch"
                ],
                [
                    "aoSearchCols",
                    "aoPreSearchCols"
                ],
                [
                    "iDisplayLength",
                    "_iDisplayLength"
                ]
            ]);
            _fnMap(oSettings.oScroll, oInit, [
                [
                    "sScrollX",
                    "sX"
                ],
                [
                    "sScrollXInner",
                    "sXInner"
                ],
                [
                    "sScrollY",
                    "sY"
                ],
                [
                    "bScrollCollapse",
                    "bCollapse"
                ]
            ]);
            _fnMap(oSettings.oLanguage, oInit, "fnInfoCallback");
            /* Callback functions which are array driven */ _fnCallbackReg(oSettings, "aoDrawCallback", oInit.fnDrawCallback, "user");
            _fnCallbackReg(oSettings, "aoServerParams", oInit.fnServerParams, "user");
            _fnCallbackReg(oSettings, "aoStateSaveParams", oInit.fnStateSaveParams, "user");
            _fnCallbackReg(oSettings, "aoStateLoadParams", oInit.fnStateLoadParams, "user");
            _fnCallbackReg(oSettings, "aoStateLoaded", oInit.fnStateLoaded, "user");
            _fnCallbackReg(oSettings, "aoRowCallback", oInit.fnRowCallback, "user");
            _fnCallbackReg(oSettings, "aoRowCreatedCallback", oInit.fnCreatedRow, "user");
            _fnCallbackReg(oSettings, "aoHeaderCallback", oInit.fnHeaderCallback, "user");
            _fnCallbackReg(oSettings, "aoFooterCallback", oInit.fnFooterCallback, "user");
            _fnCallbackReg(oSettings, "aoInitComplete", oInit.fnInitComplete, "user");
            _fnCallbackReg(oSettings, "aoPreDrawCallback", oInit.fnPreDrawCallback, "user");
            oSettings.rowIdFn = _fnGetObjectDataFn(oInit.rowId);
            /* Browser support detection */ _fnBrowserDetect(oSettings);
            var oClasses = oSettings.oClasses;
            $.extend(oClasses, DataTable.ext.classes, oInit.oClasses);
            $this.addClass(oClasses.sTable);
            if (oSettings.iInitDisplayStart === undefined) {
                /* Display start point, taking into account the save saving */ oSettings.iInitDisplayStart = oInit.iDisplayStart;
                oSettings._iDisplayStart = oInit.iDisplayStart;
            }
            if (oInit.iDeferLoading !== null) {
                oSettings.bDeferLoading = true;
                var tmp = Array.isArray(oInit.iDeferLoading);
                oSettings._iRecordsDisplay = tmp ? oInit.iDeferLoading[0] : oInit.iDeferLoading;
                oSettings._iRecordsTotal = tmp ? oInit.iDeferLoading[1] : oInit.iDeferLoading;
            }
            /* Language definitions */ var oLanguage = oSettings.oLanguage;
            $.extend(true, oLanguage, oInit.oLanguage);
            if (oLanguage.sUrl) {
                /* Get the language definitions from a file - because this Ajax call makes the language
				 * get async to the remainder of this function we use bInitHandedOff to indicate that
				 * _fnInitialise will be fired by the returned Ajax handler, rather than the constructor
				 */ $.ajax({
                    dataType: "json",
                    url: oLanguage.sUrl,
                    success: function(json) {
                        _fnCamelToHungarian(defaults.oLanguage, json);
                        _fnLanguageCompat(json);
                        $.extend(true, oLanguage, json, oSettings.oInit.oLanguage);
                        _fnCallbackFire(oSettings, null, "i18n", [
                            oSettings
                        ]);
                        _fnInitialise(oSettings);
                    },
                    error: function() {
                        // Error occurred loading language file, continue on as best we can
                        _fnInitialise(oSettings);
                    }
                });
                bInitHandedOff = true;
            } else _fnCallbackFire(oSettings, null, "i18n", [
                oSettings
            ]);
            /*
			 * Stripes
			 */ if (oInit.asStripeClasses === null) oSettings.asStripeClasses = [
                oClasses.sStripeOdd,
                oClasses.sStripeEven
            ];
            /* Remove row stripe classes if they are already on the table row */ var stripeClasses = oSettings.asStripeClasses;
            var rowOne = $this.children("tbody").find("tr").eq(0);
            if ($.inArray(true, $.map(stripeClasses, function(el, i) {
                return rowOne.hasClass(el);
            })) !== -1) {
                $("tbody tr", this).removeClass(stripeClasses.join(" "));
                oSettings.asDestroyStripes = stripeClasses.slice();
            }
            /*
			 * Columns
			 * See if we should load columns automatically or use defined ones
			 */ var anThs = [];
            var aoColumnsInit;
            var nThead = this.getElementsByTagName("thead");
            if (nThead.length !== 0) {
                _fnDetectHeader(oSettings.aoHeader, nThead[0]);
                anThs = _fnGetUniqueThs(oSettings);
            }
            /* If not given a column array, generate one with nulls */ if (oInit.aoColumns === null) {
                aoColumnsInit = [];
                for(i = 0, iLen = anThs.length; i < iLen; i++)aoColumnsInit.push(null);
            } else aoColumnsInit = oInit.aoColumns;
            /* Add the columns */ for(i = 0, iLen = aoColumnsInit.length; i < iLen; i++)_fnAddColumn(oSettings, anThs ? anThs[i] : null);
            /* Apply the column definitions */ _fnApplyColumnDefs(oSettings, oInit.aoColumnDefs, aoColumnsInit, function(iCol, oDef) {
                _fnColumnOptions(oSettings, iCol, oDef);
            });
            /* HTML5 attribute detection - build an mData object automatically if the
			 * attributes are found
			 */ if (rowOne.length) {
                var a = function(cell, name) {
                    return cell.getAttribute("data-" + name) !== null ? name : null;
                };
                $(rowOne[0]).children("th, td").each(function(i, cell) {
                    var col = oSettings.aoColumns[i];
                    if (col.mData === i) {
                        var sort = a(cell, "sort") || a(cell, "order");
                        var filter = a(cell, "filter") || a(cell, "search");
                        if (sort !== null || filter !== null) {
                            col.mData = {
                                _: i + ".display",
                                sort: sort !== null ? i + ".@data-" + sort : undefined,
                                type: sort !== null ? i + ".@data-" + sort : undefined,
                                filter: filter !== null ? i + ".@data-" + filter : undefined
                            };
                            _fnColumnOptions(oSettings, i);
                        }
                    }
                });
            }
            var features = oSettings.oFeatures;
            var loadedInit = function() {
                /*
				 * Sorting
				 * @todo For modularisation (1.11) this needs to do into a sort start up handler
				 */ // If aaSorting is not defined, then we use the first indicator in asSorting
                // in case that has been altered, so the default sort reflects that option
                if (oInit.aaSorting === undefined) {
                    var sorting = oSettings.aaSorting;
                    for(i = 0, iLen = sorting.length; i < iLen; i++)sorting[i][1] = oSettings.aoColumns[i].asSorting[0];
                }
                /* Do a first pass on the sorting classes (allows any size changes to be taken into
				 * account, and also will apply sorting disabled classes if disabled
				 */ _fnSortingClasses(oSettings);
                if (features.bSort) _fnCallbackReg(oSettings, "aoDrawCallback", function() {
                    if (oSettings.bSorted) {
                        var aSort = _fnSortFlatten(oSettings);
                        var sortedColumns = {};
                        $.each(aSort, function(i, val) {
                            sortedColumns[val.src] = val.dir;
                        });
                        _fnCallbackFire(oSettings, null, "order", [
                            oSettings,
                            aSort,
                            sortedColumns
                        ]);
                        _fnSortAria(oSettings);
                    }
                });
                _fnCallbackReg(oSettings, "aoDrawCallback", function() {
                    if (oSettings.bSorted || _fnDataSource(oSettings) === "ssp" || features.bDeferRender) _fnSortingClasses(oSettings);
                }, "sc");
                /*
				 * Final init
				 * Cache the header, body and footer as required, creating them if needed
				 */ // Work around for Webkit bug 83867 - store the caption-side before removing from doc
                var captions = $this.children("caption").each(function() {
                    this._captionSide = $(this).css("caption-side");
                });
                var thead = $this.children("thead");
                if (thead.length === 0) thead = $("<thead/>").appendTo($this);
                oSettings.nTHead = thead[0];
                var tbody = $this.children("tbody");
                if (tbody.length === 0) tbody = $("<tbody/>").insertAfter(thead);
                oSettings.nTBody = tbody[0];
                var tfoot = $this.children("tfoot");
                if (tfoot.length === 0 && captions.length > 0 && (oSettings.oScroll.sX !== "" || oSettings.oScroll.sY !== "")) // If we are a scrolling table, and no footer has been given, then we need to create
                // a tfoot element for the caption element to be appended to
                tfoot = $("<tfoot/>").appendTo($this);
                if (tfoot.length === 0 || tfoot.children().length === 0) $this.addClass(oClasses.sNoFooter);
                else if (tfoot.length > 0) {
                    oSettings.nTFoot = tfoot[0];
                    _fnDetectHeader(oSettings.aoFooter, oSettings.nTFoot);
                }
                /* Check if there is data passing into the constructor */ if (oInit.aaData) for(i = 0; i < oInit.aaData.length; i++)_fnAddData(oSettings, oInit.aaData[i]);
                else if (oSettings.bDeferLoading || _fnDataSource(oSettings) == "dom") /* Grab the data from the page - only do this when deferred loading or no Ajax
					 * source since there is no point in reading the DOM data if we are then going
					 * to replace it with Ajax data
					 */ _fnAddTr(oSettings, $(oSettings.nTBody).children("tr"));
                /* Copy the data index array */ oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
                /* Initialisation complete - table can be drawn */ oSettings.bInitialised = true;
                /* Check if we need to initialise the table (it might not have been handed off to the
				 * language processor)
				 */ if (bInitHandedOff === false) _fnInitialise(oSettings);
            };
            /* Must be done after everything which can be overridden by the state saving! */ _fnCallbackReg(oSettings, "aoDrawCallback", _fnSaveState, "state_save");
            if (oInit.bStateSave) {
                features.bStateSave = true;
                _fnLoadState(oSettings, oInit, loadedInit);
            } else loadedInit();
        });
        _that = null;
        return this;
    };
    /*
	 * It is useful to have variables which are scoped locally so only the
	 * DataTables functions can access them and they don't leak into global space.
	 * At the same time these functions are often useful over multiple files in the
	 * core and API, so we list, or at least document, all variables which are used
	 * by DataTables as private variables here. This also ensures that there is no
	 * clashing of variable names and that they can easily referenced for reuse.
	 */ // Defined else where
    //  _selector_run
    //  _selector_opts
    //  _selector_first
    //  _selector_row_indexes
    var _ext; // DataTable.ext
    var _Api; // DataTable.Api
    var _api_register; // DataTable.Api.register
    var _api_registerPlural; // DataTable.Api.registerPlural
    var _re_dic = {};
    var _re_new_lines = /[\r\n\u2028]/g;
    var _re_html = /<.*?>/g;
    // This is not strict ISO8601 - Date.parse() is quite lax, although
    // implementations differ between browsers.
    var _re_date = /^\d{2,4}[\.\/\-]\d{1,2}[\.\/\-]\d{1,2}([T ]{1}\d{1,2}[:\.]\d{2}([\.:]\d{2})?)?$/;
    // Escape regular expression special characters
    var _re_escape_regex = new RegExp("(\\" + [
        "/",
        ".",
        "*",
        "+",
        "?",
        "|",
        "(",
        ")",
        "[",
        "]",
        "{",
        "}",
        "\\",
        "$",
        "^",
        "-"
    ].join("|\\") + ")", "g");
    // http://en.wikipedia.org/wiki/Foreign_exchange_market
    // - \u20BD - Russian ruble.
    // - \u20a9 - South Korean Won
    // - \u20BA - Turkish Lira
    // - \u20B9 - Indian Rupee
    // - R - Brazil (R$) and South Africa
    // - fr - Swiss Franc
    // - kr - Swedish krona, Norwegian krone and Danish krone
    // - \u2009 is thin space and \u202F is narrow no-break space, both used in many
    // - Ƀ - Bitcoin
    // - Ξ - Ethereum
    //   standards as thousands separators.
    var _re_formatted_numeric = /['\u00A0,$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfkɃΞ]/gi;
    var _empty = function(d) {
        return !d || d === true || d === "-" ? true : false;
    };
    var _intVal = function(s) {
        var integer = parseInt(s, 10);
        return !isNaN(integer) && isFinite(s) ? integer : null;
    };
    // Convert from a formatted number with characters other than `.` as the
    // decimal place, to a Javascript number
    var _numToDecimal = function(num, decimalPoint) {
        // Cache created regular expressions for speed as this function is called often
        if (!_re_dic[decimalPoint]) _re_dic[decimalPoint] = new RegExp(_fnEscapeRegex(decimalPoint), "g");
        return typeof num === "string" && decimalPoint !== "." ? num.replace(/\./g, "").replace(_re_dic[decimalPoint], ".") : num;
    };
    var _isNumber = function(d, decimalPoint, formatted) {
        var strType = typeof d === "string";
        // If empty return immediately so there must be a number if it is a
        // formatted string (this stops the string "k", or "kr", etc being detected
        // as a formatted number for currency
        if (_empty(d)) return true;
        if (decimalPoint && strType) d = _numToDecimal(d, decimalPoint);
        if (formatted && strType) d = d.replace(_re_formatted_numeric, "");
        return !isNaN(parseFloat(d)) && isFinite(d);
    };
    // A string without HTML in it can be considered to be HTML still
    var _isHtml = function(d) {
        return _empty(d) || typeof d === "string";
    };
    var _htmlNumeric = function(d, decimalPoint, formatted) {
        if (_empty(d)) return true;
        var html = _isHtml(d);
        return !html ? null : _isNumber(_stripHtml(d), decimalPoint, formatted) ? true : null;
    };
    var _pluck = function(a, prop, prop2) {
        var out = [];
        var i = 0, ien = a.length;
        // Could have the test in the loop for slightly smaller code, but speed
        // is essential here
        if (prop2 !== undefined) {
            for(; i < ien; i++)if (a[i] && a[i][prop]) out.push(a[i][prop][prop2]);
        } else {
            for(; i < ien; i++)if (a[i]) out.push(a[i][prop]);
        }
        return out;
    };
    // Basically the same as _pluck, but rather than looping over `a` we use `order`
    // as the indexes to pick from `a`
    var _pluck_order = function(a, order, prop, prop2) {
        var out = [];
        var i = 0, ien = order.length;
        // Could have the test in the loop for slightly smaller code, but speed
        // is essential here
        if (prop2 !== undefined) {
            for(; i < ien; i++)if (a[order[i]][prop]) out.push(a[order[i]][prop][prop2]);
        } else for(; i < ien; i++)out.push(a[order[i]][prop]);
        return out;
    };
    var _range = function(len, start) {
        var out = [];
        var end;
        if (start === undefined) {
            start = 0;
            end = len;
        } else {
            end = start;
            start = len;
        }
        for(var i = start; i < end; i++)out.push(i);
        return out;
    };
    var _removeEmpty = function(a) {
        var out = [];
        for(var i = 0, ien = a.length; i < ien; i++)if (a[i]) out.push(a[i]);
        return out;
    };
    var _stripHtml = function(d) {
        return d.replace(_re_html, "");
    };
    /**
	 * Determine if all values in the array are unique. This means we can short
	 * cut the _unique method at the cost of a single loop. A sorted array is used
	 * to easily check the values.
	 *
	 * @param  {array} src Source array
	 * @return {boolean} true if all unique, false otherwise
	 * @ignore
	 */ var _areAllUnique = function(src) {
        if (src.length < 2) return true;
        var sorted = src.slice().sort();
        var last = sorted[0];
        for(var i = 1, ien = sorted.length; i < ien; i++){
            if (sorted[i] === last) return false;
            last = sorted[i];
        }
        return true;
    };
    /**
	 * Find the unique elements in a source array.
	 *
	 * @param  {array} src Source array
	 * @return {array} Array of unique items
	 * @ignore
	 */ var _unique = function(src) {
        if (_areAllUnique(src)) return src.slice();
        // A faster unique method is to use object keys to identify used values,
        // but this doesn't work with arrays or objects, which we must also
        // consider. See jsperf.com/compare-array-unique-versions/4 for more
        // information.
        var out = [], val, i, ien = src.length, j, k = 0;
        again: for(i = 0; i < ien; i++){
            val = src[i];
            for(j = 0; j < k; j++){
                if (out[j] === val) continue again;
            }
            out.push(val);
            k++;
        }
        return out;
    };
    // Surprisingly this is faster than [].concat.apply
    // https://jsperf.com/flatten-an-array-loop-vs-reduce/2
    var _flatten = function(out, val) {
        if (Array.isArray(val)) for(var i = 0; i < val.length; i++)_flatten(out, val[i]);
        else out.push(val);
        return out;
    };
    var _includes = function(search, start) {
        if (start === undefined) start = 0;
        return this.indexOf(search, start) !== -1;
    };
    // Array.isArray polyfill.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
    if (!Array.isArray) Array.isArray = function(arg) {
        return Object.prototype.toString.call(arg) === "[object Array]";
    };
    if (!Array.prototype.includes) Array.prototype.includes = _includes;
    // .trim() polyfill
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/trim
    if (!String.prototype.trim) String.prototype.trim = function() {
        return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    };
    if (!String.prototype.includes) String.prototype.includes = _includes;
    /**
	 * DataTables utility methods
	 * 
	 * This namespace provides helper methods that DataTables uses internally to
	 * create a DataTable, but which are not exclusively used only for DataTables.
	 * These methods can be used by extension authors to save the duplication of
	 * code.
	 *
	 *  @namespace
	 */ DataTable.util = {
        /**
		 * Throttle the calls to a function. Arguments and context are maintained
		 * for the throttled function.
		 *
		 * @param {function} fn Function to be called
		 * @param {integer} freq Call frequency in mS
		 * @return {function} Wrapped function
		 */ throttle: function(fn, freq) {
            var frequency = freq !== undefined ? freq : 200, last, timer;
            return function() {
                var that = this, now = +new Date(), args = arguments;
                if (last && now < last + frequency) {
                    clearTimeout(timer);
                    timer = setTimeout(function() {
                        last = undefined;
                        fn.apply(that, args);
                    }, frequency);
                } else {
                    last = now;
                    fn.apply(that, args);
                }
            };
        },
        /**
		 * Escape a string such that it can be used in a regular expression
		 *
		 *  @param {string} val string to escape
		 *  @returns {string} escaped string
		 */ escapeRegex: function(val) {
            return val.replace(_re_escape_regex, "\\$1");
        },
        /**
		 * Create a function that will write to a nested object or array
		 * @param {*} source JSON notation string
		 * @returns Write function
		 */ set: function(source) {
            if ($.isPlainObject(source)) /* Unlike get, only the underscore (global) option is used for for
				 * setting data since we don't know the type here. This is why an object
				 * option is not documented for `mData` (which is read/write), but it is
				 * for `mRender` which is read only.
				 */ return DataTable.util.set(source._);
            else if (source === null) // Nothing to do when the data source is null
            return function() {};
            else if (typeof source === "function") return function(data, val, meta) {
                source(data, "set", val, meta);
            };
            else if (typeof source === "string" && (source.indexOf(".") !== -1 || source.indexOf("[") !== -1 || source.indexOf("(") !== -1)) {
                // Like the get, we need to get data from a nested object
                var setData = function(data, val, src) {
                    var a = _fnSplitObjNotation(src), b;
                    var aLast = a[a.length - 1];
                    var arrayNotation, funcNotation, o, innerSrc;
                    for(var i = 0, iLen = a.length - 1; i < iLen; i++){
                        // Protect against prototype pollution
                        if (a[i] === "__proto__" || a[i] === "constructor") throw new Error("Cannot set prototype values");
                        // Check if we are dealing with an array notation request
                        arrayNotation = a[i].match(__reArray);
                        funcNotation = a[i].match(__reFn);
                        if (arrayNotation) {
                            a[i] = a[i].replace(__reArray, "");
                            data[a[i]] = [];
                            // Get the remainder of the nested object to set so we can recurse
                            b = a.slice();
                            b.splice(0, i + 1);
                            innerSrc = b.join(".");
                            // Traverse each entry in the array setting the properties requested
                            if (Array.isArray(val)) for(var j = 0, jLen = val.length; j < jLen; j++){
                                o = {};
                                setData(o, val[j], innerSrc);
                                data[a[i]].push(o);
                            }
                            else // We've been asked to save data to an array, but it
                            // isn't array data to be saved. Best that can be done
                            // is to just save the value.
                            data[a[i]] = val;
                            // The inner call to setData has already traversed through the remainder
                            // of the source and has set the data, thus we can exit here
                            return;
                        } else if (funcNotation) {
                            // Function call
                            a[i] = a[i].replace(__reFn, "");
                            data = data[a[i]](val);
                        }
                        // If the nested object doesn't currently exist - since we are
                        // trying to set the value - create it
                        if (data[a[i]] === null || data[a[i]] === undefined) data[a[i]] = {};
                        data = data[a[i]];
                    }
                    // Last item in the input - i.e, the actual set
                    if (aLast.match(__reFn)) // Function call
                    data = data[aLast.replace(__reFn, "")](val);
                    else // If array notation is used, we just want to strip it and use the property name
                    // and assign the value. If it isn't used, then we get the result we want anyway
                    data[aLast.replace(__reArray, "")] = val;
                };
                return function(data, val) {
                    return setData(data, val, source);
                };
            } else // Array or flat object mapping
            return function(data, val) {
                data[source] = val;
            };
        },
        /**
		 * Create a function that will read nested objects from arrays, based on JSON notation
		 * @param {*} source JSON notation string
		 * @returns Value read
		 */ get: function(source) {
            if ($.isPlainObject(source)) {
                // Build an object of get functions, and wrap them in a single call
                var o = {};
                $.each(source, function(key, val) {
                    if (val) o[key] = DataTable.util.get(val);
                });
                return function(data, type, row, meta) {
                    var t = o[type] || o._;
                    return t !== undefined ? t(data, type, row, meta) : data;
                };
            } else if (source === null) // Give an empty string for rendering / sorting etc
            return function(data) {
                return data;
            };
            else if (typeof source === "function") return function(data, type, row, meta) {
                return source(data, type, row, meta);
            };
            else if (typeof source === "string" && (source.indexOf(".") !== -1 || source.indexOf("[") !== -1 || source.indexOf("(") !== -1)) {
                /* If there is a . in the source string then the data source is in a
				 * nested object so we loop over the data for each level to get the next
				 * level down. On each loop we test for undefined, and if found immediately
				 * return. This allows entire objects to be missing and sDefaultContent to
				 * be used if defined, rather than throwing an error
				 */ var fetchData = function(data, type, src) {
                    var arrayNotation, funcNotation, out, innerSrc;
                    if (src !== "") {
                        var a = _fnSplitObjNotation(src);
                        for(var i = 0, iLen = a.length; i < iLen; i++){
                            // Check if we are dealing with special notation
                            arrayNotation = a[i].match(__reArray);
                            funcNotation = a[i].match(__reFn);
                            if (arrayNotation) {
                                // Array notation
                                a[i] = a[i].replace(__reArray, "");
                                // Condition allows simply [] to be passed in
                                if (a[i] !== "") data = data[a[i]];
                                out = [];
                                // Get the remainder of the nested object to get
                                a.splice(0, i + 1);
                                innerSrc = a.join(".");
                                // Traverse each entry in the array getting the properties requested
                                if (Array.isArray(data)) for(var j = 0, jLen = data.length; j < jLen; j++)out.push(fetchData(data[j], type, innerSrc));
                                // If a string is given in between the array notation indicators, that
                                // is used to join the strings together, otherwise an array is returned
                                var join = arrayNotation[0].substring(1, arrayNotation[0].length - 1);
                                data = join === "" ? out : out.join(join);
                                break;
                            } else if (funcNotation) {
                                // Function call
                                a[i] = a[i].replace(__reFn, "");
                                data = data[a[i]]();
                                continue;
                            }
                            if (data === null || data[a[i]] === undefined) return undefined;
                            data = data[a[i]];
                        }
                    }
                    return data;
                };
                return function(data, type) {
                    return fetchData(data, type, source);
                };
            } else // Array or flat object mapping
            return function(data, type) {
                return data[source];
            };
        }
    };
    /**
	 * Create a mapping object that allows camel case parameters to be looked up
	 * for their Hungarian counterparts. The mapping is stored in a private
	 * parameter called `_hungarianMap` which can be accessed on the source object.
	 *  @param {object} o
	 *  @memberof DataTable#oApi
	 */ function _fnHungarianMap(o) {
        var hungarian = "a aa ai ao as b fn i m o s ", match, newKey, map = {};
        $.each(o, function(key, val) {
            match = key.match(/^([^A-Z]+?)([A-Z])/);
            if (match && hungarian.indexOf(match[1] + " ") !== -1) {
                newKey = key.replace(match[0], match[2].toLowerCase());
                map[newKey] = key;
                if (match[1] === "o") _fnHungarianMap(o[key]);
            }
        });
        o._hungarianMap = map;
    }
    /**
	 * Convert from camel case parameters to Hungarian, based on a Hungarian map
	 * created by _fnHungarianMap.
	 *  @param {object} src The model object which holds all parameters that can be
	 *    mapped.
	 *  @param {object} user The object to convert from camel case to Hungarian.
	 *  @param {boolean} force When set to `true`, properties which already have a
	 *    Hungarian value in the `user` object will be overwritten. Otherwise they
	 *    won't be.
	 *  @memberof DataTable#oApi
	 */ function _fnCamelToHungarian(src, user, force) {
        if (!src._hungarianMap) _fnHungarianMap(src);
        var hungarianKey;
        $.each(user, function(key, val) {
            hungarianKey = src._hungarianMap[key];
            if (hungarianKey !== undefined && (force || user[hungarianKey] === undefined)) {
                // For objects, we need to buzz down into the object to copy parameters
                if (hungarianKey.charAt(0) === "o") {
                    // Copy the camelCase options over to the hungarian
                    if (!user[hungarianKey]) user[hungarianKey] = {};
                    $.extend(true, user[hungarianKey], user[key]);
                    _fnCamelToHungarian(src[hungarianKey], user[hungarianKey], force);
                } else user[hungarianKey] = user[key];
            }
        });
    }
    /**
	 * Language compatibility - when certain options are given, and others aren't, we
	 * need to duplicate the values over, in order to provide backwards compatibility
	 * with older language files.
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */ function _fnLanguageCompat(lang) {
        // Note the use of the Hungarian notation for the parameters in this method as
        // this is called after the mapping of camelCase to Hungarian
        var defaults = DataTable.defaults.oLanguage;
        // Default mapping
        var defaultDecimal = defaults.sDecimal;
        if (defaultDecimal) _addNumericSort(defaultDecimal);
        if (lang) {
            var zeroRecords = lang.sZeroRecords;
            // Backwards compatibility - if there is no sEmptyTable given, then use the same as
            // sZeroRecords - assuming that is given.
            if (!lang.sEmptyTable && zeroRecords && defaults.sEmptyTable === "No data available in table") _fnMap(lang, lang, "sZeroRecords", "sEmptyTable");
            // Likewise with loading records
            if (!lang.sLoadingRecords && zeroRecords && defaults.sLoadingRecords === "Loading...") _fnMap(lang, lang, "sZeroRecords", "sLoadingRecords");
            // Old parameter name of the thousands separator mapped onto the new
            if (lang.sInfoThousands) lang.sThousands = lang.sInfoThousands;
            var decimal = lang.sDecimal;
            if (decimal && defaultDecimal !== decimal) _addNumericSort(decimal);
        }
    }
    /**
	 * Map one parameter onto another
	 *  @param {object} o Object to map
	 *  @param {*} knew The new parameter name
	 *  @param {*} old The old parameter name
	 */ var _fnCompatMap = function(o, knew, old) {
        if (o[knew] !== undefined) o[old] = o[knew];
    };
    /**
	 * Provide backwards compatibility for the main DT options. Note that the new
	 * options are mapped onto the old parameters, so this is an external interface
	 * change only.
	 *  @param {object} init Object to map
	 */ function _fnCompatOpts(init) {
        _fnCompatMap(init, "ordering", "bSort");
        _fnCompatMap(init, "orderMulti", "bSortMulti");
        _fnCompatMap(init, "orderClasses", "bSortClasses");
        _fnCompatMap(init, "orderCellsTop", "bSortCellsTop");
        _fnCompatMap(init, "order", "aaSorting");
        _fnCompatMap(init, "orderFixed", "aaSortingFixed");
        _fnCompatMap(init, "paging", "bPaginate");
        _fnCompatMap(init, "pagingType", "sPaginationType");
        _fnCompatMap(init, "pageLength", "iDisplayLength");
        _fnCompatMap(init, "searching", "bFilter");
        // Boolean initialisation of x-scrolling
        if (typeof init.sScrollX === "boolean") init.sScrollX = init.sScrollX ? "100%" : "";
        if (typeof init.scrollX === "boolean") init.scrollX = init.scrollX ? "100%" : "";
        // Column search objects are in an array, so it needs to be converted
        // element by element
        var searchCols = init.aoSearchCols;
        if (searchCols) {
            for(var i = 0, ien = searchCols.length; i < ien; i++)if (searchCols[i]) _fnCamelToHungarian(DataTable.models.oSearch, searchCols[i]);
        }
    }
    /**
	 * Provide backwards compatibility for column options. Note that the new options
	 * are mapped onto the old parameters, so this is an external interface change
	 * only.
	 *  @param {object} init Object to map
	 */ function _fnCompatCols(init) {
        _fnCompatMap(init, "orderable", "bSortable");
        _fnCompatMap(init, "orderData", "aDataSort");
        _fnCompatMap(init, "orderSequence", "asSorting");
        _fnCompatMap(init, "orderDataType", "sortDataType");
        // orderData can be given as an integer
        var dataSort = init.aDataSort;
        if (typeof dataSort === "number" && !Array.isArray(dataSort)) init.aDataSort = [
            dataSort
        ];
    }
    /**
	 * Browser feature detection for capabilities, quirks
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */ function _fnBrowserDetect(settings) {
        // We don't need to do this every time DataTables is constructed, the values
        // calculated are specific to the browser and OS configuration which we
        // don't expect to change between initialisations
        if (!DataTable.__browser) {
            var browser = {};
            DataTable.__browser = browser;
            // Scrolling feature / quirks detection
            var n = $("<div/>").css({
                position: "fixed",
                top: 0,
                left: $(window1).scrollLeft() * -1,
                height: 1,
                width: 1,
                overflow: "hidden"
            }).append($("<div/>").css({
                position: "absolute",
                top: 1,
                left: 1,
                width: 100,
                overflow: "scroll"
            }).append($("<div/>").css({
                width: "100%",
                height: 10
            }))).appendTo("body");
            var outer = n.children();
            var inner = outer.children();
            // Numbers below, in order, are:
            // inner.offsetWidth, inner.clientWidth, outer.offsetWidth, outer.clientWidth
            //
            // IE6 XP:                           100 100 100  83
            // IE7 Vista:                        100 100 100  83
            // IE 8+ Windows:                     83  83 100  83
            // Evergreen Windows:                 83  83 100  83
            // Evergreen Mac with scrollbars:     85  85 100  85
            // Evergreen Mac without scrollbars: 100 100 100 100
            // Get scrollbar width
            browser.barWidth = outer[0].offsetWidth - outer[0].clientWidth;
            // IE6/7 will oversize a width 100% element inside a scrolling element, to
            // include the width of the scrollbar, while other browsers ensure the inner
            // element is contained without forcing scrolling
            browser.bScrollOversize = inner[0].offsetWidth === 100 && outer[0].clientWidth !== 100;
            // In rtl text layout, some browsers (most, but not all) will place the
            // scrollbar on the left, rather than the right.
            browser.bScrollbarLeft = Math.round(inner.offset().left) !== 1;
            // IE8- don't provide height and width for getBoundingClientRect
            browser.bBounding = n[0].getBoundingClientRect().width ? true : false;
            n.remove();
        }
        $.extend(settings.oBrowser, DataTable.__browser);
        settings.oScroll.iBarWidth = DataTable.__browser.barWidth;
    }
    /**
	 * Array.prototype reduce[Right] method, used for browsers which don't support
	 * JS 1.6. Done this way to reduce code size, since we iterate either way
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */ function _fnReduce(that, fn, init, start, end, inc) {
        var i = start, value, isSet = false;
        if (init !== undefined) {
            value = init;
            isSet = true;
        }
        while(i !== end){
            if (!that.hasOwnProperty(i)) continue;
            value = isSet ? fn(value, that[i], i, that) : that[i];
            isSet = true;
            i += inc;
        }
        return value;
    }
    /**
	 * Add a column to the list used for the table with default values
	 *  @param {object} oSettings dataTables settings object
	 *  @param {node} nTh The th element for this column
	 *  @memberof DataTable#oApi
	 */ function _fnAddColumn(oSettings, nTh) {
        // Add column to aoColumns array
        var oDefaults = DataTable.defaults.column;
        var iCol = oSettings.aoColumns.length;
        var oCol = $.extend({}, DataTable.models.oColumn, oDefaults, {
            "nTh": nTh ? nTh : document1.createElement("th"),
            "sTitle": oDefaults.sTitle ? oDefaults.sTitle : nTh ? nTh.innerHTML : "",
            "aDataSort": oDefaults.aDataSort ? oDefaults.aDataSort : [
                iCol
            ],
            "mData": oDefaults.mData ? oDefaults.mData : iCol,
            idx: iCol
        });
        oSettings.aoColumns.push(oCol);
        // Add search object for column specific search. Note that the `searchCols[ iCol ]`
        // passed into extend can be undefined. This allows the user to give a default
        // with only some of the parameters defined, and also not give a default
        var searchCols = oSettings.aoPreSearchCols;
        searchCols[iCol] = $.extend({}, DataTable.models.oSearch, searchCols[iCol]);
        // Use the default column options function to initialise classes etc
        _fnColumnOptions(oSettings, iCol, $(nTh).data());
    }
    /**
	 * Apply options for a column
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iCol column index to consider
	 *  @param {object} oOptions object with sType, bVisible and bSearchable etc
	 *  @memberof DataTable#oApi
	 */ function _fnColumnOptions(oSettings, iCol, oOptions) {
        var oCol = oSettings.aoColumns[iCol];
        var oClasses = oSettings.oClasses;
        var th = $(oCol.nTh);
        // Try to get width information from the DOM. We can't get it from CSS
        // as we'd need to parse the CSS stylesheet. `width` option can override
        if (!oCol.sWidthOrig) {
            // Width attribute
            oCol.sWidthOrig = th.attr("width") || null;
            // Style attribute
            var t = (th.attr("style") || "").match(/width:\s*(\d+[pxem%]+)/);
            if (t) oCol.sWidthOrig = t[1];
        }
        /* User specified column options */ if (oOptions !== undefined && oOptions !== null) {
            // Backwards compatibility
            _fnCompatCols(oOptions);
            // Map camel case parameters to their Hungarian counterparts
            _fnCamelToHungarian(DataTable.defaults.column, oOptions, true);
            /* Backwards compatibility for mDataProp */ if (oOptions.mDataProp !== undefined && !oOptions.mData) oOptions.mData = oOptions.mDataProp;
            if (oOptions.sType) oCol._sManualType = oOptions.sType;
            // `class` is a reserved word in Javascript, so we need to provide
            // the ability to use a valid name for the camel case input
            if (oOptions.className && !oOptions.sClass) oOptions.sClass = oOptions.className;
            if (oOptions.sClass) th.addClass(oOptions.sClass);
            var origClass = oCol.sClass;
            $.extend(oCol, oOptions);
            _fnMap(oCol, oOptions, "sWidth", "sWidthOrig");
            // Merge class from previously defined classes with this one, rather than just
            // overwriting it in the extend above
            if (origClass !== oCol.sClass) oCol.sClass = origClass + " " + oCol.sClass;
            /* iDataSort to be applied (backwards compatibility), but aDataSort will take
			 * priority if defined
			 */ if (oOptions.iDataSort !== undefined) oCol.aDataSort = [
                oOptions.iDataSort
            ];
            _fnMap(oCol, oOptions, "aDataSort");
        }
        /* Cache the data get and set functions for speed */ var mDataSrc = oCol.mData;
        var mData = _fnGetObjectDataFn(mDataSrc);
        var mRender = oCol.mRender ? _fnGetObjectDataFn(oCol.mRender) : null;
        var attrTest = function(src) {
            return typeof src === "string" && src.indexOf("@") !== -1;
        };
        oCol._bAttrSrc = $.isPlainObject(mDataSrc) && (attrTest(mDataSrc.sort) || attrTest(mDataSrc.type) || attrTest(mDataSrc.filter));
        oCol._setter = null;
        oCol.fnGetData = function(rowData, type, meta) {
            var innerData = mData(rowData, type, undefined, meta);
            return mRender && type ? mRender(innerData, type, rowData, meta) : innerData;
        };
        oCol.fnSetData = function(rowData, val, meta) {
            return _fnSetObjectDataFn(mDataSrc)(rowData, val, meta);
        };
        // Indicate if DataTables should read DOM data as an object or array
        // Used in _fnGetRowElements
        if (typeof mDataSrc !== "number") oSettings._rowReadObject = true;
        /* Feature sorting overrides column specific when off */ if (!oSettings.oFeatures.bSort) {
            oCol.bSortable = false;
            th.addClass(oClasses.sSortableNone); // Have to add class here as order event isn't called
        }
        /* Check that the class assignment is correct for sorting */ var bAsc = $.inArray("asc", oCol.asSorting) !== -1;
        var bDesc = $.inArray("desc", oCol.asSorting) !== -1;
        if (!oCol.bSortable || !bAsc && !bDesc) {
            oCol.sSortingClass = oClasses.sSortableNone;
            oCol.sSortingClassJUI = "";
        } else if (bAsc && !bDesc) {
            oCol.sSortingClass = oClasses.sSortableAsc;
            oCol.sSortingClassJUI = oClasses.sSortJUIAscAllowed;
        } else if (!bAsc && bDesc) {
            oCol.sSortingClass = oClasses.sSortableDesc;
            oCol.sSortingClassJUI = oClasses.sSortJUIDescAllowed;
        } else {
            oCol.sSortingClass = oClasses.sSortable;
            oCol.sSortingClassJUI = oClasses.sSortJUI;
        }
    }
    /**
	 * Adjust the table column widths for new data. Note: you would probably want to
	 * do a redraw after calling this function!
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */ function _fnAdjustColumnSizing(settings) {
        /* Not interested in doing column width calculation if auto-width is disabled */ if (settings.oFeatures.bAutoWidth !== false) {
            var columns = settings.aoColumns;
            _fnCalculateColumnWidths(settings);
            for(var i = 0, iLen = columns.length; i < iLen; i++)columns[i].nTh.style.width = columns[i].sWidth;
        }
        var scroll = settings.oScroll;
        if (scroll.sY !== "" || scroll.sX !== "") _fnScrollDraw(settings);
        _fnCallbackFire(settings, null, "column-sizing", [
            settings
        ]);
    }
    /**
	 * Convert the index of a visible column to the index in the data array (take account
	 * of hidden columns)
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iMatch Visible column index to lookup
	 *  @returns {int} i the data index
	 *  @memberof DataTable#oApi
	 */ function _fnVisibleToColumnIndex(oSettings, iMatch) {
        var aiVis = _fnGetColumns(oSettings, "bVisible");
        return typeof aiVis[iMatch] === "number" ? aiVis[iMatch] : null;
    }
    /**
	 * Convert the index of an index in the data array and convert it to the visible
	 *   column index (take account of hidden columns)
	 *  @param {int} iMatch Column index to lookup
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {int} i the data index
	 *  @memberof DataTable#oApi
	 */ function _fnColumnIndexToVisible(oSettings, iMatch) {
        var aiVis = _fnGetColumns(oSettings, "bVisible");
        var iPos = $.inArray(iMatch, aiVis);
        return iPos !== -1 ? iPos : null;
    }
    /**
	 * Get the number of visible columns
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {int} i the number of visible columns
	 *  @memberof DataTable#oApi
	 */ function _fnVisbleColumns(oSettings) {
        var vis = 0;
        // No reduce in IE8, use a loop for now
        $.each(oSettings.aoColumns, function(i, col) {
            if (col.bVisible && $(col.nTh).css("display") !== "none") vis++;
        });
        return vis;
    }
    /**
	 * Get an array of column indexes that match a given property
	 *  @param {object} oSettings dataTables settings object
	 *  @param {string} sParam Parameter in aoColumns to look for - typically
	 *    bVisible or bSearchable
	 *  @returns {array} Array of indexes with matched properties
	 *  @memberof DataTable#oApi
	 */ function _fnGetColumns(oSettings, sParam) {
        var a = [];
        $.map(oSettings.aoColumns, function(val, i) {
            if (val[sParam]) a.push(i);
        });
        return a;
    }
    /**
	 * Calculate the 'type' of a column
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */ function _fnColumnTypes(settings) {
        var columns = settings.aoColumns;
        var data = settings.aoData;
        var types = DataTable.ext.type.detect;
        var i, ien, j, jen, k, ken;
        var col, cell, detectedType, cache;
        // For each column, spin over the 
        for(i = 0, ien = columns.length; i < ien; i++){
            col = columns[i];
            cache = [];
            if (!col.sType && col._sManualType) col.sType = col._sManualType;
            else if (!col.sType) {
                for(j = 0, jen = types.length; j < jen; j++){
                    for(k = 0, ken = data.length; k < ken; k++){
                        // Use a cache array so we only need to get the type data
                        // from the formatter once (when using multiple detectors)
                        if (cache[k] === undefined) cache[k] = _fnGetCellData(settings, k, i, "type");
                        detectedType = types[j](cache[k], settings);
                        // If null, then this type can't apply to this column, so
                        // rather than testing all cells, break out. There is an
                        // exception for the last type which is `html`. We need to
                        // scan all rows since it is possible to mix string and HTML
                        // types
                        if (!detectedType && j !== types.length - 1) break;
                        // Only a single match is needed for html type since it is
                        // bottom of the pile and very similar to string - but it
                        // must not be empty
                        if (detectedType === "html" && !_empty(cache[k])) break;
                    }
                    // Type is valid for all data points in the column - use this
                    // type
                    if (detectedType) {
                        col.sType = detectedType;
                        break;
                    }
                }
                // Fall back - if no type was detected, always use string
                if (!col.sType) col.sType = "string";
            }
        }
    }
    /**
	 * Take the column definitions and static columns arrays and calculate how
	 * they relate to column indexes. The callback function will then apply the
	 * definition found for a column to a suitable configuration object.
	 *  @param {object} oSettings dataTables settings object
	 *  @param {array} aoColDefs The aoColumnDefs array that is to be applied
	 *  @param {array} aoCols The aoColumns array that defines columns individually
	 *  @param {function} fn Callback function - takes two parameters, the calculated
	 *    column index and the definition for that column.
	 *  @memberof DataTable#oApi
	 */ function _fnApplyColumnDefs(oSettings, aoColDefs, aoCols, fn) {
        var i, iLen, j, jLen, k, kLen, def;
        var columns = oSettings.aoColumns;
        // Column definitions with aTargets
        if (aoColDefs) /* Loop over the definitions array - loop in reverse so first instance has priority */ for(i = aoColDefs.length - 1; i >= 0; i--){
            def = aoColDefs[i];
            /* Each definition can target multiple columns, as it is an array */ var aTargets = def.target !== undefined ? def.target : def.targets !== undefined ? def.targets : def.aTargets;
            if (!Array.isArray(aTargets)) aTargets = [
                aTargets
            ];
            for(j = 0, jLen = aTargets.length; j < jLen; j++){
                if (typeof aTargets[j] === "number" && aTargets[j] >= 0) {
                    /* Add columns that we don't yet know about */ while(columns.length <= aTargets[j])_fnAddColumn(oSettings);
                    /* Integer, basic index */ fn(aTargets[j], def);
                } else if (typeof aTargets[j] === "number" && aTargets[j] < 0) /* Negative integer, right to left column counting */ fn(columns.length + aTargets[j], def);
                else if (typeof aTargets[j] === "string") {
                    /* Class name matching on TH element */ for(k = 0, kLen = columns.length; k < kLen; k++)if (aTargets[j] == "_all" || $(columns[k].nTh).hasClass(aTargets[j])) fn(k, def);
                }
            }
        }
        // Statically defined columns array
        if (aoCols) for(i = 0, iLen = aoCols.length; i < iLen; i++)fn(i, aoCols[i]);
    }
    /**
	 * Add a data array to the table, creating DOM node etc. This is the parallel to
	 * _fnGatherData, but for adding rows from a Javascript source, rather than a
	 * DOM source.
	 *  @param {object} oSettings dataTables settings object
	 *  @param {array} aData data array to be added
	 *  @param {node} [nTr] TR element to add to the table - optional. If not given,
	 *    DataTables will create a row automatically
	 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
	 *    if nTr is.
	 *  @returns {int} >=0 if successful (index of new aoData entry), -1 if failed
	 *  @memberof DataTable#oApi
	 */ function _fnAddData(oSettings, aDataIn, nTr, anTds) {
        /* Create the object for storing information about this new row */ var iRow = oSettings.aoData.length;
        var oData = $.extend(true, {}, DataTable.models.oRow, {
            src: nTr ? "dom" : "data",
            idx: iRow
        });
        oData._aData = aDataIn;
        oSettings.aoData.push(oData);
        /* Create the cells */ var nTd, sThisType;
        var columns = oSettings.aoColumns;
        // Invalidate the column types as the new data needs to be revalidated
        for(var i = 0, iLen = columns.length; i < iLen; i++)columns[i].sType = null;
        /* Add to the display array */ oSettings.aiDisplayMaster.push(iRow);
        var id = oSettings.rowIdFn(aDataIn);
        if (id !== undefined) oSettings.aIds[id] = oData;
        /* Create the DOM information, or register it if already present */ if (nTr || !oSettings.oFeatures.bDeferRender) _fnCreateTr(oSettings, iRow, nTr, anTds);
        return iRow;
    }
    /**
	 * Add one or more TR elements to the table. Generally we'd expect to
	 * use this for reading data from a DOM sourced table, but it could be
	 * used for an TR element. Note that if a TR is given, it is used (i.e.
	 * it is not cloned).
	 *  @param {object} settings dataTables settings object
	 *  @param {array|node|jQuery} trs The TR element(s) to add to the table
	 *  @returns {array} Array of indexes for the added rows
	 *  @memberof DataTable#oApi
	 */ function _fnAddTr(settings, trs) {
        var row;
        // Allow an individual node to be passed in
        if (!(trs instanceof $)) trs = $(trs);
        return trs.map(function(i, el) {
            row = _fnGetRowElements(settings, el);
            return _fnAddData(settings, row.data, el, row.cells);
        });
    }
    /**
	 * Take a TR element and convert it to an index in aoData
	 *  @param {object} oSettings dataTables settings object
	 *  @param {node} n the TR element to find
	 *  @returns {int} index if the node is found, null if not
	 *  @memberof DataTable#oApi
	 */ function _fnNodeToDataIndex(oSettings, n) {
        return n._DT_RowIndex !== undefined ? n._DT_RowIndex : null;
    }
    /**
	 * Take a TD element and convert it into a column data index (not the visible index)
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iRow The row number the TD/TH can be found in
	 *  @param {node} n The TD/TH element to find
	 *  @returns {int} index if the node is found, -1 if not
	 *  @memberof DataTable#oApi
	 */ function _fnNodeToColumnIndex(oSettings, iRow, n) {
        return $.inArray(n, oSettings.aoData[iRow].anCells);
    }
    /**
	 * Get the data for a given cell from the internal cache, taking into account data mapping
	 *  @param {object} settings dataTables settings object
	 *  @param {int} rowIdx aoData row id
	 *  @param {int} colIdx Column index
	 *  @param {string} type data get type ('display', 'type' 'filter|search' 'sort|order')
	 *  @returns {*} Cell data
	 *  @memberof DataTable#oApi
	 */ function _fnGetCellData(settings, rowIdx, colIdx, type) {
        if (type === "search") type = "filter";
        else if (type === "order") type = "sort";
        var draw = settings.iDraw;
        var col = settings.aoColumns[colIdx];
        var rowData = settings.aoData[rowIdx]._aData;
        var defaultContent = col.sDefaultContent;
        var cellData = col.fnGetData(rowData, type, {
            settings: settings,
            row: rowIdx,
            col: colIdx
        });
        if (cellData === undefined) {
            if (settings.iDrawError != draw && defaultContent === null) {
                _fnLog(settings, 0, "Requested unknown parameter " + (typeof col.mData == "function" ? "{function}" : "'" + col.mData + "'") + " for row " + rowIdx + ", column " + colIdx, 4);
                settings.iDrawError = draw;
            }
            return defaultContent;
        }
        // When the data source is null and a specific data type is requested (i.e.
        // not the original data), we can use default column data
        if ((cellData === rowData || cellData === null) && defaultContent !== null && type !== undefined) cellData = defaultContent;
        else if (typeof cellData === "function") // If the data source is a function, then we run it and use the return,
        // executing in the scope of the data object (for instances)
        return cellData.call(rowData);
        if (cellData === null && type === "display") return "";
        if (type === "filter") {
            var fomatters = DataTable.ext.type.search;
            if (fomatters[col.sType]) cellData = fomatters[col.sType](cellData);
        }
        return cellData;
    }
    /**
	 * Set the value for a specific cell, into the internal data cache
	 *  @param {object} settings dataTables settings object
	 *  @param {int} rowIdx aoData row id
	 *  @param {int} colIdx Column index
	 *  @param {*} val Value to set
	 *  @memberof DataTable#oApi
	 */ function _fnSetCellData(settings, rowIdx, colIdx, val) {
        var col = settings.aoColumns[colIdx];
        var rowData = settings.aoData[rowIdx]._aData;
        col.fnSetData(rowData, val, {
            settings: settings,
            row: rowIdx,
            col: colIdx
        });
    }
    // Private variable that is used to match action syntax in the data property object
    var __reArray = /\[.*?\]$/;
    var __reFn = /\(\)$/;
    /**
	 * Split string on periods, taking into account escaped periods
	 * @param  {string} str String to split
	 * @return {array} Split string
	 */ function _fnSplitObjNotation(str) {
        return $.map(str.match(/(\\.|[^\.])+/g) || [
            ""
        ], function(s) {
            return s.replace(/\\\./g, ".");
        });
    }
    /**
	 * Return a function that can be used to get data from a source object, taking
	 * into account the ability to use nested objects as a source
	 *  @param {string|int|function} mSource The data source for the object
	 *  @returns {function} Data get function
	 *  @memberof DataTable#oApi
	 */ var _fnGetObjectDataFn = DataTable.util.get;
    /**
	 * Return a function that can be used to set data from a source object, taking
	 * into account the ability to use nested objects as a source
	 *  @param {string|int|function} mSource The data source for the object
	 *  @returns {function} Data set function
	 *  @memberof DataTable#oApi
	 */ var _fnSetObjectDataFn = DataTable.util.set;
    /**
	 * Return an array with the full table data
	 *  @param {object} oSettings dataTables settings object
	 *  @returns array {array} aData Master data array
	 *  @memberof DataTable#oApi
	 */ function _fnGetDataMaster(settings) {
        return _pluck(settings.aoData, "_aData");
    }
    /**
	 * Nuke the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */ function _fnClearTable(settings) {
        settings.aoData.length = 0;
        settings.aiDisplayMaster.length = 0;
        settings.aiDisplay.length = 0;
        settings.aIds = {};
    }
    /**
	 * Take an array of integers (index array) and remove a target integer (value - not
	 * the key!)
	 *  @param {array} a Index array to target
	 *  @param {int} iTarget value to find
	 *  @memberof DataTable#oApi
	 */ function _fnDeleteIndex(a, iTarget, splice) {
        var iTargetIndex = -1;
        for(var i = 0, iLen = a.length; i < iLen; i++){
            if (a[i] == iTarget) iTargetIndex = i;
            else if (a[i] > iTarget) a[i]--;
        }
        if (iTargetIndex != -1 && splice === undefined) a.splice(iTargetIndex, 1);
    }
    /**
	 * Mark cached data as invalid such that a re-read of the data will occur when
	 * the cached data is next requested. Also update from the data source object.
	 *
	 * @param {object} settings DataTables settings object
	 * @param {int}    rowIdx   Row index to invalidate
	 * @param {string} [src]    Source to invalidate from: undefined, 'auto', 'dom'
	 *     or 'data'
	 * @param {int}    [colIdx] Column index to invalidate. If undefined the whole
	 *     row will be invalidated
	 * @memberof DataTable#oApi
	 *
	 * @todo For the modularisation of v1.11 this will need to become a callback, so
	 *   the sort and filter methods can subscribe to it. That will required
	 *   initialisation options for sorting, which is why it is not already baked in
	 */ function _fnInvalidate(settings, rowIdx, src, colIdx) {
        var row = settings.aoData[rowIdx];
        var i, ien;
        var cellWrite = function(cell, col) {
            // This is very frustrating, but in IE if you just write directly
            // to innerHTML, and elements that are overwritten are GC'ed,
            // even if there is a reference to them elsewhere
            while(cell.childNodes.length)cell.removeChild(cell.firstChild);
            cell.innerHTML = _fnGetCellData(settings, rowIdx, col, "display");
        };
        // Are we reading last data from DOM or the data object?
        if (src === "dom" || (!src || src === "auto") && row.src === "dom") // Read the data from the DOM
        row._aData = _fnGetRowElements(settings, row, colIdx, colIdx === undefined ? undefined : row._aData).data;
        else {
            // Reading from data object, update the DOM
            var cells = row.anCells;
            if (cells) {
                if (colIdx !== undefined) cellWrite(cells[colIdx], colIdx);
                else for(i = 0, ien = cells.length; i < ien; i++)cellWrite(cells[i], i);
            }
        }
        // For both row and cell invalidation, the cached data for sorting and
        // filtering is nulled out
        row._aSortData = null;
        row._aFilterData = null;
        // Invalidate the type for a specific column (if given) or all columns since
        // the data might have changed
        var cols = settings.aoColumns;
        if (colIdx !== undefined) cols[colIdx].sType = null;
        else {
            for(i = 0, ien = cols.length; i < ien; i++)cols[i].sType = null;
            // Update DataTables special `DT_*` attributes for the row
            _fnRowAttributes(settings, row);
        }
    }
    /**
	 * Build a data source object from an HTML row, reading the contents of the
	 * cells that are in the row.
	 *
	 * @param {object} settings DataTables settings object
	 * @param {node|object} TR element from which to read data or existing row
	 *   object from which to re-read the data from the cells
	 * @param {int} [colIdx] Optional column index
	 * @param {array|object} [d] Data source object. If `colIdx` is given then this
	 *   parameter should also be given and will be used to write the data into.
	 *   Only the column in question will be written
	 * @returns {object} Object with two parameters: `data` the data read, in
	 *   document order, and `cells` and array of nodes (they can be useful to the
	 *   caller, so rather than needing a second traversal to get them, just return
	 *   them from here).
	 * @memberof DataTable#oApi
	 */ function _fnGetRowElements(settings, row, colIdx, d) {
        var tds = [], td = row.firstChild, name, col, o, i = 0, contents, columns = settings.aoColumns, objectRead = settings._rowReadObject;
        // Allow the data object to be passed in, or construct
        d = d !== undefined ? d : objectRead ? {} : [];
        var attr = function(str, td) {
            if (typeof str === "string") {
                var idx = str.indexOf("@");
                if (idx !== -1) {
                    var attr = str.substring(idx + 1);
                    var setter = _fnSetObjectDataFn(str);
                    setter(d, td.getAttribute(attr));
                }
            }
        };
        // Read data from a cell and store into the data object
        var cellProcess = function(cell) {
            if (colIdx === undefined || colIdx === i) {
                col = columns[i];
                contents = cell.innerHTML.trim();
                if (col && col._bAttrSrc) {
                    var setter = _fnSetObjectDataFn(col.mData._);
                    setter(d, contents);
                    attr(col.mData.sort, cell);
                    attr(col.mData.type, cell);
                    attr(col.mData.filter, cell);
                } else // Depending on the `data` option for the columns the data can
                // be read to either an object or an array.
                if (objectRead) {
                    if (!col._setter) // Cache the setter function
                    col._setter = _fnSetObjectDataFn(col.mData);
                    col._setter(d, contents);
                } else d[i] = contents;
            }
            i++;
        };
        if (td) // `tr` element was passed in
        while(td){
            name = td.nodeName.toUpperCase();
            if (name == "TD" || name == "TH") {
                cellProcess(td);
                tds.push(td);
            }
            td = td.nextSibling;
        }
        else {
            // Existing row object passed in
            tds = row.anCells;
            for(var j = 0, jen = tds.length; j < jen; j++)cellProcess(tds[j]);
        }
        // Read the ID from the DOM if present
        var rowNode = row.firstChild ? row : row.nTr;
        if (rowNode) {
            var id = rowNode.getAttribute("id");
            if (id) _fnSetObjectDataFn(settings.rowId)(d, id);
        }
        return {
            data: d,
            cells: tds
        };
    }
    /**
	 * Create a new TR element (and it's TD children) for a row
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iRow Row to consider
	 *  @param {node} [nTrIn] TR element to add to the table - optional. If not given,
	 *    DataTables will create a row automatically
	 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
	 *    if nTr is.
	 *  @memberof DataTable#oApi
	 */ function _fnCreateTr(oSettings, iRow, nTrIn, anTds) {
        var row = oSettings.aoData[iRow], rowData = row._aData, cells = [], nTr, nTd, oCol, i, iLen, create;
        if (row.nTr === null) {
            nTr = nTrIn || document1.createElement("tr");
            row.nTr = nTr;
            row.anCells = cells;
            /* Use a private property on the node to allow reserve mapping from the node
			 * to the aoData array for fast look up
			 */ nTr._DT_RowIndex = iRow;
            /* Special parameters can be given by the data source to be used on the row */ _fnRowAttributes(oSettings, row);
            /* Process each column */ for(i = 0, iLen = oSettings.aoColumns.length; i < iLen; i++){
                oCol = oSettings.aoColumns[i];
                create = nTrIn ? false : true;
                nTd = create ? document1.createElement(oCol.sCellType) : anTds[i];
                nTd._DT_CellIndex = {
                    row: iRow,
                    column: i
                };
                cells.push(nTd);
                // Need to create the HTML if new, or if a rendering function is defined
                if (create || (oCol.mRender || oCol.mData !== i) && (!$.isPlainObject(oCol.mData) || oCol.mData._ !== i + ".display")) nTd.innerHTML = _fnGetCellData(oSettings, iRow, i, "display");
                /* Add user defined class */ if (oCol.sClass) nTd.className += " " + oCol.sClass;
                // Visibility - add or remove as required
                if (oCol.bVisible && !nTrIn) nTr.appendChild(nTd);
                else if (!oCol.bVisible && nTrIn) nTd.parentNode.removeChild(nTd);
                if (oCol.fnCreatedCell) oCol.fnCreatedCell.call(oSettings.oInstance, nTd, _fnGetCellData(oSettings, iRow, i), rowData, iRow, i);
            }
            _fnCallbackFire(oSettings, "aoRowCreatedCallback", null, [
                nTr,
                rowData,
                iRow,
                cells
            ]);
        }
    }
    /**
	 * Add attributes to a row based on the special `DT_*` parameters in a data
	 * source object.
	 *  @param {object} settings DataTables settings object
	 *  @param {object} DataTables row object for the row to be modified
	 *  @memberof DataTable#oApi
	 */ function _fnRowAttributes(settings, row) {
        var tr = row.nTr;
        var data = row._aData;
        if (tr) {
            var id = settings.rowIdFn(data);
            if (id) tr.id = id;
            if (data.DT_RowClass) {
                // Remove any classes added by DT_RowClass before
                var a = data.DT_RowClass.split(" ");
                row.__rowc = row.__rowc ? _unique(row.__rowc.concat(a)) : a;
                $(tr).removeClass(row.__rowc.join(" ")).addClass(data.DT_RowClass);
            }
            if (data.DT_RowAttr) $(tr).attr(data.DT_RowAttr);
            if (data.DT_RowData) $(tr).data(data.DT_RowData);
        }
    }
    /**
	 * Create the HTML header for the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */ function _fnBuildHead(oSettings) {
        var i, ien, cell, row, column;
        var thead = oSettings.nTHead;
        var tfoot = oSettings.nTFoot;
        var createHeader = $("th, td", thead).length === 0;
        var classes = oSettings.oClasses;
        var columns = oSettings.aoColumns;
        if (createHeader) row = $("<tr/>").appendTo(thead);
        for(i = 0, ien = columns.length; i < ien; i++){
            column = columns[i];
            cell = $(column.nTh).addClass(column.sClass);
            if (createHeader) cell.appendTo(row);
            // 1.11 move into sorting
            if (oSettings.oFeatures.bSort) {
                cell.addClass(column.sSortingClass);
                if (column.bSortable !== false) {
                    cell.attr("tabindex", oSettings.iTabIndex).attr("aria-controls", oSettings.sTableId);
                    _fnSortAttachListener(oSettings, column.nTh, i);
                }
            }
            if (column.sTitle != cell[0].innerHTML) cell.html(column.sTitle);
            _fnRenderer(oSettings, "header")(oSettings, cell, column, classes);
        }
        if (createHeader) _fnDetectHeader(oSettings.aoHeader, thead);
        /* Deal with the footer - add classes if required */ $(thead).children("tr").children("th, td").addClass(classes.sHeaderTH);
        $(tfoot).children("tr").children("th, td").addClass(classes.sFooterTH);
        // Cache the footer cells. Note that we only take the cells from the first
        // row in the footer. If there is more than one row the user wants to
        // interact with, they need to use the table().foot() method. Note also this
        // allows cells to be used for multiple columns using colspan
        if (tfoot !== null) {
            var cells = oSettings.aoFooter[0];
            for(i = 0, ien = cells.length; i < ien; i++){
                column = columns[i];
                column.nTf = cells[i].cell;
                if (column.sClass) $(column.nTf).addClass(column.sClass);
            }
        }
    }
    /**
	 * Draw the header (or footer) element based on the column visibility states. The
	 * methodology here is to use the layout array from _fnDetectHeader, modified for
	 * the instantaneous column visibility, to construct the new layout. The grid is
	 * traversed over cell at a time in a rows x columns grid fashion, although each
	 * cell insert can cover multiple elements in the grid - which is tracks using the
	 * aApplied array. Cell inserts in the grid will only occur where there isn't
	 * already a cell in that position.
	 *  @param {object} oSettings dataTables settings object
	 *  @param array {objects} aoSource Layout array from _fnDetectHeader
	 *  @param {boolean} [bIncludeHidden=false] If true then include the hidden columns in the calc,
	 *  @memberof DataTable#oApi
	 */ function _fnDrawHead(oSettings, aoSource, bIncludeHidden) {
        var i, iLen, j, jLen, k, kLen, n, nLocalTr;
        var aoLocal = [];
        var aApplied = [];
        var iColumns = oSettings.aoColumns.length;
        var iRowspan, iColspan;
        if (!aoSource) return;
        if (bIncludeHidden === undefined) bIncludeHidden = false;
        /* Make a copy of the master layout array, but without the visible columns in it */ for(i = 0, iLen = aoSource.length; i < iLen; i++){
            aoLocal[i] = aoSource[i].slice();
            aoLocal[i].nTr = aoSource[i].nTr;
            /* Remove any columns which are currently hidden */ for(j = iColumns - 1; j >= 0; j--)if (!oSettings.aoColumns[j].bVisible && !bIncludeHidden) aoLocal[i].splice(j, 1);
            /* Prep the applied array - it needs an element for each row */ aApplied.push([]);
        }
        for(i = 0, iLen = aoLocal.length; i < iLen; i++){
            nLocalTr = aoLocal[i].nTr;
            /* All cells are going to be replaced, so empty out the row */ if (nLocalTr) while(n = nLocalTr.firstChild)nLocalTr.removeChild(n);
            for(j = 0, jLen = aoLocal[i].length; j < jLen; j++){
                iRowspan = 1;
                iColspan = 1;
                /* Check to see if there is already a cell (row/colspan) covering our target
				 * insert point. If there is, then there is nothing to do.
				 */ if (aApplied[i][j] === undefined) {
                    nLocalTr.appendChild(aoLocal[i][j].cell);
                    aApplied[i][j] = 1;
                    /* Expand the cell to cover as many rows as needed */ while(aoLocal[i + iRowspan] !== undefined && aoLocal[i][j].cell == aoLocal[i + iRowspan][j].cell){
                        aApplied[i + iRowspan][j] = 1;
                        iRowspan++;
                    }
                    /* Expand the cell to cover as many columns as needed */ while(aoLocal[i][j + iColspan] !== undefined && aoLocal[i][j].cell == aoLocal[i][j + iColspan].cell){
                        /* Must update the applied array over the rows for the columns */ for(k = 0; k < iRowspan; k++)aApplied[i + k][j + iColspan] = 1;
                        iColspan++;
                    }
                    /* Do the actual expansion in the DOM */ $(aoLocal[i][j].cell).attr("rowspan", iRowspan).attr("colspan", iColspan);
                }
            }
        }
    }
    /**
	 * Insert the required TR nodes into the table for display
	 *  @param {object} oSettings dataTables settings object
	 *  @param ajaxComplete true after ajax call to complete rendering
	 *  @memberof DataTable#oApi
	 */ function _fnDraw(oSettings, ajaxComplete) {
        // Allow for state saving and a custom start position
        _fnStart(oSettings);
        /* Provide a pre-callback function which can be used to cancel the draw is false is returned */ var aPreDraw = _fnCallbackFire(oSettings, "aoPreDrawCallback", "preDraw", [
            oSettings
        ]);
        if ($.inArray(false, aPreDraw) !== -1) {
            _fnProcessingDisplay(oSettings, false);
            return;
        }
        var anRows = [];
        var iRowCount = 0;
        var asStripeClasses = oSettings.asStripeClasses;
        var iStripes = asStripeClasses.length;
        var oLang = oSettings.oLanguage;
        var bServerSide = _fnDataSource(oSettings) == "ssp";
        var aiDisplay = oSettings.aiDisplay;
        var iDisplayStart = oSettings._iDisplayStart;
        var iDisplayEnd = oSettings.fnDisplayEnd();
        oSettings.bDrawing = true;
        /* Server-side processing draw intercept */ if (oSettings.bDeferLoading) {
            oSettings.bDeferLoading = false;
            oSettings.iDraw++;
            _fnProcessingDisplay(oSettings, false);
        } else if (!bServerSide) oSettings.iDraw++;
        else if (!oSettings.bDestroying && !ajaxComplete) {
            _fnAjaxUpdate(oSettings);
            return;
        }
        if (aiDisplay.length !== 0) {
            var iStart = bServerSide ? 0 : iDisplayStart;
            var iEnd = bServerSide ? oSettings.aoData.length : iDisplayEnd;
            for(var j = iStart; j < iEnd; j++){
                var iDataIndex = aiDisplay[j];
                var aoData = oSettings.aoData[iDataIndex];
                if (aoData.nTr === null) _fnCreateTr(oSettings, iDataIndex);
                var nRow = aoData.nTr;
                /* Remove the old striping classes and then add the new one */ if (iStripes !== 0) {
                    var sStripe = asStripeClasses[iRowCount % iStripes];
                    if (aoData._sRowStripe != sStripe) {
                        $(nRow).removeClass(aoData._sRowStripe).addClass(sStripe);
                        aoData._sRowStripe = sStripe;
                    }
                }
                // Row callback functions - might want to manipulate the row
                // iRowCount and j are not currently documented. Are they at all
                // useful?
                _fnCallbackFire(oSettings, "aoRowCallback", null, [
                    nRow,
                    aoData._aData,
                    iRowCount,
                    j,
                    iDataIndex
                ]);
                anRows.push(nRow);
                iRowCount++;
            }
        } else {
            /* Table is empty - create a row with an empty message in it */ var sZero = oLang.sZeroRecords;
            if (oSettings.iDraw == 1 && _fnDataSource(oSettings) == "ajax") sZero = oLang.sLoadingRecords;
            else if (oLang.sEmptyTable && oSettings.fnRecordsTotal() === 0) sZero = oLang.sEmptyTable;
            anRows[0] = $("<tr/>", {
                "class": iStripes ? asStripeClasses[0] : ""
            }).append($("<td />", {
                "valign": "top",
                "colSpan": _fnVisbleColumns(oSettings),
                "class": oSettings.oClasses.sRowEmpty
            }).html(sZero))[0];
        }
        /* Header and footer callbacks */ _fnCallbackFire(oSettings, "aoHeaderCallback", "header", [
            $(oSettings.nTHead).children("tr")[0],
            _fnGetDataMaster(oSettings),
            iDisplayStart,
            iDisplayEnd,
            aiDisplay
        ]);
        _fnCallbackFire(oSettings, "aoFooterCallback", "footer", [
            $(oSettings.nTFoot).children("tr")[0],
            _fnGetDataMaster(oSettings),
            iDisplayStart,
            iDisplayEnd,
            aiDisplay
        ]);
        var body = $(oSettings.nTBody);
        body.children().detach();
        body.append($(anRows));
        /* Call all required callback functions for the end of a draw */ _fnCallbackFire(oSettings, "aoDrawCallback", "draw", [
            oSettings
        ]);
        /* Draw is complete, sorting and filtering must be as well */ oSettings.bSorted = false;
        oSettings.bFiltered = false;
        oSettings.bDrawing = false;
    }
    /**
	 * Redraw the table - taking account of the various features which are enabled
	 *  @param {object} oSettings dataTables settings object
	 *  @param {boolean} [holdPosition] Keep the current paging position. By default
	 *    the paging is reset to the first page
	 *  @memberof DataTable#oApi
	 */ function _fnReDraw(settings, holdPosition) {
        var features = settings.oFeatures, sort = features.bSort, filter = features.bFilter;
        if (sort) _fnSort(settings);
        if (filter) _fnFilterComplete(settings, settings.oPreviousSearch);
        else // No filtering, so we want to just use the display master
        settings.aiDisplay = settings.aiDisplayMaster.slice();
        if (holdPosition !== true) settings._iDisplayStart = 0;
        // Let any modules know about the draw hold position state (used by
        // scrolling internally)
        settings._drawHold = holdPosition;
        _fnDraw(settings);
        settings._drawHold = false;
    }
    /**
	 * Add the options to the page HTML for the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */ function _fnAddOptionsHtml(oSettings) {
        var classes = oSettings.oClasses;
        var table = $(oSettings.nTable);
        var holding = $("<div/>").insertBefore(table); // Holding element for speed
        var features = oSettings.oFeatures;
        // All DataTables are wrapped in a div
        var insert = $("<div/>", {
            id: oSettings.sTableId + "_wrapper",
            "class": classes.sWrapper + (oSettings.nTFoot ? "" : " " + classes.sNoFooter)
        });
        oSettings.nHolding = holding[0];
        oSettings.nTableWrapper = insert[0];
        oSettings.nTableReinsertBefore = oSettings.nTable.nextSibling;
        /* Loop over the user set positioning and place the elements as needed */ var aDom = oSettings.sDom.split("");
        var featureNode, cOption, nNewNode, cNext, sAttr, j;
        for(var i = 0; i < aDom.length; i++){
            featureNode = null;
            cOption = aDom[i];
            if (cOption == "<") {
                /* New container div */ nNewNode = $("<div/>")[0];
                /* Check to see if we should append an id and/or a class name to the container */ cNext = aDom[i + 1];
                if (cNext == "'" || cNext == '"') {
                    sAttr = "";
                    j = 2;
                    while(aDom[i + j] != cNext){
                        sAttr += aDom[i + j];
                        j++;
                    }
                    /* Replace jQuery UI constants @todo depreciated */ if (sAttr == "H") sAttr = classes.sJUIHeader;
                    else if (sAttr == "F") sAttr = classes.sJUIFooter;
                    /* The attribute can be in the format of "#id.class", "#id" or "class" This logic
					 * breaks the string into parts and applies them as needed
					 */ if (sAttr.indexOf(".") != -1) {
                        var aSplit = sAttr.split(".");
                        nNewNode.id = aSplit[0].substr(1, aSplit[0].length - 1);
                        nNewNode.className = aSplit[1];
                    } else if (sAttr.charAt(0) == "#") nNewNode.id = sAttr.substr(1, sAttr.length - 1);
                    else nNewNode.className = sAttr;
                    i += j; /* Move along the position array */ 
                }
                insert.append(nNewNode);
                insert = $(nNewNode);
            } else if (cOption == ">") /* End container div */ insert = insert.parent();
            else if (cOption == "l" && features.bPaginate && features.bLengthChange) /* Length */ featureNode = _fnFeatureHtmlLength(oSettings);
            else if (cOption == "f" && features.bFilter) /* Filter */ featureNode = _fnFeatureHtmlFilter(oSettings);
            else if (cOption == "r" && features.bProcessing) /* pRocessing */ featureNode = _fnFeatureHtmlProcessing(oSettings);
            else if (cOption == "t") /* Table */ featureNode = _fnFeatureHtmlTable(oSettings);
            else if (cOption == "i" && features.bInfo) /* Info */ featureNode = _fnFeatureHtmlInfo(oSettings);
            else if (cOption == "p" && features.bPaginate) /* Pagination */ featureNode = _fnFeatureHtmlPaginate(oSettings);
            else if (DataTable.ext.feature.length !== 0) {
                /* Plug-in features */ var aoFeatures = DataTable.ext.feature;
                for(var k = 0, kLen = aoFeatures.length; k < kLen; k++)if (cOption == aoFeatures[k].cFeature) {
                    featureNode = aoFeatures[k].fnInit(oSettings);
                    break;
                }
            }
            /* Add to the 2D features array */ if (featureNode) {
                var aanFeatures = oSettings.aanFeatures;
                if (!aanFeatures[cOption]) aanFeatures[cOption] = [];
                aanFeatures[cOption].push(featureNode);
                insert.append(featureNode);
            }
        }
        /* Built our DOM structure - replace the holding div with what we want */ holding.replaceWith(insert);
        oSettings.nHolding = null;
    }
    /**
	 * Use the DOM source to create up an array of header cells. The idea here is to
	 * create a layout grid (array) of rows x columns, which contains a reference
	 * to the cell that that point in the grid (regardless of col/rowspan), such that
	 * any column / row could be removed and the new grid constructed
	 *  @param array {object} aLayout Array to store the calculated layout in
	 *  @param {node} nThead The header/footer element for the table
	 *  @memberof DataTable#oApi
	 */ function _fnDetectHeader(aLayout, nThead) {
        var nTrs = $(nThead).children("tr");
        var nTr, nCell;
        var i, k, l, iLen, jLen, iColShifted, iColumn, iColspan, iRowspan;
        var bUnique;
        var fnShiftCol = function(a, i, j) {
            var k = a[i];
            while(k[j])j++;
            return j;
        };
        aLayout.splice(0, aLayout.length);
        /* We know how many rows there are in the layout - so prep it */ for(i = 0, iLen = nTrs.length; i < iLen; i++)aLayout.push([]);
        /* Calculate a layout array */ for(i = 0, iLen = nTrs.length; i < iLen; i++){
            nTr = nTrs[i];
            iColumn = 0;
            /* For every cell in the row... */ nCell = nTr.firstChild;
            while(nCell){
                if (nCell.nodeName.toUpperCase() == "TD" || nCell.nodeName.toUpperCase() == "TH") {
                    /* Get the col and rowspan attributes from the DOM and sanitise them */ iColspan = nCell.getAttribute("colspan") * 1;
                    iRowspan = nCell.getAttribute("rowspan") * 1;
                    iColspan = !iColspan || iColspan === 0 || iColspan === 1 ? 1 : iColspan;
                    iRowspan = !iRowspan || iRowspan === 0 || iRowspan === 1 ? 1 : iRowspan;
                    /* There might be colspan cells already in this row, so shift our target
					 * accordingly
					 */ iColShifted = fnShiftCol(aLayout, i, iColumn);
                    /* Cache calculation for unique columns */ bUnique = iColspan === 1 ? true : false;
                    /* If there is col / rowspan, copy the information into the layout grid */ for(l = 0; l < iColspan; l++)for(k = 0; k < iRowspan; k++){
                        aLayout[i + k][iColShifted + l] = {
                            "cell": nCell,
                            "unique": bUnique
                        };
                        aLayout[i + k].nTr = nTr;
                    }
                }
                nCell = nCell.nextSibling;
            }
        }
    }
    /**
	 * Get an array of unique th elements, one for each column
	 *  @param {object} oSettings dataTables settings object
	 *  @param {node} nHeader automatically detect the layout from this node - optional
	 *  @param {array} aLayout thead/tfoot layout from _fnDetectHeader - optional
	 *  @returns array {node} aReturn list of unique th's
	 *  @memberof DataTable#oApi
	 */ function _fnGetUniqueThs(oSettings, nHeader, aLayout) {
        var aReturn = [];
        if (!aLayout) {
            aLayout = oSettings.aoHeader;
            if (nHeader) {
                aLayout = [];
                _fnDetectHeader(aLayout, nHeader);
            }
        }
        for(var i = 0, iLen = aLayout.length; i < iLen; i++){
            for(var j = 0, jLen = aLayout[i].length; j < jLen; j++)if (aLayout[i][j].unique && (!aReturn[j] || !oSettings.bSortCellsTop)) aReturn[j] = aLayout[i][j].cell;
        }
        return aReturn;
    }
    /**
	 * Set the start position for draw
	 *  @param {object} oSettings dataTables settings object
	 */ function _fnStart(oSettings) {
        var bServerSide = _fnDataSource(oSettings) == "ssp";
        var iInitDisplayStart = oSettings.iInitDisplayStart;
        // Check and see if we have an initial draw position from state saving
        if (iInitDisplayStart !== undefined && iInitDisplayStart !== -1) {
            oSettings._iDisplayStart = bServerSide ? iInitDisplayStart : iInitDisplayStart >= oSettings.fnRecordsDisplay() ? 0 : iInitDisplayStart;
            oSettings.iInitDisplayStart = -1;
        }
    }
    /**
	 * Create an Ajax call based on the table's settings, taking into account that
	 * parameters can have multiple forms, and backwards compatibility.
	 *
	 * @param {object} oSettings dataTables settings object
	 * @param {array} data Data to send to the server, required by
	 *     DataTables - may be augmented by developer callbacks
	 * @param {function} fn Callback function to run when data is obtained
	 */ function _fnBuildAjax(oSettings, data, fn) {
        // Compatibility with 1.9-, allow fnServerData and event to manipulate
        _fnCallbackFire(oSettings, "aoServerParams", "serverParams", [
            data
        ]);
        // Convert to object based for 1.10+ if using the old array scheme which can
        // come from server-side processing or serverParams
        if (data && Array.isArray(data)) {
            var tmp = {};
            var rbracket = /(.*?)\[\]$/;
            $.each(data, function(key, val) {
                var match = val.name.match(rbracket);
                if (match) {
                    // Support for arrays
                    var name = match[0];
                    if (!tmp[name]) tmp[name] = [];
                    tmp[name].push(val.value);
                } else tmp[val.name] = val.value;
            });
            data = tmp;
        }
        var ajaxData;
        var ajax = oSettings.ajax;
        var instance = oSettings.oInstance;
        var callback = function(json) {
            var status = oSettings.jqXHR ? oSettings.jqXHR.status : null;
            if (json === null || typeof status === "number" && status == 204) {
                json = {};
                _fnAjaxDataSrc(oSettings, json, []);
            }
            var error = json.error || json.sError;
            if (error) _fnLog(oSettings, 0, error);
            oSettings.json = json;
            _fnCallbackFire(oSettings, null, "xhr", [
                oSettings,
                json,
                oSettings.jqXHR
            ]);
            fn(json);
        };
        if ($.isPlainObject(ajax) && ajax.data) {
            ajaxData = ajax.data;
            var newData = typeof ajaxData === "function" ? ajaxData(data, oSettings) : ajaxData; // an object object or array to merge
            // If the function returned something, use that alone
            data = typeof ajaxData === "function" && newData ? newData : $.extend(true, data, newData);
            // Remove the data property as we've resolved it already and don't want
            // jQuery to do it again (it is restored at the end of the function)
            delete ajax.data;
        }
        var baseAjax = {
            "data": data,
            "success": callback,
            "dataType": "json",
            "cache": false,
            "type": oSettings.sServerMethod,
            "error": function(xhr, error, thrown) {
                var ret = _fnCallbackFire(oSettings, null, "xhr", [
                    oSettings,
                    null,
                    oSettings.jqXHR
                ]);
                if ($.inArray(true, ret) === -1) {
                    if (error == "parsererror") _fnLog(oSettings, 0, "Invalid JSON response", 1);
                    else if (xhr.readyState === 4) _fnLog(oSettings, 0, "Ajax error", 7);
                }
                _fnProcessingDisplay(oSettings, false);
            }
        };
        // Store the data submitted for the API
        oSettings.oAjaxData = data;
        // Allow plug-ins and external processes to modify the data
        _fnCallbackFire(oSettings, null, "preXhr", [
            oSettings,
            data
        ]);
        if (oSettings.fnServerData) // DataTables 1.9- compatibility
        oSettings.fnServerData.call(instance, oSettings.sAjaxSource, $.map(data, function(val, key) {
            return {
                name: key,
                value: val
            };
        }), callback, oSettings);
        else if (oSettings.sAjaxSource || typeof ajax === "string") // DataTables 1.9- compatibility
        oSettings.jqXHR = $.ajax($.extend(baseAjax, {
            url: ajax || oSettings.sAjaxSource
        }));
        else if (typeof ajax === "function") // Is a function - let the caller define what needs to be done
        oSettings.jqXHR = ajax.call(instance, data, callback, oSettings);
        else {
            // Object to extend the base settings
            oSettings.jqXHR = $.ajax($.extend(baseAjax, ajax));
            // Restore for next time around
            ajax.data = ajaxData;
        }
    }
    /**
	 * Update the table using an Ajax call
	 *  @param {object} settings dataTables settings object
	 *  @returns {boolean} Block the table drawing or not
	 *  @memberof DataTable#oApi
	 */ function _fnAjaxUpdate(settings) {
        settings.iDraw++;
        _fnProcessingDisplay(settings, true);
        _fnBuildAjax(settings, _fnAjaxParameters(settings), function(json) {
            _fnAjaxUpdateDraw(settings, json);
        });
    }
    /**
	 * Build up the parameters in an object needed for a server-side processing
	 * request. Note that this is basically done twice, is different ways - a modern
	 * method which is used by default in DataTables 1.10 which uses objects and
	 * arrays, or the 1.9- method with is name / value pairs. 1.9 method is used if
	 * the sAjaxSource option is used in the initialisation, or the legacyAjax
	 * option is set.
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {bool} block the table drawing or not
	 *  @memberof DataTable#oApi
	 */ function _fnAjaxParameters(settings) {
        var columns = settings.aoColumns, columnCount = columns.length, features = settings.oFeatures, preSearch = settings.oPreviousSearch, preColSearch = settings.aoPreSearchCols, i, data = [], dataProp, column, columnSearch, sort = _fnSortFlatten(settings), displayStart = settings._iDisplayStart, displayLength = features.bPaginate !== false ? settings._iDisplayLength : -1;
        var param = function(name, value) {
            data.push({
                "name": name,
                "value": value
            });
        };
        // DataTables 1.9- compatible method
        param("sEcho", settings.iDraw);
        param("iColumns", columnCount);
        param("sColumns", _pluck(columns, "sName").join(","));
        param("iDisplayStart", displayStart);
        param("iDisplayLength", displayLength);
        // DataTables 1.10+ method
        var d = {
            draw: settings.iDraw,
            columns: [],
            order: [],
            start: displayStart,
            length: displayLength,
            search: {
                value: preSearch.sSearch,
                regex: preSearch.bRegex
            }
        };
        for(i = 0; i < columnCount; i++){
            column = columns[i];
            columnSearch = preColSearch[i];
            dataProp = typeof column.mData == "function" ? "function" : column.mData;
            d.columns.push({
                data: dataProp,
                name: column.sName,
                searchable: column.bSearchable,
                orderable: column.bSortable,
                search: {
                    value: columnSearch.sSearch,
                    regex: columnSearch.bRegex
                }
            });
            param("mDataProp_" + i, dataProp);
            if (features.bFilter) {
                param("sSearch_" + i, columnSearch.sSearch);
                param("bRegex_" + i, columnSearch.bRegex);
                param("bSearchable_" + i, column.bSearchable);
            }
            if (features.bSort) param("bSortable_" + i, column.bSortable);
        }
        if (features.bFilter) {
            param("sSearch", preSearch.sSearch);
            param("bRegex", preSearch.bRegex);
        }
        if (features.bSort) {
            $.each(sort, function(i, val) {
                d.order.push({
                    column: val.col,
                    dir: val.dir
                });
                param("iSortCol_" + i, val.col);
                param("sSortDir_" + i, val.dir);
            });
            param("iSortingCols", sort.length);
        }
        // If the legacy.ajax parameter is null, then we automatically decide which
        // form to use, based on sAjaxSource
        var legacy = DataTable.ext.legacy.ajax;
        if (legacy === null) return settings.sAjaxSource ? data : d;
        // Otherwise, if legacy has been specified then we use that to decide on the
        // form
        return legacy ? data : d;
    }
    /**
	 * Data the data from the server (nuking the old) and redraw the table
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} json json data return from the server.
	 *  @param {string} json.sEcho Tracking flag for DataTables to match requests
	 *  @param {int} json.iTotalRecords Number of records in the data set, not accounting for filtering
	 *  @param {int} json.iTotalDisplayRecords Number of records in the data set, accounting for filtering
	 *  @param {array} json.aaData The data to display on this page
	 *  @param {string} [json.sColumns] Column ordering (sName, comma separated)
	 *  @memberof DataTable#oApi
	 */ function _fnAjaxUpdateDraw(settings, json) {
        // v1.10 uses camelCase variables, while 1.9 uses Hungarian notation.
        // Support both
        var compat = function(old, modern) {
            return json[old] !== undefined ? json[old] : json[modern];
        };
        var data = _fnAjaxDataSrc(settings, json);
        var draw = compat("sEcho", "draw");
        var recordsTotal = compat("iTotalRecords", "recordsTotal");
        var recordsFiltered = compat("iTotalDisplayRecords", "recordsFiltered");
        if (draw !== undefined) {
            // Protect against out of sequence returns
            if (draw * 1 < settings.iDraw) return;
            settings.iDraw = draw * 1;
        }
        // No data in returned object, so rather than an array, we show an empty table
        if (!data) data = [];
        _fnClearTable(settings);
        settings._iRecordsTotal = parseInt(recordsTotal, 10);
        settings._iRecordsDisplay = parseInt(recordsFiltered, 10);
        for(var i = 0, ien = data.length; i < ien; i++)_fnAddData(settings, data[i]);
        settings.aiDisplay = settings.aiDisplayMaster.slice();
        _fnDraw(settings, true);
        if (!settings._bInitComplete) _fnInitComplete(settings, json);
        _fnProcessingDisplay(settings, false);
    }
    /**
	 * Get the data from the JSON data source to use for drawing a table. Using
	 * `_fnGetObjectDataFn` allows the data to be sourced from a property of the
	 * source object, or from a processing function.
	 *  @param {object} oSettings dataTables settings object
	 *  @param  {object} json Data source object / array from the server
	 *  @return {array} Array of data to use
	 */ function _fnAjaxDataSrc(oSettings, json, write) {
        var dataSrc = $.isPlainObject(oSettings.ajax) && oSettings.ajax.dataSrc !== undefined ? oSettings.ajax.dataSrc : oSettings.sAjaxDataProp; // Compatibility with 1.9-.
        if (!write) {
            if (dataSrc === "data") // If the default, then we still want to support the old style, and safely ignore
            // it if possible
            return json.aaData || json[dataSrc];
            return dataSrc !== "" ? _fnGetObjectDataFn(dataSrc)(json) : json;
        }
        // set
        _fnSetObjectDataFn(dataSrc)(json, write);
    }
    /**
	 * Generate the node required for filtering text
	 *  @returns {node} Filter control element
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */ function _fnFeatureHtmlFilter(settings) {
        var classes = settings.oClasses;
        var tableId = settings.sTableId;
        var language = settings.oLanguage;
        var previousSearch = settings.oPreviousSearch;
        var features = settings.aanFeatures;
        var input = '<input type="search" class="' + classes.sFilterInput + '"/>';
        var str = language.sSearch;
        str = str.match(/_INPUT_/) ? str.replace("_INPUT_", input) : str + input;
        var filter = $("<div/>", {
            "id": !features.f ? tableId + "_filter" : null,
            "class": classes.sFilter
        }).append($("<label/>").append(str));
        var searchFn = function(event) {
            /* Update all other filter input elements for the new display */ var n = features.f;
            var val = !this.value ? "" : this.value; // mental IE8 fix :-(
            if (previousSearch.return && event.key !== "Enter") return;
            /* Now do the filter */ if (val != previousSearch.sSearch) {
                _fnFilterComplete(settings, {
                    "sSearch": val,
                    "bRegex": previousSearch.bRegex,
                    "bSmart": previousSearch.bSmart,
                    "bCaseInsensitive": previousSearch.bCaseInsensitive,
                    "return": previousSearch.return
                });
                // Need to redraw, without resorting
                settings._iDisplayStart = 0;
                _fnDraw(settings);
            }
        };
        var searchDelay = settings.searchDelay !== null ? settings.searchDelay : _fnDataSource(settings) === "ssp" ? 400 : 0;
        var jqFilter = $("input", filter).val(previousSearch.sSearch).attr("placeholder", language.sSearchPlaceholder).on("keyup.DT search.DT input.DT paste.DT cut.DT", searchDelay ? _fnThrottle(searchFn, searchDelay) : searchFn).on("mouseup", function(e) {
            // Edge fix! Edge 17 does not trigger anything other than mouse events when clicking
            // on the clear icon (Edge bug 17584515). This is safe in other browsers as `searchFn`
            // checks the value to see if it has changed. In other browsers it won't have.
            setTimeout(function() {
                searchFn.call(jqFilter[0], e);
            }, 10);
        }).on("keypress.DT", function(e) {
            /* Prevent form submission */ if (e.keyCode == 13) return false;
        }).attr("aria-controls", tableId);
        // Update the input elements whenever the table is filtered
        $(settings.nTable).on("search.dt.DT", function(ev, s) {
            if (settings === s) // IE9 throws an 'unknown error' if document.activeElement is used
            // inside an iframe or frame...
            try {
                if (jqFilter[0] !== document1.activeElement) jqFilter.val(previousSearch.sSearch);
            } catch (e) {}
        });
        return filter[0];
    }
    /**
	 * Filter the table using both the global filter and column based filtering
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} oSearch search information
	 *  @param {int} [iForce] force a research of the master array (1) or not (undefined or 0)
	 *  @memberof DataTable#oApi
	 */ function _fnFilterComplete(oSettings, oInput, iForce) {
        var oPrevSearch = oSettings.oPreviousSearch;
        var aoPrevSearch = oSettings.aoPreSearchCols;
        var fnSaveFilter = function(oFilter) {
            /* Save the filtering values */ oPrevSearch.sSearch = oFilter.sSearch;
            oPrevSearch.bRegex = oFilter.bRegex;
            oPrevSearch.bSmart = oFilter.bSmart;
            oPrevSearch.bCaseInsensitive = oFilter.bCaseInsensitive;
            oPrevSearch.return = oFilter.return;
        };
        var fnRegex = function(o) {
            // Backwards compatibility with the bEscapeRegex option
            return o.bEscapeRegex !== undefined ? !o.bEscapeRegex : o.bRegex;
        };
        // Resolve any column types that are unknown due to addition or invalidation
        // @todo As per sort - can this be moved into an event handler?
        _fnColumnTypes(oSettings);
        /* In server-side processing all filtering is done by the server, so no point hanging around here */ if (_fnDataSource(oSettings) != "ssp") {
            /* Global filter */ _fnFilter(oSettings, oInput.sSearch, iForce, fnRegex(oInput), oInput.bSmart, oInput.bCaseInsensitive, oInput.return);
            fnSaveFilter(oInput);
            /* Now do the individual column filter */ for(var i = 0; i < aoPrevSearch.length; i++)_fnFilterColumn(oSettings, aoPrevSearch[i].sSearch, i, fnRegex(aoPrevSearch[i]), aoPrevSearch[i].bSmart, aoPrevSearch[i].bCaseInsensitive);
            /* Custom filtering */ _fnFilterCustom(oSettings);
        } else fnSaveFilter(oInput);
        /* Tell the draw function we have been filtering */ oSettings.bFiltered = true;
        _fnCallbackFire(oSettings, null, "search", [
            oSettings
        ]);
    }
    /**
	 * Apply custom filtering functions
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */ function _fnFilterCustom(settings) {
        var filters = DataTable.ext.search;
        var displayRows = settings.aiDisplay;
        var row, rowIdx;
        for(var i = 0, ien = filters.length; i < ien; i++){
            var rows = [];
            // Loop over each row and see if it should be included
            for(var j = 0, jen = displayRows.length; j < jen; j++){
                rowIdx = displayRows[j];
                row = settings.aoData[rowIdx];
                if (filters[i](settings, row._aFilterData, rowIdx, row._aData, j)) rows.push(rowIdx);
            }
            // So the array reference doesn't break set the results into the
            // existing array
            displayRows.length = 0;
            $.merge(displayRows, rows);
        }
    }
    /**
	 * Filter the table on a per-column basis
	 *  @param {object} oSettings dataTables settings object
	 *  @param {string} sInput string to filter on
	 *  @param {int} iColumn column to filter
	 *  @param {bool} bRegex treat search string as a regular expression or not
	 *  @param {bool} bSmart use smart filtering or not
	 *  @param {bool} bCaseInsensitive Do case insensitive matching or not
	 *  @memberof DataTable#oApi
	 */ function _fnFilterColumn(settings, searchStr, colIdx, regex, smart, caseInsensitive) {
        if (searchStr === "") return;
        var data;
        var out = [];
        var display = settings.aiDisplay;
        var rpSearch = _fnFilterCreateSearch(searchStr, regex, smart, caseInsensitive);
        for(var i = 0; i < display.length; i++){
            data = settings.aoData[display[i]]._aFilterData[colIdx];
            if (rpSearch.test(data)) out.push(display[i]);
        }
        settings.aiDisplay = out;
    }
    /**
	 * Filter the data table based on user input and draw the table
	 *  @param {object} settings dataTables settings object
	 *  @param {string} input string to filter on
	 *  @param {int} force optional - force a research of the master array (1) or not (undefined or 0)
	 *  @param {bool} regex treat as a regular expression or not
	 *  @param {bool} smart perform smart filtering or not
	 *  @param {bool} caseInsensitive Do case insensitive matching or not
	 *  @memberof DataTable#oApi
	 */ function _fnFilter(settings, input, force, regex, smart, caseInsensitive) {
        var rpSearch = _fnFilterCreateSearch(input, regex, smart, caseInsensitive);
        var prevSearch = settings.oPreviousSearch.sSearch;
        var displayMaster = settings.aiDisplayMaster;
        var display, invalidated, i;
        var filtered = [];
        // Need to take account of custom filtering functions - always filter
        if (DataTable.ext.search.length !== 0) force = true;
        // Check if any of the rows were invalidated
        invalidated = _fnFilterData(settings);
        // If the input is blank - we just want the full data set
        if (input.length <= 0) settings.aiDisplay = displayMaster.slice();
        else {
            // New search - start from the master array
            if (invalidated || force || regex || prevSearch.length > input.length || input.indexOf(prevSearch) !== 0 || settings.bSorted // On resort, the display master needs to be
            ) settings.aiDisplay = displayMaster.slice();
            // Search the display array
            display = settings.aiDisplay;
            for(i = 0; i < display.length; i++)if (rpSearch.test(settings.aoData[display[i]]._sFilterRow)) filtered.push(display[i]);
            settings.aiDisplay = filtered;
        }
    }
    /**
	 * Build a regular expression object suitable for searching a table
	 *  @param {string} sSearch string to search for
	 *  @param {bool} bRegex treat as a regular expression or not
	 *  @param {bool} bSmart perform smart filtering or not
	 *  @param {bool} bCaseInsensitive Do case insensitive matching or not
	 *  @returns {RegExp} constructed object
	 *  @memberof DataTable#oApi
	 */ function _fnFilterCreateSearch(search, regex, smart, caseInsensitive) {
        search = regex ? search : _fnEscapeRegex(search);
        if (smart) {
            /* For smart filtering we want to allow the search to work regardless of
			 * word order. We also want double quoted text to be preserved, so word
			 * order is important - a la google. So this is what we want to
			 * generate:
			 * 
			 * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
			 */ var a = $.map(search.match(/"[^"]+"|[^ ]+/g) || [
                ""
            ], function(word) {
                if (word.charAt(0) === '"') {
                    var m = word.match(/^"(.*)"$/);
                    word = m ? m[1] : word;
                }
                return word.replace('"', "");
            });
            search = "^(?=.*?" + a.join(")(?=.*?") + ").*$";
        }
        return new RegExp(search, caseInsensitive ? "i" : "");
    }
    /**
	 * Escape a string such that it can be used in a regular expression
	 *  @param {string} sVal string to escape
	 *  @returns {string} escaped string
	 *  @memberof DataTable#oApi
	 */ var _fnEscapeRegex = DataTable.util.escapeRegex;
    var __filter_div = $("<div>")[0];
    var __filter_div_textContent = __filter_div.textContent !== undefined;
    // Update the filtering data for each row if needed (by invalidation or first run)
    function _fnFilterData(settings) {
        var columns = settings.aoColumns;
        var column;
        var i, j, ien, jen, filterData, cellData, row;
        var wasInvalidated = false;
        for(i = 0, ien = settings.aoData.length; i < ien; i++){
            row = settings.aoData[i];
            if (!row._aFilterData) {
                filterData = [];
                for(j = 0, jen = columns.length; j < jen; j++){
                    column = columns[j];
                    if (column.bSearchable) {
                        cellData = _fnGetCellData(settings, i, j, "filter");
                        // Search in DataTables 1.10 is string based. In 1.11 this
                        // should be altered to also allow strict type checking.
                        if (cellData === null) cellData = "";
                        if (typeof cellData !== "string" && cellData.toString) cellData = cellData.toString();
                    } else cellData = "";
                    // If it looks like there is an HTML entity in the string,
                    // attempt to decode it so sorting works as expected. Note that
                    // we could use a single line of jQuery to do this, but the DOM
                    // method used here is much faster http://jsperf.com/html-decode
                    if (cellData.indexOf && cellData.indexOf("&") !== -1) {
                        __filter_div.innerHTML = cellData;
                        cellData = __filter_div_textContent ? __filter_div.textContent : __filter_div.innerText;
                    }
                    if (cellData.replace) cellData = cellData.replace(/[\r\n\u2028]/g, "");
                    filterData.push(cellData);
                }
                row._aFilterData = filterData;
                row._sFilterRow = filterData.join("  ");
                wasInvalidated = true;
            }
        }
        return wasInvalidated;
    }
    /**
	 * Convert from the internal Hungarian notation to camelCase for external
	 * interaction
	 *  @param {object} obj Object to convert
	 *  @returns {object} Inverted object
	 *  @memberof DataTable#oApi
	 */ function _fnSearchToCamel(obj) {
        return {
            search: obj.sSearch,
            smart: obj.bSmart,
            regex: obj.bRegex,
            caseInsensitive: obj.bCaseInsensitive
        };
    }
    /**
	 * Convert from camelCase notation to the internal Hungarian. We could use the
	 * Hungarian convert function here, but this is cleaner
	 *  @param {object} obj Object to convert
	 *  @returns {object} Inverted object
	 *  @memberof DataTable#oApi
	 */ function _fnSearchToHung(obj) {
        return {
            sSearch: obj.search,
            bSmart: obj.smart,
            bRegex: obj.regex,
            bCaseInsensitive: obj.caseInsensitive
        };
    }
    /**
	 * Generate the node required for the info display
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {node} Information element
	 *  @memberof DataTable#oApi
	 */ function _fnFeatureHtmlInfo(settings) {
        var tid = settings.sTableId, nodes = settings.aanFeatures.i, n = $("<div/>", {
            "class": settings.oClasses.sInfo,
            "id": !nodes ? tid + "_info" : null
        });
        if (!nodes) {
            // Update display on each draw
            settings.aoDrawCallback.push({
                "fn": _fnUpdateInfo,
                "sName": "information"
            });
            n.attr("role", "status").attr("aria-live", "polite");
            // Table is described by our info div
            $(settings.nTable).attr("aria-describedby", tid + "_info");
        }
        return n[0];
    }
    /**
	 * Update the information elements in the display
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */ function _fnUpdateInfo(settings) {
        /* Show information about the table */ var nodes = settings.aanFeatures.i;
        if (nodes.length === 0) return;
        var lang = settings.oLanguage, start = settings._iDisplayStart + 1, end = settings.fnDisplayEnd(), max = settings.fnRecordsTotal(), total = settings.fnRecordsDisplay(), out = total ? lang.sInfo : lang.sInfoEmpty;
        if (total !== max) /* Record set after filtering */ out += " " + lang.sInfoFiltered;
        // Convert the macros
        out += lang.sInfoPostFix;
        out = _fnInfoMacros(settings, out);
        var callback = lang.fnInfoCallback;
        if (callback !== null) out = callback.call(settings.oInstance, settings, start, end, max, total, out);
        $(nodes).html(out);
    }
    function _fnInfoMacros(settings, str) {
        // When infinite scrolling, we are always starting at 1. _iDisplayStart is used only
        // internally
        var formatter = settings.fnFormatNumber, start = settings._iDisplayStart + 1, len = settings._iDisplayLength, vis = settings.fnRecordsDisplay(), all = len === -1;
        return str.replace(/_START_/g, formatter.call(settings, start)).replace(/_END_/g, formatter.call(settings, settings.fnDisplayEnd())).replace(/_MAX_/g, formatter.call(settings, settings.fnRecordsTotal())).replace(/_TOTAL_/g, formatter.call(settings, vis)).replace(/_PAGE_/g, formatter.call(settings, all ? 1 : Math.ceil(start / len))).replace(/_PAGES_/g, formatter.call(settings, all ? 1 : Math.ceil(vis / len)));
    }
    /**
	 * Draw the table for the first time, adding all required features
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */ function _fnInitialise(settings) {
        var i, iLen, iAjaxStart = settings.iInitDisplayStart;
        var columns = settings.aoColumns, column;
        var features = settings.oFeatures;
        var deferLoading = settings.bDeferLoading; // value modified by the draw
        /* Ensure that the table data is fully initialised */ if (!settings.bInitialised) {
            setTimeout(function() {
                _fnInitialise(settings);
            }, 200);
            return;
        }
        /* Show the display HTML options */ _fnAddOptionsHtml(settings);
        /* Build and draw the header / footer for the table */ _fnBuildHead(settings);
        _fnDrawHead(settings, settings.aoHeader);
        _fnDrawHead(settings, settings.aoFooter);
        /* Okay to show that something is going on now */ _fnProcessingDisplay(settings, true);
        /* Calculate sizes for columns */ if (features.bAutoWidth) _fnCalculateColumnWidths(settings);
        for(i = 0, iLen = columns.length; i < iLen; i++){
            column = columns[i];
            if (column.sWidth) column.nTh.style.width = _fnStringToCss(column.sWidth);
        }
        _fnCallbackFire(settings, null, "preInit", [
            settings
        ]);
        // If there is default sorting required - let's do it. The sort function
        // will do the drawing for us. Otherwise we draw the table regardless of the
        // Ajax source - this allows the table to look initialised for Ajax sourcing
        // data (show 'loading' message possibly)
        _fnReDraw(settings);
        // Server-side processing init complete is done by _fnAjaxUpdateDraw
        var dataSrc = _fnDataSource(settings);
        if (dataSrc != "ssp" || deferLoading) {
            // if there is an ajax source load the data
            if (dataSrc == "ajax") _fnBuildAjax(settings, [], function(json) {
                var aData = _fnAjaxDataSrc(settings, json);
                // Got the data - add it to the table
                for(i = 0; i < aData.length; i++)_fnAddData(settings, aData[i]);
                // Reset the init display for cookie saving. We've already done
                // a filter, and therefore cleared it before. So we need to make
                // it appear 'fresh'
                settings.iInitDisplayStart = iAjaxStart;
                _fnReDraw(settings);
                _fnProcessingDisplay(settings, false);
                _fnInitComplete(settings, json);
            }, settings);
            else {
                _fnProcessingDisplay(settings, false);
                _fnInitComplete(settings);
            }
        }
    }
    /**
	 * Draw the table for the first time, adding all required features
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} [json] JSON from the server that completed the table, if using Ajax source
	 *    with client-side processing (optional)
	 *  @memberof DataTable#oApi
	 */ function _fnInitComplete(settings, json) {
        settings._bInitComplete = true;
        // When data was added after the initialisation (data or Ajax) we need to
        // calculate the column sizing
        if (json || settings.oInit.aaData) _fnAdjustColumnSizing(settings);
        _fnCallbackFire(settings, null, "plugin-init", [
            settings,
            json
        ]);
        _fnCallbackFire(settings, "aoInitComplete", "init", [
            settings,
            json
        ]);
    }
    function _fnLengthChange(settings, val) {
        var len = parseInt(val, 10);
        settings._iDisplayLength = len;
        _fnLengthOverflow(settings);
        // Fire length change event
        _fnCallbackFire(settings, null, "length", [
            settings,
            len
        ]);
    }
    /**
	 * Generate the node required for user display length changing
	 *  @param {object} settings dataTables settings object
	 *  @returns {node} Display length feature node
	 *  @memberof DataTable#oApi
	 */ function _fnFeatureHtmlLength(settings) {
        var classes = settings.oClasses, tableId = settings.sTableId, menu = settings.aLengthMenu, d2 = Array.isArray(menu[0]), lengths = d2 ? menu[0] : menu, language = d2 ? menu[1] : menu;
        var select = $("<select/>", {
            "name": tableId + "_length",
            "aria-controls": tableId,
            "class": classes.sLengthSelect
        });
        for(var i = 0, ien = lengths.length; i < ien; i++)select[0][i] = new Option(typeof language[i] === "number" ? settings.fnFormatNumber(language[i]) : language[i], lengths[i]);
        var div = $("<div><label/></div>").addClass(classes.sLength);
        if (!settings.aanFeatures.l) div[0].id = tableId + "_length";
        div.children().append(settings.oLanguage.sLengthMenu.replace("_MENU_", select[0].outerHTML));
        // Can't use `select` variable as user might provide their own and the
        // reference is broken by the use of outerHTML
        $("select", div).val(settings._iDisplayLength).on("change.DT", function(e) {
            _fnLengthChange(settings, $(this).val());
            _fnDraw(settings);
        });
        // Update node value whenever anything changes the table's length
        $(settings.nTable).on("length.dt.DT", function(e, s, len) {
            if (settings === s) $("select", div).val(len);
        });
        return div[0];
    }
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Note that most of the paging logic is done in
	 * DataTable.ext.pager
	 */ /**
	 * Generate the node required for default pagination
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {node} Pagination feature node
	 *  @memberof DataTable#oApi
	 */ function _fnFeatureHtmlPaginate(settings) {
        var type = settings.sPaginationType, plugin = DataTable.ext.pager[type], modern = typeof plugin === "function", redraw = function(settings) {
            _fnDraw(settings);
        }, node = $("<div/>").addClass(settings.oClasses.sPaging + type)[0], features = settings.aanFeatures;
        if (!modern) plugin.fnInit(settings, node, redraw);
        /* Add a draw callback for the pagination on first instance, to update the paging display */ if (!features.p) {
            node.id = settings.sTableId + "_paginate";
            settings.aoDrawCallback.push({
                "fn": function(settings) {
                    if (modern) {
                        var start = settings._iDisplayStart, len = settings._iDisplayLength, visRecords = settings.fnRecordsDisplay(), all = len === -1, page = all ? 0 : Math.ceil(start / len), pages = all ? 1 : Math.ceil(visRecords / len), buttons = plugin(page, pages), i, ien;
                        for(i = 0, ien = features.p.length; i < ien; i++)_fnRenderer(settings, "pageButton")(settings, features.p[i], i, buttons, page, pages);
                    } else plugin.fnUpdate(settings, redraw);
                },
                "sName": "pagination"
            });
        }
        return node;
    }
    /**
	 * Alter the display settings to change the page
	 *  @param {object} settings DataTables settings object
	 *  @param {string|int} action Paging action to take: "first", "previous",
	 *    "next" or "last" or page number to jump to (integer)
	 *  @param [bool] redraw Automatically draw the update or not
	 *  @returns {bool} true page has changed, false - no change
	 *  @memberof DataTable#oApi
	 */ function _fnPageChange(settings, action, redraw) {
        var start = settings._iDisplayStart, len = settings._iDisplayLength, records = settings.fnRecordsDisplay();
        if (records === 0 || len === -1) start = 0;
        else if (typeof action === "number") {
            start = action * len;
            if (start > records) start = 0;
        } else if (action == "first") start = 0;
        else if (action == "previous") {
            start = len >= 0 ? start - len : 0;
            if (start < 0) start = 0;
        } else if (action == "next") {
            if (start + len < records) start += len;
        } else if (action == "last") start = Math.floor((records - 1) / len) * len;
        else _fnLog(settings, 0, "Unknown paging action: " + action, 5);
        var changed = settings._iDisplayStart !== start;
        settings._iDisplayStart = start;
        if (changed) {
            _fnCallbackFire(settings, null, "page", [
                settings
            ]);
            if (redraw) _fnDraw(settings);
        }
        return changed;
    }
    /**
	 * Generate the node required for the processing node
	 *  @param {object} settings dataTables settings object
	 *  @returns {node} Processing element
	 *  @memberof DataTable#oApi
	 */ function _fnFeatureHtmlProcessing(settings) {
        return $("<div/>", {
            "id": !settings.aanFeatures.r ? settings.sTableId + "_processing" : null,
            "class": settings.oClasses.sProcessing
        }).html(settings.oLanguage.sProcessing).append("<div><div></div><div></div><div></div><div></div></div>").insertBefore(settings.nTable)[0];
    }
    /**
	 * Display or hide the processing indicator
	 *  @param {object} settings dataTables settings object
	 *  @param {bool} show Show the processing indicator (true) or not (false)
	 *  @memberof DataTable#oApi
	 */ function _fnProcessingDisplay(settings, show) {
        if (settings.oFeatures.bProcessing) $(settings.aanFeatures.r).css("display", show ? "block" : "none");
        _fnCallbackFire(settings, null, "processing", [
            settings,
            show
        ]);
    }
    /**
	 * Add any control elements for the table - specifically scrolling
	 *  @param {object} settings dataTables settings object
	 *  @returns {node} Node to add to the DOM
	 *  @memberof DataTable#oApi
	 */ function _fnFeatureHtmlTable(settings) {
        var table = $(settings.nTable);
        // Scrolling from here on in
        var scroll = settings.oScroll;
        if (scroll.sX === "" && scroll.sY === "") return settings.nTable;
        var scrollX = scroll.sX;
        var scrollY = scroll.sY;
        var classes = settings.oClasses;
        var caption = table.children("caption");
        var captionSide = caption.length ? caption[0]._captionSide : null;
        var headerClone = $(table[0].cloneNode(false));
        var footerClone = $(table[0].cloneNode(false));
        var footer = table.children("tfoot");
        var _div = "<div/>";
        var size = function(s) {
            return !s ? null : _fnStringToCss(s);
        };
        if (!footer.length) footer = null;
        /*
		 * The HTML structure that we want to generate in this function is:
		 *  div - scroller
		 *    div - scroll head
		 *      div - scroll head inner
		 *        table - scroll head table
		 *          thead - thead
		 *    div - scroll body
		 *      table - table (master table)
		 *        thead - thead clone for sizing
		 *        tbody - tbody
		 *    div - scroll foot
		 *      div - scroll foot inner
		 *        table - scroll foot table
		 *          tfoot - tfoot
		 */ var scroller = $(_div, {
            "class": classes.sScrollWrapper
        }).append($(_div, {
            "class": classes.sScrollHead
        }).css({
            overflow: "hidden",
            position: "relative",
            border: 0,
            width: scrollX ? size(scrollX) : "100%"
        }).append($(_div, {
            "class": classes.sScrollHeadInner
        }).css({
            "box-sizing": "content-box",
            width: scroll.sXInner || "100%"
        }).append(headerClone.removeAttr("id").css("margin-left", 0).append(captionSide === "top" ? caption : null).append(table.children("thead"))))).append($(_div, {
            "class": classes.sScrollBody
        }).css({
            position: "relative",
            overflow: "auto",
            width: size(scrollX)
        }).append(table));
        if (footer) scroller.append($(_div, {
            "class": classes.sScrollFoot
        }).css({
            overflow: "hidden",
            border: 0,
            width: scrollX ? size(scrollX) : "100%"
        }).append($(_div, {
            "class": classes.sScrollFootInner
        }).append(footerClone.removeAttr("id").css("margin-left", 0).append(captionSide === "bottom" ? caption : null).append(table.children("tfoot")))));
        var children = scroller.children();
        var scrollHead = children[0];
        var scrollBody = children[1];
        var scrollFoot = footer ? children[2] : null;
        // When the body is scrolled, then we also want to scroll the headers
        if (scrollX) $(scrollBody).on("scroll.DT", function(e) {
            var scrollLeft = this.scrollLeft;
            scrollHead.scrollLeft = scrollLeft;
            if (footer) scrollFoot.scrollLeft = scrollLeft;
        });
        $(scrollBody).css("max-height", scrollY);
        if (!scroll.bCollapse) $(scrollBody).css("height", scrollY);
        settings.nScrollHead = scrollHead;
        settings.nScrollBody = scrollBody;
        settings.nScrollFoot = scrollFoot;
        // On redraw - align columns
        settings.aoDrawCallback.push({
            "fn": _fnScrollDraw,
            "sName": "scrolling"
        });
        return scroller[0];
    }
    /**
	 * Update the header, footer and body tables for resizing - i.e. column
	 * alignment.
	 *
	 * Welcome to the most horrible function DataTables. The process that this
	 * function follows is basically:
	 *   1. Re-create the table inside the scrolling div
	 *   2. Take live measurements from the DOM
	 *   3. Apply the measurements to align the columns
	 *   4. Clean up
	 *
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */ function _fnScrollDraw(settings) {
        // Given that this is such a monster function, a lot of variables are use
        // to try and keep the minimised size as small as possible
        var scroll = settings.oScroll, scrollX = scroll.sX, scrollXInner = scroll.sXInner, scrollY = scroll.sY, barWidth = scroll.iBarWidth, divHeader = $(settings.nScrollHead), divHeaderStyle = divHeader[0].style, divHeaderInner = divHeader.children("div"), divHeaderInnerStyle = divHeaderInner[0].style, divHeaderTable = divHeaderInner.children("table"), divBodyEl = settings.nScrollBody, divBody = $(divBodyEl), divBodyStyle = divBodyEl.style, divFooter = $(settings.nScrollFoot), divFooterInner = divFooter.children("div"), divFooterTable = divFooterInner.children("table"), header = $(settings.nTHead), table = $(settings.nTable), tableEl = table[0], tableStyle = tableEl.style, footer = settings.nTFoot ? $(settings.nTFoot) : null, browser = settings.oBrowser, ie67 = browser.bScrollOversize, dtHeaderCells = _pluck(settings.aoColumns, "nTh"), headerTrgEls, footerTrgEls, headerSrcEls, footerSrcEls, headerCopy, footerCopy, headerWidths = [], footerWidths = [], headerContent = [], footerContent = [], idx, correction, sanityWidth, zeroOut = function(nSizer) {
            var style = nSizer.style;
            style.paddingTop = "0";
            style.paddingBottom = "0";
            style.borderTopWidth = "0";
            style.borderBottomWidth = "0";
            style.height = 0;
        };
        // If the scrollbar visibility has changed from the last draw, we need to
        // adjust the column sizes as the table width will have changed to account
        // for the scrollbar
        var scrollBarVis = divBodyEl.scrollHeight > divBodyEl.clientHeight;
        if (settings.scrollBarVis !== scrollBarVis && settings.scrollBarVis !== undefined) {
            settings.scrollBarVis = scrollBarVis;
            _fnAdjustColumnSizing(settings);
            return; // adjust column sizing will call this function again
        } else settings.scrollBarVis = scrollBarVis;
        /*
		 * 1. Re-create the table inside the scrolling div
		 */ // Remove the old minimised thead and tfoot elements in the inner table
        table.children("thead, tfoot").remove();
        if (footer) {
            footerCopy = footer.clone().prependTo(table);
            footerTrgEls = footer.find("tr"); // the original tfoot is in its own table and must be sized
            footerSrcEls = footerCopy.find("tr");
            footerCopy.find("[id]").removeAttr("id");
        }
        // Clone the current header and footer elements and then place it into the inner table
        headerCopy = header.clone().prependTo(table);
        headerTrgEls = header.find("tr"); // original header is in its own table
        headerSrcEls = headerCopy.find("tr");
        headerCopy.find("th, td").removeAttr("tabindex");
        headerCopy.find("[id]").removeAttr("id");
        /*
		 * 2. Take live measurements from the DOM - do not alter the DOM itself!
		 */ // Remove old sizing and apply the calculated column widths
        // Get the unique column headers in the newly created (cloned) header. We want to apply the
        // calculated sizes to this header
        if (!scrollX) {
            divBodyStyle.width = "100%";
            divHeader[0].style.width = "100%";
        }
        $.each(_fnGetUniqueThs(settings, headerCopy), function(i, el) {
            idx = _fnVisibleToColumnIndex(settings, i);
            el.style.width = settings.aoColumns[idx].sWidth;
        });
        if (footer) _fnApplyToChildren(function(n) {
            n.style.width = "";
        }, footerSrcEls);
        // Size the table as a whole
        sanityWidth = table.outerWidth();
        if (scrollX === "") {
            // No x scrolling
            tableStyle.width = "100%";
            // IE7 will make the width of the table when 100% include the scrollbar
            // - which is shouldn't. When there is a scrollbar we need to take this
            // into account.
            if (ie67 && (table.find("tbody").height() > divBodyEl.offsetHeight || divBody.css("overflow-y") == "scroll")) tableStyle.width = _fnStringToCss(table.outerWidth() - barWidth);
            // Recalculate the sanity width
            sanityWidth = table.outerWidth();
        } else if (scrollXInner !== "") {
            // legacy x scroll inner has been given - use it
            tableStyle.width = _fnStringToCss(scrollXInner);
            // Recalculate the sanity width
            sanityWidth = table.outerWidth();
        }
        // Hidden header should have zero height, so remove padding and borders. Then
        // set the width based on the real headers
        // Apply all styles in one pass
        _fnApplyToChildren(zeroOut, headerSrcEls);
        // Read all widths in next pass
        _fnApplyToChildren(function(nSizer) {
            var style = window1.getComputedStyle ? window1.getComputedStyle(nSizer).width : _fnStringToCss($(nSizer).width());
            headerContent.push(nSizer.innerHTML);
            headerWidths.push(style);
        }, headerSrcEls);
        // Apply all widths in final pass
        _fnApplyToChildren(function(nToSize, i) {
            nToSize.style.width = headerWidths[i];
        }, headerTrgEls);
        $(headerSrcEls).css("height", 0);
        /* Same again with the footer if we have one */ if (footer) {
            _fnApplyToChildren(zeroOut, footerSrcEls);
            _fnApplyToChildren(function(nSizer) {
                footerContent.push(nSizer.innerHTML);
                footerWidths.push(_fnStringToCss($(nSizer).css("width")));
            }, footerSrcEls);
            _fnApplyToChildren(function(nToSize, i) {
                nToSize.style.width = footerWidths[i];
            }, footerTrgEls);
            $(footerSrcEls).height(0);
        }
        /*
		 * 3. Apply the measurements
		 */ // "Hide" the header and footer that we used for the sizing. We need to keep
        // the content of the cell so that the width applied to the header and body
        // both match, but we want to hide it completely. We want to also fix their
        // width to what they currently are
        _fnApplyToChildren(function(nSizer, i) {
            nSizer.innerHTML = '<div class="dataTables_sizing">' + headerContent[i] + "</div>";
            nSizer.childNodes[0].style.height = "0";
            nSizer.childNodes[0].style.overflow = "hidden";
            nSizer.style.width = headerWidths[i];
        }, headerSrcEls);
        if (footer) _fnApplyToChildren(function(nSizer, i) {
            nSizer.innerHTML = '<div class="dataTables_sizing">' + footerContent[i] + "</div>";
            nSizer.childNodes[0].style.height = "0";
            nSizer.childNodes[0].style.overflow = "hidden";
            nSizer.style.width = footerWidths[i];
        }, footerSrcEls);
        // Sanity check that the table is of a sensible width. If not then we are going to get
        // misalignment - try to prevent this by not allowing the table to shrink below its min width
        if (Math.round(table.outerWidth()) < Math.round(sanityWidth)) {
            // The min width depends upon if we have a vertical scrollbar visible or not */
            correction = divBodyEl.scrollHeight > divBodyEl.offsetHeight || divBody.css("overflow-y") == "scroll" ? sanityWidth + barWidth : sanityWidth;
            // IE6/7 are a law unto themselves...
            if (ie67 && (divBodyEl.scrollHeight > divBodyEl.offsetHeight || divBody.css("overflow-y") == "scroll")) tableStyle.width = _fnStringToCss(correction - barWidth);
            // And give the user a warning that we've stopped the table getting too small
            if (scrollX === "" || scrollXInner !== "") _fnLog(settings, 1, "Possible column misalignment", 6);
        } else correction = "100%";
        // Apply to the container elements
        divBodyStyle.width = _fnStringToCss(correction);
        divHeaderStyle.width = _fnStringToCss(correction);
        if (footer) settings.nScrollFoot.style.width = _fnStringToCss(correction);
        /*
		 * 4. Clean up
		 */ if (!scrollY) /* IE7< puts a vertical scrollbar in place (when it shouldn't be) due to subtracting
			 * the scrollbar height from the visible display, rather than adding it on. We need to
			 * set the height in order to sort this. Don't want to do it in any other browsers.
			 */ {
            if (ie67) divBodyStyle.height = _fnStringToCss(tableEl.offsetHeight + barWidth);
        }
        /* Finally set the width's of the header and footer tables */ var iOuterWidth = table.outerWidth();
        divHeaderTable[0].style.width = _fnStringToCss(iOuterWidth);
        divHeaderInnerStyle.width = _fnStringToCss(iOuterWidth);
        // Figure out if there are scrollbar present - if so then we need a the header and footer to
        // provide a bit more space to allow "overflow" scrolling (i.e. past the scrollbar)
        var bScrolling = table.height() > divBodyEl.clientHeight || divBody.css("overflow-y") == "scroll";
        var padding = "padding" + (browser.bScrollbarLeft ? "Left" : "Right");
        divHeaderInnerStyle[padding] = bScrolling ? barWidth + "px" : "0px";
        if (footer) {
            divFooterTable[0].style.width = _fnStringToCss(iOuterWidth);
            divFooterInner[0].style.width = _fnStringToCss(iOuterWidth);
            divFooterInner[0].style[padding] = bScrolling ? barWidth + "px" : "0px";
        }
        // Correct DOM ordering for colgroup - comes before the thead
        table.children("colgroup").insertBefore(table.children("thead"));
        /* Adjust the position of the header in case we loose the y-scrollbar */ divBody.trigger("scroll");
        // If sorting or filtering has occurred, jump the scrolling back to the top
        // only if we aren't holding the position
        if ((settings.bSorted || settings.bFiltered) && !settings._drawHold) divBodyEl.scrollTop = 0;
    }
    /**
	 * Apply a given function to the display child nodes of an element array (typically
	 * TD children of TR rows
	 *  @param {function} fn Method to apply to the objects
	 *  @param array {nodes} an1 List of elements to look through for display children
	 *  @param array {nodes} an2 Another list (identical structure to the first) - optional
	 *  @memberof DataTable#oApi
	 */ function _fnApplyToChildren(fn, an1, an2) {
        var index = 0, i = 0, iLen = an1.length;
        var nNode1, nNode2;
        while(i < iLen){
            nNode1 = an1[i].firstChild;
            nNode2 = an2 ? an2[i].firstChild : null;
            while(nNode1){
                if (nNode1.nodeType === 1) {
                    if (an2) fn(nNode1, nNode2, index);
                    else fn(nNode1, index);
                    index++;
                }
                nNode1 = nNode1.nextSibling;
                nNode2 = an2 ? nNode2.nextSibling : null;
            }
            i++;
        }
    }
    var __re_html_remove = /<.*?>/g;
    /**
	 * Calculate the width of columns for the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */ function _fnCalculateColumnWidths(oSettings) {
        var table = oSettings.nTable, columns = oSettings.aoColumns, scroll = oSettings.oScroll, scrollY = scroll.sY, scrollX = scroll.sX, scrollXInner = scroll.sXInner, columnCount = columns.length, visibleColumns = _fnGetColumns(oSettings, "bVisible"), headerCells = $("th", oSettings.nTHead), tableWidthAttr = table.getAttribute("width"), tableContainer = table.parentNode, userInputs = false, i, column, columnIdx, width, outerWidth, browser = oSettings.oBrowser, ie67 = browser.bScrollOversize;
        var styleWidth = table.style.width;
        if (styleWidth && styleWidth.indexOf("%") !== -1) tableWidthAttr = styleWidth;
        /* Convert any user input sizes into pixel sizes */ for(i = 0; i < visibleColumns.length; i++){
            column = columns[visibleColumns[i]];
            if (column.sWidth !== null) {
                column.sWidth = _fnConvertToWidth(column.sWidthOrig, tableContainer);
                userInputs = true;
            }
        }
        /* If the number of columns in the DOM equals the number that we have to
		 * process in DataTables, then we can use the offsets that are created by
		 * the web- browser. No custom sizes can be set in order for this to happen,
		 * nor scrolling used
		 */ if (ie67 || !userInputs && !scrollX && !scrollY && columnCount == _fnVisbleColumns(oSettings) && columnCount == headerCells.length) for(i = 0; i < columnCount; i++){
            var colIdx = _fnVisibleToColumnIndex(oSettings, i);
            if (colIdx !== null) columns[colIdx].sWidth = _fnStringToCss(headerCells.eq(i).width());
        }
        else {
            // Otherwise construct a single row, worst case, table with the widest
            // node in the data, assign any user defined widths, then insert it into
            // the DOM and allow the browser to do all the hard work of calculating
            // table widths
            var tmpTable = $(table).clone() // don't use cloneNode - IE8 will remove events on the main table
            .css("visibility", "hidden").removeAttr("id");
            // Clean up the table body
            tmpTable.find("tbody tr").remove();
            var tr = $("<tr/>").appendTo(tmpTable.find("tbody"));
            // Clone the table header and footer - we can't use the header / footer
            // from the cloned table, since if scrolling is active, the table's
            // real header and footer are contained in different table tags
            tmpTable.find("thead, tfoot").remove();
            tmpTable.append($(oSettings.nTHead).clone()).append($(oSettings.nTFoot).clone());
            // Remove any assigned widths from the footer (from scrolling)
            tmpTable.find("tfoot th, tfoot td").css("width", "");
            // Apply custom sizing to the cloned header
            headerCells = _fnGetUniqueThs(oSettings, tmpTable.find("thead")[0]);
            for(i = 0; i < visibleColumns.length; i++){
                column = columns[visibleColumns[i]];
                headerCells[i].style.width = column.sWidthOrig !== null && column.sWidthOrig !== "" ? _fnStringToCss(column.sWidthOrig) : "";
                // For scrollX we need to force the column width otherwise the
                // browser will collapse it. If this width is smaller than the
                // width the column requires, then it will have no effect
                if (column.sWidthOrig && scrollX) $(headerCells[i]).append($("<div/>").css({
                    width: column.sWidthOrig,
                    margin: 0,
                    padding: 0,
                    border: 0,
                    height: 1
                }));
            }
            // Find the widest cell for each column and put it into the table
            if (oSettings.aoData.length) for(i = 0; i < visibleColumns.length; i++){
                columnIdx = visibleColumns[i];
                column = columns[columnIdx];
                $(_fnGetWidestNode(oSettings, columnIdx)).clone(false).append(column.sContentPadding).appendTo(tr);
            }
            // Tidy the temporary table - remove name attributes so there aren't
            // duplicated in the dom (radio elements for example)
            $("[name]", tmpTable).removeAttr("name");
            // Table has been built, attach to the document so we can work with it.
            // A holding element is used, positioned at the top of the container
            // with minimal height, so it has no effect on if the container scrolls
            // or not. Otherwise it might trigger scrolling when it actually isn't
            // needed
            var holder = $("<div/>").css(scrollX || scrollY ? {
                position: "absolute",
                top: 0,
                left: 0,
                height: 1,
                right: 0,
                overflow: "hidden"
            } : {}).append(tmpTable).appendTo(tableContainer);
            // When scrolling (X or Y) we want to set the width of the table as 
            // appropriate. However, when not scrolling leave the table width as it
            // is. This results in slightly different, but I think correct behaviour
            if (scrollX && scrollXInner) tmpTable.width(scrollXInner);
            else if (scrollX) {
                tmpTable.css("width", "auto");
                tmpTable.removeAttr("width");
                // If there is no width attribute or style, then allow the table to
                // collapse
                if (tmpTable.width() < tableContainer.clientWidth && tableWidthAttr) tmpTable.width(tableContainer.clientWidth);
            } else if (scrollY) tmpTable.width(tableContainer.clientWidth);
            else if (tableWidthAttr) tmpTable.width(tableWidthAttr);
            // Get the width of each column in the constructed table - we need to
            // know the inner width (so it can be assigned to the other table's
            // cells) and the outer width so we can calculate the full width of the
            // table. This is safe since DataTables requires a unique cell for each
            // column, but if ever a header can span multiple columns, this will
            // need to be modified.
            var total = 0;
            for(i = 0; i < visibleColumns.length; i++){
                var cell = $(headerCells[i]);
                var border = cell.outerWidth() - cell.width();
                // Use getBounding... where possible (not IE8-) because it can give
                // sub-pixel accuracy, which we then want to round up!
                var bounding = browser.bBounding ? Math.ceil(headerCells[i].getBoundingClientRect().width) : cell.outerWidth();
                // Total is tracked to remove any sub-pixel errors as the outerWidth
                // of the table might not equal the total given here (IE!).
                total += bounding;
                // Width for each column to use
                columns[visibleColumns[i]].sWidth = _fnStringToCss(bounding - border);
            }
            table.style.width = _fnStringToCss(total);
            // Finished with the table - ditch it
            holder.remove();
        }
        // If there is a width attr, we want to attach an event listener which
        // allows the table sizing to automatically adjust when the window is
        // resized. Use the width attr rather than CSS, since we can't know if the
        // CSS is a relative value or absolute - DOM read is always px.
        if (tableWidthAttr) table.style.width = _fnStringToCss(tableWidthAttr);
        if ((tableWidthAttr || scrollX) && !oSettings._reszEvt) {
            var bindResize = function() {
                $(window1).on("resize.DT-" + oSettings.sInstance, _fnThrottle(function() {
                    _fnAdjustColumnSizing(oSettings);
                }));
            };
            // IE6/7 will crash if we bind a resize event handler on page load.
            // To be removed in 1.11 which drops IE6/7 support
            if (ie67) setTimeout(bindResize, 1000);
            else bindResize();
            oSettings._reszEvt = true;
        }
    }
    /**
	 * Throttle the calls to a function. Arguments and context are maintained for
	 * the throttled function
	 *  @param {function} fn Function to be called
	 *  @param {int} [freq=200] call frequency in mS
	 *  @returns {function} wrapped function
	 *  @memberof DataTable#oApi
	 */ var _fnThrottle = DataTable.util.throttle;
    /**
	 * Convert a CSS unit width to pixels (e.g. 2em)
	 *  @param {string} width width to be converted
	 *  @param {node} parent parent to get the with for (required for relative widths) - optional
	 *  @returns {int} width in pixels
	 *  @memberof DataTable#oApi
	 */ function _fnConvertToWidth(width, parent) {
        if (!width) return 0;
        var n = $("<div/>").css("width", _fnStringToCss(width)).appendTo(parent || document1.body);
        var val = n[0].offsetWidth;
        n.remove();
        return val;
    }
    /**
	 * Get the widest node
	 *  @param {object} settings dataTables settings object
	 *  @param {int} colIdx column of interest
	 *  @returns {node} widest table node
	 *  @memberof DataTable#oApi
	 */ function _fnGetWidestNode(settings, colIdx) {
        var idx = _fnGetMaxLenString(settings, colIdx);
        if (idx < 0) return null;
        var data = settings.aoData[idx];
        return !data.nTr ? $("<td/>").html(_fnGetCellData(settings, idx, colIdx, "display"))[0] : data.anCells[colIdx];
    }
    /**
	 * Get the maximum strlen for each data column
	 *  @param {object} settings dataTables settings object
	 *  @param {int} colIdx column of interest
	 *  @returns {string} max string length for each column
	 *  @memberof DataTable#oApi
	 */ function _fnGetMaxLenString(settings, colIdx) {
        var s, max = -1, maxIdx = -1;
        for(var i = 0, ien = settings.aoData.length; i < ien; i++){
            s = _fnGetCellData(settings, i, colIdx, "display") + "";
            s = s.replace(__re_html_remove, "");
            s = s.replace(/&nbsp;/g, " ");
            if (s.length > max) {
                max = s.length;
                maxIdx = i;
            }
        }
        return maxIdx;
    }
    /**
	 * Append a CSS unit (only if required) to a string
	 *  @param {string} value to css-ify
	 *  @returns {string} value with css unit
	 *  @memberof DataTable#oApi
	 */ function _fnStringToCss(s) {
        if (s === null) return "0px";
        if (typeof s == "number") return s < 0 ? "0px" : s + "px";
        // Check it has a unit character already
        return s.match(/\d$/) ? s + "px" : s;
    }
    function _fnSortFlatten(settings) {
        var i, iLen, k, kLen, aSort = [], aiOrig = [], aoColumns = settings.aoColumns, aDataSort, iCol, sType, srcCol, fixed = settings.aaSortingFixed, fixedObj = $.isPlainObject(fixed), nestedSort = [], add = function(a) {
            if (a.length && !Array.isArray(a[0])) // 1D array
            nestedSort.push(a);
            else // 2D array
            $.merge(nestedSort, a);
        };
        // Build the sort array, with pre-fix and post-fix options if they have been
        // specified
        if (Array.isArray(fixed)) add(fixed);
        if (fixedObj && fixed.pre) add(fixed.pre);
        add(settings.aaSorting);
        if (fixedObj && fixed.post) add(fixed.post);
        for(i = 0; i < nestedSort.length; i++){
            srcCol = nestedSort[i][0];
            aDataSort = aoColumns[srcCol].aDataSort;
            for(k = 0, kLen = aDataSort.length; k < kLen; k++){
                iCol = aDataSort[k];
                sType = aoColumns[iCol].sType || "string";
                if (nestedSort[i]._idx === undefined) nestedSort[i]._idx = $.inArray(nestedSort[i][1], aoColumns[iCol].asSorting);
                aSort.push({
                    src: srcCol,
                    col: iCol,
                    dir: nestedSort[i][1],
                    index: nestedSort[i]._idx,
                    type: sType,
                    formatter: DataTable.ext.type.order[sType + "-pre"]
                });
            }
        }
        return aSort;
    }
    /**
	 * Change the order of the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 *  @todo This really needs split up!
	 */ function _fnSort(oSettings) {
        var i, ien, iLen, j, jLen, k, kLen, sDataType, nTh, aiOrig = [], oExtSort = DataTable.ext.type.order, aoData = oSettings.aoData, aoColumns = oSettings.aoColumns, aDataSort, data, iCol, sType, oSort, formatters = 0, sortCol, displayMaster = oSettings.aiDisplayMaster, aSort;
        // Resolve any column types that are unknown due to addition or invalidation
        // @todo Can this be moved into a 'data-ready' handler which is called when
        //   data is going to be used in the table?
        _fnColumnTypes(oSettings);
        aSort = _fnSortFlatten(oSettings);
        for(i = 0, ien = aSort.length; i < ien; i++){
            sortCol = aSort[i];
            // Track if we can use the fast sort algorithm
            if (sortCol.formatter) formatters++;
            // Load the data needed for the sort, for each cell
            _fnSortData(oSettings, sortCol.col);
        }
        /* No sorting required if server-side or no sorting array */ if (_fnDataSource(oSettings) != "ssp" && aSort.length !== 0) {
            // Create a value - key array of the current row positions such that we can use their
            // current position during the sort, if values match, in order to perform stable sorting
            for(i = 0, iLen = displayMaster.length; i < iLen; i++)aiOrig[displayMaster[i]] = i;
            /* Do the sort - here we want multi-column sorting based on a given data source (column)
			 * and sorting function (from oSort) in a certain direction. It's reasonably complex to
			 * follow on it's own, but this is what we want (example two column sorting):
			 *  fnLocalSorting = function(a,b){
			 *    var iTest;
			 *    iTest = oSort['string-asc']('data11', 'data12');
			 *      if (iTest !== 0)
			 *        return iTest;
			 *    iTest = oSort['numeric-desc']('data21', 'data22');
			 *    if (iTest !== 0)
			 *      return iTest;
			 *    return oSort['numeric-asc']( aiOrig[a], aiOrig[b] );
			 *  }
			 * Basically we have a test for each sorting column, if the data in that column is equal,
			 * test the next column. If all columns match, then we use a numeric sort on the row
			 * positions in the original data array to provide a stable sort.
			 *
			 * Note - I know it seems excessive to have two sorting methods, but the first is around
			 * 15% faster, so the second is only maintained for backwards compatibility with sorting
			 * methods which do not have a pre-sort formatting function.
			 */ if (formatters === aSort.length) // All sort types have formatting functions
            displayMaster.sort(function(a, b) {
                var x, y, k, test, sort, len = aSort.length, dataA = aoData[a]._aSortData, dataB = aoData[b]._aSortData;
                for(k = 0; k < len; k++){
                    sort = aSort[k];
                    x = dataA[sort.col];
                    y = dataB[sort.col];
                    test = x < y ? -1 : x > y ? 1 : 0;
                    if (test !== 0) return sort.dir === "asc" ? test : -test;
                }
                x = aiOrig[a];
                y = aiOrig[b];
                return x < y ? -1 : x > y ? 1 : 0;
            });
            else // Depreciated - remove in 1.11 (providing a plug-in option)
            // Not all sort types have formatting methods, so we have to call their sorting
            // methods.
            displayMaster.sort(function(a, b) {
                var x, y, k, l, test, sort, fn, len = aSort.length, dataA = aoData[a]._aSortData, dataB = aoData[b]._aSortData;
                for(k = 0; k < len; k++){
                    sort = aSort[k];
                    x = dataA[sort.col];
                    y = dataB[sort.col];
                    fn = oExtSort[sort.type + "-" + sort.dir] || oExtSort["string-" + sort.dir];
                    test = fn(x, y);
                    if (test !== 0) return test;
                }
                x = aiOrig[a];
                y = aiOrig[b];
                return x < y ? -1 : x > y ? 1 : 0;
            });
        }
        /* Tell the draw function that we have sorted the data */ oSettings.bSorted = true;
    }
    function _fnSortAria(settings) {
        var label;
        var nextSort;
        var columns = settings.aoColumns;
        var aSort = _fnSortFlatten(settings);
        var oAria = settings.oLanguage.oAria;
        // ARIA attributes - need to loop all columns, to update all (removing old
        // attributes as needed)
        for(var i = 0, iLen = columns.length; i < iLen; i++){
            var col = columns[i];
            var asSorting = col.asSorting;
            var sTitle = col.ariaTitle || col.sTitle.replace(/<.*?>/g, "");
            var th = col.nTh;
            // IE7 is throwing an error when setting these properties with jQuery's
            // attr() and removeAttr() methods...
            th.removeAttribute("aria-sort");
            /* In ARIA only the first sorting column can be marked as sorting - no multi-sort option */ if (col.bSortable) {
                if (aSort.length > 0 && aSort[0].col == i) {
                    th.setAttribute("aria-sort", aSort[0].dir == "asc" ? "ascending" : "descending");
                    nextSort = asSorting[aSort[0].index + 1] || asSorting[0];
                } else nextSort = asSorting[0];
                label = sTitle + (nextSort === "asc" ? oAria.sSortAscending : oAria.sSortDescending);
            } else label = sTitle;
            th.setAttribute("aria-label", label);
        }
    }
    /**
	 * Function to run on user sort request
	 *  @param {object} settings dataTables settings object
	 *  @param {node} attachTo node to attach the handler to
	 *  @param {int} colIdx column sorting index
	 *  @param {boolean} [append=false] Append the requested sort to the existing
	 *    sort if true (i.e. multi-column sort)
	 *  @param {function} [callback] callback function
	 *  @memberof DataTable#oApi
	 */ function _fnSortListener(settings, colIdx, append, callback) {
        var col = settings.aoColumns[colIdx];
        var sorting = settings.aaSorting;
        var asSorting = col.asSorting;
        var nextSortIdx;
        var next = function(a, overflow) {
            var idx = a._idx;
            if (idx === undefined) idx = $.inArray(a[1], asSorting);
            return idx + 1 < asSorting.length ? idx + 1 : overflow ? null : 0;
        };
        // Convert to 2D array if needed
        if (typeof sorting[0] === "number") sorting = settings.aaSorting = [
            sorting
        ];
        // If appending the sort then we are multi-column sorting
        if (append && settings.oFeatures.bSortMulti) {
            // Are we already doing some kind of sort on this column?
            var sortIdx = $.inArray(colIdx, _pluck(sorting, "0"));
            if (sortIdx !== -1) {
                // Yes, modify the sort
                nextSortIdx = next(sorting[sortIdx], true);
                if (nextSortIdx === null && sorting.length === 1) nextSortIdx = 0; // can't remove sorting completely
                if (nextSortIdx === null) sorting.splice(sortIdx, 1);
                else {
                    sorting[sortIdx][1] = asSorting[nextSortIdx];
                    sorting[sortIdx]._idx = nextSortIdx;
                }
            } else {
                // No sort on this column yet
                sorting.push([
                    colIdx,
                    asSorting[0],
                    0
                ]);
                sorting[sorting.length - 1]._idx = 0;
            }
        } else if (sorting.length && sorting[0][0] == colIdx) {
            // Single column - already sorting on this column, modify the sort
            nextSortIdx = next(sorting[0]);
            sorting.length = 1;
            sorting[0][1] = asSorting[nextSortIdx];
            sorting[0]._idx = nextSortIdx;
        } else {
            // Single column - sort only on this column
            sorting.length = 0;
            sorting.push([
                colIdx,
                asSorting[0]
            ]);
            sorting[0]._idx = 0;
        }
        // Run the sort by calling a full redraw
        _fnReDraw(settings);
        // callback used for async user interaction
        if (typeof callback == "function") callback(settings);
    }
    /**
	 * Attach a sort handler (click) to a node
	 *  @param {object} settings dataTables settings object
	 *  @param {node} attachTo node to attach the handler to
	 *  @param {int} colIdx column sorting index
	 *  @param {function} [callback] callback function
	 *  @memberof DataTable#oApi
	 */ function _fnSortAttachListener(settings, attachTo, colIdx, callback) {
        var col = settings.aoColumns[colIdx];
        _fnBindAction(attachTo, {}, function(e) {
            /* If the column is not sortable - don't to anything */ if (col.bSortable === false) return;
            // If processing is enabled use a timeout to allow the processing
            // display to be shown - otherwise to it synchronously
            if (settings.oFeatures.bProcessing) {
                _fnProcessingDisplay(settings, true);
                setTimeout(function() {
                    _fnSortListener(settings, colIdx, e.shiftKey, callback);
                    // In server-side processing, the draw callback will remove the
                    // processing display
                    if (_fnDataSource(settings) !== "ssp") _fnProcessingDisplay(settings, false);
                }, 0);
            } else _fnSortListener(settings, colIdx, e.shiftKey, callback);
        });
    }
    /**
	 * Set the sorting classes on table's body, Note: it is safe to call this function
	 * when bSort and bSortClasses are false
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */ function _fnSortingClasses(settings) {
        var oldSort = settings.aLastSort;
        var sortClass = settings.oClasses.sSortColumn;
        var sort = _fnSortFlatten(settings);
        var features = settings.oFeatures;
        var i, ien, colIdx;
        if (features.bSort && features.bSortClasses) {
            // Remove old sorting classes
            for(i = 0, ien = oldSort.length; i < ien; i++){
                colIdx = oldSort[i].src;
                // Remove column sorting
                $(_pluck(settings.aoData, "anCells", colIdx)).removeClass(sortClass + (i < 2 ? i + 1 : 3));
            }
            // Add new column sorting
            for(i = 0, ien = sort.length; i < ien; i++){
                colIdx = sort[i].src;
                $(_pluck(settings.aoData, "anCells", colIdx)).addClass(sortClass + (i < 2 ? i + 1 : 3));
            }
        }
        settings.aLastSort = sort;
    }
    // Get the data to sort a column, be it from cache, fresh (populating the
    // cache), or from a sort formatter
    function _fnSortData(settings, idx) {
        // Custom sorting function - provided by the sort data type
        var column = settings.aoColumns[idx];
        var customSort = DataTable.ext.order[column.sSortDataType];
        var customData;
        if (customSort) customData = customSort.call(settings.oInstance, settings, idx, _fnColumnIndexToVisible(settings, idx));
        // Use / populate cache
        var row, cellData;
        var formatter = DataTable.ext.type.order[column.sType + "-pre"];
        for(var i = 0, ien = settings.aoData.length; i < ien; i++){
            row = settings.aoData[i];
            if (!row._aSortData) row._aSortData = [];
            if (!row._aSortData[idx] || customSort) {
                cellData = customSort ? customData[i] : _fnGetCellData(settings, i, idx, "sort");
                row._aSortData[idx] = formatter ? formatter(cellData) : cellData;
            }
        }
    }
    /**
	 * Save the state of a table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */ function _fnSaveState(settings) {
        if (settings._bLoadingState) return;
        /* Store the interesting variables */ var state = {
            time: +new Date(),
            start: settings._iDisplayStart,
            length: settings._iDisplayLength,
            order: $.extend(true, [], settings.aaSorting),
            search: _fnSearchToCamel(settings.oPreviousSearch),
            columns: $.map(settings.aoColumns, function(col, i) {
                return {
                    visible: col.bVisible,
                    search: _fnSearchToCamel(settings.aoPreSearchCols[i])
                };
            })
        };
        settings.oSavedState = state;
        _fnCallbackFire(settings, "aoStateSaveParams", "stateSaveParams", [
            settings,
            state
        ]);
        if (settings.oFeatures.bStateSave && !settings.bDestroying) settings.fnStateSaveCallback.call(settings.oInstance, settings, state);
    }
    /**
	 * Attempt to load a saved table state
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} oInit DataTables init object so we can override settings
	 *  @param {function} callback Callback to execute when the state has been loaded
	 *  @memberof DataTable#oApi
	 */ function _fnLoadState(settings, oInit, callback) {
        if (!settings.oFeatures.bStateSave) {
            callback();
            return;
        }
        var loaded = function(state) {
            _fnImplementState(settings, state, callback);
        };
        var state = settings.fnStateLoadCallback.call(settings.oInstance, settings, loaded);
        if (state !== undefined) _fnImplementState(settings, state, callback);
        // otherwise, wait for the loaded callback to be executed
        return true;
    }
    function _fnImplementState(settings, s, callback) {
        var i, ien;
        var columns = settings.aoColumns;
        settings._bLoadingState = true;
        // When StateRestore was introduced the state could now be implemented at any time
        // Not just initialisation. To do this an api instance is required in some places
        var api = settings._bInitComplete ? new DataTable.Api(settings) : null;
        if (!s || !s.time) {
            settings._bLoadingState = false;
            callback();
            return;
        }
        // Allow custom and plug-in manipulation functions to alter the saved data set and
        // cancelling of loading by returning false
        var abStateLoad = _fnCallbackFire(settings, "aoStateLoadParams", "stateLoadParams", [
            settings,
            s
        ]);
        if ($.inArray(false, abStateLoad) !== -1) {
            settings._bLoadingState = false;
            callback();
            return;
        }
        // Reject old data
        var duration = settings.iStateDuration;
        if (duration > 0 && s.time < +new Date() - duration * 1000) {
            settings._bLoadingState = false;
            callback();
            return;
        }
        // Number of columns have changed - all bets are off, no restore of settings
        if (s.columns && columns.length !== s.columns.length) {
            settings._bLoadingState = false;
            callback();
            return;
        }
        // Store the saved state so it might be accessed at any time
        settings.oLoadedState = $.extend(true, {}, s);
        // Page Length
        if (s.length !== undefined) {
            // If already initialised just set the value directly so that the select element is also updated
            if (api) api.page.len(s.length);
            else settings._iDisplayLength = s.length;
        }
        // Restore key features - todo - for 1.11 this needs to be done by
        // subscribed events
        if (s.start !== undefined) {
            if (api === null) {
                settings._iDisplayStart = s.start;
                settings.iInitDisplayStart = s.start;
            } else _fnPageChange(settings, s.start / settings._iDisplayLength);
        }
        // Order
        if (s.order !== undefined) {
            settings.aaSorting = [];
            $.each(s.order, function(i, col) {
                settings.aaSorting.push(col[0] >= columns.length ? [
                    0,
                    col[1]
                ] : col);
            });
        }
        // Search
        if (s.search !== undefined) $.extend(settings.oPreviousSearch, _fnSearchToHung(s.search));
        // Columns
        if (s.columns) {
            for(i = 0, ien = s.columns.length; i < ien; i++){
                var col = s.columns[i];
                // Visibility
                if (col.visible !== undefined) {
                    // If the api is defined, the table has been initialised so we need to use it rather than internal settings
                    if (api) // Don't redraw the columns on every iteration of this loop, we will do this at the end instead
                    api.column(i).visible(col.visible, false);
                    else columns[i].bVisible = col.visible;
                }
                // Search
                if (col.search !== undefined) $.extend(settings.aoPreSearchCols[i], _fnSearchToHung(col.search));
            }
            // If the api is defined then we need to adjust the columns once the visibility has been changed
            if (api) api.columns.adjust();
        }
        settings._bLoadingState = false;
        _fnCallbackFire(settings, "aoStateLoaded", "stateLoaded", [
            settings,
            s
        ]);
        callback();
    }
    /**
	 * Return the settings object for a particular table
	 *  @param {node} table table we are using as a dataTable
	 *  @returns {object} Settings object - or null if not found
	 *  @memberof DataTable#oApi
	 */ function _fnSettingsFromNode(table) {
        var settings = DataTable.settings;
        var idx = $.inArray(table, _pluck(settings, "nTable"));
        return idx !== -1 ? settings[idx] : null;
    }
    /**
	 * Log an error message
	 *  @param {object} settings dataTables settings object
	 *  @param {int} level log error messages, or display them to the user
	 *  @param {string} msg error message
	 *  @param {int} tn Technical note id to get more information about the error.
	 *  @memberof DataTable#oApi
	 */ function _fnLog(settings, level, msg, tn) {
        msg = "DataTables warning: " + (settings ? "table id=" + settings.sTableId + " - " : "") + msg;
        if (tn) msg += ". For more information about this error, please see http://datatables.net/tn/" + tn;
        if (!level) {
            // Backwards compatibility pre 1.10
            var ext = DataTable.ext;
            var type = ext.sErrMode || ext.errMode;
            if (settings) _fnCallbackFire(settings, null, "error", [
                settings,
                tn,
                msg
            ]);
            if (type == "alert") alert(msg);
            else if (type == "throw") throw new Error(msg);
            else if (typeof type == "function") type(settings, tn, msg);
        } else if (window1.console && console.log) console.log(msg);
    }
    /**
	 * See if a property is defined on one object, if so assign it to the other object
	 *  @param {object} ret target object
	 *  @param {object} src source object
	 *  @param {string} name property
	 *  @param {string} [mappedName] name to map too - optional, name used if not given
	 *  @memberof DataTable#oApi
	 */ function _fnMap(ret, src, name, mappedName) {
        if (Array.isArray(name)) {
            $.each(name, function(i, val) {
                if (Array.isArray(val)) _fnMap(ret, src, val[0], val[1]);
                else _fnMap(ret, src, val);
            });
            return;
        }
        if (mappedName === undefined) mappedName = name;
        if (src[name] !== undefined) ret[mappedName] = src[name];
    }
    /**
	 * Extend objects - very similar to jQuery.extend, but deep copy objects, and
	 * shallow copy arrays. The reason we need to do this, is that we don't want to
	 * deep copy array init values (such as aaSorting) since the dev wouldn't be
	 * able to override them, but we do want to deep copy arrays.
	 *  @param {object} out Object to extend
	 *  @param {object} extender Object from which the properties will be applied to
	 *      out
	 *  @param {boolean} breakRefs If true, then arrays will be sliced to take an
	 *      independent copy with the exception of the `data` or `aaData` parameters
	 *      if they are present. This is so you can pass in a collection to
	 *      DataTables and have that used as your data source without breaking the
	 *      references
	 *  @returns {object} out Reference, just for convenience - out === the return.
	 *  @memberof DataTable#oApi
	 *  @todo This doesn't take account of arrays inside the deep copied objects.
	 */ function _fnExtend(out, extender, breakRefs) {
        var val;
        for(var prop in extender)if (extender.hasOwnProperty(prop)) {
            val = extender[prop];
            if ($.isPlainObject(val)) {
                if (!$.isPlainObject(out[prop])) out[prop] = {};
                $.extend(true, out[prop], val);
            } else if (breakRefs && prop !== "data" && prop !== "aaData" && Array.isArray(val)) out[prop] = val.slice();
            else out[prop] = val;
        }
        return out;
    }
    /**
	 * Bind an event handers to allow a click or return key to activate the callback.
	 * This is good for accessibility since a return on the keyboard will have the
	 * same effect as a click, if the element has focus.
	 *  @param {element} n Element to bind the action to
	 *  @param {object} oData Data object to pass to the triggered function
	 *  @param {function} fn Callback function for when the event is triggered
	 *  @memberof DataTable#oApi
	 */ function _fnBindAction(n, oData, fn) {
        $(n).on("click.DT", oData, function(e) {
            $(n).trigger("blur"); // Remove focus outline for mouse users
            fn(e);
        }).on("keypress.DT", oData, function(e) {
            if (e.which === 13) {
                e.preventDefault();
                fn(e);
            }
        }).on("selectstart.DT", function() {
            /* Take the brutal approach to cancelling text selection */ return false;
        });
    }
    /**
	 * Register a callback function. Easily allows a callback function to be added to
	 * an array store of callback functions that can then all be called together.
	 *  @param {object} oSettings dataTables settings object
	 *  @param {string} sStore Name of the array storage for the callbacks in oSettings
	 *  @param {function} fn Function to be called back
	 *  @param {string} sName Identifying name for the callback (i.e. a label)
	 *  @memberof DataTable#oApi
	 */ function _fnCallbackReg(oSettings, sStore, fn, sName) {
        if (fn) oSettings[sStore].push({
            "fn": fn,
            "sName": sName
        });
    }
    /**
	 * Fire callback functions and trigger events. Note that the loop over the
	 * callback array store is done backwards! Further note that you do not want to
	 * fire off triggers in time sensitive applications (for example cell creation)
	 * as its slow.
	 *  @param {object} settings dataTables settings object
	 *  @param {string} callbackArr Name of the array storage for the callbacks in
	 *      oSettings
	 *  @param {string} eventName Name of the jQuery custom event to trigger. If
	 *      null no trigger is fired
	 *  @param {array} args Array of arguments to pass to the callback function /
	 *      trigger
	 *  @memberof DataTable#oApi
	 */ function _fnCallbackFire(settings, callbackArr, eventName, args) {
        var ret = [];
        if (callbackArr) ret = $.map(settings[callbackArr].slice().reverse(), function(val, i) {
            return val.fn.apply(settings.oInstance, args);
        });
        if (eventName !== null) {
            var e = $.Event(eventName + ".dt");
            $(settings.nTable).trigger(e, args);
            ret.push(e.result);
        }
        return ret;
    }
    function _fnLengthOverflow(settings) {
        var start = settings._iDisplayStart, end = settings.fnDisplayEnd(), len = settings._iDisplayLength;
        /* If we have space to show extra rows (backing up from the end point - then do so */ if (start >= end) start = end - len;
        // Keep the start record on the current page
        start -= start % len;
        if (len === -1 || start < 0) start = 0;
        settings._iDisplayStart = start;
    }
    function _fnRenderer(settings, type) {
        var renderer = settings.renderer;
        var host = DataTable.ext.renderer[type];
        if ($.isPlainObject(renderer) && renderer[type]) // Specific renderer for this type. If available use it, otherwise use
        // the default.
        return host[renderer[type]] || host._;
        else if (typeof renderer === "string") // Common renderer - if there is one available for this type use it,
        // otherwise use the default
        return host[renderer] || host._;
        // Use the default
        return host._;
    }
    /**
	 * Detect the data source being used for the table. Used to simplify the code
	 * a little (ajax) and to make it compress a little smaller.
	 *
	 *  @param {object} settings dataTables settings object
	 *  @returns {string} Data source
	 *  @memberof DataTable#oApi
	 */ function _fnDataSource(settings) {
        if (settings.oFeatures.bServerSide) return "ssp";
        else if (settings.ajax || settings.sAjaxSource) return "ajax";
        return "dom";
    }
    /**
	 * Computed structure of the DataTables API, defined by the options passed to
	 * `DataTable.Api.register()` when building the API.
	 *
	 * The structure is built in order to speed creation and extension of the Api
	 * objects since the extensions are effectively pre-parsed.
	 *
	 * The array is an array of objects with the following structure, where this
	 * base array represents the Api prototype base:
	 *
	 *     [
	 *       {
	 *         name:      'data'                -- string   - Property name
	 *         val:       function () {},       -- function - Api method (or undefined if just an object
	 *         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
	 *         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
	 *       },
	 *       {
	 *         name:     'row'
	 *         val:       {},
	 *         methodExt: [ ... ],
	 *         propExt:   [
	 *           {
	 *             name:      'data'
	 *             val:       function () {},
	 *             methodExt: [ ... ],
	 *             propExt:   [ ... ]
	 *           },
	 *           ...
	 *         ]
	 *       }
	 *     ]
	 *
	 * @type {Array}
	 * @ignore
	 */ var __apiStruct = [];
    /**
	 * `Array.prototype` reference.
	 *
	 * @type object
	 * @ignore
	 */ var __arrayProto = Array.prototype;
    /**
	 * Abstraction for `context` parameter of the `Api` constructor to allow it to
	 * take several different forms for ease of use.
	 *
	 * Each of the input parameter types will be converted to a DataTables settings
	 * object where possible.
	 *
	 * @param  {string|node|jQuery|object} mixed DataTable identifier. Can be one
	 *   of:
	 *
	 *   * `string` - jQuery selector. Any DataTables' matching the given selector
	 *     with be found and used.
	 *   * `node` - `TABLE` node which has already been formed into a DataTable.
	 *   * `jQuery` - A jQuery object of `TABLE` nodes.
	 *   * `object` - DataTables settings object
	 *   * `DataTables.Api` - API instance
	 * @return {array|null} Matching DataTables settings objects. `null` or
	 *   `undefined` is returned if no matching DataTable is found.
	 * @ignore
	 */ var _toSettings = function(mixed) {
        var idx, jq;
        var settings = DataTable.settings;
        var tables = $.map(settings, function(el, i) {
            return el.nTable;
        });
        if (!mixed) return [];
        else if (mixed.nTable && mixed.oApi) // DataTables settings object
        return [
            mixed
        ];
        else if (mixed.nodeName && mixed.nodeName.toLowerCase() === "table") {
            // Table node
            idx = $.inArray(mixed, tables);
            return idx !== -1 ? [
                settings[idx]
            ] : null;
        } else if (mixed && typeof mixed.settings === "function") return mixed.settings().toArray();
        else if (typeof mixed === "string") // jQuery selector
        jq = $(mixed);
        else if (mixed instanceof $) // jQuery object (also DataTables instance)
        jq = mixed;
        if (jq) return jq.map(function(i) {
            idx = $.inArray(this, tables);
            return idx !== -1 ? settings[idx] : null;
        }).toArray();
    };
    /**
	 * DataTables API class - used to control and interface with  one or more
	 * DataTables enhanced tables.
	 *
	 * The API class is heavily based on jQuery, presenting a chainable interface
	 * that you can use to interact with tables. Each instance of the API class has
	 * a "context" - i.e. the tables that it will operate on. This could be a single
	 * table, all tables on a page or a sub-set thereof.
	 *
	 * Additionally the API is designed to allow you to easily work with the data in
	 * the tables, retrieving and manipulating it as required. This is done by
	 * presenting the API class as an array like interface. The contents of the
	 * array depend upon the actions requested by each method (for example
	 * `rows().nodes()` will return an array of nodes, while `rows().data()` will
	 * return an array of objects or arrays depending upon your table's
	 * configuration). The API object has a number of array like methods (`push`,
	 * `pop`, `reverse` etc) as well as additional helper methods (`each`, `pluck`,
	 * `unique` etc) to assist your working with the data held in a table.
	 *
	 * Most methods (those which return an Api instance) are chainable, which means
	 * the return from a method call also has all of the methods available that the
	 * top level object had. For example, these two calls are equivalent:
	 *
	 *     // Not chained
	 *     api.row.add( {...} );
	 *     api.draw();
	 *
	 *     // Chained
	 *     api.row.add( {...} ).draw();
	 *
	 * @class DataTable.Api
	 * @param {array|object|string|jQuery} context DataTable identifier. This is
	 *   used to define which DataTables enhanced tables this API will operate on.
	 *   Can be one of:
	 *
	 *   * `string` - jQuery selector. Any DataTables' matching the given selector
	 *     with be found and used.
	 *   * `node` - `TABLE` node which has already been formed into a DataTable.
	 *   * `jQuery` - A jQuery object of `TABLE` nodes.
	 *   * `object` - DataTables settings object
	 * @param {array} [data] Data to initialise the Api instance with.
	 *
	 * @example
	 *   // Direct initialisation during DataTables construction
	 *   var api = $('#example').DataTable();
	 *
	 * @example
	 *   // Initialisation using a DataTables jQuery object
	 *   var api = $('#example').dataTable().api();
	 *
	 * @example
	 *   // Initialisation as a constructor
	 *   var api = new $.fn.DataTable.Api( 'table.dataTable' );
	 */ _Api = function(context, data) {
        if (!(this instanceof _Api)) return new _Api(context, data);
        var settings = [];
        var ctxSettings = function(o) {
            var a = _toSettings(o);
            if (a) settings.push.apply(settings, a);
        };
        if (Array.isArray(context)) for(var i = 0, ien = context.length; i < ien; i++)ctxSettings(context[i]);
        else ctxSettings(context);
        // Remove duplicates
        this.context = _unique(settings);
        // Initial data
        if (data) $.merge(this, data);
        // selector
        this.selector = {
            rows: null,
            cols: null,
            opts: null
        };
        _Api.extend(this, this, __apiStruct);
    };
    DataTable.Api = _Api;
    // Don't destroy the existing prototype, just extend it. Required for jQuery 2's
    // isPlainObject.
    $.extend(_Api.prototype, {
        any: function() {
            return this.count() !== 0;
        },
        concat: __arrayProto.concat,
        context: [],
        count: function() {
            return this.flatten().length;
        },
        each: function(fn) {
            for(var i = 0, ien = this.length; i < ien; i++)fn.call(this, this[i], i, this);
            return this;
        },
        eq: function(idx) {
            var ctx = this.context;
            return ctx.length > idx ? new _Api(ctx[idx], this[idx]) : null;
        },
        filter: function(fn) {
            var a = [];
            if (__arrayProto.filter) a = __arrayProto.filter.call(this, fn, this);
            else {
                // Compatibility for browsers without EMCA-252-5 (JS 1.6)
                for(var i = 0, ien = this.length; i < ien; i++)if (fn.call(this, this[i], i, this)) a.push(this[i]);
            }
            return new _Api(this.context, a);
        },
        flatten: function() {
            var a = [];
            return new _Api(this.context, a.concat.apply(a, this.toArray()));
        },
        join: __arrayProto.join,
        indexOf: __arrayProto.indexOf || function(obj, start) {
            for(var i = start || 0, ien = this.length; i < ien; i++){
                if (this[i] === obj) return i;
            }
            return -1;
        },
        iterator: function(flatten, type, fn, alwaysNew) {
            var a = [], ret, i, ien, j, jen, context = this.context, rows, items, item, selector = this.selector;
            // Argument shifting
            if (typeof flatten === "string") {
                alwaysNew = fn;
                fn = type;
                type = flatten;
                flatten = false;
            }
            for(i = 0, ien = context.length; i < ien; i++){
                var apiInst = new _Api(context[i]);
                if (type === "table") {
                    ret = fn.call(apiInst, context[i], i);
                    if (ret !== undefined) a.push(ret);
                } else if (type === "columns" || type === "rows") {
                    // this has same length as context - one entry for each table
                    ret = fn.call(apiInst, context[i], this[i], i);
                    if (ret !== undefined) a.push(ret);
                } else if (type === "column" || type === "column-rows" || type === "row" || type === "cell") {
                    // columns and rows share the same structure.
                    // 'this' is an array of column indexes for each context
                    items = this[i];
                    if (type === "column-rows") rows = _selector_row_indexes(context[i], selector.opts);
                    for(j = 0, jen = items.length; j < jen; j++){
                        item = items[j];
                        if (type === "cell") ret = fn.call(apiInst, context[i], item.row, item.column, i, j);
                        else ret = fn.call(apiInst, context[i], item, i, j, rows);
                        if (ret !== undefined) a.push(ret);
                    }
                }
            }
            if (a.length || alwaysNew) {
                var api = new _Api(context, flatten ? a.concat.apply([], a) : a);
                var apiSelector = api.selector;
                apiSelector.rows = selector.rows;
                apiSelector.cols = selector.cols;
                apiSelector.opts = selector.opts;
                return api;
            }
            return this;
        },
        lastIndexOf: __arrayProto.lastIndexOf || function(obj, start) {
            // Bit cheeky...
            return this.indexOf.apply(this.toArray.reverse(), arguments);
        },
        length: 0,
        map: function(fn) {
            var a = [];
            if (__arrayProto.map) a = __arrayProto.map.call(this, fn, this);
            else // Compatibility for browsers without EMCA-252-5 (JS 1.6)
            for(var i = 0, ien = this.length; i < ien; i++)a.push(fn.call(this, this[i], i));
            return new _Api(this.context, a);
        },
        pluck: function(prop) {
            let fn = DataTable.util.get(prop);
            return this.map(function(el) {
                return fn(el);
            });
        },
        pop: __arrayProto.pop,
        push: __arrayProto.push,
        // Does not return an API instance
        reduce: __arrayProto.reduce || function(fn, init) {
            return _fnReduce(this, fn, init, 0, this.length, 1);
        },
        reduceRight: __arrayProto.reduceRight || function(fn, init) {
            return _fnReduce(this, fn, init, this.length - 1, -1, -1);
        },
        reverse: __arrayProto.reverse,
        // Object with rows, columns and opts
        selector: null,
        shift: __arrayProto.shift,
        slice: function() {
            return new _Api(this.context, this);
        },
        sort: __arrayProto.sort,
        splice: __arrayProto.splice,
        toArray: function() {
            return __arrayProto.slice.call(this);
        },
        to$: function() {
            return $(this);
        },
        toJQuery: function() {
            return $(this);
        },
        unique: function() {
            return new _Api(this.context, _unique(this));
        },
        unshift: __arrayProto.unshift
    });
    _Api.extend = function(scope, obj, ext) {
        // Only extend API instances and static properties of the API
        if (!ext.length || !obj || !(obj instanceof _Api) && !obj.__dt_wrapper) return;
        var i, ien, struct, methodScoping = function(scope, fn, struc) {
            return function() {
                var ret = fn.apply(scope, arguments);
                // Method extension
                _Api.extend(ret, ret, struc.methodExt);
                return ret;
            };
        };
        for(i = 0, ien = ext.length; i < ien; i++){
            struct = ext[i];
            // Value
            obj[struct.name] = struct.type === "function" ? methodScoping(scope, struct.val, struct) : struct.type === "object" ? {} : struct.val;
            obj[struct.name].__dt_wrapper = true;
            // Property extension
            _Api.extend(scope, obj[struct.name], struct.propExt);
        }
    };
    // @todo - Is there need for an augment function?
    // _Api.augment = function ( inst, name )
    // {
    // 	// Find src object in the structure from the name
    // 	var parts = name.split('.');
    // 	_Api.extend( inst, obj );
    // };
    //     [
    //       {
    //         name:      'data'                -- string   - Property name
    //         val:       function () {},       -- function - Api method (or undefined if just an object
    //         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
    //         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
    //       },
    //       {
    //         name:     'row'
    //         val:       {},
    //         methodExt: [ ... ],
    //         propExt:   [
    //           {
    //             name:      'data'
    //             val:       function () {},
    //             methodExt: [ ... ],
    //             propExt:   [ ... ]
    //           },
    //           ...
    //         ]
    //       }
    //     ]
    _Api.register = _api_register = function(name, val) {
        if (Array.isArray(name)) {
            for(var j = 0, jen = name.length; j < jen; j++)_Api.register(name[j], val);
            return;
        }
        var i, ien, heir = name.split("."), struct = __apiStruct, key, method;
        var find = function(src, name) {
            for(var i = 0, ien = src.length; i < ien; i++){
                if (src[i].name === name) return src[i];
            }
            return null;
        };
        for(i = 0, ien = heir.length; i < ien; i++){
            method = heir[i].indexOf("()") !== -1;
            key = method ? heir[i].replace("()", "") : heir[i];
            var src = find(struct, key);
            if (!src) {
                src = {
                    name: key,
                    val: {},
                    methodExt: [],
                    propExt: [],
                    type: "object"
                };
                struct.push(src);
            }
            if (i === ien - 1) {
                src.val = val;
                src.type = typeof val === "function" ? "function" : $.isPlainObject(val) ? "object" : "other";
            } else struct = method ? src.methodExt : src.propExt;
        }
    };
    _Api.registerPlural = _api_registerPlural = function(pluralName, singularName, val) {
        _Api.register(pluralName, val);
        _Api.register(singularName, function() {
            var ret = val.apply(this, arguments);
            if (ret === this) // Returned item is the API instance that was passed in, return it
            return this;
            else if (ret instanceof _Api) // New API instance returned, want the value from the first item
            // in the returned array for the singular result.
            return ret.length ? Array.isArray(ret[0]) ? new _Api(ret.context, ret[0]) : ret[0] : undefined;
            // Non-API return - just fire it back
            return ret;
        });
    };
    /**
	 * Selector for HTML tables. Apply the given selector to the give array of
	 * DataTables settings objects.
	 *
	 * @param {string|integer} [selector] jQuery selector string or integer
	 * @param  {array} Array of DataTables settings objects to be filtered
	 * @return {array}
	 * @ignore
	 */ var __table_selector = function(selector, a) {
        if (Array.isArray(selector)) return $.map(selector, function(item) {
            return __table_selector(item, a);
        });
        // Integer is used to pick out a table by index
        if (typeof selector === "number") return [
            a[selector]
        ];
        // Perform a jQuery selector on the table nodes
        var nodes = $.map(a, function(el, i) {
            return el.nTable;
        });
        return $(nodes).filter(selector).map(function(i) {
            // Need to translate back from the table node to the settings
            var idx = $.inArray(this, nodes);
            return a[idx];
        }).toArray();
    };
    /**
	 * Context selector for the API's context (i.e. the tables the API instance
	 * refers to.
	 *
	 * @name    DataTable.Api#tables
	 * @param {string|integer} [selector] Selector to pick which tables the iterator
	 *   should operate on. If not given, all tables in the current context are
	 *   used. This can be given as a jQuery selector (for example `':gt(0)'`) to
	 *   select multiple tables or as an integer to select a single table.
	 * @returns {DataTable.Api} Returns a new API instance if a selector is given.
	 */ _api_register("tables()", function(selector) {
        // A new instance is created if there was a selector specified
        return selector !== undefined && selector !== null ? new _Api(__table_selector(selector, this.context)) : this;
    });
    _api_register("table()", function(selector) {
        var tables = this.tables(selector);
        var ctx = tables.context;
        // Truncate to the first matched table
        return ctx.length ? new _Api(ctx[0]) : tables;
    });
    _api_registerPlural("tables().nodes()", "table().node()", function() {
        return this.iterator("table", function(ctx) {
            return ctx.nTable;
        }, 1);
    });
    _api_registerPlural("tables().body()", "table().body()", function() {
        return this.iterator("table", function(ctx) {
            return ctx.nTBody;
        }, 1);
    });
    _api_registerPlural("tables().header()", "table().header()", function() {
        return this.iterator("table", function(ctx) {
            return ctx.nTHead;
        }, 1);
    });
    _api_registerPlural("tables().footer()", "table().footer()", function() {
        return this.iterator("table", function(ctx) {
            return ctx.nTFoot;
        }, 1);
    });
    _api_registerPlural("tables().containers()", "table().container()", function() {
        return this.iterator("table", function(ctx) {
            return ctx.nTableWrapper;
        }, 1);
    });
    /**
	 * Redraw the tables in the current context.
	 */ _api_register("draw()", function(paging) {
        return this.iterator("table", function(settings) {
            if (paging === "page") _fnDraw(settings);
            else {
                if (typeof paging === "string") paging = paging === "full-hold" ? false : true;
                _fnReDraw(settings, paging === false);
            }
        });
    });
    /**
	 * Get the current page index.
	 *
	 * @return {integer} Current page index (zero based)
	 */ /**
	 * Set the current page.
	 *
	 * Note that if you attempt to show a page which does not exist, DataTables will
	 * not throw an error, but rather reset the paging.
	 *
	 * @param {integer|string} action The paging action to take. This can be one of:
	 *  * `integer` - The page index to jump to
	 *  * `string` - An action to take:
	 *    * `first` - Jump to first page.
	 *    * `next` - Jump to the next page
	 *    * `previous` - Jump to previous page
	 *    * `last` - Jump to the last page.
	 * @returns {DataTables.Api} this
	 */ _api_register("page()", function(action) {
        if (action === undefined) return this.page.info().page; // not an expensive call
        // else, have an action to take on all tables
        return this.iterator("table", function(settings) {
            _fnPageChange(settings, action);
        });
    });
    /**
	 * Paging information for the first table in the current context.
	 *
	 * If you require paging information for another table, use the `table()` method
	 * with a suitable selector.
	 *
	 * @return {object} Object with the following properties set:
	 *  * `page` - Current page index (zero based - i.e. the first page is `0`)
	 *  * `pages` - Total number of pages
	 *  * `start` - Display index for the first record shown on the current page
	 *  * `end` - Display index for the last record shown on the current page
	 *  * `length` - Display length (number of records). Note that generally `start
	 *    + length = end`, but this is not always true, for example if there are
	 *    only 2 records to show on the final page, with a length of 10.
	 *  * `recordsTotal` - Full data set length
	 *  * `recordsDisplay` - Data set length once the current filtering criterion
	 *    are applied.
	 */ _api_register("page.info()", function(action) {
        if (this.context.length === 0) return undefined;
        var settings = this.context[0], start = settings._iDisplayStart, len = settings.oFeatures.bPaginate ? settings._iDisplayLength : -1, visRecords = settings.fnRecordsDisplay(), all = len === -1;
        return {
            "page": all ? 0 : Math.floor(start / len),
            "pages": all ? 1 : Math.ceil(visRecords / len),
            "start": start,
            "end": settings.fnDisplayEnd(),
            "length": len,
            "recordsTotal": settings.fnRecordsTotal(),
            "recordsDisplay": visRecords,
            "serverSide": _fnDataSource(settings) === "ssp"
        };
    });
    /**
	 * Get the current page length.
	 *
	 * @return {integer} Current page length. Note `-1` indicates that all records
	 *   are to be shown.
	 */ /**
	 * Set the current page length.
	 *
	 * @param {integer} Page length to set. Use `-1` to show all records.
	 * @returns {DataTables.Api} this
	 */ _api_register("page.len()", function(len) {
        // Note that we can't call this function 'length()' because `length`
        // is a Javascript property of functions which defines how many arguments
        // the function expects.
        if (len === undefined) return this.context.length !== 0 ? this.context[0]._iDisplayLength : undefined;
        // else, set the page length
        return this.iterator("table", function(settings) {
            _fnLengthChange(settings, len);
        });
    });
    var __reload = function(settings, holdPosition, callback) {
        // Use the draw event to trigger a callback
        if (callback) {
            var api = new _Api(settings);
            api.one("draw", function() {
                callback(api.ajax.json());
            });
        }
        if (_fnDataSource(settings) == "ssp") _fnReDraw(settings, holdPosition);
        else {
            _fnProcessingDisplay(settings, true);
            // Cancel an existing request
            var xhr = settings.jqXHR;
            if (xhr && xhr.readyState !== 4) xhr.abort();
            // Trigger xhr
            _fnBuildAjax(settings, [], function(json) {
                _fnClearTable(settings);
                var data = _fnAjaxDataSrc(settings, json);
                for(var i = 0, ien = data.length; i < ien; i++)_fnAddData(settings, data[i]);
                _fnReDraw(settings, holdPosition);
                _fnProcessingDisplay(settings, false);
            });
        }
    };
    /**
	 * Get the JSON response from the last Ajax request that DataTables made to the
	 * server. Note that this returns the JSON from the first table in the current
	 * context.
	 *
	 * @return {object} JSON received from the server.
	 */ _api_register("ajax.json()", function() {
        var ctx = this.context;
        if (ctx.length > 0) return ctx[0].json;
    // else return undefined;
    });
    /**
	 * Get the data submitted in the last Ajax request
	 */ _api_register("ajax.params()", function() {
        var ctx = this.context;
        if (ctx.length > 0) return ctx[0].oAjaxData;
    // else return undefined;
    });
    /**
	 * Reload tables from the Ajax data source. Note that this function will
	 * automatically re-draw the table when the remote data has been loaded.
	 *
	 * @param {boolean} [reset=true] Reset (default) or hold the current paging
	 *   position. A full re-sort and re-filter is performed when this method is
	 *   called, which is why the pagination reset is the default action.
	 * @returns {DataTables.Api} this
	 */ _api_register("ajax.reload()", function(callback, resetPaging) {
        return this.iterator("table", function(settings) {
            __reload(settings, resetPaging === false, callback);
        });
    });
    /**
	 * Get the current Ajax URL. Note that this returns the URL from the first
	 * table in the current context.
	 *
	 * @return {string} Current Ajax source URL
	 */ /**
	 * Set the Ajax URL. Note that this will set the URL for all tables in the
	 * current context.
	 *
	 * @param {string} url URL to set.
	 * @returns {DataTables.Api} this
	 */ _api_register("ajax.url()", function(url) {
        var ctx = this.context;
        if (url === undefined) {
            // get
            if (ctx.length === 0) return undefined;
            ctx = ctx[0];
            return ctx.ajax ? $.isPlainObject(ctx.ajax) ? ctx.ajax.url : ctx.ajax : ctx.sAjaxSource;
        }
        // set
        return this.iterator("table", function(settings) {
            if ($.isPlainObject(settings.ajax)) settings.ajax.url = url;
            else settings.ajax = url;
        // No need to consider sAjaxSource here since DataTables gives priority
        // to `ajax` over `sAjaxSource`. So setting `ajax` here, renders any
        // value of `sAjaxSource` redundant.
        });
    });
    /**
	 * Load data from the newly set Ajax URL. Note that this method is only
	 * available when `ajax.url()` is used to set a URL. Additionally, this method
	 * has the same effect as calling `ajax.reload()` but is provided for
	 * convenience when setting a new URL. Like `ajax.reload()` it will
	 * automatically redraw the table once the remote data has been loaded.
	 *
	 * @returns {DataTables.Api} this
	 */ _api_register("ajax.url().load()", function(callback, resetPaging) {
        // Same as a reload, but makes sense to present it for easy access after a
        // url change
        return this.iterator("table", function(ctx) {
            __reload(ctx, resetPaging === false, callback);
        });
    });
    var _selector_run = function(type, selector, selectFn, settings, opts) {
        var out = [], res, a, i, ien, j, jen, selectorType = typeof selector;
        // Can't just check for isArray here, as an API or jQuery instance might be
        // given with their array like look
        if (!selector || selectorType === "string" || selectorType === "function" || selector.length === undefined) selector = [
            selector
        ];
        for(i = 0, ien = selector.length; i < ien; i++){
            // Only split on simple strings - complex expressions will be jQuery selectors
            a = selector[i] && selector[i].split && !selector[i].match(/[\[\(:]/) ? selector[i].split(",") : [
                selector[i]
            ];
            for(j = 0, jen = a.length; j < jen; j++){
                res = selectFn(typeof a[j] === "string" ? a[j].trim() : a[j]);
                if (res && res.length) out = out.concat(res);
            }
        }
        // selector extensions
        var ext = _ext.selector[type];
        if (ext.length) for(i = 0, ien = ext.length; i < ien; i++)out = ext[i](settings, opts, out);
        return _unique(out);
    };
    var _selector_opts = function(opts) {
        if (!opts) opts = {};
        // Backwards compatibility for 1.9- which used the terminology filter rather
        // than search
        if (opts.filter && opts.search === undefined) opts.search = opts.filter;
        return $.extend({
            search: "none",
            order: "current",
            page: "all"
        }, opts);
    };
    var _selector_first = function(inst) {
        // Reduce the API instance to the first item found
        for(var i = 0, ien = inst.length; i < ien; i++)if (inst[i].length > 0) {
            // Assign the first element to the first item in the instance
            // and truncate the instance and context
            inst[0] = inst[i];
            inst[0].length = 1;
            inst.length = 1;
            inst.context = [
                inst.context[i]
            ];
            return inst;
        }
        // Not found - return an empty instance
        inst.length = 0;
        return inst;
    };
    var _selector_row_indexes = function(settings, opts) {
        var i, ien, tmp, a = [], displayFiltered = settings.aiDisplay, displayMaster = settings.aiDisplayMaster;
        var search = opts.search, order = opts.order, page = opts.page; // all, current
        if (_fnDataSource(settings) == "ssp") // In server-side processing mode, most options are irrelevant since
        // rows not shown don't exist and the index order is the applied order
        // Removed is a special case - for consistency just return an empty
        // array
        return search === "removed" ? [] : _range(0, displayMaster.length);
        else if (page == "current") // Current page implies that order=current and filter=applied, since it is
        // fairly senseless otherwise, regardless of what order and search actually
        // are
        for(i = settings._iDisplayStart, ien = settings.fnDisplayEnd(); i < ien; i++)a.push(displayFiltered[i]);
        else if (order == "current" || order == "applied") {
            if (search == "none") a = displayMaster.slice();
            else if (search == "applied") a = displayFiltered.slice();
            else if (search == "removed") {
                // O(n+m) solution by creating a hash map
                var displayFilteredMap = {};
                for(var i = 0, ien = displayFiltered.length; i < ien; i++)displayFilteredMap[displayFiltered[i]] = null;
                a = $.map(displayMaster, function(el) {
                    return !displayFilteredMap.hasOwnProperty(el) ? el : null;
                });
            }
        } else if (order == "index" || order == "original") {
            for(i = 0, ien = settings.aoData.length; i < ien; i++)if (search == "none") a.push(i);
            else {
                tmp = $.inArray(i, displayFiltered);
                if (tmp === -1 && search == "removed" || tmp >= 0 && search == "applied") a.push(i);
            }
        }
        return a;
    };
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Rows
	 *
	 * {}          - no selector - use all available rows
	 * {integer}   - row aoData index
	 * {node}      - TR node
	 * {string}    - jQuery selector to apply to the TR elements
	 * {array}     - jQuery array of nodes, or simply an array of TR nodes
	 *
	 */ var __row_selector = function(settings, selector, opts) {
        var rows;
        var run = function(sel) {
            var selInt = _intVal(sel);
            var i, ien;
            var aoData = settings.aoData;
            // Short cut - selector is a number and no options provided (default is
            // all records, so no need to check if the index is in there, since it
            // must be - dev error if the index doesn't exist).
            if (selInt !== null && !opts) return [
                selInt
            ];
            if (!rows) rows = _selector_row_indexes(settings, opts);
            if (selInt !== null && $.inArray(selInt, rows) !== -1) // Selector - integer
            return [
                selInt
            ];
            else if (sel === null || sel === undefined || sel === "") // Selector - none
            return rows;
            // Selector - function
            if (typeof sel === "function") return $.map(rows, function(idx) {
                var row = aoData[idx];
                return sel(idx, row._aData, row.nTr) ? idx : null;
            });
            // Selector - node
            if (sel.nodeName) {
                var rowIdx = sel._DT_RowIndex; // Property added by DT for fast lookup
                var cellIdx = sel._DT_CellIndex;
                if (rowIdx !== undefined) // Make sure that the row is actually still present in the table
                return aoData[rowIdx] && aoData[rowIdx].nTr === sel ? [
                    rowIdx
                ] : [];
                else if (cellIdx) return aoData[cellIdx.row] && aoData[cellIdx.row].nTr === sel.parentNode ? [
                    cellIdx.row
                ] : [];
                else {
                    var host = $(sel).closest("*[data-dt-row]");
                    return host.length ? [
                        host.data("dt-row")
                    ] : [];
                }
            }
            // ID selector. Want to always be able to select rows by id, regardless
            // of if the tr element has been created or not, so can't rely upon
            // jQuery here - hence a custom implementation. This does not match
            // Sizzle's fast selector or HTML4 - in HTML5 the ID can be anything,
            // but to select it using a CSS selector engine (like Sizzle or
            // querySelect) it would need to need to be escaped for some characters.
            // DataTables simplifies this for row selectors since you can select
            // only a row. A # indicates an id any anything that follows is the id -
            // unescaped.
            if (typeof sel === "string" && sel.charAt(0) === "#") {
                // get row index from id
                var rowObj = settings.aIds[sel.replace(/^#/, "")];
                if (rowObj !== undefined) return [
                    rowObj.idx
                ];
            // need to fall through to jQuery in case there is DOM id that
            // matches
            }
            // Get nodes in the order from the `rows` array with null values removed
            var nodes = _removeEmpty(_pluck_order(settings.aoData, rows, "nTr"));
            // Selector - jQuery selector string, array of nodes or jQuery object/
            // As jQuery's .filter() allows jQuery objects to be passed in filter,
            // it also allows arrays, so this will cope with all three options
            return $(nodes).filter(sel).map(function() {
                return this._DT_RowIndex;
            }).toArray();
        };
        return _selector_run("row", selector, run, settings, opts);
    };
    _api_register("rows()", function(selector, opts) {
        // argument shifting
        if (selector === undefined) selector = "";
        else if ($.isPlainObject(selector)) {
            opts = selector;
            selector = "";
        }
        opts = _selector_opts(opts);
        var inst = this.iterator("table", function(settings) {
            return __row_selector(settings, selector, opts);
        }, 1);
        // Want argument shifting here and in __row_selector?
        inst.selector.rows = selector;
        inst.selector.opts = opts;
        return inst;
    });
    _api_register("rows().nodes()", function() {
        return this.iterator("row", function(settings, row) {
            return settings.aoData[row].nTr || undefined;
        }, 1);
    });
    _api_register("rows().data()", function() {
        return this.iterator(true, "rows", function(settings, rows) {
            return _pluck_order(settings.aoData, rows, "_aData");
        }, 1);
    });
    _api_registerPlural("rows().cache()", "row().cache()", function(type) {
        return this.iterator("row", function(settings, row) {
            var r = settings.aoData[row];
            return type === "search" ? r._aFilterData : r._aSortData;
        }, 1);
    });
    _api_registerPlural("rows().invalidate()", "row().invalidate()", function(src) {
        return this.iterator("row", function(settings, row) {
            _fnInvalidate(settings, row, src);
        });
    });
    _api_registerPlural("rows().indexes()", "row().index()", function() {
        return this.iterator("row", function(settings, row) {
            return row;
        }, 1);
    });
    _api_registerPlural("rows().ids()", "row().id()", function(hash) {
        var a = [];
        var context = this.context;
        // `iterator` will drop undefined values, but in this case we want them
        for(var i = 0, ien = context.length; i < ien; i++)for(var j = 0, jen = this[i].length; j < jen; j++){
            var id = context[i].rowIdFn(context[i].aoData[this[i][j]]._aData);
            a.push((hash === true ? "#" : "") + id);
        }
        return new _Api(context, a);
    });
    _api_registerPlural("rows().remove()", "row().remove()", function() {
        var that = this;
        this.iterator("row", function(settings, row, thatIdx) {
            var data = settings.aoData;
            var rowData = data[row];
            var i, ien, j, jen;
            var loopRow, loopCells;
            data.splice(row, 1);
            // Update the cached indexes
            for(i = 0, ien = data.length; i < ien; i++){
                loopRow = data[i];
                loopCells = loopRow.anCells;
                // Rows
                if (loopRow.nTr !== null) loopRow.nTr._DT_RowIndex = i;
                // Cells
                if (loopCells !== null) for(j = 0, jen = loopCells.length; j < jen; j++)loopCells[j]._DT_CellIndex.row = i;
            }
            // Delete from the display arrays
            _fnDeleteIndex(settings.aiDisplayMaster, row);
            _fnDeleteIndex(settings.aiDisplay, row);
            _fnDeleteIndex(that[thatIdx], row, false); // maintain local indexes
            // For server-side processing tables - subtract the deleted row from the count
            if (settings._iRecordsDisplay > 0) settings._iRecordsDisplay--;
            // Check for an 'overflow' they case for displaying the table
            _fnLengthOverflow(settings);
            // Remove the row's ID reference if there is one
            var id = settings.rowIdFn(rowData._aData);
            if (id !== undefined) delete settings.aIds[id];
        });
        this.iterator("table", function(settings) {
            for(var i = 0, ien = settings.aoData.length; i < ien; i++)settings.aoData[i].idx = i;
        });
        return this;
    });
    _api_register("rows.add()", function(rows) {
        var newRows = this.iterator("table", function(settings) {
            var row, i, ien;
            var out = [];
            for(i = 0, ien = rows.length; i < ien; i++){
                row = rows[i];
                if (row.nodeName && row.nodeName.toUpperCase() === "TR") out.push(_fnAddTr(settings, row)[0]);
                else out.push(_fnAddData(settings, row));
            }
            return out;
        }, 1);
        // Return an Api.rows() extended instance, so rows().nodes() etc can be used
        var modRows = this.rows(-1);
        modRows.pop();
        $.merge(modRows, newRows);
        return modRows;
    });
    /**
	 *
	 */ _api_register("row()", function(selector, opts) {
        return _selector_first(this.rows(selector, opts));
    });
    _api_register("row().data()", function(data) {
        var ctx = this.context;
        if (data === undefined) // Get
        return ctx.length && this.length ? ctx[0].aoData[this[0]]._aData : undefined;
        // Set
        var row = ctx[0].aoData[this[0]];
        row._aData = data;
        // If the DOM has an id, and the data source is an array
        if (Array.isArray(data) && row.nTr && row.nTr.id) _fnSetObjectDataFn(ctx[0].rowId)(data, row.nTr.id);
        // Automatically invalidate
        _fnInvalidate(ctx[0], this[0], "data");
        return this;
    });
    _api_register("row().node()", function() {
        var ctx = this.context;
        return ctx.length && this.length ? ctx[0].aoData[this[0]].nTr || null : null;
    });
    _api_register("row.add()", function(row) {
        // Allow a jQuery object to be passed in - only a single row is added from
        // it though - the first element in the set
        if (row instanceof $ && row.length) row = row[0];
        var rows = this.iterator("table", function(settings) {
            if (row.nodeName && row.nodeName.toUpperCase() === "TR") return _fnAddTr(settings, row)[0];
            return _fnAddData(settings, row);
        });
        // Return an Api.rows() extended instance, with the newly added row selected
        return this.row(rows[0]);
    });
    $(document1).on("plugin-init.dt", function(e, context) {
        var api = new _Api(context);
        api.on("stateSaveParams", function(e, settings, d) {
            // This could be more compact with the API, but it is a lot faster as a simple
            // internal loop
            var idFn = settings.rowIdFn;
            var data = settings.aoData;
            var ids = [];
            for(var i = 0; i < data.length; i++)if (data[i]._detailsShow) ids.push("#" + idFn(data[i]._aData));
            d.childRows = ids;
        });
        var loaded = api.state.loaded();
        if (loaded && loaded.childRows) api.rows($.map(loaded.childRows, function(id) {
            return id.replace(/:/g, "\\:");
        })).every(function() {
            _fnCallbackFire(context, null, "requestChild", [
                this
            ]);
        });
    });
    var __details_add = function(ctx, row, data, klass) {
        // Convert to array of TR elements
        var rows = [];
        var addRow = function(r, k) {
            // Recursion to allow for arrays of jQuery objects
            if (Array.isArray(r) || r instanceof $) {
                for(var i = 0, ien = r.length; i < ien; i++)addRow(r[i], k);
                return;
            }
            // If we get a TR element, then just add it directly - up to the dev
            // to add the correct number of columns etc
            if (r.nodeName && r.nodeName.toLowerCase() === "tr") rows.push(r);
            else {
                // Otherwise create a row with a wrapper
                var created = $("<tr><td></td></tr>").addClass(k);
                $("td", created).addClass(k).html(r)[0].colSpan = _fnVisbleColumns(ctx);
                rows.push(created[0]);
            }
        };
        addRow(data, klass);
        if (row._details) row._details.detach();
        row._details = $(rows);
        // If the children were already shown, that state should be retained
        if (row._detailsShow) row._details.insertAfter(row.nTr);
    };
    // Make state saving of child row details async to allow them to be batch processed
    var __details_state = DataTable.util.throttle(function(ctx) {
        _fnSaveState(ctx[0]);
    }, 500);
    var __details_remove = function(api, idx) {
        var ctx = api.context;
        if (ctx.length) {
            var row = ctx[0].aoData[idx !== undefined ? idx : api[0]];
            if (row && row._details) {
                row._details.remove();
                row._detailsShow = undefined;
                row._details = undefined;
                $(row.nTr).removeClass("dt-hasChild");
                __details_state(ctx);
            }
        }
    };
    var __details_display = function(api, show) {
        var ctx = api.context;
        if (ctx.length && api.length) {
            var row = ctx[0].aoData[api[0]];
            if (row._details) {
                row._detailsShow = show;
                if (show) {
                    row._details.insertAfter(row.nTr);
                    $(row.nTr).addClass("dt-hasChild");
                } else {
                    row._details.detach();
                    $(row.nTr).removeClass("dt-hasChild");
                }
                _fnCallbackFire(ctx[0], null, "childRow", [
                    show,
                    api.row(api[0])
                ]);
                __details_events(ctx[0]);
                __details_state(ctx);
            }
        }
    };
    var __details_events = function(settings) {
        var api = new _Api(settings);
        var namespace = ".dt.DT_details";
        var drawEvent = "draw" + namespace;
        var colvisEvent = "column-sizing" + namespace;
        var destroyEvent = "destroy" + namespace;
        var data = settings.aoData;
        api.off(drawEvent + " " + colvisEvent + " " + destroyEvent);
        if (_pluck(data, "_details").length > 0) {
            // On each draw, insert the required elements into the document
            api.on(drawEvent, function(e, ctx) {
                if (settings !== ctx) return;
                api.rows({
                    page: "current"
                }).eq(0).each(function(idx) {
                    // Internal data grab
                    var row = data[idx];
                    if (row._detailsShow) row._details.insertAfter(row.nTr);
                });
            });
            // Column visibility change - update the colspan
            api.on(colvisEvent, function(e, ctx, idx, vis) {
                if (settings !== ctx) return;
                // Update the colspan for the details rows (note, only if it already has
                // a colspan)
                var row, visible = _fnVisbleColumns(ctx);
                for(var i = 0, ien = data.length; i < ien; i++){
                    row = data[i];
                    if (row._details) row._details.children("td[colspan]").attr("colspan", visible);
                }
            });
            // Table destroyed - nuke any child rows
            api.on(destroyEvent, function(e, ctx) {
                if (settings !== ctx) return;
                for(var i = 0, ien = data.length; i < ien; i++)if (data[i]._details) __details_remove(api, i);
            });
        }
    };
    // Strings for the method names to help minification
    var _emp = "";
    var _child_obj = _emp + "row().child";
    var _child_mth = _child_obj + "()";
    // data can be:
    //  tr
    //  string
    //  jQuery or array of any of the above
    _api_register(_child_mth, function(data, klass) {
        var ctx = this.context;
        if (data === undefined) // get
        return ctx.length && this.length ? ctx[0].aoData[this[0]]._details : undefined;
        else if (data === true) // show
        this.child.show();
        else if (data === false) // remove
        __details_remove(this);
        else if (ctx.length && this.length) // set
        __details_add(ctx[0], ctx[0].aoData[this[0]], data, klass);
        return this;
    });
    _api_register([
        _child_obj + ".show()",
        _child_mth + ".show()" // only when `child()` was called with parameters (without
    ], function(show) {
        __details_display(this, true);
        return this;
    });
    _api_register([
        _child_obj + ".hide()",
        _child_mth + ".hide()" // only when `child()` was called with parameters (without
    ], function() {
        __details_display(this, false);
        return this;
    });
    _api_register([
        _child_obj + ".remove()",
        _child_mth + ".remove()" // only when `child()` was called with parameters (without
    ], function() {
        __details_remove(this);
        return this;
    });
    _api_register(_child_obj + ".isShown()", function() {
        var ctx = this.context;
        if (ctx.length && this.length) // _detailsShown as false or undefined will fall through to return false
        return ctx[0].aoData[this[0]]._detailsShow || false;
        return false;
    });
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Columns
	 *
	 * {integer}           - column index (>=0 count from left, <0 count from right)
	 * "{integer}:visIdx"  - visible column index (i.e. translate to column index)  (>=0 count from left, <0 count from right)
	 * "{integer}:visible" - alias for {integer}:visIdx  (>=0 count from left, <0 count from right)
	 * "{string}:name"     - column name
	 * "{string}"          - jQuery selector on column header nodes
	 *
	 */ // can be an array of these items, comma separated list, or an array of comma
    // separated lists
    var __re_column_selector = /^([^:]+):(name|visIdx|visible)$/;
    // r1 and r2 are redundant - but it means that the parameters match for the
    // iterator callback in columns().data()
    var __columnData = function(settings, column, r1, r2, rows) {
        var a = [];
        for(var row = 0, ien = rows.length; row < ien; row++)a.push(_fnGetCellData(settings, rows[row], column));
        return a;
    };
    var __column_selector = function(settings, selector, opts) {
        var columns = settings.aoColumns, names = _pluck(columns, "sName"), nodes = _pluck(columns, "nTh");
        var run = function(s) {
            var selInt = _intVal(s);
            // Selector - all
            if (s === "") return _range(columns.length);
            // Selector - index
            if (selInt !== null) return [
                selInt >= 0 ? selInt : columns.length + selInt // Count from right (+ because its a negative value)
            ];
            // Selector = function
            if (typeof s === "function") {
                var rows = _selector_row_indexes(settings, opts);
                return $.map(columns, function(col, idx) {
                    return s(idx, __columnData(settings, idx, 0, 0, rows), nodes[idx]) ? idx : null;
                });
            }
            // jQuery or string selector
            var match = typeof s === "string" ? s.match(__re_column_selector) : "";
            if (match) switch(match[2]){
                case "visIdx":
                case "visible":
                    var idx = parseInt(match[1], 10);
                    // Visible index given, convert to column index
                    if (idx < 0) {
                        // Counting from the right
                        var visColumns = $.map(columns, function(col, i) {
                            return col.bVisible ? i : null;
                        });
                        return [
                            visColumns[visColumns.length + idx]
                        ];
                    }
                    // Counting from the left
                    return [
                        _fnVisibleToColumnIndex(settings, idx)
                    ];
                case "name":
                    // match by name. `names` is column index complete and in order
                    return $.map(names, function(name, i) {
                        return name === match[1] ? i : null;
                    });
                default:
                    return [];
            }
            // Cell in the table body
            if (s.nodeName && s._DT_CellIndex) return [
                s._DT_CellIndex.column
            ];
            // jQuery selector on the TH elements for the columns
            var jqResult = $(nodes).filter(s).map(function() {
                return $.inArray(this, nodes); // `nodes` is column index complete and in order
            }).toArray();
            if (jqResult.length || !s.nodeName) return jqResult;
            // Otherwise a node which might have a `dt-column` data attribute, or be
            // a child or such an element
            var host = $(s).closest("*[data-dt-column]");
            return host.length ? [
                host.data("dt-column")
            ] : [];
        };
        return _selector_run("column", selector, run, settings, opts);
    };
    var __setColumnVis = function(settings, column, vis) {
        var cols = settings.aoColumns, col = cols[column], data = settings.aoData, row, cells, i, ien, tr;
        // Get
        if (vis === undefined) return col.bVisible;
        // Set
        // No change
        if (col.bVisible === vis) return;
        if (vis) {
            // Insert column
            // Need to decide if we should use appendChild or insertBefore
            var insertBefore = $.inArray(true, _pluck(cols, "bVisible"), column + 1);
            for(i = 0, ien = data.length; i < ien; i++){
                tr = data[i].nTr;
                cells = data[i].anCells;
                if (tr) // insertBefore can act like appendChild if 2nd arg is null
                tr.insertBefore(cells[column], cells[insertBefore] || null);
            }
        } else // Remove column
        $(_pluck(settings.aoData, "anCells", column)).detach();
        // Common actions
        col.bVisible = vis;
    };
    _api_register("columns()", function(selector, opts) {
        // argument shifting
        if (selector === undefined) selector = "";
        else if ($.isPlainObject(selector)) {
            opts = selector;
            selector = "";
        }
        opts = _selector_opts(opts);
        var inst = this.iterator("table", function(settings) {
            return __column_selector(settings, selector, opts);
        }, 1);
        // Want argument shifting here and in _row_selector?
        inst.selector.cols = selector;
        inst.selector.opts = opts;
        return inst;
    });
    _api_registerPlural("columns().header()", "column().header()", function(selector, opts) {
        return this.iterator("column", function(settings, column) {
            return settings.aoColumns[column].nTh;
        }, 1);
    });
    _api_registerPlural("columns().footer()", "column().footer()", function(selector, opts) {
        return this.iterator("column", function(settings, column) {
            return settings.aoColumns[column].nTf;
        }, 1);
    });
    _api_registerPlural("columns().data()", "column().data()", function() {
        return this.iterator("column-rows", __columnData, 1);
    });
    _api_registerPlural("columns().dataSrc()", "column().dataSrc()", function() {
        return this.iterator("column", function(settings, column) {
            return settings.aoColumns[column].mData;
        }, 1);
    });
    _api_registerPlural("columns().cache()", "column().cache()", function(type) {
        return this.iterator("column-rows", function(settings, column, i, j, rows) {
            return _pluck_order(settings.aoData, rows, type === "search" ? "_aFilterData" : "_aSortData", column);
        }, 1);
    });
    _api_registerPlural("columns().nodes()", "column().nodes()", function() {
        return this.iterator("column-rows", function(settings, column, i, j, rows) {
            return _pluck_order(settings.aoData, rows, "anCells", column);
        }, 1);
    });
    _api_registerPlural("columns().visible()", "column().visible()", function(vis, calc) {
        var that = this;
        var ret = this.iterator("column", function(settings, column) {
            if (vis === undefined) return settings.aoColumns[column].bVisible;
             // else
            __setColumnVis(settings, column, vis);
        });
        // Group the column visibility changes
        if (vis !== undefined) this.iterator("table", function(settings) {
            // Redraw the header after changes
            _fnDrawHead(settings, settings.aoHeader);
            _fnDrawHead(settings, settings.aoFooter);
            // Update colspan for no records display. Child rows and extensions will use their own
            // listeners to do this - only need to update the empty table item here
            if (!settings.aiDisplay.length) $(settings.nTBody).find("td[colspan]").attr("colspan", _fnVisbleColumns(settings));
            _fnSaveState(settings);
            // Second loop once the first is done for events
            that.iterator("column", function(settings, column) {
                _fnCallbackFire(settings, null, "column-visibility", [
                    settings,
                    column,
                    vis,
                    calc
                ]);
            });
            if (calc === undefined || calc) that.columns.adjust();
        });
        return ret;
    });
    _api_registerPlural("columns().indexes()", "column().index()", function(type) {
        return this.iterator("column", function(settings, column) {
            return type === "visible" ? _fnColumnIndexToVisible(settings, column) : column;
        }, 1);
    });
    _api_register("columns.adjust()", function() {
        return this.iterator("table", function(settings) {
            _fnAdjustColumnSizing(settings);
        }, 1);
    });
    _api_register("column.index()", function(type, idx) {
        if (this.context.length !== 0) {
            var ctx = this.context[0];
            if (type === "fromVisible" || type === "toData") return _fnVisibleToColumnIndex(ctx, idx);
            else if (type === "fromData" || type === "toVisible") return _fnColumnIndexToVisible(ctx, idx);
        }
    });
    _api_register("column()", function(selector, opts) {
        return _selector_first(this.columns(selector, opts));
    });
    var __cell_selector = function(settings, selector, opts) {
        var data = settings.aoData;
        var rows = _selector_row_indexes(settings, opts);
        var cells = _removeEmpty(_pluck_order(data, rows, "anCells"));
        var allCells = $(_flatten([], cells));
        var row;
        var columns = settings.aoColumns.length;
        var a, i, ien, j, o, host;
        var run = function(s) {
            var fnSelector = typeof s === "function";
            if (s === null || s === undefined || fnSelector) {
                // All cells and function selectors
                a = [];
                for(i = 0, ien = rows.length; i < ien; i++){
                    row = rows[i];
                    for(j = 0; j < columns; j++){
                        o = {
                            row: row,
                            column: j
                        };
                        if (fnSelector) {
                            // Selector - function
                            host = data[row];
                            if (s(o, _fnGetCellData(settings, row, j), host.anCells ? host.anCells[j] : null)) a.push(o);
                        } else // Selector - all
                        a.push(o);
                    }
                }
                return a;
            }
            // Selector - index
            if ($.isPlainObject(s)) // Valid cell index and its in the array of selectable rows
            return s.column !== undefined && s.row !== undefined && $.inArray(s.row, rows) !== -1 ? [
                s
            ] : [];
            // Selector - jQuery filtered cells
            var jqResult = allCells.filter(s).map(function(i, el) {
                return {
                    row: el._DT_CellIndex.row,
                    column: el._DT_CellIndex.column
                };
            }).toArray();
            if (jqResult.length || !s.nodeName) return jqResult;
            // Otherwise the selector is a node, and there is one last option - the
            // element might be a child of an element which has dt-row and dt-column
            // data attributes
            host = $(s).closest("*[data-dt-row]");
            return host.length ? [
                {
                    row: host.data("dt-row"),
                    column: host.data("dt-column")
                }
            ] : [];
        };
        return _selector_run("cell", selector, run, settings, opts);
    };
    _api_register("cells()", function(rowSelector, columnSelector, opts) {
        // Argument shifting
        if ($.isPlainObject(rowSelector)) {
            // Indexes
            if (rowSelector.row === undefined) {
                // Selector options in first parameter
                opts = rowSelector;
                rowSelector = null;
            } else {
                // Cell index objects in first parameter
                opts = columnSelector;
                columnSelector = null;
            }
        }
        if ($.isPlainObject(columnSelector)) {
            opts = columnSelector;
            columnSelector = null;
        }
        // Cell selector
        if (columnSelector === null || columnSelector === undefined) return this.iterator("table", function(settings) {
            return __cell_selector(settings, rowSelector, _selector_opts(opts));
        });
        // The default built in options need to apply to row and columns
        var internalOpts = opts ? {
            page: opts.page,
            order: opts.order,
            search: opts.search
        } : {};
        // Row + column selector
        var columns = this.columns(columnSelector, internalOpts);
        var rows = this.rows(rowSelector, internalOpts);
        var i, ien, j, jen;
        var cellsNoOpts = this.iterator("table", function(settings, idx) {
            var a = [];
            for(i = 0, ien = rows[idx].length; i < ien; i++)for(j = 0, jen = columns[idx].length; j < jen; j++)a.push({
                row: rows[idx][i],
                column: columns[idx][j]
            });
            return a;
        }, 1);
        // There is currently only one extension which uses a cell selector extension
        // It is a _major_ performance drag to run this if it isn't needed, so this is
        // an extension specific check at the moment
        var cells = opts && opts.selected ? this.cells(cellsNoOpts, opts) : cellsNoOpts;
        $.extend(cells.selector, {
            cols: columnSelector,
            rows: rowSelector,
            opts: opts
        });
        return cells;
    });
    _api_registerPlural("cells().nodes()", "cell().node()", function() {
        return this.iterator("cell", function(settings, row, column) {
            var data = settings.aoData[row];
            return data && data.anCells ? data.anCells[column] : undefined;
        }, 1);
    });
    _api_register("cells().data()", function() {
        return this.iterator("cell", function(settings, row, column) {
            return _fnGetCellData(settings, row, column);
        }, 1);
    });
    _api_registerPlural("cells().cache()", "cell().cache()", function(type) {
        type = type === "search" ? "_aFilterData" : "_aSortData";
        return this.iterator("cell", function(settings, row, column) {
            return settings.aoData[row][type][column];
        }, 1);
    });
    _api_registerPlural("cells().render()", "cell().render()", function(type) {
        return this.iterator("cell", function(settings, row, column) {
            return _fnGetCellData(settings, row, column, type);
        }, 1);
    });
    _api_registerPlural("cells().indexes()", "cell().index()", function() {
        return this.iterator("cell", function(settings, row, column) {
            return {
                row: row,
                column: column,
                columnVisible: _fnColumnIndexToVisible(settings, column)
            };
        }, 1);
    });
    _api_registerPlural("cells().invalidate()", "cell().invalidate()", function(src) {
        return this.iterator("cell", function(settings, row, column) {
            _fnInvalidate(settings, row, src, column);
        });
    });
    _api_register("cell()", function(rowSelector, columnSelector, opts) {
        return _selector_first(this.cells(rowSelector, columnSelector, opts));
    });
    _api_register("cell().data()", function(data) {
        var ctx = this.context;
        var cell = this[0];
        if (data === undefined) // Get
        return ctx.length && cell.length ? _fnGetCellData(ctx[0], cell[0].row, cell[0].column) : undefined;
        // Set
        _fnSetCellData(ctx[0], cell[0].row, cell[0].column, data);
        _fnInvalidate(ctx[0], cell[0].row, "data", cell[0].column);
        return this;
    });
    /**
	 * Get current ordering (sorting) that has been applied to the table.
	 *
	 * @returns {array} 2D array containing the sorting information for the first
	 *   table in the current context. Each element in the parent array represents
	 *   a column being sorted upon (i.e. multi-sorting with two columns would have
	 *   2 inner arrays). The inner arrays may have 2 or 3 elements. The first is
	 *   the column index that the sorting condition applies to, the second is the
	 *   direction of the sort (`desc` or `asc`) and, optionally, the third is the
	 *   index of the sorting order from the `column.sorting` initialisation array.
	 */ /**
	 * Set the ordering for the table.
	 *
	 * @param {integer} order Column index to sort upon.
	 * @param {string} direction Direction of the sort to be applied (`asc` or `desc`)
	 * @returns {DataTables.Api} this
	 */ /**
	 * Set the ordering for the table.
	 *
	 * @param {array} order 1D array of sorting information to be applied.
	 * @param {array} [...] Optional additional sorting conditions
	 * @returns {DataTables.Api} this
	 */ /**
	 * Set the ordering for the table.
	 *
	 * @param {array} order 2D array of sorting information to be applied.
	 * @returns {DataTables.Api} this
	 */ _api_register("order()", function(order, dir) {
        var ctx = this.context;
        if (order === undefined) // get
        return ctx.length !== 0 ? ctx[0].aaSorting : undefined;
        // set
        if (typeof order === "number") // Simple column / direction passed in
        order = [
            [
                order,
                dir
            ]
        ];
        else if (order.length && !Array.isArray(order[0])) // Arguments passed in (list of 1D arrays)
        order = Array.prototype.slice.call(arguments);
        // otherwise a 2D array was passed in
        return this.iterator("table", function(settings) {
            settings.aaSorting = order.slice();
        });
    });
    /**
	 * Attach a sort listener to an element for a given column
	 *
	 * @param {node|jQuery|string} node Identifier for the element(s) to attach the
	 *   listener to. This can take the form of a single DOM node, a jQuery
	 *   collection of nodes or a jQuery selector which will identify the node(s).
	 * @param {integer} column the column that a click on this node will sort on
	 * @param {function} [callback] callback function when sort is run
	 * @returns {DataTables.Api} this
	 */ _api_register("order.listener()", function(node, column, callback) {
        return this.iterator("table", function(settings) {
            _fnSortAttachListener(settings, node, column, callback);
        });
    });
    _api_register("order.fixed()", function(set) {
        if (!set) {
            var ctx = this.context;
            var fixed = ctx.length ? ctx[0].aaSortingFixed : undefined;
            return Array.isArray(fixed) ? {
                pre: fixed
            } : fixed;
        }
        return this.iterator("table", function(settings) {
            settings.aaSortingFixed = $.extend(true, {}, set);
        });
    });
    // Order by the selected column(s)
    _api_register([
        "columns().order()",
        "column().order()"
    ], function(dir) {
        var that = this;
        return this.iterator("table", function(settings, i) {
            var sort = [];
            $.each(that[i], function(j, col) {
                sort.push([
                    col,
                    dir
                ]);
            });
            settings.aaSorting = sort;
        });
    });
    _api_register("search()", function(input, regex, smart, caseInsen) {
        var ctx = this.context;
        if (input === undefined) // get
        return ctx.length !== 0 ? ctx[0].oPreviousSearch.sSearch : undefined;
        // set
        return this.iterator("table", function(settings) {
            if (!settings.oFeatures.bFilter) return;
            _fnFilterComplete(settings, $.extend({}, settings.oPreviousSearch, {
                "sSearch": input + "",
                "bRegex": regex === null ? false : regex,
                "bSmart": smart === null ? true : smart,
                "bCaseInsensitive": caseInsen === null ? true : caseInsen
            }), 1);
        });
    });
    _api_registerPlural("columns().search()", "column().search()", function(input, regex, smart, caseInsen) {
        return this.iterator("column", function(settings, column) {
            var preSearch = settings.aoPreSearchCols;
            if (input === undefined) // get
            return preSearch[column].sSearch;
            // set
            if (!settings.oFeatures.bFilter) return;
            $.extend(preSearch[column], {
                "sSearch": input + "",
                "bRegex": regex === null ? false : regex,
                "bSmart": smart === null ? true : smart,
                "bCaseInsensitive": caseInsen === null ? true : caseInsen
            });
            _fnFilterComplete(settings, settings.oPreviousSearch, 1);
        });
    });
    /*
	 * State API methods
	 */ _api_register("state()", function() {
        return this.context.length ? this.context[0].oSavedState : null;
    });
    _api_register("state.clear()", function() {
        return this.iterator("table", function(settings) {
            // Save an empty object
            settings.fnStateSaveCallback.call(settings.oInstance, settings, {});
        });
    });
    _api_register("state.loaded()", function() {
        return this.context.length ? this.context[0].oLoadedState : null;
    });
    _api_register("state.save()", function() {
        return this.iterator("table", function(settings) {
            _fnSaveState(settings);
        });
    });
    /**
	 * Provide a common method for plug-ins to check the version of DataTables being
	 * used, in order to ensure compatibility.
	 *
	 *  @param {string} version Version string to check for, in the format "X.Y.Z".
	 *    Note that the formats "X" and "X.Y" are also acceptable.
	 *  @returns {boolean} true if this version of DataTables is greater or equal to
	 *    the required version, or false if this version of DataTales is not
	 *    suitable
	 *  @static
	 *  @dtopt API-Static
	 *
	 *  @example
	 *    alert( $.fn.dataTable.versionCheck( '1.9.0' ) );
	 */ DataTable.versionCheck = DataTable.fnVersionCheck = function(version) {
        var aThis = DataTable.version.split(".");
        var aThat = version.split(".");
        var iThis, iThat;
        for(var i = 0, iLen = aThat.length; i < iLen; i++){
            iThis = parseInt(aThis[i], 10) || 0;
            iThat = parseInt(aThat[i], 10) || 0;
            // Parts are the same, keep comparing
            if (iThis === iThat) continue;
            // Parts are different, return immediately
            return iThis > iThat;
        }
        return true;
    };
    /**
	 * Check if a `<table>` node is a DataTable table already or not.
	 *
	 *  @param {node|jquery|string} table Table node, jQuery object or jQuery
	 *      selector for the table to test. Note that if more than more than one
	 *      table is passed on, only the first will be checked
	 *  @returns {boolean} true the table given is a DataTable, or false otherwise
	 *  @static
	 *  @dtopt API-Static
	 *
	 *  @example
	 *    if ( ! $.fn.DataTable.isDataTable( '#example' ) ) {
	 *      $('#example').dataTable();
	 *    }
	 */ DataTable.isDataTable = DataTable.fnIsDataTable = function(table) {
        var t = $(table).get(0);
        var is = false;
        if (table instanceof DataTable.Api) return true;
        $.each(DataTable.settings, function(i, o) {
            var head = o.nScrollHead ? $("table", o.nScrollHead)[0] : null;
            var foot = o.nScrollFoot ? $("table", o.nScrollFoot)[0] : null;
            if (o.nTable === t || head === t || foot === t) is = true;
        });
        return is;
    };
    /**
	 * Get all DataTable tables that have been initialised - optionally you can
	 * select to get only currently visible tables.
	 *
	 *  @param {boolean} [visible=false] Flag to indicate if you want all (default)
	 *    or visible tables only.
	 *  @returns {array} Array of `table` nodes (not DataTable instances) which are
	 *    DataTables
	 *  @static
	 *  @dtopt API-Static
	 *
	 *  @example
	 *    $.each( $.fn.dataTable.tables(true), function () {
	 *      $(table).DataTable().columns.adjust();
	 *    } );
	 */ DataTable.tables = DataTable.fnTables = function(visible) {
        var api = false;
        if ($.isPlainObject(visible)) {
            api = visible.api;
            visible = visible.visible;
        }
        var a = $.map(DataTable.settings, function(o) {
            if (!visible || visible && $(o.nTable).is(":visible")) return o.nTable;
        });
        return api ? new _Api(a) : a;
    };
    /**
	 * Convert from camel case parameters to Hungarian notation. This is made public
	 * for the extensions to provide the same ability as DataTables core to accept
	 * either the 1.9 style Hungarian notation, or the 1.10+ style camelCase
	 * parameters.
	 *
	 *  @param {object} src The model object which holds all parameters that can be
	 *    mapped.
	 *  @param {object} user The object to convert from camel case to Hungarian.
	 *  @param {boolean} force When set to `true`, properties which already have a
	 *    Hungarian value in the `user` object will be overwritten. Otherwise they
	 *    won't be.
	 */ DataTable.camelToHungarian = _fnCamelToHungarian;
    /**
	 *
	 */ _api_register("$()", function(selector, opts) {
        var rows = this.rows(opts).nodes(), jqRows = $(rows);
        return $([].concat(jqRows.filter(selector).toArray(), jqRows.find(selector).toArray()));
    });
    // jQuery functions to operate on the tables
    $.each([
        "on",
        "one",
        "off"
    ], function(i, key) {
        _api_register(key + "()", function() {
            var args = Array.prototype.slice.call(arguments);
            // Add the `dt` namespace automatically if it isn't already present
            args[0] = $.map(args[0].split(/\s/), function(e) {
                return !e.match(/\.dt\b/) ? e + ".dt" : e;
            }).join(" ");
            var inst = $(this.tables().nodes());
            inst[key].apply(inst, args);
            return this;
        });
    });
    _api_register("clear()", function() {
        return this.iterator("table", function(settings) {
            _fnClearTable(settings);
        });
    });
    _api_register("settings()", function() {
        return new _Api(this.context, this.context);
    });
    _api_register("init()", function() {
        var ctx = this.context;
        return ctx.length ? ctx[0].oInit : null;
    });
    _api_register("data()", function() {
        return this.iterator("table", function(settings) {
            return _pluck(settings.aoData, "_aData");
        }).flatten();
    });
    _api_register("destroy()", function(remove) {
        remove = remove || false;
        return this.iterator("table", function(settings) {
            var classes = settings.oClasses;
            var table = settings.nTable;
            var tbody = settings.nTBody;
            var thead = settings.nTHead;
            var tfoot = settings.nTFoot;
            var jqTable = $(table);
            var jqTbody = $(tbody);
            var jqWrapper = $(settings.nTableWrapper);
            var rows = $.map(settings.aoData, function(r) {
                return r.nTr;
            });
            var i, ien;
            // Flag to note that the table is currently being destroyed - no action
            // should be taken
            settings.bDestroying = true;
            // Fire off the destroy callbacks for plug-ins etc
            _fnCallbackFire(settings, "aoDestroyCallback", "destroy", [
                settings
            ]);
            // If not being removed from the document, make all columns visible
            if (!remove) new _Api(settings).columns().visible(true);
            // Blitz all `DT` namespaced events (these are internal events, the
            // lowercase, `dt` events are user subscribed and they are responsible
            // for removing them
            jqWrapper.off(".DT").find(":not(tbody *)").off(".DT");
            $(window1).off(".DT-" + settings.sInstance);
            // When scrolling we had to break the table up - restore it
            if (table != thead.parentNode) {
                jqTable.children("thead").detach();
                jqTable.append(thead);
            }
            if (tfoot && table != tfoot.parentNode) {
                jqTable.children("tfoot").detach();
                jqTable.append(tfoot);
            }
            settings.aaSorting = [];
            settings.aaSortingFixed = [];
            _fnSortingClasses(settings);
            $(rows).removeClass(settings.asStripeClasses.join(" "));
            $("th, td", thead).removeClass(classes.sSortable + " " + classes.sSortableAsc + " " + classes.sSortableDesc + " " + classes.sSortableNone);
            // Add the TR elements back into the table in their original order
            jqTbody.children().detach();
            jqTbody.append(rows);
            var orig = settings.nTableWrapper.parentNode;
            // Remove the DataTables generated nodes, events and classes
            var removedMethod = remove ? "remove" : "detach";
            jqTable[removedMethod]();
            jqWrapper[removedMethod]();
            // If we need to reattach the table to the document
            if (!remove && orig) {
                // insertBefore acts like appendChild if !arg[1]
                orig.insertBefore(table, settings.nTableReinsertBefore);
                // Restore the width of the original table - was read from the style property,
                // so we can restore directly to that
                jqTable.css("width", settings.sDestroyWidth).removeClass(classes.sTable);
                // If the were originally stripe classes - then we add them back here.
                // Note this is not fool proof (for example if not all rows had stripe
                // classes - but it's a good effort without getting carried away
                ien = settings.asDestroyStripes.length;
                if (ien) jqTbody.children().each(function(i) {
                    $(this).addClass(settings.asDestroyStripes[i % ien]);
                });
            }
            /* Remove the settings object from the settings array */ var idx = $.inArray(settings, DataTable.settings);
            if (idx !== -1) DataTable.settings.splice(idx, 1);
        });
    });
    // Add the `every()` method for rows, columns and cells in a compact form
    $.each([
        "column",
        "row",
        "cell"
    ], function(i, type) {
        _api_register(type + "s().every()", function(fn) {
            var opts = this.selector.opts;
            var api = this;
            return this.iterator(type, function(settings, arg1, arg2, arg3, arg4) {
                // Rows and columns:
                //  arg1 - index
                //  arg2 - table counter
                //  arg3 - loop counter
                //  arg4 - undefined
                // Cells:
                //  arg1 - row index
                //  arg2 - column index
                //  arg3 - table counter
                //  arg4 - loop counter
                fn.call(api[type](arg1, type === "cell" ? arg2 : opts, type === "cell" ? opts : undefined), arg1, arg2, arg3, arg4);
            });
        });
    });
    // i18n method for extensions to be able to use the language object from the
    // DataTable
    _api_register("i18n()", function(token, def, plural) {
        var ctx = this.context[0];
        var resolved = _fnGetObjectDataFn(token)(ctx.oLanguage);
        if (resolved === undefined) resolved = def;
        if (plural !== undefined && $.isPlainObject(resolved)) resolved = resolved[plural] !== undefined ? resolved[plural] : resolved._;
        return resolved.replace("%d", plural); // nb: plural might be undefined,
    });
    /**
	 * Version string for plug-ins to check compatibility. Allowed format is
	 * `a.b.c-d` where: a:int, b:int, c:int, d:string(dev|beta|alpha). `d` is used
	 * only for non-release builds. See http://semver.org/ for more information.
	 *  @member
	 *  @type string
	 *  @default Version number
	 */ DataTable.version = "1.12.1";
    /**
	 * Private data store, containing all of the settings objects that are
	 * created for the tables on a given page.
	 *
	 * Note that the `DataTable.settings` object is aliased to
	 * `jQuery.fn.dataTableExt` through which it may be accessed and
	 * manipulated, or `jQuery.fn.dataTable.settings`.
	 *  @member
	 *  @type array
	 *  @default []
	 *  @private
	 */ DataTable.settings = [];
    /**
	 * Object models container, for the various models that DataTables has
	 * available to it. These models define the objects that are used to hold
	 * the active state and configuration of the table.
	 *  @namespace
	 */ DataTable.models = {};
    /**
	 * Template object for the way in which DataTables holds information about
	 * search information for the global filter and individual column filters.
	 *  @namespace
	 */ DataTable.models.oSearch = {
        /**
		 * Flag to indicate if the filtering should be case insensitive or not
		 *  @type boolean
		 *  @default true
		 */ "bCaseInsensitive": true,
        /**
		 * Applied search term
		 *  @type string
		 *  @default <i>Empty string</i>
		 */ "sSearch": "",
        /**
		 * Flag to indicate if the search term should be interpreted as a
		 * regular expression (true) or not (false) and therefore and special
		 * regex characters escaped.
		 *  @type boolean
		 *  @default false
		 */ "bRegex": false,
        /**
		 * Flag to indicate if DataTables is to use its smart filtering or not.
		 *  @type boolean
		 *  @default true
		 */ "bSmart": true,
        /**
		 * Flag to indicate if DataTables should only trigger a search when
		 * the return key is pressed.
		 *  @type boolean
		 *  @default false
		 */ "return": false
    };
    /**
	 * Template object for the way in which DataTables holds information about
	 * each individual row. This is the object format used for the settings
	 * aoData array.
	 *  @namespace
	 */ DataTable.models.oRow = {
        /**
		 * TR element for the row
		 *  @type node
		 *  @default null
		 */ "nTr": null,
        /**
		 * Array of TD elements for each row. This is null until the row has been
		 * created.
		 *  @type array nodes
		 *  @default []
		 */ "anCells": null,
        /**
		 * Data object from the original data source for the row. This is either
		 * an array if using the traditional form of DataTables, or an object if
		 * using mData options. The exact type will depend on the passed in
		 * data from the data source, or will be an array if using DOM a data
		 * source.
		 *  @type array|object
		 *  @default []
		 */ "_aData": [],
        /**
		 * Sorting data cache - this array is ostensibly the same length as the
		 * number of columns (although each index is generated only as it is
		 * needed), and holds the data that is used for sorting each column in the
		 * row. We do this cache generation at the start of the sort in order that
		 * the formatting of the sort data need be done only once for each cell
		 * per sort. This array should not be read from or written to by anything
		 * other than the master sorting methods.
		 *  @type array
		 *  @default null
		 *  @private
		 */ "_aSortData": null,
        /**
		 * Per cell filtering data cache. As per the sort data cache, used to
		 * increase the performance of the filtering in DataTables
		 *  @type array
		 *  @default null
		 *  @private
		 */ "_aFilterData": null,
        /**
		 * Filtering data cache. This is the same as the cell filtering cache, but
		 * in this case a string rather than an array. This is easily computed with
		 * a join on `_aFilterData`, but is provided as a cache so the join isn't
		 * needed on every search (memory traded for performance)
		 *  @type array
		 *  @default null
		 *  @private
		 */ "_sFilterRow": null,
        /**
		 * Cache of the class name that DataTables has applied to the row, so we
		 * can quickly look at this variable rather than needing to do a DOM check
		 * on className for the nTr property.
		 *  @type string
		 *  @default <i>Empty string</i>
		 *  @private
		 */ "_sRowStripe": "",
        /**
		 * Denote if the original data source was from the DOM, or the data source
		 * object. This is used for invalidating data, so DataTables can
		 * automatically read data from the original source, unless uninstructed
		 * otherwise.
		 *  @type string
		 *  @default null
		 *  @private
		 */ "src": null,
        /**
		 * Index in the aoData array. This saves an indexOf lookup when we have the
		 * object, but want to know the index
		 *  @type integer
		 *  @default -1
		 *  @private
		 */ "idx": -1
    };
    /**
	 * Template object for the column information object in DataTables. This object
	 * is held in the settings aoColumns array and contains all the information that
	 * DataTables needs about each individual column.
	 *
	 * Note that this object is related to {@link DataTable.defaults.column}
	 * but this one is the internal data store for DataTables's cache of columns.
	 * It should NOT be manipulated outside of DataTables. Any configuration should
	 * be done through the initialisation options.
	 *  @namespace
	 */ DataTable.models.oColumn = {
        /**
		 * Column index. This could be worked out on-the-fly with $.inArray, but it
		 * is faster to just hold it as a variable
		 *  @type integer
		 *  @default null
		 */ "idx": null,
        /**
		 * A list of the columns that sorting should occur on when this column
		 * is sorted. That this property is an array allows multi-column sorting
		 * to be defined for a column (for example first name / last name columns
		 * would benefit from this). The values are integers pointing to the
		 * columns to be sorted on (typically it will be a single integer pointing
		 * at itself, but that doesn't need to be the case).
		 *  @type array
		 */ "aDataSort": null,
        /**
		 * Define the sorting directions that are applied to the column, in sequence
		 * as the column is repeatedly sorted upon - i.e. the first value is used
		 * as the sorting direction when the column if first sorted (clicked on).
		 * Sort it again (click again) and it will move on to the next index.
		 * Repeat until loop.
		 *  @type array
		 */ "asSorting": null,
        /**
		 * Flag to indicate if the column is searchable, and thus should be included
		 * in the filtering or not.
		 *  @type boolean
		 */ "bSearchable": null,
        /**
		 * Flag to indicate if the column is sortable or not.
		 *  @type boolean
		 */ "bSortable": null,
        /**
		 * Flag to indicate if the column is currently visible in the table or not
		 *  @type boolean
		 */ "bVisible": null,
        /**
		 * Store for manual type assignment using the `column.type` option. This
		 * is held in store so we can manipulate the column's `sType` property.
		 *  @type string
		 *  @default null
		 *  @private
		 */ "_sManualType": null,
        /**
		 * Flag to indicate if HTML5 data attributes should be used as the data
		 * source for filtering or sorting. True is either are.
		 *  @type boolean
		 *  @default false
		 *  @private
		 */ "_bAttrSrc": false,
        /**
		 * Developer definable function that is called whenever a cell is created (Ajax source,
		 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
		 * allowing you to modify the DOM element (add background colour for example) when the
		 * element is available.
		 *  @type function
		 *  @param {element} nTd The TD node that has been created
		 *  @param {*} sData The Data for the cell
		 *  @param {array|object} oData The data for the whole row
		 *  @param {int} iRow The row index for the aoData data store
		 *  @default null
		 */ "fnCreatedCell": null,
        /**
		 * Function to get data from a cell in a column. You should <b>never</b>
		 * access data directly through _aData internally in DataTables - always use
		 * the method attached to this property. It allows mData to function as
		 * required. This function is automatically assigned by the column
		 * initialisation method
		 *  @type function
		 *  @param {array|object} oData The data array/object for the array
		 *    (i.e. aoData[]._aData)
		 *  @param {string} sSpecific The specific data type you want to get -
		 *    'display', 'type' 'filter' 'sort'
		 *  @returns {*} The data for the cell from the given row's data
		 *  @default null
		 */ "fnGetData": null,
        /**
		 * Function to set data for a cell in the column. You should <b>never</b>
		 * set the data directly to _aData internally in DataTables - always use
		 * this method. It allows mData to function as required. This function
		 * is automatically assigned by the column initialisation method
		 *  @type function
		 *  @param {array|object} oData The data array/object for the array
		 *    (i.e. aoData[]._aData)
		 *  @param {*} sValue Value to set
		 *  @default null
		 */ "fnSetData": null,
        /**
		 * Property to read the value for the cells in the column from the data
		 * source array / object. If null, then the default content is used, if a
		 * function is given then the return from the function is used.
		 *  @type function|int|string|null
		 *  @default null
		 */ "mData": null,
        /**
		 * Partner property to mData which is used (only when defined) to get
		 * the data - i.e. it is basically the same as mData, but without the
		 * 'set' option, and also the data fed to it is the result from mData.
		 * This is the rendering method to match the data method of mData.
		 *  @type function|int|string|null
		 *  @default null
		 */ "mRender": null,
        /**
		 * Unique header TH/TD element for this column - this is what the sorting
		 * listener is attached to (if sorting is enabled.)
		 *  @type node
		 *  @default null
		 */ "nTh": null,
        /**
		 * Unique footer TH/TD element for this column (if there is one). Not used
		 * in DataTables as such, but can be used for plug-ins to reference the
		 * footer for each column.
		 *  @type node
		 *  @default null
		 */ "nTf": null,
        /**
		 * The class to apply to all TD elements in the table's TBODY for the column
		 *  @type string
		 *  @default null
		 */ "sClass": null,
        /**
		 * When DataTables calculates the column widths to assign to each column,
		 * it finds the longest string in each column and then constructs a
		 * temporary table and reads the widths from that. The problem with this
		 * is that "mmm" is much wider then "iiii", but the latter is a longer
		 * string - thus the calculation can go wrong (doing it properly and putting
		 * it into an DOM object and measuring that is horribly(!) slow). Thus as
		 * a "work around" we provide this option. It will append its value to the
		 * text that is found to be the longest string for the column - i.e. padding.
		 *  @type string
		 */ "sContentPadding": null,
        /**
		 * Allows a default value to be given for a column's data, and will be used
		 * whenever a null data source is encountered (this can be because mData
		 * is set to null, or because the data source itself is null).
		 *  @type string
		 *  @default null
		 */ "sDefaultContent": null,
        /**
		 * Name for the column, allowing reference to the column by name as well as
		 * by index (needs a lookup to work by name).
		 *  @type string
		 */ "sName": null,
        /**
		 * Custom sorting data type - defines which of the available plug-ins in
		 * afnSortData the custom sorting will use - if any is defined.
		 *  @type string
		 *  @default std
		 */ "sSortDataType": "std",
        /**
		 * Class to be applied to the header element when sorting on this column
		 *  @type string
		 *  @default null
		 */ "sSortingClass": null,
        /**
		 * Class to be applied to the header element when sorting on this column -
		 * when jQuery UI theming is used.
		 *  @type string
		 *  @default null
		 */ "sSortingClassJUI": null,
        /**
		 * Title of the column - what is seen in the TH element (nTh).
		 *  @type string
		 */ "sTitle": null,
        /**
		 * Column sorting and filtering type
		 *  @type string
		 *  @default null
		 */ "sType": null,
        /**
		 * Width of the column
		 *  @type string
		 *  @default null
		 */ "sWidth": null,
        /**
		 * Width of the column when it was first "encountered"
		 *  @type string
		 *  @default null
		 */ "sWidthOrig": null
    };
    /*
	 * Developer note: The properties of the object below are given in Hungarian
	 * notation, that was used as the interface for DataTables prior to v1.10, however
	 * from v1.10 onwards the primary interface is camel case. In order to avoid
	 * breaking backwards compatibility utterly with this change, the Hungarian
	 * version is still, internally the primary interface, but is is not documented
	 * - hence the @name tags in each doc comment. This allows a Javascript function
	 * to create a map from Hungarian notation to camel case (going the other direction
	 * would require each property to be listed, which would add around 3K to the size
	 * of DataTables, while this method is about a 0.5K hit).
	 *
	 * Ultimately this does pave the way for Hungarian notation to be dropped
	 * completely, but that is a massive amount of work and will break current
	 * installs (therefore is on-hold until v2).
	 */ /**
	 * Initialisation options that can be given to DataTables at initialisation
	 * time.
	 *  @namespace
	 */ DataTable.defaults = {
        /**
		 * An array of data to use for the table, passed in at initialisation which
		 * will be used in preference to any data which is already in the DOM. This is
		 * particularly useful for constructing tables purely in Javascript, for
		 * example with a custom Ajax call.
		 *  @type array
		 *  @default null
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.data
		 *
		 *  @example
		 *    // Using a 2D array data source
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "data": [
		 *          ['Trident', 'Internet Explorer 4.0', 'Win 95+', 4, 'X'],
		 *          ['Trident', 'Internet Explorer 5.0', 'Win 95+', 5, 'C'],
		 *        ],
		 *        "columns": [
		 *          { "title": "Engine" },
		 *          { "title": "Browser" },
		 *          { "title": "Platform" },
		 *          { "title": "Version" },
		 *          { "title": "Grade" }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using an array of objects as a data source (`data`)
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "data": [
		 *          {
		 *            "engine":   "Trident",
		 *            "browser":  "Internet Explorer 4.0",
		 *            "platform": "Win 95+",
		 *            "version":  4,
		 *            "grade":    "X"
		 *          },
		 *          {
		 *            "engine":   "Trident",
		 *            "browser":  "Internet Explorer 5.0",
		 *            "platform": "Win 95+",
		 *            "version":  5,
		 *            "grade":    "C"
		 *          }
		 *        ],
		 *        "columns": [
		 *          { "title": "Engine",   "data": "engine" },
		 *          { "title": "Browser",  "data": "browser" },
		 *          { "title": "Platform", "data": "platform" },
		 *          { "title": "Version",  "data": "version" },
		 *          { "title": "Grade",    "data": "grade" }
		 *        ]
		 *      } );
		 *    } );
		 */ "aaData": null,
        /**
		 * If ordering is enabled, then DataTables will perform a first pass sort on
		 * initialisation. You can define which column(s) the sort is performed
		 * upon, and the sorting direction, with this variable. The `sorting` array
		 * should contain an array for each column to be sorted initially containing
		 * the column's index and a direction string ('asc' or 'desc').
		 *  @type array
		 *  @default [[0,'asc']]
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.order
		 *
		 *  @example
		 *    // Sort by 3rd column first, and then 4th column
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "order": [[2,'asc'], [3,'desc']]
		 *      } );
		 *    } );
		 *
		 *    // No initial sorting
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "order": []
		 *      } );
		 *    } );
		 */ "aaSorting": [
            [
                0,
                "asc"
            ]
        ],
        /**
		 * This parameter is basically identical to the `sorting` parameter, but
		 * cannot be overridden by user interaction with the table. What this means
		 * is that you could have a column (visible or hidden) which the sorting
		 * will always be forced on first - any sorting after that (from the user)
		 * will then be performed as required. This can be useful for grouping rows
		 * together.
		 *  @type array
		 *  @default null
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.orderFixed
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "orderFixed": [[0,'asc']]
		 *      } );
		 *    } )
		 */ "aaSortingFixed": [],
        /**
		 * DataTables can be instructed to load data to display in the table from a
		 * Ajax source. This option defines how that Ajax call is made and where to.
		 *
		 * The `ajax` property has three different modes of operation, depending on
		 * how it is defined. These are:
		 *
		 * * `string` - Set the URL from where the data should be loaded from.
		 * * `object` - Define properties for `jQuery.ajax`.
		 * * `function` - Custom data get function
		 *
		 * `string`
		 * --------
		 *
		 * As a string, the `ajax` property simply defines the URL from which
		 * DataTables will load data.
		 *
		 * `object`
		 * --------
		 *
		 * As an object, the parameters in the object are passed to
		 * [jQuery.ajax](http://api.jquery.com/jQuery.ajax/) allowing fine control
		 * of the Ajax request. DataTables has a number of default parameters which
		 * you can override using this option. Please refer to the jQuery
		 * documentation for a full description of the options available, although
		 * the following parameters provide additional options in DataTables or
		 * require special consideration:
		 *
		 * * `data` - As with jQuery, `data` can be provided as an object, but it
		 *   can also be used as a function to manipulate the data DataTables sends
		 *   to the server. The function takes a single parameter, an object of
		 *   parameters with the values that DataTables has readied for sending. An
		 *   object may be returned which will be merged into the DataTables
		 *   defaults, or you can add the items to the object that was passed in and
		 *   not return anything from the function. This supersedes `fnServerParams`
		 *   from DataTables 1.9-.
		 *
		 * * `dataSrc` - By default DataTables will look for the property `data` (or
		 *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
		 *   from an Ajax source or for server-side processing - this parameter
		 *   allows that property to be changed. You can use Javascript dotted
		 *   object notation to get a data source for multiple levels of nesting, or
		 *   it my be used as a function. As a function it takes a single parameter,
		 *   the JSON returned from the server, which can be manipulated as
		 *   required, with the returned value being that used by DataTables as the
		 *   data source for the table. This supersedes `sAjaxDataProp` from
		 *   DataTables 1.9-.
		 *
		 * * `success` - Should not be overridden it is used internally in
		 *   DataTables. To manipulate / transform the data returned by the server
		 *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
		 *
		 * `function`
		 * ----------
		 *
		 * As a function, making the Ajax call is left up to yourself allowing
		 * complete control of the Ajax request. Indeed, if desired, a method other
		 * than Ajax could be used to obtain the required data, such as Web storage
		 * or an AIR database.
		 *
		 * The function is given four parameters and no return is required. The
		 * parameters are:
		 *
		 * 1. _object_ - Data to send to the server
		 * 2. _function_ - Callback function that must be executed when the required
		 *    data has been obtained. That data should be passed into the callback
		 *    as the only parameter
		 * 3. _object_ - DataTables settings object for the table
		 *
		 * Note that this supersedes `fnServerData` from DataTables 1.9-.
		 *
		 *  @type string|object|function
		 *  @default null
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.ajax
		 *  @since 1.10.0
		 *
		 * @example
		 *   // Get JSON data from a file via Ajax.
		 *   // Note DataTables expects data in the form `{ data: [ ...data... ] }` by default).
		 *   $('#example').dataTable( {
		 *     "ajax": "data.json"
		 *   } );
		 *
		 * @example
		 *   // Get JSON data from a file via Ajax, using `dataSrc` to change
		 *   // `data` to `tableData` (i.e. `{ tableData: [ ...data... ] }`)
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "dataSrc": "tableData"
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Get JSON data from a file via Ajax, using `dataSrc` to read data
		 *   // from a plain array rather than an array in an object
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "dataSrc": ""
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Manipulate the data returned from the server - add a link to data
		 *   // (note this can, should, be done using `render` for the column - this
		 *   // is just a simple example of how the data can be manipulated).
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "dataSrc": function ( json ) {
		 *         for ( var i=0, ien=json.length ; i<ien ; i++ ) {
		 *           json[i][0] = '<a href="/message/'+json[i][0]+'>View message</a>';
		 *         }
		 *         return json;
		 *       }
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Add data to the request
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "data": function ( d ) {
		 *         return {
		 *           "extra_search": $('#extra').val()
		 *         };
		 *       }
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Send request as POST
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "type": "POST"
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Get the data from localStorage (could interface with a form for
		 *   // adding, editing and removing rows).
		 *   $('#example').dataTable( {
		 *     "ajax": function (data, callback, settings) {
		 *       callback(
		 *         JSON.parse( localStorage.getItem('dataTablesData') )
		 *       );
		 *     }
		 *   } );
		 */ "ajax": null,
        /**
		 * This parameter allows you to readily specify the entries in the length drop
		 * down menu that DataTables shows when pagination is enabled. It can be
		 * either a 1D array of options which will be used for both the displayed
		 * option and the value, or a 2D array which will use the array in the first
		 * position as the value, and the array in the second position as the
		 * displayed options (useful for language strings such as 'All').
		 *
		 * Note that the `pageLength` property will be automatically set to the
		 * first value given in this array, unless `pageLength` is also provided.
		 *  @type array
		 *  @default [ 10, 25, 50, 100 ]
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.lengthMenu
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]]
		 *      } );
		 *    } );
		 */ "aLengthMenu": [
            10,
            25,
            50,
            100
        ],
        /**
		 * The `columns` option in the initialisation parameter allows you to define
		 * details about the way individual columns behave. For a full list of
		 * column options that can be set, please see
		 * {@link DataTable.defaults.column}. Note that if you use `columns` to
		 * define your columns, you must have an entry in the array for every single
		 * column that you have in your table (these can be null if you don't which
		 * to specify any options).
		 *  @member
		 *
		 *  @name DataTable.defaults.column
		 */ "aoColumns": null,
        /**
		 * Very similar to `columns`, `columnDefs` allows you to target a specific
		 * column, multiple columns, or all columns, using the `targets` property of
		 * each object in the array. This allows great flexibility when creating
		 * tables, as the `columnDefs` arrays can be of any length, targeting the
		 * columns you specifically want. `columnDefs` may use any of the column
		 * options available: {@link DataTable.defaults.column}, but it _must_
		 * have `targets` defined in each object in the array. Values in the `targets`
		 * array may be:
		 *   <ul>
		 *     <li>a string - class name will be matched on the TH for the column</li>
		 *     <li>0 or a positive integer - column index counting from the left</li>
		 *     <li>a negative integer - column index counting from the right</li>
		 *     <li>the string "_all" - all columns (i.e. assign a default)</li>
		 *   </ul>
		 *  @member
		 *
		 *  @name DataTable.defaults.columnDefs
		 */ "aoColumnDefs": null,
        /**
		 * Basically the same as `search`, this parameter defines the individual column
		 * filtering state at initialisation time. The array must be of the same size
		 * as the number of columns, and each element be an object with the parameters
		 * `search` and `escapeRegex` (the latter is optional). 'null' is also
		 * accepted and the default will be used.
		 *  @type array
		 *  @default []
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.searchCols
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "searchCols": [
		 *          null,
		 *          { "search": "My filter" },
		 *          null,
		 *          { "search": "^[0-9]", "escapeRegex": false }
		 *        ]
		 *      } );
		 *    } )
		 */ "aoSearchCols": [],
        /**
		 * An array of CSS classes that should be applied to displayed rows. This
		 * array may be of any length, and DataTables will apply each class
		 * sequentially, looping when required.
		 *  @type array
		 *  @default null <i>Will take the values determined by the `oClasses.stripe*`
		 *    options</i>
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.stripeClasses
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stripeClasses": [ 'strip1', 'strip2', 'strip3' ]
		 *      } );
		 *    } )
		 */ "asStripeClasses": null,
        /**
		 * Enable or disable automatic column width calculation. This can be disabled
		 * as an optimisation (it takes some time to calculate the widths) if the
		 * tables widths are passed in using `columns`.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.autoWidth
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "autoWidth": false
		 *      } );
		 *    } );
		 */ "bAutoWidth": true,
        /**
		 * Deferred rendering can provide DataTables with a huge speed boost when you
		 * are using an Ajax or JS data source for the table. This option, when set to
		 * true, will cause DataTables to defer the creation of the table elements for
		 * each row until they are needed for a draw - saving a significant amount of
		 * time.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.deferRender
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajax": "sources/arrays.txt",
		 *        "deferRender": true
		 *      } );
		 *    } );
		 */ "bDeferRender": false,
        /**
		 * Replace a DataTable which matches the given selector and replace it with
		 * one which has the properties of the new initialisation object passed. If no
		 * table matches the selector, then the new DataTable will be constructed as
		 * per normal.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.destroy
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "srollY": "200px",
		 *        "paginate": false
		 *      } );
		 *
		 *      // Some time later....
		 *      $('#example').dataTable( {
		 *        "filter": false,
		 *        "destroy": true
		 *      } );
		 *    } );
		 */ "bDestroy": false,
        /**
		 * Enable or disable filtering of data. Filtering in DataTables is "smart" in
		 * that it allows the end user to input multiple words (space separated) and
		 * will match a row containing those words, even if not in the order that was
		 * specified (this allow matching across multiple columns). Note that if you
		 * wish to use filtering in DataTables this must remain 'true' - to remove the
		 * default filtering input box and retain filtering abilities, please use
		 * {@link DataTable.defaults.dom}.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.searching
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "searching": false
		 *      } );
		 *    } );
		 */ "bFilter": true,
        /**
		 * Enable or disable the table information display. This shows information
		 * about the data that is currently visible on the page, including information
		 * about filtered data if that action is being performed.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.info
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "info": false
		 *      } );
		 *    } );
		 */ "bInfo": true,
        /**
		 * Allows the end user to select the size of a formatted page from a select
		 * menu (sizes are 10, 25, 50 and 100). Requires pagination (`paginate`).
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.lengthChange
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "lengthChange": false
		 *      } );
		 *    } );
		 */ "bLengthChange": true,
        /**
		 * Enable or disable pagination.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.paging
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "paging": false
		 *      } );
		 *    } );
		 */ "bPaginate": true,
        /**
		 * Enable or disable the display of a 'processing' indicator when the table is
		 * being processed (e.g. a sort). This is particularly useful for tables with
		 * large amounts of data where it can take a noticeable amount of time to sort
		 * the entries.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.processing
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "processing": true
		 *      } );
		 *    } );
		 */ "bProcessing": false,
        /**
		 * Retrieve the DataTables object for the given selector. Note that if the
		 * table has already been initialised, this parameter will cause DataTables
		 * to simply return the object that has already been set up - it will not take
		 * account of any changes you might have made to the initialisation object
		 * passed to DataTables (setting this parameter to true is an acknowledgement
		 * that you understand this). `destroy` can be used to reinitialise a table if
		 * you need.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.retrieve
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      initTable();
		 *      tableActions();
		 *    } );
		 *
		 *    function initTable ()
		 *    {
		 *      return $('#example').dataTable( {
		 *        "scrollY": "200px",
		 *        "paginate": false,
		 *        "retrieve": true
		 *      } );
		 *    }
		 *
		 *    function tableActions ()
		 *    {
		 *      var table = initTable();
		 *      // perform API operations with oTable
		 *    }
		 */ "bRetrieve": false,
        /**
		 * When vertical (y) scrolling is enabled, DataTables will force the height of
		 * the table's viewport to the given height at all times (useful for layout).
		 * However, this can look odd when filtering data down to a small data set,
		 * and the footer is left "floating" further down. This parameter (when
		 * enabled) will cause DataTables to collapse the table's viewport down when
		 * the result set will fit within the given Y height.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.scrollCollapse
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollY": "200",
		 *        "scrollCollapse": true
		 *      } );
		 *    } );
		 */ "bScrollCollapse": false,
        /**
		 * Configure DataTables to use server-side processing. Note that the
		 * `ajax` parameter must also be given in order to give DataTables a
		 * source to obtain the required data for each draw.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverSide
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "serverSide": true,
		 *        "ajax": "xhr.php"
		 *      } );
		 *    } );
		 */ "bServerSide": false,
        /**
		 * Enable or disable sorting of columns. Sorting of individual columns can be
		 * disabled by the `sortable` option for each column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.ordering
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "ordering": false
		 *      } );
		 *    } );
		 */ "bSort": true,
        /**
		 * Enable or display DataTables' ability to sort multiple columns at the
		 * same time (activated by shift-click by the user).
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.orderMulti
		 *
		 *  @example
		 *    // Disable multiple column sorting ability
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "orderMulti": false
		 *      } );
		 *    } );
		 */ "bSortMulti": true,
        /**
		 * Allows control over whether DataTables should use the top (true) unique
		 * cell that is found for a single column, or the bottom (false - default).
		 * This is useful when using complex headers.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.orderCellsTop
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "orderCellsTop": true
		 *      } );
		 *    } );
		 */ "bSortCellsTop": false,
        /**
		 * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
		 * `sorting\_3` to the columns which are currently being sorted on. This is
		 * presented as a feature switch as it can increase processing time (while
		 * classes are removed and added) so for large data sets you might want to
		 * turn this off.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.orderClasses
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "orderClasses": false
		 *      } );
		 *    } );
		 */ "bSortClasses": true,
        /**
		 * Enable or disable state saving. When enabled HTML5 `localStorage` will be
		 * used to save table display information such as pagination information,
		 * display length, filtering and sorting. As such when the end user reloads
		 * the page the display display will match what thy had previously set up.
		 *
		 * Due to the use of `localStorage` the default state saving is not supported
		 * in IE6 or 7. If state saving is required in those browsers, use
		 * `stateSaveCallback` to provide a storage solution such as cookies.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.stateSave
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "stateSave": true
		 *      } );
		 *    } );
		 */ "bStateSave": false,
        /**
		 * This function is called when a TR element is created (and all TD child
		 * elements have been inserted), or registered if using a DOM source, allowing
		 * manipulation of the TR element (adding classes etc).
		 *  @type function
		 *  @param {node} row "TR" element for the current row
		 *  @param {array} data Raw data array for this row
		 *  @param {int} dataIndex The index of this row in the internal aoData array
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.createdRow
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "createdRow": function( row, data, dataIndex ) {
		 *          // Bold the grade for all 'A' grade browsers
		 *          if ( data[4] == "A" )
		 *          {
		 *            $('td:eq(4)', row).html( '<b>A</b>' );
		 *          }
		 *        }
		 *      } );
		 *    } );
		 */ "fnCreatedRow": null,
        /**
		 * This function is called on every 'draw' event, and allows you to
		 * dynamically modify any aspect you want about the created DOM.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.drawCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "drawCallback": function( settings ) {
		 *          alert( 'DataTables has redrawn the table' );
		 *        }
		 *      } );
		 *    } );
		 */ "fnDrawCallback": null,
        /**
		 * Identical to fnHeaderCallback() but for the table footer this function
		 * allows you to modify the table footer on every 'draw' event.
		 *  @type function
		 *  @param {node} foot "TR" element for the footer
		 *  @param {array} data Full table data (as derived from the original HTML)
		 *  @param {int} start Index for the current display starting point in the
		 *    display array
		 *  @param {int} end Index for the current display ending point in the
		 *    display array
		 *  @param {array int} display Index array to translate the visual position
		 *    to the full data array
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.footerCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "footerCallback": function( tfoot, data, start, end, display ) {
		 *          tfoot.getElementsByTagName('th')[0].innerHTML = "Starting index is "+start;
		 *        }
		 *      } );
		 *    } )
		 */ "fnFooterCallback": null,
        /**
		 * When rendering large numbers in the information element for the table
		 * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
		 * to have a comma separator for the 'thousands' units (e.g. 1 million is
		 * rendered as "1,000,000") to help readability for the end user. This
		 * function will override the default method DataTables uses.
		 *  @type function
		 *  @member
		 *  @param {int} toFormat number to be formatted
		 *  @returns {string} formatted string for DataTables to show the number
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.formatNumber
		 *
		 *  @example
		 *    // Format a number using a single quote for the separator (note that
		 *    // this can also be done with the language.thousands option)
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "formatNumber": function ( toFormat ) {
		 *          return toFormat.toString().replace(
		 *            /\B(?=(\d{3})+(?!\d))/g, "'"
		 *          );
		 *        };
		 *      } );
		 *    } );
		 */ "fnFormatNumber": function(toFormat) {
            return toFormat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, this.oLanguage.sThousands);
        },
        /**
		 * This function is called on every 'draw' event, and allows you to
		 * dynamically modify the header row. This can be used to calculate and
		 * display useful information about the table.
		 *  @type function
		 *  @param {node} head "TR" element for the header
		 *  @param {array} data Full table data (as derived from the original HTML)
		 *  @param {int} start Index for the current display starting point in the
		 *    display array
		 *  @param {int} end Index for the current display ending point in the
		 *    display array
		 *  @param {array int} display Index array to translate the visual position
		 *    to the full data array
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.headerCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "fheaderCallback": function( head, data, start, end, display ) {
		 *          head.getElementsByTagName('th')[0].innerHTML = "Displaying "+(end-start)+" records";
		 *        }
		 *      } );
		 *    } )
		 */ "fnHeaderCallback": null,
        /**
		 * The information element can be used to convey information about the current
		 * state of the table. Although the internationalisation options presented by
		 * DataTables are quite capable of dealing with most customisations, there may
		 * be times where you wish to customise the string further. This callback
		 * allows you to do exactly that.
		 *  @type function
		 *  @param {object} oSettings DataTables settings object
		 *  @param {int} start Starting position in data for the draw
		 *  @param {int} end End position in data for the draw
		 *  @param {int} max Total number of rows in the table (regardless of
		 *    filtering)
		 *  @param {int} total Total number of rows in the data set, after filtering
		 *  @param {string} pre The string that DataTables has formatted using it's
		 *    own rules
		 *  @returns {string} The string to be displayed in the information element.
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.infoCallback
		 *
		 *  @example
		 *    $('#example').dataTable( {
		 *      "infoCallback": function( settings, start, end, max, total, pre ) {
		 *        return start +" to "+ end;
		 *      }
		 *    } );
		 */ "fnInfoCallback": null,
        /**
		 * Called when the table has been initialised. Normally DataTables will
		 * initialise sequentially and there will be no need for this function,
		 * however, this does not hold true when using external language information
		 * since that is obtained using an async XHR call.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} json The JSON object request from the server - only
		 *    present if client-side Ajax sourced data is used
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.initComplete
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "initComplete": function(settings, json) {
		 *          alert( 'DataTables has finished its initialisation.' );
		 *        }
		 *      } );
		 *    } )
		 */ "fnInitComplete": null,
        /**
		 * Called at the very start of each table draw and can be used to cancel the
		 * draw by returning false, any other return (including undefined) results in
		 * the full draw occurring).
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @returns {boolean} False will cancel the draw, anything else (including no
		 *    return) will allow it to complete.
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.preDrawCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "preDrawCallback": function( settings ) {
		 *          if ( $('#test').val() == 1 ) {
		 *            return false;
		 *          }
		 *        }
		 *      } );
		 *    } );
		 */ "fnPreDrawCallback": null,
        /**
		 * This function allows you to 'post process' each row after it have been
		 * generated for each table draw, but before it is rendered on screen. This
		 * function might be used for setting the row class name etc.
		 *  @type function
		 *  @param {node} row "TR" element for the current row
		 *  @param {array} data Raw data array for this row
		 *  @param {int} displayIndex The display index for the current table draw
		 *  @param {int} displayIndexFull The index of the data in the full list of
		 *    rows (after filtering)
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.rowCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "rowCallback": function( row, data, displayIndex, displayIndexFull ) {
		 *          // Bold the grade for all 'A' grade browsers
		 *          if ( data[4] == "A" ) {
		 *            $('td:eq(4)', row).html( '<b>A</b>' );
		 *          }
		 *        }
		 *      } );
		 *    } );
		 */ "fnRowCallback": null,
        /**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * This parameter allows you to override the default function which obtains
		 * the data from the server so something more suitable for your application.
		 * For example you could use POST data, or pull information from a Gears or
		 * AIR database.
		 *  @type function
		 *  @member
		 *  @param {string} source HTTP source to obtain the data from (`ajax`)
		 *  @param {array} data A key/value pair object containing the data to send
		 *    to the server
		 *  @param {function} callback to be called on completion of the data get
		 *    process that will draw the data on the page.
		 *  @param {object} settings DataTables settings object
		 *
		 *  @dtopt Callbacks
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverData
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */ "fnServerData": null,
        /**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 *  It is often useful to send extra data to the server when making an Ajax
		 * request - for example custom filtering information, and this callback
		 * function makes it trivial to send extra information to the server. The
		 * passed in parameter is the data set that has been constructed by
		 * DataTables, and you can add to this or modify it as you require.
		 *  @type function
		 *  @param {array} data Data array (array of objects which are name/value
		 *    pairs) that has been constructed by DataTables and will be sent to the
		 *    server. In the case of Ajax sourced data with server-side processing
		 *    this will be an empty array, for server-side processing there will be a
		 *    significant number of parameters!
		 *  @returns {undefined} Ensure that you modify the data array passed in,
		 *    as this is passed by reference.
		 *
		 *  @dtopt Callbacks
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverParams
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */ "fnServerParams": null,
        /**
		 * Load the table state. With this function you can define from where, and how, the
		 * state of a table is loaded. By default DataTables will load from `localStorage`
		 * but you might wish to use a server-side database or cookies.
		 *  @type function
		 *  @member
		 *  @param {object} settings DataTables settings object
		 *  @param {object} callback Callback that can be executed when done. It
		 *    should be passed the loaded state object.
		 *  @return {object} The DataTables state object to be loaded
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateLoadCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoadCallback": function (settings, callback) {
		 *          $.ajax( {
		 *            "url": "/state_load",
		 *            "dataType": "json",
		 *            "success": function (json) {
		 *              callback( json );
		 *            }
		 *          } );
		 *        }
		 *      } );
		 *    } );
		 */ "fnStateLoadCallback": function(settings) {
            try {
                return JSON.parse((settings.iStateDuration === -1 ? sessionStorage : localStorage).getItem("DataTables_" + settings.sInstance + "_" + location.pathname));
            } catch (e) {
                return {};
            }
        },
        /**
		 * Callback which allows modification of the saved state prior to loading that state.
		 * This callback is called when the table is loading state from the stored data, but
		 * prior to the settings object being modified by the saved state. Note that for
		 * plug-in authors, you should use the `stateLoadParams` event to load parameters for
		 * a plug-in.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object that is to be loaded
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateLoadParams
		 *
		 *  @example
		 *    // Remove a saved filter, so filtering is never loaded
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoadParams": function (settings, data) {
		 *          data.oSearch.sSearch = "";
		 *        }
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Disallow state loading by returning false
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoadParams": function (settings, data) {
		 *          return false;
		 *        }
		 *      } );
		 *    } );
		 */ "fnStateLoadParams": null,
        /**
		 * Callback that is called when the state has been loaded from the state saving method
		 * and the DataTables settings object has been modified as a result of the loaded state.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object that was loaded
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateLoaded
		 *
		 *  @example
		 *    // Show an alert with the filtering value that was saved
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoaded": function (settings, data) {
		 *          alert( 'Saved filter was: '+data.oSearch.sSearch );
		 *        }
		 *      } );
		 *    } );
		 */ "fnStateLoaded": null,
        /**
		 * Save the table state. This function allows you to define where and how the state
		 * information for the table is stored By default DataTables will use `localStorage`
		 * but you might wish to use a server-side database or cookies.
		 *  @type function
		 *  @member
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object to be saved
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateSaveCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateSaveCallback": function (settings, data) {
		 *          // Send an Ajax request to the server with the state object
		 *          $.ajax( {
		 *            "url": "/state_save",
		 *            "data": data,
		 *            "dataType": "json",
		 *            "method": "POST"
		 *            "success": function () {}
		 *          } );
		 *        }
		 *      } );
		 *    } );
		 */ "fnStateSaveCallback": function(settings, data) {
            try {
                (settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem("DataTables_" + settings.sInstance + "_" + location.pathname, JSON.stringify(data));
            } catch (e) {}
        },
        /**
		 * Callback which allows modification of the state to be saved. Called when the table
		 * has changed state a new state save is required. This method allows modification of
		 * the state saving object prior to actually doing the save, including addition or
		 * other state properties or modification. Note that for plug-in authors, you should
		 * use the `stateSaveParams` event to save parameters for a plug-in.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object to be saved
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateSaveParams
		 *
		 *  @example
		 *    // Remove a saved filter, so filtering is never saved
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateSaveParams": function (settings, data) {
		 *          data.oSearch.sSearch = "";
		 *        }
		 *      } );
		 *    } );
		 */ "fnStateSaveParams": null,
        /**
		 * Duration for which the saved state information is considered valid. After this period
		 * has elapsed the state will be returned to the default.
		 * Value is given in seconds.
		 *  @type int
		 *  @default 7200 <i>(2 hours)</i>
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.stateDuration
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateDuration": 60*60*24; // 1 day
		 *      } );
		 *    } )
		 */ "iStateDuration": 7200,
        /**
		 * When enabled DataTables will not make a request to the server for the first
		 * page draw - rather it will use the data already on the page (no sorting etc
		 * will be applied to it), thus saving on an XHR at load time. `deferLoading`
		 * is used to indicate that deferred loading is required, but it is also used
		 * to tell DataTables how many records there are in the full table (allowing
		 * the information element and pagination to be displayed correctly). In the case
		 * where a filtering is applied to the table on initial load, this can be
		 * indicated by giving the parameter as an array, where the first element is
		 * the number of records available after filtering and the second element is the
		 * number of records without filtering (allowing the table information element
		 * to be shown correctly).
		 *  @type int | array
		 *  @default null
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.deferLoading
		 *
		 *  @example
		 *    // 57 records available in the table, no filtering applied
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "serverSide": true,
		 *        "ajax": "scripts/server_processing.php",
		 *        "deferLoading": 57
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // 57 records after filtering, 100 without filtering (an initial filter applied)
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "serverSide": true,
		 *        "ajax": "scripts/server_processing.php",
		 *        "deferLoading": [ 57, 100 ],
		 *        "search": {
		 *          "search": "my_filter"
		 *        }
		 *      } );
		 *    } );
		 */ "iDeferLoading": null,
        /**
		 * Number of rows to display on a single page when using pagination. If
		 * feature enabled (`lengthChange`) then the end user will be able to override
		 * this to a custom setting using a pop-up menu.
		 *  @type int
		 *  @default 10
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.pageLength
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "pageLength": 50
		 *      } );
		 *    } )
		 */ "iDisplayLength": 10,
        /**
		 * Define the starting point for data display when using DataTables with
		 * pagination. Note that this parameter is the number of records, rather than
		 * the page number, so if you have 10 records per page and want to start on
		 * the third page, it should be "20".
		 *  @type int
		 *  @default 0
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.displayStart
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "displayStart": 20
		 *      } );
		 *    } )
		 */ "iDisplayStart": 0,
        /**
		 * By default DataTables allows keyboard navigation of the table (sorting, paging,
		 * and filtering) by adding a `tabindex` attribute to the required elements. This
		 * allows you to tab through the controls and press the enter key to activate them.
		 * The tabindex is default 0, meaning that the tab follows the flow of the document.
		 * You can overrule this using this parameter if you wish. Use a value of -1 to
		 * disable built-in keyboard navigation.
		 *  @type int
		 *  @default 0
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.tabIndex
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "tabIndex": 1
		 *      } );
		 *    } );
		 */ "iTabIndex": 0,
        /**
		 * Classes that DataTables assigns to the various components and features
		 * that it adds to the HTML table. This allows classes to be configured
		 * during initialisation in addition to through the static
		 * {@link DataTable.ext.oStdClasses} object).
		 *  @namespace
		 *  @name DataTable.defaults.classes
		 */ "oClasses": {},
        /**
		 * All strings that DataTables uses in the user interface that it creates
		 * are defined in this object, allowing you to modified them individually or
		 * completely replace them all as required.
		 *  @namespace
		 *  @name DataTable.defaults.language
		 */ "oLanguage": {
            /**
			 * Strings that are used for WAI-ARIA labels and controls only (these are not
			 * actually visible on the page, but will be read by screenreaders, and thus
			 * must be internationalised as well).
			 *  @namespace
			 *  @name DataTable.defaults.language.aria
			 */ "oAria": {
                /**
				 * ARIA label that is added to the table headers when the column may be
				 * sorted ascending by activing the column (click or return when focused).
				 * Note that the column header is prefixed to this string.
				 *  @type string
				 *  @default : activate to sort column ascending
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.aria.sortAscending
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "aria": {
				 *            "sortAscending": " - click/return to sort ascending"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */ "sSortAscending": ": activate to sort column ascending",
                /**
				 * ARIA label that is added to the table headers when the column may be
				 * sorted descending by activing the column (click or return when focused).
				 * Note that the column header is prefixed to this string.
				 *  @type string
				 *  @default : activate to sort column ascending
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.aria.sortDescending
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "aria": {
				 *            "sortDescending": " - click/return to sort descending"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */ "sSortDescending": ": activate to sort column descending"
            },
            /**
			 * Pagination string used by DataTables for the built-in pagination
			 * control types.
			 *  @namespace
			 *  @name DataTable.defaults.language.paginate
			 */ "oPaginate": {
                /**
				 * Text to use when using the 'full_numbers' type of pagination for the
				 * button to take the user to the first page.
				 *  @type string
				 *  @default First
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.first
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "first": "First page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */ "sFirst": "First",
                /**
				 * Text to use when using the 'full_numbers' type of pagination for the
				 * button to take the user to the last page.
				 *  @type string
				 *  @default Last
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.last
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "last": "Last page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */ "sLast": "Last",
                /**
				 * Text to use for the 'next' pagination button (to take the user to the
				 * next page).
				 *  @type string
				 *  @default Next
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.next
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "next": "Next page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */ "sNext": "Next",
                /**
				 * Text to use for the 'previous' pagination button (to take the user to
				 * the previous page).
				 *  @type string
				 *  @default Previous
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.previous
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "previous": "Previous page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */ "sPrevious": "Previous"
            },
            /**
			 * This string is shown in preference to `zeroRecords` when the table is
			 * empty of data (regardless of filtering). Note that this is an optional
			 * parameter - if it is not given, the value of `zeroRecords` will be used
			 * instead (either the default or given value).
			 *  @type string
			 *  @default No data available in table
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.emptyTable
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "emptyTable": "No data available in table"
			 *        }
			 *      } );
			 *    } );
			 */ "sEmptyTable": "No data available in table",
            /**
			 * This string gives information to the end user about the information
			 * that is current on display on the page. The following tokens can be
			 * used in the string and will be dynamically replaced as the table
			 * display updates. This tokens can be placed anywhere in the string, or
			 * removed as needed by the language requires:
			 *
			 * * `\_START\_` - Display index of the first record on the current page
			 * * `\_END\_` - Display index of the last record on the current page
			 * * `\_TOTAL\_` - Number of records in the table after filtering
			 * * `\_MAX\_` - Number of records in the table without filtering
			 * * `\_PAGE\_` - Current page number
			 * * `\_PAGES\_` - Total number of pages of data in the table
			 *
			 *  @type string
			 *  @default Showing _START_ to _END_ of _TOTAL_ entries
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.info
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "info": "Showing page _PAGE_ of _PAGES_"
			 *        }
			 *      } );
			 *    } );
			 */ "sInfo": "Showing _START_ to _END_ of _TOTAL_ entries",
            /**
			 * Display information string for when the table is empty. Typically the
			 * format of this string should match `info`.
			 *  @type string
			 *  @default Showing 0 to 0 of 0 entries
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.infoEmpty
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "infoEmpty": "No entries to show"
			 *        }
			 *      } );
			 *    } );
			 */ "sInfoEmpty": "Showing 0 to 0 of 0 entries",
            /**
			 * When a user filters the information in a table, this string is appended
			 * to the information (`info`) to give an idea of how strong the filtering
			 * is. The variable _MAX_ is dynamically updated.
			 *  @type string
			 *  @default (filtered from _MAX_ total entries)
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.infoFiltered
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "infoFiltered": " - filtering from _MAX_ records"
			 *        }
			 *      } );
			 *    } );
			 */ "sInfoFiltered": "(filtered from _MAX_ total entries)",
            /**
			 * If can be useful to append extra information to the info string at times,
			 * and this variable does exactly that. This information will be appended to
			 * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
			 * being used) at all times.
			 *  @type string
			 *  @default <i>Empty string</i>
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.infoPostFix
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "infoPostFix": "All records shown are derived from real information."
			 *        }
			 *      } );
			 *    } );
			 */ "sInfoPostFix": "",
            /**
			 * This decimal place operator is a little different from the other
			 * language options since DataTables doesn't output floating point
			 * numbers, so it won't ever use this for display of a number. Rather,
			 * what this parameter does is modify the sort methods of the table so
			 * that numbers which are in a format which has a character other than
			 * a period (`.`) as a decimal place will be sorted numerically.
			 *
			 * Note that numbers with different decimal places cannot be shown in
			 * the same table and still be sortable, the table must be consistent.
			 * However, multiple different tables on the page can use different
			 * decimal place characters.
			 *  @type string
			 *  @default 
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.decimal
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "decimal": ","
			 *          "thousands": "."
			 *        }
			 *      } );
			 *    } );
			 */ "sDecimal": "",
            /**
			 * DataTables has a build in number formatter (`formatNumber`) which is
			 * used to format large numbers that are used in the table information.
			 * By default a comma is used, but this can be trivially changed to any
			 * character you wish with this parameter.
			 *  @type string
			 *  @default ,
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.thousands
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "thousands": "'"
			 *        }
			 *      } );
			 *    } );
			 */ "sThousands": ",",
            /**
			 * Detail the action that will be taken when the drop down menu for the
			 * pagination length option is changed. The '_MENU_' variable is replaced
			 * with a default select list of 10, 25, 50 and 100, and can be replaced
			 * with a custom select box if required.
			 *  @type string
			 *  @default Show _MENU_ entries
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.lengthMenu
			 *
			 *  @example
			 *    // Language change only
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "lengthMenu": "Display _MENU_ records"
			 *        }
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Language and options change
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "lengthMenu": 'Display <select>'+
			 *            '<option value="10">10</option>'+
			 *            '<option value="20">20</option>'+
			 *            '<option value="30">30</option>'+
			 *            '<option value="40">40</option>'+
			 *            '<option value="50">50</option>'+
			 *            '<option value="-1">All</option>'+
			 *            '</select> records'
			 *        }
			 *      } );
			 *    } );
			 */ "sLengthMenu": "Show _MENU_ entries",
            /**
			 * When using Ajax sourced data and during the first draw when DataTables is
			 * gathering the data, this message is shown in an empty row in the table to
			 * indicate to the end user the the data is being loaded. Note that this
			 * parameter is not used when loading data by server-side processing, just
			 * Ajax sourced data with client-side processing.
			 *  @type string
			 *  @default Loading...
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.loadingRecords
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "loadingRecords": "Please wait - loading..."
			 *        }
			 *      } );
			 *    } );
			 */ "sLoadingRecords": "Loading...",
            /**
			 * Text which is displayed when the table is processing a user action
			 * (usually a sort command or similar).
			 *  @type string
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.processing
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "processing": "DataTables is currently busy"
			 *        }
			 *      } );
			 *    } );
			 */ "sProcessing": "",
            /**
			 * Details the actions that will be taken when the user types into the
			 * filtering input text box. The variable "_INPUT_", if used in the string,
			 * is replaced with the HTML text box for the filtering input allowing
			 * control over where it appears in the string. If "_INPUT_" is not given
			 * then the input box is appended to the string automatically.
			 *  @type string
			 *  @default Search:
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.search
			 *
			 *  @example
			 *    // Input text box will be appended at the end automatically
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "search": "Filter records:"
			 *        }
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Specify where the filter should appear
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "search": "Apply filter _INPUT_ to table"
			 *        }
			 *      } );
			 *    } );
			 */ "sSearch": "Search:",
            /**
			 * Assign a `placeholder` attribute to the search `input` element
			 *  @type string
			 *  @default 
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.searchPlaceholder
			 */ "sSearchPlaceholder": "",
            /**
			 * All of the language information can be stored in a file on the
			 * server-side, which DataTables will look up if this parameter is passed.
			 * It must store the URL of the language file, which is in a JSON format,
			 * and the object has the same properties as the oLanguage object in the
			 * initialiser object (i.e. the above parameters). Please refer to one of
			 * the example language files to see how this works in action.
			 *  @type string
			 *  @default <i>Empty string - i.e. disabled</i>
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.url
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "url": "http://www.sprymedia.co.uk/dataTables/lang.txt"
			 *        }
			 *      } );
			 *    } );
			 */ "sUrl": "",
            /**
			 * Text shown inside the table records when the is no information to be
			 * displayed after filtering. `emptyTable` is shown when there is simply no
			 * information in the table at all (regardless of filtering).
			 *  @type string
			 *  @default No matching records found
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.zeroRecords
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "zeroRecords": "No records to display"
			 *        }
			 *      } );
			 *    } );
			 */ "sZeroRecords": "No matching records found"
        },
        /**
		 * This parameter allows you to have define the global filtering state at
		 * initialisation time. As an object the `search` parameter must be
		 * defined, but all other parameters are optional. When `regex` is true,
		 * the search string will be treated as a regular expression, when false
		 * (default) it will be treated as a straight string. When `smart`
		 * DataTables will use it's smart filtering methods (to word match at
		 * any point in the data), when false this will not be done.
		 *  @namespace
		 *  @extends DataTable.models.oSearch
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.search
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "search": {"search": "Initial search"}
		 *      } );
		 *    } )
		 */ "oSearch": $.extend({}, DataTable.models.oSearch),
        /**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * By default DataTables will look for the property `data` (or `aaData` for
		 * compatibility with DataTables 1.9-) when obtaining data from an Ajax
		 * source or for server-side processing - this parameter allows that
		 * property to be changed. You can use Javascript dotted object notation to
		 * get a data source for multiple levels of nesting.
		 *  @type string
		 *  @default data
		 *
		 *  @dtopt Options
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.ajaxDataProp
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */ "sAjaxDataProp": "data",
        /**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * You can instruct DataTables to load data from an external
		 * source using this parameter (use aData if you want to pass data in you
		 * already have). Simply provide a url a JSON object can be obtained from.
		 *  @type string
		 *  @default null
		 *
		 *  @dtopt Options
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.ajaxSource
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */ "sAjaxSource": null,
        /**
		 * This initialisation variable allows you to specify exactly where in the
		 * DOM you want DataTables to inject the various controls it adds to the page
		 * (for example you might want the pagination controls at the top of the
		 * table). DIV elements (with or without a custom class) can also be added to
		 * aid styling. The follow syntax is used:
		 *   <ul>
		 *     <li>The following options are allowed:
		 *       <ul>
		 *         <li>'l' - Length changing</li>
		 *         <li>'f' - Filtering input</li>
		 *         <li>'t' - The table!</li>
		 *         <li>'i' - Information</li>
		 *         <li>'p' - Pagination</li>
		 *         <li>'r' - pRocessing</li>
		 *       </ul>
		 *     </li>
		 *     <li>The following constants are allowed:
		 *       <ul>
		 *         <li>'H' - jQueryUI theme "header" classes ('fg-toolbar ui-widget-header ui-corner-tl ui-corner-tr ui-helper-clearfix')</li>
		 *         <li>'F' - jQueryUI theme "footer" classes ('fg-toolbar ui-widget-header ui-corner-bl ui-corner-br ui-helper-clearfix')</li>
		 *       </ul>
		 *     </li>
		 *     <li>The following syntax is expected:
		 *       <ul>
		 *         <li>'&lt;' and '&gt;' - div elements</li>
		 *         <li>'&lt;"class" and '&gt;' - div with a class</li>
		 *         <li>'&lt;"#id" and '&gt;' - div with an ID</li>
		 *       </ul>
		 *     </li>
		 *     <li>Examples:
		 *       <ul>
		 *         <li>'&lt;"wrapper"flipt&gt;'</li>
		 *         <li>'&lt;lf&lt;t&gt;ip&gt;'</li>
		 *       </ul>
		 *     </li>
		 *   </ul>
		 *  @type string
		 *  @default lfrtip <i>(when `jQueryUI` is false)</i> <b>or</b>
		 *    <"H"lfr>t<"F"ip> <i>(when `jQueryUI` is true)</i>
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.dom
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "dom": '&lt;"top"i&gt;rt&lt;"bottom"flp&gt;&lt;"clear"&gt;'
		 *      } );
		 *    } );
		 */ "sDom": "lfrtip",
        /**
		 * Search delay option. This will throttle full table searches that use the
		 * DataTables provided search input element (it does not effect calls to
		 * `dt-api search()`, providing a delay before the search is made.
		 *  @type integer
		 *  @default 0
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.searchDelay
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "searchDelay": 200
		 *      } );
		 *    } )
		 */ "searchDelay": null,
        /**
		 * DataTables features six different built-in options for the buttons to
		 * display for pagination control:
		 *
		 * * `numbers` - Page number buttons only
		 * * `simple` - 'Previous' and 'Next' buttons only
		 * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
		 * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
		 * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus page numbers
		 * * `first_last_numbers` - 'First' and 'Last' buttons, plus page numbers
		 *  
		 * Further methods can be added using {@link DataTable.ext.oPagination}.
		 *  @type string
		 *  @default simple_numbers
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.pagingType
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "pagingType": "full_numbers"
		 *      } );
		 *    } )
		 */ "sPaginationType": "simple_numbers",
        /**
		 * Enable horizontal scrolling. When a table is too wide to fit into a
		 * certain layout, or you have a large number of columns in the table, you
		 * can enable x-scrolling to show the table in a viewport, which can be
		 * scrolled. This property can be `true` which will allow the table to
		 * scroll horizontally when needed, or any CSS unit, or a number (in which
		 * case it will be treated as a pixel measurement). Setting as simply `true`
		 * is recommended.
		 *  @type boolean|string
		 *  @default <i>blank string - i.e. disabled</i>
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.scrollX
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollX": true,
		 *        "scrollCollapse": true
		 *      } );
		 *    } );
		 */ "sScrollX": "",
        /**
		 * This property can be used to force a DataTable to use more width than it
		 * might otherwise do when x-scrolling is enabled. For example if you have a
		 * table which requires to be well spaced, this parameter is useful for
		 * "over-sizing" the table, and thus forcing scrolling. This property can by
		 * any CSS unit, or a number (in which case it will be treated as a pixel
		 * measurement).
		 *  @type string
		 *  @default <i>blank string - i.e. disabled</i>
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.scrollXInner
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollX": "100%",
		 *        "scrollXInner": "110%"
		 *      } );
		 *    } );
		 */ "sScrollXInner": "",
        /**
		 * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
		 * to the given height, and enable scrolling for any data which overflows the
		 * current viewport. This can be used as an alternative to paging to display
		 * a lot of data in a small area (although paging and scrolling can both be
		 * enabled at the same time). This property can be any CSS unit, or a number
		 * (in which case it will be treated as a pixel measurement).
		 *  @type string
		 *  @default <i>blank string - i.e. disabled</i>
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.scrollY
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollY": "200px",
		 *        "paginate": false
		 *      } );
		 *    } );
		 */ "sScrollY": "",
        /**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * Set the HTTP method that is used to make the Ajax call for server-side
		 * processing or Ajax sourced data.
		 *  @type string
		 *  @default GET
		 *
		 *  @dtopt Options
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverMethod
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */ "sServerMethod": "GET",
        /**
		 * DataTables makes use of renderers when displaying HTML elements for
		 * a table. These renderers can be added or modified by plug-ins to
		 * generate suitable mark-up for a site. For example the Bootstrap
		 * integration plug-in for DataTables uses a paging button renderer to
		 * display pagination buttons in the mark-up required by Bootstrap.
		 *
		 * For further information about the renderers available see
		 * DataTable.ext.renderer
		 *  @type string|object
		 *  @default null
		 *
		 *  @name DataTable.defaults.renderer
		 *
		 */ "renderer": null,
        /**
		 * Set the data property name that DataTables should use to get a row's id
		 * to set as the `id` property in the node.
		 *  @type string
		 *  @default DT_RowId
		 *
		 *  @name DataTable.defaults.rowId
		 */ "rowId": "DT_RowId"
    };
    _fnHungarianMap(DataTable.defaults);
    /*
	 * Developer note - See note in model.defaults.js about the use of Hungarian
	 * notation and camel case.
	 */ /**
	 * Column options that can be given to DataTables at initialisation time.
	 *  @namespace
	 */ DataTable.defaults.column = {
        /**
		 * Define which column(s) an order will occur on for this column. This
		 * allows a column's ordering to take multiple columns into account when
		 * doing a sort or use the data from a different column. For example first
		 * name / last name columns make sense to do a multi-column sort over the
		 * two columns.
		 *  @type array|int
		 *  @default null <i>Takes the value of the column index automatically</i>
		 *
		 *  @name DataTable.defaults.column.orderData
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderData": [ 0, 1 ], "targets": [ 0 ] },
		 *          { "orderData": [ 1, 0 ], "targets": [ 1 ] },
		 *          { "orderData": 2, "targets": [ 2 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "orderData": [ 0, 1 ] },
		 *          { "orderData": [ 1, 0 ] },
		 *          { "orderData": 2 },
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */ "aDataSort": null,
        "iDataSort": -1,
        /**
		 * You can control the default ordering direction, and even alter the
		 * behaviour of the sort handler (i.e. only allow ascending ordering etc)
		 * using this parameter.
		 *  @type array
		 *  @default [ 'asc', 'desc' ]
		 *
		 *  @name DataTable.defaults.column.orderSequence
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderSequence": [ "asc" ], "targets": [ 1 ] },
		 *          { "orderSequence": [ "desc", "asc", "asc" ], "targets": [ 2 ] },
		 *          { "orderSequence": [ "desc" ], "targets": [ 3 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          { "orderSequence": [ "asc" ] },
		 *          { "orderSequence": [ "desc", "asc", "asc" ] },
		 *          { "orderSequence": [ "desc" ] },
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */ "asSorting": [
            "asc",
            "desc"
        ],
        /**
		 * Enable or disable filtering on the data in this column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @name DataTable.defaults.column.searchable
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "searchable": false, "targets": [ 0 ] }
		 *        ] } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "searchable": false },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ] } );
		 *    } );
		 */ "bSearchable": true,
        /**
		 * Enable or disable ordering on this column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @name DataTable.defaults.column.orderable
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderable": false, "targets": [ 0 ] }
		 *        ] } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "orderable": false },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ] } );
		 *    } );
		 */ "bSortable": true,
        /**
		 * Enable or disable the display of this column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @name DataTable.defaults.column.visible
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "visible": false, "targets": [ 0 ] }
		 *        ] } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "visible": false },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ] } );
		 *    } );
		 */ "bVisible": true,
        /**
		 * Developer definable function that is called whenever a cell is created (Ajax source,
		 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
		 * allowing you to modify the DOM element (add background colour for example) when the
		 * element is available.
		 *  @type function
		 *  @param {element} td The TD node that has been created
		 *  @param {*} cellData The Data for the cell
		 *  @param {array|object} rowData The data for the whole row
		 *  @param {int} row The row index for the aoData data store
		 *  @param {int} col The column index for aoColumns
		 *
		 *  @name DataTable.defaults.column.createdCell
		 *  @dtopt Columns
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [3],
		 *          "createdCell": function (td, cellData, rowData, row, col) {
		 *            if ( cellData == "1.7" ) {
		 *              $(td).css('color', 'blue')
		 *            }
		 *          }
		 *        } ]
		 *      });
		 *    } );
		 */ "fnCreatedCell": null,
        /**
		 * This parameter has been replaced by `data` in DataTables to ensure naming
		 * consistency. `dataProp` can still be used, as there is backwards
		 * compatibility in DataTables for this option, but it is strongly
		 * recommended that you use `data` in preference to `dataProp`.
		 *  @name DataTable.defaults.column.dataProp
		 */ /**
		 * This property can be used to read data from any data source property,
		 * including deeply nested objects / properties. `data` can be given in a
		 * number of different ways which effect its behaviour:
		 *
		 * * `integer` - treated as an array index for the data source. This is the
		 *   default that DataTables uses (incrementally increased for each column).
		 * * `string` - read an object property from the data source. There are
		 *   three 'special' options that can be used in the string to alter how
		 *   DataTables reads the data from the source object:
		 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
		 *      Javascript to read from nested objects, so to can the options
		 *      specified in `data`. For example: `browser.version` or
		 *      `browser.name`. If your object parameter name contains a period, use
		 *      `\\` to escape it - i.e. `first\\.name`.
		 *    * `[]` - Array notation. DataTables can automatically combine data
		 *      from and array source, joining the data with the characters provided
		 *      between the two brackets. For example: `name[, ]` would provide a
		 *      comma-space separated list from the source array. If no characters
		 *      are provided between the brackets, the original array source is
		 *      returned.
		 *    * `()` - Function notation. Adding `()` to the end of a parameter will
		 *      execute a function of the name given. For example: `browser()` for a
		 *      simple function on the data source, `browser.version()` for a
		 *      function in a nested property or even `browser().version` to get an
		 *      object property if the function called returns an object. Note that
		 *      function notation is recommended for use in `render` rather than
		 *      `data` as it is much simpler to use as a renderer.
		 * * `null` - use the original data source for the row rather than plucking
		 *   data directly from it. This action has effects on two other
		 *   initialisation options:
		 *    * `defaultContent` - When null is given as the `data` option and
		 *      `defaultContent` is specified for the column, the value defined by
		 *      `defaultContent` will be used for the cell.
		 *    * `render` - When null is used for the `data` option and the `render`
		 *      option is specified for the column, the whole data source for the
		 *      row is used for the renderer.
		 * * `function` - the function given will be executed whenever DataTables
		 *   needs to set or get the data for a cell in the column. The function
		 *   takes three parameters:
		 *    * Parameters:
		 *      * `{array|object}` The data source for the row
		 *      * `{string}` The type call data requested - this will be 'set' when
		 *        setting data or 'filter', 'display', 'type', 'sort' or undefined
		 *        when gathering data. Note that when `undefined` is given for the
		 *        type DataTables expects to get the raw data for the object back<
		 *      * `{*}` Data to set when the second parameter is 'set'.
		 *    * Return:
		 *      * The return value from the function is not required when 'set' is
		 *        the type of call, but otherwise the return is what will be used
		 *        for the data requested.
		 *
		 * Note that `data` is a getter and setter option. If you just require
		 * formatting of data for output, you will likely want to use `render` which
		 * is simply a getter and thus simpler to use.
		 *
		 * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
		 * name change reflects the flexibility of this property and is consistent
		 * with the naming of mRender. If 'mDataProp' is given, then it will still
		 * be used by DataTables, as it automatically maps the old name to the new
		 * if required.
		 *
		 *  @type string|int|function|null
		 *  @default null <i>Use automatically calculated column index</i>
		 *
		 *  @name DataTable.defaults.column.data
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Read table data from objects
		 *    // JSON structure for each row:
		 *    //   {
		 *    //      "engine": {value},
		 *    //      "browser": {value},
		 *    //      "platform": {value},
		 *    //      "version": {value},
		 *    //      "grade": {value}
		 *    //   }
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajaxSource": "sources/objects.txt",
		 *        "columns": [
		 *          { "data": "engine" },
		 *          { "data": "browser" },
		 *          { "data": "platform" },
		 *          { "data": "version" },
		 *          { "data": "grade" }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Read information from deeply nested objects
		 *    // JSON structure for each row:
		 *    //   {
		 *    //      "engine": {value},
		 *    //      "browser": {value},
		 *    //      "platform": {
		 *    //         "inner": {value}
		 *    //      },
		 *    //      "details": [
		 *    //         {value}, {value}
		 *    //      ]
		 *    //   }
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajaxSource": "sources/deep.txt",
		 *        "columns": [
		 *          { "data": "engine" },
		 *          { "data": "browser" },
		 *          { "data": "platform.inner" },
		 *          { "data": "details.0" },
		 *          { "data": "details.1" }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `data` as a function to provide different information for
		 *    // sorting, filtering and display. In this case, currency (price)
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": function ( source, type, val ) {
		 *            if (type === 'set') {
		 *              source.price = val;
		 *              // Store the computed display and filter values for efficiency
		 *              source.price_display = val=="" ? "" : "$"+numberFormat(val);
		 *              source.price_filter  = val=="" ? "" : "$"+numberFormat(val)+" "+val;
		 *              return;
		 *            }
		 *            else if (type === 'display') {
		 *              return source.price_display;
		 *            }
		 *            else if (type === 'filter') {
		 *              return source.price_filter;
		 *            }
		 *            // 'sort', 'type' and undefined all just use the integer
		 *            return source.price;
		 *          }
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using default content
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": null,
		 *          "defaultContent": "Click to edit"
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using array notation - outputting a list from an array
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": "name[, ]"
		 *        } ]
		 *      } );
		 *    } );
		 *
		 */ "mData": null,
        /**
		 * This property is the rendering partner to `data` and it is suggested that
		 * when you want to manipulate data for display (including filtering,
		 * sorting etc) without altering the underlying data for the table, use this
		 * property. `render` can be considered to be the the read only companion to
		 * `data` which is read / write (then as such more complex). Like `data`
		 * this option can be given in a number of different ways to effect its
		 * behaviour:
		 *
		 * * `integer` - treated as an array index for the data source. This is the
		 *   default that DataTables uses (incrementally increased for each column).
		 * * `string` - read an object property from the data source. There are
		 *   three 'special' options that can be used in the string to alter how
		 *   DataTables reads the data from the source object:
		 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
		 *      Javascript to read from nested objects, so to can the options
		 *      specified in `data`. For example: `browser.version` or
		 *      `browser.name`. If your object parameter name contains a period, use
		 *      `\\` to escape it - i.e. `first\\.name`.
		 *    * `[]` - Array notation. DataTables can automatically combine data
		 *      from and array source, joining the data with the characters provided
		 *      between the two brackets. For example: `name[, ]` would provide a
		 *      comma-space separated list from the source array. If no characters
		 *      are provided between the brackets, the original array source is
		 *      returned.
		 *    * `()` - Function notation. Adding `()` to the end of a parameter will
		 *      execute a function of the name given. For example: `browser()` for a
		 *      simple function on the data source, `browser.version()` for a
		 *      function in a nested property or even `browser().version` to get an
		 *      object property if the function called returns an object.
		 * * `object` - use different data for the different data types requested by
		 *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
		 *   of the object is the data type the property refers to and the value can
		 *   defined using an integer, string or function using the same rules as
		 *   `render` normally does. Note that an `_` option _must_ be specified.
		 *   This is the default value to use if you haven't specified a value for
		 *   the data type requested by DataTables.
		 * * `function` - the function given will be executed whenever DataTables
		 *   needs to set or get the data for a cell in the column. The function
		 *   takes three parameters:
		 *    * Parameters:
		 *      * {array|object} The data source for the row (based on `data`)
		 *      * {string} The type call data requested - this will be 'filter',
		 *        'display', 'type' or 'sort'.
		 *      * {array|object} The full data source for the row (not based on
		 *        `data`)
		 *    * Return:
		 *      * The return value from the function is what will be used for the
		 *        data requested.
		 *
		 *  @type string|int|function|object|null
		 *  @default null Use the data source value.
		 *
		 *  @name DataTable.defaults.column.render
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Create a comma separated list from an array of objects
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajaxSource": "sources/deep.txt",
		 *        "columns": [
		 *          { "data": "engine" },
		 *          { "data": "browser" },
		 *          {
		 *            "data": "platform",
		 *            "render": "[, ].name"
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Execute a function to obtain data
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": null, // Use the full data source object for the renderer's source
		 *          "render": "browserName()"
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // As an object, extracting different data for the different types
		 *    // This would be used with a data source such as:
		 *    //   { "phone": 5552368, "phone_filter": "5552368 555-2368", "phone_display": "555-2368" }
		 *    // Here the `phone` integer is used for sorting and type detection, while `phone_filter`
		 *    // (which has both forms) is used for filtering for if a user inputs either format, while
		 *    // the formatted phone number is the one that is shown in the table.
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": null, // Use the full data source object for the renderer's source
		 *          "render": {
		 *            "_": "phone",
		 *            "filter": "phone_filter",
		 *            "display": "phone_display"
		 *          }
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Use as a function to create a link from the data source
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": "download_link",
		 *          "render": function ( data, type, full ) {
		 *            return '<a href="'+data+'">Download</a>';
		 *          }
		 *        } ]
		 *      } );
		 *    } );
		 */ "mRender": null,
        /**
		 * Change the cell type created for the column - either TD cells or TH cells. This
		 * can be useful as TH cells have semantic meaning in the table body, allowing them
		 * to act as a header for a row (you may wish to add scope='row' to the TH elements).
		 *  @type string
		 *  @default td
		 *
		 *  @name DataTable.defaults.column.cellType
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Make the first column use TH cells
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "cellType": "th"
		 *        } ]
		 *      } );
		 *    } );
		 */ "sCellType": "td",
        /**
		 * Class to give to each cell in this column.
		 *  @type string
		 *  @default <i>Empty string</i>
		 *
		 *  @name DataTable.defaults.column.class
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "class": "my_class", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "class": "my_class" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */ "sClass": "",
        /**
		 * When DataTables calculates the column widths to assign to each column,
		 * it finds the longest string in each column and then constructs a
		 * temporary table and reads the widths from that. The problem with this
		 * is that "mmm" is much wider then "iiii", but the latter is a longer
		 * string - thus the calculation can go wrong (doing it properly and putting
		 * it into an DOM object and measuring that is horribly(!) slow). Thus as
		 * a "work around" we provide this option. It will append its value to the
		 * text that is found to be the longest string for the column - i.e. padding.
		 * Generally you shouldn't need this!
		 *  @type string
		 *  @default <i>Empty string<i>
		 *
		 *  @name DataTable.defaults.column.contentPadding
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          null,
		 *          null,
		 *          {
		 *            "contentPadding": "mmm"
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 */ "sContentPadding": "",
        /**
		 * Allows a default value to be given for a column's data, and will be used
		 * whenever a null data source is encountered (this can be because `data`
		 * is set to null, or because the data source itself is null).
		 *  @type string
		 *  @default null
		 *
		 *  @name DataTable.defaults.column.defaultContent
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          {
		 *            "data": null,
		 *            "defaultContent": "Edit",
		 *            "targets": [ -1 ]
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          null,
		 *          null,
		 *          {
		 *            "data": null,
		 *            "defaultContent": "Edit"
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 */ "sDefaultContent": null,
        /**
		 * This parameter is only used in DataTables' server-side processing. It can
		 * be exceptionally useful to know what columns are being displayed on the
		 * client side, and to map these to database fields. When defined, the names
		 * also allow DataTables to reorder information from the server if it comes
		 * back in an unexpected order (i.e. if you switch your columns around on the
		 * client-side, your server-side code does not also need updating).
		 *  @type string
		 *  @default <i>Empty string</i>
		 *
		 *  @name DataTable.defaults.column.name
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "name": "engine", "targets": [ 0 ] },
		 *          { "name": "browser", "targets": [ 1 ] },
		 *          { "name": "platform", "targets": [ 2 ] },
		 *          { "name": "version", "targets": [ 3 ] },
		 *          { "name": "grade", "targets": [ 4 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "name": "engine" },
		 *          { "name": "browser" },
		 *          { "name": "platform" },
		 *          { "name": "version" },
		 *          { "name": "grade" }
		 *        ]
		 *      } );
		 *    } );
		 */ "sName": "",
        /**
		 * Defines a data source type for the ordering which can be used to read
		 * real-time information from the table (updating the internally cached
		 * version) prior to ordering. This allows ordering to occur on user
		 * editable elements such as form inputs.
		 *  @type string
		 *  @default std
		 *
		 *  @name DataTable.defaults.column.orderDataType
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderDataType": "dom-text", "targets": [ 2, 3 ] },
		 *          { "type": "numeric", "targets": [ 3 ] },
		 *          { "orderDataType": "dom-select", "targets": [ 4 ] },
		 *          { "orderDataType": "dom-checkbox", "targets": [ 5 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          null,
		 *          { "orderDataType": "dom-text" },
		 *          { "orderDataType": "dom-text", "type": "numeric" },
		 *          { "orderDataType": "dom-select" },
		 *          { "orderDataType": "dom-checkbox" }
		 *        ]
		 *      } );
		 *    } );
		 */ "sSortDataType": "std",
        /**
		 * The title of this column.
		 *  @type string
		 *  @default null <i>Derived from the 'TH' value for this column in the
		 *    original HTML table.</i>
		 *
		 *  @name DataTable.defaults.column.title
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "title": "My column title", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "title": "My column title" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */ "sTitle": null,
        /**
		 * The type allows you to specify how the data for this column will be
		 * ordered. Four types (string, numeric, date and html (which will strip
		 * HTML tags before ordering)) are currently available. Note that only date
		 * formats understood by Javascript's Date() object will be accepted as type
		 * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
		 * 'numeric', 'date' or 'html' (by default). Further types can be adding
		 * through plug-ins.
		 *  @type string
		 *  @default null <i>Auto-detected from raw data</i>
		 *
		 *  @name DataTable.defaults.column.type
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "type": "html", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "type": "html" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */ "sType": null,
        /**
		 * Defining the width of the column, this parameter may take any CSS value
		 * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
		 * been given a specific width through this interface ensuring that the table
		 * remains readable.
		 *  @type string
		 *  @default null <i>Automatic</i>
		 *
		 *  @name DataTable.defaults.column.width
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "width": "20%", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "width": "20%" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */ "sWidth": null
    };
    _fnHungarianMap(DataTable.defaults.column);
    /**
	 * DataTables settings object - this holds all the information needed for a
	 * given table, including configuration, data and current application of the
	 * table options. DataTables does not have a single instance for each DataTable
	 * with the settings attached to that instance, but rather instances of the
	 * DataTable "class" are created on-the-fly as needed (typically by a
	 * $().dataTable() call) and the settings object is then applied to that
	 * instance.
	 *
	 * Note that this object is related to {@link DataTable.defaults} but this
	 * one is the internal data store for DataTables's cache of columns. It should
	 * NOT be manipulated outside of DataTables. Any configuration should be done
	 * through the initialisation options.
	 *  @namespace
	 *  @todo Really should attach the settings object to individual instances so we
	 *    don't need to create new instances on each $().dataTable() call (if the
	 *    table already exists). It would also save passing oSettings around and
	 *    into every single function. However, this is a very significant
	 *    architecture change for DataTables and will almost certainly break
	 *    backwards compatibility with older installations. This is something that
	 *    will be done in 2.0.
	 */ DataTable.models.oSettings = {
        /**
		 * Primary features of DataTables and their enablement state.
		 *  @namespace
		 */ "oFeatures": {
            /**
			 * Flag to say if DataTables should automatically try to calculate the
			 * optimum table and columns widths (true) or not (false).
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */ "bAutoWidth": null,
            /**
			 * Delay the creation of TR and TD elements until they are actually
			 * needed by a driven page draw. This can give a significant speed
			 * increase for Ajax source and Javascript source data, but makes no
			 * difference at all for DOM and server-side processing tables.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */ "bDeferRender": null,
            /**
			 * Enable filtering on the table or not. Note that if this is disabled
			 * then there is no filtering at all on the table, including fnFilter.
			 * To just remove the filtering input use sDom and remove the 'f' option.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */ "bFilter": null,
            /**
			 * Table information element (the 'Showing x of y records' div) enable
			 * flag.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */ "bInfo": null,
            /**
			 * Present a user control allowing the end user to change the page size
			 * when pagination is enabled.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */ "bLengthChange": null,
            /**
			 * Pagination enabled or not. Note that if this is disabled then length
			 * changing must also be disabled.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */ "bPaginate": null,
            /**
			 * Processing indicator enable flag whenever DataTables is enacting a
			 * user request - typically an Ajax request for server-side processing.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */ "bProcessing": null,
            /**
			 * Server-side processing enabled flag - when enabled DataTables will
			 * get all data from the server for every draw - there is no filtering,
			 * sorting or paging done on the client-side.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */ "bServerSide": null,
            /**
			 * Sorting enablement flag.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */ "bSort": null,
            /**
			 * Multi-column sorting
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */ "bSortMulti": null,
            /**
			 * Apply a class to the columns which are being sorted to provide a
			 * visual highlight or not. This can slow things down when enabled since
			 * there is a lot of DOM interaction.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */ "bSortClasses": null,
            /**
			 * State saving enablement flag.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */ "bStateSave": null
        },
        /**
		 * Scrolling settings for a table.
		 *  @namespace
		 */ "oScroll": {
            /**
			 * When the table is shorter in height than sScrollY, collapse the
			 * table container down to the height of the table (when true).
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */ "bCollapse": null,
            /**
			 * Width of the scrollbar for the web-browser's platform. Calculated
			 * during table initialisation.
			 *  @type int
			 *  @default 0
			 */ "iBarWidth": 0,
            /**
			 * Viewport width for horizontal scrolling. Horizontal scrolling is
			 * disabled if an empty string.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 */ "sX": null,
            /**
			 * Width to expand the table to when using x-scrolling. Typically you
			 * should not need to use this.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 *  @deprecated
			 */ "sXInner": null,
            /**
			 * Viewport height for vertical scrolling. Vertical scrolling is disabled
			 * if an empty string.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 */ "sY": null
        },
        /**
		 * Language information for the table.
		 *  @namespace
		 *  @extends DataTable.defaults.oLanguage
		 */ "oLanguage": {
            /**
			 * Information callback function. See
			 * {@link DataTable.defaults.fnInfoCallback}
			 *  @type function
			 *  @default null
			 */ "fnInfoCallback": null
        },
        /**
		 * Browser support parameters
		 *  @namespace
		 */ "oBrowser": {
            /**
			 * Indicate if the browser incorrectly calculates width:100% inside a
			 * scrolling element (IE6/7)
			 *  @type boolean
			 *  @default false
			 */ "bScrollOversize": false,
            /**
			 * Determine if the vertical scrollbar is on the right or left of the
			 * scrolling container - needed for rtl language layout, although not
			 * all browsers move the scrollbar (Safari).
			 *  @type boolean
			 *  @default false
			 */ "bScrollbarLeft": false,
            /**
			 * Flag for if `getBoundingClientRect` is fully supported or not
			 *  @type boolean
			 *  @default false
			 */ "bBounding": false,
            /**
			 * Browser scrollbar width
			 *  @type integer
			 *  @default 0
			 */ "barWidth": 0
        },
        "ajax": null,
        /**
		 * Array referencing the nodes which are used for the features. The
		 * parameters of this object match what is allowed by sDom - i.e.
		 *   <ul>
		 *     <li>'l' - Length changing</li>
		 *     <li>'f' - Filtering input</li>
		 *     <li>'t' - The table!</li>
		 *     <li>'i' - Information</li>
		 *     <li>'p' - Pagination</li>
		 *     <li>'r' - pRocessing</li>
		 *   </ul>
		 *  @type array
		 *  @default []
		 */ "aanFeatures": [],
        /**
		 * Store data information - see {@link DataTable.models.oRow} for detailed
		 * information.
		 *  @type array
		 *  @default []
		 */ "aoData": [],
        /**
		 * Array of indexes which are in the current display (after filtering etc)
		 *  @type array
		 *  @default []
		 */ "aiDisplay": [],
        /**
		 * Array of indexes for display - no filtering
		 *  @type array
		 *  @default []
		 */ "aiDisplayMaster": [],
        /**
		 * Map of row ids to data indexes
		 *  @type object
		 *  @default {}
		 */ "aIds": {},
        /**
		 * Store information about each column that is in use
		 *  @type array
		 *  @default []
		 */ "aoColumns": [],
        /**
		 * Store information about the table's header
		 *  @type array
		 *  @default []
		 */ "aoHeader": [],
        /**
		 * Store information about the table's footer
		 *  @type array
		 *  @default []
		 */ "aoFooter": [],
        /**
		 * Store the applied global search information in case we want to force a
		 * research or compare the old search to a new one.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @namespace
		 *  @extends DataTable.models.oSearch
		 */ "oPreviousSearch": {},
        /**
		 * Store the applied search for each column - see
		 * {@link DataTable.models.oSearch} for the format that is used for the
		 * filtering information for each column.
		 *  @type array
		 *  @default []
		 */ "aoPreSearchCols": [],
        /**
		 * Sorting that is applied to the table. Note that the inner arrays are
		 * used in the following manner:
		 * <ul>
		 *   <li>Index 0 - column number</li>
		 *   <li>Index 1 - current sorting direction</li>
		 * </ul>
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @todo These inner arrays should really be objects
		 */ "aaSorting": null,
        /**
		 * Sorting that is always applied to the table (i.e. prefixed in front of
		 * aaSorting).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @default []
		 */ "aaSortingFixed": [],
        /**
		 * Classes to use for the striping of a table.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @default []
		 */ "asStripeClasses": null,
        /**
		 * If restoring a table - we should restore its striping classes as well
		 *  @type array
		 *  @default []
		 */ "asDestroyStripes": [],
        /**
		 * If restoring a table - we should restore its width
		 *  @type int
		 *  @default 0
		 */ "sDestroyWidth": 0,
        /**
		 * Callback functions array for every time a row is inserted (i.e. on a draw).
		 *  @type array
		 *  @default []
		 */ "aoRowCallback": [],
        /**
		 * Callback functions for the header on each draw.
		 *  @type array
		 *  @default []
		 */ "aoHeaderCallback": [],
        /**
		 * Callback function for the footer on each draw.
		 *  @type array
		 *  @default []
		 */ "aoFooterCallback": [],
        /**
		 * Array of callback functions for draw callback functions
		 *  @type array
		 *  @default []
		 */ "aoDrawCallback": [],
        /**
		 * Array of callback functions for row created function
		 *  @type array
		 *  @default []
		 */ "aoRowCreatedCallback": [],
        /**
		 * Callback functions for just before the table is redrawn. A return of
		 * false will be used to cancel the draw.
		 *  @type array
		 *  @default []
		 */ "aoPreDrawCallback": [],
        /**
		 * Callback functions for when the table has been initialised.
		 *  @type array
		 *  @default []
		 */ "aoInitComplete": [],
        /**
		 * Callbacks for modifying the settings to be stored for state saving, prior to
		 * saving state.
		 *  @type array
		 *  @default []
		 */ "aoStateSaveParams": [],
        /**
		 * Callbacks for modifying the settings that have been stored for state saving
		 * prior to using the stored values to restore the state.
		 *  @type array
		 *  @default []
		 */ "aoStateLoadParams": [],
        /**
		 * Callbacks for operating on the settings object once the saved state has been
		 * loaded
		 *  @type array
		 *  @default []
		 */ "aoStateLoaded": [],
        /**
		 * Cache the table ID for quick access
		 *  @type string
		 *  @default <i>Empty string</i>
		 */ "sTableId": "",
        /**
		 * The TABLE node for the main table
		 *  @type node
		 *  @default null
		 */ "nTable": null,
        /**
		 * Permanent ref to the thead element
		 *  @type node
		 *  @default null
		 */ "nTHead": null,
        /**
		 * Permanent ref to the tfoot element - if it exists
		 *  @type node
		 *  @default null
		 */ "nTFoot": null,
        /**
		 * Permanent ref to the tbody element
		 *  @type node
		 *  @default null
		 */ "nTBody": null,
        /**
		 * Cache the wrapper node (contains all DataTables controlled elements)
		 *  @type node
		 *  @default null
		 */ "nTableWrapper": null,
        /**
		 * Indicate if when using server-side processing the loading of data
		 * should be deferred until the second draw.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 *  @default false
		 */ "bDeferLoading": false,
        /**
		 * Indicate if all required information has been read in
		 *  @type boolean
		 *  @default false
		 */ "bInitialised": false,
        /**
		 * Information about open rows. Each object in the array has the parameters
		 * 'nTr' and 'nParent'
		 *  @type array
		 *  @default []
		 */ "aoOpenRows": [],
        /**
		 * Dictate the positioning of DataTables' control elements - see
		 * {@link DataTable.model.oInit.sDom}.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @default null
		 */ "sDom": null,
        /**
		 * Search delay (in mS)
		 *  @type integer
		 *  @default null
		 */ "searchDelay": null,
        /**
		 * Which type of pagination should be used.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @default two_button
		 */ "sPaginationType": "two_button",
        /**
		 * The state duration (for `stateSave`) in seconds.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type int
		 *  @default 0
		 */ "iStateDuration": 0,
        /**
		 * Array of callback functions for state saving. Each array element is an
		 * object with the following parameters:
		 *   <ul>
		 *     <li>function:fn - function to call. Takes two parameters, oSettings
		 *       and the JSON string to save that has been thus far created. Returns
		 *       a JSON string to be inserted into a json object
		 *       (i.e. '"param": [ 0, 1, 2]')</li>
		 *     <li>string:sName - name of callback</li>
		 *   </ul>
		 *  @type array
		 *  @default []
		 */ "aoStateSave": [],
        /**
		 * Array of callback functions for state loading. Each array element is an
		 * object with the following parameters:
		 *   <ul>
		 *     <li>function:fn - function to call. Takes two parameters, oSettings
		 *       and the object stored. May return false to cancel state loading</li>
		 *     <li>string:sName - name of callback</li>
		 *   </ul>
		 *  @type array
		 *  @default []
		 */ "aoStateLoad": [],
        /**
		 * State that was saved. Useful for back reference
		 *  @type object
		 *  @default null
		 */ "oSavedState": null,
        /**
		 * State that was loaded. Useful for back reference
		 *  @type object
		 *  @default null
		 */ "oLoadedState": null,
        /**
		 * Source url for AJAX data for the table.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @default null
		 */ "sAjaxSource": null,
        /**
		 * Property from a given object from which to read the table data from. This
		 * can be an empty string (when not server-side processing), in which case
		 * it is  assumed an an array is given directly.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 */ "sAjaxDataProp": null,
        /**
		 * The last jQuery XHR object that was used for server-side data gathering.
		 * This can be used for working with the XHR information in one of the
		 * callbacks
		 *  @type object
		 *  @default null
		 */ "jqXHR": null,
        /**
		 * JSON returned from the server in the last Ajax request
		 *  @type object
		 *  @default undefined
		 */ "json": undefined,
        /**
		 * Data submitted as part of the last Ajax request
		 *  @type object
		 *  @default undefined
		 */ "oAjaxData": undefined,
        /**
		 * Function to get the server-side data.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type function
		 */ "fnServerData": null,
        /**
		 * Functions which are called prior to sending an Ajax request so extra
		 * parameters can easily be sent to the server
		 *  @type array
		 *  @default []
		 */ "aoServerParams": [],
        /**
		 * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
		 * required).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 */ "sServerMethod": null,
        /**
		 * Format numbers for display.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type function
		 */ "fnFormatNumber": null,
        /**
		 * List of options that can be used for the user selectable length menu.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @default []
		 */ "aLengthMenu": null,
        /**
		 * Counter for the draws that the table does. Also used as a tracker for
		 * server-side processing
		 *  @type int
		 *  @default 0
		 */ "iDraw": 0,
        /**
		 * Indicate if a redraw is being done - useful for Ajax
		 *  @type boolean
		 *  @default false
		 */ "bDrawing": false,
        /**
		 * Draw index (iDraw) of the last error when parsing the returned data
		 *  @type int
		 *  @default -1
		 */ "iDrawError": -1,
        /**
		 * Paging display length
		 *  @type int
		 *  @default 10
		 */ "_iDisplayLength": 10,
        /**
		 * Paging start point - aiDisplay index
		 *  @type int
		 *  @default 0
		 */ "_iDisplayStart": 0,
        /**
		 * Server-side processing - number of records in the result set
		 * (i.e. before filtering), Use fnRecordsTotal rather than
		 * this property to get the value of the number of records, regardless of
		 * the server-side processing setting.
		 *  @type int
		 *  @default 0
		 *  @private
		 */ "_iRecordsTotal": 0,
        /**
		 * Server-side processing - number of records in the current display set
		 * (i.e. after filtering). Use fnRecordsDisplay rather than
		 * this property to get the value of the number of records, regardless of
		 * the server-side processing setting.
		 *  @type boolean
		 *  @default 0
		 *  @private
		 */ "_iRecordsDisplay": 0,
        /**
		 * The classes to use for the table
		 *  @type object
		 *  @default {}
		 */ "oClasses": {},
        /**
		 * Flag attached to the settings object so you can check in the draw
		 * callback if filtering has been done in the draw. Deprecated in favour of
		 * events.
		 *  @type boolean
		 *  @default false
		 *  @deprecated
		 */ "bFiltered": false,
        /**
		 * Flag attached to the settings object so you can check in the draw
		 * callback if sorting has been done in the draw. Deprecated in favour of
		 * events.
		 *  @type boolean
		 *  @default false
		 *  @deprecated
		 */ "bSorted": false,
        /**
		 * Indicate that if multiple rows are in the header and there is more than
		 * one unique cell per column, if the top one (true) or bottom one (false)
		 * should be used for sorting / title by DataTables.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */ "bSortCellsTop": null,
        /**
		 * Initialisation object that is used for the table
		 *  @type object
		 *  @default null
		 */ "oInit": null,
        /**
		 * Destroy callback functions - for plug-ins to attach themselves to the
		 * destroy so they can clean up markup and events.
		 *  @type array
		 *  @default []
		 */ "aoDestroyCallback": [],
        /**
		 * Get the number of records in the current record set, before filtering
		 *  @type function
		 */ "fnRecordsTotal": function() {
            return _fnDataSource(this) == "ssp" ? this._iRecordsTotal * 1 : this.aiDisplayMaster.length;
        },
        /**
		 * Get the number of records in the current record set, after filtering
		 *  @type function
		 */ "fnRecordsDisplay": function() {
            return _fnDataSource(this) == "ssp" ? this._iRecordsDisplay * 1 : this.aiDisplay.length;
        },
        /**
		 * Get the display end point - aiDisplay index
		 *  @type function
		 */ "fnDisplayEnd": function() {
            var len = this._iDisplayLength, start = this._iDisplayStart, calc = start + len, records = this.aiDisplay.length, features = this.oFeatures, paginate = features.bPaginate;
            if (features.bServerSide) return paginate === false || len === -1 ? start + records : Math.min(start + len, this._iRecordsDisplay);
            else return !paginate || calc > records || len === -1 ? records : calc;
        },
        /**
		 * The DataTables object for this table
		 *  @type object
		 *  @default null
		 */ "oInstance": null,
        /**
		 * Unique identifier for each instance of the DataTables object. If there
		 * is an ID on the table node, then it takes that value, otherwise an
		 * incrementing internal counter is used.
		 *  @type string
		 *  @default null
		 */ "sInstance": null,
        /**
		 * tabindex attribute value that is added to DataTables control elements, allowing
		 * keyboard navigation of the table and its controls.
		 */ "iTabIndex": 0,
        /**
		 * DIV container for the footer scrolling table if scrolling
		 */ "nScrollHead": null,
        /**
		 * DIV container for the footer scrolling table if scrolling
		 */ "nScrollFoot": null,
        /**
		 * Last applied sort
		 *  @type array
		 *  @default []
		 */ "aLastSort": [],
        /**
		 * Stored plug-in instances
		 *  @type object
		 *  @default {}
		 */ "oPlugins": {},
        /**
		 * Function used to get a row's id from the row's data
		 *  @type function
		 *  @default null
		 */ "rowIdFn": null,
        /**
		 * Data location where to store a row's id
		 *  @type string
		 *  @default null
		 */ "rowId": null
    };
    /**
	 * Extension object for DataTables that is used to provide all extension
	 * options.
	 *
	 * Note that the `DataTable.ext` object is available through
	 * `jQuery.fn.dataTable.ext` where it may be accessed and manipulated. It is
	 * also aliased to `jQuery.fn.dataTableExt` for historic reasons.
	 *  @namespace
	 *  @extends DataTable.models.ext
	 */ /**
	 * DataTables extensions
	 * 
	 * This namespace acts as a collection area for plug-ins that can be used to
	 * extend DataTables capabilities. Indeed many of the build in methods
	 * use this method to provide their own capabilities (sorting methods for
	 * example).
	 *
	 * Note that this namespace is aliased to `jQuery.fn.dataTableExt` for legacy
	 * reasons
	 *
	 *  @namespace
	 */ DataTable.ext = _ext = {
        /**
		 * Buttons. For use with the Buttons extension for DataTables. This is
		 * defined here so other extensions can define buttons regardless of load
		 * order. It is _not_ used by DataTables core.
		 *
		 *  @type object
		 *  @default {}
		 */ buttons: {},
        /**
		 * Element class names
		 *
		 *  @type object
		 *  @default {}
		 */ classes: {},
        /**
		 * DataTables build type (expanded by the download builder)
		 *
		 *  @type string
		 */ builder: "-source-",
        /**
		 * Error reporting.
		 * 
		 * How should DataTables report an error. Can take the value 'alert',
		 * 'throw', 'none' or a function.
		 *
		 *  @type string|function
		 *  @default alert
		 */ errMode: "alert",
        /**
		 * Feature plug-ins.
		 * 
		 * This is an array of objects which describe the feature plug-ins that are
		 * available to DataTables. These feature plug-ins are then available for
		 * use through the `dom` initialisation option.
		 * 
		 * Each feature plug-in is described by an object which must have the
		 * following properties:
		 * 
		 * * `fnInit` - function that is used to initialise the plug-in,
		 * * `cFeature` - a character so the feature can be enabled by the `dom`
		 *   instillation option. This is case sensitive.
		 *
		 * The `fnInit` function has the following input parameters:
		 *
		 * 1. `{object}` DataTables settings object: see
		 *    {@link DataTable.models.oSettings}
		 *
		 * And the following return is expected:
		 * 
		 * * {node|null} The element which contains your feature. Note that the
		 *   return may also be void if your plug-in does not require to inject any
		 *   DOM elements into DataTables control (`dom`) - for example this might
		 *   be useful when developing a plug-in which allows table control via
		 *   keyboard entry
		 *
		 *  @type array
		 *
		 *  @example
		 *    $.fn.dataTable.ext.features.push( {
		 *      "fnInit": function( oSettings ) {
		 *        return new TableTools( { "oDTSettings": oSettings } );
		 *      },
		 *      "cFeature": "T"
		 *    } );
		 */ feature: [],
        /**
		 * Row searching.
		 * 
		 * This method of searching is complimentary to the default type based
		 * searching, and a lot more comprehensive as it allows you complete control
		 * over the searching logic. Each element in this array is a function
		 * (parameters described below) that is called for every row in the table,
		 * and your logic decides if it should be included in the searching data set
		 * or not.
		 *
		 * Searching functions have the following input parameters:
		 *
		 * 1. `{object}` DataTables settings object: see
		 *    {@link DataTable.models.oSettings}
		 * 2. `{array|object}` Data for the row to be processed (same as the
		 *    original format that was passed in as the data source, or an array
		 *    from a DOM data source
		 * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
		 *    can be useful to retrieve the `TR` element if you need DOM interaction.
		 *
		 * And the following return is expected:
		 *
		 * * {boolean} Include the row in the searched result set (true) or not
		 *   (false)
		 *
		 * Note that as with the main search ability in DataTables, technically this
		 * is "filtering", since it is subtractive. However, for consistency in
		 * naming we call it searching here.
		 *
		 *  @type array
		 *  @default []
		 *
		 *  @example
		 *    // The following example shows custom search being applied to the
		 *    // fourth column (i.e. the data[3] index) based on two input values
		 *    // from the end-user, matching the data in a certain range.
		 *    $.fn.dataTable.ext.search.push(
		 *      function( settings, data, dataIndex ) {
		 *        var min = document.getElementById('min').value * 1;
		 *        var max = document.getElementById('max').value * 1;
		 *        var version = data[3] == "-" ? 0 : data[3]*1;
		 *
		 *        if ( min == "" && max == "" ) {
		 *          return true;
		 *        }
		 *        else if ( min == "" && version < max ) {
		 *          return true;
		 *        }
		 *        else if ( min < version && "" == max ) {
		 *          return true;
		 *        }
		 *        else if ( min < version && version < max ) {
		 *          return true;
		 *        }
		 *        return false;
		 *      }
		 *    );
		 */ search: [],
        /**
		 * Selector extensions
		 *
		 * The `selector` option can be used to extend the options available for the
		 * selector modifier options (`selector-modifier` object data type) that
		 * each of the three built in selector types offer (row, column and cell +
		 * their plural counterparts). For example the Select extension uses this
		 * mechanism to provide an option to select only rows, columns and cells
		 * that have been marked as selected by the end user (`{selected: true}`),
		 * which can be used in conjunction with the existing built in selector
		 * options.
		 *
		 * Each property is an array to which functions can be pushed. The functions
		 * take three attributes:
		 *
		 * * Settings object for the host table
		 * * Options object (`selector-modifier` object type)
		 * * Array of selected item indexes
		 *
		 * The return is an array of the resulting item indexes after the custom
		 * selector has been applied.
		 *
		 *  @type object
		 */ selector: {
            cell: [],
            column: [],
            row: []
        },
        /**
		 * Internal functions, exposed for used in plug-ins.
		 * 
		 * Please note that you should not need to use the internal methods for
		 * anything other than a plug-in (and even then, try to avoid if possible).
		 * The internal function may change between releases.
		 *
		 *  @type object
		 *  @default {}
		 */ internal: {},
        /**
		 * Legacy configuration options. Enable and disable legacy options that
		 * are available in DataTables.
		 *
		 *  @type object
		 */ legacy: {
            /**
			 * Enable / disable DataTables 1.9 compatible server-side processing
			 * requests
			 *
			 *  @type boolean
			 *  @default null
			 */ ajax: null
        },
        /**
		 * Pagination plug-in methods.
		 * 
		 * Each entry in this object is a function and defines which buttons should
		 * be shown by the pagination rendering method that is used for the table:
		 * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
		 * buttons are displayed in the document, while the functions here tell it
		 * what buttons to display. This is done by returning an array of button
		 * descriptions (what each button will do).
		 *
		 * Pagination types (the four built in options and any additional plug-in
		 * options defined here) can be used through the `paginationType`
		 * initialisation parameter.
		 *
		 * The functions defined take two parameters:
		 *
		 * 1. `{int} page` The current page index
		 * 2. `{int} pages` The number of pages in the table
		 *
		 * Each function is expected to return an array where each element of the
		 * array can be one of:
		 *
		 * * `first` - Jump to first page when activated
		 * * `last` - Jump to last page when activated
		 * * `previous` - Show previous page when activated
		 * * `next` - Show next page when activated
		 * * `{int}` - Show page of the index given
		 * * `{array}` - A nested array containing the above elements to add a
		 *   containing 'DIV' element (might be useful for styling).
		 *
		 * Note that DataTables v1.9- used this object slightly differently whereby
		 * an object with two functions would be defined for each plug-in. That
		 * ability is still supported by DataTables 1.10+ to provide backwards
		 * compatibility, but this option of use is now decremented and no longer
		 * documented in DataTables 1.10+.
		 *
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    // Show previous, next and current page buttons only
		 *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
		 *      return [ 'previous', page, 'next' ];
		 *    };
		 */ pager: {},
        renderer: {
            pageButton: {},
            header: {}
        },
        /**
		 * Ordering plug-ins - custom data source
		 * 
		 * The extension options for ordering of data available here is complimentary
		 * to the default type based ordering that DataTables typically uses. It
		 * allows much greater control over the the data that is being used to
		 * order a column, but is necessarily therefore more complex.
		 * 
		 * This type of ordering is useful if you want to do ordering based on data
		 * live from the DOM (for example the contents of an 'input' element) rather
		 * than just the static string that DataTables knows of.
		 * 
		 * The way these plug-ins work is that you create an array of the values you
		 * wish to be ordering for the column in question and then return that
		 * array. The data in the array much be in the index order of the rows in
		 * the table (not the currently ordering order!). Which order data gathering
		 * function is run here depends on the `dt-init columns.orderDataType`
		 * parameter that is used for the column (if any).
		 *
		 * The functions defined take two parameters:
		 *
		 * 1. `{object}` DataTables settings object: see
		 *    {@link DataTable.models.oSettings}
		 * 2. `{int}` Target column index
		 *
		 * Each function is expected to return an array:
		 *
		 * * `{array}` Data for the column to be ordering upon
		 *
		 *  @type array
		 *
		 *  @example
		 *    // Ordering using `input` node values
		 *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
		 *    {
		 *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
		 *        return $('input', td).val();
		 *      } );
		 *    }
		 */ order: {},
        /**
		 * Type based plug-ins.
		 *
		 * Each column in DataTables has a type assigned to it, either by automatic
		 * detection or by direct assignment using the `type` option for the column.
		 * The type of a column will effect how it is ordering and search (plug-ins
		 * can also make use of the column type if required).
		 *
		 * @namespace
		 */ type: {
            /**
			 * Type detection functions.
			 *
			 * The functions defined in this object are used to automatically detect
			 * a column's type, making initialisation of DataTables super easy, even
			 * when complex data is in the table.
			 *
			 * The functions defined take two parameters:
			 *
		     *  1. `{*}` Data from the column cell to be analysed
		     *  2. `{settings}` DataTables settings object. This can be used to
		     *     perform context specific type detection - for example detection
		     *     based on language settings such as using a comma for a decimal
		     *     place. Generally speaking the options from the settings will not
		     *     be required
			 *
			 * Each function is expected to return:
			 *
			 * * `{string|null}` Data type detected, or null if unknown (and thus
			 *   pass it on to the other type detection functions.
			 *
			 *  @type array
			 *
			 *  @example
			 *    // Currency type detection plug-in:
			 *    $.fn.dataTable.ext.type.detect.push(
			 *      function ( data, settings ) {
			 *        // Check the numeric part
			 *        if ( ! data.substring(1).match(/[0-9]/) ) {
			 *          return null;
			 *        }
			 *
			 *        // Check prefixed by currency
			 *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
			 *          return 'currency';
			 *        }
			 *        return null;
			 *      }
			 *    );
			 */ detect: [],
            /**
			 * Type based search formatting.
			 *
			 * The type based searching functions can be used to pre-format the
			 * data to be search on. For example, it can be used to strip HTML
			 * tags or to de-format telephone numbers for numeric only searching.
			 *
			 * Note that is a search is not defined for a column of a given type,
			 * no search formatting will be performed.
			 * 
			 * Pre-processing of searching data plug-ins - When you assign the sType
			 * for a column (or have it automatically detected for you by DataTables
			 * or a type detection plug-in), you will typically be using this for
			 * custom sorting, but it can also be used to provide custom searching
			 * by allowing you to pre-processing the data and returning the data in
			 * the format that should be searched upon. This is done by adding
			 * functions this object with a parameter name which matches the sType
			 * for that target column. This is the corollary of <i>afnSortData</i>
			 * for searching data.
			 *
			 * The functions defined take a single parameter:
			 *
		     *  1. `{*}` Data from the column cell to be prepared for searching
			 *
			 * Each function is expected to return:
			 *
			 * * `{string|null}` Formatted string that will be used for the searching.
			 *
			 *  @type object
			 *  @default {}
			 *
			 *  @example
			 *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
			 *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
			 *    }
			 */ search: {},
            /**
			 * Type based ordering.
			 *
			 * The column type tells DataTables what ordering to apply to the table
			 * when a column is sorted upon. The order for each type that is defined,
			 * is defined by the functions available in this object.
			 *
			 * Each ordering option can be described by three properties added to
			 * this object:
			 *
			 * * `{type}-pre` - Pre-formatting function
			 * * `{type}-asc` - Ascending order function
			 * * `{type}-desc` - Descending order function
			 *
			 * All three can be used together, only `{type}-pre` or only
			 * `{type}-asc` and `{type}-desc` together. It is generally recommended
			 * that only `{type}-pre` is used, as this provides the optimal
			 * implementation in terms of speed, although the others are provided
			 * for compatibility with existing Javascript sort functions.
			 *
			 * `{type}-pre`: Functions defined take a single parameter:
			 *
		     *  1. `{*}` Data from the column cell to be prepared for ordering
			 *
			 * And return:
			 *
			 * * `{*}` Data to be sorted upon
			 *
			 * `{type}-asc` and `{type}-desc`: Functions are typical Javascript sort
			 * functions, taking two parameters:
			 *
		     *  1. `{*}` Data to compare to the second parameter
		     *  2. `{*}` Data to compare to the first parameter
			 *
			 * And returning:
			 *
			 * * `{*}` Ordering match: <0 if first parameter should be sorted lower
			 *   than the second parameter, ===0 if the two parameters are equal and
			 *   >0 if the first parameter should be sorted height than the second
			 *   parameter.
			 * 
			 *  @type object
			 *  @default {}
			 *
			 *  @example
			 *    // Numeric ordering of formatted numbers with a pre-formatter
			 *    $.extend( $.fn.dataTable.ext.type.order, {
			 *      "string-pre": function(x) {
			 *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
			 *        return parseFloat( a );
			 *      }
			 *    } );
			 *
			 *  @example
			 *    // Case-sensitive string ordering, with no pre-formatting method
			 *    $.extend( $.fn.dataTable.ext.order, {
			 *      "string-case-asc": function(x,y) {
			 *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
			 *      },
			 *      "string-case-desc": function(x,y) {
			 *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
			 *      }
			 *    } );
			 */ order: {}
        },
        /**
		 * Unique DataTables instance counter
		 *
		 * @type int
		 * @private
		 */ _unique: 0,
        //
        // Depreciated
        // The following properties are retained for backwards compatibility only.
        // The should not be used in new projects and will be removed in a future
        // version
        //
        /**
		 * Version check function.
		 *  @type function
		 *  @depreciated Since 1.10
		 */ fnVersionCheck: DataTable.fnVersionCheck,
        /**
		 * Index for what 'this' index API functions should use
		 *  @type int
		 *  @deprecated Since v1.10
		 */ iApiIndex: 0,
        /**
		 * jQuery UI class container
		 *  @type object
		 *  @deprecated Since v1.10
		 */ oJUIClasses: {},
        /**
		 * Software version
		 *  @type string
		 *  @deprecated Since v1.10
		 */ sVersion: DataTable.version
    };
    //
    // Backwards compatibility. Alias to pre 1.10 Hungarian notation counter parts
    //
    $.extend(_ext, {
        afnFiltering: _ext.search,
        aTypes: _ext.type.detect,
        ofnSearch: _ext.type.search,
        oSort: _ext.type.order,
        afnSortData: _ext.order,
        aoFeatures: _ext.feature,
        oApi: _ext.internal,
        oStdClasses: _ext.classes,
        oPagination: _ext.pager
    });
    $.extend(DataTable.ext.classes, {
        "sTable": "dataTable",
        "sNoFooter": "no-footer",
        /* Paging buttons */ "sPageButton": "paginate_button",
        "sPageButtonActive": "current",
        "sPageButtonDisabled": "disabled",
        /* Striping classes */ "sStripeOdd": "odd",
        "sStripeEven": "even",
        /* Empty row */ "sRowEmpty": "dataTables_empty",
        /* Features */ "sWrapper": "dataTables_wrapper",
        "sFilter": "dataTables_filter",
        "sInfo": "dataTables_info",
        "sPaging": "dataTables_paginate paging_",
        /* Note that the type is postfixed */ "sLength": "dataTables_length",
        "sProcessing": "dataTables_processing",
        /* Sorting */ "sSortAsc": "sorting_asc",
        "sSortDesc": "sorting_desc",
        "sSortable": "sorting",
        /* Sortable in both directions */ "sSortableAsc": "sorting_desc_disabled",
        "sSortableDesc": "sorting_asc_disabled",
        "sSortableNone": "sorting_disabled",
        "sSortColumn": "sorting_",
        /* Note that an int is postfixed for the sorting order */ /* Filtering */ "sFilterInput": "",
        /* Page length */ "sLengthSelect": "",
        /* Scrolling */ "sScrollWrapper": "dataTables_scroll",
        "sScrollHead": "dataTables_scrollHead",
        "sScrollHeadInner": "dataTables_scrollHeadInner",
        "sScrollBody": "dataTables_scrollBody",
        "sScrollFoot": "dataTables_scrollFoot",
        "sScrollFootInner": "dataTables_scrollFootInner",
        /* Misc */ "sHeaderTH": "",
        "sFooterTH": "",
        // Deprecated
        "sSortJUIAsc": "",
        "sSortJUIDesc": "",
        "sSortJUI": "",
        "sSortJUIAscAllowed": "",
        "sSortJUIDescAllowed": "",
        "sSortJUIWrapper": "",
        "sSortIcon": "",
        "sJUIHeader": "",
        "sJUIFooter": ""
    });
    var extPagination = DataTable.ext.pager;
    function _numbers(page, pages) {
        var numbers = [], buttons = extPagination.numbers_length, half = Math.floor(buttons / 2), i = 1;
        if (pages <= buttons) numbers = _range(0, pages);
        else if (page <= half) {
            numbers = _range(0, buttons - 2);
            numbers.push("ellipsis");
            numbers.push(pages - 1);
        } else if (page >= pages - 1 - half) {
            numbers = _range(pages - (buttons - 2), pages);
            numbers.splice(0, 0, "ellipsis"); // no unshift in ie6
            numbers.splice(0, 0, 0);
        } else {
            numbers = _range(page - half + 2, page + half - 1);
            numbers.push("ellipsis");
            numbers.push(pages - 1);
            numbers.splice(0, 0, "ellipsis");
            numbers.splice(0, 0, 0);
        }
        numbers.DT_el = "span";
        return numbers;
    }
    $.extend(extPagination, {
        simple: function(page, pages) {
            return [
                "previous",
                "next"
            ];
        },
        full: function(page, pages) {
            return [
                "first",
                "previous",
                "next",
                "last"
            ];
        },
        numbers: function(page, pages) {
            return [
                _numbers(page, pages)
            ];
        },
        simple_numbers: function(page, pages) {
            return [
                "previous",
                _numbers(page, pages),
                "next"
            ];
        },
        full_numbers: function(page, pages) {
            return [
                "first",
                "previous",
                _numbers(page, pages),
                "next",
                "last"
            ];
        },
        first_last_numbers: function(page, pages) {
            return [
                "first",
                _numbers(page, pages),
                "last"
            ];
        },
        // For testing and plug-ins to use
        _numbers: _numbers,
        // Number of number buttons (including ellipsis) to show. _Must be odd!_
        numbers_length: 7
    });
    $.extend(true, DataTable.ext.renderer, {
        pageButton: {
            _: function(settings, host, idx, buttons, page, pages) {
                var classes = settings.oClasses;
                var lang = settings.oLanguage.oPaginate;
                var aria = settings.oLanguage.oAria.paginate || {};
                var btnDisplay, btnClass, counter = 0;
                var attach = function(container, buttons) {
                    var i, ien, node, button, tabIndex;
                    var disabledClass = classes.sPageButtonDisabled;
                    var clickHandler = function(e) {
                        _fnPageChange(settings, e.data.action, true);
                    };
                    for(i = 0, ien = buttons.length; i < ien; i++){
                        button = buttons[i];
                        if (Array.isArray(button)) {
                            var inner = $("<" + (button.DT_el || "div") + "/>").appendTo(container);
                            attach(inner, button);
                        } else {
                            btnDisplay = null;
                            btnClass = button;
                            tabIndex = settings.iTabIndex;
                            switch(button){
                                case "ellipsis":
                                    container.append('<span class="ellipsis">&#x2026;</span>');
                                    break;
                                case "first":
                                    btnDisplay = lang.sFirst;
                                    if (page === 0) {
                                        tabIndex = -1;
                                        btnClass += " " + disabledClass;
                                    }
                                    break;
                                case "previous":
                                    btnDisplay = lang.sPrevious;
                                    if (page === 0) {
                                        tabIndex = -1;
                                        btnClass += " " + disabledClass;
                                    }
                                    break;
                                case "next":
                                    btnDisplay = lang.sNext;
                                    if (pages === 0 || page === pages - 1) {
                                        tabIndex = -1;
                                        btnClass += " " + disabledClass;
                                    }
                                    break;
                                case "last":
                                    btnDisplay = lang.sLast;
                                    if (pages === 0 || page === pages - 1) {
                                        tabIndex = -1;
                                        btnClass += " " + disabledClass;
                                    }
                                    break;
                                default:
                                    btnDisplay = settings.fnFormatNumber(button + 1);
                                    btnClass = page === button ? classes.sPageButtonActive : "";
                                    break;
                            }
                            if (btnDisplay !== null) {
                                node = $("<a>", {
                                    "class": classes.sPageButton + " " + btnClass,
                                    "aria-controls": settings.sTableId,
                                    "aria-label": aria[button],
                                    "data-dt-idx": counter,
                                    "tabindex": tabIndex,
                                    "id": idx === 0 && typeof button === "string" ? settings.sTableId + "_" + button : null
                                }).html(btnDisplay).appendTo(container);
                                _fnBindAction(node, {
                                    action: button
                                }, clickHandler);
                                counter++;
                            }
                        }
                    }
                };
                // IE9 throws an 'unknown error' if document.activeElement is used
                // inside an iframe or frame. Try / catch the error. Not good for
                // accessibility, but neither are frames.
                var activeEl;
                try {
                    // Because this approach is destroying and recreating the paging
                    // elements, focus is lost on the select button which is bad for
                    // accessibility. So we want to restore focus once the draw has
                    // completed
                    activeEl = $(host).find(document1.activeElement).data("dt-idx");
                } catch (e) {}
                attach($(host).empty(), buttons);
                if (activeEl !== undefined) $(host).find("[data-dt-idx=" + activeEl + "]").trigger("focus");
            }
        }
    });
    // Built in type detection. See model.ext.aTypes for information about
    // what is required from this methods.
    $.extend(DataTable.ext.type.detect, [
        // Plain numbers - first since V8 detects some plain numbers as dates
        // e.g. Date.parse('55') (but not all, e.g. Date.parse('22')...).
        function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return _isNumber(d, decimal) ? "num" + decimal : null;
        },
        // Dates (only those recognised by the browser's Date.parse)
        function(d, settings) {
            // V8 tries _very_ hard to make a string passed into `Date.parse()`
            // valid, so we need to use a regex to restrict date formats. Use a
            // plug-in for anything other than ISO8601 style strings
            if (d && !(d instanceof Date) && !_re_date.test(d)) return null;
            var parsed = Date.parse(d);
            return parsed !== null && !isNaN(parsed) || _empty(d) ? "date" : null;
        },
        // Formatted numbers
        function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return _isNumber(d, decimal, true) ? "num-fmt" + decimal : null;
        },
        // HTML numeric
        function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return _htmlNumeric(d, decimal) ? "html-num" + decimal : null;
        },
        // HTML numeric, formatted
        function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return _htmlNumeric(d, decimal, true) ? "html-num-fmt" + decimal : null;
        },
        // HTML (this is strict checking - there must be html)
        function(d, settings) {
            return _empty(d) || typeof d === "string" && d.indexOf("<") !== -1 ? "html" : null;
        }
    ]);
    // Filter formatting functions. See model.ext.ofnSearch for information about
    // what is required from these methods.
    // 
    // Note that additional search methods are added for the html numbers and
    // html formatted numbers by `_addNumericSort()` when we know what the decimal
    // place is
    $.extend(DataTable.ext.type.search, {
        html: function(data) {
            return _empty(data) ? data : typeof data === "string" ? data.replace(_re_new_lines, " ").replace(_re_html, "") : "";
        },
        string: function(data) {
            return _empty(data) ? data : typeof data === "string" ? data.replace(_re_new_lines, " ") : data;
        }
    });
    var __numericReplace = function(d, decimalPlace, re1, re2) {
        if (d !== 0 && (!d || d === "-")) return -Infinity;
        // If a decimal place other than `.` is used, it needs to be given to the
        // function so we can detect it and replace with a `.` which is the only
        // decimal place Javascript recognises - it is not locale aware.
        if (decimalPlace) d = _numToDecimal(d, decimalPlace);
        if (d.replace) {
            if (re1) d = d.replace(re1, "");
            if (re2) d = d.replace(re2, "");
        }
        return d * 1;
    };
    // Add the numeric 'deformatting' functions for sorting and search. This is done
    // in a function to provide an easy ability for the language options to add
    // additional methods if a non-period decimal place is used.
    function _addNumericSort(decimalPlace) {
        $.each({
            // Plain numbers
            "num": function(d) {
                return __numericReplace(d, decimalPlace);
            },
            // Formatted numbers
            "num-fmt": function(d) {
                return __numericReplace(d, decimalPlace, _re_formatted_numeric);
            },
            // HTML numeric
            "html-num": function(d) {
                return __numericReplace(d, decimalPlace, _re_html);
            },
            // HTML numeric, formatted
            "html-num-fmt": function(d) {
                return __numericReplace(d, decimalPlace, _re_html, _re_formatted_numeric);
            }
        }, function(key, fn) {
            // Add the ordering method
            _ext.type.order[key + decimalPlace + "-pre"] = fn;
            // For HTML types add a search formatter that will strip the HTML
            if (key.match(/^html\-/)) _ext.type.search[key + decimalPlace] = _ext.type.search.html;
        });
    }
    // Default sort methods
    $.extend(_ext.type.order, {
        // Dates
        "date-pre": function(d) {
            var ts = Date.parse(d);
            return isNaN(ts) ? -Infinity : ts;
        },
        // html
        "html-pre": function(a) {
            return _empty(a) ? "" : a.replace ? a.replace(/<.*?>/g, "").toLowerCase() : a + "";
        },
        // string
        "string-pre": function(a) {
            // This is a little complex, but faster than always calling toString,
            // http://jsperf.com/tostring-v-check
            return _empty(a) ? "" : typeof a === "string" ? a.toLowerCase() : !a.toString ? "" : a.toString();
        },
        // string-asc and -desc are retained only for compatibility with the old
        // sort methods
        "string-asc": function(x, y) {
            return x < y ? -1 : x > y ? 1 : 0;
        },
        "string-desc": function(x, y) {
            return x < y ? 1 : x > y ? -1 : 0;
        }
    });
    // Numeric sorting types - order doesn't matter here
    _addNumericSort("");
    $.extend(true, DataTable.ext.renderer, {
        header: {
            _: function(settings, cell, column, classes) {
                // No additional mark-up required
                // Attach a sort listener to update on sort - note that using the
                // `DT` namespace will allow the event to be removed automatically
                // on destroy, while the `dt` namespaced event is the one we are
                // listening for
                $(settings.nTable).on("order.dt.DT", function(e, ctx, sorting, columns) {
                    if (settings !== ctx) return; // table, not a nested one
                    var colIdx = column.idx;
                    cell.removeClass(classes.sSortAsc + " " + classes.sSortDesc).addClass(columns[colIdx] == "asc" ? classes.sSortAsc : columns[colIdx] == "desc" ? classes.sSortDesc : column.sSortingClass);
                });
            },
            jqueryui: function(settings, cell, column, classes) {
                $("<div/>").addClass(classes.sSortJUIWrapper).append(cell.contents()).append($("<span/>").addClass(classes.sSortIcon + " " + column.sSortingClassJUI)).appendTo(cell);
                // Attach a sort listener to update on sort
                $(settings.nTable).on("order.dt.DT", function(e, ctx, sorting, columns) {
                    if (settings !== ctx) return;
                    var colIdx = column.idx;
                    cell.removeClass(classes.sSortAsc + " " + classes.sSortDesc).addClass(columns[colIdx] == "asc" ? classes.sSortAsc : columns[colIdx] == "desc" ? classes.sSortDesc : column.sSortingClass);
                    cell.find("span." + classes.sSortIcon).removeClass(classes.sSortJUIAsc + " " + classes.sSortJUIDesc + " " + classes.sSortJUI + " " + classes.sSortJUIAscAllowed + " " + classes.sSortJUIDescAllowed).addClass(columns[colIdx] == "asc" ? classes.sSortJUIAsc : columns[colIdx] == "desc" ? classes.sSortJUIDesc : column.sSortingClassJUI);
                });
            }
        }
    });
    /*
	 * Public helper functions. These aren't used internally by DataTables, or
	 * called by any of the options passed into DataTables, but they can be used
	 * externally by developers working with DataTables. They are helper functions
	 * to make working with DataTables a little bit easier.
	 */ var __htmlEscapeEntities = function(d) {
        if (Array.isArray(d)) d = d.join(",");
        return typeof d === "string" ? d.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;") : d;
    };
    // Common logic for moment, luxon or a date action
    function __mld(dt, momentFn, luxonFn, dateFn, arg1) {
        if (window1.moment) return dt[momentFn](arg1);
        else if (window1.luxon) return dt[luxonFn](arg1);
        return dateFn ? dt[dateFn](arg1) : dt;
    }
    var __mlWarning = false;
    function __mldObj(d, format, locale) {
        var dt;
        if (window1.moment) {
            dt = window1.moment.utc(d, format, locale, true);
            if (!dt.isValid()) return null;
        } else if (window1.luxon) {
            dt = format ? window1.luxon.DateTime.fromFormat(d, format) : window1.luxon.DateTime.fromISO(d);
            if (!dt.isValid) return null;
            dt.setLocale(locale);
        } else if (!format) // No format given, must be ISO
        dt = new Date(d);
        else {
            if (!__mlWarning) alert("DataTables warning: Formatted date without Moment.js or Luxon - https://datatables.net/tn/17");
            __mlWarning = true;
        }
        return dt;
    }
    // Wrapper for date, datetime and time which all operate the same way with the exception of
    // the output string for auto locale support
    function __mlHelper(localeString) {
        return function(from, to, locale, def) {
            // Luxon and Moment support
            // Argument shifting
            if (arguments.length === 0) {
                locale = "en";
                to = null; // means toLocaleString
                from = null; // means iso8601
            } else if (arguments.length === 1) {
                locale = "en";
                to = from;
                from = null;
            } else if (arguments.length === 2) {
                locale = to;
                to = from;
                from = null;
            }
            var typeName = "datetime-" + to;
            // Add type detection and sorting specific to this date format - we need to be able to identify
            // date type columns as such, rather than as numbers in extensions. Hence the need for this.
            if (!DataTable.ext.type.order[typeName]) {
                // The renderer will give the value to type detect as the type!
                DataTable.ext.type.detect.unshift(function(d) {
                    return d === typeName ? typeName : false;
                });
                // The renderer gives us Moment, Luxon or Date obects for the sorting, all of which have a
                // `valueOf` which gives milliseconds epoch
                DataTable.ext.type.order[typeName + "-asc"] = function(a, b) {
                    var x = a.valueOf();
                    var y = b.valueOf();
                    return x === y ? 0 : x < y ? -1 : 1;
                };
                DataTable.ext.type.order[typeName + "-desc"] = function(a, b) {
                    var x = a.valueOf();
                    var y = b.valueOf();
                    return x === y ? 0 : x > y ? -1 : 1;
                };
            }
            return function(d, type) {
                // Allow for a default value
                if (d === null || d === undefined) {
                    if (def === "--now") {
                        // We treat everything as UTC further down, so no changes are
                        // made, as such need to get the local date / time as if it were
                        // UTC
                        var local = new Date();
                        d = new Date(Date.UTC(local.getFullYear(), local.getMonth(), local.getDate(), local.getHours(), local.getMinutes(), local.getSeconds()));
                    } else d = "";
                }
                if (type === "type") // Typing uses the type name for fast matching
                return typeName;
                if (d === "") return type !== "sort" ? "" : __mldObj("0000-01-01 00:00:00", null, locale);
                // Shortcut. If `from` and `to` are the same, we are using the renderer to
                // format for ordering, not display - its already in the display format.
                if (to !== null && from === to && type !== "sort" && type !== "type" && !(d instanceof Date)) return d;
                var dt = __mldObj(d, from, locale);
                if (dt === null) return d;
                if (type === "sort") return dt;
                var formatted = to === null ? __mld(dt, "toDate", "toJSDate", "")[localeString]() : __mld(dt, "format", "toFormat", "toISOString", to);
                // XSS protection
                return type === "display" ? __htmlEscapeEntities(formatted) : formatted;
            };
        };
    }
    // Based on locale, determine standard number formatting
    // Fallback for legacy browsers is US English
    var __thousands = ",";
    var __decimal = ".";
    if (Intl) try {
        var num = new Intl.NumberFormat().formatToParts(100000.1);
        for(var i = 0; i < num.length; i++){
            if (num[i].type === "group") __thousands = num[i].value;
            else if (num[i].type === "decimal") __decimal = num[i].value;
        }
    } catch (e) {
    // noop
    }
    // Formatted date time detection - use by declaring the formats you are going to use
    DataTable.datetime = function(format, locale) {
        var typeName = "datetime-detect-" + format;
        if (!locale) locale = "en";
        if (!DataTable.ext.type.order[typeName]) {
            DataTable.ext.type.detect.unshift(function(d) {
                var dt = __mldObj(d, format, locale);
                return d === "" || dt ? typeName : false;
            });
            DataTable.ext.type.order[typeName + "-pre"] = function(d) {
                return __mldObj(d, format, locale) || 0;
            };
        }
    };
    /**
	 * Helpers for `columns.render`.
	 *
	 * The options defined here can be used with the `columns.render` initialisation
	 * option to provide a display renderer. The following functions are defined:
	 *
	 * * `number` - Will format numeric data (defined by `columns.data`) for
	 *   display, retaining the original unformatted data for sorting and filtering.
	 *   It takes 5 parameters:
	 *   * `string` - Thousands grouping separator
	 *   * `string` - Decimal point indicator
	 *   * `integer` - Number of decimal points to show
	 *   * `string` (optional) - Prefix.
	 *   * `string` (optional) - Postfix (/suffix).
	 * * `text` - Escape HTML to help prevent XSS attacks. It has no optional
	 *   parameters.
	 *
	 * @example
	 *   // Column definition using the number renderer
	 *   {
	 *     data: "salary",
	 *     render: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
	 *   }
	 *
	 * @namespace
	 */ DataTable.render = {
        date: __mlHelper("toLocaleDateString"),
        datetime: __mlHelper("toLocaleString"),
        time: __mlHelper("toLocaleTimeString"),
        number: function(thousands, decimal, precision, prefix, postfix) {
            // Auto locale detection
            if (thousands === null || thousands === undefined) thousands = __thousands;
            if (decimal === null || decimal === undefined) decimal = __decimal;
            return {
                display: function(d) {
                    if (typeof d !== "number" && typeof d !== "string") return d;
                    if (d === "" || d === null) return d;
                    var negative = d < 0 ? "-" : "";
                    var flo = parseFloat(d);
                    // If NaN then there isn't much formatting that we can do - just
                    // return immediately, escaping any HTML (this was supposed to
                    // be a number after all)
                    if (isNaN(flo)) return __htmlEscapeEntities(d);
                    flo = flo.toFixed(precision);
                    d = Math.abs(flo);
                    var intPart = parseInt(d, 10);
                    var floatPart = precision ? decimal + (d - intPart).toFixed(precision).substring(2) : "";
                    // If zero, then can't have a negative prefix
                    if (intPart === 0 && parseFloat(floatPart) === 0) negative = "";
                    return negative + (prefix || "") + intPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + floatPart + (postfix || "");
                }
            };
        },
        text: function() {
            return {
                display: __htmlEscapeEntities,
                filter: __htmlEscapeEntities
            };
        }
    };
    /*
	 * This is really a good bit rubbish this method of exposing the internal methods
	 * publicly... - To be fixed in 2.0 using methods on the prototype
	 */ /**
	 * Create a wrapper function for exporting an internal functions to an external API.
	 *  @param {string} fn API function name
	 *  @returns {function} wrapped function
	 *  @memberof DataTable#internal
	 */ function _fnExternApiFunc(fn) {
        return function() {
            var args = [
                _fnSettingsFromNode(this[DataTable.ext.iApiIndex])
            ].concat(Array.prototype.slice.call(arguments));
            return DataTable.ext.internal[fn].apply(this, args);
        };
    }
    /**
	 * Reference to internal functions for use by plug-in developers. Note that
	 * these methods are references to internal functions and are considered to be
	 * private. If you use these methods, be aware that they are liable to change
	 * between versions.
	 *  @namespace
	 */ $.extend(DataTable.ext.internal, {
        _fnExternApiFunc: _fnExternApiFunc,
        _fnBuildAjax: _fnBuildAjax,
        _fnAjaxUpdate: _fnAjaxUpdate,
        _fnAjaxParameters: _fnAjaxParameters,
        _fnAjaxUpdateDraw: _fnAjaxUpdateDraw,
        _fnAjaxDataSrc: _fnAjaxDataSrc,
        _fnAddColumn: _fnAddColumn,
        _fnColumnOptions: _fnColumnOptions,
        _fnAdjustColumnSizing: _fnAdjustColumnSizing,
        _fnVisibleToColumnIndex: _fnVisibleToColumnIndex,
        _fnColumnIndexToVisible: _fnColumnIndexToVisible,
        _fnVisbleColumns: _fnVisbleColumns,
        _fnGetColumns: _fnGetColumns,
        _fnColumnTypes: _fnColumnTypes,
        _fnApplyColumnDefs: _fnApplyColumnDefs,
        _fnHungarianMap: _fnHungarianMap,
        _fnCamelToHungarian: _fnCamelToHungarian,
        _fnLanguageCompat: _fnLanguageCompat,
        _fnBrowserDetect: _fnBrowserDetect,
        _fnAddData: _fnAddData,
        _fnAddTr: _fnAddTr,
        _fnNodeToDataIndex: _fnNodeToDataIndex,
        _fnNodeToColumnIndex: _fnNodeToColumnIndex,
        _fnGetCellData: _fnGetCellData,
        _fnSetCellData: _fnSetCellData,
        _fnSplitObjNotation: _fnSplitObjNotation,
        _fnGetObjectDataFn: _fnGetObjectDataFn,
        _fnSetObjectDataFn: _fnSetObjectDataFn,
        _fnGetDataMaster: _fnGetDataMaster,
        _fnClearTable: _fnClearTable,
        _fnDeleteIndex: _fnDeleteIndex,
        _fnInvalidate: _fnInvalidate,
        _fnGetRowElements: _fnGetRowElements,
        _fnCreateTr: _fnCreateTr,
        _fnBuildHead: _fnBuildHead,
        _fnDrawHead: _fnDrawHead,
        _fnDraw: _fnDraw,
        _fnReDraw: _fnReDraw,
        _fnAddOptionsHtml: _fnAddOptionsHtml,
        _fnDetectHeader: _fnDetectHeader,
        _fnGetUniqueThs: _fnGetUniqueThs,
        _fnFeatureHtmlFilter: _fnFeatureHtmlFilter,
        _fnFilterComplete: _fnFilterComplete,
        _fnFilterCustom: _fnFilterCustom,
        _fnFilterColumn: _fnFilterColumn,
        _fnFilter: _fnFilter,
        _fnFilterCreateSearch: _fnFilterCreateSearch,
        _fnEscapeRegex: _fnEscapeRegex,
        _fnFilterData: _fnFilterData,
        _fnFeatureHtmlInfo: _fnFeatureHtmlInfo,
        _fnUpdateInfo: _fnUpdateInfo,
        _fnInfoMacros: _fnInfoMacros,
        _fnInitialise: _fnInitialise,
        _fnInitComplete: _fnInitComplete,
        _fnLengthChange: _fnLengthChange,
        _fnFeatureHtmlLength: _fnFeatureHtmlLength,
        _fnFeatureHtmlPaginate: _fnFeatureHtmlPaginate,
        _fnPageChange: _fnPageChange,
        _fnFeatureHtmlProcessing: _fnFeatureHtmlProcessing,
        _fnProcessingDisplay: _fnProcessingDisplay,
        _fnFeatureHtmlTable: _fnFeatureHtmlTable,
        _fnScrollDraw: _fnScrollDraw,
        _fnApplyToChildren: _fnApplyToChildren,
        _fnCalculateColumnWidths: _fnCalculateColumnWidths,
        _fnThrottle: _fnThrottle,
        _fnConvertToWidth: _fnConvertToWidth,
        _fnGetWidestNode: _fnGetWidestNode,
        _fnGetMaxLenString: _fnGetMaxLenString,
        _fnStringToCss: _fnStringToCss,
        _fnSortFlatten: _fnSortFlatten,
        _fnSort: _fnSort,
        _fnSortAria: _fnSortAria,
        _fnSortListener: _fnSortListener,
        _fnSortAttachListener: _fnSortAttachListener,
        _fnSortingClasses: _fnSortingClasses,
        _fnSortData: _fnSortData,
        _fnSaveState: _fnSaveState,
        _fnLoadState: _fnLoadState,
        _fnImplementState: _fnImplementState,
        _fnSettingsFromNode: _fnSettingsFromNode,
        _fnLog: _fnLog,
        _fnMap: _fnMap,
        _fnBindAction: _fnBindAction,
        _fnCallbackReg: _fnCallbackReg,
        _fnCallbackFire: _fnCallbackFire,
        _fnLengthOverflow: _fnLengthOverflow,
        _fnRenderer: _fnRenderer,
        _fnDataSource: _fnDataSource,
        _fnRowAttributes: _fnRowAttributes,
        _fnExtend: _fnExtend,
        _fnCalculateEnd: function() {} // Used by a lot of plug-ins, but redundant
    });
    // jQuery access
    $.fn.dataTable = DataTable;
    // Provide access to the host jQuery object (circular reference)
    DataTable.$ = $;
    // Legacy aliases
    $.fn.dataTableSettings = DataTable.settings;
    $.fn.dataTableExt = DataTable.ext;
    // With a capital `D` we return a DataTables API instance rather than a
    // jQuery object
    $.fn.DataTable = function(opts) {
        return $(this).dataTable(opts).api();
    };
    // All properties that are available to $.fn.dataTable should also be
    // available on $.fn.DataTable
    $.each(DataTable, function(prop, val) {
        $.fn.DataTable[prop] = val;
    });
    return DataTable;
});

});

parcelRegister("aDBCM", function(module, exports) {

/*! Select for DataTables 1.4.0-dev
 * 2015-2021 SpryMedia Ltd - datatables.net/license/mit
 */ /**
 * @summary     Select for DataTables
 * @description A collection of API methods, events and buttons for DataTables
 *   that provides selection options of the items in a DataTable
 * @version     1.4.0-dev
 * @file        dataTables.select.js
 * @author      SpryMedia Ltd (www.sprymedia.co.uk)
 * @contact     datatables.net/forums
 * @copyright   Copyright 2015-2021 SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license/mit
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net/extensions/select
 */ (function(factory) {
    if (typeof define === "function" && define.amd) // AMD
    define([
        "jquery",
        "datatables.net"
    ], function($) {
        return factory($, window, document);
    });
    else // CommonJS
    module.exports = function(root, $) {
        if (!root) root = window;
        if (!$ || !$.fn.dataTable) $ = (parcelRequire("EHlDu"))(root, $).$;
        return factory($, root, root.document);
    };
})(function($, window1, document1, undefined) {
    "use strict";
    var DataTable = $.fn.dataTable;
    // Version information for debugger
    DataTable.select = {};
    DataTable.select.version = "1.4.0-dev";
    DataTable.select.init = function(dt) {
        var ctx = dt.settings()[0];
        if (ctx._select) return;
        var savedSelected = dt.state.loaded();
        var selectAndSave = function(e, settings, data) {
            if (data === null || data.select === undefined) return;
            // Clear any currently selected rows, before restoring state
            // None will be selected on first initialisation
            if (dt.rows({
                selected: true
            }).any()) dt.rows().deselect();
            if (data.select.rows !== undefined) dt.rows(data.select.rows).select();
            if (dt.columns({
                selected: true
            }).any()) dt.columns().deselect();
            if (data.select.columns !== undefined) dt.columns(data.select.columns).select();
            if (dt.cells({
                selected: true
            }).any()) dt.cells().deselect();
            if (data.select.cells !== undefined) for(var i = 0; i < data.select.cells.length; i++)dt.cell(data.select.cells[i].row, data.select.cells[i].column).select();
            dt.state.save();
        };
        dt.one("init", function() {
            dt.on("stateSaveParams", function(e, settings, data) {
                data.select = {};
                data.select.rows = dt.rows({
                    selected: true
                }).ids(true).toArray();
                data.select.columns = dt.columns({
                    selected: true
                })[0];
                data.select.cells = dt.cells({
                    selected: true
                })[0].map(function(coords) {
                    return {
                        row: dt.row(coords.row).id(true),
                        column: coords.column
                    };
                });
            });
            selectAndSave(undefined, undefined, savedSelected);
            dt.on("stateLoaded stateLoadParams", selectAndSave);
        });
        var init = ctx.oInit.select;
        var defaults = DataTable.defaults.select;
        var opts = init === undefined ? defaults : init;
        // Set defaults
        var items = "row";
        var style = "api";
        var blurable = false;
        var toggleable = true;
        var info = true;
        var selector = "td, th";
        var className = "selected";
        var setStyle = false;
        ctx._select = {};
        // Initialisation customisations
        if (opts === true) {
            style = "os";
            setStyle = true;
        } else if (typeof opts === "string") {
            style = opts;
            setStyle = true;
        } else if ($.isPlainObject(opts)) {
            if (opts.blurable !== undefined) blurable = opts.blurable;
            if (opts.toggleable !== undefined) toggleable = opts.toggleable;
            if (opts.info !== undefined) info = opts.info;
            if (opts.items !== undefined) items = opts.items;
            if (opts.style !== undefined) {
                style = opts.style;
                setStyle = true;
            } else {
                style = "os";
                setStyle = true;
            }
            if (opts.selector !== undefined) selector = opts.selector;
            if (opts.className !== undefined) className = opts.className;
        }
        dt.select.selector(selector);
        dt.select.items(items);
        dt.select.style(style);
        dt.select.blurable(blurable);
        dt.select.toggleable(toggleable);
        dt.select.info(info);
        ctx._select.className = className;
        // Sort table based on selected rows. Requires Select Datatables extension
        $.fn.dataTable.ext.order["select-checkbox"] = function(settings, col) {
            return this.api().column(col, {
                order: "index"
            }).nodes().map(function(td) {
                if (settings._select.items === "row") return $(td).parent().hasClass(settings._select.className);
                else if (settings._select.items === "cell") return $(td).hasClass(settings._select.className);
                return false;
            });
        };
        // If the init options haven't enabled select, but there is a selectable
        // class name, then enable
        if (!setStyle && $(dt.table().node()).hasClass("selectable")) dt.select.style("os");
    };
    /*

Select is a collection of API methods, event handlers, event emitters and
buttons (for the `Buttons` extension) for DataTables. It provides the following
features, with an overview of how they are implemented:

## Selection of rows, columns and cells. Whether an item is selected or not is
   stored in:

* rows: a `_select_selected` property which contains a boolean value of the
  DataTables' `aoData` object for each row
* columns: a `_select_selected` property which contains a boolean value of the
  DataTables' `aoColumns` object for each column
* cells: a `_selected_cells` property which contains an array of boolean values
  of the `aoData` object for each row. The array is the same length as the
  columns array, with each element of it representing a cell.

This method of using boolean flags allows Select to operate when nodes have not
been created for rows / cells (DataTables' defer rendering feature).

## API methods

A range of API methods are available for triggering selection and de-selection
of rows. Methods are also available to configure the selection events that can
be triggered by an end user (such as which items are to be selected). To a large
extent, these of API methods *is* Select. It is basically a collection of helper
functions that can be used to select items in a DataTable.

Configuration of select is held in the object `_select` which is attached to the
DataTables settings object on initialisation. Select being available on a table
is not optional when Select is loaded, but its default is for selection only to
be available via the API - so the end user wouldn't be able to select rows
without additional configuration.

The `_select` object contains the following properties:

```
{
	items:string       - Can be `rows`, `columns` or `cells`. Defines what item 
	                     will be selected if the user is allowed to activate row
	                     selection using the mouse.
	style:string       - Can be `none`, `single`, `multi` or `os`. Defines the
	                     interaction style when selecting items
	blurable:boolean   - If row selection can be cleared by clicking outside of
	                     the table
	toggleable:boolean - If row selection can be cancelled by repeated clicking
	                     on the row
	info:boolean       - If the selection summary should be shown in the table
	                     information elements
}
```

In addition to the API methods, Select also extends the DataTables selector
options for rows, columns and cells adding a `selected` option to the selector
options object, allowing the developer to select only selected items or
unselected items.

## Mouse selection of items

Clicking on items can be used to select items. This is done by a simple event
handler that will select the items using the API methods.

 */ /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Local functions
 */ /**
 * Add one or more cells to the selection when shift clicking in OS selection
 * style cell selection.
 *
 * Cell range is more complicated than row and column as we want to select
 * in the visible grid rather than by index in sequence. For example, if you
 * click first in cell 1-1 and then shift click in 2-2 - cells 1-2 and 2-1
 * should also be selected (and not 1-3, 1-4. etc)
 * 
 * @param  {DataTable.Api} dt   DataTable
 * @param  {object}        idx  Cell index to select to
 * @param  {object}        last Cell index to select from
 * @private
 */ function cellRange(dt, idx, last) {
        var indexes;
        var columnIndexes;
        var rowIndexes;
        var selectColumns = function(start, end) {
            if (start > end) {
                var tmp = end;
                end = start;
                start = tmp;
            }
            var record = false;
            return dt.columns(":visible").indexes().filter(function(i) {
                if (i === start) record = true;
                if (i === end) {
                    record = false;
                    return true;
                }
                return record;
            });
        };
        var selectRows = function(start, end) {
            var indexes = dt.rows({
                search: "applied"
            }).indexes();
            // Which comes first - might need to swap
            if (indexes.indexOf(start) > indexes.indexOf(end)) {
                var tmp = end;
                end = start;
                start = tmp;
            }
            var record = false;
            return indexes.filter(function(i) {
                if (i === start) record = true;
                if (i === end) {
                    record = false;
                    return true;
                }
                return record;
            });
        };
        if (!dt.cells({
            selected: true
        }).any() && !last) {
            // select from the top left cell to this one
            columnIndexes = selectColumns(0, idx.column);
            rowIndexes = selectRows(0, idx.row);
        } else {
            // Get column indexes between old and new
            columnIndexes = selectColumns(last.column, idx.column);
            rowIndexes = selectRows(last.row, idx.row);
        }
        indexes = dt.cells(rowIndexes, columnIndexes).flatten();
        if (!dt.cells(idx, {
            selected: true
        }).any()) // Select range
        dt.cells(indexes).select();
        else // Deselect range
        dt.cells(indexes).deselect();
    }
    /**
 * Disable mouse selection by removing the selectors
 *
 * @param {DataTable.Api} dt DataTable to remove events from
 * @private
 */ function disableMouseSelection(dt) {
        var ctx = dt.settings()[0];
        var selector = ctx._select.selector;
        $(dt.table().container()).off("mousedown.dtSelect", selector).off("mouseup.dtSelect", selector).off("click.dtSelect", selector);
        $("body").off("click.dtSelect" + _safeId(dt.table().node()));
    }
    /**
 * Attach mouse listeners to the table to allow mouse selection of items
 *
 * @param {DataTable.Api} dt DataTable to remove events from
 * @private
 */ function enableMouseSelection(dt) {
        var container = $(dt.table().container());
        var ctx = dt.settings()[0];
        var selector = ctx._select.selector;
        var matchSelection;
        container.on("mousedown.dtSelect", selector, function(e) {
            // Disallow text selection for shift clicking on the table so multi
            // element selection doesn't look terrible!
            if (e.shiftKey || e.metaKey || e.ctrlKey) container.css("-moz-user-select", "none").one("selectstart.dtSelect", selector, function() {
                return false;
            });
            if (window1.getSelection) matchSelection = window1.getSelection();
        }).on("mouseup.dtSelect", selector, function() {
            // Allow text selection to occur again, Mozilla style (tested in FF
            // 35.0.1 - still required)
            container.css("-moz-user-select", "");
        }).on("click.dtSelect", selector, function(e) {
            var items = dt.select.items();
            var idx;
            // If text was selected (click and drag), then we shouldn't change
            // the row's selected state
            if (matchSelection) {
                var selection = window1.getSelection();
                // If the element that contains the selection is not in the table, we can ignore it
                // This can happen if the developer selects text from the click event
                if (!selection.anchorNode || $(selection.anchorNode).closest("table")[0] === dt.table().node()) {
                    if (selection !== matchSelection) return;
                }
            }
            var ctx = dt.settings()[0];
            var wrapperClass = dt.settings()[0].oClasses.sWrapper.trim().replace(/ +/g, ".");
            // Ignore clicks inside a sub-table
            if ($(e.target).closest("div." + wrapperClass)[0] != dt.table().container()) return;
            var cell = dt.cell($(e.target).closest("td, th"));
            // Check the cell actually belongs to the host DataTable (so child
            // rows, etc, are ignored)
            if (!cell.any()) return;
            var event = $.Event("user-select.dt");
            eventTrigger(dt, event, [
                items,
                cell,
                e
            ]);
            if (event.isDefaultPrevented()) return;
            var cellIndex = cell.index();
            if (items === "row") {
                idx = cellIndex.row;
                typeSelect(e, dt, ctx, "row", idx);
            } else if (items === "column") {
                idx = cell.index().column;
                typeSelect(e, dt, ctx, "column", idx);
            } else if (items === "cell") {
                idx = cell.index();
                typeSelect(e, dt, ctx, "cell", idx);
            }
            ctx._select_lastCell = cellIndex;
        });
        // Blurable
        $("body").on("click.dtSelect" + _safeId(dt.table().node()), function(e) {
            if (ctx._select.blurable) {
                // If the click was inside the DataTables container, don't blur
                if ($(e.target).parents().filter(dt.table().container()).length) return;
                // Ignore elements which have been removed from the DOM (i.e. paging
                // buttons)
                if ($(e.target).parents("html").length === 0) return;
                // Don't blur in Editor form
                if ($(e.target).parents("div.DTE").length) return;
                var event = $.Event("select-blur.dt");
                eventTrigger(dt, event, [
                    e.target,
                    e
                ]);
                if (event.isDefaultPrevented()) return;
                clear(ctx, true);
            }
        });
    }
    /**
 * Trigger an event on a DataTable
 *
 * @param {DataTable.Api} api      DataTable to trigger events on
 * @param  {boolean}      selected true if selected, false if deselected
 * @param  {string}       type     Item type acting on
 * @param  {boolean}      any      Require that there are values before
 *     triggering
 * @private
 */ function eventTrigger(api, type, args, any) {
        if (any && !api.flatten().length) return;
        if (typeof type === "string") type = type + ".dt";
        args.unshift(api);
        $(api.table().node()).trigger(type, args);
    }
    /**
 * Update the information element of the DataTable showing information about the
 * items selected. This is done by adding tags to the existing text
 * 
 * @param {DataTable.Api} api DataTable to update
 * @private
 */ function info(api) {
        var ctx = api.settings()[0];
        if (!ctx._select.info || !ctx.aanFeatures.i) return;
        if (api.select.style() === "api") return;
        var rows = api.rows({
            selected: true
        }).flatten().length;
        var columns = api.columns({
            selected: true
        }).flatten().length;
        var cells = api.cells({
            selected: true
        }).flatten().length;
        var add = function(el, name, num) {
            el.append($('<span class="select-item"/>').append(api.i18n("select." + name + "s", {
                _: "%d " + name + "s selected",
                0: "",
                1: "1 " + name + " selected"
            }, num)));
        };
        // Internal knowledge of DataTables to loop over all information elements
        $.each(ctx.aanFeatures.i, function(i, el) {
            el = $(el);
            var output = $('<span class="select-info"/>');
            add(output, "row", rows);
            add(output, "column", columns);
            add(output, "cell", cells);
            var exisiting = el.children("span.select-info");
            if (exisiting.length) exisiting.remove();
            if (output.text() !== "") el.append(output);
        });
    }
    /**
 * Initialisation of a new table. Attach event handlers and callbacks to allow
 * Select to operate correctly.
 *
 * This will occur _after_ the initial DataTables initialisation, although
 * before Ajax data is rendered, if there is ajax data
 *
 * @param  {DataTable.settings} ctx Settings object to operate on
 * @private
 */ function init(ctx) {
        var api = new DataTable.Api(ctx);
        ctx._select_init = true;
        // Row callback so that classes can be added to rows and cells if the item
        // was selected before the element was created. This will happen with the
        // `deferRender` option enabled.
        // 
        // This method of attaching to `aoRowCreatedCallback` is a hack until
        // DataTables has proper events for row manipulation If you are reviewing
        // this code to create your own plug-ins, please do not do this!
        ctx.aoRowCreatedCallback.push({
            fn: function(row, data, index) {
                var i, ien;
                var d = ctx.aoData[index];
                // Row
                if (d._select_selected) $(row).addClass(ctx._select.className);
                // Cells and columns - if separated out, we would need to do two
                // loops, so it makes sense to combine them into a single one
                for(i = 0, ien = ctx.aoColumns.length; i < ien; i++)if (ctx.aoColumns[i]._select_selected || d._selected_cells && d._selected_cells[i]) $(d.anCells[i]).addClass(ctx._select.className);
            },
            sName: "select-deferRender"
        });
        // On Ajax reload we want to reselect all rows which are currently selected,
        // if there is an rowId (i.e. a unique value to identify each row with)
        api.on("preXhr.dt.dtSelect", function(e, settings) {
            if (settings !== api.settings()[0]) // Not triggered by our DataTable!
            return;
            // note that column selection doesn't need to be cached and then
            // reselected, as they are already selected
            var rows = api.rows({
                selected: true
            }).ids(true).filter(function(d) {
                return d !== undefined;
            });
            var cells = api.cells({
                selected: true
            }).eq(0).map(function(cellIdx) {
                var id = api.row(cellIdx.row).id(true);
                return id ? {
                    row: id,
                    column: cellIdx.column
                } : undefined;
            }).filter(function(d) {
                return d !== undefined;
            });
            // On the next draw, reselect the currently selected items
            api.one("draw.dt.dtSelect", function() {
                api.rows(rows).select();
                // `cells` is not a cell index selector, so it needs a loop
                if (cells.any()) cells.each(function(id) {
                    api.cells(id.row, id.column).select();
                });
            });
        });
        // Update the table information element with selected item summary
        api.on("draw.dtSelect.dt select.dtSelect.dt deselect.dtSelect.dt info.dt", function() {
            info(api);
            api.state.save();
        });
        // Clean up and release
        api.on("destroy.dtSelect", function() {
            api.rows({
                selected: true
            }).deselect();
            disableMouseSelection(api);
            api.off(".dtSelect");
            $("body").off(".dtSelect" + _safeId(api.table().node()));
        });
    }
    /**
 * Add one or more items (rows or columns) to the selection when shift clicking
 * in OS selection style
 *
 * @param  {DataTable.Api} dt   DataTable
 * @param  {string}        type Row or column range selector
 * @param  {object}        idx  Item index to select to
 * @param  {object}        last Item index to select from
 * @private
 */ function rowColumnRange(dt, type, idx, last) {
        // Add a range of rows from the last selected row to this one
        var indexes = dt[type + "s"]({
            search: "applied"
        }).indexes();
        var idx1 = $.inArray(last, indexes);
        var idx2 = $.inArray(idx, indexes);
        if (!dt[type + "s"]({
            selected: true
        }).any() && idx1 === -1) // select from top to here - slightly odd, but both Windows and Mac OS
        // do this
        indexes.splice($.inArray(idx, indexes) + 1, indexes.length);
        else {
            // reverse so we can shift click 'up' as well as down
            if (idx1 > idx2) {
                var tmp = idx2;
                idx2 = idx1;
                idx1 = tmp;
            }
            indexes.splice(idx2 + 1, indexes.length);
            indexes.splice(0, idx1);
        }
        if (!dt[type](idx, {
            selected: true
        }).any()) // Select range
        dt[type + "s"](indexes).select();
        else {
            // Deselect range - need to keep the clicked on row selected
            indexes.splice($.inArray(idx, indexes), 1);
            dt[type + "s"](indexes).deselect();
        }
    }
    /**
 * Clear all selected items
 *
 * @param  {DataTable.settings} ctx Settings object of the host DataTable
 * @param  {boolean} [force=false] Force the de-selection to happen, regardless
 *     of selection style
 * @private
 */ function clear(ctx, force) {
        if (force || ctx._select.style === "single") {
            var api = new DataTable.Api(ctx);
            api.rows({
                selected: true
            }).deselect();
            api.columns({
                selected: true
            }).deselect();
            api.cells({
                selected: true
            }).deselect();
        }
    }
    /**
 * Select items based on the current configuration for style and items.
 *
 * @param  {object}             e    Mouse event object
 * @param  {DataTables.Api}     dt   DataTable
 * @param  {DataTable.settings} ctx  Settings object of the host DataTable
 * @param  {string}             type Items to select
 * @param  {int|object}         idx  Index of the item to select
 * @private
 */ function typeSelect(e, dt, ctx, type, idx) {
        var style = dt.select.style();
        var toggleable = dt.select.toggleable();
        var isSelected = dt[type](idx, {
            selected: true
        }).any();
        if (isSelected && !toggleable) return;
        if (style === "os") {
            if (e.ctrlKey || e.metaKey) // Add or remove from the selection
            dt[type](idx).select(!isSelected);
            else if (e.shiftKey) {
                if (type === "cell") cellRange(dt, idx, ctx._select_lastCell || null);
                else rowColumnRange(dt, type, idx, ctx._select_lastCell ? ctx._select_lastCell[type] : null);
            } else {
                // No cmd or shift click - deselect if selected, or select
                // this row only
                var selected = dt[type + "s"]({
                    selected: true
                });
                if (isSelected && selected.flatten().length === 1) dt[type](idx).deselect();
                else {
                    selected.deselect();
                    dt[type](idx).select();
                }
            }
        } else if (style == "multi+shift") {
            if (e.shiftKey) {
                if (type === "cell") cellRange(dt, idx, ctx._select_lastCell || null);
                else rowColumnRange(dt, type, idx, ctx._select_lastCell ? ctx._select_lastCell[type] : null);
            } else dt[type](idx).select(!isSelected);
        } else dt[type](idx).select(!isSelected);
    }
    function _safeId(node) {
        return node.id.replace(/[^a-zA-Z0-9\-\_]/g, "-");
    }
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables selectors
 */ // row and column are basically identical just assigned to different properties
    // and checking a different array, so we can dynamically create the functions to
    // reduce the code size
    $.each([
        {
            type: "row",
            prop: "aoData"
        },
        {
            type: "column",
            prop: "aoColumns"
        }
    ], function(i, o) {
        DataTable.ext.selector[o.type].push(function(settings, opts, indexes) {
            var selected = opts.selected;
            var data;
            var out = [];
            if (selected !== true && selected !== false) return indexes;
            for(var i = 0, ien = indexes.length; i < ien; i++){
                data = settings[o.prop][indexes[i]];
                if (selected === true && data._select_selected === true || selected === false && !data._select_selected) out.push(indexes[i]);
            }
            return out;
        });
    });
    DataTable.ext.selector.cell.push(function(settings, opts, cells) {
        var selected = opts.selected;
        var rowData;
        var out = [];
        if (selected === undefined) return cells;
        for(var i = 0, ien = cells.length; i < ien; i++){
            rowData = settings.aoData[cells[i].row];
            if (selected === true && rowData._selected_cells && rowData._selected_cells[cells[i].column] === true || selected === false && (!rowData._selected_cells || !rowData._selected_cells[cells[i].column])) out.push(cells[i]);
        }
        return out;
    });
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables API
 *
 * For complete documentation, please refer to the docs/api directory or the
 * DataTables site
 */ // Local variables to improve compression
    var apiRegister = DataTable.Api.register;
    var apiRegisterPlural = DataTable.Api.registerPlural;
    apiRegister("select()", function() {
        return this.iterator("table", function(ctx) {
            DataTable.select.init(new DataTable.Api(ctx));
        });
    });
    apiRegister("select.blurable()", function(flag) {
        if (flag === undefined) return this.context[0]._select.blurable;
        return this.iterator("table", function(ctx) {
            ctx._select.blurable = flag;
        });
    });
    apiRegister("select.toggleable()", function(flag) {
        if (flag === undefined) return this.context[0]._select.toggleable;
        return this.iterator("table", function(ctx) {
            ctx._select.toggleable = flag;
        });
    });
    apiRegister("select.info()", function(flag) {
        if (flag === undefined) return this.context[0]._select.info;
        return this.iterator("table", function(ctx) {
            ctx._select.info = flag;
        });
    });
    apiRegister("select.items()", function(items) {
        if (items === undefined) return this.context[0]._select.items;
        return this.iterator("table", function(ctx) {
            ctx._select.items = items;
            eventTrigger(new DataTable.Api(ctx), "selectItems", [
                items
            ]);
        });
    });
    // Takes effect from the _next_ selection. None disables future selection, but
    // does not clear the current selection. Use the `deselect` methods for that
    apiRegister("select.style()", function(style) {
        if (style === undefined) return this.context[0]._select.style;
        return this.iterator("table", function(ctx) {
            if (!ctx._select) DataTable.select.init(new DataTable.Api(ctx));
            if (!ctx._select_init) init(ctx);
            ctx._select.style = style;
            // Add / remove mouse event handlers. They aren't required when only
            // API selection is available
            var dt = new DataTable.Api(ctx);
            disableMouseSelection(dt);
            if (style !== "api") enableMouseSelection(dt);
            eventTrigger(new DataTable.Api(ctx), "selectStyle", [
                style
            ]);
        });
    });
    apiRegister("select.selector()", function(selector) {
        if (selector === undefined) return this.context[0]._select.selector;
        return this.iterator("table", function(ctx) {
            disableMouseSelection(new DataTable.Api(ctx));
            ctx._select.selector = selector;
            if (ctx._select.style !== "api") enableMouseSelection(new DataTable.Api(ctx));
        });
    });
    apiRegisterPlural("rows().select()", "row().select()", function(select) {
        var api = this;
        if (select === false) return this.deselect();
        this.iterator("row", function(ctx, idx) {
            clear(ctx);
            ctx.aoData[idx]._select_selected = true;
            $(ctx.aoData[idx].nTr).addClass(ctx._select.className);
        });
        this.iterator("table", function(ctx, i) {
            eventTrigger(api, "select", [
                "row",
                api[i]
            ], true);
        });
        return this;
    });
    apiRegister("row().selected()", function() {
        var ctx = this.context[0];
        if (ctx && this.length && ctx.aoData[this[0]] && ctx.aoData[this[0]]._select_selected) return true;
        return false;
    });
    apiRegisterPlural("columns().select()", "column().select()", function(select) {
        var api = this;
        if (select === false) return this.deselect();
        this.iterator("column", function(ctx, idx) {
            clear(ctx);
            ctx.aoColumns[idx]._select_selected = true;
            var column = new DataTable.Api(ctx).column(idx);
            $(column.header()).addClass(ctx._select.className);
            $(column.footer()).addClass(ctx._select.className);
            column.nodes().to$().addClass(ctx._select.className);
        });
        this.iterator("table", function(ctx, i) {
            eventTrigger(api, "select", [
                "column",
                api[i]
            ], true);
        });
        return this;
    });
    apiRegister("column().selected()", function() {
        var ctx = this.context[0];
        if (ctx && this.length && ctx.aoColumns[this[0]] && ctx.aoColumns[this[0]]._select_selected) return true;
        return false;
    });
    apiRegisterPlural("cells().select()", "cell().select()", function(select) {
        var api = this;
        if (select === false) return this.deselect();
        this.iterator("cell", function(ctx, rowIdx, colIdx) {
            clear(ctx);
            var data = ctx.aoData[rowIdx];
            if (data._selected_cells === undefined) data._selected_cells = [];
            data._selected_cells[colIdx] = true;
            if (data.anCells) $(data.anCells[colIdx]).addClass(ctx._select.className);
        });
        this.iterator("table", function(ctx, i) {
            eventTrigger(api, "select", [
                "cell",
                api.cells(api[i]).indexes().toArray()
            ], true);
        });
        return this;
    });
    apiRegister("cell().selected()", function() {
        var ctx = this.context[0];
        if (ctx && this.length) {
            var row = ctx.aoData[this[0][0].row];
            if (row && row._selected_cells && row._selected_cells[this[0][0].column]) return true;
        }
        return false;
    });
    apiRegisterPlural("rows().deselect()", "row().deselect()", function() {
        var api = this;
        this.iterator("row", function(ctx, idx) {
            ctx.aoData[idx]._select_selected = false;
            ctx._select_lastCell = null;
            $(ctx.aoData[idx].nTr).removeClass(ctx._select.className);
        });
        this.iterator("table", function(ctx, i) {
            eventTrigger(api, "deselect", [
                "row",
                api[i]
            ], true);
        });
        return this;
    });
    apiRegisterPlural("columns().deselect()", "column().deselect()", function() {
        var api = this;
        this.iterator("column", function(ctx, idx) {
            ctx.aoColumns[idx]._select_selected = false;
            var api = new DataTable.Api(ctx);
            var column = api.column(idx);
            $(column.header()).removeClass(ctx._select.className);
            $(column.footer()).removeClass(ctx._select.className);
            // Need to loop over each cell, rather than just using
            // `column().nodes()` as cells which are individually selected should
            // not have the `selected` class removed from them
            api.cells(null, idx).indexes().each(function(cellIdx) {
                var data = ctx.aoData[cellIdx.row];
                var cellSelected = data._selected_cells;
                if (data.anCells && (!cellSelected || !cellSelected[cellIdx.column])) $(data.anCells[cellIdx.column]).removeClass(ctx._select.className);
            });
        });
        this.iterator("table", function(ctx, i) {
            eventTrigger(api, "deselect", [
                "column",
                api[i]
            ], true);
        });
        return this;
    });
    apiRegisterPlural("cells().deselect()", "cell().deselect()", function() {
        var api = this;
        this.iterator("cell", function(ctx, rowIdx, colIdx) {
            var data = ctx.aoData[rowIdx];
            if (data._selected_cells !== undefined) data._selected_cells[colIdx] = false;
            // Remove class only if the cells exist, and the cell is not column
            // selected, in which case the class should remain (since it is selected
            // in the column)
            if (data.anCells && !ctx.aoColumns[colIdx]._select_selected) $(data.anCells[colIdx]).removeClass(ctx._select.className);
        });
        this.iterator("table", function(ctx, i) {
            eventTrigger(api, "deselect", [
                "cell",
                api[i]
            ], true);
        });
        return this;
    });
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Buttons
 */ function i18n(label, def) {
        return function(dt) {
            return dt.i18n("buttons." + label, def);
        };
    }
    // Common events with suitable namespaces
    function namespacedEvents(config) {
        var unique = config._eventNamespace;
        return "draw.dt.DT" + unique + " select.dt.DT" + unique + " deselect.dt.DT" + unique;
    }
    function enabled(dt, config) {
        if ($.inArray("rows", config.limitTo) !== -1 && dt.rows({
            selected: true
        }).any()) return true;
        if ($.inArray("columns", config.limitTo) !== -1 && dt.columns({
            selected: true
        }).any()) return true;
        if ($.inArray("cells", config.limitTo) !== -1 && dt.cells({
            selected: true
        }).any()) return true;
        return false;
    }
    var _buttonNamespace = 0;
    $.extend(DataTable.ext.buttons, {
        selected: {
            text: i18n("selected", "Selected"),
            className: "buttons-selected",
            limitTo: [
                "rows",
                "columns",
                "cells"
            ],
            init: function(dt, node, config) {
                var that = this;
                config._eventNamespace = ".select" + _buttonNamespace++;
                // .DT namespace listeners are removed by DataTables automatically
                // on table destroy
                dt.on(namespacedEvents(config), function() {
                    that.enable(enabled(dt, config));
                });
                this.disable();
            },
            destroy: function(dt, node, config) {
                dt.off(config._eventNamespace);
            }
        },
        selectedSingle: {
            text: i18n("selectedSingle", "Selected single"),
            className: "buttons-selected-single",
            init: function(dt, node, config) {
                var that = this;
                config._eventNamespace = ".select" + _buttonNamespace++;
                dt.on(namespacedEvents(config), function() {
                    var count = dt.rows({
                        selected: true
                    }).flatten().length + dt.columns({
                        selected: true
                    }).flatten().length + dt.cells({
                        selected: true
                    }).flatten().length;
                    that.enable(count === 1);
                });
                this.disable();
            },
            destroy: function(dt, node, config) {
                dt.off(config._eventNamespace);
            }
        },
        selectAll: {
            text: i18n("selectAll", "Select all"),
            className: "buttons-select-all",
            action: function() {
                var items = this.select.items();
                this[items + "s"]().select();
            }
        },
        selectNone: {
            text: i18n("selectNone", "Deselect all"),
            className: "buttons-select-none",
            action: function() {
                clear(this.settings()[0], true);
            },
            init: function(dt, node, config) {
                var that = this;
                config._eventNamespace = ".select" + _buttonNamespace++;
                dt.on(namespacedEvents(config), function() {
                    var count = dt.rows({
                        selected: true
                    }).flatten().length + dt.columns({
                        selected: true
                    }).flatten().length + dt.cells({
                        selected: true
                    }).flatten().length;
                    that.enable(count > 0);
                });
                this.disable();
            },
            destroy: function(dt, node, config) {
                dt.off(config._eventNamespace);
            }
        }
    });
    $.each([
        "Row",
        "Column",
        "Cell"
    ], function(i, item) {
        var lc = item.toLowerCase();
        DataTable.ext.buttons["select" + item + "s"] = {
            text: i18n("select" + item + "s", "Select " + lc + "s"),
            className: "buttons-select-" + lc + "s",
            action: function() {
                this.select.items(lc);
            },
            init: function(dt) {
                var that = this;
                dt.on("selectItems.dt.DT", function(e, ctx, items) {
                    that.active(items === lc);
                });
            }
        };
    });
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Initialisation
 */ // DataTables creation - check if select has been defined in the options. Note
    // this required that the table be in the document! If it isn't then something
    // needs to trigger this method unfortunately. The next major release of
    // DataTables will rework the events and address this.
    $(document1).on("preInit.dt.dtSelect", function(e, ctx) {
        if (e.namespace !== "dt") return;
        DataTable.select.init(new DataTable.Api(ctx));
    });
    return DataTable.select;
});

});

parcelRegister("1d1BV", function(module, exports) {

/*! Buttons for DataTables 1.7.1
 * ©2016-2021 SpryMedia Ltd - datatables.net/license
 */ (function(factory) {
    if (typeof define === "function" && define.amd) // AMD
    define([
        "jquery",
        "datatables.net"
    ], function($) {
        return factory($, window, document);
    });
    else // CommonJS
    module.exports = function(root, $) {
        if (!root) root = window;
        if (!$ || !$.fn.dataTable) $ = (parcelRequire("EHlDu"))(root, $).$;
        return factory($, root, root.document);
    };
})(function($, window1, document1, undefined) {
    "use strict";
    var DataTable = $.fn.dataTable;
    // Used for namespacing events added to the document by each instance, so they
    // can be removed on destroy
    var _instCounter = 0;
    // Button namespacing counter for namespacing events on individual buttons
    var _buttonCounter = 0;
    var _dtButtons = DataTable.ext.buttons;
    // Allow for jQuery slim
    function _fadeIn(el, duration, fn) {
        if ($.fn.animate) el.stop().fadeIn(duration, fn);
        else {
            el.css("display", "block");
            if (fn) fn.call(el);
        }
    }
    function _fadeOut(el, duration, fn) {
        if ($.fn.animate) el.stop().fadeOut(duration, fn);
        else {
            el.css("display", "none");
            if (fn) fn.call(el);
        }
    }
    /**
 * [Buttons description]
 * @param {[type]}
 * @param {[type]}
 */ var Buttons = function(dt, config) {
        // If not created with a `new` keyword then we return a wrapper function that
        // will take the settings object for a DT. This allows easy use of new instances
        // with the `layout` option - e.g. `topLeft: $.fn.dataTable.Buttons( ... )`.
        if (!(this instanceof Buttons)) return function(settings) {
            return new Buttons(settings, dt).container();
        };
        // If there is no config set it to an empty object
        if (typeof config === "undefined") config = {};
        // Allow a boolean true for defaults
        if (config === true) config = {};
        // For easy configuration of buttons an array can be given
        if (Array.isArray(config)) config = {
            buttons: config
        };
        this.c = $.extend(true, {}, Buttons.defaults, config);
        // Don't want a deep copy for the buttons
        if (config.buttons) this.c.buttons = config.buttons;
        this.s = {
            dt: new DataTable.Api(dt),
            buttons: [],
            listenKeys: "",
            namespace: "dtb" + _instCounter++
        };
        this.dom = {
            container: $("<" + this.c.dom.container.tag + "/>").addClass(this.c.dom.container.className)
        };
        this._constructor();
    };
    $.extend(Buttons.prototype, {
        /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Public methods
	 */ /**
	 * Get the action of a button
	 * @param  {int|string} Button index
	 * @return {function}
	 */ /**
	 * Set the action of a button
	 * @param  {node} node Button element
	 * @param  {function} action Function to set
	 * @return {Buttons} Self for chaining
	 */ action: function(node, action) {
            var button = this._nodeToButton(node);
            if (action === undefined) return button.conf.action;
            button.conf.action = action;
            return this;
        },
        /**
	 * Add an active class to the button to make to look active or get current
	 * active state.
	 * @param  {node} node Button element
	 * @param  {boolean} [flag] Enable / disable flag
	 * @return {Buttons} Self for chaining or boolean for getter
	 */ active: function(node, flag) {
            var button = this._nodeToButton(node);
            var klass = this.c.dom.button.active;
            var jqNode = $(button.node);
            if (flag === undefined) return jqNode.hasClass(klass);
            jqNode.toggleClass(klass, flag === undefined ? true : flag);
            return this;
        },
        /**
	 * Add a new button
	 * @param {object} config Button configuration object, base string name or function
	 * @param {int|string} [idx] Button index for where to insert the button
	 * @return {Buttons} Self for chaining
	 */ add: function(config, idx) {
            var buttons = this.s.buttons;
            if (typeof idx === "string") {
                var split = idx.split("-");
                var base = this.s;
                for(var i = 0, ien = split.length - 1; i < ien; i++)base = base.buttons[split[i] * 1];
                buttons = base.buttons;
                idx = split[split.length - 1] * 1;
            }
            this._expandButton(buttons, config, base !== undefined, idx);
            this._draw();
            return this;
        },
        /**
	 * Get the container node for the buttons
	 * @return {jQuery} Buttons node
	 */ container: function() {
            return this.dom.container;
        },
        /**
	 * Disable a button
	 * @param  {node} node Button node
	 * @return {Buttons} Self for chaining
	 */ disable: function(node) {
            var button = this._nodeToButton(node);
            $(button.node).addClass(this.c.dom.button.disabled).attr("disabled", true);
            return this;
        },
        /**
	 * Destroy the instance, cleaning up event handlers and removing DOM
	 * elements
	 * @return {Buttons} Self for chaining
	 */ destroy: function() {
            // Key event listener
            $("body").off("keyup." + this.s.namespace);
            // Individual button destroy (so they can remove their own events if
            // needed). Take a copy as the array is modified by `remove`
            var buttons = this.s.buttons.slice();
            var i, ien;
            for(i = 0, ien = buttons.length; i < ien; i++)this.remove(buttons[i].node);
            // Container
            this.dom.container.remove();
            // Remove from the settings object collection
            var buttonInsts = this.s.dt.settings()[0];
            for(i = 0, ien = buttonInsts.length; i < ien; i++)if (buttonInsts.inst === this) {
                buttonInsts.splice(i, 1);
                break;
            }
            return this;
        },
        /**
	 * Enable / disable a button
	 * @param  {node} node Button node
	 * @param  {boolean} [flag=true] Enable / disable flag
	 * @return {Buttons} Self for chaining
	 */ enable: function(node, flag) {
            if (flag === false) return this.disable(node);
            var button = this._nodeToButton(node);
            $(button.node).removeClass(this.c.dom.button.disabled).removeAttr("disabled");
            return this;
        },
        /**
	 * Get the instance name for the button set selector
	 * @return {string} Instance name
	 */ name: function() {
            return this.c.name;
        },
        /**
	 * Get a button's node of the buttons container if no button is given
	 * @param  {node} [node] Button node
	 * @return {jQuery} Button element, or container
	 */ node: function(node) {
            if (!node) return this.dom.container;
            var button = this._nodeToButton(node);
            return $(button.node);
        },
        /**
	 * Set / get a processing class on the selected button
	 * @param {element} node Triggering button node
	 * @param  {boolean} flag true to add, false to remove, undefined to get
	 * @return {boolean|Buttons} Getter value or this if a setter.
	 */ processing: function(node, flag) {
            var dt = this.s.dt;
            var button = this._nodeToButton(node);
            if (flag === undefined) return $(button.node).hasClass("processing");
            $(button.node).toggleClass("processing", flag);
            $(dt.table().node()).triggerHandler("buttons-processing.dt", [
                flag,
                dt.button(node),
                dt,
                $(node),
                button.conf
            ]);
            return this;
        },
        /**
	 * Remove a button.
	 * @param  {node} node Button node
	 * @return {Buttons} Self for chaining
	 */ remove: function(node) {
            var button = this._nodeToButton(node);
            var host = this._nodeToHost(node);
            var dt = this.s.dt;
            // Remove any child buttons first
            if (button.buttons.length) for(var i = button.buttons.length - 1; i >= 0; i--)this.remove(button.buttons[i].node);
            // Allow the button to remove event handlers, etc
            if (button.conf.destroy) button.conf.destroy.call(dt.button(node), dt, $(node), button.conf);
            this._removeKey(button.conf);
            $(button.node).remove();
            var idx = $.inArray(button, host);
            host.splice(idx, 1);
            return this;
        },
        /**
	 * Get the text for a button
	 * @param  {int|string} node Button index
	 * @return {string} Button text
	 */ /**
	 * Set the text for a button
	 * @param  {int|string|function} node Button index
	 * @param  {string} label Text
	 * @return {Buttons} Self for chaining
	 */ text: function(node, label) {
            var button = this._nodeToButton(node);
            var buttonLiner = this.c.dom.collection.buttonLiner;
            var linerTag = button.inCollection && buttonLiner && buttonLiner.tag ? buttonLiner.tag : this.c.dom.buttonLiner.tag;
            var dt = this.s.dt;
            var jqNode = $(button.node);
            var text = function(opt) {
                return typeof opt === "function" ? opt(dt, jqNode, button.conf) : opt;
            };
            if (label === undefined) return text(button.conf.text);
            button.conf.text = label;
            if (linerTag) jqNode.children(linerTag).html(text(label));
            else jqNode.html(text(label));
            return this;
        },
        /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Constructor
	 */ /**
	 * Buttons constructor
	 * @private
	 */ _constructor: function() {
            var that = this;
            var dt = this.s.dt;
            var dtSettings = dt.settings()[0];
            var buttons = this.c.buttons;
            if (!dtSettings._buttons) dtSettings._buttons = [];
            dtSettings._buttons.push({
                inst: this,
                name: this.c.name
            });
            for(var i = 0, ien = buttons.length; i < ien; i++)this.add(buttons[i]);
            dt.on("destroy", function(e, settings) {
                if (settings === dtSettings) that.destroy();
            });
            // Global key event binding to listen for button keys
            $("body").on("keyup." + this.s.namespace, function(e) {
                if (!document1.activeElement || document1.activeElement === document1.body) {
                    // SUse a string of characters for fast lookup of if we need to
                    // handle this
                    var character = String.fromCharCode(e.keyCode).toLowerCase();
                    if (that.s.listenKeys.toLowerCase().indexOf(character) !== -1) that._keypress(character, e);
                }
            });
        },
        /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods
	 */ /**
	 * Add a new button to the key press listener
	 * @param {object} conf Resolved button configuration object
	 * @private
	 */ _addKey: function(conf) {
            if (conf.key) this.s.listenKeys += $.isPlainObject(conf.key) ? conf.key.key : conf.key;
        },
        /**
	 * Insert the buttons into the container. Call without parameters!
	 * @param  {node} [container] Recursive only - Insert point
	 * @param  {array} [buttons] Recursive only - Buttons array
	 * @private
	 */ _draw: function(container, buttons) {
            if (!container) {
                container = this.dom.container;
                buttons = this.s.buttons;
            }
            container.children().detach();
            for(var i = 0, ien = buttons.length; i < ien; i++){
                container.append(buttons[i].inserter);
                container.append(" ");
                if (buttons[i].buttons && buttons[i].buttons.length) this._draw(buttons[i].collection, buttons[i].buttons);
            }
        },
        /**
	 * Create buttons from an array of buttons
	 * @param  {array} attachTo Buttons array to attach to
	 * @param  {object} button Button definition
	 * @param  {boolean} inCollection true if the button is in a collection
	 * @private
	 */ _expandButton: function(attachTo, button, inCollection, attachPoint) {
            var dt = this.s.dt;
            var buttonCounter = 0;
            var buttons = !Array.isArray(button) ? [
                button
            ] : button;
            for(var i = 0, ien = buttons.length; i < ien; i++){
                var conf = this._resolveExtends(buttons[i]);
                if (!conf) continue;
                // If the configuration is an array, then expand the buttons at this
                // point
                if (Array.isArray(conf)) {
                    this._expandButton(attachTo, conf, inCollection, attachPoint);
                    continue;
                }
                var built = this._buildButton(conf, inCollection);
                if (!built) continue;
                if (attachPoint !== undefined && attachPoint !== null) {
                    attachTo.splice(attachPoint, 0, built);
                    attachPoint++;
                } else attachTo.push(built);
                if (built.conf.buttons) {
                    built.collection = $("<" + this.c.dom.collection.tag + "/>");
                    built.conf._collection = built.collection;
                    this._expandButton(built.buttons, built.conf.buttons, true, attachPoint);
                }
                // init call is made here, rather than buildButton as it needs to
                // be selectable, and for that it needs to be in the buttons array
                if (conf.init) conf.init.call(dt.button(built.node), dt, $(built.node), conf);
                buttonCounter++;
            }
        },
        /**
	 * Create an individual button
	 * @param  {object} config            Resolved button configuration
	 * @param  {boolean} inCollection `true` if a collection button
	 * @return {jQuery} Created button node (jQuery)
	 * @private
	 */ _buildButton: function(config, inCollection) {
            var buttonDom = this.c.dom.button;
            var linerDom = this.c.dom.buttonLiner;
            var collectionDom = this.c.dom.collection;
            var dt = this.s.dt;
            var text = function(opt) {
                return typeof opt === "function" ? opt(dt, button, config) : opt;
            };
            if (inCollection && collectionDom.button) buttonDom = collectionDom.button;
            if (inCollection && collectionDom.buttonLiner) linerDom = collectionDom.buttonLiner;
            // Make sure that the button is available based on whatever requirements
            // it has. For example, PDF button require pdfmake
            if (config.available && !config.available(dt, config)) return false;
            var action = function(e, dt, button, config) {
                config.action.call(dt.button(button), e, dt, button, config);
                $(dt.table().node()).triggerHandler("buttons-action.dt", [
                    dt.button(button),
                    dt,
                    button,
                    config
                ]);
            };
            var tag = config.tag || buttonDom.tag;
            var clickBlurs = config.clickBlurs === undefined ? true : config.clickBlurs;
            var button = $("<" + tag + "/>").addClass(buttonDom.className).attr("tabindex", this.s.dt.settings()[0].iTabIndex).attr("aria-controls", this.s.dt.table().node().id).on("click.dtb", function(e) {
                e.preventDefault();
                if (!button.hasClass(buttonDom.disabled) && config.action) action(e, dt, button, config);
                if (clickBlurs) button.trigger("blur");
            }).on("keyup.dtb", function(e) {
                if (e.keyCode === 13) {
                    if (!button.hasClass(buttonDom.disabled) && config.action) action(e, dt, button, config);
                }
            });
            // Make `a` tags act like a link
            if (tag.toLowerCase() === "a") button.attr("href", "#");
            // Button tags should have `type=button` so they don't have any default behaviour
            if (tag.toLowerCase() === "button") button.attr("type", "button");
            if (linerDom.tag) {
                var liner = $("<" + linerDom.tag + "/>").html(text(config.text)).addClass(linerDom.className);
                if (linerDom.tag.toLowerCase() === "a") liner.attr("href", "#");
                button.append(liner);
            } else button.html(text(config.text));
            if (config.enabled === false) button.addClass(buttonDom.disabled);
            if (config.className) button.addClass(config.className);
            if (config.titleAttr) button.attr("title", text(config.titleAttr));
            if (config.attr) button.attr(config.attr);
            if (!config.namespace) config.namespace = ".dt-button-" + _buttonCounter++;
            var buttonContainer = this.c.dom.buttonContainer;
            var inserter;
            if (buttonContainer && buttonContainer.tag) inserter = $("<" + buttonContainer.tag + "/>").addClass(buttonContainer.className).append(button);
            else inserter = button;
            this._addKey(config);
            // Style integration callback for DOM manipulation
            // Note that this is _not_ documented. It is currently
            // for style integration only
            if (this.c.buttonCreated) inserter = this.c.buttonCreated(config, inserter);
            return {
                conf: config,
                node: button.get(0),
                inserter: inserter,
                buttons: [],
                inCollection: inCollection,
                collection: null
            };
        },
        /**
	 * Get the button object from a node (recursive)
	 * @param  {node} node Button node
	 * @param  {array} [buttons] Button array, uses base if not defined
	 * @return {object} Button object
	 * @private
	 */ _nodeToButton: function(node, buttons) {
            if (!buttons) buttons = this.s.buttons;
            for(var i = 0, ien = buttons.length; i < ien; i++){
                if (buttons[i].node === node) return buttons[i];
                if (buttons[i].buttons.length) {
                    var ret = this._nodeToButton(node, buttons[i].buttons);
                    if (ret) return ret;
                }
            }
        },
        /**
	 * Get container array for a button from a button node (recursive)
	 * @param  {node} node Button node
	 * @param  {array} [buttons] Button array, uses base if not defined
	 * @return {array} Button's host array
	 * @private
	 */ _nodeToHost: function(node, buttons) {
            if (!buttons) buttons = this.s.buttons;
            for(var i = 0, ien = buttons.length; i < ien; i++){
                if (buttons[i].node === node) return buttons;
                if (buttons[i].buttons.length) {
                    var ret = this._nodeToHost(node, buttons[i].buttons);
                    if (ret) return ret;
                }
            }
        },
        /**
	 * Handle a key press - determine if any button's key configured matches
	 * what was typed and trigger the action if so.
	 * @param  {string} character The character pressed
	 * @param  {object} e Key event that triggered this call
	 * @private
	 */ _keypress: function(character, e) {
            // Check if this button press already activated on another instance of Buttons
            if (e._buttonsHandled) return;
            var run = function(conf, node) {
                if (!conf.key) return;
                if (conf.key === character) {
                    e._buttonsHandled = true;
                    $(node).click();
                } else if ($.isPlainObject(conf.key)) {
                    if (conf.key.key !== character) return;
                    if (conf.key.shiftKey && !e.shiftKey) return;
                    if (conf.key.altKey && !e.altKey) return;
                    if (conf.key.ctrlKey && !e.ctrlKey) return;
                    if (conf.key.metaKey && !e.metaKey) return;
                    // Made it this far - it is good
                    e._buttonsHandled = true;
                    $(node).click();
                }
            };
            var recurse = function(a) {
                for(var i = 0, ien = a.length; i < ien; i++){
                    run(a[i].conf, a[i].node);
                    if (a[i].buttons.length) recurse(a[i].buttons);
                }
            };
            recurse(this.s.buttons);
        },
        /**
	 * Remove a key from the key listener for this instance (to be used when a
	 * button is removed)
	 * @param  {object} conf Button configuration
	 * @private
	 */ _removeKey: function(conf) {
            if (conf.key) {
                var character = $.isPlainObject(conf.key) ? conf.key.key : conf.key;
                // Remove only one character, as multiple buttons could have the
                // same listening key
                var a = this.s.listenKeys.split("");
                var idx = $.inArray(character, a);
                a.splice(idx, 1);
                this.s.listenKeys = a.join("");
            }
        },
        /**
	 * Resolve a button configuration
	 * @param  {string|function|object} conf Button config to resolve
	 * @return {object} Button configuration
	 * @private
	 */ _resolveExtends: function(conf) {
            var dt = this.s.dt;
            var i, ien;
            var toConfObject = function(base) {
                var loop = 0;
                // Loop until we have resolved to a button configuration, or an
                // array of button configurations (which will be iterated
                // separately)
                while(!$.isPlainObject(base) && !Array.isArray(base)){
                    if (base === undefined) return;
                    if (typeof base === "function") {
                        base = base(dt, conf);
                        if (!base) return false;
                    } else if (typeof base === "string") {
                        if (!_dtButtons[base]) throw "Unknown button type: " + base;
                        base = _dtButtons[base];
                    }
                    loop++;
                    if (loop > 30) // Protect against misconfiguration killing the browser
                    throw "Buttons: Too many iterations";
                }
                return Array.isArray(base) ? base : $.extend({}, base);
            };
            conf = toConfObject(conf);
            while(conf && conf.extend){
                // Use `toConfObject` in case the button definition being extended
                // is itself a string or a function
                if (!_dtButtons[conf.extend]) throw "Cannot extend unknown button type: " + conf.extend;
                var objArray = toConfObject(_dtButtons[conf.extend]);
                if (Array.isArray(objArray)) return objArray;
                else if (!objArray) // This is a little brutal as it might be possible to have a
                // valid button without the extend, but if there is no extend
                // then the host button would be acting in an undefined state
                return false;
                // Stash the current class name
                var originalClassName = objArray.className;
                conf = $.extend({}, objArray, conf);
                // The extend will have overwritten the original class name if the
                // `conf` object also assigned a class, but we want to concatenate
                // them so they are list that is combined from all extended buttons
                if (originalClassName && conf.className !== originalClassName) conf.className = originalClassName + " " + conf.className;
                // Buttons to be added to a collection  -gives the ability to define
                // if buttons should be added to the start or end of a collection
                var postfixButtons = conf.postfixButtons;
                if (postfixButtons) {
                    if (!conf.buttons) conf.buttons = [];
                    for(i = 0, ien = postfixButtons.length; i < ien; i++)conf.buttons.push(postfixButtons[i]);
                    conf.postfixButtons = null;
                }
                var prefixButtons = conf.prefixButtons;
                if (prefixButtons) {
                    if (!conf.buttons) conf.buttons = [];
                    for(i = 0, ien = prefixButtons.length; i < ien; i++)conf.buttons.splice(i, 0, prefixButtons[i]);
                    conf.prefixButtons = null;
                }
                // Although we want the `conf` object to overwrite almost all of
                // the properties of the object being extended, the `extend`
                // property should come from the object being extended
                conf.extend = objArray.extend;
            }
            return conf;
        },
        /**
	 * Display (and replace if there is an existing one) a popover attached to a button
	 * @param {string|node} content Content to show
	 * @param {DataTable.Api} hostButton DT API instance of the button
	 * @param {object} inOpts Options (see object below for all options)
	 */ _popover: function(content, hostButton, inOpts) {
            var dt = hostButton;
            var buttonsSettings = this.c;
            var options = $.extend({
                align: "button-left",
                autoClose: false,
                background: true,
                backgroundClassName: "dt-button-background",
                contentClassName: buttonsSettings.dom.collection.className,
                collectionLayout: "",
                collectionTitle: "",
                dropup: false,
                fade: 400,
                rightAlignClassName: "dt-button-right",
                tag: buttonsSettings.dom.collection.tag
            }, inOpts);
            var hostNode = hostButton.node();
            var close = function() {
                _fadeOut($(".dt-button-collection"), options.fade, function() {
                    $(this).detach();
                });
                $(dt.buttons('[aria-haspopup="true"][aria-expanded="true"]').nodes()).attr("aria-expanded", "false");
                $("div.dt-button-background").off("click.dtb-collection");
                Buttons.background(false, options.backgroundClassName, options.fade, hostNode);
                $("body").off(".dtb-collection");
                dt.off("buttons-action.b-internal");
            };
            if (content === false) close();
            var existingExpanded = $(dt.buttons('[aria-haspopup="true"][aria-expanded="true"]').nodes());
            if (existingExpanded.length) {
                hostNode = existingExpanded.eq(0);
                close();
            }
            var display = $("<div/>").addClass("dt-button-collection").addClass(options.collectionLayout).css("display", "none");
            content = $(content).addClass(options.contentClassName).attr("role", "menu").appendTo(display);
            hostNode.attr("aria-expanded", "true");
            if (hostNode.parents("body")[0] !== document1.body) hostNode = document1.body.lastChild;
            if (options.collectionTitle) display.prepend('<div class="dt-button-collection-title">' + options.collectionTitle + "</div>");
            _fadeIn(display.insertAfter(hostNode), options.fade);
            var tableContainer = $(hostButton.table().container());
            var position = display.css("position");
            if (options.align === "dt-container") {
                hostNode = hostNode.parent();
                display.css("width", tableContainer.width());
            }
            // Align the popover relative to the DataTables container
            // Useful for wide popovers such as SearchPanes
            if (position === "absolute") {
                // Align relative to the host button
                var hostPosition = hostNode.position();
                var buttonPosition = $(hostButton.node()).position();
                display.css({
                    top: buttonPosition.top + hostNode.outerHeight(),
                    left: hostPosition.left
                });
                // calculate overflow when positioned beneath
                var collectionHeight = display.outerHeight();
                var tableBottom = tableContainer.offset().top + tableContainer.height();
                var listBottom = buttonPosition.top + hostNode.outerHeight() + collectionHeight;
                var bottomOverflow = listBottom - tableBottom;
                // calculate overflow when positioned above
                var listTop = buttonPosition.top - collectionHeight;
                var tableTop = tableContainer.offset().top;
                var topOverflow = tableTop - listTop;
                // if bottom overflow is larger, move to the top because it fits better, or if dropup is requested
                var moveTop = buttonPosition.top - collectionHeight - 5;
                if ((bottomOverflow > topOverflow || options.dropup) && -moveTop < tableTop) display.css("top", moveTop);
                // Get the size of the container (left and width - and thus also right)
                var tableLeft = tableContainer.offset().left;
                var tableWidth = tableContainer.width();
                var tableRight = tableLeft + tableWidth;
                // Get the size of the popover (left and width - and ...)
                var popoverLeft = display.offset().left;
                var popoverWidth = display.width();
                var popoverRight = popoverLeft + popoverWidth;
                // Get the size of the host buttons (left and width - and ...)
                var buttonsLeft = hostNode.offset().left;
                var buttonsWidth = hostNode.outerWidth();
                var buttonsRight = buttonsLeft + buttonsWidth;
                if (display.hasClass(options.rightAlignClassName) || display.hasClass(options.leftAlignClassName) || options.align === "dt-container") {
                    // You've then got all the numbers you need to do some calculations and if statements,
                    //  so we can do some quick JS maths and apply it only once
                    // If it has the right align class OR the buttons are right aligned OR the button container is floated right,
                    //  then calculate left position for the popover to align the popover to the right hand
                    //  side of the button - check to see if the left of the popover is inside the table container.
                    // If not, move the popover so it is, but not more than it means that the popover is to the right of the table container
                    var popoverShuffle = 0;
                    if (display.hasClass(options.rightAlignClassName)) {
                        popoverShuffle = buttonsRight - popoverRight;
                        if (tableLeft > popoverLeft + popoverShuffle) {
                            var leftGap = tableLeft - (popoverLeft + popoverShuffle);
                            var rightGap = tableRight - (popoverRight + popoverShuffle);
                            if (leftGap > rightGap) popoverShuffle += rightGap;
                            else popoverShuffle += leftGap;
                        }
                    } else {
                        popoverShuffle = tableLeft - popoverLeft;
                        if (tableRight < popoverRight + popoverShuffle) {
                            var leftGap = tableLeft - (popoverLeft + popoverShuffle);
                            var rightGap = tableRight - (popoverRight + popoverShuffle);
                            if (leftGap > rightGap) popoverShuffle += rightGap;
                            else popoverShuffle += leftGap;
                        }
                    }
                    display.css("left", display.position().left + popoverShuffle);
                } else {
                    var top = hostNode.offset().top;
                    var popoverShuffle = 0;
                    popoverShuffle = options.align === "button-right" ? buttonsRight - popoverRight : buttonsLeft - popoverLeft;
                    display.css("left", display.position().left + popoverShuffle);
                }
            } else {
                // Fix position - centre on screen
                var top = display.height() / 2;
                if (top > $(window1).height() / 2) top = $(window1).height() / 2;
                display.css("marginTop", top * -1);
            }
            if (options.background) Buttons.background(true, options.backgroundClassName, options.fade, hostNode);
            // This is bonkers, but if we don't have a click listener on the
            // background element, iOS Safari will ignore the body click
            // listener below. An empty function here is all that is
            // required to make it work...
            $("div.dt-button-background").on("click.dtb-collection", function() {});
            $("body").on("click.dtb-collection", function(e) {
                // andSelf is deprecated in jQ1.8, but we want 1.7 compat
                var back = $.fn.addBack ? "addBack" : "andSelf";
                var parent = $(e.target).parent()[0];
                if (!$(e.target).parents()[back]().filter(content).length && !$(parent).hasClass("dt-buttons") || $(e.target).hasClass("dt-button-background")) close();
            }).on("keyup.dtb-collection", function(e) {
                if (e.keyCode === 27) close();
            });
            if (options.autoClose) setTimeout(function() {
                dt.on("buttons-action.b-internal", function(e, btn, dt, node) {
                    if (node[0] === hostNode[0]) return;
                    close();
                });
            }, 0);
            $(display).trigger("buttons-popover.dt");
        }
    });
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Statics
 */ /**
 * Show / hide a background layer behind a collection
 * @param  {boolean} Flag to indicate if the background should be shown or
 *   hidden 
 * @param  {string} Class to assign to the background
 * @static
 */ Buttons.background = function(show, className, fade, insertPoint) {
        if (fade === undefined) fade = 400;
        if (!insertPoint) insertPoint = document1.body;
        if (show) _fadeIn($("<div/>").addClass(className).css("display", "none").insertAfter(insertPoint), fade);
        else _fadeOut($("div." + className), fade, function() {
            $(this).removeClass(className).remove();
        });
    };
    /**
 * Instance selector - select Buttons instances based on an instance selector
 * value from the buttons assigned to a DataTable. This is only useful if
 * multiple instances are attached to a DataTable.
 * @param  {string|int|array} Instance selector - see `instance-selector`
 *   documentation on the DataTables site
 * @param  {array} Button instance array that was attached to the DataTables
 *   settings object
 * @return {array} Buttons instances
 * @static
 */ Buttons.instanceSelector = function(group, buttons) {
        if (group === undefined || group === null) return $.map(buttons, function(v) {
            return v.inst;
        });
        var ret = [];
        var names = $.map(buttons, function(v) {
            return v.name;
        });
        // Flatten the group selector into an array of single options
        var process = function(input) {
            if (Array.isArray(input)) {
                for(var i = 0, ien = input.length; i < ien; i++)process(input[i]);
                return;
            }
            if (typeof input === "string") {
                if (input.indexOf(",") !== -1) // String selector, list of names
                process(input.split(","));
                else {
                    // String selector individual name
                    var idx = $.inArray(input.trim(), names);
                    if (idx !== -1) ret.push(buttons[idx].inst);
                }
            } else if (typeof input === "number") // Index selector
            ret.push(buttons[input].inst);
        };
        process(group);
        return ret;
    };
    /**
 * Button selector - select one or more buttons from a selector input so some
 * operation can be performed on them.
 * @param  {array} Button instances array that the selector should operate on
 * @param  {string|int|node|jQuery|array} Button selector - see
 *   `button-selector` documentation on the DataTables site
 * @return {array} Array of objects containing `inst` and `idx` properties of
 *   the selected buttons so you know which instance each button belongs to.
 * @static
 */ Buttons.buttonSelector = function(insts, selector) {
        var ret = [];
        var nodeBuilder = function(a, buttons, baseIdx) {
            var button;
            var idx;
            for(var i = 0, ien = buttons.length; i < ien; i++){
                button = buttons[i];
                if (button) {
                    idx = baseIdx !== undefined ? baseIdx + i : i + "";
                    a.push({
                        node: button.node,
                        name: button.conf.name,
                        idx: idx
                    });
                    if (button.buttons) nodeBuilder(a, button.buttons, idx + "-");
                }
            }
        };
        var run = function(selector, inst) {
            var i, ien;
            var buttons = [];
            nodeBuilder(buttons, inst.s.buttons);
            var nodes = $.map(buttons, function(v) {
                return v.node;
            });
            if (Array.isArray(selector) || selector instanceof $) {
                for(i = 0, ien = selector.length; i < ien; i++)run(selector[i], inst);
                return;
            }
            if (selector === null || selector === undefined || selector === "*") // Select all
            for(i = 0, ien = buttons.length; i < ien; i++)ret.push({
                inst: inst,
                node: buttons[i].node
            });
            else if (typeof selector === "number") // Main button index selector
            ret.push({
                inst: inst,
                node: inst.s.buttons[selector].node
            });
            else if (typeof selector === "string") {
                if (selector.indexOf(",") !== -1) {
                    // Split
                    var a = selector.split(",");
                    for(i = 0, ien = a.length; i < ien; i++)run(a[i].trim(), inst);
                } else if (selector.match(/^\d+(\-\d+)*$/)) {
                    // Sub-button index selector
                    var indexes = $.map(buttons, function(v) {
                        return v.idx;
                    });
                    ret.push({
                        inst: inst,
                        node: buttons[$.inArray(selector, indexes)].node
                    });
                } else if (selector.indexOf(":name") !== -1) {
                    // Button name selector
                    var name = selector.replace(":name", "");
                    for(i = 0, ien = buttons.length; i < ien; i++)if (buttons[i].name === name) ret.push({
                        inst: inst,
                        node: buttons[i].node
                    });
                } else // jQuery selector on the nodes
                $(nodes).filter(selector).each(function() {
                    ret.push({
                        inst: inst,
                        node: this
                    });
                });
            } else if (typeof selector === "object" && selector.nodeName) {
                // Node selector
                var idx = $.inArray(selector, nodes);
                if (idx !== -1) ret.push({
                    inst: inst,
                    node: nodes[idx]
                });
            }
        };
        for(var i = 0, ien = insts.length; i < ien; i++){
            var inst = insts[i];
            run(selector, inst);
        }
        return ret;
    };
    /**
 * Default function used for formatting output data.
 * @param {*} str Data to strip
 */ Buttons.stripData = function(str, config) {
        if (typeof str !== "string") return str;
        // Always remove script tags
        str = str.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "");
        // Always remove comments
        str = str.replace(/<!\-\-.*?\-\->/g, "");
        if (!config || config.stripHtml) str = str.replace(/<[^>]*>/g, "");
        if (!config || config.trim) str = str.replace(/^\s+|\s+$/g, "");
        if (!config || config.stripNewlines) str = str.replace(/\n/g, " ");
        if (!config || config.decodeEntities) {
            _exportTextarea.innerHTML = str;
            str = _exportTextarea.value;
        }
        return str;
    };
    /**
 * Buttons defaults. For full documentation, please refer to the docs/option
 * directory or the DataTables site.
 * @type {Object}
 * @static
 */ Buttons.defaults = {
        buttons: [
            "copy",
            "excel",
            "csv",
            "pdf",
            "print"
        ],
        name: "main",
        tabIndex: 0,
        dom: {
            container: {
                tag: "div",
                className: "dt-buttons"
            },
            collection: {
                tag: "div",
                className: ""
            },
            button: {
                tag: "button",
                className: "dt-button",
                active: "active",
                disabled: "disabled"
            },
            buttonLiner: {
                tag: "span",
                className: ""
            }
        }
    };
    /**
 * Version information
 * @type {string}
 * @static
 */ Buttons.version = "1.7.1";
    $.extend(_dtButtons, {
        collection: {
            text: function(dt) {
                return dt.i18n("buttons.collection", "Collection");
            },
            className: "buttons-collection",
            init: function(dt, button, config) {
                button.attr("aria-expanded", false);
            },
            action: function(e, dt, button, config) {
                e.stopPropagation();
                if (config._collection.parents("body").length) this.popover(false, config);
                else this.popover(config._collection, config);
            },
            attr: {
                "aria-haspopup": true
            }
        },
        copy: function(dt, conf) {
            if (_dtButtons.copyHtml5) return "copyHtml5";
        },
        csv: function(dt, conf) {
            if (_dtButtons.csvHtml5 && _dtButtons.csvHtml5.available(dt, conf)) return "csvHtml5";
        },
        excel: function(dt, conf) {
            if (_dtButtons.excelHtml5 && _dtButtons.excelHtml5.available(dt, conf)) return "excelHtml5";
        },
        pdf: function(dt, conf) {
            if (_dtButtons.pdfHtml5 && _dtButtons.pdfHtml5.available(dt, conf)) return "pdfHtml5";
        },
        pageLength: function(dt) {
            var lengthMenu = dt.settings()[0].aLengthMenu;
            var vals = [];
            var lang = [];
            var text = function(dt) {
                return dt.i18n("buttons.pageLength", {
                    "-1": "Show all rows",
                    _: "Show %d rows"
                }, dt.page.len());
            };
            // Support for DataTables 1.x 2D array
            if (Array.isArray(lengthMenu[0])) {
                vals = lengthMenu[0];
                lang = lengthMenu[1];
            } else for(var i = 0; i < lengthMenu.length; i++){
                var option = lengthMenu[i];
                // Support for DataTables 2 object in the array
                if ($.isPlainObject(option)) {
                    vals.push(option.value);
                    lang.push(option.label);
                } else {
                    vals.push(option);
                    lang.push(option);
                }
            }
            return {
                extend: "collection",
                text: text,
                className: "buttons-page-length",
                autoClose: true,
                buttons: $.map(vals, function(val, i) {
                    return {
                        text: lang[i],
                        className: "button-page-length",
                        action: function(e, dt) {
                            dt.page.len(val).draw();
                        },
                        init: function(dt, node, conf) {
                            var that = this;
                            var fn = function() {
                                that.active(dt.page.len() === val);
                            };
                            dt.on("length.dt" + conf.namespace, fn);
                            fn();
                        },
                        destroy: function(dt, node, conf) {
                            dt.off("length.dt" + conf.namespace);
                        }
                    };
                }),
                init: function(dt, node, conf) {
                    var that = this;
                    dt.on("length.dt" + conf.namespace, function() {
                        that.text(conf.text);
                    });
                },
                destroy: function(dt, node, conf) {
                    dt.off("length.dt" + conf.namespace);
                }
            };
        }
    });
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables API
 *
 * For complete documentation, please refer to the docs/api directory or the
 * DataTables site
 */ // Buttons group and individual button selector
    DataTable.Api.register("buttons()", function(group, selector) {
        // Argument shifting
        if (selector === undefined) {
            selector = group;
            group = undefined;
        }
        this.selector.buttonGroup = group;
        var res = this.iterator(true, "table", function(ctx) {
            if (ctx._buttons) return Buttons.buttonSelector(Buttons.instanceSelector(group, ctx._buttons), selector);
        }, true);
        res._groupSelector = group;
        return res;
    });
    // Individual button selector
    DataTable.Api.register("button()", function(group, selector) {
        // just run buttons() and truncate
        var buttons = this.buttons(group, selector);
        if (buttons.length > 1) buttons.splice(1, buttons.length);
        return buttons;
    });
    // Active buttons
    DataTable.Api.registerPlural("buttons().active()", "button().active()", function(flag) {
        if (flag === undefined) return this.map(function(set) {
            return set.inst.active(set.node);
        });
        return this.each(function(set) {
            set.inst.active(set.node, flag);
        });
    });
    // Get / set button action
    DataTable.Api.registerPlural("buttons().action()", "button().action()", function(action) {
        if (action === undefined) return this.map(function(set) {
            return set.inst.action(set.node);
        });
        return this.each(function(set) {
            set.inst.action(set.node, action);
        });
    });
    // Enable / disable buttons
    DataTable.Api.register([
        "buttons().enable()",
        "button().enable()"
    ], function(flag) {
        return this.each(function(set) {
            set.inst.enable(set.node, flag);
        });
    });
    // Disable buttons
    DataTable.Api.register([
        "buttons().disable()",
        "button().disable()"
    ], function() {
        return this.each(function(set) {
            set.inst.disable(set.node);
        });
    });
    // Get button nodes
    DataTable.Api.registerPlural("buttons().nodes()", "button().node()", function() {
        var jq = $();
        // jQuery will automatically reduce duplicates to a single entry
        $(this.each(function(set) {
            jq = jq.add(set.inst.node(set.node));
        }));
        return jq;
    });
    // Get / set button processing state
    DataTable.Api.registerPlural("buttons().processing()", "button().processing()", function(flag) {
        if (flag === undefined) return this.map(function(set) {
            return set.inst.processing(set.node);
        });
        return this.each(function(set) {
            set.inst.processing(set.node, flag);
        });
    });
    // Get / set button text (i.e. the button labels)
    DataTable.Api.registerPlural("buttons().text()", "button().text()", function(label) {
        if (label === undefined) return this.map(function(set) {
            return set.inst.text(set.node);
        });
        return this.each(function(set) {
            set.inst.text(set.node, label);
        });
    });
    // Trigger a button's action
    DataTable.Api.registerPlural("buttons().trigger()", "button().trigger()", function() {
        return this.each(function(set) {
            set.inst.node(set.node).trigger("click");
        });
    });
    // Button resolver to the popover
    DataTable.Api.register("button().popover()", function(content, options) {
        return this.map(function(set) {
            return set.inst._popover(content, this.button(this[0].node), options);
        });
    });
    // Get the container elements
    DataTable.Api.register("buttons().containers()", function() {
        var jq = $();
        var groupSelector = this._groupSelector;
        // We need to use the group selector directly, since if there are no buttons
        // the result set will be empty
        this.iterator(true, "table", function(ctx) {
            if (ctx._buttons) {
                var insts = Buttons.instanceSelector(groupSelector, ctx._buttons);
                for(var i = 0, ien = insts.length; i < ien; i++)jq = jq.add(insts[i].container());
            }
        });
        return jq;
    });
    DataTable.Api.register("buttons().container()", function() {
        // API level of nesting is `buttons()` so we can zip into the containers method
        return this.containers().eq(0);
    });
    // Add a new button
    DataTable.Api.register("button().add()", function(idx, conf) {
        var ctx = this.context;
        // Don't use `this` as it could be empty - select the instances directly
        if (ctx.length) {
            var inst = Buttons.instanceSelector(this._groupSelector, ctx[0]._buttons);
            if (inst.length) inst[0].add(conf, idx);
        }
        return this.button(this._groupSelector, idx);
    });
    // Destroy the button sets selected
    DataTable.Api.register("buttons().destroy()", function() {
        this.pluck("inst").unique().each(function(inst) {
            inst.destroy();
        });
        return this;
    });
    // Remove a button
    DataTable.Api.registerPlural("buttons().remove()", "buttons().remove()", function() {
        this.each(function(set) {
            set.inst.remove(set.node);
        });
        return this;
    });
    // Information box that can be used by buttons
    var _infoTimer;
    DataTable.Api.register("buttons.info()", function(title, message, time) {
        var that = this;
        if (title === false) {
            this.off("destroy.btn-info");
            _fadeOut($("#datatables_buttons_info"), 400, function() {
                $(this).remove();
            });
            clearTimeout(_infoTimer);
            _infoTimer = null;
            return this;
        }
        if (_infoTimer) clearTimeout(_infoTimer);
        if ($("#datatables_buttons_info").length) $("#datatables_buttons_info").remove();
        title = title ? "<h2>" + title + "</h2>" : "";
        _fadeIn($('<div id="datatables_buttons_info" class="dt-button-info"/>').html(title).append($("<div/>")[typeof message === "string" ? "html" : "append"](message)).css("display", "none").appendTo("body"));
        if (time !== undefined && time !== 0) _infoTimer = setTimeout(function() {
            that.buttons.info(false);
        }, time);
        this.on("destroy.btn-info", function() {
            that.buttons.info(false);
        });
        return this;
    });
    // Get data from the table for export - this is common to a number of plug-in
    // buttons so it is included in the Buttons core library
    DataTable.Api.register("buttons.exportData()", function(options) {
        if (this.context.length) return _exportData(new DataTable.Api(this.context[0]), options);
    });
    // Get information about the export that is common to many of the export data
    // types (DRY)
    DataTable.Api.register("buttons.exportInfo()", function(conf) {
        if (!conf) conf = {};
        return {
            filename: _filename(conf),
            title: _title(conf),
            messageTop: _message(this, conf.message || conf.messageTop, "top"),
            messageBottom: _message(this, conf.messageBottom, "bottom")
        };
    });
    /**
 * Get the file name for an exported file.
 *
 * @param {object}	config Button configuration
 * @param {boolean} incExtension Include the file name extension
 */ var _filename = function(config) {
        // Backwards compatibility
        var filename = config.filename === "*" && config.title !== "*" && config.title !== undefined && config.title !== null && config.title !== "" ? config.title : config.filename;
        if (typeof filename === "function") filename = filename();
        if (filename === undefined || filename === null) return null;
        if (filename.indexOf("*") !== -1) filename = filename.replace("*", $("head > title").text()).trim();
        // Strip characters which the OS will object to
        filename = filename.replace(/[^a-zA-Z0-9_\u00A1-\uFFFF\.,\-_ !\(\)]/g, "");
        var extension = _stringOrFunction(config.extension);
        if (!extension) extension = "";
        return filename + extension;
    };
    /**
 * Simply utility method to allow parameters to be given as a function
 *
 * @param {undefined|string|function} option Option
 * @return {null|string} Resolved value
 */ var _stringOrFunction = function(option) {
        if (option === null || option === undefined) return null;
        else if (typeof option === "function") return option();
        return option;
    };
    /**
 * Get the title for an exported file.
 *
 * @param {object} config	Button configuration
 */ var _title = function(config) {
        var title = _stringOrFunction(config.title);
        return title === null ? null : title.indexOf("*") !== -1 ? title.replace("*", $("head > title").text() || "Exported data") : title;
    };
    var _message = function(dt, option, position) {
        var message = _stringOrFunction(option);
        if (message === null) return null;
        var caption = $("caption", dt.table().container()).eq(0);
        if (message === "*") {
            var side = caption.css("caption-side");
            if (side !== position) return null;
            return caption.length ? caption.text() : "";
        }
        return message;
    };
    var _exportTextarea = $("<textarea/>")[0];
    var _exportData = function(dt, inOpts) {
        var config = $.extend(true, {}, {
            rows: null,
            columns: "",
            modifier: {
                search: "applied",
                order: "applied"
            },
            orthogonal: "display",
            stripHtml: true,
            stripNewlines: true,
            decodeEntities: true,
            trim: true,
            format: {
                header: function(d) {
                    return Buttons.stripData(d, config);
                },
                footer: function(d) {
                    return Buttons.stripData(d, config);
                },
                body: function(d) {
                    return Buttons.stripData(d, config);
                }
            },
            customizeData: null
        }, inOpts);
        var header = dt.columns(config.columns).indexes().map(function(idx) {
            var el = dt.column(idx).header();
            return config.format.header(el.innerHTML, idx, el);
        }).toArray();
        var footer = dt.table().footer() ? dt.columns(config.columns).indexes().map(function(idx) {
            var el = dt.column(idx).footer();
            return config.format.footer(el ? el.innerHTML : "", idx, el);
        }).toArray() : null;
        // If Select is available on this table, and any rows are selected, limit the export
        // to the selected rows. If no rows are selected, all rows will be exported. Specify
        // a `selected` modifier to control directly.
        var modifier = $.extend({}, config.modifier);
        if (dt.select && typeof dt.select.info === "function" && modifier.selected === undefined) {
            if (dt.rows(config.rows, $.extend({
                selected: true
            }, modifier)).any()) $.extend(modifier, {
                selected: true
            });
        }
        var rowIndexes = dt.rows(config.rows, modifier).indexes().toArray();
        var selectedCells = dt.cells(rowIndexes, config.columns);
        var cells = selectedCells.render(config.orthogonal).toArray();
        var cellNodes = selectedCells.nodes().toArray();
        var columns = header.length;
        var rows = columns > 0 ? cells.length / columns : 0;
        var body = [];
        var cellCounter = 0;
        for(var i = 0, ien = rows; i < ien; i++){
            var row = [
                columns
            ];
            for(var j = 0; j < columns; j++){
                row[j] = config.format.body(cells[cellCounter], i, j, cellNodes[cellCounter]);
                cellCounter++;
            }
            body[i] = row;
        }
        var data = {
            header: header,
            footer: footer,
            body: body
        };
        if (config.customizeData) config.customizeData(data);
        return data;
    };
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables interface
 */ // Attach to DataTables objects for global access
    $.fn.dataTable.Buttons = Buttons;
    $.fn.DataTable.Buttons = Buttons;
    // DataTables creation - check if the buttons have been defined for this table,
    // they will have been if the `B` option was used in `dom`, otherwise we should
    // create the buttons instance here so they can be inserted into the document
    // using the API. Listen for `init` for compatibility with pre 1.10.10, but to
    // be removed in future.
    $(document1).on("init.dt plugin-init.dt", function(e, settings) {
        if (e.namespace !== "dt") return;
        var opts = settings.oInit.buttons || DataTable.defaults.buttons;
        if (opts && !settings._buttons) new Buttons(settings, opts).container();
    });
    function _init(settings, options) {
        var api = new DataTable.Api(settings);
        var opts = options ? options : api.init().buttons || DataTable.defaults.buttons;
        return new Buttons(api, opts).container();
    }
    // DataTables `dom` feature option
    DataTable.ext.feature.push({
        fnInit: _init,
        cFeature: "B"
    });
    // DataTables 2 layout feature
    if (DataTable.ext.features) DataTable.ext.features.register("buttons", _init);
    return Buttons;
});

});

parcelRegister("52RUY", function(module, exports) {

/*! KeyTable 2.6.4
 * ©2009-2021 SpryMedia Ltd - datatables.net/license
 */ /**
 * @summary     KeyTable
 * @description Spreadsheet like keyboard navigation for DataTables
 * @version     2.6.4
 * @file        dataTables.keyTable.js
 * @author      SpryMedia Ltd (www.sprymedia.co.uk)
 * @contact     www.sprymedia.co.uk/contact
 * @copyright   Copyright 2009-2021 SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license/mit
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net
 */ (function(factory) {
    if (typeof define === "function" && define.amd) // AMD
    define([
        "jquery",
        "datatables.net"
    ], function($) {
        return factory($, window, document);
    });
    else // CommonJS
    module.exports = function(root, $) {
        if (!root) root = window;
        if (!$ || !$.fn.dataTable) $ = (parcelRequire("EHlDu"))(root, $).$;
        return factory($, root, root.document);
    };
})(function($, window1, document1, undefined) {
    "use strict";
    var DataTable = $.fn.dataTable;
    var namespaceCounter = 0;
    var editorNamespaceCounter = 0;
    var KeyTable = function(dt, opts) {
        // Sanity check that we are using DataTables 1.10 or newer
        if (!DataTable.versionCheck || !DataTable.versionCheck("1.10.8")) throw "KeyTable requires DataTables 1.10.8 or newer";
        // User and defaults configuration object
        this.c = $.extend(true, {}, DataTable.defaults.keyTable, KeyTable.defaults, opts);
        // Internal settings
        this.s = {
            /** @type {DataTable.Api} DataTables' API instance */ dt: new DataTable.Api(dt),
            enable: true,
            /** @type {bool} Flag for if a draw is triggered by focus */ focusDraw: false,
            /** @type {bool} Flag to indicate when waiting for a draw to happen.
		  *   Will ignore key presses at this point
		  */ waitingForDraw: false,
            /** @type {object} Information about the last cell that was focused */ lastFocus: null,
            /** @type {string} Unique namespace per instance */ namespace: ".keyTable-" + namespaceCounter++,
            /** @type {Node} Input element for tabbing into the table */ tabInput: null
        };
        // DOM items
        this.dom = {};
        // Check if row reorder has already been initialised on this table
        var settings = this.s.dt.settings()[0];
        var exisiting = settings.keytable;
        if (exisiting) return exisiting;
        settings.keytable = this;
        this._constructor();
    };
    $.extend(KeyTable.prototype, {
        /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * API methods for DataTables API interface
	 */ /**
	 * Blur the table's cell focus
	 */ blur: function() {
            this._blur();
        },
        /**
	 * Enable cell focus for the table
	 *
	 * @param  {string} state Can be `true`, `false` or `-string navigation-only`
	 */ enable: function(state) {
            this.s.enable = state;
        },
        /**
	 * Get enable status
	 */ enabled: function() {
            return this.s.enable;
        },
        /**
	 * Focus on a cell
	 * @param  {integer} row    Row index
	 * @param  {integer} column Column index
	 */ focus: function(row, column) {
            this._focus(this.s.dt.cell(row, column));
        },
        /**
	 * Is the cell focused
	 * @param  {object} cell Cell index to check
	 * @returns {boolean} true if focused, false otherwise
	 */ focused: function(cell) {
            var lastFocus = this.s.lastFocus;
            if (!lastFocus) return false;
            var lastIdx = this.s.lastFocus.cell.index();
            return cell.row === lastIdx.row && cell.column === lastIdx.column;
        },
        /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Constructor
	 */ /**
	 * Initialise the KeyTable instance
	 *
	 * @private
	 */ _constructor: function() {
            this._tabInput();
            var that = this;
            var dt = this.s.dt;
            var table = $(dt.table().node());
            var namespace = this.s.namespace;
            var editorBlock = false;
            // Need to be able to calculate the cell positions relative to the table
            if (table.css("position") === "static") table.css("position", "relative");
            // Click to focus
            $(dt.table().body()).on("click" + namespace, "th, td", function(e) {
                if (that.s.enable === false) return;
                var cell = dt.cell(this);
                if (!cell.any()) return;
                that._focus(cell, null, false, e);
            });
            // Key events
            $(document1).on("keydown" + namespace, function(e) {
                if (!editorBlock) that._key(e);
            });
            // Click blur
            if (this.c.blurable) $(document1).on("mousedown" + namespace, function(e) {
                // Click on the search input will blur focus
                if ($(e.target).parents(".dataTables_filter").length) that._blur();
                // If the click was inside the DataTables container, don't blur
                if ($(e.target).parents().filter(dt.table().container()).length) return;
                // Don't blur in Editor form
                if ($(e.target).parents("div.DTE").length) return;
                // Or an Editor date input
                if ($(e.target).parents("div.editor-datetime").length || $(e.target).parents("div.dt-datetime").length) return;
                //If the click was inside the fixed columns container, don't blur
                if ($(e.target).parents().filter(".DTFC_Cloned").length) return;
                that._blur();
            });
            if (this.c.editor) {
                var editor = this.c.editor;
                // Need to disable KeyTable when the main editor is shown
                editor.on("open.keyTableMain", function(e, mode, action) {
                    if (mode !== "inline" && that.s.enable) {
                        that.enable(false);
                        editor.one("close" + namespace, function() {
                            that.enable(true);
                        });
                    }
                });
                if (this.c.editOnFocus) dt.on("key-focus" + namespace + " key-refocus" + namespace, function(e, dt, cell, orig) {
                    that._editor(null, orig, true);
                });
                // Activate Editor when a key is pressed (will be ignored, if
                // already active).
                dt.on("key" + namespace, function(e, dt, key, cell, orig) {
                    that._editor(key, orig, false);
                });
                // Active editing on double click - it will already have focus from
                // the click event handler above
                $(dt.table().body()).on("dblclick" + namespace, "th, td", function(e) {
                    if (that.s.enable === false) return;
                    var cell = dt.cell(this);
                    if (!cell.any()) return;
                    if (that.s.lastFocus && this !== that.s.lastFocus.cell.node()) return;
                    that._editor(null, e, true);
                });
                // While Editor is busy processing, we don't want to process any key events
                editor.on("preSubmit", function() {
                    editorBlock = true;
                }).on("preSubmitCancelled", function() {
                    editorBlock = false;
                }).on("submitComplete", function() {
                    editorBlock = false;
                });
            }
            // Stave saving
            // if ( dt.settings()[0].oFeatures.bStateSave ) {
            dt.on("stateSaveParams" + namespace, function(e, s, d) {
                d.keyTable = that.s.lastFocus ? that.s.lastFocus.cell.index() : null;
            });
            // }
            dt.on("column-visibility" + namespace, function(e) {
                that._tabInput();
            });
            // Redraw - retain focus on the current cell
            dt.on("draw" + namespace, function(e) {
                that._tabInput();
                if (that.s.focusDraw) return;
                var lastFocus = that.s.lastFocus;
                if (lastFocus) {
                    var relative = that.s.lastFocus.relative;
                    var info = dt.page.info();
                    var row = relative.row + info.start;
                    if (info.recordsDisplay === 0) return;
                    // Reverse if needed
                    if (row >= info.recordsDisplay) row = info.recordsDisplay - 1;
                    that._focus(row, relative.column, true, e);
                }
            });
            // Clipboard support
            if (this.c.clipboard) this._clipboard();
            dt.on("destroy" + namespace, function() {
                that._blur(true);
                // Event tidy up
                dt.off(namespace);
                $(dt.table().body()).off("click" + namespace, "th, td").off("dblclick" + namespace, "th, td");
                $(document1).off("mousedown" + namespace).off("keydown" + namespace).off("copy" + namespace).off("paste" + namespace);
            });
            // Initial focus comes from state or options
            var state = dt.state.loaded();
            if (state && state.keyTable) // Wait until init is done
            dt.one("init", function() {
                var cell = dt.cell(state.keyTable);
                // Ensure that the saved cell still exists
                if (cell.any()) cell.focus();
            });
            else if (this.c.focus) dt.cell(this.c.focus).focus();
        },
        /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods
	 */ /**
	 * Blur the control
	 *
	 * @param {boolean} [noEvents=false] Don't trigger updates / events (for destroying)
	 * @private
	 */ _blur: function(noEvents) {
            if (!this.s.enable || !this.s.lastFocus) return;
            var cell = this.s.lastFocus.cell;
            $(cell.node()).removeClass(this.c.className);
            this.s.lastFocus = null;
            if (!noEvents) {
                this._updateFixedColumns(cell.index().column);
                this._emitEvent("key-blur", [
                    this.s.dt,
                    cell
                ]);
            }
        },
        /**
	 * Clipboard interaction handlers
	 *
	 * @private
	 */ _clipboard: function() {
            var dt = this.s.dt;
            var that = this;
            var namespace = this.s.namespace;
            // IE8 doesn't support getting selected text
            if (!window1.getSelection) return;
            $(document1).on("copy" + namespace, function(ejq) {
                var e = ejq.originalEvent;
                var selection = window1.getSelection().toString();
                var focused = that.s.lastFocus;
                // Only copy cell text to clipboard if there is no other selection
                // and there is a focused cell
                if (!selection && focused) {
                    e.clipboardData.setData("text/plain", focused.cell.render(that.c.clipboardOrthogonal));
                    e.preventDefault();
                }
            });
            $(document1).on("paste" + namespace, function(ejq) {
                var e = ejq.originalEvent;
                var focused = that.s.lastFocus;
                var activeEl = document1.activeElement;
                var editor = that.c.editor;
                var pastedText;
                if (focused && (!activeEl || activeEl.nodeName.toLowerCase() === "body")) {
                    e.preventDefault();
                    if (window1.clipboardData && window1.clipboardData.getData) // IE
                    pastedText = window1.clipboardData.getData("Text");
                    else if (e.clipboardData && e.clipboardData.getData) // Everything else
                    pastedText = e.clipboardData.getData("text/plain");
                    if (editor) {
                        // Got Editor - need to activate inline editing,
                        // set the value and submit
                        var options = that._inlineOptions(focused.cell.index());
                        editor.inline(options.cell, options.field, options.options).set(editor.displayed()[0], pastedText).submit();
                    } else {
                        // No editor, so just dump the data in
                        focused.cell.data(pastedText);
                        dt.draw(false);
                    }
                }
            });
        },
        /**
	 * Get an array of the column indexes that KeyTable can operate on. This
	 * is a merge of the user supplied columns and the visible columns.
	 *
	 * @private
	 */ _columns: function() {
            var dt = this.s.dt;
            var user = dt.columns(this.c.columns).indexes();
            var out = [];
            dt.columns(":visible").every(function(i) {
                if (user.indexOf(i) !== -1) out.push(i);
            });
            return out;
        },
        /**
	 * Perform excel like navigation for Editor by triggering an edit on key
	 * press
	 *
	 * @param  {integer} key Key code for the pressed key
	 * @param  {object} orig Original event
	 * @private
	 */ _editor: function(key, orig, hardEdit) {
            // If nothing focused, we can't take any action
            if (!this.s.lastFocus) return;
            // DataTables draw event
            if (orig && orig.type === "draw") return;
            var that = this;
            var dt = this.s.dt;
            var editor = this.c.editor;
            var editCell = this.s.lastFocus.cell;
            var namespace = this.s.namespace + "e" + editorNamespaceCounter++;
            // Do nothing if there is already an inline edit in this cell
            if ($("div.DTE", editCell.node()).length) return;
            // Don't activate Editor on control key presses
            if (key !== null && (key >= 0x00 && key <= 0x09 || key === 0x0b || key === 0x0c || key >= 0x0e && key <= 0x1f || key >= 0x70 && key <= 0x7b || key >= 0x7f && key <= 0x9f)) return;
            if (orig) {
                orig.stopPropagation();
                // Return key should do nothing - for textareas it would empty the
                // contents
                if (key === 13) orig.preventDefault();
            }
            var editInline = function() {
                var options = that._inlineOptions(editCell.index());
                editor.one("open" + namespace, function() {
                    // Remove cancel open
                    editor.off("cancelOpen" + namespace);
                    // Excel style - select all text
                    if (!hardEdit) $("div.DTE_Field_InputControl input, div.DTE_Field_InputControl textarea").select();
                    // Reduce the keys the Keys listens for
                    dt.keys.enable(hardEdit ? "tab-only" : "navigation-only");
                    // On blur of the navigation submit
                    dt.on("key-blur.editor", function(e, dt, cell) {
                        if (editor.displayed() && cell.node() === editCell.node()) editor.submit();
                    });
                    // Highlight the cell a different colour on full edit
                    if (hardEdit) $(dt.table().container()).addClass("dtk-focus-alt");
                    // If the dev cancels the submit, we need to return focus
                    editor.on("preSubmitCancelled" + namespace, function() {
                        setTimeout(function() {
                            that._focus(editCell, null, false);
                        }, 50);
                    });
                    editor.on("submitUnsuccessful" + namespace, function() {
                        that._focus(editCell, null, false);
                    });
                    // Restore full key navigation on close
                    editor.one("close" + namespace, function() {
                        dt.keys.enable(true);
                        dt.off("key-blur.editor");
                        editor.off(namespace);
                        $(dt.table().container()).removeClass("dtk-focus-alt");
                        if (that.s.returnSubmit) {
                            that.s.returnSubmit = false;
                            that._emitEvent("key-return-submit", [
                                dt,
                                editCell
                            ]);
                        }
                    });
                }).one("cancelOpen" + namespace, function() {
                    // `preOpen` can cancel the display of the form, so it
                    // might be that the open event handler isn't needed
                    editor.off(namespace);
                }).inline(options.cell, options.field, options.options);
            };
            // Editor 1.7 listens for `return` on keyup, so if return is the trigger
            // key, we need to wait for `keyup` otherwise Editor would just submit
            // the content triggered by this keypress.
            if (key === 13) {
                hardEdit = true;
                $(document1).one("keyup", function() {
                    editInline();
                });
            } else editInline();
        },
        _inlineOptions: function(cellIdx) {
            if (this.c.editorOptions) return this.c.editorOptions(cellIdx);
            return {
                cell: cellIdx,
                field: undefined,
                options: undefined
            };
        },
        /**
	 * Emit an event on the DataTable for listeners
	 *
	 * @param  {string} name Event name
	 * @param  {array} args Event arguments
	 * @private
	 */ _emitEvent: function(name, args) {
            this.s.dt.iterator("table", function(ctx, i) {
                $(ctx.nTable).triggerHandler(name, args);
            });
        },
        /**
	 * Focus on a particular cell, shifting the table's paging if required
	 *
	 * @param  {DataTables.Api|integer} row Can be given as an API instance that
	 *   contains the cell to focus or as an integer. As the latter it is the
	 *   visible row index (from the whole data set) - NOT the data index
	 * @param  {integer} [column] Not required if a cell is given as the first
	 *   parameter. Otherwise this is the column data index for the cell to
	 *   focus on
	 * @param {boolean} [shift=true] Should the viewport be moved to show cell
	 * @private
	 */ _focus: function(row, column, shift, originalEvent) {
            var that = this;
            var dt = this.s.dt;
            var pageInfo = dt.page.info();
            var lastFocus = this.s.lastFocus;
            if (!originalEvent) originalEvent = null;
            if (!this.s.enable) return;
            if (typeof row !== "number") {
                // Its an API instance - check that there is actually a row
                if (!row.any()) return;
                // Convert the cell to a row and column
                var index = row.index();
                column = index.column;
                row = dt.rows({
                    filter: "applied",
                    order: "applied"
                }).indexes().indexOf(index.row);
                // Don't focus rows that were filtered out.
                if (row < 0) return;
                // For server-side processing normalise the row by adding the start
                // point, since `rows().indexes()` includes only rows that are
                // available at the client-side
                if (pageInfo.serverSide) row += pageInfo.start;
            }
            // Is the row on the current page? If not, we need to redraw to show the
            // page
            if (pageInfo.length !== -1 && (row < pageInfo.start || row >= pageInfo.start + pageInfo.length)) {
                this.s.focusDraw = true;
                this.s.waitingForDraw = true;
                dt.one("draw", function() {
                    that.s.focusDraw = false;
                    that.s.waitingForDraw = false;
                    that._focus(row, column, undefined, originalEvent);
                }).page(Math.floor(row / pageInfo.length)).draw(false);
                return;
            }
            // In the available columns?
            if ($.inArray(column, this._columns()) === -1) return;
            // De-normalise the server-side processing row, so we select the row
            // in its displayed position
            if (pageInfo.serverSide) row -= pageInfo.start;
            // Get the cell from the current position - ignoring any cells which might
            // not have been rendered (therefore can't use `:eq()` selector).
            var cells = dt.cells(null, column, {
                search: "applied",
                order: "applied"
            }).flatten();
            var cell = dt.cell(cells[row]);
            if (lastFocus) {
                // Don't trigger a refocus on the same cell
                if (lastFocus.node === cell.node()) {
                    this._emitEvent("key-refocus", [
                        this.s.dt,
                        cell,
                        originalEvent || null
                    ]);
                    return;
                }
                // Otherwise blur the old focus
                this._blur();
            }
            // Clear focus from other tables
            this._removeOtherFocus();
            var node = $(cell.node());
            node.addClass(this.c.className);
            this._updateFixedColumns(column);
            // Shift viewpoint and page to make cell visible
            if (shift === undefined || shift === true) {
                this._scroll($(window1), $(document1.body), node, "offset");
                var bodyParent = dt.table().body().parentNode;
                if (bodyParent !== dt.table().header().parentNode) {
                    var parent = $(bodyParent.parentNode);
                    this._scroll(parent, parent, node, "position");
                }
            }
            // Event and finish
            this.s.lastFocus = {
                cell: cell,
                node: cell.node(),
                relative: {
                    row: dt.rows({
                        page: "current"
                    }).indexes().indexOf(cell.index().row),
                    column: cell.index().column
                }
            };
            this._emitEvent("key-focus", [
                this.s.dt,
                cell,
                originalEvent || null
            ]);
            dt.state.save();
        },
        /**
	 * Handle key press
	 *
	 * @param  {object} e Event
	 * @private
	 */ _key: function(e) {
            // If we are waiting for a draw to happen from another key event, then
            // do nothing for this new key press.
            if (this.s.waitingForDraw) {
                e.preventDefault();
                return;
            }
            var enable = this.s.enable;
            this.s.returnSubmit = (enable === "navigation-only" || enable === "tab-only") && e.keyCode === 13 ? true : false;
            var navEnable = enable === true || enable === "navigation-only";
            if (!enable) return;
            if ((e.keyCode === 0 || e.ctrlKey || e.metaKey || e.altKey) && !(e.ctrlKey && e.altKey)) return;
            // If not focused, then there is no key action to take
            var lastFocus = this.s.lastFocus;
            if (!lastFocus) return;
            // And the last focus still exists!
            if (!this.s.dt.cell(lastFocus.node).any()) {
                this.s.lastFocus = null;
                return;
            }
            var that = this;
            var dt = this.s.dt;
            var scrolling = this.s.dt.settings()[0].oScroll.sY ? true : false;
            // If we are not listening for this key, do nothing
            if (this.c.keys && $.inArray(e.keyCode, this.c.keys) === -1) return;
            switch(e.keyCode){
                case 9:
                    // `enable` can be tab-only
                    this._shift(e, e.shiftKey ? "left" : "right", true);
                    break;
                case 27:
                    if (this.c.blurable && enable === true) this._blur();
                    break;
                case 33:
                case 34:
                    if (navEnable && !scrolling) {
                        e.preventDefault();
                        dt.page(e.keyCode === 33 ? "previous" : "next").draw(false);
                    }
                    break;
                case 35:
                case 36:
                    if (navEnable) {
                        e.preventDefault();
                        var indexes = dt.cells({
                            page: "current"
                        }).indexes();
                        var colIndexes = this._columns();
                        this._focus(dt.cell(indexes[e.keyCode === 35 ? indexes.length - 1 : colIndexes[0]]), null, true, e);
                    }
                    break;
                case 37:
                    if (navEnable) this._shift(e, "left");
                    break;
                case 38:
                    if (navEnable) this._shift(e, "up");
                    break;
                case 39:
                    if (navEnable) this._shift(e, "right");
                    break;
                case 40:
                    if (navEnable) this._shift(e, "down");
                    break;
                case 113:
                    if (this.c.editor) {
                        this._editor(null, e, true);
                        break;
                    }
                // else fallthrough
                default:
                    // Everything else - pass through only when fully enabled
                    if (enable === true) this._emitEvent("key", [
                        dt,
                        e.keyCode,
                        this.s.lastFocus.cell,
                        e
                    ]);
                    break;
            }
        },
        /**
	 * Remove focus from all tables other than this one
	 */ _removeOtherFocus: function() {
            var thisTable = this.s.dt.table().node();
            $.fn.dataTable.tables({
                api: true
            }).iterator("table", function(settings) {
                if (this.table().node() !== thisTable) this.cell.blur();
            });
        },
        /**
	 * Scroll a container to make a cell visible in it. This can be used for
	 * both DataTables scrolling and native window scrolling.
	 *
	 * @param  {jQuery} container Scrolling container
	 * @param  {jQuery} scroller  Item being scrolled
	 * @param  {jQuery} cell      Cell in the scroller
	 * @param  {string} posOff    `position` or `offset` - which to use for the
	 *   calculation. `offset` for the document, otherwise `position`
	 * @private
	 */ _scroll: function(container, scroller, cell, posOff) {
            var offset = cell[posOff]();
            var height = cell.outerHeight();
            var width = cell.outerWidth();
            var scrollTop = scroller.scrollTop();
            var scrollLeft = scroller.scrollLeft();
            var containerHeight = container.height();
            var containerWidth = container.width();
            // If Scroller is being used, the table can be `position: absolute` and that
            // needs to be taken account of in the offset. If no Scroller, this will be 0
            if (posOff === "position") offset.top += parseInt(cell.closest("table").css("top"), 10);
            // Top correction
            if (offset.top < scrollTop) scroller.scrollTop(offset.top);
            // Left correction
            if (offset.left < scrollLeft) scroller.scrollLeft(offset.left);
            // Bottom correction
            if (offset.top + height > scrollTop + containerHeight && height < containerHeight) scroller.scrollTop(offset.top + height - containerHeight);
            // Right correction
            if (offset.left + width > scrollLeft + containerWidth && width < containerWidth) scroller.scrollLeft(offset.left + width - containerWidth);
        },
        /**
	 * Calculate a single offset movement in the table - up, down, left and
	 * right and then perform the focus if possible
	 *
	 * @param  {object}  e           Event object
	 * @param  {string}  direction   Movement direction
	 * @param  {boolean} keyBlurable `true` if the key press can result in the
	 *   table being blurred. This is so arrow keys won't blur the table, but
	 *   tab will.
	 * @private
	 */ _shift: function(e, direction, keyBlurable) {
            var that = this;
            var dt = this.s.dt;
            var pageInfo = dt.page.info();
            var rows = pageInfo.recordsDisplay;
            var columns = this._columns();
            var last = this.s.lastFocus;
            if (!last) return;
            var currentCell = last.cell;
            if (!currentCell) return;
            var currRow = dt.rows({
                filter: "applied",
                order: "applied"
            }).indexes().indexOf(currentCell.index().row);
            // When server-side processing, `rows().indexes()` only gives the rows
            // that are available at the client-side, so we need to normalise the
            // row's current position by the display start point
            if (pageInfo.serverSide) currRow += pageInfo.start;
            var currCol = dt.columns(columns).indexes().indexOf(currentCell.index().column);
            var row = currRow, column = columns[currCol]; // row is the display, column is an index
            // If the direction is rtl then the logic needs to be inverted from this point forwards
            if ($(dt.table().node()).css("direction") === "rtl") {
                if (direction === "right") direction = "left";
                else if (direction === "left") direction = "right";
            }
            if (direction === "right") {
                if (currCol >= columns.length - 1) {
                    row++;
                    column = columns[0];
                } else column = columns[currCol + 1];
            } else if (direction === "left") {
                if (currCol === 0) {
                    row--;
                    column = columns[columns.length - 1];
                } else column = columns[currCol - 1];
            } else if (direction === "up") row--;
            else if (direction === "down") row++;
            if (row >= 0 && row < rows && $.inArray(column, columns) !== -1) {
                if (e) e.preventDefault();
                this._focus(row, column, true, e);
            } else if (!keyBlurable || !this.c.blurable) // No new focus, but if the table isn't blurable, then don't loose
            // focus
            {
                if (e) e.preventDefault();
            } else this._blur();
        },
        /**
	 * Create and insert a hidden input element that can receive focus on behalf
	 * of the table
	 *
	 * @private
	 */ _tabInput: function() {
            var that = this;
            var dt = this.s.dt;
            var tabIndex = this.c.tabIndex !== null ? this.c.tabIndex : dt.settings()[0].iTabIndex;
            if (tabIndex == -1) return;
            // Only create the input element once on first class
            if (!this.s.tabInput) {
                var div = $('<div><input type="text" tabindex="' + tabIndex + '"/></div>').css({
                    position: "absolute",
                    height: 1,
                    width: 0,
                    overflow: "hidden"
                });
                div.children().on("focus", function(e) {
                    var cell = dt.cell(":eq(0)", that._columns(), {
                        page: "current"
                    });
                    if (cell.any()) that._focus(cell, null, true, e);
                });
                this.s.tabInput = div;
            }
            // Insert the input element into the first cell in the table's body
            var cell = this.s.dt.cell(":eq(0)", "0:visible", {
                page: "current",
                order: "current"
            }).node();
            if (cell) $(cell).prepend(this.s.tabInput);
        },
        /**
	 * Update fixed columns if they are enabled and if the cell we are
	 * focusing is inside a fixed column
	 * @param  {integer} column Index of the column being changed
	 * @private
	 */ _updateFixedColumns: function(column) {
            var dt = this.s.dt;
            var settings = dt.settings()[0];
            if (settings._oFixedColumns) {
                var leftCols = settings._oFixedColumns.s.iLeftColumns;
                var rightCols = settings.aoColumns.length - settings._oFixedColumns.s.iRightColumns;
                if (column < leftCols || column >= rightCols) dt.fixedColumns().update();
            }
        }
    });
    /**
 * KeyTable default settings for initialisation
 *
 * @namespace
 * @name KeyTable.defaults
 * @static
 */ KeyTable.defaults = {
        /**
	 * Can focus be removed from the table
	 * @type {Boolean}
	 */ blurable: true,
        /**
	 * Class to give to the focused cell
	 * @type {String}
	 */ className: "focus",
        /**
	 * Enable or disable clipboard support
	 * @type {Boolean}
	 */ clipboard: true,
        /**
	 * Orthogonal data that should be copied to clipboard
	 * @type {string}
	 */ clipboardOrthogonal: "display",
        /**
	 * Columns that can be focused. This is automatically merged with the
	 * visible columns as only visible columns can gain focus.
	 * @type {String}
	 */ columns: "",
        /**
	 * Editor instance to automatically perform Excel like navigation
	 * @type {Editor}
	 */ editor: null,
        /**
	 * Trigger editing immediately on focus
	 * @type {boolean}
	 */ editOnFocus: false,
        /**
	 * Options to pass to Editor's inline method
	 * @type {function}
	 */ editorOptions: null,
        /**
	 * Select a cell to automatically select on start up. `null` for no
	 * automatic selection
	 * @type {cell-selector}
	 */ focus: null,
        /**
	 * Array of keys to listen for
	 * @type {null|array}
	 */ keys: null,
        /**
	 * Tab index for where the table should sit in the document's tab flow
	 * @type {integer|null}
	 */ tabIndex: null
    };
    KeyTable.version = "2.6.4";
    $.fn.dataTable.KeyTable = KeyTable;
    $.fn.DataTable.KeyTable = KeyTable;
    DataTable.Api.register("cell.blur()", function() {
        return this.iterator("table", function(ctx) {
            if (ctx.keytable) ctx.keytable.blur();
        });
    });
    DataTable.Api.register("cell().focus()", function() {
        return this.iterator("cell", function(ctx, row, column) {
            if (ctx.keytable) ctx.keytable.focus(row, column);
        });
    });
    DataTable.Api.register("keys.disable()", function() {
        return this.iterator("table", function(ctx) {
            if (ctx.keytable) ctx.keytable.enable(false);
        });
    });
    DataTable.Api.register("keys.enable()", function(opts) {
        return this.iterator("table", function(ctx) {
            if (ctx.keytable) ctx.keytable.enable(opts === undefined ? true : opts);
        });
    });
    DataTable.Api.register("keys.enabled()", function(opts) {
        var ctx = this.context;
        if (ctx.length) return ctx[0].keytable ? ctx[0].keytable.enabled() : false;
        return false;
    });
    DataTable.Api.register("keys.move()", function(dir) {
        return this.iterator("table", function(ctx) {
            if (ctx.keytable) ctx.keytable._shift(null, dir, false);
        });
    });
    // Cell selector
    DataTable.ext.selector.cell.push(function(settings, opts, cells) {
        var focused = opts.focused;
        var kt = settings.keytable;
        var out = [];
        if (!kt || focused === undefined) return cells;
        for(var i = 0, ien = cells.length; i < ien; i++)if (focused === true && kt.focused(cells[i]) || focused === false && !kt.focused(cells[i])) out.push(cells[i]);
        return out;
    });
    // Attach a listener to the document which listens for DataTables initialisation
    // events so we can automatically initialise
    $(document1).on("preInit.dt.dtk", function(e, settings, json) {
        if (e.namespace !== "dt") return;
        var init = settings.oInit.keys;
        var defaults = DataTable.defaults.keys;
        if (init || defaults) {
            var opts = $.extend({}, defaults, init);
            if (init !== false) new KeyTable(settings, opts);
        }
    });
    return KeyTable;
});

});

parcelRegister("jgdy4", function(module, exports) {
/* ***** BEGIN LICENSE BLOCK *****
 * Distributed under the BSD license:
 *
 * Copyright (c) 2010, Ajax.org B.V.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *     * Redistributions of source code must retain the above copyright
 *       notice, this list of conditions and the following disclaimer.
 *     * Redistributions in binary form must reproduce the above copyright
 *       notice, this list of conditions and the following disclaimer in the
 *       documentation and/or other materials provided with the distribution.
 *     * Neither the name of Ajax.org B.V. nor the
 *       names of its contributors may be used to endorse or promote products
 *       derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL AJAX.ORG B.V. BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * ***** END LICENSE BLOCK ***** */ /**
 * Define a module along with a payload
 * @param module a name for the payload
 * @param payload a function to call with (require, exports, module) params
 */ (function() {
    var ACE_NAMESPACE = "ace";
    var global = function() {
        return this;
    }();
    if (!global && typeof window != "undefined") global = window; // strict mode
    if (!ACE_NAMESPACE && typeof requirejs !== "undefined") return;
    var define1 = function(module1, deps, payload) {
        if (typeof module1 !== "string") {
            if (define1.original) define1.original.apply(this, arguments);
            else {
                console.error("dropping module because define wasn't a string.");
                console.trace();
            }
            return;
        }
        if (arguments.length == 2) payload = deps;
        if (!define1.modules[module1]) {
            define1.payloads[module1] = payload;
            define1.modules[module1] = null;
        }
    };
    define1.modules = {};
    define1.payloads = {};
    /**
 * Get at functionality define()ed using the function above
 */ var _require = function(parentId, module1, callback) {
        if (typeof module1 === "string") {
            var payload = lookup(parentId, module1);
            if (payload != undefined) {
                callback && callback();
                return payload;
            }
        } else if (Object.prototype.toString.call(module1) === "[object Array]") {
            var params = [];
            for(var i = 0, l = module1.length; i < l; ++i){
                var dep = lookup(parentId, module1[i]);
                if (dep == undefined && require.original) return;
                params.push(dep);
            }
            return callback && callback.apply(null, params) || true;
        }
    };
    var require = function(module1, callback) {
        var packagedModule = _require("", module1, callback);
        if (packagedModule == undefined && require.original) return require.original.apply(this, arguments);
        return packagedModule;
    };
    var normalizeModule = function(parentId, moduleName) {
        // normalize plugin requires
        if (moduleName.indexOf("!") !== -1) {
            var chunks = moduleName.split("!");
            return normalizeModule(parentId, chunks[0]) + "!" + normalizeModule(parentId, chunks[1]);
        }
        // normalize relative requires
        if (moduleName.charAt(0) == ".") {
            var base = parentId.split("/").slice(0, -1).join("/");
            moduleName = base + "/" + moduleName;
            while(moduleName.indexOf(".") !== -1 && previous != moduleName){
                var previous = moduleName;
                moduleName = moduleName.replace(/\/\.\//, "/").replace(/[^\/]+\/\.\.\//, "");
            }
        }
        return moduleName;
    };
    /**
 * Internal function to lookup moduleNames and resolve them by calling the
 * definition function if needed.
 */ var lookup = function(parentId, moduleName) {
        moduleName = normalizeModule(parentId, moduleName);
        var module1 = define1.modules[moduleName];
        if (!module1) {
            module1 = define1.payloads[moduleName];
            if (typeof module1 === "function") {
                var exports = {};
                var mod = {
                    id: moduleName,
                    uri: "",
                    exports: exports,
                    packaged: true
                };
                var req = function(module1, callback) {
                    return _require(moduleName, module1, callback);
                };
                var returnValue = module1(req, exports, mod);
                exports = returnValue || mod.exports;
                define1.modules[moduleName] = exports;
                delete define1.payloads[moduleName];
            }
            module1 = define1.modules[moduleName] = exports || module1;
        }
        return module1;
    };
    function exportAce(ns) {
        var root = global;
        if (ns) {
            if (!global[ns]) global[ns] = {};
            root = global[ns];
        }
        if (!root.define || !root.define.packaged) {
            define1.original = root.define;
            root.define = define1;
            root.define.packaged = true;
        }
        if (!root.require || !root.require.packaged) {
            require.original = root.require;
            root.require = require;
            root.require.packaged = true;
        }
    }
    exportAce(ACE_NAMESPACE);
})();
ace.define("ace/lib/es6-shim", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    function defineProp(obj, name, val) {
        Object.defineProperty(obj, name, {
            value: val,
            enumerable: false,
            writable: true,
            configurable: true
        });
    }
    if (!String.prototype.startsWith) defineProp(String.prototype, "startsWith", function(searchString, position) {
        position = position || 0;
        return this.lastIndexOf(searchString, position) === position;
    });
    if (!String.prototype.endsWith) defineProp(String.prototype, "endsWith", function(searchString, position) {
        var subjectString = this;
        if (position === undefined || position > subjectString.length) position = subjectString.length;
        position -= searchString.length;
        var lastIndex = subjectString.indexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    });
    if (!String.prototype.repeat) defineProp(String.prototype, "repeat", function(count) {
        var result = "";
        var string = this;
        while(count > 0){
            if (count & 1) result += string;
            if (count >>= 1) string += string;
        }
        return result;
    });
    if (!String.prototype.includes) defineProp(String.prototype, "includes", function(str, position) {
        return this.indexOf(str, position) != -1;
    });
    if (!Object.assign) Object.assign = function(target) {
        if (target === undefined || target === null) throw new TypeError("Cannot convert undefined or null to object");
        var output = Object(target);
        for(var index = 1; index < arguments.length; index++){
            var source = arguments[index];
            if (source !== undefined && source !== null) Object.keys(source).forEach(function(key) {
                output[key] = source[key];
            });
        }
        return output;
    };
    if (!Object.values) Object.values = function(o) {
        return Object.keys(o).map(function(k) {
            return o[k];
        });
    };
    if (!Array.prototype.find) defineProp(Array.prototype, "find", function(predicate) {
        var len = this.length;
        var thisArg = arguments[1];
        for(var k = 0; k < len; k++){
            var kValue = this[k];
            if (predicate.call(thisArg, kValue, k, this)) return kValue;
        }
    });
    if (!Array.prototype.findIndex) defineProp(Array.prototype, "findIndex", function(predicate) {
        var len = this.length;
        var thisArg = arguments[1];
        for(var k = 0; k < len; k++){
            var kValue = this[k];
            if (predicate.call(thisArg, kValue, k, this)) return k;
        }
    });
    if (!Array.prototype.includes) defineProp(Array.prototype, "includes", function(item, position) {
        return this.indexOf(item, position) != -1;
    });
    if (!Array.prototype.fill) defineProp(Array.prototype, "fill", function(value) {
        var O = this;
        var len = O.length >>> 0;
        var start = arguments[1];
        var relativeStart = start >> 0;
        var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len);
        var end = arguments[2];
        var relativeEnd = end === undefined ? len : end >> 0;
        var final = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len);
        while(k < final){
            O[k] = value;
            k++;
        }
        return O;
    });
    if (!Array.of) defineProp(Array, "of", function() {
        return Array.prototype.slice.call(arguments);
    });
});
ace.define("ace/lib/fixoldbrowsers", [
    "require",
    "exports",
    "module",
    "ace/lib/es6-shim"
], function(require, exports, module1) {
    "use strict";
    require("./es6-shim");
});
ace.define("ace/lib/deep_copy", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    exports.deepCopy = function deepCopy(obj) {
        if (typeof obj !== "object" || !obj) return obj;
        var copy;
        if (Array.isArray(obj)) {
            copy = [];
            for(var key = 0; key < obj.length; key++)copy[key] = deepCopy(obj[key]);
            return copy;
        }
        if (Object.prototype.toString.call(obj) !== "[object Object]") return obj;
        copy = {};
        for(var key in obj)copy[key] = deepCopy(obj[key]);
        return copy;
    };
});
ace.define("ace/lib/lang", [
    "require",
    "exports",
    "module",
    "ace/lib/deep_copy"
], function(require, exports, module1) {
    "use strict";
    exports.last = function(a) {
        return a[a.length - 1];
    };
    exports.stringReverse = function(string) {
        return string.split("").reverse().join("");
    };
    exports.stringRepeat = function(string, count) {
        var result = "";
        while(count > 0){
            if (count & 1) result += string;
            if (count >>= 1) string += string;
        }
        return result;
    };
    var trimBeginRegexp = /^\s\s*/;
    var trimEndRegexp = /\s\s*$/;
    exports.stringTrimLeft = function(string) {
        return string.replace(trimBeginRegexp, "");
    };
    exports.stringTrimRight = function(string) {
        return string.replace(trimEndRegexp, "");
    };
    exports.copyObject = function(obj) {
        var copy = {};
        for(var key in obj)copy[key] = obj[key];
        return copy;
    };
    exports.copyArray = function(array) {
        var copy = [];
        for(var i = 0, l = array.length; i < l; i++)if (array[i] && typeof array[i] == "object") copy[i] = this.copyObject(array[i]);
        else copy[i] = array[i];
        return copy;
    };
    exports.deepCopy = require("./deep_copy").deepCopy;
    exports.arrayToMap = function(arr) {
        var map = {};
        for(var i = 0; i < arr.length; i++)map[arr[i]] = 1;
        return map;
    };
    exports.createMap = function(props) {
        var map = Object.create(null);
        for(var i in props)map[i] = props[i];
        return map;
    };
    exports.arrayRemove = function(array, value) {
        for(var i = 0; i <= array.length; i++)if (value === array[i]) array.splice(i, 1);
    };
    exports.escapeRegExp = function(str) {
        return str.replace(/([.*+?^${}()|[\]\/\\])/g, "\\$1");
    };
    exports.escapeHTML = function(str) {
        return ("" + str).replace(/&/g, "&#38;").replace(/"/g, "&#34;").replace(/'/g, "&#39;").replace(/</g, "&#60;");
    };
    exports.getMatchOffsets = function(string, regExp) {
        var matches = [];
        string.replace(regExp, function(str) {
            matches.push({
                offset: arguments[arguments.length - 2],
                length: str.length
            });
        });
        return matches;
    };
    exports.deferredCall = function(fcn) {
        var timer = null;
        var callback = function() {
            timer = null;
            fcn();
        };
        var deferred = function(timeout) {
            deferred.cancel();
            timer = setTimeout(callback, timeout || 0);
            return deferred;
        };
        deferred.schedule = deferred;
        deferred.call = function() {
            this.cancel();
            fcn();
            return deferred;
        };
        deferred.cancel = function() {
            clearTimeout(timer);
            timer = null;
            return deferred;
        };
        deferred.isPending = function() {
            return timer;
        };
        return deferred;
    };
    exports.delayedCall = function(fcn, defaultTimeout) {
        var timer = null;
        var callback = function() {
            timer = null;
            fcn();
        };
        var _self = function(timeout) {
            if (timer == null) timer = setTimeout(callback, timeout || defaultTimeout);
        };
        _self.delay = function(timeout) {
            timer && clearTimeout(timer);
            timer = setTimeout(callback, timeout || defaultTimeout);
        };
        _self.schedule = _self;
        _self.call = function() {
            this.cancel();
            fcn();
        };
        _self.cancel = function() {
            timer && clearTimeout(timer);
            timer = null;
        };
        _self.isPending = function() {
            return timer;
        };
        return _self;
    };
    exports.supportsLookbehind = function() {
        try {
            new RegExp("(?<=.)");
        } catch (e) {
            return false;
        }
        return true;
    };
    exports.skipEmptyMatch = function(line, last, supportsUnicodeFlag) {
        return supportsUnicodeFlag && line.codePointAt(last) > 0xffff ? 2 : 1;
    };
});
ace.define("ace/lib/useragent", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    exports.OS = {
        LINUX: "LINUX",
        MAC: "MAC",
        WINDOWS: "WINDOWS"
    };
    exports.getOS = function() {
        if (exports.isMac) return exports.OS.MAC;
        else if (exports.isLinux) return exports.OS.LINUX;
        else return exports.OS.WINDOWS;
    };
    var _navigator = typeof navigator == "object" ? navigator : {};
    var os = (/mac|win|linux/i.exec(_navigator.platform) || [
        "other"
    ])[0].toLowerCase();
    var ua = _navigator.userAgent || "";
    var appName = _navigator.appName || "";
    exports.isWin = os == "win";
    exports.isMac = os == "mac";
    exports.isLinux = os == "linux";
    exports.isIE = appName == "Microsoft Internet Explorer" || appName.indexOf("MSAppHost") >= 0 ? parseFloat((ua.match(/(?:MSIE |Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/) || [])[1]) : parseFloat((ua.match(/(?:Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/) || [])[1]); // for ie
    exports.isOldIE = exports.isIE && exports.isIE < 9;
    exports.isGecko = exports.isMozilla = ua.match(/ Gecko\/\d+/);
    exports.isOpera = typeof opera == "object" && Object.prototype.toString.call(window["opera"]) == "[object Opera]";
    exports.isWebKit = parseFloat(ua.split("WebKit/")[1]) || undefined;
    exports.isChrome = parseFloat(ua.split(" Chrome/")[1]) || undefined;
    exports.isSafari = parseFloat(ua.split(" Safari/")[1]) && !exports.isChrome || undefined;
    exports.isEdge = parseFloat(ua.split(" Edge/")[1]) || undefined;
    exports.isAIR = ua.indexOf("AdobeAIR") >= 0;
    exports.isAndroid = ua.indexOf("Android") >= 0;
    exports.isChromeOS = ua.indexOf(" CrOS ") >= 0;
    exports.isIOS = /iPad|iPhone|iPod/.test(ua) && !window["MSStream"];
    if (exports.isIOS) exports.isMac = true;
    exports.isMobile = exports.isIOS || exports.isAndroid;
});
ace.define("ace/lib/dom", [
    "require",
    "exports",
    "module",
    "ace/lib/useragent"
], function(require, exports, module1) {
    "use strict";
    var useragent = require("./useragent");
    var XHTML_NS = "http://www.w3.org/1999/xhtml";
    exports.buildDom = function buildDom(arr, parent, refs) {
        if (typeof arr == "string" && arr) {
            var txt = document.createTextNode(arr);
            if (parent) parent.appendChild(txt);
            return txt;
        }
        if (!Array.isArray(arr)) {
            if (arr && arr.appendChild && parent) parent.appendChild(arr);
            return arr;
        }
        if (typeof arr[0] != "string" || !arr[0]) {
            var els = [];
            for(var i = 0; i < arr.length; i++){
                var ch = buildDom(arr[i], parent, refs);
                ch && els.push(ch);
            }
            return els;
        }
        var el = document.createElement(arr[0]);
        var options = arr[1];
        var childIndex = 1;
        if (options && typeof options == "object" && !Array.isArray(options)) childIndex = 2;
        for(var i = childIndex; i < arr.length; i++)buildDom(arr[i], el, refs);
        if (childIndex == 2) Object.keys(options).forEach(function(n) {
            var val = options[n];
            if (n === "class") el.className = Array.isArray(val) ? val.join(" ") : val;
            else if (typeof val == "function" || n == "value" || n[0] == "$") el[n] = val;
            else if (n === "ref") {
                if (refs) refs[val] = el;
            } else if (n === "style") {
                if (typeof val == "string") el.style.cssText = val;
            } else if (val != null) el.setAttribute(n, val);
        });
        if (parent) parent.appendChild(el);
        return el;
    };
    exports.getDocumentHead = function(doc) {
        if (!doc) doc = document;
        return doc.head || doc.getElementsByTagName("head")[0] || doc.documentElement;
    };
    exports.createElement = function(tag, ns) {
        return document.createElementNS ? document.createElementNS(ns || XHTML_NS, tag) : document.createElement(tag);
    };
    exports.removeChildren = function(element) {
        element.innerHTML = "";
    };
    exports.createTextNode = function(textContent, element) {
        var doc = element ? element.ownerDocument : document;
        return doc.createTextNode(textContent);
    };
    exports.createFragment = function(element) {
        var doc = element ? element.ownerDocument : document;
        return doc.createDocumentFragment();
    };
    exports.hasCssClass = function(el, name) {
        var classes = (el.className + "").split(/\s+/g);
        return classes.indexOf(name) !== -1;
    };
    exports.addCssClass = function(el, name) {
        if (!exports.hasCssClass(el, name)) el.className += " " + name;
    };
    exports.removeCssClass = function(el, name) {
        var classes = el.className.split(/\s+/g);
        while(true){
            var index = classes.indexOf(name);
            if (index == -1) break;
            classes.splice(index, 1);
        }
        el.className = classes.join(" ");
    };
    exports.toggleCssClass = function(el, name) {
        var classes = el.className.split(/\s+/g), add = true;
        while(true){
            var index = classes.indexOf(name);
            if (index == -1) break;
            add = false;
            classes.splice(index, 1);
        }
        if (add) classes.push(name);
        el.className = classes.join(" ");
        return add;
    };
    exports.setCssClass = function(node, className, include) {
        if (include) exports.addCssClass(node, className);
        else exports.removeCssClass(node, className);
    };
    exports.hasCssString = function(id, doc) {
        var index = 0, sheets;
        doc = doc || document;
        if (sheets = doc.querySelectorAll("style")) while(index < sheets.length){
            if (sheets[index++].id === id) return true;
        }
    };
    exports.removeElementById = function(id, doc) {
        doc = doc || document;
        if (doc.getElementById(id)) doc.getElementById(id).remove();
    };
    var strictCSP;
    var cssCache = [];
    exports.useStrictCSP = function(value) {
        strictCSP = value;
        if (value == false) insertPendingStyles();
        else if (!cssCache) cssCache = [];
    };
    function insertPendingStyles() {
        var cache = cssCache;
        cssCache = null;
        cache && cache.forEach(function(item) {
            importCssString(item[0], item[1]);
        });
    }
    function importCssString(cssText, id, target) {
        if (typeof document == "undefined") return;
        if (cssCache) {
            if (target) insertPendingStyles();
            else if (target === false) return cssCache.push([
                cssText,
                id
            ]);
        }
        if (strictCSP) return;
        var container = target;
        if (!target || !target.getRootNode) container = document;
        else {
            container = target.getRootNode();
            if (!container || container == target) container = document;
        }
        var doc = container.ownerDocument || container;
        if (id && exports.hasCssString(id, container)) return null;
        if (id) cssText += "\n/*# sourceURL=ace/css/" + id + " */";
        var style = exports.createElement("style");
        style.appendChild(doc.createTextNode(cssText));
        if (id) style.id = id;
        if (container == doc) container = exports.getDocumentHead(doc);
        container.insertBefore(style, container.firstChild);
    }
    exports.importCssString = importCssString;
    exports.importCssStylsheet = function(uri, doc) {
        exports.buildDom([
            "link",
            {
                rel: "stylesheet",
                href: uri
            }
        ], exports.getDocumentHead(doc));
    };
    exports.scrollbarWidth = function(doc) {
        var inner = exports.createElement("ace_inner");
        inner.style.width = "100%";
        inner.style.minWidth = "0px";
        inner.style.height = "200px";
        inner.style.display = "block";
        var outer = exports.createElement("ace_outer");
        var style = outer.style;
        style.position = "absolute";
        style.left = "-10000px";
        style.overflow = "hidden";
        style.width = "200px";
        style.minWidth = "0px";
        style.height = "150px";
        style.display = "block";
        outer.appendChild(inner);
        var body = doc && doc.documentElement || document && document.documentElement;
        if (!body) return 0;
        body.appendChild(outer);
        var noScrollbar = inner.offsetWidth;
        style.overflow = "scroll";
        var withScrollbar = inner.offsetWidth;
        if (noScrollbar === withScrollbar) withScrollbar = outer.clientWidth;
        body.removeChild(outer);
        return noScrollbar - withScrollbar;
    };
    exports.computedStyle = function(element, style) {
        return window.getComputedStyle(element, "") || {};
    };
    exports.setStyle = function(styles, property, value) {
        if (styles[property] !== value) styles[property] = value;
    };
    exports.HAS_CSS_ANIMATION = false;
    exports.HAS_CSS_TRANSFORMS = false;
    exports.HI_DPI = useragent.isWin ? typeof window !== "undefined" && window.devicePixelRatio >= 1.5 : true;
    if (useragent.isChromeOS) exports.HI_DPI = false;
    if (typeof document !== "undefined") {
        var div = document.createElement("div");
        if (exports.HI_DPI && div.style.transform !== undefined) exports.HAS_CSS_TRANSFORMS = true;
        if (!useragent.isEdge && typeof div.style.animationName !== "undefined") exports.HAS_CSS_ANIMATION = true;
        div = null;
    }
    if (exports.HAS_CSS_TRANSFORMS) exports.translate = function(element, tx, ty) {
        element.style.transform = "translate(" + Math.round(tx) + "px, " + Math.round(ty) + "px)";
    };
    else exports.translate = function(element, tx, ty) {
        element.style.top = Math.round(ty) + "px";
        element.style.left = Math.round(tx) + "px";
    };
});
ace.define("ace/lib/net", [
    "require",
    "exports",
    "module",
    "ace/lib/dom"
], function(require, exports, module1) {
    "use strict";
    var dom = require("./dom");
    exports.get = function(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) callback(xhr.responseText);
        };
        xhr.send(null);
    };
    exports.loadScript = function(path, callback) {
        var head = dom.getDocumentHead();
        var s = document.createElement("script");
        s.src = path;
        head.appendChild(s);
        s.onload = s.onreadystatechange = function(_, isAbort) {
            if (isAbort || !s.readyState || s.readyState == "loaded" || s.readyState == "complete") {
                s = s.onload = s.onreadystatechange = null;
                if (!isAbort) callback();
            }
        };
    };
    exports.qualifyURL = function(url) {
        var a = document.createElement("a");
        a.href = url;
        return a.href;
    };
});
ace.define("ace/lib/oop", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    exports.inherits = function(ctor, superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    };
    exports.mixin = function(obj, mixin) {
        for(var key in mixin)obj[key] = mixin[key];
        return obj;
    };
    exports.implement = function(proto, mixin) {
        exports.mixin(proto, mixin);
    };
});
ace.define("ace/lib/event_emitter", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var EventEmitter = {};
    var stopPropagation = function() {
        this.propagationStopped = true;
    };
    var preventDefault = function() {
        this.defaultPrevented = true;
    };
    EventEmitter._emit = EventEmitter._dispatchEvent = function(eventName, e) {
        this._eventRegistry || (this._eventRegistry = {});
        this._defaultHandlers || (this._defaultHandlers = {});
        var listeners = this._eventRegistry[eventName] || [];
        var defaultHandler = this._defaultHandlers[eventName];
        if (!listeners.length && !defaultHandler) return;
        if (typeof e != "object" || !e) e = {};
        if (!e.type) e.type = eventName;
        if (!e.stopPropagation) e.stopPropagation = stopPropagation;
        if (!e.preventDefault) e.preventDefault = preventDefault;
        listeners = listeners.slice();
        for(var i = 0; i < listeners.length; i++){
            listeners[i](e, this);
            if (e.propagationStopped) break;
        }
        if (defaultHandler && !e.defaultPrevented) return defaultHandler(e, this);
    };
    EventEmitter._signal = function(eventName, e) {
        var listeners = (this._eventRegistry || {})[eventName];
        if (!listeners) return;
        listeners = listeners.slice();
        for(var i = 0; i < listeners.length; i++)listeners[i](e, this);
    };
    EventEmitter.once = function(eventName, callback) {
        var _self = this;
        this.on(eventName, function newCallback() {
            _self.off(eventName, newCallback);
            callback.apply(null, arguments);
        });
        if (!callback) return new Promise(function(resolve) {
            callback = resolve;
        });
    };
    EventEmitter.setDefaultHandler = function(eventName, callback) {
        var handlers = this._defaultHandlers;
        if (!handlers) handlers = this._defaultHandlers = {
            _disabled_: {}
        };
        if (handlers[eventName]) {
            var old = handlers[eventName];
            var disabled = handlers._disabled_[eventName];
            if (!disabled) handlers._disabled_[eventName] = disabled = [];
            disabled.push(old);
            var i = disabled.indexOf(callback);
            if (i != -1) disabled.splice(i, 1);
        }
        handlers[eventName] = callback;
    };
    EventEmitter.removeDefaultHandler = function(eventName, callback) {
        var handlers = this._defaultHandlers;
        if (!handlers) return;
        var disabled = handlers._disabled_[eventName];
        if (handlers[eventName] == callback) {
            if (disabled) this.setDefaultHandler(eventName, disabled.pop());
        } else if (disabled) {
            var i = disabled.indexOf(callback);
            if (i != -1) disabled.splice(i, 1);
        }
    };
    EventEmitter.on = EventEmitter.addEventListener = function(eventName, callback, capturing) {
        this._eventRegistry = this._eventRegistry || {};
        var listeners = this._eventRegistry[eventName];
        if (!listeners) listeners = this._eventRegistry[eventName] = [];
        if (listeners.indexOf(callback) == -1) listeners[capturing ? "unshift" : "push"](callback);
        return callback;
    };
    EventEmitter.off = EventEmitter.removeListener = EventEmitter.removeEventListener = function(eventName, callback) {
        this._eventRegistry = this._eventRegistry || {};
        var listeners = this._eventRegistry[eventName];
        if (!listeners) return;
        var index = listeners.indexOf(callback);
        if (index !== -1) listeners.splice(index, 1);
    };
    EventEmitter.removeAllListeners = function(eventName) {
        if (!eventName) this._eventRegistry = this._defaultHandlers = undefined;
        if (this._eventRegistry) this._eventRegistry[eventName] = undefined;
        if (this._defaultHandlers) this._defaultHandlers[eventName] = undefined;
    };
    exports.EventEmitter = EventEmitter;
});
ace.define("ace/lib/report_error", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    exports.reportError = function reportError(msg, data) {
        var e = new Error(msg);
        e["data"] = data;
        if (typeof console == "object" && console.error) console.error(e);
        setTimeout(function() {
            throw e;
        });
    };
});
ace.define("ace/lib/default_english_messages", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    var defaultEnglishMessages = {
        "autocomplete.popup.aria-roledescription": "Autocomplete suggestions",
        "autocomplete.popup.aria-label": "Autocomplete suggestions",
        "autocomplete.popup.item.aria-roledescription": "item",
        "autocomplete.loading": "Loading...",
        "editor.scroller.aria-roledescription": "editor",
        "editor.scroller.aria-label": "Editor content, press Enter to start editing, press Escape to exit",
        "editor.gutter.aria-roledescription": "editor",
        "editor.gutter.aria-label": "Editor gutter, press Enter to interact with controls using arrow keys, press Escape to exit",
        "error-marker.good-state": "Looks good!",
        "prompt.recently-used": "Recently used",
        "prompt.other-commands": "Other commands",
        "prompt.no-matching-commands": "No matching commands",
        "search-box.find.placeholder": "Search for",
        "search-box.find-all.text": "All",
        "search-box.replace.placeholder": "Replace with",
        "search-box.replace-next.text": "Replace",
        "search-box.replace-all.text": "All",
        "search-box.toggle-replace.title": "Toggle Replace mode",
        "search-box.toggle-regexp.title": "RegExp Search",
        "search-box.toggle-case.title": "CaseSensitive Search",
        "search-box.toggle-whole-word.title": "Whole Word Search",
        "search-box.toggle-in-selection.title": "Search In Selection",
        "search-box.search-counter": "$0 of $1",
        "text-input.aria-roledescription": "editor",
        "text-input.aria-label": "Cursor at row $0",
        "gutter.code-folding.range.aria-label": "Toggle code folding, rows $0 through $1",
        "gutter.code-folding.closed.aria-label": "Toggle code folding, rows $0 through $1",
        "gutter.code-folding.open.aria-label": "Toggle code folding, row $0",
        "gutter.code-folding.closed.title": "Unfold code",
        "gutter.code-folding.open.title": "Fold code",
        "gutter.annotation.aria-label.error": "Error, read annotations row $0",
        "gutter.annotation.aria-label.warning": "Warning, read annotations row $0",
        "gutter.annotation.aria-label.info": "Info, read annotations row $0",
        "inline-fold.closed.title": "Unfold code",
        "gutter-tooltip.aria-label.error.singular": "error",
        "gutter-tooltip.aria-label.error.plural": "errors",
        "gutter-tooltip.aria-label.warning.singular": "warning",
        "gutter-tooltip.aria-label.warning.plural": "warnings",
        "gutter-tooltip.aria-label.info.singular": "information message",
        "gutter-tooltip.aria-label.info.plural": "information messages"
    };
    exports.defaultEnglishMessages = defaultEnglishMessages;
});
ace.define("ace/lib/app_config", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/event_emitter",
    "ace/lib/report_error",
    "ace/lib/default_english_messages"
], function(require, exports, module1) {
    "no use strict";
    var oop = require("./oop");
    var EventEmitter = require("./event_emitter").EventEmitter;
    var reportError = require("./report_error").reportError;
    var defaultEnglishMessages = require("./default_english_messages").defaultEnglishMessages;
    var optionsProvider = {
        setOptions: function(optList) {
            Object.keys(optList).forEach(function(key) {
                this.setOption(key, optList[key]);
            }, this);
        },
        getOptions: function(optionNames) {
            var result = {};
            if (!optionNames) {
                var options = this.$options;
                optionNames = Object.keys(options).filter(function(key) {
                    return !options[key].hidden;
                });
            } else if (!Array.isArray(optionNames)) {
                result = optionNames;
                optionNames = Object.keys(result);
            }
            optionNames.forEach(function(key) {
                result[key] = this.getOption(key);
            }, this);
            return result;
        },
        setOption: function(name, value) {
            if (this["$" + name] === value) return;
            var opt = this.$options[name];
            if (!opt) return warn('misspelled option "' + name + '"');
            if (opt.forwardTo) return this[opt.forwardTo] && this[opt.forwardTo].setOption(name, value);
            if (!opt.handlesSet) this["$" + name] = value;
            if (opt && opt.set) opt.set.call(this, value);
        },
        getOption: function(name) {
            var opt = this.$options[name];
            if (!opt) return warn('misspelled option "' + name + '"');
            if (opt.forwardTo) return this[opt.forwardTo] && this[opt.forwardTo].getOption(name);
            return opt && opt.get ? opt.get.call(this) : this["$" + name];
        }
    };
    function warn(message) {
        if (typeof console != "undefined" && console.warn) console.warn.apply(console, arguments);
    }
    var messages;
    var nlsPlaceholders;
    var AppConfig = /** @class */ function() {
        function AppConfig() {
            this.$defaultOptions = {};
            messages = defaultEnglishMessages;
            nlsPlaceholders = "dollarSigns";
        }
        AppConfig.prototype.defineOptions = function(obj, path, options) {
            if (!obj.$options) this.$defaultOptions[path] = obj.$options = {};
            Object.keys(options).forEach(function(key) {
                var opt = options[key];
                if (typeof opt == "string") opt = {
                    forwardTo: opt
                };
                opt.name || (opt.name = key);
                obj.$options[opt.name] = opt;
                if ("initialValue" in opt) obj["$" + opt.name] = opt.initialValue;
            });
            oop.implement(obj, optionsProvider);
            return this;
        };
        AppConfig.prototype.resetOptions = function(obj) {
            Object.keys(obj.$options).forEach(function(key) {
                var opt = obj.$options[key];
                if ("value" in opt) obj.setOption(key, opt.value);
            });
        };
        AppConfig.prototype.setDefaultValue = function(path, name, value) {
            if (!path) {
                for(path in this.$defaultOptions)if (this.$defaultOptions[path][name]) break;
                if (!this.$defaultOptions[path][name]) return false;
            }
            var opts = this.$defaultOptions[path] || (this.$defaultOptions[path] = {});
            if (opts[name]) {
                if (opts.forwardTo) this.setDefaultValue(opts.forwardTo, name, value);
                else opts[name].value = value;
            }
        };
        AppConfig.prototype.setDefaultValues = function(path, optionHash) {
            Object.keys(optionHash).forEach(function(key) {
                this.setDefaultValue(path, key, optionHash[key]);
            }, this);
        };
        AppConfig.prototype.setMessages = function(value, options) {
            messages = value;
            if (options && options.placeholders) nlsPlaceholders = options.placeholders;
        };
        AppConfig.prototype.nls = function(key, defaultString, params) {
            if (!messages[key]) {
                warn("No message found for the key '" + key + "' in the provided messages, trying to find a translation for the default string '" + defaultString + "'.");
                if (!messages[defaultString]) warn("No message found for the default string '" + defaultString + "' in the provided messages. Falling back to the default English message.");
            }
            var translated = messages[key] || messages[defaultString] || defaultString;
            if (params) {
                if (nlsPlaceholders === "dollarSigns") translated = translated.replace(/\$(\$|[\d]+)/g, function(_, dollarMatch) {
                    if (dollarMatch == "$") return "$";
                    return params[dollarMatch];
                });
                if (nlsPlaceholders === "curlyBrackets") translated = translated.replace(/\{([^\}]+)\}/g, function(_, curlyBracketMatch) {
                    return params[curlyBracketMatch];
                });
            }
            return translated;
        };
        return AppConfig;
    }();
    AppConfig.prototype.warn = warn;
    AppConfig.prototype.reportError = reportError;
    oop.implement(AppConfig.prototype, EventEmitter);
    exports.AppConfig = AppConfig;
});
ace.define("ace/theme/textmate-css", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    module1.exports = '.ace-tm .ace_gutter {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.ace-tm .ace_print-margin {\n  width: 1px;\n  background: #e8e8e8;\n}\n\n.ace-tm .ace_fold {\n    background-color: #6B72E6;\n}\n\n.ace-tm {\n  background-color: #FFFFFF;\n  color: black;\n}\n\n.ace-tm .ace_cursor {\n  color: black;\n}\n        \n.ace-tm .ace_invisible {\n  color: rgb(191, 191, 191);\n}\n\n.ace-tm .ace_storage,\n.ace-tm .ace_keyword {\n  color: blue;\n}\n\n.ace-tm .ace_constant {\n  color: rgb(197, 6, 11);\n}\n\n.ace-tm .ace_constant.ace_buildin {\n  color: rgb(88, 72, 246);\n}\n\n.ace-tm .ace_constant.ace_language {\n  color: rgb(88, 92, 246);\n}\n\n.ace-tm .ace_constant.ace_library {\n  color: rgb(6, 150, 14);\n}\n\n.ace-tm .ace_invalid {\n  background-color: rgba(255, 0, 0, 0.1);\n  color: red;\n}\n\n.ace-tm .ace_support.ace_function {\n  color: rgb(60, 76, 114);\n}\n\n.ace-tm .ace_support.ace_constant {\n  color: rgb(6, 150, 14);\n}\n\n.ace-tm .ace_support.ace_type,\n.ace-tm .ace_support.ace_class {\n  color: rgb(109, 121, 222);\n}\n\n.ace-tm .ace_keyword.ace_operator {\n  color: rgb(104, 118, 135);\n}\n\n.ace-tm .ace_string {\n  color: rgb(3, 106, 7);\n}\n\n.ace-tm .ace_comment {\n  color: rgb(76, 136, 107);\n}\n\n.ace-tm .ace_comment.ace_doc {\n  color: rgb(0, 102, 255);\n}\n\n.ace-tm .ace_comment.ace_doc.ace_tag {\n  color: rgb(128, 159, 191);\n}\n\n.ace-tm .ace_constant.ace_numeric {\n  color: rgb(0, 0, 205);\n}\n\n.ace-tm .ace_variable {\n  color: rgb(49, 132, 149);\n}\n\n.ace-tm .ace_xml-pe {\n  color: rgb(104, 104, 91);\n}\n\n.ace-tm .ace_entity.ace_name.ace_function {\n  color: #0000A2;\n}\n\n\n.ace-tm .ace_heading {\n  color: rgb(12, 7, 255);\n}\n\n.ace-tm .ace_list {\n  color:rgb(185, 6, 144);\n}\n\n.ace-tm .ace_meta.ace_tag {\n  color:rgb(0, 22, 142);\n}\n\n.ace-tm .ace_string.ace_regex {\n  color: rgb(255, 0, 0)\n}\n\n.ace-tm .ace_marker-layer .ace_selection {\n  background: rgb(181, 213, 255);\n}\n.ace-tm.ace_multiselect .ace_selection.ace_start {\n  box-shadow: 0 0 3px 0px white;\n}\n.ace-tm .ace_marker-layer .ace_step {\n  background: rgb(252, 255, 0);\n}\n\n.ace-tm .ace_marker-layer .ace_stack {\n  background: rgb(164, 229, 101);\n}\n\n.ace-tm .ace_marker-layer .ace_bracket {\n  margin: -1px 0 0 -1px;\n  border: 1px solid rgb(192, 192, 192);\n}\n\n.ace-tm .ace_marker-layer .ace_active-line {\n  background: rgba(0, 0, 0, 0.07);\n}\n\n.ace-tm .ace_gutter-active-line {\n    background-color : #dcdcdc;\n}\n\n.ace-tm .ace_marker-layer .ace_selected-word {\n  background: rgb(250, 250, 255);\n  border: 1px solid rgb(200, 200, 250);\n}\n\n.ace-tm .ace_indent-guide {\n  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==") right repeat-y;\n}\n\n.ace-tm .ace_indent-guide-active {\n  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAZSURBVHjaYvj///9/hivKyv8BAAAA//8DACLqBhbvk+/eAAAAAElFTkSuQmCC") right repeat-y;\n}\n';
});
ace.define("ace/theme/textmate", [
    "require",
    "exports",
    "module",
    "ace/theme/textmate-css",
    "ace/lib/dom"
], function(require, exports, module1) {
    "use strict";
    exports.isDark = false;
    exports.cssClass = "ace-tm";
    exports.cssText = require("./textmate-css");
    exports.$id = "ace/theme/textmate";
    var dom = require("../lib/dom");
    dom.importCssString(exports.cssText, exports.cssClass, false);
});
ace.define("ace/config", [
    "require",
    "exports",
    "module",
    "ace/lib/lang",
    "ace/lib/net",
    "ace/lib/dom",
    "ace/lib/app_config",
    "ace/theme/textmate"
], function(require, exports, module1) {
    "no use strict";
    var lang = require("./lib/lang");
    var net = require("./lib/net");
    var dom = require("./lib/dom");
    var AppConfig = require("./lib/app_config").AppConfig;
    module1.exports = exports = new AppConfig();
    var options = {
        packaged: false,
        workerPath: null,
        modePath: null,
        themePath: null,
        basePath: "",
        suffix: ".js",
        $moduleUrls: {},
        loadWorkerFromBlob: true,
        sharedPopups: false,
        useStrictCSP: null
    };
    exports.get = function(key) {
        if (!options.hasOwnProperty(key)) throw new Error("Unknown config key: " + key);
        return options[key];
    };
    exports.set = function(key, value) {
        if (options.hasOwnProperty(key)) options[key] = value;
        else if (this.setDefaultValue("", key, value) == false) throw new Error("Unknown config key: " + key);
        if (key == "useStrictCSP") dom.useStrictCSP(value);
    };
    exports.all = function() {
        return lang.copyObject(options);
    };
    exports.$modes = {};
    exports.moduleUrl = function(name, component) {
        if (options.$moduleUrls[name]) return options.$moduleUrls[name];
        var parts = name.split("/");
        component = component || parts[parts.length - 2] || "";
        var sep = component == "snippets" ? "/" : "-";
        var base = parts[parts.length - 1];
        if (component == "worker" && sep == "-") {
            var re = new RegExp("^" + component + "[\\-_]|[\\-_]" + component + "$", "g");
            base = base.replace(re, "");
        }
        if ((!base || base == component) && parts.length > 1) base = parts[parts.length - 2];
        var path = options[component + "Path"];
        if (path == null) path = options.basePath;
        else if (sep == "/") component = sep = "";
        if (path && path.slice(-1) != "/") path += "/";
        return path + component + sep + base + this.get("suffix");
    };
    exports.setModuleUrl = function(name, subst) {
        return options.$moduleUrls[name] = subst;
    };
    var loader = function(moduleName, cb) {
        if (moduleName === "ace/theme/textmate" || moduleName === "./theme/textmate") return cb(null, require("./theme/textmate"));
        if (customLoader) return customLoader(moduleName, cb);
        console.error("loader is not configured");
    };
    var customLoader;
    exports.setLoader = function(cb) {
        customLoader = cb;
    };
    exports.dynamicModules = Object.create(null);
    exports.$loading = {};
    exports.$loaded = {};
    exports.loadModule = function(moduleId, onLoad) {
        var loadedModule;
        if (Array.isArray(moduleId)) {
            var moduleType = moduleId[0];
            var moduleName = moduleId[1];
        } else if (typeof moduleId == "string") var moduleName = moduleId;
        var load = function(module1) {
            if (module1 && !exports.$loading[moduleName]) return onLoad && onLoad(module1);
            if (!exports.$loading[moduleName]) exports.$loading[moduleName] = [];
            exports.$loading[moduleName].push(onLoad);
            if (exports.$loading[moduleName].length > 1) return;
            var afterLoad = function() {
                loader(moduleName, function(err, module1) {
                    if (module1) exports.$loaded[moduleName] = module1;
                    exports._emit("load.module", {
                        name: moduleName,
                        module: module1
                    });
                    var listeners = exports.$loading[moduleName];
                    exports.$loading[moduleName] = null;
                    listeners.forEach(function(onLoad) {
                        onLoad && onLoad(module1);
                    });
                });
            };
            if (!exports.get("packaged")) return afterLoad();
            net.loadScript(exports.moduleUrl(moduleName, moduleType), afterLoad);
            reportErrorIfPathIsNotConfigured();
        };
        if (exports.dynamicModules[moduleName]) exports.dynamicModules[moduleName]().then(function(module1) {
            if (module1.default) load(module1.default);
            else load(module1);
        });
        else {
            try {
                loadedModule = this.$require(moduleName);
            } catch (e) {}
            load(loadedModule || exports.$loaded[moduleName]);
        }
    };
    exports.$require = function(moduleName) {
        if (typeof module1["require"] == "function") {
            var req = "require";
            return module1[req](moduleName);
        }
    };
    exports.setModuleLoader = function(moduleName, onLoad) {
        exports.dynamicModules[moduleName] = onLoad;
    };
    var reportErrorIfPathIsNotConfigured = function() {
        if (!options.basePath && !options.workerPath && !options.modePath && !options.themePath && !Object.keys(options.$moduleUrls).length) {
            console.error("Unable to infer path to ace from script src,", "use ace.config.set('basePath', 'path') to enable dynamic loading of modes and themes", "or with webpack use ace/webpack-resolver");
            reportErrorIfPathIsNotConfigured = function() {};
        }
    };
    exports.version = "1.35.2";
});
ace.define("ace/loader_build", [
    "require",
    "exports",
    "module",
    "ace/lib/fixoldbrowsers",
    "ace/config"
], function(require, exports, module1) {
    "use strict";
    require("./lib/fixoldbrowsers");
    var config = require("./config");
    config.setLoader(function(moduleName, cb) {
        require([
            moduleName
        ], function(module1) {
            cb(null, module1);
        });
    });
    var global = function() {
        return this || typeof window != "undefined" && window;
    }();
    module1.exports = function(ace1) {
        config.init = init;
        config.$require = require;
        ace1.require = require;
        if (typeof define === "function") ace1.define = define;
    };
    init(true);
    function init(packaged) {
        if (!global || !global.document) return;
        config.set("packaged", packaged || require.packaged || module1.packaged || global.define && define.packaged);
        var scriptOptions = {};
        var scriptUrl = "";
        var currentScript = document.currentScript || document._currentScript; // native or polyfill
        var currentDocument = currentScript && currentScript.ownerDocument || document;
        if (currentScript && currentScript.src) scriptUrl = currentScript.src.split(/[?#]/)[0].split("/").slice(0, -1).join("/") || "";
        var scripts = currentDocument.getElementsByTagName("script");
        for(var i = 0; i < scripts.length; i++){
            var script = scripts[i];
            var src = script.src || script.getAttribute("src");
            if (!src) continue;
            var attributes = script.attributes;
            for(var j = 0, l = attributes.length; j < l; j++){
                var attr = attributes[j];
                if (attr.name.indexOf("data-ace-") === 0) scriptOptions[deHyphenate(attr.name.replace(/^data-ace-/, ""))] = attr.value;
            }
            var m = src.match(/^(.*)\/ace([\-.]\w+)?\.js(\?|$)/);
            if (m) scriptUrl = m[1];
        }
        if (scriptUrl) {
            scriptOptions.base = scriptOptions.base || scriptUrl;
            scriptOptions.packaged = true;
        }
        scriptOptions.basePath = scriptOptions.base;
        scriptOptions.workerPath = scriptOptions.workerPath || scriptOptions.base;
        scriptOptions.modePath = scriptOptions.modePath || scriptOptions.base;
        scriptOptions.themePath = scriptOptions.themePath || scriptOptions.base;
        delete scriptOptions.base;
        for(var key in scriptOptions)if (typeof scriptOptions[key] !== "undefined") config.set(key, scriptOptions[key]);
    }
    function deHyphenate(str) {
        return str.replace(/-(.)/g, function(m, m1) {
            return m1.toUpperCase();
        });
    }
});
ace.define("ace/range", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var Range = /** @class */ function() {
        function Range(startRow, startColumn, endRow, endColumn) {
            this.start = {
                row: startRow,
                column: startColumn
            };
            this.end = {
                row: endRow,
                column: endColumn
            };
        }
        Range.prototype.isEqual = function(range) {
            return this.start.row === range.start.row && this.end.row === range.end.row && this.start.column === range.start.column && this.end.column === range.end.column;
        };
        Range.prototype.toString = function() {
            return "Range: [" + this.start.row + "/" + this.start.column + "] -> [" + this.end.row + "/" + this.end.column + "]";
        };
        Range.prototype.contains = function(row, column) {
            return this.compare(row, column) == 0;
        };
        Range.prototype.compareRange = function(range) {
            var cmp, end = range.end, start = range.start;
            cmp = this.compare(end.row, end.column);
            if (cmp == 1) {
                cmp = this.compare(start.row, start.column);
                if (cmp == 1) return 2;
                else if (cmp == 0) return 1;
                else return 0;
            } else if (cmp == -1) return -2;
            else {
                cmp = this.compare(start.row, start.column);
                if (cmp == -1) return -1;
                else if (cmp == 1) return 42;
                else return 0;
            }
        };
        Range.prototype.comparePoint = function(p) {
            return this.compare(p.row, p.column);
        };
        Range.prototype.containsRange = function(range) {
            return this.comparePoint(range.start) == 0 && this.comparePoint(range.end) == 0;
        };
        Range.prototype.intersects = function(range) {
            var cmp = this.compareRange(range);
            return cmp == -1 || cmp == 0 || cmp == 1;
        };
        Range.prototype.isEnd = function(row, column) {
            return this.end.row == row && this.end.column == column;
        };
        Range.prototype.isStart = function(row, column) {
            return this.start.row == row && this.start.column == column;
        };
        Range.prototype.setStart = function(row, column) {
            if (typeof row == "object") {
                this.start.column = row.column;
                this.start.row = row.row;
            } else {
                this.start.row = row;
                this.start.column = column;
            }
        };
        Range.prototype.setEnd = function(row, column) {
            if (typeof row == "object") {
                this.end.column = row.column;
                this.end.row = row.row;
            } else {
                this.end.row = row;
                this.end.column = column;
            }
        };
        Range.prototype.inside = function(row, column) {
            if (this.compare(row, column) == 0) {
                if (this.isEnd(row, column) || this.isStart(row, column)) return false;
                else return true;
            }
            return false;
        };
        Range.prototype.insideStart = function(row, column) {
            if (this.compare(row, column) == 0) {
                if (this.isEnd(row, column)) return false;
                else return true;
            }
            return false;
        };
        Range.prototype.insideEnd = function(row, column) {
            if (this.compare(row, column) == 0) {
                if (this.isStart(row, column)) return false;
                else return true;
            }
            return false;
        };
        Range.prototype.compare = function(row, column) {
            if (!this.isMultiLine()) {
                if (row === this.start.row) return column < this.start.column ? -1 : column > this.end.column ? 1 : 0;
            }
            if (row < this.start.row) return -1;
            if (row > this.end.row) return 1;
            if (this.start.row === row) return column >= this.start.column ? 0 : -1;
            if (this.end.row === row) return column <= this.end.column ? 0 : 1;
            return 0;
        };
        Range.prototype.compareStart = function(row, column) {
            if (this.start.row == row && this.start.column == column) return -1;
            else return this.compare(row, column);
        };
        Range.prototype.compareEnd = function(row, column) {
            if (this.end.row == row && this.end.column == column) return 1;
            else return this.compare(row, column);
        };
        Range.prototype.compareInside = function(row, column) {
            if (this.end.row == row && this.end.column == column) return 1;
            else if (this.start.row == row && this.start.column == column) return -1;
            else return this.compare(row, column);
        };
        Range.prototype.clipRows = function(firstRow, lastRow) {
            if (this.end.row > lastRow) var end = {
                row: lastRow + 1,
                column: 0
            };
            else if (this.end.row < firstRow) var end = {
                row: firstRow,
                column: 0
            };
            if (this.start.row > lastRow) var start = {
                row: lastRow + 1,
                column: 0
            };
            else if (this.start.row < firstRow) var start = {
                row: firstRow,
                column: 0
            };
            return Range.fromPoints(start || this.start, end || this.end);
        };
        Range.prototype.extend = function(row, column) {
            var cmp = this.compare(row, column);
            if (cmp == 0) return this;
            else if (cmp == -1) var start = {
                row: row,
                column: column
            };
            else var end = {
                row: row,
                column: column
            };
            return Range.fromPoints(start || this.start, end || this.end);
        };
        Range.prototype.isEmpty = function() {
            return this.start.row === this.end.row && this.start.column === this.end.column;
        };
        Range.prototype.isMultiLine = function() {
            return this.start.row !== this.end.row;
        };
        Range.prototype.clone = function() {
            return Range.fromPoints(this.start, this.end);
        };
        Range.prototype.collapseRows = function() {
            if (this.end.column == 0) return new Range(this.start.row, 0, Math.max(this.start.row, this.end.row - 1), 0);
            else return new Range(this.start.row, 0, this.end.row, 0);
        };
        Range.prototype.toScreenRange = function(session) {
            var screenPosStart = session.documentToScreenPosition(this.start);
            var screenPosEnd = session.documentToScreenPosition(this.end);
            return new Range(screenPosStart.row, screenPosStart.column, screenPosEnd.row, screenPosEnd.column);
        };
        Range.prototype.moveBy = function(row, column) {
            this.start.row += row;
            this.start.column += column;
            this.end.row += row;
            this.end.column += column;
        };
        return Range;
    }();
    Range.fromPoints = function(start, end) {
        return new Range(start.row, start.column, end.row, end.column);
    };
    Range.comparePoints = function(p1, p2) {
        return p1.row - p2.row || p1.column - p2.column;
    };
    exports.Range = Range;
});
ace.define("ace/lib/keys", [
    "require",
    "exports",
    "module",
    "ace/lib/oop"
], function(require, exports, module1) {
    "use strict";
    var oop = require("./oop");
    var Keys = {
        MODIFIER_KEYS: {
            16: "Shift",
            17: "Ctrl",
            18: "Alt",
            224: "Meta",
            91: "MetaLeft",
            92: "MetaRight",
            93: "ContextMenu"
        },
        KEY_MODS: {
            "ctrl": 1,
            "alt": 2,
            "option": 2,
            "shift": 4,
            "super": 8,
            "meta": 8,
            "command": 8,
            "cmd": 8,
            "control": 1
        },
        FUNCTION_KEYS: {
            8: "Backspace",
            9: "Tab",
            13: "Return",
            19: "Pause",
            27: "Esc",
            32: "Space",
            33: "PageUp",
            34: "PageDown",
            35: "End",
            36: "Home",
            37: "Left",
            38: "Up",
            39: "Right",
            40: "Down",
            44: "Print",
            45: "Insert",
            46: "Delete",
            "-13": "NumpadEnter",
            144: "Numlock",
            145: "Scrolllock"
        },
        PRINTABLE_KEYS: {
            32: " ",
            59: ";",
            61: "=",
            107: "+",
            109: "-",
            110: ".",
            186: ";",
            187: "=",
            188: ",",
            189: "-",
            190: ".",
            191: "/",
            192: "`",
            219: "[",
            220: "\\",
            221: "]",
            222: "'",
            111: "/",
            106: "*"
        }
    };
    var codeToKeyCode = {
        Command: 224,
        Backspace: 8,
        Tab: 9,
        Return: 13,
        Enter: 13,
        Pause: 19,
        Escape: 27,
        PageUp: 33,
        PageDown: 34,
        End: 35,
        Home: 36,
        Insert: 45,
        Delete: 46,
        ArrowLeft: 37,
        ArrowUp: 38,
        ArrowRight: 39,
        ArrowDown: 40,
        Backquote: 192,
        Minus: 189,
        Equal: 187,
        BracketLeft: 219,
        Backslash: 220,
        BracketRight: 221,
        Semicolon: 186,
        Quote: 222,
        Comma: 188,
        Period: 190,
        Slash: 191,
        Space: 32,
        NumpadAdd: 107,
        NumpadDecimal: 110,
        NumpadSubtract: 109,
        NumpadDivide: 111,
        NumpadMultiply: 106
    };
    for(var i = 0; i < 10; i++){
        codeToKeyCode["Digit" + i] = 48 + i;
        codeToKeyCode["Numpad" + i] = 96 + i;
        Keys.PRINTABLE_KEYS[48 + i] = "" + i;
        Keys.FUNCTION_KEYS[96 + i] = "Numpad" + i;
    }
    for(var i = 65; i < 91; i++){
        var chr = String.fromCharCode(i + 32);
        codeToKeyCode["Key" + chr.toUpperCase()] = i;
        Keys.PRINTABLE_KEYS[i] = chr;
    }
    for(var i = 1; i < 13; i++){
        codeToKeyCode["F" + i] = 111 + i;
        Keys.FUNCTION_KEYS[111 + i] = "F" + i;
    }
    var modifiers = {
        Shift: 16,
        Control: 17,
        Alt: 18,
        Meta: 224
    };
    for(var mod in modifiers)codeToKeyCode[mod] = codeToKeyCode[mod + "Left"] = codeToKeyCode[mod + "Right"] = modifiers[mod];
    exports.$codeToKeyCode = codeToKeyCode;
    Keys.PRINTABLE_KEYS[173] = "-";
    for(var j in Keys.FUNCTION_KEYS){
        var name = Keys.FUNCTION_KEYS[j].toLowerCase();
        Keys[name] = parseInt(j, 10);
    }
    for(var j in Keys.PRINTABLE_KEYS){
        var name = Keys.PRINTABLE_KEYS[j].toLowerCase();
        Keys[name] = parseInt(j, 10);
    }
    oop.mixin(Keys, Keys.MODIFIER_KEYS);
    oop.mixin(Keys, Keys.PRINTABLE_KEYS);
    oop.mixin(Keys, Keys.FUNCTION_KEYS);
    Keys.enter = Keys["return"];
    Keys.escape = Keys.esc;
    Keys.del = Keys["delete"];
    (function() {
        var mods = [
            "cmd",
            "ctrl",
            "alt",
            "shift"
        ];
        for(var i = Math.pow(2, mods.length); i--;)Keys.KEY_MODS[i] = mods.filter(function(x) {
            return i & Keys.KEY_MODS[x];
        }).join("-") + "-";
    })();
    Keys.KEY_MODS[0] = "";
    Keys.KEY_MODS[-1] = "input-";
    oop.mixin(exports, Keys);
    exports.default = exports;
    exports.keyCodeToString = function(keyCode) {
        var keyString = Keys[keyCode];
        if (typeof keyString != "string") keyString = String.fromCharCode(keyCode);
        return keyString.toLowerCase();
    };
});
ace.define("ace/lib/event", [
    "require",
    "exports",
    "module",
    "ace/lib/keys",
    "ace/lib/useragent"
], function(require, exports, module1) {
    "use strict";
    var keys = require("./keys");
    var useragent = require("./useragent");
    var pressedKeys = null;
    var ts = 0;
    var activeListenerOptions;
    function detectListenerOptionsSupport() {
        activeListenerOptions = false;
        try {
            document.createComment("").addEventListener("test", function() {}, {
                get passive () {
                    activeListenerOptions = {
                        passive: false
                    };
                    return true;
                }
            });
        } catch (e) {}
    }
    function getListenerOptions() {
        if (activeListenerOptions == undefined) detectListenerOptionsSupport();
        return activeListenerOptions;
    }
    function EventListener(elem, type, callback) {
        this.elem = elem;
        this.type = type;
        this.callback = callback;
    }
    EventListener.prototype.destroy = function() {
        removeListener(this.elem, this.type, this.callback);
        this.elem = this.type = this.callback = undefined;
    };
    var addListener = exports.addListener = function(elem, type, callback, /**@type{any?}*/ destroyer) {
        elem.addEventListener(type, callback, getListenerOptions());
        if (destroyer) destroyer.$toDestroy.push(new EventListener(elem, type, callback));
    };
    var removeListener = exports.removeListener = function(elem, type, callback) {
        elem.removeEventListener(type, callback, getListenerOptions());
    };
    exports.stopEvent = function(e) {
        exports.stopPropagation(e);
        exports.preventDefault(e);
        return false;
    };
    exports.stopPropagation = function(e) {
        if (e.stopPropagation) e.stopPropagation();
    };
    exports.preventDefault = function(e) {
        if (e.preventDefault) e.preventDefault();
    };
    exports.getButton = function(e) {
        if (e.type == "dblclick") return 0;
        if (e.type == "contextmenu" || useragent.isMac && e.ctrlKey && !e.altKey && !e.shiftKey) return 2;
        return e.button;
    };
    exports.capture = function(el, eventHandler, releaseCaptureHandler) {
        var ownerDocument = el && el.ownerDocument || document;
        function onMouseUp(e) {
            eventHandler && eventHandler(e);
            releaseCaptureHandler && releaseCaptureHandler(e);
            removeListener(ownerDocument, "mousemove", eventHandler);
            removeListener(ownerDocument, "mouseup", onMouseUp);
            removeListener(ownerDocument, "dragstart", onMouseUp);
        }
        addListener(ownerDocument, "mousemove", eventHandler);
        addListener(ownerDocument, "mouseup", onMouseUp);
        addListener(ownerDocument, "dragstart", onMouseUp);
        return onMouseUp;
    };
    exports.addMouseWheelListener = function(el, callback, destroyer) {
        addListener(el, "wheel", function(e) {
            var factor = 0.15;
            var deltaX = e.deltaX || 0;
            var deltaY = e.deltaY || 0;
            switch(e.deltaMode){
                case e.DOM_DELTA_PIXEL:
                    e.wheelX = deltaX * factor;
                    e.wheelY = deltaY * factor;
                    break;
                case e.DOM_DELTA_LINE:
                    var linePixels = 15;
                    e.wheelX = deltaX * linePixels;
                    e.wheelY = deltaY * linePixels;
                    break;
                case e.DOM_DELTA_PAGE:
                    var pagePixels = 150;
                    e.wheelX = deltaX * pagePixels;
                    e.wheelY = deltaY * pagePixels;
                    break;
            }
            callback(e);
        }, destroyer);
    };
    exports.addMultiMouseDownListener = function(elements, timeouts, eventHandler, callbackName, destroyer) {
        var clicks = 0;
        var startX, startY, timer;
        var eventNames = {
            2: "dblclick",
            3: "tripleclick",
            4: "quadclick"
        };
        function onMousedown(e) {
            if (exports.getButton(e) !== 0) clicks = 0;
            else if (e.detail > 1) {
                clicks++;
                if (clicks > 4) clicks = 1;
            } else clicks = 1;
            if (useragent.isIE) {
                var isNewClick = Math.abs(e.clientX - startX) > 5 || Math.abs(e.clientY - startY) > 5;
                if (!timer || isNewClick) clicks = 1;
                if (timer) clearTimeout(timer);
                timer = setTimeout(function() {
                    timer = null;
                }, timeouts[clicks - 1] || 600);
                if (clicks == 1) {
                    startX = e.clientX;
                    startY = e.clientY;
                }
            }
            e._clicks = clicks;
            eventHandler[callbackName]("mousedown", e);
            if (clicks > 4) clicks = 0;
            else if (clicks > 1) return eventHandler[callbackName](eventNames[clicks], e);
        }
        if (!Array.isArray(elements)) elements = [
            elements
        ];
        elements.forEach(function(el) {
            addListener(el, "mousedown", onMousedown, destroyer);
        });
    };
    function getModifierHash(e) {
        return 0 | (e.ctrlKey ? 1 : 0) | (e.altKey ? 2 : 0) | (e.shiftKey ? 4 : 0) | (e.metaKey ? 8 : 0);
    }
    exports.getModifierString = function(e) {
        return keys.KEY_MODS[getModifierHash(e)];
    };
    function normalizeCommandKeys(callback, e, keyCode) {
        var hashId = getModifierHash(e);
        if (!keyCode && e.code) keyCode = keys.$codeToKeyCode[e.code] || keyCode;
        if (!useragent.isMac && pressedKeys) {
            if (e.getModifierState && (e.getModifierState("OS") || e.getModifierState("Win"))) hashId |= 8;
            if (pressedKeys.altGr) {
                if ((3 & hashId) != 3) pressedKeys.altGr = 0;
                else return;
            }
            if (keyCode === 18 || keyCode === 17) {
                var location = e.location;
                if (keyCode === 17 && location === 1) {
                    if (pressedKeys[keyCode] == 1) ts = e.timeStamp;
                } else if (keyCode === 18 && hashId === 3 && location === 2) {
                    var dt = e.timeStamp - ts;
                    if (dt < 50) pressedKeys.altGr = true;
                }
            }
        }
        if (keyCode in keys.MODIFIER_KEYS) keyCode = -1;
        if (!hashId && keyCode === 13) {
            if (e.location === 3) {
                callback(e, hashId, -keyCode);
                if (e.defaultPrevented) return;
            }
        }
        if (useragent.isChromeOS && hashId & 8) {
            callback(e, hashId, keyCode);
            if (e.defaultPrevented) return;
            else hashId &= -9;
        }
        if (!hashId && !(keyCode in keys.FUNCTION_KEYS) && !(keyCode in keys.PRINTABLE_KEYS)) return false;
        return callback(e, hashId, keyCode);
    }
    exports.addCommandKeyListener = function(el, callback, destroyer) {
        var lastDefaultPrevented = null;
        addListener(el, "keydown", function(e) {
            pressedKeys[e.keyCode] = (pressedKeys[e.keyCode] || 0) + 1;
            var result = normalizeCommandKeys(callback, e, e.keyCode);
            lastDefaultPrevented = e.defaultPrevented;
            return result;
        }, destroyer);
        addListener(el, "keypress", function(e) {
            if (lastDefaultPrevented && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey)) {
                exports.stopEvent(e);
                lastDefaultPrevented = null;
            }
        }, destroyer);
        addListener(el, "keyup", function(e) {
            pressedKeys[e.keyCode] = null;
        }, destroyer);
        if (!pressedKeys) {
            resetPressedKeys();
            addListener(window, "focus", resetPressedKeys);
        }
    };
    function resetPressedKeys() {
        pressedKeys = Object.create(null);
    }
    if (typeof window == "object" && window.postMessage && !useragent.isOldIE) {
        var postMessageId = 1;
        exports.nextTick = function(callback, win) {
            win = win || window;
            var messageName = "zero-timeout-message-" + postMessageId++;
            var listener = function(e) {
                if (e.data == messageName) {
                    exports.stopPropagation(e);
                    removeListener(win, "message", listener);
                    callback();
                }
            };
            addListener(win, "message", listener);
            win.postMessage(messageName, "*");
        };
    }
    exports.$idleBlocked = false;
    exports.onIdle = function(cb, timeout) {
        return setTimeout(function handler() {
            if (!exports.$idleBlocked) cb();
            else setTimeout(handler, 100);
        }, timeout);
    };
    exports.$idleBlockId = null;
    exports.blockIdle = function(delay) {
        if (exports.$idleBlockId) clearTimeout(exports.$idleBlockId);
        exports.$idleBlocked = true;
        exports.$idleBlockId = setTimeout(function() {
            exports.$idleBlocked = false;
        }, delay || 100);
    };
    exports.nextFrame = typeof window == "object" && (window.requestAnimationFrame || window["mozRequestAnimationFrame"] || window["webkitRequestAnimationFrame"] || window["msRequestAnimationFrame"] || window["oRequestAnimationFrame"]);
    if (exports.nextFrame) exports.nextFrame = exports.nextFrame.bind(window);
    else exports.nextFrame = function(callback) {
        setTimeout(callback, 17);
    };
});
ace.define("ace/clipboard", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var $cancelT;
    module1.exports = {
        lineMode: false,
        pasteCancelled: function() {
            if ($cancelT && $cancelT > Date.now() - 50) return true;
            return $cancelT = false;
        },
        cancel: function() {
            $cancelT = Date.now();
        }
    };
});
ace.define("ace/keyboard/textinput", [
    "require",
    "exports",
    "module",
    "ace/lib/event",
    "ace/config",
    "ace/lib/useragent",
    "ace/lib/dom",
    "ace/lib/lang",
    "ace/clipboard",
    "ace/lib/keys"
], function(require, exports, module1) {
    "use strict";
    var event = require("../lib/event");
    var nls = require("../config").nls;
    var useragent = require("../lib/useragent");
    var dom = require("../lib/dom");
    var lang = require("../lib/lang");
    var clipboard = require("../clipboard");
    var BROKEN_SETDATA = useragent.isChrome < 18;
    var USE_IE_MIME_TYPE = useragent.isIE;
    var HAS_FOCUS_ARGS = useragent.isChrome > 63;
    var MAX_LINE_LENGTH = 400;
    var KEYS = require("../lib/keys");
    var MODS = KEYS.KEY_MODS;
    var isIOS = useragent.isIOS;
    var valueResetRegex = isIOS ? /\s/ : /\n/;
    var isMobile = useragent.isMobile;
    var TextInput;
    TextInput = function(parentNode, host) {
        var text = dom.createElement("textarea");
        text.className = "ace_text-input";
        text.setAttribute("wrap", "off");
        text.setAttribute("autocorrect", "off");
        text.setAttribute("autocapitalize", "off");
        text.setAttribute("spellcheck", "false");
        text.style.opacity = "0";
        parentNode.insertBefore(text, parentNode.firstChild);
        var copied = false;
        var pasted = false;
        var inComposition = false;
        var sendingText = false;
        var tempStyle = "";
        if (!isMobile) text.style.fontSize = "1px";
        var commandMode = false;
        var ignoreFocusEvents = false;
        var lastValue = "";
        var lastSelectionStart = 0;
        var lastSelectionEnd = 0;
        var lastRestoreEnd = 0;
        var rowStart = Number.MAX_SAFE_INTEGER;
        var rowEnd = Number.MIN_SAFE_INTEGER;
        var numberOfExtraLines = 0;
        try {
            var isFocused = document.activeElement === text;
        } catch (e) {}
        this.setNumberOfExtraLines = function(number) {
            rowStart = Number.MAX_SAFE_INTEGER;
            rowEnd = Number.MIN_SAFE_INTEGER;
            if (number < 0) {
                numberOfExtraLines = 0;
                return;
            }
            numberOfExtraLines = number;
        };
        this.setAriaOptions = function(options) {
            if (options.activeDescendant) {
                text.setAttribute("aria-haspopup", "true");
                text.setAttribute("aria-autocomplete", options.inline ? "both" : "list");
                text.setAttribute("aria-activedescendant", options.activeDescendant);
            } else {
                text.setAttribute("aria-haspopup", "false");
                text.setAttribute("aria-autocomplete", "both");
                text.removeAttribute("aria-activedescendant");
            }
            if (options.role) text.setAttribute("role", options.role);
            if (options.setLabel) {
                text.setAttribute("aria-roledescription", nls("text-input.aria-roledescription", "editor"));
                var arialLabel = "";
                if (host.$textInputAriaLabel) arialLabel += "".concat(host.$textInputAriaLabel, ", ");
                if (host.session) {
                    var row = host.session.selection.cursor.row;
                    arialLabel += nls("text-input.aria-label", "Cursor at row $0", [
                        row + 1
                    ]);
                }
                text.setAttribute("aria-label", arialLabel);
            }
        };
        this.setAriaOptions({
            role: "textbox"
        });
        event.addListener(text, "blur", function(e) {
            if (ignoreFocusEvents) return;
            host.onBlur(e);
            isFocused = false;
        }, host);
        event.addListener(text, "focus", function(e) {
            if (ignoreFocusEvents) return;
            isFocused = true;
            if (useragent.isEdge) try {
                if (!document.hasFocus()) return;
            } catch (e) {}
            host.onFocus(e);
            if (useragent.isEdge) setTimeout(resetSelection);
            else resetSelection();
        }, host);
        this.$focusScroll = false;
        this.focus = function() {
            this.setAriaOptions({
                setLabel: host.renderer.enableKeyboardAccessibility
            });
            if (tempStyle || HAS_FOCUS_ARGS || this.$focusScroll == "browser") return text.focus({
                preventScroll: true
            });
            var top = text.style.top;
            text.style.position = "fixed";
            text.style.top = "0px";
            try {
                var isTransformed = text.getBoundingClientRect().top != 0;
            } catch (e) {
                return;
            }
            var ancestors = [];
            if (isTransformed) {
                var t = text.parentElement;
                while(t && t.nodeType == 1){
                    ancestors.push(t);
                    t.setAttribute("ace_nocontext", "true");
                    if (!t.parentElement && t.getRootNode) t = t.getRootNode()["host"];
                    else t = t.parentElement;
                }
            }
            text.focus({
                preventScroll: true
            });
            if (isTransformed) ancestors.forEach(function(p) {
                p.removeAttribute("ace_nocontext");
            });
            setTimeout(function() {
                text.style.position = "";
                if (text.style.top == "0px") text.style.top = top;
            }, 0);
        };
        this.blur = function() {
            text.blur();
        };
        this.isFocused = function() {
            return isFocused;
        };
        host.on("beforeEndOperation", function() {
            var curOp = host.curOp;
            var commandName = curOp && curOp.command && curOp.command.name;
            if (commandName == "insertstring") return;
            var isUserAction = commandName && (curOp.docChanged || curOp.selectionChanged);
            if (inComposition && isUserAction) {
                lastValue = text.value = "";
                onCompositionEnd();
            }
            resetSelection();
        });
        var positionToSelection = function(row, column) {
            var selection = column;
            for(var i = 1; i <= row - rowStart && i < 2 * numberOfExtraLines + 1; i++)selection += host.session.getLine(row - i).length + 1;
            return selection;
        };
        var resetSelection = isIOS ? function(value) {
            if (!isFocused || copied && !value || sendingText) return;
            if (!value) value = "";
            var newValue = "\n ab" + value + "cde fg\n";
            if (newValue != text.value) text.value = lastValue = newValue;
            var selectionStart = 4;
            var selectionEnd = 4 + (value.length || (host.selection.isEmpty() ? 0 : 1));
            if (lastSelectionStart != selectionStart || lastSelectionEnd != selectionEnd) text.setSelectionRange(selectionStart, selectionEnd);
            lastSelectionStart = selectionStart;
            lastSelectionEnd = selectionEnd;
        } : function() {
            if (inComposition || sendingText) return;
            if (!isFocused && !afterContextMenu) return;
            inComposition = true;
            var selectionStart = 0;
            var selectionEnd = 0;
            var line = "";
            if (host.session) {
                var selection = host.selection;
                var range = selection.getRange();
                var row = selection.cursor.row;
                if (row === rowEnd + 1) {
                    rowStart = rowEnd + 1;
                    rowEnd = rowStart + 2 * numberOfExtraLines;
                } else if (row === rowStart - 1) {
                    rowEnd = rowStart - 1;
                    rowStart = rowEnd - 2 * numberOfExtraLines;
                } else if (row < rowStart - 1 || row > rowEnd + 1) {
                    rowStart = row > numberOfExtraLines ? row - numberOfExtraLines : 0;
                    rowEnd = row > numberOfExtraLines ? row + numberOfExtraLines : 2 * numberOfExtraLines;
                }
                var lines = [];
                for(var i = rowStart; i <= rowEnd; i++)lines.push(host.session.getLine(i));
                line = lines.join("\n");
                selectionStart = positionToSelection(range.start.row, range.start.column);
                selectionEnd = positionToSelection(range.end.row, range.end.column);
                if (range.start.row < rowStart) {
                    var prevLine = host.session.getLine(rowStart - 1);
                    selectionStart = range.start.row < rowStart - 1 ? 0 : selectionStart;
                    selectionEnd += prevLine.length + 1;
                    line = prevLine + "\n" + line;
                } else if (range.end.row > rowEnd) {
                    var nextLine = host.session.getLine(rowEnd + 1);
                    selectionEnd = range.end.row > rowEnd + 1 ? nextLine.length : range.end.column;
                    selectionEnd += line.length + 1;
                    line = line + "\n" + nextLine;
                } else if (isMobile && row > 0) {
                    line = "\n" + line;
                    selectionEnd += 1;
                    selectionStart += 1;
                }
                if (line.length > MAX_LINE_LENGTH) {
                    if (selectionStart < MAX_LINE_LENGTH && selectionEnd < MAX_LINE_LENGTH) line = line.slice(0, MAX_LINE_LENGTH);
                    else {
                        line = "\n";
                        if (selectionStart == selectionEnd) selectionStart = selectionEnd = 0;
                        else {
                            selectionStart = 0;
                            selectionEnd = 1;
                        }
                    }
                }
                var newValue = line + "\n\n";
                if (newValue != lastValue) {
                    text.value = lastValue = newValue;
                    lastSelectionStart = lastSelectionEnd = newValue.length;
                }
            }
            if (afterContextMenu) {
                lastSelectionStart = text.selectionStart;
                lastSelectionEnd = text.selectionEnd;
            }
            if (lastSelectionEnd != selectionEnd || lastSelectionStart != selectionStart || text.selectionEnd != lastSelectionEnd // on ie edge selectionEnd changes silently after the initialization
            ) try {
                text.setSelectionRange(selectionStart, selectionEnd);
                lastSelectionStart = selectionStart;
                lastSelectionEnd = selectionEnd;
            } catch (e) {}
            inComposition = false;
        };
        this.resetSelection = resetSelection;
        if (isFocused) host.onFocus();
        var isAllSelected = function(text) {
            return text.selectionStart === 0 && text.selectionEnd >= lastValue.length && text.value === lastValue && lastValue && text.selectionEnd !== lastSelectionEnd;
        };
        var onSelect = function(e) {
            if (inComposition) return;
            if (copied) copied = false;
            else if (isAllSelected(text)) {
                host.selectAll();
                resetSelection();
            } else if (isMobile && text.selectionStart != lastSelectionStart) resetSelection();
        };
        var inputHandler = null;
        this.setInputHandler = function(cb) {
            inputHandler = cb;
        };
        this.getInputHandler = function() {
            return inputHandler;
        };
        var afterContextMenu = false;
        var sendText = function(value, fromInput) {
            if (afterContextMenu) afterContextMenu = false;
            if (pasted) {
                resetSelection();
                if (value) host.onPaste(value);
                pasted = false;
                return "";
            } else {
                var selectionStart = text.selectionStart;
                var selectionEnd = text.selectionEnd;
                var extendLeft = lastSelectionStart;
                var extendRight = lastValue.length - lastSelectionEnd;
                var inserted = value;
                var restoreStart = value.length - selectionStart;
                var restoreEnd = value.length - selectionEnd;
                var i = 0;
                while(extendLeft > 0 && lastValue[i] == value[i]){
                    i++;
                    extendLeft--;
                }
                inserted = inserted.slice(i);
                i = 1;
                while(extendRight > 0 && lastValue.length - i > lastSelectionStart - 1 && lastValue[lastValue.length - i] == value[value.length - i]){
                    i++;
                    extendRight--;
                }
                restoreStart -= i - 1;
                restoreEnd -= i - 1;
                var endIndex = inserted.length - i + 1;
                if (endIndex < 0) {
                    extendLeft = -endIndex;
                    endIndex = 0;
                }
                inserted = inserted.slice(0, endIndex);
                if (!fromInput && !inserted && !restoreStart && !extendLeft && !extendRight && !restoreEnd) return "";
                sendingText = true;
                var shouldReset = false;
                if (useragent.isAndroid && inserted == ". ") {
                    inserted = "  ";
                    shouldReset = true;
                }
                if (inserted && !extendLeft && !extendRight && !restoreStart && !restoreEnd || commandMode) host.onTextInput(inserted);
                else host.onTextInput(inserted, {
                    extendLeft: extendLeft,
                    extendRight: extendRight,
                    restoreStart: restoreStart,
                    restoreEnd: restoreEnd
                });
                sendingText = false;
                lastValue = value;
                lastSelectionStart = selectionStart;
                lastSelectionEnd = selectionEnd;
                lastRestoreEnd = restoreEnd;
                return shouldReset ? "\n" : inserted;
            }
        };
        var onInput = function(e) {
            if (inComposition) return onCompositionUpdate();
            if (e && e.inputType) {
                if (e.inputType == "historyUndo") return host.execCommand("undo");
                if (e.inputType == "historyRedo") return host.execCommand("redo");
            }
            var data = text.value;
            var inserted = sendText(data, true);
            if (data.length > MAX_LINE_LENGTH + 100 || valueResetRegex.test(inserted) || isMobile && lastSelectionStart < 1 && lastSelectionStart == lastSelectionEnd) resetSelection();
        };
        var handleClipboardData = function(e, data, forceIEMime) {
            var clipboardData = e.clipboardData || window["clipboardData"];
            if (!clipboardData || BROKEN_SETDATA) return;
            var mime = USE_IE_MIME_TYPE || forceIEMime ? "Text" : "text/plain";
            try {
                if (data) return clipboardData.setData(mime, data) !== false;
                else return clipboardData.getData(mime);
            } catch (e) {
                if (!forceIEMime) return handleClipboardData(e, data, true);
            }
        };
        var doCopy = function(e, isCut) {
            var data = host.getCopyText();
            if (!data) return event.preventDefault(e);
            if (handleClipboardData(e, data)) {
                if (isIOS) {
                    resetSelection(data);
                    copied = data;
                    setTimeout(function() {
                        copied = false;
                    }, 10);
                }
                isCut ? host.onCut() : host.onCopy();
                event.preventDefault(e);
            } else {
                copied = true;
                text.value = data;
                text.select();
                setTimeout(function() {
                    copied = false;
                    resetSelection();
                    isCut ? host.onCut() : host.onCopy();
                });
            }
        };
        var onCut = function(e) {
            doCopy(e, true);
        };
        var onCopy = function(e) {
            doCopy(e, false);
        };
        var onPaste = function(e) {
            var data = handleClipboardData(e);
            if (clipboard.pasteCancelled()) return;
            if (typeof data == "string") {
                if (data) host.onPaste(data, e);
                if (useragent.isIE) setTimeout(resetSelection);
                event.preventDefault(e);
            } else {
                text.value = "";
                pasted = true;
            }
        };
        event.addCommandKeyListener(text, function(e, hashId, keyCode) {
            if (inComposition) return;
            return host.onCommandKey(e, hashId, keyCode);
        }, host);
        event.addListener(text, "select", onSelect, host);
        event.addListener(text, "input", onInput, host);
        event.addListener(text, "cut", onCut, host);
        event.addListener(text, "copy", onCopy, host);
        event.addListener(text, "paste", onPaste, host);
        if (!("oncut" in text) || !("oncopy" in text) || !("onpaste" in text)) event.addListener(parentNode, "keydown", function(e) {
            if (useragent.isMac && !e.metaKey || !e.ctrlKey) return;
            switch(e.keyCode){
                case 67:
                    onCopy(e);
                    break;
                case 86:
                    onPaste(e);
                    break;
                case 88:
                    onCut(e);
                    break;
            }
        }, host);
        var onCompositionStart = function(e) {
            if (inComposition || !host.onCompositionStart || host.$readOnly) return;
            inComposition = {};
            if (commandMode) return;
            if (e.data) inComposition.useTextareaForIME = false;
            setTimeout(onCompositionUpdate, 0);
            host._signal("compositionStart");
            host.on("mousedown", cancelComposition);
            var range = host.getSelectionRange();
            range.end.row = range.start.row;
            range.end.column = range.start.column;
            inComposition.markerRange = range;
            inComposition.selectionStart = lastSelectionStart;
            host.onCompositionStart(inComposition);
            if (inComposition.useTextareaForIME) {
                lastValue = text.value = "";
                lastSelectionStart = 0;
                lastSelectionEnd = 0;
            } else {
                if (text.msGetInputContext) inComposition.context = text.msGetInputContext();
                if (text.getInputContext) inComposition.context = text.getInputContext();
            }
        };
        var onCompositionUpdate = function() {
            if (!inComposition || !host.onCompositionUpdate || host.$readOnly) return;
            if (commandMode) return cancelComposition();
            if (inComposition.useTextareaForIME) host.onCompositionUpdate(text.value);
            else {
                var data = text.value;
                sendText(data);
                if (inComposition.markerRange) {
                    if (inComposition.context) inComposition.markerRange.start.column = inComposition.selectionStart = inComposition.context.compositionStartOffset;
                    inComposition.markerRange.end.column = inComposition.markerRange.start.column + lastSelectionEnd - inComposition.selectionStart + lastRestoreEnd;
                }
            }
        };
        var onCompositionEnd = function(e) {
            if (!host.onCompositionEnd || host.$readOnly) return;
            inComposition = false;
            host.onCompositionEnd();
            host.off("mousedown", cancelComposition);
            if (e) onInput();
        };
        function cancelComposition() {
            ignoreFocusEvents = true;
            text.blur();
            text.focus();
            ignoreFocusEvents = false;
        }
        var syncComposition = lang.delayedCall(onCompositionUpdate, 50).schedule.bind(null, null);
        function onKeyup(e) {
            if (e.keyCode == 27 && text.value.length < text.selectionStart) {
                if (!inComposition) lastValue = text.value;
                lastSelectionStart = lastSelectionEnd = -1;
                resetSelection();
            }
            syncComposition();
        }
        event.addListener(text, "compositionstart", onCompositionStart, host);
        event.addListener(text, "compositionupdate", onCompositionUpdate, host);
        event.addListener(text, "keyup", onKeyup, host);
        event.addListener(text, "keydown", syncComposition, host);
        event.addListener(text, "compositionend", onCompositionEnd, host);
        this.getElement = function() {
            return text;
        };
        this.setCommandMode = function(value) {
            commandMode = value;
            text.readOnly = false;
        };
        this.setReadOnly = function(readOnly) {
            if (!commandMode) text.readOnly = readOnly;
        };
        this.setCopyWithEmptySelection = function(value) {};
        this.onContextMenu = function(e) {
            afterContextMenu = true;
            resetSelection();
            host._emit("nativecontextmenu", {
                target: host,
                domEvent: e
            });
            this.moveToMouse(e, true);
        };
        this.moveToMouse = function(e, bringToFront) {
            if (!tempStyle) tempStyle = text.style.cssText;
            text.style.cssText = (bringToFront ? "z-index:100000;" : "") + (useragent.isIE ? "opacity:0.1;" : "") + "text-indent: -" + (lastSelectionStart + lastSelectionEnd) * host.renderer.characterWidth * 0.5 + "px;";
            var rect = host.container.getBoundingClientRect();
            var style = dom.computedStyle(host.container);
            var top = rect.top + (parseInt(style.borderTopWidth) || 0);
            var left = rect.left + (parseInt(rect.borderLeftWidth) || 0);
            var maxTop = rect.bottom - top - text.clientHeight - 2;
            var move = function(e) {
                dom.translate(text, e.clientX - left - 2, Math.min(e.clientY - top - 2, maxTop));
            };
            move(e);
            if (e.type != "mousedown") return;
            host.renderer.$isMousePressed = true;
            clearTimeout(closeTimeout);
            if (useragent.isWin) event.capture(host.container, move, onContextMenuClose);
        };
        this.onContextMenuClose = onContextMenuClose;
        var closeTimeout;
        function onContextMenuClose() {
            clearTimeout(closeTimeout);
            closeTimeout = setTimeout(function() {
                if (tempStyle) {
                    text.style.cssText = tempStyle;
                    tempStyle = "";
                }
                host.renderer.$isMousePressed = false;
                if (host.renderer.$keepTextAreaAtCursor) host.renderer.$moveTextAreaToCursor();
            }, 0);
        }
        var onContextMenu = function(e) {
            host.textInput.onContextMenu(e);
            onContextMenuClose();
        };
        event.addListener(text, "mouseup", onContextMenu, host);
        event.addListener(text, "mousedown", function(e) {
            e.preventDefault();
            onContextMenuClose();
        }, host);
        event.addListener(host.renderer.scroller, "contextmenu", onContextMenu, host);
        event.addListener(text, "contextmenu", onContextMenu, host);
        if (isIOS) addIosSelectionHandler(parentNode, host, text);
        function addIosSelectionHandler(parentNode, host, text) {
            var typingResetTimeout = null;
            var typing = false;
            text.addEventListener("keydown", function(e) {
                if (typingResetTimeout) clearTimeout(typingResetTimeout);
                typing = true;
            }, true);
            text.addEventListener("keyup", function(e) {
                typingResetTimeout = setTimeout(function() {
                    typing = false;
                }, 100);
            }, true);
            var detectArrowKeys = function(e) {
                if (document.activeElement !== text) return;
                if (typing || inComposition || host.$mouseHandler.isMousePressed) return;
                if (copied) return;
                var selectionStart = text.selectionStart;
                var selectionEnd = text.selectionEnd;
                var key = null;
                var modifier = 0;
                if (selectionStart == 0) key = KEYS.up;
                else if (selectionStart == 1) key = KEYS.home;
                else if (selectionEnd > lastSelectionEnd && lastValue[selectionEnd] == "\n") key = KEYS.end;
                else if (selectionStart < lastSelectionStart && lastValue[selectionStart - 1] == " ") {
                    key = KEYS.left;
                    modifier = MODS.option;
                } else if (selectionStart < lastSelectionStart || selectionStart == lastSelectionStart && lastSelectionEnd != lastSelectionStart && selectionStart == selectionEnd) key = KEYS.left;
                else if (selectionEnd > lastSelectionEnd && lastValue.slice(0, selectionEnd).split("\n").length > 2) key = KEYS.down;
                else if (selectionEnd > lastSelectionEnd && lastValue[selectionEnd - 1] == " ") {
                    key = KEYS.right;
                    modifier = MODS.option;
                } else if (selectionEnd > lastSelectionEnd || selectionEnd == lastSelectionEnd && lastSelectionEnd != lastSelectionStart && selectionStart == selectionEnd) key = KEYS.right;
                if (selectionStart !== selectionEnd) modifier |= MODS.shift;
                if (key) {
                    var result = host.onCommandKey({}, modifier, key);
                    if (!result && host.commands) {
                        key = KEYS.keyCodeToString(key);
                        var command = host.commands.findKeyCommand(modifier, key);
                        if (command) host.execCommand(command);
                    }
                    lastSelectionStart = selectionStart;
                    lastSelectionEnd = selectionEnd;
                    resetSelection("");
                }
            };
            document.addEventListener("selectionchange", detectArrowKeys);
            host.on("destroy", function() {
                document.removeEventListener("selectionchange", detectArrowKeys);
            });
        }
        this.destroy = function() {
            if (text.parentElement) text.parentElement.removeChild(text);
        };
    };
    exports.TextInput = TextInput;
    exports.$setUserAgentForTests = function(_isMobile, _isIOS) {
        isMobile = _isMobile;
        isIOS = _isIOS;
    };
});
ace.define("ace/mouse/default_handlers", [
    "require",
    "exports",
    "module",
    "ace/lib/useragent"
], function(require, exports, module1) {
    "use strict";
    var useragent = require("../lib/useragent");
    var DRAG_OFFSET = 0; // pixels
    var SCROLL_COOLDOWN_T = 550; // milliseconds
    var DefaultHandlers = /** @class */ function() {
        function DefaultHandlers(mouseHandler) {
            mouseHandler.$clickSelection = null;
            var editor = mouseHandler.editor;
            editor.setDefaultHandler("mousedown", this.onMouseDown.bind(mouseHandler));
            editor.setDefaultHandler("dblclick", this.onDoubleClick.bind(mouseHandler));
            editor.setDefaultHandler("tripleclick", this.onTripleClick.bind(mouseHandler));
            editor.setDefaultHandler("quadclick", this.onQuadClick.bind(mouseHandler));
            editor.setDefaultHandler("mousewheel", this.onMouseWheel.bind(mouseHandler));
            var exports = [
                "select",
                "startSelect",
                "selectEnd",
                "selectAllEnd",
                "selectByWordsEnd",
                "selectByLinesEnd",
                "dragWait",
                "dragWaitEnd",
                "focusWait"
            ];
            exports.forEach(function(x) {
                mouseHandler[x] = this[x];
            }, this);
            mouseHandler["selectByLines"] = this.extendSelectionBy.bind(mouseHandler, "getLineRange");
            mouseHandler["selectByWords"] = this.extendSelectionBy.bind(mouseHandler, "getWordRange");
        }
        DefaultHandlers.prototype.onMouseDown = function(ev) {
            var inSelection = ev.inSelection();
            var pos = ev.getDocumentPosition();
            this.mousedownEvent = ev;
            var editor = this.editor;
            var button = ev.getButton();
            if (button !== 0) {
                var selectionRange = editor.getSelectionRange();
                var selectionEmpty = selectionRange.isEmpty();
                if (selectionEmpty || button == 1) editor.selection.moveToPosition(pos);
                if (button == 2) {
                    editor.textInput.onContextMenu(ev.domEvent);
                    if (!useragent.isMozilla) ev.preventDefault();
                }
                return;
            }
            this.mousedownEvent.time = Date.now();
            if (inSelection && !editor.isFocused()) {
                editor.focus();
                if (this.$focusTimeout && !this.$clickSelection && !editor.inMultiSelectMode) {
                    this.setState("focusWait");
                    this.captureMouse(ev);
                    return;
                }
            }
            this.captureMouse(ev);
            this.startSelect(pos, ev.domEvent._clicks > 1);
            return ev.preventDefault();
        };
        DefaultHandlers.prototype.startSelect = function(pos, waitForClickSelection) {
            pos = pos || this.editor.renderer.screenToTextCoordinates(this.x, this.y);
            var editor = this.editor;
            if (!this.mousedownEvent) return;
            if (this.mousedownEvent.getShiftKey()) editor.selection.selectToPosition(pos);
            else if (!waitForClickSelection) editor.selection.moveToPosition(pos);
            if (!waitForClickSelection) this.select();
            editor.setStyle("ace_selecting");
            this.setState("select");
        };
        DefaultHandlers.prototype.select = function() {
            var anchor, editor = this.editor;
            var cursor = editor.renderer.screenToTextCoordinates(this.x, this.y);
            if (this.$clickSelection) {
                var cmp = this.$clickSelection.comparePoint(cursor);
                if (cmp == -1) anchor = this.$clickSelection.end;
                else if (cmp == 1) anchor = this.$clickSelection.start;
                else {
                    var orientedRange = calcRangeOrientation(this.$clickSelection, cursor);
                    cursor = orientedRange.cursor;
                    anchor = orientedRange.anchor;
                }
                editor.selection.setSelectionAnchor(anchor.row, anchor.column);
            }
            editor.selection.selectToPosition(cursor);
            editor.renderer.scrollCursorIntoView();
        };
        DefaultHandlers.prototype.extendSelectionBy = function(unitName) {
            var anchor, editor = this.editor;
            var cursor = editor.renderer.screenToTextCoordinates(this.x, this.y);
            var range = editor.selection[unitName](cursor.row, cursor.column);
            if (this.$clickSelection) {
                var cmpStart = this.$clickSelection.comparePoint(range.start);
                var cmpEnd = this.$clickSelection.comparePoint(range.end);
                if (cmpStart == -1 && cmpEnd <= 0) {
                    anchor = this.$clickSelection.end;
                    if (range.end.row != cursor.row || range.end.column != cursor.column) cursor = range.start;
                } else if (cmpEnd == 1 && cmpStart >= 0) {
                    anchor = this.$clickSelection.start;
                    if (range.start.row != cursor.row || range.start.column != cursor.column) cursor = range.end;
                } else if (cmpStart == -1 && cmpEnd == 1) {
                    cursor = range.end;
                    anchor = range.start;
                } else {
                    var orientedRange = calcRangeOrientation(this.$clickSelection, cursor);
                    cursor = orientedRange.cursor;
                    anchor = orientedRange.anchor;
                }
                editor.selection.setSelectionAnchor(anchor.row, anchor.column);
            }
            editor.selection.selectToPosition(cursor);
            editor.renderer.scrollCursorIntoView();
        };
        DefaultHandlers.prototype.selectByLinesEnd = function() {
            this.$clickSelection = null;
            this.editor.unsetStyle("ace_selecting");
        };
        DefaultHandlers.prototype.focusWait = function() {
            var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
            var time = Date.now();
            if (distance > DRAG_OFFSET || time - this.mousedownEvent.time > this.$focusTimeout) this.startSelect(this.mousedownEvent.getDocumentPosition());
        };
        DefaultHandlers.prototype.onDoubleClick = function(ev) {
            var pos = ev.getDocumentPosition();
            var editor = this.editor;
            var session = editor.session;
            var range = session.getBracketRange(pos);
            if (range) {
                if (range.isEmpty()) {
                    range.start.column--;
                    range.end.column++;
                }
                this.setState("select");
            } else {
                range = editor.selection.getWordRange(pos.row, pos.column);
                this.setState("selectByWords");
            }
            this.$clickSelection = range;
            this.select();
        };
        DefaultHandlers.prototype.onTripleClick = function(ev) {
            var pos = ev.getDocumentPosition();
            var editor = this.editor;
            this.setState("selectByLines");
            var range = editor.getSelectionRange();
            if (range.isMultiLine() && range.contains(pos.row, pos.column)) {
                this.$clickSelection = editor.selection.getLineRange(range.start.row);
                this.$clickSelection.end = editor.selection.getLineRange(range.end.row).end;
            } else this.$clickSelection = editor.selection.getLineRange(pos.row);
            this.select();
        };
        DefaultHandlers.prototype.onQuadClick = function(ev) {
            var editor = this.editor;
            editor.selectAll();
            this.$clickSelection = editor.getSelectionRange();
            this.setState("selectAll");
        };
        DefaultHandlers.prototype.onMouseWheel = function(ev) {
            if (ev.getAccelKey()) return;
            if (ev.getShiftKey() && ev.wheelY && !ev.wheelX) {
                ev.wheelX = ev.wheelY;
                ev.wheelY = 0;
            }
            var editor = this.editor;
            if (!this.$lastScroll) this.$lastScroll = {
                t: 0,
                vx: 0,
                vy: 0,
                allowed: 0
            };
            var prevScroll = this.$lastScroll;
            var t = ev.domEvent.timeStamp;
            var dt = t - prevScroll.t;
            var vx = dt ? ev.wheelX / dt : prevScroll.vx;
            var vy = dt ? ev.wheelY / dt : prevScroll.vy;
            if (dt < SCROLL_COOLDOWN_T) {
                vx = (vx + prevScroll.vx) / 2;
                vy = (vy + prevScroll.vy) / 2;
            }
            var direction = Math.abs(vx / vy);
            var canScroll = false;
            if (direction >= 1 && editor.renderer.isScrollableBy(ev.wheelX * ev.speed, 0)) canScroll = true;
            if (direction <= 1 && editor.renderer.isScrollableBy(0, ev.wheelY * ev.speed)) canScroll = true;
            if (canScroll) prevScroll.allowed = t;
            else if (t - prevScroll.allowed < SCROLL_COOLDOWN_T) {
                var isSlower = Math.abs(vx) <= 1.5 * Math.abs(prevScroll.vx) && Math.abs(vy) <= 1.5 * Math.abs(prevScroll.vy);
                if (isSlower) {
                    canScroll = true;
                    prevScroll.allowed = t;
                } else prevScroll.allowed = 0;
            }
            prevScroll.t = t;
            prevScroll.vx = vx;
            prevScroll.vy = vy;
            if (canScroll) {
                editor.renderer.scrollBy(ev.wheelX * ev.speed, ev.wheelY * ev.speed);
                return ev.stop();
            }
        };
        return DefaultHandlers;
    }();
    DefaultHandlers.prototype.selectEnd = DefaultHandlers.prototype.selectByLinesEnd;
    DefaultHandlers.prototype.selectAllEnd = DefaultHandlers.prototype.selectByLinesEnd;
    DefaultHandlers.prototype.selectByWordsEnd = DefaultHandlers.prototype.selectByLinesEnd;
    exports.DefaultHandlers = DefaultHandlers;
    function calcDistance(ax, ay, bx, by) {
        return Math.sqrt(Math.pow(bx - ax, 2) + Math.pow(by - ay, 2));
    }
    function calcRangeOrientation(range, cursor) {
        if (range.start.row == range.end.row) var cmp = 2 * cursor.column - range.start.column - range.end.column;
        else if (range.start.row == range.end.row - 1 && !range.start.column && !range.end.column) var cmp = cursor.column - 4;
        else var cmp = 2 * cursor.row - range.start.row - range.end.row;
        if (cmp < 0) return {
            cursor: range.start,
            anchor: range.end
        };
        else return {
            cursor: range.end,
            anchor: range.start
        };
    }
});
ace.define("ace/lib/scroll", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    exports.preventParentScroll = function preventParentScroll(event) {
        event.stopPropagation();
        var target = event.currentTarget;
        var contentOverflows = target.scrollHeight > target.clientHeight;
        if (!contentOverflows) event.preventDefault();
    };
});
ace.define("ace/tooltip", [
    "require",
    "exports",
    "module",
    "ace/lib/dom",
    "ace/lib/event",
    "ace/range",
    "ace/lib/scroll"
], function(require, exports, module1) {
    "use strict";
    var __extends = this && this.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __values = this && this.__values || function(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function() {
                if (o && i >= o.length) o = void 0;
                return {
                    value: o && o[i++],
                    done: !o
                };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    var dom = require("./lib/dom");
    var event = require("./lib/event");
    var Range = require("./range").Range;
    var preventParentScroll = require("./lib/scroll").preventParentScroll;
    var CLASSNAME = "ace_tooltip";
    var Tooltip = /** @class */ function() {
        function Tooltip(parentNode) {
            this.isOpen = false;
            this.$element = null;
            this.$parentNode = parentNode;
        }
        Tooltip.prototype.$init = function() {
            this.$element = dom.createElement("div");
            this.$element.className = CLASSNAME;
            this.$element.style.display = "none";
            this.$parentNode.appendChild(this.$element);
            return this.$element;
        };
        Tooltip.prototype.getElement = function() {
            return this.$element || this.$init();
        };
        Tooltip.prototype.setText = function(text) {
            this.getElement().textContent = text;
        };
        Tooltip.prototype.setHtml = function(html) {
            this.getElement().innerHTML = html;
        };
        Tooltip.prototype.setPosition = function(x, y) {
            this.getElement().style.left = x + "px";
            this.getElement().style.top = y + "px";
        };
        Tooltip.prototype.setClassName = function(className) {
            dom.addCssClass(this.getElement(), className);
        };
        Tooltip.prototype.setTheme = function(theme) {
            this.$element.className = CLASSNAME + " " + (theme.isDark ? "ace_dark " : "") + (theme.cssClass || "");
        };
        Tooltip.prototype.show = function(text, x, y) {
            if (text != null) this.setText(text);
            if (x != null && y != null) this.setPosition(x, y);
            if (!this.isOpen) {
                this.getElement().style.display = "block";
                this.isOpen = true;
            }
        };
        Tooltip.prototype.hide = function(e) {
            if (this.isOpen) {
                this.getElement().style.display = "none";
                this.getElement().className = CLASSNAME;
                this.isOpen = false;
            }
        };
        Tooltip.prototype.getHeight = function() {
            return this.getElement().offsetHeight;
        };
        Tooltip.prototype.getWidth = function() {
            return this.getElement().offsetWidth;
        };
        Tooltip.prototype.destroy = function() {
            this.isOpen = false;
            if (this.$element && this.$element.parentNode) this.$element.parentNode.removeChild(this.$element);
        };
        return Tooltip;
    }();
    var PopupManager = /** @class */ function() {
        function PopupManager() {
            this.popups = [];
        }
        PopupManager.prototype.addPopup = function(popup) {
            this.popups.push(popup);
            this.updatePopups();
        };
        PopupManager.prototype.removePopup = function(popup) {
            var index = this.popups.indexOf(popup);
            if (index !== -1) {
                this.popups.splice(index, 1);
                this.updatePopups();
            }
        };
        PopupManager.prototype.updatePopups = function() {
            var e_1, _a, e_2, _b;
            this.popups.sort(function(a, b) {
                return b.priority - a.priority;
            });
            var visiblepopups = [];
            try {
                for(var _c = __values(this.popups), _d = _c.next(); !_d.done; _d = _c.next()){
                    var popup = _d.value;
                    var shouldDisplay = true;
                    try {
                        for(var visiblepopups_1 = (e_2 = void 0, __values(visiblepopups)), visiblepopups_1_1 = visiblepopups_1.next(); !visiblepopups_1_1.done; visiblepopups_1_1 = visiblepopups_1.next()){
                            var visiblePopup = visiblepopups_1_1.value;
                            if (this.doPopupsOverlap(visiblePopup, popup)) {
                                shouldDisplay = false;
                                break;
                            }
                        }
                    } catch (e_2_1) {
                        e_2 = {
                            error: e_2_1
                        };
                    } finally{
                        try {
                            if (visiblepopups_1_1 && !visiblepopups_1_1.done && (_b = visiblepopups_1.return)) _b.call(visiblepopups_1);
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                    }
                    if (shouldDisplay) visiblepopups.push(popup);
                    else popup.hide();
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        };
        PopupManager.prototype.doPopupsOverlap = function(popupA, popupB) {
            var rectA = popupA.getElement().getBoundingClientRect();
            var rectB = popupB.getElement().getBoundingClientRect();
            return rectA.left < rectB.right && rectA.right > rectB.left && rectA.top < rectB.bottom && rectA.bottom > rectB.top;
        };
        return PopupManager;
    }();
    var popupManager = new PopupManager();
    exports.popupManager = popupManager;
    exports.Tooltip = Tooltip;
    var HoverTooltip = /** @class */ function(_super) {
        __extends(HoverTooltip, _super);
        function HoverTooltip(parentNode) {
            if (parentNode === void 0) parentNode = document.body;
            var _this = _super.call(this, parentNode) || this;
            _this.timeout = undefined;
            _this.lastT = 0;
            _this.idleTime = 350;
            _this.lastEvent = undefined;
            _this.onMouseOut = _this.onMouseOut.bind(_this);
            _this.onMouseMove = _this.onMouseMove.bind(_this);
            _this.waitForHover = _this.waitForHover.bind(_this);
            _this.hide = _this.hide.bind(_this);
            var el = _this.getElement();
            el.style.whiteSpace = "pre-wrap";
            el.style.pointerEvents = "auto";
            el.addEventListener("mouseout", _this.onMouseOut);
            el.tabIndex = -1;
            el.addEventListener("blur", (function() {
                if (!el.contains(document.activeElement)) this.hide();
            }).bind(_this));
            el.addEventListener("wheel", preventParentScroll);
            return _this;
        }
        HoverTooltip.prototype.addToEditor = function(editor) {
            editor.on("mousemove", this.onMouseMove);
            editor.on("mousedown", this.hide);
            editor.renderer.getMouseEventTarget().addEventListener("mouseout", this.onMouseOut, true);
        };
        HoverTooltip.prototype.removeFromEditor = function(editor) {
            editor.off("mousemove", this.onMouseMove);
            editor.off("mousedown", this.hide);
            editor.renderer.getMouseEventTarget().removeEventListener("mouseout", this.onMouseOut, true);
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
        };
        HoverTooltip.prototype.onMouseMove = function(e, editor) {
            this.lastEvent = e;
            this.lastT = Date.now();
            var isMousePressed = editor.$mouseHandler.isMousePressed;
            if (this.isOpen) {
                var pos = this.lastEvent && this.lastEvent.getDocumentPosition();
                if (!this.range || !this.range.contains(pos.row, pos.column) || isMousePressed || this.isOutsideOfText(this.lastEvent)) this.hide();
            }
            if (this.timeout || isMousePressed) return;
            this.lastEvent = e;
            this.timeout = setTimeout(this.waitForHover, this.idleTime);
        };
        HoverTooltip.prototype.waitForHover = function() {
            if (this.timeout) clearTimeout(this.timeout);
            var dt = Date.now() - this.lastT;
            if (this.idleTime - dt > 10) {
                this.timeout = setTimeout(this.waitForHover, this.idleTime - dt);
                return;
            }
            this.timeout = null;
            if (this.lastEvent && !this.isOutsideOfText(this.lastEvent)) this.$gatherData(this.lastEvent, this.lastEvent.editor);
        };
        HoverTooltip.prototype.isOutsideOfText = function(e) {
            var editor = e.editor;
            var docPos = e.getDocumentPosition();
            var line = editor.session.getLine(docPos.row);
            if (docPos.column == line.length) {
                var screenPos = editor.renderer.pixelToScreenCoordinates(e.clientX, e.clientY);
                var clippedPos = editor.session.documentToScreenPosition(docPos.row, docPos.column);
                if (clippedPos.column != screenPos.column || clippedPos.row != screenPos.row) return true;
            }
            return false;
        };
        HoverTooltip.prototype.setDataProvider = function(value) {
            this.$gatherData = value;
        };
        HoverTooltip.prototype.showForRange = function(editor, range, domNode, startingEvent) {
            var MARGIN = 10;
            if (startingEvent && startingEvent != this.lastEvent) return;
            if (this.isOpen && document.activeElement == this.getElement()) return;
            var renderer = editor.renderer;
            if (!this.isOpen) {
                popupManager.addPopup(this);
                this.$registerCloseEvents();
                this.setTheme(renderer.theme);
            }
            this.isOpen = true;
            this.addMarker(range, editor.session);
            this.range = Range.fromPoints(range.start, range.end);
            var position = renderer.textToScreenCoordinates(range.start.row, range.start.column);
            var rect = renderer.scroller.getBoundingClientRect();
            if (position.pageX < rect.left) position.pageX = rect.left;
            var element = this.getElement();
            element.innerHTML = "";
            element.appendChild(domNode);
            element.style.maxHeight = "";
            element.style.display = "block";
            var labelHeight = element.clientHeight;
            var labelWidth = element.clientWidth;
            var spaceBelow = window.innerHeight - position.pageY - renderer.lineHeight;
            var isAbove = true;
            if (position.pageY - labelHeight < 0 && position.pageY < spaceBelow) isAbove = false;
            element.style.maxHeight = (isAbove ? position.pageY : spaceBelow) - MARGIN + "px";
            element.style.top = isAbove ? "" : position.pageY + renderer.lineHeight + "px";
            element.style.bottom = isAbove ? window.innerHeight - position.pageY + "px" : "";
            element.style.left = Math.min(position.pageX, window.innerWidth - labelWidth - MARGIN) + "px";
        };
        HoverTooltip.prototype.addMarker = function(range, session) {
            if (this.marker) this.$markerSession.removeMarker(this.marker);
            this.$markerSession = session;
            this.marker = session && session.addMarker(range, "ace_highlight-marker", "text");
        };
        HoverTooltip.prototype.hide = function(e) {
            if (!e && document.activeElement == this.getElement()) return;
            if (e && e.target && (e.type != "keydown" || e.ctrlKey || e.metaKey) && this.$element.contains(e.target)) return;
            this.lastEvent = null;
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = null;
            this.addMarker(null);
            if (this.isOpen) {
                this.$removeCloseEvents();
                this.getElement().style.display = "none";
                this.isOpen = false;
                popupManager.removePopup(this);
            }
        };
        HoverTooltip.prototype.$registerCloseEvents = function() {
            window.addEventListener("keydown", this.hide, true);
            window.addEventListener("wheel", this.hide, true);
            window.addEventListener("mousedown", this.hide, true);
        };
        HoverTooltip.prototype.$removeCloseEvents = function() {
            window.removeEventListener("keydown", this.hide, true);
            window.removeEventListener("wheel", this.hide, true);
            window.removeEventListener("mousedown", this.hide, true);
        };
        HoverTooltip.prototype.onMouseOut = function(e) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.lastEvent = null;
            if (!this.isOpen) return;
            if (!e.relatedTarget || this.getElement().contains(e.relatedTarget)) return;
            if (e && e.currentTarget.contains(e.relatedTarget)) return;
            if (!e.relatedTarget.classList.contains("ace_content")) this.hide();
        };
        return HoverTooltip;
    }(Tooltip);
    exports.HoverTooltip = HoverTooltip;
});
ace.define("ace/mouse/default_gutter_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/dom",
    "ace/lib/event",
    "ace/tooltip",
    "ace/config",
    "ace/lib/lang"
], function(require, exports, module1) {
    "use strict";
    var __extends = this && this.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __values = this && this.__values || function(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function() {
                if (o && i >= o.length) o = void 0;
                return {
                    value: o && o[i++],
                    done: !o
                };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    var dom = require("../lib/dom");
    var event = require("../lib/event");
    var Tooltip = require("../tooltip").Tooltip;
    var nls = require("../config").nls;
    var lang = require("../lib/lang");
    function GutterHandler(mouseHandler) {
        var editor = mouseHandler.editor;
        var gutter = editor.renderer.$gutterLayer;
        var tooltip = new GutterTooltip(editor);
        mouseHandler.editor.setDefaultHandler("guttermousedown", function(e) {
            if (!editor.isFocused() || e.getButton() != 0) return;
            var gutterRegion = gutter.getRegion(e);
            if (gutterRegion == "foldWidgets") return;
            var row = e.getDocumentPosition().row;
            var selection = editor.session.selection;
            if (e.getShiftKey()) selection.selectTo(row, 0);
            else {
                if (e.domEvent.detail == 2) {
                    editor.selectAll();
                    return e.preventDefault();
                }
                mouseHandler.$clickSelection = editor.selection.getLineRange(row);
            }
            mouseHandler.setState("selectByLines");
            mouseHandler.captureMouse(e);
            return e.preventDefault();
        });
        var tooltipTimeout, mouseEvent;
        function showTooltip() {
            var row = mouseEvent.getDocumentPosition().row;
            var maxRow = editor.session.getLength();
            if (row == maxRow) {
                var screenRow = editor.renderer.pixelToScreenCoordinates(0, mouseEvent.y).row;
                var pos = mouseEvent.$pos;
                if (screenRow > editor.session.documentToScreenRow(pos.row, pos.column)) return hideTooltip();
            }
            tooltip.showTooltip(row);
            if (!tooltip.isOpen) return;
            editor.on("mousewheel", hideTooltip);
            if (mouseHandler.$tooltipFollowsMouse) moveTooltip(mouseEvent);
            else {
                var gutterRow = mouseEvent.getGutterRow();
                var gutterCell = gutter.$lines.get(gutterRow);
                if (gutterCell) {
                    var gutterElement = gutterCell.element.querySelector(".ace_gutter_annotation");
                    var rect = gutterElement.getBoundingClientRect();
                    var style = tooltip.getElement().style;
                    style.left = rect.right + "px";
                    style.top = rect.bottom + "px";
                } else moveTooltip(mouseEvent);
            }
        }
        function hideTooltip() {
            if (tooltipTimeout) tooltipTimeout = clearTimeout(tooltipTimeout);
            if (tooltip.isOpen) {
                tooltip.hideTooltip();
                editor.off("mousewheel", hideTooltip);
            }
        }
        function moveTooltip(e) {
            tooltip.setPosition(e.x, e.y);
        }
        mouseHandler.editor.setDefaultHandler("guttermousemove", function(e) {
            var target = e.domEvent.target || e.domEvent.srcElement;
            if (dom.hasCssClass(target, "ace_fold-widget")) return hideTooltip();
            if (tooltip.isOpen && mouseHandler.$tooltipFollowsMouse) moveTooltip(e);
            mouseEvent = e;
            if (tooltipTimeout) return;
            tooltipTimeout = setTimeout(function() {
                tooltipTimeout = null;
                if (mouseEvent && !mouseHandler.isMousePressed) showTooltip();
                else hideTooltip();
            }, 50);
        });
        event.addListener(editor.renderer.$gutter, "mouseout", function(e) {
            mouseEvent = null;
            if (!tooltip.isOpen || tooltipTimeout) return;
            tooltipTimeout = setTimeout(function() {
                tooltipTimeout = null;
                hideTooltip();
            }, 50);
        }, editor);
        editor.on("changeSession", hideTooltip);
        editor.on("input", hideTooltip);
    }
    exports.GutterHandler = GutterHandler;
    var GutterTooltip = /** @class */ function(_super) {
        __extends(GutterTooltip, _super);
        function GutterTooltip(editor) {
            var _this = _super.call(this, editor.container) || this;
            _this.editor = editor;
            return _this;
        }
        GutterTooltip.prototype.setPosition = function(x, y) {
            var windowWidth = window.innerWidth || document.documentElement.clientWidth;
            var windowHeight = window.innerHeight || document.documentElement.clientHeight;
            var width = this.getWidth();
            var height = this.getHeight();
            x += 15;
            y += 15;
            if (x + width > windowWidth) x -= x + width - windowWidth;
            if (y + height > windowHeight) y -= 20 + height;
            Tooltip.prototype.setPosition.call(this, x, y);
        };
        Object.defineProperty(GutterTooltip, "annotationLabels", {
            get: function() {
                return {
                    error: {
                        singular: nls("gutter-tooltip.aria-label.error.singular", "error"),
                        plural: nls("gutter-tooltip.aria-label.error.plural", "errors")
                    },
                    warning: {
                        singular: nls("gutter-tooltip.aria-label.warning.singular", "warning"),
                        plural: nls("gutter-tooltip.aria-label.warning.plural", "warnings")
                    },
                    info: {
                        singular: nls("gutter-tooltip.aria-label.info.singular", "information message"),
                        plural: nls("gutter-tooltip.aria-label.info.plural", "information messages")
                    }
                };
            },
            enumerable: false,
            configurable: true
        });
        GutterTooltip.prototype.showTooltip = function(row) {
            var _a;
            var gutter = this.editor.renderer.$gutterLayer;
            var annotationsInRow = gutter.$annotations[row];
            var annotation;
            if (annotationsInRow) annotation = {
                displayText: Array.from(annotationsInRow.displayText),
                type: Array.from(annotationsInRow.type)
            };
            else annotation = {
                displayText: [],
                type: []
            };
            var fold = gutter.session.getFoldLine(row);
            if (fold && gutter.$showFoldedAnnotations) {
                var annotationsInFold = {
                    error: [],
                    warning: [],
                    info: []
                };
                var mostSevereAnnotationInFoldType;
                for(var i = row + 1; i <= fold.end.row; i++){
                    if (!gutter.$annotations[i]) continue;
                    for(var j = 0; j < gutter.$annotations[i].text.length; j++){
                        var annotationType = gutter.$annotations[i].type[j];
                        annotationsInFold[annotationType].push(gutter.$annotations[i].text[j]);
                        if (annotationType === "error") {
                            mostSevereAnnotationInFoldType = "error_fold";
                            continue;
                        }
                        if (annotationType === "warning") {
                            mostSevereAnnotationInFoldType = "warning_fold";
                            continue;
                        }
                    }
                }
                if (mostSevereAnnotationInFoldType === "error_fold" || mostSevereAnnotationInFoldType === "warning_fold") {
                    var summaryFoldedAnnotations = "".concat(GutterTooltip.annotationsToSummaryString(annotationsInFold), " in folded code.");
                    annotation.displayText.push(summaryFoldedAnnotations);
                    annotation.type.push(mostSevereAnnotationInFoldType);
                }
            }
            if (annotation.displayText.length === 0) return this.hide();
            var annotationMessages = {
                error: [],
                warning: [],
                info: []
            };
            var iconClassName = gutter.$useSvgGutterIcons ? "ace_icon_svg" : "ace_icon";
            for(var i = 0; i < annotation.displayText.length; i++){
                var lineElement = dom.createElement("span");
                var iconElement = dom.createElement("span");
                (_a = iconElement.classList).add.apply(_a, [
                    "ace_".concat(annotation.type[i]),
                    iconClassName
                ]);
                iconElement.setAttribute("aria-label", "".concat(GutterTooltip.annotationLabels[annotation.type[i].replace("_fold", "")].singular));
                iconElement.setAttribute("role", "img");
                iconElement.appendChild(dom.createTextNode(" "));
                lineElement.appendChild(iconElement);
                lineElement.appendChild(dom.createTextNode(annotation.displayText[i]));
                lineElement.appendChild(dom.createElement("br"));
                annotationMessages[annotation.type[i].replace("_fold", "")].push(lineElement);
            }
            var tooltipElement = this.getElement();
            dom.removeChildren(tooltipElement);
            annotationMessages.error.forEach(function(el) {
                return tooltipElement.appendChild(el);
            });
            annotationMessages.warning.forEach(function(el) {
                return tooltipElement.appendChild(el);
            });
            annotationMessages.info.forEach(function(el) {
                return tooltipElement.appendChild(el);
            });
            tooltipElement.setAttribute("aria-live", "polite");
            if (!this.isOpen) {
                this.setTheme(this.editor.renderer.theme);
                this.setClassName("ace_gutter-tooltip");
            }
            this.show();
            this.editor._signal("showGutterTooltip", this);
        };
        GutterTooltip.prototype.hideTooltip = function() {
            this.$element.removeAttribute("aria-live");
            this.hide();
            this.editor._signal("hideGutterTooltip", this);
        };
        GutterTooltip.annotationsToSummaryString = function(annotations) {
            var e_1, _a;
            var summary = [];
            var annotationTypes = [
                "error",
                "warning",
                "info"
            ];
            try {
                for(var annotationTypes_1 = __values(annotationTypes), annotationTypes_1_1 = annotationTypes_1.next(); !annotationTypes_1_1.done; annotationTypes_1_1 = annotationTypes_1.next()){
                    var annotationType = annotationTypes_1_1.value;
                    if (!annotations[annotationType].length) continue;
                    var label = annotations[annotationType].length === 1 ? GutterTooltip.annotationLabels[annotationType].singular : GutterTooltip.annotationLabels[annotationType].plural;
                    summary.push("".concat(annotations[annotationType].length, " ").concat(label));
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (annotationTypes_1_1 && !annotationTypes_1_1.done && (_a = annotationTypes_1.return)) _a.call(annotationTypes_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return summary.join(", ");
        };
        return GutterTooltip;
    }(Tooltip);
    exports.GutterTooltip = GutterTooltip;
});
ace.define("ace/mouse/mouse_event", [
    "require",
    "exports",
    "module",
    "ace/lib/event",
    "ace/lib/useragent"
], function(require, exports, module1) {
    "use strict";
    var event = require("../lib/event");
    var useragent = require("../lib/useragent");
    var MouseEvent = /** @class */ function() {
        function MouseEvent(domEvent, editor) {
            this.speed;
            this.wheelX;
            this.wheelY;
            this.domEvent = domEvent;
            this.editor = editor;
            this.x = this.clientX = domEvent.clientX;
            this.y = this.clientY = domEvent.clientY;
            this.$pos = null;
            this.$inSelection = null;
            this.propagationStopped = false;
            this.defaultPrevented = false;
        }
        MouseEvent.prototype.stopPropagation = function() {
            event.stopPropagation(this.domEvent);
            this.propagationStopped = true;
        };
        MouseEvent.prototype.preventDefault = function() {
            event.preventDefault(this.domEvent);
            this.defaultPrevented = true;
        };
        MouseEvent.prototype.stop = function() {
            this.stopPropagation();
            this.preventDefault();
        };
        MouseEvent.prototype.getDocumentPosition = function() {
            if (this.$pos) return this.$pos;
            this.$pos = this.editor.renderer.screenToTextCoordinates(this.clientX, this.clientY);
            return this.$pos;
        };
        MouseEvent.prototype.getGutterRow = function() {
            var documentRow = this.getDocumentPosition().row;
            var screenRow = this.editor.session.documentToScreenRow(documentRow, 0);
            var screenTopRow = this.editor.session.documentToScreenRow(this.editor.renderer.$gutterLayer.$lines.get(0).row, 0);
            return screenRow - screenTopRow;
        };
        MouseEvent.prototype.inSelection = function() {
            if (this.$inSelection !== null) return this.$inSelection;
            var editor = this.editor;
            var selectionRange = editor.getSelectionRange();
            if (selectionRange.isEmpty()) this.$inSelection = false;
            else {
                var pos = this.getDocumentPosition();
                this.$inSelection = selectionRange.contains(pos.row, pos.column);
            }
            return this.$inSelection;
        };
        MouseEvent.prototype.getButton = function() {
            return event.getButton(this.domEvent);
        };
        MouseEvent.prototype.getShiftKey = function() {
            return this.domEvent.shiftKey;
        };
        MouseEvent.prototype.getAccelKey = function() {
            return useragent.isMac ? this.domEvent.metaKey : this.domEvent.ctrlKey;
        };
        return MouseEvent;
    }();
    exports.MouseEvent = MouseEvent;
});
ace.define("ace/mouse/dragdrop_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/dom",
    "ace/lib/event",
    "ace/lib/useragent"
], function(require, exports, module1) {
    "use strict";
    var dom = require("../lib/dom");
    var event = require("../lib/event");
    var useragent = require("../lib/useragent");
    var AUTOSCROLL_DELAY = 200;
    var SCROLL_CURSOR_DELAY = 200;
    var SCROLL_CURSOR_HYSTERESIS = 5;
    function DragdropHandler(mouseHandler) {
        var editor = mouseHandler.editor;
        var dragImage = dom.createElement("div");
        dragImage.style.cssText = "top:-100px;position:absolute;z-index:2147483647;opacity:0.5";
        dragImage.textContent = "\xa0";
        var exports = [
            "dragWait",
            "dragWaitEnd",
            "startDrag",
            "dragReadyEnd",
            "onMouseDrag"
        ];
        exports.forEach(function(x) {
            mouseHandler[x] = this[x];
        }, this);
        editor.on("mousedown", this.onMouseDown.bind(mouseHandler));
        var mouseTarget = editor.container;
        var dragSelectionMarker, x, y;
        var timerId, range;
        var dragCursor, counter = 0;
        var dragOperation;
        var isInternal;
        var autoScrollStartTime;
        var cursorMovedTime;
        var cursorPointOnCaretMoved;
        this.onDragStart = function(e) {
            if (this.cancelDrag || !mouseTarget.draggable) {
                var self1 = this;
                setTimeout(function() {
                    self1.startSelect();
                    self1.captureMouse(e);
                }, 0);
                return e.preventDefault();
            }
            range = editor.getSelectionRange();
            var dataTransfer = e.dataTransfer;
            dataTransfer.effectAllowed = editor.getReadOnly() ? "copy" : "copyMove";
            editor.container.appendChild(dragImage);
            dataTransfer.setDragImage && dataTransfer.setDragImage(dragImage, 0, 0);
            setTimeout(function() {
                editor.container.removeChild(dragImage);
            });
            dataTransfer.clearData();
            dataTransfer.setData("Text", editor.session.getTextRange());
            isInternal = true;
            this.setState("drag");
        };
        this.onDragEnd = function(e) {
            mouseTarget.draggable = false;
            isInternal = false;
            this.setState(null);
            if (!editor.getReadOnly()) {
                var dropEffect = e.dataTransfer.dropEffect;
                if (!dragOperation && dropEffect == "move") editor.session.remove(editor.getSelectionRange());
                editor.$resetCursorStyle();
            }
            this.editor.unsetStyle("ace_dragging");
            this.editor.renderer.setCursorStyle("");
        };
        this.onDragEnter = function(e) {
            if (editor.getReadOnly() || !canAccept(e.dataTransfer)) return;
            x = e.clientX;
            y = e.clientY;
            if (!dragSelectionMarker) addDragMarker();
            counter++;
            e.dataTransfer.dropEffect = dragOperation = getDropEffect(e);
            return event.preventDefault(e);
        };
        this.onDragOver = function(e) {
            if (editor.getReadOnly() || !canAccept(e.dataTransfer)) return;
            x = e.clientX;
            y = e.clientY;
            if (!dragSelectionMarker) {
                addDragMarker();
                counter++;
            }
            if (onMouseMoveTimer !== null) onMouseMoveTimer = null;
            e.dataTransfer.dropEffect = dragOperation = getDropEffect(e);
            return event.preventDefault(e);
        };
        this.onDragLeave = function(e) {
            counter--;
            if (counter <= 0 && dragSelectionMarker) {
                clearDragMarker();
                dragOperation = null;
                return event.preventDefault(e);
            }
        };
        this.onDrop = function(e) {
            if (!dragCursor) return;
            var dataTransfer = e.dataTransfer;
            if (isInternal) switch(dragOperation){
                case "move":
                    if (range.contains(dragCursor.row, dragCursor.column)) range = {
                        start: dragCursor,
                        end: dragCursor
                    };
                    else range = editor.moveText(range, dragCursor);
                    break;
                case "copy":
                    range = editor.moveText(range, dragCursor, true);
                    break;
            }
            else {
                var dropData = dataTransfer.getData("Text");
                range = {
                    start: dragCursor,
                    end: editor.session.insert(dragCursor, dropData)
                };
                editor.focus();
                dragOperation = null;
            }
            clearDragMarker();
            return event.preventDefault(e);
        };
        event.addListener(mouseTarget, "dragstart", this.onDragStart.bind(mouseHandler), editor);
        event.addListener(mouseTarget, "dragend", this.onDragEnd.bind(mouseHandler), editor);
        event.addListener(mouseTarget, "dragenter", this.onDragEnter.bind(mouseHandler), editor);
        event.addListener(mouseTarget, "dragover", this.onDragOver.bind(mouseHandler), editor);
        event.addListener(mouseTarget, "dragleave", this.onDragLeave.bind(mouseHandler), editor);
        event.addListener(mouseTarget, "drop", this.onDrop.bind(mouseHandler), editor);
        function scrollCursorIntoView(cursor, prevCursor) {
            var now = Date.now();
            var vMovement = !prevCursor || cursor.row != prevCursor.row;
            var hMovement = !prevCursor || cursor.column != prevCursor.column;
            if (!cursorMovedTime || vMovement || hMovement) {
                editor.moveCursorToPosition(cursor);
                cursorMovedTime = now;
                cursorPointOnCaretMoved = {
                    x: x,
                    y: y
                };
            } else {
                var distance = calcDistance(cursorPointOnCaretMoved.x, cursorPointOnCaretMoved.y, x, y);
                if (distance > SCROLL_CURSOR_HYSTERESIS) cursorMovedTime = null;
                else if (now - cursorMovedTime >= SCROLL_CURSOR_DELAY) {
                    editor.renderer.scrollCursorIntoView();
                    cursorMovedTime = null;
                }
            }
        }
        function autoScroll(cursor, prevCursor) {
            var now = Date.now();
            var lineHeight = editor.renderer.layerConfig.lineHeight;
            var characterWidth = editor.renderer.layerConfig.characterWidth;
            var editorRect = editor.renderer.scroller.getBoundingClientRect();
            var offsets = {
                x: {
                    left: x - editorRect.left,
                    right: editorRect.right - x
                },
                y: {
                    top: y - editorRect.top,
                    bottom: editorRect.bottom - y
                }
            };
            var nearestXOffset = Math.min(offsets.x.left, offsets.x.right);
            var nearestYOffset = Math.min(offsets.y.top, offsets.y.bottom);
            var scrollCursor = {
                row: cursor.row,
                column: cursor.column
            };
            if (nearestXOffset / characterWidth <= 2) scrollCursor.column += offsets.x.left < offsets.x.right ? -3 : 2;
            if (nearestYOffset / lineHeight <= 1) scrollCursor.row += offsets.y.top < offsets.y.bottom ? -1 : 1;
            var vScroll = cursor.row != scrollCursor.row;
            var hScroll = cursor.column != scrollCursor.column;
            var vMovement = !prevCursor || cursor.row != prevCursor.row;
            if (vScroll || hScroll && !vMovement) {
                if (!autoScrollStartTime) autoScrollStartTime = now;
                else if (now - autoScrollStartTime >= AUTOSCROLL_DELAY) editor.renderer.scrollCursorIntoView(scrollCursor);
            } else autoScrollStartTime = null;
        }
        function onDragInterval() {
            var prevCursor = dragCursor;
            dragCursor = editor.renderer.screenToTextCoordinates(x, y);
            scrollCursorIntoView(dragCursor, prevCursor);
            autoScroll(dragCursor, prevCursor);
        }
        function addDragMarker() {
            range = editor.selection.toOrientedRange();
            dragSelectionMarker = editor.session.addMarker(range, "ace_selection", editor.getSelectionStyle());
            editor.clearSelection();
            if (editor.isFocused()) editor.renderer.$cursorLayer.setBlinking(false);
            clearInterval(timerId);
            onDragInterval();
            timerId = setInterval(onDragInterval, 20);
            counter = 0;
            event.addListener(document, "mousemove", onMouseMove);
        }
        function clearDragMarker() {
            clearInterval(timerId);
            editor.session.removeMarker(dragSelectionMarker);
            dragSelectionMarker = null;
            editor.selection.fromOrientedRange(range);
            if (editor.isFocused() && !isInternal) editor.$resetCursorStyle();
            range = null;
            dragCursor = null;
            counter = 0;
            autoScrollStartTime = null;
            cursorMovedTime = null;
            event.removeListener(document, "mousemove", onMouseMove);
        }
        var onMouseMoveTimer = null;
        function onMouseMove() {
            if (onMouseMoveTimer == null) onMouseMoveTimer = setTimeout(function() {
                if (onMouseMoveTimer != null && dragSelectionMarker) clearDragMarker();
            }, 20);
        }
        function canAccept(dataTransfer) {
            var types = dataTransfer.types;
            return !types || Array.prototype.some.call(types, function(type) {
                return type == "text/plain" || type == "Text";
            });
        }
        function getDropEffect(e) {
            var copyAllowed = [
                "copy",
                "copymove",
                "all",
                "uninitialized"
            ];
            var moveAllowed = [
                "move",
                "copymove",
                "linkmove",
                "all",
                "uninitialized"
            ];
            var copyModifierState = useragent.isMac ? e.altKey : e.ctrlKey;
            var effectAllowed = "uninitialized";
            try {
                effectAllowed = e.dataTransfer.effectAllowed.toLowerCase();
            } catch (e) {}
            var dropEffect = "none";
            if (copyModifierState && copyAllowed.indexOf(effectAllowed) >= 0) dropEffect = "copy";
            else if (moveAllowed.indexOf(effectAllowed) >= 0) dropEffect = "move";
            else if (copyAllowed.indexOf(effectAllowed) >= 0) dropEffect = "copy";
            return dropEffect;
        }
    }
    (function() {
        this.dragWait = function() {
            var interval = Date.now() - this.mousedownEvent.time;
            if (interval > this.editor.getDragDelay()) this.startDrag();
        };
        this.dragWaitEnd = function() {
            var target = this.editor.container;
            target.draggable = false;
            this.startSelect(this.mousedownEvent.getDocumentPosition());
            this.selectEnd();
        };
        this.dragReadyEnd = function(e) {
            this.editor.$resetCursorStyle();
            this.editor.unsetStyle("ace_dragging");
            this.editor.renderer.setCursorStyle("");
            this.dragWaitEnd();
        };
        this.startDrag = function() {
            this.cancelDrag = false;
            var editor = this.editor;
            var target = editor.container;
            target.draggable = true;
            editor.renderer.$cursorLayer.setBlinking(false);
            editor.setStyle("ace_dragging");
            var cursorStyle = useragent.isWin ? "default" : "move";
            editor.renderer.setCursorStyle(cursorStyle);
            this.setState("dragReady");
        };
        this.onMouseDrag = function(e) {
            var target = this.editor.container;
            if (useragent.isIE && this.state == "dragReady") {
                var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
                if (distance > 3) target.dragDrop();
            }
            if (this.state === "dragWait") {
                var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
                if (distance > 0) {
                    target.draggable = false;
                    this.startSelect(this.mousedownEvent.getDocumentPosition());
                }
            }
        };
        this.onMouseDown = function(e) {
            if (!this.$dragEnabled) return;
            this.mousedownEvent = e;
            var editor = this.editor;
            var inSelection = e.inSelection();
            var button = e.getButton();
            var clickCount = e.domEvent.detail || 1;
            if (clickCount === 1 && button === 0 && inSelection) {
                if (e.editor.inMultiSelectMode && (e.getAccelKey() || e.getShiftKey())) return;
                this.mousedownEvent.time = Date.now();
                var eventTarget = e.domEvent.target || e.domEvent.srcElement;
                if ("unselectable" in eventTarget) eventTarget.unselectable = "on";
                if (editor.getDragDelay()) {
                    if (useragent.isWebKit) {
                        this.cancelDrag = true;
                        var mouseTarget = editor.container;
                        mouseTarget.draggable = true;
                    }
                    this.setState("dragWait");
                } else this.startDrag();
                this.captureMouse(e, this.onMouseDrag.bind(this));
                e.defaultPrevented = true;
            }
        };
    }).call(DragdropHandler.prototype);
    function calcDistance(ax, ay, bx, by) {
        return Math.sqrt(Math.pow(bx - ax, 2) + Math.pow(by - ay, 2));
    }
    exports.DragdropHandler = DragdropHandler;
});
ace.define("ace/mouse/touch_handler", [
    "require",
    "exports",
    "module",
    "ace/mouse/mouse_event",
    "ace/lib/event",
    "ace/lib/dom"
], function(require, exports, module1) {
    "use strict";
    var MouseEvent = require("./mouse_event").MouseEvent;
    var event = require("../lib/event");
    var dom = require("../lib/dom");
    exports.addTouchListeners = function(el, editor) {
        var mode = "scroll";
        var startX;
        var startY;
        var touchStartT;
        var lastT;
        var longTouchTimer;
        var animationTimer;
        var animationSteps = 0;
        var pos;
        var clickCount = 0;
        var vX = 0;
        var vY = 0;
        var pressed;
        var contextMenu;
        function createContextMenu() {
            var clipboard = window.navigator && window.navigator.clipboard;
            var isOpen = false;
            var updateMenu = function() {
                var selected = editor.getCopyText();
                var hasUndo = editor.session.getUndoManager().hasUndo();
                contextMenu.replaceChild(dom.buildDom(isOpen ? [
                    "span",
                    !selected && canExecuteCommand("selectall") && [
                        "span",
                        {
                            class: "ace_mobile-button",
                            action: "selectall"
                        },
                        "Select All"
                    ],
                    selected && canExecuteCommand("copy") && [
                        "span",
                        {
                            class: "ace_mobile-button",
                            action: "copy"
                        },
                        "Copy"
                    ],
                    selected && canExecuteCommand("cut") && [
                        "span",
                        {
                            class: "ace_mobile-button",
                            action: "cut"
                        },
                        "Cut"
                    ],
                    clipboard && canExecuteCommand("paste") && [
                        "span",
                        {
                            class: "ace_mobile-button",
                            action: "paste"
                        },
                        "Paste"
                    ],
                    hasUndo && canExecuteCommand("undo") && [
                        "span",
                        {
                            class: "ace_mobile-button",
                            action: "undo"
                        },
                        "Undo"
                    ],
                    canExecuteCommand("find") && [
                        "span",
                        {
                            class: "ace_mobile-button",
                            action: "find"
                        },
                        "Find"
                    ],
                    canExecuteCommand("openCommandPalette") && [
                        "span",
                        {
                            class: "ace_mobile-button",
                            action: "openCommandPalette"
                        },
                        "Palette"
                    ]
                ] : [
                    "span"
                ]), contextMenu.firstChild);
            };
            var canExecuteCommand = function(/** @type {string} */ cmd) {
                return editor.commands.canExecute(cmd, editor);
            };
            var handleClick = function(e) {
                var action = e.target.getAttribute("action");
                if (action == "more" || !isOpen) {
                    isOpen = !isOpen;
                    return updateMenu();
                }
                if (action == "paste") clipboard.readText().then(function(text) {
                    editor.execCommand(action, text);
                });
                else if (action) {
                    if (action == "cut" || action == "copy") {
                        if (clipboard) clipboard.writeText(editor.getCopyText());
                        else document.execCommand("copy");
                    }
                    editor.execCommand(action);
                }
                contextMenu.firstChild.style.display = "none";
                isOpen = false;
                if (action != "openCommandPalette") editor.focus();
            };
            contextMenu = dom.buildDom([
                "div",
                {
                    class: "ace_mobile-menu",
                    ontouchstart: function(e) {
                        mode = "menu";
                        e.stopPropagation();
                        e.preventDefault();
                        editor.textInput.focus();
                    },
                    ontouchend: function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        handleClick(e);
                    },
                    onclick: handleClick
                },
                [
                    "span"
                ],
                [
                    "span",
                    {
                        class: "ace_mobile-button",
                        action: "more"
                    },
                    "..."
                ]
            ], editor.container);
        }
        function showContextMenu() {
            if (!editor.getOption("enableMobileMenu")) {
                if (contextMenu) hideContextMenu();
                return;
            }
            if (!contextMenu) createContextMenu();
            var cursor = editor.selection.cursor;
            var pagePos = editor.renderer.textToScreenCoordinates(cursor.row, cursor.column);
            var leftOffset = editor.renderer.textToScreenCoordinates(0, 0).pageX;
            var scrollLeft = editor.renderer.scrollLeft;
            var rect = editor.container.getBoundingClientRect();
            contextMenu.style.top = pagePos.pageY - rect.top - 3 + "px";
            if (pagePos.pageX - rect.left < rect.width - 70) {
                contextMenu.style.left = "";
                contextMenu.style.right = "10px";
            } else {
                contextMenu.style.right = "";
                contextMenu.style.left = leftOffset + scrollLeft - rect.left + "px";
            }
            contextMenu.style.display = "";
            contextMenu.firstChild.style.display = "none";
            editor.on("input", hideContextMenu);
        }
        function hideContextMenu(e) {
            if (contextMenu) contextMenu.style.display = "none";
            editor.off("input", hideContextMenu);
        }
        function handleLongTap() {
            longTouchTimer = null;
            clearTimeout(longTouchTimer);
            var range = editor.selection.getRange();
            var inSelection = range.contains(pos.row, pos.column);
            if (range.isEmpty() || !inSelection) {
                editor.selection.moveToPosition(pos);
                editor.selection.selectWord();
            }
            mode = "wait";
            showContextMenu();
        }
        function switchToSelectionMode() {
            longTouchTimer = null;
            clearTimeout(longTouchTimer);
            editor.selection.moveToPosition(pos);
            var range = clickCount >= 2 ? editor.selection.getLineRange(pos.row) : editor.session.getBracketRange(pos);
            if (range && !range.isEmpty()) editor.selection.setRange(range);
            else editor.selection.selectWord();
            mode = "wait";
        }
        event.addListener(el, "contextmenu", function(e) {
            if (!pressed) return;
            var textarea = editor.textInput.getElement();
            textarea.focus();
        }, editor);
        event.addListener(el, "touchstart", function(e) {
            var touches = e.touches;
            if (longTouchTimer || touches.length > 1) {
                clearTimeout(longTouchTimer);
                longTouchTimer = null;
                touchStartT = -1;
                mode = "zoom";
                return;
            }
            pressed = editor.$mouseHandler.isMousePressed = true;
            var h = editor.renderer.layerConfig.lineHeight;
            var w = editor.renderer.layerConfig.lineHeight;
            var t = e.timeStamp;
            lastT = t;
            var touchObj = touches[0];
            var x = touchObj.clientX;
            var y = touchObj.clientY;
            if (Math.abs(startX - x) + Math.abs(startY - y) > h) touchStartT = -1;
            startX = e.clientX = x;
            startY = e.clientY = y;
            vX = vY = 0;
            var ev = new MouseEvent(e, editor);
            pos = ev.getDocumentPosition();
            if (t - touchStartT < 500 && touches.length == 1 && !animationSteps) {
                clickCount++;
                e.preventDefault();
                e.button = 0;
                switchToSelectionMode();
            } else {
                clickCount = 0;
                var cursor = editor.selection.cursor;
                var anchor = editor.selection.isEmpty() ? cursor : editor.selection.anchor;
                var cursorPos = editor.renderer.$cursorLayer.getPixelPosition(cursor, true);
                var anchorPos = editor.renderer.$cursorLayer.getPixelPosition(anchor, true);
                var rect = editor.renderer.scroller.getBoundingClientRect();
                var offsetTop = editor.renderer.layerConfig.offset;
                var offsetLeft = editor.renderer.scrollLeft;
                var weightedDistance = function(x, y) {
                    x = x / w;
                    y = y / h - 0.75;
                    return x * x + y * y;
                };
                if (e.clientX < rect.left) {
                    mode = "zoom";
                    return;
                }
                var diff1 = weightedDistance(e.clientX - rect.left - cursorPos.left + offsetLeft, e.clientY - rect.top - cursorPos.top + offsetTop);
                var diff2 = weightedDistance(e.clientX - rect.left - anchorPos.left + offsetLeft, e.clientY - rect.top - anchorPos.top + offsetTop);
                if (diff1 < 3.5 && diff2 < 3.5) mode = diff1 > diff2 ? "cursor" : "anchor";
                if (diff2 < 3.5) mode = "anchor";
                else if (diff1 < 3.5) mode = "cursor";
                else mode = "scroll";
                longTouchTimer = setTimeout(handleLongTap, 450);
            }
            touchStartT = t;
        }, editor);
        event.addListener(el, "touchend", function(e) {
            pressed = editor.$mouseHandler.isMousePressed = false;
            if (animationTimer) clearInterval(animationTimer);
            if (mode == "zoom") {
                mode = "";
                animationSteps = 0;
            } else if (longTouchTimer) {
                editor.selection.moveToPosition(pos);
                animationSteps = 0;
                showContextMenu();
            } else if (mode == "scroll") {
                animate();
                hideContextMenu();
            } else showContextMenu();
            clearTimeout(longTouchTimer);
            longTouchTimer = null;
        }, editor);
        event.addListener(el, "touchmove", function(e) {
            if (longTouchTimer) {
                clearTimeout(longTouchTimer);
                longTouchTimer = null;
            }
            var touches = e.touches;
            if (touches.length > 1 || mode == "zoom") return;
            var touchObj = touches[0];
            var wheelX = startX - touchObj.clientX;
            var wheelY = startY - touchObj.clientY;
            if (mode == "wait") {
                if (wheelX * wheelX + wheelY * wheelY > 4) mode = "cursor";
                else return e.preventDefault();
            }
            startX = touchObj.clientX;
            startY = touchObj.clientY;
            e.clientX = touchObj.clientX;
            e.clientY = touchObj.clientY;
            var t = e.timeStamp;
            var dt = t - lastT;
            lastT = t;
            if (mode == "scroll") {
                var mouseEvent = new MouseEvent(e, editor);
                mouseEvent.speed = 1;
                mouseEvent.wheelX = wheelX;
                mouseEvent.wheelY = wheelY;
                if (10 * Math.abs(wheelX) < Math.abs(wheelY)) wheelX = 0;
                if (10 * Math.abs(wheelY) < Math.abs(wheelX)) wheelY = 0;
                if (dt != 0) {
                    vX = wheelX / dt;
                    vY = wheelY / dt;
                }
                editor._emit("mousewheel", mouseEvent);
                if (!mouseEvent.propagationStopped) vX = vY = 0;
            } else {
                var ev = new MouseEvent(e, editor);
                var pos = ev.getDocumentPosition();
                if (mode == "cursor") editor.selection.moveCursorToPosition(pos);
                else if (mode == "anchor") editor.selection.setSelectionAnchor(pos.row, pos.column);
                editor.renderer.scrollCursorIntoView(pos);
                e.preventDefault();
            }
        }, editor);
        function animate() {
            animationSteps += 60;
            animationTimer = setInterval(function() {
                if (animationSteps-- <= 0) {
                    clearInterval(animationTimer);
                    animationTimer = null;
                }
                if (Math.abs(vX) < 0.01) vX = 0;
                if (Math.abs(vY) < 0.01) vY = 0;
                if (animationSteps < 20) vX = 0.9 * vX;
                if (animationSteps < 20) vY = 0.9 * vY;
                var oldScrollTop = editor.session.getScrollTop();
                editor.renderer.scrollBy(10 * vX, 10 * vY);
                if (oldScrollTop == editor.session.getScrollTop()) animationSteps = 0;
            }, 10);
        }
    };
});
ace.define("ace/mouse/mouse_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/event",
    "ace/lib/useragent",
    "ace/mouse/default_handlers",
    "ace/mouse/default_gutter_handler",
    "ace/mouse/mouse_event",
    "ace/mouse/dragdrop_handler",
    "ace/mouse/touch_handler",
    "ace/config"
], function(require, exports, module1) {
    "use strict";
    var event = require("../lib/event");
    var useragent = require("../lib/useragent");
    var DefaultHandlers = require("./default_handlers").DefaultHandlers;
    var DefaultGutterHandler = require("./default_gutter_handler").GutterHandler;
    var MouseEvent = require("./mouse_event").MouseEvent;
    var DragdropHandler = require("./dragdrop_handler").DragdropHandler;
    var addTouchListeners = require("./touch_handler").addTouchListeners;
    var config = require("../config");
    var MouseHandler = /** @class */ function() {
        function MouseHandler(editor) {
            this.$dragDelay;
            this.$dragEnabled;
            this.$mouseMoved;
            this.mouseEvent;
            this.$focusTimeout;
            var _self = this;
            this.editor = editor;
            new DefaultHandlers(this);
            new DefaultGutterHandler(this);
            new DragdropHandler(this);
            var focusEditor = function(e) {
                var windowBlurred = !document.hasFocus || !document.hasFocus() || !editor.isFocused() && document.activeElement == (editor.textInput && editor.textInput.getElement());
                if (windowBlurred) window.focus();
                editor.focus();
                setTimeout(function() {
                    if (!editor.isFocused()) editor.focus();
                });
            };
            var mouseTarget = editor.renderer.getMouseEventTarget();
            event.addListener(mouseTarget, "click", this.onMouseEvent.bind(this, "click"), editor);
            event.addListener(mouseTarget, "mousemove", this.onMouseMove.bind(this, "mousemove"), editor);
            event.addMultiMouseDownListener([
                mouseTarget,
                editor.renderer.scrollBarV && editor.renderer.scrollBarV.inner,
                editor.renderer.scrollBarH && editor.renderer.scrollBarH.inner,
                editor.textInput && editor.textInput.getElement()
            ].filter(Boolean), [
                400,
                300,
                250
            ], this, "onMouseEvent", editor);
            event.addMouseWheelListener(editor.container, this.onMouseWheel.bind(this, "mousewheel"), editor);
            addTouchListeners(editor.container, editor);
            var gutterEl = editor.renderer.$gutter;
            event.addListener(gutterEl, "mousedown", this.onMouseEvent.bind(this, "guttermousedown"), editor);
            event.addListener(gutterEl, "click", this.onMouseEvent.bind(this, "gutterclick"), editor);
            event.addListener(gutterEl, "dblclick", this.onMouseEvent.bind(this, "gutterdblclick"), editor);
            event.addListener(gutterEl, "mousemove", this.onMouseEvent.bind(this, "guttermousemove"), editor);
            event.addListener(mouseTarget, "mousedown", focusEditor, editor);
            event.addListener(gutterEl, "mousedown", focusEditor, editor);
            if (useragent.isIE && editor.renderer.scrollBarV) {
                event.addListener(editor.renderer.scrollBarV.element, "mousedown", focusEditor, editor);
                event.addListener(editor.renderer.scrollBarH.element, "mousedown", focusEditor, editor);
            }
            editor.on("mousemove", function(e) {
                if (_self.state || _self.$dragDelay || !_self.$dragEnabled) return;
                var character = editor.renderer.screenToTextCoordinates(e.x, e.y);
                var range = editor.session.selection.getRange();
                var renderer = editor.renderer;
                if (!range.isEmpty() && range.insideStart(character.row, character.column)) renderer.setCursorStyle("default");
                else renderer.setCursorStyle("");
            }, editor);
        }
        MouseHandler.prototype.onMouseEvent = function(name, e) {
            if (!this.editor.session) return;
            this.editor._emit(name, new MouseEvent(e, this.editor));
        };
        MouseHandler.prototype.onMouseMove = function(name, e) {
            var listeners = this.editor._eventRegistry && this.editor._eventRegistry.mousemove;
            if (!listeners || !listeners.length) return;
            this.editor._emit(name, new MouseEvent(e, this.editor));
        };
        MouseHandler.prototype.onMouseWheel = function(name, e) {
            var mouseEvent = new MouseEvent(e, this.editor);
            mouseEvent.speed = this.$scrollSpeed * 2;
            mouseEvent.wheelX = e.wheelX;
            mouseEvent.wheelY = e.wheelY;
            this.editor._emit(name, mouseEvent);
        };
        MouseHandler.prototype.setState = function(state) {
            this.state = state;
        };
        MouseHandler.prototype.captureMouse = function(ev, mouseMoveHandler) {
            this.x = ev.x;
            this.y = ev.y;
            this.isMousePressed = true;
            var editor = this.editor;
            var renderer = this.editor.renderer;
            renderer.$isMousePressed = true;
            var self1 = this;
            var onMouseMove = function(e) {
                if (!e) return;
                if (useragent.isWebKit && !e.which && self1.releaseMouse) return self1.releaseMouse();
                self1.x = e.clientX;
                self1.y = e.clientY;
                mouseMoveHandler && mouseMoveHandler(e);
                self1.mouseEvent = new MouseEvent(e, self1.editor);
                self1.$mouseMoved = true;
            };
            var onCaptureEnd = function(e) {
                editor.off("beforeEndOperation", onOperationEnd);
                clearInterval(timerId);
                if (editor.session) onCaptureInterval();
                self1[self1.state + "End"] && self1[self1.state + "End"](e);
                self1.state = "";
                self1.isMousePressed = renderer.$isMousePressed = false;
                if (renderer.$keepTextAreaAtCursor) renderer.$moveTextAreaToCursor();
                self1.$onCaptureMouseMove = self1.releaseMouse = null;
                e && self1.onMouseEvent("mouseup", e);
                editor.endOperation();
            };
            var onCaptureInterval = function() {
                self1[self1.state] && self1[self1.state]();
                self1.$mouseMoved = false;
            };
            if (useragent.isOldIE && ev.domEvent.type == "dblclick") return setTimeout(function() {
                onCaptureEnd(ev);
            });
            var onOperationEnd = function(e) {
                if (!self1.releaseMouse) return;
                if (editor.curOp.command.name && editor.curOp.selectionChanged) {
                    self1[self1.state + "End"] && self1[self1.state + "End"]();
                    self1.state = "";
                    self1.releaseMouse();
                }
            };
            editor.on("beforeEndOperation", onOperationEnd);
            editor.startOperation({
                command: {
                    name: "mouse"
                }
            });
            self1.$onCaptureMouseMove = onMouseMove;
            self1.releaseMouse = event.capture(this.editor.container, onMouseMove, onCaptureEnd);
            var timerId = setInterval(onCaptureInterval, 20);
        };
        MouseHandler.prototype.cancelContextMenu = function() {
            var stop = (function(e) {
                if (e && e.domEvent && e.domEvent.type != "contextmenu") return;
                this.editor.off("nativecontextmenu", stop);
                if (e && e.domEvent) event.stopEvent(e.domEvent);
            }).bind(this);
            setTimeout(stop, 10);
            this.editor.on("nativecontextmenu", stop);
        };
        MouseHandler.prototype.destroy = function() {
            if (this.releaseMouse) this.releaseMouse();
        };
        return MouseHandler;
    }();
    MouseHandler.prototype.releaseMouse = null;
    config.defineOptions(MouseHandler.prototype, "mouseHandler", {
        scrollSpeed: {
            initialValue: 2
        },
        dragDelay: {
            initialValue: useragent.isMac ? 150 : 0
        },
        dragEnabled: {
            initialValue: true
        },
        focusTimeout: {
            initialValue: 0
        },
        tooltipFollowsMouse: {
            initialValue: true
        }
    });
    exports.MouseHandler = MouseHandler;
});
ace.define("ace/mouse/fold_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/dom"
], function(require, exports, module1) {
    "use strict";
    var dom = require("../lib/dom");
    var FoldHandler = /** @class */ function() {
        function FoldHandler(editor) {
            editor.on("click", function(e) {
                var position = e.getDocumentPosition();
                var session = editor.session;
                var fold = session.getFoldAt(position.row, position.column, 1);
                if (fold) {
                    if (e.getAccelKey()) session.removeFold(fold);
                    else session.expandFold(fold);
                    e.stop();
                }
                var target = e.domEvent && e.domEvent.target;
                if (target && dom.hasCssClass(target, "ace_inline_button")) {
                    if (dom.hasCssClass(target, "ace_toggle_wrap")) {
                        session.setOption("wrap", !session.getUseWrapMode());
                        editor.renderer.scrollCursorIntoView();
                    }
                }
            });
            editor.on("gutterclick", function(e) {
                var gutterRegion = editor.renderer.$gutterLayer.getRegion(e);
                if (gutterRegion == "foldWidgets") {
                    var row = e.getDocumentPosition().row;
                    var session = editor.session;
                    if (session.foldWidgets && session.foldWidgets[row]) editor.session.onFoldWidgetClick(row, e);
                    if (!editor.isFocused()) editor.focus();
                    e.stop();
                }
            });
            editor.on("gutterdblclick", function(e) {
                var gutterRegion = editor.renderer.$gutterLayer.getRegion(e);
                if (gutterRegion == "foldWidgets") {
                    var row = e.getDocumentPosition().row;
                    var session = editor.session;
                    var data = session.getParentFoldRangeData(row, true);
                    var range = data.range || data.firstRange;
                    if (range) {
                        row = range.start.row;
                        var fold = session.getFoldAt(row, session.getLine(row).length, 1);
                        if (fold) session.removeFold(fold);
                        else {
                            session.addFold("...", range);
                            editor.renderer.scrollCursorIntoView({
                                row: range.start.row,
                                column: 0
                            });
                        }
                    }
                    e.stop();
                }
            });
        }
        return FoldHandler;
    }();
    exports.FoldHandler = FoldHandler;
});
ace.define("ace/keyboard/keybinding", [
    "require",
    "exports",
    "module",
    "ace/lib/keys",
    "ace/lib/event"
], function(require, exports, module1) {
    "use strict";
    var keyUtil = require("../lib/keys");
    var event = require("../lib/event");
    var KeyBinding = /** @class */ function() {
        function KeyBinding(editor) {
            this.$editor = editor;
            this.$data = {
                editor: editor
            };
            this.$handlers = [];
            this.setDefaultHandler(editor.commands);
        }
        KeyBinding.prototype.setDefaultHandler = function(kb) {
            this.removeKeyboardHandler(this.$defaultHandler);
            this.$defaultHandler = kb;
            this.addKeyboardHandler(kb, 0);
        };
        KeyBinding.prototype.setKeyboardHandler = function(kb) {
            var h = this.$handlers;
            if (h[h.length - 1] == kb) return;
            while(h[h.length - 1] && h[h.length - 1] != this.$defaultHandler)this.removeKeyboardHandler(h[h.length - 1]);
            this.addKeyboardHandler(kb, 1);
        };
        KeyBinding.prototype.addKeyboardHandler = function(kb, pos) {
            if (!kb) return;
            if (typeof kb == "function" && !kb.handleKeyboard) kb.handleKeyboard = kb;
            var i = this.$handlers.indexOf(kb);
            if (i != -1) this.$handlers.splice(i, 1);
            if (pos == undefined) this.$handlers.push(kb);
            else this.$handlers.splice(pos, 0, kb);
            if (i == -1 && kb.attach) kb.attach(this.$editor);
        };
        KeyBinding.prototype.removeKeyboardHandler = function(kb) {
            var i = this.$handlers.indexOf(kb);
            if (i == -1) return false;
            this.$handlers.splice(i, 1);
            kb.detach && kb.detach(this.$editor);
            return true;
        };
        KeyBinding.prototype.getKeyboardHandler = function() {
            return this.$handlers[this.$handlers.length - 1];
        };
        KeyBinding.prototype.getStatusText = function() {
            var data = this.$data;
            var editor = data.editor;
            return this.$handlers.map(function(h) {
                return h.getStatusText && h.getStatusText(editor, data) || "";
            }).filter(Boolean).join(" ");
        };
        KeyBinding.prototype.$callKeyboardHandlers = function(hashId, keyString, keyCode, e) {
            var toExecute;
            var success = false;
            var commands = this.$editor.commands;
            for(var i = this.$handlers.length; i--;){
                toExecute = this.$handlers[i].handleKeyboard(this.$data, hashId, keyString, keyCode, e);
                if (!toExecute || !toExecute.command) continue;
                if (toExecute.command == "null") success = true;
                else success = commands.exec(toExecute.command, this.$editor, toExecute.args, e);
                if (success && e && hashId != -1 && toExecute["passEvent"] != true && toExecute.command["passEvent"] != true) event.stopEvent(e);
                if (success) break;
            }
            if (!success && hashId == -1) {
                toExecute = {
                    command: "insertstring"
                };
                success = commands.exec("insertstring", this.$editor, keyString);
            }
            if (success && this.$editor._signal) this.$editor._signal("keyboardActivity", toExecute);
            return success;
        };
        KeyBinding.prototype.onCommandKey = function(e, hashId, keyCode) {
            var keyString = keyUtil.keyCodeToString(keyCode);
            return this.$callKeyboardHandlers(hashId, keyString, keyCode, e);
        };
        KeyBinding.prototype.onTextInput = function(text) {
            return this.$callKeyboardHandlers(-1, text);
        };
        return KeyBinding;
    }();
    exports.KeyBinding = KeyBinding;
});
ace.define("ace/lib/bidiutil", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var ArabicAlefBetIntervalsBegine = [
        "\u0621",
        "\u0641"
    ];
    var ArabicAlefBetIntervalsEnd = [
        "\u063A",
        "\u064A"
    ];
    var dir = 0, hiLevel = 0;
    var lastArabic = false, hasUBAT_AL = false, hasUBAT_B = false, hasUBAT_S = false, hasBlockSep = false, hasSegSep = false;
    var impTab_LTR = [
        [
            0,
            3,
            0,
            1,
            0,
            0,
            0
        ],
        [
            0,
            3,
            0,
            1,
            2,
            2,
            0
        ],
        [
            0,
            3,
            0,
            0x11,
            2,
            0,
            1
        ],
        [
            0,
            3,
            5,
            5,
            4,
            1,
            0
        ],
        [
            0,
            3,
            0x15,
            0x15,
            4,
            0,
            1
        ],
        [
            0,
            3,
            5,
            5,
            4,
            2,
            0
        ]
    ];
    var impTab_RTL = [
        [
            2,
            0,
            1,
            1,
            0,
            1,
            0
        ],
        [
            2,
            0,
            1,
            1,
            0,
            2,
            0
        ],
        [
            2,
            0,
            2,
            1,
            3,
            2,
            0
        ],
        [
            2,
            0,
            2,
            0x21,
            3,
            1,
            1
        ]
    ];
    var LTR = 0, RTL = 1;
    var L = 0;
    var R = 1;
    var EN = 2;
    var AN = 3;
    var ON = 4;
    var B = 5;
    var S = 6;
    var AL = 7;
    var WS = 8;
    var CS = 9;
    var ES = 10;
    var ET = 11;
    var NSM = 12;
    var LRE = 13;
    var RLE = 14;
    var PDF = 15;
    var LRO = 16;
    var RLO = 17;
    var BN = 18;
    var UnicodeTBL00 = [
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        S,
        B,
        S,
        WS,
        B,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        B,
        B,
        B,
        S,
        WS,
        ON,
        ON,
        ET,
        ET,
        ET,
        ON,
        ON,
        ON,
        ON,
        ON,
        ES,
        CS,
        ES,
        CS,
        CS,
        EN,
        EN,
        EN,
        EN,
        EN,
        EN,
        EN,
        EN,
        EN,
        EN,
        CS,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        ON,
        ON,
        ON,
        ON,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        B,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        CS,
        ON,
        ET,
        ET,
        ET,
        ET,
        ON,
        ON,
        ON,
        ON,
        L,
        ON,
        ON,
        BN,
        ON,
        ON,
        ET,
        ET,
        EN,
        EN,
        ON,
        L,
        ON,
        ON,
        ON,
        EN,
        L,
        ON,
        ON,
        ON,
        ON,
        ON
    ];
    var UnicodeTBL20 = [
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        BN,
        BN,
        BN,
        L,
        R,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        WS,
        B,
        LRE,
        RLE,
        PDF,
        LRO,
        RLO,
        CS,
        ET,
        ET,
        ET,
        ET,
        ET,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        CS,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        WS
    ];
    function _computeLevels(chars, levels, len, charTypes) {
        var impTab = dir ? impTab_RTL : impTab_LTR, prevState = null, newClass = null, newLevel = null, newState = 0, action = null, cond = null, condPos = -1, i = null, ix = null, classes = [];
        if (!charTypes) for(i = 0, charTypes = []; i < len; i++)charTypes[i] = _getCharacterType(chars[i]);
        hiLevel = dir;
        lastArabic = false;
        hasUBAT_AL = false;
        hasUBAT_B = false;
        hasUBAT_S = false;
        for(ix = 0; ix < len; ix++){
            prevState = newState;
            classes[ix] = newClass = _getCharClass(chars, charTypes, classes, ix);
            newState = impTab[prevState][newClass];
            action = newState & 0xF0;
            newState &= 0x0F;
            levels[ix] = newLevel = impTab[newState][5];
            if (action > 0) {
                if (action == 0x10) {
                    for(i = condPos; i < ix; i++)levels[i] = 1;
                    condPos = -1;
                } else condPos = -1;
            }
            cond = impTab[newState][6];
            if (cond) {
                if (condPos == -1) condPos = ix;
            } else if (condPos > -1) {
                for(i = condPos; i < ix; i++)levels[i] = newLevel;
                condPos = -1;
            }
            if (charTypes[ix] == B) levels[ix] = 0;
            hiLevel |= newLevel;
        }
        if (hasUBAT_S) {
            for(i = 0; i < len; i++)if (charTypes[i] == S) {
                levels[i] = dir;
                for(var j = i - 1; j >= 0; j--){
                    if (charTypes[j] == WS) levels[j] = dir;
                    else break;
                }
            }
        }
    }
    function _invertLevel(lev, levels, _array) {
        if (hiLevel < lev) return;
        if (lev == 1 && dir == RTL && !hasUBAT_B) {
            _array.reverse();
            return;
        }
        var len = _array.length, start = 0, end, lo, hi, tmp;
        while(start < len){
            if (levels[start] >= lev) {
                end = start + 1;
                while(end < len && levels[end] >= lev)end++;
                for(lo = start, hi = end - 1; lo < hi; lo++, hi--){
                    tmp = _array[lo];
                    _array[lo] = _array[hi];
                    _array[hi] = tmp;
                }
                start = end;
            }
            start++;
        }
    }
    function _getCharClass(chars, types, classes, ix) {
        var cType = types[ix], wType, nType, len, i;
        switch(cType){
            case L:
            case R:
                lastArabic = false;
            case ON:
            case AN:
                return cType;
            case EN:
                return lastArabic ? AN : EN;
            case AL:
                lastArabic = true;
                hasUBAT_AL = true;
                return R;
            case WS:
                return ON;
            case CS:
                if (ix < 1 || ix + 1 >= types.length || (wType = classes[ix - 1]) != EN && wType != AN || (nType = types[ix + 1]) != EN && nType != AN) return ON;
                if (lastArabic) nType = AN;
                return nType == wType ? nType : ON;
            case ES:
                wType = ix > 0 ? classes[ix - 1] : B;
                if (wType == EN && ix + 1 < types.length && types[ix + 1] == EN) return EN;
                return ON;
            case ET:
                if (ix > 0 && classes[ix - 1] == EN) return EN;
                if (lastArabic) return ON;
                i = ix + 1;
                len = types.length;
                while(i < len && types[i] == ET)i++;
                if (i < len && types[i] == EN) return EN;
                return ON;
            case NSM:
                len = types.length;
                i = ix + 1;
                while(i < len && types[i] == NSM)i++;
                if (i < len) {
                    var c = chars[ix], rtlCandidate = c >= 0x0591 && c <= 0x08FF || c == 0xFB1E;
                    wType = types[i];
                    if (rtlCandidate && (wType == R || wType == AL)) return R;
                }
                if (ix < 1 || (wType = types[ix - 1]) == B) return ON;
                return classes[ix - 1];
            case B:
                lastArabic = false;
                hasUBAT_B = true;
                return dir;
            case S:
                hasUBAT_S = true;
                return ON;
            case LRE:
            case RLE:
            case LRO:
            case RLO:
            case PDF:
                lastArabic = false;
            case BN:
                return ON;
        }
    }
    function _getCharacterType(ch) {
        var uc = ch.charCodeAt(0), hi = uc >> 8;
        if (hi == 0) return uc > 0x00BF ? L : UnicodeTBL00[uc];
        else if (hi == 5) return /[\u0591-\u05f4]/.test(ch) ? R : L;
        else if (hi == 6) {
            if (/[\u0610-\u061a\u064b-\u065f\u06d6-\u06e4\u06e7-\u06ed]/.test(ch)) return NSM;
            else if (/[\u0660-\u0669\u066b-\u066c]/.test(ch)) return AN;
            else if (uc == 0x066A) return ET;
            else if (/[\u06f0-\u06f9]/.test(ch)) return EN;
            else return AL;
        } else if (hi == 0x20 && uc <= 0x205F) return UnicodeTBL20[uc & 0xFF];
        else if (hi == 0xFE) return uc >= 0xFE70 ? AL : ON;
        return ON;
    }
    function _isArabicDiacritics(ch) {
        return ch >= "\u064B" && ch <= "\u0655";
    }
    exports.L = L;
    exports.R = R;
    exports.EN = EN;
    exports.ON_R = 3;
    exports.AN = 4;
    exports.R_H = 5;
    exports.B = 6;
    exports.RLE = 7;
    exports.DOT = "\xb7";
    exports.doBidiReorder = function(text, textCharTypes, isRtl) {
        if (text.length < 2) return {};
        var chars = text.split(""), logicalFromVisual = new Array(chars.length), bidiLevels = new Array(chars.length), levels = [];
        dir = isRtl ? RTL : LTR;
        _computeLevels(chars, levels, chars.length, textCharTypes);
        for(var i = 0; i < logicalFromVisual.length; logicalFromVisual[i] = i, i++);
        _invertLevel(2, levels, logicalFromVisual);
        _invertLevel(1, levels, logicalFromVisual);
        for(var i = 0; i < logicalFromVisual.length - 1; i++){
            if (textCharTypes[i] === AN) levels[i] = exports.AN;
            else if (levels[i] === R && (textCharTypes[i] > AL && textCharTypes[i] < LRE || textCharTypes[i] === ON || textCharTypes[i] === BN)) levels[i] = exports.ON_R;
            else if (i > 0 && chars[i - 1] === "\u0644" && /\u0622|\u0623|\u0625|\u0627/.test(chars[i])) {
                levels[i - 1] = levels[i] = exports.R_H;
                i++;
            }
        }
        if (chars[chars.length - 1] === exports.DOT) levels[chars.length - 1] = exports.B;
        if (chars[0] === "\u202B") levels[0] = exports.RLE;
        for(var i = 0; i < logicalFromVisual.length; i++)bidiLevels[i] = levels[logicalFromVisual[i]];
        return {
            "logicalFromVisual": logicalFromVisual,
            "bidiLevels": bidiLevels
        };
    };
    exports.hasBidiCharacters = function(text, textCharTypes) {
        var ret = false;
        for(var i = 0; i < text.length; i++){
            textCharTypes[i] = _getCharacterType(text.charAt(i));
            if (!ret && (textCharTypes[i] == R || textCharTypes[i] == AL || textCharTypes[i] == AN)) ret = true;
        }
        return ret;
    };
    exports.getVisualFromLogicalIdx = function(logIdx, rowMap) {
        for(var i = 0; i < rowMap.logicalFromVisual.length; i++){
            if (rowMap.logicalFromVisual[i] == logIdx) return i;
        }
        return 0;
    };
});
ace.define("ace/bidihandler", [
    "require",
    "exports",
    "module",
    "ace/lib/bidiutil",
    "ace/lib/lang"
], function(require, exports, module1) {
    "use strict";
    var bidiUtil = require("./lib/bidiutil");
    var lang = require("./lib/lang");
    var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\u202B]/;
    var BidiHandler = /** @class */ function() {
        function BidiHandler(session) {
            this.session = session;
            this.bidiMap = {};
            this.currentRow = null;
            this.bidiUtil = bidiUtil;
            this.charWidths = [];
            this.EOL = "\xac";
            this.showInvisibles = true;
            this.isRtlDir = false;
            this.$isRtl = false;
            this.line = "";
            this.wrapIndent = 0;
            this.EOF = "\xb6";
            this.RLE = "\u202B";
            this.contentWidth = 0;
            this.fontMetrics = null;
            this.rtlLineOffset = 0;
            this.wrapOffset = 0;
            this.isMoveLeftOperation = false;
            this.seenBidi = bidiRE.test(session.getValue());
        }
        BidiHandler.prototype.isBidiRow = function(screenRow, docRow, splitIndex) {
            if (!this.seenBidi) return false;
            if (screenRow !== this.currentRow) {
                this.currentRow = screenRow;
                this.updateRowLine(docRow, splitIndex);
                this.updateBidiMap();
            }
            return this.bidiMap.bidiLevels;
        };
        BidiHandler.prototype.onChange = function(delta) {
            if (!this.seenBidi) {
                if (delta.action == "insert" && bidiRE.test(delta.lines.join("\n"))) {
                    this.seenBidi = true;
                    this.currentRow = null;
                }
            } else this.currentRow = null;
        };
        BidiHandler.prototype.getDocumentRow = function() {
            var docRow = 0;
            var rowCache = this.session.$screenRowCache;
            if (rowCache.length) {
                var index = this.session.$getRowCacheIndex(rowCache, this.currentRow);
                if (index >= 0) docRow = this.session.$docRowCache[index];
            }
            return docRow;
        };
        BidiHandler.prototype.getSplitIndex = function() {
            var splitIndex = 0;
            var rowCache = this.session.$screenRowCache;
            if (rowCache.length) {
                var currentIndex, prevIndex = this.session.$getRowCacheIndex(rowCache, this.currentRow);
                while(this.currentRow - splitIndex > 0){
                    currentIndex = this.session.$getRowCacheIndex(rowCache, this.currentRow - splitIndex - 1);
                    if (currentIndex !== prevIndex) break;
                    prevIndex = currentIndex;
                    splitIndex++;
                }
            } else splitIndex = this.currentRow;
            return splitIndex;
        };
        BidiHandler.prototype.updateRowLine = function(docRow, splitIndex) {
            if (docRow === undefined) docRow = this.getDocumentRow();
            var isLastRow = docRow === this.session.getLength() - 1, endOfLine = isLastRow ? this.EOF : this.EOL;
            this.wrapIndent = 0;
            this.line = this.session.getLine(docRow);
            this.isRtlDir = this.$isRtl || this.line.charAt(0) === this.RLE;
            if (this.session.$useWrapMode) {
                var splits = this.session.$wrapData[docRow];
                if (splits) {
                    if (splitIndex === undefined) splitIndex = this.getSplitIndex();
                    if (splitIndex > 0 && splits.length) {
                        this.wrapIndent = splits.indent;
                        this.wrapOffset = this.wrapIndent * this.charWidths[bidiUtil.L];
                        this.line = splitIndex < splits.length ? this.line.substring(splits[splitIndex - 1], splits[splitIndex]) : this.line.substring(splits[splits.length - 1]);
                    } else this.line = this.line.substring(0, splits[splitIndex]);
                    if (splitIndex == splits.length) this.line += this.showInvisibles ? endOfLine : bidiUtil.DOT;
                }
            } else this.line += this.showInvisibles ? endOfLine : bidiUtil.DOT;
            var session = this.session, shift = 0, size;
            this.line = this.line.replace(/\t|[\u1100-\u2029, \u202F-\uFFE6]/g, function(ch, i) {
                if (ch === "	" || session.isFullWidth(ch.charCodeAt(0))) {
                    size = ch === "	" ? session.getScreenTabSize(i + shift) : 2;
                    shift += size - 1;
                    return lang.stringRepeat(bidiUtil.DOT, size);
                }
                return ch;
            });
            if (this.isRtlDir) {
                this.fontMetrics.$main.textContent = this.line.charAt(this.line.length - 1) == bidiUtil.DOT ? this.line.substr(0, this.line.length - 1) : this.line;
                this.rtlLineOffset = this.contentWidth - this.fontMetrics.$main.getBoundingClientRect().width;
            }
        };
        BidiHandler.prototype.updateBidiMap = function() {
            var textCharTypes = [];
            if (bidiUtil.hasBidiCharacters(this.line, textCharTypes) || this.isRtlDir) this.bidiMap = bidiUtil.doBidiReorder(this.line, textCharTypes, this.isRtlDir);
            else this.bidiMap = {};
        };
        BidiHandler.prototype.markAsDirty = function() {
            this.currentRow = null;
        };
        BidiHandler.prototype.updateCharacterWidths = function(fontMetrics) {
            if (this.characterWidth === fontMetrics.$characterSize.width) return;
            this.fontMetrics = fontMetrics;
            var characterWidth = this.characterWidth = fontMetrics.$characterSize.width;
            var bidiCharWidth = fontMetrics.$measureCharWidth("\u05D4");
            this.charWidths[bidiUtil.L] = this.charWidths[bidiUtil.EN] = this.charWidths[bidiUtil.ON_R] = characterWidth;
            this.charWidths[bidiUtil.R] = this.charWidths[bidiUtil.AN] = bidiCharWidth;
            this.charWidths[bidiUtil.R_H] = bidiCharWidth * 0.45;
            this.charWidths[bidiUtil.B] = this.charWidths[bidiUtil.RLE] = 0;
            this.currentRow = null;
        };
        BidiHandler.prototype.setShowInvisibles = function(showInvisibles) {
            this.showInvisibles = showInvisibles;
            this.currentRow = null;
        };
        BidiHandler.prototype.setEolChar = function(eolChar) {
            this.EOL = eolChar;
        };
        BidiHandler.prototype.setContentWidth = function(width) {
            this.contentWidth = width;
        };
        BidiHandler.prototype.isRtlLine = function(row) {
            if (this.$isRtl) return true;
            if (row != undefined) return this.session.getLine(row).charAt(0) == this.RLE;
            else return this.isRtlDir;
        };
        BidiHandler.prototype.setRtlDirection = function(editor, isRtlDir) {
            var cursor = editor.getCursorPosition();
            for(var row = editor.selection.getSelectionAnchor().row; row <= cursor.row; row++){
                if (!isRtlDir && editor.session.getLine(row).charAt(0) === editor.session.$bidiHandler.RLE) editor.session.doc.removeInLine(row, 0, 1);
                else if (isRtlDir && editor.session.getLine(row).charAt(0) !== editor.session.$bidiHandler.RLE) editor.session.doc.insert({
                    column: 0,
                    row: row
                }, editor.session.$bidiHandler.RLE);
            }
        };
        BidiHandler.prototype.getPosLeft = function(col) {
            col -= this.wrapIndent;
            var leftBoundary = this.line.charAt(0) === this.RLE ? 1 : 0;
            var logicalIdx = col > leftBoundary ? this.session.getOverwrite() ? col : col - 1 : leftBoundary;
            var visualIdx = bidiUtil.getVisualFromLogicalIdx(logicalIdx, this.bidiMap), levels = this.bidiMap.bidiLevels, left = 0;
            if (!this.session.getOverwrite() && col <= leftBoundary && levels[visualIdx] % 2 !== 0) visualIdx++;
            for(var i = 0; i < visualIdx; i++)left += this.charWidths[levels[i]];
            if (!this.session.getOverwrite() && col > leftBoundary && levels[visualIdx] % 2 === 0) left += this.charWidths[levels[visualIdx]];
            if (this.wrapIndent) left += this.isRtlDir ? -1 * this.wrapOffset : this.wrapOffset;
            if (this.isRtlDir) left += this.rtlLineOffset;
            return left;
        };
        BidiHandler.prototype.getSelections = function(startCol, endCol) {
            var map = this.bidiMap, levels = map.bidiLevels, level, selections = [], offset = 0, selColMin = Math.min(startCol, endCol) - this.wrapIndent, selColMax = Math.max(startCol, endCol) - this.wrapIndent, isSelected = false, isSelectedPrev = false, selectionStart = 0;
            if (this.wrapIndent) offset += this.isRtlDir ? -1 * this.wrapOffset : this.wrapOffset;
            for(var logIdx, visIdx = 0; visIdx < levels.length; visIdx++){
                logIdx = map.logicalFromVisual[visIdx];
                level = levels[visIdx];
                isSelected = logIdx >= selColMin && logIdx < selColMax;
                if (isSelected && !isSelectedPrev) selectionStart = offset;
                else if (!isSelected && isSelectedPrev) selections.push({
                    left: selectionStart,
                    width: offset - selectionStart
                });
                offset += this.charWidths[level];
                isSelectedPrev = isSelected;
            }
            if (isSelected && visIdx === levels.length) selections.push({
                left: selectionStart,
                width: offset - selectionStart
            });
            if (this.isRtlDir) for(var i = 0; i < selections.length; i++)selections[i].left += this.rtlLineOffset;
            return selections;
        };
        BidiHandler.prototype.offsetToCol = function(posX) {
            if (this.isRtlDir) posX -= this.rtlLineOffset;
            var logicalIdx = 0, posX = Math.max(posX, 0), offset = 0, visualIdx = 0, levels = this.bidiMap.bidiLevels, charWidth = this.charWidths[levels[visualIdx]];
            if (this.wrapIndent) posX -= this.isRtlDir ? -1 * this.wrapOffset : this.wrapOffset;
            while(posX > offset + charWidth / 2){
                offset += charWidth;
                if (visualIdx === levels.length - 1) {
                    charWidth = 0;
                    break;
                }
                charWidth = this.charWidths[levels[++visualIdx]];
            }
            if (visualIdx > 0 && levels[visualIdx - 1] % 2 !== 0 && levels[visualIdx] % 2 === 0) {
                if (posX < offset) visualIdx--;
                logicalIdx = this.bidiMap.logicalFromVisual[visualIdx];
            } else if (visualIdx > 0 && levels[visualIdx - 1] % 2 === 0 && levels[visualIdx] % 2 !== 0) logicalIdx = 1 + (posX > offset ? this.bidiMap.logicalFromVisual[visualIdx] : this.bidiMap.logicalFromVisual[visualIdx - 1]);
            else if (this.isRtlDir && visualIdx === levels.length - 1 && charWidth === 0 && levels[visualIdx - 1] % 2 === 0 || !this.isRtlDir && visualIdx === 0 && levels[visualIdx] % 2 !== 0) logicalIdx = 1 + this.bidiMap.logicalFromVisual[visualIdx];
            else {
                if (visualIdx > 0 && levels[visualIdx - 1] % 2 !== 0 && charWidth !== 0) visualIdx--;
                logicalIdx = this.bidiMap.logicalFromVisual[visualIdx];
            }
            if (logicalIdx === 0 && this.isRtlDir) logicalIdx++;
            return logicalIdx + this.wrapIndent;
        };
        return BidiHandler;
    }();
    exports.BidiHandler = BidiHandler;
});
ace.define("ace/selection", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/lib/event_emitter",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var oop = require("./lib/oop");
    var lang = require("./lib/lang");
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var Range = require("./range").Range;
    var Selection = /** @class */ function() {
        function Selection(session) {
            this.session = session;
            this.doc = session.getDocument();
            this.clearSelection();
            this.cursor = this.lead = this.doc.createAnchor(0, 0);
            this.anchor = this.doc.createAnchor(0, 0);
            this.$silent = false;
            var self1 = this;
            this.cursor.on("change", function(e) {
                self1.$cursorChanged = true;
                if (!self1.$silent) self1._emit("changeCursor");
                if (!self1.$isEmpty && !self1.$silent) self1._emit("changeSelection");
                if (!self1.$keepDesiredColumnOnChange && e.old.column != e.value.column) self1.$desiredColumn = null;
            });
            this.anchor.on("change", function() {
                self1.$anchorChanged = true;
                if (!self1.$isEmpty && !self1.$silent) self1._emit("changeSelection");
            });
        }
        Selection.prototype.isEmpty = function() {
            return this.$isEmpty || this.anchor.row == this.lead.row && this.anchor.column == this.lead.column;
        };
        Selection.prototype.isMultiLine = function() {
            return !this.$isEmpty && this.anchor.row != this.cursor.row;
        };
        Selection.prototype.getCursor = function() {
            return this.lead.getPosition();
        };
        Selection.prototype.setAnchor = function(row, column) {
            this.$isEmpty = false;
            this.anchor.setPosition(row, column);
        };
        Selection.prototype.getAnchor = function() {
            if (this.$isEmpty) return this.getSelectionLead();
            return this.anchor.getPosition();
        };
        Selection.prototype.getSelectionLead = function() {
            return this.lead.getPosition();
        };
        Selection.prototype.isBackwards = function() {
            var anchor = this.anchor;
            var lead = this.lead;
            return anchor.row > lead.row || anchor.row == lead.row && anchor.column > lead.column;
        };
        Selection.prototype.getRange = function() {
            var anchor = this.anchor;
            var lead = this.lead;
            if (this.$isEmpty) return Range.fromPoints(lead, lead);
            return this.isBackwards() ? Range.fromPoints(lead, anchor) : Range.fromPoints(anchor, lead);
        };
        Selection.prototype.clearSelection = function() {
            if (!this.$isEmpty) {
                this.$isEmpty = true;
                this._emit("changeSelection");
            }
        };
        Selection.prototype.selectAll = function() {
            this.$setSelection(0, 0, Number.MAX_VALUE, Number.MAX_VALUE);
        };
        Selection.prototype.setRange = function(range, reverse) {
            var start = reverse ? range.end : range.start;
            var end = reverse ? range.start : range.end;
            this.$setSelection(start.row, start.column, end.row, end.column);
        };
        Selection.prototype.$setSelection = function(anchorRow, anchorColumn, cursorRow, cursorColumn) {
            if (this.$silent) return;
            var wasEmpty = this.$isEmpty;
            var wasMultiselect = this.inMultiSelectMode;
            this.$silent = true;
            this.$cursorChanged = this.$anchorChanged = false;
            this.anchor.setPosition(anchorRow, anchorColumn);
            this.cursor.setPosition(cursorRow, cursorColumn);
            this.$isEmpty = !Range.comparePoints(this.anchor, this.cursor);
            this.$silent = false;
            if (this.$cursorChanged) this._emit("changeCursor");
            if (this.$cursorChanged || this.$anchorChanged || wasEmpty != this.$isEmpty || wasMultiselect) this._emit("changeSelection");
        };
        Selection.prototype.$moveSelection = function(mover) {
            var lead = this.lead;
            if (this.$isEmpty) this.setSelectionAnchor(lead.row, lead.column);
            mover.call(this);
        };
        Selection.prototype.selectTo = function(row, column) {
            this.$moveSelection(function() {
                this.moveCursorTo(row, column);
            });
        };
        Selection.prototype.selectToPosition = function(pos) {
            this.$moveSelection(function() {
                this.moveCursorToPosition(pos);
            });
        };
        Selection.prototype.moveTo = function(row, column) {
            this.clearSelection();
            this.moveCursorTo(row, column);
        };
        Selection.prototype.moveToPosition = function(pos) {
            this.clearSelection();
            this.moveCursorToPosition(pos);
        };
        Selection.prototype.selectUp = function() {
            this.$moveSelection(this.moveCursorUp);
        };
        Selection.prototype.selectDown = function() {
            this.$moveSelection(this.moveCursorDown);
        };
        Selection.prototype.selectRight = function() {
            this.$moveSelection(this.moveCursorRight);
        };
        Selection.prototype.selectLeft = function() {
            this.$moveSelection(this.moveCursorLeft);
        };
        Selection.prototype.selectLineStart = function() {
            this.$moveSelection(this.moveCursorLineStart);
        };
        Selection.prototype.selectLineEnd = function() {
            this.$moveSelection(this.moveCursorLineEnd);
        };
        Selection.prototype.selectFileEnd = function() {
            this.$moveSelection(this.moveCursorFileEnd);
        };
        Selection.prototype.selectFileStart = function() {
            this.$moveSelection(this.moveCursorFileStart);
        };
        Selection.prototype.selectWordRight = function() {
            this.$moveSelection(this.moveCursorWordRight);
        };
        Selection.prototype.selectWordLeft = function() {
            this.$moveSelection(this.moveCursorWordLeft);
        };
        Selection.prototype.getWordRange = function(row, column) {
            if (typeof column == "undefined") {
                var cursor = row || this.lead;
                row = cursor.row;
                column = cursor.column;
            }
            return this.session.getWordRange(row, column);
        };
        Selection.prototype.selectWord = function() {
            this.setSelectionRange(this.getWordRange());
        };
        Selection.prototype.selectAWord = function() {
            var cursor = this.getCursor();
            var range = this.session.getAWordRange(cursor.row, cursor.column);
            this.setSelectionRange(range);
        };
        Selection.prototype.getLineRange = function(row, excludeLastChar) {
            var rowStart = typeof row == "number" ? row : this.lead.row;
            var rowEnd;
            var foldLine = this.session.getFoldLine(rowStart);
            if (foldLine) {
                rowStart = foldLine.start.row;
                rowEnd = foldLine.end.row;
            } else rowEnd = rowStart;
            if (excludeLastChar === true) return new Range(rowStart, 0, rowEnd, this.session.getLine(rowEnd).length);
            else return new Range(rowStart, 0, rowEnd + 1, 0);
        };
        Selection.prototype.selectLine = function() {
            this.setSelectionRange(this.getLineRange());
        };
        Selection.prototype.moveCursorUp = function() {
            this.moveCursorBy(-1, 0);
        };
        Selection.prototype.moveCursorDown = function() {
            this.moveCursorBy(1, 0);
        };
        Selection.prototype.wouldMoveIntoSoftTab = function(cursor, tabSize, direction) {
            var start = cursor.column;
            var end = cursor.column + tabSize;
            if (direction < 0) {
                start = cursor.column - tabSize;
                end = cursor.column;
            }
            return this.session.isTabStop(cursor) && this.doc.getLine(cursor.row).slice(start, end).split(" ").length - 1 == tabSize;
        };
        Selection.prototype.moveCursorLeft = function() {
            var cursor = this.lead.getPosition(), fold;
            if (fold = this.session.getFoldAt(cursor.row, cursor.column, -1)) this.moveCursorTo(fold.start.row, fold.start.column);
            else if (cursor.column === 0) {
                if (cursor.row > 0) this.moveCursorTo(cursor.row - 1, this.doc.getLine(cursor.row - 1).length);
            } else {
                var tabSize = this.session.getTabSize();
                if (this.wouldMoveIntoSoftTab(cursor, tabSize, -1) && !this.session.getNavigateWithinSoftTabs()) this.moveCursorBy(0, -tabSize);
                else this.moveCursorBy(0, -1);
            }
        };
        Selection.prototype.moveCursorRight = function() {
            var cursor = this.lead.getPosition(), fold;
            if (fold = this.session.getFoldAt(cursor.row, cursor.column, 1)) this.moveCursorTo(fold.end.row, fold.end.column);
            else if (this.lead.column == this.doc.getLine(this.lead.row).length) {
                if (this.lead.row < this.doc.getLength() - 1) this.moveCursorTo(this.lead.row + 1, 0);
            } else {
                var tabSize = this.session.getTabSize();
                var cursor = this.lead;
                if (this.wouldMoveIntoSoftTab(cursor, tabSize, 1) && !this.session.getNavigateWithinSoftTabs()) this.moveCursorBy(0, tabSize);
                else this.moveCursorBy(0, 1);
            }
        };
        Selection.prototype.moveCursorLineStart = function() {
            var row = this.lead.row;
            var column = this.lead.column;
            var screenRow = this.session.documentToScreenRow(row, column);
            var firstColumnPosition = this.session.screenToDocumentPosition(screenRow, 0);
            var beforeCursor = this.session.getDisplayLine(row, null, firstColumnPosition.row, firstColumnPosition.column);
            var leadingSpace = beforeCursor.match(/^\s*/);
            if (leadingSpace[0].length != column && !this.session.$useEmacsStyleLineStart) firstColumnPosition.column += leadingSpace[0].length;
            this.moveCursorToPosition(firstColumnPosition);
        };
        Selection.prototype.moveCursorLineEnd = function() {
            var lead = this.lead;
            var lineEnd = this.session.getDocumentLastRowColumnPosition(lead.row, lead.column);
            if (this.lead.column == lineEnd.column) {
                var line = this.session.getLine(lineEnd.row);
                if (lineEnd.column == line.length) {
                    var textEnd = line.search(/\s+$/);
                    if (textEnd > 0) lineEnd.column = textEnd;
                }
            }
            this.moveCursorTo(lineEnd.row, lineEnd.column);
        };
        Selection.prototype.moveCursorFileEnd = function() {
            var row = this.doc.getLength() - 1;
            var column = this.doc.getLine(row).length;
            this.moveCursorTo(row, column);
        };
        Selection.prototype.moveCursorFileStart = function() {
            this.moveCursorTo(0, 0);
        };
        Selection.prototype.moveCursorLongWordRight = function() {
            var row = this.lead.row;
            var column = this.lead.column;
            var line = this.doc.getLine(row);
            var rightOfCursor = line.substring(column);
            this.session.nonTokenRe.lastIndex = 0;
            this.session.tokenRe.lastIndex = 0;
            var fold = this.session.getFoldAt(row, column, 1);
            if (fold) {
                this.moveCursorTo(fold.end.row, fold.end.column);
                return;
            }
            if (this.session.nonTokenRe.exec(rightOfCursor)) {
                column += this.session.nonTokenRe.lastIndex;
                this.session.nonTokenRe.lastIndex = 0;
                rightOfCursor = line.substring(column);
            }
            if (column >= line.length) {
                this.moveCursorTo(row, line.length);
                this.moveCursorRight();
                if (row < this.doc.getLength() - 1) this.moveCursorWordRight();
                return;
            }
            if (this.session.tokenRe.exec(rightOfCursor)) {
                column += this.session.tokenRe.lastIndex;
                this.session.tokenRe.lastIndex = 0;
            }
            this.moveCursorTo(row, column);
        };
        Selection.prototype.moveCursorLongWordLeft = function() {
            var row = this.lead.row;
            var column = this.lead.column;
            var fold;
            if (fold = this.session.getFoldAt(row, column, -1)) {
                this.moveCursorTo(fold.start.row, fold.start.column);
                return;
            }
            var str = this.session.getFoldStringAt(row, column, -1);
            if (str == null) str = this.doc.getLine(row).substring(0, column);
            var leftOfCursor = lang.stringReverse(str);
            this.session.nonTokenRe.lastIndex = 0;
            this.session.tokenRe.lastIndex = 0;
            if (this.session.nonTokenRe.exec(leftOfCursor)) {
                column -= this.session.nonTokenRe.lastIndex;
                leftOfCursor = leftOfCursor.slice(this.session.nonTokenRe.lastIndex);
                this.session.nonTokenRe.lastIndex = 0;
            }
            if (column <= 0) {
                this.moveCursorTo(row, 0);
                this.moveCursorLeft();
                if (row > 0) this.moveCursorWordLeft();
                return;
            }
            if (this.session.tokenRe.exec(leftOfCursor)) {
                column -= this.session.tokenRe.lastIndex;
                this.session.tokenRe.lastIndex = 0;
            }
            this.moveCursorTo(row, column);
        };
        Selection.prototype.$shortWordEndIndex = function(rightOfCursor) {
            var index = 0, ch;
            var whitespaceRe = /\s/;
            var tokenRe = this.session.tokenRe;
            tokenRe.lastIndex = 0;
            if (this.session.tokenRe.exec(rightOfCursor)) index = this.session.tokenRe.lastIndex;
            else {
                while((ch = rightOfCursor[index]) && whitespaceRe.test(ch))index++;
                if (index < 1) {
                    tokenRe.lastIndex = 0;
                    while((ch = rightOfCursor[index]) && !tokenRe.test(ch)){
                        tokenRe.lastIndex = 0;
                        index++;
                        if (whitespaceRe.test(ch)) {
                            if (index > 2) {
                                index--;
                                break;
                            } else {
                                while((ch = rightOfCursor[index]) && whitespaceRe.test(ch))index++;
                                if (index > 2) break;
                            }
                        }
                    }
                }
            }
            tokenRe.lastIndex = 0;
            return index;
        };
        Selection.prototype.moveCursorShortWordRight = function() {
            var row = this.lead.row;
            var column = this.lead.column;
            var line = this.doc.getLine(row);
            var rightOfCursor = line.substring(column);
            var fold = this.session.getFoldAt(row, column, 1);
            if (fold) return this.moveCursorTo(fold.end.row, fold.end.column);
            if (column == line.length) {
                var l = this.doc.getLength();
                do {
                    row++;
                    rightOfCursor = this.doc.getLine(row);
                }while (row < l && /^\s*$/.test(rightOfCursor));
                if (!/^\s+/.test(rightOfCursor)) rightOfCursor = "";
                column = 0;
            }
            var index = this.$shortWordEndIndex(rightOfCursor);
            this.moveCursorTo(row, column + index);
        };
        Selection.prototype.moveCursorShortWordLeft = function() {
            var row = this.lead.row;
            var column = this.lead.column;
            var fold;
            if (fold = this.session.getFoldAt(row, column, -1)) return this.moveCursorTo(fold.start.row, fold.start.column);
            var line = this.session.getLine(row).substring(0, column);
            if (column === 0) {
                do {
                    row--;
                    line = this.doc.getLine(row);
                }while (row > 0 && /^\s*$/.test(line));
                column = line.length;
                if (!/\s+$/.test(line)) line = "";
            }
            var leftOfCursor = lang.stringReverse(line);
            var index = this.$shortWordEndIndex(leftOfCursor);
            return this.moveCursorTo(row, column - index);
        };
        Selection.prototype.moveCursorWordRight = function() {
            if (this.session.$selectLongWords) this.moveCursorLongWordRight();
            else this.moveCursorShortWordRight();
        };
        Selection.prototype.moveCursorWordLeft = function() {
            if (this.session.$selectLongWords) this.moveCursorLongWordLeft();
            else this.moveCursorShortWordLeft();
        };
        Selection.prototype.moveCursorBy = function(rows, chars) {
            var screenPos = this.session.documentToScreenPosition(this.lead.row, this.lead.column);
            var offsetX;
            if (chars === 0) {
                if (rows !== 0) {
                    if (this.session.$bidiHandler.isBidiRow(screenPos.row, this.lead.row)) {
                        offsetX = this.session.$bidiHandler.getPosLeft(screenPos.column);
                        screenPos.column = Math.round(offsetX / this.session.$bidiHandler.charWidths[0]);
                    } else offsetX = screenPos.column * this.session.$bidiHandler.charWidths[0];
                }
                if (this.$desiredColumn) screenPos.column = this.$desiredColumn;
                else this.$desiredColumn = screenPos.column;
            }
            if (rows != 0 && this.session.lineWidgets && this.session.lineWidgets[this.lead.row]) {
                var widget = this.session.lineWidgets[this.lead.row];
                if (rows < 0) rows -= widget.rowsAbove || 0;
                else if (rows > 0) rows += widget.rowCount - (widget.rowsAbove || 0);
            }
            var docPos = this.session.screenToDocumentPosition(screenPos.row + rows, screenPos.column, offsetX);
            rows !== 0 && chars === 0 && docPos.row === this.lead.row && (docPos.column, this.lead.column);
            this.moveCursorTo(docPos.row, docPos.column + chars, chars === 0);
        };
        Selection.prototype.moveCursorToPosition = function(position) {
            this.moveCursorTo(position.row, position.column);
        };
        Selection.prototype.moveCursorTo = function(row, column, keepDesiredColumn) {
            var fold = this.session.getFoldAt(row, column, 1);
            if (fold) {
                row = fold.start.row;
                column = fold.start.column;
            }
            this.$keepDesiredColumnOnChange = true;
            var line = this.session.getLine(row);
            if (/[\uDC00-\uDFFF]/.test(line.charAt(column)) && line.charAt(column - 1)) {
                if (this.lead.row == row && this.lead.column == column + 1) column = column - 1;
                else column = column + 1;
            }
            this.lead.setPosition(row, column);
            this.$keepDesiredColumnOnChange = false;
            if (!keepDesiredColumn) this.$desiredColumn = null;
        };
        Selection.prototype.moveCursorToScreen = function(row, column, keepDesiredColumn) {
            var pos = this.session.screenToDocumentPosition(row, column);
            this.moveCursorTo(pos.row, pos.column, keepDesiredColumn);
        };
        Selection.prototype.detach = function() {
            this.lead.detach();
            this.anchor.detach();
        };
        Selection.prototype.fromOrientedRange = function(range) {
            this.setSelectionRange(range, range.cursor == range.start);
            this.$desiredColumn = range.desiredColumn || this.$desiredColumn;
        };
        Selection.prototype.toOrientedRange = function(range) {
            var r = this.getRange();
            if (range) {
                range.start.column = r.start.column;
                range.start.row = r.start.row;
                range.end.column = r.end.column;
                range.end.row = r.end.row;
            } else range = r;
            range.cursor = this.isBackwards() ? range.start : range.end;
            range.desiredColumn = this.$desiredColumn;
            return range;
        };
        Selection.prototype.getRangeOfMovements = function(func) {
            var start = this.getCursor();
            try {
                func(this);
                var end = this.getCursor();
                return Range.fromPoints(start, end);
            } catch (e) {
                return Range.fromPoints(start, start);
            } finally{
                this.moveCursorToPosition(start);
            }
        };
        Selection.prototype.toJSON = function() {
            if (this.rangeCount) var data = this.ranges.map(function(r) {
                var r1 = r.clone();
                r1.isBackwards = r.cursor == r.start;
                return r1;
            });
            else {
                var data = this.getRange();
                data.isBackwards = this.isBackwards();
            }
            return data;
        };
        Selection.prototype.fromJSON = function(data) {
            if (data.start == undefined) {
                if (this.rangeList && data.length > 1) {
                    this.toSingleRange(data[0]);
                    for(var i = data.length; i--;){
                        var r = Range.fromPoints(data[i].start, data[i].end);
                        if (data[i].isBackwards) r.cursor = r.start;
                        this.addRange(r, true);
                    }
                    return;
                } else data = data[0];
            }
            if (this.rangeList) this.toSingleRange(data);
            this.setSelectionRange(data, data.isBackwards);
        };
        Selection.prototype.isEqual = function(data) {
            if ((data.length || this.rangeCount) && data.length != this.rangeCount) return false;
            if (!data.length || !this.ranges) return this.getRange().isEqual(data);
            for(var i = this.ranges.length; i--;){
                if (!this.ranges[i].isEqual(data[i])) return false;
            }
            return true;
        };
        return Selection;
    }();
    Selection.prototype.setSelectionAnchor = Selection.prototype.setAnchor;
    Selection.prototype.getSelectionAnchor = Selection.prototype.getAnchor;
    Selection.prototype.setSelectionRange = Selection.prototype.setRange;
    oop.implement(Selection.prototype, EventEmitter);
    exports.Selection = Selection;
});
ace.define("ace/tokenizer", [
    "require",
    "exports",
    "module",
    "ace/lib/report_error"
], function(require, exports, module1) {
    "use strict";
    var reportError = require("./lib/report_error").reportError;
    var MAX_TOKEN_COUNT = 2000;
    var Tokenizer = /** @class */ function() {
        function Tokenizer(rules) {
            this.splitRegex;
            this.states = rules;
            this.regExps = {};
            this.matchMappings = {};
            for(var key in this.states){
                var state = this.states[key];
                var ruleRegExps = [];
                var matchTotal = 0;
                var mapping = this.matchMappings[key] = {
                    defaultToken: "text"
                };
                var flag = "g";
                var splitterRurles = [];
                for(var i = 0; i < state.length; i++){
                    var rule = state[i];
                    if (rule.defaultToken) mapping.defaultToken = rule.defaultToken;
                    if (rule.caseInsensitive && flag.indexOf("i") === -1) flag += "i";
                    if (rule.unicode && flag.indexOf("u") === -1) flag += "u";
                    if (rule.regex == null) continue;
                    if (rule.regex instanceof RegExp) rule.regex = rule.regex.toString().slice(1, -1);
                    var adjustedregex = rule.regex;
                    var matchcount = new RegExp("(?:(" + adjustedregex + ")|(.))").exec("a").length - 2;
                    if (Array.isArray(rule.token)) {
                        if (rule.token.length == 1 || matchcount == 1) rule.token = rule.token[0];
                        else if (matchcount - 1 != rule.token.length) {
                            this.reportError("number of classes and regexp groups doesn't match", {
                                rule: rule,
                                groupCount: matchcount - 1
                            });
                            rule.token = rule.token[0];
                        } else {
                            rule.tokenArray = rule.token;
                            rule.token = null;
                            rule.onMatch = this.$arrayTokens;
                        }
                    } else if (typeof rule.token == "function" && !rule.onMatch) {
                        if (matchcount > 1) rule.onMatch = this.$applyToken;
                        else rule.onMatch = rule.token;
                    }
                    if (matchcount > 1) {
                        if (/\\\d/.test(rule.regex)) adjustedregex = rule.regex.replace(/\\([0-9]+)/g, function(match, digit) {
                            return "\\" + (parseInt(digit, 10) + matchTotal + 1);
                        });
                        else {
                            matchcount = 1;
                            adjustedregex = this.removeCapturingGroups(rule.regex);
                        }
                        if (!rule.splitRegex && typeof rule.token != "string") splitterRurles.push(rule); // flag will be known only at the very end
                    }
                    mapping[matchTotal] = i;
                    matchTotal += matchcount;
                    ruleRegExps.push(adjustedregex);
                    if (!rule.onMatch) rule.onMatch = null;
                }
                if (!ruleRegExps.length) {
                    mapping[0] = 0;
                    ruleRegExps.push("$");
                }
                splitterRurles.forEach(function(rule) {
                    rule.splitRegex = this.createSplitterRegexp(rule.regex, flag);
                }, this);
                this.regExps[key] = new RegExp("(" + ruleRegExps.join(")|(") + ")|($)", flag);
            }
        }
        Tokenizer.prototype.$setMaxTokenCount = function(m) {
            MAX_TOKEN_COUNT = m | 0;
        };
        Tokenizer.prototype.$applyToken = function(str) {
            var values = this.splitRegex.exec(str).slice(1);
            var types = this.token.apply(this, values);
            if (typeof types === "string") return [
                {
                    type: types,
                    value: str
                }
            ];
            var tokens = [];
            for(var i = 0, l = types.length; i < l; i++)if (values[i]) tokens[tokens.length] = {
                type: types[i],
                value: values[i]
            };
            return tokens;
        };
        Tokenizer.prototype.$arrayTokens = function(str) {
            if (!str) return [];
            var values = this.splitRegex.exec(str);
            if (!values) return "text";
            var tokens = [];
            var types = this.tokenArray;
            for(var i = 0, l = types.length; i < l; i++)if (values[i + 1]) tokens[tokens.length] = {
                type: types[i],
                value: values[i + 1]
            };
            return tokens;
        };
        Tokenizer.prototype.removeCapturingGroups = function(src) {
            var r = src.replace(/\\.|\[(?:\\.|[^\\\]])*|\(\?[:=!<]|(\()/g, function(x, y) {
                return y ? "(?:" : x;
            });
            return r;
        };
        Tokenizer.prototype.createSplitterRegexp = function(src, flag) {
            if (src.indexOf("(?=") != -1) {
                var stack = 0;
                var inChClass = false;
                var lastCapture = {};
                src.replace(/(\\.)|(\((?:\?[=!])?)|(\))|([\[\]])/g, function(m, esc, parenOpen, parenClose, square, index) {
                    if (inChClass) inChClass = square != "]";
                    else if (square) inChClass = true;
                    else if (parenClose) {
                        if (stack == lastCapture.stack) {
                            lastCapture.end = index + 1;
                            lastCapture.stack = -1;
                        }
                        stack--;
                    } else if (parenOpen) {
                        stack++;
                        if (parenOpen.length != 1) {
                            lastCapture.stack = stack;
                            lastCapture.start = index;
                        }
                    }
                    return m;
                });
                if (lastCapture.end != null && /^\)*$/.test(src.substr(lastCapture.end))) src = src.substring(0, lastCapture.start) + src.substr(lastCapture.end);
            }
            if (src.charAt(0) != "^") src = "^" + src;
            if (src.charAt(src.length - 1) != "$") src += "$";
            return new RegExp(src, (flag || "").replace("g", ""));
        };
        Tokenizer.prototype.getLineTokens = function(line, startState) {
            if (startState && typeof startState != "string") {
                var stack = startState.slice(0);
                startState = stack[0];
                if (startState === "#tmp") {
                    stack.shift();
                    startState = stack.shift();
                }
            } else var stack = [];
            var currentState = /**@type{string}*/ startState || "start";
            var state = this.states[currentState];
            if (!state) {
                currentState = "start";
                state = this.states[currentState];
            }
            var mapping = this.matchMappings[currentState];
            var re = this.regExps[currentState];
            re.lastIndex = 0;
            var match, tokens = [];
            var lastIndex = 0;
            var matchAttempts = 0;
            var token = {
                type: null,
                value: ""
            };
            while(match = re.exec(line)){
                var type = mapping.defaultToken;
                var rule = null;
                var value = match[0];
                var index = re.lastIndex;
                if (index - value.length > lastIndex) {
                    var skipped = line.substring(lastIndex, index - value.length);
                    if (token.type == type) token.value += skipped;
                    else {
                        if (token.type) tokens.push(token);
                        token = {
                            type: type,
                            value: skipped
                        };
                    }
                }
                for(var i = 0; i < match.length - 2; i++){
                    if (match[i + 1] === undefined) continue;
                    rule = state[mapping[i]];
                    if (rule.onMatch) type = rule.onMatch(value, currentState, stack, line);
                    else type = rule.token;
                    if (rule.next) {
                        if (typeof rule.next == "string") currentState = rule.next;
                        else currentState = rule.next(currentState, stack);
                        state = this.states[currentState];
                        if (!state) {
                            this.reportError("state doesn't exist", currentState);
                            currentState = "start";
                            state = this.states[currentState];
                        }
                        mapping = this.matchMappings[currentState];
                        lastIndex = index;
                        re = this.regExps[currentState];
                        re.lastIndex = index;
                    }
                    if (rule.consumeLineEnd) lastIndex = index;
                    break;
                }
                if (value) {
                    if (typeof type === "string") {
                        if ((!rule || rule.merge !== false) && token.type === type) token.value += value;
                        else {
                            if (token.type) tokens.push(token);
                            token = {
                                type: type,
                                value: value
                            };
                        }
                    } else if (type) {
                        if (token.type) tokens.push(token);
                        token = {
                            type: null,
                            value: ""
                        };
                        for(var i = 0; i < type.length; i++)tokens.push(type[i]);
                    }
                }
                if (lastIndex == line.length) break;
                lastIndex = index;
                if (matchAttempts++ > MAX_TOKEN_COUNT) {
                    if (matchAttempts > 2 * line.length) this.reportError("infinite loop with in ace tokenizer", {
                        startState: startState,
                        line: line
                    });
                    while(lastIndex < line.length){
                        if (token.type) tokens.push(token);
                        token = {
                            value: line.substring(lastIndex, lastIndex += 500),
                            type: "overflow"
                        };
                    }
                    currentState = "start";
                    stack = [];
                    break;
                }
            }
            if (token.type) tokens.push(token);
            if (stack.length > 1) {
                if (stack[0] !== currentState) stack.unshift("#tmp", currentState);
            }
            return {
                tokens: tokens,
                state: stack.length ? stack : currentState
            };
        };
        return Tokenizer;
    }();
    Tokenizer.prototype.reportError = reportError;
    exports.Tokenizer = Tokenizer;
});
ace.define("ace/mode/text_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/deep_copy"
], function(require, exports, module1) {
    "use strict";
    var deepCopy = require("../lib/deep_copy").deepCopy;
    var TextHighlightRules;
    TextHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: "empty_line",
                    regex: "^$"
                },
                {
                    defaultToken: "text"
                }
            ]
        };
    };
    (function() {
        this.addRules = function(rules, prefix) {
            if (!prefix) {
                for(var key in rules)this.$rules[key] = rules[key];
                return;
            }
            for(var key in rules){
                var state = rules[key];
                for(var i = 0; i < state.length; i++){
                    var rule = state[i];
                    if (rule.next || rule.onMatch) {
                        if (typeof rule.next == "string") {
                            if (rule.next.indexOf(prefix) !== 0) rule.next = prefix + rule.next;
                        }
                        if (rule.nextState && rule.nextState.indexOf(prefix) !== 0) rule.nextState = prefix + rule.nextState;
                    }
                }
                this.$rules[prefix + key] = state;
            }
        };
        this.getRules = function() {
            return this.$rules;
        };
        this.embedRules = function(HighlightRules, prefix, escapeRules, states, append) {
            var embedRules = typeof HighlightRules == "function" ? new HighlightRules().getRules() : HighlightRules;
            if (states) for(var i = 0; i < states.length; i++)states[i] = prefix + states[i];
            else {
                states = [];
                for(var key in embedRules)states.push(prefix + key);
            }
            this.addRules(embedRules, prefix);
            if (escapeRules) {
                var addRules = Array.prototype[append ? "push" : "unshift"];
                for(var i = 0; i < states.length; i++)addRules.apply(this.$rules[states[i]], deepCopy(escapeRules));
            }
            if (!this.$embeds) this.$embeds = [];
            this.$embeds.push(prefix);
        };
        this.getEmbeds = function() {
            return this.$embeds;
        };
        var pushState = function(currentState, stack) {
            if (currentState != "start" || stack.length) stack.unshift(this.nextState, currentState);
            return this.nextState;
        };
        var popState = function(currentState, stack) {
            stack.shift();
            return stack.shift() || "start";
        };
        this.normalizeRules = function() {
            var id = 0;
            var rules = this.$rules;
            function processState(key) {
                var state = rules[key];
                state["processed"] = true;
                for(var i = 0; i < state.length; i++){
                    var rule = state[i];
                    var toInsert = null;
                    if (Array.isArray(rule)) {
                        toInsert = rule;
                        rule = {};
                    }
                    if (!rule.regex && rule.start) {
                        rule.regex = rule.start;
                        if (!rule.next) rule.next = [];
                        rule.next.push({
                            defaultToken: rule.token
                        }, {
                            token: rule.token + ".end",
                            regex: rule.end || rule.start,
                            next: "pop"
                        });
                        rule.token = rule.token + ".start";
                        rule.push = true;
                    }
                    var next = rule.next || rule.push;
                    if (next && Array.isArray(next)) {
                        var stateName = rule.stateName;
                        if (!stateName) {
                            stateName = rule.token;
                            if (typeof stateName != "string") stateName = stateName[0] || "";
                            if (rules[stateName]) stateName += id++;
                        }
                        rules[stateName] = next;
                        rule.next = stateName;
                        processState(stateName);
                    } else if (next == "pop") rule.next = popState;
                    if (rule.push) {
                        rule.nextState = rule.next || rule.push;
                        rule.next = pushState;
                        delete rule.push;
                    }
                    if (rule.rules) for(var r in rule.rules){
                        if (rules[r]) {
                            if (rules[r].push) rules[r].push.apply(rules[r], rule.rules[r]);
                        } else rules[r] = rule.rules[r];
                    }
                    var includeName = typeof rule == "string" ? rule : rule.include;
                    if (includeName) {
                        if (includeName === "$self") includeName = "start";
                        if (Array.isArray(includeName)) toInsert = includeName.map(function(x) {
                            return rules[x];
                        });
                        else toInsert = rules[includeName];
                    }
                    if (toInsert) {
                        var args = [
                            i,
                            1
                        ].concat(toInsert);
                        if (rule.noEscape) args = args.filter(function(x) {
                            return !x.next;
                        });
                        state.splice.apply(state, args);
                        i--;
                    }
                    if (rule.keywordMap) {
                        rule.token = this.createKeywordMapper(rule.keywordMap, rule.defaultToken || "text", rule.caseInsensitive);
                        delete rule.defaultToken;
                    }
                }
            }
            Object.keys(rules).forEach(processState, this);
        };
        this.createKeywordMapper = function(map, defaultToken, ignoreCase, splitChar) {
            var keywords = Object.create(null);
            this.$keywordList = [];
            Object.keys(map).forEach(function(className) {
                var a = map[className];
                var list = a.split(splitChar || "|");
                for(var i = list.length; i--;){
                    var word = list[i];
                    this.$keywordList.push(word);
                    if (ignoreCase) word = word.toLowerCase();
                    keywords[word] = className;
                }
            }, this);
            map = null;
            return ignoreCase ? function(value) {
                return keywords[value.toLowerCase()] || defaultToken;
            } : function(value) {
                return keywords[value] || defaultToken;
            };
        };
        this.getKeywords = function() {
            return this.$keywords;
        };
    }).call(TextHighlightRules.prototype);
    exports.TextHighlightRules = TextHighlightRules;
});
ace.define("ace/mode/behaviour", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var Behaviour;
    Behaviour = function() {
        this.$behaviours = {};
    };
    (function() {
        this.add = function(name, action, callback) {
            switch(undefined){
                case this.$behaviours:
                    this.$behaviours = {};
                case this.$behaviours[name]:
                    this.$behaviours[name] = {};
            }
            this.$behaviours[name][action] = callback;
        };
        this.addBehaviours = function(behaviours) {
            for(var key in behaviours)for(var action in behaviours[key])this.add(key, action, behaviours[key][action]);
        };
        this.remove = function(name) {
            if (this.$behaviours && this.$behaviours[name]) delete this.$behaviours[name];
        };
        this.inherit = function(mode, filter) {
            if (typeof mode === "function") var behaviours = new mode().getBehaviours(filter);
            else var behaviours = mode.getBehaviours(filter);
            this.addBehaviours(behaviours);
        };
        this.getBehaviours = function(filter) {
            if (!filter) return this.$behaviours;
            else {
                var ret = {};
                for(var i = 0; i < filter.length; i++)if (this.$behaviours[filter[i]]) ret[filter[i]] = this.$behaviours[filter[i]];
                return ret;
            }
        };
    }).call(Behaviour.prototype);
    exports.Behaviour = Behaviour;
});
ace.define("ace/token_iterator", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("./range").Range;
    var TokenIterator = /** @class */ function() {
        function TokenIterator(session, initialRow, initialColumn) {
            this.$session = session;
            this.$row = initialRow;
            this.$rowTokens = session.getTokens(initialRow);
            var token = session.getTokenAt(initialRow, initialColumn);
            this.$tokenIndex = token ? token.index : -1;
        }
        TokenIterator.prototype.stepBackward = function() {
            this.$tokenIndex -= 1;
            while(this.$tokenIndex < 0){
                this.$row -= 1;
                if (this.$row < 0) {
                    this.$row = 0;
                    return null;
                }
                this.$rowTokens = this.$session.getTokens(this.$row);
                this.$tokenIndex = this.$rowTokens.length - 1;
            }
            return this.$rowTokens[this.$tokenIndex];
        };
        TokenIterator.prototype.stepForward = function() {
            this.$tokenIndex += 1;
            var rowCount;
            while(this.$tokenIndex >= this.$rowTokens.length){
                this.$row += 1;
                if (!rowCount) rowCount = this.$session.getLength();
                if (this.$row >= rowCount) {
                    this.$row = rowCount - 1;
                    return null;
                }
                this.$rowTokens = this.$session.getTokens(this.$row);
                this.$tokenIndex = 0;
            }
            return this.$rowTokens[this.$tokenIndex];
        };
        TokenIterator.prototype.getCurrentToken = function() {
            return this.$rowTokens[this.$tokenIndex];
        };
        TokenIterator.prototype.getCurrentTokenRow = function() {
            return this.$row;
        };
        TokenIterator.prototype.getCurrentTokenColumn = function() {
            var rowTokens = this.$rowTokens;
            var tokenIndex = this.$tokenIndex;
            var column = rowTokens[tokenIndex].start;
            if (column !== undefined) return column;
            column = 0;
            while(tokenIndex > 0){
                tokenIndex -= 1;
                column += rowTokens[tokenIndex].value.length;
            }
            return column;
        };
        TokenIterator.prototype.getCurrentTokenPosition = function() {
            return {
                row: this.$row,
                column: this.getCurrentTokenColumn()
            };
        };
        TokenIterator.prototype.getCurrentTokenRange = function() {
            var token = this.$rowTokens[this.$tokenIndex];
            var column = this.getCurrentTokenColumn();
            return new Range(this.$row, column, this.$row, column + token.value.length);
        };
        return TokenIterator;
    }();
    exports.TokenIterator = TokenIterator;
});
ace.define("ace/mode/behaviour/cstyle", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/behaviour",
    "ace/token_iterator",
    "ace/lib/lang"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Behaviour = require("../behaviour").Behaviour;
    var TokenIterator = require("../../token_iterator").TokenIterator;
    var lang = require("../../lib/lang");
    var SAFE_INSERT_IN_TOKENS = [
        "text",
        "paren.rparen",
        "rparen",
        "paren",
        "punctuation.operator"
    ];
    var SAFE_INSERT_BEFORE_TOKENS = [
        "text",
        "paren.rparen",
        "rparen",
        "paren",
        "punctuation.operator",
        "comment"
    ];
    var context;
    var contextCache = {};
    var defaultQuotes = {
        '"': '"',
        "'": "'"
    };
    var initContext = function(editor) {
        var id = -1;
        if (editor.multiSelect) {
            id = editor.selection.index;
            if (contextCache.rangeCount != editor.multiSelect.rangeCount) contextCache = {
                rangeCount: editor.multiSelect.rangeCount
            };
        }
        if (contextCache[id]) return context = contextCache[id];
        context = contextCache[id] = {
            autoInsertedBrackets: 0,
            autoInsertedRow: -1,
            autoInsertedLineEnd: "",
            maybeInsertedBrackets: 0,
            maybeInsertedRow: -1,
            maybeInsertedLineStart: "",
            maybeInsertedLineEnd: ""
        };
    };
    var getWrapped = function(selection, selected, opening, closing) {
        var rowDiff = selection.end.row - selection.start.row;
        return {
            text: opening + selected + closing,
            selection: [
                0,
                selection.start.column + 1,
                rowDiff,
                selection.end.column + (rowDiff ? 0 : 1)
            ]
        };
    };
    var CstyleBehaviour;
    CstyleBehaviour = function(options) {
        options = options || {};
        this.add("braces", "insertion", function(state, action, editor, session, text) {
            var cursor = editor.getCursorPosition();
            var line = session.doc.getLine(cursor.row);
            if (text == "{") {
                initContext(editor);
                var selection = editor.getSelectionRange();
                var selected = session.doc.getTextRange(selection);
                var token = session.getTokenAt(cursor.row, cursor.column);
                if (selected !== "" && selected !== "{" && editor.getWrapBehavioursEnabled()) return getWrapped(selection, selected, "{", "}");
                else if (token && /(?:string)\.quasi|\.xml/.test(token.type)) {
                    var excludeTokens = [
                        /tag\-(?:open|name)/,
                        /attribute\-name/
                    ];
                    if (excludeTokens.some(function(el) {
                        return el.test(token.type);
                    }) || /(string)\.quasi/.test(token.type) && token.value[cursor.column - token.start - 1] !== "$") return;
                    CstyleBehaviour.recordAutoInsert(editor, session, "}");
                    return {
                        text: "{}",
                        selection: [
                            1,
                            1
                        ]
                    };
                } else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
                    if (/[\]\}\)]/.test(line[cursor.column]) || editor.inMultiSelectMode || options.braces) {
                        CstyleBehaviour.recordAutoInsert(editor, session, "}");
                        return {
                            text: "{}",
                            selection: [
                                1,
                                1
                            ]
                        };
                    } else {
                        CstyleBehaviour.recordMaybeInsert(editor, session, "{");
                        return {
                            text: "{",
                            selection: [
                                1,
                                1
                            ]
                        };
                    }
                }
            } else if (text == "}") {
                initContext(editor);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                if (rightChar == "}") {
                    var matching = session.$findOpeningBracket("}", {
                        column: cursor.column + 1,
                        row: cursor.row
                    });
                    if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
                        CstyleBehaviour.popAutoInsertedClosing();
                        return {
                            text: "",
                            selection: [
                                1,
                                1
                            ]
                        };
                    }
                }
            } else if (text == "\n" || text == "\r\n") {
                initContext(editor);
                var closing = "";
                if (CstyleBehaviour.isMaybeInsertedClosing(cursor, line)) {
                    closing = lang.stringRepeat("}", context.maybeInsertedBrackets);
                    CstyleBehaviour.clearMaybeInsertedClosing();
                }
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                if (rightChar === "}") {
                    var openBracePos = session.findMatchingBracket({
                        row: cursor.row,
                        column: cursor.column + 1
                    }, "}");
                    if (!openBracePos) return null;
                    var next_indent = this.$getIndent(session.getLine(openBracePos.row));
                } else if (closing) var next_indent = this.$getIndent(line);
                else {
                    CstyleBehaviour.clearMaybeInsertedClosing();
                    return;
                }
                var indent = next_indent + session.getTabString();
                return {
                    text: "\n" + indent + "\n" + next_indent + closing,
                    selection: [
                        1,
                        indent.length,
                        1,
                        indent.length
                    ]
                };
            } else CstyleBehaviour.clearMaybeInsertedClosing();
        });
        this.add("braces", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && selected == "{") {
                initContext(editor);
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.end.column, range.end.column + 1);
                if (rightChar == "}") {
                    range.end.column++;
                    return range;
                } else context.maybeInsertedBrackets--;
            }
        });
        this.add("parens", "insertion", function(state, action, editor, session, text) {
            if (text == "(") {
                initContext(editor);
                var selection = editor.getSelectionRange();
                var selected = session.doc.getTextRange(selection);
                if (selected !== "" && editor.getWrapBehavioursEnabled()) return getWrapped(selection, selected, "(", ")");
                else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
                    CstyleBehaviour.recordAutoInsert(editor, session, ")");
                    return {
                        text: "()",
                        selection: [
                            1,
                            1
                        ]
                    };
                }
            } else if (text == ")") {
                initContext(editor);
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                if (rightChar == ")") {
                    var matching = session.$findOpeningBracket(")", {
                        column: cursor.column + 1,
                        row: cursor.row
                    });
                    if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
                        CstyleBehaviour.popAutoInsertedClosing();
                        return {
                            text: "",
                            selection: [
                                1,
                                1
                            ]
                        };
                    }
                }
            }
        });
        this.add("parens", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && selected == "(") {
                initContext(editor);
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
                if (rightChar == ")") {
                    range.end.column++;
                    return range;
                }
            }
        });
        this.add("brackets", "insertion", function(state, action, editor, session, text) {
            if (text == "[") {
                initContext(editor);
                var selection = editor.getSelectionRange();
                var selected = session.doc.getTextRange(selection);
                if (selected !== "" && editor.getWrapBehavioursEnabled()) return getWrapped(selection, selected, "[", "]");
                else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
                    CstyleBehaviour.recordAutoInsert(editor, session, "]");
                    return {
                        text: "[]",
                        selection: [
                            1,
                            1
                        ]
                    };
                }
            } else if (text == "]") {
                initContext(editor);
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                if (rightChar == "]") {
                    var matching = session.$findOpeningBracket("]", {
                        column: cursor.column + 1,
                        row: cursor.row
                    });
                    if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
                        CstyleBehaviour.popAutoInsertedClosing();
                        return {
                            text: "",
                            selection: [
                                1,
                                1
                            ]
                        };
                    }
                }
            }
        });
        this.add("brackets", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && selected == "[") {
                initContext(editor);
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
                if (rightChar == "]") {
                    range.end.column++;
                    return range;
                }
            }
        });
        this.add("string_dquotes", "insertion", function(state, action, editor, session, text) {
            var quotes = session.$mode.$quotes || defaultQuotes;
            if (text.length == 1 && quotes[text]) {
                if (this.lineCommentStart && this.lineCommentStart.indexOf(text) != -1) return;
                initContext(editor);
                var quote = text;
                var selection = editor.getSelectionRange();
                var selected = session.doc.getTextRange(selection);
                if (selected !== "" && (selected.length != 1 || !quotes[selected]) && editor.getWrapBehavioursEnabled()) return getWrapped(selection, selected, quote, quote);
                else if (!selected) {
                    var cursor = editor.getCursorPosition();
                    var line = session.doc.getLine(cursor.row);
                    var leftChar = line.substring(cursor.column - 1, cursor.column);
                    var rightChar = line.substring(cursor.column, cursor.column + 1);
                    var token = session.getTokenAt(cursor.row, cursor.column);
                    var rightToken = session.getTokenAt(cursor.row, cursor.column + 1);
                    if (leftChar == "\\" && token && /escape/.test(token.type)) return null;
                    var stringBefore = token && /string|escape/.test(token.type);
                    var stringAfter = !rightToken || /string|escape/.test(rightToken.type);
                    var pair;
                    if (rightChar == quote) {
                        pair = stringBefore !== stringAfter;
                        if (pair && /string\.end/.test(rightToken.type)) pair = false;
                    } else {
                        if (stringBefore && !stringAfter) return null; // wrap string with different quote
                        if (stringBefore && stringAfter) return null; // do not pair quotes inside strings
                        var wordRe = session.$mode.tokenRe;
                        wordRe.lastIndex = 0;
                        var isWordBefore = wordRe.test(leftChar);
                        wordRe.lastIndex = 0;
                        var isWordAfter = wordRe.test(rightChar);
                        var pairQuotesAfter = session.$mode.$pairQuotesAfter;
                        var shouldPairQuotes = pairQuotesAfter && pairQuotesAfter[quote] && pairQuotesAfter[quote].test(leftChar);
                        if (!shouldPairQuotes && isWordBefore || isWordAfter) return null; // before or after alphanumeric
                        if (rightChar && !/[\s;,.})\]\\]/.test(rightChar)) return null; // there is rightChar and it isn't closing
                        var charBefore = line[cursor.column - 2];
                        if (leftChar == quote && (charBefore == quote || wordRe.test(charBefore))) return null;
                        pair = true;
                    }
                    return {
                        text: pair ? quote + quote : "",
                        selection: [
                            1,
                            1
                        ]
                    };
                }
            }
        });
        this.add("string_dquotes", "deletion", function(state, action, editor, session, range) {
            var quotes = session.$mode.$quotes || defaultQuotes;
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && quotes.hasOwnProperty(selected)) {
                initContext(editor);
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
                if (rightChar == selected) {
                    range.end.column++;
                    return range;
                }
            }
        });
        if (options.closeDocComment !== false) this.add("doc comment end", "insertion", function(state, action, editor, session, text) {
            if (state === "doc-start" && (text === "\n" || text === "\r\n") && editor.selection.isEmpty()) {
                var cursor = editor.getCursorPosition();
                if (cursor.column === 0) return;
                var line = session.doc.getLine(cursor.row);
                var nextLine = session.doc.getLine(cursor.row + 1);
                var tokens = session.getTokens(cursor.row);
                var index = 0;
                for(var i = 0; i < tokens.length; i++){
                    index += tokens[i].value.length;
                    var currentToken = tokens[i];
                    if (index >= cursor.column) {
                        if (index === cursor.column) {
                            if (!/\.doc/.test(currentToken.type)) return;
                            if (/\*\//.test(currentToken.value)) {
                                var nextToken = tokens[i + 1];
                                if (!nextToken || !/\.doc/.test(nextToken.type)) return;
                            }
                        }
                        var cursorPosInToken = cursor.column - (index - currentToken.value.length);
                        var closeDocPos = currentToken.value.indexOf("*/");
                        var openDocPos = currentToken.value.indexOf("/**", closeDocPos > -1 ? closeDocPos + 2 : 0);
                        if (openDocPos !== -1 && cursorPosInToken > openDocPos && cursorPosInToken < openDocPos + 3) return;
                        if (closeDocPos !== -1 && openDocPos !== -1 && cursorPosInToken >= closeDocPos && cursorPosInToken <= openDocPos || !/\.doc/.test(currentToken.type)) return;
                        break;
                    }
                }
                var indent = this.$getIndent(line);
                if (/\s*\*/.test(nextLine)) {
                    if (/^\s*\*/.test(line)) return {
                        text: text + indent + "* ",
                        selection: [
                            1,
                            2 + indent.length,
                            1,
                            2 + indent.length
                        ]
                    };
                    else return {
                        text: text + indent + " * ",
                        selection: [
                            1,
                            3 + indent.length,
                            1,
                            3 + indent.length
                        ]
                    };
                }
                if (/\/\*\*/.test(line.substring(0, cursor.column))) return {
                    text: text + indent + " * " + text + " " + indent + "*/",
                    selection: [
                        1,
                        4 + indent.length,
                        1,
                        4 + indent.length
                    ]
                };
            }
        });
    };
    CstyleBehaviour.isSaneInsertion = function(editor, session) {
        var cursor = editor.getCursorPosition();
        var iterator = new TokenIterator(session, cursor.row, cursor.column);
        if (!this.$matchTokenType(iterator.getCurrentToken() || "text", SAFE_INSERT_IN_TOKENS)) {
            if (/[)}\]]/.test(editor.session.getLine(cursor.row)[cursor.column])) return true;
            var iterator2 = new TokenIterator(session, cursor.row, cursor.column + 1);
            if (!this.$matchTokenType(iterator2.getCurrentToken() || "text", SAFE_INSERT_IN_TOKENS)) return false;
        }
        iterator.stepForward();
        return iterator.getCurrentTokenRow() !== cursor.row || this.$matchTokenType(iterator.getCurrentToken() || "text", SAFE_INSERT_BEFORE_TOKENS);
    };
    CstyleBehaviour["$matchTokenType"] = function(token, types) {
        return types.indexOf(token.type || token) > -1;
    };
    CstyleBehaviour["recordAutoInsert"] = function(editor, session, bracket) {
        var cursor = editor.getCursorPosition();
        var line = session.doc.getLine(cursor.row);
        if (!this["isAutoInsertedClosing"](cursor, line, context.autoInsertedLineEnd[0])) context.autoInsertedBrackets = 0;
        context.autoInsertedRow = cursor.row;
        context.autoInsertedLineEnd = bracket + line.substr(cursor.column);
        context.autoInsertedBrackets++;
    };
    CstyleBehaviour["recordMaybeInsert"] = function(editor, session, bracket) {
        var cursor = editor.getCursorPosition();
        var line = session.doc.getLine(cursor.row);
        if (!this["isMaybeInsertedClosing"](cursor, line)) context.maybeInsertedBrackets = 0;
        context.maybeInsertedRow = cursor.row;
        context.maybeInsertedLineStart = line.substr(0, cursor.column) + bracket;
        context.maybeInsertedLineEnd = line.substr(cursor.column);
        context.maybeInsertedBrackets++;
    };
    CstyleBehaviour["isAutoInsertedClosing"] = function(cursor, line, bracket) {
        return context.autoInsertedBrackets > 0 && cursor.row === context.autoInsertedRow && bracket === context.autoInsertedLineEnd[0] && line.substr(cursor.column) === context.autoInsertedLineEnd;
    };
    CstyleBehaviour["isMaybeInsertedClosing"] = function(cursor, line) {
        return context.maybeInsertedBrackets > 0 && cursor.row === context.maybeInsertedRow && line.substr(cursor.column) === context.maybeInsertedLineEnd && line.substr(0, cursor.column) == context.maybeInsertedLineStart;
    };
    CstyleBehaviour["popAutoInsertedClosing"] = function() {
        context.autoInsertedLineEnd = context.autoInsertedLineEnd.substr(1);
        context.autoInsertedBrackets--;
    };
    CstyleBehaviour["clearMaybeInsertedClosing"] = function() {
        if (context) {
            context.maybeInsertedBrackets = 0;
            context.maybeInsertedRow = -1;
        }
    };
    oop.inherits(CstyleBehaviour, Behaviour);
    exports.CstyleBehaviour = CstyleBehaviour;
});
ace.define("ace/unicode", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var wordChars = [
        48,
        9,
        8,
        25,
        5,
        0,
        2,
        25,
        48,
        0,
        11,
        0,
        5,
        0,
        6,
        22,
        2,
        30,
        2,
        457,
        5,
        11,
        15,
        4,
        8,
        0,
        2,
        0,
        18,
        116,
        2,
        1,
        3,
        3,
        9,
        0,
        2,
        2,
        2,
        0,
        2,
        19,
        2,
        82,
        2,
        138,
        2,
        4,
        3,
        155,
        12,
        37,
        3,
        0,
        8,
        38,
        10,
        44,
        2,
        0,
        2,
        1,
        2,
        1,
        2,
        0,
        9,
        26,
        6,
        2,
        30,
        10,
        7,
        61,
        2,
        9,
        5,
        101,
        2,
        7,
        3,
        9,
        2,
        18,
        3,
        0,
        17,
        58,
        3,
        100,
        15,
        53,
        5,
        0,
        6,
        45,
        211,
        57,
        3,
        18,
        2,
        5,
        3,
        11,
        3,
        9,
        2,
        1,
        7,
        6,
        2,
        2,
        2,
        7,
        3,
        1,
        3,
        21,
        2,
        6,
        2,
        0,
        4,
        3,
        3,
        8,
        3,
        1,
        3,
        3,
        9,
        0,
        5,
        1,
        2,
        4,
        3,
        11,
        16,
        2,
        2,
        5,
        5,
        1,
        3,
        21,
        2,
        6,
        2,
        1,
        2,
        1,
        2,
        1,
        3,
        0,
        2,
        4,
        5,
        1,
        3,
        2,
        4,
        0,
        8,
        3,
        2,
        0,
        8,
        15,
        12,
        2,
        2,
        8,
        2,
        2,
        2,
        21,
        2,
        6,
        2,
        1,
        2,
        4,
        3,
        9,
        2,
        2,
        2,
        2,
        3,
        0,
        16,
        3,
        3,
        9,
        18,
        2,
        2,
        7,
        3,
        1,
        3,
        21,
        2,
        6,
        2,
        1,
        2,
        4,
        3,
        8,
        3,
        1,
        3,
        2,
        9,
        1,
        5,
        1,
        2,
        4,
        3,
        9,
        2,
        0,
        17,
        1,
        2,
        5,
        4,
        2,
        2,
        3,
        4,
        1,
        2,
        0,
        2,
        1,
        4,
        1,
        4,
        2,
        4,
        11,
        5,
        4,
        4,
        2,
        2,
        3,
        3,
        0,
        7,
        0,
        15,
        9,
        18,
        2,
        2,
        7,
        2,
        2,
        2,
        22,
        2,
        9,
        2,
        4,
        4,
        7,
        2,
        2,
        2,
        3,
        8,
        1,
        2,
        1,
        7,
        3,
        3,
        9,
        19,
        1,
        2,
        7,
        2,
        2,
        2,
        22,
        2,
        9,
        2,
        4,
        3,
        8,
        2,
        2,
        2,
        3,
        8,
        1,
        8,
        0,
        2,
        3,
        3,
        9,
        19,
        1,
        2,
        7,
        2,
        2,
        2,
        22,
        2,
        15,
        4,
        7,
        2,
        2,
        2,
        3,
        10,
        0,
        9,
        3,
        3,
        9,
        11,
        5,
        3,
        1,
        2,
        17,
        4,
        23,
        2,
        8,
        2,
        0,
        3,
        6,
        4,
        0,
        5,
        5,
        2,
        0,
        2,
        7,
        19,
        1,
        14,
        57,
        6,
        14,
        2,
        9,
        40,
        1,
        2,
        0,
        3,
        1,
        2,
        0,
        3,
        0,
        7,
        3,
        2,
        6,
        2,
        2,
        2,
        0,
        2,
        0,
        3,
        1,
        2,
        12,
        2,
        2,
        3,
        4,
        2,
        0,
        2,
        5,
        3,
        9,
        3,
        1,
        35,
        0,
        24,
        1,
        7,
        9,
        12,
        0,
        2,
        0,
        2,
        0,
        5,
        9,
        2,
        35,
        5,
        19,
        2,
        5,
        5,
        7,
        2,
        35,
        10,
        0,
        58,
        73,
        7,
        77,
        3,
        37,
        11,
        42,
        2,
        0,
        4,
        328,
        2,
        3,
        3,
        6,
        2,
        0,
        2,
        3,
        3,
        40,
        2,
        3,
        3,
        32,
        2,
        3,
        3,
        6,
        2,
        0,
        2,
        3,
        3,
        14,
        2,
        56,
        2,
        3,
        3,
        66,
        5,
        0,
        33,
        15,
        17,
        84,
        13,
        619,
        3,
        16,
        2,
        25,
        6,
        74,
        22,
        12,
        2,
        6,
        12,
        20,
        12,
        19,
        13,
        12,
        2,
        2,
        2,
        1,
        13,
        51,
        3,
        29,
        4,
        0,
        5,
        1,
        3,
        9,
        34,
        2,
        3,
        9,
        7,
        87,
        9,
        42,
        6,
        69,
        11,
        28,
        4,
        11,
        5,
        11,
        11,
        39,
        3,
        4,
        12,
        43,
        5,
        25,
        7,
        10,
        38,
        27,
        5,
        62,
        2,
        28,
        3,
        10,
        7,
        9,
        14,
        0,
        89,
        75,
        5,
        9,
        18,
        8,
        13,
        42,
        4,
        11,
        71,
        55,
        9,
        9,
        4,
        48,
        83,
        2,
        2,
        30,
        14,
        230,
        23,
        280,
        3,
        5,
        3,
        37,
        3,
        5,
        3,
        7,
        2,
        0,
        2,
        0,
        2,
        0,
        2,
        30,
        3,
        52,
        2,
        6,
        2,
        0,
        4,
        2,
        2,
        6,
        4,
        3,
        3,
        5,
        5,
        12,
        6,
        2,
        2,
        6,
        67,
        1,
        20,
        0,
        29,
        0,
        14,
        0,
        17,
        4,
        60,
        12,
        5,
        0,
        4,
        11,
        18,
        0,
        5,
        0,
        3,
        9,
        2,
        0,
        4,
        4,
        7,
        0,
        2,
        0,
        2,
        0,
        2,
        3,
        2,
        10,
        3,
        3,
        6,
        4,
        5,
        0,
        53,
        1,
        2684,
        46,
        2,
        46,
        2,
        132,
        7,
        6,
        15,
        37,
        11,
        53,
        10,
        0,
        17,
        22,
        10,
        6,
        2,
        6,
        2,
        6,
        2,
        6,
        2,
        6,
        2,
        6,
        2,
        6,
        2,
        6,
        2,
        31,
        48,
        0,
        470,
        1,
        36,
        5,
        2,
        4,
        6,
        1,
        5,
        85,
        3,
        1,
        3,
        2,
        2,
        89,
        2,
        3,
        6,
        40,
        4,
        93,
        18,
        23,
        57,
        15,
        513,
        6581,
        75,
        20939,
        53,
        1164,
        68,
        45,
        3,
        268,
        4,
        27,
        21,
        31,
        3,
        13,
        13,
        1,
        2,
        24,
        9,
        69,
        11,
        1,
        38,
        8,
        3,
        102,
        3,
        1,
        111,
        44,
        25,
        51,
        13,
        68,
        12,
        9,
        7,
        23,
        4,
        0,
        5,
        45,
        3,
        35,
        13,
        28,
        4,
        64,
        15,
        10,
        39,
        54,
        10,
        13,
        3,
        9,
        7,
        22,
        4,
        1,
        5,
        66,
        25,
        2,
        227,
        42,
        2,
        1,
        3,
        9,
        7,
        11171,
        13,
        22,
        5,
        48,
        8453,
        301,
        3,
        61,
        3,
        105,
        39,
        6,
        13,
        4,
        6,
        11,
        2,
        12,
        2,
        4,
        2,
        0,
        2,
        1,
        2,
        1,
        2,
        107,
        34,
        362,
        19,
        63,
        3,
        53,
        41,
        11,
        5,
        15,
        17,
        6,
        13,
        1,
        25,
        2,
        33,
        4,
        2,
        134,
        20,
        9,
        8,
        25,
        5,
        0,
        2,
        25,
        12,
        88,
        4,
        5,
        3,
        5,
        3,
        5,
        3,
        2
    ];
    var code = 0;
    var str = [];
    for(var i = 0; i < wordChars.length; i += 2){
        str.push(code += wordChars[i]);
        if (wordChars[i + 1]) str.push(45, code += wordChars[i + 1]);
    }
    exports.wordChars = String.fromCharCode.apply(null, str);
});
ace.define("ace/mode/text", [
    "require",
    "exports",
    "module",
    "ace/config",
    "ace/tokenizer",
    "ace/mode/text_highlight_rules",
    "ace/mode/behaviour/cstyle",
    "ace/unicode",
    "ace/lib/lang",
    "ace/token_iterator",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var config = require("../config");
    var Tokenizer = require("../tokenizer").Tokenizer;
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var CstyleBehaviour = require("./behaviour/cstyle").CstyleBehaviour;
    var unicode = require("../unicode");
    var lang = require("../lib/lang");
    var TokenIterator = require("../token_iterator").TokenIterator;
    var Range = require("../range").Range;
    var Mode;
    Mode = function() {
        this.HighlightRules = TextHighlightRules;
    };
    (function() {
        this.$defaultBehaviour = new CstyleBehaviour();
        this.tokenRe = new RegExp("^[" + unicode.wordChars + "\\$_]+", "g");
        this.nonTokenRe = new RegExp("^(?:[^" + unicode.wordChars + "\\$_]|\\s])+", "g");
        this.getTokenizer = function() {
            if (!this.$tokenizer) {
                this.$highlightRules = this.$highlightRules || new this.HighlightRules(this.$highlightRuleConfig);
                this.$tokenizer = new Tokenizer(this.$highlightRules.getRules());
            }
            return this.$tokenizer;
        };
        this.lineCommentStart = "";
        this.blockComment = "";
        this.toggleCommentLines = function(state, session, startRow, endRow) {
            var doc = session.doc;
            var ignoreBlankLines = true;
            var shouldRemove = true;
            var minIndent = Infinity;
            var tabSize = session.getTabSize();
            var insertAtTabStop = false;
            if (!this.lineCommentStart) {
                if (!this.blockComment) return false;
                var lineCommentStart = this.blockComment.start;
                var lineCommentEnd = this.blockComment.end;
                var regexpStart = new RegExp("^(\\s*)(?:" + lang.escapeRegExp(lineCommentStart) + ")");
                var regexpEnd = new RegExp("(?:" + lang.escapeRegExp(lineCommentEnd) + ")\\s*$");
                var comment = function(line, i) {
                    if (testRemove(line, i)) return;
                    if (!ignoreBlankLines || /\S/.test(line)) {
                        doc.insertInLine({
                            row: i,
                            column: line.length
                        }, lineCommentEnd);
                        doc.insertInLine({
                            row: i,
                            column: minIndent
                        }, lineCommentStart);
                    }
                };
                var uncomment = function(line, i) {
                    var m;
                    if (m = line.match(regexpEnd)) doc.removeInLine(i, line.length - m[0].length, line.length);
                    if (m = line.match(regexpStart)) doc.removeInLine(i, m[1].length, m[0].length);
                };
                var testRemove = function(line, row) {
                    if (regexpStart.test(line)) return true;
                    var tokens = session.getTokens(row);
                    for(var i = 0; i < tokens.length; i++){
                        if (tokens[i].type === "comment") return true;
                    }
                };
            } else {
                if (Array.isArray(this.lineCommentStart)) {
                    var regexpStart = this.lineCommentStart.map(lang.escapeRegExp).join("|");
                    var lineCommentStart = this.lineCommentStart[0];
                } else {
                    var regexpStart = lang.escapeRegExp(this.lineCommentStart);
                    var lineCommentStart = this.lineCommentStart;
                }
                regexpStart = new RegExp("^(\\s*)(?:" + regexpStart + ") ?");
                insertAtTabStop = session.getUseSoftTabs();
                var uncomment = function(line, i) {
                    var m = line.match(regexpStart);
                    if (!m) return;
                    var start = m[1].length, end = m[0].length;
                    if (!shouldInsertSpace(line, start, end) && m[0][end - 1] == " ") end--;
                    doc.removeInLine(i, start, end);
                };
                var commentWithSpace = lineCommentStart + " ";
                var comment = function(line, i) {
                    if (!ignoreBlankLines || /\S/.test(line)) {
                        if (shouldInsertSpace(line, minIndent, minIndent)) doc.insertInLine({
                            row: i,
                            column: minIndent
                        }, commentWithSpace);
                        else doc.insertInLine({
                            row: i,
                            column: minIndent
                        }, lineCommentStart);
                    }
                };
                var testRemove = function(line, i) {
                    return regexpStart.test(line);
                };
                var shouldInsertSpace = function(line, before, after) {
                    var spaces = 0;
                    while(before-- && line.charAt(before) == " ")spaces++;
                    if (spaces % tabSize != 0) return false;
                    var spaces = 0;
                    while(line.charAt(after++) == " ")spaces++;
                    if (tabSize > 2) return spaces % tabSize != tabSize - 1;
                    else return spaces % tabSize == 0;
                };
            }
            function iter(fun) {
                for(var i = startRow; i <= endRow; i++)fun(doc.getLine(i), i);
            }
            var minEmptyLength = Infinity;
            iter(function(line, i) {
                var indent = line.search(/\S/);
                if (indent !== -1) {
                    if (indent < minIndent) minIndent = indent;
                    if (shouldRemove && !testRemove(line, i)) shouldRemove = false;
                } else if (minEmptyLength > line.length) minEmptyLength = line.length;
            });
            if (minIndent == Infinity) {
                minIndent = minEmptyLength;
                ignoreBlankLines = false;
                shouldRemove = false;
            }
            if (insertAtTabStop && minIndent % tabSize != 0) minIndent = Math.floor(minIndent / tabSize) * tabSize;
            iter(shouldRemove ? uncomment : comment);
        };
        this.toggleBlockComment = function(state, session, range, cursor) {
            var comment = this.blockComment;
            if (!comment) return;
            if (!comment.start && comment[0]) comment = comment[0];
            var iterator = new TokenIterator(session, cursor.row, cursor.column);
            var token = iterator.getCurrentToken();
            var sel = session.selection;
            var initialRange = session.selection.toOrientedRange();
            var startRow, colDiff;
            if (token && /comment/.test(token.type)) {
                var startRange, endRange;
                while(token && /comment/.test(token.type)){
                    var i = token.value.indexOf(comment.start);
                    if (i != -1) {
                        var row = iterator.getCurrentTokenRow();
                        var column = iterator.getCurrentTokenColumn() + i;
                        startRange = new Range(row, column, row, column + comment.start.length);
                        break;
                    }
                    token = iterator.stepBackward();
                }
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                while(token && /comment/.test(token.type)){
                    var i = token.value.indexOf(comment.end);
                    if (i != -1) {
                        var row = iterator.getCurrentTokenRow();
                        var column = iterator.getCurrentTokenColumn() + i;
                        endRange = new Range(row, column, row, column + comment.end.length);
                        break;
                    }
                    token = iterator.stepForward();
                }
                if (endRange) session.remove(endRange);
                if (startRange) {
                    session.remove(startRange);
                    startRow = startRange.start.row;
                    colDiff = -comment.start.length;
                }
            } else {
                colDiff = comment.start.length;
                startRow = range.start.row;
                session.insert(range.end, comment.end);
                session.insert(range.start, comment.start);
            }
            if (initialRange.start.row == startRow) initialRange.start.column += colDiff;
            if (initialRange.end.row == startRow) initialRange.end.column += colDiff;
            session.selection.fromOrientedRange(initialRange);
        };
        this.getNextLineIndent = function(state, line, tab) {
            return this.$getIndent(line);
        };
        this.checkOutdent = function(state, line, input) {
            return false;
        };
        this.autoOutdent = function(state, doc, row) {};
        this.$getIndent = function(line) {
            return line.match(/^\s*/)[0];
        };
        this.createWorker = function(session) {
            return null;
        };
        this.createModeDelegates = function(mapping) {
            this.$embeds = [];
            this.$modes = {};
            for(var i in mapping)if (mapping[i]) {
                var Mode = mapping[i];
                var id = Mode.prototype.$id;
                var mode = config.$modes[id];
                if (!mode) config.$modes[id] = mode = new Mode();
                if (!config.$modes[i]) config.$modes[i] = mode;
                this.$embeds.push(i);
                this.$modes[i] = mode;
            }
            var delegations = [
                "toggleBlockComment",
                "toggleCommentLines",
                "getNextLineIndent",
                "checkOutdent",
                "autoOutdent",
                "transformAction",
                "getCompletions"
            ];
            var _loop_1 = function(i) {
                (function(scope) {
                    var functionName = delegations[i];
                    var defaultHandler = scope[functionName];
                    scope[delegations[i]] = function() {
                        return this.$delegator(functionName, arguments, defaultHandler);
                    };
                })(this_1);
            };
            var this_1 = this;
            for(var i = 0; i < delegations.length; i++)_loop_1(i);
        };
        this.$delegator = function(method, args, defaultHandler) {
            var state = args[0] || "start";
            if (typeof state != "string") {
                if (Array.isArray(state[2])) {
                    var language = state[2][state[2].length - 1];
                    var mode = this.$modes[language];
                    if (mode) return mode[method].apply(mode, [
                        state[1]
                    ].concat([].slice.call(args, 1)));
                }
                state = state[0] || "start";
            }
            for(var i = 0; i < this.$embeds.length; i++){
                if (!this.$modes[this.$embeds[i]]) continue;
                var split = state.split(this.$embeds[i]);
                if (!split[0] && split[1]) {
                    args[0] = split[1];
                    var mode = this.$modes[this.$embeds[i]];
                    return mode[method].apply(mode, args);
                }
            }
            var ret = defaultHandler.apply(this, args);
            return defaultHandler ? ret : undefined;
        };
        this.transformAction = function(state, action, editor, session, param) {
            if (this.$behaviour) {
                var behaviours = this.$behaviour.getBehaviours();
                for(var key in behaviours)if (behaviours[key][action]) {
                    var ret = behaviours[key][action].apply(this, arguments);
                    if (ret) return ret;
                }
            }
        };
        this.getKeywords = function(append) {
            if (!this.completionKeywords) {
                var rules = this.$tokenizer["rules"];
                var completionKeywords = [];
                for(var rule in rules){
                    var ruleItr = rules[rule];
                    for(var r = 0, l = ruleItr.length; r < l; r++){
                        if (typeof ruleItr[r].token === "string") {
                            if (/keyword|support|storage/.test(ruleItr[r].token)) completionKeywords.push(ruleItr[r].regex);
                        } else if (typeof ruleItr[r].token === "object") {
                            for(var a = 0, aLength = ruleItr[r].token.length; a < aLength; a++)if (/keyword|support|storage/.test(ruleItr[r].token[a])) {
                                var rule = ruleItr[r].regex.match(/\(.+?\)/g)[a];
                                completionKeywords.push(rule.substr(1, rule.length - 2));
                            }
                        }
                    }
                }
                this.completionKeywords = completionKeywords;
            }
            if (!append) return this.$keywordList;
            return completionKeywords.concat(this.$keywordList || []);
        };
        this.$createKeywordList = function() {
            if (!this.$highlightRules) this.getTokenizer();
            return this.$keywordList = this.$highlightRules.$keywordList || [];
        };
        this.getCompletions = function(state, session, pos, prefix) {
            var keywords = this.$keywordList || this.$createKeywordList();
            return keywords.map(function(word) {
                return {
                    name: word,
                    value: word,
                    score: 0,
                    meta: "keyword"
                };
            });
        };
        this.$id = "ace/mode/text";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
ace.define("ace/apply_delta", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    function throwDeltaError(delta, errorText) {
        console.log("Invalid Delta:", delta);
        throw "Invalid Delta: " + errorText;
    }
    function positionInDocument(docLines, position) {
        return position.row >= 0 && position.row < docLines.length && position.column >= 0 && position.column <= docLines[position.row].length;
    }
    function validateDelta(docLines, delta) {
        if (delta.action != "insert" && delta.action != "remove") throwDeltaError(delta, "delta.action must be 'insert' or 'remove'");
        if (!(delta.lines instanceof Array)) throwDeltaError(delta, "delta.lines must be an Array");
        if (!delta.start || !delta.end) throwDeltaError(delta, "delta.start/end must be an present");
        var start = delta.start;
        if (!positionInDocument(docLines, delta.start)) throwDeltaError(delta, "delta.start must be contained in document");
        var end = delta.end;
        if (delta.action == "remove" && !positionInDocument(docLines, end)) throwDeltaError(delta, "delta.end must contained in document for 'remove' actions");
        var numRangeRows = end.row - start.row;
        var numRangeLastLineChars = end.column - (numRangeRows == 0 ? start.column : 0);
        if (numRangeRows != delta.lines.length - 1 || delta.lines[numRangeRows].length != numRangeLastLineChars) throwDeltaError(delta, "delta.range must match delta lines");
    }
    exports.applyDelta = function(docLines, delta, doNotValidate) {
        var row = delta.start.row;
        var startColumn = delta.start.column;
        var line = docLines[row] || "";
        switch(delta.action){
            case "insert":
                var lines = delta.lines;
                if (lines.length === 1) docLines[row] = line.substring(0, startColumn) + delta.lines[0] + line.substring(startColumn);
                else {
                    var args = [
                        row,
                        1
                    ].concat(delta.lines);
                    docLines.splice.apply(docLines, args);
                    docLines[row] = line.substring(0, startColumn) + docLines[row];
                    docLines[row + delta.lines.length - 1] += line.substring(startColumn);
                }
                break;
            case "remove":
                var endColumn = delta.end.column;
                var endRow = delta.end.row;
                if (row === endRow) docLines[row] = line.substring(0, startColumn) + line.substring(endColumn);
                else docLines.splice(row, endRow - row + 1, line.substring(0, startColumn) + docLines[endRow].substring(endColumn));
                break;
        }
    };
});
ace.define("ace/anchor", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/event_emitter"
], function(require, exports, module1) {
    "use strict";
    var oop = require("./lib/oop");
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var Anchor = /** @class */ function() {
        function Anchor(doc, row, column) {
            this.$onChange = this.onChange.bind(this);
            this.attach(doc);
            if (typeof row != "number") this.setPosition(row.row, row.column);
            else this.setPosition(row, column);
        }
        Anchor.prototype.getPosition = function() {
            return this.$clipPositionToDocument(this.row, this.column);
        };
        Anchor.prototype.getDocument = function() {
            return this.document;
        };
        Anchor.prototype.onChange = function(delta) {
            if (delta.start.row == delta.end.row && delta.start.row != this.row) return;
            if (delta.start.row > this.row) return;
            var point = $getTransformedPoint(delta, {
                row: this.row,
                column: this.column
            }, this.$insertRight);
            this.setPosition(point.row, point.column, true);
        };
        Anchor.prototype.setPosition = function(row, column, noClip) {
            var pos;
            if (noClip) pos = {
                row: row,
                column: column
            };
            else pos = this.$clipPositionToDocument(row, column);
            if (this.row == pos.row && this.column == pos.column) return;
            var old = {
                row: this.row,
                column: this.column
            };
            this.row = pos.row;
            this.column = pos.column;
            this._signal("change", {
                old: old,
                value: pos
            });
        };
        Anchor.prototype.detach = function() {
            this.document.off("change", this.$onChange);
        };
        Anchor.prototype.attach = function(doc) {
            this.document = doc || this.document;
            this.document.on("change", this.$onChange);
        };
        Anchor.prototype.$clipPositionToDocument = function(row, column) {
            var pos = {};
            if (row >= this.document.getLength()) {
                pos.row = Math.max(0, this.document.getLength() - 1);
                pos.column = this.document.getLine(pos.row).length;
            } else if (row < 0) {
                pos.row = 0;
                pos.column = 0;
            } else {
                pos.row = row;
                pos.column = Math.min(this.document.getLine(pos.row).length, Math.max(0, column));
            }
            if (column < 0) pos.column = 0;
            return pos;
        };
        return Anchor;
    }();
    Anchor.prototype.$insertRight = false;
    oop.implement(Anchor.prototype, EventEmitter);
    function $pointsInOrder(point1, point2, equalPointsInOrder) {
        var bColIsAfter = equalPointsInOrder ? point1.column <= point2.column : point1.column < point2.column;
        return point1.row < point2.row || point1.row == point2.row && bColIsAfter;
    }
    function $getTransformedPoint(delta, point, moveIfEqual) {
        var deltaIsInsert = delta.action == "insert";
        var deltaRowShift = (deltaIsInsert ? 1 : -1) * (delta.end.row - delta.start.row);
        var deltaColShift = (deltaIsInsert ? 1 : -1) * (delta.end.column - delta.start.column);
        var deltaStart = delta.start;
        var deltaEnd = deltaIsInsert ? deltaStart : delta.end; // Collapse insert range.
        if ($pointsInOrder(point, deltaStart, moveIfEqual)) return {
            row: point.row,
            column: point.column
        };
        if ($pointsInOrder(deltaEnd, point, !moveIfEqual)) return {
            row: point.row + deltaRowShift,
            column: point.column + (point.row == deltaEnd.row ? deltaColShift : 0)
        };
        return {
            row: deltaStart.row,
            column: deltaStart.column
        };
    }
    exports.Anchor = Anchor;
});
ace.define("ace/document", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/apply_delta",
    "ace/lib/event_emitter",
    "ace/range",
    "ace/anchor"
], function(require, exports, module1) {
    "use strict";
    var oop = require("./lib/oop");
    var applyDelta = require("./apply_delta").applyDelta;
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var Range = require("./range").Range;
    var Anchor = require("./anchor").Anchor;
    var Document = /** @class */ function() {
        function Document(textOrLines) {
            this.$lines = [
                ""
            ];
            if (textOrLines.length === 0) this.$lines = [
                ""
            ];
            else if (Array.isArray(textOrLines)) this.insertMergedLines({
                row: 0,
                column: 0
            }, textOrLines);
            else this.insert({
                row: 0,
                column: 0
            }, textOrLines);
        }
        Document.prototype.setValue = function(text) {
            var len = this.getLength() - 1;
            this.remove(new Range(0, 0, len, this.getLine(len).length));
            this.insert({
                row: 0,
                column: 0
            }, text || "");
        };
        Document.prototype.getValue = function() {
            return this.getAllLines().join(this.getNewLineCharacter());
        };
        Document.prototype.createAnchor = function(row, column) {
            return new Anchor(this, row, column);
        };
        Document.prototype.$detectNewLine = function(text) {
            var match = text.match(/^.*?(\r\n|\r|\n)/m);
            this.$autoNewLine = match ? match[1] : "\n";
            this._signal("changeNewLineMode");
        };
        Document.prototype.getNewLineCharacter = function() {
            switch(this.$newLineMode){
                case "windows":
                    return "\r\n";
                case "unix":
                    return "\n";
                default:
                    return this.$autoNewLine || "\n";
            }
        };
        Document.prototype.setNewLineMode = function(newLineMode) {
            if (this.$newLineMode === newLineMode) return;
            this.$newLineMode = newLineMode;
            this._signal("changeNewLineMode");
        };
        Document.prototype.getNewLineMode = function() {
            return this.$newLineMode;
        };
        Document.prototype.isNewLine = function(text) {
            return text == "\r\n" || text == "\r" || text == "\n";
        };
        Document.prototype.getLine = function(row) {
            return this.$lines[row] || "";
        };
        Document.prototype.getLines = function(firstRow, lastRow) {
            return this.$lines.slice(firstRow, lastRow + 1);
        };
        Document.prototype.getAllLines = function() {
            return this.getLines(0, this.getLength());
        };
        Document.prototype.getLength = function() {
            return this.$lines.length;
        };
        Document.prototype.getTextRange = function(range) {
            return this.getLinesForRange(range).join(this.getNewLineCharacter());
        };
        Document.prototype.getLinesForRange = function(range) {
            var lines;
            if (range.start.row === range.end.row) lines = [
                this.getLine(range.start.row).substring(range.start.column, range.end.column)
            ];
            else {
                lines = this.getLines(range.start.row, range.end.row);
                lines[0] = (lines[0] || "").substring(range.start.column);
                var l = lines.length - 1;
                if (range.end.row - range.start.row == l) lines[l] = lines[l].substring(0, range.end.column);
            }
            return lines;
        };
        Document.prototype.insertLines = function(row, lines) {
            console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead.");
            return this.insertFullLines(row, lines);
        };
        Document.prototype.removeLines = function(firstRow, lastRow) {
            console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead.");
            return this.removeFullLines(firstRow, lastRow);
        };
        Document.prototype.insertNewLine = function(position) {
            console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.");
            return this.insertMergedLines(position, [
                "",
                ""
            ]);
        };
        Document.prototype.insert = function(position, text) {
            if (this.getLength() <= 1) this.$detectNewLine(text);
            return this.insertMergedLines(position, this.$split(text));
        };
        Document.prototype.insertInLine = function(position, text) {
            var start = this.clippedPos(position.row, position.column);
            var end = this.pos(position.row, position.column + text.length);
            this.applyDelta({
                start: start,
                end: end,
                action: "insert",
                lines: [
                    text
                ]
            }, true);
            return this.clonePos(end);
        };
        Document.prototype.clippedPos = function(row, column) {
            var length = this.getLength();
            if (row === undefined) row = length;
            else if (row < 0) row = 0;
            else if (row >= length) {
                row = length - 1;
                column = undefined;
            }
            var line = this.getLine(row);
            if (column == undefined) column = line.length;
            column = Math.min(Math.max(column, 0), line.length);
            return {
                row: row,
                column: column
            };
        };
        Document.prototype.clonePos = function(pos) {
            return {
                row: pos.row,
                column: pos.column
            };
        };
        Document.prototype.pos = function(row, column) {
            return {
                row: row,
                column: column
            };
        };
        Document.prototype.$clipPosition = function(position) {
            var length = this.getLength();
            if (position.row >= length) {
                position.row = Math.max(0, length - 1);
                position.column = this.getLine(length - 1).length;
            } else {
                position.row = Math.max(0, position.row);
                position.column = Math.min(Math.max(position.column, 0), this.getLine(position.row).length);
            }
            return position;
        };
        Document.prototype.insertFullLines = function(row, lines) {
            row = Math.min(Math.max(row, 0), this.getLength());
            var column = 0;
            if (row < this.getLength()) {
                lines = lines.concat([
                    ""
                ]);
                column = 0;
            } else {
                lines = [
                    ""
                ].concat(lines);
                row--;
                column = this.$lines[row].length;
            }
            this.insertMergedLines({
                row: row,
                column: column
            }, lines);
        };
        Document.prototype.insertMergedLines = function(position, lines) {
            var start = this.clippedPos(position.row, position.column);
            var end = {
                row: start.row + lines.length - 1,
                column: (lines.length == 1 ? start.column : 0) + lines[lines.length - 1].length
            };
            this.applyDelta({
                start: start,
                end: end,
                action: "insert",
                lines: lines
            });
            return this.clonePos(end);
        };
        Document.prototype.remove = function(range) {
            var start = this.clippedPos(range.start.row, range.start.column);
            var end = this.clippedPos(range.end.row, range.end.column);
            this.applyDelta({
                start: start,
                end: end,
                action: "remove",
                lines: this.getLinesForRange({
                    start: start,
                    end: end
                })
            });
            return this.clonePos(start);
        };
        Document.prototype.removeInLine = function(row, startColumn, endColumn) {
            var start = this.clippedPos(row, startColumn);
            var end = this.clippedPos(row, endColumn);
            this.applyDelta({
                start: start,
                end: end,
                action: "remove",
                lines: this.getLinesForRange({
                    start: start,
                    end: end
                })
            }, true);
            return this.clonePos(start);
        };
        Document.prototype.removeFullLines = function(firstRow, lastRow) {
            firstRow = Math.min(Math.max(0, firstRow), this.getLength() - 1);
            lastRow = Math.min(Math.max(0, lastRow), this.getLength() - 1);
            var deleteFirstNewLine = lastRow == this.getLength() - 1 && firstRow > 0;
            var deleteLastNewLine = lastRow < this.getLength() - 1;
            var startRow = deleteFirstNewLine ? firstRow - 1 : firstRow;
            var startCol = deleteFirstNewLine ? this.getLine(startRow).length : 0;
            var endRow = deleteLastNewLine ? lastRow + 1 : lastRow;
            var endCol = deleteLastNewLine ? 0 : this.getLine(endRow).length;
            var range = new Range(startRow, startCol, endRow, endCol);
            var deletedLines = this.$lines.slice(firstRow, lastRow + 1);
            this.applyDelta({
                start: range.start,
                end: range.end,
                action: "remove",
                lines: this.getLinesForRange(range)
            });
            return deletedLines;
        };
        Document.prototype.removeNewLine = function(row) {
            if (row < this.getLength() - 1 && row >= 0) this.applyDelta({
                start: this.pos(row, this.getLine(row).length),
                end: this.pos(row + 1, 0),
                action: "remove",
                lines: [
                    "",
                    ""
                ]
            });
        };
        Document.prototype.replace = function(range, text) {
            if (!(range instanceof Range)) range = Range.fromPoints(range.start, range.end);
            if (text.length === 0 && range.isEmpty()) return range.start;
            if (text == this.getTextRange(range)) return range.end;
            this.remove(range);
            var end;
            if (text) end = this.insert(range.start, text);
            else end = range.start;
            return end;
        };
        Document.prototype.applyDeltas = function(deltas) {
            for(var i = 0; i < deltas.length; i++)this.applyDelta(deltas[i]);
        };
        Document.prototype.revertDeltas = function(deltas) {
            for(var i = deltas.length - 1; i >= 0; i--)this.revertDelta(deltas[i]);
        };
        Document.prototype.applyDelta = function(delta, doNotValidate) {
            var isInsert = delta.action == "insert";
            if (isInsert ? delta.lines.length <= 1 && !delta.lines[0] : !Range.comparePoints(delta.start, delta.end)) return;
            if (isInsert && delta.lines.length > 20000) this.$splitAndapplyLargeDelta(delta, 20000);
            else {
                applyDelta(this.$lines, delta, doNotValidate);
                this._signal("change", delta);
            }
        };
        Document.prototype.$safeApplyDelta = function(delta) {
            var docLength = this.$lines.length;
            if (delta.action == "remove" && delta.start.row < docLength && delta.end.row < docLength || delta.action == "insert" && delta.start.row <= docLength) this.applyDelta(delta);
        };
        Document.prototype.$splitAndapplyLargeDelta = function(delta, MAX) {
            var lines = delta.lines;
            var l = lines.length - MAX + 1;
            var row = delta.start.row;
            var column = delta.start.column;
            for(var from = 0, to = 0; from < l; from = to){
                to += MAX - 1;
                var chunk = lines.slice(from, to);
                chunk.push("");
                this.applyDelta({
                    start: this.pos(row + from, column),
                    end: this.pos(row + to, column = 0),
                    action: delta.action,
                    lines: chunk
                }, true);
            }
            delta.lines = lines.slice(from);
            delta.start.row = row + from;
            delta.start.column = column;
            this.applyDelta(delta, true);
        };
        Document.prototype.revertDelta = function(delta) {
            this.$safeApplyDelta({
                start: this.clonePos(delta.start),
                end: this.clonePos(delta.end),
                action: delta.action == "insert" ? "remove" : "insert",
                lines: delta.lines.slice()
            });
        };
        Document.prototype.indexToPosition = function(index, startRow) {
            var lines = this.$lines || this.getAllLines();
            var newlineLength = this.getNewLineCharacter().length;
            for(var i = startRow || 0, l = lines.length; i < l; i++){
                index -= lines[i].length + newlineLength;
                if (index < 0) return {
                    row: i,
                    column: index + lines[i].length + newlineLength
                };
            }
            return {
                row: l - 1,
                column: index + lines[l - 1].length + newlineLength
            };
        };
        Document.prototype.positionToIndex = function(pos, startRow) {
            var lines = this.$lines || this.getAllLines();
            var newlineLength = this.getNewLineCharacter().length;
            var index = 0;
            var row = Math.min(pos.row, lines.length);
            for(var i = startRow || 0; i < row; ++i)index += lines[i].length + newlineLength;
            return index + pos.column;
        };
        Document.prototype.$split = function(text) {
            return text.split(/\r\n|\r|\n/);
        };
        return Document;
    }();
    Document.prototype.$autoNewLine = "";
    Document.prototype.$newLineMode = "auto";
    oop.implement(Document.prototype, EventEmitter);
    exports.Document = Document;
});
ace.define("ace/background_tokenizer", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/event_emitter"
], function(require, exports, module1) {
    "use strict";
    var oop = require("./lib/oop");
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var BackgroundTokenizer = /** @class */ function() {
        function BackgroundTokenizer(tokenizer, session) {
            this.running = false;
            this.lines = [];
            this.states = [];
            this.currentLine = 0;
            this.tokenizer = tokenizer;
            var self1 = this;
            this.$worker = function() {
                if (!self1.running) return;
                var workerStart = new Date();
                var currentLine = self1.currentLine;
                var endLine = -1;
                var doc = self1.doc;
                var startLine = currentLine;
                while(self1.lines[currentLine])currentLine++;
                var len = doc.getLength();
                var processedLines = 0;
                self1.running = false;
                while(currentLine < len){
                    self1.$tokenizeRow(currentLine);
                    endLine = currentLine;
                    do currentLine++;
                    while (self1.lines[currentLine]);
                    processedLines++;
                    if (processedLines % 5 === 0 && new Date() - workerStart > 20) {
                        self1.running = setTimeout(self1.$worker, 20);
                        break;
                    }
                }
                self1.currentLine = currentLine;
                if (endLine == -1) endLine = currentLine;
                if (startLine <= endLine) self1.fireUpdateEvent(startLine, endLine);
            };
        }
        BackgroundTokenizer.prototype.setTokenizer = function(tokenizer) {
            this.tokenizer = tokenizer;
            this.lines = [];
            this.states = [];
            this.start(0);
        };
        BackgroundTokenizer.prototype.setDocument = function(doc) {
            this.doc = doc;
            this.lines = [];
            this.states = [];
            this.stop();
        };
        BackgroundTokenizer.prototype.fireUpdateEvent = function(firstRow, lastRow) {
            var data = {
                first: firstRow,
                last: lastRow
            };
            this._signal("update", {
                data: data
            });
        };
        BackgroundTokenizer.prototype.start = function(startRow) {
            this.currentLine = Math.min(startRow || 0, this.currentLine, this.doc.getLength());
            this.lines.splice(this.currentLine, this.lines.length);
            this.states.splice(this.currentLine, this.states.length);
            this.stop();
            this.running = setTimeout(this.$worker, 700);
        };
        BackgroundTokenizer.prototype.scheduleStart = function() {
            if (!this.running) this.running = setTimeout(this.$worker, 700);
        };
        BackgroundTokenizer.prototype.$updateOnChange = function(delta) {
            var startRow = delta.start.row;
            var len = delta.end.row - startRow;
            if (len === 0) this.lines[startRow] = null;
            else if (delta.action == "remove") {
                this.lines.splice(startRow, len + 1, null);
                this.states.splice(startRow, len + 1, null);
            } else {
                var args = Array(len + 1);
                args.unshift(startRow, 1);
                this.lines.splice.apply(this.lines, args);
                this.states.splice.apply(this.states, args);
            }
            this.currentLine = Math.min(startRow, this.currentLine, this.doc.getLength());
            this.stop();
        };
        BackgroundTokenizer.prototype.stop = function() {
            if (this.running) clearTimeout(this.running);
            this.running = false;
        };
        BackgroundTokenizer.prototype.getTokens = function(row) {
            return this.lines[row] || this.$tokenizeRow(row);
        };
        BackgroundTokenizer.prototype.getState = function(row) {
            if (this.currentLine == row) this.$tokenizeRow(row);
            return this.states[row] || "start";
        };
        BackgroundTokenizer.prototype.$tokenizeRow = function(row) {
            var line = this.doc.getLine(row);
            var state = this.states[row - 1];
            var data = this.tokenizer.getLineTokens(line, state, row);
            if (this.states[row] + "" !== data.state + "") {
                this.states[row] = data.state;
                this.lines[row + 1] = null;
                if (this.currentLine > row + 1) this.currentLine = row + 1;
            } else if (this.currentLine == row) this.currentLine = row + 1;
            return this.lines[row] = data.tokens;
        };
        BackgroundTokenizer.prototype.cleanup = function() {
            this.running = false;
            this.lines = [];
            this.states = [];
            this.currentLine = 0;
            this.removeAllListeners();
        };
        return BackgroundTokenizer;
    }();
    oop.implement(BackgroundTokenizer.prototype, EventEmitter);
    exports.BackgroundTokenizer = BackgroundTokenizer;
});
ace.define("ace/search_highlight", [
    "require",
    "exports",
    "module",
    "ace/lib/lang",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var lang = require("./lib/lang");
    var Range = require("./range").Range;
    var SearchHighlight = /** @class */ function() {
        function SearchHighlight(regExp, clazz, type) {
            if (type === void 0) type = "text";
            this.setRegexp(regExp);
            this.clazz = clazz;
            this.type = type;
        }
        SearchHighlight.prototype.setRegexp = function(regExp) {
            if (this.regExp + "" == regExp + "") return;
            this.regExp = regExp;
            this.cache = [];
        };
        SearchHighlight.prototype.update = function(html, markerLayer, session, config) {
            if (!this.regExp) return;
            var start = config.firstRow, end = config.lastRow;
            var renderedMarkerRanges = {};
            for(var i = start; i <= end; i++){
                var ranges = this.cache[i];
                if (ranges == null) {
                    ranges = lang.getMatchOffsets(session.getLine(i), this.regExp);
                    if (ranges.length > this.MAX_RANGES) ranges = ranges.slice(0, this.MAX_RANGES);
                    ranges = ranges.map(function(match) {
                        return new Range(i, match.offset, i, match.offset + match.length);
                    });
                    this.cache[i] = ranges.length ? ranges : "";
                }
                for(var j = ranges.length; j--;){
                    var rangeToAddMarkerTo = ranges[j].toScreenRange(session);
                    var rangeAsString = rangeToAddMarkerTo.toString();
                    if (renderedMarkerRanges[rangeAsString]) continue;
                    renderedMarkerRanges[rangeAsString] = true;
                    markerLayer.drawSingleLineMarker(html, rangeToAddMarkerTo, this.clazz, config);
                }
            }
        };
        return SearchHighlight;
    }();
    SearchHighlight.prototype.MAX_RANGES = 500;
    exports.SearchHighlight = SearchHighlight;
});
ace.define("ace/undomanager", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var UndoManager = /** @class */ function() {
        function UndoManager() {
            this.$keepRedoStack;
            this.$maxRev = 0;
            this.$fromUndo = false;
            this.$undoDepth = Infinity;
            this.reset();
        }
        UndoManager.prototype.addSession = function(session) {
            this.$session = session;
        };
        UndoManager.prototype.add = function(delta, allowMerge, session) {
            if (this.$fromUndo) return;
            if (delta == this.$lastDelta) return;
            if (!this.$keepRedoStack) this.$redoStack.length = 0;
            if (allowMerge === false || !this.lastDeltas) {
                this.lastDeltas = [];
                var undoStackLength = this.$undoStack.length;
                if (undoStackLength > this.$undoDepth - 1) this.$undoStack.splice(0, undoStackLength - this.$undoDepth + 1);
                this.$undoStack.push(this.lastDeltas);
                delta.id = this.$rev = ++this.$maxRev;
            }
            if (delta.action == "remove" || delta.action == "insert") this.$lastDelta = delta;
            this.lastDeltas.push(delta);
        };
        UndoManager.prototype.addSelection = function(selection, rev) {
            this.selections.push({
                value: selection,
                rev: rev || this.$rev
            });
        };
        UndoManager.prototype.startNewGroup = function() {
            this.lastDeltas = null;
            return this.$rev;
        };
        UndoManager.prototype.markIgnored = function(from, to) {
            if (to == null) to = this.$rev + 1;
            var stack = this.$undoStack;
            for(var i = stack.length; i--;){
                var delta = stack[i][0];
                if (delta.id <= from) break;
                if (delta.id < to) delta.ignore = true;
            }
            this.lastDeltas = null;
        };
        UndoManager.prototype.getSelection = function(rev, after) {
            var stack = this.selections;
            for(var i = stack.length; i--;){
                var selection = stack[i];
                if (selection.rev < rev) {
                    if (after) selection = stack[i + 1];
                    return selection;
                }
            }
        };
        UndoManager.prototype.getRevision = function() {
            return this.$rev;
        };
        UndoManager.prototype.getDeltas = function(from, to) {
            if (to == null) to = this.$rev + 1;
            var stack = this.$undoStack;
            var end = null, start = 0;
            for(var i = stack.length; i--;){
                var delta = stack[i][0];
                if (delta.id < to && !end) end = i + 1;
                if (delta.id <= from) {
                    start = i + 1;
                    break;
                }
            }
            return stack.slice(start, end);
        };
        UndoManager.prototype.getChangedRanges = function(from, to) {
            if (to == null) to = this.$rev + 1;
        };
        UndoManager.prototype.getChangedLines = function(from, to) {
            if (to == null) to = this.$rev + 1;
        };
        UndoManager.prototype.undo = function(session, dontSelect) {
            this.lastDeltas = null;
            var stack = this.$undoStack;
            if (!rearrangeUndoStack(stack, stack.length)) return;
            if (!session) session = this.$session;
            if (this.$redoStackBaseRev !== this.$rev && this.$redoStack.length) this.$redoStack = [];
            this.$fromUndo = true;
            var deltaSet = stack.pop();
            var undoSelectionRange = null;
            if (deltaSet) {
                undoSelectionRange = session.undoChanges(deltaSet, dontSelect);
                this.$redoStack.push(deltaSet);
                this.$syncRev();
            }
            this.$fromUndo = false;
            return undoSelectionRange;
        };
        UndoManager.prototype.redo = function(session, dontSelect) {
            this.lastDeltas = null;
            if (!session) session = this.$session;
            this.$fromUndo = true;
            if (this.$redoStackBaseRev != this.$rev) {
                var diff = this.getDeltas(this.$redoStackBaseRev, this.$rev + 1);
                rebaseRedoStack(this.$redoStack, diff);
                this.$redoStackBaseRev = this.$rev;
                this.$redoStack.forEach(function(x) {
                    x[0].id = ++this.$maxRev;
                }, this);
            }
            var deltaSet = this.$redoStack.pop();
            var redoSelectionRange = null;
            if (deltaSet) {
                redoSelectionRange = session.redoChanges(deltaSet, dontSelect);
                this.$undoStack.push(deltaSet);
                this.$syncRev();
            }
            this.$fromUndo = false;
            return redoSelectionRange;
        };
        UndoManager.prototype.$syncRev = function() {
            var stack = this.$undoStack;
            var nextDelta = stack[stack.length - 1];
            var id = nextDelta && nextDelta[0].id || 0;
            this.$redoStackBaseRev = id;
            this.$rev = id;
        };
        UndoManager.prototype.reset = function() {
            this.lastDeltas = null;
            this.$lastDelta = null;
            this.$undoStack = [];
            this.$redoStack = [];
            this.$rev = 0;
            this.mark = 0;
            this.$redoStackBaseRev = this.$rev;
            this.selections = [];
        };
        UndoManager.prototype.canUndo = function() {
            return this.$undoStack.length > 0;
        };
        UndoManager.prototype.canRedo = function() {
            return this.$redoStack.length > 0;
        };
        UndoManager.prototype.bookmark = function(rev) {
            if (rev == undefined) rev = this.$rev;
            this.mark = rev;
        };
        UndoManager.prototype.isAtBookmark = function() {
            return this.$rev === this.mark;
        };
        UndoManager.prototype.toJSON = function() {
            return {
                $redoStack: this.$redoStack,
                $undoStack: this.$undoStack
            };
        };
        UndoManager.prototype.fromJSON = function(json) {
            this.reset();
            this.$undoStack = json.$undoStack;
            this.$redoStack = json.$redoStack;
        };
        UndoManager.prototype.$prettyPrint = function(delta) {
            if (delta) return stringifyDelta(delta);
            return stringifyDelta(this.$undoStack) + "\n---\n" + stringifyDelta(this.$redoStack);
        };
        return UndoManager;
    }();
    UndoManager.prototype.hasUndo = UndoManager.prototype.canUndo;
    UndoManager.prototype.hasRedo = UndoManager.prototype.canRedo;
    UndoManager.prototype.isClean = UndoManager.prototype.isAtBookmark;
    UndoManager.prototype.markClean = UndoManager.prototype.bookmark;
    function rearrangeUndoStack(stack, pos) {
        for(var i = pos; i--;){
            var deltaSet = stack[i];
            if (deltaSet && !deltaSet[0].ignore) {
                while(i < pos - 1){
                    var swapped = swapGroups(stack[i], stack[i + 1]);
                    stack[i] = swapped[0];
                    stack[i + 1] = swapped[1];
                    i++;
                }
                return true;
            }
        }
    }
    var Range = require("./range").Range;
    var cmp = Range.comparePoints;
    var comparePoints = Range.comparePoints;
    function $updateMarkers(delta) {
        var isInsert = delta.action == "insert";
        var start = delta.start;
        var end = delta.end;
        var rowShift = (end.row - start.row) * (isInsert ? 1 : -1);
        var colShift = (end.column - start.column) * (isInsert ? 1 : -1);
        if (isInsert) end = start;
        for(var i in this.marks){
            var point = this.marks[i];
            var cmp = comparePoints(point, start);
            if (cmp < 0) continue; // delta starts after the range
            if (cmp === 0) {
                if (isInsert) {
                    if (point.bias == 1) cmp = 1;
                    else {
                        point.bias;
                        continue;
                    }
                }
            }
            var cmp2 = isInsert ? cmp : comparePoints(point, end);
            if (cmp2 > 0) {
                point.row += rowShift;
                point.column += point.row == end.row ? colShift : 0;
                continue;
            }
            if (!isInsert && cmp2 <= 0) {
                point.row = start.row;
                point.column = start.column;
                if (cmp2 === 0) point.bias = 1;
            }
        }
    }
    function clonePos(pos) {
        return {
            row: pos.row,
            column: pos.column
        };
    }
    function cloneDelta(d) {
        return {
            start: clonePos(d.start),
            end: clonePos(d.end),
            action: d.action,
            lines: d.lines.slice()
        };
    }
    function stringifyDelta(d) {
        d = d || this;
        if (Array.isArray(d)) return d.map(stringifyDelta).join("\n");
        var type = "";
        if (d.action) {
            type = d.action == "insert" ? "+" : "-";
            type += "[" + d.lines + "]";
        } else if (d.value) {
            if (Array.isArray(d.value)) type = d.value.map(stringifyRange).join("\n");
            else type = stringifyRange(d.value);
        }
        if (d.start) type += stringifyRange(d);
        if (d.id || d.rev) type += "	(" + (d.id || d.rev) + ")";
        return type;
    }
    function stringifyRange(r) {
        return r.start.row + ":" + r.start.column + "=>" + r.end.row + ":" + r.end.column;
    }
    function swap(d1, d2) {
        var i1 = d1.action == "insert";
        var i2 = d2.action == "insert";
        if (i1 && i2) {
            if (cmp(d2.start, d1.end) >= 0) shift(d2, d1, -1);
            else if (cmp(d2.start, d1.start) <= 0) shift(d1, d2, 1);
            else return null;
        } else if (i1 && !i2) {
            if (cmp(d2.start, d1.end) >= 0) shift(d2, d1, -1);
            else if (cmp(d2.end, d1.start) <= 0) shift(d1, d2, -1);
            else return null;
        } else if (!i1 && i2) {
            if (cmp(d2.start, d1.start) >= 0) shift(d2, d1, 1);
            else if (cmp(d2.start, d1.start) <= 0) shift(d1, d2, 1);
            else return null;
        } else if (!i1 && !i2) {
            if (cmp(d2.start, d1.start) >= 0) shift(d2, d1, 1);
            else if (cmp(d2.end, d1.start) <= 0) shift(d1, d2, -1);
            else return null;
        }
        return [
            d2,
            d1
        ];
    }
    function swapGroups(ds1, ds2) {
        for(var i = ds1.length; i--;){
            for(var j = 0; j < ds2.length; j++)if (!swap(ds1[i], ds2[j])) {
                while(i < ds1.length){
                    while(j--)swap(ds2[j], ds1[i]);
                    j = ds2.length;
                    i++;
                }
                return [
                    ds1,
                    ds2
                ];
            }
        }
        ds1.selectionBefore = ds2.selectionBefore = ds1.selectionAfter = ds2.selectionAfter = null;
        return [
            ds2,
            ds1
        ];
    }
    function xform(d1, c1) {
        var i1 = d1.action == "insert";
        var i2 = c1.action == "insert";
        if (i1 && i2) {
            if (cmp(d1.start, c1.start) < 0) shift(c1, d1, 1);
            else shift(d1, c1, 1);
        } else if (i1 && !i2) {
            if (cmp(d1.start, c1.end) >= 0) shift(d1, c1, -1);
            else if (cmp(d1.start, c1.start) <= 0) shift(c1, d1, 1);
            else {
                shift(d1, Range.fromPoints(c1.start, d1.start), -1);
                shift(c1, d1, 1);
            }
        } else if (!i1 && i2) {
            if (cmp(c1.start, d1.end) >= 0) shift(c1, d1, -1);
            else if (cmp(c1.start, d1.start) <= 0) shift(d1, c1, 1);
            else {
                shift(c1, Range.fromPoints(d1.start, c1.start), -1);
                shift(d1, c1, 1);
            }
        } else if (!i1 && !i2) {
            if (cmp(c1.start, d1.end) >= 0) shift(c1, d1, -1);
            else if (cmp(c1.end, d1.start) <= 0) shift(d1, c1, -1);
            else {
                var before, after;
                if (cmp(d1.start, c1.start) < 0) {
                    before = d1;
                    d1 = splitDelta(d1, c1.start);
                }
                if (cmp(d1.end, c1.end) > 0) after = splitDelta(d1, c1.end);
                shiftPos(c1.end, d1.start, d1.end, -1);
                if (after && !before) {
                    d1.lines = after.lines;
                    d1.start = after.start;
                    d1.end = after.end;
                    after = d1;
                }
                return [
                    c1,
                    before,
                    after
                ].filter(Boolean);
            }
        }
        return [
            c1,
            d1
        ];
    }
    function shift(d1, d2, dir) {
        shiftPos(d1.start, d2.start, d2.end, dir);
        shiftPos(d1.end, d2.start, d2.end, dir);
    }
    function shiftPos(pos, start, end, dir) {
        if (pos.row == (dir == 1 ? start : end).row) pos.column += dir * (end.column - start.column);
        pos.row += dir * (end.row - start.row);
    }
    function splitDelta(c, pos) {
        var lines = c.lines;
        var end = c.end;
        c.end = clonePos(pos);
        var rowsBefore = c.end.row - c.start.row;
        var otherLines = lines.splice(rowsBefore, lines.length);
        var col = rowsBefore ? pos.column : pos.column - c.start.column;
        lines.push(otherLines[0].substring(0, col));
        otherLines[0] = otherLines[0].substr(col);
        var rest = {
            start: clonePos(pos),
            end: end,
            lines: otherLines,
            action: c.action
        };
        return rest;
    }
    function moveDeltasByOne(redoStack, d) {
        d = cloneDelta(d);
        for(var j = redoStack.length; j--;){
            var deltaSet = redoStack[j];
            for(var i = 0; i < deltaSet.length; i++){
                var x = deltaSet[i];
                var xformed = xform(x, d);
                d = xformed[0];
                if (xformed.length != 2) {
                    if (xformed[2]) {
                        deltaSet.splice(i + 1, 1, xformed[1], xformed[2]);
                        i++;
                    } else if (!xformed[1]) {
                        deltaSet.splice(i, 1);
                        i--;
                    }
                }
            }
            if (!deltaSet.length) redoStack.splice(j, 1);
        }
        return redoStack;
    }
    function rebaseRedoStack(redoStack, deltaSets) {
        for(var i = 0; i < deltaSets.length; i++){
            var deltas = deltaSets[i];
            for(var j = 0; j < deltas.length; j++)moveDeltasByOne(redoStack, deltas[j]);
        }
    }
    exports.UndoManager = UndoManager;
});
ace.define("ace/edit_session/fold_line", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var FoldLine = /** @class */ function() {
        function FoldLine(foldData, folds) {
            this.foldData = foldData;
            if (Array.isArray(folds)) this.folds = folds;
            else folds = this.folds = [
                folds
            ];
            var last = folds[folds.length - 1];
            this.range = new Range(folds[0].start.row, folds[0].start.column, last.end.row, last.end.column);
            this.start = this.range.start;
            this.end = this.range.end;
            this.folds.forEach(function(fold) {
                fold.setFoldLine(this);
            }, this);
        }
        FoldLine.prototype.shiftRow = function(shift) {
            this.start.row += shift;
            this.end.row += shift;
            this.folds.forEach(function(fold) {
                fold.start.row += shift;
                fold.end.row += shift;
            });
        };
        FoldLine.prototype.addFold = function(fold) {
            if (fold.sameRow) {
                if (fold.start.row < this.startRow || fold.endRow > this.endRow) throw new Error("Can't add a fold to this FoldLine as it has no connection");
                this.folds.push(fold);
                this.folds.sort(function(a, b) {
                    return -a.range.compareEnd(b.start.row, b.start.column);
                });
                if (this.range.compareEnd(fold.start.row, fold.start.column) > 0) {
                    this.end.row = fold.end.row;
                    this.end.column = fold.end.column;
                } else if (this.range.compareStart(fold.end.row, fold.end.column) < 0) {
                    this.start.row = fold.start.row;
                    this.start.column = fold.start.column;
                }
            } else if (fold.start.row == this.end.row) {
                this.folds.push(fold);
                this.end.row = fold.end.row;
                this.end.column = fold.end.column;
            } else if (fold.end.row == this.start.row) {
                this.folds.unshift(fold);
                this.start.row = fold.start.row;
                this.start.column = fold.start.column;
            } else throw new Error("Trying to add fold to FoldRow that doesn't have a matching row");
            fold.foldLine = this;
        };
        FoldLine.prototype.containsRow = function(row) {
            return row >= this.start.row && row <= this.end.row;
        };
        FoldLine.prototype.walk = function(callback, endRow, endColumn) {
            var lastEnd = 0, folds = this.folds, fold, cmp, stop, isNewRow = true;
            if (endRow == null) {
                endRow = this.end.row;
                endColumn = this.end.column;
            }
            for(var i = 0; i < folds.length; i++){
                fold = folds[i];
                cmp = fold.range.compareStart(endRow, endColumn);
                if (cmp == -1) {
                    callback(null, endRow, endColumn, lastEnd, isNewRow);
                    return;
                }
                stop = callback(null, fold.start.row, fold.start.column, lastEnd, isNewRow);
                stop = !stop && callback(fold.placeholder, fold.start.row, fold.start.column, lastEnd);
                if (stop || cmp === 0) return;
                isNewRow = !fold.sameRow;
                lastEnd = fold.end.column;
            }
            callback(null, endRow, endColumn, lastEnd, isNewRow);
        };
        FoldLine.prototype.getNextFoldTo = function(row, column) {
            var fold, cmp;
            for(var i = 0; i < this.folds.length; i++){
                fold = this.folds[i];
                cmp = fold.range.compareEnd(row, column);
                if (cmp == -1) return {
                    fold: fold,
                    kind: "after"
                };
                else if (cmp === 0) return {
                    fold: fold,
                    kind: "inside"
                };
            }
            return null;
        };
        FoldLine.prototype.addRemoveChars = function(row, column, len) {
            var ret = this.getNextFoldTo(row, column), fold, folds;
            if (ret) {
                fold = ret.fold;
                if (ret.kind == "inside" && fold.start.column != column && fold.start.row != row) window.console && window.console.log(row, column, fold);
                else if (fold.start.row == row) {
                    folds = this.folds;
                    var i = folds.indexOf(fold);
                    if (i === 0) this.start.column += len;
                    for(i; i < folds.length; i++){
                        fold = folds[i];
                        fold.start.column += len;
                        if (!fold.sameRow) return;
                        fold.end.column += len;
                    }
                    this.end.column += len;
                }
            }
        };
        FoldLine.prototype.split = function(row, column) {
            var pos = this.getNextFoldTo(row, column);
            if (!pos || pos.kind == "inside") return null;
            var fold = pos.fold;
            var folds = this.folds;
            var foldData = this.foldData;
            var i = folds.indexOf(fold);
            var foldBefore = folds[i - 1];
            this.end.row = foldBefore.end.row;
            this.end.column = foldBefore.end.column;
            folds = folds.splice(i, folds.length - i);
            var newFoldLine = new FoldLine(foldData, folds);
            foldData.splice(foldData.indexOf(this) + 1, 0, newFoldLine);
            return newFoldLine;
        };
        FoldLine.prototype.merge = function(foldLineNext) {
            var folds = foldLineNext.folds;
            for(var i = 0; i < folds.length; i++)this.addFold(folds[i]);
            var foldData = this.foldData;
            foldData.splice(foldData.indexOf(foldLineNext), 1);
        };
        FoldLine.prototype.toString = function() {
            var ret = [
                this.range.toString() + ": ["
            ];
            this.folds.forEach(function(fold) {
                ret.push("  " + fold.toString());
            });
            ret.push("]");
            return ret.join("\n");
        };
        FoldLine.prototype.idxToPosition = function(idx) {
            var lastFoldEndColumn = 0;
            for(var i = 0; i < this.folds.length; i++){
                var fold = this.folds[i];
                idx -= fold.start.column - lastFoldEndColumn;
                if (idx < 0) return {
                    row: fold.start.row,
                    column: fold.start.column + idx
                };
                idx -= fold.placeholder.length;
                if (idx < 0) return fold.start;
                lastFoldEndColumn = fold.end.column;
            }
            return {
                row: this.end.row,
                column: this.end.column + idx
            };
        };
        return FoldLine;
    }();
    exports.FoldLine = FoldLine;
});
ace.define("ace/range_list", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("./range").Range;
    var comparePoints = Range.comparePoints;
    var RangeList = /** @class */ function() {
        function RangeList() {
            this.ranges = [];
            this.$bias = 1;
        }
        RangeList.prototype.pointIndex = function(pos, excludeEdges, startIndex) {
            var list = this.ranges;
            for(var i = startIndex || 0; i < list.length; i++){
                var range = list[i];
                var cmpEnd = comparePoints(pos, range.end);
                if (cmpEnd > 0) continue;
                var cmpStart = comparePoints(pos, range.start);
                if (cmpEnd === 0) return excludeEdges && cmpStart !== 0 ? -i - 2 : i;
                if (cmpStart > 0 || cmpStart === 0 && !excludeEdges) return i;
                return -i - 1;
            }
            return -i - 1;
        };
        RangeList.prototype.add = function(range) {
            var excludeEdges = !range.isEmpty();
            var startIndex = this.pointIndex(range.start, excludeEdges);
            if (startIndex < 0) startIndex = -startIndex - 1;
            var endIndex = this.pointIndex(range.end, excludeEdges, startIndex);
            if (endIndex < 0) endIndex = -endIndex - 1;
            else endIndex++;
            return this.ranges.splice(startIndex, endIndex - startIndex, range);
        };
        RangeList.prototype.addList = function(list) {
            var removed = [];
            for(var i = list.length; i--;)removed.push.apply(removed, this.add(list[i]));
            return removed;
        };
        RangeList.prototype.substractPoint = function(pos) {
            var i = this.pointIndex(pos);
            if (i >= 0) return this.ranges.splice(i, 1);
        };
        RangeList.prototype.merge = function() {
            var removed = [];
            var list = this.ranges;
            list = list.sort(function(a, b) {
                return comparePoints(a.start, b.start);
            });
            var next = list[0], range;
            for(var i = 1; i < list.length; i++){
                range = next;
                next = list[i];
                var cmp = comparePoints(range.end, next.start);
                if (cmp < 0) continue;
                if (cmp == 0 && !range.isEmpty() && !next.isEmpty()) continue;
                if (comparePoints(range.end, next.end) < 0) {
                    range.end.row = next.end.row;
                    range.end.column = next.end.column;
                }
                list.splice(i, 1);
                removed.push(next);
                next = range;
                i--;
            }
            this.ranges = list;
            return removed;
        };
        RangeList.prototype.contains = function(row, column) {
            return this.pointIndex({
                row: row,
                column: column
            }) >= 0;
        };
        RangeList.prototype.containsPoint = function(pos) {
            return this.pointIndex(pos) >= 0;
        };
        RangeList.prototype.rangeAtPoint = function(pos) {
            var i = this.pointIndex(pos);
            if (i >= 0) return this.ranges[i];
        };
        RangeList.prototype.clipRows = function(startRow, endRow) {
            var list = this.ranges;
            if (list[0].start.row > endRow || list[list.length - 1].start.row < startRow) return [];
            var startIndex = this.pointIndex({
                row: startRow,
                column: 0
            });
            if (startIndex < 0) startIndex = -startIndex - 1;
            var endIndex = this.pointIndex({
                row: endRow,
                column: 0
            }, startIndex);
            if (endIndex < 0) endIndex = -endIndex - 1;
            var clipped = [];
            for(var i = startIndex; i < endIndex; i++)clipped.push(list[i]);
            return clipped;
        };
        RangeList.prototype.removeAll = function() {
            return this.ranges.splice(0, this.ranges.length);
        };
        RangeList.prototype.attach = function(session) {
            if (this.session) this.detach();
            this.session = session;
            this.onChange = this.$onChange.bind(this);
            this.session.on("change", this.onChange);
        };
        RangeList.prototype.detach = function() {
            if (!this.session) return;
            this.session.removeListener("change", this.onChange);
            this.session = null;
        };
        RangeList.prototype.$onChange = function(delta) {
            var start = delta.start;
            var end = delta.end;
            var startRow = start.row;
            var endRow = end.row;
            var ranges = this.ranges;
            for(var i = 0, n = ranges.length; i < n; i++){
                var r = ranges[i];
                if (r.end.row >= startRow) break;
            }
            if (delta.action == "insert") {
                var lineDif = endRow - startRow;
                var colDiff = -start.column + end.column;
                for(; i < n; i++){
                    var r = ranges[i];
                    if (r.start.row > startRow) break;
                    if (r.start.row == startRow && r.start.column >= start.column) {
                        if (r.start.column == start.column && this.$bias <= 0) ;
                        else {
                            r.start.column += colDiff;
                            r.start.row += lineDif;
                        }
                    }
                    if (r.end.row == startRow && r.end.column >= start.column) {
                        if (r.end.column == start.column && this.$bias < 0) continue;
                        if (r.end.column == start.column && colDiff > 0 && i < n - 1) {
                            if (r.end.column > r.start.column && r.end.column == ranges[i + 1].start.column) r.end.column -= colDiff;
                        }
                        r.end.column += colDiff;
                        r.end.row += lineDif;
                    }
                }
            } else {
                var lineDif = startRow - endRow;
                var colDiff = start.column - end.column;
                for(; i < n; i++){
                    var r = ranges[i];
                    if (r.start.row > endRow) break;
                    if (r.end.row < endRow && (startRow < r.end.row || startRow == r.end.row && start.column < r.end.column)) {
                        r.end.row = startRow;
                        r.end.column = start.column;
                    } else if (r.end.row == endRow) {
                        if (r.end.column <= end.column) {
                            if (lineDif || r.end.column > start.column) {
                                r.end.column = start.column;
                                r.end.row = start.row;
                            }
                        } else {
                            r.end.column += colDiff;
                            r.end.row += lineDif;
                        }
                    } else if (r.end.row > endRow) r.end.row += lineDif;
                    if (r.start.row < endRow && (startRow < r.start.row || startRow == r.start.row && start.column < r.start.column)) {
                        r.start.row = startRow;
                        r.start.column = start.column;
                    } else if (r.start.row == endRow) {
                        if (r.start.column <= end.column) {
                            if (lineDif || r.start.column > start.column) {
                                r.start.column = start.column;
                                r.start.row = start.row;
                            }
                        } else {
                            r.start.column += colDiff;
                            r.start.row += lineDif;
                        }
                    } else if (r.start.row > endRow) r.start.row += lineDif;
                }
            }
            if (lineDif != 0 && i < n) for(; i < n; i++){
                var r = ranges[i];
                r.start.row += lineDif;
                r.end.row += lineDif;
            }
        };
        return RangeList;
    }();
    RangeList.prototype.comparePoints = comparePoints;
    exports.RangeList = RangeList;
});
ace.define("ace/edit_session/fold", [
    "require",
    "exports",
    "module",
    "ace/range_list"
], function(require, exports, module1) {
    "use strict";
    var __extends = this && this.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var RangeList = require("../range_list").RangeList;
    var Fold = /** @class */ function(_super) {
        __extends(Fold, _super);
        function Fold(range, placeholder) {
            var _this = _super.call(this) || this;
            _this.foldLine = null;
            _this.placeholder = placeholder;
            _this.range = range;
            _this.start = range.start;
            _this.end = range.end;
            _this.sameRow = range.start.row == range.end.row;
            _this.subFolds = _this.ranges = [];
            return _this;
        }
        Fold.prototype.toString = function() {
            return '"' + this.placeholder + '" ' + this.range.toString();
        };
        Fold.prototype.setFoldLine = function(foldLine) {
            this.foldLine = foldLine;
            this.subFolds.forEach(function(fold) {
                fold.setFoldLine(foldLine);
            });
        };
        Fold.prototype.clone = function() {
            var range = this.range.clone();
            var fold = new Fold(range, this.placeholder);
            this.subFolds.forEach(function(subFold) {
                fold.subFolds.push(subFold.clone());
            });
            fold.collapseChildren = this.collapseChildren;
            return fold;
        };
        Fold.prototype.addSubFold = function(fold) {
            if (this.range.isEqual(fold)) return;
            consumeRange(fold, this.start);
            var row = fold.start.row, column = fold.start.column;
            for(var i = 0, cmp = -1; i < this.subFolds.length; i++){
                cmp = this.subFolds[i].range.compare(row, column);
                if (cmp != 1) break;
            }
            var afterStart = this.subFolds[i];
            var firstConsumed = 0;
            if (cmp == 0) {
                if (afterStart.range.containsRange(fold)) return afterStart.addSubFold(fold);
                else firstConsumed = 1;
            }
            var row = fold.range.end.row, column = fold.range.end.column;
            for(var j = i, cmp = -1; j < this.subFolds.length; j++){
                cmp = this.subFolds[j].range.compare(row, column);
                if (cmp != 1) break;
            }
            if (cmp == 0) j++;
            var consumedFolds = this.subFolds.splice(i, j - i, fold);
            var last = cmp == 0 ? consumedFolds.length - 1 : consumedFolds.length;
            for(var k = firstConsumed; k < last; k++)fold.addSubFold(consumedFolds[k]);
            fold.setFoldLine(this.foldLine);
            return fold;
        };
        Fold.prototype.restoreRange = function(range) {
            return restoreRange(range, this.start);
        };
        return Fold;
    }(RangeList);
    function consumePoint(point, anchor) {
        point.row -= anchor.row;
        if (point.row == 0) point.column -= anchor.column;
    }
    function consumeRange(range, anchor) {
        consumePoint(range.start, anchor);
        consumePoint(range.end, anchor);
    }
    function restorePoint(point, anchor) {
        if (point.row == 0) point.column += anchor.column;
        point.row += anchor.row;
    }
    function restoreRange(range, anchor) {
        restorePoint(range.start, anchor);
        restorePoint(range.end, anchor);
    }
    exports.Fold = Fold;
});
ace.define("ace/edit_session/folding", [
    "require",
    "exports",
    "module",
    "ace/range",
    "ace/edit_session/fold_line",
    "ace/edit_session/fold",
    "ace/token_iterator",
    "ace/mouse/mouse_event"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var FoldLine = require("./fold_line").FoldLine;
    var Fold = require("./fold").Fold;
    var TokenIterator = require("../token_iterator").TokenIterator;
    var MouseEvent = require("../mouse/mouse_event").MouseEvent;
    function Folding() {
        this.getFoldAt = function(row, column, side) {
            var foldLine = this.getFoldLine(row);
            if (!foldLine) return null;
            var folds = foldLine.folds;
            for(var i = 0; i < folds.length; i++){
                var range = folds[i].range;
                if (range.contains(row, column)) {
                    if (side == 1 && range.isEnd(row, column) && !range.isEmpty()) continue;
                    else if (side == -1 && range.isStart(row, column) && !range.isEmpty()) continue;
                    return folds[i];
                }
            }
        };
        this.getFoldsInRange = function(range) {
            var start = range.start;
            var end = range.end;
            var foldLines = this.$foldData;
            var foundFolds = [];
            start.column += 1;
            end.column -= 1;
            for(var i = 0; i < foldLines.length; i++){
                var cmp = foldLines[i].range.compareRange(range);
                if (cmp == 2) continue;
                else if (cmp == -2) break;
                var folds = foldLines[i].folds;
                for(var j = 0; j < folds.length; j++){
                    var fold = folds[j];
                    cmp = fold.range.compareRange(range);
                    if (cmp == -2) break;
                    else if (cmp == 2) continue;
                    else if (cmp == 42) break;
                    foundFolds.push(fold);
                }
            }
            start.column -= 1;
            end.column += 1;
            return foundFolds;
        };
        this.getFoldsInRangeList = function(ranges) {
            if (Array.isArray(ranges)) {
                var folds = [];
                ranges.forEach(function(range) {
                    folds = folds.concat(this.getFoldsInRange(range));
                }, this);
            } else var folds = this.getFoldsInRange(ranges);
            return folds;
        };
        this.getAllFolds = function() {
            var folds = [];
            var foldLines = this.$foldData;
            for(var i = 0; i < foldLines.length; i++)for(var j = 0; j < foldLines[i].folds.length; j++)folds.push(foldLines[i].folds[j]);
            return folds;
        };
        this.getFoldStringAt = function(row, column, trim, foldLine) {
            foldLine = foldLine || this.getFoldLine(row);
            if (!foldLine) return null;
            var lastFold = {
                end: {
                    column: 0
                }
            };
            var str, fold;
            for(var i = 0; i < foldLine.folds.length; i++){
                fold = foldLine.folds[i];
                var cmp = fold.range.compareEnd(row, column);
                if (cmp == -1) {
                    str = this.getLine(fold.start.row).substring(lastFold.end.column, fold.start.column);
                    break;
                } else if (cmp === 0) return null;
                lastFold = fold;
            }
            if (!str) str = this.getLine(fold.start.row).substring(lastFold.end.column);
            if (trim == -1) return str.substring(0, column - lastFold.end.column);
            else if (trim == 1) return str.substring(column - lastFold.end.column);
            else return str;
        };
        this.getFoldLine = function(docRow, startFoldLine) {
            var foldData = this.$foldData;
            var i = 0;
            if (startFoldLine) i = foldData.indexOf(startFoldLine);
            if (i == -1) i = 0;
            for(i; i < foldData.length; i++){
                var foldLine = foldData[i];
                if (foldLine.start.row <= docRow && foldLine.end.row >= docRow) return foldLine;
                else if (foldLine.end.row > docRow) return null;
            }
            return null;
        };
        this.getNextFoldLine = function(docRow, startFoldLine) {
            var foldData = this.$foldData;
            var i = 0;
            if (startFoldLine) i = foldData.indexOf(startFoldLine);
            if (i == -1) i = 0;
            for(i; i < foldData.length; i++){
                var foldLine = foldData[i];
                if (foldLine.end.row >= docRow) return foldLine;
            }
            return null;
        };
        this.getFoldedRowCount = function(first, last) {
            var foldData = this.$foldData, rowCount = last - first + 1;
            for(var i = 0; i < foldData.length; i++){
                var foldLine = foldData[i], end = foldLine.end.row, start = foldLine.start.row;
                if (end >= last) {
                    if (start < last) {
                        if (start >= first) rowCount -= last - start;
                        else rowCount = 0; // in one fold
                    }
                    break;
                } else if (end >= first) {
                    if (start >= first) rowCount -= end - start;
                    else rowCount -= end - first + 1;
                }
            }
            return rowCount;
        };
        this.$addFoldLine = function(foldLine) {
            this.$foldData.push(foldLine);
            this.$foldData.sort(function(a, b) {
                return a.start.row - b.start.row;
            });
            return foldLine;
        };
        this.addFold = function(placeholder, range) {
            var foldData = this.$foldData;
            var added = false;
            var fold;
            if (placeholder instanceof Fold) fold = placeholder;
            else {
                fold = new Fold(range, placeholder);
                fold.collapseChildren = range.collapseChildren;
            }
            this.$clipRangeToDocument(fold.range);
            var startRow = fold.start.row;
            var startColumn = fold.start.column;
            var endRow = fold.end.row;
            var endColumn = fold.end.column;
            var startFold = this.getFoldAt(startRow, startColumn, 1);
            var endFold = this.getFoldAt(endRow, endColumn, -1);
            if (startFold && endFold == startFold) return startFold.addSubFold(fold);
            if (startFold && !startFold.range.isStart(startRow, startColumn)) this.removeFold(startFold);
            if (endFold && !endFold.range.isEnd(endRow, endColumn)) this.removeFold(endFold);
            var folds = this.getFoldsInRange(fold.range);
            if (folds.length > 0) {
                this.removeFolds(folds);
                if (!fold.collapseChildren) folds.forEach(function(subFold) {
                    fold.addSubFold(subFold);
                });
            }
            for(var i = 0; i < foldData.length; i++){
                var foldLine = foldData[i];
                if (endRow == foldLine.start.row) {
                    foldLine.addFold(fold);
                    added = true;
                    break;
                } else if (startRow == foldLine.end.row) {
                    foldLine.addFold(fold);
                    added = true;
                    if (!fold.sameRow) {
                        var foldLineNext = foldData[i + 1];
                        if (foldLineNext && foldLineNext.start.row == endRow) {
                            foldLine.merge(foldLineNext);
                            break;
                        }
                    }
                    break;
                } else if (endRow <= foldLine.start.row) break;
            }
            if (!added) foldLine = this.$addFoldLine(new FoldLine(this.$foldData, fold));
            if (this.$useWrapMode) this.$updateWrapData(foldLine.start.row, foldLine.start.row);
            else this.$updateRowLengthCache(foldLine.start.row, foldLine.start.row);
            this.$modified = true;
            this._signal("changeFold", {
                data: fold,
                action: "add"
            });
            return fold;
        };
        this.addFolds = function(folds) {
            folds.forEach(function(fold) {
                this.addFold(fold);
            }, this);
        };
        this.removeFold = function(fold) {
            var foldLine = fold.foldLine;
            var startRow = foldLine.start.row;
            var endRow = foldLine.end.row;
            var foldLines = this.$foldData;
            var folds = foldLine.folds;
            if (folds.length == 1) foldLines.splice(foldLines.indexOf(foldLine), 1);
            else if (foldLine.range.isEnd(fold.end.row, fold.end.column)) {
                folds.pop();
                foldLine.end.row = folds[folds.length - 1].end.row;
                foldLine.end.column = folds[folds.length - 1].end.column;
            } else if (foldLine.range.isStart(fold.start.row, fold.start.column)) {
                folds.shift();
                foldLine.start.row = folds[0].start.row;
                foldLine.start.column = folds[0].start.column;
            } else if (fold.sameRow) folds.splice(folds.indexOf(fold), 1);
            else {
                var newFoldLine = foldLine.split(fold.start.row, fold.start.column);
                folds = newFoldLine.folds;
                folds.shift();
                newFoldLine.start.row = folds[0].start.row;
                newFoldLine.start.column = folds[0].start.column;
            }
            if (!this.$updating) {
                if (this.$useWrapMode) this.$updateWrapData(startRow, endRow);
                else this.$updateRowLengthCache(startRow, endRow);
            }
            this.$modified = true;
            this._signal("changeFold", {
                data: fold,
                action: "remove"
            });
        };
        this.removeFolds = function(folds) {
            var cloneFolds = [];
            for(var i = 0; i < folds.length; i++)cloneFolds.push(folds[i]);
            cloneFolds.forEach(function(fold) {
                this.removeFold(fold);
            }, this);
            this.$modified = true;
        };
        this.expandFold = function(fold) {
            this.removeFold(fold);
            fold.subFolds.forEach(function(subFold) {
                fold.restoreRange(subFold);
                this.addFold(subFold);
            }, this);
            if (fold.collapseChildren > 0) this.foldAll(fold.start.row + 1, fold.end.row, fold.collapseChildren - 1);
            fold.subFolds = [];
        };
        this.expandFolds = function(folds) {
            folds.forEach(function(fold) {
                this.expandFold(fold);
            }, this);
        };
        this.unfold = function(location, expandInner) {
            var range, folds;
            if (location == null) {
                range = new Range(0, 0, this.getLength(), 0);
                if (expandInner == null) expandInner = true;
            } else if (typeof location == "number") range = new Range(location, 0, location, this.getLine(location).length);
            else if ("row" in location) range = Range.fromPoints(location, location);
            else if (Array.isArray(location)) {
                folds = [];
                location.forEach(function(range) {
                    folds = folds.concat(this.unfold(range));
                }, this);
                return folds;
            } else range = location;
            folds = this.getFoldsInRangeList(range);
            var outermostFolds = folds;
            while(folds.length == 1 && Range.comparePoints(folds[0].start, range.start) < 0 && Range.comparePoints(folds[0].end, range.end) > 0){
                this.expandFolds(folds);
                folds = this.getFoldsInRangeList(range);
            }
            if (expandInner != false) this.removeFolds(folds);
            else this.expandFolds(folds);
            if (outermostFolds.length) return outermostFolds;
        };
        this.isRowFolded = function(docRow, startFoldRow) {
            return !!this.getFoldLine(docRow, startFoldRow);
        };
        this.getRowFoldEnd = function(docRow, startFoldRow) {
            var foldLine = this.getFoldLine(docRow, startFoldRow);
            return foldLine ? foldLine.end.row : docRow;
        };
        this.getRowFoldStart = function(docRow, startFoldRow) {
            var foldLine = this.getFoldLine(docRow, startFoldRow);
            return foldLine ? foldLine.start.row : docRow;
        };
        this.getFoldDisplayLine = function(foldLine, endRow, endColumn, startRow, startColumn) {
            if (startRow == null) startRow = foldLine.start.row;
            if (startColumn == null) startColumn = 0;
            if (endRow == null) endRow = foldLine.end.row;
            if (endColumn == null) endColumn = this.getLine(endRow).length;
            var doc = this.doc;
            var textLine = "";
            foldLine.walk(function(placeholder, row, column, lastColumn) {
                if (row < startRow) return;
                if (row == startRow) {
                    if (column < startColumn) return;
                    lastColumn = Math.max(startColumn, lastColumn);
                }
                if (placeholder != null) textLine += placeholder;
                else textLine += doc.getLine(row).substring(lastColumn, column);
            }, endRow, endColumn);
            return textLine;
        };
        this.getDisplayLine = function(row, endColumn, startRow, startColumn) {
            var foldLine = this.getFoldLine(row);
            if (!foldLine) {
                var line;
                line = this.doc.getLine(row);
                return line.substring(startColumn || 0, endColumn || line.length);
            } else return this.getFoldDisplayLine(foldLine, row, endColumn, startRow, startColumn);
        };
        this.$cloneFoldData = function() {
            var fd = [];
            fd = this.$foldData.map(function(foldLine) {
                var folds = foldLine.folds.map(function(fold) {
                    return fold.clone();
                });
                return new FoldLine(fd, folds);
            });
            return fd;
        };
        this.toggleFold = function(tryToUnfold) {
            var selection = this.selection;
            var range = selection.getRange();
            var fold;
            var bracketPos;
            if (range.isEmpty()) {
                var cursor = range.start;
                fold = this.getFoldAt(cursor.row, cursor.column);
                if (fold) {
                    this.expandFold(fold);
                    return;
                } else if (bracketPos = this.findMatchingBracket(cursor)) {
                    if (range.comparePoint(bracketPos) == 1) range.end = bracketPos;
                    else {
                        range.start = bracketPos;
                        range.start.column++;
                        range.end.column--;
                    }
                } else if (bracketPos = this.findMatchingBracket({
                    row: cursor.row,
                    column: cursor.column + 1
                })) {
                    if (range.comparePoint(bracketPos) == 1) range.end = bracketPos;
                    else range.start = bracketPos;
                    range.start.column++;
                } else range = this.getCommentFoldRange(cursor.row, cursor.column) || range;
            } else {
                var folds = this.getFoldsInRange(range);
                if (tryToUnfold && folds.length) {
                    this.expandFolds(folds);
                    return;
                } else if (folds.length == 1) fold = folds[0];
            }
            if (!fold) fold = this.getFoldAt(range.start.row, range.start.column);
            if (fold && fold.range.toString() == range.toString()) {
                this.expandFold(fold);
                return;
            }
            var placeholder = "...";
            if (!range.isMultiLine()) {
                placeholder = this.getTextRange(range);
                if (placeholder.length < 4) return;
                placeholder = placeholder.trim().substring(0, 2) + "..";
            }
            this.addFold(placeholder, range);
        };
        this.getCommentFoldRange = function(row, column, dir) {
            var iterator = new TokenIterator(this, row, column);
            var token = iterator.getCurrentToken();
            var type = token && token.type;
            if (token && /^comment|string/.test(type)) {
                type = type.match(/comment|string/)[0];
                if (type == "comment") type += "|doc-start|\\.doc";
                var re = new RegExp(type);
                var range = new Range();
                if (dir != 1) {
                    do token = iterator.stepBackward();
                    while (token && re.test(token.type));
                    token = iterator.stepForward();
                }
                range.start.row = iterator.getCurrentTokenRow();
                range.start.column = iterator.getCurrentTokenColumn() + token.value.length;
                iterator = new TokenIterator(this, row, column);
                var initState = this.getState(iterator.$row);
                if (dir != -1) {
                    var lastRow = -1;
                    do {
                        token = iterator.stepForward();
                        if (lastRow == -1) {
                            var state = this.getState(iterator.$row);
                            if (initState.toString() !== state.toString()) lastRow = iterator.$row;
                        } else if (iterator.$row > lastRow) break;
                    }while (token && re.test(token.type));
                    token = iterator.stepBackward();
                } else token = iterator.getCurrentToken();
                range.end.row = iterator.getCurrentTokenRow();
                range.end.column = iterator.getCurrentTokenColumn();
                return range;
            }
        };
        this.foldAll = function(startRow, endRow, depth, test) {
            if (depth == undefined) depth = 100000; // JSON.stringify doesn't hanle Infinity
            var foldWidgets = this.foldWidgets;
            if (!foldWidgets) return; // mode doesn't support folding
            endRow = endRow || this.getLength();
            startRow = startRow || 0;
            for(var row = startRow; row < endRow; row++){
                if (foldWidgets[row] == null) foldWidgets[row] = this.getFoldWidget(row);
                if (foldWidgets[row] != "start") continue;
                if (test && !test(row)) continue;
                var range = this.getFoldWidgetRange(row);
                if (range && range.isMultiLine() && range.end.row <= endRow && range.start.row >= startRow) {
                    row = range.end.row;
                    range.collapseChildren = depth;
                    this.addFold("...", range);
                }
            }
        };
        this.foldToLevel = function(level) {
            this.foldAll();
            while(level-- > 0)this.unfold(null, false);
        };
        this.foldAllComments = function() {
            var session = this;
            this.foldAll(null, null, null, function(row) {
                var tokens = session.getTokens(row);
                for(var i = 0; i < tokens.length; i++){
                    var token = tokens[i];
                    if (token.type == "text" && /^\s+$/.test(token.value)) continue;
                    if (/comment/.test(token.type)) return true;
                    return false;
                }
            });
        };
        this.$foldStyles = {
            "manual": 1,
            "markbegin": 1,
            "markbeginend": 1
        };
        this.$foldStyle = "markbegin";
        this.setFoldStyle = function(style) {
            if (!this.$foldStyles[style]) throw new Error("invalid fold style: " + style + "[" + Object.keys(this.$foldStyles).join(", ") + "]");
            if (this.$foldStyle == style) return;
            this.$foldStyle = style;
            if (style == "manual") this.unfold();
            var mode = this.$foldMode;
            this.$setFolding(null);
            this.$setFolding(mode);
        };
        this.$setFolding = function(foldMode) {
            if (this.$foldMode == foldMode) return;
            this.$foldMode = foldMode;
            this.off("change", this.$updateFoldWidgets);
            this.off("tokenizerUpdate", this.$tokenizerUpdateFoldWidgets);
            this._signal("changeAnnotation");
            if (!foldMode || this.$foldStyle == "manual") {
                this.foldWidgets = null;
                return;
            }
            this.foldWidgets = [];
            this.getFoldWidget = foldMode.getFoldWidget.bind(foldMode, this, this.$foldStyle);
            this.getFoldWidgetRange = foldMode.getFoldWidgetRange.bind(foldMode, this, this.$foldStyle);
            this.$updateFoldWidgets = this.updateFoldWidgets.bind(this);
            this.$tokenizerUpdateFoldWidgets = this.tokenizerUpdateFoldWidgets.bind(this);
            this.on("change", this.$updateFoldWidgets);
            this.on("tokenizerUpdate", this.$tokenizerUpdateFoldWidgets);
        };
        this.getParentFoldRangeData = function(row, ignoreCurrent) {
            var fw = this.foldWidgets;
            if (!fw || ignoreCurrent && fw[row]) return {};
            var i = row - 1, firstRange;
            while(i >= 0){
                var c = fw[i];
                if (c == null) c = fw[i] = this.getFoldWidget(i);
                if (c == "start") {
                    var range = this.getFoldWidgetRange(i);
                    if (!firstRange) firstRange = range;
                    if (range && range.end.row >= row) break;
                }
                i--;
            }
            return {
                range: i !== -1 && range,
                firstRange: firstRange
            };
        };
        this.onFoldWidgetClick = function(row, e) {
            if (e instanceof MouseEvent) e = e.domEvent;
            var options = {
                children: e.shiftKey,
                all: e.ctrlKey || e.metaKey,
                siblings: e.altKey
            };
            var range = this.$toggleFoldWidget(row, options);
            if (!range) {
                var el = e.target || e.srcElement;
                if (el && /ace_fold-widget/.test(el.className)) el.className += " ace_invalid";
            }
        };
        this.$toggleFoldWidget = function(row, options) {
            if (!this.getFoldWidget) return;
            var type = this.getFoldWidget(row);
            var line = this.getLine(row);
            var dir = type === "end" ? -1 : 1;
            var fold = this.getFoldAt(row, dir === -1 ? 0 : line.length, dir);
            if (fold) {
                if (options.children || options.all) this.removeFold(fold);
                else this.expandFold(fold);
                return fold;
            }
            var range = this.getFoldWidgetRange(row, true);
            if (range && !range.isMultiLine()) {
                fold = this.getFoldAt(range.start.row, range.start.column, 1);
                if (fold && range.isEqual(fold.range)) {
                    this.removeFold(fold);
                    return fold;
                }
            }
            if (options.siblings) {
                var data = this.getParentFoldRangeData(row);
                if (data.range) {
                    var startRow = data.range.start.row + 1;
                    var endRow = data.range.end.row;
                }
                this.foldAll(startRow, endRow, options.all ? 10000 : 0);
            } else if (options.children) {
                endRow = range ? range.end.row : this.getLength();
                this.foldAll(row + 1, endRow, options.all ? 10000 : 0);
            } else if (range) {
                if (options.all) range.collapseChildren = 10000;
                this.addFold("...", range);
            }
            return range;
        };
        this.toggleFoldWidget = function(toggleParent) {
            var row = this.selection.getCursor().row;
            row = this.getRowFoldStart(row);
            var range = this.$toggleFoldWidget(row, {});
            if (range) return;
            var data = this.getParentFoldRangeData(row, true);
            range = data.range || data.firstRange;
            if (range) {
                row = range.start.row;
                var fold = this.getFoldAt(row, this.getLine(row).length, 1);
                if (fold) this.removeFold(fold);
                else this.addFold("...", range);
            }
        };
        this.updateFoldWidgets = function(delta) {
            var firstRow = delta.start.row;
            var len = delta.end.row - firstRow;
            if (len === 0) this.foldWidgets[firstRow] = null;
            else if (delta.action == "remove") this.foldWidgets.splice(firstRow, len + 1, null);
            else {
                var args = Array(len + 1);
                args.unshift(firstRow, 1);
                this.foldWidgets.splice.apply(this.foldWidgets, args);
            }
        };
        this.tokenizerUpdateFoldWidgets = function(e) {
            var rows = e.data;
            if (rows.first != rows.last) {
                if (this.foldWidgets.length > rows.first) this.foldWidgets.splice(rows.first, this.foldWidgets.length);
            }
        };
    }
    exports.Folding = Folding;
});
ace.define("ace/edit_session/bracket_match", [
    "require",
    "exports",
    "module",
    "ace/token_iterator",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var TokenIterator = require("../token_iterator").TokenIterator;
    var Range = require("../range").Range;
    function BracketMatch() {
        this.findMatchingBracket = function(position, chr) {
            if (position.column == 0) return null;
            var charBeforeCursor = chr || this.getLine(position.row).charAt(position.column - 1);
            if (charBeforeCursor == "") return null;
            var match = charBeforeCursor.match(/([\(\[\{])|([\)\]\}])/);
            if (!match) return null;
            if (match[1]) return this.$findClosingBracket(match[1], position);
            else return this.$findOpeningBracket(match[2], position);
        };
        this.getBracketRange = function(pos) {
            var line = this.getLine(pos.row);
            var before = true, range;
            var chr = line.charAt(pos.column - 1);
            var match = chr && chr.match(/([\(\[\{])|([\)\]\}])/);
            if (!match) {
                chr = line.charAt(pos.column);
                pos = {
                    row: pos.row,
                    column: pos.column + 1
                };
                match = chr && chr.match(/([\(\[\{])|([\)\]\}])/);
                before = false;
            }
            if (!match) return null;
            if (match[1]) {
                var bracketPos = this.$findClosingBracket(match[1], pos);
                if (!bracketPos) return null;
                range = Range.fromPoints(pos, bracketPos);
                if (!before) {
                    range.end.column++;
                    range.start.column--;
                }
                range.cursor = range.end;
            } else {
                var bracketPos = this.$findOpeningBracket(match[2], pos);
                if (!bracketPos) return null;
                range = Range.fromPoints(bracketPos, pos);
                if (!before) {
                    range.start.column++;
                    range.end.column--;
                }
                range.cursor = range.start;
            }
            return range;
        };
        this.getMatchingBracketRanges = function(pos, isBackwards) {
            var line = this.getLine(pos.row);
            var bracketsRegExp = /([\(\[\{])|([\)\]\}])/;
            var chr = !isBackwards && line.charAt(pos.column - 1);
            var match = chr && chr.match(bracketsRegExp);
            if (!match) {
                chr = (isBackwards === undefined || isBackwards) && line.charAt(pos.column);
                pos = {
                    row: pos.row,
                    column: pos.column + 1
                };
                match = chr && chr.match(bracketsRegExp);
            }
            if (!match) return null;
            var startRange = new Range(pos.row, pos.column - 1, pos.row, pos.column);
            var bracketPos = match[1] ? this.$findClosingBracket(match[1], pos) : this.$findOpeningBracket(match[2], pos);
            if (!bracketPos) return [
                startRange
            ];
            var endRange = new Range(bracketPos.row, bracketPos.column, bracketPos.row, bracketPos.column + 1);
            return [
                startRange,
                endRange
            ];
        };
        this.$brackets = {
            ")": "(",
            "(": ")",
            "]": "[",
            "[": "]",
            "{": "}",
            "}": "{",
            "<": ">",
            ">": "<"
        };
        this.$findOpeningBracket = function(bracket, position, typeRe) {
            var openBracket = this.$brackets[bracket];
            var depth = 1;
            var iterator = new TokenIterator(this, position.row, position.column);
            var token = iterator.getCurrentToken();
            if (!token) token = iterator.stepForward();
            if (!token) return;
            if (!typeRe) typeRe = new RegExp("(\\.?" + token.type.replace(".", "\\.").replace("rparen", ".paren").replace(/\b(?:end)\b/, "(?:start|begin|end)").replace(/-close\b/, "-(close|open)") + ")+");
            var valueIndex = position.column - iterator.getCurrentTokenColumn() - 2;
            var value = token.value;
            while(true){
                while(valueIndex >= 0){
                    var chr = value.charAt(valueIndex);
                    if (chr == openBracket) {
                        depth -= 1;
                        if (depth == 0) return {
                            row: iterator.getCurrentTokenRow(),
                            column: valueIndex + iterator.getCurrentTokenColumn()
                        };
                    } else if (chr == bracket) depth += 1;
                    valueIndex -= 1;
                }
                do token = iterator.stepBackward();
                while (token && !typeRe.test(token.type));
                if (token == null) break;
                value = token.value;
                valueIndex = value.length - 1;
            }
            return null;
        };
        this.$findClosingBracket = function(bracket, position, typeRe) {
            var closingBracket = this.$brackets[bracket];
            var depth = 1;
            var iterator = new TokenIterator(this, position.row, position.column);
            var token = iterator.getCurrentToken();
            if (!token) token = iterator.stepForward();
            if (!token) return;
            if (!typeRe) typeRe = new RegExp("(\\.?" + token.type.replace(".", "\\.").replace("lparen", ".paren").replace(/\b(?:start|begin)\b/, "(?:start|begin|end)").replace(/-open\b/, "-(close|open)") + ")+");
            var valueIndex = position.column - iterator.getCurrentTokenColumn();
            while(true){
                var value = token.value;
                var valueLength = value.length;
                while(valueIndex < valueLength){
                    var chr = value.charAt(valueIndex);
                    if (chr == closingBracket) {
                        depth -= 1;
                        if (depth == 0) return {
                            row: iterator.getCurrentTokenRow(),
                            column: valueIndex + iterator.getCurrentTokenColumn()
                        };
                    } else if (chr == bracket) depth += 1;
                    valueIndex += 1;
                }
                do token = iterator.stepForward();
                while (token && !typeRe.test(token.type));
                if (token == null) break;
                valueIndex = 0;
            }
            return null;
        };
        this.getMatchingTags = function(pos) {
            var iterator = new TokenIterator(this, pos.row, pos.column);
            var token = this.$findTagName(iterator);
            if (!token) return;
            var prevToken = iterator.stepBackward();
            if (prevToken.value === "<") return this.$findClosingTag(iterator, token);
            else return this.$findOpeningTag(iterator, token);
        };
        this.$findTagName = function(iterator) {
            var token = iterator.getCurrentToken();
            var found = false;
            var backward = false;
            if (token && token.type.indexOf("tag-name") === -1) do {
                if (backward) token = iterator.stepBackward();
                else token = iterator.stepForward();
                if (token) {
                    if (token.value === "/>") backward = true;
                    else if (token.type.indexOf("tag-name") !== -1) found = true;
                }
            }while (token && !found);
            return token;
        };
        this.$findClosingTag = function(iterator, token) {
            var prevToken;
            var currentTag = token.value;
            var tag = token.value;
            var depth = 0;
            var openTagStart = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1);
            token = iterator.stepForward();
            var openTagName = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + token.value.length);
            var foundOpenTagEnd = false;
            do {
                prevToken = token;
                if (prevToken.type.indexOf("tag-close") !== -1 && !foundOpenTagEnd) {
                    var openTagEnd = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1); //Range for `>`
                    foundOpenTagEnd = true;
                }
                token = iterator.stepForward();
                if (token) {
                    if (token.value === ">" && !foundOpenTagEnd) {
                        var openTagEnd = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1); //Range for `>`
                        foundOpenTagEnd = true;
                    }
                    if (token.type.indexOf("tag-name") !== -1) {
                        currentTag = token.value;
                        if (tag === currentTag) {
                            if (prevToken.value === "<") depth++;
                            else if (prevToken.value === "</") {
                                depth--;
                                if (depth < 0) {
                                    iterator.stepBackward();
                                    var closeTagStart = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 2); //Range for </
                                    token = iterator.stepForward();
                                    var closeTagName = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + token.value.length);
                                    if (token.type.indexOf("tag-close") === -1) token = iterator.stepForward();
                                    if (token && token.value === ">") var closeTagEnd = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1); //Range for >
                                    else return;
                                }
                            }
                        }
                    } else if (tag === currentTag && token.value === "/>") {
                        depth--;
                        if (depth < 0) {
                            var closeTagStart = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 2);
                            var closeTagName = closeTagStart;
                            var closeTagEnd = closeTagName;
                            var openTagEnd = new Range(openTagName.end.row, openTagName.end.column, openTagName.end.row, openTagName.end.column + 1);
                        }
                    }
                }
            }while (token && depth >= 0);
            if (openTagStart && openTagEnd && closeTagStart && closeTagEnd && openTagName && closeTagName) return {
                openTag: new Range(openTagStart.start.row, openTagStart.start.column, openTagEnd.end.row, openTagEnd.end.column),
                closeTag: new Range(closeTagStart.start.row, closeTagStart.start.column, closeTagEnd.end.row, closeTagEnd.end.column),
                openTagName: openTagName,
                closeTagName: closeTagName
            };
        };
        this.$findOpeningTag = function(iterator, token) {
            var prevToken = iterator.getCurrentToken();
            var tag = token.value;
            var depth = 0;
            var startRow = iterator.getCurrentTokenRow();
            var startColumn = iterator.getCurrentTokenColumn();
            var endColumn = startColumn + 2;
            var closeTagStart = new Range(startRow, startColumn, startRow, endColumn); //Range for </
            iterator.stepForward();
            var closeTagName = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + token.value.length);
            if (token.type.indexOf("tag-close") === -1) token = iterator.stepForward();
            if (!token || token.value !== ">") return;
            var closeTagEnd = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1); //Range for >
            iterator.stepBackward();
            iterator.stepBackward();
            do {
                token = prevToken;
                startRow = iterator.getCurrentTokenRow();
                startColumn = iterator.getCurrentTokenColumn();
                endColumn = startColumn + token.value.length;
                prevToken = iterator.stepBackward();
                if (token) {
                    if (token.type.indexOf("tag-name") !== -1) {
                        if (tag === token.value) {
                            if (prevToken.value === "<") {
                                depth++;
                                if (depth > 0) {
                                    var openTagName = new Range(startRow, startColumn, startRow, endColumn);
                                    var openTagStart = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1); //Range for <
                                    do token = iterator.stepForward();
                                    while (token && token.value !== ">");
                                    var openTagEnd = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1); //Range for >
                                }
                            } else if (prevToken.value === "</") depth--;
                        }
                    } else if (token.value === "/>") {
                        var stepCount = 0;
                        var tmpToken = prevToken;
                        while(tmpToken){
                            if (tmpToken.type.indexOf("tag-name") !== -1 && tmpToken.value === tag) {
                                depth--;
                                break;
                            } else if (tmpToken.value === "<") break;
                            tmpToken = iterator.stepBackward();
                            stepCount++;
                        }
                        for(var i = 0; i < stepCount; i++)iterator.stepForward();
                    }
                }
            }while (prevToken && depth <= 0);
            if (openTagStart && openTagEnd && closeTagStart && closeTagEnd && openTagName && closeTagName) return {
                openTag: new Range(openTagStart.start.row, openTagStart.start.column, openTagEnd.end.row, openTagEnd.end.column),
                closeTag: new Range(closeTagStart.start.row, closeTagStart.start.column, closeTagEnd.end.row, closeTagEnd.end.column),
                openTagName: openTagName,
                closeTagName: closeTagName
            };
        };
    }
    exports.BracketMatch = BracketMatch;
});
ace.define("ace/edit_session", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/bidihandler",
    "ace/config",
    "ace/lib/event_emitter",
    "ace/selection",
    "ace/mode/text",
    "ace/range",
    "ace/document",
    "ace/background_tokenizer",
    "ace/search_highlight",
    "ace/undomanager",
    "ace/edit_session/folding",
    "ace/edit_session/bracket_match"
], function(require, exports, module1) {
    "use strict";
    var oop = require("./lib/oop");
    var lang = require("./lib/lang");
    var BidiHandler = require("./bidihandler").BidiHandler;
    var config = require("./config");
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var Selection = require("./selection").Selection;
    var TextMode = require("./mode/text").Mode;
    var Range = require("./range").Range;
    var Document = require("./document").Document;
    var BackgroundTokenizer = require("./background_tokenizer").BackgroundTokenizer;
    var SearchHighlight = require("./search_highlight").SearchHighlight;
    var UndoManager = require("./undomanager").UndoManager;
    var EditSession = /** @class */ function() {
        function EditSession(text, mode) {
            this.doc;
            this.$breakpoints = [];
            this.$decorations = [];
            this.$frontMarkers = {};
            this.$backMarkers = {};
            this.$markerId = 1;
            this.$undoSelect = true;
            this.$foldData = [];
            this.id = "session" + ++EditSession.$uid;
            this.$foldData.toString = function() {
                return this.join("\n");
            };
            this.bgTokenizer = new BackgroundTokenizer(new TextMode().getTokenizer(), this);
            var _self = this;
            this.bgTokenizer.on("update", function(e) {
                _self._signal("tokenizerUpdate", e);
            });
            this.on("changeFold", this.onChangeFold.bind(this));
            this.$onChange = this.onChange.bind(this);
            if (typeof text != "object" || !text.getLine) text = new Document(/**@type{string}*/ text);
            this.setDocument(text);
            this.selection = new Selection(this);
            this.$bidiHandler = new BidiHandler(this);
            config.resetOptions(this);
            this.setMode(mode);
            config._signal("session", this);
            this.destroyed = false;
        }
        EditSession.prototype.setDocument = function(doc) {
            if (this.doc) this.doc.off("change", this.$onChange);
            this.doc = doc;
            doc.on("change", this.$onChange, true);
            this.bgTokenizer.setDocument(this.getDocument());
            this.resetCaches();
        };
        EditSession.prototype.getDocument = function() {
            return this.doc;
        };
        EditSession.prototype.$resetRowCache = function(docRow) {
            if (!docRow) {
                this.$docRowCache = [];
                this.$screenRowCache = [];
                return;
            }
            var l = this.$docRowCache.length;
            var i = this.$getRowCacheIndex(this.$docRowCache, docRow) + 1;
            if (l > i) {
                this.$docRowCache.splice(i, l);
                this.$screenRowCache.splice(i, l);
            }
        };
        EditSession.prototype.$getRowCacheIndex = function(cacheArray, val) {
            var low = 0;
            var hi = cacheArray.length - 1;
            while(low <= hi){
                var mid = low + hi >> 1;
                var c = cacheArray[mid];
                if (val > c) low = mid + 1;
                else if (val < c) hi = mid - 1;
                else return mid;
            }
            return low - 1;
        };
        EditSession.prototype.resetCaches = function() {
            this.$modified = true;
            this.$wrapData = [];
            this.$rowLengthCache = [];
            this.$resetRowCache(0);
            if (!this.destroyed) this.bgTokenizer.start(0);
        };
        EditSession.prototype.onChangeFold = function(e) {
            var fold = e.data;
            this.$resetRowCache(fold.start.row);
        };
        EditSession.prototype.onChange = function(delta) {
            this.$modified = true;
            this.$bidiHandler.onChange(delta);
            this.$resetRowCache(delta.start.row);
            var removedFolds = this.$updateInternalDataOnChange(delta);
            if (!this.$fromUndo && this.$undoManager) {
                if (removedFolds && removedFolds.length) {
                    this.$undoManager.add({
                        action: "removeFolds",
                        folds: removedFolds
                    }, this.mergeUndoDeltas);
                    this.mergeUndoDeltas = true;
                }
                this.$undoManager.add(delta, this.mergeUndoDeltas);
                this.mergeUndoDeltas = true;
                this.$informUndoManager.schedule();
            }
            this.bgTokenizer.$updateOnChange(delta);
            this._signal("change", delta);
        };
        EditSession.prototype.setValue = function(text) {
            this.doc.setValue(text);
            this.selection.moveTo(0, 0);
            this.$resetRowCache(0);
            this.setUndoManager(this.$undoManager);
            this.getUndoManager().reset();
        };
        EditSession.fromJSON = function(session) {
            if (typeof session == "string") session = JSON.parse(session);
            var undoManager = new UndoManager();
            undoManager.$undoStack = session.history.undo;
            undoManager.$redoStack = session.history.redo;
            undoManager.mark = session.history.mark;
            undoManager.$rev = session.history.rev;
            var editSession = new EditSession(session.value);
            session.folds.forEach(function(fold) {
                editSession.addFold("...", Range.fromPoints(fold.start, fold.end));
            });
            editSession.setAnnotations(session.annotations);
            editSession.setBreakpoints(session.breakpoints);
            editSession.setMode(session.mode);
            editSession.setScrollLeft(session.scrollLeft);
            editSession.setScrollTop(session.scrollTop);
            editSession.setUndoManager(undoManager);
            editSession.selection.fromJSON(session.selection);
            return editSession;
        };
        EditSession.prototype.toJSON = function() {
            return {
                annotations: this.$annotations,
                breakpoints: this.$breakpoints,
                folds: this.getAllFolds().map(function(fold) {
                    return fold.range;
                }),
                history: this.getUndoManager(),
                mode: this.$mode.$id,
                scrollLeft: this.$scrollLeft,
                scrollTop: this.$scrollTop,
                selection: this.selection.toJSON(),
                value: this.doc.getValue()
            };
        };
        EditSession.prototype.toString = function() {
            return this.doc.getValue();
        };
        EditSession.prototype.getSelection = function() {
            return this.selection;
        };
        EditSession.prototype.getState = function(row) {
            return this.bgTokenizer.getState(row);
        };
        EditSession.prototype.getTokens = function(row) {
            return this.bgTokenizer.getTokens(row);
        };
        EditSession.prototype.getTokenAt = function(row, column) {
            var tokens = this.bgTokenizer.getTokens(row);
            var token, c = 0;
            if (column == null) {
                var i = tokens.length - 1;
                c = this.getLine(row).length;
            } else for(var i = 0; i < tokens.length; i++){
                c += tokens[i].value.length;
                if (c >= column) break;
            }
            token = tokens[i];
            if (!token) return null;
            token.index = i;
            token.start = c - token.value.length;
            return token;
        };
        EditSession.prototype.setUndoManager = function(undoManager) {
            this.$undoManager = undoManager;
            if (this.$informUndoManager) this.$informUndoManager.cancel();
            if (undoManager) {
                var self1 = this;
                undoManager.addSession(this);
                this.$syncInformUndoManager = function() {
                    self1.$informUndoManager.cancel();
                    self1.mergeUndoDeltas = false;
                };
                this.$informUndoManager = lang.delayedCall(this.$syncInformUndoManager);
            } else this.$syncInformUndoManager = function() {};
        };
        EditSession.prototype.markUndoGroup = function() {
            if (this.$syncInformUndoManager) this.$syncInformUndoManager();
        };
        EditSession.prototype.getUndoManager = function() {
            return this.$undoManager || this.$defaultUndoManager;
        };
        EditSession.prototype.getTabString = function() {
            if (this.getUseSoftTabs()) return lang.stringRepeat(" ", this.getTabSize());
            else return "	";
        };
        EditSession.prototype.setUseSoftTabs = function(val) {
            this.setOption("useSoftTabs", val);
        };
        EditSession.prototype.getUseSoftTabs = function() {
            return this.$useSoftTabs && !this.$mode.$indentWithTabs;
        };
        EditSession.prototype.setTabSize = function(tabSize) {
            this.setOption("tabSize", tabSize);
        };
        EditSession.prototype.getTabSize = function() {
            return this.$tabSize;
        };
        EditSession.prototype.isTabStop = function(position) {
            return this.$useSoftTabs && position.column % this.$tabSize === 0;
        };
        EditSession.prototype.setNavigateWithinSoftTabs = function(navigateWithinSoftTabs) {
            this.setOption("navigateWithinSoftTabs", navigateWithinSoftTabs);
        };
        EditSession.prototype.getNavigateWithinSoftTabs = function() {
            return this.$navigateWithinSoftTabs;
        };
        EditSession.prototype.setOverwrite = function(overwrite) {
            this.setOption("overwrite", overwrite);
        };
        EditSession.prototype.getOverwrite = function() {
            return this.$overwrite;
        };
        EditSession.prototype.toggleOverwrite = function() {
            this.setOverwrite(!this.$overwrite);
        };
        EditSession.prototype.addGutterDecoration = function(row, className) {
            if (!this.$decorations[row]) this.$decorations[row] = "";
            this.$decorations[row] += " " + className;
            this._signal("changeBreakpoint", {});
        };
        EditSession.prototype.removeGutterDecoration = function(row, className) {
            this.$decorations[row] = (this.$decorations[row] || "").replace(" " + className, "");
            this._signal("changeBreakpoint", {});
        };
        EditSession.prototype.getBreakpoints = function() {
            return this.$breakpoints;
        };
        EditSession.prototype.setBreakpoints = function(rows) {
            this.$breakpoints = [];
            for(var i = 0; i < rows.length; i++)this.$breakpoints[rows[i]] = "ace_breakpoint";
            this._signal("changeBreakpoint", {});
        };
        EditSession.prototype.clearBreakpoints = function() {
            this.$breakpoints = [];
            this._signal("changeBreakpoint", {});
        };
        EditSession.prototype.setBreakpoint = function(row, className) {
            if (className === undefined) className = "ace_breakpoint";
            if (className) this.$breakpoints[row] = className;
            else delete this.$breakpoints[row];
            this._signal("changeBreakpoint", {});
        };
        EditSession.prototype.clearBreakpoint = function(row) {
            delete this.$breakpoints[row];
            this._signal("changeBreakpoint", {});
        };
        EditSession.prototype.addMarker = function(range, clazz, type, inFront) {
            var id = this.$markerId++;
            var marker = {
                range: range,
                type: type || "line",
                renderer: typeof type == "function" ? type : null,
                clazz: clazz,
                inFront: !!inFront,
                id: id
            };
            if (inFront) {
                this.$frontMarkers[id] = marker;
                this._signal("changeFrontMarker");
            } else {
                this.$backMarkers[id] = marker;
                this._signal("changeBackMarker");
            }
            return id;
        };
        EditSession.prototype.addDynamicMarker = function(marker, inFront) {
            if (!marker.update) return;
            var id = this.$markerId++;
            marker.id = id;
            marker.inFront = !!inFront;
            if (inFront) {
                this.$frontMarkers[id] = marker;
                this._signal("changeFrontMarker");
            } else {
                this.$backMarkers[id] = marker;
                this._signal("changeBackMarker");
            }
            return marker;
        };
        EditSession.prototype.removeMarker = function(markerId) {
            var marker = this.$frontMarkers[markerId] || this.$backMarkers[markerId];
            if (!marker) return;
            var markers = marker.inFront ? this.$frontMarkers : this.$backMarkers;
            delete markers[markerId];
            this._signal(marker.inFront ? "changeFrontMarker" : "changeBackMarker");
        };
        EditSession.prototype.getMarkers = function(inFront) {
            return inFront ? this.$frontMarkers : this.$backMarkers;
        };
        EditSession.prototype.highlight = function(re) {
            if (!this.$searchHighlight) {
                var highlight = new SearchHighlight(null, "ace_selected-word", "text");
                this.$searchHighlight = this.addDynamicMarker(highlight);
            }
            this.$searchHighlight.setRegexp(re);
        };
        EditSession.prototype.highlightLines = function(startRow, endRow, clazz, inFront) {
            if (typeof endRow != "number") {
                clazz = endRow;
                endRow = startRow;
            }
            if (!clazz) clazz = "ace_step";
            var range = new Range(startRow, 0, endRow, Infinity);
            range.id = this.addMarker(range, clazz, "fullLine", inFront);
            return range;
        };
        EditSession.prototype.setAnnotations = function(annotations) {
            this.$annotations = annotations;
            this._signal("changeAnnotation", {});
        };
        EditSession.prototype.getAnnotations = function() {
            return this.$annotations || [];
        };
        EditSession.prototype.clearAnnotations = function() {
            this.setAnnotations([]);
        };
        EditSession.prototype.$detectNewLine = function(text) {
            var match = text.match(/^.*?(\r?\n)/m);
            if (match) this.$autoNewLine = match[1];
            else this.$autoNewLine = "\n";
        };
        EditSession.prototype.getWordRange = function(row, column) {
            var line = this.getLine(row);
            var inToken = false;
            if (column > 0) inToken = !!line.charAt(column - 1).match(this.tokenRe);
            if (!inToken) inToken = !!line.charAt(column).match(this.tokenRe);
            if (inToken) var re = this.tokenRe;
            else if (/^\s+$/.test(line.slice(column - 1, column + 1))) var re = /\s/;
            else var re = this.nonTokenRe;
            var start = column;
            if (start > 0) {
                do start--;
                while (start >= 0 && line.charAt(start).match(re));
                start++;
            }
            var end = column;
            while(end < line.length && line.charAt(end).match(re))end++;
            return new Range(row, start, row, end);
        };
        EditSession.prototype.getAWordRange = function(row, column) {
            var wordRange = this.getWordRange(row, column);
            var line = this.getLine(wordRange.end.row);
            while(line.charAt(wordRange.end.column).match(/[ \t]/))wordRange.end.column += 1;
            return wordRange;
        };
        EditSession.prototype.setNewLineMode = function(newLineMode) {
            this.doc.setNewLineMode(newLineMode);
        };
        EditSession.prototype.getNewLineMode = function() {
            return this.doc.getNewLineMode();
        };
        EditSession.prototype.setUseWorker = function(useWorker) {
            this.setOption("useWorker", useWorker);
        };
        EditSession.prototype.getUseWorker = function() {
            return this.$useWorker;
        };
        EditSession.prototype.onReloadTokenizer = function(e) {
            var rows = e.data;
            this.bgTokenizer.start(rows.first);
            this._signal("tokenizerUpdate", e);
        };
        EditSession.prototype.setMode = function(mode, cb) {
            if (mode && typeof mode === "object") {
                if (mode.getTokenizer) return this.$onChangeMode(mode);
                var options = mode;
                var path = options.path;
            } else path = /**@type{string}*/ mode || "ace/mode/text";
            if (!this.$modes["ace/mode/text"]) this.$modes["ace/mode/text"] = new TextMode();
            if (this.$modes[path] && !options) {
                this.$onChangeMode(this.$modes[path]);
                cb && cb();
                return;
            }
            this.$modeId = path;
            config.loadModule([
                "mode",
                path
            ], (function(m) {
                if (this.$modeId !== path) return cb && cb();
                if (this.$modes[path] && !options) this.$onChangeMode(this.$modes[path]);
                else if (m && m.Mode) {
                    m = new m.Mode(options);
                    if (!options) {
                        this.$modes[path] = m;
                        m.$id = path;
                    }
                    this.$onChangeMode(m);
                }
                cb && cb();
            }).bind(this));
            if (!this.$mode) this.$onChangeMode(this.$modes["ace/mode/text"], true);
        };
        EditSession.prototype.$onChangeMode = function(mode, $isPlaceholder) {
            if (!$isPlaceholder) this.$modeId = mode.$id;
            if (this.$mode === mode) return;
            var oldMode = this.$mode;
            this.$mode = mode;
            this.$stopWorker();
            if (this.$useWorker) this.$startWorker();
            var tokenizer = mode.getTokenizer();
            if (tokenizer.on !== undefined) {
                var onReloadTokenizer = this.onReloadTokenizer.bind(this);
                tokenizer.on("update", onReloadTokenizer);
            }
            this.bgTokenizer.setTokenizer(tokenizer);
            this.bgTokenizer.setDocument(this.getDocument());
            this.tokenRe = mode.tokenRe;
            this.nonTokenRe = mode.nonTokenRe;
            if (!$isPlaceholder) {
                if (mode.attachToSession) mode.attachToSession(this);
                this.$options.wrapMethod.set.call(this, this.$wrapMethod);
                this.$setFolding(mode.foldingRules);
                this.bgTokenizer.start(0);
                this._emit("changeMode", {
                    oldMode: oldMode,
                    mode: mode
                });
            }
        };
        EditSession.prototype.$stopWorker = function() {
            if (this.$worker) {
                this.$worker.terminate();
                this.$worker = null;
            }
        };
        EditSession.prototype.$startWorker = function() {
            try {
                this.$worker = this.$mode.createWorker(this);
            } catch (e) {
                config.warn("Could not load worker", e);
                this.$worker = null;
            }
        };
        EditSession.prototype.getMode = function() {
            return this.$mode;
        };
        EditSession.prototype.setScrollTop = function(scrollTop) {
            if (this.$scrollTop === scrollTop || isNaN(scrollTop)) return;
            this.$scrollTop = scrollTop;
            this._signal("changeScrollTop", scrollTop);
        };
        EditSession.prototype.getScrollTop = function() {
            return this.$scrollTop;
        };
        EditSession.prototype.setScrollLeft = function(scrollLeft) {
            if (this.$scrollLeft === scrollLeft || isNaN(scrollLeft)) return;
            this.$scrollLeft = scrollLeft;
            this._signal("changeScrollLeft", scrollLeft);
        };
        EditSession.prototype.getScrollLeft = function() {
            return this.$scrollLeft;
        };
        EditSession.prototype.getScreenWidth = function() {
            this.$computeWidth();
            if (this.lineWidgets) return Math.max(this.getLineWidgetMaxWidth(), this.screenWidth);
            return this.screenWidth;
        };
        EditSession.prototype.getLineWidgetMaxWidth = function() {
            if (this.lineWidgetsWidth != null) return this.lineWidgetsWidth;
            var width = 0;
            this.lineWidgets.forEach(function(w) {
                if (w && w.screenWidth > width) width = w.screenWidth;
            });
            return this.lineWidgetWidth = width;
        };
        EditSession.prototype.$computeWidth = function(force) {
            if (this.$modified || force) {
                this.$modified = false;
                if (this.$useWrapMode) return this.screenWidth = this.$wrapLimit;
                var lines = this.doc.getAllLines();
                var cache = this.$rowLengthCache;
                var longestScreenLine = 0;
                var foldIndex = 0;
                var foldLine = this.$foldData[foldIndex];
                var foldStart = foldLine ? foldLine.start.row : Infinity;
                var len = lines.length;
                for(var i = 0; i < len; i++){
                    if (i > foldStart) {
                        i = foldLine.end.row + 1;
                        if (i >= len) break;
                        foldLine = this.$foldData[foldIndex++];
                        foldStart = foldLine ? foldLine.start.row : Infinity;
                    }
                    if (cache[i] == null) cache[i] = this.$getStringScreenWidth(lines[i])[0];
                    if (cache[i] > longestScreenLine) longestScreenLine = cache[i];
                }
                this.screenWidth = longestScreenLine;
            }
        };
        EditSession.prototype.getLine = function(row) {
            return this.doc.getLine(row);
        };
        EditSession.prototype.getLines = function(firstRow, lastRow) {
            return this.doc.getLines(firstRow, lastRow);
        };
        EditSession.prototype.getLength = function() {
            return this.doc.getLength();
        };
        EditSession.prototype.getTextRange = function(range) {
            return this.doc.getTextRange(range || this.selection.getRange());
        };
        EditSession.prototype.insert = function(position, text) {
            return this.doc.insert(position, text);
        };
        EditSession.prototype.remove = function(range) {
            return this.doc.remove(range);
        };
        EditSession.prototype.removeFullLines = function(firstRow, lastRow) {
            return this.doc.removeFullLines(firstRow, lastRow);
        };
        EditSession.prototype.undoChanges = function(deltas, dontSelect) {
            if (!deltas.length) return;
            this.$fromUndo = true;
            for(var i = deltas.length - 1; i != -1; i--){
                var delta = deltas[i];
                if (delta.action == "insert" || delta.action == "remove") this.doc.revertDelta(delta);
                else if (delta.folds) this.addFolds(delta.folds);
            }
            if (!dontSelect && this.$undoSelect) {
                if (deltas.selectionBefore) this.selection.fromJSON(deltas.selectionBefore);
                else this.selection.setRange(this.$getUndoSelection(deltas, true));
            }
            this.$fromUndo = false;
        };
        EditSession.prototype.redoChanges = function(deltas, dontSelect) {
            if (!deltas.length) return;
            this.$fromUndo = true;
            for(var i = 0; i < deltas.length; i++){
                var delta = deltas[i];
                if (delta.action == "insert" || delta.action == "remove") this.doc.$safeApplyDelta(delta);
            }
            if (!dontSelect && this.$undoSelect) {
                if (deltas.selectionAfter) this.selection.fromJSON(deltas.selectionAfter);
                else this.selection.setRange(this.$getUndoSelection(deltas, false));
            }
            this.$fromUndo = false;
        };
        EditSession.prototype.setUndoSelect = function(enable) {
            this.$undoSelect = enable;
        };
        EditSession.prototype.$getUndoSelection = function(deltas, isUndo) {
            function isInsert(delta) {
                return isUndo ? delta.action !== "insert" : delta.action === "insert";
            }
            var range, point;
            for(var i = 0; i < deltas.length; i++){
                var delta = deltas[i];
                if (!delta.start) continue; // skip folds
                if (!range) {
                    if (isInsert(delta)) range = Range.fromPoints(delta.start, delta.end);
                    else range = Range.fromPoints(delta.start, delta.start);
                    continue;
                }
                if (isInsert(delta)) {
                    point = delta.start;
                    if (range.compare(point.row, point.column) == -1) range.setStart(point);
                    point = delta.end;
                    if (range.compare(point.row, point.column) == 1) range.setEnd(point);
                } else {
                    point = delta.start;
                    if (range.compare(point.row, point.column) == -1) range = Range.fromPoints(delta.start, delta.start);
                }
            }
            return range;
        };
        EditSession.prototype.replace = function(range, text) {
            return this.doc.replace(range, text);
        };
        EditSession.prototype.moveText = function(fromRange, toPosition, copy) {
            var text = this.getTextRange(fromRange);
            var folds = this.getFoldsInRange(fromRange);
            var toRange = Range.fromPoints(toPosition, toPosition);
            if (!copy) {
                this.remove(fromRange);
                var rowDiff = fromRange.start.row - fromRange.end.row;
                var collDiff = rowDiff ? -fromRange.end.column : fromRange.start.column - fromRange.end.column;
                if (collDiff) {
                    if (toRange.start.row == fromRange.end.row && toRange.start.column > fromRange.end.column) toRange.start.column += collDiff;
                    if (toRange.end.row == fromRange.end.row && toRange.end.column > fromRange.end.column) toRange.end.column += collDiff;
                }
                if (rowDiff && toRange.start.row >= fromRange.end.row) {
                    toRange.start.row += rowDiff;
                    toRange.end.row += rowDiff;
                }
            }
            toRange.end = this.insert(toRange.start, text);
            if (folds.length) {
                var oldStart = fromRange.start;
                var newStart = toRange.start;
                var rowDiff = newStart.row - oldStart.row;
                var collDiff = newStart.column - oldStart.column;
                this.addFolds(folds.map(function(x) {
                    x = x.clone();
                    if (x.start.row == oldStart.row) x.start.column += collDiff;
                    if (x.end.row == oldStart.row) x.end.column += collDiff;
                    x.start.row += rowDiff;
                    x.end.row += rowDiff;
                    return x;
                }));
            }
            return toRange;
        };
        EditSession.prototype.indentRows = function(startRow, endRow, indentString) {
            indentString = indentString.replace(/\t/g, this.getTabString());
            for(var row = startRow; row <= endRow; row++)this.doc.insertInLine({
                row: row,
                column: 0
            }, indentString);
        };
        EditSession.prototype.outdentRows = function(range) {
            var rowRange = range.collapseRows();
            var deleteRange = new Range(0, 0, 0, 0);
            var size = this.getTabSize();
            for(var i = rowRange.start.row; i <= rowRange.end.row; ++i){
                var line = this.getLine(i);
                deleteRange.start.row = i;
                deleteRange.end.row = i;
                for(var j = 0; j < size; ++j)if (line.charAt(j) != " ") break;
                if (j < size && line.charAt(j) == "	") {
                    deleteRange.start.column = j;
                    deleteRange.end.column = j + 1;
                } else {
                    deleteRange.start.column = 0;
                    deleteRange.end.column = j;
                }
                this.remove(deleteRange);
            }
        };
        EditSession.prototype.$moveLines = function(firstRow, lastRow, dir) {
            firstRow = this.getRowFoldStart(firstRow);
            lastRow = this.getRowFoldEnd(lastRow);
            if (dir < 0) {
                var row = this.getRowFoldStart(firstRow + dir);
                if (row < 0) return 0;
                var diff = row - firstRow;
            } else if (dir > 0) {
                var row = this.getRowFoldEnd(lastRow + dir);
                if (row > this.doc.getLength() - 1) return 0;
                var diff = row - lastRow;
            } else {
                firstRow = this.$clipRowToDocument(firstRow);
                lastRow = this.$clipRowToDocument(lastRow);
                var diff = lastRow - firstRow + 1;
            }
            var range = new Range(firstRow, 0, lastRow, Number.MAX_VALUE);
            var folds = this.getFoldsInRange(range).map(function(x) {
                x = x.clone();
                x.start.row += diff;
                x.end.row += diff;
                return x;
            });
            var lines = dir == 0 ? this.doc.getLines(firstRow, lastRow) : this.doc.removeFullLines(firstRow, lastRow);
            this.doc.insertFullLines(firstRow + diff, lines);
            folds.length && this.addFolds(folds);
            return diff;
        };
        EditSession.prototype.moveLinesUp = function(firstRow, lastRow) {
            return this.$moveLines(firstRow, lastRow, -1);
        };
        EditSession.prototype.moveLinesDown = function(firstRow, lastRow) {
            return this.$moveLines(firstRow, lastRow, 1);
        };
        EditSession.prototype.duplicateLines = function(firstRow, lastRow) {
            return this.$moveLines(firstRow, lastRow, 0);
        };
        EditSession.prototype.$clipRowToDocument = function(row) {
            return Math.max(0, Math.min(row, this.doc.getLength() - 1));
        };
        EditSession.prototype.$clipColumnToRow = function(row, column) {
            if (column < 0) return 0;
            return Math.min(this.doc.getLine(row).length, column);
        };
        EditSession.prototype.$clipPositionToDocument = function(row, column) {
            column = Math.max(0, column);
            if (row < 0) {
                row = 0;
                column = 0;
            } else {
                var len = this.doc.getLength();
                if (row >= len) {
                    row = len - 1;
                    column = this.doc.getLine(len - 1).length;
                } else column = Math.min(this.doc.getLine(row).length, column);
            }
            return {
                row: row,
                column: column
            };
        };
        EditSession.prototype.$clipRangeToDocument = function(range) {
            if (range.start.row < 0) {
                range.start.row = 0;
                range.start.column = 0;
            } else range.start.column = this.$clipColumnToRow(range.start.row, range.start.column);
            var len = this.doc.getLength() - 1;
            if (range.end.row > len) {
                range.end.row = len;
                range.end.column = this.doc.getLine(len).length;
            } else range.end.column = this.$clipColumnToRow(range.end.row, range.end.column);
            return range;
        };
        EditSession.prototype.setUseWrapMode = function(useWrapMode) {
            if (useWrapMode != this.$useWrapMode) {
                this.$useWrapMode = useWrapMode;
                this.$modified = true;
                this.$resetRowCache(0);
                if (useWrapMode) {
                    var len = this.getLength();
                    this.$wrapData = Array(len);
                    this.$updateWrapData(0, len - 1);
                }
                this._signal("changeWrapMode");
            }
        };
        EditSession.prototype.getUseWrapMode = function() {
            return this.$useWrapMode;
        };
        EditSession.prototype.setWrapLimitRange = function(min, max) {
            if (this.$wrapLimitRange.min !== min || this.$wrapLimitRange.max !== max) {
                this.$wrapLimitRange = {
                    min: min,
                    max: max
                };
                this.$modified = true;
                this.$bidiHandler.markAsDirty();
                if (this.$useWrapMode) this._signal("changeWrapMode");
            }
        };
        EditSession.prototype.adjustWrapLimit = function(desiredLimit, $printMargin) {
            var limits = this.$wrapLimitRange;
            if (limits.max < 0) limits = {
                min: $printMargin,
                max: $printMargin
            };
            var wrapLimit = this.$constrainWrapLimit(desiredLimit, limits.min, limits.max);
            if (wrapLimit != this.$wrapLimit && wrapLimit > 1) {
                this.$wrapLimit = wrapLimit;
                this.$modified = true;
                if (this.$useWrapMode) {
                    this.$updateWrapData(0, this.getLength() - 1);
                    this.$resetRowCache(0);
                    this._signal("changeWrapLimit");
                }
                return true;
            }
            return false;
        };
        EditSession.prototype.$constrainWrapLimit = function(wrapLimit, min, max) {
            if (min) wrapLimit = Math.max(min, wrapLimit);
            if (max) wrapLimit = Math.min(max, wrapLimit);
            return wrapLimit;
        };
        EditSession.prototype.getWrapLimit = function() {
            return this.$wrapLimit;
        };
        EditSession.prototype.setWrapLimit = function(limit) {
            this.setWrapLimitRange(limit, limit);
        };
        EditSession.prototype.getWrapLimitRange = function() {
            return {
                min: this.$wrapLimitRange.min,
                max: this.$wrapLimitRange.max
            };
        };
        EditSession.prototype.$updateInternalDataOnChange = function(delta) {
            var useWrapMode = this.$useWrapMode;
            var action = delta.action;
            var start = delta.start;
            var end = delta.end;
            var firstRow = start.row;
            var lastRow = end.row;
            var len = lastRow - firstRow;
            var removedFolds = null;
            this.$updating = true;
            if (len != 0) {
                if (action === "remove") {
                    this[useWrapMode ? "$wrapData" : "$rowLengthCache"].splice(firstRow, len);
                    var foldLines = this.$foldData;
                    removedFolds = this.getFoldsInRange(delta);
                    this.removeFolds(removedFolds);
                    var foldLine = this.getFoldLine(end.row);
                    var idx = 0;
                    if (foldLine) {
                        foldLine.addRemoveChars(end.row, end.column, start.column - end.column);
                        foldLine.shiftRow(-len);
                        var foldLineBefore = this.getFoldLine(firstRow);
                        if (foldLineBefore && foldLineBefore !== foldLine) {
                            foldLineBefore.merge(foldLine);
                            foldLine = foldLineBefore;
                        }
                        idx = foldLines.indexOf(foldLine) + 1;
                    }
                    for(idx; idx < foldLines.length; idx++){
                        var foldLine = foldLines[idx];
                        if (foldLine.start.row >= end.row) foldLine.shiftRow(-len);
                    }
                    lastRow = firstRow;
                } else {
                    var args = Array(len);
                    args.unshift(firstRow, 0);
                    var arr = useWrapMode ? this.$wrapData : this.$rowLengthCache;
                    arr.splice.apply(arr, args);
                    var foldLines = this.$foldData;
                    var foldLine = this.getFoldLine(firstRow);
                    var idx = 0;
                    if (foldLine) {
                        var cmp = foldLine.range.compareInside(start.row, start.column);
                        if (cmp == 0) {
                            foldLine = foldLine.split(start.row, start.column);
                            if (foldLine) {
                                foldLine.shiftRow(len);
                                foldLine.addRemoveChars(lastRow, 0, end.column - start.column);
                            }
                        } else if (cmp == -1) {
                            foldLine.addRemoveChars(firstRow, 0, end.column - start.column);
                            foldLine.shiftRow(len);
                        }
                        idx = foldLines.indexOf(foldLine) + 1;
                    }
                    for(idx; idx < foldLines.length; idx++){
                        var foldLine = foldLines[idx];
                        if (foldLine.start.row >= firstRow) foldLine.shiftRow(len);
                    }
                }
            } else {
                len = Math.abs(delta.start.column - delta.end.column);
                if (action === "remove") {
                    removedFolds = this.getFoldsInRange(delta);
                    this.removeFolds(removedFolds);
                    len = -len;
                }
                var foldLine = this.getFoldLine(firstRow);
                if (foldLine) foldLine.addRemoveChars(firstRow, start.column, len);
            }
            if (useWrapMode && this.$wrapData.length != this.doc.getLength()) console.error("doc.getLength() and $wrapData.length have to be the same!");
            this.$updating = false;
            if (useWrapMode) this.$updateWrapData(firstRow, lastRow);
            else this.$updateRowLengthCache(firstRow, lastRow);
            return removedFolds;
        };
        EditSession.prototype.$updateRowLengthCache = function(firstRow, lastRow) {
            this.$rowLengthCache[firstRow] = null;
            this.$rowLengthCache[lastRow] = null;
        };
        EditSession.prototype.$updateWrapData = function(firstRow, lastRow) {
            var lines = this.doc.getAllLines();
            var tabSize = this.getTabSize();
            var wrapData = this.$wrapData;
            var wrapLimit = this.$wrapLimit;
            var tokens;
            var foldLine;
            var row = firstRow;
            lastRow = Math.min(lastRow, lines.length - 1);
            while(row <= lastRow){
                foldLine = this.getFoldLine(row, foldLine);
                if (!foldLine) {
                    tokens = this.$getDisplayTokens(lines[row]);
                    wrapData[row] = this.$computeWrapSplits(tokens, wrapLimit, tabSize);
                    row++;
                } else {
                    tokens = [];
                    foldLine.walk((function(placeholder, row, column, lastColumn) {
                        var walkTokens;
                        if (placeholder != null) {
                            walkTokens = this.$getDisplayTokens(placeholder, tokens.length);
                            walkTokens[0] = PLACEHOLDER_START;
                            for(var i = 1; i < walkTokens.length; i++)walkTokens[i] = PLACEHOLDER_BODY;
                        } else walkTokens = this.$getDisplayTokens(lines[row].substring(lastColumn, column), tokens.length);
                        tokens = tokens.concat(walkTokens);
                    }).bind(this), foldLine.end.row, lines[foldLine.end.row].length + 1);
                    wrapData[foldLine.start.row] = this.$computeWrapSplits(tokens, wrapLimit, tabSize);
                    row = foldLine.end.row + 1;
                }
            }
        };
        EditSession.prototype.$computeWrapSplits = function(tokens, wrapLimit, tabSize) {
            if (tokens.length == 0) return [];
            var splits = [];
            var displayLength = tokens.length;
            var lastSplit = 0, lastDocSplit = 0;
            var isCode = this.$wrapAsCode;
            var indentedSoftWrap = this.$indentedSoftWrap;
            var maxIndent = wrapLimit <= Math.max(2 * tabSize, 8) || indentedSoftWrap === false ? 0 : Math.floor(wrapLimit / 2);
            function getWrapIndent() {
                var indentation = 0;
                if (maxIndent === 0) return indentation;
                if (indentedSoftWrap) for(var i = 0; i < tokens.length; i++){
                    var token = tokens[i];
                    if (token == SPACE) indentation += 1;
                    else if (token == TAB) indentation += tabSize;
                    else if (token == TAB_SPACE) continue;
                    else break;
                }
                if (isCode && indentedSoftWrap !== false) indentation += tabSize;
                return Math.min(indentation, maxIndent);
            }
            function addSplit(screenPos) {
                var len = screenPos - lastSplit;
                for(var i = lastSplit; i < screenPos; i++){
                    var ch = tokens[i];
                    if (ch === 12 || ch === 2) len -= 1;
                }
                if (!splits.length) {
                    indent = getWrapIndent();
                    splits.indent = indent;
                }
                lastDocSplit += len;
                splits.push(lastDocSplit);
                lastSplit = screenPos;
            }
            var indent = 0;
            while(displayLength - lastSplit > wrapLimit - indent){
                var split = lastSplit + wrapLimit - indent;
                if (tokens[split - 1] >= SPACE && tokens[split] >= SPACE) {
                    addSplit(split);
                    continue;
                }
                if (tokens[split] == PLACEHOLDER_START || tokens[split] == PLACEHOLDER_BODY) {
                    for(split; split != lastSplit - 1; split--){
                        if (tokens[split] == PLACEHOLDER_START) break;
                    }
                    if (split > lastSplit) {
                        addSplit(split);
                        continue;
                    }
                    split = lastSplit + wrapLimit;
                    for(split; split < tokens.length; split++){
                        if (tokens[split] != PLACEHOLDER_BODY) break;
                    }
                    if (split == tokens.length) break; // Breaks the while-loop.
                    addSplit(split);
                    continue;
                }
                var minSplit = Math.max(split - (wrapLimit - (wrapLimit >> 2)), lastSplit - 1);
                while(split > minSplit && tokens[split] < PLACEHOLDER_START)split--;
                if (isCode) {
                    while(split > minSplit && tokens[split] < PLACEHOLDER_START)split--;
                    while(split > minSplit && tokens[split] == PUNCTUATION)split--;
                } else while(split > minSplit && tokens[split] < SPACE)split--;
                if (split > minSplit) {
                    addSplit(++split);
                    continue;
                }
                split = lastSplit + wrapLimit;
                if (tokens[split] == CHAR_EXT) split--;
                addSplit(split - indent);
            }
            return splits;
        };
        EditSession.prototype.$getDisplayTokens = function(str, offset) {
            var arr = [];
            var tabSize;
            offset = offset || 0;
            for(var i = 0; i < str.length; i++){
                var c = str.charCodeAt(i);
                if (c == 9) {
                    tabSize = this.getScreenTabSize(arr.length + offset);
                    arr.push(TAB);
                    for(var n = 1; n < tabSize; n++)arr.push(TAB_SPACE);
                } else if (c == 32) arr.push(SPACE);
                else if (c > 39 && c < 48 || c > 57 && c < 64) arr.push(PUNCTUATION);
                else if (c >= 0x1100 && isFullWidth(c)) arr.push(CHAR, CHAR_EXT);
                else arr.push(CHAR);
            }
            return arr;
        };
        EditSession.prototype.$getStringScreenWidth = function(str, maxScreenColumn, screenColumn) {
            if (maxScreenColumn == 0) return [
                0,
                0
            ];
            if (maxScreenColumn == null) maxScreenColumn = Infinity;
            screenColumn = screenColumn || 0;
            var c, column;
            for(column = 0; column < str.length; column++){
                c = str.charCodeAt(column);
                if (c == 9) screenColumn += this.getScreenTabSize(screenColumn);
                else if (c >= 0x1100 && isFullWidth(c)) screenColumn += 2;
                else screenColumn += 1;
                if (screenColumn > maxScreenColumn) break;
            }
            return [
                screenColumn,
                column
            ];
        };
        EditSession.prototype.getRowLength = function(row) {
            var h = 1;
            if (this.lineWidgets) h += this.lineWidgets[row] && this.lineWidgets[row].rowCount || 0;
            if (!this.$useWrapMode || !this.$wrapData[row]) return h;
            else return this.$wrapData[row].length + h;
        };
        EditSession.prototype.getRowLineCount = function(row) {
            if (!this.$useWrapMode || !this.$wrapData[row]) return 1;
            else return this.$wrapData[row].length + 1;
        };
        EditSession.prototype.getRowWrapIndent = function(screenRow) {
            if (this.$useWrapMode) {
                var pos = this.screenToDocumentPosition(screenRow, Number.MAX_VALUE);
                var splits = this.$wrapData[pos.row];
                return splits.length && splits[0] < pos.column ? splits.indent : 0;
            } else return 0;
        };
        EditSession.prototype.getScreenLastRowColumn = function(screenRow) {
            var pos = this.screenToDocumentPosition(screenRow, Number.MAX_VALUE);
            return this.documentToScreenColumn(pos.row, pos.column);
        };
        EditSession.prototype.getDocumentLastRowColumn = function(docRow, docColumn) {
            var screenRow = this.documentToScreenRow(docRow, docColumn);
            return this.getScreenLastRowColumn(screenRow);
        };
        EditSession.prototype.getDocumentLastRowColumnPosition = function(docRow, docColumn) {
            var screenRow = this.documentToScreenRow(docRow, docColumn);
            return this.screenToDocumentPosition(screenRow, Number.MAX_VALUE / 10);
        };
        EditSession.prototype.getRowSplitData = function(row) {
            if (!this.$useWrapMode) return undefined;
            else return this.$wrapData[row];
        };
        EditSession.prototype.getScreenTabSize = function(screenColumn) {
            return this.$tabSize - (screenColumn % this.$tabSize | 0);
        };
        EditSession.prototype.screenToDocumentRow = function(screenRow, screenColumn) {
            return this.screenToDocumentPosition(screenRow, screenColumn).row;
        };
        EditSession.prototype.screenToDocumentColumn = function(screenRow, screenColumn) {
            return this.screenToDocumentPosition(screenRow, screenColumn).column;
        };
        EditSession.prototype.screenToDocumentPosition = function(screenRow, screenColumn, offsetX) {
            if (screenRow < 0) return {
                row: 0,
                column: 0
            };
            var line;
            var docRow = 0;
            var docColumn = 0;
            var column;
            var row = 0;
            var rowLength = 0;
            var rowCache = this.$screenRowCache;
            var i = this.$getRowCacheIndex(rowCache, screenRow);
            var l = rowCache.length;
            if (l && i >= 0) {
                var row = rowCache[i];
                var docRow = this.$docRowCache[i];
                var doCache = screenRow > rowCache[l - 1];
            } else var doCache = !l;
            var maxRow = this.getLength() - 1;
            var foldLine = this.getNextFoldLine(docRow);
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            while(row <= screenRow){
                rowLength = this.getRowLength(docRow);
                if (row + rowLength > screenRow || docRow >= maxRow) break;
                else {
                    row += rowLength;
                    docRow++;
                    if (docRow > foldStart) {
                        docRow = foldLine.end.row + 1;
                        foldLine = this.getNextFoldLine(docRow, foldLine);
                        foldStart = foldLine ? foldLine.start.row : Infinity;
                    }
                }
                if (doCache) {
                    this.$docRowCache.push(docRow);
                    this.$screenRowCache.push(row);
                }
            }
            if (foldLine && foldLine.start.row <= docRow) {
                line = this.getFoldDisplayLine(foldLine);
                docRow = foldLine.start.row;
            } else if (row + rowLength <= screenRow || docRow > maxRow) return {
                row: maxRow,
                column: this.getLine(maxRow).length
            };
            else {
                line = this.getLine(docRow);
                foldLine = null;
            }
            var wrapIndent = 0, splitIndex = Math.floor(screenRow - row);
            if (this.$useWrapMode) {
                var splits = this.$wrapData[docRow];
                if (splits) {
                    column = splits[splitIndex];
                    if (splitIndex > 0 && splits.length) {
                        wrapIndent = splits.indent;
                        docColumn = splits[splitIndex - 1] || splits[splits.length - 1];
                        line = line.substring(docColumn);
                    }
                }
            }
            if (offsetX !== undefined && this.$bidiHandler.isBidiRow(row + splitIndex, docRow, splitIndex)) screenColumn = this.$bidiHandler.offsetToCol(offsetX);
            docColumn += this.$getStringScreenWidth(line, screenColumn - wrapIndent)[1];
            if (this.$useWrapMode && docColumn >= column) docColumn = column - 1;
            if (foldLine) return foldLine.idxToPosition(docColumn);
            return {
                row: docRow,
                column: docColumn
            };
        };
        EditSession.prototype.documentToScreenPosition = function(docRow, docColumn) {
            if (typeof docColumn === "undefined") var pos = this.$clipPositionToDocument(/**@type{Point}*/ docRow.row, /**@type{Point}*/ docRow.column);
            else pos = this.$clipPositionToDocument(/**@type{number}*/ docRow, docColumn);
            docRow = pos.row;
            docColumn = pos.column;
            var screenRow = 0;
            var foldStartRow = null;
            var fold = null;
            fold = this.getFoldAt(docRow, docColumn, 1);
            if (fold) {
                docRow = fold.start.row;
                docColumn = fold.start.column;
            }
            var rowEnd, row = 0;
            var rowCache = this.$docRowCache;
            var i = this.$getRowCacheIndex(rowCache, docRow);
            var l = rowCache.length;
            if (l && i >= 0) {
                var row = rowCache[i];
                var screenRow = this.$screenRowCache[i];
                var doCache = docRow > rowCache[l - 1];
            } else var doCache = !l;
            var foldLine = this.getNextFoldLine(row);
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            while(row < docRow){
                if (row >= foldStart) {
                    rowEnd = foldLine.end.row + 1;
                    if (rowEnd > docRow) break;
                    foldLine = this.getNextFoldLine(rowEnd, foldLine);
                    foldStart = foldLine ? foldLine.start.row : Infinity;
                } else rowEnd = row + 1;
                screenRow += this.getRowLength(row);
                row = rowEnd;
                if (doCache) {
                    this.$docRowCache.push(row);
                    this.$screenRowCache.push(screenRow);
                }
            }
            var textLine = "";
            if (foldLine && row >= foldStart) {
                textLine = this.getFoldDisplayLine(foldLine, docRow, docColumn);
                foldStartRow = foldLine.start.row;
            } else {
                textLine = this.getLine(docRow).substring(0, docColumn);
                foldStartRow = docRow;
            }
            var wrapIndent = 0;
            if (this.$useWrapMode) {
                var wrapRow = this.$wrapData[foldStartRow];
                if (wrapRow) {
                    var screenRowOffset = 0;
                    while(textLine.length >= wrapRow[screenRowOffset]){
                        screenRow++;
                        screenRowOffset++;
                    }
                    textLine = textLine.substring(wrapRow[screenRowOffset - 1] || 0, textLine.length);
                    wrapIndent = screenRowOffset > 0 ? wrapRow.indent : 0;
                }
            }
            if (this.lineWidgets && this.lineWidgets[row] && this.lineWidgets[row].rowsAbove) screenRow += this.lineWidgets[row].rowsAbove;
            return {
                row: screenRow,
                column: wrapIndent + this.$getStringScreenWidth(textLine)[0]
            };
        };
        EditSession.prototype.documentToScreenColumn = function(row, docColumn) {
            return this.documentToScreenPosition(row, docColumn).column;
        };
        EditSession.prototype.documentToScreenRow = function(docRow, docColumn) {
            return this.documentToScreenPosition(docRow, docColumn).row;
        };
        EditSession.prototype.getScreenLength = function() {
            var screenRows = 0;
            var fold = null;
            if (!this.$useWrapMode) {
                screenRows = this.getLength();
                var foldData = this.$foldData;
                for(var i = 0; i < foldData.length; i++){
                    fold = foldData[i];
                    screenRows -= fold.end.row - fold.start.row;
                }
            } else {
                var lastRow = this.$wrapData.length;
                var row = 0, i = 0;
                var fold = this.$foldData[i++];
                var foldStart = fold ? fold.start.row : Infinity;
                while(row < lastRow){
                    var splits = this.$wrapData[row];
                    screenRows += splits ? splits.length + 1 : 1;
                    row++;
                    if (row > foldStart) {
                        row = fold.end.row + 1;
                        fold = this.$foldData[i++];
                        foldStart = fold ? fold.start.row : Infinity;
                    }
                }
            }
            if (this.lineWidgets) screenRows += this.$getWidgetScreenLength();
            return screenRows;
        };
        EditSession.prototype.$setFontMetrics = function(fm) {
            if (!this.$enableVarChar) return;
            this.$getStringScreenWidth = function(str, maxScreenColumn, screenColumn) {
                if (maxScreenColumn === 0) return [
                    0,
                    0
                ];
                if (!maxScreenColumn) maxScreenColumn = Infinity;
                screenColumn = screenColumn || 0;
                var c, column;
                for(column = 0; column < str.length; column++){
                    c = str.charAt(column);
                    if (c === "	") screenColumn += this.getScreenTabSize(screenColumn);
                    else screenColumn += fm.getCharacterWidth(c);
                    if (screenColumn > maxScreenColumn) break;
                }
                return [
                    screenColumn,
                    column
                ];
            };
        };
        EditSession.prototype.getPrecedingCharacter = function() {
            var pos = this.selection.getCursor();
            if (pos.column === 0) return pos.row === 0 ? "" : this.doc.getNewLineCharacter();
            var currentLine = this.getLine(pos.row);
            return currentLine[pos.column - 1];
        };
        EditSession.prototype.destroy = function() {
            if (!this.destroyed) {
                this.bgTokenizer.setDocument(null);
                this.bgTokenizer.cleanup();
                this.destroyed = true;
            }
            this.$stopWorker();
            this.removeAllListeners();
            if (this.doc) this.doc.off("change", this.$onChange);
            this.selection.detach();
        };
        return EditSession;
    }();
    EditSession.$uid = 0;
    EditSession.prototype.$modes = config.$modes;
    EditSession.prototype.getValue = EditSession.prototype.toString;
    EditSession.prototype.$defaultUndoManager = {
        undo: function() {},
        redo: function() {},
        hasUndo: function() {},
        hasRedo: function() {},
        reset: function() {},
        add: function() {},
        addSelection: function() {},
        startNewGroup: function() {},
        addSession: function() {}
    };
    EditSession.prototype.$overwrite = false;
    EditSession.prototype.$mode = null;
    EditSession.prototype.$modeId = null;
    EditSession.prototype.$scrollTop = 0;
    EditSession.prototype.$scrollLeft = 0;
    EditSession.prototype.$wrapLimit = 80;
    EditSession.prototype.$useWrapMode = false;
    EditSession.prototype.$wrapLimitRange = {
        min: null,
        max: null
    };
    EditSession.prototype.lineWidgets = null;
    EditSession.prototype.isFullWidth = isFullWidth;
    oop.implement(EditSession.prototype, EventEmitter);
    var CHAR = 1, CHAR_EXT = 2, PLACEHOLDER_START = 3, PLACEHOLDER_BODY = 4, PUNCTUATION = 9, SPACE = 10, TAB = 11, TAB_SPACE = 12;
    function isFullWidth(c) {
        if (c < 0x1100) return false;
        return c >= 0x1100 && c <= 0x115F || c >= 0x11A3 && c <= 0x11A7 || c >= 0x11FA && c <= 0x11FF || c >= 0x2329 && c <= 0x232A || c >= 0x2E80 && c <= 0x2E99 || c >= 0x2E9B && c <= 0x2EF3 || c >= 0x2F00 && c <= 0x2FD5 || c >= 0x2FF0 && c <= 0x2FFB || c >= 0x3000 && c <= 0x303E || c >= 0x3041 && c <= 0x3096 || c >= 0x3099 && c <= 0x30FF || c >= 0x3105 && c <= 0x312D || c >= 0x3131 && c <= 0x318E || c >= 0x3190 && c <= 0x31BA || c >= 0x31C0 && c <= 0x31E3 || c >= 0x31F0 && c <= 0x321E || c >= 0x3220 && c <= 0x3247 || c >= 0x3250 && c <= 0x32FE || c >= 0x3300 && c <= 0x4DBF || c >= 0x4E00 && c <= 0xA48C || c >= 0xA490 && c <= 0xA4C6 || c >= 0xA960 && c <= 0xA97C || c >= 0xAC00 && c <= 0xD7A3 || c >= 0xD7B0 && c <= 0xD7C6 || c >= 0xD7CB && c <= 0xD7FB || c >= 0xF900 && c <= 0xFAFF || c >= 0xFE10 && c <= 0xFE19 || c >= 0xFE30 && c <= 0xFE52 || c >= 0xFE54 && c <= 0xFE66 || c >= 0xFE68 && c <= 0xFE6B || c >= 0xFF01 && c <= 0xFF60 || c >= 0xFFE0 && c <= 0xFFE6;
    }
    require("./edit_session/folding").Folding.call(EditSession.prototype);
    require("./edit_session/bracket_match").BracketMatch.call(EditSession.prototype);
    config.defineOptions(EditSession.prototype, "session", {
        wrap: {
            set: function(value) {
                if (!value || value == "off") value = false;
                else if (value == "free") value = true;
                else if (value == "printMargin") value = -1;
                else if (typeof value == "string") value = parseInt(value, 10) || false;
                if (this.$wrap == value) return;
                this.$wrap = value;
                if (!value) this.setUseWrapMode(false);
                else {
                    var col = typeof value == "number" ? value : null;
                    this.setWrapLimitRange(col, col);
                    this.setUseWrapMode(true);
                }
            },
            get: function() {
                if (this.getUseWrapMode()) {
                    if (this.$wrap == -1) return "printMargin";
                    if (!this.getWrapLimitRange().min) return "free";
                    return this.$wrap;
                }
                return "off";
            },
            handlesSet: true
        },
        wrapMethod: {
            set: function(val) {
                val = val == "auto" ? this.$mode.type != "text" : val != "text";
                if (val != this.$wrapAsCode) {
                    this.$wrapAsCode = val;
                    if (this.$useWrapMode) {
                        this.$useWrapMode = false;
                        this.setUseWrapMode(true);
                    }
                }
            },
            initialValue: "auto"
        },
        indentedSoftWrap: {
            set: function() {
                if (this.$useWrapMode) {
                    this.$useWrapMode = false;
                    this.setUseWrapMode(true);
                }
            },
            initialValue: true
        },
        firstLineNumber: {
            set: function() {
                this._signal("changeBreakpoint");
            },
            initialValue: 1
        },
        useWorker: {
            set: function(useWorker) {
                this.$useWorker = useWorker;
                this.$stopWorker();
                if (useWorker) this.$startWorker();
            },
            initialValue: true
        },
        useSoftTabs: {
            initialValue: true
        },
        tabSize: {
            set: function(tabSize) {
                tabSize = parseInt(tabSize);
                if (tabSize > 0 && this.$tabSize !== tabSize) {
                    this.$modified = true;
                    this.$rowLengthCache = [];
                    this.$tabSize = tabSize;
                    this._signal("changeTabSize");
                }
            },
            initialValue: 4,
            handlesSet: true
        },
        navigateWithinSoftTabs: {
            initialValue: false
        },
        foldStyle: {
            set: function(val) {
                this.setFoldStyle(val);
            },
            handlesSet: true
        },
        overwrite: {
            set: function(val) {
                this._signal("changeOverwrite");
            },
            initialValue: false
        },
        newLineMode: {
            set: function(val) {
                this.doc.setNewLineMode(val);
            },
            get: function() {
                return this.doc.getNewLineMode();
            },
            handlesSet: true
        },
        mode: {
            set: function(val) {
                this.setMode(val);
            },
            get: function() {
                return this.$modeId;
            },
            handlesSet: true
        }
    });
    exports.EditSession = EditSession;
});
ace.define("ace/search", [
    "require",
    "exports",
    "module",
    "ace/lib/lang",
    "ace/lib/oop",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var lang = require("./lib/lang");
    var oop = require("./lib/oop");
    var Range = require("./range").Range;
    var Search = /** @class */ function() {
        function Search() {
            this.$options = {};
        }
        Search.prototype.set = function(options) {
            oop.mixin(this.$options, options);
            return this;
        };
        Search.prototype.getOptions = function() {
            return lang.copyObject(this.$options);
        };
        Search.prototype.setOptions = function(options) {
            this.$options = options;
        };
        Search.prototype.find = function(session) {
            var options = this.$options;
            var iterator = this.$matchIterator(session, options);
            if (!iterator) return false;
            var firstRange = null;
            iterator.forEach(function(sr, sc, er, ec) {
                firstRange = new Range(sr, sc, er, ec);
                if (sc == ec && options.start && /**@type{Range}*/ options.start.start && options.skipCurrent != false && firstRange.isEqual(/**@type{Range}*/ options.start)) {
                    firstRange = null;
                    return false;
                }
                return true;
            });
            return firstRange;
        };
        Search.prototype.findAll = function(session) {
            var options = this.$options;
            if (!options.needle) return [];
            this.$assembleRegExp(options);
            var range = options.range;
            var lines = range ? session.getLines(range.start.row, range.end.row) : session.doc.getAllLines();
            var ranges = [];
            var re = options.re;
            if (options.$isMultiLine) {
                var len = re.length;
                var maxRow = lines.length - len;
                var prevRange;
                outer: for(var row = re.offset || 0; row <= maxRow; row++){
                    for(var j = 0; j < len; j++)if (lines[row + j].search(re[j]) == -1) continue outer;
                    var startLine = lines[row];
                    var line = lines[row + len - 1];
                    var startIndex = startLine.length - startLine.match(re[0])[0].length;
                    var endIndex = line.match(re[len - 1])[0].length;
                    if (prevRange && prevRange.end.row === row && prevRange.end.column > startIndex) continue;
                    ranges.push(prevRange = new Range(row, startIndex, row + len - 1, endIndex));
                    if (len > 2) row = row + len - 2;
                }
            } else for(var i = 0; i < lines.length; i++){
                var matches = lang.getMatchOffsets(lines[i], re);
                for(var j = 0; j < matches.length; j++){
                    var match = matches[j];
                    ranges.push(new Range(i, match.offset, i, match.offset + match.length));
                }
            }
            if (range) {
                var startColumn = range.start.column;
                var endColumn = range.end.column;
                var i = 0, j = ranges.length - 1;
                while(i < j && ranges[i].start.column < startColumn && ranges[i].start.row == 0)i++;
                var endRow = range.end.row - range.start.row;
                while(i < j && ranges[j].end.column > endColumn && ranges[j].end.row == endRow)j--;
                ranges = ranges.slice(i, j + 1);
                for(i = 0, j = ranges.length; i < j; i++){
                    ranges[i].start.row += range.start.row;
                    ranges[i].end.row += range.start.row;
                }
            }
            return ranges;
        };
        Search.prototype.replace = function(input, replacement) {
            var options = this.$options;
            var re = this.$assembleRegExp(options);
            if (options.$isMultiLine) return replacement;
            if (!re) return;
            var match = re.exec(input);
            if (!match || match[0].length != input.length) return null;
            if (!options.regExp) replacement = replacement.replace(/\$/g, "$$$$");
            replacement = input.replace(re, replacement);
            if (options.preserveCase) {
                replacement = replacement.split("");
                for(var i = Math.min(input.length, input.length); i--;){
                    var ch = input[i];
                    if (ch && ch.toLowerCase() != ch) replacement[i] = replacement[i].toUpperCase();
                    else replacement[i] = replacement[i].toLowerCase();
                }
                replacement = replacement.join("");
            }
            return replacement;
        };
        Search.prototype.$assembleRegExp = function(options, $disableFakeMultiline) {
            if (options.needle instanceof RegExp) return options.re = options.needle;
            var needle = options.needle;
            if (!options.needle) return options.re = false;
            if (!options.regExp) needle = lang.escapeRegExp(needle);
            var modifier = options.caseSensitive ? "gm" : "gmi";
            try {
                new RegExp(needle, "u");
                options.$supportsUnicodeFlag = true;
                modifier += "u";
            } catch (e) {
                options.$supportsUnicodeFlag = false; //left for backward compatibility with previous versions for cases like /ab\{2}/gu
            }
            if (options.wholeWord) needle = addWordBoundary(needle, options);
            options.$isMultiLine = !$disableFakeMultiline && /[\n\r]/.test(needle);
            if (options.$isMultiLine) return options.re = this.$assembleMultilineRegExp(needle, modifier);
            try {
                var re = new RegExp(needle, modifier);
            } catch (e) {
                re = false;
            }
            return options.re = re;
        };
        Search.prototype.$assembleMultilineRegExp = function(needle, modifier) {
            var parts = needle.replace(/\r\n|\r|\n/g, "$\n^").split("\n");
            var re = [];
            for(var i = 0; i < parts.length; i++)try {
                re.push(new RegExp(parts[i], modifier));
            } catch (e) {
                return false;
            }
            return re;
        };
        Search.prototype.$matchIterator = function(session, options) {
            var re = this.$assembleRegExp(options);
            if (!re) return false;
            var backwards = options.backwards == true;
            var skipCurrent = options.skipCurrent != false;
            var supportsUnicodeFlag = re.unicode;
            var range = options.range;
            var start = options.start;
            if (!start) start = range ? range[backwards ? "end" : "start"] : session.selection.getRange();
            if (start.start) start = start[skipCurrent != backwards ? "end" : "start"];
            var firstRow = range ? range.start.row : 0;
            var lastRow = range ? range.end.row : session.getLength() - 1;
            if (backwards) var forEach = function(callback) {
                var row = start.row;
                if (forEachInLine(row, start.column, callback)) return;
                for(row--; row >= firstRow; row--)if (forEachInLine(row, Number.MAX_VALUE, callback)) return;
                if (options.wrap == false) return;
                for(row = lastRow, firstRow = start.row; row >= firstRow; row--)if (forEachInLine(row, Number.MAX_VALUE, callback)) return;
            };
            else var forEach = function(callback) {
                var row = start.row;
                if (forEachInLine(row, start.column, callback)) return;
                for(row = row + 1; row <= lastRow; row++)if (forEachInLine(row, 0, callback)) return;
                if (options.wrap == false) return;
                for(row = firstRow, lastRow = start.row; row <= lastRow; row++)if (forEachInLine(row, 0, callback)) return;
            };
            if (options.$isMultiLine) {
                var len = re.length;
                var forEachInLine = function(row, offset, callback) {
                    var startRow = backwards ? row - len + 1 : row;
                    if (startRow < 0 || startRow + len > session.getLength()) return;
                    var line = session.getLine(startRow);
                    var startIndex = line.search(re[0]);
                    if (!backwards && startIndex < offset || startIndex === -1) return;
                    for(var i = 1; i < len; i++){
                        line = session.getLine(startRow + i);
                        if (line.search(re[i]) == -1) return;
                    }
                    var endIndex = line.match(re[len - 1])[0].length;
                    if (backwards && endIndex > offset) return;
                    if (callback(startRow, startIndex, startRow + len - 1, endIndex)) return true;
                };
            } else if (backwards) var forEachInLine = function(row, endIndex, callback) {
                var line = session.getLine(row);
                var matches = [];
                var m, last = 0;
                re.lastIndex = 0;
                while(m = re.exec(line)){
                    var length = m[0].length;
                    last = m.index;
                    if (!length) {
                        if (last >= line.length) break;
                        re.lastIndex = last += lang.skipEmptyMatch(line, last, supportsUnicodeFlag);
                    }
                    if (m.index + length > endIndex) break;
                    matches.push(m.index, length);
                }
                for(var i = matches.length - 1; i >= 0; i -= 2){
                    var column = matches[i - 1];
                    var length = matches[i];
                    if (callback(row, column, row, column + length)) return true;
                }
            };
            else var forEachInLine = function(row, startIndex, callback) {
                var line = session.getLine(row);
                var last;
                var m;
                re.lastIndex = startIndex;
                while(m = re.exec(line)){
                    var length = m[0].length;
                    last = m.index;
                    if (callback(row, last, row, last + length)) return true;
                    if (!length) {
                        re.lastIndex = last += lang.skipEmptyMatch(line, last, supportsUnicodeFlag);
                        if (last >= line.length) return false;
                    }
                }
            };
            return {
                forEach: forEach
            };
        };
        return Search;
    }();
    function addWordBoundary(needle, options) {
        var supportsLookbehind = lang.supportsLookbehind();
        function wordBoundary(c, firstChar) {
            if (firstChar === void 0) firstChar = true;
            var wordRegExp = supportsLookbehind && options.$supportsUnicodeFlag ? new RegExp("[\\p{L}\\p{N}_]", "u") : new RegExp("\\w");
            if (wordRegExp.test(c) || options.regExp) {
                if (supportsLookbehind && options.$supportsUnicodeFlag) {
                    if (firstChar) return "(?<=^|[^\\p{L}\\p{N}_])";
                    return "(?=[^\\p{L}\\p{N}_]|$)";
                }
                return "\\b";
            }
            return "";
        }
        var needleArray = Array.from(needle);
        var firstChar = needleArray[0];
        var lastChar = needleArray[needleArray.length - 1];
        return wordBoundary(firstChar) + needle + wordBoundary(lastChar, false);
    }
    exports.Search = Search;
});
ace.define("ace/keyboard/hash_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/keys",
    "ace/lib/useragent"
], function(require, exports, module1) {
    "use strict";
    var __extends = this && this.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var keyUtil = require("../lib/keys");
    var useragent = require("../lib/useragent");
    var KEY_MODS = keyUtil.KEY_MODS;
    var MultiHashHandler = /** @class */ function() {
        function MultiHashHandler(config, platform) {
            this.$init(config, platform, false);
        }
        MultiHashHandler.prototype.$init = function(config, platform, $singleCommand) {
            this.platform = platform || (useragent.isMac ? "mac" : "win");
            this.commands = {};
            this.commandKeyBinding = {};
            this.addCommands(config);
            this.$singleCommand = $singleCommand;
        };
        MultiHashHandler.prototype.addCommand = function(command) {
            if (this.commands[command.name]) this.removeCommand(command);
            this.commands[command.name] = command;
            if (command.bindKey) this._buildKeyHash(command);
        };
        MultiHashHandler.prototype.removeCommand = function(command, keepCommand) {
            var name = command && (typeof command === "string" ? command : command.name);
            command = this.commands[name];
            if (!keepCommand) delete this.commands[name];
            var ckb = this.commandKeyBinding;
            for(var keyId in ckb){
                var cmdGroup = ckb[keyId];
                if (cmdGroup == command) delete ckb[keyId];
                else if (Array.isArray(cmdGroup)) {
                    var i = cmdGroup.indexOf(command);
                    if (i != -1) {
                        cmdGroup.splice(i, 1);
                        if (cmdGroup.length == 1) ckb[keyId] = cmdGroup[0];
                    }
                }
            }
        };
        MultiHashHandler.prototype.bindKey = function(key, command, position) {
            if (typeof key == "object" && key) {
                if (position == undefined) position = key.position;
                key = key[this.platform];
            }
            if (!key) return;
            if (typeof command == "function") return this.addCommand({
                exec: command,
                bindKey: key,
                name: command.name || /**@type{string}*/ key
            });
            key.split("|").forEach(function(keyPart) {
                var chain = "";
                if (keyPart.indexOf(" ") != -1) {
                    var parts = keyPart.split(/\s+/);
                    keyPart = parts.pop();
                    parts.forEach(function(keyPart) {
                        var binding = this.parseKeys(keyPart);
                        var id = KEY_MODS[binding.hashId] + binding.key;
                        chain += (chain ? " " : "") + id;
                        this._addCommandToBinding(chain, "chainKeys");
                    }, this);
                    chain += " ";
                }
                var binding = this.parseKeys(keyPart);
                var id = KEY_MODS[binding.hashId] + binding.key;
                this._addCommandToBinding(chain + id, command, position);
            }, this);
        };
        MultiHashHandler.prototype._addCommandToBinding = function(keyId, command, position) {
            var ckb = this.commandKeyBinding, i;
            if (!command) delete ckb[keyId];
            else if (!ckb[keyId] || this.$singleCommand) ckb[keyId] = command;
            else {
                if (!Array.isArray(ckb[keyId])) ckb[keyId] = [
                    ckb[keyId]
                ];
                else if ((i = ckb[keyId].indexOf(command)) != -1) ckb[keyId].splice(i, 1);
                if (typeof position != "number") position = getPosition(command);
                var commands = ckb[keyId];
                for(i = 0; i < commands.length; i++){
                    var other = commands[i];
                    var otherPos = getPosition(other);
                    if (otherPos > position) break;
                }
                commands.splice(i, 0, command);
            }
        };
        MultiHashHandler.prototype.addCommands = function(commands) {
            commands && Object.keys(commands).forEach(function(name) {
                var command = commands[name];
                if (!command) return;
                if (typeof command === "string") return this.bindKey(command, name);
                if (typeof command === "function") command = {
                    exec: command
                };
                if (typeof command !== "object") return;
                if (!command.name) command.name = name;
                this.addCommand(command);
            }, this);
        };
        MultiHashHandler.prototype.removeCommands = function(commands) {
            Object.keys(commands).forEach(function(name) {
                this.removeCommand(commands[name]);
            }, this);
        };
        MultiHashHandler.prototype.bindKeys = function(keyList) {
            Object.keys(keyList).forEach(function(key) {
                this.bindKey(key, keyList[key]);
            }, this);
        };
        MultiHashHandler.prototype._buildKeyHash = function(command) {
            this.bindKey(command.bindKey, command);
        };
        MultiHashHandler.prototype.parseKeys = function(keys) {
            var parts = keys.toLowerCase().split(/[\-\+]([\-\+])?/).filter(function(x) {
                return x;
            });
            var key = parts.pop();
            var keyCode = keyUtil[key];
            if (keyUtil.FUNCTION_KEYS[keyCode]) key = keyUtil.FUNCTION_KEYS[keyCode].toLowerCase();
            else if (!parts.length) return {
                key: key,
                hashId: -1
            };
            else if (parts.length == 1 && parts[0] == "shift") return {
                key: key.toUpperCase(),
                hashId: -1
            };
            var hashId = 0;
            for(var i = parts.length; i--;){
                var modifier = keyUtil.KEY_MODS[parts[i]];
                if (modifier == null) {
                    if (typeof console != "undefined") console.error("invalid modifier " + parts[i] + " in " + keys);
                    return false;
                }
                hashId |= modifier;
            }
            return {
                key: key,
                hashId: hashId
            };
        };
        MultiHashHandler.prototype.findKeyCommand = function(hashId, keyString) {
            var key = KEY_MODS[hashId] + keyString;
            return this.commandKeyBinding[key];
        };
        MultiHashHandler.prototype.handleKeyboard = function(data, hashId, keyString, keyCode) {
            if (keyCode < 0) return;
            var key = KEY_MODS[hashId] + keyString;
            var command = this.commandKeyBinding[key];
            if (data.$keyChain) {
                data.$keyChain += " " + key;
                command = this.commandKeyBinding[data.$keyChain] || command;
            }
            if (command) {
                if (command == "chainKeys" || command[command.length - 1] == "chainKeys") {
                    data.$keyChain = data.$keyChain || key;
                    return {
                        command: "null"
                    };
                }
            }
            if (data.$keyChain) {
                if ((!hashId || hashId == 4) && keyString.length == 1) data.$keyChain = data.$keyChain.slice(0, -key.length - 1); // wait for input
                else if (hashId == -1 || keyCode > 0) data.$keyChain = ""; // reset keyChain
            }
            return {
                command: command
            };
        };
        MultiHashHandler.prototype.getStatusText = function(editor, data) {
            return data.$keyChain || "";
        };
        return MultiHashHandler;
    }();
    function getPosition(command) {
        return typeof command == "object" && command.bindKey && command.bindKey.position || (command.isDefault ? -100 : 0);
    }
    var HashHandler = /** @class */ function(_super) {
        __extends(HashHandler, _super);
        function HashHandler(config, platform) {
            var _this = _super.call(this, config, platform) || this;
            _this.$singleCommand = true;
            return _this;
        }
        return HashHandler;
    }(MultiHashHandler);
    HashHandler.call = function(thisArg, config, platform) {
        MultiHashHandler.prototype.$init.call(thisArg, config, platform, true);
    };
    MultiHashHandler.call = function(thisArg, config, platform) {
        MultiHashHandler.prototype.$init.call(thisArg, config, platform, false);
    };
    exports.HashHandler = HashHandler;
    exports.MultiHashHandler = MultiHashHandler;
});
ace.define("ace/commands/command_manager", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/keyboard/hash_handler",
    "ace/lib/event_emitter"
], function(require, exports, module1) {
    "use strict";
    var __extends = this && this.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var oop = require("../lib/oop");
    var MultiHashHandler = require("../keyboard/hash_handler").MultiHashHandler;
    var EventEmitter = require("../lib/event_emitter").EventEmitter;
    var CommandManager = /** @class */ function(_super) {
        __extends(CommandManager, _super);
        function CommandManager(platform, commands) {
            var _this = _super.call(this, commands, platform) || this;
            _this.byName = _this.commands;
            _this.setDefaultHandler("exec", function(e) {
                if (!e.args) return e.command.exec(e.editor, {}, e.event, true);
                return e.command.exec(e.editor, e.args, e.event, false);
            });
            return _this;
        }
        CommandManager.prototype.exec = function(command, editor, args) {
            if (Array.isArray(command)) {
                for(var i = command.length; i--;){
                    if (this.exec(command[i], editor, args)) return true;
                }
                return false;
            }
            if (typeof command === "string") command = this.commands[command];
            if (!this.canExecute(command, editor)) return false;
            var e = {
                editor: editor,
                command: command,
                args: args
            };
            e.returnValue = this._emit("exec", e);
            this._signal("afterExec", e);
            return e.returnValue === false ? false : true;
        };
        CommandManager.prototype.canExecute = function(command, editor) {
            if (typeof command === "string") command = this.commands[command];
            if (!command) return false;
            if (editor && editor.$readOnly && !command.readOnly) return false;
            if (this.$checkCommandState != false && command.isAvailable && !command.isAvailable(editor)) return false;
            return true;
        };
        CommandManager.prototype.toggleRecording = function(editor) {
            if (this.$inReplay) return;
            editor && editor._emit("changeStatus");
            if (this.recording) {
                this.macro.pop();
                this.off("exec", this.$addCommandToMacro);
                if (!this.macro.length) this.macro = this.oldMacro;
                return this.recording = false;
            }
            if (!this.$addCommandToMacro) this.$addCommandToMacro = (function(e) {
                this.macro.push([
                    e.command,
                    e.args
                ]);
            }).bind(this);
            this.oldMacro = this.macro;
            this.macro = [];
            this.on("exec", this.$addCommandToMacro);
            return this.recording = true;
        };
        CommandManager.prototype.replay = function(editor) {
            if (this.$inReplay || !this.macro) return;
            if (this.recording) return this.toggleRecording(editor);
            try {
                this.$inReplay = true;
                this.macro.forEach(function(x) {
                    if (typeof x == "string") this.exec(x, editor);
                    else this.exec(x[0], editor, x[1]);
                }, this);
            } finally{
                this.$inReplay = false;
            }
        };
        CommandManager.prototype.trimMacro = function(m) {
            return m.map(function(x) {
                if (typeof x[0] != "string") x[0] = x[0].name;
                if (!x[1]) x = x[0];
                return x;
            });
        };
        return CommandManager;
    }(MultiHashHandler);
    oop.implement(CommandManager.prototype, EventEmitter);
    exports.CommandManager = CommandManager;
});
ace.define("ace/commands/default_commands", [
    "require",
    "exports",
    "module",
    "ace/lib/lang",
    "ace/config",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var lang = require("../lib/lang");
    var config = require("../config");
    var Range = require("../range").Range;
    function bindKey(win, mac) {
        return {
            win: win,
            mac: mac
        };
    }
    exports.commands = [
        {
            name: "showSettingsMenu",
            description: "Show settings menu",
            bindKey: bindKey("Ctrl-,", "Command-,"),
            exec: function(editor) {
                config.loadModule("ace/ext/settings_menu", function(module1) {
                    module1.init(editor);
                    editor.showSettingsMenu();
                });
            },
            readOnly: true
        },
        {
            name: "goToNextError",
            description: "Go to next error",
            bindKey: bindKey("Alt-E", "F4"),
            exec: function(editor) {
                config.loadModule("ace/ext/error_marker", function(module1) {
                    module1.showErrorMarker(editor, 1);
                });
            },
            scrollIntoView: "animate",
            readOnly: true
        },
        {
            name: "goToPreviousError",
            description: "Go to previous error",
            bindKey: bindKey("Alt-Shift-E", "Shift-F4"),
            exec: function(editor) {
                config.loadModule("ace/ext/error_marker", function(module1) {
                    module1.showErrorMarker(editor, -1);
                });
            },
            scrollIntoView: "animate",
            readOnly: true
        },
        {
            name: "selectall",
            description: "Select all",
            bindKey: bindKey("Ctrl-A", "Command-A"),
            exec: function(editor) {
                editor.selectAll();
            },
            readOnly: true
        },
        {
            name: "centerselection",
            description: "Center selection",
            bindKey: bindKey(null, "Ctrl-L"),
            exec: function(editor) {
                editor.centerSelection();
            },
            readOnly: true
        },
        {
            name: "gotoline",
            description: "Go to line...",
            bindKey: bindKey("Ctrl-L", "Command-L"),
            exec: function(editor, line) {
                if (typeof line === "number" && !isNaN(line)) editor.gotoLine(line);
                editor.prompt({
                    $type: "gotoLine"
                });
            },
            readOnly: true
        },
        {
            name: "fold",
            bindKey: bindKey("Alt-L|Ctrl-F1", "Command-Alt-L|Command-F1"),
            exec: function(editor) {
                editor.session.toggleFold(false);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "unfold",
            bindKey: bindKey("Alt-Shift-L|Ctrl-Shift-F1", "Command-Alt-Shift-L|Command-Shift-F1"),
            exec: function(editor) {
                editor.session.toggleFold(true);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "toggleFoldWidget",
            description: "Toggle fold widget",
            bindKey: bindKey("F2", "F2"),
            exec: function(editor) {
                editor.session.toggleFoldWidget();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "toggleParentFoldWidget",
            description: "Toggle parent fold widget",
            bindKey: bindKey("Alt-F2", "Alt-F2"),
            exec: function(editor) {
                editor.session.toggleFoldWidget(true);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "foldall",
            description: "Fold all",
            bindKey: bindKey(null, "Ctrl-Command-Option-0"),
            exec: function(editor) {
                editor.session.foldAll();
            },
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "foldAllComments",
            description: "Fold all comments",
            bindKey: bindKey(null, "Ctrl-Command-Option-0"),
            exec: function(editor) {
                editor.session.foldAllComments();
            },
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "foldOther",
            description: "Fold other",
            bindKey: bindKey("Alt-0", "Command-Option-0"),
            exec: function(editor) {
                editor.session.foldAll();
                editor.session.unfold(editor.selection.getAllRanges());
            },
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "unfoldall",
            description: "Unfold all",
            bindKey: bindKey("Alt-Shift-0", "Command-Option-Shift-0"),
            exec: function(editor) {
                editor.session.unfold();
            },
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "findnext",
            description: "Find next",
            bindKey: bindKey("Ctrl-K", "Command-G"),
            exec: function(editor) {
                editor.findNext();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "findprevious",
            description: "Find previous",
            bindKey: bindKey("Ctrl-Shift-K", "Command-Shift-G"),
            exec: function(editor) {
                editor.findPrevious();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "selectOrFindNext",
            description: "Select or find next",
            bindKey: bindKey("Alt-K", "Ctrl-G"),
            exec: function(editor) {
                if (editor.selection.isEmpty()) editor.selection.selectWord();
                else editor.findNext();
            },
            readOnly: true
        },
        {
            name: "selectOrFindPrevious",
            description: "Select or find previous",
            bindKey: bindKey("Alt-Shift-K", "Ctrl-Shift-G"),
            exec: function(editor) {
                if (editor.selection.isEmpty()) editor.selection.selectWord();
                else editor.findPrevious();
            },
            readOnly: true
        },
        {
            name: "find",
            description: "Find",
            bindKey: bindKey("Ctrl-F", "Command-F"),
            exec: function(editor) {
                config.loadModule("ace/ext/searchbox", function(e) {
                    e.Search(editor);
                });
            },
            readOnly: true
        },
        {
            name: "overwrite",
            description: "Overwrite",
            bindKey: "Insert",
            exec: function(editor) {
                editor.toggleOverwrite();
            },
            readOnly: true
        },
        {
            name: "selecttostart",
            description: "Select to start",
            bindKey: bindKey("Ctrl-Shift-Home", "Command-Shift-Home|Command-Shift-Up"),
            exec: function(editor) {
                editor.getSelection().selectFileStart();
            },
            multiSelectAction: "forEach",
            readOnly: true,
            scrollIntoView: "animate",
            aceCommandGroup: "fileJump"
        },
        {
            name: "gotostart",
            description: "Go to start",
            bindKey: bindKey("Ctrl-Home", "Command-Home|Command-Up"),
            exec: function(editor) {
                editor.navigateFileStart();
            },
            multiSelectAction: "forEach",
            readOnly: true,
            scrollIntoView: "animate",
            aceCommandGroup: "fileJump"
        },
        {
            name: "selectup",
            description: "Select up",
            bindKey: bindKey("Shift-Up", "Shift-Up|Ctrl-Shift-P"),
            exec: function(editor) {
                editor.getSelection().selectUp();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "golineup",
            description: "Go line up",
            bindKey: bindKey("Up", "Up|Ctrl-P"),
            exec: function(editor, args) {
                editor.navigateUp(args.times);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selecttoend",
            description: "Select to end",
            bindKey: bindKey("Ctrl-Shift-End", "Command-Shift-End|Command-Shift-Down"),
            exec: function(editor) {
                editor.getSelection().selectFileEnd();
            },
            multiSelectAction: "forEach",
            readOnly: true,
            scrollIntoView: "animate",
            aceCommandGroup: "fileJump"
        },
        {
            name: "gotoend",
            description: "Go to end",
            bindKey: bindKey("Ctrl-End", "Command-End|Command-Down"),
            exec: function(editor) {
                editor.navigateFileEnd();
            },
            multiSelectAction: "forEach",
            readOnly: true,
            scrollIntoView: "animate",
            aceCommandGroup: "fileJump"
        },
        {
            name: "selectdown",
            description: "Select down",
            bindKey: bindKey("Shift-Down", "Shift-Down|Ctrl-Shift-N"),
            exec: function(editor) {
                editor.getSelection().selectDown();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "golinedown",
            description: "Go line down",
            bindKey: bindKey("Down", "Down|Ctrl-N"),
            exec: function(editor, args) {
                editor.navigateDown(args.times);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectwordleft",
            description: "Select word left",
            bindKey: bindKey("Ctrl-Shift-Left", "Option-Shift-Left"),
            exec: function(editor) {
                editor.getSelection().selectWordLeft();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotowordleft",
            description: "Go to word left",
            bindKey: bindKey("Ctrl-Left", "Option-Left"),
            exec: function(editor) {
                editor.navigateWordLeft();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selecttolinestart",
            description: "Select to line start",
            bindKey: bindKey("Alt-Shift-Left", "Command-Shift-Left|Ctrl-Shift-A"),
            exec: function(editor) {
                editor.getSelection().selectLineStart();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotolinestart",
            description: "Go to line start",
            bindKey: bindKey("Alt-Left|Home", "Command-Left|Home|Ctrl-A"),
            exec: function(editor) {
                editor.navigateLineStart();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectleft",
            description: "Select left",
            bindKey: bindKey("Shift-Left", "Shift-Left|Ctrl-Shift-B"),
            exec: function(editor) {
                editor.getSelection().selectLeft();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotoleft",
            description: "Go to left",
            bindKey: bindKey("Left", "Left|Ctrl-B"),
            exec: function(editor, args) {
                editor.navigateLeft(args.times);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectwordright",
            description: "Select word right",
            bindKey: bindKey("Ctrl-Shift-Right", "Option-Shift-Right"),
            exec: function(editor) {
                editor.getSelection().selectWordRight();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotowordright",
            description: "Go to word right",
            bindKey: bindKey("Ctrl-Right", "Option-Right"),
            exec: function(editor) {
                editor.navigateWordRight();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selecttolineend",
            description: "Select to line end",
            bindKey: bindKey("Alt-Shift-Right", "Command-Shift-Right|Shift-End|Ctrl-Shift-E"),
            exec: function(editor) {
                editor.getSelection().selectLineEnd();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotolineend",
            description: "Go to line end",
            bindKey: bindKey("Alt-Right|End", "Command-Right|End|Ctrl-E"),
            exec: function(editor) {
                editor.navigateLineEnd();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectright",
            description: "Select right",
            bindKey: bindKey("Shift-Right", "Shift-Right"),
            exec: function(editor) {
                editor.getSelection().selectRight();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotoright",
            description: "Go to right",
            bindKey: bindKey("Right", "Right|Ctrl-F"),
            exec: function(editor, args) {
                editor.navigateRight(args.times);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectpagedown",
            description: "Select page down",
            bindKey: "Shift-PageDown",
            exec: function(editor) {
                editor.selectPageDown();
            },
            readOnly: true
        },
        {
            name: "pagedown",
            description: "Page down",
            bindKey: bindKey(null, "Option-PageDown"),
            exec: function(editor) {
                editor.scrollPageDown();
            },
            readOnly: true
        },
        {
            name: "gotopagedown",
            description: "Go to page down",
            bindKey: bindKey("PageDown", "PageDown|Ctrl-V"),
            exec: function(editor) {
                editor.gotoPageDown();
            },
            readOnly: true
        },
        {
            name: "selectpageup",
            description: "Select page up",
            bindKey: "Shift-PageUp",
            exec: function(editor) {
                editor.selectPageUp();
            },
            readOnly: true
        },
        {
            name: "pageup",
            description: "Page up",
            bindKey: bindKey(null, "Option-PageUp"),
            exec: function(editor) {
                editor.scrollPageUp();
            },
            readOnly: true
        },
        {
            name: "gotopageup",
            description: "Go to page up",
            bindKey: "PageUp",
            exec: function(editor) {
                editor.gotoPageUp();
            },
            readOnly: true
        },
        {
            name: "scrollup",
            description: "Scroll up",
            bindKey: bindKey("Ctrl-Up", null),
            exec: function(e) {
                e.renderer.scrollBy(0, -2 * e.renderer.layerConfig.lineHeight);
            },
            readOnly: true
        },
        {
            name: "scrolldown",
            description: "Scroll down",
            bindKey: bindKey("Ctrl-Down", null),
            exec: function(e) {
                e.renderer.scrollBy(0, 2 * e.renderer.layerConfig.lineHeight);
            },
            readOnly: true
        },
        {
            name: "selectlinestart",
            description: "Select line start",
            bindKey: "Shift-Home",
            exec: function(editor) {
                editor.getSelection().selectLineStart();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectlineend",
            description: "Select line end",
            bindKey: "Shift-End",
            exec: function(editor) {
                editor.getSelection().selectLineEnd();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "togglerecording",
            description: "Toggle recording",
            bindKey: bindKey("Ctrl-Alt-E", "Command-Option-E"),
            exec: function(editor) {
                editor.commands.toggleRecording(editor);
            },
            readOnly: true
        },
        {
            name: "replaymacro",
            description: "Replay macro",
            bindKey: bindKey("Ctrl-Shift-E", "Command-Shift-E"),
            exec: function(editor) {
                editor.commands.replay(editor);
            },
            readOnly: true
        },
        {
            name: "jumptomatching",
            description: "Jump to matching",
            bindKey: bindKey("Ctrl-\\|Ctrl-P", "Command-\\"),
            exec: function(editor) {
                editor.jumpToMatching();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "animate",
            readOnly: true
        },
        {
            name: "selecttomatching",
            description: "Select to matching",
            bindKey: bindKey("Ctrl-Shift-\\|Ctrl-Shift-P", "Command-Shift-\\"),
            exec: function(editor) {
                editor.jumpToMatching(true);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "animate",
            readOnly: true
        },
        {
            name: "expandToMatching",
            description: "Expand to matching",
            bindKey: bindKey("Ctrl-Shift-M", "Ctrl-Shift-M"),
            exec: function(editor) {
                editor.jumpToMatching(true, true);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "animate",
            readOnly: true
        },
        {
            name: "passKeysToBrowser",
            description: "Pass keys to browser",
            bindKey: bindKey(null, null),
            exec: function() {},
            passEvent: true,
            readOnly: true
        },
        {
            name: "copy",
            description: "Copy",
            exec: function(editor) {},
            readOnly: true
        },
        {
            name: "cut",
            description: "Cut",
            exec: function(editor) {
                var cutLine = editor.$copyWithEmptySelection && editor.selection.isEmpty();
                var range = cutLine ? editor.selection.getLineRange() : editor.selection.getRange();
                editor._emit("cut", range);
                if (!range.isEmpty()) editor.session.remove(range);
                editor.clearSelection();
            },
            scrollIntoView: "cursor",
            multiSelectAction: "forEach"
        },
        {
            name: "paste",
            description: "Paste",
            exec: function(editor, args) {
                editor.$handlePaste(args);
            },
            scrollIntoView: "cursor"
        },
        {
            name: "removeline",
            description: "Remove line",
            bindKey: bindKey("Ctrl-D", "Command-D"),
            exec: function(editor) {
                editor.removeLines();
            },
            scrollIntoView: "cursor",
            multiSelectAction: "forEachLine"
        },
        {
            name: "duplicateSelection",
            description: "Duplicate selection",
            bindKey: bindKey("Ctrl-Shift-D", "Command-Shift-D"),
            exec: function(editor) {
                editor.duplicateSelection();
            },
            scrollIntoView: "cursor",
            multiSelectAction: "forEach"
        },
        {
            name: "sortlines",
            description: "Sort lines",
            bindKey: bindKey("Ctrl-Alt-S", "Command-Alt-S"),
            exec: function(editor) {
                editor.sortLines();
            },
            scrollIntoView: "selection",
            multiSelectAction: "forEachLine"
        },
        {
            name: "togglecomment",
            description: "Toggle comment",
            bindKey: bindKey("Ctrl-/", "Command-/"),
            exec: function(editor) {
                editor.toggleCommentLines();
            },
            multiSelectAction: "forEachLine",
            scrollIntoView: "selectionPart"
        },
        {
            name: "toggleBlockComment",
            description: "Toggle block comment",
            bindKey: bindKey("Ctrl-Shift-/", "Command-Shift-/"),
            exec: function(editor) {
                editor.toggleBlockComment();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "selectionPart"
        },
        {
            name: "modifyNumberUp",
            description: "Modify number up",
            bindKey: bindKey("Ctrl-Shift-Up", "Alt-Shift-Up"),
            exec: function(editor) {
                editor.modifyNumber(1);
            },
            scrollIntoView: "cursor",
            multiSelectAction: "forEach"
        },
        {
            name: "modifyNumberDown",
            description: "Modify number down",
            bindKey: bindKey("Ctrl-Shift-Down", "Alt-Shift-Down"),
            exec: function(editor) {
                editor.modifyNumber(-1);
            },
            scrollIntoView: "cursor",
            multiSelectAction: "forEach"
        },
        {
            name: "replace",
            description: "Replace",
            bindKey: bindKey("Ctrl-H", "Command-Option-F"),
            exec: function(editor) {
                config.loadModule("ace/ext/searchbox", function(e) {
                    e.Search(editor, true);
                });
            }
        },
        {
            name: "undo",
            description: "Undo",
            bindKey: bindKey("Ctrl-Z", "Command-Z"),
            exec: function(editor) {
                editor.undo();
            }
        },
        {
            name: "redo",
            description: "Redo",
            bindKey: bindKey("Ctrl-Shift-Z|Ctrl-Y", "Command-Shift-Z|Command-Y"),
            exec: function(editor) {
                editor.redo();
            }
        },
        {
            name: "copylinesup",
            description: "Copy lines up",
            bindKey: bindKey("Alt-Shift-Up", "Command-Option-Up"),
            exec: function(editor) {
                editor.copyLinesUp();
            },
            scrollIntoView: "cursor"
        },
        {
            name: "movelinesup",
            description: "Move lines up",
            bindKey: bindKey("Alt-Up", "Option-Up"),
            exec: function(editor) {
                editor.moveLinesUp();
            },
            scrollIntoView: "cursor"
        },
        {
            name: "copylinesdown",
            description: "Copy lines down",
            bindKey: bindKey("Alt-Shift-Down", "Command-Option-Down"),
            exec: function(editor) {
                editor.copyLinesDown();
            },
            scrollIntoView: "cursor"
        },
        {
            name: "movelinesdown",
            description: "Move lines down",
            bindKey: bindKey("Alt-Down", "Option-Down"),
            exec: function(editor) {
                editor.moveLinesDown();
            },
            scrollIntoView: "cursor"
        },
        {
            name: "del",
            description: "Delete",
            bindKey: bindKey("Delete", "Delete|Ctrl-D|Shift-Delete"),
            exec: function(editor) {
                editor.remove("right");
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "backspace",
            description: "Backspace",
            bindKey: bindKey("Shift-Backspace|Backspace", "Ctrl-Backspace|Shift-Backspace|Backspace|Ctrl-H"),
            exec: function(editor) {
                editor.remove("left");
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "cut_or_delete",
            description: "Cut or delete",
            bindKey: bindKey("Shift-Delete", null),
            exec: function(editor) {
                if (editor.selection.isEmpty()) editor.remove("left");
                else return false;
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removetolinestart",
            description: "Remove to line start",
            bindKey: bindKey("Alt-Backspace", "Command-Backspace"),
            exec: function(editor) {
                editor.removeToLineStart();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removetolineend",
            description: "Remove to line end",
            bindKey: bindKey("Alt-Delete", "Ctrl-K|Command-Delete"),
            exec: function(editor) {
                editor.removeToLineEnd();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removetolinestarthard",
            description: "Remove to line start hard",
            bindKey: bindKey("Ctrl-Shift-Backspace", null),
            exec: function(editor) {
                var range = editor.selection.getRange();
                range.start.column = 0;
                editor.session.remove(range);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removetolineendhard",
            description: "Remove to line end hard",
            bindKey: bindKey("Ctrl-Shift-Delete", null),
            exec: function(editor) {
                var range = editor.selection.getRange();
                range.end.column = Number.MAX_VALUE;
                editor.session.remove(range);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removewordleft",
            description: "Remove word left",
            bindKey: bindKey("Ctrl-Backspace", "Alt-Backspace|Ctrl-Alt-Backspace"),
            exec: function(editor) {
                editor.removeWordLeft();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removewordright",
            description: "Remove word right",
            bindKey: bindKey("Ctrl-Delete", "Alt-Delete"),
            exec: function(editor) {
                editor.removeWordRight();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "outdent",
            description: "Outdent",
            bindKey: bindKey("Shift-Tab", "Shift-Tab"),
            exec: function(editor) {
                editor.blockOutdent();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "selectionPart"
        },
        {
            name: "indent",
            description: "Indent",
            bindKey: bindKey("Tab", "Tab"),
            exec: function(editor) {
                editor.indent();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "selectionPart"
        },
        {
            name: "blockoutdent",
            description: "Block outdent",
            bindKey: bindKey("Ctrl-[", "Ctrl-["),
            exec: function(editor) {
                editor.blockOutdent();
            },
            multiSelectAction: "forEachLine",
            scrollIntoView: "selectionPart"
        },
        {
            name: "blockindent",
            description: "Block indent",
            bindKey: bindKey("Ctrl-]", "Ctrl-]"),
            exec: function(editor) {
                editor.blockIndent();
            },
            multiSelectAction: "forEachLine",
            scrollIntoView: "selectionPart"
        },
        {
            name: "insertstring",
            description: "Insert string",
            exec: function(editor, str) {
                editor.insert(str);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "inserttext",
            description: "Insert text",
            exec: function(editor, args) {
                editor.insert(lang.stringRepeat(args.text || "", args.times || 1));
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "splitline",
            description: "Split line",
            bindKey: bindKey(null, "Ctrl-O"),
            exec: function(editor) {
                editor.splitLine();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "transposeletters",
            description: "Transpose letters",
            bindKey: bindKey("Alt-Shift-X", "Ctrl-T"),
            exec: function(editor) {
                editor.transposeLetters();
            },
            multiSelectAction: function(editor) {
                editor.transposeSelections(1);
            },
            scrollIntoView: "cursor"
        },
        {
            name: "touppercase",
            description: "To uppercase",
            bindKey: bindKey("Ctrl-U", "Ctrl-U"),
            exec: function(editor) {
                editor.toUpperCase();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "tolowercase",
            description: "To lowercase",
            bindKey: bindKey("Ctrl-Shift-U", "Ctrl-Shift-U"),
            exec: function(editor) {
                editor.toLowerCase();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "autoindent",
            description: "Auto Indent",
            bindKey: bindKey(null, null),
            exec: function(editor) {
                editor.autoIndent();
            },
            scrollIntoView: "animate"
        },
        {
            name: "expandtoline",
            description: "Expand to line",
            bindKey: bindKey("Ctrl-Shift-L", "Command-Shift-L"),
            exec: function(editor) {
                var range = editor.selection.getRange();
                range.start.column = range.end.column = 0;
                range.end.row++;
                editor.selection.setRange(range, false);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "openlink",
            bindKey: bindKey("Ctrl+F3", "F3"),
            exec: function(editor) {
                editor.openLink();
            }
        },
        {
            name: "joinlines",
            description: "Join lines",
            bindKey: bindKey(null, null),
            exec: function(editor) {
                var isBackwards = editor.selection.isBackwards();
                var selectionStart = isBackwards ? editor.selection.getSelectionLead() : editor.selection.getSelectionAnchor();
                var selectionEnd = isBackwards ? editor.selection.getSelectionAnchor() : editor.selection.getSelectionLead();
                var firstLineEndCol = editor.session.doc.getLine(selectionStart.row).length;
                var selectedText = editor.session.doc.getTextRange(editor.selection.getRange());
                var selectedCount = selectedText.replace(/\n\s*/, " ").length;
                var insertLine = editor.session.doc.getLine(selectionStart.row);
                for(var i = selectionStart.row + 1; i <= selectionEnd.row + 1; i++){
                    var curLine = lang.stringTrimLeft(lang.stringTrimRight(editor.session.doc.getLine(i)));
                    if (curLine.length !== 0) curLine = " " + curLine;
                    insertLine += curLine;
                }
                if (selectionEnd.row + 1 < editor.session.doc.getLength() - 1) insertLine += editor.session.doc.getNewLineCharacter();
                editor.clearSelection();
                editor.session.doc.replace(new Range(selectionStart.row, 0, selectionEnd.row + 2, 0), insertLine);
                if (selectedCount > 0) {
                    editor.selection.moveCursorTo(selectionStart.row, selectionStart.column);
                    editor.selection.selectTo(selectionStart.row, selectionStart.column + selectedCount);
                } else {
                    firstLineEndCol = editor.session.doc.getLine(selectionStart.row).length > firstLineEndCol ? firstLineEndCol + 1 : firstLineEndCol;
                    editor.selection.moveCursorTo(selectionStart.row, firstLineEndCol);
                }
            },
            multiSelectAction: "forEach",
            readOnly: true
        },
        {
            name: "invertSelection",
            description: "Invert selection",
            bindKey: bindKey(null, null),
            exec: function(editor) {
                var endRow = editor.session.doc.getLength() - 1;
                var endCol = editor.session.doc.getLine(endRow).length;
                var ranges = editor.selection.rangeList.ranges;
                var newRanges = [];
                if (ranges.length < 1) ranges = [
                    editor.selection.getRange()
                ];
                for(var i = 0; i < ranges.length; i++){
                    if (i == ranges.length - 1) {
                        if (!(ranges[i].end.row === endRow && ranges[i].end.column === endCol)) newRanges.push(new Range(ranges[i].end.row, ranges[i].end.column, endRow, endCol));
                    }
                    if (i === 0) {
                        if (!(ranges[i].start.row === 0 && ranges[i].start.column === 0)) newRanges.push(new Range(0, 0, ranges[i].start.row, ranges[i].start.column));
                    } else newRanges.push(new Range(ranges[i - 1].end.row, ranges[i - 1].end.column, ranges[i].start.row, ranges[i].start.column));
                }
                editor.exitMultiSelectMode();
                editor.clearSelection();
                for(var i = 0; i < newRanges.length; i++)editor.selection.addRange(newRanges[i], false);
            },
            readOnly: true,
            scrollIntoView: "none"
        },
        {
            name: "addLineAfter",
            description: "Add new line after the current line",
            exec: function(editor) {
                editor.selection.clearSelection();
                editor.navigateLineEnd();
                editor.insert("\n");
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "addLineBefore",
            description: "Add new line before the current line",
            exec: function(editor) {
                editor.selection.clearSelection();
                var cursor = editor.getCursorPosition();
                editor.selection.moveTo(cursor.row - 1, Number.MAX_VALUE);
                editor.insert("\n");
                if (cursor.row === 0) editor.navigateUp();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "openCommandPallete",
            exec: function(editor) {
                console.warn("This is an obsolete command. Please use `openCommandPalette` instead.");
                editor.prompt({
                    $type: "commands"
                });
            },
            readOnly: true
        },
        {
            name: "openCommandPalette",
            description: "Open command palette",
            bindKey: bindKey("F1", "F1"),
            exec: function(editor) {
                editor.prompt({
                    $type: "commands"
                });
            },
            readOnly: true
        },
        {
            name: "modeSelect",
            description: "Change language mode...",
            bindKey: bindKey(null, null),
            exec: function(editor) {
                editor.prompt({
                    $type: "modes"
                });
            },
            readOnly: true
        }
    ];
    for(var i = 1; i < 9; i++)exports.commands.push({
        name: "foldToLevel" + i,
        description: "Fold To Level " + i,
        level: i,
        exec: function(editor) {
            editor.session.foldToLevel(this.level);
        },
        scrollIntoView: "center",
        readOnly: true
    });
});
ace.define("ace/line_widgets", [
    "require",
    "exports",
    "module",
    "ace/lib/dom"
], function(require, exports, module1) {
    "use strict";
    var dom = require("./lib/dom");
    var LineWidgets = /** @class */ function() {
        function LineWidgets(session) {
            this.session = session;
            this.session.widgetManager = this;
            this.session.getRowLength = this.getRowLength;
            this.session.$getWidgetScreenLength = this.$getWidgetScreenLength;
            this.updateOnChange = this.updateOnChange.bind(this);
            this.renderWidgets = this.renderWidgets.bind(this);
            this.measureWidgets = this.measureWidgets.bind(this);
            this.session._changedWidgets = [];
            this.$onChangeEditor = this.$onChangeEditor.bind(this);
            this.session.on("change", this.updateOnChange);
            this.session.on("changeFold", this.updateOnFold);
            this.session.on("changeEditor", this.$onChangeEditor);
        }
        LineWidgets.prototype.getRowLength = function(row) {
            var h;
            if (this.lineWidgets) h = this.lineWidgets[row] && this.lineWidgets[row].rowCount || 0;
            else h = 0;
            if (!this["$useWrapMode"] || !this["$wrapData"][row]) return 1 + h;
            else return this["$wrapData"][row].length + 1 + h;
        };
        LineWidgets.prototype.$getWidgetScreenLength = function() {
            var screenRows = 0;
            this.lineWidgets.forEach(function(w) {
                if (w && w.rowCount && !w.hidden) screenRows += w.rowCount;
            });
            return screenRows;
        };
        LineWidgets.prototype.$onChangeEditor = function(e) {
            this.attach(e.editor);
        };
        LineWidgets.prototype.attach = function(editor) {
            if (editor && editor.widgetManager && editor.widgetManager != this) editor.widgetManager.detach();
            if (this.editor == editor) return;
            this.detach();
            this.editor = editor;
            if (editor) {
                editor.widgetManager = this;
                editor.renderer.on("beforeRender", this.measureWidgets);
                editor.renderer.on("afterRender", this.renderWidgets);
            }
        };
        LineWidgets.prototype.detach = function(e) {
            var editor = this.editor;
            if (!editor) return;
            this.editor = null;
            editor.widgetManager = null;
            editor.renderer.off("beforeRender", this.measureWidgets);
            editor.renderer.off("afterRender", this.renderWidgets);
            var lineWidgets = this.session.lineWidgets;
            lineWidgets && lineWidgets.forEach(function(w) {
                if (w && w.el && w.el.parentNode) {
                    w._inDocument = false;
                    w.el.parentNode.removeChild(w.el);
                }
            });
        };
        LineWidgets.prototype.updateOnFold = function(e, session) {
            var lineWidgets = session.lineWidgets;
            if (!lineWidgets || !e.action) return;
            var fold = e.data;
            var start = fold.start.row;
            var end = fold.end.row;
            var hide = e.action == "add";
            for(var i = start + 1; i < end; i++)if (lineWidgets[i]) lineWidgets[i].hidden = hide;
            if (lineWidgets[end]) {
                if (hide) {
                    if (!lineWidgets[start]) lineWidgets[start] = lineWidgets[end];
                    else lineWidgets[end].hidden = hide;
                } else {
                    if (lineWidgets[start] == lineWidgets[end]) lineWidgets[start] = undefined;
                    lineWidgets[end].hidden = hide;
                }
            }
        };
        LineWidgets.prototype.updateOnChange = function(delta) {
            var lineWidgets = this.session.lineWidgets;
            if (!lineWidgets) return;
            var startRow = delta.start.row;
            var len = delta.end.row - startRow;
            if (len === 0) ;
            else if (delta.action == "remove") {
                var removed = lineWidgets.splice(startRow + 1, len);
                if (!lineWidgets[startRow] && removed[removed.length - 1]) lineWidgets[startRow] = removed.pop();
                removed.forEach(function(w) {
                    w && this.removeLineWidget(w);
                }, this);
                this.$updateRows();
            } else {
                var args = new Array(len);
                if (lineWidgets[startRow] && lineWidgets[startRow].column != null) {
                    if (delta.start.column > lineWidgets[startRow].column) startRow++;
                }
                args.unshift(startRow, 0);
                lineWidgets.splice.apply(lineWidgets, args);
                this.$updateRows();
            }
        };
        LineWidgets.prototype.$updateRows = function() {
            var lineWidgets = this.session.lineWidgets;
            if (!lineWidgets) return;
            var noWidgets = true;
            lineWidgets.forEach(function(w, i) {
                if (w) {
                    noWidgets = false;
                    w.row = i;
                    while(w.$oldWidget){
                        w.$oldWidget.row = i;
                        w = w.$oldWidget;
                    }
                }
            });
            if (noWidgets) this.session.lineWidgets = null;
        };
        LineWidgets.prototype.$registerLineWidget = function(w) {
            if (!this.session.lineWidgets) this.session.lineWidgets = new Array(this.session.getLength());
            var old = this.session.lineWidgets[w.row];
            if (old) {
                w.$oldWidget = old;
                if (old.el && old.el.parentNode) {
                    old.el.parentNode.removeChild(old.el);
                    old._inDocument = false;
                }
            }
            this.session.lineWidgets[w.row] = w;
            return w;
        };
        LineWidgets.prototype.addLineWidget = function(w) {
            this.$registerLineWidget(w);
            w.session = this.session;
            if (!this.editor) return w;
            var renderer = this.editor.renderer;
            if (w.html && !w.el) {
                w.el = dom.createElement("div");
                w.el.innerHTML = w.html;
            }
            if (w.text && !w.el) {
                w.el = dom.createElement("div");
                w.el.textContent = w.text;
            }
            if (w.el) {
                dom.addCssClass(w.el, "ace_lineWidgetContainer");
                if (w.className) dom.addCssClass(w.el, w.className);
                w.el.style.position = "absolute";
                w.el.style.zIndex = "5";
                renderer.container.appendChild(w.el);
                w._inDocument = true;
                if (!w.coverGutter) w.el.style.zIndex = "3";
                if (w.pixelHeight == null) w.pixelHeight = w.el.offsetHeight;
            }
            if (w.rowCount == null) w.rowCount = w.pixelHeight / renderer.layerConfig.lineHeight;
            var fold = this.session.getFoldAt(w.row, 0);
            w.$fold = fold;
            if (fold) {
                var lineWidgets = this.session.lineWidgets;
                if (w.row == fold.end.row && !lineWidgets[fold.start.row]) lineWidgets[fold.start.row] = w;
                else w.hidden = true;
            }
            this.session._emit("changeFold", {
                data: {
                    start: {
                        row: w.row
                    }
                }
            });
            this.$updateRows();
            this.renderWidgets(null, renderer);
            this.onWidgetChanged(w);
            return w;
        };
        LineWidgets.prototype.removeLineWidget = function(w) {
            w._inDocument = false;
            w.session = null;
            if (w.el && w.el.parentNode) w.el.parentNode.removeChild(w.el);
            if (w.editor && w.editor.destroy) try {
                w.editor.destroy();
            } catch (e) {}
            if (this.session.lineWidgets) {
                var w1 = this.session.lineWidgets[w.row];
                if (w1 == w) {
                    this.session.lineWidgets[w.row] = w.$oldWidget;
                    if (w.$oldWidget) this.onWidgetChanged(w.$oldWidget);
                } else while(w1){
                    if (w1.$oldWidget == w) {
                        w1.$oldWidget = w.$oldWidget;
                        break;
                    }
                    w1 = w1.$oldWidget;
                }
            }
            this.session._emit("changeFold", {
                data: {
                    start: {
                        row: w.row
                    }
                }
            });
            this.$updateRows();
        };
        LineWidgets.prototype.getWidgetsAtRow = function(row) {
            var lineWidgets = this.session.lineWidgets;
            var w = lineWidgets && lineWidgets[row];
            var list = [];
            while(w){
                list.push(w);
                w = w.$oldWidget;
            }
            return list;
        };
        LineWidgets.prototype.onWidgetChanged = function(w) {
            this.session._changedWidgets.push(w);
            this.editor && this.editor.renderer.updateFull();
        };
        LineWidgets.prototype.measureWidgets = function(e, renderer) {
            var changedWidgets = this.session._changedWidgets;
            var config = renderer.layerConfig;
            if (!changedWidgets || !changedWidgets.length) return;
            var min = Infinity;
            for(var i = 0; i < changedWidgets.length; i++){
                var w = changedWidgets[i];
                if (!w || !w.el) continue;
                if (w.session != this.session) continue;
                if (!w._inDocument) {
                    if (this.session.lineWidgets[w.row] != w) continue;
                    w._inDocument = true;
                    renderer.container.appendChild(w.el);
                }
                w.h = w.el.offsetHeight;
                if (!w.fixedWidth) {
                    w.w = w.el.offsetWidth;
                    w.screenWidth = Math.ceil(w.w / config.characterWidth);
                }
                var rowCount = w.h / config.lineHeight;
                if (w.coverLine) {
                    rowCount -= this.session.getRowLineCount(w.row);
                    if (rowCount < 0) rowCount = 0;
                }
                if (w.rowCount != rowCount) {
                    w.rowCount = rowCount;
                    if (w.row < min) min = w.row;
                }
            }
            if (min != Infinity) {
                this.session._emit("changeFold", {
                    data: {
                        start: {
                            row: min
                        }
                    }
                });
                this.session.lineWidgetWidth = null;
            }
            this.session._changedWidgets = [];
        };
        LineWidgets.prototype.renderWidgets = function(e, renderer) {
            var config = renderer.layerConfig;
            var lineWidgets = this.session.lineWidgets;
            if (!lineWidgets) return;
            var first = Math.min(this.firstRow, config.firstRow);
            var last = Math.max(this.lastRow, config.lastRow, lineWidgets.length);
            while(first > 0 && !lineWidgets[first])first--;
            this.firstRow = config.firstRow;
            this.lastRow = config.lastRow;
            renderer.$cursorLayer.config = config;
            for(var i = first; i <= last; i++){
                var w = lineWidgets[i];
                if (!w || !w.el) continue;
                if (w.hidden) {
                    w.el.style.top = -100 - (w.pixelHeight || 0) + "px";
                    continue;
                }
                if (!w._inDocument) {
                    w._inDocument = true;
                    renderer.container.appendChild(w.el);
                }
                var top = renderer.$cursorLayer.getPixelPosition({
                    row: i,
                    column: 0
                }, true).top;
                if (!w.coverLine) top += config.lineHeight * this.session.getRowLineCount(w.row);
                w.el.style.top = top - config.offset + "px";
                var left = w.coverGutter ? 0 : renderer.gutterWidth;
                if (!w.fixedWidth) left -= renderer.scrollLeft;
                w.el.style.left = left + "px";
                if (w.fullWidth && w.screenWidth) w.el.style.minWidth = config.width + 2 * config.padding + "px";
                if (w.fixedWidth) w.el.style.right = renderer.scrollBar.getWidth() + "px";
                else w.el.style.right = "";
            }
        };
        return LineWidgets;
    }();
    exports.LineWidgets = LineWidgets;
});
ace.define("ace/keyboard/gutter_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/keys",
    "ace/mouse/default_gutter_handler"
], function(require, exports, module1) {
    "use strict";
    var keys = require("../lib/keys");
    var GutterTooltip = require("../mouse/default_gutter_handler").GutterTooltip;
    var GutterKeyboardHandler = /** @class */ function() {
        function GutterKeyboardHandler(editor) {
            this.editor = editor;
            this.gutterLayer = editor.renderer.$gutterLayer;
            this.element = editor.renderer.$gutter;
            this.lines = editor.renderer.$gutterLayer.$lines;
            this.activeRowIndex = null;
            this.activeLane = null;
            this.annotationTooltip = new GutterTooltip(this.editor);
        }
        GutterKeyboardHandler.prototype.addListener = function() {
            this.element.addEventListener("keydown", this.$onGutterKeyDown.bind(this));
            this.element.addEventListener("focusout", this.$blurGutter.bind(this));
            this.editor.on("mousewheel", this.$blurGutter.bind(this));
        };
        GutterKeyboardHandler.prototype.removeListener = function() {
            this.element.removeEventListener("keydown", this.$onGutterKeyDown.bind(this));
            this.element.removeEventListener("focusout", this.$blurGutter.bind(this));
            this.editor.off("mousewheel", this.$blurGutter.bind(this));
        };
        GutterKeyboardHandler.prototype.$onGutterKeyDown = function(e) {
            if (this.annotationTooltip.isOpen) {
                e.preventDefault();
                if (e.keyCode === keys["escape"]) this.annotationTooltip.hideTooltip();
                return;
            }
            if (e.target === this.element) {
                if (e.keyCode != keys["enter"]) return;
                e.preventDefault();
                var row = this.editor.getCursorPosition().row;
                if (!this.editor.isRowVisible(row)) this.editor.scrollToLine(row, true, true);
                setTimeout((function() {
                    var index = this.$rowToRowIndex(this.gutterLayer.$cursorCell.row);
                    var nearestFoldIndex = this.$findNearestFoldWidget(index);
                    var nearestAnnotationIndex = this.$findNearestAnnotation(index);
                    if (nearestFoldIndex === null && nearestAnnotationIndex === null) return;
                    if (nearestFoldIndex === null && nearestAnnotationIndex !== null) {
                        this.activeRowIndex = nearestAnnotationIndex;
                        this.activeLane = "annotation";
                        this.$focusAnnotation(this.activeRowIndex);
                        return;
                    }
                    if (nearestFoldIndex !== null && nearestAnnotationIndex === null) {
                        this.activeRowIndex = nearestFoldIndex;
                        this.activeLane = "fold";
                        this.$focusFoldWidget(this.activeRowIndex);
                        return;
                    }
                    if (Math.abs(nearestAnnotationIndex - index) < Math.abs(nearestFoldIndex - index)) {
                        this.activeRowIndex = nearestAnnotationIndex;
                        this.activeLane = "annotation";
                        this.$focusAnnotation(this.activeRowIndex);
                        return;
                    } else {
                        this.activeRowIndex = nearestFoldIndex;
                        this.activeLane = "fold";
                        this.$focusFoldWidget(this.activeRowIndex);
                        return;
                    }
                }).bind(this), 10);
                return;
            }
            this.$handleGutterKeyboardInteraction(e);
            setTimeout((function() {
                this.editor._signal("gutterkeydown", new GutterKeyboardEvent(e, this));
            }).bind(this), 10);
        };
        GutterKeyboardHandler.prototype.$handleGutterKeyboardInteraction = function(e) {
            if (e.keyCode === keys["tab"]) {
                e.preventDefault();
                return;
            }
            if (e.keyCode === keys["escape"]) {
                e.preventDefault();
                this.$blurGutter();
                this.element.focus();
                this.lane = null;
                return;
            }
            if (e.keyCode === keys["up"]) {
                e.preventDefault();
                switch(this.activeLane){
                    case "fold":
                        this.$moveFoldWidgetUp();
                        break;
                    case "annotation":
                        this.$moveAnnotationUp();
                        break;
                }
                return;
            }
            if (e.keyCode === keys["down"]) {
                e.preventDefault();
                switch(this.activeLane){
                    case "fold":
                        this.$moveFoldWidgetDown();
                        break;
                    case "annotation":
                        this.$moveAnnotationDown();
                        break;
                }
                return;
            }
            if (e.keyCode === keys["left"]) {
                e.preventDefault();
                this.$switchLane("annotation");
                return;
            }
            if (e.keyCode === keys["right"]) {
                e.preventDefault();
                this.$switchLane("fold");
                return;
            }
            if (e.keyCode === keys["enter"] || e.keyCode === keys["space"]) {
                e.preventDefault();
                switch(this.activeLane){
                    case "fold":
                        if (this.gutterLayer.session.foldWidgets[this.$rowIndexToRow(this.activeRowIndex)] === "start") {
                            var rowFoldingWidget = this.$rowIndexToRow(this.activeRowIndex);
                            this.editor.session.onFoldWidgetClick(this.$rowIndexToRow(this.activeRowIndex), e);
                            setTimeout((function() {
                                if (this.$rowIndexToRow(this.activeRowIndex) !== rowFoldingWidget) {
                                    this.$blurFoldWidget(this.activeRowIndex);
                                    this.activeRowIndex = this.$rowToRowIndex(rowFoldingWidget);
                                    this.$focusFoldWidget(this.activeRowIndex);
                                }
                            }).bind(this), 10);
                            break;
                        } else if (this.gutterLayer.session.foldWidgets[this.$rowIndexToRow(this.activeRowIndex)] === "end") break;
                        return;
                    case "annotation":
                        var gutterElement = this.lines.cells[this.activeRowIndex].element.childNodes[2];
                        var rect = gutterElement.getBoundingClientRect();
                        var style = this.annotationTooltip.getElement().style;
                        style.left = rect.right + "px";
                        style.top = rect.bottom + "px";
                        this.annotationTooltip.showTooltip(this.$rowIndexToRow(this.activeRowIndex));
                        break;
                }
                return;
            }
        };
        GutterKeyboardHandler.prototype.$blurGutter = function() {
            if (this.activeRowIndex !== null) switch(this.activeLane){
                case "fold":
                    this.$blurFoldWidget(this.activeRowIndex);
                    break;
                case "annotation":
                    this.$blurAnnotation(this.activeRowIndex);
                    break;
            }
            if (this.annotationTooltip.isOpen) this.annotationTooltip.hideTooltip();
            return;
        };
        GutterKeyboardHandler.prototype.$isFoldWidgetVisible = function(index) {
            var isRowFullyVisible = this.editor.isRowFullyVisible(this.$rowIndexToRow(index));
            var isIconVisible = this.$getFoldWidget(index).style.display !== "none";
            return isRowFullyVisible && isIconVisible;
        };
        GutterKeyboardHandler.prototype.$isAnnotationVisible = function(index) {
            var isRowFullyVisible = this.editor.isRowFullyVisible(this.$rowIndexToRow(index));
            var isIconVisible = this.$getAnnotation(index).style.display !== "none";
            return isRowFullyVisible && isIconVisible;
        };
        GutterKeyboardHandler.prototype.$getFoldWidget = function(index) {
            var cell = this.lines.get(index);
            var element = cell.element;
            return element.childNodes[1];
        };
        GutterKeyboardHandler.prototype.$getAnnotation = function(index) {
            var cell = this.lines.get(index);
            var element = cell.element;
            return element.childNodes[2];
        };
        GutterKeyboardHandler.prototype.$findNearestFoldWidget = function(index) {
            if (this.$isFoldWidgetVisible(index)) return index;
            var i = 0;
            while(index - i > 0 || index + i < this.lines.getLength() - 1){
                i++;
                if (index - i >= 0 && this.$isFoldWidgetVisible(index - i)) return index - i;
                if (index + i <= this.lines.getLength() - 1 && this.$isFoldWidgetVisible(index + i)) return index + i;
            }
            return null;
        };
        GutterKeyboardHandler.prototype.$findNearestAnnotation = function(index) {
            if (this.$isAnnotationVisible(index)) return index;
            var i = 0;
            while(index - i > 0 || index + i < this.lines.getLength() - 1){
                i++;
                if (index - i >= 0 && this.$isAnnotationVisible(index - i)) return index - i;
                if (index + i <= this.lines.getLength() - 1 && this.$isAnnotationVisible(index + i)) return index + i;
            }
            return null;
        };
        GutterKeyboardHandler.prototype.$focusFoldWidget = function(index) {
            if (index == null) return;
            var foldWidget = this.$getFoldWidget(index);
            foldWidget.classList.add(this.editor.renderer.keyboardFocusClassName);
            foldWidget.focus();
        };
        GutterKeyboardHandler.prototype.$focusAnnotation = function(index) {
            if (index == null) return;
            var annotation = this.$getAnnotation(index);
            annotation.classList.add(this.editor.renderer.keyboardFocusClassName);
            annotation.focus();
        };
        GutterKeyboardHandler.prototype.$blurFoldWidget = function(index) {
            var foldWidget = this.$getFoldWidget(index);
            foldWidget.classList.remove(this.editor.renderer.keyboardFocusClassName);
            foldWidget.blur();
        };
        GutterKeyboardHandler.prototype.$blurAnnotation = function(index) {
            var annotation = this.$getAnnotation(index);
            annotation.classList.remove(this.editor.renderer.keyboardFocusClassName);
            annotation.blur();
        };
        GutterKeyboardHandler.prototype.$moveFoldWidgetUp = function() {
            var index = this.activeRowIndex;
            while(index > 0){
                index--;
                if (this.$isFoldWidgetVisible(index)) {
                    this.$blurFoldWidget(this.activeRowIndex);
                    this.activeRowIndex = index;
                    this.$focusFoldWidget(this.activeRowIndex);
                    return;
                }
            }
            return;
        };
        GutterKeyboardHandler.prototype.$moveFoldWidgetDown = function() {
            var index = this.activeRowIndex;
            while(index < this.lines.getLength() - 1){
                index++;
                if (this.$isFoldWidgetVisible(index)) {
                    this.$blurFoldWidget(this.activeRowIndex);
                    this.activeRowIndex = index;
                    this.$focusFoldWidget(this.activeRowIndex);
                    return;
                }
            }
            return;
        };
        GutterKeyboardHandler.prototype.$moveAnnotationUp = function() {
            var index = this.activeRowIndex;
            while(index > 0){
                index--;
                if (this.$isAnnotationVisible(index)) {
                    this.$blurAnnotation(this.activeRowIndex);
                    this.activeRowIndex = index;
                    this.$focusAnnotation(this.activeRowIndex);
                    return;
                }
            }
            return;
        };
        GutterKeyboardHandler.prototype.$moveAnnotationDown = function() {
            var index = this.activeRowIndex;
            while(index < this.lines.getLength() - 1){
                index++;
                if (this.$isAnnotationVisible(index)) {
                    this.$blurAnnotation(this.activeRowIndex);
                    this.activeRowIndex = index;
                    this.$focusAnnotation(this.activeRowIndex);
                    return;
                }
            }
            return;
        };
        GutterKeyboardHandler.prototype.$switchLane = function(desinationLane) {
            switch(desinationLane){
                case "annotation":
                    if (this.activeLane === "annotation") break;
                    var annotationIndex = this.$findNearestAnnotation(this.activeRowIndex);
                    if (annotationIndex == null) break;
                    this.activeLane = "annotation";
                    this.$blurFoldWidget(this.activeRowIndex);
                    this.activeRowIndex = annotationIndex;
                    this.$focusAnnotation(this.activeRowIndex);
                    break;
                case "fold":
                    if (this.activeLane === "fold") break;
                    var foldWidgetIndex = this.$findNearestFoldWidget(this.activeRowIndex);
                    if (foldWidgetIndex == null) break;
                    this.activeLane = "fold";
                    this.$blurAnnotation(this.activeRowIndex);
                    this.activeRowIndex = foldWidgetIndex;
                    this.$focusFoldWidget(this.activeRowIndex);
                    break;
            }
            return;
        };
        GutterKeyboardHandler.prototype.$rowIndexToRow = function(index) {
            var cell = this.lines.get(index);
            if (cell) return cell.row;
            return null;
        };
        GutterKeyboardHandler.prototype.$rowToRowIndex = function(row) {
            for(var i = 0; i < this.lines.getLength(); i++){
                var cell = this.lines.get(i);
                if (cell.row == row) return i;
            }
            return null;
        };
        return GutterKeyboardHandler;
    }();
    exports.GutterKeyboardHandler = GutterKeyboardHandler;
    var GutterKeyboardEvent = /** @class */ function() {
        function GutterKeyboardEvent(domEvent, gutterKeyboardHandler) {
            this.gutterKeyboardHandler = gutterKeyboardHandler;
            this.domEvent = domEvent;
        }
        GutterKeyboardEvent.prototype.getKey = function() {
            return keys.keyCodeToString(this.domEvent.keyCode);
        };
        GutterKeyboardEvent.prototype.getRow = function() {
            return this.gutterKeyboardHandler.$rowIndexToRow(this.gutterKeyboardHandler.activeRowIndex);
        };
        GutterKeyboardEvent.prototype.isInAnnotationLane = function() {
            return this.gutterKeyboardHandler.activeLane === "annotation";
        };
        GutterKeyboardEvent.prototype.isInFoldLane = function() {
            return this.gutterKeyboardHandler.activeLane === "fold";
        };
        return GutterKeyboardEvent;
    }();
    exports.GutterKeyboardEvent = GutterKeyboardEvent;
});
ace.define("ace/editor", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/lib/lang",
    "ace/lib/useragent",
    "ace/keyboard/textinput",
    "ace/mouse/mouse_handler",
    "ace/mouse/fold_handler",
    "ace/keyboard/keybinding",
    "ace/edit_session",
    "ace/search",
    "ace/range",
    "ace/lib/event_emitter",
    "ace/commands/command_manager",
    "ace/commands/default_commands",
    "ace/config",
    "ace/token_iterator",
    "ace/line_widgets",
    "ace/keyboard/gutter_handler",
    "ace/config",
    "ace/clipboard",
    "ace/lib/keys"
], function(require, exports, module1) {
    "use strict";
    var __values = this && this.__values || function(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function() {
                if (o && i >= o.length) o = void 0;
                return {
                    value: o && o[i++],
                    done: !o
                };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    var oop = require("./lib/oop");
    var dom = require("./lib/dom");
    var lang = require("./lib/lang");
    var useragent = require("./lib/useragent");
    var TextInput = require("./keyboard/textinput").TextInput;
    var MouseHandler = require("./mouse/mouse_handler").MouseHandler;
    var FoldHandler = require("./mouse/fold_handler").FoldHandler;
    var KeyBinding = require("./keyboard/keybinding").KeyBinding;
    var EditSession = require("./edit_session").EditSession;
    var Search = require("./search").Search;
    var Range = require("./range").Range;
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var CommandManager = require("./commands/command_manager").CommandManager;
    var defaultCommands = require("./commands/default_commands").commands;
    var config = require("./config");
    var TokenIterator = require("./token_iterator").TokenIterator;
    var LineWidgets = require("./line_widgets").LineWidgets;
    var GutterKeyboardHandler = require("./keyboard/gutter_handler").GutterKeyboardHandler;
    var nls = require("./config").nls;
    var clipboard = require("./clipboard");
    var keys = require("./lib/keys");
    var Editor = /** @class */ function() {
        function Editor(renderer, session, options) {
            this.session;
            this.$toDestroy = [];
            var container = renderer.getContainerElement();
            this.container = container;
            this.renderer = renderer;
            this.id = "editor" + ++Editor.$uid;
            this.commands = new CommandManager(useragent.isMac ? "mac" : "win", defaultCommands);
            if (typeof document == "object") {
                this.textInput = new TextInput(renderer.getTextAreaContainer(), this);
                this.renderer.textarea = this.textInput.getElement();
                this.$mouseHandler = new MouseHandler(this);
                new FoldHandler(this);
            }
            this.keyBinding = new KeyBinding(this);
            this.$search = new Search().set({
                wrap: true
            });
            this.$historyTracker = this.$historyTracker.bind(this);
            this.commands.on("exec", this.$historyTracker);
            this.$initOperationListeners();
            this._$emitInputEvent = lang.delayedCall((function() {
                this._signal("input", {});
                if (this.session && !this.session.destroyed) this.session.bgTokenizer.scheduleStart();
            }).bind(this));
            this.on("change", function(_, _self) {
                _self._$emitInputEvent.schedule(31);
            });
            this.setSession(session || options && options.session || new EditSession(""));
            config.resetOptions(this);
            if (options) this.setOptions(options);
            config._signal("editor", this);
        }
        Editor.prototype.$initOperationListeners = function() {
            this.commands.on("exec", this.startOperation.bind(this), true);
            this.commands.on("afterExec", this.endOperation.bind(this), true);
            this.$opResetTimer = lang.delayedCall(this.endOperation.bind(this, true));
            this.on("change", (function() {
                if (!this.curOp) {
                    this.startOperation();
                    this.curOp.selectionBefore = this.$lastSel;
                }
                this.curOp.docChanged = true;
            }).bind(this), true);
            this.on("changeSelection", (function() {
                if (!this.curOp) {
                    this.startOperation();
                    this.curOp.selectionBefore = this.$lastSel;
                }
                this.curOp.selectionChanged = true;
            }).bind(this), true);
        };
        Editor.prototype.startOperation = function(commandEvent) {
            if (this.curOp) {
                if (!commandEvent || this.curOp.command) return;
                this.prevOp = this.curOp;
            }
            if (!commandEvent) {
                this.previousCommand = null;
                commandEvent = {};
            }
            this.$opResetTimer.schedule();
            this.curOp = this.session.curOp = {
                command: commandEvent.command || {},
                args: commandEvent.args,
                scrollTop: this.renderer.scrollTop
            };
            this.curOp.selectionBefore = this.selection.toJSON();
        };
        Editor.prototype.endOperation = function(e) {
            if (this.curOp && this.session) {
                if (e && e.returnValue === false || !this.session) return this.curOp = null;
                if (e == true && this.curOp.command && this.curOp.command.name == "mouse") return;
                this._signal("beforeEndOperation");
                if (!this.curOp) return;
                var command = this.curOp.command;
                var scrollIntoView = command && command.scrollIntoView;
                if (scrollIntoView) {
                    switch(scrollIntoView){
                        case "center-animate":
                            scrollIntoView = "animate";
                        case "center":
                            this.renderer.scrollCursorIntoView(null, 0.5);
                            break;
                        case "animate":
                        case "cursor":
                            this.renderer.scrollCursorIntoView();
                            break;
                        case "selectionPart":
                            var range = this.selection.getRange();
                            var config = this.renderer.layerConfig;
                            if (range.start.row >= config.lastRow || range.end.row <= config.firstRow) this.renderer.scrollSelectionIntoView(this.selection.anchor, this.selection.lead);
                            break;
                        default:
                            break;
                    }
                    if (scrollIntoView == "animate") this.renderer.animateScrolling(this.curOp.scrollTop);
                }
                var sel = this.selection.toJSON();
                this.curOp.selectionAfter = sel;
                this.$lastSel = this.selection.toJSON();
                this.session.getUndoManager().addSelection(sel);
                this.prevOp = this.curOp;
                this.curOp = null;
            }
        };
        Editor.prototype.$historyTracker = function(e) {
            if (!this.$mergeUndoDeltas) return;
            var prev = this.prevOp;
            var mergeableCommands = this.$mergeableCommands;
            var shouldMerge = prev.command && e.command.name == prev.command.name;
            if (e.command.name == "insertstring") {
                var text = e.args;
                if (this.mergeNextCommand === undefined) this.mergeNextCommand = true;
                shouldMerge = shouldMerge && this.mergeNextCommand // previous command allows to coalesce with
                 && (!/\s/.test(text) || /\s/.test(prev.args)); // previous insertion was of same type
                this.mergeNextCommand = true;
            } else shouldMerge = shouldMerge && mergeableCommands.indexOf(e.command.name) !== -1; // the command is mergeable
            if (this.$mergeUndoDeltas != "always" && Date.now() - this.sequenceStartTime > 2000) shouldMerge = false; // the sequence is too long
            if (shouldMerge) this.session.mergeUndoDeltas = true;
            else if (mergeableCommands.indexOf(e.command.name) !== -1) this.sequenceStartTime = Date.now();
        };
        Editor.prototype.setKeyboardHandler = function(keyboardHandler, cb) {
            if (keyboardHandler && typeof keyboardHandler === "string" && keyboardHandler != "ace") {
                this.$keybindingId = keyboardHandler;
                var _self = this;
                config.loadModule([
                    "keybinding",
                    keyboardHandler
                ], function(module1) {
                    if (_self.$keybindingId == keyboardHandler) _self.keyBinding.setKeyboardHandler(module1 && module1.handler);
                    cb && cb();
                });
            } else {
                this.$keybindingId = null;
                this.keyBinding.setKeyboardHandler(keyboardHandler);
                cb && cb();
            }
        };
        Editor.prototype.getKeyboardHandler = function() {
            return this.keyBinding.getKeyboardHandler();
        };
        Editor.prototype.setSession = function(session) {
            if (this.session == session) return;
            if (this.curOp) this.endOperation();
            this.curOp = {};
            var oldSession = this.session;
            if (oldSession) {
                this.session.off("change", this.$onDocumentChange);
                this.session.off("changeMode", this.$onChangeMode);
                this.session.off("tokenizerUpdate", this.$onTokenizerUpdate);
                this.session.off("changeTabSize", this.$onChangeTabSize);
                this.session.off("changeWrapLimit", this.$onChangeWrapLimit);
                this.session.off("changeWrapMode", this.$onChangeWrapMode);
                this.session.off("changeFold", this.$onChangeFold);
                this.session.off("changeFrontMarker", this.$onChangeFrontMarker);
                this.session.off("changeBackMarker", this.$onChangeBackMarker);
                this.session.off("changeBreakpoint", this.$onChangeBreakpoint);
                this.session.off("changeAnnotation", this.$onChangeAnnotation);
                this.session.off("changeOverwrite", this.$onCursorChange);
                this.session.off("changeScrollTop", this.$onScrollTopChange);
                this.session.off("changeScrollLeft", this.$onScrollLeftChange);
                var selection = this.session.getSelection();
                selection.off("changeCursor", this.$onCursorChange);
                selection.off("changeSelection", this.$onSelectionChange);
            }
            this.session = session;
            if (session) {
                this.$onDocumentChange = this.onDocumentChange.bind(this);
                session.on("change", this.$onDocumentChange);
                this.renderer.setSession(session);
                this.$onChangeMode = this.onChangeMode.bind(this);
                session.on("changeMode", this.$onChangeMode);
                this.$onTokenizerUpdate = this.onTokenizerUpdate.bind(this);
                session.on("tokenizerUpdate", this.$onTokenizerUpdate);
                this.$onChangeTabSize = this.renderer.onChangeTabSize.bind(this.renderer);
                session.on("changeTabSize", this.$onChangeTabSize);
                this.$onChangeWrapLimit = this.onChangeWrapLimit.bind(this);
                session.on("changeWrapLimit", this.$onChangeWrapLimit);
                this.$onChangeWrapMode = this.onChangeWrapMode.bind(this);
                session.on("changeWrapMode", this.$onChangeWrapMode);
                this.$onChangeFold = this.onChangeFold.bind(this);
                session.on("changeFold", this.$onChangeFold);
                this.$onChangeFrontMarker = this.onChangeFrontMarker.bind(this);
                this.session.on("changeFrontMarker", this.$onChangeFrontMarker);
                this.$onChangeBackMarker = this.onChangeBackMarker.bind(this);
                this.session.on("changeBackMarker", this.$onChangeBackMarker);
                this.$onChangeBreakpoint = this.onChangeBreakpoint.bind(this);
                this.session.on("changeBreakpoint", this.$onChangeBreakpoint);
                this.$onChangeAnnotation = this.onChangeAnnotation.bind(this);
                this.session.on("changeAnnotation", this.$onChangeAnnotation);
                this.$onCursorChange = this.onCursorChange.bind(this);
                this.session.on("changeOverwrite", this.$onCursorChange);
                this.$onScrollTopChange = this.onScrollTopChange.bind(this);
                this.session.on("changeScrollTop", this.$onScrollTopChange);
                this.$onScrollLeftChange = this.onScrollLeftChange.bind(this);
                this.session.on("changeScrollLeft", this.$onScrollLeftChange);
                this.selection = session.getSelection();
                this.selection.on("changeCursor", this.$onCursorChange);
                this.$onSelectionChange = this.onSelectionChange.bind(this);
                this.selection.on("changeSelection", this.$onSelectionChange);
                this.onChangeMode();
                this.onCursorChange();
                this.onScrollTopChange();
                this.onScrollLeftChange();
                this.onSelectionChange();
                this.onChangeFrontMarker();
                this.onChangeBackMarker();
                this.onChangeBreakpoint();
                this.onChangeAnnotation();
                this.session.getUseWrapMode() && this.renderer.adjustWrapLimit();
                this.renderer.updateFull();
            } else {
                this.selection = null;
                this.renderer.setSession(session);
            }
            this._signal("changeSession", {
                session: session,
                oldSession: oldSession
            });
            this.curOp = null;
            oldSession && oldSession._signal("changeEditor", {
                oldEditor: this
            });
            session && session._signal("changeEditor", {
                editor: this
            });
            if (session && !session.destroyed) session.bgTokenizer.scheduleStart();
        };
        Editor.prototype.getSession = function() {
            return this.session;
        };
        Editor.prototype.setValue = function(val, cursorPos) {
            this.session.doc.setValue(val);
            if (!cursorPos) this.selectAll();
            else if (cursorPos == 1) this.navigateFileEnd();
            else if (cursorPos == -1) this.navigateFileStart();
            return val;
        };
        Editor.prototype.getValue = function() {
            return this.session.getValue();
        };
        Editor.prototype.getSelection = function() {
            return this.selection;
        };
        Editor.prototype.resize = function(force) {
            this.renderer.onResize(force);
        };
        Editor.prototype.setTheme = function(theme, cb) {
            this.renderer.setTheme(theme, cb);
        };
        Editor.prototype.getTheme = function() {
            return this.renderer.getTheme();
        };
        Editor.prototype.setStyle = function(style) {
            this.renderer.setStyle(style);
        };
        Editor.prototype.unsetStyle = function(style) {
            this.renderer.unsetStyle(style);
        };
        Editor.prototype.getFontSize = function() {
            return this.getOption("fontSize") || dom.computedStyle(this.container).fontSize;
        };
        Editor.prototype.setFontSize = function(size) {
            this.setOption("fontSize", size);
        };
        Editor.prototype.$highlightBrackets = function() {
            if (this.$highlightPending) return;
            var self1 = this;
            this.$highlightPending = true;
            setTimeout(function() {
                self1.$highlightPending = false;
                var session = self1.session;
                if (!session || session.destroyed) return;
                if (session.$bracketHighlight) {
                    session.$bracketHighlight.markerIds.forEach(function(id) {
                        session.removeMarker(id);
                    });
                    session.$bracketHighlight = null;
                }
                var pos = self1.getCursorPosition();
                var handler = self1.getKeyboardHandler();
                var isBackwards = handler && handler.$getDirectionForHighlight && handler.$getDirectionForHighlight(self1);
                var ranges = session.getMatchingBracketRanges(pos, isBackwards);
                if (!ranges) {
                    var iterator = new TokenIterator(session, pos.row, pos.column);
                    var token = iterator.getCurrentToken();
                    if (token && /\b(?:tag-open|tag-name)/.test(token.type)) {
                        var tagNamesRanges = session.getMatchingTags(pos);
                        if (tagNamesRanges) ranges = [
                            tagNamesRanges.openTagName.isEmpty() ? tagNamesRanges.openTag : tagNamesRanges.openTagName,
                            tagNamesRanges.closeTagName.isEmpty() ? tagNamesRanges.closeTag : tagNamesRanges.closeTagName
                        ];
                    }
                }
                if (!ranges && session.$mode.getMatching) ranges = session.$mode.getMatching(self1.session);
                if (!ranges) {
                    if (self1.getHighlightIndentGuides()) self1.renderer.$textLayer.$highlightIndentGuide();
                    return;
                }
                var markerType = "ace_bracket";
                if (!Array.isArray(ranges)) ranges = [
                    ranges
                ];
                else if (ranges.length == 1) markerType = "ace_error_bracket";
                if (ranges.length == 2) {
                    if (Range.comparePoints(ranges[0].end, ranges[1].start) == 0) ranges = [
                        Range.fromPoints(ranges[0].start, ranges[1].end)
                    ];
                    else if (Range.comparePoints(ranges[0].start, ranges[1].end) == 0) ranges = [
                        Range.fromPoints(ranges[1].start, ranges[0].end)
                    ];
                }
                session.$bracketHighlight = {
                    ranges: ranges,
                    markerIds: ranges.map(function(range) {
                        return session.addMarker(range, markerType, "text");
                    })
                };
                if (self1.getHighlightIndentGuides()) self1.renderer.$textLayer.$highlightIndentGuide();
            }, 50);
        };
        Editor.prototype.focus = function() {
            this.textInput.focus();
        };
        Editor.prototype.isFocused = function() {
            return this.textInput.isFocused();
        };
        Editor.prototype.blur = function() {
            this.textInput.blur();
        };
        Editor.prototype.onFocus = function(e) {
            if (this.$isFocused) return;
            this.$isFocused = true;
            this.renderer.showCursor();
            this.renderer.visualizeFocus();
            this._emit("focus", e);
        };
        Editor.prototype.onBlur = function(e) {
            if (!this.$isFocused) return;
            this.$isFocused = false;
            this.renderer.hideCursor();
            this.renderer.visualizeBlur();
            this._emit("blur", e);
        };
        Editor.prototype.$cursorChange = function() {
            this.renderer.updateCursor();
            this.$highlightBrackets();
            this.$updateHighlightActiveLine();
        };
        Editor.prototype.onDocumentChange = function(delta) {
            var wrap = this.session.$useWrapMode;
            var lastRow = delta.start.row == delta.end.row ? delta.end.row : Infinity;
            this.renderer.updateLines(delta.start.row, lastRow, wrap);
            this._signal("change", delta);
            this.$cursorChange();
        };
        Editor.prototype.onTokenizerUpdate = function(e) {
            var rows = e.data;
            this.renderer.updateLines(rows.first, rows.last);
        };
        Editor.prototype.onScrollTopChange = function() {
            this.renderer.scrollToY(this.session.getScrollTop());
        };
        Editor.prototype.onScrollLeftChange = function() {
            this.renderer.scrollToX(this.session.getScrollLeft());
        };
        Editor.prototype.onCursorChange = function() {
            this.$cursorChange();
            this._signal("changeSelection");
        };
        Editor.prototype.$updateHighlightActiveLine = function() {
            var session = this.getSession();
            var highlight;
            if (this.$highlightActiveLine) {
                if (this.$selectionStyle != "line" || !this.selection.isMultiLine()) highlight = this.getCursorPosition();
                if (this.renderer.theme && this.renderer.theme.$selectionColorConflict && !this.selection.isEmpty()) highlight = false;
                if (this.renderer.$maxLines && this.session.getLength() === 1 && !(this.renderer.$minLines > 1)) highlight = false;
            }
            if (session.$highlightLineMarker && !highlight) {
                session.removeMarker(session.$highlightLineMarker.id);
                session.$highlightLineMarker = null;
            } else if (!session.$highlightLineMarker && highlight) {
                var range = new Range(highlight.row, highlight.column, highlight.row, Infinity);
                range.id = session.addMarker(range, "ace_active-line", "screenLine");
                session.$highlightLineMarker = range;
            } else if (highlight) {
                session.$highlightLineMarker.start.row = highlight.row;
                session.$highlightLineMarker.end.row = highlight.row;
                session.$highlightLineMarker.start.column = highlight.column;
                session._signal("changeBackMarker");
            }
        };
        Editor.prototype.onSelectionChange = function(e) {
            var session = this.session;
            if (session.$selectionMarker) session.removeMarker(session.$selectionMarker);
            session.$selectionMarker = null;
            if (!this.selection.isEmpty()) {
                var range = this.selection.getRange();
                var style = this.getSelectionStyle();
                session.$selectionMarker = session.addMarker(range, "ace_selection", style);
            } else this.$updateHighlightActiveLine();
            var re = this.$highlightSelectedWord && this.$getSelectionHighLightRegexp();
            this.session.highlight(re);
            this._signal("changeSelection");
        };
        Editor.prototype.$getSelectionHighLightRegexp = function() {
            var session = this.session;
            var selection = this.getSelectionRange();
            if (selection.isEmpty() || selection.isMultiLine()) return;
            var startColumn = selection.start.column;
            var endColumn = selection.end.column;
            var line = session.getLine(selection.start.row);
            var needle = line.substring(startColumn, endColumn);
            if (needle.length > 5000 || !/[\w\d]/.test(needle)) return;
            var re = this.$search.$assembleRegExp({
                wholeWord: true,
                caseSensitive: true,
                needle: needle
            });
            var wordWithBoundary = line.substring(startColumn - 1, endColumn + 1);
            if (!re.test(wordWithBoundary)) return;
            return re;
        };
        Editor.prototype.onChangeFrontMarker = function() {
            this.renderer.updateFrontMarkers();
        };
        Editor.prototype.onChangeBackMarker = function() {
            this.renderer.updateBackMarkers();
        };
        Editor.prototype.onChangeBreakpoint = function() {
            this.renderer.updateBreakpoints();
        };
        Editor.prototype.onChangeAnnotation = function() {
            this.renderer.setAnnotations(this.session.getAnnotations());
        };
        Editor.prototype.onChangeMode = function(e) {
            this.renderer.updateText();
            this._emit("changeMode", e);
        };
        Editor.prototype.onChangeWrapLimit = function() {
            this.renderer.updateFull();
        };
        Editor.prototype.onChangeWrapMode = function() {
            this.renderer.onResize(true);
        };
        Editor.prototype.onChangeFold = function() {
            this.$updateHighlightActiveLine();
            this.renderer.updateFull();
        };
        Editor.prototype.getSelectedText = function() {
            return this.session.getTextRange(this.getSelectionRange());
        };
        Editor.prototype.getCopyText = function() {
            var text = this.getSelectedText();
            var nl = this.session.doc.getNewLineCharacter();
            var copyLine = false;
            if (!text && this.$copyWithEmptySelection) {
                copyLine = true;
                var ranges = this.selection.getAllRanges();
                for(var i = 0; i < ranges.length; i++){
                    var range = ranges[i];
                    if (i && ranges[i - 1].start.row == range.start.row) continue;
                    text += this.session.getLine(range.start.row) + nl;
                }
            }
            var e = {
                text: text
            };
            this._signal("copy", e);
            clipboard.lineMode = copyLine ? e.text : false;
            return e.text;
        };
        Editor.prototype.onCopy = function() {
            this.commands.exec("copy", this);
        };
        Editor.prototype.onCut = function() {
            this.commands.exec("cut", this);
        };
        Editor.prototype.onPaste = function(text, event) {
            var e = {
                text: text,
                event: event
            };
            this.commands.exec("paste", this, e);
        };
        Editor.prototype.$handlePaste = function(e) {
            if (typeof e == "string") e = {
                text: e
            };
            this._signal("paste", e);
            var text = e.text;
            var lineMode = text === clipboard.lineMode;
            var session = this.session;
            if (!this.inMultiSelectMode || this.inVirtualSelectionMode) {
                if (lineMode) session.insert({
                    row: this.selection.lead.row,
                    column: 0
                }, text);
                else this.insert(text);
            } else if (lineMode) this.selection.rangeList.ranges.forEach(function(range) {
                session.insert({
                    row: range.start.row,
                    column: 0
                }, text);
            });
            else {
                var lines = text.split(/\r\n|\r|\n/);
                var ranges = this.selection.rangeList.ranges;
                var isFullLine = lines.length == 2 && (!lines[0] || !lines[1]);
                if (lines.length != ranges.length || isFullLine) return this.commands.exec("insertstring", this, text);
                for(var i = ranges.length; i--;){
                    var range = ranges[i];
                    if (!range.isEmpty()) session.remove(range);
                    session.insert(range.start, lines[i]);
                }
            }
        };
        Editor.prototype.execCommand = function(command, args) {
            return this.commands.exec(command, this, args);
        };
        Editor.prototype.insert = function(text, pasted) {
            var session = this.session;
            var mode = session.getMode();
            var cursor = this.getCursorPosition();
            if (this.getBehavioursEnabled() && !pasted) {
                var transform = mode.transformAction(session.getState(cursor.row), "insertion", this, session, text);
                if (transform) {
                    if (text !== transform.text) {
                        if (!this.inVirtualSelectionMode) {
                            this.session.mergeUndoDeltas = false;
                            this.mergeNextCommand = false;
                        }
                    }
                    text = transform.text;
                }
            }
            if (text == "	") text = this.session.getTabString();
            if (!this.selection.isEmpty()) {
                var range = this.getSelectionRange();
                cursor = this.session.remove(range);
                this.clearSelection();
            } else if (this.session.getOverwrite() && text.indexOf("\n") == -1) {
                var range = Range.fromPoints(cursor, cursor);
                range.end.column += text.length;
                this.session.remove(range);
            }
            if (text == "\n" || text == "\r\n") {
                var line = session.getLine(cursor.row);
                if (cursor.column > line.search(/\S|$/)) {
                    var d = line.substr(cursor.column).search(/\S|$/);
                    session.doc.removeInLine(cursor.row, cursor.column, cursor.column + d);
                }
            }
            this.clearSelection();
            var start = cursor.column;
            var lineState = session.getState(cursor.row);
            var line = session.getLine(cursor.row);
            var shouldOutdent = mode.checkOutdent(lineState, line, text);
            session.insert(cursor, text);
            if (transform && transform.selection) {
                if (transform.selection.length == 2) this.selection.setSelectionRange(new Range(cursor.row, start + transform.selection[0], cursor.row, start + transform.selection[1]));
                else this.selection.setSelectionRange(new Range(cursor.row + transform.selection[0], transform.selection[1], cursor.row + transform.selection[2], transform.selection[3]));
            }
            if (this.$enableAutoIndent) {
                if (session.getDocument().isNewLine(text)) {
                    var lineIndent = mode.getNextLineIndent(lineState, line.slice(0, cursor.column), session.getTabString());
                    session.insert({
                        row: cursor.row + 1,
                        column: 0
                    }, lineIndent);
                }
                if (shouldOutdent) mode.autoOutdent(lineState, session, cursor.row);
            }
        };
        Editor.prototype.autoIndent = function() {
            var session = this.session;
            var mode = session.getMode();
            var ranges = this.selection.isEmpty() ? [
                new Range(0, 0, session.doc.getLength() - 1, 0)
            ] : this.selection.getAllRanges();
            var prevLineState = "";
            var prevLine = "";
            var lineIndent = "";
            var tab = session.getTabString();
            for(var i = 0; i < ranges.length; i++){
                var startRow = ranges[i].start.row;
                var endRow = ranges[i].end.row;
                for(var row = startRow; row <= endRow; row++){
                    if (row > 0) {
                        prevLineState = session.getState(row - 1);
                        prevLine = session.getLine(row - 1);
                        lineIndent = mode.getNextLineIndent(prevLineState, prevLine, tab);
                    }
                    var line = session.getLine(row);
                    var currIndent = mode.$getIndent(line);
                    if (lineIndent !== currIndent) {
                        if (currIndent.length > 0) {
                            var range = new Range(row, 0, row, currIndent.length);
                            session.remove(range);
                        }
                        if (lineIndent.length > 0) session.insert({
                            row: row,
                            column: 0
                        }, lineIndent);
                    }
                    mode.autoOutdent(prevLineState, session, row);
                }
            }
        };
        Editor.prototype.onTextInput = function(text, composition) {
            if (!composition) return this.keyBinding.onTextInput(text);
            this.startOperation({
                command: {
                    name: "insertstring"
                }
            });
            var applyComposition = this.applyComposition.bind(this, text, composition);
            if (this.selection.rangeCount) this.forEachSelection(applyComposition);
            else applyComposition();
            this.endOperation();
        };
        Editor.prototype.applyComposition = function(text, composition) {
            if (composition.extendLeft || composition.extendRight) {
                var r = this.selection.getRange();
                r.start.column -= composition.extendLeft;
                r.end.column += composition.extendRight;
                if (r.start.column < 0) {
                    r.start.row--;
                    r.start.column += this.session.getLine(r.start.row).length + 1;
                }
                this.selection.setRange(r);
                if (!text && !r.isEmpty()) this.remove();
            }
            if (text || !this.selection.isEmpty()) this.insert(text, true);
            if (composition.restoreStart || composition.restoreEnd) {
                var r = this.selection.getRange();
                r.start.column -= composition.restoreStart;
                r.end.column -= composition.restoreEnd;
                this.selection.setRange(r);
            }
        };
        Editor.prototype.onCommandKey = function(e, hashId, keyCode) {
            return this.keyBinding.onCommandKey(e, hashId, keyCode);
        };
        Editor.prototype.setOverwrite = function(overwrite) {
            this.session.setOverwrite(overwrite);
        };
        Editor.prototype.getOverwrite = function() {
            return this.session.getOverwrite();
        };
        Editor.prototype.toggleOverwrite = function() {
            this.session.toggleOverwrite();
        };
        Editor.prototype.setScrollSpeed = function(speed) {
            this.setOption("scrollSpeed", speed);
        };
        Editor.prototype.getScrollSpeed = function() {
            return this.getOption("scrollSpeed");
        };
        Editor.prototype.setDragDelay = function(dragDelay) {
            this.setOption("dragDelay", dragDelay);
        };
        Editor.prototype.getDragDelay = function() {
            return this.getOption("dragDelay");
        };
        Editor.prototype.setSelectionStyle = function(val) {
            this.setOption("selectionStyle", val);
        };
        Editor.prototype.getSelectionStyle = function() {
            return this.getOption("selectionStyle");
        };
        Editor.prototype.setHighlightActiveLine = function(shouldHighlight) {
            this.setOption("highlightActiveLine", shouldHighlight);
        };
        Editor.prototype.getHighlightActiveLine = function() {
            return this.getOption("highlightActiveLine");
        };
        Editor.prototype.setHighlightGutterLine = function(shouldHighlight) {
            this.setOption("highlightGutterLine", shouldHighlight);
        };
        Editor.prototype.getHighlightGutterLine = function() {
            return this.getOption("highlightGutterLine");
        };
        Editor.prototype.setHighlightSelectedWord = function(shouldHighlight) {
            this.setOption("highlightSelectedWord", shouldHighlight);
        };
        Editor.prototype.getHighlightSelectedWord = function() {
            return this.$highlightSelectedWord;
        };
        Editor.prototype.setAnimatedScroll = function(shouldAnimate) {
            this.renderer.setAnimatedScroll(shouldAnimate);
        };
        Editor.prototype.getAnimatedScroll = function() {
            return this.renderer.getAnimatedScroll();
        };
        Editor.prototype.setShowInvisibles = function(showInvisibles) {
            this.renderer.setShowInvisibles(showInvisibles);
        };
        Editor.prototype.getShowInvisibles = function() {
            return this.renderer.getShowInvisibles();
        };
        Editor.prototype.setDisplayIndentGuides = function(display) {
            this.renderer.setDisplayIndentGuides(display);
        };
        Editor.prototype.getDisplayIndentGuides = function() {
            return this.renderer.getDisplayIndentGuides();
        };
        Editor.prototype.setHighlightIndentGuides = function(highlight) {
            this.renderer.setHighlightIndentGuides(highlight);
        };
        Editor.prototype.getHighlightIndentGuides = function() {
            return this.renderer.getHighlightIndentGuides();
        };
        Editor.prototype.setShowPrintMargin = function(showPrintMargin) {
            this.renderer.setShowPrintMargin(showPrintMargin);
        };
        Editor.prototype.getShowPrintMargin = function() {
            return this.renderer.getShowPrintMargin();
        };
        Editor.prototype.setPrintMarginColumn = function(showPrintMargin) {
            this.renderer.setPrintMarginColumn(showPrintMargin);
        };
        Editor.prototype.getPrintMarginColumn = function() {
            return this.renderer.getPrintMarginColumn();
        };
        Editor.prototype.setReadOnly = function(readOnly) {
            this.setOption("readOnly", readOnly);
        };
        Editor.prototype.getReadOnly = function() {
            return this.getOption("readOnly");
        };
        Editor.prototype.setBehavioursEnabled = function(enabled) {
            this.setOption("behavioursEnabled", enabled);
        };
        Editor.prototype.getBehavioursEnabled = function() {
            return this.getOption("behavioursEnabled");
        };
        Editor.prototype.setWrapBehavioursEnabled = function(enabled) {
            this.setOption("wrapBehavioursEnabled", enabled);
        };
        Editor.prototype.getWrapBehavioursEnabled = function() {
            return this.getOption("wrapBehavioursEnabled");
        };
        Editor.prototype.setShowFoldWidgets = function(show) {
            this.setOption("showFoldWidgets", show);
        };
        Editor.prototype.getShowFoldWidgets = function() {
            return this.getOption("showFoldWidgets");
        };
        Editor.prototype.setFadeFoldWidgets = function(fade) {
            this.setOption("fadeFoldWidgets", fade);
        };
        Editor.prototype.getFadeFoldWidgets = function() {
            return this.getOption("fadeFoldWidgets");
        };
        Editor.prototype.remove = function(dir) {
            if (this.selection.isEmpty()) {
                if (dir == "left") this.selection.selectLeft();
                else this.selection.selectRight();
            }
            var range = this.getSelectionRange();
            if (this.getBehavioursEnabled()) {
                var session = this.session;
                var state = session.getState(range.start.row);
                var new_range = session.getMode().transformAction(state, "deletion", this, session, range);
                if (range.end.column === 0) {
                    var text = session.getTextRange(range);
                    if (text[text.length - 1] == "\n") {
                        var line = session.getLine(range.end.row);
                        if (/^\s+$/.test(line)) range.end.column = line.length;
                    }
                }
                if (new_range) range = new_range;
            }
            this.session.remove(range);
            this.clearSelection();
        };
        Editor.prototype.removeWordRight = function() {
            if (this.selection.isEmpty()) this.selection.selectWordRight();
            this.session.remove(this.getSelectionRange());
            this.clearSelection();
        };
        Editor.prototype.removeWordLeft = function() {
            if (this.selection.isEmpty()) this.selection.selectWordLeft();
            this.session.remove(this.getSelectionRange());
            this.clearSelection();
        };
        Editor.prototype.removeToLineStart = function() {
            if (this.selection.isEmpty()) this.selection.selectLineStart();
            if (this.selection.isEmpty()) this.selection.selectLeft();
            this.session.remove(this.getSelectionRange());
            this.clearSelection();
        };
        Editor.prototype.removeToLineEnd = function() {
            if (this.selection.isEmpty()) this.selection.selectLineEnd();
            var range = this.getSelectionRange();
            if (range.start.column == range.end.column && range.start.row == range.end.row) {
                range.end.column = 0;
                range.end.row++;
            }
            this.session.remove(range);
            this.clearSelection();
        };
        Editor.prototype.splitLine = function() {
            if (!this.selection.isEmpty()) {
                this.session.remove(this.getSelectionRange());
                this.clearSelection();
            }
            var cursor = this.getCursorPosition();
            this.insert("\n");
            this.moveCursorToPosition(cursor);
        };
        Editor.prototype.setGhostText = function(text, position) {
            if (!this.session.widgetManager) {
                this.session.widgetManager = new LineWidgets(this.session);
                this.session.widgetManager.attach(this);
            }
            this.renderer.setGhostText(text, position);
        };
        Editor.prototype.removeGhostText = function() {
            if (!this.session.widgetManager) return;
            this.renderer.removeGhostText();
        };
        Editor.prototype.transposeLetters = function() {
            if (!this.selection.isEmpty()) return;
            var cursor = this.getCursorPosition();
            var column = cursor.column;
            if (column === 0) return;
            var line = this.session.getLine(cursor.row);
            var swap, range;
            if (column < line.length) {
                swap = line.charAt(column) + line.charAt(column - 1);
                range = new Range(cursor.row, column - 1, cursor.row, column + 1);
            } else {
                swap = line.charAt(column - 1) + line.charAt(column - 2);
                range = new Range(cursor.row, column - 2, cursor.row, column);
            }
            this.session.replace(range, swap);
            this.session.selection.moveToPosition(range.end);
        };
        Editor.prototype.toLowerCase = function() {
            var originalRange = this.getSelectionRange();
            if (this.selection.isEmpty()) this.selection.selectWord();
            var range = this.getSelectionRange();
            var text = this.session.getTextRange(range);
            this.session.replace(range, text.toLowerCase());
            this.selection.setSelectionRange(originalRange);
        };
        Editor.prototype.toUpperCase = function() {
            var originalRange = this.getSelectionRange();
            if (this.selection.isEmpty()) this.selection.selectWord();
            var range = this.getSelectionRange();
            var text = this.session.getTextRange(range);
            this.session.replace(range, text.toUpperCase());
            this.selection.setSelectionRange(originalRange);
        };
        Editor.prototype.indent = function() {
            var session = this.session;
            var range = this.getSelectionRange();
            if (range.start.row < range.end.row) {
                var rows = this.$getSelectedRows();
                session.indentRows(rows.first, rows.last, "	");
                return;
            } else if (range.start.column < range.end.column) {
                var text = session.getTextRange(range);
                if (!/^\s+$/.test(text)) {
                    var rows = this.$getSelectedRows();
                    session.indentRows(rows.first, rows.last, "	");
                    return;
                }
            }
            var line = session.getLine(range.start.row);
            var position = range.start;
            var size = session.getTabSize();
            var column = session.documentToScreenColumn(position.row, position.column);
            if (this.session.getUseSoftTabs()) {
                var count = size - column % size;
                var indentString = lang.stringRepeat(" ", count);
            } else {
                var count = column % size;
                while(line[range.start.column - 1] == " " && count){
                    range.start.column--;
                    count--;
                }
                this.selection.setSelectionRange(range);
                indentString = "	";
            }
            return this.insert(indentString);
        };
        Editor.prototype.blockIndent = function() {
            var rows = this.$getSelectedRows();
            this.session.indentRows(rows.first, rows.last, "	");
        };
        Editor.prototype.blockOutdent = function() {
            var selection = this.session.getSelection();
            this.session.outdentRows(selection.getRange());
        };
        Editor.prototype.sortLines = function() {
            var rows = this.$getSelectedRows();
            var session = this.session;
            var lines = [];
            for(var i = rows.first; i <= rows.last; i++)lines.push(session.getLine(i));
            lines.sort(function(a, b) {
                if (a.toLowerCase() < b.toLowerCase()) return -1;
                if (a.toLowerCase() > b.toLowerCase()) return 1;
                return 0;
            });
            var deleteRange = new Range(0, 0, 0, 0);
            for(var i = rows.first; i <= rows.last; i++){
                var line = session.getLine(i);
                deleteRange.start.row = i;
                deleteRange.end.row = i;
                deleteRange.end.column = line.length;
                session.replace(deleteRange, lines[i - rows.first]);
            }
        };
        Editor.prototype.toggleCommentLines = function() {
            var state = this.session.getState(this.getCursorPosition().row);
            var rows = this.$getSelectedRows();
            this.session.getMode().toggleCommentLines(state, this.session, rows.first, rows.last);
        };
        Editor.prototype.toggleBlockComment = function() {
            var cursor = this.getCursorPosition();
            var state = this.session.getState(cursor.row);
            var range = this.getSelectionRange();
            this.session.getMode().toggleBlockComment(state, this.session, range, cursor);
        };
        Editor.prototype.getNumberAt = function(row, column) {
            var _numberRx = /[\-]?[0-9]+(?:\.[0-9]+)?/g;
            _numberRx.lastIndex = 0;
            var s = this.session.getLine(row);
            while(_numberRx.lastIndex < column){
                var m = _numberRx.exec(s);
                if (m.index <= column && m.index + m[0].length >= column) {
                    var number = {
                        value: m[0],
                        start: m.index,
                        end: m.index + m[0].length
                    };
                    return number;
                }
            }
            return null;
        };
        Editor.prototype.modifyNumber = function(amount) {
            var row = this.selection.getCursor().row;
            var column = this.selection.getCursor().column;
            var charRange = new Range(row, column - 1, row, column);
            var c = this.session.getTextRange(charRange);
            if (!isNaN(parseFloat(c)) && isFinite(c)) {
                var nr = this.getNumberAt(row, column);
                if (nr) {
                    var fp = nr.value.indexOf(".") >= 0 ? nr.start + nr.value.indexOf(".") + 1 : nr.end;
                    var decimals = nr.start + nr.value.length - fp;
                    var t = parseFloat(nr.value);
                    t *= Math.pow(10, decimals);
                    if (fp !== nr.end && column < fp) amount *= Math.pow(10, nr.end - column - 1);
                    else amount *= Math.pow(10, nr.end - column);
                    t += amount;
                    t /= Math.pow(10, decimals);
                    var nnr = t.toFixed(decimals);
                    var replaceRange = new Range(row, nr.start, row, nr.end);
                    this.session.replace(replaceRange, nnr);
                    this.moveCursorTo(row, Math.max(nr.start + 1, column + nnr.length - nr.value.length));
                }
            } else this.toggleWord();
        };
        Editor.prototype.toggleWord = function() {
            var row = this.selection.getCursor().row;
            var column = this.selection.getCursor().column;
            this.selection.selectWord();
            var currentState = this.getSelectedText();
            var currWordStart = this.selection.getWordRange().start.column;
            var wordParts = currentState.replace(/([a-z]+|[A-Z]+)(?=[A-Z_]|$)/g, "$1 ").split(/\s/);
            var delta = column - currWordStart - 1;
            if (delta < 0) delta = 0;
            var curLength = 0, itLength = 0;
            var that = this;
            if (currentState.match(/[A-Za-z0-9_]+/)) wordParts.forEach(function(item, i) {
                itLength = curLength + item.length;
                if (delta >= curLength && delta <= itLength) {
                    currentState = item;
                    that.selection.clearSelection();
                    that.moveCursorTo(row, curLength + currWordStart);
                    that.selection.selectTo(row, itLength + currWordStart);
                }
                curLength = itLength;
            });
            var wordPairs = this.$toggleWordPairs;
            var reg;
            for(var i = 0; i < wordPairs.length; i++){
                var item = wordPairs[i];
                for(var j = 0; j <= 1; j++){
                    var negate = +!j;
                    var firstCondition = currentState.match(new RegExp("^\\s?_?(" + lang.escapeRegExp(item[j]) + ")\\s?$", "i"));
                    if (firstCondition) {
                        var secondCondition = currentState.match(new RegExp("([_]|^|\\s)(" + lang.escapeRegExp(firstCondition[1]) + ")($|\\s)", "g"));
                        if (secondCondition) {
                            reg = currentState.replace(new RegExp(lang.escapeRegExp(item[j]), "i"), function(result) {
                                var res = item[negate];
                                if (result.toUpperCase() == result) res = res.toUpperCase();
                                else if (result.charAt(0).toUpperCase() == result.charAt(0)) res = res.substr(0, 0) + item[negate].charAt(0).toUpperCase() + res.substr(1);
                                return res;
                            });
                            this.insert(reg);
                            reg = "";
                        }
                    }
                }
            }
        };
        Editor.prototype.findLinkAt = function(row, column) {
            var e_1, _a;
            var line = this.session.getLine(row);
            var wordParts = line.split(/((?:https?|ftp):\/\/[\S]+)/);
            var columnPosition = column;
            if (columnPosition < 0) columnPosition = 0;
            var previousPosition = 0, currentPosition = 0, match;
            try {
                for(var wordParts_1 = __values(wordParts), wordParts_1_1 = wordParts_1.next(); !wordParts_1_1.done; wordParts_1_1 = wordParts_1.next()){
                    var item = wordParts_1_1.value;
                    currentPosition = previousPosition + item.length;
                    if (columnPosition >= previousPosition && columnPosition <= currentPosition) {
                        if (item.match(/((?:https?|ftp):\/\/[\S]+)/)) {
                            match = item.replace(/[\s:.,'";}\]]+$/, "");
                            break;
                        }
                    }
                    previousPosition = currentPosition;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (wordParts_1_1 && !wordParts_1_1.done && (_a = wordParts_1.return)) _a.call(wordParts_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return match;
        };
        Editor.prototype.openLink = function() {
            var cursor = this.selection.getCursor();
            var url = this.findLinkAt(cursor.row, cursor.column);
            if (url) window.open(url, "_blank");
            return url != null;
        };
        Editor.prototype.removeLines = function() {
            var rows = this.$getSelectedRows();
            this.session.removeFullLines(rows.first, rows.last);
            this.clearSelection();
        };
        Editor.prototype.duplicateSelection = function() {
            var sel = this.selection;
            var doc = this.session;
            var range = sel.getRange();
            var reverse = sel.isBackwards();
            if (range.isEmpty()) {
                var row = range.start.row;
                doc.duplicateLines(row, row);
            } else {
                var point = reverse ? range.start : range.end;
                var endPoint = doc.insert(point, doc.getTextRange(range));
                range.start = point;
                range.end = endPoint;
                sel.setSelectionRange(range, reverse);
            }
        };
        Editor.prototype.moveLinesDown = function() {
            this.$moveLines(1, false);
        };
        Editor.prototype.moveLinesUp = function() {
            this.$moveLines(-1, false);
        };
        Editor.prototype.moveText = function(range, toPosition, copy) {
            return this.session.moveText(range, toPosition, copy);
        };
        Editor.prototype.copyLinesUp = function() {
            this.$moveLines(-1, true);
        };
        Editor.prototype.copyLinesDown = function() {
            this.$moveLines(1, true);
        };
        Editor.prototype.$moveLines = function(dir, copy) {
            var rows, moved;
            var selection = this.selection;
            if (!selection.inMultiSelectMode || this.inVirtualSelectionMode) {
                var range = selection.toOrientedRange();
                rows = this.$getSelectedRows(range);
                moved = this.session.$moveLines(rows.first, rows.last, copy ? 0 : dir);
                if (copy && dir == -1) moved = 0;
                range.moveBy(moved, 0);
                selection.fromOrientedRange(range);
            } else {
                var ranges = selection.rangeList.ranges;
                selection.rangeList.detach(this.session);
                this.inVirtualSelectionMode = true;
                var diff = 0;
                var totalDiff = 0;
                var l = ranges.length;
                for(var i = 0; i < l; i++){
                    var rangeIndex = i;
                    ranges[i].moveBy(diff, 0);
                    rows = this.$getSelectedRows(ranges[i]);
                    var first = rows.first;
                    var last = rows.last;
                    while(++i < l){
                        if (totalDiff) ranges[i].moveBy(totalDiff, 0);
                        var subRows = this.$getSelectedRows(ranges[i]);
                        if (copy && subRows.first != last) break;
                        else if (!copy && subRows.first > last + 1) break;
                        last = subRows.last;
                    }
                    i--;
                    diff = this.session.$moveLines(first, last, copy ? 0 : dir);
                    if (copy && dir == -1) rangeIndex = i + 1;
                    while(rangeIndex <= i){
                        ranges[rangeIndex].moveBy(diff, 0);
                        rangeIndex++;
                    }
                    if (!copy) diff = 0;
                    totalDiff += diff;
                }
                selection.fromOrientedRange(selection.ranges[0]);
                selection.rangeList.attach(this.session);
                this.inVirtualSelectionMode = false;
            }
        };
        Editor.prototype.$getSelectedRows = function(range) {
            range = (range || this.getSelectionRange()).collapseRows();
            return {
                first: this.session.getRowFoldStart(range.start.row),
                last: this.session.getRowFoldEnd(range.end.row)
            };
        };
        Editor.prototype.onCompositionStart = function(compositionState) {
            this.renderer.showComposition(compositionState);
        };
        Editor.prototype.onCompositionUpdate = function(text) {
            this.renderer.setCompositionText(text);
        };
        Editor.prototype.onCompositionEnd = function() {
            this.renderer.hideComposition();
        };
        Editor.prototype.getFirstVisibleRow = function() {
            return this.renderer.getFirstVisibleRow();
        };
        Editor.prototype.getLastVisibleRow = function() {
            return this.renderer.getLastVisibleRow();
        };
        Editor.prototype.isRowVisible = function(row) {
            return row >= this.getFirstVisibleRow() && row <= this.getLastVisibleRow();
        };
        Editor.prototype.isRowFullyVisible = function(row) {
            return row >= this.renderer.getFirstFullyVisibleRow() && row <= this.renderer.getLastFullyVisibleRow();
        };
        Editor.prototype.$getVisibleRowCount = function() {
            return this.renderer.getScrollBottomRow() - this.renderer.getScrollTopRow() + 1;
        };
        Editor.prototype.$moveByPage = function(dir, select) {
            var renderer = this.renderer;
            var config = this.renderer.layerConfig;
            var rows = dir * Math.floor(config.height / config.lineHeight);
            if (select === true) this.selection.$moveSelection(function() {
                this.moveCursorBy(rows, 0);
            });
            else if (select === false) {
                this.selection.moveCursorBy(rows, 0);
                this.selection.clearSelection();
            }
            var scrollTop = renderer.scrollTop;
            renderer.scrollBy(0, rows * config.lineHeight);
            if (select != null) renderer.scrollCursorIntoView(null, 0.5);
            renderer.animateScrolling(scrollTop);
        };
        Editor.prototype.selectPageDown = function() {
            this.$moveByPage(1, true);
        };
        Editor.prototype.selectPageUp = function() {
            this.$moveByPage(-1, true);
        };
        Editor.prototype.gotoPageDown = function() {
            this.$moveByPage(1, false);
        };
        Editor.prototype.gotoPageUp = function() {
            this.$moveByPage(-1, false);
        };
        Editor.prototype.scrollPageDown = function() {
            this.$moveByPage(1);
        };
        Editor.prototype.scrollPageUp = function() {
            this.$moveByPage(-1);
        };
        Editor.prototype.scrollToRow = function(row) {
            this.renderer.scrollToRow(row);
        };
        Editor.prototype.scrollToLine = function(line, center, animate, callback) {
            this.renderer.scrollToLine(line, center, animate, callback);
        };
        Editor.prototype.centerSelection = function() {
            var range = this.getSelectionRange();
            var pos = {
                row: Math.floor(range.start.row + (range.end.row - range.start.row) / 2),
                column: Math.floor(range.start.column + (range.end.column - range.start.column) / 2)
            };
            this.renderer.alignCursor(pos, 0.5);
        };
        Editor.prototype.getCursorPosition = function() {
            return this.selection.getCursor();
        };
        Editor.prototype.getCursorPositionScreen = function() {
            return this.session.documentToScreenPosition(this.getCursorPosition());
        };
        Editor.prototype.getSelectionRange = function() {
            return this.selection.getRange();
        };
        Editor.prototype.selectAll = function() {
            this.selection.selectAll();
        };
        Editor.prototype.clearSelection = function() {
            this.selection.clearSelection();
        };
        Editor.prototype.moveCursorTo = function(row, column) {
            this.selection.moveCursorTo(row, column);
        };
        Editor.prototype.moveCursorToPosition = function(pos) {
            this.selection.moveCursorToPosition(pos);
        };
        Editor.prototype.jumpToMatching = function(select, expand) {
            var cursor = this.getCursorPosition();
            var iterator = new TokenIterator(this.session, cursor.row, cursor.column);
            var prevToken = iterator.getCurrentToken();
            var tokenCount = 0;
            if (prevToken && prevToken.type.indexOf("tag-name") !== -1) prevToken = iterator.stepBackward();
            var token = prevToken || iterator.stepForward();
            if (!token) return;
            var matchType;
            var found = false;
            var depth = {};
            var i = cursor.column - token.start;
            var bracketType;
            var brackets = {
                ")": "(",
                "(": "(",
                "]": "[",
                "[": "[",
                "{": "{",
                "}": "{"
            };
            do {
                if (token.value.match(/[{}()\[\]]/g)) for(; i < token.value.length && !found; i++){
                    if (!brackets[token.value[i]]) continue;
                    bracketType = brackets[token.value[i]] + "." + token.type.replace("rparen", "lparen");
                    if (isNaN(depth[bracketType])) depth[bracketType] = 0;
                    switch(token.value[i]){
                        case "(":
                        case "[":
                        case "{":
                            depth[bracketType]++;
                            break;
                        case ")":
                        case "]":
                        case "}":
                            depth[bracketType]--;
                            if (depth[bracketType] === -1) {
                                matchType = "bracket";
                                found = true;
                            }
                            break;
                    }
                }
                else if (token.type.indexOf("tag-name") !== -1) {
                    if (isNaN(depth[token.value])) depth[token.value] = 0;
                    if (prevToken.value === "<" && tokenCount > 1) depth[token.value]++;
                    else if (prevToken.value === "</") depth[token.value]--;
                    if (depth[token.value] === -1) {
                        matchType = "tag";
                        found = true;
                    }
                }
                if (!found) {
                    prevToken = token;
                    tokenCount++;
                    token = iterator.stepForward();
                    i = 0;
                }
            }while (token && !found);
            if (!matchType) return;
            var range, pos;
            if (matchType === "bracket") {
                range = this.session.getBracketRange(cursor);
                if (!range) {
                    range = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + i - 1, iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + i - 1);
                    pos = range.start;
                    if (expand || pos.row === cursor.row && Math.abs(pos.column - cursor.column) < 2) range = this.session.getBracketRange(pos);
                }
            } else if (matchType === "tag") {
                if (!token || token.type.indexOf("tag-name") === -1) return;
                range = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() - 2, iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() - 2);
                if (range.compare(cursor.row, cursor.column) === 0) {
                    var tagsRanges = this.session.getMatchingTags(cursor);
                    if (tagsRanges) {
                        if (tagsRanges.openTag.contains(cursor.row, cursor.column)) {
                            range = tagsRanges.closeTag;
                            pos = range.start;
                        } else {
                            range = tagsRanges.openTag;
                            if (tagsRanges.closeTag.start.row === cursor.row && tagsRanges.closeTag.start.column === cursor.column) pos = range.end;
                            else pos = range.start;
                        }
                    }
                }
                pos = pos || range.start;
            }
            pos = range && range.cursor || pos;
            if (pos) {
                if (select) {
                    if (range && expand) this.selection.setRange(range);
                    else if (range && range.isEqual(this.getSelectionRange())) this.clearSelection();
                    else this.selection.selectTo(pos.row, pos.column);
                } else this.selection.moveTo(pos.row, pos.column);
            }
        };
        Editor.prototype.gotoLine = function(lineNumber, column, animate) {
            this.selection.clearSelection();
            this.session.unfold({
                row: lineNumber - 1,
                column: column || 0
            });
            this.exitMultiSelectMode && this.exitMultiSelectMode();
            this.moveCursorTo(lineNumber - 1, column || 0);
            if (!this.isRowFullyVisible(lineNumber - 1)) this.scrollToLine(lineNumber - 1, true, animate);
        };
        Editor.prototype.navigateTo = function(row, column) {
            this.selection.moveTo(row, column);
        };
        Editor.prototype.navigateUp = function(times) {
            if (this.selection.isMultiLine() && !this.selection.isBackwards()) {
                var selectionStart = this.selection.anchor.getPosition();
                return this.moveCursorToPosition(selectionStart);
            }
            this.selection.clearSelection();
            this.selection.moveCursorBy(-times || -1, 0);
        };
        Editor.prototype.navigateDown = function(times) {
            if (this.selection.isMultiLine() && this.selection.isBackwards()) {
                var selectionEnd = this.selection.anchor.getPosition();
                return this.moveCursorToPosition(selectionEnd);
            }
            this.selection.clearSelection();
            this.selection.moveCursorBy(times || 1, 0);
        };
        Editor.prototype.navigateLeft = function(times) {
            if (!this.selection.isEmpty()) {
                var selectionStart = this.getSelectionRange().start;
                this.moveCursorToPosition(selectionStart);
            } else {
                times = times || 1;
                while(times--)this.selection.moveCursorLeft();
            }
            this.clearSelection();
        };
        Editor.prototype.navigateRight = function(times) {
            if (!this.selection.isEmpty()) {
                var selectionEnd = this.getSelectionRange().end;
                this.moveCursorToPosition(selectionEnd);
            } else {
                times = times || 1;
                while(times--)this.selection.moveCursorRight();
            }
            this.clearSelection();
        };
        Editor.prototype.navigateLineStart = function() {
            this.selection.moveCursorLineStart();
            this.clearSelection();
        };
        Editor.prototype.navigateLineEnd = function() {
            this.selection.moveCursorLineEnd();
            this.clearSelection();
        };
        Editor.prototype.navigateFileEnd = function() {
            this.selection.moveCursorFileEnd();
            this.clearSelection();
        };
        Editor.prototype.navigateFileStart = function() {
            this.selection.moveCursorFileStart();
            this.clearSelection();
        };
        Editor.prototype.navigateWordRight = function() {
            this.selection.moveCursorWordRight();
            this.clearSelection();
        };
        Editor.prototype.navigateWordLeft = function() {
            this.selection.moveCursorWordLeft();
            this.clearSelection();
        };
        Editor.prototype.replace = function(replacement, options) {
            if (options) this.$search.set(options);
            var range = this.$search.find(this.session);
            var replaced = 0;
            if (!range) return replaced;
            if (this.$tryReplace(range, replacement)) replaced = 1;
            this.selection.setSelectionRange(range);
            this.renderer.scrollSelectionIntoView(range.start, range.end);
            return replaced;
        };
        Editor.prototype.replaceAll = function(replacement, options) {
            if (options) this.$search.set(options);
            var ranges = this.$search.findAll(this.session);
            var replaced = 0;
            if (!ranges.length) return replaced;
            var selection = this.getSelectionRange();
            this.selection.moveTo(0, 0);
            for(var i = ranges.length - 1; i >= 0; --i)if (this.$tryReplace(ranges[i], replacement)) replaced++;
            this.selection.setSelectionRange(selection);
            return replaced;
        };
        Editor.prototype.$tryReplace = function(range, replacement) {
            var input = this.session.getTextRange(range);
            replacement = this.$search.replace(input, replacement);
            if (replacement !== null) {
                range.end = this.session.replace(range, replacement);
                return range;
            } else return null;
        };
        Editor.prototype.getLastSearchOptions = function() {
            return this.$search.getOptions();
        };
        Editor.prototype.find = function(needle, options, animate) {
            if (!options) options = {};
            if (typeof needle == "string" || needle instanceof RegExp) options.needle = needle;
            else if (typeof needle == "object") oop.mixin(options, needle);
            var range = this.selection.getRange();
            if (options.needle == null) {
                needle = this.session.getTextRange(range) || this.$search.$options.needle;
                if (!needle) {
                    range = this.session.getWordRange(range.start.row, range.start.column);
                    needle = this.session.getTextRange(range);
                }
                this.$search.set({
                    needle: needle
                });
            }
            this.$search.set(options);
            if (!options.start) this.$search.set({
                start: range
            });
            var newRange = this.$search.find(this.session);
            if (options.preventScroll) return newRange;
            if (newRange) {
                this.revealRange(newRange, animate);
                return newRange;
            }
            if (options.backwards) range.start = range.end;
            else range.end = range.start;
            this.selection.setRange(range);
        };
        Editor.prototype.findNext = function(options, animate) {
            this.find({
                skipCurrent: true,
                backwards: false
            }, options, animate);
        };
        Editor.prototype.findPrevious = function(options, animate) {
            this.find(options, {
                skipCurrent: true,
                backwards: true
            }, animate);
        };
        Editor.prototype.revealRange = function(range, animate) {
            this.session.unfold(range);
            this.selection.setSelectionRange(range);
            var scrollTop = this.renderer.scrollTop;
            this.renderer.scrollSelectionIntoView(range.start, range.end, 0.5);
            if (animate !== false) this.renderer.animateScrolling(scrollTop);
        };
        Editor.prototype.undo = function() {
            this.session.getUndoManager().undo(this.session);
            this.renderer.scrollCursorIntoView(null, 0.5);
        };
        Editor.prototype.redo = function() {
            this.session.getUndoManager().redo(this.session);
            this.renderer.scrollCursorIntoView(null, 0.5);
        };
        Editor.prototype.destroy = function() {
            if (this.$toDestroy) {
                this.$toDestroy.forEach(function(el) {
                    el.destroy();
                });
                this.$toDestroy = null;
            }
            if (this.$mouseHandler) this.$mouseHandler.destroy();
            this.renderer.destroy();
            this._signal("destroy", this);
            if (this.session) this.session.destroy();
            if (this._$emitInputEvent) this._$emitInputEvent.cancel();
            this.removeAllListeners();
        };
        Editor.prototype.setAutoScrollEditorIntoView = function(enable) {
            if (!enable) return;
            var rect;
            var self1 = this;
            var shouldScroll = false;
            if (!this.$scrollAnchor) this.$scrollAnchor = document.createElement("div");
            var scrollAnchor = this.$scrollAnchor;
            scrollAnchor.style.cssText = "position:absolute";
            this.container.insertBefore(scrollAnchor, this.container.firstChild);
            var onChangeSelection = this.on("changeSelection", function() {
                shouldScroll = true;
            });
            var onBeforeRender = this.renderer.on("beforeRender", function() {
                if (shouldScroll) rect = self1.renderer.container.getBoundingClientRect();
            });
            var onAfterRender = this.renderer.on("afterRender", function() {
                if (shouldScroll && rect && (self1.isFocused() || self1.searchBox && self1.searchBox.isFocused())) {
                    var renderer = self1.renderer;
                    var pos = renderer.$cursorLayer.$pixelPos;
                    var config = renderer.layerConfig;
                    var top = pos.top - config.offset;
                    if (pos.top >= 0 && top + rect.top < 0) shouldScroll = true;
                    else if (pos.top < config.height && pos.top + rect.top + config.lineHeight > window.innerHeight) shouldScroll = false;
                    else shouldScroll = null;
                    if (shouldScroll != null) {
                        scrollAnchor.style.top = top + "px";
                        scrollAnchor.style.left = pos.left + "px";
                        scrollAnchor.style.height = config.lineHeight + "px";
                        scrollAnchor.scrollIntoView(shouldScroll);
                    }
                    shouldScroll = rect = null;
                }
            });
            this.setAutoScrollEditorIntoView = function(enable) {
                if (enable) return;
                delete this.setAutoScrollEditorIntoView;
                this.off("changeSelection", onChangeSelection);
                this.renderer.off("afterRender", onAfterRender);
                this.renderer.off("beforeRender", onBeforeRender);
            };
        };
        Editor.prototype.$resetCursorStyle = function() {
            var style = this.$cursorStyle || "ace";
            var cursorLayer = this.renderer.$cursorLayer;
            if (!cursorLayer) return;
            cursorLayer.setSmoothBlinking(/smooth/.test(style));
            cursorLayer.isBlinking = !this.$readOnly && style != "wide";
            dom.setCssClass(cursorLayer.element, "ace_slim-cursors", /slim/.test(style));
        };
        Editor.prototype.prompt = function(message, options, callback) {
            var editor = this;
            config.loadModule("ace/ext/prompt", function(module1) {
                module1.prompt(editor, message, options, callback);
            });
        };
        return Editor;
    }();
    Editor.$uid = 0;
    Editor.prototype.curOp = null;
    Editor.prototype.prevOp = {};
    Editor.prototype.$mergeableCommands = [
        "backspace",
        "del",
        "insertstring"
    ];
    Editor.prototype.$toggleWordPairs = [
        [
            "first",
            "last"
        ],
        [
            "true",
            "false"
        ],
        [
            "yes",
            "no"
        ],
        [
            "width",
            "height"
        ],
        [
            "top",
            "bottom"
        ],
        [
            "right",
            "left"
        ],
        [
            "on",
            "off"
        ],
        [
            "x",
            "y"
        ],
        [
            "get",
            "set"
        ],
        [
            "max",
            "min"
        ],
        [
            "horizontal",
            "vertical"
        ],
        [
            "show",
            "hide"
        ],
        [
            "add",
            "remove"
        ],
        [
            "up",
            "down"
        ],
        [
            "before",
            "after"
        ],
        [
            "even",
            "odd"
        ],
        [
            "in",
            "out"
        ],
        [
            "inside",
            "outside"
        ],
        [
            "next",
            "previous"
        ],
        [
            "increase",
            "decrease"
        ],
        [
            "attach",
            "detach"
        ],
        [
            "&&",
            "||"
        ],
        [
            "==",
            "!="
        ]
    ];
    oop.implement(Editor.prototype, EventEmitter);
    config.defineOptions(Editor.prototype, "editor", {
        selectionStyle: {
            set: function(style) {
                this.onSelectionChange();
                this._signal("changeSelectionStyle", {
                    data: style
                });
            },
            initialValue: "line"
        },
        highlightActiveLine: {
            set: function() {
                this.$updateHighlightActiveLine();
            },
            initialValue: true
        },
        highlightSelectedWord: {
            set: function(shouldHighlight) {
                this.$onSelectionChange();
            },
            initialValue: true
        },
        readOnly: {
            set: function(readOnly) {
                this.textInput.setReadOnly(readOnly);
                this.$resetCursorStyle();
            },
            initialValue: false
        },
        copyWithEmptySelection: {
            set: function(value) {
                this.textInput.setCopyWithEmptySelection(value);
            },
            initialValue: false
        },
        cursorStyle: {
            set: function(val) {
                this.$resetCursorStyle();
            },
            values: [
                "ace",
                "slim",
                "smooth",
                "wide"
            ],
            initialValue: "ace"
        },
        mergeUndoDeltas: {
            values: [
                false,
                true,
                "always"
            ],
            initialValue: true
        },
        behavioursEnabled: {
            initialValue: true
        },
        wrapBehavioursEnabled: {
            initialValue: true
        },
        enableAutoIndent: {
            initialValue: true
        },
        autoScrollEditorIntoView: {
            set: function(val) {
                this.setAutoScrollEditorIntoView(val);
            }
        },
        keyboardHandler: {
            set: function(val) {
                this.setKeyboardHandler(val);
            },
            get: function() {
                return this.$keybindingId;
            },
            handlesSet: true
        },
        value: {
            set: function(val) {
                this.session.setValue(val);
            },
            get: function() {
                return this.getValue();
            },
            handlesSet: true,
            hidden: true
        },
        session: {
            set: function(val) {
                this.setSession(val);
            },
            get: function() {
                return this.session;
            },
            handlesSet: true,
            hidden: true
        },
        showLineNumbers: {
            set: function(show) {
                this.renderer.$gutterLayer.setShowLineNumbers(show);
                this.renderer.$loop.schedule(this.renderer.CHANGE_GUTTER);
                if (show && this.$relativeLineNumbers) relativeNumberRenderer.attach(this);
                else relativeNumberRenderer.detach(this);
            },
            initialValue: true
        },
        relativeLineNumbers: {
            set: function(value) {
                if (this.$showLineNumbers && value) relativeNumberRenderer.attach(this);
                else relativeNumberRenderer.detach(this);
            }
        },
        placeholder: {
            set: function(message) {
                if (!this.$updatePlaceholder) {
                    this.$updatePlaceholder = (function() {
                        var hasValue = this.session && (this.renderer.$composition || this.session.getLength() > 1 || this.session.getLine(0).length > 0);
                        if (hasValue && this.renderer.placeholderNode) {
                            this.renderer.off("afterRender", this.$updatePlaceholder);
                            dom.removeCssClass(this.container, "ace_hasPlaceholder");
                            this.renderer.placeholderNode.remove();
                            this.renderer.placeholderNode = null;
                        } else if (!hasValue && !this.renderer.placeholderNode) {
                            this.renderer.on("afterRender", this.$updatePlaceholder);
                            dom.addCssClass(this.container, "ace_hasPlaceholder");
                            var el = dom.createElement("div");
                            el.className = "ace_placeholder";
                            el.textContent = this.$placeholder || "";
                            this.renderer.placeholderNode = el;
                            this.renderer.content.appendChild(this.renderer.placeholderNode);
                        } else if (!hasValue && this.renderer.placeholderNode) this.renderer.placeholderNode.textContent = this.$placeholder || "";
                    }).bind(this);
                    this.on("input", this.$updatePlaceholder);
                }
                this.$updatePlaceholder();
            }
        },
        enableKeyboardAccessibility: {
            set: function(value) {
                var blurCommand = {
                    name: "blurTextInput",
                    description: "Set focus to the editor content div to allow tabbing through the page",
                    bindKey: "Esc",
                    exec: function(editor) {
                        editor.blur();
                        editor.renderer.scroller.focus();
                    },
                    readOnly: true
                };
                var focusOnEnterKeyup = function(e) {
                    if (e.target == this.renderer.scroller && e.keyCode === keys["enter"]) {
                        e.preventDefault();
                        var row = this.getCursorPosition().row;
                        if (!this.isRowVisible(row)) this.scrollToLine(row, true, true);
                        this.focus();
                    }
                };
                var gutterKeyboardHandler;
                if (value) {
                    this.renderer.enableKeyboardAccessibility = true;
                    this.renderer.keyboardFocusClassName = "ace_keyboard-focus";
                    this.textInput.getElement().setAttribute("tabindex", -1);
                    this.textInput.setNumberOfExtraLines(useragent.isWin ? 3 : 0);
                    this.renderer.scroller.setAttribute("tabindex", 0);
                    this.renderer.scroller.setAttribute("role", "group");
                    this.renderer.scroller.setAttribute("aria-roledescription", nls("editor.scroller.aria-roledescription", "editor"));
                    this.renderer.scroller.classList.add(this.renderer.keyboardFocusClassName);
                    this.renderer.scroller.setAttribute("aria-label", nls("editor.scroller.aria-label", "Editor content, press Enter to start editing, press Escape to exit"));
                    this.renderer.scroller.addEventListener("keyup", focusOnEnterKeyup.bind(this));
                    this.commands.addCommand(blurCommand);
                    this.renderer.$gutter.setAttribute("tabindex", 0);
                    this.renderer.$gutter.setAttribute("aria-hidden", false);
                    this.renderer.$gutter.setAttribute("role", "group");
                    this.renderer.$gutter.setAttribute("aria-roledescription", nls("editor.gutter.aria-roledescription", "editor"));
                    this.renderer.$gutter.setAttribute("aria-label", nls("editor.gutter.aria-label", "Editor gutter, press Enter to interact with controls using arrow keys, press Escape to exit"));
                    this.renderer.$gutter.classList.add(this.renderer.keyboardFocusClassName);
                    this.renderer.content.setAttribute("aria-hidden", true);
                    if (!gutterKeyboardHandler) gutterKeyboardHandler = new GutterKeyboardHandler(this);
                    gutterKeyboardHandler.addListener();
                    this.textInput.setAriaOptions({
                        setLabel: true
                    });
                } else {
                    this.renderer.enableKeyboardAccessibility = false;
                    this.textInput.getElement().setAttribute("tabindex", 0);
                    this.textInput.setNumberOfExtraLines(0);
                    this.renderer.scroller.setAttribute("tabindex", -1);
                    this.renderer.scroller.removeAttribute("role");
                    this.renderer.scroller.removeAttribute("aria-roledescription");
                    this.renderer.scroller.classList.remove(this.renderer.keyboardFocusClassName);
                    this.renderer.scroller.removeAttribute("aria-label");
                    this.renderer.scroller.removeEventListener("keyup", focusOnEnterKeyup.bind(this));
                    this.commands.removeCommand(blurCommand);
                    this.renderer.content.removeAttribute("aria-hidden");
                    this.renderer.$gutter.setAttribute("tabindex", -1);
                    this.renderer.$gutter.setAttribute("aria-hidden", true);
                    this.renderer.$gutter.removeAttribute("role");
                    this.renderer.$gutter.removeAttribute("aria-roledescription");
                    this.renderer.$gutter.removeAttribute("aria-label");
                    this.renderer.$gutter.classList.remove(this.renderer.keyboardFocusClassName);
                    if (gutterKeyboardHandler) gutterKeyboardHandler.removeListener();
                }
            },
            initialValue: false
        },
        textInputAriaLabel: {
            set: function(val) {
                this.$textInputAriaLabel = val;
            },
            initialValue: ""
        },
        enableMobileMenu: {
            set: function(val) {
                this.$enableMobileMenu = val;
            },
            initialValue: true
        },
        customScrollbar: "renderer",
        hScrollBarAlwaysVisible: "renderer",
        vScrollBarAlwaysVisible: "renderer",
        highlightGutterLine: "renderer",
        animatedScroll: "renderer",
        showInvisibles: "renderer",
        showPrintMargin: "renderer",
        printMarginColumn: "renderer",
        printMargin: "renderer",
        fadeFoldWidgets: "renderer",
        showFoldWidgets: "renderer",
        displayIndentGuides: "renderer",
        highlightIndentGuides: "renderer",
        showGutter: "renderer",
        fontSize: "renderer",
        fontFamily: "renderer",
        maxLines: "renderer",
        minLines: "renderer",
        scrollPastEnd: "renderer",
        fixedWidthGutter: "renderer",
        theme: "renderer",
        hasCssTransforms: "renderer",
        maxPixelHeight: "renderer",
        useTextareaForIME: "renderer",
        useResizeObserver: "renderer",
        useSvgGutterIcons: "renderer",
        showFoldedAnnotations: "renderer",
        scrollSpeed: "$mouseHandler",
        dragDelay: "$mouseHandler",
        dragEnabled: "$mouseHandler",
        focusTimeout: "$mouseHandler",
        tooltipFollowsMouse: "$mouseHandler",
        firstLineNumber: "session",
        overwrite: "session",
        newLineMode: "session",
        useWorker: "session",
        useSoftTabs: "session",
        navigateWithinSoftTabs: "session",
        tabSize: "session",
        wrap: "session",
        indentedSoftWrap: "session",
        foldStyle: "session",
        mode: "session"
    });
    var relativeNumberRenderer = {
        getText: function(/**@type{EditSession}*/ session, /**@type{number}*/ row) {
            return (Math.abs(session.selection.lead.row - row) || row + 1 + (row < 9 ? "\xb7" : "")) + "";
        },
        getWidth: function(session, /**@type{number}*/ lastLineNumber, config) {
            return Math.max(lastLineNumber.toString().length, (config.lastRow + 1).toString().length, 2) * config.characterWidth;
        },
        update: function(e, /**@type{Editor}*/ editor) {
            editor.renderer.$loop.schedule(editor.renderer.CHANGE_GUTTER);
        },
        attach: function(/**@type{Editor}*/ editor) {
            editor.renderer.$gutterLayer.$renderer = this;
            editor.on("changeSelection", this.update);
            this.update(null, editor);
        },
        detach: function(/**@type{Editor}*/ editor) {
            if (editor.renderer.$gutterLayer.$renderer == this) editor.renderer.$gutterLayer.$renderer = null;
            editor.off("changeSelection", this.update);
            this.update(null, editor);
        }
    };
    exports.Editor = Editor;
});
ace.define("ace/layer/lines", [
    "require",
    "exports",
    "module",
    "ace/lib/dom"
], function(require, exports, module1) {
    "use strict";
    var dom = require("../lib/dom");
    var Lines = /** @class */ function() {
        function Lines(element, canvasHeight) {
            this.element = element;
            this.canvasHeight = canvasHeight || 500000;
            this.element.style.height = this.canvasHeight * 2 + "px";
            this.cells = [];
            this.cellCache = [];
            this.$offsetCoefficient = 0;
        }
        Lines.prototype.moveContainer = function(config) {
            dom.translate(this.element, 0, -(config.firstRowScreen * config.lineHeight % this.canvasHeight) - config.offset * this.$offsetCoefficient);
        };
        Lines.prototype.pageChanged = function(oldConfig, newConfig) {
            return Math.floor(oldConfig.firstRowScreen * oldConfig.lineHeight / this.canvasHeight) !== Math.floor(newConfig.firstRowScreen * newConfig.lineHeight / this.canvasHeight);
        };
        Lines.prototype.computeLineTop = function(row, config, session) {
            var screenTop = config.firstRowScreen * config.lineHeight;
            var screenPage = Math.floor(screenTop / this.canvasHeight);
            var lineTop = session.documentToScreenRow(row, 0) * config.lineHeight;
            return lineTop - screenPage * this.canvasHeight;
        };
        Lines.prototype.computeLineHeight = function(row, config, session) {
            return config.lineHeight * session.getRowLineCount(row);
        };
        Lines.prototype.getLength = function() {
            return this.cells.length;
        };
        Lines.prototype.get = function(index) {
            return this.cells[index];
        };
        Lines.prototype.shift = function() {
            this.$cacheCell(this.cells.shift());
        };
        Lines.prototype.pop = function() {
            this.$cacheCell(this.cells.pop());
        };
        Lines.prototype.push = function(cell) {
            if (Array.isArray(cell)) {
                this.cells.push.apply(this.cells, cell);
                var fragment = dom.createFragment(this.element);
                for(var i = 0; i < cell.length; i++)fragment.appendChild(cell[i].element);
                this.element.appendChild(fragment);
            } else {
                this.cells.push(cell);
                this.element.appendChild(cell.element);
            }
        };
        Lines.prototype.unshift = function(cell) {
            if (Array.isArray(cell)) {
                this.cells.unshift.apply(this.cells, cell);
                var fragment = dom.createFragment(this.element);
                for(var i = 0; i < cell.length; i++)fragment.appendChild(cell[i].element);
                if (this.element.firstChild) this.element.insertBefore(fragment, this.element.firstChild);
                else this.element.appendChild(fragment);
            } else {
                this.cells.unshift(cell);
                this.element.insertAdjacentElement("afterbegin", cell.element);
            }
        };
        Lines.prototype.last = function() {
            if (this.cells.length) return this.cells[this.cells.length - 1];
            else return null;
        };
        Lines.prototype.$cacheCell = function(cell) {
            if (!cell) return;
            cell.element.remove();
            this.cellCache.push(cell);
        };
        Lines.prototype.createCell = function(row, config, session, initElement) {
            var cell = this.cellCache.pop();
            if (!cell) {
                var element = dom.createElement("div");
                if (initElement) initElement(element);
                this.element.appendChild(element);
                cell = {
                    element: element,
                    text: "",
                    row: row
                };
            }
            cell.row = row;
            return cell;
        };
        return Lines;
    }();
    exports.Lines = Lines;
});
ace.define("ace/layer/gutter", [
    "require",
    "exports",
    "module",
    "ace/lib/dom",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/lib/event_emitter",
    "ace/layer/lines",
    "ace/config"
], function(require, exports, module1) {
    "use strict";
    var dom = require("../lib/dom");
    var oop = require("../lib/oop");
    var lang = require("../lib/lang");
    var EventEmitter = require("../lib/event_emitter").EventEmitter;
    var Lines = require("./lines").Lines;
    var nls = require("../config").nls;
    var Gutter = /** @class */ function() {
        function Gutter(parentEl) {
            this.element = dom.createElement("div");
            this.element.className = "ace_layer ace_gutter-layer";
            parentEl.appendChild(this.element);
            this.setShowFoldWidgets(this.$showFoldWidgets);
            this.gutterWidth = 0;
            this.$annotations = [];
            this.$updateAnnotations = this.$updateAnnotations.bind(this);
            this.$lines = new Lines(this.element);
            this.$lines.$offsetCoefficient = 1;
        }
        Gutter.prototype.setSession = function(session) {
            if (this.session) this.session.off("change", this.$updateAnnotations);
            this.session = session;
            if (session) session.on("change", this.$updateAnnotations);
        };
        Gutter.prototype.addGutterDecoration = function(row, className) {
            if (window.console) console.warn && console.warn("deprecated use session.addGutterDecoration");
            this.session.addGutterDecoration(row, className);
        };
        Gutter.prototype.removeGutterDecoration = function(row, className) {
            if (window.console) console.warn && console.warn("deprecated use session.removeGutterDecoration");
            this.session.removeGutterDecoration(row, className);
        };
        Gutter.prototype.setAnnotations = function(annotations) {
            this.$annotations = [];
            for(var i = 0; i < annotations.length; i++){
                var annotation = annotations[i];
                var row = annotation.row;
                var rowInfo = this.$annotations[row];
                if (!rowInfo) rowInfo = this.$annotations[row] = {
                    text: [],
                    type: [],
                    displayText: []
                };
                var annoText = annotation.text;
                var displayAnnoText = annotation.text;
                var annoType = annotation.type;
                annoText = annoText ? lang.escapeHTML(annoText) : annotation.html || "";
                displayAnnoText = displayAnnoText ? displayAnnoText : annotation.html || "";
                if (rowInfo.text.indexOf(annoText) === -1) {
                    rowInfo.text.push(annoText);
                    rowInfo.type.push(annoType);
                    rowInfo.displayText.push(displayAnnoText);
                }
                var className = annotation.className;
                if (className) rowInfo.className = className;
                else if (annoType == "error") rowInfo.className = " ace_error";
                else if (annoType == "warning" && rowInfo.className != " ace_error") rowInfo.className = " ace_warning";
                else if (annoType == "info" && !rowInfo.className) rowInfo.className = " ace_info";
            }
        };
        Gutter.prototype.$updateAnnotations = function(delta) {
            if (!this.$annotations.length) return;
            var firstRow = delta.start.row;
            var len = delta.end.row - firstRow;
            if (len === 0) ;
            else if (delta.action == "remove") this.$annotations.splice(firstRow, len + 1, null);
            else {
                var args = new Array(len + 1);
                args.unshift(firstRow, 1);
                this.$annotations.splice.apply(this.$annotations, args);
            }
        };
        Gutter.prototype.update = function(config) {
            this.config = config;
            var session = this.session;
            var firstRow = config.firstRow;
            var lastRow = Math.min(config.lastRow + config.gutterOffset, session.getLength() - 1);
            this.oldLastRow = lastRow;
            this.config = config;
            this.$lines.moveContainer(config);
            this.$updateCursorRow();
            var fold = session.getNextFoldLine(firstRow);
            var foldStart = fold ? fold.start.row : Infinity;
            var cell = null;
            var index = -1;
            var row = firstRow;
            while(true){
                if (row > foldStart) {
                    row = fold.end.row + 1;
                    fold = session.getNextFoldLine(row, fold);
                    foldStart = fold ? fold.start.row : Infinity;
                }
                if (row > lastRow) {
                    while(this.$lines.getLength() > index + 1)this.$lines.pop();
                    break;
                }
                cell = this.$lines.get(++index);
                if (cell) cell.row = row;
                else {
                    cell = this.$lines.createCell(row, config, this.session, onCreateCell);
                    this.$lines.push(cell);
                }
                this.$renderCell(cell, config, fold, row);
                row++;
            }
            this._signal("afterRender");
            this.$updateGutterWidth(config);
        };
        Gutter.prototype.$updateGutterWidth = function(config) {
            var session = this.session;
            var gutterRenderer = session.gutterRenderer || this.$renderer;
            var firstLineNumber = session.$firstLineNumber;
            var lastLineText = this.$lines.last() ? this.$lines.last().text : "";
            if (this.$fixedWidth || session.$useWrapMode) lastLineText = session.getLength() + firstLineNumber - 1;
            var gutterWidth = gutterRenderer ? gutterRenderer.getWidth(session, lastLineText, config) : lastLineText.toString().length * config.characterWidth;
            var padding = this.$padding || this.$computePadding();
            gutterWidth += padding.left + padding.right;
            if (gutterWidth !== this.gutterWidth && !isNaN(gutterWidth)) {
                this.gutterWidth = gutterWidth;
                this.element.parentNode.style.width = this.element.style.width = Math.ceil(this.gutterWidth) + "px";
                this._signal("changeGutterWidth", gutterWidth);
            }
        };
        Gutter.prototype.$updateCursorRow = function() {
            if (!this.$highlightGutterLine) return;
            var position = this.session.selection.getCursor();
            if (this.$cursorRow === position.row) return;
            this.$cursorRow = position.row;
        };
        Gutter.prototype.updateLineHighlight = function() {
            if (!this.$highlightGutterLine) return;
            var row = this.session.selection.cursor.row;
            this.$cursorRow = row;
            if (this.$cursorCell && this.$cursorCell.row == row) return;
            if (this.$cursorCell) this.$cursorCell.element.className = this.$cursorCell.element.className.replace("ace_gutter-active-line ", "");
            var cells = this.$lines.cells;
            this.$cursorCell = null;
            for(var i = 0; i < cells.length; i++){
                var cell = cells[i];
                if (cell.row >= this.$cursorRow) {
                    if (cell.row > this.$cursorRow) {
                        var fold = this.session.getFoldLine(this.$cursorRow);
                        if (i > 0 && fold && fold.start.row == cells[i - 1].row) cell = cells[i - 1];
                        else break;
                    }
                    cell.element.className = "ace_gutter-active-line " + cell.element.className;
                    this.$cursorCell = cell;
                    break;
                }
            }
        };
        Gutter.prototype.scrollLines = function(config) {
            var oldConfig = this.config;
            this.config = config;
            this.$updateCursorRow();
            if (this.$lines.pageChanged(oldConfig, config)) return this.update(config);
            this.$lines.moveContainer(config);
            var lastRow = Math.min(config.lastRow + config.gutterOffset, this.session.getLength() - 1);
            var oldLastRow = this.oldLastRow;
            this.oldLastRow = lastRow;
            if (!oldConfig || oldLastRow < config.firstRow) return this.update(config);
            if (lastRow < oldConfig.firstRow) return this.update(config);
            if (oldConfig.firstRow < config.firstRow) for(var row = this.session.getFoldedRowCount(oldConfig.firstRow, config.firstRow - 1); row > 0; row--)this.$lines.shift();
            if (oldLastRow > lastRow) for(var row = this.session.getFoldedRowCount(lastRow + 1, oldLastRow); row > 0; row--)this.$lines.pop();
            if (config.firstRow < oldConfig.firstRow) this.$lines.unshift(this.$renderLines(config, config.firstRow, oldConfig.firstRow - 1));
            if (lastRow > oldLastRow) this.$lines.push(this.$renderLines(config, oldLastRow + 1, lastRow));
            this.updateLineHighlight();
            this._signal("afterRender");
            this.$updateGutterWidth(config);
        };
        Gutter.prototype.$renderLines = function(config, firstRow, lastRow) {
            var fragment = [];
            var row = firstRow;
            var foldLine = this.session.getNextFoldLine(row);
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            while(true){
                if (row > foldStart) {
                    row = foldLine.end.row + 1;
                    foldLine = this.session.getNextFoldLine(row, foldLine);
                    foldStart = foldLine ? foldLine.start.row : Infinity;
                }
                if (row > lastRow) break;
                var cell = this.$lines.createCell(row, config, this.session, onCreateCell);
                this.$renderCell(cell, config, foldLine, row);
                fragment.push(cell);
                row++;
            }
            return fragment;
        };
        Gutter.prototype.$renderCell = function(cell, config, fold, row) {
            var element = cell.element;
            var session = this.session;
            var textNode = element.childNodes[0];
            var foldWidget = element.childNodes[1];
            var annotationNode = element.childNodes[2];
            var annotationIconNode = annotationNode.firstChild;
            var firstLineNumber = session.$firstLineNumber;
            var breakpoints = session.$breakpoints;
            var decorations = session.$decorations;
            var gutterRenderer = session.gutterRenderer || this.$renderer;
            var foldWidgets = this.$showFoldWidgets && session.foldWidgets;
            var foldStart = fold ? fold.start.row : Number.MAX_VALUE;
            var lineHeight = config.lineHeight + "px";
            var className = this.$useSvgGutterIcons ? "ace_gutter-cell_svg-icons " : "ace_gutter-cell ";
            var iconClassName = this.$useSvgGutterIcons ? "ace_icon_svg" : "ace_icon";
            var rowText = (gutterRenderer ? gutterRenderer.getText(session, row) : row + firstLineNumber).toString();
            if (this.$highlightGutterLine) {
                if (row == this.$cursorRow || fold && row < this.$cursorRow && row >= foldStart && this.$cursorRow <= fold.end.row) {
                    className += "ace_gutter-active-line ";
                    if (this.$cursorCell != cell) {
                        if (this.$cursorCell) this.$cursorCell.element.className = this.$cursorCell.element.className.replace("ace_gutter-active-line ", "");
                        this.$cursorCell = cell;
                    }
                }
            }
            if (breakpoints[row]) className += breakpoints[row];
            if (decorations[row]) className += decorations[row];
            if (this.$annotations[row] && row !== foldStart) className += this.$annotations[row].className;
            if (foldWidgets) {
                var c = foldWidgets[row];
                if (c == null) c = foldWidgets[row] = session.getFoldWidget(row);
            }
            if (c) {
                var foldClass = "ace_fold-widget ace_" + c;
                var isClosedFold = c == "start" && row == foldStart && row < fold.end.row;
                if (isClosedFold) {
                    foldClass += " ace_closed";
                    var foldAnnotationClass = "";
                    var annotationInFold = false;
                    for(var i = row + 1; i <= fold.end.row; i++){
                        if (!this.$annotations[i]) continue;
                        if (this.$annotations[i].className === " ace_error") {
                            annotationInFold = true;
                            foldAnnotationClass = " ace_error_fold";
                            break;
                        }
                        if (this.$annotations[i].className === " ace_warning") {
                            annotationInFold = true;
                            foldAnnotationClass = " ace_warning_fold";
                            continue;
                        }
                    }
                    className += foldAnnotationClass;
                } else foldClass += " ace_open";
                if (foldWidget.className != foldClass) foldWidget.className = foldClass;
                dom.setStyle(foldWidget.style, "height", lineHeight);
                dom.setStyle(foldWidget.style, "display", "inline-block");
                foldWidget.setAttribute("role", "button");
                foldWidget.setAttribute("tabindex", "-1");
                var foldRange = session.getFoldWidgetRange(row);
                if (foldRange) foldWidget.setAttribute("aria-label", nls("gutter.code-folding.range.aria-label", "Toggle code folding, rows $0 through $1", [
                    foldRange.start.row + 1,
                    foldRange.end.row + 1
                ]));
                else if (fold) foldWidget.setAttribute("aria-label", nls("gutter.code-folding.closed.aria-label", "Toggle code folding, rows $0 through $1", [
                    fold.start.row + 1,
                    fold.end.row + 1
                ]));
                else foldWidget.setAttribute("aria-label", nls("gutter.code-folding.open.aria-label", "Toggle code folding, row $0", [
                    row + 1
                ]));
                if (isClosedFold) {
                    foldWidget.setAttribute("aria-expanded", "false");
                    foldWidget.setAttribute("title", nls("gutter.code-folding.closed.title", "Unfold code"));
                } else {
                    foldWidget.setAttribute("aria-expanded", "true");
                    foldWidget.setAttribute("title", nls("gutter.code-folding.open.title", "Fold code"));
                }
            } else if (foldWidget) {
                dom.setStyle(foldWidget.style, "display", "none");
                foldWidget.setAttribute("tabindex", "0");
                foldWidget.removeAttribute("role");
                foldWidget.removeAttribute("aria-label");
            }
            if (annotationInFold && this.$showFoldedAnnotations) {
                annotationNode.className = "ace_gutter_annotation";
                annotationIconNode.className = iconClassName;
                annotationIconNode.className += foldAnnotationClass;
                dom.setStyle(annotationIconNode.style, "height", lineHeight);
                dom.setStyle(annotationNode.style, "display", "block");
                dom.setStyle(annotationNode.style, "height", lineHeight);
                var ariaLabel;
                switch(foldAnnotationClass){
                    case " ace_error_fold":
                        ariaLabel = nls("gutter.annotation.aria-label.error", "Read annotations row $0", [
                            rowText
                        ]);
                        break;
                    case " ace_warning_fold":
                        ariaLabel = nls("gutter.annotation.aria-label.warning", "Read annotations row $0", [
                            rowText
                        ]);
                        break;
                }
                annotationNode.setAttribute("aria-label", ariaLabel);
                annotationNode.setAttribute("tabindex", "-1");
                annotationNode.setAttribute("role", "button");
            } else if (this.$annotations[row]) {
                annotationNode.className = "ace_gutter_annotation";
                annotationIconNode.className = iconClassName;
                if (this.$useSvgGutterIcons) annotationIconNode.className += this.$annotations[row].className;
                else element.classList.add(this.$annotations[row].className.replace(" ", ""));
                dom.setStyle(annotationIconNode.style, "height", lineHeight);
                dom.setStyle(annotationNode.style, "display", "block");
                dom.setStyle(annotationNode.style, "height", lineHeight);
                var ariaLabel;
                switch(this.$annotations[row].className){
                    case " ace_error":
                        ariaLabel = nls("gutter.annotation.aria-label.error", "Read annotations row $0", [
                            rowText
                        ]);
                        break;
                    case " ace_warning":
                        ariaLabel = nls("gutter.annotation.aria-label.warning", "Read annotations row $0", [
                            rowText
                        ]);
                        break;
                    case " ace_info":
                        ariaLabel = nls("gutter.annotation.aria-label.info", "Read annotations row $0", [
                            rowText
                        ]);
                        break;
                }
                annotationNode.setAttribute("aria-label", ariaLabel);
                annotationNode.setAttribute("tabindex", "-1");
                annotationNode.setAttribute("role", "button");
            } else {
                dom.setStyle(annotationNode.style, "display", "none");
                annotationNode.removeAttribute("aria-label");
                annotationNode.removeAttribute("role");
                annotationNode.setAttribute("tabindex", "0");
            }
            if (rowText !== textNode.data) textNode.data = rowText;
            if (element.className != className) element.className = className;
            dom.setStyle(cell.element.style, "height", this.$lines.computeLineHeight(row, config, session) + "px");
            dom.setStyle(cell.element.style, "top", this.$lines.computeLineTop(row, config, session) + "px");
            cell.text = rowText;
            if (annotationNode.style.display === "none" && foldWidget.style.display === "none") cell.element.setAttribute("aria-hidden", true);
            else cell.element.setAttribute("aria-hidden", false);
            return cell;
        };
        Gutter.prototype.setHighlightGutterLine = function(highlightGutterLine) {
            this.$highlightGutterLine = highlightGutterLine;
        };
        Gutter.prototype.setShowLineNumbers = function(show) {
            this.$renderer = !show && {
                getWidth: function() {
                    return 0;
                },
                getText: function() {
                    return "";
                }
            };
        };
        Gutter.prototype.getShowLineNumbers = function() {
            return this.$showLineNumbers;
        };
        Gutter.prototype.setShowFoldWidgets = function(show) {
            if (show) dom.addCssClass(this.element, "ace_folding-enabled");
            else dom.removeCssClass(this.element, "ace_folding-enabled");
            this.$showFoldWidgets = show;
            this.$padding = null;
        };
        Gutter.prototype.getShowFoldWidgets = function() {
            return this.$showFoldWidgets;
        };
        Gutter.prototype.$computePadding = function() {
            if (!this.element.firstChild) return {
                left: 0,
                right: 0
            };
            var style = dom.computedStyle(/**@type{Element}*/ this.element.firstChild);
            this.$padding = {};
            this.$padding.left = (parseInt(style.borderLeftWidth) || 0) + (parseInt(style.paddingLeft) || 0) + 1;
            this.$padding.right = (parseInt(style.borderRightWidth) || 0) + (parseInt(style.paddingRight) || 0);
            return this.$padding;
        };
        Gutter.prototype.getRegion = function(point) {
            var padding = this.$padding || this.$computePadding();
            var rect = this.element.getBoundingClientRect();
            if (point.x < padding.left + rect.left) return "markers";
            if (this.$showFoldWidgets && point.x > rect.right - padding.right) return "foldWidgets";
        };
        return Gutter;
    }();
    Gutter.prototype.$fixedWidth = false;
    Gutter.prototype.$highlightGutterLine = true;
    Gutter.prototype.$renderer = "";
    Gutter.prototype.$showLineNumbers = true;
    Gutter.prototype.$showFoldWidgets = true;
    oop.implement(Gutter.prototype, EventEmitter);
    function onCreateCell(element) {
        var textNode = document.createTextNode("");
        element.appendChild(textNode);
        var foldWidget = dom.createElement("span");
        element.appendChild(foldWidget);
        var annotationNode = dom.createElement("span");
        element.appendChild(annotationNode);
        var annotationIconNode = dom.createElement("span");
        annotationNode.appendChild(annotationIconNode);
        return element;
    }
    exports.Gutter = Gutter;
});
ace.define("ace/layer/marker", [
    "require",
    "exports",
    "module",
    "ace/range",
    "ace/lib/dom"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var dom = require("../lib/dom");
    var Marker = /** @class */ function() {
        function Marker(parentEl) {
            this.element = dom.createElement("div");
            this.element.className = "ace_layer ace_marker-layer";
            parentEl.appendChild(this.element);
        }
        Marker.prototype.setPadding = function(padding) {
            this.$padding = padding;
        };
        Marker.prototype.setSession = function(session) {
            this.session = session;
        };
        Marker.prototype.setMarkers = function(markers) {
            this.markers = markers;
        };
        Marker.prototype.elt = function(className, css) {
            var x = this.i != -1 && this.element.childNodes[this.i];
            if (!x) {
                x = document.createElement("div");
                this.element.appendChild(x);
                this.i = -1;
            } else this.i++;
            x.style.cssText = css;
            x.className = className;
        };
        Marker.prototype.update = function(config) {
            if (!config) return;
            this.config = config;
            this.i = 0;
            var html;
            for(var key in this.markers){
                var marker = this.markers[key];
                if (!marker.range) {
                    marker.update(html, this, this.session, config);
                    continue;
                }
                var range = marker.range.clipRows(config.firstRow, config.lastRow);
                if (range.isEmpty()) continue;
                range = range.toScreenRange(this.session);
                if (marker.renderer) {
                    var top = this.$getTop(range.start.row, config);
                    var left = this.$padding + range.start.column * config.characterWidth;
                    marker.renderer(html, range, left, top, config);
                } else if (marker.type == "fullLine") this.drawFullLineMarker(html, range, marker.clazz, config);
                else if (marker.type == "screenLine") this.drawScreenLineMarker(html, range, marker.clazz, config);
                else if (range.isMultiLine()) {
                    if (marker.type == "text") this.drawTextMarker(html, range, marker.clazz, config);
                    else this.drawMultiLineMarker(html, range, marker.clazz, config);
                } else this.drawSingleLineMarker(html, range, marker.clazz + " ace_start" + " ace_br15", config);
            }
            if (this.i != -1) while(this.i < this.element.childElementCount)this.element.removeChild(this.element.lastChild);
        };
        Marker.prototype.$getTop = function(row, layerConfig) {
            return (row - layerConfig.firstRowScreen) * layerConfig.lineHeight;
        };
        Marker.prototype.drawTextMarker = function(stringBuilder, range, clazz, layerConfig, extraStyle) {
            var session = this.session;
            var start = range.start.row;
            var end = range.end.row;
            var row = start;
            var prev = 0;
            var curr = 0;
            var next = session.getScreenLastRowColumn(row);
            var lineRange = new Range(row, range.start.column, row, curr);
            for(; row <= end; row++){
                lineRange.start.row = lineRange.end.row = row;
                lineRange.start.column = row == start ? range.start.column : session.getRowWrapIndent(row);
                lineRange.end.column = next;
                prev = curr;
                curr = next;
                next = row + 1 < end ? session.getScreenLastRowColumn(row + 1) : row == end ? 0 : range.end.column;
                this.drawSingleLineMarker(stringBuilder, lineRange, clazz + (row == start ? " ace_start" : "") + " ace_br" + getBorderClass(row == start || row == start + 1 && range.start.column, prev < curr, curr > next, row == end), layerConfig, row == end ? 0 : 1, extraStyle);
            }
        };
        Marker.prototype.drawMultiLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
            var padding = this.$padding;
            var height = config.lineHeight;
            var top = this.$getTop(range.start.row, config);
            var left = padding + range.start.column * config.characterWidth;
            extraStyle = extraStyle || "";
            if (this.session.$bidiHandler.isBidiRow(range.start.row)) {
                var range1 = range.clone();
                range1.end.row = range1.start.row;
                range1.end.column = this.session.getLine(range1.start.row).length;
                this.drawBidiSingleLineMarker(stringBuilder, range1, clazz + " ace_br1 ace_start", config, null, extraStyle);
            } else this.elt(clazz + " ace_br1 ace_start", "height:" + height + "px;" + "right:0;" + "top:" + top + "px;left:" + left + "px;" + (extraStyle || ""));
            if (this.session.$bidiHandler.isBidiRow(range.end.row)) {
                var range1 = range.clone();
                range1.start.row = range1.end.row;
                range1.start.column = 0;
                this.drawBidiSingleLineMarker(stringBuilder, range1, clazz + " ace_br12", config, null, extraStyle);
            } else {
                top = this.$getTop(range.end.row, config);
                var width = range.end.column * config.characterWidth;
                this.elt(clazz + " ace_br12", "height:" + height + "px;" + "width:" + width + "px;" + "top:" + top + "px;" + "left:" + padding + "px;" + (extraStyle || ""));
            }
            height = (range.end.row - range.start.row - 1) * config.lineHeight;
            if (height <= 0) return;
            top = this.$getTop(range.start.row + 1, config);
            var radiusClass = (range.start.column ? 1 : 0) | (range.end.column ? 0 : 8);
            this.elt(clazz + (radiusClass ? " ace_br" + radiusClass : ""), "height:" + height + "px;" + "right:0;" + "top:" + top + "px;" + "left:" + padding + "px;" + (extraStyle || ""));
        };
        Marker.prototype.drawSingleLineMarker = function(stringBuilder, range, clazz, config, extraLength, extraStyle) {
            if (this.session.$bidiHandler.isBidiRow(range.start.row)) return this.drawBidiSingleLineMarker(stringBuilder, range, clazz, config, extraLength, extraStyle);
            var height = config.lineHeight;
            var width = (range.end.column + (extraLength || 0) - range.start.column) * config.characterWidth;
            var top = this.$getTop(range.start.row, config);
            var left = this.$padding + range.start.column * config.characterWidth;
            this.elt(clazz, "height:" + height + "px;" + "width:" + width + "px;" + "top:" + top + "px;" + "left:" + left + "px;" + (extraStyle || ""));
        };
        Marker.prototype.drawBidiSingleLineMarker = function(stringBuilder, range, clazz, config, extraLength, extraStyle) {
            var height = config.lineHeight, top = this.$getTop(range.start.row, config), padding = this.$padding;
            var selections = this.session.$bidiHandler.getSelections(range.start.column, range.end.column);
            selections.forEach(function(selection) {
                this.elt(clazz, "height:" + height + "px;" + "width:" + (selection.width + (extraLength || 0)) + "px;" + "top:" + top + "px;" + "left:" + (padding + selection.left) + "px;" + (extraStyle || ""));
            }, this);
        };
        Marker.prototype.drawFullLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
            var top = this.$getTop(range.start.row, config);
            var height = config.lineHeight;
            if (range.start.row != range.end.row) height += this.$getTop(range.end.row, config) - top;
            this.elt(clazz, "height:" + height + "px;" + "top:" + top + "px;" + "left:0;right:0;" + (extraStyle || ""));
        };
        Marker.prototype.drawScreenLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
            var top = this.$getTop(range.start.row, config);
            var height = config.lineHeight;
            this.elt(clazz, "height:" + height + "px;" + "top:" + top + "px;" + "left:0;right:0;" + (extraStyle || ""));
        };
        return Marker;
    }();
    Marker.prototype.$padding = 0;
    function getBorderClass(tl, tr, br, bl) {
        return (tl ? 1 : 0) | (tr ? 2 : 0) | (br ? 4 : 0) | (bl ? 8 : 0);
    }
    exports.Marker = Marker;
});
ace.define("ace/layer/text_util", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    var textTokens = new Set([
        "text",
        "rparen",
        "lparen"
    ]);
    exports.isTextToken = function(tokenType) {
        return textTokens.has(tokenType);
    };
});
ace.define("ace/layer/text", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/lib/lang",
    "ace/layer/lines",
    "ace/lib/event_emitter",
    "ace/config",
    "ace/layer/text_util"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var dom = require("../lib/dom");
    var lang = require("../lib/lang");
    var Lines = require("./lines").Lines;
    var EventEmitter = require("../lib/event_emitter").EventEmitter;
    var nls = require("../config").nls;
    var isTextToken = require("./text_util").isTextToken;
    var Text = /** @class */ function() {
        function Text(parentEl) {
            this.dom = dom;
            this.element = this.dom.createElement("div");
            this.element.className = "ace_layer ace_text-layer";
            parentEl.appendChild(this.element);
            this.$updateEolChar = this.$updateEolChar.bind(this);
            this.$lines = new Lines(this.element);
        }
        Text.prototype.$updateEolChar = function() {
            var doc = this.session.doc;
            var unixMode = doc.getNewLineCharacter() == "\n" && doc.getNewLineMode() != "windows";
            var EOL_CHAR = unixMode ? this.EOL_CHAR_LF : this.EOL_CHAR_CRLF;
            if (this.EOL_CHAR != EOL_CHAR) {
                this.EOL_CHAR = EOL_CHAR;
                return true;
            }
        };
        Text.prototype.setPadding = function(padding) {
            this.$padding = padding;
            this.element.style.margin = "0 " + padding + "px";
        };
        Text.prototype.getLineHeight = function() {
            return this.$fontMetrics.$characterSize.height || 0;
        };
        Text.prototype.getCharacterWidth = function() {
            return this.$fontMetrics.$characterSize.width || 0;
        };
        Text.prototype.$setFontMetrics = function(measure) {
            this.$fontMetrics = measure;
            this.$fontMetrics.on("changeCharacterSize", (function(e) {
                this._signal("changeCharacterSize", e);
            }).bind(this));
            this.$pollSizeChanges();
        };
        Text.prototype.checkForSizeChanges = function() {
            this.$fontMetrics.checkForSizeChanges();
        };
        Text.prototype.$pollSizeChanges = function() {
            return this.$pollSizeChangesTimer = this.$fontMetrics.$pollSizeChanges();
        };
        Text.prototype.setSession = function(session) {
            this.session = session;
            if (session) this.$computeTabString();
        };
        Text.prototype.setShowInvisibles = function(showInvisibles) {
            if (this.showInvisibles == showInvisibles) return false;
            this.showInvisibles = showInvisibles;
            if (typeof showInvisibles == "string") {
                this.showSpaces = /tab/i.test(showInvisibles);
                this.showTabs = /space/i.test(showInvisibles);
                this.showEOL = /eol/i.test(showInvisibles);
            } else this.showSpaces = this.showTabs = this.showEOL = showInvisibles;
            this.$computeTabString();
            return true;
        };
        Text.prototype.setDisplayIndentGuides = function(display) {
            if (this.displayIndentGuides == display) return false;
            this.displayIndentGuides = display;
            this.$computeTabString();
            return true;
        };
        Text.prototype.setHighlightIndentGuides = function(highlight) {
            if (this.$highlightIndentGuides === highlight) return false;
            this.$highlightIndentGuides = highlight;
            return highlight;
        };
        Text.prototype.$computeTabString = function() {
            var tabSize = this.session.getTabSize();
            this.tabSize = tabSize;
            var tabStr = this.$tabStrings = [
                0
            ];
            for(var i = 1; i < tabSize + 1; i++)if (this.showTabs) {
                var span = this.dom.createElement("span");
                span.className = "ace_invisible ace_invisible_tab";
                span.textContent = lang.stringRepeat(this.TAB_CHAR, i);
                tabStr.push(span);
            } else tabStr.push(this.dom.createTextNode(lang.stringRepeat(" ", i), this.element));
            if (this.displayIndentGuides) {
                this.$indentGuideRe = /\s\S| \t|\t |\s$/;
                var className = "ace_indent-guide";
                var spaceClass = this.showSpaces ? " ace_invisible ace_invisible_space" : "";
                var spaceContent = this.showSpaces ? lang.stringRepeat(this.SPACE_CHAR, this.tabSize) : lang.stringRepeat(" ", this.tabSize);
                var tabClass = this.showTabs ? " ace_invisible ace_invisible_tab" : "";
                var tabContent = this.showTabs ? lang.stringRepeat(this.TAB_CHAR, this.tabSize) : spaceContent;
                var span = this.dom.createElement("span");
                span.className = className + spaceClass;
                span.textContent = spaceContent;
                this.$tabStrings[" "] = span;
                var span = this.dom.createElement("span");
                span.className = className + tabClass;
                span.textContent = tabContent;
                this.$tabStrings["	"] = span;
            }
        };
        Text.prototype.updateLines = function(config, firstRow, lastRow) {
            if (this.config.lastRow != config.lastRow || this.config.firstRow != config.firstRow) return this.update(config);
            this.config = config;
            var first = Math.max(firstRow, config.firstRow);
            var last = Math.min(lastRow, config.lastRow);
            var lineElements = this.element.childNodes;
            var lineElementsIdx = 0;
            for(var row = config.firstRow; row < first; row++){
                var foldLine = this.session.getFoldLine(row);
                if (foldLine) {
                    if (foldLine.containsRow(first)) {
                        first = foldLine.start.row;
                        break;
                    } else row = foldLine.end.row;
                }
                lineElementsIdx++;
            }
            var heightChanged = false;
            var row = first;
            var foldLine = this.session.getNextFoldLine(row);
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            while(true){
                if (row > foldStart) {
                    row = foldLine.end.row + 1;
                    foldLine = this.session.getNextFoldLine(row, foldLine);
                    foldStart = foldLine ? foldLine.start.row : Infinity;
                }
                if (row > last) break;
                var lineElement = lineElements[lineElementsIdx++];
                if (lineElement) {
                    this.dom.removeChildren(lineElement);
                    this.$renderLine(lineElement, row, row == foldStart ? foldLine : false);
                    if (heightChanged) lineElement.style.top = this.$lines.computeLineTop(row, config, this.session) + "px";
                    var height = config.lineHeight * this.session.getRowLength(row) + "px";
                    if (lineElement.style.height != height) {
                        heightChanged = true;
                        lineElement.style.height = height;
                    }
                }
                row++;
            }
            if (heightChanged) while(lineElementsIdx < this.$lines.cells.length){
                var cell = this.$lines.cells[lineElementsIdx++];
                cell.element.style.top = this.$lines.computeLineTop(cell.row, config, this.session) + "px";
            }
        };
        Text.prototype.scrollLines = function(config) {
            var oldConfig = this.config;
            this.config = config;
            if (this.$lines.pageChanged(oldConfig, config)) return this.update(config);
            this.$lines.moveContainer(config);
            var lastRow = config.lastRow;
            var oldLastRow = oldConfig ? oldConfig.lastRow : -1;
            if (!oldConfig || oldLastRow < config.firstRow) return this.update(config);
            if (lastRow < oldConfig.firstRow) return this.update(config);
            if (!oldConfig || oldConfig.lastRow < config.firstRow) return this.update(config);
            if (config.lastRow < oldConfig.firstRow) return this.update(config);
            if (oldConfig.firstRow < config.firstRow) for(var row = this.session.getFoldedRowCount(oldConfig.firstRow, config.firstRow - 1); row > 0; row--)this.$lines.shift();
            if (oldConfig.lastRow > config.lastRow) for(var row = this.session.getFoldedRowCount(config.lastRow + 1, oldConfig.lastRow); row > 0; row--)this.$lines.pop();
            if (config.firstRow < oldConfig.firstRow) this.$lines.unshift(this.$renderLinesFragment(config, config.firstRow, oldConfig.firstRow - 1));
            if (config.lastRow > oldConfig.lastRow) this.$lines.push(this.$renderLinesFragment(config, oldConfig.lastRow + 1, config.lastRow));
            this.$highlightIndentGuide();
        };
        Text.prototype.$renderLinesFragment = function(config, firstRow, lastRow) {
            var fragment = [];
            var row = firstRow;
            var foldLine = this.session.getNextFoldLine(row);
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            while(true){
                if (row > foldStart) {
                    row = foldLine.end.row + 1;
                    foldLine = this.session.getNextFoldLine(row, foldLine);
                    foldStart = foldLine ? foldLine.start.row : Infinity;
                }
                if (row > lastRow) break;
                var line = this.$lines.createCell(row, config, this.session);
                var lineEl = line.element;
                this.dom.removeChildren(lineEl);
                dom.setStyle(lineEl.style, "height", this.$lines.computeLineHeight(row, config, this.session) + "px");
                dom.setStyle(lineEl.style, "top", this.$lines.computeLineTop(row, config, this.session) + "px");
                this.$renderLine(lineEl, row, row == foldStart ? foldLine : false);
                if (this.$useLineGroups()) lineEl.className = "ace_line_group";
                else lineEl.className = "ace_line";
                fragment.push(line);
                row++;
            }
            return fragment;
        };
        Text.prototype.update = function(config) {
            this.$lines.moveContainer(config);
            this.config = config;
            var firstRow = config.firstRow;
            var lastRow = config.lastRow;
            var lines = this.$lines;
            while(lines.getLength())lines.pop();
            lines.push(this.$renderLinesFragment(config, firstRow, lastRow));
        };
        Text.prototype.$renderToken = function(parent, screenColumn, token, value) {
            var self1 = this;
            var re = /(\t)|( +)|([\x00-\x1f\x80-\xa0\xad\u1680\u180E\u2000-\u200f\u2028\u2029\u202F\u205F\uFEFF\uFFF9-\uFFFC\u2066\u2067\u2068\u202A\u202B\u202D\u202E\u202C\u2069]+)|(\u3000)|([\u1100-\u115F\u11A3-\u11A7\u11FA-\u11FF\u2329-\u232A\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3001-\u303E\u3041-\u3096\u3099-\u30FF\u3105-\u312D\u3131-\u318E\u3190-\u31BA\u31C0-\u31E3\u31F0-\u321E\u3220-\u3247\u3250-\u32FE\u3300-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFAFF\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF60\uFFE0-\uFFE6]|[\uD800-\uDBFF][\uDC00-\uDFFF])/g;
            var valueFragment = this.dom.createFragment(this.element);
            var m;
            var i = 0;
            while(m = re.exec(value)){
                var tab = m[1];
                var simpleSpace = m[2];
                var controlCharacter = m[3];
                var cjkSpace = m[4];
                var cjk = m[5];
                if (!self1.showSpaces && simpleSpace) continue;
                var before = i != m.index ? value.slice(i, m.index) : "";
                i = m.index + m[0].length;
                if (before) valueFragment.appendChild(this.dom.createTextNode(before, this.element));
                if (tab) {
                    var tabSize = self1.session.getScreenTabSize(screenColumn + m.index);
                    valueFragment.appendChild(self1.$tabStrings[tabSize].cloneNode(true));
                    screenColumn += tabSize - 1;
                } else if (simpleSpace) {
                    if (self1.showSpaces) {
                        var span = this.dom.createElement("span");
                        span.className = "ace_invisible ace_invisible_space";
                        span.textContent = lang.stringRepeat(self1.SPACE_CHAR, simpleSpace.length);
                        valueFragment.appendChild(span);
                    } else valueFragment.appendChild(this.dom.createTextNode(simpleSpace, this.element));
                } else if (controlCharacter) {
                    var span = this.dom.createElement("span");
                    span.className = "ace_invisible ace_invisible_space ace_invalid";
                    span.textContent = lang.stringRepeat(self1.SPACE_CHAR, controlCharacter.length);
                    valueFragment.appendChild(span);
                } else if (cjkSpace) {
                    screenColumn += 1;
                    var span = this.dom.createElement("span");
                    span.style.width = self1.config.characterWidth * 2 + "px";
                    span.className = self1.showSpaces ? "ace_cjk ace_invisible ace_invisible_space" : "ace_cjk";
                    span.textContent = self1.showSpaces ? self1.SPACE_CHAR : cjkSpace;
                    valueFragment.appendChild(span);
                } else if (cjk) {
                    screenColumn += 1;
                    var span = this.dom.createElement("span");
                    span.style.width = self1.config.characterWidth * 2 + "px";
                    span.className = "ace_cjk";
                    span.textContent = cjk;
                    valueFragment.appendChild(span);
                }
            }
            valueFragment.appendChild(this.dom.createTextNode(i ? value.slice(i) : value, this.element));
            if (!isTextToken(token.type)) {
                var classes = "ace_" + token.type.replace(/\./g, " ace_");
                var span = this.dom.createElement("span");
                if (token.type == "fold") {
                    span.style.width = token.value.length * this.config.characterWidth + "px";
                    span.setAttribute("title", nls("inline-fold.closed.title", "Unfold code"));
                }
                span.className = classes;
                span.appendChild(valueFragment);
                parent.appendChild(span);
            } else parent.appendChild(valueFragment);
            return screenColumn + value.length;
        };
        Text.prototype.renderIndentGuide = function(parent, value, max) {
            var cols = value.search(this.$indentGuideRe);
            if (cols <= 0 || cols >= max) return value;
            if (value[0] == " ") {
                cols -= cols % this.tabSize;
                var count = cols / this.tabSize;
                for(var i = 0; i < count; i++)parent.appendChild(this.$tabStrings[" "].cloneNode(true));
                this.$highlightIndentGuide();
                return value.substr(cols);
            } else if (value[0] == "	") {
                for(var i = 0; i < cols; i++)parent.appendChild(this.$tabStrings["	"].cloneNode(true));
                this.$highlightIndentGuide();
                return value.substr(cols);
            }
            this.$highlightIndentGuide();
            return value;
        };
        Text.prototype.$highlightIndentGuide = function() {
            if (!this.$highlightIndentGuides || !this.displayIndentGuides) return;
            this.$highlightIndentGuideMarker = {
                indentLevel: undefined,
                start: undefined,
                end: undefined,
                dir: undefined
            };
            var lines = this.session.doc.$lines;
            if (!lines) return;
            var cursor = this.session.selection.getCursor();
            var initialIndent = /^\s*/.exec(this.session.doc.getLine(cursor.row))[0].length;
            var elementIndentLevel = Math.floor(initialIndent / this.tabSize);
            this.$highlightIndentGuideMarker = {
                indentLevel: elementIndentLevel,
                start: cursor.row
            };
            var bracketHighlight = this.session.$bracketHighlight;
            if (bracketHighlight) {
                var ranges = this.session.$bracketHighlight.ranges;
                for(var i = 0; i < ranges.length; i++)if (cursor.row !== ranges[i].start.row) {
                    this.$highlightIndentGuideMarker.end = ranges[i].start.row;
                    if (cursor.row > ranges[i].start.row) this.$highlightIndentGuideMarker.dir = -1;
                    else this.$highlightIndentGuideMarker.dir = 1;
                    break;
                }
            }
            if (!this.$highlightIndentGuideMarker.end) {
                if (lines[cursor.row] !== "" && cursor.column === lines[cursor.row].length) {
                    this.$highlightIndentGuideMarker.dir = 1;
                    for(var i = cursor.row + 1; i < lines.length; i++){
                        var line = lines[i];
                        var currentIndent = /^\s*/.exec(line)[0].length;
                        if (line !== "") {
                            this.$highlightIndentGuideMarker.end = i;
                            if (currentIndent <= initialIndent) break;
                        }
                    }
                }
            }
            this.$renderHighlightIndentGuide();
        };
        Text.prototype.$clearActiveIndentGuide = function() {
            var cells = this.$lines.cells;
            for(var i = 0; i < cells.length; i++){
                var cell = cells[i];
                var childNodes = cell.element.childNodes;
                if (childNodes.length > 0) {
                    for(var j = 0; j < childNodes.length; j++)if (childNodes[j].classList && childNodes[j].classList.contains("ace_indent-guide-active")) {
                        childNodes[j].classList.remove("ace_indent-guide-active");
                        break;
                    }
                }
            }
        };
        Text.prototype.$setIndentGuideActive = function(cell, indentLevel) {
            var line = this.session.doc.getLine(cell.row);
            if (line !== "") {
                var childNodes = cell.element.childNodes;
                if (childNodes) {
                    var node = childNodes[indentLevel - 1];
                    if (node && node.classList && node.classList.contains("ace_indent-guide")) node.classList.add("ace_indent-guide-active");
                }
            }
        };
        Text.prototype.$renderHighlightIndentGuide = function() {
            if (!this.$lines) return;
            var cells = this.$lines.cells;
            this.$clearActiveIndentGuide();
            var indentLevel = this.$highlightIndentGuideMarker.indentLevel;
            if (indentLevel !== 0) {
                if (this.$highlightIndentGuideMarker.dir === 1) for(var i = 0; i < cells.length; i++){
                    var cell = cells[i];
                    if (this.$highlightIndentGuideMarker.end && cell.row >= this.$highlightIndentGuideMarker.start + 1) {
                        if (cell.row >= this.$highlightIndentGuideMarker.end) break;
                        this.$setIndentGuideActive(cell, indentLevel);
                    }
                }
                else for(var i = cells.length - 1; i >= 0; i--){
                    var cell = cells[i];
                    if (this.$highlightIndentGuideMarker.end && cell.row < this.$highlightIndentGuideMarker.start) {
                        if (cell.row <= this.$highlightIndentGuideMarker.end) break;
                        this.$setIndentGuideActive(cell, indentLevel);
                    }
                }
            }
        };
        Text.prototype.$createLineElement = function(parent) {
            var lineEl = this.dom.createElement("div");
            lineEl.className = "ace_line";
            lineEl.style.height = this.config.lineHeight + "px";
            return lineEl;
        };
        Text.prototype.$renderWrappedLine = function(parent, tokens, splits) {
            var chars = 0;
            var split = 0;
            var splitChars = splits[0];
            var screenColumn = 0;
            var lineEl = this.$createLineElement();
            parent.appendChild(lineEl);
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var value = token.value;
                if (i == 0 && this.displayIndentGuides) {
                    chars = value.length;
                    value = this.renderIndentGuide(lineEl, value, splitChars);
                    if (!value) continue;
                    chars -= value.length;
                }
                if (chars + value.length < splitChars) {
                    screenColumn = this.$renderToken(lineEl, screenColumn, token, value);
                    chars += value.length;
                } else {
                    while(chars + value.length >= splitChars){
                        screenColumn = this.$renderToken(lineEl, screenColumn, token, value.substring(0, splitChars - chars));
                        value = value.substring(splitChars - chars);
                        chars = splitChars;
                        lineEl = this.$createLineElement();
                        parent.appendChild(lineEl);
                        lineEl.appendChild(this.dom.createTextNode(lang.stringRepeat("\xa0", splits.indent), this.element));
                        split++;
                        screenColumn = 0;
                        splitChars = splits[split] || Number.MAX_VALUE;
                    }
                    if (value.length != 0) {
                        chars += value.length;
                        screenColumn = this.$renderToken(lineEl, screenColumn, token, value);
                    }
                }
            }
            if (splits[splits.length - 1] > this.MAX_LINE_LENGTH) this.$renderOverflowMessage(lineEl, screenColumn, null, "", true);
        };
        Text.prototype.$renderSimpleLine = function(parent, tokens) {
            var screenColumn = 0;
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var value = token.value;
                if (i == 0 && this.displayIndentGuides) {
                    value = this.renderIndentGuide(parent, value);
                    if (!value) continue;
                }
                if (screenColumn + value.length > this.MAX_LINE_LENGTH) return this.$renderOverflowMessage(parent, screenColumn, token, value);
                screenColumn = this.$renderToken(parent, screenColumn, token, value);
            }
        };
        Text.prototype.$renderOverflowMessage = function(parent, screenColumn, token, value, hide) {
            token && this.$renderToken(parent, screenColumn, token, value.slice(0, this.MAX_LINE_LENGTH - screenColumn));
            var overflowEl = this.dom.createElement("span");
            overflowEl.className = "ace_inline_button ace_keyword ace_toggle_wrap";
            overflowEl.textContent = hide ? "<hide>" : "<click to see more...>";
            parent.appendChild(overflowEl);
        };
        Text.prototype.$renderLine = function(parent, row, foldLine) {
            if (!foldLine && foldLine != false) foldLine = this.session.getFoldLine(row);
            if (foldLine) var tokens = this.$getFoldLineTokens(row, foldLine);
            else var tokens = this.session.getTokens(row);
            var lastLineEl = parent;
            if (tokens.length) {
                var splits = this.session.getRowSplitData(row);
                if (splits && splits.length) {
                    this.$renderWrappedLine(parent, tokens, splits);
                    var lastLineEl = parent.lastChild;
                } else {
                    var lastLineEl = parent;
                    if (this.$useLineGroups()) {
                        lastLineEl = this.$createLineElement();
                        parent.appendChild(lastLineEl);
                    }
                    this.$renderSimpleLine(lastLineEl, tokens);
                }
            } else if (this.$useLineGroups()) {
                lastLineEl = this.$createLineElement();
                parent.appendChild(lastLineEl);
            }
            if (this.showEOL && lastLineEl) {
                if (foldLine) row = foldLine.end.row;
                var invisibleEl = this.dom.createElement("span");
                invisibleEl.className = "ace_invisible ace_invisible_eol";
                invisibleEl.textContent = row == this.session.getLength() - 1 ? this.EOF_CHAR : this.EOL_CHAR;
                lastLineEl.appendChild(invisibleEl);
            }
        };
        Text.prototype.$getFoldLineTokens = function(row, foldLine) {
            var session = this.session;
            var renderTokens = [];
            function addTokens(tokens, from, to) {
                var idx = 0, col = 0;
                while(col + tokens[idx].value.length < from){
                    col += tokens[idx].value.length;
                    idx++;
                    if (idx == tokens.length) return;
                }
                if (col != from) {
                    var value = tokens[idx].value.substring(from - col);
                    if (value.length > to - from) value = value.substring(0, to - from);
                    renderTokens.push({
                        type: tokens[idx].type,
                        value: value
                    });
                    col = from + value.length;
                    idx += 1;
                }
                while(col < to && idx < tokens.length){
                    var value = tokens[idx].value;
                    if (value.length + col > to) renderTokens.push({
                        type: tokens[idx].type,
                        value: value.substring(0, to - col)
                    });
                    else renderTokens.push(tokens[idx]);
                    col += value.length;
                    idx += 1;
                }
            }
            var tokens = session.getTokens(row);
            foldLine.walk(function(placeholder, row, column, lastColumn, isNewRow) {
                if (placeholder != null) renderTokens.push({
                    type: "fold",
                    value: placeholder
                });
                else {
                    if (isNewRow) tokens = session.getTokens(row);
                    if (tokens.length) addTokens(tokens, lastColumn, column);
                }
            }, foldLine.end.row, this.session.getLine(foldLine.end.row).length);
            return renderTokens;
        };
        Text.prototype.$useLineGroups = function() {
            return this.session.getUseWrapMode();
        };
        return Text;
    }();
    Text.prototype.EOF_CHAR = "\xb6";
    Text.prototype.EOL_CHAR_LF = "\xac";
    Text.prototype.EOL_CHAR_CRLF = "\xa4";
    Text.prototype.EOL_CHAR = Text.prototype.EOL_CHAR_LF;
    Text.prototype.TAB_CHAR = "\u2014"; //"\u21E5";
    Text.prototype.SPACE_CHAR = "\xb7";
    Text.prototype.$padding = 0;
    Text.prototype.MAX_LINE_LENGTH = 10000;
    Text.prototype.showInvisibles = false;
    Text.prototype.showSpaces = false;
    Text.prototype.showTabs = false;
    Text.prototype.showEOL = false;
    Text.prototype.displayIndentGuides = true;
    Text.prototype.$highlightIndentGuides = true;
    Text.prototype.$tabStrings = [];
    Text.prototype.destroy = {};
    Text.prototype.onChangeTabSize = Text.prototype.$computeTabString;
    oop.implement(Text.prototype, EventEmitter);
    exports.Text = Text;
});
ace.define("ace/layer/cursor", [
    "require",
    "exports",
    "module",
    "ace/lib/dom"
], function(require, exports, module1) {
    "use strict";
    var dom = require("../lib/dom");
    var Cursor = /** @class */ function() {
        function Cursor(parentEl) {
            this.element = dom.createElement("div");
            this.element.className = "ace_layer ace_cursor-layer";
            parentEl.appendChild(this.element);
            this.isVisible = false;
            this.isBlinking = true;
            this.blinkInterval = 1000;
            this.smoothBlinking = false;
            this.cursors = [];
            this.cursor = this.addCursor();
            dom.addCssClass(this.element, "ace_hidden-cursors");
            this.$updateCursors = this.$updateOpacity.bind(this);
        }
        Cursor.prototype.$updateOpacity = function(val) {
            var cursors = this.cursors;
            for(var i = cursors.length; i--;)dom.setStyle(cursors[i].style, "opacity", val ? "" : "0");
        };
        Cursor.prototype.$startCssAnimation = function() {
            var cursors = this.cursors;
            for(var i = cursors.length; i--;)cursors[i].style.animationDuration = this.blinkInterval + "ms";
            this.$isAnimating = true;
            setTimeout((function() {
                if (this.$isAnimating) dom.addCssClass(this.element, "ace_animate-blinking");
            }).bind(this));
        };
        Cursor.prototype.$stopCssAnimation = function() {
            this.$isAnimating = false;
            dom.removeCssClass(this.element, "ace_animate-blinking");
        };
        Cursor.prototype.setPadding = function(padding) {
            this.$padding = padding;
        };
        Cursor.prototype.setSession = function(session) {
            this.session = session;
        };
        Cursor.prototype.setBlinking = function(blinking) {
            if (blinking != this.isBlinking) {
                this.isBlinking = blinking;
                this.restartTimer();
            }
        };
        Cursor.prototype.setBlinkInterval = function(blinkInterval) {
            if (blinkInterval != this.blinkInterval) {
                this.blinkInterval = blinkInterval;
                this.restartTimer();
            }
        };
        Cursor.prototype.setSmoothBlinking = function(smoothBlinking) {
            if (smoothBlinking != this.smoothBlinking) {
                this.smoothBlinking = smoothBlinking;
                dom.setCssClass(this.element, "ace_smooth-blinking", smoothBlinking);
                this.$updateCursors(true);
                this.restartTimer();
            }
        };
        Cursor.prototype.addCursor = function() {
            var el = dom.createElement("div");
            el.className = "ace_cursor";
            this.element.appendChild(el);
            this.cursors.push(el);
            return el;
        };
        Cursor.prototype.removeCursor = function() {
            if (this.cursors.length > 1) {
                var el = this.cursors.pop();
                el.parentNode.removeChild(el);
                return el;
            }
        };
        Cursor.prototype.hideCursor = function() {
            this.isVisible = false;
            dom.addCssClass(this.element, "ace_hidden-cursors");
            this.restartTimer();
        };
        Cursor.prototype.showCursor = function() {
            this.isVisible = true;
            dom.removeCssClass(this.element, "ace_hidden-cursors");
            this.restartTimer();
        };
        Cursor.prototype.restartTimer = function() {
            var update = this.$updateCursors;
            clearInterval(this.intervalId);
            clearTimeout(this.timeoutId);
            this.$stopCssAnimation();
            if (this.smoothBlinking) {
                this.$isSmoothBlinking = false;
                dom.removeCssClass(this.element, "ace_smooth-blinking");
            }
            update(true);
            if (!this.isBlinking || !this.blinkInterval || !this.isVisible) {
                this.$stopCssAnimation();
                return;
            }
            if (this.smoothBlinking) {
                this.$isSmoothBlinking = true;
                setTimeout((function() {
                    if (this.$isSmoothBlinking) dom.addCssClass(this.element, "ace_smooth-blinking");
                }).bind(this));
            }
            if (dom.HAS_CSS_ANIMATION) this.$startCssAnimation();
            else {
                var blink = /**@this{Cursor}*/ (function() {
                    this.timeoutId = setTimeout(function() {
                        update(false);
                    }, 0.6 * this.blinkInterval);
                }).bind(this);
                this.intervalId = setInterval(function() {
                    update(true);
                    blink();
                }, this.blinkInterval);
                blink();
            }
        };
        Cursor.prototype.getPixelPosition = function(position, onScreen) {
            if (!this.config || !this.session) return {
                left: 0,
                top: 0
            };
            if (!position) position = this.session.selection.getCursor();
            var pos = this.session.documentToScreenPosition(position);
            var cursorLeft = this.$padding + (this.session.$bidiHandler.isBidiRow(pos.row, position.row) ? this.session.$bidiHandler.getPosLeft(pos.column) : pos.column * this.config.characterWidth);
            var cursorTop = (pos.row - (onScreen ? this.config.firstRowScreen : 0)) * this.config.lineHeight;
            return {
                left: cursorLeft,
                top: cursorTop
            };
        };
        Cursor.prototype.isCursorInView = function(pixelPos, config) {
            return pixelPos.top >= 0 && pixelPos.top < config.maxHeight;
        };
        Cursor.prototype.update = function(config) {
            this.config = config;
            var selections = this.session.$selectionMarkers;
            var i = 0, cursorIndex = 0;
            if (selections === undefined || selections.length === 0) selections = [
                {
                    cursor: null
                }
            ];
            for(var i = 0, n = selections.length; i < n; i++){
                var pixelPos = this.getPixelPosition(selections[i].cursor, true);
                if ((pixelPos.top > config.height + config.offset || pixelPos.top < 0) && i > 1) continue;
                var element = this.cursors[cursorIndex++] || this.addCursor();
                var style = element.style;
                if (!this.drawCursor) {
                    if (!this.isCursorInView(pixelPos, config)) dom.setStyle(style, "display", "none");
                    else {
                        dom.setStyle(style, "display", "block");
                        dom.translate(element, pixelPos.left, pixelPos.top);
                        dom.setStyle(style, "width", Math.round(config.characterWidth) + "px");
                        dom.setStyle(style, "height", config.lineHeight + "px");
                    }
                } else this.drawCursor(element, pixelPos, config, selections[i], this.session);
            }
            while(this.cursors.length > cursorIndex)this.removeCursor();
            var overwrite = this.session.getOverwrite();
            this.$setOverwrite(overwrite);
            this.$pixelPos = pixelPos;
            this.restartTimer();
        };
        Cursor.prototype.$setOverwrite = function(overwrite) {
            if (overwrite != this.overwrite) {
                this.overwrite = overwrite;
                if (overwrite) dom.addCssClass(this.element, "ace_overwrite-cursors");
                else dom.removeCssClass(this.element, "ace_overwrite-cursors");
            }
        };
        Cursor.prototype.destroy = function() {
            clearInterval(this.intervalId);
            clearTimeout(this.timeoutId);
        };
        return Cursor;
    }();
    Cursor.prototype.$padding = 0;
    Cursor.prototype.drawCursor = null;
    exports.Cursor = Cursor;
});
ace.define("ace/scrollbar", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/lib/event",
    "ace/lib/event_emitter"
], function(require, exports, module1) {
    "use strict";
    var __extends = this && this.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var oop = require("./lib/oop");
    var dom = require("./lib/dom");
    var event = require("./lib/event");
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var MAX_SCROLL_H = 0x8000;
    var Scrollbar = /** @class */ function() {
        function Scrollbar(parent, classSuffix) {
            this.element = dom.createElement("div");
            this.element.className = "ace_scrollbar ace_scrollbar" + classSuffix;
            this.inner = dom.createElement("div");
            this.inner.className = "ace_scrollbar-inner";
            this.inner.textContent = "\xa0";
            this.element.appendChild(this.inner);
            parent.appendChild(this.element);
            this.setVisible(false);
            this.skipEvent = false;
            event.addListener(this.element, "scroll", this.onScroll.bind(this));
            event.addListener(this.element, "mousedown", event.preventDefault);
        }
        Scrollbar.prototype.setVisible = function(isVisible) {
            this.element.style.display = isVisible ? "" : "none";
            this.isVisible = isVisible;
            this.coeff = 1;
        };
        return Scrollbar;
    }();
    oop.implement(Scrollbar.prototype, EventEmitter);
    var VScrollBar = /** @class */ function(_super) {
        __extends(VScrollBar, _super);
        function VScrollBar(parent, renderer) {
            var _this = _super.call(this, parent, "-v") || this;
            _this.scrollTop = 0;
            _this.scrollHeight = 0;
            renderer.$scrollbarWidth = _this.width = dom.scrollbarWidth(parent.ownerDocument);
            _this.inner.style.width = _this.element.style.width = (_this.width || 15) + 5 + "px";
            _this.$minWidth = 0;
            return _this;
        }
        VScrollBar.prototype.onScroll = function() {
            if (!this.skipEvent) {
                this.scrollTop = this.element.scrollTop;
                if (this.coeff != 1) {
                    var h = this.element.clientHeight / this.scrollHeight;
                    this.scrollTop = this.scrollTop * (1 - h) / (this.coeff - h);
                }
                this._emit("scroll", {
                    data: this.scrollTop
                });
            }
            this.skipEvent = false;
        };
        VScrollBar.prototype.getWidth = function() {
            return Math.max(this.isVisible ? this.width : 0, this.$minWidth || 0);
        };
        VScrollBar.prototype.setHeight = function(height) {
            this.element.style.height = height + "px";
        };
        VScrollBar.prototype.setScrollHeight = function(height) {
            this.scrollHeight = height;
            if (height > MAX_SCROLL_H) {
                this.coeff = MAX_SCROLL_H / height;
                height = MAX_SCROLL_H;
            } else if (this.coeff != 1) this.coeff = 1;
            this.inner.style.height = height + "px";
        };
        VScrollBar.prototype.setScrollTop = function(scrollTop) {
            if (this.scrollTop != scrollTop) {
                this.skipEvent = true;
                this.scrollTop = scrollTop;
                this.element.scrollTop = scrollTop * this.coeff;
            }
        };
        return VScrollBar;
    }(Scrollbar);
    VScrollBar.prototype.setInnerHeight = VScrollBar.prototype.setScrollHeight;
    var HScrollBar = /** @class */ function(_super) {
        __extends(HScrollBar, _super);
        function HScrollBar(parent, renderer) {
            var _this = _super.call(this, parent, "-h") || this;
            _this.scrollLeft = 0;
            _this.height = renderer.$scrollbarWidth;
            _this.inner.style.height = _this.element.style.height = (_this.height || 15) + 5 + "px";
            return _this;
        }
        HScrollBar.prototype.onScroll = function() {
            if (!this.skipEvent) {
                this.scrollLeft = this.element.scrollLeft;
                this._emit("scroll", {
                    data: this.scrollLeft
                });
            }
            this.skipEvent = false;
        };
        HScrollBar.prototype.getHeight = function() {
            return this.isVisible ? this.height : 0;
        };
        HScrollBar.prototype.setWidth = function(width) {
            this.element.style.width = width + "px";
        };
        HScrollBar.prototype.setInnerWidth = function(width) {
            this.inner.style.width = width + "px";
        };
        HScrollBar.prototype.setScrollWidth = function(width) {
            this.inner.style.width = width + "px";
        };
        HScrollBar.prototype.setScrollLeft = function(scrollLeft) {
            if (this.scrollLeft != scrollLeft) {
                this.skipEvent = true;
                this.scrollLeft = this.element.scrollLeft = scrollLeft;
            }
        };
        return HScrollBar;
    }(Scrollbar);
    exports.ScrollBar = VScrollBar; // backward compatibility
    exports.ScrollBarV = VScrollBar; // backward compatibility
    exports.ScrollBarH = HScrollBar; // backward compatibility
    exports.VScrollBar = VScrollBar;
    exports.HScrollBar = HScrollBar;
});
ace.define("ace/scrollbar_custom", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/lib/event",
    "ace/lib/event_emitter"
], function(require, exports, module1) {
    "use strict";
    var __extends = this && this.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var oop = require("./lib/oop");
    var dom = require("./lib/dom");
    var event = require("./lib/event");
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    dom.importCssString(".ace_editor>.ace_sb-v div, .ace_editor>.ace_sb-h div{\n  position: absolute;\n  background: rgba(128, 128, 128, 0.6);\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  border: 1px solid #bbb;\n  border-radius: 2px;\n  z-index: 8;\n}\n.ace_editor>.ace_sb-v, .ace_editor>.ace_sb-h {\n  position: absolute;\n  z-index: 6;\n  background: none;\n  overflow: hidden!important;\n}\n.ace_editor>.ace_sb-v {\n  z-index: 6;\n  right: 0;\n  top: 0;\n  width: 12px;\n}\n.ace_editor>.ace_sb-v div {\n  z-index: 8;\n  right: 0;\n  width: 100%;\n}\n.ace_editor>.ace_sb-h {\n  bottom: 0;\n  left: 0;\n  height: 12px;\n}\n.ace_editor>.ace_sb-h div {\n  bottom: 0;\n  height: 100%;\n}\n.ace_editor>.ace_sb_grabbed {\n  z-index: 8;\n  background: #000;\n}", "ace_scrollbar.css", false);
    var ScrollBar = /** @class */ function() {
        function ScrollBar(parent, classSuffix) {
            this.element = dom.createElement("div");
            this.element.className = "ace_sb" + classSuffix;
            this.inner = dom.createElement("div");
            this.inner.className = "";
            this.element.appendChild(this.inner);
            this.VScrollWidth = 12;
            this.HScrollHeight = 12;
            parent.appendChild(this.element);
            this.setVisible(false);
            this.skipEvent = false;
            event.addMultiMouseDownListener(this.element, [
                500,
                300,
                300
            ], this, "onMouseDown");
        }
        ScrollBar.prototype.setVisible = function(isVisible) {
            this.element.style.display = isVisible ? "" : "none";
            this.isVisible = isVisible;
            this.coeff = 1;
        };
        return ScrollBar;
    }();
    oop.implement(ScrollBar.prototype, EventEmitter);
    var VScrollBar = /** @class */ function(_super) {
        __extends(VScrollBar, _super);
        function VScrollBar(parent, renderer) {
            var _this = _super.call(this, parent, "-v") || this;
            _this.scrollTop = 0;
            _this.scrollHeight = 0;
            _this.parent = parent;
            _this.width = _this.VScrollWidth;
            _this.renderer = renderer;
            _this.inner.style.width = _this.element.style.width = (_this.width || 15) + "px";
            _this.$minWidth = 0;
            return _this;
        }
        VScrollBar.prototype.onMouseDown = function(eType, e) {
            if (eType !== "mousedown") return;
            if (event.getButton(e) !== 0 || e.detail === 2) return;
            if (e.target === this.inner) {
                var self1 = this;
                var mousePageY = e.clientY;
                var onMouseMove = function(e) {
                    mousePageY = e.clientY;
                };
                var onMouseUp = function() {
                    clearInterval(timerId);
                };
                var startY = e.clientY;
                var startTop = this.thumbTop;
                var onScrollInterval = function() {
                    if (mousePageY === undefined) return;
                    var scrollTop = self1.scrollTopFromThumbTop(startTop + mousePageY - startY);
                    if (scrollTop === self1.scrollTop) return;
                    self1._emit("scroll", {
                        data: scrollTop
                    });
                };
                event.capture(this.inner, onMouseMove, onMouseUp);
                var timerId = setInterval(onScrollInterval, 20);
                return event.preventDefault(e);
            }
            var top = e.clientY - this.element.getBoundingClientRect().top - this.thumbHeight / 2;
            this._emit("scroll", {
                data: this.scrollTopFromThumbTop(top)
            });
            return event.preventDefault(e);
        };
        VScrollBar.prototype.getHeight = function() {
            return this.height;
        };
        VScrollBar.prototype.scrollTopFromThumbTop = function(thumbTop) {
            var scrollTop = thumbTop * (this.pageHeight - this.viewHeight) / (this.slideHeight - this.thumbHeight);
            scrollTop = scrollTop >> 0;
            if (scrollTop < 0) scrollTop = 0;
            else if (scrollTop > this.pageHeight - this.viewHeight) scrollTop = this.pageHeight - this.viewHeight;
            return scrollTop;
        };
        VScrollBar.prototype.getWidth = function() {
            return Math.max(this.isVisible ? this.width : 0, this.$minWidth || 0);
        };
        VScrollBar.prototype.setHeight = function(height) {
            this.height = Math.max(0, height);
            this.slideHeight = this.height;
            this.viewHeight = this.height;
            this.setScrollHeight(this.pageHeight, true);
        };
        VScrollBar.prototype.setScrollHeight = function(height, force) {
            if (this.pageHeight === height && !force) return;
            this.pageHeight = height;
            this.thumbHeight = this.slideHeight * this.viewHeight / this.pageHeight;
            if (this.thumbHeight > this.slideHeight) this.thumbHeight = this.slideHeight;
            if (this.thumbHeight < 15) this.thumbHeight = 15;
            this.inner.style.height = this.thumbHeight + "px";
            if (this.scrollTop > this.pageHeight - this.viewHeight) {
                this.scrollTop = this.pageHeight - this.viewHeight;
                if (this.scrollTop < 0) this.scrollTop = 0;
                this._emit("scroll", {
                    data: this.scrollTop
                });
            }
        };
        VScrollBar.prototype.setScrollTop = function(scrollTop) {
            this.scrollTop = scrollTop;
            if (scrollTop < 0) scrollTop = 0;
            this.thumbTop = scrollTop * (this.slideHeight - this.thumbHeight) / (this.pageHeight - this.viewHeight);
            this.inner.style.top = this.thumbTop + "px";
        };
        return VScrollBar;
    }(ScrollBar);
    VScrollBar.prototype.setInnerHeight = VScrollBar.prototype.setScrollHeight;
    var HScrollBar = /** @class */ function(_super) {
        __extends(HScrollBar, _super);
        function HScrollBar(parent, renderer) {
            var _this = _super.call(this, parent, "-h") || this;
            _this.scrollLeft = 0;
            _this.scrollWidth = 0;
            _this.height = _this.HScrollHeight;
            _this.inner.style.height = _this.element.style.height = (_this.height || 12) + "px";
            _this.renderer = renderer;
            return _this;
        }
        HScrollBar.prototype.onMouseDown = function(eType, e) {
            if (eType !== "mousedown") return;
            if (event.getButton(e) !== 0 || e.detail === 2) return;
            if (e.target === this.inner) {
                var self1 = this;
                var mousePageX = e.clientX;
                var onMouseMove = function(e) {
                    mousePageX = e.clientX;
                };
                var onMouseUp = function() {
                    clearInterval(timerId);
                };
                var startX = e.clientX;
                var startLeft = this.thumbLeft;
                var onScrollInterval = function() {
                    if (mousePageX === undefined) return;
                    var scrollLeft = self1.scrollLeftFromThumbLeft(startLeft + mousePageX - startX);
                    if (scrollLeft === self1.scrollLeft) return;
                    self1._emit("scroll", {
                        data: scrollLeft
                    });
                };
                event.capture(this.inner, onMouseMove, onMouseUp);
                var timerId = setInterval(onScrollInterval, 20);
                return event.preventDefault(e);
            }
            var left = e.clientX - this.element.getBoundingClientRect().left - this.thumbWidth / 2;
            this._emit("scroll", {
                data: this.scrollLeftFromThumbLeft(left)
            });
            return event.preventDefault(e);
        };
        HScrollBar.prototype.getHeight = function() {
            return this.isVisible ? this.height : 0;
        };
        HScrollBar.prototype.scrollLeftFromThumbLeft = function(thumbLeft) {
            var scrollLeft = thumbLeft * (this.pageWidth - this.viewWidth) / (this.slideWidth - this.thumbWidth);
            scrollLeft = scrollLeft >> 0;
            if (scrollLeft < 0) scrollLeft = 0;
            else if (scrollLeft > this.pageWidth - this.viewWidth) scrollLeft = this.pageWidth - this.viewWidth;
            return scrollLeft;
        };
        HScrollBar.prototype.setWidth = function(width) {
            this.width = Math.max(0, width);
            this.element.style.width = this.width + "px";
            this.slideWidth = this.width;
            this.viewWidth = this.width;
            this.setScrollWidth(this.pageWidth, true);
        };
        HScrollBar.prototype.setScrollWidth = function(width, force) {
            if (this.pageWidth === width && !force) return;
            this.pageWidth = width;
            this.thumbWidth = this.slideWidth * this.viewWidth / this.pageWidth;
            if (this.thumbWidth > this.slideWidth) this.thumbWidth = this.slideWidth;
            if (this.thumbWidth < 15) this.thumbWidth = 15;
            this.inner.style.width = this.thumbWidth + "px";
            if (this.scrollLeft > this.pageWidth - this.viewWidth) {
                this.scrollLeft = this.pageWidth - this.viewWidth;
                if (this.scrollLeft < 0) this.scrollLeft = 0;
                this._emit("scroll", {
                    data: this.scrollLeft
                });
            }
        };
        HScrollBar.prototype.setScrollLeft = function(scrollLeft) {
            this.scrollLeft = scrollLeft;
            if (scrollLeft < 0) scrollLeft = 0;
            this.thumbLeft = scrollLeft * (this.slideWidth - this.thumbWidth) / (this.pageWidth - this.viewWidth);
            this.inner.style.left = this.thumbLeft + "px";
        };
        return HScrollBar;
    }(ScrollBar);
    HScrollBar.prototype.setInnerWidth = HScrollBar.prototype.setScrollWidth;
    exports.ScrollBar = VScrollBar; // backward compatibility
    exports.ScrollBarV = VScrollBar; // backward compatibility
    exports.ScrollBarH = HScrollBar; // backward compatibility
    exports.VScrollBar = VScrollBar;
    exports.HScrollBar = HScrollBar;
});
ace.define("ace/renderloop", [
    "require",
    "exports",
    "module",
    "ace/lib/event"
], function(require, exports, module1) {
    "use strict";
    var event = require("./lib/event");
    var RenderLoop = /** @class */ function() {
        function RenderLoop(onRender, win) {
            this.onRender = onRender;
            this.pending = false;
            this.changes = 0;
            this.$recursionLimit = 2;
            this.window = win || window;
            var _self = this;
            this._flush = function(ts) {
                _self.pending = false;
                var changes = _self.changes;
                if (changes) {
                    event.blockIdle(100);
                    _self.changes = 0;
                    _self.onRender(changes);
                }
                if (_self.changes) {
                    if (_self.$recursionLimit-- < 0) return;
                    _self.schedule();
                } else _self.$recursionLimit = 2;
            };
        }
        RenderLoop.prototype.schedule = function(change) {
            this.changes = this.changes | change;
            if (this.changes && !this.pending) {
                event.nextFrame(this._flush);
                this.pending = true;
            }
        };
        RenderLoop.prototype.clear = function(change) {
            var changes = this.changes;
            this.changes = 0;
            return changes;
        };
        return RenderLoop;
    }();
    exports.RenderLoop = RenderLoop;
});
ace.define("ace/layer/font_metrics", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/lib/lang",
    "ace/lib/event",
    "ace/lib/useragent",
    "ace/lib/event_emitter"
], function(require, exports, module1) {
    var oop = require("../lib/oop");
    var dom = require("../lib/dom");
    var lang = require("../lib/lang");
    var event = require("../lib/event");
    var useragent = require("../lib/useragent");
    var EventEmitter = require("../lib/event_emitter").EventEmitter;
    var CHAR_COUNT = 512;
    var USE_OBSERVER = typeof ResizeObserver == "function";
    var L = 200;
    var FontMetrics = /** @class */ function() {
        function FontMetrics(parentEl) {
            this.el = dom.createElement("div");
            this.$setMeasureNodeStyles(this.el.style, true);
            this.$main = dom.createElement("div");
            this.$setMeasureNodeStyles(this.$main.style);
            this.$measureNode = dom.createElement("div");
            this.$setMeasureNodeStyles(this.$measureNode.style);
            this.el.appendChild(this.$main);
            this.el.appendChild(this.$measureNode);
            parentEl.appendChild(this.el);
            this.$measureNode.textContent = lang.stringRepeat("X", CHAR_COUNT);
            this.$characterSize = {
                width: 0,
                height: 0
            };
            if (USE_OBSERVER) this.$addObserver();
            else this.checkForSizeChanges();
        }
        FontMetrics.prototype.$setMeasureNodeStyles = function(style, isRoot) {
            style.width = style.height = "auto";
            style.left = style.top = "0px";
            style.visibility = "hidden";
            style.position = "absolute";
            style.whiteSpace = "pre";
            if (useragent.isIE < 8) style["font-family"] = "inherit";
            else style.font = "inherit";
            style.overflow = isRoot ? "hidden" : "visible";
        };
        FontMetrics.prototype.checkForSizeChanges = function(size) {
            if (size === undefined) size = this.$measureSizes();
            if (size && (this.$characterSize.width !== size.width || this.$characterSize.height !== size.height)) {
                this.$measureNode.style.fontWeight = "bold";
                var boldSize = this.$measureSizes();
                this.$measureNode.style.fontWeight = "";
                this.$characterSize = size;
                this.charSizes = Object.create(null);
                this.allowBoldFonts = boldSize && boldSize.width === size.width && boldSize.height === size.height;
                this._emit("changeCharacterSize", {
                    data: size
                });
            }
        };
        FontMetrics.prototype.$addObserver = function() {
            var self1 = this;
            this.$observer = new window.ResizeObserver(function(e) {
                self1.checkForSizeChanges();
            });
            this.$observer.observe(this.$measureNode);
        };
        FontMetrics.prototype.$pollSizeChanges = function() {
            if (this.$pollSizeChangesTimer || this.$observer) return this.$pollSizeChangesTimer;
            var self1 = this;
            return this.$pollSizeChangesTimer = event.onIdle(function cb() {
                self1.checkForSizeChanges();
                event.onIdle(cb, 500);
            }, 500);
        };
        FontMetrics.prototype.setPolling = function(val) {
            if (val) this.$pollSizeChanges();
            else if (this.$pollSizeChangesTimer) {
                clearInterval(this.$pollSizeChangesTimer);
                this.$pollSizeChangesTimer = 0;
            }
        };
        FontMetrics.prototype.$measureSizes = function(node) {
            var size = {
                height: (node || this.$measureNode).clientHeight,
                width: (node || this.$measureNode).clientWidth / CHAR_COUNT
            };
            if (size.width === 0 || size.height === 0) return null;
            return size;
        };
        FontMetrics.prototype.$measureCharWidth = function(ch) {
            this.$main.textContent = lang.stringRepeat(ch, CHAR_COUNT);
            var rect = this.$main.getBoundingClientRect();
            return rect.width / CHAR_COUNT;
        };
        FontMetrics.prototype.getCharacterWidth = function(ch) {
            var w = this.charSizes[ch];
            if (w === undefined) w = this.charSizes[ch] = this.$measureCharWidth(ch) / this.$characterSize.width;
            return w;
        };
        FontMetrics.prototype.destroy = function() {
            clearInterval(this.$pollSizeChangesTimer);
            if (this.$observer) this.$observer.disconnect();
            if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
        };
        FontMetrics.prototype.$getZoom = function(element) {
            if (!element || !element.parentElement) return 1;
            return (Number(window.getComputedStyle(element)["zoom"]) || 1) * this.$getZoom(element.parentElement);
        };
        FontMetrics.prototype.$initTransformMeasureNodes = function() {
            var t = function(t, l) {
                return [
                    "div",
                    {
                        style: "position: absolute;top:" + t + "px;left:" + l + "px;"
                    }
                ];
            };
            this.els = dom.buildDom([
                t(0, 0),
                t(L, 0),
                t(0, L),
                t(L, L)
            ], this.el);
        };
        FontMetrics.prototype.transformCoordinates = function(clientPos, elPos) {
            if (clientPos) {
                var zoom = this.$getZoom(this.el);
                clientPos = mul(1 / zoom, clientPos);
            }
            function solve(l1, l2, r) {
                var det = l1[1] * l2[0] - l1[0] * l2[1];
                return [
                    (-l2[1] * r[0] + l2[0] * r[1]) / det,
                    (+l1[1] * r[0] - l1[0] * r[1]) / det
                ];
            }
            function sub(a, b) {
                return [
                    a[0] - b[0],
                    a[1] - b[1]
                ];
            }
            function add(a, b) {
                return [
                    a[0] + b[0],
                    a[1] + b[1]
                ];
            }
            function mul(a, b) {
                return [
                    a * b[0],
                    a * b[1]
                ];
            }
            if (!this.els) this.$initTransformMeasureNodes();
            function p(el) {
                var r = el.getBoundingClientRect();
                return [
                    r.left,
                    r.top
                ];
            }
            var a = p(this.els[0]);
            var b = p(this.els[1]);
            var c = p(this.els[2]);
            var d = p(this.els[3]);
            var h = solve(sub(d, b), sub(d, c), sub(add(b, c), add(d, a)));
            var m1 = mul(1 + h[0], sub(b, a));
            var m2 = mul(1 + h[1], sub(c, a));
            if (elPos) {
                var x = elPos;
                var k = h[0] * x[0] / L + h[1] * x[1] / L + 1;
                var ut = add(mul(x[0], m1), mul(x[1], m2));
                return add(mul(1 / k / L, ut), a);
            }
            var u = sub(clientPos, a);
            var f = solve(sub(m1, mul(h[0], u)), sub(m2, mul(h[1], u)), u);
            return mul(L, f);
        };
        return FontMetrics;
    }();
    FontMetrics.prototype.$characterSize = {
        width: 0,
        height: 0
    };
    oop.implement(FontMetrics.prototype, EventEmitter);
    exports.FontMetrics = FontMetrics;
});
ace.define("ace/css/editor-css", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    module1.exports = '\n.ace_br1 {border-top-left-radius    : 3px;}\n.ace_br2 {border-top-right-radius   : 3px;}\n.ace_br3 {border-top-left-radius    : 3px; border-top-right-radius:    3px;}\n.ace_br4 {border-bottom-right-radius: 3px;}\n.ace_br5 {border-top-left-radius    : 3px; border-bottom-right-radius: 3px;}\n.ace_br6 {border-top-right-radius   : 3px; border-bottom-right-radius: 3px;}\n.ace_br7 {border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px;}\n.ace_br8 {border-bottom-left-radius : 3px;}\n.ace_br9 {border-top-left-radius    : 3px; border-bottom-left-radius:  3px;}\n.ace_br10{border-top-right-radius   : 3px; border-bottom-left-radius:  3px;}\n.ace_br11{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-left-radius:  3px;}\n.ace_br12{border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br13{border-top-left-radius    : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br14{border-top-right-radius   : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br15{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px;}\n\n\n.ace_editor {\n    position: relative;\n    overflow: hidden;\n    padding: 0;\n    font: 12px/normal \'Monaco\', \'Menlo\', \'Ubuntu Mono\', \'Consolas\', \'Source Code Pro\', \'source-code-pro\', monospace;\n    direction: ltr;\n    text-align: left;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.ace_scroller {\n    position: absolute;\n    overflow: hidden;\n    top: 0;\n    bottom: 0;\n    background-color: inherit;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    cursor: text;\n}\n\n.ace_content {\n    position: absolute;\n    box-sizing: border-box;\n    min-width: 100%;\n    contain: style size layout;\n    font-variant-ligatures: no-common-ligatures;\n}\n\n.ace_keyboard-focus:focus {\n    box-shadow: inset 0 0 0 2px #5E9ED6;\n    outline: none;\n}\n\n.ace_dragging .ace_scroller:before{\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    content: \'\';\n    background: rgba(250, 250, 250, 0.01);\n    z-index: 1000;\n}\n.ace_dragging.ace_dark .ace_scroller:before{\n    background: rgba(0, 0, 0, 0.01);\n}\n\n.ace_gutter {\n    position: absolute;\n    overflow : hidden;\n    width: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    cursor: default;\n    z-index: 4;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    contain: style size layout;\n}\n\n.ace_gutter-active-line {\n    position: absolute;\n    left: 0;\n    right: 0;\n}\n\n.ace_scroller.ace_scroll-left:after {\n    content: "";\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    box-shadow: 17px 0 16px -16px rgba(0, 0, 0, 0.4) inset;\n    pointer-events: none;\n}\n\n.ace_gutter-cell, .ace_gutter-cell_svg-icons {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    padding-left: 19px;\n    padding-right: 6px;\n    background-repeat: no-repeat;\n}\n\n.ace_gutter-cell_svg-icons .ace_gutter_annotation {\n    margin-left: -14px;\n    float: left;\n}\n\n.ace_gutter-cell .ace_gutter_annotation {\n    margin-left: -19px;\n    float: left;\n}\n\n.ace_gutter-cell.ace_error, .ace_icon.ace_error, .ace_icon.ace_error_fold {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAABOFBMVEX/////////QRswFAb/Ui4wFAYwFAYwFAaWGAfDRymzOSH/PxswFAb/SiUwFAYwFAbUPRvjQiDllog5HhHdRybsTi3/Tyv9Tir+Syj/UC3////XurebMBIwFAb/RSHbPx/gUzfdwL3kzMivKBAwFAbbvbnhPx66NhowFAYwFAaZJg8wFAaxKBDZurf/RB6mMxb/SCMwFAYwFAbxQB3+RB4wFAb/Qhy4Oh+4QifbNRcwFAYwFAYwFAb/QRzdNhgwFAYwFAbav7v/Uy7oaE68MBK5LxLewr/r2NXewLswFAaxJw4wFAbkPRy2PyYwFAaxKhLm1tMwFAazPiQwFAaUGAb/QBrfOx3bvrv/VC/maE4wFAbRPBq6MRO8Qynew8Dp2tjfwb0wFAbx6eju5+by6uns4uH9/f36+vr/GkHjAAAAYnRSTlMAGt+64rnWu/bo8eAA4InH3+DwoN7j4eLi4xP99Nfg4+b+/u9B/eDs1MD1mO7+4PHg2MXa347g7vDizMLN4eG+Pv7i5evs/v79yu7S3/DV7/498Yv24eH+4ufQ3Ozu/v7+y13sRqwAAADLSURBVHjaZc/XDsFgGIBhtDrshlitmk2IrbHFqL2pvXf/+78DPokj7+Fz9qpU/9UXJIlhmPaTaQ6QPaz0mm+5gwkgovcV6GZzd5JtCQwgsxoHOvJO15kleRLAnMgHFIESUEPmawB9ngmelTtipwwfASilxOLyiV5UVUyVAfbG0cCPHig+GBkzAENHS0AstVF6bacZIOzgLmxsHbt2OecNgJC83JERmePUYq8ARGkJx6XtFsdddBQgZE2nPR6CICZhawjA4Fb/chv+399kfR+MMMDGOQAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_gutter-cell.ace_warning, .ace_icon.ace_warning, .ace_icon.ace_warning_fold {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAmVBMVEX///8AAAD///8AAAAAAABPSzb/5sAAAAB/blH/73z/ulkAAAAAAAD85pkAAAAAAAACAgP/vGz/rkDerGbGrV7/pkQICAf////e0IsAAAD/oED/qTvhrnUAAAD/yHD/njcAAADuv2r/nz//oTj/p064oGf/zHAAAAA9Nir/tFIAAAD/tlTiuWf/tkIAAACynXEAAAAAAAAtIRW7zBpBAAAAM3RSTlMAABR1m7RXO8Ln31Z36zT+neXe5OzooRDfn+TZ4p3h2hTf4t3k3ucyrN1K5+Xaks52Sfs9CXgrAAAAjklEQVR42o3PbQ+CIBQFYEwboPhSYgoYunIqqLn6/z8uYdH8Vmdnu9vz4WwXgN/xTPRD2+sgOcZjsge/whXZgUaYYvT8QnuJaUrjrHUQreGczuEafQCO/SJTufTbroWsPgsllVhq3wJEk2jUSzX3CUEDJC84707djRc5MTAQxoLgupWRwW6UB5fS++NV8AbOZgnsC7BpEAAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_gutter-cell.ace_info, .ace_icon.ace_info {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAJ0Uk5TAAB2k804AAAAPklEQVQY02NgIB68QuO3tiLznjAwpKTgNyDbMegwisCHZUETUZV0ZqOquBpXj2rtnpSJT1AEnnRmL2OgGgAAIKkRQap2htgAAAAASUVORK5CYII=");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n.ace_dark .ace_gutter-cell.ace_info, .ace_dark .ace_icon.ace_info {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAAChoaGAgIAqKiq+vr6tra1ZWVmUlJSbm5s8PDxubm56enrdgzg3AAAAAXRSTlMAQObYZgAAAClJREFUeNpjYMAPdsMYHegyJZFQBlsUlMFVCWUYKkAZMxZAGdxlDMQBAG+TBP4B6RyJAAAAAElFTkSuQmCC");\n}\n\n.ace_icon_svg.ace_error {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJyZWQiIHNoYXBlLXJlbmRlcmluZz0iZ2VvbWV0cmljUHJlY2lzaW9uIj4KPGNpcmNsZSBmaWxsPSJub25lIiBjeD0iOCIgY3k9IjgiIHI9IjciIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGxpbmUgeDE9IjExIiB5MT0iNSIgeDI9IjUiIHkyPSIxMSIvPgo8bGluZSB4MT0iMTEiIHkxPSIxMSIgeDI9IjUiIHkyPSI1Ii8+CjwvZz4KPC9zdmc+");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_warning {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJkYXJrb3JhbmdlIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+Cjxwb2x5Z29uIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGZpbGw9Im5vbmUiIHBvaW50cz0iOCAxIDE1IDE1IDEgMTUgOCAxIi8+CjxyZWN0IHg9IjgiIHk9IjEyIiB3aWR0aD0iMC4wMSIgaGVpZ2h0PSIwLjAxIi8+CjxsaW5lIHgxPSI4IiB5MT0iNiIgeDI9IjgiIHkyPSIxMCIvPgo8L2c+Cjwvc3ZnPg==");\n    background-color: darkorange;\n}\n.ace_icon_svg.ace_info {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJibHVlIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+CjxjaXJjbGUgZmlsbD0ibm9uZSIgY3g9IjgiIGN5PSI4IiByPSI3IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjxwb2x5bGluZSBwb2ludHM9IjggMTEgOCA4Ii8+Cjxwb2x5bGluZSBwb2ludHM9IjkgOCA2IDgiLz4KPGxpbmUgeDE9IjEwIiB5MT0iMTEiIHgyPSI2IiB5Mj0iMTEiLz4KPHJlY3QgeD0iOCIgeT0iNSIgd2lkdGg9IjAuMDEiIGhlaWdodD0iMC4wMSIvPgo8L2c+Cjwvc3ZnPg==");\n    background-color: royalblue;\n}\n\n.ace_icon_svg.ace_error_fold {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSI+CiAgPHBhdGggZD0ibSAxOC45Mjk4NTEsNy44Mjk4MDc2IGMgMC4xNDYzNTMsNi4zMzc0NjA0IC02LjMyMzE0Nyw3Ljc3Nzg0NDQgLTcuNDc3OTEyLDcuNzc3ODQ0NCAtMi4xMDcyNzI2LC0wLjEyODc1IDUuMTE3Njc4LDAuMzU2MjQ5IDUuMDUxNjk4LC03Ljg3MDA2MTggLTAuNjA0NjcyLC04LjAwMzk3MzQ5IC03LjA3NzI3MDYsLTcuNTYzMTE4OSAtNC44NTczLC03LjQzMDM5NTU2IDEuNjA2LC0wLjExNTE0MjI1IDYuODk3NDg1LDEuMjYyNTQ1OTYgNy4yODM1MTQsNy41MjI2MTI5NiB6IiBmaWxsPSJjcmltc29uIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0ibSA4LjExNDc1NjIsMi4wNTI5ODI4IGMgMy4zNDkxNjk4LDAgNi4wNjQxMzI4LDIuNjc2ODYyNyA2LjA2NDEzMjgsNS45Nzg5NTMgMCwzLjMwMjExMjIgLTIuNzE0OTYzLDUuOTc4OTIwMiAtNi4wNjQxMzI4LDUuOTc4OTIwMiAtMy4zNDkxNDczLDAgLTYuMDY0MTc3MiwtMi42NzY4MDggLTYuMDY0MTc3MiwtNS45Nzg5MjAyIDAuMDA1MzksLTMuMjk5ODg2MSAyLjcxNzI2NTYsLTUuOTczNjQwOCA2LjA2NDE3NzIsLTUuOTc4OTUzIHogbSAwLC0xLjczNTgyNzE5IGMgLTQuMzIxNDgzNiwwIC03LjgyNDc0MDM4LDMuNDU0MDE4NDkgLTcuODI0NzQwMzgsNy43MTQ3ODAxOSAwLDQuMjYwNzI4MiAzLjUwMzI1Njc4LDcuNzE0NzQ1MiA3LjgyNDc0MDM4LDcuNzE0NzQ1MiA0LjMyMTQ0OTgsMCA3LjgyNDY5OTgsLTMuNDU0MDE3IDcuODI0Njk5OCwtNy43MTQ3NDUyIDAsLTIuMDQ2MDkxNCAtMC44MjQzOTIsLTQuMDA4MzY3MiAtMi4yOTE3NTYsLTUuNDU1MTc0NiBDIDEyLjE4MDIyNSwxLjEyOTk2NDggMTAuMTkwMDEzLDAuMzE3MTU1NjEgOC4xMTQ3NTYyLDAuMzE3MTU1NjEgWiBNIDYuOTM3NDU2Myw4LjI0MDU5ODUgNC42NzE4Njg1LDEwLjQ4NTg1MiA2LjAwODY4MTQsMTEuODc2NzI4IDguMzE3MDAzNSw5LjYwMDc5MTEgMTAuNjI1MzM3LDExLjg3NjcyOCAxMS45NjIxMzgsMTAuNDg1ODUyIDkuNjk2NTUwOCw4LjI0MDU5ODUgMTEuOTYyMTM4LDYuMDA2ODA2NiAxMC41NzMyNDYsNC42Mzc0MzM1IDguMzE3MDAzNSw2Ljg3MzQyOTcgNi4wNjA3NjA3LDQuNjM3NDMzNSA0LjY3MTg2ODUsNi4wMDY4MDY2IFoiIGZpbGw9ImNyaW1zb24iIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4=");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_warning_fold {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC43NzY5IDE0LjczMzdMOC42NTE5MiAyLjQ4MzY5QzguMzI5NDYgMS44Mzg3NyA3LjQwOTEzIDEuODM4NzcgNy4wODY2NyAyLjQ4MzY5TDAuOTYxNjY5IDE0LjczMzdDMC42NzA3NzUgMTUuMzE1NSAxLjA5MzgzIDE2IDEuNzQ0MjkgMTZIMTMuOTk0M0MxNC42NDQ4IDE2IDE1LjA2NzggMTUuMzE1NSAxNC43NzY5IDE0LjczMzdaTTMuMTYwMDcgMTQuMjVMNy44NjkyOSA0LjgzMTU2TDEyLjU3ODUgMTQuMjVIMy4xNjAwN1pNOC43NDQyOSAxMS42MjVWMTMuMzc1SDYuOTk0MjlWMTEuNjI1SDguNzQ0MjlaTTYuOTk0MjkgMTAuNzVWNy4yNUg4Ljc0NDI5VjEwLjc1SDYuOTk0MjlaIiBmaWxsPSIjRUM3MjExIi8+CjxwYXRoIGQ9Ik0xMS4xOTkxIDIuOTUyMzhDMTAuODgwOSAyLjMxNDY3IDEwLjM1MzcgMS44MDUyNiA5LjcwNTUgMS41MDlMMTEuMDQxIDEuMDY5NzhDMTEuNjg4MyAwLjk0OTgxNCAxMi4zMzcgMS4yNzI2MyAxMi42MzE3IDEuODYxNDFMMTcuNjEzNiAxMS44MTYxQzE4LjM1MjcgMTMuMjkyOSAxNy41OTM4IDE1LjA4MDQgMTYuMDE4IDE1LjU3NDVDMTYuNDA0NCAxNC40NTA3IDE2LjMyMzEgMTMuMjE4OCAxNS43OTI0IDEyLjE1NTVMMTEuMTk5MSAyLjk1MjM4WiIgZmlsbD0iI0VDNzIxMSIvPgo8L3N2Zz4=");\n    background-color: darkorange;\n}\n\n.ace_scrollbar {\n    contain: strict;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    z-index: 6;\n}\n\n.ace_scrollbar-inner {\n    position: absolute;\n    cursor: text;\n    left: 0;\n    top: 0;\n}\n\n.ace_scrollbar-v{\n    overflow-x: hidden;\n    overflow-y: scroll;\n    top: 0;\n}\n\n.ace_scrollbar-h {\n    overflow-x: scroll;\n    overflow-y: hidden;\n    left: 0;\n}\n\n.ace_print-margin {\n    position: absolute;\n    height: 100%;\n}\n\n.ace_text-input {\n    position: absolute;\n    z-index: 0;\n    width: 0.5em;\n    height: 1em;\n    opacity: 0;\n    background: transparent;\n    -moz-appearance: none;\n    appearance: none;\n    border: none;\n    resize: none;\n    outline: none;\n    overflow: hidden;\n    font: inherit;\n    padding: 0 1px;\n    margin: 0 -1px;\n    contain: strict;\n    -ms-user-select: text;\n    -moz-user-select: text;\n    -webkit-user-select: text;\n    user-select: text;\n    /*with `pre-line` chrome inserts &nbsp; instead of space*/\n    white-space: pre!important;\n}\n.ace_text-input.ace_composition {\n    background: transparent;\n    color: inherit;\n    z-index: 1000;\n    opacity: 1;\n}\n.ace_composition_placeholder { color: transparent }\n.ace_composition_marker { \n    border-bottom: 1px solid;\n    position: absolute;\n    border-radius: 0;\n    margin-top: 1px;\n}\n\n[ace_nocontext=true] {\n    transform: none!important;\n    filter: none!important;\n    clip-path: none!important;\n    mask : none!important;\n    contain: none!important;\n    perspective: none!important;\n    mix-blend-mode: initial!important;\n    z-index: auto;\n}\n\n.ace_layer {\n    z-index: 1;\n    position: absolute;\n    overflow: hidden;\n    /* workaround for chrome bug https://github.com/ajaxorg/ace/issues/2312*/\n    word-wrap: normal;\n    white-space: pre;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    /* setting pointer-events: auto; on node under the mouse, which changes\n        during scroll, will break mouse wheel scrolling in Safari */\n    pointer-events: none;\n}\n\n.ace_gutter-layer {\n    position: relative;\n    width: auto;\n    text-align: right;\n    pointer-events: auto;\n    height: 1000000px;\n    contain: style size layout;\n}\n\n.ace_text-layer {\n    font: inherit !important;\n    position: absolute;\n    height: 1000000px;\n    width: 1000000px;\n    contain: style size layout;\n}\n\n.ace_text-layer > .ace_line, .ace_text-layer > .ace_line_group {\n    contain: style size layout;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n}\n\n.ace_hidpi .ace_text-layer,\n.ace_hidpi .ace_gutter-layer,\n.ace_hidpi .ace_content,\n.ace_hidpi .ace_gutter {\n    contain: strict;\n}\n.ace_hidpi .ace_text-layer > .ace_line, \n.ace_hidpi .ace_text-layer > .ace_line_group {\n    contain: strict;\n}\n\n.ace_cjk {\n    display: inline-block;\n    text-align: center;\n}\n\n.ace_cursor-layer {\n    z-index: 4;\n}\n\n.ace_cursor {\n    z-index: 4;\n    position: absolute;\n    box-sizing: border-box;\n    border-left: 2px solid;\n    /* workaround for smooth cursor repaintng whole screen in chrome */\n    transform: translatez(0);\n}\n\n.ace_multiselect .ace_cursor {\n    border-left-width: 1px;\n}\n\n.ace_slim-cursors .ace_cursor {\n    border-left-width: 1px;\n}\n\n.ace_overwrite-cursors .ace_cursor {\n    border-left-width: 0;\n    border-bottom: 1px solid;\n}\n\n.ace_hidden-cursors .ace_cursor {\n    opacity: 0.2;\n}\n\n.ace_hasPlaceholder .ace_hidden-cursors .ace_cursor {\n    opacity: 0;\n}\n\n.ace_smooth-blinking .ace_cursor {\n    transition: opacity 0.18s;\n}\n\n.ace_animate-blinking .ace_cursor {\n    animation-duration: 1000ms;\n    animation-timing-function: step-end;\n    animation-name: blink-ace-animate;\n    animation-iteration-count: infinite;\n}\n\n.ace_animate-blinking.ace_smooth-blinking .ace_cursor {\n    animation-duration: 1000ms;\n    animation-timing-function: ease-in-out;\n    animation-name: blink-ace-animate-smooth;\n}\n    \n@keyframes blink-ace-animate {\n    from, to { opacity: 1; }\n    60% { opacity: 0; }\n}\n\n@keyframes blink-ace-animate-smooth {\n    from, to { opacity: 1; }\n    45% { opacity: 1; }\n    60% { opacity: 0; }\n    85% { opacity: 0; }\n}\n\n.ace_marker-layer .ace_step, .ace_marker-layer .ace_stack {\n    position: absolute;\n    z-index: 3;\n}\n\n.ace_marker-layer .ace_selection {\n    position: absolute;\n    z-index: 5;\n}\n\n.ace_marker-layer .ace_bracket {\n    position: absolute;\n    z-index: 6;\n}\n\n.ace_marker-layer .ace_error_bracket {\n    position: absolute;\n    border-bottom: 1px solid #DE5555;\n    border-radius: 0;\n}\n\n.ace_marker-layer .ace_active-line {\n    position: absolute;\n    z-index: 2;\n}\n\n.ace_marker-layer .ace_selected-word {\n    position: absolute;\n    z-index: 4;\n    box-sizing: border-box;\n}\n\n.ace_line .ace_fold {\n    box-sizing: border-box;\n\n    display: inline-block;\n    height: 11px;\n    margin-top: -2px;\n    vertical-align: middle;\n\n    background-image:\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACJJREFUeNpi+P//fxgTAwPDBxDxD078RSX+YeEyDFMCIMAAI3INmXiwf2YAAAAASUVORK5CYII=");\n    background-repeat: no-repeat, repeat-x;\n    background-position: center center, top left;\n    color: transparent;\n\n    border: 1px solid black;\n    border-radius: 2px;\n\n    cursor: pointer;\n    pointer-events: auto;\n}\n\n.ace_dark .ace_fold {\n}\n\n.ace_fold:hover{\n    background-image:\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACBJREFUeNpi+P//fz4TAwPDZxDxD5X4i5fLMEwJgAADAEPVDbjNw87ZAAAAAElFTkSuQmCC");\n}\n\n.ace_tooltip {\n    background-color: #f5f5f5;\n    border: 1px solid gray;\n    border-radius: 1px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n    color: black;\n    max-width: 100%;\n    padding: 3px 4px;\n    position: fixed;\n    z-index: 999999;\n    box-sizing: border-box;\n    cursor: default;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    line-height: normal;\n    font-style: normal;\n    font-weight: normal;\n    letter-spacing: normal;\n    pointer-events: none;\n    overflow: auto;\n    max-width: min(60em, 66vw);\n    overscroll-behavior: contain;\n}\n.ace_tooltip pre {\n    white-space: pre-wrap;\n}\n\n.ace_tooltip.ace_dark {\n    background-color: #636363;\n    color: #fff;\n}\n\n.ace_tooltip:focus {\n    outline: 1px solid #5E9ED6;\n}\n\n.ace_icon {\n    display: inline-block;\n    width: 18px;\n    vertical-align: top;\n}\n\n.ace_icon_svg {\n    display: inline-block;\n    width: 12px;\n    vertical-align: top;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-size: 12px;\n    -webkit-mask-position: center;\n}\n\n.ace_folding-enabled > .ace_gutter-cell, .ace_folding-enabled > .ace_gutter-cell_svg-icons {\n    padding-right: 13px;\n}\n\n.ace_fold-widget {\n    box-sizing: border-box;\n\n    margin: 0 -12px 0 1px;\n    display: none;\n    width: 11px;\n    vertical-align: top;\n\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42mWKsQ0AMAzC8ixLlrzQjzmBiEjp0A6WwBCSPgKAXoLkqSot7nN3yMwR7pZ32NzpKkVoDBUxKAAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: center;\n\n    border-radius: 3px;\n    \n    border: 1px solid transparent;\n    cursor: pointer;\n}\n\n.ace_folding-enabled .ace_fold-widget {\n    display: inline-block;   \n}\n\n.ace_fold-widget.ace_end {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42m3HwQkAMAhD0YzsRchFKI7sAikeWkrxwScEB0nh5e7KTPWimZki4tYfVbX+MNl4pyZXejUO1QAAAABJRU5ErkJggg==");\n}\n\n.ace_fold-widget.ace_closed {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAAOUlEQVR42jXKwQkAMAgDwKwqKD4EwQ26sSOkVWjgIIHAzPiCgaqiqnJHZnKICBERHN194O5b9vbLuAVRL+l0YWnZAAAAAElFTkSuQmCCXA==");\n}\n\n.ace_fold-widget:hover {\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: rgba(255, 255, 255, 0.2);\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);\n}\n\n.ace_fold-widget:active {\n    border: 1px solid rgba(0, 0, 0, 0.4);\n    background-color: rgba(0, 0, 0, 0.05);\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.8);\n}\n/**\n * Dark version for fold widgets\n */\n.ace_dark .ace_fold-widget {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVQIW2P4//8/AzoGEQ7oGCaLLAhWiSwB146BAQCSTPYocqT0AAAAAElFTkSuQmCC");\n}\n.ace_dark .ace_fold-widget.ace_end {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAH0lEQVQIW2P4//8/AxQ7wNjIAjDMgC4AxjCVKBirIAAF0kz2rlhxpAAAAABJRU5ErkJggg==");\n}\n.ace_dark .ace_fold-widget.ace_closed {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAAHElEQVQIW2P4//+/AxAzgDADlOOAznHAKgPWAwARji8UIDTfQQAAAABJRU5ErkJggg==");\n}\n.ace_dark .ace_fold-widget:hover {\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\n    background-color: rgba(255, 255, 255, 0.1);\n}\n.ace_dark .ace_fold-widget:active {\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\n}\n\n.ace_inline_button {\n    border: 1px solid lightgray;\n    display: inline-block;\n    margin: -1px 8px;\n    padding: 0 5px;\n    pointer-events: auto;\n    cursor: pointer;\n}\n.ace_inline_button:hover {\n    border-color: gray;\n    background: rgba(200,200,200,0.2);\n    display: inline-block;\n    pointer-events: auto;\n}\n\n.ace_fold-widget.ace_invalid {\n    background-color: #FFB4B4;\n    border-color: #DE5555;\n}\n\n.ace_fade-fold-widgets .ace_fold-widget {\n    transition: opacity 0.4s ease 0.05s;\n    opacity: 0;\n}\n\n.ace_fade-fold-widgets:hover .ace_fold-widget {\n    transition: opacity 0.05s ease 0.05s;\n    opacity:1;\n}\n\n.ace_underline {\n    text-decoration: underline;\n}\n\n.ace_bold {\n    font-weight: bold;\n}\n\n.ace_nobold .ace_bold {\n    font-weight: normal;\n}\n\n.ace_italic {\n    font-style: italic;\n}\n\n\n.ace_error-marker {\n    background-color: rgba(255, 0, 0,0.2);\n    position: absolute;\n    z-index: 9;\n}\n\n.ace_highlight-marker {\n    background-color: rgba(255, 255, 0,0.2);\n    position: absolute;\n    z-index: 8;\n}\n\n.ace_mobile-menu {\n    position: absolute;\n    line-height: 1.5;\n    border-radius: 4px;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    background: white;\n    box-shadow: 1px 3px 2px grey;\n    border: 1px solid #dcdcdc;\n    color: black;\n}\n.ace_dark > .ace_mobile-menu {\n    background: #333;\n    color: #ccc;\n    box-shadow: 1px 3px 2px grey;\n    border: 1px solid #444;\n\n}\n.ace_mobile-button {\n    padding: 2px;\n    cursor: pointer;\n    overflow: hidden;\n}\n.ace_mobile-button:hover {\n    background-color: #eee;\n    opacity:1;\n}\n.ace_mobile-button:active {\n    background-color: #ddd;\n}\n\n.ace_placeholder {\n    font-family: arial;\n    transform: scale(0.9);\n    transform-origin: left;\n    white-space: pre;\n    opacity: 0.7;\n    margin: 0 10px;\n}\n\n.ace_ghost_text {\n    opacity: 0.5;\n    font-style: italic;\n}\n\n.ace_ghost_text > div {\n    white-space: pre;\n}\n\n.ghost_text_line_wrapped::after {\n    content: "\u21A9";\n    position: absolute;\n}\n\n.ace_lineWidgetContainer.ace_ghost_text {\n    margin: 0px 4px\n}\n\n.ace_screenreader-only {\n    position:absolute;\n    left:-10000px;\n    top:auto;\n    width:1px;\n    height:1px;\n    overflow:hidden;\n}';
});
ace.define("ace/layer/decorators", [
    "require",
    "exports",
    "module",
    "ace/lib/dom",
    "ace/lib/oop",
    "ace/lib/event_emitter"
], function(require, exports, module1) {
    "use strict";
    var dom = require("../lib/dom");
    var oop = require("../lib/oop");
    var EventEmitter = require("../lib/event_emitter").EventEmitter;
    var Decorator = /** @class */ function() {
        function Decorator(parent, renderer) {
            this.canvas = dom.createElement("canvas");
            this.renderer = renderer;
            this.pixelRatio = 1;
            this.maxHeight = renderer.layerConfig.maxHeight;
            this.lineHeight = renderer.layerConfig.lineHeight;
            this.canvasHeight = parent.parent.scrollHeight;
            this.heightRatio = this.canvasHeight / this.maxHeight;
            this.canvasWidth = parent.width;
            this.minDecorationHeight = 2 * this.pixelRatio | 0;
            this.halfMinDecorationHeight = this.minDecorationHeight / 2 | 0;
            this.canvas.width = this.canvasWidth;
            this.canvas.height = this.canvasHeight;
            this.canvas.style.top = "0px";
            this.canvas.style.right = "0px";
            this.canvas.style.zIndex = "7px";
            this.canvas.style.position = "absolute";
            this.colors = {};
            this.colors.dark = {
                "error": "rgba(255, 18, 18, 1)",
                "warning": "rgba(18, 136, 18, 1)",
                "info": "rgba(18, 18, 136, 1)"
            };
            this.colors.light = {
                "error": "rgb(255,51,51)",
                "warning": "rgb(32,133,72)",
                "info": "rgb(35,68,138)"
            };
            parent.element.appendChild(this.canvas);
        }
        Decorator.prototype.$updateDecorators = function(config) {
            var colors = this.renderer.theme.isDark === true ? this.colors.dark : this.colors.light;
            if (config) {
                this.maxHeight = config.maxHeight;
                this.lineHeight = config.lineHeight;
                this.canvasHeight = config.height;
                var allLineHeight = (config.lastRow + 1) * this.lineHeight;
                if (allLineHeight < this.canvasHeight) this.heightRatio = 1;
                else this.heightRatio = this.canvasHeight / this.maxHeight;
            }
            var ctx = this.canvas.getContext("2d");
            function compare(a, b) {
                if (a.priority < b.priority) return -1;
                if (a.priority > b.priority) return 1;
                return 0;
            }
            var annotations = this.renderer.session.$annotations;
            ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            if (annotations) {
                var priorities = {
                    "info": 1,
                    "warning": 2,
                    "error": 3
                };
                annotations.forEach(function(item) {
                    item.priority = priorities[item.type] || null;
                });
                annotations = annotations.sort(compare);
                var foldData = this.renderer.session.$foldData;
                for(var i = 0; i < annotations.length; i++){
                    var row = annotations[i].row;
                    var compensateFold = this.compensateFoldRows(row, foldData);
                    var currentY = Math.round((row - compensateFold) * this.lineHeight * this.heightRatio);
                    var y1 = Math.round((row - compensateFold) * this.lineHeight * this.heightRatio);
                    var y2 = Math.round(((row - compensateFold) * this.lineHeight + this.lineHeight) * this.heightRatio);
                    var height = y2 - y1;
                    if (height < this.minDecorationHeight) {
                        var yCenter = (y1 + y2) / 2 | 0;
                        if (yCenter < this.halfMinDecorationHeight) yCenter = this.halfMinDecorationHeight;
                        else if (yCenter + this.halfMinDecorationHeight > this.canvasHeight) yCenter = this.canvasHeight - this.halfMinDecorationHeight;
                        y1 = Math.round(yCenter - this.halfMinDecorationHeight);
                        y2 = Math.round(yCenter + this.halfMinDecorationHeight);
                    }
                    ctx.fillStyle = colors[annotations[i].type] || null;
                    ctx.fillRect(0, currentY, this.canvasWidth, y2 - y1);
                }
            }
            var cursor = this.renderer.session.selection.getCursor();
            if (cursor) {
                var compensateFold = this.compensateFoldRows(cursor.row, foldData);
                var currentY = Math.round((cursor.row - compensateFold) * this.lineHeight * this.heightRatio);
                ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
                ctx.fillRect(0, currentY, this.canvasWidth, 2);
            }
        };
        Decorator.prototype.compensateFoldRows = function(row, foldData) {
            var compensateFold = 0;
            if (foldData && foldData.length > 0) for(var j = 0; j < foldData.length; j++){
                if (row > foldData[j].start.row && row < foldData[j].end.row) compensateFold += row - foldData[j].start.row;
                else if (row >= foldData[j].end.row) compensateFold += foldData[j].end.row - foldData[j].start.row;
            }
            return compensateFold;
        };
        return Decorator;
    }();
    oop.implement(Decorator.prototype, EventEmitter);
    exports.Decorator = Decorator;
});
ace.define("ace/virtual_renderer", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/lib/lang",
    "ace/config",
    "ace/layer/gutter",
    "ace/layer/marker",
    "ace/layer/text",
    "ace/layer/cursor",
    "ace/scrollbar",
    "ace/scrollbar",
    "ace/scrollbar_custom",
    "ace/scrollbar_custom",
    "ace/renderloop",
    "ace/layer/font_metrics",
    "ace/lib/event_emitter",
    "ace/css/editor-css",
    "ace/layer/decorators",
    "ace/lib/useragent"
], function(require, exports, module1) {
    "use strict";
    var oop = require("./lib/oop");
    var dom = require("./lib/dom");
    var lang = require("./lib/lang");
    var config = require("./config");
    var GutterLayer = require("./layer/gutter").Gutter;
    var MarkerLayer = require("./layer/marker").Marker;
    var TextLayer = require("./layer/text").Text;
    var CursorLayer = require("./layer/cursor").Cursor;
    var HScrollBar = require("./scrollbar").HScrollBar;
    var VScrollBar = require("./scrollbar").VScrollBar;
    var HScrollBarCustom = require("./scrollbar_custom").HScrollBar;
    var VScrollBarCustom = require("./scrollbar_custom").VScrollBar;
    var RenderLoop = require("./renderloop").RenderLoop;
    var FontMetrics = require("./layer/font_metrics").FontMetrics;
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var editorCss = require("./css/editor-css");
    var Decorator = require("./layer/decorators").Decorator;
    var useragent = require("./lib/useragent");
    dom.importCssString(editorCss, "ace_editor.css", false);
    var VirtualRenderer = /** @class */ function() {
        function VirtualRenderer(container, theme) {
            var _self = this;
            this.container = container || dom.createElement("div");
            dom.addCssClass(this.container, "ace_editor");
            if (dom.HI_DPI) dom.addCssClass(this.container, "ace_hidpi");
            this.setTheme(theme);
            if (config.get("useStrictCSP") == null) config.set("useStrictCSP", false);
            this.$gutter = dom.createElement("div");
            this.$gutter.className = "ace_gutter";
            this.container.appendChild(this.$gutter);
            this.$gutter.setAttribute("aria-hidden", "true");
            this.scroller = dom.createElement("div");
            this.scroller.className = "ace_scroller";
            this.container.appendChild(this.scroller);
            this.content = dom.createElement("div");
            this.content.className = "ace_content";
            this.scroller.appendChild(this.content);
            this.$gutterLayer = new GutterLayer(this.$gutter);
            this.$gutterLayer.on("changeGutterWidth", this.onGutterResize.bind(this));
            this.$markerBack = new MarkerLayer(this.content);
            var textLayer = this.$textLayer = new TextLayer(this.content);
            this.canvas = textLayer.element;
            this.$markerFront = new MarkerLayer(this.content);
            this.$cursorLayer = new CursorLayer(this.content);
            this.$horizScroll = false;
            this.$vScroll = false;
            this.scrollBar = this.scrollBarV = new VScrollBar(this.container, this);
            this.scrollBarH = new HScrollBar(this.container, this);
            this.scrollBarV.on("scroll", function(e) {
                if (!_self.$scrollAnimation) _self.session.setScrollTop(e.data - _self.scrollMargin.top);
            });
            this.scrollBarH.on("scroll", function(e) {
                if (!_self.$scrollAnimation) _self.session.setScrollLeft(e.data - _self.scrollMargin.left);
            });
            this.scrollTop = 0;
            this.scrollLeft = 0;
            this.cursorPos = {
                row: 0,
                column: 0
            };
            this.$fontMetrics = new FontMetrics(this.container);
            this.$textLayer.$setFontMetrics(this.$fontMetrics);
            this.$textLayer.on("changeCharacterSize", function(e) {
                _self.updateCharacterSize();
                _self.onResize(true, _self.gutterWidth, _self.$size.width, _self.$size.height);
                _self._signal("changeCharacterSize", e);
            });
            this.$size = {
                width: 0,
                height: 0,
                scrollerHeight: 0,
                scrollerWidth: 0,
                $dirty: true
            };
            this.layerConfig = {
                width: 1,
                padding: 0,
                firstRow: 0,
                firstRowScreen: 0,
                lastRow: 0,
                lineHeight: 0,
                characterWidth: 0,
                minHeight: 1,
                maxHeight: 1,
                offset: 0,
                height: 1,
                gutterOffset: 1
            };
            this.scrollMargin = {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                v: 0,
                h: 0
            };
            this.margin = {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                v: 0,
                h: 0
            };
            this.$keepTextAreaAtCursor = !useragent.isIOS;
            this.$loop = new RenderLoop(this.$renderChanges.bind(this), this.container.ownerDocument.defaultView);
            this.$loop.schedule(this.CHANGE_FULL);
            this.updateCharacterSize();
            this.setPadding(4);
            this.$addResizeObserver();
            config.resetOptions(this);
            config._signal("renderer", this);
        }
        VirtualRenderer.prototype.updateCharacterSize = function() {
            if (this.$textLayer.allowBoldFonts != this.$allowBoldFonts) {
                this.$allowBoldFonts = this.$textLayer.allowBoldFonts;
                this.setStyle("ace_nobold", !this.$allowBoldFonts);
            }
            this.layerConfig.characterWidth = this.characterWidth = this.$textLayer.getCharacterWidth();
            this.layerConfig.lineHeight = this.lineHeight = this.$textLayer.getLineHeight();
            this.$updatePrintMargin();
            dom.setStyle(this.scroller.style, "line-height", this.lineHeight + "px");
        };
        VirtualRenderer.prototype.setSession = function(session) {
            if (this.session) this.session.doc.off("changeNewLineMode", this.onChangeNewLineMode);
            this.session = session;
            if (session && this.scrollMargin.top && session.getScrollTop() <= 0) session.setScrollTop(-this.scrollMargin.top);
            this.$cursorLayer.setSession(session);
            this.$markerBack.setSession(session);
            this.$markerFront.setSession(session);
            this.$gutterLayer.setSession(session);
            this.$textLayer.setSession(session);
            if (!session) return;
            this.$loop.schedule(this.CHANGE_FULL);
            this.session.$setFontMetrics(this.$fontMetrics);
            this.scrollBarH.scrollLeft = this.scrollBarV.scrollTop = null;
            this.onChangeNewLineMode = this.onChangeNewLineMode.bind(this);
            this.onChangeNewLineMode();
            this.session.doc.on("changeNewLineMode", this.onChangeNewLineMode);
        };
        VirtualRenderer.prototype.updateLines = function(firstRow, lastRow, force) {
            if (lastRow === undefined) lastRow = Infinity;
            if (!this.$changedLines) this.$changedLines = {
                firstRow: firstRow,
                lastRow: lastRow
            };
            else {
                if (this.$changedLines.firstRow > firstRow) this.$changedLines.firstRow = firstRow;
                if (this.$changedLines.lastRow < lastRow) this.$changedLines.lastRow = lastRow;
            }
            if (this.$changedLines.lastRow < this.layerConfig.firstRow) {
                if (force) this.$changedLines.lastRow = this.layerConfig.lastRow;
                else return;
            }
            if (this.$changedLines.firstRow > this.layerConfig.lastRow) return;
            this.$loop.schedule(this.CHANGE_LINES);
        };
        VirtualRenderer.prototype.onChangeNewLineMode = function() {
            this.$loop.schedule(this.CHANGE_TEXT);
            this.$textLayer.$updateEolChar();
            this.session.$bidiHandler.setEolChar(this.$textLayer.EOL_CHAR);
        };
        VirtualRenderer.prototype.onChangeTabSize = function() {
            this.$loop.schedule(this.CHANGE_TEXT | this.CHANGE_MARKER);
            this.$textLayer.onChangeTabSize();
        };
        VirtualRenderer.prototype.updateText = function() {
            this.$loop.schedule(this.CHANGE_TEXT);
        };
        VirtualRenderer.prototype.updateFull = function(force) {
            if (force) this.$renderChanges(this.CHANGE_FULL, true);
            else this.$loop.schedule(this.CHANGE_FULL);
        };
        VirtualRenderer.prototype.updateFontSize = function() {
            this.$textLayer.checkForSizeChanges();
        };
        VirtualRenderer.prototype.$updateSizeAsync = function() {
            if (this.$loop.pending) this.$size.$dirty = true;
            else this.onResize();
        };
        VirtualRenderer.prototype.onResize = function(force, gutterWidth, width, height) {
            if (this.resizing > 2) return;
            else if (this.resizing > 0) this.resizing++;
            else this.resizing = force ? 1 : 0;
            var el = this.container;
            if (!height) height = el.clientHeight || el.scrollHeight;
            if (!height && this.$maxLines && this.lineHeight > 1) {
                if (!el.style.height || el.style.height == "0px") {
                    el.style.height = "1px";
                    height = el.clientHeight || el.scrollHeight;
                }
            }
            if (!width) width = el.clientWidth || el.scrollWidth;
            var changes = this.$updateCachedSize(force, gutterWidth, width, height);
            if (this.$resizeTimer) this.$resizeTimer.cancel();
            if (!this.$size.scrollerHeight || !width && !height) return this.resizing = 0;
            if (force) this.$gutterLayer.$padding = null;
            if (force) this.$renderChanges(changes | this.$changes, true);
            else this.$loop.schedule(changes | this.$changes);
            if (this.resizing) this.resizing = 0;
            this.scrollBarH.scrollLeft = this.scrollBarV.scrollTop = null;
            if (this.$customScrollbar) this.$updateCustomScrollbar(true);
        };
        VirtualRenderer.prototype.$updateCachedSize = function(force, gutterWidth, width, height) {
            height -= this.$extraHeight || 0;
            var changes = 0;
            var size = this.$size;
            var oldSize = {
                width: size.width,
                height: size.height,
                scrollerHeight: size.scrollerHeight,
                scrollerWidth: size.scrollerWidth
            };
            if (height && (force || size.height != height)) {
                size.height = height;
                changes |= this.CHANGE_SIZE;
                size.scrollerHeight = size.height;
                if (this.$horizScroll) size.scrollerHeight -= this.scrollBarH.getHeight();
                this.scrollBarV.setHeight(size.scrollerHeight);
                this.scrollBarV.element.style.bottom = this.scrollBarH.getHeight() + "px";
                changes = changes | this.CHANGE_SCROLL;
            }
            if (width && (force || size.width != width)) {
                changes |= this.CHANGE_SIZE;
                size.width = width;
                if (gutterWidth == null) gutterWidth = this.$showGutter ? this.$gutter.offsetWidth : 0;
                this.gutterWidth = gutterWidth;
                dom.setStyle(this.scrollBarH.element.style, "left", gutterWidth + "px");
                dom.setStyle(this.scroller.style, "left", gutterWidth + this.margin.left + "px");
                size.scrollerWidth = Math.max(0, width - gutterWidth - this.scrollBarV.getWidth() - this.margin.h);
                dom.setStyle(this.$gutter.style, "left", this.margin.left + "px");
                var right = this.scrollBarV.getWidth() + "px";
                dom.setStyle(this.scrollBarH.element.style, "right", right);
                dom.setStyle(this.scroller.style, "right", right);
                dom.setStyle(this.scroller.style, "bottom", this.scrollBarH.getHeight());
                this.scrollBarH.setWidth(size.scrollerWidth);
                if (this.session && this.session.getUseWrapMode() && this.adjustWrapLimit() || force) changes |= this.CHANGE_FULL;
            }
            size.$dirty = !width || !height;
            if (changes) this._signal("resize", oldSize);
            return changes;
        };
        VirtualRenderer.prototype.onGutterResize = function(width) {
            var gutterWidth = this.$showGutter ? width : 0;
            if (gutterWidth != this.gutterWidth) this.$changes |= this.$updateCachedSize(true, gutterWidth, this.$size.width, this.$size.height);
            if (this.session.getUseWrapMode() && this.adjustWrapLimit()) this.$loop.schedule(this.CHANGE_FULL);
            else if (this.$size.$dirty) this.$loop.schedule(this.CHANGE_FULL);
            else this.$computeLayerConfig();
        };
        VirtualRenderer.prototype.adjustWrapLimit = function() {
            var availableWidth = this.$size.scrollerWidth - this.$padding * 2;
            var limit = Math.floor(availableWidth / this.characterWidth);
            return this.session.adjustWrapLimit(limit, this.$showPrintMargin && this.$printMarginColumn);
        };
        VirtualRenderer.prototype.setAnimatedScroll = function(shouldAnimate) {
            this.setOption("animatedScroll", shouldAnimate);
        };
        VirtualRenderer.prototype.getAnimatedScroll = function() {
            return this.$animatedScroll;
        };
        VirtualRenderer.prototype.setShowInvisibles = function(showInvisibles) {
            this.setOption("showInvisibles", showInvisibles);
            this.session.$bidiHandler.setShowInvisibles(showInvisibles);
        };
        VirtualRenderer.prototype.getShowInvisibles = function() {
            return this.getOption("showInvisibles");
        };
        VirtualRenderer.prototype.getDisplayIndentGuides = function() {
            return this.getOption("displayIndentGuides");
        };
        VirtualRenderer.prototype.setDisplayIndentGuides = function(display) {
            this.setOption("displayIndentGuides", display);
        };
        VirtualRenderer.prototype.getHighlightIndentGuides = function() {
            return this.getOption("highlightIndentGuides");
        };
        VirtualRenderer.prototype.setHighlightIndentGuides = function(highlight) {
            this.setOption("highlightIndentGuides", highlight);
        };
        VirtualRenderer.prototype.setShowPrintMargin = function(showPrintMargin) {
            this.setOption("showPrintMargin", showPrintMargin);
        };
        VirtualRenderer.prototype.getShowPrintMargin = function() {
            return this.getOption("showPrintMargin");
        };
        VirtualRenderer.prototype.setPrintMarginColumn = function(printMarginColumn) {
            this.setOption("printMarginColumn", printMarginColumn);
        };
        VirtualRenderer.prototype.getPrintMarginColumn = function() {
            return this.getOption("printMarginColumn");
        };
        VirtualRenderer.prototype.getShowGutter = function() {
            return this.getOption("showGutter");
        };
        VirtualRenderer.prototype.setShowGutter = function(show) {
            return this.setOption("showGutter", show);
        };
        VirtualRenderer.prototype.getFadeFoldWidgets = function() {
            return this.getOption("fadeFoldWidgets");
        };
        VirtualRenderer.prototype.setFadeFoldWidgets = function(show) {
            this.setOption("fadeFoldWidgets", show);
        };
        VirtualRenderer.prototype.setHighlightGutterLine = function(shouldHighlight) {
            this.setOption("highlightGutterLine", shouldHighlight);
        };
        VirtualRenderer.prototype.getHighlightGutterLine = function() {
            return this.getOption("highlightGutterLine");
        };
        VirtualRenderer.prototype.$updatePrintMargin = function() {
            if (!this.$showPrintMargin && !this.$printMarginEl) return;
            if (!this.$printMarginEl) {
                var containerEl = dom.createElement("div");
                containerEl.className = "ace_layer ace_print-margin-layer";
                this.$printMarginEl = dom.createElement("div");
                this.$printMarginEl.className = "ace_print-margin";
                containerEl.appendChild(this.$printMarginEl);
                this.content.insertBefore(containerEl, this.content.firstChild);
            }
            var style = this.$printMarginEl.style;
            style.left = Math.round(this.characterWidth * this.$printMarginColumn + this.$padding) + "px";
            style.visibility = this.$showPrintMargin ? "visible" : "hidden";
            if (this.session && this.session.$wrap == -1) this.adjustWrapLimit();
        };
        VirtualRenderer.prototype.getContainerElement = function() {
            return this.container;
        };
        VirtualRenderer.prototype.getMouseEventTarget = function() {
            return this.scroller;
        };
        VirtualRenderer.prototype.getTextAreaContainer = function() {
            return this.container;
        };
        VirtualRenderer.prototype.$moveTextAreaToCursor = function() {
            if (this.$isMousePressed) return;
            var style = this.textarea.style;
            var composition = this.$composition;
            if (!this.$keepTextAreaAtCursor && !composition) {
                dom.translate(this.textarea, -100, 0);
                return;
            }
            var pixelPos = this.$cursorLayer.$pixelPos;
            if (!pixelPos) return;
            if (composition && composition.markerRange) pixelPos = this.$cursorLayer.getPixelPosition(composition.markerRange.start, true);
            var config = this.layerConfig;
            var posTop = pixelPos.top;
            var posLeft = pixelPos.left;
            posTop -= config.offset;
            var h = composition && composition.useTextareaForIME || useragent.isMobile ? this.lineHeight : 1;
            if (posTop < 0 || posTop > config.height - h) {
                dom.translate(this.textarea, 0, 0);
                return;
            }
            var w = 1;
            var maxTop = this.$size.height - h;
            if (!composition) posTop += this.lineHeight;
            else if (composition.useTextareaForIME) {
                var val = this.textarea.value;
                w = this.characterWidth * this.session.$getStringScreenWidth(val)[0];
            } else posTop += this.lineHeight + 2;
            posLeft -= this.scrollLeft;
            if (posLeft > this.$size.scrollerWidth - w) posLeft = this.$size.scrollerWidth - w;
            posLeft += this.gutterWidth + this.margin.left;
            dom.setStyle(style, "height", h + "px");
            dom.setStyle(style, "width", w + "px");
            dom.translate(this.textarea, Math.min(posLeft, this.$size.scrollerWidth - w), Math.min(posTop, maxTop));
        };
        VirtualRenderer.prototype.getFirstVisibleRow = function() {
            return this.layerConfig.firstRow;
        };
        VirtualRenderer.prototype.getFirstFullyVisibleRow = function() {
            return this.layerConfig.firstRow + (this.layerConfig.offset === 0 ? 0 : 1);
        };
        VirtualRenderer.prototype.getLastFullyVisibleRow = function() {
            var config = this.layerConfig;
            var lastRow = config.lastRow;
            var top = this.session.documentToScreenRow(lastRow, 0) * config.lineHeight;
            if (top - this.session.getScrollTop() > config.height - config.lineHeight) return lastRow - 1;
            return lastRow;
        };
        VirtualRenderer.prototype.getLastVisibleRow = function() {
            return this.layerConfig.lastRow;
        };
        VirtualRenderer.prototype.setPadding = function(padding) {
            this.$padding = padding;
            this.$textLayer.setPadding(padding);
            this.$cursorLayer.setPadding(padding);
            this.$markerFront.setPadding(padding);
            this.$markerBack.setPadding(padding);
            this.$loop.schedule(this.CHANGE_FULL);
            this.$updatePrintMargin();
        };
        VirtualRenderer.prototype.setScrollMargin = function(top, bottom, left, right) {
            var sm = this.scrollMargin;
            sm.top = top | 0;
            sm.bottom = bottom | 0;
            sm.right = right | 0;
            sm.left = left | 0;
            sm.v = sm.top + sm.bottom;
            sm.h = sm.left + sm.right;
            if (sm.top && this.scrollTop <= 0 && this.session) this.session.setScrollTop(-sm.top);
            this.updateFull();
        };
        VirtualRenderer.prototype.setMargin = function(top, bottom, left, right) {
            var sm = this.margin;
            sm.top = top | 0;
            sm.bottom = bottom | 0;
            sm.right = right | 0;
            sm.left = left | 0;
            sm.v = sm.top + sm.bottom;
            sm.h = sm.left + sm.right;
            this.$updateCachedSize(true, this.gutterWidth, this.$size.width, this.$size.height);
            this.updateFull();
        };
        VirtualRenderer.prototype.getHScrollBarAlwaysVisible = function() {
            return this.$hScrollBarAlwaysVisible;
        };
        VirtualRenderer.prototype.setHScrollBarAlwaysVisible = function(alwaysVisible) {
            this.setOption("hScrollBarAlwaysVisible", alwaysVisible);
        };
        VirtualRenderer.prototype.getVScrollBarAlwaysVisible = function() {
            return this.$vScrollBarAlwaysVisible;
        };
        VirtualRenderer.prototype.setVScrollBarAlwaysVisible = function(alwaysVisible) {
            this.setOption("vScrollBarAlwaysVisible", alwaysVisible);
        };
        VirtualRenderer.prototype.$updateScrollBarV = function() {
            var scrollHeight = this.layerConfig.maxHeight;
            var scrollerHeight = this.$size.scrollerHeight;
            if (!this.$maxLines && this.$scrollPastEnd) {
                scrollHeight -= (scrollerHeight - this.lineHeight) * this.$scrollPastEnd;
                if (this.scrollTop > scrollHeight - scrollerHeight) {
                    scrollHeight = this.scrollTop + scrollerHeight;
                    this.scrollBarV.scrollTop = null;
                }
            }
            this.scrollBarV.setScrollHeight(scrollHeight + this.scrollMargin.v);
            this.scrollBarV.setScrollTop(this.scrollTop + this.scrollMargin.top);
        };
        VirtualRenderer.prototype.$updateScrollBarH = function() {
            this.scrollBarH.setScrollWidth(this.layerConfig.width + 2 * this.$padding + this.scrollMargin.h);
            this.scrollBarH.setScrollLeft(this.scrollLeft + this.scrollMargin.left);
        };
        VirtualRenderer.prototype.freeze = function() {
            this.$frozen = true;
        };
        VirtualRenderer.prototype.unfreeze = function() {
            this.$frozen = false;
        };
        VirtualRenderer.prototype.$renderChanges = function(changes, force) {
            if (this.$changes) {
                changes |= this.$changes;
                this.$changes = 0;
            }
            if (!this.session || !this.container.offsetWidth || this.$frozen || !changes && !force) {
                this.$changes |= changes;
                return;
            }
            if (this.$size.$dirty) {
                this.$changes |= changes;
                return this.onResize(true);
            }
            if (!this.lineHeight) this.$textLayer.checkForSizeChanges();
            this._signal("beforeRender", changes);
            if (this.session && this.session.$bidiHandler) this.session.$bidiHandler.updateCharacterWidths(this.$fontMetrics);
            var config = this.layerConfig;
            if (changes & this.CHANGE_FULL || changes & this.CHANGE_SIZE || changes & this.CHANGE_TEXT || changes & this.CHANGE_LINES || changes & this.CHANGE_SCROLL || changes & this.CHANGE_H_SCROLL) {
                changes |= this.$computeLayerConfig() | this.$loop.clear();
                if (config.firstRow != this.layerConfig.firstRow && config.firstRowScreen == this.layerConfig.firstRowScreen) {
                    var st = this.scrollTop + (config.firstRow - Math.max(this.layerConfig.firstRow, 0)) * this.lineHeight;
                    if (st > 0) {
                        this.scrollTop = st;
                        changes = changes | this.CHANGE_SCROLL;
                        changes |= this.$computeLayerConfig() | this.$loop.clear();
                    }
                }
                config = this.layerConfig;
                this.$updateScrollBarV();
                if (changes & this.CHANGE_H_SCROLL) this.$updateScrollBarH();
                dom.translate(this.content, -this.scrollLeft, -config.offset);
                var width = config.width + 2 * this.$padding + "px";
                var height = config.minHeight + "px";
                dom.setStyle(this.content.style, "width", width);
                dom.setStyle(this.content.style, "height", height);
            }
            if (changes & this.CHANGE_H_SCROLL) {
                dom.translate(this.content, -this.scrollLeft, -config.offset);
                this.scroller.className = this.scrollLeft <= 0 ? "ace_scroller " : "ace_scroller ace_scroll-left ";
                if (this.enableKeyboardAccessibility) this.scroller.className += this.keyboardFocusClassName;
            }
            if (changes & this.CHANGE_FULL) {
                this.$changedLines = null;
                this.$textLayer.update(config);
                if (this.$showGutter) this.$gutterLayer.update(config);
                if (this.$customScrollbar) this.$scrollDecorator.$updateDecorators(config);
                this.$markerBack.update(config);
                this.$markerFront.update(config);
                this.$cursorLayer.update(config);
                this.$moveTextAreaToCursor();
                this._signal("afterRender", changes);
                return;
            }
            if (changes & this.CHANGE_SCROLL) {
                this.$changedLines = null;
                if (changes & this.CHANGE_TEXT || changes & this.CHANGE_LINES) this.$textLayer.update(config);
                else this.$textLayer.scrollLines(config);
                if (this.$showGutter) {
                    if (changes & this.CHANGE_GUTTER || changes & this.CHANGE_LINES) this.$gutterLayer.update(config);
                    else this.$gutterLayer.scrollLines(config);
                }
                if (this.$customScrollbar) this.$scrollDecorator.$updateDecorators(config);
                this.$markerBack.update(config);
                this.$markerFront.update(config);
                this.$cursorLayer.update(config);
                this.$moveTextAreaToCursor();
                this._signal("afterRender", changes);
                return;
            }
            if (changes & this.CHANGE_TEXT) {
                this.$changedLines = null;
                this.$textLayer.update(config);
                if (this.$showGutter) this.$gutterLayer.update(config);
                if (this.$customScrollbar) this.$scrollDecorator.$updateDecorators(config);
            } else if (changes & this.CHANGE_LINES) {
                if (this.$updateLines() || changes & this.CHANGE_GUTTER && this.$showGutter) this.$gutterLayer.update(config);
                if (this.$customScrollbar) this.$scrollDecorator.$updateDecorators(config);
            } else if (changes & this.CHANGE_TEXT || changes & this.CHANGE_GUTTER) {
                if (this.$showGutter) this.$gutterLayer.update(config);
                if (this.$customScrollbar) this.$scrollDecorator.$updateDecorators(config);
            } else if (changes & this.CHANGE_CURSOR) {
                if (this.$highlightGutterLine) this.$gutterLayer.updateLineHighlight(config);
                if (this.$customScrollbar) this.$scrollDecorator.$updateDecorators(config);
            }
            if (changes & this.CHANGE_CURSOR) {
                this.$cursorLayer.update(config);
                this.$moveTextAreaToCursor();
            }
            if (changes & (this.CHANGE_MARKER | this.CHANGE_MARKER_FRONT)) this.$markerFront.update(config);
            if (changes & (this.CHANGE_MARKER | this.CHANGE_MARKER_BACK)) this.$markerBack.update(config);
            this._signal("afterRender", changes);
        };
        VirtualRenderer.prototype.$autosize = function() {
            var height = this.session.getScreenLength() * this.lineHeight;
            var maxHeight = this.$maxLines * this.lineHeight;
            var desiredHeight = Math.min(maxHeight, Math.max((this.$minLines || 1) * this.lineHeight, height)) + this.scrollMargin.v + (this.$extraHeight || 0);
            if (this.$horizScroll) desiredHeight += this.scrollBarH.getHeight();
            if (this.$maxPixelHeight && desiredHeight > this.$maxPixelHeight) desiredHeight = this.$maxPixelHeight;
            var hideScrollbars = desiredHeight <= 2 * this.lineHeight;
            var vScroll = !hideScrollbars && height > maxHeight;
            if (desiredHeight != this.desiredHeight || this.$size.height != this.desiredHeight || vScroll != this.$vScroll) {
                if (vScroll != this.$vScroll) {
                    this.$vScroll = vScroll;
                    this.scrollBarV.setVisible(vScroll);
                }
                var w = this.container.clientWidth;
                this.container.style.height = desiredHeight + "px";
                this.$updateCachedSize(true, this.$gutterWidth, w, desiredHeight);
                this.desiredHeight = desiredHeight;
                this._signal("autosize");
            }
        };
        VirtualRenderer.prototype.$computeLayerConfig = function() {
            var session = this.session;
            var size = this.$size;
            var hideScrollbars = size.height <= 2 * this.lineHeight;
            var screenLines = this.session.getScreenLength();
            var maxHeight = screenLines * this.lineHeight;
            var longestLine = this.$getLongestLine();
            var horizScroll = !hideScrollbars && (this.$hScrollBarAlwaysVisible || size.scrollerWidth - longestLine - 2 * this.$padding < 0);
            var hScrollChanged = this.$horizScroll !== horizScroll;
            if (hScrollChanged) {
                this.$horizScroll = horizScroll;
                this.scrollBarH.setVisible(horizScroll);
            }
            var vScrollBefore = this.$vScroll; // autosize can change vscroll value in which case we need to update longestLine
            if (this.$maxLines && this.lineHeight > 1) this.$autosize();
            var minHeight = size.scrollerHeight + this.lineHeight;
            var scrollPastEnd = !this.$maxLines && this.$scrollPastEnd ? (size.scrollerHeight - this.lineHeight) * this.$scrollPastEnd : 0;
            maxHeight += scrollPastEnd;
            var sm = this.scrollMargin;
            this.session.setScrollTop(Math.max(-sm.top, Math.min(this.scrollTop, maxHeight - size.scrollerHeight + sm.bottom)));
            this.session.setScrollLeft(Math.max(-sm.left, Math.min(this.scrollLeft, longestLine + 2 * this.$padding - size.scrollerWidth + sm.right)));
            var vScroll = !hideScrollbars && (this.$vScrollBarAlwaysVisible || size.scrollerHeight - maxHeight + scrollPastEnd < 0 || this.scrollTop > sm.top);
            var vScrollChanged = vScrollBefore !== vScroll;
            if (vScrollChanged) {
                this.$vScroll = vScroll;
                this.scrollBarV.setVisible(vScroll);
            }
            var offset = this.scrollTop % this.lineHeight;
            var lineCount = Math.ceil(minHeight / this.lineHeight) - 1;
            var firstRow = Math.max(0, Math.round((this.scrollTop - offset) / this.lineHeight));
            var lastRow = firstRow + lineCount;
            var firstRowScreen, firstRowHeight;
            var lineHeight = this.lineHeight;
            firstRow = session.screenToDocumentRow(firstRow, 0);
            var foldLine = session.getFoldLine(firstRow);
            if (foldLine) firstRow = foldLine.start.row;
            firstRowScreen = session.documentToScreenRow(firstRow, 0);
            firstRowHeight = session.getRowLength(firstRow) * lineHeight;
            lastRow = Math.min(session.screenToDocumentRow(lastRow, 0), session.getLength() - 1);
            minHeight = size.scrollerHeight + session.getRowLength(lastRow) * lineHeight + firstRowHeight;
            offset = this.scrollTop - firstRowScreen * lineHeight;
            var changes = 0;
            if (this.layerConfig.width != longestLine || hScrollChanged) changes = this.CHANGE_H_SCROLL;
            if (hScrollChanged || vScrollChanged) {
                changes |= this.$updateCachedSize(true, this.gutterWidth, size.width, size.height);
                this._signal("scrollbarVisibilityChanged");
                if (vScrollChanged) longestLine = this.$getLongestLine();
            }
            this.layerConfig = {
                width: longestLine,
                padding: this.$padding,
                firstRow: firstRow,
                firstRowScreen: firstRowScreen,
                lastRow: lastRow,
                lineHeight: lineHeight,
                characterWidth: this.characterWidth,
                minHeight: minHeight,
                maxHeight: maxHeight,
                offset: offset,
                gutterOffset: lineHeight ? Math.max(0, Math.ceil((offset + size.height - size.scrollerHeight) / lineHeight)) : 0,
                height: this.$size.scrollerHeight
            };
            if (this.session.$bidiHandler) this.session.$bidiHandler.setContentWidth(longestLine - this.$padding);
            return changes;
        };
        VirtualRenderer.prototype.$updateLines = function() {
            if (!this.$changedLines) return;
            var firstRow = this.$changedLines.firstRow;
            var lastRow = this.$changedLines.lastRow;
            this.$changedLines = null;
            var layerConfig = this.layerConfig;
            if (firstRow > layerConfig.lastRow + 1) return;
            if (lastRow < layerConfig.firstRow) return;
            if (lastRow === Infinity) {
                if (this.$showGutter) this.$gutterLayer.update(layerConfig);
                this.$textLayer.update(layerConfig);
                return;
            }
            this.$textLayer.updateLines(layerConfig, firstRow, lastRow);
            return true;
        };
        VirtualRenderer.prototype.$getLongestLine = function() {
            var charCount = this.session.getScreenWidth();
            if (this.showInvisibles && !this.session.$useWrapMode) charCount += 1;
            if (this.$textLayer && charCount > this.$textLayer.MAX_LINE_LENGTH) charCount = this.$textLayer.MAX_LINE_LENGTH + 30;
            return Math.max(this.$size.scrollerWidth - 2 * this.$padding, Math.round(charCount * this.characterWidth));
        };
        VirtualRenderer.prototype.updateFrontMarkers = function() {
            this.$markerFront.setMarkers(this.session.getMarkers(true));
            this.$loop.schedule(this.CHANGE_MARKER_FRONT);
        };
        VirtualRenderer.prototype.updateBackMarkers = function() {
            this.$markerBack.setMarkers(this.session.getMarkers());
            this.$loop.schedule(this.CHANGE_MARKER_BACK);
        };
        VirtualRenderer.prototype.addGutterDecoration = function(row, className) {
            this.$gutterLayer.addGutterDecoration(row, className);
        };
        VirtualRenderer.prototype.removeGutterDecoration = function(row, className) {
            this.$gutterLayer.removeGutterDecoration(row, className);
        };
        VirtualRenderer.prototype.updateBreakpoints = function(rows) {
            this._rows = rows;
            this.$loop.schedule(this.CHANGE_GUTTER);
        };
        VirtualRenderer.prototype.setAnnotations = function(annotations) {
            this.$gutterLayer.setAnnotations(annotations);
            this.$loop.schedule(this.CHANGE_GUTTER);
        };
        VirtualRenderer.prototype.updateCursor = function() {
            this.$loop.schedule(this.CHANGE_CURSOR);
        };
        VirtualRenderer.prototype.hideCursor = function() {
            this.$cursorLayer.hideCursor();
        };
        VirtualRenderer.prototype.showCursor = function() {
            this.$cursorLayer.showCursor();
        };
        VirtualRenderer.prototype.scrollSelectionIntoView = function(anchor, lead, offset) {
            this.scrollCursorIntoView(anchor, offset);
            this.scrollCursorIntoView(lead, offset);
        };
        VirtualRenderer.prototype.scrollCursorIntoView = function(cursor, offset, $viewMargin) {
            if (this.$size.scrollerHeight === 0) return;
            var pos = this.$cursorLayer.getPixelPosition(cursor);
            var newLeft = pos.left;
            var newTop = pos.top;
            var topMargin = $viewMargin && $viewMargin.top || 0;
            var bottomMargin = $viewMargin && $viewMargin.bottom || 0;
            if (this.$scrollAnimation) this.$stopAnimation = true;
            var currentTop = this.$scrollAnimation ? this.session.getScrollTop() : this.scrollTop;
            if (currentTop + topMargin > newTop) {
                if (offset && currentTop + topMargin > newTop + this.lineHeight) newTop -= offset * this.$size.scrollerHeight;
                if (newTop === 0) newTop = -this.scrollMargin.top;
                this.session.setScrollTop(newTop);
            } else if (currentTop + this.$size.scrollerHeight - bottomMargin < newTop + this.lineHeight) {
                if (offset && currentTop + this.$size.scrollerHeight - bottomMargin < newTop - this.lineHeight) newTop += offset * this.$size.scrollerHeight;
                this.session.setScrollTop(newTop + this.lineHeight + bottomMargin - this.$size.scrollerHeight);
            }
            var currentLeft = this.scrollLeft;
            var twoCharsWidth = 2 * this.layerConfig.characterWidth;
            if (newLeft - twoCharsWidth < currentLeft) {
                newLeft -= twoCharsWidth;
                if (newLeft < this.$padding + twoCharsWidth) newLeft = -this.scrollMargin.left;
                this.session.setScrollLeft(newLeft);
            } else {
                newLeft += twoCharsWidth;
                if (currentLeft + this.$size.scrollerWidth < newLeft + this.characterWidth) this.session.setScrollLeft(Math.round(newLeft + this.characterWidth - this.$size.scrollerWidth));
                else if (currentLeft <= this.$padding && newLeft - currentLeft < this.characterWidth) this.session.setScrollLeft(0);
            }
        };
        VirtualRenderer.prototype.getScrollTop = function() {
            return this.session.getScrollTop();
        };
        VirtualRenderer.prototype.getScrollLeft = function() {
            return this.session.getScrollLeft();
        };
        VirtualRenderer.prototype.getScrollTopRow = function() {
            return this.scrollTop / this.lineHeight;
        };
        VirtualRenderer.prototype.getScrollBottomRow = function() {
            return Math.max(0, Math.floor((this.scrollTop + this.$size.scrollerHeight) / this.lineHeight) - 1);
        };
        VirtualRenderer.prototype.scrollToRow = function(row) {
            this.session.setScrollTop(row * this.lineHeight);
        };
        VirtualRenderer.prototype.alignCursor = function(cursor, alignment) {
            if (typeof cursor == "number") cursor = {
                row: cursor,
                column: 0
            };
            var pos = this.$cursorLayer.getPixelPosition(cursor);
            var h = this.$size.scrollerHeight - this.lineHeight;
            var offset = pos.top - h * (alignment || 0);
            this.session.setScrollTop(offset);
            return offset;
        };
        VirtualRenderer.prototype.$calcSteps = function(fromValue, toValue) {
            var i = 0;
            var l = this.STEPS;
            var steps = [];
            var func = function(t, x_min, dx) {
                return dx * (Math.pow(t - 1, 3) + 1) + x_min;
            };
            for(i = 0; i < l; ++i)steps.push(func(i / this.STEPS, fromValue, toValue - fromValue));
            return steps;
        };
        VirtualRenderer.prototype.scrollToLine = function(line, center, animate, callback) {
            var pos = this.$cursorLayer.getPixelPosition({
                row: line,
                column: 0
            });
            var offset = pos.top;
            if (center) offset -= this.$size.scrollerHeight / 2;
            var initialScroll = this.scrollTop;
            this.session.setScrollTop(offset);
            if (animate !== false) this.animateScrolling(initialScroll, callback);
        };
        VirtualRenderer.prototype.animateScrolling = function(fromValue, callback) {
            var toValue = this.scrollTop;
            if (!this.$animatedScroll) return;
            var _self = this;
            if (fromValue == toValue) return;
            if (this.$scrollAnimation) {
                var oldSteps = this.$scrollAnimation.steps;
                if (oldSteps.length) {
                    fromValue = oldSteps[0];
                    if (fromValue == toValue) return;
                }
            }
            var steps = _self.$calcSteps(fromValue, toValue);
            this.$scrollAnimation = {
                from: fromValue,
                to: toValue,
                steps: steps
            };
            clearInterval(this.$timer);
            _self.session.setScrollTop(steps.shift());
            _self.session.$scrollTop = toValue;
            function endAnimation() {
                _self.$timer = clearInterval(_self.$timer);
                _self.$scrollAnimation = null;
                _self.$stopAnimation = false;
                callback && callback();
            }
            this.$timer = setInterval(function() {
                if (_self.$stopAnimation) {
                    endAnimation();
                    return;
                }
                if (!_self.session) return clearInterval(_self.$timer);
                if (steps.length) {
                    _self.session.setScrollTop(steps.shift());
                    _self.session.$scrollTop = toValue;
                } else if (toValue != null) {
                    _self.session.$scrollTop = -1;
                    _self.session.setScrollTop(toValue);
                    toValue = null;
                } else endAnimation();
            }, 10);
        };
        VirtualRenderer.prototype.scrollToY = function(scrollTop) {
            if (this.scrollTop !== scrollTop) {
                this.$loop.schedule(this.CHANGE_SCROLL);
                this.scrollTop = scrollTop;
            }
        };
        VirtualRenderer.prototype.scrollToX = function(scrollLeft) {
            if (this.scrollLeft !== scrollLeft) this.scrollLeft = scrollLeft;
            this.$loop.schedule(this.CHANGE_H_SCROLL);
        };
        VirtualRenderer.prototype.scrollTo = function(x, y) {
            this.session.setScrollTop(y);
            this.session.setScrollLeft(x);
        };
        VirtualRenderer.prototype.scrollBy = function(deltaX, deltaY) {
            deltaY && this.session.setScrollTop(this.session.getScrollTop() + deltaY);
            deltaX && this.session.setScrollLeft(this.session.getScrollLeft() + deltaX);
        };
        VirtualRenderer.prototype.isScrollableBy = function(deltaX, deltaY) {
            if (deltaY < 0 && this.session.getScrollTop() >= 1 - this.scrollMargin.top) return true;
            if (deltaY > 0 && this.session.getScrollTop() + this.$size.scrollerHeight - this.layerConfig.maxHeight < -1 + this.scrollMargin.bottom) return true;
            if (deltaX < 0 && this.session.getScrollLeft() >= 1 - this.scrollMargin.left) return true;
            if (deltaX > 0 && this.session.getScrollLeft() + this.$size.scrollerWidth - this.layerConfig.width < -1 + this.scrollMargin.right) return true;
        };
        VirtualRenderer.prototype.pixelToScreenCoordinates = function(x, y) {
            var canvasPos;
            if (this.$hasCssTransforms) {
                canvasPos = {
                    top: 0,
                    left: 0
                };
                var p = this.$fontMetrics.transformCoordinates([
                    x,
                    y
                ]);
                x = p[1] - this.gutterWidth - this.margin.left;
                y = p[0];
            } else canvasPos = this.scroller.getBoundingClientRect();
            var offsetX = x + this.scrollLeft - canvasPos.left - this.$padding;
            var offset = offsetX / this.characterWidth;
            var row = Math.floor((y + this.scrollTop - canvasPos.top) / this.lineHeight);
            var col = this.$blockCursor ? Math.floor(offset) : Math.round(offset);
            return {
                row: row,
                column: col,
                side: offset - col > 0 ? 1 : -1,
                offsetX: offsetX
            };
        };
        VirtualRenderer.prototype.screenToTextCoordinates = function(x, y) {
            var canvasPos;
            if (this.$hasCssTransforms) {
                canvasPos = {
                    top: 0,
                    left: 0
                };
                var p = this.$fontMetrics.transformCoordinates([
                    x,
                    y
                ]);
                x = p[1] - this.gutterWidth - this.margin.left;
                y = p[0];
            } else canvasPos = this.scroller.getBoundingClientRect();
            var offsetX = x + this.scrollLeft - canvasPos.left - this.$padding;
            var offset = offsetX / this.characterWidth;
            var col = this.$blockCursor ? Math.floor(offset) : Math.round(offset);
            var row = Math.floor((y + this.scrollTop - canvasPos.top) / this.lineHeight);
            return this.session.screenToDocumentPosition(row, Math.max(col, 0), offsetX);
        };
        VirtualRenderer.prototype.textToScreenCoordinates = function(row, column) {
            var canvasPos = this.scroller.getBoundingClientRect();
            var pos = this.session.documentToScreenPosition(row, column);
            var x = this.$padding + (this.session.$bidiHandler.isBidiRow(pos.row, row) ? this.session.$bidiHandler.getPosLeft(pos.column) : Math.round(pos.column * this.characterWidth));
            var y = pos.row * this.lineHeight;
            return {
                pageX: canvasPos.left + x - this.scrollLeft,
                pageY: canvasPos.top + y - this.scrollTop
            };
        };
        VirtualRenderer.prototype.visualizeFocus = function() {
            dom.addCssClass(this.container, "ace_focus");
        };
        VirtualRenderer.prototype.visualizeBlur = function() {
            dom.removeCssClass(this.container, "ace_focus");
        };
        VirtualRenderer.prototype.showComposition = function(composition) {
            this.$composition = composition;
            if (!composition.cssText) composition.cssText = this.textarea.style.cssText;
            if (composition.useTextareaForIME == undefined) composition.useTextareaForIME = this.$useTextareaForIME;
            if (this.$useTextareaForIME) {
                dom.addCssClass(this.textarea, "ace_composition");
                this.textarea.style.cssText = "";
                this.$moveTextAreaToCursor();
                this.$cursorLayer.element.style.display = "none";
            } else composition.markerId = this.session.addMarker(composition.markerRange, "ace_composition_marker", "text");
        };
        VirtualRenderer.prototype.setCompositionText = function(text) {
            var cursor = this.session.selection.cursor;
            this.addToken(text, "composition_placeholder", cursor.row, cursor.column);
            this.$moveTextAreaToCursor();
        };
        VirtualRenderer.prototype.hideComposition = function() {
            if (!this.$composition) return;
            if (this.$composition.markerId) this.session.removeMarker(this.$composition.markerId);
            dom.removeCssClass(this.textarea, "ace_composition");
            this.textarea.style.cssText = this.$composition.cssText;
            var cursor = this.session.selection.cursor;
            this.removeExtraToken(cursor.row, cursor.column);
            this.$composition = null;
            this.$cursorLayer.element.style.display = "";
        };
        VirtualRenderer.prototype.setGhostText = function(text, position) {
            var cursor = this.session.selection.cursor;
            var insertPosition = position || {
                row: cursor.row,
                column: cursor.column
            };
            this.removeGhostText();
            var textChunks = this.$calculateWrappedTextChunks(text, insertPosition);
            this.addToken(textChunks[0].text, "ghost_text", insertPosition.row, insertPosition.column);
            this.$ghostText = {
                text: text,
                position: {
                    row: insertPosition.row,
                    column: insertPosition.column
                }
            };
            var widgetDiv = dom.createElement("div");
            if (textChunks.length > 1) {
                textChunks.slice(1).forEach(function(el) {
                    var chunkDiv = dom.createElement("div");
                    if (el.wrapped) chunkDiv.className = "ghost_text_line_wrapped";
                    chunkDiv.appendChild(dom.createTextNode(el.text));
                    widgetDiv.appendChild(chunkDiv);
                });
                this.$ghostTextWidget = {
                    el: widgetDiv,
                    row: insertPosition.row,
                    column: insertPosition.column,
                    className: "ace_ghost_text"
                };
                this.session.widgetManager.addLineWidget(this.$ghostTextWidget);
                var pixelPosition = this.$cursorLayer.getPixelPosition(insertPosition, true);
                var el = this.container;
                var height = el.getBoundingClientRect().height;
                var ghostTextHeight = textChunks.length * this.lineHeight;
                var fitsY = ghostTextHeight < height - pixelPosition.top;
                if (fitsY) return;
                if (ghostTextHeight < height) this.scrollBy(0, (textChunks.length - 1) * this.lineHeight);
                else this.scrollToRow(insertPosition.row);
            }
        };
        VirtualRenderer.prototype.$calculateWrappedTextChunks = function(text, position) {
            var availableWidth = this.$size.scrollerWidth - this.$padding * 2;
            var limit = Math.floor(availableWidth / this.characterWidth) - 2;
            limit = limit <= 0 ? 60 : limit; // this is a hack to prevent the editor from crashing when the window is too small
            var textLines = text.split(/\r?\n/);
            var textChunks = [];
            for(var i = 0; i < textLines.length; i++){
                var displayTokens = this.session.$getDisplayTokens(textLines[i], position.column);
                var wrapSplits = this.session.$computeWrapSplits(displayTokens, limit, this.session.$tabSize);
                if (wrapSplits.length > 0) {
                    var start = 0;
                    wrapSplits.push(textLines[i].length);
                    for(var j = 0; j < wrapSplits.length; j++){
                        var textSlice = textLines[i].slice(start, wrapSplits[j]);
                        textChunks.push({
                            text: textSlice,
                            wrapped: true
                        });
                        start = wrapSplits[j];
                    }
                } else textChunks.push({
                    text: textLines[i],
                    wrapped: false
                });
            }
            return textChunks;
        };
        VirtualRenderer.prototype.removeGhostText = function() {
            if (!this.$ghostText) return;
            var position = this.$ghostText.position;
            this.removeExtraToken(position.row, position.column);
            if (this.$ghostTextWidget) {
                this.session.widgetManager.removeLineWidget(this.$ghostTextWidget);
                this.$ghostTextWidget = null;
            }
            this.$ghostText = null;
        };
        VirtualRenderer.prototype.addToken = function(text, type, row, column) {
            var session = this.session;
            session.bgTokenizer.lines[row] = null;
            var newToken = {
                type: type,
                value: text
            };
            var tokens = session.getTokens(row);
            if (column == null || !tokens.length) tokens.push(newToken);
            else {
                var l = 0;
                for(var i = 0; i < tokens.length; i++){
                    var token = tokens[i];
                    l += token.value.length;
                    if (column <= l) {
                        var diff = token.value.length - (l - column);
                        var before = token.value.slice(0, diff);
                        var after = token.value.slice(diff);
                        tokens.splice(i, 1, {
                            type: token.type,
                            value: before
                        }, newToken, {
                            type: token.type,
                            value: after
                        });
                        break;
                    }
                }
            }
            this.updateLines(row, row);
        };
        VirtualRenderer.prototype.removeExtraToken = function(row, column) {
            this.session.bgTokenizer.lines[row] = null;
            this.updateLines(row, row);
        };
        VirtualRenderer.prototype.setTheme = function(theme, cb) {
            var _self = this;
            this.$themeId = theme;
            _self._dispatchEvent("themeChange", {
                theme: theme
            });
            if (!theme || typeof theme == "string") {
                var moduleName = theme || this.$options.theme.initialValue;
                config.loadModule([
                    "theme",
                    moduleName
                ], afterLoad);
            } else afterLoad(theme);
            function afterLoad(module1) {
                if (_self.$themeId != theme) return cb && cb();
                if (!module1 || !module1.cssClass) throw new Error("couldn't load module " + theme + " or it didn't call define");
                if (module1.$id) _self.$themeId = module1.$id;
                dom.importCssString(module1.cssText, module1.cssClass, _self.container);
                if (_self.theme) dom.removeCssClass(_self.container, _self.theme.cssClass);
                var padding = "padding" in module1 ? module1.padding : "padding" in (_self.theme || {}) ? 4 : _self.$padding;
                if (_self.$padding && padding != _self.$padding) _self.setPadding(padding);
                _self.$theme = module1.cssClass;
                _self.theme = module1;
                dom.addCssClass(_self.container, module1.cssClass);
                dom.setCssClass(_self.container, "ace_dark", module1.isDark);
                if (_self.$size) {
                    _self.$size.width = 0;
                    _self.$updateSizeAsync();
                }
                _self._dispatchEvent("themeLoaded", {
                    theme: module1
                });
                cb && cb();
                if (useragent.isSafari && _self.scroller) {
                    _self.scroller.style.background = "red";
                    _self.scroller.style.background = "";
                }
            }
        };
        VirtualRenderer.prototype.getTheme = function() {
            return this.$themeId;
        };
        VirtualRenderer.prototype.setStyle = function(style, include) {
            dom.setCssClass(this.container, style, include !== false);
        };
        VirtualRenderer.prototype.unsetStyle = function(style) {
            dom.removeCssClass(this.container, style);
        };
        VirtualRenderer.prototype.setCursorStyle = function(style) {
            dom.setStyle(this.scroller.style, "cursor", style);
        };
        VirtualRenderer.prototype.setMouseCursor = function(cursorStyle) {
            dom.setStyle(this.scroller.style, "cursor", cursorStyle);
        };
        VirtualRenderer.prototype.attachToShadowRoot = function() {
            dom.importCssString(editorCss, "ace_editor.css", this.container);
        };
        VirtualRenderer.prototype.destroy = function() {
            this.freeze();
            this.$fontMetrics.destroy();
            this.$cursorLayer.destroy();
            this.removeAllListeners();
            this.container.textContent = "";
            this.setOption("useResizeObserver", false);
        };
        VirtualRenderer.prototype.$updateCustomScrollbar = function(val) {
            var _self = this;
            this.$horizScroll = this.$vScroll = null;
            this.scrollBarV.element.remove();
            this.scrollBarH.element.remove();
            if (this.$scrollDecorator) delete this.$scrollDecorator;
            if (val === true) {
                this.scrollBarV = new VScrollBarCustom(this.container, this);
                this.scrollBarH = new HScrollBarCustom(this.container, this);
                this.scrollBarV.setHeight(this.$size.scrollerHeight);
                this.scrollBarH.setWidth(this.$size.scrollerWidth);
                this.scrollBarV.addEventListener("scroll", function(e) {
                    if (!_self.$scrollAnimation) _self.session.setScrollTop(e.data - _self.scrollMargin.top);
                });
                this.scrollBarH.addEventListener("scroll", function(e) {
                    if (!_self.$scrollAnimation) _self.session.setScrollLeft(e.data - _self.scrollMargin.left);
                });
                this.$scrollDecorator = new Decorator(this.scrollBarV, this);
                this.$scrollDecorator.$updateDecorators();
            } else {
                this.scrollBarV = new VScrollBar(this.container, this);
                this.scrollBarH = new HScrollBar(this.container, this);
                this.scrollBarV.addEventListener("scroll", function(e) {
                    if (!_self.$scrollAnimation) _self.session.setScrollTop(e.data - _self.scrollMargin.top);
                });
                this.scrollBarH.addEventListener("scroll", function(e) {
                    if (!_self.$scrollAnimation) _self.session.setScrollLeft(e.data - _self.scrollMargin.left);
                });
            }
        };
        VirtualRenderer.prototype.$addResizeObserver = function() {
            if (!window.ResizeObserver || this.$resizeObserver) return;
            var self1 = this;
            this.$resizeTimer = lang.delayedCall(function() {
                if (!self1.destroyed) self1.onResize();
            }, 50);
            this.$resizeObserver = new window.ResizeObserver(function(e) {
                var w = e[0].contentRect.width;
                var h = e[0].contentRect.height;
                if (Math.abs(self1.$size.width - w) > 1 || Math.abs(self1.$size.height - h) > 1) self1.$resizeTimer.delay();
                else self1.$resizeTimer.cancel();
            });
            this.$resizeObserver.observe(this.container);
        };
        return VirtualRenderer;
    }();
    VirtualRenderer.prototype.CHANGE_CURSOR = 1;
    VirtualRenderer.prototype.CHANGE_MARKER = 2;
    VirtualRenderer.prototype.CHANGE_GUTTER = 4;
    VirtualRenderer.prototype.CHANGE_SCROLL = 8;
    VirtualRenderer.prototype.CHANGE_LINES = 16;
    VirtualRenderer.prototype.CHANGE_TEXT = 32;
    VirtualRenderer.prototype.CHANGE_SIZE = 64;
    VirtualRenderer.prototype.CHANGE_MARKER_BACK = 128;
    VirtualRenderer.prototype.CHANGE_MARKER_FRONT = 256;
    VirtualRenderer.prototype.CHANGE_FULL = 512;
    VirtualRenderer.prototype.CHANGE_H_SCROLL = 1024;
    VirtualRenderer.prototype.$changes = 0;
    VirtualRenderer.prototype.$padding = null;
    VirtualRenderer.prototype.$frozen = false;
    VirtualRenderer.prototype.STEPS = 8;
    oop.implement(VirtualRenderer.prototype, EventEmitter);
    config.defineOptions(VirtualRenderer.prototype, "renderer", {
        useResizeObserver: {
            set: function(value) {
                if (!value && this.$resizeObserver) {
                    this.$resizeObserver.disconnect();
                    this.$resizeTimer.cancel();
                    this.$resizeTimer = this.$resizeObserver = null;
                } else if (value && !this.$resizeObserver) this.$addResizeObserver();
            }
        },
        animatedScroll: {
            initialValue: false
        },
        showInvisibles: {
            set: function(value) {
                if (this.$textLayer.setShowInvisibles(value)) this.$loop.schedule(this.CHANGE_TEXT);
            },
            initialValue: false
        },
        showPrintMargin: {
            set: function() {
                this.$updatePrintMargin();
            },
            initialValue: true
        },
        printMarginColumn: {
            set: function() {
                this.$updatePrintMargin();
            },
            initialValue: 80
        },
        printMargin: {
            set: function(val) {
                if (typeof val == "number") this.$printMarginColumn = val;
                this.$showPrintMargin = !!val;
                this.$updatePrintMargin();
            },
            get: function() {
                return this.$showPrintMargin && this.$printMarginColumn;
            }
        },
        showGutter: {
            set: function(show) {
                this.$gutter.style.display = show ? "block" : "none";
                this.$loop.schedule(this.CHANGE_FULL);
                this.onGutterResize();
            },
            initialValue: true
        },
        useSvgGutterIcons: {
            set: function(value) {
                this.$gutterLayer.$useSvgGutterIcons = value;
            },
            initialValue: false
        },
        showFoldedAnnotations: {
            set: function(value) {
                this.$gutterLayer.$showFoldedAnnotations = value;
            },
            initialValue: false
        },
        fadeFoldWidgets: {
            set: function(show) {
                dom.setCssClass(this.$gutter, "ace_fade-fold-widgets", show);
            },
            initialValue: false
        },
        showFoldWidgets: {
            set: function(show) {
                this.$gutterLayer.setShowFoldWidgets(show);
                this.$loop.schedule(this.CHANGE_GUTTER);
            },
            initialValue: true
        },
        displayIndentGuides: {
            set: function(show) {
                if (this.$textLayer.setDisplayIndentGuides(show)) this.$loop.schedule(this.CHANGE_TEXT);
            },
            initialValue: true
        },
        highlightIndentGuides: {
            set: function(show) {
                if (this.$textLayer.setHighlightIndentGuides(show) == true) this.$textLayer.$highlightIndentGuide();
                else this.$textLayer.$clearActiveIndentGuide(this.$textLayer.$lines.cells);
            },
            initialValue: true
        },
        highlightGutterLine: {
            set: function(shouldHighlight) {
                this.$gutterLayer.setHighlightGutterLine(shouldHighlight);
                this.$loop.schedule(this.CHANGE_GUTTER);
            },
            initialValue: true
        },
        hScrollBarAlwaysVisible: {
            set: function(val) {
                if (!this.$hScrollBarAlwaysVisible || !this.$horizScroll) this.$loop.schedule(this.CHANGE_SCROLL);
            },
            initialValue: false
        },
        vScrollBarAlwaysVisible: {
            set: function(val) {
                if (!this.$vScrollBarAlwaysVisible || !this.$vScroll) this.$loop.schedule(this.CHANGE_SCROLL);
            },
            initialValue: false
        },
        fontSize: {
            set: function(size) {
                if (typeof size == "number") size = size + "px";
                this.container.style.fontSize = size;
                this.updateFontSize();
            },
            initialValue: 12
        },
        fontFamily: {
            set: function(name) {
                this.container.style.fontFamily = name;
                this.updateFontSize();
            }
        },
        maxLines: {
            set: function(val) {
                this.updateFull();
            }
        },
        minLines: {
            set: function(val) {
                if (!(this.$minLines < 0x1ffffffffffff)) this.$minLines = 0;
                this.updateFull();
            }
        },
        maxPixelHeight: {
            set: function(val) {
                this.updateFull();
            },
            initialValue: 0
        },
        scrollPastEnd: {
            set: function(val) {
                val = +val || 0;
                if (this.$scrollPastEnd == val) return;
                this.$scrollPastEnd = val;
                this.$loop.schedule(this.CHANGE_SCROLL);
            },
            initialValue: 0,
            handlesSet: true
        },
        fixedWidthGutter: {
            set: function(val) {
                this.$gutterLayer.$fixedWidth = !!val;
                this.$loop.schedule(this.CHANGE_GUTTER);
            }
        },
        customScrollbar: {
            set: function(val) {
                this.$updateCustomScrollbar(val);
            },
            initialValue: false
        },
        theme: {
            set: function(val) {
                this.setTheme(val);
            },
            get: function() {
                return this.$themeId || this.theme;
            },
            initialValue: "./theme/textmate",
            handlesSet: true
        },
        hasCssTransforms: {},
        useTextareaForIME: {
            initialValue: !useragent.isMobile && !useragent.isIE
        }
    });
    exports.VirtualRenderer = VirtualRenderer;
});
ace.define("ace/worker/worker_client", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/net",
    "ace/lib/event_emitter",
    "ace/config"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var net = require("../lib/net");
    var EventEmitter = require("../lib/event_emitter").EventEmitter;
    var config = require("../config");
    function $workerBlob(workerUrl) {
        var script = "importScripts('" + net.qualifyURL(workerUrl) + "');";
        try {
            return new Blob([
                script
            ], {
                "type": "application/javascript"
            });
        } catch (e) {
            var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder;
            var blobBuilder = new BlobBuilder();
            blobBuilder.append(script);
            return blobBuilder.getBlob("application/javascript");
        }
    }
    function createWorker(workerUrl) {
        if (typeof Worker == "undefined") return {
            postMessage: function() {},
            terminate: function() {}
        };
        if (config.get("loadWorkerFromBlob")) {
            var blob = $workerBlob(workerUrl);
            var URL = window.URL || window.webkitURL;
            var blobURL = URL.createObjectURL(blob);
            return new Worker(blobURL);
        }
        return new Worker(workerUrl);
    }
    var WorkerClient = function(worker) {
        if (!worker.postMessage) worker = this.$createWorkerFromOldConfig.apply(this, arguments);
        this.$worker = worker;
        this.$sendDeltaQueue = this.$sendDeltaQueue.bind(this);
        this.changeListener = this.changeListener.bind(this);
        this.onMessage = this.onMessage.bind(this);
        this.callbackId = 1;
        this.callbacks = {};
        this.$worker.onmessage = this.onMessage;
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.$createWorkerFromOldConfig = function(topLevelNamespaces, mod, classname, workerUrl, importScripts) {
            if (require.nameToUrl && !require.toUrl) require.toUrl = require.nameToUrl;
            if (config.get("packaged") || !require.toUrl) workerUrl = workerUrl || config.moduleUrl(mod, "worker");
            else {
                var normalizePath = this.$normalizePath;
                workerUrl = workerUrl || normalizePath(require.toUrl("ace/worker/worker.js", null, "_"));
                var tlns = {};
                topLevelNamespaces.forEach(function(ns) {
                    tlns[ns] = normalizePath(require.toUrl(ns, null, "_").replace(/(\.js)?(\?.*)?$/, ""));
                });
            }
            this.$worker = createWorker(workerUrl);
            if (importScripts) this.send("importScripts", importScripts);
            this.$worker.postMessage({
                init: true,
                tlns: tlns,
                module: mod,
                classname: classname
            });
            return this.$worker;
        };
        this.onMessage = function(e) {
            var msg = e.data;
            switch(msg.type){
                case "event":
                    this._signal(msg.name, {
                        data: msg.data
                    });
                    break;
                case "call":
                    var callback = this.callbacks[msg.id];
                    if (callback) {
                        callback(msg.data);
                        delete this.callbacks[msg.id];
                    }
                    break;
                case "error":
                    this.reportError(msg.data);
                    break;
                case "log":
                    window.console && console.log && console.log.apply(console, msg.data);
                    break;
            }
        };
        this.reportError = function(err) {
            window.console && console.error && console.error(err);
        };
        this.$normalizePath = function(path) {
            return net.qualifyURL(path);
        };
        this.terminate = function() {
            this._signal("terminate", {});
            this.deltaQueue = null;
            this.$worker.terminate();
            this.$worker.onerror = function(e) {
                e.preventDefault();
            };
            this.$worker = null;
            if (this.$doc) this.$doc.off("change", this.changeListener);
            this.$doc = null;
        };
        this.send = function(cmd, args) {
            this.$worker.postMessage({
                command: cmd,
                args: args
            });
        };
        this.call = function(cmd, args, callback) {
            if (callback) {
                var id = this.callbackId++;
                this.callbacks[id] = callback;
                args.push(id);
            }
            this.send(cmd, args);
        };
        this.emit = function(event, data) {
            try {
                if (data.data && data.data.err) data.data.err = {
                    message: data.data.err.message,
                    stack: data.data.err.stack,
                    code: data.data.err.code
                };
                this.$worker && this.$worker.postMessage({
                    event: event,
                    data: {
                        data: data.data
                    }
                });
            } catch (ex) {
                console.error(ex.stack);
            }
        };
        this.attachToDocument = function(doc) {
            if (this.$doc) this.terminate();
            this.$doc = doc;
            this.call("setValue", [
                doc.getValue()
            ]);
            doc.on("change", this.changeListener, true);
        };
        this.changeListener = function(delta) {
            if (!this.deltaQueue) {
                this.deltaQueue = [];
                setTimeout(this.$sendDeltaQueue, 0);
            }
            if (delta.action == "insert") this.deltaQueue.push(delta.start, delta.lines);
            else this.deltaQueue.push(delta.start, delta.end);
        };
        this.$sendDeltaQueue = function() {
            var q = this.deltaQueue;
            if (!q) return;
            this.deltaQueue = null;
            if (q.length > 50 && q.length > this.$doc.getLength() >> 1) this.call("setValue", [
                this.$doc.getValue()
            ]);
            else this.emit("change", {
                data: q
            });
        };
    }).call(WorkerClient.prototype);
    var UIWorkerClient = function(topLevelNamespaces, mod, classname) {
        var main = null;
        var emitSync = false;
        var sender = Object.create(EventEmitter);
        var messageBuffer = [];
        var workerClient = new WorkerClient({
            messageBuffer: messageBuffer,
            terminate: function() {},
            postMessage: function(e) {
                messageBuffer.push(e);
                if (!main) return;
                if (emitSync) setTimeout(processNext);
                else processNext();
            }
        });
        workerClient.setEmitSync = function(val) {
            emitSync = val;
        };
        var processNext = function() {
            var msg = messageBuffer.shift();
            if (msg.command) main[msg.command].apply(main, msg.args);
            else if (msg.event) sender._signal(msg.event, msg.data);
        };
        sender.postMessage = function(msg) {
            workerClient.onMessage({
                data: msg
            });
        };
        sender.callback = function(data, callbackId) {
            this.postMessage({
                type: "call",
                id: callbackId,
                data: data
            });
        };
        sender.emit = function(name, data) {
            this.postMessage({
                type: "event",
                name: name,
                data: data
            });
        };
        config.loadModule([
            "worker",
            mod
        ], function(Main) {
            main = new Main[classname](sender);
            while(messageBuffer.length)processNext();
        });
        return workerClient;
    };
    exports.UIWorkerClient = UIWorkerClient;
    exports.WorkerClient = WorkerClient;
    exports.createWorker = createWorker;
});
ace.define("ace/placeholder", [
    "require",
    "exports",
    "module",
    "ace/range",
    "ace/lib/event_emitter",
    "ace/lib/oop"
], function(require, exports, module1) {
    "use strict";
    var Range = require("./range").Range;
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var oop = require("./lib/oop");
    var PlaceHolder = /** @class */ function() {
        function PlaceHolder(session, length, pos, others, mainClass, othersClass) {
            var _self = this;
            this.length = length;
            this.session = session;
            this.doc = session.getDocument();
            this.mainClass = mainClass;
            this.othersClass = othersClass;
            this.$onUpdate = this.onUpdate.bind(this);
            this.doc.on("change", this.$onUpdate, true);
            this.$others = others;
            this.$onCursorChange = function() {
                setTimeout(function() {
                    _self.onCursorChange();
                });
            };
            this.$pos = pos;
            var undoStack = session.getUndoManager().$undoStack || session.getUndoManager()["$undostack"] || {
                length: -1
            };
            this.$undoStackDepth = undoStack.length;
            this.setup();
            session.selection.on("changeCursor", this.$onCursorChange);
        }
        PlaceHolder.prototype.setup = function() {
            var _self = this;
            var doc = this.doc;
            var session = this.session;
            this.selectionBefore = session.selection.toJSON();
            if (session.selection.inMultiSelectMode) session.selection.toSingleRange();
            this.pos = doc.createAnchor(this.$pos.row, this.$pos.column);
            var pos = this.pos;
            pos.$insertRight = true;
            pos.detach();
            pos.markerId = session.addMarker(new Range(pos.row, pos.column, pos.row, pos.column + this.length), this.mainClass, null, false);
            this.others = [];
            this.$others.forEach(function(other) {
                var anchor = doc.createAnchor(other.row, other.column);
                anchor.$insertRight = true;
                anchor.detach();
                _self.others.push(anchor);
            });
            session.setUndoSelect(false);
        };
        PlaceHolder.prototype.showOtherMarkers = function() {
            if (this.othersActive) return;
            var session = this.session;
            var _self = this;
            this.othersActive = true;
            this.others.forEach(function(anchor) {
                anchor.markerId = session.addMarker(new Range(anchor.row, anchor.column, anchor.row, anchor.column + _self.length), _self.othersClass, null, false);
            });
        };
        PlaceHolder.prototype.hideOtherMarkers = function() {
            if (!this.othersActive) return;
            this.othersActive = false;
            for(var i = 0; i < this.others.length; i++)this.session.removeMarker(this.others[i].markerId);
        };
        PlaceHolder.prototype.onUpdate = function(delta) {
            if (this.$updating) return this.updateAnchors(delta);
            var range = delta;
            if (range.start.row !== range.end.row) return;
            if (range.start.row !== this.pos.row) return;
            this.$updating = true;
            var lengthDiff = delta.action === "insert" ? range.end.column - range.start.column : range.start.column - range.end.column;
            var inMainRange = range.start.column >= this.pos.column && range.start.column <= this.pos.column + this.length + 1;
            var distanceFromStart = range.start.column - this.pos.column;
            this.updateAnchors(delta);
            if (inMainRange) this.length += lengthDiff;
            if (inMainRange && !this.session.$fromUndo) {
                if (delta.action === "insert") for(var i = this.others.length - 1; i >= 0; i--){
                    var otherPos = this.others[i];
                    var newPos = {
                        row: otherPos.row,
                        column: otherPos.column + distanceFromStart
                    };
                    this.doc.insertMergedLines(newPos, delta.lines);
                }
                else if (delta.action === "remove") for(var i = this.others.length - 1; i >= 0; i--){
                    var otherPos = this.others[i];
                    var newPos = {
                        row: otherPos.row,
                        column: otherPos.column + distanceFromStart
                    };
                    this.doc.remove(new Range(newPos.row, newPos.column, newPos.row, newPos.column - lengthDiff));
                }
            }
            this.$updating = false;
            this.updateMarkers();
        };
        PlaceHolder.prototype.updateAnchors = function(delta) {
            this.pos.onChange(delta);
            for(var i = this.others.length; i--;)this.others[i].onChange(delta);
            this.updateMarkers();
        };
        PlaceHolder.prototype.updateMarkers = function() {
            if (this.$updating) return;
            var _self = this;
            var session = this.session;
            var updateMarker = function(pos, className) {
                session.removeMarker(pos.markerId);
                pos.markerId = session.addMarker(new Range(pos.row, pos.column, pos.row, pos.column + _self.length), className, null, false);
            };
            updateMarker(this.pos, this.mainClass);
            for(var i = this.others.length; i--;)updateMarker(this.others[i], this.othersClass);
        };
        PlaceHolder.prototype.onCursorChange = function(event) {
            if (this.$updating || !this.session) return;
            var pos = this.session.selection.getCursor();
            if (pos.row === this.pos.row && pos.column >= this.pos.column && pos.column <= this.pos.column + this.length) {
                this.showOtherMarkers();
                this._emit("cursorEnter", event);
            } else {
                this.hideOtherMarkers();
                this._emit("cursorLeave", event);
            }
        };
        PlaceHolder.prototype.detach = function() {
            this.session.removeMarker(this.pos && this.pos.markerId);
            this.hideOtherMarkers();
            this.doc.off("change", this.$onUpdate);
            this.session.selection.off("changeCursor", this.$onCursorChange);
            this.session.setUndoSelect(true);
            this.session = null;
        };
        PlaceHolder.prototype.cancel = function() {
            if (this.$undoStackDepth === -1) return;
            var undoManager = this.session.getUndoManager();
            var undosRequired = (undoManager.$undoStack || undoManager["$undostack"]).length - this.$undoStackDepth;
            for(var i = 0; i < undosRequired; i++)undoManager.undo(this.session, true);
            if (this.selectionBefore) this.session.selection.fromJSON(this.selectionBefore);
        };
        return PlaceHolder;
    }();
    oop.implement(PlaceHolder.prototype, EventEmitter);
    exports.PlaceHolder = PlaceHolder;
});
ace.define("ace/mouse/multi_select_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/event",
    "ace/lib/useragent"
], function(require, exports, module1) {
    var event = require("../lib/event");
    var useragent = require("../lib/useragent");
    function isSamePoint(p1, p2) {
        return p1.row == p2.row && p1.column == p2.column;
    }
    function onMouseDown(e) {
        var ev = e.domEvent;
        var alt = ev.altKey;
        var shift = ev.shiftKey;
        var ctrl = ev.ctrlKey;
        var accel = e.getAccelKey();
        var button = e.getButton();
        if (ctrl && useragent.isMac) button = ev.button;
        if (e.editor.inMultiSelectMode && button == 2) {
            e.editor.textInput.onContextMenu(e.domEvent);
            return;
        }
        if (!ctrl && !alt && !accel) {
            if (button === 0 && e.editor.inMultiSelectMode) e.editor.exitMultiSelectMode();
            return;
        }
        if (button !== 0) return;
        var editor = e.editor;
        var selection = editor.selection;
        var isMultiSelect = editor.inMultiSelectMode;
        var pos = e.getDocumentPosition();
        var cursor = selection.getCursor();
        var inSelection = e.inSelection() || selection.isEmpty() && isSamePoint(pos, cursor);
        var mouseX = e.x, mouseY = e.y;
        var onMouseSelection = function(e) {
            mouseX = e.clientX;
            mouseY = e.clientY;
        };
        var session = editor.session;
        var screenAnchor = editor.renderer.pixelToScreenCoordinates(mouseX, mouseY);
        var screenCursor = screenAnchor;
        var selectionMode;
        if (editor.$mouseHandler.$enableJumpToDef) {
            if (ctrl && alt || accel && alt) selectionMode = shift ? "block" : "add";
            else if (alt && editor.$blockSelectEnabled) selectionMode = "block";
        } else {
            if (accel && !alt) {
                selectionMode = "add";
                if (!isMultiSelect && shift) return;
            } else if (alt && editor.$blockSelectEnabled) selectionMode = "block";
        }
        if (selectionMode && useragent.isMac && ev.ctrlKey) editor.$mouseHandler.cancelContextMenu();
        if (selectionMode == "add") {
            if (!isMultiSelect && inSelection) return; // dragging
            if (!isMultiSelect) {
                var range = selection.toOrientedRange();
                editor.addSelectionMarker(range);
            }
            var oldRange = selection.rangeList.rangeAtPoint(pos);
            editor.inVirtualSelectionMode = true;
            if (shift) {
                oldRange = null;
                range = selection.ranges[0] || range;
                editor.removeSelectionMarker(range);
            }
            editor.once("mouseup", function() {
                var tmpSel = selection.toOrientedRange();
                if (oldRange && tmpSel.isEmpty() && isSamePoint(oldRange.cursor, tmpSel.cursor)) selection.substractPoint(tmpSel.cursor);
                else {
                    if (shift) selection.substractPoint(range.cursor);
                    else if (range) {
                        editor.removeSelectionMarker(range);
                        selection.addRange(range);
                    }
                    selection.addRange(tmpSel);
                }
                editor.inVirtualSelectionMode = false;
            });
        } else if (selectionMode == "block") {
            e.stop();
            editor.inVirtualSelectionMode = true;
            var initialRange;
            var rectSel = [];
            var blockSelect = function() {
                var newCursor = editor.renderer.pixelToScreenCoordinates(mouseX, mouseY);
                var cursor = session.screenToDocumentPosition(newCursor.row, newCursor.column, newCursor.offsetX);
                if (isSamePoint(screenCursor, newCursor) && isSamePoint(cursor, selection.lead)) return;
                screenCursor = newCursor;
                editor.selection.moveToPosition(cursor);
                editor.renderer.scrollCursorIntoView();
                editor.removeSelectionMarkers(rectSel);
                rectSel = selection.rectangularRangeBlock(screenCursor, screenAnchor);
                if (editor.$mouseHandler.$clickSelection && rectSel.length == 1 && rectSel[0].isEmpty()) rectSel[0] = editor.$mouseHandler.$clickSelection.clone();
                rectSel.forEach(editor.addSelectionMarker, editor);
                editor.updateSelectionMarkers();
            };
            if (isMultiSelect && !accel) selection.toSingleRange();
            else if (!isMultiSelect && accel) {
                initialRange = selection.toOrientedRange();
                editor.addSelectionMarker(initialRange);
            }
            if (shift) screenAnchor = session.documentToScreenPosition(selection.lead);
            else selection.moveToPosition(pos);
            screenCursor = {
                row: -1,
                column: -1
            };
            var onMouseSelectionEnd = function(e) {
                blockSelect();
                clearInterval(timerId);
                editor.removeSelectionMarkers(rectSel);
                if (!rectSel.length) rectSel = [
                    selection.toOrientedRange()
                ];
                if (initialRange) {
                    editor.removeSelectionMarker(initialRange);
                    selection.toSingleRange(initialRange);
                }
                for(var i = 0; i < rectSel.length; i++)selection.addRange(rectSel[i]);
                editor.inVirtualSelectionMode = false;
                editor.$mouseHandler.$clickSelection = null;
            };
            var onSelectionInterval = blockSelect;
            event.capture(editor.container, onMouseSelection, onMouseSelectionEnd);
            var timerId = setInterval(function() {
                onSelectionInterval();
            }, 20);
            return e.preventDefault();
        }
    }
    exports.onMouseDown = onMouseDown;
});
ace.define("ace/commands/multi_select_commands", [
    "require",
    "exports",
    "module",
    "ace/keyboard/hash_handler"
], function(require, exports, module1) {
    exports.defaultCommands = [
        {
            name: "addCursorAbove",
            description: "Add cursor above",
            exec: function(editor) {
                editor.selectMoreLines(-1);
            },
            bindKey: {
                win: "Ctrl-Alt-Up",
                mac: "Ctrl-Alt-Up"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "addCursorBelow",
            description: "Add cursor below",
            exec: function(editor) {
                editor.selectMoreLines(1);
            },
            bindKey: {
                win: "Ctrl-Alt-Down",
                mac: "Ctrl-Alt-Down"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "addCursorAboveSkipCurrent",
            description: "Add cursor above (skip current)",
            exec: function(editor) {
                editor.selectMoreLines(-1, true);
            },
            bindKey: {
                win: "Ctrl-Alt-Shift-Up",
                mac: "Ctrl-Alt-Shift-Up"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "addCursorBelowSkipCurrent",
            description: "Add cursor below (skip current)",
            exec: function(editor) {
                editor.selectMoreLines(1, true);
            },
            bindKey: {
                win: "Ctrl-Alt-Shift-Down",
                mac: "Ctrl-Alt-Shift-Down"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectMoreBefore",
            description: "Select more before",
            exec: function(editor) {
                editor.selectMore(-1);
            },
            bindKey: {
                win: "Ctrl-Alt-Left",
                mac: "Ctrl-Alt-Left"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectMoreAfter",
            description: "Select more after",
            exec: function(editor) {
                editor.selectMore(1);
            },
            bindKey: {
                win: "Ctrl-Alt-Right",
                mac: "Ctrl-Alt-Right"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectNextBefore",
            description: "Select next before",
            exec: function(editor) {
                editor.selectMore(-1, true);
            },
            bindKey: {
                win: "Ctrl-Alt-Shift-Left",
                mac: "Ctrl-Alt-Shift-Left"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectNextAfter",
            description: "Select next after",
            exec: function(editor) {
                editor.selectMore(1, true);
            },
            bindKey: {
                win: "Ctrl-Alt-Shift-Right",
                mac: "Ctrl-Alt-Shift-Right"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "toggleSplitSelectionIntoLines",
            description: "Split selection into lines",
            exec: function(editor) {
                if (editor.multiSelect.rangeCount > 1) editor.multiSelect.joinSelections();
                else editor.multiSelect.splitIntoLines();
            },
            bindKey: {
                win: "Ctrl-Alt-L",
                mac: "Ctrl-Alt-L"
            },
            readOnly: true
        },
        {
            name: "splitSelectionIntoLines",
            description: "Split into lines",
            exec: function(editor) {
                editor.multiSelect.splitIntoLines();
            },
            readOnly: true
        },
        {
            name: "alignCursors",
            description: "Align cursors",
            exec: function(editor) {
                editor.alignCursors();
            },
            bindKey: {
                win: "Ctrl-Alt-A",
                mac: "Ctrl-Alt-A"
            },
            scrollIntoView: "cursor"
        },
        {
            name: "findAll",
            description: "Find all",
            exec: function(editor) {
                editor.findAll();
            },
            bindKey: {
                win: "Ctrl-Alt-K",
                mac: "Ctrl-Alt-G"
            },
            scrollIntoView: "cursor",
            readOnly: true
        }
    ];
    exports.multiSelectCommands = [
        {
            name: "singleSelection",
            description: "Single selection",
            bindKey: "esc",
            exec: function(editor) {
                editor.exitMultiSelectMode();
            },
            scrollIntoView: "cursor",
            readOnly: true,
            isAvailable: function(editor) {
                return editor && editor.inMultiSelectMode;
            }
        }
    ];
    var HashHandler = require("../keyboard/hash_handler").HashHandler;
    exports.keyboardHandler = new HashHandler(exports.multiSelectCommands);
});
ace.define("ace/multi_select", [
    "require",
    "exports",
    "module",
    "ace/range_list",
    "ace/range",
    "ace/selection",
    "ace/mouse/multi_select_handler",
    "ace/lib/event",
    "ace/lib/lang",
    "ace/commands/multi_select_commands",
    "ace/search",
    "ace/edit_session",
    "ace/editor",
    "ace/config"
], function(require, exports, module1) {
    var RangeList = require("./range_list").RangeList;
    var Range = require("./range").Range;
    var Selection = require("./selection").Selection;
    var onMouseDown = require("./mouse/multi_select_handler").onMouseDown;
    var event = require("./lib/event");
    var lang = require("./lib/lang");
    var commands = require("./commands/multi_select_commands");
    exports.commands = commands.defaultCommands.concat(commands.multiSelectCommands);
    var Search = require("./search").Search;
    var search = new Search();
    function find(session, needle, dir) {
        search.$options.wrap = true;
        search.$options.needle = needle;
        search.$options.backwards = dir == -1;
        return search.find(session);
    }
    var EditSession = require("./edit_session").EditSession;
    (function() {
        this.getSelectionMarkers = function() {
            return this.$selectionMarkers;
        };
    }).call(EditSession.prototype);
    (function() {
        this.ranges = null;
        this.rangeList = null;
        this.addRange = function(range, $blockChangeEvents) {
            if (!range) return;
            if (!this.inMultiSelectMode && this.rangeCount === 0) {
                var oldRange = this.toOrientedRange();
                this.rangeList.add(oldRange);
                this.rangeList.add(range);
                if (this.rangeList.ranges.length != 2) {
                    this.rangeList.removeAll();
                    return $blockChangeEvents || this.fromOrientedRange(range);
                }
                this.rangeList.removeAll();
                this.rangeList.add(oldRange);
                this.$onAddRange(oldRange);
            }
            if (!range.cursor) range.cursor = range.end;
            var removed = this.rangeList.add(range);
            this.$onAddRange(range);
            if (removed.length) this.$onRemoveRange(removed);
            if (this.rangeCount > 1 && !this.inMultiSelectMode) {
                this._signal("multiSelect");
                this.inMultiSelectMode = true;
                this.session.$undoSelect = false;
                this.rangeList.attach(this.session);
            }
            return $blockChangeEvents || this.fromOrientedRange(range);
        };
        this.toSingleRange = function(range) {
            range = range || this.ranges[0];
            var removed = this.rangeList.removeAll();
            if (removed.length) this.$onRemoveRange(removed);
            range && this.fromOrientedRange(range);
        };
        this.substractPoint = function(pos) {
            var removed = this.rangeList.substractPoint(pos);
            if (removed) {
                this.$onRemoveRange(removed);
                return removed[0];
            }
        };
        this.mergeOverlappingRanges = function() {
            var removed = this.rangeList.merge();
            if (removed.length) this.$onRemoveRange(removed);
        };
        this.$onAddRange = function(range) {
            this.rangeCount = this.rangeList.ranges.length;
            this.ranges.unshift(range);
            this._signal("addRange", {
                range: range
            });
        };
        this.$onRemoveRange = function(removed) {
            this.rangeCount = this.rangeList.ranges.length;
            if (this.rangeCount == 1 && this.inMultiSelectMode) {
                var lastRange = this.rangeList.ranges.pop();
                removed.push(lastRange);
                this.rangeCount = 0;
            }
            for(var i = removed.length; i--;){
                var index = this.ranges.indexOf(removed[i]);
                this.ranges.splice(index, 1);
            }
            this._signal("removeRange", {
                ranges: removed
            });
            if (this.rangeCount === 0 && this.inMultiSelectMode) {
                this.inMultiSelectMode = false;
                this._signal("singleSelect");
                this.session.$undoSelect = true;
                this.rangeList.detach(this.session);
            }
            lastRange = lastRange || this.ranges[0];
            if (lastRange && !lastRange.isEqual(this.getRange())) this.fromOrientedRange(lastRange);
        };
        this.$initRangeList = function() {
            if (this.rangeList) return;
            this.rangeList = new RangeList();
            this.ranges = [];
            this.rangeCount = 0;
        };
        this.getAllRanges = function() {
            return this.rangeCount ? this.rangeList.ranges.concat() : [
                this.getRange()
            ];
        };
        this.splitIntoLines = function() {
            var ranges = this.ranges.length ? this.ranges : [
                this.getRange()
            ];
            var newRanges = [];
            for(var i = 0; i < ranges.length; i++){
                var range = ranges[i];
                var row = range.start.row;
                var endRow = range.end.row;
                if (row === endRow) newRanges.push(range.clone());
                else {
                    newRanges.push(new Range(row, range.start.column, row, this.session.getLine(row).length));
                    while(++row < endRow)newRanges.push(this.getLineRange(row, true));
                    newRanges.push(new Range(endRow, 0, endRow, range.end.column));
                }
                if (i == 0 && !this.isBackwards()) newRanges = newRanges.reverse();
            }
            this.toSingleRange();
            for(var i = newRanges.length; i--;)this.addRange(newRanges[i]);
        };
        this.joinSelections = function() {
            var ranges = this.rangeList.ranges;
            var lastRange = ranges[ranges.length - 1];
            var range = Range.fromPoints(ranges[0].start, lastRange.end);
            this.toSingleRange();
            this.setSelectionRange(range, lastRange.cursor == lastRange.start);
        };
        this.toggleBlockSelection = function() {
            if (this.rangeCount > 1) {
                var ranges = this.rangeList.ranges;
                var lastRange = ranges[ranges.length - 1];
                var range = Range.fromPoints(ranges[0].start, lastRange.end);
                this.toSingleRange();
                this.setSelectionRange(range, lastRange.cursor == lastRange.start);
            } else {
                var cursor = this.session.documentToScreenPosition(this.cursor);
                var anchor = this.session.documentToScreenPosition(this.anchor);
                var rectSel = this.rectangularRangeBlock(cursor, anchor);
                rectSel.forEach(this.addRange, this);
            }
        };
        this.rectangularRangeBlock = function(screenCursor, screenAnchor, includeEmptyLines) {
            var rectSel = [];
            var xBackwards = screenCursor.column < screenAnchor.column;
            if (xBackwards) {
                var startColumn = screenCursor.column;
                var endColumn = screenAnchor.column;
                var startOffsetX = screenCursor.offsetX;
                var endOffsetX = screenAnchor.offsetX;
            } else {
                var startColumn = screenAnchor.column;
                var endColumn = screenCursor.column;
                var startOffsetX = screenAnchor.offsetX;
                var endOffsetX = screenCursor.offsetX;
            }
            var yBackwards = screenCursor.row < screenAnchor.row;
            if (yBackwards) {
                var startRow = screenCursor.row;
                var endRow = screenAnchor.row;
            } else {
                var startRow = screenAnchor.row;
                var endRow = screenCursor.row;
            }
            if (startColumn < 0) startColumn = 0;
            if (startRow < 0) startRow = 0;
            if (startRow == endRow) includeEmptyLines = true;
            var docEnd;
            for(var row = startRow; row <= endRow; row++){
                var range = Range.fromPoints(this.session.screenToDocumentPosition(row, startColumn, startOffsetX), this.session.screenToDocumentPosition(row, endColumn, endOffsetX));
                if (range.isEmpty()) {
                    if (docEnd && isSamePoint(range.end, docEnd)) break;
                    docEnd = range.end;
                }
                range.cursor = xBackwards ? range.start : range.end;
                rectSel.push(range);
            }
            if (yBackwards) rectSel.reverse();
            if (!includeEmptyLines) {
                var end = rectSel.length - 1;
                while(rectSel[end].isEmpty() && end > 0)end--;
                if (end > 0) {
                    var start = 0;
                    while(rectSel[start].isEmpty())start++;
                }
                for(var i = end; i >= start; i--)if (rectSel[i].isEmpty()) rectSel.splice(i, 1);
            }
            return rectSel;
        };
    }).call(Selection.prototype);
    var Editor = require("./editor").Editor;
    (function() {
        this.updateSelectionMarkers = function() {
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
        };
        this.addSelectionMarker = function(orientedRange) {
            if (!orientedRange.cursor) orientedRange.cursor = orientedRange.end;
            var style = this.getSelectionStyle();
            orientedRange.marker = this.session.addMarker(orientedRange, "ace_selection", style);
            this.session.$selectionMarkers.push(orientedRange);
            this.session.selectionMarkerCount = this.session.$selectionMarkers.length;
            return orientedRange;
        };
        this.removeSelectionMarker = function(range) {
            if (!range.marker) return;
            this.session.removeMarker(range.marker);
            var index = this.session.$selectionMarkers.indexOf(range);
            if (index != -1) this.session.$selectionMarkers.splice(index, 1);
            this.session.selectionMarkerCount = this.session.$selectionMarkers.length;
        };
        this.removeSelectionMarkers = function(ranges) {
            var markerList = this.session.$selectionMarkers;
            for(var i = ranges.length; i--;){
                var range = ranges[i];
                if (!range.marker) continue;
                this.session.removeMarker(range.marker);
                var index = markerList.indexOf(range);
                if (index != -1) markerList.splice(index, 1);
            }
            this.session.selectionMarkerCount = markerList.length;
        };
        this.$onAddRange = function(e) {
            this.addSelectionMarker(e.range);
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
        };
        this.$onRemoveRange = function(e) {
            this.removeSelectionMarkers(e.ranges);
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
        };
        this.$onMultiSelect = function(e) {
            if (this.inMultiSelectMode) return;
            this.inMultiSelectMode = true;
            this.setStyle("ace_multiselect");
            this.keyBinding.addKeyboardHandler(commands.keyboardHandler);
            this.commands.setDefaultHandler("exec", this.$onMultiSelectExec);
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
        };
        this.$onSingleSelect = function(e) {
            if (this.session.multiSelect.inVirtualMode) return;
            this.inMultiSelectMode = false;
            this.unsetStyle("ace_multiselect");
            this.keyBinding.removeKeyboardHandler(commands.keyboardHandler);
            this.commands.removeDefaultHandler("exec", this.$onMultiSelectExec);
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
            this._emit("changeSelection");
        };
        this.$onMultiSelectExec = function(e) {
            var command = e.command;
            var editor = e.editor;
            if (!editor.multiSelect) return;
            if (!command.multiSelectAction) {
                var result = command.exec(editor, e.args || {});
                editor.multiSelect.addRange(editor.multiSelect.toOrientedRange());
                editor.multiSelect.mergeOverlappingRanges();
            } else if (command.multiSelectAction == "forEach") result = editor.forEachSelection(command, e.args);
            else if (command.multiSelectAction == "forEachLine") result = editor.forEachSelection(command, e.args, true);
            else if (command.multiSelectAction == "single") {
                editor.exitMultiSelectMode();
                result = command.exec(editor, e.args || {});
            } else result = command.multiSelectAction(editor, e.args || {});
            return result;
        };
        this.forEachSelection = function(cmd, args, options) {
            if (this.inVirtualSelectionMode) return;
            var keepOrder = options && options.keepOrder;
            var $byLines = options == true || options && options.$byLines;
            var session = this.session;
            var selection = this.selection;
            var rangeList = selection.rangeList;
            var ranges = (keepOrder ? selection : rangeList).ranges;
            var result;
            if (!ranges.length) return cmd.exec ? cmd.exec(this, args || {}) : cmd(this, args || {});
            var reg = selection._eventRegistry;
            selection._eventRegistry = {};
            var tmpSel = new Selection(session);
            this.inVirtualSelectionMode = true;
            for(var i = ranges.length; i--;){
                if ($byLines) while(i > 0 && ranges[i].start.row == ranges[i - 1].end.row)i--;
                tmpSel.fromOrientedRange(ranges[i]);
                tmpSel.index = i;
                this.selection = session.selection = tmpSel;
                var cmdResult = cmd.exec ? cmd.exec(this, args || {}) : cmd(this, args || {});
                if (!result && cmdResult !== undefined) result = cmdResult;
                tmpSel.toOrientedRange(ranges[i]);
            }
            tmpSel.detach();
            this.selection = session.selection = selection;
            this.inVirtualSelectionMode = false;
            selection._eventRegistry = reg;
            selection.mergeOverlappingRanges();
            if (selection.ranges[0]) selection.fromOrientedRange(selection.ranges[0]);
            var anim = this.renderer.$scrollAnimation;
            this.onCursorChange();
            this.onSelectionChange();
            if (anim && anim.from == anim.to) this.renderer.animateScrolling(anim.from);
            return result;
        };
        this.exitMultiSelectMode = function() {
            if (!this.inMultiSelectMode || this.inVirtualSelectionMode) return;
            this.multiSelect.toSingleRange();
        };
        this.getSelectedText = function() {
            var text = "";
            if (this.inMultiSelectMode && !this.inVirtualSelectionMode) {
                var ranges = this.multiSelect.rangeList.ranges;
                var buf = [];
                for(var i = 0; i < ranges.length; i++)buf.push(this.session.getTextRange(ranges[i]));
                var nl = this.session.getDocument().getNewLineCharacter();
                text = buf.join(nl);
                if (text.length == (buf.length - 1) * nl.length) text = "";
            } else if (!this.selection.isEmpty()) text = this.session.getTextRange(this.getSelectionRange());
            return text;
        };
        this.$checkMultiselectChange = function(e, anchor) {
            if (this.inMultiSelectMode && !this.inVirtualSelectionMode) {
                var range = this.multiSelect.ranges[0];
                if (this.multiSelect.isEmpty() && anchor == this.multiSelect.anchor) return;
                var pos = anchor == this.multiSelect.anchor ? range.cursor == range.start ? range.end : range.start : range.cursor;
                if (pos.row != anchor.row || this.session.$clipPositionToDocument(pos.row, pos.column).column != anchor.column) this.multiSelect.toSingleRange(this.multiSelect.toOrientedRange());
                else this.multiSelect.mergeOverlappingRanges();
            }
        };
        this.findAll = function(needle, options, additive) {
            options = options || {};
            options.needle = needle || options.needle;
            if (options.needle == undefined) {
                var range = this.selection.isEmpty() ? this.selection.getWordRange() : this.selection.getRange();
                options.needle = this.session.getTextRange(range);
            }
            this.$search.set(options);
            var ranges = this.$search.findAll(this.session);
            if (!ranges.length) return 0;
            var selection = this.multiSelect;
            if (!additive) selection.toSingleRange(ranges[0]);
            for(var i = ranges.length; i--;)selection.addRange(ranges[i], true);
            if (range && selection.rangeList.rangeAtPoint(range.start)) selection.addRange(range, true);
            return ranges.length;
        };
        this.selectMoreLines = function(dir, skip) {
            var range = this.selection.toOrientedRange();
            var isBackwards = range.cursor == range.end;
            var screenLead = this.session.documentToScreenPosition(range.cursor);
            if (this.selection.$desiredColumn) screenLead.column = this.selection.$desiredColumn;
            var lead = this.session.screenToDocumentPosition(screenLead.row + dir, screenLead.column);
            if (!range.isEmpty()) {
                var screenAnchor = this.session.documentToScreenPosition(isBackwards ? range.end : range.start);
                var anchor = this.session.screenToDocumentPosition(screenAnchor.row + dir, screenAnchor.column);
            } else var anchor = lead;
            if (isBackwards) {
                var newRange = Range.fromPoints(lead, anchor);
                newRange.cursor = newRange.start;
            } else {
                var newRange = Range.fromPoints(anchor, lead);
                newRange.cursor = newRange.end;
            }
            newRange.desiredColumn = screenLead.column;
            if (!this.selection.inMultiSelectMode) this.selection.addRange(range);
            else if (skip) var toRemove = range.cursor;
            this.selection.addRange(newRange);
            if (toRemove) this.selection.substractPoint(toRemove);
        };
        this.transposeSelections = function(dir) {
            var session = this.session;
            var sel = session.multiSelect;
            var all = sel.ranges;
            for(var i = all.length; i--;){
                var range = all[i];
                if (range.isEmpty()) {
                    var tmp_1 = session.getWordRange(range.start.row, range.start.column);
                    range.start.row = tmp_1.start.row;
                    range.start.column = tmp_1.start.column;
                    range.end.row = tmp_1.end.row;
                    range.end.column = tmp_1.end.column;
                }
            }
            sel.mergeOverlappingRanges();
            var words = [];
            for(var i = all.length; i--;){
                var range = all[i];
                words.unshift(session.getTextRange(range));
            }
            if (dir < 0) words.unshift(words.pop());
            else words.push(words.shift());
            for(var i = all.length; i--;){
                var range = all[i];
                var tmp = range.clone();
                session.replace(range, words[i]);
                range.start.row = tmp.start.row;
                range.start.column = tmp.start.column;
            }
            sel.fromOrientedRange(sel.ranges[0]);
        };
        this.selectMore = function(dir, skip, stopAtFirst) {
            var session = this.session;
            var sel = session.multiSelect;
            var range = sel.toOrientedRange();
            if (range.isEmpty()) {
                range = session.getWordRange(range.start.row, range.start.column);
                range.cursor = dir == -1 ? range.start : range.end;
                this.multiSelect.addRange(range);
                if (stopAtFirst) return;
            }
            var needle = session.getTextRange(range);
            var newRange = find(session, needle, dir);
            if (newRange) {
                newRange.cursor = dir == -1 ? newRange.start : newRange.end;
                this.session.unfold(newRange);
                this.multiSelect.addRange(newRange);
                this.renderer.scrollCursorIntoView(null, 0.5);
            }
            if (skip) this.multiSelect.substractPoint(range.cursor);
        };
        this.alignCursors = function() {
            var session = this.session;
            var sel = session.multiSelect;
            var ranges = sel.ranges;
            var row = -1;
            var sameRowRanges = ranges.filter(function(r) {
                if (r.cursor.row == row) return true;
                row = r.cursor.row;
            });
            if (!ranges.length || sameRowRanges.length == ranges.length - 1) {
                var range = this.selection.getRange();
                var fr = range.start.row, lr = range.end.row;
                var guessRange = fr == lr;
                if (guessRange) {
                    var max = this.session.getLength();
                    var line;
                    do line = this.session.getLine(lr);
                    while (/[=:]/.test(line) && ++lr < max);
                    do line = this.session.getLine(fr);
                    while (/[=:]/.test(line) && --fr > 0);
                    if (fr < 0) fr = 0;
                    if (lr >= max) lr = max - 1;
                }
                var lines = this.session.removeFullLines(fr, lr);
                lines = this.$reAlignText(lines, guessRange);
                this.session.insert({
                    row: fr,
                    column: 0
                }, lines.join("\n") + "\n");
                if (!guessRange) {
                    range.start.column = 0;
                    range.end.column = lines[lines.length - 1].length;
                }
                this.selection.setRange(range);
            } else {
                sameRowRanges.forEach(function(r) {
                    sel.substractPoint(r.cursor);
                });
                var maxCol = 0;
                var minSpace = Infinity;
                var spaceOffsets = ranges.map(function(r) {
                    var p = r.cursor;
                    var line = session.getLine(p.row);
                    var spaceOffset = line.substr(p.column).search(/\S/g);
                    if (spaceOffset == -1) spaceOffset = 0;
                    if (p.column > maxCol) maxCol = p.column;
                    if (spaceOffset < minSpace) minSpace = spaceOffset;
                    return spaceOffset;
                });
                ranges.forEach(function(r, i) {
                    var p = r.cursor;
                    var l = maxCol - p.column;
                    var d = spaceOffsets[i] - minSpace;
                    if (l > d) session.insert(p, lang.stringRepeat(" ", l - d));
                    else session.remove(new Range(p.row, p.column, p.row, p.column - l + d));
                    r.start.column = r.end.column = maxCol;
                    r.start.row = r.end.row = p.row;
                    r.cursor = r.end;
                });
                sel.fromOrientedRange(ranges[0]);
                this.renderer.updateCursor();
                this.renderer.updateBackMarkers();
            }
        };
        this.$reAlignText = function(lines, forceLeft) {
            var isLeftAligned = true, isRightAligned = true;
            var startW, textW, endW;
            return lines.map(function(line) {
                var m = line.match(/(\s*)(.*?)(\s*)([=:].*)/);
                if (!m) return [
                    line
                ];
                if (startW == null) {
                    startW = m[1].length;
                    textW = m[2].length;
                    endW = m[3].length;
                    return m;
                }
                if (startW + textW + endW != m[1].length + m[2].length + m[3].length) isRightAligned = false;
                if (startW != m[1].length) isLeftAligned = false;
                if (startW > m[1].length) startW = m[1].length;
                if (textW < m[2].length) textW = m[2].length;
                if (endW > m[3].length) endW = m[3].length;
                return m;
            }).map(forceLeft ? alignLeft : isLeftAligned ? isRightAligned ? alignRight : alignLeft : unAlign);
            function spaces(n) {
                return lang.stringRepeat(" ", n);
            }
            function alignLeft(m) {
                return !m[2] ? m[0] : spaces(startW) + m[2] + spaces(textW - m[2].length + endW) + m[4].replace(/^([=:])\s+/, "$1 ");
            }
            function alignRight(m) {
                return !m[2] ? m[0] : spaces(startW + textW - m[2].length) + m[2] + spaces(endW) + m[4].replace(/^([=:])\s+/, "$1 ");
            }
            function unAlign(m) {
                return !m[2] ? m[0] : spaces(startW) + m[2] + spaces(endW) + m[4].replace(/^([=:])\s+/, "$1 ");
            }
        };
    }).call(Editor.prototype);
    function isSamePoint(p1, p2) {
        return p1.row == p2.row && p1.column == p2.column;
    }
    exports.onSessionChange = function(e) {
        var session = e.session;
        if (session && !session.multiSelect) {
            session.$selectionMarkers = [];
            session.selection.$initRangeList();
            session.multiSelect = session.selection;
        }
        this.multiSelect = session && session.multiSelect;
        var oldSession = e.oldSession;
        if (oldSession) {
            oldSession.multiSelect.off("addRange", this.$onAddRange);
            oldSession.multiSelect.off("removeRange", this.$onRemoveRange);
            oldSession.multiSelect.off("multiSelect", this.$onMultiSelect);
            oldSession.multiSelect.off("singleSelect", this.$onSingleSelect);
            oldSession.multiSelect.lead.off("change", this.$checkMultiselectChange);
            oldSession.multiSelect.anchor.off("change", this.$checkMultiselectChange);
        }
        if (session) {
            session.multiSelect.on("addRange", this.$onAddRange);
            session.multiSelect.on("removeRange", this.$onRemoveRange);
            session.multiSelect.on("multiSelect", this.$onMultiSelect);
            session.multiSelect.on("singleSelect", this.$onSingleSelect);
            session.multiSelect.lead.on("change", this.$checkMultiselectChange);
            session.multiSelect.anchor.on("change", this.$checkMultiselectChange);
        }
        if (session && this.inMultiSelectMode != session.selection.inMultiSelectMode) {
            if (session.selection.inMultiSelectMode) this.$onMultiSelect();
            else this.$onSingleSelect();
        }
    };
    function MultiSelect(editor) {
        if (editor.$multiselectOnSessionChange) return;
        editor.$onAddRange = editor.$onAddRange.bind(editor);
        editor.$onRemoveRange = editor.$onRemoveRange.bind(editor);
        editor.$onMultiSelect = editor.$onMultiSelect.bind(editor);
        editor.$onSingleSelect = editor.$onSingleSelect.bind(editor);
        editor.$multiselectOnSessionChange = exports.onSessionChange.bind(editor);
        editor.$checkMultiselectChange = editor.$checkMultiselectChange.bind(editor);
        editor.$multiselectOnSessionChange(editor);
        editor.on("changeSession", editor.$multiselectOnSessionChange);
        editor.on("mousedown", onMouseDown);
        editor.commands.addCommands(commands.defaultCommands);
        addAltCursorListeners(editor);
    }
    function addAltCursorListeners(editor) {
        if (!editor.textInput) return;
        var el = editor.textInput.getElement();
        var altCursor = false;
        event.addListener(el, "keydown", function(e) {
            var altDown = e.keyCode == 18 && !(e.ctrlKey || e.shiftKey || e.metaKey);
            if (editor.$blockSelectEnabled && altDown) {
                if (!altCursor) {
                    editor.renderer.setMouseCursor("crosshair");
                    altCursor = true;
                }
            } else if (altCursor) reset();
        }, editor);
        event.addListener(el, "keyup", reset, editor);
        event.addListener(el, "blur", reset, editor);
        function reset(e) {
            if (altCursor) {
                editor.renderer.setMouseCursor("");
                altCursor = false;
            }
        }
    }
    exports.MultiSelect = MultiSelect;
    require("./config").defineOptions(Editor.prototype, "editor", {
        enableMultiselect: {
            set: function(val) {
                MultiSelect(this);
                if (val) this.on("mousedown", onMouseDown);
                else this.off("mousedown", onMouseDown);
            },
            value: true
        },
        enableBlockSelect: {
            set: function(val) {
                this.$blockSelectEnabled = val;
            },
            value: true
        }
    });
});
ace.define("ace/mode/folding/fold_mode", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../../range").Range;
    var FoldMode = exports.FoldMode = function() {};
    (function() {
        this.foldingStartMarker = null;
        this.foldingStopMarker = null;
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            if (this.foldingStartMarker.test(line)) return "start";
            if (foldStyle == "markbeginend" && this.foldingStopMarker && this.foldingStopMarker.test(line)) return "end";
            return "";
        };
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            return null;
        };
        this.indentationBlock = function(session, row, column) {
            var re = /\S/;
            var line = session.getLine(row);
            var startLevel = line.search(re);
            if (startLevel == -1) return;
            var startColumn = column || line.length;
            var maxRow = session.getLength();
            var startRow = row;
            var endRow = row;
            while(++row < maxRow){
                var level = session.getLine(row).search(re);
                if (level == -1) continue;
                if (level <= startLevel) {
                    var token = session.getTokenAt(row, 0);
                    if (!token || token.type !== "string") break;
                }
                endRow = row;
            }
            if (endRow > startRow) {
                var endColumn = session.getLine(endRow).length;
                return new Range(startRow, startColumn, endRow, endColumn);
            }
        };
        this.openingBracketBlock = function(session, bracket, row, column, typeRe) {
            var start = {
                row: row,
                column: column + 1
            };
            var end = session.$findClosingBracket(bracket, start, typeRe);
            if (!end) return;
            var fw = session.foldWidgets[end.row];
            if (fw == null) fw = session.getFoldWidget(end.row);
            if (fw == "start" && end.row > start.row) {
                end.row--;
                end.column = session.getLine(end.row).length;
            }
            return Range.fromPoints(start, end);
        };
        this.closingBracketBlock = function(session, bracket, row, column, typeRe) {
            var end = {
                row: row,
                column: column
            };
            var start = session.$findOpeningBracket(bracket, end);
            if (!start) return;
            start.column++;
            end.column--;
            return Range.fromPoints(start, end);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/ext/error_marker", [
    "require",
    "exports",
    "module",
    "ace/line_widgets",
    "ace/lib/dom",
    "ace/range",
    "ace/config"
], function(require, exports, module1) {
    "use strict";
    var LineWidgets = require("../line_widgets").LineWidgets;
    var dom = require("../lib/dom");
    var Range = require("../range").Range;
    var nls = require("../config").nls;
    function binarySearch(array, needle, comparator) {
        var first = 0;
        var last = array.length - 1;
        while(first <= last){
            var mid = first + last >> 1;
            var c = comparator(needle, array[mid]);
            if (c > 0) first = mid + 1;
            else if (c < 0) last = mid - 1;
            else return mid;
        }
        return -(first + 1);
    }
    function findAnnotations(session, row, dir) {
        var annotations = session.getAnnotations().sort(Range.comparePoints);
        if (!annotations.length) return;
        var i = binarySearch(annotations, {
            row: row,
            column: -1
        }, Range.comparePoints);
        if (i < 0) i = -i - 1;
        if (i >= annotations.length) i = dir > 0 ? 0 : annotations.length - 1;
        else if (i === 0 && dir < 0) i = annotations.length - 1;
        var annotation = annotations[i];
        if (!annotation || !dir) return;
        if (annotation.row === row) {
            do annotation = annotations[i += dir];
            while (annotation && annotation.row === row);
            if (!annotation) return annotations.slice();
        }
        var matched = [];
        row = annotation.row;
        do {
            matched[dir < 0 ? "unshift" : "push"](annotation);
            annotation = annotations[i += dir];
        }while (annotation && annotation.row == row);
        return matched.length && matched;
    }
    exports.showErrorMarker = function(editor, dir) {
        var session = editor.session;
        if (!session.widgetManager) {
            session.widgetManager = new LineWidgets(session);
            session.widgetManager.attach(editor);
        }
        var pos = editor.getCursorPosition();
        var row = pos.row;
        var oldWidget = session.widgetManager.getWidgetsAtRow(row).filter(function(w) {
            return w.type == "errorMarker";
        })[0];
        if (oldWidget) oldWidget.destroy();
        else row -= dir;
        var annotations = findAnnotations(session, row, dir);
        var gutterAnno;
        if (annotations) {
            var annotation = annotations[0];
            pos.column = (annotation.pos && typeof annotation.column != "number" ? annotation.pos.sc : annotation.column) || 0;
            pos.row = annotation.row;
            gutterAnno = editor.renderer.$gutterLayer.$annotations[pos.row];
        } else if (oldWidget) return;
        else gutterAnno = {
            text: [
                nls("error-marker.good-state", "Looks good!")
            ],
            className: "ace_ok"
        };
        editor.session.unfold(pos.row);
        editor.selection.moveToPosition(pos);
        var w = {
            row: pos.row,
            fixedWidth: true,
            coverGutter: true,
            el: dom.createElement("div"),
            type: "errorMarker"
        };
        var el = w.el.appendChild(dom.createElement("div"));
        var arrow = w.el.appendChild(dom.createElement("div"));
        arrow.className = "error_widget_arrow " + gutterAnno.className;
        var left = editor.renderer.$cursorLayer.getPixelPosition(pos).left;
        arrow.style.left = left + editor.renderer.gutterWidth - 5 + "px";
        w.el.className = "error_widget_wrapper";
        el.className = "error_widget " + gutterAnno.className;
        el.innerHTML = gutterAnno.text.join("<br>");
        el.appendChild(dom.createElement("div"));
        var kb = function(_, hashId, keyString) {
            if (hashId === 0 && (keyString === "esc" || keyString === "return")) {
                w.destroy();
                return {
                    command: "null"
                };
            }
        };
        w.destroy = function() {
            if (editor.$mouseHandler.isMousePressed) return;
            editor.keyBinding.removeKeyboardHandler(kb);
            session.widgetManager.removeLineWidget(w);
            editor.off("changeSelection", w.destroy);
            editor.off("changeSession", w.destroy);
            editor.off("mouseup", w.destroy);
            editor.off("change", w.destroy);
        };
        editor.keyBinding.addKeyboardHandler(kb);
        editor.on("changeSelection", w.destroy);
        editor.on("changeSession", w.destroy);
        editor.on("mouseup", w.destroy);
        editor.on("change", w.destroy);
        editor.session.widgetManager.addLineWidget(w);
        w.el.onmousedown = editor.focus.bind(editor);
        editor.renderer.scrollCursorIntoView(null, 0.5, {
            bottom: w.el.offsetHeight
        });
    };
    dom.importCssString("\n    .error_widget_wrapper {\n        background: inherit;\n        color: inherit;\n        border:none\n    }\n    .error_widget {\n        border-top: solid 2px;\n        border-bottom: solid 2px;\n        margin: 5px 0;\n        padding: 10px 40px;\n        white-space: pre-wrap;\n    }\n    .error_widget.ace_error, .error_widget_arrow.ace_error{\n        border-color: #ff5a5a\n    }\n    .error_widget.ace_warning, .error_widget_arrow.ace_warning{\n        border-color: #F1D817\n    }\n    .error_widget.ace_info, .error_widget_arrow.ace_info{\n        border-color: #5a5a5a\n    }\n    .error_widget.ace_ok, .error_widget_arrow.ace_ok{\n        border-color: #5aaa5a\n    }\n    .error_widget_arrow {\n        position: absolute;\n        border: solid 5px;\n        border-top-color: transparent!important;\n        border-right-color: transparent!important;\n        border-left-color: transparent!important;\n        top: -5px;\n    }\n", "error_marker.css", false);
});
ace.define("ace/ace", [
    "require",
    "exports",
    "module",
    "ace/lib/dom",
    "ace/range",
    "ace/editor",
    "ace/edit_session",
    "ace/undomanager",
    "ace/virtual_renderer",
    "ace/worker/worker_client",
    "ace/keyboard/hash_handler",
    "ace/placeholder",
    "ace/multi_select",
    "ace/mode/folding/fold_mode",
    "ace/theme/textmate",
    "ace/ext/error_marker",
    "ace/config",
    "ace/loader_build"
], function(require, exports, module1) {
    "use strict";
    require("./loader_build")(exports);
    var dom = require("./lib/dom");
    var Range = require("./range").Range;
    var Editor = require("./editor").Editor;
    var EditSession = require("./edit_session").EditSession;
    var UndoManager = require("./undomanager").UndoManager;
    var Renderer = require("./virtual_renderer").VirtualRenderer;
    require("./worker/worker_client");
    require("./keyboard/hash_handler");
    require("./placeholder");
    require("./multi_select");
    require("./mode/folding/fold_mode");
    require("./theme/textmate");
    require("./ext/error_marker");
    exports.config = require("./config");
    exports.edit = function(el, options) {
        if (typeof el == "string") {
            var _id = el;
            el = document.getElementById(_id);
            if (!el) throw new Error("ace.edit can't find div #" + _id);
        }
        if (el && el.env && el.env.editor instanceof Editor) return el.env.editor;
        var value = "";
        if (el && /input|textarea/i.test(el.tagName)) {
            var oldNode = el;
            value = oldNode.value;
            el = dom.createElement("pre");
            oldNode.parentNode.replaceChild(el, oldNode);
        } else if (el) {
            value = el.textContent;
            el.innerHTML = "";
        }
        var doc = exports.createEditSession(value);
        var editor = new Editor(new Renderer(el), doc, options);
        var env = {
            document: doc,
            editor: editor,
            onResize: editor.resize.bind(editor, null)
        };
        if (oldNode) env.textarea = oldNode;
        editor.on("destroy", function() {
            env.editor.container.env = null; // prevent memory leak on old ie
        });
        editor.container.env = editor.env = env;
        return editor;
    };
    exports.createEditSession = function(text, mode) {
        var doc = new EditSession(text, mode);
        doc.setUndoManager(new UndoManager());
        return doc;
    };
    exports.Range = Range;
    exports.Editor = Editor;
    exports.EditSession = EditSession;
    exports.UndoManager = UndoManager;
    exports.VirtualRenderer = Renderer;
    exports.version = exports.config.version;
});
(function() {
    ace.require([
        "ace/ace"
    ], function(a) {
        if (a) {
            a.config.init(true);
            a.define = ace.define;
        }
        var global = function() {
            return this;
        }();
        if (!global && typeof window != "undefined") global = window; // can happen in strict mode
        if (!global && typeof self != "undefined") global = self; // can happen in webworker
        if (!global.ace) global.ace = a;
        for(var key in a)if (a.hasOwnProperty(key)) global.ace[key] = a[key];
        global.ace["default"] = global.ace;
        if (module) module.exports = global.ace;
    });
})();

});

parcelRegister("8h8ZT", function(module, exports) {
ace.define("ace/ext/modelist", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var modes = [];
    function getModeForPath(path) {
        var mode = modesByName.text;
        var fileName = path.split(/[\/\\]/).pop();
        for(var i = 0; i < modes.length; i++)if (modes[i].supportsFile(fileName)) {
            mode = modes[i];
            break;
        }
        return mode;
    }
    var Mode = /** @class */ function() {
        function Mode(name, caption, extensions) {
            this.name = name;
            this.caption = caption;
            this.mode = "ace/mode/" + name;
            this.extensions = extensions;
            var re;
            if (/\^/.test(extensions)) re = extensions.replace(/\|(\^)?/g, function(a, b) {
                return "$|" + (b ? "^" : "^.*\\.");
            }) + "$";
            else re = "^.*\\.(" + extensions + ")$";
            this.extRe = new RegExp(re, "gi");
        }
        Mode.prototype.supportsFile = function(filename) {
            return filename.match(this.extRe);
        };
        return Mode;
    }();
    var supportedModes = {
        ABAP: [
            "abap"
        ],
        ABC: [
            "abc"
        ],
        ActionScript: [
            "as"
        ],
        ADA: [
            "ada|adb"
        ],
        Alda: [
            "alda"
        ],
        Apache_Conf: [
            "^htaccess|^htgroups|^htpasswd|^conf|htaccess|htgroups|htpasswd"
        ],
        Apex: [
            "apex|cls|trigger|tgr"
        ],
        AQL: [
            "aql"
        ],
        AsciiDoc: [
            "asciidoc|adoc"
        ],
        ASL: [
            "dsl|asl|asl.json"
        ],
        Assembly_ARM32: [
            "s"
        ],
        Assembly_x86: [
            "asm|a"
        ],
        Astro: [
            "astro"
        ],
        AutoHotKey: [
            "ahk"
        ],
        BatchFile: [
            "bat|cmd"
        ],
        BibTeX: [
            "bib"
        ],
        C_Cpp: [
            "cpp|c|cc|cxx|h|hh|hpp|ino"
        ],
        C9Search: [
            "c9search_results"
        ],
        Cirru: [
            "cirru|cr"
        ],
        Clojure: [
            "clj|cljs"
        ],
        Cobol: [
            "CBL|COB"
        ],
        coffee: [
            "coffee|cf|cson|^Cakefile"
        ],
        ColdFusion: [
            "cfm|cfc"
        ],
        Crystal: [
            "cr"
        ],
        CSharp: [
            "cs"
        ],
        Csound_Document: [
            "csd"
        ],
        Csound_Orchestra: [
            "orc"
        ],
        Csound_Score: [
            "sco"
        ],
        CSS: [
            "css"
        ],
        Curly: [
            "curly"
        ],
        Cuttlefish: [
            "conf"
        ],
        D: [
            "d|di"
        ],
        Dart: [
            "dart"
        ],
        Diff: [
            "diff|patch"
        ],
        Django: [
            "djt|html.djt|dj.html|djhtml"
        ],
        Dockerfile: [
            "^Dockerfile"
        ],
        Dot: [
            "dot"
        ],
        Drools: [
            "drl"
        ],
        Edifact: [
            "edi"
        ],
        Eiffel: [
            "e|ge"
        ],
        EJS: [
            "ejs"
        ],
        Elixir: [
            "ex|exs"
        ],
        Elm: [
            "elm"
        ],
        Erlang: [
            "erl|hrl"
        ],
        Flix: [
            "flix"
        ],
        Forth: [
            "frt|fs|ldr|fth|4th"
        ],
        Fortran: [
            "f|f90"
        ],
        FSharp: [
            "fsi|fs|ml|mli|fsx|fsscript"
        ],
        FSL: [
            "fsl"
        ],
        FTL: [
            "ftl"
        ],
        Gcode: [
            "gcode"
        ],
        Gherkin: [
            "feature"
        ],
        Gitignore: [
            "^.gitignore"
        ],
        Glsl: [
            "glsl|frag|vert"
        ],
        Gobstones: [
            "gbs"
        ],
        golang: [
            "go"
        ],
        GraphQLSchema: [
            "gql"
        ],
        Groovy: [
            "groovy"
        ],
        HAML: [
            "haml"
        ],
        Handlebars: [
            "hbs|handlebars|tpl|mustache"
        ],
        Haskell: [
            "hs"
        ],
        Haskell_Cabal: [
            "cabal"
        ],
        haXe: [
            "hx"
        ],
        Hjson: [
            "hjson"
        ],
        HTML: [
            "html|htm|xhtml|we|wpy"
        ],
        HTML_Elixir: [
            "eex|html.eex"
        ],
        HTML_Ruby: [
            "erb|rhtml|html.erb"
        ],
        INI: [
            "ini|conf|cfg|prefs"
        ],
        Io: [
            "io"
        ],
        Ion: [
            "ion"
        ],
        Jack: [
            "jack"
        ],
        Jade: [
            "jade|pug"
        ],
        Java: [
            "java"
        ],
        JavaScript: [
            "js|jsm|cjs|mjs"
        ],
        JEXL: [
            "jexl"
        ],
        JSON: [
            "json"
        ],
        JSON5: [
            "json5"
        ],
        JSONiq: [
            "jq"
        ],
        JSP: [
            "jsp"
        ],
        JSSM: [
            "jssm|jssm_state"
        ],
        JSX: [
            "jsx"
        ],
        Julia: [
            "jl"
        ],
        Kotlin: [
            "kt|kts"
        ],
        LaTeX: [
            "tex|latex|ltx|bib"
        ],
        Latte: [
            "latte"
        ],
        LESS: [
            "less"
        ],
        Liquid: [
            "liquid"
        ],
        Lisp: [
            "lisp"
        ],
        LiveScript: [
            "ls"
        ],
        Log: [
            "log"
        ],
        LogiQL: [
            "logic|lql"
        ],
        Logtalk: [
            "lgt"
        ],
        LSL: [
            "lsl"
        ],
        Lua: [
            "lua"
        ],
        LuaPage: [
            "lp"
        ],
        Lucene: [
            "lucene"
        ],
        Makefile: [
            "^Makefile|^GNUmakefile|^makefile|^OCamlMakefile|make"
        ],
        Markdown: [
            "md|markdown"
        ],
        Mask: [
            "mask"
        ],
        MATLAB: [
            "matlab"
        ],
        Maze: [
            "mz"
        ],
        MediaWiki: [
            "wiki|mediawiki"
        ],
        MEL: [
            "mel"
        ],
        MIPS: [
            "s|asm"
        ],
        MIXAL: [
            "mixal"
        ],
        MUSHCode: [
            "mc|mush"
        ],
        MySQL: [
            "mysql"
        ],
        Nasal: [
            "nas"
        ],
        Nginx: [
            "nginx|conf"
        ],
        Nim: [
            "nim"
        ],
        Nix: [
            "nix"
        ],
        NSIS: [
            "nsi|nsh"
        ],
        Nunjucks: [
            "nunjucks|nunjs|nj|njk"
        ],
        ObjectiveC: [
            "m|mm"
        ],
        OCaml: [
            "ml|mli"
        ],
        Odin: [
            "odin"
        ],
        PartiQL: [
            "partiql|pql"
        ],
        Pascal: [
            "pas|p"
        ],
        Perl: [
            "pl|pm"
        ],
        pgSQL: [
            "pgsql"
        ],
        PHP: [
            "php|inc|phtml|shtml|php3|php4|php5|phps|phpt|aw|ctp|module"
        ],
        PHP_Laravel_blade: [
            "blade.php"
        ],
        Pig: [
            "pig"
        ],
        PLSQL: [
            "plsql"
        ],
        Powershell: [
            "ps1"
        ],
        Praat: [
            "praat|praatscript|psc|proc"
        ],
        Prisma: [
            "prisma"
        ],
        Prolog: [
            "plg|prolog"
        ],
        Properties: [
            "properties"
        ],
        Protobuf: [
            "proto"
        ],
        PRQL: [
            "prql"
        ],
        Puppet: [
            "epp|pp"
        ],
        Python: [
            "py"
        ],
        QML: [
            "qml"
        ],
        R: [
            "r"
        ],
        Raku: [
            "raku|rakumod|rakutest|p6|pl6|pm6"
        ],
        Razor: [
            "cshtml|asp"
        ],
        RDoc: [
            "Rd"
        ],
        Red: [
            "red|reds"
        ],
        RHTML: [
            "Rhtml"
        ],
        Robot: [
            "robot|resource"
        ],
        RST: [
            "rst"
        ],
        Ruby: [
            "rb|ru|gemspec|rake|^Guardfile|^Rakefile|^Gemfile"
        ],
        Rust: [
            "rs"
        ],
        SaC: [
            "sac"
        ],
        SASS: [
            "sass"
        ],
        SCAD: [
            "scad"
        ],
        Scala: [
            "scala|sbt"
        ],
        Scheme: [
            "scm|sm|rkt|oak|scheme"
        ],
        Scrypt: [
            "scrypt"
        ],
        SCSS: [
            "scss"
        ],
        SH: [
            "sh|bash|^.bashrc"
        ],
        SJS: [
            "sjs"
        ],
        Slim: [
            "slim|skim"
        ],
        Smarty: [
            "smarty|tpl"
        ],
        Smithy: [
            "smithy"
        ],
        snippets: [
            "snippets"
        ],
        Soy_Template: [
            "soy"
        ],
        Space: [
            "space"
        ],
        SPARQL: [
            "rq"
        ],
        SQL: [
            "sql"
        ],
        SQLServer: [
            "sqlserver"
        ],
        Stylus: [
            "styl|stylus"
        ],
        SVG: [
            "svg"
        ],
        Swift: [
            "swift"
        ],
        Tcl: [
            "tcl"
        ],
        Terraform: [
            "tf",
            "tfvars",
            "terragrunt"
        ],
        Tex: [
            "tex"
        ],
        Text: [
            "txt"
        ],
        Textile: [
            "textile"
        ],
        Toml: [
            "toml"
        ],
        TSX: [
            "tsx"
        ],
        Turtle: [
            "ttl"
        ],
        Twig: [
            "twig|swig"
        ],
        Typescript: [
            "ts|mts|cts|typescript|str"
        ],
        Vala: [
            "vala"
        ],
        VBScript: [
            "vbs|vb"
        ],
        Velocity: [
            "vm"
        ],
        Verilog: [
            "v|vh|sv|svh"
        ],
        VHDL: [
            "vhd|vhdl"
        ],
        Visualforce: [
            "vfp|component|page"
        ],
        Vue: [
            "vue"
        ],
        Wollok: [
            "wlk|wpgm|wtest"
        ],
        XML: [
            "xml|rdf|rss|wsdl|xslt|atom|mathml|mml|xul|xbl|xaml"
        ],
        XQuery: [
            "xq"
        ],
        YAML: [
            "yaml|yml"
        ],
        Zeek: [
            "zeek|bro"
        ],
        Zig: [
            "zig"
        ]
    };
    var nameOverrides = {
        ObjectiveC: "Objective-C",
        CSharp: "C#",
        golang: "Go",
        C_Cpp: "C and C++",
        Csound_Document: "Csound Document",
        Csound_Orchestra: "Csound",
        Csound_Score: "Csound Score",
        coffee: "CoffeeScript",
        HTML_Ruby: "HTML (Ruby)",
        HTML_Elixir: "HTML (Elixir)",
        FTL: "FreeMarker",
        PHP_Laravel_blade: "PHP (Blade Template)",
        Perl6: "Perl 6",
        AutoHotKey: "AutoHotkey / AutoIt"
    };
    var modesByName = {};
    for(var name in supportedModes){
        var data = supportedModes[name];
        var displayName = (nameOverrides[name] || name).replace(/_/g, " ");
        var filename = name.toLowerCase();
        var mode = new Mode(filename, displayName, data[0]);
        modesByName[filename] = mode;
        modes.push(mode);
    }
    module1.exports = {
        getModeForPath: getModeForPath,
        modes: modes,
        modesByName: modesByName
    };
});
(function() {
    ace.require([
        "ace/ext/modelist"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("jVOIp", function(module, exports) {
ace.define("ace/mode/css_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var lang = require("../lib/lang");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var supportType = exports.supportType = "align-content|align-items|align-self|all|animation|animation-delay|animation-direction|animation-duration|animation-fill-mode|animation-iteration-count|animation-name|animation-play-state|animation-timing-function|backface-visibility|background|background-attachment|background-blend-mode|background-clip|background-color|background-image|background-origin|background-position|background-repeat|background-size|border|border-bottom|border-bottom-color|border-bottom-left-radius|border-bottom-right-radius|border-bottom-style|border-bottom-width|border-collapse|border-color|border-image|border-image-outset|border-image-repeat|border-image-slice|border-image-source|border-image-width|border-left|border-left-color|border-left-style|border-left-width|border-radius|border-right|border-right-color|border-right-style|border-right-width|border-spacing|border-style|border-top|border-top-color|border-top-left-radius|border-top-right-radius|border-top-style|border-top-width|border-width|bottom|box-shadow|box-sizing|caption-side|clear|clip|color|column-count|column-fill|column-gap|column-rule|column-rule-color|column-rule-style|column-rule-width|column-span|column-width|columns|content|counter-increment|counter-reset|cursor|direction|display|empty-cells|filter|flex|flex-basis|flex-direction|flex-flow|flex-grow|flex-shrink|flex-wrap|float|font|font-family|font-size|font-size-adjust|font-stretch|font-style|font-variant|font-weight|hanging-punctuation|height|justify-content|left|letter-spacing|line-height|list-style|list-style-image|list-style-position|list-style-type|margin|margin-bottom|margin-left|margin-right|margin-top|max-height|max-width|max-zoom|min-height|min-width|min-zoom|nav-down|nav-index|nav-left|nav-right|nav-up|opacity|order|outline|outline-color|outline-offset|outline-style|outline-width|overflow|overflow-x|overflow-y|padding|padding-bottom|padding-left|padding-right|padding-top|page-break-after|page-break-before|page-break-inside|perspective|perspective-origin|position|quotes|resize|right|tab-size|table-layout|text-align|text-align-last|text-decoration|text-decoration-color|text-decoration-line|text-decoration-style|text-indent|text-justify|text-overflow|text-shadow|text-transform|top|transform|transform-origin|transform-style|transition|transition-delay|transition-duration|transition-property|transition-timing-function|unicode-bidi|user-select|user-zoom|vertical-align|visibility|white-space|width|word-break|word-spacing|word-wrap|z-index";
    var supportFunction = exports.supportFunction = "rgb|rgba|url|attr|counter|counters";
    var supportConstant = exports.supportConstant = "absolute|after-edge|after|all-scroll|all|alphabetic|always|antialiased|armenian|auto|avoid-column|avoid-page|avoid|balance|baseline|before-edge|before|below|bidi-override|block-line-height|block|bold|bolder|border-box|both|bottom|box|break-all|break-word|capitalize|caps-height|caption|center|central|char|circle|cjk-ideographic|clone|close-quote|col-resize|collapse|column|consider-shifts|contain|content-box|cover|crosshair|cubic-bezier|dashed|decimal-leading-zero|decimal|default|disabled|disc|disregard-shifts|distribute-all-lines|distribute-letter|distribute-space|distribute|dotted|double|e-resize|ease-in|ease-in-out|ease-out|ease|ellipsis|end|exclude-ruby|flex-end|flex-start|fill|fixed|georgian|glyphs|grid-height|groove|hand|hanging|hebrew|help|hidden|hiragana-iroha|hiragana|horizontal|icon|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space|ideographic|inactive|include-ruby|inherit|initial|inline-block|inline-box|inline-line-height|inline-table|inline|inset|inside|inter-ideograph|inter-word|invert|italic|justify|katakana-iroha|katakana|keep-all|last|left|lighter|line-edge|line-through|line|linear|list-item|local|loose|lower-alpha|lower-greek|lower-latin|lower-roman|lowercase|lr-tb|ltr|mathematical|max-height|max-size|medium|menu|message-box|middle|move|n-resize|ne-resize|newspaper|no-change|no-close-quote|no-drop|no-open-quote|no-repeat|none|normal|not-allowed|nowrap|nw-resize|oblique|open-quote|outset|outside|overline|padding-box|page|pointer|pre-line|pre-wrap|pre|preserve-3d|progress|relative|repeat-x|repeat-y|repeat|replaced|reset-size|ridge|right|round|row-resize|rtl|s-resize|scroll|se-resize|separate|slice|small-caps|small-caption|solid|space|square|start|static|status-bar|step-end|step-start|steps|stretch|strict|sub|super|sw-resize|table-caption|table-cell|table-column-group|table-column|table-footer-group|table-header-group|table-row-group|table-row|table|tb-rl|text-after-edge|text-before-edge|text-bottom|text-size|text-top|text|thick|thin|transparent|underline|upper-alpha|upper-latin|upper-roman|uppercase|use-script|vertical-ideographic|vertical-text|visible|w-resize|wait|whitespace|z-index|zero|zoom";
    var supportConstantColor = exports.supportConstantColor = "aliceblue|antiquewhite|aqua|aquamarine|azure|beige|bisque|black|blanchedalmond|blue|blueviolet|brown|burlywood|cadetblue|chartreuse|chocolate|coral|cornflowerblue|cornsilk|crimson|cyan|darkblue|darkcyan|darkgoldenrod|darkgray|darkgreen|darkgrey|darkkhaki|darkmagenta|darkolivegreen|darkorange|darkorchid|darkred|darksalmon|darkseagreen|darkslateblue|darkslategray|darkslategrey|darkturquoise|darkviolet|deeppink|deepskyblue|dimgray|dimgrey|dodgerblue|firebrick|floralwhite|forestgreen|fuchsia|gainsboro|ghostwhite|gold|goldenrod|gray|green|greenyellow|grey|honeydew|hotpink|indianred|indigo|ivory|khaki|lavender|lavenderblush|lawngreen|lemonchiffon|lightblue|lightcoral|lightcyan|lightgoldenrodyellow|lightgray|lightgreen|lightgrey|lightpink|lightsalmon|lightseagreen|lightskyblue|lightslategray|lightslategrey|lightsteelblue|lightyellow|lime|limegreen|linen|magenta|maroon|mediumaquamarine|mediumblue|mediumorchid|mediumpurple|mediumseagreen|mediumslateblue|mediumspringgreen|mediumturquoise|mediumvioletred|midnightblue|mintcream|mistyrose|moccasin|navajowhite|navy|oldlace|olive|olivedrab|orange|orangered|orchid|palegoldenrod|palegreen|paleturquoise|palevioletred|papayawhip|peachpuff|peru|pink|plum|powderblue|purple|rebeccapurple|red|rosybrown|royalblue|saddlebrown|salmon|sandybrown|seagreen|seashell|sienna|silver|skyblue|slateblue|slategray|slategrey|snow|springgreen|steelblue|tan|teal|thistle|tomato|turquoise|violet|wheat|white|whitesmoke|yellow|yellowgreen";
    var supportConstantFonts = exports.supportConstantFonts = "arial|century|comic|courier|cursive|fantasy|garamond|georgia|helvetica|impact|lucida|symbol|system|tahoma|times|trebuchet|utopia|verdana|webdings|sans-serif|serif|monospace";
    var numRe = exports.numRe = "\\-?(?:(?:[0-9]+(?:\\.[0-9]+)?)|(?:\\.[0-9]+))";
    var pseudoElements = exports.pseudoElements = "(\\:+)\\b(after|before|first-letter|first-line|moz-selection|selection)\\b";
    var pseudoClasses = exports.pseudoClasses = "(:)\\b(active|checked|disabled|empty|enabled|first-child|first-of-type|focus|hover|indeterminate|invalid|last-child|last-of-type|link|not|nth-child|nth-last-child|nth-last-of-type|nth-of-type|only-child|only-of-type|required|root|target|valid|visited)\\b";
    var CssHighlightRules = function() {
        var keywordMapper = this.createKeywordMapper({
            "support.function": supportFunction,
            "support.constant": supportConstant,
            "support.type": supportType,
            "support.constant.color": supportConstantColor,
            "support.constant.fonts": supportConstantFonts
        }, "text", true);
        this.$rules = {
            "start": [
                {
                    include: [
                        "strings",
                        "url",
                        "comments"
                    ]
                },
                {
                    token: "paren.lparen",
                    regex: "\\{",
                    next: "ruleset"
                },
                {
                    token: "paren.rparen",
                    regex: "\\}"
                },
                {
                    token: "string",
                    regex: "@(?!viewport)",
                    next: "media"
                },
                {
                    token: "keyword",
                    regex: "#[a-z0-9-_]+"
                },
                {
                    token: "keyword",
                    regex: "%"
                },
                {
                    token: "variable",
                    regex: "\\.[a-z0-9-_]+"
                },
                {
                    token: "string",
                    regex: ":[a-z0-9-_]+"
                },
                {
                    token: "constant.numeric",
                    regex: numRe
                },
                {
                    token: "constant",
                    regex: "[a-z0-9-_]+"
                },
                {
                    caseInsensitive: true
                }
            ],
            "media": [
                {
                    include: [
                        "strings",
                        "url",
                        "comments"
                    ]
                },
                {
                    token: "paren.lparen",
                    regex: "\\{",
                    next: "start"
                },
                {
                    token: "paren.rparen",
                    regex: "\\}",
                    next: "start"
                },
                {
                    token: "string",
                    regex: ";",
                    next: "start"
                },
                {
                    token: "keyword",
                    regex: "(?:media|supports|document|charset|import|namespace|media|supports|document|page|font|keyframes|viewport|counter-style|font-feature-values|swash|ornaments|annotation|stylistic|styleset|character-variant)"
                }
            ],
            "comments": [
                {
                    token: "comment",
                    regex: "\\/\\*",
                    push: [
                        {
                            token: "comment",
                            regex: "\\*\\/",
                            next: "pop"
                        },
                        {
                            defaultToken: "comment"
                        }
                    ]
                }
            ],
            "ruleset": [
                {
                    regex: "-(webkit|ms|moz|o)-",
                    token: "text"
                },
                {
                    token: "punctuation.operator",
                    regex: "[:;]"
                },
                {
                    token: "paren.rparen",
                    regex: "\\}",
                    next: "start"
                },
                {
                    include: [
                        "strings",
                        "url",
                        "comments"
                    ]
                },
                {
                    token: [
                        "constant.numeric",
                        "keyword"
                    ],
                    regex: "(" + numRe + ")(ch|cm|deg|em|ex|fr|gd|grad|Hz|in|kHz|mm|ms|pc|pt|px|rad|rem|s|turn|vh|vmax|vmin|vm|vw|%)"
                },
                {
                    token: "constant.numeric",
                    regex: numRe
                },
                {
                    token: "constant.numeric",
                    regex: "#[a-f0-9]{6}"
                },
                {
                    token: "constant.numeric",
                    regex: "#[a-f0-9]{3}"
                },
                {
                    token: [
                        "punctuation",
                        "entity.other.attribute-name.pseudo-element.css"
                    ],
                    regex: pseudoElements
                },
                {
                    token: [
                        "punctuation",
                        "entity.other.attribute-name.pseudo-class.css"
                    ],
                    regex: pseudoClasses
                },
                {
                    include: "url"
                },
                {
                    token: keywordMapper,
                    regex: "\\-?[a-zA-Z_][a-zA-Z0-9_\\-]*"
                },
                {
                    token: "paren.lparen",
                    regex: "\\{"
                },
                {
                    caseInsensitive: true
                }
            ],
            url: [
                {
                    token: "support.function",
                    regex: "(?:url(:?-prefix)?|domain|regexp)\\(",
                    push: [
                        {
                            token: "support.function",
                            regex: "\\)",
                            next: "pop"
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                }
            ],
            strings: [
                {
                    token: "string.start",
                    regex: "'",
                    push: [
                        {
                            token: "string.end",
                            regex: "'|$",
                            next: "pop"
                        },
                        {
                            include: "escapes"
                        },
                        {
                            token: "constant.language.escape",
                            regex: /\\$/,
                            consumeLineEnd: true
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                },
                {
                    token: "string.start",
                    regex: '"',
                    push: [
                        {
                            token: "string.end",
                            regex: '"|$',
                            next: "pop"
                        },
                        {
                            include: "escapes"
                        },
                        {
                            token: "constant.language.escape",
                            regex: /\\$/,
                            consumeLineEnd: true
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                }
            ],
            escapes: [
                {
                    token: "constant.language.escape",
                    regex: /\\([a-fA-F\d]{1,6}|[^a-fA-F\d])/
                }
            ]
        };
        this.normalizeRules();
    };
    oop.inherits(CssHighlightRules, TextHighlightRules);
    exports.CssHighlightRules = CssHighlightRules;
});
ace.define("ace/mode/matching_brace_outdent", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var MatchingBraceOutdent = function() {};
    (function() {
        this.checkOutdent = function(line, input) {
            if (!/^\s+$/.test(line)) return false;
            return /^\s*\}/.test(input);
        };
        this.autoOutdent = function(doc, row) {
            var line = doc.getLine(row);
            var match = line.match(/^(\s*\})/);
            if (!match) return 0;
            var column = match[1].length;
            var openBracePos = doc.findMatchingBracket({
                row: row,
                column: column
            });
            if (!openBracePos || openBracePos.row == row) return 0;
            var indent = this.$getIndent(doc.getLine(openBracePos.row));
            doc.replace(new Range(row, 0, row, column - 1), indent);
        };
        this.$getIndent = function(line) {
            return line.match(/^\s*/)[0];
        };
    }).call(MatchingBraceOutdent.prototype);
    exports.MatchingBraceOutdent = MatchingBraceOutdent;
});
ace.define("ace/mode/css_completions", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var propertyMap = {
        "background": {
            "#$0": 1
        },
        "background-color": {
            "#$0": 1,
            "transparent": 1,
            "fixed": 1
        },
        "background-image": {
            "url('/$0')": 1
        },
        "background-repeat": {
            "repeat": 1,
            "repeat-x": 1,
            "repeat-y": 1,
            "no-repeat": 1,
            "inherit": 1
        },
        "background-position": {
            "bottom": 2,
            "center": 2,
            "left": 2,
            "right": 2,
            "top": 2,
            "inherit": 2
        },
        "background-attachment": {
            "scroll": 1,
            "fixed": 1
        },
        "background-size": {
            "cover": 1,
            "contain": 1
        },
        "background-clip": {
            "border-box": 1,
            "padding-box": 1,
            "content-box": 1
        },
        "background-origin": {
            "border-box": 1,
            "padding-box": 1,
            "content-box": 1
        },
        "border": {
            "solid $0": 1,
            "dashed $0": 1,
            "dotted $0": 1,
            "#$0": 1
        },
        "border-color": {
            "#$0": 1
        },
        "border-style": {
            "solid": 2,
            "dashed": 2,
            "dotted": 2,
            "double": 2,
            "groove": 2,
            "hidden": 2,
            "inherit": 2,
            "inset": 2,
            "none": 2,
            "outset": 2,
            "ridged": 2
        },
        "border-collapse": {
            "collapse": 1,
            "separate": 1
        },
        "bottom": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "clear": {
            "left": 1,
            "right": 1,
            "both": 1,
            "none": 1
        },
        "color": {
            "#$0": 1,
            "rgb(#$00,0,0)": 1
        },
        "cursor": {
            "default": 1,
            "pointer": 1,
            "move": 1,
            "text": 1,
            "wait": 1,
            "help": 1,
            "progress": 1,
            "n-resize": 1,
            "ne-resize": 1,
            "e-resize": 1,
            "se-resize": 1,
            "s-resize": 1,
            "sw-resize": 1,
            "w-resize": 1,
            "nw-resize": 1
        },
        "display": {
            "none": 1,
            "block": 1,
            "inline": 1,
            "inline-block": 1,
            "table-cell": 1
        },
        "empty-cells": {
            "show": 1,
            "hide": 1
        },
        "float": {
            "left": 1,
            "right": 1,
            "none": 1
        },
        "font-family": {
            "Arial": 2,
            "Comic Sans MS": 2,
            "Consolas": 2,
            "Courier New": 2,
            "Courier": 2,
            "Georgia": 2,
            "Monospace": 2,
            "Sans-Serif": 2,
            "Segoe UI": 2,
            "Tahoma": 2,
            "Times New Roman": 2,
            "Trebuchet MS": 2,
            "Verdana": 1
        },
        "font-size": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "font-weight": {
            "bold": 1,
            "normal": 1
        },
        "font-style": {
            "italic": 1,
            "normal": 1
        },
        "font-variant": {
            "normal": 1,
            "small-caps": 1
        },
        "height": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "left": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "letter-spacing": {
            "normal": 1
        },
        "line-height": {
            "normal": 1
        },
        "list-style-type": {
            "none": 1,
            "disc": 1,
            "circle": 1,
            "square": 1,
            "decimal": 1,
            "decimal-leading-zero": 1,
            "lower-roman": 1,
            "upper-roman": 1,
            "lower-greek": 1,
            "lower-latin": 1,
            "upper-latin": 1,
            "georgian": 1,
            "lower-alpha": 1,
            "upper-alpha": 1
        },
        "margin": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "margin-right": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "margin-left": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "margin-top": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "margin-bottom": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "max-height": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "max-width": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "min-height": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "min-width": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "overflow": {
            "hidden": 1,
            "visible": 1,
            "auto": 1,
            "scroll": 1
        },
        "overflow-x": {
            "hidden": 1,
            "visible": 1,
            "auto": 1,
            "scroll": 1
        },
        "overflow-y": {
            "hidden": 1,
            "visible": 1,
            "auto": 1,
            "scroll": 1
        },
        "padding": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "padding-top": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "padding-right": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "padding-bottom": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "padding-left": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "page-break-after": {
            "auto": 1,
            "always": 1,
            "avoid": 1,
            "left": 1,
            "right": 1
        },
        "page-break-before": {
            "auto": 1,
            "always": 1,
            "avoid": 1,
            "left": 1,
            "right": 1
        },
        "position": {
            "absolute": 1,
            "relative": 1,
            "fixed": 1,
            "static": 1
        },
        "right": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "table-layout": {
            "fixed": 1,
            "auto": 1
        },
        "text-decoration": {
            "none": 1,
            "underline": 1,
            "line-through": 1,
            "blink": 1
        },
        "text-align": {
            "left": 1,
            "right": 1,
            "center": 1,
            "justify": 1
        },
        "text-transform": {
            "capitalize": 1,
            "uppercase": 1,
            "lowercase": 1,
            "none": 1
        },
        "top": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "vertical-align": {
            "top": 1,
            "bottom": 1
        },
        "visibility": {
            "hidden": 1,
            "visible": 1
        },
        "white-space": {
            "nowrap": 1,
            "normal": 1,
            "pre": 1,
            "pre-line": 1,
            "pre-wrap": 1
        },
        "width": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "word-spacing": {
            "normal": 1
        },
        "filter": {
            "alpha(opacity=$0100)": 1
        },
        "text-shadow": {
            "$02px 2px 2px #777": 1
        },
        "text-overflow": {
            "ellipsis-word": 1,
            "clip": 1,
            "ellipsis": 1
        },
        "-moz-border-radius": 1,
        "-moz-border-radius-topright": 1,
        "-moz-border-radius-bottomright": 1,
        "-moz-border-radius-topleft": 1,
        "-moz-border-radius-bottomleft": 1,
        "-webkit-border-radius": 1,
        "-webkit-border-top-right-radius": 1,
        "-webkit-border-top-left-radius": 1,
        "-webkit-border-bottom-right-radius": 1,
        "-webkit-border-bottom-left-radius": 1,
        "-moz-box-shadow": 1,
        "-webkit-box-shadow": 1,
        "transform": {
            "rotate($00deg)": 1,
            "skew($00deg)": 1
        },
        "-moz-transform": {
            "rotate($00deg)": 1,
            "skew($00deg)": 1
        },
        "-webkit-transform": {
            "rotate($00deg)": 1,
            "skew($00deg)": 1
        }
    };
    var CssCompletions = function() {};
    (function() {
        this.completionsDefined = false;
        this.defineCompletions = function() {
            if (document) {
                var style = document.createElement("c").style;
                for(var i in style){
                    if (typeof style[i] !== "string") continue;
                    var name = i.replace(/[A-Z]/g, function(x) {
                        return "-" + x.toLowerCase();
                    });
                    if (!propertyMap.hasOwnProperty(name)) propertyMap[name] = 1;
                }
            }
            this.completionsDefined = true;
        };
        this.getCompletions = function(state, session, pos, prefix) {
            if (!this.completionsDefined) this.defineCompletions();
            if (state === "ruleset" || session.$mode.$id == "ace/mode/scss") {
                var line = session.getLine(pos.row).substr(0, pos.column);
                var inParens = /\([^)]*$/.test(line);
                if (inParens) line = line.substr(line.lastIndexOf("(") + 1);
                if (/:[^;]+$/.test(line)) {
                    /([\w\-]+):[^:]*$/.test(line);
                    return this.getPropertyValueCompletions(state, session, pos, prefix);
                } else return this.getPropertyCompletions(state, session, pos, prefix, inParens);
            }
            return [];
        };
        this.getPropertyCompletions = function(state, session, pos, prefix, skipSemicolon) {
            skipSemicolon = skipSemicolon || false;
            var properties = Object.keys(propertyMap);
            return properties.map(function(property) {
                return {
                    caption: property,
                    snippet: property + ": $0" + (skipSemicolon ? "" : ";"),
                    meta: "property",
                    score: 1000000
                };
            });
        };
        this.getPropertyValueCompletions = function(state, session, pos, prefix) {
            var line = session.getLine(pos.row).substr(0, pos.column);
            var property = (/([\w\-]+):[^:]*$/.exec(line) || {})[1];
            if (!property) return [];
            var values = [];
            if (property in propertyMap && typeof propertyMap[property] === "object") values = Object.keys(propertyMap[property]);
            return values.map(function(value) {
                return {
                    caption: value,
                    snippet: value,
                    meta: "property value",
                    score: 1000000
                };
            });
        };
    }).call(CssCompletions.prototype);
    exports.CssCompletions = CssCompletions;
});
ace.define("ace/mode/behaviour/css", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/behaviour",
    "ace/mode/behaviour/cstyle",
    "ace/token_iterator"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Behaviour = require("../behaviour").Behaviour;
    var CstyleBehaviour = require("./cstyle").CstyleBehaviour;
    var TokenIterator = require("../../token_iterator").TokenIterator;
    var CssBehaviour = function() {
        this.inherit(CstyleBehaviour);
        this.add("colon", "insertion", function(state, action, editor, session, text) {
            if (text === ":" && editor.selection.isEmpty()) {
                var cursor = editor.getCursorPosition();
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (token && token.value.match(/\s+/)) token = iterator.stepBackward();
                if (token && token.type === "support.type") {
                    var line = session.doc.getLine(cursor.row);
                    var rightChar = line.substring(cursor.column, cursor.column + 1);
                    if (rightChar === ":") return {
                        text: "",
                        selection: [
                            1,
                            1
                        ]
                    };
                    if (/^(\s+[^;]|\s*$)/.test(line.substring(cursor.column))) return {
                        text: ":;",
                        selection: [
                            1,
                            1
                        ]
                    };
                }
            }
        });
        this.add("colon", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && selected === ":") {
                var cursor = editor.getCursorPosition();
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (token && token.value.match(/\s+/)) token = iterator.stepBackward();
                if (token && token.type === "support.type") {
                    var line = session.doc.getLine(range.start.row);
                    var rightChar = line.substring(range.end.column, range.end.column + 1);
                    if (rightChar === ";") {
                        range.end.column++;
                        return range;
                    }
                }
            }
        });
        this.add("semicolon", "insertion", function(state, action, editor, session, text) {
            if (text === ";" && editor.selection.isEmpty()) {
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                if (rightChar === ";") return {
                    text: "",
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("!important", "insertion", function(state, action, editor, session, text) {
            if (text === "!" && editor.selection.isEmpty()) {
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                if (/^\s*(;|}|$)/.test(line.substring(cursor.column))) return {
                    text: "!important",
                    selection: [
                        10,
                        10
                    ]
                };
            }
        });
    };
    oop.inherits(CssBehaviour, CstyleBehaviour);
    exports.CssBehaviour = CssBehaviour;
});
ace.define("ace/mode/folding/cstyle", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
    };
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
        this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
        this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
        this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
        this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
        this._getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            if (this.singleLineBlockCommentRe.test(line)) {
                if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line)) return "";
            }
            var fw = this._getFoldWidgetBase(session, foldStyle, row);
            if (!fw && this.startRegionRe.test(line)) return "start"; // lineCommentRegionStart
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var line = session.getLine(row);
            if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
            var match = line.match(this.foldingStartMarker);
            if (match) {
                var i = match.index;
                if (match[1]) return this.openingBracketBlock(session, match[1], row, i);
                var range = session.getCommentFoldRange(row, i + match[0].length, 1);
                if (range && !range.isMultiLine()) {
                    if (forceMultiline) range = this.getSectionRange(session, row);
                    else if (foldStyle != "all") range = null;
                }
                return range;
            }
            if (foldStyle === "markbegin") return;
            var match = line.match(this.foldingStopMarker);
            if (match) {
                var i = match.index + match[0].length;
                if (match[1]) return this.closingBracketBlock(session, match[1], row, i);
                return session.getCommentFoldRange(row, i, -1);
            }
        };
        this.getSectionRange = function(session, row) {
            var line = session.getLine(row);
            var startIndent = line.search(/\S/);
            var startRow = row;
            var startColumn = line.length;
            row = row + 1;
            var endRow = row;
            var maxRow = session.getLength();
            while(++row < maxRow){
                line = session.getLine(row);
                var indent = line.search(/\S/);
                if (indent === -1) continue;
                if (startIndent > indent) break;
                var subRange = this.getFoldWidgetRange(session, "all", row);
                if (subRange) {
                    if (subRange.start.row <= startRow) break;
                    else if (subRange.isMultiLine()) row = subRange.end.row;
                    else if (startIndent == indent) break;
                }
                endRow = row;
            }
            return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
        };
        this.getCommentRegionBlock = function(session, line, row) {
            var startColumn = line.search(/\s*$/);
            var maxRow = session.getLength();
            var startRow = row;
            var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
            var depth = 1;
            while(++row < maxRow){
                line = session.getLine(row);
                var m = re.exec(line);
                if (!m) continue;
                if (m[1]) depth--;
                else depth++;
                if (!depth) break;
            }
            var endRow = row;
            if (endRow > startRow) return new Range(startRow, startColumn, endRow, line.length);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/css", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/css_highlight_rules",
    "ace/mode/matching_brace_outdent",
    "ace/worker/worker_client",
    "ace/mode/css_completions",
    "ace/mode/behaviour/css",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var CssHighlightRules = require("./css_highlight_rules").CssHighlightRules;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var CssCompletions = require("./css_completions").CssCompletions;
    var CssBehaviour = require("./behaviour/css").CssBehaviour;
    var CStyleFoldMode = require("./folding/cstyle").FoldMode;
    var Mode = function() {
        this.HighlightRules = CssHighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.$behaviour = new CssBehaviour();
        this.$completer = new CssCompletions();
        this.foldingRules = new CStyleFoldMode();
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.foldingRules = "cStyle";
        this.blockComment = {
            start: "/*",
            end: "*/"
        };
        this.getNextLineIndent = function(state, line, tab) {
            var indent = this.$getIndent(line);
            var tokens = this.getTokenizer().getLineTokens(line, state).tokens;
            if (tokens.length && tokens[tokens.length - 1].type == "comment") return indent;
            var match = line.match(/^.*\{\s*$/);
            if (match) indent += tab;
            return indent;
        };
        this.checkOutdent = function(state, line, input) {
            return this.$outdent.checkOutdent(line, input);
        };
        this.autoOutdent = function(state, doc, row) {
            this.$outdent.autoOutdent(doc, row);
        };
        this.getCompletions = function(state, session, pos, prefix) {
            return this.$completer.getCompletions(state, session, pos, prefix);
        };
        this.createWorker = function(session) {
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/css_worker", "Worker");
            worker.attachToDocument(session.getDocument());
            worker.on("annotate", function(e) {
                session.setAnnotations(e.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/css";
        this.snippetFileId = "ace/snippets/css";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/css"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("4mYj6", function(module, exports) {
ace.define("ace/mode/jsdoc_comment_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var JsDocCommentHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: [
                        "comment.doc.tag",
                        "comment.doc.text",
                        "lparen.doc"
                    ],
                    regex: "(@(?:param|member|typedef|property|namespace|var|const|callback))(\\s*)({)",
                    push: [
                        {
                            token: "lparen.doc",
                            regex: "{",
                            push: [
                                {
                                    include: "doc-syntax"
                                },
                                {
                                    token: "rparen.doc",
                                    regex: "}|(?=$)",
                                    next: "pop"
                                }
                            ]
                        },
                        {
                            token: [
                                "rparen.doc",
                                "text.doc",
                                "variable.parameter.doc",
                                "lparen.doc",
                                "variable.parameter.doc",
                                "rparen.doc"
                            ],
                            regex: /(})(\s*)(?:([\w=:\/\.]+)|(?:(\[)([\w=:\/\.\-\'\" ]+)(\])))/,
                            next: "pop"
                        },
                        {
                            token: "rparen.doc",
                            regex: "}|(?=$)",
                            next: "pop"
                        },
                        {
                            include: "doc-syntax"
                        },
                        {
                            defaultToken: "text.doc"
                        }
                    ]
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "lparen.doc"
                    ],
                    regex: "(@(?:returns?|yields|type|this|suppress|public|protected|private|package|modifies|implements|external|exception|throws|enum|define|extends))(\\s*)({)",
                    push: [
                        {
                            token: "lparen.doc",
                            regex: "{",
                            push: [
                                {
                                    include: "doc-syntax"
                                },
                                {
                                    token: "rparen.doc",
                                    regex: "}|(?=$)",
                                    next: "pop"
                                }
                            ]
                        },
                        {
                            token: "rparen.doc",
                            regex: "}|(?=$)",
                            next: "pop"
                        },
                        {
                            include: "doc-syntax"
                        },
                        {
                            defaultToken: "text.doc"
                        }
                    ]
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "variable.parameter.doc"
                    ],
                    regex: '(@(?:alias|memberof|instance|module|name|lends|namespace|external|this|template|requires|param|implements|function|extends|typedef|mixes|constructor|var|memberof\\!|event|listens|exports|class|constructs|interface|emits|fires|throws|const|callback|borrows|augments))(\\s+)(\\w[\\w#.:/~"\\-]*)?'
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "variable.parameter.doc"
                    ],
                    regex: "(@method)(\\s+)(\\w[\\w.\\(\\)]*)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@access\\s+(?:private|public|protected)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@kind\\s+(?:class|constant|event|external|file|function|member|mixin|module|namespace|typedef)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@\\w+(?=\\s|$)"
                },
                JsDocCommentHighlightRules.getTagRule(),
                {
                    defaultToken: "comment.doc.body",
                    caseInsensitive: true
                }
            ],
            "doc-syntax": [
                {
                    token: "operator.doc",
                    regex: /[|:]/
                },
                {
                    token: "paren.doc",
                    regex: /[\[\]]/
                }
            ]
        };
        this.normalizeRules();
    };
    oop.inherits(JsDocCommentHighlightRules, TextHighlightRules);
    JsDocCommentHighlightRules.getTagRule = function(start) {
        return {
            token: "comment.doc.tag.storage.type",
            regex: "\\b(?:TODO|FIXME|XXX|HACK)\\b"
        };
    };
    JsDocCommentHighlightRules.getStartRule = function(start) {
        return {
            token: "comment.doc",
            regex: /\/\*\*(?!\/)/,
            next: start
        };
    };
    JsDocCommentHighlightRules.getEndRule = function(start) {
        return {
            token: "comment.doc",
            regex: "\\*\\/",
            next: start
        };
    };
    exports.JsDocCommentHighlightRules = JsDocCommentHighlightRules;
});
ace.define("ace/mode/javascript_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/jsdoc_comment_highlight_rules",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var DocCommentHighlightRules = require("./jsdoc_comment_highlight_rules").JsDocCommentHighlightRules;
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var identifierRe = "[a-zA-Z\\$_\xa1-\uFFFF][a-zA-Z\\d\\$_\xa1-\uFFFF]*";
    var JavaScriptHighlightRules = function(options) {
        var keywords = {
            "variable.language": "Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|Symbol|Namespace|QName|XML|XMLList|ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|SyntaxError|TypeError|URIError|decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|isNaN|parseFloat|parseInt|JSON|Math|this|arguments|prototype|window|document",
            "keyword": "const|yield|import|get|set|async|await|break|case|catch|continue|default|delete|do|else|finally|for|if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|__parent__|__count__|escape|unescape|with|__proto__|class|enum|extends|super|export|implements|private|public|interface|package|protected|static|constructor",
            "storage.type": "const|let|var|function",
            "constant.language": "null|Infinity|NaN|undefined",
            "support.function": "alert",
            "constant.language.boolean": "true|false"
        };
        var keywordMapper = this.createKeywordMapper(keywords, "identifier");
        var kwBeforeRe = "case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void";
        var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|u{[0-9a-fA-F]{1,6}}|[0-2][0-7]{0,2}|3[0-7][0-7]?|[4-7][0-7]?|.)";
        var anonymousFunctionRe = "(function)(\\s*)(\\*?)";
        var functionCallStartRule = {
            token: [
                "identifier",
                "text",
                "paren.lparen"
            ],
            regex: "(\\b(?!" + Object.values(keywords).join("|") + "\\b)" + identifierRe + ")(\\s*)(\\()"
        };
        this.$rules = {
            "no_regex": [
                DocCommentHighlightRules.getStartRule("doc-start"),
                comments("no_regex"),
                functionCallStartRule,
                {
                    token: "string",
                    regex: "'(?=.)",
                    next: "qstring"
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    next: "qqstring"
                },
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
                },
                {
                    token: "constant.numeric",
                    regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
                },
                {
                    token: [
                        "entity.name.function",
                        "text",
                        "keyword.operator",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\s*)(=)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(function)(?:(?:(\\s*)(\\*)(\\s*))|(\\s+))(" + identifierRe + ")(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "entity.name.function",
                        "text",
                        "punctuation.operator",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\s*)(:)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "text",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(:)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: "keyword",
                    regex: "from(?=\\s*('|\"))"
                },
                {
                    token: "keyword",
                    regex: "(?:" + kwBeforeRe + ")\\b",
                    next: "start"
                },
                {
                    token: "support.constant",
                    regex: /that\b/
                },
                {
                    token: [
                        "storage.type",
                        "punctuation.operator",
                        "support.function.firebug"
                    ],
                    regex: /(console)(\.)(warn|info|log|error|debug|time|trace|timeEnd|assert)\b/
                },
                {
                    token: keywordMapper,
                    regex: identifierRe
                },
                {
                    token: "punctuation.operator",
                    regex: /[.](?![.])/,
                    next: "property"
                },
                {
                    token: "storage.type",
                    regex: /=>/,
                    next: "start"
                },
                {
                    token: "keyword.operator",
                    regex: /--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,
                    next: "start"
                },
                {
                    token: "punctuation.operator",
                    regex: /[?:,;.]/,
                    next: "start"
                },
                {
                    token: "paren.lparen",
                    regex: /[\[({]/,
                    next: "start"
                },
                {
                    token: "paren.rparen",
                    regex: /[\])}]/
                },
                {
                    token: "comment",
                    regex: /^#!.*$/
                }
            ],
            property: [
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "keyword.operator",
                    regex: /=/
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(function)(?:(?:(\\s*)(\\*)(\\s*))|(\\s+))(\\w+)(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: "punctuation.operator",
                    regex: /[.](?![.])/
                },
                {
                    token: "support.function",
                    regex: "prototype"
                },
                {
                    token: "support.function",
                    regex: /(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|lter|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward|rEach)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/
                },
                {
                    token: "support.function.dom",
                    regex: /(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/
                },
                {
                    token: "support.constant",
                    regex: /(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/
                },
                {
                    token: "identifier",
                    regex: identifierRe
                },
                {
                    regex: "",
                    token: "empty",
                    next: "no_regex"
                }
            ],
            "start": [
                DocCommentHighlightRules.getStartRule("doc-start"),
                comments("start"),
                {
                    token: "string.regexp",
                    regex: "\\/",
                    next: "regex"
                },
                {
                    token: "text",
                    regex: "\\s+|^$",
                    next: "start"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "regex": [
                {
                    token: "regexp.keyword.operator",
                    regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
                },
                {
                    token: "string.regexp",
                    regex: "/[sxngimy]*",
                    next: "no_regex"
                },
                {
                    token: "invalid",
                    regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
                },
                {
                    token: "constant.language.escape",
                    regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
                },
                {
                    token: "constant.language.delimiter",
                    regex: /\|/
                },
                {
                    token: "constant.language.escape",
                    regex: /\[\^?/,
                    next: "regex_character_class"
                },
                {
                    token: "empty",
                    regex: "$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string.regexp"
                }
            ],
            "regex_character_class": [
                {
                    token: "regexp.charclass.keyword.operator",
                    regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
                },
                {
                    token: "constant.language.escape",
                    regex: "]",
                    next: "regex"
                },
                {
                    token: "constant.language.escape",
                    regex: "-"
                },
                {
                    token: "empty",
                    regex: "$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string.regexp.charachterclass"
                }
            ],
            "default_parameter": [
                {
                    token: "string",
                    regex: "'(?=.)",
                    push: [
                        {
                            token: "string",
                            regex: "'|$",
                            next: "pop"
                        },
                        {
                            include: "qstring"
                        }
                    ]
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    push: [
                        {
                            token: "string",
                            regex: '"|$',
                            next: "pop"
                        },
                        {
                            include: "qqstring"
                        }
                    ]
                },
                {
                    token: "constant.language",
                    regex: "null|Infinity|NaN|undefined"
                },
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
                },
                {
                    token: "constant.numeric",
                    regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
                },
                {
                    token: "punctuation.operator",
                    regex: ",",
                    next: "function_arguments"
                },
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.operator",
                    regex: "$"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "function_arguments": [
                comments("function_arguments"),
                {
                    token: "variable.parameter",
                    regex: identifierRe
                },
                {
                    token: "punctuation.operator",
                    regex: ","
                },
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.operator",
                    regex: "$"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "qqstring": [
                {
                    token: "constant.language.escape",
                    regex: escapedRe
                },
                {
                    token: "string",
                    regex: "\\\\$",
                    consumeLineEnd: true
                },
                {
                    token: "string",
                    regex: '"|$',
                    next: "no_regex"
                },
                {
                    defaultToken: "string"
                }
            ],
            "qstring": [
                {
                    token: "constant.language.escape",
                    regex: escapedRe
                },
                {
                    token: "string",
                    regex: "\\\\$",
                    consumeLineEnd: true
                },
                {
                    token: "string",
                    regex: "'|$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string"
                }
            ]
        };
        if (!options || !options.noES6) {
            this.$rules.no_regex.unshift({
                regex: "[{}]",
                onMatch: function(val, state, stack) {
                    this.next = val == "{" ? this.nextState : "";
                    if (val == "{" && stack.length) stack.unshift("start", state);
                    else if (val == "}" && stack.length) {
                        stack.shift();
                        this.next = stack.shift();
                        if (this.next.indexOf("string") != -1 || this.next.indexOf("jsx") != -1) return "paren.quasi.end";
                    }
                    return val == "{" ? "paren.lparen" : "paren.rparen";
                },
                nextState: "start"
            }, {
                token: "string.quasi.start",
                regex: /`/,
                push: [
                    {
                        token: "constant.language.escape",
                        regex: escapedRe
                    },
                    {
                        token: "paren.quasi.start",
                        regex: /\${/,
                        push: "start"
                    },
                    {
                        token: "string.quasi.end",
                        regex: /`/,
                        next: "pop"
                    },
                    {
                        defaultToken: "string.quasi"
                    }
                ]
            }, {
                token: [
                    "variable.parameter",
                    "text"
                ],
                regex: "(" + identifierRe + ")(\\s*)(?=\\=>)"
            }, {
                token: "paren.lparen",
                regex: "(\\()(?=[^\\(]+\\s*=>)",
                next: "function_arguments"
            }, {
                token: "variable.language",
                regex: "(?:(?:(?:Weak)?(?:Set|Map))|Promise)\\b"
            });
            this.$rules["function_arguments"].unshift({
                token: "keyword.operator",
                regex: "=",
                next: "default_parameter"
            }, {
                token: "keyword.operator",
                regex: "\\.{3}"
            });
            this.$rules["property"].unshift({
                token: "support.function",
                regex: "(findIndex|repeat|startsWith|endsWith|includes|isSafeInteger|trunc|cbrt|log2|log10|sign|then|catch|finally|resolve|reject|race|any|all|allSettled|keys|entries|isInteger)\\b(?=\\()"
            }, {
                token: "constant.language",
                regex: "(?:MAX_SAFE_INTEGER|MIN_SAFE_INTEGER|EPSILON)\\b"
            });
            if (!options || options.jsx != false) JSX.call(this);
        }
        this.embedRules(DocCommentHighlightRules, "doc-", [
            DocCommentHighlightRules.getEndRule("no_regex")
        ]);
        this.normalizeRules();
    };
    oop.inherits(JavaScriptHighlightRules, TextHighlightRules);
    function JSX() {
        var tagRegex = identifierRe.replace("\\d", "\\d\\-");
        var jsxTag = {
            onMatch: function(val, state, stack) {
                var offset = val.charAt(1) == "/" ? 2 : 1;
                if (offset == 1) {
                    if (state != this.nextState) stack.unshift(this.next, this.nextState, 0);
                    else stack.unshift(this.next);
                    stack[2]++;
                } else if (offset == 2) {
                    if (state == this.nextState) {
                        stack[1]--;
                        if (!stack[1] || stack[1] < 0) {
                            stack.shift();
                            stack.shift();
                        }
                    }
                }
                return [
                    {
                        type: "meta.tag.punctuation." + (offset == 1 ? "" : "end-") + "tag-open.xml",
                        value: val.slice(0, offset)
                    },
                    {
                        type: "meta.tag.tag-name.xml",
                        value: val.substr(offset)
                    }
                ];
            },
            regex: "</?(?:" + tagRegex + "|(?=>))",
            next: "jsxAttributes",
            nextState: "jsx"
        };
        this.$rules.start.unshift(jsxTag);
        var jsxJsRule = {
            regex: "{",
            token: "paren.quasi.start",
            push: "start"
        };
        this.$rules.jsx = [
            jsxJsRule,
            jsxTag,
            {
                include: "reference"
            },
            {
                defaultToken: "string.xml"
            }
        ];
        this.$rules.jsxAttributes = [
            {
                token: "meta.tag.punctuation.tag-close.xml",
                regex: "/?>",
                onMatch: function(value, currentState, stack) {
                    if (currentState == stack[0]) stack.shift();
                    if (value.length == 2) {
                        if (stack[0] == this.nextState) stack[1]--;
                        if (!stack[1] || stack[1] < 0) stack.splice(0, 2);
                    }
                    this.next = stack[0] || "start";
                    return [
                        {
                            type: this.token,
                            value: value
                        }
                    ];
                },
                nextState: "jsx"
            },
            jsxJsRule,
            comments("jsxAttributes"),
            {
                token: "entity.other.attribute-name.xml",
                regex: tagRegex
            },
            {
                token: "keyword.operator.attribute-equals.xml",
                regex: "="
            },
            {
                token: "text.tag-whitespace.xml",
                regex: "\\s+"
            },
            {
                token: "string.attribute-value.xml",
                regex: "'",
                stateName: "jsx_attr_q",
                push: [
                    {
                        token: "string.attribute-value.xml",
                        regex: "'",
                        next: "pop"
                    },
                    {
                        include: "reference"
                    },
                    {
                        defaultToken: "string.attribute-value.xml"
                    }
                ]
            },
            {
                token: "string.attribute-value.xml",
                regex: '"',
                stateName: "jsx_attr_qq",
                push: [
                    {
                        token: "string.attribute-value.xml",
                        regex: '"',
                        next: "pop"
                    },
                    {
                        include: "reference"
                    },
                    {
                        defaultToken: "string.attribute-value.xml"
                    }
                ]
            },
            jsxTag
        ];
        this.$rules.reference = [
            {
                token: "constant.language.escape.reference.xml",
                regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
            }
        ];
    }
    function comments(next) {
        return [
            {
                token: "comment",
                regex: /\/\*/,
                next: [
                    DocCommentHighlightRules.getTagRule(),
                    {
                        token: "comment",
                        regex: "\\*\\/",
                        next: next || "pop"
                    },
                    {
                        defaultToken: "comment",
                        caseInsensitive: true
                    }
                ]
            },
            {
                token: "comment",
                regex: "\\/\\/",
                next: [
                    DocCommentHighlightRules.getTagRule(),
                    {
                        token: "comment",
                        regex: "$|^",
                        next: next || "pop"
                    },
                    {
                        defaultToken: "comment",
                        caseInsensitive: true
                    }
                ]
            }
        ];
    }
    exports.JavaScriptHighlightRules = JavaScriptHighlightRules;
});
ace.define("ace/mode/matching_brace_outdent", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var MatchingBraceOutdent = function() {};
    (function() {
        this.checkOutdent = function(line, input) {
            if (!/^\s+$/.test(line)) return false;
            return /^\s*\}/.test(input);
        };
        this.autoOutdent = function(doc, row) {
            var line = doc.getLine(row);
            var match = line.match(/^(\s*\})/);
            if (!match) return 0;
            var column = match[1].length;
            var openBracePos = doc.findMatchingBracket({
                row: row,
                column: column
            });
            if (!openBracePos || openBracePos.row == row) return 0;
            var indent = this.$getIndent(doc.getLine(openBracePos.row));
            doc.replace(new Range(row, 0, row, column - 1), indent);
        };
        this.$getIndent = function(line) {
            return line.match(/^\s*/)[0];
        };
    }).call(MatchingBraceOutdent.prototype);
    exports.MatchingBraceOutdent = MatchingBraceOutdent;
});
ace.define("ace/mode/behaviour/xml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/behaviour",
    "ace/token_iterator"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Behaviour = require("../behaviour").Behaviour;
    var TokenIterator = require("../../token_iterator").TokenIterator;
    function is(token, type) {
        return token && token.type.lastIndexOf(type + ".xml") > -1;
    }
    var XmlBehaviour = function() {
        this.add("string_dquotes", "insertion", function(state, action, editor, session, text) {
            if (text == '"' || text == "'") {
                var quote = text;
                var selected = session.doc.getTextRange(editor.getSelectionRange());
                if (selected !== "" && selected !== "'" && selected != '"' && editor.getWrapBehavioursEnabled()) return {
                    text: quote + selected + quote,
                    selection: false
                };
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (rightChar == quote && (is(token, "attribute-value") || is(token, "string"))) return {
                    text: "",
                    selection: [
                        1,
                        1
                    ]
                };
                if (!token) token = iterator.stepBackward();
                if (!token) return;
                while(is(token, "tag-whitespace") || is(token, "whitespace"))token = iterator.stepBackward();
                var rightSpace = !rightChar || rightChar.match(/\s/);
                if (is(token, "attribute-equals") && (rightSpace || rightChar == ">") || is(token, "decl-attribute-equals") && (rightSpace || rightChar == "?")) return {
                    text: quote + quote,
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("string_dquotes", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && (selected == '"' || selected == "'")) {
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
                if (rightChar == selected) {
                    range.end.column++;
                    return range;
                }
            }
        });
        this.add("autoclosing", "insertion", function(state, action, editor, session, text) {
            if (text == ">") {
                var position = editor.getSelectionRange().start;
                var iterator = new TokenIterator(session, position.row, position.column);
                var token = iterator.getCurrentToken() || iterator.stepBackward();
                if (!token || !(is(token, "tag-name") || is(token, "tag-whitespace") || is(token, "attribute-name") || is(token, "attribute-equals") || is(token, "attribute-value"))) return;
                if (is(token, "reference.attribute-value")) return;
                if (is(token, "attribute-value")) {
                    var tokenEndColumn = iterator.getCurrentTokenColumn() + token.value.length;
                    if (position.column < tokenEndColumn) return;
                    if (position.column == tokenEndColumn) {
                        var nextToken = iterator.stepForward();
                        if (nextToken && is(nextToken, "attribute-value")) return;
                        iterator.stepBackward();
                    }
                }
                if (/^\s*>/.test(session.getLine(position.row).slice(position.column))) return;
                while(!is(token, "tag-name")){
                    token = iterator.stepBackward();
                    if (token.value == "<") {
                        token = iterator.stepForward();
                        break;
                    }
                }
                var tokenRow = iterator.getCurrentTokenRow();
                var tokenColumn = iterator.getCurrentTokenColumn();
                if (is(iterator.stepBackward(), "end-tag-open")) return;
                var element = token.value;
                if (tokenRow == position.row) element = element.substring(0, position.column - tokenColumn);
                if (this.voidElements && this.voidElements.hasOwnProperty(element.toLowerCase())) return;
                return {
                    text: "></" + element + ">",
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("autoindent", "insertion", function(state, action, editor, session, text) {
            if (text == "\n") {
                var cursor = editor.getCursorPosition();
                var line = session.getLine(cursor.row);
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (is(token, "") && token.type.indexOf("tag-close") !== -1) {
                    if (token.value == "/>") return;
                    while(token && token.type.indexOf("tag-name") === -1)token = iterator.stepBackward();
                    if (!token) return;
                    var tag = token.value;
                    var row = iterator.getCurrentTokenRow();
                    token = iterator.stepBackward();
                    if (!token || token.type.indexOf("end-tag") !== -1) return;
                    if (this.voidElements && !this.voidElements[tag] || !this.voidElements) {
                        var nextToken = session.getTokenAt(cursor.row, cursor.column + 1);
                        var line = session.getLine(row);
                        var nextIndent = this.$getIndent(line);
                        var indent = nextIndent + session.getTabString();
                        if (nextToken && nextToken.value === "</") return {
                            text: "\n" + indent + "\n" + nextIndent,
                            selection: [
                                1,
                                indent.length,
                                1,
                                indent.length
                            ]
                        };
                        else return {
                            text: "\n" + indent
                        };
                    }
                }
            }
        });
    };
    oop.inherits(XmlBehaviour, Behaviour);
    exports.XmlBehaviour = XmlBehaviour;
});
ace.define("ace/mode/behaviour/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/token_iterator",
    "ace/mode/behaviour/cstyle",
    "ace/mode/behaviour/xml"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var TokenIterator = require("../../token_iterator").TokenIterator;
    var CstyleBehaviour = require("../behaviour/cstyle").CstyleBehaviour;
    var XmlBehaviour = require("../behaviour/xml").XmlBehaviour;
    var JavaScriptBehaviour = function() {
        var xmlBehaviours = new XmlBehaviour({
            closeCurlyBraces: true
        }).getBehaviours();
        this.addBehaviours(xmlBehaviours);
        this.inherit(CstyleBehaviour);
        this.add("autoclosing-fragment", "insertion", function(state, action, editor, session, text) {
            if (text == ">") {
                var position = editor.getSelectionRange().start;
                var iterator = new TokenIterator(session, position.row, position.column);
                var token = iterator.getCurrentToken() || iterator.stepBackward();
                if (!token) return;
                if (token.value == "<") return {
                    text: "></>",
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
    };
    oop.inherits(JavaScriptBehaviour, CstyleBehaviour);
    exports.JavaScriptBehaviour = JavaScriptBehaviour;
});
ace.define("ace/mode/folding/xml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(voidElements, optionalEndTags) {
        BaseFoldMode.call(this);
        this.voidElements = voidElements || {};
        this.optionalEndTags = oop.mixin({}, this.voidElements);
        if (optionalEndTags) oop.mixin(this.optionalEndTags, optionalEndTags);
    };
    oop.inherits(FoldMode, BaseFoldMode);
    var Tag = function() {
        this.tagName = "";
        this.closing = false;
        this.selfClosing = false;
        this.start = {
            row: 0,
            column: 0
        };
        this.end = {
            row: 0,
            column: 0
        };
    };
    function is(token, type) {
        return token.type.lastIndexOf(type + ".xml") > -1;
    }
    (function() {
        this.getFoldWidget = function(session, foldStyle, row) {
            var tag = this._getFirstTagInLine(session, row);
            if (!tag) return this.getCommentFoldWidget(session, row);
            if (tag.closing || !tag.tagName && tag.selfClosing) return foldStyle === "markbeginend" ? "end" : "";
            if (!tag.tagName || tag.selfClosing || this.voidElements.hasOwnProperty(tag.tagName.toLowerCase())) return "";
            if (this._findEndTagInLine(session, row, tag.tagName, tag.end.column)) return "";
            return "start";
        };
        this.getCommentFoldWidget = function(session, row) {
            if (/comment/.test(session.getState(row)) && /<!-/.test(session.getLine(row))) return "start";
            return "";
        };
        this._getFirstTagInLine = function(session, row) {
            var tokens = session.getTokens(row);
            var tag = new Tag();
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                if (is(token, "tag-open")) {
                    tag.end.column = tag.start.column + token.value.length;
                    tag.closing = is(token, "end-tag-open");
                    token = tokens[++i];
                    if (!token) return null;
                    tag.tagName = token.value;
                    if (token.value === "") {
                        token = tokens[++i];
                        if (!token) return null;
                        tag.tagName = token.value;
                    }
                    tag.end.column += token.value.length;
                    for(i++; i < tokens.length; i++){
                        token = tokens[i];
                        tag.end.column += token.value.length;
                        if (is(token, "tag-close")) {
                            tag.selfClosing = token.value == "/>";
                            break;
                        }
                    }
                    return tag;
                } else if (is(token, "tag-close")) {
                    tag.selfClosing = token.value == "/>";
                    return tag;
                }
                tag.start.column += token.value.length;
            }
            return null;
        };
        this._findEndTagInLine = function(session, row, tagName, startColumn) {
            var tokens = session.getTokens(row);
            var column = 0;
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                column += token.value.length;
                if (column < startColumn - 1) continue;
                if (is(token, "end-tag-open")) {
                    token = tokens[i + 1];
                    if (is(token, "tag-name") && token.value === "") token = tokens[i + 2];
                    if (token && token.value == tagName) return true;
                }
            }
            return false;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            var firstTag = this._getFirstTagInLine(session, row);
            if (!firstTag) return this.getCommentFoldWidget(session, row) && session.getCommentFoldRange(row, session.getLine(row).length);
            var tags = session.getMatchingTags({
                row: row,
                column: 0
            });
            if (tags) return new Range(tags.openTag.end.row, tags.openTag.end.column, tags.closeTag.start.row, tags.closeTag.start.column);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/folding/cstyle", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
    };
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
        this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
        this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
        this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
        this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
        this._getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            if (this.singleLineBlockCommentRe.test(line)) {
                if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line)) return "";
            }
            var fw = this._getFoldWidgetBase(session, foldStyle, row);
            if (!fw && this.startRegionRe.test(line)) return "start"; // lineCommentRegionStart
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var line = session.getLine(row);
            if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
            var match = line.match(this.foldingStartMarker);
            if (match) {
                var i = match.index;
                if (match[1]) return this.openingBracketBlock(session, match[1], row, i);
                var range = session.getCommentFoldRange(row, i + match[0].length, 1);
                if (range && !range.isMultiLine()) {
                    if (forceMultiline) range = this.getSectionRange(session, row);
                    else if (foldStyle != "all") range = null;
                }
                return range;
            }
            if (foldStyle === "markbegin") return;
            var match = line.match(this.foldingStopMarker);
            if (match) {
                var i = match.index + match[0].length;
                if (match[1]) return this.closingBracketBlock(session, match[1], row, i);
                return session.getCommentFoldRange(row, i, -1);
            }
        };
        this.getSectionRange = function(session, row) {
            var line = session.getLine(row);
            var startIndent = line.search(/\S/);
            var startRow = row;
            var startColumn = line.length;
            row = row + 1;
            var endRow = row;
            var maxRow = session.getLength();
            while(++row < maxRow){
                line = session.getLine(row);
                var indent = line.search(/\S/);
                if (indent === -1) continue;
                if (startIndent > indent) break;
                var subRange = this.getFoldWidgetRange(session, "all", row);
                if (subRange) {
                    if (subRange.start.row <= startRow) break;
                    else if (subRange.isMultiLine()) row = subRange.end.row;
                    else if (startIndent == indent) break;
                }
                endRow = row;
            }
            return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
        };
        this.getCommentRegionBlock = function(session, line, row) {
            var startColumn = line.search(/\s*$/);
            var maxRow = session.getLength();
            var startRow = row;
            var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
            var depth = 1;
            while(++row < maxRow){
                line = session.getLine(row);
                var m = re.exec(line);
                if (!m) continue;
                if (m[1]) depth--;
                else depth++;
                if (!depth) break;
            }
            var endRow = row;
            if (endRow > startRow) return new Range(startRow, startColumn, endRow, line.length);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/folding/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/folding/xml",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var XmlFoldMode = require("./xml").FoldMode;
    var CFoldMode = require("./cstyle").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
        this.xmlFoldMode = new XmlFoldMode();
    };
    oop.inherits(FoldMode, CFoldMode);
    (function() {
        this.getFoldWidgetRangeBase = this.getFoldWidgetRange;
        this.getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var fw = this.getFoldWidgetBase(session, foldStyle, row);
            if (!fw) return this.xmlFoldMode.getFoldWidget(session, foldStyle, row);
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var range = this.getFoldWidgetRangeBase(session, foldStyle, row, forceMultiline);
            if (range) return range;
            return this.xmlFoldMode.getFoldWidgetRange(session, foldStyle, row);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/javascript_highlight_rules",
    "ace/mode/matching_brace_outdent",
    "ace/worker/worker_client",
    "ace/mode/behaviour/javascript",
    "ace/mode/folding/javascript"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var JavaScriptHighlightRules = require("./javascript_highlight_rules").JavaScriptHighlightRules;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var JavaScriptBehaviour = require("./behaviour/javascript").JavaScriptBehaviour;
    var JavaScriptFoldMode = require("./folding/javascript").FoldMode;
    var Mode = function() {
        this.HighlightRules = JavaScriptHighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.$behaviour = new JavaScriptBehaviour();
        this.foldingRules = new JavaScriptFoldMode();
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.lineCommentStart = "//";
        this.blockComment = {
            start: "/*",
            end: "*/"
        };
        this.$quotes = {
            '"': '"',
            "'": "'",
            "`": "`"
        };
        this.$pairQuotesAfter = {
            "`": /\w/
        };
        this.getNextLineIndent = function(state, line, tab) {
            var indent = this.$getIndent(line);
            var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
            var tokens = tokenizedLine.tokens;
            var endState = tokenizedLine.state;
            if (tokens.length && tokens[tokens.length - 1].type == "comment") return indent;
            if (state == "start" || state == "no_regex") {
                var match = line.match(/^.*(?:\bcase\b.*:|[\{\(\[])\s*$/);
                if (match) indent += tab;
            } else if (state == "doc-start") {
                if (endState == "start" || endState == "no_regex") return "";
            }
            return indent;
        };
        this.checkOutdent = function(state, line, input) {
            return this.$outdent.checkOutdent(line, input);
        };
        this.autoOutdent = function(state, doc, row) {
            this.$outdent.autoOutdent(doc, row);
        };
        this.createWorker = function(session) {
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/javascript_worker", "JavaScriptWorker");
            worker.attachToDocument(session.getDocument());
            worker.on("annotate", function(results) {
                session.setAnnotations(results.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/javascript";
        this.snippetFileId = "ace/snippets/javascript";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
ace.define("ace/mode/css_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var lang = require("../lib/lang");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var supportType = exports.supportType = "align-content|align-items|align-self|all|animation|animation-delay|animation-direction|animation-duration|animation-fill-mode|animation-iteration-count|animation-name|animation-play-state|animation-timing-function|backface-visibility|background|background-attachment|background-blend-mode|background-clip|background-color|background-image|background-origin|background-position|background-repeat|background-size|border|border-bottom|border-bottom-color|border-bottom-left-radius|border-bottom-right-radius|border-bottom-style|border-bottom-width|border-collapse|border-color|border-image|border-image-outset|border-image-repeat|border-image-slice|border-image-source|border-image-width|border-left|border-left-color|border-left-style|border-left-width|border-radius|border-right|border-right-color|border-right-style|border-right-width|border-spacing|border-style|border-top|border-top-color|border-top-left-radius|border-top-right-radius|border-top-style|border-top-width|border-width|bottom|box-shadow|box-sizing|caption-side|clear|clip|color|column-count|column-fill|column-gap|column-rule|column-rule-color|column-rule-style|column-rule-width|column-span|column-width|columns|content|counter-increment|counter-reset|cursor|direction|display|empty-cells|filter|flex|flex-basis|flex-direction|flex-flow|flex-grow|flex-shrink|flex-wrap|float|font|font-family|font-size|font-size-adjust|font-stretch|font-style|font-variant|font-weight|hanging-punctuation|height|justify-content|left|letter-spacing|line-height|list-style|list-style-image|list-style-position|list-style-type|margin|margin-bottom|margin-left|margin-right|margin-top|max-height|max-width|max-zoom|min-height|min-width|min-zoom|nav-down|nav-index|nav-left|nav-right|nav-up|opacity|order|outline|outline-color|outline-offset|outline-style|outline-width|overflow|overflow-x|overflow-y|padding|padding-bottom|padding-left|padding-right|padding-top|page-break-after|page-break-before|page-break-inside|perspective|perspective-origin|position|quotes|resize|right|tab-size|table-layout|text-align|text-align-last|text-decoration|text-decoration-color|text-decoration-line|text-decoration-style|text-indent|text-justify|text-overflow|text-shadow|text-transform|top|transform|transform-origin|transform-style|transition|transition-delay|transition-duration|transition-property|transition-timing-function|unicode-bidi|user-select|user-zoom|vertical-align|visibility|white-space|width|word-break|word-spacing|word-wrap|z-index";
    var supportFunction = exports.supportFunction = "rgb|rgba|url|attr|counter|counters";
    var supportConstant = exports.supportConstant = "absolute|after-edge|after|all-scroll|all|alphabetic|always|antialiased|armenian|auto|avoid-column|avoid-page|avoid|balance|baseline|before-edge|before|below|bidi-override|block-line-height|block|bold|bolder|border-box|both|bottom|box|break-all|break-word|capitalize|caps-height|caption|center|central|char|circle|cjk-ideographic|clone|close-quote|col-resize|collapse|column|consider-shifts|contain|content-box|cover|crosshair|cubic-bezier|dashed|decimal-leading-zero|decimal|default|disabled|disc|disregard-shifts|distribute-all-lines|distribute-letter|distribute-space|distribute|dotted|double|e-resize|ease-in|ease-in-out|ease-out|ease|ellipsis|end|exclude-ruby|flex-end|flex-start|fill|fixed|georgian|glyphs|grid-height|groove|hand|hanging|hebrew|help|hidden|hiragana-iroha|hiragana|horizontal|icon|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space|ideographic|inactive|include-ruby|inherit|initial|inline-block|inline-box|inline-line-height|inline-table|inline|inset|inside|inter-ideograph|inter-word|invert|italic|justify|katakana-iroha|katakana|keep-all|last|left|lighter|line-edge|line-through|line|linear|list-item|local|loose|lower-alpha|lower-greek|lower-latin|lower-roman|lowercase|lr-tb|ltr|mathematical|max-height|max-size|medium|menu|message-box|middle|move|n-resize|ne-resize|newspaper|no-change|no-close-quote|no-drop|no-open-quote|no-repeat|none|normal|not-allowed|nowrap|nw-resize|oblique|open-quote|outset|outside|overline|padding-box|page|pointer|pre-line|pre-wrap|pre|preserve-3d|progress|relative|repeat-x|repeat-y|repeat|replaced|reset-size|ridge|right|round|row-resize|rtl|s-resize|scroll|se-resize|separate|slice|small-caps|small-caption|solid|space|square|start|static|status-bar|step-end|step-start|steps|stretch|strict|sub|super|sw-resize|table-caption|table-cell|table-column-group|table-column|table-footer-group|table-header-group|table-row-group|table-row|table|tb-rl|text-after-edge|text-before-edge|text-bottom|text-size|text-top|text|thick|thin|transparent|underline|upper-alpha|upper-latin|upper-roman|uppercase|use-script|vertical-ideographic|vertical-text|visible|w-resize|wait|whitespace|z-index|zero|zoom";
    var supportConstantColor = exports.supportConstantColor = "aliceblue|antiquewhite|aqua|aquamarine|azure|beige|bisque|black|blanchedalmond|blue|blueviolet|brown|burlywood|cadetblue|chartreuse|chocolate|coral|cornflowerblue|cornsilk|crimson|cyan|darkblue|darkcyan|darkgoldenrod|darkgray|darkgreen|darkgrey|darkkhaki|darkmagenta|darkolivegreen|darkorange|darkorchid|darkred|darksalmon|darkseagreen|darkslateblue|darkslategray|darkslategrey|darkturquoise|darkviolet|deeppink|deepskyblue|dimgray|dimgrey|dodgerblue|firebrick|floralwhite|forestgreen|fuchsia|gainsboro|ghostwhite|gold|goldenrod|gray|green|greenyellow|grey|honeydew|hotpink|indianred|indigo|ivory|khaki|lavender|lavenderblush|lawngreen|lemonchiffon|lightblue|lightcoral|lightcyan|lightgoldenrodyellow|lightgray|lightgreen|lightgrey|lightpink|lightsalmon|lightseagreen|lightskyblue|lightslategray|lightslategrey|lightsteelblue|lightyellow|lime|limegreen|linen|magenta|maroon|mediumaquamarine|mediumblue|mediumorchid|mediumpurple|mediumseagreen|mediumslateblue|mediumspringgreen|mediumturquoise|mediumvioletred|midnightblue|mintcream|mistyrose|moccasin|navajowhite|navy|oldlace|olive|olivedrab|orange|orangered|orchid|palegoldenrod|palegreen|paleturquoise|palevioletred|papayawhip|peachpuff|peru|pink|plum|powderblue|purple|rebeccapurple|red|rosybrown|royalblue|saddlebrown|salmon|sandybrown|seagreen|seashell|sienna|silver|skyblue|slateblue|slategray|slategrey|snow|springgreen|steelblue|tan|teal|thistle|tomato|turquoise|violet|wheat|white|whitesmoke|yellow|yellowgreen";
    var supportConstantFonts = exports.supportConstantFonts = "arial|century|comic|courier|cursive|fantasy|garamond|georgia|helvetica|impact|lucida|symbol|system|tahoma|times|trebuchet|utopia|verdana|webdings|sans-serif|serif|monospace";
    var numRe = exports.numRe = "\\-?(?:(?:[0-9]+(?:\\.[0-9]+)?)|(?:\\.[0-9]+))";
    var pseudoElements = exports.pseudoElements = "(\\:+)\\b(after|before|first-letter|first-line|moz-selection|selection)\\b";
    var pseudoClasses = exports.pseudoClasses = "(:)\\b(active|checked|disabled|empty|enabled|first-child|first-of-type|focus|hover|indeterminate|invalid|last-child|last-of-type|link|not|nth-child|nth-last-child|nth-last-of-type|nth-of-type|only-child|only-of-type|required|root|target|valid|visited)\\b";
    var CssHighlightRules = function() {
        var keywordMapper = this.createKeywordMapper({
            "support.function": supportFunction,
            "support.constant": supportConstant,
            "support.type": supportType,
            "support.constant.color": supportConstantColor,
            "support.constant.fonts": supportConstantFonts
        }, "text", true);
        this.$rules = {
            "start": [
                {
                    include: [
                        "strings",
                        "url",
                        "comments"
                    ]
                },
                {
                    token: "paren.lparen",
                    regex: "\\{",
                    next: "ruleset"
                },
                {
                    token: "paren.rparen",
                    regex: "\\}"
                },
                {
                    token: "string",
                    regex: "@(?!viewport)",
                    next: "media"
                },
                {
                    token: "keyword",
                    regex: "#[a-z0-9-_]+"
                },
                {
                    token: "keyword",
                    regex: "%"
                },
                {
                    token: "variable",
                    regex: "\\.[a-z0-9-_]+"
                },
                {
                    token: "string",
                    regex: ":[a-z0-9-_]+"
                },
                {
                    token: "constant.numeric",
                    regex: numRe
                },
                {
                    token: "constant",
                    regex: "[a-z0-9-_]+"
                },
                {
                    caseInsensitive: true
                }
            ],
            "media": [
                {
                    include: [
                        "strings",
                        "url",
                        "comments"
                    ]
                },
                {
                    token: "paren.lparen",
                    regex: "\\{",
                    next: "start"
                },
                {
                    token: "paren.rparen",
                    regex: "\\}",
                    next: "start"
                },
                {
                    token: "string",
                    regex: ";",
                    next: "start"
                },
                {
                    token: "keyword",
                    regex: "(?:media|supports|document|charset|import|namespace|media|supports|document|page|font|keyframes|viewport|counter-style|font-feature-values|swash|ornaments|annotation|stylistic|styleset|character-variant)"
                }
            ],
            "comments": [
                {
                    token: "comment",
                    regex: "\\/\\*",
                    push: [
                        {
                            token: "comment",
                            regex: "\\*\\/",
                            next: "pop"
                        },
                        {
                            defaultToken: "comment"
                        }
                    ]
                }
            ],
            "ruleset": [
                {
                    regex: "-(webkit|ms|moz|o)-",
                    token: "text"
                },
                {
                    token: "punctuation.operator",
                    regex: "[:;]"
                },
                {
                    token: "paren.rparen",
                    regex: "\\}",
                    next: "start"
                },
                {
                    include: [
                        "strings",
                        "url",
                        "comments"
                    ]
                },
                {
                    token: [
                        "constant.numeric",
                        "keyword"
                    ],
                    regex: "(" + numRe + ")(ch|cm|deg|em|ex|fr|gd|grad|Hz|in|kHz|mm|ms|pc|pt|px|rad|rem|s|turn|vh|vmax|vmin|vm|vw|%)"
                },
                {
                    token: "constant.numeric",
                    regex: numRe
                },
                {
                    token: "constant.numeric",
                    regex: "#[a-f0-9]{6}"
                },
                {
                    token: "constant.numeric",
                    regex: "#[a-f0-9]{3}"
                },
                {
                    token: [
                        "punctuation",
                        "entity.other.attribute-name.pseudo-element.css"
                    ],
                    regex: pseudoElements
                },
                {
                    token: [
                        "punctuation",
                        "entity.other.attribute-name.pseudo-class.css"
                    ],
                    regex: pseudoClasses
                },
                {
                    include: "url"
                },
                {
                    token: keywordMapper,
                    regex: "\\-?[a-zA-Z_][a-zA-Z0-9_\\-]*"
                },
                {
                    token: "paren.lparen",
                    regex: "\\{"
                },
                {
                    caseInsensitive: true
                }
            ],
            url: [
                {
                    token: "support.function",
                    regex: "(?:url(:?-prefix)?|domain|regexp)\\(",
                    push: [
                        {
                            token: "support.function",
                            regex: "\\)",
                            next: "pop"
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                }
            ],
            strings: [
                {
                    token: "string.start",
                    regex: "'",
                    push: [
                        {
                            token: "string.end",
                            regex: "'|$",
                            next: "pop"
                        },
                        {
                            include: "escapes"
                        },
                        {
                            token: "constant.language.escape",
                            regex: /\\$/,
                            consumeLineEnd: true
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                },
                {
                    token: "string.start",
                    regex: '"',
                    push: [
                        {
                            token: "string.end",
                            regex: '"|$',
                            next: "pop"
                        },
                        {
                            include: "escapes"
                        },
                        {
                            token: "constant.language.escape",
                            regex: /\\$/,
                            consumeLineEnd: true
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                }
            ],
            escapes: [
                {
                    token: "constant.language.escape",
                    regex: /\\([a-fA-F\d]{1,6}|[^a-fA-F\d])/
                }
            ]
        };
        this.normalizeRules();
    };
    oop.inherits(CssHighlightRules, TextHighlightRules);
    exports.CssHighlightRules = CssHighlightRules;
});
ace.define("ace/mode/css_completions", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var propertyMap = {
        "background": {
            "#$0": 1
        },
        "background-color": {
            "#$0": 1,
            "transparent": 1,
            "fixed": 1
        },
        "background-image": {
            "url('/$0')": 1
        },
        "background-repeat": {
            "repeat": 1,
            "repeat-x": 1,
            "repeat-y": 1,
            "no-repeat": 1,
            "inherit": 1
        },
        "background-position": {
            "bottom": 2,
            "center": 2,
            "left": 2,
            "right": 2,
            "top": 2,
            "inherit": 2
        },
        "background-attachment": {
            "scroll": 1,
            "fixed": 1
        },
        "background-size": {
            "cover": 1,
            "contain": 1
        },
        "background-clip": {
            "border-box": 1,
            "padding-box": 1,
            "content-box": 1
        },
        "background-origin": {
            "border-box": 1,
            "padding-box": 1,
            "content-box": 1
        },
        "border": {
            "solid $0": 1,
            "dashed $0": 1,
            "dotted $0": 1,
            "#$0": 1
        },
        "border-color": {
            "#$0": 1
        },
        "border-style": {
            "solid": 2,
            "dashed": 2,
            "dotted": 2,
            "double": 2,
            "groove": 2,
            "hidden": 2,
            "inherit": 2,
            "inset": 2,
            "none": 2,
            "outset": 2,
            "ridged": 2
        },
        "border-collapse": {
            "collapse": 1,
            "separate": 1
        },
        "bottom": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "clear": {
            "left": 1,
            "right": 1,
            "both": 1,
            "none": 1
        },
        "color": {
            "#$0": 1,
            "rgb(#$00,0,0)": 1
        },
        "cursor": {
            "default": 1,
            "pointer": 1,
            "move": 1,
            "text": 1,
            "wait": 1,
            "help": 1,
            "progress": 1,
            "n-resize": 1,
            "ne-resize": 1,
            "e-resize": 1,
            "se-resize": 1,
            "s-resize": 1,
            "sw-resize": 1,
            "w-resize": 1,
            "nw-resize": 1
        },
        "display": {
            "none": 1,
            "block": 1,
            "inline": 1,
            "inline-block": 1,
            "table-cell": 1
        },
        "empty-cells": {
            "show": 1,
            "hide": 1
        },
        "float": {
            "left": 1,
            "right": 1,
            "none": 1
        },
        "font-family": {
            "Arial": 2,
            "Comic Sans MS": 2,
            "Consolas": 2,
            "Courier New": 2,
            "Courier": 2,
            "Georgia": 2,
            "Monospace": 2,
            "Sans-Serif": 2,
            "Segoe UI": 2,
            "Tahoma": 2,
            "Times New Roman": 2,
            "Trebuchet MS": 2,
            "Verdana": 1
        },
        "font-size": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "font-weight": {
            "bold": 1,
            "normal": 1
        },
        "font-style": {
            "italic": 1,
            "normal": 1
        },
        "font-variant": {
            "normal": 1,
            "small-caps": 1
        },
        "height": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "left": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "letter-spacing": {
            "normal": 1
        },
        "line-height": {
            "normal": 1
        },
        "list-style-type": {
            "none": 1,
            "disc": 1,
            "circle": 1,
            "square": 1,
            "decimal": 1,
            "decimal-leading-zero": 1,
            "lower-roman": 1,
            "upper-roman": 1,
            "lower-greek": 1,
            "lower-latin": 1,
            "upper-latin": 1,
            "georgian": 1,
            "lower-alpha": 1,
            "upper-alpha": 1
        },
        "margin": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "margin-right": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "margin-left": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "margin-top": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "margin-bottom": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "max-height": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "max-width": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "min-height": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "min-width": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "overflow": {
            "hidden": 1,
            "visible": 1,
            "auto": 1,
            "scroll": 1
        },
        "overflow-x": {
            "hidden": 1,
            "visible": 1,
            "auto": 1,
            "scroll": 1
        },
        "overflow-y": {
            "hidden": 1,
            "visible": 1,
            "auto": 1,
            "scroll": 1
        },
        "padding": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "padding-top": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "padding-right": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "padding-bottom": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "padding-left": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "page-break-after": {
            "auto": 1,
            "always": 1,
            "avoid": 1,
            "left": 1,
            "right": 1
        },
        "page-break-before": {
            "auto": 1,
            "always": 1,
            "avoid": 1,
            "left": 1,
            "right": 1
        },
        "position": {
            "absolute": 1,
            "relative": 1,
            "fixed": 1,
            "static": 1
        },
        "right": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "table-layout": {
            "fixed": 1,
            "auto": 1
        },
        "text-decoration": {
            "none": 1,
            "underline": 1,
            "line-through": 1,
            "blink": 1
        },
        "text-align": {
            "left": 1,
            "right": 1,
            "center": 1,
            "justify": 1
        },
        "text-transform": {
            "capitalize": 1,
            "uppercase": 1,
            "lowercase": 1,
            "none": 1
        },
        "top": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "vertical-align": {
            "top": 1,
            "bottom": 1
        },
        "visibility": {
            "hidden": 1,
            "visible": 1
        },
        "white-space": {
            "nowrap": 1,
            "normal": 1,
            "pre": 1,
            "pre-line": 1,
            "pre-wrap": 1
        },
        "width": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "word-spacing": {
            "normal": 1
        },
        "filter": {
            "alpha(opacity=$0100)": 1
        },
        "text-shadow": {
            "$02px 2px 2px #777": 1
        },
        "text-overflow": {
            "ellipsis-word": 1,
            "clip": 1,
            "ellipsis": 1
        },
        "-moz-border-radius": 1,
        "-moz-border-radius-topright": 1,
        "-moz-border-radius-bottomright": 1,
        "-moz-border-radius-topleft": 1,
        "-moz-border-radius-bottomleft": 1,
        "-webkit-border-radius": 1,
        "-webkit-border-top-right-radius": 1,
        "-webkit-border-top-left-radius": 1,
        "-webkit-border-bottom-right-radius": 1,
        "-webkit-border-bottom-left-radius": 1,
        "-moz-box-shadow": 1,
        "-webkit-box-shadow": 1,
        "transform": {
            "rotate($00deg)": 1,
            "skew($00deg)": 1
        },
        "-moz-transform": {
            "rotate($00deg)": 1,
            "skew($00deg)": 1
        },
        "-webkit-transform": {
            "rotate($00deg)": 1,
            "skew($00deg)": 1
        }
    };
    var CssCompletions = function() {};
    (function() {
        this.completionsDefined = false;
        this.defineCompletions = function() {
            if (document) {
                var style = document.createElement("c").style;
                for(var i in style){
                    if (typeof style[i] !== "string") continue;
                    var name = i.replace(/[A-Z]/g, function(x) {
                        return "-" + x.toLowerCase();
                    });
                    if (!propertyMap.hasOwnProperty(name)) propertyMap[name] = 1;
                }
            }
            this.completionsDefined = true;
        };
        this.getCompletions = function(state, session, pos, prefix) {
            if (!this.completionsDefined) this.defineCompletions();
            if (state === "ruleset" || session.$mode.$id == "ace/mode/scss") {
                var line = session.getLine(pos.row).substr(0, pos.column);
                var inParens = /\([^)]*$/.test(line);
                if (inParens) line = line.substr(line.lastIndexOf("(") + 1);
                if (/:[^;]+$/.test(line)) {
                    /([\w\-]+):[^:]*$/.test(line);
                    return this.getPropertyValueCompletions(state, session, pos, prefix);
                } else return this.getPropertyCompletions(state, session, pos, prefix, inParens);
            }
            return [];
        };
        this.getPropertyCompletions = function(state, session, pos, prefix, skipSemicolon) {
            skipSemicolon = skipSemicolon || false;
            var properties = Object.keys(propertyMap);
            return properties.map(function(property) {
                return {
                    caption: property,
                    snippet: property + ": $0" + (skipSemicolon ? "" : ";"),
                    meta: "property",
                    score: 1000000
                };
            });
        };
        this.getPropertyValueCompletions = function(state, session, pos, prefix) {
            var line = session.getLine(pos.row).substr(0, pos.column);
            var property = (/([\w\-]+):[^:]*$/.exec(line) || {})[1];
            if (!property) return [];
            var values = [];
            if (property in propertyMap && typeof propertyMap[property] === "object") values = Object.keys(propertyMap[property]);
            return values.map(function(value) {
                return {
                    caption: value,
                    snippet: value,
                    meta: "property value",
                    score: 1000000
                };
            });
        };
    }).call(CssCompletions.prototype);
    exports.CssCompletions = CssCompletions;
});
ace.define("ace/mode/behaviour/css", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/behaviour",
    "ace/mode/behaviour/cstyle",
    "ace/token_iterator"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Behaviour = require("../behaviour").Behaviour;
    var CstyleBehaviour = require("./cstyle").CstyleBehaviour;
    var TokenIterator = require("../../token_iterator").TokenIterator;
    var CssBehaviour = function() {
        this.inherit(CstyleBehaviour);
        this.add("colon", "insertion", function(state, action, editor, session, text) {
            if (text === ":" && editor.selection.isEmpty()) {
                var cursor = editor.getCursorPosition();
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (token && token.value.match(/\s+/)) token = iterator.stepBackward();
                if (token && token.type === "support.type") {
                    var line = session.doc.getLine(cursor.row);
                    var rightChar = line.substring(cursor.column, cursor.column + 1);
                    if (rightChar === ":") return {
                        text: "",
                        selection: [
                            1,
                            1
                        ]
                    };
                    if (/^(\s+[^;]|\s*$)/.test(line.substring(cursor.column))) return {
                        text: ":;",
                        selection: [
                            1,
                            1
                        ]
                    };
                }
            }
        });
        this.add("colon", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && selected === ":") {
                var cursor = editor.getCursorPosition();
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (token && token.value.match(/\s+/)) token = iterator.stepBackward();
                if (token && token.type === "support.type") {
                    var line = session.doc.getLine(range.start.row);
                    var rightChar = line.substring(range.end.column, range.end.column + 1);
                    if (rightChar === ";") {
                        range.end.column++;
                        return range;
                    }
                }
            }
        });
        this.add("semicolon", "insertion", function(state, action, editor, session, text) {
            if (text === ";" && editor.selection.isEmpty()) {
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                if (rightChar === ";") return {
                    text: "",
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("!important", "insertion", function(state, action, editor, session, text) {
            if (text === "!" && editor.selection.isEmpty()) {
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                if (/^\s*(;|}|$)/.test(line.substring(cursor.column))) return {
                    text: "!important",
                    selection: [
                        10,
                        10
                    ]
                };
            }
        });
    };
    oop.inherits(CssBehaviour, CstyleBehaviour);
    exports.CssBehaviour = CssBehaviour;
});
ace.define("ace/mode/css", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/css_highlight_rules",
    "ace/mode/matching_brace_outdent",
    "ace/worker/worker_client",
    "ace/mode/css_completions",
    "ace/mode/behaviour/css",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var CssHighlightRules = require("./css_highlight_rules").CssHighlightRules;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var CssCompletions = require("./css_completions").CssCompletions;
    var CssBehaviour = require("./behaviour/css").CssBehaviour;
    var CStyleFoldMode = require("./folding/cstyle").FoldMode;
    var Mode = function() {
        this.HighlightRules = CssHighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.$behaviour = new CssBehaviour();
        this.$completer = new CssCompletions();
        this.foldingRules = new CStyleFoldMode();
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.foldingRules = "cStyle";
        this.blockComment = {
            start: "/*",
            end: "*/"
        };
        this.getNextLineIndent = function(state, line, tab) {
            var indent = this.$getIndent(line);
            var tokens = this.getTokenizer().getLineTokens(line, state).tokens;
            if (tokens.length && tokens[tokens.length - 1].type == "comment") return indent;
            var match = line.match(/^.*\{\s*$/);
            if (match) indent += tab;
            return indent;
        };
        this.checkOutdent = function(state, line, input) {
            return this.$outdent.checkOutdent(line, input);
        };
        this.autoOutdent = function(state, doc, row) {
            this.$outdent.autoOutdent(doc, row);
        };
        this.getCompletions = function(state, session, pos, prefix) {
            return this.$completer.getCompletions(state, session, pos, prefix);
        };
        this.createWorker = function(session) {
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/css_worker", "Worker");
            worker.attachToDocument(session.getDocument());
            worker.on("annotate", function(e) {
                session.setAnnotations(e.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/css";
        this.snippetFileId = "ace/snippets/css";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
ace.define("ace/mode/xml_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var XmlHighlightRules = function(normalize) {
        var tagRegex = "[_:a-zA-Z\xc0-\uFFFF][-_:.a-zA-Z0-9\xc0-\uFFFF]*";
        this.$rules = {
            start: [
                {
                    token: "string.cdata.xml",
                    regex: "<\\!\\[CDATA\\[",
                    next: "cdata"
                },
                {
                    token: [
                        "punctuation.instruction.xml",
                        "keyword.instruction.xml"
                    ],
                    regex: "(<\\?)(" + tagRegex + ")",
                    next: "processing_instruction"
                },
                {
                    token: "comment.start.xml",
                    regex: "<\\!--",
                    next: "comment"
                },
                {
                    token: [
                        "xml-pe.doctype.xml",
                        "xml-pe.doctype.xml"
                    ],
                    regex: "(<\\!)(DOCTYPE)(?=[\\s])",
                    next: "doctype",
                    caseInsensitive: true
                },
                {
                    include: "tag"
                },
                {
                    token: "text.end-tag-open.xml",
                    regex: "</"
                },
                {
                    token: "text.tag-open.xml",
                    regex: "<"
                },
                {
                    include: "reference"
                },
                {
                    defaultToken: "text.xml"
                }
            ],
            processing_instruction: [
                {
                    token: "entity.other.attribute-name.decl-attribute-name.xml",
                    regex: tagRegex
                },
                {
                    token: "keyword.operator.decl-attribute-equals.xml",
                    regex: "="
                },
                {
                    include: "whitespace"
                },
                {
                    include: "string"
                },
                {
                    token: "punctuation.xml-decl.xml",
                    regex: "\\?>",
                    next: "start"
                }
            ],
            doctype: [
                {
                    include: "whitespace"
                },
                {
                    include: "string"
                },
                {
                    token: "xml-pe.doctype.xml",
                    regex: ">",
                    next: "start"
                },
                {
                    token: "xml-pe.xml",
                    regex: "[-_a-zA-Z0-9:]+"
                },
                {
                    token: "punctuation.int-subset",
                    regex: "\\[",
                    push: "int_subset"
                }
            ],
            int_subset: [
                {
                    token: "text.xml",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.int-subset.xml",
                    regex: "]",
                    next: "pop"
                },
                {
                    token: [
                        "punctuation.markup-decl.xml",
                        "keyword.markup-decl.xml"
                    ],
                    regex: "(<\\!)(" + tagRegex + ")",
                    push: [
                        {
                            token: "text",
                            regex: "\\s+"
                        },
                        {
                            token: "punctuation.markup-decl.xml",
                            regex: ">",
                            next: "pop"
                        },
                        {
                            include: "string"
                        }
                    ]
                }
            ],
            cdata: [
                {
                    token: "string.cdata.xml",
                    regex: "\\]\\]>",
                    next: "start"
                },
                {
                    token: "text.xml",
                    regex: "\\s+"
                },
                {
                    token: "text.xml",
                    regex: "(?:[^\\]]|\\](?!\\]>))+"
                }
            ],
            comment: [
                {
                    token: "comment.end.xml",
                    regex: "-->",
                    next: "start"
                },
                {
                    defaultToken: "comment.xml"
                }
            ],
            reference: [
                {
                    token: "constant.language.escape.reference.xml",
                    regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
                }
            ],
            attr_reference: [
                {
                    token: "constant.language.escape.reference.attribute-value.xml",
                    regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
                }
            ],
            tag: [
                {
                    token: [
                        "meta.tag.punctuation.tag-open.xml",
                        "meta.tag.punctuation.end-tag-open.xml",
                        "meta.tag.tag-name.xml"
                    ],
                    regex: "(?:(<)|(</))((?:" + tagRegex + ":)?" + tagRegex + ")",
                    next: [
                        {
                            include: "attributes"
                        },
                        {
                            token: "meta.tag.punctuation.tag-close.xml",
                            regex: "/?>",
                            next: "start"
                        }
                    ]
                }
            ],
            tag_whitespace: [
                {
                    token: "text.tag-whitespace.xml",
                    regex: "\\s+"
                }
            ],
            whitespace: [
                {
                    token: "text.whitespace.xml",
                    regex: "\\s+"
                }
            ],
            string: [
                {
                    token: "string.xml",
                    regex: "'",
                    push: [
                        {
                            token: "string.xml",
                            regex: "'",
                            next: "pop"
                        },
                        {
                            defaultToken: "string.xml"
                        }
                    ]
                },
                {
                    token: "string.xml",
                    regex: '"',
                    push: [
                        {
                            token: "string.xml",
                            regex: '"',
                            next: "pop"
                        },
                        {
                            defaultToken: "string.xml"
                        }
                    ]
                }
            ],
            attributes: [
                {
                    token: "entity.other.attribute-name.xml",
                    regex: tagRegex
                },
                {
                    token: "keyword.operator.attribute-equals.xml",
                    regex: "="
                },
                {
                    include: "tag_whitespace"
                },
                {
                    include: "attribute_value"
                }
            ],
            attribute_value: [
                {
                    token: "string.attribute-value.xml",
                    regex: "'",
                    push: [
                        {
                            token: "string.attribute-value.xml",
                            regex: "'",
                            next: "pop"
                        },
                        {
                            include: "attr_reference"
                        },
                        {
                            defaultToken: "string.attribute-value.xml"
                        }
                    ]
                },
                {
                    token: "string.attribute-value.xml",
                    regex: '"',
                    push: [
                        {
                            token: "string.attribute-value.xml",
                            regex: '"',
                            next: "pop"
                        },
                        {
                            include: "attr_reference"
                        },
                        {
                            defaultToken: "string.attribute-value.xml"
                        }
                    ]
                }
            ]
        };
        if (this.constructor === XmlHighlightRules) this.normalizeRules();
    };
    (function() {
        this.embedTagRules = function(HighlightRules, prefix, tag) {
            this.$rules.tag.unshift({
                token: [
                    "meta.tag.punctuation.tag-open.xml",
                    "meta.tag." + tag + ".tag-name.xml"
                ],
                regex: "(<)(" + tag + "(?=\\s|>|$))",
                next: [
                    {
                        include: "attributes"
                    },
                    {
                        token: "meta.tag.punctuation.tag-close.xml",
                        regex: "/?>",
                        next: prefix + "start"
                    }
                ]
            });
            this.$rules[tag + "-end"] = [
                {
                    include: "attributes"
                },
                {
                    token: "meta.tag.punctuation.tag-close.xml",
                    regex: "/?>",
                    next: "start",
                    onMatch: function(value, currentState, stack) {
                        stack.splice(0);
                        return this.token;
                    }
                }
            ];
            this.embedRules(HighlightRules, prefix, [
                {
                    token: [
                        "meta.tag.punctuation.end-tag-open.xml",
                        "meta.tag." + tag + ".tag-name.xml"
                    ],
                    regex: "(</)(" + tag + "(?=\\s|>|$))",
                    next: tag + "-end"
                },
                {
                    token: "string.cdata.xml",
                    regex: "<\\!\\[CDATA\\["
                },
                {
                    token: "string.cdata.xml",
                    regex: "\\]\\]>"
                }
            ]);
        };
    }).call(TextHighlightRules.prototype);
    oop.inherits(XmlHighlightRules, TextHighlightRules);
    exports.XmlHighlightRules = XmlHighlightRules;
});
ace.define("ace/mode/html_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/mode/css_highlight_rules",
    "ace/mode/javascript_highlight_rules",
    "ace/mode/xml_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var lang = require("../lib/lang");
    var CssHighlightRules = require("./css_highlight_rules").CssHighlightRules;
    var JavaScriptHighlightRules = require("./javascript_highlight_rules").JavaScriptHighlightRules;
    var XmlHighlightRules = require("./xml_highlight_rules").XmlHighlightRules;
    var tagMap = lang.createMap({
        a: "anchor",
        button: "form",
        form: "form",
        img: "image",
        input: "form",
        label: "form",
        option: "form",
        script: "script",
        select: "form",
        textarea: "form",
        style: "style",
        table: "table",
        tbody: "table",
        td: "table",
        tfoot: "table",
        th: "table",
        tr: "table"
    });
    var HtmlHighlightRules = function() {
        XmlHighlightRules.call(this);
        this.addRules({
            attributes: [
                {
                    include: "tag_whitespace"
                },
                {
                    token: "entity.other.attribute-name.xml",
                    regex: "[-_a-zA-Z0-9:.]+"
                },
                {
                    token: "keyword.operator.attribute-equals.xml",
                    regex: "=",
                    push: [
                        {
                            include: "tag_whitespace"
                        },
                        {
                            token: "string.unquoted.attribute-value.html",
                            regex: "[^<>='\"`\\s]+",
                            next: "pop"
                        },
                        {
                            token: "empty",
                            regex: "",
                            next: "pop"
                        }
                    ]
                },
                {
                    include: "attribute_value"
                }
            ],
            tag: [
                {
                    token: function(start, tag) {
                        var group = tagMap[tag];
                        return [
                            "meta.tag.punctuation." + (start == "<" ? "" : "end-") + "tag-open.xml",
                            "meta.tag" + (group ? "." + group : "") + ".tag-name.xml"
                        ];
                    },
                    regex: "(</?)([-_a-zA-Z0-9:.]+)",
                    next: "tag_stuff"
                }
            ],
            tag_stuff: [
                {
                    include: "attributes"
                },
                {
                    token: "meta.tag.punctuation.tag-close.xml",
                    regex: "/?>",
                    next: "start"
                }
            ]
        });
        this.embedTagRules(CssHighlightRules, "css-", "style");
        this.embedTagRules(new JavaScriptHighlightRules({
            jsx: false
        }).getRules(), "js-", "script");
        if (this.constructor === HtmlHighlightRules) this.normalizeRules();
    };
    oop.inherits(HtmlHighlightRules, XmlHighlightRules);
    exports.HtmlHighlightRules = HtmlHighlightRules;
});
ace.define("ace/mode/folding/mixed", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(defaultMode, subModes) {
        this.defaultMode = defaultMode;
        this.subModes = subModes;
    };
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.$getMode = function(state) {
            if (typeof state != "string") state = state[0];
            for(var key in this.subModes){
                if (state.indexOf(key) === 0) return this.subModes[key];
            }
            return null;
        };
        this.$tryMode = function(state, session, foldStyle, row) {
            var mode = this.$getMode(state);
            return mode ? mode.getFoldWidget(session, foldStyle, row) : "";
        };
        this.getFoldWidget = function(session, foldStyle, row) {
            return this.$tryMode(session.getState(row - 1), session, foldStyle, row) || this.$tryMode(session.getState(row), session, foldStyle, row) || this.defaultMode.getFoldWidget(session, foldStyle, row);
        };
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            var mode = this.$getMode(session.getState(row - 1));
            if (!mode || !mode.getFoldWidget(session, foldStyle, row)) mode = this.$getMode(session.getState(row));
            if (!mode || !mode.getFoldWidget(session, foldStyle, row)) mode = this.defaultMode;
            return mode.getFoldWidgetRange(session, foldStyle, row);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/folding/html", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/folding/mixed",
    "ace/mode/folding/xml",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var MixedFoldMode = require("./mixed").FoldMode;
    var XmlFoldMode = require("./xml").FoldMode;
    var CStyleFoldMode = require("./cstyle").FoldMode;
    var FoldMode = exports.FoldMode = function(voidElements, optionalTags) {
        MixedFoldMode.call(this, new XmlFoldMode(voidElements, optionalTags), {
            "js-": new CStyleFoldMode(),
            "css-": new CStyleFoldMode()
        });
    };
    oop.inherits(FoldMode, MixedFoldMode);
});
ace.define("ace/mode/html_completions", [
    "require",
    "exports",
    "module",
    "ace/token_iterator"
], function(require, exports, module1) {
    "use strict";
    var TokenIterator = require("../token_iterator").TokenIterator;
    var commonAttributes = [
        "accesskey",
        "class",
        "contenteditable",
        "contextmenu",
        "dir",
        "draggable",
        "dropzone",
        "hidden",
        "id",
        "inert",
        "itemid",
        "itemprop",
        "itemref",
        "itemscope",
        "itemtype",
        "lang",
        "spellcheck",
        "style",
        "tabindex",
        "title",
        "translate"
    ];
    var eventAttributes = [
        "onabort",
        "onblur",
        "oncancel",
        "oncanplay",
        "oncanplaythrough",
        "onchange",
        "onclick",
        "onclose",
        "oncontextmenu",
        "oncuechange",
        "ondblclick",
        "ondrag",
        "ondragend",
        "ondragenter",
        "ondragleave",
        "ondragover",
        "ondragstart",
        "ondrop",
        "ondurationchange",
        "onemptied",
        "onended",
        "onerror",
        "onfocus",
        "oninput",
        "oninvalid",
        "onkeydown",
        "onkeypress",
        "onkeyup",
        "onload",
        "onloadeddata",
        "onloadedmetadata",
        "onloadstart",
        "onmousedown",
        "onmousemove",
        "onmouseout",
        "onmouseover",
        "onmouseup",
        "onmousewheel",
        "onpause",
        "onplay",
        "onplaying",
        "onprogress",
        "onratechange",
        "onreset",
        "onscroll",
        "onseeked",
        "onseeking",
        "onselect",
        "onshow",
        "onstalled",
        "onsubmit",
        "onsuspend",
        "ontimeupdate",
        "onvolumechange",
        "onwaiting"
    ];
    var globalAttributes = commonAttributes.concat(eventAttributes);
    var attributeMap = {
        "a": {
            "href": 1,
            "target": {
                "_blank": 1,
                "top": 1
            },
            "ping": 1,
            "rel": {
                "nofollow": 1,
                "alternate": 1,
                "author": 1,
                "bookmark": 1,
                "help": 1,
                "license": 1,
                "next": 1,
                "noreferrer": 1,
                "prefetch": 1,
                "prev": 1,
                "search": 1,
                "tag": 1
            },
            "media": 1,
            "hreflang": 1,
            "type": 1
        },
        "abbr": {},
        "address": {},
        "area": {
            "shape": 1,
            "coords": 1,
            "href": 1,
            "hreflang": 1,
            "alt": 1,
            "target": 1,
            "media": 1,
            "rel": 1,
            "ping": 1,
            "type": 1
        },
        "article": {
            "pubdate": 1
        },
        "aside": {},
        "audio": {
            "src": 1,
            "autobuffer": 1,
            "autoplay": {
                "autoplay": 1
            },
            "loop": {
                "loop": 1
            },
            "controls": {
                "controls": 1
            },
            "muted": {
                "muted": 1
            },
            "preload": {
                "auto": 1,
                "metadata": 1,
                "none": 1
            }
        },
        "b": {},
        "base": {
            "href": 1,
            "target": 1
        },
        "bdi": {},
        "bdo": {},
        "blockquote": {
            "cite": 1
        },
        "body": {
            "onafterprint": 1,
            "onbeforeprint": 1,
            "onbeforeunload": 1,
            "onhashchange": 1,
            "onmessage": 1,
            "onoffline": 1,
            "onpopstate": 1,
            "onredo": 1,
            "onresize": 1,
            "onstorage": 1,
            "onundo": 1,
            "onunload": 1
        },
        "br": {},
        "button": {
            "autofocus": 1,
            "disabled": {
                "disabled": 1
            },
            "form": 1,
            "formaction": 1,
            "formenctype": 1,
            "formmethod": 1,
            "formnovalidate": 1,
            "formtarget": 1,
            "name": 1,
            "value": 1,
            "type": {
                "button": 1,
                "submit": 1
            }
        },
        "canvas": {
            "width": 1,
            "height": 1
        },
        "caption": {},
        "cite": {},
        "code": {},
        "col": {
            "span": 1
        },
        "colgroup": {
            "span": 1
        },
        "command": {
            "type": 1,
            "label": 1,
            "icon": 1,
            "disabled": 1,
            "checked": 1,
            "radiogroup": 1,
            "command": 1
        },
        "data": {},
        "datalist": {},
        "dd": {},
        "del": {
            "cite": 1,
            "datetime": 1
        },
        "details": {
            "open": 1
        },
        "dfn": {},
        "dialog": {
            "open": 1
        },
        "div": {},
        "dl": {},
        "dt": {},
        "em": {},
        "embed": {
            "src": 1,
            "height": 1,
            "width": 1,
            "type": 1
        },
        "fieldset": {
            "disabled": 1,
            "form": 1,
            "name": 1
        },
        "figcaption": {},
        "figure": {},
        "footer": {},
        "form": {
            "accept-charset": 1,
            "action": 1,
            "autocomplete": 1,
            "enctype": {
                "multipart/form-data": 1,
                "application/x-www-form-urlencoded": 1
            },
            "method": {
                "get": 1,
                "post": 1
            },
            "name": 1,
            "novalidate": 1,
            "target": {
                "_blank": 1,
                "top": 1
            }
        },
        "h1": {},
        "h2": {},
        "h3": {},
        "h4": {},
        "h5": {},
        "h6": {},
        "head": {},
        "header": {},
        "hr": {},
        "html": {
            "manifest": 1
        },
        "i": {},
        "iframe": {
            "name": 1,
            "src": 1,
            "height": 1,
            "width": 1,
            "sandbox": {
                "allow-same-origin": 1,
                "allow-top-navigation": 1,
                "allow-forms": 1,
                "allow-scripts": 1
            },
            "seamless": {
                "seamless": 1
            }
        },
        "img": {
            "alt": 1,
            "src": 1,
            "height": 1,
            "width": 1,
            "usemap": 1,
            "ismap": 1
        },
        "input": {
            "type": {
                "text": 1,
                "password": 1,
                "hidden": 1,
                "checkbox": 1,
                "submit": 1,
                "radio": 1,
                "file": 1,
                "button": 1,
                "reset": 1,
                "image": 31,
                "color": 1,
                "date": 1,
                "datetime": 1,
                "datetime-local": 1,
                "email": 1,
                "month": 1,
                "number": 1,
                "range": 1,
                "search": 1,
                "tel": 1,
                "time": 1,
                "url": 1,
                "week": 1
            },
            "accept": 1,
            "alt": 1,
            "autocomplete": {
                "on": 1,
                "off": 1
            },
            "autofocus": {
                "autofocus": 1
            },
            "checked": {
                "checked": 1
            },
            "disabled": {
                "disabled": 1
            },
            "form": 1,
            "formaction": 1,
            "formenctype": {
                "application/x-www-form-urlencoded": 1,
                "multipart/form-data": 1,
                "text/plain": 1
            },
            "formmethod": {
                "get": 1,
                "post": 1
            },
            "formnovalidate": {
                "formnovalidate": 1
            },
            "formtarget": {
                "_blank": 1,
                "_self": 1,
                "_parent": 1,
                "_top": 1
            },
            "height": 1,
            "list": 1,
            "max": 1,
            "maxlength": 1,
            "min": 1,
            "multiple": {
                "multiple": 1
            },
            "name": 1,
            "pattern": 1,
            "placeholder": 1,
            "readonly": {
                "readonly": 1
            },
            "required": {
                "required": 1
            },
            "size": 1,
            "src": 1,
            "step": 1,
            "width": 1,
            "files": 1,
            "value": 1
        },
        "ins": {
            "cite": 1,
            "datetime": 1
        },
        "kbd": {},
        "keygen": {
            "autofocus": 1,
            "challenge": {
                "challenge": 1
            },
            "disabled": {
                "disabled": 1
            },
            "form": 1,
            "keytype": {
                "rsa": 1,
                "dsa": 1,
                "ec": 1
            },
            "name": 1
        },
        "label": {
            "form": 1,
            "for": 1
        },
        "legend": {},
        "li": {
            "value": 1
        },
        "link": {
            "href": 1,
            "hreflang": 1,
            "rel": {
                "stylesheet": 1,
                "icon": 1
            },
            "media": {
                "all": 1,
                "screen": 1,
                "print": 1
            },
            "type": {
                "text/css": 1,
                "image/png": 1,
                "image/jpeg": 1,
                "image/gif": 1
            },
            "sizes": 1
        },
        "main": {},
        "map": {
            "name": 1
        },
        "mark": {},
        "math": {},
        "menu": {
            "type": 1,
            "label": 1
        },
        "meta": {
            "http-equiv": {
                "content-type": 1
            },
            "name": {
                "description": 1,
                "keywords": 1
            },
            "content": {
                "text/html; charset=UTF-8": 1
            },
            "charset": 1
        },
        "meter": {
            "value": 1,
            "min": 1,
            "max": 1,
            "low": 1,
            "high": 1,
            "optimum": 1
        },
        "nav": {},
        "noscript": {
            "href": 1
        },
        "object": {
            "param": 1,
            "data": 1,
            "type": 1,
            "height": 1,
            "width": 1,
            "usemap": 1,
            "name": 1,
            "form": 1,
            "classid": 1
        },
        "ol": {
            "start": 1,
            "reversed": 1
        },
        "optgroup": {
            "disabled": 1,
            "label": 1
        },
        "option": {
            "disabled": 1,
            "selected": 1,
            "label": 1,
            "value": 1
        },
        "output": {
            "for": 1,
            "form": 1,
            "name": 1
        },
        "p": {},
        "param": {
            "name": 1,
            "value": 1
        },
        "pre": {},
        "progress": {
            "value": 1,
            "max": 1
        },
        "q": {
            "cite": 1
        },
        "rp": {},
        "rt": {},
        "ruby": {},
        "s": {},
        "samp": {},
        "script": {
            "charset": 1,
            "type": {
                "text/javascript": 1
            },
            "src": 1,
            "defer": 1,
            "async": 1
        },
        "select": {
            "autofocus": 1,
            "disabled": 1,
            "form": 1,
            "multiple": {
                "multiple": 1
            },
            "name": 1,
            "size": 1,
            "readonly": {
                "readonly": 1
            }
        },
        "small": {},
        "source": {
            "src": 1,
            "type": 1,
            "media": 1
        },
        "span": {},
        "strong": {},
        "style": {
            "type": 1,
            "media": {
                "all": 1,
                "screen": 1,
                "print": 1
            },
            "scoped": 1
        },
        "sub": {},
        "sup": {},
        "svg": {},
        "table": {
            "summary": 1
        },
        "tbody": {},
        "td": {
            "headers": 1,
            "rowspan": 1,
            "colspan": 1
        },
        "textarea": {
            "autofocus": {
                "autofocus": 1
            },
            "disabled": {
                "disabled": 1
            },
            "form": 1,
            "maxlength": 1,
            "name": 1,
            "placeholder": 1,
            "readonly": {
                "readonly": 1
            },
            "required": {
                "required": 1
            },
            "rows": 1,
            "cols": 1,
            "wrap": {
                "on": 1,
                "off": 1,
                "hard": 1,
                "soft": 1
            }
        },
        "tfoot": {},
        "th": {
            "headers": 1,
            "rowspan": 1,
            "colspan": 1,
            "scope": 1
        },
        "thead": {},
        "time": {
            "datetime": 1
        },
        "title": {},
        "tr": {},
        "track": {
            "kind": 1,
            "src": 1,
            "srclang": 1,
            "label": 1,
            "default": 1
        },
        "section": {},
        "summary": {},
        "u": {},
        "ul": {},
        "var": {},
        "video": {
            "src": 1,
            "autobuffer": 1,
            "autoplay": {
                "autoplay": 1
            },
            "loop": {
                "loop": 1
            },
            "controls": {
                "controls": 1
            },
            "width": 1,
            "height": 1,
            "poster": 1,
            "muted": {
                "muted": 1
            },
            "preload": {
                "auto": 1,
                "metadata": 1,
                "none": 1
            }
        },
        "wbr": {}
    };
    var elements = Object.keys(attributeMap);
    function is(token, type) {
        return token.type.lastIndexOf(type + ".xml") > -1;
    }
    function findTagName(session, pos) {
        var iterator = new TokenIterator(session, pos.row, pos.column);
        var token = iterator.getCurrentToken();
        while(token && !is(token, "tag-name"))token = iterator.stepBackward();
        if (token) return token.value;
    }
    function findAttributeName(session, pos) {
        var iterator = new TokenIterator(session, pos.row, pos.column);
        var token = iterator.getCurrentToken();
        while(token && !is(token, "attribute-name"))token = iterator.stepBackward();
        if (token) return token.value;
    }
    var HtmlCompletions = function() {};
    (function() {
        this.getCompletions = function(state, session, pos, prefix) {
            var token = session.getTokenAt(pos.row, pos.column);
            if (!token) return [];
            if (is(token, "tag-name") || is(token, "tag-open") || is(token, "end-tag-open")) return this.getTagCompletions(state, session, pos, prefix);
            if (is(token, "tag-whitespace") || is(token, "attribute-name")) return this.getAttributeCompletions(state, session, pos, prefix);
            if (is(token, "attribute-value")) return this.getAttributeValueCompletions(state, session, pos, prefix);
            var line = session.getLine(pos.row).substr(0, pos.column);
            if (/&[a-z]*$/i.test(line)) return this.getHTMLEntityCompletions(state, session, pos, prefix);
            return [];
        };
        this.getTagCompletions = function(state, session, pos, prefix) {
            return elements.map(function(element) {
                return {
                    value: element,
                    meta: "tag",
                    score: 1000000
                };
            });
        };
        this.getAttributeCompletions = function(state, session, pos, prefix) {
            var tagName = findTagName(session, pos);
            if (!tagName) return [];
            var attributes = globalAttributes;
            if (tagName in attributeMap) attributes = attributes.concat(Object.keys(attributeMap[tagName]));
            return attributes.map(function(attribute) {
                return {
                    caption: attribute,
                    snippet: attribute + '="$0"',
                    meta: "attribute",
                    score: 1000000
                };
            });
        };
        this.getAttributeValueCompletions = function(state, session, pos, prefix) {
            var tagName = findTagName(session, pos);
            var attributeName = findAttributeName(session, pos);
            if (!tagName) return [];
            var values = [];
            if (tagName in attributeMap && attributeName in attributeMap[tagName] && typeof attributeMap[tagName][attributeName] === "object") values = Object.keys(attributeMap[tagName][attributeName]);
            return values.map(function(value) {
                return {
                    caption: value,
                    snippet: value,
                    meta: "attribute value",
                    score: 1000000
                };
            });
        };
        this.getHTMLEntityCompletions = function(state, session, pos, prefix) {
            var values = [
                "Aacute;",
                "aacute;",
                "Acirc;",
                "acirc;",
                "acute;",
                "AElig;",
                "aelig;",
                "Agrave;",
                "agrave;",
                "alefsym;",
                "Alpha;",
                "alpha;",
                "amp;",
                "and;",
                "ang;",
                "Aring;",
                "aring;",
                "asymp;",
                "Atilde;",
                "atilde;",
                "Auml;",
                "auml;",
                "bdquo;",
                "Beta;",
                "beta;",
                "brvbar;",
                "bull;",
                "cap;",
                "Ccedil;",
                "ccedil;",
                "cedil;",
                "cent;",
                "Chi;",
                "chi;",
                "circ;",
                "clubs;",
                "cong;",
                "copy;",
                "crarr;",
                "cup;",
                "curren;",
                "Dagger;",
                "dagger;",
                "dArr;",
                "darr;",
                "deg;",
                "Delta;",
                "delta;",
                "diams;",
                "divide;",
                "Eacute;",
                "eacute;",
                "Ecirc;",
                "ecirc;",
                "Egrave;",
                "egrave;",
                "empty;",
                "emsp;",
                "ensp;",
                "Epsilon;",
                "epsilon;",
                "equiv;",
                "Eta;",
                "eta;",
                "ETH;",
                "eth;",
                "Euml;",
                "euml;",
                "euro;",
                "exist;",
                "fnof;",
                "forall;",
                "frac12;",
                "frac14;",
                "frac34;",
                "frasl;",
                "Gamma;",
                "gamma;",
                "ge;",
                "gt;",
                "hArr;",
                "harr;",
                "hearts;",
                "hellip;",
                "Iacute;",
                "iacute;",
                "Icirc;",
                "icirc;",
                "iexcl;",
                "Igrave;",
                "igrave;",
                "image;",
                "infin;",
                "int;",
                "Iota;",
                "iota;",
                "iquest;",
                "isin;",
                "Iuml;",
                "iuml;",
                "Kappa;",
                "kappa;",
                "Lambda;",
                "lambda;",
                "lang;",
                "laquo;",
                "lArr;",
                "larr;",
                "lceil;",
                "ldquo;",
                "le;",
                "lfloor;",
                "lowast;",
                "loz;",
                "lrm;",
                "lsaquo;",
                "lsquo;",
                "lt;",
                "macr;",
                "mdash;",
                "micro;",
                "middot;",
                "minus;",
                "Mu;",
                "mu;",
                "nabla;",
                "nbsp;",
                "ndash;",
                "ne;",
                "ni;",
                "not;",
                "notin;",
                "nsub;",
                "Ntilde;",
                "ntilde;",
                "Nu;",
                "nu;",
                "Oacute;",
                "oacute;",
                "Ocirc;",
                "ocirc;",
                "OElig;",
                "oelig;",
                "Ograve;",
                "ograve;",
                "oline;",
                "Omega;",
                "omega;",
                "Omicron;",
                "omicron;",
                "oplus;",
                "or;",
                "ordf;",
                "ordm;",
                "Oslash;",
                "oslash;",
                "Otilde;",
                "otilde;",
                "otimes;",
                "Ouml;",
                "ouml;",
                "para;",
                "part;",
                "permil;",
                "perp;",
                "Phi;",
                "phi;",
                "Pi;",
                "pi;",
                "piv;",
                "plusmn;",
                "pound;",
                "Prime;",
                "prime;",
                "prod;",
                "prop;",
                "Psi;",
                "psi;",
                "quot;",
                "radic;",
                "rang;",
                "raquo;",
                "rArr;",
                "rarr;",
                "rceil;",
                "rdquo;",
                "real;",
                "reg;",
                "rfloor;",
                "Rho;",
                "rho;",
                "rlm;",
                "rsaquo;",
                "rsquo;",
                "sbquo;",
                "Scaron;",
                "scaron;",
                "sdot;",
                "sect;",
                "shy;",
                "Sigma;",
                "sigma;",
                "sigmaf;",
                "sim;",
                "spades;",
                "sub;",
                "sube;",
                "sum;",
                "sup;",
                "sup1;",
                "sup2;",
                "sup3;",
                "supe;",
                "szlig;",
                "Tau;",
                "tau;",
                "there4;",
                "Theta;",
                "theta;",
                "thetasym;",
                "thinsp;",
                "THORN;",
                "thorn;",
                "tilde;",
                "times;",
                "trade;",
                "Uacute;",
                "uacute;",
                "uArr;",
                "uarr;",
                "Ucirc;",
                "ucirc;",
                "Ugrave;",
                "ugrave;",
                "uml;",
                "upsih;",
                "Upsilon;",
                "upsilon;",
                "Uuml;",
                "uuml;",
                "weierp;",
                "Xi;",
                "xi;",
                "Yacute;",
                "yacute;",
                "yen;",
                "Yuml;",
                "yuml;",
                "Zeta;",
                "zeta;",
                "zwj;",
                "zwnj;"
            ];
            return values.map(function(value) {
                return {
                    caption: value,
                    snippet: value,
                    meta: "html entity",
                    score: 1000000
                };
            });
        };
    }).call(HtmlCompletions.prototype);
    exports.HtmlCompletions = HtmlCompletions;
});
ace.define("ace/mode/html", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/mode/text",
    "ace/mode/javascript",
    "ace/mode/css",
    "ace/mode/html_highlight_rules",
    "ace/mode/behaviour/xml",
    "ace/mode/folding/html",
    "ace/mode/html_completions",
    "ace/worker/worker_client"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var lang = require("../lib/lang");
    var TextMode = require("./text").Mode;
    var JavaScriptMode = require("./javascript").Mode;
    var CssMode = require("./css").Mode;
    var HtmlHighlightRules = require("./html_highlight_rules").HtmlHighlightRules;
    var XmlBehaviour = require("./behaviour/xml").XmlBehaviour;
    var HtmlFoldMode = require("./folding/html").FoldMode;
    var HtmlCompletions = require("./html_completions").HtmlCompletions;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var voidElements = [
        "area",
        "base",
        "br",
        "col",
        "embed",
        "hr",
        "img",
        "input",
        "keygen",
        "link",
        "meta",
        "menuitem",
        "param",
        "source",
        "track",
        "wbr"
    ];
    var optionalEndTags = [
        "li",
        "dt",
        "dd",
        "p",
        "rt",
        "rp",
        "optgroup",
        "option",
        "colgroup",
        "td",
        "th"
    ];
    var Mode = function(options) {
        this.fragmentContext = options && options.fragmentContext;
        this.HighlightRules = HtmlHighlightRules;
        this.$behaviour = new XmlBehaviour();
        this.$completer = new HtmlCompletions();
        this.createModeDelegates({
            "js-": JavaScriptMode,
            "css-": CssMode
        });
        this.foldingRules = new HtmlFoldMode(this.voidElements, lang.arrayToMap(optionalEndTags));
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.blockComment = {
            start: "<!--",
            end: "-->"
        };
        this.voidElements = lang.arrayToMap(voidElements);
        this.getNextLineIndent = function(state, line, tab) {
            return this.$getIndent(line);
        };
        this.checkOutdent = function(state, line, input) {
            return false;
        };
        this.getCompletions = function(state, session, pos, prefix) {
            return this.$completer.getCompletions(state, session, pos, prefix);
        };
        this.createWorker = function(session) {
            if (this.constructor != Mode) return;
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/html_worker", "Worker");
            worker.attachToDocument(session.getDocument());
            if (this.fragmentContext) worker.call("setOptions", [
                {
                    context: this.fragmentContext
                }
            ]);
            worker.on("error", function(e) {
                session.setAnnotations(e.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/html";
        this.snippetFileId = "ace/snippets/html";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/html"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("erFzf", function(module, exports) {
ace.define("ace/mode/jsdoc_comment_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var JsDocCommentHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: [
                        "comment.doc.tag",
                        "comment.doc.text",
                        "lparen.doc"
                    ],
                    regex: "(@(?:param|member|typedef|property|namespace|var|const|callback))(\\s*)({)",
                    push: [
                        {
                            token: "lparen.doc",
                            regex: "{",
                            push: [
                                {
                                    include: "doc-syntax"
                                },
                                {
                                    token: "rparen.doc",
                                    regex: "}|(?=$)",
                                    next: "pop"
                                }
                            ]
                        },
                        {
                            token: [
                                "rparen.doc",
                                "text.doc",
                                "variable.parameter.doc",
                                "lparen.doc",
                                "variable.parameter.doc",
                                "rparen.doc"
                            ],
                            regex: /(})(\s*)(?:([\w=:\/\.]+)|(?:(\[)([\w=:\/\.\-\'\" ]+)(\])))/,
                            next: "pop"
                        },
                        {
                            token: "rparen.doc",
                            regex: "}|(?=$)",
                            next: "pop"
                        },
                        {
                            include: "doc-syntax"
                        },
                        {
                            defaultToken: "text.doc"
                        }
                    ]
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "lparen.doc"
                    ],
                    regex: "(@(?:returns?|yields|type|this|suppress|public|protected|private|package|modifies|implements|external|exception|throws|enum|define|extends))(\\s*)({)",
                    push: [
                        {
                            token: "lparen.doc",
                            regex: "{",
                            push: [
                                {
                                    include: "doc-syntax"
                                },
                                {
                                    token: "rparen.doc",
                                    regex: "}|(?=$)",
                                    next: "pop"
                                }
                            ]
                        },
                        {
                            token: "rparen.doc",
                            regex: "}|(?=$)",
                            next: "pop"
                        },
                        {
                            include: "doc-syntax"
                        },
                        {
                            defaultToken: "text.doc"
                        }
                    ]
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "variable.parameter.doc"
                    ],
                    regex: '(@(?:alias|memberof|instance|module|name|lends|namespace|external|this|template|requires|param|implements|function|extends|typedef|mixes|constructor|var|memberof\\!|event|listens|exports|class|constructs|interface|emits|fires|throws|const|callback|borrows|augments))(\\s+)(\\w[\\w#.:/~"\\-]*)?'
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "variable.parameter.doc"
                    ],
                    regex: "(@method)(\\s+)(\\w[\\w.\\(\\)]*)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@access\\s+(?:private|public|protected)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@kind\\s+(?:class|constant|event|external|file|function|member|mixin|module|namespace|typedef)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@\\w+(?=\\s|$)"
                },
                JsDocCommentHighlightRules.getTagRule(),
                {
                    defaultToken: "comment.doc.body",
                    caseInsensitive: true
                }
            ],
            "doc-syntax": [
                {
                    token: "operator.doc",
                    regex: /[|:]/
                },
                {
                    token: "paren.doc",
                    regex: /[\[\]]/
                }
            ]
        };
        this.normalizeRules();
    };
    oop.inherits(JsDocCommentHighlightRules, TextHighlightRules);
    JsDocCommentHighlightRules.getTagRule = function(start) {
        return {
            token: "comment.doc.tag.storage.type",
            regex: "\\b(?:TODO|FIXME|XXX|HACK)\\b"
        };
    };
    JsDocCommentHighlightRules.getStartRule = function(start) {
        return {
            token: "comment.doc",
            regex: /\/\*\*(?!\/)/,
            next: start
        };
    };
    JsDocCommentHighlightRules.getEndRule = function(start) {
        return {
            token: "comment.doc",
            regex: "\\*\\/",
            next: start
        };
    };
    exports.JsDocCommentHighlightRules = JsDocCommentHighlightRules;
});
ace.define("ace/mode/javascript_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/jsdoc_comment_highlight_rules",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var DocCommentHighlightRules = require("./jsdoc_comment_highlight_rules").JsDocCommentHighlightRules;
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var identifierRe = "[a-zA-Z\\$_\xa1-\uFFFF][a-zA-Z\\d\\$_\xa1-\uFFFF]*";
    var JavaScriptHighlightRules = function(options) {
        var keywords = {
            "variable.language": "Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|Symbol|Namespace|QName|XML|XMLList|ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|SyntaxError|TypeError|URIError|decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|isNaN|parseFloat|parseInt|JSON|Math|this|arguments|prototype|window|document",
            "keyword": "const|yield|import|get|set|async|await|break|case|catch|continue|default|delete|do|else|finally|for|if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|__parent__|__count__|escape|unescape|with|__proto__|class|enum|extends|super|export|implements|private|public|interface|package|protected|static|constructor",
            "storage.type": "const|let|var|function",
            "constant.language": "null|Infinity|NaN|undefined",
            "support.function": "alert",
            "constant.language.boolean": "true|false"
        };
        var keywordMapper = this.createKeywordMapper(keywords, "identifier");
        var kwBeforeRe = "case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void";
        var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|u{[0-9a-fA-F]{1,6}}|[0-2][0-7]{0,2}|3[0-7][0-7]?|[4-7][0-7]?|.)";
        var anonymousFunctionRe = "(function)(\\s*)(\\*?)";
        var functionCallStartRule = {
            token: [
                "identifier",
                "text",
                "paren.lparen"
            ],
            regex: "(\\b(?!" + Object.values(keywords).join("|") + "\\b)" + identifierRe + ")(\\s*)(\\()"
        };
        this.$rules = {
            "no_regex": [
                DocCommentHighlightRules.getStartRule("doc-start"),
                comments("no_regex"),
                functionCallStartRule,
                {
                    token: "string",
                    regex: "'(?=.)",
                    next: "qstring"
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    next: "qqstring"
                },
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
                },
                {
                    token: "constant.numeric",
                    regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
                },
                {
                    token: [
                        "entity.name.function",
                        "text",
                        "keyword.operator",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\s*)(=)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(function)(?:(?:(\\s*)(\\*)(\\s*))|(\\s+))(" + identifierRe + ")(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "entity.name.function",
                        "text",
                        "punctuation.operator",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\s*)(:)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "text",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(:)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: "keyword",
                    regex: "from(?=\\s*('|\"))"
                },
                {
                    token: "keyword",
                    regex: "(?:" + kwBeforeRe + ")\\b",
                    next: "start"
                },
                {
                    token: "support.constant",
                    regex: /that\b/
                },
                {
                    token: [
                        "storage.type",
                        "punctuation.operator",
                        "support.function.firebug"
                    ],
                    regex: /(console)(\.)(warn|info|log|error|debug|time|trace|timeEnd|assert)\b/
                },
                {
                    token: keywordMapper,
                    regex: identifierRe
                },
                {
                    token: "punctuation.operator",
                    regex: /[.](?![.])/,
                    next: "property"
                },
                {
                    token: "storage.type",
                    regex: /=>/,
                    next: "start"
                },
                {
                    token: "keyword.operator",
                    regex: /--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,
                    next: "start"
                },
                {
                    token: "punctuation.operator",
                    regex: /[?:,;.]/,
                    next: "start"
                },
                {
                    token: "paren.lparen",
                    regex: /[\[({]/,
                    next: "start"
                },
                {
                    token: "paren.rparen",
                    regex: /[\])}]/
                },
                {
                    token: "comment",
                    regex: /^#!.*$/
                }
            ],
            property: [
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "keyword.operator",
                    regex: /=/
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(function)(?:(?:(\\s*)(\\*)(\\s*))|(\\s+))(\\w+)(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: "punctuation.operator",
                    regex: /[.](?![.])/
                },
                {
                    token: "support.function",
                    regex: "prototype"
                },
                {
                    token: "support.function",
                    regex: /(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|lter|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward|rEach)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/
                },
                {
                    token: "support.function.dom",
                    regex: /(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/
                },
                {
                    token: "support.constant",
                    regex: /(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/
                },
                {
                    token: "identifier",
                    regex: identifierRe
                },
                {
                    regex: "",
                    token: "empty",
                    next: "no_regex"
                }
            ],
            "start": [
                DocCommentHighlightRules.getStartRule("doc-start"),
                comments("start"),
                {
                    token: "string.regexp",
                    regex: "\\/",
                    next: "regex"
                },
                {
                    token: "text",
                    regex: "\\s+|^$",
                    next: "start"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "regex": [
                {
                    token: "regexp.keyword.operator",
                    regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
                },
                {
                    token: "string.regexp",
                    regex: "/[sxngimy]*",
                    next: "no_regex"
                },
                {
                    token: "invalid",
                    regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
                },
                {
                    token: "constant.language.escape",
                    regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
                },
                {
                    token: "constant.language.delimiter",
                    regex: /\|/
                },
                {
                    token: "constant.language.escape",
                    regex: /\[\^?/,
                    next: "regex_character_class"
                },
                {
                    token: "empty",
                    regex: "$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string.regexp"
                }
            ],
            "regex_character_class": [
                {
                    token: "regexp.charclass.keyword.operator",
                    regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
                },
                {
                    token: "constant.language.escape",
                    regex: "]",
                    next: "regex"
                },
                {
                    token: "constant.language.escape",
                    regex: "-"
                },
                {
                    token: "empty",
                    regex: "$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string.regexp.charachterclass"
                }
            ],
            "default_parameter": [
                {
                    token: "string",
                    regex: "'(?=.)",
                    push: [
                        {
                            token: "string",
                            regex: "'|$",
                            next: "pop"
                        },
                        {
                            include: "qstring"
                        }
                    ]
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    push: [
                        {
                            token: "string",
                            regex: '"|$',
                            next: "pop"
                        },
                        {
                            include: "qqstring"
                        }
                    ]
                },
                {
                    token: "constant.language",
                    regex: "null|Infinity|NaN|undefined"
                },
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
                },
                {
                    token: "constant.numeric",
                    regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
                },
                {
                    token: "punctuation.operator",
                    regex: ",",
                    next: "function_arguments"
                },
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.operator",
                    regex: "$"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "function_arguments": [
                comments("function_arguments"),
                {
                    token: "variable.parameter",
                    regex: identifierRe
                },
                {
                    token: "punctuation.operator",
                    regex: ","
                },
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.operator",
                    regex: "$"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "qqstring": [
                {
                    token: "constant.language.escape",
                    regex: escapedRe
                },
                {
                    token: "string",
                    regex: "\\\\$",
                    consumeLineEnd: true
                },
                {
                    token: "string",
                    regex: '"|$',
                    next: "no_regex"
                },
                {
                    defaultToken: "string"
                }
            ],
            "qstring": [
                {
                    token: "constant.language.escape",
                    regex: escapedRe
                },
                {
                    token: "string",
                    regex: "\\\\$",
                    consumeLineEnd: true
                },
                {
                    token: "string",
                    regex: "'|$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string"
                }
            ]
        };
        if (!options || !options.noES6) {
            this.$rules.no_regex.unshift({
                regex: "[{}]",
                onMatch: function(val, state, stack) {
                    this.next = val == "{" ? this.nextState : "";
                    if (val == "{" && stack.length) stack.unshift("start", state);
                    else if (val == "}" && stack.length) {
                        stack.shift();
                        this.next = stack.shift();
                        if (this.next.indexOf("string") != -1 || this.next.indexOf("jsx") != -1) return "paren.quasi.end";
                    }
                    return val == "{" ? "paren.lparen" : "paren.rparen";
                },
                nextState: "start"
            }, {
                token: "string.quasi.start",
                regex: /`/,
                push: [
                    {
                        token: "constant.language.escape",
                        regex: escapedRe
                    },
                    {
                        token: "paren.quasi.start",
                        regex: /\${/,
                        push: "start"
                    },
                    {
                        token: "string.quasi.end",
                        regex: /`/,
                        next: "pop"
                    },
                    {
                        defaultToken: "string.quasi"
                    }
                ]
            }, {
                token: [
                    "variable.parameter",
                    "text"
                ],
                regex: "(" + identifierRe + ")(\\s*)(?=\\=>)"
            }, {
                token: "paren.lparen",
                regex: "(\\()(?=[^\\(]+\\s*=>)",
                next: "function_arguments"
            }, {
                token: "variable.language",
                regex: "(?:(?:(?:Weak)?(?:Set|Map))|Promise)\\b"
            });
            this.$rules["function_arguments"].unshift({
                token: "keyword.operator",
                regex: "=",
                next: "default_parameter"
            }, {
                token: "keyword.operator",
                regex: "\\.{3}"
            });
            this.$rules["property"].unshift({
                token: "support.function",
                regex: "(findIndex|repeat|startsWith|endsWith|includes|isSafeInteger|trunc|cbrt|log2|log10|sign|then|catch|finally|resolve|reject|race|any|all|allSettled|keys|entries|isInteger)\\b(?=\\()"
            }, {
                token: "constant.language",
                regex: "(?:MAX_SAFE_INTEGER|MIN_SAFE_INTEGER|EPSILON)\\b"
            });
            if (!options || options.jsx != false) JSX.call(this);
        }
        this.embedRules(DocCommentHighlightRules, "doc-", [
            DocCommentHighlightRules.getEndRule("no_regex")
        ]);
        this.normalizeRules();
    };
    oop.inherits(JavaScriptHighlightRules, TextHighlightRules);
    function JSX() {
        var tagRegex = identifierRe.replace("\\d", "\\d\\-");
        var jsxTag = {
            onMatch: function(val, state, stack) {
                var offset = val.charAt(1) == "/" ? 2 : 1;
                if (offset == 1) {
                    if (state != this.nextState) stack.unshift(this.next, this.nextState, 0);
                    else stack.unshift(this.next);
                    stack[2]++;
                } else if (offset == 2) {
                    if (state == this.nextState) {
                        stack[1]--;
                        if (!stack[1] || stack[1] < 0) {
                            stack.shift();
                            stack.shift();
                        }
                    }
                }
                return [
                    {
                        type: "meta.tag.punctuation." + (offset == 1 ? "" : "end-") + "tag-open.xml",
                        value: val.slice(0, offset)
                    },
                    {
                        type: "meta.tag.tag-name.xml",
                        value: val.substr(offset)
                    }
                ];
            },
            regex: "</?(?:" + tagRegex + "|(?=>))",
            next: "jsxAttributes",
            nextState: "jsx"
        };
        this.$rules.start.unshift(jsxTag);
        var jsxJsRule = {
            regex: "{",
            token: "paren.quasi.start",
            push: "start"
        };
        this.$rules.jsx = [
            jsxJsRule,
            jsxTag,
            {
                include: "reference"
            },
            {
                defaultToken: "string.xml"
            }
        ];
        this.$rules.jsxAttributes = [
            {
                token: "meta.tag.punctuation.tag-close.xml",
                regex: "/?>",
                onMatch: function(value, currentState, stack) {
                    if (currentState == stack[0]) stack.shift();
                    if (value.length == 2) {
                        if (stack[0] == this.nextState) stack[1]--;
                        if (!stack[1] || stack[1] < 0) stack.splice(0, 2);
                    }
                    this.next = stack[0] || "start";
                    return [
                        {
                            type: this.token,
                            value: value
                        }
                    ];
                },
                nextState: "jsx"
            },
            jsxJsRule,
            comments("jsxAttributes"),
            {
                token: "entity.other.attribute-name.xml",
                regex: tagRegex
            },
            {
                token: "keyword.operator.attribute-equals.xml",
                regex: "="
            },
            {
                token: "text.tag-whitespace.xml",
                regex: "\\s+"
            },
            {
                token: "string.attribute-value.xml",
                regex: "'",
                stateName: "jsx_attr_q",
                push: [
                    {
                        token: "string.attribute-value.xml",
                        regex: "'",
                        next: "pop"
                    },
                    {
                        include: "reference"
                    },
                    {
                        defaultToken: "string.attribute-value.xml"
                    }
                ]
            },
            {
                token: "string.attribute-value.xml",
                regex: '"',
                stateName: "jsx_attr_qq",
                push: [
                    {
                        token: "string.attribute-value.xml",
                        regex: '"',
                        next: "pop"
                    },
                    {
                        include: "reference"
                    },
                    {
                        defaultToken: "string.attribute-value.xml"
                    }
                ]
            },
            jsxTag
        ];
        this.$rules.reference = [
            {
                token: "constant.language.escape.reference.xml",
                regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
            }
        ];
    }
    function comments(next) {
        return [
            {
                token: "comment",
                regex: /\/\*/,
                next: [
                    DocCommentHighlightRules.getTagRule(),
                    {
                        token: "comment",
                        regex: "\\*\\/",
                        next: next || "pop"
                    },
                    {
                        defaultToken: "comment",
                        caseInsensitive: true
                    }
                ]
            },
            {
                token: "comment",
                regex: "\\/\\/",
                next: [
                    DocCommentHighlightRules.getTagRule(),
                    {
                        token: "comment",
                        regex: "$|^",
                        next: next || "pop"
                    },
                    {
                        defaultToken: "comment",
                        caseInsensitive: true
                    }
                ]
            }
        ];
    }
    exports.JavaScriptHighlightRules = JavaScriptHighlightRules;
});
ace.define("ace/mode/matching_brace_outdent", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var MatchingBraceOutdent = function() {};
    (function() {
        this.checkOutdent = function(line, input) {
            if (!/^\s+$/.test(line)) return false;
            return /^\s*\}/.test(input);
        };
        this.autoOutdent = function(doc, row) {
            var line = doc.getLine(row);
            var match = line.match(/^(\s*\})/);
            if (!match) return 0;
            var column = match[1].length;
            var openBracePos = doc.findMatchingBracket({
                row: row,
                column: column
            });
            if (!openBracePos || openBracePos.row == row) return 0;
            var indent = this.$getIndent(doc.getLine(openBracePos.row));
            doc.replace(new Range(row, 0, row, column - 1), indent);
        };
        this.$getIndent = function(line) {
            return line.match(/^\s*/)[0];
        };
    }).call(MatchingBraceOutdent.prototype);
    exports.MatchingBraceOutdent = MatchingBraceOutdent;
});
ace.define("ace/mode/behaviour/xml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/behaviour",
    "ace/token_iterator"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Behaviour = require("../behaviour").Behaviour;
    var TokenIterator = require("../../token_iterator").TokenIterator;
    function is(token, type) {
        return token && token.type.lastIndexOf(type + ".xml") > -1;
    }
    var XmlBehaviour = function() {
        this.add("string_dquotes", "insertion", function(state, action, editor, session, text) {
            if (text == '"' || text == "'") {
                var quote = text;
                var selected = session.doc.getTextRange(editor.getSelectionRange());
                if (selected !== "" && selected !== "'" && selected != '"' && editor.getWrapBehavioursEnabled()) return {
                    text: quote + selected + quote,
                    selection: false
                };
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (rightChar == quote && (is(token, "attribute-value") || is(token, "string"))) return {
                    text: "",
                    selection: [
                        1,
                        1
                    ]
                };
                if (!token) token = iterator.stepBackward();
                if (!token) return;
                while(is(token, "tag-whitespace") || is(token, "whitespace"))token = iterator.stepBackward();
                var rightSpace = !rightChar || rightChar.match(/\s/);
                if (is(token, "attribute-equals") && (rightSpace || rightChar == ">") || is(token, "decl-attribute-equals") && (rightSpace || rightChar == "?")) return {
                    text: quote + quote,
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("string_dquotes", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && (selected == '"' || selected == "'")) {
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
                if (rightChar == selected) {
                    range.end.column++;
                    return range;
                }
            }
        });
        this.add("autoclosing", "insertion", function(state, action, editor, session, text) {
            if (text == ">") {
                var position = editor.getSelectionRange().start;
                var iterator = new TokenIterator(session, position.row, position.column);
                var token = iterator.getCurrentToken() || iterator.stepBackward();
                if (!token || !(is(token, "tag-name") || is(token, "tag-whitespace") || is(token, "attribute-name") || is(token, "attribute-equals") || is(token, "attribute-value"))) return;
                if (is(token, "reference.attribute-value")) return;
                if (is(token, "attribute-value")) {
                    var tokenEndColumn = iterator.getCurrentTokenColumn() + token.value.length;
                    if (position.column < tokenEndColumn) return;
                    if (position.column == tokenEndColumn) {
                        var nextToken = iterator.stepForward();
                        if (nextToken && is(nextToken, "attribute-value")) return;
                        iterator.stepBackward();
                    }
                }
                if (/^\s*>/.test(session.getLine(position.row).slice(position.column))) return;
                while(!is(token, "tag-name")){
                    token = iterator.stepBackward();
                    if (token.value == "<") {
                        token = iterator.stepForward();
                        break;
                    }
                }
                var tokenRow = iterator.getCurrentTokenRow();
                var tokenColumn = iterator.getCurrentTokenColumn();
                if (is(iterator.stepBackward(), "end-tag-open")) return;
                var element = token.value;
                if (tokenRow == position.row) element = element.substring(0, position.column - tokenColumn);
                if (this.voidElements && this.voidElements.hasOwnProperty(element.toLowerCase())) return;
                return {
                    text: "></" + element + ">",
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("autoindent", "insertion", function(state, action, editor, session, text) {
            if (text == "\n") {
                var cursor = editor.getCursorPosition();
                var line = session.getLine(cursor.row);
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (is(token, "") && token.type.indexOf("tag-close") !== -1) {
                    if (token.value == "/>") return;
                    while(token && token.type.indexOf("tag-name") === -1)token = iterator.stepBackward();
                    if (!token) return;
                    var tag = token.value;
                    var row = iterator.getCurrentTokenRow();
                    token = iterator.stepBackward();
                    if (!token || token.type.indexOf("end-tag") !== -1) return;
                    if (this.voidElements && !this.voidElements[tag] || !this.voidElements) {
                        var nextToken = session.getTokenAt(cursor.row, cursor.column + 1);
                        var line = session.getLine(row);
                        var nextIndent = this.$getIndent(line);
                        var indent = nextIndent + session.getTabString();
                        if (nextToken && nextToken.value === "</") return {
                            text: "\n" + indent + "\n" + nextIndent,
                            selection: [
                                1,
                                indent.length,
                                1,
                                indent.length
                            ]
                        };
                        else return {
                            text: "\n" + indent
                        };
                    }
                }
            }
        });
    };
    oop.inherits(XmlBehaviour, Behaviour);
    exports.XmlBehaviour = XmlBehaviour;
});
ace.define("ace/mode/behaviour/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/token_iterator",
    "ace/mode/behaviour/cstyle",
    "ace/mode/behaviour/xml"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var TokenIterator = require("../../token_iterator").TokenIterator;
    var CstyleBehaviour = require("../behaviour/cstyle").CstyleBehaviour;
    var XmlBehaviour = require("../behaviour/xml").XmlBehaviour;
    var JavaScriptBehaviour = function() {
        var xmlBehaviours = new XmlBehaviour({
            closeCurlyBraces: true
        }).getBehaviours();
        this.addBehaviours(xmlBehaviours);
        this.inherit(CstyleBehaviour);
        this.add("autoclosing-fragment", "insertion", function(state, action, editor, session, text) {
            if (text == ">") {
                var position = editor.getSelectionRange().start;
                var iterator = new TokenIterator(session, position.row, position.column);
                var token = iterator.getCurrentToken() || iterator.stepBackward();
                if (!token) return;
                if (token.value == "<") return {
                    text: "></>",
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
    };
    oop.inherits(JavaScriptBehaviour, CstyleBehaviour);
    exports.JavaScriptBehaviour = JavaScriptBehaviour;
});
ace.define("ace/mode/folding/xml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(voidElements, optionalEndTags) {
        BaseFoldMode.call(this);
        this.voidElements = voidElements || {};
        this.optionalEndTags = oop.mixin({}, this.voidElements);
        if (optionalEndTags) oop.mixin(this.optionalEndTags, optionalEndTags);
    };
    oop.inherits(FoldMode, BaseFoldMode);
    var Tag = function() {
        this.tagName = "";
        this.closing = false;
        this.selfClosing = false;
        this.start = {
            row: 0,
            column: 0
        };
        this.end = {
            row: 0,
            column: 0
        };
    };
    function is(token, type) {
        return token.type.lastIndexOf(type + ".xml") > -1;
    }
    (function() {
        this.getFoldWidget = function(session, foldStyle, row) {
            var tag = this._getFirstTagInLine(session, row);
            if (!tag) return this.getCommentFoldWidget(session, row);
            if (tag.closing || !tag.tagName && tag.selfClosing) return foldStyle === "markbeginend" ? "end" : "";
            if (!tag.tagName || tag.selfClosing || this.voidElements.hasOwnProperty(tag.tagName.toLowerCase())) return "";
            if (this._findEndTagInLine(session, row, tag.tagName, tag.end.column)) return "";
            return "start";
        };
        this.getCommentFoldWidget = function(session, row) {
            if (/comment/.test(session.getState(row)) && /<!-/.test(session.getLine(row))) return "start";
            return "";
        };
        this._getFirstTagInLine = function(session, row) {
            var tokens = session.getTokens(row);
            var tag = new Tag();
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                if (is(token, "tag-open")) {
                    tag.end.column = tag.start.column + token.value.length;
                    tag.closing = is(token, "end-tag-open");
                    token = tokens[++i];
                    if (!token) return null;
                    tag.tagName = token.value;
                    if (token.value === "") {
                        token = tokens[++i];
                        if (!token) return null;
                        tag.tagName = token.value;
                    }
                    tag.end.column += token.value.length;
                    for(i++; i < tokens.length; i++){
                        token = tokens[i];
                        tag.end.column += token.value.length;
                        if (is(token, "tag-close")) {
                            tag.selfClosing = token.value == "/>";
                            break;
                        }
                    }
                    return tag;
                } else if (is(token, "tag-close")) {
                    tag.selfClosing = token.value == "/>";
                    return tag;
                }
                tag.start.column += token.value.length;
            }
            return null;
        };
        this._findEndTagInLine = function(session, row, tagName, startColumn) {
            var tokens = session.getTokens(row);
            var column = 0;
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                column += token.value.length;
                if (column < startColumn - 1) continue;
                if (is(token, "end-tag-open")) {
                    token = tokens[i + 1];
                    if (is(token, "tag-name") && token.value === "") token = tokens[i + 2];
                    if (token && token.value == tagName) return true;
                }
            }
            return false;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            var firstTag = this._getFirstTagInLine(session, row);
            if (!firstTag) return this.getCommentFoldWidget(session, row) && session.getCommentFoldRange(row, session.getLine(row).length);
            var tags = session.getMatchingTags({
                row: row,
                column: 0
            });
            if (tags) return new Range(tags.openTag.end.row, tags.openTag.end.column, tags.closeTag.start.row, tags.closeTag.start.column);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/folding/cstyle", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
    };
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
        this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
        this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
        this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
        this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
        this._getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            if (this.singleLineBlockCommentRe.test(line)) {
                if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line)) return "";
            }
            var fw = this._getFoldWidgetBase(session, foldStyle, row);
            if (!fw && this.startRegionRe.test(line)) return "start"; // lineCommentRegionStart
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var line = session.getLine(row);
            if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
            var match = line.match(this.foldingStartMarker);
            if (match) {
                var i = match.index;
                if (match[1]) return this.openingBracketBlock(session, match[1], row, i);
                var range = session.getCommentFoldRange(row, i + match[0].length, 1);
                if (range && !range.isMultiLine()) {
                    if (forceMultiline) range = this.getSectionRange(session, row);
                    else if (foldStyle != "all") range = null;
                }
                return range;
            }
            if (foldStyle === "markbegin") return;
            var match = line.match(this.foldingStopMarker);
            if (match) {
                var i = match.index + match[0].length;
                if (match[1]) return this.closingBracketBlock(session, match[1], row, i);
                return session.getCommentFoldRange(row, i, -1);
            }
        };
        this.getSectionRange = function(session, row) {
            var line = session.getLine(row);
            var startIndent = line.search(/\S/);
            var startRow = row;
            var startColumn = line.length;
            row = row + 1;
            var endRow = row;
            var maxRow = session.getLength();
            while(++row < maxRow){
                line = session.getLine(row);
                var indent = line.search(/\S/);
                if (indent === -1) continue;
                if (startIndent > indent) break;
                var subRange = this.getFoldWidgetRange(session, "all", row);
                if (subRange) {
                    if (subRange.start.row <= startRow) break;
                    else if (subRange.isMultiLine()) row = subRange.end.row;
                    else if (startIndent == indent) break;
                }
                endRow = row;
            }
            return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
        };
        this.getCommentRegionBlock = function(session, line, row) {
            var startColumn = line.search(/\s*$/);
            var maxRow = session.getLength();
            var startRow = row;
            var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
            var depth = 1;
            while(++row < maxRow){
                line = session.getLine(row);
                var m = re.exec(line);
                if (!m) continue;
                if (m[1]) depth--;
                else depth++;
                if (!depth) break;
            }
            var endRow = row;
            if (endRow > startRow) return new Range(startRow, startColumn, endRow, line.length);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/folding/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/folding/xml",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var XmlFoldMode = require("./xml").FoldMode;
    var CFoldMode = require("./cstyle").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
        this.xmlFoldMode = new XmlFoldMode();
    };
    oop.inherits(FoldMode, CFoldMode);
    (function() {
        this.getFoldWidgetRangeBase = this.getFoldWidgetRange;
        this.getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var fw = this.getFoldWidgetBase(session, foldStyle, row);
            if (!fw) return this.xmlFoldMode.getFoldWidget(session, foldStyle, row);
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var range = this.getFoldWidgetRangeBase(session, foldStyle, row, forceMultiline);
            if (range) return range;
            return this.xmlFoldMode.getFoldWidgetRange(session, foldStyle, row);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/javascript_highlight_rules",
    "ace/mode/matching_brace_outdent",
    "ace/worker/worker_client",
    "ace/mode/behaviour/javascript",
    "ace/mode/folding/javascript"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var JavaScriptHighlightRules = require("./javascript_highlight_rules").JavaScriptHighlightRules;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var JavaScriptBehaviour = require("./behaviour/javascript").JavaScriptBehaviour;
    var JavaScriptFoldMode = require("./folding/javascript").FoldMode;
    var Mode = function() {
        this.HighlightRules = JavaScriptHighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.$behaviour = new JavaScriptBehaviour();
        this.foldingRules = new JavaScriptFoldMode();
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.lineCommentStart = "//";
        this.blockComment = {
            start: "/*",
            end: "*/"
        };
        this.$quotes = {
            '"': '"',
            "'": "'",
            "`": "`"
        };
        this.$pairQuotesAfter = {
            "`": /\w/
        };
        this.getNextLineIndent = function(state, line, tab) {
            var indent = this.$getIndent(line);
            var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
            var tokens = tokenizedLine.tokens;
            var endState = tokenizedLine.state;
            if (tokens.length && tokens[tokens.length - 1].type == "comment") return indent;
            if (state == "start" || state == "no_regex") {
                var match = line.match(/^.*(?:\bcase\b.*:|[\{\(\[])\s*$/);
                if (match) indent += tab;
            } else if (state == "doc-start") {
                if (endState == "start" || endState == "no_regex") return "";
            }
            return indent;
        };
        this.checkOutdent = function(state, line, input) {
            return this.$outdent.checkOutdent(line, input);
        };
        this.autoOutdent = function(state, doc, row) {
            this.$outdent.autoOutdent(doc, row);
        };
        this.createWorker = function(session) {
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/javascript_worker", "JavaScriptWorker");
            worker.attachToDocument(session.getDocument());
            worker.on("annotate", function(results) {
                session.setAnnotations(results.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/javascript";
        this.snippetFileId = "ace/snippets/javascript";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
ace.define("ace/mode/doc_comment_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var DocCommentHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: "comment.doc.tag",
                    regex: "@\\w+(?=\\s|$)"
                },
                DocCommentHighlightRules.getTagRule(),
                {
                    defaultToken: "comment.doc.body",
                    caseInsensitive: true
                }
            ]
        };
    };
    oop.inherits(DocCommentHighlightRules, TextHighlightRules);
    DocCommentHighlightRules.getTagRule = function(start) {
        return {
            token: "comment.doc.tag.storage.type",
            regex: "\\b(?:TODO|FIXME|XXX|HACK)\\b"
        };
    };
    DocCommentHighlightRules.getStartRule = function(start) {
        return {
            token: "comment.doc",
            regex: /\/\*\*(?!\/)/,
            next: start
        };
    };
    DocCommentHighlightRules.getEndRule = function(start) {
        return {
            token: "comment.doc",
            regex: "\\*\\/",
            next: start
        };
    };
    exports.DocCommentHighlightRules = DocCommentHighlightRules;
});
ace.define("ace/mode/java_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/doc_comment_highlight_rules",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var DocCommentHighlightRules = require("./doc_comment_highlight_rules").DocCommentHighlightRules;
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var JavaHighlightRules = function() {
        var identifierRe = "[a-zA-Z_$][a-zA-Z0-9_$]*";
        var keywords = "abstract|continue|for|new|switch|assert|default|goto|package|synchronized|boolean|do|if|private|this|break|double|implements|protected|throw|byte|else|import|public|throws|case|enum|instanceof|return|transient|catch|extends|int|short|try|char|final|interface|static|void|class|finally|long|strictfp|volatile|const|float|native|super|while|var|exports|opens|requires|uses|yield|module|permits|(?:non\\-)?sealed|var|provides|to|when|open|record|transitive|with";
        var buildinConstants = "null|Infinity|NaN|undefined";
        var langClasses = "AbstractMethodError|AssertionError|ClassCircularityError|ClassFormatError|Deprecated|EnumConstantNotPresentException|ExceptionInInitializerError|IllegalAccessError|IllegalThreadStateException|InstantiationError|InternalError|NegativeArraySizeException|NoSuchFieldError|Override|Process|ProcessBuilder|SecurityManager|StringIndexOutOfBoundsException|SuppressWarnings|TypeNotPresentException|UnknownError|UnsatisfiedLinkError|UnsupportedClassVersionError|VerifyError|InstantiationException|IndexOutOfBoundsException|ArrayIndexOutOfBoundsException|CloneNotSupportedException|NoSuchFieldException|IllegalArgumentException|NumberFormatException|SecurityException|Void|InheritableThreadLocal|IllegalStateException|InterruptedException|NoSuchMethodException|IllegalAccessException|UnsupportedOperationException|Enum|StrictMath|Package|Compiler|Readable|Runtime|StringBuilder|Math|IncompatibleClassChangeError|NoSuchMethodError|ThreadLocal|RuntimePermission|ArithmeticException|NullPointerException|Long|Integer|Short|Byte|Double|Number|Float|Character|Boolean|StackTraceElement|Appendable|StringBuffer|Iterable|ThreadGroup|Runnable|Thread|IllegalMonitorStateException|StackOverflowError|OutOfMemoryError|VirtualMachineError|ArrayStoreException|ClassCastException|LinkageError|NoClassDefFoundError|ClassNotFoundException|RuntimeException|Exception|ThreadDeath|Error|Throwable|System|ClassLoader|Cloneable|Class|CharSequence|Comparable|String|Object";
        var keywordMapper = this.createKeywordMapper({
            "variable.language": "this",
            "constant.language": buildinConstants,
            "support.function": langClasses
        }, "identifier");
        this.$rules = {
            "start": [
                {
                    token: "comment",
                    regex: "\\/\\/.*$"
                },
                DocCommentHighlightRules.getStartRule("doc-start"),
                {
                    token: "comment",
                    regex: "\\/\\*",
                    next: "comment"
                },
                {
                    include: "multiline-strings"
                },
                {
                    include: "strings"
                },
                {
                    include: "constants"
                },
                {
                    regex: "(open(?:\\s+))?module(?=\\s*\\w)",
                    token: "keyword",
                    next: [
                        {
                            regex: "{",
                            token: "paren.lparen",
                            next: [
                                {
                                    regex: "}",
                                    token: "paren.rparen",
                                    next: "start"
                                },
                                {
                                    regex: "\\b(requires|transitive|exports|opens|to|uses|provides|with)\\b",
                                    token: "keyword"
                                }
                            ]
                        },
                        {
                            token: "text",
                            regex: "\\s+"
                        },
                        {
                            token: "identifier",
                            regex: "\\w+"
                        },
                        {
                            token: "punctuation.operator",
                            regex: "."
                        },
                        {
                            token: "text",
                            regex: "\\s+"
                        },
                        {
                            regex: "",
                            next: "start"
                        }
                    ]
                },
                {
                    include: "statements"
                }
            ],
            "comment": [
                {
                    token: "comment",
                    regex: "\\*\\/",
                    next: "start"
                },
                {
                    defaultToken: "comment"
                }
            ],
            "strings": [
                {
                    token: [
                        "punctuation",
                        "string"
                    ],
                    regex: /(\.)(")/,
                    push: [
                        {
                            token: "lparen",
                            regex: /\\\{/,
                            push: [
                                {
                                    token: "text",
                                    regex: /$/,
                                    next: "start"
                                },
                                {
                                    token: "rparen",
                                    regex: /}/,
                                    next: "pop"
                                },
                                {
                                    include: "strings"
                                },
                                {
                                    include: "constants"
                                },
                                {
                                    include: "statements"
                                }
                            ]
                        },
                        {
                            token: "string",
                            regex: /"/,
                            next: "pop"
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                },
                {
                    token: "string",
                    regex: '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]'
                },
                {
                    token: "string",
                    regex: "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
                }
            ],
            "multiline-strings": [
                {
                    token: [
                        "punctuation",
                        "string"
                    ],
                    regex: /(\.)(""")/,
                    push: [
                        {
                            token: "string",
                            regex: '"""',
                            next: "pop"
                        },
                        {
                            token: "lparen",
                            regex: /\\\{/,
                            push: [
                                {
                                    token: "text",
                                    regex: /$/,
                                    next: "start"
                                },
                                {
                                    token: "rparen",
                                    regex: /}/,
                                    next: "pop"
                                },
                                {
                                    include: "multiline-strings"
                                },
                                {
                                    include: "strings"
                                },
                                {
                                    include: "constants"
                                },
                                {
                                    include: "statements"
                                }
                            ]
                        },
                        {
                            token: "constant.language.escape",
                            regex: /\\./
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                },
                {
                    token: "string",
                    regex: '"""',
                    push: [
                        {
                            token: "string",
                            regex: '"""',
                            next: "pop"
                        },
                        {
                            token: "constant.language.escape",
                            regex: /\\./
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                }
            ],
            "constants": [
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F][0-9a-fA-F_]*|[bB][01][01_]*)[LlSsDdFfYy]?\b/
                },
                {
                    token: "constant.numeric",
                    regex: /[+-]?\d[\d_]*(?:(?:\.[\d_]*)?(?:[eE][+-]?[\d_]+)?)?[LlSsDdFfYy]?\b/
                },
                {
                    token: "constant.language.boolean",
                    regex: "(?:true|false)\\b"
                }
            ],
            "statements": [
                {
                    token: [
                        "keyword",
                        "text",
                        "identifier"
                    ],
                    regex: "(record)(\\s+)(" + identifierRe + ")\\b"
                },
                {
                    token: "keyword",
                    regex: "(?:" + keywords + ")\\b"
                },
                {
                    token: "storage.type.annotation",
                    regex: "@" + identifierRe + "\\b"
                },
                {
                    token: "entity.name.function",
                    regex: identifierRe + "(?=\\()"
                },
                {
                    token: keywordMapper,
                    regex: identifierRe + "\\b"
                },
                {
                    token: "keyword.operator",
                    regex: "!|\\$|%|&|\\||\\^|\\*|\\/|\\-\\-|\\-|\\+\\+|\\+|~|===|==|=|!=|!==|<=|>=|<<=|>>=|>>>=|<>|<|>|!|&&|\\|\\||\\?|\\:|\\*=|\\/=|%=|\\+=|\\-=|&=|\\|=|\\^=|\\b(?:in|instanceof|new|delete|typeof|void)"
                },
                {
                    token: "lparen",
                    regex: "[[({]"
                },
                {
                    token: "rparen",
                    regex: "[\\])}]"
                },
                {
                    token: "text",
                    regex: "\\s+"
                }
            ]
        };
        this.embedRules(DocCommentHighlightRules, "doc-", [
            DocCommentHighlightRules.getEndRule("start")
        ]);
        this.normalizeRules();
    };
    oop.inherits(JavaHighlightRules, TextHighlightRules);
    exports.JavaHighlightRules = JavaHighlightRules;
});
ace.define("ace/mode/folding/java", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/folding/cstyle",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var CStyleFoldMode = require("./cstyle").FoldMode;
    var Range = require("../../range").Range;
    var FoldMode = exports.FoldMode = function() {};
    oop.inherits(FoldMode, CStyleFoldMode);
    (function() {
        this.importRegex = /^import /;
        this.getCStyleFoldWidget = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            if (foldStyle === "markbegin") {
                var line = session.getLine(row);
                if (this.importRegex.test(line)) {
                    if (row == 0 || !this.importRegex.test(session.getLine(row - 1))) return "start";
                }
            }
            return this.getCStyleFoldWidget(session, foldStyle, row);
        };
        this.getCstyleFoldWidgetRange = this.getFoldWidgetRange;
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var line = session.getLine(row);
            var match = line.match(this.importRegex);
            if (!match || foldStyle !== "markbegin") return this.getCstyleFoldWidgetRange(session, foldStyle, row, forceMultiline);
            var startColumn = match[0].length;
            var maxRow = session.getLength();
            var startRow = row;
            var endRow = row;
            while(++row < maxRow){
                var line = session.getLine(row);
                if (line.match(/^\s*$/)) continue;
                if (!line.match(this.importRegex)) break;
                endRow = row;
            }
            if (endRow > startRow) {
                var endColumn = session.getLine(endRow).length;
                return new Range(startRow, startColumn, endRow, endColumn);
            }
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/java", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/javascript",
    "ace/mode/java_highlight_rules",
    "ace/mode/folding/java"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var JavaScriptMode = require("./javascript").Mode;
    var JavaHighlightRules = require("./java_highlight_rules").JavaHighlightRules;
    var JavaFoldMode = require("./folding/java").FoldMode;
    var Mode = function() {
        JavaScriptMode.call(this);
        this.HighlightRules = JavaHighlightRules;
        this.foldingRules = new JavaFoldMode();
    };
    oop.inherits(Mode, JavaScriptMode);
    (function() {
        this.createWorker = function(session) {
            return null;
        };
        this.$id = "ace/mode/java";
        this.snippetFileId = "ace/snippets/java";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/java"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("cri0C", function(module, exports) {
ace.define("ace/mode/jsdoc_comment_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var JsDocCommentHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: [
                        "comment.doc.tag",
                        "comment.doc.text",
                        "lparen.doc"
                    ],
                    regex: "(@(?:param|member|typedef|property|namespace|var|const|callback))(\\s*)({)",
                    push: [
                        {
                            token: "lparen.doc",
                            regex: "{",
                            push: [
                                {
                                    include: "doc-syntax"
                                },
                                {
                                    token: "rparen.doc",
                                    regex: "}|(?=$)",
                                    next: "pop"
                                }
                            ]
                        },
                        {
                            token: [
                                "rparen.doc",
                                "text.doc",
                                "variable.parameter.doc",
                                "lparen.doc",
                                "variable.parameter.doc",
                                "rparen.doc"
                            ],
                            regex: /(})(\s*)(?:([\w=:\/\.]+)|(?:(\[)([\w=:\/\.\-\'\" ]+)(\])))/,
                            next: "pop"
                        },
                        {
                            token: "rparen.doc",
                            regex: "}|(?=$)",
                            next: "pop"
                        },
                        {
                            include: "doc-syntax"
                        },
                        {
                            defaultToken: "text.doc"
                        }
                    ]
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "lparen.doc"
                    ],
                    regex: "(@(?:returns?|yields|type|this|suppress|public|protected|private|package|modifies|implements|external|exception|throws|enum|define|extends))(\\s*)({)",
                    push: [
                        {
                            token: "lparen.doc",
                            regex: "{",
                            push: [
                                {
                                    include: "doc-syntax"
                                },
                                {
                                    token: "rparen.doc",
                                    regex: "}|(?=$)",
                                    next: "pop"
                                }
                            ]
                        },
                        {
                            token: "rparen.doc",
                            regex: "}|(?=$)",
                            next: "pop"
                        },
                        {
                            include: "doc-syntax"
                        },
                        {
                            defaultToken: "text.doc"
                        }
                    ]
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "variable.parameter.doc"
                    ],
                    regex: '(@(?:alias|memberof|instance|module|name|lends|namespace|external|this|template|requires|param|implements|function|extends|typedef|mixes|constructor|var|memberof\\!|event|listens|exports|class|constructs|interface|emits|fires|throws|const|callback|borrows|augments))(\\s+)(\\w[\\w#.:/~"\\-]*)?'
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "variable.parameter.doc"
                    ],
                    regex: "(@method)(\\s+)(\\w[\\w.\\(\\)]*)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@access\\s+(?:private|public|protected)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@kind\\s+(?:class|constant|event|external|file|function|member|mixin|module|namespace|typedef)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@\\w+(?=\\s|$)"
                },
                JsDocCommentHighlightRules.getTagRule(),
                {
                    defaultToken: "comment.doc.body",
                    caseInsensitive: true
                }
            ],
            "doc-syntax": [
                {
                    token: "operator.doc",
                    regex: /[|:]/
                },
                {
                    token: "paren.doc",
                    regex: /[\[\]]/
                }
            ]
        };
        this.normalizeRules();
    };
    oop.inherits(JsDocCommentHighlightRules, TextHighlightRules);
    JsDocCommentHighlightRules.getTagRule = function(start) {
        return {
            token: "comment.doc.tag.storage.type",
            regex: "\\b(?:TODO|FIXME|XXX|HACK)\\b"
        };
    };
    JsDocCommentHighlightRules.getStartRule = function(start) {
        return {
            token: "comment.doc",
            regex: /\/\*\*(?!\/)/,
            next: start
        };
    };
    JsDocCommentHighlightRules.getEndRule = function(start) {
        return {
            token: "comment.doc",
            regex: "\\*\\/",
            next: start
        };
    };
    exports.JsDocCommentHighlightRules = JsDocCommentHighlightRules;
});
ace.define("ace/mode/javascript_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/jsdoc_comment_highlight_rules",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var DocCommentHighlightRules = require("./jsdoc_comment_highlight_rules").JsDocCommentHighlightRules;
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var identifierRe = "[a-zA-Z\\$_\xa1-\uFFFF][a-zA-Z\\d\\$_\xa1-\uFFFF]*";
    var JavaScriptHighlightRules = function(options) {
        var keywords = {
            "variable.language": "Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|Symbol|Namespace|QName|XML|XMLList|ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|SyntaxError|TypeError|URIError|decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|isNaN|parseFloat|parseInt|JSON|Math|this|arguments|prototype|window|document",
            "keyword": "const|yield|import|get|set|async|await|break|case|catch|continue|default|delete|do|else|finally|for|if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|__parent__|__count__|escape|unescape|with|__proto__|class|enum|extends|super|export|implements|private|public|interface|package|protected|static|constructor",
            "storage.type": "const|let|var|function",
            "constant.language": "null|Infinity|NaN|undefined",
            "support.function": "alert",
            "constant.language.boolean": "true|false"
        };
        var keywordMapper = this.createKeywordMapper(keywords, "identifier");
        var kwBeforeRe = "case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void";
        var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|u{[0-9a-fA-F]{1,6}}|[0-2][0-7]{0,2}|3[0-7][0-7]?|[4-7][0-7]?|.)";
        var anonymousFunctionRe = "(function)(\\s*)(\\*?)";
        var functionCallStartRule = {
            token: [
                "identifier",
                "text",
                "paren.lparen"
            ],
            regex: "(\\b(?!" + Object.values(keywords).join("|") + "\\b)" + identifierRe + ")(\\s*)(\\()"
        };
        this.$rules = {
            "no_regex": [
                DocCommentHighlightRules.getStartRule("doc-start"),
                comments("no_regex"),
                functionCallStartRule,
                {
                    token: "string",
                    regex: "'(?=.)",
                    next: "qstring"
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    next: "qqstring"
                },
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
                },
                {
                    token: "constant.numeric",
                    regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
                },
                {
                    token: [
                        "entity.name.function",
                        "text",
                        "keyword.operator",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\s*)(=)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(function)(?:(?:(\\s*)(\\*)(\\s*))|(\\s+))(" + identifierRe + ")(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "entity.name.function",
                        "text",
                        "punctuation.operator",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\s*)(:)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "text",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(:)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: "keyword",
                    regex: "from(?=\\s*('|\"))"
                },
                {
                    token: "keyword",
                    regex: "(?:" + kwBeforeRe + ")\\b",
                    next: "start"
                },
                {
                    token: "support.constant",
                    regex: /that\b/
                },
                {
                    token: [
                        "storage.type",
                        "punctuation.operator",
                        "support.function.firebug"
                    ],
                    regex: /(console)(\.)(warn|info|log|error|debug|time|trace|timeEnd|assert)\b/
                },
                {
                    token: keywordMapper,
                    regex: identifierRe
                },
                {
                    token: "punctuation.operator",
                    regex: /[.](?![.])/,
                    next: "property"
                },
                {
                    token: "storage.type",
                    regex: /=>/,
                    next: "start"
                },
                {
                    token: "keyword.operator",
                    regex: /--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,
                    next: "start"
                },
                {
                    token: "punctuation.operator",
                    regex: /[?:,;.]/,
                    next: "start"
                },
                {
                    token: "paren.lparen",
                    regex: /[\[({]/,
                    next: "start"
                },
                {
                    token: "paren.rparen",
                    regex: /[\])}]/
                },
                {
                    token: "comment",
                    regex: /^#!.*$/
                }
            ],
            property: [
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "keyword.operator",
                    regex: /=/
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(function)(?:(?:(\\s*)(\\*)(\\s*))|(\\s+))(\\w+)(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: "punctuation.operator",
                    regex: /[.](?![.])/
                },
                {
                    token: "support.function",
                    regex: "prototype"
                },
                {
                    token: "support.function",
                    regex: /(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|lter|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward|rEach)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/
                },
                {
                    token: "support.function.dom",
                    regex: /(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/
                },
                {
                    token: "support.constant",
                    regex: /(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/
                },
                {
                    token: "identifier",
                    regex: identifierRe
                },
                {
                    regex: "",
                    token: "empty",
                    next: "no_regex"
                }
            ],
            "start": [
                DocCommentHighlightRules.getStartRule("doc-start"),
                comments("start"),
                {
                    token: "string.regexp",
                    regex: "\\/",
                    next: "regex"
                },
                {
                    token: "text",
                    regex: "\\s+|^$",
                    next: "start"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "regex": [
                {
                    token: "regexp.keyword.operator",
                    regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
                },
                {
                    token: "string.regexp",
                    regex: "/[sxngimy]*",
                    next: "no_regex"
                },
                {
                    token: "invalid",
                    regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
                },
                {
                    token: "constant.language.escape",
                    regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
                },
                {
                    token: "constant.language.delimiter",
                    regex: /\|/
                },
                {
                    token: "constant.language.escape",
                    regex: /\[\^?/,
                    next: "regex_character_class"
                },
                {
                    token: "empty",
                    regex: "$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string.regexp"
                }
            ],
            "regex_character_class": [
                {
                    token: "regexp.charclass.keyword.operator",
                    regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
                },
                {
                    token: "constant.language.escape",
                    regex: "]",
                    next: "regex"
                },
                {
                    token: "constant.language.escape",
                    regex: "-"
                },
                {
                    token: "empty",
                    regex: "$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string.regexp.charachterclass"
                }
            ],
            "default_parameter": [
                {
                    token: "string",
                    regex: "'(?=.)",
                    push: [
                        {
                            token: "string",
                            regex: "'|$",
                            next: "pop"
                        },
                        {
                            include: "qstring"
                        }
                    ]
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    push: [
                        {
                            token: "string",
                            regex: '"|$',
                            next: "pop"
                        },
                        {
                            include: "qqstring"
                        }
                    ]
                },
                {
                    token: "constant.language",
                    regex: "null|Infinity|NaN|undefined"
                },
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
                },
                {
                    token: "constant.numeric",
                    regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
                },
                {
                    token: "punctuation.operator",
                    regex: ",",
                    next: "function_arguments"
                },
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.operator",
                    regex: "$"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "function_arguments": [
                comments("function_arguments"),
                {
                    token: "variable.parameter",
                    regex: identifierRe
                },
                {
                    token: "punctuation.operator",
                    regex: ","
                },
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.operator",
                    regex: "$"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "qqstring": [
                {
                    token: "constant.language.escape",
                    regex: escapedRe
                },
                {
                    token: "string",
                    regex: "\\\\$",
                    consumeLineEnd: true
                },
                {
                    token: "string",
                    regex: '"|$',
                    next: "no_regex"
                },
                {
                    defaultToken: "string"
                }
            ],
            "qstring": [
                {
                    token: "constant.language.escape",
                    regex: escapedRe
                },
                {
                    token: "string",
                    regex: "\\\\$",
                    consumeLineEnd: true
                },
                {
                    token: "string",
                    regex: "'|$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string"
                }
            ]
        };
        if (!options || !options.noES6) {
            this.$rules.no_regex.unshift({
                regex: "[{}]",
                onMatch: function(val, state, stack) {
                    this.next = val == "{" ? this.nextState : "";
                    if (val == "{" && stack.length) stack.unshift("start", state);
                    else if (val == "}" && stack.length) {
                        stack.shift();
                        this.next = stack.shift();
                        if (this.next.indexOf("string") != -1 || this.next.indexOf("jsx") != -1) return "paren.quasi.end";
                    }
                    return val == "{" ? "paren.lparen" : "paren.rparen";
                },
                nextState: "start"
            }, {
                token: "string.quasi.start",
                regex: /`/,
                push: [
                    {
                        token: "constant.language.escape",
                        regex: escapedRe
                    },
                    {
                        token: "paren.quasi.start",
                        regex: /\${/,
                        push: "start"
                    },
                    {
                        token: "string.quasi.end",
                        regex: /`/,
                        next: "pop"
                    },
                    {
                        defaultToken: "string.quasi"
                    }
                ]
            }, {
                token: [
                    "variable.parameter",
                    "text"
                ],
                regex: "(" + identifierRe + ")(\\s*)(?=\\=>)"
            }, {
                token: "paren.lparen",
                regex: "(\\()(?=[^\\(]+\\s*=>)",
                next: "function_arguments"
            }, {
                token: "variable.language",
                regex: "(?:(?:(?:Weak)?(?:Set|Map))|Promise)\\b"
            });
            this.$rules["function_arguments"].unshift({
                token: "keyword.operator",
                regex: "=",
                next: "default_parameter"
            }, {
                token: "keyword.operator",
                regex: "\\.{3}"
            });
            this.$rules["property"].unshift({
                token: "support.function",
                regex: "(findIndex|repeat|startsWith|endsWith|includes|isSafeInteger|trunc|cbrt|log2|log10|sign|then|catch|finally|resolve|reject|race|any|all|allSettled|keys|entries|isInteger)\\b(?=\\()"
            }, {
                token: "constant.language",
                regex: "(?:MAX_SAFE_INTEGER|MIN_SAFE_INTEGER|EPSILON)\\b"
            });
            if (!options || options.jsx != false) JSX.call(this);
        }
        this.embedRules(DocCommentHighlightRules, "doc-", [
            DocCommentHighlightRules.getEndRule("no_regex")
        ]);
        this.normalizeRules();
    };
    oop.inherits(JavaScriptHighlightRules, TextHighlightRules);
    function JSX() {
        var tagRegex = identifierRe.replace("\\d", "\\d\\-");
        var jsxTag = {
            onMatch: function(val, state, stack) {
                var offset = val.charAt(1) == "/" ? 2 : 1;
                if (offset == 1) {
                    if (state != this.nextState) stack.unshift(this.next, this.nextState, 0);
                    else stack.unshift(this.next);
                    stack[2]++;
                } else if (offset == 2) {
                    if (state == this.nextState) {
                        stack[1]--;
                        if (!stack[1] || stack[1] < 0) {
                            stack.shift();
                            stack.shift();
                        }
                    }
                }
                return [
                    {
                        type: "meta.tag.punctuation." + (offset == 1 ? "" : "end-") + "tag-open.xml",
                        value: val.slice(0, offset)
                    },
                    {
                        type: "meta.tag.tag-name.xml",
                        value: val.substr(offset)
                    }
                ];
            },
            regex: "</?(?:" + tagRegex + "|(?=>))",
            next: "jsxAttributes",
            nextState: "jsx"
        };
        this.$rules.start.unshift(jsxTag);
        var jsxJsRule = {
            regex: "{",
            token: "paren.quasi.start",
            push: "start"
        };
        this.$rules.jsx = [
            jsxJsRule,
            jsxTag,
            {
                include: "reference"
            },
            {
                defaultToken: "string.xml"
            }
        ];
        this.$rules.jsxAttributes = [
            {
                token: "meta.tag.punctuation.tag-close.xml",
                regex: "/?>",
                onMatch: function(value, currentState, stack) {
                    if (currentState == stack[0]) stack.shift();
                    if (value.length == 2) {
                        if (stack[0] == this.nextState) stack[1]--;
                        if (!stack[1] || stack[1] < 0) stack.splice(0, 2);
                    }
                    this.next = stack[0] || "start";
                    return [
                        {
                            type: this.token,
                            value: value
                        }
                    ];
                },
                nextState: "jsx"
            },
            jsxJsRule,
            comments("jsxAttributes"),
            {
                token: "entity.other.attribute-name.xml",
                regex: tagRegex
            },
            {
                token: "keyword.operator.attribute-equals.xml",
                regex: "="
            },
            {
                token: "text.tag-whitespace.xml",
                regex: "\\s+"
            },
            {
                token: "string.attribute-value.xml",
                regex: "'",
                stateName: "jsx_attr_q",
                push: [
                    {
                        token: "string.attribute-value.xml",
                        regex: "'",
                        next: "pop"
                    },
                    {
                        include: "reference"
                    },
                    {
                        defaultToken: "string.attribute-value.xml"
                    }
                ]
            },
            {
                token: "string.attribute-value.xml",
                regex: '"',
                stateName: "jsx_attr_qq",
                push: [
                    {
                        token: "string.attribute-value.xml",
                        regex: '"',
                        next: "pop"
                    },
                    {
                        include: "reference"
                    },
                    {
                        defaultToken: "string.attribute-value.xml"
                    }
                ]
            },
            jsxTag
        ];
        this.$rules.reference = [
            {
                token: "constant.language.escape.reference.xml",
                regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
            }
        ];
    }
    function comments(next) {
        return [
            {
                token: "comment",
                regex: /\/\*/,
                next: [
                    DocCommentHighlightRules.getTagRule(),
                    {
                        token: "comment",
                        regex: "\\*\\/",
                        next: next || "pop"
                    },
                    {
                        defaultToken: "comment",
                        caseInsensitive: true
                    }
                ]
            },
            {
                token: "comment",
                regex: "\\/\\/",
                next: [
                    DocCommentHighlightRules.getTagRule(),
                    {
                        token: "comment",
                        regex: "$|^",
                        next: next || "pop"
                    },
                    {
                        defaultToken: "comment",
                        caseInsensitive: true
                    }
                ]
            }
        ];
    }
    exports.JavaScriptHighlightRules = JavaScriptHighlightRules;
});
ace.define("ace/mode/matching_brace_outdent", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var MatchingBraceOutdent = function() {};
    (function() {
        this.checkOutdent = function(line, input) {
            if (!/^\s+$/.test(line)) return false;
            return /^\s*\}/.test(input);
        };
        this.autoOutdent = function(doc, row) {
            var line = doc.getLine(row);
            var match = line.match(/^(\s*\})/);
            if (!match) return 0;
            var column = match[1].length;
            var openBracePos = doc.findMatchingBracket({
                row: row,
                column: column
            });
            if (!openBracePos || openBracePos.row == row) return 0;
            var indent = this.$getIndent(doc.getLine(openBracePos.row));
            doc.replace(new Range(row, 0, row, column - 1), indent);
        };
        this.$getIndent = function(line) {
            return line.match(/^\s*/)[0];
        };
    }).call(MatchingBraceOutdent.prototype);
    exports.MatchingBraceOutdent = MatchingBraceOutdent;
});
ace.define("ace/mode/behaviour/xml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/behaviour",
    "ace/token_iterator"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Behaviour = require("../behaviour").Behaviour;
    var TokenIterator = require("../../token_iterator").TokenIterator;
    function is(token, type) {
        return token && token.type.lastIndexOf(type + ".xml") > -1;
    }
    var XmlBehaviour = function() {
        this.add("string_dquotes", "insertion", function(state, action, editor, session, text) {
            if (text == '"' || text == "'") {
                var quote = text;
                var selected = session.doc.getTextRange(editor.getSelectionRange());
                if (selected !== "" && selected !== "'" && selected != '"' && editor.getWrapBehavioursEnabled()) return {
                    text: quote + selected + quote,
                    selection: false
                };
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (rightChar == quote && (is(token, "attribute-value") || is(token, "string"))) return {
                    text: "",
                    selection: [
                        1,
                        1
                    ]
                };
                if (!token) token = iterator.stepBackward();
                if (!token) return;
                while(is(token, "tag-whitespace") || is(token, "whitespace"))token = iterator.stepBackward();
                var rightSpace = !rightChar || rightChar.match(/\s/);
                if (is(token, "attribute-equals") && (rightSpace || rightChar == ">") || is(token, "decl-attribute-equals") && (rightSpace || rightChar == "?")) return {
                    text: quote + quote,
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("string_dquotes", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && (selected == '"' || selected == "'")) {
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
                if (rightChar == selected) {
                    range.end.column++;
                    return range;
                }
            }
        });
        this.add("autoclosing", "insertion", function(state, action, editor, session, text) {
            if (text == ">") {
                var position = editor.getSelectionRange().start;
                var iterator = new TokenIterator(session, position.row, position.column);
                var token = iterator.getCurrentToken() || iterator.stepBackward();
                if (!token || !(is(token, "tag-name") || is(token, "tag-whitespace") || is(token, "attribute-name") || is(token, "attribute-equals") || is(token, "attribute-value"))) return;
                if (is(token, "reference.attribute-value")) return;
                if (is(token, "attribute-value")) {
                    var tokenEndColumn = iterator.getCurrentTokenColumn() + token.value.length;
                    if (position.column < tokenEndColumn) return;
                    if (position.column == tokenEndColumn) {
                        var nextToken = iterator.stepForward();
                        if (nextToken && is(nextToken, "attribute-value")) return;
                        iterator.stepBackward();
                    }
                }
                if (/^\s*>/.test(session.getLine(position.row).slice(position.column))) return;
                while(!is(token, "tag-name")){
                    token = iterator.stepBackward();
                    if (token.value == "<") {
                        token = iterator.stepForward();
                        break;
                    }
                }
                var tokenRow = iterator.getCurrentTokenRow();
                var tokenColumn = iterator.getCurrentTokenColumn();
                if (is(iterator.stepBackward(), "end-tag-open")) return;
                var element = token.value;
                if (tokenRow == position.row) element = element.substring(0, position.column - tokenColumn);
                if (this.voidElements && this.voidElements.hasOwnProperty(element.toLowerCase())) return;
                return {
                    text: "></" + element + ">",
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("autoindent", "insertion", function(state, action, editor, session, text) {
            if (text == "\n") {
                var cursor = editor.getCursorPosition();
                var line = session.getLine(cursor.row);
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (is(token, "") && token.type.indexOf("tag-close") !== -1) {
                    if (token.value == "/>") return;
                    while(token && token.type.indexOf("tag-name") === -1)token = iterator.stepBackward();
                    if (!token) return;
                    var tag = token.value;
                    var row = iterator.getCurrentTokenRow();
                    token = iterator.stepBackward();
                    if (!token || token.type.indexOf("end-tag") !== -1) return;
                    if (this.voidElements && !this.voidElements[tag] || !this.voidElements) {
                        var nextToken = session.getTokenAt(cursor.row, cursor.column + 1);
                        var line = session.getLine(row);
                        var nextIndent = this.$getIndent(line);
                        var indent = nextIndent + session.getTabString();
                        if (nextToken && nextToken.value === "</") return {
                            text: "\n" + indent + "\n" + nextIndent,
                            selection: [
                                1,
                                indent.length,
                                1,
                                indent.length
                            ]
                        };
                        else return {
                            text: "\n" + indent
                        };
                    }
                }
            }
        });
    };
    oop.inherits(XmlBehaviour, Behaviour);
    exports.XmlBehaviour = XmlBehaviour;
});
ace.define("ace/mode/behaviour/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/token_iterator",
    "ace/mode/behaviour/cstyle",
    "ace/mode/behaviour/xml"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var TokenIterator = require("../../token_iterator").TokenIterator;
    var CstyleBehaviour = require("../behaviour/cstyle").CstyleBehaviour;
    var XmlBehaviour = require("../behaviour/xml").XmlBehaviour;
    var JavaScriptBehaviour = function() {
        var xmlBehaviours = new XmlBehaviour({
            closeCurlyBraces: true
        }).getBehaviours();
        this.addBehaviours(xmlBehaviours);
        this.inherit(CstyleBehaviour);
        this.add("autoclosing-fragment", "insertion", function(state, action, editor, session, text) {
            if (text == ">") {
                var position = editor.getSelectionRange().start;
                var iterator = new TokenIterator(session, position.row, position.column);
                var token = iterator.getCurrentToken() || iterator.stepBackward();
                if (!token) return;
                if (token.value == "<") return {
                    text: "></>",
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
    };
    oop.inherits(JavaScriptBehaviour, CstyleBehaviour);
    exports.JavaScriptBehaviour = JavaScriptBehaviour;
});
ace.define("ace/mode/folding/xml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(voidElements, optionalEndTags) {
        BaseFoldMode.call(this);
        this.voidElements = voidElements || {};
        this.optionalEndTags = oop.mixin({}, this.voidElements);
        if (optionalEndTags) oop.mixin(this.optionalEndTags, optionalEndTags);
    };
    oop.inherits(FoldMode, BaseFoldMode);
    var Tag = function() {
        this.tagName = "";
        this.closing = false;
        this.selfClosing = false;
        this.start = {
            row: 0,
            column: 0
        };
        this.end = {
            row: 0,
            column: 0
        };
    };
    function is(token, type) {
        return token.type.lastIndexOf(type + ".xml") > -1;
    }
    (function() {
        this.getFoldWidget = function(session, foldStyle, row) {
            var tag = this._getFirstTagInLine(session, row);
            if (!tag) return this.getCommentFoldWidget(session, row);
            if (tag.closing || !tag.tagName && tag.selfClosing) return foldStyle === "markbeginend" ? "end" : "";
            if (!tag.tagName || tag.selfClosing || this.voidElements.hasOwnProperty(tag.tagName.toLowerCase())) return "";
            if (this._findEndTagInLine(session, row, tag.tagName, tag.end.column)) return "";
            return "start";
        };
        this.getCommentFoldWidget = function(session, row) {
            if (/comment/.test(session.getState(row)) && /<!-/.test(session.getLine(row))) return "start";
            return "";
        };
        this._getFirstTagInLine = function(session, row) {
            var tokens = session.getTokens(row);
            var tag = new Tag();
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                if (is(token, "tag-open")) {
                    tag.end.column = tag.start.column + token.value.length;
                    tag.closing = is(token, "end-tag-open");
                    token = tokens[++i];
                    if (!token) return null;
                    tag.tagName = token.value;
                    if (token.value === "") {
                        token = tokens[++i];
                        if (!token) return null;
                        tag.tagName = token.value;
                    }
                    tag.end.column += token.value.length;
                    for(i++; i < tokens.length; i++){
                        token = tokens[i];
                        tag.end.column += token.value.length;
                        if (is(token, "tag-close")) {
                            tag.selfClosing = token.value == "/>";
                            break;
                        }
                    }
                    return tag;
                } else if (is(token, "tag-close")) {
                    tag.selfClosing = token.value == "/>";
                    return tag;
                }
                tag.start.column += token.value.length;
            }
            return null;
        };
        this._findEndTagInLine = function(session, row, tagName, startColumn) {
            var tokens = session.getTokens(row);
            var column = 0;
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                column += token.value.length;
                if (column < startColumn - 1) continue;
                if (is(token, "end-tag-open")) {
                    token = tokens[i + 1];
                    if (is(token, "tag-name") && token.value === "") token = tokens[i + 2];
                    if (token && token.value == tagName) return true;
                }
            }
            return false;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            var firstTag = this._getFirstTagInLine(session, row);
            if (!firstTag) return this.getCommentFoldWidget(session, row) && session.getCommentFoldRange(row, session.getLine(row).length);
            var tags = session.getMatchingTags({
                row: row,
                column: 0
            });
            if (tags) return new Range(tags.openTag.end.row, tags.openTag.end.column, tags.closeTag.start.row, tags.closeTag.start.column);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/folding/cstyle", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
    };
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
        this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
        this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
        this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
        this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
        this._getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            if (this.singleLineBlockCommentRe.test(line)) {
                if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line)) return "";
            }
            var fw = this._getFoldWidgetBase(session, foldStyle, row);
            if (!fw && this.startRegionRe.test(line)) return "start"; // lineCommentRegionStart
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var line = session.getLine(row);
            if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
            var match = line.match(this.foldingStartMarker);
            if (match) {
                var i = match.index;
                if (match[1]) return this.openingBracketBlock(session, match[1], row, i);
                var range = session.getCommentFoldRange(row, i + match[0].length, 1);
                if (range && !range.isMultiLine()) {
                    if (forceMultiline) range = this.getSectionRange(session, row);
                    else if (foldStyle != "all") range = null;
                }
                return range;
            }
            if (foldStyle === "markbegin") return;
            var match = line.match(this.foldingStopMarker);
            if (match) {
                var i = match.index + match[0].length;
                if (match[1]) return this.closingBracketBlock(session, match[1], row, i);
                return session.getCommentFoldRange(row, i, -1);
            }
        };
        this.getSectionRange = function(session, row) {
            var line = session.getLine(row);
            var startIndent = line.search(/\S/);
            var startRow = row;
            var startColumn = line.length;
            row = row + 1;
            var endRow = row;
            var maxRow = session.getLength();
            while(++row < maxRow){
                line = session.getLine(row);
                var indent = line.search(/\S/);
                if (indent === -1) continue;
                if (startIndent > indent) break;
                var subRange = this.getFoldWidgetRange(session, "all", row);
                if (subRange) {
                    if (subRange.start.row <= startRow) break;
                    else if (subRange.isMultiLine()) row = subRange.end.row;
                    else if (startIndent == indent) break;
                }
                endRow = row;
            }
            return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
        };
        this.getCommentRegionBlock = function(session, line, row) {
            var startColumn = line.search(/\s*$/);
            var maxRow = session.getLength();
            var startRow = row;
            var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
            var depth = 1;
            while(++row < maxRow){
                line = session.getLine(row);
                var m = re.exec(line);
                if (!m) continue;
                if (m[1]) depth--;
                else depth++;
                if (!depth) break;
            }
            var endRow = row;
            if (endRow > startRow) return new Range(startRow, startColumn, endRow, line.length);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/folding/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/folding/xml",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var XmlFoldMode = require("./xml").FoldMode;
    var CFoldMode = require("./cstyle").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
        this.xmlFoldMode = new XmlFoldMode();
    };
    oop.inherits(FoldMode, CFoldMode);
    (function() {
        this.getFoldWidgetRangeBase = this.getFoldWidgetRange;
        this.getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var fw = this.getFoldWidgetBase(session, foldStyle, row);
            if (!fw) return this.xmlFoldMode.getFoldWidget(session, foldStyle, row);
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var range = this.getFoldWidgetRangeBase(session, foldStyle, row, forceMultiline);
            if (range) return range;
            return this.xmlFoldMode.getFoldWidgetRange(session, foldStyle, row);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/javascript_highlight_rules",
    "ace/mode/matching_brace_outdent",
    "ace/worker/worker_client",
    "ace/mode/behaviour/javascript",
    "ace/mode/folding/javascript"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var JavaScriptHighlightRules = require("./javascript_highlight_rules").JavaScriptHighlightRules;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var JavaScriptBehaviour = require("./behaviour/javascript").JavaScriptBehaviour;
    var JavaScriptFoldMode = require("./folding/javascript").FoldMode;
    var Mode = function() {
        this.HighlightRules = JavaScriptHighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.$behaviour = new JavaScriptBehaviour();
        this.foldingRules = new JavaScriptFoldMode();
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.lineCommentStart = "//";
        this.blockComment = {
            start: "/*",
            end: "*/"
        };
        this.$quotes = {
            '"': '"',
            "'": "'",
            "`": "`"
        };
        this.$pairQuotesAfter = {
            "`": /\w/
        };
        this.getNextLineIndent = function(state, line, tab) {
            var indent = this.$getIndent(line);
            var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
            var tokens = tokenizedLine.tokens;
            var endState = tokenizedLine.state;
            if (tokens.length && tokens[tokens.length - 1].type == "comment") return indent;
            if (state == "start" || state == "no_regex") {
                var match = line.match(/^.*(?:\bcase\b.*:|[\{\(\[])\s*$/);
                if (match) indent += tab;
            } else if (state == "doc-start") {
                if (endState == "start" || endState == "no_regex") return "";
            }
            return indent;
        };
        this.checkOutdent = function(state, line, input) {
            return this.$outdent.checkOutdent(line, input);
        };
        this.autoOutdent = function(state, doc, row) {
            this.$outdent.autoOutdent(doc, row);
        };
        this.createWorker = function(session) {
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/javascript_worker", "JavaScriptWorker");
            worker.attachToDocument(session.getDocument());
            worker.on("annotate", function(results) {
                session.setAnnotations(results.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/javascript";
        this.snippetFileId = "ace/snippets/javascript";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/javascript"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("8oQ7S", function(module, exports) {
ace.define("ace/mode/json_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var JsonHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: "variable",
                    regex: '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]\\s*(?=:)'
                },
                {
                    token: "string",
                    regex: '"',
                    next: "string"
                },
                {
                    token: "constant.numeric",
                    regex: "0[xX][0-9a-fA-F]+\\b"
                },
                {
                    token: "constant.numeric",
                    regex: "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
                },
                {
                    token: "constant.language.boolean",
                    regex: "(?:true|false)\\b"
                },
                {
                    token: "text",
                    regex: "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
                },
                {
                    token: "comment",
                    regex: "\\/\\/.*$"
                },
                {
                    token: "comment.start",
                    regex: "\\/\\*",
                    next: "comment"
                },
                {
                    token: "paren.lparen",
                    regex: "[[({]"
                },
                {
                    token: "paren.rparen",
                    regex: "[\\])}]"
                },
                {
                    token: "punctuation.operator",
                    regex: /[,]/
                },
                {
                    token: "text",
                    regex: "\\s+"
                }
            ],
            "string": [
                {
                    token: "constant.language.escape",
                    regex: /\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\\\/bfnrt])/
                },
                {
                    token: "string",
                    regex: '"|$',
                    next: "start"
                },
                {
                    defaultToken: "string"
                }
            ],
            "comment": [
                {
                    token: "comment.end",
                    regex: "\\*\\/",
                    next: "start"
                },
                {
                    defaultToken: "comment"
                }
            ]
        };
    };
    oop.inherits(JsonHighlightRules, TextHighlightRules);
    exports.JsonHighlightRules = JsonHighlightRules;
});
ace.define("ace/mode/matching_brace_outdent", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var MatchingBraceOutdent = function() {};
    (function() {
        this.checkOutdent = function(line, input) {
            if (!/^\s+$/.test(line)) return false;
            return /^\s*\}/.test(input);
        };
        this.autoOutdent = function(doc, row) {
            var line = doc.getLine(row);
            var match = line.match(/^(\s*\})/);
            if (!match) return 0;
            var column = match[1].length;
            var openBracePos = doc.findMatchingBracket({
                row: row,
                column: column
            });
            if (!openBracePos || openBracePos.row == row) return 0;
            var indent = this.$getIndent(doc.getLine(openBracePos.row));
            doc.replace(new Range(row, 0, row, column - 1), indent);
        };
        this.$getIndent = function(line) {
            return line.match(/^\s*/)[0];
        };
    }).call(MatchingBraceOutdent.prototype);
    exports.MatchingBraceOutdent = MatchingBraceOutdent;
});
ace.define("ace/mode/folding/cstyle", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
    };
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
        this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
        this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
        this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
        this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
        this._getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            if (this.singleLineBlockCommentRe.test(line)) {
                if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line)) return "";
            }
            var fw = this._getFoldWidgetBase(session, foldStyle, row);
            if (!fw && this.startRegionRe.test(line)) return "start"; // lineCommentRegionStart
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var line = session.getLine(row);
            if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
            var match = line.match(this.foldingStartMarker);
            if (match) {
                var i = match.index;
                if (match[1]) return this.openingBracketBlock(session, match[1], row, i);
                var range = session.getCommentFoldRange(row, i + match[0].length, 1);
                if (range && !range.isMultiLine()) {
                    if (forceMultiline) range = this.getSectionRange(session, row);
                    else if (foldStyle != "all") range = null;
                }
                return range;
            }
            if (foldStyle === "markbegin") return;
            var match = line.match(this.foldingStopMarker);
            if (match) {
                var i = match.index + match[0].length;
                if (match[1]) return this.closingBracketBlock(session, match[1], row, i);
                return session.getCommentFoldRange(row, i, -1);
            }
        };
        this.getSectionRange = function(session, row) {
            var line = session.getLine(row);
            var startIndent = line.search(/\S/);
            var startRow = row;
            var startColumn = line.length;
            row = row + 1;
            var endRow = row;
            var maxRow = session.getLength();
            while(++row < maxRow){
                line = session.getLine(row);
                var indent = line.search(/\S/);
                if (indent === -1) continue;
                if (startIndent > indent) break;
                var subRange = this.getFoldWidgetRange(session, "all", row);
                if (subRange) {
                    if (subRange.start.row <= startRow) break;
                    else if (subRange.isMultiLine()) row = subRange.end.row;
                    else if (startIndent == indent) break;
                }
                endRow = row;
            }
            return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
        };
        this.getCommentRegionBlock = function(session, line, row) {
            var startColumn = line.search(/\s*$/);
            var maxRow = session.getLength();
            var startRow = row;
            var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
            var depth = 1;
            while(++row < maxRow){
                line = session.getLine(row);
                var m = re.exec(line);
                if (!m) continue;
                if (m[1]) depth--;
                else depth++;
                if (!depth) break;
            }
            var endRow = row;
            if (endRow > startRow) return new Range(startRow, startColumn, endRow, line.length);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/json", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/json_highlight_rules",
    "ace/mode/matching_brace_outdent",
    "ace/mode/folding/cstyle",
    "ace/worker/worker_client"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var HighlightRules = require("./json_highlight_rules").JsonHighlightRules;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var CStyleFoldMode = require("./folding/cstyle").FoldMode;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var Mode = function() {
        this.HighlightRules = HighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.$behaviour = this.$defaultBehaviour;
        this.foldingRules = new CStyleFoldMode();
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.lineCommentStart = "//";
        this.blockComment = {
            start: "/*",
            end: "*/"
        };
        this.getNextLineIndent = function(state, line, tab) {
            var indent = this.$getIndent(line);
            if (state == "start") {
                var match = line.match(/^.*[\{\(\[]\s*$/);
                if (match) indent += tab;
            }
            return indent;
        };
        this.checkOutdent = function(state, line, input) {
            return this.$outdent.checkOutdent(line, input);
        };
        this.autoOutdent = function(state, doc, row) {
            this.$outdent.autoOutdent(doc, row);
        };
        this.createWorker = function(session) {
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/json_worker", "JsonWorker");
            worker.attachToDocument(session.getDocument());
            worker.on("annotate", function(e) {
                session.setAnnotations(e.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/json";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/json"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("aShYl", function(module, exports) {
ace.define("ace/mode/json_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var JsonHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: "variable",
                    regex: '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]\\s*(?=:)'
                },
                {
                    token: "string",
                    regex: '"',
                    next: "string"
                },
                {
                    token: "constant.numeric",
                    regex: "0[xX][0-9a-fA-F]+\\b"
                },
                {
                    token: "constant.numeric",
                    regex: "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
                },
                {
                    token: "constant.language.boolean",
                    regex: "(?:true|false)\\b"
                },
                {
                    token: "text",
                    regex: "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
                },
                {
                    token: "comment",
                    regex: "\\/\\/.*$"
                },
                {
                    token: "comment.start",
                    regex: "\\/\\*",
                    next: "comment"
                },
                {
                    token: "paren.lparen",
                    regex: "[[({]"
                },
                {
                    token: "paren.rparen",
                    regex: "[\\])}]"
                },
                {
                    token: "punctuation.operator",
                    regex: /[,]/
                },
                {
                    token: "text",
                    regex: "\\s+"
                }
            ],
            "string": [
                {
                    token: "constant.language.escape",
                    regex: /\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\\\/bfnrt])/
                },
                {
                    token: "string",
                    regex: '"|$',
                    next: "start"
                },
                {
                    defaultToken: "string"
                }
            ],
            "comment": [
                {
                    token: "comment.end",
                    regex: "\\*\\/",
                    next: "start"
                },
                {
                    defaultToken: "comment"
                }
            ]
        };
    };
    oop.inherits(JsonHighlightRules, TextHighlightRules);
    exports.JsonHighlightRules = JsonHighlightRules;
});
ace.define("ace/mode/json5_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/json_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var JsonHighlightRules = require("./json_highlight_rules").JsonHighlightRules;
    var Json5HighlightRules = function() {
        JsonHighlightRules.call(this);
        var startRules = [
            {
                token: "variable",
                regex: /[a-zA-Z$_\u00a1-\uffff][\w$\u00a1-\uffff]*\s*(?=:)/
            },
            {
                token: "variable",
                regex: /['](?:(?:\\.)|(?:[^'\\]))*?[']\s*(?=:)/
            },
            {
                token: "constant.language.boolean",
                regex: /(?:null)\b/
            },
            {
                token: "string",
                regex: /'/,
                next: [
                    {
                        token: "constant.language.escape",
                        regex: /\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\/bfnrt]|$)/,
                        consumeLineEnd: true
                    },
                    {
                        token: "string",
                        regex: /'|$/,
                        next: "start"
                    },
                    {
                        defaultToken: "string"
                    }
                ]
            },
            {
                token: "string",
                regex: /"(?![^"]*":)/,
                next: [
                    {
                        token: "constant.language.escape",
                        regex: /\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\/bfnrt]|$)/,
                        consumeLineEnd: true
                    },
                    {
                        token: "string",
                        regex: /"|$/,
                        next: "start"
                    },
                    {
                        defaultToken: "string"
                    }
                ]
            },
            {
                token: "constant.numeric",
                regex: /[+-]?(?:Infinity|NaN)\b/
            }
        ];
        for(var key in this.$rules)this.$rules[key].unshift.apply(this.$rules[key], startRules);
        this.normalizeRules();
    };
    oop.inherits(Json5HighlightRules, JsonHighlightRules);
    exports.Json5HighlightRules = Json5HighlightRules;
});
ace.define("ace/mode/matching_brace_outdent", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var MatchingBraceOutdent = function() {};
    (function() {
        this.checkOutdent = function(line, input) {
            if (!/^\s+$/.test(line)) return false;
            return /^\s*\}/.test(input);
        };
        this.autoOutdent = function(doc, row) {
            var line = doc.getLine(row);
            var match = line.match(/^(\s*\})/);
            if (!match) return 0;
            var column = match[1].length;
            var openBracePos = doc.findMatchingBracket({
                row: row,
                column: column
            });
            if (!openBracePos || openBracePos.row == row) return 0;
            var indent = this.$getIndent(doc.getLine(openBracePos.row));
            doc.replace(new Range(row, 0, row, column - 1), indent);
        };
        this.$getIndent = function(line) {
            return line.match(/^\s*/)[0];
        };
    }).call(MatchingBraceOutdent.prototype);
    exports.MatchingBraceOutdent = MatchingBraceOutdent;
});
ace.define("ace/mode/folding/cstyle", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
    };
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
        this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
        this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
        this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
        this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
        this._getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            if (this.singleLineBlockCommentRe.test(line)) {
                if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line)) return "";
            }
            var fw = this._getFoldWidgetBase(session, foldStyle, row);
            if (!fw && this.startRegionRe.test(line)) return "start"; // lineCommentRegionStart
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var line = session.getLine(row);
            if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
            var match = line.match(this.foldingStartMarker);
            if (match) {
                var i = match.index;
                if (match[1]) return this.openingBracketBlock(session, match[1], row, i);
                var range = session.getCommentFoldRange(row, i + match[0].length, 1);
                if (range && !range.isMultiLine()) {
                    if (forceMultiline) range = this.getSectionRange(session, row);
                    else if (foldStyle != "all") range = null;
                }
                return range;
            }
            if (foldStyle === "markbegin") return;
            var match = line.match(this.foldingStopMarker);
            if (match) {
                var i = match.index + match[0].length;
                if (match[1]) return this.closingBracketBlock(session, match[1], row, i);
                return session.getCommentFoldRange(row, i, -1);
            }
        };
        this.getSectionRange = function(session, row) {
            var line = session.getLine(row);
            var startIndent = line.search(/\S/);
            var startRow = row;
            var startColumn = line.length;
            row = row + 1;
            var endRow = row;
            var maxRow = session.getLength();
            while(++row < maxRow){
                line = session.getLine(row);
                var indent = line.search(/\S/);
                if (indent === -1) continue;
                if (startIndent > indent) break;
                var subRange = this.getFoldWidgetRange(session, "all", row);
                if (subRange) {
                    if (subRange.start.row <= startRow) break;
                    else if (subRange.isMultiLine()) row = subRange.end.row;
                    else if (startIndent == indent) break;
                }
                endRow = row;
            }
            return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
        };
        this.getCommentRegionBlock = function(session, line, row) {
            var startColumn = line.search(/\s*$/);
            var maxRow = session.getLength();
            var startRow = row;
            var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
            var depth = 1;
            while(++row < maxRow){
                line = session.getLine(row);
                var m = re.exec(line);
                if (!m) continue;
                if (m[1]) depth--;
                else depth++;
                if (!depth) break;
            }
            var endRow = row;
            if (endRow > startRow) return new Range(startRow, startColumn, endRow, line.length);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/json5", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/json5_highlight_rules",
    "ace/mode/matching_brace_outdent",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var HighlightRules = require("./json5_highlight_rules").Json5HighlightRules;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var CStyleFoldMode = require("./folding/cstyle").FoldMode;
    var Mode = function() {
        this.HighlightRules = HighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.$behaviour = this.$defaultBehaviour;
        this.foldingRules = new CStyleFoldMode();
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.lineCommentStart = "//";
        this.blockComment = {
            start: "/*",
            end: "*/"
        };
        this.checkOutdent = function(state, line, input) {
            return this.$outdent.checkOutdent(line, input);
        };
        this.autoOutdent = function(state, doc, row) {
            this.$outdent.autoOutdent(doc, row);
        };
        this.$id = "ace/mode/json5";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/json5"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("gba37", function(module, exports) {
ace.define("ace/mode/css_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var lang = require("../lib/lang");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var supportType = exports.supportType = "align-content|align-items|align-self|all|animation|animation-delay|animation-direction|animation-duration|animation-fill-mode|animation-iteration-count|animation-name|animation-play-state|animation-timing-function|backface-visibility|background|background-attachment|background-blend-mode|background-clip|background-color|background-image|background-origin|background-position|background-repeat|background-size|border|border-bottom|border-bottom-color|border-bottom-left-radius|border-bottom-right-radius|border-bottom-style|border-bottom-width|border-collapse|border-color|border-image|border-image-outset|border-image-repeat|border-image-slice|border-image-source|border-image-width|border-left|border-left-color|border-left-style|border-left-width|border-radius|border-right|border-right-color|border-right-style|border-right-width|border-spacing|border-style|border-top|border-top-color|border-top-left-radius|border-top-right-radius|border-top-style|border-top-width|border-width|bottom|box-shadow|box-sizing|caption-side|clear|clip|color|column-count|column-fill|column-gap|column-rule|column-rule-color|column-rule-style|column-rule-width|column-span|column-width|columns|content|counter-increment|counter-reset|cursor|direction|display|empty-cells|filter|flex|flex-basis|flex-direction|flex-flow|flex-grow|flex-shrink|flex-wrap|float|font|font-family|font-size|font-size-adjust|font-stretch|font-style|font-variant|font-weight|hanging-punctuation|height|justify-content|left|letter-spacing|line-height|list-style|list-style-image|list-style-position|list-style-type|margin|margin-bottom|margin-left|margin-right|margin-top|max-height|max-width|max-zoom|min-height|min-width|min-zoom|nav-down|nav-index|nav-left|nav-right|nav-up|opacity|order|outline|outline-color|outline-offset|outline-style|outline-width|overflow|overflow-x|overflow-y|padding|padding-bottom|padding-left|padding-right|padding-top|page-break-after|page-break-before|page-break-inside|perspective|perspective-origin|position|quotes|resize|right|tab-size|table-layout|text-align|text-align-last|text-decoration|text-decoration-color|text-decoration-line|text-decoration-style|text-indent|text-justify|text-overflow|text-shadow|text-transform|top|transform|transform-origin|transform-style|transition|transition-delay|transition-duration|transition-property|transition-timing-function|unicode-bidi|user-select|user-zoom|vertical-align|visibility|white-space|width|word-break|word-spacing|word-wrap|z-index";
    var supportFunction = exports.supportFunction = "rgb|rgba|url|attr|counter|counters";
    var supportConstant = exports.supportConstant = "absolute|after-edge|after|all-scroll|all|alphabetic|always|antialiased|armenian|auto|avoid-column|avoid-page|avoid|balance|baseline|before-edge|before|below|bidi-override|block-line-height|block|bold|bolder|border-box|both|bottom|box|break-all|break-word|capitalize|caps-height|caption|center|central|char|circle|cjk-ideographic|clone|close-quote|col-resize|collapse|column|consider-shifts|contain|content-box|cover|crosshair|cubic-bezier|dashed|decimal-leading-zero|decimal|default|disabled|disc|disregard-shifts|distribute-all-lines|distribute-letter|distribute-space|distribute|dotted|double|e-resize|ease-in|ease-in-out|ease-out|ease|ellipsis|end|exclude-ruby|flex-end|flex-start|fill|fixed|georgian|glyphs|grid-height|groove|hand|hanging|hebrew|help|hidden|hiragana-iroha|hiragana|horizontal|icon|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space|ideographic|inactive|include-ruby|inherit|initial|inline-block|inline-box|inline-line-height|inline-table|inline|inset|inside|inter-ideograph|inter-word|invert|italic|justify|katakana-iroha|katakana|keep-all|last|left|lighter|line-edge|line-through|line|linear|list-item|local|loose|lower-alpha|lower-greek|lower-latin|lower-roman|lowercase|lr-tb|ltr|mathematical|max-height|max-size|medium|menu|message-box|middle|move|n-resize|ne-resize|newspaper|no-change|no-close-quote|no-drop|no-open-quote|no-repeat|none|normal|not-allowed|nowrap|nw-resize|oblique|open-quote|outset|outside|overline|padding-box|page|pointer|pre-line|pre-wrap|pre|preserve-3d|progress|relative|repeat-x|repeat-y|repeat|replaced|reset-size|ridge|right|round|row-resize|rtl|s-resize|scroll|se-resize|separate|slice|small-caps|small-caption|solid|space|square|start|static|status-bar|step-end|step-start|steps|stretch|strict|sub|super|sw-resize|table-caption|table-cell|table-column-group|table-column|table-footer-group|table-header-group|table-row-group|table-row|table|tb-rl|text-after-edge|text-before-edge|text-bottom|text-size|text-top|text|thick|thin|transparent|underline|upper-alpha|upper-latin|upper-roman|uppercase|use-script|vertical-ideographic|vertical-text|visible|w-resize|wait|whitespace|z-index|zero|zoom";
    var supportConstantColor = exports.supportConstantColor = "aliceblue|antiquewhite|aqua|aquamarine|azure|beige|bisque|black|blanchedalmond|blue|blueviolet|brown|burlywood|cadetblue|chartreuse|chocolate|coral|cornflowerblue|cornsilk|crimson|cyan|darkblue|darkcyan|darkgoldenrod|darkgray|darkgreen|darkgrey|darkkhaki|darkmagenta|darkolivegreen|darkorange|darkorchid|darkred|darksalmon|darkseagreen|darkslateblue|darkslategray|darkslategrey|darkturquoise|darkviolet|deeppink|deepskyblue|dimgray|dimgrey|dodgerblue|firebrick|floralwhite|forestgreen|fuchsia|gainsboro|ghostwhite|gold|goldenrod|gray|green|greenyellow|grey|honeydew|hotpink|indianred|indigo|ivory|khaki|lavender|lavenderblush|lawngreen|lemonchiffon|lightblue|lightcoral|lightcyan|lightgoldenrodyellow|lightgray|lightgreen|lightgrey|lightpink|lightsalmon|lightseagreen|lightskyblue|lightslategray|lightslategrey|lightsteelblue|lightyellow|lime|limegreen|linen|magenta|maroon|mediumaquamarine|mediumblue|mediumorchid|mediumpurple|mediumseagreen|mediumslateblue|mediumspringgreen|mediumturquoise|mediumvioletred|midnightblue|mintcream|mistyrose|moccasin|navajowhite|navy|oldlace|olive|olivedrab|orange|orangered|orchid|palegoldenrod|palegreen|paleturquoise|palevioletred|papayawhip|peachpuff|peru|pink|plum|powderblue|purple|rebeccapurple|red|rosybrown|royalblue|saddlebrown|salmon|sandybrown|seagreen|seashell|sienna|silver|skyblue|slateblue|slategray|slategrey|snow|springgreen|steelblue|tan|teal|thistle|tomato|turquoise|violet|wheat|white|whitesmoke|yellow|yellowgreen";
    var supportConstantFonts = exports.supportConstantFonts = "arial|century|comic|courier|cursive|fantasy|garamond|georgia|helvetica|impact|lucida|symbol|system|tahoma|times|trebuchet|utopia|verdana|webdings|sans-serif|serif|monospace";
    var numRe = exports.numRe = "\\-?(?:(?:[0-9]+(?:\\.[0-9]+)?)|(?:\\.[0-9]+))";
    var pseudoElements = exports.pseudoElements = "(\\:+)\\b(after|before|first-letter|first-line|moz-selection|selection)\\b";
    var pseudoClasses = exports.pseudoClasses = "(:)\\b(active|checked|disabled|empty|enabled|first-child|first-of-type|focus|hover|indeterminate|invalid|last-child|last-of-type|link|not|nth-child|nth-last-child|nth-last-of-type|nth-of-type|only-child|only-of-type|required|root|target|valid|visited)\\b";
    var CssHighlightRules = function() {
        var keywordMapper = this.createKeywordMapper({
            "support.function": supportFunction,
            "support.constant": supportConstant,
            "support.type": supportType,
            "support.constant.color": supportConstantColor,
            "support.constant.fonts": supportConstantFonts
        }, "text", true);
        this.$rules = {
            "start": [
                {
                    include: [
                        "strings",
                        "url",
                        "comments"
                    ]
                },
                {
                    token: "paren.lparen",
                    regex: "\\{",
                    next: "ruleset"
                },
                {
                    token: "paren.rparen",
                    regex: "\\}"
                },
                {
                    token: "string",
                    regex: "@(?!viewport)",
                    next: "media"
                },
                {
                    token: "keyword",
                    regex: "#[a-z0-9-_]+"
                },
                {
                    token: "keyword",
                    regex: "%"
                },
                {
                    token: "variable",
                    regex: "\\.[a-z0-9-_]+"
                },
                {
                    token: "string",
                    regex: ":[a-z0-9-_]+"
                },
                {
                    token: "constant.numeric",
                    regex: numRe
                },
                {
                    token: "constant",
                    regex: "[a-z0-9-_]+"
                },
                {
                    caseInsensitive: true
                }
            ],
            "media": [
                {
                    include: [
                        "strings",
                        "url",
                        "comments"
                    ]
                },
                {
                    token: "paren.lparen",
                    regex: "\\{",
                    next: "start"
                },
                {
                    token: "paren.rparen",
                    regex: "\\}",
                    next: "start"
                },
                {
                    token: "string",
                    regex: ";",
                    next: "start"
                },
                {
                    token: "keyword",
                    regex: "(?:media|supports|document|charset|import|namespace|media|supports|document|page|font|keyframes|viewport|counter-style|font-feature-values|swash|ornaments|annotation|stylistic|styleset|character-variant)"
                }
            ],
            "comments": [
                {
                    token: "comment",
                    regex: "\\/\\*",
                    push: [
                        {
                            token: "comment",
                            regex: "\\*\\/",
                            next: "pop"
                        },
                        {
                            defaultToken: "comment"
                        }
                    ]
                }
            ],
            "ruleset": [
                {
                    regex: "-(webkit|ms|moz|o)-",
                    token: "text"
                },
                {
                    token: "punctuation.operator",
                    regex: "[:;]"
                },
                {
                    token: "paren.rparen",
                    regex: "\\}",
                    next: "start"
                },
                {
                    include: [
                        "strings",
                        "url",
                        "comments"
                    ]
                },
                {
                    token: [
                        "constant.numeric",
                        "keyword"
                    ],
                    regex: "(" + numRe + ")(ch|cm|deg|em|ex|fr|gd|grad|Hz|in|kHz|mm|ms|pc|pt|px|rad|rem|s|turn|vh|vmax|vmin|vm|vw|%)"
                },
                {
                    token: "constant.numeric",
                    regex: numRe
                },
                {
                    token: "constant.numeric",
                    regex: "#[a-f0-9]{6}"
                },
                {
                    token: "constant.numeric",
                    regex: "#[a-f0-9]{3}"
                },
                {
                    token: [
                        "punctuation",
                        "entity.other.attribute-name.pseudo-element.css"
                    ],
                    regex: pseudoElements
                },
                {
                    token: [
                        "punctuation",
                        "entity.other.attribute-name.pseudo-class.css"
                    ],
                    regex: pseudoClasses
                },
                {
                    include: "url"
                },
                {
                    token: keywordMapper,
                    regex: "\\-?[a-zA-Z_][a-zA-Z0-9_\\-]*"
                },
                {
                    token: "paren.lparen",
                    regex: "\\{"
                },
                {
                    caseInsensitive: true
                }
            ],
            url: [
                {
                    token: "support.function",
                    regex: "(?:url(:?-prefix)?|domain|regexp)\\(",
                    push: [
                        {
                            token: "support.function",
                            regex: "\\)",
                            next: "pop"
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                }
            ],
            strings: [
                {
                    token: "string.start",
                    regex: "'",
                    push: [
                        {
                            token: "string.end",
                            regex: "'|$",
                            next: "pop"
                        },
                        {
                            include: "escapes"
                        },
                        {
                            token: "constant.language.escape",
                            regex: /\\$/,
                            consumeLineEnd: true
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                },
                {
                    token: "string.start",
                    regex: '"',
                    push: [
                        {
                            token: "string.end",
                            regex: '"|$',
                            next: "pop"
                        },
                        {
                            include: "escapes"
                        },
                        {
                            token: "constant.language.escape",
                            regex: /\\$/,
                            consumeLineEnd: true
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                }
            ],
            escapes: [
                {
                    token: "constant.language.escape",
                    regex: /\\([a-fA-F\d]{1,6}|[^a-fA-F\d])/
                }
            ]
        };
        this.normalizeRules();
    };
    oop.inherits(CssHighlightRules, TextHighlightRules);
    exports.CssHighlightRules = CssHighlightRules;
});
ace.define("ace/mode/jsdoc_comment_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var JsDocCommentHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: [
                        "comment.doc.tag",
                        "comment.doc.text",
                        "lparen.doc"
                    ],
                    regex: "(@(?:param|member|typedef|property|namespace|var|const|callback))(\\s*)({)",
                    push: [
                        {
                            token: "lparen.doc",
                            regex: "{",
                            push: [
                                {
                                    include: "doc-syntax"
                                },
                                {
                                    token: "rparen.doc",
                                    regex: "}|(?=$)",
                                    next: "pop"
                                }
                            ]
                        },
                        {
                            token: [
                                "rparen.doc",
                                "text.doc",
                                "variable.parameter.doc",
                                "lparen.doc",
                                "variable.parameter.doc",
                                "rparen.doc"
                            ],
                            regex: /(})(\s*)(?:([\w=:\/\.]+)|(?:(\[)([\w=:\/\.\-\'\" ]+)(\])))/,
                            next: "pop"
                        },
                        {
                            token: "rparen.doc",
                            regex: "}|(?=$)",
                            next: "pop"
                        },
                        {
                            include: "doc-syntax"
                        },
                        {
                            defaultToken: "text.doc"
                        }
                    ]
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "lparen.doc"
                    ],
                    regex: "(@(?:returns?|yields|type|this|suppress|public|protected|private|package|modifies|implements|external|exception|throws|enum|define|extends))(\\s*)({)",
                    push: [
                        {
                            token: "lparen.doc",
                            regex: "{",
                            push: [
                                {
                                    include: "doc-syntax"
                                },
                                {
                                    token: "rparen.doc",
                                    regex: "}|(?=$)",
                                    next: "pop"
                                }
                            ]
                        },
                        {
                            token: "rparen.doc",
                            regex: "}|(?=$)",
                            next: "pop"
                        },
                        {
                            include: "doc-syntax"
                        },
                        {
                            defaultToken: "text.doc"
                        }
                    ]
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "variable.parameter.doc"
                    ],
                    regex: '(@(?:alias|memberof|instance|module|name|lends|namespace|external|this|template|requires|param|implements|function|extends|typedef|mixes|constructor|var|memberof\\!|event|listens|exports|class|constructs|interface|emits|fires|throws|const|callback|borrows|augments))(\\s+)(\\w[\\w#.:/~"\\-]*)?'
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "variable.parameter.doc"
                    ],
                    regex: "(@method)(\\s+)(\\w[\\w.\\(\\)]*)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@access\\s+(?:private|public|protected)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@kind\\s+(?:class|constant|event|external|file|function|member|mixin|module|namespace|typedef)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@\\w+(?=\\s|$)"
                },
                JsDocCommentHighlightRules.getTagRule(),
                {
                    defaultToken: "comment.doc.body",
                    caseInsensitive: true
                }
            ],
            "doc-syntax": [
                {
                    token: "operator.doc",
                    regex: /[|:]/
                },
                {
                    token: "paren.doc",
                    regex: /[\[\]]/
                }
            ]
        };
        this.normalizeRules();
    };
    oop.inherits(JsDocCommentHighlightRules, TextHighlightRules);
    JsDocCommentHighlightRules.getTagRule = function(start) {
        return {
            token: "comment.doc.tag.storage.type",
            regex: "\\b(?:TODO|FIXME|XXX|HACK)\\b"
        };
    };
    JsDocCommentHighlightRules.getStartRule = function(start) {
        return {
            token: "comment.doc",
            regex: /\/\*\*(?!\/)/,
            next: start
        };
    };
    JsDocCommentHighlightRules.getEndRule = function(start) {
        return {
            token: "comment.doc",
            regex: "\\*\\/",
            next: start
        };
    };
    exports.JsDocCommentHighlightRules = JsDocCommentHighlightRules;
});
ace.define("ace/mode/javascript_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/jsdoc_comment_highlight_rules",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var DocCommentHighlightRules = require("./jsdoc_comment_highlight_rules").JsDocCommentHighlightRules;
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var identifierRe = "[a-zA-Z\\$_\xa1-\uFFFF][a-zA-Z\\d\\$_\xa1-\uFFFF]*";
    var JavaScriptHighlightRules = function(options) {
        var keywords = {
            "variable.language": "Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|Symbol|Namespace|QName|XML|XMLList|ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|SyntaxError|TypeError|URIError|decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|isNaN|parseFloat|parseInt|JSON|Math|this|arguments|prototype|window|document",
            "keyword": "const|yield|import|get|set|async|await|break|case|catch|continue|default|delete|do|else|finally|for|if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|__parent__|__count__|escape|unescape|with|__proto__|class|enum|extends|super|export|implements|private|public|interface|package|protected|static|constructor",
            "storage.type": "const|let|var|function",
            "constant.language": "null|Infinity|NaN|undefined",
            "support.function": "alert",
            "constant.language.boolean": "true|false"
        };
        var keywordMapper = this.createKeywordMapper(keywords, "identifier");
        var kwBeforeRe = "case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void";
        var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|u{[0-9a-fA-F]{1,6}}|[0-2][0-7]{0,2}|3[0-7][0-7]?|[4-7][0-7]?|.)";
        var anonymousFunctionRe = "(function)(\\s*)(\\*?)";
        var functionCallStartRule = {
            token: [
                "identifier",
                "text",
                "paren.lparen"
            ],
            regex: "(\\b(?!" + Object.values(keywords).join("|") + "\\b)" + identifierRe + ")(\\s*)(\\()"
        };
        this.$rules = {
            "no_regex": [
                DocCommentHighlightRules.getStartRule("doc-start"),
                comments("no_regex"),
                functionCallStartRule,
                {
                    token: "string",
                    regex: "'(?=.)",
                    next: "qstring"
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    next: "qqstring"
                },
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
                },
                {
                    token: "constant.numeric",
                    regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
                },
                {
                    token: [
                        "entity.name.function",
                        "text",
                        "keyword.operator",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\s*)(=)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(function)(?:(?:(\\s*)(\\*)(\\s*))|(\\s+))(" + identifierRe + ")(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "entity.name.function",
                        "text",
                        "punctuation.operator",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\s*)(:)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "text",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(:)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: "keyword",
                    regex: "from(?=\\s*('|\"))"
                },
                {
                    token: "keyword",
                    regex: "(?:" + kwBeforeRe + ")\\b",
                    next: "start"
                },
                {
                    token: "support.constant",
                    regex: /that\b/
                },
                {
                    token: [
                        "storage.type",
                        "punctuation.operator",
                        "support.function.firebug"
                    ],
                    regex: /(console)(\.)(warn|info|log|error|debug|time|trace|timeEnd|assert)\b/
                },
                {
                    token: keywordMapper,
                    regex: identifierRe
                },
                {
                    token: "punctuation.operator",
                    regex: /[.](?![.])/,
                    next: "property"
                },
                {
                    token: "storage.type",
                    regex: /=>/,
                    next: "start"
                },
                {
                    token: "keyword.operator",
                    regex: /--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,
                    next: "start"
                },
                {
                    token: "punctuation.operator",
                    regex: /[?:,;.]/,
                    next: "start"
                },
                {
                    token: "paren.lparen",
                    regex: /[\[({]/,
                    next: "start"
                },
                {
                    token: "paren.rparen",
                    regex: /[\])}]/
                },
                {
                    token: "comment",
                    regex: /^#!.*$/
                }
            ],
            property: [
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "keyword.operator",
                    regex: /=/
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(function)(?:(?:(\\s*)(\\*)(\\s*))|(\\s+))(\\w+)(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: "punctuation.operator",
                    regex: /[.](?![.])/
                },
                {
                    token: "support.function",
                    regex: "prototype"
                },
                {
                    token: "support.function",
                    regex: /(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|lter|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward|rEach)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/
                },
                {
                    token: "support.function.dom",
                    regex: /(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/
                },
                {
                    token: "support.constant",
                    regex: /(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/
                },
                {
                    token: "identifier",
                    regex: identifierRe
                },
                {
                    regex: "",
                    token: "empty",
                    next: "no_regex"
                }
            ],
            "start": [
                DocCommentHighlightRules.getStartRule("doc-start"),
                comments("start"),
                {
                    token: "string.regexp",
                    regex: "\\/",
                    next: "regex"
                },
                {
                    token: "text",
                    regex: "\\s+|^$",
                    next: "start"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "regex": [
                {
                    token: "regexp.keyword.operator",
                    regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
                },
                {
                    token: "string.regexp",
                    regex: "/[sxngimy]*",
                    next: "no_regex"
                },
                {
                    token: "invalid",
                    regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
                },
                {
                    token: "constant.language.escape",
                    regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
                },
                {
                    token: "constant.language.delimiter",
                    regex: /\|/
                },
                {
                    token: "constant.language.escape",
                    regex: /\[\^?/,
                    next: "regex_character_class"
                },
                {
                    token: "empty",
                    regex: "$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string.regexp"
                }
            ],
            "regex_character_class": [
                {
                    token: "regexp.charclass.keyword.operator",
                    regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
                },
                {
                    token: "constant.language.escape",
                    regex: "]",
                    next: "regex"
                },
                {
                    token: "constant.language.escape",
                    regex: "-"
                },
                {
                    token: "empty",
                    regex: "$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string.regexp.charachterclass"
                }
            ],
            "default_parameter": [
                {
                    token: "string",
                    regex: "'(?=.)",
                    push: [
                        {
                            token: "string",
                            regex: "'|$",
                            next: "pop"
                        },
                        {
                            include: "qstring"
                        }
                    ]
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    push: [
                        {
                            token: "string",
                            regex: '"|$',
                            next: "pop"
                        },
                        {
                            include: "qqstring"
                        }
                    ]
                },
                {
                    token: "constant.language",
                    regex: "null|Infinity|NaN|undefined"
                },
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
                },
                {
                    token: "constant.numeric",
                    regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
                },
                {
                    token: "punctuation.operator",
                    regex: ",",
                    next: "function_arguments"
                },
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.operator",
                    regex: "$"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "function_arguments": [
                comments("function_arguments"),
                {
                    token: "variable.parameter",
                    regex: identifierRe
                },
                {
                    token: "punctuation.operator",
                    regex: ","
                },
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.operator",
                    regex: "$"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "qqstring": [
                {
                    token: "constant.language.escape",
                    regex: escapedRe
                },
                {
                    token: "string",
                    regex: "\\\\$",
                    consumeLineEnd: true
                },
                {
                    token: "string",
                    regex: '"|$',
                    next: "no_regex"
                },
                {
                    defaultToken: "string"
                }
            ],
            "qstring": [
                {
                    token: "constant.language.escape",
                    regex: escapedRe
                },
                {
                    token: "string",
                    regex: "\\\\$",
                    consumeLineEnd: true
                },
                {
                    token: "string",
                    regex: "'|$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string"
                }
            ]
        };
        if (!options || !options.noES6) {
            this.$rules.no_regex.unshift({
                regex: "[{}]",
                onMatch: function(val, state, stack) {
                    this.next = val == "{" ? this.nextState : "";
                    if (val == "{" && stack.length) stack.unshift("start", state);
                    else if (val == "}" && stack.length) {
                        stack.shift();
                        this.next = stack.shift();
                        if (this.next.indexOf("string") != -1 || this.next.indexOf("jsx") != -1) return "paren.quasi.end";
                    }
                    return val == "{" ? "paren.lparen" : "paren.rparen";
                },
                nextState: "start"
            }, {
                token: "string.quasi.start",
                regex: /`/,
                push: [
                    {
                        token: "constant.language.escape",
                        regex: escapedRe
                    },
                    {
                        token: "paren.quasi.start",
                        regex: /\${/,
                        push: "start"
                    },
                    {
                        token: "string.quasi.end",
                        regex: /`/,
                        next: "pop"
                    },
                    {
                        defaultToken: "string.quasi"
                    }
                ]
            }, {
                token: [
                    "variable.parameter",
                    "text"
                ],
                regex: "(" + identifierRe + ")(\\s*)(?=\\=>)"
            }, {
                token: "paren.lparen",
                regex: "(\\()(?=[^\\(]+\\s*=>)",
                next: "function_arguments"
            }, {
                token: "variable.language",
                regex: "(?:(?:(?:Weak)?(?:Set|Map))|Promise)\\b"
            });
            this.$rules["function_arguments"].unshift({
                token: "keyword.operator",
                regex: "=",
                next: "default_parameter"
            }, {
                token: "keyword.operator",
                regex: "\\.{3}"
            });
            this.$rules["property"].unshift({
                token: "support.function",
                regex: "(findIndex|repeat|startsWith|endsWith|includes|isSafeInteger|trunc|cbrt|log2|log10|sign|then|catch|finally|resolve|reject|race|any|all|allSettled|keys|entries|isInteger)\\b(?=\\()"
            }, {
                token: "constant.language",
                regex: "(?:MAX_SAFE_INTEGER|MIN_SAFE_INTEGER|EPSILON)\\b"
            });
            if (!options || options.jsx != false) JSX.call(this);
        }
        this.embedRules(DocCommentHighlightRules, "doc-", [
            DocCommentHighlightRules.getEndRule("no_regex")
        ]);
        this.normalizeRules();
    };
    oop.inherits(JavaScriptHighlightRules, TextHighlightRules);
    function JSX() {
        var tagRegex = identifierRe.replace("\\d", "\\d\\-");
        var jsxTag = {
            onMatch: function(val, state, stack) {
                var offset = val.charAt(1) == "/" ? 2 : 1;
                if (offset == 1) {
                    if (state != this.nextState) stack.unshift(this.next, this.nextState, 0);
                    else stack.unshift(this.next);
                    stack[2]++;
                } else if (offset == 2) {
                    if (state == this.nextState) {
                        stack[1]--;
                        if (!stack[1] || stack[1] < 0) {
                            stack.shift();
                            stack.shift();
                        }
                    }
                }
                return [
                    {
                        type: "meta.tag.punctuation." + (offset == 1 ? "" : "end-") + "tag-open.xml",
                        value: val.slice(0, offset)
                    },
                    {
                        type: "meta.tag.tag-name.xml",
                        value: val.substr(offset)
                    }
                ];
            },
            regex: "</?(?:" + tagRegex + "|(?=>))",
            next: "jsxAttributes",
            nextState: "jsx"
        };
        this.$rules.start.unshift(jsxTag);
        var jsxJsRule = {
            regex: "{",
            token: "paren.quasi.start",
            push: "start"
        };
        this.$rules.jsx = [
            jsxJsRule,
            jsxTag,
            {
                include: "reference"
            },
            {
                defaultToken: "string.xml"
            }
        ];
        this.$rules.jsxAttributes = [
            {
                token: "meta.tag.punctuation.tag-close.xml",
                regex: "/?>",
                onMatch: function(value, currentState, stack) {
                    if (currentState == stack[0]) stack.shift();
                    if (value.length == 2) {
                        if (stack[0] == this.nextState) stack[1]--;
                        if (!stack[1] || stack[1] < 0) stack.splice(0, 2);
                    }
                    this.next = stack[0] || "start";
                    return [
                        {
                            type: this.token,
                            value: value
                        }
                    ];
                },
                nextState: "jsx"
            },
            jsxJsRule,
            comments("jsxAttributes"),
            {
                token: "entity.other.attribute-name.xml",
                regex: tagRegex
            },
            {
                token: "keyword.operator.attribute-equals.xml",
                regex: "="
            },
            {
                token: "text.tag-whitespace.xml",
                regex: "\\s+"
            },
            {
                token: "string.attribute-value.xml",
                regex: "'",
                stateName: "jsx_attr_q",
                push: [
                    {
                        token: "string.attribute-value.xml",
                        regex: "'",
                        next: "pop"
                    },
                    {
                        include: "reference"
                    },
                    {
                        defaultToken: "string.attribute-value.xml"
                    }
                ]
            },
            {
                token: "string.attribute-value.xml",
                regex: '"',
                stateName: "jsx_attr_qq",
                push: [
                    {
                        token: "string.attribute-value.xml",
                        regex: '"',
                        next: "pop"
                    },
                    {
                        include: "reference"
                    },
                    {
                        defaultToken: "string.attribute-value.xml"
                    }
                ]
            },
            jsxTag
        ];
        this.$rules.reference = [
            {
                token: "constant.language.escape.reference.xml",
                regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
            }
        ];
    }
    function comments(next) {
        return [
            {
                token: "comment",
                regex: /\/\*/,
                next: [
                    DocCommentHighlightRules.getTagRule(),
                    {
                        token: "comment",
                        regex: "\\*\\/",
                        next: next || "pop"
                    },
                    {
                        defaultToken: "comment",
                        caseInsensitive: true
                    }
                ]
            },
            {
                token: "comment",
                regex: "\\/\\/",
                next: [
                    DocCommentHighlightRules.getTagRule(),
                    {
                        token: "comment",
                        regex: "$|^",
                        next: next || "pop"
                    },
                    {
                        defaultToken: "comment",
                        caseInsensitive: true
                    }
                ]
            }
        ];
    }
    exports.JavaScriptHighlightRules = JavaScriptHighlightRules;
});
ace.define("ace/mode/xml_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var XmlHighlightRules = function(normalize) {
        var tagRegex = "[_:a-zA-Z\xc0-\uFFFF][-_:.a-zA-Z0-9\xc0-\uFFFF]*";
        this.$rules = {
            start: [
                {
                    token: "string.cdata.xml",
                    regex: "<\\!\\[CDATA\\[",
                    next: "cdata"
                },
                {
                    token: [
                        "punctuation.instruction.xml",
                        "keyword.instruction.xml"
                    ],
                    regex: "(<\\?)(" + tagRegex + ")",
                    next: "processing_instruction"
                },
                {
                    token: "comment.start.xml",
                    regex: "<\\!--",
                    next: "comment"
                },
                {
                    token: [
                        "xml-pe.doctype.xml",
                        "xml-pe.doctype.xml"
                    ],
                    regex: "(<\\!)(DOCTYPE)(?=[\\s])",
                    next: "doctype",
                    caseInsensitive: true
                },
                {
                    include: "tag"
                },
                {
                    token: "text.end-tag-open.xml",
                    regex: "</"
                },
                {
                    token: "text.tag-open.xml",
                    regex: "<"
                },
                {
                    include: "reference"
                },
                {
                    defaultToken: "text.xml"
                }
            ],
            processing_instruction: [
                {
                    token: "entity.other.attribute-name.decl-attribute-name.xml",
                    regex: tagRegex
                },
                {
                    token: "keyword.operator.decl-attribute-equals.xml",
                    regex: "="
                },
                {
                    include: "whitespace"
                },
                {
                    include: "string"
                },
                {
                    token: "punctuation.xml-decl.xml",
                    regex: "\\?>",
                    next: "start"
                }
            ],
            doctype: [
                {
                    include: "whitespace"
                },
                {
                    include: "string"
                },
                {
                    token: "xml-pe.doctype.xml",
                    regex: ">",
                    next: "start"
                },
                {
                    token: "xml-pe.xml",
                    regex: "[-_a-zA-Z0-9:]+"
                },
                {
                    token: "punctuation.int-subset",
                    regex: "\\[",
                    push: "int_subset"
                }
            ],
            int_subset: [
                {
                    token: "text.xml",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.int-subset.xml",
                    regex: "]",
                    next: "pop"
                },
                {
                    token: [
                        "punctuation.markup-decl.xml",
                        "keyword.markup-decl.xml"
                    ],
                    regex: "(<\\!)(" + tagRegex + ")",
                    push: [
                        {
                            token: "text",
                            regex: "\\s+"
                        },
                        {
                            token: "punctuation.markup-decl.xml",
                            regex: ">",
                            next: "pop"
                        },
                        {
                            include: "string"
                        }
                    ]
                }
            ],
            cdata: [
                {
                    token: "string.cdata.xml",
                    regex: "\\]\\]>",
                    next: "start"
                },
                {
                    token: "text.xml",
                    regex: "\\s+"
                },
                {
                    token: "text.xml",
                    regex: "(?:[^\\]]|\\](?!\\]>))+"
                }
            ],
            comment: [
                {
                    token: "comment.end.xml",
                    regex: "-->",
                    next: "start"
                },
                {
                    defaultToken: "comment.xml"
                }
            ],
            reference: [
                {
                    token: "constant.language.escape.reference.xml",
                    regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
                }
            ],
            attr_reference: [
                {
                    token: "constant.language.escape.reference.attribute-value.xml",
                    regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
                }
            ],
            tag: [
                {
                    token: [
                        "meta.tag.punctuation.tag-open.xml",
                        "meta.tag.punctuation.end-tag-open.xml",
                        "meta.tag.tag-name.xml"
                    ],
                    regex: "(?:(<)|(</))((?:" + tagRegex + ":)?" + tagRegex + ")",
                    next: [
                        {
                            include: "attributes"
                        },
                        {
                            token: "meta.tag.punctuation.tag-close.xml",
                            regex: "/?>",
                            next: "start"
                        }
                    ]
                }
            ],
            tag_whitespace: [
                {
                    token: "text.tag-whitespace.xml",
                    regex: "\\s+"
                }
            ],
            whitespace: [
                {
                    token: "text.whitespace.xml",
                    regex: "\\s+"
                }
            ],
            string: [
                {
                    token: "string.xml",
                    regex: "'",
                    push: [
                        {
                            token: "string.xml",
                            regex: "'",
                            next: "pop"
                        },
                        {
                            defaultToken: "string.xml"
                        }
                    ]
                },
                {
                    token: "string.xml",
                    regex: '"',
                    push: [
                        {
                            token: "string.xml",
                            regex: '"',
                            next: "pop"
                        },
                        {
                            defaultToken: "string.xml"
                        }
                    ]
                }
            ],
            attributes: [
                {
                    token: "entity.other.attribute-name.xml",
                    regex: tagRegex
                },
                {
                    token: "keyword.operator.attribute-equals.xml",
                    regex: "="
                },
                {
                    include: "tag_whitespace"
                },
                {
                    include: "attribute_value"
                }
            ],
            attribute_value: [
                {
                    token: "string.attribute-value.xml",
                    regex: "'",
                    push: [
                        {
                            token: "string.attribute-value.xml",
                            regex: "'",
                            next: "pop"
                        },
                        {
                            include: "attr_reference"
                        },
                        {
                            defaultToken: "string.attribute-value.xml"
                        }
                    ]
                },
                {
                    token: "string.attribute-value.xml",
                    regex: '"',
                    push: [
                        {
                            token: "string.attribute-value.xml",
                            regex: '"',
                            next: "pop"
                        },
                        {
                            include: "attr_reference"
                        },
                        {
                            defaultToken: "string.attribute-value.xml"
                        }
                    ]
                }
            ]
        };
        if (this.constructor === XmlHighlightRules) this.normalizeRules();
    };
    (function() {
        this.embedTagRules = function(HighlightRules, prefix, tag) {
            this.$rules.tag.unshift({
                token: [
                    "meta.tag.punctuation.tag-open.xml",
                    "meta.tag." + tag + ".tag-name.xml"
                ],
                regex: "(<)(" + tag + "(?=\\s|>|$))",
                next: [
                    {
                        include: "attributes"
                    },
                    {
                        token: "meta.tag.punctuation.tag-close.xml",
                        regex: "/?>",
                        next: prefix + "start"
                    }
                ]
            });
            this.$rules[tag + "-end"] = [
                {
                    include: "attributes"
                },
                {
                    token: "meta.tag.punctuation.tag-close.xml",
                    regex: "/?>",
                    next: "start",
                    onMatch: function(value, currentState, stack) {
                        stack.splice(0);
                        return this.token;
                    }
                }
            ];
            this.embedRules(HighlightRules, prefix, [
                {
                    token: [
                        "meta.tag.punctuation.end-tag-open.xml",
                        "meta.tag." + tag + ".tag-name.xml"
                    ],
                    regex: "(</)(" + tag + "(?=\\s|>|$))",
                    next: tag + "-end"
                },
                {
                    token: "string.cdata.xml",
                    regex: "<\\!\\[CDATA\\["
                },
                {
                    token: "string.cdata.xml",
                    regex: "\\]\\]>"
                }
            ]);
        };
    }).call(TextHighlightRules.prototype);
    oop.inherits(XmlHighlightRules, TextHighlightRules);
    exports.XmlHighlightRules = XmlHighlightRules;
});
ace.define("ace/mode/html_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/mode/css_highlight_rules",
    "ace/mode/javascript_highlight_rules",
    "ace/mode/xml_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var lang = require("../lib/lang");
    var CssHighlightRules = require("./css_highlight_rules").CssHighlightRules;
    var JavaScriptHighlightRules = require("./javascript_highlight_rules").JavaScriptHighlightRules;
    var XmlHighlightRules = require("./xml_highlight_rules").XmlHighlightRules;
    var tagMap = lang.createMap({
        a: "anchor",
        button: "form",
        form: "form",
        img: "image",
        input: "form",
        label: "form",
        option: "form",
        script: "script",
        select: "form",
        textarea: "form",
        style: "style",
        table: "table",
        tbody: "table",
        td: "table",
        tfoot: "table",
        th: "table",
        tr: "table"
    });
    var HtmlHighlightRules = function() {
        XmlHighlightRules.call(this);
        this.addRules({
            attributes: [
                {
                    include: "tag_whitespace"
                },
                {
                    token: "entity.other.attribute-name.xml",
                    regex: "[-_a-zA-Z0-9:.]+"
                },
                {
                    token: "keyword.operator.attribute-equals.xml",
                    regex: "=",
                    push: [
                        {
                            include: "tag_whitespace"
                        },
                        {
                            token: "string.unquoted.attribute-value.html",
                            regex: "[^<>='\"`\\s]+",
                            next: "pop"
                        },
                        {
                            token: "empty",
                            regex: "",
                            next: "pop"
                        }
                    ]
                },
                {
                    include: "attribute_value"
                }
            ],
            tag: [
                {
                    token: function(start, tag) {
                        var group = tagMap[tag];
                        return [
                            "meta.tag.punctuation." + (start == "<" ? "" : "end-") + "tag-open.xml",
                            "meta.tag" + (group ? "." + group : "") + ".tag-name.xml"
                        ];
                    },
                    regex: "(</?)([-_a-zA-Z0-9:.]+)",
                    next: "tag_stuff"
                }
            ],
            tag_stuff: [
                {
                    include: "attributes"
                },
                {
                    token: "meta.tag.punctuation.tag-close.xml",
                    regex: "/?>",
                    next: "start"
                }
            ]
        });
        this.embedTagRules(CssHighlightRules, "css-", "style");
        this.embedTagRules(new JavaScriptHighlightRules({
            jsx: false
        }).getRules(), "js-", "script");
        if (this.constructor === HtmlHighlightRules) this.normalizeRules();
    };
    oop.inherits(HtmlHighlightRules, XmlHighlightRules);
    exports.HtmlHighlightRules = HtmlHighlightRules;
});
ace.define("ace/mode/doc_comment_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var DocCommentHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: "comment.doc.tag",
                    regex: "@\\w+(?=\\s|$)"
                },
                DocCommentHighlightRules.getTagRule(),
                {
                    defaultToken: "comment.doc.body",
                    caseInsensitive: true
                }
            ]
        };
    };
    oop.inherits(DocCommentHighlightRules, TextHighlightRules);
    DocCommentHighlightRules.getTagRule = function(start) {
        return {
            token: "comment.doc.tag.storage.type",
            regex: "\\b(?:TODO|FIXME|XXX|HACK)\\b"
        };
    };
    DocCommentHighlightRules.getStartRule = function(start) {
        return {
            token: "comment.doc",
            regex: /\/\*\*(?!\/)/,
            next: start
        };
    };
    DocCommentHighlightRules.getEndRule = function(start) {
        return {
            token: "comment.doc",
            regex: "\\*\\/",
            next: start
        };
    };
    exports.DocCommentHighlightRules = DocCommentHighlightRules;
});
ace.define("ace/mode/java_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/doc_comment_highlight_rules",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var DocCommentHighlightRules = require("./doc_comment_highlight_rules").DocCommentHighlightRules;
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var JavaHighlightRules = function() {
        var identifierRe = "[a-zA-Z_$][a-zA-Z0-9_$]*";
        var keywords = "abstract|continue|for|new|switch|assert|default|goto|package|synchronized|boolean|do|if|private|this|break|double|implements|protected|throw|byte|else|import|public|throws|case|enum|instanceof|return|transient|catch|extends|int|short|try|char|final|interface|static|void|class|finally|long|strictfp|volatile|const|float|native|super|while|var|exports|opens|requires|uses|yield|module|permits|(?:non\\-)?sealed|var|provides|to|when|open|record|transitive|with";
        var buildinConstants = "null|Infinity|NaN|undefined";
        var langClasses = "AbstractMethodError|AssertionError|ClassCircularityError|ClassFormatError|Deprecated|EnumConstantNotPresentException|ExceptionInInitializerError|IllegalAccessError|IllegalThreadStateException|InstantiationError|InternalError|NegativeArraySizeException|NoSuchFieldError|Override|Process|ProcessBuilder|SecurityManager|StringIndexOutOfBoundsException|SuppressWarnings|TypeNotPresentException|UnknownError|UnsatisfiedLinkError|UnsupportedClassVersionError|VerifyError|InstantiationException|IndexOutOfBoundsException|ArrayIndexOutOfBoundsException|CloneNotSupportedException|NoSuchFieldException|IllegalArgumentException|NumberFormatException|SecurityException|Void|InheritableThreadLocal|IllegalStateException|InterruptedException|NoSuchMethodException|IllegalAccessException|UnsupportedOperationException|Enum|StrictMath|Package|Compiler|Readable|Runtime|StringBuilder|Math|IncompatibleClassChangeError|NoSuchMethodError|ThreadLocal|RuntimePermission|ArithmeticException|NullPointerException|Long|Integer|Short|Byte|Double|Number|Float|Character|Boolean|StackTraceElement|Appendable|StringBuffer|Iterable|ThreadGroup|Runnable|Thread|IllegalMonitorStateException|StackOverflowError|OutOfMemoryError|VirtualMachineError|ArrayStoreException|ClassCastException|LinkageError|NoClassDefFoundError|ClassNotFoundException|RuntimeException|Exception|ThreadDeath|Error|Throwable|System|ClassLoader|Cloneable|Class|CharSequence|Comparable|String|Object";
        var keywordMapper = this.createKeywordMapper({
            "variable.language": "this",
            "constant.language": buildinConstants,
            "support.function": langClasses
        }, "identifier");
        this.$rules = {
            "start": [
                {
                    token: "comment",
                    regex: "\\/\\/.*$"
                },
                DocCommentHighlightRules.getStartRule("doc-start"),
                {
                    token: "comment",
                    regex: "\\/\\*",
                    next: "comment"
                },
                {
                    include: "multiline-strings"
                },
                {
                    include: "strings"
                },
                {
                    include: "constants"
                },
                {
                    regex: "(open(?:\\s+))?module(?=\\s*\\w)",
                    token: "keyword",
                    next: [
                        {
                            regex: "{",
                            token: "paren.lparen",
                            next: [
                                {
                                    regex: "}",
                                    token: "paren.rparen",
                                    next: "start"
                                },
                                {
                                    regex: "\\b(requires|transitive|exports|opens|to|uses|provides|with)\\b",
                                    token: "keyword"
                                }
                            ]
                        },
                        {
                            token: "text",
                            regex: "\\s+"
                        },
                        {
                            token: "identifier",
                            regex: "\\w+"
                        },
                        {
                            token: "punctuation.operator",
                            regex: "."
                        },
                        {
                            token: "text",
                            regex: "\\s+"
                        },
                        {
                            regex: "",
                            next: "start"
                        }
                    ]
                },
                {
                    include: "statements"
                }
            ],
            "comment": [
                {
                    token: "comment",
                    regex: "\\*\\/",
                    next: "start"
                },
                {
                    defaultToken: "comment"
                }
            ],
            "strings": [
                {
                    token: [
                        "punctuation",
                        "string"
                    ],
                    regex: /(\.)(")/,
                    push: [
                        {
                            token: "lparen",
                            regex: /\\\{/,
                            push: [
                                {
                                    token: "text",
                                    regex: /$/,
                                    next: "start"
                                },
                                {
                                    token: "rparen",
                                    regex: /}/,
                                    next: "pop"
                                },
                                {
                                    include: "strings"
                                },
                                {
                                    include: "constants"
                                },
                                {
                                    include: "statements"
                                }
                            ]
                        },
                        {
                            token: "string",
                            regex: /"/,
                            next: "pop"
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                },
                {
                    token: "string",
                    regex: '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]'
                },
                {
                    token: "string",
                    regex: "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
                }
            ],
            "multiline-strings": [
                {
                    token: [
                        "punctuation",
                        "string"
                    ],
                    regex: /(\.)(""")/,
                    push: [
                        {
                            token: "string",
                            regex: '"""',
                            next: "pop"
                        },
                        {
                            token: "lparen",
                            regex: /\\\{/,
                            push: [
                                {
                                    token: "text",
                                    regex: /$/,
                                    next: "start"
                                },
                                {
                                    token: "rparen",
                                    regex: /}/,
                                    next: "pop"
                                },
                                {
                                    include: "multiline-strings"
                                },
                                {
                                    include: "strings"
                                },
                                {
                                    include: "constants"
                                },
                                {
                                    include: "statements"
                                }
                            ]
                        },
                        {
                            token: "constant.language.escape",
                            regex: /\\./
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                },
                {
                    token: "string",
                    regex: '"""',
                    push: [
                        {
                            token: "string",
                            regex: '"""',
                            next: "pop"
                        },
                        {
                            token: "constant.language.escape",
                            regex: /\\./
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                }
            ],
            "constants": [
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F][0-9a-fA-F_]*|[bB][01][01_]*)[LlSsDdFfYy]?\b/
                },
                {
                    token: "constant.numeric",
                    regex: /[+-]?\d[\d_]*(?:(?:\.[\d_]*)?(?:[eE][+-]?[\d_]+)?)?[LlSsDdFfYy]?\b/
                },
                {
                    token: "constant.language.boolean",
                    regex: "(?:true|false)\\b"
                }
            ],
            "statements": [
                {
                    token: [
                        "keyword",
                        "text",
                        "identifier"
                    ],
                    regex: "(record)(\\s+)(" + identifierRe + ")\\b"
                },
                {
                    token: "keyword",
                    regex: "(?:" + keywords + ")\\b"
                },
                {
                    token: "storage.type.annotation",
                    regex: "@" + identifierRe + "\\b"
                },
                {
                    token: "entity.name.function",
                    regex: identifierRe + "(?=\\()"
                },
                {
                    token: keywordMapper,
                    regex: identifierRe + "\\b"
                },
                {
                    token: "keyword.operator",
                    regex: "!|\\$|%|&|\\||\\^|\\*|\\/|\\-\\-|\\-|\\+\\+|\\+|~|===|==|=|!=|!==|<=|>=|<<=|>>=|>>>=|<>|<|>|!|&&|\\|\\||\\?|\\:|\\*=|\\/=|%=|\\+=|\\-=|&=|\\|=|\\^=|\\b(?:in|instanceof|new|delete|typeof|void)"
                },
                {
                    token: "lparen",
                    regex: "[[({]"
                },
                {
                    token: "rparen",
                    regex: "[\\])}]"
                },
                {
                    token: "text",
                    regex: "\\s+"
                }
            ]
        };
        this.embedRules(DocCommentHighlightRules, "doc-", [
            DocCommentHighlightRules.getEndRule("start")
        ]);
        this.normalizeRules();
    };
    oop.inherits(JavaHighlightRules, TextHighlightRules);
    exports.JavaHighlightRules = JavaHighlightRules;
});
ace.define("ace/mode/jsp_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/html_highlight_rules",
    "ace/mode/java_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var HtmlHighlightRules = require("./html_highlight_rules").HtmlHighlightRules;
    var JavaHighlightRules = require("./java_highlight_rules").JavaHighlightRules;
    var JspHighlightRules = function() {
        HtmlHighlightRules.call(this);
        var builtinVariables = "request|response|out|session|application|config|pageContext|page|Exception";
        var keywords = "page|include|taglib";
        var startRules = [
            {
                token: "comment",
                regex: "<%--",
                push: "jsp-dcomment"
            },
            {
                token: "meta.tag",
                regex: "<%@?|<%=?|<%!?|<jsp:[^>]+>",
                push: "jsp-start"
            }
        ];
        var endRules = [
            {
                token: "meta.tag",
                regex: "%>|<\\/jsp:[^>]+>",
                next: "pop"
            },
            {
                token: "variable.language",
                regex: builtinVariables
            },
            {
                token: "keyword",
                regex: keywords
            }
        ];
        for(var key in this.$rules)this.$rules[key].unshift.apply(this.$rules[key], startRules);
        this.embedRules(JavaHighlightRules, "jsp-", endRules, [
            "start"
        ]);
        this.addRules({
            "jsp-dcomment": [
                {
                    token: "comment",
                    regex: ".*?--%>",
                    next: "pop"
                }
            ]
        });
        this.normalizeRules();
    };
    oop.inherits(JspHighlightRules, HtmlHighlightRules);
    exports.JspHighlightRules = JspHighlightRules;
});
ace.define("ace/mode/matching_brace_outdent", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var MatchingBraceOutdent = function() {};
    (function() {
        this.checkOutdent = function(line, input) {
            if (!/^\s+$/.test(line)) return false;
            return /^\s*\}/.test(input);
        };
        this.autoOutdent = function(doc, row) {
            var line = doc.getLine(row);
            var match = line.match(/^(\s*\})/);
            if (!match) return 0;
            var column = match[1].length;
            var openBracePos = doc.findMatchingBracket({
                row: row,
                column: column
            });
            if (!openBracePos || openBracePos.row == row) return 0;
            var indent = this.$getIndent(doc.getLine(openBracePos.row));
            doc.replace(new Range(row, 0, row, column - 1), indent);
        };
        this.$getIndent = function(line) {
            return line.match(/^\s*/)[0];
        };
    }).call(MatchingBraceOutdent.prototype);
    exports.MatchingBraceOutdent = MatchingBraceOutdent;
});
ace.define("ace/mode/folding/cstyle", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
    };
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
        this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
        this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
        this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
        this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
        this._getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            if (this.singleLineBlockCommentRe.test(line)) {
                if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line)) return "";
            }
            var fw = this._getFoldWidgetBase(session, foldStyle, row);
            if (!fw && this.startRegionRe.test(line)) return "start"; // lineCommentRegionStart
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var line = session.getLine(row);
            if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
            var match = line.match(this.foldingStartMarker);
            if (match) {
                var i = match.index;
                if (match[1]) return this.openingBracketBlock(session, match[1], row, i);
                var range = session.getCommentFoldRange(row, i + match[0].length, 1);
                if (range && !range.isMultiLine()) {
                    if (forceMultiline) range = this.getSectionRange(session, row);
                    else if (foldStyle != "all") range = null;
                }
                return range;
            }
            if (foldStyle === "markbegin") return;
            var match = line.match(this.foldingStopMarker);
            if (match) {
                var i = match.index + match[0].length;
                if (match[1]) return this.closingBracketBlock(session, match[1], row, i);
                return session.getCommentFoldRange(row, i, -1);
            }
        };
        this.getSectionRange = function(session, row) {
            var line = session.getLine(row);
            var startIndent = line.search(/\S/);
            var startRow = row;
            var startColumn = line.length;
            row = row + 1;
            var endRow = row;
            var maxRow = session.getLength();
            while(++row < maxRow){
                line = session.getLine(row);
                var indent = line.search(/\S/);
                if (indent === -1) continue;
                if (startIndent > indent) break;
                var subRange = this.getFoldWidgetRange(session, "all", row);
                if (subRange) {
                    if (subRange.start.row <= startRow) break;
                    else if (subRange.isMultiLine()) row = subRange.end.row;
                    else if (startIndent == indent) break;
                }
                endRow = row;
            }
            return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
        };
        this.getCommentRegionBlock = function(session, line, row) {
            var startColumn = line.search(/\s*$/);
            var maxRow = session.getLength();
            var startRow = row;
            var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
            var depth = 1;
            while(++row < maxRow){
                line = session.getLine(row);
                var m = re.exec(line);
                if (!m) continue;
                if (m[1]) depth--;
                else depth++;
                if (!depth) break;
            }
            var endRow = row;
            if (endRow > startRow) return new Range(startRow, startColumn, endRow, line.length);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/jsp", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/jsp_highlight_rules",
    "ace/mode/matching_brace_outdent",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var JspHighlightRules = require("./jsp_highlight_rules").JspHighlightRules;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var CStyleFoldMode = require("./folding/cstyle").FoldMode;
    var Mode = function() {
        this.HighlightRules = JspHighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.$behaviour = this.$defaultBehaviour;
        this.foldingRules = new CStyleFoldMode();
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.$id = "ace/mode/jsp";
        this.snippetFileId = "ace/snippets/jsp";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/jsp"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("6GnD9", function(module, exports) {
ace.define("ace/mode/doc_comment_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var DocCommentHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: "comment.doc.tag",
                    regex: "@\\w+(?=\\s|$)"
                },
                DocCommentHighlightRules.getTagRule(),
                {
                    defaultToken: "comment.doc.body",
                    caseInsensitive: true
                }
            ]
        };
    };
    oop.inherits(DocCommentHighlightRules, TextHighlightRules);
    DocCommentHighlightRules.getTagRule = function(start) {
        return {
            token: "comment.doc.tag.storage.type",
            regex: "\\b(?:TODO|FIXME|XXX|HACK)\\b"
        };
    };
    DocCommentHighlightRules.getStartRule = function(start) {
        return {
            token: "comment.doc",
            regex: /\/\*\*(?!\/)/,
            next: start
        };
    };
    DocCommentHighlightRules.getEndRule = function(start) {
        return {
            token: "comment.doc",
            regex: "\\*\\/",
            next: start
        };
    };
    exports.DocCommentHighlightRules = DocCommentHighlightRules;
});
ace.define("ace/mode/css_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var lang = require("../lib/lang");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var supportType = exports.supportType = "align-content|align-items|align-self|all|animation|animation-delay|animation-direction|animation-duration|animation-fill-mode|animation-iteration-count|animation-name|animation-play-state|animation-timing-function|backface-visibility|background|background-attachment|background-blend-mode|background-clip|background-color|background-image|background-origin|background-position|background-repeat|background-size|border|border-bottom|border-bottom-color|border-bottom-left-radius|border-bottom-right-radius|border-bottom-style|border-bottom-width|border-collapse|border-color|border-image|border-image-outset|border-image-repeat|border-image-slice|border-image-source|border-image-width|border-left|border-left-color|border-left-style|border-left-width|border-radius|border-right|border-right-color|border-right-style|border-right-width|border-spacing|border-style|border-top|border-top-color|border-top-left-radius|border-top-right-radius|border-top-style|border-top-width|border-width|bottom|box-shadow|box-sizing|caption-side|clear|clip|color|column-count|column-fill|column-gap|column-rule|column-rule-color|column-rule-style|column-rule-width|column-span|column-width|columns|content|counter-increment|counter-reset|cursor|direction|display|empty-cells|filter|flex|flex-basis|flex-direction|flex-flow|flex-grow|flex-shrink|flex-wrap|float|font|font-family|font-size|font-size-adjust|font-stretch|font-style|font-variant|font-weight|hanging-punctuation|height|justify-content|left|letter-spacing|line-height|list-style|list-style-image|list-style-position|list-style-type|margin|margin-bottom|margin-left|margin-right|margin-top|max-height|max-width|max-zoom|min-height|min-width|min-zoom|nav-down|nav-index|nav-left|nav-right|nav-up|opacity|order|outline|outline-color|outline-offset|outline-style|outline-width|overflow|overflow-x|overflow-y|padding|padding-bottom|padding-left|padding-right|padding-top|page-break-after|page-break-before|page-break-inside|perspective|perspective-origin|position|quotes|resize|right|tab-size|table-layout|text-align|text-align-last|text-decoration|text-decoration-color|text-decoration-line|text-decoration-style|text-indent|text-justify|text-overflow|text-shadow|text-transform|top|transform|transform-origin|transform-style|transition|transition-delay|transition-duration|transition-property|transition-timing-function|unicode-bidi|user-select|user-zoom|vertical-align|visibility|white-space|width|word-break|word-spacing|word-wrap|z-index";
    var supportFunction = exports.supportFunction = "rgb|rgba|url|attr|counter|counters";
    var supportConstant = exports.supportConstant = "absolute|after-edge|after|all-scroll|all|alphabetic|always|antialiased|armenian|auto|avoid-column|avoid-page|avoid|balance|baseline|before-edge|before|below|bidi-override|block-line-height|block|bold|bolder|border-box|both|bottom|box|break-all|break-word|capitalize|caps-height|caption|center|central|char|circle|cjk-ideographic|clone|close-quote|col-resize|collapse|column|consider-shifts|contain|content-box|cover|crosshair|cubic-bezier|dashed|decimal-leading-zero|decimal|default|disabled|disc|disregard-shifts|distribute-all-lines|distribute-letter|distribute-space|distribute|dotted|double|e-resize|ease-in|ease-in-out|ease-out|ease|ellipsis|end|exclude-ruby|flex-end|flex-start|fill|fixed|georgian|glyphs|grid-height|groove|hand|hanging|hebrew|help|hidden|hiragana-iroha|hiragana|horizontal|icon|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space|ideographic|inactive|include-ruby|inherit|initial|inline-block|inline-box|inline-line-height|inline-table|inline|inset|inside|inter-ideograph|inter-word|invert|italic|justify|katakana-iroha|katakana|keep-all|last|left|lighter|line-edge|line-through|line|linear|list-item|local|loose|lower-alpha|lower-greek|lower-latin|lower-roman|lowercase|lr-tb|ltr|mathematical|max-height|max-size|medium|menu|message-box|middle|move|n-resize|ne-resize|newspaper|no-change|no-close-quote|no-drop|no-open-quote|no-repeat|none|normal|not-allowed|nowrap|nw-resize|oblique|open-quote|outset|outside|overline|padding-box|page|pointer|pre-line|pre-wrap|pre|preserve-3d|progress|relative|repeat-x|repeat-y|repeat|replaced|reset-size|ridge|right|round|row-resize|rtl|s-resize|scroll|se-resize|separate|slice|small-caps|small-caption|solid|space|square|start|static|status-bar|step-end|step-start|steps|stretch|strict|sub|super|sw-resize|table-caption|table-cell|table-column-group|table-column|table-footer-group|table-header-group|table-row-group|table-row|table|tb-rl|text-after-edge|text-before-edge|text-bottom|text-size|text-top|text|thick|thin|transparent|underline|upper-alpha|upper-latin|upper-roman|uppercase|use-script|vertical-ideographic|vertical-text|visible|w-resize|wait|whitespace|z-index|zero|zoom";
    var supportConstantColor = exports.supportConstantColor = "aliceblue|antiquewhite|aqua|aquamarine|azure|beige|bisque|black|blanchedalmond|blue|blueviolet|brown|burlywood|cadetblue|chartreuse|chocolate|coral|cornflowerblue|cornsilk|crimson|cyan|darkblue|darkcyan|darkgoldenrod|darkgray|darkgreen|darkgrey|darkkhaki|darkmagenta|darkolivegreen|darkorange|darkorchid|darkred|darksalmon|darkseagreen|darkslateblue|darkslategray|darkslategrey|darkturquoise|darkviolet|deeppink|deepskyblue|dimgray|dimgrey|dodgerblue|firebrick|floralwhite|forestgreen|fuchsia|gainsboro|ghostwhite|gold|goldenrod|gray|green|greenyellow|grey|honeydew|hotpink|indianred|indigo|ivory|khaki|lavender|lavenderblush|lawngreen|lemonchiffon|lightblue|lightcoral|lightcyan|lightgoldenrodyellow|lightgray|lightgreen|lightgrey|lightpink|lightsalmon|lightseagreen|lightskyblue|lightslategray|lightslategrey|lightsteelblue|lightyellow|lime|limegreen|linen|magenta|maroon|mediumaquamarine|mediumblue|mediumorchid|mediumpurple|mediumseagreen|mediumslateblue|mediumspringgreen|mediumturquoise|mediumvioletred|midnightblue|mintcream|mistyrose|moccasin|navajowhite|navy|oldlace|olive|olivedrab|orange|orangered|orchid|palegoldenrod|palegreen|paleturquoise|palevioletred|papayawhip|peachpuff|peru|pink|plum|powderblue|purple|rebeccapurple|red|rosybrown|royalblue|saddlebrown|salmon|sandybrown|seagreen|seashell|sienna|silver|skyblue|slateblue|slategray|slategrey|snow|springgreen|steelblue|tan|teal|thistle|tomato|turquoise|violet|wheat|white|whitesmoke|yellow|yellowgreen";
    var supportConstantFonts = exports.supportConstantFonts = "arial|century|comic|courier|cursive|fantasy|garamond|georgia|helvetica|impact|lucida|symbol|system|tahoma|times|trebuchet|utopia|verdana|webdings|sans-serif|serif|monospace";
    var numRe = exports.numRe = "\\-?(?:(?:[0-9]+(?:\\.[0-9]+)?)|(?:\\.[0-9]+))";
    var pseudoElements = exports.pseudoElements = "(\\:+)\\b(after|before|first-letter|first-line|moz-selection|selection)\\b";
    var pseudoClasses = exports.pseudoClasses = "(:)\\b(active|checked|disabled|empty|enabled|first-child|first-of-type|focus|hover|indeterminate|invalid|last-child|last-of-type|link|not|nth-child|nth-last-child|nth-last-of-type|nth-of-type|only-child|only-of-type|required|root|target|valid|visited)\\b";
    var CssHighlightRules = function() {
        var keywordMapper = this.createKeywordMapper({
            "support.function": supportFunction,
            "support.constant": supportConstant,
            "support.type": supportType,
            "support.constant.color": supportConstantColor,
            "support.constant.fonts": supportConstantFonts
        }, "text", true);
        this.$rules = {
            "start": [
                {
                    include: [
                        "strings",
                        "url",
                        "comments"
                    ]
                },
                {
                    token: "paren.lparen",
                    regex: "\\{",
                    next: "ruleset"
                },
                {
                    token: "paren.rparen",
                    regex: "\\}"
                },
                {
                    token: "string",
                    regex: "@(?!viewport)",
                    next: "media"
                },
                {
                    token: "keyword",
                    regex: "#[a-z0-9-_]+"
                },
                {
                    token: "keyword",
                    regex: "%"
                },
                {
                    token: "variable",
                    regex: "\\.[a-z0-9-_]+"
                },
                {
                    token: "string",
                    regex: ":[a-z0-9-_]+"
                },
                {
                    token: "constant.numeric",
                    regex: numRe
                },
                {
                    token: "constant",
                    regex: "[a-z0-9-_]+"
                },
                {
                    caseInsensitive: true
                }
            ],
            "media": [
                {
                    include: [
                        "strings",
                        "url",
                        "comments"
                    ]
                },
                {
                    token: "paren.lparen",
                    regex: "\\{",
                    next: "start"
                },
                {
                    token: "paren.rparen",
                    regex: "\\}",
                    next: "start"
                },
                {
                    token: "string",
                    regex: ";",
                    next: "start"
                },
                {
                    token: "keyword",
                    regex: "(?:media|supports|document|charset|import|namespace|media|supports|document|page|font|keyframes|viewport|counter-style|font-feature-values|swash|ornaments|annotation|stylistic|styleset|character-variant)"
                }
            ],
            "comments": [
                {
                    token: "comment",
                    regex: "\\/\\*",
                    push: [
                        {
                            token: "comment",
                            regex: "\\*\\/",
                            next: "pop"
                        },
                        {
                            defaultToken: "comment"
                        }
                    ]
                }
            ],
            "ruleset": [
                {
                    regex: "-(webkit|ms|moz|o)-",
                    token: "text"
                },
                {
                    token: "punctuation.operator",
                    regex: "[:;]"
                },
                {
                    token: "paren.rparen",
                    regex: "\\}",
                    next: "start"
                },
                {
                    include: [
                        "strings",
                        "url",
                        "comments"
                    ]
                },
                {
                    token: [
                        "constant.numeric",
                        "keyword"
                    ],
                    regex: "(" + numRe + ")(ch|cm|deg|em|ex|fr|gd|grad|Hz|in|kHz|mm|ms|pc|pt|px|rad|rem|s|turn|vh|vmax|vmin|vm|vw|%)"
                },
                {
                    token: "constant.numeric",
                    regex: numRe
                },
                {
                    token: "constant.numeric",
                    regex: "#[a-f0-9]{6}"
                },
                {
                    token: "constant.numeric",
                    regex: "#[a-f0-9]{3}"
                },
                {
                    token: [
                        "punctuation",
                        "entity.other.attribute-name.pseudo-element.css"
                    ],
                    regex: pseudoElements
                },
                {
                    token: [
                        "punctuation",
                        "entity.other.attribute-name.pseudo-class.css"
                    ],
                    regex: pseudoClasses
                },
                {
                    include: "url"
                },
                {
                    token: keywordMapper,
                    regex: "\\-?[a-zA-Z_][a-zA-Z0-9_\\-]*"
                },
                {
                    token: "paren.lparen",
                    regex: "\\{"
                },
                {
                    caseInsensitive: true
                }
            ],
            url: [
                {
                    token: "support.function",
                    regex: "(?:url(:?-prefix)?|domain|regexp)\\(",
                    push: [
                        {
                            token: "support.function",
                            regex: "\\)",
                            next: "pop"
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                }
            ],
            strings: [
                {
                    token: "string.start",
                    regex: "'",
                    push: [
                        {
                            token: "string.end",
                            regex: "'|$",
                            next: "pop"
                        },
                        {
                            include: "escapes"
                        },
                        {
                            token: "constant.language.escape",
                            regex: /\\$/,
                            consumeLineEnd: true
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                },
                {
                    token: "string.start",
                    regex: '"',
                    push: [
                        {
                            token: "string.end",
                            regex: '"|$',
                            next: "pop"
                        },
                        {
                            include: "escapes"
                        },
                        {
                            token: "constant.language.escape",
                            regex: /\\$/,
                            consumeLineEnd: true
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                }
            ],
            escapes: [
                {
                    token: "constant.language.escape",
                    regex: /\\([a-fA-F\d]{1,6}|[^a-fA-F\d])/
                }
            ]
        };
        this.normalizeRules();
    };
    oop.inherits(CssHighlightRules, TextHighlightRules);
    exports.CssHighlightRules = CssHighlightRules;
});
ace.define("ace/mode/jsdoc_comment_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var JsDocCommentHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: [
                        "comment.doc.tag",
                        "comment.doc.text",
                        "lparen.doc"
                    ],
                    regex: "(@(?:param|member|typedef|property|namespace|var|const|callback))(\\s*)({)",
                    push: [
                        {
                            token: "lparen.doc",
                            regex: "{",
                            push: [
                                {
                                    include: "doc-syntax"
                                },
                                {
                                    token: "rparen.doc",
                                    regex: "}|(?=$)",
                                    next: "pop"
                                }
                            ]
                        },
                        {
                            token: [
                                "rparen.doc",
                                "text.doc",
                                "variable.parameter.doc",
                                "lparen.doc",
                                "variable.parameter.doc",
                                "rparen.doc"
                            ],
                            regex: /(})(\s*)(?:([\w=:\/\.]+)|(?:(\[)([\w=:\/\.\-\'\" ]+)(\])))/,
                            next: "pop"
                        },
                        {
                            token: "rparen.doc",
                            regex: "}|(?=$)",
                            next: "pop"
                        },
                        {
                            include: "doc-syntax"
                        },
                        {
                            defaultToken: "text.doc"
                        }
                    ]
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "lparen.doc"
                    ],
                    regex: "(@(?:returns?|yields|type|this|suppress|public|protected|private|package|modifies|implements|external|exception|throws|enum|define|extends))(\\s*)({)",
                    push: [
                        {
                            token: "lparen.doc",
                            regex: "{",
                            push: [
                                {
                                    include: "doc-syntax"
                                },
                                {
                                    token: "rparen.doc",
                                    regex: "}|(?=$)",
                                    next: "pop"
                                }
                            ]
                        },
                        {
                            token: "rparen.doc",
                            regex: "}|(?=$)",
                            next: "pop"
                        },
                        {
                            include: "doc-syntax"
                        },
                        {
                            defaultToken: "text.doc"
                        }
                    ]
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "variable.parameter.doc"
                    ],
                    regex: '(@(?:alias|memberof|instance|module|name|lends|namespace|external|this|template|requires|param|implements|function|extends|typedef|mixes|constructor|var|memberof\\!|event|listens|exports|class|constructs|interface|emits|fires|throws|const|callback|borrows|augments))(\\s+)(\\w[\\w#.:/~"\\-]*)?'
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "variable.parameter.doc"
                    ],
                    regex: "(@method)(\\s+)(\\w[\\w.\\(\\)]*)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@access\\s+(?:private|public|protected)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@kind\\s+(?:class|constant|event|external|file|function|member|mixin|module|namespace|typedef)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@\\w+(?=\\s|$)"
                },
                JsDocCommentHighlightRules.getTagRule(),
                {
                    defaultToken: "comment.doc.body",
                    caseInsensitive: true
                }
            ],
            "doc-syntax": [
                {
                    token: "operator.doc",
                    regex: /[|:]/
                },
                {
                    token: "paren.doc",
                    regex: /[\[\]]/
                }
            ]
        };
        this.normalizeRules();
    };
    oop.inherits(JsDocCommentHighlightRules, TextHighlightRules);
    JsDocCommentHighlightRules.getTagRule = function(start) {
        return {
            token: "comment.doc.tag.storage.type",
            regex: "\\b(?:TODO|FIXME|XXX|HACK)\\b"
        };
    };
    JsDocCommentHighlightRules.getStartRule = function(start) {
        return {
            token: "comment.doc",
            regex: /\/\*\*(?!\/)/,
            next: start
        };
    };
    JsDocCommentHighlightRules.getEndRule = function(start) {
        return {
            token: "comment.doc",
            regex: "\\*\\/",
            next: start
        };
    };
    exports.JsDocCommentHighlightRules = JsDocCommentHighlightRules;
});
ace.define("ace/mode/javascript_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/jsdoc_comment_highlight_rules",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var DocCommentHighlightRules = require("./jsdoc_comment_highlight_rules").JsDocCommentHighlightRules;
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var identifierRe = "[a-zA-Z\\$_\xa1-\uFFFF][a-zA-Z\\d\\$_\xa1-\uFFFF]*";
    var JavaScriptHighlightRules = function(options) {
        var keywords = {
            "variable.language": "Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|Symbol|Namespace|QName|XML|XMLList|ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|SyntaxError|TypeError|URIError|decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|isNaN|parseFloat|parseInt|JSON|Math|this|arguments|prototype|window|document",
            "keyword": "const|yield|import|get|set|async|await|break|case|catch|continue|default|delete|do|else|finally|for|if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|__parent__|__count__|escape|unescape|with|__proto__|class|enum|extends|super|export|implements|private|public|interface|package|protected|static|constructor",
            "storage.type": "const|let|var|function",
            "constant.language": "null|Infinity|NaN|undefined",
            "support.function": "alert",
            "constant.language.boolean": "true|false"
        };
        var keywordMapper = this.createKeywordMapper(keywords, "identifier");
        var kwBeforeRe = "case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void";
        var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|u{[0-9a-fA-F]{1,6}}|[0-2][0-7]{0,2}|3[0-7][0-7]?|[4-7][0-7]?|.)";
        var anonymousFunctionRe = "(function)(\\s*)(\\*?)";
        var functionCallStartRule = {
            token: [
                "identifier",
                "text",
                "paren.lparen"
            ],
            regex: "(\\b(?!" + Object.values(keywords).join("|") + "\\b)" + identifierRe + ")(\\s*)(\\()"
        };
        this.$rules = {
            "no_regex": [
                DocCommentHighlightRules.getStartRule("doc-start"),
                comments("no_regex"),
                functionCallStartRule,
                {
                    token: "string",
                    regex: "'(?=.)",
                    next: "qstring"
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    next: "qqstring"
                },
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
                },
                {
                    token: "constant.numeric",
                    regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
                },
                {
                    token: [
                        "entity.name.function",
                        "text",
                        "keyword.operator",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\s*)(=)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(function)(?:(?:(\\s*)(\\*)(\\s*))|(\\s+))(" + identifierRe + ")(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "entity.name.function",
                        "text",
                        "punctuation.operator",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\s*)(:)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "text",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(:)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: "keyword",
                    regex: "from(?=\\s*('|\"))"
                },
                {
                    token: "keyword",
                    regex: "(?:" + kwBeforeRe + ")\\b",
                    next: "start"
                },
                {
                    token: "support.constant",
                    regex: /that\b/
                },
                {
                    token: [
                        "storage.type",
                        "punctuation.operator",
                        "support.function.firebug"
                    ],
                    regex: /(console)(\.)(warn|info|log|error|debug|time|trace|timeEnd|assert)\b/
                },
                {
                    token: keywordMapper,
                    regex: identifierRe
                },
                {
                    token: "punctuation.operator",
                    regex: /[.](?![.])/,
                    next: "property"
                },
                {
                    token: "storage.type",
                    regex: /=>/,
                    next: "start"
                },
                {
                    token: "keyword.operator",
                    regex: /--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,
                    next: "start"
                },
                {
                    token: "punctuation.operator",
                    regex: /[?:,;.]/,
                    next: "start"
                },
                {
                    token: "paren.lparen",
                    regex: /[\[({]/,
                    next: "start"
                },
                {
                    token: "paren.rparen",
                    regex: /[\])}]/
                },
                {
                    token: "comment",
                    regex: /^#!.*$/
                }
            ],
            property: [
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "keyword.operator",
                    regex: /=/
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(function)(?:(?:(\\s*)(\\*)(\\s*))|(\\s+))(\\w+)(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: "punctuation.operator",
                    regex: /[.](?![.])/
                },
                {
                    token: "support.function",
                    regex: "prototype"
                },
                {
                    token: "support.function",
                    regex: /(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|lter|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward|rEach)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/
                },
                {
                    token: "support.function.dom",
                    regex: /(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/
                },
                {
                    token: "support.constant",
                    regex: /(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/
                },
                {
                    token: "identifier",
                    regex: identifierRe
                },
                {
                    regex: "",
                    token: "empty",
                    next: "no_regex"
                }
            ],
            "start": [
                DocCommentHighlightRules.getStartRule("doc-start"),
                comments("start"),
                {
                    token: "string.regexp",
                    regex: "\\/",
                    next: "regex"
                },
                {
                    token: "text",
                    regex: "\\s+|^$",
                    next: "start"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "regex": [
                {
                    token: "regexp.keyword.operator",
                    regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
                },
                {
                    token: "string.regexp",
                    regex: "/[sxngimy]*",
                    next: "no_regex"
                },
                {
                    token: "invalid",
                    regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
                },
                {
                    token: "constant.language.escape",
                    regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
                },
                {
                    token: "constant.language.delimiter",
                    regex: /\|/
                },
                {
                    token: "constant.language.escape",
                    regex: /\[\^?/,
                    next: "regex_character_class"
                },
                {
                    token: "empty",
                    regex: "$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string.regexp"
                }
            ],
            "regex_character_class": [
                {
                    token: "regexp.charclass.keyword.operator",
                    regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
                },
                {
                    token: "constant.language.escape",
                    regex: "]",
                    next: "regex"
                },
                {
                    token: "constant.language.escape",
                    regex: "-"
                },
                {
                    token: "empty",
                    regex: "$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string.regexp.charachterclass"
                }
            ],
            "default_parameter": [
                {
                    token: "string",
                    regex: "'(?=.)",
                    push: [
                        {
                            token: "string",
                            regex: "'|$",
                            next: "pop"
                        },
                        {
                            include: "qstring"
                        }
                    ]
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    push: [
                        {
                            token: "string",
                            regex: '"|$',
                            next: "pop"
                        },
                        {
                            include: "qqstring"
                        }
                    ]
                },
                {
                    token: "constant.language",
                    regex: "null|Infinity|NaN|undefined"
                },
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
                },
                {
                    token: "constant.numeric",
                    regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
                },
                {
                    token: "punctuation.operator",
                    regex: ",",
                    next: "function_arguments"
                },
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.operator",
                    regex: "$"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "function_arguments": [
                comments("function_arguments"),
                {
                    token: "variable.parameter",
                    regex: identifierRe
                },
                {
                    token: "punctuation.operator",
                    regex: ","
                },
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.operator",
                    regex: "$"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "qqstring": [
                {
                    token: "constant.language.escape",
                    regex: escapedRe
                },
                {
                    token: "string",
                    regex: "\\\\$",
                    consumeLineEnd: true
                },
                {
                    token: "string",
                    regex: '"|$',
                    next: "no_regex"
                },
                {
                    defaultToken: "string"
                }
            ],
            "qstring": [
                {
                    token: "constant.language.escape",
                    regex: escapedRe
                },
                {
                    token: "string",
                    regex: "\\\\$",
                    consumeLineEnd: true
                },
                {
                    token: "string",
                    regex: "'|$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string"
                }
            ]
        };
        if (!options || !options.noES6) {
            this.$rules.no_regex.unshift({
                regex: "[{}]",
                onMatch: function(val, state, stack) {
                    this.next = val == "{" ? this.nextState : "";
                    if (val == "{" && stack.length) stack.unshift("start", state);
                    else if (val == "}" && stack.length) {
                        stack.shift();
                        this.next = stack.shift();
                        if (this.next.indexOf("string") != -1 || this.next.indexOf("jsx") != -1) return "paren.quasi.end";
                    }
                    return val == "{" ? "paren.lparen" : "paren.rparen";
                },
                nextState: "start"
            }, {
                token: "string.quasi.start",
                regex: /`/,
                push: [
                    {
                        token: "constant.language.escape",
                        regex: escapedRe
                    },
                    {
                        token: "paren.quasi.start",
                        regex: /\${/,
                        push: "start"
                    },
                    {
                        token: "string.quasi.end",
                        regex: /`/,
                        next: "pop"
                    },
                    {
                        defaultToken: "string.quasi"
                    }
                ]
            }, {
                token: [
                    "variable.parameter",
                    "text"
                ],
                regex: "(" + identifierRe + ")(\\s*)(?=\\=>)"
            }, {
                token: "paren.lparen",
                regex: "(\\()(?=[^\\(]+\\s*=>)",
                next: "function_arguments"
            }, {
                token: "variable.language",
                regex: "(?:(?:(?:Weak)?(?:Set|Map))|Promise)\\b"
            });
            this.$rules["function_arguments"].unshift({
                token: "keyword.operator",
                regex: "=",
                next: "default_parameter"
            }, {
                token: "keyword.operator",
                regex: "\\.{3}"
            });
            this.$rules["property"].unshift({
                token: "support.function",
                regex: "(findIndex|repeat|startsWith|endsWith|includes|isSafeInteger|trunc|cbrt|log2|log10|sign|then|catch|finally|resolve|reject|race|any|all|allSettled|keys|entries|isInteger)\\b(?=\\()"
            }, {
                token: "constant.language",
                regex: "(?:MAX_SAFE_INTEGER|MIN_SAFE_INTEGER|EPSILON)\\b"
            });
            if (!options || options.jsx != false) JSX.call(this);
        }
        this.embedRules(DocCommentHighlightRules, "doc-", [
            DocCommentHighlightRules.getEndRule("no_regex")
        ]);
        this.normalizeRules();
    };
    oop.inherits(JavaScriptHighlightRules, TextHighlightRules);
    function JSX() {
        var tagRegex = identifierRe.replace("\\d", "\\d\\-");
        var jsxTag = {
            onMatch: function(val, state, stack) {
                var offset = val.charAt(1) == "/" ? 2 : 1;
                if (offset == 1) {
                    if (state != this.nextState) stack.unshift(this.next, this.nextState, 0);
                    else stack.unshift(this.next);
                    stack[2]++;
                } else if (offset == 2) {
                    if (state == this.nextState) {
                        stack[1]--;
                        if (!stack[1] || stack[1] < 0) {
                            stack.shift();
                            stack.shift();
                        }
                    }
                }
                return [
                    {
                        type: "meta.tag.punctuation." + (offset == 1 ? "" : "end-") + "tag-open.xml",
                        value: val.slice(0, offset)
                    },
                    {
                        type: "meta.tag.tag-name.xml",
                        value: val.substr(offset)
                    }
                ];
            },
            regex: "</?(?:" + tagRegex + "|(?=>))",
            next: "jsxAttributes",
            nextState: "jsx"
        };
        this.$rules.start.unshift(jsxTag);
        var jsxJsRule = {
            regex: "{",
            token: "paren.quasi.start",
            push: "start"
        };
        this.$rules.jsx = [
            jsxJsRule,
            jsxTag,
            {
                include: "reference"
            },
            {
                defaultToken: "string.xml"
            }
        ];
        this.$rules.jsxAttributes = [
            {
                token: "meta.tag.punctuation.tag-close.xml",
                regex: "/?>",
                onMatch: function(value, currentState, stack) {
                    if (currentState == stack[0]) stack.shift();
                    if (value.length == 2) {
                        if (stack[0] == this.nextState) stack[1]--;
                        if (!stack[1] || stack[1] < 0) stack.splice(0, 2);
                    }
                    this.next = stack[0] || "start";
                    return [
                        {
                            type: this.token,
                            value: value
                        }
                    ];
                },
                nextState: "jsx"
            },
            jsxJsRule,
            comments("jsxAttributes"),
            {
                token: "entity.other.attribute-name.xml",
                regex: tagRegex
            },
            {
                token: "keyword.operator.attribute-equals.xml",
                regex: "="
            },
            {
                token: "text.tag-whitespace.xml",
                regex: "\\s+"
            },
            {
                token: "string.attribute-value.xml",
                regex: "'",
                stateName: "jsx_attr_q",
                push: [
                    {
                        token: "string.attribute-value.xml",
                        regex: "'",
                        next: "pop"
                    },
                    {
                        include: "reference"
                    },
                    {
                        defaultToken: "string.attribute-value.xml"
                    }
                ]
            },
            {
                token: "string.attribute-value.xml",
                regex: '"',
                stateName: "jsx_attr_qq",
                push: [
                    {
                        token: "string.attribute-value.xml",
                        regex: '"',
                        next: "pop"
                    },
                    {
                        include: "reference"
                    },
                    {
                        defaultToken: "string.attribute-value.xml"
                    }
                ]
            },
            jsxTag
        ];
        this.$rules.reference = [
            {
                token: "constant.language.escape.reference.xml",
                regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
            }
        ];
    }
    function comments(next) {
        return [
            {
                token: "comment",
                regex: /\/\*/,
                next: [
                    DocCommentHighlightRules.getTagRule(),
                    {
                        token: "comment",
                        regex: "\\*\\/",
                        next: next || "pop"
                    },
                    {
                        defaultToken: "comment",
                        caseInsensitive: true
                    }
                ]
            },
            {
                token: "comment",
                regex: "\\/\\/",
                next: [
                    DocCommentHighlightRules.getTagRule(),
                    {
                        token: "comment",
                        regex: "$|^",
                        next: next || "pop"
                    },
                    {
                        defaultToken: "comment",
                        caseInsensitive: true
                    }
                ]
            }
        ];
    }
    exports.JavaScriptHighlightRules = JavaScriptHighlightRules;
});
ace.define("ace/mode/xml_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var XmlHighlightRules = function(normalize) {
        var tagRegex = "[_:a-zA-Z\xc0-\uFFFF][-_:.a-zA-Z0-9\xc0-\uFFFF]*";
        this.$rules = {
            start: [
                {
                    token: "string.cdata.xml",
                    regex: "<\\!\\[CDATA\\[",
                    next: "cdata"
                },
                {
                    token: [
                        "punctuation.instruction.xml",
                        "keyword.instruction.xml"
                    ],
                    regex: "(<\\?)(" + tagRegex + ")",
                    next: "processing_instruction"
                },
                {
                    token: "comment.start.xml",
                    regex: "<\\!--",
                    next: "comment"
                },
                {
                    token: [
                        "xml-pe.doctype.xml",
                        "xml-pe.doctype.xml"
                    ],
                    regex: "(<\\!)(DOCTYPE)(?=[\\s])",
                    next: "doctype",
                    caseInsensitive: true
                },
                {
                    include: "tag"
                },
                {
                    token: "text.end-tag-open.xml",
                    regex: "</"
                },
                {
                    token: "text.tag-open.xml",
                    regex: "<"
                },
                {
                    include: "reference"
                },
                {
                    defaultToken: "text.xml"
                }
            ],
            processing_instruction: [
                {
                    token: "entity.other.attribute-name.decl-attribute-name.xml",
                    regex: tagRegex
                },
                {
                    token: "keyword.operator.decl-attribute-equals.xml",
                    regex: "="
                },
                {
                    include: "whitespace"
                },
                {
                    include: "string"
                },
                {
                    token: "punctuation.xml-decl.xml",
                    regex: "\\?>",
                    next: "start"
                }
            ],
            doctype: [
                {
                    include: "whitespace"
                },
                {
                    include: "string"
                },
                {
                    token: "xml-pe.doctype.xml",
                    regex: ">",
                    next: "start"
                },
                {
                    token: "xml-pe.xml",
                    regex: "[-_a-zA-Z0-9:]+"
                },
                {
                    token: "punctuation.int-subset",
                    regex: "\\[",
                    push: "int_subset"
                }
            ],
            int_subset: [
                {
                    token: "text.xml",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.int-subset.xml",
                    regex: "]",
                    next: "pop"
                },
                {
                    token: [
                        "punctuation.markup-decl.xml",
                        "keyword.markup-decl.xml"
                    ],
                    regex: "(<\\!)(" + tagRegex + ")",
                    push: [
                        {
                            token: "text",
                            regex: "\\s+"
                        },
                        {
                            token: "punctuation.markup-decl.xml",
                            regex: ">",
                            next: "pop"
                        },
                        {
                            include: "string"
                        }
                    ]
                }
            ],
            cdata: [
                {
                    token: "string.cdata.xml",
                    regex: "\\]\\]>",
                    next: "start"
                },
                {
                    token: "text.xml",
                    regex: "\\s+"
                },
                {
                    token: "text.xml",
                    regex: "(?:[^\\]]|\\](?!\\]>))+"
                }
            ],
            comment: [
                {
                    token: "comment.end.xml",
                    regex: "-->",
                    next: "start"
                },
                {
                    defaultToken: "comment.xml"
                }
            ],
            reference: [
                {
                    token: "constant.language.escape.reference.xml",
                    regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
                }
            ],
            attr_reference: [
                {
                    token: "constant.language.escape.reference.attribute-value.xml",
                    regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
                }
            ],
            tag: [
                {
                    token: [
                        "meta.tag.punctuation.tag-open.xml",
                        "meta.tag.punctuation.end-tag-open.xml",
                        "meta.tag.tag-name.xml"
                    ],
                    regex: "(?:(<)|(</))((?:" + tagRegex + ":)?" + tagRegex + ")",
                    next: [
                        {
                            include: "attributes"
                        },
                        {
                            token: "meta.tag.punctuation.tag-close.xml",
                            regex: "/?>",
                            next: "start"
                        }
                    ]
                }
            ],
            tag_whitespace: [
                {
                    token: "text.tag-whitespace.xml",
                    regex: "\\s+"
                }
            ],
            whitespace: [
                {
                    token: "text.whitespace.xml",
                    regex: "\\s+"
                }
            ],
            string: [
                {
                    token: "string.xml",
                    regex: "'",
                    push: [
                        {
                            token: "string.xml",
                            regex: "'",
                            next: "pop"
                        },
                        {
                            defaultToken: "string.xml"
                        }
                    ]
                },
                {
                    token: "string.xml",
                    regex: '"',
                    push: [
                        {
                            token: "string.xml",
                            regex: '"',
                            next: "pop"
                        },
                        {
                            defaultToken: "string.xml"
                        }
                    ]
                }
            ],
            attributes: [
                {
                    token: "entity.other.attribute-name.xml",
                    regex: tagRegex
                },
                {
                    token: "keyword.operator.attribute-equals.xml",
                    regex: "="
                },
                {
                    include: "tag_whitespace"
                },
                {
                    include: "attribute_value"
                }
            ],
            attribute_value: [
                {
                    token: "string.attribute-value.xml",
                    regex: "'",
                    push: [
                        {
                            token: "string.attribute-value.xml",
                            regex: "'",
                            next: "pop"
                        },
                        {
                            include: "attr_reference"
                        },
                        {
                            defaultToken: "string.attribute-value.xml"
                        }
                    ]
                },
                {
                    token: "string.attribute-value.xml",
                    regex: '"',
                    push: [
                        {
                            token: "string.attribute-value.xml",
                            regex: '"',
                            next: "pop"
                        },
                        {
                            include: "attr_reference"
                        },
                        {
                            defaultToken: "string.attribute-value.xml"
                        }
                    ]
                }
            ]
        };
        if (this.constructor === XmlHighlightRules) this.normalizeRules();
    };
    (function() {
        this.embedTagRules = function(HighlightRules, prefix, tag) {
            this.$rules.tag.unshift({
                token: [
                    "meta.tag.punctuation.tag-open.xml",
                    "meta.tag." + tag + ".tag-name.xml"
                ],
                regex: "(<)(" + tag + "(?=\\s|>|$))",
                next: [
                    {
                        include: "attributes"
                    },
                    {
                        token: "meta.tag.punctuation.tag-close.xml",
                        regex: "/?>",
                        next: prefix + "start"
                    }
                ]
            });
            this.$rules[tag + "-end"] = [
                {
                    include: "attributes"
                },
                {
                    token: "meta.tag.punctuation.tag-close.xml",
                    regex: "/?>",
                    next: "start",
                    onMatch: function(value, currentState, stack) {
                        stack.splice(0);
                        return this.token;
                    }
                }
            ];
            this.embedRules(HighlightRules, prefix, [
                {
                    token: [
                        "meta.tag.punctuation.end-tag-open.xml",
                        "meta.tag." + tag + ".tag-name.xml"
                    ],
                    regex: "(</)(" + tag + "(?=\\s|>|$))",
                    next: tag + "-end"
                },
                {
                    token: "string.cdata.xml",
                    regex: "<\\!\\[CDATA\\["
                },
                {
                    token: "string.cdata.xml",
                    regex: "\\]\\]>"
                }
            ]);
        };
    }).call(TextHighlightRules.prototype);
    oop.inherits(XmlHighlightRules, TextHighlightRules);
    exports.XmlHighlightRules = XmlHighlightRules;
});
ace.define("ace/mode/html_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/mode/css_highlight_rules",
    "ace/mode/javascript_highlight_rules",
    "ace/mode/xml_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var lang = require("../lib/lang");
    var CssHighlightRules = require("./css_highlight_rules").CssHighlightRules;
    var JavaScriptHighlightRules = require("./javascript_highlight_rules").JavaScriptHighlightRules;
    var XmlHighlightRules = require("./xml_highlight_rules").XmlHighlightRules;
    var tagMap = lang.createMap({
        a: "anchor",
        button: "form",
        form: "form",
        img: "image",
        input: "form",
        label: "form",
        option: "form",
        script: "script",
        select: "form",
        textarea: "form",
        style: "style",
        table: "table",
        tbody: "table",
        td: "table",
        tfoot: "table",
        th: "table",
        tr: "table"
    });
    var HtmlHighlightRules = function() {
        XmlHighlightRules.call(this);
        this.addRules({
            attributes: [
                {
                    include: "tag_whitespace"
                },
                {
                    token: "entity.other.attribute-name.xml",
                    regex: "[-_a-zA-Z0-9:.]+"
                },
                {
                    token: "keyword.operator.attribute-equals.xml",
                    regex: "=",
                    push: [
                        {
                            include: "tag_whitespace"
                        },
                        {
                            token: "string.unquoted.attribute-value.html",
                            regex: "[^<>='\"`\\s]+",
                            next: "pop"
                        },
                        {
                            token: "empty",
                            regex: "",
                            next: "pop"
                        }
                    ]
                },
                {
                    include: "attribute_value"
                }
            ],
            tag: [
                {
                    token: function(start, tag) {
                        var group = tagMap[tag];
                        return [
                            "meta.tag.punctuation." + (start == "<" ? "" : "end-") + "tag-open.xml",
                            "meta.tag" + (group ? "." + group : "") + ".tag-name.xml"
                        ];
                    },
                    regex: "(</?)([-_a-zA-Z0-9:.]+)",
                    next: "tag_stuff"
                }
            ],
            tag_stuff: [
                {
                    include: "attributes"
                },
                {
                    token: "meta.tag.punctuation.tag-close.xml",
                    regex: "/?>",
                    next: "start"
                }
            ]
        });
        this.embedTagRules(CssHighlightRules, "css-", "style");
        this.embedTagRules(new JavaScriptHighlightRules({
            jsx: false
        }).getRules(), "js-", "script");
        if (this.constructor === HtmlHighlightRules) this.normalizeRules();
    };
    oop.inherits(HtmlHighlightRules, XmlHighlightRules);
    exports.HtmlHighlightRules = HtmlHighlightRules;
});
ace.define("ace/mode/php_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/mode/doc_comment_highlight_rules",
    "ace/mode/text_highlight_rules",
    "ace/mode/html_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var lang = require("../lib/lang");
    var DocCommentHighlightRules = require("./doc_comment_highlight_rules").DocCommentHighlightRules;
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var HtmlHighlightRules = require("./html_highlight_rules").HtmlHighlightRules;
    var PhpLangHighlightRules = function() {
        var docComment = DocCommentHighlightRules;
        var builtinFunctions = lang.arrayToMap("abs|acos|acosh|addcslashes|addslashes|aggregate|aggregate_info|aggregate_methods|aggregate_methods_by_list|aggregate_methods_by_regexp|aggregate_properties|aggregate_properties_by_list|aggregate_properties_by_regexp|aggregation_info|amqpconnection|amqpexchange|amqpqueue|apache_child_terminate|apache_get_modules|apache_get_version|apache_getenv|apache_lookup_uri|apache_note|apache_request_headers|apache_reset_timeout|apache_response_headers|apache_setenv|apc_add|apc_bin_dump|apc_bin_dumpfile|apc_bin_load|apc_bin_loadfile|apc_cache_info|apc_cas|apc_clear_cache|apc_compile_file|apc_dec|apc_define_constants|apc_delete|apc_delete_file|apc_exists|apc_fetch|apc_inc|apc_load_constants|apc_sma_info|apc_store|apciterator|apd_breakpoint|apd_callstack|apd_clunk|apd_continue|apd_croak|apd_dump_function_table|apd_dump_persistent_resources|apd_dump_regular_resources|apd_echo|apd_get_active_symbols|apd_set_pprof_trace|apd_set_session|apd_set_session_trace|apd_set_session_trace_socket|appenditerator|array|array_change_key_case|array_chunk|array_column|array_combine|array_count_values|array_diff|array_diff_assoc|array_diff_key|array_diff_uassoc|array_diff_ukey|array_fill|array_fill_keys|array_filter|array_flip|array_intersect|array_intersect_assoc|array_intersect_key|array_intersect_uassoc|array_intersect_ukey|array_key_exists|array_keys|array_map|array_merge|array_merge_recursive|array_multisort|array_pad|array_pop|array_product|array_push|array_rand|array_reduce|array_replace|array_replace_recursive|array_reverse|array_search|array_shift|array_slice|array_splice|array_sum|array_udiff|array_udiff_assoc|array_udiff_uassoc|array_uintersect|array_uintersect_assoc|array_uintersect_uassoc|array_unique|array_unshift|array_values|array_walk|array_walk_recursive|arrayaccess|arrayiterator|arrayobject|arsort|asin|asinh|asort|assert|assert_options|atan|atan2|atanh|audioproperties|badfunctioncallexception|badmethodcallexception|base64_decode|base64_encode|base_convert|basename|bbcode_add_element|bbcode_add_smiley|bbcode_create|bbcode_destroy|bbcode_parse|bbcode_set_arg_parser|bbcode_set_flags|bcadd|bccomp|bcdiv|bcmod|bcmul|bcompiler_load|bcompiler_load_exe|bcompiler_parse_class|bcompiler_read|bcompiler_write_class|bcompiler_write_constant|bcompiler_write_exe_footer|bcompiler_write_file|bcompiler_write_footer|bcompiler_write_function|bcompiler_write_functions_from_file|bcompiler_write_header|bcompiler_write_included_filename|bcpow|bcpowmod|bcscale|bcsqrt|bcsub|bin2hex|bind_textdomain_codeset|bindec|bindtextdomain|bson_decode|bson_encode|bumpValue|bzclose|bzcompress|bzdecompress|bzerrno|bzerror|bzerrstr|bzflush|bzopen|bzread|bzwrite|cachingiterator|cairo|cairo_create|cairo_font_face_get_type|cairo_font_face_status|cairo_font_options_create|cairo_font_options_equal|cairo_font_options_get_antialias|cairo_font_options_get_hint_metrics|cairo_font_options_get_hint_style|cairo_font_options_get_subpixel_order|cairo_font_options_hash|cairo_font_options_merge|cairo_font_options_set_antialias|cairo_font_options_set_hint_metrics|cairo_font_options_set_hint_style|cairo_font_options_set_subpixel_order|cairo_font_options_status|cairo_format_stride_for_width|cairo_image_surface_create|cairo_image_surface_create_for_data|cairo_image_surface_create_from_png|cairo_image_surface_get_data|cairo_image_surface_get_format|cairo_image_surface_get_height|cairo_image_surface_get_stride|cairo_image_surface_get_width|cairo_matrix_create_scale|cairo_matrix_create_translate|cairo_matrix_invert|cairo_matrix_multiply|cairo_matrix_rotate|cairo_matrix_transform_distance|cairo_matrix_transform_point|cairo_matrix_translate|cairo_pattern_add_color_stop_rgb|cairo_pattern_add_color_stop_rgba|cairo_pattern_create_for_surface|cairo_pattern_create_linear|cairo_pattern_create_radial|cairo_pattern_create_rgb|cairo_pattern_create_rgba|cairo_pattern_get_color_stop_count|cairo_pattern_get_color_stop_rgba|cairo_pattern_get_extend|cairo_pattern_get_filter|cairo_pattern_get_linear_points|cairo_pattern_get_matrix|cairo_pattern_get_radial_circles|cairo_pattern_get_rgba|cairo_pattern_get_surface|cairo_pattern_get_type|cairo_pattern_set_extend|cairo_pattern_set_filter|cairo_pattern_set_matrix|cairo_pattern_status|cairo_pdf_surface_create|cairo_pdf_surface_set_size|cairo_ps_get_levels|cairo_ps_level_to_string|cairo_ps_surface_create|cairo_ps_surface_dsc_begin_page_setup|cairo_ps_surface_dsc_begin_setup|cairo_ps_surface_dsc_comment|cairo_ps_surface_get_eps|cairo_ps_surface_restrict_to_level|cairo_ps_surface_set_eps|cairo_ps_surface_set_size|cairo_scaled_font_create|cairo_scaled_font_extents|cairo_scaled_font_get_ctm|cairo_scaled_font_get_font_face|cairo_scaled_font_get_font_matrix|cairo_scaled_font_get_font_options|cairo_scaled_font_get_scale_matrix|cairo_scaled_font_get_type|cairo_scaled_font_glyph_extents|cairo_scaled_font_status|cairo_scaled_font_text_extents|cairo_surface_copy_page|cairo_surface_create_similar|cairo_surface_finish|cairo_surface_flush|cairo_surface_get_content|cairo_surface_get_device_offset|cairo_surface_get_font_options|cairo_surface_get_type|cairo_surface_mark_dirty|cairo_surface_mark_dirty_rectangle|cairo_surface_set_device_offset|cairo_surface_set_fallback_resolution|cairo_surface_show_page|cairo_surface_status|cairo_surface_write_to_png|cairo_svg_surface_create|cairo_svg_surface_restrict_to_version|cairo_svg_version_to_string|cairoantialias|cairocontent|cairocontext|cairoexception|cairoextend|cairofillrule|cairofilter|cairofontface|cairofontoptions|cairofontslant|cairofonttype|cairofontweight|cairoformat|cairogradientpattern|cairohintmetrics|cairohintstyle|cairoimagesurface|cairolineargradient|cairolinecap|cairolinejoin|cairomatrix|cairooperator|cairopath|cairopattern|cairopatterntype|cairopdfsurface|cairopslevel|cairopssurface|cairoradialgradient|cairoscaledfont|cairosolidpattern|cairostatus|cairosubpixelorder|cairosurface|cairosurfacepattern|cairosurfacetype|cairosvgsurface|cairosvgversion|cairotoyfontface|cal_days_in_month|cal_from_jd|cal_info|cal_to_jd|calcul_hmac|calculhmac|call_user_func|call_user_func_array|call_user_method|call_user_method_array|callbackfilteriterator|ceil|chdb|chdb_create|chdir|checkdate|checkdnsrr|chgrp|chmod|chop|chown|chr|chroot|chunk_split|class_alias|class_exists|class_implements|class_parents|class_uses|classkit_import|classkit_method_add|classkit_method_copy|classkit_method_redefine|classkit_method_remove|classkit_method_rename|clearstatcache|clone|closedir|closelog|collator|com|com_addref|com_create_guid|com_event_sink|com_get|com_get_active_object|com_invoke|com_isenum|com_load|com_load_typelib|com_message_pump|com_print_typeinfo|com_propget|com_propput|com_propset|com_release|com_set|compact|connection_aborted|connection_status|connection_timeout|constant|construct|construct|construct|convert_cyr_string|convert_uudecode|convert_uuencode|copy|cos|cosh|count|count_chars|countable|counter_bump|counter_bump_value|counter_create|counter_get|counter_get_meta|counter_get_named|counter_get_value|counter_reset|counter_reset_value|crack_check|crack_closedict|crack_getlastmessage|crack_opendict|crc32|create_function|crypt|ctype_alnum|ctype_alpha|ctype_cntrl|ctype_digit|ctype_graph|ctype_lower|ctype_print|ctype_punct|ctype_space|ctype_upper|ctype_xdigit|cubrid_affected_rows|cubrid_bind|cubrid_client_encoding|cubrid_close|cubrid_close_prepare|cubrid_close_request|cubrid_col_get|cubrid_col_size|cubrid_column_names|cubrid_column_types|cubrid_commit|cubrid_connect|cubrid_connect_with_url|cubrid_current_oid|cubrid_data_seek|cubrid_db_name|cubrid_disconnect|cubrid_drop|cubrid_errno|cubrid_error|cubrid_error_code|cubrid_error_code_facility|cubrid_error_msg|cubrid_execute|cubrid_fetch|cubrid_fetch_array|cubrid_fetch_assoc|cubrid_fetch_field|cubrid_fetch_lengths|cubrid_fetch_object|cubrid_fetch_row|cubrid_field_flags|cubrid_field_len|cubrid_field_name|cubrid_field_seek|cubrid_field_table|cubrid_field_type|cubrid_free_result|cubrid_get|cubrid_get_autocommit|cubrid_get_charset|cubrid_get_class_name|cubrid_get_client_info|cubrid_get_db_parameter|cubrid_get_server_info|cubrid_insert_id|cubrid_is_instance|cubrid_list_dbs|cubrid_load_from_glo|cubrid_lob_close|cubrid_lob_export|cubrid_lob_get|cubrid_lob_send|cubrid_lob_size|cubrid_lock_read|cubrid_lock_write|cubrid_move_cursor|cubrid_new_glo|cubrid_next_result|cubrid_num_cols|cubrid_num_fields|cubrid_num_rows|cubrid_ping|cubrid_prepare|cubrid_put|cubrid_query|cubrid_real_escape_string|cubrid_result|cubrid_rollback|cubrid_save_to_glo|cubrid_schema|cubrid_send_glo|cubrid_seq_drop|cubrid_seq_insert|cubrid_seq_put|cubrid_set_add|cubrid_set_autocommit|cubrid_set_db_parameter|cubrid_set_drop|cubrid_unbuffered_query|cubrid_version|curl_close|curl_copy_handle|curl_errno|curl_error|curl_exec|curl_getinfo|curl_init|curl_multi_add_handle|curl_multi_close|curl_multi_exec|curl_multi_getcontent|curl_multi_info_read|curl_multi_init|curl_multi_remove_handle|curl_multi_select|curl_setopt|curl_setopt_array|curl_version|current|cyrus_authenticate|cyrus_bind|cyrus_close|cyrus_connect|cyrus_query|cyrus_unbind|date|date_add|date_create|date_create_from_format|date_date_set|date_default_timezone_get|date_default_timezone_set|date_diff|date_format|date_get_last_errors|date_interval_create_from_date_string|date_interval_format|date_isodate_set|date_modify|date_offset_get|date_parse|date_parse_from_format|date_sub|date_sun_info|date_sunrise|date_sunset|date_time_set|date_timestamp_get|date_timestamp_set|date_timezone_get|date_timezone_set|dateinterval|dateperiod|datetime|datetimezone|db2_autocommit|db2_bind_param|db2_client_info|db2_close|db2_column_privileges|db2_columns|db2_commit|db2_conn_error|db2_conn_errormsg|db2_connect|db2_cursor_type|db2_escape_string|db2_exec|db2_execute|db2_fetch_array|db2_fetch_assoc|db2_fetch_both|db2_fetch_object|db2_fetch_row|db2_field_display_size|db2_field_name|db2_field_num|db2_field_precision|db2_field_scale|db2_field_type|db2_field_width|db2_foreign_keys|db2_free_result|db2_free_stmt|db2_get_option|db2_last_insert_id|db2_lob_read|db2_next_result|db2_num_fields|db2_num_rows|db2_pclose|db2_pconnect|db2_prepare|db2_primary_keys|db2_procedure_columns|db2_procedures|db2_result|db2_rollback|db2_server_info|db2_set_option|db2_special_columns|db2_statistics|db2_stmt_error|db2_stmt_errormsg|db2_table_privileges|db2_tables|dba_close|dba_delete|dba_exists|dba_fetch|dba_firstkey|dba_handlers|dba_insert|dba_key_split|dba_list|dba_nextkey|dba_open|dba_optimize|dba_popen|dba_replace|dba_sync|dbase_add_record|dbase_close|dbase_create|dbase_delete_record|dbase_get_header_info|dbase_get_record|dbase_get_record_with_names|dbase_numfields|dbase_numrecords|dbase_open|dbase_pack|dbase_replace_record|dbplus_add|dbplus_aql|dbplus_chdir|dbplus_close|dbplus_curr|dbplus_errcode|dbplus_errno|dbplus_find|dbplus_first|dbplus_flush|dbplus_freealllocks|dbplus_freelock|dbplus_freerlocks|dbplus_getlock|dbplus_getunique|dbplus_info|dbplus_last|dbplus_lockrel|dbplus_next|dbplus_open|dbplus_prev|dbplus_rchperm|dbplus_rcreate|dbplus_rcrtexact|dbplus_rcrtlike|dbplus_resolve|dbplus_restorepos|dbplus_rkeys|dbplus_ropen|dbplus_rquery|dbplus_rrename|dbplus_rsecindex|dbplus_runlink|dbplus_rzap|dbplus_savepos|dbplus_setindex|dbplus_setindexbynumber|dbplus_sql|dbplus_tcl|dbplus_tremove|dbplus_undo|dbplus_undoprepare|dbplus_unlockrel|dbplus_unselect|dbplus_update|dbplus_xlockrel|dbplus_xunlockrel|dbx_close|dbx_compare|dbx_connect|dbx_error|dbx_escape_string|dbx_fetch_row|dbx_query|dbx_sort|dcgettext|dcngettext|deaggregate|debug_backtrace|debug_print_backtrace|debug_zval_dump|decbin|dechex|decoct|define|define_syslog_variables|defined|deg2rad|delete|dgettext|die|dio_close|dio_fcntl|dio_open|dio_read|dio_seek|dio_stat|dio_tcsetattr|dio_truncate|dio_write|dir|directoryiterator|dirname|disk_free_space|disk_total_space|diskfreespace|dl|dngettext|dns_check_record|dns_get_mx|dns_get_record|dom_import_simplexml|domainexception|domattr|domattribute_name|domattribute_set_value|domattribute_specified|domattribute_value|domcharacterdata|domcomment|domdocument|domdocument_add_root|domdocument_create_attribute|domdocument_create_cdata_section|domdocument_create_comment|domdocument_create_element|domdocument_create_element_ns|domdocument_create_entity_reference|domdocument_create_processing_instruction|domdocument_create_text_node|domdocument_doctype|domdocument_document_element|domdocument_dump_file|domdocument_dump_mem|domdocument_get_element_by_id|domdocument_get_elements_by_tagname|domdocument_html_dump_mem|domdocument_xinclude|domdocumentfragment|domdocumenttype|domdocumenttype_entities|domdocumenttype_internal_subset|domdocumenttype_name|domdocumenttype_notations|domdocumenttype_public_id|domdocumenttype_system_id|domelement|domelement_get_attribute|domelement_get_attribute_node|domelement_get_elements_by_tagname|domelement_has_attribute|domelement_remove_attribute|domelement_set_attribute|domelement_set_attribute_node|domelement_tagname|domentity|domentityreference|domexception|domimplementation|domnamednodemap|domnode|domnode_add_namespace|domnode_append_child|domnode_append_sibling|domnode_attributes|domnode_child_nodes|domnode_clone_node|domnode_dump_node|domnode_first_child|domnode_get_content|domnode_has_attributes|domnode_has_child_nodes|domnode_insert_before|domnode_is_blank_node|domnode_last_child|domnode_next_sibling|domnode_node_name|domnode_node_type|domnode_node_value|domnode_owner_document|domnode_parent_node|domnode_prefix|domnode_previous_sibling|domnode_remove_child|domnode_replace_child|domnode_replace_node|domnode_set_content|domnode_set_name|domnode_set_namespace|domnode_unlink_node|domnodelist|domnotation|domprocessinginstruction|domprocessinginstruction_data|domprocessinginstruction_target|domtext|domxml_new_doc|domxml_open_file|domxml_open_mem|domxml_version|domxml_xmltree|domxml_xslt_stylesheet|domxml_xslt_stylesheet_doc|domxml_xslt_stylesheet_file|domxml_xslt_version|domxpath|domxsltstylesheet_process|domxsltstylesheet_result_dump_file|domxsltstylesheet_result_dump_mem|dotnet|dotnet_load|doubleval|each|easter_date|easter_days|echo|empty|emptyiterator|enchant_broker_describe|enchant_broker_dict_exists|enchant_broker_free|enchant_broker_free_dict|enchant_broker_get_error|enchant_broker_init|enchant_broker_list_dicts|enchant_broker_request_dict|enchant_broker_request_pwl_dict|enchant_broker_set_ordering|enchant_dict_add_to_personal|enchant_dict_add_to_session|enchant_dict_check|enchant_dict_describe|enchant_dict_get_error|enchant_dict_is_in_session|enchant_dict_quick_check|enchant_dict_store_replacement|enchant_dict_suggest|end|ereg|ereg_replace|eregi|eregi_replace|error_get_last|error_log|error_reporting|errorexception|escapeshellarg|escapeshellcmd|eval|event_add|event_base_free|event_base_loop|event_base_loopbreak|event_base_loopexit|event_base_new|event_base_priority_init|event_base_set|event_buffer_base_set|event_buffer_disable|event_buffer_enable|event_buffer_fd_set|event_buffer_free|event_buffer_new|event_buffer_priority_set|event_buffer_read|event_buffer_set_callback|event_buffer_timeout_set|event_buffer_watermark_set|event_buffer_write|event_del|event_free|event_new|event_set|exception|exec|exif_imagetype|exif_read_data|exif_tagname|exif_thumbnail|exit|exp|expect_expectl|expect_popen|explode|expm1|export|export|extension_loaded|extract|ezmlm_hash|fam_cancel_monitor|fam_close|fam_monitor_collection|fam_monitor_directory|fam_monitor_file|fam_next_event|fam_open|fam_pending|fam_resume_monitor|fam_suspend_monitor|fbsql_affected_rows|fbsql_autocommit|fbsql_blob_size|fbsql_change_user|fbsql_clob_size|fbsql_close|fbsql_commit|fbsql_connect|fbsql_create_blob|fbsql_create_clob|fbsql_create_db|fbsql_data_seek|fbsql_database|fbsql_database_password|fbsql_db_query|fbsql_db_status|fbsql_drop_db|fbsql_errno|fbsql_error|fbsql_fetch_array|fbsql_fetch_assoc|fbsql_fetch_field|fbsql_fetch_lengths|fbsql_fetch_object|fbsql_fetch_row|fbsql_field_flags|fbsql_field_len|fbsql_field_name|fbsql_field_seek|fbsql_field_table|fbsql_field_type|fbsql_free_result|fbsql_get_autostart_info|fbsql_hostname|fbsql_insert_id|fbsql_list_dbs|fbsql_list_fields|fbsql_list_tables|fbsql_next_result|fbsql_num_fields|fbsql_num_rows|fbsql_password|fbsql_pconnect|fbsql_query|fbsql_read_blob|fbsql_read_clob|fbsql_result|fbsql_rollback|fbsql_rows_fetched|fbsql_select_db|fbsql_set_characterset|fbsql_set_lob_mode|fbsql_set_password|fbsql_set_transaction|fbsql_start_db|fbsql_stop_db|fbsql_table_name|fbsql_tablename|fbsql_username|fbsql_warnings|fclose|fdf_add_doc_javascript|fdf_add_template|fdf_close|fdf_create|fdf_enum_values|fdf_errno|fdf_error|fdf_get_ap|fdf_get_attachment|fdf_get_encoding|fdf_get_file|fdf_get_flags|fdf_get_opt|fdf_get_status|fdf_get_value|fdf_get_version|fdf_header|fdf_next_field_name|fdf_open|fdf_open_string|fdf_remove_item|fdf_save|fdf_save_string|fdf_set_ap|fdf_set_encoding|fdf_set_file|fdf_set_flags|fdf_set_javascript_action|fdf_set_on_import_javascript|fdf_set_opt|fdf_set_status|fdf_set_submit_form_action|fdf_set_target_frame|fdf_set_value|fdf_set_version|feof|fflush|fgetc|fgetcsv|fgets|fgetss|file|file_exists|file_get_contents|file_put_contents|fileatime|filectime|filegroup|fileinode|filemtime|fileowner|fileperms|filepro|filepro_fieldcount|filepro_fieldname|filepro_fieldtype|filepro_fieldwidth|filepro_retrieve|filepro_rowcount|filesize|filesystemiterator|filetype|filter_has_var|filter_id|filter_input|filter_input_array|filter_list|filter_var|filter_var_array|filteriterator|finfo_buffer|finfo_close|finfo_file|finfo_open|finfo_set_flags|floatval|flock|floor|flush|fmod|fnmatch|fopen|forward_static_call|forward_static_call_array|fpassthru|fprintf|fputcsv|fputs|fread|frenchtojd|fribidi_log2vis|fscanf|fseek|fsockopen|fstat|ftell|ftok|ftp_alloc|ftp_cdup|ftp_chdir|ftp_chmod|ftp_close|ftp_connect|ftp_delete|ftp_exec|ftp_fget|ftp_fput|ftp_get|ftp_get_option|ftp_login|ftp_mdtm|ftp_mkdir|ftp_nb_continue|ftp_nb_fget|ftp_nb_fput|ftp_nb_get|ftp_nb_put|ftp_nlist|ftp_pasv|ftp_put|ftp_pwd|ftp_quit|ftp_raw|ftp_rawlist|ftp_rename|ftp_rmdir|ftp_set_option|ftp_site|ftp_size|ftp_ssl_connect|ftp_systype|ftruncate|func_get_arg|func_get_args|func_num_args|function_exists|fwrite|gc_collect_cycles|gc_disable|gc_enable|gc_enabled|gd_info|gearmanclient|gearmanjob|gearmantask|gearmanworker|geoip_continent_code_by_name|geoip_country_code3_by_name|geoip_country_code_by_name|geoip_country_name_by_name|geoip_database_info|geoip_db_avail|geoip_db_filename|geoip_db_get_all_info|geoip_id_by_name|geoip_isp_by_name|geoip_org_by_name|geoip_record_by_name|geoip_region_by_name|geoip_region_name_by_code|geoip_time_zone_by_country_and_region|getMeta|getNamed|getValue|get_browser|get_called_class|get_cfg_var|get_class|get_class_methods|get_class_vars|get_current_user|get_declared_classes|get_declared_interfaces|get_declared_traits|get_defined_constants|get_defined_functions|get_defined_vars|get_extension_funcs|get_headers|get_html_translation_table|get_include_path|get_included_files|get_loaded_extensions|get_magic_quotes_gpc|get_magic_quotes_runtime|get_meta_tags|get_object_vars|get_parent_class|get_required_files|get_resource_type|getallheaders|getconstant|getconstants|getconstructor|getcwd|getdate|getdefaultproperties|getdoccomment|getendline|getenv|getextension|getextensionname|getfilename|gethostbyaddr|gethostbyname|gethostbynamel|gethostname|getimagesize|getinterfacenames|getinterfaces|getlastmod|getmethod|getmethods|getmodifiers|getmxrr|getmygid|getmyinode|getmypid|getmyuid|getname|getnamespacename|getopt|getparentclass|getproperties|getproperty|getprotobyname|getprotobynumber|getrandmax|getrusage|getservbyname|getservbyport|getshortname|getstartline|getstaticproperties|getstaticpropertyvalue|gettext|gettimeofday|gettype|glob|globiterator|gmagick|gmagickdraw|gmagickpixel|gmdate|gmmktime|gmp_abs|gmp_add|gmp_and|gmp_clrbit|gmp_cmp|gmp_com|gmp_div|gmp_div_q|gmp_div_qr|gmp_div_r|gmp_divexact|gmp_fact|gmp_gcd|gmp_gcdext|gmp_hamdist|gmp_init|gmp_intval|gmp_invert|gmp_jacobi|gmp_legendre|gmp_mod|gmp_mul|gmp_neg|gmp_nextprime|gmp_or|gmp_perfect_square|gmp_popcount|gmp_pow|gmp_powm|gmp_prob_prime|gmp_random|gmp_scan0|gmp_scan1|gmp_setbit|gmp_sign|gmp_sqrt|gmp_sqrtrem|gmp_strval|gmp_sub|gmp_testbit|gmp_xor|gmstrftime|gnupg_adddecryptkey|gnupg_addencryptkey|gnupg_addsignkey|gnupg_cleardecryptkeys|gnupg_clearencryptkeys|gnupg_clearsignkeys|gnupg_decrypt|gnupg_decryptverify|gnupg_encrypt|gnupg_encryptsign|gnupg_export|gnupg_geterror|gnupg_getprotocol|gnupg_import|gnupg_init|gnupg_keyinfo|gnupg_setarmor|gnupg_seterrormode|gnupg_setsignmode|gnupg_sign|gnupg_verify|gopher_parsedir|grapheme_extract|grapheme_stripos|grapheme_stristr|grapheme_strlen|grapheme_strpos|grapheme_strripos|grapheme_strrpos|grapheme_strstr|grapheme_substr|gregoriantojd|gupnp_context_get_host_ip|gupnp_context_get_port|gupnp_context_get_subscription_timeout|gupnp_context_host_path|gupnp_context_new|gupnp_context_set_subscription_timeout|gupnp_context_timeout_add|gupnp_context_unhost_path|gupnp_control_point_browse_start|gupnp_control_point_browse_stop|gupnp_control_point_callback_set|gupnp_control_point_new|gupnp_device_action_callback_set|gupnp_device_info_get|gupnp_device_info_get_service|gupnp_root_device_get_available|gupnp_root_device_get_relative_location|gupnp_root_device_new|gupnp_root_device_set_available|gupnp_root_device_start|gupnp_root_device_stop|gupnp_service_action_get|gupnp_service_action_return|gupnp_service_action_return_error|gupnp_service_action_set|gupnp_service_freeze_notify|gupnp_service_info_get|gupnp_service_info_get_introspection|gupnp_service_introspection_get_state_variable|gupnp_service_notify|gupnp_service_proxy_action_get|gupnp_service_proxy_action_set|gupnp_service_proxy_add_notify|gupnp_service_proxy_callback_set|gupnp_service_proxy_get_subscribed|gupnp_service_proxy_remove_notify|gupnp_service_proxy_set_subscribed|gupnp_service_thaw_notify|gzclose|gzcompress|gzdecode|gzdeflate|gzencode|gzeof|gzfile|gzgetc|gzgets|gzgetss|gzinflate|gzopen|gzpassthru|gzputs|gzread|gzrewind|gzseek|gztell|gzuncompress|gzwrite|halt_compiler|haruannotation|haruannotation_setborderstyle|haruannotation_sethighlightmode|haruannotation_seticon|haruannotation_setopened|harudestination|harudestination_setfit|harudestination_setfitb|harudestination_setfitbh|harudestination_setfitbv|harudestination_setfith|harudestination_setfitr|harudestination_setfitv|harudestination_setxyz|harudoc|harudoc_addpage|harudoc_addpagelabel|harudoc_construct|harudoc_createoutline|harudoc_getcurrentencoder|harudoc_getcurrentpage|harudoc_getencoder|harudoc_getfont|harudoc_getinfoattr|harudoc_getpagelayout|harudoc_getpagemode|harudoc_getstreamsize|harudoc_insertpage|harudoc_loadjpeg|harudoc_loadpng|harudoc_loadraw|harudoc_loadttc|harudoc_loadttf|harudoc_loadtype1|harudoc_output|harudoc_readfromstream|harudoc_reseterror|harudoc_resetstream|harudoc_save|harudoc_savetostream|harudoc_setcompressionmode|harudoc_setcurrentencoder|harudoc_setencryptionmode|harudoc_setinfoattr|harudoc_setinfodateattr|harudoc_setopenaction|harudoc_setpagelayout|harudoc_setpagemode|harudoc_setpagesconfiguration|harudoc_setpassword|harudoc_setpermission|harudoc_usecnsencodings|harudoc_usecnsfonts|harudoc_usecntencodings|harudoc_usecntfonts|harudoc_usejpencodings|harudoc_usejpfonts|harudoc_usekrencodings|harudoc_usekrfonts|haruencoder|haruencoder_getbytetype|haruencoder_gettype|haruencoder_getunicode|haruencoder_getwritingmode|haruexception|harufont|harufont_getascent|harufont_getcapheight|harufont_getdescent|harufont_getencodingname|harufont_getfontname|harufont_gettextwidth|harufont_getunicodewidth|harufont_getxheight|harufont_measuretext|haruimage|haruimage_getbitspercomponent|haruimage_getcolorspace|haruimage_getheight|haruimage_getsize|haruimage_getwidth|haruimage_setcolormask|haruimage_setmaskimage|haruoutline|haruoutline_setdestination|haruoutline_setopened|harupage|harupage_arc|harupage_begintext|harupage_circle|harupage_closepath|harupage_concat|harupage_createdestination|harupage_createlinkannotation|harupage_createtextannotation|harupage_createurlannotation|harupage_curveto|harupage_curveto2|harupage_curveto3|harupage_drawimage|harupage_ellipse|harupage_endpath|harupage_endtext|harupage_eofill|harupage_eofillstroke|harupage_fill|harupage_fillstroke|harupage_getcharspace|harupage_getcmykfill|harupage_getcmykstroke|harupage_getcurrentfont|harupage_getcurrentfontsize|harupage_getcurrentpos|harupage_getcurrenttextpos|harupage_getdash|harupage_getfillingcolorspace|harupage_getflatness|harupage_getgmode|harupage_getgrayfill|harupage_getgraystroke|harupage_getheight|harupage_gethorizontalscaling|harupage_getlinecap|harupage_getlinejoin|harupage_getlinewidth|harupage_getmiterlimit|harupage_getrgbfill|harupage_getrgbstroke|harupage_getstrokingcolorspace|harupage_gettextleading|harupage_gettextmatrix|harupage_gettextrenderingmode|harupage_gettextrise|harupage_gettextwidth|harupage_gettransmatrix|harupage_getwidth|harupage_getwordspace|harupage_lineto|harupage_measuretext|harupage_movetextpos|harupage_moveto|harupage_movetonextline|harupage_rectangle|harupage_setcharspace|harupage_setcmykfill|harupage_setcmykstroke|harupage_setdash|harupage_setflatness|harupage_setfontandsize|harupage_setgrayfill|harupage_setgraystroke|harupage_setheight|harupage_sethorizontalscaling|harupage_setlinecap|harupage_setlinejoin|harupage_setlinewidth|harupage_setmiterlimit|harupage_setrgbfill|harupage_setrgbstroke|harupage_setrotate|harupage_setsize|harupage_setslideshow|harupage_settextleading|harupage_settextmatrix|harupage_settextrenderingmode|harupage_settextrise|harupage_setwidth|harupage_setwordspace|harupage_showtext|harupage_showtextnextline|harupage_stroke|harupage_textout|harupage_textrect|hasconstant|hash|hash_algos|hash_copy|hash_file|hash_final|hash_hmac|hash_hmac_file|hash_init|hash_update|hash_update_file|hash_update_stream|hasmethod|hasproperty|header|header_register_callback|header_remove|headers_list|headers_sent|hebrev|hebrevc|hex2bin|hexdec|highlight_file|highlight_string|html_entity_decode|htmlentities|htmlspecialchars|htmlspecialchars_decode|http_build_cookie|http_build_query|http_build_str|http_build_url|http_cache_etag|http_cache_last_modified|http_chunked_decode|http_date|http_deflate|http_get|http_get_request_body|http_get_request_body_stream|http_get_request_headers|http_head|http_inflate|http_match_etag|http_match_modified|http_match_request_header|http_negotiate_charset|http_negotiate_content_type|http_negotiate_language|http_parse_cookie|http_parse_headers|http_parse_message|http_parse_params|http_persistent_handles_clean|http_persistent_handles_count|http_persistent_handles_ident|http_post_data|http_post_fields|http_put_data|http_put_file|http_put_stream|http_redirect|http_request|http_request_body_encode|http_request_method_exists|http_request_method_name|http_request_method_register|http_request_method_unregister|http_response_code|http_send_content_disposition|http_send_content_type|http_send_data|http_send_file|http_send_last_modified|http_send_status|http_send_stream|http_support|http_throttle|httpdeflatestream|httpdeflatestream_construct|httpdeflatestream_factory|httpdeflatestream_finish|httpdeflatestream_flush|httpdeflatestream_update|httpinflatestream|httpinflatestream_construct|httpinflatestream_factory|httpinflatestream_finish|httpinflatestream_flush|httpinflatestream_update|httpmessage|httpmessage_addheaders|httpmessage_construct|httpmessage_detach|httpmessage_factory|httpmessage_fromenv|httpmessage_fromstring|httpmessage_getbody|httpmessage_getheader|httpmessage_getheaders|httpmessage_gethttpversion|httpmessage_getparentmessage|httpmessage_getrequestmethod|httpmessage_getrequesturl|httpmessage_getresponsecode|httpmessage_getresponsestatus|httpmessage_gettype|httpmessage_guesscontenttype|httpmessage_prepend|httpmessage_reverse|httpmessage_send|httpmessage_setbody|httpmessage_setheaders|httpmessage_sethttpversion|httpmessage_setrequestmethod|httpmessage_setrequesturl|httpmessage_setresponsecode|httpmessage_setresponsestatus|httpmessage_settype|httpmessage_tomessagetypeobject|httpmessage_tostring|httpquerystring|httpquerystring_construct|httpquerystring_get|httpquerystring_mod|httpquerystring_set|httpquerystring_singleton|httpquerystring_toarray|httpquerystring_tostring|httpquerystring_xlate|httprequest|httprequest_addcookies|httprequest_addheaders|httprequest_addpostfields|httprequest_addpostfile|httprequest_addputdata|httprequest_addquerydata|httprequest_addrawpostdata|httprequest_addssloptions|httprequest_clearhistory|httprequest_construct|httprequest_enablecookies|httprequest_getcontenttype|httprequest_getcookies|httprequest_getheaders|httprequest_gethistory|httprequest_getmethod|httprequest_getoptions|httprequest_getpostfields|httprequest_getpostfiles|httprequest_getputdata|httprequest_getputfile|httprequest_getquerydata|httprequest_getrawpostdata|httprequest_getrawrequestmessage|httprequest_getrawresponsemessage|httprequest_getrequestmessage|httprequest_getresponsebody|httprequest_getresponsecode|httprequest_getresponsecookies|httprequest_getresponsedata|httprequest_getresponseheader|httprequest_getresponseinfo|httprequest_getresponsemessage|httprequest_getresponsestatus|httprequest_getssloptions|httprequest_geturl|httprequest_resetcookies|httprequest_send|httprequest_setcontenttype|httprequest_setcookies|httprequest_setheaders|httprequest_setmethod|httprequest_setoptions|httprequest_setpostfields|httprequest_setpostfiles|httprequest_setputdata|httprequest_setputfile|httprequest_setquerydata|httprequest_setrawpostdata|httprequest_setssloptions|httprequest_seturl|httprequestpool|httprequestpool_attach|httprequestpool_construct|httprequestpool_destruct|httprequestpool_detach|httprequestpool_getattachedrequests|httprequestpool_getfinishedrequests|httprequestpool_reset|httprequestpool_send|httprequestpool_socketperform|httprequestpool_socketselect|httpresponse|httpresponse_capture|httpresponse_getbuffersize|httpresponse_getcache|httpresponse_getcachecontrol|httpresponse_getcontentdisposition|httpresponse_getcontenttype|httpresponse_getdata|httpresponse_getetag|httpresponse_getfile|httpresponse_getgzip|httpresponse_getheader|httpresponse_getlastmodified|httpresponse_getrequestbody|httpresponse_getrequestbodystream|httpresponse_getrequestheaders|httpresponse_getstream|httpresponse_getthrottledelay|httpresponse_guesscontenttype|httpresponse_redirect|httpresponse_send|httpresponse_setbuffersize|httpresponse_setcache|httpresponse_setcachecontrol|httpresponse_setcontentdisposition|httpresponse_setcontenttype|httpresponse_setdata|httpresponse_setetag|httpresponse_setfile|httpresponse_setgzip|httpresponse_setheader|httpresponse_setlastmodified|httpresponse_setstream|httpresponse_setthrottledelay|httpresponse_status|hw_array2objrec|hw_changeobject|hw_children|hw_childrenobj|hw_close|hw_connect|hw_connection_info|hw_cp|hw_deleteobject|hw_docbyanchor|hw_docbyanchorobj|hw_document_attributes|hw_document_bodytag|hw_document_content|hw_document_setcontent|hw_document_size|hw_dummy|hw_edittext|hw_error|hw_errormsg|hw_free_document|hw_getanchors|hw_getanchorsobj|hw_getandlock|hw_getchildcoll|hw_getchildcollobj|hw_getchilddoccoll|hw_getchilddoccollobj|hw_getobject|hw_getobjectbyquery|hw_getobjectbyquerycoll|hw_getobjectbyquerycollobj|hw_getobjectbyqueryobj|hw_getparents|hw_getparentsobj|hw_getrellink|hw_getremote|hw_getremotechildren|hw_getsrcbydestobj|hw_gettext|hw_getusername|hw_identify|hw_incollections|hw_info|hw_inscoll|hw_insdoc|hw_insertanchors|hw_insertdocument|hw_insertobject|hw_mapid|hw_modifyobject|hw_mv|hw_new_document|hw_objrec2array|hw_output_document|hw_pconnect|hw_pipedocument|hw_root|hw_setlinkroot|hw_stat|hw_unlock|hw_who|hwapi_attribute|hwapi_attribute_key|hwapi_attribute_langdepvalue|hwapi_attribute_value|hwapi_attribute_values|hwapi_checkin|hwapi_checkout|hwapi_children|hwapi_content|hwapi_content_mimetype|hwapi_content_read|hwapi_copy|hwapi_dbstat|hwapi_dcstat|hwapi_dstanchors|hwapi_dstofsrcanchor|hwapi_error_count|hwapi_error_reason|hwapi_find|hwapi_ftstat|hwapi_hgcsp|hwapi_hwstat|hwapi_identify|hwapi_info|hwapi_insert|hwapi_insertanchor|hwapi_insertcollection|hwapi_insertdocument|hwapi_link|hwapi_lock|hwapi_move|hwapi_new_content|hwapi_object|hwapi_object_assign|hwapi_object_attreditable|hwapi_object_count|hwapi_object_insert|hwapi_object_new|hwapi_object_remove|hwapi_object_title|hwapi_object_value|hwapi_objectbyanchor|hwapi_parents|hwapi_reason_description|hwapi_reason_type|hwapi_remove|hwapi_replace|hwapi_setcommittedversion|hwapi_srcanchors|hwapi_srcsofdst|hwapi_unlock|hwapi_user|hwapi_userlist|hypot|ibase_add_user|ibase_affected_rows|ibase_backup|ibase_blob_add|ibase_blob_cancel|ibase_blob_close|ibase_blob_create|ibase_blob_echo|ibase_blob_get|ibase_blob_import|ibase_blob_info|ibase_blob_open|ibase_close|ibase_commit|ibase_commit_ret|ibase_connect|ibase_db_info|ibase_delete_user|ibase_drop_db|ibase_errcode|ibase_errmsg|ibase_execute|ibase_fetch_assoc|ibase_fetch_object|ibase_fetch_row|ibase_field_info|ibase_free_event_handler|ibase_free_query|ibase_free_result|ibase_gen_id|ibase_maintain_db|ibase_modify_user|ibase_name_result|ibase_num_fields|ibase_num_params|ibase_param_info|ibase_pconnect|ibase_prepare|ibase_query|ibase_restore|ibase_rollback|ibase_rollback_ret|ibase_server_info|ibase_service_attach|ibase_service_detach|ibase_set_event_handler|ibase_timefmt|ibase_trans|ibase_wait_event|iconv|iconv_get_encoding|iconv_mime_decode|iconv_mime_decode_headers|iconv_mime_encode|iconv_set_encoding|iconv_strlen|iconv_strpos|iconv_strrpos|iconv_substr|id3_get_frame_long_name|id3_get_frame_short_name|id3_get_genre_id|id3_get_genre_list|id3_get_genre_name|id3_get_tag|id3_get_version|id3_remove_tag|id3_set_tag|id3v2attachedpictureframe|id3v2frame|id3v2tag|idate|idn_to_ascii|idn_to_unicode|idn_to_utf8|ifx_affected_rows|ifx_blobinfile_mode|ifx_byteasvarchar|ifx_close|ifx_connect|ifx_copy_blob|ifx_create_blob|ifx_create_char|ifx_do|ifx_error|ifx_errormsg|ifx_fetch_row|ifx_fieldproperties|ifx_fieldtypes|ifx_free_blob|ifx_free_char|ifx_free_result|ifx_get_blob|ifx_get_char|ifx_getsqlca|ifx_htmltbl_result|ifx_nullformat|ifx_num_fields|ifx_num_rows|ifx_pconnect|ifx_prepare|ifx_query|ifx_textasvarchar|ifx_update_blob|ifx_update_char|ifxus_close_slob|ifxus_create_slob|ifxus_free_slob|ifxus_open_slob|ifxus_read_slob|ifxus_seek_slob|ifxus_tell_slob|ifxus_write_slob|ignore_user_abort|iis_add_server|iis_get_dir_security|iis_get_script_map|iis_get_server_by_comment|iis_get_server_by_path|iis_get_server_rights|iis_get_service_state|iis_remove_server|iis_set_app_settings|iis_set_dir_security|iis_set_script_map|iis_set_server_rights|iis_start_server|iis_start_service|iis_stop_server|iis_stop_service|image2wbmp|image_type_to_extension|image_type_to_mime_type|imagealphablending|imageantialias|imagearc|imagechar|imagecharup|imagecolorallocate|imagecolorallocatealpha|imagecolorat|imagecolorclosest|imagecolorclosestalpha|imagecolorclosesthwb|imagecolordeallocate|imagecolorexact|imagecolorexactalpha|imagecolormatch|imagecolorresolve|imagecolorresolvealpha|imagecolorset|imagecolorsforindex|imagecolorstotal|imagecolortransparent|imageconvolution|imagecopy|imagecopymerge|imagecopymergegray|imagecopyresampled|imagecopyresized|imagecreate|imagecreatefromgd|imagecreatefromgd2|imagecreatefromgd2part|imagecreatefromgif|imagecreatefromjpeg|imagecreatefrompng|imagecreatefromstring|imagecreatefromwbmp|imagecreatefromxbm|imagecreatefromxpm|imagecreatetruecolor|imagedashedline|imagedestroy|imageellipse|imagefill|imagefilledarc|imagefilledellipse|imagefilledpolygon|imagefilledrectangle|imagefilltoborder|imagefilter|imagefontheight|imagefontwidth|imageftbbox|imagefttext|imagegammacorrect|imagegd|imagegd2|imagegif|imagegrabscreen|imagegrabwindow|imageinterlace|imageistruecolor|imagejpeg|imagelayereffect|imageline|imageloadfont|imagepalettecopy|imagepng|imagepolygon|imagepsbbox|imagepsencodefont|imagepsextendfont|imagepsfreefont|imagepsloadfont|imagepsslantfont|imagepstext|imagerectangle|imagerotate|imagesavealpha|imagesetbrush|imagesetpixel|imagesetstyle|imagesetthickness|imagesettile|imagestring|imagestringup|imagesx|imagesy|imagetruecolortopalette|imagettfbbox|imagettftext|imagetypes|imagewbmp|imagexbm|imagick|imagick_adaptiveblurimage|imagick_adaptiveresizeimage|imagick_adaptivesharpenimage|imagick_adaptivethresholdimage|imagick_addimage|imagick_addnoiseimage|imagick_affinetransformimage|imagick_animateimages|imagick_annotateimage|imagick_appendimages|imagick_averageimages|imagick_blackthresholdimage|imagick_blurimage|imagick_borderimage|imagick_charcoalimage|imagick_chopimage|imagick_clear|imagick_clipimage|imagick_clippathimage|imagick_clone|imagick_clutimage|imagick_coalesceimages|imagick_colorfloodfillimage|imagick_colorizeimage|imagick_combineimages|imagick_commentimage|imagick_compareimagechannels|imagick_compareimagelayers|imagick_compareimages|imagick_compositeimage|imagick_construct|imagick_contrastimage|imagick_contraststretchimage|imagick_convolveimage|imagick_cropimage|imagick_cropthumbnailimage|imagick_current|imagick_cyclecolormapimage|imagick_decipherimage|imagick_deconstructimages|imagick_deleteimageartifact|imagick_despeckleimage|imagick_destroy|imagick_displayimage|imagick_displayimages|imagick_distortimage|imagick_drawimage|imagick_edgeimage|imagick_embossimage|imagick_encipherimage|imagick_enhanceimage|imagick_equalizeimage|imagick_evaluateimage|imagick_extentimage|imagick_flattenimages|imagick_flipimage|imagick_floodfillpaintimage|imagick_flopimage|imagick_frameimage|imagick_fximage|imagick_gammaimage|imagick_gaussianblurimage|imagick_getcolorspace|imagick_getcompression|imagick_getcompressionquality|imagick_getcopyright|imagick_getfilename|imagick_getfont|imagick_getformat|imagick_getgravity|imagick_gethomeurl|imagick_getimage|imagick_getimagealphachannel|imagick_getimageartifact|imagick_getimagebackgroundcolor|imagick_getimageblob|imagick_getimageblueprimary|imagick_getimagebordercolor|imagick_getimagechanneldepth|imagick_getimagechanneldistortion|imagick_getimagechanneldistortions|imagick_getimagechannelextrema|imagick_getimagechannelmean|imagick_getimagechannelrange|imagick_getimagechannelstatistics|imagick_getimageclipmask|imagick_getimagecolormapcolor|imagick_getimagecolors|imagick_getimagecolorspace|imagick_getimagecompose|imagick_getimagecompression|imagick_getimagecompressionquality|imagick_getimagedelay|imagick_getimagedepth|imagick_getimagedispose|imagick_getimagedistortion|imagick_getimageextrema|imagick_getimagefilename|imagick_getimageformat|imagick_getimagegamma|imagick_getimagegeometry|imagick_getimagegravity|imagick_getimagegreenprimary|imagick_getimageheight|imagick_getimagehistogram|imagick_getimageindex|imagick_getimageinterlacescheme|imagick_getimageinterpolatemethod|imagick_getimageiterations|imagick_getimagelength|imagick_getimagemagicklicense|imagick_getimagematte|imagick_getimagemattecolor|imagick_getimageorientation|imagick_getimagepage|imagick_getimagepixelcolor|imagick_getimageprofile|imagick_getimageprofiles|imagick_getimageproperties|imagick_getimageproperty|imagick_getimageredprimary|imagick_getimageregion|imagick_getimagerenderingintent|imagick_getimageresolution|imagick_getimagesblob|imagick_getimagescene|imagick_getimagesignature|imagick_getimagesize|imagick_getimagetickspersecond|imagick_getimagetotalinkdensity|imagick_getimagetype|imagick_getimageunits|imagick_getimagevirtualpixelmethod|imagick_getimagewhitepoint|imagick_getimagewidth|imagick_getinterlacescheme|imagick_getiteratorindex|imagick_getnumberimages|imagick_getoption|imagick_getpackagename|imagick_getpage|imagick_getpixeliterator|imagick_getpixelregioniterator|imagick_getpointsize|imagick_getquantumdepth|imagick_getquantumrange|imagick_getreleasedate|imagick_getresource|imagick_getresourcelimit|imagick_getsamplingfactors|imagick_getsize|imagick_getsizeoffset|imagick_getversion|imagick_hasnextimage|imagick_haspreviousimage|imagick_identifyimage|imagick_implodeimage|imagick_labelimage|imagick_levelimage|imagick_linearstretchimage|imagick_liquidrescaleimage|imagick_magnifyimage|imagick_mapimage|imagick_mattefloodfillimage|imagick_medianfilterimage|imagick_mergeimagelayers|imagick_minifyimage|imagick_modulateimage|imagick_montageimage|imagick_morphimages|imagick_mosaicimages|imagick_motionblurimage|imagick_negateimage|imagick_newimage|imagick_newpseudoimage|imagick_nextimage|imagick_normalizeimage|imagick_oilpaintimage|imagick_opaquepaintimage|imagick_optimizeimagelayers|imagick_orderedposterizeimage|imagick_paintfloodfillimage|imagick_paintopaqueimage|imagick_painttransparentimage|imagick_pingimage|imagick_pingimageblob|imagick_pingimagefile|imagick_polaroidimage|imagick_posterizeimage|imagick_previewimages|imagick_previousimage|imagick_profileimage|imagick_quantizeimage|imagick_quantizeimages|imagick_queryfontmetrics|imagick_queryfonts|imagick_queryformats|imagick_radialblurimage|imagick_raiseimage|imagick_randomthresholdimage|imagick_readimage|imagick_readimageblob|imagick_readimagefile|imagick_recolorimage|imagick_reducenoiseimage|imagick_removeimage|imagick_removeimageprofile|imagick_render|imagick_resampleimage|imagick_resetimagepage|imagick_resizeimage|imagick_rollimage|imagick_rotateimage|imagick_roundcorners|imagick_sampleimage|imagick_scaleimage|imagick_separateimagechannel|imagick_sepiatoneimage|imagick_setbackgroundcolor|imagick_setcolorspace|imagick_setcompression|imagick_setcompressionquality|imagick_setfilename|imagick_setfirstiterator|imagick_setfont|imagick_setformat|imagick_setgravity|imagick_setimage|imagick_setimagealphachannel|imagick_setimageartifact|imagick_setimagebackgroundcolor|imagick_setimagebias|imagick_setimageblueprimary|imagick_setimagebordercolor|imagick_setimagechanneldepth|imagick_setimageclipmask|imagick_setimagecolormapcolor|imagick_setimagecolorspace|imagick_setimagecompose|imagick_setimagecompression|imagick_setimagecompressionquality|imagick_setimagedelay|imagick_setimagedepth|imagick_setimagedispose|imagick_setimageextent|imagick_setimagefilename|imagick_setimageformat|imagick_setimagegamma|imagick_setimagegravity|imagick_setimagegreenprimary|imagick_setimageindex|imagick_setimageinterlacescheme|imagick_setimageinterpolatemethod|imagick_setimageiterations|imagick_setimagematte|imagick_setimagemattecolor|imagick_setimageopacity|imagick_setimageorientation|imagick_setimagepage|imagick_setimageprofile|imagick_setimageproperty|imagick_setimageredprimary|imagick_setimagerenderingintent|imagick_setimageresolution|imagick_setimagescene|imagick_setimagetickspersecond|imagick_setimagetype|imagick_setimageunits|imagick_setimagevirtualpixelmethod|imagick_setimagewhitepoint|imagick_setinterlacescheme|imagick_setiteratorindex|imagick_setlastiterator|imagick_setoption|imagick_setpage|imagick_setpointsize|imagick_setresolution|imagick_setresourcelimit|imagick_setsamplingfactors|imagick_setsize|imagick_setsizeoffset|imagick_settype|imagick_shadeimage|imagick_shadowimage|imagick_sharpenimage|imagick_shaveimage|imagick_shearimage|imagick_sigmoidalcontrastimage|imagick_sketchimage|imagick_solarizeimage|imagick_spliceimage|imagick_spreadimage|imagick_steganoimage|imagick_stereoimage|imagick_stripimage|imagick_swirlimage|imagick_textureimage|imagick_thresholdimage|imagick_thumbnailimage|imagick_tintimage|imagick_transformimage|imagick_transparentpaintimage|imagick_transposeimage|imagick_transverseimage|imagick_trimimage|imagick_uniqueimagecolors|imagick_unsharpmaskimage|imagick_valid|imagick_vignetteimage|imagick_waveimage|imagick_whitethresholdimage|imagick_writeimage|imagick_writeimagefile|imagick_writeimages|imagick_writeimagesfile|imagickdraw|imagickdraw_affine|imagickdraw_annotation|imagickdraw_arc|imagickdraw_bezier|imagickdraw_circle|imagickdraw_clear|imagickdraw_clone|imagickdraw_color|imagickdraw_comment|imagickdraw_composite|imagickdraw_construct|imagickdraw_destroy|imagickdraw_ellipse|imagickdraw_getclippath|imagickdraw_getcliprule|imagickdraw_getclipunits|imagickdraw_getfillcolor|imagickdraw_getfillopacity|imagickdraw_getfillrule|imagickdraw_getfont|imagickdraw_getfontfamily|imagickdraw_getfontsize|imagickdraw_getfontstyle|imagickdraw_getfontweight|imagickdraw_getgravity|imagickdraw_getstrokeantialias|imagickdraw_getstrokecolor|imagickdraw_getstrokedasharray|imagickdraw_getstrokedashoffset|imagickdraw_getstrokelinecap|imagickdraw_getstrokelinejoin|imagickdraw_getstrokemiterlimit|imagickdraw_getstrokeopacity|imagickdraw_getstrokewidth|imagickdraw_gettextalignment|imagickdraw_gettextantialias|imagickdraw_gettextdecoration|imagickdraw_gettextencoding|imagickdraw_gettextundercolor|imagickdraw_getvectorgraphics|imagickdraw_line|imagickdraw_matte|imagickdraw_pathclose|imagickdraw_pathcurvetoabsolute|imagickdraw_pathcurvetoquadraticbezierabsolute|imagickdraw_pathcurvetoquadraticbezierrelative|imagickdraw_pathcurvetoquadraticbeziersmoothabsolute|imagickdraw_pathcurvetoquadraticbeziersmoothrelative|imagickdraw_pathcurvetorelative|imagickdraw_pathcurvetosmoothabsolute|imagickdraw_pathcurvetosmoothrelative|imagickdraw_pathellipticarcabsolute|imagickdraw_pathellipticarcrelative|imagickdraw_pathfinish|imagickdraw_pathlinetoabsolute|imagickdraw_pathlinetohorizontalabsolute|imagickdraw_pathlinetohorizontalrelative|imagickdraw_pathlinetorelative|imagickdraw_pathlinetoverticalabsolute|imagickdraw_pathlinetoverticalrelative|imagickdraw_pathmovetoabsolute|imagickdraw_pathmovetorelative|imagickdraw_pathstart|imagickdraw_point|imagickdraw_polygon|imagickdraw_polyline|imagickdraw_pop|imagickdraw_popclippath|imagickdraw_popdefs|imagickdraw_poppattern|imagickdraw_push|imagickdraw_pushclippath|imagickdraw_pushdefs|imagickdraw_pushpattern|imagickdraw_rectangle|imagickdraw_render|imagickdraw_rotate|imagickdraw_roundrectangle|imagickdraw_scale|imagickdraw_setclippath|imagickdraw_setcliprule|imagickdraw_setclipunits|imagickdraw_setfillalpha|imagickdraw_setfillcolor|imagickdraw_setfillopacity|imagickdraw_setfillpatternurl|imagickdraw_setfillrule|imagickdraw_setfont|imagickdraw_setfontfamily|imagickdraw_setfontsize|imagickdraw_setfontstretch|imagickdraw_setfontstyle|imagickdraw_setfontweight|imagickdraw_setgravity|imagickdraw_setstrokealpha|imagickdraw_setstrokeantialias|imagickdraw_setstrokecolor|imagickdraw_setstrokedasharray|imagickdraw_setstrokedashoffset|imagickdraw_setstrokelinecap|imagickdraw_setstrokelinejoin|imagickdraw_setstrokemiterlimit|imagickdraw_setstrokeopacity|imagickdraw_setstrokepatternurl|imagickdraw_setstrokewidth|imagickdraw_settextalignment|imagickdraw_settextantialias|imagickdraw_settextdecoration|imagickdraw_settextencoding|imagickdraw_settextundercolor|imagickdraw_setvectorgraphics|imagickdraw_setviewbox|imagickdraw_skewx|imagickdraw_skewy|imagickdraw_translate|imagickpixel|imagickpixel_clear|imagickpixel_construct|imagickpixel_destroy|imagickpixel_getcolor|imagickpixel_getcolorasstring|imagickpixel_getcolorcount|imagickpixel_getcolorvalue|imagickpixel_gethsl|imagickpixel_issimilar|imagickpixel_setcolor|imagickpixel_setcolorvalue|imagickpixel_sethsl|imagickpixeliterator|imagickpixeliterator_clear|imagickpixeliterator_construct|imagickpixeliterator_destroy|imagickpixeliterator_getcurrentiteratorrow|imagickpixeliterator_getiteratorrow|imagickpixeliterator_getnextiteratorrow|imagickpixeliterator_getpreviousiteratorrow|imagickpixeliterator_newpixeliterator|imagickpixeliterator_newpixelregioniterator|imagickpixeliterator_resetiterator|imagickpixeliterator_setiteratorfirstrow|imagickpixeliterator_setiteratorlastrow|imagickpixeliterator_setiteratorrow|imagickpixeliterator_synciterator|imap_8bit|imap_alerts|imap_append|imap_base64|imap_binary|imap_body|imap_bodystruct|imap_check|imap_clearflag_full|imap_close|imap_create|imap_createmailbox|imap_delete|imap_deletemailbox|imap_errors|imap_expunge|imap_fetch_overview|imap_fetchbody|imap_fetchheader|imap_fetchmime|imap_fetchstructure|imap_fetchtext|imap_gc|imap_get_quota|imap_get_quotaroot|imap_getacl|imap_getmailboxes|imap_getsubscribed|imap_header|imap_headerinfo|imap_headers|imap_last_error|imap_list|imap_listmailbox|imap_listscan|imap_listsubscribed|imap_lsub|imap_mail|imap_mail_compose|imap_mail_copy|imap_mail_move|imap_mailboxmsginfo|imap_mime_header_decode|imap_msgno|imap_num_msg|imap_num_recent|imap_open|imap_ping|imap_qprint|imap_rename|imap_renamemailbox|imap_reopen|imap_rfc822_parse_adrlist|imap_rfc822_parse_headers|imap_rfc822_write_address|imap_savebody|imap_scan|imap_scanmailbox|imap_search|imap_set_quota|imap_setacl|imap_setflag_full|imap_sort|imap_status|imap_subscribe|imap_thread|imap_timeout|imap_uid|imap_undelete|imap_unsubscribe|imap_utf7_decode|imap_utf7_encode|imap_utf8|implementsinterface|implode|import_request_variables|in_array|include|include_once|inclued_get_data|inet_ntop|inet_pton|infiniteiterator|ingres_autocommit|ingres_autocommit_state|ingres_charset|ingres_close|ingres_commit|ingres_connect|ingres_cursor|ingres_errno|ingres_error|ingres_errsqlstate|ingres_escape_string|ingres_execute|ingres_fetch_array|ingres_fetch_assoc|ingres_fetch_object|ingres_fetch_proc_return|ingres_fetch_row|ingres_field_length|ingres_field_name|ingres_field_nullable|ingres_field_precision|ingres_field_scale|ingres_field_type|ingres_free_result|ingres_next_error|ingres_num_fields|ingres_num_rows|ingres_pconnect|ingres_prepare|ingres_query|ingres_result_seek|ingres_rollback|ingres_set_environment|ingres_unbuffered_query|ini_alter|ini_get|ini_get_all|ini_restore|ini_set|innamespace|inotify_add_watch|inotify_init|inotify_queue_len|inotify_read|inotify_rm_watch|interface_exists|intl_error_name|intl_get_error_code|intl_get_error_message|intl_is_failure|intldateformatter|intval|invalidargumentexception|invoke|invokeargs|ip2long|iptcembed|iptcparse|is_a|is_array|is_bool|is_callable|is_dir|is_double|is_executable|is_file|is_finite|is_float|is_infinite|is_int|is_integer|is_link|is_long|is_nan|is_null|is_numeric|is_object|is_readable|is_real|is_resource|is_scalar|is_soap_fault|is_string|is_subclass_of|is_uploaded_file|is_writable|is_writeable|isabstract|iscloneable|isdisabled|isfinal|isinstance|isinstantiable|isinterface|isinternal|isiterateable|isset|issubclassof|isuserdefined|iterator|iterator_apply|iterator_count|iterator_to_array|iteratoraggregate|iteratoriterator|java_last_exception_clear|java_last_exception_get|jddayofweek|jdmonthname|jdtofrench|jdtogregorian|jdtojewish|jdtojulian|jdtounix|jewishtojd|join|jpeg2wbmp|json_decode|json_encode|json_last_error|jsonserializable|judy|judy_type|judy_version|juliantojd|kadm5_chpass_principal|kadm5_create_principal|kadm5_delete_principal|kadm5_destroy|kadm5_flush|kadm5_get_policies|kadm5_get_principal|kadm5_get_principals|kadm5_init_with_password|kadm5_modify_principal|key|krsort|ksort|lcfirst|lcg_value|lchgrp|lchown|ldap_8859_to_t61|ldap_add|ldap_bind|ldap_close|ldap_compare|ldap_connect|ldap_count_entries|ldap_delete|ldap_dn2ufn|ldap_err2str|ldap_errno|ldap_error|ldap_explode_dn|ldap_first_attribute|ldap_first_entry|ldap_first_reference|ldap_free_result|ldap_get_attributes|ldap_get_dn|ldap_get_entries|ldap_get_option|ldap_get_values|ldap_get_values_len|ldap_list|ldap_mod_add|ldap_mod_del|ldap_mod_replace|ldap_modify|ldap_next_attribute|ldap_next_entry|ldap_next_reference|ldap_parse_reference|ldap_parse_result|ldap_read|ldap_rename|ldap_sasl_bind|ldap_search|ldap_set_option|ldap_set_rebind_proc|ldap_sort|ldap_start_tls|ldap_t61_to_8859|ldap_unbind|lengthexception|levenshtein|libxml_clear_errors|libxml_disable_entity_loader|libxml_get_errors|libxml_get_last_error|libxml_set_streams_context|libxml_use_internal_errors|libxmlerror|limititerator|link|linkinfo|list|locale|localeconv|localtime|log|log10|log1p|logicexception|long2ip|lstat|ltrim|lzf_compress|lzf_decompress|lzf_optimized_for|m_checkstatus|m_completeauthorizations|m_connect|m_connectionerror|m_deletetrans|m_destroyconn|m_destroyengine|m_getcell|m_getcellbynum|m_getcommadelimited|m_getheader|m_initconn|m_initengine|m_iscommadelimited|m_maxconntimeout|m_monitor|m_numcolumns|m_numrows|m_parsecommadelimited|m_responsekeys|m_responseparam|m_returnstatus|m_setblocking|m_setdropfile|m_setip|m_setssl|m_setssl_cafile|m_setssl_files|m_settimeout|m_sslcert_gen_hash|m_transactionssent|m_transinqueue|m_transkeyval|m_transnew|m_transsend|m_uwait|m_validateidentifier|m_verifyconnection|m_verifysslcert|magic_quotes_runtime|mail|mailparse_determine_best_xfer_encoding|mailparse_msg_create|mailparse_msg_extract_part|mailparse_msg_extract_part_file|mailparse_msg_extract_whole_part_file|mailparse_msg_free|mailparse_msg_get_part|mailparse_msg_get_part_data|mailparse_msg_get_structure|mailparse_msg_parse|mailparse_msg_parse_file|mailparse_rfc822_parse_addresses|mailparse_stream_encode|mailparse_uudecode_all|main|max|maxdb_affected_rows|maxdb_autocommit|maxdb_bind_param|maxdb_bind_result|maxdb_change_user|maxdb_character_set_name|maxdb_client_encoding|maxdb_close|maxdb_close_long_data|maxdb_commit|maxdb_connect|maxdb_connect_errno|maxdb_connect_error|maxdb_data_seek|maxdb_debug|maxdb_disable_reads_from_master|maxdb_disable_rpl_parse|maxdb_dump_debug_info|maxdb_embedded_connect|maxdb_enable_reads_from_master|maxdb_enable_rpl_parse|maxdb_errno|maxdb_error|maxdb_escape_string|maxdb_execute|maxdb_fetch|maxdb_fetch_array|maxdb_fetch_assoc|maxdb_fetch_field|maxdb_fetch_field_direct|maxdb_fetch_fields|maxdb_fetch_lengths|maxdb_fetch_object|maxdb_fetch_row|maxdb_field_count|maxdb_field_seek|maxdb_field_tell|maxdb_free_result|maxdb_get_client_info|maxdb_get_client_version|maxdb_get_host_info|maxdb_get_metadata|maxdb_get_proto_info|maxdb_get_server_info|maxdb_get_server_version|maxdb_info|maxdb_init|maxdb_insert_id|maxdb_kill|maxdb_master_query|maxdb_more_results|maxdb_multi_query|maxdb_next_result|maxdb_num_fields|maxdb_num_rows|maxdb_options|maxdb_param_count|maxdb_ping|maxdb_prepare|maxdb_query|maxdb_real_connect|maxdb_real_escape_string|maxdb_real_query|maxdb_report|maxdb_rollback|maxdb_rpl_parse_enabled|maxdb_rpl_probe|maxdb_rpl_query_type|maxdb_select_db|maxdb_send_long_data|maxdb_send_query|maxdb_server_end|maxdb_server_init|maxdb_set_opt|maxdb_sqlstate|maxdb_ssl_set|maxdb_stat|maxdb_stmt_affected_rows|maxdb_stmt_bind_param|maxdb_stmt_bind_result|maxdb_stmt_close|maxdb_stmt_close_long_data|maxdb_stmt_data_seek|maxdb_stmt_errno|maxdb_stmt_error|maxdb_stmt_execute|maxdb_stmt_fetch|maxdb_stmt_free_result|maxdb_stmt_init|maxdb_stmt_num_rows|maxdb_stmt_param_count|maxdb_stmt_prepare|maxdb_stmt_reset|maxdb_stmt_result_metadata|maxdb_stmt_send_long_data|maxdb_stmt_sqlstate|maxdb_stmt_store_result|maxdb_store_result|maxdb_thread_id|maxdb_thread_safe|maxdb_use_result|maxdb_warning_count|mb_check_encoding|mb_convert_case|mb_convert_encoding|mb_convert_kana|mb_convert_variables|mb_decode_mimeheader|mb_decode_numericentity|mb_detect_encoding|mb_detect_order|mb_encode_mimeheader|mb_encode_numericentity|mb_encoding_aliases|mb_ereg|mb_ereg_match|mb_ereg_replace|mb_ereg_search|mb_ereg_search_getpos|mb_ereg_search_getregs|mb_ereg_search_init|mb_ereg_search_pos|mb_ereg_search_regs|mb_ereg_search_setpos|mb_eregi|mb_eregi_replace|mb_get_info|mb_http_input|mb_http_output|mb_internal_encoding|mb_language|mb_list_encodings|mb_output_handler|mb_parse_str|mb_preferred_mime_name|mb_regex_encoding|mb_regex_set_options|mb_send_mail|mb_split|mb_strcut|mb_strimwidth|mb_stripos|mb_stristr|mb_strlen|mb_strpos|mb_strrchr|mb_strrichr|mb_strripos|mb_strrpos|mb_strstr|mb_strtolower|mb_strtoupper|mb_strwidth|mb_substitute_character|mb_substr|mb_substr_count|mcrypt_cbc|mcrypt_cfb|mcrypt_create_iv|mcrypt_decrypt|mcrypt_ecb|mcrypt_enc_get_algorithms_name|mcrypt_enc_get_block_size|mcrypt_enc_get_iv_size|mcrypt_enc_get_key_size|mcrypt_enc_get_modes_name|mcrypt_enc_get_supported_key_sizes|mcrypt_enc_is_block_algorithm|mcrypt_enc_is_block_algorithm_mode|mcrypt_enc_is_block_mode|mcrypt_enc_self_test|mcrypt_encrypt|mcrypt_generic|mcrypt_generic_deinit|mcrypt_generic_end|mcrypt_generic_init|mcrypt_get_block_size|mcrypt_get_cipher_name|mcrypt_get_iv_size|mcrypt_get_key_size|mcrypt_list_algorithms|mcrypt_list_modes|mcrypt_module_close|mcrypt_module_get_algo_block_size|mcrypt_module_get_algo_key_size|mcrypt_module_get_supported_key_sizes|mcrypt_module_is_block_algorithm|mcrypt_module_is_block_algorithm_mode|mcrypt_module_is_block_mode|mcrypt_module_open|mcrypt_module_self_test|mcrypt_ofb|md5|md5_file|mdecrypt_generic|memcache|memcache_debug|memcached|memory_get_peak_usage|memory_get_usage|messageformatter|metaphone|method_exists|mhash|mhash_count|mhash_get_block_size|mhash_get_hash_name|mhash_keygen_s2k|microtime|mime_content_type|min|ming_keypress|ming_setcubicthreshold|ming_setscale|ming_setswfcompression|ming_useconstants|ming_useswfversion|mkdir|mktime|money_format|mongo|mongobindata|mongocode|mongocollection|mongoconnectionexception|mongocursor|mongocursorexception|mongocursortimeoutexception|mongodate|mongodb|mongodbref|mongoexception|mongogridfs|mongogridfscursor|mongogridfsexception|mongogridfsfile|mongoid|mongoint32|mongoint64|mongomaxkey|mongominkey|mongoregex|mongotimestamp|move_uploaded_file|mpegfile|mqseries_back|mqseries_begin|mqseries_close|mqseries_cmit|mqseries_conn|mqseries_connx|mqseries_disc|mqseries_get|mqseries_inq|mqseries_open|mqseries_put|mqseries_put1|mqseries_set|mqseries_strerror|msession_connect|msession_count|msession_create|msession_destroy|msession_disconnect|msession_find|msession_get|msession_get_array|msession_get_data|msession_inc|msession_list|msession_listvar|msession_lock|msession_plugin|msession_randstr|msession_set|msession_set_array|msession_set_data|msession_timeout|msession_uniq|msession_unlock|msg_get_queue|msg_queue_exists|msg_receive|msg_remove_queue|msg_send|msg_set_queue|msg_stat_queue|msql|msql_affected_rows|msql_close|msql_connect|msql_create_db|msql_createdb|msql_data_seek|msql_db_query|msql_dbname|msql_drop_db|msql_error|msql_fetch_array|msql_fetch_field|msql_fetch_object|msql_fetch_row|msql_field_flags|msql_field_len|msql_field_name|msql_field_seek|msql_field_table|msql_field_type|msql_fieldflags|msql_fieldlen|msql_fieldname|msql_fieldtable|msql_fieldtype|msql_free_result|msql_list_dbs|msql_list_fields|msql_list_tables|msql_num_fields|msql_num_rows|msql_numfields|msql_numrows|msql_pconnect|msql_query|msql_regcase|msql_result|msql_select_db|msql_tablename|mssql_bind|mssql_close|mssql_connect|mssql_data_seek|mssql_execute|mssql_fetch_array|mssql_fetch_assoc|mssql_fetch_batch|mssql_fetch_field|mssql_fetch_object|mssql_fetch_row|mssql_field_length|mssql_field_name|mssql_field_seek|mssql_field_type|mssql_free_result|mssql_free_statement|mssql_get_last_message|mssql_guid_string|mssql_init|mssql_min_error_severity|mssql_min_message_severity|mssql_next_result|mssql_num_fields|mssql_num_rows|mssql_pconnect|mssql_query|mssql_result|mssql_rows_affected|mssql_select_db|mt_getrandmax|mt_rand|mt_srand|multipleiterator|mysql_affected_rows|mysql_client_encoding|mysql_close|mysql_connect|mysql_create_db|mysql_data_seek|mysql_db_name|mysql_db_query|mysql_drop_db|mysql_errno|mysql_error|mysql_escape_string|mysql_fetch_array|mysql_fetch_assoc|mysql_fetch_field|mysql_fetch_lengths|mysql_fetch_object|mysql_fetch_row|mysql_field_flags|mysql_field_len|mysql_field_name|mysql_field_seek|mysql_field_table|mysql_field_type|mysql_free_result|mysql_get_client_info|mysql_get_host_info|mysql_get_proto_info|mysql_get_server_info|mysql_info|mysql_insert_id|mysql_list_dbs|mysql_list_fields|mysql_list_processes|mysql_list_tables|mysql_num_fields|mysql_num_rows|mysql_pconnect|mysql_ping|mysql_query|mysql_real_escape_string|mysql_result|mysql_select_db|mysql_set_charset|mysql_stat|mysql_tablename|mysql_thread_id|mysql_unbuffered_query|mysqli|mysqli_affected_rows|mysqli_autocommit|mysqli_bind_param|mysqli_bind_result|mysqli_cache_stats|mysqli_change_user|mysqli_character_set_name|mysqli_client_encoding|mysqli_close|mysqli_commit|mysqli_connect|mysqli_connect_errno|mysqli_connect_error|mysqli_data_seek|mysqli_debug|mysqli_disable_reads_from_master|mysqli_disable_rpl_parse|mysqli_driver|mysqli_dump_debug_info|mysqli_embedded_server_end|mysqli_embedded_server_start|mysqli_enable_reads_from_master|mysqli_enable_rpl_parse|mysqli_errno|mysqli_error|mysqli_escape_string|mysqli_execute|mysqli_fetch|mysqli_fetch_all|mysqli_fetch_array|mysqli_fetch_assoc|mysqli_fetch_field|mysqli_fetch_field_direct|mysqli_fetch_fields|mysqli_fetch_lengths|mysqli_fetch_object|mysqli_fetch_row|mysqli_field_count|mysqli_field_seek|mysqli_field_tell|mysqli_free_result|mysqli_get_charset|mysqli_get_client_info|mysqli_get_client_stats|mysqli_get_client_version|mysqli_get_connection_stats|mysqli_get_host_info|mysqli_get_metadata|mysqli_get_proto_info|mysqli_get_server_info|mysqli_get_server_version|mysqli_get_warnings|mysqli_info|mysqli_init|mysqli_insert_id|mysqli_kill|mysqli_link_construct|mysqli_master_query|mysqli_more_results|mysqli_multi_query|mysqli_next_result|mysqli_num_fields|mysqli_num_rows|mysqli_options|mysqli_param_count|mysqli_ping|mysqli_poll|mysqli_prepare|mysqli_query|mysqli_real_connect|mysqli_real_escape_string|mysqli_real_query|mysqli_reap_async_query|mysqli_refresh|mysqli_report|mysqli_result|mysqli_rollback|mysqli_rpl_parse_enabled|mysqli_rpl_probe|mysqli_rpl_query_type|mysqli_select_db|mysqli_send_long_data|mysqli_send_query|mysqli_set_charset|mysqli_set_local_infile_default|mysqli_set_local_infile_handler|mysqli_set_opt|mysqli_slave_query|mysqli_sqlstate|mysqli_ssl_set|mysqli_stat|mysqli_stmt|mysqli_stmt_affected_rows|mysqli_stmt_attr_get|mysqli_stmt_attr_set|mysqli_stmt_bind_param|mysqli_stmt_bind_result|mysqli_stmt_close|mysqli_stmt_data_seek|mysqli_stmt_errno|mysqli_stmt_error|mysqli_stmt_execute|mysqli_stmt_fetch|mysqli_stmt_field_count|mysqli_stmt_free_result|mysqli_stmt_get_result|mysqli_stmt_get_warnings|mysqli_stmt_init|mysqli_stmt_insert_id|mysqli_stmt_next_result|mysqli_stmt_num_rows|mysqli_stmt_param_count|mysqli_stmt_prepare|mysqli_stmt_reset|mysqli_stmt_result_metadata|mysqli_stmt_send_long_data|mysqli_stmt_sqlstate|mysqli_stmt_store_result|mysqli_store_result|mysqli_thread_id|mysqli_thread_safe|mysqli_use_result|mysqli_warning|mysqli_warning_count|mysqlnd_ms_get_stats|mysqlnd_ms_query_is_select|mysqlnd_ms_set_user_pick_server|mysqlnd_qc_change_handler|mysqlnd_qc_clear_cache|mysqlnd_qc_get_cache_info|mysqlnd_qc_get_core_stats|mysqlnd_qc_get_handler|mysqlnd_qc_get_query_trace_log|mysqlnd_qc_set_user_handlers|natcasesort|natsort|ncurses_addch|ncurses_addchnstr|ncurses_addchstr|ncurses_addnstr|ncurses_addstr|ncurses_assume_default_colors|ncurses_attroff|ncurses_attron|ncurses_attrset|ncurses_baudrate|ncurses_beep|ncurses_bkgd|ncurses_bkgdset|ncurses_border|ncurses_bottom_panel|ncurses_can_change_color|ncurses_cbreak|ncurses_clear|ncurses_clrtobot|ncurses_clrtoeol|ncurses_color_content|ncurses_color_set|ncurses_curs_set|ncurses_def_prog_mode|ncurses_def_shell_mode|ncurses_define_key|ncurses_del_panel|ncurses_delay_output|ncurses_delch|ncurses_deleteln|ncurses_delwin|ncurses_doupdate|ncurses_echo|ncurses_echochar|ncurses_end|ncurses_erase|ncurses_erasechar|ncurses_filter|ncurses_flash|ncurses_flushinp|ncurses_getch|ncurses_getmaxyx|ncurses_getmouse|ncurses_getyx|ncurses_halfdelay|ncurses_has_colors|ncurses_has_ic|ncurses_has_il|ncurses_has_key|ncurses_hide_panel|ncurses_hline|ncurses_inch|ncurses_init|ncurses_init_color|ncurses_init_pair|ncurses_insch|ncurses_insdelln|ncurses_insertln|ncurses_insstr|ncurses_instr|ncurses_isendwin|ncurses_keyok|ncurses_keypad|ncurses_killchar|ncurses_longname|ncurses_meta|ncurses_mouse_trafo|ncurses_mouseinterval|ncurses_mousemask|ncurses_move|ncurses_move_panel|ncurses_mvaddch|ncurses_mvaddchnstr|ncurses_mvaddchstr|ncurses_mvaddnstr|ncurses_mvaddstr|ncurses_mvcur|ncurses_mvdelch|ncurses_mvgetch|ncurses_mvhline|ncurses_mvinch|ncurses_mvvline|ncurses_mvwaddstr|ncurses_napms|ncurses_new_panel|ncurses_newpad|ncurses_newwin|ncurses_nl|ncurses_nocbreak|ncurses_noecho|ncurses_nonl|ncurses_noqiflush|ncurses_noraw|ncurses_pair_content|ncurses_panel_above|ncurses_panel_below|ncurses_panel_window|ncurses_pnoutrefresh|ncurses_prefresh|ncurses_putp|ncurses_qiflush|ncurses_raw|ncurses_refresh|ncurses_replace_panel|ncurses_reset_prog_mode|ncurses_reset_shell_mode|ncurses_resetty|ncurses_savetty|ncurses_scr_dump|ncurses_scr_init|ncurses_scr_restore|ncurses_scr_set|ncurses_scrl|ncurses_show_panel|ncurses_slk_attr|ncurses_slk_attroff|ncurses_slk_attron|ncurses_slk_attrset|ncurses_slk_clear|ncurses_slk_color|ncurses_slk_init|ncurses_slk_noutrefresh|ncurses_slk_refresh|ncurses_slk_restore|ncurses_slk_set|ncurses_slk_touch|ncurses_standend|ncurses_standout|ncurses_start_color|ncurses_termattrs|ncurses_termname|ncurses_timeout|ncurses_top_panel|ncurses_typeahead|ncurses_ungetch|ncurses_ungetmouse|ncurses_update_panels|ncurses_use_default_colors|ncurses_use_env|ncurses_use_extended_names|ncurses_vidattr|ncurses_vline|ncurses_waddch|ncurses_waddstr|ncurses_wattroff|ncurses_wattron|ncurses_wattrset|ncurses_wborder|ncurses_wclear|ncurses_wcolor_set|ncurses_werase|ncurses_wgetch|ncurses_whline|ncurses_wmouse_trafo|ncurses_wmove|ncurses_wnoutrefresh|ncurses_wrefresh|ncurses_wstandend|ncurses_wstandout|ncurses_wvline|newinstance|newinstanceargs|newt_bell|newt_button|newt_button_bar|newt_centered_window|newt_checkbox|newt_checkbox_get_value|newt_checkbox_set_flags|newt_checkbox_set_value|newt_checkbox_tree|newt_checkbox_tree_add_item|newt_checkbox_tree_find_item|newt_checkbox_tree_get_current|newt_checkbox_tree_get_entry_value|newt_checkbox_tree_get_multi_selection|newt_checkbox_tree_get_selection|newt_checkbox_tree_multi|newt_checkbox_tree_set_current|newt_checkbox_tree_set_entry|newt_checkbox_tree_set_entry_value|newt_checkbox_tree_set_width|newt_clear_key_buffer|newt_cls|newt_compact_button|newt_component_add_callback|newt_component_takes_focus|newt_create_grid|newt_cursor_off|newt_cursor_on|newt_delay|newt_draw_form|newt_draw_root_text|newt_entry|newt_entry_get_value|newt_entry_set|newt_entry_set_filter|newt_entry_set_flags|newt_finished|newt_form|newt_form_add_component|newt_form_add_components|newt_form_add_hot_key|newt_form_destroy|newt_form_get_current|newt_form_run|newt_form_set_background|newt_form_set_height|newt_form_set_size|newt_form_set_timer|newt_form_set_width|newt_form_watch_fd|newt_get_screen_size|newt_grid_add_components_to_form|newt_grid_basic_window|newt_grid_free|newt_grid_get_size|newt_grid_h_close_stacked|newt_grid_h_stacked|newt_grid_place|newt_grid_set_field|newt_grid_simple_window|newt_grid_v_close_stacked|newt_grid_v_stacked|newt_grid_wrapped_window|newt_grid_wrapped_window_at|newt_init|newt_label|newt_label_set_text|newt_listbox|newt_listbox_append_entry|newt_listbox_clear|newt_listbox_clear_selection|newt_listbox_delete_entry|newt_listbox_get_current|newt_listbox_get_selection|newt_listbox_insert_entry|newt_listbox_item_count|newt_listbox_select_item|newt_listbox_set_current|newt_listbox_set_current_by_key|newt_listbox_set_data|newt_listbox_set_entry|newt_listbox_set_width|newt_listitem|newt_listitem_get_data|newt_listitem_set|newt_open_window|newt_pop_help_line|newt_pop_window|newt_push_help_line|newt_radio_get_current|newt_radiobutton|newt_redraw_help_line|newt_reflow_text|newt_refresh|newt_resize_screen|newt_resume|newt_run_form|newt_scale|newt_scale_set|newt_scrollbar_set|newt_set_help_callback|newt_set_suspend_callback|newt_suspend|newt_textbox|newt_textbox_get_num_lines|newt_textbox_reflowed|newt_textbox_set_height|newt_textbox_set_text|newt_vertical_scrollbar|newt_wait_for_key|newt_win_choice|newt_win_entries|newt_win_menu|newt_win_message|newt_win_messagev|newt_win_ternary|next|ngettext|nl2br|nl_langinfo|norewinditerator|normalizer|notes_body|notes_copy_db|notes_create_db|notes_create_note|notes_drop_db|notes_find_note|notes_header_info|notes_list_msgs|notes_mark_read|notes_mark_unread|notes_nav_create|notes_search|notes_unread|notes_version|nsapi_request_headers|nsapi_response_headers|nsapi_virtual|nthmac|number_format|numberformatter|oauth|oauth_get_sbs|oauth_urlencode|oauthexception|oauthprovider|ob_clean|ob_deflatehandler|ob_end_clean|ob_end_flush|ob_etaghandler|ob_flush|ob_get_clean|ob_get_contents|ob_get_flush|ob_get_length|ob_get_level|ob_get_status|ob_gzhandler|ob_iconv_handler|ob_implicit_flush|ob_inflatehandler|ob_list_handlers|ob_start|ob_tidyhandler|oci_bind_array_by_name|oci_bind_by_name|oci_cancel|oci_client_version|oci_close|oci_collection_append|oci_collection_assign|oci_collection_element_assign|oci_collection_element_get|oci_collection_free|oci_collection_max|oci_collection_size|oci_collection_trim|oci_commit|oci_connect|oci_define_by_name|oci_error|oci_execute|oci_fetch|oci_fetch_all|oci_fetch_array|oci_fetch_assoc|oci_fetch_object|oci_fetch_row|oci_field_is_null|oci_field_name|oci_field_precision|oci_field_scale|oci_field_size|oci_field_type|oci_field_type_raw|oci_free_statement|oci_internal_debug|oci_lob_append|oci_lob_close|oci_lob_copy|oci_lob_eof|oci_lob_erase|oci_lob_export|oci_lob_flush|oci_lob_free|oci_lob_getbuffering|oci_lob_import|oci_lob_is_equal|oci_lob_load|oci_lob_read|oci_lob_rewind|oci_lob_save|oci_lob_savefile|oci_lob_seek|oci_lob_setbuffering|oci_lob_size|oci_lob_tell|oci_lob_truncate|oci_lob_write|oci_lob_writetemporary|oci_lob_writetofile|oci_new_collection|oci_new_connect|oci_new_cursor|oci_new_descriptor|oci_num_fields|oci_num_rows|oci_parse|oci_password_change|oci_pconnect|oci_result|oci_rollback|oci_server_version|oci_set_action|oci_set_client_identifier|oci_set_client_info|oci_set_edition|oci_set_module_name|oci_set_prefetch|oci_statement_type|ocibindbyname|ocicancel|ocicloselob|ocicollappend|ocicollassign|ocicollassignelem|ocicollgetelem|ocicollmax|ocicollsize|ocicolltrim|ocicolumnisnull|ocicolumnname|ocicolumnprecision|ocicolumnscale|ocicolumnsize|ocicolumntype|ocicolumntyperaw|ocicommit|ocidefinebyname|ocierror|ociexecute|ocifetch|ocifetchinto|ocifetchstatement|ocifreecollection|ocifreecursor|ocifreedesc|ocifreestatement|ociinternaldebug|ociloadlob|ocilogoff|ocilogon|ocinewcollection|ocinewcursor|ocinewdescriptor|ocinlogon|ocinumcols|ociparse|ociplogon|ociresult|ocirollback|ocirowcount|ocisavelob|ocisavelobfile|ociserverversion|ocisetprefetch|ocistatementtype|ociwritelobtofile|ociwritetemporarylob|octdec|odbc_autocommit|odbc_binmode|odbc_close|odbc_close_all|odbc_columnprivileges|odbc_columns|odbc_commit|odbc_connect|odbc_cursor|odbc_data_source|odbc_do|odbc_error|odbc_errormsg|odbc_exec|odbc_execute|odbc_fetch_array|odbc_fetch_into|odbc_fetch_object|odbc_fetch_row|odbc_field_len|odbc_field_name|odbc_field_num|odbc_field_precision|odbc_field_scale|odbc_field_type|odbc_foreignkeys|odbc_free_result|odbc_gettypeinfo|odbc_longreadlen|odbc_next_result|odbc_num_fields|odbc_num_rows|odbc_pconnect|odbc_prepare|odbc_primarykeys|odbc_procedurecolumns|odbc_procedures|odbc_result|odbc_result_all|odbc_rollback|odbc_setoption|odbc_specialcolumns|odbc_statistics|odbc_tableprivileges|odbc_tables|openal_buffer_create|openal_buffer_data|openal_buffer_destroy|openal_buffer_get|openal_buffer_loadwav|openal_context_create|openal_context_current|openal_context_destroy|openal_context_process|openal_context_suspend|openal_device_close|openal_device_open|openal_listener_get|openal_listener_set|openal_source_create|openal_source_destroy|openal_source_get|openal_source_pause|openal_source_play|openal_source_rewind|openal_source_set|openal_source_stop|openal_stream|opendir|openlog|openssl_cipher_iv_length|openssl_csr_export|openssl_csr_export_to_file|openssl_csr_get_public_key|openssl_csr_get_subject|openssl_csr_new|openssl_csr_sign|openssl_decrypt|openssl_dh_compute_key|openssl_digest|openssl_encrypt|openssl_error_string|openssl_free_key|openssl_get_cipher_methods|openssl_get_md_methods|openssl_get_privatekey|openssl_get_publickey|openssl_open|openssl_pkcs12_export|openssl_pkcs12_export_to_file|openssl_pkcs12_read|openssl_pkcs7_decrypt|openssl_pkcs7_encrypt|openssl_pkcs7_sign|openssl_pkcs7_verify|openssl_pkey_export|openssl_pkey_export_to_file|openssl_pkey_free|openssl_pkey_get_details|openssl_pkey_get_private|openssl_pkey_get_public|openssl_pkey_new|openssl_private_decrypt|openssl_private_encrypt|openssl_public_decrypt|openssl_public_encrypt|openssl_random_pseudo_bytes|openssl_seal|openssl_sign|openssl_verify|openssl_x509_check_private_key|openssl_x509_checkpurpose|openssl_x509_export|openssl_x509_export_to_file|openssl_x509_free|openssl_x509_parse|openssl_x509_read|ord|outeriterator|outofboundsexception|outofrangeexception|output_add_rewrite_var|output_reset_rewrite_vars|overflowexception|overload|override_function|ovrimos_close|ovrimos_commit|ovrimos_connect|ovrimos_cursor|ovrimos_exec|ovrimos_execute|ovrimos_fetch_into|ovrimos_fetch_row|ovrimos_field_len|ovrimos_field_name|ovrimos_field_num|ovrimos_field_type|ovrimos_free_result|ovrimos_longreadlen|ovrimos_num_fields|ovrimos_num_rows|ovrimos_prepare|ovrimos_result|ovrimos_result_all|ovrimos_rollback|pack|parentiterator|parse_ini_file|parse_ini_string|parse_str|parse_url|parsekit_compile_file|parsekit_compile_string|parsekit_func_arginfo|passthru|pathinfo|pclose|pcntl_alarm|pcntl_exec|pcntl_fork|pcntl_getpriority|pcntl_setpriority|pcntl_signal|pcntl_signal_dispatch|pcntl_sigprocmask|pcntl_sigtimedwait|pcntl_sigwaitinfo|pcntl_wait|pcntl_waitpid|pcntl_wexitstatus|pcntl_wifexited|pcntl_wifsignaled|pcntl_wifstopped|pcntl_wstopsig|pcntl_wtermsig|pdf_activate_item|pdf_add_annotation|pdf_add_bookmark|pdf_add_launchlink|pdf_add_locallink|pdf_add_nameddest|pdf_add_note|pdf_add_outline|pdf_add_pdflink|pdf_add_table_cell|pdf_add_textflow|pdf_add_thumbnail|pdf_add_weblink|pdf_arc|pdf_arcn|pdf_attach_file|pdf_begin_document|pdf_begin_font|pdf_begin_glyph|pdf_begin_item|pdf_begin_layer|pdf_begin_page|pdf_begin_page_ext|pdf_begin_pattern|pdf_begin_template|pdf_begin_template_ext|pdf_circle|pdf_clip|pdf_close|pdf_close_image|pdf_close_pdi|pdf_close_pdi_page|pdf_closepath|pdf_closepath_fill_stroke|pdf_closepath_stroke|pdf_concat|pdf_continue_text|pdf_create_3dview|pdf_create_action|pdf_create_annotation|pdf_create_bookmark|pdf_create_field|pdf_create_fieldgroup|pdf_create_gstate|pdf_create_pvf|pdf_create_textflow|pdf_curveto|pdf_define_layer|pdf_delete|pdf_delete_pvf|pdf_delete_table|pdf_delete_textflow|pdf_encoding_set_char|pdf_end_document|pdf_end_font|pdf_end_glyph|pdf_end_item|pdf_end_layer|pdf_end_page|pdf_end_page_ext|pdf_end_pattern|pdf_end_template|pdf_endpath|pdf_fill|pdf_fill_imageblock|pdf_fill_pdfblock|pdf_fill_stroke|pdf_fill_textblock|pdf_findfont|pdf_fit_image|pdf_fit_pdi_page|pdf_fit_table|pdf_fit_textflow|pdf_fit_textline|pdf_get_apiname|pdf_get_buffer|pdf_get_errmsg|pdf_get_errnum|pdf_get_font|pdf_get_fontname|pdf_get_fontsize|pdf_get_image_height|pdf_get_image_width|pdf_get_majorversion|pdf_get_minorversion|pdf_get_parameter|pdf_get_pdi_parameter|pdf_get_pdi_value|pdf_get_value|pdf_info_font|pdf_info_matchbox|pdf_info_table|pdf_info_textflow|pdf_info_textline|pdf_initgraphics|pdf_lineto|pdf_load_3ddata|pdf_load_font|pdf_load_iccprofile|pdf_load_image|pdf_makespotcolor|pdf_moveto|pdf_new|pdf_open_ccitt|pdf_open_file|pdf_open_gif|pdf_open_image|pdf_open_image_file|pdf_open_jpeg|pdf_open_memory_image|pdf_open_pdi|pdf_open_pdi_document|pdf_open_pdi_page|pdf_open_tiff|pdf_pcos_get_number|pdf_pcos_get_stream|pdf_pcos_get_string|pdf_place_image|pdf_place_pdi_page|pdf_process_pdi|pdf_rect|pdf_restore|pdf_resume_page|pdf_rotate|pdf_save|pdf_scale|pdf_set_border_color|pdf_set_border_dash|pdf_set_border_style|pdf_set_char_spacing|pdf_set_duration|pdf_set_gstate|pdf_set_horiz_scaling|pdf_set_info|pdf_set_info_author|pdf_set_info_creator|pdf_set_info_keywords|pdf_set_info_subject|pdf_set_info_title|pdf_set_layer_dependency|pdf_set_leading|pdf_set_parameter|pdf_set_text_matrix|pdf_set_text_pos|pdf_set_text_rendering|pdf_set_text_rise|pdf_set_value|pdf_set_word_spacing|pdf_setcolor|pdf_setdash|pdf_setdashpattern|pdf_setflat|pdf_setfont|pdf_setgray|pdf_setgray_fill|pdf_setgray_stroke|pdf_setlinecap|pdf_setlinejoin|pdf_setlinewidth|pdf_setmatrix|pdf_setmiterlimit|pdf_setpolydash|pdf_setrgbcolor|pdf_setrgbcolor_fill|pdf_setrgbcolor_stroke|pdf_shading|pdf_shading_pattern|pdf_shfill|pdf_show|pdf_show_boxed|pdf_show_xy|pdf_skew|pdf_stringwidth|pdf_stroke|pdf_suspend_page|pdf_translate|pdf_utf16_to_utf8|pdf_utf32_to_utf16|pdf_utf8_to_utf16|pdo|pdo_cubrid_schema|pdo_pgsqllobcreate|pdo_pgsqllobopen|pdo_pgsqllobunlink|pdo_sqlitecreateaggregate|pdo_sqlitecreatefunction|pdoexception|pdostatement|pfsockopen|pg_affected_rows|pg_cancel_query|pg_client_encoding|pg_close|pg_connect|pg_connection_busy|pg_connection_reset|pg_connection_status|pg_convert|pg_copy_from|pg_copy_to|pg_dbname|pg_delete|pg_end_copy|pg_escape_bytea|pg_escape_string|pg_execute|pg_fetch_all|pg_fetch_all_columns|pg_fetch_array|pg_fetch_assoc|pg_fetch_object|pg_fetch_result|pg_fetch_row|pg_field_is_null|pg_field_name|pg_field_num|pg_field_prtlen|pg_field_size|pg_field_table|pg_field_type|pg_field_type_oid|pg_free_result|pg_get_notify|pg_get_pid|pg_get_result|pg_host|pg_insert|pg_last_error|pg_last_notice|pg_last_oid|pg_lo_close|pg_lo_create|pg_lo_export|pg_lo_import|pg_lo_open|pg_lo_read|pg_lo_read_all|pg_lo_seek|pg_lo_tell|pg_lo_unlink|pg_lo_write|pg_meta_data|pg_num_fields|pg_num_rows|pg_options|pg_parameter_status|pg_pconnect|pg_ping|pg_port|pg_prepare|pg_put_line|pg_query|pg_query_params|pg_result_error|pg_result_error_field|pg_result_seek|pg_result_status|pg_select|pg_send_execute|pg_send_prepare|pg_send_query|pg_send_query_params|pg_set_client_encoding|pg_set_error_verbosity|pg_trace|pg_transaction_status|pg_tty|pg_unescape_bytea|pg_untrace|pg_update|pg_version|php_check_syntax|php_ini_loaded_file|php_ini_scanned_files|php_logo_guid|php_sapi_name|php_strip_whitespace|php_uname|phpcredits|phpinfo|phpversion|pi|png2wbmp|popen|pos|posix_access|posix_ctermid|posix_errno|posix_get_last_error|posix_getcwd|posix_getegid|posix_geteuid|posix_getgid|posix_getgrgid|posix_getgrnam|posix_getgroups|posix_getlogin|posix_getpgid|posix_getpgrp|posix_getpid|posix_getppid|posix_getpwnam|posix_getpwuid|posix_getrlimit|posix_getsid|posix_getuid|posix_initgroups|posix_isatty|posix_kill|posix_mkfifo|posix_mknod|posix_setegid|posix_seteuid|posix_setgid|posix_setpgid|posix_setsid|posix_setuid|posix_strerror|posix_times|posix_ttyname|posix_uname|pow|preg_filter|preg_grep|preg_last_error|preg_match|preg_match_all|preg_quote|preg_replace|preg_replace_callback|preg_split|prev|print|print_r|printer_abort|printer_close|printer_create_brush|printer_create_dc|printer_create_font|printer_create_pen|printer_delete_brush|printer_delete_dc|printer_delete_font|printer_delete_pen|printer_draw_bmp|printer_draw_chord|printer_draw_elipse|printer_draw_line|printer_draw_pie|printer_draw_rectangle|printer_draw_roundrect|printer_draw_text|printer_end_doc|printer_end_page|printer_get_option|printer_list|printer_logical_fontheight|printer_open|printer_select_brush|printer_select_font|printer_select_pen|printer_set_option|printer_start_doc|printer_start_page|printer_write|printf|proc_close|proc_get_status|proc_nice|proc_open|proc_terminate|property_exists|ps_add_bookmark|ps_add_launchlink|ps_add_locallink|ps_add_note|ps_add_pdflink|ps_add_weblink|ps_arc|ps_arcn|ps_begin_page|ps_begin_pattern|ps_begin_template|ps_circle|ps_clip|ps_close|ps_close_image|ps_closepath|ps_closepath_stroke|ps_continue_text|ps_curveto|ps_delete|ps_end_page|ps_end_pattern|ps_end_template|ps_fill|ps_fill_stroke|ps_findfont|ps_get_buffer|ps_get_parameter|ps_get_value|ps_hyphenate|ps_include_file|ps_lineto|ps_makespotcolor|ps_moveto|ps_new|ps_open_file|ps_open_image|ps_open_image_file|ps_open_memory_image|ps_place_image|ps_rect|ps_restore|ps_rotate|ps_save|ps_scale|ps_set_border_color|ps_set_border_dash|ps_set_border_style|ps_set_info|ps_set_parameter|ps_set_text_pos|ps_set_value|ps_setcolor|ps_setdash|ps_setflat|ps_setfont|ps_setgray|ps_setlinecap|ps_setlinejoin|ps_setlinewidth|ps_setmiterlimit|ps_setoverprintmode|ps_setpolydash|ps_shading|ps_shading_pattern|ps_shfill|ps_show|ps_show2|ps_show_boxed|ps_show_xy|ps_show_xy2|ps_string_geometry|ps_stringwidth|ps_stroke|ps_symbol|ps_symbol_name|ps_symbol_width|ps_translate|pspell_add_to_personal|pspell_add_to_session|pspell_check|pspell_clear_session|pspell_config_create|pspell_config_data_dir|pspell_config_dict_dir|pspell_config_ignore|pspell_config_mode|pspell_config_personal|pspell_config_repl|pspell_config_runtogether|pspell_config_save_repl|pspell_new|pspell_new_config|pspell_new_personal|pspell_save_wordlist|pspell_store_replacement|pspell_suggest|putenv|px_close|px_create_fp|px_date2string|px_delete|px_delete_record|px_get_field|px_get_info|px_get_parameter|px_get_record|px_get_schema|px_get_value|px_insert_record|px_new|px_numfields|px_numrecords|px_open_fp|px_put_record|px_retrieve_record|px_set_blob_file|px_set_parameter|px_set_tablename|px_set_targetencoding|px_set_value|px_timestamp2string|px_update_record|qdom_error|qdom_tree|quoted_printable_decode|quoted_printable_encode|quotemeta|rad2deg|radius_acct_open|radius_add_server|radius_auth_open|radius_close|radius_config|radius_create_request|radius_cvt_addr|radius_cvt_int|radius_cvt_string|radius_demangle|radius_demangle_mppe_key|radius_get_attr|radius_get_vendor_attr|radius_put_addr|radius_put_attr|radius_put_int|radius_put_string|radius_put_vendor_addr|radius_put_vendor_attr|radius_put_vendor_int|radius_put_vendor_string|radius_request_authenticator|radius_send_request|radius_server_secret|radius_strerror|rand|range|rangeexception|rar_wrapper_cache_stats|rararchive|rarentry|rarexception|rawurldecode|rawurlencode|read_exif_data|readdir|readfile|readgzfile|readline|readline_add_history|readline_callback_handler_install|readline_callback_handler_remove|readline_callback_read_char|readline_clear_history|readline_completion_function|readline_info|readline_list_history|readline_on_new_line|readline_read_history|readline_redisplay|readline_write_history|readlink|realpath|realpath_cache_get|realpath_cache_size|recode|recode_file|recode_string|recursivearrayiterator|recursivecachingiterator|recursivecallbackfilteriterator|recursivedirectoryiterator|recursivefilteriterator|recursiveiterator|recursiveiteratoriterator|recursiveregexiterator|recursivetreeiterator|reflection|reflectionclass|reflectionexception|reflectionextension|reflectionfunction|reflectionfunctionabstract|reflectionmethod|reflectionobject|reflectionparameter|reflectionproperty|reflector|regexiterator|register_shutdown_function|register_tick_function|rename|rename_function|require|require_once|reset|resetValue|resourcebundle|restore_error_handler|restore_exception_handler|restore_include_path|return|rewind|rewinddir|rmdir|round|rpm_close|rpm_get_tag|rpm_is_valid|rpm_open|rpm_version|rrd_create|rrd_error|rrd_fetch|rrd_first|rrd_graph|rrd_info|rrd_last|rrd_lastupdate|rrd_restore|rrd_tune|rrd_update|rrd_xport|rrdcreator|rrdgraph|rrdupdater|rsort|rtrim|runkit_class_adopt|runkit_class_emancipate|runkit_constant_add|runkit_constant_redefine|runkit_constant_remove|runkit_function_add|runkit_function_copy|runkit_function_redefine|runkit_function_remove|runkit_function_rename|runkit_import|runkit_lint|runkit_lint_file|runkit_method_add|runkit_method_copy|runkit_method_redefine|runkit_method_remove|runkit_method_rename|runkit_return_value_used|runkit_sandbox_output_handler|runkit_superglobals|runtimeexception|samconnection_commit|samconnection_connect|samconnection_constructor|samconnection_disconnect|samconnection_errno|samconnection_error|samconnection_isconnected|samconnection_peek|samconnection_peekall|samconnection_receive|samconnection_remove|samconnection_rollback|samconnection_send|samconnection_setDebug|samconnection_subscribe|samconnection_unsubscribe|sammessage_body|sammessage_constructor|sammessage_header|sca_createdataobject|sca_getservice|sca_localproxy_createdataobject|sca_soapproxy_createdataobject|scandir|sdo_das_changesummary_beginlogging|sdo_das_changesummary_endlogging|sdo_das_changesummary_getchangeddataobjects|sdo_das_changesummary_getchangetype|sdo_das_changesummary_getoldcontainer|sdo_das_changesummary_getoldvalues|sdo_das_changesummary_islogging|sdo_das_datafactory_addpropertytotype|sdo_das_datafactory_addtype|sdo_das_datafactory_getdatafactory|sdo_das_dataobject_getchangesummary|sdo_das_relational_applychanges|sdo_das_relational_construct|sdo_das_relational_createrootdataobject|sdo_das_relational_executepreparedquery|sdo_das_relational_executequery|sdo_das_setting_getlistindex|sdo_das_setting_getpropertyindex|sdo_das_setting_getpropertyname|sdo_das_setting_getvalue|sdo_das_setting_isset|sdo_das_xml_addtypes|sdo_das_xml_create|sdo_das_xml_createdataobject|sdo_das_xml_createdocument|sdo_das_xml_document_getrootdataobject|sdo_das_xml_document_getrootelementname|sdo_das_xml_document_getrootelementuri|sdo_das_xml_document_setencoding|sdo_das_xml_document_setxmldeclaration|sdo_das_xml_document_setxmlversion|sdo_das_xml_loadfile|sdo_das_xml_loadstring|sdo_das_xml_savefile|sdo_das_xml_savestring|sdo_datafactory_create|sdo_dataobject_clear|sdo_dataobject_createdataobject|sdo_dataobject_getcontainer|sdo_dataobject_getsequence|sdo_dataobject_gettypename|sdo_dataobject_gettypenamespaceuri|sdo_exception_getcause|sdo_list_insert|sdo_model_property_getcontainingtype|sdo_model_property_getdefault|sdo_model_property_getname|sdo_model_property_gettype|sdo_model_property_iscontainment|sdo_model_property_ismany|sdo_model_reflectiondataobject_construct|sdo_model_reflectiondataobject_export|sdo_model_reflectiondataobject_getcontainmentproperty|sdo_model_reflectiondataobject_getinstanceproperties|sdo_model_reflectiondataobject_gettype|sdo_model_type_getbasetype|sdo_model_type_getname|sdo_model_type_getnamespaceuri|sdo_model_type_getproperties|sdo_model_type_getproperty|sdo_model_type_isabstracttype|sdo_model_type_isdatatype|sdo_model_type_isinstance|sdo_model_type_isopentype|sdo_model_type_issequencedtype|sdo_sequence_getproperty|sdo_sequence_insert|sdo_sequence_move|seekableiterator|sem_acquire|sem_get|sem_release|sem_remove|serializable|serialize|session_cache_expire|session_cache_limiter|session_commit|session_decode|session_destroy|session_encode|session_get_cookie_params|session_id|session_is_registered|session_module_name|session_name|session_pgsql_add_error|session_pgsql_get_error|session_pgsql_get_field|session_pgsql_reset|session_pgsql_set_field|session_pgsql_status|session_regenerate_id|session_register|session_save_path|session_set_cookie_params|session_set_save_handler|session_start|session_unregister|session_unset|session_write_close|setCounterClass|set_error_handler|set_exception_handler|set_file_buffer|set_include_path|set_magic_quotes_runtime|set_socket_blocking|set_time_limit|setcookie|setlocale|setproctitle|setrawcookie|setstaticpropertyvalue|setthreadtitle|settype|sha1|sha1_file|shell_exec|shm_attach|shm_detach|shm_get_var|shm_has_var|shm_put_var|shm_remove|shm_remove_var|shmop_close|shmop_delete|shmop_open|shmop_read|shmop_size|shmop_write|show_source|shuffle|signeurlpaiement|similar_text|simplexml_import_dom|simplexml_load_file|simplexml_load_string|simplexmlelement|simplexmliterator|sin|sinh|sizeof|sleep|snmp|snmp2_get|snmp2_getnext|snmp2_real_walk|snmp2_set|snmp2_walk|snmp3_get|snmp3_getnext|snmp3_real_walk|snmp3_set|snmp3_walk|snmp_get_quick_print|snmp_get_valueretrieval|snmp_read_mib|snmp_set_enum_print|snmp_set_oid_numeric_print|snmp_set_oid_output_format|snmp_set_quick_print|snmp_set_valueretrieval|snmpget|snmpgetnext|snmprealwalk|snmpset|snmpwalk|snmpwalkoid|soapclient|soapfault|soapheader|soapparam|soapserver|soapvar|socket_accept|socket_bind|socket_clear_error|socket_close|socket_connect|socket_create|socket_create_listen|socket_create_pair|socket_get_option|socket_get_status|socket_getpeername|socket_getsockname|socket_last_error|socket_listen|socket_read|socket_recv|socket_recvfrom|socket_select|socket_send|socket_sendto|socket_set_block|socket_set_blocking|socket_set_nonblock|socket_set_option|socket_set_timeout|socket_shutdown|socket_strerror|socket_write|solr_get_version|solrclient|solrclientexception|solrdocument|solrdocumentfield|solrexception|solrgenericresponse|solrillegalargumentexception|solrillegaloperationexception|solrinputdocument|solrmodifiableparams|solrobject|solrparams|solrpingresponse|solrquery|solrqueryresponse|solrresponse|solrupdateresponse|solrutils|sort|soundex|sphinxclient|spl_autoload|spl_autoload_call|spl_autoload_extensions|spl_autoload_functions|spl_autoload_register|spl_autoload_unregister|spl_classes|spl_object_hash|splbool|spldoublylinkedlist|splenum|splfileinfo|splfileobject|splfixedarray|splfloat|splheap|splint|split|spliti|splmaxheap|splminheap|splobjectstorage|splobserver|splpriorityqueue|splqueue|splstack|splstring|splsubject|spltempfileobject|spoofchecker|sprintf|sql_regcase|sqlite3|sqlite3result|sqlite3stmt|sqlite_array_query|sqlite_busy_timeout|sqlite_changes|sqlite_close|sqlite_column|sqlite_create_aggregate|sqlite_create_function|sqlite_current|sqlite_error_string|sqlite_escape_string|sqlite_exec|sqlite_factory|sqlite_fetch_all|sqlite_fetch_array|sqlite_fetch_column_types|sqlite_fetch_object|sqlite_fetch_single|sqlite_fetch_string|sqlite_field_name|sqlite_has_more|sqlite_has_prev|sqlite_key|sqlite_last_error|sqlite_last_insert_rowid|sqlite_libencoding|sqlite_libversion|sqlite_next|sqlite_num_fields|sqlite_num_rows|sqlite_open|sqlite_popen|sqlite_prev|sqlite_query|sqlite_rewind|sqlite_seek|sqlite_single_query|sqlite_udf_decode_binary|sqlite_udf_encode_binary|sqlite_unbuffered_query|sqlite_valid|sqrt|srand|sscanf|ssdeep_fuzzy_compare|ssdeep_fuzzy_hash|ssdeep_fuzzy_hash_filename|ssh2_auth_hostbased_file|ssh2_auth_none|ssh2_auth_password|ssh2_auth_pubkey_file|ssh2_connect|ssh2_exec|ssh2_fetch_stream|ssh2_fingerprint|ssh2_methods_negotiated|ssh2_publickey_add|ssh2_publickey_init|ssh2_publickey_list|ssh2_publickey_remove|ssh2_scp_recv|ssh2_scp_send|ssh2_sftp|ssh2_sftp_lstat|ssh2_sftp_mkdir|ssh2_sftp_readlink|ssh2_sftp_realpath|ssh2_sftp_rename|ssh2_sftp_rmdir|ssh2_sftp_stat|ssh2_sftp_symlink|ssh2_sftp_unlink|ssh2_shell|ssh2_tunnel|stat|stats_absolute_deviation|stats_cdf_beta|stats_cdf_binomial|stats_cdf_cauchy|stats_cdf_chisquare|stats_cdf_exponential|stats_cdf_f|stats_cdf_gamma|stats_cdf_laplace|stats_cdf_logistic|stats_cdf_negative_binomial|stats_cdf_noncentral_chisquare|stats_cdf_noncentral_f|stats_cdf_poisson|stats_cdf_t|stats_cdf_uniform|stats_cdf_weibull|stats_covariance|stats_den_uniform|stats_dens_beta|stats_dens_cauchy|stats_dens_chisquare|stats_dens_exponential|stats_dens_f|stats_dens_gamma|stats_dens_laplace|stats_dens_logistic|stats_dens_negative_binomial|stats_dens_normal|stats_dens_pmf_binomial|stats_dens_pmf_hypergeometric|stats_dens_pmf_poisson|stats_dens_t|stats_dens_weibull|stats_harmonic_mean|stats_kurtosis|stats_rand_gen_beta|stats_rand_gen_chisquare|stats_rand_gen_exponential|stats_rand_gen_f|stats_rand_gen_funiform|stats_rand_gen_gamma|stats_rand_gen_ibinomial|stats_rand_gen_ibinomial_negative|stats_rand_gen_int|stats_rand_gen_ipoisson|stats_rand_gen_iuniform|stats_rand_gen_noncenral_chisquare|stats_rand_gen_noncentral_f|stats_rand_gen_noncentral_t|stats_rand_gen_normal|stats_rand_gen_t|stats_rand_get_seeds|stats_rand_phrase_to_seeds|stats_rand_ranf|stats_rand_setall|stats_skew|stats_standard_deviation|stats_stat_binomial_coef|stats_stat_correlation|stats_stat_gennch|stats_stat_independent_t|stats_stat_innerproduct|stats_stat_noncentral_t|stats_stat_paired_t|stats_stat_percentile|stats_stat_powersum|stats_variance|stomp|stomp_connect_error|stomp_version|stompexception|stompframe|str_getcsv|str_ireplace|str_pad|str_repeat|str_replace|str_rot13|str_shuffle|str_split|str_word_count|strcasecmp|strchr|strcmp|strcoll|strcspn|stream_bucket_append|stream_bucket_make_writeable|stream_bucket_new|stream_bucket_prepend|stream_context_create|stream_context_get_default|stream_context_get_options|stream_context_get_params|stream_context_set_default|stream_context_set_option|stream_context_set_params|stream_copy_to_stream|stream_encoding|stream_filter_append|stream_filter_prepend|stream_filter_register|stream_filter_remove|stream_get_contents|stream_get_filters|stream_get_line|stream_get_meta_data|stream_get_transports|stream_get_wrappers|stream_is_local|stream_notification_callback|stream_register_wrapper|stream_resolve_include_path|stream_select|stream_set_blocking|stream_set_read_buffer|stream_set_timeout|stream_set_write_buffer|stream_socket_accept|stream_socket_client|stream_socket_enable_crypto|stream_socket_get_name|stream_socket_pair|stream_socket_recvfrom|stream_socket_sendto|stream_socket_server|stream_socket_shutdown|stream_supports_lock|stream_wrapper_register|stream_wrapper_restore|stream_wrapper_unregister|streamwrapper|strftime|strip_tags|stripcslashes|stripos|stripslashes|stristr|strlen|strnatcasecmp|strnatcmp|strncasecmp|strncmp|strpbrk|strpos|strptime|strrchr|strrev|strripos|strrpos|strspn|strstr|strtok|strtolower|strtotime|strtoupper|strtr|strval|substr|substr_compare|substr_count|substr_replace|svm|svmmodel|svn_add|svn_auth_get_parameter|svn_auth_set_parameter|svn_blame|svn_cat|svn_checkout|svn_cleanup|svn_client_version|svn_commit|svn_delete|svn_diff|svn_export|svn_fs_abort_txn|svn_fs_apply_text|svn_fs_begin_txn2|svn_fs_change_node_prop|svn_fs_check_path|svn_fs_contents_changed|svn_fs_copy|svn_fs_delete|svn_fs_dir_entries|svn_fs_file_contents|svn_fs_file_length|svn_fs_is_dir|svn_fs_is_file|svn_fs_make_dir|svn_fs_make_file|svn_fs_node_created_rev|svn_fs_node_prop|svn_fs_props_changed|svn_fs_revision_prop|svn_fs_revision_root|svn_fs_txn_root|svn_fs_youngest_rev|svn_import|svn_log|svn_ls|svn_mkdir|svn_repos_create|svn_repos_fs|svn_repos_fs_begin_txn_for_commit|svn_repos_fs_commit_txn|svn_repos_hotcopy|svn_repos_open|svn_repos_recover|svn_revert|svn_status|svn_update|swf_actiongeturl|swf_actiongotoframe|swf_actiongotolabel|swf_actionnextframe|swf_actionplay|swf_actionprevframe|swf_actionsettarget|swf_actionstop|swf_actiontogglequality|swf_actionwaitforframe|swf_addbuttonrecord|swf_addcolor|swf_closefile|swf_definebitmap|swf_definefont|swf_defineline|swf_definepoly|swf_definerect|swf_definetext|swf_endbutton|swf_enddoaction|swf_endshape|swf_endsymbol|swf_fontsize|swf_fontslant|swf_fonttracking|swf_getbitmapinfo|swf_getfontinfo|swf_getframe|swf_labelframe|swf_lookat|swf_modifyobject|swf_mulcolor|swf_nextid|swf_oncondition|swf_openfile|swf_ortho|swf_ortho2|swf_perspective|swf_placeobject|swf_polarview|swf_popmatrix|swf_posround|swf_pushmatrix|swf_removeobject|swf_rotate|swf_scale|swf_setfont|swf_setframe|swf_shapearc|swf_shapecurveto|swf_shapecurveto3|swf_shapefillbitmapclip|swf_shapefillbitmaptile|swf_shapefilloff|swf_shapefillsolid|swf_shapelinesolid|swf_shapelineto|swf_shapemoveto|swf_showframe|swf_startbutton|swf_startdoaction|swf_startshape|swf_startsymbol|swf_textwidth|swf_translate|swf_viewport|swfaction|swfbitmap|swfbutton|swfdisplayitem|swffill|swffont|swffontchar|swfgradient|swfmorph|swfmovie|swfprebuiltclip|swfshape|swfsound|swfsoundinstance|swfsprite|swftext|swftextfield|swfvideostream|swish_construct|swish_getmetalist|swish_getpropertylist|swish_prepare|swish_query|swishresult_getmetalist|swishresult_stem|swishresults_getparsedwords|swishresults_getremovedstopwords|swishresults_nextresult|swishresults_seekresult|swishsearch_execute|swishsearch_resetlimit|swishsearch_setlimit|swishsearch_setphrasedelimiter|swishsearch_setsort|swishsearch_setstructure|sybase_affected_rows|sybase_close|sybase_connect|sybase_data_seek|sybase_deadlock_retry_count|sybase_fetch_array|sybase_fetch_assoc|sybase_fetch_field|sybase_fetch_object|sybase_fetch_row|sybase_field_seek|sybase_free_result|sybase_get_last_message|sybase_min_client_severity|sybase_min_error_severity|sybase_min_message_severity|sybase_min_server_severity|sybase_num_fields|sybase_num_rows|sybase_pconnect|sybase_query|sybase_result|sybase_select_db|sybase_set_message_handler|sybase_unbuffered_query|symlink|sys_get_temp_dir|sys_getloadavg|syslog|system|tag|tan|tanh|tcpwrap_check|tempnam|textdomain|tidy|tidy_access_count|tidy_config_count|tidy_diagnose|tidy_error_count|tidy_get_error_buffer|tidy_get_output|tidy_load_config|tidy_reset_config|tidy_save_config|tidy_set_encoding|tidy_setopt|tidy_warning_count|tidynode|time|time_nanosleep|time_sleep_until|timezone_abbreviations_list|timezone_identifiers_list|timezone_location_get|timezone_name_from_abbr|timezone_name_get|timezone_offset_get|timezone_open|timezone_transitions_get|timezone_version_get|tmpfile|token_get_all|token_name|tokyotyrant|tokyotyrantquery|tokyotyranttable|tostring|tostring|touch|trait_exists|transliterator|traversable|trigger_error|trim|uasort|ucfirst|ucwords|udm_add_search_limit|udm_alloc_agent|udm_alloc_agent_array|udm_api_version|udm_cat_list|udm_cat_path|udm_check_charset|udm_check_stored|udm_clear_search_limits|udm_close_stored|udm_crc32|udm_errno|udm_error|udm_find|udm_free_agent|udm_free_ispell_data|udm_free_res|udm_get_doc_count|udm_get_res_field|udm_get_res_param|udm_hash32|udm_load_ispell_data|udm_open_stored|udm_set_agent_param|uksort|umask|underflowexception|unexpectedvalueexception|uniqid|unixtojd|unlink|unpack|unregister_tick_function|unserialize|unset|urldecode|urlencode|use_soap_error_handler|user_error|usleep|usort|utf8_decode|utf8_encode|v8js|v8jsexception|var_dump|var_export|variant|variant_abs|variant_add|variant_and|variant_cast|variant_cat|variant_cmp|variant_date_from_timestamp|variant_date_to_timestamp|variant_div|variant_eqv|variant_fix|variant_get_type|variant_idiv|variant_imp|variant_int|variant_mod|variant_mul|variant_neg|variant_not|variant_or|variant_pow|variant_round|variant_set|variant_set_type|variant_sub|variant_xor|version_compare|vfprintf|virtual|vpopmail_add_alias_domain|vpopmail_add_alias_domain_ex|vpopmail_add_domain|vpopmail_add_domain_ex|vpopmail_add_user|vpopmail_alias_add|vpopmail_alias_del|vpopmail_alias_del_domain|vpopmail_alias_get|vpopmail_alias_get_all|vpopmail_auth_user|vpopmail_del_domain|vpopmail_del_domain_ex|vpopmail_del_user|vpopmail_error|vpopmail_passwd|vpopmail_set_user_quota|vprintf|vsprintf|w32api_deftype|w32api_init_dtype|w32api_invoke_function|w32api_register_function|w32api_set_call_method|wddx_add_vars|wddx_deserialize|wddx_packet_end|wddx_packet_start|wddx_serialize_value|wddx_serialize_vars|win32_continue_service|win32_create_service|win32_delete_service|win32_get_last_control_message|win32_pause_service|win32_ps_list_procs|win32_ps_stat_mem|win32_ps_stat_proc|win32_query_service_status|win32_set_service_status|win32_start_service|win32_start_service_ctrl_dispatcher|win32_stop_service|wincache_fcache_fileinfo|wincache_fcache_meminfo|wincache_lock|wincache_ocache_fileinfo|wincache_ocache_meminfo|wincache_refresh_if_changed|wincache_rplist_fileinfo|wincache_rplist_meminfo|wincache_scache_info|wincache_scache_meminfo|wincache_ucache_add|wincache_ucache_cas|wincache_ucache_clear|wincache_ucache_dec|wincache_ucache_delete|wincache_ucache_exists|wincache_ucache_get|wincache_ucache_inc|wincache_ucache_info|wincache_ucache_meminfo|wincache_ucache_set|wincache_unlock|wordwrap|xattr_get|xattr_list|xattr_remove|xattr_set|xattr_supported|xdiff_file_bdiff|xdiff_file_bdiff_size|xdiff_file_bpatch|xdiff_file_diff|xdiff_file_diff_binary|xdiff_file_merge3|xdiff_file_patch|xdiff_file_patch_binary|xdiff_file_rabdiff|xdiff_string_bdiff|xdiff_string_bdiff_size|xdiff_string_bpatch|xdiff_string_diff|xdiff_string_diff_binary|xdiff_string_merge3|xdiff_string_patch|xdiff_string_patch_binary|xdiff_string_rabdiff|xhprof_disable|xhprof_enable|xhprof_sample_disable|xhprof_sample_enable|xml_error_string|xml_get_current_byte_index|xml_get_current_column_number|xml_get_current_line_number|xml_get_error_code|xml_parse|xml_parse_into_struct|xml_parser_create|xml_parser_create_ns|xml_parser_free|xml_parser_get_option|xml_parser_set_option|xml_set_character_data_handler|xml_set_default_handler|xml_set_element_handler|xml_set_end_namespace_decl_handler|xml_set_external_entity_ref_handler|xml_set_notation_decl_handler|xml_set_object|xml_set_processing_instruction_handler|xml_set_start_namespace_decl_handler|xml_set_unparsed_entity_decl_handler|xmlreader|xmlrpc_decode|xmlrpc_decode_request|xmlrpc_encode|xmlrpc_encode_request|xmlrpc_get_type|xmlrpc_is_fault|xmlrpc_parse_method_descriptions|xmlrpc_server_add_introspection_data|xmlrpc_server_call_method|xmlrpc_server_create|xmlrpc_server_destroy|xmlrpc_server_register_introspection_callback|xmlrpc_server_register_method|xmlrpc_set_type|xmlwriter_end_attribute|xmlwriter_end_cdata|xmlwriter_end_comment|xmlwriter_end_document|xmlwriter_end_dtd|xmlwriter_end_dtd_attlist|xmlwriter_end_dtd_element|xmlwriter_end_dtd_entity|xmlwriter_end_element|xmlwriter_end_pi|xmlwriter_flush|xmlwriter_full_end_element|xmlwriter_open_memory|xmlwriter_open_uri|xmlwriter_output_memory|xmlwriter_set_indent|xmlwriter_set_indent_string|xmlwriter_start_attribute|xmlwriter_start_attribute_ns|xmlwriter_start_cdata|xmlwriter_start_comment|xmlwriter_start_document|xmlwriter_start_dtd|xmlwriter_start_dtd_attlist|xmlwriter_start_dtd_element|xmlwriter_start_dtd_entity|xmlwriter_start_element|xmlwriter_start_element_ns|xmlwriter_start_pi|xmlwriter_text|xmlwriter_write_attribute|xmlwriter_write_attribute_ns|xmlwriter_write_cdata|xmlwriter_write_comment|xmlwriter_write_dtd|xmlwriter_write_dtd_attlist|xmlwriter_write_dtd_element|xmlwriter_write_dtd_entity|xmlwriter_write_element|xmlwriter_write_element_ns|xmlwriter_write_pi|xmlwriter_write_raw|xpath_eval|xpath_eval_expression|xpath_new_context|xpath_register_ns|xpath_register_ns_auto|xptr_eval|xptr_new_context|xslt_backend_info|xslt_backend_name|xslt_backend_version|xslt_create|xslt_errno|xslt_error|xslt_free|xslt_getopt|xslt_process|xslt_set_base|xslt_set_encoding|xslt_set_error_handler|xslt_set_log|xslt_set_object|xslt_set_sax_handler|xslt_set_sax_handlers|xslt_set_scheme_handler|xslt_set_scheme_handlers|xslt_setopt|xsltprocessor|yaml_emit|yaml_emit_file|yaml_parse|yaml_parse_file|yaml_parse_url|yaz_addinfo|yaz_ccl_conf|yaz_ccl_parse|yaz_close|yaz_connect|yaz_database|yaz_element|yaz_errno|yaz_error|yaz_es|yaz_es_result|yaz_get_option|yaz_hits|yaz_itemorder|yaz_present|yaz_range|yaz_record|yaz_scan|yaz_scan_result|yaz_schema|yaz_search|yaz_set_option|yaz_sort|yaz_syntax|yaz_wait|yp_all|yp_cat|yp_err_string|yp_errno|yp_first|yp_get_default_domain|yp_master|yp_match|yp_next|yp_order|zend_logo_guid|zend_thread_id|zend_version|zip_close|zip_entry_close|zip_entry_compressedsize|zip_entry_compressionmethod|zip_entry_filesize|zip_entry_name|zip_entry_open|zip_entry_read|zip_open|zip_read|ziparchive|ziparchive_addemptydir|ziparchive_addfile|ziparchive_addfromstring|ziparchive_close|ziparchive_deleteindex|ziparchive_deletename|ziparchive_extractto|ziparchive_getarchivecomment|ziparchive_getcommentindex|ziparchive_getcommentname|ziparchive_getfromindex|ziparchive_getfromname|ziparchive_getnameindex|ziparchive_getstatusstring|ziparchive_getstream|ziparchive_locatename|ziparchive_open|ziparchive_renameindex|ziparchive_renamename|ziparchive_setCommentName|ziparchive_setarchivecomment|ziparchive_setcommentindex|ziparchive_statindex|ziparchive_statname|ziparchive_unchangeall|ziparchive_unchangearchive|ziparchive_unchangeindex|ziparchive_unchangename|zlib_get_coding_type".split("|"));
        var keywords = lang.arrayToMap("abstract|and|array|as|break|callable|case|catch|class|clone|const|continue|declare|default|do|else|elseif|enddeclare|endfor|endforeach|endif|endswitch|endwhile|extends|final|finally|for|foreach|function|global|goto|if|implements|instanceof|insteadof|interface|namespace|new|or|private|protected|public|static|switch|throw|trait|try|use|var|while|xor|yield".split("|"));
        var languageConstructs = lang.arrayToMap("__halt_compiler|die|echo|empty|exit|eval|include|include_once|isset|list|require|require_once|return|print|unset".split("|"));
        var builtinConstants = lang.arrayToMap("true|TRUE|false|FALSE|null|NULL|__CLASS__|__DIR__|__FILE__|__LINE__|__METHOD__|__FUNCTION__|__NAMESPACE__|__TRAIT__".split("|"));
        var builtinVariables = lang.arrayToMap("$GLOBALS|$_SERVER|$_GET|$_POST|$_FILES|$_REQUEST|$_SESSION|$_ENV|$_COOKIE|$php_errormsg|$HTTP_RAW_POST_DATA|$http_response_header|$argc|$argv".split("|"));
        var builtinFunctionsDeprecated = lang.arrayToMap("key_exists|cairo_matrix_create_scale|cairo_matrix_create_translate|call_user_method|call_user_method_array|com_addref|com_get|com_invoke|com_isenum|com_load|com_release|com_set|connection_timeout|cubrid_load_from_glo|cubrid_new_glo|cubrid_save_to_glo|cubrid_send_glo|define_syslog_variables|dl|ereg|ereg_replace|eregi|eregi_replace|hw_documentattributes|hw_documentbodytag|hw_documentsize|hw_outputdocument|imagedashedline|maxdb_bind_param|maxdb_bind_result|maxdb_client_encoding|maxdb_close_long_data|maxdb_execute|maxdb_fetch|maxdb_get_metadata|maxdb_param_count|maxdb_send_long_data|mcrypt_ecb|mcrypt_generic_end|mime_content_type|mysql_createdb|mysql_dbname|mysql_db_query|mysql_drop_db|mysql_dropdb|mysql_escape_string|mysql_fieldflags|mysql_fieldflags|mysql_fieldname|mysql_fieldtable|mysql_fieldtype|mysql_freeresult|mysql_listdbs|mysql_list_fields|mysql_listfields|mysql_list_tables|mysql_listtables|mysql_numfields|mysql_numrows|mysql_selectdb|mysql_tablename|mysqli_bind_param|mysqli_bind_result|mysqli_disable_reads_from_master|mysqli_disable_rpl_parse|mysqli_enable_reads_from_master|mysqli_enable_rpl_parse|mysqli_execute|mysqli_fetch|mysqli_get_metadata|mysqli_master_query|mysqli_param_count|mysqli_rpl_parse_enabled|mysqli_rpl_probe|mysqli_rpl_query_type|mysqli_send_long_data|mysqli_send_query|mysqli_slave_query|ocibindbyname|ocicancel|ocicloselob|ocicollappend|ocicollassign|ocicollassignelem|ocicollgetelem|ocicollmax|ocicollsize|ocicolltrim|ocicolumnisnull|ocicolumnname|ocicolumnprecision|ocicolumnscale|ocicolumnsize|ocicolumntype|ocicolumntyperaw|ocicommit|ocidefinebyname|ocierror|ociexecute|ocifetch|ocifetchinto|ocifetchstatement|ocifreecollection|ocifreecursor|ocifreedesc|ocifreestatement|ociinternaldebug|ociloadlob|ocilogoff|ocilogon|ocinewcollection|ocinewcursor|ocinewdescriptor|ocinlogon|ocinumcols|ociparse|ociplogon|ociresult|ocirollback|ocirowcount|ocisavelob|ocisavelobfile|ociserverversion|ocisetprefetch|ocistatementtype|ociwritelobtofile|ociwritetemporarylob|PDF_add_annotation|PDF_add_bookmark|PDF_add_launchlink|PDF_add_locallink|PDF_add_note|PDF_add_outline|PDF_add_pdflink|PDF_add_weblink|PDF_attach_file|PDF_begin_page|PDF_begin_template|PDF_close_pdi|PDF_close|PDF_findfont|PDF_get_font|PDF_get_fontname|PDF_get_fontsize|PDF_get_image_height|PDF_get_image_width|PDF_get_majorversion|PDF_get_minorversion|PDF_get_pdi_parameter|PDF_get_pdi_value|PDF_open_ccitt|PDF_open_file|PDF_open_gif|PDF_open_image_file|PDF_open_image|PDF_open_jpeg|PDF_open_pdi|PDF_open_tiff|PDF_place_image|PDF_place_pdi_page|PDF_set_border_color|PDF_set_border_dash|PDF_set_border_style|PDF_set_char_spacing|PDF_set_duration|PDF_set_horiz_scaling|PDF_set_info_author|PDF_set_info_creator|PDF_set_info_keywords|PDF_set_info_subject|PDF_set_info_title|PDF_set_leading|PDF_set_text_matrix|PDF_set_text_rendering|PDF_set_text_rise|PDF_set_word_spacing|PDF_setgray_fill|PDF_setgray_stroke|PDF_setgray|PDF_setpolydash|PDF_setrgbcolor_fill|PDF_setrgbcolor_stroke|PDF_setrgbcolor|PDF_show_boxed|php_check_syntax|px_set_tablename|px_set_targetencoding|runkit_sandbox_output_handler|session_is_registered|session_register|session_unregisterset_magic_quotes_runtime|magic_quotes_runtime|set_socket_blocking|socket_set_blocking|set_socket_timeout|socket_set_timeout|split|spliti|sql_regcase".split("|"));
        var keywordsDeprecated = lang.arrayToMap("cfunction|old_function".split("|"));
        var futureReserved = lang.arrayToMap([]);
        this.$rules = {
            "start": [
                {
                    token: "comment",
                    regex: /(?:#|\/\/)(?:[^?]|\?[^>])*/
                },
                docComment.getStartRule("doc-start"),
                {
                    token: "comment",
                    regex: "\\/\\*",
                    next: "comment"
                },
                {
                    token: "string.regexp",
                    regex: "[/](?:(?:\\[(?:\\\\]|[^\\]])+\\])|(?:\\\\/|[^\\]/]))*[/][gimy]*\\s*(?=[).,;]|$)"
                },
                {
                    token: "string",
                    regex: '"',
                    next: "qqstring"
                },
                {
                    token: "string",
                    regex: "'",
                    next: "qstring"
                },
                {
                    token: "constant.numeric",
                    regex: "0[xX][0-9a-fA-F]+\\b"
                },
                {
                    token: "constant.numeric",
                    regex: "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
                },
                {
                    token: "constant.language",
                    regex: "\\b(?:DEFAULT_INCLUDE_PATH|E_(?:ALL|CO(?:MPILE_(?:ERROR|WARNING)|RE_(?:ERROR|WARNING))|ERROR|NOTICE|PARSE|STRICT|USER_(?:ERROR|NOTICE|WARNING)|WARNING)|P(?:EAR_(?:EXTENSION_DIR|INSTALL_DIR)|HP_(?:BINDIR|CONFIG_FILE_(?:PATH|SCAN_DIR)|DATADIR|E(?:OL|XTENSION_DIR)|INT_(?:MAX|SIZE)|L(?:IBDIR|OCALSTATEDIR)|O(?:S|UTPUT_HANDLER_(?:CONT|END|START))|PREFIX|S(?:API|HLIB_SUFFIX|YSCONFDIR)|VERSION))|__COMPILER_HALT_OFFSET__)\\b"
                },
                {
                    token: [
                        "keyword",
                        "text",
                        "support.class"
                    ],
                    regex: "\\b(new)(\\s+)(\\w+)"
                },
                {
                    token: [
                        "support.class",
                        "keyword.operator"
                    ],
                    regex: "\\b(\\w+)(::)"
                },
                {
                    token: "constant.language",
                    regex: "\\b(?:A(?:B(?:DAY_(?:1|2|3|4|5|6|7)|MON_(?:1(?:0|1|2|)|2|3|4|5|6|7|8|9))|LT_DIGITS|M_STR|SSERT_(?:ACTIVE|BAIL|CALLBACK|QUIET_EVAL|WARNING))|C(?:ASE_(?:LOWER|UPPER)|HAR_MAX|O(?:DESET|NNECTION_(?:ABORTED|NORMAL|TIMEOUT)|UNT_(?:NORMAL|RECURSIVE))|R(?:EDITS_(?:ALL|DOCS|FULLPAGE|G(?:ENERAL|ROUP)|MODULES|QA|SAPI)|NCYSTR|YPT_(?:BLOWFISH|EXT_DES|MD5|S(?:ALT_LENGTH|TD_DES)))|URRENCY_SYMBOL)|D(?:AY_(?:1|2|3|4|5|6|7)|ECIMAL_POINT|IRECTORY_SEPARATOR|_(?:FMT|T_FMT))|E(?:NT_(?:COMPAT|NOQUOTES|QUOTES)|RA(?:_(?:D_(?:FMT|T_FMT)|T_FMT|YEAR)|)|XTR_(?:IF_EXISTS|OVERWRITE|PREFIX_(?:ALL|I(?:F_EXISTS|NVALID)|SAME)|SKIP))|FRAC_DIGITS|GROUPING|HTML_(?:ENTITIES|SPECIALCHARS)|IN(?:FO_(?:ALL|C(?:ONFIGURATION|REDITS)|ENVIRONMENT|GENERAL|LICENSE|MODULES|VARIABLES)|I_(?:ALL|PERDIR|SYSTEM|USER)|T_(?:CURR_SYMBOL|FRAC_DIGITS))|L(?:C_(?:ALL|C(?:OLLATE|TYPE)|M(?:ESSAGES|ONETARY)|NUMERIC|TIME)|O(?:CK_(?:EX|NB|SH|UN)|G_(?:A(?:LERT|UTH(?:PRIV|))|C(?:ONS|R(?:IT|ON))|D(?:AEMON|EBUG)|E(?:MERG|RR)|INFO|KERN|L(?:OCAL(?:0|1|2|3|4|5|6|7)|PR)|MAIL|N(?:DELAY|EWS|O(?:TICE|WAIT))|ODELAY|P(?:ERROR|ID)|SYSLOG|U(?:SER|UCP)|WARNING)))|M(?:ON_(?:1(?:0|1|2|)|2|3|4|5|6|7|8|9|DECIMAL_POINT|GROUPING|THOUSANDS_SEP)|_(?:1_PI|2_(?:PI|SQRTPI)|E|L(?:N(?:10|2)|OG(?:10E|2E))|PI(?:_(?:2|4)|)|SQRT(?:1_2|2)))|N(?:EGATIVE_SIGN|O(?:EXPR|STR)|_(?:CS_PRECEDES|S(?:EP_BY_SPACE|IGN_POSN)))|P(?:ATH(?:INFO_(?:BASENAME|DIRNAME|EXTENSION)|_SEPARATOR)|M_STR|OSITIVE_SIGN|_(?:CS_PRECEDES|S(?:EP_BY_SPACE|IGN_POSN)))|RADIXCHAR|S(?:EEK_(?:CUR|END|SET)|ORT_(?:ASC|DESC|NUMERIC|REGULAR|STRING)|TR_PAD_(?:BOTH|LEFT|RIGHT))|T(?:HOUS(?:ANDS_SEP|EP)|_FMT(?:_AMPM|))|YES(?:EXPR|STR)|STD(?:IN|OUT|ERR))\\b"
                },
                {
                    token: function(value) {
                        if (keywords.hasOwnProperty(value)) return "keyword";
                        else if (builtinConstants.hasOwnProperty(value)) return "constant.language";
                        else if (builtinVariables.hasOwnProperty(value)) return "variable.language";
                        else if (futureReserved.hasOwnProperty(value)) return "invalid.illegal";
                        else if (builtinFunctions.hasOwnProperty(value)) return "support.function";
                        else if (value == "debugger") return "invalid.deprecated";
                        else if (value.match(/^(\$[a-zA-Z_\x7f-\uffff][a-zA-Z0-9_\x7f-\uffff]*|self|parent)$/)) return "variable";
                        return "identifier";
                    },
                    regex: /[a-zA-Z_$\x7f-\uffff][a-zA-Z0-9_\x7f-\uffff]*/
                },
                {
                    onMatch: function(value, currentSate, state) {
                        value = value.substr(3);
                        if (value[0] == "'" || value[0] == '"') value = value.slice(1, -1);
                        state.unshift(this.next, value);
                        return "markup.list";
                    },
                    regex: /<<<(?:\w+|'\w+'|"\w+")$/,
                    next: "heredoc"
                },
                {
                    token: "keyword.operator",
                    regex: "::|!|\\$|%|&|\\*|\\-\\-|\\-|\\+\\+|\\+|~|===|==|!=|!==|<=|>=|=>|<<=|>>=|>>>=|<>|<|>|\\.=|=|!|&&|\\|\\||\\?\\:|\\*=|/=|%=|\\+=|\\-=|&=|\\^=|\\b(?:in|instanceof|new|delete|typeof|void)"
                },
                {
                    token: "punctuation.operator",
                    regex: /[,;]/
                },
                {
                    token: "paren.lparen",
                    regex: "[[({]"
                },
                {
                    token: "paren.rparen",
                    regex: "[\\])}]"
                },
                {
                    token: "text",
                    regex: "\\s+"
                }
            ],
            "heredoc": [
                {
                    onMatch: function(value, currentState, stack) {
                        if (stack[1] != value) {
                            this.next = "";
                            return "string";
                        }
                        stack.shift();
                        stack.shift();
                        this.next = this.nextState;
                        return "markup.list";
                    },
                    regex: "^\\w+(?=;?$)",
                    nextState: "start"
                },
                {
                    token: "string",
                    regex: ".*"
                }
            ],
            "comment": [
                {
                    token: "comment",
                    regex: "\\*\\/",
                    next: "start"
                },
                {
                    defaultToken: "comment"
                }
            ],
            "qqstring": [
                {
                    token: "constant.language.escape",
                    regex: '\\\\(?:[nrtvef\\\\"$]|[0-7]{1,3}|x[0-9A-Fa-f]{1,2})'
                },
                {
                    token: "variable",
                    regex: /\$[\w]+(?:\[[\w\]+]|[=\-]>\w+)?/
                },
                {
                    token: "variable",
                    regex: /\$\{[^"\}]+\}?/ // this is wrong but ok for now
                },
                {
                    token: "string",
                    regex: '"',
                    next: "start"
                },
                {
                    defaultToken: "string"
                }
            ],
            "qstring": [
                {
                    token: "constant.language.escape",
                    regex: /\\['\\]/
                },
                {
                    token: "string",
                    regex: "'",
                    next: "start"
                },
                {
                    defaultToken: "string"
                }
            ]
        };
        this.embedRules(DocCommentHighlightRules, "doc-", [
            DocCommentHighlightRules.getEndRule("start")
        ]);
    };
    oop.inherits(PhpLangHighlightRules, TextHighlightRules);
    var PhpHighlightRules = function() {
        HtmlHighlightRules.call(this);
        var startRules = [
            {
                token: "support.php_tag",
                regex: "<\\?(?:php|=)?",
                push: "php-start"
            }
        ];
        var endRules = [
            {
                token: "support.php_tag",
                regex: "\\?>",
                next: "pop"
            }
        ];
        for(var key in this.$rules)this.$rules[key].unshift.apply(this.$rules[key], startRules);
        this.embedRules(PhpLangHighlightRules, "php-", endRules, [
            "start"
        ]);
        this.normalizeRules();
    };
    oop.inherits(PhpHighlightRules, HtmlHighlightRules);
    exports.PhpHighlightRules = PhpHighlightRules;
    exports.PhpLangHighlightRules = PhpLangHighlightRules;
});
ace.define("ace/mode/matching_brace_outdent", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var MatchingBraceOutdent = function() {};
    (function() {
        this.checkOutdent = function(line, input) {
            if (!/^\s+$/.test(line)) return false;
            return /^\s*\}/.test(input);
        };
        this.autoOutdent = function(doc, row) {
            var line = doc.getLine(row);
            var match = line.match(/^(\s*\})/);
            if (!match) return 0;
            var column = match[1].length;
            var openBracePos = doc.findMatchingBracket({
                row: row,
                column: column
            });
            if (!openBracePos || openBracePos.row == row) return 0;
            var indent = this.$getIndent(doc.getLine(openBracePos.row));
            doc.replace(new Range(row, 0, row, column - 1), indent);
        };
        this.$getIndent = function(line) {
            return line.match(/^\s*/)[0];
        };
    }).call(MatchingBraceOutdent.prototype);
    exports.MatchingBraceOutdent = MatchingBraceOutdent;
});
ace.define("ace/mode/php_completions", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var functionMap = {
        "abs": [
            "int abs(int number)",
            "Return the absolute value of the number"
        ],
        "acos": [
            "float acos(float number)",
            "Return the arc cosine of the number in radians"
        ],
        "acosh": [
            "float acosh(float number)",
            "Returns the inverse hyperbolic cosine of the number, i.e. the value whose hyperbolic cosine is number"
        ],
        "addGlob": [
            "bool addGlob(string pattern[,int flags [, array options]])",
            "Add files matching the glob pattern. See php's glob for the pattern syntax."
        ],
        "addPattern": [
            "bool addPattern(string pattern[, string path [, array options]])",
            "Add files matching the pcre pattern. See php's pcre for the pattern syntax."
        ],
        "addcslashes": [
            "string addcslashes(string str, string charlist)",
            "Escapes all chars mentioned in charlist with backslash. It creates octal representations if asked to backslash characters with 8th bit set or with ASCII<32 (except '\\n', '\\r', '\\t' etc...)"
        ],
        "addslashes": [
            "string addslashes(string str)",
            "Escapes single quote, double quotes and backslash characters in a string with backslashes"
        ],
        "apache_child_terminate": [
            "bool apache_child_terminate()",
            "Terminate apache process after this request"
        ],
        "apache_get_modules": [
            "array apache_get_modules()",
            "Get a list of loaded Apache modules"
        ],
        "apache_get_version": [
            "string apache_get_version()",
            "Fetch Apache version"
        ],
        "apache_getenv": [
            "bool apache_getenv(string variable [, bool walk_to_top])",
            "Get an Apache subprocess_env variable"
        ],
        "apache_lookup_uri": [
            "object apache_lookup_uri(string URI)",
            "Perform a partial request of the given URI to obtain information about it"
        ],
        "apache_note": [
            "string apache_note(string note_name [, string note_value])",
            "Get and set Apache request notes"
        ],
        "apache_request_auth_name": [
            "string apache_request_auth_name()",
            ""
        ],
        "apache_request_auth_type": [
            "string apache_request_auth_type()",
            ""
        ],
        "apache_request_discard_request_body": [
            "long apache_request_discard_request_body()",
            ""
        ],
        "apache_request_err_headers_out": [
            "array apache_request_err_headers_out([{string name|array list} [, string value [, bool replace = false]]])",
            "* fetch all headers that go out in case of an error or a subrequest"
        ],
        "apache_request_headers": [
            "array apache_request_headers()",
            "Fetch all HTTP request headers"
        ],
        "apache_request_headers_in": [
            "array apache_request_headers_in()",
            "* fetch all incoming request headers"
        ],
        "apache_request_headers_out": [
            "array apache_request_headers_out([{string name|array list} [, string value [, bool replace = false]]])",
            "* fetch all outgoing request headers"
        ],
        "apache_request_is_initial_req": [
            "bool apache_request_is_initial_req()",
            ""
        ],
        "apache_request_log_error": [
            "bool apache_request_log_error(string message, [long facility])",
            ""
        ],
        "apache_request_meets_conditions": [
            "long apache_request_meets_conditions()",
            ""
        ],
        "apache_request_remote_host": [
            "int apache_request_remote_host([int type])",
            ""
        ],
        "apache_request_run": [
            "long apache_request_run()",
            "This is a wrapper for ap_sub_run_req and ap_destory_sub_req.  It takes      sub_request, runs it, destroys it, and returns it's status."
        ],
        "apache_request_satisfies": [
            "long apache_request_satisfies()",
            ""
        ],
        "apache_request_server_port": [
            "int apache_request_server_port()",
            ""
        ],
        "apache_request_set_etag": [
            "void apache_request_set_etag()",
            ""
        ],
        "apache_request_set_last_modified": [
            "void apache_request_set_last_modified()",
            ""
        ],
        "apache_request_some_auth_required": [
            "bool apache_request_some_auth_required()",
            ""
        ],
        "apache_request_sub_req_lookup_file": [
            "object apache_request_sub_req_lookup_file(string file)",
            "Returns sub-request for the specified file.  You would     need to run it yourself with run()."
        ],
        "apache_request_sub_req_lookup_uri": [
            "object apache_request_sub_req_lookup_uri(string uri)",
            "Returns sub-request for the specified uri.  You would     need to run it yourself with run()"
        ],
        "apache_request_sub_req_method_uri": [
            "object apache_request_sub_req_method_uri(string method, string uri)",
            "Returns sub-request for the specified file.  You would     need to run it yourself with run()."
        ],
        "apache_request_update_mtime": [
            "long apache_request_update_mtime([int dependency_mtime])",
            ""
        ],
        "apache_reset_timeout": [
            "bool apache_reset_timeout()",
            "Reset the Apache write timer"
        ],
        "apache_response_headers": [
            "array apache_response_headers()",
            "Fetch all HTTP response headers"
        ],
        "apache_setenv": [
            "bool apache_setenv(string variable, string value [, bool walk_to_top])",
            "Set an Apache subprocess_env variable"
        ],
        "array_change_key_case": [
            "array array_change_key_case(array input [, int case=CASE_LOWER])",
            "Retuns an array with all string keys lowercased [or uppercased]"
        ],
        "array_chunk": [
            "array array_chunk(array input, int size [, bool preserve_keys])",
            "Split array into chunks"
        ],
        "array_combine": [
            "array array_combine(array keys, array values)",
            "Creates an array by using the elements of the first parameter as keys and the elements of the second as the corresponding values"
        ],
        "array_count_values": [
            "array array_count_values(array input)",
            "Return the value as key and the frequency of that value in input as value"
        ],
        "array_diff": [
            "array array_diff(array arr1, array arr2 [, array ...])",
            "Returns the entries of arr1 that have values which are not present in any of the others arguments."
        ],
        "array_diff_assoc": [
            "array array_diff_assoc(array arr1, array arr2 [, array ...])",
            "Returns the entries of arr1 that have values which are not present in any of the others arguments but do additional checks whether the keys are equal"
        ],
        "array_diff_key": [
            "array array_diff_key(array arr1, array arr2 [, array ...])",
            "Returns the entries of arr1 that have keys which are not present in any of the others arguments. This function is like array_diff() but works on the keys instead of the values. The associativity is preserved."
        ],
        "array_diff_uassoc": [
            "array array_diff_uassoc(array arr1, array arr2 [, array ...], callback data_comp_func)",
            "Returns the entries of arr1 that have values which are not present in any of the others arguments but do additional checks whether the keys are equal. Elements are compared by user supplied function."
        ],
        "array_diff_ukey": [
            "array array_diff_ukey(array arr1, array arr2 [, array ...], callback key_comp_func)",
            "Returns the entries of arr1 that have keys which are not present in any of the others arguments. User supplied function is used for comparing the keys. This function is like array_udiff() but works on the keys instead of the values. The associativity is preserved."
        ],
        "array_fill": [
            "array array_fill(int start_key, int num, mixed val)",
            "Create an array containing num elements starting with index start_key each initialized to val"
        ],
        "array_fill_keys": [
            "array array_fill_keys(array keys, mixed val)",
            "Create an array using the elements of the first parameter as keys each initialized to val"
        ],
        "array_filter": [
            "array array_filter(array input [, mixed callback])",
            "Filters elements from the array via the callback."
        ],
        "array_flip": [
            "array array_flip(array input)",
            "Return array with key <-> value flipped"
        ],
        "array_intersect": [
            "array array_intersect(array arr1, array arr2 [, array ...])",
            "Returns the entries of arr1 that have values which are present in all the other arguments"
        ],
        "array_intersect_assoc": [
            "array array_intersect_assoc(array arr1, array arr2 [, array ...])",
            "Returns the entries of arr1 that have values which are present in all the other arguments. Keys are used to do more restrictive check"
        ],
        "array_intersect_key": [
            "array array_intersect_key(array arr1, array arr2 [, array ...])",
            "Returns the entries of arr1 that have keys which are present in all the other arguments. Kind of equivalent to array_diff(array_keys($arr1), array_keys($arr2)[,array_keys(...)]). Equivalent of array_intersect_assoc() but does not do compare of the data."
        ],
        "array_intersect_uassoc": [
            "array array_intersect_uassoc(array arr1, array arr2 [, array ...], callback key_compare_func)",
            "Returns the entries of arr1 that have values which are present in all the other arguments. Keys are used to do more restrictive check and they are compared by using an user-supplied callback."
        ],
        "array_intersect_ukey": [
            "array array_intersect_ukey(array arr1, array arr2 [, array ...], callback key_compare_func)",
            "Returns the entries of arr1 that have keys which are present in all the other arguments. Kind of equivalent to array_diff(array_keys($arr1), array_keys($arr2)[,array_keys(...)]). The comparison of the keys is performed by a user supplied function. Equivalent of array_intersect_uassoc() but does not do compare of the data."
        ],
        "array_key_exists": [
            "bool array_key_exists(mixed key, array search)",
            "Checks if the given key or index exists in the array"
        ],
        "array_keys": [
            "array array_keys(array input [, mixed search_value[, bool strict]])",
            "Return just the keys from the input array, optionally only for the specified search_value"
        ],
        "array_key_first": [
            "mixed array_key_first(array arr)",
            "Returns the first key of arr if the array is not empty; NULL otherwise"
        ],
        "array_key_last": [
            "mixed array_key_last(array arr)",
            "Returns the last key of arr if the array is not empty; NULL otherwise"
        ],
        "array_map": [
            "array array_map(mixed callback, array input1 [, array input2 ,...])",
            "Applies the callback to the elements in given arrays."
        ],
        "array_merge": [
            "array array_merge(array arr1, array arr2 [, array ...])",
            "Merges elements from passed arrays into one array"
        ],
        "array_merge_recursive": [
            "array array_merge_recursive(array arr1, array arr2 [, array ...])",
            "Recursively merges elements from passed arrays into one array"
        ],
        "array_multisort": [
            "bool array_multisort(array ar1 [, SORT_ASC|SORT_DESC [, SORT_REGULAR|SORT_NUMERIC|SORT_STRING]] [, array ar2 [, SORT_ASC|SORT_DESC [, SORT_REGULAR|SORT_NUMERIC|SORT_STRING]], ...])",
            "Sort multiple arrays at once similar to how ORDER BY clause works in SQL"
        ],
        "array_pad": [
            "array array_pad(array input, int pad_size, mixed pad_value)",
            "Returns a copy of input array padded with pad_value to size pad_size"
        ],
        "array_pop": [
            "mixed array_pop(array stack)",
            "Pops an element off the end of the array"
        ],
        "array_product": [
            "mixed array_product(array input)",
            "Returns the product of the array entries"
        ],
        "array_push": [
            "int array_push(array stack, mixed var [, mixed ...])",
            "Pushes elements onto the end of the array"
        ],
        "array_rand": [
            "mixed array_rand(array input [, int num_req])",
            "Return key/keys for random entry/entries in the array"
        ],
        "array_reduce": [
            "mixed array_reduce(array input, mixed callback [, mixed initial])",
            "Iteratively reduce the array to a single value via the callback."
        ],
        "array_replace": [
            "array array_replace(array arr1, array arr2 [, array ...])",
            "Replaces elements from passed arrays into one array"
        ],
        "array_replace_recursive": [
            "array array_replace_recursive(array arr1, array arr2 [, array ...])",
            "Recursively replaces elements from passed arrays into one array"
        ],
        "array_reverse": [
            "array array_reverse(array input [, bool preserve keys])",
            "Return input as a new array with the order of the entries reversed"
        ],
        "array_search": [
            "mixed array_search(mixed needle, array haystack [, bool strict])",
            "Searches the array for a given value and returns the corresponding key if successful"
        ],
        "array_shift": [
            "mixed array_shift(array stack)",
            "Pops an element off the beginning of the array"
        ],
        "array_slice": [
            "array array_slice(array input, int offset [, int length [, bool preserve_keys]])",
            "Returns elements specified by offset and length"
        ],
        "array_splice": [
            "array array_splice(array input, int offset [, int length [, array replacement]])",
            "Removes the elements designated by offset and length and replace them with supplied array"
        ],
        "array_sum": [
            "mixed array_sum(array input)",
            "Returns the sum of the array entries"
        ],
        "array_udiff": [
            "array array_udiff(array arr1, array arr2 [, array ...], callback data_comp_func)",
            "Returns the entries of arr1 that have values which are not present in any of the others arguments. Elements are compared by user supplied function."
        ],
        "array_udiff_assoc": [
            "array array_udiff_assoc(array arr1, array arr2 [, array ...], callback key_comp_func)",
            "Returns the entries of arr1 that have values which are not present in any of the others arguments but do additional checks whether the keys are equal. Keys are compared by user supplied function."
        ],
        "array_udiff_uassoc": [
            "array array_udiff_uassoc(array arr1, array arr2 [, array ...], callback data_comp_func, callback key_comp_func)",
            "Returns the entries of arr1 that have values which are not present in any of the others arguments but do additional checks whether the keys are equal. Keys and elements are compared by user supplied functions."
        ],
        "array_uintersect": [
            "array array_uintersect(array arr1, array arr2 [, array ...], callback data_compare_func)",
            "Returns the entries of arr1 that have values which are present in all the other arguments. Data is compared by using an user-supplied callback."
        ],
        "array_uintersect_assoc": [
            "array array_uintersect_assoc(array arr1, array arr2 [, array ...], callback data_compare_func)",
            "Returns the entries of arr1 that have values which are present in all the other arguments. Keys are used to do more restrictive check. Data is compared by using an user-supplied callback."
        ],
        "array_uintersect_uassoc": [
            "array array_uintersect_uassoc(array arr1, array arr2 [, array ...], callback data_compare_func, callback key_compare_func)",
            "Returns the entries of arr1 that have values which are present in all the other arguments. Keys are used to do more restrictive check. Both data and keys are compared by using user-supplied callbacks."
        ],
        "array_unique": [
            "array array_unique(array input [, int sort_flags])",
            "Removes duplicate values from array"
        ],
        "array_unshift": [
            "int array_unshift(array stack, mixed var [, mixed ...])",
            "Pushes elements onto the beginning of the array"
        ],
        "array_values": [
            "array array_values(array input)",
            "Return just the values from the input array"
        ],
        "array_walk": [
            "bool array_walk(array input, string funcname [, mixed userdata])",
            "Apply a user function to every member of an array"
        ],
        "array_walk_recursive": [
            "bool array_walk_recursive(array input, string funcname [, mixed userdata])",
            "Apply a user function recursively to every member of an array"
        ],
        "arsort": [
            "bool arsort(array &array_arg [, int sort_flags])",
            "Sort an array in reverse order and maintain index association"
        ],
        "asin": [
            "float asin(float number)",
            "Returns the arc sine of the number in radians"
        ],
        "asinh": [
            "float asinh(float number)",
            "Returns the inverse hyperbolic sine of the number, i.e. the value whose hyperbolic sine is number"
        ],
        "asort": [
            "bool asort(array &array_arg [, int sort_flags])",
            "Sort an array and maintain index association"
        ],
        "assert": [
            "int assert(string|bool assertion)",
            "Checks if assertion is false"
        ],
        "assert_options": [
            "mixed assert_options(int what [, mixed value])",
            "Set/get the various assert flags"
        ],
        "atan": [
            "float atan(float number)",
            "Returns the arc tangent of the number in radians"
        ],
        "atan2": [
            "float atan2(float y, float x)",
            "Returns the arc tangent of y/x, with the resulting quadrant determined by the signs of y and x"
        ],
        "atanh": [
            "float atanh(float number)",
            "Returns the inverse hyperbolic tangent of the number, i.e. the value whose hyperbolic tangent is number"
        ],
        "attachIterator": [
            "void attachIterator(Iterator iterator[, mixed info])",
            "Attach a new iterator"
        ],
        "base64_decode": [
            "string base64_decode(string str[, bool strict])",
            "Decodes string using MIME base64 algorithm"
        ],
        "base64_encode": [
            "string base64_encode(string str)",
            "Encodes string using MIME base64 algorithm"
        ],
        "base_convert": [
            "string base_convert(string number, int frombase, int tobase)",
            "Converts a number in a string from any base <= 36 to any base <= 36"
        ],
        "basename": [
            "string basename(string path [, string suffix])",
            "Returns the filename component of the path"
        ],
        "bcadd": [
            "string bcadd(string left_operand, string right_operand [, int scale])",
            "Returns the sum of two arbitrary precision numbers"
        ],
        "bccomp": [
            "int bccomp(string left_operand, string right_operand [, int scale])",
            "Compares two arbitrary precision numbers"
        ],
        "bcdiv": [
            "string bcdiv(string left_operand, string right_operand [, int scale])",
            "Returns the quotient of two arbitrary precision numbers (division)"
        ],
        "bcmod": [
            "string bcmod(string left_operand, string right_operand)",
            "Returns the modulus of the two arbitrary precision operands"
        ],
        "bcmul": [
            "string bcmul(string left_operand, string right_operand [, int scale])",
            "Returns the multiplication of two arbitrary precision numbers"
        ],
        "bcpow": [
            "string bcpow(string x, string y [, int scale])",
            "Returns the value of an arbitrary precision number raised to the power of another"
        ],
        "bcpowmod": [
            "string bcpowmod(string x, string y, string mod [, int scale])",
            "Returns the value of an arbitrary precision number raised to the power of another reduced by a modulous"
        ],
        "bcscale": [
            "bool bcscale(int scale)",
            "Sets default scale parameter for all bc math functions"
        ],
        "bcsqrt": [
            "string bcsqrt(string operand [, int scale])",
            "Returns the square root of an arbitray precision number"
        ],
        "bcsub": [
            "string bcsub(string left_operand, string right_operand [, int scale])",
            "Returns the difference between two arbitrary precision numbers"
        ],
        "bin2hex": [
            "string bin2hex(string data)",
            "Converts the binary representation of data to hex"
        ],
        "bind_textdomain_codeset": [
            "string bind_textdomain_codeset (string domain, string codeset)",
            "Specify the character encoding in which the messages from the DOMAIN message catalog will be returned."
        ],
        "bindec": [
            "int bindec(string binary_number)",
            "Returns the decimal equivalent of the binary number"
        ],
        "bindtextdomain": [
            "string bindtextdomain(string domain_name, string dir)",
            "Bind to the text domain domain_name, looking for translations in dir. Returns the current domain"
        ],
        "birdstep_autocommit": [
            "bool birdstep_autocommit(int index)",
            ""
        ],
        "birdstep_close": [
            "bool birdstep_close(int id)",
            ""
        ],
        "birdstep_commit": [
            "bool birdstep_commit(int index)",
            ""
        ],
        "birdstep_connect": [
            "int birdstep_connect(string server, string user, string pass)",
            ""
        ],
        "birdstep_exec": [
            "int birdstep_exec(int index, string exec_str)",
            ""
        ],
        "birdstep_fetch": [
            "bool birdstep_fetch(int index)",
            ""
        ],
        "birdstep_fieldname": [
            "string birdstep_fieldname(int index, int col)",
            ""
        ],
        "birdstep_fieldnum": [
            "int birdstep_fieldnum(int index)",
            ""
        ],
        "birdstep_freeresult": [
            "bool birdstep_freeresult(int index)",
            ""
        ],
        "birdstep_off_autocommit": [
            "bool birdstep_off_autocommit(int index)",
            ""
        ],
        "birdstep_result": [
            "mixed birdstep_result(int index, mixed col)",
            ""
        ],
        "birdstep_rollback": [
            "bool birdstep_rollback(int index)",
            ""
        ],
        "bzcompress": [
            "string bzcompress(string source [, int blocksize100k [, int workfactor]])",
            "Compresses a string into BZip2 encoded data"
        ],
        "bzdecompress": [
            "string bzdecompress(string source [, int small])",
            "Decompresses BZip2 compressed data"
        ],
        "bzerrno": [
            "int bzerrno(resource bz)",
            "Returns the error number"
        ],
        "bzerror": [
            "array bzerror(resource bz)",
            "Returns the error number and error string in an associative array"
        ],
        "bzerrstr": [
            "string bzerrstr(resource bz)",
            "Returns the error string"
        ],
        "bzopen": [
            "resource bzopen(string|int file|fp, string mode)",
            "Opens a new BZip2 stream"
        ],
        "bzread": [
            "string bzread(resource bz[, int length])",
            "Reads up to length bytes from a BZip2 stream, or 1024 bytes if length is not specified"
        ],
        "cal_days_in_month": [
            "int cal_days_in_month(int calendar, int month, int year)",
            "Returns the number of days in a month for a given year and calendar"
        ],
        "cal_from_jd": [
            "array cal_from_jd(int jd, int calendar)",
            "Converts from Julian Day Count to a supported calendar and return extended information"
        ],
        "cal_info": [
            "array cal_info([int calendar])",
            "Returns information about a particular calendar"
        ],
        "cal_to_jd": [
            "int cal_to_jd(int calendar, int month, int day, int year)",
            "Converts from a supported calendar to Julian Day Count"
        ],
        "call_user_func": [
            "mixed call_user_func(mixed function_name [, mixed parmeter] [, mixed ...])",
            "Call a user function which is the first parameter"
        ],
        "call_user_func_array": [
            "mixed call_user_func_array(string function_name, array parameters)",
            "Call a user function which is the first parameter with the arguments contained in array"
        ],
        "call_user_method": [
            "mixed call_user_method(string method_name, mixed object [, mixed parameter] [, mixed ...])",
            "Call a user method on a specific object or class"
        ],
        "call_user_method_array": [
            "mixed call_user_method_array(string method_name, mixed object, array params)",
            "Call a user method on a specific object or class using a parameter array"
        ],
        "ceil": [
            "float ceil(float number)",
            "Returns the next highest integer value of the number"
        ],
        "chdir": [
            "bool chdir(string directory)",
            "Change the current directory"
        ],
        "checkdate": [
            "bool checkdate(int month, int day, int year)",
            "Returns true(1) if it is a valid date in gregorian calendar"
        ],
        "chgrp": [
            "bool chgrp(string filename, mixed group)",
            "Change file group"
        ],
        "chmod": [
            "bool chmod(string filename, int mode)",
            "Change file mode"
        ],
        "chown": [
            "bool chown(string filename, mixed user)",
            "Change file owner"
        ],
        "chr": [
            "string chr(int ascii)",
            "Converts ASCII code to a character"
        ],
        "chroot": [
            "bool chroot(string directory)",
            "Change root directory"
        ],
        "chunk_split": [
            "string chunk_split(string str [, int chunklen [, string ending]])",
            "Returns split line"
        ],
        "class_alias": [
            "bool class_alias(string user_class_name , string alias_name [, bool autoload])",
            "Creates an alias for user defined class"
        ],
        "class_exists": [
            "bool class_exists(string classname [, bool autoload])",
            "Checks if the class exists"
        ],
        "class_implements": [
            "array class_implements(mixed what [, bool autoload ])",
            "Return all classes and interfaces implemented by SPL"
        ],
        "class_parents": [
            "array class_parents(object instance [, bool autoload = true])",
            "Return an array containing the names of all parent classes"
        ],
        "clearstatcache": [
            "void clearstatcache([bool clear_realpath_cache[, string filename]])",
            "Clear file stat cache"
        ],
        "closedir": [
            "void closedir([resource dir_handle])",
            "Close directory connection identified by the dir_handle"
        ],
        "closelog": [
            "bool closelog()",
            "Close connection to system logger"
        ],
        "collator_asort": [
            "bool collator_asort( Collator $coll, array(string) $arr )",
            "* Sort array using specified collator, maintaining index association."
        ],
        "collator_compare": [
            "int collator_compare( Collator $coll, string $str1, string $str2 )",
            "* Compare two strings."
        ],
        "collator_create": [
            "Collator collator_create( string $locale )",
            "* Create collator."
        ],
        "collator_get_attribute": [
            "int collator_get_attribute( Collator $coll, int $attr )",
            "* Get collation attribute value."
        ],
        "collator_get_error_code": [
            "int collator_get_error_code( Collator $coll )",
            "* Get collator's last error code."
        ],
        "collator_get_error_message": [
            "string collator_get_error_message( Collator $coll )",
            "* Get text description for collator's last error code."
        ],
        "collator_get_locale": [
            "string collator_get_locale( Collator $coll, int $type )",
            "* Gets the locale name of the collator."
        ],
        "collator_get_sort_key": [
            "bool collator_get_sort_key( Collator $coll, string $str )",
            "* Get a sort key for a string from a Collator. }}}"
        ],
        "collator_get_strength": [
            "int collator_get_strength(Collator coll)",
            "* Returns the current collation strength."
        ],
        "collator_set_attribute": [
            "bool collator_set_attribute( Collator $coll, int $attr, int $val )",
            "* Set collation attribute."
        ],
        "collator_set_strength": [
            "bool collator_set_strength(Collator coll, int strength)",
            "* Set the collation strength."
        ],
        "collator_sort": [
            "bool collator_sort(  Collator $coll, array(string) $arr [, int $sort_flags] )",
            "* Sort array using specified collator."
        ],
        "collator_sort_with_sort_keys": [
            "bool collator_sort_with_sort_keys( Collator $coll, array(string) $arr )",
            "* Equivalent to standard PHP sort using Collator.  * Uses ICU ucol_getSortKey for performance."
        ],
        "com_create_guid": [
            "string com_create_guid()",
            "Generate a globally unique identifier (GUID)"
        ],
        "com_event_sink": [
            "bool com_event_sink(object comobject, object sinkobject [, mixed sinkinterface])",
            "Connect events from a COM object to a PHP object"
        ],
        "com_get_active_object": [
            "object com_get_active_object(string progid [, int code_page ])",
            "Returns a handle to an already running instance of a COM object"
        ],
        "com_load_typelib": [
            "bool com_load_typelib(string typelib_name [, int case_insensitive])",
            "Loads a Typelibrary and registers its constants"
        ],
        "com_message_pump": [
            "bool com_message_pump([int timeoutms])",
            "Process COM messages, sleeping for up to timeoutms milliseconds"
        ],
        "com_print_typeinfo": [
            "bool com_print_typeinfo(object comobject | string typelib, string dispinterface, bool wantsink)",
            "Print out a PHP class definition for a dispatchable interface"
        ],
        "compact": [
            "array compact(mixed var_names [, mixed ...])",
            "Creates a hash containing variables and their values"
        ],
        "compose_locale": [
            "static string compose_locale($array)",
            "* Creates a locale by combining the parts of locale-ID passed  * }}}"
        ],
        "confirm_extname_compiled": [
            "string confirm_extname_compiled(string arg)",
            "Return a string to confirm that the module is compiled in"
        ],
        "connection_aborted": [
            "int connection_aborted()",
            "Returns true if client disconnected"
        ],
        "connection_status": [
            "int connection_status()",
            "Returns the connection status bitfield"
        ],
        "constant": [
            "mixed constant(string const_name)",
            "Given the name of a constant this function will return the constant's associated value"
        ],
        "convert_cyr_string": [
            "string convert_cyr_string(string str, string from, string to)",
            "Convert from one Cyrillic character set to another"
        ],
        "convert_uudecode": [
            "string convert_uudecode(string data)",
            "decode a uuencoded string"
        ],
        "convert_uuencode": [
            "string convert_uuencode(string data)",
            "uuencode a string"
        ],
        "copy": [
            "bool copy(string source_file, string destination_file [, resource context])",
            "Copy a file"
        ],
        "cos": [
            "float cos(float number)",
            "Returns the cosine of the number in radians"
        ],
        "cosh": [
            "float cosh(float number)",
            "Returns the hyperbolic cosine of the number, defined as (exp(number) + exp(-number))/2"
        ],
        "count": [
            "int count(mixed var [, int mode])",
            "Count the number of elements in a variable (usually an array)"
        ],
        "count_chars": [
            "mixed count_chars(string input [, int mode])",
            "Returns info about what characters are used in input"
        ],
        "crc32": [
            "string crc32(string str)",
            "Calculate the crc32 polynomial of a string"
        ],
        "create_function": [
            "string create_function(string args, string code)",
            "Creates an anonymous function, and returns its name"
        ],
        "crypt": [
            "string crypt(string str [, string salt])",
            "Hash a string"
        ],
        "ctype_alnum": [
            "bool ctype_alnum(mixed c)",
            "Checks for alphanumeric character(s)"
        ],
        "ctype_alpha": [
            "bool ctype_alpha(mixed c)",
            "Checks for alphabetic character(s)"
        ],
        "ctype_cntrl": [
            "bool ctype_cntrl(mixed c)",
            "Checks for control character(s)"
        ],
        "ctype_digit": [
            "bool ctype_digit(mixed c)",
            "Checks for numeric character(s)"
        ],
        "ctype_graph": [
            "bool ctype_graph(mixed c)",
            "Checks for any printable character(s) except space"
        ],
        "ctype_lower": [
            "bool ctype_lower(mixed c)",
            "Checks for lowercase character(s)"
        ],
        "ctype_print": [
            "bool ctype_print(mixed c)",
            "Checks for printable character(s)"
        ],
        "ctype_punct": [
            "bool ctype_punct(mixed c)",
            "Checks for any printable character which is not whitespace or an alphanumeric character"
        ],
        "ctype_space": [
            "bool ctype_space(mixed c)",
            "Checks for whitespace character(s)"
        ],
        "ctype_upper": [
            "bool ctype_upper(mixed c)",
            "Checks for uppercase character(s)"
        ],
        "ctype_xdigit": [
            "bool ctype_xdigit(mixed c)",
            "Checks for character(s) representing a hexadecimal digit"
        ],
        "curl_close": [
            "void curl_close(resource ch)",
            "Close a cURL session"
        ],
        "curl_copy_handle": [
            "resource curl_copy_handle(resource ch)",
            "Copy a cURL handle along with all of it's preferences"
        ],
        "curl_errno": [
            "int curl_errno(resource ch)",
            "Return an integer containing the last error number"
        ],
        "curl_error": [
            "string curl_error(resource ch)",
            "Return a string contain the last error for the current session"
        ],
        "curl_exec": [
            "bool curl_exec(resource ch)",
            "Perform a cURL session"
        ],
        "curl_getinfo": [
            "mixed curl_getinfo(resource ch [, int option])",
            "Get information regarding a specific transfer"
        ],
        "curl_init": [
            "resource curl_init([string url])",
            "Initialize a cURL session"
        ],
        "curl_multi_add_handle": [
            "int curl_multi_add_handle(resource mh, resource ch)",
            "Add a normal cURL handle to a cURL multi handle"
        ],
        "curl_multi_close": [
            "void curl_multi_close(resource mh)",
            "Close a set of cURL handles"
        ],
        "curl_multi_exec": [
            "int curl_multi_exec(resource mh, int &still_running)",
            "Run the sub-connections of the current cURL handle"
        ],
        "curl_multi_getcontent": [
            "string curl_multi_getcontent(resource ch)",
            "Return the content of a cURL handle if CURLOPT_RETURNTRANSFER is set"
        ],
        "curl_multi_info_read": [
            "array curl_multi_info_read(resource mh [, long msgs_in_queue])",
            "Get information about the current transfers"
        ],
        "curl_multi_init": [
            "resource curl_multi_init()",
            "Returns a new cURL multi handle"
        ],
        "curl_multi_remove_handle": [
            "int curl_multi_remove_handle(resource mh, resource ch)",
            "Remove a multi handle from a set of cURL handles"
        ],
        "curl_multi_select": [
            "int curl_multi_select(resource mh[, double timeout])",
            'Get all the sockets associated with the cURL extension, which can then be "selected"'
        ],
        "curl_setopt": [
            "bool curl_setopt(resource ch, int option, mixed value)",
            "Set an option for a cURL transfer"
        ],
        "curl_setopt_array": [
            "bool curl_setopt_array(resource ch, array options)",
            "Set an array of option for a cURL transfer"
        ],
        "curl_version": [
            "array curl_version([int version])",
            "Return cURL version information."
        ],
        "current": [
            "mixed current(array array_arg)",
            "Return the element currently pointed to by the internal array pointer"
        ],
        "date": [
            "string date(string format [, long timestamp])",
            "Format a local date/time"
        ],
        "date_add": [
            "DateTime date_add(DateTime object, DateInterval interval)",
            "Adds an interval to the current date in object."
        ],
        "date_create": [
            "DateTime date_create([string time[, DateTimeZone object]])",
            "Returns new DateTime object"
        ],
        "date_create_from_format": [
            "DateTime date_create_from_format(string format, string time[, DateTimeZone object])",
            "Returns new DateTime object formatted according to the specified format"
        ],
        "date_date_set": [
            "DateTime date_date_set(DateTime object, long year, long month, long day)",
            "Sets the date."
        ],
        "date_default_timezone_get": [
            "string date_default_timezone_get()",
            "Gets the default timezone used by all date/time functions in a script"
        ],
        "date_default_timezone_set": [
            "bool date_default_timezone_set(string timezone_identifier)",
            "Sets the default timezone used by all date/time functions in a script"
        ],
        "date_diff": [
            "DateInterval date_diff(DateTime object [, bool absolute])",
            "Returns the difference between two DateTime objects."
        ],
        "date_format": [
            "string date_format(DateTime object, string format)",
            "Returns date formatted according to given format"
        ],
        "date_get_last_errors": [
            "array date_get_last_errors()",
            "Returns the warnings and errors found while parsing a date/time string."
        ],
        "date_interval_create_from_date_string": [
            "DateInterval date_interval_create_from_date_string(string time)",
            "Uses the normal date parsers and sets up a DateInterval from the relative parts of the parsed string"
        ],
        "date_interval_format": [
            "string date_interval_format(DateInterval object, string format)",
            "Formats the interval."
        ],
        "date_isodate_set": [
            "DateTime date_isodate_set(DateTime object, long year, long week[, long day])",
            "Sets the ISO date."
        ],
        "date_modify": [
            "DateTime date_modify(DateTime object, string modify)",
            "Alters the timestamp."
        ],
        "date_offset_get": [
            "long date_offset_get(DateTime object)",
            "Returns the DST offset."
        ],
        "date_parse": [
            "array date_parse(string date)",
            "Returns associative array with detailed info about given date"
        ],
        "date_parse_from_format": [
            "array date_parse_from_format(string format, string date)",
            "Returns associative array with detailed info about given date"
        ],
        "date_sub": [
            "DateTime date_sub(DateTime object, DateInterval interval)",
            "Subtracts an interval to the current date in object."
        ],
        "date_sun_info": [
            "array date_sun_info(long time, float latitude, float longitude)",
            "Returns an array with information about sun set/rise and twilight begin/end"
        ],
        "date_sunrise": [
            "mixed date_sunrise(mixed time [, int format [, float latitude [, float longitude [, float zenith [, float gmt_offset]]]]])",
            "Returns time of sunrise for a given day and location"
        ],
        "date_sunset": [
            "mixed date_sunset(mixed time [, int format [, float latitude [, float longitude [, float zenith [, float gmt_offset]]]]])",
            "Returns time of sunset for a given day and location"
        ],
        "date_time_set": [
            "DateTime date_time_set(DateTime object, long hour, long minute[, long second])",
            "Sets the time."
        ],
        "date_timestamp_get": [
            "long date_timestamp_get(DateTime object)",
            "Gets the Unix timestamp."
        ],
        "date_timestamp_set": [
            "DateTime date_timestamp_set(DateTime object, long unixTimestamp)",
            "Sets the date and time based on an Unix timestamp."
        ],
        "date_timezone_get": [
            "DateTimeZone date_timezone_get(DateTime object)",
            "Return new DateTimeZone object relative to give DateTime"
        ],
        "date_timezone_set": [
            "DateTime date_timezone_set(DateTime object, DateTimeZone object)",
            "Sets the timezone for the DateTime object."
        ],
        "datefmt_create": [
            "IntlDateFormatter datefmt_create(string $locale, long date_type, long time_type[, string $timezone_str, long $calendar, string $pattern] )",
            "* Create formatter."
        ],
        "datefmt_format": [
            "string datefmt_format( [mixed]int $args or array $args )",
            "* Format the time value as a string. }}}"
        ],
        "datefmt_get_calendar": [
            "string datefmt_get_calendar( IntlDateFormatter $mf )",
            "* Get formatter calendar."
        ],
        "datefmt_get_datetype": [
            "string datefmt_get_datetype( IntlDateFormatter $mf )",
            "* Get formatter datetype."
        ],
        "datefmt_get_error_code": [
            "int datefmt_get_error_code( IntlDateFormatter $nf )",
            "* Get formatter's last error code."
        ],
        "datefmt_get_error_message": [
            "string datefmt_get_error_message( IntlDateFormatter $coll )",
            "* Get text description for formatter's last error code."
        ],
        "datefmt_get_locale": [
            "string datefmt_get_locale(IntlDateFormatter $mf)",
            "* Get formatter locale."
        ],
        "datefmt_get_pattern": [
            "string datefmt_get_pattern( IntlDateFormatter $mf )",
            "* Get formatter pattern."
        ],
        "datefmt_get_timetype": [
            "string datefmt_get_timetype( IntlDateFormatter $mf )",
            "* Get formatter timetype."
        ],
        "datefmt_get_timezone_id": [
            "string datefmt_get_timezone_id( IntlDateFormatter $mf )",
            "* Get formatter timezone_id."
        ],
        "datefmt_isLenient": [
            "string datefmt_isLenient(IntlDateFormatter $mf)",
            "* Get formatter locale."
        ],
        "datefmt_localtime": [
            "integer datefmt_localtime( IntlDateFormatter $fmt, string $text_to_parse[, int $parse_pos ])",
            "* Parse the string $value to a localtime array  }}}"
        ],
        "datefmt_parse": [
            "integer datefmt_parse( IntlDateFormatter $fmt, string $text_to_parse [, int $parse_pos] )",
            "* Parse the string $value starting at parse_pos to a Unix timestamp -int }}}"
        ],
        "datefmt_setLenient": [
            "string datefmt_setLenient(IntlDateFormatter $mf)",
            "* Set formatter lenient."
        ],
        "datefmt_set_calendar": [
            "bool datefmt_set_calendar( IntlDateFormatter $mf, int $calendar )",
            "* Set formatter calendar."
        ],
        "datefmt_set_pattern": [
            "bool datefmt_set_pattern( IntlDateFormatter $mf, string $pattern )",
            "* Set formatter pattern."
        ],
        "datefmt_set_timezone_id": [
            "bool datefmt_set_timezone_id( IntlDateFormatter $mf,$timezone_id)",
            "* Set formatter timezone_id."
        ],
        "dba_close": [
            "void dba_close(resource handle)",
            "Closes database"
        ],
        "dba_delete": [
            "bool dba_delete(string key, resource handle)",
            "Deletes the entry associated with key    If inifile: remove all other key lines"
        ],
        "dba_exists": [
            "bool dba_exists(string key, resource handle)",
            "Checks, if the specified key exists"
        ],
        "dba_fetch": [
            "string dba_fetch(string key, [int skip ,] resource handle)",
            "Fetches the data associated with key"
        ],
        "dba_firstkey": [
            "string dba_firstkey(resource handle)",
            "Resets the internal key pointer and returns the first key"
        ],
        "dba_handlers": [
            "array dba_handlers([bool full_info])",
            "List configured database handlers"
        ],
        "dba_insert": [
            "bool dba_insert(string key, string value, resource handle)",
            "If not inifile: Insert value as key, return false, if key exists already     If inifile: Add vakue as key (next instance of key)"
        ],
        "dba_key_split": [
            "array|false dba_key_split(string key)",
            "Splits an inifile key into an array of the form array(0=>group,1=>value_name) but returns false if input is false or null"
        ],
        "dba_list": [
            "array dba_list()",
            "List opened databases"
        ],
        "dba_nextkey": [
            "string dba_nextkey(resource handle)",
            "Returns the next key"
        ],
        "dba_open": [
            "resource dba_open(string path, string mode [, string handlername, string ...])",
            "Opens path using the specified handler in mode"
        ],
        "dba_optimize": [
            "bool dba_optimize(resource handle)",
            "Optimizes (e.g. clean up, vacuum) database"
        ],
        "dba_popen": [
            "resource dba_popen(string path, string mode [, string handlername, string ...])",
            "Opens path using the specified handler in mode persistently"
        ],
        "dba_replace": [
            "bool dba_replace(string key, string value, resource handle)",
            "Inserts value as key, replaces key, if key exists already    If inifile: remove all other key lines"
        ],
        "dba_sync": [
            "bool dba_sync(resource handle)",
            "Synchronizes database"
        ],
        "dcgettext": [
            "string dcgettext(string domain_name, string msgid, long category)",
            "Return the translation of msgid for domain_name and category, or msgid unaltered if a translation does not exist"
        ],
        "dcngettext": [
            "string dcngettext(string domain, string msgid1, string msgid2, int n, int category)",
            "Plural version of dcgettext()"
        ],
        "debug_backtrace": [
            "array debug_backtrace([bool provide_object])",
            "Return backtrace as array"
        ],
        "debug_print_backtrace": [
            "void debug_print_backtrace()",
            "Prints a PHP backtrace"
        ],
        "debug_zval_dump": [
            "void debug_zval_dump(mixed var)",
            "Dumps a string representation of an internal Zend value to output"
        ],
        "decbin": [
            "string decbin(int decimal_number)",
            "Returns a string containing a binary representation of the number"
        ],
        "dechex": [
            "string dechex(int decimal_number)",
            "Returns a string containing a hexadecimal representation of the given number"
        ],
        "decoct": [
            "string decoct(int decimal_number)",
            "Returns a string containing an octal representation of the given number"
        ],
        "define": [
            "bool define(string constant_name, mixed value, bool case_insensitive=false)",
            "Define a new constant"
        ],
        "define_syslog_variables": [
            "void define_syslog_variables()",
            "Initializes all syslog-related variables"
        ],
        "defined": [
            "bool defined(string constant_name)",
            "Check whether a constant exists"
        ],
        "deg2rad": [
            "float deg2rad(float number)",
            "Converts the number in degrees to the radian equivalent"
        ],
        "dgettext": [
            "string dgettext(string domain_name, string msgid)",
            "Return the translation of msgid for domain_name, or msgid unaltered if a translation does not exist"
        ],
        "die": [
            "void die([mixed status])",
            "Output a message and terminate the current script"
        ],
        "dir": [
            "object dir(string directory[, resource context])",
            "Directory class with properties, handle and class and methods read, rewind and close"
        ],
        "dirname": [
            "string dirname(string path)",
            "Returns the directory name component of the path"
        ],
        "disk_free_space": [
            "float disk_free_space(string path)",
            "Get free disk space for filesystem that path is on"
        ],
        "disk_total_space": [
            "float disk_total_space(string path)",
            "Get total disk space for filesystem that path is on"
        ],
        "display_disabled_function": [
            "void display_disabled_function()",
            "Dummy function which displays an error when a disabled function is called."
        ],
        "dl": [
            "int dl(string extension_filename)",
            "Load a PHP extension at runtime"
        ],
        "dngettext": [
            "string dngettext(string domain, string msgid1, string msgid2, int count)",
            "Plural version of dgettext()"
        ],
        "dns_check_record": [
            "bool dns_check_record(string host [, string type])",
            "Check DNS records corresponding to a given Internet host name or IP address"
        ],
        "dns_get_mx": [
            "bool dns_get_mx(string hostname, array mxhosts [, array weight])",
            "Get MX records corresponding to a given Internet host name"
        ],
        "dns_get_record": [
            "array|false dns_get_record(string hostname [, int type[, array authns, array addtl]])",
            "Get any Resource Record corresponding to a given Internet host name"
        ],
        "dom_attr_is_id": [
            "bool dom_attr_is_id()",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#Attr-isId Since: DOM Level 3"
        ],
        "dom_characterdata_append_data": [
            "void dom_characterdata_append_data(string arg)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-32791A2F Since:"
        ],
        "dom_characterdata_delete_data": [
            "void dom_characterdata_delete_data(int offset, int count)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-7C603781 Since:"
        ],
        "dom_characterdata_insert_data": [
            "void dom_characterdata_insert_data(int offset, string arg)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-3EDB695F Since:"
        ],
        "dom_characterdata_replace_data": [
            "void dom_characterdata_replace_data(int offset, int count, string arg)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-E5CBA7FB Since:"
        ],
        "dom_characterdata_substring_data": [
            "string dom_characterdata_substring_data(int offset, int count)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-6531BCCF Since:"
        ],
        "dom_document_adopt_node": [
            "DOMNode dom_document_adopt_node(DOMNode source)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-Document3-adoptNode Since: DOM Level 3"
        ],
        "dom_document_create_attribute": [
            "DOMAttr dom_document_create_attribute(string name)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-1084891198 Since:"
        ],
        "dom_document_create_attribute_ns": [
            "DOMAttr dom_document_create_attribute_ns(string namespaceURI, string qualifiedName)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-DocCrAttrNS Since: DOM Level 2"
        ],
        "dom_document_create_cdatasection": [
            "DOMCdataSection dom_document_create_cdatasection(string data)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-D26C0AF8 Since:"
        ],
        "dom_document_create_comment": [
            "DOMComment dom_document_create_comment(string data)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-1334481328 Since:"
        ],
        "dom_document_create_document_fragment": [
            "DOMDocumentFragment dom_document_create_document_fragment()",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-35CB04B5 Since:"
        ],
        "dom_document_create_element": [
            "DOMElement dom_document_create_element(string tagName [, string value])",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-2141741547 Since:"
        ],
        "dom_document_create_element_ns": [
            "DOMElement dom_document_create_element_ns(string namespaceURI, string qualifiedName [,string value])",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-DocCrElNS Since: DOM Level 2"
        ],
        "dom_document_create_entity_reference": [
            "DOMEntityReference dom_document_create_entity_reference(string name)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-392B75AE Since:"
        ],
        "dom_document_create_processing_instruction": [
            "DOMProcessingInstruction dom_document_create_processing_instruction(string target, string data)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-135944439 Since:"
        ],
        "dom_document_create_text_node": [
            "DOMText dom_document_create_text_node(string data)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-1975348127 Since:"
        ],
        "dom_document_get_element_by_id": [
            "DOMElement dom_document_get_element_by_id(string elementId)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-getElBId Since: DOM Level 2"
        ],
        "dom_document_get_elements_by_tag_name": [
            "DOMNodeList dom_document_get_elements_by_tag_name(string tagname)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-A6C9094 Since:"
        ],
        "dom_document_get_elements_by_tag_name_ns": [
            "DOMNodeList dom_document_get_elements_by_tag_name_ns(string namespaceURI, string localName)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-getElBTNNS Since: DOM Level 2"
        ],
        "dom_document_import_node": [
            "DOMNode dom_document_import_node(DOMNode importedNode, bool deep)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#Core-Document-importNode Since: DOM Level 2"
        ],
        "dom_document_load": [
            "DOMNode dom_document_load(string source [, int options])",
            "URL: http://www.w3.org/TR/DOM-Level-3-LS/load-save.html#LS-DocumentLS-load Since: DOM Level 3"
        ],
        "dom_document_load_html": [
            "DOMNode dom_document_load_html(string source)",
            "Since: DOM extended"
        ],
        "dom_document_load_html_file": [
            "DOMNode dom_document_load_html_file(string source)",
            "Since: DOM extended"
        ],
        "dom_document_loadxml": [
            "DOMNode dom_document_loadxml(string source [, int options])",
            "URL: http://www.w3.org/TR/DOM-Level-3-LS/load-save.html#LS-DocumentLS-loadXML Since: DOM Level 3"
        ],
        "dom_document_normalize_document": [
            "void dom_document_normalize_document()",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-Document3-normalizeDocument Since: DOM Level 3"
        ],
        "dom_document_relaxNG_validate_file": [
            "bool dom_document_relaxNG_validate_file(string filename); */",
            "PHP_FUNCTION(dom_document_relaxNG_validate_file) {  _dom_document_relaxNG_validate(INTERNAL_FUNCTION_PARAM_PASSTHRU, DOM_LOAD_FILE); } /* }}} end dom_document_relaxNG_validate_file"
        ],
        "dom_document_relaxNG_validate_xml": [
            "bool dom_document_relaxNG_validate_xml(string source); */",
            "PHP_FUNCTION(dom_document_relaxNG_validate_xml) {  _dom_document_relaxNG_validate(INTERNAL_FUNCTION_PARAM_PASSTHRU, DOM_LOAD_STRING); } /* }}} end dom_document_relaxNG_validate_xml"
        ],
        "dom_document_rename_node": [
            "DOMNode dom_document_rename_node(node n, string namespaceURI, string qualifiedName)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-Document3-renameNode Since: DOM Level 3"
        ],
        "dom_document_save": [
            "int dom_document_save(string file)",
            "Convenience method to save to file"
        ],
        "dom_document_save_html": [
            "string dom_document_save_html()",
            "Convenience method to output as html"
        ],
        "dom_document_save_html_file": [
            "int dom_document_save_html_file(string file)",
            "Convenience method to save to file as html"
        ],
        "dom_document_savexml": [
            "string dom_document_savexml([node n])",
            "URL: http://www.w3.org/TR/DOM-Level-3-LS/load-save.html#LS-DocumentLS-saveXML Since: DOM Level 3"
        ],
        "dom_document_schema_validate": [
            "bool dom_document_schema_validate(string source); */",
            "PHP_FUNCTION(dom_document_schema_validate_xml) {  _dom_document_schema_validate(INTERNAL_FUNCTION_PARAM_PASSTHRU, DOM_LOAD_STRING); } /* }}} end dom_document_schema_validate"
        ],
        "dom_document_schema_validate_file": [
            "bool dom_document_schema_validate_file(string filename); */",
            "PHP_FUNCTION(dom_document_schema_validate_file) {  _dom_document_schema_validate(INTERNAL_FUNCTION_PARAM_PASSTHRU, DOM_LOAD_FILE); } /* }}} end dom_document_schema_validate_file"
        ],
        "dom_document_validate": [
            "bool dom_document_validate()",
            "Since: DOM extended"
        ],
        "dom_document_xinclude": [
            "int dom_document_xinclude([int options])",
            "Substitutues xincludes in a DomDocument"
        ],
        "dom_domconfiguration_can_set_parameter": [
            "bool dom_domconfiguration_can_set_parameter(string name, domuserdata value)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#DOMConfiguration-canSetParameter Since:"
        ],
        "dom_domconfiguration_get_parameter": [
            "domdomuserdata dom_domconfiguration_get_parameter(string name)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#DOMConfiguration-getParameter Since:"
        ],
        "dom_domconfiguration_set_parameter": [
            "dom_void dom_domconfiguration_set_parameter(string name, domuserdata value)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#DOMConfiguration-property Since:"
        ],
        "dom_domerrorhandler_handle_error": [
            "dom_bool dom_domerrorhandler_handle_error(domerror error)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#ID-ERRORS-DOMErrorHandler-handleError Since:"
        ],
        "dom_domimplementation_create_document": [
            "DOMDocument dom_domimplementation_create_document(string namespaceURI, string qualifiedName, DOMDocumentType doctype)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#Level-2-Core-DOM-createDocument Since: DOM Level 2"
        ],
        "dom_domimplementation_create_document_type": [
            "DOMDocumentType dom_domimplementation_create_document_type(string qualifiedName, string publicId, string systemId)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#Level-2-Core-DOM-createDocType Since: DOM Level 2"
        ],
        "dom_domimplementation_get_feature": [
            "DOMNode dom_domimplementation_get_feature(string feature, string version)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#DOMImplementation3-getFeature Since: DOM Level 3"
        ],
        "dom_domimplementation_has_feature": [
            "bool dom_domimplementation_has_feature(string feature, string version)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#ID-5CED94D7 Since:"
        ],
        "dom_domimplementationlist_item": [
            "domdomimplementation dom_domimplementationlist_item(int index)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#DOMImplementationList-item Since:"
        ],
        "dom_domimplementationsource_get_domimplementation": [
            "domdomimplementation dom_domimplementationsource_get_domimplementation(string features)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#ID-getDOMImpl Since:"
        ],
        "dom_domimplementationsource_get_domimplementations": [
            "domimplementationlist dom_domimplementationsource_get_domimplementations(string features)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#ID-getDOMImpls Since:"
        ],
        "dom_domstringlist_item": [
            "domstring dom_domstringlist_item(int index)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#DOMStringList-item Since:"
        ],
        "dom_element_get_attribute": [
            "string dom_element_get_attribute(string name)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-666EE0F9 Since:"
        ],
        "dom_element_get_attribute_node": [
            "DOMAttr dom_element_get_attribute_node(string name)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-217A91B8 Since:"
        ],
        "dom_element_get_attribute_node_ns": [
            "DOMAttr dom_element_get_attribute_node_ns(string namespaceURI, string localName)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-ElGetAtNodeNS Since: DOM Level 2"
        ],
        "dom_element_get_attribute_ns": [
            "string dom_element_get_attribute_ns(string namespaceURI, string localName)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-ElGetAttrNS Since: DOM Level 2"
        ],
        "dom_element_get_elements_by_tag_name": [
            "DOMNodeList dom_element_get_elements_by_tag_name(string name)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-1938918D Since:"
        ],
        "dom_element_get_elements_by_tag_name_ns": [
            "DOMNodeList dom_element_get_elements_by_tag_name_ns(string namespaceURI, string localName)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-A6C90942 Since: DOM Level 2"
        ],
        "dom_element_has_attribute": [
            "bool dom_element_has_attribute(string name)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-ElHasAttr Since: DOM Level 2"
        ],
        "dom_element_has_attribute_ns": [
            "bool dom_element_has_attribute_ns(string namespaceURI, string localName)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-ElHasAttrNS Since: DOM Level 2"
        ],
        "dom_element_remove_attribute": [
            "void dom_element_remove_attribute(string name)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-6D6AC0F9 Since:"
        ],
        "dom_element_remove_attribute_node": [
            "DOMAttr dom_element_remove_attribute_node(DOMAttr oldAttr)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-D589198 Since:"
        ],
        "dom_element_remove_attribute_ns": [
            "void dom_element_remove_attribute_ns(string namespaceURI, string localName)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-ElRemAtNS Since: DOM Level 2"
        ],
        "dom_element_set_attribute": [
            "void dom_element_set_attribute(string name, string value)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-F68F082 Since:"
        ],
        "dom_element_set_attribute_node": [
            "DOMAttr dom_element_set_attribute_node(DOMAttr newAttr)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-887236154 Since:"
        ],
        "dom_element_set_attribute_node_ns": [
            "DOMAttr dom_element_set_attribute_node_ns(DOMAttr newAttr)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-ElSetAtNodeNS Since: DOM Level 2"
        ],
        "dom_element_set_attribute_ns": [
            "void dom_element_set_attribute_ns(string namespaceURI, string qualifiedName, string value)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-ElSetAttrNS Since: DOM Level 2"
        ],
        "dom_element_set_id_attribute": [
            "void dom_element_set_id_attribute(string name, bool isId)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-ElSetIdAttr Since: DOM Level 3"
        ],
        "dom_element_set_id_attribute_node": [
            "void dom_element_set_id_attribute_node(attr idAttr, bool isId)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-ElSetIdAttrNode Since: DOM Level 3"
        ],
        "dom_element_set_id_attribute_ns": [
            "void dom_element_set_id_attribute_ns(string namespaceURI, string localName, bool isId)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-ElSetIdAttrNS Since: DOM Level 3"
        ],
        "dom_import_simplexml": [
            "somNode dom_import_simplexml(sxeobject node)",
            "Get a simplexml_element object from dom to allow for processing"
        ],
        "dom_namednodemap_get_named_item": [
            "DOMNode dom_namednodemap_get_named_item(string name)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-1074577549 Since:"
        ],
        "dom_namednodemap_get_named_item_ns": [
            "DOMNode dom_namednodemap_get_named_item_ns(string namespaceURI, string localName)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-getNamedItemNS Since: DOM Level 2"
        ],
        "dom_namednodemap_item": [
            "DOMNode dom_namednodemap_item(int index)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-349467F9 Since:"
        ],
        "dom_namednodemap_remove_named_item": [
            "DOMNode dom_namednodemap_remove_named_item(string name)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-D58B193 Since:"
        ],
        "dom_namednodemap_remove_named_item_ns": [
            "DOMNode dom_namednodemap_remove_named_item_ns(string namespaceURI, string localName)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-removeNamedItemNS Since: DOM Level 2"
        ],
        "dom_namednodemap_set_named_item": [
            "DOMNode dom_namednodemap_set_named_item(DOMNode arg)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-1025163788 Since:"
        ],
        "dom_namednodemap_set_named_item_ns": [
            "DOMNode dom_namednodemap_set_named_item_ns(DOMNode arg)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-setNamedItemNS Since: DOM Level 2"
        ],
        "dom_namelist_get_name": [
            "string dom_namelist_get_name(int index)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#NameList-getName Since:"
        ],
        "dom_namelist_get_namespace_uri": [
            "string dom_namelist_get_namespace_uri(int index)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#NameList-getNamespaceURI Since:"
        ],
        "dom_node_append_child": [
            "DomNode dom_node_append_child(DomNode newChild)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-184E7107 Since:"
        ],
        "dom_node_clone_node": [
            "DomNode dom_node_clone_node(bool deep)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-3A0ED0A4 Since:"
        ],
        "dom_node_compare_document_position": [
            "short dom_node_compare_document_position(DomNode other)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#Node3-compareDocumentPosition Since: DOM Level 3"
        ],
        "dom_node_get_feature": [
            "DomNode dom_node_get_feature(string feature, string version)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#Node3-getFeature Since: DOM Level 3"
        ],
        "dom_node_get_user_data": [
            "mixed dom_node_get_user_data(string key)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#Node3-getUserData Since: DOM Level 3"
        ],
        "dom_node_has_attributes": [
            "bool dom_node_has_attributes()",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-NodeHasAttrs Since: DOM Level 2"
        ],
        "dom_node_has_child_nodes": [
            "bool dom_node_has_child_nodes()",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-810594187 Since:"
        ],
        "dom_node_insert_before": [
            "domnode dom_node_insert_before(DomNode newChild, DomNode refChild)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-952280727 Since:"
        ],
        "dom_node_is_default_namespace": [
            "bool dom_node_is_default_namespace(string namespaceURI)",
            "URL: http://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-isDefaultNamespace Since: DOM Level 3"
        ],
        "dom_node_is_equal_node": [
            "bool dom_node_is_equal_node(DomNode arg)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#Node3-isEqualNode Since: DOM Level 3"
        ],
        "dom_node_is_same_node": [
            "bool dom_node_is_same_node(DomNode other)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#Node3-isSameNode Since: DOM Level 3"
        ],
        "dom_node_is_supported": [
            "bool dom_node_is_supported(string feature, string version)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-Level-2-Core-Node-supports Since: DOM Level 2"
        ],
        "dom_node_lookup_namespace_uri": [
            "string dom_node_lookup_namespace_uri(string prefix)",
            "URL: http://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespaceURI Since: DOM Level 3"
        ],
        "dom_node_lookup_prefix": [
            "string dom_node_lookup_prefix(string namespaceURI)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#Node3-lookupNamespacePrefix Since: DOM Level 3"
        ],
        "dom_node_normalize": [
            "void dom_node_normalize()",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-normalize Since:"
        ],
        "dom_node_remove_child": [
            "DomNode dom_node_remove_child(DomNode oldChild)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-1734834066 Since:"
        ],
        "dom_node_replace_child": [
            "DomNode dom_node_replace_child(DomNode newChild, DomNode oldChild)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-785887307 Since:"
        ],
        "dom_node_set_user_data": [
            "mixed dom_node_set_user_data(string key, mixed data, userdatahandler handler)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#Node3-setUserData Since: DOM Level 3"
        ],
        "dom_nodelist_item": [
            "DOMNode dom_nodelist_item(int index)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#ID-844377136 Since:"
        ],
        "dom_string_extend_find_offset16": [
            "int dom_string_extend_find_offset16(int offset32)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#i18n-methods-StringExtend-findOffset16 Since:"
        ],
        "dom_string_extend_find_offset32": [
            "int dom_string_extend_find_offset32(int offset16)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#i18n-methods-StringExtend-findOffset32 Since:"
        ],
        "dom_text_is_whitespace_in_element_content": [
            "bool dom_text_is_whitespace_in_element_content()",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-Text3-isWhitespaceInElementContent Since: DOM Level 3"
        ],
        "dom_text_replace_whole_text": [
            "DOMText dom_text_replace_whole_text(string content)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-Text3-replaceWholeText Since: DOM Level 3"
        ],
        "dom_text_split_text": [
            "DOMText dom_text_split_text(int offset)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#core-ID-38853C1D Since:"
        ],
        "dom_userdatahandler_handle": [
            "dom_void dom_userdatahandler_handle(short operation, string key, domobject data, node src, node dst)",
            "URL: http://www.w3.org/TR/2003/WD-DOM-Level-3-Core-20030226/DOM3-Core.html#ID-handleUserDataEvent Since:"
        ],
        "dom_xpath_evaluate": [
            "mixed dom_xpath_evaluate(string expr [,DOMNode context])",
            ""
        ],
        "dom_xpath_query": [
            "DOMNodeList dom_xpath_query(string expr [,DOMNode context])",
            ""
        ],
        "dom_xpath_register_ns": [
            "bool dom_xpath_register_ns(string prefix, string uri)",
            ""
        ],
        "dom_xpath_register_php_functions": [
            "void dom_xpath_register_php_functions()",
            ""
        ],
        "each": [
            "array each(array arr)",
            "Return the currently pointed key..value pair in the passed array, and advance the pointer to the next element"
        ],
        "easter_date": [
            "int easter_date([int year])",
            "Return the timestamp of midnight on Easter of a given year (defaults to current year)"
        ],
        "easter_days": [
            "int easter_days([int year, [int method]])",
            "Return the number of days after March 21 that Easter falls on for a given year (defaults to current year)"
        ],
        "echo": [
            "void echo(string arg1 [, string ...])",
            "Output one or more strings"
        ],
        "empty": [
            "bool empty(mixed var)",
            "Determine whether a variable is empty"
        ],
        "enchant_broker_describe": [
            "array enchant_broker_describe(resource broker)",
            "Enumerates the Enchant providers and tells you some rudimentary information about them. The same info is provided through phpinfo()"
        ],
        "enchant_broker_dict_exists": [
            "bool enchant_broker_dict_exists(resource broker, string tag)",
            "Whether a dictionary exists or not. Using non-empty tag"
        ],
        "enchant_broker_free": [
            "bool enchant_broker_free(resource broker)",
            "Destroys the broker object and its dictionnaries"
        ],
        "enchant_broker_free_dict": [
            "resource enchant_broker_free_dict(resource dict)",
            "Free the dictionary resource"
        ],
        "enchant_broker_get_dict_path": [
            "string enchant_broker_get_dict_path(resource broker, int dict_type)",
            "Get the directory path for a given backend, works with ispell and myspell"
        ],
        "enchant_broker_get_error": [
            "string enchant_broker_get_error(resource broker)",
            "Returns the last error of the broker"
        ],
        "enchant_broker_init": [
            "resource enchant_broker_init()",
            "create a new broker object capable of requesting"
        ],
        "enchant_broker_list_dicts": [
            "string enchant_broker_list_dicts(resource broker)",
            "Lists the dictionaries available for the given broker"
        ],
        "enchant_broker_request_dict": [
            "resource enchant_broker_request_dict(resource broker, string tag)",
            'create a new dictionary using tag, the non-empty language tag you wish to request  a dictionary for ("en_US", "de_DE", ...)'
        ],
        "enchant_broker_request_pwl_dict": [
            "resource enchant_broker_request_pwl_dict(resource broker, string filename)",
            "creates a dictionary using a PWL file. A PWL file is personal word file one word per line. It must exist before the call."
        ],
        "enchant_broker_set_dict_path": [
            "bool enchant_broker_set_dict_path(resource broker, int dict_type, string value)",
            "Set the directory path for a given backend, works with ispell and myspell"
        ],
        "enchant_broker_set_ordering": [
            "bool enchant_broker_set_ordering(resource broker, string tag, string ordering)",
            "Declares a preference of dictionaries to use for the language  described/referred to by 'tag'. The ordering is a comma delimited  list of provider names. As a special exception, the \"*\" tag can  be used as a language tag to declare a default ordering for any  language that does not explictly declare an ordering."
        ],
        "enchant_dict_add_to_personal": [
            "void enchant_dict_add_to_personal(resource dict, string word)",
            "add 'word' to personal word list"
        ],
        "enchant_dict_add_to_session": [
            "void enchant_dict_add_to_session(resource dict, string word)",
            "add 'word' to this spell-checking session"
        ],
        "enchant_dict_check": [
            "bool enchant_dict_check(resource dict, string word)",
            "If the word is correctly spelled return true, otherwise return false"
        ],
        "enchant_dict_describe": [
            "array enchant_dict_describe(resource dict)",
            "Describes an individual dictionary 'dict'"
        ],
        "enchant_dict_get_error": [
            "string enchant_dict_get_error(resource dict)",
            "Returns the last error of the current spelling-session"
        ],
        "enchant_dict_is_in_session": [
            "bool enchant_dict_is_in_session(resource dict, string word)",
            "whether or not 'word' exists in this spelling-session"
        ],
        "enchant_dict_quick_check": [
            "bool enchant_dict_quick_check(resource dict, string word [, array &suggestions])",
            "If the word is correctly spelled return true, otherwise return false, if suggestions variable     is provided, fill it with spelling alternatives."
        ],
        "enchant_dict_store_replacement": [
            "void enchant_dict_store_replacement(resource dict, string mis, string cor)",
            "add a correction for 'mis' using 'cor'.  Notes that you replaced @mis with @cor, so it's possibly more likely  that future occurrences of @mis will be replaced with @cor. So it might  bump @cor up in the suggestion list."
        ],
        "enchant_dict_suggest": [
            "array enchant_dict_suggest(resource dict, string word)",
            "Will return a list of values if any of those pre-conditions are not met."
        ],
        "end": [
            "mixed end(array array_arg)",
            "Advances array argument's internal pointer to the last element and return it"
        ],
        "ereg": [
            "int ereg(string pattern, string string [, array registers])",
            "Regular expression match"
        ],
        "ereg_replace": [
            "string ereg_replace(string pattern, string replacement, string string)",
            "Replace regular expression"
        ],
        "eregi": [
            "int eregi(string pattern, string string [, array registers])",
            "Case-insensitive regular expression match"
        ],
        "eregi_replace": [
            "string eregi_replace(string pattern, string replacement, string string)",
            "Case insensitive replace regular expression"
        ],
        "error_get_last": [
            "array error_get_last()",
            "Get the last occurred error as associative array. Returns NULL if there hasn't been an error yet."
        ],
        "error_log": [
            "bool error_log(string message [, int message_type [, string destination [, string extra_headers]]])",
            "Send an error message somewhere"
        ],
        "error_reporting": [
            "int error_reporting([int new_error_level])",
            "Return the current error_reporting level, and if an argument was passed - change to the new level"
        ],
        "escapeshellarg": [
            "string escapeshellarg(string arg)",
            "Quote and escape an argument for use in a shell command"
        ],
        "escapeshellcmd": [
            "string escapeshellcmd(string command)",
            "Escape shell metacharacters"
        ],
        "exec": [
            "string exec(string command [, array &output [, int &return_value]])",
            "Execute an external program"
        ],
        "exif_imagetype": [
            "int exif_imagetype(string imagefile)",
            "Get the type of an image"
        ],
        "exif_read_data": [
            "array exif_read_data(string filename [, sections_needed [, sub_arrays[, read_thumbnail]]])",
            "Reads header data from the JPEG/TIFF image filename and optionally reads the internal thumbnails"
        ],
        "exif_tagname": [
            "string exif_tagname(index)",
            "Get headername for index or false if not defined"
        ],
        "exif_thumbnail": [
            "string exif_thumbnail(string filename [, &width, &height [, &imagetype]])",
            "Reads the embedded thumbnail"
        ],
        "exit": [
            "void exit([mixed status])",
            "Output a message and terminate the current script"
        ],
        "exp": [
            "float exp(float number)",
            "Returns e raised to the power of the number"
        ],
        "explode": [
            "array explode(string separator, string str [, int limit])",
            "Splits a string on string separator and return array of components. If limit is positive only limit number of components is returned. If limit is negative all components except the last abs(limit) are returned."
        ],
        "expm1": [
            "float expm1(float number)",
            "Returns exp(number) - 1, computed in a way that accurate even when the value of number is close to zero"
        ],
        "extension_loaded": [
            "bool extension_loaded(string extension_name)",
            "Returns true if the named extension is loaded"
        ],
        "extract": [
            "int extract(array var_array [, int extract_type [, string prefix]])",
            "Imports variables into symbol table from an array"
        ],
        "ezmlm_hash": [
            "int ezmlm_hash(string addr)",
            "Calculate EZMLM list hash value."
        ],
        "fclose": [
            "bool fclose(resource fp)",
            "Close an open file pointer"
        ],
        "feof": [
            "bool feof(resource fp)",
            "Test for end-of-file on a file pointer"
        ],
        "fflush": [
            "bool fflush(resource fp)",
            "Flushes output"
        ],
        "fgetc": [
            "string fgetc(resource fp)",
            "Get a character from file pointer"
        ],
        "fgetcsv": [
            "array fgetcsv(resource fp [,int length [, string delimiter [, string enclosure [, string escape]]]])",
            "Get line from file pointer and parse for CSV fields"
        ],
        "fgets": [
            "string fgets(resource fp[, int length])",
            "Get a line from file pointer"
        ],
        "fgetss": [
            "string fgetss(resource fp [, int length [, string allowable_tags]])",
            "Get a line from file pointer and strip HTML tags"
        ],
        "file": [
            "array file(string filename [, int flags[, resource context]])",
            "Read entire file into an array"
        ],
        "file_exists": [
            "bool file_exists(string filename)",
            "Returns true if filename exists"
        ],
        "file_get_contents": [
            "string file_get_contents(string filename [, bool use_include_path [, resource context [, long offset [, long maxlen]]]])",
            "Read the entire file into a string"
        ],
        "file_put_contents": [
            "int file_put_contents(string file, mixed data [, int flags [, resource context]])",
            "Write/Create a file with contents data and return the number of bytes written"
        ],
        "fileatime": [
            "int fileatime(string filename)",
            "Get last access time of file"
        ],
        "filectime": [
            "int filectime(string filename)",
            "Get inode modification time of file"
        ],
        "filegroup": [
            "int filegroup(string filename)",
            "Get file group"
        ],
        "fileinode": [
            "int fileinode(string filename)",
            "Get file inode"
        ],
        "filemtime": [
            "int filemtime(string filename)",
            "Get last modification time of file"
        ],
        "fileowner": [
            "int fileowner(string filename)",
            "Get file owner"
        ],
        "fileperms": [
            "int fileperms(string filename)",
            "Get file permissions"
        ],
        "filesize": [
            "int filesize(string filename)",
            "Get file size"
        ],
        "filetype": [
            "string filetype(string filename)",
            "Get file type"
        ],
        "filter_has_var": [
            "mixed filter_has_var(constant type, string variable_name)",
            "* Returns true if the variable with the name 'name' exists in source."
        ],
        "filter_input": [
            "mixed filter_input(constant type, string variable_name [, long filter [, mixed options]])",
            "* Returns the filtered variable 'name'* from source `type`."
        ],
        "filter_input_array": [
            "mixed filter_input_array(constant type, [, mixed options]])",
            "* Returns an array with all arguments defined in 'definition'."
        ],
        "filter_var": [
            "mixed filter_var(mixed variable [, long filter [, mixed options]])",
            "* Returns the filtered version of the vriable."
        ],
        "filter_var_array": [
            "mixed filter_var_array(array data, [, mixed options]])",
            "* Returns an array with all arguments defined in 'definition'."
        ],
        "finfo_buffer": [
            "string finfo_buffer(resource finfo, char *string [, int options [, resource context]])",
            "Return infromation about a string buffer."
        ],
        "finfo_close": [
            "resource finfo_close(resource finfo)",
            "Close fileinfo resource."
        ],
        "finfo_file": [
            "string finfo_file(resource finfo, char *file_name [, int options [, resource context]])",
            "Return information about a file."
        ],
        "finfo_open": [
            "resource finfo_open([int options [, string arg]])",
            "Create a new fileinfo resource."
        ],
        "finfo_set_flags": [
            "bool finfo_set_flags(resource finfo, int options)",
            "Set libmagic configuration options."
        ],
        "floatval": [
            "float floatval(mixed var)",
            "Get the float value of a variable"
        ],
        "flock": [
            "bool flock(resource fp, int operation [, int &wouldblock])",
            "Portable file locking"
        ],
        "floor": [
            "float floor(float number)",
            "Returns the next lowest integer value from the number"
        ],
        "flush": [
            "void flush()",
            "Flush the output buffer"
        ],
        "fmod": [
            "float fmod(float x, float y)",
            "Returns the remainder of dividing x by y as a float"
        ],
        "fnmatch": [
            "bool fnmatch(string pattern, string filename [, int flags])",
            "Match filename against pattern"
        ],
        "fopen": [
            "resource fopen(string filename, string mode [, bool use_include_path [, resource context]])",
            "Open a file or a URL and return a file pointer"
        ],
        "forward_static_call": [
            "mixed forward_static_call(mixed function_name [, mixed parmeter] [, mixed ...])",
            "Call a user function which is the first parameter"
        ],
        "fpassthru": [
            "int fpassthru(resource fp)",
            "Output all remaining data from a file pointer"
        ],
        "fprintf": [
            "int fprintf(resource stream, string format [, mixed arg1 [, mixed ...]])",
            "Output a formatted string into a stream"
        ],
        "fputcsv": [
            "int fputcsv(resource fp, array fields [, string delimiter [, string enclosure]])",
            "Format line as CSV and write to file pointer"
        ],
        "fread": [
            "string fread(resource fp, int length)",
            "Binary-safe file read"
        ],
        "frenchtojd": [
            "int frenchtojd(int month, int day, int year)",
            "Converts a french republic calendar date to julian day count"
        ],
        "fscanf": [
            "mixed fscanf(resource stream, string format [, string ...])",
            "Implements a mostly ANSI compatible fscanf()"
        ],
        "fseek": [
            "int fseek(resource fp, int offset [, int whence])",
            "Seek on a file pointer"
        ],
        "fsockopen": [
            "resource fsockopen(string hostname, int port [, int errno [, string errstr [, float timeout]]])",
            "Open Internet or Unix domain socket connection"
        ],
        "fstat": [
            "array fstat(resource fp)",
            "Stat() on a filehandle"
        ],
        "ftell": [
            "int ftell(resource fp)",
            "Get file pointer's read/write position"
        ],
        "ftok": [
            "int ftok(string pathname, string proj)",
            "Convert a pathname and a project identifier to a System V IPC key"
        ],
        "ftp_alloc": [
            "bool ftp_alloc(resource stream, int size[, &response])",
            "Attempt to allocate space on the remote FTP server"
        ],
        "ftp_cdup": [
            "bool ftp_cdup(resource stream)",
            "Changes to the parent directory"
        ],
        "ftp_chdir": [
            "bool ftp_chdir(resource stream, string directory)",
            "Changes directories"
        ],
        "ftp_chmod": [
            "int ftp_chmod(resource stream, int mode, string filename)",
            "Sets permissions on a file"
        ],
        "ftp_close": [
            "bool ftp_close(resource stream)",
            "Closes the FTP stream"
        ],
        "ftp_connect": [
            "resource ftp_connect(string host [, int port [, int timeout]])",
            "Opens a FTP stream"
        ],
        "ftp_delete": [
            "bool ftp_delete(resource stream, string file)",
            "Deletes a file"
        ],
        "ftp_exec": [
            "bool ftp_exec(resource stream, string command)",
            "Requests execution of a program on the FTP server"
        ],
        "ftp_fget": [
            "bool ftp_fget(resource stream, resource fp, string remote_file, int mode[, int resumepos])",
            "Retrieves a file from the FTP server and writes it to an open file"
        ],
        "ftp_fput": [
            "bool ftp_fput(resource stream, string remote_file, resource fp, int mode[, int startpos])",
            "Stores a file from an open file to the FTP server"
        ],
        "ftp_get": [
            "bool ftp_get(resource stream, string local_file, string remote_file, int mode[, int resume_pos])",
            "Retrieves a file from the FTP server and writes it to a local file"
        ],
        "ftp_get_option": [
            "mixed ftp_get_option(resource stream, int option)",
            "Gets an FTP option"
        ],
        "ftp_login": [
            "bool ftp_login(resource stream, string username, string password)",
            "Logs into the FTP server"
        ],
        "ftp_mdtm": [
            "int ftp_mdtm(resource stream, string filename)",
            "Returns the last modification time of the file, or -1 on error"
        ],
        "ftp_mkdir": [
            "string ftp_mkdir(resource stream, string directory)",
            "Creates a directory and returns the absolute path for the new directory or false on error"
        ],
        "ftp_nb_continue": [
            "int ftp_nb_continue(resource stream)",
            "Continues retrieving/sending a file nbronously"
        ],
        "ftp_nb_fget": [
            "int ftp_nb_fget(resource stream, resource fp, string remote_file, int mode[, int resumepos])",
            "Retrieves a file from the FTP server asynchronly and writes it to an open file"
        ],
        "ftp_nb_fput": [
            "int ftp_nb_fput(resource stream, string remote_file, resource fp, int mode[, int startpos])",
            "Stores a file from an open file to the FTP server nbronly"
        ],
        "ftp_nb_get": [
            "int ftp_nb_get(resource stream, string local_file, string remote_file, int mode[, int resume_pos])",
            "Retrieves a file from the FTP server nbhronly and writes it to a local file"
        ],
        "ftp_nb_put": [
            "int ftp_nb_put(resource stream, string remote_file, string local_file, int mode[, int startpos])",
            "Stores a file on the FTP server"
        ],
        "ftp_nlist": [
            "array ftp_nlist(resource stream, string directory)",
            "Returns an array of filenames in the given directory"
        ],
        "ftp_pasv": [
            "bool ftp_pasv(resource stream, bool pasv)",
            "Turns passive mode on or off"
        ],
        "ftp_put": [
            "bool ftp_put(resource stream, string remote_file, string local_file, int mode[, int startpos])",
            "Stores a file on the FTP server"
        ],
        "ftp_pwd": [
            "string ftp_pwd(resource stream)",
            "Returns the present working directory"
        ],
        "ftp_raw": [
            "array ftp_raw(resource stream, string command)",
            "Sends a literal command to the FTP server"
        ],
        "ftp_rawlist": [
            "array ftp_rawlist(resource stream, string directory [, bool recursive])",
            "Returns a detailed listing of a directory as an array of output lines"
        ],
        "ftp_rename": [
            "bool ftp_rename(resource stream, string src, string dest)",
            "Renames the given file to a new path"
        ],
        "ftp_rmdir": [
            "bool ftp_rmdir(resource stream, string directory)",
            "Removes a directory"
        ],
        "ftp_set_option": [
            "bool ftp_set_option(resource stream, int option, mixed value)",
            "Sets an FTP option"
        ],
        "ftp_site": [
            "bool ftp_site(resource stream, string cmd)",
            "Sends a SITE command to the server"
        ],
        "ftp_size": [
            "int ftp_size(resource stream, string filename)",
            "Returns the size of the file, or -1 on error"
        ],
        "ftp_ssl_connect": [
            "resource ftp_ssl_connect(string host [, int port [, int timeout]])",
            "Opens a FTP-SSL stream"
        ],
        "ftp_systype": [
            "string ftp_systype(resource stream)",
            "Returns the system type identifier"
        ],
        "ftruncate": [
            "bool ftruncate(resource fp, int size)",
            "Truncate file to 'size' length"
        ],
        "func_get_arg": [
            "mixed func_get_arg(int arg_num)",
            "Get the $arg_num'th argument that was passed to the function"
        ],
        "func_get_args": [
            "array func_get_args()",
            "Get an array of the arguments that were passed to the function"
        ],
        "func_num_args": [
            "int func_num_args()",
            "Get the number of arguments that were passed to the function"
        ],
        "function ": [
            "",
            ""
        ],
        "foreach ": [
            "",
            ""
        ],
        "function_exists": [
            "bool function_exists(string function_name)",
            "Checks if the function exists"
        ],
        "fwrite": [
            "int fwrite(resource fp, string str [, int length])",
            "Binary-safe file write"
        ],
        "gc_collect_cycles": [
            "int gc_collect_cycles()",
            "Forces collection of any existing garbage cycles.    Returns number of freed zvals"
        ],
        "gc_disable": [
            "void gc_disable()",
            "Deactivates the circular reference collector"
        ],
        "gc_enable": [
            "void gc_enable()",
            "Activates the circular reference collector"
        ],
        "gc_enabled": [
            "void gc_enabled()",
            "Returns status of the circular reference collector"
        ],
        "gd_info": [
            "array gd_info()",
            ""
        ],
        "getKeywords": [
            "static array getKeywords(string $locale) {",
            "* return an associative array containing keyword-value  * pairs for this locale. The keys are keys to the array  * }}}"
        ],
        "get_browser": [
            "mixed get_browser([string browser_name [, bool return_array]])",
            "Get information about the capabilities of a browser. If browser_name is omitted or null, HTTP_USER_AGENT is used. Returns an object by default; if return_array is true, returns an array."
        ],
        "get_called_class": [
            "string get_called_class()",
            'Retrieves the "Late Static Binding" class name'
        ],
        "get_cfg_var": [
            "mixed get_cfg_var(string option_name)",
            "Get the value of a PHP configuration option"
        ],
        "get_class": [
            "string get_class([object object])",
            "Retrieves the class name"
        ],
        "get_class_methods": [
            "array get_class_methods(mixed class)",
            "Returns an array of method names for class or class instance."
        ],
        "get_class_vars": [
            "array get_class_vars(string class_name)",
            "Returns an array of default properties of the class."
        ],
        "get_current_user": [
            "string get_current_user()",
            "Get the name of the owner of the current PHP script"
        ],
        "get_declared_classes": [
            "array get_declared_classes()",
            "Returns an array of all declared classes."
        ],
        "get_declared_interfaces": [
            "array get_declared_interfaces()",
            "Returns an array of all declared interfaces."
        ],
        "get_defined_constants": [
            "array get_defined_constants([bool categorize])",
            "Return an array containing the names and values of all defined constants"
        ],
        "get_defined_functions": [
            "array get_defined_functions()",
            "Returns an array of all defined functions"
        ],
        "get_defined_vars": [
            "array get_defined_vars()",
            "Returns an associative array of names and values of all currently defined variable names (variables in the current scope)"
        ],
        "get_display_language": [
            "static string get_display_language($locale[, $in_locale = null])",
            "* gets the language for the $locale in $in_locale or default_locale"
        ],
        "get_display_name": [
            "static string get_display_name($locale[, $in_locale = null])",
            "* gets the name for the $locale in $in_locale or default_locale"
        ],
        "get_display_region": [
            "static string get_display_region($locale, $in_locale = null)",
            "* gets the region for the $locale in $in_locale or default_locale"
        ],
        "get_display_script": [
            "static string get_display_script($locale, $in_locale = null)",
            "* gets the script for the $locale in $in_locale or default_locale"
        ],
        "get_extension_funcs": [
            "array get_extension_funcs(string extension_name)",
            "Returns an array with the names of functions belonging to the named extension"
        ],
        "get_headers": [
            "array get_headers(string url[, int format])",
            "fetches all the headers sent by the server in response to a HTTP request"
        ],
        "get_html_translation_table": [
            "array get_html_translation_table([int table [, int quote_style]])",
            "Returns the internal translation table used by htmlspecialchars and htmlentities"
        ],
        "get_include_path": [
            "string get_include_path()",
            "Get the current include_path configuration option"
        ],
        "get_included_files": [
            "array get_included_files()",
            "Returns an array with the file names that were include_once()'d"
        ],
        "get_loaded_extensions": [
            "array get_loaded_extensions([bool zend_extensions])",
            "Return an array containing names of loaded extensions"
        ],
        "get_magic_quotes_gpc": [
            "int get_magic_quotes_gpc()",
            "Get the current active configuration setting of magic_quotes_gpc"
        ],
        "get_magic_quotes_runtime": [
            "int get_magic_quotes_runtime()",
            "Get the current active configuration setting of magic_quotes_runtime"
        ],
        "get_meta_tags": [
            "array get_meta_tags(string filename [, bool use_include_path])",
            "Extracts all meta tag content attributes from a file and returns an array"
        ],
        "get_object_vars": [
            "array get_object_vars(object obj)",
            "Returns an array of object properties"
        ],
        "get_parent_class": [
            "string get_parent_class([mixed object])",
            "Retrieves the parent class name for object or class or current scope."
        ],
        "get_resource_type": [
            "string get_resource_type(resource res)",
            "Get the resource type name for a given resource"
        ],
        "getallheaders": [
            "array getallheaders()",
            ""
        ],
        "getcwd": [
            "mixed getcwd()",
            "Gets the current directory"
        ],
        "getdate": [
            "array getdate([int timestamp])",
            "Get date/time information"
        ],
        "getenv": [
            "string getenv(string varname)",
            "Get the value of an environment variable"
        ],
        "gethostbyaddr": [
            "string gethostbyaddr(string ip_address)",
            "Get the Internet host name corresponding to a given IP address"
        ],
        "gethostbyname": [
            "string gethostbyname(string hostname)",
            "Get the IP address corresponding to a given Internet host name"
        ],
        "gethostbynamel": [
            "array gethostbynamel(string hostname)",
            "Return a list of IP addresses that a given hostname resolves to."
        ],
        "gethostname": [
            "string gethostname()",
            "Get the host name of the current machine"
        ],
        "getimagesize": [
            "array getimagesize(string imagefile [, array info])",
            "Get the size of an image as 4-element array"
        ],
        "getlastmod": [
            "int getlastmod()",
            "Get time of last page modification"
        ],
        "getmygid": [
            "int getmygid()",
            "Get PHP script owner's GID"
        ],
        "getmyinode": [
            "int getmyinode()",
            "Get the inode of the current script being parsed"
        ],
        "getmypid": [
            "int getmypid()",
            "Get current process ID"
        ],
        "getmyuid": [
            "int getmyuid()",
            "Get PHP script owner's UID"
        ],
        "getopt": [
            "array getopt(string options [, array longopts])",
            "Get options from the command line argument list"
        ],
        "getprotobyname": [
            "int getprotobyname(string name)",
            "Returns protocol number associated with name as per /etc/protocols"
        ],
        "getprotobynumber": [
            "string getprotobynumber(int proto)",
            "Returns protocol name associated with protocol number proto"
        ],
        "getrandmax": [
            "int getrandmax()",
            "Returns the maximum value a random number can have"
        ],
        "getrusage": [
            "array getrusage([int who])",
            "Returns an array of usage statistics"
        ],
        "getservbyname": [
            "int getservbyname(string service, string protocol)",
            'Returns port associated with service. Protocol must be "tcp" or "udp"'
        ],
        "getservbyport": [
            "string getservbyport(int port, string protocol)",
            'Returns service name associated with port. Protocol must be "tcp" or "udp"'
        ],
        "gettext": [
            "string gettext(string msgid)",
            "Return the translation of msgid for the current domain, or msgid unaltered if a translation does not exist"
        ],
        "gettimeofday": [
            "array gettimeofday([bool get_as_float])",
            "Returns the current time as array"
        ],
        "gettype": [
            "string gettype(mixed var)",
            "Returns the type of the variable"
        ],
        "glob": [
            "array glob(string pattern [, int flags])",
            "Find pathnames matching a pattern"
        ],
        "gmdate": [
            "string gmdate(string format [, long timestamp])",
            "Format a GMT date/time"
        ],
        "gmmktime": [
            "int gmmktime([int hour [, int min [, int sec [, int mon [, int day [, int year]]]]]])",
            "Get UNIX timestamp for a GMT date"
        ],
        "gmp_abs": [
            "resource gmp_abs(resource a)",
            "Calculates absolute value"
        ],
        "gmp_add": [
            "resource gmp_add(resource a, resource b)",
            "Add a and b"
        ],
        "gmp_and": [
            "resource gmp_and(resource a, resource b)",
            "Calculates logical AND of a and b"
        ],
        "gmp_clrbit": [
            "void gmp_clrbit(resource &a, int index)",
            "Clears bit in a"
        ],
        "gmp_cmp": [
            "int gmp_cmp(resource a, resource b)",
            "Compares two numbers"
        ],
        "gmp_com": [
            "resource gmp_com(resource a)",
            "Calculates one's complement of a"
        ],
        "gmp_div_q": [
            "resource gmp_div_q(resource a, resource b [, int round])",
            "Divide a by b, returns quotient only"
        ],
        "gmp_div_qr": [
            "array gmp_div_qr(resource a, resource b [, int round])",
            "Divide a by b, returns quotient and reminder"
        ],
        "gmp_div_r": [
            "resource gmp_div_r(resource a, resource b [, int round])",
            "Divide a by b, returns reminder only"
        ],
        "gmp_divexact": [
            "resource gmp_divexact(resource a, resource b)",
            "Divide a by b using exact division algorithm"
        ],
        "gmp_fact": [
            "resource gmp_fact(int a)",
            "Calculates factorial function"
        ],
        "gmp_gcd": [
            "resource gmp_gcd(resource a, resource b)",
            "Computes greatest common denominator (gcd) of a and b"
        ],
        "gmp_gcdext": [
            "array gmp_gcdext(resource a, resource b)",
            "Computes G, S, and T, such that AS + BT = G = `gcd' (A, B)"
        ],
        "gmp_hamdist": [
            "int gmp_hamdist(resource a, resource b)",
            "Calculates hamming distance between a and b"
        ],
        "gmp_init": [
            "resource gmp_init(mixed number [, int base])",
            "Initializes GMP number"
        ],
        "gmp_intval": [
            "int gmp_intval(resource gmpnumber)",
            "Gets signed long value of GMP number"
        ],
        "gmp_invert": [
            "resource gmp_invert(resource a, resource b)",
            "Computes the inverse of a modulo b"
        ],
        "gmp_jacobi": [
            "int gmp_jacobi(resource a, resource b)",
            "Computes Jacobi symbol"
        ],
        "gmp_legendre": [
            "int gmp_legendre(resource a, resource b)",
            "Computes Legendre symbol"
        ],
        "gmp_mod": [
            "resource gmp_mod(resource a, resource b)",
            "Computes a modulo b"
        ],
        "gmp_mul": [
            "resource gmp_mul(resource a, resource b)",
            "Multiply a and b"
        ],
        "gmp_neg": [
            "resource gmp_neg(resource a)",
            "Negates a number"
        ],
        "gmp_nextprime": [
            "resource gmp_nextprime(resource a)",
            "Finds next prime of a"
        ],
        "gmp_or": [
            "resource gmp_or(resource a, resource b)",
            "Calculates logical OR of a and b"
        ],
        "gmp_perfect_square": [
            "bool gmp_perfect_square(resource a)",
            "Checks if a is an exact square"
        ],
        "gmp_popcount": [
            "int gmp_popcount(resource a)",
            "Calculates the population count of a"
        ],
        "gmp_pow": [
            "resource gmp_pow(resource base, int exp)",
            "Raise base to power exp"
        ],
        "gmp_powm": [
            "resource gmp_powm(resource base, resource exp, resource mod)",
            "Raise base to power exp and take result modulo mod"
        ],
        "gmp_prob_prime": [
            "int gmp_prob_prime(resource a[, int reps])",
            'Checks if a is "probably prime"'
        ],
        "gmp_random": [
            "resource gmp_random([int limiter])",
            "Gets random number"
        ],
        "gmp_scan0": [
            "int gmp_scan0(resource a, int start)",
            "Finds first zero bit"
        ],
        "gmp_scan1": [
            "int gmp_scan1(resource a, int start)",
            "Finds first non-zero bit"
        ],
        "gmp_setbit": [
            "void gmp_setbit(resource &a, int index[, bool set_clear])",
            "Sets or clear bit in a"
        ],
        "gmp_sign": [
            "int gmp_sign(resource a)",
            "Gets the sign of the number"
        ],
        "gmp_sqrt": [
            "resource gmp_sqrt(resource a)",
            "Takes integer part of square root of a"
        ],
        "gmp_sqrtrem": [
            "array gmp_sqrtrem(resource a)",
            "Square root with remainder"
        ],
        "gmp_strval": [
            "string gmp_strval(resource gmpnumber [, int base])",
            "Gets string representation of GMP number"
        ],
        "gmp_sub": [
            "resource gmp_sub(resource a, resource b)",
            "Subtract b from a"
        ],
        "gmp_testbit": [
            "bool gmp_testbit(resource a, int index)",
            "Tests if bit is set in a"
        ],
        "gmp_xor": [
            "resource gmp_xor(resource a, resource b)",
            "Calculates logical exclusive OR of a and b"
        ],
        "gmstrftime": [
            "string gmstrftime(string format [, int timestamp])",
            "Format a GMT/UCT time/date according to locale settings"
        ],
        "grapheme_extract": [
            "string grapheme_extract(string str, int size[, int extract_type[, int start[, int next]]])",
            "Function to extract a sequence of default grapheme clusters"
        ],
        "grapheme_stripos": [
            "int grapheme_stripos(string haystack, string needle [, int offset ])",
            "Find position of first occurrence of a string within another, ignoring case differences"
        ],
        "grapheme_stristr": [
            "string grapheme_stristr(string haystack, string needle[, bool part])",
            "Finds first occurrence of a string within another"
        ],
        "grapheme_strlen": [
            "int grapheme_strlen(string str)",
            "Get number of graphemes in a string"
        ],
        "grapheme_strpos": [
            "int grapheme_strpos(string haystack, string needle [, int offset ])",
            "Find position of first occurrence of a string within another"
        ],
        "grapheme_strripos": [
            "int grapheme_strripos(string haystack, string needle [, int offset])",
            "Find position of last occurrence of a string within another, ignoring case"
        ],
        "grapheme_strrpos": [
            "int grapheme_strrpos(string haystack, string needle [, int offset])",
            "Find position of last occurrence of a string within another"
        ],
        "grapheme_strstr": [
            "string grapheme_strstr(string haystack, string needle[, bool part])",
            "Finds first occurrence of a string within another"
        ],
        "grapheme_substr": [
            "string grapheme_substr(string str, int start [, int length])",
            "Returns part of a string"
        ],
        "gregoriantojd": [
            "int gregoriantojd(int month, int day, int year)",
            "Converts a gregorian calendar date to julian day count"
        ],
        "gzcompress": [
            "string gzcompress(string data [, int level])",
            "Gzip-compress a string"
        ],
        "gzdeflate": [
            "string gzdeflate(string data [, int level])",
            "Gzip-compress a string"
        ],
        "gzencode": [
            "string gzencode(string data [, int level [, int encoding_mode]])",
            "GZ encode a string"
        ],
        "gzfile": [
            "array gzfile(string filename [, int use_include_path])",
            "Read und uncompress entire .gz-file into an array"
        ],
        "gzinflate": [
            "string gzinflate(string data [, int length])",
            "Unzip a gzip-compressed string"
        ],
        "gzopen": [
            "resource gzopen(string filename, string mode [, int use_include_path])",
            "Open a .gz-file and return a .gz-file pointer"
        ],
        "gzuncompress": [
            "string gzuncompress(string data [, int length])",
            "Unzip a gzip-compressed string"
        ],
        "hash": [
            "string hash(string algo, string data[, bool raw_output = false])",
            "Generate a hash of a given input string Returns lowercase hexits by default"
        ],
        "hash_algos": [
            "array hash_algos()",
            "Return a list of registered hashing algorithms"
        ],
        "hash_copy": [
            "resource hash_copy(resource context)",
            "Copy hash resource"
        ],
        "hash_file": [
            "string hash_file(string algo, string filename[, bool raw_output = false])",
            "Generate a hash of a given file Returns lowercase hexits by default"
        ],
        "hash_final": [
            "string hash_final(resource context[, bool raw_output=false])",
            "Output resulting digest"
        ],
        "hash_hmac": [
            "string hash_hmac(string algo, string data, string key[, bool raw_output = false])",
            "Generate a hash of a given input string with a key using HMAC Returns lowercase hexits by default"
        ],
        "hash_hmac_file": [
            "string hash_hmac_file(string algo, string filename, string key[, bool raw_output = false])",
            "Generate a hash of a given file with a key using HMAC Returns lowercase hexits by default"
        ],
        "hash_init": [
            "resource hash_init(string algo[, int options, string key])",
            "Initialize a hashing context"
        ],
        "hash_update": [
            "bool hash_update(resource context, string data)",
            "Pump data into the hashing algorithm"
        ],
        "hash_update_file": [
            "bool hash_update_file(resource context, string filename[, resource context])",
            "Pump data into the hashing algorithm from a file"
        ],
        "hash_update_stream": [
            "int hash_update_stream(resource context, resource handle[, integer length])",
            "Pump data into the hashing algorithm from an open stream"
        ],
        "header": [
            "void header(string header [, bool replace, [int http_response_code]])",
            "Sends a raw HTTP header"
        ],
        "header_remove": [
            "void header_remove([string name])",
            "Removes an HTTP header previously set using header()"
        ],
        "headers_list": [
            "array headers_list()",
            "Return list of headers to be sent / already sent"
        ],
        "headers_sent": [
            "bool headers_sent([string &$file [, int &$line]])",
            "Returns true if headers have already been sent, false otherwise"
        ],
        "hebrev": [
            "string hebrev(string str [, int max_chars_per_line])",
            "Converts logical Hebrew text to visual text"
        ],
        "hebrevc": [
            "string hebrevc(string str [, int max_chars_per_line])",
            "Converts logical Hebrew text to visual text with newline conversion"
        ],
        "hexdec": [
            "int hexdec(string hexadecimal_number)",
            "Returns the decimal equivalent of the hexadecimal number"
        ],
        "highlight_file": [
            "bool highlight_file(string file_name [, bool return] )",
            "Syntax highlight a source file"
        ],
        "highlight_string": [
            "bool highlight_string(string string [, bool return] )",
            "Syntax highlight a string or optionally return it"
        ],
        "html_entity_decode": [
            "string html_entity_decode(string string [, int quote_style][, string charset])",
            "Convert all HTML entities to their applicable characters"
        ],
        "htmlentities": [
            "string htmlentities(string string [, int quote_style[, string charset[, bool double_encode]]])",
            "Convert all applicable characters to HTML entities"
        ],
        "htmlspecialchars": [
            "string htmlspecialchars(string string [, int quote_style[, string charset[, bool double_encode]]])",
            "Convert special characters to HTML entities"
        ],
        "htmlspecialchars_decode": [
            "string htmlspecialchars_decode(string string [, int quote_style])",
            "Convert special HTML entities back to characters"
        ],
        "http_build_query": [
            "string http_build_query(mixed formdata [, string prefix [, string arg_separator]])",
            "Generates a form-encoded query string from an associative array or object."
        ],
        "hypot": [
            "float hypot(float num1, float num2)",
            "Returns sqrt(num1*num1 + num2*num2)"
        ],
        "ibase_add_user": [
            "bool ibase_add_user(resource service_handle, string user_name, string password [, string first_name [, string middle_name [, string last_name]]])",
            "Add a user to security database"
        ],
        "ibase_affected_rows": [
            "int ibase_affected_rows( [ resource link_identifier ] )",
            "Returns the number of rows affected by the previous INSERT, UPDATE or DELETE statement"
        ],
        "ibase_backup": [
            "mixed ibase_backup(resource service_handle, string source_db, string dest_file [, int options [, bool verbose]])",
            "Initiates a backup task in the service manager and returns immediately"
        ],
        "ibase_blob_add": [
            "bool ibase_blob_add(resource blob_handle, string data)",
            "Add data into created blob"
        ],
        "ibase_blob_cancel": [
            "bool ibase_blob_cancel(resource blob_handle)",
            "Cancel creating blob"
        ],
        "ibase_blob_close": [
            "string ibase_blob_close(resource blob_handle)",
            "Close blob"
        ],
        "ibase_blob_create": [
            "resource ibase_blob_create([resource link_identifier])",
            "Create blob for adding data"
        ],
        "ibase_blob_echo": [
            "bool ibase_blob_echo([ resource link_identifier, ] string blob_id)",
            "Output blob contents to browser"
        ],
        "ibase_blob_get": [
            "string ibase_blob_get(resource blob_handle, int len)",
            "Get len bytes data from open blob"
        ],
        "ibase_blob_import": [
            "string ibase_blob_import([ resource link_identifier, ] resource file)",
            "Create blob, copy file in it, and close it"
        ],
        "ibase_blob_info": [
            "array ibase_blob_info([ resource link_identifier, ] string blob_id)",
            "Return blob length and other useful info"
        ],
        "ibase_blob_open": [
            "resource ibase_blob_open([ resource link_identifier, ] string blob_id)",
            "Open blob for retrieving data parts"
        ],
        "ibase_close": [
            "bool ibase_close([resource link_identifier])",
            "Close an InterBase connection"
        ],
        "ibase_commit": [
            "bool ibase_commit( resource link_identifier )",
            "Commit transaction"
        ],
        "ibase_commit_ret": [
            "bool ibase_commit_ret( resource link_identifier )",
            "Commit transaction and retain the transaction context"
        ],
        "ibase_connect": [
            "resource ibase_connect(string database [, string username [, string password [, string charset [, int buffers [, int dialect [, string role]]]]]])",
            "Open a connection to an InterBase database"
        ],
        "ibase_db_info": [
            "string ibase_db_info(resource service_handle, string db, int action [, int argument])",
            "Request statistics about a database"
        ],
        "ibase_delete_user": [
            "bool ibase_delete_user(resource service_handle, string user_name, string password [, string first_name [, string middle_name [, string last_name]]])",
            "Delete a user from security database"
        ],
        "ibase_drop_db": [
            "bool ibase_drop_db([resource link_identifier])",
            "Drop an InterBase database"
        ],
        "ibase_errcode": [
            "int ibase_errcode()",
            "Return error code"
        ],
        "ibase_errmsg": [
            "string ibase_errmsg()",
            "Return error message"
        ],
        "ibase_execute": [
            "mixed ibase_execute(resource query [, mixed bind_arg [, mixed bind_arg [, ...]]])",
            "Execute a previously prepared query"
        ],
        "ibase_fetch_assoc": [
            "array ibase_fetch_assoc(resource result [, int fetch_flags])",
            "Fetch a row  from the results of a query"
        ],
        "ibase_fetch_object": [
            "object ibase_fetch_object(resource result [, int fetch_flags])",
            "Fetch a object from the results of a query"
        ],
        "ibase_fetch_row": [
            "array ibase_fetch_row(resource result [, int fetch_flags])",
            "Fetch a row  from the results of a query"
        ],
        "ibase_field_info": [
            "array ibase_field_info(resource query_result, int field_number)",
            "Get information about a field"
        ],
        "ibase_free_event_handler": [
            "bool ibase_free_event_handler(resource event)",
            "Frees the event handler set by ibase_set_event_handler()"
        ],
        "ibase_free_query": [
            "bool ibase_free_query(resource query)",
            "Free memory used by a query"
        ],
        "ibase_free_result": [
            "bool ibase_free_result(resource result)",
            "Free the memory used by a result"
        ],
        "ibase_gen_id": [
            "int ibase_gen_id(string generator [, int increment [, resource link_identifier ]])",
            "Increments the named generator and returns its new value"
        ],
        "ibase_maintain_db": [
            "bool ibase_maintain_db(resource service_handle, string db, int action [, int argument])",
            "Execute a maintenance command on the database server"
        ],
        "ibase_modify_user": [
            "bool ibase_modify_user(resource service_handle, string user_name, string password [, string first_name [, string middle_name [, string last_name]]])",
            "Modify a user in security database"
        ],
        "ibase_name_result": [
            "bool ibase_name_result(resource result, string name)",
            "Assign a name to a result for use with ... WHERE CURRENT OF <name> statements"
        ],
        "ibase_num_fields": [
            "int ibase_num_fields(resource query_result)",
            "Get the number of fields in result"
        ],
        "ibase_num_params": [
            "int ibase_num_params(resource query)",
            "Get the number of params in a prepared query"
        ],
        "ibase_num_rows": [
            "int ibase_num_rows( resource result_identifier )",
            "Return the number of rows that are available in a result"
        ],
        "ibase_param_info": [
            "array ibase_param_info(resource query, int field_number)",
            "Get information about a parameter"
        ],
        "ibase_pconnect": [
            "resource ibase_pconnect(string database [, string username [, string password [, string charset [, int buffers [, int dialect [, string role]]]]]])",
            "Open a persistent connection to an InterBase database"
        ],
        "ibase_prepare": [
            "resource ibase_prepare(resource link_identifier[, string query [, resource trans_identifier ]])",
            "Prepare a query for later execution"
        ],
        "ibase_query": [
            "mixed ibase_query([resource link_identifier, [ resource link_identifier, ]] string query [, mixed bind_arg [, mixed bind_arg [, ...]]])",
            "Execute a query"
        ],
        "ibase_restore": [
            "mixed ibase_restore(resource service_handle, string source_file, string dest_db [, int options [, bool verbose]])",
            "Initiates a restore task in the service manager and returns immediately"
        ],
        "ibase_rollback": [
            "bool ibase_rollback( resource link_identifier )",
            "Rollback transaction"
        ],
        "ibase_rollback_ret": [
            "bool ibase_rollback_ret( resource link_identifier )",
            "Rollback transaction and retain the transaction context"
        ],
        "ibase_server_info": [
            "string ibase_server_info(resource service_handle, int action)",
            "Request information about a database server"
        ],
        "ibase_service_attach": [
            "resource ibase_service_attach(string host, string dba_username, string dba_password)",
            "Connect to the service manager"
        ],
        "ibase_service_detach": [
            "bool ibase_service_detach(resource service_handle)",
            "Disconnect from the service manager"
        ],
        "ibase_set_event_handler": [
            "resource ibase_set_event_handler([resource link_identifier,] callback handler, string event [, string event [, ...]])",
            "Register the callback for handling each of the named events"
        ],
        "ibase_trans": [
            "resource ibase_trans([int trans_args [, resource link_identifier [, ... ], int trans_args [, resource link_identifier [, ... ]] [, ...]]])",
            "Start a transaction over one or several databases"
        ],
        "ibase_wait_event": [
            "string ibase_wait_event([resource link_identifier,] string event [, string event [, ...]])",
            "Waits for any one of the passed Interbase events to be posted by the database, and returns its name"
        ],
        "iconv": [
            "string iconv(string in_charset, string out_charset, string str)",
            "Returns str converted to the out_charset character set"
        ],
        "iconv_get_encoding": [
            "mixed iconv_get_encoding([string type])",
            "Get internal encoding and output encoding for ob_iconv_handler()"
        ],
        "iconv_mime_decode": [
            "string iconv_mime_decode(string encoded_string [, int mode, string charset])",
            "Decodes a mime header field"
        ],
        "iconv_mime_decode_headers": [
            "array iconv_mime_decode_headers(string headers [, int mode, string charset])",
            "Decodes multiple mime header fields"
        ],
        "iconv_mime_encode": [
            "string iconv_mime_encode(string field_name, string field_value [, array preference])",
            "Composes a mime header field with field_name and field_value in a specified scheme"
        ],
        "iconv_set_encoding": [
            "bool iconv_set_encoding(string type, string charset)",
            "Sets internal encoding and output encoding for ob_iconv_handler()"
        ],
        "iconv_strlen": [
            "int iconv_strlen(string str [, string charset])",
            "Returns the character count of str"
        ],
        "iconv_strpos": [
            "int iconv_strpos(string haystack, string needle [, int offset [, string charset]])",
            "Finds position of first occurrence of needle within part of haystack beginning with offset"
        ],
        "iconv_strrpos": [
            "int iconv_strrpos(string haystack, string needle [, string charset])",
            "Finds position of last occurrence of needle within part of haystack beginning with offset"
        ],
        "iconv_substr": [
            "string iconv_substr(string str, int offset, [int length, string charset])",
            "Returns specified part of a string"
        ],
        "idate": [
            "int idate(string format [, int timestamp])",
            "Format a local time/date as integer"
        ],
        "idn_to_ascii": [
            "int idn_to_ascii(string domain[, int options])",
            "Converts an Unicode domain to ASCII representation, as defined in the IDNA RFC"
        ],
        "idn_to_utf8": [
            "int idn_to_utf8(string domain[, int options])",
            "Converts an ASCII representation of the domain to Unicode (UTF-8), as defined in the IDNA RFC"
        ],
        "ignore_user_abort": [
            "int ignore_user_abort([string value])",
            "Set whether we want to ignore a user abort event or not"
        ],
        "image2wbmp": [
            "bool image2wbmp(resource im [, string filename [, int threshold]])",
            "Output WBMP image to browser or file"
        ],
        "image_type_to_extension": [
            "string image_type_to_extension(int imagetype [, bool include_dot])",
            "Get file extension for image-type returned by getimagesize, exif_read_data, exif_thumbnail, exif_imagetype"
        ],
        "image_type_to_mime_type": [
            "string image_type_to_mime_type(int imagetype)",
            "Get Mime-Type for image-type returned by getimagesize, exif_read_data, exif_thumbnail, exif_imagetype"
        ],
        "imagealphablending": [
            "bool imagealphablending(resource im, bool on)",
            "Turn alpha blending mode on or off for the given image"
        ],
        "imageantialias": [
            "bool imageantialias(resource im, bool on)",
            "Should antialiased functions used or not"
        ],
        "imagearc": [
            "bool imagearc(resource im, int cx, int cy, int w, int h, int s, int e, int col)",
            "Draw a partial ellipse"
        ],
        "imagechar": [
            "bool imagechar(resource im, int font, int x, int y, string c, int col)",
            "Draw a character"
        ],
        "imagecharup": [
            "bool imagecharup(resource im, int font, int x, int y, string c, int col)",
            "Draw a character rotated 90 degrees counter-clockwise"
        ],
        "imagecolorallocate": [
            "int imagecolorallocate(resource im, int red, int green, int blue)",
            "Allocate a color for an image"
        ],
        "imagecolorallocatealpha": [
            "int imagecolorallocatealpha(resource im, int red, int green, int blue, int alpha)",
            "Allocate a color with an alpha level.  Works for true color and palette based images"
        ],
        "imagecolorat": [
            "int imagecolorat(resource im, int x, int y)",
            "Get the index of the color of a pixel"
        ],
        "imagecolorclosest": [
            "int imagecolorclosest(resource im, int red, int green, int blue)",
            "Get the index of the closest color to the specified color"
        ],
        "imagecolorclosestalpha": [
            "int imagecolorclosestalpha(resource im, int red, int green, int blue, int alpha)",
            "Find the closest matching colour with alpha transparency"
        ],
        "imagecolorclosesthwb": [
            "int imagecolorclosesthwb(resource im, int red, int green, int blue)",
            "Get the index of the color which has the hue, white and blackness nearest to the given color"
        ],
        "imagecolordeallocate": [
            "bool imagecolordeallocate(resource im, int index)",
            "De-allocate a color for an image"
        ],
        "imagecolorexact": [
            "int imagecolorexact(resource im, int red, int green, int blue)",
            "Get the index of the specified color"
        ],
        "imagecolorexactalpha": [
            "int imagecolorexactalpha(resource im, int red, int green, int blue, int alpha)",
            "Find exact match for colour with transparency"
        ],
        "imagecolormatch": [
            "bool imagecolormatch(resource im1, resource im2)",
            "Makes the colors of the palette version of an image more closely match the true color version"
        ],
        "imagecolorresolve": [
            "int imagecolorresolve(resource im, int red, int green, int blue)",
            "Get the index of the specified color or its closest possible alternative"
        ],
        "imagecolorresolvealpha": [
            "int imagecolorresolvealpha(resource im, int red, int green, int blue, int alpha)",
            "Resolve/Allocate a colour with an alpha level.  Works for true colour and palette based images"
        ],
        "imagecolorset": [
            "void imagecolorset(resource im, int col, int red, int green, int blue)",
            "Set the color for the specified palette index"
        ],
        "imagecolorsforindex": [
            "array imagecolorsforindex(resource im, int col)",
            "Get the colors for an index"
        ],
        "imagecolorstotal": [
            "int imagecolorstotal(resource im)",
            "Find out the number of colors in an image's palette"
        ],
        "imagecolortransparent": [
            "int imagecolortransparent(resource im [, int col])",
            "Define a color as transparent"
        ],
        "imageconvolution": [
            "resource imageconvolution(resource src_im, array matrix3x3, double div, double offset)",
            "Apply a 3x3 convolution matrix, using coefficient div and offset"
        ],
        "imagecopy": [
            "bool imagecopy(resource dst_im, resource src_im, int dst_x, int dst_y, int src_x, int src_y, int src_w, int src_h)",
            "Copy part of an image"
        ],
        "imagecopymerge": [
            "bool imagecopymerge(resource src_im, resource dst_im, int dst_x, int dst_y, int src_x, int src_y, int src_w, int src_h, int pct)",
            "Merge one part of an image with another"
        ],
        "imagecopymergegray": [
            "bool imagecopymergegray(resource src_im, resource dst_im, int dst_x, int dst_y, int src_x, int src_y, int src_w, int src_h, int pct)",
            "Merge one part of an image with another"
        ],
        "imagecopyresampled": [
            "bool imagecopyresampled(resource dst_im, resource src_im, int dst_x, int dst_y, int src_x, int src_y, int dst_w, int dst_h, int src_w, int src_h)",
            "Copy and resize part of an image using resampling to help ensure clarity"
        ],
        "imagecopyresized": [
            "bool imagecopyresized(resource dst_im, resource src_im, int dst_x, int dst_y, int src_x, int src_y, int dst_w, int dst_h, int src_w, int src_h)",
            "Copy and resize part of an image"
        ],
        "imagecreate": [
            "resource imagecreate(int x_size, int y_size)",
            "Create a new image"
        ],
        "imagecreatefromgd": [
            "resource imagecreatefromgd(string filename)",
            "Create a new image from GD file or URL"
        ],
        "imagecreatefromgd2": [
            "resource imagecreatefromgd2(string filename)",
            "Create a new image from GD2 file or URL"
        ],
        "imagecreatefromgd2part": [
            "resource imagecreatefromgd2part(string filename, int srcX, int srcY, int width, int height)",
            "Create a new image from a given part of GD2 file or URL"
        ],
        "imagecreatefromgif": [
            "resource imagecreatefromgif(string filename)",
            "Create a new image from GIF file or URL"
        ],
        "imagecreatefromjpeg": [
            "resource imagecreatefromjpeg(string filename)",
            "Create a new image from JPEG file or URL"
        ],
        "imagecreatefrompng": [
            "resource imagecreatefrompng(string filename)",
            "Create a new image from PNG file or URL"
        ],
        "imagecreatefromstring": [
            "resource imagecreatefromstring(string image)",
            "Create a new image from the image stream in the string"
        ],
        "imagecreatefromwbmp": [
            "resource imagecreatefromwbmp(string filename)",
            "Create a new image from WBMP file or URL"
        ],
        "imagecreatefromxbm": [
            "resource imagecreatefromxbm(string filename)",
            "Create a new image from XBM file or URL"
        ],
        "imagecreatefromxpm": [
            "resource imagecreatefromxpm(string filename)",
            "Create a new image from XPM file or URL"
        ],
        "imagecreatetruecolor": [
            "resource imagecreatetruecolor(int x_size, int y_size)",
            "Create a new true color image"
        ],
        "imagedashedline": [
            "bool imagedashedline(resource im, int x1, int y1, int x2, int y2, int col)",
            "Draw a dashed line"
        ],
        "imagedestroy": [
            "bool imagedestroy(resource im)",
            "Destroy an image"
        ],
        "imageellipse": [
            "bool imageellipse(resource im, int cx, int cy, int w, int h, int color)",
            "Draw an ellipse"
        ],
        "imagefill": [
            "bool imagefill(resource im, int x, int y, int col)",
            "Flood fill"
        ],
        "imagefilledarc": [
            "bool imagefilledarc(resource im, int cx, int cy, int w, int h, int s, int e, int col, int style)",
            "Draw a filled partial ellipse"
        ],
        "imagefilledellipse": [
            "bool imagefilledellipse(resource im, int cx, int cy, int w, int h, int color)",
            "Draw an ellipse"
        ],
        "imagefilledpolygon": [
            "bool imagefilledpolygon(resource im, array point, int num_points, int col)",
            "Draw a filled polygon"
        ],
        "imagefilledrectangle": [
            "bool imagefilledrectangle(resource im, int x1, int y1, int x2, int y2, int col)",
            "Draw a filled rectangle"
        ],
        "imagefilltoborder": [
            "bool imagefilltoborder(resource im, int x, int y, int border, int col)",
            "Flood fill to specific color"
        ],
        "imagefilter": [
            "bool imagefilter(resource src_im, int filtertype, [args] )",
            "Applies Filter an image using a custom angle"
        ],
        "imagefontheight": [
            "int imagefontheight(int font)",
            "Get font height"
        ],
        "imagefontwidth": [
            "int imagefontwidth(int font)",
            "Get font width"
        ],
        "imageftbbox": [
            "array imageftbbox(float size, float angle, string font_file, string text [, array extrainfo])",
            "Give the bounding box of a text using fonts via freetype2"
        ],
        "imagefttext": [
            "array imagefttext(resource im, float size, float angle, int x, int y, int col, string font_file, string text [, array extrainfo])",
            "Write text to the image using fonts via freetype2"
        ],
        "imagegammacorrect": [
            "bool imagegammacorrect(resource im, float inputgamma, float outputgamma)",
            "Apply a gamma correction to a GD image"
        ],
        "imagegd": [
            "bool imagegd(resource im [, string filename])",
            "Output GD image to browser or file"
        ],
        "imagegd2": [
            "bool imagegd2(resource im [, string filename, [, int chunk_size, [, int type]]])",
            "Output GD2 image to browser or file"
        ],
        "imagegif": [
            "bool imagegif(resource im [, string filename])",
            "Output GIF image to browser or file"
        ],
        "imagegrabscreen": [
            "resource imagegrabscreen()",
            "Grab a screenshot"
        ],
        "imagegrabwindow": [
            "resource imagegrabwindow(int window_handle [, int client_area])",
            "Grab a window or its client area using a windows handle (HWND property in COM instance)"
        ],
        "imageinterlace": [
            "int imageinterlace(resource im [, int interlace])",
            "Enable or disable interlace"
        ],
        "imageistruecolor": [
            "bool imageistruecolor(resource im)",
            "return true if the image uses truecolor"
        ],
        "imagejpeg": [
            "bool imagejpeg(resource im [, string filename [, int quality]])",
            "Output JPEG image to browser or file"
        ],
        "imagelayereffect": [
            "bool imagelayereffect(resource im, int effect)",
            "Set the alpha blending flag to use the bundled libgd layering effects"
        ],
        "imageline": [
            "bool imageline(resource im, int x1, int y1, int x2, int y2, int col)",
            "Draw a line"
        ],
        "imageloadfont": [
            "int imageloadfont(string filename)",
            "Load a new font"
        ],
        "imagepalettecopy": [
            "void imagepalettecopy(resource dst, resource src)",
            "Copy the palette from the src image onto the dst image"
        ],
        "imagepng": [
            "bool imagepng(resource im [, string filename])",
            "Output PNG image to browser or file"
        ],
        "imagepolygon": [
            "bool imagepolygon(resource im, array point, int num_points, int col)",
            "Draw a polygon"
        ],
        "imagepsbbox": [
            "array imagepsbbox(string text, resource font, int size [, int space, int tightness, float angle])",
            "Return the bounding box needed by a string if rasterized"
        ],
        "imagepscopyfont": [
            "int imagepscopyfont(int font_index)",
            "Make a copy of a font for purposes like extending or reenconding"
        ],
        "imagepsencodefont": [
            "bool imagepsencodefont(resource font_index, string filename)",
            "To change a fonts character encoding vector"
        ],
        "imagepsextendfont": [
            "bool imagepsextendfont(resource font_index, float extend)",
            "Extend or or condense if (extend < 1) a font"
        ],
        "imagepsfreefont": [
            "bool imagepsfreefont(resource font_index)",
            "Free memory used by a font"
        ],
        "imagepsloadfont": [
            "resource imagepsloadfont(string pathname)",
            "Load a new font from specified file"
        ],
        "imagepsslantfont": [
            "bool imagepsslantfont(resource font_index, float slant)",
            "Slant a font"
        ],
        "imagepstext": [
            "array imagepstext(resource image, string text, resource font, int size, int foreground, int background, int xcoord, int ycoord [, int space [, int tightness [, float angle [, int antialias])",
            "Rasterize a string over an image"
        ],
        "imagerectangle": [
            "bool imagerectangle(resource im, int x1, int y1, int x2, int y2, int col)",
            "Draw a rectangle"
        ],
        "imagerotate": [
            "resource imagerotate(resource src_im, float angle, int bgdcolor [, int ignoretransparent])",
            "Rotate an image using a custom angle"
        ],
        "imagesavealpha": [
            "bool imagesavealpha(resource im, bool on)",
            "Include alpha channel to a saved image"
        ],
        "imagesetbrush": [
            "bool imagesetbrush(resource image, resource brush)",
            'Set the brush image to $brush when filling $image with the "IMG_COLOR_BRUSHED" color'
        ],
        "imagesetpixel": [
            "bool imagesetpixel(resource im, int x, int y, int col)",
            "Set a single pixel"
        ],
        "imagesetstyle": [
            "bool imagesetstyle(resource im, array styles)",
            "Set the line drawing styles for use with imageline and IMG_COLOR_STYLED."
        ],
        "imagesetthickness": [
            "bool imagesetthickness(resource im, int thickness)",
            "Set line thickness for drawing lines, ellipses, rectangles, polygons etc."
        ],
        "imagesettile": [
            "bool imagesettile(resource image, resource tile)",
            'Set the tile image to $tile when filling $image with the "IMG_COLOR_TILED" color'
        ],
        "imagestring": [
            "bool imagestring(resource im, int font, int x, int y, string str, int col)",
            "Draw a string horizontally"
        ],
        "imagestringup": [
            "bool imagestringup(resource im, int font, int x, int y, string str, int col)",
            "Draw a string vertically - rotated 90 degrees counter-clockwise"
        ],
        "imagesx": [
            "int imagesx(resource im)",
            "Get image width"
        ],
        "imagesy": [
            "int imagesy(resource im)",
            "Get image height"
        ],
        "imagetruecolortopalette": [
            "void imagetruecolortopalette(resource im, bool ditherFlag, int colorsWanted)",
            "Convert a true colour image to a palette based image with a number of colours, optionally using dithering."
        ],
        "imagettfbbox": [
            "array imagettfbbox(float size, float angle, string font_file, string text)",
            "Give the bounding box of a text using TrueType fonts"
        ],
        "imagettftext": [
            "array imagettftext(resource im, float size, float angle, int x, int y, int col, string font_file, string text)",
            "Write text to the image using a TrueType font"
        ],
        "imagetypes": [
            "int imagetypes()",
            "Return the types of images supported in a bitfield - 1=GIF, 2=JPEG, 4=PNG, 8=WBMP, 16=XPM"
        ],
        "imagewbmp": [
            "bool imagewbmp(resource im [, string filename, [, int foreground]])",
            "Output WBMP image to browser or file"
        ],
        "imagexbm": [
            "int imagexbm(int im, string filename [, int foreground])",
            "Output XBM image to browser or file"
        ],
        "imap_8bit": [
            "string imap_8bit(string text)",
            "Convert an 8-bit string to a quoted-printable string"
        ],
        "imap_alerts": [
            "array imap_alerts()",
            "Returns an array of all IMAP alerts that have been generated since the last page load or since the last imap_alerts() call, whichever came last. The alert stack is cleared after imap_alerts() is called."
        ],
        "imap_append": [
            "bool imap_append(resource stream_id, string folder, string message [, string options [, string internal_date]])",
            "Append a new message to a specified mailbox"
        ],
        "imap_base64": [
            "string imap_base64(string text)",
            "Decode BASE64 encoded text"
        ],
        "imap_binary": [
            "string imap_binary(string text)",
            "Convert an 8bit string to a base64 string"
        ],
        "imap_body": [
            "string imap_body(resource stream_id, int msg_no [, int options])",
            "Read the message body"
        ],
        "imap_bodystruct": [
            "object imap_bodystruct(resource stream_id, int msg_no, string section)",
            "Read the structure of a specified body section of a specific message"
        ],
        "imap_check": [
            "object imap_check(resource stream_id)",
            "Get mailbox properties"
        ],
        "imap_clearflag_full": [
            "bool imap_clearflag_full(resource stream_id, string sequence, string flag [, int options])",
            "Clears flags on messages"
        ],
        "imap_close": [
            "bool imap_close(resource stream_id [, int options])",
            "Close an IMAP stream"
        ],
        "imap_createmailbox": [
            "bool imap_createmailbox(resource stream_id, string mailbox)",
            "Create a new mailbox"
        ],
        "imap_delete": [
            "bool imap_delete(resource stream_id, int msg_no [, int options])",
            "Mark a message for deletion"
        ],
        "imap_deletemailbox": [
            "bool imap_deletemailbox(resource stream_id, string mailbox)",
            "Delete a mailbox"
        ],
        "imap_errors": [
            "array imap_errors()",
            "Returns an array of all IMAP errors generated since the last page load, or since the last imap_errors() call, whichever came last. The error stack is cleared after imap_errors() is called."
        ],
        "imap_expunge": [
            "bool imap_expunge(resource stream_id)",
            "Permanently delete all messages marked for deletion"
        ],
        "imap_fetch_overview": [
            "array imap_fetch_overview(resource stream_id, string sequence [, int options])",
            "Read an overview of the information in the headers of the given message sequence"
        ],
        "imap_fetchbody": [
            "string imap_fetchbody(resource stream_id, int msg_no, string section [, int options])",
            "Get a specific body section"
        ],
        "imap_fetchheader": [
            "string imap_fetchheader(resource stream_id, int msg_no [, int options])",
            "Get the full unfiltered header for a message"
        ],
        "imap_fetchstructure": [
            "object imap_fetchstructure(resource stream_id, int msg_no [, int options])",
            "Read the full structure of a message"
        ],
        "imap_gc": [
            "bool imap_gc(resource stream_id, int flags)",
            "This function garbage collects (purges) the cache of entries of a specific type."
        ],
        "imap_get_quota": [
            "array imap_get_quota(resource stream_id, string qroot)",
            "Returns the quota set to the mailbox account qroot"
        ],
        "imap_get_quotaroot": [
            "array imap_get_quotaroot(resource stream_id, string mbox)",
            "Returns the quota set to the mailbox account mbox"
        ],
        "imap_getacl": [
            "array imap_getacl(resource stream_id, string mailbox)",
            "Gets the ACL for a given mailbox"
        ],
        "imap_getmailboxes": [
            "array imap_getmailboxes(resource stream_id, string ref, string pattern)",
            "Reads the list of mailboxes and returns a full array of objects containing name, attributes, and delimiter"
        ],
        "imap_getsubscribed": [
            "array imap_getsubscribed(resource stream_id, string ref, string pattern)",
            "Return a list of subscribed mailboxes, in the same format as imap_getmailboxes()"
        ],
        "imap_headerinfo": [
            "object imap_headerinfo(resource stream_id, int msg_no [, int from_length [, int subject_length [, string default_host]]])",
            "Read the headers of the message"
        ],
        "imap_headers": [
            "array imap_headers(resource stream_id)",
            "Returns headers for all messages in a mailbox"
        ],
        "imap_last_error": [
            "string imap_last_error()",
            "Returns the last error that was generated by an IMAP function. The error stack is NOT cleared after this call."
        ],
        "imap_list": [
            "array imap_list(resource stream_id, string ref, string pattern)",
            "Read the list of mailboxes"
        ],
        "imap_listscan": [
            "array imap_listscan(resource stream_id, string ref, string pattern, string content)",
            "Read list of mailboxes containing a certain string"
        ],
        "imap_lsub": [
            "array imap_lsub(resource stream_id, string ref, string pattern)",
            "Return a list of subscribed mailboxes"
        ],
        "imap_mail": [
            "bool imap_mail(string to, string subject, string message [, string additional_headers [, string cc [, string bcc [, string rpath]]]])",
            "Send an email message"
        ],
        "imap_mail_compose": [
            "string imap_mail_compose(array envelope, array body)",
            "Create a MIME message based on given envelope and body sections"
        ],
        "imap_mail_copy": [
            "bool imap_mail_copy(resource stream_id, string msglist, string mailbox [, int options])",
            "Copy specified message to a mailbox"
        ],
        "imap_mail_move": [
            "bool imap_mail_move(resource stream_id, string sequence, string mailbox [, int options])",
            "Move specified message to a mailbox"
        ],
        "imap_mailboxmsginfo": [
            "object imap_mailboxmsginfo(resource stream_id)",
            "Returns info about the current mailbox"
        ],
        "imap_mime_header_decode": [
            "array imap_mime_header_decode(string str)",
            "Decode mime header element in accordance with RFC 2047 and return array of objects containing 'charset' encoding and decoded 'text'"
        ],
        "imap_msgno": [
            "int imap_msgno(resource stream_id, int unique_msg_id)",
            "Get the sequence number associated with a UID"
        ],
        "imap_mutf7_to_utf8": [
            "string imap_mutf7_to_utf8(string in)",
            "Decode a modified UTF-7 string to UTF-8"
        ],
        "imap_num_msg": [
            "int imap_num_msg(resource stream_id)",
            "Gives the number of messages in the current mailbox"
        ],
        "imap_num_recent": [
            "int imap_num_recent(resource stream_id)",
            "Gives the number of recent messages in current mailbox"
        ],
        "imap_open": [
            "resource imap_open(string mailbox, string user, string password [, int options [, int n_retries]])",
            "Open an IMAP stream to a mailbox"
        ],
        "imap_ping": [
            "bool imap_ping(resource stream_id)",
            "Check if the IMAP stream is still active"
        ],
        "imap_qprint": [
            "string imap_qprint(string text)",
            "Convert a quoted-printable string to an 8-bit string"
        ],
        "imap_renamemailbox": [
            "bool imap_renamemailbox(resource stream_id, string old_name, string new_name)",
            "Rename a mailbox"
        ],
        "imap_reopen": [
            "bool imap_reopen(resource stream_id, string mailbox [, int options [, int n_retries]])",
            "Reopen an IMAP stream to a new mailbox"
        ],
        "imap_rfc822_parse_adrlist": [
            "array imap_rfc822_parse_adrlist(string address_string, string default_host)",
            "Parses an address string"
        ],
        "imap_rfc822_parse_headers": [
            "object imap_rfc822_parse_headers(string headers [, string default_host])",
            "Parse a set of mail headers contained in a string, and return an object similar to imap_headerinfo()"
        ],
        "imap_rfc822_write_address": [
            "string imap_rfc822_write_address(string mailbox, string host, string personal)",
            "Returns a properly formatted email address given the mailbox, host, and personal info"
        ],
        "imap_savebody": [
            'bool imap_savebody(resource stream_id, string|resource file, int msg_no[, string section = ""[, int options = 0]])',
            "Save a specific body section to a file"
        ],
        "imap_search": [
            "array imap_search(resource stream_id, string criteria [, int options [, string charset]])",
            "Return a list of messages matching the given criteria"
        ],
        "imap_set_quota": [
            "bool imap_set_quota(resource stream_id, string qroot, int mailbox_size)",
            "Will set the quota for qroot mailbox"
        ],
        "imap_setacl": [
            "bool imap_setacl(resource stream_id, string mailbox, string id, string rights)",
            "Sets the ACL for a given mailbox"
        ],
        "imap_setflag_full": [
            "bool imap_setflag_full(resource stream_id, string sequence, string flag [, int options])",
            "Sets flags on messages"
        ],
        "imap_sort": [
            "array imap_sort(resource stream_id, int criteria, int reverse [, int options [, string search_criteria [, string charset]]])",
            "Sort an array of message headers, optionally including only messages that meet specified criteria."
        ],
        "imap_status": [
            "object imap_status(resource stream_id, string mailbox, int options)",
            "Get status info from a mailbox"
        ],
        "imap_subscribe": [
            "bool imap_subscribe(resource stream_id, string mailbox)",
            "Subscribe to a mailbox"
        ],
        "imap_thread": [
            "array imap_thread(resource stream_id [, int options])",
            "Return threaded by REFERENCES tree"
        ],
        "imap_timeout": [
            "mixed imap_timeout(int timeout_type [, int timeout])",
            "Set or fetch imap timeout"
        ],
        "imap_uid": [
            "int imap_uid(resource stream_id, int msg_no)",
            "Get the unique message id associated with a standard sequential message number"
        ],
        "imap_undelete": [
            "bool imap_undelete(resource stream_id, int msg_no [, int flags])",
            "Remove the delete flag from a message"
        ],
        "imap_unsubscribe": [
            "bool imap_unsubscribe(resource stream_id, string mailbox)",
            "Unsubscribe from a mailbox"
        ],
        "imap_utf7_decode": [
            "string imap_utf7_decode(string buf)",
            "Decode a modified UTF-7 string"
        ],
        "imap_utf7_encode": [
            "string imap_utf7_encode(string buf)",
            "Encode a string in modified UTF-7"
        ],
        "imap_utf8": [
            "string imap_utf8(string mime_encoded_text)",
            "Convert a mime-encoded text to UTF-8"
        ],
        "imap_utf8_to_mutf7": [
            "string imap_utf8_to_mutf7(string in)",
            "Encode a UTF-8 string to modified UTF-7"
        ],
        "implode": [
            "string implode([string glue,] array pieces)",
            "Joins array elements placing glue string between items and return one string"
        ],
        "import_request_variables": [
            "bool import_request_variables(string types [, string prefix])",
            "Import GET/POST/Cookie variables into the global scope"
        ],
        "in_array": [
            "bool in_array(mixed needle, array haystack [, bool strict])",
            "Checks if the given value exists in the array"
        ],
        "include": [
            "bool include(string path)",
            "Includes and evaluates the specified file"
        ],
        "include_once": [
            "bool include_once(string path)",
            "Includes and evaluates the specified file"
        ],
        "inet_ntop": [
            "string inet_ntop(string in_addr)",
            "Converts a packed inet address to a human readable IP address string"
        ],
        "inet_pton": [
            "string inet_pton(string ip_address)",
            "Converts a human readable IP address to a packed binary string"
        ],
        "ini_get": [
            "string ini_get(string varname)",
            "Get a configuration option"
        ],
        "ini_get_all": [
            "array ini_get_all([string extension[, bool details = true]])",
            "Get all configuration options"
        ],
        "ini_restore": [
            "void ini_restore(string varname)",
            "Restore the value of a configuration option specified by varname"
        ],
        "ini_set": [
            "string ini_set(string varname, string newvalue)",
            "Set a configuration option, returns false on error and the old value of the configuration option on success"
        ],
        "interface_exists": [
            "bool interface_exists(string classname [, bool autoload])",
            "Checks if the class exists"
        ],
        "intl_error_name": [
            "string intl_error_name()",
            "* Return a string for a given error code.  * The string will be the same as the name of the error code constant."
        ],
        "intl_get_error_code": [
            "int intl_get_error_code()",
            "* Get code of the last occured error."
        ],
        "intl_get_error_message": [
            "string intl_get_error_message()",
            "* Get text description of the last occured error."
        ],
        "intl_is_failure": [
            "bool intl_is_failure()",
            "* Check whether the given error code indicates a failure.  * Returns true if it does, and false if the code  * indicates success or a warning."
        ],
        "intval": [
            "int intval(mixed var [, int base])",
            "Get the integer value of a variable using the optional base for the conversion"
        ],
        "ip2long": [
            "int ip2long(string ip_address)",
            "Converts a string containing an (IPv4) Internet Protocol dotted address into a proper address"
        ],
        "iptcembed": [
            "array iptcembed(string iptcdata, string jpeg_file_name [, int spool])",
            "Embed binary IPTC data into a JPEG image."
        ],
        "iptcparse": [
            "array iptcparse(string iptcdata)",
            "Parse binary IPTC-data into associative array"
        ],
        "is_a": [
            "bool is_a(object object, string class_name)",
            "Returns true if the object is of this class or has this class as one of its parents"
        ],
        "is_array": [
            "bool is_array(mixed var)",
            "Returns true if variable is an array"
        ],
        "is_bool": [
            "bool is_bool(mixed var)",
            "Returns true if variable is a boolean"
        ],
        "is_callable": [
            "bool is_callable(mixed var [, bool syntax_only [, string callable_name]])",
            "Returns true if var is callable."
        ],
        "is_countable": [
            "bool is_countable(mixed var)",
            "Returns true if var is countable, false otherwise"
        ],
        "is_dir": [
            "bool is_dir(string filename)",
            "Returns true if file is directory"
        ],
        "is_executable": [
            "bool is_executable(string filename)",
            "Returns true if file is executable"
        ],
        "is_file": [
            "bool is_file(string filename)",
            "Returns true if file is a regular file"
        ],
        "is_finite": [
            "bool is_finite(float val)",
            "Returns whether argument is finite"
        ],
        "is_float": [
            "bool is_float(mixed var)",
            "Returns true if variable is float point"
        ],
        "is_infinite": [
            "bool is_infinite(float val)",
            "Returns whether argument is infinite"
        ],
        "is_link": [
            "bool is_link(string filename)",
            "Returns true if file is symbolic link"
        ],
        "is_long": [
            "bool is_long(mixed var)",
            "Returns true if variable is a long (integer)"
        ],
        "is_nan": [
            "bool is_nan(float val)",
            "Returns whether argument is not a number"
        ],
        "is_null": [
            "bool is_null(mixed var)",
            "Returns true if variable is null"
        ],
        "is_numeric": [
            "bool is_numeric(mixed value)",
            "Returns true if value is a number or a numeric string"
        ],
        "is_object": [
            "bool is_object(mixed var)",
            "Returns true if variable is an object"
        ],
        "is_readable": [
            "bool is_readable(string filename)",
            "Returns true if file can be read"
        ],
        "is_resource": [
            "bool is_resource(mixed var)",
            "Returns true if variable is a resource"
        ],
        "is_scalar": [
            "bool is_scalar(mixed value)",
            "Returns true if value is a scalar"
        ],
        "is_string": [
            "bool is_string(mixed var)",
            "Returns true if variable is a string"
        ],
        "is_subclass_of": [
            "bool is_subclass_of(object object, string class_name)",
            "Returns true if the object has this class as one of its parents"
        ],
        "is_uploaded_file": [
            "bool is_uploaded_file(string path)",
            "Check if file was created by rfc1867 upload"
        ],
        "is_writable": [
            "bool is_writable(string filename)",
            "Returns true if file can be written"
        ],
        "isset": [
            "bool isset(mixed var [, mixed var])",
            "Determine whether a variable is set"
        ],
        "iterator_apply": [
            "int iterator_apply(Traversable iterator, callable function [, array args = null)",
            "Calls a function for every element in an iterator"
        ],
        "iterator_count": [
            "int iterator_count(Traversable iterator)",
            "Count the elements in an iterator"
        ],
        "iterator_to_array": [
            "array iterator_to_array(Traversable iterator [, bool use_keys = true])",
            "Copy the iterator into an array"
        ],
        "jddayofweek": [
            "mixed jddayofweek(int juliandaycount [, int mode])",
            "Returns name or number of day of week from julian day count"
        ],
        "jdmonthname": [
            "string jdmonthname(int juliandaycount, int mode)",
            "Returns name of month for julian day count"
        ],
        "jdtofrench": [
            "string jdtofrench(int juliandaycount)",
            "Converts a julian day count to a french republic calendar date"
        ],
        "jdtogregorian": [
            "string jdtogregorian(int juliandaycount)",
            "Converts a julian day count to a gregorian calendar date"
        ],
        "jdtojewish": [
            "string jdtojewish(int juliandaycount [, bool hebrew [, int fl]])",
            "Converts a julian day count to a jewish calendar date"
        ],
        "jdtojulian": [
            "string jdtojulian(int juliandaycount)",
            "Convert a julian day count to a julian calendar date"
        ],
        "jdtounix": [
            "int jdtounix(int jday)",
            "Convert Julian Day to UNIX timestamp"
        ],
        "jewishtojd": [
            "int jewishtojd(int month, int day, int year)",
            "Converts a jewish calendar date to a julian day count"
        ],
        "join": [
            "string join([string glue,] array pieces)",
            "Returns a string containing a string representation of all the arrayelements in the same order, with the glue string between each element"
        ],
        "jpeg2wbmp": [
            "bool jpeg2wbmp(string f_org, string f_dest, int d_height, int d_width, int threshold)",
            "Convert JPEG image to WBMP image"
        ],
        "json_decode": [
            "mixed json_decode(string json [, bool assoc [, long depth]])",
            "Decodes the JSON representation into a PHP value"
        ],
        "json_encode": [
            "string json_encode(mixed data [, int options])",
            "Returns the JSON representation of a value"
        ],
        "json_last_error": [
            "int json_last_error()",
            "Returns the error code of the last json_decode()."
        ],
        "juliantojd": [
            "int juliantojd(int month, int day, int year)",
            "Converts a julian calendar date to julian day count"
        ],
        "key": [
            "mixed key(array array_arg)",
            "Return the key of the element currently pointed to by the internal array pointer"
        ],
        "krsort": [
            "bool krsort(array &array_arg [, int sort_flags])",
            "Sort an array by key value in reverse order"
        ],
        "ksort": [
            "bool ksort(array &array_arg [, int sort_flags])",
            "Sort an array by key"
        ],
        "lcfirst": [
            "string lcfirst(string str)",
            "Make a string's first character lowercase"
        ],
        "lcg_value": [
            "float lcg_value()",
            "Returns a value from the combined linear congruential generator"
        ],
        "lchgrp": [
            "bool lchgrp(string filename, mixed group)",
            "Change symlink group"
        ],
        "ldap_8859_to_t61": [
            "string ldap_8859_to_t61(string value)",
            "Translate 8859 characters to t61 characters"
        ],
        "ldap_add": [
            "bool ldap_add(resource link, string dn, array entry)",
            "Add entries to LDAP directory"
        ],
        "ldap_bind": [
            "bool ldap_bind(resource link [, string dn [, string password]])",
            "Bind to LDAP directory"
        ],
        "ldap_compare": [
            "bool ldap_compare(resource link, string dn, string attr, string value)",
            "Determine if an entry has a specific value for one of its attributes"
        ],
        "ldap_connect": [
            "resource ldap_connect([string host [, int port [, string wallet [, string wallet_passwd [, int authmode]]]]])",
            "Connect to an LDAP server"
        ],
        "ldap_count_entries": [
            "int ldap_count_entries(resource link, resource result)",
            "Count the number of entries in a search result"
        ],
        "ldap_delete": [
            "bool ldap_delete(resource link, string dn)",
            "Delete an entry from a directory"
        ],
        "ldap_dn2ufn": [
            "string ldap_dn2ufn(string dn)",
            "Convert DN to User Friendly Naming format"
        ],
        "ldap_err2str": [
            "string ldap_err2str(int errno)",
            "Convert error number to error string"
        ],
        "ldap_errno": [
            "int ldap_errno(resource link)",
            "Get the current ldap error number"
        ],
        "ldap_error": [
            "string ldap_error(resource link)",
            "Get the current ldap error string"
        ],
        "ldap_explode_dn": [
            "array ldap_explode_dn(string dn, int with_attrib)",
            "Splits DN into its component parts"
        ],
        "ldap_first_attribute": [
            "string ldap_first_attribute(resource link, resource result_entry)",
            "Return first attribute"
        ],
        "ldap_first_entry": [
            "resource ldap_first_entry(resource link, resource result)",
            "Return first result id"
        ],
        "ldap_first_reference": [
            "resource ldap_first_reference(resource link, resource result)",
            "Return first reference"
        ],
        "ldap_free_result": [
            "bool ldap_free_result(resource result)",
            "Free result memory"
        ],
        "ldap_get_attributes": [
            "array ldap_get_attributes(resource link, resource result_entry)",
            "Get attributes from a search result entry"
        ],
        "ldap_get_dn": [
            "string ldap_get_dn(resource link, resource result_entry)",
            "Get the DN of a result entry"
        ],
        "ldap_get_entries": [
            "array ldap_get_entries(resource link, resource result)",
            "Get all result entries"
        ],
        "ldap_get_option": [
            "bool ldap_get_option(resource link, int option, mixed retval)",
            "Get the current value of various session-wide parameters"
        ],
        "ldap_get_values_len": [
            "array ldap_get_values_len(resource link, resource result_entry, string attribute)",
            "Get all values with lengths from a result entry"
        ],
        "ldap_list": [
            "resource ldap_list(resource|array link, string base_dn, string filter [, array attrs [, int attrsonly [, int sizelimit [, int timelimit [, int deref]]]]])",
            "Single-level search"
        ],
        "ldap_mod_add": [
            "bool ldap_mod_add(resource link, string dn, array entry)",
            "Add attribute values to current"
        ],
        "ldap_mod_del": [
            "bool ldap_mod_del(resource link, string dn, array entry)",
            "Delete attribute values"
        ],
        "ldap_mod_replace": [
            "bool ldap_mod_replace(resource link, string dn, array entry)",
            "Replace attribute values with new ones"
        ],
        "ldap_next_attribute": [
            "string ldap_next_attribute(resource link, resource result_entry)",
            "Get the next attribute in result"
        ],
        "ldap_next_entry": [
            "resource ldap_next_entry(resource link, resource result_entry)",
            "Get next result entry"
        ],
        "ldap_next_reference": [
            "resource ldap_next_reference(resource link, resource reference_entry)",
            "Get next reference"
        ],
        "ldap_parse_reference": [
            "bool ldap_parse_reference(resource link, resource reference_entry, array referrals)",
            "Extract information from reference entry"
        ],
        "ldap_parse_result": [
            "bool ldap_parse_result(resource link, resource result, int errcode, string matcheddn, string errmsg, array referrals)",
            "Extract information from result"
        ],
        "ldap_read": [
            "resource ldap_read(resource|array link, string base_dn, string filter [, array attrs [, int attrsonly [, int sizelimit [, int timelimit [, int deref]]]]])",
            "Read an entry"
        ],
        "ldap_rename": [
            "bool ldap_rename(resource link, string dn, string newrdn, string newparent, bool deleteoldrdn)",
            "Modify the name of an entry"
        ],
        "ldap_sasl_bind": [
            "bool ldap_sasl_bind(resource link [, string binddn [, string password [, string sasl_mech [, string sasl_realm [, string sasl_authc_id [, string sasl_authz_id [, string props]]]]]]])",
            "Bind to LDAP directory using SASL"
        ],
        "ldap_search": [
            "resource ldap_search(resource|array link, string base_dn, string filter [, array attrs [, int attrsonly [, int sizelimit [, int timelimit [, int deref]]]]])",
            "Search LDAP tree under base_dn"
        ],
        "ldap_set_option": [
            "bool ldap_set_option(resource link, int option, mixed newval)",
            "Set the value of various session-wide parameters"
        ],
        "ldap_set_rebind_proc": [
            "bool ldap_set_rebind_proc(resource link, string callback)",
            "Set a callback function to do re-binds on referral chasing."
        ],
        "ldap_sort": [
            "bool ldap_sort(resource link, resource result, string sortfilter)",
            "Sort LDAP result entries"
        ],
        "ldap_start_tls": [
            "bool ldap_start_tls(resource link)",
            "Start TLS"
        ],
        "ldap_t61_to_8859": [
            "string ldap_t61_to_8859(string value)",
            "Translate t61 characters to 8859 characters"
        ],
        "ldap_unbind": [
            "bool ldap_unbind(resource link)",
            "Unbind from LDAP directory"
        ],
        "leak": [
            "void leak(int num_bytes=3)",
            "Cause an intentional memory leak, for testing/debugging purposes"
        ],
        "levenshtein": [
            "int levenshtein(string str1, string str2[, int cost_ins, int cost_rep, int cost_del])",
            "Calculate Levenshtein distance between two strings"
        ],
        "libxml_clear_errors": [
            "void libxml_clear_errors()",
            "Clear last error from libxml"
        ],
        "libxml_disable_entity_loader": [
            "bool libxml_disable_entity_loader([bool disable])",
            "Disable/Enable ability to load external entities"
        ],
        "libxml_get_errors": [
            "object libxml_get_errors()",
            "Retrieve array of errors"
        ],
        "libxml_get_last_error": [
            "object libxml_get_last_error()",
            "Retrieve last error from libxml"
        ],
        "libxml_set_streams_context": [
            "void libxml_set_streams_context(resource streams_context)",
            "Set the streams context for the next libxml document load or write"
        ],
        "libxml_use_internal_errors": [
            "bool libxml_use_internal_errors([bool use_errors])",
            "Disable libxml errors and allow user to fetch error information as needed"
        ],
        "link": [
            "int link(string target, string link)",
            "Create a hard link"
        ],
        "linkinfo": [
            "int linkinfo(string filename)",
            "Returns the st_dev field of the UNIX C stat structure describing the link"
        ],
        "litespeed_request_headers": [
            "array litespeed_request_headers()",
            "Fetch all HTTP request headers"
        ],
        "litespeed_response_headers": [
            "array litespeed_response_headers()",
            "Fetch all HTTP response headers"
        ],
        "locale_accept_from_http": [
            "string locale_accept_from_http(string $http_accept)",
            null
        ],
        "locale_canonicalize": [
            "static string locale_canonicalize(Locale $loc, string $locale)",
            "* @param string $locale The locale string to canonicalize"
        ],
        "locale_filter_matches": [
            "bool locale_filter_matches(string $langtag, string $locale[, bool $canonicalize])",
            "* Checks if a $langtag filter matches with $locale according to RFC 4647's basic filtering algorithm"
        ],
        "locale_get_all_variants": [
            "static array locale_get_all_variants($locale)",
            "* gets an array containing the list of variants, or null"
        ],
        "locale_get_default": [
            "static string locale_get_default( )",
            "Get default locale"
        ],
        "locale_get_keywords": [
            "static array locale_get_keywords(string $locale) {",
            "* return an associative array containing keyword-value  * pairs for this locale. The keys are keys to the array"
        ],
        "locale_get_primary_language": [
            "static string locale_get_primary_language($locale)",
            "* gets the primary language for the $locale"
        ],
        "locale_get_region": [
            "static string locale_get_region($locale)",
            "* gets the region for the $locale"
        ],
        "locale_get_script": [
            "static string locale_get_script($locale)",
            "* gets the script for the $locale"
        ],
        "locale_lookup": [
            "string locale_lookup(array $langtag, string $locale[, bool $canonicalize[, string $default = null]])",
            "* Searchs the items in $langtag for the best match to the language * range"
        ],
        "locale_set_default": [
            "static string locale_set_default( string $locale )",
            "Set default locale"
        ],
        "localeconv": [
            "array localeconv()",
            "Returns numeric formatting information based on the current locale"
        ],
        "localtime": [
            "array localtime([int timestamp [, bool associative_array]])",
            "Returns the results of the C system call localtime as an associative array if the associative_array argument is set to 1 other wise it is a regular array"
        ],
        "log": [
            "float log(float number, [float base])",
            "Returns the natural logarithm of the number, or the base log if base is specified"
        ],
        "log10": [
            "float log10(float number)",
            "Returns the base-10 logarithm of the number"
        ],
        "log1p": [
            "float log1p(float number)",
            "Returns log(1 + number), computed in a way that accurate even when the value of number is close to zero"
        ],
        "long2ip": [
            "string long2ip(int proper_address)",
            "Converts an (IPv4) Internet network address into a string in Internet standard dotted format"
        ],
        "lstat": [
            "array lstat(string filename)",
            "Give information about a file or symbolic link"
        ],
        "ltrim": [
            "string ltrim(string str [, string character_mask])",
            "Strips whitespace from the beginning of a string"
        ],
        "mail": [
            "int mail(string to, string subject, string message [, string additional_headers [, string additional_parameters]])",
            "Send an email message"
        ],
        "max": [
            "mixed max(mixed arg1 [, mixed arg2 [, mixed ...]])",
            "Return the highest value in an array or a series of arguments"
        ],
        "mb_check_encoding": [
            "bool mb_check_encoding([string var[, string encoding]])",
            "Check if the string is valid for the specified encoding"
        ],
        "mb_convert_case": [
            "string mb_convert_case(string sourcestring, int mode [, string encoding])",
            "Returns a case-folded version of sourcestring"
        ],
        "mb_convert_encoding": [
            "string mb_convert_encoding(string str, string to-encoding [, mixed from-encoding])",
            "Returns converted string in desired encoding"
        ],
        "mb_convert_kana": [
            "string mb_convert_kana(string str [, string option] [, string encoding])",
            "Conversion between full-width character and half-width character (Japanese)"
        ],
        "mb_convert_variables": [
            "string mb_convert_variables(string to-encoding, mixed from-encoding, mixed vars [, ...])",
            "Converts the string resource in variables to desired encoding"
        ],
        "mb_decode_mimeheader": [
            "string mb_decode_mimeheader(string string)",
            'Decodes the MIME "encoded-word" in the string'
        ],
        "mb_decode_numericentity": [
            "string mb_decode_numericentity(string string, array convmap [, string encoding])",
            "Converts HTML numeric entities to character code"
        ],
        "mb_detect_encoding": [
            "string mb_detect_encoding(string str [, mixed encoding_list [, bool strict]])",
            "Encodings of the given string is returned (as a string)"
        ],
        "mb_detect_order": [
            "bool|array mb_detect_order([mixed encoding-list])",
            "Sets the current detect_order or Return the current detect_order as a array"
        ],
        "mb_encode_mimeheader": [
            "string mb_encode_mimeheader(string str [, string charset [, string transfer-encoding [, string linefeed [, int indent]]]])",
            'Converts the string to MIME "encoded-word" in the format of =?charset?(B|Q)?encoded_string?='
        ],
        "mb_encode_numericentity": [
            "string mb_encode_numericentity(string string, array convmap [, string encoding])",
            "Converts specified characters to HTML numeric entities"
        ],
        "mb_encoding_aliases": [
            "array mb_encoding_aliases(string encoding)",
            "Returns an array of the aliases of a given encoding name"
        ],
        "mb_ereg": [
            "int mb_ereg(string pattern, string string [, array registers])",
            "Regular expression match for multibyte string"
        ],
        "mb_ereg_match": [
            "bool mb_ereg_match(string pattern, string string [,string option])",
            "Regular expression match for multibyte string"
        ],
        "mb_ereg_replace": [
            "string mb_ereg_replace(string pattern, string replacement, string string [, string option])",
            "Replace regular expression for multibyte string"
        ],
        "mb_ereg_search": [
            "bool mb_ereg_search([string pattern[, string option]])",
            "Regular expression search for multibyte string"
        ],
        "mb_ereg_search_getpos": [
            "int mb_ereg_search_getpos()",
            "Get search start position"
        ],
        "mb_ereg_search_getregs": [
            "array mb_ereg_search_getregs()",
            "Get matched substring of the last time"
        ],
        "mb_ereg_search_init": [
            "bool mb_ereg_search_init(string string [, string pattern[, string option]])",
            "Initialize string and regular expression for search."
        ],
        "mb_ereg_search_pos": [
            "array mb_ereg_search_pos([string pattern[, string option]])",
            "Regular expression search for multibyte string"
        ],
        "mb_ereg_search_regs": [
            "array mb_ereg_search_regs([string pattern[, string option]])",
            "Regular expression search for multibyte string"
        ],
        "mb_ereg_search_setpos": [
            "bool mb_ereg_search_setpos(int position)",
            "Set search start position"
        ],
        "mb_eregi": [
            "int mb_eregi(string pattern, string string [, array registers])",
            "Case-insensitive regular expression match for multibyte string"
        ],
        "mb_eregi_replace": [
            "string mb_eregi_replace(string pattern, string replacement, string string)",
            "Case insensitive replace regular expression for multibyte string"
        ],
        "mb_get_info": [
            "mixed mb_get_info([string type])",
            "Returns the current settings of mbstring"
        ],
        "mb_http_input": [
            "mixed mb_http_input([string type])",
            "Returns the input encoding"
        ],
        "mb_http_output": [
            "string mb_http_output([string encoding])",
            "Sets the current output_encoding or returns the current output_encoding as a string"
        ],
        "mb_internal_encoding": [
            "string mb_internal_encoding([string encoding])",
            "Sets the current internal encoding or Returns the current internal encoding as a string"
        ],
        "mb_language": [
            "string mb_language([string language])",
            "Sets the current language or Returns the current language as a string"
        ],
        "mb_list_encodings": [
            "mixed mb_list_encodings()",
            "Returns an array of all supported entity encodings"
        ],
        "mb_output_handler": [
            "string mb_output_handler(string contents, int status)",
            "Returns string in output buffer converted to the http_output encoding"
        ],
        "mb_parse_str": [
            "bool mb_parse_str(string encoded_string [, array result])",
            "Parses GET/POST/COOKIE data and sets global variables"
        ],
        "mb_preferred_mime_name": [
            "string mb_preferred_mime_name(string encoding)",
            "Return the preferred MIME name (charset) as a string"
        ],
        "mb_regex_encoding": [
            "string mb_regex_encoding([string encoding])",
            "Returns the current encoding for regex as a string."
        ],
        "mb_regex_set_options": [
            "string mb_regex_set_options([string options])",
            "Set or get the default options for mbregex functions"
        ],
        "mb_send_mail": [
            "int mb_send_mail(string to, string subject, string message [, string additional_headers [, string additional_parameters]])",
            "*  Sends an email message with MIME scheme"
        ],
        "mb_split": [
            "array mb_split(string pattern, string string [, int limit])",
            "split multibyte string into array by regular expression"
        ],
        "mb_strcut": [
            "string mb_strcut(string str, int start [, int length [, string encoding]])",
            "Returns part of a string"
        ],
        "mb_strimwidth": [
            "string mb_strimwidth(string str, int start, int width [, string trimmarker [, string encoding]])",
            "Trim the string in terminal width"
        ],
        "mb_stripos": [
            "int mb_stripos(string haystack, string needle [, int offset [, string encoding]])",
            "Finds position of first occurrence of a string within another, case insensitive"
        ],
        "mb_stristr": [
            "string mb_stristr(string haystack, string needle[, bool part[, string encoding]])",
            "Finds first occurrence of a string within another, case insensitive"
        ],
        "mb_strlen": [
            "int mb_strlen(string str [, string encoding])",
            "Get character numbers of a string"
        ],
        "mb_strpos": [
            "int mb_strpos(string haystack, string needle [, int offset [, string encoding]])",
            "Find position of first occurrence of a string within another"
        ],
        "mb_strrchr": [
            "string mb_strrchr(string haystack, string needle[, bool part[, string encoding]])",
            "Finds the last occurrence of a character in a string within another"
        ],
        "mb_strrichr": [
            "string mb_strrichr(string haystack, string needle[, bool part[, string encoding]])",
            "Finds the last occurrence of a character in a string within another, case insensitive"
        ],
        "mb_strripos": [
            "int mb_strripos(string haystack, string needle [, int offset [, string encoding]])",
            "Finds position of last occurrence of a string within another, case insensitive"
        ],
        "mb_strrpos": [
            "int mb_strrpos(string haystack, string needle [, int offset [, string encoding]])",
            "Find position of last occurrence of a string within another"
        ],
        "mb_strstr": [
            "string mb_strstr(string haystack, string needle[, bool part[, string encoding]])",
            "Finds first occurrence of a string within another"
        ],
        "mb_strtolower": [
            "string mb_strtolower(string sourcestring [, string encoding])",
            "*  Returns a lowercased version of sourcestring"
        ],
        "mb_strtoupper": [
            "string mb_strtoupper(string sourcestring [, string encoding])",
            "*  Returns a uppercased version of sourcestring"
        ],
        "mb_strwidth": [
            "int mb_strwidth(string str [, string encoding])",
            "Gets terminal width of a string"
        ],
        "mb_substitute_character": [
            "mixed mb_substitute_character([mixed substchar])",
            "Sets the current substitute_character or returns the current substitute_character"
        ],
        "mb_substr": [
            "string mb_substr(string str, int start [, int length [, string encoding]])",
            "Returns part of a string"
        ],
        "mb_substr_count": [
            "int mb_substr_count(string haystack, string needle [, string encoding])",
            "Count the number of substring occurrences"
        ],
        "mcrypt_cbc": [
            "string mcrypt_cbc(int cipher, string key, string data, int mode, string iv)",
            "CBC crypt/decrypt data using key key with cipher cipher starting with iv"
        ],
        "mcrypt_cfb": [
            "string mcrypt_cfb(int cipher, string key, string data, int mode, string iv)",
            "CFB crypt/decrypt data using key key with cipher cipher starting with iv"
        ],
        "mcrypt_create_iv": [
            "string mcrypt_create_iv(int size, int source)",
            "Create an initialization vector (IV)"
        ],
        "mcrypt_decrypt": [
            "string mcrypt_decrypt(string cipher, string key, string data, string mode, string iv)",
            "OFB crypt/decrypt data using key key with cipher cipher starting with iv"
        ],
        "mcrypt_ecb": [
            "string mcrypt_ecb(int cipher, string key, string data, int mode, string iv)",
            "ECB crypt/decrypt data using key key with cipher cipher starting with iv"
        ],
        "mcrypt_enc_get_algorithms_name": [
            "string mcrypt_enc_get_algorithms_name(resource td)",
            "Returns the name of the algorithm specified by the descriptor td"
        ],
        "mcrypt_enc_get_block_size": [
            "int mcrypt_enc_get_block_size(resource td)",
            "Returns the block size of the cipher specified by the descriptor td"
        ],
        "mcrypt_enc_get_iv_size": [
            "int mcrypt_enc_get_iv_size(resource td)",
            "Returns the size of the IV in bytes of the algorithm specified by the descriptor td"
        ],
        "mcrypt_enc_get_key_size": [
            "int mcrypt_enc_get_key_size(resource td)",
            "Returns the maximum supported key size in bytes of the algorithm specified by the descriptor td"
        ],
        "mcrypt_enc_get_modes_name": [
            "string mcrypt_enc_get_modes_name(resource td)",
            "Returns the name of the mode specified by the descriptor td"
        ],
        "mcrypt_enc_get_supported_key_sizes": [
            "array mcrypt_enc_get_supported_key_sizes(resource td)",
            "This function decrypts the crypttext"
        ],
        "mcrypt_enc_is_block_algorithm": [
            "bool mcrypt_enc_is_block_algorithm(resource td)",
            "Returns TRUE if the alrogithm is a block algorithms"
        ],
        "mcrypt_enc_is_block_algorithm_mode": [
            "bool mcrypt_enc_is_block_algorithm_mode(resource td)",
            "Returns TRUE if the mode is for use with block algorithms"
        ],
        "mcrypt_enc_is_block_mode": [
            "bool mcrypt_enc_is_block_mode(resource td)",
            "Returns TRUE if the mode outputs blocks"
        ],
        "mcrypt_enc_self_test": [
            "int mcrypt_enc_self_test(resource td)",
            "This function runs the self test on the algorithm specified by the descriptor td"
        ],
        "mcrypt_encrypt": [
            "string mcrypt_encrypt(string cipher, string key, string data, string mode, string iv)",
            "OFB crypt/decrypt data using key key with cipher cipher starting with iv"
        ],
        "mcrypt_generic": [
            "string mcrypt_generic(resource td, string data)",
            "This function encrypts the plaintext"
        ],
        "mcrypt_generic_deinit": [
            "bool mcrypt_generic_deinit(resource td)",
            "This function terminates encrypt specified by the descriptor td"
        ],
        "mcrypt_generic_init": [
            "int mcrypt_generic_init(resource td, string key, string iv)",
            "This function initializes all buffers for the specific module"
        ],
        "mcrypt_get_block_size": [
            "int mcrypt_get_block_size(string cipher, string module)",
            "Get the key size of cipher"
        ],
        "mcrypt_get_cipher_name": [
            "string mcrypt_get_cipher_name(string cipher)",
            "Get the key size of cipher"
        ],
        "mcrypt_get_iv_size": [
            "int mcrypt_get_iv_size(string cipher, string module)",
            "Get the IV size of cipher (Usually the same as the blocksize)"
        ],
        "mcrypt_get_key_size": [
            "int mcrypt_get_key_size(string cipher, string module)",
            "Get the key size of cipher"
        ],
        "mcrypt_list_algorithms": [
            "array mcrypt_list_algorithms([string lib_dir])",
            'List all algorithms in "module_dir"'
        ],
        "mcrypt_list_modes": [
            "array mcrypt_list_modes([string lib_dir])",
            'List all modes "module_dir"'
        ],
        "mcrypt_module_close": [
            "bool mcrypt_module_close(resource td)",
            "Free the descriptor td"
        ],
        "mcrypt_module_get_algo_block_size": [
            "int mcrypt_module_get_algo_block_size(string algorithm [, string lib_dir])",
            "Returns the block size of the algorithm"
        ],
        "mcrypt_module_get_algo_key_size": [
            "int mcrypt_module_get_algo_key_size(string algorithm [, string lib_dir])",
            "Returns the maximum supported key size of the algorithm"
        ],
        "mcrypt_module_get_supported_key_sizes": [
            "array mcrypt_module_get_supported_key_sizes(string algorithm [, string lib_dir])",
            "This function decrypts the crypttext"
        ],
        "mcrypt_module_is_block_algorithm": [
            "bool mcrypt_module_is_block_algorithm(string algorithm [, string lib_dir])",
            "Returns TRUE if the algorithm is a block algorithm"
        ],
        "mcrypt_module_is_block_algorithm_mode": [
            "bool mcrypt_module_is_block_algorithm_mode(string mode [, string lib_dir])",
            "Returns TRUE if the mode is for use with block algorithms"
        ],
        "mcrypt_module_is_block_mode": [
            "bool mcrypt_module_is_block_mode(string mode [, string lib_dir])",
            "Returns TRUE if the mode outputs blocks of bytes"
        ],
        "mcrypt_module_open": [
            "resource mcrypt_module_open(string cipher, string cipher_directory, string mode, string mode_directory)",
            "Opens the module of the algorithm and the mode to be used"
        ],
        "mcrypt_module_self_test": [
            "bool mcrypt_module_self_test(string algorithm [, string lib_dir])",
            'Does a self test of the module "module"'
        ],
        "mcrypt_ofb": [
            "string mcrypt_ofb(int cipher, string key, string data, int mode, string iv)",
            "OFB crypt/decrypt data using key key with cipher cipher starting with iv"
        ],
        "md5": [
            "string md5(string str, [ bool raw_output])",
            "Calculate the md5 hash of a string"
        ],
        "md5_file": [
            "string md5_file(string filename [, bool raw_output])",
            "Calculate the md5 hash of given filename"
        ],
        "mdecrypt_generic": [
            "string mdecrypt_generic(resource td, string data)",
            "This function decrypts the plaintext"
        ],
        "memory_get_peak_usage": [
            "int memory_get_peak_usage([real_usage])",
            "Returns the peak allocated by PHP memory"
        ],
        "memory_get_usage": [
            "int memory_get_usage([real_usage])",
            "Returns the allocated by PHP memory"
        ],
        "metaphone": [
            "string metaphone(string text[, int phones])",
            "Break english phrases down into their phonemes"
        ],
        "method_exists": [
            "bool method_exists(object object, string method)",
            "Checks if the class method exists"
        ],
        "mhash": [
            "string mhash(int hash, string data [, string key])",
            "Hash data with hash"
        ],
        "mhash_count": [
            "int mhash_count()",
            "Gets the number of available hashes"
        ],
        "mhash_get_block_size": [
            "int mhash_get_block_size(int hash)",
            "Gets the block size of hash"
        ],
        "mhash_get_hash_name": [
            "string mhash_get_hash_name(int hash)",
            "Gets the name of hash"
        ],
        "mhash_keygen_s2k": [
            "string mhash_keygen_s2k(int hash, string input_password, string salt, int bytes)",
            "Generates a key using hash functions"
        ],
        "microtime": [
            "mixed microtime([bool get_as_float])",
            "Returns either a string or a float containing the current time in seconds and microseconds"
        ],
        "mime_content_type": [
            "string mime_content_type(string filename|resource stream)",
            "Return content-type for file"
        ],
        "min": [
            "mixed min(mixed arg1 [, mixed arg2 [, mixed ...]])",
            "Return the lowest value in an array or a series of arguments"
        ],
        "mkdir": [
            "bool mkdir(string pathname [, int mode [, bool recursive [, resource context]]])",
            "Create a directory"
        ],
        "mktime": [
            "int mktime([int hour [, int min [, int sec [, int mon [, int day [, int year]]]]]])",
            "Get UNIX timestamp for a date"
        ],
        "money_format": [
            "string money_format(string format , float value)",
            "Convert monetary value(s) to string"
        ],
        "move_uploaded_file": [
            "bool move_uploaded_file(string path, string new_path)",
            "Move a file if and only if it was created by an upload"
        ],
        "msg_get_queue": [
            "resource msg_get_queue(int key [, int perms])",
            "Attach to a message queue"
        ],
        "msg_queue_exists": [
            "bool msg_queue_exists(int key)",
            "Check whether a message queue exists"
        ],
        "msg_receive": [
            "mixed msg_receive(resource queue, int desiredmsgtype, int &msgtype, int maxsize, mixed message [, bool unserialize=true [, int flags=0 [, int errorcode]]])",
            "Send a message of type msgtype (must be > 0) to a message queue"
        ],
        "msg_remove_queue": [
            "bool msg_remove_queue(resource queue)",
            "Destroy the queue"
        ],
        "msg_send": [
            "bool msg_send(resource queue, int msgtype, mixed message [, bool serialize=true [, bool blocking=true [, int errorcode]]])",
            "Send a message of type msgtype (must be > 0) to a message queue"
        ],
        "msg_set_queue": [
            "bool msg_set_queue(resource queue, array data)",
            "Set information for a message queue"
        ],
        "msg_stat_queue": [
            "array msg_stat_queue(resource queue)",
            "Returns information about a message queue"
        ],
        "msgfmt_create": [
            "MessageFormatter msgfmt_create( string $locale, string $pattern )",
            "* Create formatter."
        ],
        "msgfmt_format": [
            "mixed msgfmt_format( MessageFormatter $nf, array $args )",
            "* Format a message."
        ],
        "msgfmt_format_message": [
            "mixed msgfmt_format_message( string $locale, string $pattern, array $args )",
            "* Format a message."
        ],
        "msgfmt_get_error_code": [
            "int msgfmt_get_error_code( MessageFormatter $nf )",
            "* Get formatter's last error code."
        ],
        "msgfmt_get_error_message": [
            "string msgfmt_get_error_message( MessageFormatter $coll )",
            "* Get text description for formatter's last error code."
        ],
        "msgfmt_get_locale": [
            "string msgfmt_get_locale(MessageFormatter $mf)",
            "* Get formatter locale."
        ],
        "msgfmt_get_pattern": [
            "string msgfmt_get_pattern( MessageFormatter $mf )",
            "* Get formatter pattern."
        ],
        "msgfmt_parse": [
            "array msgfmt_parse( MessageFormatter $nf, string $source )",
            "* Parse a message."
        ],
        "msgfmt_set_pattern": [
            "bool msgfmt_set_pattern( MessageFormatter $mf, string $pattern )",
            "* Set formatter pattern."
        ],
        "mssql_bind": [
            "bool mssql_bind(resource stmt, string param_name, mixed var, int type [, bool is_output [, bool is_null [, int maxlen]]])",
            "Adds a parameter to a stored procedure or a remote stored procedure"
        ],
        "mssql_close": [
            "bool mssql_close([resource conn_id])",
            "Closes a connection to a MS-SQL server"
        ],
        "mssql_connect": [
            "int mssql_connect([string servername [, string username [, string password [, bool new_link]]]])",
            "Establishes a connection to a MS-SQL server"
        ],
        "mssql_data_seek": [
            "bool mssql_data_seek(resource result_id, int offset)",
            "Moves the internal row pointer of the MS-SQL result associated with the specified result identifier to pointer to the specified row number"
        ],
        "mssql_execute": [
            "mixed mssql_execute(resource stmt [, bool skip_results = false])",
            "Executes a stored procedure on a MS-SQL server database"
        ],
        "mssql_fetch_array": [
            "array mssql_fetch_array(resource result_id [, int result_type])",
            "Returns an associative array of the current row in the result set specified by result_id"
        ],
        "mssql_fetch_assoc": [
            "array mssql_fetch_assoc(resource result_id)",
            "Returns an associative array of the current row in the result set specified by result_id"
        ],
        "mssql_fetch_batch": [
            "int mssql_fetch_batch(resource result_index)",
            "Returns the next batch of records"
        ],
        "mssql_fetch_field": [
            "object mssql_fetch_field(resource result_id [, int offset])",
            "Gets information about certain fields in a query result"
        ],
        "mssql_fetch_object": [
            "object mssql_fetch_object(resource result_id)",
            "Returns a pseudo-object of the current row in the result set specified by result_id"
        ],
        "mssql_fetch_row": [
            "array mssql_fetch_row(resource result_id)",
            "Returns an array of the current row in the result set specified by result_id"
        ],
        "mssql_field_length": [
            "int mssql_field_length(resource result_id [, int offset])",
            "Get the length of a MS-SQL field"
        ],
        "mssql_field_name": [
            "string mssql_field_name(resource result_id [, int offset])",
            "Returns the name of the field given by offset in the result set given by result_id"
        ],
        "mssql_field_seek": [
            "bool mssql_field_seek(resource result_id, int offset)",
            "Seeks to the specified field offset"
        ],
        "mssql_field_type": [
            "string mssql_field_type(resource result_id [, int offset])",
            "Returns the type of a field"
        ],
        "mssql_free_result": [
            "bool mssql_free_result(resource result_index)",
            "Free a MS-SQL result index"
        ],
        "mssql_free_statement": [
            "bool mssql_free_statement(resource result_index)",
            "Free a MS-SQL statement index"
        ],
        "mssql_get_last_message": [
            "string mssql_get_last_message()",
            "Gets the last message from the MS-SQL server"
        ],
        "mssql_guid_string": [
            "string mssql_guid_string(string binary [,bool short_format])",
            "Converts a 16 byte binary GUID to a string"
        ],
        "mssql_init": [
            "int mssql_init(string sp_name [, resource conn_id])",
            "Initializes a stored procedure or a remote stored procedure"
        ],
        "mssql_min_error_severity": [
            "void mssql_min_error_severity(int severity)",
            "Sets the lower error severity"
        ],
        "mssql_min_message_severity": [
            "void mssql_min_message_severity(int severity)",
            "Sets the lower message severity"
        ],
        "mssql_next_result": [
            "bool mssql_next_result(resource result_id)",
            "Move the internal result pointer to the next result"
        ],
        "mssql_num_fields": [
            "int mssql_num_fields(resource mssql_result_index)",
            "Returns the number of fields fetched in from the result id specified"
        ],
        "mssql_num_rows": [
            "int mssql_num_rows(resource mssql_result_index)",
            "Returns the number of rows fetched in from the result id specified"
        ],
        "mssql_pconnect": [
            "int mssql_pconnect([string servername [, string username [, string password [, bool new_link]]]])",
            "Establishes a persistent connection to a MS-SQL server"
        ],
        "mssql_query": [
            "resource mssql_query(string query [, resource conn_id [, int batch_size]])",
            "Perform an SQL query on a MS-SQL server database"
        ],
        "mssql_result": [
            "string mssql_result(resource result_id, int row, mixed field)",
            "Returns the contents of one cell from a MS-SQL result set"
        ],
        "mssql_rows_affected": [
            "int mssql_rows_affected(resource conn_id)",
            "Returns the number of records affected by the query"
        ],
        "mssql_select_db": [
            "bool mssql_select_db(string database_name [, resource conn_id])",
            "Select a MS-SQL database"
        ],
        "mt_getrandmax": [
            "int mt_getrandmax()",
            "Returns the maximum value a random number from Mersenne Twister can have"
        ],
        "mt_rand": [
            "int mt_rand([int min, int max])",
            "Returns a random number from Mersenne Twister"
        ],
        "mt_srand": [
            "void mt_srand([int seed])",
            "Seeds Mersenne Twister random number generator"
        ],
        "mysql_affected_rows": [
            "int mysql_affected_rows([int link_identifier])",
            "Gets number of affected rows in previous MySQL operation"
        ],
        "mysql_client_encoding": [
            "string mysql_client_encoding([int link_identifier])",
            "Returns the default character set for the current connection"
        ],
        "mysql_close": [
            "bool mysql_close([int link_identifier])",
            "Close a MySQL connection"
        ],
        "mysql_connect": [
            "resource mysql_connect([string hostname[:port][:/path/to/socket] [, string username [, string password [, bool new [, int flags]]]]])",
            "Opens a connection to a MySQL Server"
        ],
        "mysql_create_db": [
            "bool mysql_create_db(string database_name [, int link_identifier])",
            "Create a MySQL database"
        ],
        "mysql_data_seek": [
            "bool mysql_data_seek(resource result, int row_number)",
            "Move internal result pointer"
        ],
        "mysql_db_query": [
            "resource mysql_db_query(string database_name, string query [, int link_identifier])",
            "Sends an SQL query to MySQL"
        ],
        "mysql_drop_db": [
            "bool mysql_drop_db(string database_name [, int link_identifier])",
            "Drops (delete) a MySQL database"
        ],
        "mysql_errno": [
            "int mysql_errno([int link_identifier])",
            "Returns the number of the error message from previous MySQL operation"
        ],
        "mysql_error": [
            "string mysql_error([int link_identifier])",
            "Returns the text of the error message from previous MySQL operation"
        ],
        "mysql_escape_string": [
            "string mysql_escape_string(string to_be_escaped)",
            "Escape string for mysql query"
        ],
        "mysql_fetch_array": [
            "array mysql_fetch_array(resource result [, int result_type])",
            "Fetch a result row as an array (associative, numeric or both)"
        ],
        "mysql_fetch_assoc": [
            "array mysql_fetch_assoc(resource result)",
            "Fetch a result row as an associative array"
        ],
        "mysql_fetch_field": [
            "object mysql_fetch_field(resource result [, int field_offset])",
            "Gets column information from a result and return as an object"
        ],
        "mysql_fetch_lengths": [
            "array mysql_fetch_lengths(resource result)",
            "Gets max data size of each column in a result"
        ],
        "mysql_fetch_object": [
            "object mysql_fetch_object(resource result [, string class_name [, NULL|array ctor_params]])",
            "Fetch a result row as an object"
        ],
        "mysql_fetch_row": [
            "array mysql_fetch_row(resource result)",
            "Gets a result row as an enumerated array"
        ],
        "mysql_field_flags": [
            "string mysql_field_flags(resource result, int field_offset)",
            "Gets the flags associated with the specified field in a result"
        ],
        "mysql_field_len": [
            "int mysql_field_len(resource result, int field_offset)",
            "Returns the length of the specified field"
        ],
        "mysql_field_name": [
            "string mysql_field_name(resource result, int field_index)",
            "Gets the name of the specified field in a result"
        ],
        "mysql_field_seek": [
            "bool mysql_field_seek(resource result, int field_offset)",
            "Sets result pointer to a specific field offset"
        ],
        "mysql_field_table": [
            "string mysql_field_table(resource result, int field_offset)",
            "Gets name of the table the specified field is in"
        ],
        "mysql_field_type": [
            "string mysql_field_type(resource result, int field_offset)",
            "Gets the type of the specified field in a result"
        ],
        "mysql_free_result": [
            "bool mysql_free_result(resource result)",
            "Free result memory"
        ],
        "mysql_get_client_info": [
            "string mysql_get_client_info()",
            "Returns a string that represents the client library version"
        ],
        "mysql_get_host_info": [
            "string mysql_get_host_info([int link_identifier])",
            "Returns a string describing the type of connection in use, including the server host name"
        ],
        "mysql_get_proto_info": [
            "int mysql_get_proto_info([int link_identifier])",
            "Returns the protocol version used by current connection"
        ],
        "mysql_get_server_info": [
            "string mysql_get_server_info([int link_identifier])",
            "Returns a string that represents the server version number"
        ],
        "mysql_info": [
            "string mysql_info([int link_identifier])",
            "Returns a string containing information about the most recent query"
        ],
        "mysql_insert_id": [
            "int mysql_insert_id([int link_identifier])",
            "Gets the ID generated from the previous INSERT operation"
        ],
        "mysql_list_dbs": [
            "resource mysql_list_dbs([int link_identifier])",
            "List databases available on a MySQL server"
        ],
        "mysql_list_fields": [
            "resource mysql_list_fields(string database_name, string table_name [, int link_identifier])",
            "List MySQL result fields"
        ],
        "mysql_list_processes": [
            "resource mysql_list_processes([int link_identifier])",
            "Returns a result set describing the current server threads"
        ],
        "mysql_list_tables": [
            "resource mysql_list_tables(string database_name [, int link_identifier])",
            "List tables in a MySQL database"
        ],
        "mysql_num_fields": [
            "int mysql_num_fields(resource result)",
            "Gets number of fields in a result"
        ],
        "mysql_num_rows": [
            "int mysql_num_rows(resource result)",
            "Gets number of rows in a result"
        ],
        "mysql_pconnect": [
            "resource mysql_pconnect([string hostname[:port][:/path/to/socket] [, string username [, string password [, int flags]]]])",
            "Opens a persistent connection to a MySQL Server"
        ],
        "mysql_ping": [
            "bool mysql_ping([int link_identifier])",
            "Ping a server connection. If no connection then reconnect."
        ],
        "mysql_query": [
            "resource mysql_query(string query [, int link_identifier])",
            "Sends an SQL query to MySQL"
        ],
        "mysql_real_escape_string": [
            "string mysql_real_escape_string(string to_be_escaped [, int link_identifier])",
            "Escape special characters in a string for use in a SQL statement, taking into account the current charset of the connection"
        ],
        "mysql_result": [
            "mixed mysql_result(resource result, int row [, mixed field])",
            "Gets result data"
        ],
        "mysql_select_db": [
            "bool mysql_select_db(string database_name [, int link_identifier])",
            "Selects a MySQL database"
        ],
        "mysql_set_charset": [
            "bool mysql_set_charset(string csname [, int link_identifier])",
            "sets client character set"
        ],
        "mysql_stat": [
            "string mysql_stat([int link_identifier])",
            "Returns a string containing status information"
        ],
        "mysql_thread_id": [
            "int mysql_thread_id([int link_identifier])",
            "Returns the thread id of current connection"
        ],
        "mysql_unbuffered_query": [
            "resource mysql_unbuffered_query(string query [, int link_identifier])",
            "Sends an SQL query to MySQL, without fetching and buffering the result rows"
        ],
        "mysqli_affected_rows": [
            "mixed mysqli_affected_rows(object link)",
            "Get number of affected rows in previous MySQL operation"
        ],
        "mysqli_autocommit": [
            "bool mysqli_autocommit(object link, bool mode)",
            "Turn auto commit on or of"
        ],
        "mysqli_cache_stats": [
            "array mysqli_cache_stats()",
            "Returns statistics about the zval cache"
        ],
        "mysqli_change_user": [
            "bool mysqli_change_user(object link, string user, string password, string database)",
            "Change logged-in user of the active connection"
        ],
        "mysqli_character_set_name": [
            "string mysqli_character_set_name(object link)",
            "Returns the name of the character set used for this connection"
        ],
        "mysqli_close": [
            "bool mysqli_close(object link)",
            "Close connection"
        ],
        "mysqli_commit": [
            "bool mysqli_commit(object link)",
            "Commit outstanding actions and close transaction"
        ],
        "mysqli_connect": [
            "object mysqli_connect([string hostname [,string username [,string passwd [,string dbname [,int port [,string socket]]]]]])",
            "Open a connection to a mysql server"
        ],
        "mysqli_connect_errno": [
            "int mysqli_connect_errno()",
            "Returns the numerical value of the error message from last connect command"
        ],
        "mysqli_connect_error": [
            "string mysqli_connect_error()",
            "Returns the text of the error message from previous MySQL operation"
        ],
        "mysqli_data_seek": [
            "bool mysqli_data_seek(object result, int offset)",
            "Move internal result pointer"
        ],
        "mysqli_debug": [
            "void mysqli_debug(string debug)",
            ""
        ],
        "mysqli_dump_debug_info": [
            "bool mysqli_dump_debug_info(object link)",
            ""
        ],
        "mysqli_embedded_server_end": [
            "void mysqli_embedded_server_end()",
            ""
        ],
        "mysqli_embedded_server_start": [
            "bool mysqli_embedded_server_start(bool start, array arguments, array groups)",
            "initialize and start embedded server"
        ],
        "mysqli_errno": [
            "int mysqli_errno(object link)",
            "Returns the numerical value of the error message from previous MySQL operation"
        ],
        "mysqli_error": [
            "string mysqli_error(object link)",
            "Returns the text of the error message from previous MySQL operation"
        ],
        "mysqli_fetch_all": [
            "mixed mysqli_fetch_all(object result [,int resulttype])",
            "Fetches all result rows as an associative array, a numeric array, or both"
        ],
        "mysqli_fetch_array": [
            "mixed mysqli_fetch_array(object result [,int resulttype])",
            "Fetch a result row as an associative array, a numeric array, or both"
        ],
        "mysqli_fetch_assoc": [
            "mixed mysqli_fetch_assoc(object result)",
            "Fetch a result row as an associative array"
        ],
        "mysqli_fetch_field": [
            "mixed mysqli_fetch_field(object result)",
            "Get column information from a result and return as an object"
        ],
        "mysqli_fetch_field_direct": [
            "mixed mysqli_fetch_field_direct(object result, int offset)",
            "Fetch meta-data for a single field"
        ],
        "mysqli_fetch_fields": [
            "mixed mysqli_fetch_fields(object result)",
            "Return array of objects containing field meta-data"
        ],
        "mysqli_fetch_lengths": [
            "mixed mysqli_fetch_lengths(object result)",
            "Get the length of each output in a result"
        ],
        "mysqli_fetch_object": [
            "mixed mysqli_fetch_object(object result [, string class_name [, NULL|array ctor_params]])",
            "Fetch a result row as an object"
        ],
        "mysqli_fetch_row": [
            "array mysqli_fetch_row(object result)",
            "Get a result row as an enumerated array"
        ],
        "mysqli_field_count": [
            "int mysqli_field_count(object link)",
            "Fetch the number of fields returned by the last query for the given link"
        ],
        "mysqli_field_seek": [
            "int mysqli_field_seek(object result, int fieldnr)",
            "Set result pointer to a specified field offset"
        ],
        "mysqli_field_tell": [
            "int mysqli_field_tell(object result)",
            "Get current field offset of result pointer"
        ],
        "mysqli_free_result": [
            "void mysqli_free_result(object result)",
            "Free query result memory for the given result handle"
        ],
        "mysqli_get_charset": [
            "object mysqli_get_charset(object link)",
            "returns a character set object"
        ],
        "mysqli_get_client_info": [
            "string mysqli_get_client_info()",
            "Get MySQL client info"
        ],
        "mysqli_get_client_stats": [
            "array mysqli_get_client_stats()",
            "Returns statistics about the zval cache"
        ],
        "mysqli_get_client_version": [
            "int mysqli_get_client_version()",
            "Get MySQL client info"
        ],
        "mysqli_get_connection_stats": [
            "array mysqli_get_connection_stats()",
            "Returns statistics about the zval cache"
        ],
        "mysqli_get_host_info": [
            "string mysqli_get_host_info(object link)",
            "Get MySQL host info"
        ],
        "mysqli_get_proto_info": [
            "int mysqli_get_proto_info(object link)",
            "Get MySQL protocol information"
        ],
        "mysqli_get_server_info": [
            "string mysqli_get_server_info(object link)",
            "Get MySQL server info"
        ],
        "mysqli_get_server_version": [
            "int mysqli_get_server_version(object link)",
            "Return the MySQL version for the server referenced by the given link"
        ],
        "mysqli_get_warnings": [
            "object mysqli_get_warnings(object link)",
            ""
        ],
        "mysqli_info": [
            "string mysqli_info(object link)",
            "Get information about the most recent query"
        ],
        "mysqli_init": [
            "resource mysqli_init()",
            "Initialize mysqli and return a resource for use with mysql_real_connect"
        ],
        "mysqli_insert_id": [
            "mixed mysqli_insert_id(object link)",
            "Get the ID generated from the previous INSERT operation"
        ],
        "mysqli_kill": [
            "bool mysqli_kill(object link, int processid)",
            "Kill a mysql process on the server"
        ],
        "mysqli_link_construct": [
            "object mysqli_link_construct()",
            ""
        ],
        "mysqli_more_results": [
            "bool mysqli_more_results(object link)",
            "check if there any more query results from a multi query"
        ],
        "mysqli_multi_query": [
            "bool mysqli_multi_query(object link, string query)",
            "allows to execute multiple queries"
        ],
        "mysqli_next_result": [
            "bool mysqli_next_result(object link)",
            "read next result from multi_query"
        ],
        "mysqli_num_fields": [
            "int mysqli_num_fields(object result)",
            "Get number of fields in result"
        ],
        "mysqli_num_rows": [
            "mixed mysqli_num_rows(object result)",
            "Get number of rows in result"
        ],
        "mysqli_options": [
            "bool mysqli_options(object link, int flags, mixed values)",
            "Set options"
        ],
        "mysqli_ping": [
            "bool mysqli_ping(object link)",
            "Ping a server connection or reconnect if there is no connection"
        ],
        "mysqli_poll": [
            "int mysqli_poll(array read, array write, array error, long sec [, long usec])",
            "Poll connections"
        ],
        "mysqli_prepare": [
            "mixed mysqli_prepare(object link, string query)",
            "Prepare a SQL statement for execution"
        ],
        "mysqli_query": [
            "mixed mysqli_query(object link, string query [,int resultmode])",
            ""
        ],
        "mysqli_real_connect": [
            "bool mysqli_real_connect(object link [,string hostname [,string username [,string passwd [,string dbname [,int port [,string socket [,int flags]]]]]]])",
            "Open a connection to a mysql server"
        ],
        "mysqli_real_escape_string": [
            "string mysqli_real_escape_string(object link, string escapestr)",
            "Escapes special characters in a string for use in a SQL statement, taking into account the current charset of the connection"
        ],
        "mysqli_real_query": [
            "bool mysqli_real_query(object link, string query)",
            "Binary-safe version of mysql_query()"
        ],
        "mysqli_reap_async_query": [
            "int mysqli_reap_async_query(object link)",
            "Poll connections"
        ],
        "mysqli_refresh": [
            "bool mysqli_refresh(object link, long options)",
            "Flush tables or caches, or reset replication server information"
        ],
        "mysqli_report": [
            "bool mysqli_report(int flags)",
            "sets report level"
        ],
        "mysqli_rollback": [
            "bool mysqli_rollback(object link)",
            "Undo actions from current transaction"
        ],
        "mysqli_select_db": [
            "bool mysqli_select_db(object link, string dbname)",
            "Select a MySQL database"
        ],
        "mysqli_set_charset": [
            "bool mysqli_set_charset(object link, string csname)",
            "sets client character set"
        ],
        "mysqli_set_local_infile_default": [
            "void mysqli_set_local_infile_default(object link)",
            "unsets user defined handler for load local infile command"
        ],
        "mysqli_set_local_infile_handler": [
            "bool mysqli_set_local_infile_handler(object link, callback read_func)",
            "Set callback functions for LOAD DATA LOCAL INFILE"
        ],
        "mysqli_sqlstate": [
            "string mysqli_sqlstate(object link)",
            "Returns the SQLSTATE error from previous MySQL operation"
        ],
        "mysqli_ssl_set": [
            "bool mysqli_ssl_set(object link ,string key ,string cert ,string ca ,string capath ,string cipher])",
            ""
        ],
        "mysqli_stat": [
            "mixed mysqli_stat(object link)",
            "Get current system status"
        ],
        "mysqli_stmt_affected_rows": [
            "mixed mysqli_stmt_affected_rows(object stmt)",
            "Return the number of rows affected in the last query for the given link"
        ],
        "mysqli_stmt_attr_get": [
            "int mysqli_stmt_attr_get(object stmt, long attr)",
            ""
        ],
        "mysqli_stmt_attr_set": [
            "int mysqli_stmt_attr_set(object stmt, long attr, long mode)",
            ""
        ],
        "mysqli_stmt_bind_param": [
            "bool mysqli_stmt_bind_param(object stmt, string types, mixed variable [,mixed,....])",
            "Bind variables to a prepared statement as parameters"
        ],
        "mysqli_stmt_bind_result": [
            "bool mysqli_stmt_bind_result(object stmt, mixed var, [,mixed, ...])",
            "Bind variables to a prepared statement for result storage"
        ],
        "mysqli_stmt_close": [
            "bool mysqli_stmt_close(object stmt)",
            "Close statement"
        ],
        "mysqli_stmt_data_seek": [
            "void mysqli_stmt_data_seek(object stmt, int offset)",
            "Move internal result pointer"
        ],
        "mysqli_stmt_errno": [
            "int mysqli_stmt_errno(object stmt)",
            ""
        ],
        "mysqli_stmt_error": [
            "string mysqli_stmt_error(object stmt)",
            ""
        ],
        "mysqli_stmt_execute": [
            "bool mysqli_stmt_execute(object stmt)",
            "Execute a prepared statement"
        ],
        "mysqli_stmt_fetch": [
            "mixed mysqli_stmt_fetch(object stmt)",
            "Fetch results from a prepared statement into the bound variables"
        ],
        "mysqli_stmt_field_count": [
            "int mysqli_stmt_field_count(object stmt) {",
            "Return the number of result columns for the given statement"
        ],
        "mysqli_stmt_free_result": [
            "void mysqli_stmt_free_result(object stmt)",
            "Free stored result memory for the given statement handle"
        ],
        "mysqli_stmt_get_result": [
            "object mysqli_stmt_get_result(object link)",
            "Buffer result set on client"
        ],
        "mysqli_stmt_get_warnings": [
            "object mysqli_stmt_get_warnings(object link)",
            ""
        ],
        "mysqli_stmt_init": [
            "mixed mysqli_stmt_init(object link)",
            "Initialize statement object"
        ],
        "mysqli_stmt_insert_id": [
            "mixed mysqli_stmt_insert_id(object stmt)",
            "Get the ID generated from the previous INSERT operation"
        ],
        "mysqli_stmt_next_result": [
            "bool mysqli_stmt_next_result(object link)",
            "read next result from multi_query"
        ],
        "mysqli_stmt_num_rows": [
            "mixed mysqli_stmt_num_rows(object stmt)",
            "Return the number of rows in statements result set"
        ],
        "mysqli_stmt_param_count": [
            "int mysqli_stmt_param_count(object stmt)",
            "Return the number of parameter for the given statement"
        ],
        "mysqli_stmt_prepare": [
            "bool mysqli_stmt_prepare(object stmt, string query)",
            "prepare server side statement with query"
        ],
        "mysqli_stmt_reset": [
            "bool mysqli_stmt_reset(object stmt)",
            "reset a prepared statement"
        ],
        "mysqli_stmt_result_metadata": [
            "mixed mysqli_stmt_result_metadata(object stmt)",
            "return result set from statement"
        ],
        "mysqli_stmt_send_long_data": [
            "bool mysqli_stmt_send_long_data(object stmt, int param_nr, string data)",
            ""
        ],
        "mysqli_stmt_sqlstate": [
            "string mysqli_stmt_sqlstate(object stmt)",
            ""
        ],
        "mysqli_stmt_store_result": [
            "bool mysqli_stmt_store_result(stmt)",
            ""
        ],
        "mysqli_store_result": [
            "object mysqli_store_result(object link)",
            "Buffer result set on client"
        ],
        "mysqli_thread_id": [
            "int mysqli_thread_id(object link)",
            "Return the current thread ID"
        ],
        "mysqli_thread_safe": [
            "bool mysqli_thread_safe()",
            "Return whether thread safety is given or not"
        ],
        "mysqli_use_result": [
            "mixed mysqli_use_result(object link)",
            "Directly retrieve query results - do not buffer results on client side"
        ],
        "mysqli_warning_count": [
            "int mysqli_warning_count(object link)",
            "Return number of warnings from the last query for the given link"
        ],
        "natcasesort": [
            "void natcasesort(array &array_arg)",
            "Sort an array using case-insensitive natural sort"
        ],
        "natsort": [
            "void natsort(array &array_arg)",
            "Sort an array using natural sort"
        ],
        "next": [
            "mixed next(array array_arg)",
            "Move array argument's internal pointer to the next element and return it"
        ],
        "ngettext": [
            "string ngettext(string MSGID1, string MSGID2, int N)",
            "Plural version of gettext()"
        ],
        "nl2br": [
            "string nl2br(string str [, bool is_xhtml])",
            "Converts newlines to HTML line breaks"
        ],
        "nl_langinfo": [
            "string nl_langinfo(int item)",
            "Query language and locale information"
        ],
        "normalizer_is_normalize": [
            "bool normalizer_is_normalize( string $input [, string $form = FORM_C] )",
            "* Test if a string is in a given normalization form."
        ],
        "normalizer_normalize": [
            "string normalizer_normalize( string $input [, string $form = FORM_C] )",
            "* Normalize a string."
        ],
        "nsapi_request_headers": [
            "array nsapi_request_headers()",
            "Get all headers from the request"
        ],
        "nsapi_response_headers": [
            "array nsapi_response_headers()",
            "Get all headers from the response"
        ],
        "nsapi_virtual": [
            "bool nsapi_virtual(string uri)",
            "Perform an NSAPI sub-request"
        ],
        "number_format": [
            "string number_format(float number [, int num_decimal_places [, string dec_seperator, string thousands_seperator]])",
            "Formats a number with grouped thousands"
        ],
        "numfmt_create": [
            "NumberFormatter numfmt_create( string $locale, int style[, string $pattern ] )",
            "* Create number formatter."
        ],
        "numfmt_format": [
            "mixed numfmt_format( NumberFormatter $nf, mixed $num[, int type] )",
            "* Format a number."
        ],
        "numfmt_format_currency": [
            "mixed numfmt_format_currency( NumberFormatter $nf, double $num, string $currency )",
            "* Format a number as currency."
        ],
        "numfmt_get_attribute": [
            "mixed numfmt_get_attribute( NumberFormatter $nf, int $attr )",
            "* Get formatter attribute value."
        ],
        "numfmt_get_error_code": [
            "int numfmt_get_error_code( NumberFormatter $nf )",
            "* Get formatter's last error code."
        ],
        "numfmt_get_error_message": [
            "string numfmt_get_error_message( NumberFormatter $nf )",
            "* Get text description for formatter's last error code."
        ],
        "numfmt_get_locale": [
            "string numfmt_get_locale( NumberFormatter $nf[, int type] )",
            "* Get formatter locale."
        ],
        "numfmt_get_pattern": [
            "string numfmt_get_pattern( NumberFormatter $nf )",
            "* Get formatter pattern."
        ],
        "numfmt_get_symbol": [
            "string numfmt_get_symbol( NumberFormatter $nf, int $attr )",
            "* Get formatter symbol value."
        ],
        "numfmt_get_text_attribute": [
            "string numfmt_get_text_attribute( NumberFormatter $nf, int $attr )",
            "* Get formatter attribute value."
        ],
        "numfmt_parse": [
            "mixed numfmt_parse( NumberFormatter $nf, string $str[, int $type, int &$position ])",
            "* Parse a number."
        ],
        "numfmt_parse_currency": [
            "double numfmt_parse_currency( NumberFormatter $nf, string $str, string $&currency[, int $&position] )",
            "* Parse a number as currency."
        ],
        "numfmt_parse_message": [
            "array numfmt_parse_message( string $locale, string $pattern, string $source )",
            "* Parse a message."
        ],
        "numfmt_set_attribute": [
            "bool numfmt_set_attribute( NumberFormatter $nf, int $attr, mixed $value )",
            "* Get formatter attribute value."
        ],
        "numfmt_set_pattern": [
            "bool numfmt_set_pattern( NumberFormatter $nf, string $pattern )",
            "* Set formatter pattern."
        ],
        "numfmt_set_symbol": [
            "bool numfmt_set_symbol( NumberFormatter $nf, int $attr, string $symbol )",
            "* Set formatter symbol value."
        ],
        "numfmt_set_text_attribute": [
            "bool numfmt_set_text_attribute( NumberFormatter $nf, int $attr, string $value )",
            "* Get formatter attribute value."
        ],
        "ob_clean": [
            "bool ob_clean()",
            "Clean (delete) the current output buffer"
        ],
        "ob_end_clean": [
            "bool ob_end_clean()",
            "Clean the output buffer, and delete current output buffer"
        ],
        "ob_end_flush": [
            "bool ob_end_flush()",
            "Flush (send) the output buffer, and delete current output buffer"
        ],
        "ob_flush": [
            "bool ob_flush()",
            "Flush (send) contents of the output buffer. The last buffer content is sent to next buffer"
        ],
        "ob_get_clean": [
            "bool ob_get_clean()",
            "Get current buffer contents and delete current output buffer"
        ],
        "ob_get_contents": [
            "string ob_get_contents()",
            "Return the contents of the output buffer"
        ],
        "ob_get_flush": [
            "bool ob_get_flush()",
            "Get current buffer contents, flush (send) the output buffer, and delete current output buffer"
        ],
        "ob_get_length": [
            "int ob_get_length()",
            "Return the length of the output buffer"
        ],
        "ob_get_level": [
            "int ob_get_level()",
            "Return the nesting level of the output buffer"
        ],
        "ob_get_status": [
            "false|array ob_get_status([bool full_status])",
            "Return the status of the active or all output buffers"
        ],
        "ob_gzhandler": [
            "string ob_gzhandler(string str, int mode)",
            "Encode str based on accept-encoding setting - designed to be called from ob_start()"
        ],
        "ob_iconv_handler": [
            "string ob_iconv_handler(string contents, int status)",
            "Returns str in output buffer converted to the iconv.output_encoding character set"
        ],
        "ob_implicit_flush": [
            "void ob_implicit_flush([int flag])",
            "Turn implicit flush on/off and is equivalent to calling flush() after every output call"
        ],
        "ob_list_handlers": [
            "false|array ob_list_handlers()",
            "*  List all output_buffers in an array"
        ],
        "ob_start": [
            "bool ob_start([ string|array user_function [, int chunk_size [, bool erase]]])",
            "Turn on Output Buffering (specifying an optional output handler)."
        ],
        "oci_bind_array_by_name": [
            "bool oci_bind_array_by_name(resource stmt, string name, array &var, int max_table_length [, int max_item_length [, int type ]])",
            "Bind a PHP array to an Oracle PL/SQL type by name"
        ],
        "oci_bind_by_name": [
            "bool oci_bind_by_name(resource stmt, string name, mixed &var, [, int maxlength [, int type]])",
            "Bind a PHP variable to an Oracle placeholder by name"
        ],
        "oci_cancel": [
            "bool oci_cancel(resource stmt)",
            "Cancel reading from a cursor"
        ],
        "oci_close": [
            "bool oci_close(resource connection)",
            "Disconnect from database"
        ],
        "oci_collection_append": [
            "bool oci_collection_append(string value)",
            "Append an object to the collection"
        ],
        "oci_collection_assign": [
            "bool oci_collection_assign(object from)",
            "Assign a collection from another existing collection"
        ],
        "oci_collection_element_assign": [
            "bool oci_collection_element_assign(int index, string val)",
            "Assign element val to collection at index ndx"
        ],
        "oci_collection_element_get": [
            "string oci_collection_element_get(int ndx)",
            "Retrieve the value at collection index ndx"
        ],
        "oci_collection_max": [
            "int oci_collection_max()",
            "Return the max value of a collection. For a varray this is the maximum length of the array"
        ],
        "oci_collection_size": [
            "int oci_collection_size()",
            "Return the size of a collection"
        ],
        "oci_collection_trim": [
            "bool oci_collection_trim(int num)",
            "Trim num elements from the end of a collection"
        ],
        "oci_commit": [
            "bool oci_commit(resource connection)",
            "Commit the current context"
        ],
        "oci_connect": [
            "resource oci_connect(string user, string pass [, string db [, string charset [, int session_mode ]])",
            "Connect to an Oracle database and log on. Returns a new session."
        ],
        "oci_define_by_name": [
            "bool oci_define_by_name(resource stmt, string name, mixed &var [, int type])",
            "Define a PHP variable to an Oracle column by name"
        ],
        "oci_error": [
            "array oci_error([resource stmt|connection|global])",
            "Return the last error of stmt|connection|global. If no error happened returns false."
        ],
        "oci_execute": [
            "bool oci_execute(resource stmt [, int mode])",
            "Execute a parsed statement"
        ],
        "oci_fetch": [
            "bool oci_fetch(resource stmt)",
            "Prepare a new row of data for reading"
        ],
        "oci_fetch_all": [
            "int oci_fetch_all(resource stmt, array &output[, int skip[, int maxrows[, int flags]]])",
            "Fetch all rows of result data into an array"
        ],
        "oci_fetch_array": [
            "array oci_fetch_array( resource stmt [, int mode ])",
            "Fetch a result row as an array"
        ],
        "oci_fetch_assoc": [
            "array oci_fetch_assoc( resource stmt )",
            "Fetch a result row as an associative array"
        ],
        "oci_fetch_object": [
            "object oci_fetch_object( resource stmt )",
            "Fetch a result row as an object"
        ],
        "oci_fetch_row": [
            "array oci_fetch_row( resource stmt )",
            "Fetch a result row as an enumerated array"
        ],
        "oci_field_is_null": [
            "bool oci_field_is_null(resource stmt, int col)",
            "Tell whether a column is NULL"
        ],
        "oci_field_name": [
            "string oci_field_name(resource stmt, int col)",
            "Tell the name of a column"
        ],
        "oci_field_precision": [
            "int oci_field_precision(resource stmt, int col)",
            "Tell the precision of a column"
        ],
        "oci_field_scale": [
            "int oci_field_scale(resource stmt, int col)",
            "Tell the scale of a column"
        ],
        "oci_field_size": [
            "int oci_field_size(resource stmt, int col)",
            "Tell the maximum data size of a column"
        ],
        "oci_field_type": [
            "mixed oci_field_type(resource stmt, int col)",
            "Tell the data type of a column"
        ],
        "oci_field_type_raw": [
            "int oci_field_type_raw(resource stmt, int col)",
            "Tell the raw oracle data type of a column"
        ],
        "oci_free_collection": [
            "bool oci_free_collection()",
            "Deletes collection object"
        ],
        "oci_free_descriptor": [
            "bool oci_free_descriptor()",
            "Deletes large object description"
        ],
        "oci_free_statement": [
            "bool oci_free_statement(resource stmt)",
            "Free all resources associated with a statement"
        ],
        "oci_internal_debug": [
            "void oci_internal_debug(int onoff)",
            "Toggle internal debugging output for the OCI extension"
        ],
        "oci_lob_append": [
            "bool oci_lob_append( object lob )",
            "Appends data from a LOB to another LOB"
        ],
        "oci_lob_close": [
            "bool oci_lob_close()",
            "Closes lob descriptor"
        ],
        "oci_lob_copy": [
            "bool oci_lob_copy( object lob_to, object lob_from [, int length ] )",
            "Copies data from a LOB to another LOB"
        ],
        "oci_lob_eof": [
            "bool oci_lob_eof()",
            "Checks if EOF is reached"
        ],
        "oci_lob_erase": [
            "int oci_lob_erase( [ int offset [, int length ] ] )",
            "Erases a specified portion of the internal LOB, starting at a specified offset"
        ],
        "oci_lob_export": [
            "bool oci_lob_export([string filename [, int start [, int length]]])",
            "Writes a large object into a file"
        ],
        "oci_lob_flush": [
            "bool oci_lob_flush( [ int flag ] )",
            "Flushes the LOB buffer"
        ],
        "oci_lob_import": [
            "bool oci_lob_import( string filename )",
            "Loads file into a LOB"
        ],
        "oci_lob_is_equal": [
            "bool oci_lob_is_equal( object lob1, object lob2 )",
            "Tests to see if two LOB/FILE locators are equal"
        ],
        "oci_lob_load": [
            "string oci_lob_load()",
            "Loads a large object"
        ],
        "oci_lob_read": [
            "string oci_lob_read( int length )",
            "Reads particular part of a large object"
        ],
        "oci_lob_rewind": [
            "bool oci_lob_rewind()",
            "Rewind pointer of a LOB"
        ],
        "oci_lob_save": [
            "bool oci_lob_save( string data [, int offset ])",
            "Saves a large object"
        ],
        "oci_lob_seek": [
            "bool oci_lob_seek( int offset [, int whence ])",
            "Moves the pointer of a LOB"
        ],
        "oci_lob_size": [
            "int oci_lob_size()",
            "Returns size of a large object"
        ],
        "oci_lob_tell": [
            "int oci_lob_tell()",
            "Tells LOB pointer position"
        ],
        "oci_lob_truncate": [
            "bool oci_lob_truncate( [ int length ])",
            "Truncates a LOB"
        ],
        "oci_lob_write": [
            "int oci_lob_write( string string [, int length ])",
            "Writes data to current position of a LOB"
        ],
        "oci_lob_write_temporary": [
            "bool oci_lob_write_temporary(string var [, int lob_type])",
            "Writes temporary blob"
        ],
        "oci_new_collection": [
            "object oci_new_collection(resource connection, string tdo [, string schema])",
            "Initialize a new collection"
        ],
        "oci_new_connect": [
            "resource oci_new_connect(string user, string pass [, string db])",
            "Connect to an Oracle database and log on. Returns a new session."
        ],
        "oci_new_cursor": [
            "resource oci_new_cursor(resource connection)",
            "Return a new cursor (Statement-Handle) - use this to bind ref-cursors!"
        ],
        "oci_new_descriptor": [
            "object oci_new_descriptor(resource connection [, int type])",
            "Initialize a new empty descriptor LOB/FILE (LOB is default)"
        ],
        "oci_num_fields": [
            "int oci_num_fields(resource stmt)",
            "Return the number of result columns in a statement"
        ],
        "oci_num_rows": [
            "int oci_num_rows(resource stmt)",
            "Return the row count of an OCI statement"
        ],
        "oci_parse": [
            "resource oci_parse(resource connection, string query)",
            "Parse a query and return a statement"
        ],
        "oci_password_change": [
            "bool oci_password_change(resource connection, string username, string old_password, string new_password)",
            "Changes the password of an account"
        ],
        "oci_pconnect": [
            "resource oci_pconnect(string user, string pass [, string db [, string charset ]])",
            "Connect to an Oracle database using a persistent connection and log on. Returns a new session."
        ],
        "oci_result": [
            "string oci_result(resource stmt, mixed column)",
            "Return a single column of result data"
        ],
        "oci_rollback": [
            "bool oci_rollback(resource connection)",
            "Rollback the current context"
        ],
        "oci_server_version": [
            "string oci_server_version(resource connection)",
            "Return a string containing server version information"
        ],
        "oci_set_action": [
            "bool oci_set_action(resource connection, string value)",
            "Sets the action attribute on the connection"
        ],
        "oci_set_client_identifier": [
            "bool oci_set_client_identifier(resource connection, string value)",
            "Sets the client identifier attribute on the connection"
        ],
        "oci_set_client_info": [
            "bool oci_set_client_info(resource connection, string value)",
            "Sets the client info attribute on the connection"
        ],
        "oci_set_edition": [
            "bool oci_set_edition(string value)",
            "Sets the edition attribute for all subsequent connections created"
        ],
        "oci_set_module_name": [
            "bool oci_set_module_name(resource connection, string value)",
            "Sets the module attribute on the connection"
        ],
        "oci_set_prefetch": [
            "bool oci_set_prefetch(resource stmt, int prefetch_rows)",
            "Sets the number of rows to be prefetched on execute to prefetch_rows for stmt"
        ],
        "oci_statement_type": [
            "string oci_statement_type(resource stmt)",
            "Return the query type of an OCI statement"
        ],
        "ocifetchinto": [
            "int ocifetchinto(resource stmt, array &output [, int mode])",
            "Fetch a row of result data into an array"
        ],
        "ocigetbufferinglob": [
            "bool ocigetbufferinglob()",
            "Returns current state of buffering for a LOB"
        ],
        "ocisetbufferinglob": [
            "bool ocisetbufferinglob( bool flag )",
            "Enables/disables buffering for a LOB"
        ],
        "octdec": [
            "int octdec(string octal_number)",
            "Returns the decimal equivalent of an octal string"
        ],
        "odbc_autocommit": [
            "mixed odbc_autocommit(resource connection_id [, int OnOff])",
            "Toggle autocommit mode or get status"
        ],
        "odbc_binmode": [
            "bool odbc_binmode(int result_id, int mode)",
            "Handle binary column data"
        ],
        "odbc_close": [
            "void odbc_close(resource connection_id)",
            "Close an ODBC connection"
        ],
        "odbc_close_all": [
            "void odbc_close_all()",
            "Close all ODBC connections"
        ],
        "odbc_columnprivileges": [
            "resource odbc_columnprivileges(resource connection_id, string catalog, string schema, string table, string column)",
            "Returns a result identifier that can be used to fetch a list of columns and associated privileges for the specified table"
        ],
        "odbc_columns": [
            "resource odbc_columns(resource connection_id [, string qualifier [, string owner [, string table_name [, string column_name]]]])",
            "Returns a result identifier that can be used to fetch a list of column names in specified tables"
        ],
        "odbc_commit": [
            "bool odbc_commit(resource connection_id)",
            "Commit an ODBC transaction"
        ],
        "odbc_connect": [
            "resource odbc_connect(string DSN, string user, string password [, int cursor_option])",
            "Connect to a datasource"
        ],
        "odbc_cursor": [
            "string odbc_cursor(resource result_id)",
            "Get cursor name"
        ],
        "odbc_data_source": [
            "array odbc_data_source(resource connection_id, int fetch_type)",
            "Return information about the currently connected data source"
        ],
        "odbc_error": [
            "string odbc_error([resource connection_id])",
            "Get the last error code"
        ],
        "odbc_errormsg": [
            "string odbc_errormsg([resource connection_id])",
            "Get the last error message"
        ],
        "odbc_exec": [
            "resource odbc_exec(resource connection_id, string query [, int flags])",
            "Prepare and execute an SQL statement"
        ],
        "odbc_execute": [
            "bool odbc_execute(resource result_id [, array parameters_array])",
            "Execute a prepared statement"
        ],
        "odbc_fetch_array": [
            "array odbc_fetch_array(int result [, int rownumber])",
            "Fetch a result row as an associative array"
        ],
        "odbc_fetch_into": [
            "int odbc_fetch_into(resource result_id, array &result_array, [, int rownumber])",
            "Fetch one result row into an array"
        ],
        "odbc_fetch_object": [
            "object odbc_fetch_object(int result [, int rownumber])",
            "Fetch a result row as an object"
        ],
        "odbc_fetch_row": [
            "bool odbc_fetch_row(resource result_id [, int row_number])",
            "Fetch a row"
        ],
        "odbc_field_len": [
            "int odbc_field_len(resource result_id, int field_number)",
            "Get the length (precision) of a column"
        ],
        "odbc_field_name": [
            "string odbc_field_name(resource result_id, int field_number)",
            "Get a column name"
        ],
        "odbc_field_num": [
            "int odbc_field_num(resource result_id, string field_name)",
            "Return column number"
        ],
        "odbc_field_scale": [
            "int odbc_field_scale(resource result_id, int field_number)",
            "Get the scale of a column"
        ],
        "odbc_field_type": [
            "string odbc_field_type(resource result_id, int field_number)",
            "Get the datatype of a column"
        ],
        "odbc_foreignkeys": [
            "resource odbc_foreignkeys(resource connection_id, string pk_qualifier, string pk_owner, string pk_table, string fk_qualifier, string fk_owner, string fk_table)",
            "Returns a result identifier to either a list of foreign keys in the specified table or a list of foreign keys in other tables that refer to the primary key in the specified table"
        ],
        "odbc_free_result": [
            "bool odbc_free_result(resource result_id)",
            "Free resources associated with a result"
        ],
        "odbc_gettypeinfo": [
            "resource odbc_gettypeinfo(resource connection_id [, int data_type])",
            "Returns a result identifier containing information about data types supported by the data source"
        ],
        "odbc_longreadlen": [
            "bool odbc_longreadlen(int result_id, int length)",
            "Handle LONG columns"
        ],
        "odbc_next_result": [
            "bool odbc_next_result(resource result_id)",
            "Checks if multiple results are avaiable"
        ],
        "odbc_num_fields": [
            "int odbc_num_fields(resource result_id)",
            "Get number of columns in a result"
        ],
        "odbc_num_rows": [
            "int odbc_num_rows(resource result_id)",
            "Get number of rows in a result"
        ],
        "odbc_pconnect": [
            "resource odbc_pconnect(string DSN, string user, string password [, int cursor_option])",
            "Establish a persistent connection to a datasource"
        ],
        "odbc_prepare": [
            "resource odbc_prepare(resource connection_id, string query)",
            "Prepares a statement for execution"
        ],
        "odbc_primarykeys": [
            "resource odbc_primarykeys(resource connection_id, string qualifier, string owner, string table)",
            "Returns a result identifier listing the column names that comprise the primary key for a table"
        ],
        "odbc_procedurecolumns": [
            "resource odbc_procedurecolumns(resource connection_id [, string qualifier, string owner, string proc, string column])",
            "Returns a result identifier containing the list of input and output parameters, as well as the columns that make up the result set for the specified procedures"
        ],
        "odbc_procedures": [
            "resource odbc_procedures(resource connection_id [, string qualifier, string owner, string name])",
            "Returns a result identifier containg the list of procedure names in a datasource"
        ],
        "odbc_result": [
            "mixed odbc_result(resource result_id, mixed field)",
            "Get result data"
        ],
        "odbc_result_all": [
            "int odbc_result_all(resource result_id [, string format])",
            "Print result as HTML table"
        ],
        "odbc_rollback": [
            "bool odbc_rollback(resource connection_id)",
            "Rollback a transaction"
        ],
        "odbc_setoption": [
            "bool odbc_setoption(resource conn_id|result_id, int which, int option, int value)",
            "Sets connection or statement options"
        ],
        "odbc_specialcolumns": [
            "resource odbc_specialcolumns(resource connection_id, int type, string qualifier, string owner, string table, int scope, int nullable)",
            "Returns a result identifier containing either the optimal set of columns that uniquely identifies a row in the table or columns that are automatically updated when any value in the row is updated by a transaction"
        ],
        "odbc_statistics": [
            "resource odbc_statistics(resource connection_id, string qualifier, string owner, string name, int unique, int accuracy)",
            "Returns a result identifier that contains statistics about a single table and the indexes associated with the table"
        ],
        "odbc_tableprivileges": [
            "resource odbc_tableprivileges(resource connection_id, string qualifier, string owner, string name)",
            "Returns a result identifier containing a list of tables and the privileges associated with each table"
        ],
        "odbc_tables": [
            "resource odbc_tables(resource connection_id [, string qualifier [, string owner [, string name [, string table_types]]]])",
            "Call the SQLTables function"
        ],
        "opendir": [
            "mixed opendir(string path[, resource context])",
            "Open a directory and return a dir_handle"
        ],
        "openlog": [
            "bool openlog(string ident, int option, int facility)",
            "Open connection to system logger"
        ],
        "openssl_csr_export": [
            "bool openssl_csr_export(resource csr, string &out [, bool notext=true])",
            "Exports a CSR to file or a var"
        ],
        "openssl_csr_export_to_file": [
            "bool openssl_csr_export_to_file(resource csr, string outfilename [, bool notext=true])",
            "Exports a CSR to file"
        ],
        "openssl_csr_get_public_key": [
            "mixed openssl_csr_get_public_key(mixed csr)",
            "Returns the subject of a CERT or FALSE on error"
        ],
        "openssl_csr_get_subject": [
            "mixed openssl_csr_get_subject(mixed csr)",
            "Returns the subject of a CERT or FALSE on error"
        ],
        "openssl_csr_new": [
            "bool openssl_csr_new(array dn, resource &privkey [, array configargs [, array extraattribs]])",
            "Generates a privkey and CSR"
        ],
        "openssl_csr_sign": [
            "resource openssl_csr_sign(mixed csr, mixed x509, mixed priv_key, long days [, array config_args [, long serial]])",
            "Signs a cert with another CERT"
        ],
        "openssl_decrypt": [
            "string openssl_decrypt(string data, string method, string password [, bool raw_input=false])",
            "Takes raw or base64 encoded string and dectupt it using given method and key"
        ],
        "openssl_dh_compute_key": [
            "string openssl_dh_compute_key(string pub_key, resource dh_key)",
            "Computes shared sicret for public value of remote DH key and local DH key"
        ],
        "openssl_digest": [
            "string openssl_digest(string data, string method [, bool raw_output=false])",
            "Computes digest hash value for given data using given method, returns raw or binhex encoded string"
        ],
        "openssl_encrypt": [
            "string openssl_encrypt(string data, string method, string password [, bool raw_output=false])",
            "Encrypts given data with given method and key, returns raw or base64 encoded string"
        ],
        "openssl_error_string": [
            "mixed openssl_error_string()",
            "Returns a description of the last error, and alters the index of the error messages. Returns false when the are no more messages"
        ],
        "openssl_get_cipher_methods": [
            "array openssl_get_cipher_methods([bool aliases = false])",
            "Return array of available cipher methods"
        ],
        "openssl_get_md_methods": [
            "array openssl_get_md_methods([bool aliases = false])",
            "Return array of available digest methods"
        ],
        "openssl_open": [
            "bool openssl_open(string data, &string opendata, string ekey, mixed privkey)",
            "Opens data"
        ],
        "openssl_pkcs12_export": [
            "bool openssl_pkcs12_export(mixed x509, string &out, mixed priv_key, string pass[, array args])",
            "Creates and exports a PKCS12 to a var"
        ],
        "openssl_pkcs12_export_to_file": [
            "bool openssl_pkcs12_export_to_file(mixed x509, string filename, mixed priv_key, string pass[, array args])",
            "Creates and exports a PKCS to file"
        ],
        "openssl_pkcs12_read": [
            "bool openssl_pkcs12_read(string PKCS12, array &certs, string pass)",
            "Parses a PKCS12 to an array"
        ],
        "openssl_pkcs7_decrypt": [
            "bool openssl_pkcs7_decrypt(string infilename, string outfilename, mixed recipcert [, mixed recipkey])",
            "Decrypts the S/MIME message in the file name infilename and output the results to the file name outfilename.  recipcert is a CERT for one of the recipients. recipkey specifies the private key matching recipcert, if recipcert does not include the key"
        ],
        "openssl_pkcs7_encrypt": [
            "bool openssl_pkcs7_encrypt(string infile, string outfile, mixed recipcerts, array headers [, long flags [, long cipher]])",
            "Encrypts the message in the file named infile with the certificates in recipcerts and output the result to the file named outfile"
        ],
        "openssl_pkcs7_sign": [
            "bool openssl_pkcs7_sign(string infile, string outfile, mixed signcert, mixed signkey, array headers [, long flags [, string extracertsfilename]])",
            "Signs the MIME message in the file named infile with signcert/signkey and output the result to file name outfile. headers lists plain text headers to exclude from the signed portion of the message, and should include to, from and subject as a minimum"
        ],
        "openssl_pkcs7_verify": [
            "bool openssl_pkcs7_verify(string filename, long flags [, string signerscerts [, array cainfo [, string extracerts [, string content]]]])",
            "Verifys that the data block is intact, the signer is who they say they are, and returns the CERTs of the signers"
        ],
        "openssl_pkey_export": [
            "bool openssl_pkey_export(mixed key, &mixed out [, string passphrase [, array config_args]])",
            "Gets an exportable representation of a key into a string or file"
        ],
        "openssl_pkey_export_to_file": [
            "bool openssl_pkey_export_to_file(mixed key, string outfilename [, string passphrase, array config_args)",
            "Gets an exportable representation of a key into a file"
        ],
        "openssl_pkey_free": [
            "void openssl_pkey_free(int key)",
            "Frees a key"
        ],
        "openssl_pkey_get_details": [
            "resource openssl_pkey_get_details(resource key)",
            "returns an array with the key details (bits, pkey, type)"
        ],
        "openssl_pkey_get_private": [
            "int openssl_pkey_get_private(string key [, string passphrase])",
            "Gets private keys"
        ],
        "openssl_pkey_get_public": [
            "int openssl_pkey_get_public(mixed cert)",
            "Gets public key from X.509 certificate"
        ],
        "openssl_pkey_new": [
            "resource openssl_pkey_new([array configargs])",
            "Generates a new private key"
        ],
        "openssl_private_decrypt": [
            "bool openssl_private_decrypt(string data, string &decrypted, mixed key [, int padding])",
            "Decrypts data with private key"
        ],
        "openssl_private_encrypt": [
            "bool openssl_private_encrypt(string data, string &crypted, mixed key [, int padding])",
            "Encrypts data with private key"
        ],
        "openssl_public_decrypt": [
            "bool openssl_public_decrypt(string data, string &crypted, resource key [, int padding])",
            "Decrypts data with public key"
        ],
        "openssl_public_encrypt": [
            "bool openssl_public_encrypt(string data, string &crypted, mixed key [, int padding])",
            "Encrypts data with public key"
        ],
        "openssl_random_pseudo_bytes": [
            "string openssl_random_pseudo_bytes(integer length [, &bool returned_strong_result])",
            "Returns a string of the length specified filled with random pseudo bytes"
        ],
        "openssl_seal": [
            "int openssl_seal(string data, &string sealdata, &array ekeys, array pubkeys)",
            "Seals data"
        ],
        "openssl_sign": [
            "bool openssl_sign(string data, &string signature, mixed key[, mixed method])",
            "Signs data"
        ],
        "openssl_verify": [
            "int openssl_verify(string data, string signature, mixed key[, mixed method])",
            "Verifys data"
        ],
        "openssl_x509_check_private_key": [
            "bool openssl_x509_check_private_key(mixed cert, mixed key)",
            "Checks if a private key corresponds to a CERT"
        ],
        "openssl_x509_checkpurpose": [
            "int openssl_x509_checkpurpose(mixed x509cert, int purpose, array cainfo [, string untrustedfile])",
            "Checks the CERT to see if it can be used for the purpose in purpose. cainfo holds information about trusted CAs"
        ],
        "openssl_x509_export": [
            "bool openssl_x509_export(mixed x509, string &out [, bool notext = true])",
            "Exports a CERT to file or a var"
        ],
        "openssl_x509_export_to_file": [
            "bool openssl_x509_export_to_file(mixed x509, string outfilename [, bool notext = true])",
            "Exports a CERT to file or a var"
        ],
        "openssl_x509_free": [
            "void openssl_x509_free(resource x509)",
            "Frees X.509 certificates"
        ],
        "openssl_x509_parse": [
            "array openssl_x509_parse(mixed x509 [, bool shortnames=true])",
            "Returns an array of the fields/values of the CERT"
        ],
        "openssl_x509_read": [
            "resource openssl_x509_read(mixed cert)",
            "Reads X.509 certificates"
        ],
        "ord": [
            "int ord(string character)",
            "Returns ASCII value of character"
        ],
        "output_add_rewrite_var": [
            "bool output_add_rewrite_var(string name, string value)",
            "Add URL rewriter values"
        ],
        "output_reset_rewrite_vars": [
            "bool output_reset_rewrite_vars()",
            "Reset(clear) URL rewriter values"
        ],
        "pack": [
            "string pack(string format, mixed arg1 [, mixed arg2 [, mixed ...]])",
            "Takes one or more arguments and packs them into a binary string according to the format argument"
        ],
        "parse_ini_file": [
            "array parse_ini_file(string filename [, bool process_sections [, int scanner_mode]])",
            "Parse configuration file"
        ],
        "parse_ini_string": [
            "array parse_ini_string(string ini_string [, bool process_sections [, int scanner_mode]])",
            "Parse configuration string"
        ],
        "parse_locale": [
            "static array parse_locale($locale)",
            "* parses a locale-id into an array the different parts of it"
        ],
        "parse_str": [
            "void parse_str(string encoded_string [, array result])",
            "Parses GET/POST/COOKIE data and sets global variables"
        ],
        "parse_url": [
            "mixed parse_url(string url, [int url_component])",
            "Parse a URL and return its components"
        ],
        "passthru": [
            "void passthru(string command [, int &return_value])",
            "Execute an external program and display raw output"
        ],
        "pathinfo": [
            "array pathinfo(string path[, int options])",
            "Returns information about a certain string"
        ],
        "pclose": [
            "int pclose(resource fp)",
            "Close a file pointer opened by popen()"
        ],
        "pcnlt_sigwaitinfo": [
            "int pcnlt_sigwaitinfo(array set[, array &siginfo])",
            "Synchronously wait for queued signals"
        ],
        "pcntl_alarm": [
            "int pcntl_alarm(int seconds)",
            "Set an alarm clock for delivery of a signal"
        ],
        "pcntl_exec": [
            "bool pcntl_exec(string path [, array args [, array envs]])",
            "Executes specified program in current process space as defined by exec(2)"
        ],
        "pcntl_fork": [
            "int pcntl_fork()",
            "Forks the currently running process following the same behavior as the UNIX fork() system call"
        ],
        "pcntl_getpriority": [
            "int pcntl_getpriority([int pid [, int process_identifier]])",
            "Get the priority of any process"
        ],
        "pcntl_setpriority": [
            "bool pcntl_setpriority(int priority [, int pid [, int process_identifier]])",
            "Change the priority of any process"
        ],
        "pcntl_signal": [
            "bool pcntl_signal(int signo, callback handle [, bool restart_syscalls])",
            "Assigns a system signal handler to a PHP function"
        ],
        "pcntl_signal_dispatch": [
            "bool pcntl_signal_dispatch()",
            "Dispatch signals to signal handlers"
        ],
        "pcntl_sigprocmask": [
            "bool pcntl_sigprocmask(int how, array set[, array &oldset])",
            "Examine and change blocked signals"
        ],
        "pcntl_sigtimedwait": [
            "int pcntl_sigtimedwait(array set[, array &siginfo[, int seconds[, int nanoseconds]]])",
            "Wait for queued signals"
        ],
        "pcntl_wait": [
            "int pcntl_wait(int &status)",
            "Waits on or returns the status of a forked child as defined by the waitpid() system call"
        ],
        "pcntl_waitpid": [
            "int pcntl_waitpid(int pid, int &status, int options)",
            "Waits on or returns the status of a forked child as defined by the waitpid() system call"
        ],
        "pcntl_wexitstatus": [
            "int pcntl_wexitstatus(int status)",
            "Returns the status code of a child's exit"
        ],
        "pcntl_wifexited": [
            "bool pcntl_wifexited(int status)",
            "Returns true if the child status code represents a successful exit"
        ],
        "pcntl_wifsignaled": [
            "bool pcntl_wifsignaled(int status)",
            "Returns true if the child status code represents a process that was terminated due to a signal"
        ],
        "pcntl_wifstopped": [
            "bool pcntl_wifstopped(int status)",
            "Returns true if the child status code represents a stopped process (WUNTRACED must have been used with waitpid)"
        ],
        "pcntl_wstopsig": [
            "int pcntl_wstopsig(int status)",
            "Returns the number of the signal that caused the process to stop who's status code is passed"
        ],
        "pcntl_wtermsig": [
            "int pcntl_wtermsig(int status)",
            "Returns the number of the signal that terminated the process who's status code is passed"
        ],
        "pdo_drivers": [
            "array pdo_drivers()",
            "Return array of available PDO drivers"
        ],
        "pfsockopen": [
            "resource pfsockopen(string hostname, int port [, int errno [, string errstr [, float timeout]]])",
            "Open persistent Internet or Unix domain socket connection"
        ],
        "pg_affected_rows": [
            "int pg_affected_rows(resource result)",
            "Returns the number of affected tuples"
        ],
        "pg_cancel_query": [
            "bool pg_cancel_query(resource connection)",
            "Cancel request"
        ],
        "pg_client_encoding": [
            "string pg_client_encoding([resource connection])",
            "Get the current client encoding"
        ],
        "pg_close": [
            "bool pg_close([resource connection])",
            "Close a PostgreSQL connection"
        ],
        "pg_connect": [
            "resource pg_connect(string connection_string[, int connect_type] | [string host, string port [, string options [, string tty,]]] string database)",
            "Open a PostgreSQL connection"
        ],
        "pg_connection_busy": [
            "bool pg_connection_busy(resource connection)",
            "Get connection is busy or not"
        ],
        "pg_connection_reset": [
            "bool pg_connection_reset(resource connection)",
            "Reset connection (reconnect)"
        ],
        "pg_connection_status": [
            "int pg_connection_status(resource connnection)",
            "Get connection status"
        ],
        "pg_convert": [
            "array pg_convert(resource db, string table, array values[, int options])",
            "Check and convert values for PostgreSQL SQL statement"
        ],
        "pg_copy_from": [
            "bool pg_copy_from(resource connection, string table_name , array rows [, string delimiter [, string null_as]])",
            "Copy table from array"
        ],
        "pg_copy_to": [
            "array pg_copy_to(resource connection, string table_name [, string delimiter [, string null_as]])",
            "Copy table to array"
        ],
        "pg_dbname": [
            "string pg_dbname([resource connection])",
            "Get the database name"
        ],
        "pg_delete": [
            "mixed pg_delete(resource db, string table, array ids[, int options])",
            "Delete records has ids (id => value)"
        ],
        "pg_end_copy": [
            "bool pg_end_copy([resource connection])",
            "Sync with backend. Completes the Copy command"
        ],
        "pg_escape_bytea": [
            "string pg_escape_bytea([resource connection,] string data)",
            "Escape binary for bytea type"
        ],
        "pg_escape_string": [
            "string pg_escape_string([resource connection,] string data)",
            "Escape string for text/char type"
        ],
        "pg_execute": [
            "resource pg_execute([resource connection,] string stmtname, array params)",
            "Execute a prepared query"
        ],
        "pg_fetch_all": [
            "array pg_fetch_all(resource result)",
            "Fetch all rows into array"
        ],
        "pg_fetch_all_columns": [
            "array pg_fetch_all_columns(resource result [, int column_number])",
            "Fetch all rows into array"
        ],
        "pg_fetch_array": [
            "array pg_fetch_array(resource result [, int row [, int result_type]])",
            "Fetch a row as an array"
        ],
        "pg_fetch_assoc": [
            "array pg_fetch_assoc(resource result [, int row])",
            "Fetch a row as an assoc array"
        ],
        "pg_fetch_object": [
            "object pg_fetch_object(resource result [, int row [, string class_name [, NULL|array ctor_params]]])",
            "Fetch a row as an object"
        ],
        "pg_fetch_result": [
            "mixed pg_fetch_result(resource result, [int row_number,] mixed field_name)",
            "Returns values from a result identifier"
        ],
        "pg_fetch_row": [
            "array pg_fetch_row(resource result [, int row [, int result_type]])",
            "Get a row as an enumerated array"
        ],
        "pg_field_is_null": [
            "int pg_field_is_null(resource result, [int row,] mixed field_name_or_number)",
            "Test if a field is NULL"
        ],
        "pg_field_name": [
            "string pg_field_name(resource result, int field_number)",
            "Returns the name of the field"
        ],
        "pg_field_num": [
            "int pg_field_num(resource result, string field_name)",
            "Returns the field number of the named field"
        ],
        "pg_field_prtlen": [
            "int pg_field_prtlen(resource result, [int row,] mixed field_name_or_number)",
            "Returns the printed length"
        ],
        "pg_field_size": [
            "int pg_field_size(resource result, int field_number)",
            "Returns the internal size of the field"
        ],
        "pg_field_table": [
            "mixed pg_field_table(resource result, int field_number[, bool oid_only])",
            "Returns the name of the table field belongs to, or table's oid if oid_only is true"
        ],
        "pg_field_type": [
            "string pg_field_type(resource result, int field_number)",
            "Returns the type name for the given field"
        ],
        "pg_field_type_oid": [
            "string pg_field_type_oid(resource result, int field_number)",
            "Returns the type oid for the given field"
        ],
        "pg_free_result": [
            "bool pg_free_result(resource result)",
            "Free result memory"
        ],
        "pg_get_notify": [
            "array pg_get_notify([resource connection[, result_type]])",
            "Get asynchronous notification"
        ],
        "pg_get_pid": [
            "int pg_get_pid([resource connection)",
            "Get backend(server) pid"
        ],
        "pg_get_result": [
            "resource pg_get_result(resource connection)",
            "Get asynchronous query result"
        ],
        "pg_host": [
            "string pg_host([resource connection])",
            "Returns the host name associated with the connection"
        ],
        "pg_insert": [
            "mixed pg_insert(resource db, string table, array values[, int options])",
            "Insert values (filed => value) to table"
        ],
        "pg_last_error": [
            "string pg_last_error([resource connection])",
            "Get the error message string"
        ],
        "pg_last_notice": [
            "string pg_last_notice(resource connection)",
            "Returns the last notice set by the backend"
        ],
        "pg_last_oid": [
            "string pg_last_oid(resource result)",
            "Returns the last object identifier"
        ],
        "pg_lo_close": [
            "bool pg_lo_close(resource large_object)",
            "Close a large object"
        ],
        "pg_lo_create": [
            "mixed pg_lo_create([resource connection],[mixed large_object_oid])",
            "Create a large object"
        ],
        "pg_lo_export": [
            "bool pg_lo_export([resource connection, ] int objoid, string filename)",
            "Export large object direct to filesystem"
        ],
        "pg_lo_import": [
            "int pg_lo_import([resource connection, ] string filename [, mixed oid])",
            "Import large object direct from filesystem"
        ],
        "pg_lo_open": [
            "resource pg_lo_open([resource connection,] int large_object_oid, string mode)",
            "Open a large object and return fd"
        ],
        "pg_lo_read": [
            "string pg_lo_read(resource large_object [, int len])",
            "Read a large object"
        ],
        "pg_lo_read_all": [
            "int pg_lo_read_all(resource large_object)",
            "Read a large object and send straight to browser"
        ],
        "pg_lo_seek": [
            "bool pg_lo_seek(resource large_object, int offset [, int whence])",
            "Seeks position of large object"
        ],
        "pg_lo_tell": [
            "int pg_lo_tell(resource large_object)",
            "Returns current position of large object"
        ],
        "pg_lo_unlink": [
            "bool pg_lo_unlink([resource connection,] string large_object_oid)",
            "Delete a large object"
        ],
        "pg_lo_write": [
            "int pg_lo_write(resource large_object, string buf [, int len])",
            "Write a large object"
        ],
        "pg_meta_data": [
            "array pg_meta_data(resource db, string table)",
            "Get meta_data"
        ],
        "pg_num_fields": [
            "int pg_num_fields(resource result)",
            "Return the number of fields in the result"
        ],
        "pg_num_rows": [
            "int pg_num_rows(resource result)",
            "Return the number of rows in the result"
        ],
        "pg_options": [
            "string pg_options([resource connection])",
            "Get the options associated with the connection"
        ],
        "pg_parameter_status": [
            "string|false pg_parameter_status([resource connection,] string param_name)",
            "Returns the value of a server parameter"
        ],
        "pg_pconnect": [
            "resource pg_pconnect(string connection_string | [string host, string port [, string options [, string tty,]]] string database)",
            "Open a persistent PostgreSQL connection"
        ],
        "pg_ping": [
            "bool pg_ping([resource connection])",
            "Ping database. If connection is bad, try to reconnect."
        ],
        "pg_port": [
            "int pg_port([resource connection])",
            "Return the port number associated with the connection"
        ],
        "pg_prepare": [
            "resource pg_prepare([resource connection,] string stmtname, string query)",
            "Prepare a query for future execution"
        ],
        "pg_put_line": [
            "bool pg_put_line([resource connection,] string query)",
            "Send null-terminated string to backend server"
        ],
        "pg_query": [
            "resource pg_query([resource connection,] string query)",
            "Execute a query"
        ],
        "pg_query_params": [
            "resource pg_query_params([resource connection,] string query, array params)",
            "Execute a query"
        ],
        "pg_result_error": [
            "string pg_result_error(resource result)",
            "Get error message associated with result"
        ],
        "pg_result_error_field": [
            "string pg_result_error_field(resource result, int fieldcode)",
            "Get error message field associated with result"
        ],
        "pg_result_seek": [
            "bool pg_result_seek(resource result, int offset)",
            "Set internal row offset"
        ],
        "pg_result_status": [
            "mixed pg_result_status(resource result[, long result_type])",
            "Get status of query result"
        ],
        "pg_select": [
            "mixed pg_select(resource db, string table, array ids[, int options])",
            "Select records that has ids (id => value)"
        ],
        "pg_send_execute": [
            "bool pg_send_execute(resource connection, string stmtname, array params)",
            "Executes prevriously prepared stmtname asynchronously"
        ],
        "pg_send_prepare": [
            "bool pg_send_prepare(resource connection, string stmtname, string query)",
            "Asynchronously prepare a query for future execution"
        ],
        "pg_send_query": [
            "bool pg_send_query(resource connection, string query)",
            "Send asynchronous query"
        ],
        "pg_send_query_params": [
            "bool pg_send_query_params(resource connection, string query, array params)",
            "Send asynchronous parameterized query"
        ],
        "pg_set_client_encoding": [
            "int pg_set_client_encoding([resource connection,] string encoding)",
            "Set client encoding"
        ],
        "pg_set_error_verbosity": [
            "int pg_set_error_verbosity([resource connection,] int verbosity)",
            "Set error verbosity"
        ],
        "pg_trace": [
            "bool pg_trace(string filename [, string mode [, resource connection]])",
            "Enable tracing a PostgreSQL connection"
        ],
        "pg_transaction_status": [
            "int pg_transaction_status(resource connnection)",
            "Get transaction status"
        ],
        "pg_tty": [
            "string pg_tty([resource connection])",
            "Return the tty name associated with the connection"
        ],
        "pg_unescape_bytea": [
            "string pg_unescape_bytea(string data)",
            "Unescape binary for bytea type"
        ],
        "pg_untrace": [
            "bool pg_untrace([resource connection])",
            "Disable tracing of a PostgreSQL connection"
        ],
        "pg_update": [
            "mixed pg_update(resource db, string table, array fields, array ids[, int options])",
            "Update table using values (field => value) and ids (id => value)"
        ],
        "pg_version": [
            "array pg_version([resource connection])",
            "Returns an array with client, protocol and server version (when available)"
        ],
        "php_egg_logo_guid": [
            "string php_egg_logo_guid()",
            "Return the special ID used to request the PHP logo in phpinfo screens"
        ],
        "php_ini_loaded_file": [
            "string php_ini_loaded_file()",
            "Return the actual loaded ini filename"
        ],
        "php_ini_scanned_files": [
            "string php_ini_scanned_files()",
            "Return comma-separated string of .ini files parsed from the additional ini dir"
        ],
        "php_logo_guid": [
            "string php_logo_guid()",
            "Return the special ID used to request the PHP logo in phpinfo screens"
        ],
        "php_real_logo_guid": [
            "string php_real_logo_guid()",
            "Return the special ID used to request the PHP logo in phpinfo screens"
        ],
        "php_sapi_name": [
            "string php_sapi_name()",
            "Return the current SAPI module name"
        ],
        "php_snmpv3": [
            "void php_snmpv3(INTERNAL_FUNCTION_PARAMETERS, int st)",
            "* * Generic SNMPv3 object fetcher * From here is passed on the the common internal object fetcher. * * st=SNMP_CMD_GET   snmp3_get() - query an agent and return a single value. * st=SNMP_CMD_GETNEXT   snmp3_getnext() - query an agent and return the next single value. * st=SNMP_CMD_WALK   snmp3_walk() - walk the mib and return a single dimensional array  *                       containing the values. * st=SNMP_CMD_REALWALK   snmp3_real_walk() - walk the mib and return an  *                            array of oid,value pairs. * st=SNMP_CMD_SET  snmp3_set() - query an agent and set a single value *"
        ],
        "php_strip_whitespace": [
            "string php_strip_whitespace(string file_name)",
            "Return source with stripped comments and whitespace"
        ],
        "php_uname": [
            "string php_uname()",
            "Return information about the system PHP was built on"
        ],
        "phpcredits": [
            "void phpcredits([int flag])",
            "Prints the list of people who've contributed to the PHP project"
        ],
        "phpinfo": [
            "void phpinfo([int what])",
            "Output a page of useful information about PHP and the current request"
        ],
        "phpversion": [
            "string phpversion([string extension])",
            "Return the current PHP version"
        ],
        "pi": [
            "float pi()",
            "Returns an approximation of pi"
        ],
        "png2wbmp": [
            "bool png2wbmp(string f_org, string f_dest, int d_height, int d_width, int threshold)",
            "Convert PNG image to WBMP image"
        ],
        "popen": [
            "resource popen(string command, string mode)",
            "Execute a command and open either a read or a write pipe to it"
        ],
        "posix_access": [
            "bool posix_access(string file [, int mode])",
            "Determine accessibility of a file (POSIX.1 5.6.3)"
        ],
        "posix_ctermid": [
            "string posix_ctermid()",
            "Generate terminal path name (POSIX.1, 4.7.1)"
        ],
        "posix_get_last_error": [
            "int posix_get_last_error()",
            "Retrieve the error number set by the last posix function which failed."
        ],
        "posix_getcwd": [
            "string posix_getcwd()",
            "Get working directory pathname (POSIX.1, 5.2.2)"
        ],
        "posix_getegid": [
            "int posix_getegid()",
            "Get the current effective group id (POSIX.1, 4.2.1)"
        ],
        "posix_geteuid": [
            "int posix_geteuid()",
            "Get the current effective user id (POSIX.1, 4.2.1)"
        ],
        "posix_getgid": [
            "int posix_getgid()",
            "Get the current group id (POSIX.1, 4.2.1)"
        ],
        "posix_getgrgid": [
            "array posix_getgrgid(long gid)",
            "Group database access (POSIX.1, 9.2.1)"
        ],
        "posix_getgrnam": [
            "array posix_getgrnam(string groupname)",
            "Group database access (POSIX.1, 9.2.1)"
        ],
        "posix_getgroups": [
            "array posix_getgroups()",
            "Get supplementary group id's (POSIX.1, 4.2.3)"
        ],
        "posix_getlogin": [
            "string posix_getlogin()",
            "Get user name (POSIX.1, 4.2.4)"
        ],
        "posix_getpgid": [
            "int posix_getpgid()",
            "Get the process group id of the specified process (This is not a POSIX function, but a SVR4ism, so we compile conditionally)"
        ],
        "posix_getpgrp": [
            "int posix_getpgrp()",
            "Get current process group id (POSIX.1, 4.3.1)"
        ],
        "posix_getpid": [
            "int posix_getpid()",
            "Get the current process id (POSIX.1, 4.1.1)"
        ],
        "posix_getppid": [
            "int posix_getppid()",
            "Get the parent process id (POSIX.1, 4.1.1)"
        ],
        "posix_getpwnam": [
            "array posix_getpwnam(string groupname)",
            "User database access (POSIX.1, 9.2.2)"
        ],
        "posix_getpwuid": [
            "array posix_getpwuid(long uid)",
            "User database access (POSIX.1, 9.2.2)"
        ],
        "posix_getrlimit": [
            "array posix_getrlimit()",
            "Get system resource consumption limits (This is not a POSIX function, but a BSDism and a SVR4ism. We compile conditionally)"
        ],
        "posix_getsid": [
            "int posix_getsid()",
            "Get process group id of session leader (This is not a POSIX function, but a SVR4ism, so be compile conditionally)"
        ],
        "posix_getuid": [
            "int posix_getuid()",
            "Get the current user id (POSIX.1, 4.2.1)"
        ],
        "posix_initgroups": [
            "bool posix_initgroups(string name, int base_group_id)",
            "Calculate the group access list for the user specified in name."
        ],
        "posix_isatty": [
            "bool posix_isatty(int fd)",
            "Determine if filedesc is a tty (POSIX.1, 4.7.1)"
        ],
        "posix_kill": [
            "bool posix_kill(int pid, int sig)",
            "Send a signal to a process (POSIX.1, 3.3.2)"
        ],
        "posix_mkfifo": [
            "bool posix_mkfifo(string pathname, int mode)",
            "Make a FIFO special file (POSIX.1, 5.4.2)"
        ],
        "posix_mknod": [
            "bool posix_mknod(string pathname, int mode [, int major [, int minor]])",
            "Make a special or ordinary file (POSIX.1)"
        ],
        "posix_setegid": [
            "bool posix_setegid(long uid)",
            "Set effective group id"
        ],
        "posix_seteuid": [
            "bool posix_seteuid(long uid)",
            "Set effective user id"
        ],
        "posix_setgid": [
            "bool posix_setgid(int uid)",
            "Set group id (POSIX.1, 4.2.2)"
        ],
        "posix_setpgid": [
            "bool posix_setpgid(int pid, int pgid)",
            "Set process group id for job control (POSIX.1, 4.3.3)"
        ],
        "posix_setsid": [
            "int posix_setsid()",
            "Create session and set process group id (POSIX.1, 4.3.2)"
        ],
        "posix_setuid": [
            "bool posix_setuid(long uid)",
            "Set user id (POSIX.1, 4.2.2)"
        ],
        "posix_strerror": [
            "string posix_strerror(int errno)",
            "Retrieve the system error message associated with the given errno."
        ],
        "posix_times": [
            "array posix_times()",
            "Get process times (POSIX.1, 4.5.2)"
        ],
        "posix_ttyname": [
            "string posix_ttyname(int fd)",
            "Determine terminal device name (POSIX.1, 4.7.2)"
        ],
        "posix_uname": [
            "array posix_uname()",
            "Get system name (POSIX.1, 4.4.1)"
        ],
        "pow": [
            "number pow(number base, number exponent)",
            "Returns base raised to the power of exponent. Returns integer result when possible"
        ],
        "preg_filter": [
            "mixed preg_filter(mixed regex, mixed replace, mixed subject [, int limit [, int &count]])",
            "Perform Perl-style regular expression replacement and only return matches."
        ],
        "preg_grep": [
            "array preg_grep(string regex, array input [, int flags])",
            "Searches array and returns entries which match regex"
        ],
        "preg_last_error": [
            "int preg_last_error()",
            "Returns the error code of the last regexp execution."
        ],
        "preg_match": [
            "int preg_match(string pattern, string subject [, array &subpatterns [, int flags [, int offset]]])",
            "Perform a Perl-style regular expression match"
        ],
        "preg_match_all": [
            "int preg_match_all(string pattern, string subject, array &subpatterns [, int flags [, int offset]])",
            "Perform a Perl-style global regular expression match"
        ],
        "preg_quote": [
            "string preg_quote(string str [, string delim_char])",
            "Quote regular expression characters plus an optional character"
        ],
        "preg_replace": [
            "mixed preg_replace(mixed regex, mixed replace, mixed subject [, int limit [, int &count]])",
            "Perform Perl-style regular expression replacement."
        ],
        "preg_replace_callback": [
            "mixed preg_replace_callback(mixed regex, mixed callback, mixed subject [, int limit [, int &count]])",
            "Perform Perl-style regular expression replacement using replacement callback."
        ],
        "preg_split": [
            "array preg_split(string pattern, string subject [, int limit [, int flags]])",
            "Split string into an array using a perl-style regular expression as a delimiter"
        ],
        "prev": [
            "mixed prev(array array_arg)",
            "Move array argument's internal pointer to the previous element and return it"
        ],
        "print": [
            "int print(string arg)",
            "Output a string"
        ],
        "print_r": [
            "mixed print_r(mixed var [, bool return])",
            "Prints out or returns information about the specified variable"
        ],
        "printf": [
            "int printf(string format [, mixed arg1 [, mixed ...]])",
            "Output a formatted string"
        ],
        "proc_close": [
            "int proc_close(resource process)",
            "close a process opened by proc_open"
        ],
        "proc_get_status": [
            "array proc_get_status(resource process)",
            "get information about a process opened by proc_open"
        ],
        "proc_nice": [
            "bool proc_nice(int priority)",
            "Change the priority of the current process"
        ],
        "proc_open": [
            "resource proc_open(string command, array descriptorspec, array &pipes [, string cwd [, array env [, array other_options]]])",
            "Run a process with more control over it's file descriptors"
        ],
        "proc_terminate": [
            "bool proc_terminate(resource process [, long signal])",
            "kill a process opened by proc_open"
        ],
        "property_exists": [
            "bool property_exists(mixed object_or_class, string property_name)",
            "Checks if the object or class has a property"
        ],
        "pspell_add_to_personal": [
            "bool pspell_add_to_personal(int pspell, string word)",
            "Adds a word to a personal list"
        ],
        "pspell_add_to_session": [
            "bool pspell_add_to_session(int pspell, string word)",
            "Adds a word to the current session"
        ],
        "pspell_check": [
            "bool pspell_check(int pspell, string word)",
            "Returns true if word is valid"
        ],
        "pspell_clear_session": [
            "bool pspell_clear_session(int pspell)",
            "Clears the current session"
        ],
        "pspell_config_create": [
            "int pspell_config_create(string language [, string spelling [, string jargon [, string encoding]]])",
            "Create a new config to be used later to create a manager"
        ],
        "pspell_config_data_dir": [
            "bool pspell_config_data_dir(int conf, string directory)",
            "location of language data files"
        ],
        "pspell_config_dict_dir": [
            "bool pspell_config_dict_dir(int conf, string directory)",
            "location of the main word list"
        ],
        "pspell_config_ignore": [
            "bool pspell_config_ignore(int conf, int ignore)",
            "Ignore words <= n chars"
        ],
        "pspell_config_mode": [
            "bool pspell_config_mode(int conf, long mode)",
            "Select mode for config (PSPELL_FAST, PSPELL_NORMAL or PSPELL_BAD_SPELLERS)"
        ],
        "pspell_config_personal": [
            "bool pspell_config_personal(int conf, string personal)",
            "Use a personal dictionary for this config"
        ],
        "pspell_config_repl": [
            "bool pspell_config_repl(int conf, string repl)",
            "Use a personal dictionary with replacement pairs for this config"
        ],
        "pspell_config_runtogether": [
            "bool pspell_config_runtogether(int conf, bool runtogether)",
            "Consider run-together words as valid components"
        ],
        "pspell_config_save_repl": [
            "bool pspell_config_save_repl(int conf, bool save)",
            "Save replacement pairs when personal list is saved for this config"
        ],
        "pspell_new": [
            "int pspell_new(string language [, string spelling [, string jargon [, string encoding [, int mode]]]])",
            "Load a dictionary"
        ],
        "pspell_new_config": [
            "int pspell_new_config(int config)",
            "Load a dictionary based on the given config"
        ],
        "pspell_new_personal": [
            "int pspell_new_personal(string personal, string language [, string spelling [, string jargon [, string encoding [, int mode]]]])",
            "Load a dictionary with a personal wordlist"
        ],
        "pspell_save_wordlist": [
            "bool pspell_save_wordlist(int pspell)",
            "Saves the current (personal) wordlist"
        ],
        "pspell_store_replacement": [
            "bool pspell_store_replacement(int pspell, string misspell, string correct)",
            "Notify the dictionary of a user-selected replacement"
        ],
        "pspell_suggest": [
            "array pspell_suggest(int pspell, string word)",
            "Returns array of suggestions"
        ],
        "putenv": [
            "bool putenv(string setting)",
            "Set the value of an environment variable"
        ],
        "quoted_printable_decode": [
            "string quoted_printable_decode(string str)",
            "Convert a quoted-printable string to an 8 bit string"
        ],
        "quoted_printable_encode": [
            "string quoted_printable_encode(string str)",
            ""
        ],
        "quotemeta": [
            "string quotemeta(string str)",
            "Quotes meta characters"
        ],
        "rad2deg": [
            "float rad2deg(float number)",
            "Converts the radian number to the equivalent number in degrees"
        ],
        "rand": [
            "int rand([int min, int max])",
            "Returns a random number"
        ],
        "range": [
            "array range(mixed low, mixed high[, int step])",
            "Create an array containing the range of integers or characters from low to high (inclusive)"
        ],
        "rawurldecode": [
            "string rawurldecode(string str)",
            "Decodes URL-encodes string"
        ],
        "rawurlencode": [
            "string rawurlencode(string str)",
            "URL-encodes string"
        ],
        "readdir": [
            "string readdir([resource dir_handle])",
            "Read directory entry from dir_handle"
        ],
        "readfile": [
            "int readfile(string filename [, bool use_include_path[, resource context]])",
            "Output a file or a URL"
        ],
        "readgzfile": [
            "int readgzfile(string filename [, int use_include_path])",
            "Output a .gz-file"
        ],
        "readline": [
            "string readline([string prompt])",
            "Reads a line"
        ],
        "readline_add_history": [
            "bool readline_add_history(string prompt)",
            "Adds a line to the history"
        ],
        "readline_callback_handler_install": [
            "void readline_callback_handler_install(string prompt, mixed callback)",
            "Initializes the readline callback interface and terminal, prints the prompt and returns immediately"
        ],
        "readline_callback_handler_remove": [
            "bool readline_callback_handler_remove()",
            "Removes a previously installed callback handler and restores terminal settings"
        ],
        "readline_callback_read_char": [
            "void readline_callback_read_char()",
            "Informs the readline callback interface that a character is ready for input"
        ],
        "readline_clear_history": [
            "bool readline_clear_history()",
            "Clears the history"
        ],
        "readline_completion_function": [
            "bool readline_completion_function(string funcname)",
            "Readline completion function?"
        ],
        "readline_info": [
            "mixed readline_info([string varname [, string newvalue]])",
            "Gets/sets various internal readline variables."
        ],
        "readline_list_history": [
            "array readline_list_history()",
            "Lists the history"
        ],
        "readline_on_new_line": [
            "void readline_on_new_line()",
            "Inform readline that the cursor has moved to a new line"
        ],
        "readline_read_history": [
            "bool readline_read_history([string filename])",
            "Reads the history"
        ],
        "readline_redisplay": [
            "void readline_redisplay()",
            "Ask readline to redraw the display"
        ],
        "readline_write_history": [
            "bool readline_write_history([string filename])",
            "Writes the history"
        ],
        "readlink": [
            "string readlink(string filename)",
            "Return the target of a symbolic link"
        ],
        "realpath": [
            "string realpath(string path)",
            "Return the resolved path"
        ],
        "realpath_cache_get": [
            "bool realpath_cache_get()",
            "Get current size of realpath cache"
        ],
        "realpath_cache_size": [
            "bool realpath_cache_size()",
            "Get current size of realpath cache"
        ],
        "recode_file": [
            "bool recode_file(string request, resource input, resource output)",
            "Recode file input into file output according to request"
        ],
        "recode_string": [
            "string recode_string(string request, string str)",
            "Recode string str according to request string"
        ],
        "register_shutdown_function": [
            "void register_shutdown_function(string function_name)",
            "Register a user-level function to be called on request termination"
        ],
        "register_tick_function": [
            "bool register_tick_function(string function_name [, mixed arg [, mixed ... ]])",
            "Registers a tick callback function"
        ],
        "rename": [
            "bool rename(string old_name, string new_name[, resource context])",
            "Rename a file"
        ],
        "require": [
            "bool require(string path)",
            "Includes and evaluates the specified file, erroring if the file cannot be included"
        ],
        "require_once": [
            "bool require_once(string path)",
            "Includes and evaluates the specified file, erroring if the file cannot be included"
        ],
        "reset": [
            "mixed reset(array array_arg)",
            "Set array argument's internal pointer to the first element and return it"
        ],
        "restore_error_handler": [
            "void restore_error_handler()",
            "Restores the previously defined error handler function"
        ],
        "restore_exception_handler": [
            "void restore_exception_handler()",
            "Restores the previously defined exception handler function"
        ],
        "restore_include_path": [
            "void restore_include_path()",
            "Restore the value of the include_path configuration option"
        ],
        "rewind": [
            "bool rewind(resource fp)",
            "Rewind the position of a file pointer"
        ],
        "rewinddir": [
            "void rewinddir([resource dir_handle])",
            "Rewind dir_handle back to the start"
        ],
        "rmdir": [
            "bool rmdir(string dirname[, resource context])",
            "Remove a directory"
        ],
        "round": [
            "float round(float number [, int precision [, int mode]])",
            "Returns the number rounded to specified precision"
        ],
        "rsort": [
            "bool rsort(array &array_arg [, int sort_flags])",
            "Sort an array in reverse order"
        ],
        "rtrim": [
            "string rtrim(string str [, string character_mask])",
            "Removes trailing whitespace"
        ],
        "scandir": [
            "array scandir(string dir [, int sorting_order [, resource context]])",
            "List files & directories inside the specified path"
        ],
        "sem_acquire": [
            "bool sem_acquire(resource id)",
            "Acquires the semaphore with the given id, blocking if necessary"
        ],
        "sem_get": [
            "resource sem_get(int key [, int max_acquire [, int perm [, int auto_release]])",
            "Return an id for the semaphore with the given key, and allow max_acquire (default 1) processes to acquire it simultaneously"
        ],
        "sem_release": [
            "bool sem_release(resource id)",
            "Releases the semaphore with the given id"
        ],
        "sem_remove": [
            "bool sem_remove(resource id)",
            "Removes semaphore from Unix systems"
        ],
        "serialize": [
            "string serialize(mixed variable)",
            "Returns a string representation of variable (which can later be unserialized)"
        ],
        "session_cache_expire": [
            "int session_cache_expire([int new_cache_expire])",
            "Return the current cache expire. If new_cache_expire is given, the current cache_expire is replaced with new_cache_expire"
        ],
        "session_cache_limiter": [
            "string session_cache_limiter([string new_cache_limiter])",
            "Return the current cache limiter. If new_cache_limited is given, the current cache_limiter is replaced with new_cache_limiter"
        ],
        "session_decode": [
            "bool session_decode(string data)",
            "Deserializes data and reinitializes the variables"
        ],
        "session_destroy": [
            "bool session_destroy()",
            "Destroy the current session and all data associated with it"
        ],
        "session_encode": [
            "string session_encode()",
            "Serializes the current setup and returns the serialized representation"
        ],
        "session_get_cookie_params": [
            "array session_get_cookie_params()",
            "Return the session cookie parameters"
        ],
        "session_id": [
            "string session_id([string newid])",
            "Return the current session id. If newid is given, the session id is replaced with newid"
        ],
        "session_is_registered": [
            "bool session_is_registered(string varname)",
            "Checks if a variable is registered in session"
        ],
        "session_module_name": [
            "string session_module_name([string newname])",
            "Return the current module name used for accessing session data. If newname is given, the module name is replaced with newname"
        ],
        "session_name": [
            "string session_name([string newname])",
            "Return the current session name. If newname is given, the session name is replaced with newname"
        ],
        "session_regenerate_id": [
            "bool session_regenerate_id([bool delete_old_session])",
            "Update the current session id with a newly generated one. If delete_old_session is set to true, remove the old session."
        ],
        "session_register": [
            "bool session_register(mixed var_names [, mixed ...])",
            "Adds varname(s) to the list of variables which are freezed at the session end"
        ],
        "session_save_path": [
            "string session_save_path([string newname])",
            "Return the current save path passed to module_name. If newname is given, the save path is replaced with newname"
        ],
        "session_set_cookie_params": [
            "void session_set_cookie_params(int lifetime [, string path [, string domain [, bool secure[, bool httponly]]]])",
            "Set session cookie parameters"
        ],
        "session_set_save_handler": [
            "void session_set_save_handler(string open, string close, string read, string write, string destroy, string gc)",
            "Sets user-level functions"
        ],
        "session_start": [
            "bool session_start()",
            "Begin session - reinitializes freezed variables, registers browsers etc"
        ],
        "session_unregister": [
            "bool session_unregister(string varname)",
            "Removes varname from the list of variables which are freezed at the session end"
        ],
        "session_unset": [
            "void session_unset()",
            "Unset all registered variables"
        ],
        "session_write_close": [
            "void session_write_close()",
            "Write session data and end session"
        ],
        "set_error_handler": [
            "string set_error_handler(string error_handler [, int error_types])",
            "Sets a user-defined error handler function.  Returns the previously defined error handler, or false on error"
        ],
        "set_exception_handler": [
            "string set_exception_handler(callable exception_handler)",
            "Sets a user-defined exception handler function.  Returns the previously defined exception handler, or false on error"
        ],
        "set_include_path": [
            "string set_include_path(string new_include_path)",
            "Sets the include_path configuration option"
        ],
        "set_magic_quotes_runtime": [
            "bool set_magic_quotes_runtime(int new_setting)",
            "Set the current active configuration setting of magic_quotes_runtime and return previous"
        ],
        "set_time_limit": [
            "bool set_time_limit(int seconds)",
            "Sets the maximum time a script can run"
        ],
        "setcookie": [
            "bool setcookie(string name [, string value [, int expires [, string path [, string domain [, bool secure[, bool httponly]]]]]])",
            "Send a cookie"
        ],
        "setlocale": [
            "string setlocale(mixed category, string locale [, string ...])",
            "Set locale information"
        ],
        "setrawcookie": [
            "bool setrawcookie(string name [, string value [, int expires [, string path [, string domain [, bool secure[, bool httponly]]]]]])",
            "Send a cookie with no url encoding of the value"
        ],
        "settype": [
            "bool settype(mixed var, string type)",
            "Set the type of the variable"
        ],
        "sha1": [
            "string sha1(string str [, bool raw_output])",
            "Calculate the sha1 hash of a string"
        ],
        "sha1_file": [
            "string sha1_file(string filename [, bool raw_output])",
            "Calculate the sha1 hash of given filename"
        ],
        "shell_exec": [
            "string shell_exec(string cmd)",
            "Execute command via shell and return complete output as string"
        ],
        "shm_attach": [
            "int shm_attach(int key [, int memsize [, int perm]])",
            "Creates or open a shared memory segment"
        ],
        "shm_detach": [
            "bool shm_detach(resource shm_identifier)",
            "Disconnects from shared memory segment"
        ],
        "shm_get_var": [
            "mixed shm_get_var(resource id, int variable_key)",
            "Returns a variable from shared memory"
        ],
        "shm_has_var": [
            "bool shm_has_var(resource id, int variable_key)",
            "Checks whether a specific entry exists"
        ],
        "shm_put_var": [
            "bool shm_put_var(resource shm_identifier, int variable_key, mixed variable)",
            "Inserts or updates a variable in shared memory"
        ],
        "shm_remove": [
            "bool shm_remove(resource shm_identifier)",
            "Removes shared memory from Unix systems"
        ],
        "shm_remove_var": [
            "bool shm_remove_var(resource id, int variable_key)",
            "Removes variable from shared memory"
        ],
        "shmop_close": [
            "void shmop_close(int shmid)",
            "closes a shared memory segment"
        ],
        "shmop_delete": [
            "bool shmop_delete(int shmid)",
            "mark segment for deletion"
        ],
        "shmop_open": [
            "int shmop_open(int key, string flags, int mode, int size)",
            "gets and attaches a shared memory segment"
        ],
        "shmop_read": [
            "string shmop_read(int shmid, int start, int count)",
            "reads from a shm segment"
        ],
        "shmop_size": [
            "int shmop_size(int shmid)",
            "returns the shm size"
        ],
        "shmop_write": [
            "int shmop_write(int shmid, string data, int offset)",
            "writes to a shared memory segment"
        ],
        "shuffle": [
            "bool shuffle(array array_arg)",
            "Randomly shuffle the contents of an array"
        ],
        "similar_text": [
            "int similar_text(string str1, string str2 [, float percent])",
            "Calculates the similarity between two strings"
        ],
        "simplexml_import_dom": [
            "simplemxml_element simplexml_import_dom(domNode node [, string class_name])",
            "Get a simplexml_element object from dom to allow for processing"
        ],
        "simplexml_load_file": [
            "simplemxml_element simplexml_load_file(string filename [, string class_name [, int options [, string ns [, bool is_prefix]]]])",
            "Load a filename and return a simplexml_element object to allow for processing"
        ],
        "simplexml_load_string": [
            "simplemxml_element simplexml_load_string(string data [, string class_name [, int options [, string ns [, bool is_prefix]]]])",
            "Load a string and return a simplexml_element object to allow for processing"
        ],
        "sin": [
            "float sin(float number)",
            "Returns the sine of the number in radians"
        ],
        "sinh": [
            "float sinh(float number)",
            "Returns the hyperbolic sine of the number, defined as (exp(number) - exp(-number))/2"
        ],
        "sleep": [
            "void sleep(int seconds)",
            "Delay for a given number of seconds"
        ],
        "smfi_addheader": [
            "bool smfi_addheader(string headerf, string headerv)",
            "Adds a header to the current message."
        ],
        "smfi_addrcpt": [
            "bool smfi_addrcpt(string rcpt)",
            "Add a recipient to the message envelope."
        ],
        "smfi_chgheader": [
            "bool smfi_chgheader(string headerf, string headerv)",
            "Changes a header's value for the current message."
        ],
        "smfi_delrcpt": [
            "bool smfi_delrcpt(string rcpt)",
            "Removes the named recipient from the current message's envelope."
        ],
        "smfi_getsymval": [
            "string smfi_getsymval(string macro)",
            "Returns the value of the given macro or NULL if the macro is not defined."
        ],
        "smfi_replacebody": [
            "bool smfi_replacebody(string body)",
            "Replaces the body of the current message. If called more than once,    subsequent calls result in data being appended to the new body."
        ],
        "smfi_setflags": [
            "void smfi_setflags(long flags)",
            "Sets the flags describing the actions the filter may take."
        ],
        "smfi_setreply": [
            "bool smfi_setreply(string rcode, string xcode, string message)",
            "Directly set the SMTP error reply code for this connection.    This code will be used on subsequent error replies resulting from actions taken by this filter."
        ],
        "smfi_settimeout": [
            "void smfi_settimeout(long timeout)",
            "Sets the number of seconds libmilter will wait for an MTA connection before timing out a socket."
        ],
        "snmp2_get": [
            "string snmp2_get(string host, string community, string object_id [, int timeout [, int retries]])",
            "Fetch a SNMP object"
        ],
        "snmp2_getnext": [
            "string snmp2_getnext(string host, string community, string object_id [, int timeout [, int retries]])",
            "Fetch a SNMP object"
        ],
        "snmp2_real_walk": [
            "array snmp2_real_walk(string host, string community, string object_id [, int timeout [, int retries]])",
            "Return all objects including their respective object id withing the specified one"
        ],
        "snmp2_set": [
            "int snmp2_set(string host, string community, string object_id, string type, mixed value [, int timeout [, int retries]])",
            "Set the value of a SNMP object"
        ],
        "snmp2_walk": [
            "array snmp2_walk(string host, string community, string object_id [, int timeout [, int retries]])",
            "Return all objects under the specified object id"
        ],
        "snmp3_get": [
            "int snmp3_get(string host, string sec_name, string sec_level, string auth_protocol, string auth_passphrase, string priv_protocol, string priv_passphrase, string object_id [, int timeout [, int retries]])",
            "Fetch the value of a SNMP object"
        ],
        "snmp3_getnext": [
            "int snmp3_getnext(string host, string sec_name, string sec_level, string auth_protocol, string auth_passphrase, string priv_protocol, string priv_passphrase, string object_id [, int timeout [, int retries]])",
            "Fetch the value of a SNMP object"
        ],
        "snmp3_real_walk": [
            "int snmp3_real_walk(string host, string sec_name, string sec_level, string auth_protocol, string auth_passphrase, string priv_protocol, string priv_passphrase, string object_id [, int timeout [, int retries]])",
            "Fetch the value of a SNMP object"
        ],
        "snmp3_set": [
            "int snmp3_set(string host, string sec_name, string sec_level, string auth_protocol, string auth_passphrase, string priv_protocol, string priv_passphrase, string object_id, string type, mixed value [, int timeout [, int retries]])",
            "Fetch the value of a SNMP object"
        ],
        "snmp3_walk": [
            "int snmp3_walk(string host, string sec_name, string sec_level, string auth_protocol, string auth_passphrase, string priv_protocol, string priv_passphrase, string object_id [, int timeout [, int retries]])",
            "Fetch the value of a SNMP object"
        ],
        "snmp_get_quick_print": [
            "bool snmp_get_quick_print()",
            "Return the current status of quick_print"
        ],
        "snmp_get_valueretrieval": [
            "int snmp_get_valueretrieval()",
            "Return the method how the SNMP values will be returned"
        ],
        "snmp_read_mib": [
            "int snmp_read_mib(string filename)",
            "Reads and parses a MIB file into the active MIB tree."
        ],
        "snmp_set_enum_print": [
            "void snmp_set_enum_print(int enum_print)",
            "Return all values that are enums with their enum value instead of the raw integer"
        ],
        "snmp_set_oid_output_format": [
            "void snmp_set_oid_output_format(int oid_format)",
            "Set the OID output format."
        ],
        "snmp_set_quick_print": [
            "void snmp_set_quick_print(int quick_print)",
            "Return all objects including their respective object id withing the specified one"
        ],
        "snmp_set_valueretrieval": [
            "void snmp_set_valueretrieval(int method)",
            "Specify the method how the SNMP values will be returned"
        ],
        "snmpget": [
            "string snmpget(string host, string community, string object_id [, int timeout [, int retries]])",
            "Fetch a SNMP object"
        ],
        "snmpgetnext": [
            "string snmpgetnext(string host, string community, string object_id [, int timeout [, int retries]])",
            "Fetch a SNMP object"
        ],
        "snmprealwalk": [
            "array snmprealwalk(string host, string community, string object_id [, int timeout [, int retries]])",
            "Return all objects including their respective object id withing the specified one"
        ],
        "snmpset": [
            "int snmpset(string host, string community, string object_id, string type, mixed value [, int timeout [, int retries]])",
            "Set the value of a SNMP object"
        ],
        "snmpwalk": [
            "array snmpwalk(string host, string community, string object_id [, int timeout [, int retries]])",
            "Return all objects under the specified object id"
        ],
        "socket_accept": [
            "resource socket_accept(resource socket)",
            "Accepts a connection on the listening socket fd"
        ],
        "socket_bind": [
            "bool socket_bind(resource socket, string addr [, int port])",
            "Binds an open socket to a listening port, port is only specified in AF_INET family."
        ],
        "socket_clear_error": [
            "void socket_clear_error([resource socket])",
            "Clears the error on the socket or the last error code."
        ],
        "socket_close": [
            "void socket_close(resource socket)",
            "Closes a file descriptor"
        ],
        "socket_connect": [
            "bool socket_connect(resource socket, string addr [, int port])",
            "Opens a connection to addr:port on the socket specified by socket"
        ],
        "socket_create": [
            "resource socket_create(int domain, int type, int protocol)",
            "Creates an endpoint for communication in the domain specified by domain, of type specified by type"
        ],
        "socket_create_listen": [
            "resource socket_create_listen(int port[, int backlog])",
            "Opens a socket on port to accept connections"
        ],
        "socket_create_pair": [
            "bool socket_create_pair(int domain, int type, int protocol, array &fd)",
            "Creates a pair of indistinguishable sockets and stores them in fds."
        ],
        "socket_get_option": [
            "mixed socket_get_option(resource socket, int level, int optname)",
            "Gets socket options for the socket"
        ],
        "socket_getpeername": [
            "bool socket_getpeername(resource socket, string &addr[, int &port])",
            "Queries the remote side of the given socket which may either result in host/port or in a UNIX filesystem path, dependent on its type."
        ],
        "socket_getsockname": [
            "bool socket_getsockname(resource socket, string &addr[, int &port])",
            "Queries the remote side of the given socket which may either result in host/port or in a UNIX filesystem path, dependent on its type."
        ],
        "socket_last_error": [
            "int socket_last_error([resource socket])",
            "Returns the last socket error (either the last used or the provided socket resource)"
        ],
        "socket_listen": [
            "bool socket_listen(resource socket[, int backlog])",
            "Sets the maximum number of connections allowed to be waited for on the socket specified by fd"
        ],
        "socket_read": [
            "string socket_read(resource socket, int length [, int type])",
            "Reads a maximum of length bytes from socket"
        ],
        "socket_recv": [
            "int socket_recv(resource socket, string &buf, int len, int flags)",
            "Receives data from a connected socket"
        ],
        "socket_recvfrom": [
            "int socket_recvfrom(resource socket, string &buf, int len, int flags, string &name [, int &port])",
            "Receives data from a socket, connected or not"
        ],
        "socket_select": [
            "int socket_select(array &read_fds, array &write_fds, array &except_fds, int tv_sec[, int tv_usec])",
            "Runs the select() system call on the sets mentioned with a timeout specified by tv_sec and tv_usec"
        ],
        "socket_send": [
            "int socket_send(resource socket, string buf, int len, int flags)",
            "Sends data to a connected socket"
        ],
        "socket_sendto": [
            "int socket_sendto(resource socket, string buf, int len, int flags, string addr [, int port])",
            "Sends a message to a socket, whether it is connected or not"
        ],
        "socket_set_block": [
            "bool socket_set_block(resource socket)",
            "Sets blocking mode on a socket resource"
        ],
        "socket_set_nonblock": [
            "bool socket_set_nonblock(resource socket)",
            "Sets nonblocking mode on a socket resource"
        ],
        "socket_set_option": [
            "bool socket_set_option(resource socket, int level, int optname, int|array optval)",
            "Sets socket options for the socket"
        ],
        "socket_shutdown": [
            "bool socket_shutdown(resource socket[, int how])",
            "Shuts down a socket for receiving, sending, or both."
        ],
        "socket_strerror": [
            "string socket_strerror(int errno)",
            "Returns a string describing an error"
        ],
        "socket_write": [
            "int socket_write(resource socket, string buf[, int length])",
            "Writes the buffer to the socket resource, length is optional"
        ],
        "solid_fetch_prev": [
            "bool solid_fetch_prev(resource result_id)",
            ""
        ],
        "sort": [
            "bool sort(array &array_arg [, int sort_flags])",
            "Sort an array"
        ],
        "soundex": [
            "string soundex(string str)",
            "Calculate the soundex key of a string"
        ],
        "spl_autoload": [
            "void spl_autoload(string class_name [, string file_extensions])",
            "Default implementation for __autoload()"
        ],
        "spl_autoload_call": [
            "void spl_autoload_call(string class_name)",
            "Try all registerd autoload function to load the requested class"
        ],
        "spl_autoload_extensions": [
            "string spl_autoload_extensions([string file_extensions])",
            "Register and return default file extensions for spl_autoload"
        ],
        "spl_autoload_functions": [
            "false|array spl_autoload_functions()",
            "Return all registered __autoload() functionns"
        ],
        "spl_autoload_register": [
            'bool spl_autoload_register([mixed autoload_function = "spl_autoload" [, throw = true [, prepend]]])',
            "Register given function as __autoload() implementation"
        ],
        "spl_autoload_unregister": [
            "bool spl_autoload_unregister(mixed autoload_function)",
            "Unregister given function as __autoload() implementation"
        ],
        "spl_classes": [
            "array spl_classes()",
            "Return an array containing the names of all clsses and interfaces defined in SPL"
        ],
        "spl_object_hash": [
            "string spl_object_hash(object obj)",
            "Return hash id for given object"
        ],
        "split": [
            "array split(string pattern, string string [, int limit])",
            "Split string into array by regular expression"
        ],
        "spliti": [
            "array spliti(string pattern, string string [, int limit])",
            "Split string into array by regular expression case-insensitive"
        ],
        "sprintf": [
            "string sprintf(string format [, mixed arg1 [, mixed ...]])",
            "Return a formatted string"
        ],
        "sql_regcase": [
            "string sql_regcase(string string)",
            "Make regular expression for case insensitive match"
        ],
        "sqlite_array_query": [
            "array sqlite_array_query(resource db, string query [ , int result_type [, bool decode_binary]])",
            "Executes a query against a given database and returns an array of arrays."
        ],
        "sqlite_busy_timeout": [
            "void sqlite_busy_timeout(resource db, int ms)",
            "Set busy timeout duration. If ms <= 0, all busy handlers are disabled."
        ],
        "sqlite_changes": [
            "int sqlite_changes(resource db)",
            "Returns the number of rows that were changed by the most recent SQL statement."
        ],
        "sqlite_close": [
            "void sqlite_close(resource db)",
            "Closes an open sqlite database."
        ],
        "sqlite_column": [
            "mixed sqlite_column(resource result, mixed index_or_name [, bool decode_binary])",
            "Fetches a column from the current row of a result set."
        ],
        "sqlite_create_aggregate": [
            "bool sqlite_create_aggregate(resource db, string funcname, mixed step_func, mixed finalize_func[, long num_args])",
            "Registers an aggregate function for queries."
        ],
        "sqlite_create_function": [
            "bool sqlite_create_function(resource db, string funcname, mixed callback[, long num_args])",
            'Registers a "regular" function for queries.'
        ],
        "sqlite_current": [
            "array sqlite_current(resource result [, int result_type [, bool decode_binary]])",
            "Fetches the current row from a result set as an array."
        ],
        "sqlite_error_string": [
            "string sqlite_error_string(int error_code)",
            "Returns the textual description of an error code."
        ],
        "sqlite_escape_string": [
            "string sqlite_escape_string(string item)",
            "Escapes a string for use as a query parameter."
        ],
        "sqlite_exec": [
            "bool sqlite_exec(string query, resource db[, string &error_message])",
            "Executes a result-less query against a given database"
        ],
        "sqlite_factory": [
            "object sqlite_factory(string filename [, int mode [, string &error_message]])",
            "Opens a SQLite database and creates an object for it. Will create the database if it does not exist."
        ],
        "sqlite_fetch_all": [
            "array sqlite_fetch_all(resource result [, int result_type [, bool decode_binary]])",
            "Fetches all rows from a result set as an array of arrays."
        ],
        "sqlite_fetch_array": [
            "array sqlite_fetch_array(resource result [, int result_type [, bool decode_binary]])",
            "Fetches the next row from a result set as an array."
        ],
        "sqlite_fetch_column_types": [
            "resource sqlite_fetch_column_types(string table_name, resource db [, int result_type])",
            "Return an array of column types from a particular table."
        ],
        "sqlite_fetch_object": [
            "object sqlite_fetch_object(resource result [, string class_name [, NULL|array ctor_params [, bool decode_binary]]])",
            "Fetches the next row from a result set as an object."
        ],
        "sqlite_fetch_single": [
            "string sqlite_fetch_single(resource result [, bool decode_binary])",
            "Fetches the first column of a result set as a string."
        ],
        "sqlite_field_name": [
            "string sqlite_field_name(resource result, int field_index)",
            "Returns the name of a particular field of a result set."
        ],
        "sqlite_has_prev": [
            "bool sqlite_has_prev(resource result)",
            "* Returns whether a previous row is available."
        ],
        "sqlite_key": [
            "int sqlite_key(resource result)",
            "Return the current row index of a buffered result."
        ],
        "sqlite_last_error": [
            "int sqlite_last_error(resource db)",
            "Returns the error code of the last error for a database."
        ],
        "sqlite_last_insert_rowid": [
            "int sqlite_last_insert_rowid(resource db)",
            "Returns the rowid of the most recently inserted row."
        ],
        "sqlite_libencoding": [
            "string sqlite_libencoding()",
            "Returns the encoding (iso8859 or UTF-8) of the linked SQLite library."
        ],
        "sqlite_libversion": [
            "string sqlite_libversion()",
            "Returns the version of the linked SQLite library."
        ],
        "sqlite_next": [
            "bool sqlite_next(resource result)",
            "Seek to the next row number of a result set."
        ],
        "sqlite_num_fields": [
            "int sqlite_num_fields(resource result)",
            "Returns the number of fields in a result set."
        ],
        "sqlite_num_rows": [
            "int sqlite_num_rows(resource result)",
            "Returns the number of rows in a buffered result set."
        ],
        "sqlite_open": [
            "resource sqlite_open(string filename [, int mode [, string &error_message]])",
            "Opens a SQLite database. Will create the database if it does not exist."
        ],
        "sqlite_popen": [
            "resource sqlite_popen(string filename [, int mode [, string &error_message]])",
            "Opens a persistent handle to a SQLite database. Will create the database if it does not exist."
        ],
        "sqlite_prev": [
            "bool sqlite_prev(resource result)",
            "* Seek to the previous row number of a result set."
        ],
        "sqlite_query": [
            "resource sqlite_query(string query, resource db [, int result_type [, string &error_message]])",
            "Executes a query against a given database and returns a result handle."
        ],
        "sqlite_rewind": [
            "bool sqlite_rewind(resource result)",
            "Seek to the first row number of a buffered result set."
        ],
        "sqlite_seek": [
            "bool sqlite_seek(resource result, int row)",
            "Seek to a particular row number of a buffered result set."
        ],
        "sqlite_single_query": [
            "array sqlite_single_query(resource db, string query [, bool first_row_only [, bool decode_binary]])",
            "Executes a query and returns either an array for one single column or the value of the first row."
        ],
        "sqlite_udf_decode_binary": [
            "string sqlite_udf_decode_binary(string data)",
            "Decode binary encoding on a string parameter passed to an UDF."
        ],
        "sqlite_udf_encode_binary": [
            "string sqlite_udf_encode_binary(string data)",
            "Apply binary encoding (if required) to a string to return from an UDF."
        ],
        "sqlite_unbuffered_query": [
            "resource sqlite_unbuffered_query(string query, resource db [ , int result_type [, string &error_message]])",
            "Executes a query that does not prefetch and buffer all data."
        ],
        "sqlite_valid": [
            "bool sqlite_valid(resource result)",
            "Returns whether more rows are available."
        ],
        "sqrt": [
            "float sqrt(float number)",
            "Returns the square root of the number"
        ],
        "srand": [
            "void srand([int seed])",
            "Seeds random number generator"
        ],
        "sscanf": [
            "mixed sscanf(string str, string format [, string ...])",
            "Implements an ANSI C compatible sscanf"
        ],
        "stat": [
            "array stat(string filename)",
            "Give information about a file"
        ],
        "str_getcsv": [
            "array str_getcsv(string input[, string delimiter[, string enclosure[, string escape]]])",
            "Parse a CSV string into an array"
        ],
        "str_ireplace": [
            "mixed str_ireplace(mixed search, mixed replace, mixed subject [, int &replace_count])",
            "Replaces all occurrences of search in haystack with replace / case-insensitive"
        ],
        "str_pad": [
            "string str_pad(string input, int pad_length [, string pad_string [, int pad_type]])",
            "Returns input string padded on the left or right to specified length with pad_string"
        ],
        "str_repeat": [
            "string str_repeat(string input, int mult)",
            "Returns the input string repeat mult times"
        ],
        "str_replace": [
            "mixed str_replace(mixed search, mixed replace, mixed subject [, int &replace_count])",
            "Replaces all occurrences of search in haystack with replace"
        ],
        "str_rot13": [
            "string str_rot13(string str)",
            "Perform the rot13 transform on a string"
        ],
        "str_shuffle": [
            "void str_shuffle(string str)",
            "Shuffles string. One permutation of all possible is created"
        ],
        "str_split": [
            "array str_split(string str [, int split_length])",
            "Convert a string to an array. If split_length is specified, break the string down into chunks each split_length characters long."
        ],
        "str_word_count": [
            "mixed str_word_count(string str, [int format [, string charlist]])",
            'Counts the number of words inside a string. If format of 1 is specified,     then the function will return an array containing all the words     found inside the string. If format of 2 is specified, then the function     will return an associated array where the position of the word is the key     and the word itself is the value.          For the purpose of this function, \'word\' is defined as a locale dependent     string containing alphabetic characters, which also may contain, but not start     with "\'" and "-" characters.'
        ],
        "strcasecmp": [
            "int strcasecmp(string str1, string str2)",
            "Binary safe case-insensitive string comparison"
        ],
        "strchr": [
            "string strchr(string haystack, string needle)",
            "An alias for strstr"
        ],
        "strcmp": [
            "int strcmp(string str1, string str2)",
            "Binary safe string comparison"
        ],
        "strcoll": [
            "int strcoll(string str1, string str2)",
            "Compares two strings using the current locale"
        ],
        "strcspn": [
            "int strcspn(string str, string mask [, start [, len]])",
            "Finds length of initial segment consisting entirely of characters not found in mask. If start or/and length is provide works like strcspn(substr($s,$start,$len),$bad_chars)"
        ],
        "stream_bucket_append": [
            "void stream_bucket_append(resource brigade, resource bucket)",
            "Append bucket to brigade"
        ],
        "stream_bucket_make_writeable": [
            "object stream_bucket_make_writeable(resource brigade)",
            "Return a bucket object from the brigade for operating on"
        ],
        "stream_bucket_new": [
            "resource stream_bucket_new(resource stream, string buffer)",
            "Create a new bucket for use on the current stream"
        ],
        "stream_bucket_prepend": [
            "void stream_bucket_prepend(resource brigade, resource bucket)",
            "Prepend bucket to brigade"
        ],
        "stream_context_create": [
            "resource stream_context_create([array options[, array params]])",
            "Create a file context and optionally set parameters"
        ],
        "stream_context_get_default": [
            "resource stream_context_get_default([array options])",
            "Get a handle on the default file/stream context and optionally set parameters"
        ],
        "stream_context_get_options": [
            "array stream_context_get_options(resource context|resource stream)",
            "Retrieve options for a stream/wrapper/context"
        ],
        "stream_context_get_params": [
            "array stream_context_get_params(resource context|resource stream)",
            "Get parameters of a file context"
        ],
        "stream_context_set_default": [
            "resource stream_context_set_default(array options)",
            "Set default file/stream context, returns the context as a resource"
        ],
        "stream_context_set_option": [
            "bool stream_context_set_option(resource context|resource stream, string wrappername, string optionname, mixed value)",
            "Set an option for a wrapper"
        ],
        "stream_context_set_params": [
            "bool stream_context_set_params(resource context|resource stream, array options)",
            "Set parameters for a file context"
        ],
        "stream_copy_to_stream": [
            "long stream_copy_to_stream(resource source, resource dest [, long maxlen [, long pos]])",
            "Reads up to maxlen bytes from source stream and writes them to dest stream."
        ],
        "stream_filter_append": [
            "resource stream_filter_append(resource stream, string filtername[, int read_write[, string filterparams]])",
            "Append a filter to a stream"
        ],
        "stream_filter_prepend": [
            "resource stream_filter_prepend(resource stream, string filtername[, int read_write[, string filterparams]])",
            "Prepend a filter to a stream"
        ],
        "stream_filter_register": [
            "bool stream_filter_register(string filtername, string classname)",
            "Registers a custom filter handler class"
        ],
        "stream_filter_remove": [
            "bool stream_filter_remove(resource stream_filter)",
            "Flushes any data in the filter's internal buffer, removes it from the chain, and frees the resource"
        ],
        "stream_get_contents": [
            "string stream_get_contents(resource source [, long maxlen [, long offset]])",
            "Reads all remaining bytes (or up to maxlen bytes) from a stream and returns them as a string."
        ],
        "stream_get_filters": [
            "array stream_get_filters()",
            "Returns a list of registered filters"
        ],
        "stream_get_line": [
            "string stream_get_line(resource stream, int maxlen [, string ending])",
            "Read up to maxlen bytes from a stream or until the ending string is found"
        ],
        "stream_get_meta_data": [
            "array stream_get_meta_data(resource fp)",
            "Retrieves header/meta data from streams/file pointers"
        ],
        "stream_get_transports": [
            "array stream_get_transports()",
            "Retrieves list of registered socket transports"
        ],
        "stream_get_wrappers": [
            "array stream_get_wrappers()",
            "Retrieves list of registered stream wrappers"
        ],
        "stream_is_local": [
            "bool stream_is_local(resource stream|string url)",
            ""
        ],
        "stream_resolve_include_path": [
            "string stream_resolve_include_path(string filename)",
            "Determine what file will be opened by calls to fopen() with a relative path"
        ],
        "stream_select": [
            "int stream_select(array &read_streams, array &write_streams, array &except_streams, int tv_sec[, int tv_usec])",
            "Runs the select() system call on the sets of streams with a timeout specified by tv_sec and tv_usec"
        ],
        "stream_set_blocking": [
            "bool stream_set_blocking(resource socket, int mode)",
            "Set blocking/non-blocking mode on a socket or stream"
        ],
        "stream_set_timeout": [
            "bool stream_set_timeout(resource stream, int seconds [, int microseconds])",
            "Set timeout on stream read to seconds + microseonds"
        ],
        "stream_set_write_buffer": [
            "int stream_set_write_buffer(resource fp, int buffer)",
            "Set file write buffer"
        ],
        "stream_socket_accept": [
            "resource stream_socket_accept(resource serverstream, [ double timeout [, string &peername ]])",
            "Accept a client connection from a server socket"
        ],
        "stream_socket_client": [
            "resource stream_socket_client(string remoteaddress [, long &errcode [, string &errstring [, double timeout [, long flags [, resource context]]]]])",
            "Open a client connection to a remote address"
        ],
        "stream_socket_enable_crypto": [
            "int stream_socket_enable_crypto(resource stream, bool enable [, int cryptokind [, resource sessionstream]])",
            "Enable or disable a specific kind of crypto on the stream"
        ],
        "stream_socket_get_name": [
            "string stream_socket_get_name(resource stream, bool want_peer)",
            "Returns either the locally bound or remote name for a socket stream"
        ],
        "stream_socket_pair": [
            "array stream_socket_pair(int domain, int type, int protocol)",
            "Creates a pair of connected, indistinguishable socket streams"
        ],
        "stream_socket_recvfrom": [
            "string stream_socket_recvfrom(resource stream, long amount [, long flags [, string &remote_addr]])",
            "Receives data from a socket stream"
        ],
        "stream_socket_sendto": [
            "long stream_socket_sendto(resouce stream, string data [, long flags [, string target_addr]])",
            "Send data to a socket stream.  If target_addr is specified it must be in dotted quad (or [ipv6]) format"
        ],
        "stream_socket_server": [
            "resource stream_socket_server(string localaddress [, long &errcode [, string &errstring [, long flags [, resource context]]]])",
            "Create a server socket bound to localaddress"
        ],
        "stream_socket_shutdown": [
            "int stream_socket_shutdown(resource stream, int how)",
            "causes all or part of a full-duplex connection on the socket associated  with stream to be shut down.  If how is SHUT_RD,  further receptions will  be disallowed. If how is SHUT_WR, further transmissions will be disallowed.  If how is SHUT_RDWR,  further  receptions and transmissions will be  disallowed."
        ],
        "stream_supports_lock": [
            "bool stream_supports_lock(resource stream)",
            "Tells whether the stream supports locking through flock()."
        ],
        "stream_wrapper_register": [
            "bool stream_wrapper_register(string protocol, string classname[, integer flags])",
            "Registers a custom URL protocol handler class"
        ],
        "stream_wrapper_restore": [
            "bool stream_wrapper_restore(string protocol)",
            "Restore the original protocol handler, overriding if necessary"
        ],
        "stream_wrapper_unregister": [
            "bool stream_wrapper_unregister(string protocol)",
            "Unregister a wrapper for the life of the current request."
        ],
        "strftime": [
            "string strftime(string format [, int timestamp])",
            "Format a local time/date according to locale settings"
        ],
        "strip_tags": [
            "string strip_tags(string str [, string allowable_tags])",
            "Strips HTML and PHP tags from a string"
        ],
        "stripcslashes": [
            "string stripcslashes(string str)",
            "Strips backslashes from a string. Uses C-style conventions"
        ],
        "stripos": [
            "int stripos(string haystack, string needle [, int offset])",
            "Finds position of first occurrence of a string within another, case insensitive"
        ],
        "stripslashes": [
            "string stripslashes(string str)",
            "Strips backslashes from a string"
        ],
        "stristr": [
            "string stristr(string haystack, string needle[, bool part])",
            "Finds first occurrence of a string within another, case insensitive"
        ],
        "strlen": [
            "int strlen(string str)",
            "Get string length"
        ],
        "strnatcasecmp": [
            "int strnatcasecmp(string s1, string s2)",
            "Returns the result of case-insensitive string comparison using 'natural' algorithm"
        ],
        "strnatcmp": [
            "int strnatcmp(string s1, string s2)",
            "Returns the result of string comparison using 'natural' algorithm"
        ],
        "strncasecmp": [
            "int strncasecmp(string str1, string str2, int len)",
            "Binary safe string comparison"
        ],
        "strncmp": [
            "int strncmp(string str1, string str2, int len)",
            "Binary safe string comparison"
        ],
        "strpbrk": [
            "array strpbrk(string haystack, string char_list)",
            "Search a string for any of a set of characters"
        ],
        "strpos": [
            "int strpos(string haystack, string needle [, int offset])",
            "Finds position of first occurrence of a string within another"
        ],
        "strptime": [
            "string strptime(string timestamp, string format)",
            "Parse a time/date generated with strftime()"
        ],
        "strrchr": [
            "string strrchr(string haystack, string needle)",
            "Finds the last occurrence of a character in a string within another"
        ],
        "strrev": [
            "string strrev(string str)",
            "Reverse a string"
        ],
        "strripos": [
            "int strripos(string haystack, string needle [, int offset])",
            "Finds position of last occurrence of a string within another string"
        ],
        "strrpos": [
            "int strrpos(string haystack, string needle [, int offset])",
            "Finds position of last occurrence of a string within another string"
        ],
        "strspn": [
            "int strspn(string str, string mask [, start [, len]])",
            "Finds length of initial segment consisting entirely of characters found in mask. If start or/and length is provided works like strspn(substr($s,$start,$len),$good_chars)"
        ],
        "strstr": [
            "string strstr(string haystack, string needle[, bool part])",
            "Finds first occurrence of a string within another"
        ],
        "strtok": [
            "string strtok([string str,] string token)",
            "Tokenize a string"
        ],
        "strtolower": [
            "string strtolower(string str)",
            "Makes a string lowercase"
        ],
        "strtotime": [
            "int strtotime(string time [, int now ])",
            "Convert string representation of date and time to a timestamp"
        ],
        "strtoupper": [
            "string strtoupper(string str)",
            "Makes a string uppercase"
        ],
        "strtr": [
            "string strtr(string str, string from[, string to])",
            "Translates characters in str using given translation tables"
        ],
        "strval": [
            "string strval(mixed var)",
            "Get the string value of a variable"
        ],
        "substr": [
            "string substr(string str, int start [, int length])",
            "Returns part of a string"
        ],
        "substr_compare": [
            "int substr_compare(string main_str, string str, int offset [, int length [, bool case_sensitivity]])",
            "Binary safe optionally case insensitive comparison of 2 strings from an offset, up to length characters"
        ],
        "substr_count": [
            "int substr_count(string haystack, string needle [, int offset [, int length]])",
            "Returns the number of times a substring occurs in the string"
        ],
        "substr_replace": [
            "mixed substr_replace(mixed str, mixed repl, mixed start [, mixed length])",
            "Replaces part of a string with another string"
        ],
        "sybase_affected_rows": [
            "int sybase_affected_rows([resource link_id])",
            "Get number of affected rows in last query"
        ],
        "sybase_close": [
            "bool sybase_close([resource link_id])",
            "Close Sybase connection"
        ],
        "sybase_connect": [
            "int sybase_connect([string host [, string user [, string password [, string charset [, string appname [, bool new]]]]]])",
            "Open Sybase server connection"
        ],
        "sybase_data_seek": [
            "bool sybase_data_seek(resource result, int offset)",
            "Move internal row pointer"
        ],
        "sybase_deadlock_retry_count": [
            "void sybase_deadlock_retry_count(int retry_count)",
            "Sets deadlock retry count"
        ],
        "sybase_fetch_array": [
            "array sybase_fetch_array(resource result)",
            "Fetch row as array"
        ],
        "sybase_fetch_assoc": [
            "array sybase_fetch_assoc(resource result)",
            "Fetch row as array without numberic indices"
        ],
        "sybase_fetch_field": [
            "object sybase_fetch_field(resource result [, int offset])",
            "Get field information"
        ],
        "sybase_fetch_object": [
            "object sybase_fetch_object(resource result [, mixed object])",
            "Fetch row as object"
        ],
        "sybase_fetch_row": [
            "array sybase_fetch_row(resource result)",
            "Get row as enumerated array"
        ],
        "sybase_field_seek": [
            "bool sybase_field_seek(resource result, int offset)",
            "Set field offset"
        ],
        "sybase_free_result": [
            "bool sybase_free_result(resource result)",
            "Free result memory"
        ],
        "sybase_get_last_message": [
            "string sybase_get_last_message()",
            "Returns the last message from server (over min_message_severity)"
        ],
        "sybase_min_client_severity": [
            "void sybase_min_client_severity(int severity)",
            "Sets minimum client severity"
        ],
        "sybase_min_server_severity": [
            "void sybase_min_server_severity(int severity)",
            "Sets minimum server severity"
        ],
        "sybase_num_fields": [
            "int sybase_num_fields(resource result)",
            "Get number of fields in result"
        ],
        "sybase_num_rows": [
            "int sybase_num_rows(resource result)",
            "Get number of rows in result"
        ],
        "sybase_pconnect": [
            "int sybase_pconnect([string host [, string user [, string password [, string charset [, string appname]]]]])",
            "Open persistent Sybase connection"
        ],
        "sybase_query": [
            "int sybase_query(string query [, resource link_id])",
            "Send Sybase query"
        ],
        "sybase_result": [
            "string sybase_result(resource result, int row, mixed field)",
            "Get result data"
        ],
        "sybase_select_db": [
            "bool sybase_select_db(string database [, resource link_id])",
            "Select Sybase database"
        ],
        "sybase_set_message_handler": [
            "bool sybase_set_message_handler(mixed error_func [, resource connection])",
            "Set the error handler, to be called when a server message is raised.     If error_func is NULL the handler will be deleted"
        ],
        "sybase_unbuffered_query": [
            "int sybase_unbuffered_query(string query [, resource link_id])",
            "Send Sybase query"
        ],
        "symlink": [
            "int symlink(string target, string link)",
            "Create a symbolic link"
        ],
        "sys_get_temp_dir": [
            "string sys_get_temp_dir()",
            "Returns directory path used for temporary files"
        ],
        "sys_getloadavg": [
            "array sys_getloadavg()",
            ""
        ],
        "syslog": [
            "bool syslog(int priority, string message)",
            "Generate a system log message"
        ],
        "system": [
            "int system(string command [, int &return_value])",
            "Execute an external program and display output"
        ],
        "tan": [
            "float tan(float number)",
            "Returns the tangent of the number in radians"
        ],
        "tanh": [
            "float tanh(float number)",
            "Returns the hyperbolic tangent of the number, defined as sinh(number)/cosh(number)"
        ],
        "tempnam": [
            "string tempnam(string dir, string prefix)",
            "Create a unique filename in a directory"
        ],
        "textdomain": [
            "string textdomain(string domain)",
            'Set the textdomain to "domain". Returns the current domain'
        ],
        "tidy_access_count": [
            "int tidy_access_count()",
            "Returns the Number of Tidy accessibility warnings encountered for specified document."
        ],
        "tidy_clean_repair": [
            "bool tidy_clean_repair()",
            "Execute configured cleanup and repair operations on parsed markup"
        ],
        "tidy_config_count": [
            "int tidy_config_count()",
            "Returns the Number of Tidy configuration errors encountered for specified document."
        ],
        "tidy_diagnose": [
            "bool tidy_diagnose()",
            "Run configured diagnostics on parsed and repaired markup."
        ],
        "tidy_error_count": [
            "int tidy_error_count()",
            "Returns the Number of Tidy errors encountered for specified document."
        ],
        "tidy_get_body": [
            "TidyNode tidy_get_body(resource tidy)",
            "Returns a TidyNode Object starting from the <BODY> tag of the tidy parse tree"
        ],
        "tidy_get_config": [
            "array tidy_get_config()",
            "Get current Tidy configuarion"
        ],
        "tidy_get_error_buffer": [
            "string tidy_get_error_buffer([bool detailed])",
            "Return warnings and errors which occured parsing the specified document"
        ],
        "tidy_get_head": [
            "TidyNode tidy_get_head()",
            "Returns a TidyNode Object starting from the <HEAD> tag of the tidy parse tree"
        ],
        "tidy_get_html": [
            "TidyNode tidy_get_html()",
            "Returns a TidyNode Object starting from the <HTML> tag of the tidy parse tree"
        ],
        "tidy_get_html_ver": [
            "int tidy_get_html_ver()",
            "Get the Detected HTML version for the specified document."
        ],
        "tidy_get_opt_doc": [
            "string tidy_get_opt_doc(tidy resource, string optname)",
            "Returns the documentation for the given option name"
        ],
        "tidy_get_output": [
            "string tidy_get_output()",
            "Return a string representing the parsed tidy markup"
        ],
        "tidy_get_release": [
            "string tidy_get_release()",
            "Get release date (version) for Tidy library"
        ],
        "tidy_get_root": [
            "TidyNode tidy_get_root()",
            "Returns a TidyNode Object representing the root of the tidy parse tree"
        ],
        "tidy_get_status": [
            "int tidy_get_status()",
            "Get status of specfied document."
        ],
        "tidy_getopt": [
            "mixed tidy_getopt(string option)",
            "Returns the value of the specified configuration option for the tidy document."
        ],
        "tidy_is_xhtml": [
            "bool tidy_is_xhtml()",
            "Indicates if the document is a XHTML document."
        ],
        "tidy_is_xml": [
            "bool tidy_is_xml()",
            "Indicates if the document is a generic (non HTML/XHTML) XML document."
        ],
        "tidy_parse_file": [
            "bool tidy_parse_file(string file [, mixed config_options [, string encoding [, bool use_include_path]]])",
            "Parse markup in file or URI"
        ],
        "tidy_parse_string": [
            "bool tidy_parse_string(string input [, mixed config_options [, string encoding]])",
            "Parse a document stored in a string"
        ],
        "tidy_repair_file": [
            "bool tidy_repair_file(string filename [, mixed config_file [, string encoding [, bool use_include_path]]])",
            "Repair a file using an optionally provided configuration file"
        ],
        "tidy_repair_string": [
            "bool tidy_repair_string(string data [, mixed config_file [, string encoding]])",
            "Repair a string using an optionally provided configuration file"
        ],
        "tidy_warning_count": [
            "int tidy_warning_count()",
            "Returns the Number of Tidy warnings encountered for specified document."
        ],
        "time": [
            "int time()",
            "Return current UNIX timestamp"
        ],
        "time_nanosleep": [
            "mixed time_nanosleep(long seconds, long nanoseconds)",
            "Delay for a number of seconds and nano seconds"
        ],
        "time_sleep_until": [
            "mixed time_sleep_until(float timestamp)",
            "Make the script sleep until the specified time"
        ],
        "timezone_abbreviations_list": [
            "array timezone_abbreviations_list()",
            "Returns associative array containing dst, offset and the timezone name"
        ],
        "timezone_identifiers_list": [
            "array timezone_identifiers_list([long what[, string country]])",
            "Returns numerically index array with all timezone identifiers."
        ],
        "timezone_location_get": [
            "array timezone_location_get()",
            "Returns location information for a timezone, including country code, latitude/longitude and comments"
        ],
        "timezone_name_from_abbr": [
            "string timezone_name_from_abbr(string abbr[, long gmtOffset[, long isdst]])",
            "Returns the timezone name from abbrevation"
        ],
        "timezone_name_get": [
            "string timezone_name_get(DateTimeZone object)",
            "Returns the name of the timezone."
        ],
        "timezone_offset_get": [
            "long timezone_offset_get(DateTimeZone object, DateTime object)",
            "Returns the timezone offset."
        ],
        "timezone_open": [
            "DateTimeZone timezone_open(string timezone)",
            "Returns new DateTimeZone object"
        ],
        "timezone_transitions_get": [
            "array timezone_transitions_get(DateTimeZone object [, long timestamp_begin [, long timestamp_end ]])",
            "Returns numerically indexed array containing associative array for all transitions in the specified range for the timezone."
        ],
        "timezone_version_get": [
            "array timezone_version_get()",
            "Returns the Olson database version number."
        ],
        "tmpfile": [
            "resource tmpfile()",
            "Create a temporary file that will be deleted automatically after use"
        ],
        "token_get_all": [
            "array token_get_all(string source)",
            ""
        ],
        "token_name": [
            "string token_name(int type)",
            ""
        ],
        "touch": [
            "bool touch(string filename [, int time [, int atime]])",
            "Set modification time of file"
        ],
        "trigger_error": [
            "void trigger_error(string messsage [, int error_type])",
            "Generates a user-level error/warning/notice message"
        ],
        "trim": [
            "string trim(string str [, string character_mask])",
            "Strips whitespace from the beginning and end of a string"
        ],
        "uasort": [
            "bool uasort(array array_arg, string cmp_function)",
            "Sort an array with a user-defined comparison function and maintain index association"
        ],
        "ucfirst": [
            "string ucfirst(string str)",
            "Make a string's first character lowercase"
        ],
        "ucwords": [
            "string ucwords(string str)",
            "Uppercase the first character of every word in a string"
        ],
        "uksort": [
            "bool uksort(array array_arg, string cmp_function)",
            "Sort an array by keys using a user-defined comparison function"
        ],
        "umask": [
            "int umask([int mask])",
            "Return or change the umask"
        ],
        "uniqid": [
            "string uniqid([string prefix [, bool more_entropy]])",
            "Generates a unique ID"
        ],
        "unixtojd": [
            "int unixtojd([int timestamp])",
            "Convert UNIX timestamp to Julian Day"
        ],
        "unlink": [
            "bool unlink(string filename[, context context])",
            "Delete a file"
        ],
        "unpack": [
            "array unpack(string format, string input)",
            "Unpack binary string into named array elements according to format argument"
        ],
        "unregister_tick_function": [
            "void unregister_tick_function(string function_name)",
            "Unregisters a tick callback function"
        ],
        "unserialize": [
            "mixed unserialize(string variable_representation)",
            "Takes a string representation of variable and recreates it"
        ],
        "unset": [
            "void unset(mixed var [, mixed var])",
            "Unset a given variable"
        ],
        "urldecode": [
            "string urldecode(string str)",
            "Decodes URL-encoded string"
        ],
        "urlencode": [
            "string urlencode(string str)",
            "URL-encodes string"
        ],
        "usleep": [
            "void usleep(int micro_seconds)",
            "Delay for a given number of micro seconds"
        ],
        "usort": [
            "bool usort(array array_arg, string cmp_function)",
            "Sort an array by values using a user-defined comparison function"
        ],
        "utf8_decode": [
            "string utf8_decode(string data)",
            "Converts a UTF-8 encoded string to ISO-8859-1"
        ],
        "utf8_encode": [
            "string utf8_encode(string data)",
            "Encodes an ISO-8859-1 string to UTF-8"
        ],
        "var_dump": [
            "void var_dump(mixed var)",
            "Dumps a string representation of variable to output"
        ],
        "var_export": [
            "string var_export(mixed var [, bool return])",
            "Outputs or returns a string representation of a variable"
        ],
        "variant_abs": [
            "mixed variant_abs(mixed left)",
            "Returns the absolute value of a variant"
        ],
        "variant_add": [
            "mixed variant_add(mixed left, mixed right)",
            '"Adds" two variant values together and returns the result'
        ],
        "variant_and": [
            "mixed variant_and(mixed left, mixed right)",
            "performs a bitwise AND operation between two variants and returns the result"
        ],
        "variant_cast": [
            "object variant_cast(object variant, int type)",
            "Convert a variant into a new variant object of another type"
        ],
        "variant_cat": [
            "mixed variant_cat(mixed left, mixed right)",
            "concatenates two variant values together and returns the result"
        ],
        "variant_cmp": [
            "int variant_cmp(mixed left, mixed right [, int lcid [, int flags]])",
            "Compares two variants"
        ],
        "variant_date_from_timestamp": [
            "object variant_date_from_timestamp(int timestamp)",
            "Returns a variant date representation of a unix timestamp"
        ],
        "variant_date_to_timestamp": [
            "int variant_date_to_timestamp(object variant)",
            "Converts a variant date/time value to unix timestamp"
        ],
        "variant_div": [
            "mixed variant_div(mixed left, mixed right)",
            "Returns the result from dividing two variants"
        ],
        "variant_eqv": [
            "mixed variant_eqv(mixed left, mixed right)",
            "Performs a bitwise equivalence on two variants"
        ],
        "variant_fix": [
            "mixed variant_fix(mixed left)",
            "Returns the integer part ? of a variant"
        ],
        "variant_get_type": [
            "int variant_get_type(object variant)",
            "Returns the VT_XXX type code for a variant"
        ],
        "variant_idiv": [
            "mixed variant_idiv(mixed left, mixed right)",
            "Converts variants to integers and then returns the result from dividing them"
        ],
        "variant_imp": [
            "mixed variant_imp(mixed left, mixed right)",
            "Performs a bitwise implication on two variants"
        ],
        "variant_int": [
            "mixed variant_int(mixed left)",
            "Returns the integer portion of a variant"
        ],
        "variant_mod": [
            "mixed variant_mod(mixed left, mixed right)",
            "Divides two variants and returns only the remainder"
        ],
        "variant_mul": [
            "mixed variant_mul(mixed left, mixed right)",
            "multiplies the values of the two variants and returns the result"
        ],
        "variant_neg": [
            "mixed variant_neg(mixed left)",
            "Performs logical negation on a variant"
        ],
        "variant_not": [
            "mixed variant_not(mixed left)",
            "Performs bitwise not negation on a variant"
        ],
        "variant_or": [
            "mixed variant_or(mixed left, mixed right)",
            "Performs a logical disjunction on two variants"
        ],
        "variant_pow": [
            "mixed variant_pow(mixed left, mixed right)",
            "Returns the result of performing the power function with two variants"
        ],
        "variant_round": [
            "mixed variant_round(mixed left, int decimals)",
            "Rounds a variant to the specified number of decimal places"
        ],
        "variant_set": [
            "void variant_set(object variant, mixed value)",
            "Assigns a new value for a variant object"
        ],
        "variant_set_type": [
            "void variant_set_type(object variant, int type)",
            'Convert a variant into another type.  Variant is modified "in-place"'
        ],
        "variant_sub": [
            "mixed variant_sub(mixed left, mixed right)",
            "subtracts the value of the right variant from the left variant value and returns the result"
        ],
        "variant_xor": [
            "mixed variant_xor(mixed left, mixed right)",
            "Performs a logical exclusion on two variants"
        ],
        "version_compare": [
            "int version_compare(string ver1, string ver2 [, string oper])",
            'Compares two "PHP-standardized" version number strings'
        ],
        "vfprintf": [
            "int vfprintf(resource stream, string format, array args)",
            "Output a formatted string into a stream"
        ],
        "virtual": [
            "bool virtual(string filename)",
            "Perform an Apache sub-request"
        ],
        "vprintf": [
            "int vprintf(string format, array args)",
            "Output a formatted string"
        ],
        "vsprintf": [
            "string vsprintf(string format, array args)",
            "Return a formatted string"
        ],
        "wddx_add_vars": [
            "int wddx_add_vars(resource packet_id, mixed var_names [, mixed ...])",
            "Serializes given variables and adds them to packet given by packet_id"
        ],
        "wddx_deserialize": [
            "mixed wddx_deserialize(mixed packet)",
            "Deserializes given packet and returns a PHP value"
        ],
        "wddx_packet_end": [
            "string wddx_packet_end(resource packet_id)",
            "Ends specified WDDX packet and returns the string containing the packet"
        ],
        "wddx_packet_start": [
            "resource wddx_packet_start([string comment])",
            "Starts a WDDX packet with optional comment and returns the packet id"
        ],
        "wddx_serialize_value": [
            "string wddx_serialize_value(mixed var [, string comment])",
            "Creates a new packet and serializes the given value"
        ],
        "wddx_serialize_vars": [
            "string wddx_serialize_vars(mixed var_name [, mixed ...])",
            "Creates a new packet and serializes given variables into a struct"
        ],
        "wordwrap": [
            "string wordwrap(string str [, int width [, string break [, bool cut]]])",
            "Wraps buffer to selected number of characters using string break char"
        ],
        "xml_error_string": [
            "string xml_error_string(int code)",
            "Get XML parser error string"
        ],
        "xml_get_current_byte_index": [
            "int xml_get_current_byte_index(resource parser)",
            "Get current byte index for an XML parser"
        ],
        "xml_get_current_column_number": [
            "int xml_get_current_column_number(resource parser)",
            "Get current column number for an XML parser"
        ],
        "xml_get_current_line_number": [
            "int xml_get_current_line_number(resource parser)",
            "Get current line number for an XML parser"
        ],
        "xml_get_error_code": [
            "int xml_get_error_code(resource parser)",
            "Get XML parser error code"
        ],
        "xml_parse": [
            "int xml_parse(resource parser, string data [, int isFinal])",
            "Start parsing an XML document"
        ],
        "xml_parse_into_struct": [
            "int xml_parse_into_struct(resource parser, string data, array &values [, array &index ])",
            "Parsing a XML document"
        ],
        "xml_parser_create": [
            "resource xml_parser_create([string encoding])",
            "Create an XML parser"
        ],
        "xml_parser_create_ns": [
            "resource xml_parser_create_ns([string encoding [, string sep]])",
            "Create an XML parser"
        ],
        "xml_parser_free": [
            "int xml_parser_free(resource parser)",
            "Free an XML parser"
        ],
        "xml_parser_get_option": [
            "int xml_parser_get_option(resource parser, int option)",
            "Get options from an XML parser"
        ],
        "xml_parser_set_option": [
            "int xml_parser_set_option(resource parser, int option, mixed value)",
            "Set options in an XML parser"
        ],
        "xml_set_character_data_handler": [
            "int xml_set_character_data_handler(resource parser, string hdl)",
            "Set up character data handler"
        ],
        "xml_set_default_handler": [
            "int xml_set_default_handler(resource parser, string hdl)",
            "Set up default handler"
        ],
        "xml_set_element_handler": [
            "int xml_set_element_handler(resource parser, string shdl, string ehdl)",
            "Set up start and end element handlers"
        ],
        "xml_set_end_namespace_decl_handler": [
            "int xml_set_end_namespace_decl_handler(resource parser, string hdl)",
            "Set up character data handler"
        ],
        "xml_set_external_entity_ref_handler": [
            "int xml_set_external_entity_ref_handler(resource parser, string hdl)",
            "Set up external entity reference handler"
        ],
        "xml_set_notation_decl_handler": [
            "int xml_set_notation_decl_handler(resource parser, string hdl)",
            "Set up notation declaration handler"
        ],
        "xml_set_object": [
            "int xml_set_object(resource parser, object &obj)",
            "Set up object which should be used for callbacks"
        ],
        "xml_set_processing_instruction_handler": [
            "int xml_set_processing_instruction_handler(resource parser, string hdl)",
            "Set up processing instruction (PI) handler"
        ],
        "xml_set_start_namespace_decl_handler": [
            "int xml_set_start_namespace_decl_handler(resource parser, string hdl)",
            "Set up character data handler"
        ],
        "xml_set_unparsed_entity_decl_handler": [
            "int xml_set_unparsed_entity_decl_handler(resource parser, string hdl)",
            "Set up unparsed entity declaration handler"
        ],
        "xmlrpc_decode": [
            "array xmlrpc_decode(string xml [, string encoding])",
            "Decodes XML into native PHP types"
        ],
        "xmlrpc_decode_request": [
            "array xmlrpc_decode_request(string xml, string& method [, string encoding])",
            "Decodes XML into native PHP types"
        ],
        "xmlrpc_encode": [
            "string xmlrpc_encode(mixed value)",
            "Generates XML for a PHP value"
        ],
        "xmlrpc_encode_request": [
            "string xmlrpc_encode_request(string method, mixed params [, array output_options])",
            "Generates XML for a method request"
        ],
        "xmlrpc_get_type": [
            "string xmlrpc_get_type(mixed value)",
            "Gets xmlrpc type for a PHP value. Especially useful for base64 and datetime strings"
        ],
        "xmlrpc_is_fault": [
            "bool xmlrpc_is_fault(array)",
            "Determines if an array value represents an XMLRPC fault."
        ],
        "xmlrpc_parse_method_descriptions": [
            "array xmlrpc_parse_method_descriptions(string xml)",
            "Decodes XML into a list of method descriptions"
        ],
        "xmlrpc_server_add_introspection_data": [
            "int xmlrpc_server_add_introspection_data(resource server, array desc)",
            "Adds introspection documentation"
        ],
        "xmlrpc_server_call_method": [
            "mixed xmlrpc_server_call_method(resource server, string xml, mixed user_data [, array output_options])",
            "Parses XML requests and call methods"
        ],
        "xmlrpc_server_create": [
            "resource xmlrpc_server_create()",
            "Creates an xmlrpc server"
        ],
        "xmlrpc_server_destroy": [
            "int xmlrpc_server_destroy(resource server)",
            "Destroys server resources"
        ],
        "xmlrpc_server_register_introspection_callback": [
            "bool xmlrpc_server_register_introspection_callback(resource server, string function)",
            "Register a PHP function to generate documentation"
        ],
        "xmlrpc_server_register_method": [
            "bool xmlrpc_server_register_method(resource server, string method_name, string function)",
            "Register a PHP function to handle method matching method_name"
        ],
        "xmlrpc_set_type": [
            "bool xmlrpc_set_type(string value, string type)",
            "Sets xmlrpc type, base64 or datetime, for a PHP string value"
        ],
        "xmlwriter_end_attribute": [
            "bool xmlwriter_end_attribute(resource xmlwriter)",
            "End attribute - returns FALSE on error"
        ],
        "xmlwriter_end_cdata": [
            "bool xmlwriter_end_cdata(resource xmlwriter)",
            "End current CDATA - returns FALSE on error"
        ],
        "xmlwriter_end_comment": [
            "bool xmlwriter_end_comment(resource xmlwriter)",
            "Create end comment - returns FALSE on error"
        ],
        "xmlwriter_end_document": [
            "bool xmlwriter_end_document(resource xmlwriter)",
            "End current document - returns FALSE on error"
        ],
        "xmlwriter_end_dtd": [
            "bool xmlwriter_end_dtd(resource xmlwriter)",
            "End current DTD - returns FALSE on error"
        ],
        "xmlwriter_end_dtd_attlist": [
            "bool xmlwriter_end_dtd_attlist(resource xmlwriter)",
            "End current DTD AttList - returns FALSE on error"
        ],
        "xmlwriter_end_dtd_element": [
            "bool xmlwriter_end_dtd_element(resource xmlwriter)",
            "End current DTD element - returns FALSE on error"
        ],
        "xmlwriter_end_dtd_entity": [
            "bool xmlwriter_end_dtd_entity(resource xmlwriter)",
            "End current DTD Entity - returns FALSE on error"
        ],
        "xmlwriter_end_element": [
            "bool xmlwriter_end_element(resource xmlwriter)",
            "End current element - returns FALSE on error"
        ],
        "xmlwriter_end_pi": [
            "bool xmlwriter_end_pi(resource xmlwriter)",
            "End current PI - returns FALSE on error"
        ],
        "xmlwriter_flush": [
            "mixed xmlwriter_flush(resource xmlwriter [,bool empty])",
            "Output current buffer"
        ],
        "xmlwriter_full_end_element": [
            "bool xmlwriter_full_end_element(resource xmlwriter)",
            "End current element - returns FALSE on error"
        ],
        "xmlwriter_open_memory": [
            "resource xmlwriter_open_memory()",
            "Create new xmlwriter using memory for string output"
        ],
        "xmlwriter_open_uri": [
            "resource xmlwriter_open_uri(resource xmlwriter, string source)",
            "Create new xmlwriter using source uri for output"
        ],
        "xmlwriter_output_memory": [
            "string xmlwriter_output_memory(resource xmlwriter [,bool flush])",
            "Output current buffer as string"
        ],
        "xmlwriter_set_indent": [
            "bool xmlwriter_set_indent(resource xmlwriter, bool indent)",
            "Toggle indentation on/off - returns FALSE on error"
        ],
        "xmlwriter_set_indent_string": [
            "bool xmlwriter_set_indent_string(resource xmlwriter, string indentString)",
            "Set string used for indenting - returns FALSE on error"
        ],
        "xmlwriter_start_attribute": [
            "bool xmlwriter_start_attribute(resource xmlwriter, string name)",
            "Create start attribute - returns FALSE on error"
        ],
        "xmlwriter_start_attribute_ns": [
            "bool xmlwriter_start_attribute_ns(resource xmlwriter, string prefix, string name, string uri)",
            "Create start namespaced attribute - returns FALSE on error"
        ],
        "xmlwriter_start_cdata": [
            "bool xmlwriter_start_cdata(resource xmlwriter)",
            "Create start CDATA tag - returns FALSE on error"
        ],
        "xmlwriter_start_comment": [
            "bool xmlwriter_start_comment(resource xmlwriter)",
            "Create start comment - returns FALSE on error"
        ],
        "xmlwriter_start_document": [
            "bool xmlwriter_start_document(resource xmlwriter, string version, string encoding, string standalone)",
            "Create document tag - returns FALSE on error"
        ],
        "xmlwriter_start_dtd": [
            "bool xmlwriter_start_dtd(resource xmlwriter, string name, string pubid, string sysid)",
            "Create start DTD tag - returns FALSE on error"
        ],
        "xmlwriter_start_dtd_attlist": [
            "bool xmlwriter_start_dtd_attlist(resource xmlwriter, string name)",
            "Create start DTD AttList - returns FALSE on error"
        ],
        "xmlwriter_start_dtd_element": [
            "bool xmlwriter_start_dtd_element(resource xmlwriter, string name)",
            "Create start DTD element - returns FALSE on error"
        ],
        "xmlwriter_start_dtd_entity": [
            "bool xmlwriter_start_dtd_entity(resource xmlwriter, string name, bool isparam)",
            "Create start DTD Entity - returns FALSE on error"
        ],
        "xmlwriter_start_element": [
            "bool xmlwriter_start_element(resource xmlwriter, string name)",
            "Create start element tag - returns FALSE on error"
        ],
        "xmlwriter_start_element_ns": [
            "bool xmlwriter_start_element_ns(resource xmlwriter, string prefix, string name, string uri)",
            "Create start namespaced element tag - returns FALSE on error"
        ],
        "xmlwriter_start_pi": [
            "bool xmlwriter_start_pi(resource xmlwriter, string target)",
            "Create start PI tag - returns FALSE on error"
        ],
        "xmlwriter_text": [
            "bool xmlwriter_text(resource xmlwriter, string content)",
            "Write text - returns FALSE on error"
        ],
        "xmlwriter_write_attribute": [
            "bool xmlwriter_write_attribute(resource xmlwriter, string name, string content)",
            "Write full attribute - returns FALSE on error"
        ],
        "xmlwriter_write_attribute_ns": [
            "bool xmlwriter_write_attribute_ns(resource xmlwriter, string prefix, string name, string uri, string content)",
            "Write full namespaced attribute - returns FALSE on error"
        ],
        "xmlwriter_write_cdata": [
            "bool xmlwriter_write_cdata(resource xmlwriter, string content)",
            "Write full CDATA tag - returns FALSE on error"
        ],
        "xmlwriter_write_comment": [
            "bool xmlwriter_write_comment(resource xmlwriter, string content)",
            "Write full comment tag - returns FALSE on error"
        ],
        "xmlwriter_write_dtd": [
            "bool xmlwriter_write_dtd(resource xmlwriter, string name, string pubid, string sysid, string subset)",
            "Write full DTD tag - returns FALSE on error"
        ],
        "xmlwriter_write_dtd_attlist": [
            "bool xmlwriter_write_dtd_attlist(resource xmlwriter, string name, string content)",
            "Write full DTD AttList tag - returns FALSE on error"
        ],
        "xmlwriter_write_dtd_element": [
            "bool xmlwriter_write_dtd_element(resource xmlwriter, string name, string content)",
            "Write full DTD element tag - returns FALSE on error"
        ],
        "xmlwriter_write_dtd_entity": [
            "bool xmlwriter_write_dtd_entity(resource xmlwriter, string name, string content [, int pe [, string pubid [, string sysid [, string ndataid]]]])",
            "Write full DTD Entity tag - returns FALSE on error"
        ],
        "xmlwriter_write_element": [
            "bool xmlwriter_write_element(resource xmlwriter, string name[, string content])",
            "Write full element tag - returns FALSE on error"
        ],
        "xmlwriter_write_element_ns": [
            "bool xmlwriter_write_element_ns(resource xmlwriter, string prefix, string name, string uri[, string content])",
            "Write full namespaced element tag - returns FALSE on error"
        ],
        "xmlwriter_write_pi": [
            "bool xmlwriter_write_pi(resource xmlwriter, string target, string content)",
            "Write full PI tag - returns FALSE on error"
        ],
        "xmlwriter_write_raw": [
            "bool xmlwriter_write_raw(resource xmlwriter, string content)",
            "Write text - returns FALSE on error"
        ],
        "xsl_xsltprocessor_get_parameter": [
            "string xsl_xsltprocessor_get_parameter(string namespace, string name)",
            ""
        ],
        "xsl_xsltprocessor_has_exslt_support": [
            "bool xsl_xsltprocessor_has_exslt_support()",
            ""
        ],
        "xsl_xsltprocessor_import_stylesheet": [
            "void xsl_xsltprocessor_import_stylesheet(domdocument doc)",
            ""
        ],
        "xsl_xsltprocessor_register_php_functions": [
            "void xsl_xsltprocessor_register_php_functions([mixed $restrict])",
            ""
        ],
        "xsl_xsltprocessor_remove_parameter": [
            "bool xsl_xsltprocessor_remove_parameter(string namespace, string name)",
            ""
        ],
        "xsl_xsltprocessor_set_parameter": [
            "bool xsl_xsltprocessor_set_parameter(string namespace, mixed name [, string value])",
            ""
        ],
        "xsl_xsltprocessor_set_profiling": [
            "bool xsl_xsltprocessor_set_profiling(string filename)",
            ""
        ],
        "xsl_xsltprocessor_transform_to_doc": [
            "domdocument xsl_xsltprocessor_transform_to_doc(domnode doc)",
            ""
        ],
        "xsl_xsltprocessor_transform_to_uri": [
            "int xsl_xsltprocessor_transform_to_uri(domdocument doc, string uri)",
            ""
        ],
        "xsl_xsltprocessor_transform_to_xml": [
            "string xsl_xsltprocessor_transform_to_xml(domdocument doc)",
            ""
        ],
        "zend_logo_guid": [
            "string zend_logo_guid()",
            "Return the special ID used to request the Zend logo in phpinfo screens"
        ],
        "zend_version": [
            "string zend_version()",
            "Get the version of the Zend Engine"
        ],
        "zip_close": [
            "void zip_close(resource zip)",
            "Close a Zip archive"
        ],
        "zip_entry_close": [
            "void zip_entry_close(resource zip_ent)",
            "Close a zip entry"
        ],
        "zip_entry_compressedsize": [
            "int zip_entry_compressedsize(resource zip_entry)",
            "Return the compressed size of a ZZip entry"
        ],
        "zip_entry_compressionmethod": [
            "string zip_entry_compressionmethod(resource zip_entry)",
            "Return a string containing the compression method used on a particular entry"
        ],
        "zip_entry_filesize": [
            "int zip_entry_filesize(resource zip_entry)",
            "Return the actual filesize of a ZZip entry"
        ],
        "zip_entry_name": [
            "string zip_entry_name(resource zip_entry)",
            "Return the name given a ZZip entry"
        ],
        "zip_entry_open": [
            "bool zip_entry_open(resource zip_dp, resource zip_entry [, string mode])",
            "Open a Zip File, pointed by the resource entry"
        ],
        "zip_entry_read": [
            "mixed zip_entry_read(resource zip_entry [, int len])",
            "Read from an open directory entry"
        ],
        "zip_open": [
            "resource zip_open(string filename)",
            "Create new zip using source uri for output"
        ],
        "zip_read": [
            "resource zip_read(resource zip)",
            "Returns the next file in the archive"
        ],
        "zlib_get_coding_type": [
            "string zlib_get_coding_type()",
            "Returns the coding type used for output compression"
        ],
        "array_column": [
            "array_column(array $array, int|string|null $column_key, int|string|null $index_key = null): array",
            "Return the values from a single column in the input array"
        ],
        "boolval": [
            "boolval(mixed $value): bool",
            "Get the boolean value of a variable"
        ],
        "bzclose": [
            "bzclose(resource $bz): bool",
            "Close a bzip2 file"
        ],
        "bzflush": [
            "bzflush(resource $bz): bool",
            "Do nothing"
        ],
        "bzwrite": [
            "bzwrite(resource $bz, string $data, ?int $length = null): int|false",
            "Binary safe bzip2 file write"
        ],
        "checkdnsrr": [
            "checkdnsrr(string $hostname, string $type = &quot;MX&quot;): bool",
            "Check DNS records corresponding to a given Internet host name or IP address"
        ],
        "chop": [
            "chop()",
            "Alias of rtrim()"
        ],
        "class_uses": [
            "class_uses(object|string $object_or_class, bool $autoload = true): array|false",
            ""
        ],
        "curl_escape": [
            "curl_escape(CurlHandle $handle, string $string): string|false",
            "URL encodes the given string"
        ],
        "curl_file_create": [
            "curl_file_create()",
            "Create a CURLFile object"
        ],
        "curl_multi_errno": [
            "curl_multi_errno(CurlMultiHandle $multi_handle): int",
            "Return the last multi curl error number"
        ],
        "curl_multi_setopt": [
            "curl_multi_setopt(CurlMultiHandle $multi_handle, int $option, mixed $value): bool",
            "Set an option for the cURL multi handle"
        ],
        "curl_multi_strerror": [
            "curl_multi_strerror(int $error_code): ?string",
            "Return string describing error code"
        ],
        "curl_pause": [
            "curl_pause(CurlHandle $handle, int $flags): int",
            "Pause and unpause a connection"
        ],
        "curl_reset": [
            "curl_reset(CurlHandle $handle): void",
            "Reset all options of a libcurl session handle"
        ],
        "curl_share_close": [
            "curl_share_close(CurlShareHandle $share_handle): void",
            "Close a cURL share handle"
        ],
        "curl_share_errno": [
            "curl_share_errno(CurlShareHandle $share_handle): int",
            "Return the last share curl error number"
        ],
        "curl_share_init": [
            "curl_share_init(): CurlShareHandle",
            "Initialize a cURL share handle"
        ],
        "curl_share_setopt": [
            "curl_share_setopt(CurlShareHandle $share_handle, int $option, mixed $value): bool",
            "Set an option for a cURL share handle"
        ],
        "curl_share_strerror": [
            "curl_share_strerror(int $error_code): ?string",
            "Return string describing the given error code"
        ],
        "curl_strerror": [
            "curl_strerror(int $error_code): ?string",
            "Return string describing the given error code"
        ],
        "curl_unescape": [
            "curl_unescape(CurlHandle $handle, string $string): string|false",
            "Decodes the given URL encoded string"
        ],
        "date_create_immutable_from_format": [
            "date_create_immutable_from_format()",
            "Alias of DateTimeImmutable::createFromFormat()"
        ],
        "date_create_immutable": [
            "date_create_immutable()",
            "Alias of DateTimeImmutable::__construct()"
        ],
        "deflate_add": [
            "deflate_add(DeflateContext $context, string $data, int $flush_mode = ZLIB_SYNC_FLUSH): string|false",
            "Incrementally deflate data"
        ],
        "deflate_init": [
            "deflate_init(int $encoding, array $options = []): DeflateContext|false",
            "Initialize an incremental deflate context"
        ],
        "delete": [
            "delete()",
            "See unlink()"
        ],
        "diskfreespace": [
            "diskfreespace()",
            "Alias of disk_free_space()"
        ],
        "doubleval": [
            "doubleval()",
            "Alias of floatval()"
        ],
        "enchant_dict_add": [
            "enchant_dict_add(EnchantDictionary $dictionary, string $word): void",
            "Add a word to personal word list"
        ],
        "enchant_dict_is_added": [
            "enchant_dict_is_added(EnchantDictionary $dictionary, string $word): bool",
            "Whether or not &#039;word&#039; exists in this spelling-session"
        ],
        "error_clear_last": [
            "error_clear_last(): void",
            "Clear the most recent error"
        ],
        "eval": [
            "eval(string $code): mixed",
            "Evaluate a string as PHP code"
        ],
        "expect_expectl": [
            "expect_expectl(resource $expect, array $cases, array &$match = ?): int",
            ""
        ],
        "expect_popen": [
            "expect_popen(string $command): resource",
            ""
        ],
        "fdiv": [
            "fdiv(float $num1, float $num2): float",
            "Divides two numbers, according to IEEE 754"
        ],
        "filter_id": [
            "filter_id(string $name): int|false",
            "Returns the filter ID belonging to a named filter"
        ],
        "filter_list": [
            "filter_list(): array",
            "Returns a list of all supported filters"
        ],
        "forward_static_call_array": [
            "forward_static_call_array(callable $callback, array $args): mixed",
            "Call a static method and pass the arguments as array"
        ],
        "fputs": [
            "fputs()",
            "Alias of fwrite()"
        ],
        "ftp_append": [
            "ftp_append(FTP\\Connection $ftp, string $remote_filename, string $local_filename, int $mode = FTP_BINARY): bool",
            "Append the contents of a file to another file on the FTP server"
        ],
        "ftp_mlsd": [
            "ftp_mlsd(FTP\\Connection $ftp, string $directory): array|false",
            "Returns a list of files in the given directory"
        ],
        "ftp_quit": [
            "ftp_quit()",
            "Alias of ftp_close()"
        ],
        "gc_mem_caches": [
            "gc_mem_caches(): int",
            ""
        ],
        "gc_status": [
            "gc_status(): array",
            "Gets information about the garbage collector"
        ],
        "get_debug_type": [
            "get_debug_type(mixed $value): string",
            "Gets the type name of a variable in a way that is suitable for debugging"
        ],
        "get_declared_traits": [
            "get_declared_traits(): array",
            "Returns an array of all declared traits"
        ],
        "get_required_files": [
            "get_required_files()",
            "Alias of get_included_files()"
        ],
        "get_resource_id": [
            "get_resource_id(resource $resource): int",
            ""
        ],
        "get_resources": [
            "get_resources(?string $type = null): array",
            "Returns active resources"
        ],
        "getimagesizefromstring": [
            "getimagesizefromstring(string $string, array &$image_info = null): array|false",
            "Get the size of an image from a string"
        ],
        "getmxrr": [
            "getmxrr(string $hostname, array &$hosts, array &$weights = null): bool",
            "Get MX records corresponding to a given Internet host name"
        ],
        "gmp_binomial": [
            "gmp_binomial(GMP|int|string $n, int $k): GMP",
            "Calculates binomial coefficient"
        ],
        "gmp_div": [
            "gmp_div()",
            "Alias of gmp_div_q()"
        ],
        "gmp_export": [
            "gmp_export(GMP|int|string $num, int $word_size = 1, int $flags = GMP_MSW_FIRST | GMP_NATIVE_ENDIAN): string",
            "Export to a binary string"
        ],
        "gmp_import": [
            "gmp_import(string $data, int $word_size = 1, int $flags = GMP_MSW_FIRST | GMP_NATIVE_ENDIAN): GMP",
            "Import from a binary string"
        ],
        "gmp_kronecker": [
            "gmp_kronecker(GMP|int|string $num1, GMP|int|string $num2): int",
            "Kronecker symbol"
        ],
        "gmp_lcm": [
            "gmp_lcm(GMP|int|string $num1, GMP|int|string $num2): GMP",
            "Calculate LCM"
        ],
        "gmp_perfect_power": [
            "gmp_perfect_power(GMP|int|string $num): bool",
            "Perfect power check"
        ],
        "gmp_random_bits": [
            "gmp_random_bits(int $bits): GMP",
            "Random number"
        ],
        "gmp_random_range": [
            "gmp_random_range(GMP|int|string $min, GMP|int|string $max): GMP",
            "Random number"
        ],
        "gmp_random_seed": [
            "gmp_random_seed(GMP|int|string $seed): void",
            "Sets the RNG seed"
        ],
        "gmp_root": [
            "gmp_root(GMP|int|string $num, int $nth): GMP",
            "Take the integer part of nth root"
        ],
        "gmp_rootrem": [
            "gmp_rootrem(GMP|int|string $num, int $nth): array",
            "Take the integer part and remainder of nth root"
        ],
        "gzclose": [
            "gzclose(resource $stream): bool",
            "Close an open gz-file pointer"
        ],
        "gzdecode": [
            "gzdecode(string $data, int $max_length = 0): string|false",
            "Decodes a gzip compressed string"
        ],
        "gzeof": [
            "gzeof(resource $stream): bool",
            "Test for EOF on a gz-file pointer"
        ],
        "gzgetc": [
            "gzgetc(resource $stream): string|false",
            "Get character from gz-file pointer"
        ],
        "gzgets": [
            "gzgets(resource $stream, ?int $length = null): string|false",
            "Get line from file pointer"
        ],
        "gzgetss": [
            "gzgetss(resource $zp, int $length, string $allowable_tags = ?): string",
            ""
        ],
        "gzpassthru": [
            "gzpassthru(resource $stream): int",
            ""
        ],
        "gzputs": [
            "gzputs()",
            "Alias of gzwrite()"
        ],
        "gzread": [
            "gzread(resource $stream, int $length): string|false",
            "Binary-safe gz-file read"
        ],
        "gzrewind": [
            "gzrewind(resource $stream): bool",
            "Rewind the position of a gz-file pointer"
        ],
        "gzseek": [
            "gzseek(resource $stream, int $offset, int $whence = SEEK_SET): int",
            "Seek on a gz-file pointer"
        ],
        "gztell": [
            "gztell(resource $stream): int|false",
            "Tell gz-file pointer read/write position"
        ],
        "gzwrite": [
            "gzwrite(resource $stream, string $data, ?int $length = null): int|false",
            "Binary-safe gz-file write"
        ],
        "halt_compiler": [
            "__halt_compiler(): void",
            ""
        ],
        "hash_equals": [
            "hash_equals(string $known_string, string $user_string): bool",
            "Timing attack safe string comparison"
        ],
        "hash_hkdf": [
            'hash_hkdf(string $algo, string $key, int $length = 0, string $info = "", string $salt = ""): string',
            "Generate a HKDF key derivation of a supplied key input"
        ],
        "hash_hmac_algos": [
            "hash_hmac_algos(): array",
            "Return a list of registered hashing algorithms suitable for hash_hmac"
        ],
        "hash_pbkdf2": [
            "hash_pbkdf2(string $algo, string $password, string $salt, int $iterations, int $length = 0, bool $binary = false): string",
            "Generate a PBKDF2 key derivation of a supplied password"
        ],
        "header_register_callback": [
            "header_register_callback(callable $callback): bool",
            "Call a header function"
        ],
        "hex2bin": [
            "hex2bin(string $string): string|false",
            "Decodes a hexadecimally encoded binary string"
        ],
        "hrtime": [
            "hrtime(bool $as_number = false): array|int|float|false",
            "Get the system&#039;s high resolution time"
        ],
        "http_response_code": [
            "http_response_code(int $response_code = 0): int|bool",
            "Get or Set the HTTP response code"
        ],
        "imageaffine": [
            "imageaffine(GdImage $image, array $affine, ?array $clip = null): GdImage|false",
            "Return an image containing the affine transformed src image, using an optional clipping area"
        ],
        "imageaffinematrixconcat": [
            "imageaffinematrixconcat(array $matrix1, array $matrix2): array|false",
            "Concatenate two affine transformation matrices"
        ],
        "imageaffinematrixget": [
            "imageaffinematrixget(int $type, array|float $options): array|false",
            "Get an affine transformation matrix"
        ],
        "imagebmp": [
            "imagebmp(GdImage $image, resource|string|null $file = null, bool $compressed = true): bool",
            "Output a BMP image to browser or file"
        ],
        "imagecreatefrombmp": [
            "imagecreatefrombmp(string $filename): GdImage|false",
            "Create a new image from file or URL"
        ],
        "imagecreatefromwebp": [
            "imagecreatefromwebp(string $filename): GdImage|false",
            "Create a new image from file or URL"
        ],
        "imagecrop": [
            "imagecrop(GdImage $image, array $rectangle): GdImage|false",
            "Crop an image to the given rectangle"
        ],
        "imagecropauto": [
            "imagecropauto(GdImage $image, int $mode = IMG_CROP_DEFAULT, float $threshold = 0.5, int $color = -1): GdImage|false",
            "Crop an image automatically using one of the available modes"
        ],
        "imageflip": [
            "imageflip(GdImage $image, int $mode): bool",
            "Flips an image using a given mode"
        ],
        "imagegetclip": [
            "imagegetclip(GdImage $image): array",
            "Get the clipping rectangle"
        ],
        "imagegetinterpolation": [
            "imagegetinterpolation(GdImage $image): int",
            "Get the interpolation method"
        ],
        "imageopenpolygon": [
            "imageopenpolygon(GdImage $image, array $points, int $color): bool",
            "Draws an open polygon"
        ],
        "imagepalettetotruecolor": [
            "imagepalettetotruecolor(GdImage $image): bool",
            "Converts a palette based image to true color"
        ],
        "imageresolution": [
            "imageresolution(GdImage $image, ?int $resolution_x = null, ?int $resolution_y = null): array|bool",
            "Get or set the resolution of the image"
        ],
        "imagescale": [
            "imagescale(GdImage $image, int $width, int $height = -1, int $mode = IMG_BILINEAR_FIXED): GdImage|false",
            "Scale an image using the given new width and height"
        ],
        "imagesetclip": [
            "imagesetclip(GdImage $image, int $x1, int $y1, int $x2, int $y2): bool",
            "Set the clipping rectangle"
        ],
        "imagesetinterpolation": [
            "imagesetinterpolation(GdImage $image, int $method = IMG_BILINEAR_FIXED): bool",
            "Set the interpolation method"
        ],
        "imagewebp": [
            "imagewebp(GdImage $image, resource|string|null $file = null, int $quality = -1): bool",
            "Output a WebP image to browser or file"
        ],
        "imap_create": [
            "",
            "Alias of imap_createmailbox()"
        ],
        "imap_fetchmime": [
            "imap_fetchmime(IMAP\\Connection $imap, int $message_num, string $section, int $flags = 0): string|false",
            "Fetch MIME headers for a particular section of the message"
        ],
        "imap_fetchtext": [
            "imap_fetchtext()",
            "Alias of imap_body()"
        ],
        "imap_header": [
            "imap_header()",
            "Alias of imap_headerinfo()"
        ],
        "imap_listmailbox": [
            "imap_listmailbox()",
            "Alias of imap_list()"
        ],
        "imap_listsubscribed": [
            "imap_listsubscribed()",
            "Alias of imap_lsub()"
        ],
        "imap_rename": [
            "imap_rename()",
            "Alias of imap_renamemailbox()"
        ],
        "imap_scan": [
            "imap_scan()",
            "Alias of imap_listscan()"
        ],
        "imap_scanmailbox": [
            "imap_scanmailbox()",
            "Alias of imap_listscan()"
        ],
        "ini_alter": [
            "ini_alter()",
            "Alias of ini_set()"
        ],
        "intdiv": [
            "intdiv(int $num1, int $num2): int",
            "Integer division"
        ],
        "is_double": [
            "is_double()",
            "Alias of is_float()"
        ],
        "is_int": [
            "is_int(mixed $value): bool",
            "Find whether the type of a variable is integer"
        ],
        "is_integer": [
            "is_integer()",
            "Alias of is_int()"
        ],
        "is_iterable": [
            "is_iterable(mixed $value): bool",
            ""
        ],
        "is_real": [
            "is_real()",
            "Alias of is_float()"
        ],
        "is_soap_fault": [
            "is_soap_fault(mixed $object): bool",
            "Checks if a SOAP call has failed"
        ],
        "is_tainted": [
            "is_tainted(string $string): bool",
            "Checks whether a string is tainted"
        ],
        "is_writeable": [
            "is_writeable()",
            "Alias of is_writable()"
        ],
        "json_last_error_msg": [
            "json_last_error_msg(): string",
            "Returns the error string of the last json_encode() or json_decode() call"
        ],
        "key_exists": [
            "key_exists()",
            "Alias of array_key_exists()"
        ],
        "lchown": [
            "lchown(string $filename, string|int $user): bool",
            "Changes user ownership of symlink"
        ],
        "libxml_set_external_entity_loader": [
            "libxml_set_external_entity_loader(?callable $resolver_function): bool",
            "Changes the default external entity loader"
        ],
        "mb_chr": [
            "mb_chr(int $codepoint, ?string $encoding = null): string|false",
            "Return character by Unicode code point value"
        ],
        "mb_ereg_replace_callback": [
            "mb_ereg_replace_callback(string $pattern, callable $callback, string $string, ?string $options = null): string|false|null",
            ""
        ],
        "mb_ord": [
            "mb_ord(string $string, ?string $encoding = null): int|false",
            "Get Unicode code point of character"
        ],
        "mb_scrub": [
            "mb_scrub(string $string, ?string $encoding = null): string",
            "Description"
        ],
        "mb_str_split": [
            "mb_str_split(string $string, int $length = 1, ?string $encoding = null): array",
            "Given a multibyte string, return an array of its characters"
        ],
        "memcache_debug": [
            "memcache_debug(bool $on_off): bool",
            "Turn debug output on/off"
        ],
        "mysql_db_name": [
            "mysql_db_name(resource $result, int $row, mixed $field = NULL): string",
            "Retrieves database name from the call to mysql_list_dbs()"
        ],
        "mysql_tablename": [
            "mysql_tablename(resource $result, int $i): string|false",
            "Get table name of field"
        ],
        "mysql_xdevapi_expression": [
            "mysql_xdevapi\\expression(string $expression): object",
            "Bind prepared statement variables as parameters"
        ],
        "mysql_xdevapi_getsession": [
            "mysql_xdevapi\\getSession(string $uri): mysql_xdevapi\\Session",
            "Connect to a MySQL server"
        ],
        "mysqli_escape_string": [
            "mysqli_escape_string()",
            "Alias of mysqli_real_escape_string()"
        ],
        "mysqli_execute": [
            "mysqli_execute()",
            "Alias for mysqli_stmt_execute()"
        ],
        "mysqli_get_links_stats": [
            "mysqli_get_links_stats(): array",
            "Return information about open and cached links"
        ],
        "mysqli_set_opt": [
            "mysqli_set_opt()",
            "Alias of mysqli_options()"
        ],
        "ob_tidyhandler": [
            "ob_tidyhandler(string $input, int $mode = ?): string",
            "ob_start callback function to repair the buffer"
        ],
        "odbc_do": [
            "odbc_do()",
            "Alias of odbc_exec()"
        ],
        "odbc_field_precision": [
            "odbc_field_precision()",
            "Alias of odbc_field_len()"
        ],
        "opcache_compile_file": [
            "opcache_compile_file(string $filename): bool",
            "Compiles and caches a PHP script without executing it"
        ],
        "opcache_get_configuration": [
            "opcache_get_configuration(): array|false",
            "Get configuration information about the cache"
        ],
        "opcache_get_status": [
            "opcache_get_status(bool $include_scripts = true): array|false",
            "Get status information about the cache"
        ],
        "opcache_invalidate": [
            "opcache_invalidate(string $filename, bool $force = false): bool",
            "Invalidates a cached script"
        ],
        "opcache_is_script_cached": [
            "opcache_is_script_cached(string $filename): bool",
            "Tells whether a script is cached in OPCache"
        ],
        "opcache_reset": [
            "opcache_reset(): bool",
            "Resets the contents of the opcode cache"
        ],
        "password_algos": [
            "password_algos(): array",
            "Get available password hashing algorithm IDs"
        ],
        "password_get_info": [
            "password_get_info(string $hash): array",
            "Returns information about the given hash"
        ],
        "password_hash": [
            "password_hash(string $password, string|int|null $algo, array $options = []): string",
            "Creates a password hash"
        ],
        "password_needs_rehash": [
            "password_needs_rehash(string $hash, string|int|null $algo, array $options = []): bool",
            "Checks if the given hash matches the given options"
        ],
        "password_verify": [
            "password_verify(string $password, string $hash): bool",
            "Verifies that a password matches a hash"
        ],
        "pcntl_async_signals": [
            "pcntl_async_signals(?bool $enable = null): bool",
            "Enable/disable asynchronous signal handling or return the old setting"
        ],
        "pcntl_errno": [
            "pcntl_errno()",
            "Alias of pcntl_get_last_error()"
        ],
        "pcntl_get_last_error": [
            "pcntl_get_last_error(): int",
            "Retrieve the error number set by the last pcntl function which failed"
        ],
        "pcntl_signal_get_handler": [
            "pcntl_signal_get_handler(int $signal): callable|int",
            "Get the current handler for specified signal"
        ],
        "pcntl_sigwaitinfo": [
            "pcntl_sigwaitinfo(array $signals, array &$info = []): int|false",
            "Waits for signals"
        ],
        "pcntl_strerror": [
            "pcntl_strerror(int $error_code): string",
            "Retrieve the system error message associated with the given errno"
        ],
        "pg_connect_poll": [
            "pg_connect_poll(PgSql\\Connection $connection): int",
            ""
        ],
        "pg_consume_input": [
            "pg_consume_input(PgSql\\Connection $connection): bool",
            "Reads input on the connection"
        ],
        "pg_escape_identifier": [
            "pg_escape_identifier(PgSql\\Connection $connection = ?, string $data): string",
            ""
        ],
        "pg_escape_literal": [
            "pg_escape_literal(PgSql\\Connection $connection = ?, string $data): string",
            ""
        ],
        "pg_flush": [
            "pg_flush(PgSql\\Connection $connection): int|bool",
            "Flush outbound query data on the connection"
        ],
        "pg_lo_truncate": [
            "pg_lo_truncate(PgSql\\Lob $lob, int $size): bool",
            ""
        ],
        "pg_socket": [
            "pg_socket(PgSql\\Connection $connection): resource|false",
            ""
        ],
        "pos": [
            "pos()",
            "Alias of current()"
        ],
        "posix_errno": [
            "posix_errno()",
            "Alias of posix_get_last_error()"
        ],
        "posix_setrlimit": [
            "posix_setrlimit(int $resource, int $soft_limit, int $hard_limit): bool",
            "Set system resource limits"
        ],
        "preg_last_error_msg": [
            "preg_last_error_msg(): string",
            "Returns the error message of the last PCRE regex execution"
        ],
        "preg_replace_callback_array": [
            "preg_replace_callback_array(array $pattern, string|array $subject, int $limit = -1, int &$count = null, int $flags = 0): string|array|null",
            "Perform a regular expression search and replace using callbacks"
        ],
        "ps_translate": [
            "ps_translate(resource $psdoc, float $x, float $y): bool",
            "Sets translation"
        ],
        "random_bytes": [
            "random_bytes(int $length): string",
            "Generates cryptographically secure pseudo-random bytes"
        ],
        "random_int": [
            "random_int(int $min, int $max): int",
            "Generates cryptographically secure pseudo-random integers"
        ],
        "read_exif_data": [
            "read_exif_data()",
            "Alias of exif_read_data()"
        ],
        "recode": [
            "recode()",
            "Alias of recode_string()"
        ],
        "session_abort": [
            "session_abort(): bool",
            "Discard session array changes and finish session"
        ],
        "session_commit": [
            "session_commit()",
            "Alias of session_write_close()"
        ],
        "session_create_id": [
            'session_create_id(string $prefix = ""): string|false',
            "Create new session id"
        ],
        "session_gc": [
            "session_gc(): int|false",
            "Perform session data garbage collection"
        ],
        "session_register_shutdown": [
            "session_register_shutdown(): void",
            "Session shutdown function"
        ],
        "session_reset": [
            "session_reset(): bool",
            "Re-initialize session array with original values"
        ],
        "session_status": [
            "session_status(): int",
            "Returns the current session status"
        ],
        "set_file_buffer": [
            "set_file_buffer()",
            "Alias of stream_set_write_buffer()"
        ],
        "show_source": [
            "show_source()",
            "Alias of highlight_file()"
        ],
        "sizeof": [
            "sizeof()",
            "Alias of count()"
        ],
        "snmp_set_oid_numeric_print": [
            "snmp_set_oid_numeric_print(int $format): bool",
            ""
        ],
        "snmpwalkoid": [
            "snmpwalkoid(string $hostname, string $community, array|string $object_id, int $timeout = -1, int $retries = -1): array|false",
            ""
        ],
        "socket_addrinfo_bind": [
            "socket_addrinfo_bind(AddressInfo $address): Socket|false",
            "Create and bind to a socket from a given addrinfo"
        ],
        "socket_addrinfo_connect": [
            "socket_addrinfo_connect(AddressInfo $address): Socket|false",
            "Create and connect to a socket from a given addrinfo"
        ],
        "socket_addrinfo_explain": [
            "socket_addrinfo_explain(AddressInfo $address): array",
            "Get information about addrinfo"
        ],
        "socket_addrinfo_lookup": [
            "socket_addrinfo_lookup(string $host, ?string $service = null, array $hints = []): array|false",
            "Get array with contents of getaddrinfo about the given hostname"
        ],
        "socket_cmsg_space": [
            "socket_cmsg_space(int $level, int $type, int $num = 0): ?int",
            "Calculate message buffer size"
        ],
        "socket_export_stream": [
            "socket_export_stream(Socket $socket): resource|false",
            "Export a socket into a stream that encapsulates a socket"
        ],
        "socket_get_status": [
            "socket_get_status()",
            "Alias of stream_get_meta_data()"
        ],
        "socket_getopt": [
            "socket_getopt()",
            "Alias of socket_get_option()"
        ],
        "socket_import_stream": [
            "socket_import_stream(resource $stream): Socket|false",
            "Import a stream"
        ],
        "socket_recvmsg": [
            "socket_recvmsg(Socket $socket, array &$message, int $flags = 0): int|false",
            "Read a message"
        ],
        "socket_sendmsg": [
            "socket_sendmsg(Socket $socket, array $message, int $flags = 0): int|false",
            "Send a message"
        ],
        "socket_set_blocking": [
            "socket_set_blocking()",
            "Alias of stream_set_blocking()"
        ],
        "socket_set_timeout": [
            "socket_set_timeout()",
            "Alias of stream_set_timeout()"
        ],
        "socket_setopt": [
            "socket_setopt()",
            "Alias of socket_set_option()"
        ],
        "socket_wsaprotocol_info_export": [
            "socket_wsaprotocol_info_export(Socket $socket, int $process_id): string|false",
            "Exports the WSAPROTOCOL_INFO Structure"
        ],
        "socket_wsaprotocol_info_import": [
            "socket_wsaprotocol_info_import(string $info_id): Socket|false",
            "Imports a Socket from another Process"
        ],
        "socket_wsaprotocol_info_release": [
            "socket_wsaprotocol_info_release(string $info_id): bool",
            "Releases an exported WSAPROTOCOL_INFO Structure"
        ],
        "spl_object_id": [
            "spl_object_id(object $object): int",
            ""
        ],
        "sqlsrv_begin_transaction": [
            "sqlsrv_begin_transaction(resource $conn): bool",
            "Begins a database transaction"
        ],
        "sqlsrv_cancel": [
            "sqlsrv_cancel(resource $stmt): bool",
            "Cancels a statement"
        ],
        "sqlsrv_client_info": [
            "sqlsrv_client_info(resource $conn): array",
            "Returns information about the client and specified connection"
        ],
        "sqlsrv_close": [
            "sqlsrv_close(resource $conn): bool",
            "Closes an open connection and releases resourses associated with the connection"
        ],
        "sqlsrv_commit": [
            "sqlsrv_commit(resource $conn): bool",
            "Commits a transaction that was begun with sqlsrv_begin_transaction()"
        ],
        "sqlsrv_configure": [
            "sqlsrv_configure(string $setting, mixed $value): bool",
            "Changes the driver error handling and logging configurations"
        ],
        "sqlsrv_connect": [
            "sqlsrv_connect(string $serverName, array $connectionInfo = ?): resource",
            "Opens a connection to a Microsoft SQL Server database"
        ],
        "sqlsrv_errors": [
            "sqlsrv_errors(int $errorsOrWarnings = ?): mixed",
            "Returns error and warning information about the last SQLSRV operation performed"
        ],
        "sqlsrv_execute": [
            "sqlsrv_execute(resource $stmt): bool",
            "Executes a statement prepared with sqlsrv_prepare()"
        ],
        "sqlsrv_fetch_array": [
            "sqlsrv_fetch_array(resource $stmt, int $fetchType = ?, int $row = ?, int $offset = ?): array",
            "Returns a row as an array"
        ],
        "sqlsrv_fetch_object": [
            "sqlsrv_fetch_object(resource $stmt, string $className = ?, array $ctorParams = ?, int $row = ?, int $offset = ?): mixed",
            "Retrieves the next row of data in a result set as an object"
        ],
        "sqlsrv_fetch": [
            "sqlsrv_fetch(resource $stmt, int $row = ?, int $offset = ?): mixed",
            "Makes the next row in a result set available for reading"
        ],
        "sqlsrv_field_metadata": [
            "sqlsrv_field_metadata(resource $stmt): mixed",
            ""
        ],
        "sqlsrv_free_stmt": [
            "sqlsrv_free_stmt(resource $stmt): bool",
            "Frees all resources for the specified statement"
        ],
        "sqlsrv_get_config": [
            "sqlsrv_get_config(string $setting): mixed",
            "Returns the value of the specified configuration setting"
        ],
        "sqlsrv_get_field": [
            "sqlsrv_get_field(resource $stmt, int $fieldIndex, int $getAsType = ?): mixed",
            "Gets field data from the currently selected row"
        ],
        "sqlsrv_has_rows": [
            "sqlsrv_has_rows(resource $stmt): bool",
            "Indicates whether the specified statement has rows"
        ],
        "sqlsrv_next_result": [
            "sqlsrv_next_result(resource $stmt): mixed",
            "Makes the next result of the specified statement active"
        ],
        "sqlsrv_num_fields": [
            "sqlsrv_num_fields(resource $stmt): mixed",
            "Retrieves the number of fields (columns) on a statement"
        ],
        "sqlsrv_num_rows": [
            "sqlsrv_num_rows(resource $stmt): mixed",
            "Retrieves the number of rows in a result set"
        ],
        "sqlsrv_prepare": [
            "sqlsrv_prepare(resource $conn, string $sql, array $params = ?, array $options = ?): mixed",
            "Prepares a query for execution"
        ],
        "sqlsrv_query": [
            "sqlsrv_query(resource $conn, string $sql, array $params = ?, array $options = ?): mixed",
            "Prepares and executes a query"
        ],
        "sqlsrv_rollback": [
            "sqlsrv_rollback(resource $conn): bool",
            ""
        ],
        "sqlsrv_rows_affected": [
            "sqlsrv_rows_affected(resource $stmt): int|false",
            ""
        ],
        "sqlsrv_send_stream_data": [
            "sqlsrv_send_stream_data(resource $stmt): bool",
            "Sends data from parameter streams to the server"
        ],
        "sqlsrv_server_info": [
            "sqlsrv_server_info(resource $conn): array",
            "Returns information about the server"
        ],
        "str_contains": [
            "str_contains(string $haystack, string $needle): bool",
            "Determine if a string contains a given substring"
        ],
        "str_ends_with": [
            "str_ends_with(string $haystack, string $needle): bool",
            "Checks if a string ends with a given substring"
        ],
        "str_starts_with": [
            "str_starts_with(string $haystack, string $needle): bool",
            "Checks if a string starts with a given substring"
        ],
        "stream_isatty": [
            "stream_isatty(resource $stream): bool",
            "Check if a stream is a TTY"
        ],
        "stream_notification_callback": [
            "stream_notification_callback(int $notification_code, int $severity, string $message, int $message_code, int $bytes_transferred, int $bytes_max): void",
            "A callback function for the notification context parameter"
        ],
        "stream_register_wrapper": [
            "stream_register_wrapper()",
            "Alias of stream_wrapper_register()"
        ],
        "stream_set_chunk_size": [
            "stream_set_chunk_size(resource $stream, int $size): int",
            "Set the stream chunk size"
        ],
        "stream_set_read_buffer": [
            "stream_set_read_buffer(resource $stream, int $size): int",
            "Set read file buffering on the given stream"
        ],
        "tcpwrap_check": [
            "tcpwrap_check(string $daemon, string $address, string $user = ?, bool $nodns = false): bool",
            "Performs a tcpwrap check"
        ],
        "trait_exists": [
            "trait_exists(string $trait, bool $autoload = true): bool",
            "Checks if the trait exists"
        ],
        "use_soap_error_handler": [
            "use_soap_error_handler(bool $enable = true): bool",
            "Set whether to use the SOAP error handler"
        ],
        "user_error": [
            "user_error()",
            "Alias of trigger_error()"
        ],
        "yaml_emit_file": [
            "yaml_emit_file(string $filename, mixed $data, int $encoding = YAML_ANY_ENCODING, int $linebreak = YAML_ANY_BREAK, array $callbacks = null): bool",
            "Send the YAML representation of a value to a file"
        ],
        "yaml_emit": [
            "yaml_emit(mixed $data, int $encoding = YAML_ANY_ENCODING, int $linebreak = YAML_ANY_BREAK, array $callbacks = null): string",
            "Returns the YAML representation of a value"
        ],
        "yaml_parse_file": [
            "yaml_parse_file(string $filename, int $pos = 0, int &$ndocs = ?, array $callbacks = null): mixed",
            "Parse a YAML stream from a file"
        ],
        "yaml_parse_url": [
            "yaml_parse_url(string $url, int $pos = 0, int &$ndocs = ?, array $callbacks = null): mixed",
            "Parse a Yaml stream from a URL"
        ],
        "yaml_parse": [
            "yaml_parse(string $input, int $pos = 0, int &$ndocs = ?, array $callbacks = null): mixed",
            "Parse a YAML stream"
        ],
        "zlib_decode": [
            "zlib_decode(string $data, int $max_length = 0): string|false",
            "Uncompress any raw/gzip/zlib encoded data"
        ],
        "zlib_encode": [
            "zlib_encode(string $data, int $encoding, int $level = -1): string|false",
            "Compress data with the specified encoding"
        ]
    };
    var variableMap = {
        "$_COOKIE": {
            type: "array"
        },
        "$_ENV": {
            type: "array"
        },
        "$_FILES": {
            type: "array"
        },
        "$_GET": {
            type: "array"
        },
        "$_POST": {
            type: "array"
        },
        "$_REQUEST": {
            type: "array"
        },
        "$_SERVER": {
            type: "array",
            value: {
                "DOCUMENT_ROOT": 1,
                "GATEWAY_INTERFACE": 1,
                "HTTP_ACCEPT": 1,
                "HTTP_ACCEPT_CHARSET": 1,
                "HTTP_ACCEPT_ENCODING": 1,
                "HTTP_ACCEPT_LANGUAGE": 1,
                "HTTP_CONNECTION": 1,
                "HTTP_HOST": 1,
                "HTTP_REFERER": 1,
                "HTTP_USER_AGENT": 1,
                "PATH_TRANSLATED": 1,
                "PHP_SELF": 1,
                "QUERY_STRING": 1,
                "REMOTE_ADDR": 1,
                "REMOTE_PORT": 1,
                "REQUEST_METHOD": 1,
                "REQUEST_URI": 1,
                "SCRIPT_FILENAME": 1,
                "SCRIPT_NAME": 1,
                "SERVER_ADMIN": 1,
                "SERVER_NAME": 1,
                "SERVER_PORT": 1,
                "SERVER_PROTOCOL": 1,
                "SERVER_SIGNATURE": 1,
                "SERVER_SOFTWARE": 1,
                "argv": 1,
                "argc": 1
            }
        },
        "$_SESSION": {
            type: "array"
        },
        "$GLOBALS": {
            type: "array"
        },
        "$argv": {
            type: "array"
        },
        "$argc": {
            type: "int"
        }
    };
    function is(token, type) {
        return token.type.lastIndexOf(type) > -1;
    }
    var PhpCompletions = function() {};
    (function() {
        this.getCompletions = function(state, session, pos, prefix) {
            var token = session.getTokenAt(pos.row, pos.column);
            if (!token) return [];
            if (token.type === "support.php_tag" && token.value === "<?") return this.getTagCompletions(state, session, pos, prefix);
            if (token.type === "identifier") {
                if (token.index > 0) {
                    var prevToken = session.getTokenAt(pos.row, token.start);
                    if (prevToken.type === "support.php_tag") return this.getTagCompletions(state, session, pos, prefix);
                }
                return this.getFunctionCompletions(state, session, pos, prefix);
            }
            if (is(token, "variable")) return this.getVariableCompletions(state, session, pos, prefix);
            var line = session.getLine(pos.row).substr(0, pos.column);
            if (token.type === "string" && /(\$[\w]*)\[["']([^'"]*)$/i.test(line)) return this.getArrayKeyCompletions(state, session, pos, prefix);
            return [];
        };
        this.getTagCompletions = function(state, session, pos, prefix) {
            return [
                {
                    caption: "php",
                    value: "php",
                    meta: "php tag",
                    score: 1000000
                },
                {
                    caption: "=",
                    value: "=",
                    meta: "php tag",
                    score: 1000000
                }
            ];
        };
        this.getFunctionCompletions = function(state, session, pos, prefix) {
            var functions = Object.keys(functionMap);
            return functions.map(function(func) {
                return {
                    caption: func,
                    snippet: func + "($0)",
                    meta: "php function",
                    score: 1000000,
                    docHTML: functionMap[func][1]
                };
            });
        };
        this.getVariableCompletions = function(state, session, pos, prefix) {
            var variables = Object.keys(variableMap);
            return variables.map(function(variable) {
                return {
                    caption: variable,
                    value: variable,
                    meta: "php variable",
                    score: 1000000
                };
            });
        };
        this.getArrayKeyCompletions = function(state, session, pos, prefix) {
            var line = session.getLine(pos.row).substr(0, pos.column);
            var variable = line.match(/(\$[\w]*)\[["']([^'"]*)$/i)[1];
            if (!variableMap[variable]) return [];
            var keys = [];
            if (variableMap[variable].type === "array" && variableMap[variable].value) keys = Object.keys(variableMap[variable].value);
            return keys.map(function(key) {
                return {
                    caption: key,
                    value: key,
                    meta: "php array key",
                    score: 1000000
                };
            });
        };
    }).call(PhpCompletions.prototype);
    exports.PhpCompletions = PhpCompletions;
});
ace.define("ace/mode/folding/cstyle", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
    };
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
        this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
        this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
        this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
        this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
        this._getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            if (this.singleLineBlockCommentRe.test(line)) {
                if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line)) return "";
            }
            var fw = this._getFoldWidgetBase(session, foldStyle, row);
            if (!fw && this.startRegionRe.test(line)) return "start"; // lineCommentRegionStart
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var line = session.getLine(row);
            if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
            var match = line.match(this.foldingStartMarker);
            if (match) {
                var i = match.index;
                if (match[1]) return this.openingBracketBlock(session, match[1], row, i);
                var range = session.getCommentFoldRange(row, i + match[0].length, 1);
                if (range && !range.isMultiLine()) {
                    if (forceMultiline) range = this.getSectionRange(session, row);
                    else if (foldStyle != "all") range = null;
                }
                return range;
            }
            if (foldStyle === "markbegin") return;
            var match = line.match(this.foldingStopMarker);
            if (match) {
                var i = match.index + match[0].length;
                if (match[1]) return this.closingBracketBlock(session, match[1], row, i);
                return session.getCommentFoldRange(row, i, -1);
            }
        };
        this.getSectionRange = function(session, row) {
            var line = session.getLine(row);
            var startIndent = line.search(/\S/);
            var startRow = row;
            var startColumn = line.length;
            row = row + 1;
            var endRow = row;
            var maxRow = session.getLength();
            while(++row < maxRow){
                line = session.getLine(row);
                var indent = line.search(/\S/);
                if (indent === -1) continue;
                if (startIndent > indent) break;
                var subRange = this.getFoldWidgetRange(session, "all", row);
                if (subRange) {
                    if (subRange.start.row <= startRow) break;
                    else if (subRange.isMultiLine()) row = subRange.end.row;
                    else if (startIndent == indent) break;
                }
                endRow = row;
            }
            return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
        };
        this.getCommentRegionBlock = function(session, line, row) {
            var startColumn = line.search(/\s*$/);
            var maxRow = session.getLength();
            var startRow = row;
            var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
            var depth = 1;
            while(++row < maxRow){
                line = session.getLine(row);
                var m = re.exec(line);
                if (!m) continue;
                if (m[1]) depth--;
                else depth++;
                if (!depth) break;
            }
            var endRow = row;
            if (endRow > startRow) return new Range(startRow, startColumn, endRow, line.length);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/folding/php", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/folding/cstyle",
    "ace/range",
    "ace/token_iterator"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var CstyleFoldMode = require("./cstyle").FoldMode;
    var Range = require("../../range").Range;
    var TokenIterator = require("../../token_iterator").TokenIterator;
    var FoldMode = exports.FoldMode = function() {};
    oop.inherits(FoldMode, CstyleFoldMode);
    (function() {
        this.getFoldWidgetRangeBase = this.getFoldWidgetRange;
        this.getFoldWidgetBase = this.getFoldWidget;
        this.indentKeywords = {
            "if": 1,
            "while": 1,
            "for": 1,
            "foreach": 1,
            "switch": 1,
            "else": 0,
            "elseif": 0,
            "endif": -1,
            "endwhile": -1,
            "endfor": -1,
            "endforeach": -1,
            "endswitch": -1
        };
        this.foldingStartMarkerPhp = /(?:\s|^)(if|else|elseif|while|for|foreach|switch).*\:/i;
        this.foldingStopMarkerPhp = /(?:\s|^)(endif|endwhile|endfor|endforeach|endswitch)\;/i;
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            var line = session.doc.getLine(row);
            var match = this.foldingStartMarkerPhp.exec(line);
            if (match) return this.phpBlock(session, row, match.index + 2);
            var match = this.foldingStopMarkerPhp.exec(line);
            if (match) return this.phpBlock(session, row, match.index + 2);
            return this.getFoldWidgetRangeBase(session, foldStyle, row);
        };
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            var isStart = this.foldingStartMarkerPhp.test(line);
            var isEnd = this.foldingStopMarkerPhp.test(line);
            if (isStart && !isEnd) {
                var match = this.foldingStartMarkerPhp.exec(line);
                var keyword = match && match[1].toLowerCase();
                if (keyword) {
                    var type = session.getTokenAt(row, match.index + 2).type;
                    if (type == "keyword") return "start";
                }
            }
            if (isEnd && foldStyle === "markbeginend") {
                var match = this.foldingStopMarkerPhp.exec(line);
                var keyword = match && match[1].toLowerCase();
                if (keyword) {
                    var type = session.getTokenAt(row, match.index + 2).type;
                    if (type == "keyword") return "end";
                }
            }
            return this.getFoldWidgetBase(session, foldStyle, row);
        };
        this.phpBlock = function(session, row, column, tokenRange) {
            var stream = new TokenIterator(session, row, column);
            var token = stream.getCurrentToken();
            if (!token || token.type != "keyword") return;
            var val = token.value;
            var stack = [
                val
            ];
            var dir = this.indentKeywords[val];
            if (val === "else" || val === "elseif") dir = 1;
            if (!dir) return;
            var startColumn = dir === -1 ? stream.getCurrentTokenColumn() : session.getLine(row).length;
            var startRow = row;
            stream.step = dir === -1 ? stream.stepBackward : stream.stepForward;
            while(token = stream.step()){
                if (token.type !== "keyword") continue;
                var level = dir * this.indentKeywords[token.value];
                if (level > 0) stack.unshift(token.value);
                else if (level <= 0) {
                    stack.shift();
                    if (!stack.length) break;
                    if (level === 0) stack.unshift(token.value);
                }
            }
            if (!token) return null;
            if (tokenRange) return stream.getCurrentTokenRange();
            var row = stream.getCurrentTokenRow();
            if (dir === -1) return new Range(row, session.getLine(row).length, startRow, startColumn);
            else return new Range(startRow, startColumn, row, stream.getCurrentTokenColumn());
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/folding/mixed", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(defaultMode, subModes) {
        this.defaultMode = defaultMode;
        this.subModes = subModes;
    };
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.$getMode = function(state) {
            if (typeof state != "string") state = state[0];
            for(var key in this.subModes){
                if (state.indexOf(key) === 0) return this.subModes[key];
            }
            return null;
        };
        this.$tryMode = function(state, session, foldStyle, row) {
            var mode = this.$getMode(state);
            return mode ? mode.getFoldWidget(session, foldStyle, row) : "";
        };
        this.getFoldWidget = function(session, foldStyle, row) {
            return this.$tryMode(session.getState(row - 1), session, foldStyle, row) || this.$tryMode(session.getState(row), session, foldStyle, row) || this.defaultMode.getFoldWidget(session, foldStyle, row);
        };
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            var mode = this.$getMode(session.getState(row - 1));
            if (!mode || !mode.getFoldWidget(session, foldStyle, row)) mode = this.$getMode(session.getState(row));
            if (!mode || !mode.getFoldWidget(session, foldStyle, row)) mode = this.defaultMode;
            return mode.getFoldWidgetRange(session, foldStyle, row);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/folding/xml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(voidElements, optionalEndTags) {
        BaseFoldMode.call(this);
        this.voidElements = voidElements || {};
        this.optionalEndTags = oop.mixin({}, this.voidElements);
        if (optionalEndTags) oop.mixin(this.optionalEndTags, optionalEndTags);
    };
    oop.inherits(FoldMode, BaseFoldMode);
    var Tag = function() {
        this.tagName = "";
        this.closing = false;
        this.selfClosing = false;
        this.start = {
            row: 0,
            column: 0
        };
        this.end = {
            row: 0,
            column: 0
        };
    };
    function is(token, type) {
        return token.type.lastIndexOf(type + ".xml") > -1;
    }
    (function() {
        this.getFoldWidget = function(session, foldStyle, row) {
            var tag = this._getFirstTagInLine(session, row);
            if (!tag) return this.getCommentFoldWidget(session, row);
            if (tag.closing || !tag.tagName && tag.selfClosing) return foldStyle === "markbeginend" ? "end" : "";
            if (!tag.tagName || tag.selfClosing || this.voidElements.hasOwnProperty(tag.tagName.toLowerCase())) return "";
            if (this._findEndTagInLine(session, row, tag.tagName, tag.end.column)) return "";
            return "start";
        };
        this.getCommentFoldWidget = function(session, row) {
            if (/comment/.test(session.getState(row)) && /<!-/.test(session.getLine(row))) return "start";
            return "";
        };
        this._getFirstTagInLine = function(session, row) {
            var tokens = session.getTokens(row);
            var tag = new Tag();
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                if (is(token, "tag-open")) {
                    tag.end.column = tag.start.column + token.value.length;
                    tag.closing = is(token, "end-tag-open");
                    token = tokens[++i];
                    if (!token) return null;
                    tag.tagName = token.value;
                    if (token.value === "") {
                        token = tokens[++i];
                        if (!token) return null;
                        tag.tagName = token.value;
                    }
                    tag.end.column += token.value.length;
                    for(i++; i < tokens.length; i++){
                        token = tokens[i];
                        tag.end.column += token.value.length;
                        if (is(token, "tag-close")) {
                            tag.selfClosing = token.value == "/>";
                            break;
                        }
                    }
                    return tag;
                } else if (is(token, "tag-close")) {
                    tag.selfClosing = token.value == "/>";
                    return tag;
                }
                tag.start.column += token.value.length;
            }
            return null;
        };
        this._findEndTagInLine = function(session, row, tagName, startColumn) {
            var tokens = session.getTokens(row);
            var column = 0;
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                column += token.value.length;
                if (column < startColumn - 1) continue;
                if (is(token, "end-tag-open")) {
                    token = tokens[i + 1];
                    if (is(token, "tag-name") && token.value === "") token = tokens[i + 2];
                    if (token && token.value == tagName) return true;
                }
            }
            return false;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            var firstTag = this._getFirstTagInLine(session, row);
            if (!firstTag) return this.getCommentFoldWidget(session, row) && session.getCommentFoldRange(row, session.getLine(row).length);
            var tags = session.getMatchingTags({
                row: row,
                column: 0
            });
            if (tags) return new Range(tags.openTag.end.row, tags.openTag.end.column, tags.closeTag.start.row, tags.closeTag.start.column);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/folding/html", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/folding/mixed",
    "ace/mode/folding/xml",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var MixedFoldMode = require("./mixed").FoldMode;
    var XmlFoldMode = require("./xml").FoldMode;
    var CStyleFoldMode = require("./cstyle").FoldMode;
    var FoldMode = exports.FoldMode = function(voidElements, optionalTags) {
        MixedFoldMode.call(this, new XmlFoldMode(voidElements, optionalTags), {
            "js-": new CStyleFoldMode(),
            "css-": new CStyleFoldMode()
        });
    };
    oop.inherits(FoldMode, MixedFoldMode);
});
ace.define("ace/mode/behaviour/xml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/behaviour",
    "ace/token_iterator"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Behaviour = require("../behaviour").Behaviour;
    var TokenIterator = require("../../token_iterator").TokenIterator;
    function is(token, type) {
        return token && token.type.lastIndexOf(type + ".xml") > -1;
    }
    var XmlBehaviour = function() {
        this.add("string_dquotes", "insertion", function(state, action, editor, session, text) {
            if (text == '"' || text == "'") {
                var quote = text;
                var selected = session.doc.getTextRange(editor.getSelectionRange());
                if (selected !== "" && selected !== "'" && selected != '"' && editor.getWrapBehavioursEnabled()) return {
                    text: quote + selected + quote,
                    selection: false
                };
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (rightChar == quote && (is(token, "attribute-value") || is(token, "string"))) return {
                    text: "",
                    selection: [
                        1,
                        1
                    ]
                };
                if (!token) token = iterator.stepBackward();
                if (!token) return;
                while(is(token, "tag-whitespace") || is(token, "whitespace"))token = iterator.stepBackward();
                var rightSpace = !rightChar || rightChar.match(/\s/);
                if (is(token, "attribute-equals") && (rightSpace || rightChar == ">") || is(token, "decl-attribute-equals") && (rightSpace || rightChar == "?")) return {
                    text: quote + quote,
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("string_dquotes", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && (selected == '"' || selected == "'")) {
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
                if (rightChar == selected) {
                    range.end.column++;
                    return range;
                }
            }
        });
        this.add("autoclosing", "insertion", function(state, action, editor, session, text) {
            if (text == ">") {
                var position = editor.getSelectionRange().start;
                var iterator = new TokenIterator(session, position.row, position.column);
                var token = iterator.getCurrentToken() || iterator.stepBackward();
                if (!token || !(is(token, "tag-name") || is(token, "tag-whitespace") || is(token, "attribute-name") || is(token, "attribute-equals") || is(token, "attribute-value"))) return;
                if (is(token, "reference.attribute-value")) return;
                if (is(token, "attribute-value")) {
                    var tokenEndColumn = iterator.getCurrentTokenColumn() + token.value.length;
                    if (position.column < tokenEndColumn) return;
                    if (position.column == tokenEndColumn) {
                        var nextToken = iterator.stepForward();
                        if (nextToken && is(nextToken, "attribute-value")) return;
                        iterator.stepBackward();
                    }
                }
                if (/^\s*>/.test(session.getLine(position.row).slice(position.column))) return;
                while(!is(token, "tag-name")){
                    token = iterator.stepBackward();
                    if (token.value == "<") {
                        token = iterator.stepForward();
                        break;
                    }
                }
                var tokenRow = iterator.getCurrentTokenRow();
                var tokenColumn = iterator.getCurrentTokenColumn();
                if (is(iterator.stepBackward(), "end-tag-open")) return;
                var element = token.value;
                if (tokenRow == position.row) element = element.substring(0, position.column - tokenColumn);
                if (this.voidElements && this.voidElements.hasOwnProperty(element.toLowerCase())) return;
                return {
                    text: "></" + element + ">",
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("autoindent", "insertion", function(state, action, editor, session, text) {
            if (text == "\n") {
                var cursor = editor.getCursorPosition();
                var line = session.getLine(cursor.row);
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (is(token, "") && token.type.indexOf("tag-close") !== -1) {
                    if (token.value == "/>") return;
                    while(token && token.type.indexOf("tag-name") === -1)token = iterator.stepBackward();
                    if (!token) return;
                    var tag = token.value;
                    var row = iterator.getCurrentTokenRow();
                    token = iterator.stepBackward();
                    if (!token || token.type.indexOf("end-tag") !== -1) return;
                    if (this.voidElements && !this.voidElements[tag] || !this.voidElements) {
                        var nextToken = session.getTokenAt(cursor.row, cursor.column + 1);
                        var line = session.getLine(row);
                        var nextIndent = this.$getIndent(line);
                        var indent = nextIndent + session.getTabString();
                        if (nextToken && nextToken.value === "</") return {
                            text: "\n" + indent + "\n" + nextIndent,
                            selection: [
                                1,
                                indent.length,
                                1,
                                indent.length
                            ]
                        };
                        else return {
                            text: "\n" + indent
                        };
                    }
                }
            }
        });
    };
    oop.inherits(XmlBehaviour, Behaviour);
    exports.XmlBehaviour = XmlBehaviour;
});
ace.define("ace/mode/behaviour/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/token_iterator",
    "ace/mode/behaviour/cstyle",
    "ace/mode/behaviour/xml"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var TokenIterator = require("../../token_iterator").TokenIterator;
    var CstyleBehaviour = require("../behaviour/cstyle").CstyleBehaviour;
    var XmlBehaviour = require("../behaviour/xml").XmlBehaviour;
    var JavaScriptBehaviour = function() {
        var xmlBehaviours = new XmlBehaviour({
            closeCurlyBraces: true
        }).getBehaviours();
        this.addBehaviours(xmlBehaviours);
        this.inherit(CstyleBehaviour);
        this.add("autoclosing-fragment", "insertion", function(state, action, editor, session, text) {
            if (text == ">") {
                var position = editor.getSelectionRange().start;
                var iterator = new TokenIterator(session, position.row, position.column);
                var token = iterator.getCurrentToken() || iterator.stepBackward();
                if (!token) return;
                if (token.value == "<") return {
                    text: "></>",
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
    };
    oop.inherits(JavaScriptBehaviour, CstyleBehaviour);
    exports.JavaScriptBehaviour = JavaScriptBehaviour;
});
ace.define("ace/mode/folding/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/folding/xml",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var XmlFoldMode = require("./xml").FoldMode;
    var CFoldMode = require("./cstyle").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
        this.xmlFoldMode = new XmlFoldMode();
    };
    oop.inherits(FoldMode, CFoldMode);
    (function() {
        this.getFoldWidgetRangeBase = this.getFoldWidgetRange;
        this.getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var fw = this.getFoldWidgetBase(session, foldStyle, row);
            if (!fw) return this.xmlFoldMode.getFoldWidget(session, foldStyle, row);
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var range = this.getFoldWidgetRangeBase(session, foldStyle, row, forceMultiline);
            if (range) return range;
            return this.xmlFoldMode.getFoldWidgetRange(session, foldStyle, row);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/javascript_highlight_rules",
    "ace/mode/matching_brace_outdent",
    "ace/worker/worker_client",
    "ace/mode/behaviour/javascript",
    "ace/mode/folding/javascript"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var JavaScriptHighlightRules = require("./javascript_highlight_rules").JavaScriptHighlightRules;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var JavaScriptBehaviour = require("./behaviour/javascript").JavaScriptBehaviour;
    var JavaScriptFoldMode = require("./folding/javascript").FoldMode;
    var Mode = function() {
        this.HighlightRules = JavaScriptHighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.$behaviour = new JavaScriptBehaviour();
        this.foldingRules = new JavaScriptFoldMode();
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.lineCommentStart = "//";
        this.blockComment = {
            start: "/*",
            end: "*/"
        };
        this.$quotes = {
            '"': '"',
            "'": "'",
            "`": "`"
        };
        this.$pairQuotesAfter = {
            "`": /\w/
        };
        this.getNextLineIndent = function(state, line, tab) {
            var indent = this.$getIndent(line);
            var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
            var tokens = tokenizedLine.tokens;
            var endState = tokenizedLine.state;
            if (tokens.length && tokens[tokens.length - 1].type == "comment") return indent;
            if (state == "start" || state == "no_regex") {
                var match = line.match(/^.*(?:\bcase\b.*:|[\{\(\[])\s*$/);
                if (match) indent += tab;
            } else if (state == "doc-start") {
                if (endState == "start" || endState == "no_regex") return "";
            }
            return indent;
        };
        this.checkOutdent = function(state, line, input) {
            return this.$outdent.checkOutdent(line, input);
        };
        this.autoOutdent = function(state, doc, row) {
            this.$outdent.autoOutdent(doc, row);
        };
        this.createWorker = function(session) {
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/javascript_worker", "JavaScriptWorker");
            worker.attachToDocument(session.getDocument());
            worker.on("annotate", function(results) {
                session.setAnnotations(results.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/javascript";
        this.snippetFileId = "ace/snippets/javascript";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
ace.define("ace/mode/css_completions", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var propertyMap = {
        "background": {
            "#$0": 1
        },
        "background-color": {
            "#$0": 1,
            "transparent": 1,
            "fixed": 1
        },
        "background-image": {
            "url('/$0')": 1
        },
        "background-repeat": {
            "repeat": 1,
            "repeat-x": 1,
            "repeat-y": 1,
            "no-repeat": 1,
            "inherit": 1
        },
        "background-position": {
            "bottom": 2,
            "center": 2,
            "left": 2,
            "right": 2,
            "top": 2,
            "inherit": 2
        },
        "background-attachment": {
            "scroll": 1,
            "fixed": 1
        },
        "background-size": {
            "cover": 1,
            "contain": 1
        },
        "background-clip": {
            "border-box": 1,
            "padding-box": 1,
            "content-box": 1
        },
        "background-origin": {
            "border-box": 1,
            "padding-box": 1,
            "content-box": 1
        },
        "border": {
            "solid $0": 1,
            "dashed $0": 1,
            "dotted $0": 1,
            "#$0": 1
        },
        "border-color": {
            "#$0": 1
        },
        "border-style": {
            "solid": 2,
            "dashed": 2,
            "dotted": 2,
            "double": 2,
            "groove": 2,
            "hidden": 2,
            "inherit": 2,
            "inset": 2,
            "none": 2,
            "outset": 2,
            "ridged": 2
        },
        "border-collapse": {
            "collapse": 1,
            "separate": 1
        },
        "bottom": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "clear": {
            "left": 1,
            "right": 1,
            "both": 1,
            "none": 1
        },
        "color": {
            "#$0": 1,
            "rgb(#$00,0,0)": 1
        },
        "cursor": {
            "default": 1,
            "pointer": 1,
            "move": 1,
            "text": 1,
            "wait": 1,
            "help": 1,
            "progress": 1,
            "n-resize": 1,
            "ne-resize": 1,
            "e-resize": 1,
            "se-resize": 1,
            "s-resize": 1,
            "sw-resize": 1,
            "w-resize": 1,
            "nw-resize": 1
        },
        "display": {
            "none": 1,
            "block": 1,
            "inline": 1,
            "inline-block": 1,
            "table-cell": 1
        },
        "empty-cells": {
            "show": 1,
            "hide": 1
        },
        "float": {
            "left": 1,
            "right": 1,
            "none": 1
        },
        "font-family": {
            "Arial": 2,
            "Comic Sans MS": 2,
            "Consolas": 2,
            "Courier New": 2,
            "Courier": 2,
            "Georgia": 2,
            "Monospace": 2,
            "Sans-Serif": 2,
            "Segoe UI": 2,
            "Tahoma": 2,
            "Times New Roman": 2,
            "Trebuchet MS": 2,
            "Verdana": 1
        },
        "font-size": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "font-weight": {
            "bold": 1,
            "normal": 1
        },
        "font-style": {
            "italic": 1,
            "normal": 1
        },
        "font-variant": {
            "normal": 1,
            "small-caps": 1
        },
        "height": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "left": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "letter-spacing": {
            "normal": 1
        },
        "line-height": {
            "normal": 1
        },
        "list-style-type": {
            "none": 1,
            "disc": 1,
            "circle": 1,
            "square": 1,
            "decimal": 1,
            "decimal-leading-zero": 1,
            "lower-roman": 1,
            "upper-roman": 1,
            "lower-greek": 1,
            "lower-latin": 1,
            "upper-latin": 1,
            "georgian": 1,
            "lower-alpha": 1,
            "upper-alpha": 1
        },
        "margin": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "margin-right": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "margin-left": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "margin-top": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "margin-bottom": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "max-height": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "max-width": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "min-height": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "min-width": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "overflow": {
            "hidden": 1,
            "visible": 1,
            "auto": 1,
            "scroll": 1
        },
        "overflow-x": {
            "hidden": 1,
            "visible": 1,
            "auto": 1,
            "scroll": 1
        },
        "overflow-y": {
            "hidden": 1,
            "visible": 1,
            "auto": 1,
            "scroll": 1
        },
        "padding": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "padding-top": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "padding-right": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "padding-bottom": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "padding-left": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "page-break-after": {
            "auto": 1,
            "always": 1,
            "avoid": 1,
            "left": 1,
            "right": 1
        },
        "page-break-before": {
            "auto": 1,
            "always": 1,
            "avoid": 1,
            "left": 1,
            "right": 1
        },
        "position": {
            "absolute": 1,
            "relative": 1,
            "fixed": 1,
            "static": 1
        },
        "right": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "table-layout": {
            "fixed": 1,
            "auto": 1
        },
        "text-decoration": {
            "none": 1,
            "underline": 1,
            "line-through": 1,
            "blink": 1
        },
        "text-align": {
            "left": 1,
            "right": 1,
            "center": 1,
            "justify": 1
        },
        "text-transform": {
            "capitalize": 1,
            "uppercase": 1,
            "lowercase": 1,
            "none": 1
        },
        "top": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "vertical-align": {
            "top": 1,
            "bottom": 1
        },
        "visibility": {
            "hidden": 1,
            "visible": 1
        },
        "white-space": {
            "nowrap": 1,
            "normal": 1,
            "pre": 1,
            "pre-line": 1,
            "pre-wrap": 1
        },
        "width": {
            "px": 1,
            "em": 1,
            "%": 1
        },
        "word-spacing": {
            "normal": 1
        },
        "filter": {
            "alpha(opacity=$0100)": 1
        },
        "text-shadow": {
            "$02px 2px 2px #777": 1
        },
        "text-overflow": {
            "ellipsis-word": 1,
            "clip": 1,
            "ellipsis": 1
        },
        "-moz-border-radius": 1,
        "-moz-border-radius-topright": 1,
        "-moz-border-radius-bottomright": 1,
        "-moz-border-radius-topleft": 1,
        "-moz-border-radius-bottomleft": 1,
        "-webkit-border-radius": 1,
        "-webkit-border-top-right-radius": 1,
        "-webkit-border-top-left-radius": 1,
        "-webkit-border-bottom-right-radius": 1,
        "-webkit-border-bottom-left-radius": 1,
        "-moz-box-shadow": 1,
        "-webkit-box-shadow": 1,
        "transform": {
            "rotate($00deg)": 1,
            "skew($00deg)": 1
        },
        "-moz-transform": {
            "rotate($00deg)": 1,
            "skew($00deg)": 1
        },
        "-webkit-transform": {
            "rotate($00deg)": 1,
            "skew($00deg)": 1
        }
    };
    var CssCompletions = function() {};
    (function() {
        this.completionsDefined = false;
        this.defineCompletions = function() {
            if (document) {
                var style = document.createElement("c").style;
                for(var i in style){
                    if (typeof style[i] !== "string") continue;
                    var name = i.replace(/[A-Z]/g, function(x) {
                        return "-" + x.toLowerCase();
                    });
                    if (!propertyMap.hasOwnProperty(name)) propertyMap[name] = 1;
                }
            }
            this.completionsDefined = true;
        };
        this.getCompletions = function(state, session, pos, prefix) {
            if (!this.completionsDefined) this.defineCompletions();
            if (state === "ruleset" || session.$mode.$id == "ace/mode/scss") {
                var line = session.getLine(pos.row).substr(0, pos.column);
                var inParens = /\([^)]*$/.test(line);
                if (inParens) line = line.substr(line.lastIndexOf("(") + 1);
                if (/:[^;]+$/.test(line)) {
                    /([\w\-]+):[^:]*$/.test(line);
                    return this.getPropertyValueCompletions(state, session, pos, prefix);
                } else return this.getPropertyCompletions(state, session, pos, prefix, inParens);
            }
            return [];
        };
        this.getPropertyCompletions = function(state, session, pos, prefix, skipSemicolon) {
            skipSemicolon = skipSemicolon || false;
            var properties = Object.keys(propertyMap);
            return properties.map(function(property) {
                return {
                    caption: property,
                    snippet: property + ": $0" + (skipSemicolon ? "" : ";"),
                    meta: "property",
                    score: 1000000
                };
            });
        };
        this.getPropertyValueCompletions = function(state, session, pos, prefix) {
            var line = session.getLine(pos.row).substr(0, pos.column);
            var property = (/([\w\-]+):[^:]*$/.exec(line) || {})[1];
            if (!property) return [];
            var values = [];
            if (property in propertyMap && typeof propertyMap[property] === "object") values = Object.keys(propertyMap[property]);
            return values.map(function(value) {
                return {
                    caption: value,
                    snippet: value,
                    meta: "property value",
                    score: 1000000
                };
            });
        };
    }).call(CssCompletions.prototype);
    exports.CssCompletions = CssCompletions;
});
ace.define("ace/mode/behaviour/css", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/behaviour",
    "ace/mode/behaviour/cstyle",
    "ace/token_iterator"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Behaviour = require("../behaviour").Behaviour;
    var CstyleBehaviour = require("./cstyle").CstyleBehaviour;
    var TokenIterator = require("../../token_iterator").TokenIterator;
    var CssBehaviour = function() {
        this.inherit(CstyleBehaviour);
        this.add("colon", "insertion", function(state, action, editor, session, text) {
            if (text === ":" && editor.selection.isEmpty()) {
                var cursor = editor.getCursorPosition();
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (token && token.value.match(/\s+/)) token = iterator.stepBackward();
                if (token && token.type === "support.type") {
                    var line = session.doc.getLine(cursor.row);
                    var rightChar = line.substring(cursor.column, cursor.column + 1);
                    if (rightChar === ":") return {
                        text: "",
                        selection: [
                            1,
                            1
                        ]
                    };
                    if (/^(\s+[^;]|\s*$)/.test(line.substring(cursor.column))) return {
                        text: ":;",
                        selection: [
                            1,
                            1
                        ]
                    };
                }
            }
        });
        this.add("colon", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && selected === ":") {
                var cursor = editor.getCursorPosition();
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (token && token.value.match(/\s+/)) token = iterator.stepBackward();
                if (token && token.type === "support.type") {
                    var line = session.doc.getLine(range.start.row);
                    var rightChar = line.substring(range.end.column, range.end.column + 1);
                    if (rightChar === ";") {
                        range.end.column++;
                        return range;
                    }
                }
            }
        });
        this.add("semicolon", "insertion", function(state, action, editor, session, text) {
            if (text === ";" && editor.selection.isEmpty()) {
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                if (rightChar === ";") return {
                    text: "",
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("!important", "insertion", function(state, action, editor, session, text) {
            if (text === "!" && editor.selection.isEmpty()) {
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                if (/^\s*(;|}|$)/.test(line.substring(cursor.column))) return {
                    text: "!important",
                    selection: [
                        10,
                        10
                    ]
                };
            }
        });
    };
    oop.inherits(CssBehaviour, CstyleBehaviour);
    exports.CssBehaviour = CssBehaviour;
});
ace.define("ace/mode/css", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/css_highlight_rules",
    "ace/mode/matching_brace_outdent",
    "ace/worker/worker_client",
    "ace/mode/css_completions",
    "ace/mode/behaviour/css",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var CssHighlightRules = require("./css_highlight_rules").CssHighlightRules;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var CssCompletions = require("./css_completions").CssCompletions;
    var CssBehaviour = require("./behaviour/css").CssBehaviour;
    var CStyleFoldMode = require("./folding/cstyle").FoldMode;
    var Mode = function() {
        this.HighlightRules = CssHighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.$behaviour = new CssBehaviour();
        this.$completer = new CssCompletions();
        this.foldingRules = new CStyleFoldMode();
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.foldingRules = "cStyle";
        this.blockComment = {
            start: "/*",
            end: "*/"
        };
        this.getNextLineIndent = function(state, line, tab) {
            var indent = this.$getIndent(line);
            var tokens = this.getTokenizer().getLineTokens(line, state).tokens;
            if (tokens.length && tokens[tokens.length - 1].type == "comment") return indent;
            var match = line.match(/^.*\{\s*$/);
            if (match) indent += tab;
            return indent;
        };
        this.checkOutdent = function(state, line, input) {
            return this.$outdent.checkOutdent(line, input);
        };
        this.autoOutdent = function(state, doc, row) {
            this.$outdent.autoOutdent(doc, row);
        };
        this.getCompletions = function(state, session, pos, prefix) {
            return this.$completer.getCompletions(state, session, pos, prefix);
        };
        this.createWorker = function(session) {
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/css_worker", "Worker");
            worker.attachToDocument(session.getDocument());
            worker.on("annotate", function(e) {
                session.setAnnotations(e.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/css";
        this.snippetFileId = "ace/snippets/css";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
ace.define("ace/mode/html_completions", [
    "require",
    "exports",
    "module",
    "ace/token_iterator"
], function(require, exports, module1) {
    "use strict";
    var TokenIterator = require("../token_iterator").TokenIterator;
    var commonAttributes = [
        "accesskey",
        "class",
        "contenteditable",
        "contextmenu",
        "dir",
        "draggable",
        "dropzone",
        "hidden",
        "id",
        "inert",
        "itemid",
        "itemprop",
        "itemref",
        "itemscope",
        "itemtype",
        "lang",
        "spellcheck",
        "style",
        "tabindex",
        "title",
        "translate"
    ];
    var eventAttributes = [
        "onabort",
        "onblur",
        "oncancel",
        "oncanplay",
        "oncanplaythrough",
        "onchange",
        "onclick",
        "onclose",
        "oncontextmenu",
        "oncuechange",
        "ondblclick",
        "ondrag",
        "ondragend",
        "ondragenter",
        "ondragleave",
        "ondragover",
        "ondragstart",
        "ondrop",
        "ondurationchange",
        "onemptied",
        "onended",
        "onerror",
        "onfocus",
        "oninput",
        "oninvalid",
        "onkeydown",
        "onkeypress",
        "onkeyup",
        "onload",
        "onloadeddata",
        "onloadedmetadata",
        "onloadstart",
        "onmousedown",
        "onmousemove",
        "onmouseout",
        "onmouseover",
        "onmouseup",
        "onmousewheel",
        "onpause",
        "onplay",
        "onplaying",
        "onprogress",
        "onratechange",
        "onreset",
        "onscroll",
        "onseeked",
        "onseeking",
        "onselect",
        "onshow",
        "onstalled",
        "onsubmit",
        "onsuspend",
        "ontimeupdate",
        "onvolumechange",
        "onwaiting"
    ];
    var globalAttributes = commonAttributes.concat(eventAttributes);
    var attributeMap = {
        "a": {
            "href": 1,
            "target": {
                "_blank": 1,
                "top": 1
            },
            "ping": 1,
            "rel": {
                "nofollow": 1,
                "alternate": 1,
                "author": 1,
                "bookmark": 1,
                "help": 1,
                "license": 1,
                "next": 1,
                "noreferrer": 1,
                "prefetch": 1,
                "prev": 1,
                "search": 1,
                "tag": 1
            },
            "media": 1,
            "hreflang": 1,
            "type": 1
        },
        "abbr": {},
        "address": {},
        "area": {
            "shape": 1,
            "coords": 1,
            "href": 1,
            "hreflang": 1,
            "alt": 1,
            "target": 1,
            "media": 1,
            "rel": 1,
            "ping": 1,
            "type": 1
        },
        "article": {
            "pubdate": 1
        },
        "aside": {},
        "audio": {
            "src": 1,
            "autobuffer": 1,
            "autoplay": {
                "autoplay": 1
            },
            "loop": {
                "loop": 1
            },
            "controls": {
                "controls": 1
            },
            "muted": {
                "muted": 1
            },
            "preload": {
                "auto": 1,
                "metadata": 1,
                "none": 1
            }
        },
        "b": {},
        "base": {
            "href": 1,
            "target": 1
        },
        "bdi": {},
        "bdo": {},
        "blockquote": {
            "cite": 1
        },
        "body": {
            "onafterprint": 1,
            "onbeforeprint": 1,
            "onbeforeunload": 1,
            "onhashchange": 1,
            "onmessage": 1,
            "onoffline": 1,
            "onpopstate": 1,
            "onredo": 1,
            "onresize": 1,
            "onstorage": 1,
            "onundo": 1,
            "onunload": 1
        },
        "br": {},
        "button": {
            "autofocus": 1,
            "disabled": {
                "disabled": 1
            },
            "form": 1,
            "formaction": 1,
            "formenctype": 1,
            "formmethod": 1,
            "formnovalidate": 1,
            "formtarget": 1,
            "name": 1,
            "value": 1,
            "type": {
                "button": 1,
                "submit": 1
            }
        },
        "canvas": {
            "width": 1,
            "height": 1
        },
        "caption": {},
        "cite": {},
        "code": {},
        "col": {
            "span": 1
        },
        "colgroup": {
            "span": 1
        },
        "command": {
            "type": 1,
            "label": 1,
            "icon": 1,
            "disabled": 1,
            "checked": 1,
            "radiogroup": 1,
            "command": 1
        },
        "data": {},
        "datalist": {},
        "dd": {},
        "del": {
            "cite": 1,
            "datetime": 1
        },
        "details": {
            "open": 1
        },
        "dfn": {},
        "dialog": {
            "open": 1
        },
        "div": {},
        "dl": {},
        "dt": {},
        "em": {},
        "embed": {
            "src": 1,
            "height": 1,
            "width": 1,
            "type": 1
        },
        "fieldset": {
            "disabled": 1,
            "form": 1,
            "name": 1
        },
        "figcaption": {},
        "figure": {},
        "footer": {},
        "form": {
            "accept-charset": 1,
            "action": 1,
            "autocomplete": 1,
            "enctype": {
                "multipart/form-data": 1,
                "application/x-www-form-urlencoded": 1
            },
            "method": {
                "get": 1,
                "post": 1
            },
            "name": 1,
            "novalidate": 1,
            "target": {
                "_blank": 1,
                "top": 1
            }
        },
        "h1": {},
        "h2": {},
        "h3": {},
        "h4": {},
        "h5": {},
        "h6": {},
        "head": {},
        "header": {},
        "hr": {},
        "html": {
            "manifest": 1
        },
        "i": {},
        "iframe": {
            "name": 1,
            "src": 1,
            "height": 1,
            "width": 1,
            "sandbox": {
                "allow-same-origin": 1,
                "allow-top-navigation": 1,
                "allow-forms": 1,
                "allow-scripts": 1
            },
            "seamless": {
                "seamless": 1
            }
        },
        "img": {
            "alt": 1,
            "src": 1,
            "height": 1,
            "width": 1,
            "usemap": 1,
            "ismap": 1
        },
        "input": {
            "type": {
                "text": 1,
                "password": 1,
                "hidden": 1,
                "checkbox": 1,
                "submit": 1,
                "radio": 1,
                "file": 1,
                "button": 1,
                "reset": 1,
                "image": 31,
                "color": 1,
                "date": 1,
                "datetime": 1,
                "datetime-local": 1,
                "email": 1,
                "month": 1,
                "number": 1,
                "range": 1,
                "search": 1,
                "tel": 1,
                "time": 1,
                "url": 1,
                "week": 1
            },
            "accept": 1,
            "alt": 1,
            "autocomplete": {
                "on": 1,
                "off": 1
            },
            "autofocus": {
                "autofocus": 1
            },
            "checked": {
                "checked": 1
            },
            "disabled": {
                "disabled": 1
            },
            "form": 1,
            "formaction": 1,
            "formenctype": {
                "application/x-www-form-urlencoded": 1,
                "multipart/form-data": 1,
                "text/plain": 1
            },
            "formmethod": {
                "get": 1,
                "post": 1
            },
            "formnovalidate": {
                "formnovalidate": 1
            },
            "formtarget": {
                "_blank": 1,
                "_self": 1,
                "_parent": 1,
                "_top": 1
            },
            "height": 1,
            "list": 1,
            "max": 1,
            "maxlength": 1,
            "min": 1,
            "multiple": {
                "multiple": 1
            },
            "name": 1,
            "pattern": 1,
            "placeholder": 1,
            "readonly": {
                "readonly": 1
            },
            "required": {
                "required": 1
            },
            "size": 1,
            "src": 1,
            "step": 1,
            "width": 1,
            "files": 1,
            "value": 1
        },
        "ins": {
            "cite": 1,
            "datetime": 1
        },
        "kbd": {},
        "keygen": {
            "autofocus": 1,
            "challenge": {
                "challenge": 1
            },
            "disabled": {
                "disabled": 1
            },
            "form": 1,
            "keytype": {
                "rsa": 1,
                "dsa": 1,
                "ec": 1
            },
            "name": 1
        },
        "label": {
            "form": 1,
            "for": 1
        },
        "legend": {},
        "li": {
            "value": 1
        },
        "link": {
            "href": 1,
            "hreflang": 1,
            "rel": {
                "stylesheet": 1,
                "icon": 1
            },
            "media": {
                "all": 1,
                "screen": 1,
                "print": 1
            },
            "type": {
                "text/css": 1,
                "image/png": 1,
                "image/jpeg": 1,
                "image/gif": 1
            },
            "sizes": 1
        },
        "main": {},
        "map": {
            "name": 1
        },
        "mark": {},
        "math": {},
        "menu": {
            "type": 1,
            "label": 1
        },
        "meta": {
            "http-equiv": {
                "content-type": 1
            },
            "name": {
                "description": 1,
                "keywords": 1
            },
            "content": {
                "text/html; charset=UTF-8": 1
            },
            "charset": 1
        },
        "meter": {
            "value": 1,
            "min": 1,
            "max": 1,
            "low": 1,
            "high": 1,
            "optimum": 1
        },
        "nav": {},
        "noscript": {
            "href": 1
        },
        "object": {
            "param": 1,
            "data": 1,
            "type": 1,
            "height": 1,
            "width": 1,
            "usemap": 1,
            "name": 1,
            "form": 1,
            "classid": 1
        },
        "ol": {
            "start": 1,
            "reversed": 1
        },
        "optgroup": {
            "disabled": 1,
            "label": 1
        },
        "option": {
            "disabled": 1,
            "selected": 1,
            "label": 1,
            "value": 1
        },
        "output": {
            "for": 1,
            "form": 1,
            "name": 1
        },
        "p": {},
        "param": {
            "name": 1,
            "value": 1
        },
        "pre": {},
        "progress": {
            "value": 1,
            "max": 1
        },
        "q": {
            "cite": 1
        },
        "rp": {},
        "rt": {},
        "ruby": {},
        "s": {},
        "samp": {},
        "script": {
            "charset": 1,
            "type": {
                "text/javascript": 1
            },
            "src": 1,
            "defer": 1,
            "async": 1
        },
        "select": {
            "autofocus": 1,
            "disabled": 1,
            "form": 1,
            "multiple": {
                "multiple": 1
            },
            "name": 1,
            "size": 1,
            "readonly": {
                "readonly": 1
            }
        },
        "small": {},
        "source": {
            "src": 1,
            "type": 1,
            "media": 1
        },
        "span": {},
        "strong": {},
        "style": {
            "type": 1,
            "media": {
                "all": 1,
                "screen": 1,
                "print": 1
            },
            "scoped": 1
        },
        "sub": {},
        "sup": {},
        "svg": {},
        "table": {
            "summary": 1
        },
        "tbody": {},
        "td": {
            "headers": 1,
            "rowspan": 1,
            "colspan": 1
        },
        "textarea": {
            "autofocus": {
                "autofocus": 1
            },
            "disabled": {
                "disabled": 1
            },
            "form": 1,
            "maxlength": 1,
            "name": 1,
            "placeholder": 1,
            "readonly": {
                "readonly": 1
            },
            "required": {
                "required": 1
            },
            "rows": 1,
            "cols": 1,
            "wrap": {
                "on": 1,
                "off": 1,
                "hard": 1,
                "soft": 1
            }
        },
        "tfoot": {},
        "th": {
            "headers": 1,
            "rowspan": 1,
            "colspan": 1,
            "scope": 1
        },
        "thead": {},
        "time": {
            "datetime": 1
        },
        "title": {},
        "tr": {},
        "track": {
            "kind": 1,
            "src": 1,
            "srclang": 1,
            "label": 1,
            "default": 1
        },
        "section": {},
        "summary": {},
        "u": {},
        "ul": {},
        "var": {},
        "video": {
            "src": 1,
            "autobuffer": 1,
            "autoplay": {
                "autoplay": 1
            },
            "loop": {
                "loop": 1
            },
            "controls": {
                "controls": 1
            },
            "width": 1,
            "height": 1,
            "poster": 1,
            "muted": {
                "muted": 1
            },
            "preload": {
                "auto": 1,
                "metadata": 1,
                "none": 1
            }
        },
        "wbr": {}
    };
    var elements = Object.keys(attributeMap);
    function is(token, type) {
        return token.type.lastIndexOf(type + ".xml") > -1;
    }
    function findTagName(session, pos) {
        var iterator = new TokenIterator(session, pos.row, pos.column);
        var token = iterator.getCurrentToken();
        while(token && !is(token, "tag-name"))token = iterator.stepBackward();
        if (token) return token.value;
    }
    function findAttributeName(session, pos) {
        var iterator = new TokenIterator(session, pos.row, pos.column);
        var token = iterator.getCurrentToken();
        while(token && !is(token, "attribute-name"))token = iterator.stepBackward();
        if (token) return token.value;
    }
    var HtmlCompletions = function() {};
    (function() {
        this.getCompletions = function(state, session, pos, prefix) {
            var token = session.getTokenAt(pos.row, pos.column);
            if (!token) return [];
            if (is(token, "tag-name") || is(token, "tag-open") || is(token, "end-tag-open")) return this.getTagCompletions(state, session, pos, prefix);
            if (is(token, "tag-whitespace") || is(token, "attribute-name")) return this.getAttributeCompletions(state, session, pos, prefix);
            if (is(token, "attribute-value")) return this.getAttributeValueCompletions(state, session, pos, prefix);
            var line = session.getLine(pos.row).substr(0, pos.column);
            if (/&[a-z]*$/i.test(line)) return this.getHTMLEntityCompletions(state, session, pos, prefix);
            return [];
        };
        this.getTagCompletions = function(state, session, pos, prefix) {
            return elements.map(function(element) {
                return {
                    value: element,
                    meta: "tag",
                    score: 1000000
                };
            });
        };
        this.getAttributeCompletions = function(state, session, pos, prefix) {
            var tagName = findTagName(session, pos);
            if (!tagName) return [];
            var attributes = globalAttributes;
            if (tagName in attributeMap) attributes = attributes.concat(Object.keys(attributeMap[tagName]));
            return attributes.map(function(attribute) {
                return {
                    caption: attribute,
                    snippet: attribute + '="$0"',
                    meta: "attribute",
                    score: 1000000
                };
            });
        };
        this.getAttributeValueCompletions = function(state, session, pos, prefix) {
            var tagName = findTagName(session, pos);
            var attributeName = findAttributeName(session, pos);
            if (!tagName) return [];
            var values = [];
            if (tagName in attributeMap && attributeName in attributeMap[tagName] && typeof attributeMap[tagName][attributeName] === "object") values = Object.keys(attributeMap[tagName][attributeName]);
            return values.map(function(value) {
                return {
                    caption: value,
                    snippet: value,
                    meta: "attribute value",
                    score: 1000000
                };
            });
        };
        this.getHTMLEntityCompletions = function(state, session, pos, prefix) {
            var values = [
                "Aacute;",
                "aacute;",
                "Acirc;",
                "acirc;",
                "acute;",
                "AElig;",
                "aelig;",
                "Agrave;",
                "agrave;",
                "alefsym;",
                "Alpha;",
                "alpha;",
                "amp;",
                "and;",
                "ang;",
                "Aring;",
                "aring;",
                "asymp;",
                "Atilde;",
                "atilde;",
                "Auml;",
                "auml;",
                "bdquo;",
                "Beta;",
                "beta;",
                "brvbar;",
                "bull;",
                "cap;",
                "Ccedil;",
                "ccedil;",
                "cedil;",
                "cent;",
                "Chi;",
                "chi;",
                "circ;",
                "clubs;",
                "cong;",
                "copy;",
                "crarr;",
                "cup;",
                "curren;",
                "Dagger;",
                "dagger;",
                "dArr;",
                "darr;",
                "deg;",
                "Delta;",
                "delta;",
                "diams;",
                "divide;",
                "Eacute;",
                "eacute;",
                "Ecirc;",
                "ecirc;",
                "Egrave;",
                "egrave;",
                "empty;",
                "emsp;",
                "ensp;",
                "Epsilon;",
                "epsilon;",
                "equiv;",
                "Eta;",
                "eta;",
                "ETH;",
                "eth;",
                "Euml;",
                "euml;",
                "euro;",
                "exist;",
                "fnof;",
                "forall;",
                "frac12;",
                "frac14;",
                "frac34;",
                "frasl;",
                "Gamma;",
                "gamma;",
                "ge;",
                "gt;",
                "hArr;",
                "harr;",
                "hearts;",
                "hellip;",
                "Iacute;",
                "iacute;",
                "Icirc;",
                "icirc;",
                "iexcl;",
                "Igrave;",
                "igrave;",
                "image;",
                "infin;",
                "int;",
                "Iota;",
                "iota;",
                "iquest;",
                "isin;",
                "Iuml;",
                "iuml;",
                "Kappa;",
                "kappa;",
                "Lambda;",
                "lambda;",
                "lang;",
                "laquo;",
                "lArr;",
                "larr;",
                "lceil;",
                "ldquo;",
                "le;",
                "lfloor;",
                "lowast;",
                "loz;",
                "lrm;",
                "lsaquo;",
                "lsquo;",
                "lt;",
                "macr;",
                "mdash;",
                "micro;",
                "middot;",
                "minus;",
                "Mu;",
                "mu;",
                "nabla;",
                "nbsp;",
                "ndash;",
                "ne;",
                "ni;",
                "not;",
                "notin;",
                "nsub;",
                "Ntilde;",
                "ntilde;",
                "Nu;",
                "nu;",
                "Oacute;",
                "oacute;",
                "Ocirc;",
                "ocirc;",
                "OElig;",
                "oelig;",
                "Ograve;",
                "ograve;",
                "oline;",
                "Omega;",
                "omega;",
                "Omicron;",
                "omicron;",
                "oplus;",
                "or;",
                "ordf;",
                "ordm;",
                "Oslash;",
                "oslash;",
                "Otilde;",
                "otilde;",
                "otimes;",
                "Ouml;",
                "ouml;",
                "para;",
                "part;",
                "permil;",
                "perp;",
                "Phi;",
                "phi;",
                "Pi;",
                "pi;",
                "piv;",
                "plusmn;",
                "pound;",
                "Prime;",
                "prime;",
                "prod;",
                "prop;",
                "Psi;",
                "psi;",
                "quot;",
                "radic;",
                "rang;",
                "raquo;",
                "rArr;",
                "rarr;",
                "rceil;",
                "rdquo;",
                "real;",
                "reg;",
                "rfloor;",
                "Rho;",
                "rho;",
                "rlm;",
                "rsaquo;",
                "rsquo;",
                "sbquo;",
                "Scaron;",
                "scaron;",
                "sdot;",
                "sect;",
                "shy;",
                "Sigma;",
                "sigma;",
                "sigmaf;",
                "sim;",
                "spades;",
                "sub;",
                "sube;",
                "sum;",
                "sup;",
                "sup1;",
                "sup2;",
                "sup3;",
                "supe;",
                "szlig;",
                "Tau;",
                "tau;",
                "there4;",
                "Theta;",
                "theta;",
                "thetasym;",
                "thinsp;",
                "THORN;",
                "thorn;",
                "tilde;",
                "times;",
                "trade;",
                "Uacute;",
                "uacute;",
                "uArr;",
                "uarr;",
                "Ucirc;",
                "ucirc;",
                "Ugrave;",
                "ugrave;",
                "uml;",
                "upsih;",
                "Upsilon;",
                "upsilon;",
                "Uuml;",
                "uuml;",
                "weierp;",
                "Xi;",
                "xi;",
                "Yacute;",
                "yacute;",
                "yen;",
                "Yuml;",
                "yuml;",
                "Zeta;",
                "zeta;",
                "zwj;",
                "zwnj;"
            ];
            return values.map(function(value) {
                return {
                    caption: value,
                    snippet: value,
                    meta: "html entity",
                    score: 1000000
                };
            });
        };
    }).call(HtmlCompletions.prototype);
    exports.HtmlCompletions = HtmlCompletions;
});
ace.define("ace/mode/html", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/mode/text",
    "ace/mode/javascript",
    "ace/mode/css",
    "ace/mode/html_highlight_rules",
    "ace/mode/behaviour/xml",
    "ace/mode/folding/html",
    "ace/mode/html_completions",
    "ace/worker/worker_client"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var lang = require("../lib/lang");
    var TextMode = require("./text").Mode;
    var JavaScriptMode = require("./javascript").Mode;
    var CssMode = require("./css").Mode;
    var HtmlHighlightRules = require("./html_highlight_rules").HtmlHighlightRules;
    var XmlBehaviour = require("./behaviour/xml").XmlBehaviour;
    var HtmlFoldMode = require("./folding/html").FoldMode;
    var HtmlCompletions = require("./html_completions").HtmlCompletions;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var voidElements = [
        "area",
        "base",
        "br",
        "col",
        "embed",
        "hr",
        "img",
        "input",
        "keygen",
        "link",
        "meta",
        "menuitem",
        "param",
        "source",
        "track",
        "wbr"
    ];
    var optionalEndTags = [
        "li",
        "dt",
        "dd",
        "p",
        "rt",
        "rp",
        "optgroup",
        "option",
        "colgroup",
        "td",
        "th"
    ];
    var Mode = function(options) {
        this.fragmentContext = options && options.fragmentContext;
        this.HighlightRules = HtmlHighlightRules;
        this.$behaviour = new XmlBehaviour();
        this.$completer = new HtmlCompletions();
        this.createModeDelegates({
            "js-": JavaScriptMode,
            "css-": CssMode
        });
        this.foldingRules = new HtmlFoldMode(this.voidElements, lang.arrayToMap(optionalEndTags));
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.blockComment = {
            start: "<!--",
            end: "-->"
        };
        this.voidElements = lang.arrayToMap(voidElements);
        this.getNextLineIndent = function(state, line, tab) {
            return this.$getIndent(line);
        };
        this.checkOutdent = function(state, line, input) {
            return false;
        };
        this.getCompletions = function(state, session, pos, prefix) {
            return this.$completer.getCompletions(state, session, pos, prefix);
        };
        this.createWorker = function(session) {
            if (this.constructor != Mode) return;
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/html_worker", "Worker");
            worker.attachToDocument(session.getDocument());
            if (this.fragmentContext) worker.call("setOptions", [
                {
                    context: this.fragmentContext
                }
            ]);
            worker.on("error", function(e) {
                session.setAnnotations(e.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/html";
        this.snippetFileId = "ace/snippets/html";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
ace.define("ace/mode/php", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/php_highlight_rules",
    "ace/mode/php_highlight_rules",
    "ace/mode/matching_brace_outdent",
    "ace/worker/worker_client",
    "ace/mode/php_completions",
    "ace/mode/folding/php",
    "ace/unicode",
    "ace/mode/folding/mixed",
    "ace/mode/folding/html",
    "ace/mode/folding/cstyle",
    "ace/mode/html",
    "ace/mode/javascript",
    "ace/mode/css"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var PhpHighlightRules = require("./php_highlight_rules").PhpHighlightRules;
    var PhpLangHighlightRules = require("./php_highlight_rules").PhpLangHighlightRules;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var PhpCompletions = require("./php_completions").PhpCompletions;
    var PhpFoldMode = require("./folding/php").FoldMode;
    var unicode = require("../unicode");
    var MixedFoldMode = require("./folding/mixed").FoldMode;
    var HtmlFoldMode = require("./folding/html").FoldMode;
    var CstyleFoldMode = require("./folding/cstyle").FoldMode;
    var HtmlMode = require("./html").Mode;
    var JavaScriptMode = require("./javascript").Mode;
    var CssMode = require("./css").Mode;
    var PhpMode = function(opts) {
        this.HighlightRules = PhpLangHighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.$behaviour = this.$defaultBehaviour;
        this.$completer = new PhpCompletions();
        this.foldingRules = new MixedFoldMode(new HtmlFoldMode(), {
            "js-": new CstyleFoldMode(),
            "css-": new CstyleFoldMode(),
            "php-": new PhpFoldMode()
        });
    };
    oop.inherits(PhpMode, TextMode);
    (function() {
        this.tokenRe = new RegExp("^[" + unicode.wordChars + "_]+", "g");
        this.nonTokenRe = new RegExp("^(?:[^" + unicode.wordChars + "_]|\\s])+", "g");
        this.lineCommentStart = [
            "//",
            "#"
        ];
        this.blockComment = {
            start: "/*",
            end: "*/"
        };
        this.getNextLineIndent = function(state, line, tab) {
            var indent = this.$getIndent(line);
            var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
            var tokens = tokenizedLine.tokens;
            var endState = tokenizedLine.state;
            if (tokens.length && tokens[tokens.length - 1].type == "comment") return indent;
            if (state == "start") {
                var match = line.match(/^.*[\{\(\[:]\s*$/);
                if (match) indent += tab;
            } else if (state == "doc-start") {
                if (endState != "doc-start") return "";
                var match = line.match(/^\s*(\/?)\*/);
                if (match) {
                    if (match[1]) indent += " ";
                    indent += "* ";
                }
            }
            return indent;
        };
        this.checkOutdent = function(state, line, input) {
            return this.$outdent.checkOutdent(line, input);
        };
        this.autoOutdent = function(state, doc, row) {
            this.$outdent.autoOutdent(doc, row);
        };
        this.getCompletions = function(state, session, pos, prefix) {
            return this.$completer.getCompletions(state, session, pos, prefix);
        };
        this.$id = "ace/mode/php-inline";
    }).call(PhpMode.prototype);
    var Mode = function(opts) {
        if (opts && opts.inline) {
            var mode = new PhpMode();
            mode.createWorker = this.createWorker;
            mode.inlinePhp = true;
            return mode;
        }
        HtmlMode.call(this);
        this.HighlightRules = PhpHighlightRules;
        this.createModeDelegates({
            "js-": JavaScriptMode,
            "css-": CssMode,
            "php-": PhpMode
        });
        this.foldingRules = new MixedFoldMode(new HtmlFoldMode(), {
            "js-": new CstyleFoldMode(),
            "css-": new CstyleFoldMode(),
            "php-": new PhpFoldMode()
        });
    };
    oop.inherits(Mode, HtmlMode);
    (function() {
        this.createWorker = function(session) {
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/php_worker", "PhpWorker");
            worker.attachToDocument(session.getDocument());
            if (this.inlinePhp) worker.call("setOptions", [
                {
                    inline: true
                }
            ]);
            worker.on("annotate", function(e) {
                session.setAnnotations(e.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/php";
        this.snippetFileId = "ace/snippets/php";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/php"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("g1NYz", function(module, exports) {
ace.define("ace/mode/properties_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var PropertiesHighlightRules = function() {
        var escapeRe = /\\u[0-9a-fA-F]{4}|\\/;
        this.$rules = {
            "start": [
                {
                    token: "comment",
                    regex: /[!#].*$/
                },
                {
                    token: "keyword",
                    regex: /[=:]$/
                },
                {
                    token: "keyword",
                    regex: /[=:]/,
                    next: "value"
                },
                {
                    token: "constant.language.escape",
                    regex: escapeRe
                },
                {
                    defaultToken: "variable"
                }
            ],
            "value": [
                {
                    regex: /\\$/,
                    token: "string",
                    next: "value"
                },
                {
                    regex: /$/,
                    token: "string",
                    next: "start"
                },
                {
                    token: "constant.language.escape",
                    regex: escapeRe
                },
                {
                    defaultToken: "string"
                }
            ]
        };
    };
    oop.inherits(PropertiesHighlightRules, TextHighlightRules);
    exports.PropertiesHighlightRules = PropertiesHighlightRules;
});
ace.define("ace/mode/properties", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/properties_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var PropertiesHighlightRules = require("./properties_highlight_rules").PropertiesHighlightRules;
    var Mode = function() {
        this.HighlightRules = PropertiesHighlightRules;
        this.$behaviour = this.$defaultBehaviour;
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.$id = "ace/mode/properties";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/properties"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("jLJBe", function(module, exports) {
ace.define("ace/mode/sh_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var reservedKeywords = exports.reservedKeywords = "!|{|}|case|do|done|elif|else|esac|fi|for|if|in|then|until|while|&|;|export|local|read|typeset|unset|elif|select|set|function|declare|readonly";
    var languageConstructs = exports.languageConstructs = "[|]|alias|bg|bind|break|builtin|cd|command|compgen|complete|continue|dirs|disown|echo|enable|eval|exec|exit|fc|fg|getopts|hash|help|history|jobs|kill|let|logout|popd|printf|pushd|pwd|return|set|shift|shopt|source|suspend|test|times|trap|type|ulimit|umask|unalias|wait";
    var ShHighlightRules = function() {
        var keywordMapper = this.createKeywordMapper({
            "keyword": reservedKeywords,
            "support.function.builtin": languageConstructs,
            "invalid.deprecated": "debugger"
        }, "identifier");
        var integer = "(?:(?:[1-9]\\d*)|(?:0))";
        var fraction = "(?:\\.\\d+)";
        var intPart = "(?:\\d+)";
        var pointFloat = "(?:(?:" + intPart + "?" + fraction + ")|(?:" + intPart + "\\.))";
        var exponentFloat = "(?:(?:" + pointFloat + "|" + intPart + ")" + ")";
        var floatNumber = "(?:" + exponentFloat + "|" + pointFloat + ")";
        var fileDescriptor = "(?:&" + intPart + ")";
        var variableName = "[a-zA-Z_][a-zA-Z0-9_]*";
        var variable = "(?:" + variableName + "(?==))";
        var builtinVariable = "(?:\\$(?:SHLVL|\\$|\\!|\\?))";
        var func = "(?:" + variableName + "\\s*\\(\\))";
        this.$rules = {
            "start": [
                {
                    token: "constant",
                    regex: /\\./
                },
                {
                    token: [
                        "text",
                        "comment"
                    ],
                    regex: /(^|\s)(#.*)$/
                },
                {
                    token: "string.start",
                    regex: '"',
                    push: [
                        {
                            token: "constant.language.escape",
                            regex: /\\(?:[$`"\\]|$)/
                        },
                        {
                            include: "variables"
                        },
                        {
                            token: "keyword.operator",
                            regex: /`/ // TODO highlight `
                        },
                        {
                            token: "string.end",
                            regex: '"',
                            next: "pop"
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                },
                {
                    token: "string",
                    regex: "\\$'",
                    push: [
                        {
                            token: "constant.language.escape",
                            regex: /\\(?:[abeEfnrtv\\'"]|x[a-fA-F\d]{1,2}|u[a-fA-F\d]{4}([a-fA-F\d]{4})?|c.|\d{1,3})/
                        },
                        {
                            token: "string",
                            regex: "'",
                            next: "pop"
                        },
                        {
                            defaultToken: "string"
                        }
                    ]
                },
                {
                    regex: "<<<",
                    token: "keyword.operator"
                },
                {
                    stateName: "heredoc",
                    regex: "(<<-?)(\\s*)(['\"`]?)([\\w\\-]+)(['\"`]?)",
                    onMatch: function(value, currentState, stack) {
                        var next = value[2] == "-" ? "indentedHeredoc" : "heredoc";
                        var tokens = value.split(this.splitRegex);
                        stack.push(next, tokens[4]);
                        return [
                            {
                                type: "constant",
                                value: tokens[1]
                            },
                            {
                                type: "text",
                                value: tokens[2]
                            },
                            {
                                type: "string",
                                value: tokens[3]
                            },
                            {
                                type: "support.class",
                                value: tokens[4]
                            },
                            {
                                type: "string",
                                value: tokens[5]
                            }
                        ];
                    },
                    rules: {
                        heredoc: [
                            {
                                onMatch: function(value, currentState, stack) {
                                    if (value === stack[1]) {
                                        stack.shift();
                                        stack.shift();
                                        this.next = stack[0] || "start";
                                        return "support.class";
                                    }
                                    this.next = "";
                                    return "string";
                                },
                                regex: ".*$",
                                next: "start"
                            }
                        ],
                        indentedHeredoc: [
                            {
                                token: "string",
                                regex: "^	+"
                            },
                            {
                                onMatch: function(value, currentState, stack) {
                                    if (value === stack[1]) {
                                        stack.shift();
                                        stack.shift();
                                        this.next = stack[0] || "start";
                                        return "support.class";
                                    }
                                    this.next = "";
                                    return "string";
                                },
                                regex: ".*$",
                                next: "start"
                            }
                        ]
                    }
                },
                {
                    regex: "$",
                    token: "empty",
                    next: function(currentState, stack) {
                        if (stack[0] === "heredoc" || stack[0] === "indentedHeredoc") return stack[0];
                        return currentState;
                    }
                },
                {
                    token: [
                        "keyword",
                        "text",
                        "text",
                        "text",
                        "variable"
                    ],
                    regex: /(declare|local|readonly)(\s+)(?:(-[fixar]+)(\s+))?([a-zA-Z_][a-zA-Z0-9_]*\b)/
                },
                {
                    token: "variable.language",
                    regex: builtinVariable
                },
                {
                    token: "variable",
                    regex: variable
                },
                {
                    include: "variables"
                },
                {
                    token: "support.function",
                    regex: func
                },
                {
                    token: "support.function",
                    regex: fileDescriptor
                },
                {
                    token: "string",
                    start: "'",
                    end: "'"
                },
                {
                    token: "constant.numeric",
                    regex: floatNumber
                },
                {
                    token: "constant.numeric",
                    regex: integer + "\\b"
                },
                {
                    token: keywordMapper,
                    regex: "[a-zA-Z_][a-zA-Z0-9_]*\\b"
                },
                {
                    token: "keyword.operator",
                    regex: "\\+|\\-|\\*|\\*\\*|\\/|\\/\\/|~|<|>|<=|=>|=|!=|[%&|`]"
                },
                {
                    token: "punctuation.operator",
                    regex: ";"
                },
                {
                    token: "paren.lparen",
                    regex: "[\\[\\(\\{]"
                },
                {
                    token: "paren.rparen",
                    regex: "[\\]]"
                },
                {
                    token: "paren.rparen",
                    regex: "[\\)\\}]",
                    next: "pop"
                }
            ],
            variables: [
                {
                    token: "variable",
                    regex: /(\$)(\w+)/
                },
                {
                    token: [
                        "variable",
                        "paren.lparen"
                    ],
                    regex: /(\$)(\()/,
                    push: "start"
                },
                {
                    token: [
                        "variable",
                        "paren.lparen",
                        "keyword.operator",
                        "variable",
                        "keyword.operator"
                    ],
                    regex: /(\$)(\{)([#!]?)(\w+|[*@#?\-$!0_])(:[?+\-=]?|##?|%%?|,,?\/|\^\^?)?/,
                    push: "start"
                },
                {
                    token: "variable",
                    regex: /\$[*@#?\-$!0_]/
                },
                {
                    token: [
                        "variable",
                        "paren.lparen"
                    ],
                    regex: /(\$)(\{)/,
                    push: "start"
                }
            ]
        };
        this.normalizeRules();
    };
    oop.inherits(ShHighlightRules, TextHighlightRules);
    exports.ShHighlightRules = ShHighlightRules;
});
ace.define("ace/mode/folding/cstyle", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
    };
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
        this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
        this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
        this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
        this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
        this._getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            if (this.singleLineBlockCommentRe.test(line)) {
                if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line)) return "";
            }
            var fw = this._getFoldWidgetBase(session, foldStyle, row);
            if (!fw && this.startRegionRe.test(line)) return "start"; // lineCommentRegionStart
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var line = session.getLine(row);
            if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
            var match = line.match(this.foldingStartMarker);
            if (match) {
                var i = match.index;
                if (match[1]) return this.openingBracketBlock(session, match[1], row, i);
                var range = session.getCommentFoldRange(row, i + match[0].length, 1);
                if (range && !range.isMultiLine()) {
                    if (forceMultiline) range = this.getSectionRange(session, row);
                    else if (foldStyle != "all") range = null;
                }
                return range;
            }
            if (foldStyle === "markbegin") return;
            var match = line.match(this.foldingStopMarker);
            if (match) {
                var i = match.index + match[0].length;
                if (match[1]) return this.closingBracketBlock(session, match[1], row, i);
                return session.getCommentFoldRange(row, i, -1);
            }
        };
        this.getSectionRange = function(session, row) {
            var line = session.getLine(row);
            var startIndent = line.search(/\S/);
            var startRow = row;
            var startColumn = line.length;
            row = row + 1;
            var endRow = row;
            var maxRow = session.getLength();
            while(++row < maxRow){
                line = session.getLine(row);
                var indent = line.search(/\S/);
                if (indent === -1) continue;
                if (startIndent > indent) break;
                var subRange = this.getFoldWidgetRange(session, "all", row);
                if (subRange) {
                    if (subRange.start.row <= startRow) break;
                    else if (subRange.isMultiLine()) row = subRange.end.row;
                    else if (startIndent == indent) break;
                }
                endRow = row;
            }
            return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
        };
        this.getCommentRegionBlock = function(session, line, row) {
            var startColumn = line.search(/\s*$/);
            var maxRow = session.getLength();
            var startRow = row;
            var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
            var depth = 1;
            while(++row < maxRow){
                line = session.getLine(row);
                var m = re.exec(line);
                if (!m) continue;
                if (m[1]) depth--;
                else depth++;
                if (!depth) break;
            }
            var endRow = row;
            if (endRow > startRow) return new Range(startRow, startColumn, endRow, line.length);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/sh", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/sh_highlight_rules",
    "ace/range",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var ShHighlightRules = require("./sh_highlight_rules").ShHighlightRules;
    var Range = require("../range").Range;
    var CStyleFoldMode = require("./folding/cstyle").FoldMode;
    var Mode = function() {
        this.HighlightRules = ShHighlightRules;
        this.foldingRules = new CStyleFoldMode();
        this.$behaviour = this.$defaultBehaviour;
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.lineCommentStart = "#";
        this.getNextLineIndent = function(state, line, tab) {
            var indent = this.$getIndent(line);
            var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
            var tokens = tokenizedLine.tokens;
            if (tokens.length && tokens[tokens.length - 1].type == "comment") return indent;
            if (state == "start") {
                var match = line.match(/^.*[\{\(\[:]\s*$/);
                if (match) indent += tab;
            }
            return indent;
        };
        var outdents = {
            "pass": 1,
            "return": 1,
            "raise": 1,
            "break": 1,
            "continue": 1
        };
        this.checkOutdent = function(state, line, input) {
            if (input !== "\r\n" && input !== "\r" && input !== "\n") return false;
            var tokens = this.getTokenizer().getLineTokens(line.trim(), state).tokens;
            if (!tokens) return false;
            do var last = tokens.pop();
            while (last && (last.type == "comment" || last.type == "text" && last.value.match(/^\s+$/)));
            if (!last) return false;
            return last.type == "keyword" && outdents[last.value];
        };
        this.autoOutdent = function(state, doc, row) {
            row += 1;
            var indent = this.$getIndent(doc.getLine(row));
            var tab = doc.getTabString();
            if (indent.slice(-tab.length) == tab) doc.remove(new Range(row, indent.length - tab.length, row, indent.length));
        };
        this.$id = "ace/mode/sh";
        this.snippetFileId = "ace/snippets/sh";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/sh"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("kjBpM", function(module, exports) {
ace.define("ace/mode/sql_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var SqlHighlightRules = function() {
        var keywords = "select|insert|update|delete|from|where|and|or|group|by|order|limit|offset|having|as|case|when|then|else|end|type|left|right|join|on|outer|desc|asc|union|create|table|primary|key|if|foreign|not|references|default|null|inner|cross|natural|database|drop|grant|distinct|is|in|all|alter|any|array|at|authorization|between|both|cast|check|collate|column|commit|constraint|cube|current|current_date|current_time|current_timestamp|current_user|describe|escape|except|exists|external|extract|fetch|filter|for|full|function|global|grouping|intersect|interval|into|leading|like|local|no|of|only|out|overlaps|partition|position|range|revoke|rollback|rollup|row|rows|session_user|set|some|start|tablesample|time|to|trailing|truncate|unique|unknown|user|using|values|window|with";
        var builtinConstants = "true|false";
        var builtinFunctions = "avg|count|first|last|max|min|sum|ucase|lcase|mid|len|round|rank|now|format|coalesce|ifnull|isnull|nvl";
        var dataTypes = "int|numeric|decimal|date|varchar|char|bigint|float|double|bit|binary|text|set|timestamp|money|real|number|integer|string";
        var keywordMapper = this.createKeywordMapper({
            "support.function": builtinFunctions,
            "keyword": keywords,
            "constant.language": builtinConstants,
            "storage.type": dataTypes
        }, "identifier", true);
        this.$rules = {
            "start": [
                {
                    token: "comment",
                    regex: "--.*$"
                },
                {
                    token: "comment",
                    start: "/\\*",
                    end: "\\*/"
                },
                {
                    token: "string",
                    regex: '".*?"'
                },
                {
                    token: "string",
                    regex: "'.*?'"
                },
                {
                    token: "string",
                    regex: "`.*?`"
                },
                {
                    token: "constant.numeric",
                    regex: "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
                },
                {
                    token: keywordMapper,
                    regex: "[a-zA-Z_$][a-zA-Z0-9_$]*\\b"
                },
                {
                    token: "keyword.operator",
                    regex: "\\+|\\-|\\/|\\/\\/|%|<@>|@>|<@|&|\\^|~|<|>|<=|=>|==|!=|<>|="
                },
                {
                    token: "paren.lparen",
                    regex: "[\\(]"
                },
                {
                    token: "paren.rparen",
                    regex: "[\\)]"
                },
                {
                    token: "text",
                    regex: "\\s+"
                }
            ]
        };
        this.normalizeRules();
    };
    oop.inherits(SqlHighlightRules, TextHighlightRules);
    exports.SqlHighlightRules = SqlHighlightRules;
});
ace.define("ace/mode/folding/cstyle", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
    };
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
        this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
        this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
        this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
        this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
        this._getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            if (this.singleLineBlockCommentRe.test(line)) {
                if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line)) return "";
            }
            var fw = this._getFoldWidgetBase(session, foldStyle, row);
            if (!fw && this.startRegionRe.test(line)) return "start"; // lineCommentRegionStart
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var line = session.getLine(row);
            if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
            var match = line.match(this.foldingStartMarker);
            if (match) {
                var i = match.index;
                if (match[1]) return this.openingBracketBlock(session, match[1], row, i);
                var range = session.getCommentFoldRange(row, i + match[0].length, 1);
                if (range && !range.isMultiLine()) {
                    if (forceMultiline) range = this.getSectionRange(session, row);
                    else if (foldStyle != "all") range = null;
                }
                return range;
            }
            if (foldStyle === "markbegin") return;
            var match = line.match(this.foldingStopMarker);
            if (match) {
                var i = match.index + match[0].length;
                if (match[1]) return this.closingBracketBlock(session, match[1], row, i);
                return session.getCommentFoldRange(row, i, -1);
            }
        };
        this.getSectionRange = function(session, row) {
            var line = session.getLine(row);
            var startIndent = line.search(/\S/);
            var startRow = row;
            var startColumn = line.length;
            row = row + 1;
            var endRow = row;
            var maxRow = session.getLength();
            while(++row < maxRow){
                line = session.getLine(row);
                var indent = line.search(/\S/);
                if (indent === -1) continue;
                if (startIndent > indent) break;
                var subRange = this.getFoldWidgetRange(session, "all", row);
                if (subRange) {
                    if (subRange.start.row <= startRow) break;
                    else if (subRange.isMultiLine()) row = subRange.end.row;
                    else if (startIndent == indent) break;
                }
                endRow = row;
            }
            return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
        };
        this.getCommentRegionBlock = function(session, line, row) {
            var startColumn = line.search(/\s*$/);
            var maxRow = session.getLength();
            var startRow = row;
            var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
            var depth = 1;
            while(++row < maxRow){
                line = session.getLine(row);
                var m = re.exec(line);
                if (!m) continue;
                if (m[1]) depth--;
                else depth++;
                if (!depth) break;
            }
            var endRow = row;
            if (endRow > startRow) return new Range(startRow, startColumn, endRow, line.length);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/folding/sql", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var BaseFoldMode = require("./cstyle").FoldMode;
    var FoldMode = exports.FoldMode = function() {};
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {}).call(FoldMode.prototype);
});
ace.define("ace/mode/sql", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/sql_highlight_rules",
    "ace/mode/folding/sql"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var SqlHighlightRules = require("./sql_highlight_rules").SqlHighlightRules;
    var SqlFoldMode = require("./folding/sql").FoldMode;
    var Mode = function() {
        this.HighlightRules = SqlHighlightRules;
        this.foldingRules = new SqlFoldMode();
        this.$behaviour = this.$defaultBehaviour;
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.lineCommentStart = "--";
        this.blockComment = {
            start: "/*",
            end: "*/"
        };
        this.$id = "ace/mode/sql";
        this.snippetFileId = "ace/snippets/sql";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/sql"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("6M3hq", function(module, exports) {
ace.define("ace/mode/xml_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var XmlHighlightRules = function(normalize) {
        var tagRegex = "[_:a-zA-Z\xc0-\uFFFF][-_:.a-zA-Z0-9\xc0-\uFFFF]*";
        this.$rules = {
            start: [
                {
                    token: "string.cdata.xml",
                    regex: "<\\!\\[CDATA\\[",
                    next: "cdata"
                },
                {
                    token: [
                        "punctuation.instruction.xml",
                        "keyword.instruction.xml"
                    ],
                    regex: "(<\\?)(" + tagRegex + ")",
                    next: "processing_instruction"
                },
                {
                    token: "comment.start.xml",
                    regex: "<\\!--",
                    next: "comment"
                },
                {
                    token: [
                        "xml-pe.doctype.xml",
                        "xml-pe.doctype.xml"
                    ],
                    regex: "(<\\!)(DOCTYPE)(?=[\\s])",
                    next: "doctype",
                    caseInsensitive: true
                },
                {
                    include: "tag"
                },
                {
                    token: "text.end-tag-open.xml",
                    regex: "</"
                },
                {
                    token: "text.tag-open.xml",
                    regex: "<"
                },
                {
                    include: "reference"
                },
                {
                    defaultToken: "text.xml"
                }
            ],
            processing_instruction: [
                {
                    token: "entity.other.attribute-name.decl-attribute-name.xml",
                    regex: tagRegex
                },
                {
                    token: "keyword.operator.decl-attribute-equals.xml",
                    regex: "="
                },
                {
                    include: "whitespace"
                },
                {
                    include: "string"
                },
                {
                    token: "punctuation.xml-decl.xml",
                    regex: "\\?>",
                    next: "start"
                }
            ],
            doctype: [
                {
                    include: "whitespace"
                },
                {
                    include: "string"
                },
                {
                    token: "xml-pe.doctype.xml",
                    regex: ">",
                    next: "start"
                },
                {
                    token: "xml-pe.xml",
                    regex: "[-_a-zA-Z0-9:]+"
                },
                {
                    token: "punctuation.int-subset",
                    regex: "\\[",
                    push: "int_subset"
                }
            ],
            int_subset: [
                {
                    token: "text.xml",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.int-subset.xml",
                    regex: "]",
                    next: "pop"
                },
                {
                    token: [
                        "punctuation.markup-decl.xml",
                        "keyword.markup-decl.xml"
                    ],
                    regex: "(<\\!)(" + tagRegex + ")",
                    push: [
                        {
                            token: "text",
                            regex: "\\s+"
                        },
                        {
                            token: "punctuation.markup-decl.xml",
                            regex: ">",
                            next: "pop"
                        },
                        {
                            include: "string"
                        }
                    ]
                }
            ],
            cdata: [
                {
                    token: "string.cdata.xml",
                    regex: "\\]\\]>",
                    next: "start"
                },
                {
                    token: "text.xml",
                    regex: "\\s+"
                },
                {
                    token: "text.xml",
                    regex: "(?:[^\\]]|\\](?!\\]>))+"
                }
            ],
            comment: [
                {
                    token: "comment.end.xml",
                    regex: "-->",
                    next: "start"
                },
                {
                    defaultToken: "comment.xml"
                }
            ],
            reference: [
                {
                    token: "constant.language.escape.reference.xml",
                    regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
                }
            ],
            attr_reference: [
                {
                    token: "constant.language.escape.reference.attribute-value.xml",
                    regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
                }
            ],
            tag: [
                {
                    token: [
                        "meta.tag.punctuation.tag-open.xml",
                        "meta.tag.punctuation.end-tag-open.xml",
                        "meta.tag.tag-name.xml"
                    ],
                    regex: "(?:(<)|(</))((?:" + tagRegex + ":)?" + tagRegex + ")",
                    next: [
                        {
                            include: "attributes"
                        },
                        {
                            token: "meta.tag.punctuation.tag-close.xml",
                            regex: "/?>",
                            next: "start"
                        }
                    ]
                }
            ],
            tag_whitespace: [
                {
                    token: "text.tag-whitespace.xml",
                    regex: "\\s+"
                }
            ],
            whitespace: [
                {
                    token: "text.whitespace.xml",
                    regex: "\\s+"
                }
            ],
            string: [
                {
                    token: "string.xml",
                    regex: "'",
                    push: [
                        {
                            token: "string.xml",
                            regex: "'",
                            next: "pop"
                        },
                        {
                            defaultToken: "string.xml"
                        }
                    ]
                },
                {
                    token: "string.xml",
                    regex: '"',
                    push: [
                        {
                            token: "string.xml",
                            regex: '"',
                            next: "pop"
                        },
                        {
                            defaultToken: "string.xml"
                        }
                    ]
                }
            ],
            attributes: [
                {
                    token: "entity.other.attribute-name.xml",
                    regex: tagRegex
                },
                {
                    token: "keyword.operator.attribute-equals.xml",
                    regex: "="
                },
                {
                    include: "tag_whitespace"
                },
                {
                    include: "attribute_value"
                }
            ],
            attribute_value: [
                {
                    token: "string.attribute-value.xml",
                    regex: "'",
                    push: [
                        {
                            token: "string.attribute-value.xml",
                            regex: "'",
                            next: "pop"
                        },
                        {
                            include: "attr_reference"
                        },
                        {
                            defaultToken: "string.attribute-value.xml"
                        }
                    ]
                },
                {
                    token: "string.attribute-value.xml",
                    regex: '"',
                    push: [
                        {
                            token: "string.attribute-value.xml",
                            regex: '"',
                            next: "pop"
                        },
                        {
                            include: "attr_reference"
                        },
                        {
                            defaultToken: "string.attribute-value.xml"
                        }
                    ]
                }
            ]
        };
        if (this.constructor === XmlHighlightRules) this.normalizeRules();
    };
    (function() {
        this.embedTagRules = function(HighlightRules, prefix, tag) {
            this.$rules.tag.unshift({
                token: [
                    "meta.tag.punctuation.tag-open.xml",
                    "meta.tag." + tag + ".tag-name.xml"
                ],
                regex: "(<)(" + tag + "(?=\\s|>|$))",
                next: [
                    {
                        include: "attributes"
                    },
                    {
                        token: "meta.tag.punctuation.tag-close.xml",
                        regex: "/?>",
                        next: prefix + "start"
                    }
                ]
            });
            this.$rules[tag + "-end"] = [
                {
                    include: "attributes"
                },
                {
                    token: "meta.tag.punctuation.tag-close.xml",
                    regex: "/?>",
                    next: "start",
                    onMatch: function(value, currentState, stack) {
                        stack.splice(0);
                        return this.token;
                    }
                }
            ];
            this.embedRules(HighlightRules, prefix, [
                {
                    token: [
                        "meta.tag.punctuation.end-tag-open.xml",
                        "meta.tag." + tag + ".tag-name.xml"
                    ],
                    regex: "(</)(" + tag + "(?=\\s|>|$))",
                    next: tag + "-end"
                },
                {
                    token: "string.cdata.xml",
                    regex: "<\\!\\[CDATA\\["
                },
                {
                    token: "string.cdata.xml",
                    regex: "\\]\\]>"
                }
            ]);
        };
    }).call(TextHighlightRules.prototype);
    oop.inherits(XmlHighlightRules, TextHighlightRules);
    exports.XmlHighlightRules = XmlHighlightRules;
});
ace.define("ace/mode/behaviour/xml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/behaviour",
    "ace/token_iterator"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Behaviour = require("../behaviour").Behaviour;
    var TokenIterator = require("../../token_iterator").TokenIterator;
    function is(token, type) {
        return token && token.type.lastIndexOf(type + ".xml") > -1;
    }
    var XmlBehaviour = function() {
        this.add("string_dquotes", "insertion", function(state, action, editor, session, text) {
            if (text == '"' || text == "'") {
                var quote = text;
                var selected = session.doc.getTextRange(editor.getSelectionRange());
                if (selected !== "" && selected !== "'" && selected != '"' && editor.getWrapBehavioursEnabled()) return {
                    text: quote + selected + quote,
                    selection: false
                };
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (rightChar == quote && (is(token, "attribute-value") || is(token, "string"))) return {
                    text: "",
                    selection: [
                        1,
                        1
                    ]
                };
                if (!token) token = iterator.stepBackward();
                if (!token) return;
                while(is(token, "tag-whitespace") || is(token, "whitespace"))token = iterator.stepBackward();
                var rightSpace = !rightChar || rightChar.match(/\s/);
                if (is(token, "attribute-equals") && (rightSpace || rightChar == ">") || is(token, "decl-attribute-equals") && (rightSpace || rightChar == "?")) return {
                    text: quote + quote,
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("string_dquotes", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && (selected == '"' || selected == "'")) {
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
                if (rightChar == selected) {
                    range.end.column++;
                    return range;
                }
            }
        });
        this.add("autoclosing", "insertion", function(state, action, editor, session, text) {
            if (text == ">") {
                var position = editor.getSelectionRange().start;
                var iterator = new TokenIterator(session, position.row, position.column);
                var token = iterator.getCurrentToken() || iterator.stepBackward();
                if (!token || !(is(token, "tag-name") || is(token, "tag-whitespace") || is(token, "attribute-name") || is(token, "attribute-equals") || is(token, "attribute-value"))) return;
                if (is(token, "reference.attribute-value")) return;
                if (is(token, "attribute-value")) {
                    var tokenEndColumn = iterator.getCurrentTokenColumn() + token.value.length;
                    if (position.column < tokenEndColumn) return;
                    if (position.column == tokenEndColumn) {
                        var nextToken = iterator.stepForward();
                        if (nextToken && is(nextToken, "attribute-value")) return;
                        iterator.stepBackward();
                    }
                }
                if (/^\s*>/.test(session.getLine(position.row).slice(position.column))) return;
                while(!is(token, "tag-name")){
                    token = iterator.stepBackward();
                    if (token.value == "<") {
                        token = iterator.stepForward();
                        break;
                    }
                }
                var tokenRow = iterator.getCurrentTokenRow();
                var tokenColumn = iterator.getCurrentTokenColumn();
                if (is(iterator.stepBackward(), "end-tag-open")) return;
                var element = token.value;
                if (tokenRow == position.row) element = element.substring(0, position.column - tokenColumn);
                if (this.voidElements && this.voidElements.hasOwnProperty(element.toLowerCase())) return;
                return {
                    text: "></" + element + ">",
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("autoindent", "insertion", function(state, action, editor, session, text) {
            if (text == "\n") {
                var cursor = editor.getCursorPosition();
                var line = session.getLine(cursor.row);
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (is(token, "") && token.type.indexOf("tag-close") !== -1) {
                    if (token.value == "/>") return;
                    while(token && token.type.indexOf("tag-name") === -1)token = iterator.stepBackward();
                    if (!token) return;
                    var tag = token.value;
                    var row = iterator.getCurrentTokenRow();
                    token = iterator.stepBackward();
                    if (!token || token.type.indexOf("end-tag") !== -1) return;
                    if (this.voidElements && !this.voidElements[tag] || !this.voidElements) {
                        var nextToken = session.getTokenAt(cursor.row, cursor.column + 1);
                        var line = session.getLine(row);
                        var nextIndent = this.$getIndent(line);
                        var indent = nextIndent + session.getTabString();
                        if (nextToken && nextToken.value === "</") return {
                            text: "\n" + indent + "\n" + nextIndent,
                            selection: [
                                1,
                                indent.length,
                                1,
                                indent.length
                            ]
                        };
                        else return {
                            text: "\n" + indent
                        };
                    }
                }
            }
        });
    };
    oop.inherits(XmlBehaviour, Behaviour);
    exports.XmlBehaviour = XmlBehaviour;
});
ace.define("ace/mode/folding/xml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(voidElements, optionalEndTags) {
        BaseFoldMode.call(this);
        this.voidElements = voidElements || {};
        this.optionalEndTags = oop.mixin({}, this.voidElements);
        if (optionalEndTags) oop.mixin(this.optionalEndTags, optionalEndTags);
    };
    oop.inherits(FoldMode, BaseFoldMode);
    var Tag = function() {
        this.tagName = "";
        this.closing = false;
        this.selfClosing = false;
        this.start = {
            row: 0,
            column: 0
        };
        this.end = {
            row: 0,
            column: 0
        };
    };
    function is(token, type) {
        return token.type.lastIndexOf(type + ".xml") > -1;
    }
    (function() {
        this.getFoldWidget = function(session, foldStyle, row) {
            var tag = this._getFirstTagInLine(session, row);
            if (!tag) return this.getCommentFoldWidget(session, row);
            if (tag.closing || !tag.tagName && tag.selfClosing) return foldStyle === "markbeginend" ? "end" : "";
            if (!tag.tagName || tag.selfClosing || this.voidElements.hasOwnProperty(tag.tagName.toLowerCase())) return "";
            if (this._findEndTagInLine(session, row, tag.tagName, tag.end.column)) return "";
            return "start";
        };
        this.getCommentFoldWidget = function(session, row) {
            if (/comment/.test(session.getState(row)) && /<!-/.test(session.getLine(row))) return "start";
            return "";
        };
        this._getFirstTagInLine = function(session, row) {
            var tokens = session.getTokens(row);
            var tag = new Tag();
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                if (is(token, "tag-open")) {
                    tag.end.column = tag.start.column + token.value.length;
                    tag.closing = is(token, "end-tag-open");
                    token = tokens[++i];
                    if (!token) return null;
                    tag.tagName = token.value;
                    if (token.value === "") {
                        token = tokens[++i];
                        if (!token) return null;
                        tag.tagName = token.value;
                    }
                    tag.end.column += token.value.length;
                    for(i++; i < tokens.length; i++){
                        token = tokens[i];
                        tag.end.column += token.value.length;
                        if (is(token, "tag-close")) {
                            tag.selfClosing = token.value == "/>";
                            break;
                        }
                    }
                    return tag;
                } else if (is(token, "tag-close")) {
                    tag.selfClosing = token.value == "/>";
                    return tag;
                }
                tag.start.column += token.value.length;
            }
            return null;
        };
        this._findEndTagInLine = function(session, row, tagName, startColumn) {
            var tokens = session.getTokens(row);
            var column = 0;
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                column += token.value.length;
                if (column < startColumn - 1) continue;
                if (is(token, "end-tag-open")) {
                    token = tokens[i + 1];
                    if (is(token, "tag-name") && token.value === "") token = tokens[i + 2];
                    if (token && token.value == tagName) return true;
                }
            }
            return false;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            var firstTag = this._getFirstTagInLine(session, row);
            if (!firstTag) return this.getCommentFoldWidget(session, row) && session.getCommentFoldRange(row, session.getLine(row).length);
            var tags = session.getMatchingTags({
                row: row,
                column: 0
            });
            if (tags) return new Range(tags.openTag.end.row, tags.openTag.end.column, tags.closeTag.start.row, tags.closeTag.start.column);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/xml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/mode/text",
    "ace/mode/xml_highlight_rules",
    "ace/mode/behaviour/xml",
    "ace/mode/folding/xml",
    "ace/worker/worker_client"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var lang = require("../lib/lang");
    var TextMode = require("./text").Mode;
    var XmlHighlightRules = require("./xml_highlight_rules").XmlHighlightRules;
    var XmlBehaviour = require("./behaviour/xml").XmlBehaviour;
    var XmlFoldMode = require("./folding/xml").FoldMode;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var Mode = function() {
        this.HighlightRules = XmlHighlightRules;
        this.$behaviour = new XmlBehaviour();
        this.foldingRules = new XmlFoldMode();
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.voidElements = lang.arrayToMap([]);
        this.blockComment = {
            start: "<!--",
            end: "-->"
        };
        this.createWorker = function(session) {
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/xml_worker", "Worker");
            worker.attachToDocument(session.getDocument());
            worker.on("error", function(e) {
                session.setAnnotations(e.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/xml";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
ace.define("ace/mode/jsdoc_comment_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var JsDocCommentHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: [
                        "comment.doc.tag",
                        "comment.doc.text",
                        "lparen.doc"
                    ],
                    regex: "(@(?:param|member|typedef|property|namespace|var|const|callback))(\\s*)({)",
                    push: [
                        {
                            token: "lparen.doc",
                            regex: "{",
                            push: [
                                {
                                    include: "doc-syntax"
                                },
                                {
                                    token: "rparen.doc",
                                    regex: "}|(?=$)",
                                    next: "pop"
                                }
                            ]
                        },
                        {
                            token: [
                                "rparen.doc",
                                "text.doc",
                                "variable.parameter.doc",
                                "lparen.doc",
                                "variable.parameter.doc",
                                "rparen.doc"
                            ],
                            regex: /(})(\s*)(?:([\w=:\/\.]+)|(?:(\[)([\w=:\/\.\-\'\" ]+)(\])))/,
                            next: "pop"
                        },
                        {
                            token: "rparen.doc",
                            regex: "}|(?=$)",
                            next: "pop"
                        },
                        {
                            include: "doc-syntax"
                        },
                        {
                            defaultToken: "text.doc"
                        }
                    ]
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "lparen.doc"
                    ],
                    regex: "(@(?:returns?|yields|type|this|suppress|public|protected|private|package|modifies|implements|external|exception|throws|enum|define|extends))(\\s*)({)",
                    push: [
                        {
                            token: "lparen.doc",
                            regex: "{",
                            push: [
                                {
                                    include: "doc-syntax"
                                },
                                {
                                    token: "rparen.doc",
                                    regex: "}|(?=$)",
                                    next: "pop"
                                }
                            ]
                        },
                        {
                            token: "rparen.doc",
                            regex: "}|(?=$)",
                            next: "pop"
                        },
                        {
                            include: "doc-syntax"
                        },
                        {
                            defaultToken: "text.doc"
                        }
                    ]
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "variable.parameter.doc"
                    ],
                    regex: '(@(?:alias|memberof|instance|module|name|lends|namespace|external|this|template|requires|param|implements|function|extends|typedef|mixes|constructor|var|memberof\\!|event|listens|exports|class|constructs|interface|emits|fires|throws|const|callback|borrows|augments))(\\s+)(\\w[\\w#.:/~"\\-]*)?'
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "variable.parameter.doc"
                    ],
                    regex: "(@method)(\\s+)(\\w[\\w.\\(\\)]*)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@access\\s+(?:private|public|protected)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@kind\\s+(?:class|constant|event|external|file|function|member|mixin|module|namespace|typedef)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@\\w+(?=\\s|$)"
                },
                JsDocCommentHighlightRules.getTagRule(),
                {
                    defaultToken: "comment.doc.body",
                    caseInsensitive: true
                }
            ],
            "doc-syntax": [
                {
                    token: "operator.doc",
                    regex: /[|:]/
                },
                {
                    token: "paren.doc",
                    regex: /[\[\]]/
                }
            ]
        };
        this.normalizeRules();
    };
    oop.inherits(JsDocCommentHighlightRules, TextHighlightRules);
    JsDocCommentHighlightRules.getTagRule = function(start) {
        return {
            token: "comment.doc.tag.storage.type",
            regex: "\\b(?:TODO|FIXME|XXX|HACK)\\b"
        };
    };
    JsDocCommentHighlightRules.getStartRule = function(start) {
        return {
            token: "comment.doc",
            regex: /\/\*\*(?!\/)/,
            next: start
        };
    };
    JsDocCommentHighlightRules.getEndRule = function(start) {
        return {
            token: "comment.doc",
            regex: "\\*\\/",
            next: start
        };
    };
    exports.JsDocCommentHighlightRules = JsDocCommentHighlightRules;
});
ace.define("ace/mode/javascript_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/jsdoc_comment_highlight_rules",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var DocCommentHighlightRules = require("./jsdoc_comment_highlight_rules").JsDocCommentHighlightRules;
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var identifierRe = "[a-zA-Z\\$_\xa1-\uFFFF][a-zA-Z\\d\\$_\xa1-\uFFFF]*";
    var JavaScriptHighlightRules = function(options) {
        var keywords = {
            "variable.language": "Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|Symbol|Namespace|QName|XML|XMLList|ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|SyntaxError|TypeError|URIError|decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|isNaN|parseFloat|parseInt|JSON|Math|this|arguments|prototype|window|document",
            "keyword": "const|yield|import|get|set|async|await|break|case|catch|continue|default|delete|do|else|finally|for|if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|__parent__|__count__|escape|unescape|with|__proto__|class|enum|extends|super|export|implements|private|public|interface|package|protected|static|constructor",
            "storage.type": "const|let|var|function",
            "constant.language": "null|Infinity|NaN|undefined",
            "support.function": "alert",
            "constant.language.boolean": "true|false"
        };
        var keywordMapper = this.createKeywordMapper(keywords, "identifier");
        var kwBeforeRe = "case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void";
        var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|u{[0-9a-fA-F]{1,6}}|[0-2][0-7]{0,2}|3[0-7][0-7]?|[4-7][0-7]?|.)";
        var anonymousFunctionRe = "(function)(\\s*)(\\*?)";
        var functionCallStartRule = {
            token: [
                "identifier",
                "text",
                "paren.lparen"
            ],
            regex: "(\\b(?!" + Object.values(keywords).join("|") + "\\b)" + identifierRe + ")(\\s*)(\\()"
        };
        this.$rules = {
            "no_regex": [
                DocCommentHighlightRules.getStartRule("doc-start"),
                comments("no_regex"),
                functionCallStartRule,
                {
                    token: "string",
                    regex: "'(?=.)",
                    next: "qstring"
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    next: "qqstring"
                },
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
                },
                {
                    token: "constant.numeric",
                    regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
                },
                {
                    token: [
                        "entity.name.function",
                        "text",
                        "keyword.operator",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\s*)(=)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(function)(?:(?:(\\s*)(\\*)(\\s*))|(\\s+))(" + identifierRe + ")(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "entity.name.function",
                        "text",
                        "punctuation.operator",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\s*)(:)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "text",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(:)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: "keyword",
                    regex: "from(?=\\s*('|\"))"
                },
                {
                    token: "keyword",
                    regex: "(?:" + kwBeforeRe + ")\\b",
                    next: "start"
                },
                {
                    token: "support.constant",
                    regex: /that\b/
                },
                {
                    token: [
                        "storage.type",
                        "punctuation.operator",
                        "support.function.firebug"
                    ],
                    regex: /(console)(\.)(warn|info|log|error|debug|time|trace|timeEnd|assert)\b/
                },
                {
                    token: keywordMapper,
                    regex: identifierRe
                },
                {
                    token: "punctuation.operator",
                    regex: /[.](?![.])/,
                    next: "property"
                },
                {
                    token: "storage.type",
                    regex: /=>/,
                    next: "start"
                },
                {
                    token: "keyword.operator",
                    regex: /--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,
                    next: "start"
                },
                {
                    token: "punctuation.operator",
                    regex: /[?:,;.]/,
                    next: "start"
                },
                {
                    token: "paren.lparen",
                    regex: /[\[({]/,
                    next: "start"
                },
                {
                    token: "paren.rparen",
                    regex: /[\])}]/
                },
                {
                    token: "comment",
                    regex: /^#!.*$/
                }
            ],
            property: [
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "keyword.operator",
                    regex: /=/
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(function)(?:(?:(\\s*)(\\*)(\\s*))|(\\s+))(\\w+)(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: "punctuation.operator",
                    regex: /[.](?![.])/
                },
                {
                    token: "support.function",
                    regex: "prototype"
                },
                {
                    token: "support.function",
                    regex: /(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|lter|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward|rEach)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/
                },
                {
                    token: "support.function.dom",
                    regex: /(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/
                },
                {
                    token: "support.constant",
                    regex: /(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/
                },
                {
                    token: "identifier",
                    regex: identifierRe
                },
                {
                    regex: "",
                    token: "empty",
                    next: "no_regex"
                }
            ],
            "start": [
                DocCommentHighlightRules.getStartRule("doc-start"),
                comments("start"),
                {
                    token: "string.regexp",
                    regex: "\\/",
                    next: "regex"
                },
                {
                    token: "text",
                    regex: "\\s+|^$",
                    next: "start"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "regex": [
                {
                    token: "regexp.keyword.operator",
                    regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
                },
                {
                    token: "string.regexp",
                    regex: "/[sxngimy]*",
                    next: "no_regex"
                },
                {
                    token: "invalid",
                    regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
                },
                {
                    token: "constant.language.escape",
                    regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
                },
                {
                    token: "constant.language.delimiter",
                    regex: /\|/
                },
                {
                    token: "constant.language.escape",
                    regex: /\[\^?/,
                    next: "regex_character_class"
                },
                {
                    token: "empty",
                    regex: "$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string.regexp"
                }
            ],
            "regex_character_class": [
                {
                    token: "regexp.charclass.keyword.operator",
                    regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
                },
                {
                    token: "constant.language.escape",
                    regex: "]",
                    next: "regex"
                },
                {
                    token: "constant.language.escape",
                    regex: "-"
                },
                {
                    token: "empty",
                    regex: "$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string.regexp.charachterclass"
                }
            ],
            "default_parameter": [
                {
                    token: "string",
                    regex: "'(?=.)",
                    push: [
                        {
                            token: "string",
                            regex: "'|$",
                            next: "pop"
                        },
                        {
                            include: "qstring"
                        }
                    ]
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    push: [
                        {
                            token: "string",
                            regex: '"|$',
                            next: "pop"
                        },
                        {
                            include: "qqstring"
                        }
                    ]
                },
                {
                    token: "constant.language",
                    regex: "null|Infinity|NaN|undefined"
                },
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
                },
                {
                    token: "constant.numeric",
                    regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
                },
                {
                    token: "punctuation.operator",
                    regex: ",",
                    next: "function_arguments"
                },
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.operator",
                    regex: "$"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "function_arguments": [
                comments("function_arguments"),
                {
                    token: "variable.parameter",
                    regex: identifierRe
                },
                {
                    token: "punctuation.operator",
                    regex: ","
                },
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.operator",
                    regex: "$"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "qqstring": [
                {
                    token: "constant.language.escape",
                    regex: escapedRe
                },
                {
                    token: "string",
                    regex: "\\\\$",
                    consumeLineEnd: true
                },
                {
                    token: "string",
                    regex: '"|$',
                    next: "no_regex"
                },
                {
                    defaultToken: "string"
                }
            ],
            "qstring": [
                {
                    token: "constant.language.escape",
                    regex: escapedRe
                },
                {
                    token: "string",
                    regex: "\\\\$",
                    consumeLineEnd: true
                },
                {
                    token: "string",
                    regex: "'|$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string"
                }
            ]
        };
        if (!options || !options.noES6) {
            this.$rules.no_regex.unshift({
                regex: "[{}]",
                onMatch: function(val, state, stack) {
                    this.next = val == "{" ? this.nextState : "";
                    if (val == "{" && stack.length) stack.unshift("start", state);
                    else if (val == "}" && stack.length) {
                        stack.shift();
                        this.next = stack.shift();
                        if (this.next.indexOf("string") != -1 || this.next.indexOf("jsx") != -1) return "paren.quasi.end";
                    }
                    return val == "{" ? "paren.lparen" : "paren.rparen";
                },
                nextState: "start"
            }, {
                token: "string.quasi.start",
                regex: /`/,
                push: [
                    {
                        token: "constant.language.escape",
                        regex: escapedRe
                    },
                    {
                        token: "paren.quasi.start",
                        regex: /\${/,
                        push: "start"
                    },
                    {
                        token: "string.quasi.end",
                        regex: /`/,
                        next: "pop"
                    },
                    {
                        defaultToken: "string.quasi"
                    }
                ]
            }, {
                token: [
                    "variable.parameter",
                    "text"
                ],
                regex: "(" + identifierRe + ")(\\s*)(?=\\=>)"
            }, {
                token: "paren.lparen",
                regex: "(\\()(?=[^\\(]+\\s*=>)",
                next: "function_arguments"
            }, {
                token: "variable.language",
                regex: "(?:(?:(?:Weak)?(?:Set|Map))|Promise)\\b"
            });
            this.$rules["function_arguments"].unshift({
                token: "keyword.operator",
                regex: "=",
                next: "default_parameter"
            }, {
                token: "keyword.operator",
                regex: "\\.{3}"
            });
            this.$rules["property"].unshift({
                token: "support.function",
                regex: "(findIndex|repeat|startsWith|endsWith|includes|isSafeInteger|trunc|cbrt|log2|log10|sign|then|catch|finally|resolve|reject|race|any|all|allSettled|keys|entries|isInteger)\\b(?=\\()"
            }, {
                token: "constant.language",
                regex: "(?:MAX_SAFE_INTEGER|MIN_SAFE_INTEGER|EPSILON)\\b"
            });
            if (!options || options.jsx != false) JSX.call(this);
        }
        this.embedRules(DocCommentHighlightRules, "doc-", [
            DocCommentHighlightRules.getEndRule("no_regex")
        ]);
        this.normalizeRules();
    };
    oop.inherits(JavaScriptHighlightRules, TextHighlightRules);
    function JSX() {
        var tagRegex = identifierRe.replace("\\d", "\\d\\-");
        var jsxTag = {
            onMatch: function(val, state, stack) {
                var offset = val.charAt(1) == "/" ? 2 : 1;
                if (offset == 1) {
                    if (state != this.nextState) stack.unshift(this.next, this.nextState, 0);
                    else stack.unshift(this.next);
                    stack[2]++;
                } else if (offset == 2) {
                    if (state == this.nextState) {
                        stack[1]--;
                        if (!stack[1] || stack[1] < 0) {
                            stack.shift();
                            stack.shift();
                        }
                    }
                }
                return [
                    {
                        type: "meta.tag.punctuation." + (offset == 1 ? "" : "end-") + "tag-open.xml",
                        value: val.slice(0, offset)
                    },
                    {
                        type: "meta.tag.tag-name.xml",
                        value: val.substr(offset)
                    }
                ];
            },
            regex: "</?(?:" + tagRegex + "|(?=>))",
            next: "jsxAttributes",
            nextState: "jsx"
        };
        this.$rules.start.unshift(jsxTag);
        var jsxJsRule = {
            regex: "{",
            token: "paren.quasi.start",
            push: "start"
        };
        this.$rules.jsx = [
            jsxJsRule,
            jsxTag,
            {
                include: "reference"
            },
            {
                defaultToken: "string.xml"
            }
        ];
        this.$rules.jsxAttributes = [
            {
                token: "meta.tag.punctuation.tag-close.xml",
                regex: "/?>",
                onMatch: function(value, currentState, stack) {
                    if (currentState == stack[0]) stack.shift();
                    if (value.length == 2) {
                        if (stack[0] == this.nextState) stack[1]--;
                        if (!stack[1] || stack[1] < 0) stack.splice(0, 2);
                    }
                    this.next = stack[0] || "start";
                    return [
                        {
                            type: this.token,
                            value: value
                        }
                    ];
                },
                nextState: "jsx"
            },
            jsxJsRule,
            comments("jsxAttributes"),
            {
                token: "entity.other.attribute-name.xml",
                regex: tagRegex
            },
            {
                token: "keyword.operator.attribute-equals.xml",
                regex: "="
            },
            {
                token: "text.tag-whitespace.xml",
                regex: "\\s+"
            },
            {
                token: "string.attribute-value.xml",
                regex: "'",
                stateName: "jsx_attr_q",
                push: [
                    {
                        token: "string.attribute-value.xml",
                        regex: "'",
                        next: "pop"
                    },
                    {
                        include: "reference"
                    },
                    {
                        defaultToken: "string.attribute-value.xml"
                    }
                ]
            },
            {
                token: "string.attribute-value.xml",
                regex: '"',
                stateName: "jsx_attr_qq",
                push: [
                    {
                        token: "string.attribute-value.xml",
                        regex: '"',
                        next: "pop"
                    },
                    {
                        include: "reference"
                    },
                    {
                        defaultToken: "string.attribute-value.xml"
                    }
                ]
            },
            jsxTag
        ];
        this.$rules.reference = [
            {
                token: "constant.language.escape.reference.xml",
                regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
            }
        ];
    }
    function comments(next) {
        return [
            {
                token: "comment",
                regex: /\/\*/,
                next: [
                    DocCommentHighlightRules.getTagRule(),
                    {
                        token: "comment",
                        regex: "\\*\\/",
                        next: next || "pop"
                    },
                    {
                        defaultToken: "comment",
                        caseInsensitive: true
                    }
                ]
            },
            {
                token: "comment",
                regex: "\\/\\/",
                next: [
                    DocCommentHighlightRules.getTagRule(),
                    {
                        token: "comment",
                        regex: "$|^",
                        next: next || "pop"
                    },
                    {
                        defaultToken: "comment",
                        caseInsensitive: true
                    }
                ]
            }
        ];
    }
    exports.JavaScriptHighlightRules = JavaScriptHighlightRules;
});
ace.define("ace/mode/matching_brace_outdent", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var MatchingBraceOutdent = function() {};
    (function() {
        this.checkOutdent = function(line, input) {
            if (!/^\s+$/.test(line)) return false;
            return /^\s*\}/.test(input);
        };
        this.autoOutdent = function(doc, row) {
            var line = doc.getLine(row);
            var match = line.match(/^(\s*\})/);
            if (!match) return 0;
            var column = match[1].length;
            var openBracePos = doc.findMatchingBracket({
                row: row,
                column: column
            });
            if (!openBracePos || openBracePos.row == row) return 0;
            var indent = this.$getIndent(doc.getLine(openBracePos.row));
            doc.replace(new Range(row, 0, row, column - 1), indent);
        };
        this.$getIndent = function(line) {
            return line.match(/^\s*/)[0];
        };
    }).call(MatchingBraceOutdent.prototype);
    exports.MatchingBraceOutdent = MatchingBraceOutdent;
});
ace.define("ace/mode/behaviour/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/token_iterator",
    "ace/mode/behaviour/cstyle",
    "ace/mode/behaviour/xml"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var TokenIterator = require("../../token_iterator").TokenIterator;
    var CstyleBehaviour = require("../behaviour/cstyle").CstyleBehaviour;
    var XmlBehaviour = require("../behaviour/xml").XmlBehaviour;
    var JavaScriptBehaviour = function() {
        var xmlBehaviours = new XmlBehaviour({
            closeCurlyBraces: true
        }).getBehaviours();
        this.addBehaviours(xmlBehaviours);
        this.inherit(CstyleBehaviour);
        this.add("autoclosing-fragment", "insertion", function(state, action, editor, session, text) {
            if (text == ">") {
                var position = editor.getSelectionRange().start;
                var iterator = new TokenIterator(session, position.row, position.column);
                var token = iterator.getCurrentToken() || iterator.stepBackward();
                if (!token) return;
                if (token.value == "<") return {
                    text: "></>",
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
    };
    oop.inherits(JavaScriptBehaviour, CstyleBehaviour);
    exports.JavaScriptBehaviour = JavaScriptBehaviour;
});
ace.define("ace/mode/folding/cstyle", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
    };
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
        this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
        this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
        this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
        this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
        this._getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            if (this.singleLineBlockCommentRe.test(line)) {
                if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line)) return "";
            }
            var fw = this._getFoldWidgetBase(session, foldStyle, row);
            if (!fw && this.startRegionRe.test(line)) return "start"; // lineCommentRegionStart
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var line = session.getLine(row);
            if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
            var match = line.match(this.foldingStartMarker);
            if (match) {
                var i = match.index;
                if (match[1]) return this.openingBracketBlock(session, match[1], row, i);
                var range = session.getCommentFoldRange(row, i + match[0].length, 1);
                if (range && !range.isMultiLine()) {
                    if (forceMultiline) range = this.getSectionRange(session, row);
                    else if (foldStyle != "all") range = null;
                }
                return range;
            }
            if (foldStyle === "markbegin") return;
            var match = line.match(this.foldingStopMarker);
            if (match) {
                var i = match.index + match[0].length;
                if (match[1]) return this.closingBracketBlock(session, match[1], row, i);
                return session.getCommentFoldRange(row, i, -1);
            }
        };
        this.getSectionRange = function(session, row) {
            var line = session.getLine(row);
            var startIndent = line.search(/\S/);
            var startRow = row;
            var startColumn = line.length;
            row = row + 1;
            var endRow = row;
            var maxRow = session.getLength();
            while(++row < maxRow){
                line = session.getLine(row);
                var indent = line.search(/\S/);
                if (indent === -1) continue;
                if (startIndent > indent) break;
                var subRange = this.getFoldWidgetRange(session, "all", row);
                if (subRange) {
                    if (subRange.start.row <= startRow) break;
                    else if (subRange.isMultiLine()) row = subRange.end.row;
                    else if (startIndent == indent) break;
                }
                endRow = row;
            }
            return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
        };
        this.getCommentRegionBlock = function(session, line, row) {
            var startColumn = line.search(/\s*$/);
            var maxRow = session.getLength();
            var startRow = row;
            var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
            var depth = 1;
            while(++row < maxRow){
                line = session.getLine(row);
                var m = re.exec(line);
                if (!m) continue;
                if (m[1]) depth--;
                else depth++;
                if (!depth) break;
            }
            var endRow = row;
            if (endRow > startRow) return new Range(startRow, startColumn, endRow, line.length);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/folding/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/folding/xml",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var XmlFoldMode = require("./xml").FoldMode;
    var CFoldMode = require("./cstyle").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
        this.xmlFoldMode = new XmlFoldMode();
    };
    oop.inherits(FoldMode, CFoldMode);
    (function() {
        this.getFoldWidgetRangeBase = this.getFoldWidgetRange;
        this.getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var fw = this.getFoldWidgetBase(session, foldStyle, row);
            if (!fw) return this.xmlFoldMode.getFoldWidget(session, foldStyle, row);
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var range = this.getFoldWidgetRangeBase(session, foldStyle, row, forceMultiline);
            if (range) return range;
            return this.xmlFoldMode.getFoldWidgetRange(session, foldStyle, row);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/javascript_highlight_rules",
    "ace/mode/matching_brace_outdent",
    "ace/worker/worker_client",
    "ace/mode/behaviour/javascript",
    "ace/mode/folding/javascript"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var JavaScriptHighlightRules = require("./javascript_highlight_rules").JavaScriptHighlightRules;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var JavaScriptBehaviour = require("./behaviour/javascript").JavaScriptBehaviour;
    var JavaScriptFoldMode = require("./folding/javascript").FoldMode;
    var Mode = function() {
        this.HighlightRules = JavaScriptHighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.$behaviour = new JavaScriptBehaviour();
        this.foldingRules = new JavaScriptFoldMode();
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.lineCommentStart = "//";
        this.blockComment = {
            start: "/*",
            end: "*/"
        };
        this.$quotes = {
            '"': '"',
            "'": "'",
            "`": "`"
        };
        this.$pairQuotesAfter = {
            "`": /\w/
        };
        this.getNextLineIndent = function(state, line, tab) {
            var indent = this.$getIndent(line);
            var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
            var tokens = tokenizedLine.tokens;
            var endState = tokenizedLine.state;
            if (tokens.length && tokens[tokens.length - 1].type == "comment") return indent;
            if (state == "start" || state == "no_regex") {
                var match = line.match(/^.*(?:\bcase\b.*:|[\{\(\[])\s*$/);
                if (match) indent += tab;
            } else if (state == "doc-start") {
                if (endState == "start" || endState == "no_regex") return "";
            }
            return indent;
        };
        this.checkOutdent = function(state, line, input) {
            return this.$outdent.checkOutdent(line, input);
        };
        this.autoOutdent = function(state, doc, row) {
            this.$outdent.autoOutdent(doc, row);
        };
        this.createWorker = function(session) {
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/javascript_worker", "JavaScriptWorker");
            worker.attachToDocument(session.getDocument());
            worker.on("annotate", function(results) {
                session.setAnnotations(results.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/javascript";
        this.snippetFileId = "ace/snippets/javascript";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
ace.define("ace/mode/svg_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/javascript_highlight_rules",
    "ace/mode/xml_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var JavaScriptHighlightRules = require("./javascript_highlight_rules").JavaScriptHighlightRules;
    var XmlHighlightRules = require("./xml_highlight_rules").XmlHighlightRules;
    var SvgHighlightRules = function() {
        XmlHighlightRules.call(this);
        this.embedTagRules(JavaScriptHighlightRules, "js-", "script");
        this.normalizeRules();
    };
    oop.inherits(SvgHighlightRules, XmlHighlightRules);
    exports.SvgHighlightRules = SvgHighlightRules;
});
ace.define("ace/mode/folding/mixed", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(defaultMode, subModes) {
        this.defaultMode = defaultMode;
        this.subModes = subModes;
    };
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.$getMode = function(state) {
            if (typeof state != "string") state = state[0];
            for(var key in this.subModes){
                if (state.indexOf(key) === 0) return this.subModes[key];
            }
            return null;
        };
        this.$tryMode = function(state, session, foldStyle, row) {
            var mode = this.$getMode(state);
            return mode ? mode.getFoldWidget(session, foldStyle, row) : "";
        };
        this.getFoldWidget = function(session, foldStyle, row) {
            return this.$tryMode(session.getState(row - 1), session, foldStyle, row) || this.$tryMode(session.getState(row), session, foldStyle, row) || this.defaultMode.getFoldWidget(session, foldStyle, row);
        };
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            var mode = this.$getMode(session.getState(row - 1));
            if (!mode || !mode.getFoldWidget(session, foldStyle, row)) mode = this.$getMode(session.getState(row));
            if (!mode || !mode.getFoldWidget(session, foldStyle, row)) mode = this.defaultMode;
            return mode.getFoldWidgetRange(session, foldStyle, row);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/svg", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/xml",
    "ace/mode/javascript",
    "ace/mode/svg_highlight_rules",
    "ace/mode/folding/mixed",
    "ace/mode/folding/xml",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var XmlMode = require("./xml").Mode;
    var JavaScriptMode = require("./javascript").Mode;
    var SvgHighlightRules = require("./svg_highlight_rules").SvgHighlightRules;
    var MixedFoldMode = require("./folding/mixed").FoldMode;
    var XmlFoldMode = require("./folding/xml").FoldMode;
    var CStyleFoldMode = require("./folding/cstyle").FoldMode;
    var Mode = function() {
        XmlMode.call(this);
        this.HighlightRules = SvgHighlightRules;
        this.createModeDelegates({
            "js-": JavaScriptMode
        });
        this.foldingRules = new MixedFoldMode(new XmlFoldMode(), {
            "js-": new CStyleFoldMode()
        });
    };
    oop.inherits(Mode, XmlMode);
    (function() {
        this.getNextLineIndent = function(state, line, tab) {
            return this.$getIndent(line);
        };
        this.$id = "ace/mode/svg";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/svg"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("aZF5h", function(module, exports) {
(function() {
    ace.require([
        "ace/mode/text"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("k3Vas", function(module, exports) {
ace.define("ace/mode/toml_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var TomlHighlightRules = function() {
        var keywordMapper = this.createKeywordMapper({
            "constant.language.boolean": "true|false"
        }, "identifier");
        var identifierRe = "[a-zA-Z\\$_\xa1-\uFFFF][a-zA-Z\\d\\$_\xa1-\uFFFF]*\\b";
        this.$rules = {
            "start": [
                {
                    token: "comment.toml",
                    regex: /#.*$/
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    next: "qqstring"
                },
                {
                    token: [
                        "variable.keygroup.toml"
                    ],
                    regex: "(?:^\\s*)(\\[\\[([^\\]]+)\\]\\])"
                },
                {
                    token: [
                        "variable.keygroup.toml"
                    ],
                    regex: "(?:^\\s*)(\\[([^\\]]+)\\])"
                },
                {
                    token: keywordMapper,
                    regex: identifierRe
                },
                {
                    token: "support.date.toml",
                    regex: "\\d{4}-\\d{2}-\\d{2}(T)\\d{2}:\\d{2}:\\d{2}(Z)"
                },
                {
                    token: "constant.numeric.toml",
                    regex: "-?\\d+(\\.?\\d+)?"
                }
            ],
            "qqstring": [
                {
                    token: "string",
                    regex: "\\\\$",
                    next: "qqstring"
                },
                {
                    token: "constant.language.escape",
                    regex: '\\\\[0tnr"\\\\]'
                },
                {
                    token: "string",
                    regex: '"|$',
                    next: "start"
                },
                {
                    defaultToken: "string"
                }
            ]
        };
    };
    oop.inherits(TomlHighlightRules, TextHighlightRules);
    exports.TomlHighlightRules = TomlHighlightRules;
});
ace.define("ace/mode/folding/ini", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function() {};
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.foldingStartMarker = /^\s*\[([^\])]*)]\s*(?:$|[;#])/;
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            var re = this.foldingStartMarker;
            var line = session.getLine(row);
            var m = line.match(re);
            if (!m) return;
            var startName = m[1] + ".";
            var startColumn = line.length;
            var maxRow = session.getLength();
            var startRow = row;
            var endRow = row;
            while(++row < maxRow){
                line = session.getLine(row);
                if (/^\s*$/.test(line)) continue;
                m = line.match(re);
                if (m && m[1].lastIndexOf(startName, 0) !== 0) break;
                endRow = row;
            }
            if (endRow > startRow) {
                var endColumn = session.getLine(endRow).length;
                return new Range(startRow, startColumn, endRow, endColumn);
            }
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/toml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/toml_highlight_rules",
    "ace/mode/folding/ini"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var TomlHighlightRules = require("./toml_highlight_rules").TomlHighlightRules;
    var FoldMode = require("./folding/ini").FoldMode;
    var Mode = function() {
        this.HighlightRules = TomlHighlightRules;
        this.foldingRules = new FoldMode();
        this.$behaviour = this.$defaultBehaviour;
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.lineCommentStart = "#";
        this.$id = "ace/mode/toml";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/toml"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("fBCSK", function(module, exports) {
ace.define("ace/mode/jsdoc_comment_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var JsDocCommentHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: [
                        "comment.doc.tag",
                        "comment.doc.text",
                        "lparen.doc"
                    ],
                    regex: "(@(?:param|member|typedef|property|namespace|var|const|callback))(\\s*)({)",
                    push: [
                        {
                            token: "lparen.doc",
                            regex: "{",
                            push: [
                                {
                                    include: "doc-syntax"
                                },
                                {
                                    token: "rparen.doc",
                                    regex: "}|(?=$)",
                                    next: "pop"
                                }
                            ]
                        },
                        {
                            token: [
                                "rparen.doc",
                                "text.doc",
                                "variable.parameter.doc",
                                "lparen.doc",
                                "variable.parameter.doc",
                                "rparen.doc"
                            ],
                            regex: /(})(\s*)(?:([\w=:\/\.]+)|(?:(\[)([\w=:\/\.\-\'\" ]+)(\])))/,
                            next: "pop"
                        },
                        {
                            token: "rparen.doc",
                            regex: "}|(?=$)",
                            next: "pop"
                        },
                        {
                            include: "doc-syntax"
                        },
                        {
                            defaultToken: "text.doc"
                        }
                    ]
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "lparen.doc"
                    ],
                    regex: "(@(?:returns?|yields|type|this|suppress|public|protected|private|package|modifies|implements|external|exception|throws|enum|define|extends))(\\s*)({)",
                    push: [
                        {
                            token: "lparen.doc",
                            regex: "{",
                            push: [
                                {
                                    include: "doc-syntax"
                                },
                                {
                                    token: "rparen.doc",
                                    regex: "}|(?=$)",
                                    next: "pop"
                                }
                            ]
                        },
                        {
                            token: "rparen.doc",
                            regex: "}|(?=$)",
                            next: "pop"
                        },
                        {
                            include: "doc-syntax"
                        },
                        {
                            defaultToken: "text.doc"
                        }
                    ]
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "variable.parameter.doc"
                    ],
                    regex: '(@(?:alias|memberof|instance|module|name|lends|namespace|external|this|template|requires|param|implements|function|extends|typedef|mixes|constructor|var|memberof\\!|event|listens|exports|class|constructs|interface|emits|fires|throws|const|callback|borrows|augments))(\\s+)(\\w[\\w#.:/~"\\-]*)?'
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "variable.parameter.doc"
                    ],
                    regex: "(@method)(\\s+)(\\w[\\w.\\(\\)]*)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@access\\s+(?:private|public|protected)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@kind\\s+(?:class|constant|event|external|file|function|member|mixin|module|namespace|typedef)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@\\w+(?=\\s|$)"
                },
                JsDocCommentHighlightRules.getTagRule(),
                {
                    defaultToken: "comment.doc.body",
                    caseInsensitive: true
                }
            ],
            "doc-syntax": [
                {
                    token: "operator.doc",
                    regex: /[|:]/
                },
                {
                    token: "paren.doc",
                    regex: /[\[\]]/
                }
            ]
        };
        this.normalizeRules();
    };
    oop.inherits(JsDocCommentHighlightRules, TextHighlightRules);
    JsDocCommentHighlightRules.getTagRule = function(start) {
        return {
            token: "comment.doc.tag.storage.type",
            regex: "\\b(?:TODO|FIXME|XXX|HACK)\\b"
        };
    };
    JsDocCommentHighlightRules.getStartRule = function(start) {
        return {
            token: "comment.doc",
            regex: /\/\*\*(?!\/)/,
            next: start
        };
    };
    JsDocCommentHighlightRules.getEndRule = function(start) {
        return {
            token: "comment.doc",
            regex: "\\*\\/",
            next: start
        };
    };
    exports.JsDocCommentHighlightRules = JsDocCommentHighlightRules;
});
ace.define("ace/mode/javascript_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/jsdoc_comment_highlight_rules",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var DocCommentHighlightRules = require("./jsdoc_comment_highlight_rules").JsDocCommentHighlightRules;
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var identifierRe = "[a-zA-Z\\$_\xa1-\uFFFF][a-zA-Z\\d\\$_\xa1-\uFFFF]*";
    var JavaScriptHighlightRules = function(options) {
        var keywords = {
            "variable.language": "Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|Symbol|Namespace|QName|XML|XMLList|ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|SyntaxError|TypeError|URIError|decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|isNaN|parseFloat|parseInt|JSON|Math|this|arguments|prototype|window|document",
            "keyword": "const|yield|import|get|set|async|await|break|case|catch|continue|default|delete|do|else|finally|for|if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|__parent__|__count__|escape|unescape|with|__proto__|class|enum|extends|super|export|implements|private|public|interface|package|protected|static|constructor",
            "storage.type": "const|let|var|function",
            "constant.language": "null|Infinity|NaN|undefined",
            "support.function": "alert",
            "constant.language.boolean": "true|false"
        };
        var keywordMapper = this.createKeywordMapper(keywords, "identifier");
        var kwBeforeRe = "case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void";
        var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|u{[0-9a-fA-F]{1,6}}|[0-2][0-7]{0,2}|3[0-7][0-7]?|[4-7][0-7]?|.)";
        var anonymousFunctionRe = "(function)(\\s*)(\\*?)";
        var functionCallStartRule = {
            token: [
                "identifier",
                "text",
                "paren.lparen"
            ],
            regex: "(\\b(?!" + Object.values(keywords).join("|") + "\\b)" + identifierRe + ")(\\s*)(\\()"
        };
        this.$rules = {
            "no_regex": [
                DocCommentHighlightRules.getStartRule("doc-start"),
                comments("no_regex"),
                functionCallStartRule,
                {
                    token: "string",
                    regex: "'(?=.)",
                    next: "qstring"
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    next: "qqstring"
                },
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
                },
                {
                    token: "constant.numeric",
                    regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
                },
                {
                    token: [
                        "entity.name.function",
                        "text",
                        "keyword.operator",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\s*)(=)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(function)(?:(?:(\\s*)(\\*)(\\s*))|(\\s+))(" + identifierRe + ")(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "entity.name.function",
                        "text",
                        "punctuation.operator",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\s*)(:)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "text",
                        "text",
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(:)(\\s*)" + anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: "keyword",
                    regex: "from(?=\\s*('|\"))"
                },
                {
                    token: "keyword",
                    regex: "(?:" + kwBeforeRe + ")\\b",
                    next: "start"
                },
                {
                    token: "support.constant",
                    regex: /that\b/
                },
                {
                    token: [
                        "storage.type",
                        "punctuation.operator",
                        "support.function.firebug"
                    ],
                    regex: /(console)(\.)(warn|info|log|error|debug|time|trace|timeEnd|assert)\b/
                },
                {
                    token: keywordMapper,
                    regex: identifierRe
                },
                {
                    token: "punctuation.operator",
                    regex: /[.](?![.])/,
                    next: "property"
                },
                {
                    token: "storage.type",
                    regex: /=>/,
                    next: "start"
                },
                {
                    token: "keyword.operator",
                    regex: /--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,
                    next: "start"
                },
                {
                    token: "punctuation.operator",
                    regex: /[?:,;.]/,
                    next: "start"
                },
                {
                    token: "paren.lparen",
                    regex: /[\[({]/,
                    next: "start"
                },
                {
                    token: "paren.rparen",
                    regex: /[\])}]/
                },
                {
                    token: "comment",
                    regex: /^#!.*$/
                }
            ],
            property: [
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "keyword.operator",
                    regex: /=/
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: anonymousFunctionRe + "(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "storage.type",
                        "text",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(function)(?:(?:(\\s*)(\\*)(\\s*))|(\\s+))(\\w+)(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: "punctuation.operator",
                    regex: /[.](?![.])/
                },
                {
                    token: "support.function",
                    regex: "prototype"
                },
                {
                    token: "support.function",
                    regex: /(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|lter|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward|rEach)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/
                },
                {
                    token: "support.function.dom",
                    regex: /(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/
                },
                {
                    token: "support.constant",
                    regex: /(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/
                },
                {
                    token: "identifier",
                    regex: identifierRe
                },
                {
                    regex: "",
                    token: "empty",
                    next: "no_regex"
                }
            ],
            "start": [
                DocCommentHighlightRules.getStartRule("doc-start"),
                comments("start"),
                {
                    token: "string.regexp",
                    regex: "\\/",
                    next: "regex"
                },
                {
                    token: "text",
                    regex: "\\s+|^$",
                    next: "start"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "regex": [
                {
                    token: "regexp.keyword.operator",
                    regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
                },
                {
                    token: "string.regexp",
                    regex: "/[sxngimy]*",
                    next: "no_regex"
                },
                {
                    token: "invalid",
                    regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
                },
                {
                    token: "constant.language.escape",
                    regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
                },
                {
                    token: "constant.language.delimiter",
                    regex: /\|/
                },
                {
                    token: "constant.language.escape",
                    regex: /\[\^?/,
                    next: "regex_character_class"
                },
                {
                    token: "empty",
                    regex: "$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string.regexp"
                }
            ],
            "regex_character_class": [
                {
                    token: "regexp.charclass.keyword.operator",
                    regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
                },
                {
                    token: "constant.language.escape",
                    regex: "]",
                    next: "regex"
                },
                {
                    token: "constant.language.escape",
                    regex: "-"
                },
                {
                    token: "empty",
                    regex: "$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string.regexp.charachterclass"
                }
            ],
            "default_parameter": [
                {
                    token: "string",
                    regex: "'(?=.)",
                    push: [
                        {
                            token: "string",
                            regex: "'|$",
                            next: "pop"
                        },
                        {
                            include: "qstring"
                        }
                    ]
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    push: [
                        {
                            token: "string",
                            regex: '"|$',
                            next: "pop"
                        },
                        {
                            include: "qqstring"
                        }
                    ]
                },
                {
                    token: "constant.language",
                    regex: "null|Infinity|NaN|undefined"
                },
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
                },
                {
                    token: "constant.numeric",
                    regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
                },
                {
                    token: "punctuation.operator",
                    regex: ",",
                    next: "function_arguments"
                },
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.operator",
                    regex: "$"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "function_arguments": [
                comments("function_arguments"),
                {
                    token: "variable.parameter",
                    regex: identifierRe
                },
                {
                    token: "punctuation.operator",
                    regex: ","
                },
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.operator",
                    regex: "$"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "qqstring": [
                {
                    token: "constant.language.escape",
                    regex: escapedRe
                },
                {
                    token: "string",
                    regex: "\\\\$",
                    consumeLineEnd: true
                },
                {
                    token: "string",
                    regex: '"|$',
                    next: "no_regex"
                },
                {
                    defaultToken: "string"
                }
            ],
            "qstring": [
                {
                    token: "constant.language.escape",
                    regex: escapedRe
                },
                {
                    token: "string",
                    regex: "\\\\$",
                    consumeLineEnd: true
                },
                {
                    token: "string",
                    regex: "'|$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string"
                }
            ]
        };
        if (!options || !options.noES6) {
            this.$rules.no_regex.unshift({
                regex: "[{}]",
                onMatch: function(val, state, stack) {
                    this.next = val == "{" ? this.nextState : "";
                    if (val == "{" && stack.length) stack.unshift("start", state);
                    else if (val == "}" && stack.length) {
                        stack.shift();
                        this.next = stack.shift();
                        if (this.next.indexOf("string") != -1 || this.next.indexOf("jsx") != -1) return "paren.quasi.end";
                    }
                    return val == "{" ? "paren.lparen" : "paren.rparen";
                },
                nextState: "start"
            }, {
                token: "string.quasi.start",
                regex: /`/,
                push: [
                    {
                        token: "constant.language.escape",
                        regex: escapedRe
                    },
                    {
                        token: "paren.quasi.start",
                        regex: /\${/,
                        push: "start"
                    },
                    {
                        token: "string.quasi.end",
                        regex: /`/,
                        next: "pop"
                    },
                    {
                        defaultToken: "string.quasi"
                    }
                ]
            }, {
                token: [
                    "variable.parameter",
                    "text"
                ],
                regex: "(" + identifierRe + ")(\\s*)(?=\\=>)"
            }, {
                token: "paren.lparen",
                regex: "(\\()(?=[^\\(]+\\s*=>)",
                next: "function_arguments"
            }, {
                token: "variable.language",
                regex: "(?:(?:(?:Weak)?(?:Set|Map))|Promise)\\b"
            });
            this.$rules["function_arguments"].unshift({
                token: "keyword.operator",
                regex: "=",
                next: "default_parameter"
            }, {
                token: "keyword.operator",
                regex: "\\.{3}"
            });
            this.$rules["property"].unshift({
                token: "support.function",
                regex: "(findIndex|repeat|startsWith|endsWith|includes|isSafeInteger|trunc|cbrt|log2|log10|sign|then|catch|finally|resolve|reject|race|any|all|allSettled|keys|entries|isInteger)\\b(?=\\()"
            }, {
                token: "constant.language",
                regex: "(?:MAX_SAFE_INTEGER|MIN_SAFE_INTEGER|EPSILON)\\b"
            });
            if (!options || options.jsx != false) JSX.call(this);
        }
        this.embedRules(DocCommentHighlightRules, "doc-", [
            DocCommentHighlightRules.getEndRule("no_regex")
        ]);
        this.normalizeRules();
    };
    oop.inherits(JavaScriptHighlightRules, TextHighlightRules);
    function JSX() {
        var tagRegex = identifierRe.replace("\\d", "\\d\\-");
        var jsxTag = {
            onMatch: function(val, state, stack) {
                var offset = val.charAt(1) == "/" ? 2 : 1;
                if (offset == 1) {
                    if (state != this.nextState) stack.unshift(this.next, this.nextState, 0);
                    else stack.unshift(this.next);
                    stack[2]++;
                } else if (offset == 2) {
                    if (state == this.nextState) {
                        stack[1]--;
                        if (!stack[1] || stack[1] < 0) {
                            stack.shift();
                            stack.shift();
                        }
                    }
                }
                return [
                    {
                        type: "meta.tag.punctuation." + (offset == 1 ? "" : "end-") + "tag-open.xml",
                        value: val.slice(0, offset)
                    },
                    {
                        type: "meta.tag.tag-name.xml",
                        value: val.substr(offset)
                    }
                ];
            },
            regex: "</?(?:" + tagRegex + "|(?=>))",
            next: "jsxAttributes",
            nextState: "jsx"
        };
        this.$rules.start.unshift(jsxTag);
        var jsxJsRule = {
            regex: "{",
            token: "paren.quasi.start",
            push: "start"
        };
        this.$rules.jsx = [
            jsxJsRule,
            jsxTag,
            {
                include: "reference"
            },
            {
                defaultToken: "string.xml"
            }
        ];
        this.$rules.jsxAttributes = [
            {
                token: "meta.tag.punctuation.tag-close.xml",
                regex: "/?>",
                onMatch: function(value, currentState, stack) {
                    if (currentState == stack[0]) stack.shift();
                    if (value.length == 2) {
                        if (stack[0] == this.nextState) stack[1]--;
                        if (!stack[1] || stack[1] < 0) stack.splice(0, 2);
                    }
                    this.next = stack[0] || "start";
                    return [
                        {
                            type: this.token,
                            value: value
                        }
                    ];
                },
                nextState: "jsx"
            },
            jsxJsRule,
            comments("jsxAttributes"),
            {
                token: "entity.other.attribute-name.xml",
                regex: tagRegex
            },
            {
                token: "keyword.operator.attribute-equals.xml",
                regex: "="
            },
            {
                token: "text.tag-whitespace.xml",
                regex: "\\s+"
            },
            {
                token: "string.attribute-value.xml",
                regex: "'",
                stateName: "jsx_attr_q",
                push: [
                    {
                        token: "string.attribute-value.xml",
                        regex: "'",
                        next: "pop"
                    },
                    {
                        include: "reference"
                    },
                    {
                        defaultToken: "string.attribute-value.xml"
                    }
                ]
            },
            {
                token: "string.attribute-value.xml",
                regex: '"',
                stateName: "jsx_attr_qq",
                push: [
                    {
                        token: "string.attribute-value.xml",
                        regex: '"',
                        next: "pop"
                    },
                    {
                        include: "reference"
                    },
                    {
                        defaultToken: "string.attribute-value.xml"
                    }
                ]
            },
            jsxTag
        ];
        this.$rules.reference = [
            {
                token: "constant.language.escape.reference.xml",
                regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
            }
        ];
    }
    function comments(next) {
        return [
            {
                token: "comment",
                regex: /\/\*/,
                next: [
                    DocCommentHighlightRules.getTagRule(),
                    {
                        token: "comment",
                        regex: "\\*\\/",
                        next: next || "pop"
                    },
                    {
                        defaultToken: "comment",
                        caseInsensitive: true
                    }
                ]
            },
            {
                token: "comment",
                regex: "\\/\\/",
                next: [
                    DocCommentHighlightRules.getTagRule(),
                    {
                        token: "comment",
                        regex: "$|^",
                        next: next || "pop"
                    },
                    {
                        defaultToken: "comment",
                        caseInsensitive: true
                    }
                ]
            }
        ];
    }
    exports.JavaScriptHighlightRules = JavaScriptHighlightRules;
});
ace.define("ace/mode/matching_brace_outdent", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var MatchingBraceOutdent = function() {};
    (function() {
        this.checkOutdent = function(line, input) {
            if (!/^\s+$/.test(line)) return false;
            return /^\s*\}/.test(input);
        };
        this.autoOutdent = function(doc, row) {
            var line = doc.getLine(row);
            var match = line.match(/^(\s*\})/);
            if (!match) return 0;
            var column = match[1].length;
            var openBracePos = doc.findMatchingBracket({
                row: row,
                column: column
            });
            if (!openBracePos || openBracePos.row == row) return 0;
            var indent = this.$getIndent(doc.getLine(openBracePos.row));
            doc.replace(new Range(row, 0, row, column - 1), indent);
        };
        this.$getIndent = function(line) {
            return line.match(/^\s*/)[0];
        };
    }).call(MatchingBraceOutdent.prototype);
    exports.MatchingBraceOutdent = MatchingBraceOutdent;
});
ace.define("ace/mode/behaviour/xml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/behaviour",
    "ace/token_iterator"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Behaviour = require("../behaviour").Behaviour;
    var TokenIterator = require("../../token_iterator").TokenIterator;
    function is(token, type) {
        return token && token.type.lastIndexOf(type + ".xml") > -1;
    }
    var XmlBehaviour = function() {
        this.add("string_dquotes", "insertion", function(state, action, editor, session, text) {
            if (text == '"' || text == "'") {
                var quote = text;
                var selected = session.doc.getTextRange(editor.getSelectionRange());
                if (selected !== "" && selected !== "'" && selected != '"' && editor.getWrapBehavioursEnabled()) return {
                    text: quote + selected + quote,
                    selection: false
                };
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (rightChar == quote && (is(token, "attribute-value") || is(token, "string"))) return {
                    text: "",
                    selection: [
                        1,
                        1
                    ]
                };
                if (!token) token = iterator.stepBackward();
                if (!token) return;
                while(is(token, "tag-whitespace") || is(token, "whitespace"))token = iterator.stepBackward();
                var rightSpace = !rightChar || rightChar.match(/\s/);
                if (is(token, "attribute-equals") && (rightSpace || rightChar == ">") || is(token, "decl-attribute-equals") && (rightSpace || rightChar == "?")) return {
                    text: quote + quote,
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("string_dquotes", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && (selected == '"' || selected == "'")) {
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
                if (rightChar == selected) {
                    range.end.column++;
                    return range;
                }
            }
        });
        this.add("autoclosing", "insertion", function(state, action, editor, session, text) {
            if (text == ">") {
                var position = editor.getSelectionRange().start;
                var iterator = new TokenIterator(session, position.row, position.column);
                var token = iterator.getCurrentToken() || iterator.stepBackward();
                if (!token || !(is(token, "tag-name") || is(token, "tag-whitespace") || is(token, "attribute-name") || is(token, "attribute-equals") || is(token, "attribute-value"))) return;
                if (is(token, "reference.attribute-value")) return;
                if (is(token, "attribute-value")) {
                    var tokenEndColumn = iterator.getCurrentTokenColumn() + token.value.length;
                    if (position.column < tokenEndColumn) return;
                    if (position.column == tokenEndColumn) {
                        var nextToken = iterator.stepForward();
                        if (nextToken && is(nextToken, "attribute-value")) return;
                        iterator.stepBackward();
                    }
                }
                if (/^\s*>/.test(session.getLine(position.row).slice(position.column))) return;
                while(!is(token, "tag-name")){
                    token = iterator.stepBackward();
                    if (token.value == "<") {
                        token = iterator.stepForward();
                        break;
                    }
                }
                var tokenRow = iterator.getCurrentTokenRow();
                var tokenColumn = iterator.getCurrentTokenColumn();
                if (is(iterator.stepBackward(), "end-tag-open")) return;
                var element = token.value;
                if (tokenRow == position.row) element = element.substring(0, position.column - tokenColumn);
                if (this.voidElements && this.voidElements.hasOwnProperty(element.toLowerCase())) return;
                return {
                    text: "></" + element + ">",
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("autoindent", "insertion", function(state, action, editor, session, text) {
            if (text == "\n") {
                var cursor = editor.getCursorPosition();
                var line = session.getLine(cursor.row);
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (is(token, "") && token.type.indexOf("tag-close") !== -1) {
                    if (token.value == "/>") return;
                    while(token && token.type.indexOf("tag-name") === -1)token = iterator.stepBackward();
                    if (!token) return;
                    var tag = token.value;
                    var row = iterator.getCurrentTokenRow();
                    token = iterator.stepBackward();
                    if (!token || token.type.indexOf("end-tag") !== -1) return;
                    if (this.voidElements && !this.voidElements[tag] || !this.voidElements) {
                        var nextToken = session.getTokenAt(cursor.row, cursor.column + 1);
                        var line = session.getLine(row);
                        var nextIndent = this.$getIndent(line);
                        var indent = nextIndent + session.getTabString();
                        if (nextToken && nextToken.value === "</") return {
                            text: "\n" + indent + "\n" + nextIndent,
                            selection: [
                                1,
                                indent.length,
                                1,
                                indent.length
                            ]
                        };
                        else return {
                            text: "\n" + indent
                        };
                    }
                }
            }
        });
    };
    oop.inherits(XmlBehaviour, Behaviour);
    exports.XmlBehaviour = XmlBehaviour;
});
ace.define("ace/mode/behaviour/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/token_iterator",
    "ace/mode/behaviour/cstyle",
    "ace/mode/behaviour/xml"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var TokenIterator = require("../../token_iterator").TokenIterator;
    var CstyleBehaviour = require("../behaviour/cstyle").CstyleBehaviour;
    var XmlBehaviour = require("../behaviour/xml").XmlBehaviour;
    var JavaScriptBehaviour = function() {
        var xmlBehaviours = new XmlBehaviour({
            closeCurlyBraces: true
        }).getBehaviours();
        this.addBehaviours(xmlBehaviours);
        this.inherit(CstyleBehaviour);
        this.add("autoclosing-fragment", "insertion", function(state, action, editor, session, text) {
            if (text == ">") {
                var position = editor.getSelectionRange().start;
                var iterator = new TokenIterator(session, position.row, position.column);
                var token = iterator.getCurrentToken() || iterator.stepBackward();
                if (!token) return;
                if (token.value == "<") return {
                    text: "></>",
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
    };
    oop.inherits(JavaScriptBehaviour, CstyleBehaviour);
    exports.JavaScriptBehaviour = JavaScriptBehaviour;
});
ace.define("ace/mode/folding/xml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(voidElements, optionalEndTags) {
        BaseFoldMode.call(this);
        this.voidElements = voidElements || {};
        this.optionalEndTags = oop.mixin({}, this.voidElements);
        if (optionalEndTags) oop.mixin(this.optionalEndTags, optionalEndTags);
    };
    oop.inherits(FoldMode, BaseFoldMode);
    var Tag = function() {
        this.tagName = "";
        this.closing = false;
        this.selfClosing = false;
        this.start = {
            row: 0,
            column: 0
        };
        this.end = {
            row: 0,
            column: 0
        };
    };
    function is(token, type) {
        return token.type.lastIndexOf(type + ".xml") > -1;
    }
    (function() {
        this.getFoldWidget = function(session, foldStyle, row) {
            var tag = this._getFirstTagInLine(session, row);
            if (!tag) return this.getCommentFoldWidget(session, row);
            if (tag.closing || !tag.tagName && tag.selfClosing) return foldStyle === "markbeginend" ? "end" : "";
            if (!tag.tagName || tag.selfClosing || this.voidElements.hasOwnProperty(tag.tagName.toLowerCase())) return "";
            if (this._findEndTagInLine(session, row, tag.tagName, tag.end.column)) return "";
            return "start";
        };
        this.getCommentFoldWidget = function(session, row) {
            if (/comment/.test(session.getState(row)) && /<!-/.test(session.getLine(row))) return "start";
            return "";
        };
        this._getFirstTagInLine = function(session, row) {
            var tokens = session.getTokens(row);
            var tag = new Tag();
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                if (is(token, "tag-open")) {
                    tag.end.column = tag.start.column + token.value.length;
                    tag.closing = is(token, "end-tag-open");
                    token = tokens[++i];
                    if (!token) return null;
                    tag.tagName = token.value;
                    if (token.value === "") {
                        token = tokens[++i];
                        if (!token) return null;
                        tag.tagName = token.value;
                    }
                    tag.end.column += token.value.length;
                    for(i++; i < tokens.length; i++){
                        token = tokens[i];
                        tag.end.column += token.value.length;
                        if (is(token, "tag-close")) {
                            tag.selfClosing = token.value == "/>";
                            break;
                        }
                    }
                    return tag;
                } else if (is(token, "tag-close")) {
                    tag.selfClosing = token.value == "/>";
                    return tag;
                }
                tag.start.column += token.value.length;
            }
            return null;
        };
        this._findEndTagInLine = function(session, row, tagName, startColumn) {
            var tokens = session.getTokens(row);
            var column = 0;
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                column += token.value.length;
                if (column < startColumn - 1) continue;
                if (is(token, "end-tag-open")) {
                    token = tokens[i + 1];
                    if (is(token, "tag-name") && token.value === "") token = tokens[i + 2];
                    if (token && token.value == tagName) return true;
                }
            }
            return false;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            var firstTag = this._getFirstTagInLine(session, row);
            if (!firstTag) return this.getCommentFoldWidget(session, row) && session.getCommentFoldRange(row, session.getLine(row).length);
            var tags = session.getMatchingTags({
                row: row,
                column: 0
            });
            if (tags) return new Range(tags.openTag.end.row, tags.openTag.end.column, tags.closeTag.start.row, tags.closeTag.start.column);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/folding/cstyle", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
    };
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
        this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
        this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
        this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
        this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
        this._getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            if (this.singleLineBlockCommentRe.test(line)) {
                if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line)) return "";
            }
            var fw = this._getFoldWidgetBase(session, foldStyle, row);
            if (!fw && this.startRegionRe.test(line)) return "start"; // lineCommentRegionStart
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var line = session.getLine(row);
            if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
            var match = line.match(this.foldingStartMarker);
            if (match) {
                var i = match.index;
                if (match[1]) return this.openingBracketBlock(session, match[1], row, i);
                var range = session.getCommentFoldRange(row, i + match[0].length, 1);
                if (range && !range.isMultiLine()) {
                    if (forceMultiline) range = this.getSectionRange(session, row);
                    else if (foldStyle != "all") range = null;
                }
                return range;
            }
            if (foldStyle === "markbegin") return;
            var match = line.match(this.foldingStopMarker);
            if (match) {
                var i = match.index + match[0].length;
                if (match[1]) return this.closingBracketBlock(session, match[1], row, i);
                return session.getCommentFoldRange(row, i, -1);
            }
        };
        this.getSectionRange = function(session, row) {
            var line = session.getLine(row);
            var startIndent = line.search(/\S/);
            var startRow = row;
            var startColumn = line.length;
            row = row + 1;
            var endRow = row;
            var maxRow = session.getLength();
            while(++row < maxRow){
                line = session.getLine(row);
                var indent = line.search(/\S/);
                if (indent === -1) continue;
                if (startIndent > indent) break;
                var subRange = this.getFoldWidgetRange(session, "all", row);
                if (subRange) {
                    if (subRange.start.row <= startRow) break;
                    else if (subRange.isMultiLine()) row = subRange.end.row;
                    else if (startIndent == indent) break;
                }
                endRow = row;
            }
            return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
        };
        this.getCommentRegionBlock = function(session, line, row) {
            var startColumn = line.search(/\s*$/);
            var maxRow = session.getLength();
            var startRow = row;
            var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
            var depth = 1;
            while(++row < maxRow){
                line = session.getLine(row);
                var m = re.exec(line);
                if (!m) continue;
                if (m[1]) depth--;
                else depth++;
                if (!depth) break;
            }
            var endRow = row;
            if (endRow > startRow) return new Range(startRow, startColumn, endRow, line.length);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/folding/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/folding/xml",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var XmlFoldMode = require("./xml").FoldMode;
    var CFoldMode = require("./cstyle").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
        this.xmlFoldMode = new XmlFoldMode();
    };
    oop.inherits(FoldMode, CFoldMode);
    (function() {
        this.getFoldWidgetRangeBase = this.getFoldWidgetRange;
        this.getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var fw = this.getFoldWidgetBase(session, foldStyle, row);
            if (!fw) return this.xmlFoldMode.getFoldWidget(session, foldStyle, row);
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var range = this.getFoldWidgetRangeBase(session, foldStyle, row, forceMultiline);
            if (range) return range;
            return this.xmlFoldMode.getFoldWidgetRange(session, foldStyle, row);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/javascript_highlight_rules",
    "ace/mode/matching_brace_outdent",
    "ace/worker/worker_client",
    "ace/mode/behaviour/javascript",
    "ace/mode/folding/javascript"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var JavaScriptHighlightRules = require("./javascript_highlight_rules").JavaScriptHighlightRules;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var JavaScriptBehaviour = require("./behaviour/javascript").JavaScriptBehaviour;
    var JavaScriptFoldMode = require("./folding/javascript").FoldMode;
    var Mode = function() {
        this.HighlightRules = JavaScriptHighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.$behaviour = new JavaScriptBehaviour();
        this.foldingRules = new JavaScriptFoldMode();
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.lineCommentStart = "//";
        this.blockComment = {
            start: "/*",
            end: "*/"
        };
        this.$quotes = {
            '"': '"',
            "'": "'",
            "`": "`"
        };
        this.$pairQuotesAfter = {
            "`": /\w/
        };
        this.getNextLineIndent = function(state, line, tab) {
            var indent = this.$getIndent(line);
            var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
            var tokens = tokenizedLine.tokens;
            var endState = tokenizedLine.state;
            if (tokens.length && tokens[tokens.length - 1].type == "comment") return indent;
            if (state == "start" || state == "no_regex") {
                var match = line.match(/^.*(?:\bcase\b.*:|[\{\(\[])\s*$/);
                if (match) indent += tab;
            } else if (state == "doc-start") {
                if (endState == "start" || endState == "no_regex") return "";
            }
            return indent;
        };
        this.checkOutdent = function(state, line, input) {
            return this.$outdent.checkOutdent(line, input);
        };
        this.autoOutdent = function(state, doc, row) {
            this.$outdent.autoOutdent(doc, row);
        };
        this.createWorker = function(session) {
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/javascript_worker", "JavaScriptWorker");
            worker.attachToDocument(session.getDocument());
            worker.on("annotate", function(results) {
                session.setAnnotations(results.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/javascript";
        this.snippetFileId = "ace/snippets/javascript";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
ace.define("ace/mode/typescript_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/javascript_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var JavaScriptHighlightRules = require("./javascript_highlight_rules").JavaScriptHighlightRules;
    var TypeScriptHighlightRules = function(options) {
        var tsRules = [
            {
                token: [
                    "storage.type",
                    "text",
                    "entity.name.function.ts"
                ],
                regex: "(function)(\\s+)([a-zA-Z0-9$_\xa1-\uFFFF][a-zA-Z0-9d$_\xa1-\uFFFF]*)"
            },
            {
                token: "keyword",
                regex: "(?:\\b(constructor|declare|interface|as|AS|public|private|extends|export|super|readonly|module|namespace|abstract|implements)\\b)"
            },
            {
                token: [
                    "keyword",
                    "storage.type.variable.ts"
                ],
                regex: "(class|type)(\\s+[a-zA-Z0-9_?.$][\\w?.$]*)"
            },
            {
                token: "keyword",
                regex: "\\b(?:super|export|import|keyof|infer)\\b"
            },
            {
                token: [
                    "storage.type.variable.ts"
                ],
                regex: "(?:\\b(this\\.|string\\b|bool\\b|boolean\\b|number\\b|true\\b|false\\b|undefined\\b|any\\b|null\\b|(?:unique )?symbol\\b|object\\b|never\\b|enum\\b))"
            }
        ];
        var JSRules = new JavaScriptHighlightRules({
            jsx: (options && options.jsx) == true
        }).getRules();
        JSRules.no_regex = tsRules.concat(JSRules.no_regex);
        this.$rules = JSRules;
    };
    oop.inherits(TypeScriptHighlightRules, JavaScriptHighlightRules);
    exports.TypeScriptHighlightRules = TypeScriptHighlightRules;
});
ace.define("ace/mode/typescript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/javascript",
    "ace/mode/typescript_highlight_rules",
    "ace/mode/folding/cstyle",
    "ace/mode/matching_brace_outdent"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var jsMode = require("./javascript").Mode;
    var TypeScriptHighlightRules = require("./typescript_highlight_rules").TypeScriptHighlightRules;
    var CStyleFoldMode = require("./folding/cstyle").FoldMode;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var Mode = function() {
        this.HighlightRules = TypeScriptHighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.$behaviour = this.$defaultBehaviour;
        this.foldingRules = new CStyleFoldMode();
    };
    oop.inherits(Mode, jsMode);
    (function() {
        this.createWorker = function(session) {
            return null;
        };
        this.$id = "ace/mode/typescript";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/typescript"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("3dtcL", function(module, exports) {
ace.define("ace/mode/xml_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var XmlHighlightRules = function(normalize) {
        var tagRegex = "[_:a-zA-Z\xc0-\uFFFF][-_:.a-zA-Z0-9\xc0-\uFFFF]*";
        this.$rules = {
            start: [
                {
                    token: "string.cdata.xml",
                    regex: "<\\!\\[CDATA\\[",
                    next: "cdata"
                },
                {
                    token: [
                        "punctuation.instruction.xml",
                        "keyword.instruction.xml"
                    ],
                    regex: "(<\\?)(" + tagRegex + ")",
                    next: "processing_instruction"
                },
                {
                    token: "comment.start.xml",
                    regex: "<\\!--",
                    next: "comment"
                },
                {
                    token: [
                        "xml-pe.doctype.xml",
                        "xml-pe.doctype.xml"
                    ],
                    regex: "(<\\!)(DOCTYPE)(?=[\\s])",
                    next: "doctype",
                    caseInsensitive: true
                },
                {
                    include: "tag"
                },
                {
                    token: "text.end-tag-open.xml",
                    regex: "</"
                },
                {
                    token: "text.tag-open.xml",
                    regex: "<"
                },
                {
                    include: "reference"
                },
                {
                    defaultToken: "text.xml"
                }
            ],
            processing_instruction: [
                {
                    token: "entity.other.attribute-name.decl-attribute-name.xml",
                    regex: tagRegex
                },
                {
                    token: "keyword.operator.decl-attribute-equals.xml",
                    regex: "="
                },
                {
                    include: "whitespace"
                },
                {
                    include: "string"
                },
                {
                    token: "punctuation.xml-decl.xml",
                    regex: "\\?>",
                    next: "start"
                }
            ],
            doctype: [
                {
                    include: "whitespace"
                },
                {
                    include: "string"
                },
                {
                    token: "xml-pe.doctype.xml",
                    regex: ">",
                    next: "start"
                },
                {
                    token: "xml-pe.xml",
                    regex: "[-_a-zA-Z0-9:]+"
                },
                {
                    token: "punctuation.int-subset",
                    regex: "\\[",
                    push: "int_subset"
                }
            ],
            int_subset: [
                {
                    token: "text.xml",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.int-subset.xml",
                    regex: "]",
                    next: "pop"
                },
                {
                    token: [
                        "punctuation.markup-decl.xml",
                        "keyword.markup-decl.xml"
                    ],
                    regex: "(<\\!)(" + tagRegex + ")",
                    push: [
                        {
                            token: "text",
                            regex: "\\s+"
                        },
                        {
                            token: "punctuation.markup-decl.xml",
                            regex: ">",
                            next: "pop"
                        },
                        {
                            include: "string"
                        }
                    ]
                }
            ],
            cdata: [
                {
                    token: "string.cdata.xml",
                    regex: "\\]\\]>",
                    next: "start"
                },
                {
                    token: "text.xml",
                    regex: "\\s+"
                },
                {
                    token: "text.xml",
                    regex: "(?:[^\\]]|\\](?!\\]>))+"
                }
            ],
            comment: [
                {
                    token: "comment.end.xml",
                    regex: "-->",
                    next: "start"
                },
                {
                    defaultToken: "comment.xml"
                }
            ],
            reference: [
                {
                    token: "constant.language.escape.reference.xml",
                    regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
                }
            ],
            attr_reference: [
                {
                    token: "constant.language.escape.reference.attribute-value.xml",
                    regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
                }
            ],
            tag: [
                {
                    token: [
                        "meta.tag.punctuation.tag-open.xml",
                        "meta.tag.punctuation.end-tag-open.xml",
                        "meta.tag.tag-name.xml"
                    ],
                    regex: "(?:(<)|(</))((?:" + tagRegex + ":)?" + tagRegex + ")",
                    next: [
                        {
                            include: "attributes"
                        },
                        {
                            token: "meta.tag.punctuation.tag-close.xml",
                            regex: "/?>",
                            next: "start"
                        }
                    ]
                }
            ],
            tag_whitespace: [
                {
                    token: "text.tag-whitespace.xml",
                    regex: "\\s+"
                }
            ],
            whitespace: [
                {
                    token: "text.whitespace.xml",
                    regex: "\\s+"
                }
            ],
            string: [
                {
                    token: "string.xml",
                    regex: "'",
                    push: [
                        {
                            token: "string.xml",
                            regex: "'",
                            next: "pop"
                        },
                        {
                            defaultToken: "string.xml"
                        }
                    ]
                },
                {
                    token: "string.xml",
                    regex: '"',
                    push: [
                        {
                            token: "string.xml",
                            regex: '"',
                            next: "pop"
                        },
                        {
                            defaultToken: "string.xml"
                        }
                    ]
                }
            ],
            attributes: [
                {
                    token: "entity.other.attribute-name.xml",
                    regex: tagRegex
                },
                {
                    token: "keyword.operator.attribute-equals.xml",
                    regex: "="
                },
                {
                    include: "tag_whitespace"
                },
                {
                    include: "attribute_value"
                }
            ],
            attribute_value: [
                {
                    token: "string.attribute-value.xml",
                    regex: "'",
                    push: [
                        {
                            token: "string.attribute-value.xml",
                            regex: "'",
                            next: "pop"
                        },
                        {
                            include: "attr_reference"
                        },
                        {
                            defaultToken: "string.attribute-value.xml"
                        }
                    ]
                },
                {
                    token: "string.attribute-value.xml",
                    regex: '"',
                    push: [
                        {
                            token: "string.attribute-value.xml",
                            regex: '"',
                            next: "pop"
                        },
                        {
                            include: "attr_reference"
                        },
                        {
                            defaultToken: "string.attribute-value.xml"
                        }
                    ]
                }
            ]
        };
        if (this.constructor === XmlHighlightRules) this.normalizeRules();
    };
    (function() {
        this.embedTagRules = function(HighlightRules, prefix, tag) {
            this.$rules.tag.unshift({
                token: [
                    "meta.tag.punctuation.tag-open.xml",
                    "meta.tag." + tag + ".tag-name.xml"
                ],
                regex: "(<)(" + tag + "(?=\\s|>|$))",
                next: [
                    {
                        include: "attributes"
                    },
                    {
                        token: "meta.tag.punctuation.tag-close.xml",
                        regex: "/?>",
                        next: prefix + "start"
                    }
                ]
            });
            this.$rules[tag + "-end"] = [
                {
                    include: "attributes"
                },
                {
                    token: "meta.tag.punctuation.tag-close.xml",
                    regex: "/?>",
                    next: "start",
                    onMatch: function(value, currentState, stack) {
                        stack.splice(0);
                        return this.token;
                    }
                }
            ];
            this.embedRules(HighlightRules, prefix, [
                {
                    token: [
                        "meta.tag.punctuation.end-tag-open.xml",
                        "meta.tag." + tag + ".tag-name.xml"
                    ],
                    regex: "(</)(" + tag + "(?=\\s|>|$))",
                    next: tag + "-end"
                },
                {
                    token: "string.cdata.xml",
                    regex: "<\\!\\[CDATA\\["
                },
                {
                    token: "string.cdata.xml",
                    regex: "\\]\\]>"
                }
            ]);
        };
    }).call(TextHighlightRules.prototype);
    oop.inherits(XmlHighlightRules, TextHighlightRules);
    exports.XmlHighlightRules = XmlHighlightRules;
});
ace.define("ace/mode/behaviour/xml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/behaviour",
    "ace/token_iterator"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Behaviour = require("../behaviour").Behaviour;
    var TokenIterator = require("../../token_iterator").TokenIterator;
    function is(token, type) {
        return token && token.type.lastIndexOf(type + ".xml") > -1;
    }
    var XmlBehaviour = function() {
        this.add("string_dquotes", "insertion", function(state, action, editor, session, text) {
            if (text == '"' || text == "'") {
                var quote = text;
                var selected = session.doc.getTextRange(editor.getSelectionRange());
                if (selected !== "" && selected !== "'" && selected != '"' && editor.getWrapBehavioursEnabled()) return {
                    text: quote + selected + quote,
                    selection: false
                };
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (rightChar == quote && (is(token, "attribute-value") || is(token, "string"))) return {
                    text: "",
                    selection: [
                        1,
                        1
                    ]
                };
                if (!token) token = iterator.stepBackward();
                if (!token) return;
                while(is(token, "tag-whitespace") || is(token, "whitespace"))token = iterator.stepBackward();
                var rightSpace = !rightChar || rightChar.match(/\s/);
                if (is(token, "attribute-equals") && (rightSpace || rightChar == ">") || is(token, "decl-attribute-equals") && (rightSpace || rightChar == "?")) return {
                    text: quote + quote,
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("string_dquotes", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && (selected == '"' || selected == "'")) {
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
                if (rightChar == selected) {
                    range.end.column++;
                    return range;
                }
            }
        });
        this.add("autoclosing", "insertion", function(state, action, editor, session, text) {
            if (text == ">") {
                var position = editor.getSelectionRange().start;
                var iterator = new TokenIterator(session, position.row, position.column);
                var token = iterator.getCurrentToken() || iterator.stepBackward();
                if (!token || !(is(token, "tag-name") || is(token, "tag-whitespace") || is(token, "attribute-name") || is(token, "attribute-equals") || is(token, "attribute-value"))) return;
                if (is(token, "reference.attribute-value")) return;
                if (is(token, "attribute-value")) {
                    var tokenEndColumn = iterator.getCurrentTokenColumn() + token.value.length;
                    if (position.column < tokenEndColumn) return;
                    if (position.column == tokenEndColumn) {
                        var nextToken = iterator.stepForward();
                        if (nextToken && is(nextToken, "attribute-value")) return;
                        iterator.stepBackward();
                    }
                }
                if (/^\s*>/.test(session.getLine(position.row).slice(position.column))) return;
                while(!is(token, "tag-name")){
                    token = iterator.stepBackward();
                    if (token.value == "<") {
                        token = iterator.stepForward();
                        break;
                    }
                }
                var tokenRow = iterator.getCurrentTokenRow();
                var tokenColumn = iterator.getCurrentTokenColumn();
                if (is(iterator.stepBackward(), "end-tag-open")) return;
                var element = token.value;
                if (tokenRow == position.row) element = element.substring(0, position.column - tokenColumn);
                if (this.voidElements && this.voidElements.hasOwnProperty(element.toLowerCase())) return;
                return {
                    text: "></" + element + ">",
                    selection: [
                        1,
                        1
                    ]
                };
            }
        });
        this.add("autoindent", "insertion", function(state, action, editor, session, text) {
            if (text == "\n") {
                var cursor = editor.getCursorPosition();
                var line = session.getLine(cursor.row);
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                if (is(token, "") && token.type.indexOf("tag-close") !== -1) {
                    if (token.value == "/>") return;
                    while(token && token.type.indexOf("tag-name") === -1)token = iterator.stepBackward();
                    if (!token) return;
                    var tag = token.value;
                    var row = iterator.getCurrentTokenRow();
                    token = iterator.stepBackward();
                    if (!token || token.type.indexOf("end-tag") !== -1) return;
                    if (this.voidElements && !this.voidElements[tag] || !this.voidElements) {
                        var nextToken = session.getTokenAt(cursor.row, cursor.column + 1);
                        var line = session.getLine(row);
                        var nextIndent = this.$getIndent(line);
                        var indent = nextIndent + session.getTabString();
                        if (nextToken && nextToken.value === "</") return {
                            text: "\n" + indent + "\n" + nextIndent,
                            selection: [
                                1,
                                indent.length,
                                1,
                                indent.length
                            ]
                        };
                        else return {
                            text: "\n" + indent
                        };
                    }
                }
            }
        });
    };
    oop.inherits(XmlBehaviour, Behaviour);
    exports.XmlBehaviour = XmlBehaviour;
});
ace.define("ace/mode/folding/xml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(voidElements, optionalEndTags) {
        BaseFoldMode.call(this);
        this.voidElements = voidElements || {};
        this.optionalEndTags = oop.mixin({}, this.voidElements);
        if (optionalEndTags) oop.mixin(this.optionalEndTags, optionalEndTags);
    };
    oop.inherits(FoldMode, BaseFoldMode);
    var Tag = function() {
        this.tagName = "";
        this.closing = false;
        this.selfClosing = false;
        this.start = {
            row: 0,
            column: 0
        };
        this.end = {
            row: 0,
            column: 0
        };
    };
    function is(token, type) {
        return token.type.lastIndexOf(type + ".xml") > -1;
    }
    (function() {
        this.getFoldWidget = function(session, foldStyle, row) {
            var tag = this._getFirstTagInLine(session, row);
            if (!tag) return this.getCommentFoldWidget(session, row);
            if (tag.closing || !tag.tagName && tag.selfClosing) return foldStyle === "markbeginend" ? "end" : "";
            if (!tag.tagName || tag.selfClosing || this.voidElements.hasOwnProperty(tag.tagName.toLowerCase())) return "";
            if (this._findEndTagInLine(session, row, tag.tagName, tag.end.column)) return "";
            return "start";
        };
        this.getCommentFoldWidget = function(session, row) {
            if (/comment/.test(session.getState(row)) && /<!-/.test(session.getLine(row))) return "start";
            return "";
        };
        this._getFirstTagInLine = function(session, row) {
            var tokens = session.getTokens(row);
            var tag = new Tag();
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                if (is(token, "tag-open")) {
                    tag.end.column = tag.start.column + token.value.length;
                    tag.closing = is(token, "end-tag-open");
                    token = tokens[++i];
                    if (!token) return null;
                    tag.tagName = token.value;
                    if (token.value === "") {
                        token = tokens[++i];
                        if (!token) return null;
                        tag.tagName = token.value;
                    }
                    tag.end.column += token.value.length;
                    for(i++; i < tokens.length; i++){
                        token = tokens[i];
                        tag.end.column += token.value.length;
                        if (is(token, "tag-close")) {
                            tag.selfClosing = token.value == "/>";
                            break;
                        }
                    }
                    return tag;
                } else if (is(token, "tag-close")) {
                    tag.selfClosing = token.value == "/>";
                    return tag;
                }
                tag.start.column += token.value.length;
            }
            return null;
        };
        this._findEndTagInLine = function(session, row, tagName, startColumn) {
            var tokens = session.getTokens(row);
            var column = 0;
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                column += token.value.length;
                if (column < startColumn - 1) continue;
                if (is(token, "end-tag-open")) {
                    token = tokens[i + 1];
                    if (is(token, "tag-name") && token.value === "") token = tokens[i + 2];
                    if (token && token.value == tagName) return true;
                }
            }
            return false;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            var firstTag = this._getFirstTagInLine(session, row);
            if (!firstTag) return this.getCommentFoldWidget(session, row) && session.getCommentFoldRange(row, session.getLine(row).length);
            var tags = session.getMatchingTags({
                row: row,
                column: 0
            });
            if (tags) return new Range(tags.openTag.end.row, tags.openTag.end.column, tags.closeTag.start.row, tags.closeTag.start.column);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/xml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/mode/text",
    "ace/mode/xml_highlight_rules",
    "ace/mode/behaviour/xml",
    "ace/mode/folding/xml",
    "ace/worker/worker_client"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var lang = require("../lib/lang");
    var TextMode = require("./text").Mode;
    var XmlHighlightRules = require("./xml_highlight_rules").XmlHighlightRules;
    var XmlBehaviour = require("./behaviour/xml").XmlBehaviour;
    var XmlFoldMode = require("./folding/xml").FoldMode;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var Mode = function() {
        this.HighlightRules = XmlHighlightRules;
        this.$behaviour = new XmlBehaviour();
        this.foldingRules = new XmlFoldMode();
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.voidElements = lang.arrayToMap([]);
        this.blockComment = {
            start: "<!--",
            end: "-->"
        };
        this.createWorker = function(session) {
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/xml_worker", "Worker");
            worker.attachToDocument(session.getDocument());
            worker.on("error", function(e) {
                session.setAnnotations(e.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/xml";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/xml"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("owfCx", function(module, exports) {
ace.define("ace/mode/yaml_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var YamlHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: "comment",
                    regex: "#.*$"
                },
                {
                    token: "list.markup",
                    regex: /^(?:-{3}|\.{3})\s*(?=#|$)/
                },
                {
                    token: "list.markup",
                    regex: /^\s*[\-?](?:$|\s)/
                },
                {
                    token: "constant",
                    regex: "!![\\w//]+"
                },
                {
                    token: "constant.language",
                    regex: "[&\\*][a-zA-Z0-9-_]+"
                },
                {
                    token: [
                        "meta.tag",
                        "keyword"
                    ],
                    regex: /^(\s*\w[^\s:]*?)(:(?=\s|$))/
                },
                {
                    token: [
                        "meta.tag",
                        "keyword"
                    ],
                    regex: /(\w[^\s:]*?)(\s*:(?=\s|$))/
                },
                {
                    token: "keyword.operator",
                    regex: "<<\\w*:\\w*"
                },
                {
                    token: "keyword.operator",
                    regex: "-\\s*(?=[{])"
                },
                {
                    token: "string",
                    regex: '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]'
                },
                {
                    token: "string",
                    regex: /[|>][-+\d]*(?:$|\s+(?:$|#))/,
                    onMatch: function(val, state, stack, line) {
                        line = line.replace(/ #.*/, "");
                        var indent = /^ *((:\s*)?-(\s*[^|>])?)?/.exec(line)[0].replace(/\S\s*$/, "").length;
                        var indentationIndicator = parseInt(/\d+[\s+-]*$/.exec(line));
                        if (indentationIndicator) {
                            indent += indentationIndicator - 1;
                            this.next = "mlString";
                        } else this.next = "mlStringPre";
                        if (!stack.length) {
                            stack.push(this.next);
                            stack.push(indent);
                        } else {
                            stack[0] = this.next;
                            stack[1] = indent;
                        }
                        return this.token;
                    },
                    next: "mlString"
                },
                {
                    token: "string",
                    regex: "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
                },
                {
                    token: "constant.numeric",
                    regex: /(\b|[+\-\.])[\d_]+(?:(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)(?=[^\d-\w]|$)$/
                },
                {
                    token: "constant.numeric",
                    regex: /[+\-]?\.inf\b|NaN\b|0x[\dA-Fa-f_]+|0b[10_]+/
                },
                {
                    token: "constant.language.boolean",
                    regex: "\\b(?:true|false|TRUE|FALSE|True|False|yes|no)\\b"
                },
                {
                    token: "paren.lparen",
                    regex: "[[({]"
                },
                {
                    token: "paren.rparen",
                    regex: "[\\])}]"
                },
                {
                    token: "text",
                    regex: /[^\s,:\[\]\{\}]+/
                }
            ],
            "mlStringPre": [
                {
                    token: "indent",
                    regex: /^ *$/
                },
                {
                    token: "indent",
                    regex: /^ */,
                    onMatch: function(val, state, stack) {
                        var curIndent = stack[1];
                        if (curIndent >= val.length) {
                            this.next = "start";
                            stack.shift();
                            stack.shift();
                        } else {
                            stack[1] = val.length - 1;
                            this.next = stack[0] = "mlString";
                        }
                        return this.token;
                    },
                    next: "mlString"
                },
                {
                    defaultToken: "string"
                }
            ],
            "mlString": [
                {
                    token: "indent",
                    regex: /^ *$/
                },
                {
                    token: "indent",
                    regex: /^ */,
                    onMatch: function(val, state, stack) {
                        var curIndent = stack[1];
                        if (curIndent >= val.length) {
                            this.next = "start";
                            stack.splice(0);
                        } else this.next = "mlString";
                        return this.token;
                    },
                    next: "mlString"
                },
                {
                    token: "string",
                    regex: ".+"
                }
            ]
        };
        this.normalizeRules();
    };
    oop.inherits(YamlHighlightRules, TextHighlightRules);
    exports.YamlHighlightRules = YamlHighlightRules;
});
ace.define("ace/mode/matching_brace_outdent", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var MatchingBraceOutdent = function() {};
    (function() {
        this.checkOutdent = function(line, input) {
            if (!/^\s+$/.test(line)) return false;
            return /^\s*\}/.test(input);
        };
        this.autoOutdent = function(doc, row) {
            var line = doc.getLine(row);
            var match = line.match(/^(\s*\})/);
            if (!match) return 0;
            var column = match[1].length;
            var openBracePos = doc.findMatchingBracket({
                row: row,
                column: column
            });
            if (!openBracePos || openBracePos.row == row) return 0;
            var indent = this.$getIndent(doc.getLine(openBracePos.row));
            doc.replace(new Range(row, 0, row, column - 1), indent);
        };
        this.$getIndent = function(line) {
            return line.match(/^\s*/)[0];
        };
    }).call(MatchingBraceOutdent.prototype);
    exports.MatchingBraceOutdent = MatchingBraceOutdent;
});
ace.define("ace/mode/folding/coffee", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/folding/fold_mode",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var Range = require("../../range").Range;
    var FoldMode = exports.FoldMode = function() {};
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.commentBlock = function(session, row) {
            var re = /\S/;
            var line = session.getLine(row);
            var startLevel = line.search(re);
            if (startLevel == -1 || line[startLevel] != "#") return;
            var startColumn = line.length;
            var maxRow = session.getLength();
            var startRow = row;
            var endRow = row;
            while(++row < maxRow){
                line = session.getLine(row);
                var level = line.search(re);
                if (level == -1) continue;
                if (line[level] != "#") break;
                endRow = row;
            }
            if (endRow > startRow) {
                var endColumn = session.getLine(endRow).length;
                return new Range(startRow, startColumn, endRow, endColumn);
            }
        };
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            var range = this.indentationBlock(session, row);
            if (range) return range;
            range = this.commentBlock(session, row);
            if (range) return range;
        };
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            var indent = line.search(/\S/);
            var next = session.getLine(row + 1);
            var prev = session.getLine(row - 1);
            var prevIndent = prev.search(/\S/);
            var nextIndent = next.search(/\S/);
            if (indent == -1) {
                session.foldWidgets[row - 1] = prevIndent != -1 && prevIndent < nextIndent ? "start" : "";
                return "";
            }
            if (prevIndent == -1) {
                if (indent == nextIndent && line[indent] == "#" && next[indent] == "#") {
                    session.foldWidgets[row - 1] = "";
                    session.foldWidgets[row + 1] = "";
                    return "start";
                }
            } else if (prevIndent == indent && line[indent] == "#" && prev[indent] == "#") {
                if (session.getLine(row - 2).search(/\S/) == -1) {
                    session.foldWidgets[row - 1] = "start";
                    session.foldWidgets[row + 1] = "";
                    return "";
                }
            }
            if (prevIndent != -1 && prevIndent < indent) session.foldWidgets[row - 1] = "start";
            else session.foldWidgets[row - 1] = "";
            if (indent < nextIndent) return "start";
            else return "";
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/folding/yaml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/folding/coffee",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var CoffeeFoldMode = require("./coffee").FoldMode;
    var Range = require("../../range").Range;
    var FoldMode = exports.FoldMode = function() {};
    oop.inherits(FoldMode, CoffeeFoldMode);
    (function() {
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            var re = /\S/;
            var line = session.getLine(row);
            var startLevel = line.search(re);
            var isCommentFold = line[startLevel] === "#";
            var isDashFold = line[startLevel] === "-";
            if (startLevel == -1) return;
            var startColumn = line.length;
            var maxRow = session.getLength();
            var startRow = row;
            var endRow = row;
            if (isCommentFold) {
                var range = this.commentBlock(session, row);
                if (range) return range;
            } else if (isDashFold) {
                var range = this.indentationBlock(session, row);
                if (range) return range;
            } else while(++row < maxRow){
                var line = session.getLine(row);
                var level = line.search(re);
                if (level == -1) continue;
                if (level <= startLevel && line[startLevel] !== "-") {
                    var token = session.getTokenAt(row, 0);
                    if (!token || token.type !== "string") break;
                }
                endRow = row;
            }
            if (endRow > startRow) {
                var endColumn = session.getLine(endRow).length;
                return new Range(startRow, startColumn, endRow, endColumn);
            }
        };
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            var indent = line.search(/\S/);
            var next = session.getLine(row + 1);
            var prev = session.getLine(row - 1);
            var prevIndent = prev.search(/\S/);
            var nextIndent = next.search(/\S/);
            var lineStartsWithDash = line[indent] === "-";
            if (indent == -1) {
                session.foldWidgets[row - 1] = prevIndent != -1 && prevIndent < nextIndent ? "start" : "";
                return "";
            }
            if (prevIndent == -1) {
                if (indent == nextIndent && line[indent] == "#" && next[indent] == "#") {
                    session.foldWidgets[row - 1] = "";
                    session.foldWidgets[row + 1] = "";
                    return "start";
                }
            } else if (prevIndent == indent && line[indent] == "#" && prev[indent] == "#") {
                if (session.getLine(row - 2).search(/\S/) == -1) {
                    session.foldWidgets[row - 1] = "start";
                    session.foldWidgets[row + 1] = "";
                    return "";
                }
            }
            if (prevIndent != -1 && prevIndent < indent) session.foldWidgets[row - 1] = "start";
            else if (prevIndent != -1 && prevIndent == indent && lineStartsWithDash) session.foldWidgets[row - 1] = "start";
            else session.foldWidgets[row - 1] = "";
            if (indent < nextIndent) return "start";
            else return "";
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/yaml", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/yaml_highlight_rules",
    "ace/mode/matching_brace_outdent",
    "ace/mode/folding/yaml",
    "ace/worker/worker_client"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var YamlHighlightRules = require("./yaml_highlight_rules").YamlHighlightRules;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var FoldMode = require("./folding/yaml").FoldMode;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var Mode = function() {
        this.HighlightRules = YamlHighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.foldingRules = new FoldMode();
        this.$behaviour = this.$defaultBehaviour;
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.lineCommentStart = [
            "#"
        ];
        this.getNextLineIndent = function(state, line, tab) {
            var indent = this.$getIndent(line);
            if (state == "start") {
                var match = line.match(/^.*[\{\(\[]\s*$/);
                if (match) indent += tab;
            }
            return indent;
        };
        this.checkOutdent = function(state, line, input) {
            return this.$outdent.checkOutdent(line, input);
        };
        this.autoOutdent = function(state, doc, row) {
            this.$outdent.autoOutdent(doc, row);
        };
        this.createWorker = function(session) {
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/yaml_worker", "YamlWorker");
            worker.attachToDocument(session.getDocument());
            worker.on("annotate", function(results) {
                session.setAnnotations(results.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/yaml";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/yaml"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("3DC1Q", function(module, exports) {

/* @license C3.js v0.7.20 | (c) C3 Team and other contributors | http://c3js.org/ */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function ChartInternal(api) {
        var $$ = this;
        // Note: This part will be replaced by rollup-plugin-modify
        // When bundling esm output. Beware of changing this line.
        // TODO: Maybe we should check that the modification by rollup-plugin-modify
        // is valid during unit tests.
        $$.d3 = window.d3 ? window.d3 : (parcelRequire("8O8mS"));
        $$.api = api;
        $$.config = $$.getDefaultConfig();
        $$.data = {};
        $$.cache = {};
        $$.axes = {};
    }
    /**
   * The Chart class
   *
   * The methods of this class is the public APIs of the chart object.
   */ function Chart(config) {
        this.internal = new ChartInternal(this);
        this.internal.loadConfig(config);
        this.internal.beforeInit(config);
        this.internal.init();
        this.internal.afterInit(config);
        (function bindThis(fn, target, argThis) {
            Object.keys(fn).forEach(function(key) {
                target[key] = fn[key].bind(argThis);
                if (Object.keys(fn[key]).length > 0) bindThis(fn[key], target[key], argThis);
            });
        })(Chart.prototype, this, this);
    }
    var asHalfPixel = function(n) {
        return Math.ceil(n) + 0.5;
    };
    var ceil10 = function(v) {
        return Math.ceil(v / 10) * 10;
    };
    var diffDomain = function(d) {
        return d[1] - d[0];
    };
    var getOption = function(options, key, defaultValue) {
        return isDefined(options[key]) ? options[key] : defaultValue;
    };
    var getPathBox = function(path) {
        var box = getBBox(path), items = [
            path.pathSegList.getItem(0),
            path.pathSegList.getItem(1)
        ], minX = items[0].x, minY = Math.min(items[0].y, items[1].y);
        return {
            x: minX,
            y: minY,
            width: box.width,
            height: box.height
        };
    };
    var getBBox = function(element) {
        try {
            return element.getBBox();
        } catch (ignore) {
            // Firefox will throw an exception if getBBox() is called whereas the
            // element is rendered with display:none
            // See https://github.com/c3js/c3/issues/2692
            // The previous code was using `getBoundingClientRect` which was returning
            // everything at 0 in this case so let's reproduce this behavior here.
            return {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            };
        }
    };
    var hasValue = function(dict, value) {
        var found = false;
        Object.keys(dict).forEach(function(key) {
            if (dict[key] === value) found = true;
        });
        return found;
    };
    var isArray = function(o) {
        return Array.isArray(o);
    };
    var isDefined = function(v) {
        return typeof v !== "undefined";
    };
    var isEmpty = function(o) {
        return typeof o === "undefined" || o === null || isString(o) && o.length === 0 || typeof o === "object" && Object.keys(o).length === 0;
    };
    var isFunction = function(o) {
        return typeof o === "function";
    };
    var isNumber = function(o) {
        return typeof o === "number";
    };
    var isString = function(o) {
        return typeof o === "string";
    };
    var isUndefined = function(v) {
        return typeof v === "undefined";
    };
    var isValue = function(v) {
        return v || v === 0;
    };
    var notEmpty = function(o) {
        return !isEmpty(o);
    };
    var sanitise = function(str) {
        return typeof str === "string" ? str.replace(/</g, "&lt;").replace(/>/g, "&gt;") : str;
    };
    var flattenArray = function(arr) {
        return Array.isArray(arr) ? [].concat.apply([], arr) : [];
    };
    /**
   * Returns whether the point is within the given box.
   *
   * @param {Array} point An [x,y] coordinate
   * @param {Object} box An object with {x, y, width, height} keys
   * @param {Number} sensitivity An offset to ease check on very small boxes
   */ var isWithinBox = function(point, box, sensitivity) {
        if (sensitivity === void 0) sensitivity = 0;
        var xStart = box.x - sensitivity;
        var xEnd = box.x + box.width + sensitivity;
        var yStart = box.y + box.height + sensitivity;
        var yEnd = box.y - sensitivity;
        return xStart < point[0] && point[0] < xEnd && yEnd < point[1] && point[1] < yStart;
    };
    /**
   * Returns Internet Explorer version number (or false if no Internet Explorer used).
   *
   * @param string agent Optional parameter to specify user agent
   */ var getIEVersion = function(agent) {
        // https://stackoverflow.com/questions/19999388/check-if-user-is-using-ie
        if (typeof agent === "undefined") agent = window.navigator.userAgent;
        var pos = agent.indexOf("MSIE "); // up to IE10
        if (pos > 0) return parseInt(agent.substring(pos + 5, agent.indexOf(".", pos)), 10);
        pos = agent.indexOf("Trident/"); // IE11
        if (pos > 0) {
            pos = agent.indexOf("rv:");
            return parseInt(agent.substring(pos + 3, agent.indexOf(".", pos)), 10);
        }
        return false;
    };
    /**
   * Returns whether the used browser is Internet Explorer.
   *
   * @param version Optional parameter to specify IE version
   */ var isIE = function(version) {
        var ver = getIEVersion();
        if (typeof version === "undefined") return !!ver;
        return version === ver;
    };
    function AxisInternal(component, params) {
        var internal = this;
        internal.component = component;
        internal.params = params || {};
        internal.d3 = component.d3;
        internal.scale = internal.d3.scaleLinear();
        internal.range;
        internal.orient = "bottom";
        internal.innerTickSize = 6;
        internal.outerTickSize = this.params.withOuterTick ? 6 : 0;
        internal.tickPadding = 3;
        internal.tickValues = null;
        internal.tickFormat;
        internal.tickArguments;
        internal.tickOffset = 0;
        internal.tickCulling = true;
        internal.tickCentered;
        internal.tickTextCharSize;
        internal.tickTextRotate = internal.params.tickTextRotate;
        internal.tickLength;
        internal.axis = internal.generateAxis();
    }
    AxisInternal.prototype.axisX = function(selection, x, tickOffset) {
        selection.attr("transform", function(d) {
            return "translate(" + Math.ceil(x(d) + tickOffset) + ", 0)";
        });
    };
    AxisInternal.prototype.axisY = function(selection, y) {
        selection.attr("transform", function(d) {
            return "translate(0," + Math.ceil(y(d)) + ")";
        });
    };
    AxisInternal.prototype.scaleExtent = function(domain) {
        var start = domain[0], stop = domain[domain.length - 1];
        return start < stop ? [
            start,
            stop
        ] : [
            stop,
            start
        ];
    };
    AxisInternal.prototype.generateTicks = function(scale) {
        var internal = this;
        var i, domain, ticks = [];
        if (scale.ticks) return scale.ticks.apply(scale, internal.tickArguments);
        domain = scale.domain();
        for(i = Math.ceil(domain[0]); i < domain[1]; i++)ticks.push(i);
        if (ticks.length > 0 && ticks[0] > 0) ticks.unshift(ticks[0] - (ticks[1] - ticks[0]));
        return ticks;
    };
    AxisInternal.prototype.copyScale = function() {
        var internal = this;
        var newScale = internal.scale.copy(), domain;
        if (internal.params.isCategory) {
            domain = internal.scale.domain();
            newScale.domain([
                domain[0],
                domain[1] - 1
            ]);
        }
        return newScale;
    };
    AxisInternal.prototype.textFormatted = function(v) {
        var internal = this, formatted = internal.tickFormat ? internal.tickFormat(v) : v;
        return typeof formatted !== "undefined" ? formatted : "";
    };
    AxisInternal.prototype.updateRange = function() {
        var internal = this;
        internal.range = internal.scale.rangeExtent ? internal.scale.rangeExtent() : internal.scaleExtent(internal.scale.range());
        return internal.range;
    };
    AxisInternal.prototype.updateTickTextCharSize = function(tick) {
        var internal = this;
        if (internal.tickTextCharSize) return internal.tickTextCharSize;
        var size = {
            h: 11.5,
            w: 5.5
        };
        tick.select("text").text(function(d) {
            return internal.textFormatted(d);
        }).each(function(d) {
            var box = getBBox(this), text = internal.textFormatted(d), h = box.height, w = text ? box.width / text.length : undefined;
            if (h && w) {
                size.h = h;
                size.w = w;
            }
        }).text("");
        internal.tickTextCharSize = size;
        return size;
    };
    AxisInternal.prototype.isVertical = function() {
        return this.orient === "left" || this.orient === "right";
    };
    AxisInternal.prototype.tspanData = function(d, i, scale) {
        var internal = this;
        var splitted = internal.params.tickMultiline ? internal.splitTickText(d, scale) : [].concat(internal.textFormatted(d));
        if (internal.params.tickMultiline && internal.params.tickMultilineMax > 0) splitted = internal.ellipsify(splitted, internal.params.tickMultilineMax);
        return splitted.map(function(s) {
            return {
                index: i,
                splitted: s,
                length: splitted.length
            };
        });
    };
    AxisInternal.prototype.splitTickText = function(d, scale) {
        var internal = this, tickText = internal.textFormatted(d), maxWidth = internal.params.tickWidth, subtext, spaceIndex, textWidth, splitted = [];
        if (Object.prototype.toString.call(tickText) === "[object Array]") return tickText;
        if (!maxWidth || maxWidth <= 0) maxWidth = internal.isVertical() ? 95 : internal.params.isCategory ? Math.ceil(scale(1) - scale(0)) - 12 : 110;
        function split(splitted, text) {
            spaceIndex = undefined;
            for(var i = 1; i < text.length; i++){
                if (text.charAt(i) === " ") spaceIndex = i;
                subtext = text.substr(0, i + 1);
                textWidth = internal.tickTextCharSize.w * subtext.length;
                // if text width gets over tick width, split by space index or crrent index
                if (maxWidth < textWidth) return split(splitted.concat(text.substr(0, spaceIndex ? spaceIndex : i)), text.slice(spaceIndex ? spaceIndex + 1 : i));
            }
            return splitted.concat(text);
        }
        return split(splitted, tickText + "");
    };
    AxisInternal.prototype.ellipsify = function(splitted, max) {
        if (splitted.length <= max) return splitted;
        var ellipsified = splitted.slice(0, max);
        var remaining = 3;
        for(var i = max - 1; i >= 0; i--){
            var available = ellipsified[i].length;
            ellipsified[i] = ellipsified[i].substr(0, available - remaining).padEnd(available, ".");
            remaining -= available;
            if (remaining <= 0) break;
        }
        return ellipsified;
    };
    AxisInternal.prototype.updateTickLength = function() {
        var internal = this;
        internal.tickLength = Math.max(internal.innerTickSize, 0) + internal.tickPadding;
    };
    AxisInternal.prototype.lineY2 = function(d) {
        var internal = this, tickPosition = internal.scale(d) + (internal.tickCentered ? 0 : internal.tickOffset);
        return internal.range[0] < tickPosition && tickPosition < internal.range[1] ? internal.innerTickSize : 0;
    };
    AxisInternal.prototype.textY = function() {
        var internal = this, rotate = internal.tickTextRotate;
        return rotate ? 11.5 - 2.5 * (rotate / 15) * (rotate > 0 ? 1 : -1) : internal.tickLength;
    };
    AxisInternal.prototype.textTransform = function() {
        var internal = this, rotate = internal.tickTextRotate;
        return rotate ? "rotate(" + rotate + ")" : "";
    };
    AxisInternal.prototype.textTextAnchor = function() {
        var internal = this, rotate = internal.tickTextRotate;
        return rotate ? rotate > 0 ? "start" : "end" : "middle";
    };
    AxisInternal.prototype.tspanDx = function() {
        var internal = this, rotate = internal.tickTextRotate;
        return rotate ? 8 * Math.sin(Math.PI * (rotate / 180)) : 0;
    };
    AxisInternal.prototype.tspanDy = function(d, i) {
        var internal = this, dy = internal.tickTextCharSize.h;
        if (i === 0) {
            if (internal.isVertical()) dy = -((d.length - 1) * (internal.tickTextCharSize.h / 2) - 3);
            else dy = ".71em";
        }
        return dy;
    };
    AxisInternal.prototype.generateAxis = function() {
        var internal = this, d3 = internal.d3, params = internal.params;
        function axis(g, transition) {
            var self;
            g.each(function() {
                var g = axis.g = d3.select(this);
                var scale0 = this.__chart__ || internal.scale, scale1 = this.__chart__ = internal.copyScale();
                var ticksValues = internal.tickValues ? internal.tickValues : internal.generateTicks(scale1), ticks = g.selectAll(".tick").data(ticksValues, scale1), tickEnter = ticks.enter().insert("g", ".domain").attr("class", "tick").style("opacity", 1e-6), // MEMO: No exit transition. The reason is this transition affects max tick width calculation because old tick will be included in the ticks.
                tickExit = ticks.exit().remove(), tickUpdate = ticks.merge(tickEnter), tickTransform, tickX, tickY;
                if (params.isCategory) {
                    internal.tickOffset = Math.ceil((scale1(1) - scale1(0)) / 2);
                    tickX = internal.tickCentered ? 0 : internal.tickOffset;
                    tickY = internal.tickCentered ? internal.tickOffset : 0;
                } else internal.tickOffset = tickX = 0;
                internal.updateRange();
                internal.updateTickLength();
                internal.updateTickTextCharSize(g.select(".tick"));
                var lineUpdate = tickUpdate.select("line").merge(tickEnter.append("line")), textUpdate = tickUpdate.select("text").merge(tickEnter.append("text"));
                var tspans = tickUpdate.selectAll("text").selectAll("tspan").data(function(d, i) {
                    return internal.tspanData(d, i, scale1);
                }), tspanEnter = tspans.enter().append("tspan"), tspanUpdate = tspanEnter.merge(tspans).text(function(d) {
                    return d.splitted;
                });
                tspans.exit().remove();
                var path = g.selectAll(".domain").data([
                    0
                ]), pathUpdate = path.enter().append("path").merge(path).attr("class", "domain");
                // TODO: each attr should be one function and change its behavior by internal.orient, probably
                switch(internal.orient){
                    case "bottom":
                        tickTransform = internal.axisX;
                        lineUpdate.attr("x1", tickX).attr("x2", tickX).attr("y2", function(d, i) {
                            return internal.lineY2(d, i);
                        });
                        textUpdate.attr("x", 0).attr("y", function(d, i) {
                            return internal.textY(d, i);
                        }).attr("transform", function(d, i) {
                            return internal.textTransform(d, i);
                        }).style("text-anchor", function(d, i) {
                            return internal.textTextAnchor(d, i);
                        });
                        tspanUpdate.attr("x", 0).attr("dy", function(d, i) {
                            return internal.tspanDy(d, i);
                        }).attr("dx", function(d, i) {
                            return internal.tspanDx(d, i);
                        });
                        pathUpdate.attr("d", "M" + internal.range[0] + "," + internal.outerTickSize + "V0H" + internal.range[1] + "V" + internal.outerTickSize);
                        break;
                    case "top":
                        // TODO: rotated tick text
                        tickTransform = internal.axisX;
                        lineUpdate.attr("x1", tickX).attr("x2", tickX).attr("y2", function(d, i) {
                            return -1 * internal.lineY2(d, i);
                        });
                        textUpdate.attr("x", 0).attr("y", function(d, i) {
                            return -1 * internal.textY(d, i) - (params.isCategory ? 2 : internal.tickLength - 2);
                        }).attr("transform", function(d, i) {
                            return internal.textTransform(d, i);
                        }).style("text-anchor", function(d, i) {
                            return internal.textTextAnchor(d, i);
                        });
                        tspanUpdate.attr("x", 0).attr("dy", function(d, i) {
                            return internal.tspanDy(d, i);
                        }).attr("dx", function(d, i) {
                            return internal.tspanDx(d, i);
                        });
                        pathUpdate.attr("d", "M" + internal.range[0] + "," + -internal.outerTickSize + "V0H" + internal.range[1] + "V" + -internal.outerTickSize);
                        break;
                    case "left":
                        tickTransform = internal.axisY;
                        lineUpdate.attr("x2", -internal.innerTickSize).attr("y1", tickY).attr("y2", tickY);
                        textUpdate.attr("x", -internal.tickLength).attr("y", internal.tickOffset).style("text-anchor", "end");
                        tspanUpdate.attr("x", -internal.tickLength).attr("dy", function(d, i) {
                            return internal.tspanDy(d, i);
                        });
                        pathUpdate.attr("d", "M" + -internal.outerTickSize + "," + internal.range[0] + "H0V" + internal.range[1] + "H" + -internal.outerTickSize);
                        break;
                    case "right":
                        tickTransform = internal.axisY;
                        lineUpdate.attr("x2", internal.innerTickSize).attr("y1", tickY).attr("y2", tickY);
                        textUpdate.attr("x", internal.tickLength).attr("y", internal.tickOffset).style("text-anchor", "start");
                        tspanUpdate.attr("x", internal.tickLength).attr("dy", function(d, i) {
                            return internal.tspanDy(d, i);
                        });
                        pathUpdate.attr("d", "M" + internal.outerTickSize + "," + internal.range[0] + "H0V" + internal.range[1] + "H" + internal.outerTickSize);
                        break;
                }
                if (scale1.rangeBand) {
                    var x = scale1, dx = x.rangeBand() / 2;
                    scale0 = scale1 = function(d) {
                        return x(d) + dx;
                    };
                } else if (scale0.rangeBand) scale0 = scale1;
                else tickExit.call(tickTransform, scale1, internal.tickOffset);
                tickEnter.call(tickTransform, scale0, internal.tickOffset);
                self = (transition ? tickUpdate.transition(transition) : tickUpdate).style("opacity", 1).call(tickTransform, scale1, internal.tickOffset);
            });
            return self;
        }
        axis.scale = function(x) {
            if (!arguments.length) return internal.scale;
            internal.scale = x;
            return axis;
        };
        axis.orient = function(x) {
            if (!arguments.length) return internal.orient;
            internal.orient = x in {
                top: 1,
                right: 1,
                bottom: 1,
                left: 1
            } ? x + "" : "bottom";
            return axis;
        };
        axis.tickFormat = function(format) {
            if (!arguments.length) return internal.tickFormat;
            internal.tickFormat = format;
            return axis;
        };
        axis.tickCentered = function(isCentered) {
            if (!arguments.length) return internal.tickCentered;
            internal.tickCentered = isCentered;
            return axis;
        };
        axis.tickOffset = function() {
            return internal.tickOffset;
        };
        axis.tickInterval = function() {
            var interval, length;
            if (params.isCategory) interval = internal.tickOffset * 2;
            else {
                length = axis.g.select("path.domain").node().getTotalLength() - internal.outerTickSize * 2;
                interval = length / axis.g.selectAll("line").size();
            }
            return interval === Infinity ? 0 : interval;
        };
        axis.ticks = function() {
            if (!arguments.length) return internal.tickArguments;
            internal.tickArguments = arguments;
            return axis;
        };
        axis.tickCulling = function(culling) {
            if (!arguments.length) return internal.tickCulling;
            internal.tickCulling = culling;
            return axis;
        };
        axis.tickValues = function(x) {
            if (typeof x === "function") internal.tickValues = function() {
                return x(internal.scale.domain());
            };
            else {
                if (!arguments.length) return internal.tickValues;
                internal.tickValues = x;
            }
            return axis;
        };
        return axis;
    };
    var CLASS = {
        target: "c3-target",
        chart: "c3-chart",
        chartLine: "c3-chart-line",
        chartLines: "c3-chart-lines",
        chartBar: "c3-chart-bar",
        chartBars: "c3-chart-bars",
        chartText: "c3-chart-text",
        chartTexts: "c3-chart-texts",
        chartArc: "c3-chart-arc",
        chartArcs: "c3-chart-arcs",
        chartArcsTitle: "c3-chart-arcs-title",
        chartArcsBackground: "c3-chart-arcs-background",
        chartArcsGaugeUnit: "c3-chart-arcs-gauge-unit",
        chartArcsGaugeMax: "c3-chart-arcs-gauge-max",
        chartArcsGaugeMin: "c3-chart-arcs-gauge-min",
        selectedCircle: "c3-selected-circle",
        selectedCircles: "c3-selected-circles",
        eventRect: "c3-event-rect",
        eventRects: "c3-event-rects",
        eventRectsSingle: "c3-event-rects-single",
        eventRectsMultiple: "c3-event-rects-multiple",
        zoomRect: "c3-zoom-rect",
        brush: "c3-brush",
        dragZoom: "c3-drag-zoom",
        focused: "c3-focused",
        defocused: "c3-defocused",
        region: "c3-region",
        regions: "c3-regions",
        title: "c3-title",
        tooltipContainer: "c3-tooltip-container",
        tooltip: "c3-tooltip",
        tooltipName: "c3-tooltip-name",
        shape: "c3-shape",
        shapes: "c3-shapes",
        line: "c3-line",
        lines: "c3-lines",
        bar: "c3-bar",
        bars: "c3-bars",
        circle: "c3-circle",
        circles: "c3-circles",
        arc: "c3-arc",
        arcLabelLine: "c3-arc-label-line",
        arcs: "c3-arcs",
        area: "c3-area",
        areas: "c3-areas",
        empty: "c3-empty",
        text: "c3-text",
        texts: "c3-texts",
        gaugeValue: "c3-gauge-value",
        grid: "c3-grid",
        gridLines: "c3-grid-lines",
        xgrid: "c3-xgrid",
        xgrids: "c3-xgrids",
        xgridLine: "c3-xgrid-line",
        xgridLines: "c3-xgrid-lines",
        xgridFocus: "c3-xgrid-focus",
        ygrid: "c3-ygrid",
        ygrids: "c3-ygrids",
        ygridLine: "c3-ygrid-line",
        ygridLines: "c3-ygrid-lines",
        colorScale: "c3-colorscale",
        stanfordElements: "c3-stanford-elements",
        stanfordLine: "c3-stanford-line",
        stanfordLines: "c3-stanford-lines",
        stanfordRegion: "c3-stanford-region",
        stanfordRegions: "c3-stanford-regions",
        stanfordText: "c3-stanford-text",
        stanfordTexts: "c3-stanford-texts",
        axis: "c3-axis",
        axisX: "c3-axis-x",
        axisXLabel: "c3-axis-x-label",
        axisY: "c3-axis-y",
        axisYLabel: "c3-axis-y-label",
        axisY2: "c3-axis-y2",
        axisY2Label: "c3-axis-y2-label",
        legendBackground: "c3-legend-background",
        legendItem: "c3-legend-item",
        legendItemEvent: "c3-legend-item-event",
        legendItemTile: "c3-legend-item-tile",
        legendItemHidden: "c3-legend-item-hidden",
        legendItemFocused: "c3-legend-item-focused",
        dragarea: "c3-dragarea",
        EXPANDED: "_expanded_",
        SELECTED: "_selected_",
        INCLUDED: "_included_"
    };
    var AxisClass = /** @class */ function() {
        function AxisClass(owner) {
            this.owner = owner;
            this.d3 = owner.d3;
            this.internal = AxisInternal;
        }
        return AxisClass;
    }();
    var Axis = AxisClass;
    Axis.prototype.init = function init() {
        var $$ = this.owner, config = $$.config, main = $$.main;
        $$.axes.x = main.append("g").attr("class", CLASS.axis + " " + CLASS.axisX).attr("clip-path", config.axis_x_inner ? "" : $$.clipPathForXAxis).attr("transform", $$.getTranslate("x")).style("visibility", config.axis_x_show ? "visible" : "hidden");
        $$.axes.x.append("text").attr("class", CLASS.axisXLabel).attr("transform", config.axis_rotated ? "rotate(-90)" : "").style("text-anchor", this.textAnchorForXAxisLabel.bind(this));
        $$.axes.y = main.append("g").attr("class", CLASS.axis + " " + CLASS.axisY).attr("clip-path", config.axis_y_inner ? "" : $$.clipPathForYAxis).attr("transform", $$.getTranslate("y")).style("visibility", config.axis_y_show ? "visible" : "hidden");
        $$.axes.y.append("text").attr("class", CLASS.axisYLabel).attr("transform", config.axis_rotated ? "" : "rotate(-90)").style("text-anchor", this.textAnchorForYAxisLabel.bind(this));
        $$.axes.y2 = main.append("g").attr("class", CLASS.axis + " " + CLASS.axisY2)// clip-path?
        .attr("transform", $$.getTranslate("y2")).style("visibility", config.axis_y2_show ? "visible" : "hidden");
        $$.axes.y2.append("text").attr("class", CLASS.axisY2Label).attr("transform", config.axis_rotated ? "" : "rotate(-90)").style("text-anchor", this.textAnchorForY2AxisLabel.bind(this));
    };
    Axis.prototype.getXAxis = function getXAxis(scale, orient, tickFormat, tickValues, withOuterTick, withoutTransition, withoutRotateTickText) {
        var $$ = this.owner, config = $$.config, axisParams = {
            isCategory: $$.isCategorized(),
            withOuterTick: withOuterTick,
            tickMultiline: config.axis_x_tick_multiline,
            tickMultilineMax: config.axis_x_tick_multiline ? Number(config.axis_x_tick_multilineMax) : 0,
            tickWidth: config.axis_x_tick_width,
            tickTextRotate: withoutRotateTickText ? 0 : config.axis_x_tick_rotate,
            withoutTransition: withoutTransition
        }, axis = new this.internal(this, axisParams).axis.scale(scale).orient(orient);
        if ($$.isTimeSeries() && tickValues && typeof tickValues !== "function") tickValues = tickValues.map(function(v) {
            return $$.parseDate(v);
        });
        // Set tick
        axis.tickFormat(tickFormat).tickValues(tickValues);
        if ($$.isCategorized()) {
            axis.tickCentered(config.axis_x_tick_centered);
            if (isEmpty(config.axis_x_tick_culling)) config.axis_x_tick_culling = false;
        }
        return axis;
    };
    Axis.prototype.updateXAxisTickValues = function updateXAxisTickValues(targets, axis) {
        var $$ = this.owner, config = $$.config, tickValues;
        if (config.axis_x_tick_fit || config.axis_x_tick_count) tickValues = this.generateTickValues($$.mapTargetsToUniqueXs(targets), config.axis_x_tick_count, $$.isTimeSeries());
        if (axis) axis.tickValues(tickValues);
        else {
            $$.xAxis.tickValues(tickValues);
            $$.subXAxis.tickValues(tickValues);
        }
        return tickValues;
    };
    Axis.prototype.getYAxis = function getYAxis(axisId, scale, orient, tickValues, withOuterTick, withoutTransition, withoutRotateTickText) {
        var $$ = this.owner;
        var config = $$.config;
        var tickFormat = config["axis_" + axisId + "_tick_format"];
        if (!tickFormat && $$.isAxisNormalized(axisId)) tickFormat = function(x) {
            return x + "%";
        };
        var axis = new this.internal(this, {
            withOuterTick: withOuterTick,
            withoutTransition: withoutTransition,
            tickTextRotate: withoutRotateTickText ? 0 : config.axis_y_tick_rotate
        }).axis.scale(scale).orient(orient);
        if (tickFormat) axis.tickFormat(tickFormat);
        if ($$.isTimeSeriesY()) axis.ticks(config.axis_y_tick_time_type, config.axis_y_tick_time_interval);
        else axis.tickValues(tickValues);
        return axis;
    };
    Axis.prototype.getId = function getId(id) {
        var config = this.owner.config;
        return id in config.data_axes ? config.data_axes[id] : "y";
    };
    Axis.prototype.getXAxisTickFormat = function getXAxisTickFormat() {
        // #2251 previously set any negative values to a whole number,
        // however both should be truncated according to the users format specification
        var $$ = this.owner, config = $$.config;
        var format = $$.isTimeSeries() ? $$.defaultAxisTimeFormat : $$.isCategorized() ? $$.categoryName : function(v) {
            return v;
        };
        if (config.axis_x_tick_format) {
            if (isFunction(config.axis_x_tick_format)) format = config.axis_x_tick_format;
            else if ($$.isTimeSeries()) format = function(date) {
                return date ? $$.axisTimeFormat(config.axis_x_tick_format)(date) : "";
            };
        }
        return isFunction(format) ? function(v) {
            return format.call($$, v);
        } : format;
    };
    Axis.prototype.getTickValues = function getTickValues(tickValues, axis) {
        return tickValues ? tickValues : axis ? axis.tickValues() : undefined;
    };
    Axis.prototype.getXAxisTickValues = function getXAxisTickValues() {
        return this.getTickValues(this.owner.config.axis_x_tick_values, this.owner.xAxis);
    };
    Axis.prototype.getYAxisTickValues = function getYAxisTickValues() {
        return this.getTickValues(this.owner.config.axis_y_tick_values, this.owner.yAxis);
    };
    Axis.prototype.getY2AxisTickValues = function getY2AxisTickValues() {
        return this.getTickValues(this.owner.config.axis_y2_tick_values, this.owner.y2Axis);
    };
    Axis.prototype.getLabelOptionByAxisId = function getLabelOptionByAxisId(axisId) {
        var $$ = this.owner, config = $$.config, option;
        if (axisId === "y") option = config.axis_y_label;
        else if (axisId === "y2") option = config.axis_y2_label;
        else if (axisId === "x") option = config.axis_x_label;
        return option;
    };
    Axis.prototype.getLabelText = function getLabelText(axisId) {
        var option = this.getLabelOptionByAxisId(axisId);
        return isString(option) ? option : option ? option.text : null;
    };
    Axis.prototype.setLabelText = function setLabelText(axisId, text) {
        var $$ = this.owner, config = $$.config, option = this.getLabelOptionByAxisId(axisId);
        if (isString(option)) {
            if (axisId === "y") config.axis_y_label = text;
            else if (axisId === "y2") config.axis_y2_label = text;
            else if (axisId === "x") config.axis_x_label = text;
        } else if (option) option.text = text;
    };
    Axis.prototype.getLabelPosition = function getLabelPosition(axisId, defaultPosition) {
        var option = this.getLabelOptionByAxisId(axisId), position = option && typeof option === "object" && option.position ? option.position : defaultPosition;
        return {
            isInner: position.indexOf("inner") >= 0,
            isOuter: position.indexOf("outer") >= 0,
            isLeft: position.indexOf("left") >= 0,
            isCenter: position.indexOf("center") >= 0,
            isRight: position.indexOf("right") >= 0,
            isTop: position.indexOf("top") >= 0,
            isMiddle: position.indexOf("middle") >= 0,
            isBottom: position.indexOf("bottom") >= 0
        };
    };
    Axis.prototype.getXAxisLabelPosition = function getXAxisLabelPosition() {
        return this.getLabelPosition("x", this.owner.config.axis_rotated ? "inner-top" : "inner-right");
    };
    Axis.prototype.getYAxisLabelPosition = function getYAxisLabelPosition() {
        return this.getLabelPosition("y", this.owner.config.axis_rotated ? "inner-right" : "inner-top");
    };
    Axis.prototype.getY2AxisLabelPosition = function getY2AxisLabelPosition() {
        return this.getLabelPosition("y2", this.owner.config.axis_rotated ? "inner-right" : "inner-top");
    };
    Axis.prototype.getLabelPositionById = function getLabelPositionById(id) {
        return id === "y2" ? this.getY2AxisLabelPosition() : id === "y" ? this.getYAxisLabelPosition() : this.getXAxisLabelPosition();
    };
    Axis.prototype.textForXAxisLabel = function textForXAxisLabel() {
        return this.getLabelText("x");
    };
    Axis.prototype.textForYAxisLabel = function textForYAxisLabel() {
        return this.getLabelText("y");
    };
    Axis.prototype.textForY2AxisLabel = function textForY2AxisLabel() {
        return this.getLabelText("y2");
    };
    Axis.prototype.xForAxisLabel = function xForAxisLabel(forHorizontal, position) {
        var $$ = this.owner;
        if (forHorizontal) return position.isLeft ? 0 : position.isCenter ? $$.width / 2 : $$.width;
        else return position.isBottom ? -$$.height : position.isMiddle ? -$$.height / 2 : 0;
    };
    Axis.prototype.dxForAxisLabel = function dxForAxisLabel(forHorizontal, position) {
        if (forHorizontal) return position.isLeft ? "0.5em" : position.isRight ? "-0.5em" : "0";
        else return position.isTop ? "-0.5em" : position.isBottom ? "0.5em" : "0";
    };
    Axis.prototype.textAnchorForAxisLabel = function textAnchorForAxisLabel(forHorizontal, position) {
        if (forHorizontal) return position.isLeft ? "start" : position.isCenter ? "middle" : "end";
        else return position.isBottom ? "start" : position.isMiddle ? "middle" : "end";
    };
    Axis.prototype.xForXAxisLabel = function xForXAxisLabel() {
        return this.xForAxisLabel(!this.owner.config.axis_rotated, this.getXAxisLabelPosition());
    };
    Axis.prototype.xForYAxisLabel = function xForYAxisLabel() {
        return this.xForAxisLabel(this.owner.config.axis_rotated, this.getYAxisLabelPosition());
    };
    Axis.prototype.xForY2AxisLabel = function xForY2AxisLabel() {
        return this.xForAxisLabel(this.owner.config.axis_rotated, this.getY2AxisLabelPosition());
    };
    Axis.prototype.dxForXAxisLabel = function dxForXAxisLabel() {
        return this.dxForAxisLabel(!this.owner.config.axis_rotated, this.getXAxisLabelPosition());
    };
    Axis.prototype.dxForYAxisLabel = function dxForYAxisLabel() {
        return this.dxForAxisLabel(this.owner.config.axis_rotated, this.getYAxisLabelPosition());
    };
    Axis.prototype.dxForY2AxisLabel = function dxForY2AxisLabel() {
        return this.dxForAxisLabel(this.owner.config.axis_rotated, this.getY2AxisLabelPosition());
    };
    Axis.prototype.dyForXAxisLabel = function dyForXAxisLabel() {
        var $$ = this.owner, config = $$.config, position = this.getXAxisLabelPosition();
        if (config.axis_rotated) return position.isInner ? "1.2em" : -25 - ($$.config.axis_x_inner ? 0 : this.getMaxTickWidth("x"));
        else return position.isInner ? "-0.5em" : $$.getHorizontalAxisHeight("x") - 10;
    };
    Axis.prototype.dyForYAxisLabel = function dyForYAxisLabel() {
        var $$ = this.owner, position = this.getYAxisLabelPosition();
        if ($$.config.axis_rotated) return position.isInner ? "-0.5em" : "3em";
        else return position.isInner ? "1.2em" : -10 - ($$.config.axis_y_inner ? 0 : this.getMaxTickWidth("y") + 10);
    };
    Axis.prototype.dyForY2AxisLabel = function dyForY2AxisLabel() {
        var $$ = this.owner, position = this.getY2AxisLabelPosition();
        if ($$.config.axis_rotated) return position.isInner ? "1.2em" : "-2.2em";
        else return position.isInner ? "-0.5em" : 15 + ($$.config.axis_y2_inner ? 0 : this.getMaxTickWidth("y2") + 15);
    };
    Axis.prototype.textAnchorForXAxisLabel = function textAnchorForXAxisLabel() {
        var $$ = this.owner;
        return this.textAnchorForAxisLabel(!$$.config.axis_rotated, this.getXAxisLabelPosition());
    };
    Axis.prototype.textAnchorForYAxisLabel = function textAnchorForYAxisLabel() {
        var $$ = this.owner;
        return this.textAnchorForAxisLabel($$.config.axis_rotated, this.getYAxisLabelPosition());
    };
    Axis.prototype.textAnchorForY2AxisLabel = function textAnchorForY2AxisLabel() {
        var $$ = this.owner;
        return this.textAnchorForAxisLabel($$.config.axis_rotated, this.getY2AxisLabelPosition());
    };
    Axis.prototype.getMaxTickWidth = function getMaxTickWidth(id, withoutRecompute) {
        var $$ = this.owner, maxWidth = 0, targetsToShow, scale, axis, dummy, svg;
        if (withoutRecompute && $$.currentMaxTickWidths[id]) return $$.currentMaxTickWidths[id];
        if ($$.svg) {
            targetsToShow = $$.filterTargetsToShow($$.data.targets);
            if (id === "y") {
                scale = $$.y.copy().domain($$.getYDomain(targetsToShow, "y"));
                axis = this.getYAxis(id, scale, $$.yOrient, $$.yAxisTickValues, false, true, true);
            } else if (id === "y2") {
                scale = $$.y2.copy().domain($$.getYDomain(targetsToShow, "y2"));
                axis = this.getYAxis(id, scale, $$.y2Orient, $$.y2AxisTickValues, false, true, true);
            } else {
                scale = $$.x.copy().domain($$.getXDomain(targetsToShow));
                axis = this.getXAxis(scale, $$.xOrient, $$.xAxisTickFormat, $$.xAxisTickValues, false, true, true);
                this.updateXAxisTickValues(targetsToShow, axis);
            }
            dummy = $$.d3.select("body").append("div").classed("c3", true);
            svg = dummy.append("svg").style("visibility", "hidden").style("position", "fixed").style("top", 0).style("left", 0), svg.append("g").call(axis).each(function() {
                $$.d3.select(this).selectAll("text").each(function() {
                    var box = getBBox(this);
                    if (maxWidth < box.width) maxWidth = box.width;
                });
                dummy.remove();
            });
        }
        $$.currentMaxTickWidths[id] = maxWidth <= 0 ? $$.currentMaxTickWidths[id] : maxWidth;
        return $$.currentMaxTickWidths[id];
    };
    Axis.prototype.updateLabels = function updateLabels(withTransition) {
        var $$ = this.owner;
        var axisXLabel = $$.main.select("." + CLASS.axisX + " ." + CLASS.axisXLabel), axisYLabel = $$.main.select("." + CLASS.axisY + " ." + CLASS.axisYLabel), axisY2Label = $$.main.select("." + CLASS.axisY2 + " ." + CLASS.axisY2Label);
        (withTransition ? axisXLabel.transition() : axisXLabel).attr("x", this.xForXAxisLabel.bind(this)).attr("dx", this.dxForXAxisLabel.bind(this)).attr("dy", this.dyForXAxisLabel.bind(this)).text(this.textForXAxisLabel.bind(this));
        (withTransition ? axisYLabel.transition() : axisYLabel).attr("x", this.xForYAxisLabel.bind(this)).attr("dx", this.dxForYAxisLabel.bind(this)).attr("dy", this.dyForYAxisLabel.bind(this)).text(this.textForYAxisLabel.bind(this));
        (withTransition ? axisY2Label.transition() : axisY2Label).attr("x", this.xForY2AxisLabel.bind(this)).attr("dx", this.dxForY2AxisLabel.bind(this)).attr("dy", this.dyForY2AxisLabel.bind(this)).text(this.textForY2AxisLabel.bind(this));
    };
    Axis.prototype.getPadding = function getPadding(padding, key, defaultValue, domainLength) {
        var p = typeof padding === "number" ? padding : padding[key];
        if (!isValue(p)) return defaultValue;
        if (padding.unit === "ratio") return padding[key] * domainLength;
        // assume padding is pixels if unit is not specified
        return this.convertPixelsToAxisPadding(p, domainLength);
    };
    Axis.prototype.convertPixelsToAxisPadding = function convertPixelsToAxisPadding(pixels, domainLength) {
        var $$ = this.owner, length = $$.config.axis_rotated ? $$.width : $$.height;
        return domainLength * (pixels / length);
    };
    Axis.prototype.generateTickValues = function generateTickValues(values, tickCount, forTimeSeries) {
        var tickValues = values, targetCount, start, end, count, interval, i, tickValue;
        if (tickCount) {
            targetCount = isFunction(tickCount) ? tickCount() : tickCount;
            // compute ticks according to tickCount
            if (targetCount === 1) tickValues = [
                values[0]
            ];
            else if (targetCount === 2) tickValues = [
                values[0],
                values[values.length - 1]
            ];
            else if (targetCount > 2) {
                count = targetCount - 2;
                start = values[0];
                end = values[values.length - 1];
                interval = (end - start) / (count + 1);
                // re-construct unique values
                tickValues = [
                    start
                ];
                for(i = 0; i < count; i++){
                    tickValue = +start + interval * (i + 1);
                    tickValues.push(forTimeSeries ? new Date(tickValue) : tickValue);
                }
                tickValues.push(end);
            }
        }
        if (!forTimeSeries) tickValues = tickValues.sort(function(a, b) {
            return a - b;
        });
        return tickValues;
    };
    Axis.prototype.generateTransitions = function generateTransitions(duration) {
        var $$ = this.owner, axes = $$.axes;
        return {
            axisX: duration ? axes.x.transition().duration(duration) : axes.x,
            axisY: duration ? axes.y.transition().duration(duration) : axes.y,
            axisY2: duration ? axes.y2.transition().duration(duration) : axes.y2,
            axisSubX: duration ? axes.subx.transition().duration(duration) : axes.subx
        };
    };
    Axis.prototype.redraw = function redraw(duration, isHidden) {
        var $$ = this.owner, transition = duration ? $$.d3.transition().duration(duration) : null;
        $$.axes.x.style("opacity", isHidden ? 0 : 1).call($$.xAxis, transition);
        $$.axes.y.style("opacity", isHidden ? 0 : 1).call($$.yAxis, transition);
        $$.axes.y2.style("opacity", isHidden ? 0 : 1).call($$.y2Axis, transition);
        $$.axes.subx.style("opacity", isHidden ? 0 : 1).call($$.subXAxis, transition);
    };
    var c3 = {
        version: "0.7.20",
        chart: {
            fn: Chart.prototype,
            internal: {
                fn: ChartInternal.prototype,
                axis: {
                    fn: AxisClass.prototype,
                    internal: {
                        fn: AxisInternal.prototype
                    }
                }
            }
        },
        generate: function(config) {
            return new Chart(config);
        }
    };
    ChartInternal.prototype.beforeInit = function() {
    // can do something
    };
    ChartInternal.prototype.afterInit = function() {
    // can do something
    };
    ChartInternal.prototype.init = function() {
        var $$ = this, config = $$.config;
        $$.initParams();
        if (config.data_url) $$.convertUrlToData(config.data_url, config.data_mimeType, config.data_headers, config.data_keys, $$.initWithData);
        else if (config.data_json) $$.initWithData($$.convertJsonToData(config.data_json, config.data_keys));
        else if (config.data_rows) $$.initWithData($$.convertRowsToData(config.data_rows));
        else if (config.data_columns) $$.initWithData($$.convertColumnsToData(config.data_columns));
        else throw Error("url or json or rows or columns is required.");
    };
    ChartInternal.prototype.initParams = function() {
        var $$ = this, d3 = $$.d3, config = $$.config;
        // MEMO: clipId needs to be unique because it conflicts when multiple charts exist
        $$.clipId = "c3-" + new Date().valueOf() + "-clip";
        $$.clipIdForXAxis = $$.clipId + "-xaxis";
        $$.clipIdForYAxis = $$.clipId + "-yaxis";
        $$.clipIdForGrid = $$.clipId + "-grid";
        $$.clipIdForSubchart = $$.clipId + "-subchart";
        $$.clipPath = $$.getClipPath($$.clipId);
        $$.clipPathForXAxis = $$.getClipPath($$.clipIdForXAxis);
        $$.clipPathForYAxis = $$.getClipPath($$.clipIdForYAxis);
        $$.clipPathForGrid = $$.getClipPath($$.clipIdForGrid);
        $$.clipPathForSubchart = $$.getClipPath($$.clipIdForSubchart);
        $$.dragStart = null;
        $$.dragging = false;
        $$.flowing = false;
        $$.cancelClick = false;
        $$.mouseover = undefined;
        $$.transiting = false;
        $$.color = $$.generateColor();
        $$.levelColor = $$.generateLevelColor();
        $$.dataTimeParse = (config.data_xLocaltime ? d3.timeParse : d3.utcParse)($$.config.data_xFormat);
        $$.axisTimeFormat = config.axis_x_localtime ? d3.timeFormat : d3.utcFormat;
        $$.defaultAxisTimeFormat = function(date) {
            if (date.getMilliseconds()) return d3.timeFormat(".%L")(date);
            if (date.getSeconds()) return d3.timeFormat(":%S")(date);
            if (date.getMinutes()) return d3.timeFormat("%I:%M")(date);
            if (date.getHours()) return d3.timeFormat("%I %p")(date);
            if (date.getDay() && date.getDate() !== 1) return d3.timeFormat("%-m/%-d")(date);
            if (date.getDate() !== 1) return d3.timeFormat("%-m/%-d")(date);
            if (date.getMonth()) return d3.timeFormat("%-m/%-d")(date);
            return d3.timeFormat("%Y/%-m/%-d")(date);
        };
        $$.hiddenTargetIds = [];
        $$.hiddenLegendIds = [];
        $$.focusedTargetIds = [];
        $$.defocusedTargetIds = [];
        $$.xOrient = config.axis_rotated ? config.axis_x_inner ? "right" : "left" : config.axis_x_inner ? "top" : "bottom";
        $$.yOrient = config.axis_rotated ? config.axis_y_inner ? "top" : "bottom" : config.axis_y_inner ? "right" : "left";
        $$.y2Orient = config.axis_rotated ? config.axis_y2_inner ? "bottom" : "top" : config.axis_y2_inner ? "left" : "right";
        $$.subXOrient = config.axis_rotated ? "left" : "bottom";
        $$.isLegendRight = config.legend_position === "right";
        $$.isLegendInset = config.legend_position === "inset";
        $$.isLegendTop = config.legend_inset_anchor === "top-left" || config.legend_inset_anchor === "top-right";
        $$.isLegendLeft = config.legend_inset_anchor === "top-left" || config.legend_inset_anchor === "bottom-left";
        $$.legendStep = 0;
        $$.legendItemWidth = 0;
        $$.legendItemHeight = 0;
        $$.currentMaxTickWidths = {
            x: 0,
            y: 0,
            y2: 0
        };
        $$.rotated_padding_left = 30;
        $$.rotated_padding_right = config.axis_rotated && !config.axis_x_show ? 0 : 30;
        $$.rotated_padding_top = 5;
        $$.withoutFadeIn = {};
        $$.intervalForObserveInserted = undefined;
        $$.axes.subx = d3.selectAll([]); // needs when excluding subchart.js
    };
    ChartInternal.prototype.initChartElements = function() {
        if (this.initBar) this.initBar();
        if (this.initLine) this.initLine();
        if (this.initArc) this.initArc();
        if (this.initGauge) this.initGauge();
        if (this.initText) this.initText();
    };
    ChartInternal.prototype.initWithData = function(data) {
        var $$ = this, d3 = $$.d3, config = $$.config;
        var defs, main, binding = true;
        $$.axis = new AxisClass($$);
        if (!config.bindto) $$.selectChart = d3.selectAll([]);
        else if (typeof config.bindto.node === "function") $$.selectChart = config.bindto;
        else $$.selectChart = d3.select(config.bindto);
        if ($$.selectChart.empty()) {
            $$.selectChart = d3.select(document.createElement("div")).style("opacity", 0);
            $$.observeInserted($$.selectChart);
            binding = false;
        }
        $$.selectChart.html("").classed("c3", true);
        // Init data as targets
        $$.data.xs = {};
        $$.data.targets = $$.convertDataToTargets(data);
        if (config.data_filter) $$.data.targets = $$.data.targets.filter(config.data_filter);
        // Set targets to hide if needed
        if (config.data_hide) $$.addHiddenTargetIds(config.data_hide === true ? $$.mapToIds($$.data.targets) : config.data_hide);
        if (config.legend_hide) $$.addHiddenLegendIds(config.legend_hide === true ? $$.mapToIds($$.data.targets) : config.legend_hide);
        if ($$.isStanfordGraphType()) $$.initStanfordData();
        // Init sizes and scales
        $$.updateSizes();
        $$.updateScales();
        // Set domains for each scale
        $$.x.domain(d3.extent($$.getXDomain($$.data.targets)));
        $$.y.domain($$.getYDomain($$.data.targets, "y"));
        $$.y2.domain($$.getYDomain($$.data.targets, "y2"));
        $$.subX.domain($$.x.domain());
        $$.subY.domain($$.y.domain());
        $$.subY2.domain($$.y2.domain());
        // Save original x domain for zoom update
        $$.orgXDomain = $$.x.domain();
        /*-- Basic Elements --*/ // Define svgs
        $$.svg = $$.selectChart.append("svg").style("overflow", "hidden").on("mouseenter", function() {
            return config.onmouseover.call($$);
        }).on("mouseleave", function() {
            return config.onmouseout.call($$);
        });
        if ($$.config.svg_classname) $$.svg.attr("class", $$.config.svg_classname);
        // Define defs
        defs = $$.svg.append("defs");
        $$.clipChart = $$.appendClip(defs, $$.clipId);
        $$.clipXAxis = $$.appendClip(defs, $$.clipIdForXAxis);
        $$.clipYAxis = $$.appendClip(defs, $$.clipIdForYAxis);
        $$.clipGrid = $$.appendClip(defs, $$.clipIdForGrid);
        $$.clipSubchart = $$.appendClip(defs, $$.clipIdForSubchart);
        $$.updateSvgSize();
        // Define regions
        main = $$.main = $$.svg.append("g").attr("transform", $$.getTranslate("main"));
        if ($$.initPie) $$.initPie();
        if ($$.initDragZoom) $$.initDragZoom();
        if (config.subchart_show && $$.initSubchart) $$.initSubchart();
        if ($$.initTooltip) $$.initTooltip();
        if ($$.initLegend) $$.initLegend();
        if ($$.initTitle) $$.initTitle();
        if ($$.initZoom) $$.initZoom();
        if ($$.isStanfordGraphType()) $$.drawColorScale();
        // Update selection based on size and scale
        // TODO: currently this must be called after initLegend because of update of sizes, but it should be done in initSubchart.
        if (config.subchart_show && $$.initSubchartBrush) $$.initSubchartBrush();
        /*-- Main Region --*/ // text when empty
        main.append("text").attr("class", CLASS.text + " " + CLASS.empty).attr("text-anchor", "middle") // horizontal centering of text at x position in all browsers.
        .attr("dominant-baseline", "middle"); // vertical centering of text at y position in all browsers, except IE.
        // Regions
        $$.initRegion();
        // Grids
        $$.initGrid();
        // Define g for chart area
        main.append("g").attr("clip-path", $$.clipPath).attr("class", CLASS.chart);
        // Grid lines
        if (config.grid_lines_front) $$.initGridLines();
        $$.initStanfordElements();
        // Cover whole with rects for events
        $$.initEventRect();
        // Define g for chart
        $$.initChartElements();
        // Add Axis
        $$.axis.init();
        // Set targets
        $$.updateTargets($$.data.targets);
        // Set default extent if defined
        if (config.axis_x_selection) $$.brush.selectionAsValue($$.getDefaultSelection());
        // Draw with targets
        if (binding) {
            $$.updateDimension();
            $$.config.oninit.call($$);
            $$.redraw({
                withTransition: false,
                withTransform: true,
                withUpdateXDomain: true,
                withUpdateOrgXDomain: true,
                withTransitionForAxis: false
            });
        }
        // Bind to resize event
        $$.bindResize();
        // Bind to window focus event
        $$.bindWindowFocus();
        // export element of the chart
        $$.api.element = $$.selectChart.node();
    };
    ChartInternal.prototype.smoothLines = function(el, type) {
        var $$ = this;
        if (type === "grid") el.each(function() {
            var g = $$.d3.select(this), x1 = g.attr("x1"), x2 = g.attr("x2"), y1 = g.attr("y1"), y2 = g.attr("y2");
            g.attr({
                x1: Math.ceil(x1),
                x2: Math.ceil(x2),
                y1: Math.ceil(y1),
                y2: Math.ceil(y2)
            });
        });
    };
    ChartInternal.prototype.updateSizes = function() {
        var $$ = this, config = $$.config;
        var legendHeight = $$.legend ? $$.getLegendHeight() : 0, legendWidth = $$.legend ? $$.getLegendWidth() : 0, legendHeightForBottom = $$.isLegendRight || $$.isLegendInset ? 0 : legendHeight, hasArc = $$.hasArcType(), xAxisHeight = config.axis_rotated || hasArc ? 0 : $$.getHorizontalAxisHeight("x"), subchartXAxisHeight = config.axis_rotated || hasArc ? 0 : $$.getHorizontalAxisHeight("x", true), subchartHeight = config.subchart_show && !hasArc ? config.subchart_size_height + subchartXAxisHeight : 0;
        $$.currentWidth = $$.getCurrentWidth();
        $$.currentHeight = $$.getCurrentHeight();
        // for main
        $$.margin = config.axis_rotated ? {
            top: $$.getHorizontalAxisHeight("y2") + $$.getCurrentPaddingTop(),
            right: hasArc ? 0 : $$.getCurrentPaddingRight(),
            bottom: $$.getHorizontalAxisHeight("y") + legendHeightForBottom + $$.getCurrentPaddingBottom(),
            left: subchartHeight + (hasArc ? 0 : $$.getCurrentPaddingLeft())
        } : {
            top: 4 + $$.getCurrentPaddingTop(),
            right: hasArc ? 0 : $$.getCurrentPaddingRight(),
            bottom: xAxisHeight + subchartHeight + legendHeightForBottom + $$.getCurrentPaddingBottom(),
            left: hasArc ? 0 : $$.getCurrentPaddingLeft()
        };
        // for subchart
        $$.margin2 = config.axis_rotated ? {
            top: $$.margin.top,
            right: NaN,
            bottom: 20 + legendHeightForBottom,
            left: $$.rotated_padding_left
        } : {
            top: $$.currentHeight - subchartHeight - legendHeightForBottom,
            right: NaN,
            bottom: subchartXAxisHeight + legendHeightForBottom,
            left: $$.margin.left
        };
        // for legend
        $$.margin3 = {
            top: 0,
            right: NaN,
            bottom: 0,
            left: 0
        };
        if ($$.updateSizeForLegend) $$.updateSizeForLegend(legendHeight, legendWidth);
        $$.width = $$.currentWidth - $$.margin.left - $$.margin.right;
        $$.height = $$.currentHeight - $$.margin.top - $$.margin.bottom;
        if ($$.width < 0) $$.width = 0;
        if ($$.height < 0) $$.height = 0;
        $$.width2 = config.axis_rotated ? $$.margin.left - $$.rotated_padding_left - $$.rotated_padding_right : $$.width;
        $$.height2 = config.axis_rotated ? $$.height : $$.currentHeight - $$.margin2.top - $$.margin2.bottom;
        if ($$.width2 < 0) $$.width2 = 0;
        if ($$.height2 < 0) $$.height2 = 0;
        // for arc
        $$.arcWidth = $$.width - ($$.isLegendRight ? legendWidth + 10 : 0);
        $$.arcHeight = $$.height - ($$.isLegendRight ? 0 : 10);
        if ($$.hasType("gauge") && !config.gauge_fullCircle) $$.arcHeight += $$.height - $$.getGaugeLabelHeight();
        if ($$.updateRadius) $$.updateRadius();
        if ($$.isLegendRight && hasArc) $$.margin3.left = $$.arcWidth / 2 + $$.radiusExpanded * 1.1;
    };
    ChartInternal.prototype.updateTargets = function(targets) {
        var $$ = this, config = $$.config;
        /*-- Main --*/ //-- Text --//
        $$.updateTargetsForText(targets);
        //-- Bar --//
        $$.updateTargetsForBar(targets);
        //-- Line --//
        $$.updateTargetsForLine(targets);
        //-- Arc --//
        if ($$.hasArcType() && $$.updateTargetsForArc) $$.updateTargetsForArc(targets);
        /*-- Sub --*/ if (config.subchart_show && $$.updateTargetsForSubchart) $$.updateTargetsForSubchart(targets);
        // Fade-in each chart
        $$.showTargets();
    };
    ChartInternal.prototype.showTargets = function() {
        var $$ = this;
        $$.svg.selectAll("." + CLASS.target).filter(function(d) {
            return $$.isTargetToShow(d.id);
        }).transition().duration($$.config.transition_duration).style("opacity", 1);
    };
    ChartInternal.prototype.redraw = function(options, transitions) {
        var $$ = this, main = $$.main, d3 = $$.d3, config = $$.config;
        var areaIndices = $$.getShapeIndices($$.isAreaType), barIndices = $$.getShapeIndices($$.isBarType), lineIndices = $$.getShapeIndices($$.isLineType);
        var withY, withSubchart, withTransition, withTransitionForExit, withTransitionForAxis, withTransform, withUpdateXDomain, withUpdateOrgXDomain, withTrimXDomain, withLegend, withEventRect, withDimension, withUpdateXAxis;
        var hideAxis = $$.hasArcType();
        var drawArea, drawBar, drawLine, xForText, yForText;
        var duration, durationForExit, durationForAxis;
        var transitionsToWait, waitForDraw, flow, transition;
        var targetsToShow = $$.filterTargetsToShow($$.data.targets), tickValues, i, intervalForCulling, xDomainForZoom;
        var xv = $$.xv.bind($$), cx, cy;
        options = options || {};
        withY = getOption(options, "withY", true);
        withSubchart = getOption(options, "withSubchart", true);
        withTransition = getOption(options, "withTransition", true);
        withTransform = getOption(options, "withTransform", false);
        withUpdateXDomain = getOption(options, "withUpdateXDomain", false);
        withUpdateOrgXDomain = getOption(options, "withUpdateOrgXDomain", false);
        withTrimXDomain = getOption(options, "withTrimXDomain", true);
        withUpdateXAxis = getOption(options, "withUpdateXAxis", withUpdateXDomain);
        withLegend = getOption(options, "withLegend", false);
        withEventRect = getOption(options, "withEventRect", true);
        withDimension = getOption(options, "withDimension", true);
        withTransitionForExit = getOption(options, "withTransitionForExit", withTransition);
        withTransitionForAxis = getOption(options, "withTransitionForAxis", withTransition);
        duration = withTransition ? config.transition_duration : 0;
        durationForExit = withTransitionForExit ? duration : 0;
        durationForAxis = withTransitionForAxis ? duration : 0;
        transitions = transitions || $$.axis.generateTransitions(durationForAxis);
        // update legend and transform each g
        if (withLegend && config.legend_show) $$.updateLegend($$.mapToIds($$.data.targets), options, transitions);
        else if (withDimension) // need to update dimension (e.g. axis.y.tick.values) because y tick values should change
        // no need to update axis in it because they will be updated in redraw()
        $$.updateDimension(true);
        // MEMO: needed for grids calculation
        if ($$.isCategorized() && targetsToShow.length === 0) $$.x.domain([
            0,
            $$.axes.x.selectAll(".tick").size()
        ]);
        if (targetsToShow.length) {
            $$.updateXDomain(targetsToShow, withUpdateXDomain, withUpdateOrgXDomain, withTrimXDomain);
            if (!config.axis_x_tick_values) tickValues = $$.axis.updateXAxisTickValues(targetsToShow);
        } else {
            $$.xAxis.tickValues([]);
            $$.subXAxis.tickValues([]);
        }
        if (config.zoom_rescale && !options.flow) xDomainForZoom = $$.x.orgDomain();
        $$.y.domain($$.getYDomain(targetsToShow, "y", xDomainForZoom));
        $$.y2.domain($$.getYDomain(targetsToShow, "y2", xDomainForZoom));
        if (!config.axis_y_tick_values && config.axis_y_tick_count) $$.yAxis.tickValues($$.axis.generateTickValues($$.y.domain(), config.axis_y_tick_count));
        if (!config.axis_y2_tick_values && config.axis_y2_tick_count) $$.y2Axis.tickValues($$.axis.generateTickValues($$.y2.domain(), config.axis_y2_tick_count));
        // axes
        $$.axis.redraw(durationForAxis, hideAxis);
        // Update axis label
        $$.axis.updateLabels(withTransition);
        // show/hide if manual culling needed
        if ((withUpdateXDomain || withUpdateXAxis) && targetsToShow.length) {
            if (config.axis_x_tick_culling && tickValues) {
                for(i = 1; i < tickValues.length; i++)if (tickValues.length / i < config.axis_x_tick_culling_max) {
                    intervalForCulling = i;
                    break;
                }
                $$.svg.selectAll("." + CLASS.axisX + " .tick text").each(function(e) {
                    var index = tickValues.indexOf(e);
                    if (index >= 0) d3.select(this).style("display", index % intervalForCulling ? "none" : "block");
                });
            } else $$.svg.selectAll("." + CLASS.axisX + " .tick text").style("display", "block");
        }
        // setup drawer - MEMO: these must be called after axis updated
        drawArea = $$.generateDrawArea ? $$.generateDrawArea(areaIndices, false) : undefined;
        drawBar = $$.generateDrawBar ? $$.generateDrawBar(barIndices) : undefined;
        drawLine = $$.generateDrawLine ? $$.generateDrawLine(lineIndices, false) : undefined;
        xForText = $$.generateXYForText(areaIndices, barIndices, lineIndices, true);
        yForText = $$.generateXYForText(areaIndices, barIndices, lineIndices, false);
        // update circleY based on updated parameters
        $$.updateCircleY();
        // generate circle x/y functions depending on updated params
        cx = ($$.config.axis_rotated ? $$.circleY : $$.circleX).bind($$);
        cy = ($$.config.axis_rotated ? $$.circleX : $$.circleY).bind($$);
        // Update sub domain
        if (withY) {
            $$.subY.domain($$.getYDomain(targetsToShow, "y"));
            $$.subY2.domain($$.getYDomain(targetsToShow, "y2"));
        }
        // xgrid focus
        $$.updateXgridFocus();
        // Data empty label positioning and text.
        main.select("text." + CLASS.text + "." + CLASS.empty).attr("x", $$.width / 2).attr("y", $$.height / 2).text(config.data_empty_label_text).transition().style("opacity", targetsToShow.length ? 0 : 1);
        // event rect
        if (withEventRect) $$.redrawEventRect();
        // grid
        $$.updateGrid(duration);
        $$.updateStanfordElements(duration);
        // rect for regions
        $$.updateRegion(duration);
        // bars
        $$.updateBar(durationForExit);
        // lines, areas and circles
        $$.updateLine(durationForExit);
        $$.updateArea(durationForExit);
        $$.updateCircle(cx, cy);
        // text
        if ($$.hasDataLabel()) $$.updateText(xForText, yForText, durationForExit);
        // title
        if ($$.redrawTitle) $$.redrawTitle();
        // arc
        if ($$.redrawArc) $$.redrawArc(duration, durationForExit, withTransform);
        // subchart
        if (config.subchart_show && $$.redrawSubchart) $$.redrawSubchart(withSubchart, transitions, duration, durationForExit, areaIndices, barIndices, lineIndices);
        if ($$.isStanfordGraphType()) $$.drawColorScale();
        // circles for select
        main.selectAll("." + CLASS.selectedCircles).filter($$.isBarType.bind($$)).selectAll("circle").remove();
        if (options.flow) flow = $$.generateFlow({
            targets: targetsToShow,
            flow: options.flow,
            duration: options.flow.duration,
            drawBar: drawBar,
            drawLine: drawLine,
            drawArea: drawArea,
            cx: cx,
            cy: cy,
            xv: xv,
            xForText: xForText,
            yForText: yForText
        });
        if (duration && $$.isTabVisible()) {
            // Only use transition if tab visible. See #938.
            // transition should be derived from one transition
            transition = d3.transition().duration(duration);
            transitionsToWait = [];
            [
                $$.redrawBar(drawBar, true, transition),
                $$.redrawLine(drawLine, true, transition),
                $$.redrawArea(drawArea, true, transition),
                $$.redrawCircle(cx, cy, true, transition),
                $$.redrawText(xForText, yForText, options.flow, true, transition),
                $$.redrawRegion(true, transition),
                $$.redrawGrid(true, transition)
            ].forEach(function(transitions) {
                transitions.forEach(function(transition) {
                    transitionsToWait.push(transition);
                });
            });
            // Wait for end of transitions to call flow and onrendered callback
            waitForDraw = $$.generateWait();
            transitionsToWait.forEach(function(t) {
                waitForDraw.add(t);
            });
            waitForDraw(function() {
                if (flow) flow();
                if (config.onrendered) config.onrendered.call($$);
            });
        } else {
            $$.redrawBar(drawBar);
            $$.redrawLine(drawLine);
            $$.redrawArea(drawArea);
            $$.redrawCircle(cx, cy);
            $$.redrawText(xForText, yForText, options.flow);
            $$.redrawRegion();
            $$.redrawGrid();
            if (flow) flow();
            if (config.onrendered) config.onrendered.call($$);
        }
        // update fadein condition
        $$.mapToIds($$.data.targets).forEach(function(id) {
            $$.withoutFadeIn[id] = true;
        });
    };
    ChartInternal.prototype.updateAndRedraw = function(options) {
        var $$ = this, config = $$.config, transitions;
        options = options || {};
        // same with redraw
        options.withTransition = getOption(options, "withTransition", true);
        options.withTransform = getOption(options, "withTransform", false);
        options.withLegend = getOption(options, "withLegend", false);
        // NOT same with redraw
        options.withUpdateXDomain = getOption(options, "withUpdateXDomain", true);
        options.withUpdateOrgXDomain = getOption(options, "withUpdateOrgXDomain", true);
        options.withTransitionForExit = false;
        options.withTransitionForTransform = getOption(options, "withTransitionForTransform", options.withTransition);
        // MEMO: this needs to be called before updateLegend and it means this ALWAYS needs to be called)
        $$.updateSizes();
        // MEMO: called in updateLegend in redraw if withLegend
        if (!(options.withLegend && config.legend_show)) {
            transitions = $$.axis.generateTransitions(options.withTransitionForAxis ? config.transition_duration : 0);
            // Update scales
            $$.updateScales();
            $$.updateSvgSize();
            // Update g positions
            $$.transformAll(options.withTransitionForTransform, transitions);
        }
        // Draw with new sizes & scales
        $$.redraw(options, transitions);
    };
    ChartInternal.prototype.redrawWithoutRescale = function() {
        this.redraw({
            withY: false,
            withSubchart: false,
            withEventRect: false,
            withTransitionForAxis: false
        });
    };
    ChartInternal.prototype.isTimeSeries = function() {
        return this.config.axis_x_type === "timeseries";
    };
    ChartInternal.prototype.isCategorized = function() {
        return this.config.axis_x_type.indexOf("categor") >= 0;
    };
    ChartInternal.prototype.isCustomX = function() {
        var $$ = this, config = $$.config;
        return !$$.isTimeSeries() && (config.data_x || notEmpty(config.data_xs));
    };
    ChartInternal.prototype.isTimeSeriesY = function() {
        return this.config.axis_y_type === "timeseries";
    };
    ChartInternal.prototype.getTranslate = function(target) {
        var $$ = this, config = $$.config, x, y;
        if (target === "main") {
            x = asHalfPixel($$.margin.left);
            y = asHalfPixel($$.margin.top);
        } else if (target === "context") {
            x = asHalfPixel($$.margin2.left);
            y = asHalfPixel($$.margin2.top);
        } else if (target === "legend") {
            x = $$.margin3.left;
            y = $$.margin3.top;
        } else if (target === "x") {
            x = 0;
            y = config.axis_rotated ? 0 : $$.height;
        } else if (target === "y") {
            x = 0;
            y = config.axis_rotated ? $$.height : 0;
        } else if (target === "y2") {
            x = config.axis_rotated ? 0 : $$.width;
            y = config.axis_rotated ? 1 : 0;
        } else if (target === "subx") {
            x = 0;
            y = config.axis_rotated ? 0 : $$.height2;
        } else if (target === "arc") {
            x = $$.arcWidth / 2;
            y = $$.arcHeight / 2 - ($$.hasType("gauge") ? 6 : 0); // to prevent wrong display of min and max label
        }
        return "translate(" + x + "," + y + ")";
    };
    ChartInternal.prototype.initialOpacity = function(d) {
        return d.value !== null && this.withoutFadeIn[d.id] ? 1 : 0;
    };
    ChartInternal.prototype.initialOpacityForCircle = function(d) {
        return d.value !== null && this.withoutFadeIn[d.id] ? this.opacityForCircle(d) : 0;
    };
    ChartInternal.prototype.opacityForCircle = function(d) {
        var isPointShouldBeShown = isFunction(this.config.point_show) ? this.config.point_show(d) : this.config.point_show;
        var opacity = isPointShouldBeShown || this.isStanfordType(d) ? 1 : 0;
        return isValue(d.value) ? this.isScatterType(d) ? 0.5 : opacity : 0;
    };
    ChartInternal.prototype.opacityForText = function() {
        return this.hasDataLabel() ? 1 : 0;
    };
    ChartInternal.prototype.xx = function(d) {
        return d ? this.x(d.x) : null;
    };
    ChartInternal.prototype.xvCustom = function(d, xyValue) {
        var $$ = this, value = xyValue ? d[xyValue] : d.value;
        if ($$.isTimeSeries()) value = $$.parseDate(d.value);
        else if ($$.isCategorized() && typeof d.value === "string") value = $$.config.axis_x_categories.indexOf(d.value);
        return Math.ceil($$.x(value));
    };
    ChartInternal.prototype.yvCustom = function(d, xyValue) {
        var $$ = this, yScale = d.axis && d.axis === "y2" ? $$.y2 : $$.y, value = xyValue ? d[xyValue] : d.value;
        return Math.ceil(yScale(value));
    };
    ChartInternal.prototype.xv = function(d) {
        var $$ = this, value = d.value;
        if ($$.isTimeSeries()) value = $$.parseDate(d.value);
        else if ($$.isCategorized() && typeof d.value === "string") value = $$.config.axis_x_categories.indexOf(d.value);
        return Math.ceil($$.x(value));
    };
    ChartInternal.prototype.yv = function(d) {
        var $$ = this, yScale = d.axis && d.axis === "y2" ? $$.y2 : $$.y;
        return Math.ceil(yScale(d.value));
    };
    ChartInternal.prototype.subxx = function(d) {
        return d ? this.subX(d.x) : null;
    };
    ChartInternal.prototype.transformMain = function(withTransition, transitions) {
        var $$ = this, xAxis, yAxis, y2Axis;
        if (transitions && transitions.axisX) xAxis = transitions.axisX;
        else {
            xAxis = $$.main.select("." + CLASS.axisX);
            if (withTransition) xAxis = xAxis.transition();
        }
        if (transitions && transitions.axisY) yAxis = transitions.axisY;
        else {
            yAxis = $$.main.select("." + CLASS.axisY);
            if (withTransition) yAxis = yAxis.transition();
        }
        if (transitions && transitions.axisY2) y2Axis = transitions.axisY2;
        else {
            y2Axis = $$.main.select("." + CLASS.axisY2);
            if (withTransition) y2Axis = y2Axis.transition();
        }
        (withTransition ? $$.main.transition() : $$.main).attr("transform", $$.getTranslate("main"));
        xAxis.attr("transform", $$.getTranslate("x"));
        yAxis.attr("transform", $$.getTranslate("y"));
        y2Axis.attr("transform", $$.getTranslate("y2"));
        $$.main.select("." + CLASS.chartArcs).attr("transform", $$.getTranslate("arc"));
    };
    ChartInternal.prototype.transformAll = function(withTransition, transitions) {
        var $$ = this;
        $$.transformMain(withTransition, transitions);
        if ($$.config.subchart_show) $$.transformContext(withTransition, transitions);
        if ($$.legend) $$.transformLegend(withTransition);
    };
    ChartInternal.prototype.updateSvgSize = function() {
        var $$ = this, brush = $$.svg.select("." + CLASS.brush + " .overlay");
        $$.svg.attr("width", $$.currentWidth).attr("height", $$.currentHeight);
        $$.svg.selectAll([
            "#" + $$.clipId,
            "#" + $$.clipIdForGrid
        ]).select("rect").attr("width", $$.width).attr("height", $$.height);
        $$.svg.select("#" + $$.clipIdForXAxis).select("rect").attr("x", $$.getXAxisClipX.bind($$)).attr("y", $$.getXAxisClipY.bind($$)).attr("width", $$.getXAxisClipWidth.bind($$)).attr("height", $$.getXAxisClipHeight.bind($$));
        $$.svg.select("#" + $$.clipIdForYAxis).select("rect").attr("x", $$.getYAxisClipX.bind($$)).attr("y", $$.getYAxisClipY.bind($$)).attr("width", $$.getYAxisClipWidth.bind($$)).attr("height", $$.getYAxisClipHeight.bind($$));
        $$.svg.select("#" + $$.clipIdForSubchart).select("rect").attr("width", $$.width).attr("height", brush.size() && brush.attr("height") || 0);
        // MEMO: parent div's height will be bigger than svg when <!DOCTYPE html>
        $$.selectChart.style("max-height", $$.currentHeight + "px");
    };
    ChartInternal.prototype.updateDimension = function(withoutAxis) {
        var $$ = this;
        if (!withoutAxis) {
            if ($$.config.axis_rotated) {
                $$.axes.x.call($$.xAxis);
                $$.axes.subx.call($$.subXAxis);
            } else {
                $$.axes.y.call($$.yAxis);
                $$.axes.y2.call($$.y2Axis);
            }
        }
        $$.updateSizes();
        $$.updateScales();
        $$.updateSvgSize();
        $$.transformAll(false);
    };
    ChartInternal.prototype.observeInserted = function(selection) {
        var $$ = this, observer;
        if (typeof MutationObserver === "undefined") {
            window.console.error("MutationObserver not defined.");
            return;
        }
        observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === "childList" && mutation.previousSibling) {
                    observer.disconnect();
                    // need to wait for completion of load because size calculation requires the actual sizes determined after that completion
                    $$.intervalForObserveInserted = window.setInterval(function() {
                        // parentNode will NOT be null when completed
                        if (selection.node().parentNode) {
                            window.clearInterval($$.intervalForObserveInserted);
                            $$.updateDimension();
                            if ($$.brush) $$.brush.update();
                            $$.config.oninit.call($$);
                            $$.redraw({
                                withTransform: true,
                                withUpdateXDomain: true,
                                withUpdateOrgXDomain: true,
                                withTransition: false,
                                withTransitionForTransform: false,
                                withLegend: true
                            });
                            selection.transition().style("opacity", 1);
                        }
                    }, 10);
                }
            });
        });
        observer.observe(selection.node(), {
            attributes: true,
            childList: true,
            characterData: true
        });
    };
    /**
   * Binds handlers to the window resize event.
   */ ChartInternal.prototype.bindResize = function() {
        var $$ = this, config = $$.config;
        $$.resizeFunction = $$.generateResize(); // need to call .remove
        $$.resizeFunction.add(function() {
            config.onresize.call($$);
        });
        if (config.resize_auto) $$.resizeFunction.add(function() {
            if ($$.resizeTimeout !== undefined) window.clearTimeout($$.resizeTimeout);
            $$.resizeTimeout = window.setTimeout(function() {
                delete $$.resizeTimeout;
                $$.updateAndRedraw({
                    withUpdateXDomain: false,
                    withUpdateOrgXDomain: false,
                    withTransition: false,
                    withTransitionForTransform: false,
                    withLegend: true
                });
                if ($$.brush) $$.brush.update();
            }, 100);
        });
        $$.resizeFunction.add(function() {
            config.onresized.call($$);
        });
        $$.resizeIfElementDisplayed = function() {
            // if element not displayed skip it
            if ($$.api == null || !$$.api.element.offsetParent) return;
            $$.resizeFunction();
        };
        window.addEventListener("resize", $$.resizeIfElementDisplayed, false);
    };
    /**
   * Binds handlers to the window focus event.
   */ ChartInternal.prototype.bindWindowFocus = function() {
        var _this = this;
        if (this.windowFocusHandler) // The handler is already set
        return;
        this.windowFocusHandler = function() {
            _this.redraw();
        };
        window.addEventListener("focus", this.windowFocusHandler);
    };
    /**
   * Unbinds from the window focus event.
   */ ChartInternal.prototype.unbindWindowFocus = function() {
        window.removeEventListener("focus", this.windowFocusHandler);
        delete this.windowFocusHandler;
    };
    ChartInternal.prototype.generateResize = function() {
        var resizeFunctions = [];
        function callResizeFunctions() {
            resizeFunctions.forEach(function(f) {
                f();
            });
        }
        callResizeFunctions.add = function(f) {
            resizeFunctions.push(f);
        };
        callResizeFunctions.remove = function(f) {
            for(var i = 0; i < resizeFunctions.length; i++)if (resizeFunctions[i] === f) {
                resizeFunctions.splice(i, 1);
                break;
            }
        };
        return callResizeFunctions;
    };
    ChartInternal.prototype.endall = function(transition, callback) {
        var n = 0;
        transition.each(function() {
            ++n;
        }).on("end", function() {
            if (!--n) callback.apply(this, arguments);
        });
    };
    ChartInternal.prototype.generateWait = function() {
        var $$ = this;
        var transitionsToWait = [], f = function(callback) {
            var timer = setInterval(function() {
                if (!$$.isTabVisible()) return;
                var done = 0;
                transitionsToWait.forEach(function(t) {
                    if (t.empty()) {
                        done += 1;
                        return;
                    }
                    try {
                        t.transition();
                    } catch (e) {
                        done += 1;
                    }
                });
                if (done === transitionsToWait.length) {
                    clearInterval(timer);
                    if (callback) callback();
                }
            }, 50);
        };
        f.add = function(transition) {
            transitionsToWait.push(transition);
        };
        return f;
    };
    ChartInternal.prototype.parseDate = function(date) {
        var $$ = this, parsedDate;
        if (date instanceof Date) parsedDate = date;
        else if (typeof date === "string") parsedDate = $$.dataTimeParse(date);
        else if (typeof date === "object") parsedDate = new Date(+date);
        else if (typeof date === "number" && !isNaN(date)) parsedDate = new Date(+date);
        if (!parsedDate || isNaN(+parsedDate)) window.console.error("Failed to parse x '" + date + "' to Date object");
        return parsedDate;
    };
    ChartInternal.prototype.isTabVisible = function() {
        return !document.hidden;
    };
    ChartInternal.prototype.getPathBox = getPathBox;
    ChartInternal.prototype.CLASS = CLASS;
    /* jshint ignore:start */ (function() {
        if (!("SVGPathSeg" in window)) {
            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathSeg
            window.SVGPathSeg = function(type, typeAsLetter, owningPathSegList) {
                this.pathSegType = type;
                this.pathSegTypeAsLetter = typeAsLetter;
                this._owningPathSegList = owningPathSegList;
            };
            window.SVGPathSeg.prototype.classname = "SVGPathSeg";
            window.SVGPathSeg.PATHSEG_UNKNOWN = 0;
            window.SVGPathSeg.PATHSEG_CLOSEPATH = 1;
            window.SVGPathSeg.PATHSEG_MOVETO_ABS = 2;
            window.SVGPathSeg.PATHSEG_MOVETO_REL = 3;
            window.SVGPathSeg.PATHSEG_LINETO_ABS = 4;
            window.SVGPathSeg.PATHSEG_LINETO_REL = 5;
            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS = 6;
            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL = 7;
            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS = 8;
            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL = 9;
            window.SVGPathSeg.PATHSEG_ARC_ABS = 10;
            window.SVGPathSeg.PATHSEG_ARC_REL = 11;
            window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS = 12;
            window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL = 13;
            window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS = 14;
            window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL = 15;
            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS = 16;
            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL = 17;
            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS = 18;
            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL = 19;
            // Notify owning PathSegList on any changes so they can be synchronized back to the path element.
            window.SVGPathSeg.prototype._segmentChanged = function() {
                if (this._owningPathSegList) this._owningPathSegList.segmentChanged(this);
            };
            window.SVGPathSegClosePath = function(owningPathSegList) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CLOSEPATH, "z", owningPathSegList);
            };
            window.SVGPathSegClosePath.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegClosePath.prototype.toString = function() {
                return "[object SVGPathSegClosePath]";
            };
            window.SVGPathSegClosePath.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter;
            };
            window.SVGPathSegClosePath.prototype.clone = function() {
                return new window.SVGPathSegClosePath(undefined);
            };
            window.SVGPathSegMovetoAbs = function(owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_ABS, "M", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegMovetoAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegMovetoAbs.prototype.toString = function() {
                return "[object SVGPathSegMovetoAbs]";
            };
            window.SVGPathSegMovetoAbs.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
            };
            window.SVGPathSegMovetoAbs.prototype.clone = function() {
                return new window.SVGPathSegMovetoAbs(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegMovetoRel = function(owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_REL, "m", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegMovetoRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegMovetoRel.prototype.toString = function() {
                return "[object SVGPathSegMovetoRel]";
            };
            window.SVGPathSegMovetoRel.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
            };
            window.SVGPathSegMovetoRel.prototype.clone = function() {
                return new window.SVGPathSegMovetoRel(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegLinetoAbs = function(owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_ABS, "L", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegLinetoAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoAbs.prototype.toString = function() {
                return "[object SVGPathSegLinetoAbs]";
            };
            window.SVGPathSegLinetoAbs.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
            };
            window.SVGPathSegLinetoAbs.prototype.clone = function() {
                return new window.SVGPathSegLinetoAbs(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegLinetoRel = function(owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_REL, "l", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegLinetoRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoRel.prototype.toString = function() {
                return "[object SVGPathSegLinetoRel]";
            };
            window.SVGPathSegLinetoRel.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
            };
            window.SVGPathSegLinetoRel.prototype.clone = function() {
                return new window.SVGPathSegLinetoRel(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegCurvetoCubicAbs = function(owningPathSegList, x, y, x1, y1, x2, y2) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS, "C", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x1 = x1;
                this._y1 = y1;
                this._x2 = x2;
                this._y2 = y2;
            };
            window.SVGPathSegCurvetoCubicAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoCubicAbs.prototype.toString = function() {
                return "[object SVGPathSegCurvetoCubicAbs]";
            };
            window.SVGPathSegCurvetoCubicAbs.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
            };
            window.SVGPathSegCurvetoCubicAbs.prototype.clone = function() {
                return new window.SVGPathSegCurvetoCubicAbs(undefined, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
            };
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x1", {
                get: function() {
                    return this._x1;
                },
                set: function(x1) {
                    this._x1 = x1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y1", {
                get: function() {
                    return this._y1;
                },
                set: function(y1) {
                    this._y1 = y1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x2", {
                get: function() {
                    return this._x2;
                },
                set: function(x2) {
                    this._x2 = x2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y2", {
                get: function() {
                    return this._y2;
                },
                set: function(y2) {
                    this._y2 = y2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegCurvetoCubicRel = function(owningPathSegList, x, y, x1, y1, x2, y2) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL, "c", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x1 = x1;
                this._y1 = y1;
                this._x2 = x2;
                this._y2 = y2;
            };
            window.SVGPathSegCurvetoCubicRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoCubicRel.prototype.toString = function() {
                return "[object SVGPathSegCurvetoCubicRel]";
            };
            window.SVGPathSegCurvetoCubicRel.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
            };
            window.SVGPathSegCurvetoCubicRel.prototype.clone = function() {
                return new window.SVGPathSegCurvetoCubicRel(undefined, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
            };
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x1", {
                get: function() {
                    return this._x1;
                },
                set: function(x1) {
                    this._x1 = x1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y1", {
                get: function() {
                    return this._y1;
                },
                set: function(y1) {
                    this._y1 = y1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x2", {
                get: function() {
                    return this._x2;
                },
                set: function(x2) {
                    this._x2 = x2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y2", {
                get: function() {
                    return this._y2;
                },
                set: function(y2) {
                    this._y2 = y2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegCurvetoQuadraticAbs = function(owningPathSegList, x, y, x1, y1) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS, "Q", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x1 = x1;
                this._y1 = y1;
            };
            window.SVGPathSegCurvetoQuadraticAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoQuadraticAbs.prototype.toString = function() {
                return "[object SVGPathSegCurvetoQuadraticAbs]";
            };
            window.SVGPathSegCurvetoQuadraticAbs.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y;
            };
            window.SVGPathSegCurvetoQuadraticAbs.prototype.clone = function() {
                return new window.SVGPathSegCurvetoQuadraticAbs(undefined, this._x, this._y, this._x1, this._y1);
            };
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x1", {
                get: function() {
                    return this._x1;
                },
                set: function(x1) {
                    this._x1 = x1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y1", {
                get: function() {
                    return this._y1;
                },
                set: function(y1) {
                    this._y1 = y1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegCurvetoQuadraticRel = function(owningPathSegList, x, y, x1, y1) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL, "q", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x1 = x1;
                this._y1 = y1;
            };
            window.SVGPathSegCurvetoQuadraticRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoQuadraticRel.prototype.toString = function() {
                return "[object SVGPathSegCurvetoQuadraticRel]";
            };
            window.SVGPathSegCurvetoQuadraticRel.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y;
            };
            window.SVGPathSegCurvetoQuadraticRel.prototype.clone = function() {
                return new window.SVGPathSegCurvetoQuadraticRel(undefined, this._x, this._y, this._x1, this._y1);
            };
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x1", {
                get: function() {
                    return this._x1;
                },
                set: function(x1) {
                    this._x1 = x1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y1", {
                get: function() {
                    return this._y1;
                },
                set: function(y1) {
                    this._y1 = y1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegArcAbs = function(owningPathSegList, x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_ABS, "A", owningPathSegList);
                this._x = x;
                this._y = y;
                this._r1 = r1;
                this._r2 = r2;
                this._angle = angle;
                this._largeArcFlag = largeArcFlag;
                this._sweepFlag = sweepFlag;
            };
            window.SVGPathSegArcAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegArcAbs.prototype.toString = function() {
                return "[object SVGPathSegArcAbs]";
            };
            window.SVGPathSegArcAbs.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y;
            };
            window.SVGPathSegArcAbs.prototype.clone = function() {
                return new window.SVGPathSegArcAbs(undefined, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
            };
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r1", {
                get: function() {
                    return this._r1;
                },
                set: function(r1) {
                    this._r1 = r1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r2", {
                get: function() {
                    return this._r2;
                },
                set: function(r2) {
                    this._r2 = r2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "angle", {
                get: function() {
                    return this._angle;
                },
                set: function(angle) {
                    this._angle = angle;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "largeArcFlag", {
                get: function() {
                    return this._largeArcFlag;
                },
                set: function(largeArcFlag) {
                    this._largeArcFlag = largeArcFlag;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "sweepFlag", {
                get: function() {
                    return this._sweepFlag;
                },
                set: function(sweepFlag) {
                    this._sweepFlag = sweepFlag;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegArcRel = function(owningPathSegList, x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_REL, "a", owningPathSegList);
                this._x = x;
                this._y = y;
                this._r1 = r1;
                this._r2 = r2;
                this._angle = angle;
                this._largeArcFlag = largeArcFlag;
                this._sweepFlag = sweepFlag;
            };
            window.SVGPathSegArcRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegArcRel.prototype.toString = function() {
                return "[object SVGPathSegArcRel]";
            };
            window.SVGPathSegArcRel.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y;
            };
            window.SVGPathSegArcRel.prototype.clone = function() {
                return new window.SVGPathSegArcRel(undefined, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
            };
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "r1", {
                get: function() {
                    return this._r1;
                },
                set: function(r1) {
                    this._r1 = r1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "r2", {
                get: function() {
                    return this._r2;
                },
                set: function(r2) {
                    this._r2 = r2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "angle", {
                get: function() {
                    return this._angle;
                },
                set: function(angle) {
                    this._angle = angle;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "largeArcFlag", {
                get: function() {
                    return this._largeArcFlag;
                },
                set: function(largeArcFlag) {
                    this._largeArcFlag = largeArcFlag;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "sweepFlag", {
                get: function() {
                    return this._sweepFlag;
                },
                set: function(sweepFlag) {
                    this._sweepFlag = sweepFlag;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegLinetoHorizontalAbs = function(owningPathSegList, x) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS, "H", owningPathSegList);
                this._x = x;
            };
            window.SVGPathSegLinetoHorizontalAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoHorizontalAbs.prototype.toString = function() {
                return "[object SVGPathSegLinetoHorizontalAbs]";
            };
            window.SVGPathSegLinetoHorizontalAbs.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._x;
            };
            window.SVGPathSegLinetoHorizontalAbs.prototype.clone = function() {
                return new window.SVGPathSegLinetoHorizontalAbs(undefined, this._x);
            };
            Object.defineProperty(window.SVGPathSegLinetoHorizontalAbs.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegLinetoHorizontalRel = function(owningPathSegList, x) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL, "h", owningPathSegList);
                this._x = x;
            };
            window.SVGPathSegLinetoHorizontalRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoHorizontalRel.prototype.toString = function() {
                return "[object SVGPathSegLinetoHorizontalRel]";
            };
            window.SVGPathSegLinetoHorizontalRel.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._x;
            };
            window.SVGPathSegLinetoHorizontalRel.prototype.clone = function() {
                return new window.SVGPathSegLinetoHorizontalRel(undefined, this._x);
            };
            Object.defineProperty(window.SVGPathSegLinetoHorizontalRel.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegLinetoVerticalAbs = function(owningPathSegList, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS, "V", owningPathSegList);
                this._y = y;
            };
            window.SVGPathSegLinetoVerticalAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoVerticalAbs.prototype.toString = function() {
                return "[object SVGPathSegLinetoVerticalAbs]";
            };
            window.SVGPathSegLinetoVerticalAbs.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._y;
            };
            window.SVGPathSegLinetoVerticalAbs.prototype.clone = function() {
                return new window.SVGPathSegLinetoVerticalAbs(undefined, this._y);
            };
            Object.defineProperty(window.SVGPathSegLinetoVerticalAbs.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegLinetoVerticalRel = function(owningPathSegList, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL, "v", owningPathSegList);
                this._y = y;
            };
            window.SVGPathSegLinetoVerticalRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoVerticalRel.prototype.toString = function() {
                return "[object SVGPathSegLinetoVerticalRel]";
            };
            window.SVGPathSegLinetoVerticalRel.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._y;
            };
            window.SVGPathSegLinetoVerticalRel.prototype.clone = function() {
                return new window.SVGPathSegLinetoVerticalRel(undefined, this._y);
            };
            Object.defineProperty(window.SVGPathSegLinetoVerticalRel.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegCurvetoCubicSmoothAbs = function(owningPathSegList, x, y, x2, y2) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS, "S", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x2 = x2;
                this._y2 = y2;
            };
            window.SVGPathSegCurvetoCubicSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoCubicSmoothAbs.prototype.toString = function() {
                return "[object SVGPathSegCurvetoCubicSmoothAbs]";
            };
            window.SVGPathSegCurvetoCubicSmoothAbs.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
            };
            window.SVGPathSegCurvetoCubicSmoothAbs.prototype.clone = function() {
                return new window.SVGPathSegCurvetoCubicSmoothAbs(undefined, this._x, this._y, this._x2, this._y2);
            };
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x2", {
                get: function() {
                    return this._x2;
                },
                set: function(x2) {
                    this._x2 = x2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y2", {
                get: function() {
                    return this._y2;
                },
                set: function(y2) {
                    this._y2 = y2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegCurvetoCubicSmoothRel = function(owningPathSegList, x, y, x2, y2) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL, "s", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x2 = x2;
                this._y2 = y2;
            };
            window.SVGPathSegCurvetoCubicSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoCubicSmoothRel.prototype.toString = function() {
                return "[object SVGPathSegCurvetoCubicSmoothRel]";
            };
            window.SVGPathSegCurvetoCubicSmoothRel.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
            };
            window.SVGPathSegCurvetoCubicSmoothRel.prototype.clone = function() {
                return new window.SVGPathSegCurvetoCubicSmoothRel(undefined, this._x, this._y, this._x2, this._y2);
            };
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x2", {
                get: function() {
                    return this._x2;
                },
                set: function(x2) {
                    this._x2 = x2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y2", {
                get: function() {
                    return this._y2;
                },
                set: function(y2) {
                    this._y2 = y2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegCurvetoQuadraticSmoothAbs = function(owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS, "T", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.toString = function() {
                return "[object SVGPathSegCurvetoQuadraticSmoothAbs]";
            };
            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
            };
            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.clone = function() {
                return new window.SVGPathSegCurvetoQuadraticSmoothAbs(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegCurvetoQuadraticSmoothRel = function(owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL, "t", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.toString = function() {
                return "[object SVGPathSegCurvetoQuadraticSmoothRel]";
            };
            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
            };
            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.clone = function() {
                return new window.SVGPathSegCurvetoQuadraticSmoothRel(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            // Add createSVGPathSeg* functions to window.SVGPathElement.
            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-Interfacewindow.SVGPathElement.
            window.SVGPathElement.prototype.createSVGPathSegClosePath = function() {
                return new window.SVGPathSegClosePath(undefined);
            };
            window.SVGPathElement.prototype.createSVGPathSegMovetoAbs = function(x, y) {
                return new window.SVGPathSegMovetoAbs(undefined, x, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegMovetoRel = function(x, y) {
                return new window.SVGPathSegMovetoRel(undefined, x, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoAbs = function(x, y) {
                return new window.SVGPathSegLinetoAbs(undefined, x, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoRel = function(x, y) {
                return new window.SVGPathSegLinetoRel(undefined, x, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicAbs = function(x, y, x1, y1, x2, y2) {
                return new window.SVGPathSegCurvetoCubicAbs(undefined, x, y, x1, y1, x2, y2);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicRel = function(x, y, x1, y1, x2, y2) {
                return new window.SVGPathSegCurvetoCubicRel(undefined, x, y, x1, y1, x2, y2);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticAbs = function(x, y, x1, y1) {
                return new window.SVGPathSegCurvetoQuadraticAbs(undefined, x, y, x1, y1);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticRel = function(x, y, x1, y1) {
                return new window.SVGPathSegCurvetoQuadraticRel(undefined, x, y, x1, y1);
            };
            window.SVGPathElement.prototype.createSVGPathSegArcAbs = function(x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
                return new window.SVGPathSegArcAbs(undefined, x, y, r1, r2, angle, largeArcFlag, sweepFlag);
            };
            window.SVGPathElement.prototype.createSVGPathSegArcRel = function(x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
                return new window.SVGPathSegArcRel(undefined, x, y, r1, r2, angle, largeArcFlag, sweepFlag);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalAbs = function(x) {
                return new window.SVGPathSegLinetoHorizontalAbs(undefined, x);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalRel = function(x) {
                return new window.SVGPathSegLinetoHorizontalRel(undefined, x);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalAbs = function(y) {
                return new window.SVGPathSegLinetoVerticalAbs(undefined, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalRel = function(y) {
                return new window.SVGPathSegLinetoVerticalRel(undefined, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothAbs = function(x, y, x2, y2) {
                return new window.SVGPathSegCurvetoCubicSmoothAbs(undefined, x, y, x2, y2);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothRel = function(x, y, x2, y2) {
                return new window.SVGPathSegCurvetoCubicSmoothRel(undefined, x, y, x2, y2);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothAbs = function(x, y) {
                return new window.SVGPathSegCurvetoQuadraticSmoothAbs(undefined, x, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothRel = function(x, y) {
                return new window.SVGPathSegCurvetoQuadraticSmoothRel(undefined, x, y);
            };
            if (!("getPathSegAtLength" in window.SVGPathElement.prototype)) // Add getPathSegAtLength to SVGPathElement.
            // Spec: https://www.w3.org/TR/SVG11/single-page.html#paths-__svg__SVGPathElement__getPathSegAtLength
            // This polyfill requires SVGPathElement.getTotalLength to implement the distance-along-a-path algorithm.
            window.SVGPathElement.prototype.getPathSegAtLength = function(distance) {
                if (distance === undefined || !isFinite(distance)) throw "Invalid arguments.";
                var measurementElement = document.createElementNS("http://www.w3.org/2000/svg", "path");
                measurementElement.setAttribute("d", this.getAttribute("d"));
                var lastPathSegment = measurementElement.pathSegList.numberOfItems - 1;
                // If the path is empty, return 0.
                if (lastPathSegment <= 0) return 0;
                do {
                    measurementElement.pathSegList.removeItem(lastPathSegment);
                    if (distance > measurementElement.getTotalLength()) break;
                    lastPathSegment--;
                }while (lastPathSegment > 0);
                return lastPathSegment;
            };
        }
        if (!("SVGPathSegList" in window)) {
            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathSegList
            window.SVGPathSegList = function(pathElement) {
                this._pathElement = pathElement;
                this._list = this._parsePath(this._pathElement.getAttribute("d"));
                // Use a MutationObserver to catch changes to the path's "d" attribute.
                this._mutationObserverConfig = {
                    attributes: true,
                    attributeFilter: [
                        "d"
                    ]
                };
                this._pathElementMutationObserver = new MutationObserver(this._updateListFromPathMutations.bind(this));
                this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
            };
            window.SVGPathSegList.prototype.classname = "SVGPathSegList";
            Object.defineProperty(window.SVGPathSegList.prototype, "numberOfItems", {
                get: function() {
                    this._checkPathSynchronizedToList();
                    return this._list.length;
                },
                enumerable: true
            });
            // Add the pathSegList accessors to window.SVGPathElement.
            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGAnimatedPathData
            Object.defineProperty(window.SVGPathElement.prototype, "pathSegList", {
                get: function() {
                    if (!this._pathSegList) this._pathSegList = new window.SVGPathSegList(this);
                    return this._pathSegList;
                },
                enumerable: true
            });
            // FIXME: The following are not implemented and simply return window.SVGPathElement.pathSegList.
            Object.defineProperty(window.SVGPathElement.prototype, "normalizedPathSegList", {
                get: function() {
                    return this.pathSegList;
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathElement.prototype, "animatedPathSegList", {
                get: function() {
                    return this.pathSegList;
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathElement.prototype, "animatedNormalizedPathSegList", {
                get: function() {
                    return this.pathSegList;
                },
                enumerable: true
            });
            // Process any pending mutations to the path element and update the list as needed.
            // This should be the first call of all public functions and is needed because
            // MutationObservers are not synchronous so we can have pending asynchronous mutations.
            window.SVGPathSegList.prototype._checkPathSynchronizedToList = function() {
                this._updateListFromPathMutations(this._pathElementMutationObserver.takeRecords());
            };
            window.SVGPathSegList.prototype._updateListFromPathMutations = function(mutationRecords) {
                if (!this._pathElement) return;
                var hasPathMutations = false;
                mutationRecords.forEach(function(record) {
                    if (record.attributeName == "d") hasPathMutations = true;
                });
                if (hasPathMutations) this._list = this._parsePath(this._pathElement.getAttribute("d"));
            };
            // Serialize the list and update the path's 'd' attribute.
            window.SVGPathSegList.prototype._writeListToPath = function() {
                this._pathElementMutationObserver.disconnect();
                this._pathElement.setAttribute("d", window.SVGPathSegList._pathSegArrayAsString(this._list));
                this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
            };
            // When a path segment changes the list needs to be synchronized back to the path element.
            window.SVGPathSegList.prototype.segmentChanged = function(pathSeg) {
                this._writeListToPath();
            };
            window.SVGPathSegList.prototype.clear = function() {
                this._checkPathSynchronizedToList();
                this._list.forEach(function(pathSeg) {
                    pathSeg._owningPathSegList = null;
                });
                this._list = [];
                this._writeListToPath();
            };
            window.SVGPathSegList.prototype.initialize = function(newItem) {
                this._checkPathSynchronizedToList();
                this._list = [
                    newItem
                ];
                newItem._owningPathSegList = this;
                this._writeListToPath();
                return newItem;
            };
            window.SVGPathSegList.prototype._checkValidIndex = function(index) {
                if (isNaN(index) || index < 0 || index >= this.numberOfItems) throw "INDEX_SIZE_ERR";
            };
            window.SVGPathSegList.prototype.getItem = function(index) {
                this._checkPathSynchronizedToList();
                this._checkValidIndex(index);
                return this._list[index];
            };
            window.SVGPathSegList.prototype.insertItemBefore = function(newItem, index) {
                this._checkPathSynchronizedToList();
                // Spec: If the index is greater than or equal to numberOfItems, then the new item is appended to the end of the list.
                if (index > this.numberOfItems) index = this.numberOfItems;
                if (newItem._owningPathSegList) // SVG2 spec says to make a copy.
                newItem = newItem.clone();
                this._list.splice(index, 0, newItem);
                newItem._owningPathSegList = this;
                this._writeListToPath();
                return newItem;
            };
            window.SVGPathSegList.prototype.replaceItem = function(newItem, index) {
                this._checkPathSynchronizedToList();
                if (newItem._owningPathSegList) // SVG2 spec says to make a copy.
                newItem = newItem.clone();
                this._checkValidIndex(index);
                this._list[index] = newItem;
                newItem._owningPathSegList = this;
                this._writeListToPath();
                return newItem;
            };
            window.SVGPathSegList.prototype.removeItem = function(index) {
                this._checkPathSynchronizedToList();
                this._checkValidIndex(index);
                var item = this._list[index];
                this._list.splice(index, 1);
                this._writeListToPath();
                return item;
            };
            window.SVGPathSegList.prototype.appendItem = function(newItem) {
                this._checkPathSynchronizedToList();
                if (newItem._owningPathSegList) // SVG2 spec says to make a copy.
                newItem = newItem.clone();
                this._list.push(newItem);
                newItem._owningPathSegList = this;
                // TODO: Optimize this to just append to the existing attribute.
                this._writeListToPath();
                return newItem;
            };
            window.SVGPathSegList._pathSegArrayAsString = function(pathSegArray) {
                var string = "";
                var first = true;
                pathSegArray.forEach(function(pathSeg) {
                    if (first) {
                        first = false;
                        string += pathSeg._asPathString();
                    } else string += " " + pathSeg._asPathString();
                });
                return string;
            };
            // This closely follows SVGPathParser::parsePath from Source/core/svg/SVGPathParser.cpp.
            window.SVGPathSegList.prototype._parsePath = function(string) {
                if (!string || string.length == 0) return [];
                var owningPathSegList = this;
                var Builder = function() {
                    this.pathSegList = [];
                };
                Builder.prototype.appendSegment = function(pathSeg) {
                    this.pathSegList.push(pathSeg);
                };
                var Source = function(string) {
                    this._string = string;
                    this._currentIndex = 0;
                    this._endIndex = this._string.length;
                    this._previousCommand = window.SVGPathSeg.PATHSEG_UNKNOWN;
                    this._skipOptionalSpaces();
                };
                Source.prototype._isCurrentSpace = function() {
                    var character = this._string[this._currentIndex];
                    return character <= " " && (character == " " || character == "\n" || character == "	" || character == "\r" || character == "\f");
                };
                Source.prototype._skipOptionalSpaces = function() {
                    while(this._currentIndex < this._endIndex && this._isCurrentSpace())this._currentIndex++;
                    return this._currentIndex < this._endIndex;
                };
                Source.prototype._skipOptionalSpacesOrDelimiter = function() {
                    if (this._currentIndex < this._endIndex && !this._isCurrentSpace() && this._string.charAt(this._currentIndex) != ",") return false;
                    if (this._skipOptionalSpaces()) {
                        if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ",") {
                            this._currentIndex++;
                            this._skipOptionalSpaces();
                        }
                    }
                    return this._currentIndex < this._endIndex;
                };
                Source.prototype.hasMoreData = function() {
                    return this._currentIndex < this._endIndex;
                };
                Source.prototype.peekSegmentType = function() {
                    var lookahead = this._string[this._currentIndex];
                    return this._pathSegTypeFromChar(lookahead);
                };
                Source.prototype._pathSegTypeFromChar = function(lookahead) {
                    switch(lookahead){
                        case "Z":
                        case "z":
                            return window.SVGPathSeg.PATHSEG_CLOSEPATH;
                        case "M":
                            return window.SVGPathSeg.PATHSEG_MOVETO_ABS;
                        case "m":
                            return window.SVGPathSeg.PATHSEG_MOVETO_REL;
                        case "L":
                            return window.SVGPathSeg.PATHSEG_LINETO_ABS;
                        case "l":
                            return window.SVGPathSeg.PATHSEG_LINETO_REL;
                        case "C":
                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS;
                        case "c":
                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL;
                        case "Q":
                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS;
                        case "q":
                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL;
                        case "A":
                            return window.SVGPathSeg.PATHSEG_ARC_ABS;
                        case "a":
                            return window.SVGPathSeg.PATHSEG_ARC_REL;
                        case "H":
                            return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS;
                        case "h":
                            return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL;
                        case "V":
                            return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS;
                        case "v":
                            return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL;
                        case "S":
                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS;
                        case "s":
                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL;
                        case "T":
                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS;
                        case "t":
                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL;
                        default:
                            return window.SVGPathSeg.PATHSEG_UNKNOWN;
                    }
                };
                Source.prototype._nextCommandHelper = function(lookahead, previousCommand) {
                    // Check for remaining coordinates in the current command.
                    if ((lookahead == "+" || lookahead == "-" || lookahead == "." || lookahead >= "0" && lookahead <= "9") && previousCommand != window.SVGPathSeg.PATHSEG_CLOSEPATH) {
                        if (previousCommand == window.SVGPathSeg.PATHSEG_MOVETO_ABS) return window.SVGPathSeg.PATHSEG_LINETO_ABS;
                        if (previousCommand == window.SVGPathSeg.PATHSEG_MOVETO_REL) return window.SVGPathSeg.PATHSEG_LINETO_REL;
                        return previousCommand;
                    }
                    return window.SVGPathSeg.PATHSEG_UNKNOWN;
                };
                Source.prototype.initialCommandIsMoveTo = function() {
                    // If the path is empty it is still valid, so return true.
                    if (!this.hasMoreData()) return true;
                    var command = this.peekSegmentType();
                    // Path must start with moveTo.
                    return command == window.SVGPathSeg.PATHSEG_MOVETO_ABS || command == window.SVGPathSeg.PATHSEG_MOVETO_REL;
                };
                // Parse a number from an SVG path. This very closely follows genericParseNumber(...) from Source/core/svg/SVGParserUtilities.cpp.
                // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-PathDataBNF
                Source.prototype._parseNumber = function() {
                    var exponent = 0;
                    var integer = 0;
                    var frac = 1;
                    var decimal = 0;
                    var sign = 1;
                    var expsign = 1;
                    var startIndex = this._currentIndex;
                    this._skipOptionalSpaces();
                    // Read the sign.
                    if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "+") this._currentIndex++;
                    else if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "-") {
                        this._currentIndex++;
                        sign = -1;
                    }
                    if (this._currentIndex == this._endIndex || (this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") && this._string.charAt(this._currentIndex) != ".") // The first character of a number must be one of [0-9+-.].
                    return undefined;
                    // Read the integer part, build right-to-left.
                    var startIntPartIndex = this._currentIndex;
                    while(this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9")this._currentIndex++; // Advance to first non-digit.
                    if (this._currentIndex != startIntPartIndex) {
                        var scanIntPartIndex = this._currentIndex - 1;
                        var multiplier = 1;
                        while(scanIntPartIndex >= startIntPartIndex){
                            integer += multiplier * (this._string.charAt(scanIntPartIndex--) - "0");
                            multiplier *= 10;
                        }
                    }
                    // Read the decimals.
                    if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ".") {
                        this._currentIndex++;
                        // There must be a least one digit following the .
                        if (this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") return undefined;
                        while(this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9"){
                            frac *= 10;
                            decimal += (this._string.charAt(this._currentIndex) - "0") / frac;
                            this._currentIndex += 1;
                        }
                    }
                    // Read the exponent part.
                    if (this._currentIndex != startIndex && this._currentIndex + 1 < this._endIndex && (this._string.charAt(this._currentIndex) == "e" || this._string.charAt(this._currentIndex) == "E") && this._string.charAt(this._currentIndex + 1) != "x" && this._string.charAt(this._currentIndex + 1) != "m") {
                        this._currentIndex++;
                        // Read the sign of the exponent.
                        if (this._string.charAt(this._currentIndex) == "+") this._currentIndex++;
                        else if (this._string.charAt(this._currentIndex) == "-") {
                            this._currentIndex++;
                            expsign = -1;
                        }
                        // There must be an exponent.
                        if (this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") return undefined;
                        while(this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9"){
                            exponent *= 10;
                            exponent += this._string.charAt(this._currentIndex) - "0";
                            this._currentIndex++;
                        }
                    }
                    var number = integer + decimal;
                    number *= sign;
                    if (exponent) number *= Math.pow(10, expsign * exponent);
                    if (startIndex == this._currentIndex) return undefined;
                    this._skipOptionalSpacesOrDelimiter();
                    return number;
                };
                Source.prototype._parseArcFlag = function() {
                    if (this._currentIndex >= this._endIndex) return undefined;
                    var flag = false;
                    var flagChar = this._string.charAt(this._currentIndex++);
                    if (flagChar == "0") flag = false;
                    else if (flagChar == "1") flag = true;
                    else return undefined;
                    this._skipOptionalSpacesOrDelimiter();
                    return flag;
                };
                Source.prototype.parseSegment = function() {
                    var lookahead = this._string[this._currentIndex];
                    var command = this._pathSegTypeFromChar(lookahead);
                    if (command == window.SVGPathSeg.PATHSEG_UNKNOWN) {
                        // Possibly an implicit command. Not allowed if this is the first command.
                        if (this._previousCommand == window.SVGPathSeg.PATHSEG_UNKNOWN) return null;
                        command = this._nextCommandHelper(lookahead, this._previousCommand);
                        if (command == window.SVGPathSeg.PATHSEG_UNKNOWN) return null;
                    } else this._currentIndex++;
                    this._previousCommand = command;
                    switch(command){
                        case window.SVGPathSeg.PATHSEG_MOVETO_REL:
                            return new window.SVGPathSegMovetoRel(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_MOVETO_ABS:
                            return new window.SVGPathSegMovetoAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_REL:
                            return new window.SVGPathSegLinetoRel(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_ABS:
                            return new window.SVGPathSegLinetoAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL:
                            return new window.SVGPathSegLinetoHorizontalRel(owningPathSegList, this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS:
                            return new window.SVGPathSegLinetoHorizontalAbs(owningPathSegList, this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL:
                            return new window.SVGPathSegLinetoVerticalRel(owningPathSegList, this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS:
                            return new window.SVGPathSegLinetoVerticalAbs(owningPathSegList, this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_CLOSEPATH:
                            this._skipOptionalSpaces();
                            return new window.SVGPathSegClosePath(owningPathSegList);
                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL:
                            var points = {
                                x1: this._parseNumber(),
                                y1: this._parseNumber(),
                                x2: this._parseNumber(),
                                y2: this._parseNumber(),
                                x: this._parseNumber(),
                                y: this._parseNumber()
                            };
                            return new window.SVGPathSegCurvetoCubicRel(owningPathSegList, points.x, points.y, points.x1, points.y1, points.x2, points.y2);
                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
                            var points = {
                                x1: this._parseNumber(),
                                y1: this._parseNumber(),
                                x2: this._parseNumber(),
                                y2: this._parseNumber(),
                                x: this._parseNumber(),
                                y: this._parseNumber()
                            };
                            return new window.SVGPathSegCurvetoCubicAbs(owningPathSegList, points.x, points.y, points.x1, points.y1, points.x2, points.y2);
                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL:
                            var points = {
                                x2: this._parseNumber(),
                                y2: this._parseNumber(),
                                x: this._parseNumber(),
                                y: this._parseNumber()
                            };
                            return new window.SVGPathSegCurvetoCubicSmoothRel(owningPathSegList, points.x, points.y, points.x2, points.y2);
                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS:
                            var points = {
                                x2: this._parseNumber(),
                                y2: this._parseNumber(),
                                x: this._parseNumber(),
                                y: this._parseNumber()
                            };
                            return new window.SVGPathSegCurvetoCubicSmoothAbs(owningPathSegList, points.x, points.y, points.x2, points.y2);
                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL:
                            var points = {
                                x1: this._parseNumber(),
                                y1: this._parseNumber(),
                                x: this._parseNumber(),
                                y: this._parseNumber()
                            };
                            return new window.SVGPathSegCurvetoQuadraticRel(owningPathSegList, points.x, points.y, points.x1, points.y1);
                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS:
                            var points = {
                                x1: this._parseNumber(),
                                y1: this._parseNumber(),
                                x: this._parseNumber(),
                                y: this._parseNumber()
                            };
                            return new window.SVGPathSegCurvetoQuadraticAbs(owningPathSegList, points.x, points.y, points.x1, points.y1);
                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL:
                            return new window.SVGPathSegCurvetoQuadraticSmoothRel(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS:
                            return new window.SVGPathSegCurvetoQuadraticSmoothAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_ARC_REL:
                            var points = {
                                x1: this._parseNumber(),
                                y1: this._parseNumber(),
                                arcAngle: this._parseNumber(),
                                arcLarge: this._parseArcFlag(),
                                arcSweep: this._parseArcFlag(),
                                x: this._parseNumber(),
                                y: this._parseNumber()
                            };
                            return new window.SVGPathSegArcRel(owningPathSegList, points.x, points.y, points.x1, points.y1, points.arcAngle, points.arcLarge, points.arcSweep);
                        case window.SVGPathSeg.PATHSEG_ARC_ABS:
                            var points = {
                                x1: this._parseNumber(),
                                y1: this._parseNumber(),
                                arcAngle: this._parseNumber(),
                                arcLarge: this._parseArcFlag(),
                                arcSweep: this._parseArcFlag(),
                                x: this._parseNumber(),
                                y: this._parseNumber()
                            };
                            return new window.SVGPathSegArcAbs(owningPathSegList, points.x, points.y, points.x1, points.y1, points.arcAngle, points.arcLarge, points.arcSweep);
                        default:
                            throw "Unknown path seg type.";
                    }
                };
                var builder = new Builder();
                var source = new Source(string);
                if (!source.initialCommandIsMoveTo()) return [];
                while(source.hasMoreData()){
                    var pathSeg = source.parseSegment();
                    if (!pathSeg) return [];
                    builder.appendSegment(pathSeg);
                }
                return builder.pathSegList;
            };
        }
    })();
    // String.padEnd polyfill for IE11
    //
    // https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padEnd
    if (!String.prototype.padEnd) String.prototype.padEnd = function padEnd(targetLength, padString) {
        targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
        padString = String(typeof padString !== "undefined" ? padString : " ");
        if (this.length > targetLength) return String(this);
        else {
            targetLength = targetLength - this.length;
            if (targetLength > padString.length) padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
            return String(this) + padString.slice(0, targetLength);
        }
    };
    // Object.assign polyfill for IE11
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
    if (typeof Object.assign !== "function") // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) {
            if (target === null || target === undefined) throw new TypeError("Cannot convert undefined or null to object");
            var to = Object(target);
            for(var index = 1; index < arguments.length; index++){
                var nextSource = arguments[index];
                if (nextSource !== null && nextSource !== undefined) {
                    for(var nextKey in nextSource)// Avoid bugs when hasOwnProperty is shadowed
                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) to[nextKey] = nextSource[nextKey];
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
    /* jshint ignore:end */ Chart.prototype.axis = function() {};
    Chart.prototype.axis.labels = function(labels) {
        var $$ = this.internal;
        if (arguments.length) {
            Object.keys(labels).forEach(function(axisId) {
                $$.axis.setLabelText(axisId, labels[axisId]);
            });
            $$.axis.updateLabels();
        }
    // TODO: return some values?
    };
    Chart.prototype.axis.max = function(max) {
        var $$ = this.internal, config = $$.config;
        if (arguments.length) {
            if (typeof max === "object") {
                if (isValue(max.x)) config.axis_x_max = max.x;
                if (isValue(max.y)) config.axis_y_max = max.y;
                if (isValue(max.y2)) config.axis_y2_max = max.y2;
            } else config.axis_y_max = config.axis_y2_max = max;
            $$.redraw({
                withUpdateOrgXDomain: true,
                withUpdateXDomain: true
            });
        } else return {
            x: config.axis_x_max,
            y: config.axis_y_max,
            y2: config.axis_y2_max
        };
    };
    Chart.prototype.axis.min = function(min) {
        var $$ = this.internal, config = $$.config;
        if (arguments.length) {
            if (typeof min === "object") {
                if (isValue(min.x)) config.axis_x_min = min.x;
                if (isValue(min.y)) config.axis_y_min = min.y;
                if (isValue(min.y2)) config.axis_y2_min = min.y2;
            } else config.axis_y_min = config.axis_y2_min = min;
            $$.redraw({
                withUpdateOrgXDomain: true,
                withUpdateXDomain: true
            });
        } else return {
            x: config.axis_x_min,
            y: config.axis_y_min,
            y2: config.axis_y2_min
        };
    };
    Chart.prototype.axis.range = function(range) {
        if (arguments.length) {
            if (isDefined(range.max)) this.axis.max(range.max);
            if (isDefined(range.min)) this.axis.min(range.min);
        } else return {
            max: this.axis.max(),
            min: this.axis.min()
        };
    };
    Chart.prototype.axis.types = function(types) {
        var $$ = this.internal;
        if (types === undefined) return {
            y: $$.config.axis_y_type,
            y2: $$.config.axis_y2_type
        };
        else {
            if (isDefined(types.y)) $$.config.axis_y_type = types.y;
            if (isDefined(types.y2)) $$.config.axis_y2_type = types.y2;
            $$.updateScales();
            $$.redraw();
        }
    };
    Chart.prototype.category = function(i, category) {
        var $$ = this.internal, config = $$.config;
        if (arguments.length > 1) {
            config.axis_x_categories[i] = category;
            $$.redraw();
        }
        return config.axis_x_categories[i];
    };
    Chart.prototype.categories = function(categories) {
        var $$ = this.internal, config = $$.config;
        if (!arguments.length) return config.axis_x_categories;
        config.axis_x_categories = categories;
        $$.redraw();
        return config.axis_x_categories;
    };
    Chart.prototype.resize = function(size) {
        var $$ = this.internal, config = $$.config;
        config.size_width = size ? size.width : null;
        config.size_height = size ? size.height : null;
        this.flush();
    };
    Chart.prototype.flush = function() {
        var $$ = this.internal;
        $$.updateAndRedraw({
            withLegend: true,
            withTransition: false,
            withTransitionForTransform: false
        });
    };
    Chart.prototype.destroy = function() {
        var $$ = this.internal;
        window.clearInterval($$.intervalForObserveInserted);
        if ($$.resizeTimeout !== undefined) window.clearTimeout($$.resizeTimeout);
        window.removeEventListener("resize", $$.resizeIfElementDisplayed);
        // Removes the inner resize functions
        $$.resizeFunction.remove();
        // Unbinds from the window focus event
        $$.unbindWindowFocus();
        $$.selectChart.classed("c3", false).html("");
        // MEMO: this is needed because the reference of some elements will not be released, then memory leak will happen.
        Object.keys($$).forEach(function(key) {
            $$[key] = null;
        });
        return null;
    };
    // TODO: fix
    Chart.prototype.color = function(id) {
        var $$ = this.internal;
        return $$.color(id); // more patterns
    };
    Chart.prototype.data = function(targetIds) {
        var targets = this.internal.data.targets;
        return typeof targetIds === "undefined" ? targets : targets.filter(function(t) {
            return [].concat(targetIds).indexOf(t.id) >= 0;
        });
    };
    Chart.prototype.data.shown = function(targetIds) {
        return this.internal.filterTargetsToShow(this.data(targetIds));
    };
    /**
   * Get values of the data loaded in the chart.
   *
   * @param {String|Array} targetId This API returns the value of specified target.
   * @param flat
   * @return {Array} Data values
   */ Chart.prototype.data.values = function(targetId, flat) {
        if (flat === void 0) flat = true;
        var values = null;
        if (targetId) {
            var targets = this.data(targetId);
            if (targets && isArray(targets)) values = targets.reduce(function(ret, v) {
                var dataValue = v.values.map(function(d) {
                    return d.value;
                });
                if (flat) ret = ret.concat(dataValue);
                else ret.push(dataValue);
                return ret;
            }, []);
        }
        return values;
    };
    Chart.prototype.data.names = function(names) {
        this.internal.clearLegendItemTextBoxCache();
        return this.internal.updateDataAttributes("names", names);
    };
    Chart.prototype.data.colors = function(colors) {
        return this.internal.updateDataAttributes("colors", colors);
    };
    Chart.prototype.data.axes = function(axes) {
        return this.internal.updateDataAttributes("axes", axes);
    };
    Chart.prototype.data.stackNormalized = function(normalized) {
        if (normalized === undefined) return this.internal.isStackNormalized();
        this.internal.config.data_stack_normalize = !!normalized;
        this.internal.redraw();
    };
    Chart.prototype.donut = function() {};
    Chart.prototype.donut.padAngle = function(padAngle) {
        if (padAngle === undefined) return this.internal.config.donut_padAngle;
        this.internal.config.donut_padAngle = padAngle;
        this.flush();
    };
    Chart.prototype.flow = function(args) {
        var $$ = this.internal, targets, data, notfoundIds = [], orgDataCount = $$.getMaxDataCount(), dataCount, domain, baseTarget, baseValue, length = 0, tail = 0, diff, to;
        if (args.json) data = $$.convertJsonToData(args.json, args.keys);
        else if (args.rows) data = $$.convertRowsToData(args.rows);
        else if (args.columns) data = $$.convertColumnsToData(args.columns);
        else return;
        targets = $$.convertDataToTargets(data, true);
        // Update/Add data
        $$.data.targets.forEach(function(t) {
            var found = false, i, j;
            for(i = 0; i < targets.length; i++)if (t.id === targets[i].id) {
                found = true;
                if (t.values[t.values.length - 1]) tail = t.values[t.values.length - 1].index + 1;
                length = targets[i].values.length;
                for(j = 0; j < length; j++){
                    targets[i].values[j].index = tail + j;
                    if (!$$.isTimeSeries()) targets[i].values[j].x = tail + j;
                }
                t.values = t.values.concat(targets[i].values);
                targets.splice(i, 1);
                break;
            }
            if (!found) notfoundIds.push(t.id);
        });
        // Append null for not found targets
        $$.data.targets.forEach(function(t) {
            var i, j;
            for(i = 0; i < notfoundIds.length; i++)if (t.id === notfoundIds[i]) {
                tail = t.values[t.values.length - 1].index + 1;
                for(j = 0; j < length; j++)t.values.push({
                    id: t.id,
                    index: tail + j,
                    x: $$.isTimeSeries() ? $$.getOtherTargetX(tail + j) : tail + j,
                    value: null
                });
            }
        });
        // Generate null values for new target
        if ($$.data.targets.length) targets.forEach(function(t) {
            var i, missing = [];
            for(i = $$.data.targets[0].values[0].index; i < tail; i++)missing.push({
                id: t.id,
                index: i,
                x: $$.isTimeSeries() ? $$.getOtherTargetX(i) : i,
                value: null
            });
            t.values.forEach(function(v) {
                v.index += tail;
                if (!$$.isTimeSeries()) v.x += tail;
            });
            t.values = missing.concat(t.values);
        });
        $$.data.targets = $$.data.targets.concat(targets); // add remained
        // check data count because behavior needs to change when it's only one
        dataCount = $$.getMaxDataCount();
        baseTarget = $$.data.targets[0];
        baseValue = baseTarget.values[0];
        // Update length to flow if needed
        if (isDefined(args.to)) {
            length = 0;
            to = $$.isTimeSeries() ? $$.parseDate(args.to) : args.to;
            baseTarget.values.forEach(function(v) {
                if (v.x < to) length++;
            });
        } else if (isDefined(args.length)) length = args.length;
        // If only one data, update the domain to flow from left edge of the chart
        if (!orgDataCount) {
            if ($$.isTimeSeries()) {
                if (baseTarget.values.length > 1) diff = baseTarget.values[baseTarget.values.length - 1].x - baseValue.x;
                else diff = baseValue.x - $$.getXDomain($$.data.targets)[0];
            } else diff = 1;
            domain = [
                baseValue.x - diff,
                baseValue.x
            ];
            $$.updateXDomain(null, true, true, false, domain);
        } else if (orgDataCount === 1) {
            if ($$.isTimeSeries()) {
                diff = (baseTarget.values[baseTarget.values.length - 1].x - baseValue.x) / 2;
                domain = [
                    new Date(+baseValue.x - diff),
                    new Date(+baseValue.x + diff)
                ];
                $$.updateXDomain(null, true, true, false, domain);
            }
        }
        // Set targets
        $$.updateTargets($$.data.targets);
        // Redraw with new targets
        $$.redraw({
            flow: {
                index: baseValue.index,
                length: length,
                duration: isValue(args.duration) ? args.duration : $$.config.transition_duration,
                done: args.done,
                orgDataCount: orgDataCount
            },
            withLegend: true,
            withTransition: orgDataCount > 1,
            withTrimXDomain: false,
            withUpdateXAxis: true
        });
    };
    ChartInternal.prototype.generateFlow = function(args) {
        var $$ = this, config = $$.config, d3 = $$.d3;
        return function() {
            var targets = args.targets, flow = args.flow, drawBar = args.drawBar, drawLine = args.drawLine, drawArea = args.drawArea, cx = args.cx, cy = args.cy, xv = args.xv, xForText = args.xForText, yForText = args.yForText, duration = args.duration;
            var translateX, scaleX = 1, transform, flowIndex = flow.index, flowLength = flow.length, flowStart = $$.getValueOnIndex($$.data.targets[0].values, flowIndex), flowEnd = $$.getValueOnIndex($$.data.targets[0].values, flowIndex + flowLength), orgDomain = $$.x.domain(), domain, durationForFlow = flow.duration || duration, done = flow.done || function() {}, wait = $$.generateWait();
            var xgrid, xgridLines, mainRegion, mainText, mainBar, mainLine, mainArea, mainCircle;
            // set flag
            $$.flowing = true;
            // remove head data after rendered
            $$.data.targets.forEach(function(d) {
                d.values.splice(0, flowLength);
            });
            // update x domain to generate axis elements for flow
            domain = $$.updateXDomain(targets, true, true);
            // update elements related to x scale
            if ($$.updateXGrid) $$.updateXGrid(true);
            xgrid = $$.xgrid || d3.selectAll([]); // xgrid needs to be obtained after updateXGrid
            xgridLines = $$.xgridLines || d3.selectAll([]);
            mainRegion = $$.mainRegion || d3.selectAll([]);
            mainText = $$.mainText || d3.selectAll([]);
            mainBar = $$.mainBar || d3.selectAll([]);
            mainLine = $$.mainLine || d3.selectAll([]);
            mainArea = $$.mainArea || d3.selectAll([]);
            mainCircle = $$.mainCircle || d3.selectAll([]);
            // generate transform to flow
            if (!flow.orgDataCount) {
                // if empty
                if ($$.data.targets[0].values.length !== 1) translateX = $$.x(orgDomain[0]) - $$.x(domain[0]);
                else if ($$.isTimeSeries()) {
                    flowStart = $$.getValueOnIndex($$.data.targets[0].values, 0);
                    flowEnd = $$.getValueOnIndex($$.data.targets[0].values, $$.data.targets[0].values.length - 1);
                    translateX = $$.x(flowStart.x) - $$.x(flowEnd.x);
                } else translateX = diffDomain(domain) / 2;
            } else if (flow.orgDataCount === 1 || (flowStart && flowStart.x) === (flowEnd && flowEnd.x)) translateX = $$.x(orgDomain[0]) - $$.x(domain[0]);
            else if ($$.isTimeSeries()) translateX = $$.x(orgDomain[0]) - $$.x(domain[0]);
            else translateX = $$.x(flowStart.x) - $$.x(flowEnd.x);
            scaleX = diffDomain(orgDomain) / diffDomain(domain);
            transform = "translate(" + translateX + ",0) scale(" + scaleX + ",1)";
            $$.hideXGridFocus();
            var flowTransition = d3.transition().ease(d3.easeLinear).duration(durationForFlow);
            wait.add($$.xAxis($$.axes.x, flowTransition));
            wait.add(mainBar.transition(flowTransition).attr("transform", transform));
            wait.add(mainLine.transition(flowTransition).attr("transform", transform));
            wait.add(mainArea.transition(flowTransition).attr("transform", transform));
            wait.add(mainCircle.transition(flowTransition).attr("transform", transform));
            wait.add(mainText.transition(flowTransition).attr("transform", transform));
            wait.add(mainRegion.filter($$.isRegionOnX).transition(flowTransition).attr("transform", transform));
            wait.add(xgrid.transition(flowTransition).attr("transform", transform));
            wait.add(xgridLines.transition(flowTransition).attr("transform", transform));
            wait(function() {
                var i, shapes = [], texts = [];
                // remove flowed elements
                if (flowLength) {
                    for(i = 0; i < flowLength; i++){
                        shapes.push("." + CLASS.shape + "-" + (flowIndex + i));
                        texts.push("." + CLASS.text + "-" + (flowIndex + i));
                    }
                    $$.svg.selectAll("." + CLASS.shapes).selectAll(shapes).remove();
                    $$.svg.selectAll("." + CLASS.texts).selectAll(texts).remove();
                    $$.svg.select("." + CLASS.xgrid).remove();
                }
                // draw again for removing flowed elements and reverting attr
                xgrid.attr("transform", null).attr("x1", $$.xgridAttr.x1).attr("x2", $$.xgridAttr.x2).attr("y1", $$.xgridAttr.y1).attr("y2", $$.xgridAttr.y2).style("opacity", $$.xgridAttr.opacity);
                xgridLines.attr("transform", null);
                xgridLines.select("line").attr("x1", config.axis_rotated ? 0 : xv).attr("x2", config.axis_rotated ? $$.width : xv);
                xgridLines.select("text").attr("x", config.axis_rotated ? $$.width : 0).attr("y", xv);
                mainBar.attr("transform", null).attr("d", drawBar);
                mainLine.attr("transform", null).attr("d", drawLine);
                mainArea.attr("transform", null).attr("d", drawArea);
                mainCircle.attr("transform", null).attr("cx", cx).attr("cy", cy);
                mainText.attr("transform", null).attr("x", xForText).attr("y", yForText).style("fill-opacity", $$.opacityForText.bind($$));
                mainRegion.attr("transform", null);
                mainRegion.filter($$.isRegionOnX).attr("x", $$.regionX.bind($$)).attr("width", $$.regionWidth.bind($$));
                // callback for end of flow
                done();
                $$.flowing = false;
            });
        };
    };
    Chart.prototype.focus = function(targetIds) {
        var $$ = this.internal, candidates;
        targetIds = $$.mapToTargetIds(targetIds);
        candidates = $$.svg.selectAll($$.selectorTargets(targetIds.filter($$.isTargetToShow, $$))), this.revert();
        this.defocus();
        candidates.classed(CLASS.focused, true).classed(CLASS.defocused, false);
        if ($$.hasArcType()) $$.expandArc(targetIds);
        $$.toggleFocusLegend(targetIds, true);
        $$.focusedTargetIds = targetIds;
        $$.defocusedTargetIds = $$.defocusedTargetIds.filter(function(id) {
            return targetIds.indexOf(id) < 0;
        });
    };
    Chart.prototype.defocus = function(targetIds) {
        var $$ = this.internal, candidates;
        targetIds = $$.mapToTargetIds(targetIds);
        candidates = $$.svg.selectAll($$.selectorTargets(targetIds.filter($$.isTargetToShow, $$))), candidates.classed(CLASS.focused, false).classed(CLASS.defocused, true);
        if ($$.hasArcType()) $$.unexpandArc(targetIds);
        $$.toggleFocusLegend(targetIds, false);
        $$.focusedTargetIds = $$.focusedTargetIds.filter(function(id) {
            return targetIds.indexOf(id) < 0;
        });
        $$.defocusedTargetIds = targetIds;
    };
    Chart.prototype.revert = function(targetIds) {
        var $$ = this.internal, candidates;
        targetIds = $$.mapToTargetIds(targetIds);
        candidates = $$.svg.selectAll($$.selectorTargets(targetIds)); // should be for all targets
        candidates.classed(CLASS.focused, false).classed(CLASS.defocused, false);
        if ($$.hasArcType()) $$.unexpandArc(targetIds);
        if ($$.config.legend_show) {
            $$.showLegend(targetIds.filter($$.isLegendToShow.bind($$)));
            $$.legend.selectAll($$.selectorLegends(targetIds)).filter(function() {
                return $$.d3.select(this).classed(CLASS.legendItemFocused);
            }).classed(CLASS.legendItemFocused, false);
        }
        $$.focusedTargetIds = [];
        $$.defocusedTargetIds = [];
    };
    Chart.prototype.xgrids = function(grids) {
        var $$ = this.internal, config = $$.config;
        if (!grids) return config.grid_x_lines;
        config.grid_x_lines = grids;
        $$.redrawWithoutRescale();
        return config.grid_x_lines;
    };
    Chart.prototype.xgrids.add = function(grids) {
        var $$ = this.internal;
        return this.xgrids($$.config.grid_x_lines.concat(grids ? grids : []));
    };
    Chart.prototype.xgrids.remove = function(params) {
        // TODO: multiple
        var $$ = this.internal;
        $$.removeGridLines(params, true);
    };
    Chart.prototype.ygrids = function(grids) {
        var $$ = this.internal, config = $$.config;
        if (!grids) return config.grid_y_lines;
        config.grid_y_lines = grids;
        $$.redrawWithoutRescale();
        return config.grid_y_lines;
    };
    Chart.prototype.ygrids.add = function(grids) {
        var $$ = this.internal;
        return this.ygrids($$.config.grid_y_lines.concat(grids ? grids : []));
    };
    Chart.prototype.ygrids.remove = function(params) {
        // TODO: multiple
        var $$ = this.internal;
        $$.removeGridLines(params, false);
    };
    Chart.prototype.groups = function(groups) {
        var $$ = this.internal, config = $$.config;
        if (isUndefined(groups)) return config.data_groups;
        config.data_groups = groups;
        $$.redraw();
        return config.data_groups;
    };
    Chart.prototype.legend = function() {};
    Chart.prototype.legend.show = function(targetIds) {
        var $$ = this.internal;
        $$.showLegend($$.mapToTargetIds(targetIds));
        $$.updateAndRedraw({
            withLegend: true
        });
    };
    Chart.prototype.legend.hide = function(targetIds) {
        var $$ = this.internal;
        $$.hideLegend($$.mapToTargetIds(targetIds));
        $$.updateAndRedraw({
            withLegend: false
        });
    };
    Chart.prototype.load = function(args) {
        var $$ = this.internal, config = $$.config;
        // update xs if specified
        if (args.xs) $$.addXs(args.xs);
        // update names if exists
        if ("names" in args) Chart.prototype.data.names.bind(this)(args.names);
        // update classes if exists
        if ("classes" in args) Object.keys(args.classes).forEach(function(id) {
            config.data_classes[id] = args.classes[id];
        });
        // update categories if exists
        if ("categories" in args && $$.isCategorized()) config.axis_x_categories = args.categories;
        // update axes if exists
        if ("axes" in args) Object.keys(args.axes).forEach(function(id) {
            config.data_axes[id] = args.axes[id];
        });
        // update colors if exists
        if ("colors" in args) Object.keys(args.colors).forEach(function(id) {
            config.data_colors[id] = args.colors[id];
        });
        // use cache if exists
        if ("cacheIds" in args && $$.hasCaches(args.cacheIds)) {
            $$.load($$.getCaches(args.cacheIds), args.done);
            return;
        }
        // unload if needed
        if (args.unload) // TODO: do not unload if target will load (included in url/rows/columns)
        $$.unload($$.mapToTargetIds(args.unload === true ? null : args.unload), function() {
            $$.loadFromArgs(args);
        });
        else $$.loadFromArgs(args);
    };
    Chart.prototype.unload = function(args) {
        var $$ = this.internal;
        args = args || {};
        if (args instanceof Array) args = {
            ids: args
        };
        else if (typeof args === "string") args = {
            ids: [
                args
            ]
        };
        $$.unload($$.mapToTargetIds(args.ids), function() {
            $$.redraw({
                withUpdateOrgXDomain: true,
                withUpdateXDomain: true,
                withLegend: true
            });
            if (args.done) args.done();
        });
    };
    Chart.prototype.pie = function() {};
    Chart.prototype.pie.padAngle = function(padAngle) {
        if (padAngle === undefined) return this.internal.config.pie_padAngle;
        this.internal.config.pie_padAngle = padAngle;
        this.flush();
    };
    Chart.prototype.regions = function(regions) {
        var $$ = this.internal, config = $$.config;
        if (!regions) return config.regions;
        config.regions = regions;
        $$.redrawWithoutRescale();
        return config.regions;
    };
    Chart.prototype.regions.add = function(regions) {
        var $$ = this.internal, config = $$.config;
        if (!regions) return config.regions;
        config.regions = config.regions.concat(regions);
        $$.redrawWithoutRescale();
        return config.regions;
    };
    Chart.prototype.regions.remove = function(options) {
        var $$ = this.internal, config = $$.config, duration, classes, regions;
        options = options || {};
        duration = getOption(options, "duration", config.transition_duration);
        classes = getOption(options, "classes", [
            CLASS.region
        ]);
        regions = $$.main.select("." + CLASS.regions).selectAll(classes.map(function(c) {
            return "." + c;
        }));
        (duration ? regions.transition().duration(duration) : regions).style("opacity", 0).remove();
        config.regions = config.regions.filter(function(region) {
            var found = false;
            if (!region["class"]) return true;
            region["class"].split(" ").forEach(function(c) {
                if (classes.indexOf(c) >= 0) found = true;
            });
            return !found;
        });
        return config.regions;
    };
    Chart.prototype.selected = function(targetId) {
        var $$ = this.internal, d3 = $$.d3;
        return $$.main.selectAll("." + CLASS.shapes + $$.getTargetSelectorSuffix(targetId)).selectAll("." + CLASS.shape).filter(function() {
            return d3.select(this).classed(CLASS.SELECTED);
        }).nodes().map(function(d) {
            var data = d.__data__;
            return data.data ? data.data : data;
        });
    };
    Chart.prototype.select = function(ids, indices, resetOther) {
        var $$ = this.internal, d3 = $$.d3, config = $$.config;
        if (!config.data_selection_enabled) return;
        $$.main.selectAll("." + CLASS.shapes).selectAll("." + CLASS.shape).each(function(d, i) {
            var shape = d3.select(this), id = d.data ? d.data.id : d.id, toggle = $$.getToggle(this, d).bind($$), isTargetId = config.data_selection_grouped || !ids || ids.indexOf(id) >= 0, isTargetIndex = !indices || indices.indexOf(i) >= 0, isSelected = shape.classed(CLASS.SELECTED);
            // line/area selection not supported yet
            if (shape.classed(CLASS.line) || shape.classed(CLASS.area)) return;
            if (isTargetId && isTargetIndex) {
                if (config.data_selection_isselectable(d) && !isSelected) toggle(true, shape.classed(CLASS.SELECTED, true), d, i);
            } else if (isDefined(resetOther) && resetOther) {
                if (isSelected) toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
            }
        });
    };
    Chart.prototype.unselect = function(ids, indices) {
        var $$ = this.internal, d3 = $$.d3, config = $$.config;
        if (!config.data_selection_enabled) return;
        $$.main.selectAll("." + CLASS.shapes).selectAll("." + CLASS.shape).each(function(d, i) {
            var shape = d3.select(this), id = d.data ? d.data.id : d.id, toggle = $$.getToggle(this, d).bind($$), isTargetId = config.data_selection_grouped || !ids || ids.indexOf(id) >= 0, isTargetIndex = !indices || indices.indexOf(i) >= 0, isSelected = shape.classed(CLASS.SELECTED);
            // line/area selection not supported yet
            if (shape.classed(CLASS.line) || shape.classed(CLASS.area)) return;
            if (isTargetId && isTargetIndex) {
                if (config.data_selection_isselectable(d)) {
                    if (isSelected) toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
                }
            }
        });
    };
    Chart.prototype.show = function(targetIds, options) {
        var $$ = this.internal, targets;
        targetIds = $$.mapToTargetIds(targetIds);
        options = options || {};
        $$.removeHiddenTargetIds(targetIds);
        targets = $$.svg.selectAll($$.selectorTargets(targetIds));
        targets.transition().style("display", isIE() ? "block" : "initial", "important").style("opacity", 1, "important").call($$.endall, function() {
            targets.style("opacity", null).style("opacity", 1);
        });
        if (options.withLegend) $$.showLegend(targetIds);
        $$.redraw({
            withUpdateOrgXDomain: true,
            withUpdateXDomain: true,
            withLegend: true
        });
    };
    Chart.prototype.hide = function(targetIds, options) {
        var $$ = this.internal, targets;
        targetIds = $$.mapToTargetIds(targetIds);
        options = options || {};
        $$.addHiddenTargetIds(targetIds);
        targets = $$.svg.selectAll($$.selectorTargets(targetIds));
        targets.transition().style("opacity", 0, "important").call($$.endall, function() {
            targets.style("opacity", null).style("opacity", 0);
            targets.style("display", "none");
        });
        if (options.withLegend) $$.hideLegend(targetIds);
        $$.redraw({
            withUpdateOrgXDomain: true,
            withUpdateXDomain: true,
            withLegend: true
        });
    };
    Chart.prototype.toggle = function(targetIds, options) {
        var that = this, $$ = this.internal;
        $$.mapToTargetIds(targetIds).forEach(function(targetId) {
            $$.isTargetToShow(targetId) ? that.hide(targetId, options) : that.show(targetId, options);
        });
    };
    Chart.prototype.subchart = function() {};
    Chart.prototype.subchart.isShown = function() {
        var $$ = this.internal;
        return $$.config.subchart_show;
    };
    Chart.prototype.subchart.show = function() {
        var $$ = this.internal;
        if ($$.config.subchart_show) return;
        $$.config.subchart_show = true;
        // insert DOM
        $$.initSubchart();
        // update dimensions with sub chart now visible
        $$.updateDimension();
        // insert brush (depends on sizes previously updated)
        $$.initSubchartBrush();
        // attach data
        $$.updateTargetsForSubchart($$.getTargets());
        // reset fade-in state
        $$.mapToIds($$.data.targets).forEach(function(id) {
            $$.withoutFadeIn[id] = false;
        });
        // redraw chart !
        $$.updateAndRedraw();
        // update visible targets !
        $$.showTargets();
    };
    Chart.prototype.subchart.hide = function() {
        var $$ = this.internal;
        if (!$$.config.subchart_show) return;
        $$.config.subchart_show = false;
        // remove DOM
        $$.removeSubchart();
        // re-render chart
        $$.redraw();
    };
    Chart.prototype.tooltip = function() {};
    Chart.prototype.tooltip.show = function(args) {
        var $$ = this.internal, targets, data, mouse = {};
        // determine mouse position on the chart
        if (args.mouse) mouse = args.mouse;
        else {
            // determine focus data
            if (args.data) data = args.data;
            else if (typeof args.x !== "undefined") {
                if (args.id) targets = $$.data.targets.filter(function(t) {
                    return t.id === args.id;
                });
                else targets = $$.data.targets;
                data = $$.filterByX(targets, args.x).slice(0, 1)[0];
            }
            mouse = data ? $$.getMousePosition(data) : null;
        }
        // emulate mouse events to show
        $$.dispatchEvent("mousemove", mouse);
        $$.config.tooltip_onshow.call($$, data);
    };
    Chart.prototype.tooltip.hide = function() {
        // TODO: get target data by checking the state of focus
        this.internal.dispatchEvent("mouseout", 0);
        this.internal.config.tooltip_onhide.call(this);
    };
    Chart.prototype.transform = function(type, targetIds) {
        var $$ = this.internal, options = [
            "pie",
            "donut"
        ].indexOf(type) >= 0 ? {
            withTransform: true
        } : null;
        $$.transformTo(targetIds, type, options);
    };
    ChartInternal.prototype.transformTo = function(targetIds, type, optionsForRedraw) {
        var $$ = this, withTransitionForAxis = !$$.hasArcType(), options = optionsForRedraw || {
            withTransitionForAxis: withTransitionForAxis
        };
        options.withTransitionForTransform = false;
        $$.transiting = false;
        $$.setTargetType(targetIds, type);
        $$.updateTargets($$.data.targets); // this is needed when transforming to arc
        $$.updateAndRedraw(options);
    };
    Chart.prototype.x = function(x) {
        var $$ = this.internal;
        if (arguments.length) {
            $$.updateTargetX($$.data.targets, x);
            $$.redraw({
                withUpdateOrgXDomain: true,
                withUpdateXDomain: true
            });
        }
        return $$.data.xs;
    };
    Chart.prototype.xs = function(xs) {
        var $$ = this.internal;
        if (arguments.length) {
            $$.updateTargetXs($$.data.targets, xs);
            $$.redraw({
                withUpdateOrgXDomain: true,
                withUpdateXDomain: true
            });
        }
        return $$.data.xs;
    };
    Chart.prototype.zoom = function(domain) {
        var $$ = this.internal;
        if (domain) {
            if ($$.isTimeSeries()) domain = domain.map(function(x) {
                return $$.parseDate(x);
            });
            if ($$.config.subchart_show) $$.brush.selectionAsValue(domain, true);
            else {
                $$.updateXDomain(null, true, false, false, domain);
                $$.redraw({
                    withY: $$.config.zoom_rescale,
                    withSubchart: false
                });
            }
            $$.config.zoom_onzoom.call(this, $$.x.orgDomain());
            return domain;
        } else return $$.x.domain();
    };
    Chart.prototype.zoom.enable = function(enabled) {
        var $$ = this.internal;
        $$.config.zoom_enabled = enabled;
        $$.updateAndRedraw();
    };
    Chart.prototype.unzoom = function() {
        var $$ = this.internal;
        if ($$.config.subchart_show) $$.brush.clear();
        else {
            $$.updateXDomain(null, true, false, false, $$.subX.domain());
            $$.redraw({
                withY: $$.config.zoom_rescale,
                withSubchart: false
            });
        }
    };
    Chart.prototype.zoom.max = function(max) {
        var $$ = this.internal, config = $$.config, d3 = $$.d3;
        if (max === 0 || max) config.zoom_x_max = d3.max([
            $$.orgXDomain[1],
            max
        ]);
        else return config.zoom_x_max;
    };
    Chart.prototype.zoom.min = function(min) {
        var $$ = this.internal, config = $$.config, d3 = $$.d3;
        if (min === 0 || min) config.zoom_x_min = d3.min([
            $$.orgXDomain[0],
            min
        ]);
        else return config.zoom_x_min;
    };
    Chart.prototype.zoom.range = function(range) {
        if (arguments.length) {
            if (isDefined(range.max)) this.domain.max(range.max);
            if (isDefined(range.min)) this.domain.min(range.min);
        } else return {
            max: this.domain.max(),
            min: this.domain.min()
        };
    };
    ChartInternal.prototype.initPie = function() {
        var $$ = this, d3 = $$.d3;
        $$.pie = d3.pie().padAngle(this.getPadAngle.bind(this)).value(function(d) {
            return d.values.reduce(function(a, b) {
                return a + b.value;
            }, 0);
        });
        var orderFct = $$.getOrderFunction();
        // we need to reverse the returned order if asc or desc to have the slice in expected order.
        if (orderFct && ($$.isOrderAsc() || $$.isOrderDesc())) {
            var defaultSort_1 = orderFct;
            orderFct = function(t1, t2) {
                return defaultSort_1(t1, t2) * -1;
            };
        }
        $$.pie.sort(orderFct || null);
    };
    ChartInternal.prototype.updateRadius = function() {
        var $$ = this, config = $$.config, w = config.gauge_width || config.donut_width, gaugeArcWidth = $$.filterTargetsToShow($$.data.targets).length * $$.config.gauge_arcs_minWidth;
        $$.radiusExpanded = Math.min($$.arcWidth, $$.arcHeight) / 2 * ($$.hasType("gauge") ? 0.85 : 1);
        $$.radius = $$.radiusExpanded * 0.95;
        $$.innerRadiusRatio = w ? ($$.radius - w) / $$.radius : 0.6;
        $$.innerRadius = $$.hasType("donut") || $$.hasType("gauge") ? $$.radius * $$.innerRadiusRatio : 0;
        $$.gaugeArcWidth = w ? w : gaugeArcWidth <= $$.radius - $$.innerRadius ? $$.radius - $$.innerRadius : gaugeArcWidth <= $$.radius ? gaugeArcWidth : $$.radius;
    };
    ChartInternal.prototype.getPadAngle = function() {
        if (this.hasType("pie")) return this.config.pie_padAngle || 0;
        else if (this.hasType("donut")) return this.config.donut_padAngle || 0;
        else return 0;
    };
    ChartInternal.prototype.updateArc = function() {
        var $$ = this;
        $$.svgArc = $$.getSvgArc();
        $$.svgArcExpanded = $$.getSvgArcExpanded();
        $$.svgArcExpandedSub = $$.getSvgArcExpanded(0.98);
    };
    ChartInternal.prototype.updateAngle = function(d) {
        var $$ = this, config = $$.config, found = false, index = 0, gMin, gMax, gTic, gValue;
        if (!config) return null;
        $$.pie($$.filterTargetsToShow($$.data.targets)).forEach(function(t) {
            if (!found && t.data.id === d.data.id) {
                found = true;
                d = t;
                d.index = index;
            }
            index++;
        });
        if (isNaN(d.startAngle)) d.startAngle = 0;
        if (isNaN(d.endAngle)) d.endAngle = d.startAngle;
        if ($$.isGaugeType(d.data)) {
            gMin = config.gauge_min;
            gMax = config.gauge_max;
            gTic = Math.PI * (config.gauge_fullCircle ? 2 : 1) / (gMax - gMin);
            gValue = d.value < gMin ? 0 : d.value < gMax ? d.value - gMin : gMax - gMin;
            d.startAngle = config.gauge_startingAngle;
            d.endAngle = d.startAngle + gTic * gValue;
        }
        return found ? d : null;
    };
    ChartInternal.prototype.getSvgArc = function() {
        var $$ = this, hasGaugeType = $$.hasType("gauge"), singleArcWidth = $$.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length, arc = $$.d3.arc().outerRadius(function(d) {
            return hasGaugeType ? $$.radius - singleArcWidth * d.index : $$.radius;
        }).innerRadius(function(d) {
            return hasGaugeType ? $$.radius - singleArcWidth * (d.index + 1) : $$.innerRadius;
        }), newArc = function(d, withoutUpdate) {
            var updated;
            if (withoutUpdate) return arc(d);
             // for interpolate
            updated = $$.updateAngle(d);
            return updated ? arc(updated) : "M 0 0";
        };
        newArc.centroid = arc.centroid;
        return newArc;
    };
    ChartInternal.prototype.getSvgArcExpanded = function(rate) {
        rate = rate || 1;
        var $$ = this, hasGaugeType = $$.hasType("gauge"), singleArcWidth = $$.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length, expandWidth = Math.min($$.radiusExpanded * rate - $$.radius, singleArcWidth * 0.8 - (1 - rate) * 100), arc = $$.d3.arc().outerRadius(function(d) {
            return hasGaugeType ? $$.radius - singleArcWidth * d.index + expandWidth : $$.radiusExpanded * rate;
        }).innerRadius(function(d) {
            return hasGaugeType ? $$.radius - singleArcWidth * (d.index + 1) : $$.innerRadius;
        });
        return function(d) {
            var updated = $$.updateAngle(d);
            return updated ? arc(updated) : "M 0 0";
        };
    };
    ChartInternal.prototype.getArc = function(d, withoutUpdate, force) {
        return force || this.isArcType(d.data) ? this.svgArc(d, withoutUpdate) : "M 0 0";
    };
    ChartInternal.prototype.transformForArcLabel = function(d) {
        var $$ = this, config = $$.config, updated = $$.updateAngle(d), c, x, y, h, ratio, translate = "", hasGauge = $$.hasType("gauge");
        if (updated && !hasGauge) {
            c = this.svgArc.centroid(updated);
            x = isNaN(c[0]) ? 0 : c[0];
            y = isNaN(c[1]) ? 0 : c[1];
            h = Math.sqrt(x * x + y * y);
            if ($$.hasType("donut") && config.donut_label_ratio) ratio = isFunction(config.donut_label_ratio) ? config.donut_label_ratio(d, $$.radius, h) : config.donut_label_ratio;
            else if ($$.hasType("pie") && config.pie_label_ratio) ratio = isFunction(config.pie_label_ratio) ? config.pie_label_ratio(d, $$.radius, h) : config.pie_label_ratio;
            else ratio = $$.radius && h ? (36 / $$.radius > 0.375 ? 1.175 - 36 / $$.radius : 0.8) * $$.radius / h : 0;
            translate = "translate(" + x * ratio + "," + y * ratio + ")";
        } else if (updated && hasGauge && $$.filterTargetsToShow($$.data.targets).length > 1) {
            var y1 = Math.sin(updated.endAngle - Math.PI / 2);
            x = Math.cos(updated.endAngle - Math.PI / 2) * ($$.radiusExpanded + 25);
            y = y1 * ($$.radiusExpanded + 15 - Math.abs(y1 * 10)) + 3;
            translate = "translate(" + x + "," + y + ")";
        }
        return translate;
    };
    /**
   * @deprecated Use `getRatio('arc', d)` instead.
   */ ChartInternal.prototype.getArcRatio = function(d) {
        return this.getRatio("arc", d);
    };
    ChartInternal.prototype.convertToArcData = function(d) {
        return this.addName({
            id: d.data.id,
            value: d.value,
            ratio: this.getRatio("arc", d),
            index: d.index
        });
    };
    ChartInternal.prototype.textForArcLabel = function(d) {
        var $$ = this, updated, value, ratio, id, format;
        if (!$$.shouldShowArcLabel()) return "";
        updated = $$.updateAngle(d);
        value = updated ? updated.value : null;
        ratio = $$.getRatio("arc", updated);
        id = d.data.id;
        if (!$$.hasType("gauge") && !$$.meetsArcLabelThreshold(ratio)) return "";
        format = $$.getArcLabelFormat();
        return format ? format(value, ratio, id) : $$.defaultArcValueFormat(value, ratio);
    };
    ChartInternal.prototype.textForGaugeMinMax = function(value, isMax) {
        var $$ = this, format = $$.getGaugeLabelExtents();
        return format ? format(value, isMax) : value;
    };
    ChartInternal.prototype.expandArc = function(targetIds) {
        var $$ = this, interval;
        // MEMO: avoid to cancel transition
        if ($$.transiting) {
            interval = window.setInterval(function() {
                if (!$$.transiting) {
                    window.clearInterval(interval);
                    if ($$.legend.selectAll(".c3-legend-item-focused").size() > 0) $$.expandArc(targetIds);
                }
            }, 10);
            return;
        }
        targetIds = $$.mapToTargetIds(targetIds);
        $$.svg.selectAll($$.selectorTargets(targetIds, "." + CLASS.chartArc)).each(function(d) {
            if (!$$.shouldExpand(d.data.id)) return;
            $$.d3.select(this).selectAll("path").transition().duration($$.expandDuration(d.data.id)).attr("d", $$.svgArcExpanded).transition().duration($$.expandDuration(d.data.id) * 2).attr("d", $$.svgArcExpandedSub).each(function(d) {
                $$.isDonutType(d.data);
            });
        });
    };
    ChartInternal.prototype.unexpandArc = function(targetIds) {
        var $$ = this;
        if ($$.transiting) return;
        targetIds = $$.mapToTargetIds(targetIds);
        $$.svg.selectAll($$.selectorTargets(targetIds, "." + CLASS.chartArc)).selectAll("path").transition().duration(function(d) {
            return $$.expandDuration(d.data.id);
        }).attr("d", $$.svgArc);
        $$.svg.selectAll("." + CLASS.arc);
    };
    ChartInternal.prototype.expandDuration = function(id) {
        var $$ = this, config = $$.config;
        if ($$.isDonutType(id)) return config.donut_expand_duration;
        else if ($$.isGaugeType(id)) return config.gauge_expand_duration;
        else if ($$.isPieType(id)) return config.pie_expand_duration;
        else return 50;
    };
    ChartInternal.prototype.shouldExpand = function(id) {
        var $$ = this, config = $$.config;
        return $$.isDonutType(id) && config.donut_expand || $$.isGaugeType(id) && config.gauge_expand || $$.isPieType(id) && config.pie_expand;
    };
    ChartInternal.prototype.shouldShowArcLabel = function() {
        var $$ = this, config = $$.config, shouldShow = true;
        if ($$.hasType("donut")) shouldShow = config.donut_label_show;
        else if ($$.hasType("pie")) shouldShow = config.pie_label_show;
        // when gauge, always true
        return shouldShow;
    };
    ChartInternal.prototype.meetsArcLabelThreshold = function(ratio) {
        var $$ = this, config = $$.config, threshold = $$.hasType("donut") ? config.donut_label_threshold : config.pie_label_threshold;
        return ratio >= threshold;
    };
    ChartInternal.prototype.getArcLabelFormat = function() {
        var $$ = this, config = $$.config, format = config.pie_label_format;
        if ($$.hasType("gauge")) format = config.gauge_label_format;
        else if ($$.hasType("donut")) format = config.donut_label_format;
        return format;
    };
    ChartInternal.prototype.getGaugeLabelExtents = function() {
        var $$ = this, config = $$.config;
        return config.gauge_label_extents;
    };
    ChartInternal.prototype.getArcTitle = function() {
        var $$ = this;
        return $$.hasType("donut") ? $$.config.donut_title : "";
    };
    ChartInternal.prototype.updateTargetsForArc = function(targets) {
        var $$ = this, main = $$.main, mainPies, mainPieEnter, classChartArc = $$.classChartArc.bind($$), classArcs = $$.classArcs.bind($$), classFocus = $$.classFocus.bind($$);
        mainPies = main.select("." + CLASS.chartArcs).selectAll("." + CLASS.chartArc).data($$.pie(targets)).attr("class", function(d) {
            return classChartArc(d) + classFocus(d.data);
        });
        mainPieEnter = mainPies.enter().append("g").attr("class", classChartArc);
        mainPieEnter.append("g").attr("class", classArcs);
        mainPieEnter.append("text").attr("dy", $$.hasType("gauge") ? "-.1em" : ".35em").style("opacity", 0).style("text-anchor", "middle").style("pointer-events", "none");
    // MEMO: can not keep same color..., but not bad to update color in redraw
    //mainPieUpdate.exit().remove();
    };
    ChartInternal.prototype.initArc = function() {
        var $$ = this;
        $$.arcs = $$.main.select("." + CLASS.chart).append("g").attr("class", CLASS.chartArcs).attr("transform", $$.getTranslate("arc"));
        $$.arcs.append("text").attr("class", CLASS.chartArcsTitle).style("text-anchor", "middle").text($$.getArcTitle());
    };
    ChartInternal.prototype.redrawArc = function(duration, durationForExit, withTransform) {
        var $$ = this, d3 = $$.d3, config = $$.config, main = $$.main, arcs, mainArc, arcLabelLines, mainArcLabelLine, hasGaugeType = $$.hasType("gauge");
        arcs = main.selectAll("." + CLASS.arcs).selectAll("." + CLASS.arc).data($$.arcData.bind($$));
        mainArc = arcs.enter().append("path").attr("class", $$.classArc.bind($$)).style("fill", function(d) {
            return $$.color(d.data);
        }).style("cursor", function(d) {
            return config.interaction_enabled && config.data_selection_isselectable(d) ? "pointer" : null;
        }).each(function(d) {
            if ($$.isGaugeType(d.data)) d.startAngle = d.endAngle = config.gauge_startingAngle;
            this._current = d;
        }).merge(arcs);
        if (hasGaugeType) {
            arcLabelLines = main.selectAll("." + CLASS.arcs).selectAll("." + CLASS.arcLabelLine).data($$.arcData.bind($$));
            mainArcLabelLine = arcLabelLines.enter().append("rect").attr("class", function(d) {
                return CLASS.arcLabelLine + " " + CLASS.target + " " + CLASS.target + "-" + d.data.id;
            }).merge(arcLabelLines);
            if ($$.filterTargetsToShow($$.data.targets).length === 1) mainArcLabelLine.style("display", "none");
            else mainArcLabelLine.style("fill", function(d) {
                return $$.levelColor ? $$.levelColor(d.data.values.reduce(function(total, item) {
                    return total + item.value;
                }, 0)) : $$.color(d.data);
            }).style("display", config.gauge_labelLine_show ? "" : "none").each(function(d) {
                var lineLength = 0, lineThickness = 2, x = 0, y = 0, transform = "";
                if ($$.hiddenTargetIds.indexOf(d.data.id) < 0) {
                    var updated = $$.updateAngle(d), innerLineLength = $$.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length * (updated.index + 1), lineAngle = updated.endAngle - Math.PI / 2, arcInnerRadius = $$.radius - innerLineLength, linePositioningAngle = lineAngle - (arcInnerRadius === 0 ? 0 : 1 / arcInnerRadius);
                    lineLength = $$.radiusExpanded - $$.radius + innerLineLength;
                    x = Math.cos(linePositioningAngle) * arcInnerRadius;
                    y = Math.sin(linePositioningAngle) * arcInnerRadius;
                    transform = "rotate(" + lineAngle * 180 / Math.PI + ", " + x + ", " + y + ")";
                }
                d3.select(this).attr("x", x).attr("y", y).attr("width", lineLength).attr("height", lineThickness).attr("transform", transform).style("stroke-dasharray", "0, " + (lineLength + lineThickness) + ", 0");
            });
        }
        mainArc.attr("transform", function(d) {
            return !$$.isGaugeType(d.data) && withTransform ? "scale(0)" : "";
        }).on("mouseover", config.interaction_enabled ? function(d) {
            var updated, arcData;
            if ($$.transiting) // skip while transiting
            return;
            updated = $$.updateAngle(d);
            if (updated) {
                arcData = $$.convertToArcData(updated);
                // transitions
                $$.expandArc(updated.data.id);
                $$.api.focus(updated.data.id);
                $$.toggleFocusLegend(updated.data.id, true);
                $$.config.data_onmouseover(arcData, this);
            }
        } : null).on("mousemove", config.interaction_enabled ? function(d) {
            var updated = $$.updateAngle(d), arcData, selectedData;
            if (updated) {
                arcData = $$.convertToArcData(updated), selectedData = [
                    arcData
                ];
                $$.showTooltip(selectedData, this);
            }
        } : null).on("mouseout", config.interaction_enabled ? function(d) {
            var updated, arcData;
            if ($$.transiting) // skip while transiting
            return;
            updated = $$.updateAngle(d);
            if (updated) {
                arcData = $$.convertToArcData(updated);
                // transitions
                $$.unexpandArc(updated.data.id);
                $$.api.revert();
                $$.revertLegend();
                $$.hideTooltip();
                $$.config.data_onmouseout(arcData, this);
            }
        } : null).on("click", config.interaction_enabled ? function(d, i) {
            var updated = $$.updateAngle(d), arcData;
            if (updated) {
                arcData = $$.convertToArcData(updated);
                if ($$.toggleShape) $$.toggleShape(this, arcData, i);
                $$.config.data_onclick.call($$.api, arcData, this);
            }
        } : null).each(function() {
            $$.transiting = true;
        }).transition().duration(duration).attrTween("d", function(d) {
            var updated = $$.updateAngle(d), interpolate;
            if (!updated) return function() {
                return "M 0 0";
            };
            //                if (this._current === d) {
            //                    this._current = {
            //                        startAngle: Math.PI*2,
            //                        endAngle: Math.PI*2,
            //                    };
            //                }
            if (isNaN(this._current.startAngle)) this._current.startAngle = 0;
            if (isNaN(this._current.endAngle)) this._current.endAngle = this._current.startAngle;
            interpolate = d3.interpolate(this._current, updated);
            this._current = interpolate(0);
            return function(t) {
                // prevents crashing the charts once in transition and chart.destroy() has been called
                if ($$.config === null) return "M 0 0";
                var interpolated = interpolate(t);
                interpolated.data = d.data; // data.id will be updated by interporator
                return $$.getArc(interpolated, true);
            };
        }).attr("transform", withTransform ? "scale(1)" : "").style("fill", function(d) {
            return $$.levelColor ? $$.levelColor(d.data.values.reduce(function(total, item) {
                return total + item.value;
            }, 0)) : $$.color(d.data.id);
        }) // Where gauge reading color would receive customization.
        .call($$.endall, function() {
            $$.transiting = false;
        });
        arcs.exit().transition().duration(durationForExit).style("opacity", 0).remove();
        main.selectAll("." + CLASS.chartArc).select("text").style("opacity", 0).attr("class", function(d) {
            return $$.isGaugeType(d.data) ? CLASS.gaugeValue : "";
        }).text($$.textForArcLabel.bind($$)).attr("transform", $$.transformForArcLabel.bind($$)).style("font-size", function(d) {
            return $$.isGaugeType(d.data) && $$.filterTargetsToShow($$.data.targets).length === 1 ? Math.round($$.radius / 5) + "px" : "";
        }).transition().duration(duration).style("opacity", function(d) {
            return $$.isTargetToShow(d.data.id) && $$.isArcType(d.data) ? 1 : 0;
        });
        main.select("." + CLASS.chartArcsTitle).style("opacity", $$.hasType("donut") || hasGaugeType ? 1 : 0);
        if (hasGaugeType) {
            var index_1 = 0;
            var backgroundArc = $$.arcs.select("g." + CLASS.chartArcsBackground).selectAll("path." + CLASS.chartArcsBackground).data($$.data.targets);
            backgroundArc.enter().append("path").attr("class", function(d, i) {
                return CLASS.chartArcsBackground + " " + CLASS.chartArcsBackground + "-" + i;
            }).merge(backgroundArc).attr("d", function(d1) {
                if ($$.hiddenTargetIds.indexOf(d1.id) >= 0) return "M 0 0";
                var d = {
                    data: [
                        {
                            value: config.gauge_max
                        }
                    ],
                    startAngle: config.gauge_startingAngle,
                    endAngle: -1 * config.gauge_startingAngle * (config.gauge_fullCircle ? Math.PI : 1),
                    index: index_1++
                };
                return $$.getArc(d, true, true);
            });
            backgroundArc.exit().remove();
            $$.arcs.select("." + CLASS.chartArcsGaugeUnit).attr("dy", ".75em").text(config.gauge_label_show ? config.gauge_units : "");
            $$.arcs.select("." + CLASS.chartArcsGaugeMin).attr("dx", -1 * ($$.innerRadius + ($$.radius - $$.innerRadius) / (config.gauge_fullCircle ? 1 : 2)) + "px").attr("dy", "1.2em").text(config.gauge_label_show ? $$.textForGaugeMinMax(config.gauge_min, false) : "");
            $$.arcs.select("." + CLASS.chartArcsGaugeMax).attr("dx", $$.innerRadius + ($$.radius - $$.innerRadius) / (config.gauge_fullCircle ? 1 : 2) + "px").attr("dy", "1.2em").text(config.gauge_label_show ? $$.textForGaugeMinMax(config.gauge_max, true) : "");
        }
    };
    ChartInternal.prototype.initGauge = function() {
        var arcs = this.arcs;
        if (this.hasType("gauge")) {
            arcs.append("g").attr("class", CLASS.chartArcsBackground);
            arcs.append("text").attr("class", CLASS.chartArcsGaugeUnit).style("text-anchor", "middle").style("pointer-events", "none");
            arcs.append("text").attr("class", CLASS.chartArcsGaugeMin).style("text-anchor", "middle").style("pointer-events", "none");
            arcs.append("text").attr("class", CLASS.chartArcsGaugeMax).style("text-anchor", "middle").style("pointer-events", "none");
        }
    };
    ChartInternal.prototype.getGaugeLabelHeight = function() {
        return this.config.gauge_label_show ? 20 : 0;
    };
    /**
   * Store value into cache
   *
   * @param key
   * @param value
   */ ChartInternal.prototype.addToCache = function(key, value) {
        this.cache["$" + key] = value;
    };
    /**
   * Returns a cached value or undefined
   *
   * @param key
   * @return {*}
   */ ChartInternal.prototype.getFromCache = function(key) {
        return this.cache["$" + key];
    };
    /**
   * Reset cached data
   */ ChartInternal.prototype.resetCache = function() {
        var _this = this;
        Object.keys(this.cache).filter(function(key) {
            return /^\$/.test(key);
        }).forEach(function(key) {
            delete _this.cache[key];
        });
    };
    // Old API that stores Targets
    ChartInternal.prototype.hasCaches = function(ids) {
        for(var i = 0; i < ids.length; i++){
            if (!(ids[i] in this.cache)) return false;
        }
        return true;
    };
    ChartInternal.prototype.addCache = function(id, target) {
        this.cache[id] = this.cloneTarget(target);
    };
    ChartInternal.prototype.getCaches = function(ids) {
        var targets = [], i;
        for(i = 0; i < ids.length; i++)if (ids[i] in this.cache) targets.push(this.cloneTarget(this.cache[ids[i]]));
        return targets;
    };
    ChartInternal.prototype.categoryName = function(i) {
        var config = this.config;
        return i < config.axis_x_categories.length ? config.axis_x_categories[i] : i;
    };
    ChartInternal.prototype.generateTargetClass = function(targetId) {
        return targetId || targetId === 0 ? ("-" + targetId).replace(/\s/g, "-") : "";
    };
    ChartInternal.prototype.generateClass = function(prefix, targetId) {
        return " " + prefix + " " + prefix + this.generateTargetClass(targetId);
    };
    ChartInternal.prototype.classText = function(d) {
        return this.generateClass(CLASS.text, d.index);
    };
    ChartInternal.prototype.classTexts = function(d) {
        return this.generateClass(CLASS.texts, d.id);
    };
    ChartInternal.prototype.classShape = function(d) {
        return this.generateClass(CLASS.shape, d.index);
    };
    ChartInternal.prototype.classShapes = function(d) {
        return this.generateClass(CLASS.shapes, d.id);
    };
    ChartInternal.prototype.classLine = function(d) {
        return this.classShape(d) + this.generateClass(CLASS.line, d.id);
    };
    ChartInternal.prototype.classLines = function(d) {
        return this.classShapes(d) + this.generateClass(CLASS.lines, d.id);
    };
    ChartInternal.prototype.classCircle = function(d) {
        return this.classShape(d) + this.generateClass(CLASS.circle, d.index);
    };
    ChartInternal.prototype.classCircles = function(d) {
        return this.classShapes(d) + this.generateClass(CLASS.circles, d.id);
    };
    ChartInternal.prototype.classBar = function(d) {
        return this.classShape(d) + this.generateClass(CLASS.bar, d.index);
    };
    ChartInternal.prototype.classBars = function(d) {
        return this.classShapes(d) + this.generateClass(CLASS.bars, d.id);
    };
    ChartInternal.prototype.classArc = function(d) {
        return this.classShape(d.data) + this.generateClass(CLASS.arc, d.data.id);
    };
    ChartInternal.prototype.classArcs = function(d) {
        return this.classShapes(d.data) + this.generateClass(CLASS.arcs, d.data.id);
    };
    ChartInternal.prototype.classArea = function(d) {
        return this.classShape(d) + this.generateClass(CLASS.area, d.id);
    };
    ChartInternal.prototype.classAreas = function(d) {
        return this.classShapes(d) + this.generateClass(CLASS.areas, d.id);
    };
    ChartInternal.prototype.classRegion = function(d, i) {
        return this.generateClass(CLASS.region, i) + " " + ("class" in d ? d["class"] : "");
    };
    ChartInternal.prototype.classEvent = function(d) {
        return this.generateClass(CLASS.eventRect, d.index);
    };
    ChartInternal.prototype.classTarget = function(id) {
        var $$ = this;
        var additionalClassSuffix = $$.config.data_classes[id], additionalClass = "";
        if (additionalClassSuffix) additionalClass = " " + CLASS.target + "-" + additionalClassSuffix;
        return $$.generateClass(CLASS.target, id) + additionalClass;
    };
    ChartInternal.prototype.classFocus = function(d) {
        return this.classFocused(d) + this.classDefocused(d);
    };
    ChartInternal.prototype.classFocused = function(d) {
        return " " + (this.focusedTargetIds.indexOf(d.id) >= 0 ? CLASS.focused : "");
    };
    ChartInternal.prototype.classDefocused = function(d) {
        return " " + (this.defocusedTargetIds.indexOf(d.id) >= 0 ? CLASS.defocused : "");
    };
    ChartInternal.prototype.classChartText = function(d) {
        return CLASS.chartText + this.classTarget(d.id);
    };
    ChartInternal.prototype.classChartLine = function(d) {
        return CLASS.chartLine + this.classTarget(d.id);
    };
    ChartInternal.prototype.classChartBar = function(d) {
        return CLASS.chartBar + this.classTarget(d.id);
    };
    ChartInternal.prototype.classChartArc = function(d) {
        return CLASS.chartArc + this.classTarget(d.data.id);
    };
    ChartInternal.prototype.getTargetSelectorSuffix = function(targetId) {
        var targetClass = this.generateTargetClass(targetId);
        if (window.CSS && window.CSS.escape) return window.CSS.escape(targetClass);
        // fallback on imperfect method for old browsers (does not handles unicode)
        return targetClass.replace(/([?!@#$%^&*()=+,.<>'":;\[\]\/|~`{}\\])/g, "\\$1");
    };
    ChartInternal.prototype.selectorTarget = function(id, prefix) {
        return (prefix || "") + "." + CLASS.target + this.getTargetSelectorSuffix(id);
    };
    ChartInternal.prototype.selectorTargets = function(ids, prefix) {
        var $$ = this;
        ids = ids || [];
        return ids.length ? ids.map(function(id) {
            return $$.selectorTarget(id, prefix);
        }) : null;
    };
    ChartInternal.prototype.selectorLegend = function(id) {
        return "." + CLASS.legendItem + this.getTargetSelectorSuffix(id);
    };
    ChartInternal.prototype.selectorLegends = function(ids) {
        var $$ = this;
        return ids && ids.length ? ids.map(function(id) {
            return $$.selectorLegend(id);
        }) : null;
    };
    ChartInternal.prototype.getClipPath = function(id) {
        return "url(" + (isIE(9) ? "" : document.URL.split("#")[0]) + "#" + id + ")";
    };
    ChartInternal.prototype.appendClip = function(parent, id) {
        return parent.append("clipPath").attr("id", id).append("rect");
    };
    ChartInternal.prototype.getAxisClipX = function(forHorizontal) {
        // axis line width + padding for left
        var left = Math.max(30, this.margin.left);
        return forHorizontal ? -(1 + left) : -(left - 1);
    };
    ChartInternal.prototype.getAxisClipY = function(forHorizontal) {
        return forHorizontal ? -20 : -this.margin.top;
    };
    ChartInternal.prototype.getXAxisClipX = function() {
        var $$ = this;
        return $$.getAxisClipX(!$$.config.axis_rotated);
    };
    ChartInternal.prototype.getXAxisClipY = function() {
        var $$ = this;
        return $$.getAxisClipY(!$$.config.axis_rotated);
    };
    ChartInternal.prototype.getYAxisClipX = function() {
        var $$ = this;
        return $$.config.axis_y_inner ? -1 : $$.getAxisClipX($$.config.axis_rotated);
    };
    ChartInternal.prototype.getYAxisClipY = function() {
        var $$ = this;
        return $$.getAxisClipY($$.config.axis_rotated);
    };
    ChartInternal.prototype.getAxisClipWidth = function(forHorizontal) {
        var $$ = this, left = Math.max(30, $$.margin.left), right = Math.max(30, $$.margin.right);
        // width + axis line width + padding for left/right
        return forHorizontal ? $$.width + 2 + left + right : $$.margin.left + 20;
    };
    ChartInternal.prototype.getAxisClipHeight = function(forHorizontal) {
        // less than 20 is not enough to show the axis label 'outer' without legend
        return (forHorizontal ? this.margin.bottom : this.margin.top + this.height) + 20;
    };
    ChartInternal.prototype.getXAxisClipWidth = function() {
        var $$ = this;
        return $$.getAxisClipWidth(!$$.config.axis_rotated);
    };
    ChartInternal.prototype.getXAxisClipHeight = function() {
        var $$ = this;
        return $$.getAxisClipHeight(!$$.config.axis_rotated);
    };
    ChartInternal.prototype.getYAxisClipWidth = function() {
        var $$ = this;
        return $$.getAxisClipWidth($$.config.axis_rotated) + ($$.config.axis_y_inner ? 20 : 0);
    };
    ChartInternal.prototype.getYAxisClipHeight = function() {
        var $$ = this;
        return $$.getAxisClipHeight($$.config.axis_rotated);
    };
    ChartInternal.prototype.generateColor = function() {
        var $$ = this, config = $$.config, d3 = $$.d3, colors = config.data_colors, pattern = notEmpty(config.color_pattern) ? config.color_pattern : d3.schemeCategory10, callback = config.data_color, ids = [];
        return function(d) {
            var id = d.id || d.data && d.data.id || d, color;
            // if callback function is provided
            if (colors[id] instanceof Function) color = colors[id](d);
            else if (colors[id]) color = colors[id];
            else {
                if (ids.indexOf(id) < 0) ids.push(id);
                color = pattern[ids.indexOf(id) % pattern.length];
                colors[id] = color;
            }
            return callback instanceof Function ? callback(color, d) : color;
        };
    };
    ChartInternal.prototype.generateLevelColor = function() {
        var $$ = this, config = $$.config, colors = config.color_pattern, threshold = config.color_threshold, asValue = threshold.unit === "value", values = threshold.values && threshold.values.length ? threshold.values : [], max = threshold.max || 100;
        return notEmpty(threshold) && notEmpty(colors) ? function(value) {
            var i, v, color = colors[colors.length - 1];
            for(i = 0; i < values.length; i++){
                v = asValue ? value : value * 100 / max;
                if (v < values[i]) {
                    color = colors[i];
                    break;
                }
            }
            return color;
        } : null;
    };
    ChartInternal.prototype.getDefaultConfig = function() {
        var config = {
            bindto: "#chart",
            svg_classname: undefined,
            size_width: undefined,
            size_height: undefined,
            padding_left: undefined,
            padding_right: undefined,
            padding_top: undefined,
            padding_bottom: undefined,
            resize_auto: true,
            zoom_enabled: false,
            zoom_initialRange: undefined,
            zoom_type: "scroll",
            zoom_disableDefaultBehavior: false,
            zoom_privileged: false,
            zoom_rescale: false,
            zoom_onzoom: function() {},
            zoom_onzoomstart: function() {},
            zoom_onzoomend: function() {},
            zoom_x_min: undefined,
            zoom_x_max: undefined,
            interaction_brighten: true,
            interaction_enabled: true,
            onmouseover: function() {},
            onmouseout: function() {},
            onresize: function() {},
            onresized: function() {},
            oninit: function() {},
            onrendered: function() {},
            transition_duration: 350,
            data_epochs: "epochs",
            data_x: undefined,
            data_xs: {},
            data_xFormat: "%Y-%m-%d",
            data_xLocaltime: true,
            data_xSort: true,
            data_idConverter: function(id) {
                return id;
            },
            data_names: {},
            data_classes: {},
            data_groups: [],
            data_axes: {},
            data_type: undefined,
            data_types: {},
            data_labels: {},
            data_order: "desc",
            data_regions: {},
            data_color: undefined,
            data_colors: {},
            data_hide: false,
            data_filter: undefined,
            data_selection_enabled: false,
            data_selection_grouped: false,
            data_selection_isselectable: function() {
                return true;
            },
            data_selection_multiple: true,
            data_selection_draggable: false,
            data_stack_normalize: false,
            data_onclick: function() {},
            data_onmouseover: function() {},
            data_onmouseout: function() {},
            data_onselected: function() {},
            data_onunselected: function() {},
            data_url: undefined,
            data_headers: undefined,
            data_json: undefined,
            data_rows: undefined,
            data_columns: undefined,
            data_mimeType: undefined,
            data_keys: undefined,
            // configuration for no plot-able data supplied.
            data_empty_label_text: "",
            // subchart
            subchart_show: false,
            subchart_size_height: 60,
            subchart_axis_x_show: true,
            subchart_onbrush: function() {},
            // color
            color_pattern: [],
            color_threshold: {},
            // legend
            legend_show: true,
            legend_hide: false,
            legend_position: "bottom",
            legend_inset_anchor: "top-left",
            legend_inset_x: 10,
            legend_inset_y: 0,
            legend_inset_step: undefined,
            legend_item_onclick: undefined,
            legend_item_onmouseover: undefined,
            legend_item_onmouseout: undefined,
            legend_equally: false,
            legend_padding: 0,
            legend_item_tile_width: 10,
            legend_item_tile_height: 10,
            // axis
            axis_rotated: false,
            axis_x_show: true,
            axis_x_type: "indexed",
            axis_x_localtime: true,
            axis_x_categories: [],
            axis_x_tick_centered: false,
            axis_x_tick_format: undefined,
            axis_x_tick_culling: {},
            axis_x_tick_culling_max: 10,
            axis_x_tick_count: undefined,
            axis_x_tick_fit: true,
            axis_x_tick_values: null,
            axis_x_tick_rotate: 0,
            axis_x_tick_outer: true,
            axis_x_tick_multiline: true,
            axis_x_tick_multilineMax: 0,
            axis_x_tick_width: null,
            axis_x_max: undefined,
            axis_x_min: undefined,
            axis_x_padding: {},
            axis_x_height: undefined,
            axis_x_selection: undefined,
            axis_x_label: {},
            axis_x_inner: undefined,
            axis_y_show: true,
            axis_y_type: "linear",
            axis_y_max: undefined,
            axis_y_min: undefined,
            axis_y_inverted: false,
            axis_y_center: undefined,
            axis_y_inner: undefined,
            axis_y_label: {},
            axis_y_tick_format: undefined,
            axis_y_tick_outer: true,
            axis_y_tick_values: null,
            axis_y_tick_rotate: 0,
            axis_y_tick_count: undefined,
            axis_y_tick_time_type: undefined,
            axis_y_tick_time_interval: undefined,
            axis_y_padding: {},
            axis_y_default: undefined,
            axis_y2_show: false,
            axis_y2_type: "linear",
            axis_y2_max: undefined,
            axis_y2_min: undefined,
            axis_y2_inverted: false,
            axis_y2_center: undefined,
            axis_y2_inner: undefined,
            axis_y2_label: {},
            axis_y2_tick_format: undefined,
            axis_y2_tick_outer: true,
            axis_y2_tick_values: null,
            axis_y2_tick_count: undefined,
            axis_y2_padding: {},
            axis_y2_default: undefined,
            // grid
            grid_x_show: false,
            grid_x_type: "tick",
            grid_x_lines: [],
            grid_y_show: false,
            // not used
            // grid_y_type: 'tick',
            grid_y_lines: [],
            grid_y_ticks: 10,
            grid_focus_show: true,
            grid_lines_front: true,
            // point - point of each data
            point_show: true,
            point_r: 2.5,
            point_sensitivity: 10,
            point_focus_expand_enabled: true,
            point_focus_expand_r: undefined,
            point_select_r: undefined,
            // line
            line_connectNull: false,
            line_step_type: "step",
            // bar
            bar_width: undefined,
            bar_width_ratio: 0.6,
            bar_width_max: undefined,
            bar_zerobased: true,
            bar_space: 0,
            // area
            area_zerobased: true,
            area_above: false,
            // pie
            pie_label_show: true,
            pie_label_format: undefined,
            pie_label_threshold: 0.05,
            pie_label_ratio: undefined,
            pie_expand: {},
            pie_expand_duration: 50,
            pie_padAngle: 0,
            // gauge
            gauge_fullCircle: false,
            gauge_label_show: true,
            gauge_labelLine_show: true,
            gauge_label_format: undefined,
            gauge_min: 0,
            gauge_max: 100,
            gauge_startingAngle: -1 * Math.PI / 2,
            gauge_label_extents: undefined,
            gauge_units: undefined,
            gauge_width: undefined,
            gauge_arcs_minWidth: 5,
            gauge_expand: {},
            gauge_expand_duration: 50,
            // donut
            donut_label_show: true,
            donut_label_format: undefined,
            donut_label_threshold: 0.05,
            donut_label_ratio: undefined,
            donut_width: undefined,
            donut_title: "",
            donut_expand: {},
            donut_expand_duration: 50,
            donut_padAngle: 0,
            // spline
            spline_interpolation_type: "cardinal",
            // stanford
            stanford_lines: [],
            stanford_regions: [],
            stanford_texts: [],
            stanford_scaleMin: undefined,
            stanford_scaleMax: undefined,
            stanford_scaleWidth: undefined,
            stanford_scaleFormat: undefined,
            stanford_scaleValues: undefined,
            stanford_colors: undefined,
            stanford_padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            // region - region to change style
            regions: [],
            // tooltip - show when mouseover on each data
            tooltip_show: true,
            tooltip_grouped: true,
            tooltip_order: undefined,
            tooltip_format_title: undefined,
            tooltip_format_name: undefined,
            tooltip_format_value: undefined,
            tooltip_horizontal: undefined,
            tooltip_position: undefined,
            tooltip_contents: function(d, defaultTitleFormat, defaultValueFormat, color) {
                return this.getTooltipContent ? this.getTooltipContent(d, defaultTitleFormat, defaultValueFormat, color) : "";
            },
            tooltip_init_show: false,
            tooltip_init_x: 0,
            tooltip_init_position: {
                top: "0px",
                left: "50px"
            },
            tooltip_onshow: function() {},
            tooltip_onhide: function() {},
            // title
            title_text: undefined,
            title_padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            title_position: "top-center"
        };
        Object.keys(this.additionalConfig).forEach(function(key) {
            config[key] = this.additionalConfig[key];
        }, this);
        return config;
    };
    ChartInternal.prototype.additionalConfig = {};
    ChartInternal.prototype.loadConfig = function(config) {
        var this_config = this.config, target, keys, read;
        function find() {
            var key = keys.shift();
            //        console.log("key =>", key, ", target =>", target);
            if (key && target && typeof target === "object" && key in target) {
                target = target[key];
                return find();
            } else if (!key) return target;
            else return undefined;
        }
        Object.keys(this_config).forEach(function(key) {
            target = config;
            keys = key.split("_");
            read = find();
            //        console.log("CONFIG : ", key, read);
            if (isDefined(read)) this_config[key] = read;
        });
    };
    ChartInternal.prototype.convertUrlToData = function(url, mimeType, headers, keys, done) {
        var $$ = this, type = mimeType ? mimeType : "csv", f, converter;
        if (type === "json") {
            f = $$.d3.json;
            converter = $$.convertJsonToData;
        } else if (type === "tsv") {
            f = $$.d3.tsv;
            converter = $$.convertXsvToData;
        } else {
            f = $$.d3.csv;
            converter = $$.convertXsvToData;
        }
        f(url, headers).then(function(data) {
            done.call($$, converter.call($$, data, keys));
        }).catch(function(error) {
            throw error;
        });
    };
    ChartInternal.prototype.convertXsvToData = function(xsv) {
        var keys = xsv.columns, rows = xsv;
        if (rows.length === 0) return {
            keys: keys,
            rows: [
                keys.reduce(function(row, key) {
                    var _a;
                    return Object.assign(row, (_a = {}, _a[key] = null, _a));
                }, {})
            ]
        };
        else // [].concat() is to convert result into a plain array otherwise
        // test is not happy because rows have properties.
        return {
            keys: keys,
            rows: [].concat(xsv)
        };
    };
    ChartInternal.prototype.convertJsonToData = function(json, keys) {
        var $$ = this, new_rows = [], targetKeys, data;
        if (keys) {
            // when keys specified, json would be an array that includes objects
            if (keys.x) {
                targetKeys = keys.value.concat(keys.x);
                $$.config.data_x = keys.x;
            } else targetKeys = keys.value;
            new_rows.push(targetKeys);
            json.forEach(function(o) {
                var new_row = [];
                targetKeys.forEach(function(key) {
                    // convert undefined to null because undefined data will be removed in convertDataToTargets()
                    var v = $$.findValueInJson(o, key);
                    if (isUndefined(v)) v = null;
                    new_row.push(v);
                });
                new_rows.push(new_row);
            });
            data = $$.convertRowsToData(new_rows);
        } else {
            Object.keys(json).forEach(function(key) {
                new_rows.push([
                    key
                ].concat(json[key]));
            });
            data = $$.convertColumnsToData(new_rows);
        }
        return data;
    };
    /**
   * Finds value from the given nested object by the given path.
   * If it's not found, then this returns undefined.
   * @param {Object} object the object
   * @param {string} path the path
   */ ChartInternal.prototype.findValueInJson = function(object, path) {
        if (path in object) // If object has a key that contains . or [], return the key's value
        // instead of searching for an inner object.
        // See https://github.com/c3js/c3/issues/1691 for details.
        return object[path];
        path = path.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties (replace [] with .)
        path = path.replace(/^\./, ""); // strip a leading dot
        var pathArray = path.split(".");
        for(var i = 0; i < pathArray.length; ++i){
            var k = pathArray[i];
            if (k in object) object = object[k];
            else return;
        }
        return object;
    };
    /**
   * Converts the rows to normalized data.
   * @param {any[][]} rows The row data
   * @return {Object}
   */ ChartInternal.prototype.convertRowsToData = function(rows) {
        var newRows = [];
        var keys = rows[0];
        for(var i = 1; i < rows.length; i++){
            var newRow = {};
            for(var j = 0; j < rows[i].length; j++){
                if (isUndefined(rows[i][j])) throw new Error("Source data is missing a component at (" + i + "," + j + ")!");
                newRow[keys[j]] = rows[i][j];
            }
            newRows.push(newRow);
        }
        return {
            keys: keys,
            rows: newRows
        };
    };
    /**
   * Converts the columns to normalized data.
   * @param {any[][]} columns The column data
   * @return {Object}
   */ ChartInternal.prototype.convertColumnsToData = function(columns) {
        var newRows = [];
        var keys = [];
        for(var i = 0; i < columns.length; i++){
            var key = columns[i][0];
            for(var j = 1; j < columns[i].length; j++){
                if (isUndefined(newRows[j - 1])) newRows[j - 1] = {};
                if (isUndefined(columns[i][j])) throw new Error("Source data is missing a component at (" + i + "," + j + ")!");
                newRows[j - 1][key] = columns[i][j];
            }
            keys.push(key);
        }
        return {
            keys: keys,
            rows: newRows
        };
    };
    /**
   * Converts the data format into the target format.
   * @param {!Object} data
   * @param {!Array} data.keys Ordered list of target IDs.
   * @param {!Array} data.rows Rows of data to convert.
   * @param {boolean} appendXs True to append to $$.data.xs, False to replace.
   * @return {!Array}
   */ ChartInternal.prototype.convertDataToTargets = function(data, appendXs) {
        var $$ = this, config = $$.config, targets, ids, xs, keys, epochs;
        // handles format where keys are not orderly provided
        if (isArray(data)) keys = Object.keys(data[0]);
        else {
            keys = data.keys;
            data = data.rows;
        }
        xs = keys.filter($$.isX, $$);
        if (!$$.isStanfordGraphType()) ids = keys.filter($$.isNotX, $$);
        else {
            epochs = keys.filter($$.isEpochs, $$);
            ids = keys.filter($$.isNotXAndNotEpochs, $$);
            if (xs.length !== 1 || epochs.length !== 1 || ids.length !== 1) throw new Error("You must define the 'x' key name and the 'epochs' for Stanford Diagrams");
        }
        // save x for update data by load when custom x and c3.x API
        ids.forEach(function(id) {
            var xKey = $$.getXKey(id);
            if ($$.isCustomX() || $$.isTimeSeries()) {
                // if included in input data
                if (xs.indexOf(xKey) >= 0) $$.data.xs[id] = (appendXs && $$.data.xs[id] ? $$.data.xs[id] : []).concat(data.map(function(d) {
                    return d[xKey];
                }).filter(isValue).map(function(rawX, i) {
                    return $$.generateTargetX(rawX, id, i);
                }));
                else if (config.data_x) $$.data.xs[id] = $$.getOtherTargetXs();
                else if (notEmpty(config.data_xs)) $$.data.xs[id] = $$.getXValuesOfXKey(xKey, $$.data.targets);
            // MEMO: if no x included, use same x of current will be used
            } else $$.data.xs[id] = data.map(function(d, i) {
                return i;
            });
        });
        // check x is defined
        ids.forEach(function(id) {
            if (!$$.data.xs[id]) throw new Error('x is not defined for id = "' + id + '".');
        });
        // convert to target
        targets = ids.map(function(id, index) {
            var convertedId = config.data_idConverter(id);
            return {
                id: convertedId,
                id_org: id,
                values: data.map(function(d, i) {
                    var xKey = $$.getXKey(id), rawX = d[xKey], value = d[id] !== null && !isNaN(d[id]) ? +d[id] : null, x, returnData;
                    // use x as categories if custom x and categorized
                    if ($$.isCustomX() && $$.isCategorized() && !isUndefined(rawX)) {
                        if (index === 0 && i === 0) config.axis_x_categories = [];
                        x = config.axis_x_categories.indexOf(rawX);
                        if (x === -1) {
                            x = config.axis_x_categories.length;
                            config.axis_x_categories.push(rawX);
                        }
                    } else x = $$.generateTargetX(rawX, id, i);
                    // mark as x = undefined if value is undefined and filter to remove after mapped
                    if (isUndefined(d[id]) || $$.data.xs[id].length <= i) x = undefined;
                    returnData = {
                        x: x,
                        value: value,
                        id: convertedId
                    };
                    if ($$.isStanfordGraphType()) returnData.epochs = d[epochs];
                    return returnData;
                }).filter(function(v) {
                    return isDefined(v.x);
                })
            };
        });
        // finish targets
        targets.forEach(function(t) {
            var i;
            // sort values by its x
            if (config.data_xSort) t.values = t.values.sort(function(v1, v2) {
                var x1 = v1.x || v1.x === 0 ? v1.x : Infinity, x2 = v2.x || v2.x === 0 ? v2.x : Infinity;
                return x1 - x2;
            });
            // indexing each value
            i = 0;
            t.values.forEach(function(v) {
                v.index = i++;
            });
            // this needs to be sorted because its index and value.index is identical
            $$.data.xs[t.id].sort(function(v1, v2) {
                return v1 - v2;
            });
        });
        // cache information about values
        $$.hasNegativeValue = $$.hasNegativeValueInTargets(targets);
        $$.hasPositiveValue = $$.hasPositiveValueInTargets(targets);
        // set target types
        if (config.data_type) $$.setTargetType($$.mapToIds(targets).filter(function(id) {
            return !(id in config.data_types);
        }), config.data_type);
        // cache as original id keyed
        targets.forEach(function(d) {
            $$.addCache(d.id_org, d);
        });
        return targets;
    };
    ChartInternal.prototype.isEpochs = function(key) {
        var $$ = this, config = $$.config;
        return config.data_epochs && key === config.data_epochs;
    };
    ChartInternal.prototype.isX = function(key) {
        var $$ = this, config = $$.config;
        return config.data_x && key === config.data_x || notEmpty(config.data_xs) && hasValue(config.data_xs, key);
    };
    ChartInternal.prototype.isNotX = function(key) {
        return !this.isX(key);
    };
    ChartInternal.prototype.isNotXAndNotEpochs = function(key) {
        return !this.isX(key) && !this.isEpochs(key);
    };
    /**
   * Returns whether the normalized stack option is enabled or not.
   *
   * To be enabled it must also have data.groups defined.
   *
   * @return {boolean}
   */ ChartInternal.prototype.isStackNormalized = function() {
        return this.config.data_stack_normalize && this.config.data_groups.length > 0;
    };
    /**
   * Returns whether the axis is normalized or not.
   *
   * An axis is normalized as long as one of its associated target
   * is normalized.
   *
   * @param axisId Axis ID (y or y2)
   * @return {Boolean}
   */ ChartInternal.prototype.isAxisNormalized = function(axisId) {
        var $$ = this;
        if (!$$.isStackNormalized()) // shortcut
        return false;
        return $$.data.targets.filter(function(target) {
            return $$.axis.getId(target.id) === axisId;
        }).some(function(target) {
            return $$.isTargetNormalized(target.id);
        });
    };
    /**
   * Returns whether the values for this target ID is normalized or not.
   *
   * To be normalized the option needs to be enabled and target needs
   * to be defined in `data.groups`.
   *
   * @param targetId ID of the target
   * @return {Boolean} True if the target is normalized, false otherwise.
   */ ChartInternal.prototype.isTargetNormalized = function(targetId) {
        var $$ = this;
        return $$.isStackNormalized() && $$.config.data_groups.some(function(group) {
            return group.includes(targetId);
        });
    };
    ChartInternal.prototype.getXKey = function(id) {
        var $$ = this, config = $$.config;
        return config.data_x ? config.data_x : notEmpty(config.data_xs) ? config.data_xs[id] : null;
    };
    /**
   * Get sum of visible data per index for given axis.
   *
   * Expect axisId to be either 'y' or 'y2'.
   *
   * @private
   * @param axisId Compute sum for data associated to given axis.
   * @return {Array}
   */ ChartInternal.prototype.getTotalPerIndex = function(axisId) {
        var $$ = this;
        if (!$$.isStackNormalized()) return null;
        var cached = $$.getFromCache("getTotalPerIndex");
        if (cached !== undefined) return cached[axisId];
        var sum = {
            y: [],
            y2: []
        };
        $$.data.targets// keep only target that are normalized
        .filter(function(target) {
            return $$.isTargetNormalized(target.id);
        })// keep only target that are visible
        .filter(function(target) {
            return $$.isTargetToShow(target.id);
        })// compute sum per axis
        .forEach(function(target) {
            var sumByAxis = sum[$$.axis.getId(target.id)];
            target.values.forEach(function(v, i) {
                if (!sumByAxis[i]) sumByAxis[i] = 0;
                sumByAxis[i] += isNumber(v.value) ? v.value : 0;
            });
        });
        $$.addToCache("getTotalPerIndex", sum);
        return sum[axisId];
    };
    /**
   * Get sum of visible data.
   *
   * Should be used for normalised data only since all values
   * are expected to be positive.
   *
   * @private
   * @return {Number}
   */ ChartInternal.prototype.getTotalDataSum = function() {
        var $$ = this;
        var cached = $$.getFromCache("getTotalDataSum");
        if (cached !== undefined) return cached;
        var totalDataSum = flattenArray($$.data.targets.filter(function(target) {
            return $$.isTargetToShow(target.id);
        }).map(function(target) {
            return target.values;
        })).map(function(d) {
            return d.value;
        }).reduce(function(p, c) {
            return p + c;
        }, 0);
        $$.addToCache("getTotalDataSum", totalDataSum);
        return totalDataSum;
    };
    ChartInternal.prototype.getXValuesOfXKey = function(key, targets) {
        var $$ = this, xValues, ids = targets && notEmpty(targets) ? $$.mapToIds(targets) : [];
        ids.forEach(function(id) {
            if ($$.getXKey(id) === key) xValues = $$.data.xs[id];
        });
        return xValues;
    };
    ChartInternal.prototype.getXValue = function(id, i) {
        var $$ = this;
        return id in $$.data.xs && $$.data.xs[id] && isValue($$.data.xs[id][i]) ? $$.data.xs[id][i] : i;
    };
    ChartInternal.prototype.getOtherTargetXs = function() {
        var $$ = this, idsForX = Object.keys($$.data.xs);
        return idsForX.length ? $$.data.xs[idsForX[0]] : null;
    };
    ChartInternal.prototype.getOtherTargetX = function(index) {
        var xs = this.getOtherTargetXs();
        return xs && index < xs.length ? xs[index] : null;
    };
    ChartInternal.prototype.addXs = function(xs) {
        var $$ = this;
        Object.keys(xs).forEach(function(id) {
            $$.config.data_xs[id] = xs[id];
        });
    };
    ChartInternal.prototype.addName = function(data) {
        var $$ = this, name;
        if (data) {
            name = $$.config.data_names[data.id];
            data.name = name !== undefined ? name : data.id;
        }
        return data;
    };
    ChartInternal.prototype.getValueOnIndex = function(values, index) {
        var valueOnIndex = values.filter(function(v) {
            return v.index === index;
        });
        return valueOnIndex.length ? valueOnIndex[0] : null;
    };
    ChartInternal.prototype.updateTargetX = function(targets, x) {
        var $$ = this;
        targets.forEach(function(t) {
            t.values.forEach(function(v, i) {
                v.x = $$.generateTargetX(x[i], t.id, i);
            });
            $$.data.xs[t.id] = x;
        });
    };
    ChartInternal.prototype.updateTargetXs = function(targets, xs) {
        var $$ = this;
        targets.forEach(function(t) {
            if (xs[t.id]) $$.updateTargetX([
                t
            ], xs[t.id]);
        });
    };
    ChartInternal.prototype.generateTargetX = function(rawX, id, index) {
        var $$ = this, x;
        if ($$.isTimeSeries()) x = rawX ? $$.parseDate(rawX) : $$.parseDate($$.getXValue(id, index));
        else if ($$.isCustomX() && !$$.isCategorized()) x = isValue(rawX) ? +rawX : $$.getXValue(id, index);
        else x = index;
        return x;
    };
    ChartInternal.prototype.cloneTarget = function(target) {
        return {
            id: target.id,
            id_org: target.id_org,
            values: target.values.map(function(d) {
                return {
                    x: d.x,
                    value: d.value,
                    id: d.id
                };
            })
        };
    };
    ChartInternal.prototype.getMaxDataCount = function() {
        var $$ = this;
        return $$.d3.max($$.data.targets, function(t) {
            return t.values.length;
        });
    };
    ChartInternal.prototype.mapToIds = function(targets) {
        return targets.map(function(d) {
            return d.id;
        });
    };
    ChartInternal.prototype.mapToTargetIds = function(ids) {
        var $$ = this;
        return ids ? [].concat(ids) : $$.mapToIds($$.data.targets);
    };
    ChartInternal.prototype.hasTarget = function(targets, id) {
        var ids = this.mapToIds(targets), i;
        for(i = 0; i < ids.length; i++){
            if (ids[i] === id) return true;
        }
        return false;
    };
    ChartInternal.prototype.isTargetToShow = function(targetId) {
        return this.hiddenTargetIds.indexOf(targetId) < 0;
    };
    ChartInternal.prototype.isLegendToShow = function(targetId) {
        return this.hiddenLegendIds.indexOf(targetId) < 0;
    };
    /**
   * Returns only visible targets.
   *
   * This is the same as calling {@link filterTargetsToShow} on $$.data.targets.
   *
   * @return {Array}
   */ ChartInternal.prototype.getTargetsToShow = function() {
        var $$ = this;
        return $$.filterTargetsToShow($$.data.targets);
    };
    ChartInternal.prototype.filterTargetsToShow = function(targets) {
        var $$ = this;
        return targets.filter(function(t) {
            return $$.isTargetToShow(t.id);
        });
    };
    /**
   * @return {Array} Returns all the targets attached to the chart, visible or not
   */ ChartInternal.prototype.getTargets = function() {
        var $$ = this;
        return $$.data.targets;
    };
    ChartInternal.prototype.mapTargetsToUniqueXs = function(targets) {
        var $$ = this;
        var xs = $$.d3.set($$.d3.merge(targets.map(function(t) {
            return t.values.map(function(v) {
                return +v.x;
            });
        }))).values();
        xs = $$.isTimeSeries() ? xs.map(function(x) {
            return new Date(+x);
        }) : xs.map(function(x) {
            return +x;
        });
        return xs.sort(function(a, b) {
            return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
        });
    };
    ChartInternal.prototype.addHiddenTargetIds = function(targetIds) {
        targetIds = targetIds instanceof Array ? targetIds : new Array(targetIds);
        for(var i = 0; i < targetIds.length; i++)if (this.hiddenTargetIds.indexOf(targetIds[i]) < 0) this.hiddenTargetIds = this.hiddenTargetIds.concat(targetIds[i]);
        this.resetCache();
    };
    ChartInternal.prototype.removeHiddenTargetIds = function(targetIds) {
        this.hiddenTargetIds = this.hiddenTargetIds.filter(function(id) {
            return targetIds.indexOf(id) < 0;
        });
        this.resetCache();
    };
    ChartInternal.prototype.addHiddenLegendIds = function(targetIds) {
        targetIds = targetIds instanceof Array ? targetIds : new Array(targetIds);
        for(var i = 0; i < targetIds.length; i++)if (this.hiddenLegendIds.indexOf(targetIds[i]) < 0) this.hiddenLegendIds = this.hiddenLegendIds.concat(targetIds[i]);
    };
    ChartInternal.prototype.removeHiddenLegendIds = function(targetIds) {
        this.hiddenLegendIds = this.hiddenLegendIds.filter(function(id) {
            return targetIds.indexOf(id) < 0;
        });
    };
    ChartInternal.prototype.getValuesAsIdKeyed = function(targets) {
        var ys = {};
        targets.forEach(function(t) {
            ys[t.id] = [];
            t.values.forEach(function(v) {
                ys[t.id].push(v.value);
            });
        });
        return ys;
    };
    ChartInternal.prototype.checkValueInTargets = function(targets, checker) {
        var ids = Object.keys(targets), i, j, values;
        for(i = 0; i < ids.length; i++){
            values = targets[ids[i]].values;
            for(j = 0; j < values.length; j++){
                if (checker(values[j].value)) return true;
            }
        }
        return false;
    };
    ChartInternal.prototype.hasNegativeValueInTargets = function(targets) {
        return this.checkValueInTargets(targets, function(v) {
            return v < 0;
        });
    };
    ChartInternal.prototype.hasPositiveValueInTargets = function(targets) {
        return this.checkValueInTargets(targets, function(v) {
            return v > 0;
        });
    };
    ChartInternal.prototype.isOrderDesc = function() {
        var config = this.config;
        return typeof config.data_order === "string" && config.data_order.toLowerCase() === "desc";
    };
    ChartInternal.prototype.isOrderAsc = function() {
        var config = this.config;
        return typeof config.data_order === "string" && config.data_order.toLowerCase() === "asc";
    };
    ChartInternal.prototype.getOrderFunction = function() {
        var $$ = this, config = $$.config, orderAsc = $$.isOrderAsc(), orderDesc = $$.isOrderDesc();
        if (orderAsc || orderDesc) {
            var reducer = function(p, c) {
                return p + Math.abs(c.value);
            };
            return function(t1, t2) {
                var t1Sum = t1.values.reduce(reducer, 0), t2Sum = t2.values.reduce(reducer, 0);
                return orderAsc ? t2Sum - t1Sum : t1Sum - t2Sum;
            };
        } else if (isFunction(config.data_order)) return config.data_order;
        else if (isArray(config.data_order)) {
            var order = config.data_order;
            return function(t1, t2) {
                return order.indexOf(t1.id) - order.indexOf(t2.id);
            };
        }
    };
    ChartInternal.prototype.orderTargets = function(targets) {
        var fct = this.getOrderFunction();
        if (fct) targets.sort(fct);
        return targets;
    };
    /**
   * Returns all the values from the given targets at the given index.
   *
   * @param {Array} targets
   * @param {Number} index
   * @return {Array}
   */ ChartInternal.prototype.filterByIndex = function(targets, index) {
        return this.d3.merge(targets.map(function(t) {
            return t.values.filter(function(v) {
                return v.index === index;
            });
        }));
    };
    ChartInternal.prototype.filterByX = function(targets, x) {
        return this.d3.merge(targets.map(function(t) {
            return t.values;
        })).filter(function(v) {
            return v.x - x === 0;
        });
    };
    ChartInternal.prototype.filterRemoveNull = function(data) {
        return data.filter(function(d) {
            return isValue(d.value);
        });
    };
    ChartInternal.prototype.filterByXDomain = function(targets, xDomain) {
        return targets.map(function(t) {
            return {
                id: t.id,
                id_org: t.id_org,
                values: t.values.filter(function(v) {
                    return xDomain[0] <= v.x && v.x <= xDomain[1];
                })
            };
        });
    };
    ChartInternal.prototype.hasDataLabel = function() {
        var config = this.config;
        if (typeof config.data_labels === "boolean" && config.data_labels) return true;
        else if (typeof config.data_labels === "object" && notEmpty(config.data_labels)) return true;
        return false;
    };
    ChartInternal.prototype.getDataLabelLength = function(min, max, key) {
        var $$ = this, lengths = [
            0,
            0
        ], paddingCoef = 1.3;
        $$.selectChart.select("svg").selectAll(".dummy").data([
            min,
            max
        ]).enter().append("text").text(function(d) {
            return $$.dataLabelFormat(d.id)(d);
        }).each(function(d, i) {
            lengths[i] = getBBox(this)[key] * paddingCoef;
        }).remove();
        return lengths;
    };
    /**
   * Returns true if the given data point is not arc type, otherwise false.
   * @param {Object} d The data point
   * @return {boolean}
   */ ChartInternal.prototype.isNoneArc = function(d) {
        return this.hasTarget(this.data.targets, d.id);
    };
    /**
   * Returns true if the given data point is arc type, otherwise false.
   * @param {Object} d The data point
   * @return {boolean}
   */ ChartInternal.prototype.isArc = function(d) {
        return "data" in d && this.hasTarget(this.data.targets, d.data.id);
    };
    /**
   * Find the closest point from the given pos among the given targets or
   * undefined if none satisfies conditions.
   *
   * @param {Array} targets
   * @param {Array} pos An [x,y] coordinate
   * @return {Object|undefined}
   */ ChartInternal.prototype.findClosestFromTargets = function(targets, pos) {
        var $$ = this;
        // for each target, find the closest point
        var candidates = targets.map(function(t) {
            return $$.findClosest(t.values, pos, $$.config.tooltip_horizontal ? $$.horizontalDistance.bind($$) : $$.dist.bind($$), $$.config.point_sensitivity);
        }).filter(function(v) {
            return v;
        });
        // returns the closest of candidates
        if (candidates.length === 0) return undefined;
        else if (candidates.length === 1) return candidates[0];
        else return $$.findClosest(candidates, pos, $$.dist.bind($$));
    };
    /**
   * Find the closest point from the x value or undefined if none satisfies conditions.
   *
   * @param {Array} targets
   * @param {Array} x A value on X axis
   * @return {Object|undefined}
   */ ChartInternal.prototype.findClosestFromTargetsByX = function(targets, x) {
        var closest;
        var diff;
        targets.forEach(function(t) {
            t.values.forEach(function(d) {
                var newDiff = Math.abs(x - d.x);
                if (diff === undefined || newDiff < diff) {
                    closest = d;
                    diff = newDiff;
                }
            });
        });
        return closest;
    };
    /**
   * Using given compute distance method, returns the closest data point from the
   * given position.
   *
   * Giving optionally a minimum distance to satisfy.
   *
   * @param {Array} dataPoints List of DataPoints
   * @param {Array} pos An [x,y] coordinate
   * @param {Function} computeDist Function to compute distance between 2 points
   * @param {Number} minDist Minimal distance to satisfy
   * @return {Object|undefined} Closest data point
   */ ChartInternal.prototype.findClosest = function(dataPoints, pos, computeDist, minDist) {
        if (minDist === void 0) minDist = Infinity;
        var $$ = this;
        var closest;
        // find closest bar
        dataPoints.filter(function(v) {
            return v && $$.isBarType(v.id);
        }).forEach(function(v) {
            if (!closest) {
                var shape = $$.main.select("." + CLASS.bars + $$.getTargetSelectorSuffix(v.id) + " ." + CLASS.bar + "-" + v.index).node();
                if ($$.isWithinBar(pos, shape)) closest = v;
            }
        });
        // find closest point from non-bar
        dataPoints.filter(function(v) {
            return v && !$$.isBarType(v.id);
        }).forEach(function(v) {
            var d = computeDist(v, pos);
            if (d < minDist) {
                minDist = d;
                closest = v;
            }
        });
        return closest;
    };
    ChartInternal.prototype.dist = function(data, pos) {
        var $$ = this, config = $$.config, xIndex = config.axis_rotated ? 1 : 0, yIndex = config.axis_rotated ? 0 : 1, y = $$.circleY(data, data.index), x = $$.x(data.x);
        return Math.sqrt(Math.pow(x - pos[xIndex], 2) + Math.pow(y - pos[yIndex], 2));
    };
    ChartInternal.prototype.horizontalDistance = function(data, pos) {
        var $$ = this, config = $$.config, xIndex = config.axis_rotated ? 1 : 0, x = $$.x(data.x);
        return Math.abs(x - pos[xIndex]);
    };
    ChartInternal.prototype.convertValuesToStep = function(values) {
        var converted = [].concat(values), i;
        if (!this.isCategorized()) return values;
        for(i = values.length + 1; 0 < i; i--)converted[i] = converted[i - 1];
        converted[0] = {
            x: converted[0].x - 1,
            value: converted[0].value,
            id: converted[0].id
        };
        converted[values.length + 1] = {
            x: converted[values.length].x + 1,
            value: converted[values.length].value,
            id: converted[values.length].id
        };
        return converted;
    };
    /**
   * Get ratio value
   *
   * @param {String} type Ratio for given type
   * @param {Object} d Data value object
   * @param {Boolean} asPercent Convert the return as percent or not
   * @return {Number} Ratio value
   * @private
   */ ChartInternal.prototype.getRatio = function(type, d, asPercent) {
        if (asPercent === void 0) asPercent = false;
        var $$ = this;
        var api = $$.api;
        var ratio = 0;
        if (d && api.data.shown.call(api).length) {
            ratio = d.ratio || d.value;
            if (type === "arc") {
                if ($$.hasType("gauge")) ratio = (d.endAngle - d.startAngle) / (Math.PI * ($$.config.gauge_fullCircle ? 2 : 1));
                else {
                    var total = $$.getTotalDataSum();
                    ratio = d.value / total;
                }
            } else if (type === "index") {
                var total = $$.getTotalPerIndex($$.axis.getId(d.id));
                d.ratio = isNumber(d.value) && total && total[d.index] > 0 ? d.value / total[d.index] : 0;
                ratio = d.ratio;
            }
        }
        return asPercent && ratio ? ratio * 100 : ratio;
    };
    ChartInternal.prototype.updateDataAttributes = function(name, attrs) {
        var $$ = this, config = $$.config, current = config["data_" + name];
        if (typeof attrs === "undefined") return current;
        Object.keys(attrs).forEach(function(id) {
            current[id] = attrs[id];
        });
        $$.redraw({
            withLegend: true
        });
        return current;
    };
    ChartInternal.prototype.load = function(targets, args) {
        var $$ = this;
        if (targets) {
            // filter loading targets if needed
            if (args.filter) targets = targets.filter(args.filter);
            // set type if args.types || args.type specified
            if (args.type || args.types) targets.forEach(function(t) {
                var type = args.types && args.types[t.id] ? args.types[t.id] : args.type;
                $$.setTargetType(t.id, type);
            });
            // Update/Add data
            $$.data.targets.forEach(function(d) {
                for(var i = 0; i < targets.length; i++)if (d.id === targets[i].id) {
                    d.values = targets[i].values;
                    targets.splice(i, 1);
                    break;
                }
            });
            $$.data.targets = $$.data.targets.concat(targets); // add remained
        }
        // Set targets
        $$.updateTargets($$.data.targets);
        // Redraw with new targets
        $$.redraw({
            withUpdateOrgXDomain: true,
            withUpdateXDomain: true,
            withLegend: true
        });
        if (args.done) args.done();
    };
    ChartInternal.prototype.loadFromArgs = function(args) {
        var $$ = this;
        $$.resetCache();
        if (args.data) $$.load($$.convertDataToTargets(args.data), args);
        else if (args.url) $$.convertUrlToData(args.url, args.mimeType, args.headers, args.keys, function(data) {
            $$.load($$.convertDataToTargets(data), args);
        });
        else if (args.json) $$.load($$.convertDataToTargets($$.convertJsonToData(args.json, args.keys)), args);
        else if (args.rows) $$.load($$.convertDataToTargets($$.convertRowsToData(args.rows)), args);
        else if (args.columns) $$.load($$.convertDataToTargets($$.convertColumnsToData(args.columns)), args);
        else $$.load(null, args);
    };
    ChartInternal.prototype.unload = function(targetIds, done) {
        var $$ = this;
        $$.resetCache();
        if (!done) done = function() {};
        // filter existing target
        targetIds = targetIds.filter(function(id) {
            return $$.hasTarget($$.data.targets, id);
        });
        // If no target, call done and return
        if (!targetIds || targetIds.length === 0) {
            done();
            return;
        }
        $$.svg.selectAll(targetIds.map(function(id) {
            return $$.selectorTarget(id);
        })).transition().style("opacity", 0).remove().call($$.endall, done);
        targetIds.forEach(function(id) {
            // Reset fadein for future load
            $$.withoutFadeIn[id] = false;
            // Remove target's elements
            if ($$.legend) $$.legend.selectAll("." + CLASS.legendItem + $$.getTargetSelectorSuffix(id)).remove();
            // Remove target
            $$.data.targets = $$.data.targets.filter(function(t) {
                return t.id !== id;
            });
        });
    };
    ChartInternal.prototype.getYDomainMin = function(targets) {
        var $$ = this, config = $$.config, ids = $$.mapToIds(targets), ys = $$.getValuesAsIdKeyed(targets), j, k, baseId, idsInGroup, id, hasNegativeValue;
        if (config.data_groups.length > 0) {
            hasNegativeValue = $$.hasNegativeValueInTargets(targets);
            for(j = 0; j < config.data_groups.length; j++){
                // Determine baseId
                idsInGroup = config.data_groups[j].filter(function(id) {
                    return ids.indexOf(id) >= 0;
                });
                if (idsInGroup.length === 0) continue;
                baseId = idsInGroup[0];
                // Consider negative values
                if (hasNegativeValue && ys[baseId]) ys[baseId].forEach(function(v, i) {
                    ys[baseId][i] = v < 0 ? v : 0;
                });
                // Compute min
                for(k = 1; k < idsInGroup.length; k++){
                    id = idsInGroup[k];
                    if (!ys[id]) continue;
                    ys[id].forEach(function(v, i) {
                        if ($$.axis.getId(id) === $$.axis.getId(baseId) && ys[baseId] && !(hasNegativeValue && +v > 0)) ys[baseId][i] += +v;
                    });
                }
            }
        }
        return $$.d3.min(Object.keys(ys).map(function(key) {
            return $$.d3.min(ys[key]);
        }));
    };
    ChartInternal.prototype.getYDomainMax = function(targets) {
        var $$ = this, config = $$.config, ids = $$.mapToIds(targets), ys = $$.getValuesAsIdKeyed(targets), j, k, baseId, idsInGroup, id, hasPositiveValue;
        if (config.data_groups.length > 0) {
            hasPositiveValue = $$.hasPositiveValueInTargets(targets);
            for(j = 0; j < config.data_groups.length; j++){
                // Determine baseId
                idsInGroup = config.data_groups[j].filter(function(id) {
                    return ids.indexOf(id) >= 0;
                });
                if (idsInGroup.length === 0) continue;
                baseId = idsInGroup[0];
                // Consider positive values
                if (hasPositiveValue && ys[baseId]) ys[baseId].forEach(function(v, i) {
                    ys[baseId][i] = v > 0 ? v : 0;
                });
                // Compute max
                for(k = 1; k < idsInGroup.length; k++){
                    id = idsInGroup[k];
                    if (!ys[id]) continue;
                    ys[id].forEach(function(v, i) {
                        if ($$.axis.getId(id) === $$.axis.getId(baseId) && ys[baseId] && !(hasPositiveValue && +v < 0)) ys[baseId][i] += +v;
                    });
                }
            }
        }
        return $$.d3.max(Object.keys(ys).map(function(key) {
            return $$.d3.max(ys[key]);
        }));
    };
    ChartInternal.prototype.getYDomain = function(targets, axisId, xDomain) {
        var $$ = this, config = $$.config;
        if ($$.isAxisNormalized(axisId)) return [
            0,
            100
        ];
        var targetsByAxisId = targets.filter(function(t) {
            return $$.axis.getId(t.id) === axisId;
        }), yTargets = xDomain ? $$.filterByXDomain(targetsByAxisId, xDomain) : targetsByAxisId, yMin = axisId === "y2" ? config.axis_y2_min : config.axis_y_min, yMax = axisId === "y2" ? config.axis_y2_max : config.axis_y_max, yDomainMin = $$.getYDomainMin(yTargets), yDomainMax = $$.getYDomainMax(yTargets), domain, domainLength, padding_top, padding_bottom, center = axisId === "y2" ? config.axis_y2_center : config.axis_y_center, yDomainAbs, lengths, diff, ratio, isAllPositive, isAllNegative, isZeroBased = $$.hasType("bar", yTargets) && config.bar_zerobased || $$.hasType("area", yTargets) && config.area_zerobased, isInverted = axisId === "y2" ? config.axis_y2_inverted : config.axis_y_inverted, showHorizontalDataLabel = $$.hasDataLabel() && config.axis_rotated, showVerticalDataLabel = $$.hasDataLabel() && !config.axis_rotated;
        // MEMO: avoid inverting domain unexpectedly
        yDomainMin = isValue(yMin) ? yMin : isValue(yMax) ? yDomainMin < yMax ? yDomainMin : yMax - 10 : yDomainMin;
        yDomainMax = isValue(yMax) ? yMax : isValue(yMin) ? yMin < yDomainMax ? yDomainMax : yMin + 10 : yDomainMax;
        if (yTargets.length === 0) // use current domain if target of axisId is none
        return axisId === "y2" ? $$.y2.domain() : $$.y.domain();
        if (isNaN(yDomainMin)) // set minimum to zero when not number
        yDomainMin = 0;
        if (isNaN(yDomainMax)) // set maximum to have same value as yDomainMin
        yDomainMax = yDomainMin;
        if (yDomainMin === yDomainMax) yDomainMin < 0 ? yDomainMax = 0 : yDomainMin = 0;
        isAllPositive = yDomainMin >= 0 && yDomainMax >= 0;
        isAllNegative = yDomainMin <= 0 && yDomainMax <= 0;
        // Cancel zerobased if axis_*_min / axis_*_max specified
        if (isValue(yMin) && isAllPositive || isValue(yMax) && isAllNegative) isZeroBased = false;
        // Bar/Area chart should be 0-based if all positive|negative
        if (isZeroBased) {
            if (isAllPositive) yDomainMin = 0;
            if (isAllNegative) yDomainMax = 0;
        }
        domainLength = Math.abs(yDomainMax - yDomainMin);
        padding_top = padding_bottom = domainLength * 0.1;
        if (typeof center !== "undefined") {
            yDomainAbs = Math.max(Math.abs(yDomainMin), Math.abs(yDomainMax));
            yDomainMax = center + yDomainAbs;
            yDomainMin = center - yDomainAbs;
        }
        // add padding for data label
        if (showHorizontalDataLabel) {
            lengths = $$.getDataLabelLength(yDomainMin, yDomainMax, "width");
            diff = diffDomain($$.y.range());
            ratio = [
                lengths[0] / diff,
                lengths[1] / diff
            ];
            padding_top += domainLength * (ratio[1] / (1 - ratio[0] - ratio[1]));
            padding_bottom += domainLength * (ratio[0] / (1 - ratio[0] - ratio[1]));
        } else if (showVerticalDataLabel) {
            lengths = $$.getDataLabelLength(yDomainMin, yDomainMax, "height");
            var pixelsToAxisPadding = $$.getY(config["axis_" + axisId + "_type"], // input domain as pixels
            [
                0,
                config.axis_rotated ? $$.width : $$.height
            ], // output range as axis padding
            [
                0,
                domainLength
            ]);
            padding_top += pixelsToAxisPadding(lengths[1]);
            padding_bottom += pixelsToAxisPadding(lengths[0]);
        }
        if (axisId === "y" && notEmpty(config.axis_y_padding)) {
            padding_top = $$.axis.getPadding(config.axis_y_padding, "top", padding_top, domainLength);
            padding_bottom = $$.axis.getPadding(config.axis_y_padding, "bottom", padding_bottom, domainLength);
        }
        if (axisId === "y2" && notEmpty(config.axis_y2_padding)) {
            padding_top = $$.axis.getPadding(config.axis_y2_padding, "top", padding_top, domainLength);
            padding_bottom = $$.axis.getPadding(config.axis_y2_padding, "bottom", padding_bottom, domainLength);
        }
        // Bar/Area chart should be 0-based if all positive|negative
        if (isZeroBased) {
            if (isAllPositive) padding_bottom = yDomainMin;
            if (isAllNegative) padding_top = -yDomainMax;
        }
        domain = [
            yDomainMin - padding_bottom,
            yDomainMax + padding_top
        ];
        return isInverted ? domain.reverse() : domain;
    };
    ChartInternal.prototype.getXDomainMin = function(targets) {
        var $$ = this, config = $$.config;
        return isDefined(config.axis_x_min) ? $$.isTimeSeries() ? this.parseDate(config.axis_x_min) : config.axis_x_min : $$.d3.min(targets, function(t) {
            return $$.d3.min(t.values, function(v) {
                return v.x;
            });
        });
    };
    ChartInternal.prototype.getXDomainMax = function(targets) {
        var $$ = this, config = $$.config;
        return isDefined(config.axis_x_max) ? $$.isTimeSeries() ? this.parseDate(config.axis_x_max) : config.axis_x_max : $$.d3.max(targets, function(t) {
            return $$.d3.max(t.values, function(v) {
                return v.x;
            });
        });
    };
    ChartInternal.prototype.getXDomainPadding = function(domain) {
        var $$ = this, config = $$.config, diff = domain[1] - domain[0], maxDataCount, padding, paddingLeft, paddingRight;
        if ($$.isCategorized()) padding = 0;
        else if ($$.hasType("bar")) {
            maxDataCount = $$.getMaxDataCount();
            padding = maxDataCount > 1 ? diff / (maxDataCount - 1) / 2 : 0.5;
        } else padding = diff * 0.01;
        if (typeof config.axis_x_padding === "object" && notEmpty(config.axis_x_padding)) {
            paddingLeft = isValue(config.axis_x_padding.left) ? config.axis_x_padding.left : padding;
            paddingRight = isValue(config.axis_x_padding.right) ? config.axis_x_padding.right : padding;
        } else if (typeof config.axis_x_padding === "number") paddingLeft = paddingRight = config.axis_x_padding;
        else paddingLeft = paddingRight = padding;
        return {
            left: paddingLeft,
            right: paddingRight
        };
    };
    ChartInternal.prototype.getXDomain = function(targets) {
        var $$ = this, xDomain = [
            $$.getXDomainMin(targets),
            $$.getXDomainMax(targets)
        ], firstX = xDomain[0], lastX = xDomain[1], padding = $$.getXDomainPadding(xDomain), min = 0, max = 0;
        // show center of x domain if min and max are the same
        if (firstX - lastX === 0 && !$$.isCategorized()) {
            if ($$.isTimeSeries()) {
                firstX = new Date(firstX.getTime() * 0.5);
                lastX = new Date(lastX.getTime() * 1.5);
            } else {
                firstX = firstX === 0 ? 1 : firstX * 0.5;
                lastX = lastX === 0 ? -1 : lastX * 1.5;
            }
        }
        if (firstX || firstX === 0) min = $$.isTimeSeries() ? new Date(firstX.getTime() - padding.left) : firstX - padding.left;
        if (lastX || lastX === 0) max = $$.isTimeSeries() ? new Date(lastX.getTime() + padding.right) : lastX + padding.right;
        return [
            min,
            max
        ];
    };
    ChartInternal.prototype.updateXDomain = function(targets, withUpdateXDomain, withUpdateOrgXDomain, withTrim, domain) {
        var $$ = this, config = $$.config;
        if (withUpdateOrgXDomain) {
            $$.x.domain(domain ? domain : $$.d3.extent($$.getXDomain(targets)));
            $$.orgXDomain = $$.x.domain();
            if (config.zoom_enabled) $$.zoom.update();
            $$.subX.domain($$.x.domain());
            if ($$.brush) $$.brush.updateScale($$.subX);
        }
        if (withUpdateXDomain) $$.x.domain(domain ? domain : !$$.brush || $$.brush.empty() ? $$.orgXDomain : $$.brush.selectionAsValue());
        // Trim domain when too big by zoom mousemove event
        if (withTrim) $$.x.domain($$.trimXDomain($$.x.orgDomain()));
        return $$.x.domain();
    };
    ChartInternal.prototype.trimXDomain = function(domain) {
        var zoomDomain = this.getZoomDomain(), min = zoomDomain[0], max = zoomDomain[1];
        if (domain[0] <= min) {
            domain[1] = +domain[1] + (min - domain[0]);
            domain[0] = min;
        }
        if (max <= domain[1]) {
            domain[0] = +domain[0] - (domain[1] - max);
            domain[1] = max;
        }
        return domain;
    };
    ChartInternal.prototype.drag = function(mouse) {
        var $$ = this, config = $$.config, main = $$.main, d3 = $$.d3;
        var sx, sy, mx, my, minX, maxX, minY, maxY;
        if ($$.hasArcType()) return;
        if (!config.data_selection_enabled) return;
         // do nothing if not selectable
        if (!config.data_selection_multiple) return;
         // skip when single selection because drag is used for multiple selection
        sx = $$.dragStart[0];
        sy = $$.dragStart[1];
        mx = mouse[0];
        my = mouse[1];
        minX = Math.min(sx, mx);
        maxX = Math.max(sx, mx);
        minY = config.data_selection_grouped ? $$.margin.top : Math.min(sy, my);
        maxY = config.data_selection_grouped ? $$.height : Math.max(sy, my);
        main.select("." + CLASS.dragarea).attr("x", minX).attr("y", minY).attr("width", maxX - minX).attr("height", maxY - minY);
        // TODO: binary search when multiple xs
        main.selectAll("." + CLASS.shapes).selectAll("." + CLASS.shape).each(function(d, i) {
            if (!config.data_selection_isselectable(d)) return;
            var shape = d3.select(this), isSelected = shape.classed(CLASS.SELECTED), isIncluded = shape.classed(CLASS.INCLUDED), _x, _y, _w, _h, toggle, isWithin = false, box;
            if (shape.classed(CLASS.circle)) {
                _x = shape.attr("cx") * 1;
                _y = shape.attr("cy") * 1;
                toggle = $$.togglePoint;
                isWithin = minX < _x && _x < maxX && minY < _y && _y < maxY;
            } else if (shape.classed(CLASS.bar)) {
                box = getPathBox(this);
                _x = box.x;
                _y = box.y;
                _w = box.width;
                _h = box.height;
                toggle = $$.togglePath;
                isWithin = !(maxX < _x || _x + _w < minX) && !(maxY < _y || _y + _h < minY);
            } else // line/area selection not supported yet
            return;
            if (isWithin ^ isIncluded) {
                shape.classed(CLASS.INCLUDED, !isIncluded);
                // TODO: included/unincluded callback here
                shape.classed(CLASS.SELECTED, !isSelected);
                toggle.call($$, !isSelected, shape, d, i);
            }
        });
    };
    ChartInternal.prototype.dragstart = function(mouse) {
        var $$ = this, config = $$.config;
        if ($$.hasArcType()) return;
        if (!config.data_selection_enabled) return;
         // do nothing if not selectable
        $$.dragStart = mouse;
        $$.main.select("." + CLASS.chart).append("rect").attr("class", CLASS.dragarea).style("opacity", 0.1);
        $$.dragging = true;
    };
    ChartInternal.prototype.dragend = function() {
        var $$ = this, config = $$.config;
        if ($$.hasArcType()) return;
        if (!config.data_selection_enabled) return;
         // do nothing if not selectable
        $$.main.select("." + CLASS.dragarea).transition().duration(100).style("opacity", 0).remove();
        $$.main.selectAll("." + CLASS.shape).classed(CLASS.INCLUDED, false);
        $$.dragging = false;
    };
    ChartInternal.prototype.getYFormat = function(forArc) {
        var $$ = this, formatForY = forArc && !$$.hasType("gauge") ? $$.defaultArcValueFormat : $$.yFormat, formatForY2 = forArc && !$$.hasType("gauge") ? $$.defaultArcValueFormat : $$.y2Format;
        return function(v, ratio, id) {
            var format = $$.axis.getId(id) === "y2" ? formatForY2 : formatForY;
            return format.call($$, v, ratio);
        };
    };
    ChartInternal.prototype.yFormat = function(v) {
        var $$ = this, config = $$.config, format = config.axis_y_tick_format ? config.axis_y_tick_format : $$.defaultValueFormat;
        return format(v);
    };
    ChartInternal.prototype.y2Format = function(v) {
        var $$ = this, config = $$.config, format = config.axis_y2_tick_format ? config.axis_y2_tick_format : $$.defaultValueFormat;
        return format(v);
    };
    ChartInternal.prototype.defaultValueFormat = function(v) {
        return isValue(v) ? +v : "";
    };
    ChartInternal.prototype.defaultArcValueFormat = function(v, ratio) {
        return (ratio * 100).toFixed(1) + "%";
    };
    ChartInternal.prototype.dataLabelFormat = function(targetId) {
        var $$ = this, data_labels = $$.config.data_labels, format, defaultFormat = function(v) {
            return isValue(v) ? +v : "";
        };
        // find format according to axis id
        if (typeof data_labels.format === "function") format = data_labels.format;
        else if (typeof data_labels.format === "object") {
            if (data_labels.format[targetId]) format = data_labels.format[targetId] === true ? defaultFormat : data_labels.format[targetId];
            else format = function() {
                return "";
            };
        } else format = defaultFormat;
        return format;
    };
    ChartInternal.prototype.initGrid = function() {
        var $$ = this, config = $$.config, d3 = $$.d3;
        $$.grid = $$.main.append("g").attr("clip-path", $$.clipPathForGrid).attr("class", CLASS.grid);
        if (config.grid_x_show) $$.grid.append("g").attr("class", CLASS.xgrids);
        if (config.grid_y_show) $$.grid.append("g").attr("class", CLASS.ygrids);
        if (config.grid_focus_show) $$.grid.append("g").attr("class", CLASS.xgridFocus).append("line").attr("class", CLASS.xgridFocus);
        $$.xgrid = d3.selectAll([]);
        if (!config.grid_lines_front) $$.initGridLines();
    };
    ChartInternal.prototype.initGridLines = function() {
        var $$ = this, d3 = $$.d3;
        $$.gridLines = $$.main.append("g").attr("clip-path", $$.clipPathForGrid).attr("class", CLASS.grid + " " + CLASS.gridLines);
        $$.gridLines.append("g").attr("class", CLASS.xgridLines);
        $$.gridLines.append("g").attr("class", CLASS.ygridLines);
        $$.xgridLines = d3.selectAll([]);
    };
    ChartInternal.prototype.updateXGrid = function(withoutUpdate) {
        var $$ = this, config = $$.config, d3 = $$.d3, xgridData = $$.generateGridData(config.grid_x_type, $$.x), tickOffset = $$.isCategorized() ? $$.xAxis.tickOffset() : 0;
        $$.xgridAttr = config.axis_rotated ? {
            x1: 0,
            x2: $$.width,
            y1: function(d) {
                return $$.x(d) - tickOffset;
            },
            y2: function(d) {
                return $$.x(d) - tickOffset;
            }
        } : {
            x1: function(d) {
                return $$.x(d) + tickOffset;
            },
            x2: function(d) {
                return $$.x(d) + tickOffset;
            },
            y1: 0,
            y2: $$.height
        };
        $$.xgridAttr.opacity = function() {
            var pos = +d3.select(this).attr(config.axis_rotated ? "y1" : "x1");
            return pos === (config.axis_rotated ? $$.height : 0) ? 0 : 1;
        };
        var xgrid = $$.main.select("." + CLASS.xgrids).selectAll("." + CLASS.xgrid).data(xgridData);
        var xgridEnter = xgrid.enter().append("line").attr("class", CLASS.xgrid).attr("x1", $$.xgridAttr.x1).attr("x2", $$.xgridAttr.x2).attr("y1", $$.xgridAttr.y1).attr("y2", $$.xgridAttr.y2).style("opacity", 0);
        $$.xgrid = xgridEnter.merge(xgrid);
        if (!withoutUpdate) $$.xgrid.attr("x1", $$.xgridAttr.x1).attr("x2", $$.xgridAttr.x2).attr("y1", $$.xgridAttr.y1).attr("y2", $$.xgridAttr.y2).style("opacity", $$.xgridAttr.opacity);
        xgrid.exit().remove();
    };
    ChartInternal.prototype.updateYGrid = function() {
        var $$ = this, config = $$.config, gridValues = $$.yAxis.tickValues() || $$.y.ticks(config.grid_y_ticks);
        var ygrid = $$.main.select("." + CLASS.ygrids).selectAll("." + CLASS.ygrid).data(gridValues);
        var ygridEnter = ygrid.enter().append("line")// TODO: x1, x2, y1, y2, opacity need to be set here maybe
        .attr("class", CLASS.ygrid);
        $$.ygrid = ygridEnter.merge(ygrid);
        $$.ygrid.attr("x1", config.axis_rotated ? $$.y : 0).attr("x2", config.axis_rotated ? $$.y : $$.width).attr("y1", config.axis_rotated ? 0 : $$.y).attr("y2", config.axis_rotated ? $$.height : $$.y);
        ygrid.exit().remove();
        $$.smoothLines($$.ygrid, "grid");
    };
    ChartInternal.prototype.gridTextAnchor = function(d) {
        return d.position ? d.position : "end";
    };
    ChartInternal.prototype.gridTextDx = function(d) {
        return d.position === "start" ? 4 : d.position === "middle" ? 0 : -4;
    };
    ChartInternal.prototype.xGridTextX = function(d) {
        return d.position === "start" ? -this.height : d.position === "middle" ? -this.height / 2 : 0;
    };
    ChartInternal.prototype.yGridTextX = function(d) {
        return d.position === "start" ? 0 : d.position === "middle" ? this.width / 2 : this.width;
    };
    ChartInternal.prototype.updateGrid = function(duration) {
        var $$ = this, main = $$.main, config = $$.config, xgridLine, xgridLineEnter, ygridLine, ygridLineEnter, xv = $$.xv.bind($$), yv = $$.yv.bind($$), xGridTextX = $$.xGridTextX.bind($$), yGridTextX = $$.yGridTextX.bind($$);
        // hide if arc type
        $$.grid.style("visibility", $$.hasArcType() ? "hidden" : "visible");
        main.select("line." + CLASS.xgridFocus).style("visibility", "hidden");
        if (config.grid_x_show) $$.updateXGrid();
        xgridLine = main.select("." + CLASS.xgridLines).selectAll("." + CLASS.xgridLine).data(config.grid_x_lines);
        // enter
        xgridLineEnter = xgridLine.enter().append("g").attr("class", function(d) {
            return CLASS.xgridLine + (d["class"] ? " " + d["class"] : "");
        });
        xgridLineEnter.append("line").attr("x1", config.axis_rotated ? 0 : xv).attr("x2", config.axis_rotated ? $$.width : xv).attr("y1", config.axis_rotated ? xv : 0).attr("y2", config.axis_rotated ? xv : $$.height).style("opacity", 0);
        xgridLineEnter.append("text").attr("text-anchor", $$.gridTextAnchor).attr("transform", config.axis_rotated ? "" : "rotate(-90)").attr("x", config.axis_rotated ? yGridTextX : xGridTextX).attr("y", xv).attr("dx", $$.gridTextDx).attr("dy", -5).style("opacity", 0);
        // udpate
        $$.xgridLines = xgridLineEnter.merge(xgridLine);
        // done in d3.transition() of the end of this function
        // exit
        xgridLine.exit().transition().duration(duration).style("opacity", 0).remove();
        // Y-Grid
        if (config.grid_y_show) $$.updateYGrid();
        ygridLine = main.select("." + CLASS.ygridLines).selectAll("." + CLASS.ygridLine).data(config.grid_y_lines);
        // enter
        ygridLineEnter = ygridLine.enter().append("g").attr("class", function(d) {
            return CLASS.ygridLine + (d["class"] ? " " + d["class"] : "");
        });
        ygridLineEnter.append("line").attr("x1", config.axis_rotated ? yv : 0).attr("x2", config.axis_rotated ? yv : $$.width).attr("y1", config.axis_rotated ? 0 : yv).attr("y2", config.axis_rotated ? $$.height : yv).style("opacity", 0);
        ygridLineEnter.append("text").attr("text-anchor", $$.gridTextAnchor).attr("transform", config.axis_rotated ? "rotate(-90)" : "").attr("x", config.axis_rotated ? xGridTextX : yGridTextX).attr("y", yv).attr("dx", $$.gridTextDx).attr("dy", -5).style("opacity", 0);
        // update
        $$.ygridLines = ygridLineEnter.merge(ygridLine);
        $$.ygridLines.select("line").transition().duration(duration).attr("x1", config.axis_rotated ? yv : 0).attr("x2", config.axis_rotated ? yv : $$.width).attr("y1", config.axis_rotated ? 0 : yv).attr("y2", config.axis_rotated ? $$.height : yv).style("opacity", 1);
        $$.ygridLines.select("text").transition().duration(duration).attr("x", config.axis_rotated ? $$.xGridTextX.bind($$) : $$.yGridTextX.bind($$)).attr("y", yv).text(function(d) {
            return d.text;
        }).style("opacity", 1);
        // exit
        ygridLine.exit().transition().duration(duration).style("opacity", 0).remove();
    };
    ChartInternal.prototype.redrawGrid = function(withTransition, transition) {
        var $$ = this, config = $$.config, xv = $$.xv.bind($$), lines = $$.xgridLines.select("line"), texts = $$.xgridLines.select("text");
        return [
            (withTransition ? lines.transition(transition) : lines).attr("x1", config.axis_rotated ? 0 : xv).attr("x2", config.axis_rotated ? $$.width : xv).attr("y1", config.axis_rotated ? xv : 0).attr("y2", config.axis_rotated ? xv : $$.height).style("opacity", 1),
            (withTransition ? texts.transition(transition) : texts).attr("x", config.axis_rotated ? $$.yGridTextX.bind($$) : $$.xGridTextX.bind($$)).attr("y", xv).text(function(d) {
                return d.text;
            }).style("opacity", 1)
        ];
    };
    ChartInternal.prototype.showXGridFocus = function(selectedData) {
        var $$ = this, config = $$.config, dataToShow = selectedData.filter(function(d) {
            return d && isValue(d.value);
        }), focusEl = $$.main.selectAll("line." + CLASS.xgridFocus), xx = $$.xx.bind($$);
        if (!config.tooltip_show) return;
        // Hide when stanford plot exists
        if ($$.hasType("stanford") || $$.hasArcType()) return;
        focusEl.style("visibility", "visible").data([
            dataToShow[0]
        ]).attr(config.axis_rotated ? "y1" : "x1", xx).attr(config.axis_rotated ? "y2" : "x2", xx);
        $$.smoothLines(focusEl, "grid");
    };
    ChartInternal.prototype.hideXGridFocus = function() {
        this.main.select("line." + CLASS.xgridFocus).style("visibility", "hidden");
    };
    ChartInternal.prototype.updateXgridFocus = function() {
        var $$ = this, config = $$.config;
        $$.main.select("line." + CLASS.xgridFocus).attr("x1", config.axis_rotated ? 0 : -10).attr("x2", config.axis_rotated ? $$.width : -10).attr("y1", config.axis_rotated ? -10 : 0).attr("y2", config.axis_rotated ? -10 : $$.height);
    };
    ChartInternal.prototype.generateGridData = function(type, scale) {
        var $$ = this, gridData = [], xDomain, firstYear, lastYear, i, tickNum = $$.main.select("." + CLASS.axisX).selectAll(".tick").size();
        if (type === "year") {
            xDomain = $$.getXDomain();
            firstYear = xDomain[0].getFullYear();
            lastYear = xDomain[1].getFullYear();
            for(i = firstYear; i <= lastYear; i++)gridData.push(new Date(i + "-01-01 00:00:00"));
        } else {
            gridData = scale.ticks(10);
            if (gridData.length > tickNum) // use only int
            gridData = gridData.filter(function(d) {
                return ("" + d).indexOf(".") < 0;
            });
        }
        return gridData;
    };
    ChartInternal.prototype.getGridFilterToRemove = function(params) {
        return params ? function(line) {
            var found = false;
            [].concat(params).forEach(function(param) {
                if ("value" in param && line.value === param.value || "class" in param && line["class"] === param["class"]) found = true;
            });
            return found;
        } : function() {
            return true;
        };
    };
    ChartInternal.prototype.removeGridLines = function(params, forX) {
        var $$ = this, config = $$.config, toRemove = $$.getGridFilterToRemove(params), toShow = function(line) {
            return !toRemove(line);
        }, classLines = forX ? CLASS.xgridLines : CLASS.ygridLines, classLine = forX ? CLASS.xgridLine : CLASS.ygridLine;
        $$.main.select("." + classLines).selectAll("." + classLine).filter(toRemove).transition().duration(config.transition_duration).style("opacity", 0).remove();
        if (forX) config.grid_x_lines = config.grid_x_lines.filter(toShow);
        else config.grid_y_lines = config.grid_y_lines.filter(toShow);
    };
    ChartInternal.prototype.initEventRect = function() {
        var $$ = this, config = $$.config;
        $$.main.select("." + CLASS.chart).append("g").attr("class", CLASS.eventRects).style("fill-opacity", 0);
        $$.eventRect = $$.main.select("." + CLASS.eventRects).append("rect").attr("class", CLASS.eventRect);
        // event rect handle zoom event as well
        if (config.zoom_enabled && $$.zoom) {
            $$.eventRect.call($$.zoom).on("dblclick.zoom", null);
            if (config.zoom_initialRange) // WORKAROUND: Add transition to apply transform immediately when no subchart
            $$.eventRect.transition().duration(0).call($$.zoom.transform, $$.zoomTransform(config.zoom_initialRange));
        }
    };
    ChartInternal.prototype.redrawEventRect = function() {
        var $$ = this, d3 = $$.d3, config = $$.config;
        function mouseout() {
            $$.svg.select("." + CLASS.eventRect).style("cursor", null);
            $$.hideXGridFocus();
            $$.hideTooltip();
            $$.unexpandCircles();
            $$.unexpandBars();
        }
        var isHoveringDataPoint = function(mouse, closest) {
            return closest && ($$.isBarType(closest.id) || $$.dist(closest, mouse) < config.point_sensitivity);
        };
        var withName = function(d) {
            return d ? $$.addName(Object.assign({}, d)) : null;
        };
        // rects for mouseover
        $$.main.select("." + CLASS.eventRects).style("cursor", config.zoom_enabled ? config.axis_rotated ? "ns-resize" : "ew-resize" : null);
        $$.eventRect.attr("x", 0).attr("y", 0).attr("width", $$.width).attr("height", $$.height).on("mouseout", config.interaction_enabled ? function() {
            if (!config) return;
             // chart is destroyed
            if ($$.hasArcType()) return;
            if ($$.mouseover) {
                config.data_onmouseout.call($$.api, $$.mouseover);
                $$.mouseover = undefined;
            }
            mouseout();
        } : null).on("mousemove", config.interaction_enabled ? function() {
            // do nothing when dragging
            if ($$.dragging) return;
            var targetsToShow = $$.getTargetsToShow();
            // do nothing if arc type
            if ($$.hasArcType(targetsToShow)) return;
            var mouse = d3.mouse(this);
            var closest = withName($$.findClosestFromTargets(targetsToShow, mouse));
            var isMouseCloseToDataPoint = isHoveringDataPoint(mouse, closest);
            // ensure onmouseout is always called if mousemove switch between 2 targets
            if ($$.mouseover && (!closest || closest.id !== $$.mouseover.id || closest.index !== $$.mouseover.index)) {
                config.data_onmouseout.call($$.api, $$.mouseover);
                $$.mouseover = undefined;
            }
            if (closest && !$$.mouseover) {
                config.data_onmouseover.call($$.api, closest);
                $$.mouseover = closest;
            }
            // show cursor as pointer if we're hovering a data point close enough
            $$.svg.select("." + CLASS.eventRect).style("cursor", isMouseCloseToDataPoint ? "pointer" : null);
            // if tooltip not grouped, we want to display only data from closest data point
            var showSingleDataPoint = !config.tooltip_grouped || $$.hasType("stanford", targetsToShow);
            // find data to highlight
            var selectedData;
            if (showSingleDataPoint) {
                if (closest) selectedData = [
                    closest
                ];
            } else {
                var closestByX = void 0;
                if (closest) // reuse closest value
                closestByX = closest;
                else {
                    // try to find the closest value by X values from the mouse position
                    var mouseX = config.axis_rotated ? mouse[1] : mouse[0];
                    closestByX = $$.findClosestFromTargetsByX(targetsToShow, $$.x.invert(mouseX));
                }
                // highlight all data for this 'x' value
                if (closestByX) selectedData = $$.filterByX(targetsToShow, closestByX.x);
            }
            // ensure we have data to show
            if (!selectedData || selectedData.length === 0) return mouseout();
            // inject names for each point
            selectedData = selectedData.map(withName);
            // show tooltip
            $$.showTooltip(selectedData, this);
            // expand points
            if (config.point_focus_expand_enabled) {
                $$.unexpandCircles();
                selectedData.forEach(function(d) {
                    $$.expandCircles(d.index, d.id, false);
                });
            }
            // expand bars
            $$.unexpandBars();
            selectedData.forEach(function(d) {
                $$.expandBars(d.index, d.id, false);
            });
            // Show xgrid focus line
            $$.showXGridFocus(selectedData);
        } : null).on("click", config.interaction_enabled ? function() {
            var targetsToShow = $$.getTargetsToShow();
            if ($$.hasArcType(targetsToShow)) return;
            var mouse = d3.mouse(this);
            var closest = withName($$.findClosestFromTargets(targetsToShow, mouse));
            if (!isHoveringDataPoint(mouse, closest)) return;
            // select if selection enabled
            var sameXData;
            if (!config.data_selection_grouped || $$.isStanfordType(closest)) sameXData = [
                closest
            ];
            else sameXData = $$.filterByX(targetsToShow, closest.x);
            // toggle selected state
            sameXData.forEach(function(d) {
                $$.main.selectAll("." + CLASS.shapes + $$.getTargetSelectorSuffix(d.id)).selectAll("." + CLASS.shape + "-" + d.index).each(function() {
                    if (config.data_selection_grouped || $$.isWithinShape(this, d)) $$.toggleShape(this, d, d.index);
                });
            });
            // call data_onclick on the closest data point
            if (closest) {
                var shape = $$.main.selectAll("." + CLASS.shapes + $$.getTargetSelectorSuffix(closest.id)).select("." + CLASS.shape + "-" + closest.index);
                config.data_onclick.call($$.api, closest, shape.node());
            }
        } : null).call(config.interaction_enabled && config.data_selection_draggable && $$.drag ? d3.drag().on("drag", function() {
            $$.drag(d3.mouse(this));
        }).on("start", function() {
            $$.dragstart(d3.mouse(this));
        }).on("end", function() {
            $$.dragend();
        }) : function() {});
    };
    ChartInternal.prototype.getMousePosition = function(data) {
        var $$ = this;
        return [
            $$.x(data.x),
            $$.getYScale(data.id)(data.value)
        ];
    };
    ChartInternal.prototype.dispatchEvent = function(type, mouse) {
        var $$ = this, selector = "." + CLASS.eventRect, eventRect = $$.main.select(selector).node(), box = eventRect.getBoundingClientRect(), x = box.left + (mouse ? mouse[0] : 0), y = box.top + (mouse ? mouse[1] : 0), event = document.createEvent("MouseEvents");
        event.initMouseEvent(type, true, true, window, 0, x, y, x, y, false, false, false, false, 0, null);
        eventRect.dispatchEvent(event);
    };
    ChartInternal.prototype.initLegend = function() {
        var $$ = this;
        $$.legendItemTextBox = {};
        $$.legendHasRendered = false;
        $$.legend = $$.svg.append("g").attr("transform", $$.getTranslate("legend"));
        if (!$$.config.legend_show) {
            $$.legend.style("visibility", "hidden");
            $$.hiddenLegendIds = $$.mapToIds($$.data.targets);
            return;
        }
        // MEMO: call here to update legend box and tranlate for all
        // MEMO: translate will be updated by this, so transform not needed in updateLegend()
        $$.updateLegendWithDefaults();
    };
    ChartInternal.prototype.updateLegendWithDefaults = function() {
        var $$ = this;
        $$.updateLegend($$.mapToIds($$.data.targets), {
            withTransform: false,
            withTransitionForTransform: false,
            withTransition: false
        });
    };
    ChartInternal.prototype.updateSizeForLegend = function(legendHeight, legendWidth) {
        var $$ = this, config = $$.config, insetLegendPosition = {
            top: $$.isLegendTop ? $$.getCurrentPaddingTop() + config.legend_inset_y + 5.5 : $$.currentHeight - legendHeight - $$.getCurrentPaddingBottom() - config.legend_inset_y,
            left: $$.isLegendLeft ? $$.getCurrentPaddingLeft() + config.legend_inset_x + 0.5 : $$.currentWidth - legendWidth - $$.getCurrentPaddingRight() - config.legend_inset_x + 0.5
        };
        $$.margin3 = {
            top: $$.isLegendRight ? 0 : $$.isLegendInset ? insetLegendPosition.top : $$.currentHeight - legendHeight,
            right: NaN,
            bottom: 0,
            left: $$.isLegendRight ? $$.currentWidth - legendWidth : $$.isLegendInset ? insetLegendPosition.left : 0
        };
    };
    ChartInternal.prototype.transformLegend = function(withTransition) {
        var $$ = this;
        (withTransition ? $$.legend.transition() : $$.legend).attr("transform", $$.getTranslate("legend"));
    };
    ChartInternal.prototype.updateLegendStep = function(step) {
        this.legendStep = step;
    };
    ChartInternal.prototype.updateLegendItemWidth = function(w) {
        this.legendItemWidth = w;
    };
    ChartInternal.prototype.updateLegendItemHeight = function(h) {
        this.legendItemHeight = h;
    };
    ChartInternal.prototype.getLegendWidth = function() {
        var $$ = this;
        return $$.config.legend_show ? $$.isLegendRight || $$.isLegendInset ? $$.legendItemWidth * ($$.legendStep + 1) : $$.currentWidth : 0;
    };
    ChartInternal.prototype.getLegendHeight = function() {
        var $$ = this, h = 0;
        if ($$.config.legend_show) {
            if ($$.isLegendRight) h = $$.currentHeight;
            else h = Math.max(20, $$.legendItemHeight) * ($$.legendStep + 1);
        }
        return h;
    };
    ChartInternal.prototype.opacityForLegend = function(legendItem) {
        return legendItem.classed(CLASS.legendItemHidden) ? null : 1;
    };
    ChartInternal.prototype.opacityForUnfocusedLegend = function(legendItem) {
        return legendItem.classed(CLASS.legendItemHidden) ? null : 0.3;
    };
    ChartInternal.prototype.toggleFocusLegend = function(targetIds, focus) {
        var $$ = this;
        targetIds = $$.mapToTargetIds(targetIds);
        $$.legend.selectAll("." + CLASS.legendItem).filter(function(id) {
            return targetIds.indexOf(id) >= 0;
        }).classed(CLASS.legendItemFocused, focus).transition().duration(100).style("opacity", function() {
            var opacity = focus ? $$.opacityForLegend : $$.opacityForUnfocusedLegend;
            return opacity.call($$, $$.d3.select(this));
        });
    };
    ChartInternal.prototype.revertLegend = function() {
        var $$ = this, d3 = $$.d3;
        $$.legend.selectAll("." + CLASS.legendItem).classed(CLASS.legendItemFocused, false).transition().duration(100).style("opacity", function() {
            return $$.opacityForLegend(d3.select(this));
        });
    };
    ChartInternal.prototype.showLegend = function(targetIds) {
        var $$ = this, config = $$.config;
        if (!config.legend_show) {
            config.legend_show = true;
            $$.legend.style("visibility", "visible");
            if (!$$.legendHasRendered) $$.updateLegendWithDefaults();
        }
        $$.removeHiddenLegendIds(targetIds);
        $$.legend.selectAll($$.selectorLegends(targetIds)).style("visibility", "visible").transition().style("opacity", function() {
            return $$.opacityForLegend($$.d3.select(this));
        });
    };
    ChartInternal.prototype.hideLegend = function(targetIds) {
        var $$ = this, config = $$.config;
        if (config.legend_show && isEmpty(targetIds)) {
            config.legend_show = false;
            $$.legend.style("visibility", "hidden");
        }
        $$.addHiddenLegendIds(targetIds);
        $$.legend.selectAll($$.selectorLegends(targetIds)).style("opacity", 0).style("visibility", "hidden");
    };
    ChartInternal.prototype.clearLegendItemTextBoxCache = function() {
        this.legendItemTextBox = {};
    };
    ChartInternal.prototype.updateLegend = function(targetIds, options, transitions) {
        var $$ = this, config = $$.config;
        var xForLegend, xForLegendText, xForLegendRect, yForLegend, yForLegendText, yForLegendRect, x1ForLegendTile, x2ForLegendTile, yForLegendTile;
        var paddingTop = 4, paddingRight = 10, maxWidth = 0, maxHeight = 0, posMin = 10, tileWidth = config.legend_item_tile_width + 5;
        var l, totalLength = 0, offsets = {}, widths = {}, heights = {}, margins = [
            0
        ], steps = {}, step = 0;
        var withTransition, withTransitionForTransform;
        var texts, rects, tiles, background;
        // Skip elements when their name is set to null
        targetIds = targetIds.filter(function(id) {
            return !isDefined(config.data_names[id]) || config.data_names[id] !== null;
        });
        options = options || {};
        withTransition = getOption(options, "withTransition", true);
        withTransitionForTransform = getOption(options, "withTransitionForTransform", true);
        function getTextBox(textElement, id) {
            if (!$$.legendItemTextBox[id]) $$.legendItemTextBox[id] = $$.getTextRect(textElement.textContent, CLASS.legendItem, textElement);
            return $$.legendItemTextBox[id];
        }
        function updatePositions(textElement, id, index) {
            var reset = index === 0, isLast = index === targetIds.length - 1, box = getTextBox(textElement, id), itemWidth = box.width + tileWidth + (isLast && !($$.isLegendRight || $$.isLegendInset) ? 0 : paddingRight) + config.legend_padding, itemHeight = box.height + paddingTop, itemLength = $$.isLegendRight || $$.isLegendInset ? itemHeight : itemWidth, areaLength = $$.isLegendRight || $$.isLegendInset ? $$.getLegendHeight() : $$.getLegendWidth(), margin, maxLength;
            // MEMO: care about condifion of step, totalLength
            function updateValues(id, withoutStep) {
                if (!withoutStep) {
                    margin = (areaLength - totalLength - itemLength) / 2;
                    if (margin < posMin) {
                        margin = (areaLength - itemLength) / 2;
                        totalLength = 0;
                        step++;
                    }
                }
                steps[id] = step;
                margins[step] = $$.isLegendInset ? 10 : margin;
                offsets[id] = totalLength;
                totalLength += itemLength;
            }
            if (reset) {
                totalLength = 0;
                step = 0;
                maxWidth = 0;
                maxHeight = 0;
            }
            if (config.legend_show && !$$.isLegendToShow(id)) {
                widths[id] = heights[id] = steps[id] = offsets[id] = 0;
                return;
            }
            widths[id] = itemWidth;
            heights[id] = itemHeight;
            if (!maxWidth || itemWidth >= maxWidth) maxWidth = itemWidth;
            if (!maxHeight || itemHeight >= maxHeight) maxHeight = itemHeight;
            maxLength = $$.isLegendRight || $$.isLegendInset ? maxHeight : maxWidth;
            if (config.legend_equally) {
                Object.keys(widths).forEach(function(id) {
                    widths[id] = maxWidth;
                });
                Object.keys(heights).forEach(function(id) {
                    heights[id] = maxHeight;
                });
                margin = (areaLength - maxLength * targetIds.length) / 2;
                if (margin < posMin) {
                    totalLength = 0;
                    step = 0;
                    targetIds.forEach(function(id) {
                        updateValues(id);
                    });
                } else updateValues(id, true);
            } else updateValues(id);
        }
        if ($$.isLegendInset) {
            step = config.legend_inset_step ? config.legend_inset_step : targetIds.length;
            $$.updateLegendStep(step);
        }
        if ($$.isLegendRight) {
            xForLegend = function(id) {
                return maxWidth * steps[id];
            };
            yForLegend = function(id) {
                return margins[steps[id]] + offsets[id];
            };
        } else if ($$.isLegendInset) {
            xForLegend = function(id) {
                return maxWidth * steps[id] + 10;
            };
            yForLegend = function(id) {
                return margins[steps[id]] + offsets[id];
            };
        } else {
            xForLegend = function(id) {
                return margins[steps[id]] + offsets[id];
            };
            yForLegend = function(id) {
                return maxHeight * steps[id];
            };
        }
        xForLegendText = function(id, i) {
            return xForLegend(id, i) + 4 + config.legend_item_tile_width;
        };
        yForLegendText = function(id, i) {
            return yForLegend(id, i) + 9;
        };
        xForLegendRect = function(id, i) {
            return xForLegend(id, i);
        };
        yForLegendRect = function(id, i) {
            return yForLegend(id, i) - 5;
        };
        x1ForLegendTile = function(id, i) {
            return xForLegend(id, i) - 2;
        };
        x2ForLegendTile = function(id, i) {
            return xForLegend(id, i) - 2 + config.legend_item_tile_width;
        };
        yForLegendTile = function(id, i) {
            return yForLegend(id, i) + 4;
        };
        // Define g for legend area
        l = $$.legend.selectAll("." + CLASS.legendItem).data(targetIds).enter().append("g").attr("class", function(id) {
            return $$.generateClass(CLASS.legendItem, id);
        }).style("visibility", function(id) {
            return $$.isLegendToShow(id) ? "visible" : "hidden";
        }).style("cursor", function() {
            return config.interaction_enabled ? "pointer" : "auto";
        }).on("click", config.interaction_enabled ? function(id) {
            if (config.legend_item_onclick) config.legend_item_onclick.call($$, id);
            else if ($$.d3.event.altKey) {
                $$.api.hide();
                $$.api.show(id);
            } else {
                $$.api.toggle(id);
                $$.isTargetToShow(id) ? $$.api.focus(id) : $$.api.revert();
            }
        } : null).on("mouseover", config.interaction_enabled ? function(id) {
            if (config.legend_item_onmouseover) config.legend_item_onmouseover.call($$, id);
            else {
                $$.d3.select(this).classed(CLASS.legendItemFocused, true);
                if (!$$.transiting && $$.isTargetToShow(id)) $$.api.focus(id);
            }
        } : null).on("mouseout", config.interaction_enabled ? function(id) {
            if (config.legend_item_onmouseout) config.legend_item_onmouseout.call($$, id);
            else {
                $$.d3.select(this).classed(CLASS.legendItemFocused, false);
                $$.api.revert();
            }
        } : null);
        l.append("text").text(function(id) {
            return isDefined(config.data_names[id]) ? config.data_names[id] : id;
        }).each(function(id, i) {
            updatePositions(this, id, i);
        }).style("pointer-events", "none").attr("x", $$.isLegendRight || $$.isLegendInset ? xForLegendText : -200).attr("y", $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendText);
        l.append("rect").attr("class", CLASS.legendItemEvent).style("fill-opacity", 0).attr("x", $$.isLegendRight || $$.isLegendInset ? xForLegendRect : -200).attr("y", $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendRect);
        l.append("line").attr("class", CLASS.legendItemTile).style("stroke", $$.color).style("pointer-events", "none").attr("x1", $$.isLegendRight || $$.isLegendInset ? x1ForLegendTile : -200).attr("y1", $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendTile).attr("x2", $$.isLegendRight || $$.isLegendInset ? x2ForLegendTile : -200).attr("y2", $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendTile).attr("stroke-width", config.legend_item_tile_height);
        // Set background for inset legend
        background = $$.legend.select("." + CLASS.legendBackground + " rect");
        if ($$.isLegendInset && maxWidth > 0 && background.size() === 0) background = $$.legend.insert("g", "." + CLASS.legendItem).attr("class", CLASS.legendBackground).append("rect");
        texts = $$.legend.selectAll("text").data(targetIds).text(function(id) {
            return isDefined(config.data_names[id]) ? config.data_names[id] : id;
        }) // MEMO: needed for update
        .each(function(id, i) {
            updatePositions(this, id, i);
        });
        (withTransition ? texts.transition() : texts).attr("x", xForLegendText).attr("y", yForLegendText);
        rects = $$.legend.selectAll("rect." + CLASS.legendItemEvent).data(targetIds);
        (withTransition ? rects.transition() : rects).attr("width", function(id) {
            return widths[id];
        }).attr("height", function(id) {
            return heights[id];
        }).attr("x", xForLegendRect).attr("y", yForLegendRect);
        tiles = $$.legend.selectAll("line." + CLASS.legendItemTile).data(targetIds);
        (withTransition ? tiles.transition() : tiles).style("stroke", $$.levelColor ? function(id) {
            return $$.levelColor($$.cache[id].values.reduce(function(total, item) {
                return total + item.value;
            }, 0));
        } : $$.color).attr("x1", x1ForLegendTile).attr("y1", yForLegendTile).attr("x2", x2ForLegendTile).attr("y2", yForLegendTile);
        if (background) (withTransition ? background.transition() : background).attr("height", $$.getLegendHeight() - 12).attr("width", maxWidth * (step + 1) + 10);
        // toggle legend state
        $$.legend.selectAll("." + CLASS.legendItem).classed(CLASS.legendItemHidden, function(id) {
            return !$$.isTargetToShow(id);
        });
        // Update all to reflect change of legend
        $$.updateLegendItemWidth(maxWidth);
        $$.updateLegendItemHeight(maxHeight);
        $$.updateLegendStep(step);
        // Update size and scale
        $$.updateSizes();
        $$.updateScales();
        $$.updateSvgSize();
        // Update g positions
        $$.transformAll(withTransitionForTransform, transitions);
        $$.legendHasRendered = true;
    };
    ChartInternal.prototype.initRegion = function() {
        var $$ = this;
        $$.region = $$.main.append("g").attr("clip-path", $$.clipPath).attr("class", CLASS.regions);
    };
    ChartInternal.prototype.updateRegion = function(duration) {
        var $$ = this, config = $$.config;
        // hide if arc type
        $$.region.style("visibility", $$.hasArcType() ? "hidden" : "visible");
        var mainRegion = $$.main.select("." + CLASS.regions).selectAll("." + CLASS.region).data(config.regions);
        var g = mainRegion.enter().append("g");
        g.append("rect").attr("x", $$.regionX.bind($$)).attr("y", $$.regionY.bind($$)).attr("width", $$.regionWidth.bind($$)).attr("height", $$.regionHeight.bind($$)).style("fill-opacity", function(d) {
            return isValue(d.opacity) ? d.opacity : 0.1;
        });
        g.append("text").text($$.labelRegion.bind($$));
        $$.mainRegion = g.merge(mainRegion).attr("class", $$.classRegion.bind($$));
        mainRegion.exit().transition().duration(duration).style("opacity", 0).remove();
    };
    ChartInternal.prototype.redrawRegion = function(withTransition, transition) {
        var $$ = this, regions = $$.mainRegion, regionLabels = $$.mainRegion.selectAll("text");
        return [
            (withTransition ? regions.transition(transition) : regions).attr("x", $$.regionX.bind($$)).attr("y", $$.regionY.bind($$)).attr("width", $$.regionWidth.bind($$)).attr("height", $$.regionHeight.bind($$)).style("fill-opacity", function(d) {
                return isValue(d.opacity) ? d.opacity : 0.1;
            }),
            (withTransition ? regionLabels.transition(transition) : regionLabels).attr("x", $$.labelOffsetX.bind($$)).attr("y", $$.labelOffsetY.bind($$)).attr("transform", $$.labelTransform.bind($$)).attr("style", "text-anchor: left;")
        ];
    };
    ChartInternal.prototype.regionX = function(d) {
        var $$ = this, config = $$.config, xPos, yScale = d.axis === "y" ? $$.y : $$.y2;
        if (d.axis === "y" || d.axis === "y2") xPos = config.axis_rotated ? "start" in d ? yScale(d.start) : 0 : 0;
        else xPos = config.axis_rotated ? 0 : "start" in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.start) : d.start) : 0;
        return xPos;
    };
    ChartInternal.prototype.regionY = function(d) {
        var $$ = this, config = $$.config, yPos, yScale = d.axis === "y" ? $$.y : $$.y2;
        if (d.axis === "y" || d.axis === "y2") yPos = config.axis_rotated ? 0 : "end" in d ? yScale(d.end) : 0;
        else yPos = config.axis_rotated ? "start" in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.start) : d.start) : 0 : 0;
        return yPos;
    };
    ChartInternal.prototype.regionWidth = function(d) {
        var $$ = this, config = $$.config, start = $$.regionX(d), end, yScale = d.axis === "y" ? $$.y : $$.y2;
        if (d.axis === "y" || d.axis === "y2") end = config.axis_rotated ? "end" in d ? yScale(d.end) : $$.width : $$.width;
        else end = config.axis_rotated ? $$.width : "end" in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.end) : d.end) : $$.width;
        return end < start ? 0 : end - start;
    };
    ChartInternal.prototype.regionHeight = function(d) {
        var $$ = this, config = $$.config, start = this.regionY(d), end, yScale = d.axis === "y" ? $$.y : $$.y2;
        if (d.axis === "y" || d.axis === "y2") end = config.axis_rotated ? $$.height : "start" in d ? yScale(d.start) : $$.height;
        else end = config.axis_rotated ? "end" in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.end) : d.end) : $$.height : $$.height;
        return end < start ? 0 : end - start;
    };
    ChartInternal.prototype.isRegionOnX = function(d) {
        return !d.axis || d.axis === "x";
    };
    ChartInternal.prototype.labelRegion = function(d) {
        return "label" in d ? d.label : "";
    };
    ChartInternal.prototype.labelTransform = function(d) {
        return "vertical" in d && d.vertical ? "rotate(90)" : "";
    };
    ChartInternal.prototype.labelOffsetX = function(d) {
        var paddingX = "paddingX" in d ? d.paddingX : 3;
        var paddingY = "paddingY" in d ? d.paddingY : 3;
        return "vertical" in d && d.vertical ? this.regionY(d) + paddingY : this.regionX(d) + paddingX;
    };
    ChartInternal.prototype.labelOffsetY = function(d) {
        var paddingX = "paddingX" in d ? d.paddingX : 3;
        var paddingY = "paddingY" in d ? d.paddingY : 3;
        return "vertical" in d && d.vertical ? -(this.regionX(d) + paddingX) : this.regionY(d) + 10 + paddingY;
    };
    function c3LogScale(d3, linearScale, logScale) {
        var PROJECTION = [
            0.01,
            10
        ];
        if (!linearScale) {
            linearScale = d3.scaleLinear();
            linearScale.range(PROJECTION);
        }
        if (!logScale) {
            logScale = d3.scaleLog();
            logScale.domain(PROJECTION);
            logScale.nice();
        }
        // copied from https://github.com/compute-io/logspace
        function logspace(a, b, len) {
            var arr, end, tmp, d;
            if (arguments.length < 3) len = 10;
            else {
                if (len === 0) return [];
            }
            // Calculate the increment:
            end = len - 1;
            d = (b - a) / end;
            // Build the output array...
            arr = new Array(len);
            tmp = a;
            arr[0] = Math.pow(10, tmp);
            for(var i = 1; i < end; i++){
                tmp += d;
                arr[i] = Math.pow(10, tmp);
            }
            arr[end] = Math.pow(10, b);
            return arr;
        }
        function scale(x) {
            return logScale(linearScale(x));
        }
        scale.domain = function(x) {
            if (!arguments.length) return linearScale.domain();
            linearScale.domain(x);
            return scale;
        };
        scale.range = function(x) {
            if (!arguments.length) return logScale.range();
            logScale.range(x);
            return scale;
        };
        scale.ticks = function(m) {
            return logspace(-2, 1, m || 10).map(function(v) {
                return linearScale.invert(v);
            });
        };
        scale.copy = function() {
            return c3LogScale(d3, linearScale.copy(), logScale.copy());
        };
        return scale;
    }
    ChartInternal.prototype.getScale = function(min, max, forTimeseries) {
        return (forTimeseries ? this.d3.scaleTime() : this.d3.scaleLinear()).range([
            min,
            max
        ]);
    };
    ChartInternal.prototype.getX = function(min, max, domain, offset) {
        var $$ = this, scale = $$.getScale(min, max, $$.isTimeSeries()), _scale = domain ? scale.domain(domain) : scale, key;
        // Define customized scale if categorized axis
        if ($$.isCategorized()) {
            offset = offset || function() {
                return 0;
            };
            scale = function(d, raw) {
                var v = _scale(d) + offset(d);
                return raw ? v : Math.ceil(v);
            };
        } else scale = function(d, raw) {
            var v = _scale(d);
            return raw ? v : Math.ceil(v);
        };
        // define functions
        for(key in _scale)scale[key] = _scale[key];
        scale.orgDomain = function() {
            return _scale.domain();
        };
        // define custom domain() for categorized axis
        if ($$.isCategorized()) scale.domain = function(domain) {
            if (!arguments.length) {
                domain = this.orgDomain();
                return [
                    domain[0],
                    domain[1] + 1
                ];
            }
            _scale.domain(domain);
            return scale;
        };
        return scale;
    };
    /**
   * Creates and configures a D3 scale instance for the given type.
   *
   * By defaults it returns a Linear scale.
   *
   * @param {String} type Type of d3-scale to create. Type can be 'linear', 'time', 'timeseries' or 'log'.
   * @param {Array} domain The scale domain such as [from, to]
   * @param {Array} range The scale's range such as [from, to]
   *
   * @return A d3-scale instance
   */ ChartInternal.prototype.getY = function(type, domain, range) {
        var scale;
        if (type === "timeseries" || type === "time") scale = this.d3.scaleTime();
        else if (type === "log") scale = c3LogScale(this.d3);
        else if (type === "linear" || type === undefined) scale = this.d3.scaleLinear();
        else throw new Error('Invalid Y axis type: "' + type + '"');
        if (domain) scale.domain(domain);
        if (range) scale.range(range);
        return scale;
    };
    ChartInternal.prototype.getYScale = function(id) {
        return this.axis.getId(id) === "y2" ? this.y2 : this.y;
    };
    ChartInternal.prototype.getSubYScale = function(id) {
        return this.axis.getId(id) === "y2" ? this.subY2 : this.subY;
    };
    ChartInternal.prototype.updateScales = function() {
        var $$ = this, config = $$.config, forInit = !$$.x;
        // update edges
        $$.xMin = config.axis_rotated ? 1 : 0;
        $$.xMax = config.axis_rotated ? $$.height : $$.width;
        $$.yMin = config.axis_rotated ? 0 : $$.height;
        $$.yMax = config.axis_rotated ? $$.width : 1;
        $$.subXMin = $$.xMin;
        $$.subXMax = $$.xMax;
        $$.subYMin = config.axis_rotated ? 0 : $$.height2;
        $$.subYMax = config.axis_rotated ? $$.width2 : 1;
        // update scales
        $$.x = $$.getX($$.xMin, $$.xMax, forInit ? undefined : $$.x.orgDomain(), function() {
            return $$.xAxis.tickOffset();
        });
        $$.y = $$.getY(config.axis_y_type, forInit ? config.axis_y_default : $$.y.domain(), [
            $$.yMin,
            $$.yMax
        ]);
        $$.y2 = $$.getY(config.axis_y2_type, forInit ? config.axis_y2_default : $$.y2.domain(), [
            $$.yMin,
            $$.yMax
        ]);
        $$.subX = $$.getX($$.xMin, $$.xMax, $$.orgXDomain, function(d) {
            return d % 1 ? 0 : $$.subXAxis.tickOffset();
        });
        $$.subY = $$.getY(config.axis_y_type, forInit ? config.axis_y_default : $$.subY.domain(), [
            $$.subYMin,
            $$.subYMax
        ]);
        $$.subY2 = $$.getY(config.axis_y2_type, forInit ? config.axis_y2_default : $$.subY2.domain(), [
            $$.subYMin,
            $$.subYMax
        ]);
        // update axes
        $$.xAxisTickFormat = $$.axis.getXAxisTickFormat();
        $$.xAxisTickValues = $$.axis.getXAxisTickValues();
        $$.yAxisTickValues = $$.axis.getYAxisTickValues();
        $$.y2AxisTickValues = $$.axis.getY2AxisTickValues();
        $$.xAxis = $$.axis.getXAxis($$.x, $$.xOrient, $$.xAxisTickFormat, $$.xAxisTickValues, config.axis_x_tick_outer);
        $$.subXAxis = $$.axis.getXAxis($$.subX, $$.subXOrient, $$.xAxisTickFormat, $$.xAxisTickValues, config.axis_x_tick_outer);
        $$.yAxis = $$.axis.getYAxis("y", $$.y, $$.yOrient, $$.yAxisTickValues, config.axis_y_tick_outer);
        $$.y2Axis = $$.axis.getYAxis("y2", $$.y2, $$.y2Orient, $$.y2AxisTickValues, config.axis_y2_tick_outer);
        // Set initialized scales to brush and zoom
        if (!forInit) {
            if ($$.brush) $$.brush.updateScale($$.subX);
        }
        // update for arc
        if ($$.updateArc) $$.updateArc();
    };
    ChartInternal.prototype.selectPoint = function(target, d, i) {
        var $$ = this, config = $$.config, cx = (config.axis_rotated ? $$.circleY : $$.circleX).bind($$), cy = (config.axis_rotated ? $$.circleX : $$.circleY).bind($$), r = $$.pointSelectR.bind($$);
        config.data_onselected.call($$.api, d, target.node());
        // add selected-circle on low layer g
        $$.main.select("." + CLASS.selectedCircles + $$.getTargetSelectorSuffix(d.id)).selectAll("." + CLASS.selectedCircle + "-" + i).data([
            d
        ]).enter().append("circle").attr("class", function() {
            return $$.generateClass(CLASS.selectedCircle, i);
        }).attr("cx", cx).attr("cy", cy).attr("stroke", function() {
            return $$.color(d);
        }).attr("r", function(d) {
            return $$.pointSelectR(d) * 1.4;
        }).transition().duration(100).attr("r", r);
    };
    ChartInternal.prototype.unselectPoint = function(target, d, i) {
        var $$ = this;
        $$.config.data_onunselected.call($$.api, d, target.node());
        // remove selected-circle from low layer g
        $$.main.select("." + CLASS.selectedCircles + $$.getTargetSelectorSuffix(d.id)).selectAll("." + CLASS.selectedCircle + "-" + i).transition().duration(100).attr("r", 0).remove();
    };
    ChartInternal.prototype.togglePoint = function(selected, target, d, i) {
        selected ? this.selectPoint(target, d, i) : this.unselectPoint(target, d, i);
    };
    ChartInternal.prototype.selectPath = function(target, d) {
        var $$ = this;
        $$.config.data_onselected.call($$, d, target.node());
        if ($$.config.interaction_brighten) target.transition().duration(100).style("fill", function() {
            return $$.d3.rgb($$.color(d)).brighter(0.75);
        });
    };
    ChartInternal.prototype.unselectPath = function(target, d) {
        var $$ = this;
        $$.config.data_onunselected.call($$, d, target.node());
        if ($$.config.interaction_brighten) target.transition().duration(100).style("fill", function() {
            return $$.color(d);
        });
    };
    ChartInternal.prototype.togglePath = function(selected, target, d, i) {
        selected ? this.selectPath(target, d, i) : this.unselectPath(target, d, i);
    };
    ChartInternal.prototype.getToggle = function(that, d) {
        var $$ = this, toggle;
        if (that.nodeName === "circle") {
            if ($$.isStepType(d)) // circle is hidden in step chart, so treat as within the click area
            toggle = function() {}; // TODO: how to select step chart?
            else toggle = $$.togglePoint;
        } else if (that.nodeName === "path") toggle = $$.togglePath;
        return toggle;
    };
    ChartInternal.prototype.toggleShape = function(that, d, i) {
        var $$ = this, d3 = $$.d3, config = $$.config, shape = d3.select(that), isSelected = shape.classed(CLASS.SELECTED), toggle = $$.getToggle(that, d).bind($$);
        if (config.data_selection_enabled && config.data_selection_isselectable(d)) {
            if (!config.data_selection_multiple) $$.main.selectAll("." + CLASS.shapes + (config.data_selection_grouped ? $$.getTargetSelectorSuffix(d.id) : "")).selectAll("." + CLASS.shape).each(function(d, i) {
                var shape = d3.select(this);
                if (shape.classed(CLASS.SELECTED)) toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
            });
            shape.classed(CLASS.SELECTED, !isSelected);
            toggle(!isSelected, shape, d, i);
        }
    };
    ChartInternal.prototype.initBar = function() {
        var $$ = this;
        $$.main.select("." + CLASS.chart).append("g").attr("class", CLASS.chartBars);
    };
    ChartInternal.prototype.updateTargetsForBar = function(targets) {
        var $$ = this, config = $$.config, mainBars, mainBarEnter, classChartBar = $$.classChartBar.bind($$), classBars = $$.classBars.bind($$), classFocus = $$.classFocus.bind($$);
        mainBars = $$.main.select("." + CLASS.chartBars).selectAll("." + CLASS.chartBar).data(targets).attr("class", function(d) {
            return classChartBar(d) + classFocus(d);
        });
        mainBarEnter = mainBars.enter().append("g").attr("class", classChartBar).style("pointer-events", "none");
        // Bars for each data
        mainBarEnter.append("g").attr("class", classBars).style("cursor", function(d) {
            return config.data_selection_isselectable(d) ? "pointer" : null;
        });
    };
    ChartInternal.prototype.updateBar = function(durationForExit) {
        var $$ = this, barData = $$.barData.bind($$), classBar = $$.classBar.bind($$), initialOpacity = $$.initialOpacity.bind($$), color = function(d) {
            return $$.color(d.id);
        };
        var mainBar = $$.main.selectAll("." + CLASS.bars).selectAll("." + CLASS.bar).data(barData);
        var mainBarEnter = mainBar.enter().append("path").attr("class", classBar).style("stroke", color).style("fill", color);
        $$.mainBar = mainBarEnter.merge(mainBar).style("opacity", initialOpacity);
        mainBar.exit().transition().duration(durationForExit).style("opacity", 0);
    };
    ChartInternal.prototype.redrawBar = function(drawBar, withTransition, transition) {
        var $$ = this;
        return [
            (withTransition ? this.mainBar.transition(transition) : this.mainBar).attr("d", drawBar).style("stroke", this.color).style("fill", this.color).style("opacity", function(d) {
                return $$.isTargetToShow(d.id) ? 1 : 0;
            })
        ];
    };
    ChartInternal.prototype.getBarW = function(axis, barTargetsNum) {
        var $$ = this, config = $$.config, w = typeof config.bar_width === "number" ? config.bar_width : barTargetsNum ? axis.tickInterval() * config.bar_width_ratio / barTargetsNum : 0;
        return config.bar_width_max && w > config.bar_width_max ? config.bar_width_max : w;
    };
    ChartInternal.prototype.getBars = function(i, id) {
        var $$ = this;
        return (id ? $$.main.selectAll("." + CLASS.bars + $$.getTargetSelectorSuffix(id)) : $$.main).selectAll("." + CLASS.bar + (isValue(i) ? "-" + i : ""));
    };
    ChartInternal.prototype.expandBars = function(i, id, reset) {
        var $$ = this;
        if (reset) $$.unexpandBars();
        $$.getBars(i, id).classed(CLASS.EXPANDED, true);
    };
    ChartInternal.prototype.unexpandBars = function(i) {
        var $$ = this;
        $$.getBars(i).classed(CLASS.EXPANDED, false);
    };
    ChartInternal.prototype.generateDrawBar = function(barIndices, isSub) {
        var $$ = this, config = $$.config, getPoints = $$.generateGetBarPoints(barIndices, isSub);
        return function(d, i) {
            // 4 points that make a bar
            var points = getPoints(d, i);
            // switch points if axis is rotated, not applicable for sub chart
            var indexX = config.axis_rotated ? 1 : 0;
            var indexY = config.axis_rotated ? 0 : 1;
            var path = "M " + points[0][indexX] + "," + points[0][indexY] + " " + "L" + points[1][indexX] + "," + points[1][indexY] + " " + "L" + points[2][indexX] + "," + points[2][indexY] + " " + "L" + points[3][indexX] + "," + points[3][indexY] + " " + "z";
            return path;
        };
    };
    ChartInternal.prototype.generateGetBarPoints = function(barIndices, isSub) {
        var $$ = this, axis = isSub ? $$.subXAxis : $$.xAxis, barTargetsNum = barIndices.__max__ + 1, barW = $$.getBarW(axis, barTargetsNum), barX = $$.getShapeX(barW, barTargetsNum, barIndices, !!isSub), barY = $$.getShapeY(!!isSub), barOffset = $$.getShapeOffset($$.isBarType, barIndices, !!isSub), barSpaceOffset = barW * ($$.config.bar_space / 2), yScale = isSub ? $$.getSubYScale : $$.getYScale;
        return function(d, i) {
            var y0 = yScale.call($$, d.id)(0), offset = barOffset(d, i) || y0, posX = barX(d), posY = barY(d);
            // fix posY not to overflow opposite quadrant
            if ($$.config.axis_rotated) {
                if (0 < d.value && posY < y0 || d.value < 0 && y0 < posY) posY = y0;
            }
            posY -= y0 - offset;
            // 4 points that make a bar
            return [
                [
                    posX + barSpaceOffset,
                    offset
                ],
                [
                    posX + barSpaceOffset,
                    posY
                ],
                [
                    posX + barW - barSpaceOffset,
                    posY
                ],
                [
                    posX + barW - barSpaceOffset,
                    offset
                ]
            ];
        };
    };
    /**
   * Returns whether the data point is within the given bar shape.
   *
   * @param mouse
   * @param barShape
   * @return {boolean}
   */ ChartInternal.prototype.isWithinBar = function(mouse, barShape) {
        return isWithinBox(mouse, getBBox(barShape), 2);
    };
    ChartInternal.prototype.getShapeIndices = function(typeFilter) {
        var $$ = this, config = $$.config, indices = {}, i = 0, j, k;
        $$.filterTargetsToShow($$.data.targets.filter(typeFilter, $$)).forEach(function(d) {
            for(j = 0; j < config.data_groups.length; j++){
                if (config.data_groups[j].indexOf(d.id) < 0) continue;
                for(k = 0; k < config.data_groups[j].length; k++)if (config.data_groups[j][k] in indices) {
                    indices[d.id] = indices[config.data_groups[j][k]];
                    break;
                }
            }
            if (isUndefined(indices[d.id])) indices[d.id] = i++;
        });
        indices.__max__ = i - 1;
        return indices;
    };
    ChartInternal.prototype.getShapeX = function(offset, targetsNum, indices, isSub) {
        var $$ = this, scale = isSub ? $$.subX : $$.x;
        return function(d) {
            var index = d.id in indices ? indices[d.id] : 0;
            return d.x || d.x === 0 ? scale(d.x) - offset * (targetsNum / 2 - index) : 0;
        };
    };
    ChartInternal.prototype.getShapeY = function(isSub) {
        var $$ = this;
        return function(d) {
            var scale = isSub ? $$.getSubYScale(d.id) : $$.getYScale(d.id);
            return scale($$.isTargetNormalized(d.id) ? $$.getRatio("index", d, true) : d.value);
        };
    };
    ChartInternal.prototype.getShapeOffset = function(typeFilter, indices, isSub) {
        var $$ = this, targets = $$.orderTargets($$.filterTargetsToShow($$.data.targets.filter(typeFilter, $$))), targetIds = targets.map(function(t) {
            return t.id;
        });
        return function(d, i) {
            var scale = isSub ? $$.getSubYScale(d.id) : $$.getYScale(d.id), y0 = scale(0), offset = y0;
            targets.forEach(function(t) {
                var rowValues = $$.isStepType(d) ? $$.convertValuesToStep(t.values) : t.values;
                var isTargetNormalized = $$.isTargetNormalized(d.id);
                var values = rowValues.map(function(v) {
                    return isTargetNormalized ? $$.getRatio("index", v, true) : v.value;
                });
                if (t.id === d.id || indices[t.id] !== indices[d.id]) return;
                if (targetIds.indexOf(t.id) < targetIds.indexOf(d.id)) {
                    // check if the x values line up
                    if (isUndefined(rowValues[i]) || +rowValues[i].x !== +d.x) {
                        // "+" for timeseries
                        // if not, try to find the value that does line up
                        i = -1;
                        rowValues.forEach(function(v, j) {
                            var x1 = v.x.constructor === Date ? +v.x : v.x;
                            var x2 = d.x.constructor === Date ? +d.x : d.x;
                            if (x1 === x2) i = j;
                        });
                    }
                    if (i in rowValues && rowValues[i].value * d.value >= 0) offset += scale(values[i]) - y0;
                }
            });
            return offset;
        };
    };
    ChartInternal.prototype.isWithinShape = function(that, d) {
        var $$ = this, shape = $$.d3.select(that), isWithin;
        if (!$$.isTargetToShow(d.id)) isWithin = false;
        else if (that.nodeName === "circle") isWithin = $$.isStepType(d) ? $$.isWithinStep(that, $$.getYScale(d.id)(d.value)) : $$.isWithinCircle(that, $$.pointSelectR(d) * 1.5);
        else if (that.nodeName === "path") isWithin = shape.classed(CLASS.bar) ? $$.isWithinBar($$.d3.mouse(that), that) : true;
        return isWithin;
    };
    ChartInternal.prototype.getInterpolate = function(d) {
        var $$ = this, d3 = $$.d3, types = {
            linear: d3.curveLinear,
            "linear-closed": d3.curveLinearClosed,
            basis: d3.curveBasis,
            "basis-open": d3.curveBasisOpen,
            "basis-closed": d3.curveBasisClosed,
            bundle: d3.curveBundle,
            cardinal: d3.curveCardinal,
            "cardinal-open": d3.curveCardinalOpen,
            "cardinal-closed": d3.curveCardinalClosed,
            monotone: d3.curveMonotoneX,
            step: d3.curveStep,
            "step-before": d3.curveStepBefore,
            "step-after": d3.curveStepAfter
        }, type;
        if ($$.isSplineType(d)) type = types[$$.config.spline_interpolation_type] || types.cardinal;
        else if ($$.isStepType(d)) type = types[$$.config.line_step_type];
        else type = types.linear;
        return type;
    };
    ChartInternal.prototype.initLine = function() {
        var $$ = this;
        $$.main.select("." + CLASS.chart).append("g").attr("class", CLASS.chartLines);
    };
    ChartInternal.prototype.updateTargetsForLine = function(targets) {
        var $$ = this, config = $$.config, mainLines, mainLineEnter, classChartLine = $$.classChartLine.bind($$), classLines = $$.classLines.bind($$), classAreas = $$.classAreas.bind($$), classCircles = $$.classCircles.bind($$), classFocus = $$.classFocus.bind($$);
        mainLines = $$.main.select("." + CLASS.chartLines).selectAll("." + CLASS.chartLine).data(targets).attr("class", function(d) {
            return classChartLine(d) + classFocus(d);
        });
        mainLineEnter = mainLines.enter().append("g").attr("class", classChartLine).style("opacity", 0).style("pointer-events", "none");
        // Lines for each data
        mainLineEnter.append("g").attr("class", classLines);
        // Areas
        mainLineEnter.append("g").attr("class", classAreas);
        // Circles for each data point on lines
        mainLineEnter.append("g").attr("class", function(d) {
            return $$.generateClass(CLASS.selectedCircles, d.id);
        });
        mainLineEnter.append("g").attr("class", classCircles).style("cursor", function(d) {
            return config.data_selection_isselectable(d) ? "pointer" : null;
        });
        // Update date for selected circles
        targets.forEach(function(t) {
            $$.main.selectAll("." + CLASS.selectedCircles + $$.getTargetSelectorSuffix(t.id)).selectAll("." + CLASS.selectedCircle).each(function(d) {
                d.value = t.values[d.index].value;
            });
        });
    // MEMO: can not keep same color...
    //mainLineUpdate.exit().remove();
    };
    ChartInternal.prototype.updateLine = function(durationForExit) {
        var $$ = this;
        var mainLine = $$.main.selectAll("." + CLASS.lines).selectAll("." + CLASS.line).data($$.lineData.bind($$));
        var mainLineEnter = mainLine.enter().append("path").attr("class", $$.classLine.bind($$)).style("stroke", $$.color);
        $$.mainLine = mainLineEnter.merge(mainLine).style("opacity", $$.initialOpacity.bind($$)).style("shape-rendering", function(d) {
            return $$.isStepType(d) ? "crispEdges" : "";
        }).attr("transform", null);
        mainLine.exit().transition().duration(durationForExit).style("opacity", 0);
    };
    ChartInternal.prototype.redrawLine = function(drawLine, withTransition, transition) {
        return [
            (withTransition ? this.mainLine.transition(transition) : this.mainLine).attr("d", drawLine).style("stroke", this.color).style("opacity", 1)
        ];
    };
    ChartInternal.prototype.generateDrawLine = function(lineIndices, isSub) {
        var $$ = this, config = $$.config, line = $$.d3.line(), getPoints = $$.generateGetLinePoints(lineIndices, isSub), yScaleGetter = isSub ? $$.getSubYScale : $$.getYScale, xValue = function(d) {
            return (isSub ? $$.subxx : $$.xx).call($$, d);
        }, yValue = function(d, i) {
            return config.data_groups.length > 0 ? getPoints(d, i)[0][1] : yScaleGetter.call($$, d.id)(d.value);
        };
        line = config.axis_rotated ? line.x(yValue).y(xValue) : line.x(xValue).y(yValue);
        if (!config.line_connectNull) line = line.defined(function(d) {
            return d.value != null;
        });
        return function(d) {
            var values = config.line_connectNull ? $$.filterRemoveNull(d.values) : d.values, x = isSub ? $$.subX : $$.x, y = yScaleGetter.call($$, d.id), x0 = 0, y0 = 0, path;
            if ($$.isLineType(d)) {
                if (config.data_regions[d.id]) path = $$.lineWithRegions(values, x, y, config.data_regions[d.id]);
                else {
                    if ($$.isStepType(d)) values = $$.convertValuesToStep(values);
                    path = line.curve($$.getInterpolate(d))(values);
                }
            } else {
                if (values[0]) {
                    x0 = x(values[0].x);
                    y0 = y(values[0].value);
                }
                path = config.axis_rotated ? "M " + y0 + " " + x0 : "M " + x0 + " " + y0;
            }
            return path ? path : "M 0 0";
        };
    };
    ChartInternal.prototype.generateGetLinePoints = function(lineIndices, isSub) {
        // partial duplication of generateGetBarPoints
        var $$ = this, config = $$.config, lineTargetsNum = lineIndices.__max__ + 1, x = $$.getShapeX(0, lineTargetsNum, lineIndices, !!isSub), y = $$.getShapeY(!!isSub), lineOffset = $$.getShapeOffset($$.isLineType, lineIndices, !!isSub), yScale = isSub ? $$.getSubYScale : $$.getYScale;
        return function(d, i) {
            var y0 = yScale.call($$, d.id)(0), offset = lineOffset(d, i) || y0, posX = x(d), posY = y(d);
            // fix posY not to overflow opposite quadrant
            if (config.axis_rotated) {
                if (0 < d.value && posY < y0 || d.value < 0 && y0 < posY) posY = y0;
            }
            // 1 point that marks the line position
            return [
                [
                    posX,
                    posY - (y0 - offset)
                ],
                [
                    posX,
                    posY - (y0 - offset)
                ],
                [
                    posX,
                    posY - (y0 - offset)
                ],
                [
                    posX,
                    posY - (y0 - offset)
                ] // needed for compatibility
            ];
        };
    };
    ChartInternal.prototype.lineWithRegions = function(d, x, y, _regions) {
        var $$ = this, config = $$.config, prev = -1, i, j, s = "M", sWithRegion, xp, yp, dx, dy, dd, diff, diffx2, xOffset = $$.isCategorized() ? 0.5 : 0, xValue, yValue, regions = [];
        function isWithinRegions(x, regions) {
            var i;
            for(i = 0; i < regions.length; i++){
                if (regions[i].start < x && x <= regions[i].end) return true;
            }
            return false;
        }
        // Check start/end of regions
        if (isDefined(_regions)) for(i = 0; i < _regions.length; i++){
            regions[i] = {};
            if (isUndefined(_regions[i].start)) regions[i].start = d[0].x;
            else regions[i].start = $$.isTimeSeries() ? $$.parseDate(_regions[i].start) : _regions[i].start;
            if (isUndefined(_regions[i].end)) regions[i].end = d[d.length - 1].x;
            else regions[i].end = $$.isTimeSeries() ? $$.parseDate(_regions[i].end) : _regions[i].end;
        }
        // Set scales
        xValue = config.axis_rotated ? function(d) {
            return y(d.value);
        } : function(d) {
            return x(d.x);
        };
        yValue = config.axis_rotated ? function(d) {
            return x(d.x);
        } : function(d) {
            return y(d.value);
        };
        // Define svg generator function for region
        function generateM(points) {
            return "M" + points[0][0] + " " + points[0][1] + " " + points[1][0] + " " + points[1][1];
        }
        if ($$.isTimeSeries()) sWithRegion = function(d0, d1, j, diff) {
            var x0 = d0.x.getTime(), x_diff = d1.x - d0.x, xv0 = new Date(x0 + x_diff * j), xv1 = new Date(x0 + x_diff * (j + diff)), points;
            if (config.axis_rotated) points = [
                [
                    y(yp(j)),
                    x(xv0)
                ],
                [
                    y(yp(j + diff)),
                    x(xv1)
                ]
            ];
            else points = [
                [
                    x(xv0),
                    y(yp(j))
                ],
                [
                    x(xv1),
                    y(yp(j + diff))
                ]
            ];
            return generateM(points);
        };
        else sWithRegion = function(d0, d1, j, diff) {
            var points;
            if (config.axis_rotated) points = [
                [
                    y(yp(j), true),
                    x(xp(j))
                ],
                [
                    y(yp(j + diff), true),
                    x(xp(j + diff))
                ]
            ];
            else points = [
                [
                    x(xp(j), true),
                    y(yp(j))
                ],
                [
                    x(xp(j + diff), true),
                    y(yp(j + diff))
                ]
            ];
            return generateM(points);
        };
        // Generate
        for(i = 0; i < d.length; i++){
            // Draw as normal
            if (isUndefined(regions) || !isWithinRegions(d[i].x, regions)) s += " " + xValue(d[i]) + " " + yValue(d[i]);
            else {
                xp = $$.getScale(d[i - 1].x + xOffset, d[i].x + xOffset, $$.isTimeSeries());
                yp = $$.getScale(d[i - 1].value, d[i].value);
                dx = x(d[i].x) - x(d[i - 1].x);
                dy = y(d[i].value) - y(d[i - 1].value);
                dd = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                diff = 2 / dd;
                diffx2 = diff * 2;
                for(j = diff; j <= 1; j += diffx2)s += sWithRegion(d[i - 1], d[i], j, diff);
            }
            prev = d[i].x;
        }
        return s;
    };
    ChartInternal.prototype.updateArea = function(durationForExit) {
        var $$ = this, d3 = $$.d3;
        var mainArea = $$.main.selectAll("." + CLASS.areas).selectAll("." + CLASS.area).data($$.lineData.bind($$));
        var mainAreaEnter = mainArea.enter().append("path").attr("class", $$.classArea.bind($$)).style("fill", $$.color).style("opacity", function() {
            $$.orgAreaOpacity = +d3.select(this).style("opacity");
            return 0;
        });
        $$.mainArea = mainAreaEnter.merge(mainArea).style("opacity", $$.orgAreaOpacity);
        mainArea.exit().transition().duration(durationForExit).style("opacity", 0);
    };
    ChartInternal.prototype.redrawArea = function(drawArea, withTransition, transition) {
        return [
            (withTransition ? this.mainArea.transition(transition) : this.mainArea).attr("d", drawArea).style("fill", this.color).style("opacity", this.orgAreaOpacity)
        ];
    };
    ChartInternal.prototype.generateDrawArea = function(areaIndices, isSub) {
        var $$ = this, config = $$.config, area = $$.d3.area(), getPoints = $$.generateGetAreaPoints(areaIndices, isSub), yScaleGetter = isSub ? $$.getSubYScale : $$.getYScale, xValue = function(d) {
            return (isSub ? $$.subxx : $$.xx).call($$, d);
        }, value0 = function(d, i) {
            return config.data_groups.length > 0 ? getPoints(d, i)[0][1] : yScaleGetter.call($$, d.id)($$.getAreaBaseValue(d.id));
        }, value1 = function(d, i) {
            return config.data_groups.length > 0 ? getPoints(d, i)[1][1] : yScaleGetter.call($$, d.id)(d.value);
        };
        area = config.axis_rotated ? area.x0(value0).x1(value1).y(xValue) : area.x(xValue).y0(config.area_above ? 0 : value0).y1(value1);
        if (!config.line_connectNull) area = area.defined(function(d) {
            return d.value !== null;
        });
        return function(d) {
            var values = config.line_connectNull ? $$.filterRemoveNull(d.values) : d.values, x0 = 0, y0 = 0, path;
            if ($$.isAreaType(d)) {
                if ($$.isStepType(d)) values = $$.convertValuesToStep(values);
                path = area.curve($$.getInterpolate(d))(values);
            } else {
                if (values[0]) {
                    x0 = $$.x(values[0].x);
                    y0 = $$.getYScale(d.id)(values[0].value);
                }
                path = config.axis_rotated ? "M " + y0 + " " + x0 : "M " + x0 + " " + y0;
            }
            return path ? path : "M 0 0";
        };
    };
    ChartInternal.prototype.getAreaBaseValue = function() {
        return 0;
    };
    ChartInternal.prototype.generateGetAreaPoints = function(areaIndices, isSub) {
        // partial duplication of generateGetBarPoints
        var $$ = this, config = $$.config, areaTargetsNum = areaIndices.__max__ + 1, x = $$.getShapeX(0, areaTargetsNum, areaIndices, !!isSub), y = $$.getShapeY(!!isSub), areaOffset = $$.getShapeOffset($$.isAreaType, areaIndices, !!isSub), yScale = isSub ? $$.getSubYScale : $$.getYScale;
        return function(d, i) {
            var y0 = yScale.call($$, d.id)(0), offset = areaOffset(d, i) || y0, posX = x(d), posY = y(d);
            // fix posY not to overflow opposite quadrant
            if (config.axis_rotated) {
                if (0 < d.value && posY < y0 || d.value < 0 && y0 < posY) posY = y0;
            }
            // 1 point that marks the area position
            return [
                [
                    posX,
                    offset
                ],
                [
                    posX,
                    posY - (y0 - offset)
                ],
                [
                    posX,
                    posY - (y0 - offset)
                ],
                [
                    posX,
                    offset
                ] // needed for compatibility
            ];
        };
    };
    ChartInternal.prototype.updateCircle = function(cx, cy) {
        var $$ = this;
        var mainCircle = $$.main.selectAll("." + CLASS.circles).selectAll("." + CLASS.circle).data($$.lineOrScatterOrStanfordData.bind($$));
        var mainCircleEnter = mainCircle.enter().append("circle").attr("shape-rendering", $$.isStanfordGraphType() ? "crispEdges" : "").attr("class", $$.classCircle.bind($$)).attr("cx", cx).attr("cy", cy).attr("r", $$.pointR.bind($$)).style("color", $$.isStanfordGraphType() ? $$.getStanfordPointColor.bind($$) : $$.color);
        $$.mainCircle = mainCircleEnter.merge(mainCircle).style("opacity", $$.isStanfordGraphType() ? 1 : $$.initialOpacityForCircle.bind($$));
        mainCircle.exit().style("opacity", 0);
    };
    ChartInternal.prototype.redrawCircle = function(cx, cy, withTransition, transition) {
        var $$ = this, selectedCircles = $$.main.selectAll("." + CLASS.selectedCircle);
        return [
            (withTransition ? $$.mainCircle.transition(transition) : $$.mainCircle).style("opacity", this.opacityForCircle.bind($$)).style("color", $$.isStanfordGraphType() ? $$.getStanfordPointColor.bind($$) : $$.color).attr("cx", cx).attr("cy", cy),
            (withTransition ? selectedCircles.transition(transition) : selectedCircles).attr("cx", cx).attr("cy", cy)
        ];
    };
    ChartInternal.prototype.circleX = function(d) {
        return d.x || d.x === 0 ? this.x(d.x) : null;
    };
    ChartInternal.prototype.updateCircleY = function() {
        var $$ = this, lineIndices, getPoints;
        if ($$.config.data_groups.length > 0) {
            lineIndices = $$.getShapeIndices($$.isLineType), getPoints = $$.generateGetLinePoints(lineIndices);
            $$.circleY = function(d, i) {
                return getPoints(d, i)[0][1];
            };
        } else $$.circleY = function(d) {
            return $$.getYScale(d.id)(d.value);
        };
    };
    ChartInternal.prototype.getCircles = function(i, id) {
        var $$ = this;
        return (id ? $$.main.selectAll("." + CLASS.circles + $$.getTargetSelectorSuffix(id)) : $$.main).selectAll("." + CLASS.circle + (isValue(i) ? "-" + i : ""));
    };
    ChartInternal.prototype.expandCircles = function(i, id, reset) {
        var $$ = this, r = $$.pointExpandedR.bind($$);
        if (reset) $$.unexpandCircles();
        $$.getCircles(i, id).classed(CLASS.EXPANDED, true).attr("r", r);
    };
    ChartInternal.prototype.unexpandCircles = function(i) {
        var $$ = this, r = $$.pointR.bind($$);
        $$.getCircles(i).filter(function() {
            return $$.d3.select(this).classed(CLASS.EXPANDED);
        }).classed(CLASS.EXPANDED, false).attr("r", r);
    };
    ChartInternal.prototype.pointR = function(d) {
        var $$ = this, config = $$.config;
        return $$.isStepType(d) ? 0 : isFunction(config.point_r) ? config.point_r(d) : config.point_r;
    };
    ChartInternal.prototype.pointExpandedR = function(d) {
        var $$ = this, config = $$.config;
        if (config.point_focus_expand_enabled) return isFunction(config.point_focus_expand_r) ? config.point_focus_expand_r(d) : config.point_focus_expand_r ? config.point_focus_expand_r : $$.pointR(d) * 1.75;
        else return $$.pointR(d);
    };
    ChartInternal.prototype.pointSelectR = function(d) {
        var $$ = this, config = $$.config;
        return isFunction(config.point_select_r) ? config.point_select_r(d) : config.point_select_r ? config.point_select_r : $$.pointR(d) * 4;
    };
    ChartInternal.prototype.isWithinCircle = function(that, r) {
        var d3 = this.d3, mouse = d3.mouse(that), d3_this = d3.select(that), cx = +d3_this.attr("cx"), cy = +d3_this.attr("cy");
        return Math.sqrt(Math.pow(cx - mouse[0], 2) + Math.pow(cy - mouse[1], 2)) < r;
    };
    ChartInternal.prototype.isWithinStep = function(that, y) {
        return Math.abs(y - this.d3.mouse(that)[1]) < 30;
    };
    ChartInternal.prototype.getCurrentWidth = function() {
        var $$ = this, config = $$.config;
        return config.size_width ? config.size_width : $$.getParentWidth();
    };
    ChartInternal.prototype.getCurrentHeight = function() {
        var $$ = this, config = $$.config, h = config.size_height ? config.size_height : $$.getParentHeight();
        return h > 0 ? h : 320 / ($$.hasType("gauge") && !config.gauge_fullCircle ? 2 : 1);
    };
    ChartInternal.prototype.getCurrentPaddingTop = function() {
        var $$ = this, config = $$.config, padding = isValue(config.padding_top) ? config.padding_top : 0;
        if ($$.title && $$.title.node()) padding += $$.getTitlePadding();
        return padding;
    };
    ChartInternal.prototype.getCurrentPaddingBottom = function() {
        var config = this.config;
        return isValue(config.padding_bottom) ? config.padding_bottom : 0;
    };
    ChartInternal.prototype.getCurrentPaddingLeft = function(withoutRecompute) {
        var $$ = this, config = $$.config;
        if (isValue(config.padding_left)) return config.padding_left;
        else if (config.axis_rotated) return !config.axis_x_show || config.axis_x_inner ? 1 : Math.max(ceil10($$.getAxisWidthByAxisId("x", withoutRecompute)), 40);
        else if (!config.axis_y_show || config.axis_y_inner) // && !config.axis_rotated
        return $$.axis.getYAxisLabelPosition().isOuter ? 30 : 1;
        else return ceil10($$.getAxisWidthByAxisId("y", withoutRecompute));
    };
    ChartInternal.prototype.getCurrentPaddingRight = function() {
        var $$ = this, config = $$.config, padding = 0, defaultPadding = 10, legendWidthOnRight = $$.isLegendRight ? $$.getLegendWidth() + 20 : 0;
        if (isValue(config.padding_right)) padding = config.padding_right + 1; // 1 is needed not to hide tick line
        else if (config.axis_rotated) padding = defaultPadding + legendWidthOnRight;
        else if (!config.axis_y2_show || config.axis_y2_inner) // && !config.axis_rotated
        padding = 2 + legendWidthOnRight + ($$.axis.getY2AxisLabelPosition().isOuter ? 20 : 0);
        else padding = ceil10($$.getAxisWidthByAxisId("y2")) + legendWidthOnRight;
        if ($$.colorScale && $$.colorScale.node()) padding += $$.getColorScalePadding();
        return padding;
    };
    ChartInternal.prototype.getParentRectValue = function(key) {
        var parent = this.selectChart.node(), v;
        while(parent && parent.tagName !== "BODY"){
            try {
                v = parent.getBoundingClientRect()[key];
            } catch (e) {
                if (key === "width") // In IE in certain cases getBoundingClientRect
                // will cause an "unspecified error"
                v = parent.offsetWidth;
            }
            if (v) break;
            parent = parent.parentNode;
        }
        return v;
    };
    ChartInternal.prototype.getParentWidth = function() {
        return this.getParentRectValue("width");
    };
    ChartInternal.prototype.getParentHeight = function() {
        var h = this.selectChart.style("height");
        return h.indexOf("px") > 0 ? +h.replace("px", "") : 0;
    };
    ChartInternal.prototype.getSvgLeft = function(withoutRecompute) {
        var $$ = this, config = $$.config, hasLeftAxisRect = config.axis_rotated || !config.axis_rotated && !config.axis_y_inner, leftAxisClass = config.axis_rotated ? CLASS.axisX : CLASS.axisY, leftAxis = $$.main.select("." + leftAxisClass).node(), svgRect = leftAxis && hasLeftAxisRect ? leftAxis.getBoundingClientRect() : {
            right: 0
        }, chartRect = $$.selectChart.node().getBoundingClientRect(), hasArc = $$.hasArcType(), svgLeft = svgRect.right - chartRect.left - (hasArc ? 0 : $$.getCurrentPaddingLeft(withoutRecompute));
        return svgLeft > 0 ? svgLeft : 0;
    };
    ChartInternal.prototype.getAxisWidthByAxisId = function(id, withoutRecompute) {
        var $$ = this, position = $$.axis.getLabelPositionById(id);
        return $$.axis.getMaxTickWidth(id, withoutRecompute) + (position.isInner ? 20 : 40);
    };
    ChartInternal.prototype.getHorizontalAxisHeight = function(axisId, isSubchart) {
        var $$ = this, config = $$.config, h = 30;
        if (axisId === "x" && !(isDefined(isSubchart) && isSubchart ? config.subchart_axis_x_show : config.axis_x_show)) return 8;
        if (axisId === "x" && config.axis_x_height) return config.axis_x_height;
        if (axisId === "y" && !config.axis_y_show) return config.legend_show && !$$.isLegendRight && !$$.isLegendInset ? 10 : 1;
        if (axisId === "y2" && !config.axis_y2_show) return $$.rotated_padding_top;
        // Calculate x axis height when tick rotated
        if (axisId === "x" && !config.axis_rotated && config.axis_x_tick_rotate) h = 30 + $$.axis.getMaxTickWidth(axisId) * Math.cos(Math.PI * (90 - Math.abs(config.axis_x_tick_rotate)) / 180);
        // Calculate y axis height when tick rotated
        if (axisId === "y" && config.axis_rotated && config.axis_y_tick_rotate) h = 30 + $$.axis.getMaxTickWidth(axisId) * Math.cos(Math.PI * (90 - Math.abs(config.axis_y_tick_rotate)) / 180);
        return h + ($$.axis.getLabelPositionById(axisId).isInner ? 0 : 10) + (axisId === "y2" ? -10 : 0);
    };
    ChartInternal.prototype.initBrush = function(scale) {
        var $$ = this, d3 = $$.d3;
        // TODO: dynamically change brushY/brushX according to axis_rotated.
        $$.brush = ($$.config.axis_rotated ? d3.brushY() : d3.brushX()).on("brush", function() {
            var event = d3.event.sourceEvent;
            if (event && event.type === "zoom") return;
            $$.redrawForBrush();
        }).on("end", function() {
            var event = d3.event.sourceEvent;
            if (event && event.type === "zoom") return;
            if ($$.brush.empty() && event && event.type !== "end") $$.brush.clear();
        });
        $$.brush.updateExtent = function() {
            var range = this.scale.range(), extent;
            if ($$.config.axis_rotated) extent = [
                [
                    0,
                    range[0]
                ],
                [
                    $$.width2,
                    range[1]
                ]
            ];
            else extent = [
                [
                    range[0],
                    0
                ],
                [
                    range[1],
                    $$.height2
                ]
            ];
            this.extent(extent);
            return this;
        };
        $$.brush.updateScale = function(scale) {
            this.scale = scale;
            return this;
        };
        $$.brush.update = function(scale) {
            this.updateScale(scale || $$.subX).updateExtent();
            $$.context.select("." + CLASS.brush).call(this);
        };
        $$.brush.clear = function() {
            $$.context.select("." + CLASS.brush).call($$.brush.move, null);
        };
        $$.brush.selection = function() {
            return d3.brushSelection($$.context.select("." + CLASS.brush).node());
        };
        $$.brush.selectionAsValue = function(selectionAsValue, withTransition) {
            var selection, brush;
            if (selectionAsValue) {
                if ($$.context) {
                    selection = [
                        this.scale(selectionAsValue[0]),
                        this.scale(selectionAsValue[1])
                    ];
                    brush = $$.context.select("." + CLASS.brush);
                    if (withTransition) brush = brush.transition();
                    $$.brush.move(brush, selection);
                }
                return [];
            }
            selection = $$.brush.selection() || [
                0,
                0
            ];
            return [
                this.scale.invert(selection[0]),
                this.scale.invert(selection[1])
            ];
        };
        $$.brush.empty = function() {
            var selection = $$.brush.selection();
            return !selection || selection[0] === selection[1];
        };
        return $$.brush.updateScale(scale);
    };
    ChartInternal.prototype.initSubchart = function() {
        var $$ = this, config = $$.config, context = $$.context = $$.svg.append("g").attr("transform", $$.getTranslate("context"));
        // set style
        context.style("visibility", "visible");
        // Define g for chart area
        context.append("g").attr("clip-path", $$.clipPathForSubchart).attr("class", CLASS.chart);
        // Define g for bar chart area
        context.select("." + CLASS.chart).append("g").attr("class", CLASS.chartBars);
        // Define g for line chart area
        context.select("." + CLASS.chart).append("g").attr("class", CLASS.chartLines);
        // Add extent rect for Brush
        context.append("g").attr("clip-path", $$.clipPath).attr("class", CLASS.brush);
        // ATTENTION: This must be called AFTER chart added
        // Add Axis
        $$.axes.subx = context.append("g").attr("class", CLASS.axisX).attr("transform", $$.getTranslate("subx")).attr("clip-path", config.axis_rotated ? "" : $$.clipPathForXAxis).style("visibility", config.subchart_axis_x_show ? "visible" : "hidden");
    };
    ChartInternal.prototype.initSubchartBrush = function() {
        var $$ = this;
        // Add extent rect for Brush
        $$.initBrush($$.subX).updateExtent();
        $$.context.select("." + CLASS.brush).call($$.brush);
    };
    ChartInternal.prototype.updateTargetsForSubchart = function(targets) {
        var $$ = this, context = $$.context, config = $$.config, contextLineEnter, contextLine, contextBarEnter, contextBar, classChartBar = $$.classChartBar.bind($$), classBars = $$.classBars.bind($$), classChartLine = $$.classChartLine.bind($$), classLines = $$.classLines.bind($$), classAreas = $$.classAreas.bind($$);
        //-- Bar --//
        contextBar = context.select("." + CLASS.chartBars).selectAll("." + CLASS.chartBar).data(targets);
        contextBarEnter = contextBar.enter().append("g").style("opacity", 0);
        contextBarEnter.merge(contextBar).attr("class", classChartBar);
        // Bars for each data
        contextBarEnter.append("g").attr("class", classBars);
        //-- Line --//
        contextLine = context.select("." + CLASS.chartLines).selectAll("." + CLASS.chartLine).data(targets);
        contextLineEnter = contextLine.enter().append("g").style("opacity", 0);
        contextLineEnter.merge(contextLine).attr("class", classChartLine);
        // Lines for each data
        contextLineEnter.append("g").attr("class", classLines);
        // Area
        contextLineEnter.append("g").attr("class", classAreas);
        //-- Brush --//
        context.selectAll("." + CLASS.brush + " rect").attr(config.axis_rotated ? "width" : "height", config.axis_rotated ? $$.width2 : $$.height2);
    };
    ChartInternal.prototype.updateBarForSubchart = function(durationForExit) {
        var $$ = this;
        var contextBar = $$.context.selectAll("." + CLASS.bars).selectAll("." + CLASS.bar).data($$.barData.bind($$));
        var contextBarEnter = contextBar.enter().append("path").attr("class", $$.classBar.bind($$)).style("stroke", "none").style("fill", $$.color);
        contextBar.exit().transition().duration(durationForExit).style("opacity", 0).remove();
        $$.contextBar = contextBarEnter.merge(contextBar).style("opacity", $$.initialOpacity.bind($$));
    };
    ChartInternal.prototype.redrawBarForSubchart = function(drawBarOnSub, withTransition, duration) {
        (withTransition ? this.contextBar.transition(Math.random().toString()).duration(duration) : this.contextBar).attr("d", drawBarOnSub).style("opacity", 1);
    };
    ChartInternal.prototype.updateLineForSubchart = function(durationForExit) {
        var $$ = this;
        var contextLine = $$.context.selectAll("." + CLASS.lines).selectAll("." + CLASS.line).data($$.lineData.bind($$));
        var contextLineEnter = contextLine.enter().append("path").attr("class", $$.classLine.bind($$)).style("stroke", $$.color);
        contextLine.exit().transition().duration(durationForExit).style("opacity", 0).remove();
        $$.contextLine = contextLineEnter.merge(contextLine).style("opacity", $$.initialOpacity.bind($$));
    };
    ChartInternal.prototype.redrawLineForSubchart = function(drawLineOnSub, withTransition, duration) {
        (withTransition ? this.contextLine.transition(Math.random().toString()).duration(duration) : this.contextLine).attr("d", drawLineOnSub).style("opacity", 1);
    };
    ChartInternal.prototype.updateAreaForSubchart = function(durationForExit) {
        var $$ = this, d3 = $$.d3;
        var contextArea = $$.context.selectAll("." + CLASS.areas).selectAll("." + CLASS.area).data($$.lineData.bind($$));
        var contextAreaEnter = contextArea.enter().append("path").attr("class", $$.classArea.bind($$)).style("fill", $$.color).style("opacity", function() {
            $$.orgAreaOpacity = +d3.select(this).style("opacity");
            return 0;
        });
        contextArea.exit().transition().duration(durationForExit).style("opacity", 0).remove();
        $$.contextArea = contextAreaEnter.merge(contextArea).style("opacity", 0);
    };
    ChartInternal.prototype.redrawAreaForSubchart = function(drawAreaOnSub, withTransition, duration) {
        (withTransition ? this.contextArea.transition(Math.random().toString()).duration(duration) : this.contextArea).attr("d", drawAreaOnSub).style("fill", this.color).style("opacity", this.orgAreaOpacity);
    };
    ChartInternal.prototype.redrawSubchart = function(withSubchart, transitions, duration, durationForExit, areaIndices, barIndices, lineIndices) {
        var $$ = this, d3 = $$.d3, drawAreaOnSub, drawBarOnSub, drawLineOnSub;
        // reflect main chart to extent on subchart if zoomed
        if (d3.event && d3.event.type === "zoom") $$.brush.selectionAsValue($$.x.orgDomain());
        // update subchart elements if needed
        if (withSubchart) {
            // extent rect
            if (!$$.brush.empty()) $$.brush.selectionAsValue($$.x.orgDomain());
            // setup drawer - MEMO: this must be called after axis updated
            drawAreaOnSub = $$.generateDrawArea(areaIndices, true);
            drawBarOnSub = $$.generateDrawBar(barIndices, true);
            drawLineOnSub = $$.generateDrawLine(lineIndices, true);
            $$.updateBarForSubchart(duration);
            $$.updateLineForSubchart(duration);
            $$.updateAreaForSubchart(duration);
            $$.redrawBarForSubchart(drawBarOnSub, duration, duration);
            $$.redrawLineForSubchart(drawLineOnSub, duration, duration);
            $$.redrawAreaForSubchart(drawAreaOnSub, duration, duration);
        }
    };
    ChartInternal.prototype.redrawForBrush = function() {
        var $$ = this, x = $$.x, d3 = $$.d3, s;
        $$.redraw({
            withTransition: false,
            withY: $$.config.zoom_rescale,
            withSubchart: false,
            withUpdateXDomain: true,
            withEventRect: false,
            withDimension: false
        });
        // update zoom transation binded to event rect
        s = d3.event.selection || $$.brush.scale.range();
        $$.main.select("." + CLASS.eventRect).call($$.zoom.transform, d3.zoomIdentity.scale($$.width / (s[1] - s[0])).translate(-s[0], 0));
        $$.config.subchart_onbrush.call($$.api, x.orgDomain());
    };
    ChartInternal.prototype.transformContext = function(withTransition, transitions) {
        var $$ = this, subXAxis;
        if (transitions && transitions.axisSubX) subXAxis = transitions.axisSubX;
        else {
            subXAxis = $$.context.select("." + CLASS.axisX);
            if (withTransition) subXAxis = subXAxis.transition();
        }
        $$.context.attr("transform", $$.getTranslate("context"));
        subXAxis.attr("transform", $$.getTranslate("subx"));
    };
    ChartInternal.prototype.getDefaultSelection = function() {
        var $$ = this, config = $$.config, selection = isFunction(config.axis_x_selection) ? config.axis_x_selection($$.getXDomain($$.data.targets)) : config.axis_x_selection;
        if ($$.isTimeSeries()) selection = [
            $$.parseDate(selection[0]),
            $$.parseDate(selection[1])
        ];
        return selection;
    };
    ChartInternal.prototype.removeSubchart = function() {
        var $$ = this;
        $$.brush = null;
        $$.context.remove();
        $$.context = null;
    };
    ChartInternal.prototype.initText = function() {
        var $$ = this;
        $$.main.select("." + CLASS.chart).append("g").attr("class", CLASS.chartTexts);
        $$.mainText = $$.d3.selectAll([]);
    };
    ChartInternal.prototype.updateTargetsForText = function(targets) {
        var $$ = this, classChartText = $$.classChartText.bind($$), classTexts = $$.classTexts.bind($$), classFocus = $$.classFocus.bind($$);
        var mainText = $$.main.select("." + CLASS.chartTexts).selectAll("." + CLASS.chartText).data(targets);
        var mainTextEnter = mainText.enter().append("g").attr("class", classChartText).style("opacity", 0).style("pointer-events", "none");
        mainTextEnter.append("g").attr("class", classTexts);
        mainTextEnter.merge(mainText).attr("class", function(d) {
            return classChartText(d) + classFocus(d);
        });
    };
    ChartInternal.prototype.updateText = function(xForText, yForText, durationForExit) {
        var $$ = this, config = $$.config, barOrLineData = $$.barOrLineData.bind($$), classText = $$.classText.bind($$);
        var mainText = $$.main.selectAll("." + CLASS.texts).selectAll("." + CLASS.text).data(barOrLineData);
        var mainTextEnter = mainText.enter().append("text").attr("class", classText).attr("text-anchor", function(d) {
            return config.axis_rotated ? d.value < 0 ? "end" : "start" : "middle";
        }).style("stroke", "none").attr("x", xForText).attr("y", yForText).style("fill", function(d) {
            return $$.color(d);
        }).style("fill-opacity", 0);
        $$.mainText = mainTextEnter.merge(mainText).text(function(d, i, j) {
            return $$.dataLabelFormat(d.id)(d.value, d.id, i, j);
        });
        mainText.exit().transition().duration(durationForExit).style("fill-opacity", 0).remove();
    };
    ChartInternal.prototype.redrawText = function(xForText, yForText, forFlow, withTransition, transition) {
        return [
            (withTransition ? this.mainText.transition(transition) : this.mainText).attr("x", xForText).attr("y", yForText).style("fill", this.color).style("fill-opacity", forFlow ? 0 : this.opacityForText.bind(this))
        ];
    };
    ChartInternal.prototype.getTextRect = function(text, cls, element) {
        var dummy = this.d3.select("body").append("div").classed("c3", true), svg = dummy.append("svg").style("visibility", "hidden").style("position", "fixed").style("top", 0).style("left", 0), font = this.d3.select(element).style("font"), rect;
        svg.selectAll(".dummy").data([
            text
        ]).enter().append("text").classed(cls ? cls : "", true).style("font", font).text(text).each(function() {
            rect = getBBox(this);
        });
        dummy.remove();
        return rect;
    };
    ChartInternal.prototype.generateXYForText = function(areaIndices, barIndices, lineIndices, forX) {
        var $$ = this, getAreaPoints = $$.generateGetAreaPoints(areaIndices, false), getBarPoints = $$.generateGetBarPoints(barIndices, false), getLinePoints = $$.generateGetLinePoints(lineIndices, false), getter = forX ? $$.getXForText : $$.getYForText;
        return function(d, i) {
            var getPoints = $$.isAreaType(d) ? getAreaPoints : $$.isBarType(d) ? getBarPoints : getLinePoints;
            return getter.call($$, getPoints(d, i), d, this);
        };
    };
    ChartInternal.prototype.getXForText = function(points, d, textElement) {
        var $$ = this, box = getBBox(textElement), xPos, padding;
        if ($$.config.axis_rotated) {
            padding = $$.isBarType(d) ? 4 : 6;
            xPos = points[2][1] + padding * (d.value < 0 ? -1 : 1);
        } else xPos = $$.hasType("bar") ? (points[2][0] + points[0][0]) / 2 : points[0][0];
        // show labels regardless of the domain if value is null
        if (d.value === null) {
            if (xPos > $$.width) xPos = $$.width - box.width;
            else if (xPos < 0) xPos = 4;
        }
        return xPos;
    };
    ChartInternal.prototype.getYForText = function(points, d, textElement) {
        var $$ = this, box = getBBox(textElement), yPos;
        if ($$.config.axis_rotated) yPos = (points[0][0] + points[2][0] + box.height * 0.6) / 2;
        else {
            yPos = points[2][1];
            if (d.value < 0 || d.value === 0 && !$$.hasPositiveValue) {
                yPos += box.height;
                if ($$.isBarType(d) && $$.isSafari()) yPos -= 3;
                else if (!$$.isBarType(d) && $$.isChrome()) yPos += 3;
            } else yPos += $$.isBarType(d) ? -3 : -6;
        }
        // show labels regardless of the domain if value is null
        if (d.value === null && !$$.config.axis_rotated) {
            if (yPos < box.height) yPos = box.height;
            else if (yPos > this.height) yPos = this.height - 4;
        }
        return yPos;
    };
    ChartInternal.prototype.initTitle = function() {
        var $$ = this;
        $$.title = $$.svg.append("text").text($$.config.title_text).attr("class", $$.CLASS.title);
    };
    ChartInternal.prototype.redrawTitle = function() {
        var $$ = this;
        $$.title.attr("x", $$.xForTitle.bind($$)).attr("y", $$.yForTitle.bind($$));
    };
    ChartInternal.prototype.xForTitle = function() {
        var $$ = this, config = $$.config, position = config.title_position || "left", x;
        if (position.indexOf("right") >= 0) x = $$.currentWidth - $$.getTextRect($$.title.node().textContent, $$.CLASS.title, $$.title.node()).width - config.title_padding.right;
        else if (position.indexOf("center") >= 0) x = Math.max(($$.currentWidth - $$.getTextRect($$.title.node().textContent, $$.CLASS.title, $$.title.node()).width) / 2, 0);
        else // left
        x = config.title_padding.left;
        return x;
    };
    ChartInternal.prototype.yForTitle = function() {
        var $$ = this;
        return $$.config.title_padding.top + $$.getTextRect($$.title.node().textContent, $$.CLASS.title, $$.title.node()).height;
    };
    ChartInternal.prototype.getTitlePadding = function() {
        var $$ = this;
        return $$.yForTitle() + $$.config.title_padding.bottom;
    };
    function powerOfTen(d) {
        return d / Math.pow(10, Math.ceil(Math.log(d) / Math.LN10 - 1e-12)) === 1;
    }
    ChartInternal.prototype.drawColorScale = function() {
        var $$ = this, d3 = $$.d3, config = $$.config, target = $$.data.targets[0], barWidth, barHeight, axis, points, legendAxis, axisScale, inverseScale, height;
        barWidth = !isNaN(config.stanford_scaleWidth) ? config.stanford_scaleWidth : 20;
        barHeight = 5;
        if (barHeight < 0 || barWidth < 0) throw Error("Colorscale's barheight and barwidth must be greater than 0.");
        height = $$.height - config.stanford_padding.bottom - config.stanford_padding.top;
        points = d3.range(config.stanford_padding.bottom, height, barHeight);
        inverseScale = d3.scaleSequential(target.colors).domain([
            points[points.length - 1],
            points[0]
        ]);
        if ($$.colorScale) $$.colorScale.remove();
        $$.colorScale = $$.svg.append("g").attr("width", 50).attr("height", height).attr("class", CLASS.colorScale);
        $$.colorScale.append("g").attr("transform", "translate(0, " + config.stanford_padding.top + ")").selectAll("bars").data(points).enter().append("rect").attr("y", function(d, i) {
            return i * barHeight;
        }).attr("x", 0).attr("width", barWidth).attr("height", barHeight).attr("fill", function(d) {
            return inverseScale(d);
        });
        // Legend Axis
        axisScale = d3.scaleLog().domain([
            target.minEpochs,
            target.maxEpochs
        ]).range([
            points[0] + config.stanford_padding.top + points[points.length - 1] + barHeight - 1,
            points[0] + config.stanford_padding.top
        ]);
        legendAxis = d3.axisRight(axisScale);
        if (config.stanford_scaleFormat === "pow10") legendAxis.tickValues([
            1,
            10,
            100,
            1000,
            10000,
            100000,
            1000000,
            10000000
        ]);
        else if (isFunction(config.stanford_scaleFormat)) legendAxis.tickFormat(config.stanford_scaleFormat);
        else legendAxis.tickFormat(d3.format("d"));
        if (isFunction(config.stanford_scaleValues)) legendAxis.tickValues(config.stanford_scaleValues(target.minEpochs, target.maxEpochs));
        // Draw Axis
        axis = $$.colorScale.append("g").attr("class", "legend axis").attr("transform", "translate(" + barWidth + ",0)").call(legendAxis);
        if (config.stanford_scaleFormat === "pow10") axis.selectAll(".tick text").text(null).filter(powerOfTen).text(10).append("tspan").attr("dy", "-.7em") // https://bl.ocks.org/mbostock/6738229
        .text(function(d) {
            return Math.round(Math.log(d) / Math.LN10);
        });
        $$.colorScale.attr("transform", "translate(" + ($$.currentWidth - $$.xForColorScale()) + ", 0)");
    };
    ChartInternal.prototype.xForColorScale = function() {
        var $$ = this;
        return $$.config.stanford_padding.right + getBBox($$.colorScale.node()).width;
    };
    ChartInternal.prototype.getColorScalePadding = function() {
        var $$ = this;
        return $$.xForColorScale() + $$.config.stanford_padding.left + 20;
    };
    ChartInternal.prototype.isStanfordGraphType = function() {
        var $$ = this;
        return $$.config.data_type === "stanford";
    };
    ChartInternal.prototype.initStanfordData = function() {
        var $$ = this, d3 = $$.d3, config = $$.config, target = $$.data.targets[0], epochs, maxEpochs, minEpochs;
        // Make larger values appear on top
        target.values.sort(compareEpochs);
        // Get array of epochs
        epochs = target.values.map(function(a) {
            return a.epochs;
        });
        minEpochs = !isNaN(config.stanford_scaleMin) ? config.stanford_scaleMin : d3.min(epochs);
        maxEpochs = !isNaN(config.stanford_scaleMax) ? config.stanford_scaleMax : d3.max(epochs);
        if (minEpochs > maxEpochs) throw Error("Number of minEpochs has to be smaller than maxEpochs");
        target.colors = isFunction(config.stanford_colors) ? config.stanford_colors : d3.interpolateHslLong(d3.hsl(250, 1, 0.5), d3.hsl(0, 1, 0.5));
        target.colorscale = d3.scaleSequentialLog(target.colors).domain([
            minEpochs,
            maxEpochs
        ]);
        target.minEpochs = minEpochs;
        target.maxEpochs = maxEpochs;
    };
    ChartInternal.prototype.getStanfordPointColor = function(d) {
        var $$ = this, target = $$.data.targets[0];
        return target.colorscale(d.epochs);
    };
    // http://jsfiddle.net/Xotic750/KtzLq/
    ChartInternal.prototype.getCentroid = function(points) {
        var area = getRegionArea(points);
        var x = 0, y = 0, i, j, f, point1, point2;
        for(i = 0, j = points.length - 1; i < points.length; j = i, i += 1){
            point1 = points[i];
            point2 = points[j];
            f = point1.x * point2.y - point2.x * point1.y;
            x += (point1.x + point2.x) * f;
            y += (point1.y + point2.y) * f;
        }
        f = area * 6;
        return {
            x: x / f,
            y: y / f
        };
    };
    ChartInternal.prototype.getStanfordTooltipTitle = function(d) {
        var $$ = this, labelX = $$.axis.getLabelText("x"), labelY = $$.axis.getLabelText("y");
        return "\n      <tr><th>" + (labelX ? sanitise(labelX) : "x") + "</th><th class='value'>" + d.x + "</th></tr>\n      <tr><th>" + (labelY ? sanitise(labelY) : "y") + "</th><th class='value'>" + d.value + "</th></tr>\n    ";
    };
    ChartInternal.prototype.countEpochsInRegion = function(region) {
        var $$ = this, target = $$.data.targets[0], total, count;
        total = target.values.reduce(function(accumulator, currentValue) {
            return accumulator + Number(currentValue.epochs);
        }, 0);
        count = target.values.reduce(function(accumulator, currentValue) {
            if (pointInRegion(currentValue, region)) return accumulator + Number(currentValue.epochs);
            return accumulator;
        }, 0);
        return {
            value: count,
            percentage: count !== 0 ? (count / total * 100).toFixed(1) : 0
        };
    };
    var getRegionArea = function(points) {
        // thanks to: https://stackoverflow.com/questions/16282330/find-centerpoint-of-polygon-in-javascript
        var area = 0, i, j, point1, point2;
        for(i = 0, j = points.length - 1; i < points.length; j = i, i += 1){
            point1 = points[i];
            point2 = points[j];
            area += point1.x * point2.y;
            area -= point1.y * point2.x;
        }
        area /= 2;
        return area;
    };
    var pointInRegion = function(point, region) {
        // thanks to: http://bl.ocks.org/bycoffe/5575904
        // ray-casting algorithm based on
        // http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html
        var xi, yi, yj, xj, intersect, x = point.x, y = point.value, inside = false;
        for(var i = 0, j = region.length - 1; i < region.length; j = i++){
            xi = region[i].x;
            yi = region[i].y;
            xj = region[j].x;
            yj = region[j].y;
            intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
            if (intersect) inside = !inside;
        }
        return inside;
    };
    var compareEpochs = function(a, b) {
        if (a.epochs < b.epochs) return -1;
        if (a.epochs > b.epochs) return 1;
        return 0;
    };
    ChartInternal.prototype.initStanfordElements = function() {
        var $$ = this;
        // Avoid blocking eventRect
        $$.stanfordElements = $$.main.select("." + CLASS.chart).append("g").attr("class", CLASS.stanfordElements);
        $$.stanfordElements.append("g").attr("class", CLASS.stanfordLines);
        $$.stanfordElements.append("g").attr("class", CLASS.stanfordTexts);
        $$.stanfordElements.append("g").attr("class", CLASS.stanfordRegions);
    };
    ChartInternal.prototype.updateStanfordElements = function(duration) {
        var $$ = this, main = $$.main, config = $$.config, stanfordLine, stanfordLineEnter, stanfordRegion, stanfordRegionEnter, stanfordText, stanfordTextEnter, xvCustom = $$.xvCustom.bind($$), yvCustom = $$.yvCustom.bind($$), countPointsInRegion = $$.countEpochsInRegion.bind($$);
        // Stanford-Lines
        stanfordLine = main.select("." + CLASS.stanfordLines).style("shape-rendering", "geometricprecision").selectAll("." + CLASS.stanfordLine).data(config.stanford_lines);
        // enter
        stanfordLineEnter = stanfordLine.enter().append("g").attr("class", function(d) {
            return CLASS.stanfordLine + (d["class"] ? " " + d["class"] : "");
        });
        stanfordLineEnter.append("line").attr("x1", function(d) {
            return config.axis_rotated ? yvCustom(d, "value_y1") : xvCustom(d, "value_x1");
        }).attr("x2", function(d) {
            return config.axis_rotated ? yvCustom(d, "value_y2") : xvCustom(d, "value_x2");
        }).attr("y1", function(d) {
            return config.axis_rotated ? xvCustom(d, "value_x1") : yvCustom(d, "value_y1");
        }).attr("y2", function(d) {
            return config.axis_rotated ? xvCustom(d, "value_x2") : yvCustom(d, "value_y2");
        }).style("opacity", 0);
        // update
        $$.stanfordLines = stanfordLineEnter.merge(stanfordLine);
        $$.stanfordLines.select("line").transition().duration(duration).attr("x1", function(d) {
            return config.axis_rotated ? yvCustom(d, "value_y1") : xvCustom(d, "value_x1");
        }).attr("x2", function(d) {
            return config.axis_rotated ? yvCustom(d, "value_y2") : xvCustom(d, "value_x2");
        }).attr("y1", function(d) {
            return config.axis_rotated ? xvCustom(d, "value_x1") : yvCustom(d, "value_y1");
        }).attr("y2", function(d) {
            return config.axis_rotated ? xvCustom(d, "value_x2") : yvCustom(d, "value_y2");
        }).style("opacity", 1);
        // exit
        stanfordLine.exit().transition().duration(duration).style("opacity", 0).remove();
        // Stanford-Text
        stanfordText = main.select("." + CLASS.stanfordTexts).selectAll("." + CLASS.stanfordText).data(config.stanford_texts);
        // enter
        stanfordTextEnter = stanfordText.enter().append("g").attr("class", function(d) {
            return CLASS.stanfordText + (d["class"] ? " " + d["class"] : "");
        });
        stanfordTextEnter.append("text").attr("x", function(d) {
            return config.axis_rotated ? yvCustom(d, "y") : xvCustom(d, "x");
        }).attr("y", function(d) {
            return config.axis_rotated ? xvCustom(d, "x") : yvCustom(d, "y");
        }).style("opacity", 0);
        // update
        $$.stanfordTexts = stanfordTextEnter.merge(stanfordText);
        $$.stanfordTexts.select("text").transition().duration(duration).attr("x", function(d) {
            return config.axis_rotated ? yvCustom(d, "y") : xvCustom(d, "x");
        }).attr("y", function(d) {
            return config.axis_rotated ? xvCustom(d, "x") : yvCustom(d, "y");
        }).text(function(d) {
            return d.content;
        }).style("opacity", 1);
        // exit
        stanfordText.exit().transition().duration(duration).style("opacity", 0).remove();
        // Stanford-Regions
        stanfordRegion = main.select("." + CLASS.stanfordRegions).selectAll("." + CLASS.stanfordRegion).data(config.stanford_regions);
        // enter
        stanfordRegionEnter = stanfordRegion.enter().append("g").attr("class", function(d) {
            return CLASS.stanfordRegion + (d["class"] ? " " + d["class"] : "");
        });
        stanfordRegionEnter.append("polygon").attr("points", function(d) {
            return d.points.map(function(value) {
                return [
                    config.axis_rotated ? yvCustom(value, "y") : xvCustom(value, "x"),
                    config.axis_rotated ? xvCustom(value, "x") : yvCustom(value, "y")
                ].join(",");
            }).join(" ");
        }).style("opacity", 0);
        stanfordRegionEnter.append("text").attr("x", function(d) {
            return $$.getCentroid(d.points).x;
        }).attr("y", function(d) {
            return $$.getCentroid(d.points).y;
        }).style("opacity", 0);
        // update
        $$.stanfordRegions = stanfordRegionEnter.merge(stanfordRegion);
        $$.stanfordRegions.select("polygon").transition().duration(duration).attr("points", function(d) {
            return d.points.map(function(value) {
                return [
                    config.axis_rotated ? yvCustom(value, "y") : xvCustom(value, "x"),
                    config.axis_rotated ? xvCustom(value, "x") : yvCustom(value, "y")
                ].join(",");
            }).join(" ");
        }).style("opacity", function(d) {
            return d.opacity ? d.opacity : 0.2;
        });
        $$.stanfordRegions.select("text").transition().duration(duration).attr("x", function(d) {
            return config.axis_rotated ? yvCustom($$.getCentroid(d.points), "y") : xvCustom($$.getCentroid(d.points), "x");
        }).attr("y", function(d) {
            return config.axis_rotated ? xvCustom($$.getCentroid(d.points), "x") : yvCustom($$.getCentroid(d.points), "y");
        }).text(function(d) {
            if (d.text) {
                var value, percentage, temp;
                if ($$.isStanfordGraphType()) {
                    temp = countPointsInRegion(d.points);
                    value = temp.value;
                    percentage = temp.percentage;
                }
                return d.text(value, percentage);
            }
            return "";
        }).attr("text-anchor", "middle").attr("dominant-baseline", "middle").style("opacity", 1);
        // exit
        stanfordRegion.exit().transition().duration(duration).style("opacity", 0).remove();
    };
    ChartInternal.prototype.initTooltip = function() {
        var $$ = this, config = $$.config, i;
        $$.tooltip = $$.selectChart.style("position", "relative").append("div").attr("class", CLASS.tooltipContainer).style("position", "absolute").style("pointer-events", "none").style("display", "none");
        // Show tooltip if needed
        if (config.tooltip_init_show) {
            if ($$.isTimeSeries() && isString(config.tooltip_init_x)) {
                config.tooltip_init_x = $$.parseDate(config.tooltip_init_x);
                for(i = 0; i < $$.data.targets[0].values.length; i++){
                    if ($$.data.targets[0].values[i].x - config.tooltip_init_x === 0) break;
                }
                config.tooltip_init_x = i;
            }
            $$.tooltip.html(config.tooltip_contents.call($$, $$.data.targets.map(function(d) {
                return $$.addName(d.values[config.tooltip_init_x]);
            }), $$.axis.getXAxisTickFormat(), $$.getYFormat($$.hasArcType()), $$.color));
            $$.tooltip.style("top", config.tooltip_init_position.top).style("left", config.tooltip_init_position.left).style("display", "block");
        }
    };
    ChartInternal.prototype.getTooltipSortFunction = function() {
        var $$ = this, config = $$.config;
        if (config.data_groups.length === 0 || config.tooltip_order !== undefined) {
            // if data are not grouped or if an order is specified
            // for the tooltip values we sort them by their values
            var order = config.tooltip_order;
            if (order === undefined) order = config.data_order;
            var valueOf = function(obj) {
                return obj ? obj.value : null;
            };
            // if data are not grouped, we sort them by their value
            if (isString(order) && order.toLowerCase() === "asc") return function(a, b) {
                return valueOf(a) - valueOf(b);
            };
            else if (isString(order) && order.toLowerCase() === "desc") return function(a, b) {
                return valueOf(b) - valueOf(a);
            };
            else if (isFunction(order)) {
                // if the function is from data_order we need
                // to wrap the returned function in order to format
                // the sorted value to the expected format
                var sortFunction = order;
                if (config.tooltip_order === undefined) sortFunction = function(a, b) {
                    return order(a ? {
                        id: a.id,
                        values: [
                            a
                        ]
                    } : null, b ? {
                        id: b.id,
                        values: [
                            b
                        ]
                    } : null);
                };
                return sortFunction;
            } else if (isArray(order)) return function(a, b) {
                return order.indexOf(a.id) - order.indexOf(b.id);
            };
        } else {
            // if data are grouped, we follow the order of grouped targets
            var ids = $$.orderTargets($$.data.targets).map(function(i) {
                return i.id;
            });
            // if it was either asc or desc we need to invert the order
            // returned by orderTargets
            if ($$.isOrderAsc() || $$.isOrderDesc()) ids = ids.reverse();
            return function(a, b) {
                return ids.indexOf(a.id) - ids.indexOf(b.id);
            };
        }
    };
    ChartInternal.prototype.getTooltipContent = function(d, defaultTitleFormat, defaultValueFormat, color) {
        var $$ = this, config = $$.config, titleFormat = config.tooltip_format_title || defaultTitleFormat, nameFormat = config.tooltip_format_name || function(name) {
            return name;
        }, text, i, title, value, name, bgcolor;
        var valueFormat = config.tooltip_format_value;
        if (!valueFormat) valueFormat = $$.isTargetNormalized(d.id) ? function(v, ratio) {
            return (ratio * 100).toFixed(2) + "%";
        } : defaultValueFormat;
        var tooltipSortFunction = this.getTooltipSortFunction();
        if (tooltipSortFunction) d.sort(tooltipSortFunction);
        for(i = 0; i < d.length; i++){
            if (!(d[i] && (d[i].value || d[i].value === 0))) continue;
            if ($$.isStanfordGraphType()) {
                // Custom tooltip for stanford plots
                if (!text) {
                    title = $$.getStanfordTooltipTitle(d[i]);
                    text = "<table class='" + $$.CLASS.tooltip + "'>" + title;
                }
                bgcolor = $$.getStanfordPointColor(d[i]);
                name = sanitise(config.data_epochs); // Epochs key name
                value = d[i].epochs;
            } else {
                // Regular tooltip
                if (!text) {
                    title = sanitise(titleFormat ? titleFormat(d[i].x, d[i].index) : d[i].x);
                    text = "<table class='" + $$.CLASS.tooltip + "'>" + (title || title === 0 ? "<tr><th colspan='2'>" + title + "</th></tr>" : "");
                }
                value = sanitise(valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index, d));
                if (value !== undefined) {
                    // Skip elements when their name is set to null
                    if (d[i].name === null) continue;
                    name = sanitise(nameFormat(d[i].name, d[i].ratio, d[i].id, d[i].index));
                    bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : color(d[i].id);
                }
            }
            if (value !== undefined) {
                text += "<tr class='" + $$.CLASS.tooltipName + "-" + $$.getTargetSelectorSuffix(d[i].id) + "'>";
                text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + name + "</td>";
                text += "<td class='value'>" + value + "</td>";
                text += "</tr>";
            }
        }
        return text + "</table>";
    };
    ChartInternal.prototype.tooltipPosition = function(dataToShow, tWidth, tHeight, element) {
        var $$ = this, config = $$.config, d3 = $$.d3;
        var svgLeft, tooltipLeft, tooltipRight, tooltipTop, chartRight;
        var forArc = $$.hasArcType(), mouse = d3.mouse(element);
        // Determin tooltip position
        if (forArc) {
            tooltipLeft = ($$.width - ($$.isLegendRight ? $$.getLegendWidth() : 0)) / 2 + mouse[0];
            tooltipTop = ($$.hasType("gauge") ? $$.height : $$.height / 2) + mouse[1] + 20;
        } else {
            svgLeft = $$.getSvgLeft(true);
            if (config.axis_rotated) {
                tooltipLeft = svgLeft + mouse[0] + 100;
                tooltipRight = tooltipLeft + tWidth;
                chartRight = $$.currentWidth - $$.getCurrentPaddingRight();
                tooltipTop = $$.x(dataToShow[0].x) + 20;
            } else {
                tooltipLeft = svgLeft + $$.getCurrentPaddingLeft(true) + $$.x(dataToShow[0].x) + 20;
                tooltipRight = tooltipLeft + tWidth;
                chartRight = svgLeft + $$.currentWidth - $$.getCurrentPaddingRight();
                tooltipTop = mouse[1] + 15;
            }
            if (tooltipRight > chartRight) // 20 is needed for Firefox to keep tooltip width
            tooltipLeft -= tooltipRight - chartRight + 20;
            if (tooltipTop + tHeight > $$.currentHeight) tooltipTop -= tHeight + 30;
        }
        if (tooltipTop < 0) tooltipTop = 0;
        return {
            top: tooltipTop,
            left: tooltipLeft
        };
    };
    ChartInternal.prototype.showTooltip = function(selectedData, element) {
        var $$ = this, config = $$.config;
        var tWidth, tHeight, position;
        var forArc = $$.hasArcType(), dataToShow = selectedData.filter(function(d) {
            return d && isValue(d.value);
        }), positionFunction = config.tooltip_position || ChartInternal.prototype.tooltipPosition;
        if (dataToShow.length === 0 || !config.tooltip_show) {
            $$.hideTooltip();
            return;
        }
        $$.tooltip.html(config.tooltip_contents.call($$, selectedData, $$.axis.getXAxisTickFormat(), $$.getYFormat(forArc), $$.color)).style("display", "block");
        // Get tooltip dimensions
        tWidth = $$.tooltip.property("offsetWidth");
        tHeight = $$.tooltip.property("offsetHeight");
        position = positionFunction.call(this, dataToShow, tWidth, tHeight, element);
        // Set tooltip
        $$.tooltip.style("top", position.top + "px").style("left", position.left + "px");
    };
    ChartInternal.prototype.hideTooltip = function() {
        this.tooltip.style("display", "none");
    };
    ChartInternal.prototype.setTargetType = function(targetIds, type) {
        var $$ = this, config = $$.config;
        $$.mapToTargetIds(targetIds).forEach(function(id) {
            $$.withoutFadeIn[id] = type === config.data_types[id];
            config.data_types[id] = type;
        });
        if (!targetIds) config.data_type = type;
    };
    ChartInternal.prototype.hasType = function(type, targets) {
        var $$ = this, types = $$.config.data_types, has = false;
        targets = targets || $$.data.targets;
        if (targets && targets.length) targets.forEach(function(target) {
            var t = types[target.id];
            if (t && t.indexOf(type) >= 0 || !t && type === "line") has = true;
        });
        else if (Object.keys(types).length) Object.keys(types).forEach(function(id) {
            if (types[id] === type) has = true;
        });
        else has = $$.config.data_type === type;
        return has;
    };
    ChartInternal.prototype.hasArcType = function(targets) {
        return this.hasType("pie", targets) || this.hasType("donut", targets) || this.hasType("gauge", targets);
    };
    ChartInternal.prototype.isLineType = function(d) {
        var config = this.config, id = isString(d) ? d : d.id;
        return !config.data_types[id] || [
            "line",
            "spline",
            "area",
            "area-spline",
            "step",
            "area-step"
        ].indexOf(config.data_types[id]) >= 0;
    };
    ChartInternal.prototype.isStepType = function(d) {
        var id = isString(d) ? d : d.id;
        return [
            "step",
            "area-step"
        ].indexOf(this.config.data_types[id]) >= 0;
    };
    ChartInternal.prototype.isSplineType = function(d) {
        var id = isString(d) ? d : d.id;
        return [
            "spline",
            "area-spline"
        ].indexOf(this.config.data_types[id]) >= 0;
    };
    ChartInternal.prototype.isAreaType = function(d) {
        var id = isString(d) ? d : d.id;
        return [
            "area",
            "area-spline",
            "area-step"
        ].indexOf(this.config.data_types[id]) >= 0;
    };
    ChartInternal.prototype.isBarType = function(d) {
        var id = isString(d) ? d : d.id;
        return this.config.data_types[id] === "bar";
    };
    ChartInternal.prototype.isScatterType = function(d) {
        var id = isString(d) ? d : d.id;
        return this.config.data_types[id] === "scatter";
    };
    ChartInternal.prototype.isStanfordType = function(d) {
        var id = isString(d) ? d : d.id;
        return this.config.data_types[id] === "stanford";
    };
    ChartInternal.prototype.isPieType = function(d) {
        var id = isString(d) ? d : d.id;
        return this.config.data_types[id] === "pie";
    };
    ChartInternal.prototype.isGaugeType = function(d) {
        var id = isString(d) ? d : d.id;
        return this.config.data_types[id] === "gauge";
    };
    ChartInternal.prototype.isDonutType = function(d) {
        var id = isString(d) ? d : d.id;
        return this.config.data_types[id] === "donut";
    };
    ChartInternal.prototype.isArcType = function(d) {
        return this.isPieType(d) || this.isDonutType(d) || this.isGaugeType(d);
    };
    ChartInternal.prototype.lineData = function(d) {
        return this.isLineType(d) ? [
            d
        ] : [];
    };
    ChartInternal.prototype.arcData = function(d) {
        return this.isArcType(d.data) ? [
            d
        ] : [];
    };
    /* not used
   function scatterData(d) {
   return isScatterType(d) ? d.values : [];
   }
   */ ChartInternal.prototype.barData = function(d) {
        return this.isBarType(d) ? d.values : [];
    };
    ChartInternal.prototype.lineOrScatterOrStanfordData = function(d) {
        return this.isLineType(d) || this.isScatterType(d) || this.isStanfordType(d) ? d.values : [];
    };
    ChartInternal.prototype.barOrLineData = function(d) {
        return this.isBarType(d) || this.isLineType(d) ? d.values : [];
    };
    ChartInternal.prototype.isSafari = function() {
        var ua = window.navigator.userAgent;
        return ua.indexOf("Safari") >= 0 && ua.indexOf("Chrome") < 0;
    };
    ChartInternal.prototype.isChrome = function() {
        var ua = window.navigator.userAgent;
        return ua.indexOf("Chrome") >= 0;
    };
    ChartInternal.prototype.initZoom = function() {
        var $$ = this, d3 = $$.d3, config = $$.config, startEvent;
        $$.zoom = d3.zoom().on("start", function() {
            if (config.zoom_type !== "scroll") return;
            var e = d3.event.sourceEvent;
            if (e && e.type === "brush") return;
            startEvent = e;
            config.zoom_onzoomstart.call($$.api, e);
        }).on("zoom", function() {
            if (config.zoom_type !== "scroll") return;
            var e = d3.event.sourceEvent;
            if (e && e.type === "brush") return;
            $$.redrawForZoom();
            config.zoom_onzoom.call($$.api, $$.x.orgDomain());
        }).on("end", function() {
            if (config.zoom_type !== "scroll") return;
            var e = d3.event.sourceEvent;
            if (e && e.type === "brush") return;
            // if click, do nothing. otherwise, click interaction will be canceled.
            if (e && startEvent.clientX === e.clientX && startEvent.clientY === e.clientY) return;
            config.zoom_onzoomend.call($$.api, $$.x.orgDomain());
        });
        $$.zoom.updateDomain = function() {
            if (d3.event && d3.event.transform) {
                if (config.axis_rotated && config.zoom_type === "scroll" && d3.event.sourceEvent.type === "mousemove") // we're moving the mouse in a rotated chart with zoom = "scroll", so we need rescaleY (i.e. vertical)
                $$.x.domain(d3.event.transform.rescaleY($$.subX).domain());
                else $$.x.domain(d3.event.transform.rescaleX($$.subX).domain());
            }
            return this;
        };
        $$.zoom.updateExtent = function() {
            this.scaleExtent([
                1,
                Infinity
            ]).translateExtent([
                [
                    0,
                    0
                ],
                [
                    $$.width,
                    $$.height
                ]
            ]).extent([
                [
                    0,
                    0
                ],
                [
                    $$.width,
                    $$.height
                ]
            ]);
            return this;
        };
        $$.zoom.update = function() {
            return this.updateExtent().updateDomain();
        };
        return $$.zoom.updateExtent();
    };
    ChartInternal.prototype.zoomTransform = function(range) {
        var $$ = this, s = [
            $$.x(range[0]),
            $$.x(range[1])
        ];
        return $$.d3.zoomIdentity.scale($$.width / (s[1] - s[0])).translate(-s[0], 0);
    };
    ChartInternal.prototype.initDragZoom = function() {
        var $$ = this;
        var d3 = $$.d3;
        var config = $$.config;
        var context = $$.context = $$.svg;
        var brushXPos = $$.margin.left + 20.5;
        var brushYPos = $$.margin.top + 0.5;
        if (!(config.zoom_type === "drag" && config.zoom_enabled)) return;
        var getZoomedDomain = function(selection) {
            return selection && selection.map(function(x) {
                return $$.x.invert(x);
            });
        };
        var brush = $$.dragZoomBrush = d3.brushX().on("start", function() {
            $$.api.unzoom();
            $$.svg.select("." + CLASS.dragZoom).classed("disabled", false);
            config.zoom_onzoomstart.call($$.api, d3.event.sourceEvent);
        }).on("brush", function() {
            config.zoom_onzoom.call($$.api, getZoomedDomain(d3.event.selection));
        }).on("end", function() {
            if (d3.event.selection == null) return;
            var zoomedDomain = getZoomedDomain(d3.event.selection);
            if (!config.zoom_disableDefaultBehavior) $$.api.zoom(zoomedDomain);
            $$.svg.select("." + CLASS.dragZoom).classed("disabled", true);
            config.zoom_onzoomend.call($$.api, zoomedDomain);
        });
        context.append("g").classed(CLASS.dragZoom, true).attr("clip-path", $$.clipPath).attr("transform", "translate(" + brushXPos + "," + brushYPos + ")").call(brush);
    };
    ChartInternal.prototype.getZoomDomain = function() {
        var $$ = this, config = $$.config, d3 = $$.d3, min = d3.min([
            $$.orgXDomain[0],
            config.zoom_x_min
        ]), max = d3.max([
            $$.orgXDomain[1],
            config.zoom_x_max
        ]);
        return [
            min,
            max
        ];
    };
    ChartInternal.prototype.redrawForZoom = function() {
        var $$ = this, d3 = $$.d3, config = $$.config, zoom = $$.zoom, x = $$.x;
        if (!config.zoom_enabled) return;
        if ($$.filterTargetsToShow($$.data.targets).length === 0) return;
        zoom.update();
        if (config.zoom_disableDefaultBehavior) return;
        if ($$.isCategorized() && x.orgDomain()[0] === $$.orgXDomain[0]) x.domain([
            $$.orgXDomain[0] - 1e-10,
            x.orgDomain()[1]
        ]);
        $$.redraw({
            withTransition: false,
            withY: config.zoom_rescale,
            withSubchart: false,
            withEventRect: false,
            withDimension: false
        });
        if (d3.event.sourceEvent && d3.event.sourceEvent.type === "mousemove") $$.cancelClick = true;
    };
    return c3;
});

});
parcelRegister("8O8mS", function(module, exports) {

$parcel$export(module.exports, "version", function () { return (parcelRequire("bGqjq")).version; });

var $bGqjq = parcelRequire("bGqjq");

var $9f3pr = parcelRequire("9f3pr");

var $jO7hW = parcelRequire("jO7hW");

var $1zYwR = parcelRequire("1zYwR");

var $9zU3n = parcelRequire("9zU3n");

var $9r7nk = parcelRequire("9r7nk");

var $c8wtg = parcelRequire("c8wtg");

var $7Z038 = parcelRequire("7Z038");

var $bLK11 = parcelRequire("bLK11");

var $bDnGX = parcelRequire("bDnGX");

var $2RxIA = parcelRequire("2RxIA");

var $2cX1W = parcelRequire("2cX1W");

var $8cSF4 = parcelRequire("8cSF4");

var $dmw9p = parcelRequire("dmw9p");

var $2fM2C = parcelRequire("2fM2C");

var $jPdWX = parcelRequire("jPdWX");

var $8M7Ca = parcelRequire("8M7Ca");

var $7gg6n = parcelRequire("7gg6n");

var $jCNLX = parcelRequire("jCNLX");

var $6ajpw = parcelRequire("6ajpw");

var $4vgKc = parcelRequire("4vgKc");

var $hEfoB = parcelRequire("hEfoB");

var $8IsGx = parcelRequire("8IsGx");

var $hsmXe = parcelRequire("hsmXe");

var $9SrVX = parcelRequire("9SrVX");

var $i7aSK = parcelRequire("i7aSK");

var $kjQV0 = parcelRequire("kjQV0");

var $iuGXt = parcelRequire("iuGXt");

var $hk1Lf = parcelRequire("hk1Lf");

var $5XltZ = parcelRequire("5XltZ");

var $kjxhJ = parcelRequire("kjxhJ");

var $4PSy0 = parcelRequire("4PSy0");
$parcel$exportWildcard(module.exports, $9f3pr);
$parcel$exportWildcard(module.exports, $jO7hW);
$parcel$exportWildcard(module.exports, $1zYwR);
$parcel$exportWildcard(module.exports, $9zU3n);
$parcel$exportWildcard(module.exports, $9r7nk);
$parcel$exportWildcard(module.exports, $c8wtg);
$parcel$exportWildcard(module.exports, $7Z038);
$parcel$exportWildcard(module.exports, $bLK11);
$parcel$exportWildcard(module.exports, $bDnGX);
$parcel$exportWildcard(module.exports, $2RxIA);
$parcel$exportWildcard(module.exports, $2cX1W);
$parcel$exportWildcard(module.exports, $8cSF4);
$parcel$exportWildcard(module.exports, $dmw9p);
$parcel$exportWildcard(module.exports, $2fM2C);
$parcel$exportWildcard(module.exports, $jPdWX);
$parcel$exportWildcard(module.exports, $8M7Ca);
$parcel$exportWildcard(module.exports, $7gg6n);
$parcel$exportWildcard(module.exports, $jCNLX);
$parcel$exportWildcard(module.exports, $6ajpw);
$parcel$exportWildcard(module.exports, $4vgKc);
$parcel$exportWildcard(module.exports, $hEfoB);
$parcel$exportWildcard(module.exports, $8IsGx);
$parcel$exportWildcard(module.exports, $hsmXe);
$parcel$exportWildcard(module.exports, $9SrVX);
$parcel$exportWildcard(module.exports, $i7aSK);
$parcel$exportWildcard(module.exports, $kjQV0);
$parcel$exportWildcard(module.exports, $iuGXt);
$parcel$exportWildcard(module.exports, $hk1Lf);
$parcel$exportWildcard(module.exports, $5XltZ);
$parcel$exportWildcard(module.exports, $kjxhJ);
$parcel$exportWildcard(module.exports, $4PSy0);

});
parcelRegister("bGqjq", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $8818070c863eb9cb$export$83d89fbfd8236492; });
var $8818070c863eb9cb$export$a8ff84c12d48cfa6 = "d3";
var $8818070c863eb9cb$export$83d89fbfd8236492 = "5.16.0";
var $8818070c863eb9cb$export$6d59db4903f20f7d = "Data-Driven Documents";
var $8818070c863eb9cb$export$eebaaf2b24d91f63 = [
    "dom",
    "visualization",
    "svg",
    "animation",
    "canvas"
];
var $8818070c863eb9cb$export$4cec2234a9c7ce6d = "https://d3js.org";
var $8818070c863eb9cb$export$7ff87ebdb8ccbf20 = "BSD-3-Clause";
var $8818070c863eb9cb$export$571b02044ddb2ab3 = {
    "name": "Mike Bostock",
    "url": "https://bost.ocks.org/mike"
};
var $8818070c863eb9cb$export$f22da7240b7add18 = "dist/d3.node.js";
var $8818070c863eb9cb$export$101358e655b23e68 = "dist/d3.min.js";
var $8818070c863eb9cb$export$a2877c4988dda7ec = "dist/d3.min.js";
var $8818070c863eb9cb$export$130be424786e852f = "index.js";
var $8818070c863eb9cb$export$69a68d0c8baaec49 = {
    "type": "git",
    "url": "https://github.com/d3/d3.git"
};
var $8818070c863eb9cb$export$3a444357c5f65f65 = [
    "dist/**/*.js",
    "index.js"
];
var $8818070c863eb9cb$export$e0fef70db1fd3806 = {
    "pretest": "rimraf dist && mkdir dist && json2module package.json > dist/package.js && rollup -c",
    "test": "tape 'test/**/*-test.js'",
    "prepublishOnly": "yarn test",
    "postpublish": 'git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/dist/d3.js d3.v5.js && cp ../d3/dist/d3.min.js d3.v5.min.js && git add d3.v5.js d3.v5.min.js && git commit -m "d3 ${npm_package_version}" && git push && cd - && cd ../d3-bower && git pull && cp ../d3/LICENSE ../d3/README.md ../d3/dist/d3.js ../d3/dist/d3.min.js . && git add -- LICENSE README.md d3.js d3.min.js && git commit -m "${npm_package_version}" && git tag -am "${npm_package_version}" v${npm_package_version} && git push && git push --tags && cd - && zip -j dist/d3.zip -- LICENSE README.md API.md CHANGES.md dist/d3.js dist/d3.min.js'
};
var $8818070c863eb9cb$export$6dbeb9fdb5a4bbaa = {
    "json2module": "0.0",
    "rimraf": "2",
    "rollup": "1",
    "rollup-plugin-ascii": "0.0",
    "rollup-plugin-node-resolve": "3",
    "rollup-plugin-terser": "5",
    "tape": "4"
};
var $8818070c863eb9cb$export$b74ff737e0e298b5 = {
    "d3-array": "1",
    "d3-axis": "1",
    "d3-brush": "1",
    "d3-chord": "1",
    "d3-collection": "1",
    "d3-color": "1",
    "d3-contour": "1",
    "d3-dispatch": "1",
    "d3-drag": "1",
    "d3-dsv": "1",
    "d3-ease": "1",
    "d3-fetch": "1",
    "d3-force": "1",
    "d3-format": "1",
    "d3-geo": "1",
    "d3-hierarchy": "1",
    "d3-interpolate": "1",
    "d3-path": "1",
    "d3-polygon": "1",
    "d3-quadtree": "1",
    "d3-random": "1",
    "d3-scale": "2",
    "d3-scale-chromatic": "1",
    "d3-selection": "1",
    "d3-shape": "1",
    "d3-time": "1",
    "d3-time-format": "2",
    "d3-timer": "1",
    "d3-transition": "1",
    "d3-voronoi": "1",
    "d3-zoom": "1"
};

});

parcelRegister("9f3pr", function(module, exports) {

$parcel$export(module.exports, "bisect", function () { return (parcelRequire("7naKx")).default; });
$parcel$export(module.exports, "bisectRight", function () { return (parcelRequire("7naKx")).bisectRight; });
$parcel$export(module.exports, "bisectLeft", function () { return (parcelRequire("7naKx")).bisectLeft; });
$parcel$export(module.exports, "ascending", function () { return (parcelRequire("fW9sn")).default; });
$parcel$export(module.exports, "bisector", function () { return (parcelRequire("eIAUO")).default; });
$parcel$export(module.exports, "cross", function () { return (parcelRequire("4BzYh")).default; });
$parcel$export(module.exports, "descending", function () { return (parcelRequire("jJpVA")).default; });
$parcel$export(module.exports, "deviation", function () { return (parcelRequire("64A5S")).default; });
$parcel$export(module.exports, "extent", function () { return (parcelRequire("asOlH")).default; });
$parcel$export(module.exports, "histogram", function () { return (parcelRequire("dLRKs")).default; });
$parcel$export(module.exports, "thresholdFreedmanDiaconis", function () { return (parcelRequire("rfZ3b")).default; });
$parcel$export(module.exports, "thresholdScott", function () { return (parcelRequire("fkP4T")).default; });
$parcel$export(module.exports, "thresholdSturges", function () { return (parcelRequire("8nGdH")).default; });
$parcel$export(module.exports, "max", function () { return (parcelRequire("lgnUZ")).default; });
$parcel$export(module.exports, "mean", function () { return (parcelRequire("6kDzO")).default; });
$parcel$export(module.exports, "median", function () { return (parcelRequire("3nfMt")).default; });
$parcel$export(module.exports, "merge", function () { return (parcelRequire("saVys")).default; });
$parcel$export(module.exports, "min", function () { return (parcelRequire("8UsBb")).default; });
$parcel$export(module.exports, "pairs", function () { return (parcelRequire("1SeF6")).default; });
$parcel$export(module.exports, "permute", function () { return (parcelRequire("iIW09")).default; });
$parcel$export(module.exports, "quantile", function () { return (parcelRequire("ft9xF")).default; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("lwLP6")).default; });
$parcel$export(module.exports, "scan", function () { return (parcelRequire("eFHy2")).default; });
$parcel$export(module.exports, "shuffle", function () { return (parcelRequire("5J5Im")).default; });
$parcel$export(module.exports, "sum", function () { return (parcelRequire("8l964")).default; });
$parcel$export(module.exports, "ticks", function () { return (parcelRequire("jPKO0")).default; });
$parcel$export(module.exports, "tickIncrement", function () { return (parcelRequire("jPKO0")).tickIncrement; });
$parcel$export(module.exports, "tickStep", function () { return (parcelRequire("jPKO0")).tickStep; });
$parcel$export(module.exports, "transpose", function () { return (parcelRequire("etGXl")).default; });
$parcel$export(module.exports, "variance", function () { return (parcelRequire("lTicM")).default; });
$parcel$export(module.exports, "zip", function () { return (parcelRequire("cB035")).default; });

var $7naKx = parcelRequire("7naKx");

var $fW9sn = parcelRequire("fW9sn");

var $eIAUO = parcelRequire("eIAUO");

var $4BzYh = parcelRequire("4BzYh");

var $jJpVA = parcelRequire("jJpVA");

var $64A5S = parcelRequire("64A5S");

var $asOlH = parcelRequire("asOlH");

var $dLRKs = parcelRequire("dLRKs");

var $rfZ3b = parcelRequire("rfZ3b");

var $fkP4T = parcelRequire("fkP4T");

var $8nGdH = parcelRequire("8nGdH");

var $lgnUZ = parcelRequire("lgnUZ");

var $6kDzO = parcelRequire("6kDzO");

var $3nfMt = parcelRequire("3nfMt");

var $saVys = parcelRequire("saVys");

var $8UsBb = parcelRequire("8UsBb");

var $1SeF6 = parcelRequire("1SeF6");

var $iIW09 = parcelRequire("iIW09");

var $ft9xF = parcelRequire("ft9xF");

var $lwLP6 = parcelRequire("lwLP6");

var $eFHy2 = parcelRequire("eFHy2");

var $5J5Im = parcelRequire("5J5Im");

var $8l964 = parcelRequire("8l964");

var $jPKO0 = parcelRequire("jPKO0");

var $etGXl = parcelRequire("etGXl");

var $lTicM = parcelRequire("lTicM");

var $cB035 = parcelRequire("cB035");

});
parcelRegister("7naKx", function(module, exports) {

$parcel$export(module.exports, "bisectRight", function () { return $55e3050441957f85$export$4d945ad3ad5751b0; });
$parcel$export(module.exports, "bisectLeft", function () { return $55e3050441957f85$export$df7d25c84ebd12a5; });
$parcel$export(module.exports, "default", function () { return $55e3050441957f85$export$2e2bcd8739ae039; });

var $fW9sn = parcelRequire("fW9sn");

var $eIAUO = parcelRequire("eIAUO");
var $55e3050441957f85$var$ascendingBisect = (0, $eIAUO.default)((0, $fW9sn.default));
var $55e3050441957f85$export$4d945ad3ad5751b0 = $55e3050441957f85$var$ascendingBisect.right;
var $55e3050441957f85$export$df7d25c84ebd12a5 = $55e3050441957f85$var$ascendingBisect.left;
var $55e3050441957f85$export$2e2bcd8739ae039 = $55e3050441957f85$export$4d945ad3ad5751b0;

});
parcelRegister("fW9sn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9a39bb6f3499963$export$2e2bcd8739ae039; });
function $b9a39bb6f3499963$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("eIAUO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab71cf57ae8c76e8$export$2e2bcd8739ae039; });

var $fW9sn = parcelRequire("fW9sn");
function $ab71cf57ae8c76e8$export$2e2bcd8739ae039(compare) {
    if (compare.length === 1) compare = $ab71cf57ae8c76e8$var$ascendingComparator(compare);
    return {
        left: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        },
        right: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
    };
}
function $ab71cf57ae8c76e8$var$ascendingComparator(f) {
    return function(d, x) {
        return (0, $fW9sn.default)(f(d), x);
    };
}

});


parcelRegister("4BzYh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35a68543c7741894$export$2e2bcd8739ae039; });

var $1SeF6 = parcelRequire("1SeF6");
function $35a68543c7741894$export$2e2bcd8739ae039(values0, values1, reduce) {
    var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
    if (reduce == null) reduce = (0, $1SeF6.pair);
    for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
    return values;
}

});
parcelRegister("1SeF6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15d635208ec5affb$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "pair", function () { return $15d635208ec5affb$export$a04cb3fe8b81dd; });
function $15d635208ec5affb$export$2e2bcd8739ae039(array, f) {
    if (f == null) f = $15d635208ec5affb$export$a04cb3fe8b81dd;
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while(i < n)pairs[i] = f(p, p = array[++i]);
    return pairs;
}
function $15d635208ec5affb$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}

});


parcelRegister("jJpVA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5d655064a12cb62$export$2e2bcd8739ae039; });
function $e5d655064a12cb62$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("64A5S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46bf1d40f74caea9$export$2e2bcd8739ae039; });

var $lTicM = parcelRequire("lTicM");
function $46bf1d40f74caea9$export$2e2bcd8739ae039(array, f) {
    var v = (0, $lTicM.default)(array, f);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("lTicM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fefcdb2c57fda343$export$2e2bcd8739ae039; });

var $fXjxZ = parcelRequire("fXjxZ");
function $fefcdb2c57fda343$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $fXjxZ.default)(values[i]))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    } else {
        while(++i < n)if (!isNaN(value = (0, $fXjxZ.default)(valueof(values[i], i, values)))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    }
    if (m > 1) return sum / (m - 1);
}

});
parcelRegister("fXjxZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9db87649c27653e$export$2e2bcd8739ae039; });
function $b9db87649c27653e$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}

});



parcelRegister("asOlH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01f748914c419b92$export$2e2bcd8739ae039; });
function $01f748914c419b92$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = values[i]) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("dLRKs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0695b6cc0132b65$export$2e2bcd8739ae039; });

var $8AX8D = parcelRequire("8AX8D");

var $7naKx = parcelRequire("7naKx");

var $ctL5D = parcelRequire("ctL5D");

var $asOlH = parcelRequire("asOlH");

var $dKqrv = parcelRequire("dKqrv");

var $lwLP6 = parcelRequire("lwLP6");

var $jPKO0 = parcelRequire("jPKO0");

var $8nGdH = parcelRequire("8nGdH");
function $a0695b6cc0132b65$export$2e2bcd8739ae039() {
    var value = (0, $dKqrv.default), domain = (0, $asOlH.default), threshold = (0, $8nGdH.default);
    function histogram(data) {
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            tz = (0, $jPKO0.tickStep)(x0, x1, tz);
            tz = (0, $lwLP6.default)(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $7naKx.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $ctL5D.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $ctL5D.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $ctL5D.default)((0, $8AX8D.slice).call(_)) : (0, $ctL5D.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("8AX8D", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $641f8f2d4b191fce$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "map", function () { return $641f8f2d4b191fce$export$871de8747c9eaa88; });
var $641f8f2d4b191fce$var$array = Array.prototype;
var $641f8f2d4b191fce$export$58adb3bec8346d0f = $641f8f2d4b191fce$var$array.slice;
var $641f8f2d4b191fce$export$871de8747c9eaa88 = $641f8f2d4b191fce$var$array.map;

});

parcelRegister("ctL5D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $915cb88749ced664$export$2e2bcd8739ae039; });
function $915cb88749ced664$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("dKqrv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0241536c005e6f8$export$2e2bcd8739ae039; });
function $a0241536c005e6f8$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("lwLP6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fac1aedae8692883$export$2e2bcd8739ae039; });
function $fac1aedae8692883$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("jPKO0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e70716585309e68a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "tickIncrement", function () { return $e70716585309e68a$export$bc64d00cc98e7e95; });
$parcel$export(module.exports, "tickStep", function () { return $e70716585309e68a$export$81087d9b915d4ede; });
var $e70716585309e68a$var$e10 = Math.sqrt(50), $e70716585309e68a$var$e5 = Math.sqrt(10), $e70716585309e68a$var$e2 = Math.sqrt(2);
function $e70716585309e68a$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $e70716585309e68a$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while(++i < n)ticks[i] = (start + i) * step;
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while(++i < n)ticks[i] = (start - i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $e70716585309e68a$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $e70716585309e68a$var$e10 ? 10 : error >= $e70716585309e68a$var$e5 ? 5 : error >= $e70716585309e68a$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $e70716585309e68a$var$e10 ? 10 : error >= $e70716585309e68a$var$e5 ? 5 : error >= $e70716585309e68a$var$e2 ? 2 : 1);
}
function $e70716585309e68a$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $e70716585309e68a$var$e10) step1 *= 10;
    else if (error >= $e70716585309e68a$var$e5) step1 *= 5;
    else if (error >= $e70716585309e68a$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});

parcelRegister("8nGdH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61a138bc1392e476$export$2e2bcd8739ae039; });
function $61a138bc1392e476$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}

});


parcelRegister("rfZ3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $051eebc200e9ffbf$export$2e2bcd8739ae039; });

var $8AX8D = parcelRequire("8AX8D");

var $fW9sn = parcelRequire("fW9sn");

var $fXjxZ = parcelRequire("fXjxZ");

var $ft9xF = parcelRequire("ft9xF");
function $051eebc200e9ffbf$export$2e2bcd8739ae039(values, min, max) {
    values = (0, $8AX8D.map).call(values, (0, $fXjxZ.default)).sort((0, $fW9sn.default));
    return Math.ceil((max - min) / (2 * ((0, $ft9xF.default)(values, 0.75) - (0, $ft9xF.default)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}

});
parcelRegister("ft9xF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b430f7453c38083c$export$2e2bcd8739ae039; });

var $fXjxZ = parcelRequire("fXjxZ");
function $b430f7453c38083c$export$2e2bcd8739ae039(values, p, valueof) {
    if (valueof == null) valueof = (0, $fXjxZ.default);
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});


parcelRegister("fkP4T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2a0584c423fe6af$export$2e2bcd8739ae039; });

var $64A5S = parcelRequire("64A5S");
function $b2a0584c423fe6af$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $64A5S.default)(values) * Math.pow(values.length, -1 / 3)));
}

});

parcelRegister("lgnUZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7ada542ab7a0204$export$2e2bcd8739ae039; });
function $f7ada542ab7a0204$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = values[i]) != null && value > max) max = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
        }
    }
    return max;
}

});

parcelRegister("6kDzO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49c34f71c88d6b5e$export$2e2bcd8739ae039; });

var $fXjxZ = parcelRequire("fXjxZ");
function $49c34f71c88d6b5e$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = n, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $fXjxZ.default)(values[i]))) sum += value;
        else --m;
    } else {
        while(++i < n)if (!isNaN(value = (0, $fXjxZ.default)(valueof(values[i], i, values)))) sum += value;
        else --m;
    }
    if (m) return sum / m;
}

});

parcelRegister("3nfMt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $274fc2d52d6925bb$export$2e2bcd8739ae039; });

var $fW9sn = parcelRequire("fW9sn");

var $fXjxZ = parcelRequire("fXjxZ");

var $ft9xF = parcelRequire("ft9xF");
function $274fc2d52d6925bb$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, numbers = [];
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $fXjxZ.default)(values[i]))) numbers.push(value);
    } else {
        while(++i < n)if (!isNaN(value = (0, $fXjxZ.default)(valueof(values[i], i, values)))) numbers.push(value);
    }
    return (0, $ft9xF.default)(numbers.sort((0, $fW9sn.default)), 0.5);
}

});

parcelRegister("saVys", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $054b17931aad56cc$export$2e2bcd8739ae039; });
function $054b17931aad56cc$export$2e2bcd8739ae039(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while(++i < n)j += arrays[i].length;
    merged = new Array(j);
    while(--n >= 0){
        array = arrays[n];
        m = array.length;
        while(--m >= 0)merged[--j] = array[m];
    }
    return merged;
}

});

parcelRegister("8UsBb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67c9bcd37ca278f3$export$2e2bcd8739ae039; });
function $67c9bcd37ca278f3$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = values[i]) != null && min > value) min = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
        }
    }
    return min;
}

});

parcelRegister("iIW09", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da1953ec28f4218a$export$2e2bcd8739ae039; });
function $da1953ec28f4218a$export$2e2bcd8739ae039(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while(i--)permutes[i] = array[indexes[i]];
    return permutes;
}

});

parcelRegister("eFHy2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aae6acbe749675fc$export$2e2bcd8739ae039; });

var $fW9sn = parcelRequire("fW9sn");
function $aae6acbe749675fc$export$2e2bcd8739ae039(values, compare) {
    if (!(n = values.length)) return;
    var n, i = 0, j = 0, xi, xj = values[j];
    if (compare == null) compare = (0, $fW9sn.default);
    while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
    if (compare(xj, xj) === 0) return j;
}

});

parcelRegister("5J5Im", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42b59686596178ac$export$2e2bcd8739ae039; });
function $42b59686596178ac$export$2e2bcd8739ae039(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m + i0];
        array[m + i0] = array[i + i0];
        array[i + i0] = t;
    }
    return array;
}

});

parcelRegister("8l964", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6127575a434c1685$export$2e2bcd8739ae039; });
function $6127575a434c1685$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    } else {
        while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("etGXl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8a51850051f8701$export$2e2bcd8739ae039; });

var $8UsBb = parcelRequire("8UsBb");
function $a8a51850051f8701$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $8UsBb.default)(matrix, $a8a51850051f8701$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $a8a51850051f8701$var$length(d) {
    return d.length;
}

});

parcelRegister("cB035", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92b8fa66372bc5a0$export$2e2bcd8739ae039; });

var $etGXl = parcelRequire("etGXl");
function $92b8fa66372bc5a0$export$2e2bcd8739ae039() {
    return (0, $etGXl.default)(arguments);
}

});


parcelRegister("jO7hW", function(module, exports) {

$parcel$export(module.exports, "axisTop", function () { return (parcelRequire("cI7cu")).axisTop; });
$parcel$export(module.exports, "axisRight", function () { return (parcelRequire("cI7cu")).axisRight; });
$parcel$export(module.exports, "axisBottom", function () { return (parcelRequire("cI7cu")).axisBottom; });
$parcel$export(module.exports, "axisLeft", function () { return (parcelRequire("cI7cu")).axisLeft; });

var $cI7cu = parcelRequire("cI7cu");

});
parcelRegister("cI7cu", function(module, exports) {

$parcel$export(module.exports, "axisTop", function () { return $940f2df33af207c2$export$59b8cfab074bdeb1; });
$parcel$export(module.exports, "axisRight", function () { return $940f2df33af207c2$export$b0d2e24dc4f898f0; });
$parcel$export(module.exports, "axisBottom", function () { return $940f2df33af207c2$export$e5cb22533a15e72e; });
$parcel$export(module.exports, "axisLeft", function () { return $940f2df33af207c2$export$2749afb169a520d2; });

var $dD6an = parcelRequire("dD6an");

var $5cE2h = parcelRequire("5cE2h");
var $940f2df33af207c2$var$top = 1, $940f2df33af207c2$var$right = 2, $940f2df33af207c2$var$bottom = 3, $940f2df33af207c2$var$left = 4, $940f2df33af207c2$var$epsilon = 1e-6;
function $940f2df33af207c2$var$translateX(x) {
    return "translate(" + (x + 0.5) + ",0)";
}
function $940f2df33af207c2$var$translateY(y) {
    return "translate(0," + (y + 0.5) + ")";
}
function $940f2df33af207c2$var$number(scale) {
    return function(d) {
        return +scale(d);
    };
}
function $940f2df33af207c2$var$center(scale) {
    var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
    if (scale.round()) offset = Math.round(offset);
    return function(d) {
        return +scale(d) + offset;
    };
}
function $940f2df33af207c2$var$entering() {
    return !this.__axis;
}
function $940f2df33af207c2$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, k = orient === $940f2df33af207c2$var$top || orient === $940f2df33af207c2$var$left ? -1 : 1, x = orient === $940f2df33af207c2$var$left || orient === $940f2df33af207c2$var$right ? "x" : "y", transform = orient === $940f2df33af207c2$var$top || orient === $940f2df33af207c2$var$bottom ? $940f2df33af207c2$var$translateX : $940f2df33af207c2$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $5cE2h.default) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + 0.5, range1 = +range[range.length - 1] + 0.5, position = (scale.bandwidth ? $940f2df33af207c2$var$center : $940f2df33af207c2$var$number)(scale.copy()), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === $940f2df33af207c2$var$top ? "0em" : orient === $940f2df33af207c2$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $940f2df33af207c2$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $940f2df33af207c2$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform(p && isFinite(p = p(d)) ? p : position(d));
            });
        }
        tickExit.remove();
        path.attr("d", orient === $940f2df33af207c2$var$left || orient == $940f2df33af207c2$var$right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter : "M0.5," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + ",0.5H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d));
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($940f2df33af207c2$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $940f2df33af207c2$var$right ? "start" : orient === $940f2df33af207c2$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = (0, $dD6an.slice).call(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : (0, $dD6an.slice).call(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : (0, $dD6an.slice).call(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    return axis;
}
function $940f2df33af207c2$export$59b8cfab074bdeb1(scale) {
    return $940f2df33af207c2$var$axis($940f2df33af207c2$var$top, scale);
}
function $940f2df33af207c2$export$b0d2e24dc4f898f0(scale) {
    return $940f2df33af207c2$var$axis($940f2df33af207c2$var$right, scale);
}
function $940f2df33af207c2$export$e5cb22533a15e72e(scale) {
    return $940f2df33af207c2$var$axis($940f2df33af207c2$var$bottom, scale);
}
function $940f2df33af207c2$export$2749afb169a520d2(scale) {
    return $940f2df33af207c2$var$axis($940f2df33af207c2$var$left, scale);
}

});
parcelRegister("dD6an", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $028f8b26d8c1d859$export$58adb3bec8346d0f; });
var $028f8b26d8c1d859$export$58adb3bec8346d0f = Array.prototype.slice;

});

parcelRegister("5cE2h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c9d21084e0c1fe3$export$2e2bcd8739ae039; });
function $3c9d21084e0c1fe3$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("1zYwR", function(module, exports) {

$parcel$export(module.exports, "brush", function () { return (parcelRequire("4eEas")).default; });
$parcel$export(module.exports, "brushX", function () { return (parcelRequire("4eEas")).brushX; });
$parcel$export(module.exports, "brushY", function () { return (parcelRequire("4eEas")).brushY; });
$parcel$export(module.exports, "brushSelection", function () { return (parcelRequire("4eEas")).brushSelection; });

var $4eEas = parcelRequire("4eEas");

});
parcelRegister("4eEas", function(module, exports) {

$parcel$export(module.exports, "brushSelection", function () { return $3157a0ab58c42b8a$export$69760394fc76f689; });
$parcel$export(module.exports, "brushX", function () { return $3157a0ab58c42b8a$export$979ace6c88860aa8; });
$parcel$export(module.exports, "brushY", function () { return $3157a0ab58c42b8a$export$468748b530991c54; });
$parcel$export(module.exports, "default", function () { return $3157a0ab58c42b8a$export$2e2bcd8739ae039; });

var $1TJJe = parcelRequire("1TJJe");

var $9DnDL = parcelRequire("9DnDL");

var $f01sj = parcelRequire("f01sj");

var $fvaBb = parcelRequire("fvaBb");
var $5HV9y = parcelRequire("5HV9y");
var $ivpDr = parcelRequire("ivpDr");
var $lTUhy = parcelRequire("lTUhy");
parcelRequire("5XltZ");
var $i0eBU = parcelRequire("i0eBU");

var $arkUr = parcelRequire("arkUr");

var $8L8jw = parcelRequire("8L8jw");

var $91tvW = parcelRequire("91tvW");
var $3157a0ab58c42b8a$var$MODE_DRAG = {
    name: "drag"
}, $3157a0ab58c42b8a$var$MODE_SPACE = {
    name: "space"
}, $3157a0ab58c42b8a$var$MODE_HANDLE = {
    name: "handle"
}, $3157a0ab58c42b8a$var$MODE_CENTER = {
    name: "center"
};
function $3157a0ab58c42b8a$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $3157a0ab58c42b8a$var$number2(e) {
    return [
        $3157a0ab58c42b8a$var$number1(e[0]),
        $3157a0ab58c42b8a$var$number1(e[1])
    ];
}
function $3157a0ab58c42b8a$var$toucher(identifier) {
    return function(target) {
        return (0, $lTUhy.default)(target, (0, $fvaBb.event).touches, identifier);
    };
}
var $3157a0ab58c42b8a$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($3157a0ab58c42b8a$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $3157a0ab58c42b8a$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($3157a0ab58c42b8a$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $3157a0ab58c42b8a$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($3157a0ab58c42b8a$var$type),
    input: function(xy) {
        return xy == null ? null : $3157a0ab58c42b8a$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $3157a0ab58c42b8a$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $3157a0ab58c42b8a$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $3157a0ab58c42b8a$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $3157a0ab58c42b8a$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $3157a0ab58c42b8a$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $3157a0ab58c42b8a$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $3157a0ab58c42b8a$var$defaultFilter() {
    return !(0, $fvaBb.event).ctrlKey && !(0, $fvaBb.event).button;
}
function $3157a0ab58c42b8a$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $3157a0ab58c42b8a$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $3157a0ab58c42b8a$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $3157a0ab58c42b8a$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $3157a0ab58c42b8a$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $3157a0ab58c42b8a$export$979ace6c88860aa8() {
    return $3157a0ab58c42b8a$var$brush($3157a0ab58c42b8a$var$X);
}
function $3157a0ab58c42b8a$export$468748b530991c54() {
    return $3157a0ab58c42b8a$var$brush($3157a0ab58c42b8a$var$Y);
}
function $3157a0ab58c42b8a$export$2e2bcd8739ae039() {
    return $3157a0ab58c42b8a$var$brush($3157a0ab58c42b8a$var$XY);
}
function $3157a0ab58c42b8a$var$brush(dim) {
    var extent = $3157a0ab58c42b8a$var$defaultExtent, filter = $3157a0ab58c42b8a$var$defaultFilter, touchable = $3157a0ab58c42b8a$var$defaultTouchable, keys = true, listeners = (0, $1TJJe.default)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $3157a0ab58c42b8a$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $3157a0ab58c42b8a$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $3157a0ab58c42b8a$var$local(this).extent;
            (0, $ivpDr.default)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $3157a0ab58c42b8a$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $3157a0ab58c42b8a$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $3157a0ab58c42b8a$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection) {
        if (group.selection) group.on("start.brush", function() {
            emitter(this, arguments).beforestart().start();
        }).on("interrupt.brush end.brush", function() {
            emitter(this, arguments).end();
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $f01sj.default)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $i0eBU.default)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
        });
    };
    brush.clear = function(group) {
        brush.move(group, null);
    };
    function redraw() {
        var group = (0, $ivpDr.default)(this), selection = $3157a0ab58c42b8a$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function() {
            if (this.starting) this.starting = false, this.emit("start");
            else this.emit("brush");
            return this;
        },
        brush: function() {
            this.emit("brush");
            return this;
        },
        end: function() {
            if (--this.active === 0) delete this.state.emitter, this.emit("end");
            return this;
        },
        emit: function(type) {
            (0, $fvaBb.customEvent)(new (0, $8L8jw.default)(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [
                type,
                this.that,
                this.args
            ]);
        }
    };
    function started() {
        if (touchending && !(0, $fvaBb.event).touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = (0, $fvaBb.event).target.__data__.type, mode = (keys && (0, $fvaBb.event).metaKey ? type = "overlay" : type) === "selection" ? $3157a0ab58c42b8a$var$MODE_DRAG : keys && (0, $fvaBb.event).altKey ? $3157a0ab58c42b8a$var$MODE_CENTER : $3157a0ab58c42b8a$var$MODE_HANDLE, signX = dim === $3157a0ab58c42b8a$var$Y ? null : $3157a0ab58c42b8a$var$signsX[type], signY = dim === $3157a0ab58c42b8a$var$X ? null : $3157a0ab58c42b8a$var$signsY[type], state = $3157a0ab58c42b8a$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && (0, $fvaBb.event).shiftKey, lockX, lockY, pointer = (0, $fvaBb.event).touches ? $3157a0ab58c42b8a$var$toucher((0, $fvaBb.event).changedTouches[0].identifier) : (0, $5HV9y.default), point0 = pointer(that), point = point0, emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            state.selection = selection = [
                [
                    w0 = dim === $3157a0ab58c42b8a$var$Y ? W : point0[0],
                    n0 = dim === $3157a0ab58c42b8a$var$X ? N : point0[1]
                ],
                [
                    e0 = dim === $3157a0ab58c42b8a$var$Y ? E : w0,
                    s0 = dim === $3157a0ab58c42b8a$var$X ? S : n0
                ]
            ];
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $ivpDr.default)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $3157a0ab58c42b8a$var$cursors[type]);
        if ((0, $fvaBb.event).touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $ivpDr.default)((0, $fvaBb.event).view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $9DnDL.default)((0, $fvaBb.event).view);
        }
        (0, $91tvW.nopropagation)();
        (0, $i0eBU.default)(that);
        redraw.call(that);
        emit.start();
        function moved() {
            var point1 = pointer(that);
            if (shifting && !lockX && !lockY) {
                if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
                else lockX = true;
            }
            point = point1;
            moving = true;
            (0, $91tvW.default)();
            move();
        }
        function move() {
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $3157a0ab58c42b8a$var$MODE_SPACE:
                case $3157a0ab58c42b8a$var$MODE_DRAG:
                    if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $3157a0ab58c42b8a$var$MODE_HANDLE:
                    if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                    else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                    if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                    else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    break;
                case $3157a0ab58c42b8a$var$MODE_CENTER:
                    if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
                    if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $3157a0ab58c42b8a$var$flipX) overlay.attr("cursor", $3157a0ab58c42b8a$var$cursors[type = $3157a0ab58c42b8a$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $3157a0ab58c42b8a$var$flipY) overlay.attr("cursor", $3157a0ab58c42b8a$var$cursors[type = $3157a0ab58c42b8a$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush();
            }
        }
        function ended() {
            (0, $91tvW.nopropagation)();
            if ((0, $fvaBb.event).touches) {
                if ((0, $fvaBb.event).touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $9DnDL.yesdrag)((0, $fvaBb.event).view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $3157a0ab58c42b8a$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($3157a0ab58c42b8a$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end();
        }
        function keydowned() {
            switch((0, $fvaBb.event).keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $3157a0ab58c42b8a$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $3157a0ab58c42b8a$var$MODE_CENTER;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $3157a0ab58c42b8a$var$MODE_HANDLE || mode === $3157a0ab58c42b8a$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $3157a0ab58c42b8a$var$MODE_SPACE;
                        overlay.attr("cursor", $3157a0ab58c42b8a$var$cursors.selection);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $91tvW.default)();
        }
        function keyupped() {
            switch((0, $fvaBb.event).keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move();
                    }
                    break;
                case 18:
                    if (mode === $3157a0ab58c42b8a$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $3157a0ab58c42b8a$var$MODE_HANDLE;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $3157a0ab58c42b8a$var$MODE_SPACE) {
                        if ((0, $fvaBb.event).altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $3157a0ab58c42b8a$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $3157a0ab58c42b8a$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $3157a0ab58c42b8a$var$cursors[type]);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $91tvW.default)();
        }
    }
    function touchmoved() {
        emitter(this, arguments).moved();
    }
    function touchended() {
        emitter(this, arguments).ended();
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $3157a0ab58c42b8a$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $arkUr.default)($3157a0ab58c42b8a$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $arkUr.default)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $arkUr.default)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}

});
parcelRegister("1TJJe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $161e663aadb86456$export$2e2bcd8739ae039; });
var $161e663aadb86456$var$noop = {
    value: function() {}
};
function $161e663aadb86456$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $161e663aadb86456$var$Dispatch(_);
}
function $161e663aadb86456$var$Dispatch(_) {
    this._ = _;
}
function $161e663aadb86456$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$161e663aadb86456$var$Dispatch.prototype = $161e663aadb86456$var$dispatch.prototype = {
    constructor: $161e663aadb86456$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $161e663aadb86456$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $161e663aadb86456$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $161e663aadb86456$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $161e663aadb86456$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $161e663aadb86456$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $161e663aadb86456$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $161e663aadb86456$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $161e663aadb86456$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $161e663aadb86456$export$2e2bcd8739ae039 = $161e663aadb86456$var$dispatch;

});

parcelRegister("9DnDL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $703a18102106c991$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "yesdrag", function () { return $703a18102106c991$export$833237748009e1e1; });

var $ivpDr = parcelRequire("ivpDr");

var $8Jas9 = parcelRequire("8Jas9");
function $703a18102106c991$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $ivpDr.default)(view).on("dragstart.drag", (0, $8Jas9.default), true);
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $8Jas9.default), true);
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $703a18102106c991$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $ivpDr.default)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $8Jas9.default), true);
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

});
parcelRegister("ivpDr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d78f01d7851d977e$export$2e2bcd8739ae039; });

var $89bZp = parcelRequire("89bZp");
function $d78f01d7851d977e$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $89bZp.Selection)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $89bZp.Selection)([
        [
            selector
        ]
    ], (0, $89bZp.root));
}

});
parcelRegister("89bZp", function(module, exports) {

$parcel$export(module.exports, "root", function () { return $5ee876dcfa0147c8$export$e8e78c978b129247; });
$parcel$export(module.exports, "Selection", function () { return $5ee876dcfa0147c8$export$52baac22726c72bf; });
$parcel$export(module.exports, "default", function () { return $5ee876dcfa0147c8$export$2e2bcd8739ae039; });

var $9tDEK = parcelRequire("9tDEK");

var $7PnUQ = parcelRequire("7PnUQ");

var $1uFTc = parcelRequire("1uFTc");

var $lsLqL = parcelRequire("lsLqL");

var $SJEwr = parcelRequire("SJEwr");

var $1X4fC = parcelRequire("1X4fC");

var $iHkYU = parcelRequire("iHkYU");

var $lnxUY = parcelRequire("lnxUY");

var $lkNWJ = parcelRequire("lkNWJ");

var $84tOo = parcelRequire("84tOo");

var $h6CVM = parcelRequire("h6CVM");

var $iQ7qr = parcelRequire("iQ7qr");

var $c5kJy = parcelRequire("c5kJy");

var $1C1B6 = parcelRequire("1C1B6");

var $gQQPI = parcelRequire("gQQPI");

var $9nerg = parcelRequire("9nerg");

var $hWNjT = parcelRequire("hWNjT");

var $itJL7 = parcelRequire("itJL7");

var $ii2sP = parcelRequire("ii2sP");

var $isdGL = parcelRequire("isdGL");

var $9j3WU = parcelRequire("9j3WU");

var $7HvYN = parcelRequire("7HvYN");

var $f0aUB = parcelRequire("f0aUB");

var $jPx07 = parcelRequire("jPx07");

var $39ofr = parcelRequire("39ofr");

var $7M5M8 = parcelRequire("7M5M8");

var $h0luO = parcelRequire("h0luO");

var $62pML = parcelRequire("62pML");

var $2qHqp = parcelRequire("2qHqp");

var $fvaBb = parcelRequire("fvaBb");

var $8aIr1 = parcelRequire("8aIr1");
var $5ee876dcfa0147c8$export$e8e78c978b129247 = [
    null
];
function $5ee876dcfa0147c8$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $5ee876dcfa0147c8$var$selection() {
    return new $5ee876dcfa0147c8$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $5ee876dcfa0147c8$export$e8e78c978b129247);
}
$5ee876dcfa0147c8$export$52baac22726c72bf.prototype = $5ee876dcfa0147c8$var$selection.prototype = {
    constructor: $5ee876dcfa0147c8$export$52baac22726c72bf,
    select: (0, $9tDEK.default),
    selectAll: (0, $7PnUQ.default),
    filter: (0, $1uFTc.default),
    data: (0, $lsLqL.default),
    enter: (0, $SJEwr.default),
    exit: (0, $1X4fC.default),
    join: (0, $iHkYU.default),
    merge: (0, $lnxUY.default),
    order: (0, $lkNWJ.default),
    sort: (0, $84tOo.default),
    call: (0, $h6CVM.default),
    nodes: (0, $iQ7qr.default),
    node: (0, $c5kJy.default),
    size: (0, $1C1B6.default),
    empty: (0, $gQQPI.default),
    each: (0, $9nerg.default),
    attr: (0, $hWNjT.default),
    style: (0, $itJL7.default),
    property: (0, $ii2sP.default),
    classed: (0, $isdGL.default),
    text: (0, $9j3WU.default),
    html: (0, $7HvYN.default),
    raise: (0, $f0aUB.default),
    lower: (0, $jPx07.default),
    append: (0, $39ofr.default),
    insert: (0, $7M5M8.default),
    remove: (0, $h0luO.default),
    clone: (0, $62pML.default),
    datum: (0, $2qHqp.default),
    on: (0, $fvaBb.default),
    dispatch: (0, $8aIr1.default)
};
var $5ee876dcfa0147c8$export$2e2bcd8739ae039 = $5ee876dcfa0147c8$var$selection;

});
parcelRegister("9tDEK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e65955f79079aac$export$2e2bcd8739ae039; });

var $89bZp = parcelRequire("89bZp");

var $jiCaU = parcelRequire("jiCaU");
function $6e65955f79079aac$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $jiCaU.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $89bZp.Selection)(subgroups, this._parents);
}

});
parcelRegister("jiCaU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0cd4f805ce7da13$export$2e2bcd8739ae039; });
function $e0cd4f805ce7da13$var$none() {}
function $e0cd4f805ce7da13$export$2e2bcd8739ae039(selector) {
    return selector == null ? $e0cd4f805ce7da13$var$none : function() {
        return this.querySelector(selector);
    };
}

});


parcelRegister("7PnUQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b2fd909604f10f3$export$2e2bcd8739ae039; });

var $89bZp = parcelRequire("89bZp");

var $5IoPJ = parcelRequire("5IoPJ");
function $5b2fd909604f10f3$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $5IoPJ.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $89bZp.Selection)(subgroups, parents);
}

});
parcelRegister("5IoPJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $429453331e7e2a58$export$2e2bcd8739ae039; });
function $429453331e7e2a58$var$empty() {
    return [];
}
function $429453331e7e2a58$export$2e2bcd8739ae039(selector) {
    return selector == null ? $429453331e7e2a58$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});


parcelRegister("1uFTc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11691620a1b9b6f3$export$2e2bcd8739ae039; });

var $89bZp = parcelRequire("89bZp");

var $918kN = parcelRequire("918kN");
function $11691620a1b9b6f3$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $918kN.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $89bZp.Selection)(subgroups, this._parents);
}

});
parcelRegister("918kN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $690aac15e1c8d9ce$export$2e2bcd8739ae039; });
function $690aac15e1c8d9ce$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}

});


parcelRegister("lsLqL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa01014096277d5b$export$2e2bcd8739ae039; });

var $89bZp = parcelRequire("89bZp");

var $SJEwr = parcelRequire("SJEwr");

var $lSS6p = parcelRequire("lSS6p");
var $fa01014096277d5b$var$keyPrefix = "$"; // Protect against keys like “__proto__”.
function $fa01014096277d5b$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $SJEwr.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $fa01014096277d5b$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = {}, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = $fa01014096277d5b$var$keyPrefix + key.call(node, node.__data__, i, group);
        if (keyValue in nodeByKeyValue) exit[i] = node;
        else nodeByKeyValue[keyValue] = node;
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = $fa01014096277d5b$var$keyPrefix + key.call(parent, data[i], i, data);
        if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
        } else enter[i] = new (0, $SJEwr.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) exit[i] = node;
}
function $fa01014096277d5b$export$2e2bcd8739ae039(value, key) {
    if (!value) {
        data = new Array(this.size()), j = -1;
        this.each(function(d) {
            data[++j] = d;
        });
        return data;
    }
    var bind = key ? $fa01014096277d5b$var$bindKey : $fa01014096277d5b$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $lSS6p.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = value.call(parent, parent && parent.__data__, j, parents), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $89bZp.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}

});
parcelRegister("SJEwr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a4874e9bcdc1edd$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "EnterNode", function () { return $0a4874e9bcdc1edd$export$67b01759a14cf6a4; });

var $bXA7m = parcelRequire("bXA7m");

var $89bZp = parcelRequire("89bZp");
function $0a4874e9bcdc1edd$export$2e2bcd8739ae039() {
    return new (0, $89bZp.Selection)(this._enter || this._groups.map((0, $bXA7m.default)), this._parents);
}
function $0a4874e9bcdc1edd$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$0a4874e9bcdc1edd$export$67b01759a14cf6a4.prototype = {
    constructor: $0a4874e9bcdc1edd$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

});
parcelRegister("bXA7m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b5138a21307fc18$export$2e2bcd8739ae039; });
function $8b5138a21307fc18$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});


parcelRegister("lSS6p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fee89bb46913e9f2$export$2e2bcd8739ae039; });
function $fee89bb46913e9f2$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("1X4fC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16be99442c0246d0$export$2e2bcd8739ae039; });

var $bXA7m = parcelRequire("bXA7m");

var $89bZp = parcelRequire("89bZp");
function $16be99442c0246d0$export$2e2bcd8739ae039() {
    return new (0, $89bZp.Selection)(this._exit || this._groups.map((0, $bXA7m.default)), this._parents);
}

});

parcelRegister("iHkYU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9cc84a431584add$export$2e2bcd8739ae039; });
function $d9cc84a431584add$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}

});

parcelRegister("lnxUY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9060e557903e758$export$2e2bcd8739ae039; });

var $89bZp = parcelRequire("89bZp");
function $f9060e557903e758$export$2e2bcd8739ae039(selection) {
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $89bZp.Selection)(merges, this._parents);
}

});

parcelRegister("lkNWJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8823586b00e037d$export$2e2bcd8739ae039; });
function $f8823586b00e037d$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("84tOo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e05d26d7c04223a$export$2e2bcd8739ae039; });

var $89bZp = parcelRequire("89bZp");
function $5e05d26d7c04223a$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $5e05d26d7c04223a$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $89bZp.Selection)(sortgroups, this._parents).order();
}
function $5e05d26d7c04223a$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("h6CVM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7413215d90e2c7d$export$2e2bcd8739ae039; });
function $c7413215d90e2c7d$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("iQ7qr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db72d7def4dc0333$export$2e2bcd8739ae039; });
function $db72d7def4dc0333$export$2e2bcd8739ae039() {
    var nodes = new Array(this.size()), i = -1;
    this.each(function() {
        nodes[++i] = this;
    });
    return nodes;
}

});

parcelRegister("c5kJy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cc608ee6d80c00b$export$2e2bcd8739ae039; });
function $8cc608ee6d80c00b$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("1C1B6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12ca944a7a79ad63$export$2e2bcd8739ae039; });
function $12ca944a7a79ad63$export$2e2bcd8739ae039() {
    var size = 0;
    this.each(function() {
        ++size;
    });
    return size;
}

});

parcelRegister("gQQPI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c44a7c34daa3e930$export$2e2bcd8739ae039; });
function $c44a7c34daa3e930$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("9nerg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d31764592e39758$export$2e2bcd8739ae039; });
function $6d31764592e39758$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("hWNjT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d10e1c52ed08c9bc$export$2e2bcd8739ae039; });

var $hMW9k = parcelRequire("hMW9k");
function $d10e1c52ed08c9bc$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $d10e1c52ed08c9bc$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $d10e1c52ed08c9bc$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $d10e1c52ed08c9bc$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $d10e1c52ed08c9bc$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $d10e1c52ed08c9bc$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $d10e1c52ed08c9bc$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $hMW9k.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $d10e1c52ed08c9bc$var$attrRemoveNS : $d10e1c52ed08c9bc$var$attrRemove : typeof value === "function" ? fullname.local ? $d10e1c52ed08c9bc$var$attrFunctionNS : $d10e1c52ed08c9bc$var$attrFunction : fullname.local ? $d10e1c52ed08c9bc$var$attrConstantNS : $d10e1c52ed08c9bc$var$attrConstant)(fullname, value));
}

});
parcelRegister("hMW9k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf3406a48b514514$export$2e2bcd8739ae039; });

var $cOfvW = parcelRequire("cOfvW");
function $cf3406a48b514514$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $cOfvW.default).hasOwnProperty(prefix) ? {
        space: (0, $cOfvW.default)[prefix],
        local: name
    } : name;
}

});
parcelRegister("cOfvW", function(module, exports) {

$parcel$export(module.exports, "xhtml", function () { return $95363054c30c8afd$export$201a3f7520ccc326; });
$parcel$export(module.exports, "default", function () { return $95363054c30c8afd$export$2e2bcd8739ae039; });
var $95363054c30c8afd$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $95363054c30c8afd$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $95363054c30c8afd$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

});



parcelRegister("itJL7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d73e6e38f360be26$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "styleValue", function () { return $d73e6e38f360be26$export$5e3cec964f0b5efd; });

var $kjaK1 = parcelRequire("kjaK1");
function $d73e6e38f360be26$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $d73e6e38f360be26$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $d73e6e38f360be26$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $d73e6e38f360be26$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $d73e6e38f360be26$var$styleRemove : typeof value === "function" ? $d73e6e38f360be26$var$styleFunction : $d73e6e38f360be26$var$styleConstant)(name, value, priority == null ? "" : priority)) : $d73e6e38f360be26$export$5e3cec964f0b5efd(this.node(), name);
}
function $d73e6e38f360be26$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $kjaK1.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

});
parcelRegister("kjaK1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03d0bd94a0abcfc0$export$2e2bcd8739ae039; });
function $03d0bd94a0abcfc0$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});


parcelRegister("ii2sP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d50bd1b80c636f84$export$2e2bcd8739ae039; });
function $d50bd1b80c636f84$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $d50bd1b80c636f84$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $d50bd1b80c636f84$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $d50bd1b80c636f84$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $d50bd1b80c636f84$var$propertyRemove : typeof value === "function" ? $d50bd1b80c636f84$var$propertyFunction : $d50bd1b80c636f84$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("isdGL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6f575d6de457295$export$2e2bcd8739ae039; });
function $d6f575d6de457295$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $d6f575d6de457295$var$classList(node) {
    return node.classList || new $d6f575d6de457295$var$ClassList(node);
}
function $d6f575d6de457295$var$ClassList(node) {
    this._node = node;
    this._names = $d6f575d6de457295$var$classArray(node.getAttribute("class") || "");
}
$d6f575d6de457295$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $d6f575d6de457295$var$classedAdd(node, names) {
    var list = $d6f575d6de457295$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $d6f575d6de457295$var$classedRemove(node, names) {
    var list = $d6f575d6de457295$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $d6f575d6de457295$var$classedTrue(names) {
    return function() {
        $d6f575d6de457295$var$classedAdd(this, names);
    };
}
function $d6f575d6de457295$var$classedFalse(names) {
    return function() {
        $d6f575d6de457295$var$classedRemove(this, names);
    };
}
function $d6f575d6de457295$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $d6f575d6de457295$var$classedAdd : $d6f575d6de457295$var$classedRemove)(this, names);
    };
}
function $d6f575d6de457295$export$2e2bcd8739ae039(name, value) {
    var names = $d6f575d6de457295$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $d6f575d6de457295$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $d6f575d6de457295$var$classedFunction : value ? $d6f575d6de457295$var$classedTrue : $d6f575d6de457295$var$classedFalse)(names, value));
}

});

parcelRegister("9j3WU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c68f3a3157dd8aa$export$2e2bcd8739ae039; });
function $6c68f3a3157dd8aa$var$textRemove() {
    this.textContent = "";
}
function $6c68f3a3157dd8aa$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $6c68f3a3157dd8aa$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $6c68f3a3157dd8aa$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $6c68f3a3157dd8aa$var$textRemove : (typeof value === "function" ? $6c68f3a3157dd8aa$var$textFunction : $6c68f3a3157dd8aa$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("7HvYN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59b55b06dd39edcc$export$2e2bcd8739ae039; });
function $59b55b06dd39edcc$var$htmlRemove() {
    this.innerHTML = "";
}
function $59b55b06dd39edcc$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $59b55b06dd39edcc$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $59b55b06dd39edcc$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $59b55b06dd39edcc$var$htmlRemove : (typeof value === "function" ? $59b55b06dd39edcc$var$htmlFunction : $59b55b06dd39edcc$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("f0aUB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aebf51fbd3d9b4e9$export$2e2bcd8739ae039; });
function $aebf51fbd3d9b4e9$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $aebf51fbd3d9b4e9$export$2e2bcd8739ae039() {
    return this.each($aebf51fbd3d9b4e9$var$raise);
}

});

parcelRegister("jPx07", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6fc61098a1a916c$export$2e2bcd8739ae039; });
function $e6fc61098a1a916c$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $e6fc61098a1a916c$export$2e2bcd8739ae039() {
    return this.each($e6fc61098a1a916c$var$lower);
}

});

parcelRegister("39ofr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24b505892b9f1144$export$2e2bcd8739ae039; });

var $7B5E9 = parcelRequire("7B5E9");
function $24b505892b9f1144$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $7B5E9.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});
parcelRegister("7B5E9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58805e6cd6dec954$export$2e2bcd8739ae039; });

var $hMW9k = parcelRequire("hMW9k");

var $cOfvW = parcelRequire("cOfvW");
function $58805e6cd6dec954$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $cOfvW.xhtml) && document.documentElement.namespaceURI === (0, $cOfvW.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $58805e6cd6dec954$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $58805e6cd6dec954$export$2e2bcd8739ae039(name) {
    var fullname = (0, $hMW9k.default)(name);
    return (fullname.local ? $58805e6cd6dec954$var$creatorFixed : $58805e6cd6dec954$var$creatorInherit)(fullname);
}

});


parcelRegister("7M5M8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a917efbfd15f37d$export$2e2bcd8739ae039; });

var $7B5E9 = parcelRequire("7B5E9");

var $jiCaU = parcelRequire("jiCaU");
function $5a917efbfd15f37d$var$constantNull() {
    return null;
}
function $5a917efbfd15f37d$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $7B5E9.default)(name), select = before == null ? $5a917efbfd15f37d$var$constantNull : typeof before === "function" ? before : (0, $jiCaU.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("h0luO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6131c6be792e7b3$export$2e2bcd8739ae039; });
function $c6131c6be792e7b3$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $c6131c6be792e7b3$export$2e2bcd8739ae039() {
    return this.each($c6131c6be792e7b3$var$remove);
}

});

parcelRegister("62pML", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4656ee6e509af2ff$export$2e2bcd8739ae039; });
function $4656ee6e509af2ff$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $4656ee6e509af2ff$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $4656ee6e509af2ff$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $4656ee6e509af2ff$var$selection_cloneDeep : $4656ee6e509af2ff$var$selection_cloneShallow);
}

});

parcelRegister("2qHqp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c4fb1c2bf63fbd9$export$2e2bcd8739ae039; });
function $1c4fb1c2bf63fbd9$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("fvaBb", function(module, exports) {

$parcel$export(module.exports, "event", function () { return $b491f8f830be3d4e$export$6cd530ed55e06764; });
$parcel$export(module.exports, "default", function () { return $b491f8f830be3d4e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "customEvent", function () { return $b491f8f830be3d4e$export$4c724631b4750aef; });
var $b491f8f830be3d4e$var$filterEvents = {};
var $b491f8f830be3d4e$export$6cd530ed55e06764 = null;
if (typeof document !== "undefined") {
    var $b491f8f830be3d4e$var$element = document.documentElement;
    if (!("onmouseenter" in $b491f8f830be3d4e$var$element)) $b491f8f830be3d4e$var$filterEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
}
function $b491f8f830be3d4e$var$filterContextListener(listener, index, group) {
    listener = $b491f8f830be3d4e$var$contextListener(listener, index, group);
    return function(event) {
        var related = event.relatedTarget;
        if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) listener.call(this, event);
    };
}
function $b491f8f830be3d4e$var$contextListener(listener, index, group) {
    return function(event1) {
        var event0 = $b491f8f830be3d4e$export$6cd530ed55e06764; // Events can be reentrant (e.g., focus).
        $b491f8f830be3d4e$export$6cd530ed55e06764 = event1;
        try {
            listener.call(this, this.__data__, index, group);
        } finally{
            $b491f8f830be3d4e$export$6cd530ed55e06764 = event0;
        }
    };
}
function $b491f8f830be3d4e$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $b491f8f830be3d4e$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.capture);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $b491f8f830be3d4e$var$onAdd(typename, value, capture) {
    var wrap = $b491f8f830be3d4e$var$filterEvents.hasOwnProperty(typename.type) ? $b491f8f830be3d4e$var$filterContextListener : $b491f8f830be3d4e$var$contextListener;
    return function(d, i, group) {
        var on = this.__on, o, listener = wrap(value, i, group);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, capture);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $b491f8f830be3d4e$export$2e2bcd8739ae039(typename, value, capture) {
    var typenames = $b491f8f830be3d4e$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $b491f8f830be3d4e$var$onAdd : $b491f8f830be3d4e$var$onRemove;
    if (capture == null) capture = false;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, capture));
    return this;
}
function $b491f8f830be3d4e$export$4c724631b4750aef(event1, listener, that, args) {
    var event0 = $b491f8f830be3d4e$export$6cd530ed55e06764;
    event1.sourceEvent = $b491f8f830be3d4e$export$6cd530ed55e06764;
    $b491f8f830be3d4e$export$6cd530ed55e06764 = event1;
    try {
        return listener.apply(that, args);
    } finally{
        $b491f8f830be3d4e$export$6cd530ed55e06764 = event0;
    }
}

});

parcelRegister("8aIr1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f31b9c0c74e9455$export$2e2bcd8739ae039; });

var $kjaK1 = parcelRequire("kjaK1");
function $5f31b9c0c74e9455$var$dispatchEvent(node, type, params) {
    var window = (0, $kjaK1.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $5f31b9c0c74e9455$var$dispatchConstant(type, params) {
    return function() {
        return $5f31b9c0c74e9455$var$dispatchEvent(this, type, params);
    };
}
function $5f31b9c0c74e9455$var$dispatchFunction(type, params) {
    return function() {
        return $5f31b9c0c74e9455$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $5f31b9c0c74e9455$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $5f31b9c0c74e9455$var$dispatchFunction : $5f31b9c0c74e9455$var$dispatchConstant)(type, params));
}

});



parcelRegister("8Jas9", function(module, exports) {

$parcel$export(module.exports, "nopropagation", function () { return $65aaa2799349a29f$export$2e2561858db9bf47; });
$parcel$export(module.exports, "default", function () { return $65aaa2799349a29f$export$2e2bcd8739ae039; });

var $fvaBb = parcelRequire("fvaBb");
function $65aaa2799349a29f$export$2e2561858db9bf47() {
    (0, $fvaBb.event).stopImmediatePropagation();
}
function $65aaa2799349a29f$export$2e2bcd8739ae039() {
    (0, $fvaBb.event).preventDefault();
    (0, $fvaBb.event).stopImmediatePropagation();
}

});


parcelRegister("f01sj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aeb7fc2c29323e59$export$2e2bcd8739ae039; });

var $1tQWc = parcelRequire("1tQWc");

var $luZYw = parcelRequire("luZYw");

var $gMJO6 = parcelRequire("gMJO6");

var $jHuCs = parcelRequire("jHuCs");

var $iI7Wc = parcelRequire("iI7Wc");

var $9RiCU = parcelRequire("9RiCU");

var $2ESy3 = parcelRequire("2ESy3");

var $k6QO1 = parcelRequire("k6QO1");

var $kZrzr = parcelRequire("kZrzr");
function $aeb7fc2c29323e59$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $k6QO1.default)(b) : (t === "number" ? (0, $iI7Wc.default) : t === "string" ? (c = (0, $1tQWc.default)(b)) ? (b = c, $luZYw.default) : (0, $2ESy3.default) : b instanceof (0, $1tQWc.default) ? (0, $luZYw.default) : b instanceof Date ? (0, $jHuCs.default) : (0, $kZrzr.isNumberArray)(b) ? (0, $kZrzr.default) : Array.isArray(b) ? (0, $gMJO6.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $9RiCU.default) : (0, $iI7Wc.default))(a, b);
}

});
parcelRegister("1tQWc", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $imKCb = parcelRequire("imKCb");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $imKCb.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $imKCb.default)(Rgb, rgb, (0, $imKCb.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $imKCb.default)(Hsl, hsl, (0, $imKCb.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("imKCb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5ee70cd754aa323$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $d5ee70cd754aa323$export$8b58be045bf06082; });
function $d5ee70cd754aa323$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $d5ee70cd754aa323$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("luZYw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa6c794a4958fdf6$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "rgbBasis", function () { return $fa6c794a4958fdf6$export$2c0e28f2e2852d3f; });
$parcel$export(module.exports, "rgbBasisClosed", function () { return $fa6c794a4958fdf6$export$53d5214f625ccd4c; });

var $1tQWc = parcelRequire("1tQWc");

var $jVAt7 = parcelRequire("jVAt7");

var $bicwC = parcelRequire("bicwC");

var $8jllk = parcelRequire("8jllk");
var $fa6c794a4958fdf6$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $8jllk.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $1tQWc.rgb)(start)).r, (end = (0, $1tQWc.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $8jllk.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $fa6c794a4958fdf6$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $1tQWc.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $fa6c794a4958fdf6$export$2c0e28f2e2852d3f = $fa6c794a4958fdf6$var$rgbSpline((0, $jVAt7.default));
var $fa6c794a4958fdf6$export$53d5214f625ccd4c = $fa6c794a4958fdf6$var$rgbSpline((0, $bicwC.default));

});
parcelRegister("jVAt7", function(module, exports) {

$parcel$export(module.exports, "basis", function () { return $e81fa1172944234a$export$4e41033bfeec1a4c; });
$parcel$export(module.exports, "default", function () { return $e81fa1172944234a$export$2e2bcd8739ae039; });
function $e81fa1172944234a$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $e81fa1172944234a$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $e81fa1172944234a$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("bicwC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $838b1762decf7fe9$export$2e2bcd8739ae039; });

var $jVAt7 = parcelRequire("jVAt7");
function $838b1762decf7fe9$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $jVAt7.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("8jllk", function(module, exports) {

$parcel$export(module.exports, "hue", function () { return $60d0a75f48d588f4$export$97d7b0c7ddb78dcf; });
$parcel$export(module.exports, "gamma", function () { return $60d0a75f48d588f4$export$a7ebe8cc6aaf8d37; });
$parcel$export(module.exports, "default", function () { return $60d0a75f48d588f4$export$2e2bcd8739ae039; });

var $k6QO1 = parcelRequire("k6QO1");
function $60d0a75f48d588f4$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $60d0a75f48d588f4$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $60d0a75f48d588f4$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $60d0a75f48d588f4$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $k6QO1.default)(isNaN(a) ? b : a);
}
function $60d0a75f48d588f4$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $60d0a75f48d588f4$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $60d0a75f48d588f4$var$exponential(a, b, y) : (0, $k6QO1.default)(isNaN(a) ? b : a);
    };
}
function $60d0a75f48d588f4$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $60d0a75f48d588f4$var$linear(a, d) : (0, $k6QO1.default)(isNaN(a) ? b : a);
}

});
parcelRegister("k6QO1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea3d5457baf78b6a$export$2e2bcd8739ae039; });
function $ea3d5457baf78b6a$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});



parcelRegister("gMJO6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c384a95c8d1ce37f$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "genericArray", function () { return $c384a95c8d1ce37f$export$15d09067c6a5ee49; });

var $f01sj = parcelRequire("f01sj");

var $kZrzr = parcelRequire("kZrzr");
function $c384a95c8d1ce37f$export$2e2bcd8739ae039(a, b) {
    return ((0, $kZrzr.isNumberArray)(b) ? (0, $kZrzr.default) : $c384a95c8d1ce37f$export$15d09067c6a5ee49)(a, b);
}
function $c384a95c8d1ce37f$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $f01sj.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("kZrzr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f47ee41c426b8632$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isNumberArray", function () { return $f47ee41c426b8632$export$5cd576d1827d40c8; });
function $f47ee41c426b8632$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $f47ee41c426b8632$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("jHuCs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e579c8d711a959eb$export$2e2bcd8739ae039; });
function $e579c8d711a959eb$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("iI7Wc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9f27e55086f64c0$export$2e2bcd8739ae039; });
function $d9f27e55086f64c0$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("9RiCU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72d783271dbdb2d5$export$2e2bcd8739ae039; });

var $f01sj = parcelRequire("f01sj");
function $72d783271dbdb2d5$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $f01sj.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("2ESy3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ef9a1579573abd1$export$2e2bcd8739ae039; });

var $iI7Wc = parcelRequire("iI7Wc");
var $1ef9a1579573abd1$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $1ef9a1579573abd1$var$reB = new RegExp($1ef9a1579573abd1$var$reA.source, "g");
function $1ef9a1579573abd1$var$zero(b) {
    return function() {
        return b;
    };
}
function $1ef9a1579573abd1$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $1ef9a1579573abd1$export$2e2bcd8739ae039(a, b) {
    var bi = $1ef9a1579573abd1$var$reA.lastIndex = $1ef9a1579573abd1$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $1ef9a1579573abd1$var$reA.exec(a)) && (bm = $1ef9a1579573abd1$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $iI7Wc.default)(am, bm)
            });
        }
        bi = $1ef9a1579573abd1$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $1ef9a1579573abd1$var$one(q[0].x) : $1ef9a1579573abd1$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("5HV9y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $427d4d4b1e4cbcca$export$2e2bcd8739ae039; });

var $5Psfu = parcelRequire("5Psfu");

var $ejqBC = parcelRequire("ejqBC");
function $427d4d4b1e4cbcca$export$2e2bcd8739ae039(node) {
    var event = (0, $5Psfu.default)();
    if (event.changedTouches) event = event.changedTouches[0];
    return (0, $ejqBC.default)(node, event);
}

});
parcelRegister("5Psfu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43e7a0c95dcf7975$export$2e2bcd8739ae039; });

var $fvaBb = parcelRequire("fvaBb");
function $43e7a0c95dcf7975$export$2e2bcd8739ae039() {
    var current = (0, $fvaBb.event), source;
    while(source = current.sourceEvent)current = source;
    return current;
}

});

parcelRegister("ejqBC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6b77a5d1193379c$export$2e2bcd8739ae039; });
function $a6b77a5d1193379c$export$2e2bcd8739ae039(node, event) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        point.x = event.clientX, point.y = event.clientY;
        point = point.matrixTransform(node.getScreenCTM().inverse());
        return [
            point.x,
            point.y
        ];
    }
    var rect = node.getBoundingClientRect();
    return [
        event.clientX - rect.left - node.clientLeft,
        event.clientY - rect.top - node.clientTop
    ];
}

});


parcelRegister("lTUhy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff1a6480c83a5092$export$2e2bcd8739ae039; });

var $5Psfu = parcelRequire("5Psfu");

var $ejqBC = parcelRequire("ejqBC");
function $ff1a6480c83a5092$export$2e2bcd8739ae039(node, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = (0, $5Psfu.default)().changedTouches;
    for(var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i){
        if ((touch = touches[i]).identifier === identifier) return (0, $ejqBC.default)(node, touch);
    }
    return null;
}

});

parcelRegister("5XltZ", function(module, exports) {

$parcel$export(module.exports, "transition", function () { return (parcelRequire("fWKoQ")).default; });
$parcel$export(module.exports, "active", function () { return (parcelRequire("6I37d")).default; });
$parcel$export(module.exports, "interrupt", function () { return (parcelRequire("i0eBU")).default; });
parcelRequire("8hzkS");

var $fWKoQ = parcelRequire("fWKoQ");

var $6I37d = parcelRequire("6I37d");

var $i0eBU = parcelRequire("i0eBU");

});
parcelRegister("8hzkS", function(module, exports) {

var $89bZp = parcelRequire("89bZp");

var $h8v6h = parcelRequire("h8v6h");

var $lDKuH = parcelRequire("lDKuH");
(0, $89bZp.default).prototype.interrupt = (0, $h8v6h.default);
(0, $89bZp.default).prototype.transition = (0, $lDKuH.default);

});
parcelRegister("h8v6h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c79b4eea03e189f3$export$2e2bcd8739ae039; });

var $i0eBU = parcelRequire("i0eBU");
function $c79b4eea03e189f3$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $i0eBU.default)(this, name);
    });
}

});
parcelRegister("i0eBU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1b38f63ac288224$export$2e2bcd8739ae039; });

var $50v9q = parcelRequire("50v9q");
function $d1b38f63ac288224$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $50v9q.STARTING) && schedule.state < (0, $50v9q.ENDING);
        schedule.state = (0, $50v9q.ENDED);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}

});
parcelRegister("50v9q", function(module, exports) {

$parcel$export(module.exports, "SCHEDULED", function () { return $3a551dcc03e81635$export$584530fe98d14a84; });
$parcel$export(module.exports, "STARTING", function () { return $3a551dcc03e81635$export$a5d151aee16efd42; });
$parcel$export(module.exports, "ENDING", function () { return $3a551dcc03e81635$export$a2e792214ded83b2; });
$parcel$export(module.exports, "ENDED", function () { return $3a551dcc03e81635$export$9d38167254403955; });
$parcel$export(module.exports, "default", function () { return $3a551dcc03e81635$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "init", function () { return $3a551dcc03e81635$export$2cd8252107eb640b; });
$parcel$export(module.exports, "get", function () { return $3a551dcc03e81635$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "set", function () { return $3a551dcc03e81635$export$adaa4cf7ef1b65be; });

var $1TJJe = parcelRequire("1TJJe");

var $aEq4u = parcelRequire("aEq4u");
var $fxK5h = parcelRequire("fxK5h");
var $3a551dcc03e81635$var$emptyOn = (0, $1TJJe.default)("start", "end", "cancel", "interrupt");
var $3a551dcc03e81635$var$emptyTween = [];
var $3a551dcc03e81635$export$ff39ebd4bb12b718 = 0;
var $3a551dcc03e81635$export$584530fe98d14a84 = 1;
var $3a551dcc03e81635$export$a5d151aee16efd42 = 2;
var $3a551dcc03e81635$export$fb935ab5849a0db9 = 3;
var $3a551dcc03e81635$export$1573e22b087389af = 4;
var $3a551dcc03e81635$export$a2e792214ded83b2 = 5;
var $3a551dcc03e81635$export$9d38167254403955 = 6;
function $3a551dcc03e81635$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $3a551dcc03e81635$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $3a551dcc03e81635$var$emptyOn,
        tween: $3a551dcc03e81635$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $3a551dcc03e81635$export$ff39ebd4bb12b718
    });
}
function $3a551dcc03e81635$export$2cd8252107eb640b(node, id) {
    var schedule = $3a551dcc03e81635$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $3a551dcc03e81635$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $3a551dcc03e81635$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $3a551dcc03e81635$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $3a551dcc03e81635$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $3a551dcc03e81635$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $3a551dcc03e81635$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $fxK5h.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $3a551dcc03e81635$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $3a551dcc03e81635$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $3a551dcc03e81635$export$fb935ab5849a0db9) return (0, $aEq4u.default)(start);
            // Interrupt the active transition, if any.
            if (o.state === $3a551dcc03e81635$export$1573e22b087389af) {
                o.state = $3a551dcc03e81635$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $3a551dcc03e81635$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $aEq4u.default)(function() {
            if (self.state === $3a551dcc03e81635$export$fb935ab5849a0db9) {
                self.state = $3a551dcc03e81635$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $3a551dcc03e81635$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $3a551dcc03e81635$export$a5d151aee16efd42) return; // interrupted
        self.state = $3a551dcc03e81635$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $3a551dcc03e81635$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $3a551dcc03e81635$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $3a551dcc03e81635$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

});
parcelRegister("aEq4u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c11dd1287da4df4$export$2e2bcd8739ae039; });

var $fxK5h = parcelRequire("fxK5h");
function $7c11dd1287da4df4$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $fxK5h.Timer);
    delay = delay == null ? 0 : +delay;
    t.restart(function(elapsed) {
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}

});
parcelRegister("fxK5h", function(module, exports) {

$parcel$export(module.exports, "now", function () { return $b50daf6e64833af1$export$461939dd4422153; });
$parcel$export(module.exports, "Timer", function () { return $b50daf6e64833af1$export$c57e9b2d8b9e4de; });
$parcel$export(module.exports, "timer", function () { return $b50daf6e64833af1$export$9dc4ecf953986f04; });
$parcel$export(module.exports, "timerFlush", function () { return $b50daf6e64833af1$export$d60154c1d7f3990e; });
var $b50daf6e64833af1$var$frame = 0, $b50daf6e64833af1$var$timeout = 0, $b50daf6e64833af1$var$interval = 0, $b50daf6e64833af1$var$pokeDelay = 1000, $b50daf6e64833af1$var$taskHead, $b50daf6e64833af1$var$taskTail, $b50daf6e64833af1$var$clockLast = 0, $b50daf6e64833af1$var$clockNow = 0, $b50daf6e64833af1$var$clockSkew = 0, $b50daf6e64833af1$var$clock = typeof performance === "object" && performance.now ? performance : Date, $b50daf6e64833af1$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $b50daf6e64833af1$export$461939dd4422153() {
    return $b50daf6e64833af1$var$clockNow || ($b50daf6e64833af1$var$setFrame($b50daf6e64833af1$var$clearNow), $b50daf6e64833af1$var$clockNow = $b50daf6e64833af1$var$clock.now() + $b50daf6e64833af1$var$clockSkew);
}
function $b50daf6e64833af1$var$clearNow() {
    $b50daf6e64833af1$var$clockNow = 0;
}
function $b50daf6e64833af1$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$b50daf6e64833af1$export$c57e9b2d8b9e4de.prototype = $b50daf6e64833af1$export$9dc4ecf953986f04.prototype = {
    constructor: $b50daf6e64833af1$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $b50daf6e64833af1$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $b50daf6e64833af1$var$taskTail !== this) {
            if ($b50daf6e64833af1$var$taskTail) $b50daf6e64833af1$var$taskTail._next = this;
            else $b50daf6e64833af1$var$taskHead = this;
            $b50daf6e64833af1$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $b50daf6e64833af1$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $b50daf6e64833af1$var$sleep();
        }
    }
};
function $b50daf6e64833af1$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $b50daf6e64833af1$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $b50daf6e64833af1$export$d60154c1d7f3990e() {
    $b50daf6e64833af1$export$461939dd4422153(); // Get the current time, if not already set.
    ++$b50daf6e64833af1$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $b50daf6e64833af1$var$taskHead, e;
    while(t){
        if ((e = $b50daf6e64833af1$var$clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --$b50daf6e64833af1$var$frame;
}
function $b50daf6e64833af1$var$wake() {
    $b50daf6e64833af1$var$clockNow = ($b50daf6e64833af1$var$clockLast = $b50daf6e64833af1$var$clock.now()) + $b50daf6e64833af1$var$clockSkew;
    $b50daf6e64833af1$var$frame = $b50daf6e64833af1$var$timeout = 0;
    try {
        $b50daf6e64833af1$export$d60154c1d7f3990e();
    } finally{
        $b50daf6e64833af1$var$frame = 0;
        $b50daf6e64833af1$var$nap();
        $b50daf6e64833af1$var$clockNow = 0;
    }
}
function $b50daf6e64833af1$var$poke() {
    var now = $b50daf6e64833af1$var$clock.now(), delay = now - $b50daf6e64833af1$var$clockLast;
    if (delay > $b50daf6e64833af1$var$pokeDelay) $b50daf6e64833af1$var$clockSkew -= delay, $b50daf6e64833af1$var$clockLast = now;
}
function $b50daf6e64833af1$var$nap() {
    var t0, t1 = $b50daf6e64833af1$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $b50daf6e64833af1$var$taskHead = t2;
    }
    $b50daf6e64833af1$var$taskTail = t0;
    $b50daf6e64833af1$var$sleep(time);
}
function $b50daf6e64833af1$var$sleep(time) {
    if ($b50daf6e64833af1$var$frame) return; // Soonest alarm already set, or will be.
    if ($b50daf6e64833af1$var$timeout) $b50daf6e64833af1$var$timeout = clearTimeout($b50daf6e64833af1$var$timeout);
    var delay = time - $b50daf6e64833af1$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $b50daf6e64833af1$var$timeout = setTimeout($b50daf6e64833af1$var$wake, time - $b50daf6e64833af1$var$clock.now() - $b50daf6e64833af1$var$clockSkew);
        if ($b50daf6e64833af1$var$interval) $b50daf6e64833af1$var$interval = clearInterval($b50daf6e64833af1$var$interval);
    } else {
        if (!$b50daf6e64833af1$var$interval) $b50daf6e64833af1$var$clockLast = $b50daf6e64833af1$var$clock.now(), $b50daf6e64833af1$var$interval = setInterval($b50daf6e64833af1$var$poke, $b50daf6e64833af1$var$pokeDelay);
        $b50daf6e64833af1$var$frame = 1, $b50daf6e64833af1$var$setFrame($b50daf6e64833af1$var$wake);
    }
}

});





parcelRegister("lDKuH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc114e40e8ef0ae6$export$2e2bcd8739ae039; });

var $fWKoQ = parcelRequire("fWKoQ");

var $50v9q = parcelRequire("50v9q");

var $btL80 = parcelRequire("btL80");

var $fxK5h = parcelRequire("fxK5h");
var $fc114e40e8ef0ae6$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $btL80.cubicInOut)
};
function $fc114e40e8ef0ae6$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) return $fc114e40e8ef0ae6$var$defaultTiming.time = (0, $fxK5h.now)(), $fc114e40e8ef0ae6$var$defaultTiming;
    }
    return timing;
}
function $fc114e40e8ef0ae6$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $fWKoQ.Transition)) id = name._id, name = name._name;
    else id = (0, $fWKoQ.newId)(), (timing = $fc114e40e8ef0ae6$var$defaultTiming).time = (0, $fxK5h.now)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $50v9q.default)(node, name, id, i, group, timing || $fc114e40e8ef0ae6$var$inherit(node, id));
    }
    return new (0, $fWKoQ.Transition)(groups, this._parents, name, id);
}

});
parcelRegister("fWKoQ", function(module, exports) {

$parcel$export(module.exports, "Transition", function () { return $b9c043d1df5cab70$export$be58926105124dd4; });
$parcel$export(module.exports, "default", function () { return $b9c043d1df5cab70$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "newId", function () { return $b9c043d1df5cab70$export$9ffd10a3fbdc175b; });

var $89bZp = parcelRequire("89bZp");

var $gY5kg = parcelRequire("gY5kg");

var $jjy0J = parcelRequire("jjy0J");

var $jRkMj = parcelRequire("jRkMj");

var $lKasu = parcelRequire("lKasu");

var $149Rz = parcelRequire("149Rz");

var $ditMZ = parcelRequire("ditMZ");

var $9FQnK = parcelRequire("9FQnK");

var $j4CdW = parcelRequire("j4CdW");

var $eDQPE = parcelRequire("eDQPE");

var $2q656 = parcelRequire("2q656");

var $jqOce = parcelRequire("jqOce");

var $blVZy = parcelRequire("blVZy");

var $hE4hP = parcelRequire("hE4hP");

var $jOQ3F = parcelRequire("jOQ3F");

var $53AmB = parcelRequire("53AmB");

var $5BKDD = parcelRequire("5BKDD");

var $2lDQE = parcelRequire("2lDQE");

var $95uLu = parcelRequire("95uLu");

var $1C2ts = parcelRequire("1C2ts");
var $b9c043d1df5cab70$var$id = 0;
function $b9c043d1df5cab70$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $b9c043d1df5cab70$export$2e2bcd8739ae039(name) {
    return (0, $89bZp.default)().transition(name);
}
function $b9c043d1df5cab70$export$9ffd10a3fbdc175b() {
    return ++$b9c043d1df5cab70$var$id;
}
var $b9c043d1df5cab70$var$selection_prototype = (0, $89bZp.default).prototype;
$b9c043d1df5cab70$export$be58926105124dd4.prototype = $b9c043d1df5cab70$export$2e2bcd8739ae039.prototype = {
    constructor: $b9c043d1df5cab70$export$be58926105124dd4,
    select: (0, $2q656.default),
    selectAll: (0, $jqOce.default),
    filter: (0, $ditMZ.default),
    merge: (0, $9FQnK.default),
    selection: (0, $blVZy.default),
    transition: (0, $2lDQE.default),
    call: $b9c043d1df5cab70$var$selection_prototype.call,
    nodes: $b9c043d1df5cab70$var$selection_prototype.nodes,
    node: $b9c043d1df5cab70$var$selection_prototype.node,
    size: $b9c043d1df5cab70$var$selection_prototype.size,
    empty: $b9c043d1df5cab70$var$selection_prototype.empty,
    each: $b9c043d1df5cab70$var$selection_prototype.each,
    on: (0, $j4CdW.default),
    attr: (0, $gY5kg.default),
    attrTween: (0, $jjy0J.default),
    style: (0, $hE4hP.default),
    styleTween: (0, $jOQ3F.default),
    text: (0, $53AmB.default),
    textTween: (0, $5BKDD.default),
    remove: (0, $eDQPE.default),
    tween: (0, $95uLu.default),
    delay: (0, $jRkMj.default),
    duration: (0, $lKasu.default),
    ease: (0, $149Rz.default),
    end: (0, $1C2ts.default)
};

});
parcelRegister("gY5kg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5a6618ef8170a60$export$2e2bcd8739ae039; });

var $6oDCD = parcelRequire("6oDCD");

var $hMW9k = parcelRequire("hMW9k");

var $95uLu = parcelRequire("95uLu");

var $8fExa = parcelRequire("8fExa");
function $c5a6618ef8170a60$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $c5a6618ef8170a60$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $c5a6618ef8170a60$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $c5a6618ef8170a60$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $c5a6618ef8170a60$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $c5a6618ef8170a60$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $c5a6618ef8170a60$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $hMW9k.default)(name), i = fullname === "transform" ? (0, $6oDCD.interpolateTransformSvg) : (0, $8fExa.default);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $c5a6618ef8170a60$var$attrFunctionNS : $c5a6618ef8170a60$var$attrFunction)(fullname, i, (0, $95uLu.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? $c5a6618ef8170a60$var$attrRemoveNS : $c5a6618ef8170a60$var$attrRemove)(fullname) : (fullname.local ? $c5a6618ef8170a60$var$attrConstantNS : $c5a6618ef8170a60$var$attrConstant)(fullname, i, value));
}

});
parcelRegister("6oDCD", function(module, exports) {

$parcel$export(module.exports, "interpolateTransformCss", function () { return $4a83b814dfbd16ef$export$56bec7123bb3589a; });
$parcel$export(module.exports, "interpolateTransformSvg", function () { return $4a83b814dfbd16ef$export$da8cba906d64c082; });

var $iI7Wc = parcelRequire("iI7Wc");

var $5EqzP = parcelRequire("5EqzP");
function $4a83b814dfbd16ef$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $iI7Wc.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $iI7Wc.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $iI7Wc.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $iI7Wc.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $iI7Wc.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $iI7Wc.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $4a83b814dfbd16ef$export$56bec7123bb3589a = $4a83b814dfbd16ef$var$interpolateTransform((0, $5EqzP.parseCss), "px, ", "px)", "deg)");
var $4a83b814dfbd16ef$export$da8cba906d64c082 = $4a83b814dfbd16ef$var$interpolateTransform((0, $5EqzP.parseSvg), ", ", ")", ")");

});
parcelRegister("5EqzP", function(module, exports) {

$parcel$export(module.exports, "parseCss", function () { return $41d54dd0d6e5ea72$export$59ad369bf4938177; });
$parcel$export(module.exports, "parseSvg", function () { return $41d54dd0d6e5ea72$export$f9ef43f9a1d89a18; });

var $kkZEy = parcelRequire("kkZEy");
var $41d54dd0d6e5ea72$var$cssNode, $41d54dd0d6e5ea72$var$cssRoot, $41d54dd0d6e5ea72$var$cssView, $41d54dd0d6e5ea72$var$svgNode;
function $41d54dd0d6e5ea72$export$59ad369bf4938177(value) {
    if (value === "none") return 0, $kkZEy.identity;
    if (!$41d54dd0d6e5ea72$var$cssNode) $41d54dd0d6e5ea72$var$cssNode = document.createElement("DIV"), $41d54dd0d6e5ea72$var$cssRoot = document.documentElement, $41d54dd0d6e5ea72$var$cssView = document.defaultView;
    $41d54dd0d6e5ea72$var$cssNode.style.transform = value;
    value = $41d54dd0d6e5ea72$var$cssView.getComputedStyle($41d54dd0d6e5ea72$var$cssRoot.appendChild($41d54dd0d6e5ea72$var$cssNode), null).getPropertyValue("transform");
    $41d54dd0d6e5ea72$var$cssRoot.removeChild($41d54dd0d6e5ea72$var$cssNode);
    value = value.slice(7, -1).split(",");
    return (0, $kkZEy.default)(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}
function $41d54dd0d6e5ea72$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $kkZEy.identity;
    if (!$41d54dd0d6e5ea72$var$svgNode) $41d54dd0d6e5ea72$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $41d54dd0d6e5ea72$var$svgNode.setAttribute("transform", value);
    if (!(value = $41d54dd0d6e5ea72$var$svgNode.transform.baseVal.consolidate())) return 0, $kkZEy.identity;
    value = value.matrix;
    return (0, $kkZEy.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("kkZEy", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $ece57fed703a7f55$export$f0954fd7d5368655; });
$parcel$export(module.exports, "default", function () { return $ece57fed703a7f55$export$2e2bcd8739ae039; });
var $ece57fed703a7f55$var$degrees = 180 / Math.PI;
var $ece57fed703a7f55$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $ece57fed703a7f55$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $ece57fed703a7f55$var$degrees,
        skewX: Math.atan(skewX) * $ece57fed703a7f55$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("95uLu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69dc71fad5cf9173$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "tweenValue", function () { return $69dc71fad5cf9173$export$f78ce6ab10405d82; });

var $50v9q = parcelRequire("50v9q");
function $69dc71fad5cf9173$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $50v9q.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $69dc71fad5cf9173$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $50v9q.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $69dc71fad5cf9173$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $50v9q.get)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $69dc71fad5cf9173$var$tweenRemove : $69dc71fad5cf9173$var$tweenFunction)(id, name, value));
}
function $69dc71fad5cf9173$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $50v9q.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $50v9q.get)(node, id).value[name];
    };
}

});

parcelRegister("8fExa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $601f2aa08822a5a5$export$2e2bcd8739ae039; });

var $1tQWc = parcelRequire("1tQWc");

var $iI7Wc = parcelRequire("iI7Wc");
var $luZYw = parcelRequire("luZYw");
var $2ESy3 = parcelRequire("2ESy3");
function $601f2aa08822a5a5$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $iI7Wc.default) : b instanceof (0, $1tQWc.default) ? (0, $luZYw.default) : (c = (0, $1tQWc.default)(b)) ? (b = c, $luZYw.default) : (0, $2ESy3.default))(a, b);
}

});


parcelRegister("jjy0J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0fa2c829d5769ff$export$2e2bcd8739ae039; });

var $hMW9k = parcelRequire("hMW9k");
function $e0fa2c829d5769ff$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $e0fa2c829d5769ff$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $e0fa2c829d5769ff$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $e0fa2c829d5769ff$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $e0fa2c829d5769ff$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $e0fa2c829d5769ff$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $e0fa2c829d5769ff$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $hMW9k.default)(name);
    return this.tween(key, (fullname.local ? $e0fa2c829d5769ff$var$attrTweenNS : $e0fa2c829d5769ff$var$attrTween)(fullname, value));
}

});

parcelRegister("jRkMj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e75315ab9f71ffa1$export$2e2bcd8739ae039; });

var $50v9q = parcelRequire("50v9q");
function $e75315ab9f71ffa1$var$delayFunction(id, value) {
    return function() {
        (0, $50v9q.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function $e75315ab9f71ffa1$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $50v9q.init)(this, id).delay = value;
    };
}
function $e75315ab9f71ffa1$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $e75315ab9f71ffa1$var$delayFunction : $e75315ab9f71ffa1$var$delayConstant)(id, value)) : (0, $50v9q.get)(this.node(), id).delay;
}

});

parcelRegister("lKasu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd4601adec21e231$export$2e2bcd8739ae039; });

var $50v9q = parcelRequire("50v9q");
function $fd4601adec21e231$var$durationFunction(id, value) {
    return function() {
        (0, $50v9q.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function $fd4601adec21e231$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $50v9q.set)(this, id).duration = value;
    };
}
function $fd4601adec21e231$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $fd4601adec21e231$var$durationFunction : $fd4601adec21e231$var$durationConstant)(id, value)) : (0, $50v9q.get)(this.node(), id).duration;
}

});

parcelRegister("149Rz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c6dd0c38f95c212$export$2e2bcd8739ae039; });

var $50v9q = parcelRequire("50v9q");
function $0c6dd0c38f95c212$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $50v9q.set)(this, id).ease = value;
    };
}
function $0c6dd0c38f95c212$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($0c6dd0c38f95c212$var$easeConstant(id, value)) : (0, $50v9q.get)(this.node(), id).ease;
}

});

parcelRegister("ditMZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ae41052279dd25b$export$2e2bcd8739ae039; });

var $918kN = parcelRequire("918kN");

var $fWKoQ = parcelRequire("fWKoQ");
function $9ae41052279dd25b$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $918kN.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $fWKoQ.Transition)(subgroups, this._parents, this._name, this._id);
}

});

parcelRegister("9FQnK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70b093623528c735$export$2e2bcd8739ae039; });

var $fWKoQ = parcelRequire("fWKoQ");
function $70b093623528c735$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $fWKoQ.Transition)(merges, this._parents, this._name, this._id);
}

});

parcelRegister("j4CdW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de2c0a82b7be865f$export$2e2bcd8739ae039; });

var $50v9q = parcelRequire("50v9q");
function $de2c0a82b7be865f$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $de2c0a82b7be865f$var$onFunction(id, name, listener) {
    var on0, on1, sit = $de2c0a82b7be865f$var$start(name) ? (0, $50v9q.init) : (0, $50v9q.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $de2c0a82b7be865f$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $50v9q.get)(this.node(), id).on.on(name) : this.each($de2c0a82b7be865f$var$onFunction(id, name, listener));
}

});

parcelRegister("eDQPE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa8db08d844ce813$export$2e2bcd8739ae039; });
function $aa8db08d844ce813$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $aa8db08d844ce813$export$2e2bcd8739ae039() {
    return this.on("end.remove", $aa8db08d844ce813$var$removeFunction(this._id));
}

});

parcelRegister("2q656", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c32ba1ba4d12b29$export$2e2bcd8739ae039; });

var $jiCaU = parcelRequire("jiCaU");

var $fWKoQ = parcelRequire("fWKoQ");

var $50v9q = parcelRequire("50v9q");
function $1c32ba1ba4d12b29$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $jiCaU.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $50v9q.default)(subgroup[i], name, id, i, subgroup, (0, $50v9q.get)(node, id));
        }
    }
    return new (0, $fWKoQ.Transition)(subgroups, this._parents, name, id);
}

});

parcelRegister("jqOce", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e25761f97d011e01$export$2e2bcd8739ae039; });

var $5IoPJ = parcelRequire("5IoPJ");

var $fWKoQ = parcelRequire("fWKoQ");

var $50v9q = parcelRequire("50v9q");
function $e25761f97d011e01$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $5IoPJ.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $50v9q.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $50v9q.default)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $fWKoQ.Transition)(subgroups, parents, name, id);
}

});

parcelRegister("blVZy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $843ea3d2638a67c1$export$2e2bcd8739ae039; });

var $89bZp = parcelRequire("89bZp");
var $843ea3d2638a67c1$var$Selection = (0, $89bZp.default).prototype.constructor;
function $843ea3d2638a67c1$export$2e2bcd8739ae039() {
    return new $843ea3d2638a67c1$var$Selection(this._groups, this._parents);
}

});

parcelRegister("hE4hP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd897f4b3bc73b18$export$2e2bcd8739ae039; });

var $6oDCD = parcelRequire("6oDCD");

var $itJL7 = parcelRequire("itJL7");

var $50v9q = parcelRequire("50v9q");

var $95uLu = parcelRequire("95uLu");

var $8fExa = parcelRequire("8fExa");
function $cd897f4b3bc73b18$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $itJL7.styleValue)(this, name), string1 = (this.style.removeProperty(name), (0, $itJL7.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $cd897f4b3bc73b18$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $cd897f4b3bc73b18$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $itJL7.styleValue)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $cd897f4b3bc73b18$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $itJL7.styleValue)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $itJL7.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $cd897f4b3bc73b18$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $50v9q.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $cd897f4b3bc73b18$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $cd897f4b3bc73b18$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $6oDCD.interpolateTransformCss) : (0, $8fExa.default);
    return value == null ? this.styleTween(name, $cd897f4b3bc73b18$var$styleNull(name, i)).on("end.style." + name, $cd897f4b3bc73b18$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $cd897f4b3bc73b18$var$styleFunction(name, i, (0, $95uLu.tweenValue)(this, "style." + name, value))).each($cd897f4b3bc73b18$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $cd897f4b3bc73b18$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}

});

parcelRegister("jOQ3F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6db1179d79e5bab$export$2e2bcd8739ae039; });
function $e6db1179d79e5bab$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $e6db1179d79e5bab$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $e6db1179d79e5bab$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $e6db1179d79e5bab$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $e6db1179d79e5bab$var$styleTween(name, value, priority == null ? "" : priority));
}

});

parcelRegister("53AmB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ae970976a4f52d3$export$2e2bcd8739ae039; });

var $95uLu = parcelRequire("95uLu");
function $3ae970976a4f52d3$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $3ae970976a4f52d3$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $3ae970976a4f52d3$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $3ae970976a4f52d3$var$textFunction((0, $95uLu.tweenValue)(this, "text", value)) : $3ae970976a4f52d3$var$textConstant(value == null ? "" : value + ""));
}

});

parcelRegister("5BKDD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $415495db16f138ba$export$2e2bcd8739ae039; });
function $415495db16f138ba$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $415495db16f138ba$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $415495db16f138ba$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $415495db16f138ba$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $415495db16f138ba$var$textTween(value));
}

});

parcelRegister("2lDQE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b5c73f14e1e26f2$export$2e2bcd8739ae039; });

var $fWKoQ = parcelRequire("fWKoQ");

var $50v9q = parcelRequire("50v9q");
function $1b5c73f14e1e26f2$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $fWKoQ.newId)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $50v9q.get)(node, id0);
            (0, $50v9q.default)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $fWKoQ.Transition)(groups, this._parents, name, id1);
}

});

parcelRegister("1C2ts", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12cb42595b5abd3a$export$2e2bcd8739ae039; });

var $50v9q = parcelRequire("50v9q");
function $12cb42595b5abd3a$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $50v9q.set)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
    });
}

});


parcelRegister("btL80", function(module, exports) {

$parcel$export(module.exports, "cubicIn", function () { return $85b6f5cfc6aacf4f$export$b1a09cb1b71f86aa; });
$parcel$export(module.exports, "cubicOut", function () { return $85b6f5cfc6aacf4f$export$68d528839c701b6; });
$parcel$export(module.exports, "cubicInOut", function () { return $85b6f5cfc6aacf4f$export$89238d3bc79d3ada; });
function $85b6f5cfc6aacf4f$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $85b6f5cfc6aacf4f$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $85b6f5cfc6aacf4f$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

});



parcelRegister("6I37d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e2944ce31e1b924$export$2e2bcd8739ae039; });

var $fWKoQ = parcelRequire("fWKoQ");

var $50v9q = parcelRequire("50v9q");
var $4e2944ce31e1b924$var$root = [
    null
];
function $4e2944ce31e1b924$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, i;
    if (schedules) {
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).state > (0, $50v9q.SCHEDULED) && schedule.name === name) return new (0, $fWKoQ.Transition)([
                [
                    node
                ]
            ], $4e2944ce31e1b924$var$root, name, +i);
        }
    }
    return null;
}

});


parcelRegister("arkUr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $799ca52ce5b7f365$export$2e2bcd8739ae039; });
function $799ca52ce5b7f365$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("8L8jw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66092974645149a2$export$2e2bcd8739ae039; });
function $66092974645149a2$export$2e2bcd8739ae039(target, type, selection) {
    this.target = target;
    this.type = type;
    this.selection = selection;
}

});

parcelRegister("91tvW", function(module, exports) {

$parcel$export(module.exports, "nopropagation", function () { return $691b19ee6d02434e$export$2e2561858db9bf47; });
$parcel$export(module.exports, "default", function () { return $691b19ee6d02434e$export$2e2bcd8739ae039; });

var $fvaBb = parcelRequire("fvaBb");
function $691b19ee6d02434e$export$2e2561858db9bf47() {
    (0, $fvaBb.event).stopImmediatePropagation();
}
function $691b19ee6d02434e$export$2e2bcd8739ae039() {
    (0, $fvaBb.event).preventDefault();
    (0, $fvaBb.event).stopImmediatePropagation();
}

});



parcelRegister("9zU3n", function(module, exports) {

$parcel$export(module.exports, "chord", function () { return (parcelRequire("dXaXD")).default; });
$parcel$export(module.exports, "ribbon", function () { return (parcelRequire("60Qji")).default; });

var $dXaXD = parcelRequire("dXaXD");

var $60Qji = parcelRequire("60Qji");

});
parcelRegister("dXaXD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a28949a28f32d646$export$2e2bcd8739ae039; });
parcelRequire("9f3pr");
var $lwLP6 = parcelRequire("lwLP6");

var $7NYpB = parcelRequire("7NYpB");
function $a28949a28f32d646$var$compareValue(compare) {
    return function(a, b) {
        return compare(a.source.value + a.target.value, b.source.value + b.target.value);
    };
}
function $a28949a28f32d646$export$2e2bcd8739ae039() {
    var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
    function chord(matrix) {
        var n = matrix.length, groupSums = [], groupIndex = (0, $lwLP6.default)(n), subgroupIndex = [], chords = [], groups = chords.groups = new Array(n), subgroups = new Array(n * n), k, x, x0, dx, i, j;
        // Compute the sum.
        k = 0, i = -1;
        while(++i < n){
            x = 0, j = -1;
            while(++j < n)x += matrix[i][j];
            groupSums.push(x);
            subgroupIndex.push((0, $lwLP6.default)(n));
            k += x;
        }
        // Sort groups…
        if (sortGroups) groupIndex.sort(function(a, b) {
            return sortGroups(groupSums[a], groupSums[b]);
        });
        // Sort subgroups…
        if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
            d.sort(function(a, b) {
                return sortSubgroups(matrix[i][a], matrix[i][b]);
            });
        });
        // Convert the sum to scaling factor for [0, 2pi].
        // TODO Allow start and end angle to be specified?
        // TODO Allow padding to be specified as percentage?
        k = (0, $7NYpB.max)(0, (0, $7NYpB.tau) - padAngle * n) / k;
        dx = k ? padAngle : (0, $7NYpB.tau) / n;
        // Compute the start and end angle for each group and subgroup.
        // Note: Opera has a bug reordering object literal properties!
        x = 0, i = -1;
        while(++i < n){
            x0 = x, j = -1;
            while(++j < n){
                var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
                subgroups[dj * n + di] = {
                    index: di,
                    subindex: dj,
                    startAngle: a0,
                    endAngle: a1,
                    value: v
                };
            }
            groups[di] = {
                index: di,
                startAngle: x0,
                endAngle: x,
                value: groupSums[di]
            };
            x += dx;
        }
        // Generate chords for each (non-empty) subgroup-subgroup link.
        i = -1;
        while(++i < n){
            j = i - 1;
            while(++j < n){
                var source = subgroups[j * n + i], target = subgroups[i * n + j];
                if (source.value || target.value) chords.push(source.value < target.value ? {
                    source: target,
                    target: source
                } : {
                    source: source,
                    target: target
                });
            }
        }
        return sortChords ? chords.sort(sortChords) : chords;
    }
    chord.padAngle = function(_) {
        return arguments.length ? (padAngle = (0, $7NYpB.max)(0, _), chord) : padAngle;
    };
    chord.sortGroups = function(_) {
        return arguments.length ? (sortGroups = _, chord) : sortGroups;
    };
    chord.sortSubgroups = function(_) {
        return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
    };
    chord.sortChords = function(_) {
        return arguments.length ? (_ == null ? sortChords = null : (sortChords = $a28949a28f32d646$var$compareValue(_))._ = _, chord) : sortChords && sortChords._;
    };
    return chord;
}

});
parcelRegister("7NYpB", function(module, exports) {

$parcel$export(module.exports, "cos", function () { return $5aebf88c2f8e5226$export$50d414a77b60d802; });
$parcel$export(module.exports, "sin", function () { return $5aebf88c2f8e5226$export$5de3937cb4b592ed; });
$parcel$export(module.exports, "halfPi", function () { return $5aebf88c2f8e5226$export$e51408a300e8929a; });
$parcel$export(module.exports, "tau", function () { return $5aebf88c2f8e5226$export$a4b4b4d4d776fe92; });
$parcel$export(module.exports, "max", function () { return $5aebf88c2f8e5226$export$8960430cfd85939f; });
var $5aebf88c2f8e5226$export$50d414a77b60d802 = Math.cos;
var $5aebf88c2f8e5226$export$5de3937cb4b592ed = Math.sin;
var $5aebf88c2f8e5226$export$18c7bea995a110f = Math.PI;
var $5aebf88c2f8e5226$export$e51408a300e8929a = $5aebf88c2f8e5226$export$18c7bea995a110f / 2;
var $5aebf88c2f8e5226$export$a4b4b4d4d776fe92 = $5aebf88c2f8e5226$export$18c7bea995a110f * 2;
var $5aebf88c2f8e5226$export$8960430cfd85939f = Math.max;

});


parcelRegister("60Qji", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $460b51e5afd2ff18$export$2e2bcd8739ae039; });

var $iXR5Q = parcelRequire("iXR5Q");

var $2vPHf = parcelRequire("2vPHf");

var $7NYpB = parcelRequire("7NYpB");

var $2XIUS = parcelRequire("2XIUS");
function $460b51e5afd2ff18$var$defaultSource(d) {
    return d.source;
}
function $460b51e5afd2ff18$var$defaultTarget(d) {
    return d.target;
}
function $460b51e5afd2ff18$var$defaultRadius(d) {
    return d.radius;
}
function $460b51e5afd2ff18$var$defaultStartAngle(d) {
    return d.startAngle;
}
function $460b51e5afd2ff18$var$defaultEndAngle(d) {
    return d.endAngle;
}
function $460b51e5afd2ff18$export$2e2bcd8739ae039() {
    var source = $460b51e5afd2ff18$var$defaultSource, target = $460b51e5afd2ff18$var$defaultTarget, radius = $460b51e5afd2ff18$var$defaultRadius, startAngle = $460b51e5afd2ff18$var$defaultStartAngle, endAngle = $460b51e5afd2ff18$var$defaultEndAngle, context = null;
    function ribbon() {
        var buffer, argv = (0, $iXR5Q.slice).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv), sr = +radius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - (0, $7NYpB.halfPi), sa1 = endAngle.apply(this, argv) - (0, $7NYpB.halfPi), sx0 = sr * (0, $7NYpB.cos)(sa0), sy0 = sr * (0, $7NYpB.sin)(sa0), tr = +radius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - (0, $7NYpB.halfPi), ta1 = endAngle.apply(this, argv) - (0, $7NYpB.halfPi);
        if (!context) context = buffer = (0, $2XIUS.default)();
        context.moveTo(sx0, sy0);
        context.arc(0, 0, sr, sa0, sa1);
        if (sa0 !== ta0 || sa1 !== ta1) {
            context.quadraticCurveTo(0, 0, tr * (0, $7NYpB.cos)(ta0), tr * (0, $7NYpB.sin)(ta0));
            context.arc(0, 0, tr, ta0, ta1);
        }
        context.quadraticCurveTo(0, 0, sx0, sy0);
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    ribbon.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $2vPHf.default)(+_), ribbon) : radius;
    };
    ribbon.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $2vPHf.default)(+_), ribbon) : startAngle;
    };
    ribbon.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $2vPHf.default)(+_), ribbon) : endAngle;
    };
    ribbon.source = function(_) {
        return arguments.length ? (source = _, ribbon) : source;
    };
    ribbon.target = function(_) {
        return arguments.length ? (target = _, ribbon) : target;
    };
    ribbon.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
    };
    return ribbon;
}

});
parcelRegister("iXR5Q", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $dce6ebe38f254e93$export$58adb3bec8346d0f; });
var $dce6ebe38f254e93$export$58adb3bec8346d0f = Array.prototype.slice;

});

parcelRegister("2vPHf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d4693da6b8dd8c0$export$2e2bcd8739ae039; });
function $1d4693da6b8dd8c0$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("2XIUS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2283eeea20a117ed$export$2e2bcd8739ae039; });
var $2283eeea20a117ed$var$pi = Math.PI, $2283eeea20a117ed$var$tau = 2 * $2283eeea20a117ed$var$pi, $2283eeea20a117ed$var$epsilon = 1e-6, $2283eeea20a117ed$var$tauEpsilon = $2283eeea20a117ed$var$tau - $2283eeea20a117ed$var$epsilon;
function $2283eeea20a117ed$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $2283eeea20a117ed$var$path() {
    return new $2283eeea20a117ed$var$Path;
}
$2283eeea20a117ed$var$Path.prototype = $2283eeea20a117ed$var$path.prototype = {
    constructor: $2283eeea20a117ed$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $2283eeea20a117ed$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $2283eeea20a117ed$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($2283eeea20a117ed$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $2283eeea20a117ed$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $2283eeea20a117ed$var$epsilon || Math.abs(this._y1 - y0) > $2283eeea20a117ed$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $2283eeea20a117ed$var$tau + $2283eeea20a117ed$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $2283eeea20a117ed$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $2283eeea20a117ed$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $2283eeea20a117ed$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $2283eeea20a117ed$export$2e2bcd8739ae039 = $2283eeea20a117ed$var$path;

});



parcelRegister("9r7nk", function(module, exports) {

$parcel$export(module.exports, "nest", function () { return (parcelRequire("5p8xM")).default; });
$parcel$export(module.exports, "set", function () { return (parcelRequire("cBeeE")).default; });
$parcel$export(module.exports, "map", function () { return (parcelRequire("3WKXr")).default; });
$parcel$export(module.exports, "keys", function () { return (parcelRequire("fZ6Ms")).default; });
$parcel$export(module.exports, "values", function () { return (parcelRequire("3lIT9")).default; });
$parcel$export(module.exports, "entries", function () { return (parcelRequire("eOw6N")).default; });

var $5p8xM = parcelRequire("5p8xM");

var $cBeeE = parcelRequire("cBeeE");

var $3WKXr = parcelRequire("3WKXr");

var $fZ6Ms = parcelRequire("fZ6Ms");

var $3lIT9 = parcelRequire("3lIT9");

var $eOw6N = parcelRequire("eOw6N");

});
parcelRegister("5p8xM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ef5ea30aacd7283$export$2e2bcd8739ae039; });

var $3WKXr = parcelRequire("3WKXr");
function $3ef5ea30aacd7283$export$2e2bcd8739ae039() {
    var keys = [], sortKeys = [], sortValues, rollup, nest;
    function apply(array, depth, createResult, setResult) {
        if (depth >= keys.length) {
            if (sortValues != null) array.sort(sortValues);
            return rollup != null ? rollup(array) : array;
        }
        var i = -1, n = array.length, key = keys[depth++], keyValue, value, valuesByKey = (0, $3WKXr.default)(), values, result = createResult();
        while(++i < n)if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) values.push(value);
        else valuesByKey.set(keyValue, [
            value
        ]);
        valuesByKey.each(function(values, key) {
            setResult(result, key, apply(values, depth, createResult, setResult));
        });
        return result;
    }
    function entries(map, depth) {
        if (++depth > keys.length) return map;
        var array, sortKey = sortKeys[depth - 1];
        if (rollup != null && depth >= keys.length) array = map.entries();
        else array = [], map.each(function(v, k) {
            array.push({
                key: k,
                values: entries(v, depth)
            });
        });
        return sortKey != null ? array.sort(function(a, b) {
            return sortKey(a.key, b.key);
        }) : array;
    }
    return nest = {
        object: function(array) {
            return apply(array, 0, $3ef5ea30aacd7283$var$createObject, $3ef5ea30aacd7283$var$setObject);
        },
        map: function(array) {
            return apply(array, 0, $3ef5ea30aacd7283$var$createMap, $3ef5ea30aacd7283$var$setMap);
        },
        entries: function(array) {
            return entries(apply(array, 0, $3ef5ea30aacd7283$var$createMap, $3ef5ea30aacd7283$var$setMap), 0);
        },
        key: function(d) {
            keys.push(d);
            return nest;
        },
        sortKeys: function(order) {
            sortKeys[keys.length - 1] = order;
            return nest;
        },
        sortValues: function(order) {
            sortValues = order;
            return nest;
        },
        rollup: function(f) {
            rollup = f;
            return nest;
        }
    };
}
function $3ef5ea30aacd7283$var$createObject() {
    return {};
}
function $3ef5ea30aacd7283$var$setObject(object, key, value) {
    object[key] = value;
}
function $3ef5ea30aacd7283$var$createMap() {
    return (0, $3WKXr.default)();
}
function $3ef5ea30aacd7283$var$setMap(map, key, value) {
    map.set(key, value);
}

});
parcelRegister("3WKXr", function(module, exports) {

$parcel$export(module.exports, "prefix", function () { return $2dfb36b126eb6922$export$82e9f45cca5ba907; });
$parcel$export(module.exports, "default", function () { return $2dfb36b126eb6922$export$2e2bcd8739ae039; });
var $2dfb36b126eb6922$export$82e9f45cca5ba907 = "$";
function $2dfb36b126eb6922$var$Map() {}
$2dfb36b126eb6922$var$Map.prototype = $2dfb36b126eb6922$var$map.prototype = {
    constructor: $2dfb36b126eb6922$var$Map,
    has: function(key) {
        return $2dfb36b126eb6922$export$82e9f45cca5ba907 + key in this;
    },
    get: function(key) {
        return this[$2dfb36b126eb6922$export$82e9f45cca5ba907 + key];
    },
    set: function(key, value) {
        this[$2dfb36b126eb6922$export$82e9f45cca5ba907 + key] = value;
        return this;
    },
    remove: function(key) {
        var property = $2dfb36b126eb6922$export$82e9f45cca5ba907 + key;
        return property in this && delete this[property];
    },
    clear: function() {
        for(var property in this)if (property[0] === $2dfb36b126eb6922$export$82e9f45cca5ba907) delete this[property];
    },
    keys: function() {
        var keys = [];
        for(var property in this)if (property[0] === $2dfb36b126eb6922$export$82e9f45cca5ba907) keys.push(property.slice(1));
        return keys;
    },
    values: function() {
        var values = [];
        for(var property in this)if (property[0] === $2dfb36b126eb6922$export$82e9f45cca5ba907) values.push(this[property]);
        return values;
    },
    entries: function() {
        var entries = [];
        for(var property in this)if (property[0] === $2dfb36b126eb6922$export$82e9f45cca5ba907) entries.push({
            key: property.slice(1),
            value: this[property]
        });
        return entries;
    },
    size: function() {
        var size = 0;
        for(var property in this)if (property[0] === $2dfb36b126eb6922$export$82e9f45cca5ba907) ++size;
        return size;
    },
    empty: function() {
        for(var property in this)if (property[0] === $2dfb36b126eb6922$export$82e9f45cca5ba907) return false;
        return true;
    },
    each: function(f) {
        for(var property in this)if (property[0] === $2dfb36b126eb6922$export$82e9f45cca5ba907) f(this[property], property.slice(1), this);
    }
};
function $2dfb36b126eb6922$var$map(object, f) {
    var map = new $2dfb36b126eb6922$var$Map;
    // Copy constructor.
    if (object instanceof $2dfb36b126eb6922$var$Map) object.each(function(value, key) {
        map.set(key, value);
    });
    else if (Array.isArray(object)) {
        var i = -1, n = object.length, o;
        if (f == null) while(++i < n)map.set(i, object[i]);
        else while(++i < n)map.set(f(o = object[i], i, object), o);
    } else if (object) for(var key in object)map.set(key, object[key]);
    return map;
}
var $2dfb36b126eb6922$export$2e2bcd8739ae039 = $2dfb36b126eb6922$var$map;

});


parcelRegister("cBeeE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92c3fb940b75eb43$export$2e2bcd8739ae039; });

var $3WKXr = parcelRequire("3WKXr");
function $92c3fb940b75eb43$var$Set() {}
var $92c3fb940b75eb43$var$proto = (0, $3WKXr.default).prototype;
$92c3fb940b75eb43$var$Set.prototype = $92c3fb940b75eb43$var$set.prototype = {
    constructor: $92c3fb940b75eb43$var$Set,
    has: $92c3fb940b75eb43$var$proto.has,
    add: function(value) {
        value += "";
        this[(0, $3WKXr.prefix) + value] = value;
        return this;
    },
    remove: $92c3fb940b75eb43$var$proto.remove,
    clear: $92c3fb940b75eb43$var$proto.clear,
    values: $92c3fb940b75eb43$var$proto.keys,
    size: $92c3fb940b75eb43$var$proto.size,
    empty: $92c3fb940b75eb43$var$proto.empty,
    each: $92c3fb940b75eb43$var$proto.each
};
function $92c3fb940b75eb43$var$set(object, f) {
    var set = new $92c3fb940b75eb43$var$Set;
    // Copy constructor.
    if (object instanceof $92c3fb940b75eb43$var$Set) object.each(function(value) {
        set.add(value);
    });
    else if (object) {
        var i = -1, n = object.length;
        if (f == null) while(++i < n)set.add(object[i]);
        else while(++i < n)set.add(f(object[i], i, object));
    }
    return set;
}
var $92c3fb940b75eb43$export$2e2bcd8739ae039 = $92c3fb940b75eb43$var$set;

});

parcelRegister("fZ6Ms", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba31d00015aa6966$export$2e2bcd8739ae039; });
function $ba31d00015aa6966$export$2e2bcd8739ae039(map) {
    var keys = [];
    for(var key in map)keys.push(key);
    return keys;
}

});

parcelRegister("3lIT9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2706272db988b1f9$export$2e2bcd8739ae039; });
function $2706272db988b1f9$export$2e2bcd8739ae039(map) {
    var values = [];
    for(var key in map)values.push(map[key]);
    return values;
}

});

parcelRegister("eOw6N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac8ea450d8677192$export$2e2bcd8739ae039; });
function $ac8ea450d8677192$export$2e2bcd8739ae039(map) {
    var entries = [];
    for(var key in map)entries.push({
        key: key,
        value: map[key]
    });
    return entries;
}

});


parcelRegister("c8wtg", function(module, exports) {

$parcel$export(module.exports, "color", function () { return (parcelRequire("1tQWc")).default; });
$parcel$export(module.exports, "rgb", function () { return (parcelRequire("1tQWc")).rgb; });
$parcel$export(module.exports, "hsl", function () { return (parcelRequire("1tQWc")).hsl; });
$parcel$export(module.exports, "lab", function () { return (parcelRequire("iqJRz")).default; });
$parcel$export(module.exports, "hcl", function () { return (parcelRequire("iqJRz")).hcl; });
$parcel$export(module.exports, "lch", function () { return (parcelRequire("iqJRz")).lch; });
$parcel$export(module.exports, "gray", function () { return (parcelRequire("iqJRz")).gray; });
$parcel$export(module.exports, "cubehelix", function () { return (parcelRequire("4phTB")).default; });

var $1tQWc = parcelRequire("1tQWc");

var $iqJRz = parcelRequire("iqJRz");

var $4phTB = parcelRequire("4phTB");

});
parcelRegister("iqJRz", function(module, exports) {

$parcel$export(module.exports, "gray", function () { return $d6ae3b209dd94cf5$export$3e2c219d3ab79d01; });
$parcel$export(module.exports, "default", function () { return $d6ae3b209dd94cf5$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "lch", function () { return $d6ae3b209dd94cf5$export$5a21418738164530; });
$parcel$export(module.exports, "hcl", function () { return $d6ae3b209dd94cf5$export$d0e870ba50062ff1; });

var $imKCb = parcelRequire("imKCb");

var $1tQWc = parcelRequire("1tQWc");

var $c7oIE = parcelRequire("c7oIE");
// https://observablehq.com/@mbostock/lab-and-rgb
const $d6ae3b209dd94cf5$var$K = 18, $d6ae3b209dd94cf5$var$Xn = 0.96422, $d6ae3b209dd94cf5$var$Yn = 1, $d6ae3b209dd94cf5$var$Zn = 0.82521, $d6ae3b209dd94cf5$var$t0 = 4 / 29, $d6ae3b209dd94cf5$var$t1 = 6 / 29, $d6ae3b209dd94cf5$var$t2 = 3 * $d6ae3b209dd94cf5$var$t1 * $d6ae3b209dd94cf5$var$t1, $d6ae3b209dd94cf5$var$t3 = $d6ae3b209dd94cf5$var$t1 * $d6ae3b209dd94cf5$var$t1 * $d6ae3b209dd94cf5$var$t1;
function $d6ae3b209dd94cf5$var$labConvert(o) {
    if (o instanceof $d6ae3b209dd94cf5$export$f2722c70a60257f7) return new $d6ae3b209dd94cf5$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $d6ae3b209dd94cf5$export$d9397e094a5fbb9a) return $d6ae3b209dd94cf5$var$hcl2lab(o);
    if (!(o instanceof (0, $1tQWc.Rgb))) o = (0, $1tQWc.rgbConvert)(o);
    var r = $d6ae3b209dd94cf5$var$rgb2lrgb(o.r), g = $d6ae3b209dd94cf5$var$rgb2lrgb(o.g), b = $d6ae3b209dd94cf5$var$rgb2lrgb(o.b), y = $d6ae3b209dd94cf5$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $d6ae3b209dd94cf5$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $d6ae3b209dd94cf5$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $d6ae3b209dd94cf5$var$Xn);
        z = $d6ae3b209dd94cf5$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $d6ae3b209dd94cf5$var$Zn);
    }
    return new $d6ae3b209dd94cf5$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $d6ae3b209dd94cf5$export$3e2c219d3ab79d01(l, opacity) {
    return new $d6ae3b209dd94cf5$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $d6ae3b209dd94cf5$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $d6ae3b209dd94cf5$var$labConvert(l) : new $d6ae3b209dd94cf5$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $d6ae3b209dd94cf5$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $imKCb.default)($d6ae3b209dd94cf5$export$f2722c70a60257f7, $d6ae3b209dd94cf5$export$2e2bcd8739ae039, (0, $imKCb.extend)((0, $1tQWc.Color), {
    brighter (k) {
        return new $d6ae3b209dd94cf5$export$f2722c70a60257f7(this.l + $d6ae3b209dd94cf5$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $d6ae3b209dd94cf5$export$f2722c70a60257f7(this.l - $d6ae3b209dd94cf5$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $d6ae3b209dd94cf5$var$Xn * $d6ae3b209dd94cf5$var$lab2xyz(x);
        y = $d6ae3b209dd94cf5$var$Yn * $d6ae3b209dd94cf5$var$lab2xyz(y);
        z = $d6ae3b209dd94cf5$var$Zn * $d6ae3b209dd94cf5$var$lab2xyz(z);
        return new (0, $1tQWc.Rgb)($d6ae3b209dd94cf5$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $d6ae3b209dd94cf5$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $d6ae3b209dd94cf5$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $d6ae3b209dd94cf5$var$xyz2lab(t) {
    return t > $d6ae3b209dd94cf5$var$t3 ? Math.pow(t, 1 / 3) : t / $d6ae3b209dd94cf5$var$t2 + $d6ae3b209dd94cf5$var$t0;
}
function $d6ae3b209dd94cf5$var$lab2xyz(t) {
    return t > $d6ae3b209dd94cf5$var$t1 ? t * t * t : $d6ae3b209dd94cf5$var$t2 * (t - $d6ae3b209dd94cf5$var$t0);
}
function $d6ae3b209dd94cf5$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $d6ae3b209dd94cf5$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $d6ae3b209dd94cf5$var$hclConvert(o) {
    if (o instanceof $d6ae3b209dd94cf5$export$d9397e094a5fbb9a) return new $d6ae3b209dd94cf5$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $d6ae3b209dd94cf5$export$f2722c70a60257f7)) o = $d6ae3b209dd94cf5$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $d6ae3b209dd94cf5$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $c7oIE.degrees);
    return new $d6ae3b209dd94cf5$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $d6ae3b209dd94cf5$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $d6ae3b209dd94cf5$var$hclConvert(l) : new $d6ae3b209dd94cf5$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $d6ae3b209dd94cf5$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $d6ae3b209dd94cf5$var$hclConvert(h) : new $d6ae3b209dd94cf5$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $d6ae3b209dd94cf5$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $d6ae3b209dd94cf5$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $d6ae3b209dd94cf5$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $c7oIE.radians);
    return new $d6ae3b209dd94cf5$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $imKCb.default)($d6ae3b209dd94cf5$export$d9397e094a5fbb9a, $d6ae3b209dd94cf5$export$d0e870ba50062ff1, (0, $imKCb.extend)((0, $1tQWc.Color), {
    brighter (k) {
        return new $d6ae3b209dd94cf5$export$d9397e094a5fbb9a(this.h, this.c, this.l + $d6ae3b209dd94cf5$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $d6ae3b209dd94cf5$export$d9397e094a5fbb9a(this.h, this.c, this.l - $d6ae3b209dd94cf5$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $d6ae3b209dd94cf5$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("c7oIE", function(module, exports) {

$parcel$export(module.exports, "radians", function () { return $8d295036553b2548$export$8449e153fbd325fc; });
$parcel$export(module.exports, "degrees", function () { return $8d295036553b2548$export$41fc368e1a942b97; });
const $8d295036553b2548$export$8449e153fbd325fc = Math.PI / 180;
const $8d295036553b2548$export$41fc368e1a942b97 = 180 / Math.PI;

});


parcelRegister("4phTB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $335760f80acd369a$export$2e2bcd8739ae039; });

var $imKCb = parcelRequire("imKCb");

var $1tQWc = parcelRequire("1tQWc");

var $c7oIE = parcelRequire("c7oIE");
var $335760f80acd369a$var$A = -0.14861, $335760f80acd369a$var$B = 1.78277, $335760f80acd369a$var$C = -0.29227, $335760f80acd369a$var$D = -0.90649, $335760f80acd369a$var$E = 1.97294, $335760f80acd369a$var$ED = $335760f80acd369a$var$E * $335760f80acd369a$var$D, $335760f80acd369a$var$EB = $335760f80acd369a$var$E * $335760f80acd369a$var$B, $335760f80acd369a$var$BC_DA = $335760f80acd369a$var$B * $335760f80acd369a$var$C - $335760f80acd369a$var$D * $335760f80acd369a$var$A;
function $335760f80acd369a$var$cubehelixConvert(o) {
    if (o instanceof $335760f80acd369a$export$57ed4bde61a1e2f2) return new $335760f80acd369a$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $1tQWc.Rgb))) o = (0, $1tQWc.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($335760f80acd369a$var$BC_DA * b + $335760f80acd369a$var$ED * r - $335760f80acd369a$var$EB * g) / ($335760f80acd369a$var$BC_DA + $335760f80acd369a$var$ED - $335760f80acd369a$var$EB), bl = b - l, k = ($335760f80acd369a$var$E * (g - l) - $335760f80acd369a$var$C * bl) / $335760f80acd369a$var$D, s = Math.sqrt(k * k + bl * bl) / ($335760f80acd369a$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $c7oIE.degrees) - 120 : NaN;
    return new $335760f80acd369a$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $335760f80acd369a$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $335760f80acd369a$var$cubehelixConvert(h) : new $335760f80acd369a$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $335760f80acd369a$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $imKCb.default)($335760f80acd369a$export$57ed4bde61a1e2f2, $335760f80acd369a$export$2e2bcd8739ae039, (0, $imKCb.extend)((0, $1tQWc.Color), {
    brighter (k) {
        k = k == null ? (0, $1tQWc.brighter) : Math.pow((0, $1tQWc.brighter), k);
        return new $335760f80acd369a$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? (0, $1tQWc.darker) : Math.pow((0, $1tQWc.darker), k);
        return new $335760f80acd369a$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $c7oIE.radians), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $1tQWc.Rgb)(255 * (l + a * ($335760f80acd369a$var$A * cosh + $335760f80acd369a$var$B * sinh)), 255 * (l + a * ($335760f80acd369a$var$C * cosh + $335760f80acd369a$var$D * sinh)), 255 * (l + a * ($335760f80acd369a$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("7Z038", function(module, exports) {

$parcel$export(module.exports, "contours", function () { return (parcelRequire("5njmQ")).default; });
$parcel$export(module.exports, "contourDensity", function () { return (parcelRequire("fagU1")).default; });

var $5njmQ = parcelRequire("5njmQ");

var $fagU1 = parcelRequire("fagU1");

});
parcelRegister("5njmQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e9e1fb98d2ed1fd$export$2e2bcd8739ae039; });
parcelRequire("9f3pr");
var $asOlH = parcelRequire("asOlH");
var $lwLP6 = parcelRequire("lwLP6");
var $8nGdH = parcelRequire("8nGdH");
var $jPKO0 = parcelRequire("jPKO0");

var $1lXLi = parcelRequire("1lXLi");

var $dMGwz = parcelRequire("dMGwz");

var $bvC22 = parcelRequire("bvC22");

var $8Tub6 = parcelRequire("8Tub6");

var $h0JED = parcelRequire("h0JED");

var $72OGK = parcelRequire("72OGK");
var $3e9e1fb98d2ed1fd$var$cases = [
    [],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ],
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ],
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    []
];
function $3e9e1fb98d2ed1fd$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, threshold = (0, $8nGdH.default), smooth = smoothLinear;
    function contours(values) {
        var tz = threshold(values);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            var domain = (0, $asOlH.default)(values), start = domain[0], stop = domain[1];
            tz = (0, $jPKO0.tickStep)(start, stop, tz);
            tz = (0, $lwLP6.default)(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
        } else tz = tz.slice().sort((0, $dMGwz.default));
        return tz.map(function(value) {
            return contour(values, value);
        });
    }
    // Accumulate, smooth contour rings, assign holes to exterior rings.
    // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
    function contour(values, value) {
        var polygons = [], holes = [];
        isorings(values, value, function(ring) {
            smooth(ring, values, value);
            if ((0, $bvC22.default)(ring) > 0) polygons.push([
                ring
            ]);
            else holes.push(ring);
        });
        holes.forEach(function(hole) {
            for(var i = 0, n = polygons.length, polygon; i < n; ++i)if ((0, $h0JED.default)((polygon = polygons[i])[0], hole) !== -1) {
                polygon.push(hole);
                return;
            }
        });
        return {
            type: "MultiPolygon",
            value: value,
            coordinates: polygons
        };
    }
    // Marching squares with isolines stitched into rings.
    // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
    function isorings(values, value, callback) {
        var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
        // Special case for the first row (y = -1, t2 = t3 = 0).
        x = y = -1;
        t1 = values[0] >= value;
        $3e9e1fb98d2ed1fd$var$cases[t1 << 1].forEach(stitch);
        while(++x < dx - 1){
            t0 = t1, t1 = values[x + 1] >= value;
            $3e9e1fb98d2ed1fd$var$cases[t0 | t1 << 1].forEach(stitch);
        }
        $3e9e1fb98d2ed1fd$var$cases[t1 << 0].forEach(stitch);
        // General case for the intermediate rows.
        while(++y < dy - 1){
            x = -1;
            t1 = values[y * dx + dx] >= value;
            t2 = values[y * dx] >= value;
            $3e9e1fb98d2ed1fd$var$cases[t1 << 1 | t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
                t3 = t2, t2 = values[y * dx + x + 1] >= value;
                $3e9e1fb98d2ed1fd$var$cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
            }
            $3e9e1fb98d2ed1fd$var$cases[t1 | t2 << 3].forEach(stitch);
        }
        // Special case for the last row (y = dy - 1, t0 = t1 = 0).
        x = -1;
        t2 = values[y * dx] >= value;
        $3e9e1fb98d2ed1fd$var$cases[t2 << 2].forEach(stitch);
        while(++x < dx - 1){
            t3 = t2, t2 = values[y * dx + x + 1] >= value;
            $3e9e1fb98d2ed1fd$var$cases[t2 << 2 | t3 << 3].forEach(stitch);
        }
        $3e9e1fb98d2ed1fd$var$cases[t2 << 3].forEach(stitch);
        function stitch(line) {
            var start = [
                line[0][0] + x,
                line[0][1] + y
            ], end = [
                line[1][0] + x,
                line[1][1] + y
            ], startIndex = index(start), endIndex = index(end), f, g;
            if (f = fragmentByEnd[startIndex]) {
                if (g = fragmentByStart[endIndex]) {
                    delete fragmentByEnd[f.end];
                    delete fragmentByStart[g.start];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                        start: f.start,
                        end: g.end,
                        ring: f.ring.concat(g.ring)
                    };
                } else {
                    delete fragmentByEnd[f.end];
                    f.ring.push(end);
                    fragmentByEnd[f.end = endIndex] = f;
                }
            } else if (f = fragmentByStart[endIndex]) {
                if (g = fragmentByEnd[startIndex]) {
                    delete fragmentByStart[f.start];
                    delete fragmentByEnd[g.end];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                        start: g.start,
                        end: f.end,
                        ring: g.ring.concat(f.ring)
                    };
                } else {
                    delete fragmentByStart[f.start];
                    f.ring.unshift(start);
                    fragmentByStart[f.start = startIndex] = f;
                }
            } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                start: startIndex,
                end: endIndex,
                ring: [
                    start,
                    end
                ]
            };
        }
    }
    function index(point) {
        return point[0] * 2 + point[1] * (dx + 1) * 4;
    }
    function smoothLinear(ring, values, value) {
        ring.forEach(function(point) {
            var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v0, v1 = values[yt * dx + xt];
            if (x > 0 && x < dx && xt === x) {
                v0 = values[yt * dx + xt - 1];
                point[0] = x + (value - v0) / (v1 - v0) - 0.5;
            }
            if (y > 0 && y < dy && yt === y) {
                v0 = values[(yt - 1) * dx + xt];
                point[1] = y + (value - v0) / (v1 - v0) - 0.5;
            }
        });
    }
    contours.contour = contour;
    contours.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
        if (!(_0 > 0) || !(_1 > 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, contours;
    };
    contours.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $8Tub6.default)((0, $1lXLi.slice).call(_)) : (0, $8Tub6.default)(_), contours) : threshold;
    };
    contours.smooth = function(_) {
        return arguments.length ? (smooth = _ ? smoothLinear : (0, $72OGK.default), contours) : smooth === smoothLinear;
    };
    return contours;
}

});
parcelRegister("1lXLi", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $0fc61c0b88b2b343$export$58adb3bec8346d0f; });
var $0fc61c0b88b2b343$var$array = Array.prototype;
var $0fc61c0b88b2b343$export$58adb3bec8346d0f = $0fc61c0b88b2b343$var$array.slice;

});

parcelRegister("dMGwz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a090be7ababb0335$export$2e2bcd8739ae039; });
function $a090be7ababb0335$export$2e2bcd8739ae039(a, b) {
    return a - b;
}

});

parcelRegister("bvC22", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8610174f362e33d4$export$2e2bcd8739ae039; });
function $8610174f362e33d4$export$2e2bcd8739ae039(ring) {
    var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
    while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
    return area;
}

});

parcelRegister("8Tub6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $679ade8326899027$export$2e2bcd8739ae039; });
function $679ade8326899027$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("h0JED", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c625d9c2da1aa1f0$export$2e2bcd8739ae039; });
function $c625d9c2da1aa1f0$export$2e2bcd8739ae039(ring, hole) {
    var i = -1, n = hole.length, c;
    while(++i < n)if (c = $c625d9c2da1aa1f0$var$ringContains(ring, hole[i])) return c;
    return 0;
}
function $c625d9c2da1aa1f0$var$ringContains(ring, point) {
    var x = point[0], y = point[1], contains = -1;
    for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
        var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
        if ($c625d9c2da1aa1f0$var$segmentContains(pi, pj, point)) return 0;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
    }
    return contains;
}
function $c625d9c2da1aa1f0$var$segmentContains(a, b, c) {
    var i;
    return $c625d9c2da1aa1f0$var$collinear(a, b, c) && $c625d9c2da1aa1f0$var$within(a[i = +(a[0] === b[0])], c[i], b[i]);
}
function $c625d9c2da1aa1f0$var$collinear(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}
function $c625d9c2da1aa1f0$var$within(p, q, r) {
    return p <= q && q <= r || r <= q && q <= p;
}

});

parcelRegister("72OGK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52100a00344e13a5$export$2e2bcd8739ae039; });
function $52100a00344e13a5$export$2e2bcd8739ae039() {}

});


parcelRegister("fagU1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0a4e6b4ce80b1eb$export$2e2bcd8739ae039; });
parcelRequire("9f3pr");
var $lgnUZ = parcelRequire("lgnUZ");
var $lwLP6 = parcelRequire("lwLP6");
var $jPKO0 = parcelRequire("jPKO0");

var $1lXLi = parcelRequire("1lXLi");

var $eC6ly = parcelRequire("eC6ly");

var $8Tub6 = parcelRequire("8Tub6");

var $5njmQ = parcelRequire("5njmQ");
function $b0a4e6b4ce80b1eb$var$defaultX(d) {
    return d[0];
}
function $b0a4e6b4ce80b1eb$var$defaultY(d) {
    return d[1];
}
function $b0a4e6b4ce80b1eb$var$defaultWeight() {
    return 1;
}
function $b0a4e6b4ce80b1eb$export$2e2bcd8739ae039() {
    var x = $b0a4e6b4ce80b1eb$var$defaultX, y = $b0a4e6b4ce80b1eb$var$defaultY, weight = $b0a4e6b4ce80b1eb$var$defaultWeight, dx = 960, dy = 500, r = 20, k = 2, o = r * 3, n = dx + o * 2 >> k, m = dy + o * 2 >> k, threshold = (0, $8Tub6.default)(20);
    function density(data) {
        var values0 = new Float32Array(n * m), values1 = new Float32Array(n * m);
        data.forEach(function(d, i, data) {
            var xi = +x(d, i, data) + o >> k, yi = +y(d, i, data) + o >> k, wi = +weight(d, i, data);
            if (xi >= 0 && xi < n && yi >= 0 && yi < m) values0[xi + yi * n] += wi;
        });
        // TODO Optimize.
        (0, $eC6ly.blurX)({
            width: n,
            height: m,
            data: values0
        }, {
            width: n,
            height: m,
            data: values1
        }, r >> k);
        (0, $eC6ly.blurY)({
            width: n,
            height: m,
            data: values1
        }, {
            width: n,
            height: m,
            data: values0
        }, r >> k);
        (0, $eC6ly.blurX)({
            width: n,
            height: m,
            data: values0
        }, {
            width: n,
            height: m,
            data: values1
        }, r >> k);
        (0, $eC6ly.blurY)({
            width: n,
            height: m,
            data: values1
        }, {
            width: n,
            height: m,
            data: values0
        }, r >> k);
        (0, $eC6ly.blurX)({
            width: n,
            height: m,
            data: values0
        }, {
            width: n,
            height: m,
            data: values1
        }, r >> k);
        (0, $eC6ly.blurY)({
            width: n,
            height: m,
            data: values1
        }, {
            width: n,
            height: m,
            data: values0
        }, r >> k);
        var tz = threshold(values0);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            var stop = (0, $lgnUZ.default)(values0);
            tz = (0, $jPKO0.tickStep)(0, stop, tz);
            tz = (0, $lwLP6.default)(0, Math.floor(stop / tz) * tz, tz);
            tz.shift();
        }
        return (0, $5njmQ.default)().thresholds(tz).size([
            n,
            m
        ])(values0).map(transform);
    }
    function transform(geometry) {
        geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
        geometry.coordinates.forEach(transformPolygon);
        return geometry;
    }
    function transformPolygon(coordinates) {
        coordinates.forEach(transformRing);
    }
    function transformRing(coordinates) {
        coordinates.forEach(transformPoint);
    }
    // TODO Optimize.
    function transformPoint(coordinates) {
        coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
        coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
    }
    function resize() {
        o = r * 3;
        n = dx + o * 2 >> k;
        m = dy + o * 2 >> k;
        return density;
    }
    density.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $8Tub6.default)(+_), density) : x;
    };
    density.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $8Tub6.default)(+_), density) : y;
    };
    density.weight = function(_) {
        return arguments.length ? (weight = typeof _ === "function" ? _ : (0, $8Tub6.default)(+_), density) : weight;
    };
    density.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
        if (!(_0 >= 0) && !(_0 >= 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, resize();
    };
    density.cellSize = function(_) {
        if (!arguments.length) return 1 << k;
        if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
        return k = Math.floor(Math.log(_) / Math.LN2), resize();
    };
    density.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $8Tub6.default)((0, $1lXLi.slice).call(_)) : (0, $8Tub6.default)(_), density) : threshold;
    };
    density.bandwidth = function(_) {
        if (!arguments.length) return Math.sqrt(r * (r + 1));
        if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
        return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
    };
    return density;
}

});
parcelRegister("eC6ly", function(module, exports) {

$parcel$export(module.exports, "blurX", function () { return $aa398997f46d35c5$export$d6b6c69cb5897b44; });
$parcel$export(module.exports, "blurY", function () { return $aa398997f46d35c5$export$96ba1179f8344c4b; });
// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function $aa398997f46d35c5$export$d6b6c69cb5897b44(source, target, r) {
    var n = source.width, m = source.height, w = (r << 1) + 1;
    for(var j = 0; j < m; ++j)for(var i = 0, sr = 0; i < n + r; ++i){
        if (i < n) sr += source.data[i + j * n];
        if (i >= r) {
            if (i >= w) sr -= source.data[i - w + j * n];
            target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
        }
    }
}
function $aa398997f46d35c5$export$96ba1179f8344c4b(source, target, r) {
    var n = source.width, m = source.height, w = (r << 1) + 1;
    for(var i = 0; i < n; ++i)for(var j = 0, sr = 0; j < m + r; ++j){
        if (j < m) sr += source.data[i + j * n];
        if (j >= r) {
            if (j >= w) sr -= source.data[i + (j - w) * n];
            target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
        }
    }
}

});



parcelRegister("bLK11", function(module, exports) {

$parcel$export(module.exports, "dispatch", function () { return (parcelRequire("1TJJe")).default; });

var $1TJJe = parcelRequire("1TJJe");

});

parcelRegister("bDnGX", function(module, exports) {

$parcel$export(module.exports, "drag", function () { return (parcelRequire("7EOps")).default; });
$parcel$export(module.exports, "dragDisable", function () { return (parcelRequire("9DnDL")).default; });
$parcel$export(module.exports, "dragEnable", function () { return (parcelRequire("9DnDL")).yesdrag; });

var $7EOps = parcelRequire("7EOps");

var $9DnDL = parcelRequire("9DnDL");

});
parcelRegister("7EOps", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59335f1d3e6fba33$export$2e2bcd8739ae039; });

var $1TJJe = parcelRequire("1TJJe");

var $fvaBb = parcelRequire("fvaBb");
var $5HV9y = parcelRequire("5HV9y");
var $ivpDr = parcelRequire("ivpDr");
var $lTUhy = parcelRequire("lTUhy");

var $9DnDL = parcelRequire("9DnDL");

var $8Jas9 = parcelRequire("8Jas9");

var $6zWKO = parcelRequire("6zWKO");

var $d5p9l = parcelRequire("d5p9l");
// Ignore right-click, since that should open the context menu.
function $59335f1d3e6fba33$var$defaultFilter() {
    return !(0, $fvaBb.event).ctrlKey && !(0, $fvaBb.event).button;
}
function $59335f1d3e6fba33$var$defaultContainer() {
    return this.parentNode;
}
function $59335f1d3e6fba33$var$defaultSubject(d) {
    return d == null ? {
        x: (0, $fvaBb.event).x,
        y: (0, $fvaBb.event).y
    } : d;
}
function $59335f1d3e6fba33$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $59335f1d3e6fba33$export$2e2bcd8739ae039() {
    var filter = $59335f1d3e6fba33$var$defaultFilter, container = $59335f1d3e6fba33$var$defaultContainer, subject = $59335f1d3e6fba33$var$defaultSubject, touchable = $59335f1d3e6fba33$var$defaultTouchable, gestures = {}, listeners = (0, $1TJJe.default)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
    function drag(selection) {
        selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    function mousedowned() {
        if (touchending || !filter.apply(this, arguments)) return;
        var gesture = beforestart("mouse", container.apply(this, arguments), (0, $5HV9y.default), this, arguments);
        if (!gesture) return;
        (0, $ivpDr.default)((0, $fvaBb.event).view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
        (0, $9DnDL.default)((0, $fvaBb.event).view);
        (0, $8Jas9.nopropagation)();
        mousemoving = false;
        mousedownx = (0, $fvaBb.event).clientX;
        mousedowny = (0, $fvaBb.event).clientY;
        gesture("start");
    }
    function mousemoved() {
        (0, $8Jas9.default)();
        if (!mousemoving) {
            var dx = (0, $fvaBb.event).clientX - mousedownx, dy = (0, $fvaBb.event).clientY - mousedowny;
            mousemoving = dx * dx + dy * dy > clickDistance2;
        }
        gestures.mouse("drag");
    }
    function mouseupped() {
        (0, $ivpDr.default)((0, $fvaBb.event).view).on("mousemove.drag mouseup.drag", null);
        (0, $9DnDL.yesdrag)((0, $fvaBb.event).view, mousemoving);
        (0, $8Jas9.default)();
        gestures.mouse("end");
    }
    function touchstarted() {
        if (!filter.apply(this, arguments)) return;
        var touches = (0, $fvaBb.event).changedTouches, c = container.apply(this, arguments), n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = beforestart(touches[i].identifier, c, (0, $lTUhy.default), this, arguments)) {
            (0, $8Jas9.nopropagation)();
            gesture("start");
        }
    }
    function touchmoved() {
        var touches = (0, $fvaBb.event).changedTouches, n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $8Jas9.default)();
            gesture("drag");
        }
    }
    function touchended() {
        var touches = (0, $fvaBb.event).changedTouches, n = touches.length, i, gesture;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, 500); // Ghost clicks are delayed!
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $8Jas9.nopropagation)();
            gesture("end");
        }
    }
    function beforestart(id, container, point, that, args) {
        var p = point(container, id), s, dx, dy, sublisteners = listeners.copy();
        if (!(0, $fvaBb.customEvent)(new (0, $d5p9l.default)(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
            if (((0, $fvaBb.event).subject = s = subject.apply(that, args)) == null) return false;
            dx = s.x - p[0] || 0;
            dy = s.y - p[1] || 0;
            return true;
        })) return;
        return function gesture(type) {
            var p0 = p, n;
            switch(type){
                case "start":
                    gestures[id] = gesture, n = active++;
                    break;
                case "end":
                    delete gestures[id], --active; // nobreak
                case "drag":
                    p = point(container, id), n = active;
                    break;
            }
            (0, $fvaBb.customEvent)(new (0, $d5p9l.default)(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [
                type,
                that,
                args
            ]);
        };
    }
    drag.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $6zWKO.default)(!!_), drag) : filter;
    };
    drag.container = function(_) {
        return arguments.length ? (container = typeof _ === "function" ? _ : (0, $6zWKO.default)(_), drag) : container;
    };
    drag.subject = function(_) {
        return arguments.length ? (subject = typeof _ === "function" ? _ : (0, $6zWKO.default)(_), drag) : subject;
    };
    drag.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $6zWKO.default)(!!_), drag) : touchable;
    };
    drag.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? drag : value;
    };
    drag.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
    };
    return drag;
}

});
parcelRegister("6zWKO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ca3964b5dc2f9bc$export$2e2bcd8739ae039; });
function $4ca3964b5dc2f9bc$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("d5p9l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $986f40392ba2d1c5$export$2e2bcd8739ae039; });
function $986f40392ba2d1c5$export$2e2bcd8739ae039(target, type, subject, id, active, x, y, dx, dy, dispatch) {
    this.target = target;
    this.type = type;
    this.subject = subject;
    this.identifier = id;
    this.active = active;
    this.x = x;
    this.y = y;
    this.dx = dx;
    this.dy = dy;
    this._ = dispatch;
}
$986f40392ba2d1c5$export$2e2bcd8739ae039.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};

});



parcelRegister("2RxIA", function(module, exports) {

$parcel$export(module.exports, "dsvFormat", function () { return (parcelRequire("h8ABk")).default; });
$parcel$export(module.exports, "csvParse", function () { return (parcelRequire("4PXJB")).csvParse; });
$parcel$export(module.exports, "csvParseRows", function () { return (parcelRequire("4PXJB")).csvParseRows; });
$parcel$export(module.exports, "csvFormat", function () { return (parcelRequire("4PXJB")).csvFormat; });
$parcel$export(module.exports, "csvFormatBody", function () { return (parcelRequire("4PXJB")).csvFormatBody; });
$parcel$export(module.exports, "csvFormatRows", function () { return (parcelRequire("4PXJB")).csvFormatRows; });
$parcel$export(module.exports, "csvFormatRow", function () { return (parcelRequire("4PXJB")).csvFormatRow; });
$parcel$export(module.exports, "csvFormatValue", function () { return (parcelRequire("4PXJB")).csvFormatValue; });
$parcel$export(module.exports, "tsvParse", function () { return (parcelRequire("4MaKZ")).tsvParse; });
$parcel$export(module.exports, "tsvParseRows", function () { return (parcelRequire("4MaKZ")).tsvParseRows; });
$parcel$export(module.exports, "tsvFormat", function () { return (parcelRequire("4MaKZ")).tsvFormat; });
$parcel$export(module.exports, "tsvFormatBody", function () { return (parcelRequire("4MaKZ")).tsvFormatBody; });
$parcel$export(module.exports, "tsvFormatRows", function () { return (parcelRequire("4MaKZ")).tsvFormatRows; });
$parcel$export(module.exports, "tsvFormatRow", function () { return (parcelRequire("4MaKZ")).tsvFormatRow; });
$parcel$export(module.exports, "tsvFormatValue", function () { return (parcelRequire("4MaKZ")).tsvFormatValue; });
$parcel$export(module.exports, "autoType", function () { return (parcelRequire("1efOH")).default; });

var $h8ABk = parcelRequire("h8ABk");

var $4PXJB = parcelRequire("4PXJB");

var $4MaKZ = parcelRequire("4MaKZ");

var $1efOH = parcelRequire("1efOH");

});
parcelRegister("h8ABk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c79f934063ee5283$export$2e2bcd8739ae039; });
var $c79f934063ee5283$var$EOL = {}, $c79f934063ee5283$var$EOF = {}, $c79f934063ee5283$var$QUOTE = 34, $c79f934063ee5283$var$NEWLINE = 10, $c79f934063ee5283$var$RETURN = 13;
function $c79f934063ee5283$var$objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + '] || ""';
    }).join(",") + "}");
}
function $c79f934063ee5283$var$customConverter(columns, f) {
    var object = $c79f934063ee5283$var$objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function $c79f934063ee5283$var$inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function $c79f934063ee5283$var$pad(value, width) {
    var s = value + "", length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function $c79f934063ee5283$var$formatYear(year) {
    return year < 0 ? "-" + $c79f934063ee5283$var$pad(-year, 6) : year > 9999 ? "+" + $c79f934063ee5283$var$pad(year, 6) : $c79f934063ee5283$var$pad(year, 4);
}
function $c79f934063ee5283$var$formatDate(date) {
    var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : $c79f934063ee5283$var$formatYear(date.getUTCFullYear(), 4) + "-" + $c79f934063ee5283$var$pad(date.getUTCMonth() + 1, 2) + "-" + $c79f934063ee5283$var$pad(date.getUTCDate(), 2) + (milliseconds ? "T" + $c79f934063ee5283$var$pad(hours, 2) + ":" + $c79f934063ee5283$var$pad(minutes, 2) + ":" + $c79f934063ee5283$var$pad(seconds, 2) + "." + $c79f934063ee5283$var$pad(milliseconds, 3) + "Z" : seconds ? "T" + $c79f934063ee5283$var$pad(hours, 2) + ":" + $c79f934063ee5283$var$pad(minutes, 2) + ":" + $c79f934063ee5283$var$pad(seconds, 2) + "Z" : minutes || hours ? "T" + $c79f934063ee5283$var$pad(hours, 2) + ":" + $c79f934063ee5283$var$pad(minutes, 2) + "Z" : "");
}
function $c79f934063ee5283$export$2e2bcd8739ae039(delimiter) {
    var reFormat = new RegExp('["' + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
    function parse(text, f) {
        var convert, columns, rows = parseRows(text, function(row, i) {
            if (convert) return convert(row, i - 1);
            columns = row, convert = f ? $c79f934063ee5283$var$customConverter(row, f) : $c79f934063ee5283$var$objectConverter(row);
        });
        rows.columns = columns || [];
        return rows;
    }
    function parseRows(text, f) {
        var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
        // Strip the trailing newline.
        if (text.charCodeAt(N - 1) === $c79f934063ee5283$var$NEWLINE) --N;
        if (text.charCodeAt(N - 1) === $c79f934063ee5283$var$RETURN) --N;
        function token() {
            if (eof) return $c79f934063ee5283$var$EOF;
            if (eol) return eol = false, $c79f934063ee5283$var$EOL;
            // Unescape quotes.
            var i, j = I, c;
            if (text.charCodeAt(j) === $c79f934063ee5283$var$QUOTE) {
                while(I++ < N && text.charCodeAt(I) !== $c79f934063ee5283$var$QUOTE || text.charCodeAt(++I) === $c79f934063ee5283$var$QUOTE);
                if ((i = I) >= N) eof = true;
                else if ((c = text.charCodeAt(I++)) === $c79f934063ee5283$var$NEWLINE) eol = true;
                else if (c === $c79f934063ee5283$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $c79f934063ee5283$var$NEWLINE) ++I;
                }
                return text.slice(j + 1, i - 1).replace(/""/g, '"');
            }
            // Find next delimiter or newline.
            while(I < N){
                if ((c = text.charCodeAt(i = I++)) === $c79f934063ee5283$var$NEWLINE) eol = true;
                else if (c === $c79f934063ee5283$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $c79f934063ee5283$var$NEWLINE) ++I;
                } else if (c !== DELIMITER) continue;
                return text.slice(j, i);
            }
            // Return last token before EOF.
            return eof = true, text.slice(j, N);
        }
        while((t = token()) !== $c79f934063ee5283$var$EOF){
            var row = [];
            while(t !== $c79f934063ee5283$var$EOL && t !== $c79f934063ee5283$var$EOF)row.push(t), t = token();
            if (f && (row = f(row, n++)) == null) continue;
            rows.push(row);
        }
        return rows;
    }
    function preformatBody(rows, columns) {
        return rows.map(function(row) {
            return columns.map(function(column) {
                return formatValue(row[column]);
            }).join(delimiter);
        });
    }
    function format(rows, columns) {
        if (columns == null) columns = $c79f934063ee5283$var$inferColumns(rows);
        return [
            columns.map(formatValue).join(delimiter)
        ].concat(preformatBody(rows, columns)).join("\n");
    }
    function formatBody(rows, columns) {
        if (columns == null) columns = $c79f934063ee5283$var$inferColumns(rows);
        return preformatBody(rows, columns).join("\n");
    }
    function formatRows(rows) {
        return rows.map(formatRow).join("\n");
    }
    function formatRow(row) {
        return row.map(formatValue).join(delimiter);
    }
    function formatValue(value) {
        return value == null ? "" : value instanceof Date ? $c79f934063ee5283$var$formatDate(value) : reFormat.test(value += "") ? '"' + value.replace(/"/g, '""') + '"' : value;
    }
    return {
        parse: parse,
        parseRows: parseRows,
        format: format,
        formatBody: formatBody,
        formatRows: formatRows,
        formatRow: formatRow,
        formatValue: formatValue
    };
}

});

parcelRegister("4PXJB", function(module, exports) {

$parcel$export(module.exports, "csvParse", function () { return $385a42e57d753057$export$289d25497b0f4c16; });
$parcel$export(module.exports, "csvParseRows", function () { return $385a42e57d753057$export$c82550ca942d869; });
$parcel$export(module.exports, "csvFormat", function () { return $385a42e57d753057$export$afe767551074aa08; });
$parcel$export(module.exports, "csvFormatBody", function () { return $385a42e57d753057$export$b46fa59a5e3bc8a2; });
$parcel$export(module.exports, "csvFormatRows", function () { return $385a42e57d753057$export$3f42a65843fbd1d9; });
$parcel$export(module.exports, "csvFormatRow", function () { return $385a42e57d753057$export$c30212b87b2d080f; });
$parcel$export(module.exports, "csvFormatValue", function () { return $385a42e57d753057$export$2771de09a60fc648; });

var $h8ABk = parcelRequire("h8ABk");
var $385a42e57d753057$var$csv = (0, $h8ABk.default)(",");
var $385a42e57d753057$export$289d25497b0f4c16 = $385a42e57d753057$var$csv.parse;
var $385a42e57d753057$export$c82550ca942d869 = $385a42e57d753057$var$csv.parseRows;
var $385a42e57d753057$export$afe767551074aa08 = $385a42e57d753057$var$csv.format;
var $385a42e57d753057$export$b46fa59a5e3bc8a2 = $385a42e57d753057$var$csv.formatBody;
var $385a42e57d753057$export$3f42a65843fbd1d9 = $385a42e57d753057$var$csv.formatRows;
var $385a42e57d753057$export$c30212b87b2d080f = $385a42e57d753057$var$csv.formatRow;
var $385a42e57d753057$export$2771de09a60fc648 = $385a42e57d753057$var$csv.formatValue;

});

parcelRegister("4MaKZ", function(module, exports) {

$parcel$export(module.exports, "tsvParse", function () { return $37a3fd36f3bc9f2a$export$f913251db2f734ee; });
$parcel$export(module.exports, "tsvParseRows", function () { return $37a3fd36f3bc9f2a$export$8de3b5abc40a067f; });
$parcel$export(module.exports, "tsvFormat", function () { return $37a3fd36f3bc9f2a$export$77e754c4f8504293; });
$parcel$export(module.exports, "tsvFormatBody", function () { return $37a3fd36f3bc9f2a$export$9d44987d460c9cb3; });
$parcel$export(module.exports, "tsvFormatRows", function () { return $37a3fd36f3bc9f2a$export$ae461973f6adc981; });
$parcel$export(module.exports, "tsvFormatRow", function () { return $37a3fd36f3bc9f2a$export$5d61cf35a4a738d2; });
$parcel$export(module.exports, "tsvFormatValue", function () { return $37a3fd36f3bc9f2a$export$4280e6a416cd92a3; });

var $h8ABk = parcelRequire("h8ABk");
var $37a3fd36f3bc9f2a$var$tsv = (0, $h8ABk.default)("	");
var $37a3fd36f3bc9f2a$export$f913251db2f734ee = $37a3fd36f3bc9f2a$var$tsv.parse;
var $37a3fd36f3bc9f2a$export$8de3b5abc40a067f = $37a3fd36f3bc9f2a$var$tsv.parseRows;
var $37a3fd36f3bc9f2a$export$77e754c4f8504293 = $37a3fd36f3bc9f2a$var$tsv.format;
var $37a3fd36f3bc9f2a$export$9d44987d460c9cb3 = $37a3fd36f3bc9f2a$var$tsv.formatBody;
var $37a3fd36f3bc9f2a$export$ae461973f6adc981 = $37a3fd36f3bc9f2a$var$tsv.formatRows;
var $37a3fd36f3bc9f2a$export$5d61cf35a4a738d2 = $37a3fd36f3bc9f2a$var$tsv.formatRow;
var $37a3fd36f3bc9f2a$export$4280e6a416cd92a3 = $37a3fd36f3bc9f2a$var$tsv.formatValue;

});

parcelRegister("1efOH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e535e1df270098e$export$2e2bcd8739ae039; });
function $0e535e1df270098e$export$2e2bcd8739ae039(object) {
    for(var key in object){
        var value = object[key].trim(), number, m;
        if (!value) value = null;
        else if (value === "true") value = true;
        else if (value === "false") value = false;
        else if (value === "NaN") value = NaN;
        else if (!isNaN(number = +value)) value = number;
        else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
            if ($0e535e1df270098e$var$fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
            value = new Date(value);
        } else continue;
        object[key] = value;
    }
    return object;
}
// https://github.com/d3/d3-dsv/issues/45
var $0e535e1df270098e$var$fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();

});


parcelRegister("2cX1W", function(module, exports) {

$parcel$export(module.exports, "easeLinear", function () { return (parcelRequire("gc1Mg")).linear; });
$parcel$export(module.exports, "easeQuad", function () { return (parcelRequire("dB7kX")).quadInOut; });
$parcel$export(module.exports, "easeQuadIn", function () { return (parcelRequire("dB7kX")).quadIn; });
$parcel$export(module.exports, "easeQuadOut", function () { return (parcelRequire("dB7kX")).quadOut; });
$parcel$export(module.exports, "easeQuadInOut", function () { return (parcelRequire("dB7kX")).quadInOut; });
$parcel$export(module.exports, "easeCubic", function () { return (parcelRequire("btL80")).cubicInOut; });
$parcel$export(module.exports, "easeCubicIn", function () { return (parcelRequire("btL80")).cubicIn; });
$parcel$export(module.exports, "easeCubicOut", function () { return (parcelRequire("btL80")).cubicOut; });
$parcel$export(module.exports, "easeCubicInOut", function () { return (parcelRequire("btL80")).cubicInOut; });
$parcel$export(module.exports, "easePoly", function () { return (parcelRequire("gojib")).polyInOut; });
$parcel$export(module.exports, "easePolyIn", function () { return (parcelRequire("gojib")).polyIn; });
$parcel$export(module.exports, "easePolyOut", function () { return (parcelRequire("gojib")).polyOut; });
$parcel$export(module.exports, "easePolyInOut", function () { return (parcelRequire("gojib")).polyInOut; });
$parcel$export(module.exports, "easeSin", function () { return (parcelRequire("a61Le")).sinInOut; });
$parcel$export(module.exports, "easeSinIn", function () { return (parcelRequire("a61Le")).sinIn; });
$parcel$export(module.exports, "easeSinOut", function () { return (parcelRequire("a61Le")).sinOut; });
$parcel$export(module.exports, "easeSinInOut", function () { return (parcelRequire("a61Le")).sinInOut; });
$parcel$export(module.exports, "easeExp", function () { return (parcelRequire("ikaQo")).expInOut; });
$parcel$export(module.exports, "easeExpIn", function () { return (parcelRequire("ikaQo")).expIn; });
$parcel$export(module.exports, "easeExpOut", function () { return (parcelRequire("ikaQo")).expOut; });
$parcel$export(module.exports, "easeExpInOut", function () { return (parcelRequire("ikaQo")).expInOut; });
$parcel$export(module.exports, "easeCircle", function () { return (parcelRequire("4vx16")).circleInOut; });
$parcel$export(module.exports, "easeCircleIn", function () { return (parcelRequire("4vx16")).circleIn; });
$parcel$export(module.exports, "easeCircleOut", function () { return (parcelRequire("4vx16")).circleOut; });
$parcel$export(module.exports, "easeCircleInOut", function () { return (parcelRequire("4vx16")).circleInOut; });
$parcel$export(module.exports, "easeBounce", function () { return (parcelRequire("i3Nqz")).bounceOut; });
$parcel$export(module.exports, "easeBounceIn", function () { return (parcelRequire("i3Nqz")).bounceIn; });
$parcel$export(module.exports, "easeBounceOut", function () { return (parcelRequire("i3Nqz")).bounceOut; });
$parcel$export(module.exports, "easeBounceInOut", function () { return (parcelRequire("i3Nqz")).bounceInOut; });
$parcel$export(module.exports, "easeBack", function () { return (parcelRequire("9TSMF")).backInOut; });
$parcel$export(module.exports, "easeBackIn", function () { return (parcelRequire("9TSMF")).backIn; });
$parcel$export(module.exports, "easeBackOut", function () { return (parcelRequire("9TSMF")).backOut; });
$parcel$export(module.exports, "easeBackInOut", function () { return (parcelRequire("9TSMF")).backInOut; });
$parcel$export(module.exports, "easeElastic", function () { return (parcelRequire("chvEY")).elasticOut; });
$parcel$export(module.exports, "easeElasticIn", function () { return (parcelRequire("chvEY")).elasticIn; });
$parcel$export(module.exports, "easeElasticOut", function () { return (parcelRequire("chvEY")).elasticOut; });
$parcel$export(module.exports, "easeElasticInOut", function () { return (parcelRequire("chvEY")).elasticInOut; });

var $gc1Mg = parcelRequire("gc1Mg");

var $dB7kX = parcelRequire("dB7kX");

var $btL80 = parcelRequire("btL80");

var $gojib = parcelRequire("gojib");

var $a61Le = parcelRequire("a61Le");

var $ikaQo = parcelRequire("ikaQo");

var $4vx16 = parcelRequire("4vx16");

var $i3Nqz = parcelRequire("i3Nqz");

var $9TSMF = parcelRequire("9TSMF");

var $chvEY = parcelRequire("chvEY");

});
parcelRegister("gc1Mg", function(module, exports) {

$parcel$export(module.exports, "linear", function () { return $bc9f254d63118d8e$export$45db2fc2f15997e7; });
function $bc9f254d63118d8e$export$45db2fc2f15997e7(t) {
    return +t;
}

});

parcelRegister("dB7kX", function(module, exports) {

$parcel$export(module.exports, "quadIn", function () { return $9e646c0859c39973$export$5118fc7a1e64441b; });
$parcel$export(module.exports, "quadOut", function () { return $9e646c0859c39973$export$5be5f5e804d0b60c; });
$parcel$export(module.exports, "quadInOut", function () { return $9e646c0859c39973$export$d6ded66933892ed3; });
function $9e646c0859c39973$export$5118fc7a1e64441b(t) {
    return t * t;
}
function $9e646c0859c39973$export$5be5f5e804d0b60c(t) {
    return t * (2 - t);
}
function $9e646c0859c39973$export$d6ded66933892ed3(t) {
    return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

});

parcelRegister("gojib", function(module, exports) {

$parcel$export(module.exports, "polyIn", function () { return $beedda42abb5563e$export$aa0b5c3ce2df9d7d; });
$parcel$export(module.exports, "polyOut", function () { return $beedda42abb5563e$export$e3d987a417dc6640; });
$parcel$export(module.exports, "polyInOut", function () { return $beedda42abb5563e$export$ae94c6a40058b429; });
var $beedda42abb5563e$var$exponent = 3;
var $beedda42abb5563e$export$aa0b5c3ce2df9d7d = function custom(e) {
    e = +e;
    function polyIn(t) {
        return Math.pow(t, e);
    }
    polyIn.exponent = custom;
    return polyIn;
}($beedda42abb5563e$var$exponent);
var $beedda42abb5563e$export$e3d987a417dc6640 = function custom(e) {
    e = +e;
    function polyOut(t) {
        return 1 - Math.pow(1 - t, e);
    }
    polyOut.exponent = custom;
    return polyOut;
}($beedda42abb5563e$var$exponent);
var $beedda42abb5563e$export$ae94c6a40058b429 = function custom(e) {
    e = +e;
    function polyInOut(t) {
        return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
    }
    polyInOut.exponent = custom;
    return polyInOut;
}($beedda42abb5563e$var$exponent);

});

parcelRegister("a61Le", function(module, exports) {

$parcel$export(module.exports, "sinIn", function () { return $759bd492d9844e3c$export$a83a280f8d31ba8d; });
$parcel$export(module.exports, "sinOut", function () { return $759bd492d9844e3c$export$62ec6410ca53f2a7; });
$parcel$export(module.exports, "sinInOut", function () { return $759bd492d9844e3c$export$ff58b604d3ba15ba; });
var $759bd492d9844e3c$var$pi = Math.PI, $759bd492d9844e3c$var$halfPi = $759bd492d9844e3c$var$pi / 2;
function $759bd492d9844e3c$export$a83a280f8d31ba8d(t) {
    return +t === 1 ? 1 : 1 - Math.cos(t * $759bd492d9844e3c$var$halfPi);
}
function $759bd492d9844e3c$export$62ec6410ca53f2a7(t) {
    return Math.sin(t * $759bd492d9844e3c$var$halfPi);
}
function $759bd492d9844e3c$export$ff58b604d3ba15ba(t) {
    return (1 - Math.cos($759bd492d9844e3c$var$pi * t)) / 2;
}

});

parcelRegister("ikaQo", function(module, exports) {

$parcel$export(module.exports, "expIn", function () { return $d57281a460b25e4e$export$fc3e95f15e1ef38e; });
$parcel$export(module.exports, "expOut", function () { return $d57281a460b25e4e$export$f3c9b2f85fbcf0ab; });
$parcel$export(module.exports, "expInOut", function () { return $d57281a460b25e4e$export$ae4d4e77fab188ff; });

var $kVquy = parcelRequire("kVquy");
function $d57281a460b25e4e$export$fc3e95f15e1ef38e(t) {
    return (0, $kVquy.tpmt)(1 - +t);
}
function $d57281a460b25e4e$export$f3c9b2f85fbcf0ab(t) {
    return 1 - (0, $kVquy.tpmt)(t);
}
function $d57281a460b25e4e$export$ae4d4e77fab188ff(t) {
    return ((t *= 2) <= 1 ? (0, $kVquy.tpmt)(1 - t) : 2 - (0, $kVquy.tpmt)(t - 1)) / 2;
}

});
parcelRegister("kVquy", function(module, exports) {

$parcel$export(module.exports, "tpmt", function () { return $f3bdae386e65f240$export$be3f0f7224794b88; });
// tpmt is two power minus ten times t scaled to [0,1]
function $f3bdae386e65f240$export$be3f0f7224794b88(x) {
    return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}

});


parcelRegister("4vx16", function(module, exports) {

$parcel$export(module.exports, "circleIn", function () { return $3483ab240c2d6f6a$export$9f82a71b0377c018; });
$parcel$export(module.exports, "circleOut", function () { return $3483ab240c2d6f6a$export$27989e665abef2c8; });
$parcel$export(module.exports, "circleInOut", function () { return $3483ab240c2d6f6a$export$2d757ff9ad09038f; });
function $3483ab240c2d6f6a$export$9f82a71b0377c018(t) {
    return 1 - Math.sqrt(1 - t * t);
}
function $3483ab240c2d6f6a$export$27989e665abef2c8(t) {
    return Math.sqrt(1 - --t * t);
}
function $3483ab240c2d6f6a$export$2d757ff9ad09038f(t) {
    return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

});

parcelRegister("i3Nqz", function(module, exports) {

$parcel$export(module.exports, "bounceIn", function () { return $d25ed91d0244c6e5$export$fccebd7948554554; });
$parcel$export(module.exports, "bounceOut", function () { return $d25ed91d0244c6e5$export$cccc9e04465dce11; });
$parcel$export(module.exports, "bounceInOut", function () { return $d25ed91d0244c6e5$export$41ad9e9849a703ce; });
var $d25ed91d0244c6e5$var$b1 = 4 / 11, $d25ed91d0244c6e5$var$b2 = 6 / 11, $d25ed91d0244c6e5$var$b3 = 8 / 11, $d25ed91d0244c6e5$var$b4 = 3 / 4, $d25ed91d0244c6e5$var$b5 = 9 / 11, $d25ed91d0244c6e5$var$b6 = 10 / 11, $d25ed91d0244c6e5$var$b7 = 15 / 16, $d25ed91d0244c6e5$var$b8 = 21 / 22, $d25ed91d0244c6e5$var$b9 = 63 / 64, $d25ed91d0244c6e5$var$b0 = 1 / $d25ed91d0244c6e5$var$b1 / $d25ed91d0244c6e5$var$b1;
function $d25ed91d0244c6e5$export$fccebd7948554554(t) {
    return 1 - $d25ed91d0244c6e5$export$cccc9e04465dce11(1 - t);
}
function $d25ed91d0244c6e5$export$cccc9e04465dce11(t) {
    return (t = +t) < $d25ed91d0244c6e5$var$b1 ? $d25ed91d0244c6e5$var$b0 * t * t : t < $d25ed91d0244c6e5$var$b3 ? $d25ed91d0244c6e5$var$b0 * (t -= $d25ed91d0244c6e5$var$b2) * t + $d25ed91d0244c6e5$var$b4 : t < $d25ed91d0244c6e5$var$b6 ? $d25ed91d0244c6e5$var$b0 * (t -= $d25ed91d0244c6e5$var$b5) * t + $d25ed91d0244c6e5$var$b7 : $d25ed91d0244c6e5$var$b0 * (t -= $d25ed91d0244c6e5$var$b8) * t + $d25ed91d0244c6e5$var$b9;
}
function $d25ed91d0244c6e5$export$41ad9e9849a703ce(t) {
    return ((t *= 2) <= 1 ? 1 - $d25ed91d0244c6e5$export$cccc9e04465dce11(1 - t) : $d25ed91d0244c6e5$export$cccc9e04465dce11(t - 1) + 1) / 2;
}

});

parcelRegister("9TSMF", function(module, exports) {

$parcel$export(module.exports, "backIn", function () { return $7353bf0ed3818cfd$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backOut", function () { return $7353bf0ed3818cfd$export$77edfce482316a60; });
$parcel$export(module.exports, "backInOut", function () { return $7353bf0ed3818cfd$export$ddc5fd596f6c71b2; });
var $7353bf0ed3818cfd$var$overshoot = 1.70158;
var $7353bf0ed3818cfd$export$b01116c84cdfe1a2 = function custom(s) {
    s = +s;
    function backIn(t) {
        return (t = +t) * t * (s * (t - 1) + t);
    }
    backIn.overshoot = custom;
    return backIn;
}($7353bf0ed3818cfd$var$overshoot);
var $7353bf0ed3818cfd$export$77edfce482316a60 = function custom(s) {
    s = +s;
    function backOut(t) {
        return --t * t * ((t + 1) * s + t) + 1;
    }
    backOut.overshoot = custom;
    return backOut;
}($7353bf0ed3818cfd$var$overshoot);
var $7353bf0ed3818cfd$export$ddc5fd596f6c71b2 = function custom(s) {
    s = +s;
    function backInOut(t) {
        return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
    }
    backInOut.overshoot = custom;
    return backInOut;
}($7353bf0ed3818cfd$var$overshoot);

});

parcelRegister("chvEY", function(module, exports) {

$parcel$export(module.exports, "elasticIn", function () { return $8f0fa191401b86a4$export$41f42134872a5fa0; });
$parcel$export(module.exports, "elasticOut", function () { return $8f0fa191401b86a4$export$ed1782b99e69bbc8; });
$parcel$export(module.exports, "elasticInOut", function () { return $8f0fa191401b86a4$export$309de4f35f218bfd; });

var $kVquy = parcelRequire("kVquy");
var $8f0fa191401b86a4$var$tau = 2 * Math.PI, $8f0fa191401b86a4$var$amplitude = 1, $8f0fa191401b86a4$var$period = 0.3;
var $8f0fa191401b86a4$export$41f42134872a5fa0 = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $8f0fa191401b86a4$var$tau);
    function elasticIn(t) {
        return a * (0, $kVquy.tpmt)(- --t) * Math.sin((s - t) / p);
    }
    elasticIn.amplitude = function(a) {
        return custom(a, p * $8f0fa191401b86a4$var$tau);
    };
    elasticIn.period = function(p) {
        return custom(a, p);
    };
    return elasticIn;
}($8f0fa191401b86a4$var$amplitude, $8f0fa191401b86a4$var$period);
var $8f0fa191401b86a4$export$ed1782b99e69bbc8 = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $8f0fa191401b86a4$var$tau);
    function elasticOut(t) {
        return 1 - a * (0, $kVquy.tpmt)(t = +t) * Math.sin((t + s) / p);
    }
    elasticOut.amplitude = function(a) {
        return custom(a, p * $8f0fa191401b86a4$var$tau);
    };
    elasticOut.period = function(p) {
        return custom(a, p);
    };
    return elasticOut;
}($8f0fa191401b86a4$var$amplitude, $8f0fa191401b86a4$var$period);
var $8f0fa191401b86a4$export$309de4f35f218bfd = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $8f0fa191401b86a4$var$tau);
    function elasticInOut(t) {
        return ((t = t * 2 - 1) < 0 ? a * (0, $kVquy.tpmt)(-t) * Math.sin((s - t) / p) : 2 - a * (0, $kVquy.tpmt)(t) * Math.sin((s + t) / p)) / 2;
    }
    elasticInOut.amplitude = function(a) {
        return custom(a, p * $8f0fa191401b86a4$var$tau);
    };
    elasticInOut.period = function(p) {
        return custom(a, p);
    };
    return elasticInOut;
}($8f0fa191401b86a4$var$amplitude, $8f0fa191401b86a4$var$period);

});


parcelRegister("8cSF4", function(module, exports) {

$parcel$export(module.exports, "blob", function () { return (parcelRequire("5xN0I")).default; });
$parcel$export(module.exports, "buffer", function () { return (parcelRequire("9Vn2W")).default; });
$parcel$export(module.exports, "dsv", function () { return (parcelRequire("fSLvU")).default; });
$parcel$export(module.exports, "csv", function () { return (parcelRequire("fSLvU")).csv; });
$parcel$export(module.exports, "tsv", function () { return (parcelRequire("fSLvU")).tsv; });
$parcel$export(module.exports, "image", function () { return (parcelRequire("jjcFl")).default; });
$parcel$export(module.exports, "json", function () { return (parcelRequire("8ZXdt")).default; });
$parcel$export(module.exports, "text", function () { return (parcelRequire("iksnb")).default; });
$parcel$export(module.exports, "xml", function () { return (parcelRequire("8BQfP")).default; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("8BQfP")).html; });
$parcel$export(module.exports, "svg", function () { return (parcelRequire("8BQfP")).svg; });

var $5xN0I = parcelRequire("5xN0I");

var $9Vn2W = parcelRequire("9Vn2W");

var $fSLvU = parcelRequire("fSLvU");

var $jjcFl = parcelRequire("jjcFl");

var $8ZXdt = parcelRequire("8ZXdt");

var $iksnb = parcelRequire("iksnb");

var $8BQfP = parcelRequire("8BQfP");

});
parcelRegister("5xN0I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40960d4b7dd4a4b8$export$2e2bcd8739ae039; });
function $40960d4b7dd4a4b8$var$responseBlob(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.blob();
}
function $40960d4b7dd4a4b8$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($40960d4b7dd4a4b8$var$responseBlob);
}

});

parcelRegister("9Vn2W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $739b507cb965fb3a$export$2e2bcd8739ae039; });
function $739b507cb965fb3a$var$responseArrayBuffer(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.arrayBuffer();
}
function $739b507cb965fb3a$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($739b507cb965fb3a$var$responseArrayBuffer);
}

});

parcelRegister("fSLvU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b900c1645ac87212$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "csv", function () { return $b900c1645ac87212$export$901ba78aa04f49da; });
$parcel$export(module.exports, "tsv", function () { return $b900c1645ac87212$export$580b2de76423ff18; });

var $4PXJB = parcelRequire("4PXJB");
var $h8ABk = parcelRequire("h8ABk");
var $4MaKZ = parcelRequire("4MaKZ");

var $iksnb = parcelRequire("iksnb");
function $b900c1645ac87212$var$dsvParse(parse) {
    return function(input, init, row) {
        if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
        return (0, $iksnb.default)(input, init).then(function(response) {
            return parse(response, row);
        });
    };
}
function $b900c1645ac87212$export$2e2bcd8739ae039(delimiter, input, init, row) {
    if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
    var format = (0, $h8ABk.default)(delimiter);
    return (0, $iksnb.default)(input, init).then(function(response) {
        return format.parse(response, row);
    });
}
var $b900c1645ac87212$export$901ba78aa04f49da = $b900c1645ac87212$var$dsvParse((0, $4PXJB.csvParse));
var $b900c1645ac87212$export$580b2de76423ff18 = $b900c1645ac87212$var$dsvParse((0, $4MaKZ.tsvParse));

});
parcelRegister("iksnb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5801a81ae51d1a4$export$2e2bcd8739ae039; });
function $d5801a81ae51d1a4$var$responseText(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.text();
}
function $d5801a81ae51d1a4$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($d5801a81ae51d1a4$var$responseText);
}

});


parcelRegister("jjcFl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0e99dd81a61b3df$export$2e2bcd8739ae039; });
function $e0e99dd81a61b3df$export$2e2bcd8739ae039(input, init) {
    return new Promise(function(resolve, reject) {
        var image = new Image;
        for(var key in init)image[key] = init[key];
        image.onerror = reject;
        image.onload = function() {
            resolve(image);
        };
        image.src = input;
    });
}

});

parcelRegister("8ZXdt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68d1f4605b868e5f$export$2e2bcd8739ae039; });
function $68d1f4605b868e5f$var$responseJson(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    if (response.status === 204 || response.status === 205) return;
    return response.json();
}
function $68d1f4605b868e5f$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($68d1f4605b868e5f$var$responseJson);
}

});

parcelRegister("8BQfP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $644a5008bb144a9a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "html", function () { return $644a5008bb144a9a$export$c0bb0b647f701bb5; });
$parcel$export(module.exports, "svg", function () { return $644a5008bb144a9a$export$7ed1367e7fa1ad68; });

var $iksnb = parcelRequire("iksnb");
function $644a5008bb144a9a$var$parser(type) {
    return function(input, init) {
        return (0, $iksnb.default)(input, init).then(function(text) {
            return (new DOMParser).parseFromString(text, type);
        });
    };
}
var $644a5008bb144a9a$export$2e2bcd8739ae039 = $644a5008bb144a9a$var$parser("application/xml");
var $644a5008bb144a9a$export$c0bb0b647f701bb5 = $644a5008bb144a9a$var$parser("text/html");
var $644a5008bb144a9a$export$7ed1367e7fa1ad68 = $644a5008bb144a9a$var$parser("image/svg+xml");

});


parcelRegister("dmw9p", function(module, exports) {

$parcel$export(module.exports, "forceCenter", function () { return (parcelRequire("l3dD2")).default; });
$parcel$export(module.exports, "forceCollide", function () { return (parcelRequire("jyoOO")).default; });
$parcel$export(module.exports, "forceLink", function () { return (parcelRequire("axZKH")).default; });
$parcel$export(module.exports, "forceManyBody", function () { return (parcelRequire("fuMCb")).default; });
$parcel$export(module.exports, "forceRadial", function () { return (parcelRequire("iItgv")).default; });
$parcel$export(module.exports, "forceSimulation", function () { return (parcelRequire("dxZuf")).default; });
$parcel$export(module.exports, "forceX", function () { return (parcelRequire("8i1cn")).default; });
$parcel$export(module.exports, "forceY", function () { return (parcelRequire("6W1Cs")).default; });

var $l3dD2 = parcelRequire("l3dD2");

var $jyoOO = parcelRequire("jyoOO");

var $axZKH = parcelRequire("axZKH");

var $fuMCb = parcelRequire("fuMCb");

var $iItgv = parcelRequire("iItgv");

var $dxZuf = parcelRequire("dxZuf");

var $8i1cn = parcelRequire("8i1cn");

var $6W1Cs = parcelRequire("6W1Cs");

});
parcelRegister("l3dD2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5347323deb8dfca$export$2e2bcd8739ae039; });
function $f5347323deb8dfca$export$2e2bcd8739ae039(x, y) {
    var nodes;
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force() {
        var i, n = nodes.length, node, sx = 0, sy = 0;
        for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
        for(sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
    }
    force.initialize = function(_) {
        nodes = _;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    return force;
}

});

parcelRegister("jyoOO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3c471c1d5c3dc07$export$2e2bcd8739ae039; });

var $93ZNi = parcelRequire("93ZNi");

var $clxGu = parcelRequire("clxGu");

var $js6v0 = parcelRequire("js6v0");
function $e3c471c1d5c3dc07$var$x(d) {
    return d.x + d.vx;
}
function $e3c471c1d5c3dc07$var$y(d) {
    return d.y + d.vy;
}
function $e3c471c1d5c3dc07$export$2e2bcd8739ae039(radius) {
    var nodes, radii, strength = 1, iterations = 1;
    if (typeof radius !== "function") radius = (0, $93ZNi.default)(radius == null ? 1 : +radius);
    function force() {
        var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
        for(var k = 0; k < iterations; ++k){
            tree = (0, $js6v0.default)(nodes, $e3c471c1d5c3dc07$var$x, $e3c471c1d5c3dc07$var$y).visitAfter(prepare);
            for(i = 0; i < n; ++i){
                node = nodes[i];
                ri = radii[node.index], ri2 = ri * ri;
                xi = node.x + node.vx;
                yi = node.y + node.vy;
                tree.visit(apply);
            }
        }
        function apply(quad, x0, y0, x1, y1) {
            var data = quad.data, rj = quad.r, r = ri + rj;
            if (data) {
                if (data.index > node.index) {
                    var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                    if (l < r * r) {
                        if (x === 0) x = (0, $clxGu.default)(), l += x * x;
                        if (y === 0) y = (0, $clxGu.default)(), l += y * y;
                        l = (r - (l = Math.sqrt(l))) / l * strength;
                        node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                        node.vy += (y *= l) * r;
                        data.vx -= x * (r = 1 - r);
                        data.vy -= y * r;
                    }
                }
                return;
            }
            return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
        }
    }
    function prepare(quad) {
        if (quad.data) return quad.r = radii[quad.data.index];
        for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        radii = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $93ZNi.default)(+_), initialize(), force) : radius;
    };
    return force;
}

});
parcelRegister("93ZNi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $699453e56ac8ebe0$export$2e2bcd8739ae039; });
function $699453e56ac8ebe0$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("clxGu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fd19336467930e0$export$2e2bcd8739ae039; });
function $8fd19336467930e0$export$2e2bcd8739ae039() {
    return (Math.random() - 0.5) * 1e-6;
}

});

parcelRegister("js6v0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e295ac71102bbe1d$export$2e2bcd8739ae039; });

var $cum3A = parcelRequire("cum3A");

var $1HNmA = parcelRequire("1HNmA");

var $B9EKH = parcelRequire("B9EKH");

var $9DIl6 = parcelRequire("9DIl6");

var $dzeqI = parcelRequire("dzeqI");

var $lBgya = parcelRequire("lBgya");

var $l27Vn = parcelRequire("l27Vn");

var $hmdO5 = parcelRequire("hmdO5");

var $6dXIu = parcelRequire("6dXIu");

var $k49Zh = parcelRequire("k49Zh");

var $cH28F = parcelRequire("cH28F");

var $552f2 = parcelRequire("552f2");
function $e295ac71102bbe1d$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $e295ac71102bbe1d$var$Quadtree(x == null ? (0, $cH28F.defaultX) : x, y == null ? (0, $552f2.defaultY) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $e295ac71102bbe1d$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $e295ac71102bbe1d$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $e295ac71102bbe1d$var$treeProto = $e295ac71102bbe1d$export$2e2bcd8739ae039.prototype = $e295ac71102bbe1d$var$Quadtree.prototype;
$e295ac71102bbe1d$var$treeProto.copy = function() {
    var copy = new $e295ac71102bbe1d$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $e295ac71102bbe1d$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $e295ac71102bbe1d$var$leaf_copy(child);
        }
    }
    return copy;
};
$e295ac71102bbe1d$var$treeProto.add = (0, $cum3A.default);
$e295ac71102bbe1d$var$treeProto.addAll = (0, $cum3A.addAll);
$e295ac71102bbe1d$var$treeProto.cover = (0, $1HNmA.default);
$e295ac71102bbe1d$var$treeProto.data = (0, $B9EKH.default);
$e295ac71102bbe1d$var$treeProto.extent = (0, $9DIl6.default);
$e295ac71102bbe1d$var$treeProto.find = (0, $dzeqI.default);
$e295ac71102bbe1d$var$treeProto.remove = (0, $lBgya.default);
$e295ac71102bbe1d$var$treeProto.removeAll = (0, $lBgya.removeAll);
$e295ac71102bbe1d$var$treeProto.root = (0, $l27Vn.default);
$e295ac71102bbe1d$var$treeProto.size = (0, $hmdO5.default);
$e295ac71102bbe1d$var$treeProto.visit = (0, $6dXIu.default);
$e295ac71102bbe1d$var$treeProto.visitAfter = (0, $k49Zh.default);
$e295ac71102bbe1d$var$treeProto.x = (0, $cH28F.default);
$e295ac71102bbe1d$var$treeProto.y = (0, $552f2.default);

});
parcelRegister("cum3A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9179656ecfee5a5d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "addAll", function () { return $9179656ecfee5a5d$export$32ed0561867ec8a1; });
function $9179656ecfee5a5d$export$2e2bcd8739ae039(d) {
    var x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $9179656ecfee5a5d$var$add(this.cover(x, y), x, y, d);
}
function $9179656ecfee5a5d$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $9179656ecfee5a5d$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$9179656ecfee5a5d$var$add(this, xz[i], yz[i], data[i]);
    return this;
}

});

parcelRegister("1HNmA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13e0191933a66f23$export$2e2bcd8739ae039; });
function $13e0191933a66f23$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else {
        var z = x1 - x0, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1){
            i = (y < y0) << 1 | x < x0;
            parent = new Array(4), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z, y1 = y0 + z;
                    break;
                case 1:
                    x0 = x1 - z, y1 = y0 + z;
                    break;
                case 2:
                    x1 = x0 + z, y0 = y1 - z;
                    break;
                case 3:
                    x0 = x1 - z, y0 = y1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}

});

parcelRegister("B9EKH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06faf25ac2ac2b1d$export$2e2bcd8739ae039; });
function $06faf25ac2ac2b1d$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}

});

parcelRegister("9DIl6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $704a267129514e41$export$2e2bcd8739ae039; });
function $704a267129514e41$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}

});

parcelRegister("dzeqI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e09bcba1d9e3590$export$2e2bcd8739ae039; });

var $86Mrd = parcelRequire("86Mrd");
function $9e09bcba1d9e3590$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $86Mrd.default)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $86Mrd.default)(node[3], xm, ym, x2, y2), new (0, $86Mrd.default)(node[2], x1, ym, xm, y2), new (0, $86Mrd.default)(node[1], xm, y1, x2, ym), new (0, $86Mrd.default)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}

});
parcelRegister("86Mrd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e7475059b5e642b$export$2e2bcd8739ae039; });
function $5e7475059b5e642b$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}

});


parcelRegister("lBgya", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb99e42ba6bea3b2$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "removeAll", function () { return $fb99e42ba6bea3b2$export$1cfc7aad5cb1833b; });
function $fb99e42ba6bea3b2$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $fb99e42ba6bea3b2$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}

});

parcelRegister("l27Vn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4ffee82ff2faf94$export$2e2bcd8739ae039; });
function $f4ffee82ff2faf94$export$2e2bcd8739ae039() {
    return this._root;
}

});

parcelRegister("hmdO5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca2f337b140c0676$export$2e2bcd8739ae039; });
function $ca2f337b140c0676$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}

});

parcelRegister("6dXIu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48824771897fc87e$export$2e2bcd8739ae039; });

var $86Mrd = parcelRequire("86Mrd");
function $48824771897fc87e$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $86Mrd.default)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $86Mrd.default)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $86Mrd.default)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $86Mrd.default)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $86Mrd.default)(child, x0, y0, xm, ym));
    }
    return this;
}

});

parcelRegister("k49Zh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03c5187a855b546b$export$2e2bcd8739ae039; });

var $86Mrd = parcelRequire("86Mrd");
function $03c5187a855b546b$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $86Mrd.default)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $86Mrd.default)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $86Mrd.default)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $86Mrd.default)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $86Mrd.default)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}

});

parcelRegister("cH28F", function(module, exports) {

$parcel$export(module.exports, "defaultX", function () { return $93db28ea3f843226$export$e6fafc98131d2a44; });
$parcel$export(module.exports, "default", function () { return $93db28ea3f843226$export$2e2bcd8739ae039; });
function $93db28ea3f843226$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $93db28ea3f843226$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}

});

parcelRegister("552f2", function(module, exports) {

$parcel$export(module.exports, "defaultY", function () { return $3b2f2882ee1f6c98$export$6f0a21aeb844a64c; });
$parcel$export(module.exports, "default", function () { return $3b2f2882ee1f6c98$export$2e2bcd8739ae039; });
function $3b2f2882ee1f6c98$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $3b2f2882ee1f6c98$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}

});



parcelRegister("axZKH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7adce325042cde00$export$2e2bcd8739ae039; });

var $93ZNi = parcelRequire("93ZNi");

var $clxGu = parcelRequire("clxGu");
parcelRequire("9r7nk");
var $3WKXr = parcelRequire("3WKXr");
function $7adce325042cde00$var$index(d) {
    return d.index;
}
function $7adce325042cde00$var$find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("missing: " + nodeId);
    return node;
}
function $7adce325042cde00$export$2e2bcd8739ae039(links) {
    var id = $7adce325042cde00$var$index, strength = defaultStrength, strengths, distance = (0, $93ZNi.default)(30), distances, nodes, count, bias, iterations = 1;
    if (links == null) links = [];
    function defaultStrength(link) {
        return 1 / Math.min(count[link.source.index], count[link.target.index]);
    }
    function force(alpha) {
        for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
            link = links[i], source = link.source, target = link.target;
            x = target.x + target.vx - source.x - source.vx || (0, $clxGu.default)();
            y = target.y + target.vy - source.y - source.vy || (0, $clxGu.default)();
            l = Math.sqrt(x * x + y * y);
            l = (l - distances[i]) / l * alpha * strengths[i];
            x *= l, y *= l;
            target.vx -= x * (b = bias[i]);
            target.vy -= y * b;
            source.vx += x * (b = 1 - b);
            source.vy += y * b;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, m = links.length, nodeById = (0, $3WKXr.default)(nodes, id), link;
        for(i = 0, count = new Array(n); i < m; ++i){
            link = links[i], link.index = i;
            if (typeof link.source !== "object") link.source = $7adce325042cde00$var$find(nodeById, link.source);
            if (typeof link.target !== "object") link.target = $7adce325042cde00$var$find(nodeById, link.target);
            count[link.source.index] = (count[link.source.index] || 0) + 1;
            count[link.target.index] = (count[link.target.index] || 0) + 1;
        }
        for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
        strengths = new Array(m), initializeStrength();
        distances = new Array(m), initializeDistance();
    }
    function initializeStrength() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
    }
    function initializeDistance() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.links = function(_) {
        return arguments.length ? (links = _, initialize(), force) : links;
    };
    force.id = function(_) {
        return arguments.length ? (id = _, force) : id;
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $93ZNi.default)(+_), initializeStrength(), force) : strength;
    };
    force.distance = function(_) {
        return arguments.length ? (distance = typeof _ === "function" ? _ : (0, $93ZNi.default)(+_), initializeDistance(), force) : distance;
    };
    return force;
}

});

parcelRegister("fuMCb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b47f5e3e9e3d6b7d$export$2e2bcd8739ae039; });

var $93ZNi = parcelRequire("93ZNi");

var $clxGu = parcelRequire("clxGu");

var $js6v0 = parcelRequire("js6v0");

var $dxZuf = parcelRequire("dxZuf");
function $b47f5e3e9e3d6b7d$export$2e2bcd8739ae039() {
    var nodes, node, alpha, strength = (0, $93ZNi.default)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
    function force(_) {
        var i, n = nodes.length, tree = (0, $js6v0.default)(nodes, (0, $dxZuf.x), (0, $dxZuf.y)).visitAfter(accumulate);
        for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        strengths = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
    }
    function accumulate(quad) {
        var strength = 0, q, c, weight = 0, x, y, i;
        // For internal nodes, accumulate forces from child quadrants.
        if (quad.length) {
            for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
            quad.x = x / weight;
            quad.y = y / weight;
        } else {
            q = quad;
            q.x = q.data.x;
            q.y = q.data.y;
            do strength += strengths[q.data.index];
            while (q = q.next);
        }
        quad.value = strength;
    }
    function apply(quad, x1, _, x2) {
        if (!quad.value) return true;
        var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
        // Apply the Barnes-Hut approximation if possible.
        // Limit forces for very close nodes; randomize direction if coincident.
        if (w * w / theta2 < l) {
            if (l < distanceMax2) {
                if (x === 0) x = (0, $clxGu.default)(), l += x * x;
                if (y === 0) y = (0, $clxGu.default)(), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                node.vx += x * quad.value * alpha / l;
                node.vy += y * quad.value * alpha / l;
            }
            return true;
        } else if (quad.length || l >= distanceMax2) return;
        // Limit forces for very close nodes; randomize direction if coincident.
        if (quad.data !== node || quad.next) {
            if (x === 0) x = (0, $clxGu.default)(), l += x * x;
            if (y === 0) y = (0, $clxGu.default)(), l += y * y;
            if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        }
        do if (quad.data !== node) {
            w = strengths[quad.data.index] * alpha / l;
            node.vx += x * w;
            node.vy += y * w;
        }
        while (quad = quad.next);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $93ZNi.default)(+_), initialize(), force) : strength;
    };
    force.distanceMin = function(_) {
        return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
    };
    force.distanceMax = function(_) {
        return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
    };
    force.theta = function(_) {
        return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
    };
    return force;
}

});
parcelRegister("dxZuf", function(module, exports) {

$parcel$export(module.exports, "x", function () { return $9dce0d6ed54d6ac8$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "y", function () { return $9dce0d6ed54d6ac8$export$4a5767248b18ef41; });
$parcel$export(module.exports, "default", function () { return $9dce0d6ed54d6ac8$export$2e2bcd8739ae039; });

var $1TJJe = parcelRequire("1TJJe");
parcelRequire("9r7nk");
var $3WKXr = parcelRequire("3WKXr");

var $fxK5h = parcelRequire("fxK5h");
function $9dce0d6ed54d6ac8$export$d141bba7fdc215a3(d) {
    return d.x;
}
function $9dce0d6ed54d6ac8$export$4a5767248b18ef41(d) {
    return d.y;
}
var $9dce0d6ed54d6ac8$var$initialRadius = 10, $9dce0d6ed54d6ac8$var$initialAngle = Math.PI * (3 - Math.sqrt(5));
function $9dce0d6ed54d6ac8$export$2e2bcd8739ae039(nodes) {
    var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = (0, $3WKXr.default)(), stepper = (0, $fxK5h.timer)(step), event = (0, $1TJJe.default)("tick", "end");
    if (nodes == null) nodes = [];
    function step() {
        tick();
        event.call("tick", simulation);
        if (alpha < alphaMin) {
            stepper.stop();
            event.call("end", simulation);
        }
    }
    function tick(iterations) {
        var i, n = nodes.length, node;
        if (iterations === undefined) iterations = 1;
        for(var k = 0; k < iterations; ++k){
            alpha += (alphaTarget - alpha) * alphaDecay;
            forces.each(function(force) {
                force(alpha);
            });
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (node.fx == null) node.x += node.vx *= velocityDecay;
                else node.x = node.fx, node.vx = 0;
                if (node.fy == null) node.y += node.vy *= velocityDecay;
                else node.y = node.fy, node.vy = 0;
            }
        }
        return simulation;
    }
    function initializeNodes() {
        for(var i = 0, n = nodes.length, node; i < n; ++i){
            node = nodes[i], node.index = i;
            if (node.fx != null) node.x = node.fx;
            if (node.fy != null) node.y = node.fy;
            if (isNaN(node.x) || isNaN(node.y)) {
                var radius = $9dce0d6ed54d6ac8$var$initialRadius * Math.sqrt(i), angle = i * $9dce0d6ed54d6ac8$var$initialAngle;
                node.x = radius * Math.cos(angle);
                node.y = radius * Math.sin(angle);
            }
            if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
        }
    }
    function initializeForce(force) {
        if (force.initialize) force.initialize(nodes);
        return force;
    }
    initializeNodes();
    return simulation = {
        tick: tick,
        restart: function() {
            return stepper.restart(step), simulation;
        },
        stop: function() {
            return stepper.stop(), simulation;
        },
        nodes: function(_) {
            return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
        },
        alpha: function(_) {
            return arguments.length ? (alpha = +_, simulation) : alpha;
        },
        alphaMin: function(_) {
            return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
        },
        alphaDecay: function(_) {
            return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
        },
        alphaTarget: function(_) {
            return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
        },
        velocityDecay: function(_) {
            return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
        },
        force: function(name, _) {
            return arguments.length > 1 ? (_ == null ? forces.remove(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
        },
        find: function(x, y, radius) {
            var i = 0, n = nodes.length, dx, dy, d2, node, closest;
            if (radius == null) radius = Infinity;
            else radius *= radius;
            for(i = 0; i < n; ++i){
                node = nodes[i];
                dx = x - node.x;
                dy = y - node.y;
                d2 = dx * dx + dy * dy;
                if (d2 < radius) closest = node, radius = d2;
            }
            return closest;
        },
        on: function(name, _) {
            return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
        }
    };
}

});


parcelRegister("iItgv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da030984eadd5fea$export$2e2bcd8739ae039; });

var $93ZNi = parcelRequire("93ZNi");
function $da030984eadd5fea$export$2e2bcd8739ae039(radius, x, y) {
    var nodes, strength = (0, $93ZNi.default)(0.1), strengths, radiuses;
    if (typeof radius !== "function") radius = (0, $93ZNi.default)(+radius);
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force(alpha) {
        for(var i = 0, n = nodes.length; i < n; ++i){
            var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
            node.vx += dx * k;
            node.vy += dy * k;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        radiuses = new Array(n);
        for(i = 0; i < n; ++i){
            radiuses[i] = +radius(nodes[i], i, nodes);
            strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
        }
    }
    force.initialize = function(_) {
        nodes = _, initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $93ZNi.default)(+_), initialize(), force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $93ZNi.default)(+_), initialize(), force) : radius;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    return force;
}

});

parcelRegister("8i1cn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6090ef2cf328c191$export$2e2bcd8739ae039; });

var $93ZNi = parcelRequire("93ZNi");
function $6090ef2cf328c191$export$2e2bcd8739ae039(x) {
    var strength = (0, $93ZNi.default)(0.1), nodes, strengths, xz;
    if (typeof x !== "function") x = (0, $93ZNi.default)(x == null ? 0 : +x);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        xz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $93ZNi.default)(+_), initialize(), force) : strength;
    };
    force.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $93ZNi.default)(+_), initialize(), force) : x;
    };
    return force;
}

});

parcelRegister("6W1Cs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50c96a6691abc3a0$export$2e2bcd8739ae039; });

var $93ZNi = parcelRequire("93ZNi");
function $50c96a6691abc3a0$export$2e2bcd8739ae039(y) {
    var strength = (0, $93ZNi.default)(0.1), nodes, strengths, yz;
    if (typeof y !== "function") y = (0, $93ZNi.default)(y == null ? 0 : +y);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        yz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $93ZNi.default)(+_), initialize(), force) : strength;
    };
    force.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $93ZNi.default)(+_), initialize(), force) : y;
    };
    return force;
}

});


parcelRegister("2fM2C", function(module, exports) {

$parcel$export(module.exports, "formatDefaultLocale", function () { return (parcelRequire("l9rW7")).default; });
$parcel$export(module.exports, "format", function () { return (parcelRequire("l9rW7")).format; });
$parcel$export(module.exports, "formatPrefix", function () { return (parcelRequire("l9rW7")).formatPrefix; });
$parcel$export(module.exports, "formatLocale", function () { return (parcelRequire("hBDkV")).default; });
$parcel$export(module.exports, "formatSpecifier", function () { return (parcelRequire("2t3Cf")).default; });
$parcel$export(module.exports, "FormatSpecifier", function () { return (parcelRequire("2t3Cf")).FormatSpecifier; });
$parcel$export(module.exports, "precisionFixed", function () { return (parcelRequire("bZr7h")).default; });
$parcel$export(module.exports, "precisionPrefix", function () { return (parcelRequire("2qDiT")).default; });
$parcel$export(module.exports, "precisionRound", function () { return (parcelRequire("8ftxM")).default; });

var $l9rW7 = parcelRequire("l9rW7");

var $hBDkV = parcelRequire("hBDkV");

var $2t3Cf = parcelRequire("2t3Cf");

var $bZr7h = parcelRequire("bZr7h");

var $2qDiT = parcelRequire("2qDiT");

var $8ftxM = parcelRequire("8ftxM");

});
parcelRegister("l9rW7", function(module, exports) {

$parcel$export(module.exports, "format", function () { return $f6601bd7ba54f431$export$d9468344d3651243; });
$parcel$export(module.exports, "formatPrefix", function () { return $f6601bd7ba54f431$export$8d85692a469dde6f; });
$parcel$export(module.exports, "default", function () { return $f6601bd7ba54f431$export$2e2bcd8739ae039; });

var $hBDkV = parcelRequire("hBDkV");
var $f6601bd7ba54f431$var$locale;
var $f6601bd7ba54f431$export$d9468344d3651243;
var $f6601bd7ba54f431$export$8d85692a469dde6f;
$f6601bd7ba54f431$export$2e2bcd8739ae039({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function $f6601bd7ba54f431$export$2e2bcd8739ae039(definition) {
    $f6601bd7ba54f431$var$locale = (0, $hBDkV.default)(definition);
    $f6601bd7ba54f431$export$d9468344d3651243 = $f6601bd7ba54f431$var$locale.format;
    $f6601bd7ba54f431$export$8d85692a469dde6f = $f6601bd7ba54f431$var$locale.formatPrefix;
    return $f6601bd7ba54f431$var$locale;
}

});
parcelRegister("hBDkV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd1467c2bfb64221$export$2e2bcd8739ae039; });

var $gfLWa = parcelRequire("gfLWa");

var $beA1l = parcelRequire("beA1l");

var $iM3Pn = parcelRequire("iM3Pn");

var $2t3Cf = parcelRequire("2t3Cf");

var $8dm7S = parcelRequire("8dm7S");

var $3A6zc = parcelRequire("3A6zc");

var $6yOys = parcelRequire("6yOys");

var $lz5YQ = parcelRequire("lz5YQ");
var $cd1467c2bfb64221$var$map = Array.prototype.map, $cd1467c2bfb64221$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $cd1467c2bfb64221$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $lz5YQ.default) : (0, $beA1l.default)($cd1467c2bfb64221$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $lz5YQ.default) : (0, $iM3Pn.default)($cd1467c2bfb64221$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $2t3Cf.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $3A6zc.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $3A6zc.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $8dm7S.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $cd1467c2bfb64221$var$prefixes[8 + (0, $6yOys.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $2t3Cf.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $gfLWa.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $cd1467c2bfb64221$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("gfLWa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd533b60d24b385f$export$2e2bcd8739ae039; });

var $lTQys = parcelRequire("lTQys");
function $bd533b60d24b385f$export$2e2bcd8739ae039(x) {
    return x = (0, $lTQys.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("lTQys", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff17805088e05908$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "formatDecimalParts", function () { return $ff17805088e05908$export$8f8e23dd27dc19f5; });
function $ff17805088e05908$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $ff17805088e05908$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("beA1l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82dcf17ce1685e34$export$2e2bcd8739ae039; });
function $82dcf17ce1685e34$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("iM3Pn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $daafadc4feed89e8$export$2e2bcd8739ae039; });
function $daafadc4feed89e8$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("2t3Cf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cc1184461dd471b$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "FormatSpecifier", function () { return $1cc1184461dd471b$export$963aac351db36ed4; });
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $1cc1184461dd471b$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $1cc1184461dd471b$export$2e2bcd8739ae039(specifier) {
    if (!(match = $1cc1184461dd471b$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $1cc1184461dd471b$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$1cc1184461dd471b$export$2e2bcd8739ae039.prototype = $1cc1184461dd471b$export$963aac351db36ed4.prototype; // instanceof
function $1cc1184461dd471b$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$1cc1184461dd471b$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("8dm7S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fb0b368199b6db0$export$2e2bcd8739ae039; });
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $5fb0b368199b6db0$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("3A6zc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29b9d3e665d17e28$export$2e2bcd8739ae039; });

var $lTQys = parcelRequire("lTQys");

var $6yOys = parcelRequire("6yOys");

var $5fviV = parcelRequire("5fviV");
var $29b9d3e665d17e28$export$2e2bcd8739ae039 = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, $lTQys.default),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, $5fviV.default)(x * 100, p);
    },
    "r": (0, $5fviV.default),
    "s": (0, $6yOys.default),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};

});
parcelRegister("6yOys", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", function () { return $4c6d222e27627e6f$export$6863724d9a42263; });
$parcel$export(module.exports, "default", function () { return $4c6d222e27627e6f$export$2e2bcd8739ae039; });

var $lTQys = parcelRequire("lTQys");
var $4c6d222e27627e6f$export$6863724d9a42263;
function $4c6d222e27627e6f$export$2e2bcd8739ae039(x, p) {
    var d = (0, $lTQys.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($4c6d222e27627e6f$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $lTQys.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("5fviV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d26a2d469b438ff$export$2e2bcd8739ae039; });

var $lTQys = parcelRequire("lTQys");
function $3d26a2d469b438ff$export$2e2bcd8739ae039(x, p) {
    var d = (0, $lTQys.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("lz5YQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb31816b92782fa8$export$2e2bcd8739ae039; });
function $fb31816b92782fa8$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("bZr7h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8baa6cfb27653488$export$2e2bcd8739ae039; });

var $gfLWa = parcelRequire("gfLWa");
function $8baa6cfb27653488$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $gfLWa.default)(Math.abs(step)));
}

});

parcelRegister("2qDiT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c4c7f60569acb2c$export$2e2bcd8739ae039; });

var $gfLWa = parcelRequire("gfLWa");
function $1c4c7f60569acb2c$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $gfLWa.default)(value) / 3))) * 3 - (0, $gfLWa.default)(Math.abs(step)));
}

});

parcelRegister("8ftxM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6016a442155d6b65$export$2e2bcd8739ae039; });

var $gfLWa = parcelRequire("gfLWa");
function $6016a442155d6b65$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $gfLWa.default)(max) - (0, $gfLWa.default)(step)) + 1;
}

});


parcelRegister("jPdWX", function(module, exports) {

$parcel$export(module.exports, "geoArea", function () { return (parcelRequire("2wdr3")).default; });
$parcel$export(module.exports, "geoBounds", function () { return (parcelRequire("77o3c")).default; });
$parcel$export(module.exports, "geoCentroid", function () { return (parcelRequire("2B3kh")).default; });
$parcel$export(module.exports, "geoCircle", function () { return (parcelRequire("jJ2ZT")).default; });
$parcel$export(module.exports, "geoClipAntimeridian", function () { return (parcelRequire("90zbe")).default; });
$parcel$export(module.exports, "geoClipCircle", function () { return (parcelRequire("jDEoe")).default; });
$parcel$export(module.exports, "geoClipExtent", function () { return (parcelRequire("g4GnW")).default; });
$parcel$export(module.exports, "geoClipRectangle", function () { return (parcelRequire("3AeFV")).default; });
$parcel$export(module.exports, "geoContains", function () { return (parcelRequire("fkxFc")).default; });
$parcel$export(module.exports, "geoDistance", function () { return (parcelRequire("dPoCQ")).default; });
$parcel$export(module.exports, "geoGraticule", function () { return (parcelRequire("5Rd3w")).default; });
$parcel$export(module.exports, "geoGraticule10", function () { return (parcelRequire("5Rd3w")).graticule10; });
$parcel$export(module.exports, "geoInterpolate", function () { return (parcelRequire("6lj4p")).default; });
$parcel$export(module.exports, "geoLength", function () { return (parcelRequire("lmpEK")).default; });
$parcel$export(module.exports, "geoPath", function () { return (parcelRequire("d1FI3")).default; });
$parcel$export(module.exports, "geoAlbers", function () { return (parcelRequire("4B3pL")).default; });
$parcel$export(module.exports, "geoAlbersUsa", function () { return (parcelRequire("1dKhN")).default; });
$parcel$export(module.exports, "geoAzimuthalEqualArea", function () { return (parcelRequire("mll85")).default; });
$parcel$export(module.exports, "geoAzimuthalEqualAreaRaw", function () { return (parcelRequire("mll85")).azimuthalEqualAreaRaw; });
$parcel$export(module.exports, "geoAzimuthalEquidistant", function () { return (parcelRequire("kOOgS")).default; });
$parcel$export(module.exports, "geoAzimuthalEquidistantRaw", function () { return (parcelRequire("kOOgS")).azimuthalEquidistantRaw; });
$parcel$export(module.exports, "geoConicConformal", function () { return (parcelRequire("7Z7Gq")).default; });
$parcel$export(module.exports, "geoConicConformalRaw", function () { return (parcelRequire("7Z7Gq")).conicConformalRaw; });
$parcel$export(module.exports, "geoConicEqualArea", function () { return (parcelRequire("f6k4I")).default; });
$parcel$export(module.exports, "geoConicEqualAreaRaw", function () { return (parcelRequire("f6k4I")).conicEqualAreaRaw; });
$parcel$export(module.exports, "geoConicEquidistant", function () { return (parcelRequire("33OON")).default; });
$parcel$export(module.exports, "geoConicEquidistantRaw", function () { return (parcelRequire("33OON")).conicEquidistantRaw; });
$parcel$export(module.exports, "geoEqualEarth", function () { return (parcelRequire("coj3B")).default; });
$parcel$export(module.exports, "geoEqualEarthRaw", function () { return (parcelRequire("coj3B")).equalEarthRaw; });
$parcel$export(module.exports, "geoEquirectangular", function () { return (parcelRequire("1jnh8")).default; });
$parcel$export(module.exports, "geoEquirectangularRaw", function () { return (parcelRequire("1jnh8")).equirectangularRaw; });
$parcel$export(module.exports, "geoGnomonic", function () { return (parcelRequire("5IU3e")).default; });
$parcel$export(module.exports, "geoGnomonicRaw", function () { return (parcelRequire("5IU3e")).gnomonicRaw; });
$parcel$export(module.exports, "geoIdentity", function () { return (parcelRequire("ihvZ0")).default; });
$parcel$export(module.exports, "geoProjection", function () { return (parcelRequire("9Ld7N")).default; });
$parcel$export(module.exports, "geoProjectionMutator", function () { return (parcelRequire("9Ld7N")).projectionMutator; });
$parcel$export(module.exports, "geoMercator", function () { return (parcelRequire("7gsAH")).default; });
$parcel$export(module.exports, "geoMercatorRaw", function () { return (parcelRequire("7gsAH")).mercatorRaw; });
$parcel$export(module.exports, "geoNaturalEarth1", function () { return (parcelRequire("h8r0n")).default; });
$parcel$export(module.exports, "geoNaturalEarth1Raw", function () { return (parcelRequire("h8r0n")).naturalEarth1Raw; });
$parcel$export(module.exports, "geoOrthographic", function () { return (parcelRequire("bOJIr")).default; });
$parcel$export(module.exports, "geoOrthographicRaw", function () { return (parcelRequire("bOJIr")).orthographicRaw; });
$parcel$export(module.exports, "geoStereographic", function () { return (parcelRequire("abAWU")).default; });
$parcel$export(module.exports, "geoStereographicRaw", function () { return (parcelRequire("abAWU")).stereographicRaw; });
$parcel$export(module.exports, "geoTransverseMercator", function () { return (parcelRequire("5Q7D5")).default; });
$parcel$export(module.exports, "geoTransverseMercatorRaw", function () { return (parcelRequire("5Q7D5")).transverseMercatorRaw; });
$parcel$export(module.exports, "geoRotation", function () { return (parcelRequire("5GRgV")).default; });
$parcel$export(module.exports, "geoStream", function () { return (parcelRequire("49NvL")).default; });
$parcel$export(module.exports, "geoTransform", function () { return (parcelRequire("77LaW")).default; });

var $2wdr3 = parcelRequire("2wdr3");

var $77o3c = parcelRequire("77o3c");

var $2B3kh = parcelRequire("2B3kh");

var $jJ2ZT = parcelRequire("jJ2ZT");

var $90zbe = parcelRequire("90zbe");

var $jDEoe = parcelRequire("jDEoe");

var $g4GnW = parcelRequire("g4GnW");

var $3AeFV = parcelRequire("3AeFV");

var $fkxFc = parcelRequire("fkxFc");

var $dPoCQ = parcelRequire("dPoCQ");

var $5Rd3w = parcelRequire("5Rd3w");

var $6lj4p = parcelRequire("6lj4p");

var $lmpEK = parcelRequire("lmpEK");

var $d1FI3 = parcelRequire("d1FI3");

var $4B3pL = parcelRequire("4B3pL");

var $1dKhN = parcelRequire("1dKhN");

var $mll85 = parcelRequire("mll85");

var $kOOgS = parcelRequire("kOOgS");

var $7Z7Gq = parcelRequire("7Z7Gq");

var $f6k4I = parcelRequire("f6k4I");

var $33OON = parcelRequire("33OON");

var $coj3B = parcelRequire("coj3B");

var $1jnh8 = parcelRequire("1jnh8");

var $5IU3e = parcelRequire("5IU3e");

var $ihvZ0 = parcelRequire("ihvZ0");

var $9Ld7N = parcelRequire("9Ld7N");

var $7gsAH = parcelRequire("7gsAH");

var $h8r0n = parcelRequire("h8r0n");

var $bOJIr = parcelRequire("bOJIr");

var $abAWU = parcelRequire("abAWU");

var $5Q7D5 = parcelRequire("5Q7D5");

var $5GRgV = parcelRequire("5GRgV");

var $49NvL = parcelRequire("49NvL");

var $77LaW = parcelRequire("77LaW");

});
parcelRegister("2wdr3", function(module, exports) {

$parcel$export(module.exports, "areaRingSum", function () { return $1d58fdedf66a7e31$export$bf8f994332070c7f; });
$parcel$export(module.exports, "areaStream", function () { return $1d58fdedf66a7e31$export$cb67cfa750ae69dc; });
$parcel$export(module.exports, "default", function () { return $1d58fdedf66a7e31$export$2e2bcd8739ae039; });

var $1wbR2 = parcelRequire("1wbR2");

var $eIlmS = parcelRequire("eIlmS");

var $glE2y = parcelRequire("glE2y");

var $49NvL = parcelRequire("49NvL");
var $1d58fdedf66a7e31$export$bf8f994332070c7f = (0, $1wbR2.default)();
var $1d58fdedf66a7e31$var$areaSum = (0, $1wbR2.default)(), $1d58fdedf66a7e31$var$lambda00, $1d58fdedf66a7e31$var$phi00, $1d58fdedf66a7e31$var$lambda0, $1d58fdedf66a7e31$var$cosPhi0, $1d58fdedf66a7e31$var$sinPhi0;
var $1d58fdedf66a7e31$export$cb67cfa750ae69dc = {
    point: (0, $glE2y.default),
    lineStart: (0, $glE2y.default),
    lineEnd: (0, $glE2y.default),
    polygonStart: function() {
        $1d58fdedf66a7e31$export$bf8f994332070c7f.reset();
        $1d58fdedf66a7e31$export$cb67cfa750ae69dc.lineStart = $1d58fdedf66a7e31$var$areaRingStart;
        $1d58fdedf66a7e31$export$cb67cfa750ae69dc.lineEnd = $1d58fdedf66a7e31$var$areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +$1d58fdedf66a7e31$export$bf8f994332070c7f;
        $1d58fdedf66a7e31$var$areaSum.add(areaRing < 0 ? (0, $eIlmS.tau) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, $glE2y.default);
    },
    sphere: function() {
        $1d58fdedf66a7e31$var$areaSum.add((0, $eIlmS.tau));
    }
};
function $1d58fdedf66a7e31$var$areaRingStart() {
    $1d58fdedf66a7e31$export$cb67cfa750ae69dc.point = $1d58fdedf66a7e31$var$areaPointFirst;
}
function $1d58fdedf66a7e31$var$areaRingEnd() {
    $1d58fdedf66a7e31$var$areaPoint($1d58fdedf66a7e31$var$lambda00, $1d58fdedf66a7e31$var$phi00);
}
function $1d58fdedf66a7e31$var$areaPointFirst(lambda, phi) {
    $1d58fdedf66a7e31$export$cb67cfa750ae69dc.point = $1d58fdedf66a7e31$var$areaPoint;
    $1d58fdedf66a7e31$var$lambda00 = lambda, $1d58fdedf66a7e31$var$phi00 = phi;
    lambda *= (0, $eIlmS.radians), phi *= (0, $eIlmS.radians);
    $1d58fdedf66a7e31$var$lambda0 = lambda, $1d58fdedf66a7e31$var$cosPhi0 = (0, $eIlmS.cos)(phi = phi / 2 + (0, $eIlmS.quarterPi)), $1d58fdedf66a7e31$var$sinPhi0 = (0, $eIlmS.sin)(phi);
}
function $1d58fdedf66a7e31$var$areaPoint(lambda, phi) {
    lambda *= (0, $eIlmS.radians), phi *= (0, $eIlmS.radians);
    phi = phi / 2 + (0, $eIlmS.quarterPi); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - $1d58fdedf66a7e31$var$lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, $eIlmS.cos)(phi), sinPhi = (0, $eIlmS.sin)(phi), k = $1d58fdedf66a7e31$var$sinPhi0 * sinPhi, u = $1d58fdedf66a7e31$var$cosPhi0 * cosPhi + k * (0, $eIlmS.cos)(adLambda), v = k * sdLambda * (0, $eIlmS.sin)(adLambda);
    $1d58fdedf66a7e31$export$bf8f994332070c7f.add((0, $eIlmS.atan2)(v, u));
    // Advance the previous points.
    $1d58fdedf66a7e31$var$lambda0 = lambda, $1d58fdedf66a7e31$var$cosPhi0 = cosPhi, $1d58fdedf66a7e31$var$sinPhi0 = sinPhi;
}
function $1d58fdedf66a7e31$export$2e2bcd8739ae039(object) {
    $1d58fdedf66a7e31$var$areaSum.reset();
    (0, $49NvL.default)(object, $1d58fdedf66a7e31$export$cb67cfa750ae69dc);
    return $1d58fdedf66a7e31$var$areaSum * 2;
}

});
parcelRegister("1wbR2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11b1f9abe059c332$export$2e2bcd8739ae039; });
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/
function $11b1f9abe059c332$export$2e2bcd8739ae039() {
    return new $11b1f9abe059c332$var$Adder;
}
function $11b1f9abe059c332$var$Adder() {
    this.reset();
}
$11b1f9abe059c332$var$Adder.prototype = {
    constructor: $11b1f9abe059c332$var$Adder,
    reset: function() {
        this.s = this.t = 0; // exact error
    },
    add: function(y) {
        $11b1f9abe059c332$var$add($11b1f9abe059c332$var$temp, y, this.t);
        $11b1f9abe059c332$var$add(this, $11b1f9abe059c332$var$temp.s, this.s);
        if (this.s) this.t += $11b1f9abe059c332$var$temp.t;
        else this.s = $11b1f9abe059c332$var$temp.t;
    },
    valueOf: function() {
        return this.s;
    }
};
var $11b1f9abe059c332$var$temp = new $11b1f9abe059c332$var$Adder;
function $11b1f9abe059c332$var$add(adder, a, b) {
    var x = adder.s = a + b, bv = x - a, av = x - bv;
    adder.t = a - av + (b - bv);
}

});

parcelRegister("eIlmS", function(module, exports) {

$parcel$export(module.exports, "epsilon", function () { return $ab65c0027789676f$export$6c421550c66a327d; });
$parcel$export(module.exports, "epsilon2", function () { return $ab65c0027789676f$export$92c06fba281fe81b; });
$parcel$export(module.exports, "pi", function () { return $ab65c0027789676f$export$18c7bea995a110f; });
$parcel$export(module.exports, "halfPi", function () { return $ab65c0027789676f$export$e51408a300e8929a; });
$parcel$export(module.exports, "quarterPi", function () { return $ab65c0027789676f$export$c39a5cba78ea0fc2; });
$parcel$export(module.exports, "tau", function () { return $ab65c0027789676f$export$a4b4b4d4d776fe92; });
$parcel$export(module.exports, "degrees", function () { return $ab65c0027789676f$export$41fc368e1a942b97; });
$parcel$export(module.exports, "radians", function () { return $ab65c0027789676f$export$8449e153fbd325fc; });
$parcel$export(module.exports, "abs", function () { return $ab65c0027789676f$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "atan", function () { return $ab65c0027789676f$export$628dc4eed22b0fbd; });
$parcel$export(module.exports, "atan2", function () { return $ab65c0027789676f$export$b8b770ee6a0d9760; });
$parcel$export(module.exports, "cos", function () { return $ab65c0027789676f$export$50d414a77b60d802; });
$parcel$export(module.exports, "ceil", function () { return $ab65c0027789676f$export$803ce6b71a0a94b2; });
$parcel$export(module.exports, "exp", function () { return $ab65c0027789676f$export$b310ec824aaee37f; });
$parcel$export(module.exports, "log", function () { return $ab65c0027789676f$export$bef1f36f5486a6a3; });
$parcel$export(module.exports, "pow", function () { return $ab65c0027789676f$export$9c297f60e22e3389; });
$parcel$export(module.exports, "sin", function () { return $ab65c0027789676f$export$5de3937cb4b592ed; });
$parcel$export(module.exports, "sign", function () { return $ab65c0027789676f$export$c5552dfdbc7cec71; });
$parcel$export(module.exports, "sqrt", function () { return $ab65c0027789676f$export$eba8049fb5020b81; });
$parcel$export(module.exports, "tan", function () { return $ab65c0027789676f$export$fcdd3b0b3246a325; });
$parcel$export(module.exports, "acos", function () { return $ab65c0027789676f$export$fd6306be3fde5b04; });
$parcel$export(module.exports, "asin", function () { return $ab65c0027789676f$export$41726bdb1fc63f; });
$parcel$export(module.exports, "haversin", function () { return $ab65c0027789676f$export$e808712c2966e662; });
var $ab65c0027789676f$export$6c421550c66a327d = 1e-6;
var $ab65c0027789676f$export$92c06fba281fe81b = 1e-12;
var $ab65c0027789676f$export$18c7bea995a110f = Math.PI;
var $ab65c0027789676f$export$e51408a300e8929a = $ab65c0027789676f$export$18c7bea995a110f / 2;
var $ab65c0027789676f$export$c39a5cba78ea0fc2 = $ab65c0027789676f$export$18c7bea995a110f / 4;
var $ab65c0027789676f$export$a4b4b4d4d776fe92 = $ab65c0027789676f$export$18c7bea995a110f * 2;
var $ab65c0027789676f$export$41fc368e1a942b97 = 180 / $ab65c0027789676f$export$18c7bea995a110f;
var $ab65c0027789676f$export$8449e153fbd325fc = $ab65c0027789676f$export$18c7bea995a110f / 180;
var $ab65c0027789676f$export$2335f513bbd82c6d = Math.abs;
var $ab65c0027789676f$export$628dc4eed22b0fbd = Math.atan;
var $ab65c0027789676f$export$b8b770ee6a0d9760 = Math.atan2;
var $ab65c0027789676f$export$50d414a77b60d802 = Math.cos;
var $ab65c0027789676f$export$803ce6b71a0a94b2 = Math.ceil;
var $ab65c0027789676f$export$b310ec824aaee37f = Math.exp;
var $ab65c0027789676f$export$a3fe094919f356fd = Math.floor;
var $ab65c0027789676f$export$bef1f36f5486a6a3 = Math.log;
var $ab65c0027789676f$export$9c297f60e22e3389 = Math.pow;
var $ab65c0027789676f$export$5de3937cb4b592ed = Math.sin;
var $ab65c0027789676f$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $ab65c0027789676f$export$eba8049fb5020b81 = Math.sqrt;
var $ab65c0027789676f$export$fcdd3b0b3246a325 = Math.tan;
function $ab65c0027789676f$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $ab65c0027789676f$export$18c7bea995a110f : Math.acos(x);
}
function $ab65c0027789676f$export$41726bdb1fc63f(x) {
    return x > 1 ? $ab65c0027789676f$export$e51408a300e8929a : x < -1 ? -$ab65c0027789676f$export$e51408a300e8929a : Math.asin(x);
}
function $ab65c0027789676f$export$e808712c2966e662(x) {
    return (x = $ab65c0027789676f$export$5de3937cb4b592ed(x / 2)) * x;
}

});

parcelRegister("glE2y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be6daaab6b07e57f$export$2e2bcd8739ae039; });
function $be6daaab6b07e57f$export$2e2bcd8739ae039() {}

});

parcelRegister("49NvL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $306e689b88931e32$export$2e2bcd8739ae039; });
function $306e689b88931e32$var$streamGeometry(geometry, stream) {
    if (geometry && $306e689b88931e32$var$streamGeometryType.hasOwnProperty(geometry.type)) $306e689b88931e32$var$streamGeometryType[geometry.type](geometry, stream);
}
var $306e689b88931e32$var$streamObjectType = {
    Feature: function(object, stream) {
        $306e689b88931e32$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$306e689b88931e32$var$streamGeometry(features[i].geometry, stream);
    }
};
var $306e689b88931e32$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $306e689b88931e32$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$306e689b88931e32$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $306e689b88931e32$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$306e689b88931e32$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$306e689b88931e32$var$streamGeometry(geometries[i], stream);
    }
};
function $306e689b88931e32$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $306e689b88931e32$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$306e689b88931e32$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $306e689b88931e32$export$2e2bcd8739ae039(object, stream) {
    if (object && $306e689b88931e32$var$streamObjectType.hasOwnProperty(object.type)) $306e689b88931e32$var$streamObjectType[object.type](object, stream);
    else $306e689b88931e32$var$streamGeometry(object, stream);
}

});


parcelRegister("77o3c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52ebd7c9b7da7bda$export$2e2bcd8739ae039; });

var $1wbR2 = parcelRequire("1wbR2");

var $2wdr3 = parcelRequire("2wdr3");

var $8W5ig = parcelRequire("8W5ig");

var $eIlmS = parcelRequire("eIlmS");

var $49NvL = parcelRequire("49NvL");
var $52ebd7c9b7da7bda$var$lambda0, $52ebd7c9b7da7bda$var$phi0, $52ebd7c9b7da7bda$var$lambda1, $52ebd7c9b7da7bda$var$phi1, $52ebd7c9b7da7bda$var$lambda2, $52ebd7c9b7da7bda$var$lambda00, $52ebd7c9b7da7bda$var$phi00, $52ebd7c9b7da7bda$var$p0, $52ebd7c9b7da7bda$var$deltaSum = (0, $1wbR2.default)(), $52ebd7c9b7da7bda$var$ranges, $52ebd7c9b7da7bda$var$range;
var $52ebd7c9b7da7bda$var$boundsStream = {
    point: $52ebd7c9b7da7bda$var$boundsPoint,
    lineStart: $52ebd7c9b7da7bda$var$boundsLineStart,
    lineEnd: $52ebd7c9b7da7bda$var$boundsLineEnd,
    polygonStart: function() {
        $52ebd7c9b7da7bda$var$boundsStream.point = $52ebd7c9b7da7bda$var$boundsRingPoint;
        $52ebd7c9b7da7bda$var$boundsStream.lineStart = $52ebd7c9b7da7bda$var$boundsRingStart;
        $52ebd7c9b7da7bda$var$boundsStream.lineEnd = $52ebd7c9b7da7bda$var$boundsRingEnd;
        $52ebd7c9b7da7bda$var$deltaSum.reset();
        (0, $2wdr3.areaStream).polygonStart();
    },
    polygonEnd: function() {
        (0, $2wdr3.areaStream).polygonEnd();
        $52ebd7c9b7da7bda$var$boundsStream.point = $52ebd7c9b7da7bda$var$boundsPoint;
        $52ebd7c9b7da7bda$var$boundsStream.lineStart = $52ebd7c9b7da7bda$var$boundsLineStart;
        $52ebd7c9b7da7bda$var$boundsStream.lineEnd = $52ebd7c9b7da7bda$var$boundsLineEnd;
        if ((0, $2wdr3.areaRingSum) < 0) $52ebd7c9b7da7bda$var$lambda0 = -($52ebd7c9b7da7bda$var$lambda1 = 180), $52ebd7c9b7da7bda$var$phi0 = -($52ebd7c9b7da7bda$var$phi1 = 90);
        else if ($52ebd7c9b7da7bda$var$deltaSum > (0, $eIlmS.epsilon)) $52ebd7c9b7da7bda$var$phi1 = 90;
        else if ($52ebd7c9b7da7bda$var$deltaSum < -(0, $eIlmS.epsilon)) $52ebd7c9b7da7bda$var$phi0 = -90;
        $52ebd7c9b7da7bda$var$range[0] = $52ebd7c9b7da7bda$var$lambda0, $52ebd7c9b7da7bda$var$range[1] = $52ebd7c9b7da7bda$var$lambda1;
    },
    sphere: function() {
        $52ebd7c9b7da7bda$var$lambda0 = -($52ebd7c9b7da7bda$var$lambda1 = 180), $52ebd7c9b7da7bda$var$phi0 = -($52ebd7c9b7da7bda$var$phi1 = 90);
    }
};
function $52ebd7c9b7da7bda$var$boundsPoint(lambda, phi) {
    $52ebd7c9b7da7bda$var$ranges.push($52ebd7c9b7da7bda$var$range = [
        $52ebd7c9b7da7bda$var$lambda0 = lambda,
        $52ebd7c9b7da7bda$var$lambda1 = lambda
    ]);
    if (phi < $52ebd7c9b7da7bda$var$phi0) $52ebd7c9b7da7bda$var$phi0 = phi;
    if (phi > $52ebd7c9b7da7bda$var$phi1) $52ebd7c9b7da7bda$var$phi1 = phi;
}
function $52ebd7c9b7da7bda$var$linePoint(lambda, phi) {
    var p = (0, $8W5ig.cartesian)([
        lambda * (0, $eIlmS.radians),
        phi * (0, $eIlmS.radians)
    ]);
    if ($52ebd7c9b7da7bda$var$p0) {
        var normal = (0, $8W5ig.cartesianCross)($52ebd7c9b7da7bda$var$p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, $8W5ig.cartesianCross)(equatorial, normal);
        (0, $8W5ig.cartesianNormalizeInPlace)(inflection);
        inflection = (0, $8W5ig.spherical)(inflection);
        var delta = lambda - $52ebd7c9b7da7bda$var$lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, $eIlmS.degrees) * sign, phii, antimeridian = (0, $eIlmS.abs)(delta) > 180;
        if (antimeridian ^ (sign * $52ebd7c9b7da7bda$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, $eIlmS.degrees);
            if (phii > $52ebd7c9b7da7bda$var$phi1) $52ebd7c9b7da7bda$var$phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * $52ebd7c9b7da7bda$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, $eIlmS.degrees);
            if (phii < $52ebd7c9b7da7bda$var$phi0) $52ebd7c9b7da7bda$var$phi0 = phii;
        } else {
            if (phi < $52ebd7c9b7da7bda$var$phi0) $52ebd7c9b7da7bda$var$phi0 = phi;
            if (phi > $52ebd7c9b7da7bda$var$phi1) $52ebd7c9b7da7bda$var$phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < $52ebd7c9b7da7bda$var$lambda2) {
                if ($52ebd7c9b7da7bda$var$angle($52ebd7c9b7da7bda$var$lambda0, lambda) > $52ebd7c9b7da7bda$var$angle($52ebd7c9b7da7bda$var$lambda0, $52ebd7c9b7da7bda$var$lambda1)) $52ebd7c9b7da7bda$var$lambda1 = lambda;
            } else if ($52ebd7c9b7da7bda$var$angle(lambda, $52ebd7c9b7da7bda$var$lambda1) > $52ebd7c9b7da7bda$var$angle($52ebd7c9b7da7bda$var$lambda0, $52ebd7c9b7da7bda$var$lambda1)) $52ebd7c9b7da7bda$var$lambda0 = lambda;
        } else if ($52ebd7c9b7da7bda$var$lambda1 >= $52ebd7c9b7da7bda$var$lambda0) {
            if (lambda < $52ebd7c9b7da7bda$var$lambda0) $52ebd7c9b7da7bda$var$lambda0 = lambda;
            if (lambda > $52ebd7c9b7da7bda$var$lambda1) $52ebd7c9b7da7bda$var$lambda1 = lambda;
        } else {
            if (lambda > $52ebd7c9b7da7bda$var$lambda2) {
                if ($52ebd7c9b7da7bda$var$angle($52ebd7c9b7da7bda$var$lambda0, lambda) > $52ebd7c9b7da7bda$var$angle($52ebd7c9b7da7bda$var$lambda0, $52ebd7c9b7da7bda$var$lambda1)) $52ebd7c9b7da7bda$var$lambda1 = lambda;
            } else if ($52ebd7c9b7da7bda$var$angle(lambda, $52ebd7c9b7da7bda$var$lambda1) > $52ebd7c9b7da7bda$var$angle($52ebd7c9b7da7bda$var$lambda0, $52ebd7c9b7da7bda$var$lambda1)) $52ebd7c9b7da7bda$var$lambda0 = lambda;
        }
    } else $52ebd7c9b7da7bda$var$ranges.push($52ebd7c9b7da7bda$var$range = [
        $52ebd7c9b7da7bda$var$lambda0 = lambda,
        $52ebd7c9b7da7bda$var$lambda1 = lambda
    ]);
    if (phi < $52ebd7c9b7da7bda$var$phi0) $52ebd7c9b7da7bda$var$phi0 = phi;
    if (phi > $52ebd7c9b7da7bda$var$phi1) $52ebd7c9b7da7bda$var$phi1 = phi;
    $52ebd7c9b7da7bda$var$p0 = p, $52ebd7c9b7da7bda$var$lambda2 = lambda;
}
function $52ebd7c9b7da7bda$var$boundsLineStart() {
    $52ebd7c9b7da7bda$var$boundsStream.point = $52ebd7c9b7da7bda$var$linePoint;
}
function $52ebd7c9b7da7bda$var$boundsLineEnd() {
    $52ebd7c9b7da7bda$var$range[0] = $52ebd7c9b7da7bda$var$lambda0, $52ebd7c9b7da7bda$var$range[1] = $52ebd7c9b7da7bda$var$lambda1;
    $52ebd7c9b7da7bda$var$boundsStream.point = $52ebd7c9b7da7bda$var$boundsPoint;
    $52ebd7c9b7da7bda$var$p0 = null;
}
function $52ebd7c9b7da7bda$var$boundsRingPoint(lambda, phi) {
    if ($52ebd7c9b7da7bda$var$p0) {
        var delta = lambda - $52ebd7c9b7da7bda$var$lambda2;
        $52ebd7c9b7da7bda$var$deltaSum.add((0, $eIlmS.abs)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else $52ebd7c9b7da7bda$var$lambda00 = lambda, $52ebd7c9b7da7bda$var$phi00 = phi;
    (0, $2wdr3.areaStream).point(lambda, phi);
    $52ebd7c9b7da7bda$var$linePoint(lambda, phi);
}
function $52ebd7c9b7da7bda$var$boundsRingStart() {
    (0, $2wdr3.areaStream).lineStart();
}
function $52ebd7c9b7da7bda$var$boundsRingEnd() {
    $52ebd7c9b7da7bda$var$boundsRingPoint($52ebd7c9b7da7bda$var$lambda00, $52ebd7c9b7da7bda$var$phi00);
    (0, $2wdr3.areaStream).lineEnd();
    if ((0, $eIlmS.abs)($52ebd7c9b7da7bda$var$deltaSum) > (0, $eIlmS.epsilon)) $52ebd7c9b7da7bda$var$lambda0 = -($52ebd7c9b7da7bda$var$lambda1 = 180);
    $52ebd7c9b7da7bda$var$range[0] = $52ebd7c9b7da7bda$var$lambda0, $52ebd7c9b7da7bda$var$range[1] = $52ebd7c9b7da7bda$var$lambda1;
    $52ebd7c9b7da7bda$var$p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function $52ebd7c9b7da7bda$var$angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function $52ebd7c9b7da7bda$var$rangeCompare(a, b) {
    return a[0] - b[0];
}
function $52ebd7c9b7da7bda$var$rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}
function $52ebd7c9b7da7bda$export$2e2bcd8739ae039(feature) {
    var i, n, a, b, merged, deltaMax, delta;
    $52ebd7c9b7da7bda$var$phi1 = $52ebd7c9b7da7bda$var$lambda1 = -($52ebd7c9b7da7bda$var$lambda0 = $52ebd7c9b7da7bda$var$phi0 = Infinity);
    $52ebd7c9b7da7bda$var$ranges = [];
    (0, $49NvL.default)(feature, $52ebd7c9b7da7bda$var$boundsStream);
    // First, sort ranges by their minimum longitudes.
    if (n = $52ebd7c9b7da7bda$var$ranges.length) {
        $52ebd7c9b7da7bda$var$ranges.sort($52ebd7c9b7da7bda$var$rangeCompare);
        // Then, merge any ranges that overlap.
        for(i = 1, a = $52ebd7c9b7da7bda$var$ranges[0], merged = [
            a
        ]; i < n; ++i){
            b = $52ebd7c9b7da7bda$var$ranges[i];
            if ($52ebd7c9b7da7bda$var$rangeContains(a, b[0]) || $52ebd7c9b7da7bda$var$rangeContains(a, b[1])) {
                if ($52ebd7c9b7da7bda$var$angle(a[0], b[1]) > $52ebd7c9b7da7bda$var$angle(a[0], a[1])) a[1] = b[1];
                if ($52ebd7c9b7da7bda$var$angle(b[0], a[1]) > $52ebd7c9b7da7bda$var$angle(a[0], a[1])) a[0] = b[0];
            } else merged.push(a = b);
        }
        // Finally, find the largest gap between the merged ranges.
        // The final bounding box will be the inverse of this gap.
        for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
            b = merged[i];
            if ((delta = $52ebd7c9b7da7bda$var$angle(a[1], b[0])) > deltaMax) deltaMax = delta, $52ebd7c9b7da7bda$var$lambda0 = b[0], $52ebd7c9b7da7bda$var$lambda1 = a[1];
        }
    }
    $52ebd7c9b7da7bda$var$ranges = $52ebd7c9b7da7bda$var$range = null;
    return $52ebd7c9b7da7bda$var$lambda0 === Infinity || $52ebd7c9b7da7bda$var$phi0 === Infinity ? [
        [
            NaN,
            NaN
        ],
        [
            NaN,
            NaN
        ]
    ] : [
        [
            $52ebd7c9b7da7bda$var$lambda0,
            $52ebd7c9b7da7bda$var$phi0
        ],
        [
            $52ebd7c9b7da7bda$var$lambda1,
            $52ebd7c9b7da7bda$var$phi1
        ]
    ];
}

});
parcelRegister("8W5ig", function(module, exports) {

$parcel$export(module.exports, "spherical", function () { return $6817d8b6e438bbf2$export$12f9ad44fe773943; });
$parcel$export(module.exports, "cartesian", function () { return $6817d8b6e438bbf2$export$6e6697ef026a96; });
$parcel$export(module.exports, "cartesianDot", function () { return $6817d8b6e438bbf2$export$2ef80f51436a9de9; });
$parcel$export(module.exports, "cartesianCross", function () { return $6817d8b6e438bbf2$export$4763f5351b14293f; });
$parcel$export(module.exports, "cartesianAddInPlace", function () { return $6817d8b6e438bbf2$export$e62eba72fc898eae; });
$parcel$export(module.exports, "cartesianScale", function () { return $6817d8b6e438bbf2$export$52d0ee3fc868d452; });
$parcel$export(module.exports, "cartesianNormalizeInPlace", function () { return $6817d8b6e438bbf2$export$6789498aec2cb34b; });

var $eIlmS = parcelRequire("eIlmS");
function $6817d8b6e438bbf2$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $eIlmS.atan2)(cartesian[1], cartesian[0]),
        (0, $eIlmS.asin)(cartesian[2])
    ];
}
function $6817d8b6e438bbf2$export$6e6697ef026a96(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, $eIlmS.cos)(phi);
    return [
        cosPhi * (0, $eIlmS.cos)(lambda),
        cosPhi * (0, $eIlmS.sin)(lambda),
        (0, $eIlmS.sin)(phi)
    ];
}
function $6817d8b6e438bbf2$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $6817d8b6e438bbf2$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $6817d8b6e438bbf2$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $6817d8b6e438bbf2$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $6817d8b6e438bbf2$export$6789498aec2cb34b(d) {
    var l = (0, $eIlmS.sqrt)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}

});


parcelRegister("2B3kh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e419df535a3dc69$export$2e2bcd8739ae039; });

var $eIlmS = parcelRequire("eIlmS");

var $glE2y = parcelRequire("glE2y");

var $49NvL = parcelRequire("49NvL");
var $1e419df535a3dc69$var$W0, $1e419df535a3dc69$var$W1, $1e419df535a3dc69$var$X0, $1e419df535a3dc69$var$Y0, $1e419df535a3dc69$var$Z0, $1e419df535a3dc69$var$X1, $1e419df535a3dc69$var$Y1, $1e419df535a3dc69$var$Z1, $1e419df535a3dc69$var$X2, $1e419df535a3dc69$var$Y2, $1e419df535a3dc69$var$Z2, $1e419df535a3dc69$var$lambda00, $1e419df535a3dc69$var$phi00, $1e419df535a3dc69$var$x0, $1e419df535a3dc69$var$y0, $1e419df535a3dc69$var$z0; // previous point
var $1e419df535a3dc69$var$centroidStream = {
    sphere: (0, $glE2y.default),
    point: $1e419df535a3dc69$var$centroidPoint,
    lineStart: $1e419df535a3dc69$var$centroidLineStart,
    lineEnd: $1e419df535a3dc69$var$centroidLineEnd,
    polygonStart: function() {
        $1e419df535a3dc69$var$centroidStream.lineStart = $1e419df535a3dc69$var$centroidRingStart;
        $1e419df535a3dc69$var$centroidStream.lineEnd = $1e419df535a3dc69$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $1e419df535a3dc69$var$centroidStream.lineStart = $1e419df535a3dc69$var$centroidLineStart;
        $1e419df535a3dc69$var$centroidStream.lineEnd = $1e419df535a3dc69$var$centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function $1e419df535a3dc69$var$centroidPoint(lambda, phi) {
    lambda *= (0, $eIlmS.radians), phi *= (0, $eIlmS.radians);
    var cosPhi = (0, $eIlmS.cos)(phi);
    $1e419df535a3dc69$var$centroidPointCartesian(cosPhi * (0, $eIlmS.cos)(lambda), cosPhi * (0, $eIlmS.sin)(lambda), (0, $eIlmS.sin)(phi));
}
function $1e419df535a3dc69$var$centroidPointCartesian(x, y, z) {
    ++$1e419df535a3dc69$var$W0;
    $1e419df535a3dc69$var$X0 += (x - $1e419df535a3dc69$var$X0) / $1e419df535a3dc69$var$W0;
    $1e419df535a3dc69$var$Y0 += (y - $1e419df535a3dc69$var$Y0) / $1e419df535a3dc69$var$W0;
    $1e419df535a3dc69$var$Z0 += (z - $1e419df535a3dc69$var$Z0) / $1e419df535a3dc69$var$W0;
}
function $1e419df535a3dc69$var$centroidLineStart() {
    $1e419df535a3dc69$var$centroidStream.point = $1e419df535a3dc69$var$centroidLinePointFirst;
}
function $1e419df535a3dc69$var$centroidLinePointFirst(lambda, phi) {
    lambda *= (0, $eIlmS.radians), phi *= (0, $eIlmS.radians);
    var cosPhi = (0, $eIlmS.cos)(phi);
    $1e419df535a3dc69$var$x0 = cosPhi * (0, $eIlmS.cos)(lambda);
    $1e419df535a3dc69$var$y0 = cosPhi * (0, $eIlmS.sin)(lambda);
    $1e419df535a3dc69$var$z0 = (0, $eIlmS.sin)(phi);
    $1e419df535a3dc69$var$centroidStream.point = $1e419df535a3dc69$var$centroidLinePoint;
    $1e419df535a3dc69$var$centroidPointCartesian($1e419df535a3dc69$var$x0, $1e419df535a3dc69$var$y0, $1e419df535a3dc69$var$z0);
}
function $1e419df535a3dc69$var$centroidLinePoint(lambda, phi) {
    lambda *= (0, $eIlmS.radians), phi *= (0, $eIlmS.radians);
    var cosPhi = (0, $eIlmS.cos)(phi), x = cosPhi * (0, $eIlmS.cos)(lambda), y = cosPhi * (0, $eIlmS.sin)(lambda), z = (0, $eIlmS.sin)(phi), w = (0, $eIlmS.atan2)((0, $eIlmS.sqrt)((w = $1e419df535a3dc69$var$y0 * z - $1e419df535a3dc69$var$z0 * y) * w + (w = $1e419df535a3dc69$var$z0 * x - $1e419df535a3dc69$var$x0 * z) * w + (w = $1e419df535a3dc69$var$x0 * y - $1e419df535a3dc69$var$y0 * x) * w), $1e419df535a3dc69$var$x0 * x + $1e419df535a3dc69$var$y0 * y + $1e419df535a3dc69$var$z0 * z);
    $1e419df535a3dc69$var$W1 += w;
    $1e419df535a3dc69$var$X1 += w * ($1e419df535a3dc69$var$x0 + ($1e419df535a3dc69$var$x0 = x));
    $1e419df535a3dc69$var$Y1 += w * ($1e419df535a3dc69$var$y0 + ($1e419df535a3dc69$var$y0 = y));
    $1e419df535a3dc69$var$Z1 += w * ($1e419df535a3dc69$var$z0 + ($1e419df535a3dc69$var$z0 = z));
    $1e419df535a3dc69$var$centroidPointCartesian($1e419df535a3dc69$var$x0, $1e419df535a3dc69$var$y0, $1e419df535a3dc69$var$z0);
}
function $1e419df535a3dc69$var$centroidLineEnd() {
    $1e419df535a3dc69$var$centroidStream.point = $1e419df535a3dc69$var$centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function $1e419df535a3dc69$var$centroidRingStart() {
    $1e419df535a3dc69$var$centroidStream.point = $1e419df535a3dc69$var$centroidRingPointFirst;
}
function $1e419df535a3dc69$var$centroidRingEnd() {
    $1e419df535a3dc69$var$centroidRingPoint($1e419df535a3dc69$var$lambda00, $1e419df535a3dc69$var$phi00);
    $1e419df535a3dc69$var$centroidStream.point = $1e419df535a3dc69$var$centroidPoint;
}
function $1e419df535a3dc69$var$centroidRingPointFirst(lambda, phi) {
    $1e419df535a3dc69$var$lambda00 = lambda, $1e419df535a3dc69$var$phi00 = phi;
    lambda *= (0, $eIlmS.radians), phi *= (0, $eIlmS.radians);
    $1e419df535a3dc69$var$centroidStream.point = $1e419df535a3dc69$var$centroidRingPoint;
    var cosPhi = (0, $eIlmS.cos)(phi);
    $1e419df535a3dc69$var$x0 = cosPhi * (0, $eIlmS.cos)(lambda);
    $1e419df535a3dc69$var$y0 = cosPhi * (0, $eIlmS.sin)(lambda);
    $1e419df535a3dc69$var$z0 = (0, $eIlmS.sin)(phi);
    $1e419df535a3dc69$var$centroidPointCartesian($1e419df535a3dc69$var$x0, $1e419df535a3dc69$var$y0, $1e419df535a3dc69$var$z0);
}
function $1e419df535a3dc69$var$centroidRingPoint(lambda, phi) {
    lambda *= (0, $eIlmS.radians), phi *= (0, $eIlmS.radians);
    var cosPhi = (0, $eIlmS.cos)(phi), x = cosPhi * (0, $eIlmS.cos)(lambda), y = cosPhi * (0, $eIlmS.sin)(lambda), z = (0, $eIlmS.sin)(phi), cx = $1e419df535a3dc69$var$y0 * z - $1e419df535a3dc69$var$z0 * y, cy = $1e419df535a3dc69$var$z0 * x - $1e419df535a3dc69$var$x0 * z, cz = $1e419df535a3dc69$var$x0 * y - $1e419df535a3dc69$var$y0 * x, m = (0, $eIlmS.sqrt)(cx * cx + cy * cy + cz * cz), w = (0, $eIlmS.asin)(m), v = m && -w / m; // area weight multiplier
    $1e419df535a3dc69$var$X2 += v * cx;
    $1e419df535a3dc69$var$Y2 += v * cy;
    $1e419df535a3dc69$var$Z2 += v * cz;
    $1e419df535a3dc69$var$W1 += w;
    $1e419df535a3dc69$var$X1 += w * ($1e419df535a3dc69$var$x0 + ($1e419df535a3dc69$var$x0 = x));
    $1e419df535a3dc69$var$Y1 += w * ($1e419df535a3dc69$var$y0 + ($1e419df535a3dc69$var$y0 = y));
    $1e419df535a3dc69$var$Z1 += w * ($1e419df535a3dc69$var$z0 + ($1e419df535a3dc69$var$z0 = z));
    $1e419df535a3dc69$var$centroidPointCartesian($1e419df535a3dc69$var$x0, $1e419df535a3dc69$var$y0, $1e419df535a3dc69$var$z0);
}
function $1e419df535a3dc69$export$2e2bcd8739ae039(object) {
    $1e419df535a3dc69$var$W0 = $1e419df535a3dc69$var$W1 = $1e419df535a3dc69$var$X0 = $1e419df535a3dc69$var$Y0 = $1e419df535a3dc69$var$Z0 = $1e419df535a3dc69$var$X1 = $1e419df535a3dc69$var$Y1 = $1e419df535a3dc69$var$Z1 = $1e419df535a3dc69$var$X2 = $1e419df535a3dc69$var$Y2 = $1e419df535a3dc69$var$Z2 = 0;
    (0, $49NvL.default)(object, $1e419df535a3dc69$var$centroidStream);
    var x = $1e419df535a3dc69$var$X2, y = $1e419df535a3dc69$var$Y2, z = $1e419df535a3dc69$var$Z2, m = x * x + y * y + z * z;
    // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
    if (m < (0, $eIlmS.epsilon2)) {
        x = $1e419df535a3dc69$var$X1, y = $1e419df535a3dc69$var$Y1, z = $1e419df535a3dc69$var$Z1;
        // If the feature has zero length, fall back to arithmetic mean of point vectors.
        if ($1e419df535a3dc69$var$W1 < (0, $eIlmS.epsilon)) x = $1e419df535a3dc69$var$X0, y = $1e419df535a3dc69$var$Y0, z = $1e419df535a3dc69$var$Z0;
        m = x * x + y * y + z * z;
        // If the feature still has an undefined ccentroid, then return.
        if (m < (0, $eIlmS.epsilon2)) return [
            NaN,
            NaN
        ];
    }
    return [
        (0, $eIlmS.atan2)(y, x) * (0, $eIlmS.degrees),
        (0, $eIlmS.asin)(z / (0, $eIlmS.sqrt)(m)) * (0, $eIlmS.degrees)
    ];
}

});

parcelRegister("jJ2ZT", function(module, exports) {

$parcel$export(module.exports, "circleStream", function () { return $e5c48b77e5a8e7cb$export$b5441eb324cd8d4e; });
$parcel$export(module.exports, "default", function () { return $e5c48b77e5a8e7cb$export$2e2bcd8739ae039; });

var $8W5ig = parcelRequire("8W5ig");

var $9rEoN = parcelRequire("9rEoN");

var $eIlmS = parcelRequire("eIlmS");

var $5GRgV = parcelRequire("5GRgV");
function $e5c48b77e5a8e7cb$export$b5441eb324cd8d4e(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, $eIlmS.cos)(radius), sinRadius = (0, $eIlmS.sin)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, $eIlmS.tau);
        t1 = radius - step / 2;
    } else {
        t0 = $e5c48b77e5a8e7cb$var$circleRadius(cosRadius, t0);
        t1 = $e5c48b77e5a8e7cb$var$circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, $eIlmS.tau);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, $8W5ig.spherical)([
            cosRadius,
            -sinRadius * (0, $eIlmS.cos)(t),
            -sinRadius * (0, $eIlmS.sin)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function $e5c48b77e5a8e7cb$var$circleRadius(cosRadius, point) {
    point = (0, $8W5ig.cartesian)(point), point[0] -= cosRadius;
    (0, $8W5ig.cartesianNormalizeInPlace)(point);
    var radius = (0, $eIlmS.acos)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, $eIlmS.tau) - (0, $eIlmS.epsilon)) % (0, $eIlmS.tau);
}
function $e5c48b77e5a8e7cb$export$2e2bcd8739ae039() {
    var center = (0, $9rEoN.default)([
        0,
        0
    ]), radius = (0, $9rEoN.default)(90), precision = (0, $9rEoN.default)(6), ring, rotate, stream = {
        point: point
    };
    function point(x, y) {
        ring.push(x = rotate(x, y));
        x[0] *= (0, $eIlmS.degrees), x[1] *= (0, $eIlmS.degrees);
    }
    function circle() {
        var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, $eIlmS.radians), p = precision.apply(this, arguments) * (0, $eIlmS.radians);
        ring = [];
        rotate = (0, $5GRgV.rotateRadians)(-c[0] * (0, $eIlmS.radians), -c[1] * (0, $eIlmS.radians), 0).invert;
        $e5c48b77e5a8e7cb$export$b5441eb324cd8d4e(stream, r, p, 1);
        c = {
            type: "Polygon",
            coordinates: [
                ring
            ]
        };
        ring = rotate = null;
        return c;
    }
    circle.center = function(_) {
        return arguments.length ? (center = typeof _ === "function" ? _ : (0, $9rEoN.default)([
            +_[0],
            +_[1]
        ]), circle) : center;
    };
    circle.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $9rEoN.default)(+_), circle) : radius;
    };
    circle.precision = function(_) {
        return arguments.length ? (precision = typeof _ === "function" ? _ : (0, $9rEoN.default)(+_), circle) : precision;
    };
    return circle;
}

});
parcelRegister("9rEoN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e05f913c83f5ba1$export$2e2bcd8739ae039; });
function $6e05f913c83f5ba1$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("5GRgV", function(module, exports) {

$parcel$export(module.exports, "rotateRadians", function () { return $424a32b8da9bbbeb$export$a2ba89726971a90f; });
$parcel$export(module.exports, "default", function () { return $424a32b8da9bbbeb$export$2e2bcd8739ae039; });

var $6nGZZ = parcelRequire("6nGZZ");

var $eIlmS = parcelRequire("eIlmS");
function $424a32b8da9bbbeb$var$rotationIdentity(lambda, phi) {
    return [
        (0, $eIlmS.abs)(lambda) > (0, $eIlmS.pi) ? lambda + Math.round(-lambda / (0, $eIlmS.tau)) * (0, $eIlmS.tau) : lambda,
        phi
    ];
}
$424a32b8da9bbbeb$var$rotationIdentity.invert = $424a32b8da9bbbeb$var$rotationIdentity;
function $424a32b8da9bbbeb$export$a2ba89726971a90f(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, $eIlmS.tau)) ? deltaPhi || deltaGamma ? (0, $6nGZZ.default)($424a32b8da9bbbeb$var$rotationLambda(deltaLambda), $424a32b8da9bbbeb$var$rotationPhiGamma(deltaPhi, deltaGamma)) : $424a32b8da9bbbeb$var$rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? $424a32b8da9bbbeb$var$rotationPhiGamma(deltaPhi, deltaGamma) : $424a32b8da9bbbeb$var$rotationIdentity;
}
function $424a32b8da9bbbeb$var$forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        return lambda += deltaLambda, [
            lambda > (0, $eIlmS.pi) ? lambda - (0, $eIlmS.tau) : lambda < -(0, $eIlmS.pi) ? lambda + (0, $eIlmS.tau) : lambda,
            phi
        ];
    };
}
function $424a32b8da9bbbeb$var$rotationLambda(deltaLambda) {
    var rotation = $424a32b8da9bbbeb$var$forwardRotationLambda(deltaLambda);
    rotation.invert = $424a32b8da9bbbeb$var$forwardRotationLambda(-deltaLambda);
    return rotation;
}
function $424a32b8da9bbbeb$var$rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, $eIlmS.cos)(deltaPhi), sinDeltaPhi = (0, $eIlmS.sin)(deltaPhi), cosDeltaGamma = (0, $eIlmS.cos)(deltaGamma), sinDeltaGamma = (0, $eIlmS.sin)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, $eIlmS.cos)(phi), x = (0, $eIlmS.cos)(lambda) * cosPhi, y = (0, $eIlmS.sin)(lambda) * cosPhi, z = (0, $eIlmS.sin)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, $eIlmS.atan2)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, $eIlmS.asin)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, $eIlmS.cos)(phi), x = (0, $eIlmS.cos)(lambda) * cosPhi, y = (0, $eIlmS.sin)(lambda) * cosPhi, z = (0, $eIlmS.sin)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, $eIlmS.atan2)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, $eIlmS.asin)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}
function $424a32b8da9bbbeb$export$2e2bcd8739ae039(rotate) {
    rotate = $424a32b8da9bbbeb$export$a2ba89726971a90f(rotate[0] * (0, $eIlmS.radians), rotate[1] * (0, $eIlmS.radians), rotate.length > 2 ? rotate[2] * (0, $eIlmS.radians) : 0);
    function forward(coordinates) {
        coordinates = rotate(coordinates[0] * (0, $eIlmS.radians), coordinates[1] * (0, $eIlmS.radians));
        return coordinates[0] *= (0, $eIlmS.degrees), coordinates[1] *= (0, $eIlmS.degrees), coordinates;
    }
    forward.invert = function(coordinates) {
        coordinates = rotate.invert(coordinates[0] * (0, $eIlmS.radians), coordinates[1] * (0, $eIlmS.radians));
        return coordinates[0] *= (0, $eIlmS.degrees), coordinates[1] *= (0, $eIlmS.degrees), coordinates;
    };
    return forward;
}

});
parcelRegister("6nGZZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a563eb784e3b91c$export$2e2bcd8739ae039; });
function $4a563eb784e3b91c$export$2e2bcd8739ae039(a, b) {
    function compose(x, y) {
        return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
        return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
}

});



parcelRegister("90zbe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68ef67343b0f554a$export$2e2bcd8739ae039; });

var $ft1jw = parcelRequire("ft1jw");

var $eIlmS = parcelRequire("eIlmS");
var $68ef67343b0f554a$export$2e2bcd8739ae039 = (0, $ft1jw.default)(function() {
    return true;
}, $68ef67343b0f554a$var$clipAntimeridianLine, $68ef67343b0f554a$var$clipAntimeridianInterpolate, [
    -(0, $eIlmS.pi),
    -(0, $eIlmS.halfPi)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function $68ef67343b0f554a$var$clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, $eIlmS.pi) : -(0, $eIlmS.pi), delta = (0, $eIlmS.abs)(lambda1 - lambda0);
            if ((0, $eIlmS.abs)(delta - (0, $eIlmS.pi)) < (0, $eIlmS.epsilon)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, $eIlmS.halfPi) : -(0, $eIlmS.halfPi));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, $eIlmS.pi)) {
                if ((0, $eIlmS.abs)(lambda0 - sign0) < (0, $eIlmS.epsilon)) lambda0 -= sign0 * (0, $eIlmS.epsilon); // handle degeneracies
                if ((0, $eIlmS.abs)(lambda1 - sign1) < (0, $eIlmS.epsilon)) lambda1 -= sign1 * (0, $eIlmS.epsilon);
                phi0 = $68ef67343b0f554a$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function $68ef67343b0f554a$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, $eIlmS.sin)(lambda0 - lambda1);
    return (0, $eIlmS.abs)(sinLambda0Lambda1) > (0, $eIlmS.epsilon) ? (0, $eIlmS.atan)(((0, $eIlmS.sin)(phi0) * (cosPhi1 = (0, $eIlmS.cos)(phi1)) * (0, $eIlmS.sin)(lambda1) - (0, $eIlmS.sin)(phi1) * (cosPhi0 = (0, $eIlmS.cos)(phi0)) * (0, $eIlmS.sin)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function $68ef67343b0f554a$var$clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, $eIlmS.halfPi);
        stream.point(-(0, $eIlmS.pi), phi);
        stream.point(0, phi);
        stream.point((0, $eIlmS.pi), phi);
        stream.point((0, $eIlmS.pi), 0);
        stream.point((0, $eIlmS.pi), -phi);
        stream.point(0, -phi);
        stream.point(-(0, $eIlmS.pi), -phi);
        stream.point(-(0, $eIlmS.pi), 0);
        stream.point(-(0, $eIlmS.pi), phi);
    } else if ((0, $eIlmS.abs)(from[0] - to[0]) > (0, $eIlmS.epsilon)) {
        var lambda = from[0] < to[0] ? (0, $eIlmS.pi) : -(0, $eIlmS.pi);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}

});
parcelRegister("ft1jw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b42a9559c7fabd9f$export$2e2bcd8739ae039; });

var $lgcTD = parcelRequire("lgcTD");

var $6ta0a = parcelRequire("6ta0a");

var $eIlmS = parcelRequire("eIlmS");

var $eRlCV = parcelRequire("eRlCV");
parcelRequire("9f3pr");
var $saVys = parcelRequire("saVys");
function $b42a9559c7fabd9f$export$2e2bcd8739ae039(pointVisible, clipLine, interpolate, start) {
    return function(sink) {
        var line = clipLine(sink), ringBuffer = (0, $lgcTD.default)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
        var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                clip.point = pointRing;
                clip.lineStart = ringStart;
                clip.lineEnd = ringEnd;
                segments = [];
                polygon = [];
            },
            polygonEnd: function() {
                clip.point = point;
                clip.lineStart = lineStart;
                clip.lineEnd = lineEnd;
                segments = (0, $saVys.default)(segments);
                var startInside = (0, $eRlCV.default)(polygon, start);
                if (segments.length) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    (0, $6ta0a.default)(segments, $b42a9559c7fabd9f$var$compareIntersection, startInside, interpolate, sink);
                } else if (startInside) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                }
                if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                segments = polygon = null;
            },
            sphere: function() {
                sink.polygonStart();
                sink.lineStart();
                interpolate(null, null, 1, sink);
                sink.lineEnd();
                sink.polygonEnd();
            }
        };
        function point(lambda, phi) {
            if (pointVisible(lambda, phi)) sink.point(lambda, phi);
        }
        function pointLine(lambda, phi) {
            line.point(lambda, phi);
        }
        function lineStart() {
            clip.point = pointLine;
            line.lineStart();
        }
        function lineEnd() {
            clip.point = point;
            line.lineEnd();
        }
        function pointRing(lambda, phi) {
            ring.push([
                lambda,
                phi
            ]);
            ringSink.point(lambda, phi);
        }
        function ringStart() {
            ringSink.lineStart();
            ring = [];
        }
        function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringSink.lineEnd();
            var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n) return;
            // No intersections.
            if (clean & 1) {
                segment = ringSegments[0];
                if ((m = segment.length - 1) > 0) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                    sink.lineEnd();
                }
                return;
            }
            // Rejoin connected segments.
            // TODO reuse ringBuffer.rejoin()?
            if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter($b42a9559c7fabd9f$var$validSegment));
        }
        return clip;
    };
}
function $b42a9559c7fabd9f$var$validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function $b42a9559c7fabd9f$var$compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, $eIlmS.halfPi) - (0, $eIlmS.epsilon) : (0, $eIlmS.halfPi) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, $eIlmS.halfPi) - (0, $eIlmS.epsilon) : (0, $eIlmS.halfPi) - b[1]);
}

});
parcelRegister("lgcTD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7a5188a6c590bf9$export$2e2bcd8739ae039; });

var $glE2y = parcelRequire("glE2y");
function $f7a5188a6c590bf9$export$2e2bcd8739ae039() {
    var lines = [], line;
    return {
        point: function(x, y, m) {
            line.push([
                x,
                y,
                m
            ]);
        },
        lineStart: function() {
            lines.push(line = []);
        },
        lineEnd: (0, $glE2y.default),
        rejoin: function() {
            if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
        },
        result: function() {
            var result = lines;
            lines = [];
            line = null;
            return result;
        }
    };
}

});

parcelRegister("6ta0a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b5d35a7bacd3b02$export$2e2bcd8739ae039; });

var $bRZb6 = parcelRequire("bRZb6");

var $eIlmS = parcelRequire("eIlmS");
function $4b5d35a7bacd3b02$var$Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function $4b5d35a7bacd3b02$export$2e2bcd8739ae039(segments, compareIntersection, startInside, interpolate, stream) {
    var subject = [], clip = [], i, n;
    segments.forEach(function(segment) {
        if ((n = segment.length - 1) <= 0) return;
        var n, p0 = segment[0], p1 = segment[n], x;
        if ((0, $bRZb6.default)(p0, p1)) {
            if (!p0[2] && !p1[2]) {
                stream.lineStart();
                for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                stream.lineEnd();
                return;
            }
            // handle degenerate cases by moving the point
            p1[0] += 2 * (0, $eIlmS.epsilon);
        }
        subject.push(x = new $4b5d35a7bacd3b02$var$Intersection(p0, segment, null, true));
        clip.push(x.o = new $4b5d35a7bacd3b02$var$Intersection(p0, null, x, false));
        subject.push(x = new $4b5d35a7bacd3b02$var$Intersection(p1, segment, null, false));
        clip.push(x.o = new $4b5d35a7bacd3b02$var$Intersection(p1, null, x, true));
    });
    if (!subject.length) return;
    clip.sort(compareIntersection);
    $4b5d35a7bacd3b02$var$link(subject);
    $4b5d35a7bacd3b02$var$link(clip);
    for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
    var start = subject[0], points, point;
    while(true){
        // Find first unvisited intersection.
        var current = start, isSubject = true;
        while(current.v)if ((current = current.n) === start) return;
        points = current.z;
        stream.lineStart();
        do {
            current.v = current.o.v = true;
            if (current.e) {
                if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                else interpolate(current.x, current.n.x, 1, stream);
                current = current.n;
            } else {
                if (isSubject) {
                    points = current.p.z;
                    for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                } else interpolate(current.x, current.p.x, -1, stream);
                current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
        }while (!current.v);
        stream.lineEnd();
    }
}
function $4b5d35a7bacd3b02$var$link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}

});
parcelRegister("bRZb6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a4419a6470b10ea$export$2e2bcd8739ae039; });

var $eIlmS = parcelRequire("eIlmS");
function $8a4419a6470b10ea$export$2e2bcd8739ae039(a, b) {
    return (0, $eIlmS.abs)(a[0] - b[0]) < (0, $eIlmS.epsilon) && (0, $eIlmS.abs)(a[1] - b[1]) < (0, $eIlmS.epsilon);
}

});


parcelRegister("eRlCV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad16ca8caf3b1845$export$2e2bcd8739ae039; });

var $1wbR2 = parcelRequire("1wbR2");

var $8W5ig = parcelRequire("8W5ig");

var $eIlmS = parcelRequire("eIlmS");
var $ad16ca8caf3b1845$var$sum = (0, $1wbR2.default)();
function $ad16ca8caf3b1845$var$longitude(point) {
    if ((0, $eIlmS.abs)(point[0]) <= (0, $eIlmS.pi)) return point[0];
    else return (0, $eIlmS.sign)(point[0]) * (((0, $eIlmS.abs)(point[0]) + (0, $eIlmS.pi)) % (0, $eIlmS.tau) - (0, $eIlmS.pi));
}
function $ad16ca8caf3b1845$export$2e2bcd8739ae039(polygon, point) {
    var lambda = $ad16ca8caf3b1845$var$longitude(point), phi = point[1], sinPhi = (0, $eIlmS.sin)(phi), normal = [
        (0, $eIlmS.sin)(lambda),
        -(0, $eIlmS.cos)(lambda),
        0
    ], angle = 0, winding = 0;
    $ad16ca8caf3b1845$var$sum.reset();
    if (sinPhi === 1) phi = (0, $eIlmS.halfPi) + (0, $eIlmS.epsilon);
    else if (sinPhi === -1) phi = -(0, $eIlmS.halfPi) - (0, $eIlmS.epsilon);
    for(var i = 0, n = polygon.length; i < n; ++i){
        if (!(m = (ring = polygon[i]).length)) continue;
        var ring, m, point0 = ring[m - 1], lambda0 = $ad16ca8caf3b1845$var$longitude(point0), phi0 = point0[1] / 2 + (0, $eIlmS.quarterPi), sinPhi0 = (0, $eIlmS.sin)(phi0), cosPhi0 = (0, $eIlmS.cos)(phi0);
        for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
            var point1 = ring[j], lambda1 = $ad16ca8caf3b1845$var$longitude(point1), phi1 = point1[1] / 2 + (0, $eIlmS.quarterPi), sinPhi1 = (0, $eIlmS.sin)(phi1), cosPhi1 = (0, $eIlmS.cos)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, $eIlmS.pi), k = sinPhi0 * sinPhi1;
            $ad16ca8caf3b1845$var$sum.add((0, $eIlmS.atan2)(k * sign * (0, $eIlmS.sin)(absDelta), cosPhi0 * cosPhi1 + k * (0, $eIlmS.cos)(absDelta)));
            angle += antimeridian ? delta + sign * (0, $eIlmS.tau) : delta;
            // Are the longitudes either side of the point’s meridian (lambda),
            // and are the latitudes smaller than the parallel (phi)?
            if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                var arc = (0, $8W5ig.cartesianCross)((0, $8W5ig.cartesian)(point0), (0, $8W5ig.cartesian)(point1));
                (0, $8W5ig.cartesianNormalizeInPlace)(arc);
                var intersection = (0, $8W5ig.cartesianCross)(normal, arc);
                (0, $8W5ig.cartesianNormalizeInPlace)(intersection);
                var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, $eIlmS.asin)(intersection[2]);
                if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
            }
        }
    }
    // First, determine whether the South pole is inside or outside:
    //
    // It is inside if:
    // * the polygon winds around it in a clockwise direction.
    // * the polygon does not (cumulatively) wind around it, but has a negative
    //   (counter-clockwise) area.
    //
    // Second, count the (signed) number of times a segment crosses a lambda
    // from the point to the South pole.  If it is zero, then the point is the
    // same side as the South pole.
    return (angle < -(0, $eIlmS.epsilon) || angle < (0, $eIlmS.epsilon) && $ad16ca8caf3b1845$var$sum < -(0, $eIlmS.epsilon)) ^ winding & 1;
}

});



parcelRegister("jDEoe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4c0fd6eae1b33e7$export$2e2bcd8739ae039; });

var $8W5ig = parcelRequire("8W5ig");

var $jJ2ZT = parcelRequire("jJ2ZT");

var $eIlmS = parcelRequire("eIlmS");

var $bRZb6 = parcelRequire("bRZb6");

var $ft1jw = parcelRequire("ft1jw");
function $e4c0fd6eae1b33e7$export$2e2bcd8739ae039(radius) {
    var cr = (0, $eIlmS.cos)(radius), delta = 6 * (0, $eIlmS.radians), smallRadius = cr > 0, notHemisphere = (0, $eIlmS.abs)(cr) > (0, $eIlmS.epsilon); // TODO optimise for this common case
    function interpolate(from, to, direction, stream) {
        (0, $jJ2ZT.circleStream)(stream, radius, delta, direction, from, to);
    }
    function visible(lambda, phi) {
        return (0, $eIlmS.cos)(lambda) * (0, $eIlmS.cos)(phi) > cr;
    }
    // Takes a line and cuts into visible segments. Return values used for polygon
    // clipping: 0 - there were intersections or the line was empty; 1 - no
    // intersections 2 - there were intersections, and the first and last segments
    // should be rejoined.
    function clipLine(stream) {
        var point0, c0, v0, v00, clean; // no intersections
        return {
            lineStart: function() {
                v00 = v0 = false;
                clean = 1;
            },
            point: function(lambda, phi) {
                var point1 = [
                    lambda,
                    phi
                ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, $eIlmS.pi) : -(0, $eIlmS.pi)), phi) : 0;
                if (!point0 && (v00 = v0 = v)) stream.lineStart();
                if (v !== v0) {
                    point2 = intersect(point0, point1);
                    if (!point2 || (0, $bRZb6.default)(point0, point2) || (0, $bRZb6.default)(point1, point2)) point1[2] = 1;
                }
                if (v !== v0) {
                    clean = 0;
                    if (v) {
                        // outside going in
                        stream.lineStart();
                        point2 = intersect(point1, point0);
                        stream.point(point2[0], point2[1]);
                    } else {
                        // inside going out
                        point2 = intersect(point0, point1);
                        stream.point(point2[0], point2[1], 2);
                        stream.lineEnd();
                    }
                    point0 = point2;
                } else if (notHemisphere && point0 && smallRadius ^ v) {
                    var t;
                    // If the codes for two points are different, or are both zero,
                    // and there this segment intersects with the small circle.
                    if (!(c & c0) && (t = intersect(point1, point0, true))) {
                        clean = 0;
                        if (smallRadius) {
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                        } else {
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1], 3);
                        }
                    }
                }
                if (v && (!point0 || !(0, $bRZb6.default)(point0, point1))) stream.point(point1[0], point1[1]);
                point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function() {
                if (v0) stream.lineEnd();
                point0 = null;
            },
            // Rejoin first and last segments if there were intersections and the first
            // and last points were visible.
            clean: function() {
                return clean | (v00 && v0) << 1;
            }
        };
    }
    // Intersects the great circle between a and b with the clip circle.
    function intersect(a, b, two) {
        var pa = (0, $8W5ig.cartesian)(a), pb = (0, $8W5ig.cartesian)(b);
        // We have two planes, n1.p = d1 and n2.p = d2.
        // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
        var n1 = [
            1,
            0,
            0
        ], n2 = (0, $8W5ig.cartesianCross)(pa, pb), n2n2 = (0, $8W5ig.cartesianDot)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
        // Two polar points.
        if (!determinant) return !two && a;
        var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, $8W5ig.cartesianCross)(n1, n2), A = (0, $8W5ig.cartesianScale)(n1, c1), B = (0, $8W5ig.cartesianScale)(n2, c2);
        (0, $8W5ig.cartesianAddInPlace)(A, B);
        // Solve |p(t)|^2 = 1.
        var u = n1xn2, w = (0, $8W5ig.cartesianDot)(A, u), uu = (0, $8W5ig.cartesianDot)(u, u), t2 = w * w - uu * ((0, $8W5ig.cartesianDot)(A, A) - 1);
        if (t2 < 0) return;
        var t = (0, $eIlmS.sqrt)(t2), q = (0, $8W5ig.cartesianScale)(u, (-w - t) / uu);
        (0, $8W5ig.cartesianAddInPlace)(q, A);
        q = (0, $8W5ig.spherical)(q);
        if (!two) return q;
        // Two intersection points.
        var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
        if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
        var delta = lambda1 - lambda0, polar = (0, $eIlmS.abs)(delta - (0, $eIlmS.pi)) < (0, $eIlmS.epsilon), meridian = polar || delta < (0, $eIlmS.epsilon);
        if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
        // Check that the first point is between a and b.
        if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, $eIlmS.abs)(q[0] - lambda0) < (0, $eIlmS.epsilon) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, $eIlmS.pi) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
            var q1 = (0, $8W5ig.cartesianScale)(u, (-w + t) / uu);
            (0, $8W5ig.cartesianAddInPlace)(q1, A);
            return [
                q,
                (0, $8W5ig.spherical)(q1)
            ];
        }
    }
    // Generates a 4-bit vector representing the location of a point relative to
    // the small circle's bounding box.
    function code(lambda, phi) {
        var r = smallRadius ? radius : (0, $eIlmS.pi) - radius, code = 0;
        if (lambda < -r) code |= 1; // left
        else if (lambda > r) code |= 2; // right
        if (phi < -r) code |= 4; // below
        else if (phi > r) code |= 8; // above
        return code;
    }
    return (0, $ft1jw.default)(visible, clipLine, interpolate, smallRadius ? [
        0,
        -radius
    ] : [
        -(0, $eIlmS.pi),
        radius - (0, $eIlmS.pi)
    ]);
}

});

parcelRegister("g4GnW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb3de5dffe19c349$export$2e2bcd8739ae039; });

var $3AeFV = parcelRequire("3AeFV");
function $bb3de5dffe19c349$export$2e2bcd8739ae039() {
    var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
    return clip = {
        stream: function(stream) {
            return cache && cacheStream === stream ? cache : cache = (0, $3AeFV.default)(x0, y0, x1, y1)(cacheStream = stream);
        },
        extent: function(_) {
            return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        }
    };
}

});
parcelRegister("3AeFV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29c01e11dcbe7333$export$2e2bcd8739ae039; });

var $eIlmS = parcelRequire("eIlmS");

var $lgcTD = parcelRequire("lgcTD");

var $jwT3g = parcelRequire("jwT3g");

var $6ta0a = parcelRequire("6ta0a");
parcelRequire("9f3pr");
var $saVys = parcelRequire("saVys");
var $29c01e11dcbe7333$var$clipMax = 1e9, $29c01e11dcbe7333$var$clipMin = -$29c01e11dcbe7333$var$clipMax;
function $29c01e11dcbe7333$export$2e2bcd8739ae039(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, $eIlmS.abs)(p[0] - x0) < (0, $eIlmS.epsilon) ? direction > 0 ? 0 : 3 : (0, $eIlmS.abs)(p[0] - x1) < (0, $eIlmS.epsilon) ? direction > 0 ? 2 : 1 : (0, $eIlmS.abs)(p[1] - y0) < (0, $eIlmS.epsilon) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, $lgcTD.default)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, $saVys.default)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, $6ta0a.default)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max($29c01e11dcbe7333$var$clipMin, Math.min($29c01e11dcbe7333$var$clipMax, x_)),
                    y_ = Math.max($29c01e11dcbe7333$var$clipMin, Math.min($29c01e11dcbe7333$var$clipMax, y_))
                ], b = [
                    x = Math.max($29c01e11dcbe7333$var$clipMin, Math.min($29c01e11dcbe7333$var$clipMax, x)),
                    y = Math.max($29c01e11dcbe7333$var$clipMin, Math.min($29c01e11dcbe7333$var$clipMax, y))
                ];
                if ((0, $jwT3g.default)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}

});
parcelRegister("jwT3g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e37bb5905fedbded$export$2e2bcd8739ae039; });
function $e37bb5905fedbded$export$2e2bcd8739ae039(a, b, x0, y0, x1, y1) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
    if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
    return true;
}

});



parcelRegister("fkxFc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b292d61f8bcc374e$export$2e2bcd8739ae039; });

var $eRlCV = parcelRequire("eRlCV");

var $dPoCQ = parcelRequire("dPoCQ");

var $eIlmS = parcelRequire("eIlmS");
var $b292d61f8bcc374e$var$containsObjectType = {
    Feature: function(object, point) {
        return $b292d61f8bcc374e$var$containsGeometry(object.geometry, point);
    },
    FeatureCollection: function(object, point) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)if ($b292d61f8bcc374e$var$containsGeometry(features[i].geometry, point)) return true;
        return false;
    }
};
var $b292d61f8bcc374e$var$containsGeometryType = {
    Sphere: function() {
        return true;
    },
    Point: function(object, point) {
        return $b292d61f8bcc374e$var$containsPoint(object.coordinates, point);
    },
    MultiPoint: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($b292d61f8bcc374e$var$containsPoint(coordinates[i], point)) return true;
        return false;
    },
    LineString: function(object, point) {
        return $b292d61f8bcc374e$var$containsLine(object.coordinates, point);
    },
    MultiLineString: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($b292d61f8bcc374e$var$containsLine(coordinates[i], point)) return true;
        return false;
    },
    Polygon: function(object, point) {
        return $b292d61f8bcc374e$var$containsPolygon(object.coordinates, point);
    },
    MultiPolygon: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($b292d61f8bcc374e$var$containsPolygon(coordinates[i], point)) return true;
        return false;
    },
    GeometryCollection: function(object, point) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)if ($b292d61f8bcc374e$var$containsGeometry(geometries[i], point)) return true;
        return false;
    }
};
function $b292d61f8bcc374e$var$containsGeometry(geometry, point) {
    return geometry && $b292d61f8bcc374e$var$containsGeometryType.hasOwnProperty(geometry.type) ? $b292d61f8bcc374e$var$containsGeometryType[geometry.type](geometry, point) : false;
}
function $b292d61f8bcc374e$var$containsPoint(coordinates, point) {
    return (0, $dPoCQ.default)(coordinates, point) === 0;
}
function $b292d61f8bcc374e$var$containsLine(coordinates, point) {
    var ao, bo, ab;
    for(var i = 0, n = coordinates.length; i < n; i++){
        bo = (0, $dPoCQ.default)(coordinates[i], point);
        if (bo === 0) return true;
        if (i > 0) {
            ab = (0, $dPoCQ.default)(coordinates[i], coordinates[i - 1]);
            if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < (0, $eIlmS.epsilon2) * ab) return true;
        }
        ao = bo;
    }
    return false;
}
function $b292d61f8bcc374e$var$containsPolygon(coordinates, point) {
    return !!(0, $eRlCV.default)(coordinates.map($b292d61f8bcc374e$var$ringRadians), $b292d61f8bcc374e$var$pointRadians(point));
}
function $b292d61f8bcc374e$var$ringRadians(ring) {
    return ring = ring.map($b292d61f8bcc374e$var$pointRadians), ring.pop(), ring;
}
function $b292d61f8bcc374e$var$pointRadians(point) {
    return [
        point[0] * (0, $eIlmS.radians),
        point[1] * (0, $eIlmS.radians)
    ];
}
function $b292d61f8bcc374e$export$2e2bcd8739ae039(object, point) {
    return (object && $b292d61f8bcc374e$var$containsObjectType.hasOwnProperty(object.type) ? $b292d61f8bcc374e$var$containsObjectType[object.type] : $b292d61f8bcc374e$var$containsGeometry)(object, point);
}

});
parcelRegister("dPoCQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a11323e13332fb26$export$2e2bcd8739ae039; });

var $lmpEK = parcelRequire("lmpEK");
var $a11323e13332fb26$var$coordinates = [
    null,
    null
], $a11323e13332fb26$var$object = {
    type: "LineString",
    coordinates: $a11323e13332fb26$var$coordinates
};
function $a11323e13332fb26$export$2e2bcd8739ae039(a, b) {
    $a11323e13332fb26$var$coordinates[0] = a;
    $a11323e13332fb26$var$coordinates[1] = b;
    return (0, $lmpEK.default)($a11323e13332fb26$var$object);
}

});
parcelRegister("lmpEK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8cf8ddb95a4ba5e$export$2e2bcd8739ae039; });

var $1wbR2 = parcelRequire("1wbR2");

var $eIlmS = parcelRequire("eIlmS");

var $glE2y = parcelRequire("glE2y");

var $49NvL = parcelRequire("49NvL");
var $f8cf8ddb95a4ba5e$var$lengthSum = (0, $1wbR2.default)(), $f8cf8ddb95a4ba5e$var$lambda0, $f8cf8ddb95a4ba5e$var$sinPhi0, $f8cf8ddb95a4ba5e$var$cosPhi0;
var $f8cf8ddb95a4ba5e$var$lengthStream = {
    sphere: (0, $glE2y.default),
    point: (0, $glE2y.default),
    lineStart: $f8cf8ddb95a4ba5e$var$lengthLineStart,
    lineEnd: (0, $glE2y.default),
    polygonStart: (0, $glE2y.default),
    polygonEnd: (0, $glE2y.default)
};
function $f8cf8ddb95a4ba5e$var$lengthLineStart() {
    $f8cf8ddb95a4ba5e$var$lengthStream.point = $f8cf8ddb95a4ba5e$var$lengthPointFirst;
    $f8cf8ddb95a4ba5e$var$lengthStream.lineEnd = $f8cf8ddb95a4ba5e$var$lengthLineEnd;
}
function $f8cf8ddb95a4ba5e$var$lengthLineEnd() {
    $f8cf8ddb95a4ba5e$var$lengthStream.point = $f8cf8ddb95a4ba5e$var$lengthStream.lineEnd = (0, $glE2y.default);
}
function $f8cf8ddb95a4ba5e$var$lengthPointFirst(lambda, phi) {
    lambda *= (0, $eIlmS.radians), phi *= (0, $eIlmS.radians);
    $f8cf8ddb95a4ba5e$var$lambda0 = lambda, $f8cf8ddb95a4ba5e$var$sinPhi0 = (0, $eIlmS.sin)(phi), $f8cf8ddb95a4ba5e$var$cosPhi0 = (0, $eIlmS.cos)(phi);
    $f8cf8ddb95a4ba5e$var$lengthStream.point = $f8cf8ddb95a4ba5e$var$lengthPoint;
}
function $f8cf8ddb95a4ba5e$var$lengthPoint(lambda, phi) {
    lambda *= (0, $eIlmS.radians), phi *= (0, $eIlmS.radians);
    var sinPhi = (0, $eIlmS.sin)(phi), cosPhi = (0, $eIlmS.cos)(phi), delta = (0, $eIlmS.abs)(lambda - $f8cf8ddb95a4ba5e$var$lambda0), cosDelta = (0, $eIlmS.cos)(delta), sinDelta = (0, $eIlmS.sin)(delta), x = cosPhi * sinDelta, y = $f8cf8ddb95a4ba5e$var$cosPhi0 * sinPhi - $f8cf8ddb95a4ba5e$var$sinPhi0 * cosPhi * cosDelta, z = $f8cf8ddb95a4ba5e$var$sinPhi0 * sinPhi + $f8cf8ddb95a4ba5e$var$cosPhi0 * cosPhi * cosDelta;
    $f8cf8ddb95a4ba5e$var$lengthSum.add((0, $eIlmS.atan2)((0, $eIlmS.sqrt)(x * x + y * y), z));
    $f8cf8ddb95a4ba5e$var$lambda0 = lambda, $f8cf8ddb95a4ba5e$var$sinPhi0 = sinPhi, $f8cf8ddb95a4ba5e$var$cosPhi0 = cosPhi;
}
function $f8cf8ddb95a4ba5e$export$2e2bcd8739ae039(object) {
    $f8cf8ddb95a4ba5e$var$lengthSum.reset();
    (0, $49NvL.default)(object, $f8cf8ddb95a4ba5e$var$lengthStream);
    return +$f8cf8ddb95a4ba5e$var$lengthSum;
}

});



parcelRegister("5Rd3w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $443c079a86549bc2$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "graticule10", function () { return $443c079a86549bc2$export$b8db4e9403a5b6f1; });
parcelRequire("9f3pr");
var $lwLP6 = parcelRequire("lwLP6");

var $eIlmS = parcelRequire("eIlmS");
function $443c079a86549bc2$var$graticuleX(y0, y1, dy) {
    var y = (0, $lwLP6.default)(y0, y1 - (0, $eIlmS.epsilon), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function $443c079a86549bc2$var$graticuleY(x0, x1, dx) {
    var x = (0, $lwLP6.default)(x0, x1 - (0, $eIlmS.epsilon), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function $443c079a86549bc2$export$2e2bcd8739ae039() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, $lwLP6.default)((0, $eIlmS.ceil)(X0 / DX) * DX, X1, DX).map(X).concat((0, $lwLP6.default)((0, $eIlmS.ceil)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, $lwLP6.default)((0, $eIlmS.ceil)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, $eIlmS.abs)(x % DX) > (0, $eIlmS.epsilon);
        }).map(x)).concat((0, $lwLP6.default)((0, $eIlmS.ceil)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, $eIlmS.abs)(y % DY) > (0, $eIlmS.epsilon);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = $443c079a86549bc2$var$graticuleX(y0, y1, 90);
        y = $443c079a86549bc2$var$graticuleY(x0, x1, precision);
        X = $443c079a86549bc2$var$graticuleX(Y0, Y1, 90);
        Y = $443c079a86549bc2$var$graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, $eIlmS.epsilon)
        ],
        [
            180,
            90 - (0, $eIlmS.epsilon)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, $eIlmS.epsilon)
        ],
        [
            180,
            80 + (0, $eIlmS.epsilon)
        ]
    ]);
}
function $443c079a86549bc2$export$b8db4e9403a5b6f1() {
    return $443c079a86549bc2$export$2e2bcd8739ae039()();
}

});

parcelRegister("6lj4p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49e37f25e3d448ef$export$2e2bcd8739ae039; });

var $eIlmS = parcelRequire("eIlmS");
function $49e37f25e3d448ef$export$2e2bcd8739ae039(a, b) {
    var x0 = a[0] * (0, $eIlmS.radians), y0 = a[1] * (0, $eIlmS.radians), x1 = b[0] * (0, $eIlmS.radians), y1 = b[1] * (0, $eIlmS.radians), cy0 = (0, $eIlmS.cos)(y0), sy0 = (0, $eIlmS.sin)(y0), cy1 = (0, $eIlmS.cos)(y1), sy1 = (0, $eIlmS.sin)(y1), kx0 = cy0 * (0, $eIlmS.cos)(x0), ky0 = cy0 * (0, $eIlmS.sin)(x0), kx1 = cy1 * (0, $eIlmS.cos)(x1), ky1 = cy1 * (0, $eIlmS.sin)(x1), d = 2 * (0, $eIlmS.asin)((0, $eIlmS.sqrt)((0, $eIlmS.haversin)(y1 - y0) + cy0 * cy1 * (0, $eIlmS.haversin)(x1 - x0))), k = (0, $eIlmS.sin)(d);
    var interpolate = d ? function(t) {
        var B = (0, $eIlmS.sin)(t *= d) / k, A = (0, $eIlmS.sin)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
        return [
            (0, $eIlmS.atan2)(y, x) * (0, $eIlmS.degrees),
            (0, $eIlmS.atan2)(z, (0, $eIlmS.sqrt)(x * x + y * y)) * (0, $eIlmS.degrees)
        ];
    } : function() {
        return [
            x0 * (0, $eIlmS.degrees),
            y0 * (0, $eIlmS.degrees)
        ];
    };
    interpolate.distance = d;
    return interpolate;
}

});

parcelRegister("d1FI3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97bbb8ff676e5b41$export$2e2bcd8739ae039; });

var $egCND = parcelRequire("egCND");

var $49NvL = parcelRequire("49NvL");

var $5C4TQ = parcelRequire("5C4TQ");

var $2gWFM = parcelRequire("2gWFM");

var $8u19M = parcelRequire("8u19M");

var $jj2uY = parcelRequire("jj2uY");

var $azppD = parcelRequire("azppD");

var $ltG2C = parcelRequire("ltG2C");
function $97bbb8ff676e5b41$export$2e2bcd8739ae039(projection, context) {
    var pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $49NvL.default)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $49NvL.default)(object, projectionStream((0, $5C4TQ.default)));
        return (0, $5C4TQ.default).result();
    };
    path.measure = function(object) {
        (0, $49NvL.default)(object, projectionStream((0, $azppD.default)));
        return (0, $azppD.default).result();
    };
    path.bounds = function(object) {
        (0, $49NvL.default)(object, projectionStream((0, $2gWFM.default)));
        return (0, $2gWFM.default).result();
    };
    path.centroid = function(object) {
        (0, $49NvL.default)(object, projectionStream((0, $8u19M.default)));
        return (0, $8u19M.default).result();
    };
    path.projection = function(_) {
        return arguments.length ? (projectionStream = _ == null ? (projection = null, $egCND.default) : (projection = _).stream, path) : projection;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $ltG2C.default)) : new (0, $jj2uY.default)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    return path.projection(projection).context(context);
}

});
parcelRegister("egCND", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a630a813350b8f09$export$2e2bcd8739ae039; });
function $a630a813350b8f09$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("5C4TQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41644d52ed059899$export$2e2bcd8739ae039; });

var $1wbR2 = parcelRequire("1wbR2");

var $eIlmS = parcelRequire("eIlmS");

var $glE2y = parcelRequire("glE2y");
var $41644d52ed059899$var$areaSum = (0, $1wbR2.default)(), $41644d52ed059899$var$areaRingSum = (0, $1wbR2.default)(), $41644d52ed059899$var$x00, $41644d52ed059899$var$y00, $41644d52ed059899$var$x0, $41644d52ed059899$var$y0;
var $41644d52ed059899$var$areaStream = {
    point: (0, $glE2y.default),
    lineStart: (0, $glE2y.default),
    lineEnd: (0, $glE2y.default),
    polygonStart: function() {
        $41644d52ed059899$var$areaStream.lineStart = $41644d52ed059899$var$areaRingStart;
        $41644d52ed059899$var$areaStream.lineEnd = $41644d52ed059899$var$areaRingEnd;
    },
    polygonEnd: function() {
        $41644d52ed059899$var$areaStream.lineStart = $41644d52ed059899$var$areaStream.lineEnd = $41644d52ed059899$var$areaStream.point = (0, $glE2y.default);
        $41644d52ed059899$var$areaSum.add((0, $eIlmS.abs)($41644d52ed059899$var$areaRingSum));
        $41644d52ed059899$var$areaRingSum.reset();
    },
    result: function() {
        var area = $41644d52ed059899$var$areaSum / 2;
        $41644d52ed059899$var$areaSum.reset();
        return area;
    }
};
function $41644d52ed059899$var$areaRingStart() {
    $41644d52ed059899$var$areaStream.point = $41644d52ed059899$var$areaPointFirst;
}
function $41644d52ed059899$var$areaPointFirst(x, y) {
    $41644d52ed059899$var$areaStream.point = $41644d52ed059899$var$areaPoint;
    $41644d52ed059899$var$x00 = $41644d52ed059899$var$x0 = x, $41644d52ed059899$var$y00 = $41644d52ed059899$var$y0 = y;
}
function $41644d52ed059899$var$areaPoint(x, y) {
    $41644d52ed059899$var$areaRingSum.add($41644d52ed059899$var$y0 * x - $41644d52ed059899$var$x0 * y);
    $41644d52ed059899$var$x0 = x, $41644d52ed059899$var$y0 = y;
}
function $41644d52ed059899$var$areaRingEnd() {
    $41644d52ed059899$var$areaPoint($41644d52ed059899$var$x00, $41644d52ed059899$var$y00);
}
var $41644d52ed059899$export$2e2bcd8739ae039 = $41644d52ed059899$var$areaStream;

});

parcelRegister("2gWFM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a7a96988c9abff0$export$2e2bcd8739ae039; });

var $glE2y = parcelRequire("glE2y");
var $1a7a96988c9abff0$var$x0 = Infinity, $1a7a96988c9abff0$var$y0 = $1a7a96988c9abff0$var$x0, $1a7a96988c9abff0$var$x1 = -$1a7a96988c9abff0$var$x0, $1a7a96988c9abff0$var$y1 = $1a7a96988c9abff0$var$x1;
var $1a7a96988c9abff0$var$boundsStream = {
    point: $1a7a96988c9abff0$var$boundsPoint,
    lineStart: (0, $glE2y.default),
    lineEnd: (0, $glE2y.default),
    polygonStart: (0, $glE2y.default),
    polygonEnd: (0, $glE2y.default),
    result: function() {
        var bounds = [
            [
                $1a7a96988c9abff0$var$x0,
                $1a7a96988c9abff0$var$y0
            ],
            [
                $1a7a96988c9abff0$var$x1,
                $1a7a96988c9abff0$var$y1
            ]
        ];
        $1a7a96988c9abff0$var$x1 = $1a7a96988c9abff0$var$y1 = -($1a7a96988c9abff0$var$y0 = $1a7a96988c9abff0$var$x0 = Infinity);
        return bounds;
    }
};
function $1a7a96988c9abff0$var$boundsPoint(x, y) {
    if (x < $1a7a96988c9abff0$var$x0) $1a7a96988c9abff0$var$x0 = x;
    if (x > $1a7a96988c9abff0$var$x1) $1a7a96988c9abff0$var$x1 = x;
    if (y < $1a7a96988c9abff0$var$y0) $1a7a96988c9abff0$var$y0 = y;
    if (y > $1a7a96988c9abff0$var$y1) $1a7a96988c9abff0$var$y1 = y;
}
var $1a7a96988c9abff0$export$2e2bcd8739ae039 = $1a7a96988c9abff0$var$boundsStream;

});

parcelRegister("8u19M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62d205c6b6b3edca$export$2e2bcd8739ae039; });

var $eIlmS = parcelRequire("eIlmS");
// TODO Enforce positive area for exterior, negative area for interior?
var $62d205c6b6b3edca$var$X0 = 0, $62d205c6b6b3edca$var$Y0 = 0, $62d205c6b6b3edca$var$Z0 = 0, $62d205c6b6b3edca$var$X1 = 0, $62d205c6b6b3edca$var$Y1 = 0, $62d205c6b6b3edca$var$Z1 = 0, $62d205c6b6b3edca$var$X2 = 0, $62d205c6b6b3edca$var$Y2 = 0, $62d205c6b6b3edca$var$Z2 = 0, $62d205c6b6b3edca$var$x00, $62d205c6b6b3edca$var$y00, $62d205c6b6b3edca$var$x0, $62d205c6b6b3edca$var$y0;
var $62d205c6b6b3edca$var$centroidStream = {
    point: $62d205c6b6b3edca$var$centroidPoint,
    lineStart: $62d205c6b6b3edca$var$centroidLineStart,
    lineEnd: $62d205c6b6b3edca$var$centroidLineEnd,
    polygonStart: function() {
        $62d205c6b6b3edca$var$centroidStream.lineStart = $62d205c6b6b3edca$var$centroidRingStart;
        $62d205c6b6b3edca$var$centroidStream.lineEnd = $62d205c6b6b3edca$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $62d205c6b6b3edca$var$centroidStream.point = $62d205c6b6b3edca$var$centroidPoint;
        $62d205c6b6b3edca$var$centroidStream.lineStart = $62d205c6b6b3edca$var$centroidLineStart;
        $62d205c6b6b3edca$var$centroidStream.lineEnd = $62d205c6b6b3edca$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $62d205c6b6b3edca$var$Z2 ? [
            $62d205c6b6b3edca$var$X2 / $62d205c6b6b3edca$var$Z2,
            $62d205c6b6b3edca$var$Y2 / $62d205c6b6b3edca$var$Z2
        ] : $62d205c6b6b3edca$var$Z1 ? [
            $62d205c6b6b3edca$var$X1 / $62d205c6b6b3edca$var$Z1,
            $62d205c6b6b3edca$var$Y1 / $62d205c6b6b3edca$var$Z1
        ] : $62d205c6b6b3edca$var$Z0 ? [
            $62d205c6b6b3edca$var$X0 / $62d205c6b6b3edca$var$Z0,
            $62d205c6b6b3edca$var$Y0 / $62d205c6b6b3edca$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $62d205c6b6b3edca$var$X0 = $62d205c6b6b3edca$var$Y0 = $62d205c6b6b3edca$var$Z0 = $62d205c6b6b3edca$var$X1 = $62d205c6b6b3edca$var$Y1 = $62d205c6b6b3edca$var$Z1 = $62d205c6b6b3edca$var$X2 = $62d205c6b6b3edca$var$Y2 = $62d205c6b6b3edca$var$Z2 = 0;
        return centroid;
    }
};
function $62d205c6b6b3edca$var$centroidPoint(x, y) {
    $62d205c6b6b3edca$var$X0 += x;
    $62d205c6b6b3edca$var$Y0 += y;
    ++$62d205c6b6b3edca$var$Z0;
}
function $62d205c6b6b3edca$var$centroidLineStart() {
    $62d205c6b6b3edca$var$centroidStream.point = $62d205c6b6b3edca$var$centroidPointFirstLine;
}
function $62d205c6b6b3edca$var$centroidPointFirstLine(x, y) {
    $62d205c6b6b3edca$var$centroidStream.point = $62d205c6b6b3edca$var$centroidPointLine;
    $62d205c6b6b3edca$var$centroidPoint($62d205c6b6b3edca$var$x0 = x, $62d205c6b6b3edca$var$y0 = y);
}
function $62d205c6b6b3edca$var$centroidPointLine(x, y) {
    var dx = x - $62d205c6b6b3edca$var$x0, dy = y - $62d205c6b6b3edca$var$y0, z = (0, $eIlmS.sqrt)(dx * dx + dy * dy);
    $62d205c6b6b3edca$var$X1 += z * ($62d205c6b6b3edca$var$x0 + x) / 2;
    $62d205c6b6b3edca$var$Y1 += z * ($62d205c6b6b3edca$var$y0 + y) / 2;
    $62d205c6b6b3edca$var$Z1 += z;
    $62d205c6b6b3edca$var$centroidPoint($62d205c6b6b3edca$var$x0 = x, $62d205c6b6b3edca$var$y0 = y);
}
function $62d205c6b6b3edca$var$centroidLineEnd() {
    $62d205c6b6b3edca$var$centroidStream.point = $62d205c6b6b3edca$var$centroidPoint;
}
function $62d205c6b6b3edca$var$centroidRingStart() {
    $62d205c6b6b3edca$var$centroidStream.point = $62d205c6b6b3edca$var$centroidPointFirstRing;
}
function $62d205c6b6b3edca$var$centroidRingEnd() {
    $62d205c6b6b3edca$var$centroidPointRing($62d205c6b6b3edca$var$x00, $62d205c6b6b3edca$var$y00);
}
function $62d205c6b6b3edca$var$centroidPointFirstRing(x, y) {
    $62d205c6b6b3edca$var$centroidStream.point = $62d205c6b6b3edca$var$centroidPointRing;
    $62d205c6b6b3edca$var$centroidPoint($62d205c6b6b3edca$var$x00 = $62d205c6b6b3edca$var$x0 = x, $62d205c6b6b3edca$var$y00 = $62d205c6b6b3edca$var$y0 = y);
}
function $62d205c6b6b3edca$var$centroidPointRing(x, y) {
    var dx = x - $62d205c6b6b3edca$var$x0, dy = y - $62d205c6b6b3edca$var$y0, z = (0, $eIlmS.sqrt)(dx * dx + dy * dy);
    $62d205c6b6b3edca$var$X1 += z * ($62d205c6b6b3edca$var$x0 + x) / 2;
    $62d205c6b6b3edca$var$Y1 += z * ($62d205c6b6b3edca$var$y0 + y) / 2;
    $62d205c6b6b3edca$var$Z1 += z;
    z = $62d205c6b6b3edca$var$y0 * x - $62d205c6b6b3edca$var$x0 * y;
    $62d205c6b6b3edca$var$X2 += z * ($62d205c6b6b3edca$var$x0 + x);
    $62d205c6b6b3edca$var$Y2 += z * ($62d205c6b6b3edca$var$y0 + y);
    $62d205c6b6b3edca$var$Z2 += z * 3;
    $62d205c6b6b3edca$var$centroidPoint($62d205c6b6b3edca$var$x0 = x, $62d205c6b6b3edca$var$y0 = y);
}
var $62d205c6b6b3edca$export$2e2bcd8739ae039 = $62d205c6b6b3edca$var$centroidStream;

});

parcelRegister("jj2uY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0e1bad7bed2a46d$export$2e2bcd8739ae039; });

var $eIlmS = parcelRequire("eIlmS");

var $glE2y = parcelRequire("glE2y");
function $e0e1bad7bed2a46d$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$e0e1bad7bed2a46d$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $eIlmS.tau));
                break;
        }
    },
    result: (0, $glE2y.default)
};

});

parcelRegister("azppD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b20e2aa4d8dbb19$export$2e2bcd8739ae039; });

var $1wbR2 = parcelRequire("1wbR2");

var $eIlmS = parcelRequire("eIlmS");

var $glE2y = parcelRequire("glE2y");
var $7b20e2aa4d8dbb19$var$lengthSum = (0, $1wbR2.default)(), $7b20e2aa4d8dbb19$var$lengthRing, $7b20e2aa4d8dbb19$var$x00, $7b20e2aa4d8dbb19$var$y00, $7b20e2aa4d8dbb19$var$x0, $7b20e2aa4d8dbb19$var$y0;
var $7b20e2aa4d8dbb19$var$lengthStream = {
    point: (0, $glE2y.default),
    lineStart: function() {
        $7b20e2aa4d8dbb19$var$lengthStream.point = $7b20e2aa4d8dbb19$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($7b20e2aa4d8dbb19$var$lengthRing) $7b20e2aa4d8dbb19$var$lengthPoint($7b20e2aa4d8dbb19$var$x00, $7b20e2aa4d8dbb19$var$y00);
        $7b20e2aa4d8dbb19$var$lengthStream.point = (0, $glE2y.default);
    },
    polygonStart: function() {
        $7b20e2aa4d8dbb19$var$lengthRing = true;
    },
    polygonEnd: function() {
        $7b20e2aa4d8dbb19$var$lengthRing = null;
    },
    result: function() {
        var length = +$7b20e2aa4d8dbb19$var$lengthSum;
        $7b20e2aa4d8dbb19$var$lengthSum.reset();
        return length;
    }
};
function $7b20e2aa4d8dbb19$var$lengthPointFirst(x, y) {
    $7b20e2aa4d8dbb19$var$lengthStream.point = $7b20e2aa4d8dbb19$var$lengthPoint;
    $7b20e2aa4d8dbb19$var$x00 = $7b20e2aa4d8dbb19$var$x0 = x, $7b20e2aa4d8dbb19$var$y00 = $7b20e2aa4d8dbb19$var$y0 = y;
}
function $7b20e2aa4d8dbb19$var$lengthPoint(x, y) {
    $7b20e2aa4d8dbb19$var$x0 -= x, $7b20e2aa4d8dbb19$var$y0 -= y;
    $7b20e2aa4d8dbb19$var$lengthSum.add((0, $eIlmS.sqrt)($7b20e2aa4d8dbb19$var$x0 * $7b20e2aa4d8dbb19$var$x0 + $7b20e2aa4d8dbb19$var$y0 * $7b20e2aa4d8dbb19$var$y0));
    $7b20e2aa4d8dbb19$var$x0 = x, $7b20e2aa4d8dbb19$var$y0 = y;
}
var $7b20e2aa4d8dbb19$export$2e2bcd8739ae039 = $7b20e2aa4d8dbb19$var$lengthStream;

});

parcelRegister("ltG2C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa2ceaf23c995c0f$export$2e2bcd8739ae039; });
function $fa2ceaf23c995c0f$export$2e2bcd8739ae039() {
    this._string = [];
}
$fa2ceaf23c995c0f$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    _circle: $fa2ceaf23c995c0f$var$circle(4.5),
    pointRadius: function(_) {
        if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
        return this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._string.push("Z");
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._string.push("M", x, ",", y);
                this._point = 1;
                break;
            case 1:
                this._string.push("L", x, ",", y);
                break;
            default:
                if (this._circle == null) this._circle = $fa2ceaf23c995c0f$var$circle(this._radius);
                this._string.push("M", x, ",", y, this._circle);
                break;
        }
    },
    result: function() {
        if (this._string.length) {
            var result = this._string.join("");
            this._string = [];
            return result;
        } else return null;
    }
};
function $fa2ceaf23c995c0f$var$circle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
}

});


parcelRegister("4B3pL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $358d442e57420461$export$2e2bcd8739ae039; });

var $f6k4I = parcelRequire("f6k4I");
function $358d442e57420461$export$2e2bcd8739ae039() {
    return (0, $f6k4I.default)().parallels([
        29.5,
        45.5
    ]).scale(1070).translate([
        480,
        250
    ]).rotate([
        96,
        0
    ]).center([
        -0.6,
        38.7
    ]);
}

});
parcelRegister("f6k4I", function(module, exports) {

$parcel$export(module.exports, "conicEqualAreaRaw", function () { return $afe6fd09d4ec865a$export$75409dad1c406288; });
$parcel$export(module.exports, "default", function () { return $afe6fd09d4ec865a$export$2e2bcd8739ae039; });

var $eIlmS = parcelRequire("eIlmS");

var $f2pyu = parcelRequire("f2pyu");

var $hPtNZ = parcelRequire("hPtNZ");
function $afe6fd09d4ec865a$export$75409dad1c406288(y0, y1) {
    var sy0 = (0, $eIlmS.sin)(y0), n = (sy0 + (0, $eIlmS.sin)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, $eIlmS.abs)(n) < (0, $eIlmS.epsilon)) return (0, $hPtNZ.cylindricalEqualAreaRaw)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, $eIlmS.sqrt)(c) / n;
    function project(x, y) {
        var r = (0, $eIlmS.sqrt)(c - 2 * n * (0, $eIlmS.sin)(y)) / n;
        return [
            r * (0, $eIlmS.sin)(x *= n),
            r0 - r * (0, $eIlmS.cos)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y, l = (0, $eIlmS.atan2)(x, (0, $eIlmS.abs)(r0y)) * (0, $eIlmS.sign)(r0y);
        if (r0y * n < 0) l -= (0, $eIlmS.pi) * (0, $eIlmS.sign)(x) * (0, $eIlmS.sign)(r0y);
        return [
            l / n,
            (0, $eIlmS.asin)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}
function $afe6fd09d4ec865a$export$2e2bcd8739ae039() {
    return (0, $f2pyu.conicProjection)($afe6fd09d4ec865a$export$75409dad1c406288).scale(155.424).center([
        0,
        33.6442
    ]);
}

});
parcelRegister("f2pyu", function(module, exports) {

$parcel$export(module.exports, "conicProjection", function () { return $af2addb156dbe91f$export$228272587c4d24d8; });

var $eIlmS = parcelRequire("eIlmS");

var $9Ld7N = parcelRequire("9Ld7N");
function $af2addb156dbe91f$export$228272587c4d24d8(projectAt) {
    var phi0 = 0, phi1 = (0, $eIlmS.pi) / 3, m = (0, $9Ld7N.projectionMutator)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, $eIlmS.radians), phi1 = _[1] * (0, $eIlmS.radians)) : [
            phi0 * (0, $eIlmS.degrees),
            phi1 * (0, $eIlmS.degrees)
        ];
    };
    return p;
}

});
parcelRegister("9Ld7N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71b2af22f4400445$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "projectionMutator", function () { return $71b2af22f4400445$export$155d5a6fa6fddeba; });

var $90zbe = parcelRequire("90zbe");

var $jDEoe = parcelRequire("jDEoe");

var $3AeFV = parcelRequire("3AeFV");

var $6nGZZ = parcelRequire("6nGZZ");

var $egCND = parcelRequire("egCND");

var $eIlmS = parcelRequire("eIlmS");

var $5GRgV = parcelRequire("5GRgV");

var $77LaW = parcelRequire("77LaW");

var $ghaDX = parcelRequire("ghaDX");

var $1SCkI = parcelRequire("1SCkI");
var $71b2af22f4400445$var$transformRadians = (0, $77LaW.transformer)({
    point: function(x, y) {
        this.stream.point(x * (0, $eIlmS.radians), y * (0, $eIlmS.radians));
    }
});
function $71b2af22f4400445$var$transformRotate(rotate) {
    return (0, $77LaW.transformer)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function $71b2af22f4400445$var$scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function $71b2af22f4400445$var$scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    var cosAlpha = (0, $eIlmS.cos)(alpha), sinAlpha = (0, $eIlmS.sin)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function $71b2af22f4400445$export$2e2bcd8739ae039(project) {
    return $71b2af22f4400445$export$155d5a6fa6fddeba(function() {
        return project;
    })();
}
function $71b2af22f4400445$export$155d5a6fa6fddeba(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, $90zbe.default), x0 = null, y0, x1, y1, postclip = (0, $egCND.default), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, $eIlmS.radians), point[1] * (0, $eIlmS.radians));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, $eIlmS.degrees),
            point[1] * (0, $eIlmS.degrees)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $71b2af22f4400445$var$transformRadians($71b2af22f4400445$var$transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, $jDEoe.default)(theta = _ * (0, $eIlmS.radians)) : (theta = null, $90zbe.default), reset()) : theta * (0, $eIlmS.degrees);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $egCND.default) : (0, $3AeFV.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, $eIlmS.radians), phi = _[1] % 360 * (0, $eIlmS.radians), recenter()) : [
            lambda * (0, $eIlmS.degrees),
            phi * (0, $eIlmS.degrees)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, $eIlmS.radians), deltaPhi = _[1] % 360 * (0, $eIlmS.radians), deltaGamma = _.length > 2 ? _[2] % 360 * (0, $eIlmS.radians) : 0, recenter()) : [
            deltaLambda * (0, $eIlmS.degrees),
            deltaPhi * (0, $eIlmS.degrees),
            deltaGamma * (0, $eIlmS.degrees)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $eIlmS.radians), recenter()) : alpha * (0, $eIlmS.degrees);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, $1SCkI.default)(projectTransform, delta2 = _ * _), reset()) : (0, $eIlmS.sqrt)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, $ghaDX.fitExtent)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $ghaDX.fitSize)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $ghaDX.fitWidth)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $ghaDX.fitHeight)(projection, height, object);
    };
    function recenter() {
        var center = $71b2af22f4400445$var$scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = (alpha ? $71b2af22f4400445$var$scaleTranslateRotate : $71b2af22f4400445$var$scaleTranslate)(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, $5GRgV.rotateRadians)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, $6nGZZ.default)(project, transform);
        projectRotateTransform = (0, $6nGZZ.default)(rotate, projectTransform);
        projectResample = (0, $1SCkI.default)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}

});
parcelRegister("77LaW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52fdc7ea054fa048$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "transformer", function () { return $52fdc7ea054fa048$export$6b468dcfb64c653c; });
function $52fdc7ea054fa048$export$2e2bcd8739ae039(methods) {
    return {
        stream: $52fdc7ea054fa048$export$6b468dcfb64c653c(methods)
    };
}
function $52fdc7ea054fa048$export$6b468dcfb64c653c(methods) {
    return function(stream) {
        var s = new $52fdc7ea054fa048$var$TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function $52fdc7ea054fa048$var$TransformStream() {}
$52fdc7ea054fa048$var$TransformStream.prototype = {
    constructor: $52fdc7ea054fa048$var$TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};

});

parcelRegister("ghaDX", function(module, exports) {

$parcel$export(module.exports, "fitExtent", function () { return $bd967d71db1f265c$export$e450184041869e7f; });
$parcel$export(module.exports, "fitSize", function () { return $bd967d71db1f265c$export$33a367fa1728c3ba; });
$parcel$export(module.exports, "fitWidth", function () { return $bd967d71db1f265c$export$7d8f2192ef31c5a7; });
$parcel$export(module.exports, "fitHeight", function () { return $bd967d71db1f265c$export$7069bab0d2ced675; });

var $49NvL = parcelRequire("49NvL");

var $2gWFM = parcelRequire("2gWFM");
function $bd967d71db1f265c$var$fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, $49NvL.default)(object, projection.stream((0, $2gWFM.default)));
    fitBounds((0, $2gWFM.default).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function $bd967d71db1f265c$export$e450184041869e7f(projection, extent, object) {
    return $bd967d71db1f265c$var$fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $bd967d71db1f265c$export$33a367fa1728c3ba(projection, size, object) {
    return $bd967d71db1f265c$export$e450184041869e7f(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function $bd967d71db1f265c$export$7d8f2192ef31c5a7(projection, width, object) {
    return $bd967d71db1f265c$var$fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $bd967d71db1f265c$export$7069bab0d2ced675(projection, height, object) {
    return $bd967d71db1f265c$var$fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}

});

parcelRegister("1SCkI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15e891bdb5bf1ea4$export$2e2bcd8739ae039; });

var $8W5ig = parcelRequire("8W5ig");

var $eIlmS = parcelRequire("eIlmS");

var $77LaW = parcelRequire("77LaW");
var $15e891bdb5bf1ea4$var$maxDepth = 16, $15e891bdb5bf1ea4$var$cosMinDistance = (0, $eIlmS.cos)(30 * (0, $eIlmS.radians)); // cos(minimum angular distance)
function $15e891bdb5bf1ea4$export$2e2bcd8739ae039(project, delta2) {
    return +delta2 ? $15e891bdb5bf1ea4$var$resample(project, delta2) : $15e891bdb5bf1ea4$var$resampleNone(project);
}
function $15e891bdb5bf1ea4$var$resampleNone(project) {
    return (0, $77LaW.transformer)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function $15e891bdb5bf1ea4$var$resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, $eIlmS.sqrt)(a * a + b * b + c * c), phi2 = (0, $eIlmS.asin)(c /= m), lambda2 = (0, $eIlmS.abs)((0, $eIlmS.abs)(c) - 1) < (0, $eIlmS.epsilon) || (0, $eIlmS.abs)(lambda0 - lambda1) < (0, $eIlmS.epsilon) ? (lambda0 + lambda1) / 2 : (0, $eIlmS.atan2)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, $eIlmS.abs)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < $15e891bdb5bf1ea4$var$cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, $8W5ig.cartesian)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], $15e891bdb5bf1ea4$var$maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, $15e891bdb5bf1ea4$var$maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}

});



parcelRegister("hPtNZ", function(module, exports) {

$parcel$export(module.exports, "cylindricalEqualAreaRaw", function () { return $cfae51cebe224d40$export$ae68c6db8b65046a; });

var $eIlmS = parcelRequire("eIlmS");
function $cfae51cebe224d40$export$ae68c6db8b65046a(phi0) {
    var cosPhi0 = (0, $eIlmS.cos)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, $eIlmS.sin)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, $eIlmS.asin)(y * cosPhi0)
        ];
    };
    return forward;
}

});



parcelRegister("1dKhN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e3ae8c35e0f3d12$export$2e2bcd8739ae039; });

var $eIlmS = parcelRequire("eIlmS");

var $4B3pL = parcelRequire("4B3pL");

var $f6k4I = parcelRequire("f6k4I");

var $ghaDX = parcelRequire("ghaDX");
// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function $0e3ae8c35e0f3d12$var$multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}
function $0e3ae8c35e0f3d12$export$2e2bcd8739ae039() {
    var cache, cacheStream, lower48 = (0, $4B3pL.default)(), lower48Point, alaska = (0, $f6k4I.default)().rotate([
        154,
        0
    ]).center([
        -2,
        58.5
    ]).parallels([
        55,
        65
    ]), alaskaPoint, hawaii = (0, $f6k4I.default)().rotate([
        157,
        0
    ]).center([
        -3,
        19.9
    ]).parallels([
        8,
        18
    ]), hawaiiPoint, point, pointStream = {
        point: function(x, y) {
            point = [
                x,
                y
            ];
        }
    };
    function albersUsa(coordinates) {
        var x = coordinates[0], y = coordinates[1];
        return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
    }
    albersUsa.invert = function(coordinates) {
        var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
        return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $0e3ae8c35e0f3d12$var$multiplex([
            lower48.stream(cacheStream = stream),
            alaska.stream(stream),
            hawaii.stream(stream)
        ]);
    };
    albersUsa.precision = function(_) {
        if (!arguments.length) return lower48.precision();
        lower48.precision(_), alaska.precision(_), hawaii.precision(_);
        return reset();
    };
    albersUsa.scale = function(_) {
        if (!arguments.length) return lower48.scale();
        lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
        return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
        if (!arguments.length) return lower48.translate();
        var k = lower48.scale(), x = +_[0], y = +_[1];
        lower48Point = lower48.translate(_).clipExtent([
            [
                x - 0.455 * k,
                y - 0.238 * k
            ],
            [
                x + 0.455 * k,
                y + 0.238 * k
            ]
        ]).stream(pointStream);
        alaskaPoint = alaska.translate([
            x - 0.307 * k,
            y + 0.201 * k
        ]).clipExtent([
            [
                x - 0.425 * k + (0, $eIlmS.epsilon),
                y + 0.120 * k + (0, $eIlmS.epsilon)
            ],
            [
                x - 0.214 * k - (0, $eIlmS.epsilon),
                y + 0.234 * k - (0, $eIlmS.epsilon)
            ]
        ]).stream(pointStream);
        hawaiiPoint = hawaii.translate([
            x - 0.205 * k,
            y + 0.212 * k
        ]).clipExtent([
            [
                x - 0.214 * k + (0, $eIlmS.epsilon),
                y + 0.166 * k + (0, $eIlmS.epsilon)
            ],
            [
                x - 0.115 * k - (0, $eIlmS.epsilon),
                y + 0.234 * k - (0, $eIlmS.epsilon)
            ]
        ]).stream(pointStream);
        return reset();
    };
    albersUsa.fitExtent = function(extent, object) {
        return (0, $ghaDX.fitExtent)(albersUsa, extent, object);
    };
    albersUsa.fitSize = function(size, object) {
        return (0, $ghaDX.fitSize)(albersUsa, size, object);
    };
    albersUsa.fitWidth = function(width, object) {
        return (0, $ghaDX.fitWidth)(albersUsa, width, object);
    };
    albersUsa.fitHeight = function(height, object) {
        return (0, $ghaDX.fitHeight)(albersUsa, height, object);
    };
    function reset() {
        cache = cacheStream = null;
        return albersUsa;
    }
    return albersUsa.scale(1070);
}

});

parcelRegister("mll85", function(module, exports) {

$parcel$export(module.exports, "azimuthalEqualAreaRaw", function () { return $04329bd407ae18b3$export$5e11f94fc4a8d2c6; });
$parcel$export(module.exports, "default", function () { return $04329bd407ae18b3$export$2e2bcd8739ae039; });

var $eIlmS = parcelRequire("eIlmS");

var $81EHx = parcelRequire("81EHx");

var $9Ld7N = parcelRequire("9Ld7N");
var $04329bd407ae18b3$export$5e11f94fc4a8d2c6 = (0, $81EHx.azimuthalRaw)(function(cxcy) {
    return (0, $eIlmS.sqrt)(2 / (1 + cxcy));
});
$04329bd407ae18b3$export$5e11f94fc4a8d2c6.invert = (0, $81EHx.azimuthalInvert)(function(z) {
    return 2 * (0, $eIlmS.asin)(z / 2);
});
function $04329bd407ae18b3$export$2e2bcd8739ae039() {
    return (0, $9Ld7N.default)($04329bd407ae18b3$export$5e11f94fc4a8d2c6).scale(124.75).clipAngle(179.999);
}

});
parcelRegister("81EHx", function(module, exports) {

$parcel$export(module.exports, "azimuthalRaw", function () { return $5d7dfd257c7b2db6$export$f1211ac1bdb0796; });
$parcel$export(module.exports, "azimuthalInvert", function () { return $5d7dfd257c7b2db6$export$3cee429f13e44eac; });

var $eIlmS = parcelRequire("eIlmS");
function $5d7dfd257c7b2db6$export$f1211ac1bdb0796(scale) {
    return function(x, y) {
        var cx = (0, $eIlmS.cos)(x), cy = (0, $eIlmS.cos)(y), k = scale(cx * cy);
        return [
            k * cy * (0, $eIlmS.sin)(x),
            k * (0, $eIlmS.sin)(y)
        ];
    };
}
function $5d7dfd257c7b2db6$export$3cee429f13e44eac(angle) {
    return function(x, y) {
        var z = (0, $eIlmS.sqrt)(x * x + y * y), c = angle(z), sc = (0, $eIlmS.sin)(c), cc = (0, $eIlmS.cos)(c);
        return [
            (0, $eIlmS.atan2)(x * sc, z * cc),
            (0, $eIlmS.asin)(z && y * sc / z)
        ];
    };
}

});


parcelRegister("kOOgS", function(module, exports) {

$parcel$export(module.exports, "azimuthalEquidistantRaw", function () { return $f27f78f404b27eb2$export$b94a4d6aa3dd25c; });
$parcel$export(module.exports, "default", function () { return $f27f78f404b27eb2$export$2e2bcd8739ae039; });

var $eIlmS = parcelRequire("eIlmS");

var $81EHx = parcelRequire("81EHx");

var $9Ld7N = parcelRequire("9Ld7N");
var $f27f78f404b27eb2$export$b94a4d6aa3dd25c = (0, $81EHx.azimuthalRaw)(function(c) {
    return (c = (0, $eIlmS.acos)(c)) && c / (0, $eIlmS.sin)(c);
});
$f27f78f404b27eb2$export$b94a4d6aa3dd25c.invert = (0, $81EHx.azimuthalInvert)(function(z) {
    return z;
});
function $f27f78f404b27eb2$export$2e2bcd8739ae039() {
    return (0, $9Ld7N.default)($f27f78f404b27eb2$export$b94a4d6aa3dd25c).scale(79.4188).clipAngle(179.999);
}

});

parcelRegister("7Z7Gq", function(module, exports) {

$parcel$export(module.exports, "conicConformalRaw", function () { return $5d0430a9a26d9a22$export$2b1bc913962ed170; });
$parcel$export(module.exports, "default", function () { return $5d0430a9a26d9a22$export$2e2bcd8739ae039; });

var $eIlmS = parcelRequire("eIlmS");

var $f2pyu = parcelRequire("f2pyu");

var $7gsAH = parcelRequire("7gsAH");
function $5d0430a9a26d9a22$var$tany(y) {
    return (0, $eIlmS.tan)(((0, $eIlmS.halfPi) + y) / 2);
}
function $5d0430a9a26d9a22$export$2b1bc913962ed170(y0, y1) {
    var cy0 = (0, $eIlmS.cos)(y0), n = y0 === y1 ? (0, $eIlmS.sin)(y0) : (0, $eIlmS.log)(cy0 / (0, $eIlmS.cos)(y1)) / (0, $eIlmS.log)($5d0430a9a26d9a22$var$tany(y1) / $5d0430a9a26d9a22$var$tany(y0)), f = cy0 * (0, $eIlmS.pow)($5d0430a9a26d9a22$var$tany(y0), n) / n;
    if (!n) return 0, $7gsAH.mercatorRaw;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, $eIlmS.halfPi) + (0, $eIlmS.epsilon)) y = -(0, $eIlmS.halfPi) + (0, $eIlmS.epsilon);
        } else if (y > (0, $eIlmS.halfPi) - (0, $eIlmS.epsilon)) y = (0, $eIlmS.halfPi) - (0, $eIlmS.epsilon);
        var r = f / (0, $eIlmS.pow)($5d0430a9a26d9a22$var$tany(y), n);
        return [
            r * (0, $eIlmS.sin)(n * x),
            f - r * (0, $eIlmS.cos)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, $eIlmS.sign)(n) * (0, $eIlmS.sqrt)(x * x + fy * fy), l = (0, $eIlmS.atan2)(x, (0, $eIlmS.abs)(fy)) * (0, $eIlmS.sign)(fy);
        if (fy * n < 0) l -= (0, $eIlmS.pi) * (0, $eIlmS.sign)(x) * (0, $eIlmS.sign)(fy);
        return [
            l / n,
            2 * (0, $eIlmS.atan)((0, $eIlmS.pow)(f / r, 1 / n)) - (0, $eIlmS.halfPi)
        ];
    };
    return project;
}
function $5d0430a9a26d9a22$export$2e2bcd8739ae039() {
    return (0, $f2pyu.conicProjection)($5d0430a9a26d9a22$export$2b1bc913962ed170).scale(109.5).parallels([
        30,
        30
    ]);
}

});
parcelRegister("7gsAH", function(module, exports) {

$parcel$export(module.exports, "mercatorRaw", function () { return $54a034956ff99836$export$94ff8a57e9b91cc3; });
$parcel$export(module.exports, "default", function () { return $54a034956ff99836$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "mercatorProjection", function () { return $54a034956ff99836$export$44b9b66a01f2127b; });

var $eIlmS = parcelRequire("eIlmS");

var $5GRgV = parcelRequire("5GRgV");

var $9Ld7N = parcelRequire("9Ld7N");
function $54a034956ff99836$export$94ff8a57e9b91cc3(lambda, phi) {
    return [
        lambda,
        (0, $eIlmS.log)((0, $eIlmS.tan)(((0, $eIlmS.halfPi) + phi) / 2))
    ];
}
$54a034956ff99836$export$94ff8a57e9b91cc3.invert = function(x, y) {
    return [
        x,
        2 * (0, $eIlmS.atan)((0, $eIlmS.exp)(y)) - (0, $eIlmS.halfPi)
    ];
};
function $54a034956ff99836$export$2e2bcd8739ae039() {
    return $54a034956ff99836$export$44b9b66a01f2127b($54a034956ff99836$export$94ff8a57e9b91cc3).scale(961 / (0, $eIlmS.tau));
}
function $54a034956ff99836$export$44b9b66a01f2127b(project) {
    var m = (0, $9Ld7N.default)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, $eIlmS.pi) * scale(), t = m((0, $5GRgV.default)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === $54a034956ff99836$export$94ff8a57e9b91cc3 ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}

});


parcelRegister("33OON", function(module, exports) {

$parcel$export(module.exports, "conicEquidistantRaw", function () { return $23a9125fc33d26e7$export$24f604fe80e5f192; });
$parcel$export(module.exports, "default", function () { return $23a9125fc33d26e7$export$2e2bcd8739ae039; });

var $eIlmS = parcelRequire("eIlmS");

var $f2pyu = parcelRequire("f2pyu");

var $1jnh8 = parcelRequire("1jnh8");
function $23a9125fc33d26e7$export$24f604fe80e5f192(y0, y1) {
    var cy0 = (0, $eIlmS.cos)(y0), n = y0 === y1 ? (0, $eIlmS.sin)(y0) : (cy0 - (0, $eIlmS.cos)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, $eIlmS.abs)(n) < (0, $eIlmS.epsilon)) return 0, $1jnh8.equirectangularRaw;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, $eIlmS.sin)(nx),
            g - gy * (0, $eIlmS.cos)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y, l = (0, $eIlmS.atan2)(x, (0, $eIlmS.abs)(gy)) * (0, $eIlmS.sign)(gy);
        if (gy * n < 0) l -= (0, $eIlmS.pi) * (0, $eIlmS.sign)(x) * (0, $eIlmS.sign)(gy);
        return [
            l / n,
            g - (0, $eIlmS.sign)(n) * (0, $eIlmS.sqrt)(x * x + gy * gy)
        ];
    };
    return project;
}
function $23a9125fc33d26e7$export$2e2bcd8739ae039() {
    return (0, $f2pyu.conicProjection)($23a9125fc33d26e7$export$24f604fe80e5f192).scale(131.154).center([
        0,
        13.9389
    ]);
}

});
parcelRegister("1jnh8", function(module, exports) {

$parcel$export(module.exports, "equirectangularRaw", function () { return $0f499ecf9cc2c6eb$export$f5fee52180f2f058; });
$parcel$export(module.exports, "default", function () { return $0f499ecf9cc2c6eb$export$2e2bcd8739ae039; });

var $9Ld7N = parcelRequire("9Ld7N");
function $0f499ecf9cc2c6eb$export$f5fee52180f2f058(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
$0f499ecf9cc2c6eb$export$f5fee52180f2f058.invert = $0f499ecf9cc2c6eb$export$f5fee52180f2f058;
function $0f499ecf9cc2c6eb$export$2e2bcd8739ae039() {
    return (0, $9Ld7N.default)($0f499ecf9cc2c6eb$export$f5fee52180f2f058).scale(152.63);
}

});


parcelRegister("coj3B", function(module, exports) {

$parcel$export(module.exports, "equalEarthRaw", function () { return $9056824798c830c3$export$a320734067e7a731; });
$parcel$export(module.exports, "default", function () { return $9056824798c830c3$export$2e2bcd8739ae039; });

var $9Ld7N = parcelRequire("9Ld7N");

var $eIlmS = parcelRequire("eIlmS");
var $9056824798c830c3$var$A1 = 1.340264, $9056824798c830c3$var$A2 = -0.081106, $9056824798c830c3$var$A3 = 0.000893, $9056824798c830c3$var$A4 = 0.003796, $9056824798c830c3$var$M = (0, $eIlmS.sqrt)(3) / 2, $9056824798c830c3$var$iterations = 12;
function $9056824798c830c3$export$a320734067e7a731(lambda, phi) {
    var l = (0, $eIlmS.asin)($9056824798c830c3$var$M * (0, $eIlmS.sin)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
    return [
        lambda * (0, $eIlmS.cos)(l) / ($9056824798c830c3$var$M * ($9056824798c830c3$var$A1 + 3 * $9056824798c830c3$var$A2 * l2 + l6 * (7 * $9056824798c830c3$var$A3 + 9 * $9056824798c830c3$var$A4 * l2))),
        l * ($9056824798c830c3$var$A1 + $9056824798c830c3$var$A2 * l2 + l6 * ($9056824798c830c3$var$A3 + $9056824798c830c3$var$A4 * l2))
    ];
}
$9056824798c830c3$export$a320734067e7a731.invert = function(x, y) {
    var l = y, l2 = l * l, l6 = l2 * l2 * l2;
    for(var i = 0, delta, fy, fpy; i < $9056824798c830c3$var$iterations; ++i){
        fy = l * ($9056824798c830c3$var$A1 + $9056824798c830c3$var$A2 * l2 + l6 * ($9056824798c830c3$var$A3 + $9056824798c830c3$var$A4 * l2)) - y;
        fpy = $9056824798c830c3$var$A1 + 3 * $9056824798c830c3$var$A2 * l2 + l6 * (7 * $9056824798c830c3$var$A3 + 9 * $9056824798c830c3$var$A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if ((0, $eIlmS.abs)(delta) < (0, $eIlmS.epsilon2)) break;
    }
    return [
        $9056824798c830c3$var$M * x * ($9056824798c830c3$var$A1 + 3 * $9056824798c830c3$var$A2 * l2 + l6 * (7 * $9056824798c830c3$var$A3 + 9 * $9056824798c830c3$var$A4 * l2)) / (0, $eIlmS.cos)(l),
        (0, $eIlmS.asin)((0, $eIlmS.sin)(l) / $9056824798c830c3$var$M)
    ];
};
function $9056824798c830c3$export$2e2bcd8739ae039() {
    return (0, $9Ld7N.default)($9056824798c830c3$export$a320734067e7a731).scale(177.158);
}

});

parcelRegister("5IU3e", function(module, exports) {

$parcel$export(module.exports, "gnomonicRaw", function () { return $42ac8a6866a15865$export$dc8c6ddfc8b22c85; });
$parcel$export(module.exports, "default", function () { return $42ac8a6866a15865$export$2e2bcd8739ae039; });

var $eIlmS = parcelRequire("eIlmS");

var $81EHx = parcelRequire("81EHx");

var $9Ld7N = parcelRequire("9Ld7N");
function $42ac8a6866a15865$export$dc8c6ddfc8b22c85(x, y) {
    var cy = (0, $eIlmS.cos)(y), k = (0, $eIlmS.cos)(x) * cy;
    return [
        cy * (0, $eIlmS.sin)(x) / k,
        (0, $eIlmS.sin)(y) / k
    ];
}
$42ac8a6866a15865$export$dc8c6ddfc8b22c85.invert = (0, $81EHx.azimuthalInvert)((0, $eIlmS.atan));
function $42ac8a6866a15865$export$2e2bcd8739ae039() {
    return (0, $9Ld7N.default)($42ac8a6866a15865$export$dc8c6ddfc8b22c85).scale(144.049).clipAngle(60);
}

});

parcelRegister("ihvZ0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4f29fa9163fe707$export$2e2bcd8739ae039; });

var $3AeFV = parcelRequire("3AeFV");

var $egCND = parcelRequire("egCND");

var $77LaW = parcelRequire("77LaW");

var $ghaDX = parcelRequire("ghaDX");

var $eIlmS = parcelRequire("eIlmS");
function $d4f29fa9163fe707$export$2e2bcd8739ae039() {
    var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x0 = null, y0, x1, y1, kx = 1, ky = 1, transform = (0, $77LaW.transformer)({
        point: function(x, y) {
            var p = projection([
                x,
                y
            ]);
            this.stream.point(p[0], p[1]);
        }
    }), postclip = (0, $egCND.default), cache, cacheStream;
    function reset() {
        kx = k * sx;
        ky = k * sy;
        cache = cacheStream = null;
        return projection;
    }
    function projection(p) {
        var x = p[0] * kx, y = p[1] * ky;
        if (alpha) {
            var t = y * ca - x * sa;
            x = x * ca + y * sa;
            y = t;
        }
        return [
            x + tx,
            y + ty
        ];
    }
    projection.invert = function(p) {
        var x = p[0] - tx, y = p[1] - ty;
        if (alpha) {
            var t = y * ca + x * sa;
            x = x * ca - y * sa;
            y = t;
        }
        return [
            x / kx,
            y / ky
        ];
    };
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $egCND.default) : (0, $3AeFV.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, reset()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [
            tx,
            ty
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $eIlmS.radians), sa = (0, $eIlmS.sin)(alpha), ca = (0, $eIlmS.cos)(alpha), reset()) : alpha * (0, $eIlmS.degrees);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
    };
    projection.fitExtent = function(extent, object) {
        return (0, $ghaDX.fitExtent)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $ghaDX.fitSize)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $ghaDX.fitWidth)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $ghaDX.fitHeight)(projection, height, object);
    };
    return projection;
}

});

parcelRegister("h8r0n", function(module, exports) {

$parcel$export(module.exports, "naturalEarth1Raw", function () { return $c79821aebb7d8461$export$acb6def22fe878e6; });
$parcel$export(module.exports, "default", function () { return $c79821aebb7d8461$export$2e2bcd8739ae039; });

var $9Ld7N = parcelRequire("9Ld7N");

var $eIlmS = parcelRequire("eIlmS");
function $c79821aebb7d8461$export$acb6def22fe878e6(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
$c79821aebb7d8461$export$acb6def22fe878e6.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, $eIlmS.abs)(delta) > (0, $eIlmS.epsilon) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};
function $c79821aebb7d8461$export$2e2bcd8739ae039() {
    return (0, $9Ld7N.default)($c79821aebb7d8461$export$acb6def22fe878e6).scale(175.295);
}

});

parcelRegister("bOJIr", function(module, exports) {

$parcel$export(module.exports, "orthographicRaw", function () { return $89a7d370907937b7$export$1cd9c2eb846182a; });
$parcel$export(module.exports, "default", function () { return $89a7d370907937b7$export$2e2bcd8739ae039; });

var $eIlmS = parcelRequire("eIlmS");

var $81EHx = parcelRequire("81EHx");

var $9Ld7N = parcelRequire("9Ld7N");
function $89a7d370907937b7$export$1cd9c2eb846182a(x, y) {
    return [
        (0, $eIlmS.cos)(y) * (0, $eIlmS.sin)(x),
        (0, $eIlmS.sin)(y)
    ];
}
$89a7d370907937b7$export$1cd9c2eb846182a.invert = (0, $81EHx.azimuthalInvert)((0, $eIlmS.asin));
function $89a7d370907937b7$export$2e2bcd8739ae039() {
    return (0, $9Ld7N.default)($89a7d370907937b7$export$1cd9c2eb846182a).scale(249.5).clipAngle(90 + (0, $eIlmS.epsilon));
}

});

parcelRegister("abAWU", function(module, exports) {

$parcel$export(module.exports, "stereographicRaw", function () { return $76a797c7c27bb412$export$f9ccbb0dcb3dcd2b; });
$parcel$export(module.exports, "default", function () { return $76a797c7c27bb412$export$2e2bcd8739ae039; });

var $eIlmS = parcelRequire("eIlmS");

var $81EHx = parcelRequire("81EHx");

var $9Ld7N = parcelRequire("9Ld7N");
function $76a797c7c27bb412$export$f9ccbb0dcb3dcd2b(x, y) {
    var cy = (0, $eIlmS.cos)(y), k = 1 + (0, $eIlmS.cos)(x) * cy;
    return [
        cy * (0, $eIlmS.sin)(x) / k,
        (0, $eIlmS.sin)(y) / k
    ];
}
$76a797c7c27bb412$export$f9ccbb0dcb3dcd2b.invert = (0, $81EHx.azimuthalInvert)(function(z) {
    return 2 * (0, $eIlmS.atan)(z);
});
function $76a797c7c27bb412$export$2e2bcd8739ae039() {
    return (0, $9Ld7N.default)($76a797c7c27bb412$export$f9ccbb0dcb3dcd2b).scale(250).clipAngle(142);
}

});

parcelRegister("5Q7D5", function(module, exports) {

$parcel$export(module.exports, "transverseMercatorRaw", function () { return $4407ba215002c50e$export$e84942adec6de533; });
$parcel$export(module.exports, "default", function () { return $4407ba215002c50e$export$2e2bcd8739ae039; });

var $eIlmS = parcelRequire("eIlmS");

var $7gsAH = parcelRequire("7gsAH");
function $4407ba215002c50e$export$e84942adec6de533(lambda, phi) {
    return [
        (0, $eIlmS.log)((0, $eIlmS.tan)(((0, $eIlmS.halfPi) + phi) / 2)),
        -lambda
    ];
}
$4407ba215002c50e$export$e84942adec6de533.invert = function(x, y) {
    return [
        -y,
        2 * (0, $eIlmS.atan)((0, $eIlmS.exp)(x)) - (0, $eIlmS.halfPi)
    ];
};
function $4407ba215002c50e$export$2e2bcd8739ae039() {
    var m = (0, $7gsAH.mercatorProjection)($4407ba215002c50e$export$e84942adec6de533), center = m.center, rotate = m.rotate;
    m.center = function(_) {
        return arguments.length ? center([
            -_[1],
            _[0]
        ]) : (_ = center(), [
            _[1],
            -_[0]
        ]);
    };
    m.rotate = function(_) {
        return arguments.length ? rotate([
            _[0],
            _[1],
            _.length > 2 ? _[2] + 90 : 90
        ]) : (_ = rotate(), [
            _[0],
            _[1],
            _[2] - 90
        ]);
    };
    return rotate([
        0,
        0,
        90
    ]).scale(159.155);
}

});


parcelRegister("8M7Ca", function(module, exports) {

$parcel$export(module.exports, "cluster", function () { return (parcelRequire("lum4m")).default; });
$parcel$export(module.exports, "hierarchy", function () { return (parcelRequire("23IGt")).default; });
$parcel$export(module.exports, "pack", function () { return (parcelRequire("6Lq25")).default; });
$parcel$export(module.exports, "packSiblings", function () { return (parcelRequire("HwkGa")).default; });
$parcel$export(module.exports, "packEnclose", function () { return (parcelRequire("lxowc")).default; });
$parcel$export(module.exports, "partition", function () { return (parcelRequire("7qsBu")).default; });
$parcel$export(module.exports, "stratify", function () { return (parcelRequire("aXuxL")).default; });
$parcel$export(module.exports, "tree", function () { return (parcelRequire("dVtky")).default; });
$parcel$export(module.exports, "treemap", function () { return (parcelRequire("8r7OL")).default; });
$parcel$export(module.exports, "treemapBinary", function () { return (parcelRequire("9JKjl")).default; });
$parcel$export(module.exports, "treemapDice", function () { return (parcelRequire("lQ2jz")).default; });
$parcel$export(module.exports, "treemapSlice", function () { return (parcelRequire("4HXir")).default; });
$parcel$export(module.exports, "treemapSliceDice", function () { return (parcelRequire("2Sga7")).default; });
$parcel$export(module.exports, "treemapSquarify", function () { return (parcelRequire("9z0P0")).default; });
$parcel$export(module.exports, "treemapResquarify", function () { return (parcelRequire("eXTgu")).default; });

var $lum4m = parcelRequire("lum4m");

var $23IGt = parcelRequire("23IGt");

var $6Lq25 = parcelRequire("6Lq25");

var $HwkGa = parcelRequire("HwkGa");

var $lxowc = parcelRequire("lxowc");

var $7qsBu = parcelRequire("7qsBu");

var $aXuxL = parcelRequire("aXuxL");

var $dVtky = parcelRequire("dVtky");

var $8r7OL = parcelRequire("8r7OL");

var $9JKjl = parcelRequire("9JKjl");

var $lQ2jz = parcelRequire("lQ2jz");

var $4HXir = parcelRequire("4HXir");

var $2Sga7 = parcelRequire("2Sga7");

var $9z0P0 = parcelRequire("9z0P0");

var $eXTgu = parcelRequire("eXTgu");

});
parcelRegister("lum4m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa4d84d80e92b2eb$export$2e2bcd8739ae039; });
function $fa4d84d80e92b2eb$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
function $fa4d84d80e92b2eb$var$meanX(children) {
    return children.reduce($fa4d84d80e92b2eb$var$meanXReduce, 0) / children.length;
}
function $fa4d84d80e92b2eb$var$meanXReduce(x, c) {
    return x + c.x;
}
function $fa4d84d80e92b2eb$var$maxY(children) {
    return 1 + children.reduce($fa4d84d80e92b2eb$var$maxYReduce, 0);
}
function $fa4d84d80e92b2eb$var$maxYReduce(y, c) {
    return Math.max(y, c.y);
}
function $fa4d84d80e92b2eb$var$leafLeft(node) {
    var children;
    while(children = node.children)node = children[0];
    return node;
}
function $fa4d84d80e92b2eb$var$leafRight(node) {
    var children;
    while(children = node.children)node = children[children.length - 1];
    return node;
}
function $fa4d84d80e92b2eb$export$2e2bcd8739ae039() {
    var separation = $fa4d84d80e92b2eb$var$defaultSeparation, dx = 1, dy = 1, nodeSize = false;
    function cluster(root) {
        var previousNode, x = 0;
        // First walk, computing the initial x & y values.
        root.eachAfter(function(node) {
            var children = node.children;
            if (children) {
                node.x = $fa4d84d80e92b2eb$var$meanX(children);
                node.y = $fa4d84d80e92b2eb$var$maxY(children);
            } else {
                node.x = previousNode ? x += separation(node, previousNode) : 0;
                node.y = 0;
                previousNode = node;
            }
        });
        var left = $fa4d84d80e92b2eb$var$leafLeft(root), right = $fa4d84d80e92b2eb$var$leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
        // Second walk, normalizing x & y to the desired size.
        return root.eachAfter(nodeSize ? function(node) {
            node.x = (node.x - root.x) * dx;
            node.y = (root.y - node.y) * dy;
        } : function(node) {
            node.x = (node.x - x0) / (x1 - x0) * dx;
            node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
        });
    }
    cluster.separation = function(x) {
        return arguments.length ? (separation = x, cluster) : separation;
    };
    cluster.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    cluster.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return cluster;
}

});

parcelRegister("23IGt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17fe85e42679a193$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Node", function () { return $17fe85e42679a193$export$85c928794f8d04d4; });
$parcel$export(module.exports, "computeHeight", function () { return $17fe85e42679a193$export$5af32d52ab5dfd57; });

var $9PS1a = parcelRequire("9PS1a");

var $7KkPK = parcelRequire("7KkPK");

var $9sFUr = parcelRequire("9sFUr");

var $6O5kK = parcelRequire("6O5kK");

var $35VBw = parcelRequire("35VBw");

var $hCEiv = parcelRequire("hCEiv");

var $idT9E = parcelRequire("idT9E");

var $hesVB = parcelRequire("hesVB");

var $jIhkf = parcelRequire("jIhkf");

var $5Yq7A = parcelRequire("5Yq7A");

var $5o7Rv = parcelRequire("5o7Rv");
function $17fe85e42679a193$export$2e2bcd8739ae039(data, children) {
    var root = new $17fe85e42679a193$export$85c928794f8d04d4(data), valued = +data.value && (root.value = data.value), node, nodes = [
        root
    ], child, childs, i, n;
    if (children == null) children = $17fe85e42679a193$var$defaultChildren;
    while(node = nodes.pop()){
        if (valued) node.value = +node.data.value;
        if ((childs = children(node.data)) && (n = childs.length)) {
            node.children = new Array(n);
            for(i = n - 1; i >= 0; --i){
                nodes.push(child = node.children[i] = new $17fe85e42679a193$export$85c928794f8d04d4(childs[i]));
                child.parent = node;
                child.depth = node.depth + 1;
            }
        }
    }
    return root.eachBefore($17fe85e42679a193$export$5af32d52ab5dfd57);
}
function $17fe85e42679a193$var$node_copy() {
    return $17fe85e42679a193$export$2e2bcd8739ae039(this).eachBefore($17fe85e42679a193$var$copyData);
}
function $17fe85e42679a193$var$defaultChildren(d) {
    return d.children;
}
function $17fe85e42679a193$var$copyData(node) {
    node.data = node.data.data;
}
function $17fe85e42679a193$export$5af32d52ab5dfd57(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function $17fe85e42679a193$export$85c928794f8d04d4(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
$17fe85e42679a193$export$85c928794f8d04d4.prototype = $17fe85e42679a193$export$2e2bcd8739ae039.prototype = {
    constructor: $17fe85e42679a193$export$85c928794f8d04d4,
    count: (0, $9PS1a.default),
    each: (0, $7KkPK.default),
    eachAfter: (0, $6O5kK.default),
    eachBefore: (0, $9sFUr.default),
    sum: (0, $35VBw.default),
    sort: (0, $hCEiv.default),
    path: (0, $idT9E.default),
    ancestors: (0, $hesVB.default),
    descendants: (0, $jIhkf.default),
    leaves: (0, $5Yq7A.default),
    links: (0, $5o7Rv.default),
    copy: $17fe85e42679a193$var$node_copy
};

});
parcelRegister("9PS1a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7292c748d2c4d87d$export$2e2bcd8739ae039; });
function $7292c748d2c4d87d$var$count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}
function $7292c748d2c4d87d$export$2e2bcd8739ae039() {
    return this.eachAfter($7292c748d2c4d87d$var$count);
}

});

parcelRegister("7KkPK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a3cfd6412656d70$export$2e2bcd8739ae039; });
function $5a3cfd6412656d70$export$2e2bcd8739ae039(callback) {
    var node = this, current, next = [
        node
    ], children, i, n;
    do {
        current = next.reverse(), next = [];
        while(node = current.pop()){
            callback(node), children = node.children;
            if (children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
        }
    }while (next.length);
    return this;
}

});

parcelRegister("9sFUr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e373ce948ce20f0$export$2e2bcd8739ae039; });
function $6e373ce948ce20f0$export$2e2bcd8739ae039(callback) {
    var node = this, nodes = [
        node
    ], children, i;
    while(node = nodes.pop()){
        callback(node), children = node.children;
        if (children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
    }
    return this;
}

});

parcelRegister("6O5kK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f4b8cbbdbba91be$export$2e2bcd8739ae039; });
function $4f4b8cbbdbba91be$export$2e2bcd8739ae039(callback) {
    var node = this, nodes = [
        node
    ], next = [], children, i, n;
    while(node = nodes.pop()){
        next.push(node), children = node.children;
        if (children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
    }
    while(node = next.pop())callback(node);
    return this;
}

});

parcelRegister("35VBw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $240e85b501b5a83b$export$2e2bcd8739ae039; });
function $240e85b501b5a83b$export$2e2bcd8739ae039(value) {
    return this.eachAfter(function(node) {
        var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
        while(--i >= 0)sum += children[i].value;
        node.value = sum;
    });
}

});

parcelRegister("hCEiv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd453e87ea3aad18$export$2e2bcd8739ae039; });
function $cd453e87ea3aad18$export$2e2bcd8739ae039(compare) {
    return this.eachBefore(function(node) {
        if (node.children) node.children.sort(compare);
    });
}

});

parcelRegister("idT9E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d44439713d93f2e8$export$2e2bcd8739ae039; });
function $d44439713d93f2e8$export$2e2bcd8739ae039(end) {
    var start = this, ancestor = $d44439713d93f2e8$var$leastCommonAncestor(start, end), nodes = [
        start
    ];
    while(start !== ancestor){
        start = start.parent;
        nodes.push(start);
    }
    var k = nodes.length;
    while(end !== ancestor){
        nodes.splice(k, 0, end);
        end = end.parent;
    }
    return nodes;
}
function $d44439713d93f2e8$var$leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}

});

parcelRegister("hesVB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8ba2efb574b054b$export$2e2bcd8739ae039; });
function $c8ba2efb574b054b$export$2e2bcd8739ae039() {
    var node = this, nodes = [
        node
    ];
    while(node = node.parent)nodes.push(node);
    return nodes;
}

});

parcelRegister("jIhkf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e59f90e15e9a18cb$export$2e2bcd8739ae039; });
function $e59f90e15e9a18cb$export$2e2bcd8739ae039() {
    var nodes = [];
    this.each(function(node) {
        nodes.push(node);
    });
    return nodes;
}

});

parcelRegister("5Yq7A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4596d182dec2ec73$export$2e2bcd8739ae039; });
function $4596d182dec2ec73$export$2e2bcd8739ae039() {
    var leaves = [];
    this.eachBefore(function(node) {
        if (!node.children) leaves.push(node);
    });
    return leaves;
}

});

parcelRegister("5o7Rv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ec54ae0911d9663$export$2e2bcd8739ae039; });
function $3ec54ae0911d9663$export$2e2bcd8739ae039() {
    var root = this, links = [];
    root.each(function(node) {
        if (node !== root) links.push({
            source: node.parent,
            target: node
        });
    });
    return links;
}

});


parcelRegister("6Lq25", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ecb5365a6248cd1$export$2e2bcd8739ae039; });

var $HwkGa = parcelRequire("HwkGa");

var $c6A7L = parcelRequire("c6A7L");

var $894hg = parcelRequire("894hg");
function $4ecb5365a6248cd1$var$defaultRadius(d) {
    return Math.sqrt(d.value);
}
function $4ecb5365a6248cd1$export$2e2bcd8739ae039() {
    var radius = null, dx = 1, dy = 1, padding = (0, $894hg.constantZero);
    function pack(root) {
        root.x = dx / 2, root.y = dy / 2;
        if (radius) root.eachBefore($4ecb5365a6248cd1$var$radiusLeaf(radius)).eachAfter($4ecb5365a6248cd1$var$packChildren(padding, 0.5)).eachBefore($4ecb5365a6248cd1$var$translateChild(1));
        else root.eachBefore($4ecb5365a6248cd1$var$radiusLeaf($4ecb5365a6248cd1$var$defaultRadius)).eachAfter($4ecb5365a6248cd1$var$packChildren((0, $894hg.constantZero), 1)).eachAfter($4ecb5365a6248cd1$var$packChildren(padding, root.r / Math.min(dx, dy))).eachBefore($4ecb5365a6248cd1$var$translateChild(Math.min(dx, dy) / (2 * root.r)));
        return root;
    }
    pack.radius = function(x) {
        return arguments.length ? (radius = (0, $c6A7L.optional)(x), pack) : radius;
    };
    pack.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
            dx,
            dy
        ];
    };
    pack.padding = function(x) {
        return arguments.length ? (padding = typeof x === "function" ? x : (0, $894hg.default)(+x), pack) : padding;
    };
    return pack;
}
function $4ecb5365a6248cd1$var$radiusLeaf(radius) {
    return function(node) {
        if (!node.children) node.r = Math.max(0, +radius(node) || 0);
    };
}
function $4ecb5365a6248cd1$var$packChildren(padding, k) {
    return function(node) {
        if (children = node.children) {
            var children, i, n = children.length, r = padding(node) * k || 0, e;
            if (r) for(i = 0; i < n; ++i)children[i].r += r;
            e = (0, $HwkGa.packEnclose)(children);
            if (r) for(i = 0; i < n; ++i)children[i].r -= r;
            node.r = e + r;
        }
    };
}
function $4ecb5365a6248cd1$var$translateChild(k) {
    return function(node) {
        var parent = node.parent;
        node.r *= k;
        if (parent) {
            node.x = parent.x + k * node.x;
            node.y = parent.y + k * node.y;
        }
    };
}

});
parcelRegister("HwkGa", function(module, exports) {

$parcel$export(module.exports, "packEnclose", function () { return $082d18d5a1d7f0aa$export$b86b5dcbc4bfc7a7; });
$parcel$export(module.exports, "default", function () { return $082d18d5a1d7f0aa$export$2e2bcd8739ae039; });

var $lxowc = parcelRequire("lxowc");
function $082d18d5a1d7f0aa$var$place(b, a, c) {
    var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
    if (d2) {
        a2 = a.r + c.r, a2 *= a2;
        b2 = b.r + c.r, b2 *= b2;
        if (a2 > b2) {
            x = (d2 + b2 - a2) / (2 * d2);
            y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
            c.x = b.x - x * dx - y * dy;
            c.y = b.y - x * dy + y * dx;
        } else {
            x = (d2 + a2 - b2) / (2 * d2);
            y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
            c.x = a.x + x * dx - y * dy;
            c.y = a.y + x * dy + y * dx;
        }
    } else {
        c.x = a.x + c.r;
        c.y = a.y;
    }
}
function $082d18d5a1d7f0aa$var$intersects(a, b) {
    var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $082d18d5a1d7f0aa$var$score(node) {
    var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
}
function $082d18d5a1d7f0aa$var$Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
}
function $082d18d5a1d7f0aa$export$b86b5dcbc4bfc7a7(circles) {
    if (!(n = circles.length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
    // Place the third circle.
    $082d18d5a1d7f0aa$var$place(b, a, c = circles[2]);
    // Initialize the front-chain using the first three circles a, b and c.
    a = new $082d18d5a1d7f0aa$var$Node(a), b = new $082d18d5a1d7f0aa$var$Node(b), c = new $082d18d5a1d7f0aa$var$Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
    // Attempt to place each remaining circle…
    pack: for(i = 3; i < n; ++i){
        $082d18d5a1d7f0aa$var$place(a._, b._, c = circles[i]), c = new $082d18d5a1d7f0aa$var$Node(c);
        // Find the closest intersecting circle on the front-chain, if any.
        // “Closeness” is determined by linear distance along the front-chain.
        // “Ahead” or “behind” is likewise determined by linear distance.
        j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
        do if (sj <= sk) {
            if ($082d18d5a1d7f0aa$var$intersects(j._, c._)) {
                b = j, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sj += j._.r, j = j.next;
        } else {
            if ($082d18d5a1d7f0aa$var$intersects(k._, c._)) {
                a = k, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sk += k._.r, k = k.previous;
        }
        while (j !== k.next);
        // Success! Insert the new circle c between a and b.
        c.previous = a, c.next = b, a.next = b.previous = b = c;
        // Compute the new closest circle pair to the centroid.
        aa = $082d18d5a1d7f0aa$var$score(a);
        while((c = c.next) !== b)if ((ca = $082d18d5a1d7f0aa$var$score(c)) < aa) a = c, aa = ca;
        b = a.next;
    }
    // Compute the enclosing circle of the front chain.
    a = [
        b._
    ], c = b;
    while((c = c.next) !== b)a.push(c._);
    c = (0, $lxowc.default)(a);
    // Translate the circles to put the enclosing circle around the origin.
    for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
    return c.r;
}
function $082d18d5a1d7f0aa$export$2e2bcd8739ae039(circles) {
    $082d18d5a1d7f0aa$export$b86b5dcbc4bfc7a7(circles);
    return circles;
}

});
parcelRegister("lxowc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fadfb2e19d3a7198$export$2e2bcd8739ae039; });

var $kQKc0 = parcelRequire("kQKc0");
function $fadfb2e19d3a7198$export$2e2bcd8739ae039(circles) {
    var i = 0, n = (circles = (0, $kQKc0.shuffle)((0, $kQKc0.slice).call(circles))).length, B = [], p, e;
    while(i < n){
        p = circles[i];
        if (e && $fadfb2e19d3a7198$var$enclosesWeak(e, p)) ++i;
        else e = $fadfb2e19d3a7198$var$encloseBasis(B = $fadfb2e19d3a7198$var$extendBasis(B, p)), i = 0;
    }
    return e;
}
function $fadfb2e19d3a7198$var$extendBasis(B, p) {
    var i, j;
    if ($fadfb2e19d3a7198$var$enclosesWeakAll(p, B)) return [
        p
    ];
    // If we get here then B must have at least one element.
    for(i = 0; i < B.length; ++i){
        if ($fadfb2e19d3a7198$var$enclosesNot(p, B[i]) && $fadfb2e19d3a7198$var$enclosesWeakAll($fadfb2e19d3a7198$var$encloseBasis2(B[i], p), B)) return [
            B[i],
            p
        ];
    }
    // If we get here then B must have at least two elements.
    for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
        if ($fadfb2e19d3a7198$var$enclosesNot($fadfb2e19d3a7198$var$encloseBasis2(B[i], B[j]), p) && $fadfb2e19d3a7198$var$enclosesNot($fadfb2e19d3a7198$var$encloseBasis2(B[i], p), B[j]) && $fadfb2e19d3a7198$var$enclosesNot($fadfb2e19d3a7198$var$encloseBasis2(B[j], p), B[i]) && $fadfb2e19d3a7198$var$enclosesWeakAll($fadfb2e19d3a7198$var$encloseBasis3(B[i], B[j], p), B)) return [
            B[i],
            B[j],
            p
        ];
    }
    // If we get here then something is very wrong.
    throw new Error;
}
function $fadfb2e19d3a7198$var$enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function $fadfb2e19d3a7198$var$enclosesWeak(a, b) {
    var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $fadfb2e19d3a7198$var$enclosesWeakAll(a, B) {
    for(var i = 0; i < B.length; ++i){
        if (!$fadfb2e19d3a7198$var$enclosesWeak(a, B[i])) return false;
    }
    return true;
}
function $fadfb2e19d3a7198$var$encloseBasis(B) {
    switch(B.length){
        case 1:
            return $fadfb2e19d3a7198$var$encloseBasis1(B[0]);
        case 2:
            return $fadfb2e19d3a7198$var$encloseBasis2(B[0], B[1]);
        case 3:
            return $fadfb2e19d3a7198$var$encloseBasis3(B[0], B[1], B[2]);
    }
}
function $fadfb2e19d3a7198$var$encloseBasis1(a) {
    return {
        x: a.x,
        y: a.y,
        r: a.r
    };
}
function $fadfb2e19d3a7198$var$encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
    };
}
function $fadfb2e19d3a7198$var$encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
    };
}

});
parcelRegister("kQKc0", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $f2dc7edbef50142a$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "shuffle", function () { return $f2dc7edbef50142a$export$448332262467e042; });
var $f2dc7edbef50142a$export$58adb3bec8346d0f = Array.prototype.slice;
function $f2dc7edbef50142a$export$448332262467e042(array) {
    var m = array.length, t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}

});



parcelRegister("c6A7L", function(module, exports) {

$parcel$export(module.exports, "optional", function () { return $8d02111b02907ebb$export$516e28dec6a4b6d4; });
$parcel$export(module.exports, "required", function () { return $8d02111b02907ebb$export$a7a0278c004aac3f; });
function $8d02111b02907ebb$export$516e28dec6a4b6d4(f) {
    return f == null ? null : $8d02111b02907ebb$export$a7a0278c004aac3f(f);
}
function $8d02111b02907ebb$export$a7a0278c004aac3f(f) {
    if (typeof f !== "function") throw new Error;
    return f;
}

});

parcelRegister("894hg", function(module, exports) {

$parcel$export(module.exports, "constantZero", function () { return $5ee27b629f7edcff$export$99e2e371aa6a9db; });
$parcel$export(module.exports, "default", function () { return $5ee27b629f7edcff$export$2e2bcd8739ae039; });
function $5ee27b629f7edcff$export$99e2e371aa6a9db() {
    return 0;
}
function $5ee27b629f7edcff$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("7qsBu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56812631d8fe3270$export$2e2bcd8739ae039; });

var $dqgMd = parcelRequire("dqgMd");

var $lQ2jz = parcelRequire("lQ2jz");
function $56812631d8fe3270$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, padding = 0, round = false;
    function partition(root) {
        var n = root.height + 1;
        root.x0 = root.y0 = padding;
        root.x1 = dx;
        root.y1 = dy / n;
        root.eachBefore(positionNode(dy, n));
        if (round) root.eachBefore((0, $dqgMd.default));
        return root;
    }
    function positionNode(dy, n) {
        return function(node) {
            if (node.children) (0, $lQ2jz.default)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
            var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
        };
    }
    partition.round = function(x) {
        return arguments.length ? (round = !!x, partition) : round;
    };
    partition.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
            dx,
            dy
        ];
    };
    partition.padding = function(x) {
        return arguments.length ? (padding = +x, partition) : padding;
    };
    return partition;
}

});
parcelRegister("dqgMd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c5ab794c1f0f722$export$2e2bcd8739ae039; });
function $9c5ab794c1f0f722$export$2e2bcd8739ae039(node) {
    node.x0 = Math.round(node.x0);
    node.y0 = Math.round(node.y0);
    node.x1 = Math.round(node.x1);
    node.y1 = Math.round(node.y1);
}

});

parcelRegister("lQ2jz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe603febfcea0b28$export$2e2bcd8739ae039; });
function $fe603febfcea0b28$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
    while(++i < n){
        node = nodes[i], node.y0 = y0, node.y1 = y1;
        node.x0 = x0, node.x1 = x0 += node.value * k;
    }
}

});


parcelRegister("aXuxL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fa71b5e80353787$export$2e2bcd8739ae039; });

var $c6A7L = parcelRequire("c6A7L");

var $23IGt = parcelRequire("23IGt");
var $7fa71b5e80353787$var$keyPrefix = "$", $7fa71b5e80353787$var$preroot = {
    depth: -1
}, $7fa71b5e80353787$var$ambiguous = {};
function $7fa71b5e80353787$var$defaultId(d) {
    return d.id;
}
function $7fa71b5e80353787$var$defaultParentId(d) {
    return d.parentId;
}
function $7fa71b5e80353787$export$2e2bcd8739ae039() {
    var id = $7fa71b5e80353787$var$defaultId, parentId = $7fa71b5e80353787$var$defaultParentId;
    function stratify(data) {
        var d, i, n = data.length, root, parent, node, nodes = new Array(n), nodeId, nodeKey, nodeByKey = {};
        for(i = 0; i < n; ++i){
            d = data[i], node = nodes[i] = new (0, $23IGt.Node)(d);
            if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
                nodeKey = $7fa71b5e80353787$var$keyPrefix + (node.id = nodeId);
                nodeByKey[nodeKey] = nodeKey in nodeByKey ? $7fa71b5e80353787$var$ambiguous : node;
            }
        }
        for(i = 0; i < n; ++i){
            node = nodes[i], nodeId = parentId(data[i], i, data);
            if (nodeId == null || !(nodeId += "")) {
                if (root) throw new Error("multiple roots");
                root = node;
            } else {
                parent = nodeByKey[$7fa71b5e80353787$var$keyPrefix + nodeId];
                if (!parent) throw new Error("missing: " + nodeId);
                if (parent === $7fa71b5e80353787$var$ambiguous) throw new Error("ambiguous: " + nodeId);
                if (parent.children) parent.children.push(node);
                else parent.children = [
                    node
                ];
                node.parent = parent;
            }
        }
        if (!root) throw new Error("no root");
        root.parent = $7fa71b5e80353787$var$preroot;
        root.eachBefore(function(node) {
            node.depth = node.parent.depth + 1;
            --n;
        }).eachBefore((0, $23IGt.computeHeight));
        root.parent = null;
        if (n > 0) throw new Error("cycle");
        return root;
    }
    stratify.id = function(x) {
        return arguments.length ? (id = (0, $c6A7L.required)(x), stratify) : id;
    };
    stratify.parentId = function(x) {
        return arguments.length ? (parentId = (0, $c6A7L.required)(x), stratify) : parentId;
    };
    return stratify;
}

});

parcelRegister("dVtky", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a23759a464f7dfe8$export$2e2bcd8739ae039; });

var $23IGt = parcelRequire("23IGt");
function $a23759a464f7dfe8$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }
// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function $a23759a464f7dfe8$var$nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
}
// This function works analogously to nextLeft.
function $a23759a464f7dfe8$var$nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
}
// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function $a23759a464f7dfe8$var$moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
}
// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function $a23759a464f7dfe8$var$executeShifts(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while(--i >= 0){
        w = children[i];
        w.z += shift;
        w.m += shift;
        shift += w.s + (change += w.c);
    }
}
// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function $a23759a464f7dfe8$var$nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
}
function $a23759a464f7dfe8$var$TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor
    this.a = this; // ancestor
    this.z = 0; // prelim
    this.m = 0; // mod
    this.c = 0; // change
    this.s = 0; // shift
    this.t = null; // thread
    this.i = i; // number
}
$a23759a464f7dfe8$var$TreeNode.prototype = Object.create((0, $23IGt.Node).prototype);
function $a23759a464f7dfe8$var$treeRoot(root) {
    var tree = new $a23759a464f7dfe8$var$TreeNode(root, 0), node, nodes = [
        tree
    ], child, children, i, n;
    while(node = nodes.pop())if (children = node._.children) {
        node.children = new Array(n = children.length);
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = node.children[i] = new $a23759a464f7dfe8$var$TreeNode(children[i], i));
            child.parent = node;
        }
    }
    (tree.parent = new $a23759a464f7dfe8$var$TreeNode(null, 0)).children = [
        tree
    ];
    return tree;
}
function $a23759a464f7dfe8$export$2e2bcd8739ae039() {
    var separation = $a23759a464f7dfe8$var$defaultSeparation, dx = 1, dy = 1, nodeSize = null;
    function tree(root) {
        var t = $a23759a464f7dfe8$var$treeRoot(root);
        // Compute the layout using Buchheim et al.’s algorithm.
        t.eachAfter(firstWalk), t.parent.m = -t.z;
        t.eachBefore(secondWalk);
        // If a fixed node size is specified, scale x and y.
        if (nodeSize) root.eachBefore(sizeNode);
        else {
            var left = root, right = root, bottom = root;
            root.eachBefore(function(node) {
                if (node.x < left.x) left = node;
                if (node.x > right.x) right = node;
                if (node.depth > bottom.depth) bottom = node;
            });
            var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
            root.eachBefore(function(node) {
                node.x = (node.x + tx) * kx;
                node.y = node.depth * ky;
            });
        }
        return root;
    }
    // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
    // applied recursively to the children of v, as well as the function
    // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
    // node v is placed to the midpoint of its outermost children.
    function firstWalk(v) {
        var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
        if (children) {
            $a23759a464f7dfe8$var$executeShifts(v);
            var midpoint = (children[0].z + children[children.length - 1].z) / 2;
            if (w) {
                v.z = w.z + separation(v._, w._);
                v.m = v.z - midpoint;
            } else v.z = midpoint;
        } else if (w) v.z = w.z + separation(v._, w._);
        v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    // Computes all real x-coordinates by summing up the modifiers recursively.
    function secondWalk(v) {
        v._.x = v.z + v.parent.m;
        v.m += v.parent.m;
    }
    // The core of the algorithm. Here, a new subtree is combined with the
    // previous subtrees. Threads are used to traverse the inside and outside
    // contours of the left and right subtree up to the highest common level. The
    // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
    // superscript o means outside and i means inside, the subscript - means left
    // subtree and + means right subtree. For summing up the modifiers along the
    // contour, we use respective variables si+, si-, so-, and so+. Whenever two
    // nodes of the inside contours conflict, we compute the left one of the
    // greatest uncommon ancestors using the function ANCESTOR and call MOVE
    // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
    // Finally, we add a new thread (if necessary).
    function apportion(v, w, ancestor) {
        if (w) {
            var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
            while(vim = $a23759a464f7dfe8$var$nextRight(vim), vip = $a23759a464f7dfe8$var$nextLeft(vip), vim && vip){
                vom = $a23759a464f7dfe8$var$nextLeft(vom);
                vop = $a23759a464f7dfe8$var$nextRight(vop);
                vop.a = v;
                shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                if (shift > 0) {
                    $a23759a464f7dfe8$var$moveSubtree($a23759a464f7dfe8$var$nextAncestor(vim, v, ancestor), v, shift);
                    sip += shift;
                    sop += shift;
                }
                sim += vim.m;
                sip += vip.m;
                som += vom.m;
                sop += vop.m;
            }
            if (vim && !$a23759a464f7dfe8$var$nextRight(vop)) {
                vop.t = vim;
                vop.m += sim - sop;
            }
            if (vip && !$a23759a464f7dfe8$var$nextLeft(vom)) {
                vom.t = vip;
                vom.m += sip - som;
                ancestor = v;
            }
        }
        return ancestor;
    }
    function sizeNode(node) {
        node.x *= dx;
        node.y = node.depth * dy;
    }
    tree.separation = function(x) {
        return arguments.length ? (separation = x, tree) : separation;
    };
    tree.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    tree.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return tree;
}

});

parcelRegister("8r7OL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6246e8d1b51451ac$export$2e2bcd8739ae039; });

var $dqgMd = parcelRequire("dqgMd");

var $9z0P0 = parcelRequire("9z0P0");

var $c6A7L = parcelRequire("c6A7L");

var $894hg = parcelRequire("894hg");
function $6246e8d1b51451ac$export$2e2bcd8739ae039() {
    var tile = (0, $9z0P0.default), round = false, dx = 1, dy = 1, paddingStack = [
        0
    ], paddingInner = (0, $894hg.constantZero), paddingTop = (0, $894hg.constantZero), paddingRight = (0, $894hg.constantZero), paddingBottom = (0, $894hg.constantZero), paddingLeft = (0, $894hg.constantZero);
    function treemap(root) {
        root.x0 = root.y0 = 0;
        root.x1 = dx;
        root.y1 = dy;
        root.eachBefore(positionNode);
        paddingStack = [
            0
        ];
        if (round) root.eachBefore((0, $dqgMd.default));
        return root;
    }
    function positionNode(node) {
        var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
        if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
        if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
        node.x0 = x0;
        node.y0 = y0;
        node.x1 = x1;
        node.y1 = y1;
        if (node.children) {
            p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
            x0 += paddingLeft(node) - p;
            y0 += paddingTop(node) - p;
            x1 -= paddingRight(node) - p;
            y1 -= paddingBottom(node) - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            tile(node, x0, y0, x1, y1);
        }
    }
    treemap.round = function(x) {
        return arguments.length ? (round = !!x, treemap) : round;
    };
    treemap.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
            dx,
            dy
        ];
    };
    treemap.tile = function(x) {
        return arguments.length ? (tile = (0, $c6A7L.required)(x), treemap) : tile;
    };
    treemap.padding = function(x) {
        return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
    };
    treemap.paddingInner = function(x) {
        return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, $894hg.default)(+x), treemap) : paddingInner;
    };
    treemap.paddingOuter = function(x) {
        return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
    };
    treemap.paddingTop = function(x) {
        return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, $894hg.default)(+x), treemap) : paddingTop;
    };
    treemap.paddingRight = function(x) {
        return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, $894hg.default)(+x), treemap) : paddingRight;
    };
    treemap.paddingBottom = function(x) {
        return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, $894hg.default)(+x), treemap) : paddingBottom;
    };
    treemap.paddingLeft = function(x) {
        return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, $894hg.default)(+x), treemap) : paddingLeft;
    };
    return treemap;
}

});
parcelRegister("9z0P0", function(module, exports) {

$parcel$export(module.exports, "phi", function () { return $6f68051950be121c$export$324943737027944a; });
$parcel$export(module.exports, "squarifyRatio", function () { return $6f68051950be121c$export$9ff1217655212093; });
$parcel$export(module.exports, "default", function () { return $6f68051950be121c$export$2e2bcd8739ae039; });

var $lQ2jz = parcelRequire("lQ2jz");

var $4HXir = parcelRequire("4HXir");
var $6f68051950be121c$export$324943737027944a = (1 + Math.sqrt(5)) / 2;
function $6f68051950be121c$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, $lQ2jz.default)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, $4HXir.default)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
var $6f68051950be121c$export$2e2bcd8739ae039 = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        $6f68051950be121c$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}($6f68051950be121c$export$324943737027944a);

});
parcelRegister("4HXir", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36d92c9fb9f3c2ad$export$2e2bcd8739ae039; });
function $36d92c9fb9f3c2ad$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
    while(++i < n){
        node = nodes[i], node.x0 = x0, node.x1 = x1;
        node.y0 = y0, node.y1 = y0 += node.value * k;
    }
}

});



parcelRegister("9JKjl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $716c3d677bba400a$export$2e2bcd8739ae039; });
function $716c3d677bba400a$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
    for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
    partition(0, n, parent.value, x0, y0, x1, y1);
    function partition(i, j, value, x0, y0, x1, y1) {
        if (i >= j - 1) {
            var node = nodes[i];
            node.x0 = x0, node.y0 = y0;
            node.x1 = x1, node.y1 = y1;
            return;
        }
        var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
        while(k < hi){
            var mid = k + hi >>> 1;
            if (sums[mid] < valueTarget) k = mid + 1;
            else hi = mid;
        }
        if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
        var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
        if (x1 - x0 > y1 - y0) {
            var xk = (x0 * valueRight + x1 * valueLeft) / value;
            partition(i, k, valueLeft, x0, y0, xk, y1);
            partition(k, j, valueRight, xk, y0, x1, y1);
        } else {
            var yk = (y0 * valueRight + y1 * valueLeft) / value;
            partition(i, k, valueLeft, x0, y0, x1, yk);
            partition(k, j, valueRight, x0, yk, x1, y1);
        }
    }
}

});

parcelRegister("2Sga7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $217d29667b5d7cd2$export$2e2bcd8739ae039; });

var $lQ2jz = parcelRequire("lQ2jz");

var $4HXir = parcelRequire("4HXir");
function $217d29667b5d7cd2$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    (parent.depth & 1 ? (0, $4HXir.default) : (0, $lQ2jz.default))(parent, x0, y0, x1, y1);
}

});

parcelRegister("eXTgu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae5171d8361ac0a8$export$2e2bcd8739ae039; });

var $lQ2jz = parcelRequire("lQ2jz");

var $4HXir = parcelRequire("4HXir");

var $9z0P0 = parcelRequire("9z0P0");
var $ae5171d8361ac0a8$export$2e2bcd8739ae039 = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, $lQ2jz.default)(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
                else (0, $4HXir.default)(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, $9z0P0.squarifyRatio)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, $9z0P0.phi));

});


parcelRegister("7gg6n", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return (parcelRequire("f01sj")).default; });
$parcel$export(module.exports, "interpolateArray", function () { return (parcelRequire("gMJO6")).default; });
$parcel$export(module.exports, "interpolateBasis", function () { return (parcelRequire("jVAt7")).default; });
$parcel$export(module.exports, "interpolateBasisClosed", function () { return (parcelRequire("bicwC")).default; });
$parcel$export(module.exports, "interpolateDate", function () { return (parcelRequire("jHuCs")).default; });
$parcel$export(module.exports, "interpolateDiscrete", function () { return (parcelRequire("77dmg")).default; });
$parcel$export(module.exports, "interpolateHue", function () { return (parcelRequire("6yAT4")).default; });
$parcel$export(module.exports, "interpolateNumber", function () { return (parcelRequire("iI7Wc")).default; });
$parcel$export(module.exports, "interpolateNumberArray", function () { return (parcelRequire("kZrzr")).default; });
$parcel$export(module.exports, "interpolateObject", function () { return (parcelRequire("9RiCU")).default; });
$parcel$export(module.exports, "interpolateRound", function () { return (parcelRequire("fcwsN")).default; });
$parcel$export(module.exports, "interpolateString", function () { return (parcelRequire("2ESy3")).default; });
$parcel$export(module.exports, "interpolateTransformCss", function () { return (parcelRequire("6oDCD")).interpolateTransformCss; });
$parcel$export(module.exports, "interpolateTransformSvg", function () { return (parcelRequire("6oDCD")).interpolateTransformSvg; });
$parcel$export(module.exports, "interpolateZoom", function () { return (parcelRequire("9Zp9m")).default; });
$parcel$export(module.exports, "interpolateRgb", function () { return (parcelRequire("luZYw")).default; });
$parcel$export(module.exports, "interpolateRgbBasis", function () { return (parcelRequire("luZYw")).rgbBasis; });
$parcel$export(module.exports, "interpolateRgbBasisClosed", function () { return (parcelRequire("luZYw")).rgbBasisClosed; });
$parcel$export(module.exports, "interpolateHsl", function () { return (parcelRequire("e1HrX")).default; });
$parcel$export(module.exports, "interpolateHslLong", function () { return (parcelRequire("e1HrX")).hslLong; });
$parcel$export(module.exports, "interpolateLab", function () { return (parcelRequire("eIDVA")).default; });
$parcel$export(module.exports, "interpolateHcl", function () { return (parcelRequire("ilzCT")).default; });
$parcel$export(module.exports, "interpolateHclLong", function () { return (parcelRequire("ilzCT")).hclLong; });
$parcel$export(module.exports, "interpolateCubehelix", function () { return (parcelRequire("cxyfw")).default; });
$parcel$export(module.exports, "interpolateCubehelixLong", function () { return (parcelRequire("cxyfw")).cubehelixLong; });
$parcel$export(module.exports, "piecewise", function () { return (parcelRequire("6uozE")).default; });
$parcel$export(module.exports, "quantize", function () { return (parcelRequire("ioDUE")).default; });

var $f01sj = parcelRequire("f01sj");

var $gMJO6 = parcelRequire("gMJO6");

var $jVAt7 = parcelRequire("jVAt7");

var $bicwC = parcelRequire("bicwC");

var $jHuCs = parcelRequire("jHuCs");

var $77dmg = parcelRequire("77dmg");

var $6yAT4 = parcelRequire("6yAT4");

var $iI7Wc = parcelRequire("iI7Wc");

var $kZrzr = parcelRequire("kZrzr");

var $9RiCU = parcelRequire("9RiCU");

var $fcwsN = parcelRequire("fcwsN");

var $2ESy3 = parcelRequire("2ESy3");

var $6oDCD = parcelRequire("6oDCD");

var $9Zp9m = parcelRequire("9Zp9m");

var $luZYw = parcelRequire("luZYw");

var $e1HrX = parcelRequire("e1HrX");

var $eIDVA = parcelRequire("eIDVA");

var $ilzCT = parcelRequire("ilzCT");

var $cxyfw = parcelRequire("cxyfw");

var $6uozE = parcelRequire("6uozE");

var $ioDUE = parcelRequire("ioDUE");

});
parcelRegister("77dmg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52e38c83affdf224$export$2e2bcd8739ae039; });
function $52e38c83affdf224$export$2e2bcd8739ae039(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("6yAT4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c62881901ab76d1$export$2e2bcd8739ae039; });

var $8jllk = parcelRequire("8jllk");
function $4c62881901ab76d1$export$2e2bcd8739ae039(a, b) {
    var i = (0, $8jllk.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("fcwsN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b11128915dee5d67$export$2e2bcd8739ae039; });
function $b11128915dee5d67$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("9Zp9m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $745d51d6a21cca3e$export$2e2bcd8739ae039; });
var $745d51d6a21cca3e$var$rho = Math.SQRT2, $745d51d6a21cca3e$var$rho2 = 2, $745d51d6a21cca3e$var$rho4 = 4, $745d51d6a21cca3e$var$epsilon2 = 1e-12;
function $745d51d6a21cca3e$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $745d51d6a21cca3e$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $745d51d6a21cca3e$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
function $745d51d6a21cca3e$export$2e2bcd8739ae039(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    // Special case for u0 ≅ u1.
    if (d2 < $745d51d6a21cca3e$var$epsilon2) {
        S = Math.log(w1 / w0) / $745d51d6a21cca3e$var$rho;
        i = function(t) {
            return [
                ux0 + t * dx,
                uy0 + t * dy,
                w0 * Math.exp($745d51d6a21cca3e$var$rho * t * S)
            ];
        };
    } else {
        var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + $745d51d6a21cca3e$var$rho4 * d2) / (2 * w0 * $745d51d6a21cca3e$var$rho2 * d1), b1 = (w1 * w1 - w0 * w0 - $745d51d6a21cca3e$var$rho4 * d2) / (2 * w1 * $745d51d6a21cca3e$var$rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
        S = (r1 - r0) / $745d51d6a21cca3e$var$rho;
        i = function(t) {
            var s = t * S, coshr0 = $745d51d6a21cca3e$var$cosh(r0), u = w0 / ($745d51d6a21cca3e$var$rho2 * d1) * (coshr0 * $745d51d6a21cca3e$var$tanh($745d51d6a21cca3e$var$rho * s + r0) - $745d51d6a21cca3e$var$sinh(r0));
            return [
                ux0 + u * dx,
                uy0 + u * dy,
                w0 * coshr0 / $745d51d6a21cca3e$var$cosh($745d51d6a21cca3e$var$rho * s + r0)
            ];
        };
    }
    i.duration = S * 1000;
    return i;
}

});

parcelRegister("e1HrX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a362dcf532089f49$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "hslLong", function () { return $a362dcf532089f49$export$a2c535e270a59256; });

var $1tQWc = parcelRequire("1tQWc");

var $8jllk = parcelRequire("8jllk");
function $a362dcf532089f49$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $1tQWc.hsl)(start)).h, (end = (0, $1tQWc.hsl)(end)).h), s = (0, $8jllk.default)(start.s, end.s), l = (0, $8jllk.default)(start.l, end.l), opacity = (0, $8jllk.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $a362dcf532089f49$export$2e2bcd8739ae039 = $a362dcf532089f49$var$hsl((0, $8jllk.hue));
var $a362dcf532089f49$export$a2c535e270a59256 = $a362dcf532089f49$var$hsl((0, $8jllk.default));

});

parcelRegister("eIDVA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab74258fce40c83f$export$2e2bcd8739ae039; });

var $iqJRz = parcelRequire("iqJRz");

var $8jllk = parcelRequire("8jllk");
function $ab74258fce40c83f$export$2e2bcd8739ae039(start, end) {
    var l = (0, $8jllk.default)((start = (0, $iqJRz.default)(start)).l, (end = (0, $iqJRz.default)(end)).l), a = (0, $8jllk.default)(start.a, end.a), b = (0, $8jllk.default)(start.b, end.b), opacity = (0, $8jllk.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("ilzCT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5b5d2c8de8568db$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "hclLong", function () { return $d5b5d2c8de8568db$export$5aaa50f7615f9b70; });

var $iqJRz = parcelRequire("iqJRz");

var $8jllk = parcelRequire("8jllk");
function $d5b5d2c8de8568db$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $iqJRz.hcl)(start)).h, (end = (0, $iqJRz.hcl)(end)).h), c = (0, $8jllk.default)(start.c, end.c), l = (0, $8jllk.default)(start.l, end.l), opacity = (0, $8jllk.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $d5b5d2c8de8568db$export$2e2bcd8739ae039 = $d5b5d2c8de8568db$var$hcl((0, $8jllk.hue));
var $d5b5d2c8de8568db$export$5aaa50f7615f9b70 = $d5b5d2c8de8568db$var$hcl((0, $8jllk.default));

});

parcelRegister("cxyfw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $921322526170352b$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "cubehelixLong", function () { return $921322526170352b$export$934fa09ad474a1b4; });

var $4phTB = parcelRequire("4phTB");

var $8jllk = parcelRequire("8jllk");
function $921322526170352b$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $4phTB.default)(start)).h, (end = (0, $4phTB.default)(end)).h), s = (0, $8jllk.default)(start.s, end.s), l = (0, $8jllk.default)(start.l, end.l), opacity = (0, $8jllk.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $921322526170352b$export$2e2bcd8739ae039 = $921322526170352b$var$cubehelix((0, $8jllk.hue));
var $921322526170352b$export$934fa09ad474a1b4 = $921322526170352b$var$cubehelix((0, $8jllk.default));

});

parcelRegister("6uozE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b989b5085aa4b26$export$2e2bcd8739ae039; });
function $4b989b5085aa4b26$export$2e2bcd8739ae039(interpolate, values) {
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("ioDUE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6496db659e7f0ad$export$2e2bcd8739ae039; });
function $d6496db659e7f0ad$export$2e2bcd8739ae039(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("jCNLX", function(module, exports) {

$parcel$export(module.exports, "path", function () { return (parcelRequire("2XIUS")).default; });

var $2XIUS = parcelRequire("2XIUS");

});

parcelRegister("6ajpw", function(module, exports) {

$parcel$export(module.exports, "polygonArea", function () { return (parcelRequire("2w7ts")).default; });
$parcel$export(module.exports, "polygonCentroid", function () { return (parcelRequire("97FK2")).default; });
$parcel$export(module.exports, "polygonHull", function () { return (parcelRequire("4BTFM")).default; });
$parcel$export(module.exports, "polygonContains", function () { return (parcelRequire("cZ5DG")).default; });
$parcel$export(module.exports, "polygonLength", function () { return (parcelRequire("9Uq9r")).default; });

var $2w7ts = parcelRequire("2w7ts");

var $97FK2 = parcelRequire("97FK2");

var $4BTFM = parcelRequire("4BTFM");

var $cZ5DG = parcelRequire("cZ5DG");

var $9Uq9r = parcelRequire("9Uq9r");

});
parcelRegister("2w7ts", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d545e1f930f4001$export$2e2bcd8739ae039; });
function $1d545e1f930f4001$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, a, b = polygon[n - 1], area = 0;
    while(++i < n){
        a = b;
        b = polygon[i];
        area += a[1] * b[0] - a[0] * b[1];
    }
    return area / 2;
}

});

parcelRegister("97FK2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a452586fb4dd868$export$2e2bcd8739ae039; });
function $6a452586fb4dd868$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, x = 0, y = 0, a, b = polygon[n - 1], c, k = 0;
    while(++i < n){
        a = b;
        b = polygon[i];
        k += c = a[0] * b[1] - b[0] * a[1];
        x += (a[0] + b[0]) * c;
        y += (a[1] + b[1]) * c;
    }
    return k *= 3, [
        x / k,
        y / k
    ];
}

});

parcelRegister("4BTFM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35b5cd996cf36aea$export$2e2bcd8739ae039; });

var $db4Mb = parcelRequire("db4Mb");
function $35b5cd996cf36aea$var$lexicographicOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
}
// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function $35b5cd996cf36aea$var$computeUpperHullIndexes(points) {
    var n = points.length, indexes = [
        0,
        1
    ], size = 2;
    for(var i = 2; i < n; ++i){
        while(size > 1 && (0, $db4Mb.default)(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0)--size;
        indexes[size++] = i;
    }
    return indexes.slice(0, size); // remove popped points
}
function $35b5cd996cf36aea$export$2e2bcd8739ae039(points) {
    if ((n = points.length) < 3) return null;
    var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
    for(i = 0; i < n; ++i)sortedPoints[i] = [
        +points[i][0],
        +points[i][1],
        i
    ];
    sortedPoints.sort($35b5cd996cf36aea$var$lexicographicOrder);
    for(i = 0; i < n; ++i)flippedPoints[i] = [
        sortedPoints[i][0],
        -sortedPoints[i][1]
    ];
    var upperIndexes = $35b5cd996cf36aea$var$computeUpperHullIndexes(sortedPoints), lowerIndexes = $35b5cd996cf36aea$var$computeUpperHullIndexes(flippedPoints);
    // Construct the hull polygon, removing possible duplicate endpoints.
    var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
    // Add upper hull in right-to-l order.
    // Then add lower hull in left-to-right order.
    for(i = upperIndexes.length - 1; i >= 0; --i)hull.push(points[sortedPoints[upperIndexes[i]][2]]);
    for(i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
    return hull;
}

});
parcelRegister("db4Mb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $998001e1eb89350a$export$2e2bcd8739ae039; });
// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
function $998001e1eb89350a$export$2e2bcd8739ae039(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
}

});


parcelRegister("cZ5DG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $973f8e528c52efaf$export$2e2bcd8739ae039; });
function $973f8e528c52efaf$export$2e2bcd8739ae039(polygon, point) {
    var n = polygon.length, p = polygon[n - 1], x = point[0], y = point[1], x0 = p[0], y0 = p[1], x1, y1, inside = false;
    for(var i = 0; i < n; ++i){
        p = polygon[i], x1 = p[0], y1 = p[1];
        if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
        x0 = x1, y0 = y1;
    }
    return inside;
}

});

parcelRegister("9Uq9r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $736da11dbfe590bd$export$2e2bcd8739ae039; });
function $736da11dbfe590bd$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
    while(++i < n){
        xa = xb;
        ya = yb;
        b = polygon[i];
        xb = b[0];
        yb = b[1];
        xa -= xb;
        ya -= yb;
        perimeter += Math.sqrt(xa * xa + ya * ya);
    }
    return perimeter;
}

});


parcelRegister("4vgKc", function(module, exports) {

$parcel$export(module.exports, "quadtree", function () { return (parcelRequire("js6v0")).default; });

var $js6v0 = parcelRequire("js6v0");

});

parcelRegister("hEfoB", function(module, exports) {

$parcel$export(module.exports, "randomUniform", function () { return (parcelRequire("GrHjf")).default; });
$parcel$export(module.exports, "randomNormal", function () { return (parcelRequire("jU3XT")).default; });
$parcel$export(module.exports, "randomLogNormal", function () { return (parcelRequire("3LTIl")).default; });
$parcel$export(module.exports, "randomBates", function () { return (parcelRequire("7XWbL")).default; });
$parcel$export(module.exports, "randomIrwinHall", function () { return (parcelRequire("9DRII")).default; });
$parcel$export(module.exports, "randomExponential", function () { return (parcelRequire("iscpJ")).default; });

var $GrHjf = parcelRequire("GrHjf");

var $jU3XT = parcelRequire("jU3XT");

var $3LTIl = parcelRequire("3LTIl");

var $7XWbL = parcelRequire("7XWbL");

var $9DRII = parcelRequire("9DRII");

var $iscpJ = parcelRequire("iscpJ");

});
parcelRegister("GrHjf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07f9688366dacd66$export$2e2bcd8739ae039; });

var $1ovPG = parcelRequire("1ovPG");
var $07f9688366dacd66$export$2e2bcd8739ae039 = function sourceRandomUniform(source) {
    function randomUniform(min, max) {
        min = min == null ? 0 : +min;
        max = max == null ? 1 : +max;
        if (arguments.length === 1) max = min, min = 0;
        else max -= min;
        return function() {
            return source() * max + min;
        };
    }
    randomUniform.source = sourceRandomUniform;
    return randomUniform;
}((0, $1ovPG.default));

});
parcelRegister("1ovPG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1040b9a673a49a26$export$2e2bcd8739ae039; });
function $1040b9a673a49a26$export$2e2bcd8739ae039() {
    return Math.random();
}

});


parcelRegister("jU3XT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7d652a45891c76f$export$2e2bcd8739ae039; });

var $1ovPG = parcelRequire("1ovPG");
var $e7d652a45891c76f$export$2e2bcd8739ae039 = function sourceRandomNormal(source) {
    function randomNormal(mu, sigma) {
        var x, r;
        mu = mu == null ? 0 : +mu;
        sigma = sigma == null ? 1 : +sigma;
        return function() {
            var y;
            // If available, use the second previously-generated uniform random.
            if (x != null) y = x, x = null;
            else do {
                x = source() * 2 - 1;
                y = source() * 2 - 1;
                r = x * x + y * y;
            }while (!r || r > 1);
            return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
        };
    }
    randomNormal.source = sourceRandomNormal;
    return randomNormal;
}((0, $1ovPG.default));

});

parcelRegister("3LTIl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bf0fa98a95817c5$export$2e2bcd8739ae039; });

var $1ovPG = parcelRequire("1ovPG");

var $jU3XT = parcelRequire("jU3XT");
var $2bf0fa98a95817c5$export$2e2bcd8739ae039 = function sourceRandomLogNormal(source) {
    function randomLogNormal() {
        var randomNormal = (0, $jU3XT.default).source(source).apply(this, arguments);
        return function() {
            return Math.exp(randomNormal());
        };
    }
    randomLogNormal.source = sourceRandomLogNormal;
    return randomLogNormal;
}((0, $1ovPG.default));

});

parcelRegister("7XWbL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ccb2e26be594cb1$export$2e2bcd8739ae039; });

var $1ovPG = parcelRequire("1ovPG");

var $9DRII = parcelRequire("9DRII");
var $5ccb2e26be594cb1$export$2e2bcd8739ae039 = function sourceRandomBates(source) {
    function randomBates(n) {
        var randomIrwinHall = (0, $9DRII.default).source(source)(n);
        return function() {
            return randomIrwinHall() / n;
        };
    }
    randomBates.source = sourceRandomBates;
    return randomBates;
}((0, $1ovPG.default));

});
parcelRegister("9DRII", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70516d447a6deb1d$export$2e2bcd8739ae039; });

var $1ovPG = parcelRequire("1ovPG");
var $70516d447a6deb1d$export$2e2bcd8739ae039 = function sourceRandomIrwinHall(source) {
    function randomIrwinHall(n) {
        return function() {
            for(var sum = 0, i = 0; i < n; ++i)sum += source();
            return sum;
        };
    }
    randomIrwinHall.source = sourceRandomIrwinHall;
    return randomIrwinHall;
}((0, $1ovPG.default));

});


parcelRegister("iscpJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6f478ae3363602f$export$2e2bcd8739ae039; });

var $1ovPG = parcelRequire("1ovPG");
var $d6f478ae3363602f$export$2e2bcd8739ae039 = function sourceRandomExponential(source) {
    function randomExponential(lambda) {
        return function() {
            return -Math.log(1 - source()) / lambda;
        };
    }
    randomExponential.source = sourceRandomExponential;
    return randomExponential;
}((0, $1ovPG.default));

});


parcelRegister("8IsGx", function(module, exports) {

$parcel$export(module.exports, "scaleBand", function () { return (parcelRequire("8OvGl")).default; });
$parcel$export(module.exports, "scalePoint", function () { return (parcelRequire("8OvGl")).point; });
$parcel$export(module.exports, "scaleIdentity", function () { return (parcelRequire("3DKhm")).default; });
$parcel$export(module.exports, "scaleLinear", function () { return (parcelRequire("2KypB")).default; });
$parcel$export(module.exports, "scaleLog", function () { return (parcelRequire("2uFhV")).default; });
$parcel$export(module.exports, "scaleSymlog", function () { return (parcelRequire("77qSP")).default; });
$parcel$export(module.exports, "scaleOrdinal", function () { return (parcelRequire("fCuhP")).default; });
$parcel$export(module.exports, "scaleImplicit", function () { return (parcelRequire("fCuhP")).implicit; });
$parcel$export(module.exports, "scalePow", function () { return (parcelRequire("in36U")).default; });
$parcel$export(module.exports, "scaleSqrt", function () { return (parcelRequire("in36U")).sqrt; });
$parcel$export(module.exports, "scaleQuantile", function () { return (parcelRequire("3tH3X")).default; });
$parcel$export(module.exports, "scaleQuantize", function () { return (parcelRequire("7QKt5")).default; });
$parcel$export(module.exports, "scaleThreshold", function () { return (parcelRequire("cD27Y")).default; });
$parcel$export(module.exports, "scaleTime", function () { return (parcelRequire("jfnQ8")).default; });
$parcel$export(module.exports, "scaleUtc", function () { return (parcelRequire("6YaNq")).default; });
$parcel$export(module.exports, "scaleSequential", function () { return (parcelRequire("2IWzQ")).default; });
$parcel$export(module.exports, "scaleSequentialLog", function () { return (parcelRequire("2IWzQ")).sequentialLog; });
$parcel$export(module.exports, "scaleSequentialPow", function () { return (parcelRequire("2IWzQ")).sequentialPow; });
$parcel$export(module.exports, "scaleSequentialSqrt", function () { return (parcelRequire("2IWzQ")).sequentialSqrt; });
$parcel$export(module.exports, "scaleSequentialSymlog", function () { return (parcelRequire("2IWzQ")).sequentialSymlog; });
$parcel$export(module.exports, "scaleSequentialQuantile", function () { return (parcelRequire("1xB1b")).default; });
$parcel$export(module.exports, "scaleDiverging", function () { return (parcelRequire("52YqS")).default; });
$parcel$export(module.exports, "scaleDivergingLog", function () { return (parcelRequire("52YqS")).divergingLog; });
$parcel$export(module.exports, "scaleDivergingPow", function () { return (parcelRequire("52YqS")).divergingPow; });
$parcel$export(module.exports, "scaleDivergingSqrt", function () { return (parcelRequire("52YqS")).divergingSqrt; });
$parcel$export(module.exports, "scaleDivergingSymlog", function () { return (parcelRequire("52YqS")).divergingSymlog; });
$parcel$export(module.exports, "tickFormat", function () { return (parcelRequire("912Iy")).default; });

var $8OvGl = parcelRequire("8OvGl");

var $3DKhm = parcelRequire("3DKhm");

var $2KypB = parcelRequire("2KypB");

var $2uFhV = parcelRequire("2uFhV");

var $77qSP = parcelRequire("77qSP");

var $fCuhP = parcelRequire("fCuhP");

var $in36U = parcelRequire("in36U");

var $3tH3X = parcelRequire("3tH3X");

var $7QKt5 = parcelRequire("7QKt5");

var $cD27Y = parcelRequire("cD27Y");

var $jfnQ8 = parcelRequire("jfnQ8");

var $6YaNq = parcelRequire("6YaNq");

var $2IWzQ = parcelRequire("2IWzQ");

var $1xB1b = parcelRequire("1xB1b");

var $52YqS = parcelRequire("52YqS");

var $912Iy = parcelRequire("912Iy");

});
parcelRegister("8OvGl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66ab919e2a60291e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "point", function () { return $66ab919e2a60291e$export$105684a3041cb6f3; });
parcelRequire("9f3pr");
var $lwLP6 = parcelRequire("lwLP6");

var $2DSNq = parcelRequire("2DSNq");

var $fCuhP = parcelRequire("fCuhP");
function $66ab919e2a60291e$export$2e2bcd8739ae039() {
    var scale = (0, $fCuhP.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, range = [
        0,
        1
    ], step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = range[1] < range[0], start = range[reverse - 0], stop = range[1 - reverse];
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $lwLP6.default)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? (range = [
            +_[0],
            +_[1]
        ], rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = [
            +_[0],
            +_[1]
        ], round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $66ab919e2a60291e$export$2e2bcd8739ae039(domain(), range).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $2DSNq.initRange).apply(rescale(), arguments);
}
function $66ab919e2a60291e$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $66ab919e2a60291e$var$pointish(copy());
    };
    return scale;
}
function $66ab919e2a60291e$export$105684a3041cb6f3() {
    return $66ab919e2a60291e$var$pointish($66ab919e2a60291e$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("2DSNq", function(module, exports) {

$parcel$export(module.exports, "initRange", function () { return $1ec9baa7d5ff9a04$export$23c7bb9e6558da2a; });
$parcel$export(module.exports, "initInterpolator", function () { return $1ec9baa7d5ff9a04$export$7d6b419e59e83f3d; });
function $1ec9baa7d5ff9a04$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $1ec9baa7d5ff9a04$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.interpolator(domain);
            break;
        default:
            this.interpolator(interpolator).domain(domain);
            break;
    }
    return this;
}

});

parcelRegister("fCuhP", function(module, exports) {

$parcel$export(module.exports, "implicit", function () { return $b5f1e5e45355bfef$export$e4f898ab14d9d460; });
$parcel$export(module.exports, "default", function () { return $b5f1e5e45355bfef$export$2e2bcd8739ae039; });
parcelRequire("9r7nk");
var $3WKXr = parcelRequire("3WKXr");

var $6TPlG = parcelRequire("6TPlG");

var $2DSNq = parcelRequire("2DSNq");
var $b5f1e5e45355bfef$export$e4f898ab14d9d460 = {
    name: "implicit"
};
function $b5f1e5e45355bfef$export$2e2bcd8739ae039() {
    var index = (0, $3WKXr.default)(), domain = [], range = [], unknown = $b5f1e5e45355bfef$export$e4f898ab14d9d460;
    function scale(d) {
        var key = d + "", i = index.get(key);
        if (!i) {
            if (unknown !== $b5f1e5e45355bfef$export$e4f898ab14d9d460) return unknown;
            index.set(key, i = domain.push(d));
        }
        return range[(i - 1) % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = (0, $3WKXr.default)();
        var i = -1, n = _.length, d, key;
        while(++i < n)if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $6TPlG.slice).call(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $b5f1e5e45355bfef$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $2DSNq.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("6TPlG", function(module, exports) {

$parcel$export(module.exports, "map", function () { return $505fb5ed44b1ca97$export$871de8747c9eaa88; });
$parcel$export(module.exports, "slice", function () { return $505fb5ed44b1ca97$export$58adb3bec8346d0f; });
var $505fb5ed44b1ca97$var$array = Array.prototype;
var $505fb5ed44b1ca97$export$871de8747c9eaa88 = $505fb5ed44b1ca97$var$array.map;
var $505fb5ed44b1ca97$export$58adb3bec8346d0f = $505fb5ed44b1ca97$var$array.slice;

});



parcelRegister("3DKhm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a68e9a9fb093de6$export$2e2bcd8739ae039; });

var $6TPlG = parcelRequire("6TPlG");

var $2KypB = parcelRequire("2KypB");

var $ga6lO = parcelRequire("ga6lO");
function $2a68e9a9fb093de6$export$2e2bcd8739ae039(domain) {
    var unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = (0, $6TPlG.map).call(_, (0, $ga6lO.default)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $2a68e9a9fb093de6$export$2e2bcd8739ae039(domain).unknown(unknown);
    };
    domain = arguments.length ? (0, $6TPlG.map).call(domain, (0, $ga6lO.default)) : [
        0,
        1
    ];
    return (0, $2KypB.linearish)(scale);
}

});
parcelRegister("2KypB", function(module, exports) {

$parcel$export(module.exports, "linearish", function () { return $200a922019157658$export$16a5d4b4a61a274d; });
$parcel$export(module.exports, "default", function () { return $200a922019157658$export$2e2bcd8739ae039; });
parcelRequire("9f3pr");
var $jPKO0 = parcelRequire("jPKO0");

var $hCOuU = parcelRequire("hCOuU");

var $2DSNq = parcelRequire("2DSNq");

var $912Iy = parcelRequire("912Iy");
function $200a922019157658$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $jPKO0.default)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $912Iy.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain(), i0 = 0, i1 = d.length - 1, start = d[i0], stop = d[i1], step;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        step = (0, $jPKO0.tickIncrement)(start, stop, count);
        if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
            step = (0, $jPKO0.tickIncrement)(start, stop, count);
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
            step = (0, $jPKO0.tickIncrement)(start, stop, count);
        }
        if (step > 0) {
            d[i0] = Math.floor(start / step) * step;
            d[i1] = Math.ceil(stop / step) * step;
            domain(d);
        } else if (step < 0) {
            d[i0] = Math.ceil(start * step) / step;
            d[i1] = Math.floor(stop * step) / step;
            domain(d);
        }
        return scale;
    };
    return scale;
}
function $200a922019157658$export$2e2bcd8739ae039() {
    var scale = (0, $hCOuU.default)((0, $hCOuU.identity), (0, $hCOuU.identity));
    scale.copy = function() {
        return (0, $hCOuU.copy)(scale, $200a922019157658$export$2e2bcd8739ae039());
    };
    (0, $2DSNq.initRange).apply(scale, arguments);
    return $200a922019157658$export$16a5d4b4a61a274d(scale);
}

});
parcelRegister("hCOuU", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $cd4d28050bb392d2$export$f0954fd7d5368655; });
$parcel$export(module.exports, "copy", function () { return $cd4d28050bb392d2$export$784d13d8ee351f07; });
$parcel$export(module.exports, "transformer", function () { return $cd4d28050bb392d2$export$6b468dcfb64c653c; });
$parcel$export(module.exports, "default", function () { return $cd4d28050bb392d2$export$2e2bcd8739ae039; });
parcelRequire("9f3pr");
var $7naKx = parcelRequire("7naKx");

var $f01sj = parcelRequire("f01sj");
var $iI7Wc = parcelRequire("iI7Wc");
var $fcwsN = parcelRequire("fcwsN");

var $6TPlG = parcelRequire("6TPlG");

var $5OkNV = parcelRequire("5OkNV");

var $ga6lO = parcelRequire("ga6lO");
var $cd4d28050bb392d2$var$unit = [
    0,
    1
];
function $cd4d28050bb392d2$export$f0954fd7d5368655(x) {
    return x;
}
function $cd4d28050bb392d2$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $5OkNV.default)(isNaN(b) ? NaN : 0.5);
}
function $cd4d28050bb392d2$var$clamper(domain) {
    var a = domain[0], b = domain[domain.length - 1], t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $cd4d28050bb392d2$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $cd4d28050bb392d2$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $cd4d28050bb392d2$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $cd4d28050bb392d2$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $cd4d28050bb392d2$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $7naKx.default)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $cd4d28050bb392d2$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $cd4d28050bb392d2$export$6b468dcfb64c653c() {
    var domain = $cd4d28050bb392d2$var$unit, range = $cd4d28050bb392d2$var$unit, interpolate = (0, $f01sj.default), transform, untransform, unknown, clamp = $cd4d28050bb392d2$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        piecewise = Math.min(domain.length, range.length) > 2 ? $cd4d28050bb392d2$var$polymap : $cd4d28050bb392d2$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $iI7Wc.default))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, $6TPlG.map).call(_, (0, $ga6lO.default)), clamp === $cd4d28050bb392d2$export$f0954fd7d5368655 || (clamp = $cd4d28050bb392d2$var$clamper(domain)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $6TPlG.slice).call(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = (0, $6TPlG.slice).call(_), interpolate = (0, $fcwsN.default), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? $cd4d28050bb392d2$var$clamper(domain) : $cd4d28050bb392d2$export$f0954fd7d5368655, scale) : clamp !== $cd4d28050bb392d2$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $cd4d28050bb392d2$export$2e2bcd8739ae039(transform, untransform) {
    return $cd4d28050bb392d2$export$6b468dcfb64c653c()(transform, untransform);
}

});
parcelRegister("5OkNV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43b1c28d54e5a201$export$2e2bcd8739ae039; });
function $43b1c28d54e5a201$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("ga6lO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc4281a4abd21e9a$export$2e2bcd8739ae039; });
function $bc4281a4abd21e9a$export$2e2bcd8739ae039(x) {
    return +x;
}

});


parcelRegister("912Iy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $690650bc4737c146$export$2e2bcd8739ae039; });
parcelRequire("9f3pr");
var $jPKO0 = parcelRequire("jPKO0");

var $l9rW7 = parcelRequire("l9rW7");
var $2t3Cf = parcelRequire("2t3Cf");
var $bZr7h = parcelRequire("bZr7h");
var $2qDiT = parcelRequire("2qDiT");
var $8ftxM = parcelRequire("8ftxM");
function $690650bc4737c146$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $jPKO0.tickStep)(start, stop, count), precision;
    specifier = (0, $2t3Cf.default)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $2qDiT.default)(step, value))) specifier.precision = precision;
            return (0, $l9rW7.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $8ftxM.default)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $bZr7h.default)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $l9rW7.format)(specifier);
}

});



parcelRegister("2uFhV", function(module, exports) {

$parcel$export(module.exports, "loggish", function () { return $1d0e690dbd31296e$export$860836db074028f0; });
$parcel$export(module.exports, "default", function () { return $1d0e690dbd31296e$export$2e2bcd8739ae039; });
parcelRequire("9f3pr");
var $jPKO0 = parcelRequire("jPKO0");

var $l9rW7 = parcelRequire("l9rW7");

var $dS79P = parcelRequire("dS79P");

var $hCOuU = parcelRequire("hCOuU");

var $2DSNq = parcelRequire("2DSNq");
function $1d0e690dbd31296e$var$transformLog(x) {
    return Math.log(x);
}
function $1d0e690dbd31296e$var$transformExp(x) {
    return Math.exp(x);
}
function $1d0e690dbd31296e$var$transformLogn(x) {
    return -Math.log(-x);
}
function $1d0e690dbd31296e$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $1d0e690dbd31296e$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $1d0e690dbd31296e$var$powp(base) {
    return base === 10 ? $1d0e690dbd31296e$var$pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function $1d0e690dbd31296e$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function $1d0e690dbd31296e$var$reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function $1d0e690dbd31296e$export$860836db074028f0(transform) {
    var scale = transform($1d0e690dbd31296e$var$transformLog, $1d0e690dbd31296e$var$transformExp), domain = scale.domain, base = 10, logs, pows;
    function rescale() {
        logs = $1d0e690dbd31296e$var$logp(base), pows = $1d0e690dbd31296e$var$powp(base);
        if (domain()[0] < 0) {
            logs = $1d0e690dbd31296e$var$reflect(logs), pows = $1d0e690dbd31296e$var$reflect(pows);
            transform($1d0e690dbd31296e$var$transformLogn, $1d0e690dbd31296e$var$transformExpn);
        } else transform($1d0e690dbd31296e$var$transformLog, $1d0e690dbd31296e$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.round(i) - 1, j = Math.round(j) + 1;
            if (u > 0) for(; i < j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i < j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
        } else z = (0, $jPKO0.default)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, $l9rW7.format)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, $dS79P.default)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    return scale;
}
function $1d0e690dbd31296e$export$2e2bcd8739ae039() {
    var scale = $1d0e690dbd31296e$export$860836db074028f0((0, $hCOuU.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $hCOuU.copy)(scale, $1d0e690dbd31296e$export$2e2bcd8739ae039()).base(scale.base());
    };
    (0, $2DSNq.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("dS79P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a195ded6081247dd$export$2e2bcd8739ae039; });
function $a195ded6081247dd$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("77qSP", function(module, exports) {

$parcel$export(module.exports, "symlogish", function () { return $52ee0a5773c968a2$export$4602684e614eba38; });
$parcel$export(module.exports, "default", function () { return $52ee0a5773c968a2$export$2e2bcd8739ae039; });

var $2KypB = parcelRequire("2KypB");

var $hCOuU = parcelRequire("hCOuU");

var $2DSNq = parcelRequire("2DSNq");
function $52ee0a5773c968a2$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $52ee0a5773c968a2$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $52ee0a5773c968a2$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($52ee0a5773c968a2$var$transformSymlog(c), $52ee0a5773c968a2$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($52ee0a5773c968a2$var$transformSymlog(c = +_), $52ee0a5773c968a2$var$transformSymexp(c)) : c;
    };
    return (0, $2KypB.linearish)(scale);
}
function $52ee0a5773c968a2$export$2e2bcd8739ae039() {
    var scale = $52ee0a5773c968a2$export$4602684e614eba38((0, $hCOuU.transformer)());
    scale.copy = function() {
        return (0, $hCOuU.copy)(scale, $52ee0a5773c968a2$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $2DSNq.initRange).apply(scale, arguments);
}

});

parcelRegister("in36U", function(module, exports) {

$parcel$export(module.exports, "powish", function () { return $d5fcc9a22585ff93$export$34695211ec403a46; });
$parcel$export(module.exports, "default", function () { return $d5fcc9a22585ff93$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "sqrt", function () { return $d5fcc9a22585ff93$export$eba8049fb5020b81; });

var $2KypB = parcelRequire("2KypB");

var $hCOuU = parcelRequire("hCOuU");

var $2DSNq = parcelRequire("2DSNq");
function $d5fcc9a22585ff93$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $d5fcc9a22585ff93$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $d5fcc9a22585ff93$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $d5fcc9a22585ff93$export$34695211ec403a46(transform) {
    var scale = transform((0, $hCOuU.identity), (0, $hCOuU.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $hCOuU.identity), (0, $hCOuU.identity)) : exponent === 0.5 ? transform($d5fcc9a22585ff93$var$transformSqrt, $d5fcc9a22585ff93$var$transformSquare) : transform($d5fcc9a22585ff93$var$transformPow(exponent), $d5fcc9a22585ff93$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $2KypB.linearish)(scale);
}
function $d5fcc9a22585ff93$export$2e2bcd8739ae039() {
    var scale = $d5fcc9a22585ff93$export$34695211ec403a46((0, $hCOuU.transformer)());
    scale.copy = function() {
        return (0, $hCOuU.copy)(scale, $d5fcc9a22585ff93$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $2DSNq.initRange).apply(scale, arguments);
    return scale;
}
function $d5fcc9a22585ff93$export$eba8049fb5020b81() {
    return $d5fcc9a22585ff93$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("3tH3X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28857bea490fed4a$export$2e2bcd8739ae039; });
parcelRequire("9f3pr");
var $fW9sn = parcelRequire("fW9sn");
var $7naKx = parcelRequire("7naKx");
var $ft9xF = parcelRequire("ft9xF");

var $6TPlG = parcelRequire("6TPlG");

var $2DSNq = parcelRequire("2DSNq");
function $28857bea490fed4a$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $ft9xF.default)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return isNaN(x = +x) ? unknown : range[(0, $7naKx.default)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for(var i = 0, n = _.length, d; i < n; ++i)if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $fW9sn.default));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $6TPlG.slice).call(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $28857bea490fed4a$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $2DSNq.initRange).apply(scale, arguments);
}

});

parcelRegister("7QKt5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b716f584c76f524$export$2e2bcd8739ae039; });
parcelRequire("9f3pr");
var $7naKx = parcelRequire("7naKx");

var $6TPlG = parcelRequire("6TPlG");

var $2KypB = parcelRequire("2KypB");

var $2DSNq = parcelRequire("2DSNq");
function $5b716f584c76f524$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x <= x ? range[(0, $7naKx.default)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = (0, $6TPlG.slice).call(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $5b716f584c76f524$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $2DSNq.initRange).apply((0, $2KypB.linearish)(scale), arguments);
}

});

parcelRegister("cD27Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $931ac71004624cfe$export$2e2bcd8739ae039; });
parcelRequire("9f3pr");
var $7naKx = parcelRequire("7naKx");

var $6TPlG = parcelRequire("6TPlG");

var $2DSNq = parcelRequire("2DSNq");
function $931ac71004624cfe$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x <= x ? range[(0, $7naKx.default)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, $6TPlG.slice).call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $6TPlG.slice).call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $931ac71004624cfe$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $2DSNq.initRange).apply(scale, arguments);
}

});

parcelRegister("jfnQ8", function(module, exports) {

$parcel$export(module.exports, "calendar", function () { return $e031e928df7f8c43$export$56bbcdb8aca31149; });
$parcel$export(module.exports, "default", function () { return $e031e928df7f8c43$export$2e2bcd8739ae039; });
parcelRequire("9f3pr");
var $eIAUO = parcelRequire("eIAUO");
var $jPKO0 = parcelRequire("jPKO0");

var $2OwRo = parcelRequire("2OwRo");
var $7hefO = parcelRequire("7hefO");
var $4YZxj = parcelRequire("4YZxj");
var $8z9BB = parcelRequire("8z9BB");
var $qXCEl = parcelRequire("qXCEl");
var $ckkQj = parcelRequire("ckkQj");
var $12kxK = parcelRequire("12kxK");
var $di9fD = parcelRequire("di9fD");

var $gVMzE = parcelRequire("gVMzE");

var $6TPlG = parcelRequire("6TPlG");

var $hCOuU = parcelRequire("hCOuU");

var $2DSNq = parcelRequire("2DSNq");

var $dS79P = parcelRequire("dS79P");
var $e031e928df7f8c43$var$durationSecond = 1000, $e031e928df7f8c43$var$durationMinute = $e031e928df7f8c43$var$durationSecond * 60, $e031e928df7f8c43$var$durationHour = $e031e928df7f8c43$var$durationMinute * 60, $e031e928df7f8c43$var$durationDay = $e031e928df7f8c43$var$durationHour * 24, $e031e928df7f8c43$var$durationWeek = $e031e928df7f8c43$var$durationDay * 7, $e031e928df7f8c43$var$durationMonth = $e031e928df7f8c43$var$durationDay * 30, $e031e928df7f8c43$var$durationYear = $e031e928df7f8c43$var$durationDay * 365;
function $e031e928df7f8c43$var$date(t) {
    return new Date(t);
}
function $e031e928df7f8c43$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $e031e928df7f8c43$export$56bbcdb8aca31149(year, month, week, day, hour, minute, second, millisecond, format) {
    var scale = (0, $hCOuU.default)((0, $hCOuU.identity), (0, $hCOuU.identity)), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    var tickIntervals = [
        [
            second,
            1,
            $e031e928df7f8c43$var$durationSecond
        ],
        [
            second,
            5,
            5 * $e031e928df7f8c43$var$durationSecond
        ],
        [
            second,
            15,
            15 * $e031e928df7f8c43$var$durationSecond
        ],
        [
            second,
            30,
            30 * $e031e928df7f8c43$var$durationSecond
        ],
        [
            minute,
            1,
            $e031e928df7f8c43$var$durationMinute
        ],
        [
            minute,
            5,
            5 * $e031e928df7f8c43$var$durationMinute
        ],
        [
            minute,
            15,
            15 * $e031e928df7f8c43$var$durationMinute
        ],
        [
            minute,
            30,
            30 * $e031e928df7f8c43$var$durationMinute
        ],
        [
            hour,
            1,
            $e031e928df7f8c43$var$durationHour
        ],
        [
            hour,
            3,
            3 * $e031e928df7f8c43$var$durationHour
        ],
        [
            hour,
            6,
            6 * $e031e928df7f8c43$var$durationHour
        ],
        [
            hour,
            12,
            12 * $e031e928df7f8c43$var$durationHour
        ],
        [
            day,
            1,
            $e031e928df7f8c43$var$durationDay
        ],
        [
            day,
            2,
            2 * $e031e928df7f8c43$var$durationDay
        ],
        [
            week,
            1,
            $e031e928df7f8c43$var$durationWeek
        ],
        [
            month,
            1,
            $e031e928df7f8c43$var$durationMonth
        ],
        [
            month,
            3,
            3 * $e031e928df7f8c43$var$durationMonth
        ],
        [
            year,
            1,
            $e031e928df7f8c43$var$durationYear
        ]
    ];
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    function tickInterval(interval, start, stop, step) {
        if (interval == null) interval = 10;
        // If a desired tick count is specified, pick a reasonable tick interval
        // based on the extent of the domain and a rough estimate of tick size.
        // Otherwise, assume interval is already a time interval and use it.
        if (typeof interval === "number") {
            var target = Math.abs(stop - start) / interval, i = (0, $eIAUO.default)(function(i) {
                return i[2];
            }).right(tickIntervals, target);
            if (i === tickIntervals.length) {
                step = (0, $jPKO0.tickStep)(start / $e031e928df7f8c43$var$durationYear, stop / $e031e928df7f8c43$var$durationYear, interval);
                interval = year;
            } else if (i) {
                i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
                step = i[1];
                interval = i[0];
            } else {
                step = Math.max((0, $jPKO0.tickStep)(start, stop, interval), 1);
                interval = millisecond;
            }
        }
        return step == null ? interval : interval.every(step);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain((0, $6TPlG.map).call(_, $e031e928df7f8c43$var$number)) : domain().map($e031e928df7f8c43$var$date);
    };
    scale.ticks = function(interval, step) {
        var d = domain(), t0 = d[0], t1 = d[d.length - 1], r = t1 < t0, t;
        if (r) t = t0, t0 = t1, t1 = t;
        t = tickInterval(interval, t0, t1, step);
        t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
        return r ? t.reverse() : t;
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval, step) {
        var d = domain();
        return (interval = tickInterval(interval, d[0], d[d.length - 1], step)) ? domain((0, $dS79P.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $hCOuU.copy)(scale, $e031e928df7f8c43$export$56bbcdb8aca31149(year, month, week, day, hour, minute, second, millisecond, format));
    };
    return scale;
}
function $e031e928df7f8c43$export$2e2bcd8739ae039() {
    return (0, $2DSNq.initRange).apply($e031e928df7f8c43$export$56bbcdb8aca31149((0, $di9fD.default), (0, $qXCEl.default), (0, $12kxK.sunday), (0, $2OwRo.default), (0, $7hefO.default), (0, $8z9BB.default), (0, $ckkQj.default), (0, $4YZxj.default), (0, $gVMzE.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("2OwRo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20c9bda5cc5feed8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "days", function () { return $20c9bda5cc5feed8$export$3cf5dda4201cc0f2; });

var $d9CtV = parcelRequire("d9CtV");

var $jcbFZ = parcelRequire("jcbFZ");
var $20c9bda5cc5feed8$var$day = (0, $d9CtV.default)(function(date) {
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $jcbFZ.durationMinute)) / (0, $jcbFZ.durationDay);
}, function(date) {
    return date.getDate() - 1;
});
var $20c9bda5cc5feed8$export$2e2bcd8739ae039 = $20c9bda5cc5feed8$var$day;
var $20c9bda5cc5feed8$export$3cf5dda4201cc0f2 = $20c9bda5cc5feed8$var$day.range;

});
parcelRegister("d9CtV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9939f74c1c819889$export$2e2bcd8739ae039; });
var $9939f74c1c819889$var$t0 = new Date, $9939f74c1c819889$var$t1 = new Date;
function $9939f74c1c819889$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $9939f74c1c819889$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $9939f74c1c819889$var$t0.setTime(+start), $9939f74c1c819889$var$t1.setTime(+end);
            floori($9939f74c1c819889$var$t0), floori($9939f74c1c819889$var$t1);
            return Math.floor(count($9939f74c1c819889$var$t0, $9939f74c1c819889$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("jcbFZ", function(module, exports) {

$parcel$export(module.exports, "durationSecond", function () { return $df9831fb4f95f7fb$export$79ef0e34099623dc; });
$parcel$export(module.exports, "durationMinute", function () { return $df9831fb4f95f7fb$export$683905d551c33fa9; });
$parcel$export(module.exports, "durationHour", function () { return $df9831fb4f95f7fb$export$4157bf0c8e241659; });
$parcel$export(module.exports, "durationDay", function () { return $df9831fb4f95f7fb$export$353686095f4fbf45; });
$parcel$export(module.exports, "durationWeek", function () { return $df9831fb4f95f7fb$export$c241eb88520d5016; });
var $df9831fb4f95f7fb$export$79ef0e34099623dc = 1e3;
var $df9831fb4f95f7fb$export$683905d551c33fa9 = 6e4;
var $df9831fb4f95f7fb$export$4157bf0c8e241659 = 36e5;
var $df9831fb4f95f7fb$export$353686095f4fbf45 = 864e5;
var $df9831fb4f95f7fb$export$c241eb88520d5016 = 6048e5;

});


parcelRegister("7hefO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54c52d7793bb6b78$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "hours", function () { return $54c52d7793bb6b78$export$8d468796d69cdad1; });

var $d9CtV = parcelRequire("d9CtV");

var $jcbFZ = parcelRequire("jcbFZ");
var $54c52d7793bb6b78$var$hour = (0, $d9CtV.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $jcbFZ.durationSecond) - date.getMinutes() * (0, $jcbFZ.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, $jcbFZ.durationHour));
}, function(start, end) {
    return (end - start) / (0, $jcbFZ.durationHour);
}, function(date) {
    return date.getHours();
});
var $54c52d7793bb6b78$export$2e2bcd8739ae039 = $54c52d7793bb6b78$var$hour;
var $54c52d7793bb6b78$export$8d468796d69cdad1 = $54c52d7793bb6b78$var$hour.range;

});

parcelRegister("4YZxj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a0c7fd69e52994c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "milliseconds", function () { return $3a0c7fd69e52994c$export$9a27fac83d67afd3; });

var $d9CtV = parcelRequire("d9CtV");
var $3a0c7fd69e52994c$var$millisecond = (0, $d9CtV.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$3a0c7fd69e52994c$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $3a0c7fd69e52994c$var$millisecond;
    return (0, $d9CtV.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $3a0c7fd69e52994c$export$2e2bcd8739ae039 = $3a0c7fd69e52994c$var$millisecond;
var $3a0c7fd69e52994c$export$9a27fac83d67afd3 = $3a0c7fd69e52994c$var$millisecond.range;

});

parcelRegister("8z9BB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63c90b161916de7a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "minutes", function () { return $63c90b161916de7a$export$666252b437cce0c7; });

var $d9CtV = parcelRequire("d9CtV");

var $jcbFZ = parcelRequire("jcbFZ");
var $63c90b161916de7a$var$minute = (0, $d9CtV.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $jcbFZ.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, $jcbFZ.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $jcbFZ.durationMinute);
}, function(date) {
    return date.getMinutes();
});
var $63c90b161916de7a$export$2e2bcd8739ae039 = $63c90b161916de7a$var$minute;
var $63c90b161916de7a$export$666252b437cce0c7 = $63c90b161916de7a$var$minute.range;

});

parcelRegister("qXCEl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0510ad95fe0d8745$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "months", function () { return $0510ad95fe0d8745$export$16352d1b10c5eb38; });

var $d9CtV = parcelRequire("d9CtV");
var $0510ad95fe0d8745$var$month = (0, $d9CtV.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $0510ad95fe0d8745$export$2e2bcd8739ae039 = $0510ad95fe0d8745$var$month;
var $0510ad95fe0d8745$export$16352d1b10c5eb38 = $0510ad95fe0d8745$var$month.range;

});

parcelRegister("ckkQj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f97853afe54cc4a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "seconds", function () { return $8f97853afe54cc4a$export$4792e48abc550fa1; });

var $d9CtV = parcelRequire("d9CtV");

var $jcbFZ = parcelRequire("jcbFZ");
var $8f97853afe54cc4a$var$second = (0, $d9CtV.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, $jcbFZ.durationSecond));
}, function(start, end) {
    return (end - start) / (0, $jcbFZ.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
var $8f97853afe54cc4a$export$2e2bcd8739ae039 = $8f97853afe54cc4a$var$second;
var $8f97853afe54cc4a$export$4792e48abc550fa1 = $8f97853afe54cc4a$var$second.range;

});

parcelRegister("12kxK", function(module, exports) {

$parcel$export(module.exports, "sunday", function () { return $0c15e9d65f86b7e7$export$fb3ee18ed410cc21; });
$parcel$export(module.exports, "monday", function () { return $0c15e9d65f86b7e7$export$6416afaab03bc9b8; });
$parcel$export(module.exports, "tuesday", function () { return $0c15e9d65f86b7e7$export$cb8f040f5d17ac7b; });
$parcel$export(module.exports, "wednesday", function () { return $0c15e9d65f86b7e7$export$347581849975dfc8; });
$parcel$export(module.exports, "thursday", function () { return $0c15e9d65f86b7e7$export$2f2b56683a3e5629; });
$parcel$export(module.exports, "friday", function () { return $0c15e9d65f86b7e7$export$59b8c2ccd931d806; });
$parcel$export(module.exports, "saturday", function () { return $0c15e9d65f86b7e7$export$478ceadebff4d377; });
$parcel$export(module.exports, "sundays", function () { return $0c15e9d65f86b7e7$export$e8daabaa40641211; });
$parcel$export(module.exports, "mondays", function () { return $0c15e9d65f86b7e7$export$74e5b559c235c00e; });
$parcel$export(module.exports, "tuesdays", function () { return $0c15e9d65f86b7e7$export$e7d6aa4fb107bc56; });
$parcel$export(module.exports, "wednesdays", function () { return $0c15e9d65f86b7e7$export$fcd5880b20bb06a8; });
$parcel$export(module.exports, "thursdays", function () { return $0c15e9d65f86b7e7$export$682716b7bbe33641; });
$parcel$export(module.exports, "fridays", function () { return $0c15e9d65f86b7e7$export$482924968ca86084; });
$parcel$export(module.exports, "saturdays", function () { return $0c15e9d65f86b7e7$export$7d755172c9cda9d2; });

var $d9CtV = parcelRequire("d9CtV");

var $jcbFZ = parcelRequire("jcbFZ");
function $0c15e9d65f86b7e7$var$weekday(i) {
    return (0, $d9CtV.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $jcbFZ.durationMinute)) / (0, $jcbFZ.durationWeek);
    });
}
var $0c15e9d65f86b7e7$export$fb3ee18ed410cc21 = $0c15e9d65f86b7e7$var$weekday(0);
var $0c15e9d65f86b7e7$export$6416afaab03bc9b8 = $0c15e9d65f86b7e7$var$weekday(1);
var $0c15e9d65f86b7e7$export$cb8f040f5d17ac7b = $0c15e9d65f86b7e7$var$weekday(2);
var $0c15e9d65f86b7e7$export$347581849975dfc8 = $0c15e9d65f86b7e7$var$weekday(3);
var $0c15e9d65f86b7e7$export$2f2b56683a3e5629 = $0c15e9d65f86b7e7$var$weekday(4);
var $0c15e9d65f86b7e7$export$59b8c2ccd931d806 = $0c15e9d65f86b7e7$var$weekday(5);
var $0c15e9d65f86b7e7$export$478ceadebff4d377 = $0c15e9d65f86b7e7$var$weekday(6);
var $0c15e9d65f86b7e7$export$e8daabaa40641211 = $0c15e9d65f86b7e7$export$fb3ee18ed410cc21.range;
var $0c15e9d65f86b7e7$export$74e5b559c235c00e = $0c15e9d65f86b7e7$export$6416afaab03bc9b8.range;
var $0c15e9d65f86b7e7$export$e7d6aa4fb107bc56 = $0c15e9d65f86b7e7$export$cb8f040f5d17ac7b.range;
var $0c15e9d65f86b7e7$export$fcd5880b20bb06a8 = $0c15e9d65f86b7e7$export$347581849975dfc8.range;
var $0c15e9d65f86b7e7$export$682716b7bbe33641 = $0c15e9d65f86b7e7$export$2f2b56683a3e5629.range;
var $0c15e9d65f86b7e7$export$482924968ca86084 = $0c15e9d65f86b7e7$export$59b8c2ccd931d806.range;
var $0c15e9d65f86b7e7$export$7d755172c9cda9d2 = $0c15e9d65f86b7e7$export$478ceadebff4d377.range;

});

parcelRegister("di9fD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ad421df7f9e054b$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "years", function () { return $9ad421df7f9e054b$export$6fda41c7fb23acf9; });

var $d9CtV = parcelRequire("d9CtV");
var $9ad421df7f9e054b$var$year = (0, $d9CtV.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$9ad421df7f9e054b$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $d9CtV.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $9ad421df7f9e054b$export$2e2bcd8739ae039 = $9ad421df7f9e054b$var$year;
var $9ad421df7f9e054b$export$6fda41c7fb23acf9 = $9ad421df7f9e054b$var$year.range;

});

parcelRegister("gVMzE", function(module, exports) {

$parcel$export(module.exports, "timeFormat", function () { return $c537a5fd3791a39f$export$94f4d87fad5dcf9a; });
$parcel$export(module.exports, "timeParse", function () { return $c537a5fd3791a39f$export$32b9cd16e1b8c8d2; });
$parcel$export(module.exports, "utcFormat", function () { return $c537a5fd3791a39f$export$1a08fe38f63ebbbb; });
$parcel$export(module.exports, "utcParse", function () { return $c537a5fd3791a39f$export$3edae9cf8e233729; });
$parcel$export(module.exports, "default", function () { return $c537a5fd3791a39f$export$2e2bcd8739ae039; });

var $kQnJN = parcelRequire("kQnJN");
var $c537a5fd3791a39f$var$locale;
var $c537a5fd3791a39f$export$94f4d87fad5dcf9a;
var $c537a5fd3791a39f$export$32b9cd16e1b8c8d2;
var $c537a5fd3791a39f$export$1a08fe38f63ebbbb;
var $c537a5fd3791a39f$export$3edae9cf8e233729;
$c537a5fd3791a39f$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $c537a5fd3791a39f$export$2e2bcd8739ae039(definition) {
    $c537a5fd3791a39f$var$locale = (0, $kQnJN.default)(definition);
    $c537a5fd3791a39f$export$94f4d87fad5dcf9a = $c537a5fd3791a39f$var$locale.format;
    $c537a5fd3791a39f$export$32b9cd16e1b8c8d2 = $c537a5fd3791a39f$var$locale.parse;
    $c537a5fd3791a39f$export$1a08fe38f63ebbbb = $c537a5fd3791a39f$var$locale.utcFormat;
    $c537a5fd3791a39f$export$3edae9cf8e233729 = $c537a5fd3791a39f$var$locale.utcParse;
    return $c537a5fd3791a39f$var$locale;
}

});
parcelRegister("kQnJN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2cb13c9517eb983$export$2e2bcd8739ae039; });

var $2OwRo = parcelRequire("2OwRo");
var $12kxK = parcelRequire("12kxK");
var $di9fD = parcelRequire("di9fD");
var $kKEAx = parcelRequire("kKEAx");
var $90yBq = parcelRequire("90yBq");
var $hC9DG = parcelRequire("hC9DG");
function $f2cb13c9517eb983$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $f2cb13c9517eb983$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $f2cb13c9517eb983$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $f2cb13c9517eb983$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $f2cb13c9517eb983$var$formatRe(locale_periods), periodLookup = $f2cb13c9517eb983$var$formatLookup(locale_periods), weekdayRe = $f2cb13c9517eb983$var$formatRe(locale_weekdays), weekdayLookup = $f2cb13c9517eb983$var$formatLookup(locale_weekdays), shortWeekdayRe = $f2cb13c9517eb983$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $f2cb13c9517eb983$var$formatLookup(locale_shortWeekdays), monthRe = $f2cb13c9517eb983$var$formatRe(locale_months), monthLookup = $f2cb13c9517eb983$var$formatLookup(locale_months), shortMonthRe = $f2cb13c9517eb983$var$formatRe(locale_shortMonths), shortMonthLookup = $f2cb13c9517eb983$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $f2cb13c9517eb983$var$formatDayOfMonth,
        "e": $f2cb13c9517eb983$var$formatDayOfMonth,
        "f": $f2cb13c9517eb983$var$formatMicroseconds,
        "g": $f2cb13c9517eb983$var$formatYearISO,
        "G": $f2cb13c9517eb983$var$formatFullYearISO,
        "H": $f2cb13c9517eb983$var$formatHour24,
        "I": $f2cb13c9517eb983$var$formatHour12,
        "j": $f2cb13c9517eb983$var$formatDayOfYear,
        "L": $f2cb13c9517eb983$var$formatMilliseconds,
        "m": $f2cb13c9517eb983$var$formatMonthNumber,
        "M": $f2cb13c9517eb983$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $f2cb13c9517eb983$var$formatUnixTimestamp,
        "s": $f2cb13c9517eb983$var$formatUnixTimestampSeconds,
        "S": $f2cb13c9517eb983$var$formatSeconds,
        "u": $f2cb13c9517eb983$var$formatWeekdayNumberMonday,
        "U": $f2cb13c9517eb983$var$formatWeekNumberSunday,
        "V": $f2cb13c9517eb983$var$formatWeekNumberISO,
        "w": $f2cb13c9517eb983$var$formatWeekdayNumberSunday,
        "W": $f2cb13c9517eb983$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $f2cb13c9517eb983$var$formatYear,
        "Y": $f2cb13c9517eb983$var$formatFullYear,
        "Z": $f2cb13c9517eb983$var$formatZone,
        "%": $f2cb13c9517eb983$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $f2cb13c9517eb983$var$formatUTCDayOfMonth,
        "e": $f2cb13c9517eb983$var$formatUTCDayOfMonth,
        "f": $f2cb13c9517eb983$var$formatUTCMicroseconds,
        "g": $f2cb13c9517eb983$var$formatUTCYearISO,
        "G": $f2cb13c9517eb983$var$formatUTCFullYearISO,
        "H": $f2cb13c9517eb983$var$formatUTCHour24,
        "I": $f2cb13c9517eb983$var$formatUTCHour12,
        "j": $f2cb13c9517eb983$var$formatUTCDayOfYear,
        "L": $f2cb13c9517eb983$var$formatUTCMilliseconds,
        "m": $f2cb13c9517eb983$var$formatUTCMonthNumber,
        "M": $f2cb13c9517eb983$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $f2cb13c9517eb983$var$formatUnixTimestamp,
        "s": $f2cb13c9517eb983$var$formatUnixTimestampSeconds,
        "S": $f2cb13c9517eb983$var$formatUTCSeconds,
        "u": $f2cb13c9517eb983$var$formatUTCWeekdayNumberMonday,
        "U": $f2cb13c9517eb983$var$formatUTCWeekNumberSunday,
        "V": $f2cb13c9517eb983$var$formatUTCWeekNumberISO,
        "w": $f2cb13c9517eb983$var$formatUTCWeekdayNumberSunday,
        "W": $f2cb13c9517eb983$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $f2cb13c9517eb983$var$formatUTCYear,
        "Y": $f2cb13c9517eb983$var$formatUTCFullYear,
        "Z": $f2cb13c9517eb983$var$formatUTCZone,
        "%": $f2cb13c9517eb983$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $f2cb13c9517eb983$var$parseDayOfMonth,
        "e": $f2cb13c9517eb983$var$parseDayOfMonth,
        "f": $f2cb13c9517eb983$var$parseMicroseconds,
        "g": $f2cb13c9517eb983$var$parseYear,
        "G": $f2cb13c9517eb983$var$parseFullYear,
        "H": $f2cb13c9517eb983$var$parseHour24,
        "I": $f2cb13c9517eb983$var$parseHour24,
        "j": $f2cb13c9517eb983$var$parseDayOfYear,
        "L": $f2cb13c9517eb983$var$parseMilliseconds,
        "m": $f2cb13c9517eb983$var$parseMonthNumber,
        "M": $f2cb13c9517eb983$var$parseMinutes,
        "p": parsePeriod,
        "q": $f2cb13c9517eb983$var$parseQuarter,
        "Q": $f2cb13c9517eb983$var$parseUnixTimestamp,
        "s": $f2cb13c9517eb983$var$parseUnixTimestampSeconds,
        "S": $f2cb13c9517eb983$var$parseSeconds,
        "u": $f2cb13c9517eb983$var$parseWeekdayNumberMonday,
        "U": $f2cb13c9517eb983$var$parseWeekNumberSunday,
        "V": $f2cb13c9517eb983$var$parseWeekNumberISO,
        "w": $f2cb13c9517eb983$var$parseWeekdayNumberSunday,
        "W": $f2cb13c9517eb983$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $f2cb13c9517eb983$var$parseYear,
        "Y": $f2cb13c9517eb983$var$parseFullYear,
        "Z": $f2cb13c9517eb983$var$parseZone,
        "%": $f2cb13c9517eb983$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $f2cb13c9517eb983$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $f2cb13c9517eb983$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $f2cb13c9517eb983$var$utcDate($f2cb13c9517eb983$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $90yBq.utcMonday).ceil(week) : (0, $90yBq.utcMonday)(week);
                    week = (0, $kKEAx.default).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $f2cb13c9517eb983$var$localDate($f2cb13c9517eb983$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $12kxK.monday).ceil(week) : (0, $12kxK.monday)(week);
                    week = (0, $2OwRo.default).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $f2cb13c9517eb983$var$utcDate($f2cb13c9517eb983$var$newDate(d.y, 0, 1)).getUTCDay() : $f2cb13c9517eb983$var$localDate($f2cb13c9517eb983$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $f2cb13c9517eb983$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $f2cb13c9517eb983$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $f2cb13c9517eb983$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $f2cb13c9517eb983$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $f2cb13c9517eb983$var$numberRe = /^\s*\d+/, $f2cb13c9517eb983$var$percentRe = /^%/, $f2cb13c9517eb983$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $f2cb13c9517eb983$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $f2cb13c9517eb983$var$requote(s) {
    return s.replace($f2cb13c9517eb983$var$requoteRe, "\\$&");
}
function $f2cb13c9517eb983$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($f2cb13c9517eb983$var$requote).join("|") + ")", "i");
}
function $f2cb13c9517eb983$var$formatLookup(names) {
    var map = {}, i = -1, n = names.length;
    while(++i < n)map[names[i].toLowerCase()] = i;
    return map;
}
function $f2cb13c9517eb983$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseWeekNumberSunday(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseWeekNumberISO(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseWeekNumberMonday(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseFullYear(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseYear(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseQuarter(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseMonthNumber(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseDayOfMonth(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseDayOfYear(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseHour24(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseMinutes(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseSeconds(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseMilliseconds(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseMicroseconds(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseLiteralPercent(d, string, i) {
    var n = $f2cb13c9517eb983$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $f2cb13c9517eb983$var$parseUnixTimestamp(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$formatDayOfMonth(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getDate(), p, 2);
}
function $f2cb13c9517eb983$var$formatHour24(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getHours(), p, 2);
}
function $f2cb13c9517eb983$var$formatHour12(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $f2cb13c9517eb983$var$formatDayOfYear(d, p) {
    return $f2cb13c9517eb983$var$pad(1 + (0, $2OwRo.default).count((0, $di9fD.default)(d), d), p, 3);
}
function $f2cb13c9517eb983$var$formatMilliseconds(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getMilliseconds(), p, 3);
}
function $f2cb13c9517eb983$var$formatMicroseconds(d, p) {
    return $f2cb13c9517eb983$var$formatMilliseconds(d, p) + "000";
}
function $f2cb13c9517eb983$var$formatMonthNumber(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getMonth() + 1, p, 2);
}
function $f2cb13c9517eb983$var$formatMinutes(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getMinutes(), p, 2);
}
function $f2cb13c9517eb983$var$formatSeconds(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getSeconds(), p, 2);
}
function $f2cb13c9517eb983$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $f2cb13c9517eb983$var$formatWeekNumberSunday(d, p) {
    return $f2cb13c9517eb983$var$pad((0, $12kxK.sunday).count((0, $di9fD.default)(d) - 1, d), p, 2);
}
function $f2cb13c9517eb983$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $12kxK.thursday)(d) : (0, $12kxK.thursday).ceil(d);
}
function $f2cb13c9517eb983$var$formatWeekNumberISO(d, p) {
    d = $f2cb13c9517eb983$var$dISO(d);
    return $f2cb13c9517eb983$var$pad((0, $12kxK.thursday).count((0, $di9fD.default)(d), d) + ((0, $di9fD.default)(d).getDay() === 4), p, 2);
}
function $f2cb13c9517eb983$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $f2cb13c9517eb983$var$formatWeekNumberMonday(d, p) {
    return $f2cb13c9517eb983$var$pad((0, $12kxK.monday).count((0, $di9fD.default)(d) - 1, d), p, 2);
}
function $f2cb13c9517eb983$var$formatYear(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getFullYear() % 100, p, 2);
}
function $f2cb13c9517eb983$var$formatYearISO(d, p) {
    d = $f2cb13c9517eb983$var$dISO(d);
    return $f2cb13c9517eb983$var$pad(d.getFullYear() % 100, p, 2);
}
function $f2cb13c9517eb983$var$formatFullYear(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getFullYear() % 10000, p, 4);
}
function $f2cb13c9517eb983$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $12kxK.thursday)(d) : (0, $12kxK.thursday).ceil(d);
    return $f2cb13c9517eb983$var$pad(d.getFullYear() % 10000, p, 4);
}
function $f2cb13c9517eb983$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $f2cb13c9517eb983$var$pad(z / 60 | 0, "0", 2) + $f2cb13c9517eb983$var$pad(z % 60, "0", 2);
}
function $f2cb13c9517eb983$var$formatUTCDayOfMonth(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCDate(), p, 2);
}
function $f2cb13c9517eb983$var$formatUTCHour24(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCHours(), p, 2);
}
function $f2cb13c9517eb983$var$formatUTCHour12(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $f2cb13c9517eb983$var$formatUTCDayOfYear(d, p) {
    return $f2cb13c9517eb983$var$pad(1 + (0, $kKEAx.default).count((0, $hC9DG.default)(d), d), p, 3);
}
function $f2cb13c9517eb983$var$formatUTCMilliseconds(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $f2cb13c9517eb983$var$formatUTCMicroseconds(d, p) {
    return $f2cb13c9517eb983$var$formatUTCMilliseconds(d, p) + "000";
}
function $f2cb13c9517eb983$var$formatUTCMonthNumber(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $f2cb13c9517eb983$var$formatUTCMinutes(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCMinutes(), p, 2);
}
function $f2cb13c9517eb983$var$formatUTCSeconds(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCSeconds(), p, 2);
}
function $f2cb13c9517eb983$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $f2cb13c9517eb983$var$formatUTCWeekNumberSunday(d, p) {
    return $f2cb13c9517eb983$var$pad((0, $90yBq.utcSunday).count((0, $hC9DG.default)(d) - 1, d), p, 2);
}
function $f2cb13c9517eb983$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $90yBq.utcThursday)(d) : (0, $90yBq.utcThursday).ceil(d);
}
function $f2cb13c9517eb983$var$formatUTCWeekNumberISO(d, p) {
    d = $f2cb13c9517eb983$var$UTCdISO(d);
    return $f2cb13c9517eb983$var$pad((0, $90yBq.utcThursday).count((0, $hC9DG.default)(d), d) + ((0, $hC9DG.default)(d).getUTCDay() === 4), p, 2);
}
function $f2cb13c9517eb983$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $f2cb13c9517eb983$var$formatUTCWeekNumberMonday(d, p) {
    return $f2cb13c9517eb983$var$pad((0, $90yBq.utcMonday).count((0, $hC9DG.default)(d) - 1, d), p, 2);
}
function $f2cb13c9517eb983$var$formatUTCYear(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $f2cb13c9517eb983$var$formatUTCYearISO(d, p) {
    d = $f2cb13c9517eb983$var$UTCdISO(d);
    return $f2cb13c9517eb983$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $f2cb13c9517eb983$var$formatUTCFullYear(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $f2cb13c9517eb983$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $90yBq.utcThursday)(d) : (0, $90yBq.utcThursday).ceil(d);
    return $f2cb13c9517eb983$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $f2cb13c9517eb983$var$formatUTCZone() {
    return "+0000";
}
function $f2cb13c9517eb983$var$formatLiteralPercent() {
    return "%";
}
function $f2cb13c9517eb983$var$formatUnixTimestamp(d) {
    return +d;
}
function $f2cb13c9517eb983$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});
parcelRegister("kKEAx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1b7968b2147d13a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "utcDays", function () { return $f1b7968b2147d13a$export$d277e198508549a1; });

var $d9CtV = parcelRequire("d9CtV");

var $jcbFZ = parcelRequire("jcbFZ");
var $f1b7968b2147d13a$var$utcDay = (0, $d9CtV.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $jcbFZ.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $f1b7968b2147d13a$export$2e2bcd8739ae039 = $f1b7968b2147d13a$var$utcDay;
var $f1b7968b2147d13a$export$d277e198508549a1 = $f1b7968b2147d13a$var$utcDay.range;

});

parcelRegister("90yBq", function(module, exports) {

$parcel$export(module.exports, "utcSunday", function () { return $68eef47edb967d12$export$4898b06303a92011; });
$parcel$export(module.exports, "utcMonday", function () { return $68eef47edb967d12$export$9cfc53b9cfafd080; });
$parcel$export(module.exports, "utcTuesday", function () { return $68eef47edb967d12$export$2a6d545f77eceb15; });
$parcel$export(module.exports, "utcWednesday", function () { return $68eef47edb967d12$export$a5c25d8ed64433c4; });
$parcel$export(module.exports, "utcThursday", function () { return $68eef47edb967d12$export$1db08111baec2f53; });
$parcel$export(module.exports, "utcFriday", function () { return $68eef47edb967d12$export$29265e34dd5921f7; });
$parcel$export(module.exports, "utcSaturday", function () { return $68eef47edb967d12$export$85b74dad05049604; });
$parcel$export(module.exports, "utcSundays", function () { return $68eef47edb967d12$export$6f3e1c2b0f7d7880; });
$parcel$export(module.exports, "utcMondays", function () { return $68eef47edb967d12$export$1d2d8b858bb366f9; });
$parcel$export(module.exports, "utcTuesdays", function () { return $68eef47edb967d12$export$1d5f6785fc7f30f8; });
$parcel$export(module.exports, "utcWednesdays", function () { return $68eef47edb967d12$export$7a75faf0e37ef4af; });
$parcel$export(module.exports, "utcThursdays", function () { return $68eef47edb967d12$export$417eb959611b2f2f; });
$parcel$export(module.exports, "utcFridays", function () { return $68eef47edb967d12$export$59d308db7af08c64; });
$parcel$export(module.exports, "utcSaturdays", function () { return $68eef47edb967d12$export$a124108a0a7f34c8; });

var $d9CtV = parcelRequire("d9CtV");

var $jcbFZ = parcelRequire("jcbFZ");
function $68eef47edb967d12$var$utcWeekday(i) {
    return (0, $d9CtV.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $jcbFZ.durationWeek);
    });
}
var $68eef47edb967d12$export$4898b06303a92011 = $68eef47edb967d12$var$utcWeekday(0);
var $68eef47edb967d12$export$9cfc53b9cfafd080 = $68eef47edb967d12$var$utcWeekday(1);
var $68eef47edb967d12$export$2a6d545f77eceb15 = $68eef47edb967d12$var$utcWeekday(2);
var $68eef47edb967d12$export$a5c25d8ed64433c4 = $68eef47edb967d12$var$utcWeekday(3);
var $68eef47edb967d12$export$1db08111baec2f53 = $68eef47edb967d12$var$utcWeekday(4);
var $68eef47edb967d12$export$29265e34dd5921f7 = $68eef47edb967d12$var$utcWeekday(5);
var $68eef47edb967d12$export$85b74dad05049604 = $68eef47edb967d12$var$utcWeekday(6);
var $68eef47edb967d12$export$6f3e1c2b0f7d7880 = $68eef47edb967d12$export$4898b06303a92011.range;
var $68eef47edb967d12$export$1d2d8b858bb366f9 = $68eef47edb967d12$export$9cfc53b9cfafd080.range;
var $68eef47edb967d12$export$1d5f6785fc7f30f8 = $68eef47edb967d12$export$2a6d545f77eceb15.range;
var $68eef47edb967d12$export$7a75faf0e37ef4af = $68eef47edb967d12$export$a5c25d8ed64433c4.range;
var $68eef47edb967d12$export$417eb959611b2f2f = $68eef47edb967d12$export$1db08111baec2f53.range;
var $68eef47edb967d12$export$59d308db7af08c64 = $68eef47edb967d12$export$29265e34dd5921f7.range;
var $68eef47edb967d12$export$a124108a0a7f34c8 = $68eef47edb967d12$export$85b74dad05049604.range;

});

parcelRegister("hC9DG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd2d7668133d8e0d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "utcYears", function () { return $cd2d7668133d8e0d$export$3e24d311e17f5802; });

var $d9CtV = parcelRequire("d9CtV");
var $cd2d7668133d8e0d$var$utcYear = (0, $d9CtV.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$cd2d7668133d8e0d$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $d9CtV.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $cd2d7668133d8e0d$export$2e2bcd8739ae039 = $cd2d7668133d8e0d$var$utcYear;
var $cd2d7668133d8e0d$export$3e24d311e17f5802 = $cd2d7668133d8e0d$var$utcYear.range;

});




parcelRegister("6YaNq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5130b88d88e34ca7$export$2e2bcd8739ae039; });

var $jfnQ8 = parcelRequire("jfnQ8");

var $gVMzE = parcelRequire("gVMzE");

var $kKEAx = parcelRequire("kKEAx");
var $1Jzw0 = parcelRequire("1Jzw0");
var $4YZxj = parcelRequire("4YZxj");
var $78Eaf = parcelRequire("78Eaf");
var $5Dm9r = parcelRequire("5Dm9r");
var $ckkQj = parcelRequire("ckkQj");
var $90yBq = parcelRequire("90yBq");
var $hC9DG = parcelRequire("hC9DG");

var $2DSNq = parcelRequire("2DSNq");
function $5130b88d88e34ca7$export$2e2bcd8739ae039() {
    return (0, $2DSNq.initRange).apply((0, $jfnQ8.calendar)((0, $hC9DG.default), (0, $5Dm9r.default), (0, $90yBq.utcSunday), (0, $kKEAx.default), (0, $1Jzw0.default), (0, $78Eaf.default), (0, $ckkQj.default), (0, $4YZxj.default), (0, $gVMzE.utcFormat)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("1Jzw0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14358af9dd9896a4$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "utcHours", function () { return $14358af9dd9896a4$export$6e7a76cd5f50b719; });

var $d9CtV = parcelRequire("d9CtV");

var $jcbFZ = parcelRequire("jcbFZ");
var $14358af9dd9896a4$var$utcHour = (0, $d9CtV.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $jcbFZ.durationHour));
}, function(start, end) {
    return (end - start) / (0, $jcbFZ.durationHour);
}, function(date) {
    return date.getUTCHours();
});
var $14358af9dd9896a4$export$2e2bcd8739ae039 = $14358af9dd9896a4$var$utcHour;
var $14358af9dd9896a4$export$6e7a76cd5f50b719 = $14358af9dd9896a4$var$utcHour.range;

});

parcelRegister("78Eaf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53286f8c3608faef$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "utcMinutes", function () { return $53286f8c3608faef$export$cedd563624e8ee50; });

var $d9CtV = parcelRequire("d9CtV");

var $jcbFZ = parcelRequire("jcbFZ");
var $53286f8c3608faef$var$utcMinute = (0, $d9CtV.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $jcbFZ.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $jcbFZ.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
var $53286f8c3608faef$export$2e2bcd8739ae039 = $53286f8c3608faef$var$utcMinute;
var $53286f8c3608faef$export$cedd563624e8ee50 = $53286f8c3608faef$var$utcMinute.range;

});

parcelRegister("5Dm9r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41a1c709295b8797$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "utcMonths", function () { return $41a1c709295b8797$export$49159f585997498; });

var $d9CtV = parcelRequire("d9CtV");
var $41a1c709295b8797$var$utcMonth = (0, $d9CtV.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $41a1c709295b8797$export$2e2bcd8739ae039 = $41a1c709295b8797$var$utcMonth;
var $41a1c709295b8797$export$49159f585997498 = $41a1c709295b8797$var$utcMonth.range;

});


parcelRegister("2IWzQ", function(module, exports) {

$parcel$export(module.exports, "copy", function () { return $1fbd210729a53e59$export$784d13d8ee351f07; });
$parcel$export(module.exports, "default", function () { return $1fbd210729a53e59$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "sequentialLog", function () { return $1fbd210729a53e59$export$6843e08bf2ff981f; });
$parcel$export(module.exports, "sequentialSymlog", function () { return $1fbd210729a53e59$export$9d4af4de62c81941; });
$parcel$export(module.exports, "sequentialPow", function () { return $1fbd210729a53e59$export$de9f78581b4f2405; });
$parcel$export(module.exports, "sequentialSqrt", function () { return $1fbd210729a53e59$export$413d935127ed466e; });

var $hCOuU = parcelRequire("hCOuU");

var $2DSNq = parcelRequire("2DSNq");

var $2KypB = parcelRequire("2KypB");

var $2uFhV = parcelRequire("2uFhV");

var $77qSP = parcelRequire("77qSP");

var $in36U = parcelRequire("in36U");
function $1fbd210729a53e59$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $hCOuU.identity), clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $1fbd210729a53e59$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $1fbd210729a53e59$export$2e2bcd8739ae039() {
    var scale = (0, $2KypB.linearish)($1fbd210729a53e59$var$transformer()((0, $hCOuU.identity)));
    scale.copy = function() {
        return $1fbd210729a53e59$export$784d13d8ee351f07(scale, $1fbd210729a53e59$export$2e2bcd8739ae039());
    };
    return (0, $2DSNq.initInterpolator).apply(scale, arguments);
}
function $1fbd210729a53e59$export$6843e08bf2ff981f() {
    var scale = (0, $2uFhV.loggish)($1fbd210729a53e59$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $1fbd210729a53e59$export$784d13d8ee351f07(scale, $1fbd210729a53e59$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $2DSNq.initInterpolator).apply(scale, arguments);
}
function $1fbd210729a53e59$export$9d4af4de62c81941() {
    var scale = (0, $77qSP.symlogish)($1fbd210729a53e59$var$transformer());
    scale.copy = function() {
        return $1fbd210729a53e59$export$784d13d8ee351f07(scale, $1fbd210729a53e59$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $2DSNq.initInterpolator).apply(scale, arguments);
}
function $1fbd210729a53e59$export$de9f78581b4f2405() {
    var scale = (0, $in36U.powish)($1fbd210729a53e59$var$transformer());
    scale.copy = function() {
        return $1fbd210729a53e59$export$784d13d8ee351f07(scale, $1fbd210729a53e59$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $2DSNq.initInterpolator).apply(scale, arguments);
}
function $1fbd210729a53e59$export$413d935127ed466e() {
    return $1fbd210729a53e59$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("1xB1b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11f5968cb873f119$export$2e2bcd8739ae039; });
parcelRequire("9f3pr");
var $fW9sn = parcelRequire("fW9sn");
var $7naKx = parcelRequire("7naKx");

var $hCOuU = parcelRequire("hCOuU");

var $2DSNq = parcelRequire("2DSNq");
function $11f5968cb873f119$export$2e2bcd8739ae039() {
    var domain = [], interpolator = (0, $hCOuU.identity);
    function scale(x) {
        if (!isNaN(x = +x)) return interpolator(((0, $7naKx.default)(domain, x) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for(var i = 0, n = _.length, d; i < n; ++i)if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $fW9sn.default));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.copy = function() {
        return $11f5968cb873f119$export$2e2bcd8739ae039(interpolator).domain(domain);
    };
    return (0, $2DSNq.initInterpolator).apply(scale, arguments);
}

});

parcelRegister("52YqS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3acc04507f0fc995$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "divergingLog", function () { return $3acc04507f0fc995$export$5f0266a9159c47fb; });
$parcel$export(module.exports, "divergingSymlog", function () { return $3acc04507f0fc995$export$50b3da713cf557c6; });
$parcel$export(module.exports, "divergingPow", function () { return $3acc04507f0fc995$export$d6cedcc63bf26e7e; });
$parcel$export(module.exports, "divergingSqrt", function () { return $3acc04507f0fc995$export$33ddefb5c4ab9e9c; });

var $hCOuU = parcelRequire("hCOuU");

var $2DSNq = parcelRequire("2DSNq");

var $2KypB = parcelRequire("2KypB");

var $2uFhV = parcelRequire("2uFhV");

var $2IWzQ = parcelRequire("2IWzQ");

var $77qSP = parcelRequire("77qSP");

var $in36U = parcelRequire("in36U");
function $3acc04507f0fc995$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, t0, t1, t2, k10, k21, interpolator = (0, $hCOuU.identity), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (x < t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), t2 = transform(x2 = +_[2]), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1);
        return scale;
    };
}
function $3acc04507f0fc995$export$2e2bcd8739ae039() {
    var scale = (0, $2KypB.linearish)($3acc04507f0fc995$var$transformer()((0, $hCOuU.identity)));
    scale.copy = function() {
        return (0, $2IWzQ.copy)(scale, $3acc04507f0fc995$export$2e2bcd8739ae039());
    };
    return (0, $2DSNq.initInterpolator).apply(scale, arguments);
}
function $3acc04507f0fc995$export$5f0266a9159c47fb() {
    var scale = (0, $2uFhV.loggish)($3acc04507f0fc995$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $2IWzQ.copy)(scale, $3acc04507f0fc995$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $2DSNq.initInterpolator).apply(scale, arguments);
}
function $3acc04507f0fc995$export$50b3da713cf557c6() {
    var scale = (0, $77qSP.symlogish)($3acc04507f0fc995$var$transformer());
    scale.copy = function() {
        return (0, $2IWzQ.copy)(scale, $3acc04507f0fc995$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $2DSNq.initInterpolator).apply(scale, arguments);
}
function $3acc04507f0fc995$export$d6cedcc63bf26e7e() {
    var scale = (0, $in36U.powish)($3acc04507f0fc995$var$transformer());
    scale.copy = function() {
        return (0, $2IWzQ.copy)(scale, $3acc04507f0fc995$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $2DSNq.initInterpolator).apply(scale, arguments);
}
function $3acc04507f0fc995$export$33ddefb5c4ab9e9c() {
    return $3acc04507f0fc995$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}

});


parcelRegister("hsmXe", function(module, exports) {

$parcel$export(module.exports, "schemeCategory10", function () { return (parcelRequire("9lYWR")).default; });
$parcel$export(module.exports, "schemeAccent", function () { return (parcelRequire("eEzf4")).default; });
$parcel$export(module.exports, "schemeDark2", function () { return (parcelRequire("33TWm")).default; });
$parcel$export(module.exports, "schemePaired", function () { return (parcelRequire("iLVda")).default; });
$parcel$export(module.exports, "schemePastel1", function () { return (parcelRequire("6z4xV")).default; });
$parcel$export(module.exports, "schemePastel2", function () { return (parcelRequire("3tB02")).default; });
$parcel$export(module.exports, "schemeSet1", function () { return (parcelRequire("7mSeJ")).default; });
$parcel$export(module.exports, "schemeSet2", function () { return (parcelRequire("452if")).default; });
$parcel$export(module.exports, "schemeSet3", function () { return (parcelRequire("daVDx")).default; });
$parcel$export(module.exports, "schemeTableau10", function () { return (parcelRequire("fGln8")).default; });
$parcel$export(module.exports, "interpolateBrBG", function () { return (parcelRequire("ggQQ9")).default; });
$parcel$export(module.exports, "schemeBrBG", function () { return (parcelRequire("ggQQ9")).scheme; });
$parcel$export(module.exports, "interpolatePRGn", function () { return (parcelRequire("6rxmq")).default; });
$parcel$export(module.exports, "schemePRGn", function () { return (parcelRequire("6rxmq")).scheme; });
$parcel$export(module.exports, "interpolatePiYG", function () { return (parcelRequire("f7Jtv")).default; });
$parcel$export(module.exports, "schemePiYG", function () { return (parcelRequire("f7Jtv")).scheme; });
$parcel$export(module.exports, "interpolatePuOr", function () { return (parcelRequire("9Oo40")).default; });
$parcel$export(module.exports, "schemePuOr", function () { return (parcelRequire("9Oo40")).scheme; });
$parcel$export(module.exports, "interpolateRdBu", function () { return (parcelRequire("bJ09Y")).default; });
$parcel$export(module.exports, "schemeRdBu", function () { return (parcelRequire("bJ09Y")).scheme; });
$parcel$export(module.exports, "interpolateRdGy", function () { return (parcelRequire("kjab6")).default; });
$parcel$export(module.exports, "schemeRdGy", function () { return (parcelRequire("kjab6")).scheme; });
$parcel$export(module.exports, "interpolateRdYlBu", function () { return (parcelRequire("dGwxN")).default; });
$parcel$export(module.exports, "schemeRdYlBu", function () { return (parcelRequire("dGwxN")).scheme; });
$parcel$export(module.exports, "interpolateRdYlGn", function () { return (parcelRequire("4e1XJ")).default; });
$parcel$export(module.exports, "schemeRdYlGn", function () { return (parcelRequire("4e1XJ")).scheme; });
$parcel$export(module.exports, "interpolateSpectral", function () { return (parcelRequire("bgshW")).default; });
$parcel$export(module.exports, "schemeSpectral", function () { return (parcelRequire("bgshW")).scheme; });
$parcel$export(module.exports, "interpolateBuGn", function () { return (parcelRequire("4JKFE")).default; });
$parcel$export(module.exports, "schemeBuGn", function () { return (parcelRequire("4JKFE")).scheme; });
$parcel$export(module.exports, "interpolateBuPu", function () { return (parcelRequire("3rHLk")).default; });
$parcel$export(module.exports, "schemeBuPu", function () { return (parcelRequire("3rHLk")).scheme; });
$parcel$export(module.exports, "interpolateGnBu", function () { return (parcelRequire("kPFfm")).default; });
$parcel$export(module.exports, "schemeGnBu", function () { return (parcelRequire("kPFfm")).scheme; });
$parcel$export(module.exports, "interpolateOrRd", function () { return (parcelRequire("bBI8W")).default; });
$parcel$export(module.exports, "schemeOrRd", function () { return (parcelRequire("bBI8W")).scheme; });
$parcel$export(module.exports, "interpolatePuBuGn", function () { return (parcelRequire("6ISLE")).default; });
$parcel$export(module.exports, "schemePuBuGn", function () { return (parcelRequire("6ISLE")).scheme; });
$parcel$export(module.exports, "interpolatePuBu", function () { return (parcelRequire("cn29s")).default; });
$parcel$export(module.exports, "schemePuBu", function () { return (parcelRequire("cn29s")).scheme; });
$parcel$export(module.exports, "interpolatePuRd", function () { return (parcelRequire("pafOw")).default; });
$parcel$export(module.exports, "schemePuRd", function () { return (parcelRequire("pafOw")).scheme; });
$parcel$export(module.exports, "interpolateRdPu", function () { return (parcelRequire("apu7T")).default; });
$parcel$export(module.exports, "schemeRdPu", function () { return (parcelRequire("apu7T")).scheme; });
$parcel$export(module.exports, "interpolateYlGnBu", function () { return (parcelRequire("9l7m9")).default; });
$parcel$export(module.exports, "schemeYlGnBu", function () { return (parcelRequire("9l7m9")).scheme; });
$parcel$export(module.exports, "interpolateYlGn", function () { return (parcelRequire("gmzux")).default; });
$parcel$export(module.exports, "schemeYlGn", function () { return (parcelRequire("gmzux")).scheme; });
$parcel$export(module.exports, "interpolateYlOrBr", function () { return (parcelRequire("8PEwt")).default; });
$parcel$export(module.exports, "schemeYlOrBr", function () { return (parcelRequire("8PEwt")).scheme; });
$parcel$export(module.exports, "interpolateYlOrRd", function () { return (parcelRequire("9jRsc")).default; });
$parcel$export(module.exports, "schemeYlOrRd", function () { return (parcelRequire("9jRsc")).scheme; });
$parcel$export(module.exports, "interpolateBlues", function () { return (parcelRequire("bHgMR")).default; });
$parcel$export(module.exports, "schemeBlues", function () { return (parcelRequire("bHgMR")).scheme; });
$parcel$export(module.exports, "interpolateGreens", function () { return (parcelRequire("jVPwB")).default; });
$parcel$export(module.exports, "schemeGreens", function () { return (parcelRequire("jVPwB")).scheme; });
$parcel$export(module.exports, "interpolateGreys", function () { return (parcelRequire("8DyZz")).default; });
$parcel$export(module.exports, "schemeGreys", function () { return (parcelRequire("8DyZz")).scheme; });
$parcel$export(module.exports, "interpolatePurples", function () { return (parcelRequire("jYUGM")).default; });
$parcel$export(module.exports, "schemePurples", function () { return (parcelRequire("jYUGM")).scheme; });
$parcel$export(module.exports, "interpolateReds", function () { return (parcelRequire("gjRxN")).default; });
$parcel$export(module.exports, "schemeReds", function () { return (parcelRequire("gjRxN")).scheme; });
$parcel$export(module.exports, "interpolateOranges", function () { return (parcelRequire("4TuoW")).default; });
$parcel$export(module.exports, "schemeOranges", function () { return (parcelRequire("4TuoW")).scheme; });
$parcel$export(module.exports, "interpolateCividis", function () { return (parcelRequire("3EQyk")).default; });
$parcel$export(module.exports, "interpolateCubehelixDefault", function () { return (parcelRequire("1zMZJ")).default; });
$parcel$export(module.exports, "interpolateRainbow", function () { return (parcelRequire("frR0g")).default; });
$parcel$export(module.exports, "interpolateWarm", function () { return (parcelRequire("frR0g")).warm; });
$parcel$export(module.exports, "interpolateCool", function () { return (parcelRequire("frR0g")).cool; });
$parcel$export(module.exports, "interpolateSinebow", function () { return (parcelRequire("2Lq2L")).default; });
$parcel$export(module.exports, "interpolateTurbo", function () { return (parcelRequire("i4Jnh")).default; });
$parcel$export(module.exports, "interpolateViridis", function () { return (parcelRequire("j2wY7")).default; });
$parcel$export(module.exports, "interpolateMagma", function () { return (parcelRequire("j2wY7")).magma; });
$parcel$export(module.exports, "interpolateInferno", function () { return (parcelRequire("j2wY7")).inferno; });
$parcel$export(module.exports, "interpolatePlasma", function () { return (parcelRequire("j2wY7")).plasma; });

var $9lYWR = parcelRequire("9lYWR");

var $eEzf4 = parcelRequire("eEzf4");

var $33TWm = parcelRequire("33TWm");

var $iLVda = parcelRequire("iLVda");

var $6z4xV = parcelRequire("6z4xV");

var $3tB02 = parcelRequire("3tB02");

var $7mSeJ = parcelRequire("7mSeJ");

var $452if = parcelRequire("452if");

var $daVDx = parcelRequire("daVDx");

var $fGln8 = parcelRequire("fGln8");

var $ggQQ9 = parcelRequire("ggQQ9");

var $6rxmq = parcelRequire("6rxmq");

var $f7Jtv = parcelRequire("f7Jtv");

var $9Oo40 = parcelRequire("9Oo40");

var $bJ09Y = parcelRequire("bJ09Y");

var $kjab6 = parcelRequire("kjab6");

var $dGwxN = parcelRequire("dGwxN");

var $4e1XJ = parcelRequire("4e1XJ");

var $bgshW = parcelRequire("bgshW");

var $4JKFE = parcelRequire("4JKFE");

var $3rHLk = parcelRequire("3rHLk");

var $kPFfm = parcelRequire("kPFfm");

var $bBI8W = parcelRequire("bBI8W");

var $6ISLE = parcelRequire("6ISLE");

var $cn29s = parcelRequire("cn29s");

var $pafOw = parcelRequire("pafOw");

var $apu7T = parcelRequire("apu7T");

var $9l7m9 = parcelRequire("9l7m9");

var $gmzux = parcelRequire("gmzux");

var $8PEwt = parcelRequire("8PEwt");

var $9jRsc = parcelRequire("9jRsc");

var $bHgMR = parcelRequire("bHgMR");

var $jVPwB = parcelRequire("jVPwB");

var $8DyZz = parcelRequire("8DyZz");

var $jYUGM = parcelRequire("jYUGM");

var $gjRxN = parcelRequire("gjRxN");

var $4TuoW = parcelRequire("4TuoW");

var $3EQyk = parcelRequire("3EQyk");

var $1zMZJ = parcelRequire("1zMZJ");

var $frR0g = parcelRequire("frR0g");

var $2Lq2L = parcelRequire("2Lq2L");

var $i4Jnh = parcelRequire("i4Jnh");

var $j2wY7 = parcelRequire("j2wY7");

});
parcelRegister("9lYWR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cf55a52784c4c94$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");
var $6cf55a52784c4c94$export$2e2bcd8739ae039 = (0, $c1OIL.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

});
parcelRegister("c1OIL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c1cec2d8bf99503$export$2e2bcd8739ae039; });
function $8c1cec2d8bf99503$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}

});


parcelRegister("eEzf4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02c0c6c3f7e43cc1$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");
var $02c0c6c3f7e43cc1$export$2e2bcd8739ae039 = (0, $c1OIL.default)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

});

parcelRegister("33TWm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23ad0b7aebc66491$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");
var $23ad0b7aebc66491$export$2e2bcd8739ae039 = (0, $c1OIL.default)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

});

parcelRegister("iLVda", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $daa8fec60be60ffe$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");
var $daa8fec60be60ffe$export$2e2bcd8739ae039 = (0, $c1OIL.default)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

});

parcelRegister("6z4xV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c7989bc9a50cdfa$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");
var $4c7989bc9a50cdfa$export$2e2bcd8739ae039 = (0, $c1OIL.default)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

});

parcelRegister("3tB02", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2880c7e0dc26a886$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");
var $2880c7e0dc26a886$export$2e2bcd8739ae039 = (0, $c1OIL.default)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

});

parcelRegister("7mSeJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55d4a8bbe5640080$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");
var $55d4a8bbe5640080$export$2e2bcd8739ae039 = (0, $c1OIL.default)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

});

parcelRegister("452if", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f896875c60cd30c$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");
var $2f896875c60cd30c$export$2e2bcd8739ae039 = (0, $c1OIL.default)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

});

parcelRegister("daVDx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9978eafa53379e60$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");
var $9978eafa53379e60$export$2e2bcd8739ae039 = (0, $c1OIL.default)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

});

parcelRegister("fGln8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6ab5b54e89a6e21$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");
var $b6ab5b54e89a6e21$export$2e2bcd8739ae039 = (0, $c1OIL.default)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");

});

parcelRegister("ggQQ9", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $bd8720e4c6eb3871$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $bd8720e4c6eb3871$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $bd8720e4c6eb3871$export$3005042704f95a69 = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, $c1OIL.default));
var $bd8720e4c6eb3871$export$2e2bcd8739ae039 = (0, $iRWay.default)($bd8720e4c6eb3871$export$3005042704f95a69);

});
parcelRegister("iRWay", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbca4c68100d735c$export$2e2bcd8739ae039; });

var $luZYw = parcelRequire("luZYw");
function $dbca4c68100d735c$export$2e2bcd8739ae039(scheme) {
    return (0, $luZYw.rgbBasis)(scheme[scheme.length - 1]);
}

});


parcelRegister("6rxmq", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $4b0f24737a26d9f4$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $4b0f24737a26d9f4$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $4b0f24737a26d9f4$export$3005042704f95a69 = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, $c1OIL.default));
var $4b0f24737a26d9f4$export$2e2bcd8739ae039 = (0, $iRWay.default)($4b0f24737a26d9f4$export$3005042704f95a69);

});

parcelRegister("f7Jtv", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $b02ac8d684257c07$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $b02ac8d684257c07$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $b02ac8d684257c07$export$3005042704f95a69 = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, $c1OIL.default));
var $b02ac8d684257c07$export$2e2bcd8739ae039 = (0, $iRWay.default)($b02ac8d684257c07$export$3005042704f95a69);

});

parcelRegister("9Oo40", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $724b7315788895fd$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $724b7315788895fd$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $724b7315788895fd$export$3005042704f95a69 = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, $c1OIL.default));
var $724b7315788895fd$export$2e2bcd8739ae039 = (0, $iRWay.default)($724b7315788895fd$export$3005042704f95a69);

});

parcelRegister("bJ09Y", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $88940571a49090a6$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $88940571a49090a6$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $88940571a49090a6$export$3005042704f95a69 = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, $c1OIL.default));
var $88940571a49090a6$export$2e2bcd8739ae039 = (0, $iRWay.default)($88940571a49090a6$export$3005042704f95a69);

});

parcelRegister("kjab6", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $ec8d7a22851dff21$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $ec8d7a22851dff21$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $ec8d7a22851dff21$export$3005042704f95a69 = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, $c1OIL.default));
var $ec8d7a22851dff21$export$2e2bcd8739ae039 = (0, $iRWay.default)($ec8d7a22851dff21$export$3005042704f95a69);

});

parcelRegister("dGwxN", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $9f68712eea8cd6ac$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $9f68712eea8cd6ac$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $9f68712eea8cd6ac$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, $c1OIL.default));
var $9f68712eea8cd6ac$export$2e2bcd8739ae039 = (0, $iRWay.default)($9f68712eea8cd6ac$export$3005042704f95a69);

});

parcelRegister("4e1XJ", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $3139fdec064b7c51$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $3139fdec064b7c51$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $3139fdec064b7c51$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, $c1OIL.default));
var $3139fdec064b7c51$export$2e2bcd8739ae039 = (0, $iRWay.default)($3139fdec064b7c51$export$3005042704f95a69);

});

parcelRegister("bgshW", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $833721ceefd949c4$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $833721ceefd949c4$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $833721ceefd949c4$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, $c1OIL.default));
var $833721ceefd949c4$export$2e2bcd8739ae039 = (0, $iRWay.default)($833721ceefd949c4$export$3005042704f95a69);

});

parcelRegister("4JKFE", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $372f913b55d41ecc$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $372f913b55d41ecc$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $372f913b55d41ecc$export$3005042704f95a69 = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, $c1OIL.default));
var $372f913b55d41ecc$export$2e2bcd8739ae039 = (0, $iRWay.default)($372f913b55d41ecc$export$3005042704f95a69);

});

parcelRegister("3rHLk", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $2825d6fdb7b61318$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $2825d6fdb7b61318$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $2825d6fdb7b61318$export$3005042704f95a69 = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, $c1OIL.default));
var $2825d6fdb7b61318$export$2e2bcd8739ae039 = (0, $iRWay.default)($2825d6fdb7b61318$export$3005042704f95a69);

});

parcelRegister("kPFfm", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $f2a890cad3a27696$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $f2a890cad3a27696$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $f2a890cad3a27696$export$3005042704f95a69 = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, $c1OIL.default));
var $f2a890cad3a27696$export$2e2bcd8739ae039 = (0, $iRWay.default)($f2a890cad3a27696$export$3005042704f95a69);

});

parcelRegister("bBI8W", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $87356452b311f839$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $87356452b311f839$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $87356452b311f839$export$3005042704f95a69 = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, $c1OIL.default));
var $87356452b311f839$export$2e2bcd8739ae039 = (0, $iRWay.default)($87356452b311f839$export$3005042704f95a69);

});

parcelRegister("6ISLE", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $4e5155d770ff652d$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $4e5155d770ff652d$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $4e5155d770ff652d$export$3005042704f95a69 = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, $c1OIL.default));
var $4e5155d770ff652d$export$2e2bcd8739ae039 = (0, $iRWay.default)($4e5155d770ff652d$export$3005042704f95a69);

});

parcelRegister("cn29s", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $90194d49605c0308$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $90194d49605c0308$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $90194d49605c0308$export$3005042704f95a69 = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, $c1OIL.default));
var $90194d49605c0308$export$2e2bcd8739ae039 = (0, $iRWay.default)($90194d49605c0308$export$3005042704f95a69);

});

parcelRegister("pafOw", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $04ba4a284749d9bd$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $04ba4a284749d9bd$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $04ba4a284749d9bd$export$3005042704f95a69 = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, $c1OIL.default));
var $04ba4a284749d9bd$export$2e2bcd8739ae039 = (0, $iRWay.default)($04ba4a284749d9bd$export$3005042704f95a69);

});

parcelRegister("apu7T", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $01f4b40ef05e1844$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $01f4b40ef05e1844$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $01f4b40ef05e1844$export$3005042704f95a69 = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, $c1OIL.default));
var $01f4b40ef05e1844$export$2e2bcd8739ae039 = (0, $iRWay.default)($01f4b40ef05e1844$export$3005042704f95a69);

});

parcelRegister("9l7m9", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $6ccbc8010af45a8e$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $6ccbc8010af45a8e$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $6ccbc8010af45a8e$export$3005042704f95a69 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, $c1OIL.default));
var $6ccbc8010af45a8e$export$2e2bcd8739ae039 = (0, $iRWay.default)($6ccbc8010af45a8e$export$3005042704f95a69);

});

parcelRegister("gmzux", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $be9a3b4b45a77417$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $be9a3b4b45a77417$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $be9a3b4b45a77417$export$3005042704f95a69 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, $c1OIL.default));
var $be9a3b4b45a77417$export$2e2bcd8739ae039 = (0, $iRWay.default)($be9a3b4b45a77417$export$3005042704f95a69);

});

parcelRegister("8PEwt", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $66e2852028a8e0c6$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $66e2852028a8e0c6$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $66e2852028a8e0c6$export$3005042704f95a69 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, $c1OIL.default));
var $66e2852028a8e0c6$export$2e2bcd8739ae039 = (0, $iRWay.default)($66e2852028a8e0c6$export$3005042704f95a69);

});

parcelRegister("9jRsc", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $6c8f5a395d15fa82$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $6c8f5a395d15fa82$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $6c8f5a395d15fa82$export$3005042704f95a69 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, $c1OIL.default));
var $6c8f5a395d15fa82$export$2e2bcd8739ae039 = (0, $iRWay.default)($6c8f5a395d15fa82$export$3005042704f95a69);

});

parcelRegister("bHgMR", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $8840bb703ed77f74$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $8840bb703ed77f74$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $8840bb703ed77f74$export$3005042704f95a69 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, $c1OIL.default));
var $8840bb703ed77f74$export$2e2bcd8739ae039 = (0, $iRWay.default)($8840bb703ed77f74$export$3005042704f95a69);

});

parcelRegister("jVPwB", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $e82b4ef470f808a2$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $e82b4ef470f808a2$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $e82b4ef470f808a2$export$3005042704f95a69 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, $c1OIL.default));
var $e82b4ef470f808a2$export$2e2bcd8739ae039 = (0, $iRWay.default)($e82b4ef470f808a2$export$3005042704f95a69);

});

parcelRegister("8DyZz", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $649d1bf6470207d9$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $649d1bf6470207d9$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $649d1bf6470207d9$export$3005042704f95a69 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, $c1OIL.default));
var $649d1bf6470207d9$export$2e2bcd8739ae039 = (0, $iRWay.default)($649d1bf6470207d9$export$3005042704f95a69);

});

parcelRegister("jYUGM", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $e8bf982b60493aee$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $e8bf982b60493aee$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $e8bf982b60493aee$export$3005042704f95a69 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, $c1OIL.default));
var $e8bf982b60493aee$export$2e2bcd8739ae039 = (0, $iRWay.default)($e8bf982b60493aee$export$3005042704f95a69);

});

parcelRegister("gjRxN", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $be17f4730443c624$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $be17f4730443c624$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $be17f4730443c624$export$3005042704f95a69 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, $c1OIL.default));
var $be17f4730443c624$export$2e2bcd8739ae039 = (0, $iRWay.default)($be17f4730443c624$export$3005042704f95a69);

});

parcelRegister("4TuoW", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $3903e186315f0f9e$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $3903e186315f0f9e$export$2e2bcd8739ae039; });

var $c1OIL = parcelRequire("c1OIL");

var $iRWay = parcelRequire("iRWay");
var $3903e186315f0f9e$export$3005042704f95a69 = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, $c1OIL.default));
var $3903e186315f0f9e$export$2e2bcd8739ae039 = (0, $iRWay.default)($3903e186315f0f9e$export$3005042704f95a69);

});

parcelRegister("3EQyk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a9ddf628b4d45f4$export$2e2bcd8739ae039; });
function $2a9ddf628b4d45f4$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}

});

parcelRegister("1zMZJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $125f10a46720bcdb$export$2e2bcd8739ae039; });

var $4phTB = parcelRequire("4phTB");

var $cxyfw = parcelRequire("cxyfw");
var $125f10a46720bcdb$export$2e2bcd8739ae039 = (0, $cxyfw.cubehelixLong)((0, $4phTB.default)(300, 0.5, 0.0), (0, $4phTB.default)(-240, 0.5, 1.0));

});

parcelRegister("frR0g", function(module, exports) {

$parcel$export(module.exports, "warm", function () { return $b3f27dfcd9dec59e$export$fc70efcec537be98; });
$parcel$export(module.exports, "cool", function () { return $b3f27dfcd9dec59e$export$c5cedbc1ab3be2c3; });
$parcel$export(module.exports, "default", function () { return $b3f27dfcd9dec59e$export$2e2bcd8739ae039; });

var $4phTB = parcelRequire("4phTB");

var $cxyfw = parcelRequire("cxyfw");
var $b3f27dfcd9dec59e$export$fc70efcec537be98 = (0, $cxyfw.cubehelixLong)((0, $4phTB.default)(-100, 0.75, 0.35), (0, $4phTB.default)(80, 1.50, 0.8));
var $b3f27dfcd9dec59e$export$c5cedbc1ab3be2c3 = (0, $cxyfw.cubehelixLong)((0, $4phTB.default)(260, 0.75, 0.35), (0, $4phTB.default)(80, 1.50, 0.8));
var $b3f27dfcd9dec59e$var$c = (0, $4phTB.default)();
function $b3f27dfcd9dec59e$export$2e2bcd8739ae039(t) {
    if (t < 0 || t > 1) t -= Math.floor(t);
    var ts = Math.abs(t - 0.5);
    $b3f27dfcd9dec59e$var$c.h = 360 * t - 100;
    $b3f27dfcd9dec59e$var$c.s = 1.5 - 1.5 * ts;
    $b3f27dfcd9dec59e$var$c.l = 0.8 - 0.9 * ts;
    return $b3f27dfcd9dec59e$var$c + "";
}

});

parcelRegister("2Lq2L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20342c4b269ec35e$export$2e2bcd8739ae039; });

var $1tQWc = parcelRequire("1tQWc");
var $20342c4b269ec35e$var$c = (0, $1tQWc.rgb)(), $20342c4b269ec35e$var$pi_1_3 = Math.PI / 3, $20342c4b269ec35e$var$pi_2_3 = Math.PI * 2 / 3;
function $20342c4b269ec35e$export$2e2bcd8739ae039(t) {
    var x;
    t = (0.5 - t) * Math.PI;
    $20342c4b269ec35e$var$c.r = 255 * (x = Math.sin(t)) * x;
    $20342c4b269ec35e$var$c.g = 255 * (x = Math.sin(t + $20342c4b269ec35e$var$pi_1_3)) * x;
    $20342c4b269ec35e$var$c.b = 255 * (x = Math.sin(t + $20342c4b269ec35e$var$pi_2_3)) * x;
    return $20342c4b269ec35e$var$c + "";
}

});

parcelRegister("i4Jnh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d28bcc238e58ecac$export$2e2bcd8739ae039; });
function $d28bcc238e58ecac$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}

});

parcelRegister("j2wY7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddc7c718e0c3feb8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "magma", function () { return $ddc7c718e0c3feb8$export$c41e69203f572e8d; });
$parcel$export(module.exports, "inferno", function () { return $ddc7c718e0c3feb8$export$ad0c8285c8ea6dbd; });
$parcel$export(module.exports, "plasma", function () { return $ddc7c718e0c3feb8$export$6664860a633d9daf; });

var $c1OIL = parcelRequire("c1OIL");
function $ddc7c718e0c3feb8$var$ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
var $ddc7c718e0c3feb8$export$2e2bcd8739ae039 = $ddc7c718e0c3feb8$var$ramp((0, $c1OIL.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var $ddc7c718e0c3feb8$export$c41e69203f572e8d = $ddc7c718e0c3feb8$var$ramp((0, $c1OIL.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var $ddc7c718e0c3feb8$export$ad0c8285c8ea6dbd = $ddc7c718e0c3feb8$var$ramp((0, $c1OIL.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var $ddc7c718e0c3feb8$export$6664860a633d9daf = $ddc7c718e0c3feb8$var$ramp((0, $c1OIL.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

});


parcelRegister("9SrVX", function(module, exports) {

$parcel$export(module.exports, "create", function () { return (parcelRequire("EPpQG")).default; });
$parcel$export(module.exports, "creator", function () { return (parcelRequire("7B5E9")).default; });
$parcel$export(module.exports, "local", function () { return (parcelRequire("iRFxf")).default; });
$parcel$export(module.exports, "matcher", function () { return (parcelRequire("918kN")).default; });
$parcel$export(module.exports, "mouse", function () { return (parcelRequire("5HV9y")).default; });
$parcel$export(module.exports, "namespace", function () { return (parcelRequire("hMW9k")).default; });
$parcel$export(module.exports, "namespaces", function () { return (parcelRequire("cOfvW")).default; });
$parcel$export(module.exports, "clientPoint", function () { return (parcelRequire("ejqBC")).default; });
$parcel$export(module.exports, "select", function () { return (parcelRequire("ivpDr")).default; });
$parcel$export(module.exports, "selectAll", function () { return (parcelRequire("6M9sf")).default; });
$parcel$export(module.exports, "selection", function () { return (parcelRequire("89bZp")).default; });
$parcel$export(module.exports, "selector", function () { return (parcelRequire("jiCaU")).default; });
$parcel$export(module.exports, "selectorAll", function () { return (parcelRequire("5IoPJ")).default; });
$parcel$export(module.exports, "style", function () { return (parcelRequire("itJL7")).styleValue; });
$parcel$export(module.exports, "touch", function () { return (parcelRequire("lTUhy")).default; });
$parcel$export(module.exports, "touches", function () { return (parcelRequire("hkIkc")).default; });
$parcel$export(module.exports, "window", function () { return (parcelRequire("kjaK1")).default; });
$parcel$export(module.exports, "event", function () { return (parcelRequire("fvaBb")).event; });
$parcel$export(module.exports, "customEvent", function () { return (parcelRequire("fvaBb")).customEvent; });

var $EPpQG = parcelRequire("EPpQG");

var $7B5E9 = parcelRequire("7B5E9");

var $iRFxf = parcelRequire("iRFxf");

var $918kN = parcelRequire("918kN");

var $5HV9y = parcelRequire("5HV9y");

var $hMW9k = parcelRequire("hMW9k");

var $cOfvW = parcelRequire("cOfvW");

var $ejqBC = parcelRequire("ejqBC");

var $ivpDr = parcelRequire("ivpDr");

var $6M9sf = parcelRequire("6M9sf");

var $89bZp = parcelRequire("89bZp");

var $jiCaU = parcelRequire("jiCaU");

var $5IoPJ = parcelRequire("5IoPJ");

var $itJL7 = parcelRequire("itJL7");

var $lTUhy = parcelRequire("lTUhy");

var $hkIkc = parcelRequire("hkIkc");

var $kjaK1 = parcelRequire("kjaK1");

var $fvaBb = parcelRequire("fvaBb");

});
parcelRegister("EPpQG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07ab9eabee9c0274$export$2e2bcd8739ae039; });

var $7B5E9 = parcelRequire("7B5E9");

var $ivpDr = parcelRequire("ivpDr");
function $07ab9eabee9c0274$export$2e2bcd8739ae039(name) {
    return (0, $ivpDr.default)((0, $7B5E9.default)(name).call(document.documentElement));
}

});

parcelRegister("iRFxf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbbd6548f6755e9d$export$2e2bcd8739ae039; });
var $dbbd6548f6755e9d$var$nextId = 0;
function $dbbd6548f6755e9d$export$2e2bcd8739ae039() {
    return new $dbbd6548f6755e9d$var$Local;
}
function $dbbd6548f6755e9d$var$Local() {
    this._ = "@" + (++$dbbd6548f6755e9d$var$nextId).toString(36);
}
$dbbd6548f6755e9d$var$Local.prototype = $dbbd6548f6755e9d$export$2e2bcd8739ae039.prototype = {
    constructor: $dbbd6548f6755e9d$var$Local,
    get: function(node) {
        var id = this._;
        while(!(id in node))if (!(node = node.parentNode)) return;
        return node[id];
    },
    set: function(node, value) {
        return node[this._] = value;
    },
    remove: function(node) {
        return this._ in node && delete node[this._];
    },
    toString: function() {
        return this._;
    }
};

});

parcelRegister("6M9sf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4eee8f3e49a380ba$export$2e2bcd8739ae039; });

var $89bZp = parcelRequire("89bZp");
function $4eee8f3e49a380ba$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $89bZp.Selection)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $89bZp.Selection)([
        selector == null ? [] : selector
    ], (0, $89bZp.root));
}

});

parcelRegister("hkIkc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9e6afe4b6b3ff1c$export$2e2bcd8739ae039; });

var $5Psfu = parcelRequire("5Psfu");

var $ejqBC = parcelRequire("ejqBC");
function $c9e6afe4b6b3ff1c$export$2e2bcd8739ae039(node, touches) {
    if (touches == null) touches = (0, $5Psfu.default)().touches;
    for(var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i)points[i] = (0, $ejqBC.default)(node, touches[i]);
    return points;
}

});


parcelRegister("i7aSK", function(module, exports) {

$parcel$export(module.exports, "arc", function () { return (parcelRequire("fQ5ps")).default; });
$parcel$export(module.exports, "area", function () { return (parcelRequire("i7gdd")).default; });
$parcel$export(module.exports, "line", function () { return (parcelRequire("204Rl")).default; });
$parcel$export(module.exports, "pie", function () { return (parcelRequire("kmyFM")).default; });
$parcel$export(module.exports, "areaRadial", function () { return (parcelRequire("8lOdX")).default; });
$parcel$export(module.exports, "radialArea", function () { return (parcelRequire("8lOdX")).default; });
$parcel$export(module.exports, "lineRadial", function () { return (parcelRequire("7hGP5")).default; });
$parcel$export(module.exports, "radialLine", function () { return (parcelRequire("7hGP5")).default; });
$parcel$export(module.exports, "pointRadial", function () { return (parcelRequire("fV61s")).default; });
$parcel$export(module.exports, "linkHorizontal", function () { return (parcelRequire("bemvB")).linkHorizontal; });
$parcel$export(module.exports, "linkVertical", function () { return (parcelRequire("bemvB")).linkVertical; });
$parcel$export(module.exports, "linkRadial", function () { return (parcelRequire("bemvB")).linkRadial; });
$parcel$export(module.exports, "symbol", function () { return (parcelRequire("6wud0")).default; });
$parcel$export(module.exports, "symbols", function () { return (parcelRequire("6wud0")).symbols; });
$parcel$export(module.exports, "symbolCircle", function () { return (parcelRequire("l66xy")).default; });
$parcel$export(module.exports, "symbolCross", function () { return (parcelRequire("01Nlb")).default; });
$parcel$export(module.exports, "symbolDiamond", function () { return (parcelRequire("lxwl6")).default; });
$parcel$export(module.exports, "symbolSquare", function () { return (parcelRequire("c476H")).default; });
$parcel$export(module.exports, "symbolStar", function () { return (parcelRequire("8mdz9")).default; });
$parcel$export(module.exports, "symbolTriangle", function () { return (parcelRequire("lOLK2")).default; });
$parcel$export(module.exports, "symbolWye", function () { return (parcelRequire("j8a1d")).default; });
$parcel$export(module.exports, "curveBasisClosed", function () { return (parcelRequire("8INXB")).default; });
$parcel$export(module.exports, "curveBasisOpen", function () { return (parcelRequire("8nweQ")).default; });
$parcel$export(module.exports, "curveBasis", function () { return (parcelRequire("bUFg2")).default; });
$parcel$export(module.exports, "curveBundle", function () { return (parcelRequire("62VVA")).default; });
$parcel$export(module.exports, "curveCardinalClosed", function () { return (parcelRequire("fBy5e")).default; });
$parcel$export(module.exports, "curveCardinalOpen", function () { return (parcelRequire("d3NRi")).default; });
$parcel$export(module.exports, "curveCardinal", function () { return (parcelRequire("emMsn")).default; });
$parcel$export(module.exports, "curveCatmullRomClosed", function () { return (parcelRequire("3NGfY")).default; });
$parcel$export(module.exports, "curveCatmullRomOpen", function () { return (parcelRequire("ge2Ks")).default; });
$parcel$export(module.exports, "curveCatmullRom", function () { return (parcelRequire("dYto6")).default; });
$parcel$export(module.exports, "curveLinearClosed", function () { return (parcelRequire("jJTJ3")).default; });
$parcel$export(module.exports, "curveLinear", function () { return (parcelRequire("8gFhj")).default; });
$parcel$export(module.exports, "curveMonotoneX", function () { return (parcelRequire("e4wcM")).monotoneX; });
$parcel$export(module.exports, "curveMonotoneY", function () { return (parcelRequire("e4wcM")).monotoneY; });
$parcel$export(module.exports, "curveNatural", function () { return (parcelRequire("gdfBz")).default; });
$parcel$export(module.exports, "curveStep", function () { return (parcelRequire("5O513")).default; });
$parcel$export(module.exports, "curveStepAfter", function () { return (parcelRequire("5O513")).stepAfter; });
$parcel$export(module.exports, "curveStepBefore", function () { return (parcelRequire("5O513")).stepBefore; });
$parcel$export(module.exports, "stack", function () { return (parcelRequire("iE2cX")).default; });
$parcel$export(module.exports, "stackOffsetExpand", function () { return (parcelRequire("jEt2S")).default; });
$parcel$export(module.exports, "stackOffsetDiverging", function () { return (parcelRequire("dfxGw")).default; });
$parcel$export(module.exports, "stackOffsetNone", function () { return (parcelRequire("4AcDE")).default; });
$parcel$export(module.exports, "stackOffsetSilhouette", function () { return (parcelRequire("9rRGY")).default; });
$parcel$export(module.exports, "stackOffsetWiggle", function () { return (parcelRequire("fwp4P")).default; });
$parcel$export(module.exports, "stackOrderAppearance", function () { return (parcelRequire("j0hzK")).default; });
$parcel$export(module.exports, "stackOrderAscending", function () { return (parcelRequire("cv1za")).default; });
$parcel$export(module.exports, "stackOrderDescending", function () { return (parcelRequire("fXnyz")).default; });
$parcel$export(module.exports, "stackOrderInsideOut", function () { return (parcelRequire("6Hjnx")).default; });
$parcel$export(module.exports, "stackOrderNone", function () { return (parcelRequire("7pvHl")).default; });
$parcel$export(module.exports, "stackOrderReverse", function () { return (parcelRequire("7Fl3L")).default; });

var $fQ5ps = parcelRequire("fQ5ps");

var $i7gdd = parcelRequire("i7gdd");

var $204Rl = parcelRequire("204Rl");

var $kmyFM = parcelRequire("kmyFM");

var $8lOdX = parcelRequire("8lOdX");

var $7hGP5 = parcelRequire("7hGP5");

var $fV61s = parcelRequire("fV61s");

var $bemvB = parcelRequire("bemvB");

var $6wud0 = parcelRequire("6wud0");

var $l66xy = parcelRequire("l66xy");

var $01Nlb = parcelRequire("01Nlb");

var $lxwl6 = parcelRequire("lxwl6");

var $c476H = parcelRequire("c476H");

var $8mdz9 = parcelRequire("8mdz9");

var $lOLK2 = parcelRequire("lOLK2");

var $j8a1d = parcelRequire("j8a1d");

var $8INXB = parcelRequire("8INXB");

var $8nweQ = parcelRequire("8nweQ");

var $bUFg2 = parcelRequire("bUFg2");

var $62VVA = parcelRequire("62VVA");

var $fBy5e = parcelRequire("fBy5e");

var $d3NRi = parcelRequire("d3NRi");

var $emMsn = parcelRequire("emMsn");

var $3NGfY = parcelRequire("3NGfY");

var $ge2Ks = parcelRequire("ge2Ks");

var $dYto6 = parcelRequire("dYto6");

var $jJTJ3 = parcelRequire("jJTJ3");

var $8gFhj = parcelRequire("8gFhj");

var $e4wcM = parcelRequire("e4wcM");

var $gdfBz = parcelRequire("gdfBz");

var $5O513 = parcelRequire("5O513");

var $iE2cX = parcelRequire("iE2cX");

var $jEt2S = parcelRequire("jEt2S");

var $dfxGw = parcelRequire("dfxGw");

var $4AcDE = parcelRequire("4AcDE");

var $9rRGY = parcelRequire("9rRGY");

var $fwp4P = parcelRequire("fwp4P");

var $j0hzK = parcelRequire("j0hzK");

var $cv1za = parcelRequire("cv1za");

var $fXnyz = parcelRequire("fXnyz");

var $6Hjnx = parcelRequire("6Hjnx");

var $7pvHl = parcelRequire("7pvHl");

var $7Fl3L = parcelRequire("7Fl3L");

});
parcelRegister("fQ5ps", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b87fe88f46c998a6$export$2e2bcd8739ae039; });

var $2XIUS = parcelRequire("2XIUS");

var $iLMZb = parcelRequire("iLMZb");

var $4yPBQ = parcelRequire("4yPBQ");
function $b87fe88f46c998a6$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $b87fe88f46c998a6$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $b87fe88f46c998a6$var$arcStartAngle(d) {
    return d.startAngle;
}
function $b87fe88f46c998a6$var$arcEndAngle(d) {
    return d.endAngle;
}
function $b87fe88f46c998a6$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $b87fe88f46c998a6$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $4yPBQ.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $b87fe88f46c998a6$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $4yPBQ.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $4yPBQ.sqrt)((0, $4yPBQ.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $b87fe88f46c998a6$export$2e2bcd8739ae039() {
    var innerRadius = $b87fe88f46c998a6$var$arcInnerRadius, outerRadius = $b87fe88f46c998a6$var$arcOuterRadius, cornerRadius = (0, $iLMZb.default)(0), padRadius = null, startAngle = $b87fe88f46c998a6$var$arcStartAngle, endAngle = $b87fe88f46c998a6$var$arcEndAngle, padAngle = $b87fe88f46c998a6$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $4yPBQ.halfPi), a1 = endAngle.apply(this, arguments) - (0, $4yPBQ.halfPi), da = (0, $4yPBQ.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $2XIUS.default)();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $4yPBQ.epsilon))) context.moveTo(0, 0);
        else if (da > (0, $4yPBQ.tau) - (0, $4yPBQ.epsilon)) {
            context.moveTo(r1 * (0, $4yPBQ.cos)(a0), r1 * (0, $4yPBQ.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $4yPBQ.epsilon)) {
                context.moveTo(r0 * (0, $4yPBQ.cos)(a1), r0 * (0, $4yPBQ.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $4yPBQ.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, $4yPBQ.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $4yPBQ.min)((0, $4yPBQ.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $4yPBQ.epsilon)) {
                var p0 = (0, $4yPBQ.asin)(rp / r0 * (0, $4yPBQ.sin)(ap)), p1 = (0, $4yPBQ.asin)(rp / r1 * (0, $4yPBQ.sin)(ap));
                if ((da0 -= p0 * 2) > (0, $4yPBQ.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $4yPBQ.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $4yPBQ.cos)(a01), y01 = r1 * (0, $4yPBQ.sin)(a01), x10 = r0 * (0, $4yPBQ.cos)(a10), y10 = r0 * (0, $4yPBQ.sin)(a10);
            // Apply rounded corners?
            if (rc > (0, $4yPBQ.epsilon)) {
                var x11 = r1 * (0, $4yPBQ.cos)(a11), y11 = r1 * (0, $4yPBQ.sin)(a11), x00 = r0 * (0, $4yPBQ.cos)(a00), y00 = r0 * (0, $4yPBQ.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle.
                if (da < (0, $4yPBQ.pi) && (oc = $b87fe88f46c998a6$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $4yPBQ.sin)((0, $4yPBQ.acos)((ax * bx + ay * by) / ((0, $4yPBQ.sqrt)(ax * ax + ay * ay) * (0, $4yPBQ.sqrt)(bx * bx + by * by))) / 2), lc = (0, $4yPBQ.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $4yPBQ.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $4yPBQ.min)(rc, (r1 - lc) / (kc + 1));
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $4yPBQ.epsilon))) context.moveTo(x01, y01);
            else if (rc1 > (0, $4yPBQ.epsilon)) {
                t0 = $b87fe88f46c998a6$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $b87fe88f46c998a6$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $4yPBQ.atan2)(t0.y01, t0.x01), (0, $4yPBQ.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $4yPBQ.atan2)(t0.y01, t0.x01), (0, $4yPBQ.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $4yPBQ.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $4yPBQ.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $4yPBQ.atan2)(t1.y11, t1.x11), (0, $4yPBQ.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $4yPBQ.epsilon)) || !(da0 > (0, $4yPBQ.epsilon))) context.lineTo(x10, y10);
            else if (rc0 > (0, $4yPBQ.epsilon)) {
                t0 = $b87fe88f46c998a6$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $b87fe88f46c998a6$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $4yPBQ.atan2)(t0.y01, t0.x01), (0, $4yPBQ.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $4yPBQ.atan2)(t0.y01, t0.x01), (0, $4yPBQ.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $4yPBQ.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $4yPBQ.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $4yPBQ.atan2)(t1.y11, t1.x11), (0, $4yPBQ.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $4yPBQ.pi) / 2;
        return [
            (0, $4yPBQ.cos)(a) * r,
            (0, $4yPBQ.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("iLMZb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $daa29d5b1d6b2092$export$2e2bcd8739ae039; });
function $daa29d5b1d6b2092$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("4yPBQ", function(module, exports) {

$parcel$export(module.exports, "abs", function () { return $35225ef339569c07$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "atan2", function () { return $35225ef339569c07$export$b8b770ee6a0d9760; });
$parcel$export(module.exports, "cos", function () { return $35225ef339569c07$export$50d414a77b60d802; });
$parcel$export(module.exports, "max", function () { return $35225ef339569c07$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $35225ef339569c07$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "sin", function () { return $35225ef339569c07$export$5de3937cb4b592ed; });
$parcel$export(module.exports, "sqrt", function () { return $35225ef339569c07$export$eba8049fb5020b81; });
$parcel$export(module.exports, "epsilon", function () { return $35225ef339569c07$export$6c421550c66a327d; });
$parcel$export(module.exports, "pi", function () { return $35225ef339569c07$export$18c7bea995a110f; });
$parcel$export(module.exports, "halfPi", function () { return $35225ef339569c07$export$e51408a300e8929a; });
$parcel$export(module.exports, "tau", function () { return $35225ef339569c07$export$a4b4b4d4d776fe92; });
$parcel$export(module.exports, "acos", function () { return $35225ef339569c07$export$fd6306be3fde5b04; });
$parcel$export(module.exports, "asin", function () { return $35225ef339569c07$export$41726bdb1fc63f; });
var $35225ef339569c07$export$2335f513bbd82c6d = Math.abs;
var $35225ef339569c07$export$b8b770ee6a0d9760 = Math.atan2;
var $35225ef339569c07$export$50d414a77b60d802 = Math.cos;
var $35225ef339569c07$export$8960430cfd85939f = Math.max;
var $35225ef339569c07$export$96ec731ed4dcb222 = Math.min;
var $35225ef339569c07$export$5de3937cb4b592ed = Math.sin;
var $35225ef339569c07$export$eba8049fb5020b81 = Math.sqrt;
var $35225ef339569c07$export$6c421550c66a327d = 1e-12;
var $35225ef339569c07$export$18c7bea995a110f = Math.PI;
var $35225ef339569c07$export$e51408a300e8929a = $35225ef339569c07$export$18c7bea995a110f / 2;
var $35225ef339569c07$export$a4b4b4d4d776fe92 = 2 * $35225ef339569c07$export$18c7bea995a110f;
function $35225ef339569c07$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $35225ef339569c07$export$18c7bea995a110f : Math.acos(x);
}
function $35225ef339569c07$export$41726bdb1fc63f(x) {
    return x >= 1 ? $35225ef339569c07$export$e51408a300e8929a : x <= -1 ? -$35225ef339569c07$export$e51408a300e8929a : Math.asin(x);
}

});


parcelRegister("i7gdd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d30574d09f1dcc18$export$2e2bcd8739ae039; });

var $2XIUS = parcelRequire("2XIUS");

var $iLMZb = parcelRequire("iLMZb");

var $8gFhj = parcelRequire("8gFhj");

var $204Rl = parcelRequire("204Rl");

var $jiDA0 = parcelRequire("jiDA0");
function $d30574d09f1dcc18$export$2e2bcd8739ae039() {
    var x0 = (0, $jiDA0.x), x1 = null, y0 = (0, $iLMZb.default)(0), y1 = (0, $jiDA0.y), defined = (0, $iLMZb.default)(true), context = null, curve = (0, $8gFhj.default), output = null;
    function area(data) {
        var i, j, k, n = data.length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $2XIUS.default)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $204Rl.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $iLMZb.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("8gFhj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $604fd653e4bbe463$export$2e2bcd8739ae039; });
function $604fd653e4bbe463$var$Linear(context) {
    this._context = context;
}
$604fd653e4bbe463$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $604fd653e4bbe463$export$2e2bcd8739ae039(context) {
    return new $604fd653e4bbe463$var$Linear(context);
}

});

parcelRegister("204Rl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $174f59d7958167f4$export$2e2bcd8739ae039; });

var $2XIUS = parcelRequire("2XIUS");

var $iLMZb = parcelRequire("iLMZb");

var $8gFhj = parcelRequire("8gFhj");

var $jiDA0 = parcelRequire("jiDA0");
function $174f59d7958167f4$export$2e2bcd8739ae039() {
    var x = (0, $jiDA0.x), y = (0, $jiDA0.y), defined = (0, $iLMZb.default)(true), context = null, curve = (0, $8gFhj.default), output = null;
    function line(data) {
        var i, n = data.length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $2XIUS.default)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $iLMZb.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("jiDA0", function(module, exports) {

$parcel$export(module.exports, "x", function () { return $e0ce667ae06f073b$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "y", function () { return $e0ce667ae06f073b$export$4a5767248b18ef41; });
function $e0ce667ae06f073b$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $e0ce667ae06f073b$export$4a5767248b18ef41(p) {
    return p[1];
}

});



parcelRegister("kmyFM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed30c20e7922b910$export$2e2bcd8739ae039; });

var $iLMZb = parcelRequire("iLMZb");

var $eVVvO = parcelRequire("eVVvO");

var $l8799 = parcelRequire("l8799");

var $4yPBQ = parcelRequire("4yPBQ");
function $ed30c20e7922b910$export$2e2bcd8739ae039() {
    var value = (0, $l8799.default), sortValues = (0, $eVVvO.default), sort = null, startAngle = (0, $iLMZb.default)(0), endAngle = (0, $iLMZb.default)((0, $4yPBQ.tau)), padAngle = (0, $iLMZb.default)(0);
    function pie(data) {
        var i, n = data.length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $4yPBQ.tau), Math.max(-(0, $4yPBQ.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("eVVvO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adf300414f61b3b6$export$2e2bcd8739ae039; });
function $adf300414f61b3b6$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("l8799", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f61fe3822a1d259b$export$2e2bcd8739ae039; });
function $f61fe3822a1d259b$export$2e2bcd8739ae039(d) {
    return d;
}

});


parcelRegister("8lOdX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61473e5b3d486de9$export$2e2bcd8739ae039; });

var $bnlme = parcelRequire("bnlme");

var $i7gdd = parcelRequire("i7gdd");

var $7hGP5 = parcelRequire("7hGP5");
function $61473e5b3d486de9$export$2e2bcd8739ae039() {
    var a = (0, $i7gdd.default)().curve((0, $bnlme.curveRadialLinear)), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $7hGP5.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $7hGP5.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $7hGP5.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $7hGP5.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $bnlme.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("bnlme", function(module, exports) {

$parcel$export(module.exports, "curveRadialLinear", function () { return $848268deb00cb926$export$22d25ffb9fb15b6f; });
$parcel$export(module.exports, "default", function () { return $848268deb00cb926$export$2e2bcd8739ae039; });

var $8gFhj = parcelRequire("8gFhj");
var $848268deb00cb926$export$22d25ffb9fb15b6f = $848268deb00cb926$export$2e2bcd8739ae039((0, $8gFhj.default));
function $848268deb00cb926$var$Radial(curve) {
    this._curve = curve;
}
$848268deb00cb926$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $848268deb00cb926$export$2e2bcd8739ae039(curve) {
    function radial(context) {
        return new $848268deb00cb926$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("7hGP5", function(module, exports) {

$parcel$export(module.exports, "lineRadial", function () { return $54db56ab1877e674$export$4d8815a75dc8cd4d; });
$parcel$export(module.exports, "default", function () { return $54db56ab1877e674$export$2e2bcd8739ae039; });

var $bnlme = parcelRequire("bnlme");

var $204Rl = parcelRequire("204Rl");
function $54db56ab1877e674$export$4d8815a75dc8cd4d(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $bnlme.default)(_)) : c()._curve;
    };
    return l;
}
function $54db56ab1877e674$export$2e2bcd8739ae039() {
    return $54db56ab1877e674$export$4d8815a75dc8cd4d((0, $204Rl.default)().curve((0, $bnlme.curveRadialLinear)));
}

});


parcelRegister("fV61s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b970d9d56d74fc36$export$2e2bcd8739ae039; });
function $b970d9d56d74fc36$export$2e2bcd8739ae039(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("bemvB", function(module, exports) {

$parcel$export(module.exports, "linkHorizontal", function () { return $82d2764ddcbf13ca$export$e7c381889b2cd14d; });
$parcel$export(module.exports, "linkVertical", function () { return $82d2764ddcbf13ca$export$75de4c8c66884e04; });
$parcel$export(module.exports, "linkRadial", function () { return $82d2764ddcbf13ca$export$7739cfe68d4e0799; });

var $2XIUS = parcelRequire("2XIUS");

var $5sI1Z = parcelRequire("5sI1Z");

var $iLMZb = parcelRequire("iLMZb");

var $jiDA0 = parcelRequire("jiDA0");

var $fV61s = parcelRequire("fV61s");
function $82d2764ddcbf13ca$var$linkSource(d) {
    return d.source;
}
function $82d2764ddcbf13ca$var$linkTarget(d) {
    return d.target;
}
function $82d2764ddcbf13ca$var$link(curve) {
    var source = $82d2764ddcbf13ca$var$linkSource, target = $82d2764ddcbf13ca$var$linkTarget, x = (0, $jiDA0.x), y = (0, $jiDA0.y), context = null;
    function link() {
        var buffer, argv = (0, $5sI1Z.slice).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
        if (!context) context = buffer = (0, $2XIUS.default)();
        curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
        if (buffer) return context = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, link) : context;
    };
    return link;
}
function $82d2764ddcbf13ca$var$curveHorizontal(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}
function $82d2764ddcbf13ca$var$curveVertical(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}
function $82d2764ddcbf13ca$var$curveRadial(context, x0, y0, x1, y1) {
    var p0 = (0, $fV61s.default)(x0, y0), p1 = (0, $fV61s.default)(x0, y0 = (y0 + y1) / 2), p2 = (0, $fV61s.default)(x1, y0), p3 = (0, $fV61s.default)(x1, y1);
    context.moveTo(p0[0], p0[1]);
    context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}
function $82d2764ddcbf13ca$export$e7c381889b2cd14d() {
    return $82d2764ddcbf13ca$var$link($82d2764ddcbf13ca$var$curveHorizontal);
}
function $82d2764ddcbf13ca$export$75de4c8c66884e04() {
    return $82d2764ddcbf13ca$var$link($82d2764ddcbf13ca$var$curveVertical);
}
function $82d2764ddcbf13ca$export$7739cfe68d4e0799() {
    var l = $82d2764ddcbf13ca$var$link($82d2764ddcbf13ca$var$curveRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("5sI1Z", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $3fa1b8e94adeb982$export$58adb3bec8346d0f; });
var $3fa1b8e94adeb982$export$58adb3bec8346d0f = Array.prototype.slice;

});


parcelRegister("6wud0", function(module, exports) {

$parcel$export(module.exports, "symbols", function () { return $4bfd2a11fe1b1b9c$export$47616e9f7f5fe113; });
$parcel$export(module.exports, "default", function () { return $4bfd2a11fe1b1b9c$export$2e2bcd8739ae039; });

var $2XIUS = parcelRequire("2XIUS");

var $l66xy = parcelRequire("l66xy");

var $01Nlb = parcelRequire("01Nlb");

var $lxwl6 = parcelRequire("lxwl6");

var $8mdz9 = parcelRequire("8mdz9");

var $c476H = parcelRequire("c476H");

var $lOLK2 = parcelRequire("lOLK2");

var $j8a1d = parcelRequire("j8a1d");

var $iLMZb = parcelRequire("iLMZb");
var $4bfd2a11fe1b1b9c$export$47616e9f7f5fe113 = [
    (0, $l66xy.default),
    (0, $01Nlb.default),
    (0, $lxwl6.default),
    (0, $c476H.default),
    (0, $8mdz9.default),
    (0, $lOLK2.default),
    (0, $j8a1d.default)
];
function $4bfd2a11fe1b1b9c$export$2e2bcd8739ae039() {
    var type = (0, $iLMZb.default)((0, $l66xy.default)), size = (0, $iLMZb.default)(64), context = null;
    function symbol() {
        var buffer;
        if (!context) context = buffer = (0, $2XIUS.default)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $iLMZb.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("l66xy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5bf3b44999085fb$export$2e2bcd8739ae039; });

var $4yPBQ = parcelRequire("4yPBQ");
var $f5bf3b44999085fb$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / (0, $4yPBQ.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, $4yPBQ.tau));
    }
};

});

parcelRegister("01Nlb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00565e26c7fc5be0$export$2e2bcd8739ae039; });
var $00565e26c7fc5be0$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

});

parcelRegister("lxwl6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fae5c3fb74081a20$export$2e2bcd8739ae039; });
var $fae5c3fb74081a20$var$tan30 = Math.sqrt(1 / 3), $fae5c3fb74081a20$var$tan30_2 = $fae5c3fb74081a20$var$tan30 * 2;
var $fae5c3fb74081a20$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var y = Math.sqrt(size / $fae5c3fb74081a20$var$tan30_2), x = y * $fae5c3fb74081a20$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

});

parcelRegister("8mdz9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $615ae6be541f1c53$export$2e2bcd8739ae039; });

var $4yPBQ = parcelRequire("4yPBQ");
var $615ae6be541f1c53$var$ka = 0.89081309152928522810, $615ae6be541f1c53$var$kr = Math.sin((0, $4yPBQ.pi) / 10) / Math.sin(7 * (0, $4yPBQ.pi) / 10), $615ae6be541f1c53$var$kx = Math.sin((0, $4yPBQ.tau) / 10) * $615ae6be541f1c53$var$kr, $615ae6be541f1c53$var$ky = -Math.cos((0, $4yPBQ.tau) / 10) * $615ae6be541f1c53$var$kr;
var $615ae6be541f1c53$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size * $615ae6be541f1c53$var$ka), x = $615ae6be541f1c53$var$kx * r, y = $615ae6be541f1c53$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(var i = 1; i < 5; ++i){
            var a = (0, $4yPBQ.tau) * i / 5, c = Math.cos(a), s = Math.sin(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

});

parcelRegister("c476H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c8b5f141f5b4f7e$export$2e2bcd8739ae039; });
var $8c8b5f141f5b4f7e$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var w = Math.sqrt(size), x = -w / 2;
        context.rect(x, x, w, w);
    }
};

});

parcelRegister("lOLK2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe234cf6f2778f5d$export$2e2bcd8739ae039; });
var $fe234cf6f2778f5d$var$sqrt3 = Math.sqrt(3);
var $fe234cf6f2778f5d$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var y = -Math.sqrt(size / ($fe234cf6f2778f5d$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$fe234cf6f2778f5d$var$sqrt3 * y, -y);
        context.lineTo($fe234cf6f2778f5d$var$sqrt3 * y, -y);
        context.closePath();
    }
};

});

parcelRegister("j8a1d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ded6892d7d2d30f1$export$2e2bcd8739ae039; });
var $ded6892d7d2d30f1$var$c = -0.5, $ded6892d7d2d30f1$var$s = Math.sqrt(3) / 2, $ded6892d7d2d30f1$var$k = 1 / Math.sqrt(12), $ded6892d7d2d30f1$var$a = ($ded6892d7d2d30f1$var$k / 2 + 1) * 3;
var $ded6892d7d2d30f1$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / $ded6892d7d2d30f1$var$a), x0 = r / 2, y0 = r * $ded6892d7d2d30f1$var$k, x1 = x0, y1 = r * $ded6892d7d2d30f1$var$k + r, x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($ded6892d7d2d30f1$var$c * x0 - $ded6892d7d2d30f1$var$s * y0, $ded6892d7d2d30f1$var$s * x0 + $ded6892d7d2d30f1$var$c * y0);
        context.lineTo($ded6892d7d2d30f1$var$c * x1 - $ded6892d7d2d30f1$var$s * y1, $ded6892d7d2d30f1$var$s * x1 + $ded6892d7d2d30f1$var$c * y1);
        context.lineTo($ded6892d7d2d30f1$var$c * x2 - $ded6892d7d2d30f1$var$s * y2, $ded6892d7d2d30f1$var$s * x2 + $ded6892d7d2d30f1$var$c * y2);
        context.lineTo($ded6892d7d2d30f1$var$c * x0 + $ded6892d7d2d30f1$var$s * y0, $ded6892d7d2d30f1$var$c * y0 - $ded6892d7d2d30f1$var$s * x0);
        context.lineTo($ded6892d7d2d30f1$var$c * x1 + $ded6892d7d2d30f1$var$s * y1, $ded6892d7d2d30f1$var$c * y1 - $ded6892d7d2d30f1$var$s * x1);
        context.lineTo($ded6892d7d2d30f1$var$c * x2 + $ded6892d7d2d30f1$var$s * y2, $ded6892d7d2d30f1$var$c * y2 - $ded6892d7d2d30f1$var$s * x2);
        context.closePath();
    }
};

});


parcelRegister("8INXB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65992fe420daf471$export$2e2bcd8739ae039; });

var $jV246 = parcelRequire("jV246");

var $bUFg2 = parcelRequire("bUFg2");
function $65992fe420daf471$var$BasisClosed(context) {
    this._context = context;
}
$65992fe420daf471$var$BasisClosed.prototype = {
    areaStart: (0, $jV246.default),
    areaEnd: (0, $jV246.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $bUFg2.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $65992fe420daf471$export$2e2bcd8739ae039(context) {
    return new $65992fe420daf471$var$BasisClosed(context);
}

});
parcelRegister("jV246", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e804f14446a9edaa$export$2e2bcd8739ae039; });
function $e804f14446a9edaa$export$2e2bcd8739ae039() {}

});

parcelRegister("bUFg2", function(module, exports) {

$parcel$export(module.exports, "point", function () { return $8ac4ed992c4f3772$export$105684a3041cb6f3; });
$parcel$export(module.exports, "Basis", function () { return $8ac4ed992c4f3772$export$957f7263e89bedd2; });
$parcel$export(module.exports, "default", function () { return $8ac4ed992c4f3772$export$2e2bcd8739ae039; });
function $8ac4ed992c4f3772$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $8ac4ed992c4f3772$export$957f7263e89bedd2(context) {
    this._context = context;
}
$8ac4ed992c4f3772$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $8ac4ed992c4f3772$export$105684a3041cb6f3(this, this._x1, this._y1); // proceed
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
            default:
                $8ac4ed992c4f3772$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $8ac4ed992c4f3772$export$2e2bcd8739ae039(context) {
    return new $8ac4ed992c4f3772$export$957f7263e89bedd2(context);
}

});


parcelRegister("8nweQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61997a9b1773375f$export$2e2bcd8739ae039; });

var $bUFg2 = parcelRequire("bUFg2");
function $61997a9b1773375f$var$BasisOpen(context) {
    this._context = context;
}
$61997a9b1773375f$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $bUFg2.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $61997a9b1773375f$export$2e2bcd8739ae039(context) {
    return new $61997a9b1773375f$var$BasisOpen(context);
}

});

parcelRegister("62VVA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $466fdd409d5c4d5b$export$2e2bcd8739ae039; });

var $bUFg2 = parcelRequire("bUFg2");
function $466fdd409d5c4d5b$var$Bundle(context, beta) {
    this._basis = new (0, $bUFg2.Basis)(context);
    this._beta = beta;
}
$466fdd409d5c4d5b$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $466fdd409d5c4d5b$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $bUFg2.Basis)(context) : new $466fdd409d5c4d5b$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

});

parcelRegister("fBy5e", function(module, exports) {

$parcel$export(module.exports, "CardinalClosed", function () { return $b5c4bff3ad559049$export$da3940d7e9162858; });
$parcel$export(module.exports, "default", function () { return $b5c4bff3ad559049$export$2e2bcd8739ae039; });

var $jV246 = parcelRequire("jV246");

var $emMsn = parcelRequire("emMsn");
function $b5c4bff3ad559049$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$b5c4bff3ad559049$export$da3940d7e9162858.prototype = {
    areaStart: (0, $jV246.default),
    areaEnd: (0, $jV246.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $emMsn.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $b5c4bff3ad559049$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $b5c4bff3ad559049$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});
parcelRegister("emMsn", function(module, exports) {

$parcel$export(module.exports, "point", function () { return $a758b53c9d8352e2$export$105684a3041cb6f3; });
$parcel$export(module.exports, "Cardinal", function () { return $a758b53c9d8352e2$export$ee51ff373511cbeb; });
$parcel$export(module.exports, "default", function () { return $a758b53c9d8352e2$export$2e2bcd8739ae039; });
function $a758b53c9d8352e2$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $a758b53c9d8352e2$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$a758b53c9d8352e2$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $a758b53c9d8352e2$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                $a758b53c9d8352e2$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $a758b53c9d8352e2$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $a758b53c9d8352e2$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


parcelRegister("d3NRi", function(module, exports) {

$parcel$export(module.exports, "CardinalOpen", function () { return $98223b13f7340e00$export$cd7d1a617282f2f1; });
$parcel$export(module.exports, "default", function () { return $98223b13f7340e00$export$2e2bcd8739ae039; });

var $emMsn = parcelRequire("emMsn");
function $98223b13f7340e00$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$98223b13f7340e00$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $emMsn.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $98223b13f7340e00$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $98223b13f7340e00$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("3NGfY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c46b9fe24bf35b1$export$2e2bcd8739ae039; });

var $fBy5e = parcelRequire("fBy5e");

var $jV246 = parcelRequire("jV246");

var $dYto6 = parcelRequire("dYto6");
function $2c46b9fe24bf35b1$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$2c46b9fe24bf35b1$var$CatmullRomClosed.prototype = {
    areaStart: (0, $jV246.default),
    areaEnd: (0, $jV246.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $dYto6.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $2c46b9fe24bf35b1$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $2c46b9fe24bf35b1$var$CatmullRomClosed(context, alpha) : new (0, $fBy5e.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("dYto6", function(module, exports) {

$parcel$export(module.exports, "point", function () { return point; });
$parcel$export(module.exports, "default", function () { return $a2c7acbb2a027d43$export$2e2bcd8739ae039; });

var $4yPBQ = parcelRequire("4yPBQ");

var $emMsn = parcelRequire("emMsn");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $4yPBQ.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $4yPBQ.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $a2c7acbb2a027d43$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $emMsn.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});


parcelRegister("ge2Ks", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd0015e5fe75ddae$export$2e2bcd8739ae039; });

var $d3NRi = parcelRequire("d3NRi");

var $dYto6 = parcelRequire("dYto6");
function $bd0015e5fe75ddae$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$bd0015e5fe75ddae$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $dYto6.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $bd0015e5fe75ddae$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $bd0015e5fe75ddae$var$CatmullRomOpen(context, alpha) : new (0, $d3NRi.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("jJTJ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5ed7244a27163f2$export$2e2bcd8739ae039; });

var $jV246 = parcelRequire("jV246");
function $e5ed7244a27163f2$var$LinearClosed(context) {
    this._context = context;
}
$e5ed7244a27163f2$var$LinearClosed.prototype = {
    areaStart: (0, $jV246.default),
    areaEnd: (0, $jV246.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $e5ed7244a27163f2$export$2e2bcd8739ae039(context) {
    return new $e5ed7244a27163f2$var$LinearClosed(context);
}

});

parcelRegister("e4wcM", function(module, exports) {

$parcel$export(module.exports, "monotoneX", function () { return $a3ea6bad8f970c89$export$99563b5420dbdc55; });
$parcel$export(module.exports, "monotoneY", function () { return $a3ea6bad8f970c89$export$8b5360456d6bdb88; });
function $a3ea6bad8f970c89$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $a3ea6bad8f970c89$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($a3ea6bad8f970c89$var$sign(s0) + $a3ea6bad8f970c89$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $a3ea6bad8f970c89$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $a3ea6bad8f970c89$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $a3ea6bad8f970c89$var$MonotoneX(context) {
    this._context = context;
}
$a3ea6bad8f970c89$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $a3ea6bad8f970c89$var$point(this, this._t0, $a3ea6bad8f970c89$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $a3ea6bad8f970c89$var$point(this, $a3ea6bad8f970c89$var$slope2(this, t1 = $a3ea6bad8f970c89$var$slope3(this, x, y)), t1);
                break;
            default:
                $a3ea6bad8f970c89$var$point(this, this._t0, t1 = $a3ea6bad8f970c89$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $a3ea6bad8f970c89$var$MonotoneY(context) {
    this._context = new $a3ea6bad8f970c89$var$ReflectContext(context);
}
($a3ea6bad8f970c89$var$MonotoneY.prototype = Object.create($a3ea6bad8f970c89$var$MonotoneX.prototype)).point = function(x, y) {
    $a3ea6bad8f970c89$var$MonotoneX.prototype.point.call(this, y, x);
};
function $a3ea6bad8f970c89$var$ReflectContext(context) {
    this._context = context;
}
$a3ea6bad8f970c89$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $a3ea6bad8f970c89$export$99563b5420dbdc55(context) {
    return new $a3ea6bad8f970c89$var$MonotoneX(context);
}
function $a3ea6bad8f970c89$export$8b5360456d6bdb88(context) {
    return new $a3ea6bad8f970c89$var$MonotoneY(context);
}

});

parcelRegister("gdfBz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcd9f70ddee99a66$export$2e2bcd8739ae039; });
function $bcd9f70ddee99a66$var$Natural(context) {
    this._context = context;
}
$bcd9f70ddee99a66$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $bcd9f70ddee99a66$var$controlPoints(x), py = $bcd9f70ddee99a66$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $bcd9f70ddee99a66$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $bcd9f70ddee99a66$export$2e2bcd8739ae039(context) {
    return new $bcd9f70ddee99a66$var$Natural(context);
}

});

parcelRegister("5O513", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43a583537398228e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "stepBefore", function () { return $43a583537398228e$export$10eafa5b7478b343; });
$parcel$export(module.exports, "stepAfter", function () { return $43a583537398228e$export$793b3db073781cbb; });
function $43a583537398228e$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$43a583537398228e$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $43a583537398228e$export$2e2bcd8739ae039(context) {
    return new $43a583537398228e$var$Step(context, 0.5);
}
function $43a583537398228e$export$10eafa5b7478b343(context) {
    return new $43a583537398228e$var$Step(context, 0);
}
function $43a583537398228e$export$793b3db073781cbb(context) {
    return new $43a583537398228e$var$Step(context, 1);
}

});

parcelRegister("iE2cX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d92dace652ac813f$export$2e2bcd8739ae039; });

var $5sI1Z = parcelRequire("5sI1Z");

var $iLMZb = parcelRequire("iLMZb");

var $4AcDE = parcelRequire("4AcDE");

var $7pvHl = parcelRequire("7pvHl");
function $d92dace652ac813f$var$stackValue(d, key) {
    return d[key];
}
function $d92dace652ac813f$export$2e2bcd8739ae039() {
    var keys = (0, $iLMZb.default)([]), order = (0, $7pvHl.default), offset = (0, $4AcDE.default), value = $d92dace652ac813f$var$stackValue;
    function stack(data) {
        var kz = keys.apply(this, arguments), i, m = data.length, n = kz.length, sz = new Array(n), oz;
        for(i = 0; i < n; ++i){
            for(var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j){
                si[j] = sij = [
                    0,
                    +value(data[j], ki, j, data)
                ];
                sij.data = data[j];
            }
            si.key = ki;
        }
        for(i = 0, oz = order(sz); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $iLMZb.default)((0, $5sI1Z.slice).call(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $iLMZb.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $7pvHl.default) : typeof _ === "function" ? _ : (0, $iLMZb.default)((0, $5sI1Z.slice).call(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $4AcDE.default) : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("4AcDE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $356453f5f6c893bd$export$2e2bcd8739ae039; });
function $356453f5f6c893bd$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("7pvHl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $565374c5743884d0$export$2e2bcd8739ae039; });
function $565374c5743884d0$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("jEt2S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4e84889629ec4cc$export$2e2bcd8739ae039; });

var $4AcDE = parcelRequire("4AcDE");
function $e4e84889629ec4cc$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $4AcDE.default)(series, order);
}

});

parcelRegister("dfxGw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a56ce3478a08fdb$export$2e2bcd8739ae039; });
function $9a56ce3478a08fdb$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("9rRGY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e1048d5eee93fed$export$2e2bcd8739ae039; });

var $4AcDE = parcelRequire("4AcDE");
function $6e1048d5eee93fed$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $4AcDE.default)(series, order);
}

});

parcelRegister("fwp4P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4cd4be6d0f12a30$export$2e2bcd8739ae039; });

var $4AcDE = parcelRequire("4AcDE");
function $b4cd4be6d0f12a30$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $4AcDE.default)(series, order);
}

});

parcelRegister("j0hzK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd5ba68e0385aa00$export$2e2bcd8739ae039; });

var $7pvHl = parcelRequire("7pvHl");
function $dd5ba68e0385aa00$export$2e2bcd8739ae039(series) {
    var peaks = series.map($dd5ba68e0385aa00$var$peak);
    return (0, $7pvHl.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $dd5ba68e0385aa00$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("cv1za", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9199984cf878c516$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "sum", function () { return $9199984cf878c516$export$8a63f25cc62965f1; });

var $7pvHl = parcelRequire("7pvHl");
function $9199984cf878c516$export$2e2bcd8739ae039(series) {
    var sums = series.map($9199984cf878c516$export$8a63f25cc62965f1);
    return (0, $7pvHl.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $9199984cf878c516$export$8a63f25cc62965f1(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("fXnyz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9dea38e26768ee4$export$2e2bcd8739ae039; });

var $cv1za = parcelRequire("cv1za");
function $b9dea38e26768ee4$export$2e2bcd8739ae039(series) {
    return (0, $cv1za.default)(series).reverse();
}

});

parcelRegister("6Hjnx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e05ca6e54a3159d$export$2e2bcd8739ae039; });

var $j0hzK = parcelRequire("j0hzK");

var $cv1za = parcelRequire("cv1za");
function $4e05ca6e54a3159d$export$2e2bcd8739ae039(series) {
    var n = series.length, i, j, sums = series.map((0, $cv1za.sum)), order = (0, $j0hzK.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("7Fl3L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $594cb2c79d8ca59b$export$2e2bcd8739ae039; });

var $7pvHl = parcelRequire("7pvHl");
function $594cb2c79d8ca59b$export$2e2bcd8739ae039(series) {
    return (0, $7pvHl.default)(series).reverse();
}

});


parcelRegister("kjQV0", function(module, exports) {

$parcel$export(module.exports, "timeInterval", function () { return (parcelRequire("d9CtV")).default; });
$parcel$export(module.exports, "timeMillisecond", function () { return (parcelRequire("4YZxj")).default; });
$parcel$export(module.exports, "timeMilliseconds", function () { return (parcelRequire("4YZxj")).milliseconds; });
$parcel$export(module.exports, "utcMillisecond", function () { return (parcelRequire("4YZxj")).default; });
$parcel$export(module.exports, "utcMilliseconds", function () { return (parcelRequire("4YZxj")).milliseconds; });
$parcel$export(module.exports, "timeSecond", function () { return (parcelRequire("ckkQj")).default; });
$parcel$export(module.exports, "timeSeconds", function () { return (parcelRequire("ckkQj")).seconds; });
$parcel$export(module.exports, "utcSecond", function () { return (parcelRequire("ckkQj")).default; });
$parcel$export(module.exports, "utcSeconds", function () { return (parcelRequire("ckkQj")).seconds; });
$parcel$export(module.exports, "timeMinute", function () { return (parcelRequire("8z9BB")).default; });
$parcel$export(module.exports, "timeMinutes", function () { return (parcelRequire("8z9BB")).minutes; });
$parcel$export(module.exports, "timeHour", function () { return (parcelRequire("7hefO")).default; });
$parcel$export(module.exports, "timeHours", function () { return (parcelRequire("7hefO")).hours; });
$parcel$export(module.exports, "timeDay", function () { return (parcelRequire("2OwRo")).default; });
$parcel$export(module.exports, "timeDays", function () { return (parcelRequire("2OwRo")).days; });
$parcel$export(module.exports, "timeWeek", function () { return (parcelRequire("12kxK")).sunday; });
$parcel$export(module.exports, "timeWeeks", function () { return (parcelRequire("12kxK")).sundays; });
$parcel$export(module.exports, "timeSunday", function () { return (parcelRequire("12kxK")).sunday; });
$parcel$export(module.exports, "timeSundays", function () { return (parcelRequire("12kxK")).sundays; });
$parcel$export(module.exports, "timeMonday", function () { return (parcelRequire("12kxK")).monday; });
$parcel$export(module.exports, "timeMondays", function () { return (parcelRequire("12kxK")).mondays; });
$parcel$export(module.exports, "timeTuesday", function () { return (parcelRequire("12kxK")).tuesday; });
$parcel$export(module.exports, "timeTuesdays", function () { return (parcelRequire("12kxK")).tuesdays; });
$parcel$export(module.exports, "timeWednesday", function () { return (parcelRequire("12kxK")).wednesday; });
$parcel$export(module.exports, "timeWednesdays", function () { return (parcelRequire("12kxK")).wednesdays; });
$parcel$export(module.exports, "timeThursday", function () { return (parcelRequire("12kxK")).thursday; });
$parcel$export(module.exports, "timeThursdays", function () { return (parcelRequire("12kxK")).thursdays; });
$parcel$export(module.exports, "timeFriday", function () { return (parcelRequire("12kxK")).friday; });
$parcel$export(module.exports, "timeFridays", function () { return (parcelRequire("12kxK")).fridays; });
$parcel$export(module.exports, "timeSaturday", function () { return (parcelRequire("12kxK")).saturday; });
$parcel$export(module.exports, "timeSaturdays", function () { return (parcelRequire("12kxK")).saturdays; });
$parcel$export(module.exports, "timeMonth", function () { return (parcelRequire("qXCEl")).default; });
$parcel$export(module.exports, "timeMonths", function () { return (parcelRequire("qXCEl")).months; });
$parcel$export(module.exports, "timeYear", function () { return (parcelRequire("di9fD")).default; });
$parcel$export(module.exports, "timeYears", function () { return (parcelRequire("di9fD")).years; });
$parcel$export(module.exports, "utcMinute", function () { return (parcelRequire("78Eaf")).default; });
$parcel$export(module.exports, "utcMinutes", function () { return (parcelRequire("78Eaf")).utcMinutes; });
$parcel$export(module.exports, "utcHour", function () { return (parcelRequire("1Jzw0")).default; });
$parcel$export(module.exports, "utcHours", function () { return (parcelRequire("1Jzw0")).utcHours; });
$parcel$export(module.exports, "utcDay", function () { return (parcelRequire("kKEAx")).default; });
$parcel$export(module.exports, "utcDays", function () { return (parcelRequire("kKEAx")).utcDays; });
$parcel$export(module.exports, "utcWeek", function () { return (parcelRequire("90yBq")).utcSunday; });
$parcel$export(module.exports, "utcWeeks", function () { return (parcelRequire("90yBq")).utcSundays; });
$parcel$export(module.exports, "utcSunday", function () { return (parcelRequire("90yBq")).utcSunday; });
$parcel$export(module.exports, "utcSundays", function () { return (parcelRequire("90yBq")).utcSundays; });
$parcel$export(module.exports, "utcMonday", function () { return (parcelRequire("90yBq")).utcMonday; });
$parcel$export(module.exports, "utcMondays", function () { return (parcelRequire("90yBq")).utcMondays; });
$parcel$export(module.exports, "utcTuesday", function () { return (parcelRequire("90yBq")).utcTuesday; });
$parcel$export(module.exports, "utcTuesdays", function () { return (parcelRequire("90yBq")).utcTuesdays; });
$parcel$export(module.exports, "utcWednesday", function () { return (parcelRequire("90yBq")).utcWednesday; });
$parcel$export(module.exports, "utcWednesdays", function () { return (parcelRequire("90yBq")).utcWednesdays; });
$parcel$export(module.exports, "utcThursday", function () { return (parcelRequire("90yBq")).utcThursday; });
$parcel$export(module.exports, "utcThursdays", function () { return (parcelRequire("90yBq")).utcThursdays; });
$parcel$export(module.exports, "utcFriday", function () { return (parcelRequire("90yBq")).utcFriday; });
$parcel$export(module.exports, "utcFridays", function () { return (parcelRequire("90yBq")).utcFridays; });
$parcel$export(module.exports, "utcSaturday", function () { return (parcelRequire("90yBq")).utcSaturday; });
$parcel$export(module.exports, "utcSaturdays", function () { return (parcelRequire("90yBq")).utcSaturdays; });
$parcel$export(module.exports, "utcMonth", function () { return (parcelRequire("5Dm9r")).default; });
$parcel$export(module.exports, "utcMonths", function () { return (parcelRequire("5Dm9r")).utcMonths; });
$parcel$export(module.exports, "utcYear", function () { return (parcelRequire("hC9DG")).default; });
$parcel$export(module.exports, "utcYears", function () { return (parcelRequire("hC9DG")).utcYears; });

var $d9CtV = parcelRequire("d9CtV");

var $4YZxj = parcelRequire("4YZxj");

var $ckkQj = parcelRequire("ckkQj");

var $8z9BB = parcelRequire("8z9BB");

var $7hefO = parcelRequire("7hefO");

var $2OwRo = parcelRequire("2OwRo");

var $12kxK = parcelRequire("12kxK");

var $qXCEl = parcelRequire("qXCEl");

var $di9fD = parcelRequire("di9fD");

var $78Eaf = parcelRequire("78Eaf");

var $1Jzw0 = parcelRequire("1Jzw0");

var $kKEAx = parcelRequire("kKEAx");

var $90yBq = parcelRequire("90yBq");

var $5Dm9r = parcelRequire("5Dm9r");

var $hC9DG = parcelRequire("hC9DG");

});

parcelRegister("iuGXt", function(module, exports) {

$parcel$export(module.exports, "timeFormatDefaultLocale", function () { return (parcelRequire("gVMzE")).default; });
$parcel$export(module.exports, "timeFormat", function () { return (parcelRequire("gVMzE")).timeFormat; });
$parcel$export(module.exports, "timeParse", function () { return (parcelRequire("gVMzE")).timeParse; });
$parcel$export(module.exports, "utcFormat", function () { return (parcelRequire("gVMzE")).utcFormat; });
$parcel$export(module.exports, "utcParse", function () { return (parcelRequire("gVMzE")).utcParse; });
$parcel$export(module.exports, "timeFormatLocale", function () { return (parcelRequire("kQnJN")).default; });
$parcel$export(module.exports, "isoFormat", function () { return (parcelRequire("9Q7o1")).default; });
$parcel$export(module.exports, "isoParse", function () { return (parcelRequire("BabUy")).default; });

var $gVMzE = parcelRequire("gVMzE");

var $kQnJN = parcelRequire("kQnJN");

var $9Q7o1 = parcelRequire("9Q7o1");

var $BabUy = parcelRequire("BabUy");

});
parcelRegister("9Q7o1", function(module, exports) {

$parcel$export(module.exports, "isoSpecifier", function () { return $729eb32873d1b453$export$491f7bf2e88d83ce; });
$parcel$export(module.exports, "default", function () { return $729eb32873d1b453$export$2e2bcd8739ae039; });

var $gVMzE = parcelRequire("gVMzE");
var $729eb32873d1b453$export$491f7bf2e88d83ce = "%Y-%m-%dT%H:%M:%S.%LZ";
function $729eb32873d1b453$var$formatIsoNative(date) {
    return date.toISOString();
}
var $729eb32873d1b453$var$formatIso = Date.prototype.toISOString ? $729eb32873d1b453$var$formatIsoNative : (0, $gVMzE.utcFormat)($729eb32873d1b453$export$491f7bf2e88d83ce);
var $729eb32873d1b453$export$2e2bcd8739ae039 = $729eb32873d1b453$var$formatIso;

});

parcelRegister("BabUy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06fb5c8f3e2c49f7$export$2e2bcd8739ae039; });

var $9Q7o1 = parcelRequire("9Q7o1");

var $gVMzE = parcelRequire("gVMzE");
function $06fb5c8f3e2c49f7$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $06fb5c8f3e2c49f7$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $06fb5c8f3e2c49f7$var$parseIsoNative : (0, $gVMzE.utcParse)((0, $9Q7o1.isoSpecifier));
var $06fb5c8f3e2c49f7$export$2e2bcd8739ae039 = $06fb5c8f3e2c49f7$var$parseIso;

});


parcelRegister("hk1Lf", function(module, exports) {

$parcel$export(module.exports, "now", function () { return (parcelRequire("fxK5h")).now; });
$parcel$export(module.exports, "timer", function () { return (parcelRequire("fxK5h")).timer; });
$parcel$export(module.exports, "timerFlush", function () { return (parcelRequire("fxK5h")).timerFlush; });
$parcel$export(module.exports, "timeout", function () { return (parcelRequire("aEq4u")).default; });
$parcel$export(module.exports, "interval", function () { return (parcelRequire("hZwoI")).default; });

var $fxK5h = parcelRequire("fxK5h");

var $aEq4u = parcelRequire("aEq4u");

var $hZwoI = parcelRequire("hZwoI");

});
parcelRegister("hZwoI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d19143af11b4583c$export$2e2bcd8739ae039; });

var $fxK5h = parcelRequire("fxK5h");
function $d19143af11b4583c$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $fxK5h.Timer), total = delay;
    if (delay == null) return t.restart(callback, delay, time), t;
    delay = +delay, time = time == null ? (0, $fxK5h.now)() : +time;
    t.restart(function tick(elapsed) {
        elapsed += total;
        t.restart(tick, total += delay, time);
        callback(elapsed);
    }, delay, time);
    return t;
}

});


parcelRegister("kjxhJ", function(module, exports) {

$parcel$export(module.exports, "voronoi", function () { return (parcelRequire("9BCHy")).default; });

var $9BCHy = parcelRequire("9BCHy");

});
parcelRegister("9BCHy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fe597122457d227$export$2e2bcd8739ae039; });

var $7cMSh = parcelRequire("7cMSh");

var $f45gK = parcelRequire("f45gK");

var $84NSf = parcelRequire("84NSf");
function $6fe597122457d227$export$2e2bcd8739ae039() {
    var x = (0, $f45gK.x), y = (0, $f45gK.y), extent = null;
    function voronoi(data) {
        return new (0, $84NSf.default)(data.map(function(d, i) {
            var s = [
                Math.round(x(d, i, data) / (0, $84NSf.epsilon)) * (0, $84NSf.epsilon),
                Math.round(y(d, i, data) / (0, $84NSf.epsilon)) * (0, $84NSf.epsilon)
            ];
            s.index = i;
            s.data = d;
            return s;
        }), extent);
    }
    voronoi.polygons = function(data) {
        return voronoi(data).polygons();
    };
    voronoi.links = function(data) {
        return voronoi(data).links();
    };
    voronoi.triangles = function(data) {
        return voronoi(data).triangles();
    };
    voronoi.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $7cMSh.default)(+_), voronoi) : x;
    };
    voronoi.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $7cMSh.default)(+_), voronoi) : y;
    };
    voronoi.extent = function(_) {
        return arguments.length ? (extent = _ == null ? null : [
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ], voronoi) : extent && [
            [
                extent[0][0],
                extent[0][1]
            ],
            [
                extent[1][0],
                extent[1][1]
            ]
        ];
    };
    voronoi.size = function(_) {
        return arguments.length ? (extent = _ == null ? null : [
            [
                0,
                0
            ],
            [
                +_[0],
                +_[1]
            ]
        ], voronoi) : extent && [
            extent[1][0] - extent[0][0],
            extent[1][1] - extent[0][1]
        ];
    };
    return voronoi;
}

});
parcelRegister("7cMSh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53ef90d7c8d9386f$export$2e2bcd8739ae039; });
function $53ef90d7c8d9386f$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("f45gK", function(module, exports) {

$parcel$export(module.exports, "x", function () { return $af7b510cd9f88321$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "y", function () { return $af7b510cd9f88321$export$4a5767248b18ef41; });
function $af7b510cd9f88321$export$d141bba7fdc215a3(d) {
    return d[0];
}
function $af7b510cd9f88321$export$4a5767248b18ef41(d) {
    return d[1];
}

});

parcelRegister("84NSf", function(module, exports) {

$parcel$export(module.exports, "epsilon", function () { return epsilon; });
$parcel$export(module.exports, "epsilon2", function () { return epsilon2; });
$parcel$export(module.exports, "beaches", function () { return beaches; });
$parcel$export(module.exports, "cells", function () { return cells; });
$parcel$export(module.exports, "circles", function () { return circles; });
$parcel$export(module.exports, "edges", function () { return edges; });
$parcel$export(module.exports, "default", function () { return Diagram; });

var $6FR2Z = parcelRequire("6FR2Z");

var $4QKcY = parcelRequire("4QKcY");

var $iptZm = parcelRequire("iptZm");

var $eFsgQ = parcelRequire("eFsgQ");

var $6MBGl = parcelRequire("6MBGl");
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;
function triangleArea(a, b, c) {
    return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}
function lexicographic(a, b) {
    return b[1] - a[1] || b[0] - a[0];
}
function Diagram(sites, extent) {
    var site = sites.sort(lexicographic).pop(), x, y, circle;
    edges = [];
    cells = new Array(sites.length);
    beaches = new (0, $6MBGl.default);
    circles = new (0, $6MBGl.default);
    while(true){
        circle = (0, $iptZm.firstCircle);
        if (site && (!circle || site[1] < circle.y || site[1] === circle.y && site[0] < circle.x)) {
            if (site[0] !== x || site[1] !== y) {
                (0, $6FR2Z.addBeach)(site);
                x = site[0], y = site[1];
            }
            site = sites.pop();
        } else if (circle) (0, $6FR2Z.removeBeach)(circle.arc);
        else break;
    }
    (0, $4QKcY.sortCellHalfedges)();
    if (extent) {
        var x0 = +extent[0][0], y0 = +extent[0][1], x1 = +extent[1][0], y1 = +extent[1][1];
        (0, $eFsgQ.clipEdges)(x0, y0, x1, y1);
        (0, $4QKcY.clipCells)(x0, y0, x1, y1);
    }
    this.edges = edges;
    this.cells = cells;
    beaches = circles = edges = cells = null;
}
Diagram.prototype = {
    constructor: Diagram,
    polygons: function() {
        var edges = this.edges;
        return this.cells.map(function(cell) {
            var polygon = cell.halfedges.map(function(i) {
                return (0, $4QKcY.cellHalfedgeStart)(cell, edges[i]);
            });
            polygon.data = cell.site.data;
            return polygon;
        });
    },
    triangles: function() {
        var triangles = [], edges = this.edges;
        this.cells.forEach(function(cell, i) {
            if (!(m = (halfedges = cell.halfedges).length)) return;
            var site = cell.site, halfedges, j = -1, m, s0, e1 = edges[halfedges[m - 1]], s1 = e1.left === site ? e1.right : e1.left;
            while(++j < m){
                s0 = s1;
                e1 = edges[halfedges[j]];
                s1 = e1.left === site ? e1.right : e1.left;
                if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) triangles.push([
                    site.data,
                    s0.data,
                    s1.data
                ]);
            }
        });
        return triangles;
    },
    links: function() {
        return this.edges.filter(function(edge) {
            return edge.right;
        }).map(function(edge) {
            return {
                source: edge.left.data,
                target: edge.right.data
            };
        });
    },
    find: function(x, y, radius) {
        var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;
        // Use the previously-found cell, or start with an arbitrary one.
        while(!(cell = that.cells[i1]))if (++i1 >= n) return null;
        var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;
        // Traverse the half-edges to find a closer cell, if any.
        do {
            cell = that.cells[i0 = i1], i1 = null;
            cell.halfedges.forEach(function(e) {
                var edge = that.edges[e], v = edge.left;
                if ((v === cell.site || !v) && !(v = edge.right)) return;
                var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
                if (v2 < d2) d2 = v2, i1 = v.index;
            });
        }while (i1 !== null);
        that._found = i0;
        return radius == null || d2 <= radius * radius ? cell.site : null;
    }
};

});
parcelRegister("6FR2Z", function(module, exports) {

$parcel$export(module.exports, "removeBeach", function () { return $4dbfb8796fc454bd$export$25be321a9b2d3c3c; });
$parcel$export(module.exports, "addBeach", function () { return $4dbfb8796fc454bd$export$fec167a219592370; });

var $6MBGl = parcelRequire("6MBGl");

var $4QKcY = parcelRequire("4QKcY");

var $iptZm = parcelRequire("iptZm");

var $eFsgQ = parcelRequire("eFsgQ");

var $84NSf = parcelRequire("84NSf");
var $4dbfb8796fc454bd$var$beachPool = [];
function $4dbfb8796fc454bd$var$Beach() {
    (0, $6MBGl.RedBlackNode)(this);
    this.edge = this.site = this.circle = null;
}
function $4dbfb8796fc454bd$var$createBeach(site) {
    var beach = $4dbfb8796fc454bd$var$beachPool.pop() || new $4dbfb8796fc454bd$var$Beach;
    beach.site = site;
    return beach;
}
function $4dbfb8796fc454bd$var$detachBeach(beach) {
    (0, $iptZm.detachCircle)(beach);
    (0, $84NSf.beaches).remove(beach);
    $4dbfb8796fc454bd$var$beachPool.push(beach);
    (0, $6MBGl.RedBlackNode)(beach);
}
function $4dbfb8796fc454bd$export$25be321a9b2d3c3c(beach) {
    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = [
        x,
        y
    ], previous = beach.P, next = beach.N, disappearing = [
        beach
    ];
    $4dbfb8796fc454bd$var$detachBeach(beach);
    var lArc = previous;
    while(lArc.circle && Math.abs(x - lArc.circle.x) < (0, $84NSf.epsilon) && Math.abs(y - lArc.circle.cy) < (0, $84NSf.epsilon)){
        previous = lArc.P;
        disappearing.unshift(lArc);
        $4dbfb8796fc454bd$var$detachBeach(lArc);
        lArc = previous;
    }
    disappearing.unshift(lArc);
    (0, $iptZm.detachCircle)(lArc);
    var rArc = next;
    while(rArc.circle && Math.abs(x - rArc.circle.x) < (0, $84NSf.epsilon) && Math.abs(y - rArc.circle.cy) < (0, $84NSf.epsilon)){
        next = rArc.N;
        disappearing.push(rArc);
        $4dbfb8796fc454bd$var$detachBeach(rArc);
        rArc = next;
    }
    disappearing.push(rArc);
    (0, $iptZm.detachCircle)(rArc);
    var nArcs = disappearing.length, iArc;
    for(iArc = 1; iArc < nArcs; ++iArc){
        rArc = disappearing[iArc];
        lArc = disappearing[iArc - 1];
        (0, $eFsgQ.setEdgeEnd)(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = (0, $eFsgQ.createEdge)(lArc.site, rArc.site, null, vertex);
    (0, $iptZm.attachCircle)(lArc);
    (0, $iptZm.attachCircle)(rArc);
}
function $4dbfb8796fc454bd$export$fec167a219592370(site) {
    var x = site[0], directrix = site[1], lArc, rArc, dxl, dxr, node = (0, $84NSf.beaches)._;
    while(node){
        dxl = $4dbfb8796fc454bd$var$leftBreakPoint(node, directrix) - x;
        if (dxl > (0, $84NSf.epsilon)) node = node.L;
        else {
            dxr = x - $4dbfb8796fc454bd$var$rightBreakPoint(node, directrix);
            if (dxr > (0, $84NSf.epsilon)) {
                if (!node.R) {
                    lArc = node;
                    break;
                }
                node = node.R;
            } else {
                if (dxl > -(0, $84NSf.epsilon)) {
                    lArc = node.P;
                    rArc = node;
                } else if (dxr > -(0, $84NSf.epsilon)) {
                    lArc = node;
                    rArc = node.N;
                } else lArc = rArc = node;
                break;
            }
        }
    }
    (0, $4QKcY.createCell)(site);
    var newArc = $4dbfb8796fc454bd$var$createBeach(site);
    (0, $84NSf.beaches).insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
        (0, $iptZm.detachCircle)(lArc);
        rArc = $4dbfb8796fc454bd$var$createBeach(lArc.site);
        (0, $84NSf.beaches).insert(newArc, rArc);
        newArc.edge = rArc.edge = (0, $eFsgQ.createEdge)(lArc.site, newArc.site);
        (0, $iptZm.attachCircle)(lArc);
        (0, $iptZm.attachCircle)(rArc);
        return;
    }
    if (!rArc) {
        newArc.edge = (0, $eFsgQ.createEdge)(lArc.site, newArc.site);
        return;
    }
    // else lArc !== rArc
    (0, $iptZm.detachCircle)(lArc);
    (0, $iptZm.detachCircle)(rArc);
    var lSite = lArc.site, ax = lSite[0], ay = lSite[1], bx = site[0] - ax, by = site[1] - ay, rSite = rArc.site, cx = rSite[0] - ax, cy = rSite[1] - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = [
        (cy * hb - by * hc) / d + ax,
        (bx * hc - cx * hb) / d + ay
    ];
    (0, $eFsgQ.setEdgeEnd)(rArc.edge, lSite, rSite, vertex);
    newArc.edge = (0, $eFsgQ.createEdge)(lSite, site, null, vertex);
    rArc.edge = (0, $eFsgQ.createEdge)(site, rSite, null, vertex);
    (0, $iptZm.attachCircle)(lArc);
    (0, $iptZm.attachCircle)(rArc);
}
function $4dbfb8796fc454bd$var$leftBreakPoint(arc, directrix) {
    var site = arc.site, rfocx = site[0], rfocy = site[1], pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site[0], lfocy = site[1], plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
}
function $4dbfb8796fc454bd$var$rightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return $4dbfb8796fc454bd$var$leftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site[1] === directrix ? site[0] : Infinity;
}

});
parcelRegister("6MBGl", function(module, exports) {

$parcel$export(module.exports, "RedBlackNode", function () { return $4f0474a2a8df50a6$export$5072552a5e64b90a; });
$parcel$export(module.exports, "default", function () { return $4f0474a2a8df50a6$export$2e2bcd8739ae039; });
function $4f0474a2a8df50a6$var$RedBlackTree() {
    this._ = null; // root node
}
function $4f0474a2a8df50a6$export$5072552a5e64b90a(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null; // next node
}
$4f0474a2a8df50a6$var$RedBlackTree.prototype = {
    constructor: $4f0474a2a8df50a6$var$RedBlackTree,
    insert: function(after, node) {
        var parent, grandpa, uncle;
        if (after) {
            node.P = after;
            node.N = after.N;
            if (after.N) after.N.P = node;
            after.N = node;
            if (after.R) {
                after = after.R;
                while(after.L)after = after.L;
                after.L = node;
            } else after.R = node;
            parent = after;
        } else if (this._) {
            after = $4f0474a2a8df50a6$var$RedBlackFirst(this._);
            node.P = null;
            node.N = after;
            after.P = after.L = node;
            parent = after;
        } else {
            node.P = node.N = null;
            this._ = node;
            parent = null;
        }
        node.L = node.R = null;
        node.U = parent;
        node.C = true;
        after = node;
        while(parent && parent.C){
            grandpa = parent.U;
            if (parent === grandpa.L) {
                uncle = grandpa.R;
                if (uncle && uncle.C) {
                    parent.C = uncle.C = false;
                    grandpa.C = true;
                    after = grandpa;
                } else {
                    if (after === parent.R) {
                        $4f0474a2a8df50a6$var$RedBlackRotateLeft(this, parent);
                        after = parent;
                        parent = after.U;
                    }
                    parent.C = false;
                    grandpa.C = true;
                    $4f0474a2a8df50a6$var$RedBlackRotateRight(this, grandpa);
                }
            } else {
                uncle = grandpa.L;
                if (uncle && uncle.C) {
                    parent.C = uncle.C = false;
                    grandpa.C = true;
                    after = grandpa;
                } else {
                    if (after === parent.L) {
                        $4f0474a2a8df50a6$var$RedBlackRotateRight(this, parent);
                        after = parent;
                        parent = after.U;
                    }
                    parent.C = false;
                    grandpa.C = true;
                    $4f0474a2a8df50a6$var$RedBlackRotateLeft(this, grandpa);
                }
            }
            parent = after.U;
        }
        this._.C = false;
    },
    remove: function(node) {
        if (node.N) node.N.P = node.P;
        if (node.P) node.P.N = node.N;
        node.N = node.P = null;
        var parent = node.U, sibling, left = node.L, right = node.R, next, red;
        if (!left) next = right;
        else if (!right) next = left;
        else next = $4f0474a2a8df50a6$var$RedBlackFirst(right);
        if (parent) {
            if (parent.L === node) parent.L = next;
            else parent.R = next;
        } else this._ = next;
        if (left && right) {
            red = next.C;
            next.C = node.C;
            next.L = left;
            left.U = next;
            if (next !== right) {
                parent = next.U;
                next.U = node.U;
                node = next.R;
                parent.L = node;
                next.R = right;
                right.U = next;
            } else {
                next.U = parent;
                parent = next;
                node = next.R;
            }
        } else {
            red = node.C;
            node = next;
        }
        if (node) node.U = parent;
        if (red) return;
        if (node && node.C) {
            node.C = false;
            return;
        }
        do {
            if (node === this._) break;
            if (node === parent.L) {
                sibling = parent.R;
                if (sibling.C) {
                    sibling.C = false;
                    parent.C = true;
                    $4f0474a2a8df50a6$var$RedBlackRotateLeft(this, parent);
                    sibling = parent.R;
                }
                if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                    if (!sibling.R || !sibling.R.C) {
                        sibling.L.C = false;
                        sibling.C = true;
                        $4f0474a2a8df50a6$var$RedBlackRotateRight(this, sibling);
                        sibling = parent.R;
                    }
                    sibling.C = parent.C;
                    parent.C = sibling.R.C = false;
                    $4f0474a2a8df50a6$var$RedBlackRotateLeft(this, parent);
                    node = this._;
                    break;
                }
            } else {
                sibling = parent.L;
                if (sibling.C) {
                    sibling.C = false;
                    parent.C = true;
                    $4f0474a2a8df50a6$var$RedBlackRotateRight(this, parent);
                    sibling = parent.L;
                }
                if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                    if (!sibling.L || !sibling.L.C) {
                        sibling.R.C = false;
                        sibling.C = true;
                        $4f0474a2a8df50a6$var$RedBlackRotateLeft(this, sibling);
                        sibling = parent.L;
                    }
                    sibling.C = parent.C;
                    parent.C = sibling.L.C = false;
                    $4f0474a2a8df50a6$var$RedBlackRotateRight(this, parent);
                    node = this._;
                    break;
                }
            }
            sibling.C = true;
            node = parent;
            parent = parent.U;
        }while (!node.C);
        if (node) node.C = false;
    }
};
function $4f0474a2a8df50a6$var$RedBlackRotateLeft(tree, node) {
    var p = node, q = node.R, parent = p.U;
    if (parent) {
        if (parent.L === p) parent.L = q;
        else parent.R = q;
    } else tree._ = q;
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
}
function $4f0474a2a8df50a6$var$RedBlackRotateRight(tree, node) {
    var p = node, q = node.L, parent = p.U;
    if (parent) {
        if (parent.L === p) parent.L = q;
        else parent.R = q;
    } else tree._ = q;
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
}
function $4f0474a2a8df50a6$var$RedBlackFirst(node) {
    while(node.L)node = node.L;
    return node;
}
var $4f0474a2a8df50a6$export$2e2bcd8739ae039 = $4f0474a2a8df50a6$var$RedBlackTree;

});

parcelRegister("4QKcY", function(module, exports) {

$parcel$export(module.exports, "createCell", function () { return $387fdcc3c3f5c2ad$export$3cb21b6b1233300e; });
$parcel$export(module.exports, "cellHalfedgeStart", function () { return $387fdcc3c3f5c2ad$export$67c16aa967774be; });
$parcel$export(module.exports, "sortCellHalfedges", function () { return $387fdcc3c3f5c2ad$export$41888d88cbc31210; });
$parcel$export(module.exports, "clipCells", function () { return $387fdcc3c3f5c2ad$export$cdcebd68073bc3f; });

var $eFsgQ = parcelRequire("eFsgQ");

var $84NSf = parcelRequire("84NSf");
function $387fdcc3c3f5c2ad$export$3cb21b6b1233300e(site) {
    return (0, $84NSf.cells)[site.index] = {
        site: site,
        halfedges: []
    };
}
function $387fdcc3c3f5c2ad$var$cellHalfedgeAngle(cell, edge) {
    var site = cell.site, va = edge.left, vb = edge.right;
    if (site === vb) vb = va, va = site;
    if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
    if (site === va) va = edge[1], vb = edge[0];
    else va = edge[0], vb = edge[1];
    return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}
function $387fdcc3c3f5c2ad$export$67c16aa967774be(cell, edge) {
    return edge[+(edge.left !== cell.site)];
}
function $387fdcc3c3f5c2ad$export$bf8e581ba65a00a5(cell, edge) {
    return edge[+(edge.left === cell.site)];
}
function $387fdcc3c3f5c2ad$export$41888d88cbc31210() {
    for(var i = 0, n = (0, $84NSf.cells).length, cell, halfedges, j, m; i < n; ++i)if ((cell = (0, $84NSf.cells)[i]) && (m = (halfedges = cell.halfedges).length)) {
        var index = new Array(m), array = new Array(m);
        for(j = 0; j < m; ++j)index[j] = j, array[j] = $387fdcc3c3f5c2ad$var$cellHalfedgeAngle(cell, (0, $84NSf.edges)[halfedges[j]]);
        index.sort(function(i, j) {
            return array[j] - array[i];
        });
        for(j = 0; j < m; ++j)array[j] = halfedges[index[j]];
        for(j = 0; j < m; ++j)halfedges[j] = array[j];
    }
}
function $387fdcc3c3f5c2ad$export$cdcebd68073bc3f(x0, y0, x1, y1) {
    var nCells = (0, $84NSf.cells).length, iCell, cell, site, iHalfedge, halfedges, nHalfedges, start, startX, startY, end, endX, endY, cover = true;
    for(iCell = 0; iCell < nCells; ++iCell)if (cell = (0, $84NSf.cells)[iCell]) {
        site = cell.site;
        halfedges = cell.halfedges;
        iHalfedge = halfedges.length;
        // Remove any dangling clipped edges.
        while(iHalfedge--)if (!(0, $84NSf.edges)[halfedges[iHalfedge]]) halfedges.splice(iHalfedge, 1);
        // Insert any border edges as necessary.
        iHalfedge = 0, nHalfedges = halfedges.length;
        while(iHalfedge < nHalfedges){
            end = $387fdcc3c3f5c2ad$export$bf8e581ba65a00a5(cell, (0, $84NSf.edges)[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
            start = $387fdcc3c3f5c2ad$export$67c16aa967774be(cell, (0, $84NSf.edges)[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
            if (Math.abs(endX - startX) > (0, $84NSf.epsilon) || Math.abs(endY - startY) > (0, $84NSf.epsilon)) {
                halfedges.splice(iHalfedge, 0, (0, $84NSf.edges).push((0, $eFsgQ.createBorderEdge)(site, end, Math.abs(endX - x0) < (0, $84NSf.epsilon) && y1 - endY > (0, $84NSf.epsilon) ? [
                    x0,
                    Math.abs(startX - x0) < (0, $84NSf.epsilon) ? startY : y1
                ] : Math.abs(endY - y1) < (0, $84NSf.epsilon) && x1 - endX > (0, $84NSf.epsilon) ? [
                    Math.abs(startY - y1) < (0, $84NSf.epsilon) ? startX : x1,
                    y1
                ] : Math.abs(endX - x1) < (0, $84NSf.epsilon) && endY - y0 > (0, $84NSf.epsilon) ? [
                    x1,
                    Math.abs(startX - x1) < (0, $84NSf.epsilon) ? startY : y0
                ] : Math.abs(endY - y0) < (0, $84NSf.epsilon) && endX - x0 > (0, $84NSf.epsilon) ? [
                    Math.abs(startY - y0) < (0, $84NSf.epsilon) ? startX : x0,
                    y0
                ] : null)) - 1);
                ++nHalfedges;
            }
        }
        if (nHalfedges) cover = false;
    }
    // If there weren’t any edges, have the closest site cover the extent.
    // It doesn’t matter which corner of the extent we measure!
    if (cover) {
        var dx, dy, d2, dc = Infinity;
        for(iCell = 0, cover = null; iCell < nCells; ++iCell)if (cell = (0, $84NSf.cells)[iCell]) {
            site = cell.site;
            dx = site[0] - x0;
            dy = site[1] - y0;
            d2 = dx * dx + dy * dy;
            if (d2 < dc) dc = d2, cover = cell;
        }
        if (cover) {
            var v00 = [
                x0,
                y0
            ], v01 = [
                x0,
                y1
            ], v11 = [
                x1,
                y1
            ], v10 = [
                x1,
                y0
            ];
            cover.halfedges.push((0, $84NSf.edges).push((0, $eFsgQ.createBorderEdge)(site = cover.site, v00, v01)) - 1, (0, $84NSf.edges).push((0, $eFsgQ.createBorderEdge)(site, v01, v11)) - 1, (0, $84NSf.edges).push((0, $eFsgQ.createBorderEdge)(site, v11, v10)) - 1, (0, $84NSf.edges).push((0, $eFsgQ.createBorderEdge)(site, v10, v00)) - 1);
        }
    }
    // Lastly delete any cells with no edges; these were entirely clipped.
    for(iCell = 0; iCell < nCells; ++iCell){
        if (cell = (0, $84NSf.cells)[iCell]) {
            if (!cell.halfedges.length) delete (0, $84NSf.cells)[iCell];
        }
    }
}

});
parcelRegister("eFsgQ", function(module, exports) {

$parcel$export(module.exports, "createEdge", function () { return $aadad30153b2a449$export$bdd941b9b8806569; });
$parcel$export(module.exports, "setEdgeEnd", function () { return $aadad30153b2a449$export$9e883caea829cb44; });
$parcel$export(module.exports, "createBorderEdge", function () { return $aadad30153b2a449$export$681cc0bbec712be1; });
$parcel$export(module.exports, "clipEdges", function () { return $aadad30153b2a449$export$db4502aa9c1617af; });

var $84NSf = parcelRequire("84NSf");
function $aadad30153b2a449$export$bdd941b9b8806569(left, right, v0, v1) {
    var edge = [
        null,
        null
    ], index = (0, $84NSf.edges).push(edge) - 1;
    edge.left = left;
    edge.right = right;
    if (v0) $aadad30153b2a449$export$9e883caea829cb44(edge, left, right, v0);
    if (v1) $aadad30153b2a449$export$9e883caea829cb44(edge, right, left, v1);
    (0, $84NSf.cells)[left.index].halfedges.push(index);
    (0, $84NSf.cells)[right.index].halfedges.push(index);
    return edge;
}
function $aadad30153b2a449$export$681cc0bbec712be1(left, v0, v1) {
    var edge = [
        v0,
        v1
    ];
    edge.left = left;
    return edge;
}
function $aadad30153b2a449$export$9e883caea829cb44(edge, left, right, vertex) {
    if (!edge[0] && !edge[1]) {
        edge[0] = vertex;
        edge.left = left;
        edge.right = right;
    } else if (edge.left === right) edge[1] = vertex;
    else edge[0] = vertex;
}
// Liang–Barsky line clipping.
function $aadad30153b2a449$var$clipEdge(edge, x0, y0, x1, y1) {
    var a = edge[0], b = edge[1], ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
    if (t0 > 0) edge[0] = [
        ax + t0 * dx,
        ay + t0 * dy
    ];
    if (t1 < 1) edge[1] = [
        ax + t1 * dx,
        ay + t1 * dy
    ];
    return true;
}
function $aadad30153b2a449$var$connectEdge(edge, x0, y0, x1, y1) {
    var v1 = edge[1];
    if (v1) return true;
    var v0 = edge[0], left = edge.left, right = edge.right, lx = left[0], ly = left[1], rx = right[0], ry = right[1], fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
    if (ry === ly) {
        if (fx < x0 || fx >= x1) return;
        if (lx > rx) {
            if (!v0) v0 = [
                fx,
                y0
            ];
            else if (v0[1] >= y1) return;
            v1 = [
                fx,
                y1
            ];
        } else {
            if (!v0) v0 = [
                fx,
                y1
            ];
            else if (v0[1] < y0) return;
            v1 = [
                fx,
                y0
            ];
        }
    } else {
        fm = (lx - rx) / (ry - ly);
        fb = fy - fm * fx;
        if (fm < -1 || fm > 1) {
            if (lx > rx) {
                if (!v0) v0 = [
                    (y0 - fb) / fm,
                    y0
                ];
                else if (v0[1] >= y1) return;
                v1 = [
                    (y1 - fb) / fm,
                    y1
                ];
            } else {
                if (!v0) v0 = [
                    (y1 - fb) / fm,
                    y1
                ];
                else if (v0[1] < y0) return;
                v1 = [
                    (y0 - fb) / fm,
                    y0
                ];
            }
        } else if (ly < ry) {
            if (!v0) v0 = [
                x0,
                fm * x0 + fb
            ];
            else if (v0[0] >= x1) return;
            v1 = [
                x1,
                fm * x1 + fb
            ];
        } else {
            if (!v0) v0 = [
                x1,
                fm * x1 + fb
            ];
            else if (v0[0] < x0) return;
            v1 = [
                x0,
                fm * x0 + fb
            ];
        }
    }
    edge[0] = v0;
    edge[1] = v1;
    return true;
}
function $aadad30153b2a449$export$db4502aa9c1617af(x0, y0, x1, y1) {
    var i = (0, $84NSf.edges).length, edge;
    while(i--)if (!$aadad30153b2a449$var$connectEdge(edge = (0, $84NSf.edges)[i], x0, y0, x1, y1) || !$aadad30153b2a449$var$clipEdge(edge, x0, y0, x1, y1) || !(Math.abs(edge[0][0] - edge[1][0]) > (0, $84NSf.epsilon) || Math.abs(edge[0][1] - edge[1][1]) > (0, $84NSf.epsilon))) delete (0, $84NSf.edges)[i];
}

});


parcelRegister("iptZm", function(module, exports) {

$parcel$export(module.exports, "firstCircle", function () { return $d671d2f218de17bc$export$2ca650a30b282a37; });
$parcel$export(module.exports, "attachCircle", function () { return $d671d2f218de17bc$export$2a19333f6373b7a2; });
$parcel$export(module.exports, "detachCircle", function () { return $d671d2f218de17bc$export$f0bd50ff687673c1; });

var $6MBGl = parcelRequire("6MBGl");

var $84NSf = parcelRequire("84NSf");
var $d671d2f218de17bc$var$circlePool = [];
var $d671d2f218de17bc$export$2ca650a30b282a37;
function $d671d2f218de17bc$var$Circle() {
    (0, $6MBGl.RedBlackNode)(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
}
function $d671d2f218de17bc$export$2a19333f6373b7a2(arc) {
    var lArc = arc.P, rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite[0], by = cSite[1], ax = lSite[0] - bx, ay = lSite[1] - by, cx = rSite[0] - bx, cy = rSite[1] - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -(0, $84NSf.epsilon2)) return;
    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d;
    var circle = $d671d2f218de17bc$var$circlePool.pop() || new $d671d2f218de17bc$var$Circle;
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
    arc.circle = circle;
    var before = null, node = (0, $84NSf.circles)._;
    while(node){
        if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
            if (node.L) node = node.L;
            else {
                before = node.P;
                break;
            }
        } else if (node.R) node = node.R;
        else {
            before = node;
            break;
        }
    }
    (0, $84NSf.circles).insert(before, circle);
    if (!before) $d671d2f218de17bc$export$2ca650a30b282a37 = circle;
}
function $d671d2f218de17bc$export$f0bd50ff687673c1(arc) {
    var circle = arc.circle;
    if (circle) {
        if (!circle.P) $d671d2f218de17bc$export$2ca650a30b282a37 = circle.N;
        (0, $84NSf.circles).remove(circle);
        $d671d2f218de17bc$var$circlePool.push(circle);
        (0, $6MBGl.RedBlackNode)(circle);
        arc.circle = null;
    }
}

});





parcelRegister("4PSy0", function(module, exports) {

$parcel$export(module.exports, "zoom", function () { return (parcelRequire("26KNf")).default; });
$parcel$export(module.exports, "zoomTransform", function () { return (parcelRequire("eJgbL")).default; });
$parcel$export(module.exports, "zoomIdentity", function () { return (parcelRequire("eJgbL")).identity; });

var $26KNf = parcelRequire("26KNf");

var $eJgbL = parcelRequire("eJgbL");

});
parcelRegister("26KNf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1890707d729109f0$export$2e2bcd8739ae039; });

var $1TJJe = parcelRequire("1TJJe");

var $9DnDL = parcelRequire("9DnDL");

var $9Zp9m = parcelRequire("9Zp9m");

var $fvaBb = parcelRequire("fvaBb");
var $5HV9y = parcelRequire("5HV9y");
var $ivpDr = parcelRequire("ivpDr");
var $lTUhy = parcelRequire("lTUhy");
parcelRequire("5XltZ");
var $i0eBU = parcelRequire("i0eBU");

var $hRtwP = parcelRequire("hRtwP");

var $guZEE = parcelRequire("guZEE");

var $eJgbL = parcelRequire("eJgbL");

var $2Zmrw = parcelRequire("2Zmrw");
// Ignore right-click, since that should open the context menu.
function $1890707d729109f0$var$defaultFilter() {
    return !(0, $fvaBb.event).ctrlKey && !(0, $fvaBb.event).button;
}
function $1890707d729109f0$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $1890707d729109f0$var$defaultTransform() {
    return this.__zoom || (0, $eJgbL.identity);
}
function $1890707d729109f0$var$defaultWheelDelta() {
    return -(0, $fvaBb.event).deltaY * ((0, $fvaBb.event).deltaMode === 1 ? 0.05 : (0, $fvaBb.event).deltaMode ? 1 : 0.002);
}
function $1890707d729109f0$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $1890707d729109f0$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $1890707d729109f0$export$2e2bcd8739ae039() {
    var filter = $1890707d729109f0$var$defaultFilter, extent = $1890707d729109f0$var$defaultExtent, constrain = $1890707d729109f0$var$defaultConstrain, wheelDelta = $1890707d729109f0$var$defaultWheelDelta, touchable = $1890707d729109f0$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $9Zp9m.default), listeners = (0, $1TJJe.default)("start", "zoom", "end"), touchstarting, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0;
    function zoom(selection) {
        selection.property("__zoom", $1890707d729109f0$var$defaultTransform).on("wheel.zoom", wheeled).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $1890707d729109f0$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point);
        else selection.interrupt().each(function() {
            gesture(this, arguments).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p);
    };
    zoom.scaleTo = function(selection, k, p) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p);
    };
    zoom.translateBy = function(selection, x, y) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        });
    };
    zoom.translateTo = function(selection, x, y, p) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $eJgbL.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $eJgbL.Transform)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $eJgbL.Transform)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $eJgbL.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            (0, $fvaBb.customEvent)(new (0, $guZEE.default)(zoom, type, this.that.__zoom), listeners.apply, listeners, [
                type,
                this.that,
                this.args
            ]);
        }
    };
    function wheeled() {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, arguments), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $5HV9y.default)(this);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $i0eBU.default)(this);
            g.start();
        }
        (0, $2Zmrw.default)();
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned() {
        if (touchending || !filter.apply(this, arguments)) return;
        var g = gesture(this, arguments, true), v = (0, $ivpDr.default)((0, $fvaBb.event).view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $5HV9y.default)(this), x0 = (0, $fvaBb.event).clientX, y0 = (0, $fvaBb.event).clientY;
        (0, $9DnDL.default)((0, $fvaBb.event).view);
        (0, $2Zmrw.nopropagation)();
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $i0eBU.default)(this);
        g.start();
        function mousemoved() {
            (0, $2Zmrw.default)();
            if (!g.moved) {
                var dx = (0, $fvaBb.event).clientX - x0, dy = (0, $fvaBb.event).clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $5HV9y.default)(g.that), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped() {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $9DnDL.yesdrag)((0, $fvaBb.event).view, g.moved);
            (0, $2Zmrw.default)();
            g.end();
        }
    }
    function dblclicked() {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $5HV9y.default)(this), p1 = t0.invert(p0), k1 = t0.k * ((0, $fvaBb.event).shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments), translateExtent);
        (0, $2Zmrw.default)();
        if (duration > 0) (0, $ivpDr.default)(this).transition().duration(duration).call(schedule, t1, p0);
        else (0, $ivpDr.default)(this).call(zoom.transform, t1);
    }
    function touchstarted() {
        if (!filter.apply(this, arguments)) return;
        var touches = (0, $fvaBb.event).touches, n = touches.length, g = gesture(this, arguments, (0, $fvaBb.event).changedTouches.length === n), started, i, t, p;
        (0, $2Zmrw.nopropagation)();
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $lTUhy.default)(this, touches, t.identifier);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $i0eBU.default)(this);
            g.start();
        }
    }
    function touchmoved() {
        if (!this.__zooming) return;
        var g = gesture(this, arguments), touches = (0, $fvaBb.event).changedTouches, n = touches.length, i, t, p, l;
        (0, $2Zmrw.default)();
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        g.taps = 0;
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $lTUhy.default)(this, touches, t.identifier);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended() {
        if (!this.__zooming) return;
        var g = gesture(this, arguments), touches = (0, $fvaBb.event).changedTouches, n = touches.length, i, t;
        (0, $2Zmrw.nopropagation)();
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                var p = (0, $ivpDr.default)(this).on("dblclick.zoom");
                if (p) p.apply(this, arguments);
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $hRtwP.default)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $hRtwP.default)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $hRtwP.default)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $hRtwP.default)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    return zoom;
}

});
parcelRegister("hRtwP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d00e4aa3ad84ec9b$export$2e2bcd8739ae039; });
function $d00e4aa3ad84ec9b$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("guZEE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c02f4608ae591b47$export$2e2bcd8739ae039; });
function $c02f4608ae591b47$export$2e2bcd8739ae039(target, type, transform) {
    this.target = target;
    this.type = type;
    this.transform = transform;
}

});

parcelRegister("eJgbL", function(module, exports) {

$parcel$export(module.exports, "Transform", function () { return $ab91d36151910f02$export$563a914cafbdc389; });
$parcel$export(module.exports, "identity", function () { return $ab91d36151910f02$export$f0954fd7d5368655; });
$parcel$export(module.exports, "default", function () { return $ab91d36151910f02$export$2e2bcd8739ae039; });
function $ab91d36151910f02$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$ab91d36151910f02$export$563a914cafbdc389.prototype = {
    constructor: $ab91d36151910f02$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $ab91d36151910f02$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $ab91d36151910f02$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $ab91d36151910f02$export$f0954fd7d5368655 = new $ab91d36151910f02$export$563a914cafbdc389(1, 0, 0);
$ab91d36151910f02$export$2e2bcd8739ae039.prototype = $ab91d36151910f02$export$563a914cafbdc389.prototype;
function $ab91d36151910f02$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $ab91d36151910f02$export$f0954fd7d5368655;
    return node.__zoom;
}

});

parcelRegister("2Zmrw", function(module, exports) {

$parcel$export(module.exports, "nopropagation", function () { return $22d2aff89dfc21b4$export$2e2561858db9bf47; });
$parcel$export(module.exports, "default", function () { return $22d2aff89dfc21b4$export$2e2bcd8739ae039; });

var $fvaBb = parcelRequire("fvaBb");
function $22d2aff89dfc21b4$export$2e2561858db9bf47() {
    (0, $fvaBb.event).stopImmediatePropagation();
}
function $22d2aff89dfc21b4$export$2e2bcd8739ae039() {
    (0, $fvaBb.event).preventDefault();
    (0, $fvaBb.event).stopImmediatePropagation();
}

});





parcelRegister("bnMSv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8497c1e3bf13d11c$export$2e2bcd8739ae039; });

var $lRg87 = parcelRequire("lRg87");

var $3jkdm = parcelRequire("3jkdm");

var $hTj76 = parcelRequire("hTj76");

var $6kHnY = parcelRequire("6kHnY");

var $dG33B = parcelRequire("dG33B");

var $6qd2L = parcelRequire("6qd2L");
function $8497c1e3bf13d11c$var$mangle(key) {
    return "$" + key;
}
function $8497c1e3bf13d11c$var$unmangle(key) {
    return key.substring(1);
}
function $8497c1e3bf13d11c$var$Map$1() {
    this._store = {};
}
$8497c1e3bf13d11c$var$Map$1.prototype.get = function(key) {
    var mangled = $8497c1e3bf13d11c$var$mangle(key);
    return this._store[mangled];
};
$8497c1e3bf13d11c$var$Map$1.prototype.set = function(key, value) {
    var mangled = $8497c1e3bf13d11c$var$mangle(key);
    this._store[mangled] = value;
    return true;
};
$8497c1e3bf13d11c$var$Map$1.prototype.has = function(key) {
    var mangled = $8497c1e3bf13d11c$var$mangle(key);
    return mangled in this._store;
};
$8497c1e3bf13d11c$var$Map$1.prototype.keys = function() {
    return Object.keys(this._store).map((k)=>$8497c1e3bf13d11c$var$unmangle(k));
};
$8497c1e3bf13d11c$var$Map$1.prototype.delete = function(key) {
    var mangled = $8497c1e3bf13d11c$var$mangle(key);
    var res = mangled in this._store;
    delete this._store[mangled];
    return res;
};
$8497c1e3bf13d11c$var$Map$1.prototype.forEach = function(cb) {
    var keys = Object.keys(this._store);
    for(var i = 0, len = keys.length; i < len; i++){
        var key = keys[i];
        var value = this._store[key];
        key = $8497c1e3bf13d11c$var$unmangle(key);
        cb(value, key);
    }
};
Object.defineProperty($8497c1e3bf13d11c$var$Map$1.prototype, "size", {
    get: function() {
        return Object.keys(this._store).length;
    }
});
function $8497c1e3bf13d11c$var$Set$1(array) {
    this._store = new $8497c1e3bf13d11c$var$Map$1();
    // init with an array
    if (array && Array.isArray(array)) for(var i = 0, len = array.length; i < len; i++)this.add(array[i]);
}
$8497c1e3bf13d11c$var$Set$1.prototype.add = function(key) {
    return this._store.set(key, true);
};
$8497c1e3bf13d11c$var$Set$1.prototype.has = function(key) {
    return this._store.has(key);
};
$8497c1e3bf13d11c$var$Set$1.prototype.forEach = function(cb) {
    this._store.forEach(function(value, key) {
        cb(key);
    });
};
Object.defineProperty($8497c1e3bf13d11c$var$Set$1.prototype, "size", {
    get: function() {
        return this._store.size;
    }
});
// Based on https://kangax.github.io/compat-table/es6/ we can sniff out
// incomplete Map/Set implementations which would otherwise cause our tests to fail.
// Notably they fail in IE11 and iOS 8.4, which this prevents.
function $8497c1e3bf13d11c$var$supportsMapAndSet() {
    if (typeof Symbol === "undefined" || typeof Map === "undefined" || typeof Set === "undefined") return false;
    var prop = Object.getOwnPropertyDescriptor(Map, Symbol.species);
    return prop && "get" in prop && Map[Symbol.species] === Map;
}
// based on https://github.com/montagejs/collections
var $8497c1e3bf13d11c$var$ExportedSet;
var $8497c1e3bf13d11c$var$ExportedMap;
if ($8497c1e3bf13d11c$var$supportsMapAndSet()) {
    $8497c1e3bf13d11c$var$ExportedSet = Set;
    $8497c1e3bf13d11c$var$ExportedMap = Map;
} else {
    $8497c1e3bf13d11c$var$ExportedSet = $8497c1e3bf13d11c$var$Set$1;
    $8497c1e3bf13d11c$var$ExportedMap = $8497c1e3bf13d11c$var$Map$1;
}
function $8497c1e3bf13d11c$var$isBinaryObject(object) {
    return typeof ArrayBuffer !== "undefined" && object instanceof ArrayBuffer || typeof Blob !== "undefined" && object instanceof Blob;
}
function $8497c1e3bf13d11c$var$cloneArrayBuffer(buff) {
    if (typeof buff.slice === "function") return buff.slice(0);
    // IE10-11 slice() polyfill
    var target = new ArrayBuffer(buff.byteLength);
    var targetArray = new Uint8Array(target);
    var sourceArray = new Uint8Array(buff);
    targetArray.set(sourceArray);
    return target;
}
function $8497c1e3bf13d11c$var$cloneBinaryObject(object) {
    if (object instanceof ArrayBuffer) return $8497c1e3bf13d11c$var$cloneArrayBuffer(object);
    var size = object.size;
    var type = object.type;
    // Blob
    if (typeof object.slice === "function") return object.slice(0, size, type);
    // PhantomJS slice() replacement
    return object.webkitSlice(0, size, type);
}
// most of this is borrowed from lodash.isPlainObject:
// https://github.com/fis-components/lodash.isplainobject/
// blob/29c358140a74f252aeb08c9eb28bef86f2217d4a/index.js
var $8497c1e3bf13d11c$var$funcToString = Function.prototype.toString;
var $8497c1e3bf13d11c$var$objectCtorString = $8497c1e3bf13d11c$var$funcToString.call(Object);
function $8497c1e3bf13d11c$var$isPlainObject(value) {
    var proto = Object.getPrototypeOf(value);
    /* istanbul ignore if */ if (proto === null) return true;
    var Ctor = proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $8497c1e3bf13d11c$var$funcToString.call(Ctor) == $8497c1e3bf13d11c$var$objectCtorString;
}
function $8497c1e3bf13d11c$var$clone(object) {
    var newObject;
    var i;
    var len;
    if (!object || typeof object !== "object") return object;
    if (Array.isArray(object)) {
        newObject = [];
        for(i = 0, len = object.length; i < len; i++)newObject[i] = $8497c1e3bf13d11c$var$clone(object[i]);
        return newObject;
    }
    // special case: to avoid inconsistencies between IndexedDB
    // and other backends, we automatically stringify Dates
    if (object instanceof Date && isFinite(object)) return object.toISOString();
    if ($8497c1e3bf13d11c$var$isBinaryObject(object)) return $8497c1e3bf13d11c$var$cloneBinaryObject(object);
    if (!$8497c1e3bf13d11c$var$isPlainObject(object)) return object; // don't clone objects like Workers
    newObject = {};
    for(i in object)/* istanbul ignore else */ if (Object.prototype.hasOwnProperty.call(object, i)) {
        var value = $8497c1e3bf13d11c$var$clone(object[i]);
        if (typeof value !== "undefined") newObject[i] = value;
    }
    return newObject;
}
function $8497c1e3bf13d11c$var$once(fun) {
    var called = false;
    return function(...args) {
        /* istanbul ignore if */ if (called) // this is a smoke test and should never actually happen
        throw new Error("once called more than once");
        else {
            called = true;
            fun.apply(this, args);
        }
    };
}
function $8497c1e3bf13d11c$var$toPromise(func) {
    //create the function we will be returning
    return function(...args) {
        // Clone arguments
        args = $8497c1e3bf13d11c$var$clone(args);
        var self1 = this;
        // if the last argument is a function, assume its a callback
        var usedCB = typeof args[args.length - 1] === "function" ? args.pop() : false;
        var promise = new Promise(function(fulfill, reject) {
            var resp;
            try {
                var callback = $8497c1e3bf13d11c$var$once(function(err, mesg) {
                    if (err) reject(err);
                    else fulfill(mesg);
                });
                // create a callback for this invocation
                // apply the function in the orig context
                args.push(callback);
                resp = func.apply(self1, args);
                if (resp && typeof resp.then === "function") fulfill(resp);
            } catch (e) {
                reject(e);
            }
        });
        // if there is a callback, call it back
        if (usedCB) promise.then(function(result) {
            usedCB(null, result);
        }, usedCB);
        return promise;
    };
}
function $8497c1e3bf13d11c$var$logApiCall(self1, name, args) {
    /* istanbul ignore if */ if (self1.constructor.listeners("debug").length) {
        var logArgs = [
            "api",
            self1.name,
            name
        ];
        for(var i = 0; i < args.length - 1; i++)logArgs.push(args[i]);
        self1.constructor.emit("debug", logArgs);
        // override the callback itself to log the response
        var origCallback = args[args.length - 1];
        args[args.length - 1] = function(err, res) {
            var responseArgs = [
                "api",
                self1.name,
                name
            ];
            responseArgs = responseArgs.concat(err ? [
                "error",
                err
            ] : [
                "success",
                res
            ]);
            self1.constructor.emit("debug", responseArgs);
            origCallback(err, res);
        };
    }
}
function $8497c1e3bf13d11c$var$adapterFun(name, callback) {
    return $8497c1e3bf13d11c$var$toPromise(function(...args) {
        if (this._closed) return Promise.reject(new Error("database is closed"));
        if (this._destroyed) return Promise.reject(new Error("database is destroyed"));
        var self1 = this;
        $8497c1e3bf13d11c$var$logApiCall(self1, name, args);
        if (!this.taskqueue.isReady) return new Promise(function(fulfill, reject) {
            self1.taskqueue.addTask(function(failed) {
                if (failed) reject(failed);
                else fulfill(self1[name].apply(self1, args));
            });
        });
        return callback.apply(this, args);
    });
}
// like underscore/lodash _.pick()
function $8497c1e3bf13d11c$var$pick(obj, arr) {
    var res = {};
    for(var i = 0, len = arr.length; i < len; i++){
        var prop = arr[i];
        if (prop in obj) res[prop] = obj[prop];
    }
    return res;
}
// Most browsers throttle concurrent requests at 6, so it's silly
// to shim _bulk_get by trying to launch potentially hundreds of requests
// and then letting the majority time out. We can handle this ourselves.
var $8497c1e3bf13d11c$var$MAX_NUM_CONCURRENT_REQUESTS = 6;
function $8497c1e3bf13d11c$var$identityFunction(x) {
    return x;
}
function $8497c1e3bf13d11c$var$formatResultForOpenRevsGet(result) {
    return [
        {
            ok: result
        }
    ];
}
// shim for P/CouchDB adapters that don't directly implement _bulk_get
function $8497c1e3bf13d11c$var$bulkGet(db, opts, callback) {
    var requests = opts.docs;
    // consolidate into one request per doc if possible
    var requestsById = new $8497c1e3bf13d11c$var$ExportedMap();
    requests.forEach(function(request) {
        if (requestsById.has(request.id)) requestsById.get(request.id).push(request);
        else requestsById.set(request.id, [
            request
        ]);
    });
    var numDocs = requestsById.size;
    var numDone = 0;
    var perDocResults = new Array(numDocs);
    function collapseResultsAndFinish() {
        var results = [];
        perDocResults.forEach(function(res) {
            res.docs.forEach(function(info) {
                results.push({
                    id: res.id,
                    docs: [
                        info
                    ]
                });
            });
        });
        callback(null, {
            results: results
        });
    }
    function checkDone() {
        if (++numDone === numDocs) collapseResultsAndFinish();
    }
    function gotResult(docIndex, id, docs) {
        perDocResults[docIndex] = {
            id: id,
            docs: docs
        };
        checkDone();
    }
    var allRequests = [];
    requestsById.forEach(function(value, key) {
        allRequests.push(key);
    });
    var i = 0;
    function nextBatch() {
        if (i >= allRequests.length) return;
        var upTo = Math.min(i + $8497c1e3bf13d11c$var$MAX_NUM_CONCURRENT_REQUESTS, allRequests.length);
        var batch = allRequests.slice(i, upTo);
        processBatch(batch, i);
        i += batch.length;
    }
    function processBatch(batch, offset) {
        batch.forEach(function(docId, j) {
            var docIdx = offset + j;
            var docRequests = requestsById.get(docId);
            // just use the first request as the "template"
            // TODO: The _bulk_get API allows for more subtle use cases than this,
            // but for now it is unlikely that there will be a mix of different
            // "atts_since" or "attachments" in the same request, since it's just
            // replicate.js that is using this for the moment.
            // Also, atts_since is aspirational, since we don't support it yet.
            var docOpts = $8497c1e3bf13d11c$var$pick(docRequests[0], [
                "atts_since",
                "attachments"
            ]);
            docOpts.open_revs = docRequests.map(function(request) {
                // rev is optional, open_revs disallowed
                return request.rev;
            });
            // remove falsey / undefined revisions
            docOpts.open_revs = docOpts.open_revs.filter($8497c1e3bf13d11c$var$identityFunction);
            var formatResult = $8497c1e3bf13d11c$var$identityFunction;
            if (docOpts.open_revs.length === 0) {
                delete docOpts.open_revs;
                // when fetching only the "winning" leaf,
                // transform the result so it looks like an open_revs
                // request
                formatResult = $8497c1e3bf13d11c$var$formatResultForOpenRevsGet;
            }
            // globally-supplied options
            [
                "revs",
                "attachments",
                "binary",
                "ajax",
                "latest"
            ].forEach(function(param) {
                if (param in opts) docOpts[param] = opts[param];
            });
            db.get(docId, docOpts, function(err, res) {
                var result;
                /* istanbul ignore if */ if (err) result = [
                    {
                        error: err
                    }
                ];
                else result = formatResult(res);
                gotResult(docIdx, docId, result);
                nextBatch();
            });
        });
    }
    nextBatch();
}
var $8497c1e3bf13d11c$var$hasLocal;
try {
    localStorage.setItem("_pouch_check_localstorage", 1);
    $8497c1e3bf13d11c$var$hasLocal = !!localStorage.getItem("_pouch_check_localstorage");
} catch (e) {
    $8497c1e3bf13d11c$var$hasLocal = false;
}
function $8497c1e3bf13d11c$var$hasLocalStorage() {
    return $8497c1e3bf13d11c$var$hasLocal;
}
// Custom nextTick() shim for browsers. In node, this will just be process.nextTick(). We
class $8497c1e3bf13d11c$var$Changes extends (0, (/*@__PURE__*/$parcel$interopDefault($dG33B))) {
    constructor(){
        super();
        this._listeners = {};
        if ($8497c1e3bf13d11c$var$hasLocalStorage()) addEventListener("storage", (e)=>{
            this.emit(e.key);
        });
    }
    addListener(dbName, id, db, opts) {
        if (this._listeners[id]) return;
        var inprogress = false;
        var self1 = this;
        function eventFunction() {
            if (!self1._listeners[id]) return;
            if (inprogress) {
                inprogress = "waiting";
                return;
            }
            inprogress = true;
            var changesOpts = $8497c1e3bf13d11c$var$pick(opts, [
                "style",
                "include_docs",
                "attachments",
                "conflicts",
                "filter",
                "doc_ids",
                "view",
                "since",
                "query_params",
                "binary",
                "return_docs"
            ]);
            function onError() {
                inprogress = false;
            }
            db.changes(changesOpts).on("change", function(c) {
                if (c.seq > opts.since && !opts.cancelled) {
                    opts.since = c.seq;
                    opts.onChange(c);
                }
            }).on("complete", function() {
                if (inprogress === "waiting") (0, (/*@__PURE__*/$parcel$interopDefault($lRg87)))(eventFunction);
                inprogress = false;
            }).on("error", onError);
        }
        this._listeners[id] = eventFunction;
        this.on(dbName, eventFunction);
    }
    removeListener(dbName, id) {
        if (!(id in this._listeners)) return;
        super.removeListener(dbName, this._listeners[id]);
        delete this._listeners[id];
    }
    notifyLocalWindows(dbName) {
        //do a useless change on a storage thing
        //in order to get other windows's listeners to activate
        if ($8497c1e3bf13d11c$var$hasLocalStorage()) localStorage[dbName] = localStorage[dbName] === "a" ? "b" : "a";
    }
    notify(dbName) {
        this.emit(dbName);
        this.notifyLocalWindows(dbName);
    }
}
function $8497c1e3bf13d11c$var$guardedConsole(method) {
    /* istanbul ignore else */ if (typeof console !== "undefined" && typeof console[method] === "function") {
        var args = Array.prototype.slice.call(arguments, 1);
        console[method].apply(console, args);
    }
}
function $8497c1e3bf13d11c$var$randomNumber(min, max) {
    var maxTimeout = 600000; // Hard-coded default of 10 minutes
    min = parseInt(min, 10) || 0;
    max = parseInt(max, 10);
    if (max !== max || max <= min) max = (min || 1) << 1; //doubling
    else max = max + 1;
    // In order to not exceed maxTimeout, pick a random value between half of maxTimeout and maxTimeout
    if (max > maxTimeout) {
        min = maxTimeout >> 1; // divide by two
        max = maxTimeout;
    }
    var ratio = Math.random();
    var range = max - min;
    return ~~(range * ratio + min); // ~~ coerces to an int, but fast.
}
function $8497c1e3bf13d11c$var$defaultBackOff(min) {
    var max = 0;
    if (!min) max = 2000;
    return $8497c1e3bf13d11c$var$randomNumber(min, max);
}
// designed to give info to browser users, who are disturbed
// when they see http errors in the console
function $8497c1e3bf13d11c$var$explainError(status, str) {
    $8497c1e3bf13d11c$var$guardedConsole("info", "The above " + status + " is totally normal. " + str);
}
var $8497c1e3bf13d11c$var$assign;
if (typeof Object.assign === "function") $8497c1e3bf13d11c$var$assign = Object.assign;
else // lite Object.assign polyfill based on
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
$8497c1e3bf13d11c$var$assign = function(target) {
    var to = Object(target);
    for(var index = 1; index < arguments.length; index++){
        var nextSource = arguments[index];
        if (nextSource != null) {
            for(var nextKey in nextSource)// Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) to[nextKey] = nextSource[nextKey];
        }
    }
    return to;
};
var $8497c1e3bf13d11c$var$$inject_Object_assign = $8497c1e3bf13d11c$var$assign;
class $8497c1e3bf13d11c$var$PouchError extends Error {
    constructor(status, error, reason){
        super();
        this.status = status;
        this.name = error;
        this.message = reason;
        this.error = true;
    }
    toString() {
        return JSON.stringify({
            status: this.status,
            name: this.name,
            message: this.message,
            reason: this.reason
        });
    }
}
var $8497c1e3bf13d11c$var$UNAUTHORIZED = new $8497c1e3bf13d11c$var$PouchError(401, "unauthorized", "Name or password is incorrect.");
var $8497c1e3bf13d11c$var$MISSING_BULK_DOCS = new $8497c1e3bf13d11c$var$PouchError(400, "bad_request", "Missing JSON list of 'docs'");
var $8497c1e3bf13d11c$var$MISSING_DOC = new $8497c1e3bf13d11c$var$PouchError(404, "not_found", "missing");
var $8497c1e3bf13d11c$var$REV_CONFLICT = new $8497c1e3bf13d11c$var$PouchError(409, "conflict", "Document update conflict");
var $8497c1e3bf13d11c$var$INVALID_ID = new $8497c1e3bf13d11c$var$PouchError(400, "bad_request", "_id field must contain a string");
var $8497c1e3bf13d11c$var$MISSING_ID = new $8497c1e3bf13d11c$var$PouchError(412, "missing_id", "_id is required for puts");
var $8497c1e3bf13d11c$var$RESERVED_ID = new $8497c1e3bf13d11c$var$PouchError(400, "bad_request", "Only reserved document ids may start with underscore.");
var $8497c1e3bf13d11c$var$NOT_OPEN = new $8497c1e3bf13d11c$var$PouchError(412, "precondition_failed", "Database not open");
var $8497c1e3bf13d11c$var$UNKNOWN_ERROR = new $8497c1e3bf13d11c$var$PouchError(500, "unknown_error", "Database encountered an unknown error");
var $8497c1e3bf13d11c$var$BAD_ARG = new $8497c1e3bf13d11c$var$PouchError(500, "badarg", "Some query argument is invalid");
var $8497c1e3bf13d11c$var$INVALID_REQUEST = new $8497c1e3bf13d11c$var$PouchError(400, "invalid_request", "Request was invalid");
var $8497c1e3bf13d11c$var$QUERY_PARSE_ERROR = new $8497c1e3bf13d11c$var$PouchError(400, "query_parse_error", "Some query parameter is invalid");
var $8497c1e3bf13d11c$var$DOC_VALIDATION = new $8497c1e3bf13d11c$var$PouchError(500, "doc_validation", "Bad special document member");
var $8497c1e3bf13d11c$var$BAD_REQUEST = new $8497c1e3bf13d11c$var$PouchError(400, "bad_request", "Something wrong with the request");
var $8497c1e3bf13d11c$var$NOT_AN_OBJECT = new $8497c1e3bf13d11c$var$PouchError(400, "bad_request", "Document must be a JSON object");
var $8497c1e3bf13d11c$var$DB_MISSING = new $8497c1e3bf13d11c$var$PouchError(404, "not_found", "Database not found");
var $8497c1e3bf13d11c$var$IDB_ERROR = new $8497c1e3bf13d11c$var$PouchError(500, "indexed_db_went_bad", "unknown");
var $8497c1e3bf13d11c$var$WSQ_ERROR = new $8497c1e3bf13d11c$var$PouchError(500, "web_sql_went_bad", "unknown");
var $8497c1e3bf13d11c$var$LDB_ERROR = new $8497c1e3bf13d11c$var$PouchError(500, "levelDB_went_went_bad", "unknown");
var $8497c1e3bf13d11c$var$FORBIDDEN = new $8497c1e3bf13d11c$var$PouchError(403, "forbidden", "Forbidden by design doc validate_doc_update function");
var $8497c1e3bf13d11c$var$INVALID_REV = new $8497c1e3bf13d11c$var$PouchError(400, "bad_request", "Invalid rev format");
var $8497c1e3bf13d11c$var$FILE_EXISTS = new $8497c1e3bf13d11c$var$PouchError(412, "file_exists", "The database could not be created, the file already exists.");
var $8497c1e3bf13d11c$var$MISSING_STUB = new $8497c1e3bf13d11c$var$PouchError(412, "missing_stub", "A pre-existing attachment stub wasn't found");
var $8497c1e3bf13d11c$var$INVALID_URL = new $8497c1e3bf13d11c$var$PouchError(413, "invalid_url", "Provided URL is invalid");
function $8497c1e3bf13d11c$var$createError(error, reason) {
    function CustomPouchError(reason) {
        // inherit error properties from our parent error manually
        // so as to allow proper JSON parsing.
        /* jshint ignore:start */ var names = Object.getOwnPropertyNames(error);
        for(var i = 0, len = names.length; i < len; i++)if (typeof error[names[i]] !== "function") this[names[i]] = error[names[i]];
        if (this.stack === undefined) this.stack = new Error().stack;
        /* jshint ignore:end */ if (reason !== undefined) this.reason = reason;
    }
    CustomPouchError.prototype = $8497c1e3bf13d11c$var$PouchError.prototype;
    return new CustomPouchError(reason);
}
function $8497c1e3bf13d11c$var$generateErrorFromResponse(err) {
    if (typeof err !== "object") {
        var data = err;
        err = $8497c1e3bf13d11c$var$UNKNOWN_ERROR;
        err.data = data;
    }
    if ("error" in err && err.error === "conflict") {
        err.name = "conflict";
        err.status = 409;
    }
    if (!("name" in err)) err.name = err.error || "unknown";
    if (!("status" in err)) err.status = 500;
    if (!("message" in err)) err.message = err.message || err.reason;
    if (!("stack" in err)) err.stack = new Error().stack;
    return err;
}
function $8497c1e3bf13d11c$var$tryFilter(filter, doc, req) {
    try {
        return !filter(doc, req);
    } catch (err) {
        var msg = "Filter function threw: " + err.toString();
        return $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$BAD_REQUEST, msg);
    }
}
function $8497c1e3bf13d11c$var$filterChange(opts) {
    var req = {};
    var hasFilter = opts.filter && typeof opts.filter === "function";
    req.query = opts.query_params;
    return function filter(change) {
        if (!change.doc) // CSG sends events on the changes feed that don't have documents,
        // this hack makes a whole lot of existing code robust.
        change.doc = {};
        var filterReturn = hasFilter && $8497c1e3bf13d11c$var$tryFilter(opts.filter, change.doc, req);
        if (typeof filterReturn === "object") return filterReturn;
        if (filterReturn) return false;
        if (!opts.include_docs) delete change.doc;
        else if (!opts.attachments) {
            for(var att in change.doc._attachments)/* istanbul ignore else */ if (Object.prototype.hasOwnProperty.call(change.doc._attachments, att)) change.doc._attachments[att].stub = true;
        }
        return true;
    };
}
function $8497c1e3bf13d11c$var$flatten(arrs) {
    var res = [];
    for(var i = 0, len = arrs.length; i < len; i++)res = res.concat(arrs[i]);
    return res;
}
// shim for Function.prototype.name,
// Determine id an ID is valid
//   - invalid IDs begin with an underescore that does not begin '_design' or
//     '_local'
//   - any other string value is a valid id
// Returns the specific error object for each case
function $8497c1e3bf13d11c$var$invalidIdError(id) {
    var err;
    if (!id) err = $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$MISSING_ID);
    else if (typeof id !== "string") err = $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$INVALID_ID);
    else if (/^_/.test(id) && !/^_(design|local)/.test(id)) err = $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$RESERVED_ID);
    if (err) throw err;
}
// Checks if a PouchDB object is "remote" or not. This is
function $8497c1e3bf13d11c$var$isRemote(db) {
    if (typeof db._remote === "boolean") return db._remote;
    /* istanbul ignore next */ if (typeof db.type === "function") {
        $8497c1e3bf13d11c$var$guardedConsole("warn", "db.type() is deprecated and will be removed in a future version of PouchDB");
        return db.type() === "http";
    }
    /* istanbul ignore next */ return false;
}
function $8497c1e3bf13d11c$var$listenerCount(ee, type) {
    return "listenerCount" in ee ? ee.listenerCount(type) : (0, (/*@__PURE__*/$parcel$interopDefault($dG33B))).listenerCount(ee, type);
}
function $8497c1e3bf13d11c$var$parseDesignDocFunctionName(s) {
    if (!s) return null;
    var parts = s.split("/");
    if (parts.length === 2) return parts;
    if (parts.length === 1) return [
        s,
        s
    ];
    return null;
}
function $8497c1e3bf13d11c$var$normalizeDesignDocFunctionName(s) {
    var normalized = $8497c1e3bf13d11c$var$parseDesignDocFunctionName(s);
    return normalized ? normalized.join("/") : null;
}
// originally parseUri 1.2.2, now patched by us
// (c) Steven Levithan <stevenlevithan.com>
// MIT License
var $8497c1e3bf13d11c$var$keys = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
];
var $8497c1e3bf13d11c$var$qName = "queryKey";
var $8497c1e3bf13d11c$var$qParser = /(?:^|&)([^&=]*)=?([^&]*)/g;
// use the "loose" parser
/* eslint no-useless-escape: 0 */ var $8497c1e3bf13d11c$var$parser = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
function $8497c1e3bf13d11c$var$parseUri(str) {
    var m = $8497c1e3bf13d11c$var$parser.exec(str);
    var uri = {};
    var i = 14;
    while(i--){
        var key = $8497c1e3bf13d11c$var$keys[i];
        var value = m[i] || "";
        var encoded = [
            "user",
            "password"
        ].indexOf(key) !== -1;
        uri[key] = encoded ? decodeURIComponent(value) : value;
    }
    uri[$8497c1e3bf13d11c$var$qName] = {};
    uri[$8497c1e3bf13d11c$var$keys[12]].replace($8497c1e3bf13d11c$var$qParser, function($0, $1, $2) {
        if ($1) uri[$8497c1e3bf13d11c$var$qName][$1] = $2;
    });
    return uri;
}
// Based on https://github.com/alexdavid/scope-eval v0.0.3
// (source: https://unpkg.com/scope-eval@0.0.3/scope_eval.js)
// This is basically just a wrapper around new Function()
function $8497c1e3bf13d11c$var$scopeEval(source, scope) {
    var keys = [];
    var values = [];
    for(var key in scope)if (Object.prototype.hasOwnProperty.call(scope, key)) {
        keys.push(key);
        values.push(scope[key]);
    }
    keys.push(source);
    return Function.apply(null, keys).apply(null, values);
}
// this is essentially the "update sugar" function from daleharvey/pouchdb#1388
// the diffFun tells us what delta to apply to the doc.  it either returns
// the doc, or false if it doesn't need to do an update after all
function $8497c1e3bf13d11c$var$upsert(db, docId, diffFun) {
    return db.get(docId).catch(function(err) {
        /* istanbul ignore next */ if (err.status !== 404) throw err;
        return {};
    }).then(function(doc) {
        // the user might change the _rev, so save it for posterity
        var docRev = doc._rev;
        var newDoc = diffFun(doc);
        if (!newDoc) // if the diffFun returns falsy, we short-circuit as
        // an optimization
        return {
            updated: false,
            rev: docRev
        };
        // users aren't allowed to modify these values,
        // so reset them here
        newDoc._id = docId;
        newDoc._rev = docRev;
        return $8497c1e3bf13d11c$var$tryAndPut(db, newDoc, diffFun);
    });
}
function $8497c1e3bf13d11c$var$tryAndPut(db, doc, diffFun) {
    return db.put(doc).then(function(res) {
        return {
            updated: true,
            rev: res.rev
        };
    }, function(err) {
        /* istanbul ignore next */ if (err.status !== 409) throw err;
        return $8497c1e3bf13d11c$var$upsert(db, doc._id, diffFun);
    });
}
var $8497c1e3bf13d11c$var$thisAtob = function(str) {
    return atob(str);
};
var $8497c1e3bf13d11c$var$thisBtoa = function(str) {
    return btoa(str);
};
// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor (e.g.
// old QtWebKit versions, Android < 4.4).
function $8497c1e3bf13d11c$var$createBlob(parts, properties) {
    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */ parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    } catch (e) {
        if (e.name !== "TypeError") throw e;
        var Builder = typeof BlobBuilder !== "undefined" ? BlobBuilder : typeof MSBlobBuilder !== "undefined" ? MSBlobBuilder : typeof MozBlobBuilder !== "undefined" ? MozBlobBuilder : WebKitBlobBuilder;
        var builder = new Builder();
        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
        return builder.getBlob(properties.type);
    }
}
// From http://stackoverflow.com/questions/14967647/ (continues on next line)
// encode-decode-image-with-base64-breaks-image (2013-04-21)
function $8497c1e3bf13d11c$var$binaryStringToArrayBuffer(bin) {
    var length = bin.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    for(var i = 0; i < length; i++)arr[i] = bin.charCodeAt(i);
    return buf;
}
function $8497c1e3bf13d11c$var$binStringToBluffer(binString, type) {
    return $8497c1e3bf13d11c$var$createBlob([
        $8497c1e3bf13d11c$var$binaryStringToArrayBuffer(binString)
    ], {
        type: type
    });
}
function $8497c1e3bf13d11c$var$b64ToBluffer(b64, type) {
    return $8497c1e3bf13d11c$var$binStringToBluffer($8497c1e3bf13d11c$var$thisAtob(b64), type);
}
//Can't find original post, but this is close
//http://stackoverflow.com/questions/6965107/ (continues on next line)
//converting-between-strings-and-arraybuffers
function $8497c1e3bf13d11c$var$arrayBufferToBinaryString(buffer) {
    var binary = "";
    var bytes = new Uint8Array(buffer);
    var length = bytes.byteLength;
    for(var i = 0; i < length; i++)binary += String.fromCharCode(bytes[i]);
    return binary;
}
// shim for browsers that don't support it
function $8497c1e3bf13d11c$var$readAsBinaryString(blob, callback) {
    var reader = new FileReader();
    var hasBinaryString = typeof reader.readAsBinaryString === "function";
    reader.onloadend = function(e) {
        var result = e.target.result || "";
        if (hasBinaryString) return callback(result);
        callback($8497c1e3bf13d11c$var$arrayBufferToBinaryString(result));
    };
    if (hasBinaryString) reader.readAsBinaryString(blob);
    else reader.readAsArrayBuffer(blob);
}
function $8497c1e3bf13d11c$var$blobToBinaryString(blobOrBuffer, callback) {
    $8497c1e3bf13d11c$var$readAsBinaryString(blobOrBuffer, function(bin) {
        callback(bin);
    });
}
function $8497c1e3bf13d11c$var$blobToBase64(blobOrBuffer, callback) {
    $8497c1e3bf13d11c$var$blobToBinaryString(blobOrBuffer, function(base64) {
        callback($8497c1e3bf13d11c$var$thisBtoa(base64));
    });
}
// simplified API. universal browser support is assumed
function $8497c1e3bf13d11c$var$readAsArrayBuffer(blob, callback) {
    var reader = new FileReader();
    reader.onloadend = function(e) {
        var result = e.target.result || new ArrayBuffer(0);
        callback(result);
    };
    reader.readAsArrayBuffer(blob);
}
// this is not used in the browser
var $8497c1e3bf13d11c$var$setImmediateShim = self.setImmediate || self.setTimeout;
var $8497c1e3bf13d11c$var$MD5_CHUNK_SIZE = 32768;
function $8497c1e3bf13d11c$var$rawToBase64(raw) {
    return $8497c1e3bf13d11c$var$thisBtoa(raw);
}
function $8497c1e3bf13d11c$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    return blob.slice(start, end);
}
function $8497c1e3bf13d11c$var$appendBlob(buffer, blob, start, end, callback) {
    if (start > 0 || end < blob.size) // only slice blob if we really need to
    blob = $8497c1e3bf13d11c$var$sliceBlob(blob, start, end);
    $8497c1e3bf13d11c$var$readAsArrayBuffer(blob, function(arrayBuffer) {
        buffer.append(arrayBuffer);
        callback();
    });
}
function $8497c1e3bf13d11c$var$appendString(buffer, string, start, end, callback) {
    if (start > 0 || end < string.length) // only create a substring if we really need to
    string = string.substring(start, end);
    buffer.appendBinary(string);
    callback();
}
function $8497c1e3bf13d11c$var$binaryMd5(data, callback) {
    var inputIsString = typeof data === "string";
    var len = inputIsString ? data.length : data.size;
    var chunkSize = Math.min($8497c1e3bf13d11c$var$MD5_CHUNK_SIZE, len);
    var chunks = Math.ceil(len / chunkSize);
    var currentChunk = 0;
    var buffer = inputIsString ? new (0, (/*@__PURE__*/$parcel$interopDefault($3jkdm)))() : new (0, (/*@__PURE__*/$parcel$interopDefault($3jkdm))).ArrayBuffer();
    var append = inputIsString ? $8497c1e3bf13d11c$var$appendString : $8497c1e3bf13d11c$var$appendBlob;
    function next() {
        $8497c1e3bf13d11c$var$setImmediateShim(loadNextChunk);
    }
    function done() {
        var raw = buffer.end(true);
        var base64 = $8497c1e3bf13d11c$var$rawToBase64(raw);
        callback(base64);
        buffer.destroy();
    }
    function loadNextChunk() {
        var start = currentChunk * chunkSize;
        var end = start + chunkSize;
        currentChunk++;
        if (currentChunk < chunks) append(buffer, data, start, end, next);
        else append(buffer, data, start, end, done);
    }
    loadNextChunk();
}
function $8497c1e3bf13d11c$var$stringMd5(string) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3jkdm))).hash(string);
}
/**
 * Creates a new revision string that does NOT include the revision height
 * For example '56649f1b0506c6ca9fda0746eb0cacdf'
 */ function $8497c1e3bf13d11c$var$rev$$1(doc, deterministic_revs) {
    if (!deterministic_revs) return (0, $hTj76.default)().replace(/-/g, "").toLowerCase();
    var mutateableDoc = $8497c1e3bf13d11c$var$$inject_Object_assign({}, doc);
    delete mutateableDoc._rev_tree;
    return $8497c1e3bf13d11c$var$stringMd5(JSON.stringify(mutateableDoc));
}
var $8497c1e3bf13d11c$var$uuid = (0, $hTj76.default); // mimic old import, only v4 is ever used elsewhere
// We fetch all leafs of the revision tree, and sort them based on tree length
// and whether they were deleted, undeleted documents with the longest revision
// tree (most edits) win
// The final sort algorithm is slightly documented in a sidebar here:
// http://guide.couchdb.org/draft/conflicts.html
function $8497c1e3bf13d11c$var$winningRev(metadata) {
    var winningId;
    var winningPos;
    var winningDeleted;
    var toVisit = metadata.rev_tree.slice();
    var node;
    while(node = toVisit.pop()){
        var tree = node.ids;
        var branches = tree[2];
        var pos = node.pos;
        if (branches.length) {
            for(var i = 0, len = branches.length; i < len; i++)toVisit.push({
                pos: pos + 1,
                ids: branches[i]
            });
            continue;
        }
        var deleted = !!tree[1].deleted;
        var id = tree[0];
        // sort by deleted, then pos, then id
        if (!winningId || (winningDeleted !== deleted ? winningDeleted : winningPos !== pos ? winningPos < pos : winningId < id)) {
            winningId = id;
            winningPos = pos;
            winningDeleted = deleted;
        }
    }
    return winningPos + "-" + winningId;
}
// Pretty much all below can be combined into a higher order function to
// traverse revisions
// The return value from the callback will be passed as context to all
// children of that node
function $8497c1e3bf13d11c$var$traverseRevTree(revs, callback) {
    var toVisit = revs.slice();
    var node;
    while(node = toVisit.pop()){
        var pos = node.pos;
        var tree = node.ids;
        var branches = tree[2];
        var newCtx = callback(branches.length === 0, pos, tree[0], node.ctx, tree[1]);
        for(var i = 0, len = branches.length; i < len; i++)toVisit.push({
            pos: pos + 1,
            ids: branches[i],
            ctx: newCtx
        });
    }
}
function $8497c1e3bf13d11c$var$sortByPos(a, b) {
    return a.pos - b.pos;
}
function $8497c1e3bf13d11c$var$collectLeaves(revs) {
    var leaves = [];
    $8497c1e3bf13d11c$var$traverseRevTree(revs, function(isLeaf, pos, id, acc, opts) {
        if (isLeaf) leaves.push({
            rev: pos + "-" + id,
            pos: pos,
            opts: opts
        });
    });
    leaves.sort($8497c1e3bf13d11c$var$sortByPos).reverse();
    for(var i = 0, len = leaves.length; i < len; i++)delete leaves[i].pos;
    return leaves;
}
// returns revs of all conflicts that is leaves such that
// 1. are not deleted and
// 2. are different than winning revision
function $8497c1e3bf13d11c$var$collectConflicts(metadata) {
    var win = $8497c1e3bf13d11c$var$winningRev(metadata);
    var leaves = $8497c1e3bf13d11c$var$collectLeaves(metadata.rev_tree);
    var conflicts = [];
    for(var i = 0, len = leaves.length; i < len; i++){
        var leaf = leaves[i];
        if (leaf.rev !== win && !leaf.opts.deleted) conflicts.push(leaf.rev);
    }
    return conflicts;
}
// compact a tree by marking its non-leafs as missing,
// and return a list of revs to delete
function $8497c1e3bf13d11c$var$compactTree(metadata) {
    var revs = [];
    $8497c1e3bf13d11c$var$traverseRevTree(metadata.rev_tree, function(isLeaf, pos, revHash, ctx, opts) {
        if (opts.status === "available" && !isLeaf) {
            revs.push(pos + "-" + revHash);
            opts.status = "missing";
        }
    });
    return revs;
}
// `findPathToLeaf()` returns an array of revs that goes from the specified
// leaf rev to the root of that leaf’s branch.
//
// eg. for this rev tree:
// 1-9692 ▶ 2-37aa ▶ 3-df22 ▶ 4-6e94 ▶ 5-df4a ▶ 6-6a3a ▶ 7-57e5
//          ┃                 ┗━━━━━━▶ 5-8d8c ▶ 6-65e0
//          ┗━━━━━━▶ 3-43f6 ▶ 4-a3b4
//
// For a `targetRev` of '7-57e5', `findPathToLeaf()` would return ['7-57e5', '6-6a3a', '5-df4a']
// The `revs` arument has the same structure as what `revs_tree` has on e.g.
// the IndexedDB representation of the rev tree datastructure. Please refer to
// tests/unit/test.purge.js for examples of what these look like.
//
// This function will throw an error if:
// - The requested revision does not exist
// - The requested revision is not a leaf
function $8497c1e3bf13d11c$var$findPathToLeaf(revs, targetRev) {
    let path = [];
    const toVisit = revs.slice();
    let node;
    while(node = toVisit.pop()){
        const { pos: pos, ids: tree } = node;
        const rev = `${pos}-${tree[0]}`;
        const branches = tree[2];
        // just assuming we're already working on the path up towards our desired leaf.
        path.push(rev);
        // we've reached the leaf of our dreams, so return the computed path.
        if (rev === targetRev) {
            //…unleeeeess
            if (branches.length !== 0) throw new Error("The requested revision is not a leaf");
            return path.reverse();
        }
        // this is based on the assumption that after we have a leaf (`branches.length == 0`), we handle the next
        // branch. this is true for all branches other than the path leading to the winning rev (which is 7-57e5 in
        // the example above. i've added a reset condition for branching nodes (`branches.length > 1`) as well.
        if (branches.length === 0 || branches.length > 1) path = [];
        // as a next step, we push the branches of this node to `toVisit` for visiting it during the next iteration
        for(let i = 0, len = branches.length; i < len; i++)toVisit.push({
            pos: pos + 1,
            ids: branches[i]
        });
    }
    if (path.length === 0) throw new Error("The requested revision does not exist");
    return path.reverse();
}
// build up a list of all the paths to the leafs in this revision tree
function $8497c1e3bf13d11c$var$rootToLeaf(revs) {
    var paths = [];
    var toVisit = revs.slice();
    var node;
    while(node = toVisit.pop()){
        var pos = node.pos;
        var tree = node.ids;
        var id = tree[0];
        var opts = tree[1];
        var branches = tree[2];
        var isLeaf = branches.length === 0;
        var history = node.history ? node.history.slice() : [];
        history.push({
            id: id,
            opts: opts
        });
        if (isLeaf) paths.push({
            pos: pos + 1 - history.length,
            ids: history
        });
        for(var i = 0, len = branches.length; i < len; i++)toVisit.push({
            pos: pos + 1,
            ids: branches[i],
            history: history
        });
    }
    return paths.reverse();
}
// for a better overview of what this is doing, read:
function $8497c1e3bf13d11c$var$sortByPos$1(a, b) {
    return a.pos - b.pos;
}
// classic binary search
function $8497c1e3bf13d11c$var$binarySearch(arr, item, comparator) {
    var low = 0;
    var high = arr.length;
    var mid;
    while(low < high){
        mid = low + high >>> 1;
        if (comparator(arr[mid], item) < 0) low = mid + 1;
        else high = mid;
    }
    return low;
}
// assuming the arr is sorted, insert the item in the proper place
function $8497c1e3bf13d11c$var$insertSorted(arr, item, comparator) {
    var idx = $8497c1e3bf13d11c$var$binarySearch(arr, item, comparator);
    arr.splice(idx, 0, item);
}
// Turn a path as a flat array into a tree with a single branch.
// If any should be stemmed from the beginning of the array, that's passed
// in as the second argument
function $8497c1e3bf13d11c$var$pathToTree(path, numStemmed) {
    var root;
    var leaf;
    for(var i = numStemmed, len = path.length; i < len; i++){
        var node = path[i];
        var currentLeaf = [
            node.id,
            node.opts,
            []
        ];
        if (leaf) {
            leaf[2].push(currentLeaf);
            leaf = currentLeaf;
        } else root = leaf = currentLeaf;
    }
    return root;
}
// compare the IDs of two trees
function $8497c1e3bf13d11c$var$compareTree(a, b) {
    return a[0] < b[0] ? -1 : 1;
}
// Merge two trees together
// The roots of tree1 and tree2 must be the same revision
function $8497c1e3bf13d11c$var$mergeTree(in_tree1, in_tree2) {
    var queue = [
        {
            tree1: in_tree1,
            tree2: in_tree2
        }
    ];
    var conflicts = false;
    while(queue.length > 0){
        var item = queue.pop();
        var tree1 = item.tree1;
        var tree2 = item.tree2;
        if (tree1[1].status || tree2[1].status) tree1[1].status = tree1[1].status === "available" || tree2[1].status === "available" ? "available" : "missing";
        for(var i = 0; i < tree2[2].length; i++){
            if (!tree1[2][0]) {
                conflicts = "new_leaf";
                tree1[2][0] = tree2[2][i];
                continue;
            }
            var merged = false;
            for(var j = 0; j < tree1[2].length; j++)if (tree1[2][j][0] === tree2[2][i][0]) {
                queue.push({
                    tree1: tree1[2][j],
                    tree2: tree2[2][i]
                });
                merged = true;
            }
            if (!merged) {
                conflicts = "new_branch";
                $8497c1e3bf13d11c$var$insertSorted(tree1[2], tree2[2][i], $8497c1e3bf13d11c$var$compareTree);
            }
        }
    }
    return {
        conflicts: conflicts,
        tree: in_tree1
    };
}
function $8497c1e3bf13d11c$var$doMerge(tree, path, dontExpand) {
    var restree = [];
    var conflicts = false;
    var merged = false;
    var res;
    if (!tree.length) return {
        tree: [
            path
        ],
        conflicts: "new_leaf"
    };
    for(var i = 0, len = tree.length; i < len; i++){
        var branch = tree[i];
        if (branch.pos === path.pos && branch.ids[0] === path.ids[0]) {
            // Paths start at the same position and have the same root, so they need
            // merged
            res = $8497c1e3bf13d11c$var$mergeTree(branch.ids, path.ids);
            restree.push({
                pos: branch.pos,
                ids: res.tree
            });
            conflicts = conflicts || res.conflicts;
            merged = true;
        } else if (dontExpand !== true) {
            // The paths start at a different position, take the earliest path and
            // traverse up until it as at the same point from root as the path we
            // want to merge.  If the keys match we return the longer path with the
            // other merged After stemming we dont want to expand the trees
            var t1 = branch.pos < path.pos ? branch : path;
            var t2 = branch.pos < path.pos ? path : branch;
            var diff = t2.pos - t1.pos;
            var candidateParents = [];
            var trees = [];
            trees.push({
                ids: t1.ids,
                diff: diff,
                parent: null,
                parentIdx: null
            });
            while(trees.length > 0){
                var item = trees.pop();
                if (item.diff === 0) {
                    if (item.ids[0] === t2.ids[0]) candidateParents.push(item);
                    continue;
                }
                var elements = item.ids[2];
                for(var j = 0, elementsLen = elements.length; j < elementsLen; j++)trees.push({
                    ids: elements[j],
                    diff: item.diff - 1,
                    parent: item.ids,
                    parentIdx: j
                });
            }
            var el = candidateParents[0];
            if (!el) restree.push(branch);
            else {
                res = $8497c1e3bf13d11c$var$mergeTree(el.ids, t2.ids);
                el.parent[2][el.parentIdx] = res.tree;
                restree.push({
                    pos: t1.pos,
                    ids: t1.ids
                });
                conflicts = conflicts || res.conflicts;
                merged = true;
            }
        } else restree.push(branch);
    }
    // We didnt find
    if (!merged) restree.push(path);
    restree.sort($8497c1e3bf13d11c$var$sortByPos$1);
    return {
        tree: restree,
        conflicts: conflicts || "internal_node"
    };
}
// To ensure we dont grow the revision tree infinitely, we stem old revisions
function $8497c1e3bf13d11c$var$stem(tree, depth) {
    // First we break out the tree into a complete list of root to leaf paths
    var paths = $8497c1e3bf13d11c$var$rootToLeaf(tree);
    var stemmedRevs;
    var result;
    for(var i = 0, len = paths.length; i < len; i++){
        // Then for each path, we cut off the start of the path based on the
        // `depth` to stem to, and generate a new set of flat trees
        var path = paths[i];
        var stemmed = path.ids;
        var node;
        if (stemmed.length > depth) {
            // only do the stemming work if we actually need to stem
            if (!stemmedRevs) stemmedRevs = {}; // avoid allocating this object unnecessarily
            var numStemmed = stemmed.length - depth;
            node = {
                pos: path.pos + numStemmed,
                ids: $8497c1e3bf13d11c$var$pathToTree(stemmed, numStemmed)
            };
            for(var s = 0; s < numStemmed; s++){
                var rev = path.pos + s + "-" + stemmed[s].id;
                stemmedRevs[rev] = true;
            }
        } else node = {
            pos: path.pos,
            ids: $8497c1e3bf13d11c$var$pathToTree(stemmed, 0)
        };
        // Then we remerge all those flat trees together, ensuring that we dont
        // connect trees that would go beyond the depth limit
        if (result) result = $8497c1e3bf13d11c$var$doMerge(result, node, true).tree;
        else result = [
            node
        ];
    }
    // this is memory-heavy per Chrome profiler, avoid unless we actually stemmed
    if (stemmedRevs) $8497c1e3bf13d11c$var$traverseRevTree(result, function(isLeaf, pos, revHash) {
        // some revisions may have been removed in a branch but not in another
        delete stemmedRevs[pos + "-" + revHash];
    });
    return {
        tree: result,
        revs: stemmedRevs ? Object.keys(stemmedRevs) : []
    };
}
function $8497c1e3bf13d11c$var$merge(tree, path, depth) {
    var newTree = $8497c1e3bf13d11c$var$doMerge(tree, path);
    var stemmed = $8497c1e3bf13d11c$var$stem(newTree.tree, depth);
    return {
        tree: stemmed.tree,
        stemmedRevs: stemmed.revs,
        conflicts: newTree.conflicts
    };
}
// return true if a rev exists in the rev tree, false otherwise
function $8497c1e3bf13d11c$var$revExists(revs, rev) {
    var toVisit = revs.slice();
    var splitRev = rev.split("-");
    var targetPos = parseInt(splitRev[0], 10);
    var targetId = splitRev[1];
    var node;
    while(node = toVisit.pop()){
        if (node.pos === targetPos && node.ids[0] === targetId) return true;
        var branches = node.ids[2];
        for(var i = 0, len = branches.length; i < len; i++)toVisit.push({
            pos: node.pos + 1,
            ids: branches[i]
        });
    }
    return false;
}
function $8497c1e3bf13d11c$var$getTrees(node) {
    return node.ids;
}
// check if a specific revision of a doc has been deleted
//  - metadata: the metadata object from the doc store
//  - rev: (optional) the revision to check. defaults to winning revision
function $8497c1e3bf13d11c$var$isDeleted(metadata, rev) {
    if (!rev) rev = $8497c1e3bf13d11c$var$winningRev(metadata);
    var id = rev.substring(rev.indexOf("-") + 1);
    var toVisit = metadata.rev_tree.map($8497c1e3bf13d11c$var$getTrees);
    var tree;
    while(tree = toVisit.pop()){
        if (tree[0] === id) return !!tree[1].deleted;
        toVisit = toVisit.concat(tree[2]);
    }
}
function $8497c1e3bf13d11c$var$isLocalId(id) {
    return /^_local/.test(id);
}
// returns the current leaf node for a given revision
function $8497c1e3bf13d11c$var$latest(rev, metadata) {
    var toVisit = metadata.rev_tree.slice();
    var node;
    while(node = toVisit.pop()){
        var pos = node.pos;
        var tree = node.ids;
        var id = tree[0];
        var opts = tree[1];
        var branches = tree[2];
        var isLeaf = branches.length === 0;
        var history = node.history ? node.history.slice() : [];
        history.push({
            id: id,
            pos: pos,
            opts: opts
        });
        if (isLeaf) for(var i = 0, len = history.length; i < len; i++){
            var historyNode = history[i];
            var historyRev = historyNode.pos + "-" + historyNode.id;
            if (historyRev === rev) // return the rev of this leaf
            return pos + "-" + id;
        }
        for(var j = 0, l = branches.length; j < l; j++)toVisit.push({
            pos: pos + 1,
            ids: branches[j],
            history: history
        });
    }
    /* istanbul ignore next */ throw new Error("Unable to resolve latest revision for id " + metadata.id + ", rev " + rev);
}
function $8497c1e3bf13d11c$var$tryCatchInChangeListener(self1, change, pending, lastSeq) {
    // isolate try/catches to avoid V8 deoptimizations
    try {
        self1.emit("change", change, pending, lastSeq);
    } catch (e) {
        $8497c1e3bf13d11c$var$guardedConsole("error", 'Error in .on("change", function):', e);
    }
}
function $8497c1e3bf13d11c$var$processChange(doc, metadata, opts) {
    var changeList = [
        {
            rev: doc._rev
        }
    ];
    if (opts.style === "all_docs") changeList = $8497c1e3bf13d11c$var$collectLeaves(metadata.rev_tree).map(function(x) {
        return {
            rev: x.rev
        };
    });
    var change = {
        id: metadata.id,
        changes: changeList,
        doc: doc
    };
    if ($8497c1e3bf13d11c$var$isDeleted(metadata, doc._rev)) change.deleted = true;
    if (opts.conflicts) {
        change.doc._conflicts = $8497c1e3bf13d11c$var$collectConflicts(metadata);
        if (!change.doc._conflicts.length) delete change.doc._conflicts;
    }
    return change;
}
class $8497c1e3bf13d11c$var$Changes$1 extends (0, (/*@__PURE__*/$parcel$interopDefault($dG33B))) {
    constructor(db, opts, callback){
        super();
        this.db = db;
        opts = opts ? $8497c1e3bf13d11c$var$clone(opts) : {};
        var complete = opts.complete = $8497c1e3bf13d11c$var$once((err, resp)=>{
            if (err) {
                if ($8497c1e3bf13d11c$var$listenerCount(this, "error") > 0) this.emit("error", err);
            } else this.emit("complete", resp);
            this.removeAllListeners();
            db.removeListener("destroyed", onDestroy);
        });
        if (callback) {
            this.on("complete", function(resp) {
                callback(null, resp);
            });
            this.on("error", callback);
        }
        const onDestroy = ()=>{
            this.cancel();
        };
        db.once("destroyed", onDestroy);
        opts.onChange = (change, pending, lastSeq)=>{
            /* istanbul ignore if */ if (this.isCancelled) return;
            $8497c1e3bf13d11c$var$tryCatchInChangeListener(this, change, pending, lastSeq);
        };
        var promise = new Promise(function(fulfill, reject) {
            opts.complete = function(err, res) {
                if (err) reject(err);
                else fulfill(res);
            };
        });
        this.once("cancel", function() {
            db.removeListener("destroyed", onDestroy);
            opts.complete(null, {
                status: "cancelled"
            });
        });
        this.then = promise.then.bind(promise);
        this["catch"] = promise["catch"].bind(promise);
        this.then(function(result) {
            complete(null, result);
        }, complete);
        if (!db.taskqueue.isReady) db.taskqueue.addTask((failed)=>{
            if (failed) opts.complete(failed);
            else if (this.isCancelled) this.emit("cancel");
            else this.validateChanges(opts);
        });
        else this.validateChanges(opts);
    }
    cancel() {
        this.isCancelled = true;
        if (this.db.taskqueue.isReady) this.emit("cancel");
    }
    validateChanges(opts) {
        var callback = opts.complete;
        /* istanbul ignore else */ if ($8497c1e3bf13d11c$var$PouchDB._changesFilterPlugin) $8497c1e3bf13d11c$var$PouchDB._changesFilterPlugin.validate(opts, (err)=>{
            if (err) return callback(err);
            this.doChanges(opts);
        });
        else this.doChanges(opts);
    }
    doChanges(opts) {
        var callback = opts.complete;
        opts = $8497c1e3bf13d11c$var$clone(opts);
        if ("live" in opts && !("continuous" in opts)) opts.continuous = opts.live;
        opts.processChange = $8497c1e3bf13d11c$var$processChange;
        if (opts.since === "latest") opts.since = "now";
        if (!opts.since) opts.since = 0;
        if (opts.since === "now") {
            this.db.info().then((info)=>{
                /* istanbul ignore if */ if (this.isCancelled) {
                    callback(null, {
                        status: "cancelled"
                    });
                    return;
                }
                opts.since = info.update_seq;
                this.doChanges(opts);
            }, callback);
            return;
        }
        /* istanbul ignore else */ if ($8497c1e3bf13d11c$var$PouchDB._changesFilterPlugin) {
            $8497c1e3bf13d11c$var$PouchDB._changesFilterPlugin.normalize(opts);
            if ($8497c1e3bf13d11c$var$PouchDB._changesFilterPlugin.shouldFilter(this, opts)) return $8497c1e3bf13d11c$var$PouchDB._changesFilterPlugin.filter(this, opts);
        } else [
            "doc_ids",
            "filter",
            "selector",
            "view"
        ].forEach(function(key) {
            if (key in opts) $8497c1e3bf13d11c$var$guardedConsole("warn", 'The "' + key + '" option was passed in to changes/replicate, ' + "but pouchdb-changes-filter plugin is not installed, so it " + "was ignored. Please install the plugin to enable filtering.");
        });
        if (!("descending" in opts)) opts.descending = false;
        // 0 and 1 should return 1 document
        opts.limit = opts.limit === 0 ? 1 : opts.limit;
        opts.complete = callback;
        var newPromise = this.db._changes(opts);
        /* istanbul ignore else */ if (newPromise && typeof newPromise.cancel === "function") {
            const cancel = this.cancel;
            this.cancel = (...args)=>{
                newPromise.cancel();
                cancel.apply(this, args);
            };
        }
    }
}
/*
 * A generic pouch adapter
 */ function $8497c1e3bf13d11c$var$compare(left, right) {
    return left < right ? -1 : left > right ? 1 : 0;
}
// Wrapper for functions that call the bulkdocs api with a single doc,
// if the first result is an error, return an error
function $8497c1e3bf13d11c$var$yankError(callback, docId) {
    return function(err, results) {
        if (err || results[0] && results[0].error) {
            err = err || results[0];
            err.docId = docId;
            callback(err);
        } else callback(null, results.length ? results[0] : results);
    };
}
// clean docs given to us by the user
function $8497c1e3bf13d11c$var$cleanDocs(docs) {
    for(var i = 0; i < docs.length; i++){
        var doc = docs[i];
        if (doc._deleted) delete doc._attachments; // ignore atts for deleted docs
        else if (doc._attachments) {
            // filter out extraneous keys from _attachments
            var atts = Object.keys(doc._attachments);
            for(var j = 0; j < atts.length; j++){
                var att = atts[j];
                doc._attachments[att] = $8497c1e3bf13d11c$var$pick(doc._attachments[att], [
                    "data",
                    "digest",
                    "content_type",
                    "length",
                    "revpos",
                    "stub"
                ]);
            }
        }
    }
}
// compare two docs, first by _id then by _rev
function $8497c1e3bf13d11c$var$compareByIdThenRev(a, b) {
    var idCompare = $8497c1e3bf13d11c$var$compare(a._id, b._id);
    if (idCompare !== 0) return idCompare;
    var aStart = a._revisions ? a._revisions.start : 0;
    var bStart = b._revisions ? b._revisions.start : 0;
    return $8497c1e3bf13d11c$var$compare(aStart, bStart);
}
// for every node in a revision tree computes its distance from the closest
// leaf
function $8497c1e3bf13d11c$var$computeHeight(revs) {
    var height = {};
    var edges = [];
    $8497c1e3bf13d11c$var$traverseRevTree(revs, function(isLeaf, pos, id, prnt) {
        var rev = pos + "-" + id;
        if (isLeaf) height[rev] = 0;
        if (prnt !== undefined) edges.push({
            from: prnt,
            to: rev
        });
        return rev;
    });
    edges.reverse();
    edges.forEach(function(edge) {
        if (height[edge.from] === undefined) height[edge.from] = 1 + height[edge.to];
        else height[edge.from] = Math.min(height[edge.from], 1 + height[edge.to]);
    });
    return height;
}
function $8497c1e3bf13d11c$var$allDocsKeysParse(opts) {
    var keys = "limit" in opts ? opts.keys.slice(opts.skip, opts.limit + opts.skip) : opts.skip > 0 ? opts.keys.slice(opts.skip) : opts.keys;
    opts.keys = keys;
    opts.skip = 0;
    delete opts.limit;
    if (opts.descending) {
        keys.reverse();
        opts.descending = false;
    }
}
// all compaction is done in a queue, to avoid attaching
// too many listeners at once
function $8497c1e3bf13d11c$var$doNextCompaction(self1) {
    var task = self1._compactionQueue[0];
    var opts = task.opts;
    var callback = task.callback;
    self1.get("_local/compaction").catch(function() {
        return false;
    }).then(function(doc) {
        if (doc && doc.last_seq) opts.last_seq = doc.last_seq;
        self1._compact(opts, function(err, res) {
            /* istanbul ignore if */ if (err) callback(err);
            else callback(null, res);
            (0, (/*@__PURE__*/$parcel$interopDefault($lRg87)))(function() {
                self1._compactionQueue.shift();
                if (self1._compactionQueue.length) $8497c1e3bf13d11c$var$doNextCompaction(self1);
            });
        });
    });
}
function $8497c1e3bf13d11c$var$appendPurgeSeq(db, docId, rev) {
    return db.get("_local/purges").then(function(doc) {
        const purgeSeq = doc.purgeSeq + 1;
        doc.purges.push({
            docId: docId,
            rev: rev,
            purgeSeq: purgeSeq
        });
        if (doc.purges.length > self.purged_infos_limit) doc.purges.splice(0, doc.purges.length - self.purged_infos_limit);
        doc.purgeSeq = purgeSeq;
        return doc;
    }).catch(function(err) {
        if (err.status !== 404) throw err;
        return {
            _id: "_local/purges",
            purges: [
                {
                    docId: docId,
                    rev: rev,
                    purgeSeq: 0
                }
            ],
            purgeSeq: 0
        };
    }).then(function(doc) {
        return db.put(doc);
    });
}
function $8497c1e3bf13d11c$var$attachmentNameError(name) {
    if (name.charAt(0) === "_") return name + " is not a valid attachment name, attachment " + "names cannot start with '_'";
    return false;
}
class $8497c1e3bf13d11c$var$AbstractPouchDB extends (0, (/*@__PURE__*/$parcel$interopDefault($dG33B))) {
    _setup() {
        this.post = $8497c1e3bf13d11c$var$adapterFun("post", function(doc, opts, callback) {
            if (typeof opts === "function") {
                callback = opts;
                opts = {};
            }
            if (typeof doc !== "object" || Array.isArray(doc)) return callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$NOT_AN_OBJECT));
            this.bulkDocs({
                docs: [
                    doc
                ]
            }, opts, $8497c1e3bf13d11c$var$yankError(callback, doc._id));
        }).bind(this);
        this.put = $8497c1e3bf13d11c$var$adapterFun("put", function(doc, opts, cb) {
            if (typeof opts === "function") {
                cb = opts;
                opts = {};
            }
            if (typeof doc !== "object" || Array.isArray(doc)) return cb($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$NOT_AN_OBJECT));
            $8497c1e3bf13d11c$var$invalidIdError(doc._id);
            if ($8497c1e3bf13d11c$var$isLocalId(doc._id) && typeof this._putLocal === "function") {
                if (doc._deleted) return this._removeLocal(doc, cb);
                else return this._putLocal(doc, cb);
            }
            const putDoc = (next)=>{
                if (typeof this._put === "function" && opts.new_edits !== false) this._put(doc, opts, next);
                else this.bulkDocs({
                    docs: [
                        doc
                    ]
                }, opts, $8497c1e3bf13d11c$var$yankError(next, doc._id));
            };
            if (opts.force && doc._rev) {
                transformForceOptionToNewEditsOption();
                putDoc(function(err) {
                    var result = err ? null : {
                        ok: true,
                        id: doc._id,
                        rev: doc._rev
                    };
                    cb(err, result);
                });
            } else putDoc(cb);
            function transformForceOptionToNewEditsOption() {
                var parts = doc._rev.split("-");
                var oldRevId = parts[1];
                var oldRevNum = parseInt(parts[0], 10);
                var newRevNum = oldRevNum + 1;
                var newRevId = $8497c1e3bf13d11c$var$rev$$1();
                doc._revisions = {
                    start: newRevNum,
                    ids: [
                        newRevId,
                        oldRevId
                    ]
                };
                doc._rev = newRevNum + "-" + newRevId;
                opts.new_edits = false;
            }
        }).bind(this);
        this.putAttachment = $8497c1e3bf13d11c$var$adapterFun("putAttachment", function(docId, attachmentId, rev, blob, type) {
            var api = this;
            if (typeof type === "function") {
                type = blob;
                blob = rev;
                rev = null;
            }
            // Lets fix in https://github.com/pouchdb/pouchdb/issues/3267
            /* istanbul ignore if */ if (typeof type === "undefined") {
                type = blob;
                blob = rev;
                rev = null;
            }
            if (!type) $8497c1e3bf13d11c$var$guardedConsole("warn", "Attachment", attachmentId, "on document", docId, "is missing content_type");
            function createAttachment(doc) {
                var prevrevpos = "_rev" in doc ? parseInt(doc._rev, 10) : 0;
                doc._attachments = doc._attachments || {};
                doc._attachments[attachmentId] = {
                    content_type: type,
                    data: blob,
                    revpos: ++prevrevpos
                };
                return api.put(doc);
            }
            return api.get(docId).then(function(doc) {
                if (doc._rev !== rev) throw $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$REV_CONFLICT);
                return createAttachment(doc);
            }, function(err) {
                // create new doc
                /* istanbul ignore else */ if (err.reason === $8497c1e3bf13d11c$var$MISSING_DOC.message) return createAttachment({
                    _id: docId
                });
                else throw err;
            });
        }).bind(this);
        this.removeAttachment = $8497c1e3bf13d11c$var$adapterFun("removeAttachment", function(docId, attachmentId, rev, callback) {
            this.get(docId, (err, obj)=>{
                /* istanbul ignore if */ if (err) {
                    callback(err);
                    return;
                }
                if (obj._rev !== rev) {
                    callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$REV_CONFLICT));
                    return;
                }
                /* istanbul ignore if */ if (!obj._attachments) return callback();
                delete obj._attachments[attachmentId];
                if (Object.keys(obj._attachments).length === 0) delete obj._attachments;
                this.put(obj, callback);
            });
        }).bind(this);
        this.remove = $8497c1e3bf13d11c$var$adapterFun("remove", function(docOrId, optsOrRev, opts, callback) {
            var doc;
            if (typeof optsOrRev === "string") {
                // id, rev, opts, callback style
                doc = {
                    _id: docOrId,
                    _rev: optsOrRev
                };
                if (typeof opts === "function") {
                    callback = opts;
                    opts = {};
                }
            } else {
                // doc, opts, callback style
                doc = docOrId;
                if (typeof optsOrRev === "function") {
                    callback = optsOrRev;
                    opts = {};
                } else {
                    callback = opts;
                    opts = optsOrRev;
                }
            }
            opts = opts || {};
            opts.was_delete = true;
            var newDoc = {
                _id: doc._id,
                _rev: doc._rev || opts.rev
            };
            newDoc._deleted = true;
            if ($8497c1e3bf13d11c$var$isLocalId(newDoc._id) && typeof this._removeLocal === "function") return this._removeLocal(doc, callback);
            this.bulkDocs({
                docs: [
                    newDoc
                ]
            }, opts, $8497c1e3bf13d11c$var$yankError(callback, newDoc._id));
        }).bind(this);
        this.revsDiff = $8497c1e3bf13d11c$var$adapterFun("revsDiff", function(req, opts, callback) {
            if (typeof opts === "function") {
                callback = opts;
                opts = {};
            }
            var ids = Object.keys(req);
            if (!ids.length) return callback(null, {});
            var count = 0;
            var missing = new $8497c1e3bf13d11c$var$ExportedMap();
            function addToMissing(id, revId) {
                if (!missing.has(id)) missing.set(id, {
                    missing: []
                });
                missing.get(id).missing.push(revId);
            }
            function processDoc(id, rev_tree) {
                // Is this fast enough? Maybe we should switch to a set simulated by a map
                var missingForId = req[id].slice(0);
                $8497c1e3bf13d11c$var$traverseRevTree(rev_tree, function(isLeaf, pos, revHash, ctx, opts) {
                    var rev = pos + "-" + revHash;
                    var idx = missingForId.indexOf(rev);
                    if (idx === -1) return;
                    missingForId.splice(idx, 1);
                    /* istanbul ignore if */ if (opts.status !== "available") addToMissing(id, rev);
                });
                // Traversing the tree is synchronous, so now `missingForId` contains
                // revisions that were not found in the tree
                missingForId.forEach(function(rev) {
                    addToMissing(id, rev);
                });
            }
            ids.map(function(id) {
                this._getRevisionTree(id, function(err, rev_tree) {
                    if (err && err.status === 404 && err.message === "missing") missing.set(id, {
                        missing: req[id]
                    });
                    else if (err) /* istanbul ignore next */ return callback(err);
                    else processDoc(id, rev_tree);
                    if (++count === ids.length) {
                        // convert LazyMap to object
                        var missingObj = {};
                        missing.forEach(function(value, key) {
                            missingObj[key] = value;
                        });
                        return callback(null, missingObj);
                    }
                });
            }, this);
        }).bind(this);
        // _bulk_get API for faster replication, as described in
        // https://github.com/apache/couchdb-chttpd/pull/33
        // At the "abstract" level, it will just run multiple get()s in
        // parallel, because this isn't much of a performance cost
        // for local databases (except the cost of multiple transactions, which is
        // small). The http adapter overrides this in order
        // to do a more efficient single HTTP request.
        this.bulkGet = $8497c1e3bf13d11c$var$adapterFun("bulkGet", function(opts, callback) {
            $8497c1e3bf13d11c$var$bulkGet(this, opts, callback);
        }).bind(this);
        // compact one document and fire callback
        // by compacting we mean removing all revisions which
        // are further from the leaf in revision tree than max_height
        this.compactDocument = $8497c1e3bf13d11c$var$adapterFun("compactDocument", function(docId, maxHeight, callback) {
            this._getRevisionTree(docId, (err, revTree)=>{
                /* istanbul ignore if */ if (err) return callback(err);
                var height = $8497c1e3bf13d11c$var$computeHeight(revTree);
                var candidates = [];
                var revs = [];
                Object.keys(height).forEach(function(rev) {
                    if (height[rev] > maxHeight) candidates.push(rev);
                });
                $8497c1e3bf13d11c$var$traverseRevTree(revTree, function(isLeaf, pos, revHash, ctx, opts) {
                    var rev = pos + "-" + revHash;
                    if (opts.status === "available" && candidates.indexOf(rev) !== -1) revs.push(rev);
                });
                this._doCompaction(docId, revs, callback);
            });
        }).bind(this);
        // compact the whole database using single document
        // compaction
        this.compact = $8497c1e3bf13d11c$var$adapterFun("compact", function(opts, callback) {
            if (typeof opts === "function") {
                callback = opts;
                opts = {};
            }
            opts = opts || {};
            this._compactionQueue = this._compactionQueue || [];
            this._compactionQueue.push({
                opts: opts,
                callback: callback
            });
            if (this._compactionQueue.length === 1) $8497c1e3bf13d11c$var$doNextCompaction(this);
        }).bind(this);
        /* Begin api wrappers. Specific functionality to storage belongs in the _[method] */ this.get = $8497c1e3bf13d11c$var$adapterFun("get", function(id, opts, cb) {
            if (typeof opts === "function") {
                cb = opts;
                opts = {};
            }
            if (typeof id !== "string") return cb($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$INVALID_ID));
            if ($8497c1e3bf13d11c$var$isLocalId(id) && typeof this._getLocal === "function") return this._getLocal(id, cb);
            var leaves = [];
            const finishOpenRevs = ()=>{
                var result = [];
                var count = leaves.length;
                /* istanbul ignore if */ if (!count) return cb(null, result);
                // order with open_revs is unspecified
                leaves.forEach((leaf)=>{
                    this.get(id, {
                        rev: leaf,
                        revs: opts.revs,
                        latest: opts.latest,
                        attachments: opts.attachments,
                        binary: opts.binary
                    }, function(err, doc) {
                        if (!err) {
                            // using latest=true can produce duplicates
                            var existing;
                            for(var i = 0, l = result.length; i < l; i++)if (result[i].ok && result[i].ok._rev === doc._rev) {
                                existing = true;
                                break;
                            }
                            if (!existing) result.push({
                                ok: doc
                            });
                        } else result.push({
                            missing: leaf
                        });
                        count--;
                        if (!count) cb(null, result);
                    });
                });
            };
            if (opts.open_revs) {
                if (opts.open_revs === "all") this._getRevisionTree(id, function(err, rev_tree) {
                    /* istanbul ignore if */ if (err) return cb(err);
                    leaves = $8497c1e3bf13d11c$var$collectLeaves(rev_tree).map(function(leaf) {
                        return leaf.rev;
                    });
                    finishOpenRevs();
                });
                else {
                    if (Array.isArray(opts.open_revs)) {
                        leaves = opts.open_revs;
                        for(var i = 0; i < leaves.length; i++){
                            var l = leaves[i];
                            // looks like it's the only thing couchdb checks
                            if (!(typeof l === "string" && /^\d+-/.test(l))) return cb($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$INVALID_REV));
                        }
                        finishOpenRevs();
                    } else return cb($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$UNKNOWN_ERROR, "function_clause"));
                }
                return; // open_revs does not like other options
            }
            return this._get(id, opts, (err, result)=>{
                if (err) {
                    err.docId = id;
                    return cb(err);
                }
                var doc = result.doc;
                var metadata = result.metadata;
                var ctx = result.ctx;
                if (opts.conflicts) {
                    var conflicts = $8497c1e3bf13d11c$var$collectConflicts(metadata);
                    if (conflicts.length) doc._conflicts = conflicts;
                }
                if ($8497c1e3bf13d11c$var$isDeleted(metadata, doc._rev)) doc._deleted = true;
                if (opts.revs || opts.revs_info) {
                    var splittedRev = doc._rev.split("-");
                    var revNo = parseInt(splittedRev[0], 10);
                    var revHash = splittedRev[1];
                    var paths = $8497c1e3bf13d11c$var$rootToLeaf(metadata.rev_tree);
                    var path = null;
                    for(var i = 0; i < paths.length; i++){
                        var currentPath = paths[i];
                        var hashIndex = currentPath.ids.map(function(x) {
                            return x.id;
                        }).indexOf(revHash);
                        var hashFoundAtRevPos = hashIndex === revNo - 1;
                        if (hashFoundAtRevPos || !path && hashIndex !== -1) path = currentPath;
                    }
                    /* istanbul ignore if */ if (!path) {
                        err = new Error("invalid rev tree");
                        err.docId = id;
                        return cb(err);
                    }
                    var indexOfRev = path.ids.map(function(x) {
                        return x.id;
                    }).indexOf(doc._rev.split("-")[1]) + 1;
                    var howMany = path.ids.length - indexOfRev;
                    path.ids.splice(indexOfRev, howMany);
                    path.ids.reverse();
                    if (opts.revs) doc._revisions = {
                        start: path.pos + path.ids.length - 1,
                        ids: path.ids.map(function(rev) {
                            return rev.id;
                        })
                    };
                    if (opts.revs_info) {
                        var pos = path.pos + path.ids.length;
                        doc._revs_info = path.ids.map(function(rev) {
                            pos--;
                            return {
                                rev: pos + "-" + rev.id,
                                status: rev.opts.status
                            };
                        });
                    }
                }
                if (opts.attachments && doc._attachments) {
                    var attachments = doc._attachments;
                    var count = Object.keys(attachments).length;
                    if (count === 0) return cb(null, doc);
                    Object.keys(attachments).forEach((key)=>{
                        this._getAttachment(doc._id, key, attachments[key], {
                            // Previously the revision handling was done in adapter.js
                            // getAttachment, however since idb-next doesnt we need to
                            // pass the rev through
                            rev: doc._rev,
                            binary: opts.binary,
                            ctx: ctx
                        }, function(err, data) {
                            var att = doc._attachments[key];
                            att.data = data;
                            delete att.stub;
                            delete att.length;
                            if (!--count) cb(null, doc);
                        });
                    });
                } else {
                    if (doc._attachments) {
                        for(var key in doc._attachments)/* istanbul ignore else */ if (Object.prototype.hasOwnProperty.call(doc._attachments, key)) doc._attachments[key].stub = true;
                    }
                    cb(null, doc);
                }
            });
        }).bind(this);
        // TODO: I dont like this, it forces an extra read for every
        // attachment read and enforces a confusing api between
        // adapter.js and the adapter implementation
        this.getAttachment = $8497c1e3bf13d11c$var$adapterFun("getAttachment", function(docId, attachmentId, opts, callback) {
            if (opts instanceof Function) {
                callback = opts;
                opts = {};
            }
            this._get(docId, opts, (err, res)=>{
                if (err) return callback(err);
                if (res.doc._attachments && res.doc._attachments[attachmentId]) {
                    opts.ctx = res.ctx;
                    opts.binary = true;
                    this._getAttachment(docId, attachmentId, res.doc._attachments[attachmentId], opts, callback);
                } else return callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$MISSING_DOC));
            });
        }).bind(this);
        this.allDocs = $8497c1e3bf13d11c$var$adapterFun("allDocs", function(opts, callback) {
            if (typeof opts === "function") {
                callback = opts;
                opts = {};
            }
            opts.skip = typeof opts.skip !== "undefined" ? opts.skip : 0;
            if (opts.start_key) opts.startkey = opts.start_key;
            if (opts.end_key) opts.endkey = opts.end_key;
            if ("keys" in opts) {
                if (!Array.isArray(opts.keys)) return callback(new TypeError("options.keys must be an array"));
                var incompatibleOpt = [
                    "startkey",
                    "endkey",
                    "key"
                ].filter(function(incompatibleOpt) {
                    return incompatibleOpt in opts;
                })[0];
                if (incompatibleOpt) {
                    callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$QUERY_PARSE_ERROR, "Query parameter `" + incompatibleOpt + "` is not compatible with multi-get"));
                    return;
                }
                if (!$8497c1e3bf13d11c$var$isRemote(this)) {
                    $8497c1e3bf13d11c$var$allDocsKeysParse(opts);
                    if (opts.keys.length === 0) return this._allDocs({
                        limit: 0
                    }, callback);
                }
            }
            return this._allDocs(opts, callback);
        }).bind(this);
        this.close = $8497c1e3bf13d11c$var$adapterFun("close", function(callback) {
            this._closed = true;
            this.emit("closed");
            return this._close(callback);
        }).bind(this);
        this.info = $8497c1e3bf13d11c$var$adapterFun("info", function(callback) {
            this._info((err, info)=>{
                if (err) return callback(err);
                // assume we know better than the adapter, unless it informs us
                info.db_name = info.db_name || this.name;
                info.auto_compaction = !!(this.auto_compaction && !$8497c1e3bf13d11c$var$isRemote(this));
                info.adapter = this.adapter;
                callback(null, info);
            });
        }).bind(this);
        this.id = $8497c1e3bf13d11c$var$adapterFun("id", function(callback) {
            return this._id(callback);
        }).bind(this);
        this.bulkDocs = $8497c1e3bf13d11c$var$adapterFun("bulkDocs", function(req, opts, callback) {
            if (typeof opts === "function") {
                callback = opts;
                opts = {};
            }
            opts = opts || {};
            if (Array.isArray(req)) req = {
                docs: req
            };
            if (!req || !req.docs || !Array.isArray(req.docs)) return callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$MISSING_BULK_DOCS));
            for(var i = 0; i < req.docs.length; ++i){
                if (typeof req.docs[i] !== "object" || Array.isArray(req.docs[i])) return callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$NOT_AN_OBJECT));
            }
            var attachmentError;
            req.docs.forEach(function(doc) {
                if (doc._attachments) Object.keys(doc._attachments).forEach(function(name) {
                    attachmentError = attachmentError || $8497c1e3bf13d11c$var$attachmentNameError(name);
                    if (!doc._attachments[name].content_type) $8497c1e3bf13d11c$var$guardedConsole("warn", "Attachment", name, "on document", doc._id, "is missing content_type");
                });
            });
            if (attachmentError) return callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$BAD_REQUEST, attachmentError));
            if (!("new_edits" in opts)) {
                if ("new_edits" in req) opts.new_edits = req.new_edits;
                else opts.new_edits = true;
            }
            var adapter = this;
            if (!opts.new_edits && !$8497c1e3bf13d11c$var$isRemote(adapter)) // ensure revisions of the same doc are sorted, so that
            // the local adapter processes them correctly (#2935)
            req.docs.sort($8497c1e3bf13d11c$var$compareByIdThenRev);
            $8497c1e3bf13d11c$var$cleanDocs(req.docs);
            // in the case of conflicts, we want to return the _ids to the user
            // however, the underlying adapter may destroy the docs array, so
            // create a copy here
            var ids = req.docs.map(function(doc) {
                return doc._id;
            });
            this._bulkDocs(req, opts, function(err, res) {
                if (err) return callback(err);
                if (!opts.new_edits) // this is what couch does when new_edits is false
                res = res.filter(function(x) {
                    return x.error;
                });
                // add ids for error/conflict responses (not required for CouchDB)
                if (!$8497c1e3bf13d11c$var$isRemote(adapter)) for(var i = 0, l = res.length; i < l; i++)res[i].id = res[i].id || ids[i];
                callback(null, res);
            });
        }).bind(this);
        this.registerDependentDatabase = $8497c1e3bf13d11c$var$adapterFun("registerDependentDatabase", function(dependentDb, callback) {
            var dbOptions = $8497c1e3bf13d11c$var$clone(this.__opts);
            if (this.__opts.view_adapter) dbOptions.adapter = this.__opts.view_adapter;
            var depDB = new this.constructor(dependentDb, dbOptions);
            function diffFun(doc) {
                doc.dependentDbs = doc.dependentDbs || {};
                if (doc.dependentDbs[dependentDb]) return false; // no update required
                doc.dependentDbs[dependentDb] = true;
                return doc;
            }
            $8497c1e3bf13d11c$var$upsert(this, "_local/_pouch_dependentDbs", diffFun).then(function() {
                callback(null, {
                    db: depDB
                });
            }).catch(callback);
        }).bind(this);
        this.destroy = $8497c1e3bf13d11c$var$adapterFun("destroy", function(opts, callback) {
            if (typeof opts === "function") {
                callback = opts;
                opts = {};
            }
            var usePrefix = "use_prefix" in this ? this.use_prefix : true;
            const destroyDb = ()=>{
                // call destroy method of the particular adaptor
                this._destroy(opts, (err, resp)=>{
                    if (err) return callback(err);
                    this._destroyed = true;
                    this.emit("destroyed");
                    callback(null, resp || {
                        "ok": true
                    });
                });
            };
            if ($8497c1e3bf13d11c$var$isRemote(this)) // no need to check for dependent DBs if it's a remote DB
            return destroyDb();
            this.get("_local/_pouch_dependentDbs", (err, localDoc)=>{
                if (err) {
                    /* istanbul ignore if */ if (err.status !== 404) return callback(err);
                    else return destroyDb();
                }
                var dependentDbs = localDoc.dependentDbs;
                var PouchDB = this.constructor;
                var deletedMap = Object.keys(dependentDbs).map((name)=>{
                    // use_prefix is only false in the browser
                    /* istanbul ignore next */ var trueName = usePrefix ? name.replace(new RegExp("^" + PouchDB.prefix), "") : name;
                    return new PouchDB(trueName, this.__opts).destroy();
                });
                Promise.all(deletedMap).then(destroyDb, callback);
            });
        }).bind(this);
    }
    _compact(opts, callback) {
        var changesOpts = {
            return_docs: false,
            last_seq: opts.last_seq || 0
        };
        var promises = [];
        var taskId;
        var compactedDocs = 0;
        const onChange = (row)=>{
            this.activeTasks.update(taskId, {
                completed_items: ++compactedDocs
            });
            promises.push(this.compactDocument(row.id, 0));
        };
        const onError = (err)=>{
            this.activeTasks.remove(taskId, err);
            callback(err);
        };
        const onComplete = (resp)=>{
            var lastSeq = resp.last_seq;
            Promise.all(promises).then(()=>{
                return $8497c1e3bf13d11c$var$upsert(this, "_local/compaction", (doc)=>{
                    if (!doc.last_seq || doc.last_seq < lastSeq) {
                        doc.last_seq = lastSeq;
                        return doc;
                    }
                    return false; // somebody else got here first, don't update
                });
            }).then(()=>{
                this.activeTasks.remove(taskId);
                callback(null, {
                    ok: true
                });
            }).catch(onError);
        };
        this.info().then((info)=>{
            taskId = this.activeTasks.add({
                name: "database_compaction",
                total_items: info.update_seq - changesOpts.last_seq
            });
            this.changes(changesOpts).on("change", onChange).on("complete", onComplete).on("error", onError);
        });
    }
    changes(opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        opts = opts || {};
        // By default set return_docs to false if the caller has opts.live = true,
        // this will prevent us from collecting the set of changes indefinitely
        // resulting in growing memory
        opts.return_docs = "return_docs" in opts ? opts.return_docs : !opts.live;
        return new $8497c1e3bf13d11c$var$Changes$1(this, opts, callback);
    }
    type() {
        return typeof this._type === "function" ? this._type() : this.adapter;
    }
}
// The abstract purge implementation expects a doc id and the rev of a leaf node in that doc.
// It will return errors if the rev doesn’t exist or isn’t a leaf.
$8497c1e3bf13d11c$var$AbstractPouchDB.prototype.purge = $8497c1e3bf13d11c$var$adapterFun("_purge", function(docId, rev, callback) {
    if (typeof this._purge === "undefined") return callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$UNKNOWN_ERROR, "Purge is not implemented in the " + this.adapter + " adapter."));
    var self1 = this;
    self1._getRevisionTree(docId, (error, revs)=>{
        if (error) return callback(error);
        if (!revs) return callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$MISSING_DOC));
        let path;
        try {
            path = $8497c1e3bf13d11c$var$findPathToLeaf(revs, rev);
        } catch (error) {
            return callback(error.message || error);
        }
        self1._purge(docId, path, (error, result)=>{
            if (error) return callback(error);
            else $8497c1e3bf13d11c$var$appendPurgeSeq(self1, docId, rev).then(function() {
                return callback(null, result);
            });
        });
    });
});
class $8497c1e3bf13d11c$var$TaskQueue {
    constructor(){
        this.isReady = false;
        this.failed = false;
        this.queue = [];
    }
    execute() {
        var fun;
        if (this.failed) while(fun = this.queue.shift())fun(this.failed);
        else while(fun = this.queue.shift())fun();
    }
    fail(err) {
        this.failed = err;
        this.execute();
    }
    ready(db) {
        this.isReady = true;
        this.db = db;
        this.execute();
    }
    addTask(fun) {
        this.queue.push(fun);
        if (this.failed) this.execute();
    }
}
function $8497c1e3bf13d11c$var$parseAdapter(name, opts) {
    var match = name.match(/([a-z-]*):\/\/(.*)/);
    if (match) // the http adapter expects the fully qualified name
    return {
        name: /https?/.test(match[1]) ? match[1] + "://" + match[2] : match[2],
        adapter: match[1]
    };
    var adapters = $8497c1e3bf13d11c$var$PouchDB.adapters;
    var preferredAdapters = $8497c1e3bf13d11c$var$PouchDB.preferredAdapters;
    var prefix = $8497c1e3bf13d11c$var$PouchDB.prefix;
    var adapterName = opts.adapter;
    if (!adapterName) for(var i = 0; i < preferredAdapters.length; ++i){
        adapterName = preferredAdapters[i];
        // check for browsers that have been upgraded from websql-only to websql+idb
        /* istanbul ignore if */ if (adapterName === "idb" && "websql" in adapters && $8497c1e3bf13d11c$var$hasLocalStorage() && localStorage["_pouch__websqldb_" + prefix + name]) {
            // log it, because this can be confusing during development
            $8497c1e3bf13d11c$var$guardedConsole("log", 'PouchDB is downgrading "' + name + '" to WebSQL to' + " avoid data loss, because it was already opened with WebSQL.");
            continue; // keep using websql to avoid user data loss
        }
        break;
    }
    var adapter = adapters[adapterName];
    // if adapter is invalid, then an error will be thrown later
    var usePrefix = adapter && "use_prefix" in adapter ? adapter.use_prefix : true;
    return {
        name: usePrefix ? prefix + name : name,
        adapter: adapterName
    };
}
function $8497c1e3bf13d11c$var$inherits(A, B) {
    A.prototype = Object.create(B.prototype, {
        constructor: {
            value: A
        }
    });
}
function $8497c1e3bf13d11c$var$createClass(parent, init) {
    let klass = function(...args) {
        if (!(this instanceof klass)) return new klass(...args);
        init.apply(this, args);
    };
    $8497c1e3bf13d11c$var$inherits(klass, parent);
    return klass;
}
// OK, so here's the deal. Consider this code:
//     var db1 = new PouchDB('foo');
//     var db2 = new PouchDB('foo');
//     db1.destroy();
// ^ these two both need to emit 'destroyed' events,
// as well as the PouchDB constructor itself.
// So we have one db object (whichever one got destroy() called on it)
// responsible for emitting the initial event, which then gets emitted
// by the constructor, which then broadcasts it to any other dbs
// that may have been created with the same name.
function $8497c1e3bf13d11c$var$prepareForDestruction(self1) {
    function onDestroyed(from_constructor) {
        self1.removeListener("closed", onClosed);
        if (!from_constructor) self1.constructor.emit("destroyed", self1.name);
    }
    function onClosed() {
        self1.removeListener("destroyed", onDestroyed);
        self1.constructor.emit("unref", self1);
    }
    self1.once("destroyed", onDestroyed);
    self1.once("closed", onClosed);
    self1.constructor.emit("ref", self1);
}
class $8497c1e3bf13d11c$var$PouchInternal extends $8497c1e3bf13d11c$var$AbstractPouchDB {
    constructor(name, opts){
        super();
        this._setup(name, opts);
    }
    _setup(name, opts) {
        super._setup();
        opts = opts || {};
        if (name && typeof name === "object") {
            opts = name;
            name = opts.name;
            delete opts.name;
        }
        if (opts.deterministic_revs === undefined) opts.deterministic_revs = true;
        this.__opts = opts = $8497c1e3bf13d11c$var$clone(opts);
        this.auto_compaction = opts.auto_compaction;
        this.purged_infos_limit = opts.purged_infos_limit || 1000;
        this.prefix = $8497c1e3bf13d11c$var$PouchDB.prefix;
        if (typeof name !== "string") throw new Error("Missing/invalid DB name");
        var prefixedName = (opts.prefix || "") + name;
        var backend = $8497c1e3bf13d11c$var$parseAdapter(prefixedName, opts);
        opts.name = backend.name;
        opts.adapter = opts.adapter || backend.adapter;
        this.name = name;
        this._adapter = opts.adapter;
        $8497c1e3bf13d11c$var$PouchDB.emit("debug", [
            "adapter",
            "Picked adapter: ",
            opts.adapter
        ]);
        if (!$8497c1e3bf13d11c$var$PouchDB.adapters[opts.adapter] || !$8497c1e3bf13d11c$var$PouchDB.adapters[opts.adapter].valid()) throw new Error("Invalid Adapter: " + opts.adapter);
        if (opts.view_adapter) {
            if (!$8497c1e3bf13d11c$var$PouchDB.adapters[opts.view_adapter] || !$8497c1e3bf13d11c$var$PouchDB.adapters[opts.view_adapter].valid()) throw new Error("Invalid View Adapter: " + opts.view_adapter);
        }
        this.taskqueue = new $8497c1e3bf13d11c$var$TaskQueue();
        this.adapter = opts.adapter;
        $8497c1e3bf13d11c$var$PouchDB.adapters[opts.adapter].call(this, opts, (err)=>{
            if (err) return this.taskqueue.fail(err);
            $8497c1e3bf13d11c$var$prepareForDestruction(this);
            this.emit("created", this);
            $8497c1e3bf13d11c$var$PouchDB.emit("created", this.name);
            this.taskqueue.ready(this);
        });
    }
}
const $8497c1e3bf13d11c$var$PouchDB = $8497c1e3bf13d11c$var$createClass($8497c1e3bf13d11c$var$PouchInternal, function(name, opts) {
    $8497c1e3bf13d11c$var$PouchInternal.prototype._setup.call(this, name, opts);
});
// AbortController was introduced quite a while after fetch and
// isnt required for PouchDB to function so polyfill if needed
var $8497c1e3bf13d11c$var$a = typeof AbortController !== "undefined" ? AbortController : function() {
    return {
        abort: function() {}
    };
};
var $8497c1e3bf13d11c$var$f$1 = fetch;
var $8497c1e3bf13d11c$var$h = Headers;
class $8497c1e3bf13d11c$var$ActiveTasks {
    constructor(){
        this.tasks = {};
    }
    list() {
        return Object.values(this.tasks);
    }
    add(task) {
        const id = (0, $hTj76.default)();
        this.tasks[id] = {
            id: id,
            name: task.name,
            total_items: task.total_items,
            created_at: new Date().toJSON()
        };
        return id;
    }
    get(id) {
        return this.tasks[id];
    }
    /* eslint-disable no-unused-vars */ remove(id, reason) {
        delete this.tasks[id];
        return this.tasks;
    }
    update(id, updatedTask) {
        const task = this.tasks[id];
        if (typeof task !== "undefined") {
            const mergedTask = {
                id: task.id,
                name: task.name,
                created_at: task.created_at,
                total_items: updatedTask.total_items || task.total_items,
                completed_items: updatedTask.completed_items || task.completed_items,
                updated_at: new Date().toJSON()
            };
            this.tasks[id] = mergedTask;
        }
        return this.tasks;
    }
}
$8497c1e3bf13d11c$var$PouchDB.adapters = {};
$8497c1e3bf13d11c$var$PouchDB.preferredAdapters = [];
$8497c1e3bf13d11c$var$PouchDB.prefix = "_pouch_";
var $8497c1e3bf13d11c$var$eventEmitter = new (0, (/*@__PURE__*/$parcel$interopDefault($dG33B)))();
function $8497c1e3bf13d11c$var$setUpEventEmitter(Pouch) {
    Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($dG33B))).prototype).forEach(function(key) {
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($dG33B))).prototype[key] === "function") Pouch[key] = $8497c1e3bf13d11c$var$eventEmitter[key].bind($8497c1e3bf13d11c$var$eventEmitter);
    });
    // these are created in constructor.js, and allow us to notify each DB with
    // the same name that it was destroyed, via the constructor object
    var destructListeners = Pouch._destructionListeners = new $8497c1e3bf13d11c$var$ExportedMap();
    Pouch.on("ref", function onConstructorRef(db) {
        if (!destructListeners.has(db.name)) destructListeners.set(db.name, []);
        destructListeners.get(db.name).push(db);
    });
    Pouch.on("unref", function onConstructorUnref(db) {
        if (!destructListeners.has(db.name)) return;
        var dbList = destructListeners.get(db.name);
        var pos = dbList.indexOf(db);
        if (pos < 0) /* istanbul ignore next */ return;
        dbList.splice(pos, 1);
        if (dbList.length > 1) /* istanbul ignore next */ destructListeners.set(db.name, dbList);
        else destructListeners.delete(db.name);
    });
    Pouch.on("destroyed", function onConstructorDestroyed(name) {
        if (!destructListeners.has(name)) return;
        var dbList = destructListeners.get(name);
        destructListeners.delete(name);
        dbList.forEach(function(db) {
            db.emit("destroyed", true);
        });
    });
}
$8497c1e3bf13d11c$var$setUpEventEmitter($8497c1e3bf13d11c$var$PouchDB);
$8497c1e3bf13d11c$var$PouchDB.adapter = function(id, obj, addToPreferredAdapters) {
    /* istanbul ignore else */ if (obj.valid()) {
        $8497c1e3bf13d11c$var$PouchDB.adapters[id] = obj;
        if (addToPreferredAdapters) $8497c1e3bf13d11c$var$PouchDB.preferredAdapters.push(id);
    }
};
$8497c1e3bf13d11c$var$PouchDB.plugin = function(obj) {
    if (typeof obj === "function") obj($8497c1e3bf13d11c$var$PouchDB);
    else if (typeof obj !== "object" || Object.keys(obj).length === 0) throw new Error('Invalid plugin: got "' + obj + '", expected an object or a function');
    else Object.keys(obj).forEach(function(id) {
        $8497c1e3bf13d11c$var$PouchDB.prototype[id] = obj[id];
    });
    if (this.__defaults) $8497c1e3bf13d11c$var$PouchDB.__defaults = $8497c1e3bf13d11c$var$$inject_Object_assign({}, this.__defaults);
    return $8497c1e3bf13d11c$var$PouchDB;
};
$8497c1e3bf13d11c$var$PouchDB.defaults = function(defaultOpts) {
    let PouchWithDefaults = $8497c1e3bf13d11c$var$createClass($8497c1e3bf13d11c$var$PouchDB, function(name, opts) {
        opts = opts || {};
        if (name && typeof name === "object") {
            opts = name;
            name = opts.name;
            delete opts.name;
        }
        opts = $8497c1e3bf13d11c$var$$inject_Object_assign({}, PouchWithDefaults.__defaults, opts);
        $8497c1e3bf13d11c$var$PouchDB.call(this, name, opts);
    });
    PouchWithDefaults.preferredAdapters = $8497c1e3bf13d11c$var$PouchDB.preferredAdapters.slice();
    Object.keys($8497c1e3bf13d11c$var$PouchDB).forEach(function(key) {
        if (!(key in PouchWithDefaults)) PouchWithDefaults[key] = $8497c1e3bf13d11c$var$PouchDB[key];
    });
    // make default options transitive
    // https://github.com/pouchdb/pouchdb/issues/5922
    PouchWithDefaults.__defaults = $8497c1e3bf13d11c$var$$inject_Object_assign({}, this.__defaults, defaultOpts);
    return PouchWithDefaults;
};
$8497c1e3bf13d11c$var$PouchDB.fetch = function(url, opts) {
    return $8497c1e3bf13d11c$var$f$1(url, opts);
};
$8497c1e3bf13d11c$var$PouchDB.prototype.activeTasks = $8497c1e3bf13d11c$var$PouchDB.activeTasks = new $8497c1e3bf13d11c$var$ActiveTasks();
// managed automatically by set-version.js
var $8497c1e3bf13d11c$var$version = "8.0.1";
// this would just be "return doc[field]", but fields
// can be "deep" due to dot notation
function $8497c1e3bf13d11c$var$getFieldFromDoc(doc, parsedField) {
    var value = doc;
    for(var i = 0, len = parsedField.length; i < len; i++){
        var key = parsedField[i];
        value = value[key];
        if (!value) break;
    }
    return value;
}
function $8497c1e3bf13d11c$var$compare$1(left, right) {
    return left < right ? -1 : left > right ? 1 : 0;
}
// Converts a string in dot notation to an array of its components, with backslash escaping
function $8497c1e3bf13d11c$var$parseField(fieldName) {
    // fields may be deep (e.g. "foo.bar.baz"), so parse
    var fields = [];
    var current = "";
    for(var i = 0, len = fieldName.length; i < len; i++){
        var ch = fieldName[i];
        if (i > 0 && fieldName[i - 1] === "\\" && (ch === "$" || ch === ".")) // escaped delimiter
        current = current.substring(0, current.length - 1) + ch;
        else if (ch === ".") {
            // When `.` is not escaped (above), it is a field delimiter
            fields.push(current);
            current = "";
        } else current += ch;
    }
    fields.push(current);
    return fields;
}
var $8497c1e3bf13d11c$var$combinationFields = [
    "$or",
    "$nor",
    "$not"
];
function $8497c1e3bf13d11c$var$isCombinationalField(field) {
    return $8497c1e3bf13d11c$var$combinationFields.indexOf(field) > -1;
}
function $8497c1e3bf13d11c$var$getKey(obj) {
    return Object.keys(obj)[0];
}
function $8497c1e3bf13d11c$var$getValue(obj) {
    return obj[$8497c1e3bf13d11c$var$getKey(obj)];
}
// flatten an array of selectors joined by an $and operator
function $8497c1e3bf13d11c$var$mergeAndedSelectors(selectors) {
    // sort to ensure that e.g. if the user specified
    // $and: [{$gt: 'a'}, {$gt: 'b'}], then it's collapsed into
    // just {$gt: 'b'}
    var res = {};
    var first = {
        $or: true,
        $nor: true
    };
    selectors.forEach(function(selector) {
        Object.keys(selector).forEach(function(field) {
            var matcher = selector[field];
            if (typeof matcher !== "object") matcher = {
                $eq: matcher
            };
            if ($8497c1e3bf13d11c$var$isCombinationalField(field)) {
                // or, nor
                if (matcher instanceof Array) {
                    if (first[field]) {
                        first[field] = false;
                        res[field] = matcher;
                        return;
                    }
                    var entries = [];
                    res[field].forEach(function(existing) {
                        Object.keys(matcher).forEach(function(key) {
                            var m = matcher[key];
                            var longest = Math.max(Object.keys(existing).length, Object.keys(m).length);
                            var merged = $8497c1e3bf13d11c$var$mergeAndedSelectors([
                                existing,
                                m
                            ]);
                            if (Object.keys(merged).length <= longest) // we have a situation like: (a :{$eq :1} || ...) && (a {$eq: 2} || ...)
                            // merging would produce a $eq 2 when actually we shouldn't ever match against these merged conditions
                            // merged should always contain more values to be valid
                            return;
                            entries.push(merged);
                        });
                    });
                    res[field] = entries;
                } else // not
                res[field] = $8497c1e3bf13d11c$var$mergeAndedSelectors([
                    matcher
                ]);
            } else {
                var fieldMatchers = res[field] = res[field] || {};
                Object.keys(matcher).forEach(function(operator) {
                    var value = matcher[operator];
                    if (operator === "$gt" || operator === "$gte") return $8497c1e3bf13d11c$var$mergeGtGte(operator, value, fieldMatchers);
                    else if (operator === "$lt" || operator === "$lte") return $8497c1e3bf13d11c$var$mergeLtLte(operator, value, fieldMatchers);
                    else if (operator === "$ne") return $8497c1e3bf13d11c$var$mergeNe(value, fieldMatchers);
                    else if (operator === "$eq") return $8497c1e3bf13d11c$var$mergeEq(value, fieldMatchers);
                    else if (operator === "$regex") return $8497c1e3bf13d11c$var$mergeRegex(value, fieldMatchers);
                    fieldMatchers[operator] = value;
                });
            }
        });
    });
    return res;
}
// collapse logically equivalent gt/gte values
function $8497c1e3bf13d11c$var$mergeGtGte(operator, value, fieldMatchers) {
    if (typeof fieldMatchers.$eq !== "undefined") return; // do nothing
    if (typeof fieldMatchers.$gte !== "undefined") {
        if (operator === "$gte") {
            if (value > fieldMatchers.$gte) fieldMatchers.$gte = value;
        } else if (value >= fieldMatchers.$gte) {
            delete fieldMatchers.$gte;
            fieldMatchers.$gt = value;
        }
    } else if (typeof fieldMatchers.$gt !== "undefined") {
        if (operator === "$gte") {
            if (value > fieldMatchers.$gt) {
                delete fieldMatchers.$gt;
                fieldMatchers.$gte = value;
            }
        } else if (value > fieldMatchers.$gt) fieldMatchers.$gt = value;
    } else fieldMatchers[operator] = value;
}
// collapse logically equivalent lt/lte values
function $8497c1e3bf13d11c$var$mergeLtLte(operator, value, fieldMatchers) {
    if (typeof fieldMatchers.$eq !== "undefined") return; // do nothing
    if (typeof fieldMatchers.$lte !== "undefined") {
        if (operator === "$lte") {
            if (value < fieldMatchers.$lte) fieldMatchers.$lte = value;
        } else if (value <= fieldMatchers.$lte) {
            delete fieldMatchers.$lte;
            fieldMatchers.$lt = value;
        }
    } else if (typeof fieldMatchers.$lt !== "undefined") {
        if (operator === "$lte") {
            if (value < fieldMatchers.$lt) {
                delete fieldMatchers.$lt;
                fieldMatchers.$lte = value;
            }
        } else if (value < fieldMatchers.$lt) fieldMatchers.$lt = value;
    } else fieldMatchers[operator] = value;
}
// combine $ne values into one array
function $8497c1e3bf13d11c$var$mergeNe(value, fieldMatchers) {
    if ("$ne" in fieldMatchers) // there are many things this could "not" be
    fieldMatchers.$ne.push(value);
    else fieldMatchers.$ne = [
        value
    ];
}
// add $eq into the mix
function $8497c1e3bf13d11c$var$mergeEq(value, fieldMatchers) {
    // these all have less specificity than the $eq
    // TODO: check for user errors here
    delete fieldMatchers.$gt;
    delete fieldMatchers.$gte;
    delete fieldMatchers.$lt;
    delete fieldMatchers.$lte;
    delete fieldMatchers.$ne;
    fieldMatchers.$eq = value;
}
// combine $regex values into one array
function $8497c1e3bf13d11c$var$mergeRegex(value, fieldMatchers) {
    if ("$regex" in fieldMatchers) // a value could match multiple regexes
    fieldMatchers.$regex.push(value);
    else fieldMatchers.$regex = [
        value
    ];
}
//#7458: execute function mergeAndedSelectors on nested $and
function $8497c1e3bf13d11c$var$mergeAndedSelectorsNested(obj) {
    for(var prop in obj){
        if (Array.isArray(obj)) {
            for(var i in obj)if (obj[i]["$and"]) obj[i] = $8497c1e3bf13d11c$var$mergeAndedSelectors(obj[i]["$and"]);
        }
        var value = obj[prop];
        if (typeof value === "object") $8497c1e3bf13d11c$var$mergeAndedSelectorsNested(value); // <- recursive call
    }
    return obj;
}
//#7458: determine id $and is present in selector (at any level)
function $8497c1e3bf13d11c$var$isAndInSelector(obj, isAnd) {
    for(var prop in obj){
        if (prop === "$and") isAnd = true;
        var value = obj[prop];
        if (typeof value === "object") isAnd = $8497c1e3bf13d11c$var$isAndInSelector(value, isAnd); // <- recursive call
    }
    return isAnd;
}
//
// normalize the selector
//
function $8497c1e3bf13d11c$var$massageSelector(input) {
    var result = $8497c1e3bf13d11c$var$clone(input);
    //#7458: if $and is present in selector (at any level) merge nested $and
    if ($8497c1e3bf13d11c$var$isAndInSelector(result, false)) {
        result = $8497c1e3bf13d11c$var$mergeAndedSelectorsNested(result);
        if ("$and" in result) result = $8497c1e3bf13d11c$var$mergeAndedSelectors(result["$and"]);
    }
    [
        "$or",
        "$nor"
    ].forEach(function(orOrNor) {
        if (orOrNor in result) // message each individual selector
        // e.g. {foo: 'bar'} becomes {foo: {$eq: 'bar'}}
        result[orOrNor].forEach(function(subSelector) {
            var fields = Object.keys(subSelector);
            for(var i = 0; i < fields.length; i++){
                var field = fields[i];
                var matcher = subSelector[field];
                if (typeof matcher !== "object" || matcher === null) subSelector[field] = {
                    $eq: matcher
                };
            }
        });
    });
    if ("$not" in result) //This feels a little like forcing, but it will work for now,
    //I would like to come back to this and make the merging of selectors a little more generic
    result["$not"] = $8497c1e3bf13d11c$var$mergeAndedSelectors([
        result["$not"]
    ]);
    var fields = Object.keys(result);
    for(var i = 0; i < fields.length; i++){
        var field = fields[i];
        var matcher = result[field];
        if (typeof matcher !== "object" || matcher === null) matcher = {
            $eq: matcher
        };
        result[field] = matcher;
    }
    $8497c1e3bf13d11c$var$normalizeArrayOperators(result);
    return result;
}
//
// The $ne and $regex values must be placed in an array because these operators can be used multiple times on the same field.
// When $and is used, mergeAndedSelectors takes care of putting some of them into arrays, otherwise it's done here.
//
function $8497c1e3bf13d11c$var$normalizeArrayOperators(selector) {
    Object.keys(selector).forEach(function(field) {
        var matcher = selector[field];
        if (Array.isArray(matcher)) matcher.forEach(function(matcherItem) {
            if (matcherItem && typeof matcherItem === "object") $8497c1e3bf13d11c$var$normalizeArrayOperators(matcherItem);
        });
        else if (field === "$ne") selector.$ne = [
            matcher
        ];
        else if (field === "$regex") selector.$regex = [
            matcher
        ];
        else if (matcher && typeof matcher === "object") $8497c1e3bf13d11c$var$normalizeArrayOperators(matcher);
    });
}
function $8497c1e3bf13d11c$var$pad(str, padWith, upToLength) {
    var padding = "";
    var targetLength = upToLength - str.length;
    /* istanbul ignore next */ while(padding.length < targetLength)padding += padWith;
    return padding;
}
function $8497c1e3bf13d11c$var$padLeft(str, padWith, upToLength) {
    var padding = $8497c1e3bf13d11c$var$pad(str, padWith, upToLength);
    return padding + str;
}
var $8497c1e3bf13d11c$var$MIN_MAGNITUDE = -324; // verified by -Number.MIN_VALUE
var $8497c1e3bf13d11c$var$MAGNITUDE_DIGITS = 3; // ditto
var $8497c1e3bf13d11c$var$SEP = ""; // set to '_' for easier debugging
function $8497c1e3bf13d11c$var$collate(a, b) {
    if (a === b) return 0;
    a = $8497c1e3bf13d11c$var$normalizeKey(a);
    b = $8497c1e3bf13d11c$var$normalizeKey(b);
    var ai = $8497c1e3bf13d11c$var$collationIndex(a);
    var bi = $8497c1e3bf13d11c$var$collationIndex(b);
    if (ai - bi !== 0) return ai - bi;
    switch(typeof a){
        case "number":
            return a - b;
        case "boolean":
            return a < b ? -1 : 1;
        case "string":
            return $8497c1e3bf13d11c$var$stringCollate(a, b);
    }
    return Array.isArray(a) ? $8497c1e3bf13d11c$var$arrayCollate(a, b) : $8497c1e3bf13d11c$var$objectCollate(a, b);
}
// couch considers null/NaN/Infinity/-Infinity === undefined,
// for the purposes of mapreduce indexes. also, dates get stringified.
function $8497c1e3bf13d11c$var$normalizeKey(key) {
    switch(typeof key){
        case "undefined":
            return null;
        case "number":
            if (key === Infinity || key === -Infinity || isNaN(key)) return null;
            return key;
        case "object":
            var origKey = key;
            if (Array.isArray(key)) {
                var len = key.length;
                key = new Array(len);
                for(var i = 0; i < len; i++)key[i] = $8497c1e3bf13d11c$var$normalizeKey(origKey[i]);
            /* istanbul ignore next */ } else if (key instanceof Date) return key.toJSON();
            else if (key !== null) {
                key = {};
                for(var k in origKey)if (Object.prototype.hasOwnProperty.call(origKey, k)) {
                    var val = origKey[k];
                    if (typeof val !== "undefined") key[k] = $8497c1e3bf13d11c$var$normalizeKey(val);
                }
            }
    }
    return key;
}
function $8497c1e3bf13d11c$var$indexify(key) {
    if (key !== null) switch(typeof key){
        case "boolean":
            return key ? 1 : 0;
        case "number":
            return $8497c1e3bf13d11c$var$numToIndexableString(key);
        case "string":
            // We've to be sure that key does not contain \u0000
            // Do order-preserving replacements:
            // 0 -> 1, 1
            // 1 -> 1, 2
            // 2 -> 2, 2
            /* eslint-disable no-control-regex */ return key.replace(/\u0002/g, "\x02\x02").replace(/\u0001/g, "\x01\x02").replace(/\u0000/g, "\x01\x01");
        /* eslint-enable no-control-regex */ case "object":
            var isArray = Array.isArray(key);
            var arr = isArray ? key : Object.keys(key);
            var i = -1;
            var len = arr.length;
            var result = "";
            if (isArray) while(++i < len)result += $8497c1e3bf13d11c$var$toIndexableString(arr[i]);
            else while(++i < len){
                var objKey = arr[i];
                result += $8497c1e3bf13d11c$var$toIndexableString(objKey) + $8497c1e3bf13d11c$var$toIndexableString(key[objKey]);
            }
            return result;
    }
    return "";
}
// convert the given key to a string that would be appropriate
// for lexical sorting, e.g. within a database, where the
// sorting is the same given by the collate() function.
function $8497c1e3bf13d11c$var$toIndexableString(key) {
    var zero = "\0";
    key = $8497c1e3bf13d11c$var$normalizeKey(key);
    return $8497c1e3bf13d11c$var$collationIndex(key) + $8497c1e3bf13d11c$var$SEP + $8497c1e3bf13d11c$var$indexify(key) + zero;
}
function $8497c1e3bf13d11c$var$parseNumber(str, i) {
    var originalIdx = i;
    var num;
    var zero = str[i] === "1";
    if (zero) {
        num = 0;
        i++;
    } else {
        var neg = str[i] === "0";
        i++;
        var numAsString = "";
        var magAsString = str.substring(i, i + $8497c1e3bf13d11c$var$MAGNITUDE_DIGITS);
        var magnitude = parseInt(magAsString, 10) + $8497c1e3bf13d11c$var$MIN_MAGNITUDE;
        /* istanbul ignore next */ if (neg) magnitude = -magnitude;
        i += $8497c1e3bf13d11c$var$MAGNITUDE_DIGITS;
        while(true){
            var ch = str[i];
            if (ch === "\0") break;
            else numAsString += ch;
            i++;
        }
        numAsString = numAsString.split(".");
        if (numAsString.length === 1) num = parseInt(numAsString, 10);
        else /* istanbul ignore next */ num = parseFloat(numAsString[0] + "." + numAsString[1]);
        /* istanbul ignore next */ if (neg) num = num - 10;
        /* istanbul ignore next */ if (magnitude !== 0) // parseFloat is more reliable than pow due to rounding errors
        // e.g. Number.MAX_VALUE would return Infinity if we did
        // num * Math.pow(10, magnitude);
        num = parseFloat(num + "e" + magnitude);
    }
    return {
        num: num,
        length: i - originalIdx
    };
}
// move up the stack while parsing
// this function moved outside of parseIndexableString for performance
function $8497c1e3bf13d11c$var$pop(stack, metaStack) {
    var obj = stack.pop();
    if (metaStack.length) {
        var lastMetaElement = metaStack[metaStack.length - 1];
        if (obj === lastMetaElement.element) {
            // popping a meta-element, e.g. an object whose value is another object
            metaStack.pop();
            lastMetaElement = metaStack[metaStack.length - 1];
        }
        var element = lastMetaElement.element;
        var lastElementIndex = lastMetaElement.index;
        if (Array.isArray(element)) element.push(obj);
        else if (lastElementIndex === stack.length - 2) {
            var key = stack.pop();
            element[key] = obj;
        } else stack.push(obj); // obj with key only
    }
}
function $8497c1e3bf13d11c$var$parseIndexableString(str) {
    var stack = [];
    var metaStack = []; // stack for arrays and objects
    var i = 0;
    /*eslint no-constant-condition: ["error", { "checkLoops": false }]*/ while(true){
        var collationIndex = str[i++];
        if (collationIndex === "\0") {
            if (stack.length === 1) return stack.pop();
            else {
                $8497c1e3bf13d11c$var$pop(stack, metaStack);
                continue;
            }
        }
        switch(collationIndex){
            case "1":
                stack.push(null);
                break;
            case "2":
                stack.push(str[i] === "1");
                i++;
                break;
            case "3":
                var parsedNum = $8497c1e3bf13d11c$var$parseNumber(str, i);
                stack.push(parsedNum.num);
                i += parsedNum.length;
                break;
            case "4":
                var parsedStr = "";
                /*eslint no-constant-condition: ["error", { "checkLoops": false }]*/ while(true){
                    var ch = str[i];
                    if (ch === "\0") break;
                    parsedStr += ch;
                    i++;
                }
                // perform the reverse of the order-preserving replacement
                // algorithm (see above)
                /* eslint-disable no-control-regex */ parsedStr = parsedStr.replace(/\u0001\u0001/g, "\0").replace(/\u0001\u0002/g, "\x01").replace(/\u0002\u0002/g, "\x02");
                /* eslint-enable no-control-regex */ stack.push(parsedStr);
                break;
            case "5":
                var arrayElement = {
                    element: [],
                    index: stack.length
                };
                stack.push(arrayElement.element);
                metaStack.push(arrayElement);
                break;
            case "6":
                var objElement = {
                    element: {},
                    index: stack.length
                };
                stack.push(objElement.element);
                metaStack.push(objElement);
                break;
            /* istanbul ignore next */ default:
                throw new Error("bad collationIndex or unexpectedly reached end of input: " + collationIndex);
        }
    }
}
function $8497c1e3bf13d11c$var$arrayCollate(a, b) {
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; i++){
        var sort = $8497c1e3bf13d11c$var$collate(a[i], b[i]);
        if (sort !== 0) return sort;
    }
    return a.length === b.length ? 0 : a.length > b.length ? 1 : -1;
}
function $8497c1e3bf13d11c$var$stringCollate(a, b) {
    // See: https://github.com/daleharvey/pouchdb/issues/40
    // This is incompatible with the CouchDB implementation, but its the
    // best we can do for now
    return a === b ? 0 : a > b ? 1 : -1;
}
function $8497c1e3bf13d11c$var$objectCollate(a, b) {
    var ak = Object.keys(a), bk = Object.keys(b);
    var len = Math.min(ak.length, bk.length);
    for(var i = 0; i < len; i++){
        // First sort the keys
        var sort = $8497c1e3bf13d11c$var$collate(ak[i], bk[i]);
        if (sort !== 0) return sort;
        // if the keys are equal sort the values
        sort = $8497c1e3bf13d11c$var$collate(a[ak[i]], b[bk[i]]);
        if (sort !== 0) return sort;
    }
    return ak.length === bk.length ? 0 : ak.length > bk.length ? 1 : -1;
}
// The collation is defined by erlangs ordered terms
// the atoms null, true, false come first, then numbers, strings,
// arrays, then objects
// null/undefined/NaN/Infinity/-Infinity are all considered null
function $8497c1e3bf13d11c$var$collationIndex(x) {
    var id = [
        "boolean",
        "number",
        "string",
        "object"
    ];
    var idx = id.indexOf(typeof x);
    //false if -1 otherwise true, but fast!!!!1
    if (~idx) {
        if (x === null) return 1;
        if (Array.isArray(x)) return 5;
        return idx < 3 ? idx + 2 : idx + 3;
    }
    /* istanbul ignore next */ if (Array.isArray(x)) return 5;
}
// conversion:
// x yyy zz...zz
// x = 0 for negative, 1 for 0, 2 for positive
// y = exponent (for negative numbers negated) moved so that it's >= 0
// z = mantisse
function $8497c1e3bf13d11c$var$numToIndexableString(num) {
    if (num === 0) return "1";
    // convert number to exponential format for easier and
    // more succinct string sorting
    var expFormat = num.toExponential().split(/e\+?/);
    var magnitude = parseInt(expFormat[1], 10);
    var neg = num < 0;
    var result = neg ? "0" : "2";
    // first sort by magnitude
    // it's easier if all magnitudes are positive
    var magForComparison = (neg ? -magnitude : magnitude) - $8497c1e3bf13d11c$var$MIN_MAGNITUDE;
    var magString = $8497c1e3bf13d11c$var$padLeft(magForComparison.toString(), "0", $8497c1e3bf13d11c$var$MAGNITUDE_DIGITS);
    result += $8497c1e3bf13d11c$var$SEP + magString;
    // then sort by the factor
    var factor = Math.abs(parseFloat(expFormat[0])); // [1..10)
    /* istanbul ignore next */ if (neg) factor = 10 - factor;
    var factorStr = factor.toFixed(20);
    // strip zeros from the end
    factorStr = factorStr.replace(/\.?0+$/, "");
    result += $8497c1e3bf13d11c$var$SEP + factorStr;
    return result;
}
// create a comparator based on the sort object
function $8497c1e3bf13d11c$var$createFieldSorter(sort) {
    function getFieldValuesAsArray(doc) {
        return sort.map(function(sorting) {
            var fieldName = $8497c1e3bf13d11c$var$getKey(sorting);
            var parsedField = $8497c1e3bf13d11c$var$parseField(fieldName);
            var docFieldValue = $8497c1e3bf13d11c$var$getFieldFromDoc(doc, parsedField);
            return docFieldValue;
        });
    }
    return function(aRow, bRow) {
        var aFieldValues = getFieldValuesAsArray(aRow.doc);
        var bFieldValues = getFieldValuesAsArray(bRow.doc);
        var collation = $8497c1e3bf13d11c$var$collate(aFieldValues, bFieldValues);
        if (collation !== 0) return collation;
        // this is what mango seems to do
        return $8497c1e3bf13d11c$var$compare$1(aRow.doc._id, bRow.doc._id);
    };
}
function $8497c1e3bf13d11c$var$filterInMemoryFields(rows, requestDef, inMemoryFields) {
    rows = rows.filter(function(row) {
        return $8497c1e3bf13d11c$var$rowFilter(row.doc, requestDef.selector, inMemoryFields);
    });
    if (requestDef.sort) {
        // in-memory sort
        var fieldSorter = $8497c1e3bf13d11c$var$createFieldSorter(requestDef.sort);
        rows = rows.sort(fieldSorter);
        if (typeof requestDef.sort[0] !== "string" && $8497c1e3bf13d11c$var$getValue(requestDef.sort[0]) === "desc") rows = rows.reverse();
    }
    if ("limit" in requestDef || "skip" in requestDef) {
        // have to do the limit in-memory
        var skip = requestDef.skip || 0;
        var limit = ("limit" in requestDef ? requestDef.limit : rows.length) + skip;
        rows = rows.slice(skip, limit);
    }
    return rows;
}
function $8497c1e3bf13d11c$var$rowFilter(doc, selector, inMemoryFields) {
    return inMemoryFields.every(function(field) {
        var matcher = selector[field];
        var parsedField = $8497c1e3bf13d11c$var$parseField(field);
        var docFieldValue = $8497c1e3bf13d11c$var$getFieldFromDoc(doc, parsedField);
        if ($8497c1e3bf13d11c$var$isCombinationalField(field)) return $8497c1e3bf13d11c$var$matchCominationalSelector(field, matcher, doc);
        return $8497c1e3bf13d11c$var$matchSelector(matcher, doc, parsedField, docFieldValue);
    });
}
function $8497c1e3bf13d11c$var$matchSelector(matcher, doc, parsedField, docFieldValue) {
    if (!matcher) // no filtering necessary; this field is just needed for sorting
    return true;
    // is matcher an object, if so continue recursion
    if (typeof matcher === "object") return Object.keys(matcher).every(function(maybeUserOperator) {
        var userValue = matcher[maybeUserOperator];
        // explicit operator
        if (maybeUserOperator.indexOf("$") === 0) return $8497c1e3bf13d11c$var$match(maybeUserOperator, doc, userValue, parsedField, docFieldValue);
        else {
            var subParsedField = $8497c1e3bf13d11c$var$parseField(maybeUserOperator);
            if (docFieldValue === undefined && typeof userValue !== "object" && subParsedField.length > 0) // the field does not exist, return or getFieldFromDoc will throw
            return false;
            var subDocFieldValue = $8497c1e3bf13d11c$var$getFieldFromDoc(docFieldValue, subParsedField);
            if (typeof userValue === "object") // field value is an object that might contain more operators
            return $8497c1e3bf13d11c$var$matchSelector(userValue, doc, parsedField, subDocFieldValue);
            // implicit operator
            return $8497c1e3bf13d11c$var$match("$eq", doc, userValue, subParsedField, subDocFieldValue);
        }
    });
    // no more depth, No need to recurse further
    return matcher === docFieldValue;
}
function $8497c1e3bf13d11c$var$matchCominationalSelector(field, matcher, doc) {
    if (field === "$or") return matcher.some(function(orMatchers) {
        return $8497c1e3bf13d11c$var$rowFilter(doc, orMatchers, Object.keys(orMatchers));
    });
    if (field === "$not") return !$8497c1e3bf13d11c$var$rowFilter(doc, matcher, Object.keys(matcher));
    //`$nor`
    return !matcher.find(function(orMatchers) {
        return $8497c1e3bf13d11c$var$rowFilter(doc, orMatchers, Object.keys(orMatchers));
    });
}
function $8497c1e3bf13d11c$var$match(userOperator, doc, userValue, parsedField, docFieldValue) {
    if (!$8497c1e3bf13d11c$var$matchers[userOperator]) /* istanbul ignore next */ throw new Error('unknown operator "' + userOperator + '" - should be one of $eq, $lte, $lt, $gt, $gte, $exists, $ne, $in, ' + "$nin, $size, $mod, $regex, $elemMatch, $type, $allMatch or $all");
    return $8497c1e3bf13d11c$var$matchers[userOperator](doc, userValue, parsedField, docFieldValue);
}
function $8497c1e3bf13d11c$var$fieldExists(docFieldValue) {
    return typeof docFieldValue !== "undefined" && docFieldValue !== null;
}
function $8497c1e3bf13d11c$var$fieldIsNotUndefined(docFieldValue) {
    return typeof docFieldValue !== "undefined";
}
function $8497c1e3bf13d11c$var$modField(docFieldValue, userValue) {
    if (typeof docFieldValue !== "number" || parseInt(docFieldValue, 10) !== docFieldValue) return false;
    var divisor = userValue[0];
    var mod = userValue[1];
    return docFieldValue % divisor === mod;
}
function $8497c1e3bf13d11c$var$arrayContainsValue(docFieldValue, userValue) {
    return userValue.some(function(val) {
        if (docFieldValue instanceof Array) return docFieldValue.some(function(docFieldValueItem) {
            return $8497c1e3bf13d11c$var$collate(val, docFieldValueItem) === 0;
        });
        return $8497c1e3bf13d11c$var$collate(val, docFieldValue) === 0;
    });
}
function $8497c1e3bf13d11c$var$arrayContainsAllValues(docFieldValue, userValue) {
    return userValue.every(function(val) {
        return docFieldValue.some(function(docFieldValueItem) {
            return $8497c1e3bf13d11c$var$collate(val, docFieldValueItem) === 0;
        });
    });
}
function $8497c1e3bf13d11c$var$arraySize(docFieldValue, userValue) {
    return docFieldValue.length === userValue;
}
function $8497c1e3bf13d11c$var$regexMatch(docFieldValue, userValue) {
    var re = new RegExp(userValue);
    return re.test(docFieldValue);
}
function $8497c1e3bf13d11c$var$typeMatch(docFieldValue, userValue) {
    switch(userValue){
        case "null":
            return docFieldValue === null;
        case "boolean":
            return typeof docFieldValue === "boolean";
        case "number":
            return typeof docFieldValue === "number";
        case "string":
            return typeof docFieldValue === "string";
        case "array":
            return docFieldValue instanceof Array;
        case "object":
            return ({}).toString.call(docFieldValue) === "[object Object]";
    }
}
var $8497c1e3bf13d11c$var$matchers = {
    "$elemMatch": function(doc, userValue, parsedField, docFieldValue) {
        if (!Array.isArray(docFieldValue)) return false;
        if (docFieldValue.length === 0) return false;
        if (typeof docFieldValue[0] === "object" && docFieldValue[0] !== null) return docFieldValue.some(function(val) {
            return $8497c1e3bf13d11c$var$rowFilter(val, userValue, Object.keys(userValue));
        });
        return docFieldValue.some(function(val) {
            return $8497c1e3bf13d11c$var$matchSelector(userValue, doc, parsedField, val);
        });
    },
    "$allMatch": function(doc, userValue, parsedField, docFieldValue) {
        if (!Array.isArray(docFieldValue)) return false;
        /* istanbul ignore next */ if (docFieldValue.length === 0) return false;
        if (typeof docFieldValue[0] === "object" && docFieldValue[0] !== null) return docFieldValue.every(function(val) {
            return $8497c1e3bf13d11c$var$rowFilter(val, userValue, Object.keys(userValue));
        });
        return docFieldValue.every(function(val) {
            return $8497c1e3bf13d11c$var$matchSelector(userValue, doc, parsedField, val);
        });
    },
    "$eq": function(doc, userValue, parsedField, docFieldValue) {
        return $8497c1e3bf13d11c$var$fieldIsNotUndefined(docFieldValue) && $8497c1e3bf13d11c$var$collate(docFieldValue, userValue) === 0;
    },
    "$gte": function(doc, userValue, parsedField, docFieldValue) {
        return $8497c1e3bf13d11c$var$fieldIsNotUndefined(docFieldValue) && $8497c1e3bf13d11c$var$collate(docFieldValue, userValue) >= 0;
    },
    "$gt": function(doc, userValue, parsedField, docFieldValue) {
        return $8497c1e3bf13d11c$var$fieldIsNotUndefined(docFieldValue) && $8497c1e3bf13d11c$var$collate(docFieldValue, userValue) > 0;
    },
    "$lte": function(doc, userValue, parsedField, docFieldValue) {
        return $8497c1e3bf13d11c$var$fieldIsNotUndefined(docFieldValue) && $8497c1e3bf13d11c$var$collate(docFieldValue, userValue) <= 0;
    },
    "$lt": function(doc, userValue, parsedField, docFieldValue) {
        return $8497c1e3bf13d11c$var$fieldIsNotUndefined(docFieldValue) && $8497c1e3bf13d11c$var$collate(docFieldValue, userValue) < 0;
    },
    "$exists": function(doc, userValue, parsedField, docFieldValue) {
        //a field that is null is still considered to exist
        if (userValue) return $8497c1e3bf13d11c$var$fieldIsNotUndefined(docFieldValue);
        return !$8497c1e3bf13d11c$var$fieldIsNotUndefined(docFieldValue);
    },
    "$mod": function(doc, userValue, parsedField, docFieldValue) {
        return $8497c1e3bf13d11c$var$fieldExists(docFieldValue) && $8497c1e3bf13d11c$var$modField(docFieldValue, userValue);
    },
    "$ne": function(doc, userValue, parsedField, docFieldValue) {
        return userValue.every(function(neValue) {
            return $8497c1e3bf13d11c$var$collate(docFieldValue, neValue) !== 0;
        });
    },
    "$in": function(doc, userValue, parsedField, docFieldValue) {
        return $8497c1e3bf13d11c$var$fieldExists(docFieldValue) && $8497c1e3bf13d11c$var$arrayContainsValue(docFieldValue, userValue);
    },
    "$nin": function(doc, userValue, parsedField, docFieldValue) {
        return $8497c1e3bf13d11c$var$fieldExists(docFieldValue) && !$8497c1e3bf13d11c$var$arrayContainsValue(docFieldValue, userValue);
    },
    "$size": function(doc, userValue, parsedField, docFieldValue) {
        return $8497c1e3bf13d11c$var$fieldExists(docFieldValue) && Array.isArray(docFieldValue) && $8497c1e3bf13d11c$var$arraySize(docFieldValue, userValue);
    },
    "$all": function(doc, userValue, parsedField, docFieldValue) {
        return Array.isArray(docFieldValue) && $8497c1e3bf13d11c$var$arrayContainsAllValues(docFieldValue, userValue);
    },
    "$regex": function(doc, userValue, parsedField, docFieldValue) {
        return $8497c1e3bf13d11c$var$fieldExists(docFieldValue) && typeof docFieldValue == "string" && userValue.every(function(regexValue) {
            return $8497c1e3bf13d11c$var$regexMatch(docFieldValue, regexValue);
        });
    },
    "$type": function(doc, userValue, parsedField, docFieldValue) {
        return $8497c1e3bf13d11c$var$typeMatch(docFieldValue, userValue);
    }
};
// return true if the given doc matches the supplied selector
function $8497c1e3bf13d11c$var$matchesSelector(doc, selector) {
    /* istanbul ignore if */ if (typeof selector !== "object") // match the CouchDB error message
    throw new Error("Selector error: expected a JSON object");
    selector = $8497c1e3bf13d11c$var$massageSelector(selector);
    var row = {
        "doc": doc
    };
    var rowsMatched = $8497c1e3bf13d11c$var$filterInMemoryFields([
        row
    ], {
        "selector": selector
    }, Object.keys(selector));
    return rowsMatched && rowsMatched.length === 1;
}
function $8497c1e3bf13d11c$var$evalFilter(input) {
    return $8497c1e3bf13d11c$var$scopeEval('"use strict";\nreturn ' + input + ";", {});
}
function $8497c1e3bf13d11c$var$evalView(input) {
    var code = [
        "return function(doc) {",
        '  "use strict";',
        "  var emitted = false;",
        "  var emit = function (a, b) {",
        "    emitted = true;",
        "  };",
        "  var view = " + input + ";",
        "  view(doc);",
        "  if (emitted) {",
        "    return true;",
        "  }",
        "};"
    ].join("\n");
    return $8497c1e3bf13d11c$var$scopeEval(code, {});
}
function $8497c1e3bf13d11c$var$validate(opts, callback) {
    if (opts.selector) {
        if (opts.filter && opts.filter !== "_selector") {
            var filterName = typeof opts.filter === "string" ? opts.filter : "function";
            return callback(new Error('selector invalid for filter "' + filterName + '"'));
        }
    }
    callback();
}
function $8497c1e3bf13d11c$var$normalize(opts) {
    if (opts.view && !opts.filter) opts.filter = "_view";
    if (opts.selector && !opts.filter) opts.filter = "_selector";
    if (opts.filter && typeof opts.filter === "string") {
        if (opts.filter === "_view") opts.view = $8497c1e3bf13d11c$var$normalizeDesignDocFunctionName(opts.view);
        else opts.filter = $8497c1e3bf13d11c$var$normalizeDesignDocFunctionName(opts.filter);
    }
}
function $8497c1e3bf13d11c$var$shouldFilter(changesHandler, opts) {
    return opts.filter && typeof opts.filter === "string" && !opts.doc_ids && !$8497c1e3bf13d11c$var$isRemote(changesHandler.db);
}
function $8497c1e3bf13d11c$var$filter(changesHandler, opts) {
    var callback = opts.complete;
    if (opts.filter === "_view") {
        if (!opts.view || typeof opts.view !== "string") {
            var err = $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$BAD_REQUEST, "`view` filter parameter not found or invalid.");
            return callback(err);
        }
        // fetch a view from a design doc, make it behave like a filter
        var viewName = $8497c1e3bf13d11c$var$parseDesignDocFunctionName(opts.view);
        changesHandler.db.get("_design/" + viewName[0], function(err, ddoc) {
            /* istanbul ignore if */ if (changesHandler.isCancelled) return callback(null, {
                status: "cancelled"
            });
            /* istanbul ignore next */ if (err) return callback($8497c1e3bf13d11c$var$generateErrorFromResponse(err));
            var mapFun = ddoc && ddoc.views && ddoc.views[viewName[1]] && ddoc.views[viewName[1]].map;
            if (!mapFun) return callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$MISSING_DOC, ddoc.views ? "missing json key: " + viewName[1] : "missing json key: views"));
            opts.filter = $8497c1e3bf13d11c$var$evalView(mapFun);
            changesHandler.doChanges(opts);
        });
    } else if (opts.selector) {
        opts.filter = function(doc) {
            return $8497c1e3bf13d11c$var$matchesSelector(doc, opts.selector);
        };
        changesHandler.doChanges(opts);
    } else {
        // fetch a filter from a design doc
        var filterName = $8497c1e3bf13d11c$var$parseDesignDocFunctionName(opts.filter);
        changesHandler.db.get("_design/" + filterName[0], function(err, ddoc) {
            /* istanbul ignore if */ if (changesHandler.isCancelled) return callback(null, {
                status: "cancelled"
            });
            /* istanbul ignore next */ if (err) return callback($8497c1e3bf13d11c$var$generateErrorFromResponse(err));
            var filterFun = ddoc && ddoc.filters && ddoc.filters[filterName[1]];
            if (!filterFun) return callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$MISSING_DOC, ddoc && ddoc.filters ? "missing json key: " + filterName[1] : "missing json key: filters"));
            opts.filter = $8497c1e3bf13d11c$var$evalFilter(filterFun);
            changesHandler.doChanges(opts);
        });
    }
}
function $8497c1e3bf13d11c$var$applyChangesFilterPlugin(PouchDB) {
    PouchDB._changesFilterPlugin = {
        validate: $8497c1e3bf13d11c$var$validate,
        normalize: $8497c1e3bf13d11c$var$normalize,
        shouldFilter: $8497c1e3bf13d11c$var$shouldFilter,
        filter: $8497c1e3bf13d11c$var$filter
    };
}
// TODO: remove from pouchdb-core (breaking)
$8497c1e3bf13d11c$var$PouchDB.plugin($8497c1e3bf13d11c$var$applyChangesFilterPlugin);
$8497c1e3bf13d11c$var$PouchDB.version = $8497c1e3bf13d11c$var$version;
function $8497c1e3bf13d11c$var$toObject(array) {
    return array.reduce(function(obj, item) {
        obj[item] = true;
        return obj;
    }, {});
}
// List of top level reserved words for doc
var $8497c1e3bf13d11c$var$reservedWords = $8497c1e3bf13d11c$var$toObject([
    "_id",
    "_rev",
    "_access",
    "_attachments",
    "_deleted",
    "_revisions",
    "_revs_info",
    "_conflicts",
    "_deleted_conflicts",
    "_local_seq",
    "_rev_tree",
    // replication documents
    "_replication_id",
    "_replication_state",
    "_replication_state_time",
    "_replication_state_reason",
    "_replication_stats",
    // Specific to Couchbase Sync Gateway
    "_removed"
]);
// List of reserved words that should end up in the document
var $8497c1e3bf13d11c$var$dataWords = $8497c1e3bf13d11c$var$toObject([
    "_access",
    "_attachments",
    // replication documents
    "_replication_id",
    "_replication_state",
    "_replication_state_time",
    "_replication_state_reason",
    "_replication_stats"
]);
function $8497c1e3bf13d11c$var$parseRevisionInfo(rev) {
    if (!/^\d+-/.test(rev)) return $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$INVALID_REV);
    var idx = rev.indexOf("-");
    var left = rev.substring(0, idx);
    var right = rev.substring(idx + 1);
    return {
        prefix: parseInt(left, 10),
        id: right
    };
}
function $8497c1e3bf13d11c$var$makeRevTreeFromRevisions(revisions, opts) {
    var pos = revisions.start - revisions.ids.length + 1;
    var revisionIds = revisions.ids;
    var ids = [
        revisionIds[0],
        opts,
        []
    ];
    for(var i = 1, len = revisionIds.length; i < len; i++)ids = [
        revisionIds[i],
        {
            status: "missing"
        },
        [
            ids
        ]
    ];
    return [
        {
            pos: pos,
            ids: ids
        }
    ];
}
// Preprocess documents, parse their revisions, assign an id and a
// revision for new writes that are missing them, etc
function $8497c1e3bf13d11c$var$parseDoc(doc, newEdits, dbOpts) {
    if (!dbOpts) dbOpts = {
        deterministic_revs: true
    };
    var nRevNum;
    var newRevId;
    var revInfo;
    var opts = {
        status: "available"
    };
    if (doc._deleted) opts.deleted = true;
    if (newEdits) {
        if (!doc._id) doc._id = $8497c1e3bf13d11c$var$uuid();
        newRevId = $8497c1e3bf13d11c$var$rev$$1(doc, dbOpts.deterministic_revs);
        if (doc._rev) {
            revInfo = $8497c1e3bf13d11c$var$parseRevisionInfo(doc._rev);
            if (revInfo.error) return revInfo;
            doc._rev_tree = [
                {
                    pos: revInfo.prefix,
                    ids: [
                        revInfo.id,
                        {
                            status: "missing"
                        },
                        [
                            [
                                newRevId,
                                opts,
                                []
                            ]
                        ]
                    ]
                }
            ];
            nRevNum = revInfo.prefix + 1;
        } else {
            doc._rev_tree = [
                {
                    pos: 1,
                    ids: [
                        newRevId,
                        opts,
                        []
                    ]
                }
            ];
            nRevNum = 1;
        }
    } else {
        if (doc._revisions) {
            doc._rev_tree = $8497c1e3bf13d11c$var$makeRevTreeFromRevisions(doc._revisions, opts);
            nRevNum = doc._revisions.start;
            newRevId = doc._revisions.ids[0];
        }
        if (!doc._rev_tree) {
            revInfo = $8497c1e3bf13d11c$var$parseRevisionInfo(doc._rev);
            if (revInfo.error) return revInfo;
            nRevNum = revInfo.prefix;
            newRevId = revInfo.id;
            doc._rev_tree = [
                {
                    pos: nRevNum,
                    ids: [
                        newRevId,
                        opts,
                        []
                    ]
                }
            ];
        }
    }
    $8497c1e3bf13d11c$var$invalidIdError(doc._id);
    doc._rev = nRevNum + "-" + newRevId;
    var result = {
        metadata: {},
        data: {}
    };
    for(var key in doc)/* istanbul ignore else */ if (Object.prototype.hasOwnProperty.call(doc, key)) {
        var specialKey = key[0] === "_";
        if (specialKey && !$8497c1e3bf13d11c$var$reservedWords[key]) {
            var error = $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$DOC_VALIDATION, key);
            error.message = $8497c1e3bf13d11c$var$DOC_VALIDATION.message + ": " + key;
            throw error;
        } else if (specialKey && !$8497c1e3bf13d11c$var$dataWords[key]) result.metadata[key.slice(1)] = doc[key];
        else result.data[key] = doc[key];
    }
    return result;
}
function $8497c1e3bf13d11c$var$parseBase64(data) {
    try {
        return $8497c1e3bf13d11c$var$thisAtob(data);
    } catch (e) {
        var err = $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$BAD_ARG, "Attachment is not a valid base64 string");
        return {
            error: err
        };
    }
}
function $8497c1e3bf13d11c$var$preprocessString(att, blobType, callback) {
    var asBinary = $8497c1e3bf13d11c$var$parseBase64(att.data);
    if (asBinary.error) return callback(asBinary.error);
    att.length = asBinary.length;
    if (blobType === "blob") att.data = $8497c1e3bf13d11c$var$binStringToBluffer(asBinary, att.content_type);
    else if (blobType === "base64") att.data = $8497c1e3bf13d11c$var$thisBtoa(asBinary);
    else att.data = asBinary;
    $8497c1e3bf13d11c$var$binaryMd5(asBinary, function(result) {
        att.digest = "md5-" + result;
        callback();
    });
}
function $8497c1e3bf13d11c$var$preprocessBlob(att, blobType, callback) {
    $8497c1e3bf13d11c$var$binaryMd5(att.data, function(md5) {
        att.digest = "md5-" + md5;
        // size is for blobs (browser), length is for buffers (node)
        att.length = att.data.size || att.data.length || 0;
        if (blobType === "binary") $8497c1e3bf13d11c$var$blobToBinaryString(att.data, function(binString) {
            att.data = binString;
            callback();
        });
        else if (blobType === "base64") $8497c1e3bf13d11c$var$blobToBase64(att.data, function(b64) {
            att.data = b64;
            callback();
        });
        else callback();
    });
}
function $8497c1e3bf13d11c$var$preprocessAttachment(att, blobType, callback) {
    if (att.stub) return callback();
    if (typeof att.data === "string") $8497c1e3bf13d11c$var$preprocessString(att, blobType, callback);
    else $8497c1e3bf13d11c$var$preprocessBlob(att, blobType, callback);
}
function $8497c1e3bf13d11c$var$preprocessAttachments(docInfos, blobType, callback) {
    if (!docInfos.length) return callback();
    var docv = 0;
    var overallErr;
    docInfos.forEach(function(docInfo) {
        var attachments = docInfo.data && docInfo.data._attachments ? Object.keys(docInfo.data._attachments) : [];
        var recv = 0;
        if (!attachments.length) return done();
        function processedAttachment(err) {
            overallErr = err;
            recv++;
            if (recv === attachments.length) done();
        }
        for(var key in docInfo.data._attachments)if (Object.prototype.hasOwnProperty.call(docInfo.data._attachments, key)) $8497c1e3bf13d11c$var$preprocessAttachment(docInfo.data._attachments[key], blobType, processedAttachment);
    });
    function done() {
        docv++;
        if (docInfos.length === docv) {
            if (overallErr) callback(overallErr);
            else callback();
        }
    }
}
function $8497c1e3bf13d11c$var$updateDoc(revLimit, prev, docInfo, results, i, cb, writeDoc, newEdits) {
    if ($8497c1e3bf13d11c$var$revExists(prev.rev_tree, docInfo.metadata.rev) && !newEdits) {
        results[i] = docInfo;
        return cb();
    }
    // sometimes this is pre-calculated. historically not always
    var previousWinningRev = prev.winningRev || $8497c1e3bf13d11c$var$winningRev(prev);
    var previouslyDeleted = "deleted" in prev ? prev.deleted : $8497c1e3bf13d11c$var$isDeleted(prev, previousWinningRev);
    var deleted = "deleted" in docInfo.metadata ? docInfo.metadata.deleted : $8497c1e3bf13d11c$var$isDeleted(docInfo.metadata);
    var isRoot = /^1-/.test(docInfo.metadata.rev);
    if (previouslyDeleted && !deleted && newEdits && isRoot) {
        var newDoc = docInfo.data;
        newDoc._rev = previousWinningRev;
        newDoc._id = docInfo.metadata.id;
        docInfo = $8497c1e3bf13d11c$var$parseDoc(newDoc, newEdits);
    }
    var merged = $8497c1e3bf13d11c$var$merge(prev.rev_tree, docInfo.metadata.rev_tree[0], revLimit);
    var inConflict = newEdits && (previouslyDeleted && deleted && merged.conflicts !== "new_leaf" || !previouslyDeleted && merged.conflicts !== "new_leaf" || previouslyDeleted && !deleted && merged.conflicts === "new_branch");
    if (inConflict) {
        var err = $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$REV_CONFLICT);
        results[i] = err;
        return cb();
    }
    var newRev = docInfo.metadata.rev;
    docInfo.metadata.rev_tree = merged.tree;
    docInfo.stemmedRevs = merged.stemmedRevs || [];
    /* istanbul ignore else */ if (prev.rev_map) docInfo.metadata.rev_map = prev.rev_map; // used only by leveldb
    // recalculate
    var winningRev$$1 = $8497c1e3bf13d11c$var$winningRev(docInfo.metadata);
    var winningRevIsDeleted = $8497c1e3bf13d11c$var$isDeleted(docInfo.metadata, winningRev$$1);
    // calculate the total number of documents that were added/removed,
    // from the perspective of total_rows/doc_count
    var delta = previouslyDeleted === winningRevIsDeleted ? 0 : previouslyDeleted < winningRevIsDeleted ? -1 : 1;
    var newRevIsDeleted;
    if (newRev === winningRev$$1) // if the new rev is the same as the winning rev, we can reuse that value
    newRevIsDeleted = winningRevIsDeleted;
    else // if they're not the same, then we need to recalculate
    newRevIsDeleted = $8497c1e3bf13d11c$var$isDeleted(docInfo.metadata, newRev);
    writeDoc(docInfo, winningRev$$1, winningRevIsDeleted, newRevIsDeleted, true, delta, i, cb);
}
function $8497c1e3bf13d11c$var$rootIsMissing(docInfo) {
    return docInfo.metadata.rev_tree[0].ids[1].status === "missing";
}
function $8497c1e3bf13d11c$var$processDocs(revLimit, docInfos, api, fetchedDocs, tx, results, writeDoc, opts, overallCallback) {
    // Default to 1000 locally
    revLimit = revLimit || 1000;
    function insertDoc(docInfo, resultsIdx, callback) {
        // Cant insert new deleted documents
        var winningRev$$1 = $8497c1e3bf13d11c$var$winningRev(docInfo.metadata);
        var deleted = $8497c1e3bf13d11c$var$isDeleted(docInfo.metadata, winningRev$$1);
        if ("was_delete" in opts && deleted) {
            results[resultsIdx] = $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$MISSING_DOC, "deleted");
            return callback();
        }
        // 4712 - detect whether a new document was inserted with a _rev
        var inConflict = newEdits && $8497c1e3bf13d11c$var$rootIsMissing(docInfo);
        if (inConflict) {
            var err = $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$REV_CONFLICT);
            results[resultsIdx] = err;
            return callback();
        }
        var delta = deleted ? 0 : 1;
        writeDoc(docInfo, winningRev$$1, deleted, deleted, false, delta, resultsIdx, callback);
    }
    var newEdits = opts.new_edits;
    var idsToDocs = new $8497c1e3bf13d11c$var$ExportedMap();
    var docsDone = 0;
    var docsToDo = docInfos.length;
    function checkAllDocsDone() {
        if (++docsDone === docsToDo && overallCallback) overallCallback();
    }
    docInfos.forEach(function(currentDoc, resultsIdx) {
        if (currentDoc._id && $8497c1e3bf13d11c$var$isLocalId(currentDoc._id)) {
            var fun = currentDoc._deleted ? "_removeLocal" : "_putLocal";
            api[fun](currentDoc, {
                ctx: tx
            }, function(err, res) {
                results[resultsIdx] = err || res;
                checkAllDocsDone();
            });
            return;
        }
        var id = currentDoc.metadata.id;
        if (idsToDocs.has(id)) {
            docsToDo--; // duplicate
            idsToDocs.get(id).push([
                currentDoc,
                resultsIdx
            ]);
        } else idsToDocs.set(id, [
            [
                currentDoc,
                resultsIdx
            ]
        ]);
    });
    // in the case of new_edits, the user can provide multiple docs
    // with the same id. these need to be processed sequentially
    idsToDocs.forEach(function(docs, id) {
        var numDone = 0;
        function docWritten() {
            if (++numDone < docs.length) nextDoc();
            else checkAllDocsDone();
        }
        function nextDoc() {
            var value = docs[numDone];
            var currentDoc = value[0];
            var resultsIdx = value[1];
            if (fetchedDocs.has(id)) $8497c1e3bf13d11c$var$updateDoc(revLimit, fetchedDocs.get(id), currentDoc, results, resultsIdx, docWritten, writeDoc, newEdits);
            else {
                // Ensure stemming applies to new writes as well
                var merged = $8497c1e3bf13d11c$var$merge([], currentDoc.metadata.rev_tree[0], revLimit);
                currentDoc.metadata.rev_tree = merged.tree;
                currentDoc.stemmedRevs = merged.stemmedRevs || [];
                insertDoc(currentDoc, resultsIdx, docWritten);
            }
        }
        nextDoc();
    });
}
// IndexedDB requires a versioned database structure, so we use the
// version here to manage migrations.
var $8497c1e3bf13d11c$var$ADAPTER_VERSION = 5;
// The object stores created for each database
// DOC_STORE stores the document meta data, its revision history and state
// Keyed by document id
var $8497c1e3bf13d11c$var$DOC_STORE = "document-store";
// BY_SEQ_STORE stores a particular version of a document, keyed by its
// sequence id
var $8497c1e3bf13d11c$var$BY_SEQ_STORE = "by-sequence";
// Where we store attachments
var $8497c1e3bf13d11c$var$ATTACH_STORE = "attach-store";
// Where we store many-to-many relations
// between attachment digests and seqs
var $8497c1e3bf13d11c$var$ATTACH_AND_SEQ_STORE = "attach-seq-store";
// Where we store database-wide meta data in a single record
// keyed by id: META_STORE
var $8497c1e3bf13d11c$var$META_STORE = "meta-store";
// Where we store local documents
var $8497c1e3bf13d11c$var$LOCAL_STORE = "local-store";
// Where we detect blob support
var $8497c1e3bf13d11c$var$DETECT_BLOB_SUPPORT_STORE = "detect-blob-support";
function $8497c1e3bf13d11c$var$safeJsonParse(str) {
    // This try/catch guards against stack overflow errors.
    // JSON.parse() is faster than vuvuzela.parse() but vuvuzela
    // cannot overflow.
    try {
        return JSON.parse(str);
    } catch (e) {
        /* istanbul ignore next */ return (0, (/*@__PURE__*/$parcel$interopDefault($6kHnY))).parse(str);
    }
}
function $8497c1e3bf13d11c$var$safeJsonStringify(json) {
    try {
        return JSON.stringify(json);
    } catch (e) {
        /* istanbul ignore next */ return (0, (/*@__PURE__*/$parcel$interopDefault($6kHnY))).stringify(json);
    }
}
function $8497c1e3bf13d11c$var$idbError(callback) {
    return function(evt) {
        var message = "unknown_error";
        if (evt.target && evt.target.error) message = evt.target.error.name || evt.target.error.message;
        callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$IDB_ERROR, message, evt.type));
    };
}
// Unfortunately, the metadata has to be stringified
// when it is put into the database, because otherwise
// IndexedDB can throw errors for deeply-nested objects.
// Originally we just used JSON.parse/JSON.stringify; now
// we use this custom vuvuzela library that avoids recursion.
// If we could do it all over again, we'd probably use a
// format for the revision trees other than JSON.
function $8497c1e3bf13d11c$var$encodeMetadata(metadata, winningRev, deleted) {
    return {
        data: $8497c1e3bf13d11c$var$safeJsonStringify(metadata),
        winningRev: winningRev,
        deletedOrLocal: deleted ? "1" : "0",
        seq: metadata.seq,
        id: metadata.id
    };
}
function $8497c1e3bf13d11c$var$decodeMetadata(storedObject) {
    if (!storedObject) return null;
    var metadata = $8497c1e3bf13d11c$var$safeJsonParse(storedObject.data);
    metadata.winningRev = storedObject.winningRev;
    metadata.deleted = storedObject.deletedOrLocal === "1";
    metadata.seq = storedObject.seq;
    return metadata;
}
// read the doc back out from the database. we don't store the
// _id or _rev because we already have _doc_id_rev.
function $8497c1e3bf13d11c$var$decodeDoc(doc) {
    if (!doc) return doc;
    var idx = doc._doc_id_rev.lastIndexOf(":");
    doc._id = doc._doc_id_rev.substring(0, idx - 1);
    doc._rev = doc._doc_id_rev.substring(idx + 1);
    delete doc._doc_id_rev;
    return doc;
}
// Read a blob from the database, encoding as necessary
// and translating from base64 if the IDB doesn't support
// native Blobs
function $8497c1e3bf13d11c$var$readBlobData(body, type, asBlob, callback) {
    if (asBlob) {
        if (!body) callback($8497c1e3bf13d11c$var$createBlob([
            ""
        ], {
            type: type
        }));
        else if (typeof body !== "string") callback(body);
        else callback($8497c1e3bf13d11c$var$b64ToBluffer(body, type));
    } else {
        if (!body) callback("");
        else if (typeof body !== "string") $8497c1e3bf13d11c$var$readAsBinaryString(body, function(binary) {
            callback($8497c1e3bf13d11c$var$thisBtoa(binary));
        });
        else callback(body);
    }
}
function $8497c1e3bf13d11c$var$fetchAttachmentsIfNecessary(doc, opts, txn, cb) {
    var attachments = Object.keys(doc._attachments || {});
    if (!attachments.length) return cb && cb();
    var numDone = 0;
    function checkDone() {
        if (++numDone === attachments.length && cb) cb();
    }
    function fetchAttachment(doc, att) {
        var attObj = doc._attachments[att];
        var digest = attObj.digest;
        var req = txn.objectStore($8497c1e3bf13d11c$var$ATTACH_STORE).get(digest);
        req.onsuccess = function(e) {
            attObj.body = e.target.result.body;
            checkDone();
        };
    }
    attachments.forEach(function(att) {
        if (opts.attachments && opts.include_docs) fetchAttachment(doc, att);
        else {
            doc._attachments[att].stub = true;
            checkDone();
        }
    });
}
// IDB-specific postprocessing necessary because
// we don't know whether we stored a true Blob or
// a base64-encoded string, and if it's a Blob it
// needs to be read outside of the transaction context
function $8497c1e3bf13d11c$var$postProcessAttachments(results, asBlob) {
    return Promise.all(results.map(function(row) {
        if (row.doc && row.doc._attachments) {
            var attNames = Object.keys(row.doc._attachments);
            return Promise.all(attNames.map(function(att) {
                var attObj = row.doc._attachments[att];
                if (!("body" in attObj)) return;
                var body = attObj.body;
                var type = attObj.content_type;
                return new Promise(function(resolve) {
                    $8497c1e3bf13d11c$var$readBlobData(body, type, asBlob, function(data) {
                        row.doc._attachments[att] = $8497c1e3bf13d11c$var$$inject_Object_assign($8497c1e3bf13d11c$var$pick(attObj, [
                            "digest",
                            "content_type"
                        ]), {
                            data: data
                        });
                        resolve();
                    });
                });
            }));
        }
    }));
}
function $8497c1e3bf13d11c$var$compactRevs(revs, docId, txn) {
    var possiblyOrphanedDigests = [];
    var seqStore = txn.objectStore($8497c1e3bf13d11c$var$BY_SEQ_STORE);
    var attStore = txn.objectStore($8497c1e3bf13d11c$var$ATTACH_STORE);
    var attAndSeqStore = txn.objectStore($8497c1e3bf13d11c$var$ATTACH_AND_SEQ_STORE);
    var count = revs.length;
    function checkDone() {
        count--;
        if (!count) deleteOrphanedAttachments();
    }
    function deleteOrphanedAttachments() {
        if (!possiblyOrphanedDigests.length) return;
        possiblyOrphanedDigests.forEach(function(digest) {
            var countReq = attAndSeqStore.index("digestSeq").count(IDBKeyRange.bound(digest + "::", digest + "::\uFFFF", false, false));
            countReq.onsuccess = function(e) {
                var count = e.target.result;
                if (!count) // orphaned
                attStore.delete(digest);
            };
        });
    }
    revs.forEach(function(rev) {
        var index = seqStore.index("_doc_id_rev");
        var key = docId + "::" + rev;
        index.getKey(key).onsuccess = function(e) {
            var seq = e.target.result;
            if (typeof seq !== "number") return checkDone();
            seqStore.delete(seq);
            var cursor = attAndSeqStore.index("seq").openCursor(IDBKeyRange.only(seq));
            cursor.onsuccess = function(event) {
                var cursor = event.target.result;
                if (cursor) {
                    var digest = cursor.value.digestSeq.split("::")[0];
                    possiblyOrphanedDigests.push(digest);
                    attAndSeqStore.delete(cursor.primaryKey);
                    cursor.continue();
                } else checkDone();
            };
        };
    });
}
function $8497c1e3bf13d11c$var$openTransactionSafely(idb, stores, mode) {
    try {
        return {
            txn: idb.transaction(stores, mode)
        };
    } catch (err) {
        return {
            error: err
        };
    }
}
var $8497c1e3bf13d11c$var$changesHandler = new $8497c1e3bf13d11c$var$Changes();
function $8497c1e3bf13d11c$var$idbBulkDocs(dbOpts, req, opts, api, idb, callback) {
    var docInfos = req.docs;
    var txn;
    var docStore;
    var bySeqStore;
    var attachStore;
    var attachAndSeqStore;
    var metaStore;
    var docInfoError;
    var metaDoc;
    for(var i = 0, len = docInfos.length; i < len; i++){
        var doc = docInfos[i];
        if (doc._id && $8497c1e3bf13d11c$var$isLocalId(doc._id)) continue;
        doc = docInfos[i] = $8497c1e3bf13d11c$var$parseDoc(doc, opts.new_edits, dbOpts);
        if (doc.error && !docInfoError) docInfoError = doc;
    }
    if (docInfoError) return callback(docInfoError);
    var allDocsProcessed = false;
    var docCountDelta = 0;
    var results = new Array(docInfos.length);
    var fetchedDocs = new $8497c1e3bf13d11c$var$ExportedMap();
    var preconditionErrored = false;
    var blobType = api._meta.blobSupport ? "blob" : "base64";
    $8497c1e3bf13d11c$var$preprocessAttachments(docInfos, blobType, function(err) {
        if (err) return callback(err);
        startTransaction();
    });
    function startTransaction() {
        var stores = [
            $8497c1e3bf13d11c$var$DOC_STORE,
            $8497c1e3bf13d11c$var$BY_SEQ_STORE,
            $8497c1e3bf13d11c$var$ATTACH_STORE,
            $8497c1e3bf13d11c$var$LOCAL_STORE,
            $8497c1e3bf13d11c$var$ATTACH_AND_SEQ_STORE,
            $8497c1e3bf13d11c$var$META_STORE
        ];
        var txnResult = $8497c1e3bf13d11c$var$openTransactionSafely(idb, stores, "readwrite");
        if (txnResult.error) return callback(txnResult.error);
        txn = txnResult.txn;
        txn.onabort = $8497c1e3bf13d11c$var$idbError(callback);
        txn.ontimeout = $8497c1e3bf13d11c$var$idbError(callback);
        txn.oncomplete = complete;
        docStore = txn.objectStore($8497c1e3bf13d11c$var$DOC_STORE);
        bySeqStore = txn.objectStore($8497c1e3bf13d11c$var$BY_SEQ_STORE);
        attachStore = txn.objectStore($8497c1e3bf13d11c$var$ATTACH_STORE);
        attachAndSeqStore = txn.objectStore($8497c1e3bf13d11c$var$ATTACH_AND_SEQ_STORE);
        metaStore = txn.objectStore($8497c1e3bf13d11c$var$META_STORE);
        metaStore.get($8497c1e3bf13d11c$var$META_STORE).onsuccess = function(e) {
            metaDoc = e.target.result;
            updateDocCountIfReady();
        };
        verifyAttachments(function(err) {
            if (err) {
                preconditionErrored = true;
                return callback(err);
            }
            fetchExistingDocs();
        });
    }
    function onAllDocsProcessed() {
        allDocsProcessed = true;
        updateDocCountIfReady();
    }
    function idbProcessDocs() {
        $8497c1e3bf13d11c$var$processDocs(dbOpts.revs_limit, docInfos, api, fetchedDocs, txn, results, writeDoc, opts, onAllDocsProcessed);
    }
    function updateDocCountIfReady() {
        if (!metaDoc || !allDocsProcessed) return;
        // caching the docCount saves a lot of time in allDocs() and
        // info(), which is why we go to all the trouble of doing this
        metaDoc.docCount += docCountDelta;
        metaStore.put(metaDoc);
    }
    function fetchExistingDocs() {
        if (!docInfos.length) return;
        var numFetched = 0;
        function checkDone() {
            if (++numFetched === docInfos.length) idbProcessDocs();
        }
        function readMetadata(event) {
            var metadata = $8497c1e3bf13d11c$var$decodeMetadata(event.target.result);
            if (metadata) fetchedDocs.set(metadata.id, metadata);
            checkDone();
        }
        for(var i = 0, len = docInfos.length; i < len; i++){
            var docInfo = docInfos[i];
            if (docInfo._id && $8497c1e3bf13d11c$var$isLocalId(docInfo._id)) {
                checkDone(); // skip local docs
                continue;
            }
            var req = docStore.get(docInfo.metadata.id);
            req.onsuccess = readMetadata;
        }
    }
    function complete() {
        if (preconditionErrored) return;
        $8497c1e3bf13d11c$var$changesHandler.notify(api._meta.name);
        callback(null, results);
    }
    function verifyAttachment(digest, callback) {
        var req = attachStore.get(digest);
        req.onsuccess = function(e) {
            if (!e.target.result) {
                var err = $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$MISSING_STUB, "unknown stub attachment with digest " + digest);
                err.status = 412;
                callback(err);
            } else callback();
        };
    }
    function verifyAttachments(finish) {
        var digests = [];
        docInfos.forEach(function(docInfo) {
            if (docInfo.data && docInfo.data._attachments) Object.keys(docInfo.data._attachments).forEach(function(filename) {
                var att = docInfo.data._attachments[filename];
                if (att.stub) digests.push(att.digest);
            });
        });
        if (!digests.length) return finish();
        var numDone = 0;
        var err;
        function checkDone() {
            if (++numDone === digests.length) finish(err);
        }
        digests.forEach(function(digest) {
            verifyAttachment(digest, function(attErr) {
                if (attErr && !err) err = attErr;
                checkDone();
            });
        });
    }
    function writeDoc(docInfo, winningRev$$1, winningRevIsDeleted, newRevIsDeleted, isUpdate, delta, resultsIdx, callback) {
        docInfo.metadata.winningRev = winningRev$$1;
        docInfo.metadata.deleted = winningRevIsDeleted;
        var doc = docInfo.data;
        doc._id = docInfo.metadata.id;
        doc._rev = docInfo.metadata.rev;
        if (newRevIsDeleted) doc._deleted = true;
        var hasAttachments = doc._attachments && Object.keys(doc._attachments).length;
        if (hasAttachments) return writeAttachments(docInfo, winningRev$$1, winningRevIsDeleted, isUpdate, resultsIdx, callback);
        docCountDelta += delta;
        updateDocCountIfReady();
        finishDoc(docInfo, winningRev$$1, winningRevIsDeleted, isUpdate, resultsIdx, callback);
    }
    function finishDoc(docInfo, winningRev$$1, winningRevIsDeleted, isUpdate, resultsIdx, callback) {
        var doc = docInfo.data;
        var metadata = docInfo.metadata;
        doc._doc_id_rev = metadata.id + "::" + metadata.rev;
        delete doc._id;
        delete doc._rev;
        function afterPutDoc(e) {
            var revsToDelete = docInfo.stemmedRevs || [];
            if (isUpdate && api.auto_compaction) revsToDelete = revsToDelete.concat($8497c1e3bf13d11c$var$compactTree(docInfo.metadata));
            if (revsToDelete && revsToDelete.length) $8497c1e3bf13d11c$var$compactRevs(revsToDelete, docInfo.metadata.id, txn);
            metadata.seq = e.target.result;
            // Current _rev is calculated from _rev_tree on read
            // delete metadata.rev;
            var metadataToStore = $8497c1e3bf13d11c$var$encodeMetadata(metadata, winningRev$$1, winningRevIsDeleted);
            var metaDataReq = docStore.put(metadataToStore);
            metaDataReq.onsuccess = afterPutMetadata;
        }
        function afterPutDocError(e) {
            // ConstraintError, need to update, not put (see #1638 for details)
            e.preventDefault(); // avoid transaction abort
            e.stopPropagation(); // avoid transaction onerror
            var index = bySeqStore.index("_doc_id_rev");
            var getKeyReq = index.getKey(doc._doc_id_rev);
            getKeyReq.onsuccess = function(e) {
                var putReq = bySeqStore.put(doc, e.target.result);
                putReq.onsuccess = afterPutDoc;
            };
        }
        function afterPutMetadata() {
            results[resultsIdx] = {
                ok: true,
                id: metadata.id,
                rev: metadata.rev
            };
            fetchedDocs.set(docInfo.metadata.id, docInfo.metadata);
            insertAttachmentMappings(docInfo, metadata.seq, callback);
        }
        var putReq = bySeqStore.put(doc);
        putReq.onsuccess = afterPutDoc;
        putReq.onerror = afterPutDocError;
    }
    function writeAttachments(docInfo, winningRev$$1, winningRevIsDeleted, isUpdate, resultsIdx, callback) {
        var doc = docInfo.data;
        var numDone = 0;
        var attachments = Object.keys(doc._attachments);
        function collectResults() {
            if (numDone === attachments.length) finishDoc(docInfo, winningRev$$1, winningRevIsDeleted, isUpdate, resultsIdx, callback);
        }
        function attachmentSaved() {
            numDone++;
            collectResults();
        }
        attachments.forEach(function(key) {
            var att = docInfo.data._attachments[key];
            if (!att.stub) {
                var data = att.data;
                delete att.data;
                att.revpos = parseInt(winningRev$$1, 10);
                var digest = att.digest;
                saveAttachment(digest, data, attachmentSaved);
            } else {
                numDone++;
                collectResults();
            }
        });
    }
    // map seqs to attachment digests, which
    // we will need later during compaction
    function insertAttachmentMappings(docInfo, seq, callback) {
        var attsAdded = 0;
        var attsToAdd = Object.keys(docInfo.data._attachments || {});
        if (!attsToAdd.length) return callback();
        function checkDone() {
            if (++attsAdded === attsToAdd.length) callback();
        }
        function add(att) {
            var digest = docInfo.data._attachments[att].digest;
            var req = attachAndSeqStore.put({
                seq: seq,
                digestSeq: digest + "::" + seq
            });
            req.onsuccess = checkDone;
            req.onerror = function(e) {
                // this callback is for a constaint error, which we ignore
                // because this docid/rev has already been associated with
                // the digest (e.g. when new_edits == false)
                e.preventDefault(); // avoid transaction abort
                e.stopPropagation(); // avoid transaction onerror
                checkDone();
            };
        }
        for(var i = 0; i < attsToAdd.length; i++)add(attsToAdd[i]); // do in parallel
    }
    function saveAttachment(digest, data, callback) {
        var getKeyReq = attachStore.count(digest);
        getKeyReq.onsuccess = function(e) {
            var count = e.target.result;
            if (count) return callback(); // already exists
            var newAtt = {
                digest: digest,
                body: data
            };
            var putReq = attachStore.put(newAtt);
            putReq.onsuccess = callback;
        };
    }
}
// Abstraction over IDBCursor and getAll()/getAllKeys() that allows us to batch our operations
// while falling back to a normal IDBCursor operation on browsers that don't support getAll() or
// getAllKeys(). This allows for a much faster implementation than just straight-up cursors, because
// we're not processing each document one-at-a-time.
function $8497c1e3bf13d11c$var$runBatchedCursor(objectStore, keyRange, descending, batchSize, onBatch) {
    if (batchSize === -1) batchSize = 1000;
    // Bail out of getAll()/getAllKeys() in the following cases:
    // 1) either method is unsupported - we need both
    // 2) batchSize is 1 (might as well use IDBCursor)
    // 3) descending – no real way to do this via getAll()/getAllKeys()
    var useGetAll = typeof objectStore.getAll === "function" && typeof objectStore.getAllKeys === "function" && batchSize > 1 && !descending;
    var keysBatch;
    var valuesBatch;
    var pseudoCursor;
    function onGetAll(e) {
        valuesBatch = e.target.result;
        if (keysBatch) onBatch(keysBatch, valuesBatch, pseudoCursor);
    }
    function onGetAllKeys(e) {
        keysBatch = e.target.result;
        if (valuesBatch) onBatch(keysBatch, valuesBatch, pseudoCursor);
    }
    function continuePseudoCursor() {
        if (!keysBatch.length) return onBatch();
        // fetch next batch, exclusive start
        var lastKey = keysBatch[keysBatch.length - 1];
        var newKeyRange;
        if (keyRange && keyRange.upper) try {
            newKeyRange = IDBKeyRange.bound(lastKey, keyRange.upper, true, keyRange.upperOpen);
        } catch (e) {
            if (e.name === "DataError" && e.code === 0) return onBatch(); // we're done, startkey and endkey are equal
        }
        else newKeyRange = IDBKeyRange.lowerBound(lastKey, true);
        keyRange = newKeyRange;
        keysBatch = null;
        valuesBatch = null;
        objectStore.getAll(keyRange, batchSize).onsuccess = onGetAll;
        objectStore.getAllKeys(keyRange, batchSize).onsuccess = onGetAllKeys;
    }
    function onCursor(e) {
        var cursor = e.target.result;
        if (!cursor) return onBatch();
        // regular IDBCursor acts like a batch where batch size is always 1
        onBatch([
            cursor.key
        ], [
            cursor.value
        ], cursor);
    }
    if (useGetAll) {
        pseudoCursor = {
            "continue": continuePseudoCursor
        };
        objectStore.getAll(keyRange, batchSize).onsuccess = onGetAll;
        objectStore.getAllKeys(keyRange, batchSize).onsuccess = onGetAllKeys;
    } else if (descending) objectStore.openCursor(keyRange, "prev").onsuccess = onCursor;
    else objectStore.openCursor(keyRange).onsuccess = onCursor;
}
// simple shim for objectStore.getAll(), falling back to IDBCursor
function $8497c1e3bf13d11c$var$getAll(objectStore, keyRange, onSuccess) {
    if (typeof objectStore.getAll === "function") {
        // use native getAll
        objectStore.getAll(keyRange).onsuccess = onSuccess;
        return;
    }
    // fall back to cursors
    var values = [];
    function onCursor(e) {
        var cursor = e.target.result;
        if (cursor) {
            values.push(cursor.value);
            cursor.continue();
        } else onSuccess({
            target: {
                result: values
            }
        });
    }
    objectStore.openCursor(keyRange).onsuccess = onCursor;
}
function $8497c1e3bf13d11c$var$allDocsKeys(keys, docStore, onBatch) {
    // It's not guaranted to be returned in right order  
    var valuesBatch = new Array(keys.length);
    var count = 0;
    keys.forEach(function(key, index) {
        docStore.get(key).onsuccess = function(event) {
            if (event.target.result) valuesBatch[index] = event.target.result;
            else valuesBatch[index] = {
                key: key,
                error: "not_found"
            };
            count++;
            if (count === keys.length) onBatch(keys, valuesBatch, {});
        };
    });
}
function $8497c1e3bf13d11c$var$createKeyRange(start, end, inclusiveEnd, key, descending) {
    try {
        if (start && end) {
            if (descending) return IDBKeyRange.bound(end, start, !inclusiveEnd, false);
            else return IDBKeyRange.bound(start, end, false, !inclusiveEnd);
        } else if (start) {
            if (descending) return IDBKeyRange.upperBound(start);
            else return IDBKeyRange.lowerBound(start);
        } else if (end) {
            if (descending) return IDBKeyRange.lowerBound(end, !inclusiveEnd);
            else return IDBKeyRange.upperBound(end, !inclusiveEnd);
        } else if (key) return IDBKeyRange.only(key);
    } catch (e) {
        return {
            error: e
        };
    }
    return null;
}
function $8497c1e3bf13d11c$var$idbAllDocs(opts, idb, callback) {
    var start = "startkey" in opts ? opts.startkey : false;
    var end = "endkey" in opts ? opts.endkey : false;
    var key = "key" in opts ? opts.key : false;
    var keys = "keys" in opts ? opts.keys : false;
    var skip = opts.skip || 0;
    var limit = typeof opts.limit === "number" ? opts.limit : -1;
    var inclusiveEnd = opts.inclusive_end !== false;
    var keyRange;
    var keyRangeError;
    if (!keys) {
        keyRange = $8497c1e3bf13d11c$var$createKeyRange(start, end, inclusiveEnd, key, opts.descending);
        keyRangeError = keyRange && keyRange.error;
        if (keyRangeError && !(keyRangeError.name === "DataError" && keyRangeError.code === 0)) // DataError with error code 0 indicates start is less than end, so
        // can just do an empty query. Else need to throw
        return callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$IDB_ERROR, keyRangeError.name, keyRangeError.message));
    }
    var stores = [
        $8497c1e3bf13d11c$var$DOC_STORE,
        $8497c1e3bf13d11c$var$BY_SEQ_STORE,
        $8497c1e3bf13d11c$var$META_STORE
    ];
    if (opts.attachments) stores.push($8497c1e3bf13d11c$var$ATTACH_STORE);
    var txnResult = $8497c1e3bf13d11c$var$openTransactionSafely(idb, stores, "readonly");
    if (txnResult.error) return callback(txnResult.error);
    var txn = txnResult.txn;
    txn.oncomplete = onTxnComplete;
    txn.onabort = $8497c1e3bf13d11c$var$idbError(callback);
    var docStore = txn.objectStore($8497c1e3bf13d11c$var$DOC_STORE);
    var seqStore = txn.objectStore($8497c1e3bf13d11c$var$BY_SEQ_STORE);
    var metaStore = txn.objectStore($8497c1e3bf13d11c$var$META_STORE);
    var docIdRevIndex = seqStore.index("_doc_id_rev");
    var results = [];
    var docCount;
    var updateSeq;
    metaStore.get($8497c1e3bf13d11c$var$META_STORE).onsuccess = function(e) {
        docCount = e.target.result.docCount;
    };
    /* istanbul ignore if */ if (opts.update_seq) getMaxUpdateSeq(seqStore, function(e) {
        if (e.target.result && e.target.result.length > 0) updateSeq = e.target.result[0];
    });
    function getMaxUpdateSeq(objectStore, onSuccess) {
        function onCursor(e) {
            var cursor = e.target.result;
            var maxKey = undefined;
            if (cursor && cursor.key) maxKey = cursor.key;
            return onSuccess({
                target: {
                    result: [
                        maxKey
                    ]
                }
            });
        }
        objectStore.openCursor(null, "prev").onsuccess = onCursor;
    }
    // if the user specifies include_docs=true, then we don't
    // want to block the main cursor while we're fetching the doc
    function fetchDocAsynchronously(metadata, row, winningRev$$1) {
        var key = metadata.id + "::" + winningRev$$1;
        docIdRevIndex.get(key).onsuccess = function onGetDoc(e) {
            row.doc = $8497c1e3bf13d11c$var$decodeDoc(e.target.result) || {};
            if (opts.conflicts) {
                var conflicts = $8497c1e3bf13d11c$var$collectConflicts(metadata);
                if (conflicts.length) row.doc._conflicts = conflicts;
            }
            $8497c1e3bf13d11c$var$fetchAttachmentsIfNecessary(row.doc, opts, txn);
        };
    }
    function allDocsInner(winningRev$$1, metadata) {
        var row = {
            id: metadata.id,
            key: metadata.id,
            value: {
                rev: winningRev$$1
            }
        };
        var deleted = metadata.deleted;
        if (deleted) {
            if (keys) {
                results.push(row);
                // deleted docs are okay with "keys" requests
                row.value.deleted = true;
                row.doc = null;
            }
        } else if (skip-- <= 0) {
            results.push(row);
            if (opts.include_docs) fetchDocAsynchronously(metadata, row, winningRev$$1);
        }
    }
    function processBatch(batchValues) {
        for(var i = 0, len = batchValues.length; i < len; i++){
            if (results.length === limit) break;
            var batchValue = batchValues[i];
            if (batchValue.error && keys) {
                // key was not found with "keys" requests
                results.push(batchValue);
                continue;
            }
            var metadata = $8497c1e3bf13d11c$var$decodeMetadata(batchValue);
            var winningRev$$1 = metadata.winningRev;
            allDocsInner(winningRev$$1, metadata);
        }
    }
    function onBatch(batchKeys, batchValues, cursor) {
        if (!cursor) return;
        processBatch(batchValues);
        if (results.length < limit) cursor.continue();
    }
    function onGetAll(e) {
        var values = e.target.result;
        if (opts.descending) values = values.reverse();
        processBatch(values);
    }
    function onResultsReady() {
        var returnVal = {
            total_rows: docCount,
            offset: opts.skip,
            rows: results
        };
        /* istanbul ignore if */ if (opts.update_seq && updateSeq !== undefined) returnVal.update_seq = updateSeq;
        callback(null, returnVal);
    }
    function onTxnComplete() {
        if (opts.attachments) $8497c1e3bf13d11c$var$postProcessAttachments(results, opts.binary).then(onResultsReady);
        else onResultsReady();
    }
    // don't bother doing any requests if start > end or limit === 0
    if (keyRangeError || limit === 0) return;
    if (keys) return $8497c1e3bf13d11c$var$allDocsKeys(opts.keys, docStore, onBatch);
    if (limit === -1) return $8497c1e3bf13d11c$var$getAll(docStore, keyRange, onGetAll);
    // else do a cursor
    // choose a batch size based on the skip, since we'll need to skip that many
    $8497c1e3bf13d11c$var$runBatchedCursor(docStore, keyRange, opts.descending, limit + skip, onBatch);
}
//
// Blobs are not supported in all versions of IndexedDB, notably
// Chrome <37 and Android <5. In those versions, storing a blob will throw.
//
// Various other blob bugs exist in Chrome v37-42 (inclusive).
// Detecting them is expensive and confusing to users, and Chrome 37-42
// is at very low usage worldwide, so we do a hacky userAgent check instead.
//
// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
//
function $8497c1e3bf13d11c$var$checkBlobSupport(txn) {
    return new Promise(function(resolve) {
        var blob$$1 = $8497c1e3bf13d11c$var$createBlob([
            ""
        ]);
        var req = txn.objectStore($8497c1e3bf13d11c$var$DETECT_BLOB_SUPPORT_STORE).put(blob$$1, "key");
        req.onsuccess = function() {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            // MS Edge pretends to be Chrome 42:
            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
        };
        req.onerror = txn.onabort = function(e) {
            // If the transaction aborts now its due to not being able to
            // write to the database, likely due to the disk being full
            e.preventDefault();
            e.stopPropagation();
            resolve(false);
        };
    }).catch(function() {
        return false; // error, so assume unsupported
    });
}
function $8497c1e3bf13d11c$var$countDocs(txn, cb) {
    var index = txn.objectStore($8497c1e3bf13d11c$var$DOC_STORE).index("deletedOrLocal");
    index.count(IDBKeyRange.only("0")).onsuccess = function(e) {
        cb(e.target.result);
    };
}
// This task queue ensures that IDB open calls are done in their own tick
var $8497c1e3bf13d11c$var$running = false;
var $8497c1e3bf13d11c$var$queue = [];
function $8497c1e3bf13d11c$var$tryCode(fun, err, res, PouchDB) {
    try {
        fun(err, res);
    } catch (err) {
        // Shouldn't happen, but in some odd cases
        // IndexedDB implementations might throw a sync
        // error, in which case this will at least log it.
        PouchDB.emit("error", err);
    }
}
function $8497c1e3bf13d11c$var$applyNext() {
    if ($8497c1e3bf13d11c$var$running || !$8497c1e3bf13d11c$var$queue.length) return;
    $8497c1e3bf13d11c$var$running = true;
    $8497c1e3bf13d11c$var$queue.shift()();
}
function $8497c1e3bf13d11c$var$enqueueTask(action, callback, PouchDB) {
    $8497c1e3bf13d11c$var$queue.push(function runAction() {
        action(function runCallback(err, res) {
            $8497c1e3bf13d11c$var$tryCode(callback, err, res, PouchDB);
            $8497c1e3bf13d11c$var$running = false;
            (0, (/*@__PURE__*/$parcel$interopDefault($lRg87)))(function runNext() {
                $8497c1e3bf13d11c$var$applyNext(PouchDB);
            });
        });
    });
    $8497c1e3bf13d11c$var$applyNext();
}
function $8497c1e3bf13d11c$var$changes(opts, api, dbName, idb) {
    opts = $8497c1e3bf13d11c$var$clone(opts);
    if (opts.continuous) {
        var id = dbName + ":" + $8497c1e3bf13d11c$var$uuid();
        $8497c1e3bf13d11c$var$changesHandler.addListener(dbName, id, api, opts);
        $8497c1e3bf13d11c$var$changesHandler.notify(dbName);
        return {
            cancel: function() {
                $8497c1e3bf13d11c$var$changesHandler.removeListener(dbName, id);
            }
        };
    }
    var docIds = opts.doc_ids && new $8497c1e3bf13d11c$var$ExportedSet(opts.doc_ids);
    opts.since = opts.since || 0;
    var lastSeq = opts.since;
    var limit = "limit" in opts ? opts.limit : -1;
    if (limit === 0) limit = 1; // per CouchDB _changes spec
    var results = [];
    var numResults = 0;
    var filter = $8497c1e3bf13d11c$var$filterChange(opts);
    var docIdsToMetadata = new $8497c1e3bf13d11c$var$ExportedMap();
    var txn;
    var bySeqStore;
    var docStore;
    var docIdRevIndex;
    function onBatch(batchKeys, batchValues, cursor) {
        if (!cursor || !batchKeys.length) return;
        var winningDocs = new Array(batchKeys.length);
        var metadatas = new Array(batchKeys.length);
        function processMetadataAndWinningDoc(metadata, winningDoc) {
            var change = opts.processChange(winningDoc, metadata, opts);
            lastSeq = change.seq = metadata.seq;
            var filtered = filter(change);
            if (typeof filtered === "object") return Promise.reject(filtered);
            if (!filtered) return Promise.resolve();
            numResults++;
            if (opts.return_docs) results.push(change);
            // process the attachment immediately
            // for the benefit of live listeners
            if (opts.attachments && opts.include_docs) return new Promise(function(resolve) {
                $8497c1e3bf13d11c$var$fetchAttachmentsIfNecessary(winningDoc, opts, txn, function() {
                    $8497c1e3bf13d11c$var$postProcessAttachments([
                        change
                    ], opts.binary).then(function() {
                        resolve(change);
                    });
                });
            });
            else return Promise.resolve(change);
        }
        function onBatchDone() {
            var promises = [];
            for(var i = 0, len = winningDocs.length; i < len; i++){
                if (numResults === limit) break;
                var winningDoc = winningDocs[i];
                if (!winningDoc) continue;
                var metadata = metadatas[i];
                promises.push(processMetadataAndWinningDoc(metadata, winningDoc));
            }
            Promise.all(promises).then(function(changes) {
                for(var i = 0, len = changes.length; i < len; i++)if (changes[i]) opts.onChange(changes[i]);
            }).catch(opts.complete);
            if (numResults !== limit) cursor.continue();
        }
        // Fetch all metadatas/winningdocs from this batch in parallel, then process
        // them all only once all data has been collected. This is done in parallel
        // because it's faster than doing it one-at-a-time.
        var numDone = 0;
        batchValues.forEach(function(value, i) {
            var doc = $8497c1e3bf13d11c$var$decodeDoc(value);
            var seq = batchKeys[i];
            fetchWinningDocAndMetadata(doc, seq, function(metadata, winningDoc) {
                metadatas[i] = metadata;
                winningDocs[i] = winningDoc;
                if (++numDone === batchKeys.length) onBatchDone();
            });
        });
    }
    function onGetMetadata(doc, seq, metadata, cb) {
        if (metadata.seq !== seq) // some other seq is later
        return cb();
        if (metadata.winningRev === doc._rev) // this is the winning doc
        return cb(metadata, doc);
        // fetch winning doc in separate request
        var docIdRev = doc._id + "::" + metadata.winningRev;
        var req = docIdRevIndex.get(docIdRev);
        req.onsuccess = function(e) {
            cb(metadata, $8497c1e3bf13d11c$var$decodeDoc(e.target.result));
        };
    }
    function fetchWinningDocAndMetadata(doc, seq, cb) {
        if (docIds && !docIds.has(doc._id)) return cb();
        var metadata = docIdsToMetadata.get(doc._id);
        if (metadata) return onGetMetadata(doc, seq, metadata, cb);
        // metadata not cached, have to go fetch it
        docStore.get(doc._id).onsuccess = function(e) {
            metadata = $8497c1e3bf13d11c$var$decodeMetadata(e.target.result);
            docIdsToMetadata.set(doc._id, metadata);
            onGetMetadata(doc, seq, metadata, cb);
        };
    }
    function finish() {
        opts.complete(null, {
            results: results,
            last_seq: lastSeq
        });
    }
    function onTxnComplete() {
        if (!opts.continuous && opts.attachments) // cannot guarantee that postProcessing was already done,
        // so do it again
        $8497c1e3bf13d11c$var$postProcessAttachments(results).then(finish);
        else finish();
    }
    var objectStores = [
        $8497c1e3bf13d11c$var$DOC_STORE,
        $8497c1e3bf13d11c$var$BY_SEQ_STORE
    ];
    if (opts.attachments) objectStores.push($8497c1e3bf13d11c$var$ATTACH_STORE);
    var txnResult = $8497c1e3bf13d11c$var$openTransactionSafely(idb, objectStores, "readonly");
    if (txnResult.error) return opts.complete(txnResult.error);
    txn = txnResult.txn;
    txn.onabort = $8497c1e3bf13d11c$var$idbError(opts.complete);
    txn.oncomplete = onTxnComplete;
    bySeqStore = txn.objectStore($8497c1e3bf13d11c$var$BY_SEQ_STORE);
    docStore = txn.objectStore($8497c1e3bf13d11c$var$DOC_STORE);
    docIdRevIndex = bySeqStore.index("_doc_id_rev");
    var keyRange = opts.since && !opts.descending ? IDBKeyRange.lowerBound(opts.since, true) : null;
    $8497c1e3bf13d11c$var$runBatchedCursor(bySeqStore, keyRange, opts.descending, limit, onBatch);
}
var $8497c1e3bf13d11c$var$cachedDBs = new $8497c1e3bf13d11c$var$ExportedMap();
var $8497c1e3bf13d11c$var$blobSupportPromise;
var $8497c1e3bf13d11c$var$openReqList = new $8497c1e3bf13d11c$var$ExportedMap();
function $8497c1e3bf13d11c$var$IdbPouch(opts, callback) {
    var api = this;
    $8497c1e3bf13d11c$var$enqueueTask(function(thisCallback) {
        $8497c1e3bf13d11c$var$init(api, opts, thisCallback);
    }, callback, api.constructor);
}
function $8497c1e3bf13d11c$var$init(api, opts, callback) {
    var dbName = opts.name;
    var idb = null;
    var idbGlobalFailureError = null;
    api._meta = null;
    function enrichCallbackError(callback) {
        return function(error, result) {
            if (error && error instanceof Error && !error.reason) {
                if (idbGlobalFailureError) error.reason = idbGlobalFailureError;
            }
            callback(error, result);
        };
    }
    // called when creating a fresh new database
    function createSchema(db) {
        var docStore = db.createObjectStore($8497c1e3bf13d11c$var$DOC_STORE, {
            keyPath: "id"
        });
        db.createObjectStore($8497c1e3bf13d11c$var$BY_SEQ_STORE, {
            autoIncrement: true
        }).createIndex("_doc_id_rev", "_doc_id_rev", {
            unique: true
        });
        db.createObjectStore($8497c1e3bf13d11c$var$ATTACH_STORE, {
            keyPath: "digest"
        });
        db.createObjectStore($8497c1e3bf13d11c$var$META_STORE, {
            keyPath: "id",
            autoIncrement: false
        });
        db.createObjectStore($8497c1e3bf13d11c$var$DETECT_BLOB_SUPPORT_STORE);
        // added in v2
        docStore.createIndex("deletedOrLocal", "deletedOrLocal", {
            unique: false
        });
        // added in v3
        db.createObjectStore($8497c1e3bf13d11c$var$LOCAL_STORE, {
            keyPath: "_id"
        });
        // added in v4
        var attAndSeqStore = db.createObjectStore($8497c1e3bf13d11c$var$ATTACH_AND_SEQ_STORE, {
            autoIncrement: true
        });
        attAndSeqStore.createIndex("seq", "seq");
        attAndSeqStore.createIndex("digestSeq", "digestSeq", {
            unique: true
        });
    }
    // migration to version 2
    // unfortunately "deletedOrLocal" is a misnomer now that we no longer
    // store local docs in the main doc-store, but whaddyagonnado
    function addDeletedOrLocalIndex(txn, callback) {
        var docStore = txn.objectStore($8497c1e3bf13d11c$var$DOC_STORE);
        docStore.createIndex("deletedOrLocal", "deletedOrLocal", {
            unique: false
        });
        docStore.openCursor().onsuccess = function(event) {
            var cursor = event.target.result;
            if (cursor) {
                var metadata = cursor.value;
                var deleted = $8497c1e3bf13d11c$var$isDeleted(metadata);
                metadata.deletedOrLocal = deleted ? "1" : "0";
                docStore.put(metadata);
                cursor.continue();
            } else callback();
        };
    }
    // migration to version 3 (part 1)
    function createLocalStoreSchema(db) {
        db.createObjectStore($8497c1e3bf13d11c$var$LOCAL_STORE, {
            keyPath: "_id"
        }).createIndex("_doc_id_rev", "_doc_id_rev", {
            unique: true
        });
    }
    // migration to version 3 (part 2)
    function migrateLocalStore(txn, cb) {
        var localStore = txn.objectStore($8497c1e3bf13d11c$var$LOCAL_STORE);
        var docStore = txn.objectStore($8497c1e3bf13d11c$var$DOC_STORE);
        var seqStore = txn.objectStore($8497c1e3bf13d11c$var$BY_SEQ_STORE);
        var cursor = docStore.openCursor();
        cursor.onsuccess = function(event) {
            var cursor = event.target.result;
            if (cursor) {
                var metadata = cursor.value;
                var docId = metadata.id;
                var local = $8497c1e3bf13d11c$var$isLocalId(docId);
                var rev = $8497c1e3bf13d11c$var$winningRev(metadata);
                if (local) {
                    var docIdRev = docId + "::" + rev;
                    // remove all seq entries
                    // associated with this docId
                    var start = docId + "::";
                    var end = docId + "::~";
                    var index = seqStore.index("_doc_id_rev");
                    var range = IDBKeyRange.bound(start, end, false, false);
                    var seqCursor = index.openCursor(range);
                    seqCursor.onsuccess = function(e) {
                        seqCursor = e.target.result;
                        if (!seqCursor) {
                            // done
                            docStore.delete(cursor.primaryKey);
                            cursor.continue();
                        } else {
                            var data = seqCursor.value;
                            if (data._doc_id_rev === docIdRev) localStore.put(data);
                            seqStore.delete(seqCursor.primaryKey);
                            seqCursor.continue();
                        }
                    };
                } else cursor.continue();
            } else if (cb) cb();
        };
    }
    // migration to version 4 (part 1)
    function addAttachAndSeqStore(db) {
        var attAndSeqStore = db.createObjectStore($8497c1e3bf13d11c$var$ATTACH_AND_SEQ_STORE, {
            autoIncrement: true
        });
        attAndSeqStore.createIndex("seq", "seq");
        attAndSeqStore.createIndex("digestSeq", "digestSeq", {
            unique: true
        });
    }
    // migration to version 4 (part 2)
    function migrateAttsAndSeqs(txn, callback) {
        var seqStore = txn.objectStore($8497c1e3bf13d11c$var$BY_SEQ_STORE);
        var attStore = txn.objectStore($8497c1e3bf13d11c$var$ATTACH_STORE);
        var attAndSeqStore = txn.objectStore($8497c1e3bf13d11c$var$ATTACH_AND_SEQ_STORE);
        // need to actually populate the table. this is the expensive part,
        // so as an optimization, check first that this database even
        // contains attachments
        var req = attStore.count();
        req.onsuccess = function(e) {
            var count = e.target.result;
            if (!count) return callback(); // done
            seqStore.openCursor().onsuccess = function(e) {
                var cursor = e.target.result;
                if (!cursor) return callback(); // done
                var doc = cursor.value;
                var seq = cursor.primaryKey;
                var atts = Object.keys(doc._attachments || {});
                var digestMap = {};
                for(var j = 0; j < atts.length; j++){
                    var att = doc._attachments[atts[j]];
                    digestMap[att.digest] = true; // uniq digests, just in case
                }
                var digests = Object.keys(digestMap);
                for(j = 0; j < digests.length; j++){
                    var digest = digests[j];
                    attAndSeqStore.put({
                        seq: seq,
                        digestSeq: digest + "::" + seq
                    });
                }
                cursor.continue();
            };
        };
    }
    // migration to version 5
    // Instead of relying on on-the-fly migration of metadata,
    // this brings the doc-store to its modern form:
    // - metadata.winningrev
    // - metadata.seq
    // - stringify the metadata when storing it
    function migrateMetadata(txn) {
        function decodeMetadataCompat(storedObject) {
            if (!storedObject.data) {
                // old format, when we didn't store it stringified
                storedObject.deleted = storedObject.deletedOrLocal === "1";
                return storedObject;
            }
            return $8497c1e3bf13d11c$var$decodeMetadata(storedObject);
        }
        // ensure that every metadata has a winningRev and seq,
        // which was previously created on-the-fly but better to migrate
        var bySeqStore = txn.objectStore($8497c1e3bf13d11c$var$BY_SEQ_STORE);
        var docStore = txn.objectStore($8497c1e3bf13d11c$var$DOC_STORE);
        var cursor = docStore.openCursor();
        cursor.onsuccess = function(e) {
            var cursor = e.target.result;
            if (!cursor) return; // done
            var metadata = decodeMetadataCompat(cursor.value);
            metadata.winningRev = metadata.winningRev || $8497c1e3bf13d11c$var$winningRev(metadata);
            function fetchMetadataSeq() {
                // metadata.seq was added post-3.2.0, so if it's missing,
                // we need to fetch it manually
                var start = metadata.id + "::";
                var end = metadata.id + "::\uFFFF";
                var req = bySeqStore.index("_doc_id_rev").openCursor(IDBKeyRange.bound(start, end));
                var metadataSeq = 0;
                req.onsuccess = function(e) {
                    var cursor = e.target.result;
                    if (!cursor) {
                        metadata.seq = metadataSeq;
                        return onGetMetadataSeq();
                    }
                    var seq = cursor.primaryKey;
                    if (seq > metadataSeq) metadataSeq = seq;
                    cursor.continue();
                };
            }
            function onGetMetadataSeq() {
                var metadataToStore = $8497c1e3bf13d11c$var$encodeMetadata(metadata, metadata.winningRev, metadata.deleted);
                var req = docStore.put(metadataToStore);
                req.onsuccess = function() {
                    cursor.continue();
                };
            }
            if (metadata.seq) return onGetMetadataSeq();
            fetchMetadataSeq();
        };
    }
    api._remote = false;
    api.type = function() {
        return "idb";
    };
    api._id = $8497c1e3bf13d11c$var$toPromise(function(callback) {
        callback(null, api._meta.instanceId);
    });
    api._bulkDocs = function idb_bulkDocs(req, reqOpts, callback) {
        $8497c1e3bf13d11c$var$idbBulkDocs(opts, req, reqOpts, api, idb, enrichCallbackError(callback));
    };
    // First we look up the metadata in the ids database, then we fetch the
    // current revision(s) from the by sequence store
    api._get = function idb_get(id, opts, callback) {
        var doc;
        var metadata;
        var err;
        var txn = opts.ctx;
        if (!txn) {
            var txnResult = $8497c1e3bf13d11c$var$openTransactionSafely(idb, [
                $8497c1e3bf13d11c$var$DOC_STORE,
                $8497c1e3bf13d11c$var$BY_SEQ_STORE,
                $8497c1e3bf13d11c$var$ATTACH_STORE
            ], "readonly");
            if (txnResult.error) return callback(txnResult.error);
            txn = txnResult.txn;
        }
        function finish() {
            callback(err, {
                doc: doc,
                metadata: metadata,
                ctx: txn
            });
        }
        txn.objectStore($8497c1e3bf13d11c$var$DOC_STORE).get(id).onsuccess = function(e) {
            metadata = $8497c1e3bf13d11c$var$decodeMetadata(e.target.result);
            // we can determine the result here if:
            // 1. there is no such document
            // 2. the document is deleted and we don't ask about specific rev
            // When we ask with opts.rev we expect the answer to be either
            // doc (possibly with _deleted=true) or missing error
            if (!metadata) {
                err = $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$MISSING_DOC, "missing");
                return finish();
            }
            var rev;
            if (!opts.rev) {
                rev = metadata.winningRev;
                var deleted = $8497c1e3bf13d11c$var$isDeleted(metadata);
                if (deleted) {
                    err = $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$MISSING_DOC, "deleted");
                    return finish();
                }
            } else rev = opts.latest ? $8497c1e3bf13d11c$var$latest(opts.rev, metadata) : opts.rev;
            var objectStore = txn.objectStore($8497c1e3bf13d11c$var$BY_SEQ_STORE);
            var key = metadata.id + "::" + rev;
            objectStore.index("_doc_id_rev").get(key).onsuccess = function(e) {
                doc = e.target.result;
                if (doc) doc = $8497c1e3bf13d11c$var$decodeDoc(doc);
                if (!doc) {
                    err = $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$MISSING_DOC, "missing");
                    return finish();
                }
                finish();
            };
        };
    };
    api._getAttachment = function(docId, attachId, attachment, opts, callback) {
        var txn;
        if (opts.ctx) txn = opts.ctx;
        else {
            var txnResult = $8497c1e3bf13d11c$var$openTransactionSafely(idb, [
                $8497c1e3bf13d11c$var$DOC_STORE,
                $8497c1e3bf13d11c$var$BY_SEQ_STORE,
                $8497c1e3bf13d11c$var$ATTACH_STORE
            ], "readonly");
            if (txnResult.error) return callback(txnResult.error);
            txn = txnResult.txn;
        }
        var digest = attachment.digest;
        var type = attachment.content_type;
        txn.objectStore($8497c1e3bf13d11c$var$ATTACH_STORE).get(digest).onsuccess = function(e) {
            var body = e.target.result.body;
            $8497c1e3bf13d11c$var$readBlobData(body, type, opts.binary, function(blobData) {
                callback(null, blobData);
            });
        };
    };
    api._info = function idb_info(callback) {
        var updateSeq;
        var docCount;
        var txnResult = $8497c1e3bf13d11c$var$openTransactionSafely(idb, [
            $8497c1e3bf13d11c$var$META_STORE,
            $8497c1e3bf13d11c$var$BY_SEQ_STORE
        ], "readonly");
        if (txnResult.error) return callback(txnResult.error);
        var txn = txnResult.txn;
        txn.objectStore($8497c1e3bf13d11c$var$META_STORE).get($8497c1e3bf13d11c$var$META_STORE).onsuccess = function(e) {
            docCount = e.target.result.docCount;
        };
        txn.objectStore($8497c1e3bf13d11c$var$BY_SEQ_STORE).openCursor(null, "prev").onsuccess = function(e) {
            var cursor = e.target.result;
            updateSeq = cursor ? cursor.key : 0;
        };
        txn.oncomplete = function() {
            callback(null, {
                doc_count: docCount,
                update_seq: updateSeq,
                // for debugging
                idb_attachment_format: api._meta.blobSupport ? "binary" : "base64"
            });
        };
    };
    api._allDocs = function idb_allDocs(opts, callback) {
        $8497c1e3bf13d11c$var$idbAllDocs(opts, idb, enrichCallbackError(callback));
    };
    api._changes = function idbChanges(opts) {
        return $8497c1e3bf13d11c$var$changes(opts, api, dbName, idb);
    };
    api._close = function(callback) {
        // https://developer.mozilla.org/en-US/docs/IndexedDB/IDBDatabase#close
        // "Returns immediately and closes the connection in a separate thread..."
        idb.close();
        $8497c1e3bf13d11c$var$cachedDBs.delete(dbName);
        callback();
    };
    api._getRevisionTree = function(docId, callback) {
        var txnResult = $8497c1e3bf13d11c$var$openTransactionSafely(idb, [
            $8497c1e3bf13d11c$var$DOC_STORE
        ], "readonly");
        if (txnResult.error) return callback(txnResult.error);
        var txn = txnResult.txn;
        var req = txn.objectStore($8497c1e3bf13d11c$var$DOC_STORE).get(docId);
        req.onsuccess = function(event) {
            var doc = $8497c1e3bf13d11c$var$decodeMetadata(event.target.result);
            if (!doc) callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$MISSING_DOC));
            else callback(null, doc.rev_tree);
        };
    };
    // This function removes revisions of document docId
    // which are listed in revs and sets this document
    // revision to to rev_tree
    api._doCompaction = function(docId, revs, callback) {
        var stores = [
            $8497c1e3bf13d11c$var$DOC_STORE,
            $8497c1e3bf13d11c$var$BY_SEQ_STORE,
            $8497c1e3bf13d11c$var$ATTACH_STORE,
            $8497c1e3bf13d11c$var$ATTACH_AND_SEQ_STORE
        ];
        var txnResult = $8497c1e3bf13d11c$var$openTransactionSafely(idb, stores, "readwrite");
        if (txnResult.error) return callback(txnResult.error);
        var txn = txnResult.txn;
        var docStore = txn.objectStore($8497c1e3bf13d11c$var$DOC_STORE);
        docStore.get(docId).onsuccess = function(event) {
            var metadata = $8497c1e3bf13d11c$var$decodeMetadata(event.target.result);
            $8497c1e3bf13d11c$var$traverseRevTree(metadata.rev_tree, function(isLeaf, pos, revHash, ctx, opts) {
                var rev = pos + "-" + revHash;
                if (revs.indexOf(rev) !== -1) opts.status = "missing";
            });
            $8497c1e3bf13d11c$var$compactRevs(revs, docId, txn);
            var winningRev$$1 = metadata.winningRev;
            var deleted = metadata.deleted;
            txn.objectStore($8497c1e3bf13d11c$var$DOC_STORE).put($8497c1e3bf13d11c$var$encodeMetadata(metadata, winningRev$$1, deleted));
        };
        txn.onabort = $8497c1e3bf13d11c$var$idbError(callback);
        txn.oncomplete = function() {
            callback();
        };
    };
    api._getLocal = function(id, callback) {
        var txnResult = $8497c1e3bf13d11c$var$openTransactionSafely(idb, [
            $8497c1e3bf13d11c$var$LOCAL_STORE
        ], "readonly");
        if (txnResult.error) return callback(txnResult.error);
        var tx = txnResult.txn;
        var req = tx.objectStore($8497c1e3bf13d11c$var$LOCAL_STORE).get(id);
        req.onerror = $8497c1e3bf13d11c$var$idbError(callback);
        req.onsuccess = function(e) {
            var doc = e.target.result;
            if (!doc) callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$MISSING_DOC));
            else {
                delete doc["_doc_id_rev"]; // for backwards compat
                callback(null, doc);
            }
        };
    };
    api._putLocal = function(doc, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        delete doc._revisions; // ignore this, trust the rev
        var oldRev = doc._rev;
        var id = doc._id;
        if (!oldRev) doc._rev = "0-1";
        else doc._rev = "0-" + (parseInt(oldRev.split("-")[1], 10) + 1);
        var tx = opts.ctx;
        var ret;
        if (!tx) {
            var txnResult = $8497c1e3bf13d11c$var$openTransactionSafely(idb, [
                $8497c1e3bf13d11c$var$LOCAL_STORE
            ], "readwrite");
            if (txnResult.error) return callback(txnResult.error);
            tx = txnResult.txn;
            tx.onerror = $8497c1e3bf13d11c$var$idbError(callback);
            tx.oncomplete = function() {
                if (ret) callback(null, ret);
            };
        }
        var oStore = tx.objectStore($8497c1e3bf13d11c$var$LOCAL_STORE);
        var req;
        if (oldRev) {
            req = oStore.get(id);
            req.onsuccess = function(e) {
                var oldDoc = e.target.result;
                if (!oldDoc || oldDoc._rev !== oldRev) callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$REV_CONFLICT));
                else {
                    var req = oStore.put(doc);
                    req.onsuccess = function() {
                        ret = {
                            ok: true,
                            id: doc._id,
                            rev: doc._rev
                        };
                        if (opts.ctx) callback(null, ret);
                    };
                }
            };
        } else {
            req = oStore.add(doc);
            req.onerror = function(e) {
                // constraint error, already exists
                callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$REV_CONFLICT));
                e.preventDefault(); // avoid transaction abort
                e.stopPropagation(); // avoid transaction onerror
            };
            req.onsuccess = function() {
                ret = {
                    ok: true,
                    id: doc._id,
                    rev: doc._rev
                };
                if (opts.ctx) callback(null, ret);
            };
        }
    };
    api._removeLocal = function(doc, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        var tx = opts.ctx;
        if (!tx) {
            var txnResult = $8497c1e3bf13d11c$var$openTransactionSafely(idb, [
                $8497c1e3bf13d11c$var$LOCAL_STORE
            ], "readwrite");
            if (txnResult.error) return callback(txnResult.error);
            tx = txnResult.txn;
            tx.oncomplete = function() {
                if (ret) callback(null, ret);
            };
        }
        var ret;
        var id = doc._id;
        var oStore = tx.objectStore($8497c1e3bf13d11c$var$LOCAL_STORE);
        var req = oStore.get(id);
        req.onerror = $8497c1e3bf13d11c$var$idbError(callback);
        req.onsuccess = function(e) {
            var oldDoc = e.target.result;
            if (!oldDoc || oldDoc._rev !== doc._rev) callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$MISSING_DOC));
            else {
                oStore.delete(id);
                ret = {
                    ok: true,
                    id: id,
                    rev: "0-0"
                };
                if (opts.ctx) callback(null, ret);
            }
        };
    };
    api._destroy = function(opts, callback) {
        $8497c1e3bf13d11c$var$changesHandler.removeAllListeners(dbName);
        //Close open request for "dbName" database to fix ie delay.
        var openReq = $8497c1e3bf13d11c$var$openReqList.get(dbName);
        if (openReq && openReq.result) {
            openReq.result.close();
            $8497c1e3bf13d11c$var$cachedDBs.delete(dbName);
        }
        var req = indexedDB.deleteDatabase(dbName);
        req.onsuccess = function() {
            //Remove open request from the list.
            $8497c1e3bf13d11c$var$openReqList.delete(dbName);
            if ($8497c1e3bf13d11c$var$hasLocalStorage() && dbName in localStorage) delete localStorage[dbName];
            callback(null, {
                "ok": true
            });
        };
        req.onerror = $8497c1e3bf13d11c$var$idbError(callback);
    };
    var cached = $8497c1e3bf13d11c$var$cachedDBs.get(dbName);
    if (cached) {
        idb = cached.idb;
        api._meta = cached.global;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lRg87)))(function() {
            callback(null, api);
        });
    }
    var req = indexedDB.open(dbName, $8497c1e3bf13d11c$var$ADAPTER_VERSION);
    $8497c1e3bf13d11c$var$openReqList.set(dbName, req);
    req.onupgradeneeded = function(e) {
        var db = e.target.result;
        if (e.oldVersion < 1) return createSchema(db); // new db, initial schema
        // do migrations
        var txn = e.currentTarget.transaction;
        // these migrations have to be done in this function, before
        // control is returned to the event loop, because IndexedDB
        if (e.oldVersion < 3) createLocalStoreSchema(db); // v2 -> v3
        if (e.oldVersion < 4) addAttachAndSeqStore(db); // v3 -> v4
        var migrations = [
            addDeletedOrLocalIndex,
            migrateLocalStore,
            migrateAttsAndSeqs,
            migrateMetadata // v4 -> v5
        ];
        var i = e.oldVersion;
        function next() {
            var migration = migrations[i - 1];
            i++;
            if (migration) migration(txn, next);
        }
        next();
    };
    req.onsuccess = function(e) {
        idb = e.target.result;
        idb.onversionchange = function() {
            idb.close();
            $8497c1e3bf13d11c$var$cachedDBs.delete(dbName);
        };
        idb.onabort = function(e) {
            $8497c1e3bf13d11c$var$guardedConsole("error", "Database has a global failure", e.target.error);
            idbGlobalFailureError = e.target.error;
            idb.close();
            $8497c1e3bf13d11c$var$cachedDBs.delete(dbName);
        };
        // Do a few setup operations (in parallel as much as possible):
        // 1. Fetch meta doc
        // 2. Check blob support
        // 3. Calculate docCount
        // 4. Generate an instanceId if necessary
        // 5. Store docCount and instanceId on meta doc
        var txn = idb.transaction([
            $8497c1e3bf13d11c$var$META_STORE,
            $8497c1e3bf13d11c$var$DETECT_BLOB_SUPPORT_STORE,
            $8497c1e3bf13d11c$var$DOC_STORE
        ], "readwrite");
        var storedMetaDoc = false;
        var metaDoc;
        var docCount;
        var blobSupport;
        var instanceId;
        function completeSetup() {
            if (typeof blobSupport === "undefined" || !storedMetaDoc) return;
            api._meta = {
                name: dbName,
                instanceId: instanceId,
                blobSupport: blobSupport
            };
            $8497c1e3bf13d11c$var$cachedDBs.set(dbName, {
                idb: idb,
                global: api._meta
            });
            callback(null, api);
        }
        function storeMetaDocIfReady() {
            if (typeof docCount === "undefined" || typeof metaDoc === "undefined") return;
            var instanceKey = dbName + "_id";
            if (instanceKey in metaDoc) instanceId = metaDoc[instanceKey];
            else metaDoc[instanceKey] = instanceId = $8497c1e3bf13d11c$var$uuid();
            metaDoc.docCount = docCount;
            txn.objectStore($8497c1e3bf13d11c$var$META_STORE).put(metaDoc);
        }
        //
        // fetch or generate the instanceId
        //
        txn.objectStore($8497c1e3bf13d11c$var$META_STORE).get($8497c1e3bf13d11c$var$META_STORE).onsuccess = function(e) {
            metaDoc = e.target.result || {
                id: $8497c1e3bf13d11c$var$META_STORE
            };
            storeMetaDocIfReady();
        };
        //
        // countDocs
        //
        $8497c1e3bf13d11c$var$countDocs(txn, function(count) {
            docCount = count;
            storeMetaDocIfReady();
        });
        //
        // check blob support
        //
        if (!$8497c1e3bf13d11c$var$blobSupportPromise) // make sure blob support is only checked once
        $8497c1e3bf13d11c$var$blobSupportPromise = $8497c1e3bf13d11c$var$checkBlobSupport(txn);
        $8497c1e3bf13d11c$var$blobSupportPromise.then(function(val) {
            blobSupport = val;
            completeSetup();
        });
        // only when the metadata put transaction has completed,
        // consider the setup done
        txn.oncomplete = function() {
            storedMetaDoc = true;
            completeSetup();
        };
        txn.onabort = $8497c1e3bf13d11c$var$idbError(callback);
    };
    req.onerror = function(e) {
        var msg = e.target.error && e.target.error.message;
        if (!msg) msg = "Failed to open indexedDB, are you in private browsing mode?";
        else if (msg.indexOf("stored database is a higher version") !== -1) msg = new Error('This DB was created with the newer "indexeddb" adapter, but you are trying to open it with the older "idb" adapter');
        $8497c1e3bf13d11c$var$guardedConsole("error", msg);
        callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$IDB_ERROR, msg));
    };
}
$8497c1e3bf13d11c$var$IdbPouch.valid = function() {
    // Following #7085 buggy idb versions (typically Safari < 10.1) are
    // considered valid.
    // On Firefox SecurityError is thrown while referencing indexedDB if cookies
    // are not allowed. `typeof indexedDB` also triggers the error.
    try {
        // some outdated implementations of IDB that appear on Samsung
        // and HTC Android devices <4.4 are missing IDBKeyRange
        return typeof indexedDB !== "undefined" && typeof IDBKeyRange !== "undefined";
    } catch (e) {
        return false;
    }
};
function $8497c1e3bf13d11c$var$IDBPouch(PouchDB) {
    PouchDB.adapter("idb", $8497c1e3bf13d11c$var$IdbPouch, true);
}
// dead simple promise pool, inspired by https://github.com/timdp/es6-promise-pool
// but much smaller in code size. limits the number of concurrent promises that are executed
function $8497c1e3bf13d11c$var$pool(promiseFactories, limit) {
    return new Promise(function(resolve, reject) {
        var running = 0;
        var current = 0;
        var done = 0;
        var len = promiseFactories.length;
        var err;
        function runNext() {
            running++;
            promiseFactories[current++]().then(onSuccess, onError);
        }
        function doNext() {
            if (++done === len) {
                /* istanbul ignore if */ if (err) reject(err);
                else resolve();
            } else runNextBatch();
        }
        function onSuccess() {
            running--;
            doNext();
        }
        /* istanbul ignore next */ function onError(thisErr) {
            running--;
            err = err || thisErr;
            doNext();
        }
        function runNextBatch() {
            while(running < limit && current < len)runNext();
        }
        runNextBatch();
    });
}
const $8497c1e3bf13d11c$var$CHANGES_BATCH_SIZE = 25;
const $8497c1e3bf13d11c$var$MAX_SIMULTANEOUS_REVS = 50;
const $8497c1e3bf13d11c$var$CHANGES_TIMEOUT_BUFFER = 5000;
const $8497c1e3bf13d11c$var$DEFAULT_HEARTBEAT = 10000;
let $8497c1e3bf13d11c$var$supportsBulkGetMap = {};
function $8497c1e3bf13d11c$var$readAttachmentsAsBlobOrBuffer(row) {
    let doc = row.doc || row.ok;
    let atts = doc && doc._attachments;
    if (!atts) return;
    Object.keys(atts).forEach(function(filename) {
        let att = atts[filename];
        att.data = $8497c1e3bf13d11c$var$b64ToBluffer(att.data, att.content_type);
    });
}
function $8497c1e3bf13d11c$var$encodeDocId(id) {
    if (/^_design/.test(id)) return "_design/" + encodeURIComponent(id.slice(8));
    if (/^_local/.test(id)) return "_local/" + encodeURIComponent(id.slice(7));
    return encodeURIComponent(id);
}
function $8497c1e3bf13d11c$var$preprocessAttachments$1(doc) {
    if (!doc._attachments || !Object.keys(doc._attachments)) return Promise.resolve();
    return Promise.all(Object.keys(doc._attachments).map(function(key) {
        let attachment = doc._attachments[key];
        if (attachment.data && typeof attachment.data !== "string") return new Promise(function(resolve) {
            $8497c1e3bf13d11c$var$blobToBase64(attachment.data, resolve);
        }).then(function(b64) {
            attachment.data = b64;
        });
    }));
}
function $8497c1e3bf13d11c$var$hasUrlPrefix(opts) {
    if (!opts.prefix) return false;
    let protocol = $8497c1e3bf13d11c$var$parseUri(opts.prefix).protocol;
    return protocol === "http" || protocol === "https";
}
// Get all the information you possibly can about the URI given by name and
// return it as a suitable object.
function $8497c1e3bf13d11c$var$getHost(name, opts) {
    // encode db name if opts.prefix is a url (#5574)
    if ($8497c1e3bf13d11c$var$hasUrlPrefix(opts)) {
        let dbName = opts.name.substr(opts.prefix.length);
        // Ensure prefix has a trailing slash
        let prefix = opts.prefix.replace(/\/?$/, "/");
        name = prefix + encodeURIComponent(dbName);
    }
    let uri = $8497c1e3bf13d11c$var$parseUri(name);
    if (uri.user || uri.password) uri.auth = {
        username: uri.user,
        password: uri.password
    };
    // Split the path part of the URI into parts using '/' as the delimiter
    // after removing any leading '/' and any trailing '/'
    let parts = uri.path.replace(/(^\/|\/$)/g, "").split("/");
    uri.db = parts.pop();
    // Prevent double encoding of URI component
    if (uri.db.indexOf("%") === -1) uri.db = encodeURIComponent(uri.db);
    uri.path = parts.join("/");
    return uri;
}
// Generate a URL with the host data given by opts and the given path
function $8497c1e3bf13d11c$var$genDBUrl(opts, path) {
    return $8497c1e3bf13d11c$var$genUrl(opts, opts.db + "/" + path);
}
// Generate a URL with the host data given by opts and the given path
function $8497c1e3bf13d11c$var$genUrl(opts, path) {
    // If the host already has a path, then we need to have a path delimiter
    // Otherwise, the path delimiter is the empty string
    let pathDel = !opts.path ? "" : "/";
    // If the host already has a path, then we need to have a path delimiter
    // Otherwise, the path delimiter is the empty string
    return opts.protocol + "://" + opts.host + (opts.port ? ":" + opts.port : "") + "/" + opts.path + pathDel + path;
}
function $8497c1e3bf13d11c$var$paramsToStr(params) {
    return "?" + Object.keys(params).map(function(k) {
        return k + "=" + encodeURIComponent(params[k]);
    }).join("&");
}
function $8497c1e3bf13d11c$var$shouldCacheBust(opts) {
    let ua = typeof navigator !== "undefined" && navigator.userAgent ? navigator.userAgent.toLowerCase() : "";
    let isIE = ua.indexOf("msie") !== -1;
    let isTrident = ua.indexOf("trident") !== -1;
    let isEdge = ua.indexOf("edge") !== -1;
    let isGET = !("method" in opts) || opts.method === "GET";
    return (isIE || isTrident || isEdge) && isGET;
}
// Implements the PouchDB API for dealing with CouchDB instances over HTTP
function $8497c1e3bf13d11c$var$HttpPouch(opts, callback) {
    // The functions that will be publicly available for HttpPouch
    let api = this;
    let host = $8497c1e3bf13d11c$var$getHost(opts.name, opts);
    let dbUrl = $8497c1e3bf13d11c$var$genDBUrl(host, "");
    opts = $8497c1e3bf13d11c$var$clone(opts);
    const ourFetch = async function(url, options) {
        options = options || {};
        options.headers = options.headers || new $8497c1e3bf13d11c$var$h();
        options.credentials = "include";
        if (opts.auth || host.auth) {
            let nAuth = opts.auth || host.auth;
            let str = nAuth.username + ":" + nAuth.password;
            let token = $8497c1e3bf13d11c$var$thisBtoa(unescape(encodeURIComponent(str)));
            options.headers.set("Authorization", "Basic " + token);
        }
        let headers = opts.headers || {};
        Object.keys(headers).forEach(function(key) {
            options.headers.append(key, headers[key]);
        });
        /* istanbul ignore if */ if ($8497c1e3bf13d11c$var$shouldCacheBust(options)) url += (url.indexOf("?") === -1 ? "?" : "&") + "_nonce=" + Date.now();
        let fetchFun = opts.fetch || $8497c1e3bf13d11c$var$f$1;
        return await fetchFun(url, options);
    };
    function adapterFun$$1(name, fun) {
        return $8497c1e3bf13d11c$var$adapterFun(name, function(...args) {
            setup().then(function() {
                return fun.apply(this, args);
            }).catch(function(e) {
                let callback = args.pop();
                callback(e);
            });
        }).bind(api);
    }
    async function fetchJSON(url, options) {
        let result = {};
        options = options || {};
        options.headers = options.headers || new $8497c1e3bf13d11c$var$h();
        if (!options.headers.get("Content-Type")) options.headers.set("Content-Type", "application/json");
        if (!options.headers.get("Accept")) options.headers.set("Accept", "application/json");
        const response = await ourFetch(url, options);
        result.ok = response.ok;
        result.status = response.status;
        const json = await response.json();
        result.data = json;
        if (!result.ok) {
            result.data.status = result.status;
            let err = $8497c1e3bf13d11c$var$generateErrorFromResponse(result.data);
            throw err;
        }
        if (Array.isArray(result.data)) result.data = result.data.map(function(v) {
            if (v.error || v.missing) return $8497c1e3bf13d11c$var$generateErrorFromResponse(v);
            else return v;
        });
        return result;
    }
    let setupPromise;
    async function setup() {
        if (opts.skip_setup) return Promise.resolve();
        // If there is a setup in process or previous successful setup
        // done then we will use that
        // If previous setups have been rejected we will try again
        if (setupPromise) return setupPromise;
        setupPromise = fetchJSON(dbUrl).catch(function(err) {
            if (err && err.status && err.status === 404) {
                // Doesnt exist, create it
                $8497c1e3bf13d11c$var$explainError(404, "PouchDB is just detecting if the remote exists.");
                return fetchJSON(dbUrl, {
                    method: "PUT"
                });
            } else return Promise.reject(err);
        }).catch(function(err) {
            // If we try to create a database that already exists, skipped in
            // istanbul since its catching a race condition.
            /* istanbul ignore if */ if (err && err.status && err.status === 412) return true;
            return Promise.reject(err);
        });
        setupPromise.catch(function() {
            setupPromise = null;
        });
        return setupPromise;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lRg87)))(function() {
        callback(null, api);
    });
    api._remote = true;
    /* istanbul ignore next */ api.type = function() {
        return "http";
    };
    api.id = adapterFun$$1("id", async function(callback) {
        let result;
        try {
            const response = await ourFetch($8497c1e3bf13d11c$var$genUrl(host, ""));
            result = await response.json();
        } catch (err) {
            result = {};
        }
        // Bad response or missing `uuid` should not prevent ID generation.
        let uuid$$1 = result && result.uuid ? result.uuid + host.db : $8497c1e3bf13d11c$var$genDBUrl(host, "");
        callback(null, uuid$$1);
    });
    // Sends a POST request to the host calling the couchdb _compact function
    //    version: The version of CouchDB it is running
    api.compact = adapterFun$$1("compact", async function(opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        opts = $8497c1e3bf13d11c$var$clone(opts);
        await fetchJSON($8497c1e3bf13d11c$var$genDBUrl(host, "_compact"), {
            method: "POST"
        });
        function ping() {
            api.info(function(err, res) {
                // CouchDB may send a "compact_running:true" if it's
                // already compacting. PouchDB Server doesn't.
                /* istanbul ignore else */ if (res && !res.compact_running) callback(null, {
                    ok: true
                });
                else setTimeout(ping, opts.interval || 200);
            });
        }
        // Ping the http if it's finished compaction
        ping();
    });
    api.bulkGet = $8497c1e3bf13d11c$var$adapterFun("bulkGet", function(opts, callback) {
        let self1 = this;
        async function doBulkGet(cb) {
            let params = {};
            if (opts.revs) params.revs = true;
            if (opts.attachments) /* istanbul ignore next */ params.attachments = true;
            if (opts.latest) params.latest = true;
            try {
                const result = await fetchJSON($8497c1e3bf13d11c$var$genDBUrl(host, "_bulk_get" + $8497c1e3bf13d11c$var$paramsToStr(params)), {
                    method: "POST",
                    body: JSON.stringify({
                        docs: opts.docs
                    })
                });
                if (opts.attachments && opts.binary) result.data.results.forEach(function(res) {
                    res.docs.forEach($8497c1e3bf13d11c$var$readAttachmentsAsBlobOrBuffer);
                });
                cb(null, result.data);
            } catch (error) {
                cb(error);
            }
        }
        /* istanbul ignore next */ function doBulkGetShim() {
            // avoid "url too long error" by splitting up into multiple requests
            let batchSize = $8497c1e3bf13d11c$var$MAX_SIMULTANEOUS_REVS;
            let numBatches = Math.ceil(opts.docs.length / batchSize);
            let numDone = 0;
            let results = new Array(numBatches);
            function onResult(batchNum) {
                return function(err, res) {
                    // err is impossible because shim returns a list of errs in that case
                    results[batchNum] = res.results;
                    if (++numDone === numBatches) callback(null, {
                        results: $8497c1e3bf13d11c$var$flatten(results)
                    });
                };
            }
            for(let i = 0; i < numBatches; i++){
                let subOpts = $8497c1e3bf13d11c$var$pick(opts, [
                    "revs",
                    "attachments",
                    "binary",
                    "latest"
                ]);
                subOpts.docs = opts.docs.slice(i * batchSize, Math.min(opts.docs.length, (i + 1) * batchSize));
                $8497c1e3bf13d11c$var$bulkGet(self1, subOpts, onResult(i));
            }
        }
        // mark the whole database as either supporting or not supporting _bulk_get
        let dbUrl = $8497c1e3bf13d11c$var$genUrl(host, "");
        let supportsBulkGet = $8497c1e3bf13d11c$var$supportsBulkGetMap[dbUrl];
        /* istanbul ignore next */ if (typeof supportsBulkGet !== "boolean") // check if this database supports _bulk_get
        doBulkGet(function(err, res) {
            if (err) {
                $8497c1e3bf13d11c$var$supportsBulkGetMap[dbUrl] = false;
                $8497c1e3bf13d11c$var$explainError(err.status, "PouchDB is just detecting if the remote supports the _bulk_get API.");
                doBulkGetShim();
            } else {
                $8497c1e3bf13d11c$var$supportsBulkGetMap[dbUrl] = true;
                callback(null, res);
            }
        });
        else if (supportsBulkGet) doBulkGet(callback);
        else doBulkGetShim();
    });
    // Calls GET on the host, which gets back a JSON string containing
    //    couchdb: A welcome string
    //    version: The version of CouchDB it is running
    api._info = async function(callback) {
        try {
            await setup();
            const response = await ourFetch($8497c1e3bf13d11c$var$genDBUrl(host, ""));
            const info = await response.json();
            info.host = $8497c1e3bf13d11c$var$genDBUrl(host, "");
            callback(null, info);
        } catch (err) {
            callback(err);
        }
    };
    api.fetch = async function(path, options) {
        await setup();
        const url = path.substring(0, 1) === "/" ? $8497c1e3bf13d11c$var$genUrl(host, path.substring(1)) : $8497c1e3bf13d11c$var$genDBUrl(host, path);
        return ourFetch(url, options);
    };
    // Get the document with the given id from the database given by host.
    // The id could be solely the _id in the database, or it may be a
    // _design/ID or _local/ID path
    api.get = adapterFun$$1("get", async function(id, opts, callback) {
        // If no options were given, set the callback to the second parameter
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        opts = $8497c1e3bf13d11c$var$clone(opts);
        // List of parameters to add to the GET request
        let params = {};
        if (opts.revs) params.revs = true;
        if (opts.revs_info) params.revs_info = true;
        if (opts.latest) params.latest = true;
        if (opts.open_revs) {
            if (opts.open_revs !== "all") opts.open_revs = JSON.stringify(opts.open_revs);
            params.open_revs = opts.open_revs;
        }
        if (opts.rev) params.rev = opts.rev;
        if (opts.conflicts) params.conflicts = opts.conflicts;
        /* istanbul ignore if */ if (opts.update_seq) params.update_seq = opts.update_seq;
        id = $8497c1e3bf13d11c$var$encodeDocId(id);
        function fetchAttachments(doc) {
            let atts = doc._attachments;
            let filenames = atts && Object.keys(atts);
            if (!atts || !filenames.length) return;
            // we fetch these manually in separate XHRs, because
            // Sync Gateway would normally send it back as multipart/mixed,
            // which we cannot parse. Also, this is more efficient than
            // receiving attachments as base64-encoded strings.
            async function fetchData(filename) {
                const att = atts[filename];
                const path = $8497c1e3bf13d11c$var$encodeDocId(doc._id) + "/" + encodeAttachmentId(filename) + "?rev=" + doc._rev;
                const response = await ourFetch($8497c1e3bf13d11c$var$genDBUrl(host, path));
                let blob;
                if ("buffer" in response) blob = await response.buffer();
                else /* istanbul ignore next */ blob = await response.blob();
                let data;
                if (opts.binary) {
                    let typeFieldDescriptor = Object.getOwnPropertyDescriptor(blob.__proto__, "type");
                    if (!typeFieldDescriptor || typeFieldDescriptor.set) blob.type = att.content_type;
                    data = blob;
                } else data = await new Promise(function(resolve) {
                    $8497c1e3bf13d11c$var$blobToBase64(blob, resolve);
                });
                delete att.stub;
                delete att.length;
                att.data = data;
            }
            let promiseFactories = filenames.map(function(filename) {
                return function() {
                    return fetchData(filename);
                };
            });
            // This limits the number of parallel xhr requests to 5 any time
            // to avoid issues with maximum browser request limits
            return $8497c1e3bf13d11c$var$pool(promiseFactories, 5);
        }
        function fetchAllAttachments(docOrDocs) {
            if (Array.isArray(docOrDocs)) return Promise.all(docOrDocs.map(function(doc) {
                if (doc.ok) return fetchAttachments(doc.ok);
            }));
            return fetchAttachments(docOrDocs);
        }
        const url = $8497c1e3bf13d11c$var$genDBUrl(host, id + $8497c1e3bf13d11c$var$paramsToStr(params));
        try {
            const res = await fetchJSON(url);
            if (opts.attachments) await fetchAllAttachments(res.data);
            callback(null, res.data);
        } catch (error) {
            error.docId = id;
            callback(error);
        }
    });
    // Delete the document given by doc from the database given by host.
    api.remove = adapterFun$$1("remove", async function(docOrId, optsOrRev, opts, cb) {
        let doc;
        if (typeof optsOrRev === "string") {
            // id, rev, opts, callback style
            doc = {
                _id: docOrId,
                _rev: optsOrRev
            };
            if (typeof opts === "function") {
                cb = opts;
                opts = {};
            }
        } else {
            // doc, opts, callback style
            doc = docOrId;
            if (typeof optsOrRev === "function") {
                cb = optsOrRev;
                opts = {};
            } else {
                cb = opts;
                opts = optsOrRev;
            }
        }
        const rev = doc._rev || opts.rev;
        const url = $8497c1e3bf13d11c$var$genDBUrl(host, $8497c1e3bf13d11c$var$encodeDocId(doc._id)) + "?rev=" + rev;
        try {
            const result = await fetchJSON(url, {
                method: "DELETE"
            });
            cb(null, result.data);
        } catch (error) {
            cb(error);
        }
    });
    function encodeAttachmentId(attachmentId) {
        return attachmentId.split("/").map(encodeURIComponent).join("/");
    }
    // Get the attachment
    api.getAttachment = adapterFun$$1("getAttachment", async function(docId, attachmentId, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        const params = opts.rev ? "?rev=" + opts.rev : "";
        const url = $8497c1e3bf13d11c$var$genDBUrl(host, $8497c1e3bf13d11c$var$encodeDocId(docId)) + "/" + encodeAttachmentId(attachmentId) + params;
        let contentType;
        try {
            const response = await ourFetch(url, {
                method: "GET"
            });
            if (!response.ok) throw response;
            contentType = response.headers.get("content-type");
            let blob;
            typeof $6qd2L;
            /* istanbul ignore next */ blob = await response.blob();
            // TODO: also remove
            typeof $6qd2L;
            var typeFieldDescriptor;
            callback(null, blob);
        } catch (err) {
            callback(err);
        }
    });
    // Remove the attachment given by the id and rev
    api.removeAttachment = adapterFun$$1("removeAttachment", async function(docId, attachmentId, rev, callback) {
        const url = $8497c1e3bf13d11c$var$genDBUrl(host, $8497c1e3bf13d11c$var$encodeDocId(docId) + "/" + encodeAttachmentId(attachmentId)) + "?rev=" + rev;
        try {
            const result = await fetchJSON(url, {
                method: "DELETE"
            });
            callback(null, result.data);
        } catch (error) {
            callback(error);
        }
    });
    // Add the attachment given by blob and its contentType property
    // to the document with the given id, the revision given by rev, and
    // add it to the database given by host.
    api.putAttachment = adapterFun$$1("putAttachment", async function(docId, attachmentId, rev, blob, type, callback) {
        if (typeof type === "function") {
            callback = type;
            type = blob;
            blob = rev;
            rev = null;
        }
        const id = $8497c1e3bf13d11c$var$encodeDocId(docId) + "/" + encodeAttachmentId(attachmentId);
        let url = $8497c1e3bf13d11c$var$genDBUrl(host, id);
        if (rev) url += "?rev=" + rev;
        if (typeof blob === "string") {
            // input is assumed to be a base64 string
            let binary;
            try {
                binary = $8497c1e3bf13d11c$var$thisAtob(blob);
            } catch (err) {
                return callback($8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$BAD_ARG, "Attachment is not a valid base64 string"));
            }
            blob = binary ? $8497c1e3bf13d11c$var$binStringToBluffer(binary, type) : "";
        }
        try {
            // Add the attachment
            const result = await fetchJSON(url, {
                headers: new $8497c1e3bf13d11c$var$h({
                    "Content-Type": type
                }),
                method: "PUT",
                body: blob
            });
            callback(null, result.data);
        } catch (error) {
            callback(error);
        }
    });
    // Update/create multiple documents given by req in the database
    // given by host.
    api._bulkDocs = async function(req, opts, callback) {
        // If new_edits=false then it prevents the database from creating
        // new revision numbers for the documents. Instead it just uses
        // the old ones. This is used in database replication.
        req.new_edits = opts.new_edits;
        try {
            await setup();
            await Promise.all(req.docs.map($8497c1e3bf13d11c$var$preprocessAttachments$1));
            // Update/create the documents
            const result = await fetchJSON($8497c1e3bf13d11c$var$genDBUrl(host, "_bulk_docs"), {
                method: "POST",
                body: JSON.stringify(req)
            });
            callback(null, result.data);
        } catch (error) {
            callback(error);
        }
    };
    // Update/create document
    api._put = async function(doc, opts, callback) {
        try {
            await setup();
            await $8497c1e3bf13d11c$var$preprocessAttachments$1(doc);
            const result = await fetchJSON($8497c1e3bf13d11c$var$genDBUrl(host, $8497c1e3bf13d11c$var$encodeDocId(doc._id)), {
                method: "PUT",
                body: JSON.stringify(doc)
            });
            callback(null, result.data);
        } catch (error) {
            error.docId = doc && doc._id;
            callback(error);
        }
    };
    // Get a listing of the documents in the database given
    // by host and ordered by increasing id.
    api.allDocs = adapterFun$$1("allDocs", async function(opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        opts = $8497c1e3bf13d11c$var$clone(opts);
        // List of parameters to add to the GET request
        let params = {};
        let body;
        let method = "GET";
        if (opts.conflicts) params.conflicts = true;
        /* istanbul ignore if */ if (opts.update_seq) params.update_seq = true;
        if (opts.descending) params.descending = true;
        if (opts.include_docs) params.include_docs = true;
        // added in CouchDB 1.6.0
        if (opts.attachments) params.attachments = true;
        if (opts.key) params.key = JSON.stringify(opts.key);
        if (opts.start_key) opts.startkey = opts.start_key;
        if (opts.startkey) params.startkey = JSON.stringify(opts.startkey);
        if (opts.end_key) opts.endkey = opts.end_key;
        if (opts.endkey) params.endkey = JSON.stringify(opts.endkey);
        if (typeof opts.inclusive_end !== "undefined") params.inclusive_end = !!opts.inclusive_end;
        if (typeof opts.limit !== "undefined") params.limit = opts.limit;
        if (typeof opts.skip !== "undefined") params.skip = opts.skip;
        let paramStr = $8497c1e3bf13d11c$var$paramsToStr(params);
        if (typeof opts.keys !== "undefined") {
            method = "POST";
            body = {
                keys: opts.keys
            };
        }
        try {
            const result = await fetchJSON($8497c1e3bf13d11c$var$genDBUrl(host, "_all_docs" + paramStr), {
                method: method,
                body: JSON.stringify(body)
            });
            if (opts.include_docs && opts.attachments && opts.binary) result.data.rows.forEach($8497c1e3bf13d11c$var$readAttachmentsAsBlobOrBuffer);
            callback(null, result.data);
        } catch (error) {
            callback(error);
        }
    });
    // Get a list of changes made to documents in the database given by host.
    // TODO According to the README, there should be two other methods here,
    // api.changes.addListener and api.changes.removeListener.
    api._changes = function(opts) {
        // We internally page the results of a changes request, this means
        // if there is a large set of changes to be returned we can start
        // processing them quicker instead of waiting on the entire
        // set of changes to return and attempting to process them at once
        let batchSize = "batch_size" in opts ? opts.batch_size : $8497c1e3bf13d11c$var$CHANGES_BATCH_SIZE;
        opts = $8497c1e3bf13d11c$var$clone(opts);
        if (opts.continuous && !("heartbeat" in opts)) opts.heartbeat = $8497c1e3bf13d11c$var$DEFAULT_HEARTBEAT;
        let requestTimeout = "timeout" in opts ? opts.timeout : 30000;
        // ensure CHANGES_TIMEOUT_BUFFER applies
        if ("timeout" in opts && opts.timeout && requestTimeout - opts.timeout < $8497c1e3bf13d11c$var$CHANGES_TIMEOUT_BUFFER) requestTimeout = opts.timeout + $8497c1e3bf13d11c$var$CHANGES_TIMEOUT_BUFFER;
        /* istanbul ignore if */ if ("heartbeat" in opts && opts.heartbeat && requestTimeout - opts.heartbeat < $8497c1e3bf13d11c$var$CHANGES_TIMEOUT_BUFFER) requestTimeout = opts.heartbeat + $8497c1e3bf13d11c$var$CHANGES_TIMEOUT_BUFFER;
        let params = {};
        if ("timeout" in opts && opts.timeout) params.timeout = opts.timeout;
        let limit = typeof opts.limit !== "undefined" ? opts.limit : false;
        let leftToFetch = limit;
        if (opts.style) params.style = opts.style;
        if (opts.include_docs || opts.filter && typeof opts.filter === "function") params.include_docs = true;
        if (opts.attachments) params.attachments = true;
        if (opts.continuous) params.feed = "longpoll";
        if (opts.seq_interval) params.seq_interval = opts.seq_interval;
        if (opts.conflicts) params.conflicts = true;
        if (opts.descending) params.descending = true;
        /* istanbul ignore if */ if (opts.update_seq) params.update_seq = true;
        if ("heartbeat" in opts) // If the heartbeat value is false, it disables the default heartbeat
        {
            if (opts.heartbeat) params.heartbeat = opts.heartbeat;
        }
        if (opts.filter && typeof opts.filter === "string") params.filter = opts.filter;
        if (opts.view && typeof opts.view === "string") {
            params.filter = "_view";
            params.view = opts.view;
        }
        // If opts.query_params exists, pass it through to the changes request.
        // These parameters may be used by the filter on the source database.
        if (opts.query_params && typeof opts.query_params === "object") {
            for(let param_name in opts.query_params)/* istanbul ignore else */ if (Object.prototype.hasOwnProperty.call(opts.query_params, param_name)) params[param_name] = opts.query_params[param_name];
        }
        let method = "GET";
        let body;
        if (opts.doc_ids) {
            // set this automagically for the user; it's annoying that couchdb
            // requires both a "filter" and a "doc_ids" param.
            params.filter = "_doc_ids";
            method = "POST";
            body = {
                doc_ids: opts.doc_ids
            };
        } else if (opts.selector) {
            // set this automagically for the user, similar to above
            params.filter = "_selector";
            method = "POST";
            body = {
                selector: opts.selector
            };
        }
        let controller = new $8497c1e3bf13d11c$var$a();
        let lastFetchedSeq;
        // Get all the changes starting wtih the one immediately after the
        // sequence number given by since.
        const fetchData = async function(since, callback) {
            if (opts.aborted) return;
            params.since = since;
            // "since" can be any kind of json object in Cloudant/CouchDB 2.x
            /* istanbul ignore next */ if (typeof params.since === "object") params.since = JSON.stringify(params.since);
            if (opts.descending) {
                if (limit) params.limit = leftToFetch;
            } else params.limit = !limit || leftToFetch > batchSize ? batchSize : leftToFetch;
            // Set the options for the ajax call
            let url = $8497c1e3bf13d11c$var$genDBUrl(host, "_changes" + $8497c1e3bf13d11c$var$paramsToStr(params));
            let fetchOpts = {
                signal: controller.signal,
                method: method,
                body: JSON.stringify(body)
            };
            lastFetchedSeq = since;
            /* istanbul ignore if */ if (opts.aborted) return;
            // Get the changes
            try {
                await setup();
                const result = await fetchJSON(url, fetchOpts);
                callback(null, result.data);
            } catch (error) {
                callback(error);
            }
        };
        // If opts.since exists, get all the changes from the sequence
        // number given by opts.since. Otherwise, get all the changes
        // from the sequence number 0.
        let results = {
            results: []
        };
        const fetched = function(err, res) {
            if (opts.aborted) return;
            let raw_results_length = 0;
            // If the result of the ajax call (res) contains changes (res.results)
            if (res && res.results) {
                raw_results_length = res.results.length;
                results.last_seq = res.last_seq;
                let pending = null;
                let lastSeq = null;
                // Attach 'pending' property if server supports it (CouchDB 2.0+)
                /* istanbul ignore if */ if (typeof res.pending === "number") pending = res.pending;
                if (typeof results.last_seq === "string" || typeof results.last_seq === "number") lastSeq = results.last_seq;
                // For each change
                let req = {};
                req.query = opts.query_params;
                res.results = res.results.filter(function(c) {
                    leftToFetch--;
                    let ret = $8497c1e3bf13d11c$var$filterChange(opts)(c);
                    if (ret) {
                        if (opts.include_docs && opts.attachments && opts.binary) $8497c1e3bf13d11c$var$readAttachmentsAsBlobOrBuffer(c);
                        if (opts.return_docs) results.results.push(c);
                        opts.onChange(c, pending, lastSeq);
                    }
                    return ret;
                });
            } else if (err) {
                // In case of an error, stop listening for changes and call
                // opts.complete
                opts.aborted = true;
                opts.complete(err);
                return;
            }
            // The changes feed may have timed out with no results
            // if so reuse last update sequence
            if (res && res.last_seq) lastFetchedSeq = res.last_seq;
            let finished = limit && leftToFetch <= 0 || res && raw_results_length < batchSize || opts.descending;
            if (opts.continuous && !(limit && leftToFetch <= 0) || !finished) // Queue a call to fetch again with the newest sequence number
            (0, (/*@__PURE__*/$parcel$interopDefault($lRg87)))(function() {
                fetchData(lastFetchedSeq, fetched);
            });
            else // We're done, call the callback
            opts.complete(null, results);
        };
        fetchData(opts.since || 0, fetched);
        // Return a method to cancel this method from processing any more
        return {
            cancel: function() {
                opts.aborted = true;
                controller.abort();
            }
        };
    };
    // Given a set of document/revision IDs (given by req), tets the subset of
    // those that do NOT correspond to revisions stored in the database.
    // See http://wiki.apache.org/couchdb/HttpPostRevsDiff
    api.revsDiff = adapterFun$$1("revsDiff", async function(req, opts, callback) {
        // If no options were given, set the callback to be the second parameter
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        try {
            // Get the missing document/revision IDs
            const result = await fetchJSON($8497c1e3bf13d11c$var$genDBUrl(host, "_revs_diff"), {
                method: "POST",
                body: JSON.stringify(req)
            });
            callback(null, result.data);
        } catch (error) {
            callback(error);
        }
    });
    api._close = function(callback) {
        callback();
    };
    api._destroy = async function(options, callback) {
        try {
            const json = await fetchJSON($8497c1e3bf13d11c$var$genDBUrl(host, ""), {
                method: "DELETE"
            });
            callback(null, json);
        } catch (error) {
            if (error.status === 404) callback(null, {
                ok: true
            });
            else callback(error);
        }
    };
}
// HttpPouch is a valid adapter.
$8497c1e3bf13d11c$var$HttpPouch.valid = function() {
    return true;
};
function $8497c1e3bf13d11c$var$HttpPouch$1(PouchDB) {
    PouchDB.adapter("http", $8497c1e3bf13d11c$var$HttpPouch, false);
    PouchDB.adapter("https", $8497c1e3bf13d11c$var$HttpPouch, false);
}
class $8497c1e3bf13d11c$var$QueryParseError extends Error {
    constructor(message){
        super();
        this.status = 400;
        this.name = "query_parse_error";
        this.message = message;
        this.error = true;
        try {
            Error.captureStackTrace(this, $8497c1e3bf13d11c$var$QueryParseError);
        } catch (e) {}
    }
}
class $8497c1e3bf13d11c$var$NotFoundError extends Error {
    constructor(message){
        super();
        this.status = 404;
        this.name = "not_found";
        this.message = message;
        this.error = true;
        try {
            Error.captureStackTrace(this, $8497c1e3bf13d11c$var$NotFoundError);
        } catch (e) {}
    }
}
class $8497c1e3bf13d11c$var$BuiltInError extends Error {
    constructor(message){
        super();
        this.status = 500;
        this.name = "invalid_value";
        this.message = message;
        this.error = true;
        try {
            Error.captureStackTrace(this, $8497c1e3bf13d11c$var$BuiltInError);
        } catch (e) {}
    }
}
function $8497c1e3bf13d11c$var$promisedCallback(promise, callback) {
    if (callback) promise.then(function(res) {
        (0, (/*@__PURE__*/$parcel$interopDefault($lRg87)))(function() {
            callback(null, res);
        });
    }, function(reason) {
        (0, (/*@__PURE__*/$parcel$interopDefault($lRg87)))(function() {
            callback(reason);
        });
    });
    return promise;
}
function $8497c1e3bf13d11c$var$callbackify(fun) {
    return function(...args) {
        var cb = args.pop();
        var promise = fun.apply(this, args);
        if (typeof cb === "function") $8497c1e3bf13d11c$var$promisedCallback(promise, cb);
        return promise;
    };
}
// Promise finally util similar to Q.finally
function $8497c1e3bf13d11c$var$fin(promise, finalPromiseFactory) {
    return promise.then(function(res) {
        return finalPromiseFactory().then(function() {
            return res;
        });
    }, function(reason) {
        return finalPromiseFactory().then(function() {
            throw reason;
        });
    });
}
function $8497c1e3bf13d11c$var$sequentialize(queue, promiseFactory) {
    return function() {
        var args = arguments;
        var that = this;
        return queue.add(function() {
            return promiseFactory.apply(that, args);
        });
    };
}
// uniq an array of strings, order not guaranteed
// similar to underscore/lodash _.uniq
function $8497c1e3bf13d11c$var$uniq(arr) {
    var theSet = new $8497c1e3bf13d11c$var$ExportedSet(arr);
    var result = new Array(theSet.size);
    var index = -1;
    theSet.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
function $8497c1e3bf13d11c$var$mapToKeysArray(map) {
    var result = new Array(map.size);
    var index = -1;
    map.forEach(function(value, key) {
        result[++index] = key;
    });
    return result;
}
function $8497c1e3bf13d11c$var$createBuiltInError(name) {
    var message = "builtin " + name + " function requires map values to be numbers" + " or number arrays";
    return new $8497c1e3bf13d11c$var$BuiltInError(message);
}
function $8497c1e3bf13d11c$var$sum(values) {
    var result = 0;
    for(var i = 0, len = values.length; i < len; i++){
        var num = values[i];
        if (typeof num !== "number") {
            if (Array.isArray(num)) {
                // lists of numbers are also allowed, sum them separately
                result = typeof result === "number" ? [
                    result
                ] : result;
                for(var j = 0, jLen = num.length; j < jLen; j++){
                    var jNum = num[j];
                    if (typeof jNum !== "number") throw $8497c1e3bf13d11c$var$createBuiltInError("_sum");
                    else if (typeof result[j] === "undefined") result.push(jNum);
                    else result[j] += jNum;
                }
            } else throw $8497c1e3bf13d11c$var$createBuiltInError("_sum");
        } else if (typeof result === "number") result += num;
        else result[0] += num;
    }
    return result;
}
var $8497c1e3bf13d11c$var$log = $8497c1e3bf13d11c$var$guardedConsole.bind(null, "log");
var $8497c1e3bf13d11c$var$isArray = Array.isArray;
var $8497c1e3bf13d11c$var$toJSON = JSON.parse;
function $8497c1e3bf13d11c$var$evalFunctionWithEval(func, emit) {
    return $8497c1e3bf13d11c$var$scopeEval("return (" + func.replace(/;\s*$/, "") + ");", {
        emit: emit,
        sum: $8497c1e3bf13d11c$var$sum,
        log: $8497c1e3bf13d11c$var$log,
        isArray: $8497c1e3bf13d11c$var$isArray,
        toJSON: $8497c1e3bf13d11c$var$toJSON
    });
}
/*
 * Simple task queue to sequentialize actions. Assumes
 * callbacks will eventually fire (once).
 */ class $8497c1e3bf13d11c$var$TaskQueue$1 {
    constructor(){
        this.promise = new Promise(function(fulfill) {
            fulfill();
        });
    }
    add(promiseFactory) {
        this.promise = this.promise.catch(function() {
        // just recover
        }).then(function() {
            return promiseFactory();
        });
        return this.promise;
    }
    finish() {
        return this.promise;
    }
}
function $8497c1e3bf13d11c$var$stringify(input) {
    if (!input) return "undefined"; // backwards compat for empty reduce
    // for backwards compat with mapreduce, functions/strings are stringified
    // as-is. everything else is JSON-stringified.
    switch(typeof input){
        case "function":
            // e.g. a mapreduce map
            return input.toString();
        case "string":
            // e.g. a mapreduce built-in _reduce function
            return input.toString();
        default:
            // e.g. a JSON object in the case of mango queries
            return JSON.stringify(input);
    }
}
/* create a string signature for a view so we can cache it and uniq it */ function $8497c1e3bf13d11c$var$createViewSignature(mapFun, reduceFun) {
    // the "undefined" part is for backwards compatibility
    return $8497c1e3bf13d11c$var$stringify(mapFun) + $8497c1e3bf13d11c$var$stringify(reduceFun) + "undefined";
}
async function $8497c1e3bf13d11c$var$createView(sourceDB, viewName, mapFun, reduceFun, temporary, localDocName) {
    const viewSignature = $8497c1e3bf13d11c$var$createViewSignature(mapFun, reduceFun);
    let cachedViews;
    if (!temporary) {
        // cache this to ensure we don't try to update the same view twice
        cachedViews = sourceDB._cachedViews = sourceDB._cachedViews || {};
        if (cachedViews[viewSignature]) return cachedViews[viewSignature];
    }
    const promiseForView = sourceDB.info().then(async function(info) {
        const depDbName = info.db_name + "-mrview-" + (temporary ? "temp" : $8497c1e3bf13d11c$var$stringMd5(viewSignature));
        // save the view name in the source db so it can be cleaned up if necessary
        // (e.g. when the _design doc is deleted, remove all associated view data)
        function diffFunction(doc) {
            doc.views = doc.views || {};
            let fullViewName = viewName;
            if (fullViewName.indexOf("/") === -1) fullViewName = viewName + "/" + viewName;
            const depDbs = doc.views[fullViewName] = doc.views[fullViewName] || {};
            /* istanbul ignore if */ if (depDbs[depDbName]) return; // no update necessary
            depDbs[depDbName] = true;
            return doc;
        }
        await $8497c1e3bf13d11c$var$upsert(sourceDB, "_local/" + localDocName, diffFunction);
        const res = await sourceDB.registerDependentDatabase(depDbName);
        const db = res.db;
        db.auto_compaction = true;
        const view = {
            name: depDbName,
            db: db,
            sourceDB: sourceDB,
            adapter: sourceDB.adapter,
            mapFun: mapFun,
            reduceFun: reduceFun
        };
        let lastSeqDoc;
        try {
            lastSeqDoc = await view.db.get("_local/lastSeq");
        } catch (err) {
            /* istanbul ignore if */ if (err.status !== 404) throw err;
        }
        view.seq = lastSeqDoc ? lastSeqDoc.seq : 0;
        if (cachedViews) view.db.once("destroyed", function() {
            delete cachedViews[viewSignature];
        });
        return view;
    });
    if (cachedViews) cachedViews[viewSignature] = promiseForView;
    return promiseForView;
}
var $8497c1e3bf13d11c$var$persistentQueues = {};
var $8497c1e3bf13d11c$var$tempViewQueue = new $8497c1e3bf13d11c$var$TaskQueue$1();
var $8497c1e3bf13d11c$var$CHANGES_BATCH_SIZE$1 = 50;
function $8497c1e3bf13d11c$var$parseViewName(name) {
    // can be either 'ddocname/viewname' or just 'viewname'
    // (where the ddoc name is the same)
    return name.indexOf("/") === -1 ? [
        name,
        name
    ] : name.split("/");
}
function $8497c1e3bf13d11c$var$isGenOne(changes) {
    // only return true if the current change is 1-
    // and there are no other leafs
    return changes.length === 1 && /^1-/.test(changes[0].rev);
}
function $8497c1e3bf13d11c$var$emitError(db, e, data) {
    try {
        db.emit("error", e);
    } catch (err) {
        $8497c1e3bf13d11c$var$guardedConsole("error", "The user's map/reduce function threw an uncaught error.\nYou can debug this error by doing:\nmyDatabase.on('error', function (err) { debugger; });\nPlease double-check your map/reduce function.");
        $8497c1e3bf13d11c$var$guardedConsole("error", e, data);
    }
}
/**
 * Returns an "abstract" mapreduce object of the form:
 *
 *   {
 *     query: queryFun,
 *     viewCleanup: viewCleanupFun
 *   }
 *
 * Arguments are:
 *
 * localDoc: string
 *   This is for the local doc that gets saved in order to track the
 *   "dependent" DBs and clean them up for viewCleanup. It should be
 *   unique, so that indexer plugins don't collide with each other.
 * mapper: function (mapFunDef, emit)
 *   Returns a map function based on the mapFunDef, which in the case of
 *   normal map/reduce is just the de-stringified function, but may be
 *   something else, such as an object in the case of pouchdb-find.
 * reducer: function (reduceFunDef)
 *   Ditto, but for reducing. Modules don't have to support reducing
 *   (e.g. pouchdb-find).
 * ddocValidator: function (ddoc, viewName)
 *   Throws an error if the ddoc or viewName is not valid.
 *   This could be a way to communicate to the user that the configuration for the
 *   indexer is invalid.
 */ function $8497c1e3bf13d11c$var$createAbstractMapReduce(localDocName, mapper, reducer, ddocValidator) {
    function tryMap(db, fun, doc) {
        // emit an event if there was an error thrown by a map function.
        // putting try/catches in a single function also avoids deoptimizations.
        try {
            fun(doc);
        } catch (e) {
            $8497c1e3bf13d11c$var$emitError(db, e, {
                fun: fun,
                doc: doc
            });
        }
    }
    function tryReduce(db, fun, keys, values, rereduce) {
        // same as above, but returning the result or an error. there are two separate
        // functions to avoid extra memory allocations since the tryCode() case is used
        // for custom map functions (common) vs this function, which is only used for
        // custom reduce functions (rare)
        try {
            return {
                output: fun(keys, values, rereduce)
            };
        } catch (e) {
            $8497c1e3bf13d11c$var$emitError(db, e, {
                fun: fun,
                keys: keys,
                values: values,
                rereduce: rereduce
            });
            return {
                error: e
            };
        }
    }
    function sortByKeyThenValue(x, y) {
        const keyCompare = $8497c1e3bf13d11c$var$collate(x.key, y.key);
        return keyCompare !== 0 ? keyCompare : $8497c1e3bf13d11c$var$collate(x.value, y.value);
    }
    function sliceResults(results, limit, skip) {
        skip = skip || 0;
        if (typeof limit === "number") return results.slice(skip, limit + skip);
        else if (skip > 0) return results.slice(skip);
        return results;
    }
    function rowToDocId(row) {
        const val = row.value;
        // Users can explicitly specify a joined doc _id, or it
        // defaults to the doc _id that emitted the key/value.
        const docId = val && typeof val === "object" && val._id || row.id;
        return docId;
    }
    function readAttachmentsAsBlobOrBuffer(res) {
        res.rows.forEach(function(row) {
            const atts = row.doc && row.doc._attachments;
            if (!atts) return;
            Object.keys(atts).forEach(function(filename) {
                const att = atts[filename];
                atts[filename].data = $8497c1e3bf13d11c$var$b64ToBluffer(att.data, att.content_type);
            });
        });
    }
    function postprocessAttachments(opts) {
        return function(res) {
            if (opts.include_docs && opts.attachments && opts.binary) readAttachmentsAsBlobOrBuffer(res);
            return res;
        };
    }
    function addHttpParam(paramName, opts, params, asJson) {
        // add an http param from opts to params, optionally json-encoded
        let val = opts[paramName];
        if (typeof val !== "undefined") {
            if (asJson) val = encodeURIComponent(JSON.stringify(val));
            params.push(paramName + "=" + val);
        }
    }
    function coerceInteger(integerCandidate) {
        if (typeof integerCandidate !== "undefined") {
            const asNumber = Number(integerCandidate);
            // prevents e.g. '1foo' or '1.1' being coerced to 1
            if (!isNaN(asNumber) && asNumber === parseInt(integerCandidate, 10)) return asNumber;
            else return integerCandidate;
        }
    }
    function coerceOptions(opts) {
        opts.group_level = coerceInteger(opts.group_level);
        opts.limit = coerceInteger(opts.limit);
        opts.skip = coerceInteger(opts.skip);
        return opts;
    }
    function checkPositiveInteger(number) {
        if (number) {
            if (typeof number !== "number") return new $8497c1e3bf13d11c$var$QueryParseError(`Invalid value for integer: "${number}"`);
            if (number < 0) return new $8497c1e3bf13d11c$var$QueryParseError(`Invalid value for positive integer: "${number}"`);
        }
    }
    function checkQueryParseError(options, fun) {
        const startkeyName = options.descending ? "endkey" : "startkey";
        const endkeyName = options.descending ? "startkey" : "endkey";
        if (typeof options[startkeyName] !== "undefined" && typeof options[endkeyName] !== "undefined" && $8497c1e3bf13d11c$var$collate(options[startkeyName], options[endkeyName]) > 0) throw new $8497c1e3bf13d11c$var$QueryParseError("No rows can match your key range, reverse your start_key and end_key or set {descending : true}");
        else if (fun.reduce && options.reduce !== false) {
            if (options.include_docs) throw new $8497c1e3bf13d11c$var$QueryParseError("{include_docs:true} is invalid for reduce");
            else if (options.keys && options.keys.length > 1 && !options.group && !options.group_level) throw new $8497c1e3bf13d11c$var$QueryParseError("Multi-key fetches for reduce views must use {group: true}");
        }
        [
            "group_level",
            "limit",
            "skip"
        ].forEach(function(optionName) {
            const error = checkPositiveInteger(options[optionName]);
            if (error) throw error;
        });
    }
    async function httpQuery(db, fun, opts) {
        // List of parameters to add to the PUT request
        let params = [];
        let body;
        let method = "GET";
        let ok;
        // If opts.reduce exists and is defined, then add it to the list
        // of parameters.
        // If reduce=false then the results are that of only the map function
        // not the final result of map and reduce.
        addHttpParam("reduce", opts, params);
        addHttpParam("include_docs", opts, params);
        addHttpParam("attachments", opts, params);
        addHttpParam("limit", opts, params);
        addHttpParam("descending", opts, params);
        addHttpParam("group", opts, params);
        addHttpParam("group_level", opts, params);
        addHttpParam("skip", opts, params);
        addHttpParam("stale", opts, params);
        addHttpParam("conflicts", opts, params);
        addHttpParam("startkey", opts, params, true);
        addHttpParam("start_key", opts, params, true);
        addHttpParam("endkey", opts, params, true);
        addHttpParam("end_key", opts, params, true);
        addHttpParam("inclusive_end", opts, params);
        addHttpParam("key", opts, params, true);
        addHttpParam("update_seq", opts, params);
        // Format the list of parameters into a valid URI query string
        params = params.join("&");
        params = params === "" ? "" : "?" + params;
        // If keys are supplied, issue a POST to circumvent GET query string limits
        // see http://wiki.apache.org/couchdb/HTTP_view_API#Querying_Options
        if (typeof opts.keys !== "undefined") {
            const MAX_URL_LENGTH = 2000;
            // according to http://stackoverflow.com/a/417184/680742,
            // the de facto URL length limit is 2000 characters
            const keysAsString = `keys=${encodeURIComponent(JSON.stringify(opts.keys))}`;
            if (keysAsString.length + params.length + 1 <= MAX_URL_LENGTH) // If the keys are short enough, do a GET. we do this to work around
            // Safari not understanding 304s on POSTs (see pouchdb/pouchdb#1239)
            params += (params[0] === "?" ? "&" : "?") + keysAsString;
            else {
                method = "POST";
                if (typeof fun === "string") body = {
                    keys: opts.keys
                };
                else fun.keys = opts.keys;
            }
        }
        // We are referencing a query defined in the design doc
        if (typeof fun === "string") {
            const parts = $8497c1e3bf13d11c$var$parseViewName(fun);
            const response = await db.fetch("_design/" + parts[0] + "/_view/" + parts[1] + params, {
                headers: new $8497c1e3bf13d11c$var$h({
                    "Content-Type": "application/json"
                }),
                method: method,
                body: JSON.stringify(body)
            });
            ok = response.ok;
            // status = response.status;
            const result = await response.json();
            if (!ok) {
                result.status = response.status;
                throw $8497c1e3bf13d11c$var$generateErrorFromResponse(result);
            }
            // fail the entire request if the result contains an error
            result.rows.forEach(function(row) {
                /* istanbul ignore if */ if (row.value && row.value.error && row.value.error === "builtin_reduce_error") throw new Error(row.reason);
            });
            return new Promise(function(resolve) {
                resolve(result);
            }).then(postprocessAttachments(opts));
        }
        // We are using a temporary view, terrible for performance, good for testing
        body = body || {};
        Object.keys(fun).forEach(function(key) {
            if (Array.isArray(fun[key])) body[key] = fun[key];
            else body[key] = fun[key].toString();
        });
        const response = await db.fetch("_temp_view" + params, {
            headers: new $8497c1e3bf13d11c$var$h({
                "Content-Type": "application/json"
            }),
            method: "POST",
            body: JSON.stringify(body)
        });
        ok = response.ok;
        // status = response.status;
        const result = await response.json();
        if (!ok) {
            result.status = response.status;
            throw $8497c1e3bf13d11c$var$generateErrorFromResponse(result);
        }
        return new Promise(function(resolve) {
            resolve(result);
        }).then(postprocessAttachments(opts));
    }
    // custom adapters can define their own api._query
    // and override the default behavior
    /* istanbul ignore next */ function customQuery(db, fun, opts) {
        return new Promise(function(resolve, reject) {
            db._query(fun, opts, function(err, res) {
                if (err) return reject(err);
                resolve(res);
            });
        });
    }
    // custom adapters can define their own api._viewCleanup
    // and override the default behavior
    /* istanbul ignore next */ function customViewCleanup(db) {
        return new Promise(function(resolve, reject) {
            db._viewCleanup(function(err, res) {
                if (err) return reject(err);
                resolve(res);
            });
        });
    }
    function defaultsTo(value) {
        return function(reason) {
            /* istanbul ignore else */ if (reason.status === 404) return value;
            else throw reason;
        };
    }
    // returns a promise for a list of docs to update, based on the input docId.
    // the order doesn't matter, because post-3.2.0, bulkDocs
    // is an atomic operation in all three adapters.
    async function getDocsToPersist(docId, view, docIdsToChangesAndEmits) {
        const metaDocId = "_local/doc_" + docId;
        const defaultMetaDoc = {
            _id: metaDocId,
            keys: []
        };
        const docData = docIdsToChangesAndEmits.get(docId);
        const indexableKeysToKeyValues = docData[0];
        const changes = docData[1];
        function getMetaDoc() {
            if ($8497c1e3bf13d11c$var$isGenOne(changes)) // generation 1, so we can safely assume initial state
            // for performance reasons (avoids unnecessary GETs)
            return Promise.resolve(defaultMetaDoc);
            return view.db.get(metaDocId).catch(defaultsTo(defaultMetaDoc));
        }
        function getKeyValueDocs(metaDoc) {
            if (!metaDoc.keys.length) // no keys, no need for a lookup
            return Promise.resolve({
                rows: []
            });
            return view.db.allDocs({
                keys: metaDoc.keys,
                include_docs: true
            });
        }
        function processKeyValueDocs(metaDoc, kvDocsRes) {
            const kvDocs = [];
            const oldKeys = new $8497c1e3bf13d11c$var$ExportedSet();
            for(let i = 0, len = kvDocsRes.rows.length; i < len; i++){
                const row = kvDocsRes.rows[i];
                const doc = row.doc;
                if (!doc) continue;
                kvDocs.push(doc);
                oldKeys.add(doc._id);
                doc._deleted = !indexableKeysToKeyValues.has(doc._id);
                if (!doc._deleted) {
                    const keyValue = indexableKeysToKeyValues.get(doc._id);
                    if ("value" in keyValue) doc.value = keyValue.value;
                }
            }
            const newKeys = $8497c1e3bf13d11c$var$mapToKeysArray(indexableKeysToKeyValues);
            newKeys.forEach(function(key) {
                if (!oldKeys.has(key)) {
                    // new doc
                    const kvDoc = {
                        _id: key
                    };
                    const keyValue = indexableKeysToKeyValues.get(key);
                    if ("value" in keyValue) kvDoc.value = keyValue.value;
                    kvDocs.push(kvDoc);
                }
            });
            metaDoc.keys = $8497c1e3bf13d11c$var$uniq(newKeys.concat(metaDoc.keys));
            kvDocs.push(metaDoc);
            return kvDocs;
        }
        const metaDoc = await getMetaDoc();
        const keyValueDocs = await getKeyValueDocs(metaDoc);
        return processKeyValueDocs(metaDoc, keyValueDocs);
    }
    function updatePurgeSeq(view) {
        // with this approach, we just assume to have processed all missing purges and write the latest
        // purgeSeq into the _local/purgeSeq doc.
        return view.sourceDB.get("_local/purges").then(function(res) {
            const purgeSeq = res.purgeSeq;
            return view.db.get("_local/purgeSeq").then(function(res) {
                return res._rev;
            }).catch(function(err) {
                if (err.status !== 404) throw err;
                return undefined;
            }).then(function(rev) {
                return view.db.put({
                    _id: "_local/purgeSeq",
                    _rev: rev,
                    purgeSeq: purgeSeq
                });
            });
        }).catch(function(err) {
            if (err.status !== 404) throw err;
        });
    }
    // updates all emitted key/value docs and metaDocs in the mrview database
    // for the given batch of documents from the source database
    function saveKeyValues(view, docIdsToChangesAndEmits, seq) {
        var seqDocId = "_local/lastSeq";
        return view.db.get(seqDocId).catch(defaultsTo({
            _id: seqDocId,
            seq: 0
        })).then(function(lastSeqDoc) {
            var docIds = $8497c1e3bf13d11c$var$mapToKeysArray(docIdsToChangesAndEmits);
            return Promise.all(docIds.map(function(docId) {
                return getDocsToPersist(docId, view, docIdsToChangesAndEmits);
            })).then(function(listOfDocsToPersist) {
                var docsToPersist = $8497c1e3bf13d11c$var$flatten(listOfDocsToPersist);
                lastSeqDoc.seq = seq;
                docsToPersist.push(lastSeqDoc);
                // write all docs in a single operation, update the seq once
                return view.db.bulkDocs({
                    docs: docsToPersist
                });
            })// TODO: this should be placed somewhere else, probably? we're querying both docs twice
            //   (first time when getting the actual purges).
            .then(()=>updatePurgeSeq(view));
        });
    }
    function getQueue(view) {
        const viewName = typeof view === "string" ? view : view.name;
        let queue = $8497c1e3bf13d11c$var$persistentQueues[viewName];
        if (!queue) queue = $8497c1e3bf13d11c$var$persistentQueues[viewName] = new $8497c1e3bf13d11c$var$TaskQueue$1();
        return queue;
    }
    async function updateView(view, opts) {
        return $8497c1e3bf13d11c$var$sequentialize(getQueue(view), function() {
            return updateViewInQueue(view, opts);
        })();
    }
    async function updateViewInQueue(view, opts) {
        // bind the emit function once
        let mapResults;
        let doc;
        let taskId;
        function emit(key, value) {
            const output = {
                id: doc._id,
                key: $8497c1e3bf13d11c$var$normalizeKey(key)
            };
            // Don't explicitly store the value unless it's defined and non-null.
            // This saves on storage space, because often people don't use it.
            if (typeof value !== "undefined" && value !== null) output.value = $8497c1e3bf13d11c$var$normalizeKey(value);
            mapResults.push(output);
        }
        const mapFun = mapper(view.mapFun, emit);
        let currentSeq = view.seq || 0;
        function createTask() {
            return view.sourceDB.info().then(function(info) {
                taskId = view.sourceDB.activeTasks.add({
                    name: "view_indexing",
                    total_items: info.update_seq - currentSeq
                });
            });
        }
        function processChange(docIdsToChangesAndEmits, seq) {
            return function() {
                return saveKeyValues(view, docIdsToChangesAndEmits, seq);
            };
        }
        let indexed_docs = 0;
        const progress = {
            view: view.name,
            indexed_docs: indexed_docs
        };
        view.sourceDB.emit("indexing", progress);
        const queue = new $8497c1e3bf13d11c$var$TaskQueue$1();
        async function processNextBatch() {
            const response = await view.sourceDB.changes({
                return_docs: true,
                conflicts: true,
                include_docs: true,
                style: "all_docs",
                since: currentSeq,
                limit: opts.changes_batch_size
            });
            const purges = await getRecentPurges();
            return processBatch(response, purges);
        }
        function getRecentPurges() {
            return view.db.get("_local/purgeSeq").then(function(res) {
                return res.purgeSeq;
            }).catch(function(err) {
                if (err && err.status !== 404) throw err;
                return -1;
            }).then(function(purgeSeq) {
                return view.sourceDB.get("_local/purges").then(function(res) {
                    const recentPurges = res.purges.filter(function(purge, index) {
                        return index > purgeSeq;
                    }).map((purge)=>purge.docId);
                    const uniquePurges = recentPurges.filter(function(docId, index) {
                        return recentPurges.indexOf(docId) === index;
                    });
                    return Promise.all(uniquePurges.map(function(docId) {
                        return view.sourceDB.get(docId).then(function(doc) {
                            return {
                                docId: docId,
                                doc: doc
                            };
                        }).catch(function(err) {
                            if (err.status !== 404) throw err;
                            return {
                                docId: docId
                            };
                        });
                    }));
                }).catch(function(err) {
                    if (err && err.status !== 404) throw err;
                    return [];
                });
            });
        }
        function processBatch(response, purges) {
            var results = response.results;
            if (!results.length && !purges.length) return;
            for (let purge of purges){
                const index = results.findIndex(function(change) {
                    return change.id === purge.docId;
                });
                if (index < 0) {
                    // mimic a db.remove() on the changes feed
                    const entry = {
                        _id: purge.docId,
                        doc: {
                            _id: purge.docId,
                            _deleted: 1
                        },
                        changes: []
                    };
                    if (purge.doc) {
                        // update with new winning rev after purge
                        entry.doc = purge.doc;
                        entry.changes.push({
                            rev: purge.doc._rev
                        });
                    }
                    results.push(entry);
                }
            }
            var docIdsToChangesAndEmits = createDocIdsToChangesAndEmits(results);
            queue.add(processChange(docIdsToChangesAndEmits, currentSeq));
            indexed_docs = indexed_docs + results.length;
            const progress = {
                view: view.name,
                last_seq: response.last_seq,
                results_count: results.length,
                indexed_docs: indexed_docs
            };
            view.sourceDB.emit("indexing", progress);
            view.sourceDB.activeTasks.update(taskId, {
                completed_items: indexed_docs
            });
            if (results.length < opts.changes_batch_size) return;
            return processNextBatch();
        }
        function createDocIdsToChangesAndEmits(results) {
            const docIdsToChangesAndEmits = new $8497c1e3bf13d11c$var$ExportedMap();
            for(let i = 0, len = results.length; i < len; i++){
                const change = results[i];
                if (change.doc._id[0] !== "_") {
                    mapResults = [];
                    doc = change.doc;
                    if (!doc._deleted) tryMap(view.sourceDB, mapFun, doc);
                    mapResults.sort(sortByKeyThenValue);
                    const indexableKeysToKeyValues = createIndexableKeysToKeyValues(mapResults);
                    docIdsToChangesAndEmits.set(change.doc._id, [
                        indexableKeysToKeyValues,
                        change.changes
                    ]);
                }
                currentSeq = change.seq;
            }
            return docIdsToChangesAndEmits;
        }
        function createIndexableKeysToKeyValues(mapResults) {
            const indexableKeysToKeyValues = new $8497c1e3bf13d11c$var$ExportedMap();
            let lastKey;
            for(let i = 0, len = mapResults.length; i < len; i++){
                const emittedKeyValue = mapResults[i];
                const complexKey = [
                    emittedKeyValue.key,
                    emittedKeyValue.id
                ];
                if (i > 0 && $8497c1e3bf13d11c$var$collate(emittedKeyValue.key, lastKey) === 0) complexKey.push(i); // dup key+id, so make it unique
                indexableKeysToKeyValues.set($8497c1e3bf13d11c$var$toIndexableString(complexKey), emittedKeyValue);
                lastKey = emittedKeyValue.key;
            }
            return indexableKeysToKeyValues;
        }
        try {
            await createTask();
            await processNextBatch();
            await queue.finish();
            view.seq = currentSeq;
            view.sourceDB.activeTasks.remove(taskId);
        } catch (error) {
            view.sourceDB.activeTasks.remove(taskId, error);
        }
    }
    function reduceView(view, results, options) {
        if (options.group_level === 0) delete options.group_level;
        const shouldGroup = options.group || options.group_level;
        const reduceFun = reducer(view.reduceFun);
        const groups = [];
        const lvl = isNaN(options.group_level) ? Number.POSITIVE_INFINITY : options.group_level;
        results.forEach(function(e) {
            const last = groups[groups.length - 1];
            let groupKey = shouldGroup ? e.key : null;
            // only set group_level for array keys
            if (shouldGroup && Array.isArray(groupKey)) groupKey = groupKey.slice(0, lvl);
            if (last && $8497c1e3bf13d11c$var$collate(last.groupKey, groupKey) === 0) {
                last.keys.push([
                    e.key,
                    e.id
                ]);
                last.values.push(e.value);
                return;
            }
            groups.push({
                keys: [
                    [
                        e.key,
                        e.id
                    ]
                ],
                values: [
                    e.value
                ],
                groupKey: groupKey
            });
        });
        results = [];
        for(let i = 0, len = groups.length; i < len; i++){
            const e = groups[i];
            const reduceTry = tryReduce(view.sourceDB, reduceFun, e.keys, e.values, false);
            if (reduceTry.error && reduceTry.error instanceof $8497c1e3bf13d11c$var$BuiltInError) // CouchDB returns an error if a built-in errors out
            throw reduceTry.error;
            results.push({
                // CouchDB just sets the value to null if a non-built-in errors out
                value: reduceTry.error ? null : reduceTry.output,
                key: e.groupKey
            });
        }
        // no total_rows/offset when reducing
        return {
            rows: sliceResults(results, options.limit, options.skip)
        };
    }
    function queryView(view, opts) {
        return $8497c1e3bf13d11c$var$sequentialize(getQueue(view), function() {
            return queryViewInQueue(view, opts);
        })();
    }
    async function queryViewInQueue(view, opts) {
        let totalRows;
        const shouldReduce = view.reduceFun && opts.reduce !== false;
        const skip = opts.skip || 0;
        if (typeof opts.keys !== "undefined" && !opts.keys.length) {
            // equivalent query
            opts.limit = 0;
            delete opts.keys;
        }
        async function fetchFromView(viewOpts) {
            viewOpts.include_docs = true;
            const res = await view.db.allDocs(viewOpts);
            totalRows = res.total_rows;
            return res.rows.map(function(result) {
                // implicit migration - in older versions of PouchDB,
                // we explicitly stored the doc as {id: ..., key: ..., value: ...}
                // this is tested in a migration test
                /* istanbul ignore next */ if ("value" in result.doc && typeof result.doc.value === "object" && result.doc.value !== null) {
                    const keys = Object.keys(result.doc.value).sort();
                    // this detection method is not perfect, but it's unlikely the user
                    // emitted a value which was an object with these 3 exact keys
                    const expectedKeys = [
                        "id",
                        "key",
                        "value"
                    ];
                    if (!(keys < expectedKeys || keys > expectedKeys)) return result.doc.value;
                }
                const parsedKeyAndDocId = $8497c1e3bf13d11c$var$parseIndexableString(result.doc._id);
                return {
                    key: parsedKeyAndDocId[0],
                    id: parsedKeyAndDocId[1],
                    value: "value" in result.doc ? result.doc.value : null
                };
            });
        }
        async function onMapResultsReady(rows) {
            let finalResults;
            if (shouldReduce) finalResults = reduceView(view, rows, opts);
            else if (typeof opts.keys === "undefined") finalResults = {
                total_rows: totalRows,
                offset: skip,
                rows: rows
            };
            else // support limit, skip for keys query
            finalResults = {
                total_rows: totalRows,
                offset: skip,
                rows: sliceResults(rows, opts.limit, opts.skip)
            };
            /* istanbul ignore if */ if (opts.update_seq) finalResults.update_seq = view.seq;
            if (opts.include_docs) {
                const docIds = $8497c1e3bf13d11c$var$uniq(rows.map(rowToDocId));
                const allDocsRes = await view.sourceDB.allDocs({
                    keys: docIds,
                    include_docs: true,
                    conflicts: opts.conflicts,
                    attachments: opts.attachments,
                    binary: opts.binary
                });
                var docIdsToDocs = new $8497c1e3bf13d11c$var$ExportedMap();
                allDocsRes.rows.forEach(function(row) {
                    docIdsToDocs.set(row.id, row.doc);
                });
                rows.forEach(function(row) {
                    var docId = rowToDocId(row);
                    var doc = docIdsToDocs.get(docId);
                    if (doc) row.doc = doc;
                });
                return finalResults;
            } else return finalResults;
        }
        if (typeof opts.keys !== "undefined") {
            const keys = opts.keys;
            const fetchPromises = keys.map(function(key) {
                const viewOpts = {
                    startkey: $8497c1e3bf13d11c$var$toIndexableString([
                        key
                    ]),
                    endkey: $8497c1e3bf13d11c$var$toIndexableString([
                        key,
                        {}
                    ])
                };
                /* istanbul ignore if */ if (opts.update_seq) viewOpts.update_seq = true;
                return fetchFromView(viewOpts);
            });
            const result = await Promise.all(fetchPromises);
            const flattenedResult = $8497c1e3bf13d11c$var$flatten(result);
            return onMapResultsReady(flattenedResult);
        } else {
            const viewOpts = {
                descending: opts.descending
            };
            /* istanbul ignore if */ if (opts.update_seq) viewOpts.update_seq = true;
            let startkey;
            let endkey;
            if ("start_key" in opts) startkey = opts.start_key;
            if ("startkey" in opts) startkey = opts.startkey;
            if ("end_key" in opts) endkey = opts.end_key;
            if ("endkey" in opts) endkey = opts.endkey;
            if (typeof startkey !== "undefined") viewOpts.startkey = opts.descending ? $8497c1e3bf13d11c$var$toIndexableString([
                startkey,
                {}
            ]) : $8497c1e3bf13d11c$var$toIndexableString([
                startkey
            ]);
            if (typeof endkey !== "undefined") {
                let inclusiveEnd = opts.inclusive_end !== false;
                if (opts.descending) inclusiveEnd = !inclusiveEnd;
                viewOpts.endkey = $8497c1e3bf13d11c$var$toIndexableString(inclusiveEnd ? [
                    endkey,
                    {}
                ] : [
                    endkey
                ]);
            }
            if (typeof opts.key !== "undefined") {
                const keyStart = $8497c1e3bf13d11c$var$toIndexableString([
                    opts.key
                ]);
                const keyEnd = $8497c1e3bf13d11c$var$toIndexableString([
                    opts.key,
                    {}
                ]);
                if (viewOpts.descending) {
                    viewOpts.endkey = keyStart;
                    viewOpts.startkey = keyEnd;
                } else {
                    viewOpts.startkey = keyStart;
                    viewOpts.endkey = keyEnd;
                }
            }
            if (!shouldReduce) {
                if (typeof opts.limit === "number") viewOpts.limit = opts.limit;
                viewOpts.skip = skip;
            }
            const result = await fetchFromView(viewOpts);
            return onMapResultsReady(result);
        }
    }
    async function httpViewCleanup(db) {
        const response = await db.fetch("_view_cleanup", {
            headers: new $8497c1e3bf13d11c$var$h({
                "Content-Type": "application/json"
            }),
            method: "POST"
        });
        return response.json();
    }
    async function localViewCleanup(db) {
        try {
            const metaDoc = await db.get("_local/" + localDocName);
            const docsToViews = new $8497c1e3bf13d11c$var$ExportedMap();
            Object.keys(metaDoc.views).forEach(function(fullViewName) {
                const parts = $8497c1e3bf13d11c$var$parseViewName(fullViewName);
                const designDocName = "_design/" + parts[0];
                const viewName = parts[1];
                let views = docsToViews.get(designDocName);
                if (!views) {
                    views = new $8497c1e3bf13d11c$var$ExportedSet();
                    docsToViews.set(designDocName, views);
                }
                views.add(viewName);
            });
            const opts = {
                keys: $8497c1e3bf13d11c$var$mapToKeysArray(docsToViews),
                include_docs: true
            };
            const res = await db.allDocs(opts);
            const viewsToStatus = {};
            res.rows.forEach(function(row) {
                const ddocName = row.key.substring(8); // cuts off '_design/'
                docsToViews.get(row.key).forEach(function(viewName) {
                    let fullViewName = ddocName + "/" + viewName;
                    /* istanbul ignore if */ if (!metaDoc.views[fullViewName]) // new format, without slashes, to support PouchDB 2.2.0
                    // migration test in pouchdb's browser.migration.js verifies this
                    fullViewName = viewName;
                    const viewDBNames = Object.keys(metaDoc.views[fullViewName]);
                    // design doc deleted, or view function nonexistent
                    const statusIsGood = row.doc && row.doc.views && row.doc.views[viewName];
                    viewDBNames.forEach(function(viewDBName) {
                        viewsToStatus[viewDBName] = viewsToStatus[viewDBName] || statusIsGood;
                    });
                });
            });
            const dbsToDelete = Object.keys(viewsToStatus).filter(function(viewDBName) {
                return !viewsToStatus[viewDBName];
            });
            const destroyPromises = dbsToDelete.map(function(viewDBName) {
                return $8497c1e3bf13d11c$var$sequentialize(getQueue(viewDBName), function() {
                    return new db.constructor(viewDBName, db.__opts).destroy();
                })();
            });
            return Promise.all(destroyPromises).then(function() {
                return {
                    ok: true
                };
            });
        } catch (err) {
            if (err.status === 404) return {
                ok: true
            };
            else throw err;
        }
    }
    async function queryPromised(db, fun, opts) {
        /* istanbul ignore next */ if (typeof db._query === "function") return customQuery(db, fun, opts);
        if ($8497c1e3bf13d11c$var$isRemote(db)) return httpQuery(db, fun, opts);
        const updateViewOpts = {
            changes_batch_size: db.__opts.view_update_changes_batch_size || $8497c1e3bf13d11c$var$CHANGES_BATCH_SIZE$1
        };
        if (typeof fun !== "string") {
            // temp_view
            checkQueryParseError(opts, fun);
            $8497c1e3bf13d11c$var$tempViewQueue.add(async function() {
                const view = await $8497c1e3bf13d11c$var$createView(/* sourceDB */ db, /* viewName */ "temp_view/temp_view", /* mapFun */ fun.map, /* reduceFun */ fun.reduce, /* temporary */ true, /* localDocName */ localDocName);
                return $8497c1e3bf13d11c$var$fin(updateView(view, updateViewOpts).then(function() {
                    return queryView(view, opts);
                }), function() {
                    return view.db.destroy();
                });
            });
            return $8497c1e3bf13d11c$var$tempViewQueue.finish();
        } else {
            // persistent view
            const fullViewName = fun;
            const parts = $8497c1e3bf13d11c$var$parseViewName(fullViewName);
            const designDocName = parts[0];
            const viewName = parts[1];
            const doc = await db.get("_design/" + designDocName);
            fun = doc.views && doc.views[viewName];
            if (!fun) // basic validator; it's assumed that every subclass would want this
            throw new $8497c1e3bf13d11c$var$NotFoundError(`ddoc ${doc._id} has no view named ${viewName}`);
            ddocValidator(doc, viewName);
            checkQueryParseError(opts, fun);
            const view = await $8497c1e3bf13d11c$var$createView(/* sourceDB */ db, /* viewName */ fullViewName, /* mapFun */ fun.map, /* reduceFun */ fun.reduce, /* temporary */ false, /* localDocName */ localDocName);
            if (opts.stale === "ok" || opts.stale === "update_after") {
                if (opts.stale === "update_after") (0, (/*@__PURE__*/$parcel$interopDefault($lRg87)))(function() {
                    updateView(view, updateViewOpts);
                });
                return queryView(view, opts);
            } else {
                await updateView(view, updateViewOpts);
                return queryView(view, opts);
            }
        }
    }
    function abstractQuery(fun, opts, callback) {
        const db = this;
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        opts = opts ? coerceOptions(opts) : {};
        if (typeof fun === "function") fun = {
            map: fun
        };
        const promise = Promise.resolve().then(function() {
            return queryPromised(db, fun, opts);
        });
        $8497c1e3bf13d11c$var$promisedCallback(promise, callback);
        return promise;
    }
    const abstractViewCleanup = $8497c1e3bf13d11c$var$callbackify(function() {
        const db = this;
        /* istanbul ignore next */ if (typeof db._viewCleanup === "function") return customViewCleanup(db);
        if ($8497c1e3bf13d11c$var$isRemote(db)) return httpViewCleanup(db);
        return localViewCleanup(db);
    });
    return {
        query: abstractQuery,
        viewCleanup: abstractViewCleanup
    };
}
var $8497c1e3bf13d11c$var$builtInReduce = {
    _sum: function(keys, values) {
        return $8497c1e3bf13d11c$var$sum(values);
    },
    _count: function(keys, values) {
        return values.length;
    },
    _stats: function(keys, values) {
        // no need to implement rereduce=true, because Pouch
        // will never call it
        function sumsqr(values) {
            var _sumsqr = 0;
            for(var i = 0, len = values.length; i < len; i++){
                var num = values[i];
                _sumsqr += num * num;
            }
            return _sumsqr;
        }
        return {
            sum: $8497c1e3bf13d11c$var$sum(values),
            min: Math.min.apply(null, values),
            max: Math.max.apply(null, values),
            count: values.length,
            sumsqr: sumsqr(values)
        };
    }
};
function $8497c1e3bf13d11c$var$getBuiltIn(reduceFunString) {
    if (/^_sum/.test(reduceFunString)) return $8497c1e3bf13d11c$var$builtInReduce._sum;
    else if (/^_count/.test(reduceFunString)) return $8497c1e3bf13d11c$var$builtInReduce._count;
    else if (/^_stats/.test(reduceFunString)) return $8497c1e3bf13d11c$var$builtInReduce._stats;
    else if (/^_/.test(reduceFunString)) throw new Error(reduceFunString + " is not a supported reduce function.");
}
function $8497c1e3bf13d11c$var$mapper(mapFun, emit) {
    // for temp_views one can use emit(doc, emit), see #38
    if (typeof mapFun === "function" && mapFun.length === 2) {
        var origMap = mapFun;
        return function(doc) {
            return origMap(doc, emit);
        };
    } else return $8497c1e3bf13d11c$var$evalFunctionWithEval(mapFun.toString(), emit);
}
function $8497c1e3bf13d11c$var$reducer(reduceFun) {
    var reduceFunString = reduceFun.toString();
    var builtIn = $8497c1e3bf13d11c$var$getBuiltIn(reduceFunString);
    if (builtIn) return builtIn;
    else return $8497c1e3bf13d11c$var$evalFunctionWithEval(reduceFunString);
}
function $8497c1e3bf13d11c$var$ddocValidator(ddoc, viewName) {
    var fun = ddoc.views && ddoc.views[viewName];
    if (typeof fun.map !== "string") throw new $8497c1e3bf13d11c$var$NotFoundError("ddoc " + ddoc._id + " has no string view named " + viewName + ", instead found object of type: " + typeof fun.map);
}
var $8497c1e3bf13d11c$var$localDocName = "mrviews";
var $8497c1e3bf13d11c$var$abstract = $8497c1e3bf13d11c$var$createAbstractMapReduce($8497c1e3bf13d11c$var$localDocName, $8497c1e3bf13d11c$var$mapper, $8497c1e3bf13d11c$var$reducer, $8497c1e3bf13d11c$var$ddocValidator);
function $8497c1e3bf13d11c$var$query(fun, opts, callback) {
    return $8497c1e3bf13d11c$var$abstract.query.call(this, fun, opts, callback);
}
function $8497c1e3bf13d11c$var$viewCleanup(callback) {
    return $8497c1e3bf13d11c$var$abstract.viewCleanup.call(this, callback);
}
var $8497c1e3bf13d11c$var$mapreduce = {
    query: $8497c1e3bf13d11c$var$query,
    viewCleanup: $8497c1e3bf13d11c$var$viewCleanup
};
function $8497c1e3bf13d11c$var$fileHasChanged(localDoc, remoteDoc, filename) {
    return !localDoc._attachments || !localDoc._attachments[filename] || localDoc._attachments[filename].digest !== remoteDoc._attachments[filename].digest;
}
function $8497c1e3bf13d11c$var$getDocAttachments(db, doc) {
    var filenames = Object.keys(doc._attachments);
    return Promise.all(filenames.map(function(filename) {
        return db.getAttachment(doc._id, filename, {
            rev: doc._rev
        });
    }));
}
function $8497c1e3bf13d11c$var$getDocAttachmentsFromTargetOrSource(target, src, doc) {
    var doCheckForLocalAttachments = $8497c1e3bf13d11c$var$isRemote(src) && !$8497c1e3bf13d11c$var$isRemote(target);
    var filenames = Object.keys(doc._attachments);
    if (!doCheckForLocalAttachments) return $8497c1e3bf13d11c$var$getDocAttachments(src, doc);
    return target.get(doc._id).then(function(localDoc) {
        return Promise.all(filenames.map(function(filename) {
            if ($8497c1e3bf13d11c$var$fileHasChanged(localDoc, doc, filename)) return src.getAttachment(doc._id, filename);
            return target.getAttachment(localDoc._id, filename);
        }));
    }).catch(function(error) {
        /* istanbul ignore if */ if (error.status !== 404) throw error;
        return $8497c1e3bf13d11c$var$getDocAttachments(src, doc);
    });
}
function $8497c1e3bf13d11c$var$createBulkGetOpts(diffs) {
    var requests = [];
    Object.keys(diffs).forEach(function(id) {
        var missingRevs = diffs[id].missing;
        missingRevs.forEach(function(missingRev) {
            requests.push({
                id: id,
                rev: missingRev
            });
        });
    });
    return {
        docs: requests,
        revs: true,
        latest: true
    };
}
//
// Fetch all the documents from the src as described in the "diffs",
// which is a mapping of docs IDs to revisions. If the state ever
// changes to "cancelled", then the returned promise will be rejected.
// Else it will be resolved with a list of fetched documents.
//
function $8497c1e3bf13d11c$var$getDocs(src, target, diffs, state) {
    diffs = $8497c1e3bf13d11c$var$clone(diffs); // we do not need to modify this
    var resultDocs = [], ok = true;
    function getAllDocs() {
        var bulkGetOpts = $8497c1e3bf13d11c$var$createBulkGetOpts(diffs);
        if (!bulkGetOpts.docs.length) return;
        return src.bulkGet(bulkGetOpts).then(function(bulkGetResponse) {
            /* istanbul ignore if */ if (state.cancelled) throw new Error("cancelled");
            return Promise.all(bulkGetResponse.results.map(function(bulkGetInfo) {
                return Promise.all(bulkGetInfo.docs.map(function(doc) {
                    var remoteDoc = doc.ok;
                    if (doc.error) // when AUTO_COMPACTION is set, docs can be returned which look
                    // like this: {"missing":"1-7c3ac256b693c462af8442f992b83696"}
                    ok = false;
                    if (!remoteDoc || !remoteDoc._attachments) return remoteDoc;
                    return $8497c1e3bf13d11c$var$getDocAttachmentsFromTargetOrSource(target, src, remoteDoc).then(function(attachments) {
                        var filenames = Object.keys(remoteDoc._attachments);
                        attachments.forEach(function(attachment, i) {
                            var att = remoteDoc._attachments[filenames[i]];
                            delete att.stub;
                            delete att.length;
                            att.data = attachment;
                        });
                        return remoteDoc;
                    });
                }));
            })).then(function(results) {
                resultDocs = resultDocs.concat($8497c1e3bf13d11c$var$flatten(results).filter(Boolean));
            });
        });
    }
    function returnResult() {
        return {
            ok: ok,
            docs: resultDocs
        };
    }
    return Promise.resolve().then(getAllDocs).then(returnResult);
}
var $8497c1e3bf13d11c$var$CHECKPOINT_VERSION = 1;
var $8497c1e3bf13d11c$var$REPLICATOR = "pouchdb";
// This is an arbitrary number to limit the
// amount of replication history we save in the checkpoint.
// If we save too much, the checkpoing docs will become very big,
// if we save fewer, we'll run a greater risk of having to
// read all the changes from 0 when checkpoint PUTs fail
// CouchDB 2.0 has a more involved history pruning,
// but let's go for the simple version for now.
var $8497c1e3bf13d11c$var$CHECKPOINT_HISTORY_SIZE = 5;
var $8497c1e3bf13d11c$var$LOWEST_SEQ = 0;
function $8497c1e3bf13d11c$var$updateCheckpoint(db, id, checkpoint, session, returnValue) {
    return db.get(id).catch(function(err) {
        if (err.status === 404) {
            if (db.adapter === "http" || db.adapter === "https") $8497c1e3bf13d11c$var$explainError(404, "PouchDB is just checking if a remote checkpoint exists.");
            return {
                session_id: session,
                _id: id,
                history: [],
                replicator: $8497c1e3bf13d11c$var$REPLICATOR,
                version: $8497c1e3bf13d11c$var$CHECKPOINT_VERSION
            };
        }
        throw err;
    }).then(function(doc) {
        if (returnValue.cancelled) return;
        // if the checkpoint has not changed, do not update
        if (doc.last_seq === checkpoint) return;
        // Filter out current entry for this replication
        doc.history = (doc.history || []).filter(function(item) {
            return item.session_id !== session;
        });
        // Add the latest checkpoint to history
        doc.history.unshift({
            last_seq: checkpoint,
            session_id: session
        });
        // Just take the last pieces in history, to
        // avoid really big checkpoint docs.
        // see comment on history size above
        doc.history = doc.history.slice(0, $8497c1e3bf13d11c$var$CHECKPOINT_HISTORY_SIZE);
        doc.version = $8497c1e3bf13d11c$var$CHECKPOINT_VERSION;
        doc.replicator = $8497c1e3bf13d11c$var$REPLICATOR;
        doc.session_id = session;
        doc.last_seq = checkpoint;
        return db.put(doc).catch(function(err) {
            if (err.status === 409) // retry; someone is trying to write a checkpoint simultaneously
            return $8497c1e3bf13d11c$var$updateCheckpoint(db, id, checkpoint, session, returnValue);
            throw err;
        });
    });
}
class $8497c1e3bf13d11c$var$CheckpointerInternal {
    constructor(src, target, id, returnValue, opts){
        this.src = src;
        this.target = target;
        this.id = id;
        this.returnValue = returnValue;
        this.opts = opts || {};
    }
    writeCheckpoint(checkpoint, session) {
        var self1 = this;
        return this.updateTarget(checkpoint, session).then(function() {
            return self1.updateSource(checkpoint, session);
        });
    }
    updateTarget(checkpoint, session) {
        if (this.opts.writeTargetCheckpoint) return $8497c1e3bf13d11c$var$updateCheckpoint(this.target, this.id, checkpoint, session, this.returnValue);
        else return Promise.resolve(true);
    }
    updateSource(checkpoint, session) {
        if (this.opts.writeSourceCheckpoint) {
            var self1 = this;
            return $8497c1e3bf13d11c$var$updateCheckpoint(this.src, this.id, checkpoint, session, this.returnValue).catch(function(err) {
                if ($8497c1e3bf13d11c$var$isForbiddenError(err)) {
                    self1.opts.writeSourceCheckpoint = false;
                    return true;
                }
                throw err;
            });
        } else return Promise.resolve(true);
    }
    getCheckpoint() {
        var self1 = this;
        if (self1.opts && self1.opts.writeSourceCheckpoint && !self1.opts.writeTargetCheckpoint) return self1.src.get(self1.id).then(function(sourceDoc) {
            return sourceDoc.last_seq || $8497c1e3bf13d11c$var$LOWEST_SEQ;
        }).catch(function(err) {
            /* istanbul ignore if */ if (err.status !== 404) throw err;
            return $8497c1e3bf13d11c$var$LOWEST_SEQ;
        });
        return self1.target.get(self1.id).then(function(targetDoc) {
            if (self1.opts && self1.opts.writeTargetCheckpoint && !self1.opts.writeSourceCheckpoint) return targetDoc.last_seq || $8497c1e3bf13d11c$var$LOWEST_SEQ;
            return self1.src.get(self1.id).then(function(sourceDoc) {
                // Since we can't migrate an old version doc to a new one
                // (no session id), we just go with the lowest seq in this case
                /* istanbul ignore if */ if (targetDoc.version !== sourceDoc.version) return $8497c1e3bf13d11c$var$LOWEST_SEQ;
                var version;
                if (targetDoc.version) version = targetDoc.version.toString();
                else version = "undefined";
                if (version in $8497c1e3bf13d11c$var$comparisons) return $8497c1e3bf13d11c$var$comparisons[version](targetDoc, sourceDoc);
                /* istanbul ignore next */ return $8497c1e3bf13d11c$var$LOWEST_SEQ;
            }, function(err) {
                if (err.status === 404 && targetDoc.last_seq) return self1.src.put({
                    _id: self1.id,
                    last_seq: $8497c1e3bf13d11c$var$LOWEST_SEQ
                }).then(function() {
                    return $8497c1e3bf13d11c$var$LOWEST_SEQ;
                }, function(err) {
                    if ($8497c1e3bf13d11c$var$isForbiddenError(err)) {
                        self1.opts.writeSourceCheckpoint = false;
                        return targetDoc.last_seq;
                    }
                    /* istanbul ignore next */ return $8497c1e3bf13d11c$var$LOWEST_SEQ;
                });
                throw err;
            });
        }).catch(function(err) {
            if (err.status !== 404) throw err;
            return $8497c1e3bf13d11c$var$LOWEST_SEQ;
        });
    }
}
var $8497c1e3bf13d11c$var$comparisons = {
    "undefined": function(targetDoc, sourceDoc) {
        // This is the previous comparison function
        if ($8497c1e3bf13d11c$var$collate(targetDoc.last_seq, sourceDoc.last_seq) === 0) return sourceDoc.last_seq;
        /* istanbul ignore next */ return 0;
    },
    "1": function(targetDoc, sourceDoc) {
        // This is the comparison function ported from CouchDB
        return $8497c1e3bf13d11c$var$compareReplicationLogs(sourceDoc, targetDoc).last_seq;
    }
};
// This checkpoint comparison is ported from CouchDBs source
// they come from here:
// https://github.com/apache/couchdb-couch-replicator/blob/master/src/couch_replicator.erl#L863-L906
function $8497c1e3bf13d11c$var$compareReplicationLogs(srcDoc, tgtDoc) {
    if (srcDoc.session_id === tgtDoc.session_id) return {
        last_seq: srcDoc.last_seq,
        history: srcDoc.history
    };
    return $8497c1e3bf13d11c$var$compareReplicationHistory(srcDoc.history, tgtDoc.history);
}
function $8497c1e3bf13d11c$var$compareReplicationHistory(sourceHistory, targetHistory) {
    // the erlang loop via function arguments is not so easy to repeat in JS
    // therefore, doing this as recursion
    var S = sourceHistory[0];
    var sourceRest = sourceHistory.slice(1);
    var T = targetHistory[0];
    var targetRest = targetHistory.slice(1);
    if (!S || targetHistory.length === 0) return {
        last_seq: $8497c1e3bf13d11c$var$LOWEST_SEQ,
        history: []
    };
    var sourceId = S.session_id;
    /* istanbul ignore if */ if ($8497c1e3bf13d11c$var$hasSessionId(sourceId, targetHistory)) return {
        last_seq: S.last_seq,
        history: sourceHistory
    };
    var targetId = T.session_id;
    if ($8497c1e3bf13d11c$var$hasSessionId(targetId, sourceRest)) return {
        last_seq: T.last_seq,
        history: targetRest
    };
    return $8497c1e3bf13d11c$var$compareReplicationHistory(sourceRest, targetRest);
}
function $8497c1e3bf13d11c$var$hasSessionId(sessionId, history) {
    var props = history[0];
    var rest = history.slice(1);
    if (!sessionId || history.length === 0) return false;
    if (sessionId === props.session_id) return true;
    return $8497c1e3bf13d11c$var$hasSessionId(sessionId, rest);
}
function $8497c1e3bf13d11c$var$isForbiddenError(err) {
    return typeof err.status === "number" && Math.floor(err.status / 100) === 4;
}
function $8497c1e3bf13d11c$var$Checkpointer(src, target, id, returnValue, opts) {
    if (!(this instanceof $8497c1e3bf13d11c$var$CheckpointerInternal)) return new $8497c1e3bf13d11c$var$CheckpointerInternal(src, target, id, returnValue, opts);
    return $8497c1e3bf13d11c$var$Checkpointer;
}
var $8497c1e3bf13d11c$var$STARTING_BACK_OFF = 0;
function $8497c1e3bf13d11c$var$backOff(opts, returnValue, error, callback) {
    if (opts.retry === false) {
        returnValue.emit("error", error);
        returnValue.removeAllListeners();
        return;
    }
    /* istanbul ignore if */ if (typeof opts.back_off_function !== "function") opts.back_off_function = $8497c1e3bf13d11c$var$defaultBackOff;
    returnValue.emit("requestError", error);
    if (returnValue.state === "active" || returnValue.state === "pending") {
        returnValue.emit("paused", error);
        returnValue.state = "stopped";
        var backOffSet = function backoffTimeSet() {
            opts.current_back_off = $8497c1e3bf13d11c$var$STARTING_BACK_OFF;
        };
        var removeBackOffSetter = function removeBackOffTimeSet() {
            returnValue.removeListener("active", backOffSet);
        };
        returnValue.once("paused", removeBackOffSetter);
        returnValue.once("active", backOffSet);
    }
    opts.current_back_off = opts.current_back_off || $8497c1e3bf13d11c$var$STARTING_BACK_OFF;
    opts.current_back_off = opts.back_off_function(opts.current_back_off);
    setTimeout(callback, opts.current_back_off);
}
function $8497c1e3bf13d11c$var$sortObjectPropertiesByKey(queryParams) {
    return Object.keys(queryParams).sort($8497c1e3bf13d11c$var$collate).reduce(function(result, key) {
        result[key] = queryParams[key];
        return result;
    }, {});
}
// Generate a unique id particular to this replication.
// Not guaranteed to align perfectly with CouchDB's rep ids.
function $8497c1e3bf13d11c$var$generateReplicationId(src, target, opts) {
    var docIds = opts.doc_ids ? opts.doc_ids.sort($8497c1e3bf13d11c$var$collate) : "";
    var filterFun = opts.filter ? opts.filter.toString() : "";
    var queryParams = "";
    var filterViewName = "";
    var selector = "";
    // possibility for checkpoints to be lost here as behaviour of
    // JSON.stringify is not stable (see #6226)
    /* istanbul ignore if */ if (opts.selector) selector = JSON.stringify(opts.selector);
    if (opts.filter && opts.query_params) queryParams = JSON.stringify($8497c1e3bf13d11c$var$sortObjectPropertiesByKey(opts.query_params));
    if (opts.filter && opts.filter === "_view") filterViewName = opts.view.toString();
    return Promise.all([
        src.id(),
        target.id()
    ]).then(function(res) {
        var queryData = res[0] + res[1] + filterFun + filterViewName + queryParams + docIds + selector;
        return new Promise(function(resolve) {
            $8497c1e3bf13d11c$var$binaryMd5(queryData, resolve);
        });
    }).then(function(md5sum) {
        // can't use straight-up md5 alphabet, because
        // the char '/' is interpreted as being for attachments,
        // and + is also not url-safe
        md5sum = md5sum.replace(/\//g, ".").replace(/\+/g, "_");
        return "_local/" + md5sum;
    });
}
function $8497c1e3bf13d11c$var$replicate(src, target, opts, returnValue, result) {
    var batches = []; // list of batches to be processed
    var currentBatch; // the batch currently being processed
    var pendingBatch = {
        seq: 0,
        changes: [],
        docs: []
    }; // next batch, not yet ready to be processed
    var writingCheckpoint = false; // true while checkpoint is being written
    var changesCompleted = false; // true when all changes received
    var replicationCompleted = false; // true when replication has completed
    // initial_last_seq is the state of the source db before
    // replication started, and it is _not_ updated during
    // replication or used anywhere else, as opposed to last_seq
    var initial_last_seq = 0;
    var last_seq = 0;
    var continuous = opts.continuous || opts.live || false;
    var batch_size = opts.batch_size || 100;
    var batches_limit = opts.batches_limit || 10;
    var style = opts.style || "all_docs";
    var changesPending = false; // true while src.changes is running
    var doc_ids = opts.doc_ids;
    var selector = opts.selector;
    var repId;
    var checkpointer;
    var changedDocs = [];
    // Like couchdb, every replication gets a unique session id
    var session = $8497c1e3bf13d11c$var$uuid();
    var taskId;
    result = result || {
        ok: true,
        start_time: new Date().toISOString(),
        docs_read: 0,
        docs_written: 0,
        doc_write_failures: 0,
        errors: []
    };
    var changesOpts = {};
    returnValue.ready(src, target);
    function initCheckpointer() {
        if (checkpointer) return Promise.resolve();
        return $8497c1e3bf13d11c$var$generateReplicationId(src, target, opts).then(function(res) {
            repId = res;
            var checkpointOpts = {};
            if (opts.checkpoint === false) checkpointOpts = {
                writeSourceCheckpoint: false,
                writeTargetCheckpoint: false
            };
            else if (opts.checkpoint === "source") checkpointOpts = {
                writeSourceCheckpoint: true,
                writeTargetCheckpoint: false
            };
            else if (opts.checkpoint === "target") checkpointOpts = {
                writeSourceCheckpoint: false,
                writeTargetCheckpoint: true
            };
            else checkpointOpts = {
                writeSourceCheckpoint: true,
                writeTargetCheckpoint: true
            };
            checkpointer = new $8497c1e3bf13d11c$var$Checkpointer(src, target, repId, returnValue, checkpointOpts);
        });
    }
    function writeDocs() {
        changedDocs = [];
        if (currentBatch.docs.length === 0) return;
        var docs = currentBatch.docs;
        var bulkOpts = {
            timeout: opts.timeout
        };
        return target.bulkDocs({
            docs: docs,
            new_edits: false
        }, bulkOpts).then(function(res) {
            /* istanbul ignore if */ if (returnValue.cancelled) {
                completeReplication();
                throw new Error("cancelled");
            }
            // `res` doesn't include full documents (which live in `docs`), so we create a map of
            // (id -> error), and check for errors while iterating over `docs`
            var errorsById = Object.create(null);
            res.forEach(function(res) {
                if (res.error) errorsById[res.id] = res;
            });
            var errorsNo = Object.keys(errorsById).length;
            result.doc_write_failures += errorsNo;
            result.docs_written += docs.length - errorsNo;
            docs.forEach(function(doc) {
                var error = errorsById[doc._id];
                if (error) {
                    result.errors.push(error);
                    // Normalize error name. i.e. 'Unauthorized' -> 'unauthorized' (eg Sync Gateway)
                    var errorName = (error.name || "").toLowerCase();
                    if (errorName === "unauthorized" || errorName === "forbidden") returnValue.emit("denied", $8497c1e3bf13d11c$var$clone(error));
                    else throw error;
                } else changedDocs.push(doc);
            });
        }, function(err) {
            result.doc_write_failures += docs.length;
            throw err;
        });
    }
    function finishBatch() {
        if (currentBatch.error) throw new Error("There was a problem getting docs.");
        result.last_seq = last_seq = currentBatch.seq;
        var outResult = $8497c1e3bf13d11c$var$clone(result);
        if (changedDocs.length) {
            outResult.docs = changedDocs;
            // Attach 'pending' property if server supports it (CouchDB 2.0+)
            /* istanbul ignore if */ if (typeof currentBatch.pending === "number") {
                outResult.pending = currentBatch.pending;
                delete currentBatch.pending;
            }
            returnValue.emit("change", outResult);
        }
        writingCheckpoint = true;
        src.info().then(function(info) {
            var task = src.activeTasks.get(taskId);
            if (!currentBatch || !task) return;
            var completed = task.completed_items || 0;
            var total_items = parseInt(info.update_seq, 10) - parseInt(initial_last_seq, 10);
            src.activeTasks.update(taskId, {
                completed_items: completed + currentBatch.changes.length,
                total_items: total_items
            });
        });
        return checkpointer.writeCheckpoint(currentBatch.seq, session).then(function() {
            returnValue.emit("checkpoint", {
                "checkpoint": currentBatch.seq
            });
            writingCheckpoint = false;
            /* istanbul ignore if */ if (returnValue.cancelled) {
                completeReplication();
                throw new Error("cancelled");
            }
            currentBatch = undefined;
            getChanges();
        }).catch(function(err) {
            onCheckpointError(err);
            throw err;
        });
    }
    function getDiffs() {
        var diff = {};
        currentBatch.changes.forEach(function(change) {
            returnValue.emit("checkpoint", {
                "revs_diff": change
            });
            // Couchbase Sync Gateway emits these, but we can ignore them
            /* istanbul ignore if */ if (change.id === "_user/") return;
            diff[change.id] = change.changes.map(function(x) {
                return x.rev;
            });
        });
        return target.revsDiff(diff).then(function(diffs) {
            /* istanbul ignore if */ if (returnValue.cancelled) {
                completeReplication();
                throw new Error("cancelled");
            }
            // currentBatch.diffs elements are deleted as the documents are written
            currentBatch.diffs = diffs;
        });
    }
    function getBatchDocs() {
        return $8497c1e3bf13d11c$var$getDocs(src, target, currentBatch.diffs, returnValue).then(function(got) {
            currentBatch.error = !got.ok;
            got.docs.forEach(function(doc) {
                delete currentBatch.diffs[doc._id];
                result.docs_read++;
                currentBatch.docs.push(doc);
            });
        });
    }
    function startNextBatch() {
        if (returnValue.cancelled || currentBatch) return;
        if (batches.length === 0) {
            processPendingBatch(true);
            return;
        }
        currentBatch = batches.shift();
        returnValue.emit("checkpoint", {
            "start_next_batch": currentBatch.seq
        });
        getDiffs().then(getBatchDocs).then(writeDocs).then(finishBatch).then(startNextBatch).catch(function(err) {
            abortReplication("batch processing terminated with error", err);
        });
    }
    function processPendingBatch(immediate$$1) {
        if (pendingBatch.changes.length === 0) {
            if (batches.length === 0 && !currentBatch) {
                if (continuous && changesOpts.live || changesCompleted) {
                    returnValue.state = "pending";
                    returnValue.emit("paused");
                }
                if (changesCompleted) completeReplication();
            }
            return;
        }
        if (immediate$$1 || changesCompleted || pendingBatch.changes.length >= batch_size) {
            batches.push(pendingBatch);
            pendingBatch = {
                seq: 0,
                changes: [],
                docs: []
            };
            if (returnValue.state === "pending" || returnValue.state === "stopped") {
                returnValue.state = "active";
                returnValue.emit("active");
            }
            startNextBatch();
        }
    }
    function abortReplication(reason, err) {
        if (replicationCompleted) return;
        if (!err.message) err.message = reason;
        result.ok = false;
        result.status = "aborting";
        batches = [];
        pendingBatch = {
            seq: 0,
            changes: [],
            docs: []
        };
        completeReplication(err);
    }
    function completeReplication(fatalError) {
        if (replicationCompleted) return;
        /* istanbul ignore if */ if (returnValue.cancelled) {
            result.status = "cancelled";
            if (writingCheckpoint) return;
        }
        result.status = result.status || "complete";
        result.end_time = new Date().toISOString();
        result.last_seq = last_seq;
        replicationCompleted = true;
        src.activeTasks.remove(taskId, fatalError);
        if (fatalError) {
            // need to extend the error because Firefox considers ".result" read-only
            fatalError = $8497c1e3bf13d11c$var$createError(fatalError);
            fatalError.result = result;
            // Normalize error name. i.e. 'Unauthorized' -> 'unauthorized' (eg Sync Gateway)
            var errorName = (fatalError.name || "").toLowerCase();
            if (errorName === "unauthorized" || errorName === "forbidden") {
                returnValue.emit("error", fatalError);
                returnValue.removeAllListeners();
            } else $8497c1e3bf13d11c$var$backOff(opts, returnValue, fatalError, function() {
                $8497c1e3bf13d11c$var$replicate(src, target, opts, returnValue);
            });
        } else {
            returnValue.emit("complete", result);
            returnValue.removeAllListeners();
        }
    }
    function onChange(change, pending, lastSeq) {
        /* istanbul ignore if */ if (returnValue.cancelled) return completeReplication();
        // Attach 'pending' property if server supports it (CouchDB 2.0+)
        /* istanbul ignore if */ if (typeof pending === "number") pendingBatch.pending = pending;
        var filter = $8497c1e3bf13d11c$var$filterChange(opts)(change);
        if (!filter) {
            // update processed items count by 1
            var task = src.activeTasks.get(taskId);
            if (task) {
                // we can assume that task exists here? shouldn't be deleted by here.
                var completed = task.completed_items || 0;
                src.activeTasks.update(taskId, {
                    completed_items: ++completed
                });
            }
            return;
        }
        pendingBatch.seq = change.seq || lastSeq;
        pendingBatch.changes.push(change);
        returnValue.emit("checkpoint", {
            "pending_batch": pendingBatch.seq
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($lRg87)))(function() {
            processPendingBatch(batches.length === 0 && changesOpts.live);
        });
    }
    function onChangesComplete(changes) {
        changesPending = false;
        /* istanbul ignore if */ if (returnValue.cancelled) return completeReplication();
        // if no results were returned then we're done,
        // else fetch more
        if (changes.results.length > 0) {
            changesOpts.since = changes.results[changes.results.length - 1].seq;
            getChanges();
            processPendingBatch(true);
        } else {
            var complete = function() {
                if (continuous) {
                    changesOpts.live = true;
                    getChanges();
                } else changesCompleted = true;
                processPendingBatch(true);
            };
            // update the checkpoint so we start from the right seq next time
            if (!currentBatch && changes.results.length === 0) {
                writingCheckpoint = true;
                checkpointer.writeCheckpoint(changes.last_seq, session).then(function() {
                    writingCheckpoint = false;
                    result.last_seq = last_seq = changes.last_seq;
                    if (returnValue.cancelled) {
                        completeReplication();
                        throw new Error("cancelled");
                    } else complete();
                }).catch(onCheckpointError);
            } else complete();
        }
    }
    function onChangesError(err) {
        changesPending = false;
        /* istanbul ignore if */ if (returnValue.cancelled) return completeReplication();
        abortReplication("changes rejected", err);
    }
    function getChanges() {
        if (!(!changesPending && !changesCompleted && batches.length < batches_limit)) return;
        changesPending = true;
        function abortChanges() {
            changes.cancel();
        }
        function removeListener() {
            returnValue.removeListener("cancel", abortChanges);
        }
        if (returnValue._changes) {
            returnValue.removeListener("cancel", returnValue._abortChanges);
            returnValue._changes.cancel();
        }
        returnValue.once("cancel", abortChanges);
        var changes = src.changes(changesOpts).on("change", onChange);
        changes.then(removeListener, removeListener);
        changes.then(onChangesComplete).catch(onChangesError);
        if (opts.retry) {
            // save for later so we can cancel if necessary
            returnValue._changes = changes;
            returnValue._abortChanges = abortChanges;
        }
    }
    function createTask(checkpoint) {
        return src.info().then(function(info) {
            var total_items = typeof opts.since === "undefined" ? parseInt(info.update_seq, 10) - parseInt(checkpoint, 10) : parseInt(info.update_seq, 10);
            taskId = src.activeTasks.add({
                name: `${continuous ? "continuous " : ""}replication from ${info.db_name}`,
                total_items: total_items
            });
            return checkpoint;
        });
    }
    function startChanges() {
        initCheckpointer().then(function() {
            /* istanbul ignore if */ if (returnValue.cancelled) {
                completeReplication();
                return;
            }
            return checkpointer.getCheckpoint().then(createTask).then(function(checkpoint) {
                last_seq = checkpoint;
                initial_last_seq = checkpoint;
                changesOpts = {
                    since: last_seq,
                    limit: batch_size,
                    batch_size: batch_size,
                    style: style,
                    doc_ids: doc_ids,
                    selector: selector,
                    return_docs: true // required so we know when we're done
                };
                if (opts.filter) {
                    if (typeof opts.filter !== "string") // required for the client-side filter in onChange
                    changesOpts.include_docs = true;
                    else changesOpts.filter = opts.filter;
                }
                if ("heartbeat" in opts) changesOpts.heartbeat = opts.heartbeat;
                if ("timeout" in opts) changesOpts.timeout = opts.timeout;
                if (opts.query_params) changesOpts.query_params = opts.query_params;
                if (opts.view) changesOpts.view = opts.view;
                getChanges();
            });
        }).catch(function(err) {
            abortReplication("getCheckpoint rejected with ", err);
        });
    }
    /* istanbul ignore next */ function onCheckpointError(err) {
        writingCheckpoint = false;
        abortReplication("writeCheckpoint completed with error", err);
    }
    /* istanbul ignore if */ if (returnValue.cancelled) {
        completeReplication();
        return;
    }
    if (!returnValue._addedListeners) {
        returnValue.once("cancel", completeReplication);
        if (typeof opts.complete === "function") {
            returnValue.once("error", opts.complete);
            returnValue.once("complete", function(result) {
                opts.complete(null, result);
            });
        }
        returnValue._addedListeners = true;
    }
    if (typeof opts.since === "undefined") startChanges();
    else initCheckpointer().then(function() {
        writingCheckpoint = true;
        return checkpointer.writeCheckpoint(opts.since, session);
    }).then(function() {
        writingCheckpoint = false;
        /* istanbul ignore if */ if (returnValue.cancelled) {
            completeReplication();
            return;
        }
        last_seq = opts.since;
        startChanges();
    }).catch(onCheckpointError);
}
// We create a basic promise so the caller can cancel the replication possibly
// before we have actually started listening to changes etc
class $8497c1e3bf13d11c$var$Replication extends (0, (/*@__PURE__*/$parcel$interopDefault($dG33B))) {
    constructor(){
        super();
        this.cancelled = false;
        this.state = "pending";
        const promise = new Promise((fulfill, reject)=>{
            this.once("complete", fulfill);
            this.once("error", reject);
        });
        this.then = function(resolve, reject) {
            return promise.then(resolve, reject);
        };
        this.catch = function(reject) {
            return promise.catch(reject);
        };
        // As we allow error handling via "error" event as well,
        // put a stub in here so that rejecting never throws UnhandledError.
        this.catch(function() {});
    }
    cancel() {
        this.cancelled = true;
        this.state = "cancelled";
        this.emit("cancel");
    }
    ready(src, target) {
        if (this._readyCalled) return;
        this._readyCalled = true;
        const onDestroy = ()=>{
            this.cancel();
        };
        src.once("destroyed", onDestroy);
        target.once("destroyed", onDestroy);
        function cleanup() {
            src.removeListener("destroyed", onDestroy);
            target.removeListener("destroyed", onDestroy);
        }
        this.once("complete", cleanup);
        this.once("error", cleanup);
    }
}
function $8497c1e3bf13d11c$var$toPouch(db, opts) {
    var PouchConstructor = opts.PouchConstructor;
    if (typeof db === "string") return new PouchConstructor(db, opts);
    else return db;
}
function $8497c1e3bf13d11c$var$replicateWrapper(src, target, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    if (typeof opts === "undefined") opts = {};
    if (opts.doc_ids && !Array.isArray(opts.doc_ids)) throw $8497c1e3bf13d11c$var$createError($8497c1e3bf13d11c$var$BAD_REQUEST, "`doc_ids` filter parameter is not a list.");
    opts.complete = callback;
    opts = $8497c1e3bf13d11c$var$clone(opts);
    opts.continuous = opts.continuous || opts.live;
    opts.retry = "retry" in opts ? opts.retry : false;
    /*jshint validthis:true */ opts.PouchConstructor = opts.PouchConstructor || this;
    var replicateRet = new $8497c1e3bf13d11c$var$Replication(opts);
    var srcPouch = $8497c1e3bf13d11c$var$toPouch(src, opts);
    var targetPouch = $8497c1e3bf13d11c$var$toPouch(target, opts);
    $8497c1e3bf13d11c$var$replicate(srcPouch, targetPouch, opts, replicateRet);
    return replicateRet;
}
function $8497c1e3bf13d11c$var$sync(src, target, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    if (typeof opts === "undefined") opts = {};
    opts = $8497c1e3bf13d11c$var$clone(opts);
    /*jshint validthis:true */ opts.PouchConstructor = opts.PouchConstructor || this;
    src = $8497c1e3bf13d11c$var$toPouch(src, opts);
    target = $8497c1e3bf13d11c$var$toPouch(target, opts);
    return new $8497c1e3bf13d11c$var$Sync(src, target, opts, callback);
}
class $8497c1e3bf13d11c$var$Sync extends (0, (/*@__PURE__*/$parcel$interopDefault($dG33B))) {
    constructor(src, target, opts, callback){
        super();
        this.canceled = false;
        const optsPush = opts.push ? $8497c1e3bf13d11c$var$$inject_Object_assign({}, opts, opts.push) : opts;
        const optsPull = opts.pull ? $8497c1e3bf13d11c$var$$inject_Object_assign({}, opts, opts.pull) : opts;
        this.push = $8497c1e3bf13d11c$var$replicateWrapper(src, target, optsPush);
        this.pull = $8497c1e3bf13d11c$var$replicateWrapper(target, src, optsPull);
        this.pushPaused = true;
        this.pullPaused = true;
        const pullChange = (change)=>{
            this.emit("change", {
                direction: "pull",
                change: change
            });
        };
        const pushChange = (change)=>{
            this.emit("change", {
                direction: "push",
                change: change
            });
        };
        const pushDenied = (doc)=>{
            this.emit("denied", {
                direction: "push",
                doc: doc
            });
        };
        const pullDenied = (doc)=>{
            this.emit("denied", {
                direction: "pull",
                doc: doc
            });
        };
        const pushPaused = ()=>{
            this.pushPaused = true;
            /* istanbul ignore if */ if (this.pullPaused) this.emit("paused");
        };
        const pullPaused = ()=>{
            this.pullPaused = true;
            /* istanbul ignore if */ if (this.pushPaused) this.emit("paused");
        };
        const pushActive = ()=>{
            this.pushPaused = false;
            /* istanbul ignore if */ if (this.pullPaused) this.emit("active", {
                direction: "push"
            });
        };
        const pullActive = ()=>{
            this.pullPaused = false;
            /* istanbul ignore if */ if (this.pushPaused) this.emit("active", {
                direction: "pull"
            });
        };
        let removed = {};
        const removeAll = (type)=>{
            return (event, func)=>{
                const isChange = event === "change" && (func === pullChange || func === pushChange);
                const isDenied = event === "denied" && (func === pullDenied || func === pushDenied);
                const isPaused = event === "paused" && (func === pullPaused || func === pushPaused);
                const isActive = event === "active" && (func === pullActive || func === pushActive);
                if (isChange || isDenied || isPaused || isActive) {
                    if (!(event in removed)) removed[event] = {};
                    removed[event][type] = true;
                    if (Object.keys(removed[event]).length === 2) // both push and pull have asked to be removed
                    this.removeAllListeners(event);
                }
            };
        };
        if (opts.live) {
            this.push.on("complete", this.pull.cancel.bind(this.pull));
            this.pull.on("complete", this.push.cancel.bind(this.push));
        }
        function addOneListener(ee, event, listener) {
            if (ee.listeners(event).indexOf(listener) == -1) ee.on(event, listener);
        }
        this.on("newListener", function(event) {
            if (event === "change") {
                addOneListener(this.pull, "change", pullChange);
                addOneListener(this.push, "change", pushChange);
            } else if (event === "denied") {
                addOneListener(this.pull, "denied", pullDenied);
                addOneListener(this.push, "denied", pushDenied);
            } else if (event === "active") {
                addOneListener(this.pull, "active", pullActive);
                addOneListener(this.push, "active", pushActive);
            } else if (event === "paused") {
                addOneListener(this.pull, "paused", pullPaused);
                addOneListener(this.push, "paused", pushPaused);
            }
        });
        this.on("removeListener", function(event) {
            if (event === "change") {
                this.pull.removeListener("change", pullChange);
                this.push.removeListener("change", pushChange);
            } else if (event === "denied") {
                this.pull.removeListener("denied", pullDenied);
                this.push.removeListener("denied", pushDenied);
            } else if (event === "active") {
                this.pull.removeListener("active", pullActive);
                this.push.removeListener("active", pushActive);
            } else if (event === "paused") {
                this.pull.removeListener("paused", pullPaused);
                this.push.removeListener("paused", pushPaused);
            }
        });
        this.pull.on("removeListener", removeAll("pull"));
        this.push.on("removeListener", removeAll("push"));
        const promise = Promise.all([
            this.push,
            this.pull
        ]).then((resp)=>{
            const out = {
                push: resp[0],
                pull: resp[1]
            };
            this.emit("complete", out);
            if (callback) callback(null, out);
            this.removeAllListeners();
            return out;
        }, (err)=>{
            this.cancel();
            if (callback) // if there's a callback, then the callback can receive
            // the error event
            callback(err);
            else // if there's no callback, then we're safe to emit an error
            // event, which would otherwise throw an unhandled error
            // due to 'error' being a special event in EventEmitters
            this.emit("error", err);
            this.removeAllListeners();
            if (callback) // no sense throwing if we're already emitting an 'error' event
            throw err;
        });
        this.then = function(success, err) {
            return promise.then(success, err);
        };
        this.catch = function(err) {
            return promise.catch(err);
        };
    }
    cancel() {
        if (!this.canceled) {
            this.canceled = true;
            this.push.cancel();
            this.pull.cancel();
        }
    }
}
function $8497c1e3bf13d11c$var$replication(PouchDB) {
    PouchDB.replicate = $8497c1e3bf13d11c$var$replicateWrapper;
    PouchDB.sync = $8497c1e3bf13d11c$var$sync;
    Object.defineProperty(PouchDB.prototype, "replicate", {
        get: function() {
            var self1 = this;
            if (typeof this.replicateMethods === "undefined") this.replicateMethods = {
                from: function(other, opts, callback) {
                    return self1.constructor.replicate(other, self1, opts, callback);
                },
                to: function(other, opts, callback) {
                    return self1.constructor.replicate(self1, other, opts, callback);
                }
            };
            return this.replicateMethods;
        }
    });
    PouchDB.prototype.sync = function(dbName, opts, callback) {
        return this.constructor.sync(this, dbName, opts, callback);
    };
}
$8497c1e3bf13d11c$var$PouchDB.plugin($8497c1e3bf13d11c$var$IDBPouch).plugin($8497c1e3bf13d11c$var$HttpPouch$1).plugin($8497c1e3bf13d11c$var$mapreduce).plugin($8497c1e3bf13d11c$var$replication);
var $8497c1e3bf13d11c$export$2e2bcd8739ae039 = $8497c1e3bf13d11c$var$PouchDB;

});
parcelRegister("lRg87", function(module, exports) {
"use strict";






var $fe9b0f46da0385c7$var$types = [
    (parcelRequire("1wVs5")),
    (parcelRequire("bGuJ7")),
    (parcelRequire("bfK9h")),
    (parcelRequire("2yr8y")),
    (parcelRequire("QPv8t")),
    (parcelRequire("Dqbd4"))
];
var $fe9b0f46da0385c7$var$draining;
var $fe9b0f46da0385c7$var$currentQueue;
var $fe9b0f46da0385c7$var$queueIndex = -1;
var $fe9b0f46da0385c7$var$queue = [];
var $fe9b0f46da0385c7$var$scheduled = false;
function $fe9b0f46da0385c7$var$cleanUpNextTick() {
    if (!$fe9b0f46da0385c7$var$draining || !$fe9b0f46da0385c7$var$currentQueue) return;
    $fe9b0f46da0385c7$var$draining = false;
    if ($fe9b0f46da0385c7$var$currentQueue.length) $fe9b0f46da0385c7$var$queue = $fe9b0f46da0385c7$var$currentQueue.concat($fe9b0f46da0385c7$var$queue);
    else $fe9b0f46da0385c7$var$queueIndex = -1;
    if ($fe9b0f46da0385c7$var$queue.length) $fe9b0f46da0385c7$var$nextTick();
}
//named nextTick for less confusing stack traces
function $fe9b0f46da0385c7$var$nextTick() {
    if ($fe9b0f46da0385c7$var$draining) return;
    $fe9b0f46da0385c7$var$scheduled = false;
    $fe9b0f46da0385c7$var$draining = true;
    var len = $fe9b0f46da0385c7$var$queue.length;
    var timeout = setTimeout($fe9b0f46da0385c7$var$cleanUpNextTick);
    while(len){
        $fe9b0f46da0385c7$var$currentQueue = $fe9b0f46da0385c7$var$queue;
        $fe9b0f46da0385c7$var$queue = [];
        while($fe9b0f46da0385c7$var$currentQueue && ++$fe9b0f46da0385c7$var$queueIndex < len)$fe9b0f46da0385c7$var$currentQueue[$fe9b0f46da0385c7$var$queueIndex].run();
        $fe9b0f46da0385c7$var$queueIndex = -1;
        len = $fe9b0f46da0385c7$var$queue.length;
    }
    $fe9b0f46da0385c7$var$currentQueue = null;
    $fe9b0f46da0385c7$var$queueIndex = -1;
    $fe9b0f46da0385c7$var$draining = false;
    clearTimeout(timeout);
}
var $fe9b0f46da0385c7$var$scheduleDrain;
var $fe9b0f46da0385c7$var$i = -1;
var $fe9b0f46da0385c7$var$len = $fe9b0f46da0385c7$var$types.length;
while(++$fe9b0f46da0385c7$var$i < $fe9b0f46da0385c7$var$len)if ($fe9b0f46da0385c7$var$types[$fe9b0f46da0385c7$var$i] && $fe9b0f46da0385c7$var$types[$fe9b0f46da0385c7$var$i].test && $fe9b0f46da0385c7$var$types[$fe9b0f46da0385c7$var$i].test()) {
    $fe9b0f46da0385c7$var$scheduleDrain = $fe9b0f46da0385c7$var$types[$fe9b0f46da0385c7$var$i].install($fe9b0f46da0385c7$var$nextTick);
    break;
}
// v8 likes predictible objects
function $fe9b0f46da0385c7$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$fe9b0f46da0385c7$var$Item.prototype.run = function() {
    var fun = this.fun;
    var array = this.array;
    switch(array.length){
        case 0:
            return fun();
        case 1:
            return fun(array[0]);
        case 2:
            return fun(array[0], array[1]);
        case 3:
            return fun(array[0], array[1], array[2]);
        default:
            return fun.apply(null, array);
    }
};
module.exports = $fe9b0f46da0385c7$var$immediate;
function $fe9b0f46da0385c7$var$immediate(task) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $fe9b0f46da0385c7$var$queue.push(new $fe9b0f46da0385c7$var$Item(task, args));
    if (!$fe9b0f46da0385c7$var$scheduled && !$fe9b0f46da0385c7$var$draining) {
        $fe9b0f46da0385c7$var$scheduled = true;
        $fe9b0f46da0385c7$var$scheduleDrain();
    }
}

});
parcelRegister("1wVs5", function(module, exports) {
"use strict";

});

parcelRegister("bGuJ7", function(module, exports) {

$parcel$export(module.exports, "test", function () { return $881b73a87368e553$export$e0969da9b8fb378d; }, function (v) { return $881b73a87368e553$export$e0969da9b8fb378d = v; });
$parcel$export(module.exports, "install", function () { return $881b73a87368e553$export$4b3e715f166fdd78; }, function (v) { return $881b73a87368e553$export$4b3e715f166fdd78 = v; });
var $881b73a87368e553$export$e0969da9b8fb378d;
var $881b73a87368e553$export$4b3e715f166fdd78;
"use strict";
$881b73a87368e553$export$e0969da9b8fb378d = function() {
    return typeof $parcel$global.queueMicrotask === "function";
};
$881b73a87368e553$export$4b3e715f166fdd78 = function(func) {
    return function() {
        $parcel$global.queueMicrotask(func);
    };
};

});

parcelRegister("bfK9h", function(module, exports) {

$parcel$export(module.exports, "test", function () { return $8314e49b06cce342$export$e0969da9b8fb378d; }, function (v) { return $8314e49b06cce342$export$e0969da9b8fb378d = v; });
$parcel$export(module.exports, "install", function () { return $8314e49b06cce342$export$4b3e715f166fdd78; }, function (v) { return $8314e49b06cce342$export$4b3e715f166fdd78 = v; });
var $8314e49b06cce342$export$e0969da9b8fb378d;
var $8314e49b06cce342$export$4b3e715f166fdd78;
"use strict";
//based off rsvp https://github.com/tildeio/rsvp.js
//license https://github.com/tildeio/rsvp.js/blob/master/LICENSE
//https://github.com/tildeio/rsvp.js/blob/master/lib/rsvp/asap.js
var $8314e49b06cce342$var$Mutation = $parcel$global.MutationObserver || $parcel$global.WebKitMutationObserver;
$8314e49b06cce342$export$e0969da9b8fb378d = function() {
    return $8314e49b06cce342$var$Mutation;
};
$8314e49b06cce342$export$4b3e715f166fdd78 = function(handle) {
    var called = 0;
    var observer = new $8314e49b06cce342$var$Mutation(handle);
    var element = $parcel$global.document.createTextNode("");
    observer.observe(element, {
        characterData: true
    });
    return function() {
        element.data = called = ++called % 2;
    };
};

});

parcelRegister("2yr8y", function(module, exports) {

$parcel$export(module.exports, "test", function () { return $1dc3ce901b3e9195$export$e0969da9b8fb378d; }, function (v) { return $1dc3ce901b3e9195$export$e0969da9b8fb378d = v; });
$parcel$export(module.exports, "install", function () { return $1dc3ce901b3e9195$export$4b3e715f166fdd78; }, function (v) { return $1dc3ce901b3e9195$export$4b3e715f166fdd78 = v; });
var $1dc3ce901b3e9195$export$e0969da9b8fb378d;
var $1dc3ce901b3e9195$export$4b3e715f166fdd78;
"use strict";
$1dc3ce901b3e9195$export$e0969da9b8fb378d = function() {
    if ($parcel$global.setImmediate) // we can only get here in IE10
    // which doesn't handel postMessage well
    return false;
    return typeof $parcel$global.MessageChannel !== "undefined";
};
$1dc3ce901b3e9195$export$4b3e715f166fdd78 = function(func) {
    var channel = new $parcel$global.MessageChannel();
    channel.port1.onmessage = func;
    return function() {
        channel.port2.postMessage(0);
    };
};

});

parcelRegister("QPv8t", function(module, exports) {

$parcel$export(module.exports, "test", function () { return $09ecce819b2e69b7$export$e0969da9b8fb378d; }, function (v) { return $09ecce819b2e69b7$export$e0969da9b8fb378d = v; });
$parcel$export(module.exports, "install", function () { return $09ecce819b2e69b7$export$4b3e715f166fdd78; }, function (v) { return $09ecce819b2e69b7$export$4b3e715f166fdd78 = v; });
var $09ecce819b2e69b7$export$e0969da9b8fb378d;
var $09ecce819b2e69b7$export$4b3e715f166fdd78;
"use strict";
$09ecce819b2e69b7$export$e0969da9b8fb378d = function() {
    return "document" in $parcel$global && "onreadystatechange" in $parcel$global.document.createElement("script");
};
$09ecce819b2e69b7$export$4b3e715f166fdd78 = function(handle) {
    return function() {
        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
        var scriptEl = $parcel$global.document.createElement("script");
        scriptEl.onreadystatechange = function() {
            handle();
            scriptEl.onreadystatechange = null;
            scriptEl.parentNode.removeChild(scriptEl);
            scriptEl = null;
        };
        $parcel$global.document.documentElement.appendChild(scriptEl);
        return handle;
    };
};

});

parcelRegister("Dqbd4", function(module, exports) {

$parcel$export(module.exports, "test", function () { return $0767f3657de4bddc$export$e0969da9b8fb378d; }, function (v) { return $0767f3657de4bddc$export$e0969da9b8fb378d = v; });
$parcel$export(module.exports, "install", function () { return $0767f3657de4bddc$export$4b3e715f166fdd78; }, function (v) { return $0767f3657de4bddc$export$4b3e715f166fdd78 = v; });
var $0767f3657de4bddc$export$e0969da9b8fb378d;
var $0767f3657de4bddc$export$4b3e715f166fdd78;
"use strict";
$0767f3657de4bddc$export$e0969da9b8fb378d = function() {
    return true;
};
$0767f3657de4bddc$export$4b3e715f166fdd78 = function(t) {
    return function() {
        setTimeout(t, 0);
    };
};

});


parcelRegister("3jkdm", function(module, exports) {
(function(factory) {
    var glob, e;
    // Node/CommonJS
    module.exports = factory();
})(function(undefined) {
    "use strict";
    /*
     * Fastest md5 implementation around (JKM md5).
     * Credits: Joseph Myers
     *
     * @see http://www.myersdaily.org/joseph/javascript/md5-text.html
     * @see http://jsperf.com/md5-shootout/7
     */ /* this function is much faster,
      so if possible we use it. Some IEs
      are the only ones I know of that
      need the idiotic second function,
      generated by an if clause.  */ var add32 = function(a, b) {
        return a + b & 0xFFFFFFFF;
    }, hex_chr = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f"
    ];
    function cmn(q, a, b, x, s, t) {
        a = add32(add32(a, q), add32(x, t));
        return add32(a << s | a >>> 32 - s, b);
    }
    function md5cycle(x, k) {
        var a = x[0], b = x[1], c = x[2], d = x[3];
        a += (b & c | ~b & d) + k[0] - 680876936 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[1] - 389564586 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[2] + 606105819 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[4] - 176418897 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[7] - 45705983 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[10] - 42063 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[13] - 40341101 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & d | c & ~d) + k[1] - 165796510 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[11] + 643717713 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[0] - 373897302 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[5] - 701558691 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[10] + 38016083 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[15] - 660478335 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[4] - 405537848 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[9] + 568446438 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[3] - 187363961 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[2] - 51403784 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b ^ c ^ d) + k[5] - 378558 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[14] - 35309556 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[7] - 155497632 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[13] + 681279174 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[0] - 358537222 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[3] - 722521979 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[6] + 76029189 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[9] - 640364487 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[12] - 421815835 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[15] + 530742520 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[2] - 995338651 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        x[0] = a + x[0] | 0;
        x[1] = b + x[1] | 0;
        x[2] = c + x[2] | 0;
        x[3] = d + x[3] | 0;
    }
    function md5blk(s) {
        var md5blks = [], i; /* Andy King said do it this way. */ 
        for(i = 0; i < 64; i += 4)md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
        return md5blks;
    }
    function md5blk_array(a) {
        var md5blks = [], i; /* Andy King said do it this way. */ 
        for(i = 0; i < 64; i += 4)md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
        return md5blks;
    }
    function md51(s) {
        var n = s.length, state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ], i, length, tail, tmp, lo, hi;
        for(i = 64; i <= n; i += 64)md5cycle(state, md5blk(s.substring(i - 64, i)));
        s = s.substring(i - 64);
        length = s.length;
        tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < length; i += 1)tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(state, tail);
        return state;
    }
    function md51_array(a) {
        var n = a.length, state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ], i, length, tail, tmp, lo, hi;
        for(i = 64; i <= n; i += 64)md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
        // Not sure if it is a bug, however IE10 will always produce a sub array of length 1
        // containing the last element of the parent array if the sub array specified starts
        // beyond the length of the parent array - weird.
        // https://connect.microsoft.com/IE/feedback/details/771452/typed-array-subarray-issue
        a = i - 64 < n ? a.subarray(i - 64) : new Uint8Array(0);
        length = a.length;
        tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < length; i += 1)tail[i >> 2] |= a[i] << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(state, tail);
        return state;
    }
    function rhex(n) {
        var s = "", j;
        for(j = 0; j < 4; j += 1)s += hex_chr[n >> j * 8 + 4 & 0x0F] + hex_chr[n >> j * 8 & 0x0F];
        return s;
    }
    function hex(x) {
        var i;
        for(i = 0; i < x.length; i += 1)x[i] = rhex(x[i]);
        return x.join("");
    }
    // In some cases the fast add32 function cannot be used..
    if (hex(md51("hello")) !== "5d41402abc4b2a76b9719d911017c592") add32 = function(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xFFFF;
    };
    // ---------------------------------------------------
    /**
     * ArrayBuffer slice polyfill.
     *
     * @see https://github.com/ttaubert/node-arraybuffer-slice
     */ if (typeof ArrayBuffer !== "undefined" && !ArrayBuffer.prototype.slice) (function() {
        function clamp(val, length) {
            val = val | 0 || 0;
            if (val < 0) return Math.max(val + length, 0);
            return Math.min(val, length);
        }
        ArrayBuffer.prototype.slice = function(from, to) {
            var length = this.byteLength, begin = clamp(from, length), end = length, num, target, targetArray, sourceArray;
            if (to !== undefined) end = clamp(to, length);
            if (begin > end) return new ArrayBuffer(0);
            num = end - begin;
            target = new ArrayBuffer(num);
            targetArray = new Uint8Array(target);
            sourceArray = new Uint8Array(this, begin, num);
            targetArray.set(sourceArray);
            return target;
        };
    })();
    // ---------------------------------------------------
    /**
     * Helpers.
     */ function toUtf8(str) {
        if (/[\u0080-\uFFFF]/.test(str)) str = unescape(encodeURIComponent(str));
        return str;
    }
    function utf8Str2ArrayBuffer(str, returnUInt8Array) {
        var length = str.length, buff = new ArrayBuffer(length), arr = new Uint8Array(buff), i;
        for(i = 0; i < length; i += 1)arr[i] = str.charCodeAt(i);
        return returnUInt8Array ? arr : buff;
    }
    function arrayBuffer2Utf8Str(buff) {
        return String.fromCharCode.apply(null, new Uint8Array(buff));
    }
    function concatenateArrayBuffers(first, second, returnUInt8Array) {
        var result = new Uint8Array(first.byteLength + second.byteLength);
        result.set(new Uint8Array(first));
        result.set(new Uint8Array(second), first.byteLength);
        return returnUInt8Array ? result : result.buffer;
    }
    function hexToBinaryString(hex) {
        var bytes = [], length = hex.length, x;
        for(x = 0; x < length - 1; x += 2)bytes.push(parseInt(hex.substr(x, 2), 16));
        return String.fromCharCode.apply(String, bytes);
    }
    // ---------------------------------------------------
    /**
     * SparkMD5 OOP implementation.
     *
     * Use this class to perform an incremental md5, otherwise use the
     * static methods instead.
     */ function SparkMD5() {
        // call reset to init the instance
        this.reset();
    }
    /**
     * Appends a string.
     * A conversion will be applied if an utf8 string is detected.
     *
     * @param {String} str The string to be appended
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.append = function(str) {
        // Converts the string to utf8 bytes if necessary
        // Then append as binary
        this.appendBinary(toUtf8(str));
        return this;
    };
    /**
     * Appends a binary string.
     *
     * @param {String} contents The binary string to be appended
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.appendBinary = function(contents) {
        this._buff += contents;
        this._length += contents.length;
        var length = this._buff.length, i;
        for(i = 64; i <= length; i += 64)md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
        this._buff = this._buff.substring(i - 64);
        return this;
    };
    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.prototype.end = function(raw) {
        var buff = this._buff, length = buff.length, i, tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], ret;
        for(i = 0; i < length; i += 1)tail[i >> 2] |= buff.charCodeAt(i) << (i % 4 << 3);
        this._finish(tail, length);
        ret = hex(this._hash);
        if (raw) ret = hexToBinaryString(ret);
        this.reset();
        return ret;
    };
    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.reset = function() {
        this._buff = "";
        this._length = 0;
        this._hash = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        return this;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */ SparkMD5.prototype.getState = function() {
        return {
            buff: this._buff,
            length: this._length,
            hash: this._hash.slice()
        };
    };
    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.setState = function(state) {
        this._buff = state.buff;
        this._length = state.length;
        this._hash = state.hash;
        return this;
    };
    /**
     * Releases memory used by the incremental buffer and other additional
     * resources. If you plan to use the instance again, use reset instead.
     */ SparkMD5.prototype.destroy = function() {
        delete this._hash;
        delete this._buff;
        delete this._length;
    };
    /**
     * Finish the final calculation based on the tail.
     *
     * @param {Array}  tail   The tail (will be modified)
     * @param {Number} length The length of the remaining buffer
     */ SparkMD5.prototype._finish = function(tail, length) {
        var i = length, tmp, lo, hi;
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(this._hash, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Do the final computation based on the tail and length
        // Beware that the final length may not fit in 32 bits so we take care of that
        tmp = this._length * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(this._hash, tail);
    };
    /**
     * Performs the md5 hash on a string.
     * A conversion will be applied if utf8 string is detected.
     *
     * @param {String}  str The string
     * @param {Boolean} [raw] True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.hash = function(str, raw) {
        // Converts the string to utf8 bytes if necessary
        // Then compute it using the binary function
        return SparkMD5.hashBinary(toUtf8(str), raw);
    };
    /**
     * Performs the md5 hash on a binary string.
     *
     * @param {String}  content The binary string
     * @param {Boolean} [raw]     True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.hashBinary = function(content, raw) {
        var hash = md51(content), ret = hex(hash);
        return raw ? hexToBinaryString(ret) : ret;
    };
    // ---------------------------------------------------
    /**
     * SparkMD5 OOP implementation for array buffers.
     *
     * Use this class to perform an incremental md5 ONLY for array buffers.
     */ SparkMD5.ArrayBuffer = function() {
        // call reset to init the instance
        this.reset();
    };
    /**
     * Appends an array buffer.
     *
     * @param {ArrayBuffer} arr The array to be appended
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.append = function(arr) {
        var buff = concatenateArrayBuffers(this._buff.buffer, arr, true), length = buff.length, i;
        this._length += arr.byteLength;
        for(i = 64; i <= length; i += 64)md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
        this._buff = i - 64 < length ? new Uint8Array(buff.buffer.slice(i - 64)) : new Uint8Array(0);
        return this;
    };
    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.ArrayBuffer.prototype.end = function(raw) {
        var buff = this._buff, length = buff.length, tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], i, ret;
        for(i = 0; i < length; i += 1)tail[i >> 2] |= buff[i] << (i % 4 << 3);
        this._finish(tail, length);
        ret = hex(this._hash);
        if (raw) ret = hexToBinaryString(ret);
        this.reset();
        return ret;
    };
    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.reset = function() {
        this._buff = new Uint8Array(0);
        this._length = 0;
        this._hash = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        return this;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */ SparkMD5.ArrayBuffer.prototype.getState = function() {
        var state = SparkMD5.prototype.getState.call(this);
        // Convert buffer to a string
        state.buff = arrayBuffer2Utf8Str(state.buff);
        return state;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.setState = function(state) {
        // Convert string to buffer
        state.buff = utf8Str2ArrayBuffer(state.buff, true);
        return SparkMD5.prototype.setState.call(this, state);
    };
    SparkMD5.ArrayBuffer.prototype.destroy = SparkMD5.prototype.destroy;
    SparkMD5.ArrayBuffer.prototype._finish = SparkMD5.prototype._finish;
    /**
     * Performs the md5 hash on an array buffer.
     *
     * @param {ArrayBuffer} arr The array buffer
     * @param {Boolean}     [raw] True to get the raw string, false to get the hex one
     *
     * @return {String} The result
     */ SparkMD5.ArrayBuffer.hash = function(arr, raw) {
        var hash = md51_array(new Uint8Array(arr)), ret = hex(hash);
        return raw ? hexToBinaryString(ret) : ret;
    };
    return SparkMD5;
});

});

parcelRegister("hTj76", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0666643e2ee88b4$export$2e2bcd8739ae039; });

var $eabBn = parcelRequire("eabBn");

var $6evQb = parcelRequire("6evQb");
function $d0666643e2ee88b4$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $eabBn.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $6evQb.default)(rnds);
}
var $d0666643e2ee88b4$export$2e2bcd8739ae039 = $d0666643e2ee88b4$var$v4;

});
parcelRegister("eabBn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4faffbfed8ce8b6$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $a4faffbfed8ce8b6$var$getRandomValues;
var $a4faffbfed8ce8b6$var$rnds8 = new Uint8Array(16);
function $a4faffbfed8ce8b6$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$a4faffbfed8ce8b6$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $a4faffbfed8ce8b6$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$a4faffbfed8ce8b6$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $a4faffbfed8ce8b6$var$getRandomValues($a4faffbfed8ce8b6$var$rnds8);
}

});

parcelRegister("6evQb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $489cbfc69d38cb8e$export$2e2bcd8739ae039; });

var $ccUSO = parcelRequire("ccUSO");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $489cbfc69d38cb8e$var$byteToHex = [];
for(var $489cbfc69d38cb8e$var$i = 0; $489cbfc69d38cb8e$var$i < 256; ++$489cbfc69d38cb8e$var$i)$489cbfc69d38cb8e$var$byteToHex.push(($489cbfc69d38cb8e$var$i + 0x100).toString(16).substr(1));
function $489cbfc69d38cb8e$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($489cbfc69d38cb8e$var$byteToHex[arr[offset + 0]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 1]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 2]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 3]] + "-" + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 4]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 5]] + "-" + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 6]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 7]] + "-" + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 8]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 9]] + "-" + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 10]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 11]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 12]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 13]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 14]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $ccUSO.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $489cbfc69d38cb8e$export$2e2bcd8739ae039 = $489cbfc69d38cb8e$var$stringify;

});
parcelRegister("ccUSO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e32bacb71dd477f$export$2e2bcd8739ae039; });

var $l3plK = parcelRequire("l3plK");
function $8e32bacb71dd477f$var$validate(uuid) {
    return typeof uuid === "string" && (0, $l3plK.default).test(uuid);
}
var $8e32bacb71dd477f$export$2e2bcd8739ae039 = $8e32bacb71dd477f$var$validate;

});
parcelRegister("l3plK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f53d8abb4c91ec67$export$2e2bcd8739ae039; });
var $f53d8abb4c91ec67$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("6kHnY", function(module, exports) {

$parcel$export(module.exports, "stringify", function () { return $49c643d0d3095734$export$fac44ee5b035f737; }, function (v) { return $49c643d0d3095734$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parse", function () { return $49c643d0d3095734$export$98e6a39c04603d36; }, function (v) { return $49c643d0d3095734$export$98e6a39c04603d36 = v; });
/**
 * Stringify/parse functions that don't operate
 * recursively, so they avoid call stack exceeded
 * errors.
 */ var $49c643d0d3095734$export$fac44ee5b035f737;
var $49c643d0d3095734$export$98e6a39c04603d36;
"use strict";
$49c643d0d3095734$export$fac44ee5b035f737 = function stringify(input) {
    var queue = [];
    queue.push({
        obj: input
    });
    var res = "";
    var next, obj, prefix, val, i, arrayPrefix, keys, k, key, value, objPrefix;
    while(next = queue.pop()){
        obj = next.obj;
        prefix = next.prefix || "";
        val = next.val || "";
        res += prefix;
        if (val) res += val;
        else if (typeof obj !== "object") res += typeof obj === "undefined" ? null : JSON.stringify(obj);
        else if (obj === null) res += "null";
        else if (Array.isArray(obj)) {
            queue.push({
                val: "]"
            });
            for(i = obj.length - 1; i >= 0; i--){
                arrayPrefix = i === 0 ? "" : ",";
                queue.push({
                    obj: obj[i],
                    prefix: arrayPrefix
                });
            }
            queue.push({
                val: "["
            });
        } else {
            keys = [];
            for(k in obj)if (obj.hasOwnProperty(k)) keys.push(k);
            queue.push({
                val: "}"
            });
            for(i = keys.length - 1; i >= 0; i--){
                key = keys[i];
                value = obj[key];
                objPrefix = i > 0 ? "," : "";
                objPrefix += JSON.stringify(key) + ":";
                queue.push({
                    obj: value,
                    prefix: objPrefix
                });
            }
            queue.push({
                val: "{"
            });
        }
    }
    return res;
};
// Convenience function for the parse function.
// This pop function is basically copied from
// pouchCollate.parseIndexableString
function $49c643d0d3095734$var$pop(obj, stack, metaStack) {
    var lastMetaElement = metaStack[metaStack.length - 1];
    if (obj === lastMetaElement.element) {
        // popping a meta-element, e.g. an object whose value is another object
        metaStack.pop();
        lastMetaElement = metaStack[metaStack.length - 1];
    }
    var element = lastMetaElement.element;
    var lastElementIndex = lastMetaElement.index;
    if (Array.isArray(element)) element.push(obj);
    else if (lastElementIndex === stack.length - 2) {
        var key = stack.pop();
        element[key] = obj;
    } else stack.push(obj); // obj with key only
}
$49c643d0d3095734$export$98e6a39c04603d36 = function(str) {
    var stack = [];
    var metaStack = []; // stack for arrays and objects
    var i = 0;
    var collationIndex, parsedNum, numChar;
    var parsedString, lastCh, numConsecutiveSlashes, ch;
    var arrayElement, objElement;
    while(true){
        collationIndex = str[i++];
        if (collationIndex === "}" || collationIndex === "]" || typeof collationIndex === "undefined") {
            if (stack.length === 1) return stack.pop();
            else {
                $49c643d0d3095734$var$pop(stack.pop(), stack, metaStack);
                continue;
            }
        }
        switch(collationIndex){
            case " ":
            case "	":
            case "\n":
            case ":":
            case ",":
                break;
            case "n":
                i += 3; // 'ull'
                $49c643d0d3095734$var$pop(null, stack, metaStack);
                break;
            case "t":
                i += 3; // 'rue'
                $49c643d0d3095734$var$pop(true, stack, metaStack);
                break;
            case "f":
                i += 4; // 'alse'
                $49c643d0d3095734$var$pop(false, stack, metaStack);
                break;
            case "0":
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
            case "-":
                parsedNum = "";
                i--;
                while(true){
                    numChar = str[i++];
                    if (/[\d\.\-e\+]/.test(numChar)) parsedNum += numChar;
                    else {
                        i--;
                        break;
                    }
                }
                $49c643d0d3095734$var$pop(parseFloat(parsedNum), stack, metaStack);
                break;
            case '"':
                parsedString = "";
                lastCh = void 0;
                numConsecutiveSlashes = 0;
                while(true){
                    ch = str[i++];
                    if (ch !== '"' || lastCh === "\\" && numConsecutiveSlashes % 2 === 1) {
                        parsedString += ch;
                        lastCh = ch;
                        if (lastCh === "\\") numConsecutiveSlashes++;
                        else numConsecutiveSlashes = 0;
                    } else break;
                }
                $49c643d0d3095734$var$pop(JSON.parse('"' + parsedString + '"'), stack, metaStack);
                break;
            case "[":
                arrayElement = {
                    element: [],
                    index: stack.length
                };
                stack.push(arrayElement.element);
                metaStack.push(arrayElement);
                break;
            case "{":
                objElement = {
                    element: {},
                    index: stack.length
                };
                stack.push(objElement.element);
                metaStack.push(objElement);
                break;
            default:
                throw new Error("unexpectedly reached end of input: " + collationIndex);
        }
    }
};

});

parcelRegister("dG33B", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $9f5191ad6e142a03$var$R = typeof Reflect === "object" ? Reflect : null;
var $9f5191ad6e142a03$var$ReflectApply = $9f5191ad6e142a03$var$R && typeof $9f5191ad6e142a03$var$R.apply === "function" ? $9f5191ad6e142a03$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $9f5191ad6e142a03$var$ReflectOwnKeys;
if ($9f5191ad6e142a03$var$R && typeof $9f5191ad6e142a03$var$R.ownKeys === "function") $9f5191ad6e142a03$var$ReflectOwnKeys = $9f5191ad6e142a03$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $9f5191ad6e142a03$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $9f5191ad6e142a03$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $9f5191ad6e142a03$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $9f5191ad6e142a03$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $9f5191ad6e142a03$var$EventEmitter() {
    $9f5191ad6e142a03$var$EventEmitter.init.call(this);
}
module.exports = $9f5191ad6e142a03$var$EventEmitter;
module.exports.once = $9f5191ad6e142a03$var$once;
// Backwards-compat with node 0.10.x
$9f5191ad6e142a03$var$EventEmitter.EventEmitter = $9f5191ad6e142a03$var$EventEmitter;
$9f5191ad6e142a03$var$EventEmitter.prototype._events = undefined;
$9f5191ad6e142a03$var$EventEmitter.prototype._eventsCount = 0;
$9f5191ad6e142a03$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $9f5191ad6e142a03$var$defaultMaxListeners = 10;
function $9f5191ad6e142a03$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($9f5191ad6e142a03$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $9f5191ad6e142a03$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $9f5191ad6e142a03$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $9f5191ad6e142a03$var$defaultMaxListeners = arg;
    }
});
$9f5191ad6e142a03$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$9f5191ad6e142a03$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $9f5191ad6e142a03$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $9f5191ad6e142a03$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $9f5191ad6e142a03$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $9f5191ad6e142a03$var$_getMaxListeners(this);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $9f5191ad6e142a03$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $9f5191ad6e142a03$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$9f5191ad6e142a03$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $9f5191ad6e142a03$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $9f5191ad6e142a03$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $9f5191ad6e142a03$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $9f5191ad6e142a03$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $9f5191ad6e142a03$var$_addListener(this, type, listener, false);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.on = $9f5191ad6e142a03$var$EventEmitter.prototype.addListener;
$9f5191ad6e142a03$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $9f5191ad6e142a03$var$_addListener(this, type, listener, true);
};
function $9f5191ad6e142a03$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $9f5191ad6e142a03$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $9f5191ad6e142a03$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.once = function once(type, listener) {
    $9f5191ad6e142a03$var$checkListener(listener);
    this.on(type, $9f5191ad6e142a03$var$_onceWrap(this, type, listener));
    return this;
};
$9f5191ad6e142a03$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $9f5191ad6e142a03$var$checkListener(listener);
    this.prependListener(type, $9f5191ad6e142a03$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$9f5191ad6e142a03$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $9f5191ad6e142a03$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $9f5191ad6e142a03$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$9f5191ad6e142a03$var$EventEmitter.prototype.off = $9f5191ad6e142a03$var$EventEmitter.prototype.removeListener;
$9f5191ad6e142a03$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $9f5191ad6e142a03$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $9f5191ad6e142a03$var$unwrapListeners(evlistener) : $9f5191ad6e142a03$var$arrayClone(evlistener, evlistener.length);
}
$9f5191ad6e142a03$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $9f5191ad6e142a03$var$_listeners(this, type, true);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $9f5191ad6e142a03$var$_listeners(this, type, false);
};
$9f5191ad6e142a03$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $9f5191ad6e142a03$var$listenerCount.call(emitter, type);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.listenerCount = $9f5191ad6e142a03$var$listenerCount;
function $9f5191ad6e142a03$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $9f5191ad6e142a03$var$ReflectOwnKeys(this._events) : [];
};
function $9f5191ad6e142a03$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $9f5191ad6e142a03$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $9f5191ad6e142a03$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $9f5191ad6e142a03$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $9f5191ad6e142a03$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $9f5191ad6e142a03$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("6qd2L", function(module, exports) {
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};

});


parcelRegister("jPR8W", function(module, exports) {
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 686: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "default": function() {
                        return /* binding */ clipboard;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
                var tiny_emitter = __webpack_require__(279);
                var tiny_emitter_default = /*#__PURE__*/ __webpack_require__.n(tiny_emitter);
                // EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
                var listen = __webpack_require__(370);
                var listen_default = /*#__PURE__*/ __webpack_require__.n(listen);
                // EXTERNAL MODULE: ./node_modules/select/src/select.js
                var src_select = __webpack_require__(817);
                var select_default = /*#__PURE__*/ __webpack_require__.n(src_select);
                /**
 * Executes a given operation type.
 * @param {String} type
 * @return {Boolean}
 */ function command(type) {
                    try {
                        return document.execCommand(type);
                    } catch (err) {
                        return false;
                    }
                }
                /**
 * Cut action wrapper.
 * @param {String|HTMLElement} target
 * @return {String}
 */ var ClipboardActionCut = function ClipboardActionCut(target) {
                    var selectedText = select_default()(target);
                    command("cut");
                    return selectedText;
                };
                /* harmony default export */ var actions_cut = ClipboardActionCut;
                /**
 * Creates a fake textarea element with a value.
 * @param {String} value
 * @return {HTMLElement}
 */ function createFakeElement(value) {
                    var isRTL = document.documentElement.getAttribute("dir") === "rtl";
                    var fakeElement = document.createElement("textarea"); // Prevent zooming on iOS
                    fakeElement.style.fontSize = "12pt"; // Reset box model
                    fakeElement.style.border = "0";
                    fakeElement.style.padding = "0";
                    fakeElement.style.margin = "0"; // Move element out of screen horizontally
                    fakeElement.style.position = "absolute";
                    fakeElement.style[isRTL ? "right" : "left"] = "-9999px"; // Move element to the same position vertically
                    var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                    fakeElement.style.top = "".concat(yPosition, "px");
                    fakeElement.setAttribute("readonly", "");
                    fakeElement.value = value;
                    return fakeElement;
                }
                /**
 * Create fake copy action wrapper using a fake element.
 * @param {String} target
 * @param {Object} options
 * @return {String}
 */ var fakeCopyAction = function fakeCopyAction(value, options) {
                    var fakeElement = createFakeElement(value);
                    options.container.appendChild(fakeElement);
                    var selectedText = select_default()(fakeElement);
                    command("copy");
                    fakeElement.remove();
                    return selectedText;
                };
                /**
 * Copy action wrapper.
 * @param {String|HTMLElement} target
 * @param {Object} options
 * @return {String}
 */ var ClipboardActionCopy = function ClipboardActionCopy(target) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                        container: document.body
                    };
                    var selectedText = "";
                    if (typeof target === "string") selectedText = fakeCopyAction(target, options);
                    else if (target instanceof HTMLInputElement && ![
                        "text",
                        "search",
                        "url",
                        "tel",
                        "password"
                    ].includes(target === null || target === void 0 ? void 0 : target.type)) // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
                    selectedText = fakeCopyAction(target.value, options);
                    else {
                        selectedText = select_default()(target);
                        command("copy");
                    }
                    return selectedText;
                };
                /* harmony default export */ var actions_copy = ClipboardActionCopy;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                /**
 * Inner function which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 * @param {Object} options
 */ var ClipboardActionDefault = function ClipboardActionDefault() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    // Defines base properties passed from constructor.
                    var _options$action = options.action, action = _options$action === void 0 ? "copy" : _options$action, container = options.container, target = options.target, text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.
                    if (action !== "copy" && action !== "cut") throw new Error('Invalid "action" value, use either "copy" or "cut"');
                     // Sets the `target` property using an element that will be have its content copied.
                    if (target !== undefined) {
                        if (target && _typeof(target) === "object" && target.nodeType === 1) {
                            if (action === "copy" && target.hasAttribute("disabled")) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                            if (action === "cut" && (target.hasAttribute("readonly") || target.hasAttribute("disabled"))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        } else throw new Error('Invalid "target" value, use a valid Element');
                    } // Define selection strategy based on `text` property.
                    if (text) return actions_copy(text, {
                        container: container
                    });
                     // Defines which selection strategy based on `target` property.
                    if (target) return action === "cut" ? actions_cut(target) : actions_copy(target, {
                        container: container
                    });
                };
                /* harmony default export */ var actions_default = ClipboardActionDefault;
                function clipboard_typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") clipboard_typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else clipboard_typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return clipboard_typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */ function getAttributeValue(suffix, element) {
                    var attribute = "data-clipboard-".concat(suffix);
                    if (!element.hasAttribute(attribute)) return;
                    return element.getAttribute(attribute);
                }
                /**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */ var Clipboard = /*#__PURE__*/ function(_Emitter) {
                    _inherits(Clipboard, _Emitter);
                    var _super = _createSuper(Clipboard);
                    /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */ function Clipboard(trigger, options) {
                        var _this;
                        _classCallCheck(this, Clipboard);
                        _this = _super.call(this);
                        _this.resolveOptions(options);
                        _this.listenClick(trigger);
                        return _this;
                    }
                    /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */ _createClass(Clipboard, [
                        {
                            key: "resolveOptions",
                            value: function resolveOptions() {
                                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                this.action = typeof options.action === "function" ? options.action : this.defaultAction;
                                this.target = typeof options.target === "function" ? options.target : this.defaultTarget;
                                this.text = typeof options.text === "function" ? options.text : this.defaultText;
                                this.container = clipboard_typeof(options.container) === "object" ? options.container : document.body;
                            }
                        },
                        {
                            key: "listenClick",
                            value: function listenClick(trigger) {
                                var _this2 = this;
                                this.listener = listen_default()(trigger, "click", function(e) {
                                    return _this2.onClick(e);
                                });
                            }
                        },
                        {
                            key: "onClick",
                            value: function onClick(e) {
                                var trigger = e.delegateTarget || e.currentTarget;
                                var action = this.action(trigger) || "copy";
                                var text = actions_default({
                                    action: action,
                                    container: this.container,
                                    target: this.target(trigger),
                                    text: this.text(trigger)
                                }); // Fires an event based on the copy operation result.
                                this.emit(text ? "success" : "error", {
                                    action: action,
                                    text: text,
                                    trigger: trigger,
                                    clearSelection: function clearSelection() {
                                        if (trigger) trigger.focus();
                                        window.getSelection().removeAllRanges();
                                    }
                                });
                            }
                        },
                        {
                            key: "defaultAction",
                            value: function defaultAction(trigger) {
                                return getAttributeValue("action", trigger);
                            }
                        },
                        {
                            key: "defaultTarget",
                            value: function defaultTarget(trigger) {
                                var selector = getAttributeValue("target", trigger);
                                if (selector) return document.querySelector(selector);
                            }
                        },
                        {
                            key: "defaultText",
                            /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */ value: function defaultText(trigger) {
                                return getAttributeValue("text", trigger);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.listener.destroy();
                            }
                        }
                    ], [
                        {
                            key: "copy",
                            value: function copy(target) {
                                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                                    container: document.body
                                };
                                return actions_copy(target, options);
                            }
                        },
                        {
                            key: "cut",
                            value: function cut(target) {
                                return actions_cut(target);
                            }
                        },
                        {
                            key: "isSupported",
                            value: function isSupported() {
                                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                                    "copy",
                                    "cut"
                                ];
                                var actions = typeof action === "string" ? [
                                    action
                                ] : action;
                                var support = !!document.queryCommandSupported;
                                actions.forEach(function(action) {
                                    support = support && !!document.queryCommandSupported(action);
                                });
                                return support;
                            }
                        }
                    ]);
                    return Clipboard;
                }(tiny_emitter_default());
                /* harmony default export */ var clipboard = Clipboard;
            /***/ },
            /***/ 828: /***/ function(module1) {
                var DOCUMENT_NODE_TYPE = 9;
                /**
 * A polyfill for Element.matches()
 */ if (typeof Element !== "undefined" && !Element.prototype.matches) {
                    var proto = Element.prototype;
                    proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
                }
                /**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */ function closest(element, selector) {
                    while(element && element.nodeType !== DOCUMENT_NODE_TYPE){
                        if (typeof element.matches === "function" && element.matches(selector)) return element;
                        element = element.parentNode;
                    }
                }
                module1.exports = closest;
            /***/ },
            /***/ 438: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var closest = __webpack_require__(828);
                /**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function _delegate(element, selector, type, callback, useCapture) {
                    var listenerFn = listener.apply(this, arguments);
                    element.addEventListener(type, listenerFn, useCapture);
                    return {
                        destroy: function() {
                            element.removeEventListener(type, listenerFn, useCapture);
                        }
                    };
                }
                /**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function delegate(elements, selector, type, callback, useCapture) {
                    // Handle the regular Element usage
                    if (typeof elements.addEventListener === "function") return _delegate.apply(null, arguments);
                    // Handle Element-less usage, it defaults to global delegation
                    if (typeof type === "function") // Use `document` as the first parameter, then apply arguments
                    // This is a short way to .unshift `arguments` without running into deoptimizations
                    return _delegate.bind(null, document).apply(null, arguments);
                    // Handle Selector-based usage
                    if (typeof elements === "string") elements = document.querySelectorAll(elements);
                    // Handle Array-like based usage
                    return Array.prototype.map.call(elements, function(element) {
                        return _delegate(element, selector, type, callback, useCapture);
                    });
                }
                /**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */ function listener(element, selector, type, callback) {
                    return function(e) {
                        e.delegateTarget = closest(e.target, selector);
                        if (e.delegateTarget) callback.call(element, e);
                    };
                }
                module1.exports = delegate;
            /***/ },
            /***/ 879: /***/ function(__unused_webpack_module, exports) {
                /**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.node = function(value) {
                    return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
                };
                /**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.nodeList = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return value !== undefined && (type === "[object NodeList]" || type === "[object HTMLCollection]") && "length" in value && (value.length === 0 || exports.node(value[0]));
                };
                /**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.string = function(value) {
                    return typeof value === "string" || value instanceof String;
                };
                /**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.fn = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return type === "[object Function]";
                };
            /***/ },
            /***/ 370: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var is = __webpack_require__(879);
                var delegate = __webpack_require__(438);
                /**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listen(target, type, callback) {
                    if (!target && !type && !callback) throw new Error("Missing required arguments");
                    if (!is.string(type)) throw new TypeError("Second argument must be a String");
                    if (!is.fn(callback)) throw new TypeError("Third argument must be a Function");
                    if (is.node(target)) return listenNode(target, type, callback);
                    else if (is.nodeList(target)) return listenNodeList(target, type, callback);
                    else if (is.string(target)) return listenSelector(target, type, callback);
                    else throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
                }
                /**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNode(node, type, callback) {
                    node.addEventListener(type, callback);
                    return {
                        destroy: function() {
                            node.removeEventListener(type, callback);
                        }
                    };
                }
                /**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNodeList(nodeList, type, callback) {
                    Array.prototype.forEach.call(nodeList, function(node) {
                        node.addEventListener(type, callback);
                    });
                    return {
                        destroy: function() {
                            Array.prototype.forEach.call(nodeList, function(node) {
                                node.removeEventListener(type, callback);
                            });
                        }
                    };
                }
                /**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenSelector(selector, type, callback) {
                    return delegate(document.body, selector, type, callback);
                }
                module1.exports = listen;
            /***/ },
            /***/ 817: /***/ function(module1) {
                function select(element) {
                    var selectedText;
                    if (element.nodeName === "SELECT") {
                        element.focus();
                        selectedText = element.value;
                    } else if (element.nodeName === "INPUT" || element.nodeName === "TEXTAREA") {
                        var isReadOnly = element.hasAttribute("readonly");
                        if (!isReadOnly) element.setAttribute("readonly", "");
                        element.select();
                        element.setSelectionRange(0, element.value.length);
                        if (!isReadOnly) element.removeAttribute("readonly");
                        selectedText = element.value;
                    } else {
                        if (element.hasAttribute("contenteditable")) element.focus();
                        var selection = window.getSelection();
                        var range = document.createRange();
                        range.selectNodeContents(element);
                        selection.removeAllRanges();
                        selection.addRange(range);
                        selectedText = selection.toString();
                    }
                    return selectedText;
                }
                module1.exports = select;
            /***/ },
            /***/ 279: /***/ function(module1) {
                function E() {
                // Keep this empty so it's easier to inherit from
                // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
                }
                E.prototype = {
                    on: function(name, callback, ctx) {
                        var e = this.e || (this.e = {});
                        (e[name] || (e[name] = [])).push({
                            fn: callback,
                            ctx: ctx
                        });
                        return this;
                    },
                    once: function(name, callback, ctx) {
                        var self = this;
                        function listener() {
                            self.off(name, listener);
                            callback.apply(ctx, arguments);
                        }
                        listener._ = callback;
                        return this.on(name, listener, ctx);
                    },
                    emit: function(name) {
                        var data = [].slice.call(arguments, 1);
                        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
                        var i = 0;
                        var len = evtArr.length;
                        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
                        return this;
                    },
                    off: function(name, callback) {
                        var e = this.e || (this.e = {});
                        var evts = e[name];
                        var liveEvents = [];
                        if (evts && callback) {
                            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
                        }
                        // Remove event from queue to prevent memory leak
                        // Suggested by https://github.com/lazd
                        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
                        liveEvents.length ? e[name] = liveEvents : delete e[name];
                        return this;
                    }
                };
                module1.exports = E;
                module1.exports.TinyEmitter = E;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1["default"];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /************************************************************************/ /******/ // module exports must be returned from runtime so entry inlining is disabled
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(686);
    /******/ }().default;
});

});

// noinspection JSValidateTypes
/*
 *  Copyright 2022 Red Hat
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ // Keep the order (unless you know what you're doing)
// JQuery
// https://stackoverflow.com/a/47984928

var $9qak9 = parcelRequire("9qak9");
window.$ = window.jQuery = $9qak9;

window.Cookies = (parcelRequire("4X8V9"));
// This file is autogenerated via the `commonjs` Grunt task. You can require() this file in a CommonJS environment.
/* ========================================================================
 * Bootstrap: transition.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */ (function($) {
    "use strict";
    // CSS TRANSITION SUPPORT (Shoutout: https://modernizr.com/)
    // ============================================================
    function transitionEnd() {
        var el = document.createElement("bootstrap");
        var transEndEventNames = {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd otransitionend",
            transition: "transitionend"
        };
        for(var name in transEndEventNames){
            if (el.style[name] !== undefined) return {
                end: transEndEventNames[name]
            };
        }
        return false // explicit for ie8 (  ._.)
        ;
    }
    // https://blog.alexmaccaw.com/css-transitions
    $.fn.emulateTransitionEnd = function(duration) {
        var called = false;
        var $el = this;
        $(this).one("bsTransitionEnd", function() {
            called = true;
        });
        var callback = function() {
            if (!called) $($el).trigger($.support.transition.end);
        };
        setTimeout(callback, duration);
        return this;
    };
    $(function() {
        $.support.transition = transitionEnd();
        if (!$.support.transition) return;
        $.event.special.bsTransitionEnd = {
            bindType: $.support.transition.end,
            delegateType: $.support.transition.end,
            handle: function(e) {
                if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
            }
        };
    });
})(jQuery);


/* ========================================================================
 * Bootstrap: alert.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */ (function($) {
    "use strict";
    // ALERT CLASS DEFINITION
    // ======================
    var dismiss = '[data-dismiss="alert"]';
    var Alert = function(el) {
        $(el).on("click", dismiss, this.close);
    };
    Alert.VERSION = "3.4.1";
    Alert.TRANSITION_DURATION = 150;
    Alert.prototype.close = function(e) {
        var $this = $(this);
        var selector = $this.attr("data-target");
        if (!selector) {
            selector = $this.attr("href");
            selector = selector && selector.replace(/.*(?=#[^\s]*$)/, "") // strip for ie7
            ;
        }
        selector = selector === "#" ? [] : selector;
        var $parent = $(document).find(selector);
        if (e) e.preventDefault();
        if (!$parent.length) $parent = $this.closest(".alert");
        $parent.trigger(e = $.Event("close.bs.alert"));
        if (e.isDefaultPrevented()) return;
        $parent.removeClass("in");
        function removeElement() {
            // detach from parent, fire event then clean up data
            $parent.detach().trigger("closed.bs.alert").remove();
        }
        $.support.transition && $parent.hasClass("fade") ? $parent.one("bsTransitionEnd", removeElement).emulateTransitionEnd(Alert.TRANSITION_DURATION) : removeElement();
    };
    // ALERT PLUGIN DEFINITION
    // =======================
    function Plugin(option) {
        return this.each(function() {
            var $this = $(this);
            var data = $this.data("bs.alert");
            if (!data) $this.data("bs.alert", data = new Alert(this));
            if (typeof option == "string") data[option].call($this);
        });
    }
    var old = $.fn.alert;
    $.fn.alert = Plugin;
    $.fn.alert.Constructor = Alert;
    // ALERT NO CONFLICT
    // =================
    $.fn.alert.noConflict = function() {
        $.fn.alert = old;
        return this;
    };
    // ALERT DATA-API
    // ==============
    $(document).on("click.bs.alert.data-api", dismiss, Alert.prototype.close);
})(jQuery);


/* ========================================================================
 * Bootstrap: button.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */ (function($) {
    "use strict";
    // BUTTON PUBLIC CLASS DEFINITION
    // ==============================
    var Button = function(element, options) {
        this.$element = $(element);
        this.options = $.extend({}, Button.DEFAULTS, options);
        this.isLoading = false;
    };
    Button.VERSION = "3.4.1";
    Button.DEFAULTS = {
        loadingText: "loading..."
    };
    Button.prototype.setState = function(state) {
        var d = "disabled";
        var $el = this.$element;
        var val = $el.is("input") ? "val" : "html";
        var data = $el.data();
        state += "Text";
        if (data.resetText == null) $el.data("resetText", $el[val]());
        // push to event loop to allow forms to submit
        setTimeout($.proxy(function() {
            $el[val](data[state] == null ? this.options[state] : data[state]);
            if (state == "loadingText") {
                this.isLoading = true;
                $el.addClass(d).attr(d, d).prop(d, true);
            } else if (this.isLoading) {
                this.isLoading = false;
                $el.removeClass(d).removeAttr(d).prop(d, false);
            }
        }, this), 0);
    };
    Button.prototype.toggle = function() {
        var changed = true;
        var $parent = this.$element.closest('[data-toggle="buttons"]');
        if ($parent.length) {
            var $input = this.$element.find("input");
            if ($input.prop("type") == "radio") {
                if ($input.prop("checked")) changed = false;
                $parent.find(".active").removeClass("active");
                this.$element.addClass("active");
            } else if ($input.prop("type") == "checkbox") {
                if ($input.prop("checked") !== this.$element.hasClass("active")) changed = false;
                this.$element.toggleClass("active");
            }
            $input.prop("checked", this.$element.hasClass("active"));
            if (changed) $input.trigger("change");
        } else {
            this.$element.attr("aria-pressed", !this.$element.hasClass("active"));
            this.$element.toggleClass("active");
        }
    };
    // BUTTON PLUGIN DEFINITION
    // ========================
    function Plugin(option) {
        return this.each(function() {
            var $this = $(this);
            var data = $this.data("bs.button");
            var options = typeof option == "object" && option;
            if (!data) $this.data("bs.button", data = new Button(this, options));
            if (option == "toggle") data.toggle();
            else if (option) data.setState(option);
        });
    }
    var old = $.fn.button;
    $.fn.button = Plugin;
    $.fn.button.Constructor = Button;
    // BUTTON NO CONFLICT
    // ==================
    $.fn.button.noConflict = function() {
        $.fn.button = old;
        return this;
    };
    // BUTTON DATA-API
    // ===============
    $(document).on("click.bs.button.data-api", '[data-toggle^="button"]', function(e) {
        var $btn = $(e.target).closest(".btn");
        Plugin.call($btn, "toggle");
        if (!$(e.target).is('input[type="radio"], input[type="checkbox"]')) {
            // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
            e.preventDefault();
            // The target component still receive the focus
            if ($btn.is("input,button")) $btn.trigger("focus");
            else $btn.find("input:visible,button:visible").first().trigger("focus");
        }
    }).on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', function(e) {
        $(e.target).closest(".btn").toggleClass("focus", /^focus(in)?$/.test(e.type));
    });
})(jQuery);


/* ========================================================================
 * Bootstrap: carousel.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */ (function($) {
    "use strict";
    // CAROUSEL CLASS DEFINITION
    // =========================
    var Carousel = function(element, options) {
        this.$element = $(element);
        this.$indicators = this.$element.find(".carousel-indicators");
        this.options = options;
        this.paused = null;
        this.sliding = null;
        this.interval = null;
        this.$active = null;
        this.$items = null;
        this.options.keyboard && this.$element.on("keydown.bs.carousel", $.proxy(this.keydown, this));
        this.options.pause == "hover" && !("ontouchstart" in document.documentElement) && this.$element.on("mouseenter.bs.carousel", $.proxy(this.pause, this)).on("mouseleave.bs.carousel", $.proxy(this.cycle, this));
    };
    Carousel.VERSION = "3.4.1";
    Carousel.TRANSITION_DURATION = 600;
    Carousel.DEFAULTS = {
        interval: 5000,
        pause: "hover",
        wrap: true,
        keyboard: true
    };
    Carousel.prototype.keydown = function(e) {
        if (/input|textarea/i.test(e.target.tagName)) return;
        switch(e.which){
            case 37:
                this.prev();
                break;
            case 39:
                this.next();
                break;
            default:
                return;
        }
        e.preventDefault();
    };
    Carousel.prototype.cycle = function(e) {
        e || (this.paused = false);
        this.interval && clearInterval(this.interval);
        this.options.interval && !this.paused && (this.interval = setInterval($.proxy(this.next, this), this.options.interval));
        return this;
    };
    Carousel.prototype.getItemIndex = function(item) {
        this.$items = item.parent().children(".item");
        return this.$items.index(item || this.$active);
    };
    Carousel.prototype.getItemForDirection = function(direction, active) {
        var activeIndex = this.getItemIndex(active);
        var willWrap = direction == "prev" && activeIndex === 0 || direction == "next" && activeIndex == this.$items.length - 1;
        if (willWrap && !this.options.wrap) return active;
        var delta = direction == "prev" ? -1 : 1;
        var itemIndex = (activeIndex + delta) % this.$items.length;
        return this.$items.eq(itemIndex);
    };
    Carousel.prototype.to = function(pos) {
        var that = this;
        var activeIndex = this.getItemIndex(this.$active = this.$element.find(".item.active"));
        if (pos > this.$items.length - 1 || pos < 0) return;
        if (this.sliding) return this.$element.one("slid.bs.carousel", function() {
            that.to(pos);
        }) // yes, "slid"
        ;
        if (activeIndex == pos) return this.pause().cycle();
        return this.slide(pos > activeIndex ? "next" : "prev", this.$items.eq(pos));
    };
    Carousel.prototype.pause = function(e) {
        e || (this.paused = true);
        if (this.$element.find(".next, .prev").length && $.support.transition) {
            this.$element.trigger($.support.transition.end);
            this.cycle(true);
        }
        this.interval = clearInterval(this.interval);
        return this;
    };
    Carousel.prototype.next = function() {
        if (this.sliding) return;
        return this.slide("next");
    };
    Carousel.prototype.prev = function() {
        if (this.sliding) return;
        return this.slide("prev");
    };
    Carousel.prototype.slide = function(type, next) {
        var $active = this.$element.find(".item.active");
        var $next = next || this.getItemForDirection(type, $active);
        var isCycling = this.interval;
        var direction = type == "next" ? "left" : "right";
        var that = this;
        if ($next.hasClass("active")) return this.sliding = false;
        var relatedTarget = $next[0];
        var slideEvent = $.Event("slide.bs.carousel", {
            relatedTarget: relatedTarget,
            direction: direction
        });
        this.$element.trigger(slideEvent);
        if (slideEvent.isDefaultPrevented()) return;
        this.sliding = true;
        isCycling && this.pause();
        if (this.$indicators.length) {
            this.$indicators.find(".active").removeClass("active");
            var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)]);
            $nextIndicator && $nextIndicator.addClass("active");
        }
        var slidEvent = $.Event("slid.bs.carousel", {
            relatedTarget: relatedTarget,
            direction: direction
        }) // yes, "slid"
        ;
        if ($.support.transition && this.$element.hasClass("slide")) {
            $next.addClass(type);
            if (typeof $next === "object" && $next.length) $next[0].offsetWidth // force reflow
            ;
            $active.addClass(direction);
            $next.addClass(direction);
            $active.one("bsTransitionEnd", function() {
                $next.removeClass([
                    type,
                    direction
                ].join(" ")).addClass("active");
                $active.removeClass([
                    "active",
                    direction
                ].join(" "));
                that.sliding = false;
                setTimeout(function() {
                    that.$element.trigger(slidEvent);
                }, 0);
            }).emulateTransitionEnd(Carousel.TRANSITION_DURATION);
        } else {
            $active.removeClass("active");
            $next.addClass("active");
            this.sliding = false;
            this.$element.trigger(slidEvent);
        }
        isCycling && this.cycle();
        return this;
    };
    // CAROUSEL PLUGIN DEFINITION
    // ==========================
    function Plugin(option) {
        return this.each(function() {
            var $this = $(this);
            var data = $this.data("bs.carousel");
            var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == "object" && option);
            var action = typeof option == "string" ? option : options.slide;
            if (!data) $this.data("bs.carousel", data = new Carousel(this, options));
            if (typeof option == "number") data.to(option);
            else if (action) data[action]();
            else if (options.interval) data.pause().cycle();
        });
    }
    var old = $.fn.carousel;
    $.fn.carousel = Plugin;
    $.fn.carousel.Constructor = Carousel;
    // CAROUSEL NO CONFLICT
    // ====================
    $.fn.carousel.noConflict = function() {
        $.fn.carousel = old;
        return this;
    };
    // CAROUSEL DATA-API
    // =================
    var clickHandler = function(e) {
        var $this = $(this);
        var href = $this.attr("href");
        if (href) href = href.replace(/.*(?=#[^\s]+$)/, "") // strip for ie7
        ;
        var target = $this.attr("data-target") || href;
        var $target = $(document).find(target);
        if (!$target.hasClass("carousel")) return;
        var options = $.extend({}, $target.data(), $this.data());
        var slideIndex = $this.attr("data-slide-to");
        if (slideIndex) options.interval = false;
        Plugin.call($target, options);
        if (slideIndex) $target.data("bs.carousel").to(slideIndex);
        e.preventDefault();
    };
    $(document).on("click.bs.carousel.data-api", "[data-slide]", clickHandler).on("click.bs.carousel.data-api", "[data-slide-to]", clickHandler);
    $(window).on("load", function() {
        $('[data-ride="carousel"]').each(function() {
            var $carousel = $(this);
            Plugin.call($carousel, $carousel.data());
        });
    });
})(jQuery);


/* ========================================================================
 * Bootstrap: collapse.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */ /* jshint latedef: false */ (function($) {
    "use strict";
    // COLLAPSE PUBLIC CLASS DEFINITION
    // ================================
    var Collapse = function(element, options) {
        this.$element = $(element);
        this.options = $.extend({}, Collapse.DEFAULTS, options);
        this.$trigger = $('[data-toggle="collapse"][href="#' + element.id + '"],' + '[data-toggle="collapse"][data-target="#' + element.id + '"]');
        this.transitioning = null;
        if (this.options.parent) this.$parent = this.getParent();
        else this.addAriaAndCollapsedClass(this.$element, this.$trigger);
        if (this.options.toggle) this.toggle();
    };
    Collapse.VERSION = "3.4.1";
    Collapse.TRANSITION_DURATION = 350;
    Collapse.DEFAULTS = {
        toggle: true
    };
    Collapse.prototype.dimension = function() {
        var hasWidth = this.$element.hasClass("width");
        return hasWidth ? "width" : "height";
    };
    Collapse.prototype.show = function() {
        if (this.transitioning || this.$element.hasClass("in")) return;
        var activesData;
        var actives = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");
        if (actives && actives.length) {
            activesData = actives.data("bs.collapse");
            if (activesData && activesData.transitioning) return;
        }
        var startEvent = $.Event("show.bs.collapse");
        this.$element.trigger(startEvent);
        if (startEvent.isDefaultPrevented()) return;
        if (actives && actives.length) {
            Plugin.call(actives, "hide");
            activesData || actives.data("bs.collapse", null);
        }
        var dimension = this.dimension();
        this.$element.removeClass("collapse").addClass("collapsing")[dimension](0).attr("aria-expanded", true);
        this.$trigger.removeClass("collapsed").attr("aria-expanded", true);
        this.transitioning = 1;
        var complete = function() {
            this.$element.removeClass("collapsing").addClass("collapse in")[dimension]("");
            this.transitioning = 0;
            this.$element.trigger("shown.bs.collapse");
        };
        if (!$.support.transition) return complete.call(this);
        var scrollSize = $.camelCase([
            "scroll",
            dimension
        ].join("-"));
        this.$element.one("bsTransitionEnd", $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize]);
    };
    Collapse.prototype.hide = function() {
        if (this.transitioning || !this.$element.hasClass("in")) return;
        var startEvent = $.Event("hide.bs.collapse");
        this.$element.trigger(startEvent);
        if (startEvent.isDefaultPrevented()) return;
        var dimension = this.dimension();
        this.$element[dimension](this.$element[dimension]())[0].offsetHeight;
        this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", false);
        this.$trigger.addClass("collapsed").attr("aria-expanded", false);
        this.transitioning = 1;
        var complete = function() {
            this.transitioning = 0;
            this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse");
        };
        if (!$.support.transition) return complete.call(this);
        this.$element[dimension](0).one("bsTransitionEnd", $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION);
    };
    Collapse.prototype.toggle = function() {
        this[this.$element.hasClass("in") ? "hide" : "show"]();
    };
    Collapse.prototype.getParent = function() {
        return $(document).find(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each($.proxy(function(i, element) {
            var $element = $(element);
            this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element);
        }, this)).end();
    };
    Collapse.prototype.addAriaAndCollapsedClass = function($element, $trigger) {
        var isOpen = $element.hasClass("in");
        $element.attr("aria-expanded", isOpen);
        $trigger.toggleClass("collapsed", !isOpen).attr("aria-expanded", isOpen);
    };
    function getTargetFromTrigger($trigger) {
        var href;
        var target = $trigger.attr("data-target") || (href = $trigger.attr("href")) && href.replace(/.*(?=#[^\s]+$)/, "") // strip for ie7
        ;
        return $(document).find(target);
    }
    // COLLAPSE PLUGIN DEFINITION
    // ==========================
    function Plugin(option) {
        return this.each(function() {
            var $this = $(this);
            var data = $this.data("bs.collapse");
            var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == "object" && option);
            if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false;
            if (!data) $this.data("bs.collapse", data = new Collapse(this, options));
            if (typeof option == "string") data[option]();
        });
    }
    var old = $.fn.collapse;
    $.fn.collapse = Plugin;
    $.fn.collapse.Constructor = Collapse;
    // COLLAPSE NO CONFLICT
    // ====================
    $.fn.collapse.noConflict = function() {
        $.fn.collapse = old;
        return this;
    };
    // COLLAPSE DATA-API
    // =================
    $(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function(e) {
        var $this = $(this);
        if (!$this.attr("data-target")) e.preventDefault();
        var $target = getTargetFromTrigger($this);
        var data = $target.data("bs.collapse");
        var option = data ? "toggle" : $this.data();
        Plugin.call($target, option);
    });
})(jQuery);


/* ========================================================================
 * Bootstrap: dropdown.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */ (function($) {
    "use strict";
    // DROPDOWN CLASS DEFINITION
    // =========================
    var backdrop = ".dropdown-backdrop";
    var toggle = '[data-toggle="dropdown"]';
    var Dropdown = function(element) {
        $(element).on("click.bs.dropdown", this.toggle);
    };
    Dropdown.VERSION = "3.4.1";
    function getParent($this) {
        var selector = $this.attr("data-target");
        if (!selector) {
            selector = $this.attr("href");
            selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, "") // strip for ie7
            ;
        }
        var $parent = selector !== "#" ? $(document).find(selector) : null;
        return $parent && $parent.length ? $parent : $this.parent();
    }
    function clearMenus(e) {
        if (e && e.which === 3) return;
        $(backdrop).remove();
        $(toggle).each(function() {
            var $this = $(this);
            var $parent = getParent($this);
            var relatedTarget = {
                relatedTarget: this
            };
            if (!$parent.hasClass("open")) return;
            if (e && e.type == "click" && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return;
            $parent.trigger(e = $.Event("hide.bs.dropdown", relatedTarget));
            if (e.isDefaultPrevented()) return;
            $this.attr("aria-expanded", "false");
            $parent.removeClass("open").trigger($.Event("hidden.bs.dropdown", relatedTarget));
        });
    }
    Dropdown.prototype.toggle = function(e) {
        var $this = $(this);
        if ($this.is(".disabled, :disabled")) return;
        var $parent = getParent($this);
        var isActive = $parent.hasClass("open");
        clearMenus();
        if (!isActive) {
            if ("ontouchstart" in document.documentElement && !$parent.closest(".navbar-nav").length) // if mobile we use a backdrop because click events don't delegate
            $(document.createElement("div")).addClass("dropdown-backdrop").insertAfter($(this)).on("click", clearMenus);
            var relatedTarget = {
                relatedTarget: this
            };
            $parent.trigger(e = $.Event("show.bs.dropdown", relatedTarget));
            if (e.isDefaultPrevented()) return;
            $this.trigger("focus").attr("aria-expanded", "true");
            $parent.toggleClass("open").trigger($.Event("shown.bs.dropdown", relatedTarget));
        }
        return false;
    };
    Dropdown.prototype.keydown = function(e) {
        if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return;
        var $this = $(this);
        e.preventDefault();
        e.stopPropagation();
        if ($this.is(".disabled, :disabled")) return;
        var $parent = getParent($this);
        var isActive = $parent.hasClass("open");
        if (!isActive && e.which != 27 || isActive && e.which == 27) {
            if (e.which == 27) $parent.find(toggle).trigger("focus");
            return $this.trigger("click");
        }
        var desc = " li:not(.disabled):visible a";
        var $items = $parent.find(".dropdown-menu" + desc);
        if (!$items.length) return;
        var index = $items.index(e.target);
        if (e.which == 38 && index > 0) index-- // up
        ;
        if (e.which == 40 && index < $items.length - 1) index++ // down
        ;
        if (!~index) index = 0;
        $items.eq(index).trigger("focus");
    };
    // DROPDOWN PLUGIN DEFINITION
    // ==========================
    function Plugin(option) {
        return this.each(function() {
            var $this = $(this);
            var data = $this.data("bs.dropdown");
            if (!data) $this.data("bs.dropdown", data = new Dropdown(this));
            if (typeof option == "string") data[option].call($this);
        });
    }
    var old = $.fn.dropdown;
    $.fn.dropdown = Plugin;
    $.fn.dropdown.Constructor = Dropdown;
    // DROPDOWN NO CONFLICT
    // ====================
    $.fn.dropdown.noConflict = function() {
        $.fn.dropdown = old;
        return this;
    };
    // APPLY TO STANDARD DROPDOWN ELEMENTS
    // ===================================
    $(document).on("click.bs.dropdown.data-api", clearMenus).on("click.bs.dropdown.data-api", ".dropdown form", function(e) {
        e.stopPropagation();
    }).on("click.bs.dropdown.data-api", toggle, Dropdown.prototype.toggle).on("keydown.bs.dropdown.data-api", toggle, Dropdown.prototype.keydown).on("keydown.bs.dropdown.data-api", ".dropdown-menu", Dropdown.prototype.keydown);
})(jQuery);


/* ========================================================================
 * Bootstrap: modal.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#modals
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */ (function($) {
    "use strict";
    // MODAL CLASS DEFINITION
    // ======================
    var Modal = function(element, options) {
        this.options = options;
        this.$body = $(document.body);
        this.$element = $(element);
        this.$dialog = this.$element.find(".modal-dialog");
        this.$backdrop = null;
        this.isShown = null;
        this.originalBodyPad = null;
        this.scrollbarWidth = 0;
        this.ignoreBackdropClick = false;
        this.fixedContent = ".navbar-fixed-top, .navbar-fixed-bottom";
        if (this.options.remote) this.$element.find(".modal-content").load(this.options.remote, $.proxy(function() {
            this.$element.trigger("loaded.bs.modal");
        }, this));
    };
    Modal.VERSION = "3.4.1";
    Modal.TRANSITION_DURATION = 300;
    Modal.BACKDROP_TRANSITION_DURATION = 150;
    Modal.DEFAULTS = {
        backdrop: true,
        keyboard: true,
        show: true
    };
    Modal.prototype.toggle = function(_relatedTarget) {
        return this.isShown ? this.hide() : this.show(_relatedTarget);
    };
    Modal.prototype.show = function(_relatedTarget) {
        var that = this;
        var e = $.Event("show.bs.modal", {
            relatedTarget: _relatedTarget
        });
        this.$element.trigger(e);
        if (this.isShown || e.isDefaultPrevented()) return;
        this.isShown = true;
        this.checkScrollbar();
        this.setScrollbar();
        this.$body.addClass("modal-open");
        this.escape();
        this.resize();
        this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', $.proxy(this.hide, this));
        this.$dialog.on("mousedown.dismiss.bs.modal", function() {
            that.$element.one("mouseup.dismiss.bs.modal", function(e) {
                if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true;
            });
        });
        this.backdrop(function() {
            var transition = $.support.transition && that.$element.hasClass("fade");
            if (!that.$element.parent().length) that.$element.appendTo(that.$body) // don't move modals dom position
            ;
            that.$element.show().scrollTop(0);
            that.adjustDialog();
            if (transition) that.$element[0].offsetWidth // force reflow
            ;
            that.$element.addClass("in");
            that.enforceFocus();
            var e = $.Event("shown.bs.modal", {
                relatedTarget: _relatedTarget
            });
            transition ? that.$dialog // wait for modal to slide in
            .one("bsTransitionEnd", function() {
                that.$element.trigger("focus").trigger(e);
            }).emulateTransitionEnd(Modal.TRANSITION_DURATION) : that.$element.trigger("focus").trigger(e);
        });
    };
    Modal.prototype.hide = function(e) {
        if (e) e.preventDefault();
        e = $.Event("hide.bs.modal");
        this.$element.trigger(e);
        if (!this.isShown || e.isDefaultPrevented()) return;
        this.isShown = false;
        this.escape();
        this.resize();
        $(document).off("focusin.bs.modal");
        this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal");
        this.$dialog.off("mousedown.dismiss.bs.modal");
        $.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", $.proxy(this.hideModal, this)).emulateTransitionEnd(Modal.TRANSITION_DURATION) : this.hideModal();
    };
    Modal.prototype.enforceFocus = function() {
        $(document).off("focusin.bs.modal") // guard against infinite focus loop
        .on("focusin.bs.modal", $.proxy(function(e) {
            if (document !== e.target && this.$element[0] !== e.target && !this.$element.has(e.target).length) this.$element.trigger("focus");
        }, this));
    };
    Modal.prototype.escape = function() {
        if (this.isShown && this.options.keyboard) this.$element.on("keydown.dismiss.bs.modal", $.proxy(function(e) {
            e.which == 27 && this.hide();
        }, this));
        else if (!this.isShown) this.$element.off("keydown.dismiss.bs.modal");
    };
    Modal.prototype.resize = function() {
        if (this.isShown) $(window).on("resize.bs.modal", $.proxy(this.handleUpdate, this));
        else $(window).off("resize.bs.modal");
    };
    Modal.prototype.hideModal = function() {
        var that = this;
        this.$element.hide();
        this.backdrop(function() {
            that.$body.removeClass("modal-open");
            that.resetAdjustments();
            that.resetScrollbar();
            that.$element.trigger("hidden.bs.modal");
        });
    };
    Modal.prototype.removeBackdrop = function() {
        this.$backdrop && this.$backdrop.remove();
        this.$backdrop = null;
    };
    Modal.prototype.backdrop = function(callback) {
        var that = this;
        var animate = this.$element.hasClass("fade") ? "fade" : "";
        if (this.isShown && this.options.backdrop) {
            var doAnimate = $.support.transition && animate;
            this.$backdrop = $(document.createElement("div")).addClass("modal-backdrop " + animate).appendTo(this.$body);
            this.$element.on("click.dismiss.bs.modal", $.proxy(function(e) {
                if (this.ignoreBackdropClick) {
                    this.ignoreBackdropClick = false;
                    return;
                }
                if (e.target !== e.currentTarget) return;
                this.options.backdrop == "static" ? this.$element[0].focus() : this.hide();
            }, this));
            if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
            ;
            this.$backdrop.addClass("in");
            if (!callback) return;
            doAnimate ? this.$backdrop.one("bsTransitionEnd", callback).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callback();
        } else if (!this.isShown && this.$backdrop) {
            this.$backdrop.removeClass("in");
            var callbackRemove = function() {
                that.removeBackdrop();
                callback && callback();
            };
            $.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", callbackRemove).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callbackRemove();
        } else if (callback) callback();
    };
    // these following methods are used to handle overflowing modals
    Modal.prototype.handleUpdate = function() {
        this.adjustDialog();
    };
    Modal.prototype.adjustDialog = function() {
        var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight;
        this.$element.css({
            paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : "",
            paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ""
        });
    };
    Modal.prototype.resetAdjustments = function() {
        this.$element.css({
            paddingLeft: "",
            paddingRight: ""
        });
    };
    Modal.prototype.checkScrollbar = function() {
        var fullWindowWidth = window.innerWidth;
        if (!fullWindowWidth) {
            var documentElementRect = document.documentElement.getBoundingClientRect();
            fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
        }
        this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
        this.scrollbarWidth = this.measureScrollbar();
    };
    Modal.prototype.setScrollbar = function() {
        var bodyPad = parseInt(this.$body.css("padding-right") || 0, 10);
        this.originalBodyPad = document.body.style.paddingRight || "";
        var scrollbarWidth = this.scrollbarWidth;
        if (this.bodyIsOverflowing) {
            this.$body.css("padding-right", bodyPad + scrollbarWidth);
            $(this.fixedContent).each(function(index, element) {
                var actualPadding = element.style.paddingRight;
                var calculatedPadding = $(element).css("padding-right");
                $(element).data("padding-right", actualPadding).css("padding-right", parseFloat(calculatedPadding) + scrollbarWidth + "px");
            });
        }
    };
    Modal.prototype.resetScrollbar = function() {
        this.$body.css("padding-right", this.originalBodyPad);
        $(this.fixedContent).each(function(index, element) {
            var padding = $(element).data("padding-right");
            $(element).removeData("padding-right");
            element.style.paddingRight = padding ? padding : "";
        });
    };
    Modal.prototype.measureScrollbar = function() {
        var scrollDiv = document.createElement("div");
        scrollDiv.className = "modal-scrollbar-measure";
        this.$body.append(scrollDiv);
        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        this.$body[0].removeChild(scrollDiv);
        return scrollbarWidth;
    };
    // MODAL PLUGIN DEFINITION
    // =======================
    function Plugin(option, _relatedTarget) {
        return this.each(function() {
            var $this = $(this);
            var data = $this.data("bs.modal");
            var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == "object" && option);
            if (!data) $this.data("bs.modal", data = new Modal(this, options));
            if (typeof option == "string") data[option](_relatedTarget);
            else if (options.show) data.show(_relatedTarget);
        });
    }
    var old = $.fn.modal;
    $.fn.modal = Plugin;
    $.fn.modal.Constructor = Modal;
    // MODAL NO CONFLICT
    // =================
    $.fn.modal.noConflict = function() {
        $.fn.modal = old;
        return this;
    };
    // MODAL DATA-API
    // ==============
    $(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function(e) {
        var $this = $(this);
        var href = $this.attr("href");
        var target = $this.attr("data-target") || href && href.replace(/.*(?=#[^\s]+$)/, "") // strip for ie7
        ;
        var $target = $(document).find(target);
        var option = $target.data("bs.modal") ? "toggle" : $.extend({
            remote: !/#/.test(href) && href
        }, $target.data(), $this.data());
        if ($this.is("a")) e.preventDefault();
        $target.one("show.bs.modal", function(showEvent) {
            if (showEvent.isDefaultPrevented()) return; // only register focus restorer if modal will actually get shown
            $target.one("hidden.bs.modal", function() {
                $this.is(":visible") && $this.trigger("focus");
            });
        });
        Plugin.call($target, option, this);
    });
})(jQuery);


/* ========================================================================
 * Bootstrap: tooltip.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */ (function($) {
    "use strict";
    var DISALLOWED_ATTRIBUTES = [
        "sanitize",
        "whiteList",
        "sanitizeFn"
    ];
    var uriAttrs = [
        "background",
        "cite",
        "href",
        "itemtype",
        "longdesc",
        "poster",
        "src",
        "xlink:href"
    ];
    var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
    var DefaultWhitelist = {
        // Global attributes allowed on any supplied element below.
        "*": [
            "class",
            "dir",
            "id",
            "lang",
            "role",
            ARIA_ATTRIBUTE_PATTERN
        ],
        a: [
            "target",
            "href",
            "title",
            "rel"
        ],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        div: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: [
            "src",
            "alt",
            "title",
            "width",
            "height"
        ],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
    };
    /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */ var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
    /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */ var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;
    function allowedAttribute(attr, allowedAttributeList) {
        var attrName = attr.nodeName.toLowerCase();
        if ($.inArray(attrName, allowedAttributeList) !== -1) {
            if ($.inArray(attrName, uriAttrs) !== -1) return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN));
            return true;
        }
        var regExp = $(allowedAttributeList).filter(function(index, value) {
            return value instanceof RegExp;
        });
        // Check if a regular expression validates the attribute.
        for(var i = 0, l = regExp.length; i < l; i++){
            if (attrName.match(regExp[i])) return true;
        }
        return false;
    }
    function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
        if (unsafeHtml.length === 0) return unsafeHtml;
        if (sanitizeFn && typeof sanitizeFn === "function") return sanitizeFn(unsafeHtml);
        // IE 8 and below don't support createHTMLDocument
        if (!document.implementation || !document.implementation.createHTMLDocument) return unsafeHtml;
        var createdDocument = document.implementation.createHTMLDocument("sanitization");
        createdDocument.body.innerHTML = unsafeHtml;
        var whitelistKeys = $.map(whiteList, function(el, i) {
            return i;
        });
        var elements = $(createdDocument.body).find("*");
        for(var i = 0, len = elements.length; i < len; i++){
            var el = elements[i];
            var elName = el.nodeName.toLowerCase();
            if ($.inArray(elName, whitelistKeys) === -1) {
                el.parentNode.removeChild(el);
                continue;
            }
            var attributeList = $.map(el.attributes, function(el) {
                return el;
            });
            var whitelistedAttributes = [].concat(whiteList["*"] || [], whiteList[elName] || []);
            for(var j = 0, len2 = attributeList.length; j < len2; j++)if (!allowedAttribute(attributeList[j], whitelistedAttributes)) el.removeAttribute(attributeList[j].nodeName);
        }
        return createdDocument.body.innerHTML;
    }
    // TOOLTIP PUBLIC CLASS DEFINITION
    // ===============================
    var Tooltip = function(element, options) {
        this.type = null;
        this.options = null;
        this.enabled = null;
        this.timeout = null;
        this.hoverState = null;
        this.$element = null;
        this.inState = null;
        this.init("tooltip", element, options);
    };
    Tooltip.VERSION = "3.4.1";
    Tooltip.TRANSITION_DURATION = 150;
    Tooltip.DEFAULTS = {
        animation: true,
        placement: "top",
        selector: false,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: false,
        container: false,
        viewport: {
            selector: "body",
            padding: 0
        },
        sanitize: true,
        sanitizeFn: null,
        whiteList: DefaultWhitelist
    };
    Tooltip.prototype.init = function(type, element, options) {
        this.enabled = true;
        this.type = type;
        this.$element = $(element);
        this.options = this.getOptions(options);
        this.$viewport = this.options.viewport && $(document).find($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport);
        this.inState = {
            click: false,
            hover: false,
            focus: false
        };
        if (this.$element[0] instanceof document.constructor && !this.options.selector) throw new Error("`selector` option must be specified when initializing " + this.type + " on the window.document object!");
        var triggers = this.options.trigger.split(" ");
        for(var i = triggers.length; i--;){
            var trigger = triggers[i];
            if (trigger == "click") this.$element.on("click." + this.type, this.options.selector, $.proxy(this.toggle, this));
            else if (trigger != "manual") {
                var eventIn = trigger == "hover" ? "mouseenter" : "focusin";
                var eventOut = trigger == "hover" ? "mouseleave" : "focusout";
                this.$element.on(eventIn + "." + this.type, this.options.selector, $.proxy(this.enter, this));
                this.$element.on(eventOut + "." + this.type, this.options.selector, $.proxy(this.leave, this));
            }
        }
        this.options.selector ? this._options = $.extend({}, this.options, {
            trigger: "manual",
            selector: ""
        }) : this.fixTitle();
    };
    Tooltip.prototype.getDefaults = function() {
        return Tooltip.DEFAULTS;
    };
    Tooltip.prototype.getOptions = function(options) {
        var dataAttributes = this.$element.data();
        for(var dataAttr in dataAttributes)if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) delete dataAttributes[dataAttr];
        options = $.extend({}, this.getDefaults(), dataAttributes, options);
        if (options.delay && typeof options.delay == "number") options.delay = {
            show: options.delay,
            hide: options.delay
        };
        if (options.sanitize) options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn);
        return options;
    };
    Tooltip.prototype.getDelegateOptions = function() {
        var options = {};
        var defaults = this.getDefaults();
        this._options && $.each(this._options, function(key, value) {
            if (defaults[key] != value) options[key] = value;
        });
        return options;
    };
    Tooltip.prototype.enter = function(obj) {
        var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data("bs." + this.type);
        if (!self) {
            self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
            $(obj.currentTarget).data("bs." + this.type, self);
        }
        if (obj instanceof $.Event) self.inState[obj.type == "focusin" ? "focus" : "hover"] = true;
        if (self.tip().hasClass("in") || self.hoverState == "in") {
            self.hoverState = "in";
            return;
        }
        clearTimeout(self.timeout);
        self.hoverState = "in";
        if (!self.options.delay || !self.options.delay.show) return self.show();
        self.timeout = setTimeout(function() {
            if (self.hoverState == "in") self.show();
        }, self.options.delay.show);
    };
    Tooltip.prototype.isInStateTrue = function() {
        for(var key in this.inState){
            if (this.inState[key]) return true;
        }
        return false;
    };
    Tooltip.prototype.leave = function(obj) {
        var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data("bs." + this.type);
        if (!self) {
            self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
            $(obj.currentTarget).data("bs." + this.type, self);
        }
        if (obj instanceof $.Event) self.inState[obj.type == "focusout" ? "focus" : "hover"] = false;
        if (self.isInStateTrue()) return;
        clearTimeout(self.timeout);
        self.hoverState = "out";
        if (!self.options.delay || !self.options.delay.hide) return self.hide();
        self.timeout = setTimeout(function() {
            if (self.hoverState == "out") self.hide();
        }, self.options.delay.hide);
    };
    Tooltip.prototype.show = function() {
        var e = $.Event("show.bs." + this.type);
        if (this.hasContent() && this.enabled) {
            this.$element.trigger(e);
            var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
            if (e.isDefaultPrevented() || !inDom) return;
            var that = this;
            var $tip = this.tip();
            var tipId = this.getUID(this.type);
            this.setContent();
            $tip.attr("id", tipId);
            this.$element.attr("aria-describedby", tipId);
            if (this.options.animation) $tip.addClass("fade");
            var placement = typeof this.options.placement == "function" ? this.options.placement.call(this, $tip[0], this.$element[0]) : this.options.placement;
            var autoToken = /\s?auto?\s?/i;
            var autoPlace = autoToken.test(placement);
            if (autoPlace) placement = placement.replace(autoToken, "") || "top";
            $tip.detach().css({
                top: 0,
                left: 0,
                display: "block"
            }).addClass(placement).data("bs." + this.type, this);
            this.options.container ? $tip.appendTo($(document).find(this.options.container)) : $tip.insertAfter(this.$element);
            this.$element.trigger("inserted.bs." + this.type);
            var pos = this.getPosition();
            var actualWidth = $tip[0].offsetWidth;
            var actualHeight = $tip[0].offsetHeight;
            if (autoPlace) {
                var orgPlacement = placement;
                var viewportDim = this.getPosition(this.$viewport);
                placement = placement == "bottom" && pos.bottom + actualHeight > viewportDim.bottom ? "top" : placement == "top" && pos.top - actualHeight < viewportDim.top ? "bottom" : placement == "right" && pos.right + actualWidth > viewportDim.width ? "left" : placement == "left" && pos.left - actualWidth < viewportDim.left ? "right" : placement;
                $tip.removeClass(orgPlacement).addClass(placement);
            }
            var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);
            this.applyPlacement(calculatedOffset, placement);
            var complete = function() {
                var prevHoverState = that.hoverState;
                that.$element.trigger("shown.bs." + that.type);
                that.hoverState = null;
                if (prevHoverState == "out") that.leave(that);
            };
            $.support.transition && this.$tip.hasClass("fade") ? $tip.one("bsTransitionEnd", complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
        }
    };
    Tooltip.prototype.applyPlacement = function(offset, placement) {
        var $tip = this.tip();
        var width = $tip[0].offsetWidth;
        var height = $tip[0].offsetHeight;
        // manually read margins because getBoundingClientRect includes difference
        var marginTop = parseInt($tip.css("margin-top"), 10);
        var marginLeft = parseInt($tip.css("margin-left"), 10);
        // we must check for NaN for ie 8/9
        if (isNaN(marginTop)) marginTop = 0;
        if (isNaN(marginLeft)) marginLeft = 0;
        offset.top += marginTop;
        offset.left += marginLeft;
        // $.fn.offset doesn't round pixel values
        // so we use setOffset directly with our own function B-0
        $.offset.setOffset($tip[0], $.extend({
            using: function(props) {
                $tip.css({
                    top: Math.round(props.top),
                    left: Math.round(props.left)
                });
            }
        }, offset), 0);
        $tip.addClass("in");
        // check to see if placing tip in new offset caused the tip to resize itself
        var actualWidth = $tip[0].offsetWidth;
        var actualHeight = $tip[0].offsetHeight;
        if (placement == "top" && actualHeight != height) offset.top = offset.top + height - actualHeight;
        var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);
        if (delta.left) offset.left += delta.left;
        else offset.top += delta.top;
        var isVertical = /top|bottom/.test(placement);
        var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
        var arrowOffsetPosition = isVertical ? "offsetWidth" : "offsetHeight";
        $tip.offset(offset);
        this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical);
    };
    Tooltip.prototype.replaceArrow = function(delta, dimension, isVertical) {
        this.arrow().css(isVertical ? "left" : "top", 50 * (1 - delta / dimension) + "%").css(isVertical ? "top" : "left", "");
    };
    Tooltip.prototype.setContent = function() {
        var $tip = this.tip();
        var title = this.getTitle();
        if (this.options.html) {
            if (this.options.sanitize) title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn);
            $tip.find(".tooltip-inner").html(title);
        } else $tip.find(".tooltip-inner").text(title);
        $tip.removeClass("fade in top bottom left right");
    };
    Tooltip.prototype.hide = function(callback) {
        var that = this;
        var $tip = $(this.$tip);
        var e = $.Event("hide.bs." + this.type);
        function complete() {
            if (that.hoverState != "in") $tip.detach();
            if (that.$element) that.$element.removeAttr("aria-describedby").trigger("hidden.bs." + that.type);
            callback && callback();
        }
        this.$element.trigger(e);
        if (e.isDefaultPrevented()) return;
        $tip.removeClass("in");
        $.support.transition && $tip.hasClass("fade") ? $tip.one("bsTransitionEnd", complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
        this.hoverState = null;
        return this;
    };
    Tooltip.prototype.fixTitle = function() {
        var $e = this.$element;
        if ($e.attr("title") || typeof $e.attr("data-original-title") != "string") $e.attr("data-original-title", $e.attr("title") || "").attr("title", "");
    };
    Tooltip.prototype.hasContent = function() {
        return this.getTitle();
    };
    Tooltip.prototype.getPosition = function($element) {
        $element = $element || this.$element;
        var el = $element[0];
        var isBody = el.tagName == "BODY";
        var elRect = el.getBoundingClientRect();
        if (elRect.width == null) // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
        elRect = $.extend({}, elRect, {
            width: elRect.right - elRect.left,
            height: elRect.bottom - elRect.top
        });
        var isSvg = window.SVGElement && el instanceof window.SVGElement;
        // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
        // See https://github.com/twbs/bootstrap/issues/20280
        var elOffset = isBody ? {
            top: 0,
            left: 0
        } : isSvg ? null : $element.offset();
        var scroll = {
            scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop()
        };
        var outerDims = isBody ? {
            width: $(window).width(),
            height: $(window).height()
        } : null;
        return $.extend({}, elRect, scroll, outerDims, elOffset);
    };
    Tooltip.prototype.getCalculatedOffset = function(placement, pos, actualWidth, actualHeight) {
        return placement == "bottom" ? {
            top: pos.top + pos.height,
            left: pos.left + pos.width / 2 - actualWidth / 2
        } : placement == "top" ? {
            top: pos.top - actualHeight,
            left: pos.left + pos.width / 2 - actualWidth / 2
        } : placement == "left" ? {
            top: pos.top + pos.height / 2 - actualHeight / 2,
            left: pos.left - actualWidth
        } : /* placement == 'right' */ {
            top: pos.top + pos.height / 2 - actualHeight / 2,
            left: pos.left + pos.width
        };
    };
    Tooltip.prototype.getViewportAdjustedDelta = function(placement, pos, actualWidth, actualHeight) {
        var delta = {
            top: 0,
            left: 0
        };
        if (!this.$viewport) return delta;
        var viewportPadding = this.options.viewport && this.options.viewport.padding || 0;
        var viewportDimensions = this.getPosition(this.$viewport);
        if (/right|left/.test(placement)) {
            var topEdgeOffset = pos.top - viewportPadding - viewportDimensions.scroll;
            var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight;
            if (topEdgeOffset < viewportDimensions.top) delta.top = viewportDimensions.top - topEdgeOffset;
            else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
        } else {
            var leftEdgeOffset = pos.left - viewportPadding;
            var rightEdgeOffset = pos.left + viewportPadding + actualWidth;
            if (leftEdgeOffset < viewportDimensions.left) delta.left = viewportDimensions.left - leftEdgeOffset;
            else if (rightEdgeOffset > viewportDimensions.right) delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
        }
        return delta;
    };
    Tooltip.prototype.getTitle = function() {
        var title;
        var $e = this.$element;
        var o = this.options;
        title = $e.attr("data-original-title") || (typeof o.title == "function" ? o.title.call($e[0]) : o.title);
        return title;
    };
    Tooltip.prototype.getUID = function(prefix) {
        do prefix += ~~(Math.random() * 1000000);
        while (document.getElementById(prefix));
        return prefix;
    };
    Tooltip.prototype.tip = function() {
        if (!this.$tip) {
            this.$tip = $(this.options.template);
            if (this.$tip.length != 1) throw new Error(this.type + " `template` option must consist of exactly 1 top-level element!");
        }
        return this.$tip;
    };
    Tooltip.prototype.arrow = function() {
        return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow");
    };
    Tooltip.prototype.enable = function() {
        this.enabled = true;
    };
    Tooltip.prototype.disable = function() {
        this.enabled = false;
    };
    Tooltip.prototype.toggleEnabled = function() {
        this.enabled = !this.enabled;
    };
    Tooltip.prototype.toggle = function(e) {
        var self = this;
        if (e) {
            self = $(e.currentTarget).data("bs." + this.type);
            if (!self) {
                self = new this.constructor(e.currentTarget, this.getDelegateOptions());
                $(e.currentTarget).data("bs." + this.type, self);
            }
        }
        if (e) {
            self.inState.click = !self.inState.click;
            if (self.isInStateTrue()) self.enter(self);
            else self.leave(self);
        } else self.tip().hasClass("in") ? self.leave(self) : self.enter(self);
    };
    Tooltip.prototype.destroy = function() {
        var that = this;
        clearTimeout(this.timeout);
        this.hide(function() {
            that.$element.off("." + that.type).removeData("bs." + that.type);
            if (that.$tip) that.$tip.detach();
            that.$tip = null;
            that.$arrow = null;
            that.$viewport = null;
            that.$element = null;
        });
    };
    Tooltip.prototype.sanitizeHtml = function(unsafeHtml) {
        return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn);
    };
    // TOOLTIP PLUGIN DEFINITION
    // =========================
    function Plugin(option) {
        return this.each(function() {
            var $this = $(this);
            var data = $this.data("bs.tooltip");
            var options = typeof option == "object" && option;
            if (!data && /destroy|hide/.test(option)) return;
            if (!data) $this.data("bs.tooltip", data = new Tooltip(this, options));
            if (typeof option == "string") data[option]();
        });
    }
    var old = $.fn.tooltip;
    $.fn.tooltip = Plugin;
    $.fn.tooltip.Constructor = Tooltip;
    // TOOLTIP NO CONFLICT
    // ===================
    $.fn.tooltip.noConflict = function() {
        $.fn.tooltip = old;
        return this;
    };
})(jQuery);


/* ========================================================================
 * Bootstrap: popover.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */ (function($) {
    "use strict";
    // POPOVER PUBLIC CLASS DEFINITION
    // ===============================
    var Popover = function(element, options) {
        this.init("popover", element, options);
    };
    if (!$.fn.tooltip) throw new Error("Popover requires tooltip.js");
    Popover.VERSION = "3.4.1";
    Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
        placement: "right",
        trigger: "click",
        content: "",
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
    });
    // NOTE: POPOVER EXTENDS tooltip.js
    // ================================
    Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype);
    Popover.prototype.constructor = Popover;
    Popover.prototype.getDefaults = function() {
        return Popover.DEFAULTS;
    };
    Popover.prototype.setContent = function() {
        var $tip = this.tip();
        var title = this.getTitle();
        var content = this.getContent();
        if (this.options.html) {
            var typeContent = typeof content;
            if (this.options.sanitize) {
                title = this.sanitizeHtml(title);
                if (typeContent === "string") content = this.sanitizeHtml(content);
            }
            $tip.find(".popover-title").html(title);
            $tip.find(".popover-content").children().detach().end()[typeContent === "string" ? "html" : "append"](content);
        } else {
            $tip.find(".popover-title").text(title);
            $tip.find(".popover-content").children().detach().end().text(content);
        }
        $tip.removeClass("fade top bottom left right in");
        // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
        // this manually by checking the contents.
        if (!$tip.find(".popover-title").html()) $tip.find(".popover-title").hide();
    };
    Popover.prototype.hasContent = function() {
        return this.getTitle() || this.getContent();
    };
    Popover.prototype.getContent = function() {
        var $e = this.$element;
        var o = this.options;
        return $e.attr("data-content") || (typeof o.content == "function" ? o.content.call($e[0]) : o.content);
    };
    Popover.prototype.arrow = function() {
        return this.$arrow = this.$arrow || this.tip().find(".arrow");
    };
    // POPOVER PLUGIN DEFINITION
    // =========================
    function Plugin(option) {
        return this.each(function() {
            var $this = $(this);
            var data = $this.data("bs.popover");
            var options = typeof option == "object" && option;
            if (!data && /destroy|hide/.test(option)) return;
            if (!data) $this.data("bs.popover", data = new Popover(this, options));
            if (typeof option == "string") data[option]();
        });
    }
    var old = $.fn.popover;
    $.fn.popover = Plugin;
    $.fn.popover.Constructor = Popover;
    // POPOVER NO CONFLICT
    // ===================
    $.fn.popover.noConflict = function() {
        $.fn.popover = old;
        return this;
    };
})(jQuery);


/* ========================================================================
 * Bootstrap: scrollspy.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */ (function($) {
    "use strict";
    // SCROLLSPY CLASS DEFINITION
    // ==========================
    function ScrollSpy(element, options) {
        this.$body = $(document.body);
        this.$scrollElement = $(element).is(document.body) ? $(window) : $(element);
        this.options = $.extend({}, ScrollSpy.DEFAULTS, options);
        this.selector = (this.options.target || "") + " .nav li > a";
        this.offsets = [];
        this.targets = [];
        this.activeTarget = null;
        this.scrollHeight = 0;
        this.$scrollElement.on("scroll.bs.scrollspy", $.proxy(this.process, this));
        this.refresh();
        this.process();
    }
    ScrollSpy.VERSION = "3.4.1";
    ScrollSpy.DEFAULTS = {
        offset: 10
    };
    ScrollSpy.prototype.getScrollHeight = function() {
        return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
    };
    ScrollSpy.prototype.refresh = function() {
        var that = this;
        var offsetMethod = "offset";
        var offsetBase = 0;
        this.offsets = [];
        this.targets = [];
        this.scrollHeight = this.getScrollHeight();
        if (!$.isWindow(this.$scrollElement[0])) {
            offsetMethod = "position";
            offsetBase = this.$scrollElement.scrollTop();
        }
        this.$body.find(this.selector).map(function() {
            var $el = $(this);
            var href = $el.data("target") || $el.attr("href");
            var $href = /^#./.test(href) && $(href);
            return $href && $href.length && $href.is(":visible") && [
                [
                    $href[offsetMethod]().top + offsetBase,
                    href
                ]
            ] || null;
        }).sort(function(a, b) {
            return a[0] - b[0];
        }).each(function() {
            that.offsets.push(this[0]);
            that.targets.push(this[1]);
        });
    };
    ScrollSpy.prototype.process = function() {
        var scrollTop = this.$scrollElement.scrollTop() + this.options.offset;
        var scrollHeight = this.getScrollHeight();
        var maxScroll = this.options.offset + scrollHeight - this.$scrollElement.height();
        var offsets = this.offsets;
        var targets = this.targets;
        var activeTarget = this.activeTarget;
        var i;
        if (this.scrollHeight != scrollHeight) this.refresh();
        if (scrollTop >= maxScroll) return activeTarget != (i = targets[targets.length - 1]) && this.activate(i);
        if (activeTarget && scrollTop < offsets[0]) {
            this.activeTarget = null;
            return this.clear();
        }
        for(i = offsets.length; i--;)activeTarget != targets[i] && scrollTop >= offsets[i] && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1]) && this.activate(targets[i]);
    };
    ScrollSpy.prototype.activate = function(target) {
        this.activeTarget = target;
        this.clear();
        var selector = this.selector + '[data-target="' + target + '"],' + this.selector + '[href="' + target + '"]';
        var active = $(selector).parents("li").addClass("active");
        if (active.parent(".dropdown-menu").length) active = active.closest("li.dropdown").addClass("active");
        active.trigger("activate.bs.scrollspy");
    };
    ScrollSpy.prototype.clear = function() {
        $(this.selector).parentsUntil(this.options.target, ".active").removeClass("active");
    };
    // SCROLLSPY PLUGIN DEFINITION
    // ===========================
    function Plugin(option) {
        return this.each(function() {
            var $this = $(this);
            var data = $this.data("bs.scrollspy");
            var options = typeof option == "object" && option;
            if (!data) $this.data("bs.scrollspy", data = new ScrollSpy(this, options));
            if (typeof option == "string") data[option]();
        });
    }
    var old = $.fn.scrollspy;
    $.fn.scrollspy = Plugin;
    $.fn.scrollspy.Constructor = ScrollSpy;
    // SCROLLSPY NO CONFLICT
    // =====================
    $.fn.scrollspy.noConflict = function() {
        $.fn.scrollspy = old;
        return this;
    };
    // SCROLLSPY DATA-API
    // ==================
    $(window).on("load.bs.scrollspy.data-api", function() {
        $('[data-spy="scroll"]').each(function() {
            var $spy = $(this);
            Plugin.call($spy, $spy.data());
        });
    });
})(jQuery);


/* ========================================================================
 * Bootstrap: tab.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */ (function($) {
    "use strict";
    // TAB CLASS DEFINITION
    // ====================
    var Tab = function(element) {
        // jscs:disable requireDollarBeforejQueryAssignment
        this.element = $(element);
    // jscs:enable requireDollarBeforejQueryAssignment
    };
    Tab.VERSION = "3.4.1";
    Tab.TRANSITION_DURATION = 150;
    Tab.prototype.show = function() {
        var $this = this.element;
        var $ul = $this.closest("ul:not(.dropdown-menu)");
        var selector = $this.data("target");
        if (!selector) {
            selector = $this.attr("href");
            selector = selector && selector.replace(/.*(?=#[^\s]*$)/, "") // strip for ie7
            ;
        }
        if ($this.parent("li").hasClass("active")) return;
        var $previous = $ul.find(".active:last a");
        var hideEvent = $.Event("hide.bs.tab", {
            relatedTarget: $this[0]
        });
        var showEvent = $.Event("show.bs.tab", {
            relatedTarget: $previous[0]
        });
        $previous.trigger(hideEvent);
        $this.trigger(showEvent);
        if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return;
        var $target = $(document).find(selector);
        this.activate($this.closest("li"), $ul);
        this.activate($target, $target.parent(), function() {
            $previous.trigger({
                type: "hidden.bs.tab",
                relatedTarget: $this[0]
            });
            $this.trigger({
                type: "shown.bs.tab",
                relatedTarget: $previous[0]
            });
        });
    };
    Tab.prototype.activate = function(element, container, callback) {
        var $active = container.find("> .active");
        var transition = callback && $.support.transition && ($active.length && $active.hasClass("fade") || !!container.find("> .fade").length);
        function next() {
            $active.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", false);
            element.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", true);
            if (transition) {
                element[0].offsetWidth // reflow for transition
                ;
                element.addClass("in");
            } else element.removeClass("fade");
            if (element.parent(".dropdown-menu").length) element.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", true);
            callback && callback();
        }
        $active.length && transition ? $active.one("bsTransitionEnd", next).emulateTransitionEnd(Tab.TRANSITION_DURATION) : next();
        $active.removeClass("in");
    };
    // TAB PLUGIN DEFINITION
    // =====================
    function Plugin(option) {
        return this.each(function() {
            var $this = $(this);
            var data = $this.data("bs.tab");
            if (!data) $this.data("bs.tab", data = new Tab(this));
            if (typeof option == "string") data[option]();
        });
    }
    var old = $.fn.tab;
    $.fn.tab = Plugin;
    $.fn.tab.Constructor = Tab;
    // TAB NO CONFLICT
    // ===============
    $.fn.tab.noConflict = function() {
        $.fn.tab = old;
        return this;
    };
    // TAB DATA-API
    // ============
    var clickHandler = function(e) {
        e.preventDefault();
        Plugin.call($(this), "show");
    };
    $(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', clickHandler).on("click.bs.tab.data-api", '[data-toggle="pill"]', clickHandler);
})(jQuery);


/* ========================================================================
 * Bootstrap: affix.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#affix
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */ (function($) {
    "use strict";
    // AFFIX CLASS DEFINITION
    // ======================
    var Affix = function(element, options) {
        this.options = $.extend({}, Affix.DEFAULTS, options);
        var target = this.options.target === Affix.DEFAULTS.target ? $(this.options.target) : $(document).find(this.options.target);
        this.$target = target.on("scroll.bs.affix.data-api", $.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", $.proxy(this.checkPositionWithEventLoop, this));
        this.$element = $(element);
        this.affixed = null;
        this.unpin = null;
        this.pinnedOffset = null;
        this.checkPosition();
    };
    Affix.VERSION = "3.4.1";
    Affix.RESET = "affix affix-top affix-bottom";
    Affix.DEFAULTS = {
        offset: 0,
        target: window
    };
    Affix.prototype.getState = function(scrollHeight, height, offsetTop, offsetBottom) {
        var scrollTop = this.$target.scrollTop();
        var position = this.$element.offset();
        var targetHeight = this.$target.height();
        if (offsetTop != null && this.affixed == "top") return scrollTop < offsetTop ? "top" : false;
        if (this.affixed == "bottom") {
            if (offsetTop != null) return scrollTop + this.unpin <= position.top ? false : "bottom";
            return scrollTop + targetHeight <= scrollHeight - offsetBottom ? false : "bottom";
        }
        var initializing = this.affixed == null;
        var colliderTop = initializing ? scrollTop : position.top;
        var colliderHeight = initializing ? targetHeight : height;
        if (offsetTop != null && scrollTop <= offsetTop) return "top";
        if (offsetBottom != null && colliderTop + colliderHeight >= scrollHeight - offsetBottom) return "bottom";
        return false;
    };
    Affix.prototype.getPinnedOffset = function() {
        if (this.pinnedOffset) return this.pinnedOffset;
        this.$element.removeClass(Affix.RESET).addClass("affix");
        var scrollTop = this.$target.scrollTop();
        var position = this.$element.offset();
        return this.pinnedOffset = position.top - scrollTop;
    };
    Affix.prototype.checkPositionWithEventLoop = function() {
        setTimeout($.proxy(this.checkPosition, this), 1);
    };
    Affix.prototype.checkPosition = function() {
        if (!this.$element.is(":visible")) return;
        var height = this.$element.height();
        var offset = this.options.offset;
        var offsetTop = offset.top;
        var offsetBottom = offset.bottom;
        var scrollHeight = Math.max($(document).height(), $(document.body).height());
        if (typeof offset != "object") offsetBottom = offsetTop = offset;
        if (typeof offsetTop == "function") offsetTop = offset.top(this.$element);
        if (typeof offsetBottom == "function") offsetBottom = offset.bottom(this.$element);
        var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom);
        if (this.affixed != affix) {
            if (this.unpin != null) this.$element.css("top", "");
            var affixType = "affix" + (affix ? "-" + affix : "");
            var e = $.Event(affixType + ".bs.affix");
            this.$element.trigger(e);
            if (e.isDefaultPrevented()) return;
            this.affixed = affix;
            this.unpin = affix == "bottom" ? this.getPinnedOffset() : null;
            this.$element.removeClass(Affix.RESET).addClass(affixType).trigger(affixType.replace("affix", "affixed") + ".bs.affix");
        }
        if (affix == "bottom") this.$element.offset({
            top: scrollHeight - height - offsetBottom
        });
    };
    // AFFIX PLUGIN DEFINITION
    // =======================
    function Plugin(option) {
        return this.each(function() {
            var $this = $(this);
            var data = $this.data("bs.affix");
            var options = typeof option == "object" && option;
            if (!data) $this.data("bs.affix", data = new Affix(this, options));
            if (typeof option == "string") data[option]();
        });
    }
    var old = $.fn.affix;
    $.fn.affix = Plugin;
    $.fn.affix.Constructor = Affix;
    // AFFIX NO CONFLICT
    // =================
    $.fn.affix.noConflict = function() {
        $.fn.affix = old;
        return this;
    };
    // AFFIX DATA-API
    // ==============
    $(window).on("load", function() {
        $('[data-spy="affix"]').each(function() {
            var $spy = $(this);
            var data = $spy.data();
            data.offset = data.offset || {};
            if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom;
            if (data.offsetTop != null) data.offset.top = data.offsetTop;
            Plugin.call($spy, data);
        });
    });
})(jQuery);




var $539452f92d556c53$exports = {};

/*!
 * Bootstrap-select v1.13.18 (https://developer.snapappointments.com/bootstrap-select)
 *
 * Copyright 2012-2020 SnapAppointments, LLC
 * Licensed under MIT (https://github.com/snapappointments/bootstrap-select/blob/master/LICENSE)
 */ (function(root, factory) {
    if (root === undefined && window !== undefined) root = window;
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module unless amdModuleId is set
    define([
        "jquery"
    ], function(a0) {
        return factory(a0);
    });
    else if (0, $539452f92d556c53$exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    $539452f92d556c53$exports = factory((parcelRequire("9qak9")));
    else factory(root["jQuery"]);
})($539452f92d556c53$exports, function(jQuery) {
    (function($) {
        "use strict";
        var DISALLOWED_ATTRIBUTES = [
            "sanitize",
            "whiteList",
            "sanitizeFn"
        ];
        var uriAttrs = [
            "background",
            "cite",
            "href",
            "itemtype",
            "longdesc",
            "poster",
            "src",
            "xlink:href"
        ];
        var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
        var DefaultWhitelist = {
            // Global attributes allowed on any supplied element below.
            "*": [
                "class",
                "dir",
                "id",
                "lang",
                "role",
                "tabindex",
                "style",
                ARIA_ATTRIBUTE_PATTERN
            ],
            a: [
                "target",
                "href",
                "title",
                "rel"
            ],
            area: [],
            b: [],
            br: [],
            col: [],
            code: [],
            div: [],
            em: [],
            hr: [],
            h1: [],
            h2: [],
            h3: [],
            h4: [],
            h5: [],
            h6: [],
            i: [],
            img: [
                "src",
                "alt",
                "title",
                "width",
                "height"
            ],
            li: [],
            ol: [],
            p: [],
            pre: [],
            s: [],
            small: [],
            span: [],
            sub: [],
            sup: [],
            strong: [],
            u: [],
            ul: []
        };
        /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */ var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
        /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */ var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;
        function allowedAttribute(attr, allowedAttributeList) {
            var attrName = attr.nodeName.toLowerCase();
            if ($.inArray(attrName, allowedAttributeList) !== -1) {
                if ($.inArray(attrName, uriAttrs) !== -1) return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN));
                return true;
            }
            var regExp = $(allowedAttributeList).filter(function(index, value) {
                return value instanceof RegExp;
            });
            // Check if a regular expression validates the attribute.
            for(var i = 0, l = regExp.length; i < l; i++){
                if (attrName.match(regExp[i])) return true;
            }
            return false;
        }
        function sanitizeHtml(unsafeElements, whiteList, sanitizeFn) {
            if (sanitizeFn && typeof sanitizeFn === "function") return sanitizeFn(unsafeElements);
            var whitelistKeys = Object.keys(whiteList);
            for(var i = 0, len = unsafeElements.length; i < len; i++){
                var elements = unsafeElements[i].querySelectorAll("*");
                for(var j = 0, len2 = elements.length; j < len2; j++){
                    var el = elements[j];
                    var elName = el.nodeName.toLowerCase();
                    if (whitelistKeys.indexOf(elName) === -1) {
                        el.parentNode.removeChild(el);
                        continue;
                    }
                    var attributeList = [].slice.call(el.attributes);
                    var whitelistedAttributes = [].concat(whiteList["*"] || [], whiteList[elName] || []);
                    for(var k = 0, len3 = attributeList.length; k < len3; k++){
                        var attr = attributeList[k];
                        if (!allowedAttribute(attr, whitelistedAttributes)) el.removeAttribute(attr.nodeName);
                    }
                }
            }
        }
        // Polyfill for browsers with no classList support
        // Remove in v2
        if (!("classList" in document.createElement("_"))) (function(view) {
            if (!("Element" in view)) return;
            var classListProp = "classList", protoProp = "prototype", elemCtrProto = view.Element[protoProp], objCtr = Object, classListGetter = function() {
                var $elem = $(this);
                return {
                    add: function(classes) {
                        classes = Array.prototype.slice.call(arguments).join(" ");
                        return $elem.addClass(classes);
                    },
                    remove: function(classes) {
                        classes = Array.prototype.slice.call(arguments).join(" ");
                        return $elem.removeClass(classes);
                    },
                    toggle: function(classes, force) {
                        return $elem.toggleClass(classes, force);
                    },
                    contains: function(classes) {
                        return $elem.hasClass(classes);
                    }
                };
            };
            if (objCtr.defineProperty) {
                var classListPropDesc = {
                    get: classListGetter,
                    enumerable: true,
                    configurable: true
                };
                try {
                    objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                } catch (ex) {
                    // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
                    // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
                    if (ex.number === undefined || ex.number === -2146823252) {
                        classListPropDesc.enumerable = false;
                        objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                    }
                }
            } else if (objCtr[protoProp].__defineGetter__) elemCtrProto.__defineGetter__(classListProp, classListGetter);
        })(window);
        var testElement = document.createElement("_");
        testElement.classList.add("c1", "c2");
        if (!testElement.classList.contains("c2")) {
            var _add = DOMTokenList.prototype.add, _remove = DOMTokenList.prototype.remove;
            DOMTokenList.prototype.add = function() {
                Array.prototype.forEach.call(arguments, _add.bind(this));
            };
            DOMTokenList.prototype.remove = function() {
                Array.prototype.forEach.call(arguments, _remove.bind(this));
            };
        }
        testElement.classList.toggle("c3", false);
        // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
        // support the second argument.
        if (testElement.classList.contains("c3")) {
            var _toggle = DOMTokenList.prototype.toggle;
            DOMTokenList.prototype.toggle = function(token, force) {
                if (1 in arguments && !this.contains(token) === !force) return force;
                else return _toggle.call(this, token);
            };
        }
        testElement = null;
        // shallow array comparison
        function isEqual(array1, array2) {
            return array1.length === array2.length && array1.every(function(element, index) {
                return element === array2[index];
            });
        }
        // <editor-fold desc="Shims">
        if (!String.prototype.startsWith) (function() {
            "use strict"; // needed to support `apply`/`call` with `undefined`/`null`
            var defineProperty = function() {
                // IE 8 only supports `Object.defineProperty` on DOM elements
                try {
                    var object = {};
                    var $defineProperty = Object.defineProperty;
                    var result = $defineProperty(object, object, object) && $defineProperty;
                } catch (error) {}
                return result;
            }();
            var toString = {}.toString;
            var startsWith = function(search) {
                if (this == null) throw new TypeError();
                var string = String(this);
                if (search && toString.call(search) == "[object RegExp]") throw new TypeError();
                var stringLength = string.length;
                var searchString = String(search);
                var searchLength = searchString.length;
                var position = arguments.length > 1 ? arguments[1] : undefined;
                // `ToInteger`
                var pos = position ? Number(position) : 0;
                if (pos != pos) pos = 0;
                var start = Math.min(Math.max(pos, 0), stringLength);
                // Avoid the `indexOf` call if no match is possible
                if (searchLength + start > stringLength) return false;
                var index = -1;
                while(++index < searchLength){
                    if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) return false;
                }
                return true;
            };
            if (defineProperty) defineProperty(String.prototype, "startsWith", {
                "value": startsWith,
                "configurable": true,
                "writable": true
            });
            else String.prototype.startsWith = startsWith;
        })();
        if (!Object.keys) Object.keys = function(o, k, r // result array
        ) {
            // initialize object and result
            r = [];
            // iterate over object keys
            for(k in o)// fill result array with non-prototypical keys
            r.hasOwnProperty.call(o, k) && r.push(k);
            // return result
            return r;
        };
        if (HTMLSelectElement && !HTMLSelectElement.prototype.hasOwnProperty("selectedOptions")) Object.defineProperty(HTMLSelectElement.prototype, "selectedOptions", {
            get: function() {
                return this.querySelectorAll(":checked");
            }
        });
        function getSelectedOptions(select, ignoreDisabled) {
            var selectedOptions = select.selectedOptions, options = [], opt;
            if (ignoreDisabled) {
                for(var i = 0, len = selectedOptions.length; i < len; i++){
                    opt = selectedOptions[i];
                    if (!(opt.disabled || opt.parentNode.tagName === "OPTGROUP" && opt.parentNode.disabled)) options.push(opt);
                }
                return options;
            }
            return selectedOptions;
        }
        // much faster than $.val()
        function getSelectValues(select, selectedOptions) {
            var value = [], options = selectedOptions || select.selectedOptions, opt;
            for(var i = 0, len = options.length; i < len; i++){
                opt = options[i];
                if (!(opt.disabled || opt.parentNode.tagName === "OPTGROUP" && opt.parentNode.disabled)) value.push(opt.value);
            }
            if (!select.multiple) return !value.length ? null : value[0];
            return value;
        }
        // set data-selected on select element if the value has been programmatically selected
        // prior to initialization of bootstrap-select
        // * consider removing or replacing an alternative method *
        var valHooks = {
            useDefault: false,
            _set: $.valHooks.select.set
        };
        $.valHooks.select.set = function(elem, value) {
            if (value && !valHooks.useDefault) $(elem).data("selected", true);
            return valHooks._set.apply(this, arguments);
        };
        var changedArguments = null;
        var EventIsSupported = function() {
            try {
                new Event("change");
                return true;
            } catch (e) {
                return false;
            }
        }();
        $.fn.triggerNative = function(eventName) {
            var el = this[0], event;
            if (el.dispatchEvent) {
                if (EventIsSupported) // For modern browsers
                event = new Event(eventName, {
                    bubbles: true
                });
                else {
                    // For IE since it doesn't support Event constructor
                    event = document.createEvent("Event");
                    event.initEvent(eventName, true, false);
                }
                el.dispatchEvent(event);
            } else if (el.fireEvent) {
                event = document.createEventObject();
                event.eventType = eventName;
                el.fireEvent("on" + eventName, event);
            } else // fall back to jQuery.trigger
            this.trigger(eventName);
        };
        // </editor-fold>
        function stringSearch(li, searchString, method, normalize) {
            var stringTypes = [
                "display",
                "subtext",
                "tokens"
            ], searchSuccess = false;
            for(var i = 0; i < stringTypes.length; i++){
                var stringType = stringTypes[i], string = li[stringType];
                if (string) {
                    string = string.toString();
                    // Strip HTML tags. This isn't perfect, but it's much faster than any other method
                    if (stringType === "display") string = string.replace(/<[^>]+>/g, "");
                    if (normalize) string = normalizeToBase(string);
                    string = string.toUpperCase();
                    if (method === "contains") searchSuccess = string.indexOf(searchString) >= 0;
                    else searchSuccess = string.startsWith(searchString);
                    if (searchSuccess) break;
                }
            }
            return searchSuccess;
        }
        function toInteger(value) {
            return parseInt(value, 10) || 0;
        }
        // Borrowed from Lodash (_.deburr)
        /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
            // Latin-1 Supplement block.
            "\xc0": "A",
            "\xc1": "A",
            "\xc2": "A",
            "\xc3": "A",
            "\xc4": "A",
            "\xc5": "A",
            "\xe0": "a",
            "\xe1": "a",
            "\xe2": "a",
            "\xe3": "a",
            "\xe4": "a",
            "\xe5": "a",
            "\xc7": "C",
            "\xe7": "c",
            "\xd0": "D",
            "\xf0": "d",
            "\xc8": "E",
            "\xc9": "E",
            "\xca": "E",
            "\xcb": "E",
            "\xe8": "e",
            "\xe9": "e",
            "\xea": "e",
            "\xeb": "e",
            "\xcc": "I",
            "\xcd": "I",
            "\xce": "I",
            "\xcf": "I",
            "\xec": "i",
            "\xed": "i",
            "\xee": "i",
            "\xef": "i",
            "\xd1": "N",
            "\xf1": "n",
            "\xd2": "O",
            "\xd3": "O",
            "\xd4": "O",
            "\xd5": "O",
            "\xd6": "O",
            "\xd8": "O",
            "\xf2": "o",
            "\xf3": "o",
            "\xf4": "o",
            "\xf5": "o",
            "\xf6": "o",
            "\xf8": "o",
            "\xd9": "U",
            "\xda": "U",
            "\xdb": "U",
            "\xdc": "U",
            "\xf9": "u",
            "\xfa": "u",
            "\xfb": "u",
            "\xfc": "u",
            "\xdd": "Y",
            "\xfd": "y",
            "\xff": "y",
            "\xc6": "Ae",
            "\xe6": "ae",
            "\xde": "Th",
            "\xfe": "th",
            "\xdf": "ss",
            // Latin Extended-A block.
            "\u0100": "A",
            "\u0102": "A",
            "\u0104": "A",
            "\u0101": "a",
            "\u0103": "a",
            "\u0105": "a",
            "\u0106": "C",
            "\u0108": "C",
            "\u010A": "C",
            "\u010C": "C",
            "\u0107": "c",
            "\u0109": "c",
            "\u010B": "c",
            "\u010D": "c",
            "\u010E": "D",
            "\u0110": "D",
            "\u010F": "d",
            "\u0111": "d",
            "\u0112": "E",
            "\u0114": "E",
            "\u0116": "E",
            "\u0118": "E",
            "\u011A": "E",
            "\u0113": "e",
            "\u0115": "e",
            "\u0117": "e",
            "\u0119": "e",
            "\u011B": "e",
            "\u011C": "G",
            "\u011E": "G",
            "\u0120": "G",
            "\u0122": "G",
            "\u011D": "g",
            "\u011F": "g",
            "\u0121": "g",
            "\u0123": "g",
            "\u0124": "H",
            "\u0126": "H",
            "\u0125": "h",
            "\u0127": "h",
            "\u0128": "I",
            "\u012A": "I",
            "\u012C": "I",
            "\u012E": "I",
            "\u0130": "I",
            "\u0129": "i",
            "\u012B": "i",
            "\u012D": "i",
            "\u012F": "i",
            "\u0131": "i",
            "\u0134": "J",
            "\u0135": "j",
            "\u0136": "K",
            "\u0137": "k",
            "\u0138": "k",
            "\u0139": "L",
            "\u013B": "L",
            "\u013D": "L",
            "\u013F": "L",
            "\u0141": "L",
            "\u013A": "l",
            "\u013C": "l",
            "\u013E": "l",
            "\u0140": "l",
            "\u0142": "l",
            "\u0143": "N",
            "\u0145": "N",
            "\u0147": "N",
            "\u014A": "N",
            "\u0144": "n",
            "\u0146": "n",
            "\u0148": "n",
            "\u014B": "n",
            "\u014C": "O",
            "\u014E": "O",
            "\u0150": "O",
            "\u014D": "o",
            "\u014F": "o",
            "\u0151": "o",
            "\u0154": "R",
            "\u0156": "R",
            "\u0158": "R",
            "\u0155": "r",
            "\u0157": "r",
            "\u0159": "r",
            "\u015A": "S",
            "\u015C": "S",
            "\u015E": "S",
            "\u0160": "S",
            "\u015B": "s",
            "\u015D": "s",
            "\u015F": "s",
            "\u0161": "s",
            "\u0162": "T",
            "\u0164": "T",
            "\u0166": "T",
            "\u0163": "t",
            "\u0165": "t",
            "\u0167": "t",
            "\u0168": "U",
            "\u016A": "U",
            "\u016C": "U",
            "\u016E": "U",
            "\u0170": "U",
            "\u0172": "U",
            "\u0169": "u",
            "\u016B": "u",
            "\u016D": "u",
            "\u016F": "u",
            "\u0171": "u",
            "\u0173": "u",
            "\u0174": "W",
            "\u0175": "w",
            "\u0176": "Y",
            "\u0177": "y",
            "\u0178": "Y",
            "\u0179": "Z",
            "\u017B": "Z",
            "\u017D": "Z",
            "\u017A": "z",
            "\u017C": "z",
            "\u017E": "z",
            "\u0132": "IJ",
            "\u0133": "ij",
            "\u0152": "Oe",
            "\u0153": "oe",
            "\u0149": "'n",
            "\u017F": "s"
        };
        /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
        /** Used to compose unicode character classes. */ var rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboMarksExtendedRange = "\\u1ab0-\\u1aff", rsComboMarksSupplementRange = "\\u1dc0-\\u1dff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange + rsComboMarksExtendedRange + rsComboMarksSupplementRange;
        /** Used to compose unicode capture groups. */ var rsCombo = "[" + rsComboRange + "]";
        /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
        function deburrLetter(key) {
            return deburredLetters[key];
        }
        function normalizeToBase(string) {
            string = string.toString();
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        // List of HTML entities for escaping.
        var escapeMap = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#x27;",
            "`": "&#x60;"
        };
        // Functions for escaping and unescaping strings to/from HTML interpolation.
        var createEscaper = function(map) {
            var escaper = function(match) {
                return map[match];
            };
            // Regexes for identifying a key that needs to be escaped.
            var source = "(?:" + Object.keys(map).join("|") + ")";
            var testRegexp = RegExp(source);
            var replaceRegexp = RegExp(source, "g");
            return function(string) {
                string = string == null ? "" : "" + string;
                return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
            };
        };
        var htmlEscape = createEscaper(escapeMap);
        /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var keyCodeMap = {
            32: " ",
            48: "0",
            49: "1",
            50: "2",
            51: "3",
            52: "4",
            53: "5",
            54: "6",
            55: "7",
            56: "8",
            57: "9",
            59: ";",
            65: "A",
            66: "B",
            67: "C",
            68: "D",
            69: "E",
            70: "F",
            71: "G",
            72: "H",
            73: "I",
            74: "J",
            75: "K",
            76: "L",
            77: "M",
            78: "N",
            79: "O",
            80: "P",
            81: "Q",
            82: "R",
            83: "S",
            84: "T",
            85: "U",
            86: "V",
            87: "W",
            88: "X",
            89: "Y",
            90: "Z",
            96: "0",
            97: "1",
            98: "2",
            99: "3",
            100: "4",
            101: "5",
            102: "6",
            103: "7",
            104: "8",
            105: "9"
        };
        var keyCodes = {
            ESCAPE: 27,
            ENTER: 13,
            SPACE: 32,
            TAB: 9,
            ARROW_UP: 38,
            ARROW_DOWN: 40 // KeyboardEvent.which value for down arrow key
        };
        var version = {
            success: false,
            major: "3"
        };
        try {
            version.full = ($.fn.dropdown.Constructor.VERSION || "").split(" ")[0].split(".");
            version.major = version.full[0];
            version.success = true;
        } catch (err) {
        // do nothing
        }
        var selectId = 0;
        var EVENT_KEY = ".bs.select";
        var classNames = {
            DISABLED: "disabled",
            DIVIDER: "divider",
            SHOW: "open",
            DROPUP: "dropup",
            MENU: "dropdown-menu",
            MENURIGHT: "dropdown-menu-right",
            MENULEFT: "dropdown-menu-left",
            // to-do: replace with more advanced template/customization options
            BUTTONCLASS: "btn-default",
            POPOVERHEADER: "popover-title",
            ICONBASE: "glyphicon",
            TICKICON: "glyphicon-ok"
        };
        var Selector = {
            MENU: "." + classNames.MENU
        };
        var elementTemplates = {
            div: document.createElement("div"),
            span: document.createElement("span"),
            i: document.createElement("i"),
            subtext: document.createElement("small"),
            a: document.createElement("a"),
            li: document.createElement("li"),
            whitespace: document.createTextNode("\xa0"),
            fragment: document.createDocumentFragment()
        };
        elementTemplates.noResults = elementTemplates.li.cloneNode(false);
        elementTemplates.noResults.className = "no-results";
        elementTemplates.a.setAttribute("role", "option");
        elementTemplates.a.className = "dropdown-item";
        elementTemplates.subtext.className = "text-muted";
        elementTemplates.text = elementTemplates.span.cloneNode(false);
        elementTemplates.text.className = "text";
        elementTemplates.checkMark = elementTemplates.span.cloneNode(false);
        var REGEXP_ARROW = new RegExp(keyCodes.ARROW_UP + "|" + keyCodes.ARROW_DOWN);
        var REGEXP_TAB_OR_ESCAPE = new RegExp("^" + keyCodes.TAB + "$|" + keyCodes.ESCAPE);
        var generateOption = {
            li: function(content, classes, optgroup) {
                var li = elementTemplates.li.cloneNode(false);
                if (content) {
                    if (content.nodeType === 1 || content.nodeType === 11) li.appendChild(content);
                    else li.innerHTML = content;
                }
                if (typeof classes !== "undefined" && classes !== "") li.className = classes;
                if (typeof optgroup !== "undefined" && optgroup !== null) li.classList.add("optgroup-" + optgroup);
                return li;
            },
            a: function(text, classes, inline) {
                var a = elementTemplates.a.cloneNode(true);
                if (text) {
                    if (text.nodeType === 11) a.appendChild(text);
                    else a.insertAdjacentHTML("beforeend", text);
                }
                if (typeof classes !== "undefined" && classes !== "") a.classList.add.apply(a.classList, classes.split(/\s+/));
                if (inline) a.setAttribute("style", inline);
                return a;
            },
            text: function(options, useFragment) {
                var textElement = elementTemplates.text.cloneNode(false), subtextElement, iconElement;
                if (options.content) textElement.innerHTML = options.content;
                else {
                    textElement.textContent = options.text;
                    if (options.icon) {
                        var whitespace = elementTemplates.whitespace.cloneNode(false);
                        // need to use <i> for icons in the button to prevent a breaking change
                        // note: switch to span in next major release
                        iconElement = (useFragment === true ? elementTemplates.i : elementTemplates.span).cloneNode(false);
                        iconElement.className = this.options.iconBase + " " + options.icon;
                        elementTemplates.fragment.appendChild(iconElement);
                        elementTemplates.fragment.appendChild(whitespace);
                    }
                    if (options.subtext) {
                        subtextElement = elementTemplates.subtext.cloneNode(false);
                        subtextElement.textContent = options.subtext;
                        textElement.appendChild(subtextElement);
                    }
                }
                if (useFragment === true) while(textElement.childNodes.length > 0)elementTemplates.fragment.appendChild(textElement.childNodes[0]);
                else elementTemplates.fragment.appendChild(textElement);
                return elementTemplates.fragment;
            },
            label: function(options) {
                var textElement = elementTemplates.text.cloneNode(false), subtextElement, iconElement;
                textElement.innerHTML = options.display;
                if (options.icon) {
                    var whitespace = elementTemplates.whitespace.cloneNode(false);
                    iconElement = elementTemplates.span.cloneNode(false);
                    iconElement.className = this.options.iconBase + " " + options.icon;
                    elementTemplates.fragment.appendChild(iconElement);
                    elementTemplates.fragment.appendChild(whitespace);
                }
                if (options.subtext) {
                    subtextElement = elementTemplates.subtext.cloneNode(false);
                    subtextElement.textContent = options.subtext;
                    textElement.appendChild(subtextElement);
                }
                elementTemplates.fragment.appendChild(textElement);
                return elementTemplates.fragment;
            }
        };
        function showNoResults(searchMatch, searchValue) {
            if (!searchMatch.length) {
                elementTemplates.noResults.innerHTML = this.options.noneResultsText.replace("{0}", '"' + htmlEscape(searchValue) + '"');
                this.$menuInner[0].firstChild.appendChild(elementTemplates.noResults);
            }
        }
        var Selectpicker = function(element, options) {
            var that = this;
            // bootstrap-select has been initialized - revert valHooks.select.set back to its original function
            if (!valHooks.useDefault) {
                $.valHooks.select.set = valHooks._set;
                valHooks.useDefault = true;
            }
            this.$element = $(element);
            this.$newElement = null;
            this.$button = null;
            this.$menu = null;
            this.options = options;
            this.selectpicker = {
                main: {},
                search: {},
                current: {},
                view: {},
                isSearching: false,
                keydown: {
                    keyHistory: "",
                    resetKeyHistory: {
                        start: function() {
                            return setTimeout(function() {
                                that.selectpicker.keydown.keyHistory = "";
                            }, 800);
                        }
                    }
                }
            };
            this.sizeInfo = {};
            // If we have no title yet, try to pull it from the html title attribute (jQuery doesnt' pick it up as it's not a
            // data-attribute)
            if (this.options.title === null) this.options.title = this.$element.attr("title");
            // Format window padding
            var winPad = this.options.windowPadding;
            if (typeof winPad === "number") this.options.windowPadding = [
                winPad,
                winPad,
                winPad,
                winPad
            ];
            // Expose public methods
            this.val = Selectpicker.prototype.val;
            this.render = Selectpicker.prototype.render;
            this.refresh = Selectpicker.prototype.refresh;
            this.setStyle = Selectpicker.prototype.setStyle;
            this.selectAll = Selectpicker.prototype.selectAll;
            this.deselectAll = Selectpicker.prototype.deselectAll;
            this.destroy = Selectpicker.prototype.destroy;
            this.remove = Selectpicker.prototype.remove;
            this.show = Selectpicker.prototype.show;
            this.hide = Selectpicker.prototype.hide;
            this.init();
        };
        Selectpicker.VERSION = "1.13.18";
        // part of this is duplicated in i18n/defaults-en_US.js. Make sure to update both.
        Selectpicker.DEFAULTS = {
            noneSelectedText: "Nothing selected",
            noneResultsText: "No results matched {0}",
            countSelectedText: function(numSelected, numTotal) {
                return numSelected == 1 ? "{0} item selected" : "{0} items selected";
            },
            maxOptionsText: function(numAll, numGroup) {
                return [
                    numAll == 1 ? "Limit reached ({n} item max)" : "Limit reached ({n} items max)",
                    numGroup == 1 ? "Group limit reached ({n} item max)" : "Group limit reached ({n} items max)"
                ];
            },
            selectAllText: "Select All",
            deselectAllText: "Deselect All",
            doneButton: false,
            doneButtonText: "Close",
            multipleSeparator: ", ",
            styleBase: "btn",
            style: classNames.BUTTONCLASS,
            size: "auto",
            title: null,
            selectedTextFormat: "values",
            width: false,
            container: false,
            hideDisabled: false,
            showSubtext: false,
            showIcon: true,
            showContent: true,
            dropupAuto: true,
            header: false,
            liveSearch: false,
            liveSearchPlaceholder: null,
            liveSearchNormalize: false,
            liveSearchStyle: "contains",
            actionsBox: false,
            iconBase: classNames.ICONBASE,
            tickIcon: classNames.TICKICON,
            showTick: false,
            template: {
                caret: '<span class="caret"></span>'
            },
            maxOptions: false,
            mobile: false,
            selectOnTab: false,
            dropdownAlignRight: false,
            windowPadding: 0,
            virtualScroll: 600,
            display: false,
            sanitize: true,
            sanitizeFn: null,
            whiteList: DefaultWhitelist
        };
        Selectpicker.prototype = {
            constructor: Selectpicker,
            init: function() {
                var that = this, id = this.$element.attr("id"), element = this.$element[0], form = element.form;
                selectId++;
                this.selectId = "bs-select-" + selectId;
                element.classList.add("bs-select-hidden");
                this.multiple = this.$element.prop("multiple");
                this.autofocus = this.$element.prop("autofocus");
                if (element.classList.contains("show-tick")) this.options.showTick = true;
                this.$newElement = this.createDropdown();
                this.buildData();
                this.$element.after(this.$newElement).prependTo(this.$newElement);
                // ensure select is associated with form element if it got unlinked after moving it inside newElement
                if (form && element.form === null) {
                    if (!form.id) form.id = "form-" + this.selectId;
                    element.setAttribute("form", form.id);
                }
                this.$button = this.$newElement.children("button");
                this.$menu = this.$newElement.children(Selector.MENU);
                this.$menuInner = this.$menu.children(".inner");
                this.$searchbox = this.$menu.find("input");
                element.classList.remove("bs-select-hidden");
                if (this.options.dropdownAlignRight === true) this.$menu[0].classList.add(classNames.MENURIGHT);
                if (typeof id !== "undefined") this.$button.attr("data-id", id);
                this.checkDisabled();
                this.clickListener();
                if (this.options.liveSearch) {
                    this.liveSearchListener();
                    this.focusedParent = this.$searchbox[0];
                } else this.focusedParent = this.$menuInner[0];
                this.setStyle();
                this.render();
                this.setWidth();
                if (this.options.container) this.selectPosition();
                else this.$element.on("hide" + EVENT_KEY, function() {
                    if (that.isVirtual()) {
                        // empty menu on close
                        var menuInner = that.$menuInner[0], emptyMenu = menuInner.firstChild.cloneNode(false);
                        // replace the existing UL with an empty one - this is faster than $.empty() or innerHTML = ''
                        menuInner.replaceChild(emptyMenu, menuInner.firstChild);
                        menuInner.scrollTop = 0;
                    }
                });
                this.$menu.data("this", this);
                this.$newElement.data("this", this);
                if (this.options.mobile) this.mobile();
                this.$newElement.on({
                    "hide.bs.dropdown": function(e) {
                        that.$element.trigger("hide" + EVENT_KEY, e);
                    },
                    "hidden.bs.dropdown": function(e) {
                        that.$element.trigger("hidden" + EVENT_KEY, e);
                    },
                    "show.bs.dropdown": function(e) {
                        that.$element.trigger("show" + EVENT_KEY, e);
                    },
                    "shown.bs.dropdown": function(e) {
                        that.$element.trigger("shown" + EVENT_KEY, e);
                    }
                });
                if (element.hasAttribute("required")) this.$element.on("invalid" + EVENT_KEY, function() {
                    that.$button[0].classList.add("bs-invalid");
                    that.$element.on("shown" + EVENT_KEY + ".invalid", function() {
                        that.$element.val(that.$element.val()) // set the value to hide the validation message in Chrome when menu is opened
                        .off("shown" + EVENT_KEY + ".invalid");
                    }).on("rendered" + EVENT_KEY, function() {
                        // if select is no longer invalid, remove the bs-invalid class
                        if (this.validity.valid) that.$button[0].classList.remove("bs-invalid");
                        that.$element.off("rendered" + EVENT_KEY);
                    });
                    that.$button.on("blur" + EVENT_KEY, function() {
                        that.$element.trigger("focus").trigger("blur");
                        that.$button.off("blur" + EVENT_KEY);
                    });
                });
                setTimeout(function() {
                    that.buildList();
                    that.$element.trigger("loaded" + EVENT_KEY);
                });
            },
            createDropdown: function() {
                // Options
                // If we are multiple or showTick option is set, then add the show-tick class
                var showTick = this.multiple || this.options.showTick ? " show-tick" : "", multiselectable = this.multiple ? ' aria-multiselectable="true"' : "", inputGroup = "", autofocus = this.autofocus ? " autofocus" : "";
                if (version.major < 4 && this.$element.parent().hasClass("input-group")) inputGroup = " input-group-btn";
                // Elements
                var drop, header = "", searchbox = "", actionsbox = "", donebutton = "";
                if (this.options.header) header = '<div class="' + classNames.POPOVERHEADER + '">' + '<button type="button" class="close" aria-hidden="true">&times;</button>' + this.options.header + "</div>";
                if (this.options.liveSearch) searchbox = '<div class="bs-searchbox"><input type="search" class="form-control" autocomplete="off"' + (this.options.liveSearchPlaceholder === null ? "" : ' placeholder="' + htmlEscape(this.options.liveSearchPlaceholder) + '"') + ' role="combobox" aria-label="Search" aria-controls="' + this.selectId + '" aria-autocomplete="list">' + "</div>";
                if (this.multiple && this.options.actionsBox) actionsbox = '<div class="bs-actionsbox"><div class="btn-group btn-group-sm btn-block"><button type="button" class="actions-btn bs-select-all btn ' + classNames.BUTTONCLASS + '">' + this.options.selectAllText + "</button>" + '<button type="button" class="actions-btn bs-deselect-all btn ' + classNames.BUTTONCLASS + '">' + this.options.deselectAllText + "</button>" + "</div>" + "</div>";
                if (this.multiple && this.options.doneButton) donebutton = '<div class="bs-donebutton"><div class="btn-group btn-block"><button type="button" class="btn btn-sm ' + classNames.BUTTONCLASS + '">' + this.options.doneButtonText + "</button>" + "</div>" + "</div>";
                drop = '<div class="dropdown bootstrap-select' + showTick + inputGroup + '">' + '<button type="button" tabindex="-1" class="' + this.options.styleBase + ' dropdown-toggle" ' + (this.options.display === "static" ? 'data-display="static"' : "") + 'data-toggle="dropdown"' + autofocus + ' role="combobox" aria-owns="' + this.selectId + '" aria-haspopup="listbox" aria-expanded="false">' + '<div class="filter-option">' + '<div class="filter-option-inner">' + '<div class="filter-option-inner-inner"></div>' + "</div> " + "</div>" + (version.major === "4" ? "" : '<span class="bs-caret">' + this.options.template.caret + "</span>") + "</button>" + '<div class="' + classNames.MENU + " " + (version.major === "4" ? "" : classNames.SHOW) + '">' + header + searchbox + actionsbox + '<div class="inner ' + classNames.SHOW + '" role="listbox" id="' + this.selectId + '" tabindex="-1" ' + multiselectable + ">" + '<ul class="' + classNames.MENU + " inner " + (version.major === "4" ? classNames.SHOW : "") + '" role="presentation">' + "</ul>" + "</div>" + donebutton + "</div>" + "</div>";
                return $(drop);
            },
            setPositionData: function() {
                this.selectpicker.view.canHighlight = [];
                this.selectpicker.view.size = 0;
                this.selectpicker.view.firstHighlightIndex = false;
                for(var i = 0; i < this.selectpicker.current.data.length; i++){
                    var li = this.selectpicker.current.data[i], canHighlight = true;
                    if (li.type === "divider") {
                        canHighlight = false;
                        li.height = this.sizeInfo.dividerHeight;
                    } else if (li.type === "optgroup-label") {
                        canHighlight = false;
                        li.height = this.sizeInfo.dropdownHeaderHeight;
                    } else li.height = this.sizeInfo.liHeight;
                    if (li.disabled) canHighlight = false;
                    this.selectpicker.view.canHighlight.push(canHighlight);
                    if (canHighlight) {
                        this.selectpicker.view.size++;
                        li.posinset = this.selectpicker.view.size;
                        if (this.selectpicker.view.firstHighlightIndex === false) this.selectpicker.view.firstHighlightIndex = i;
                    }
                    li.position = (i === 0 ? 0 : this.selectpicker.current.data[i - 1].position) + li.height;
                }
            },
            isVirtual: function() {
                return this.options.virtualScroll !== false && this.selectpicker.main.elements.length >= this.options.virtualScroll || this.options.virtualScroll === true;
            },
            createView: function(isSearching, setSize, refresh) {
                var that = this, scrollTop = 0, active = [], selected, prevActive;
                this.selectpicker.isSearching = isSearching;
                this.selectpicker.current = isSearching ? this.selectpicker.search : this.selectpicker.main;
                this.setPositionData();
                if (setSize) {
                    if (refresh) scrollTop = this.$menuInner[0].scrollTop;
                    else if (!that.multiple) {
                        var element = that.$element[0], selectedIndex = (element.options[element.selectedIndex] || {}).liIndex;
                        if (typeof selectedIndex === "number" && that.options.size !== false) {
                            var selectedData = that.selectpicker.main.data[selectedIndex], position = selectedData && selectedData.position;
                            if (position) scrollTop = position - (that.sizeInfo.menuInnerHeight + that.sizeInfo.liHeight) / 2;
                        }
                    }
                }
                scroll(scrollTop, true);
                this.$menuInner.off("scroll.createView").on("scroll.createView", function(e, updateValue) {
                    if (!that.noScroll) scroll(this.scrollTop, updateValue);
                    that.noScroll = false;
                });
                function scroll(scrollTop, init) {
                    var size = that.selectpicker.current.elements.length, chunks = [], chunkSize, chunkCount, firstChunk, lastChunk, currentChunk, prevPositions, positionIsDifferent, previousElements, menuIsDifferent = true, isVirtual = that.isVirtual();
                    that.selectpicker.view.scrollTop = scrollTop;
                    chunkSize = Math.ceil(that.sizeInfo.menuInnerHeight / that.sizeInfo.liHeight * 1.5); // number of options in a chunk
                    chunkCount = Math.round(size / chunkSize) || 1; // number of chunks
                    for(var i = 0; i < chunkCount; i++){
                        var endOfChunk = (i + 1) * chunkSize;
                        if (i === chunkCount - 1) endOfChunk = size;
                        chunks[i] = [
                            i * chunkSize + (!i ? 0 : 1),
                            endOfChunk
                        ];
                        if (!size) break;
                        if (currentChunk === undefined && scrollTop - 1 <= that.selectpicker.current.data[endOfChunk - 1].position - that.sizeInfo.menuInnerHeight) currentChunk = i;
                    }
                    if (currentChunk === undefined) currentChunk = 0;
                    prevPositions = [
                        that.selectpicker.view.position0,
                        that.selectpicker.view.position1
                    ];
                    // always display previous, current, and next chunks
                    firstChunk = Math.max(0, currentChunk - 1);
                    lastChunk = Math.min(chunkCount - 1, currentChunk + 1);
                    that.selectpicker.view.position0 = isVirtual === false ? 0 : Math.max(0, chunks[firstChunk][0]) || 0;
                    that.selectpicker.view.position1 = isVirtual === false ? size : Math.min(size, chunks[lastChunk][1]) || 0;
                    positionIsDifferent = prevPositions[0] !== that.selectpicker.view.position0 || prevPositions[1] !== that.selectpicker.view.position1;
                    if (that.activeIndex !== undefined) {
                        prevActive = that.selectpicker.main.elements[that.prevActiveIndex];
                        active = that.selectpicker.main.elements[that.activeIndex];
                        selected = that.selectpicker.main.elements[that.selectedIndex];
                        if (init) {
                            if (that.activeIndex !== that.selectedIndex) that.defocusItem(active);
                            that.activeIndex = undefined;
                        }
                        if (that.activeIndex && that.activeIndex !== that.selectedIndex) that.defocusItem(selected);
                    }
                    if (that.prevActiveIndex !== undefined && that.prevActiveIndex !== that.activeIndex && that.prevActiveIndex !== that.selectedIndex) that.defocusItem(prevActive);
                    if (init || positionIsDifferent) {
                        previousElements = that.selectpicker.view.visibleElements ? that.selectpicker.view.visibleElements.slice() : [];
                        if (isVirtual === false) that.selectpicker.view.visibleElements = that.selectpicker.current.elements;
                        else that.selectpicker.view.visibleElements = that.selectpicker.current.elements.slice(that.selectpicker.view.position0, that.selectpicker.view.position1);
                        that.setOptionStatus();
                        // if searching, check to make sure the list has actually been updated before updating DOM
                        // this prevents unnecessary repaints
                        if (isSearching || isVirtual === false && init) menuIsDifferent = !isEqual(previousElements, that.selectpicker.view.visibleElements);
                        // if virtual scroll is disabled and not searching,
                        // menu should never need to be updated more than once
                        if ((init || isVirtual === true) && menuIsDifferent) {
                            var menuInner = that.$menuInner[0], menuFragment = document.createDocumentFragment(), emptyMenu = menuInner.firstChild.cloneNode(false), marginTop, marginBottom, elements = that.selectpicker.view.visibleElements, toSanitize = [];
                            // replace the existing UL with an empty one - this is faster than $.empty()
                            menuInner.replaceChild(emptyMenu, menuInner.firstChild);
                            for(var i = 0, visibleElementsLen = elements.length; i < visibleElementsLen; i++){
                                var element = elements[i], elText, elementData;
                                if (that.options.sanitize) {
                                    elText = element.lastChild;
                                    if (elText) {
                                        elementData = that.selectpicker.current.data[i + that.selectpicker.view.position0];
                                        if (elementData && elementData.content && !elementData.sanitized) {
                                            toSanitize.push(elText);
                                            elementData.sanitized = true;
                                        }
                                    }
                                }
                                menuFragment.appendChild(element);
                            }
                            if (that.options.sanitize && toSanitize.length) sanitizeHtml(toSanitize, that.options.whiteList, that.options.sanitizeFn);
                            if (isVirtual === true) {
                                marginTop = that.selectpicker.view.position0 === 0 ? 0 : that.selectpicker.current.data[that.selectpicker.view.position0 - 1].position;
                                marginBottom = that.selectpicker.view.position1 > size - 1 ? 0 : that.selectpicker.current.data[size - 1].position - that.selectpicker.current.data[that.selectpicker.view.position1 - 1].position;
                                menuInner.firstChild.style.marginTop = marginTop + "px";
                                menuInner.firstChild.style.marginBottom = marginBottom + "px";
                            } else {
                                menuInner.firstChild.style.marginTop = 0;
                                menuInner.firstChild.style.marginBottom = 0;
                            }
                            menuInner.firstChild.appendChild(menuFragment);
                            // if an option is encountered that is wider than the current menu width, update the menu width accordingly
                            // switch to ResizeObserver with increased browser support
                            if (isVirtual === true && that.sizeInfo.hasScrollBar) {
                                var menuInnerInnerWidth = menuInner.firstChild.offsetWidth;
                                if (init && menuInnerInnerWidth < that.sizeInfo.menuInnerInnerWidth && that.sizeInfo.totalMenuWidth > that.sizeInfo.selectWidth) menuInner.firstChild.style.minWidth = that.sizeInfo.menuInnerInnerWidth + "px";
                                else if (menuInnerInnerWidth > that.sizeInfo.menuInnerInnerWidth) {
                                    // set to 0 to get actual width of menu
                                    that.$menu[0].style.minWidth = 0;
                                    var actualMenuWidth = menuInner.firstChild.offsetWidth;
                                    if (actualMenuWidth > that.sizeInfo.menuInnerInnerWidth) {
                                        that.sizeInfo.menuInnerInnerWidth = actualMenuWidth;
                                        menuInner.firstChild.style.minWidth = that.sizeInfo.menuInnerInnerWidth + "px";
                                    }
                                    // reset to default CSS styling
                                    that.$menu[0].style.minWidth = "";
                                }
                            }
                        }
                    }
                    that.prevActiveIndex = that.activeIndex;
                    if (!that.options.liveSearch) that.$menuInner.trigger("focus");
                    else if (isSearching && init) {
                        var index = 0, newActive;
                        if (!that.selectpicker.view.canHighlight[index]) index = 1 + that.selectpicker.view.canHighlight.slice(1).indexOf(true);
                        newActive = that.selectpicker.view.visibleElements[index];
                        that.defocusItem(that.selectpicker.view.currentActive);
                        that.activeIndex = (that.selectpicker.current.data[index] || {}).index;
                        that.focusItem(newActive);
                    }
                }
                $(window).off("resize" + EVENT_KEY + "." + this.selectId + ".createView").on("resize" + EVENT_KEY + "." + this.selectId + ".createView", function() {
                    var isActive = that.$newElement.hasClass(classNames.SHOW);
                    if (isActive) scroll(that.$menuInner[0].scrollTop);
                });
            },
            focusItem: function(li, liData, noStyle) {
                if (li) {
                    liData = liData || this.selectpicker.main.data[this.activeIndex];
                    var a = li.firstChild;
                    if (a) {
                        a.setAttribute("aria-setsize", this.selectpicker.view.size);
                        a.setAttribute("aria-posinset", liData.posinset);
                        if (noStyle !== true) {
                            this.focusedParent.setAttribute("aria-activedescendant", a.id);
                            li.classList.add("active");
                            a.classList.add("active");
                        }
                    }
                }
            },
            defocusItem: function(li) {
                if (li) {
                    li.classList.remove("active");
                    if (li.firstChild) li.firstChild.classList.remove("active");
                }
            },
            setPlaceholder: function() {
                var that = this, updateIndex = false;
                if (this.options.title && !this.multiple) {
                    if (!this.selectpicker.view.titleOption) this.selectpicker.view.titleOption = document.createElement("option");
                    // this option doesn't create a new <li> element, but does add a new option at the start,
                    // so startIndex should increase to prevent having to check every option for the bs-title-option class
                    updateIndex = true;
                    var element = this.$element[0], selectTitleOption = false, titleNotAppended = !this.selectpicker.view.titleOption.parentNode, selectedIndex = element.selectedIndex, selectedOption = element.options[selectedIndex], navigation = window.performance && window.performance.getEntriesByType("navigation"), // Safari doesn't support getEntriesByType('navigation') - fall back to performance.navigation
                    isNotBackForward = navigation && navigation.length ? navigation[0].type !== "back_forward" : window.performance.navigation.type !== 2;
                    if (titleNotAppended) {
                        // Use native JS to prepend option (faster)
                        this.selectpicker.view.titleOption.className = "bs-title-option";
                        this.selectpicker.view.titleOption.value = "";
                        // Check if selected or data-selected attribute is already set on an option. If not, select the titleOption option.
                        // the selected item may have been changed by user or programmatically before the bootstrap select plugin runs,
                        // if so, the select will have the data-selected attribute
                        selectTitleOption = !selectedOption || selectedIndex === 0 && selectedOption.defaultSelected === false && this.$element.data("selected") === undefined;
                    }
                    if (titleNotAppended || this.selectpicker.view.titleOption.index !== 0) element.insertBefore(this.selectpicker.view.titleOption, element.firstChild);
                    // Set selected *after* appending to select,
                    // otherwise the option doesn't get selected in IE
                    // set using selectedIndex, as setting the selected attr to true here doesn't work in IE11
                    if (selectTitleOption && isNotBackForward) element.selectedIndex = 0;
                    else if (document.readyState !== "complete") // if navigation type is back_forward, there's a chance the select will have its value set by BFCache
                    // wait for that value to be set, then run render again
                    window.addEventListener("pageshow", function() {
                        if (that.selectpicker.view.displayedValue !== element.value) that.render();
                    });
                }
                return updateIndex;
            },
            buildData: function() {
                var optionSelector = ':not([hidden]):not([data-hidden="true"])', mainData = [], optID = 0, startIndex = this.setPlaceholder() ? 1 : 0; // append the titleOption if necessary and skip the first option in the loop
                if (this.options.hideDisabled) optionSelector += ":not(:disabled)";
                var selectOptions = this.$element[0].querySelectorAll("select > *" + optionSelector);
                function addDivider(config) {
                    var previousData = mainData[mainData.length - 1];
                    // ensure optgroup doesn't create back-to-back dividers
                    if (previousData && previousData.type === "divider" && (previousData.optID || config.optID)) return;
                    config = config || {};
                    config.type = "divider";
                    mainData.push(config);
                }
                function addOption(option, config) {
                    config = config || {};
                    config.divider = option.getAttribute("data-divider") === "true";
                    if (config.divider) addDivider({
                        optID: config.optID
                    });
                    else {
                        var liIndex = mainData.length, cssText = option.style.cssText, inlineStyle = cssText ? htmlEscape(cssText) : "", optionClass = (option.className || "") + (config.optgroupClass || "");
                        if (config.optID) optionClass = "opt " + optionClass;
                        config.optionClass = optionClass.trim();
                        config.inlineStyle = inlineStyle;
                        config.text = option.textContent;
                        config.content = option.getAttribute("data-content");
                        config.tokens = option.getAttribute("data-tokens");
                        config.subtext = option.getAttribute("data-subtext");
                        config.icon = option.getAttribute("data-icon");
                        option.liIndex = liIndex;
                        config.display = config.content || config.text;
                        config.type = "option";
                        config.index = liIndex;
                        config.option = option;
                        config.selected = !!option.selected;
                        config.disabled = config.disabled || !!option.disabled;
                        mainData.push(config);
                    }
                }
                function addOptgroup(index, selectOptions) {
                    var optgroup = selectOptions[index], // skip placeholder option
                    previous = index - 1 < startIndex ? false : selectOptions[index - 1], next = selectOptions[index + 1], options = optgroup.querySelectorAll("option" + optionSelector);
                    if (!options.length) return;
                    var config = {
                        display: htmlEscape(optgroup.label),
                        subtext: optgroup.getAttribute("data-subtext"),
                        icon: optgroup.getAttribute("data-icon"),
                        type: "optgroup-label",
                        optgroupClass: " " + (optgroup.className || "")
                    }, headerIndex, lastIndex;
                    optID++;
                    if (previous) addDivider({
                        optID: optID
                    });
                    config.optID = optID;
                    mainData.push(config);
                    for(var j = 0, len = options.length; j < len; j++){
                        var option = options[j];
                        if (j === 0) {
                            headerIndex = mainData.length - 1;
                            lastIndex = headerIndex + len;
                        }
                        addOption(option, {
                            headerIndex: headerIndex,
                            lastIndex: lastIndex,
                            optID: config.optID,
                            optgroupClass: config.optgroupClass,
                            disabled: optgroup.disabled
                        });
                    }
                    if (next) addDivider({
                        optID: optID
                    });
                }
                for(var len = selectOptions.length, i = startIndex; i < len; i++){
                    var item = selectOptions[i];
                    if (item.tagName !== "OPTGROUP") addOption(item, {});
                    else addOptgroup(i, selectOptions);
                }
                this.selectpicker.main.data = this.selectpicker.current.data = mainData;
            },
            buildList: function() {
                var that = this, selectData = this.selectpicker.main.data, mainElements = [], widestOptionLength = 0;
                if ((that.options.showTick || that.multiple) && !elementTemplates.checkMark.parentNode) {
                    elementTemplates.checkMark.className = this.options.iconBase + " " + that.options.tickIcon + " check-mark";
                    elementTemplates.a.appendChild(elementTemplates.checkMark);
                }
                function buildElement(item) {
                    var liElement, combinedLength = 0;
                    switch(item.type){
                        case "divider":
                            liElement = generateOption.li(false, classNames.DIVIDER, item.optID ? item.optID + "div" : undefined);
                            break;
                        case "option":
                            liElement = generateOption.li(generateOption.a(generateOption.text.call(that, item), item.optionClass, item.inlineStyle), "", item.optID);
                            if (liElement.firstChild) liElement.firstChild.id = that.selectId + "-" + item.index;
                            break;
                        case "optgroup-label":
                            liElement = generateOption.li(generateOption.label.call(that, item), "dropdown-header" + item.optgroupClass, item.optID);
                            break;
                    }
                    item.element = liElement;
                    mainElements.push(liElement);
                    // count the number of characters in the option - not perfect, but should work in most cases
                    if (item.display) combinedLength += item.display.length;
                    if (item.subtext) combinedLength += item.subtext.length;
                    // if there is an icon, ensure this option's width is checked
                    if (item.icon) combinedLength += 1;
                    if (combinedLength > widestOptionLength) {
                        widestOptionLength = combinedLength;
                        // guess which option is the widest
                        // use this when calculating menu width
                        // not perfect, but it's fast, and the width will be updating accordingly when scrolling
                        that.selectpicker.view.widestOption = mainElements[mainElements.length - 1];
                    }
                }
                for(var len = selectData.length, i = 0; i < len; i++){
                    var item = selectData[i];
                    buildElement(item);
                }
                this.selectpicker.main.elements = this.selectpicker.current.elements = mainElements;
            },
            findLis: function() {
                return this.$menuInner.find(".inner > li");
            },
            render: function() {
                var that = this, element = this.$element[0], // ensure titleOption is appended and selected (if necessary) before getting selectedOptions
                placeholderSelected = this.setPlaceholder() && element.selectedIndex === 0, selectedOptions = getSelectedOptions(element, this.options.hideDisabled), selectedCount = selectedOptions.length, button = this.$button[0], buttonInner = button.querySelector(".filter-option-inner-inner"), multipleSeparator = document.createTextNode(this.options.multipleSeparator), titleFragment = elementTemplates.fragment.cloneNode(false), showCount, countMax, hasContent = false;
                button.classList.toggle("bs-placeholder", that.multiple ? !selectedCount : !getSelectValues(element, selectedOptions));
                if (!that.multiple && selectedOptions.length === 1) that.selectpicker.view.displayedValue = getSelectValues(element, selectedOptions);
                if (this.options.selectedTextFormat === "static") titleFragment = generateOption.text.call(this, {
                    text: this.options.title
                }, true);
                else {
                    showCount = this.multiple && this.options.selectedTextFormat.indexOf("count") !== -1 && selectedCount > 1;
                    // determine if the number of selected options will be shown (showCount === true)
                    if (showCount) {
                        countMax = this.options.selectedTextFormat.split(">");
                        showCount = countMax.length > 1 && selectedCount > countMax[1] || countMax.length === 1 && selectedCount >= 2;
                    }
                    // only loop through all selected options if the count won't be shown
                    if (showCount === false) {
                        if (!placeholderSelected) {
                            for(var selectedIndex = 0; selectedIndex < selectedCount; selectedIndex++){
                                if (selectedIndex < 50) {
                                    var option = selectedOptions[selectedIndex], thisData = this.selectpicker.main.data[option.liIndex], titleOptions = {};
                                    if (this.multiple && selectedIndex > 0) titleFragment.appendChild(multipleSeparator.cloneNode(false));
                                    if (option.title) titleOptions.text = option.title;
                                    else if (thisData) {
                                        if (thisData.content && that.options.showContent) {
                                            titleOptions.content = thisData.content.toString();
                                            hasContent = true;
                                        } else {
                                            if (that.options.showIcon) titleOptions.icon = thisData.icon;
                                            if (that.options.showSubtext && !that.multiple && thisData.subtext) titleOptions.subtext = " " + thisData.subtext;
                                            titleOptions.text = option.textContent.trim();
                                        }
                                    }
                                    titleFragment.appendChild(generateOption.text.call(this, titleOptions, true));
                                } else break;
                            }
                            // add ellipsis
                            if (selectedCount > 49) titleFragment.appendChild(document.createTextNode("..."));
                        }
                    } else {
                        var optionSelector = ':not([hidden]):not([data-hidden="true"]):not([data-divider="true"])';
                        if (this.options.hideDisabled) optionSelector += ":not(:disabled)";
                        // If this is a multiselect, and selectedTextFormat is count, then show 1 of 2 selected, etc.
                        var totalCount = this.$element[0].querySelectorAll("select > option" + optionSelector + ", optgroup" + optionSelector + " option" + optionSelector).length, tr8nText = typeof this.options.countSelectedText === "function" ? this.options.countSelectedText(selectedCount, totalCount) : this.options.countSelectedText;
                        titleFragment = generateOption.text.call(this, {
                            text: tr8nText.replace("{0}", selectedCount.toString()).replace("{1}", totalCount.toString())
                        }, true);
                    }
                }
                if (this.options.title == undefined) // use .attr to ensure undefined is returned if title attribute is not set
                this.options.title = this.$element.attr("title");
                // If the select doesn't have a title, then use the default, or if nothing is set at all, use noneSelectedText
                if (!titleFragment.childNodes.length) titleFragment = generateOption.text.call(this, {
                    text: typeof this.options.title !== "undefined" ? this.options.title : this.options.noneSelectedText
                }, true);
                // strip all HTML tags and trim the result, then unescape any escaped tags
                button.title = titleFragment.textContent.replace(/<[^>]*>?/g, "").trim();
                if (this.options.sanitize && hasContent) sanitizeHtml([
                    titleFragment
                ], that.options.whiteList, that.options.sanitizeFn);
                buttonInner.innerHTML = "";
                buttonInner.appendChild(titleFragment);
                if (version.major < 4 && this.$newElement[0].classList.contains("bs3-has-addon")) {
                    var filterExpand = button.querySelector(".filter-expand"), clone = buttonInner.cloneNode(true);
                    clone.className = "filter-expand";
                    if (filterExpand) button.replaceChild(clone, filterExpand);
                    else button.appendChild(clone);
                }
                this.$element.trigger("rendered" + EVENT_KEY);
            },
            /**
     * @param [style]
     * @param [status]
     */ setStyle: function(newStyle, status) {
                var button = this.$button[0], newElement = this.$newElement[0], style = this.options.style.trim(), buttonClass;
                if (this.$element.attr("class")) this.$newElement.addClass(this.$element.attr("class").replace(/selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi, ""));
                if (version.major < 4) {
                    newElement.classList.add("bs3");
                    if (newElement.parentNode.classList && newElement.parentNode.classList.contains("input-group") && (newElement.previousElementSibling || newElement.nextElementSibling) && (newElement.previousElementSibling || newElement.nextElementSibling).classList.contains("input-group-addon")) newElement.classList.add("bs3-has-addon");
                }
                if (newStyle) buttonClass = newStyle.trim();
                else buttonClass = style;
                if (status == "add") {
                    if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(" "));
                } else if (status == "remove") {
                    if (buttonClass) button.classList.remove.apply(button.classList, buttonClass.split(" "));
                } else {
                    if (style) button.classList.remove.apply(button.classList, style.split(" "));
                    if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(" "));
                }
            },
            liHeight: function(refresh) {
                if (!refresh && (this.options.size === false || Object.keys(this.sizeInfo).length)) return;
                var newElement = elementTemplates.div.cloneNode(false), menu = elementTemplates.div.cloneNode(false), menuInner = elementTemplates.div.cloneNode(false), menuInnerInner = document.createElement("ul"), divider = elementTemplates.li.cloneNode(false), dropdownHeader = elementTemplates.li.cloneNode(false), li, a = elementTemplates.a.cloneNode(false), text = elementTemplates.span.cloneNode(false), header = this.options.header && this.$menu.find("." + classNames.POPOVERHEADER).length > 0 ? this.$menu.find("." + classNames.POPOVERHEADER)[0].cloneNode(true) : null, search = this.options.liveSearch ? elementTemplates.div.cloneNode(false) : null, actions = this.options.actionsBox && this.multiple && this.$menu.find(".bs-actionsbox").length > 0 ? this.$menu.find(".bs-actionsbox")[0].cloneNode(true) : null, doneButton = this.options.doneButton && this.multiple && this.$menu.find(".bs-donebutton").length > 0 ? this.$menu.find(".bs-donebutton")[0].cloneNode(true) : null, firstOption = this.$element.find("option")[0];
                this.sizeInfo.selectWidth = this.$newElement[0].offsetWidth;
                text.className = "text";
                a.className = "dropdown-item " + (firstOption ? firstOption.className : "");
                newElement.className = this.$menu[0].parentNode.className + " " + classNames.SHOW;
                newElement.style.width = 0; // ensure button width doesn't affect natural width of menu when calculating
                if (this.options.width === "auto") menu.style.minWidth = 0;
                menu.className = classNames.MENU + " " + classNames.SHOW;
                menuInner.className = "inner " + classNames.SHOW;
                menuInnerInner.className = classNames.MENU + " inner " + (version.major === "4" ? classNames.SHOW : "");
                divider.className = classNames.DIVIDER;
                dropdownHeader.className = "dropdown-header";
                text.appendChild(document.createTextNode("\u200B"));
                if (this.selectpicker.current.data.length) for(var i = 0; i < this.selectpicker.current.data.length; i++){
                    var data = this.selectpicker.current.data[i];
                    if (data.type === "option") {
                        li = data.element;
                        break;
                    }
                }
                else {
                    li = elementTemplates.li.cloneNode(false);
                    a.appendChild(text);
                    li.appendChild(a);
                }
                dropdownHeader.appendChild(text.cloneNode(true));
                if (this.selectpicker.view.widestOption) menuInnerInner.appendChild(this.selectpicker.view.widestOption.cloneNode(true));
                menuInnerInner.appendChild(li);
                menuInnerInner.appendChild(divider);
                menuInnerInner.appendChild(dropdownHeader);
                if (header) menu.appendChild(header);
                if (search) {
                    var input = document.createElement("input");
                    search.className = "bs-searchbox";
                    input.className = "form-control";
                    search.appendChild(input);
                    menu.appendChild(search);
                }
                if (actions) menu.appendChild(actions);
                menuInner.appendChild(menuInnerInner);
                menu.appendChild(menuInner);
                if (doneButton) menu.appendChild(doneButton);
                newElement.appendChild(menu);
                document.body.appendChild(newElement);
                var liHeight = li.offsetHeight, dropdownHeaderHeight = dropdownHeader ? dropdownHeader.offsetHeight : 0, headerHeight = header ? header.offsetHeight : 0, searchHeight = search ? search.offsetHeight : 0, actionsHeight = actions ? actions.offsetHeight : 0, doneButtonHeight = doneButton ? doneButton.offsetHeight : 0, dividerHeight = $(divider).outerHeight(true), // fall back to jQuery if getComputedStyle is not supported
                menuStyle = window.getComputedStyle ? window.getComputedStyle(menu) : false, menuWidth = menu.offsetWidth, $menu = menuStyle ? null : $(menu), menuPadding = {
                    vert: toInteger(menuStyle ? menuStyle.paddingTop : $menu.css("paddingTop")) + toInteger(menuStyle ? menuStyle.paddingBottom : $menu.css("paddingBottom")) + toInteger(menuStyle ? menuStyle.borderTopWidth : $menu.css("borderTopWidth")) + toInteger(menuStyle ? menuStyle.borderBottomWidth : $menu.css("borderBottomWidth")),
                    horiz: toInteger(menuStyle ? menuStyle.paddingLeft : $menu.css("paddingLeft")) + toInteger(menuStyle ? menuStyle.paddingRight : $menu.css("paddingRight")) + toInteger(menuStyle ? menuStyle.borderLeftWidth : $menu.css("borderLeftWidth")) + toInteger(menuStyle ? menuStyle.borderRightWidth : $menu.css("borderRightWidth"))
                }, menuExtras = {
                    vert: menuPadding.vert + toInteger(menuStyle ? menuStyle.marginTop : $menu.css("marginTop")) + toInteger(menuStyle ? menuStyle.marginBottom : $menu.css("marginBottom")) + 2,
                    horiz: menuPadding.horiz + toInteger(menuStyle ? menuStyle.marginLeft : $menu.css("marginLeft")) + toInteger(menuStyle ? menuStyle.marginRight : $menu.css("marginRight")) + 2
                }, scrollBarWidth;
                menuInner.style.overflowY = "scroll";
                scrollBarWidth = menu.offsetWidth - menuWidth;
                document.body.removeChild(newElement);
                this.sizeInfo.liHeight = liHeight;
                this.sizeInfo.dropdownHeaderHeight = dropdownHeaderHeight;
                this.sizeInfo.headerHeight = headerHeight;
                this.sizeInfo.searchHeight = searchHeight;
                this.sizeInfo.actionsHeight = actionsHeight;
                this.sizeInfo.doneButtonHeight = doneButtonHeight;
                this.sizeInfo.dividerHeight = dividerHeight;
                this.sizeInfo.menuPadding = menuPadding;
                this.sizeInfo.menuExtras = menuExtras;
                this.sizeInfo.menuWidth = menuWidth;
                this.sizeInfo.menuInnerInnerWidth = menuWidth - menuPadding.horiz;
                this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth;
                this.sizeInfo.scrollBarWidth = scrollBarWidth;
                this.sizeInfo.selectHeight = this.$newElement[0].offsetHeight;
                this.setPositionData();
            },
            getSelectPosition: function() {
                var that = this, $window = $(window), pos = that.$newElement.offset(), $container = $(that.options.container), containerPos;
                if (that.options.container && $container.length && !$container.is("body")) {
                    containerPos = $container.offset();
                    containerPos.top += parseInt($container.css("borderTopWidth"));
                    containerPos.left += parseInt($container.css("borderLeftWidth"));
                } else containerPos = {
                    top: 0,
                    left: 0
                };
                var winPad = that.options.windowPadding;
                this.sizeInfo.selectOffsetTop = pos.top - containerPos.top - $window.scrollTop();
                this.sizeInfo.selectOffsetBot = $window.height() - this.sizeInfo.selectOffsetTop - this.sizeInfo.selectHeight - containerPos.top - winPad[2];
                this.sizeInfo.selectOffsetLeft = pos.left - containerPos.left - $window.scrollLeft();
                this.sizeInfo.selectOffsetRight = $window.width() - this.sizeInfo.selectOffsetLeft - this.sizeInfo.selectWidth - containerPos.left - winPad[1];
                this.sizeInfo.selectOffsetTop -= winPad[0];
                this.sizeInfo.selectOffsetLeft -= winPad[3];
            },
            setMenuSize: function(isAuto) {
                this.getSelectPosition();
                var selectWidth = this.sizeInfo.selectWidth, liHeight = this.sizeInfo.liHeight, headerHeight = this.sizeInfo.headerHeight, searchHeight = this.sizeInfo.searchHeight, actionsHeight = this.sizeInfo.actionsHeight, doneButtonHeight = this.sizeInfo.doneButtonHeight, divHeight = this.sizeInfo.dividerHeight, menuPadding = this.sizeInfo.menuPadding, menuInnerHeight, menuHeight, divLength = 0, minHeight, _minHeight, maxHeight, menuInnerMinHeight, estimate, isDropup;
                if (this.options.dropupAuto) {
                    // Get the estimated height of the menu without scrollbars.
                    // This is useful for smaller menus, where there might be plenty of room
                    // below the button without setting dropup, but we can't know
                    // the exact height of the menu until createView is called later
                    estimate = liHeight * this.selectpicker.current.elements.length + menuPadding.vert;
                    isDropup = this.sizeInfo.selectOffsetTop - this.sizeInfo.selectOffsetBot > this.sizeInfo.menuExtras.vert && estimate + this.sizeInfo.menuExtras.vert + 50 > this.sizeInfo.selectOffsetBot;
                    // ensure dropup doesn't change while searching (so menu doesn't bounce back and forth)
                    if (this.selectpicker.isSearching === true) isDropup = this.selectpicker.dropup;
                    this.$newElement.toggleClass(classNames.DROPUP, isDropup);
                    this.selectpicker.dropup = isDropup;
                }
                if (this.options.size === "auto") {
                    _minHeight = this.selectpicker.current.elements.length > 3 ? this.sizeInfo.liHeight * 3 + this.sizeInfo.menuExtras.vert - 2 : 0;
                    menuHeight = this.sizeInfo.selectOffsetBot - this.sizeInfo.menuExtras.vert;
                    minHeight = _minHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
                    menuInnerMinHeight = Math.max(_minHeight - menuPadding.vert, 0);
                    if (this.$newElement.hasClass(classNames.DROPUP)) menuHeight = this.sizeInfo.selectOffsetTop - this.sizeInfo.menuExtras.vert;
                    maxHeight = menuHeight;
                    menuInnerHeight = menuHeight - headerHeight - searchHeight - actionsHeight - doneButtonHeight - menuPadding.vert;
                } else if (this.options.size && this.options.size != "auto" && this.selectpicker.current.elements.length > this.options.size) {
                    for(var i = 0; i < this.options.size; i++)if (this.selectpicker.current.data[i].type === "divider") divLength++;
                    menuHeight = liHeight * this.options.size + divLength * divHeight + menuPadding.vert;
                    menuInnerHeight = menuHeight - menuPadding.vert;
                    maxHeight = menuHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
                    minHeight = menuInnerMinHeight = "";
                }
                this.$menu.css({
                    "max-height": maxHeight + "px",
                    "overflow": "hidden",
                    "min-height": minHeight + "px"
                });
                this.$menuInner.css({
                    "max-height": menuInnerHeight + "px",
                    "overflow-y": "auto",
                    "min-height": menuInnerMinHeight + "px"
                });
                // ensure menuInnerHeight is always a positive number to prevent issues calculating chunkSize in createView
                this.sizeInfo.menuInnerHeight = Math.max(menuInnerHeight, 1);
                if (this.selectpicker.current.data.length && this.selectpicker.current.data[this.selectpicker.current.data.length - 1].position > this.sizeInfo.menuInnerHeight) {
                    this.sizeInfo.hasScrollBar = true;
                    this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth + this.sizeInfo.scrollBarWidth;
                }
                if (this.options.dropdownAlignRight === "auto") this.$menu.toggleClass(classNames.MENURIGHT, this.sizeInfo.selectOffsetLeft > this.sizeInfo.selectOffsetRight && this.sizeInfo.selectOffsetRight < this.sizeInfo.totalMenuWidth - selectWidth);
                if (this.dropdown && this.dropdown._popper) this.dropdown._popper.update();
            },
            setSize: function(refresh) {
                this.liHeight(refresh);
                if (this.options.header) this.$menu.css("padding-top", 0);
                if (this.options.size !== false) {
                    var that = this, $window = $(window);
                    this.setMenuSize();
                    if (this.options.liveSearch) this.$searchbox.off("input.setMenuSize propertychange.setMenuSize").on("input.setMenuSize propertychange.setMenuSize", function() {
                        return that.setMenuSize();
                    });
                    if (this.options.size === "auto") $window.off("resize" + EVENT_KEY + "." + this.selectId + ".setMenuSize" + " scroll" + EVENT_KEY + "." + this.selectId + ".setMenuSize").on("resize" + EVENT_KEY + "." + this.selectId + ".setMenuSize" + " scroll" + EVENT_KEY + "." + this.selectId + ".setMenuSize", function() {
                        return that.setMenuSize();
                    });
                    else if (this.options.size && this.options.size != "auto" && this.selectpicker.current.elements.length > this.options.size) $window.off("resize" + EVENT_KEY + "." + this.selectId + ".setMenuSize" + " scroll" + EVENT_KEY + "." + this.selectId + ".setMenuSize");
                }
                this.createView(false, true, refresh);
            },
            setWidth: function() {
                var that = this;
                if (this.options.width === "auto") requestAnimationFrame(function() {
                    that.$menu.css("min-width", "0");
                    that.$element.on("loaded" + EVENT_KEY, function() {
                        that.liHeight();
                        that.setMenuSize();
                        // Get correct width if element is hidden
                        var $selectClone = that.$newElement.clone().appendTo("body"), btnWidth = $selectClone.css("width", "auto").children("button").outerWidth();
                        $selectClone.remove();
                        // Set width to whatever's larger, button title or longest option
                        that.sizeInfo.selectWidth = Math.max(that.sizeInfo.totalMenuWidth, btnWidth);
                        that.$newElement.css("width", that.sizeInfo.selectWidth + "px");
                    });
                });
                else if (this.options.width === "fit") {
                    // Remove inline min-width so width can be changed from 'auto'
                    this.$menu.css("min-width", "");
                    this.$newElement.css("width", "").addClass("fit-width");
                } else if (this.options.width) {
                    // Remove inline min-width so width can be changed from 'auto'
                    this.$menu.css("min-width", "");
                    this.$newElement.css("width", this.options.width);
                } else {
                    // Remove inline min-width/width so width can be changed
                    this.$menu.css("min-width", "");
                    this.$newElement.css("width", "");
                }
                // Remove fit-width class if width is changed programmatically
                if (this.$newElement.hasClass("fit-width") && this.options.width !== "fit") this.$newElement[0].classList.remove("fit-width");
            },
            selectPosition: function() {
                this.$bsContainer = $('<div class="bs-container" />');
                var that = this, $container = $(this.options.container), pos, containerPos, actualHeight, getPlacement = function($element) {
                    var containerPosition = {}, // fall back to dropdown's default display setting if display is not manually set
                    display = that.options.display || // Bootstrap 3 doesn't have $.fn.dropdown.Constructor.Default
                    ($.fn.dropdown.Constructor.Default ? $.fn.dropdown.Constructor.Default.display : false);
                    that.$bsContainer.addClass($element.attr("class").replace(/form-control|fit-width/gi, "")).toggleClass(classNames.DROPUP, $element.hasClass(classNames.DROPUP));
                    pos = $element.offset();
                    if (!$container.is("body")) {
                        containerPos = $container.offset();
                        containerPos.top += parseInt($container.css("borderTopWidth")) - $container.scrollTop();
                        containerPos.left += parseInt($container.css("borderLeftWidth")) - $container.scrollLeft();
                    } else containerPos = {
                        top: 0,
                        left: 0
                    };
                    actualHeight = $element.hasClass(classNames.DROPUP) ? 0 : $element[0].offsetHeight;
                    // Bootstrap 4+ uses Popper for menu positioning
                    if (version.major < 4 || display === "static") {
                        containerPosition.top = pos.top - containerPos.top + actualHeight;
                        containerPosition.left = pos.left - containerPos.left;
                    }
                    containerPosition.width = $element[0].offsetWidth;
                    that.$bsContainer.css(containerPosition);
                };
                this.$button.on("click.bs.dropdown.data-api", function() {
                    if (that.isDisabled()) return;
                    getPlacement(that.$newElement);
                    that.$bsContainer.appendTo(that.options.container).toggleClass(classNames.SHOW, !that.$button.hasClass(classNames.SHOW)).append(that.$menu);
                });
                $(window).off("resize" + EVENT_KEY + "." + this.selectId + " scroll" + EVENT_KEY + "." + this.selectId).on("resize" + EVENT_KEY + "." + this.selectId + " scroll" + EVENT_KEY + "." + this.selectId, function() {
                    var isActive = that.$newElement.hasClass(classNames.SHOW);
                    if (isActive) getPlacement(that.$newElement);
                });
                this.$element.on("hide" + EVENT_KEY, function() {
                    that.$menu.data("height", that.$menu.height());
                    that.$bsContainer.detach();
                });
            },
            setOptionStatus: function(selectedOnly) {
                var that = this;
                that.noScroll = false;
                if (that.selectpicker.view.visibleElements && that.selectpicker.view.visibleElements.length) for(var i = 0; i < that.selectpicker.view.visibleElements.length; i++){
                    var liData = that.selectpicker.current.data[i + that.selectpicker.view.position0], option = liData.option;
                    if (option) {
                        if (selectedOnly !== true) that.setDisabled(liData.index, liData.disabled);
                        that.setSelected(liData.index, option.selected);
                    }
                }
            },
            /**
     * @param {number} index - the index of the option that is being changed
     * @param {boolean} selected - true if the option is being selected, false if being deselected
     */ setSelected: function(index, selected) {
                var li = this.selectpicker.main.elements[index], liData = this.selectpicker.main.data[index], activeIndexIsSet = this.activeIndex !== undefined, thisIsActive = this.activeIndex === index, prevActive, a, // if current option is already active
                // OR
                // if the current option is being selected, it's NOT multiple, and
                // activeIndex is undefined:
                //  - when the menu is first being opened, OR
                //  - after a search has been performed, OR
                //  - when retainActive is false when selecting a new option (i.e. index of the newly selected option is not the same as the current activeIndex)
                keepActive = thisIsActive || selected && !this.multiple && !activeIndexIsSet;
                liData.selected = selected;
                a = li.firstChild;
                if (selected) this.selectedIndex = index;
                li.classList.toggle("selected", selected);
                if (keepActive) {
                    this.focusItem(li, liData);
                    this.selectpicker.view.currentActive = li;
                    this.activeIndex = index;
                } else this.defocusItem(li);
                if (a) {
                    a.classList.toggle("selected", selected);
                    if (selected) a.setAttribute("aria-selected", true);
                    else if (this.multiple) a.setAttribute("aria-selected", false);
                    else a.removeAttribute("aria-selected");
                }
                if (!keepActive && !activeIndexIsSet && selected && this.prevActiveIndex !== undefined) {
                    prevActive = this.selectpicker.main.elements[this.prevActiveIndex];
                    this.defocusItem(prevActive);
                }
            },
            /**
     * @param {number} index - the index of the option that is being disabled
     * @param {boolean} disabled - true if the option is being disabled, false if being enabled
     */ setDisabled: function(index, disabled) {
                var li = this.selectpicker.main.elements[index], a;
                this.selectpicker.main.data[index].disabled = disabled;
                a = li.firstChild;
                li.classList.toggle(classNames.DISABLED, disabled);
                if (a) {
                    if (version.major === "4") a.classList.toggle(classNames.DISABLED, disabled);
                    if (disabled) {
                        a.setAttribute("aria-disabled", disabled);
                        a.setAttribute("tabindex", -1);
                    } else {
                        a.removeAttribute("aria-disabled");
                        a.setAttribute("tabindex", 0);
                    }
                }
            },
            isDisabled: function() {
                return this.$element[0].disabled;
            },
            checkDisabled: function() {
                if (this.isDisabled()) {
                    this.$newElement[0].classList.add(classNames.DISABLED);
                    this.$button.addClass(classNames.DISABLED).attr("aria-disabled", true);
                } else if (this.$button[0].classList.contains(classNames.DISABLED)) {
                    this.$newElement[0].classList.remove(classNames.DISABLED);
                    this.$button.removeClass(classNames.DISABLED).attr("aria-disabled", false);
                }
            },
            clickListener: function() {
                var that = this, $document = $(document);
                $document.data("spaceSelect", false);
                this.$button.on("keyup", function(e) {
                    if (/(32)/.test(e.keyCode.toString(10)) && $document.data("spaceSelect")) {
                        e.preventDefault();
                        $document.data("spaceSelect", false);
                    }
                });
                this.$newElement.on("show.bs.dropdown", function() {
                    if (version.major > 3 && !that.dropdown) {
                        that.dropdown = that.$button.data("bs.dropdown");
                        that.dropdown._menu = that.$menu[0];
                    }
                });
                this.$button.on("click.bs.dropdown.data-api", function() {
                    if (!that.$newElement.hasClass(classNames.SHOW)) that.setSize();
                });
                function setFocus() {
                    if (that.options.liveSearch) that.$searchbox.trigger("focus");
                    else that.$menuInner.trigger("focus");
                }
                function checkPopperExists() {
                    if (that.dropdown && that.dropdown._popper && that.dropdown._popper.state.isCreated) setFocus();
                    else requestAnimationFrame(checkPopperExists);
                }
                this.$element.on("shown" + EVENT_KEY, function() {
                    if (that.$menuInner[0].scrollTop !== that.selectpicker.view.scrollTop) that.$menuInner[0].scrollTop = that.selectpicker.view.scrollTop;
                    if (version.major > 3) requestAnimationFrame(checkPopperExists);
                    else setFocus();
                });
                // ensure posinset and setsize are correct before selecting an option via a click
                this.$menuInner.on("mouseenter", "li a", function(e) {
                    var hoverLi = this.parentElement, position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0, index = Array.prototype.indexOf.call(hoverLi.parentElement.children, hoverLi), hoverData = that.selectpicker.current.data[index + position0];
                    that.focusItem(hoverLi, hoverData, true);
                });
                this.$menuInner.on("click", "li a", function(e, retainActive) {
                    var $this = $(this), element = that.$element[0], position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0, clickedData = that.selectpicker.current.data[$this.parent().index() + position0], clickedIndex = clickedData.index, prevValue = getSelectValues(element), prevIndex = element.selectedIndex, prevOption = element.options[prevIndex], triggerChange = true;
                    // Don't close on multi choice menu
                    if (that.multiple && that.options.maxOptions !== 1) e.stopPropagation();
                    e.preventDefault();
                    // Don't run if the select is disabled
                    if (!that.isDisabled() && !$this.parent().hasClass(classNames.DISABLED)) {
                        var option = clickedData.option, $option = $(option), state = option.selected, $optgroup = $option.parent("optgroup"), $optgroupOptions = $optgroup.find("option"), maxOptions = that.options.maxOptions, maxOptionsGrp = $optgroup.data("maxOptions") || false;
                        if (clickedIndex === that.activeIndex) retainActive = true;
                        if (!retainActive) {
                            that.prevActiveIndex = that.activeIndex;
                            that.activeIndex = undefined;
                        }
                        if (!that.multiple) {
                            if (prevOption) prevOption.selected = false;
                            option.selected = true;
                            that.setSelected(clickedIndex, true);
                        } else {
                            option.selected = !state;
                            that.setSelected(clickedIndex, !state);
                            that.focusedParent.focus();
                            if (maxOptions !== false || maxOptionsGrp !== false) {
                                var maxReached = maxOptions < getSelectedOptions(element).length, maxReachedGrp = maxOptionsGrp < $optgroup.find("option:selected").length;
                                if (maxOptions && maxReached || maxOptionsGrp && maxReachedGrp) {
                                    if (maxOptions && maxOptions == 1) {
                                        element.selectedIndex = -1;
                                        option.selected = true;
                                        that.setOptionStatus(true);
                                    } else if (maxOptionsGrp && maxOptionsGrp == 1) {
                                        for(var i = 0; i < $optgroupOptions.length; i++){
                                            var _option = $optgroupOptions[i];
                                            _option.selected = false;
                                            that.setSelected(_option.liIndex, false);
                                        }
                                        option.selected = true;
                                        that.setSelected(clickedIndex, true);
                                    } else {
                                        var maxOptionsText = typeof that.options.maxOptionsText === "string" ? [
                                            that.options.maxOptionsText,
                                            that.options.maxOptionsText
                                        ] : that.options.maxOptionsText, maxOptionsArr = typeof maxOptionsText === "function" ? maxOptionsText(maxOptions, maxOptionsGrp) : maxOptionsText, maxTxt = maxOptionsArr[0].replace("{n}", maxOptions), maxTxtGrp = maxOptionsArr[1].replace("{n}", maxOptionsGrp), $notify = $('<div class="notify"></div>');
                                        // If {var} is set in array, replace it
                                        /** @deprecated */ if (maxOptionsArr[2]) {
                                            maxTxt = maxTxt.replace("{var}", maxOptionsArr[2][maxOptions > 1 ? 0 : 1]);
                                            maxTxtGrp = maxTxtGrp.replace("{var}", maxOptionsArr[2][maxOptionsGrp > 1 ? 0 : 1]);
                                        }
                                        option.selected = false;
                                        that.$menu.append($notify);
                                        if (maxOptions && maxReached) {
                                            $notify.append($("<div>" + maxTxt + "</div>"));
                                            triggerChange = false;
                                            that.$element.trigger("maxReached" + EVENT_KEY);
                                        }
                                        if (maxOptionsGrp && maxReachedGrp) {
                                            $notify.append($("<div>" + maxTxtGrp + "</div>"));
                                            triggerChange = false;
                                            that.$element.trigger("maxReachedGrp" + EVENT_KEY);
                                        }
                                        setTimeout(function() {
                                            that.setSelected(clickedIndex, false);
                                        }, 10);
                                        $notify[0].classList.add("fadeOut");
                                        setTimeout(function() {
                                            $notify.remove();
                                        }, 1050);
                                    }
                                }
                            }
                        }
                        if (!that.multiple || that.multiple && that.options.maxOptions === 1) that.$button.trigger("focus");
                        else if (that.options.liveSearch) that.$searchbox.trigger("focus");
                        // Trigger select 'change'
                        if (triggerChange) {
                            if (that.multiple || prevIndex !== element.selectedIndex) {
                                // $option.prop('selected') is current option state (selected/unselected). prevValue is the value of the select prior to being changed.
                                changedArguments = [
                                    option.index,
                                    $option.prop("selected"),
                                    prevValue
                                ];
                                that.$element.triggerNative("change");
                            }
                        }
                    }
                });
                this.$menu.on("click", "li." + classNames.DISABLED + " a, ." + classNames.POPOVERHEADER + ", ." + classNames.POPOVERHEADER + " :not(.close)", function(e) {
                    if (e.currentTarget == this) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (that.options.liveSearch && !$(e.target).hasClass("close")) that.$searchbox.trigger("focus");
                        else that.$button.trigger("focus");
                    }
                });
                this.$menuInner.on("click", ".divider, .dropdown-header", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (that.options.liveSearch) that.$searchbox.trigger("focus");
                    else that.$button.trigger("focus");
                });
                this.$menu.on("click", "." + classNames.POPOVERHEADER + " .close", function() {
                    that.$button.trigger("click");
                });
                this.$searchbox.on("click", function(e) {
                    e.stopPropagation();
                });
                this.$menu.on("click", ".actions-btn", function(e) {
                    if (that.options.liveSearch) that.$searchbox.trigger("focus");
                    else that.$button.trigger("focus");
                    e.preventDefault();
                    e.stopPropagation();
                    if ($(this).hasClass("bs-select-all")) that.selectAll();
                    else that.deselectAll();
                });
                this.$button.on("focus" + EVENT_KEY, function(e) {
                    var tabindex = that.$element[0].getAttribute("tabindex");
                    // only change when button is actually focused
                    if (tabindex !== undefined && e.originalEvent && e.originalEvent.isTrusted) {
                        // apply select element's tabindex to ensure correct order is followed when tabbing to the next element
                        this.setAttribute("tabindex", tabindex);
                        // set element's tabindex to -1 to allow for reverse tabbing
                        that.$element[0].setAttribute("tabindex", -1);
                        that.selectpicker.view.tabindex = tabindex;
                    }
                }).on("blur" + EVENT_KEY, function(e) {
                    // revert everything to original tabindex
                    if (that.selectpicker.view.tabindex !== undefined && e.originalEvent && e.originalEvent.isTrusted) {
                        that.$element[0].setAttribute("tabindex", that.selectpicker.view.tabindex);
                        this.setAttribute("tabindex", -1);
                        that.selectpicker.view.tabindex = undefined;
                    }
                });
                this.$element.on("change" + EVENT_KEY, function() {
                    that.render();
                    that.$element.trigger("changed" + EVENT_KEY, changedArguments);
                    changedArguments = null;
                }).on("focus" + EVENT_KEY, function() {
                    if (!that.options.mobile) that.$button[0].focus();
                });
            },
            liveSearchListener: function() {
                var that = this;
                this.$button.on("click.bs.dropdown.data-api", function() {
                    if (!!that.$searchbox.val()) {
                        that.$searchbox.val("");
                        that.selectpicker.search.previousValue = undefined;
                    }
                });
                this.$searchbox.on("click.bs.dropdown.data-api focus.bs.dropdown.data-api touchend.bs.dropdown.data-api", function(e) {
                    e.stopPropagation();
                });
                this.$searchbox.on("input propertychange", function() {
                    var searchValue = that.$searchbox[0].value;
                    that.selectpicker.search.elements = [];
                    that.selectpicker.search.data = [];
                    if (searchValue) {
                        var i, searchMatch = [], q = searchValue.toUpperCase(), cache = {}, cacheArr = [], searchStyle = that._searchStyle(), normalizeSearch = that.options.liveSearchNormalize;
                        if (normalizeSearch) q = normalizeToBase(q);
                        for(var i = 0; i < that.selectpicker.main.data.length; i++){
                            var li = that.selectpicker.main.data[i];
                            if (!cache[i]) cache[i] = stringSearch(li, q, searchStyle, normalizeSearch);
                            if (cache[i] && li.headerIndex !== undefined && cacheArr.indexOf(li.headerIndex) === -1) {
                                if (li.headerIndex > 0) {
                                    cache[li.headerIndex - 1] = true;
                                    cacheArr.push(li.headerIndex - 1);
                                }
                                cache[li.headerIndex] = true;
                                cacheArr.push(li.headerIndex);
                                cache[li.lastIndex + 1] = true;
                            }
                            if (cache[i] && li.type !== "optgroup-label") cacheArr.push(i);
                        }
                        for(var i = 0, cacheLen = cacheArr.length; i < cacheLen; i++){
                            var index = cacheArr[i], prevIndex = cacheArr[i - 1], li = that.selectpicker.main.data[index], liPrev = that.selectpicker.main.data[prevIndex];
                            if (li.type !== "divider" || li.type === "divider" && liPrev && liPrev.type !== "divider" && cacheLen - 1 !== i) {
                                that.selectpicker.search.data.push(li);
                                searchMatch.push(that.selectpicker.main.elements[index]);
                            }
                        }
                        that.activeIndex = undefined;
                        that.noScroll = true;
                        that.$menuInner.scrollTop(0);
                        that.selectpicker.search.elements = searchMatch;
                        that.createView(true);
                        showNoResults.call(that, searchMatch, searchValue);
                    } else if (that.selectpicker.search.previousValue) {
                        that.$menuInner.scrollTop(0);
                        that.createView(false);
                    }
                    that.selectpicker.search.previousValue = searchValue;
                });
            },
            _searchStyle: function() {
                return this.options.liveSearchStyle || "contains";
            },
            val: function(value) {
                var element = this.$element[0];
                if (typeof value !== "undefined") {
                    var prevValue = getSelectValues(element);
                    changedArguments = [
                        null,
                        null,
                        prevValue
                    ];
                    this.$element.val(value).trigger("changed" + EVENT_KEY, changedArguments);
                    if (this.$newElement.hasClass(classNames.SHOW)) {
                        if (this.multiple) this.setOptionStatus(true);
                        else {
                            var liSelectedIndex = (element.options[element.selectedIndex] || {}).liIndex;
                            if (typeof liSelectedIndex === "number") {
                                this.setSelected(this.selectedIndex, false);
                                this.setSelected(liSelectedIndex, true);
                            }
                        }
                    }
                    this.render();
                    changedArguments = null;
                    return this.$element;
                } else return this.$element.val();
            },
            changeAll: function(status) {
                if (!this.multiple) return;
                if (typeof status === "undefined") status = true;
                var element = this.$element[0], previousSelected = 0, currentSelected = 0, prevValue = getSelectValues(element);
                element.classList.add("bs-select-hidden");
                for(var i = 0, data = this.selectpicker.current.data, len = data.length; i < len; i++){
                    var liData = data[i], option = liData.option;
                    if (option && !liData.disabled && liData.type !== "divider") {
                        if (liData.selected) previousSelected++;
                        option.selected = status;
                        if (status === true) currentSelected++;
                    }
                }
                element.classList.remove("bs-select-hidden");
                if (previousSelected === currentSelected) return;
                this.setOptionStatus();
                changedArguments = [
                    null,
                    null,
                    prevValue
                ];
                this.$element.triggerNative("change");
            },
            selectAll: function() {
                return this.changeAll(true);
            },
            deselectAll: function() {
                return this.changeAll(false);
            },
            toggle: function(e) {
                e = e || window.event;
                if (e) e.stopPropagation();
                this.$button.trigger("click.bs.dropdown.data-api");
            },
            keydown: function(e) {
                var $this = $(this), isToggle = $this.hasClass("dropdown-toggle"), $parent = isToggle ? $this.closest(".dropdown") : $this.closest(Selector.MENU), that = $parent.data("this"), $items = that.findLis(), index, isActive, liActive, activeLi, offset, updateScroll = false, downOnTab = e.which === keyCodes.TAB && !isToggle && !that.options.selectOnTab, isArrowKey = REGEXP_ARROW.test(e.which) || downOnTab, scrollTop = that.$menuInner[0].scrollTop, isVirtual = that.isVirtual(), position0 = isVirtual === true ? that.selectpicker.view.position0 : 0;
                // do nothing if a function key is pressed
                if (e.which >= 112 && e.which <= 123) return;
                isActive = that.$newElement.hasClass(classNames.SHOW);
                if (!isActive && (isArrowKey || e.which >= 48 && e.which <= 57 || e.which >= 96 && e.which <= 105 || e.which >= 65 && e.which <= 90)) {
                    that.$button.trigger("click.bs.dropdown.data-api");
                    if (that.options.liveSearch) {
                        that.$searchbox.trigger("focus");
                        return;
                    }
                }
                if (e.which === keyCodes.ESCAPE && isActive) {
                    e.preventDefault();
                    that.$button.trigger("click.bs.dropdown.data-api").trigger("focus");
                }
                if (isArrowKey) {
                    if (!$items.length) return;
                    liActive = that.selectpicker.main.elements[that.activeIndex];
                    index = liActive ? Array.prototype.indexOf.call(liActive.parentElement.children, liActive) : -1;
                    if (index !== -1) that.defocusItem(liActive);
                    if (e.which === keyCodes.ARROW_UP) {
                        if (index !== -1) index--;
                        if (index + position0 < 0) index += $items.length;
                        if (!that.selectpicker.view.canHighlight[index + position0]) {
                            index = that.selectpicker.view.canHighlight.slice(0, index + position0).lastIndexOf(true) - position0;
                            if (index === -1) index = $items.length - 1;
                        }
                    } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) {
                        index++;
                        if (index + position0 >= that.selectpicker.view.canHighlight.length) index = that.selectpicker.view.firstHighlightIndex;
                        if (!that.selectpicker.view.canHighlight[index + position0]) index = index + 1 + that.selectpicker.view.canHighlight.slice(index + position0 + 1).indexOf(true);
                    }
                    e.preventDefault();
                    var liActiveIndex = position0 + index;
                    if (e.which === keyCodes.ARROW_UP) {
                        // scroll to bottom and highlight last option
                        if (position0 === 0 && index === $items.length - 1) {
                            that.$menuInner[0].scrollTop = that.$menuInner[0].scrollHeight;
                            liActiveIndex = that.selectpicker.current.elements.length - 1;
                        } else {
                            activeLi = that.selectpicker.current.data[liActiveIndex];
                            offset = activeLi.position - activeLi.height;
                            updateScroll = offset < scrollTop;
                        }
                    } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) {
                        // scroll to top and highlight first option
                        if (index === that.selectpicker.view.firstHighlightIndex) {
                            that.$menuInner[0].scrollTop = 0;
                            liActiveIndex = that.selectpicker.view.firstHighlightIndex;
                        } else {
                            activeLi = that.selectpicker.current.data[liActiveIndex];
                            offset = activeLi.position - that.sizeInfo.menuInnerHeight;
                            updateScroll = offset > scrollTop;
                        }
                    }
                    liActive = that.selectpicker.current.elements[liActiveIndex];
                    that.activeIndex = that.selectpicker.current.data[liActiveIndex].index;
                    that.focusItem(liActive);
                    that.selectpicker.view.currentActive = liActive;
                    if (updateScroll) that.$menuInner[0].scrollTop = offset;
                    if (that.options.liveSearch) that.$searchbox.trigger("focus");
                    else $this.trigger("focus");
                } else if (!$this.is("input") && !REGEXP_TAB_OR_ESCAPE.test(e.which) || e.which === keyCodes.SPACE && that.selectpicker.keydown.keyHistory) {
                    var searchMatch, matches = [], keyHistory;
                    e.preventDefault();
                    that.selectpicker.keydown.keyHistory += keyCodeMap[e.which];
                    if (that.selectpicker.keydown.resetKeyHistory.cancel) clearTimeout(that.selectpicker.keydown.resetKeyHistory.cancel);
                    that.selectpicker.keydown.resetKeyHistory.cancel = that.selectpicker.keydown.resetKeyHistory.start();
                    keyHistory = that.selectpicker.keydown.keyHistory;
                    // if all letters are the same, set keyHistory to just the first character when searching
                    if (/^(.)\1+$/.test(keyHistory)) keyHistory = keyHistory.charAt(0);
                    // find matches
                    for(var i = 0; i < that.selectpicker.current.data.length; i++){
                        var li = that.selectpicker.current.data[i], hasMatch;
                        hasMatch = stringSearch(li, keyHistory, "startsWith", true);
                        if (hasMatch && that.selectpicker.view.canHighlight[i]) matches.push(li.index);
                    }
                    if (matches.length) {
                        var matchIndex = 0;
                        $items.removeClass("active").find("a").removeClass("active");
                        // either only one key has been pressed or they are all the same key
                        if (keyHistory.length === 1) {
                            matchIndex = matches.indexOf(that.activeIndex);
                            if (matchIndex === -1 || matchIndex === matches.length - 1) matchIndex = 0;
                            else matchIndex++;
                        }
                        searchMatch = matches[matchIndex];
                        activeLi = that.selectpicker.main.data[searchMatch];
                        if (scrollTop - activeLi.position > 0) {
                            offset = activeLi.position - activeLi.height;
                            updateScroll = true;
                        } else {
                            offset = activeLi.position - that.sizeInfo.menuInnerHeight;
                            // if the option is already visible at the current scroll position, just keep it the same
                            updateScroll = activeLi.position > scrollTop + that.sizeInfo.menuInnerHeight;
                        }
                        liActive = that.selectpicker.main.elements[searchMatch];
                        that.activeIndex = matches[matchIndex];
                        that.focusItem(liActive);
                        if (liActive) liActive.firstChild.focus();
                        if (updateScroll) that.$menuInner[0].scrollTop = offset;
                        $this.trigger("focus");
                    }
                }
                // Select focused option if "Enter", "Spacebar" or "Tab" (when selectOnTab is true) are pressed inside the menu.
                if (isActive && (e.which === keyCodes.SPACE && !that.selectpicker.keydown.keyHistory || e.which === keyCodes.ENTER || e.which === keyCodes.TAB && that.options.selectOnTab)) {
                    if (e.which !== keyCodes.SPACE) e.preventDefault();
                    if (!that.options.liveSearch || e.which !== keyCodes.SPACE) {
                        that.$menuInner.find(".active a").trigger("click", true); // retain active class
                        $this.trigger("focus");
                        if (!that.options.liveSearch) {
                            // Prevent screen from scrolling if the user hits the spacebar
                            e.preventDefault();
                            // Fixes spacebar selection of dropdown items in FF & IE
                            $(document).data("spaceSelect", true);
                        }
                    }
                }
            },
            mobile: function() {
                // ensure mobile is set to true if mobile function is called after init
                this.options.mobile = true;
                this.$element[0].classList.add("mobile-device");
            },
            refresh: function() {
                // update options if data attributes have been changed
                var config = $.extend({}, this.options, this.$element.data());
                this.options = config;
                this.checkDisabled();
                this.buildData();
                this.setStyle();
                this.render();
                this.buildList();
                this.setWidth();
                this.setSize(true);
                this.$element.trigger("refreshed" + EVENT_KEY);
            },
            hide: function() {
                this.$newElement.hide();
            },
            show: function() {
                this.$newElement.show();
            },
            remove: function() {
                this.$newElement.remove();
                this.$element.remove();
            },
            destroy: function() {
                this.$newElement.before(this.$element).remove();
                if (this.$bsContainer) this.$bsContainer.remove();
                else this.$menu.remove();
                if (this.selectpicker.view.titleOption && this.selectpicker.view.titleOption.parentNode) this.selectpicker.view.titleOption.parentNode.removeChild(this.selectpicker.view.titleOption);
                this.$element.off(EVENT_KEY).removeData("selectpicker").removeClass("bs-select-hidden selectpicker");
                $(window).off(EVENT_KEY + "." + this.selectId);
            }
        };
        // SELECTPICKER PLUGIN DEFINITION
        // ==============================
        function Plugin(option) {
            // get the args of the outer function..
            var args = arguments;
            // The arguments of the function are explicitly re-defined from the argument list, because the shift causes them
            // to get lost/corrupted in android 2.3 and IE9 #715 #775
            var _option = option;
            [].shift.apply(args);
            // if the version was not set successfully
            if (!version.success) {
                // try to retreive it again
                try {
                    version.full = ($.fn.dropdown.Constructor.VERSION || "").split(" ")[0].split(".");
                } catch (err) {
                    // fall back to use BootstrapVersion if set
                    if (Selectpicker.BootstrapVersion) version.full = Selectpicker.BootstrapVersion.split(" ")[0].split(".");
                    else {
                        version.full = [
                            version.major,
                            "0",
                            "0"
                        ];
                        console.warn("There was an issue retrieving Bootstrap's version. Ensure Bootstrap is being loaded before bootstrap-select and there is no namespace collision. If loading Bootstrap asynchronously, the version may need to be manually specified via $.fn.selectpicker.Constructor.BootstrapVersion.", err);
                    }
                }
                version.major = version.full[0];
                version.success = true;
            }
            if (version.major === "4") {
                // some defaults need to be changed if using Bootstrap 4
                // check to see if they have already been manually changed before forcing them to update
                var toUpdate = [];
                if (Selectpicker.DEFAULTS.style === classNames.BUTTONCLASS) toUpdate.push({
                    name: "style",
                    className: "BUTTONCLASS"
                });
                if (Selectpicker.DEFAULTS.iconBase === classNames.ICONBASE) toUpdate.push({
                    name: "iconBase",
                    className: "ICONBASE"
                });
                if (Selectpicker.DEFAULTS.tickIcon === classNames.TICKICON) toUpdate.push({
                    name: "tickIcon",
                    className: "TICKICON"
                });
                classNames.DIVIDER = "dropdown-divider";
                classNames.SHOW = "show";
                classNames.BUTTONCLASS = "btn-light";
                classNames.POPOVERHEADER = "popover-header";
                classNames.ICONBASE = "";
                classNames.TICKICON = "bs-ok-default";
                for(var i = 0; i < toUpdate.length; i++){
                    var option = toUpdate[i];
                    Selectpicker.DEFAULTS[option.name] = classNames[option.className];
                }
            }
            var value;
            var chain = this.each(function() {
                var $this = $(this);
                if ($this.is("select")) {
                    var data = $this.data("selectpicker"), options = typeof _option == "object" && _option;
                    if (!data) {
                        var dataAttributes = $this.data();
                        for(var dataAttr in dataAttributes)if (Object.prototype.hasOwnProperty.call(dataAttributes, dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) delete dataAttributes[dataAttr];
                        var config = $.extend({}, Selectpicker.DEFAULTS, $.fn.selectpicker.defaults || {}, dataAttributes, options);
                        config.template = $.extend({}, Selectpicker.DEFAULTS.template, $.fn.selectpicker.defaults ? $.fn.selectpicker.defaults.template : {}, dataAttributes.template, options.template);
                        $this.data("selectpicker", data = new Selectpicker(this, config));
                    } else if (options) {
                        for(var i in options)if (Object.prototype.hasOwnProperty.call(options, i)) data.options[i] = options[i];
                    }
                    if (typeof _option == "string") {
                        if (data[_option] instanceof Function) value = data[_option].apply(data, args);
                        else value = data.options[_option];
                    }
                }
            });
            if (typeof value !== "undefined") // noinspection JSUnusedAssignment
            return value;
            else return chain;
        }
        var old = $.fn.selectpicker;
        $.fn.selectpicker = Plugin;
        $.fn.selectpicker.Constructor = Selectpicker;
        // SELECTPICKER NO CONFLICT
        // ========================
        $.fn.selectpicker.noConflict = function() {
            $.fn.selectpicker = old;
            return this;
        };
        // get Bootstrap's keydown event handler for either Bootstrap 4 or Bootstrap 3
        function keydownHandler() {
            if ($.fn.dropdown) {
                // wait to define until function is called in case Bootstrap isn't loaded yet
                var bootstrapKeydown = $.fn.dropdown.Constructor._dataApiKeydownHandler || $.fn.dropdown.Constructor.prototype.keydown;
                return bootstrapKeydown.apply(this, arguments);
            }
        }
        $(document).off("keydown.bs.dropdown.data-api").on("keydown.bs.dropdown.data-api", ':not(.bootstrap-select) > [data-toggle="dropdown"]', keydownHandler).on("keydown.bs.dropdown.data-api", ":not(.bootstrap-select) > .dropdown-menu", keydownHandler).on("keydown" + EVENT_KEY, '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', Selectpicker.prototype.keydown).on("focusin.modal", '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', function(e) {
            e.stopPropagation();
        });
        // SELECTPICKER DATA-API
        // =====================
        $(window).on("load" + EVENT_KEY + ".data-api", function() {
            $(".selectpicker").each(function() {
                var $selectpicker = $(this);
                Plugin.call($selectpicker, $selectpicker.data());
            });
        });
    })(jQuery);
});


var $1962c16037a1be25$exports = {};

/**
  * bootstrap-switch - Turn checkboxes and radio buttons into toggle switches.
  *
  * @version v3.3.5
  * @homepage https://bttstrp.github.io/bootstrap-switch
  * @author Mattia Larentis <mattia@larentis.eu> (http://larentis.eu)
  * @license MIT
  */ (function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "jquery"
    ], factory);
    else {
        var mod;
        factory((parcelRequire("9qak9")));
    }
})($1962c16037a1be25$exports, function(_jquery) {
    "use strict";
    var _jquery2 = _interopRequireDefault(_jquery);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var $ = _jquery2.default || window.jQuery || window.$;
    function getClasses(options, id) {
        var state = options.state, size = options.size, disabled = options.disabled, readonly = options.readonly, indeterminate = options.indeterminate, inverse = options.inverse;
        return [
            state ? "on" : "off",
            size,
            disabled ? "disabled" : undefined,
            readonly ? "readonly" : undefined,
            indeterminate ? "indeterminate" : undefined,
            inverse ? "inverse" : undefined,
            id ? "id-" + id : undefined
        ].filter(function(v) {
            return v == null;
        });
    }
    function prvgetElementOptions() {
        return {
            state: this.$element.is(":checked"),
            size: this.$element.data("size"),
            animate: this.$element.data("animate"),
            disabled: this.$element.is(":disabled"),
            readonly: this.$element.is("[readonly]"),
            indeterminate: this.$element.data("indeterminate"),
            inverse: this.$element.data("inverse"),
            radioAllOff: this.$element.data("radio-all-off"),
            onColor: this.$element.data("on-color"),
            offColor: this.$element.data("off-color"),
            onText: this.$element.data("on-text"),
            offText: this.$element.data("off-text"),
            labelText: this.$element.data("label-text"),
            handleWidth: this.$element.data("handle-width"),
            labelWidth: this.$element.data("label-width"),
            baseClass: this.$element.data("base-class"),
            wrapperClass: this.$element.data("wrapper-class")
        };
    }
    function prvwidth() {
        var _this = this;
        var $handles = this.$on.add(this.$off).add(this.$label).css("width", "");
        var handleWidth = this.options.handleWidth === "auto" ? Math.round(Math.max(this.$on.width(), this.$off.width())) : this.options.handleWidth;
        $handles.width(handleWidth);
        this.$label.width(function(index, width) {
            if (_this.options.labelWidth !== "auto") return _this.options.labelWidth;
            if (width < handleWidth) return handleWidth;
            return width;
        });
        this.privateHandleWidth = this.$on.outerWidth();
        this.privateLabelWidth = this.$label.outerWidth();
        this.$container.width(this.privateHandleWidth * 2 + this.privateLabelWidth);
        return this.$wrapper.width(this.privateHandleWidth + this.privateLabelWidth);
    }
    function prvcontainerPosition() {
        var _this2 = this;
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.ope;
        this.$container.css("margin-left", function() {
            var values = [
                0,
                "-" + _this2.privateHandleWidth + "px"
            ];
            if (_this2.options.indeterminate) return "-" + _this2.privateHandleWidth / 2 + "px";
            if (state) {
                if (_this2.options.inverse) return values[1];
                return values[0];
            }
            if (_this2.options.inverse) return values[0];
            return values[1];
        });
    }
    function prvgetClass(name) {
        return this.options.baseClass + "-" + name;
    }
    function prvinit() {
        var _this3 = this;
        var init = function init() {
            _this3.setPrevOptions();
            prvwidth.call(_this3);
            prvcontainerPosition.call(_this3);
            setTimeout(function() {
                return _this3.options.animate && _this3.$wrapper.addClass(prvgetClass.call(_this3, "animate"));
            }, 50);
        };
        if (this.$wrapper.is(":visible")) {
            init();
            return;
        }
        var initInterval = window.setInterval(function() {
            return _this3.$wrapper.is(":visible") && (init() || true) && window.clearInterval(initInterval);
        }, 50);
    }
    function prvelementHandlers() {
        var _this4 = this;
        return this.$element.on({
            "setPreviousOptions.bootstrapSwitch": function setPreviousOptionsBootstrapSwitch() {
                return _this4.setPrevOptions();
            },
            "previousState.bootstrapSwitch": function previousStateBootstrapSwitch() {
                _this4.options = _this4.prevOptions;
                if (_this4.options.indeterminate) _this4.$wrapper.addClass(prvgetClass.call(_this4, "indeterminate"));
                _this4.$element.prop("checked", _this4.options.state).trigger("change.bootstrapSwitch", true);
            },
            "change.bootstrapSwitch": function changeBootstrapSwitch(event, skip) {
                event.preventDefault();
                event.stopImmediatePropagation();
                var state = _this4.$element.is(":checked");
                prvcontainerPosition.call(_this4, state);
                if (state === _this4.options.state) return;
                _this4.options.state = state;
                _this4.$wrapper.toggleClass(prvgetClass.call(_this4, "off")).toggleClass(prvgetClass.call(_this4, "on"));
                if (!skip) {
                    if (_this4.$element.is(":radio")) $('[name="' + _this4.$element.attr("name") + '"]').not(_this4.$element).prop("checked", false).trigger("change.bootstrapSwitch", true);
                    _this4.$element.trigger("switchChange.bootstrapSwitch", [
                        state
                    ]);
                }
            },
            "focus.bootstrapSwitch": function focusBootstrapSwitch(event) {
                event.preventDefault();
                _this4.$wrapper.addClass(prvgetClass.call(_this4, "focused"));
            },
            "blur.bootstrapSwitch": function blurBootstrapSwitch(event) {
                event.preventDefault();
                _this4.$wrapper.removeClass(prvgetClass.call(_this4, "focused"));
            },
            "keydown.bootstrapSwitch": function keydownBootstrapSwitch(event) {
                if (!event.which || _this4.options.disabled || _this4.options.readonly) return;
                if (event.which === 37 || event.which === 39) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    _this4.state(event.which === 39);
                }
            }
        });
    }
    function prvhandleHandlers() {
        var _this5 = this;
        this.$on.on("click.bootstrapSwitch", function(event) {
            event.preventDefault();
            event.stopPropagation();
            _this5.state(false);
            return _this5.$element.trigger("focus.bootstrapSwitch");
        });
        return this.$off.on("click.bootstrapSwitch", function(event) {
            event.preventDefault();
            event.stopPropagation();
            _this5.state(true);
            return _this5.$element.trigger("focus.bootstrapSwitch");
        });
    }
    function prvlabelHandlers() {
        var _this6 = this;
        var dragStart = void 0;
        var dragEnd = void 0;
        var handlers = {
            click: function click(event) {
                event.stopPropagation();
            },
            "mousedown.bootstrapSwitch touchstart.bootstrapSwitch": function mousedownBootstrapSwitchTouchstartBootstrapSwitch(event) {
                if (dragStart || _this6.options.disabled || _this6.options.readonly) return;
                event.preventDefault();
                event.stopPropagation();
                dragStart = (event.pageX || event.originalEvent.touches[0].pageX) - parseInt(_this6.$container.css("margin-left"), 10);
                if (_this6.options.animate) _this6.$wrapper.removeClass(prvgetClass.call(_this6, "animate"));
                _this6.$element.trigger("focus.bootstrapSwitch");
            },
            "mousemove.bootstrapSwitch touchmove.bootstrapSwitch": function mousemoveBootstrapSwitchTouchmoveBootstrapSwitch(event) {
                if (dragStart == null) return;
                var difference = (event.pageX || event.originalEvent.touches[0].pageX) - dragStart;
                event.preventDefault();
                if (difference < -_this6.privateHandleWidth || difference > 0) return;
                dragEnd = difference;
                _this6.$container.css("margin-left", dragEnd + "px");
            },
            "mouseup.bootstrapSwitch touchend.bootstrapSwitch": function mouseupBootstrapSwitchTouchendBootstrapSwitch(event) {
                if (!dragStart) return;
                event.preventDefault();
                if (_this6.options.animate) _this6.$wrapper.addClass(prvgetClass.call(_this6, "animate"));
                if (dragEnd) {
                    var state = dragEnd > -(_this6.privateHandleWidth / 2);
                    dragEnd = false;
                    _this6.state(_this6.options.inverse ? !state : state);
                } else _this6.state(!_this6.options.state);
                dragStart = false;
            },
            "mouseleave.bootstrapSwitch": function mouseleaveBootstrapSwitch() {
                _this6.$label.trigger("mouseup.bootstrapSwitch");
            }
        };
        this.$label.on(handlers);
    }
    function prvexternalLabelHandler() {
        var _this7 = this;
        var $externalLabel = this.$element.closest("label");
        $externalLabel.on("click", function(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (event.target === $externalLabel[0]) _this7.toggleState();
        });
    }
    function prvformHandler() {
        function isBootstrapSwitch() {
            return $(this).data("bootstrap-switch");
        }
        function performReset() {
            return $(this).bootstrapSwitch("state", this.checked);
        }
        var $form = this.$element.closest("form");
        if ($form.data("bootstrap-switch")) return;
        $form.on("reset.bootstrapSwitch", function() {
            window.setTimeout(function() {
                $form.find("input").filter(isBootstrapSwitch).each(performReset);
            }, 1);
        }).data("bootstrap-switch", true);
    }
    function prvgetClasses(classes) {
        var _this8 = this;
        if (!$.isArray(classes)) return [
            prvgetClass.call(this, classes)
        ];
        return classes.map(function(v) {
            return prvgetClass.call(_this8, v);
        });
    }
    var BootstrapSwitch = function() {
        function BootstrapSwitch(element) {
            var _this9 = this;
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            _classCallCheck(this, BootstrapSwitch);
            this.$element = $(element);
            this.options = $.extend({}, $.fn.bootstrapSwitch.defaults, prvgetElementOptions.call(this), options);
            this.prevOptions = {};
            this.$wrapper = $("<div>", {
                class: function _class() {
                    return getClasses(_this9.options, _this9.$element.attr("id")).map(function(v) {
                        return prvgetClass.call(_this9, v);
                    }).concat([
                        _this9.options.baseClass
                    ], prvgetClasses.call(_this9, _this9.options.wrapperClass)).join(" ");
                }
            });
            this.$container = $("<div>", {
                class: prvgetClass.call(this, "container")
            });
            this.$on = $("<span>", {
                html: this.options.onText,
                class: prvgetClass.call(this, "handle-on") + " " + prvgetClass.call(this, this.options.onColor)
            });
            this.$off = $("<span>", {
                html: this.options.offText,
                class: prvgetClass.call(this, "handle-off") + " " + prvgetClass.call(this, this.options.offColor)
            });
            this.$label = $("<span>", {
                html: this.options.labelText,
                class: prvgetClass.call(this, "label")
            });
            this.$element.on("init.bootstrapSwitch", function() {
                return _this9.options.onInit(element);
            });
            this.$element.on("switchChange.bootstrapSwitch", function() {
                for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var changeState = _this9.options.onSwitchChange.apply(element, args);
                if (changeState === false) {
                    if (_this9.$element.is(":radio")) $('[name="' + _this9.$element.attr("name") + '"]').trigger("previousState.bootstrapSwitch", true);
                    else _this9.$element.trigger("previousState.bootstrapSwitch", true);
                }
            });
            this.$container = this.$element.wrap(this.$container).parent();
            this.$wrapper = this.$container.wrap(this.$wrapper).parent();
            this.$element.before(this.options.inverse ? this.$off : this.$on).before(this.$label).before(this.options.inverse ? this.$on : this.$off);
            if (this.options.indeterminate) this.$element.prop("indeterminate", true);
            prvinit.call(this);
            prvelementHandlers.call(this);
            prvhandleHandlers.call(this);
            prvlabelHandlers.call(this);
            prvformHandler.call(this);
            prvexternalLabelHandler.call(this);
            this.$element.trigger("init.bootstrapSwitch", this.options.state);
        }
        _createClass(BootstrapSwitch, [
            {
                key: "setPrevOptions",
                value: function setPrevOptions() {
                    this.prevOptions = _extends({}, this.options);
                }
            },
            {
                key: "state",
                value: function state(value, skip) {
                    if (typeof value === "undefined") return this.options.state;
                    if (this.options.disabled || this.options.readonly || this.options.state && !this.options.radioAllOff && this.$element.is(":radio")) return this.$element;
                    if (this.$element.is(":radio")) $('[name="' + this.$element.attr("name") + '"]').trigger("setPreviousOptions.bootstrapSwitch");
                    else this.$element.trigger("setPreviousOptions.bootstrapSwitch");
                    if (this.options.indeterminate) this.indeterminate(false);
                    this.$element.prop("checked", Boolean(value)).trigger("change.bootstrapSwitch", skip);
                    return this.$element;
                }
            },
            {
                key: "toggleState",
                value: function toggleState(skip) {
                    if (this.options.disabled || this.options.readonly) return this.$element;
                    if (this.options.indeterminate) {
                        this.indeterminate(false);
                        return this.state(true);
                    }
                    return this.$element.prop("checked", !this.options.state).trigger("change.bootstrapSwitch", skip);
                }
            },
            {
                key: "size",
                value: function size(value) {
                    if (typeof value === "undefined") return this.options.size;
                    if (this.options.size != null) this.$wrapper.removeClass(prvgetClass.call(this, this.options.size));
                    if (value) this.$wrapper.addClass(prvgetClass.call(this, value));
                    prvwidth.call(this);
                    prvcontainerPosition.call(this);
                    this.options.size = value;
                    return this.$element;
                }
            },
            {
                key: "animate",
                value: function animate(value) {
                    if (typeof value === "undefined") return this.options.animate;
                    if (this.options.animate === Boolean(value)) return this.$element;
                    return this.toggleAnimate();
                }
            },
            {
                key: "toggleAnimate",
                value: function toggleAnimate() {
                    this.options.animate = !this.options.animate;
                    this.$wrapper.toggleClass(prvgetClass.call(this, "animate"));
                    return this.$element;
                }
            },
            {
                key: "disabled",
                value: function disabled(value) {
                    if (typeof value === "undefined") return this.options.disabled;
                    if (this.options.disabled === Boolean(value)) return this.$element;
                    return this.toggleDisabled();
                }
            },
            {
                key: "toggleDisabled",
                value: function toggleDisabled() {
                    this.options.disabled = !this.options.disabled;
                    this.$element.prop("disabled", this.options.disabled);
                    this.$wrapper.toggleClass(prvgetClass.call(this, "disabled"));
                    return this.$element;
                }
            },
            {
                key: "readonly",
                value: function readonly(value) {
                    if (typeof value === "undefined") return this.options.readonly;
                    if (this.options.readonly === Boolean(value)) return this.$element;
                    return this.toggleReadonly();
                }
            },
            {
                key: "toggleReadonly",
                value: function toggleReadonly() {
                    this.options.readonly = !this.options.readonly;
                    this.$element.prop("readonly", this.options.readonly);
                    this.$wrapper.toggleClass(prvgetClass.call(this, "readonly"));
                    return this.$element;
                }
            },
            {
                key: "indeterminate",
                value: function indeterminate(value) {
                    if (typeof value === "undefined") return this.options.indeterminate;
                    if (this.options.indeterminate === Boolean(value)) return this.$element;
                    return this.toggleIndeterminate();
                }
            },
            {
                key: "toggleIndeterminate",
                value: function toggleIndeterminate() {
                    this.options.indeterminate = !this.options.indeterminate;
                    this.$element.prop("indeterminate", this.options.indeterminate);
                    this.$wrapper.toggleClass(prvgetClass.call(this, "indeterminate"));
                    prvcontainerPosition.call(this);
                    return this.$element;
                }
            },
            {
                key: "inverse",
                value: function inverse(value) {
                    if (typeof value === "undefined") return this.options.inverse;
                    if (this.options.inverse === Boolean(value)) return this.$element;
                    return this.toggleInverse();
                }
            },
            {
                key: "toggleInverse",
                value: function toggleInverse() {
                    this.$wrapper.toggleClass(prvgetClass.call(this, "inverse"));
                    var $on = this.$on.clone(true);
                    var $off = this.$off.clone(true);
                    this.$on.replaceWith($off);
                    this.$off.replaceWith($on);
                    this.$on = $off;
                    this.$off = $on;
                    this.options.inverse = !this.options.inverse;
                    return this.$element;
                }
            },
            {
                key: "onColor",
                value: function onColor(value) {
                    if (typeof value === "undefined") return this.options.onColor;
                    if (this.options.onColor) this.$on.removeClass(prvgetClass.call(this, this.options.onColor));
                    this.$on.addClass(prvgetClass.call(this, value));
                    this.options.onColor = value;
                    return this.$element;
                }
            },
            {
                key: "offColor",
                value: function offColor(value) {
                    if (typeof value === "undefined") return this.options.offColor;
                    if (this.options.offColor) this.$off.removeClass(prvgetClass.call(this, this.options.offColor));
                    this.$off.addClass(prvgetClass.call(this, value));
                    this.options.offColor = value;
                    return this.$element;
                }
            },
            {
                key: "onText",
                value: function onText(value) {
                    if (typeof value === "undefined") return this.options.onText;
                    this.$on.html(value);
                    prvwidth.call(this);
                    prvcontainerPosition.call(this);
                    this.options.onText = value;
                    return this.$element;
                }
            },
            {
                key: "offText",
                value: function offText(value) {
                    if (typeof value === "undefined") return this.options.offText;
                    this.$off.html(value);
                    prvwidth.call(this);
                    prvcontainerPosition.call(this);
                    this.options.offText = value;
                    return this.$element;
                }
            },
            {
                key: "labelText",
                value: function labelText(value) {
                    if (typeof value === "undefined") return this.options.labelText;
                    this.$label.html(value);
                    prvwidth.call(this);
                    this.options.labelText = value;
                    return this.$element;
                }
            },
            {
                key: "handleWidth",
                value: function handleWidth(value) {
                    if (typeof value === "undefined") return this.options.handleWidth;
                    this.options.handleWidth = value;
                    prvwidth.call(this);
                    prvcontainerPosition.call(this);
                    return this.$element;
                }
            },
            {
                key: "labelWidth",
                value: function labelWidth(value) {
                    if (typeof value === "undefined") return this.options.labelWidth;
                    this.options.labelWidth = value;
                    prvwidth.call(this);
                    prvcontainerPosition.call(this);
                    return this.$element;
                }
            },
            {
                key: "baseClass",
                value: function baseClass() {
                    return this.options.baseClass;
                }
            },
            {
                key: "wrapperClass",
                value: function wrapperClass(value) {
                    if (typeof value === "undefined") return this.options.wrapperClass;
                    var wrapperClass = value || $.fn.bootstrapSwitch.defaults.wrapperClass;
                    this.$wrapper.removeClass(prvgetClasses.call(this, this.options.wrapperClass).join(" "));
                    this.$wrapper.addClass(prvgetClasses.call(this, wrapperClass).join(" "));
                    this.options.wrapperClass = wrapperClass;
                    return this.$element;
                }
            },
            {
                key: "radioAllOff",
                value: function radioAllOff(value) {
                    if (typeof value === "undefined") return this.options.radioAllOff;
                    var val = Boolean(value);
                    if (this.options.radioAllOff === val) return this.$element;
                    this.options.radioAllOff = val;
                    return this.$element;
                }
            },
            {
                key: "onInit",
                value: function onInit(value) {
                    if (typeof value === "undefined") return this.options.onInit;
                    this.options.onInit = value || $.fn.bootstrapSwitch.defaults.onInit;
                    return this.$element;
                }
            },
            {
                key: "onSwitchChange",
                value: function onSwitchChange(value) {
                    if (typeof value === "undefined") return this.options.onSwitchChange;
                    this.options.onSwitchChange = value || $.fn.bootstrapSwitch.defaults.onSwitchChange;
                    return this.$element;
                }
            },
            {
                key: "destroy",
                value: function destroy() {
                    var $form = this.$element.closest("form");
                    if ($form.length) $form.off("reset.bootstrapSwitch").removeData("bootstrap-switch");
                    this.$container.children().not(this.$element).remove();
                    this.$element.unwrap().unwrap().off(".bootstrapSwitch").removeData("bootstrap-switch");
                    return this.$element;
                }
            }
        ]);
        return BootstrapSwitch;
    }();
    function bootstrapSwitch(option) {
        for(var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        function reducer(ret, next) {
            var $this = $(next);
            var existingData = $this.data("bootstrap-switch");
            var data = existingData || new BootstrapSwitch(next, option);
            if (!existingData) $this.data("bootstrap-switch", data);
            if (typeof option === "string") return data[option].apply(data, args);
            return ret;
        }
        return Array.prototype.reduce.call(this, reducer, this);
    }
    $.fn.bootstrapSwitch = bootstrapSwitch;
    $.fn.bootstrapSwitch.Constructor = BootstrapSwitch;
    $.fn.bootstrapSwitch.defaults = {
        state: true,
        size: null,
        animate: true,
        disabled: false,
        readonly: false,
        indeterminate: false,
        inverse: false,
        radioAllOff: false,
        onColor: "primary",
        offColor: "default",
        onText: "ON",
        offText: "OFF",
        labelText: "&nbsp",
        handleWidth: "auto",
        labelWidth: "auto",
        baseClass: "bootstrap-switch",
        wrapperClass: "wrapper",
        onInit: function onInit() {},
        onSwitchChange: function onSwitchChange() {}
    };
});



// Datatables
// https://datatables.net/download/npm
(parcelRequire("EHlDu"))(window, $);

(parcelRequire("aDBCM"))(window, $);

(parcelRequire("1d1BV"))(window, $);

(parcelRequire("52RUY"))(window, $);
parcelRequire("jgdy4");
parcelRequire("8h8ZT");
parcelRequire("jVOIp");
parcelRequire("4mYj6");
parcelRequire("erFzf");
parcelRequire("cri0C");
parcelRequire("8oQ7S");
parcelRequire("aShYl");
parcelRequire("gba37");
parcelRequire("6GnD9");
parcelRequire("g1NYz");
parcelRequire("jLJBe");
parcelRequire("kjBpM");
parcelRequire("6M3hq");
parcelRequire("aZF5h");
parcelRequire("k3Vas");
parcelRequire("fBCSK");
parcelRequire("3dtcL");
parcelRequire("owfCx");
/*
 *  Copyright 2022 Red Hat
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ ace.define("ace/mode/logfile_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var LogFileHighlightRules = function() {
        this.$rules = {
            "start": [
                // timestamp
                {
                    token: "timestamp",
                    regex: "\\d{4}-\\d{2}-\\d{2} \\d{2}:\\d{2}:\\d{2},\\d{3}"
                },
                // category
                {
                    token: "category",
                    regex: "\\[[a-z\\.]+\\]"
                },
                // levels
                {
                    token: "level.error",
                    regex: "ERROR"
                },
                {
                    token: "level.warn",
                    regex: "WARN"
                },
                {
                    token: "level.info",
                    regex: "INFO"
                },
                {
                    token: "level.debug",
                    regex: "DEBUG"
                },
                // exceptions
                {
                    token: "exception",
                    regex: "\\w*Exception"
                },
                {
                    token: "exception",
                    regex: "\\w*Error"
                }
            ]
        };
    };
    oop.inherits(LogFileHighlightRules, TextHighlightRules);
    exports.LogFileHighlightRules = LogFileHighlightRules;
});
ace.define("ace/mode/logfile", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/properties_highlight_rules"
], function(require, exports, module) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var LogFileHighlightRules = require("./logfile_highlight_rules").LogFileHighlightRules;
    var Mode = function() {
        this.HighlightRules = LogFileHighlightRules;
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.$id = "ace/mode/logfile";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});


/*
 *  Copyright 2022 Red Hat
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ ace.define("ace/theme/logfile", [
    "require",
    "exports",
    "module",
    "ace/lib/dom"
], function(require, exports, module) {
    exports.isDark = false;
    exports.cssClass = "ace-logfile";
    exports.cssText = ".ace-logfile .ace_gutter {background: #ebebeb;color: #333}.ace-logfile .ace_print-margin {width: 1px;background: #e8e8e8}.ace-logfile {background-color: #fff;color: #080808}.ace-logfile .ace_cursor {color: #000000}.ace-logfile .ace_marker-layer .ace_selection {background: rgba(39, 95, 255, 0.30)}.ace-logfile.ace_multiselect .ace_selection.ace_start {box-shadow: 0 0 3px 0px #F9F9F9;border-radius: 2px}.ace-logfile .ace_marker-layer .ace_step {background: rgb(255, 255, 0)}.ace-logfile .ace_marker-layer .ace_bracket {margin: -1px 0 0 -1px;border: 1px solid rgba(75, 75, 126, 0.50)}.ace-logfile .ace_marker-layer .ace_active-line {background: rgba(36, 99, 180, 0.12)}.ace-logfile .ace_gutter-active-line {background-color : #dcdcdc}.ace-logfile .ace_marker-layer .ace_selected-word {border: 1px solid rgba(39, 95, 255, 0.30)}.ace-logfile .ace_invisible {color: rgba(75, 75, 126, 0.50)}.ace-logfile .ace_keyword,.ace-logfile .ace_meta {color: #794938}.ace-logfile .ace_constant,.ace-logfile .ace_constant.ace_character,.ace-logfile .ace_constant.ace_character.ace_escape,.ace-logfile .ace_constant.ace_other {color: #811F24}.ace-logfile .ace_invalid.ace_illegal {text-decoration: underline;font-style: italic;color: #F8F8F8;background-color: #B52A1D}.ace-logfile .ace_invalid.ace_deprecated {text-decoration: underline;font-style: italic;color: #B52A1D}.ace-logfile .ace_support {color: #691C97}.ace-logfile .ace_support.ace_constant {color: #B4371F}.ace-logfile .ace_fold {background-color: #794938;border-color: #080808}.ace-logfile .ace_list,.ace-logfile .ace_markup.ace_list,.ace-logfile .ace_support.ace_function {color: #693A17}.ace-logfile .ace_storage {font-style: italic;color: #A71D5D}.ace-logfile .ace_string {color: #0B6125}.ace-logfile .ace_string.ace_regexp {color: #CF5628}.ace-logfile .ace_comment {font-style: italic;color: #5A525F}.ace-logfile .ace_heading,.ace-logfile .ace_markup.ace_heading {color: #19356D}.ace-logfile .ace_variable {color: #234A97}.ace-logfile .ace_indent-guide {background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQImWNgYGBgYLh/5+x/AAizA4hxNNsZAAAAAElFTkSuQmCC) right repeat-y}.ace-logfile .ace_timestamp {color: #447384;}.ace-logfile .ace_category {color: #71362D;}.ace-logfile .ace_level.ace_error {color: #CC0000;}.ace-logfile .ace_level.ace_warn {color: #FF9911;}.ace-logfile .ace_level.ace_info {color: inherit;}.ace-logfile .ace_level.ace_debug {color: #666666;}.ace-logfile .ace_exception {color: #FFBC11;background-color: #c82e2e;}";
    var dom = require("../lib/dom");
    dom.importCssString(exports.cssText, exports.cssClass);
});


var $c1c58223a1c10576$exports = {};

/*globals jQuery, define, module, exports, require, window, document, postMessage */ (function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) define([
        "jquery"
    ], factory);
    else if (0, $c1c58223a1c10576$exports) $c1c58223a1c10576$exports = factory((parcelRequire("9qak9")));
    else factory(jQuery);
})(function($, undefined) {
    "use strict";
    /*!
 * jsTree 3.3.16
 * http://jstree.com/
 *
 * Copyright (c) 2014 Ivan Bozhanov (http://vakata.com)
 *
 * Licensed same as jquery - under the terms of the MIT License
 *   http://www.opensource.org/licenses/mit-license.php
 */ /*!
 * if using jslint please allow for the jQuery global and use following options:
 * jslint: loopfunc: true, browser: true, ass: true, bitwise: true, continue: true, nomen: true, plusplus: true, regexp: true, unparam: true, todo: true, white: true
 */ /*jshint -W083 */ // prevent another load? maybe there is a better way?
    if ($.jstree) return;
    /**
	 * ### jsTree core functionality
	 */ // internal variables
    var instance_counter = 0, ccp_node = false, ccp_mode = false, ccp_inst = false, themes_loaded = [], src = $("script:last").attr("src"), document = window.document; // local variable is always faster to access then a global
    var setImmediate = window.setImmediate;
    var Promise = window.Promise;
    if (!setImmediate && Promise) // Good enough approximation of setImmediate
    setImmediate = function(cb, arg) {
        Promise.resolve(arg).then(cb);
    };
    /**
	 * holds all jstree related functions and variables, including the actual class and methods to create, access and manipulate instances.
	 * @name $.jstree
	 */ $.jstree = {
        /**
		 * specifies the jstree version in use
		 * @name $.jstree.version
		 */ version: "3.3.16",
        /**
		 * holds all the default options used when creating new instances
		 * @name $.jstree.defaults
		 */ defaults: {
            /**
			 * configure which plugins will be active on an instance. Should be an array of strings, where each element is a plugin name. The default is `[]`
			 * @name $.jstree.defaults.plugins
			 */ plugins: []
        },
        /**
		 * stores all loaded jstree plugins (used internally)
		 * @name $.jstree.plugins
		 */ plugins: {},
        path: src && src.indexOf("/") !== -1 ? src.replace(/\/[^\/]+$/, "") : "",
        idregex: /[\\:&!^|()\[\]<>@*'+~#";.,=\- \/${}%?`]/g,
        root: "#"
    };
    /**
	 * creates a jstree instance
	 * @name $.jstree.create(el [, options])
	 * @param {DOMElement|jQuery|String} el the element to create the instance on, can be jQuery extended or a selector
	 * @param {Object} options options for this instance (extends `$.jstree.defaults`)
	 * @return {jsTree} the new instance
	 */ $.jstree.create = function(el, options) {
        var tmp = new $.jstree.core(++instance_counter), opt = options;
        options = $.extend(true, {}, $.jstree.defaults, options);
        if (opt && opt.plugins) options.plugins = opt.plugins;
        $.each(options.plugins, function(i, k) {
            if (i !== "core") tmp = tmp.plugin(k, options[k]);
        });
        $(el).data("jstree", tmp);
        tmp.init(el, options);
        return tmp;
    };
    /**
	 * remove all traces of jstree from the DOM and destroy all instances
	 * @name $.jstree.destroy()
	 */ $.jstree.destroy = function() {
        $(".jstree:jstree").jstree("destroy");
        $(document).off(".jstree");
    };
    /**
	 * the jstree class constructor, used only internally
	 * @private
	 * @name $.jstree.core(id)
	 * @param {Number} id this instance's index
	 */ $.jstree.core = function(id) {
        this._id = id;
        this._cnt = 0;
        this._wrk = null;
        this._data = {
            core: {
                themes: {
                    name: false,
                    dots: false,
                    icons: false,
                    ellipsis: false
                },
                selected: [],
                last_error: {},
                working: false,
                worker_queue: [],
                focused: null
            }
        };
    };
    /**
	 * get a reference to an existing instance
	 *
	 * __Examples__
	 *
	 *	// provided a container with an ID of "tree", and a nested node with an ID of "branch"
	 *	// all of there will return the same instance
	 *	$.jstree.reference('tree');
	 *	$.jstree.reference('#tree');
	 *	$.jstree.reference($('#tree'));
	 *	$.jstree.reference(document.getElementByID('tree'));
	 *	$.jstree.reference('branch');
	 *	$.jstree.reference('#branch');
	 *	$.jstree.reference($('#branch'));
	 *	$.jstree.reference(document.getElementByID('branch'));
	 *
	 * @name $.jstree.reference(needle)
	 * @param {DOMElement|jQuery|String} needle
	 * @return {jsTree|null} the instance or `null` if not found
	 */ $.jstree.reference = function(needle) {
        var tmp = null, obj = null;
        if (needle && needle.id && (!needle.tagName || !needle.nodeType)) needle = needle.id;
        if (!obj || !obj.length) try {
            obj = $(needle);
        } catch (ignore) {}
        if (!obj || !obj.length) try {
            obj = $("#" + needle.replace($.jstree.idregex, "\\$&"));
        } catch (ignore) {}
        if (obj && obj.length && (obj = obj.closest(".jstree")).length && (obj = obj.data("jstree"))) tmp = obj;
        else $(".jstree").each(function() {
            var inst = $(this).data("jstree");
            if (inst && inst._model.data[needle]) {
                tmp = inst;
                return false;
            }
        });
        return tmp;
    };
    /**
	 * Create an instance, get an instance or invoke a command on a instance.
	 *
	 * If there is no instance associated with the current node a new one is created and `arg` is used to extend `$.jstree.defaults` for this new instance. There would be no return value (chaining is not broken).
	 *
	 * If there is an existing instance and `arg` is a string the command specified by `arg` is executed on the instance, with any additional arguments passed to the function. If the function returns a value it will be returned (chaining could break depending on function).
	 *
	 * If there is an existing instance and `arg` is not a string the instance itself is returned (similar to `$.jstree.reference`).
	 *
	 * In any other case - nothing is returned and chaining is not broken.
	 *
	 * __Examples__
	 *
	 *	$('#tree1').jstree(); // creates an instance
	 *	$('#tree2').jstree({ plugins : [] }); // create an instance with some options
	 *	$('#tree1').jstree('open_node', '#branch_1'); // call a method on an existing instance, passing additional arguments
	 *	$('#tree2').jstree(); // get an existing instance (or create an instance)
	 *	$('#tree2').jstree(true); // get an existing instance (will not create new instance)
	 *	$('#branch_1').jstree().select_node('#branch_1'); // get an instance (using a nested element and call a method)
	 *
	 * @name $().jstree([arg])
	 * @param {String|Object} arg
	 * @return {Mixed}
	 */ $.fn.jstree = function(arg) {
        // check for string argument
        var is_method = typeof arg === "string", args = Array.prototype.slice.call(arguments, 1), result = null;
        if (arg === true && !this.length) return false;
        this.each(function() {
            // get the instance (if there is one) and method (if it exists)
            var instance = $.jstree.reference(this), method = is_method && instance ? instance[arg] : null;
            // if calling a method, and method is available - execute on the instance
            result = is_method && method ? method.apply(instance, args) : null;
            // if there is no instance and no method is being called - create one
            if (!instance && !is_method && (arg === undefined || $.isPlainObject(arg))) $.jstree.create(this, arg);
            // if there is an instance and no method is called - return the instance
            if (instance && !is_method || arg === true) result = instance || false;
            // if there was a method call which returned a result - break and return the value
            if (result !== null && result !== undefined) return false;
        });
        // if there was a method call with a valid return value - return that, otherwise continue the chain
        return result !== null && result !== undefined ? result : this;
    };
    /**
	 * used to find elements containing an instance
	 *
	 * __Examples__
	 *
	 *	$('div:jstree').each(function () {
	 *		$(this).jstree('destroy');
	 *	});
	 *
	 * @name $(':jstree')
	 * @return {jQuery}
	 */ $.expr.pseudos.jstree = $.expr.createPseudo(function(search) {
        return function(a) {
            return $(a).hasClass("jstree") && $(a).data("jstree") !== undefined;
        };
    });
    /**
	 * stores all defaults for the core
	 * @name $.jstree.defaults.core
	 */ $.jstree.defaults.core = {
        /**
		 * data configuration
		 *
		 * If left as `false` the HTML inside the jstree container element is used to populate the tree (that should be an unordered list with list items).
		 *
		 * You can also pass in a HTML string or a JSON array here.
		 *
		 * It is possible to pass in a standard jQuery-like AJAX config and jstree will automatically determine if the response is JSON or HTML and use that to populate the tree.
		 * In addition to the standard jQuery ajax options here you can supply functions for `data` and `url`, the functions will be run in the current instance's scope and a param will be passed indicating which node is being loaded, the return value of those functions will be used.
		 *
		 * The last option is to specify a function, that function will receive the node being loaded as argument and a second param which is a function which should be called with the result.
		 *
		 * __Examples__
		 *
		 *	// AJAX
		 *	$('#tree').jstree({
		 *		'core' : {
		 *			'data' : {
		 *				'url' : '/get/children/',
		 *				'data' : function (node) {
		 *					return { 'id' : node.id };
		 *				}
		 *			}
		 *		});
		 *
		 *	// direct data
		 *	$('#tree').jstree({
		 *		'core' : {
		 *			'data' : [
		 *				'Simple root node',
		 *				{
		 *					'id' : 'node_2',
		 *					'text' : 'Root node with options',
		 *					'state' : { 'opened' : true, 'selected' : true },
		 *					'children' : [ { 'text' : 'Child 1' }, 'Child 2']
		 *				}
		 *			]
		 *		}
		 *	});
		 *
		 *	// function
		 *	$('#tree').jstree({
		 *		'core' : {
		 *			'data' : function (obj, callback) {
		 *				callback.call(this, ['Root 1', 'Root 2']);
		 *			}
		 *		});
		 *
		 * @name $.jstree.defaults.core.data
		 */ data: false,
        /**
		 * configure the various strings used throughout the tree
		 *
		 * You can use an object where the key is the string you need to replace and the value is your replacement.
		 * Another option is to specify a function which will be called with an argument of the needed string and should return the replacement.
		 * If left as `false` no replacement is made.
		 *
		 * __Examples__
		 *
		 *	$('#tree').jstree({
		 *		'core' : {
		 *			'strings' : {
		 *				'Loading ...' : 'Please wait ...'
		 *			}
		 *		}
		 *	});
		 *
		 * @name $.jstree.defaults.core.strings
		 */ strings: false,
        /**
		 * determines what happens when a user tries to modify the structure of the tree
		 * If left as `false` all operations like create, rename, delete, move or copy are prevented.
		 * You can set this to `true` to allow all interactions or use a function to have better control.
		 *
		 * __Examples__
		 *
		 *	$('#tree').jstree({
		 *		'core' : {
		 *			'check_callback' : function (operation, node, node_parent, node_position, more) {
		 *				// operation can be 'create_node', 'rename_node', 'delete_node', 'move_node', 'copy_node' or 'edit'
		 *				// in case of 'rename_node' node_position is filled with the new node name
		 *				return operation === 'rename_node' ? true : false;
		 *			}
		 *		}
		 *	});
		 *
		 * @name $.jstree.defaults.core.check_callback
		 */ check_callback: false,
        /**
		 * a callback called with a single object parameter in the instance's scope when something goes wrong (operation prevented, ajax failed, etc)
		 * @name $.jstree.defaults.core.error
		 */ error: $.noop,
        /**
		 * the open / close animation duration in milliseconds - set this to `false` to disable the animation (default is `200`)
		 * @name $.jstree.defaults.core.animation
		 */ animation: 200,
        /**
		 * a boolean indicating if multiple nodes can be selected
		 * @name $.jstree.defaults.core.multiple
		 */ multiple: true,
        /**
		 * theme configuration object
		 * @name $.jstree.defaults.core.themes
		 */ themes: {
            /**
			 * the name of the theme to use (if left as `false` the default theme is used)
			 * @name $.jstree.defaults.core.themes.name
			 */ name: false,
            /**
			 * the URL of the theme's CSS file, leave this as `false` if you have manually included the theme CSS (recommended). You can set this to `true` too which will try to autoload the theme.
			 * @name $.jstree.defaults.core.themes.url
			 */ url: false,
            /**
			 * the location of all jstree themes - only used if `url` is set to `true`
			 * @name $.jstree.defaults.core.themes.dir
			 */ dir: false,
            /**
			 * a boolean indicating if connecting dots are shown
			 * @name $.jstree.defaults.core.themes.dots
			 */ dots: true,
            /**
			 * a boolean indicating if node icons are shown
			 * @name $.jstree.defaults.core.themes.icons
			 */ icons: true,
            /**
			 * a boolean indicating if node ellipsis should be shown - this only works with a fixed with on the container
			 * @name $.jstree.defaults.core.themes.ellipsis
			 */ ellipsis: false,
            /**
			 * a boolean indicating if the tree background is striped
			 * @name $.jstree.defaults.core.themes.stripes
			 */ stripes: false,
            /**
			 * a string (or boolean `false`) specifying the theme variant to use (if the theme supports variants)
			 * @name $.jstree.defaults.core.themes.variant
			 */ variant: false,
            /**
			 * a boolean specifying if a reponsive version of the theme should kick in on smaller screens (if the theme supports it). Defaults to `false`.
			 * @name $.jstree.defaults.core.themes.responsive
			 */ responsive: false
        },
        /**
		 * if left as `true` all parents of all selected nodes will be opened once the tree loads (so that all selected nodes are visible to the user)
		 * @name $.jstree.defaults.core.expand_selected_onload
		 */ expand_selected_onload: true,
        /**
		 * if left as `true` web workers will be used to parse incoming JSON data where possible, so that the UI will not be blocked by large requests. Workers are however about 30% slower. Defaults to `true`
		 * @name $.jstree.defaults.core.worker
		 */ worker: true,
        /**
		 * Force node text to plain text (and escape HTML). Defaults to `false`
		 * @name $.jstree.defaults.core.force_text
		 */ force_text: false,
        /**
		 * Should the node be toggled if the text is double clicked. Defaults to `true`
		 * @name $.jstree.defaults.core.dblclick_toggle
		 */ dblclick_toggle: true,
        /**
		 * Should the loaded nodes be part of the state. Defaults to `false`
		 * @name $.jstree.defaults.core.loaded_state
		 */ loaded_state: false,
        /**
		 * Should the last active node be focused when the tree container is blurred and the focused again. This helps working with screen readers. Defaults to `true`
		 * @name $.jstree.defaults.core.restore_focus
		 */ restore_focus: true,
        /**
		 * Force to compute and set "aria-setsize" and "aria-posinset" explicitly for each treeitem. 
		 * Some browsers may compute incorrect elements position and produce wrong announcements for screen readers. Defaults to `false`
		 * @name $.jstree.defaults.core.compute_elements_positions
		 */ compute_elements_positions: false,
        /**
		 * Default keyboard shortcuts (an object where each key is the button name or combo - like 'enter', 'ctrl-space', 'p', etc and the value is the function to execute in the instance's scope)
		 * @name $.jstree.defaults.core.keyboard
		 */ keyboard: {
            "ctrl-space": function(e) {
                // aria defines space only with Ctrl
                e.type = "click";
                $(e.currentTarget).trigger(e);
            },
            "enter": function(e) {
                // enter
                e.type = "click";
                $(e.currentTarget).trigger(e);
            },
            "left": function(e) {
                // left
                e.preventDefault();
                if (this.is_open(e.currentTarget)) this.close_node(e.currentTarget);
                else {
                    var o = this.get_parent(e.currentTarget);
                    if (o && o.id !== $.jstree.root) this.get_node(o, true).children(".jstree-anchor").trigger("focus");
                }
            },
            "up": function(e) {
                // up
                e.preventDefault();
                var o = this.get_prev_dom(e.currentTarget);
                if (o && o.length) o.children(".jstree-anchor").trigger("focus");
            },
            "right": function(e) {
                // right
                e.preventDefault();
                if (this.is_closed(e.currentTarget)) this.open_node(e.currentTarget, function(o) {
                    this.get_node(o, true).children(".jstree-anchor").trigger("focus");
                });
                else if (this.is_open(e.currentTarget)) {
                    var o = this.get_node(e.currentTarget, true).children(".jstree-children")[0];
                    if (o) $(this._firstChild(o)).children(".jstree-anchor").trigger("focus");
                }
            },
            "down": function(e) {
                // down
                e.preventDefault();
                var o = this.get_next_dom(e.currentTarget);
                if (o && o.length) o.children(".jstree-anchor").trigger("focus");
            },
            "*": function(e) {
                // aria defines * on numpad as open_all - not very common
                this.open_all();
            },
            "home": function(e) {
                // home
                e.preventDefault();
                var o = this._firstChild(this.get_container_ul()[0]);
                if (o) $(o).children(".jstree-anchor").filter(":visible").trigger("focus");
            },
            "end": function(e) {
                // end
                e.preventDefault();
                this.element.find(".jstree-anchor").filter(":visible").last().trigger("focus");
            },
            "f2": function(e) {
                // f2 - safe to include - if check_callback is false it will fail
                e.preventDefault();
                this.edit(e.currentTarget);
            }
        },
        /**
		 * Should reselecting an already selected node trigger the select and changed callbacks
		 * @name $.jstree.defaults.core.allow_reselect
		 */ allow_reselect: false
    };
    $.jstree.core.prototype = {
        /**
		 * used to decorate an instance with a plugin. Used internally.
		 * @private
		 * @name plugin(deco [, opts])
		 * @param  {String} deco the plugin to decorate with
		 * @param  {Object} opts options for the plugin
		 * @return {jsTree}
		 */ plugin: function(deco, opts) {
            var Child = $.jstree.plugins[deco];
            if (Child) {
                this._data[deco] = {};
                Child.prototype = this;
                return new Child(opts, this);
            }
            return this;
        },
        /**
		 * initialize the instance. Used internally.
		 * @private
		 * @name init(el, optons)
		 * @param {DOMElement|jQuery|String} el the element we are transforming
		 * @param {Object} options options for this instance
		 * @trigger init.jstree, loading.jstree, loaded.jstree, ready.jstree, changed.jstree
		 */ init: function(el, options) {
            this._model = {
                data: {},
                changed: [],
                force_full_redraw: false,
                redraw_timeout: false,
                default_state: {
                    loaded: true,
                    opened: false,
                    selected: false,
                    disabled: false
                }
            };
            this._model.data[$.jstree.root] = {
                id: $.jstree.root,
                parent: null,
                parents: [],
                children: [],
                children_d: [],
                state: {
                    loaded: false
                }
            };
            this.element = $(el).addClass("jstree jstree-" + this._id);
            this.settings = options;
            this._data.core.ready = false;
            this._data.core.loaded = false;
            this._data.core.rtl = this.element.css("direction") === "rtl";
            this.element[this._data.core.rtl ? "addClass" : "removeClass"]("jstree-rtl");
            this.element.attr("role", "tree");
            if (this.settings.core.multiple) this.element.attr("aria-multiselectable", true);
            if (!this.element.attr("tabindex")) this.element.attr("tabindex", "0");
            this.bind();
            /**
			 * triggered after all events are bound
			 * @event
			 * @name init.jstree
			 */ this.trigger("init");
            this._data.core.original_container_html = this.element.find(" > ul > li").clone(true);
            this._data.core.original_container_html.find("li").addBack().contents().filter(function() {
                return this.nodeType === 3 && (!this.nodeValue || /^\s+$/.test(this.nodeValue));
            }).remove();
            this.element.html("<ul class='jstree-container-ul jstree-children' role='group'><li id='j" + this._id + "_loading' class='jstree-initial-node jstree-loading jstree-leaf jstree-last' role='none'><i class='jstree-icon jstree-ocl'></i><" + "a class='jstree-anchor' role='treeitem' href='#'><i class='jstree-icon jstree-themeicon-hidden'></i>" + this.get_string("Loading ...") + "</a></li></ul>");
            this.element.attr("aria-activedescendant", "j" + this._id + "_loading");
            this._data.core.li_height = this.get_container_ul().children("li").first().outerHeight() || 24;
            this._data.core.node = this._create_prototype_node();
            /**
			 * triggered after the loading text is shown and before loading starts
			 * @event
			 * @name loading.jstree
			 */ this.trigger("loading");
            this.load_node($.jstree.root);
        },
        /**
		 * destroy an instance
		 * @name destroy()
		 * @param  {Boolean} keep_html if not set to `true` the container will be emptied, otherwise the current DOM elements will be kept intact
		 */ destroy: function(keep_html) {
            /**
			 * triggered before the tree is destroyed
			 * @event
			 * @name destroy.jstree
			 */ this.trigger("destroy");
            if (this._wrk) try {
                window.URL.revokeObjectURL(this._wrk);
                this._wrk = null;
            } catch (ignore) {}
            if (!keep_html) this.element.empty();
            this.teardown();
        },
        /**
		 * Create a prototype node
		 * @name _create_prototype_node()
		 * @return {DOMElement}
		 */ _create_prototype_node: function() {
            var _node = document.createElement("LI"), _temp1, _temp2;
            _node.setAttribute("role", "none");
            _temp1 = document.createElement("I");
            _temp1.className = "jstree-icon jstree-ocl";
            _temp1.setAttribute("role", "presentation");
            _node.appendChild(_temp1);
            _temp1 = document.createElement("A");
            _temp1.className = "jstree-anchor";
            _temp1.setAttribute("href", "#");
            _temp1.setAttribute("tabindex", "-1");
            _temp1.setAttribute("role", "treeitem");
            _temp2 = document.createElement("I");
            _temp2.className = "jstree-icon jstree-themeicon";
            _temp2.setAttribute("role", "presentation");
            _temp1.appendChild(_temp2);
            _node.appendChild(_temp1);
            _temp1 = _temp2 = null;
            return _node;
        },
        _kbevent_to_func: function(e) {
            var keys = {
                8: "Backspace",
                9: "Tab",
                13: "Enter",
                19: "Pause",
                27: "Esc",
                32: "Space",
                33: "PageUp",
                34: "PageDown",
                35: "End",
                36: "Home",
                37: "Left",
                38: "Up",
                39: "Right",
                40: "Down",
                44: "Print",
                45: "Insert",
                46: "Delete",
                96: "Numpad0",
                97: "Numpad1",
                98: "Numpad2",
                99: "Numpad3",
                100: "Numpad4",
                101: "Numpad5",
                102: "Numpad6",
                103: "Numpad7",
                104: "Numpad8",
                105: "Numpad9",
                "-13": "NumpadEnter",
                112: "F1",
                113: "F2",
                114: "F3",
                115: "F4",
                116: "F5",
                117: "F6",
                118: "F7",
                119: "F8",
                120: "F9",
                121: "F10",
                122: "F11",
                123: "F12",
                144: "Numlock",
                145: "Scrolllock",
                16: "Shift",
                17: "Ctrl",
                18: "Alt",
                48: "0",
                49: "1",
                50: "2",
                51: "3",
                52: "4",
                53: "5",
                54: "6",
                55: "7",
                56: "8",
                57: "9",
                59: ";",
                61: "=",
                65: "a",
                66: "b",
                67: "c",
                68: "d",
                69: "e",
                70: "f",
                71: "g",
                72: "h",
                73: "i",
                74: "j",
                75: "k",
                76: "l",
                77: "m",
                78: "n",
                79: "o",
                80: "p",
                81: "q",
                82: "r",
                83: "s",
                84: "t",
                85: "u",
                86: "v",
                87: "w",
                88: "x",
                89: "y",
                90: "z",
                107: "+",
                109: "-",
                110: ".",
                186: ";",
                187: "=",
                188: ",",
                189: "-",
                190: ".",
                191: "/",
                192: "`",
                219: "[",
                220: "\\",
                221: "]",
                222: "'",
                111: "/",
                106: "*",
                173: "-"
            };
            var parts = [];
            if (e.ctrlKey) parts.push("ctrl");
            if (e.altKey) parts.push("alt");
            if (e.shiftKey) parts.push("shift");
            parts.push(keys[e.which] ? keys[e.which].toLowerCase() : e.which);
            parts = parts.sort().join("-").toLowerCase();
            if (parts === "shift-shift" || parts === "ctrl-ctrl" || parts === "alt-alt") return null;
            var kb = this.settings.core.keyboard, i, tmp;
            for(i in kb)if (kb.hasOwnProperty(i)) {
                tmp = i;
                if (tmp !== "-" && tmp !== "+") {
                    tmp = tmp.replace("--", "-MINUS").replace("+-", "-MINUS").replace("++", "-PLUS").replace("-+", "-PLUS");
                    tmp = tmp.split(/-|\+/).sort().join("-").replace("MINUS", "-").replace("PLUS", "+").toLowerCase();
                }
                if (tmp === parts) return kb[i];
            }
            return null;
        },
        /**
		 * part of the destroying of an instance. Used internally.
		 * @private
		 * @name teardown()
		 */ teardown: function() {
            this.unbind();
            this.element.removeClass("jstree").removeData("jstree").find("[class^='jstree']").addBack().attr("class", function() {
                return this.className.replace(/jstree[^ ]*|$/ig, "");
            });
            this.element = null;
        },
        /**
		 * bind all events. Used internally.
		 * @private
		 * @name bind()
		 */ bind: function() {
            var word = "", tout = null, was_click = 0;
            this.element.on("dblclick.jstree", function(e) {
                if (e.target.tagName && e.target.tagName.toLowerCase() === "input") return true;
                if (document.selection && document.selection.empty) document.selection.empty();
                else if (window.getSelection) {
                    var sel = window.getSelection();
                    try {
                        sel.removeAllRanges();
                        sel.collapse();
                    } catch (ignore) {}
                }
            }).on("mousedown.jstree", (function(e) {
                if (e.target === this.element[0]) {
                    e.preventDefault(); // prevent losing focus when clicking scroll arrows (FF, Chrome)
                    was_click = +new Date(); // ie does not allow to prevent losing focus
                }
            }).bind(this)).on("mousedown.jstree", ".jstree-ocl", function(e) {
                e.preventDefault(); // prevent any node inside from losing focus when clicking the open/close icon
            }).on("click.jstree", ".jstree-ocl", (function(e) {
                this.toggle_node(e.target);
            }).bind(this)).on("dblclick.jstree", ".jstree-anchor", (function(e) {
                if (e.target.tagName && e.target.tagName.toLowerCase() === "input") return true;
                if (this.settings.core.dblclick_toggle) this.toggle_node(e.target);
            }).bind(this)).on("click.jstree", ".jstree-anchor", (function(e) {
                e.preventDefault();
                if (e.currentTarget !== document.activeElement) $(e.currentTarget).trigger("focus");
                this.activate_node(e.currentTarget, e);
            }).bind(this)).on("keydown.jstree", ".jstree-anchor", (function(e) {
                if (e.target.tagName && e.target.tagName.toLowerCase() === "input") return true;
                if (this._data.core.rtl) {
                    if (e.which === 37) e.which = 39;
                    else if (e.which === 39) e.which = 37;
                }
                var f = this._kbevent_to_func(e);
                if (f) {
                    var r = f.call(this, e);
                    if (r === false || r === true) return r;
                }
            }).bind(this)).on("load_node.jstree", (function(e, data) {
                if (data.status) {
                    if (data.node.id === $.jstree.root && !this._data.core.loaded) {
                        this._data.core.loaded = true;
                        if (this._firstChild(this.get_container_ul()[0])) this.element.attr("aria-activedescendant", this._firstChild(this.get_container_ul()[0]).id);
                        /**
								 * triggered after the root node is loaded for the first time
								 * @event
								 * @name loaded.jstree
								 */ this.trigger("loaded");
                    }
                    if (!this._data.core.ready) setTimeout((function() {
                        if (this.element && !this.get_container_ul().find(".jstree-loading").length) {
                            this._data.core.ready = true;
                            if (this._data.core.selected.length) {
                                if (this.settings.core.expand_selected_onload) {
                                    var tmp = [], i, j;
                                    for(i = 0, j = this._data.core.selected.length; i < j; i++)tmp = tmp.concat(this._model.data[this._data.core.selected[i]].parents);
                                    tmp = $.vakata.array_unique(tmp);
                                    for(i = 0, j = tmp.length; i < j; i++)this.open_node(tmp[i], false, 0);
                                }
                                this.trigger("changed", {
                                    "action": "ready",
                                    "selected": this._data.core.selected
                                });
                            }
                            /**
										 * triggered after all nodes are finished loading
										 * @event
										 * @name ready.jstree
										 */ this.trigger("ready");
                        }
                    }).bind(this), 0);
                }
            }).bind(this))// quick searching when the tree is focused
            .on("keypress.jstree", (function(e) {
                if (e.target.tagName && e.target.tagName.toLowerCase() === "input") return true;
                if (tout) clearTimeout(tout);
                tout = setTimeout(function() {
                    word = "";
                }, 500);
                var chr = String.fromCharCode(e.which).toLowerCase(), col = this.element.find(".jstree-anchor").filter(":visible"), ind = col.index(document.activeElement) || 0, end = false;
                word += chr;
                // match for whole word from current node down (including the current node)
                if (word.length > 1) {
                    col.slice(ind).each((function(i, v) {
                        if ($(v).text().toLowerCase().indexOf(word) === 0) {
                            $(v).trigger("focus");
                            end = true;
                            return false;
                        }
                    }).bind(this));
                    if (end) return;
                    // match for whole word from the beginning of the tree
                    col.slice(0, ind).each((function(i, v) {
                        if ($(v).text().toLowerCase().indexOf(word) === 0) {
                            $(v).trigger("focus");
                            end = true;
                            return false;
                        }
                    }).bind(this));
                    if (end) return;
                }
                // list nodes that start with that letter (only if word consists of a single char)
                if (new RegExp("^" + chr.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&") + "+$").test(word)) {
                    // search for the next node starting with that letter
                    col.slice(ind + 1).each((function(i, v) {
                        if ($(v).text().toLowerCase().charAt(0) === chr) {
                            $(v).trigger("focus");
                            end = true;
                            return false;
                        }
                    }).bind(this));
                    if (end) return;
                    // search from the beginning
                    col.slice(0, ind + 1).each((function(i, v) {
                        if ($(v).text().toLowerCase().charAt(0) === chr) {
                            $(v).trigger("focus");
                            end = true;
                            return false;
                        }
                    }).bind(this));
                    if (end) return;
                }
            }).bind(this))// THEME RELATED
            .on("init.jstree", (function() {
                var s = this.settings.core.themes;
                this._data.core.themes.dots = s.dots;
                this._data.core.themes.stripes = s.stripes;
                this._data.core.themes.icons = s.icons;
                this._data.core.themes.ellipsis = s.ellipsis;
                this.set_theme(s.name || "default", s.url);
                this.set_theme_variant(s.variant);
            }).bind(this)).on("loading.jstree", (function() {
                this[this._data.core.themes.dots ? "show_dots" : "hide_dots"]();
                this[this._data.core.themes.icons ? "show_icons" : "hide_icons"]();
                this[this._data.core.themes.stripes ? "show_stripes" : "hide_stripes"]();
                this[this._data.core.themes.ellipsis ? "show_ellipsis" : "hide_ellipsis"]();
            }).bind(this)).on("blur.jstree", ".jstree-anchor", (function(e) {
                this._data.core.focused = null;
                $(e.currentTarget).filter(".jstree-hovered").trigger("mouseleave");
                this.element.attr("tabindex", "0");
                $(e.currentTarget).attr("tabindex", "-1");
            }).bind(this)).on("focus.jstree", ".jstree-anchor", (function(e) {
                var tmp = this.get_node(e.currentTarget);
                if (tmp && (tmp.id || tmp.id === 0)) this._data.core.focused = tmp.id;
                this.element.find(".jstree-hovered").not(e.currentTarget).trigger("mouseleave");
                $(e.currentTarget).trigger("mouseenter");
                this.element.attr("tabindex", "-1");
                $(e.currentTarget).attr("tabindex", "0");
            }).bind(this)).on("focus.jstree", (function() {
                if (+new Date() - was_click > 500 && !this._data.core.focused && this.settings.core.restore_focus) {
                    was_click = 0;
                    var act = this.get_node(this.element.attr("aria-activedescendant"), true);
                    if (act) act.find("> .jstree-anchor").trigger("focus");
                }
            }).bind(this)).on("mouseenter.jstree", ".jstree-anchor", (function(e) {
                this.hover_node(e.currentTarget);
            }).bind(this)).on("mouseleave.jstree", ".jstree-anchor", (function(e) {
                this.dehover_node(e.currentTarget);
            }).bind(this));
        },
        /**
		 * part of the destroying of an instance. Used internally.
		 * @private
		 * @name unbind()
		 */ unbind: function() {
            this.element.off(".jstree");
            $(document).off(".jstree-" + this._id);
        },
        /**
		 * trigger an event. Used internally.
		 * @private
		 * @name trigger(ev [, data])
		 * @param  {String} ev the name of the event to trigger
		 * @param  {Object} data additional data to pass with the event
		 */ trigger: function(ev, data) {
            if (!data) data = {};
            data.instance = this;
            this.element.triggerHandler(ev.replace(".jstree", "") + ".jstree", data);
        },
        /**
		 * returns the jQuery extended instance container
		 * @name get_container()
		 * @return {jQuery}
		 */ get_container: function() {
            return this.element;
        },
        /**
		 * returns the jQuery extended main UL node inside the instance container. Used internally.
		 * @private
		 * @name get_container_ul()
		 * @return {jQuery}
		 */ get_container_ul: function() {
            return this.element.children(".jstree-children").first();
        },
        /**
		 * gets string replacements (localization). Used internally.
		 * @private
		 * @name get_string(key)
		 * @param  {String} key
		 * @return {String}
		 */ get_string: function(key) {
            var a = this.settings.core.strings;
            if ($.vakata.is_function(a)) return a.call(this, key);
            if (a && a[key]) return a[key];
            return key;
        },
        /**
		 * gets the first child of a DOM node. Used internally.
		 * @private
		 * @name _firstChild(dom)
		 * @param  {DOMElement} dom
		 * @return {DOMElement}
		 */ _firstChild: function(dom) {
            dom = dom ? dom.firstChild : null;
            while(dom !== null && dom.nodeType !== 1)dom = dom.nextSibling;
            return dom;
        },
        /**
		 * gets the next sibling of a DOM node. Used internally.
		 * @private
		 * @name _nextSibling(dom)
		 * @param  {DOMElement} dom
		 * @return {DOMElement}
		 */ _nextSibling: function(dom) {
            dom = dom ? dom.nextSibling : null;
            while(dom !== null && dom.nodeType !== 1)dom = dom.nextSibling;
            return dom;
        },
        /**
		 * gets the previous sibling of a DOM node. Used internally.
		 * @private
		 * @name _previousSibling(dom)
		 * @param  {DOMElement} dom
		 * @return {DOMElement}
		 */ _previousSibling: function(dom) {
            dom = dom ? dom.previousSibling : null;
            while(dom !== null && dom.nodeType !== 1)dom = dom.previousSibling;
            return dom;
        },
        /**
		 * get the JSON representation of a node (or the actual jQuery extended DOM node) by using any input (child DOM element, ID string, selector, etc)
		 * @name get_node(obj [, as_dom])
		 * @param  {mixed} obj
		 * @param  {Boolean} as_dom
		 * @return {Object|jQuery}
		 */ get_node: function(obj, as_dom) {
            if (obj && (obj.id || obj.id === 0)) obj = obj.id;
            if (obj instanceof $ && obj.length && obj[0].id) obj = obj[0].id;
            var dom;
            try {
                if (this._model.data[obj]) obj = this._model.data[obj];
                else if (typeof obj === "string" && this._model.data[obj.replace(/^#/, "")]) obj = this._model.data[obj.replace(/^#/, "")];
                else if (typeof obj === "string" && (dom = $("#" + obj.replace($.jstree.idregex, "\\$&"), this.element)).length && this._model.data[dom.closest(".jstree-node").attr("id")]) obj = this._model.data[dom.closest(".jstree-node").attr("id")];
                else if ((dom = this.element.find(obj)).length && this._model.data[dom.closest(".jstree-node").attr("id")]) obj = this._model.data[dom.closest(".jstree-node").attr("id")];
                else if ((dom = this.element.find(obj)).length && dom.hasClass("jstree")) obj = this._model.data[$.jstree.root];
                else return false;
                if (as_dom) obj = obj.id === $.jstree.root ? this.element : $("#" + obj.id.replace($.jstree.idregex, "\\$&"), this.element);
                return obj;
            } catch (ex) {
                return false;
            }
        },
        /**
		 * get the path to a node, either consisting of node texts, or of node IDs, optionally glued together (otherwise an array)
		 * @name get_path(obj [, glue, ids])
		 * @param  {mixed} obj the node
		 * @param  {String} glue if you want the path as a string - pass the glue here (for example '/'), if a falsy value is supplied here, an array is returned
		 * @param  {Boolean} ids if set to true build the path using ID, otherwise node text is used
		 * @return {mixed}
		 */ get_path: function(obj, glue, ids) {
            obj = obj.parents ? obj : this.get_node(obj);
            if (!obj || obj.id === $.jstree.root || !obj.parents) return false;
            var i, j, p = [];
            p.push(ids ? obj.id : obj.text);
            for(i = 0, j = obj.parents.length; i < j; i++)p.push(ids ? obj.parents[i] : this.get_text(obj.parents[i]));
            p = p.reverse().slice(1);
            return glue ? p.join(glue) : p;
        },
        /**
		 * get the next visible node that is below the `obj` node. If `strict` is set to `true` only sibling nodes are returned.
		 * @name get_next_dom(obj [, strict])
		 * @param  {mixed} obj
		 * @param  {Boolean} strict
		 * @return {jQuery}
		 */ get_next_dom: function(obj, strict) {
            var tmp;
            obj = this.get_node(obj, true);
            if (obj[0] === this.element[0]) {
                tmp = this._firstChild(this.get_container_ul()[0]);
                while(tmp && tmp.offsetHeight === 0)tmp = this._nextSibling(tmp);
                return tmp ? $(tmp) : false;
            }
            if (!obj || !obj.length) return false;
            if (strict) {
                tmp = obj[0];
                do tmp = this._nextSibling(tmp);
                while (tmp && tmp.offsetHeight === 0);
                return tmp ? $(tmp) : false;
            }
            if (obj.hasClass("jstree-open")) {
                tmp = this._firstChild(obj.children(".jstree-children")[0]);
                while(tmp && tmp.offsetHeight === 0)tmp = this._nextSibling(tmp);
                if (tmp !== null) return $(tmp);
            }
            tmp = obj[0];
            do tmp = this._nextSibling(tmp);
            while (tmp && tmp.offsetHeight === 0);
            if (tmp !== null) return $(tmp);
            return obj.parentsUntil(".jstree", ".jstree-node").nextAll(".jstree-node:visible").first();
        },
        /**
		 * get the previous visible node that is above the `obj` node. If `strict` is set to `true` only sibling nodes are returned.
		 * @name get_prev_dom(obj [, strict])
		 * @param  {mixed} obj
		 * @param  {Boolean} strict
		 * @return {jQuery}
		 */ get_prev_dom: function(obj, strict) {
            var tmp;
            obj = this.get_node(obj, true);
            if (obj[0] === this.element[0]) {
                tmp = this.get_container_ul()[0].lastChild;
                while(tmp && tmp.offsetHeight === 0)tmp = this._previousSibling(tmp);
                return tmp ? $(tmp) : false;
            }
            if (!obj || !obj.length) return false;
            if (strict) {
                tmp = obj[0];
                do tmp = this._previousSibling(tmp);
                while (tmp && tmp.offsetHeight === 0);
                return tmp ? $(tmp) : false;
            }
            tmp = obj[0];
            do tmp = this._previousSibling(tmp);
            while (tmp && tmp.offsetHeight === 0);
            if (tmp !== null) {
                obj = $(tmp);
                while(obj.hasClass("jstree-open"))obj = obj.children(".jstree-children").first().children(".jstree-node:visible:last");
                return obj;
            }
            tmp = obj[0].parentNode.parentNode;
            return tmp && tmp.className && tmp.className.indexOf("jstree-node") !== -1 ? $(tmp) : false;
        },
        /**
		 * get the parent ID of a node
		 * @name get_parent(obj)
		 * @param  {mixed} obj
		 * @return {String}
		 */ get_parent: function(obj) {
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            return obj.parent;
        },
        /**
		 * get a jQuery collection of all the children of a node (node must be rendered), returns false on error
		 * @name get_children_dom(obj)
		 * @param  {mixed} obj
		 * @return {jQuery}
		 */ get_children_dom: function(obj) {
            obj = this.get_node(obj, true);
            if (obj[0] === this.element[0]) return this.get_container_ul().children(".jstree-node");
            if (!obj || !obj.length) return false;
            return obj.children(".jstree-children").children(".jstree-node");
        },
        /**
		 * checks if a node has children
		 * @name is_parent(obj)
		 * @param  {mixed} obj
		 * @return {Boolean}
		 */ is_parent: function(obj) {
            obj = this.get_node(obj);
            return obj && (obj.state.loaded === false || obj.children.length > 0);
        },
        /**
		 * checks if a node is loaded (its children are available)
		 * @name is_loaded(obj)
		 * @param  {mixed} obj
		 * @return {Boolean}
		 */ is_loaded: function(obj) {
            obj = this.get_node(obj);
            return obj && obj.state.loaded;
        },
        /**
		 * check if a node is currently loading (fetching children)
		 * @name is_loading(obj)
		 * @param  {mixed} obj
		 * @return {Boolean}
		 */ is_loading: function(obj) {
            obj = this.get_node(obj);
            return obj && obj.state && obj.state.loading;
        },
        /**
		 * check if a node is opened
		 * @name is_open(obj)
		 * @param  {mixed} obj
		 * @return {Boolean}
		 */ is_open: function(obj) {
            obj = this.get_node(obj);
            return obj && obj.state.opened;
        },
        /**
		 * check if a node is in a closed state
		 * @name is_closed(obj)
		 * @param  {mixed} obj
		 * @return {Boolean}
		 */ is_closed: function(obj) {
            obj = this.get_node(obj);
            return obj && this.is_parent(obj) && !obj.state.opened;
        },
        /**
		 * check if a node has no children
		 * @name is_leaf(obj)
		 * @param  {mixed} obj
		 * @return {Boolean}
		 */ is_leaf: function(obj) {
            return !this.is_parent(obj);
        },
        /**
		 * loads a node (fetches its children using the `core.data` setting). Multiple nodes can be passed to by using an array.
		 * @name load_node(obj [, callback])
		 * @param  {mixed} obj
		 * @param  {function} callback a function to be executed once loading is complete, the function is executed in the instance's scope and receives two arguments - the node and a boolean status
		 * @return {Boolean}
		 * @trigger load_node.jstree
		 */ load_node: function(obj, callback) {
            var dom = this.get_node(obj, true), k, l, i, j, c;
            if ($.vakata.is_array(obj)) {
                this._load_nodes(obj.slice(), callback);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj) {
                if (callback) callback.call(this, obj, false);
                return false;
            }
            // if(obj.state.loading) { } // the node is already loading - just wait for it to load and invoke callback? but if called implicitly it should be loaded again?
            if (obj.state.loaded) {
                obj.state.loaded = false;
                for(i = 0, j = obj.parents.length; i < j; i++)this._model.data[obj.parents[i]].children_d = $.vakata.array_filter(this._model.data[obj.parents[i]].children_d, function(v) {
                    return $.inArray(v, obj.children_d) === -1;
                });
                for(k = 0, l = obj.children_d.length; k < l; k++){
                    if (this._model.data[obj.children_d[k]].state.selected) c = true;
                    delete this._model.data[obj.children_d[k]];
                }
                if (c) this._data.core.selected = $.vakata.array_filter(this._data.core.selected, function(v) {
                    return $.inArray(v, obj.children_d) === -1;
                });
                obj.children = [];
                obj.children_d = [];
                if (c) this.trigger("changed", {
                    "action": "load_node",
                    "node": obj,
                    "selected": this._data.core.selected
                });
            }
            obj.state.failed = false;
            obj.state.loading = true;
            if (obj.id !== $.jstree.root) dom.children(".jstree-anchor").attr("aria-busy", true);
            else dom.attr("aria-busy", true);
            dom.addClass("jstree-loading");
            this._load_node(obj, (function(status) {
                obj = this._model.data[obj.id];
                obj.state.loading = false;
                obj.state.loaded = status;
                obj.state.failed = !obj.state.loaded;
                var dom = this.get_node(obj, true), i = 0, j = 0, m = this._model.data, has_children = false;
                for(i = 0, j = obj.children.length; i < j; i++)if (m[obj.children[i]] && !m[obj.children[i]].state.hidden) {
                    has_children = true;
                    break;
                }
                if (obj.state.loaded && dom && dom.length) {
                    dom.removeClass("jstree-closed jstree-open jstree-leaf");
                    if (!has_children) dom.addClass("jstree-leaf");
                    else if (obj.id !== "#") dom.addClass(obj.state.opened ? "jstree-open" : "jstree-closed");
                }
                if (obj.id !== $.jstree.root) dom.children(".jstree-anchor").attr("aria-busy", false);
                else dom.attr("aria-busy", false);
                dom.removeClass("jstree-loading");
                /**
				 * triggered after a node is loaded
				 * @event
				 * @name load_node.jstree
				 * @param {Object} node the node that was loading
				 * @param {Boolean} status was the node loaded successfully
				 */ this.trigger("load_node", {
                    "node": obj,
                    "status": status
                });
                if (callback) callback.call(this, obj, status);
            }).bind(this));
            return true;
        },
        /**
		 * load an array of nodes (will also load unavailable nodes as soon as they appear in the structure). Used internally.
		 * @private
		 * @name _load_nodes(nodes [, callback])
		 * @param  {array} nodes
		 * @param  {function} callback a function to be executed once loading is complete, the function is executed in the instance's scope and receives one argument - the array passed to _load_nodes
		 */ _load_nodes: function(nodes, callback, is_callback, force_reload) {
            var r = true, c = function() {
                this._load_nodes(nodes, callback, true);
            }, m = this._model.data, i, j, tmp = [];
            for(i = 0, j = nodes.length; i < j; i++)if (m[nodes[i]] && (!m[nodes[i]].state.loaded && !m[nodes[i]].state.failed || !is_callback && force_reload)) {
                if (!this.is_loading(nodes[i])) this.load_node(nodes[i], c);
                r = false;
            }
            if (r) {
                for(i = 0, j = nodes.length; i < j; i++)if (m[nodes[i]] && m[nodes[i]].state.loaded) tmp.push(nodes[i]);
                if (callback && !callback.done) {
                    callback.call(this, tmp);
                    callback.done = true;
                }
            }
        },
        /**
		 * loads all unloaded nodes
		 * @name load_all([obj, callback])
		 * @param {mixed} obj the node to load recursively, omit to load all nodes in the tree
		 * @param {function} callback a function to be executed once loading all the nodes is complete,
		 * @trigger load_all.jstree
		 */ load_all: function(obj, callback) {
            if (!obj) obj = $.jstree.root;
            obj = this.get_node(obj);
            if (!obj) return false;
            var to_load = [], m = this._model.data, c = m[obj.id].children_d, i, j;
            if (obj.state && !obj.state.loaded) to_load.push(obj.id);
            for(i = 0, j = c.length; i < j; i++)if (m[c[i]] && m[c[i]].state && !m[c[i]].state.loaded) to_load.push(c[i]);
            if (to_load.length) this._load_nodes(to_load, function() {
                this.load_all(obj, callback);
            });
            else {
                /**
				 * triggered after a load_all call completes
				 * @event
				 * @name load_all.jstree
				 * @param {Object} node the recursively loaded node
				 */ if (callback) callback.call(this, obj);
                this.trigger("load_all", {
                    "node": obj
                });
            }
        },
        /**
		 * handles the actual loading of a node. Used only internally.
		 * @private
		 * @name _load_node(obj [, callback])
		 * @param  {mixed} obj
		 * @param  {function} callback a function to be executed once loading is complete, the function is executed in the instance's scope and receives one argument - a boolean status
		 * @return {Boolean}
		 */ _load_node: function(obj, callback) {
            var s = this.settings.core.data, t;
            var notTextOrCommentNode = function notTextOrCommentNode() {
                return this.nodeType !== 3 && this.nodeType !== 8;
            };
            // use original HTML
            if (!s) {
                if (obj.id === $.jstree.root) return this._append_html_data(obj, this._data.core.original_container_html.clone(true), function(status) {
                    callback.call(this, status);
                });
                else return callback.call(this, false);
            // return callback.call(this, obj.id === $.jstree.root ? this._append_html_data(obj, this._data.core.original_container_html.clone(true)) : false);
            }
            if ($.vakata.is_function(s)) return s.call(this, obj, (function(d) {
                if (d === false) callback.call(this, false);
                else this[typeof d === "string" ? "_append_html_data" : "_append_json_data"](obj, typeof d === "string" ? $($.parseHTML(d)).filter(notTextOrCommentNode) : d, function(status) {
                    callback.call(this, status);
                });
            // return d === false ? callback.call(this, false) : callback.call(this, this[typeof d === 'string' ? '_append_html_data' : '_append_json_data'](obj, typeof d === 'string' ? $(d) : d));
            }).bind(this));
            if (typeof s === "object") {
                if (s.url) {
                    s = $.extend(true, {}, s);
                    if ($.vakata.is_function(s.url)) s.url = s.url.call(this, obj);
                    if ($.vakata.is_function(s.data)) s.data = s.data.call(this, obj);
                    return $.ajax(s).done((function(d, t, x) {
                        var type = x.getResponseHeader("Content-Type");
                        if (type && type.indexOf("json") !== -1 || typeof d === "object") return this._append_json_data(obj, d, function(status) {
                            callback.call(this, status);
                        });
                        if (type && type.indexOf("html") !== -1 || typeof d === "string") return this._append_html_data(obj, $($.parseHTML(d)).filter(notTextOrCommentNode), function(status) {
                            callback.call(this, status);
                        });
                        this._data.core.last_error = {
                            "error": "ajax",
                            "plugin": "core",
                            "id": "core_04",
                            "reason": "Could not load node",
                            "data": JSON.stringify({
                                "id": obj.id,
                                "xhr": x
                            })
                        };
                        this.settings.core.error.call(this, this._data.core.last_error);
                        return callback.call(this, false);
                    }).bind(this)).fail((function(f) {
                        this._data.core.last_error = {
                            "error": "ajax",
                            "plugin": "core",
                            "id": "core_04",
                            "reason": "Could not load node",
                            "data": JSON.stringify({
                                "id": obj.id,
                                "xhr": f
                            })
                        };
                        callback.call(this, false);
                        this.settings.core.error.call(this, this._data.core.last_error);
                    }).bind(this));
                }
                if ($.vakata.is_array(s)) t = $.extend(true, [], s);
                else if ($.isPlainObject(s)) t = $.extend(true, {}, s);
                else t = s;
                if (obj.id === $.jstree.root) return this._append_json_data(obj, t, function(status) {
                    callback.call(this, status);
                });
                else {
                    this._data.core.last_error = {
                        "error": "nodata",
                        "plugin": "core",
                        "id": "core_05",
                        "reason": "Could not load node",
                        "data": JSON.stringify({
                            "id": obj.id
                        })
                    };
                    this.settings.core.error.call(this, this._data.core.last_error);
                    return callback.call(this, false);
                }
            //return callback.call(this, (obj.id === $.jstree.root ? this._append_json_data(obj, t) : false) );
            }
            if (typeof s === "string") {
                if (obj.id === $.jstree.root) return this._append_html_data(obj, $($.parseHTML(s)).filter(notTextOrCommentNode), function(status) {
                    callback.call(this, status);
                });
                else {
                    this._data.core.last_error = {
                        "error": "nodata",
                        "plugin": "core",
                        "id": "core_06",
                        "reason": "Could not load node",
                        "data": JSON.stringify({
                            "id": obj.id
                        })
                    };
                    this.settings.core.error.call(this, this._data.core.last_error);
                    return callback.call(this, false);
                }
            //return callback.call(this, (obj.id === $.jstree.root ? this._append_html_data(obj, $(s)) : false) );
            }
            return callback.call(this, false);
        },
        /**
		 * adds a node to the list of nodes to redraw. Used only internally.
		 * @private
		 * @name _node_changed(obj [, callback])
		 * @param  {mixed} obj
		 */ _node_changed: function(obj) {
            obj = this.get_node(obj);
            if (obj && $.inArray(obj.id, this._model.changed) === -1) this._model.changed.push(obj.id);
        },
        /**
		 * appends HTML content to the tree. Used internally.
		 * @private
		 * @name _append_html_data(obj, data)
		 * @param  {mixed} obj the node to append to
		 * @param  {String} data the HTML string to parse and append
		 * @trigger model.jstree, changed.jstree
		 */ _append_html_data: function(dom, data, cb) {
            dom = this.get_node(dom);
            dom.children = [];
            dom.children_d = [];
            var dat = data.is("ul") ? data.children() : data, par = dom.id, chd = [], dpc = [], m = this._model.data, p = m[par], s = this._data.core.selected.length, tmp, i, j;
            dat.each((function(i, v) {
                tmp = this._parse_model_from_html($(v), par, p.parents.concat());
                if (tmp) {
                    chd.push(tmp);
                    dpc.push(tmp);
                    if (m[tmp].children_d.length) dpc = dpc.concat(m[tmp].children_d);
                }
            }).bind(this));
            p.children = chd;
            p.children_d = dpc;
            for(i = 0, j = p.parents.length; i < j; i++)m[p.parents[i]].children_d = m[p.parents[i]].children_d.concat(dpc);
            /**
			 * triggered when new data is inserted to the tree model
			 * @event
			 * @name model.jstree
			 * @param {Array} nodes an array of node IDs
			 * @param {String} parent the parent ID of the nodes
			 */ this.trigger("model", {
                "nodes": dpc,
                "parent": par
            });
            if (par !== $.jstree.root) {
                this._node_changed(par);
                this.redraw();
            } else {
                this.get_container_ul().children(".jstree-initial-node").remove();
                this.redraw(true);
            }
            if (this._data.core.selected.length !== s) this.trigger("changed", {
                "action": "model",
                "selected": this._data.core.selected
            });
            cb.call(this, true);
        },
        /**
		 * appends JSON content to the tree. Used internally.
		 * @private
		 * @name _append_json_data(obj, data)
		 * @param  {mixed} obj the node to append to
		 * @param  {String} data the JSON object to parse and append
		 * @param  {Boolean} force_processing internal param - do not set
		 * @trigger model.jstree, changed.jstree
		 */ _append_json_data: function(dom, data, cb, force_processing) {
            if (this.element === null) return;
            dom = this.get_node(dom);
            dom.children = [];
            dom.children_d = [];
            // *%$@!!!
            if (data.d) {
                data = data.d;
                if (typeof data === "string") data = JSON.parse(data);
            }
            if (!$.vakata.is_array(data)) data = [
                data
            ];
            var w = null, args = {
                "df": this._model.default_state,
                "dat": data,
                "par": dom.id,
                "m": this._model.data,
                "t_id": this._id,
                "t_cnt": this._cnt,
                "sel": this._data.core.selected
            }, inst = this, func = function(data, undefined) {
                if (data.data) data = data.data;
                var dat = data.dat, par = data.par, chd = [], dpc = [], add = [], df = data.df, t_id = data.t_id, t_cnt = data.t_cnt, m = data.m, p = m[par], sel = data.sel, tmp, i, j, rslt, parse_flat = function(d, p, ps) {
                    if (!ps) ps = [];
                    else ps = ps.concat();
                    if (p) ps.unshift(p);
                    var tid = d.id.toString(), i, j, c, e, tmp = {
                        id: tid,
                        text: d.text || "",
                        icon: d.icon !== undefined ? d.icon : true,
                        parent: p,
                        parents: ps,
                        children: d.children || [],
                        children_d: d.children_d || [],
                        data: d.data,
                        state: {},
                        li_attr: {
                            id: false
                        },
                        a_attr: {
                            href: "#"
                        },
                        original: false
                    };
                    for(i in df)if (df.hasOwnProperty(i)) tmp.state[i] = df[i];
                    if (d && d.data && d.data.jstree && d.data.jstree.icon) tmp.icon = d.data.jstree.icon;
                    if (tmp.icon === undefined || tmp.icon === null || tmp.icon === "") tmp.icon = true;
                    if (d && d.data) {
                        tmp.data = d.data;
                        if (d.data.jstree) {
                            for(i in d.data.jstree)if (d.data.jstree.hasOwnProperty(i)) tmp.state[i] = d.data.jstree[i];
                        }
                    }
                    if (d && typeof d.state === "object") {
                        for(i in d.state)if (d.state.hasOwnProperty(i)) tmp.state[i] = d.state[i];
                    }
                    if (d && typeof d.li_attr === "object") {
                        for(i in d.li_attr)if (d.li_attr.hasOwnProperty(i)) tmp.li_attr[i] = d.li_attr[i];
                    }
                    if (!tmp.li_attr.id) tmp.li_attr.id = tid;
                    if (d && typeof d.a_attr === "object") {
                        for(i in d.a_attr)if (d.a_attr.hasOwnProperty(i)) tmp.a_attr[i] = d.a_attr[i];
                    }
                    if (d && d.children && d.children === true) {
                        tmp.state.loaded = false;
                        tmp.children = [];
                        tmp.children_d = [];
                    }
                    m[tmp.id] = tmp;
                    for(i = 0, j = tmp.children.length; i < j; i++){
                        c = parse_flat(m[tmp.children[i]], tmp.id, ps);
                        e = m[c];
                        tmp.children_d.push(c);
                        if (e.children_d.length) tmp.children_d = tmp.children_d.concat(e.children_d);
                    }
                    delete d.data;
                    delete d.children;
                    m[tmp.id].original = d;
                    if (tmp.state.selected) add.push(tmp.id);
                    return tmp.id;
                }, parse_nest = function(d, p, ps) {
                    if (!ps) ps = [];
                    else ps = ps.concat();
                    if (p) ps.unshift(p);
                    var tid = false, i, j, c, e, tmp;
                    do tid = "j" + t_id + "_" + ++t_cnt;
                    while (m[tid]);
                    tmp = {
                        id: false,
                        text: typeof d === "string" ? d : "",
                        icon: typeof d === "object" && d.icon !== undefined ? d.icon : true,
                        parent: p,
                        parents: ps,
                        children: [],
                        children_d: [],
                        data: null,
                        state: {},
                        li_attr: {
                            id: false
                        },
                        a_attr: {
                            href: "#"
                        },
                        original: false
                    };
                    for(i in df)if (df.hasOwnProperty(i)) tmp.state[i] = df[i];
                    if (d && (d.id || d.id === 0)) tmp.id = d.id.toString();
                    if (d && d.text) tmp.text = d.text;
                    if (d && d.data && d.data.jstree && d.data.jstree.icon) tmp.icon = d.data.jstree.icon;
                    if (tmp.icon === undefined || tmp.icon === null || tmp.icon === "") tmp.icon = true;
                    if (d && d.data) {
                        tmp.data = d.data;
                        if (d.data.jstree) {
                            for(i in d.data.jstree)if (d.data.jstree.hasOwnProperty(i)) tmp.state[i] = d.data.jstree[i];
                        }
                    }
                    if (d && typeof d.state === "object") {
                        for(i in d.state)if (d.state.hasOwnProperty(i)) tmp.state[i] = d.state[i];
                    }
                    if (d && typeof d.li_attr === "object") {
                        for(i in d.li_attr)if (d.li_attr.hasOwnProperty(i)) tmp.li_attr[i] = d.li_attr[i];
                    }
                    if (tmp.li_attr.id && !(tmp.id || tmp.id === 0)) tmp.id = tmp.li_attr.id.toString();
                    if (!(tmp.id || tmp.id === 0)) tmp.id = tid;
                    if (!tmp.li_attr.id) tmp.li_attr.id = tmp.id;
                    if (d && typeof d.a_attr === "object") {
                        for(i in d.a_attr)if (d.a_attr.hasOwnProperty(i)) tmp.a_attr[i] = d.a_attr[i];
                    }
                    if (d && d.children && d.children.length) {
                        for(i = 0, j = d.children.length; i < j; i++){
                            c = parse_nest(d.children[i], tmp.id, ps);
                            e = m[c];
                            tmp.children.push(c);
                            if (e.children_d.length) tmp.children_d = tmp.children_d.concat(e.children_d);
                        }
                        tmp.children_d = tmp.children_d.concat(tmp.children);
                    }
                    if (d && d.children && d.children === true) {
                        tmp.state.loaded = false;
                        tmp.children = [];
                        tmp.children_d = [];
                    }
                    delete d.data;
                    delete d.children;
                    tmp.original = d;
                    m[tmp.id] = tmp;
                    if (tmp.state.selected) add.push(tmp.id);
                    return tmp.id;
                };
                if (dat.length && dat[0].id !== undefined && dat[0].parent !== undefined) {
                    // Flat JSON support (for easy import from DB):
                    // 1) convert to object (foreach)
                    for(i = 0, j = dat.length; i < j; i++){
                        if (!dat[i].children) dat[i].children = [];
                        if (!dat[i].state) dat[i].state = {};
                        m[dat[i].id.toString()] = dat[i];
                    }
                    // 2) populate children (foreach)
                    for(i = 0, j = dat.length; i < j; i++){
                        if (!m[dat[i].parent.toString()]) {
                            if (typeof inst !== "undefined") {
                                inst._data.core.last_error = {
                                    "error": "parse",
                                    "plugin": "core",
                                    "id": "core_07",
                                    "reason": "Node with invalid parent",
                                    "data": JSON.stringify({
                                        "id": dat[i].id.toString(),
                                        "parent": dat[i].parent.toString()
                                    })
                                };
                                inst.settings.core.error.call(inst, inst._data.core.last_error);
                            }
                            continue;
                        }
                        m[dat[i].parent.toString()].children.push(dat[i].id.toString());
                        // populate parent.children_d
                        p.children_d.push(dat[i].id.toString());
                    }
                    // 3) normalize && populate parents and children_d with recursion
                    for(i = 0, j = p.children.length; i < j; i++){
                        tmp = parse_flat(m[p.children[i]], par, p.parents.concat());
                        dpc.push(tmp);
                        if (m[tmp].children_d.length) dpc = dpc.concat(m[tmp].children_d);
                    }
                    for(i = 0, j = p.parents.length; i < j; i++)m[p.parents[i]].children_d = m[p.parents[i]].children_d.concat(dpc);
                    // ?) three_state selection - p.state.selected && t - (if three_state foreach(dat => ch) -> foreach(parents) if(parent.selected) child.selected = true;
                    rslt = {
                        "cnt": t_cnt,
                        "mod": m,
                        "sel": sel,
                        "par": par,
                        "dpc": dpc,
                        "add": add
                    };
                } else {
                    for(i = 0, j = dat.length; i < j; i++){
                        tmp = parse_nest(dat[i], par, p.parents.concat());
                        if (tmp) {
                            chd.push(tmp);
                            dpc.push(tmp);
                            if (m[tmp].children_d.length) dpc = dpc.concat(m[tmp].children_d);
                        }
                    }
                    p.children = chd;
                    p.children_d = dpc;
                    for(i = 0, j = p.parents.length; i < j; i++)m[p.parents[i]].children_d = m[p.parents[i]].children_d.concat(dpc);
                    rslt = {
                        "cnt": t_cnt,
                        "mod": m,
                        "sel": sel,
                        "par": par,
                        "dpc": dpc,
                        "add": add
                    };
                }
                if (typeof window === "undefined" || typeof window.document === "undefined") postMessage(rslt);
                else return rslt;
            }, rslt = function(rslt, worker) {
                if (this.element === null) return;
                this._cnt = rslt.cnt;
                var i, m = this._model.data;
                for(i in m)if (m.hasOwnProperty(i) && m[i].state && m[i].state.loading && rslt.mod[i]) rslt.mod[i].state.loading = true;
                this._model.data = rslt.mod; // breaks the reference in load_node - careful
                if (worker) {
                    var j, a = rslt.add, r = rslt.sel, s = this._data.core.selected.slice();
                    m = this._model.data;
                    // if selection was changed while calculating in worker
                    if (r.length !== s.length || $.vakata.array_unique(r.concat(s)).length !== r.length) {
                        // deselect nodes that are no longer selected
                        for(i = 0, j = r.length; i < j; i++)if ($.inArray(r[i], a) === -1 && $.inArray(r[i], s) === -1) m[r[i]].state.selected = false;
                        // select nodes that were selected in the mean time
                        for(i = 0, j = s.length; i < j; i++)if ($.inArray(s[i], r) === -1) m[s[i]].state.selected = true;
                    }
                }
                if (rslt.add.length) this._data.core.selected = this._data.core.selected.concat(rslt.add);
                this.trigger("model", {
                    "nodes": rslt.dpc,
                    "parent": rslt.par
                });
                if (rslt.par !== $.jstree.root) {
                    this._node_changed(rslt.par);
                    this.redraw();
                } else // this.get_container_ul().children('.jstree-initial-node').remove();
                this.redraw(true);
                if (rslt.add.length) this.trigger("changed", {
                    "action": "model",
                    "selected": this._data.core.selected
                });
                // If no worker, try to mimic worker behavioour, by invoking cb asynchronously
                if (!worker && setImmediate) setImmediate(function() {
                    cb.call(inst, true);
                });
                else cb.call(inst, true);
            };
            if (this.settings.core.worker && window.Blob && window.URL && window.Worker) try {
                if (this._wrk === null) this._wrk = window.URL.createObjectURL(new window.Blob([
                    "self.onmessage = " + func.toString()
                ], {
                    type: "text/javascript"
                }));
                if (!this._data.core.working || force_processing) {
                    this._data.core.working = true;
                    w = new window.Worker(this._wrk);
                    w.onmessage = (function(e) {
                        rslt.call(this, e.data, true);
                        try {
                            w.terminate();
                            w = null;
                        } catch (ignore) {}
                        if (this._data.core.worker_queue.length) this._append_json_data.apply(this, this._data.core.worker_queue.shift());
                        else this._data.core.working = false;
                    }).bind(this);
                    w.onerror = (function(e) {
                        rslt.call(this, func(args), false);
                        if (this._data.core.worker_queue.length) this._append_json_data.apply(this, this._data.core.worker_queue.shift());
                        else this._data.core.working = false;
                    }).bind(this);
                    if (!args.par) {
                        if (this._data.core.worker_queue.length) this._append_json_data.apply(this, this._data.core.worker_queue.shift());
                        else this._data.core.working = false;
                    } else w.postMessage(args);
                } else this._data.core.worker_queue.push([
                    dom,
                    data,
                    cb,
                    true
                ]);
            } catch (e) {
                rslt.call(this, func(args), false);
                if (this._data.core.worker_queue.length) this._append_json_data.apply(this, this._data.core.worker_queue.shift());
                else this._data.core.working = false;
            }
            else rslt.call(this, func(args), false);
        },
        /**
		 * parses a node from a jQuery object and appends them to the in memory tree model. Used internally.
		 * @private
		 * @name _parse_model_from_html(d [, p, ps])
		 * @param  {jQuery} d the jQuery object to parse
		 * @param  {String} p the parent ID
		 * @param  {Array} ps list of all parents
		 * @return {String} the ID of the object added to the model
		 */ _parse_model_from_html: function(d, p, ps) {
            if (!ps) ps = [];
            else ps = [].concat(ps);
            if (p) ps.unshift(p);
            var c, e, m = this._model.data, data = {
                id: false,
                text: false,
                icon: true,
                parent: p,
                parents: ps,
                children: [],
                children_d: [],
                data: null,
                state: {},
                li_attr: {
                    id: false
                },
                a_attr: {
                    href: "#"
                },
                original: false
            }, i, tmp, tid;
            for(i in this._model.default_state)if (this._model.default_state.hasOwnProperty(i)) data.state[i] = this._model.default_state[i];
            tmp = $.vakata.attributes(d, true);
            $.each(tmp, function(i, v) {
                v = $.vakata.trim(v);
                if (!v.length) return true;
                data.li_attr[i] = v;
                if (i === "id") data.id = v.toString();
            });
            tmp = d.children("a").first();
            if (tmp.length) {
                tmp = $.vakata.attributes(tmp, true);
                $.each(tmp, function(i, v) {
                    v = $.vakata.trim(v);
                    if (v.length) data.a_attr[i] = v;
                });
            }
            tmp = d.children("a").first().length ? d.children("a").first().clone() : d.clone();
            tmp.children("ins, i, ul").remove();
            tmp = tmp.html();
            tmp = $("<div></div>").html(tmp);
            data.text = this.settings.core.force_text ? tmp.text() : tmp.html();
            tmp = d.data();
            data.data = tmp ? $.extend(true, {}, tmp) : null;
            data.state.opened = d.hasClass("jstree-open");
            data.state.selected = d.children("a").hasClass("jstree-clicked");
            data.state.disabled = d.children("a").hasClass("jstree-disabled");
            if (data.data && data.data.jstree) {
                for(i in data.data.jstree)if (data.data.jstree.hasOwnProperty(i)) data.state[i] = data.data.jstree[i];
            }
            tmp = d.children("a").children(".jstree-themeicon");
            if (tmp.length) data.icon = tmp.hasClass("jstree-themeicon-hidden") ? false : tmp.attr("rel");
            if (data.state.icon !== undefined) data.icon = data.state.icon;
            if (data.icon === undefined || data.icon === null || data.icon === "") data.icon = true;
            tmp = d.children("ul").children("li");
            do tid = "j" + this._id + "_" + ++this._cnt;
            while (m[tid]);
            data.id = data.li_attr.id ? data.li_attr.id.toString() : tid;
            if (tmp.length) {
                tmp.each((function(i, v) {
                    c = this._parse_model_from_html($(v), data.id, ps);
                    e = this._model.data[c];
                    data.children.push(c);
                    if (e.children_d.length) data.children_d = data.children_d.concat(e.children_d);
                }).bind(this));
                data.children_d = data.children_d.concat(data.children);
            } else if (d.hasClass("jstree-closed")) data.state.loaded = false;
            if (data.li_attr["class"]) data.li_attr["class"] = data.li_attr["class"].replace("jstree-closed", "").replace("jstree-open", "");
            if (data.a_attr["class"]) data.a_attr["class"] = data.a_attr["class"].replace("jstree-clicked", "").replace("jstree-disabled", "");
            m[data.id] = data;
            if (data.state.selected) this._data.core.selected.push(data.id);
            return data.id;
        },
        /**
		 * parses a node from a JSON object (used when dealing with flat data, which has no nesting of children, but has id and parent properties) and appends it to the in memory tree model. Used internally.
		 * @private
		 * @name _parse_model_from_flat_json(d [, p, ps])
		 * @param  {Object} d the JSON object to parse
		 * @param  {String} p the parent ID
		 * @param  {Array} ps list of all parents
		 * @return {String} the ID of the object added to the model
		 */ _parse_model_from_flat_json: function(d, p, ps) {
            if (!ps) ps = [];
            else ps = ps.concat();
            if (p) ps.unshift(p);
            var tid = d.id.toString(), m = this._model.data, df = this._model.default_state, i, j, c, e, tmp = {
                id: tid,
                text: d.text || "",
                icon: d.icon !== undefined ? d.icon : true,
                parent: p,
                parents: ps,
                children: d.children || [],
                children_d: d.children_d || [],
                data: d.data,
                state: {},
                li_attr: {
                    id: false
                },
                a_attr: {
                    href: "#"
                },
                original: false
            };
            for(i in df)if (df.hasOwnProperty(i)) tmp.state[i] = df[i];
            if (d && d.data && d.data.jstree && d.data.jstree.icon) tmp.icon = d.data.jstree.icon;
            if (tmp.icon === undefined || tmp.icon === null || tmp.icon === "") tmp.icon = true;
            if (d && d.data) {
                tmp.data = d.data;
                if (d.data.jstree) {
                    for(i in d.data.jstree)if (d.data.jstree.hasOwnProperty(i)) tmp.state[i] = d.data.jstree[i];
                }
            }
            if (d && typeof d.state === "object") {
                for(i in d.state)if (d.state.hasOwnProperty(i)) tmp.state[i] = d.state[i];
            }
            if (d && typeof d.li_attr === "object") {
                for(i in d.li_attr)if (d.li_attr.hasOwnProperty(i)) tmp.li_attr[i] = d.li_attr[i];
            }
            if (!tmp.li_attr.id) tmp.li_attr.id = tid;
            if (d && typeof d.a_attr === "object") {
                for(i in d.a_attr)if (d.a_attr.hasOwnProperty(i)) tmp.a_attr[i] = d.a_attr[i];
            }
            if (d && d.children && d.children === true) {
                tmp.state.loaded = false;
                tmp.children = [];
                tmp.children_d = [];
            }
            m[tmp.id] = tmp;
            for(i = 0, j = tmp.children.length; i < j; i++){
                c = this._parse_model_from_flat_json(m[tmp.children[i]], tmp.id, ps);
                e = m[c];
                tmp.children_d.push(c);
                if (e.children_d.length) tmp.children_d = tmp.children_d.concat(e.children_d);
            }
            delete d.data;
            delete d.children;
            m[tmp.id].original = d;
            if (tmp.state.selected) this._data.core.selected.push(tmp.id);
            return tmp.id;
        },
        /**
		 * parses a node from a JSON object and appends it to the in memory tree model. Used internally.
		 * @private
		 * @name _parse_model_from_json(d [, p, ps])
		 * @param  {Object} d the JSON object to parse
		 * @param  {String} p the parent ID
		 * @param  {Array} ps list of all parents
		 * @return {String} the ID of the object added to the model
		 */ _parse_model_from_json: function(d, p, ps) {
            if (!ps) ps = [];
            else ps = ps.concat();
            if (p) ps.unshift(p);
            var tid = false, i, j, c, e, m = this._model.data, df = this._model.default_state, tmp;
            do tid = "j" + this._id + "_" + ++this._cnt;
            while (m[tid]);
            tmp = {
                id: false,
                text: typeof d === "string" ? d : "",
                icon: typeof d === "object" && d.icon !== undefined ? d.icon : true,
                parent: p,
                parents: ps,
                children: [],
                children_d: [],
                data: null,
                state: {},
                li_attr: {
                    id: false
                },
                a_attr: {
                    href: "#"
                },
                original: false
            };
            for(i in df)if (df.hasOwnProperty(i)) tmp.state[i] = df[i];
            if (d && (d.id || d.id === 0)) tmp.id = d.id.toString();
            if (d && d.text) tmp.text = d.text;
            if (d && d.data && d.data.jstree && d.data.jstree.icon) tmp.icon = d.data.jstree.icon;
            if (tmp.icon === undefined || tmp.icon === null || tmp.icon === "") tmp.icon = true;
            if (d && d.data) {
                tmp.data = d.data;
                if (d.data.jstree) {
                    for(i in d.data.jstree)if (d.data.jstree.hasOwnProperty(i)) tmp.state[i] = d.data.jstree[i];
                }
            }
            if (d && typeof d.state === "object") {
                for(i in d.state)if (d.state.hasOwnProperty(i)) tmp.state[i] = d.state[i];
            }
            if (d && typeof d.li_attr === "object") {
                for(i in d.li_attr)if (d.li_attr.hasOwnProperty(i)) tmp.li_attr[i] = d.li_attr[i];
            }
            if (tmp.li_attr.id && !(tmp.id || tmp.id === 0)) tmp.id = tmp.li_attr.id.toString();
            if (!(tmp.id || tmp.id === 0)) tmp.id = tid;
            if (!tmp.li_attr.id) tmp.li_attr.id = tmp.id;
            if (d && typeof d.a_attr === "object") {
                for(i in d.a_attr)if (d.a_attr.hasOwnProperty(i)) tmp.a_attr[i] = d.a_attr[i];
            }
            if (d && d.children && d.children.length) {
                for(i = 0, j = d.children.length; i < j; i++){
                    c = this._parse_model_from_json(d.children[i], tmp.id, ps);
                    e = m[c];
                    tmp.children.push(c);
                    if (e.children_d.length) tmp.children_d = tmp.children_d.concat(e.children_d);
                }
                tmp.children_d = tmp.children.concat(tmp.children_d);
            }
            if (d && d.children && d.children === true) {
                tmp.state.loaded = false;
                tmp.children = [];
                tmp.children_d = [];
            }
            delete d.data;
            delete d.children;
            tmp.original = d;
            m[tmp.id] = tmp;
            if (tmp.state.selected) this._data.core.selected.push(tmp.id);
            return tmp.id;
        },
        /**
		 * redraws all nodes that need to be redrawn. Used internally.
		 * @private
		 * @name _redraw()
		 * @trigger redraw.jstree
		 */ _redraw: function() {
            var nodes = this._model.force_full_redraw ? this._model.data[$.jstree.root].children.concat([]) : this._model.changed.concat([]), f = document.createElement("UL"), tmp, i, j, fe = this._data.core.focused;
            for(i = 0, j = nodes.length; i < j; i++){
                tmp = this.redraw_node(nodes[i], true, this._model.force_full_redraw);
                if (tmp && this._model.force_full_redraw) f.appendChild(tmp);
            }
            if (this._model.force_full_redraw) {
                f.className = this.get_container_ul()[0].className;
                f.setAttribute("role", "presentation");
                this.element.empty().append(f);
            //this.get_container_ul()[0].appendChild(f);
            }
            if (fe !== null && this.settings.core.restore_focus) {
                tmp = this.get_node(fe, true);
                if (tmp && tmp.length && tmp.children(".jstree-anchor")[0] !== document.activeElement) tmp.children(".jstree-anchor").trigger("focus");
                else this._data.core.focused = null;
            }
            this._model.force_full_redraw = false;
            this._model.changed = [];
            /**
			 * triggered after nodes are redrawn
			 * @event
			 * @name redraw.jstree
			 * @param {array} nodes the redrawn nodes
			 */ this.trigger("redraw", {
                "nodes": nodes
            });
        },
        /**
		 * redraws all nodes that need to be redrawn or optionally - the whole tree
		 * @name redraw([full])
		 * @param {Boolean} full if set to `true` all nodes are redrawn.
		 */ redraw: function(full) {
            if (full) this._model.force_full_redraw = true;
            //if(this._model.redraw_timeout) {
            //	clearTimeout(this._model.redraw_timeout);
            //}
            //this._model.redraw_timeout = setTimeout($.proxy(this._redraw, this),0);
            this._redraw();
        },
        /**
		 * redraws a single node's children. Used internally.
		 * @private
		 * @name draw_children(node)
		 * @param {mixed} node the node whose children will be redrawn
		 */ draw_children: function(node) {
            var obj = this.get_node(node), i = false, j = false, k = false, d = document;
            if (!obj) return false;
            if (obj.id === $.jstree.root) return this.redraw(true);
            node = this.get_node(node, true);
            if (!node || !node.length) return false;
             // TODO: quick toggle
            node.children(".jstree-children").remove();
            node = node[0];
            if (obj.children.length && obj.state.loaded) {
                k = d.createElement("UL");
                k.setAttribute("role", "group");
                k.className = "jstree-children";
                for(i = 0, j = obj.children.length; i < j; i++)k.appendChild(this.redraw_node(obj.children[i], true, true));
                node.appendChild(k);
            }
        },
        /**
		 * redraws a single node. Used internally.
		 * @private
		 * @name redraw_node(node, deep, is_callback, force_render)
		 * @param {mixed} node the node to redraw
		 * @param {Boolean} deep should child nodes be redrawn too
		 * @param {Boolean} is_callback is this a recursion call
		 * @param {Boolean} force_render should children of closed parents be drawn anyway
		 */ redraw_node: function(node, deep, is_callback, force_render) {
            var obj = this.get_node(node), par = false, ind = false, old = false, i = false, j = false, k = false, c = "", d = document, m = this._model.data, f = false, s = false, tmp = null, t = 0, l = 0, has_children = false, last_sibling = false;
            if (!obj) return false;
            if (obj.id === $.jstree.root) return this.redraw(true);
            deep = deep || obj.children.length === 0;
            node = !document.querySelector ? document.getElementById(obj.id) : this.element[0].querySelector("#" + ("0123456789".indexOf(obj.id[0]) !== -1 ? "\\3" + obj.id[0] + " " + obj.id.substr(1).replace($.jstree.idregex, "\\$&") : obj.id.replace($.jstree.idregex, "\\$&"))); //, this.element);
            if (!node) {
                deep = true;
                //node = d.createElement('LI');
                if (!is_callback) {
                    par = obj.parent !== $.jstree.root ? $("#" + obj.parent.replace($.jstree.idregex, "\\$&"), this.element)[0] : null;
                    if (par !== null && (!par || !m[obj.parent].state.opened)) return false;
                    ind = $.inArray(obj.id, par === null ? m[$.jstree.root].children : m[obj.parent].children);
                }
            } else {
                node = $(node);
                if (!is_callback) {
                    par = node.parent().parent()[0];
                    if (par === this.element[0]) par = null;
                    ind = node.index();
                }
                // m[obj.id].data = node.data(); // use only node's data, no need to touch jquery storage
                if (!deep && obj.children.length && !node.children(".jstree-children").length) deep = true;
                if (!deep) old = node.children(".jstree-children")[0];
                f = node.children(".jstree-anchor")[0] === document.activeElement;
                node.remove();
            //node = d.createElement('LI');
            //node = node[0];
            }
            node = this._data.core.node.cloneNode(true);
            // node is DOM, deep is boolean
            c = "jstree-node ";
            for(i in obj.li_attr)if (obj.li_attr.hasOwnProperty(i)) {
                if (i === "id") continue;
                if (i !== "class") node.setAttribute(i, obj.li_attr[i]);
                else c += obj.li_attr[i];
            }
            if (!obj.a_attr.id) obj.a_attr.id = obj.id + "_anchor";
            node.childNodes[1].setAttribute("aria-selected", !!obj.state.selected);
            node.childNodes[1].setAttribute("aria-level", obj.parents.length);
            if (this.settings.core.compute_elements_positions) {
                node.childNodes[1].setAttribute("aria-setsize", m[obj.parent].children.length);
                node.childNodes[1].setAttribute("aria-posinset", m[obj.parent].children.indexOf(obj.id) + 1);
            }
            if (obj.state.disabled) node.childNodes[1].setAttribute("aria-disabled", true);
            for(i = 0, j = obj.children.length; i < j; i++)if (!m[obj.children[i]].state.hidden) {
                has_children = true;
                break;
            }
            if (obj.parent !== null && m[obj.parent] && !obj.state.hidden) {
                i = $.inArray(obj.id, m[obj.parent].children);
                last_sibling = obj.id;
                if (i !== -1) {
                    i++;
                    for(j = m[obj.parent].children.length; i < j; i++){
                        if (!m[m[obj.parent].children[i]].state.hidden) last_sibling = m[obj.parent].children[i];
                        if (last_sibling !== obj.id) break;
                    }
                }
            }
            if (obj.state.hidden) c += " jstree-hidden";
            if (obj.state.loading) c += " jstree-loading";
            if (obj.state.loaded && !has_children) c += " jstree-leaf";
            else {
                c += obj.state.opened && obj.state.loaded ? " jstree-open" : " jstree-closed";
                node.childNodes[1].setAttribute("aria-expanded", obj.state.opened && obj.state.loaded);
            }
            if (last_sibling === obj.id) c += " jstree-last";
            node.id = obj.id;
            node.className = c;
            c = (obj.state.selected ? " jstree-clicked" : "") + (obj.state.disabled ? " jstree-disabled" : "");
            for(j in obj.a_attr)if (obj.a_attr.hasOwnProperty(j)) {
                if (j === "href" && obj.a_attr[j] === "#") continue;
                if (j !== "class") node.childNodes[1].setAttribute(j, obj.a_attr[j]);
                else c += " " + obj.a_attr[j];
            }
            if (c.length) node.childNodes[1].className = "jstree-anchor " + c;
            if (obj.icon && obj.icon !== true || obj.icon === false) {
                if (obj.icon === false) node.childNodes[1].childNodes[0].className += " jstree-themeicon-hidden";
                else if (obj.icon.indexOf("/") === -1 && obj.icon.indexOf(".") === -1) node.childNodes[1].childNodes[0].className += " " + obj.icon + " jstree-themeicon-custom";
                else {
                    node.childNodes[1].childNodes[0].style.backgroundImage = 'url("' + obj.icon + '")';
                    node.childNodes[1].childNodes[0].style.backgroundPosition = "center center";
                    node.childNodes[1].childNodes[0].style.backgroundSize = "auto";
                    node.childNodes[1].childNodes[0].className += " jstree-themeicon-custom";
                }
            }
            if (this.settings.core.force_text) node.childNodes[1].appendChild(d.createTextNode(obj.text));
            else node.childNodes[1].innerHTML += obj.text;
            if (deep && obj.children.length && (obj.state.opened || force_render) && obj.state.loaded) {
                k = d.createElement("UL");
                k.setAttribute("role", "group");
                k.className = "jstree-children";
                for(i = 0, j = obj.children.length; i < j; i++)k.appendChild(this.redraw_node(obj.children[i], deep, true));
                node.appendChild(k);
            }
            if (old) node.appendChild(old);
            if (!is_callback) {
                // append back using par / ind
                if (!par) par = this.element[0];
                for(i = 0, j = par.childNodes.length; i < j; i++)if (par.childNodes[i] && par.childNodes[i].className && par.childNodes[i].className.indexOf("jstree-children") !== -1) {
                    tmp = par.childNodes[i];
                    break;
                }
                if (!tmp) {
                    tmp = d.createElement("UL");
                    tmp.setAttribute("role", "group");
                    tmp.className = "jstree-children";
                    par.appendChild(tmp);
                }
                par = tmp;
                if (ind < par.childNodes.length) par.insertBefore(node, par.childNodes[ind]);
                else par.appendChild(node);
                if (f) {
                    t = this.element[0].scrollTop;
                    l = this.element[0].scrollLeft;
                    node.childNodes[1].focus();
                    this.element[0].scrollTop = t;
                    this.element[0].scrollLeft = l;
                }
            }
            if (obj.state.opened && !obj.state.loaded) {
                obj.state.opened = false;
                setTimeout((function() {
                    this.open_node(obj.id, false, 0);
                }).bind(this), 0);
            }
            return node;
        },
        /**
		 * opens a node, revealing its children. If the node is not loaded it will be loaded and opened once ready.
		 * @name open_node(obj [, callback, animation])
		 * @param {mixed} obj the node to open
		 * @param {Function} callback a function to execute once the node is opened
		 * @param {Number} animation the animation duration in milliseconds when opening the node (overrides the `core.animation` setting). Use `false` for no animation.
		 * @trigger open_node.jstree, after_open.jstree, before_open.jstree
		 */ open_node: function(obj, callback, animation) {
            var t1, t2, d, t;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.open_node(obj[t1], callback, animation);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            animation = animation === undefined ? this.settings.core.animation : animation;
            if (!this.is_closed(obj)) {
                if (callback) callback.call(this, obj, false);
                return false;
            }
            if (!this.is_loaded(obj)) {
                if (this.is_loading(obj)) return setTimeout((function() {
                    this.open_node(obj, callback, animation);
                }).bind(this), 500);
                this.load_node(obj, function(o, ok) {
                    return ok ? this.open_node(o, callback, animation) : callback ? callback.call(this, o, false) : false;
                });
            } else {
                d = this.get_node(obj, true);
                t = this;
                if (d.length) {
                    if (animation && d.children(".jstree-children").length) d.children(".jstree-children").stop(true, true);
                    if (obj.children.length && !this._firstChild(d.children(".jstree-children")[0])) this.draw_children(obj);
                    if (!animation) {
                        this.trigger("before_open", {
                            "node": obj
                        });
                        d[0].className = d[0].className.replace("jstree-closed", "jstree-open");
                        d[0].childNodes[1].setAttribute("aria-expanded", true);
                    } else {
                        this.trigger("before_open", {
                            "node": obj
                        });
                        d.children(".jstree-children").css("display", "none").end().removeClass("jstree-closed").addClass("jstree-open").children(".jstree-anchor").attr("aria-expanded", true).end().children(".jstree-children").stop(true, true).slideDown(animation, function() {
                            this.style.display = "";
                            if (t.element) t.trigger("after_open", {
                                "node": obj
                            });
                        });
                    }
                }
                obj.state.opened = true;
                if (callback) callback.call(this, obj, true);
                if (!d.length) /**
					 * triggered when a node is about to be opened (if the node is supposed to be in the DOM, it will be, but it won't be visible yet)
					 * @event
					 * @name before_open.jstree
					 * @param {Object} node the opened node
					 */ this.trigger("before_open", {
                    "node": obj
                });
                /**
				 * triggered when a node is opened (if there is an animation it will not be completed yet)
				 * @event
				 * @name open_node.jstree
				 * @param {Object} node the opened node
				 */ this.trigger("open_node", {
                    "node": obj
                });
                if (!animation || !d.length) /**
					 * triggered when a node is opened and the animation is complete
					 * @event
					 * @name after_open.jstree
					 * @param {Object} node the opened node
					 */ this.trigger("after_open", {
                    "node": obj
                });
                return true;
            }
        },
        /**
		 * opens every parent of a node (node should be loaded)
		 * @name _open_to(obj)
		 * @param {mixed} obj the node to reveal
		 * @private
		 */ _open_to: function(obj) {
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            var i, j, p = obj.parents;
            for(i = 0, j = p.length; i < j; i += 1)if (i !== $.jstree.root) this.open_node(p[i], false, 0);
            return $("#" + obj.id.replace($.jstree.idregex, "\\$&"), this.element);
        },
        /**
		 * closes a node, hiding its children
		 * @name close_node(obj [, animation])
		 * @param {mixed} obj the node to close
		 * @param {Number} animation the animation duration in milliseconds when closing the node (overrides the `core.animation` setting). Use `false` for no animation.
		 * @trigger close_node.jstree, after_close.jstree
		 */ close_node: function(obj, animation) {
            var t1, t2, t, d;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.close_node(obj[t1], animation);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            if (this.is_closed(obj)) return false;
            animation = animation === undefined ? this.settings.core.animation : animation;
            t = this;
            d = this.get_node(obj, true);
            obj.state.opened = false;
            /**
			 * triggered when a node is closed (if there is an animation it will not be complete yet)
			 * @event
			 * @name close_node.jstree
			 * @param {Object} node the closed node
			 */ this.trigger("close_node", {
                "node": obj
            });
            if (!d.length) /**
				 * triggered when a node is closed and the animation is complete
				 * @event
				 * @name after_close.jstree
				 * @param {Object} node the closed node
				 */ this.trigger("after_close", {
                "node": obj
            });
            else if (!animation) {
                d[0].className = d[0].className.replace("jstree-open", "jstree-closed");
                d.children(".jstree-anchor").attr("aria-expanded", false);
                d.children(".jstree-children").remove();
                this.trigger("after_close", {
                    "node": obj
                });
            } else d.children(".jstree-children").attr("style", "display:block !important").end().removeClass("jstree-open").addClass("jstree-closed").children(".jstree-anchor").attr("aria-expanded", false).end().children(".jstree-children").stop(true, true).slideUp(animation, function() {
                this.style.display = "";
                d.children(".jstree-children").remove();
                if (t.element) t.trigger("after_close", {
                    "node": obj
                });
            });
        },
        /**
		 * toggles a node - closing it if it is open, opening it if it is closed
		 * @name toggle_node(obj)
		 * @param {mixed} obj the node to toggle
		 */ toggle_node: function(obj) {
            var t1, t2;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.toggle_node(obj[t1]);
                return true;
            }
            if (this.is_closed(obj)) return this.open_node(obj);
            if (this.is_open(obj)) return this.close_node(obj);
        },
        /**
		 * opens all nodes within a node (or the tree), revealing their children. If the node is not loaded it will be loaded and opened once ready.
		 * @name open_all([obj, animation, original_obj])
		 * @param {mixed} obj the node to open recursively, omit to open all nodes in the tree
		 * @param {Number} animation the animation duration in milliseconds when opening the nodes, the default is no animation
		 * @param {jQuery} reference to the node that started the process (internal use)
		 * @trigger open_all.jstree
		 */ open_all: function(obj, animation, original_obj) {
            if (!obj) obj = $.jstree.root;
            obj = this.get_node(obj);
            if (!obj) return false;
            var dom = obj.id === $.jstree.root ? this.get_container_ul() : this.get_node(obj, true), i, j, _this;
            if (!dom.length) {
                for(i = 0, j = obj.children_d.length; i < j; i++)if (this.is_closed(this._model.data[obj.children_d[i]])) this._model.data[obj.children_d[i]].state.opened = true;
                return this.trigger("open_all", {
                    "node": obj
                });
            }
            original_obj = original_obj || dom;
            _this = this;
            dom = this.is_closed(obj) ? dom.find(".jstree-closed").addBack() : dom.find(".jstree-closed");
            dom.each(function() {
                _this.open_node(this, function(node, status) {
                    if (status && this.is_parent(node)) this.open_all(node, animation, original_obj);
                }, animation || 0);
            });
            if (original_obj.find(".jstree-closed").length === 0) /**
				 * triggered when an `open_all` call completes
				 * @event
				 * @name open_all.jstree
				 * @param {Object} node the opened node
				 */ this.trigger("open_all", {
                "node": this.get_node(original_obj)
            });
        },
        /**
		 * closes all nodes within a node (or the tree), revealing their children
		 * @name close_all([obj, animation])
		 * @param {mixed} obj the node to close recursively, omit to close all nodes in the tree
		 * @param {Number} animation the animation duration in milliseconds when closing the nodes, the default is no animation
		 * @trigger close_all.jstree
		 */ close_all: function(obj, animation) {
            if (!obj) obj = $.jstree.root;
            obj = this.get_node(obj);
            if (!obj) return false;
            var dom = obj.id === $.jstree.root ? this.get_container_ul() : this.get_node(obj, true), _this = this, i, j;
            if (dom.length) {
                dom = this.is_open(obj) ? dom.find(".jstree-open").addBack() : dom.find(".jstree-open");
                $(dom.get().reverse()).each(function() {
                    _this.close_node(this, animation || 0);
                });
            }
            for(i = 0, j = obj.children_d.length; i < j; i++)this._model.data[obj.children_d[i]].state.opened = false;
            /**
			 * triggered when an `close_all` call completes
			 * @event
			 * @name close_all.jstree
			 * @param {Object} node the closed node
			 */ this.trigger("close_all", {
                "node": obj
            });
        },
        /**
		 * checks if a node is disabled (not selectable)
		 * @name is_disabled(obj)
		 * @param  {mixed} obj
		 * @return {Boolean}
		 */ is_disabled: function(obj) {
            obj = this.get_node(obj);
            return obj && obj.state && obj.state.disabled;
        },
        /**
		 * enables a node - so that it can be selected
		 * @name enable_node(obj)
		 * @param {mixed} obj the node to enable
		 * @trigger enable_node.jstree
		 */ enable_node: function(obj) {
            var t1, t2;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.enable_node(obj[t1]);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            obj.state.disabled = false;
            this.get_node(obj, true).children(".jstree-anchor").removeClass("jstree-disabled").attr("aria-disabled", false);
            /**
			 * triggered when an node is enabled
			 * @event
			 * @name enable_node.jstree
			 * @param {Object} node the enabled node
			 */ this.trigger("enable_node", {
                "node": obj
            });
        },
        /**
		 * disables a node - so that it can not be selected
		 * @name disable_node(obj)
		 * @param {mixed} obj the node to disable
		 * @trigger disable_node.jstree
		 */ disable_node: function(obj) {
            var t1, t2;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.disable_node(obj[t1]);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            obj.state.disabled = true;
            this.get_node(obj, true).children(".jstree-anchor").addClass("jstree-disabled").attr("aria-disabled", true);
            /**
			 * triggered when an node is disabled
			 * @event
			 * @name disable_node.jstree
			 * @param {Object} node the disabled node
			 */ this.trigger("disable_node", {
                "node": obj
            });
        },
        /**
		 * determines if a node is hidden
		 * @name is_hidden(obj)
		 * @param {mixed} obj the node
		 */ is_hidden: function(obj) {
            obj = this.get_node(obj);
            return obj.state.hidden === true;
        },
        /**
		 * hides a node - it is still in the structure but will not be visible
		 * @name hide_node(obj)
		 * @param {mixed} obj the node to hide
		 * @param {Boolean} skip_redraw internal parameter controlling if redraw is called
		 * @trigger hide_node.jstree
		 */ hide_node: function(obj, skip_redraw) {
            var t1, t2;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.hide_node(obj[t1], true);
                if (!skip_redraw) this.redraw();
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            if (!obj.state.hidden) {
                obj.state.hidden = true;
                this._node_changed(obj.parent);
                if (!skip_redraw) this.redraw();
                /**
				 * triggered when an node is hidden
				 * @event
				 * @name hide_node.jstree
				 * @param {Object} node the hidden node
				 */ this.trigger("hide_node", {
                    "node": obj
                });
            }
        },
        /**
		 * shows a node
		 * @name show_node(obj)
		 * @param {mixed} obj the node to show
		 * @param {Boolean} skip_redraw internal parameter controlling if redraw is called
		 * @trigger show_node.jstree
		 */ show_node: function(obj, skip_redraw) {
            var t1, t2;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.show_node(obj[t1], true);
                if (!skip_redraw) this.redraw();
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            if (obj.state.hidden) {
                obj.state.hidden = false;
                this._node_changed(obj.parent);
                if (!skip_redraw) this.redraw();
                /**
				 * triggered when an node is shown
				 * @event
				 * @name show_node.jstree
				 * @param {Object} node the shown node
				 */ this.trigger("show_node", {
                    "node": obj
                });
            }
        },
        /**
		 * hides all nodes
		 * @name hide_all()
		 * @trigger hide_all.jstree
		 */ hide_all: function(skip_redraw) {
            var i, m = this._model.data, ids = [];
            for(i in m)if (m.hasOwnProperty(i) && i !== $.jstree.root && !m[i].state.hidden) {
                m[i].state.hidden = true;
                ids.push(i);
            }
            this._model.force_full_redraw = true;
            if (!skip_redraw) this.redraw();
            /**
			 * triggered when all nodes are hidden
			 * @event
			 * @name hide_all.jstree
			 * @param {Array} nodes the IDs of all hidden nodes
			 */ this.trigger("hide_all", {
                "nodes": ids
            });
            return ids;
        },
        /**
		 * shows all nodes
		 * @name show_all()
		 * @trigger show_all.jstree
		 */ show_all: function(skip_redraw) {
            var i, m = this._model.data, ids = [];
            for(i in m)if (m.hasOwnProperty(i) && i !== $.jstree.root && m[i].state.hidden) {
                m[i].state.hidden = false;
                ids.push(i);
            }
            this._model.force_full_redraw = true;
            if (!skip_redraw) this.redraw();
            /**
			 * triggered when all nodes are shown
			 * @event
			 * @name show_all.jstree
			 * @param {Array} nodes the IDs of all shown nodes
			 */ this.trigger("show_all", {
                "nodes": ids
            });
            return ids;
        },
        /**
		 * called when a node is selected by the user. Used internally.
		 * @private
		 * @name activate_node(obj, e)
		 * @param {mixed} obj the node
		 * @param {Object} e the related event
		 * @trigger activate_node.jstree, changed.jstree
		 */ activate_node: function(obj, e) {
            if (this.is_disabled(obj)) return false;
            if (!e || typeof e !== "object") e = {};
            // ensure last_clicked is still in the DOM, make it fresh (maybe it was moved?) and make sure it is still selected, if not - make last_clicked the last selected node
            this._data.core.last_clicked = this._data.core.last_clicked && this._data.core.last_clicked.id !== undefined ? this.get_node(this._data.core.last_clicked.id) : null;
            if (this._data.core.last_clicked && !this._data.core.last_clicked.state.selected) this._data.core.last_clicked = null;
            if (!this._data.core.last_clicked && this._data.core.selected.length) this._data.core.last_clicked = this.get_node(this._data.core.selected[this._data.core.selected.length - 1]);
            if (!this.settings.core.multiple || !e.metaKey && !e.ctrlKey && !e.shiftKey || e.shiftKey && (!this._data.core.last_clicked || !this.get_parent(obj) || this.get_parent(obj) !== this._data.core.last_clicked.parent)) {
                if (!this.settings.core.multiple && (e.metaKey || e.ctrlKey || e.shiftKey) && this.is_selected(obj)) this.deselect_node(obj, false, e);
                else {
                    if (this.settings.core.allow_reselect || !this.is_selected(obj) || this._data.core.selected.length !== 1) {
                        this.deselect_all(true);
                        this.select_node(obj, false, false, e);
                    }
                    this._data.core.last_clicked = this.get_node(obj);
                }
            } else {
                if (e.shiftKey) {
                    var o = this.get_node(obj).id, l = this._data.core.last_clicked.id, p = this.get_node(this._data.core.last_clicked.parent).children, c = false, i, j;
                    for(i = 0, j = p.length; i < j; i += 1){
                        // separate IFs work whem o and l are the same
                        if (p[i] === o) c = !c;
                        if (p[i] === l) c = !c;
                        if (!this.is_disabled(p[i]) && (c || p[i] === o || p[i] === l)) {
                            if (!this.is_hidden(p[i])) this.select_node(p[i], true, false, e);
                        } else if (!e.ctrlKey) this.deselect_node(p[i], true, e);
                    }
                    this.trigger("changed", {
                        "action": "select_node",
                        "node": this.get_node(obj),
                        "selected": this._data.core.selected,
                        "event": e
                    });
                } else if (!this.is_selected(obj)) {
                    if (e.ctrlKey) this._data.core.last_clicked = this.get_node(obj);
                    this.select_node(obj, false, false, e);
                } else this.deselect_node(obj, false, e);
            }
            /**
			 * triggered when an node is clicked or intercated with by the user
			 * @event
			 * @name activate_node.jstree
			 * @param {Object} node
			 * @param {Object} event the ooriginal event (if any) which triggered the call (may be an empty object)
			 */ this.trigger("activate_node", {
                "node": this.get_node(obj),
                "event": e
            });
        },
        /**
		 * applies the hover state on a node, called when a node is hovered by the user. Used internally.
		 * @private
		 * @name hover_node(obj)
		 * @param {mixed} obj
		 * @trigger hover_node.jstree
		 */ hover_node: function(obj) {
            obj = this.get_node(obj, true);
            if (!obj || !obj.length || obj.children(".jstree-hovered").length) return false;
            var o = this.element.find(".jstree-hovered"), t = this.element;
            if (o && o.length) this.dehover_node(o);
            obj.children(".jstree-anchor").addClass("jstree-hovered");
            /**
			 * triggered when an node is hovered
			 * @event
			 * @name hover_node.jstree
			 * @param {Object} node
			 */ this.trigger("hover_node", {
                "node": this.get_node(obj)
            });
            setTimeout(function() {
                t.attr("aria-activedescendant", obj[0].id);
            }, 0);
        },
        /**
		 * removes the hover state from a nodecalled when a node is no longer hovered by the user. Used internally.
		 * @private
		 * @name dehover_node(obj)
		 * @param {mixed} obj
		 * @trigger dehover_node.jstree
		 */ dehover_node: function(obj) {
            obj = this.get_node(obj, true);
            if (!obj || !obj.length || !obj.children(".jstree-hovered").length) return false;
            obj.children(".jstree-anchor").removeClass("jstree-hovered");
            /**
			 * triggered when an node is no longer hovered
			 * @event
			 * @name dehover_node.jstree
			 * @param {Object} node
			 */ this.trigger("dehover_node", {
                "node": this.get_node(obj)
            });
        },
        /**
		 * select a node
		 * @name select_node(obj [, supress_event, prevent_open])
		 * @param {mixed} obj an array can be used to select multiple nodes
		 * @param {Boolean} supress_event if set to `true` the `changed.jstree` event won't be triggered
		 * @param {Boolean} prevent_open if set to `true` parents of the selected node won't be opened
		 * @trigger select_node.jstree, changed.jstree
		 */ select_node: function(obj, supress_event, prevent_open, e) {
            var dom, t1, t2, th;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.select_node(obj[t1], supress_event, prevent_open, e);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            dom = this.get_node(obj, true);
            if (!obj.state.selected) {
                obj.state.selected = true;
                this._data.core.selected.push(obj.id);
                if (!prevent_open) dom = this._open_to(obj);
                if (dom && dom.length) dom.children(".jstree-anchor").addClass("jstree-clicked").attr("aria-selected", true);
                /**
				 * triggered when an node is selected
				 * @event
				 * @name select_node.jstree
				 * @param {Object} node
				 * @param {Array} selected the current selection
				 * @param {Object} event the event (if any) that triggered this select_node
				 */ this.trigger("select_node", {
                    "node": obj,
                    "selected": this._data.core.selected,
                    "event": e
                });
                if (!supress_event) /**
					 * triggered when selection changes
					 * @event
					 * @name changed.jstree
					 * @param {Object} node
					 * @param {Object} action the action that caused the selection to change
					 * @param {Array} selected the current selection
					 * @param {Object} event the event (if any) that triggered this changed event
					 */ this.trigger("changed", {
                    "action": "select_node",
                    "node": obj,
                    "selected": this._data.core.selected,
                    "event": e
                });
            }
        },
        /**
		 * deselect a node
		 * @name deselect_node(obj [, supress_event])
		 * @param {mixed} obj an array can be used to deselect multiple nodes
		 * @param {Boolean} supress_event if set to `true` the `changed.jstree` event won't be triggered
		 * @trigger deselect_node.jstree, changed.jstree
		 */ deselect_node: function(obj, supress_event, e) {
            var t1, t2, dom;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.deselect_node(obj[t1], supress_event, e);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            dom = this.get_node(obj, true);
            if (obj.state.selected) {
                obj.state.selected = false;
                this._data.core.selected = $.vakata.array_remove_item(this._data.core.selected, obj.id);
                if (dom.length) dom.children(".jstree-anchor").removeClass("jstree-clicked").attr("aria-selected", false);
                /**
				 * triggered when an node is deselected
				 * @event
				 * @name deselect_node.jstree
				 * @param {Object} node
				 * @param {Array} selected the current selection
				 * @param {Object} event the event (if any) that triggered this deselect_node
				 */ this.trigger("deselect_node", {
                    "node": obj,
                    "selected": this._data.core.selected,
                    "event": e
                });
                if (!supress_event) this.trigger("changed", {
                    "action": "deselect_node",
                    "node": obj,
                    "selected": this._data.core.selected,
                    "event": e
                });
            }
        },
        /**
		 * select all nodes in the tree
		 * @name select_all([supress_event])
		 * @param {Boolean} supress_event if set to `true` the `changed.jstree` event won't be triggered
		 * @trigger select_all.jstree, changed.jstree
		 */ select_all: function(supress_event) {
            var tmp = this._data.core.selected.concat([]), i, j;
            this._data.core.selected = this._model.data[$.jstree.root].children_d.concat();
            for(i = 0, j = this._data.core.selected.length; i < j; i++)if (this._model.data[this._data.core.selected[i]]) this._model.data[this._data.core.selected[i]].state.selected = true;
            this.redraw(true);
            /**
			 * triggered when all nodes are selected
			 * @event
			 * @name select_all.jstree
			 * @param {Array} selected the current selection
			 */ this.trigger("select_all", {
                "selected": this._data.core.selected
            });
            if (!supress_event) this.trigger("changed", {
                "action": "select_all",
                "selected": this._data.core.selected,
                "old_selection": tmp
            });
        },
        /**
		 * deselect all selected nodes
		 * @name deselect_all([supress_event])
		 * @param {Boolean} supress_event if set to `true` the `changed.jstree` event won't be triggered
		 * @trigger deselect_all.jstree, changed.jstree
		 */ deselect_all: function(supress_event) {
            var tmp = this._data.core.selected.concat([]), i, j;
            for(i = 0, j = this._data.core.selected.length; i < j; i++)if (this._model.data[this._data.core.selected[i]]) this._model.data[this._data.core.selected[i]].state.selected = false;
            this._data.core.selected = [];
            this.element.find(".jstree-clicked").removeClass("jstree-clicked").attr("aria-selected", false);
            /**
			 * triggered when all nodes are deselected
			 * @event
			 * @name deselect_all.jstree
			 * @param {Object} node the previous selection
			 * @param {Array} selected the current selection
			 */ this.trigger("deselect_all", {
                "selected": this._data.core.selected,
                "node": tmp
            });
            if (!supress_event) this.trigger("changed", {
                "action": "deselect_all",
                "selected": this._data.core.selected,
                "old_selection": tmp
            });
        },
        /**
		 * checks if a node is selected
		 * @name is_selected(obj)
		 * @param  {mixed}  obj
		 * @return {Boolean}
		 */ is_selected: function(obj) {
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            return obj.state.selected;
        },
        /**
		 * get an array of all selected nodes
		 * @name get_selected([full])
		 * @param  {mixed}  full if set to `true` the returned array will consist of the full node objects, otherwise - only IDs will be returned
		 * @return {Array}
		 */ get_selected: function(full) {
            return full ? $.map(this._data.core.selected, (function(i) {
                return this.get_node(i);
            }).bind(this)) : this._data.core.selected.slice();
        },
        /**
		 * get an array of all top level selected nodes (ignoring children of selected nodes)
		 * @name get_top_selected([full])
		 * @param  {mixed}  full if set to `true` the returned array will consist of the full node objects, otherwise - only IDs will be returned
		 * @return {Array}
		 */ get_top_selected: function(full) {
            var tmp = this.get_selected(true), obj = {}, i, j, k, l;
            for(i = 0, j = tmp.length; i < j; i++)obj[tmp[i].id] = tmp[i];
            for(i = 0, j = tmp.length; i < j; i++){
                for(k = 0, l = tmp[i].children_d.length; k < l; k++)if (obj[tmp[i].children_d[k]]) delete obj[tmp[i].children_d[k]];
            }
            tmp = [];
            for(i in obj)if (obj.hasOwnProperty(i)) tmp.push(i);
            return full ? $.map(tmp, (function(i) {
                return this.get_node(i);
            }).bind(this)) : tmp;
        },
        /**
		 * get an array of all bottom level selected nodes (ignoring selected parents)
		 * @name get_bottom_selected([full])
		 * @param  {mixed}  full if set to `true` the returned array will consist of the full node objects, otherwise - only IDs will be returned
		 * @return {Array}
		 */ get_bottom_selected: function(full) {
            var tmp = this.get_selected(true), obj = [], i, j;
            for(i = 0, j = tmp.length; i < j; i++)if (!tmp[i].children.length) obj.push(tmp[i].id);
            return full ? $.map(obj, (function(i) {
                return this.get_node(i);
            }).bind(this)) : obj;
        },
        /**
		 * gets the current state of the tree so that it can be restored later with `set_state(state)`. Used internally.
		 * @name get_state()
		 * @private
		 * @return {Object}
		 */ get_state: function() {
            var state = {
                "core": {
                    "open": [],
                    "loaded": [],
                    "scroll": {
                        "left": this.element.scrollLeft(),
                        "top": this.element.scrollTop()
                    },
                    /*!
					'themes' : {
						'name' : this.get_theme(),
						'icons' : this._data.core.themes.icons,
						'dots' : this._data.core.themes.dots
					},
					*/ "selected": []
                }
            }, i;
            for(i in this._model.data){
                if (this._model.data.hasOwnProperty(i)) {
                    if (i !== $.jstree.root) {
                        if (this._model.data[i].state.loaded && this.settings.core.loaded_state) state.core.loaded.push(i);
                        if (this._model.data[i].state.opened) state.core.open.push(i);
                        if (this._model.data[i].state.selected) state.core.selected.push(i);
                    }
                }
            }
            return state;
        },
        /**
		 * sets the state of the tree. Used internally.
		 * @name set_state(state [, callback])
		 * @private
		 * @param {Object} state the state to restore. Keep in mind this object is passed by reference and jstree will modify it.
		 * @param {Function} callback an optional function to execute once the state is restored.
		 * @trigger set_state.jstree
		 */ set_state: function(state, callback) {
            if (state) {
                if (state.core && state.core.selected && state.core.initial_selection === undefined) state.core.initial_selection = this._data.core.selected.concat([]).sort().join(",");
                if (state.core) {
                    var res, n, t, _this, i;
                    if (state.core.loaded) {
                        if (!this.settings.core.loaded_state || !$.vakata.is_array(state.core.loaded) || !state.core.loaded.length) {
                            delete state.core.loaded;
                            this.set_state(state, callback);
                        } else this._load_nodes(state.core.loaded, function(nodes) {
                            delete state.core.loaded;
                            this.set_state(state, callback);
                        });
                        return false;
                    }
                    if (state.core.open) {
                        if (!$.vakata.is_array(state.core.open) || !state.core.open.length) {
                            delete state.core.open;
                            this.set_state(state, callback);
                        } else this._load_nodes(state.core.open, function(nodes) {
                            this.open_node(nodes, false, 0);
                            delete state.core.open;
                            this.set_state(state, callback);
                        });
                        return false;
                    }
                    if (state.core.scroll) {
                        if (state.core.scroll && state.core.scroll.left !== undefined) this.element.scrollLeft(state.core.scroll.left);
                        if (state.core.scroll && state.core.scroll.top !== undefined) this.element.scrollTop(state.core.scroll.top);
                        delete state.core.scroll;
                        this.set_state(state, callback);
                        return false;
                    }
                    if (state.core.selected) {
                        _this = this;
                        if (state.core.initial_selection === undefined || state.core.initial_selection === this._data.core.selected.concat([]).sort().join(",")) {
                            this.deselect_all();
                            $.each(state.core.selected, function(i, v) {
                                _this.select_node(v, false, true);
                            });
                        }
                        delete state.core.initial_selection;
                        delete state.core.selected;
                        this.set_state(state, callback);
                        return false;
                    }
                    for(i in state)if (state.hasOwnProperty(i) && i !== "core" && $.inArray(i, this.settings.plugins) === -1) delete state[i];
                    if ($.isEmptyObject(state.core)) {
                        delete state.core;
                        this.set_state(state, callback);
                        return false;
                    }
                }
                if ($.isEmptyObject(state)) {
                    state = null;
                    if (callback) callback.call(this);
                    /**
					 * triggered when a `set_state` call completes
					 * @event
					 * @name set_state.jstree
					 */ this.trigger("set_state");
                    return false;
                }
                return true;
            }
            return false;
        },
        /**
		 * refreshes the tree - all nodes are reloaded with calls to `load_node`.
		 * @name refresh()
		 * @param {Boolean} skip_loading an option to skip showing the loading indicator
		 * @param {Mixed} forget_state if set to `true` state will not be reapplied, if set to a function (receiving the current state as argument) the result of that function will be used as state
		 * @trigger refresh.jstree
		 */ refresh: function(skip_loading, forget_state) {
            this._data.core.state = forget_state === true ? {} : this.get_state();
            if (forget_state && $.vakata.is_function(forget_state)) this._data.core.state = forget_state.call(this, this._data.core.state);
            this._cnt = 0;
            this._model.data = {};
            this._model.data[$.jstree.root] = {
                id: $.jstree.root,
                parent: null,
                parents: [],
                children: [],
                children_d: [],
                state: {
                    loaded: false
                }
            };
            this._data.core.selected = [];
            this._data.core.last_clicked = null;
            this._data.core.focused = null;
            var c = this.get_container_ul()[0].className;
            if (!skip_loading) {
                this.element.html("<ul class='" + c + "' role='group'><" + "li class='jstree-initial-node jstree-loading jstree-leaf jstree-last' role='none' id='j" + this._id + "_loading'><i class='jstree-icon jstree-ocl'></i><" + "a class='jstree-anchor' role='treeitem' href='#'><i class='jstree-icon jstree-themeicon-hidden'></i>" + this.get_string("Loading ...") + "</a></li></ul>");
                this.element.attr("aria-activedescendant", "j" + this._id + "_loading");
            }
            this.load_node($.jstree.root, function(o, s) {
                if (s) {
                    this.get_container_ul()[0].className = c;
                    if (this._firstChild(this.get_container_ul()[0])) this.element.attr("aria-activedescendant", this._firstChild(this.get_container_ul()[0]).id);
                    this.set_state($.extend(true, {}, this._data.core.state), function() {
                        /**
						 * triggered when a `refresh` call completes
						 * @event
						 * @name refresh.jstree
						 */ this.trigger("refresh");
                    });
                }
                this._data.core.state = null;
            });
        },
        /**
		 * refreshes a node in the tree (reload its children) all opened nodes inside that node are reloaded with calls to `load_node`.
		 * @name refresh_node(obj)
		 * @param  {mixed} obj the node
		 * @trigger refresh_node.jstree
		 */ refresh_node: function(obj) {
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            var opened = [], to_load = [], s = this._data.core.selected.concat([]);
            to_load.push(obj.id);
            if (obj.state.opened === true) opened.push(obj.id);
            this.get_node(obj, true).find(".jstree-open").each(function() {
                to_load.push(this.id);
                opened.push(this.id);
            });
            this._load_nodes(to_load, (function(nodes) {
                this.open_node(opened, false, 0);
                this.select_node(s);
                /**
				 * triggered when a node is refreshed
				 * @event
				 * @name refresh_node.jstree
				 * @param {Object} node - the refreshed node
				 * @param {Array} nodes - an array of the IDs of the nodes that were reloaded
				 */ this.trigger("refresh_node", {
                    "node": obj,
                    "nodes": nodes
                });
            }).bind(this), false, true);
        },
        /**
		 * set (change) the ID of a node
		 * @name set_id(obj, id)
		 * @param  {mixed} obj the node
		 * @param  {String} id the new ID
		 * @return {Boolean}
		 * @trigger set_id.jstree
		 */ set_id: function(obj, id) {
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            var i, j, m = this._model.data, old = obj.id;
            id = id.toString();
            // update parents (replace current ID with new one in children and children_d)
            m[obj.parent].children[$.inArray(obj.id, m[obj.parent].children)] = id;
            for(i = 0, j = obj.parents.length; i < j; i++)m[obj.parents[i]].children_d[$.inArray(obj.id, m[obj.parents[i]].children_d)] = id;
            // update children (replace current ID with new one in parent and parents)
            for(i = 0, j = obj.children.length; i < j; i++)m[obj.children[i]].parent = id;
            for(i = 0, j = obj.children_d.length; i < j; i++)m[obj.children_d[i]].parents[$.inArray(obj.id, m[obj.children_d[i]].parents)] = id;
            i = $.inArray(obj.id, this._data.core.selected);
            if (i !== -1) this._data.core.selected[i] = id;
            // update model and obj itself (obj.id, this._model.data[KEY])
            i = this.get_node(obj.id, true);
            if (i) {
                i.attr("id", id); //.children('.jstree-anchor').attr('id', id + '_anchor').end().attr('aria-labelledby', id + '_anchor');
                if (this.element.attr("aria-activedescendant") === obj.id) this.element.attr("aria-activedescendant", id);
            }
            delete m[obj.id];
            obj.id = id;
            obj.li_attr.id = id;
            m[id] = obj;
            /**
			 * triggered when a node id value is changed
			 * @event
			 * @name set_id.jstree
			 * @param {Object} node
			 * @param {String} old the old id
			 */ this.trigger("set_id", {
                "node": obj,
                "new": obj.id,
                "old": old
            });
            return true;
        },
        /**
		 * get the text value of a node
		 * @name get_text(obj)
		 * @param  {mixed} obj the node
		 * @return {String}
		 */ get_text: function(obj) {
            obj = this.get_node(obj);
            return !obj || obj.id === $.jstree.root ? false : obj.text;
        },
        /**
		 * set the text value of a node. Used internally, please use `rename_node(obj, val)`.
		 * @private
		 * @name set_text(obj, val)
		 * @param  {mixed} obj the node, you can pass an array to set the text on multiple nodes
		 * @param  {String} val the new text value
		 * @return {Boolean}
		 * @trigger set_text.jstree
		 */ set_text: function(obj, val) {
            var t1, t2;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.set_text(obj[t1], val);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            obj.text = val;
            if (this.get_node(obj, true).length) this.redraw_node(obj.id);
            /**
			 * triggered when a node text value is changed
			 * @event
			 * @name set_text.jstree
			 * @param {Object} obj
			 * @param {String} text the new value
			 */ this.trigger("set_text", {
                "obj": obj,
                "text": val
            });
            return true;
        },
        /**
		 * gets a JSON representation of a node (or the whole tree)
		 * @name get_json([obj, options])
		 * @param  {mixed} obj
		 * @param  {Object} options
		 * @param  {Boolean} options.no_state do not return state information
		 * @param  {Boolean} options.no_id do not return ID
		 * @param  {Boolean} options.no_children do not include children
		 * @param  {Boolean} options.no_data do not include node data
		 * @param  {Boolean} options.no_li_attr do not include LI attributes
		 * @param  {Boolean} options.no_a_attr do not include A attributes
		 * @param  {Boolean} options.flat return flat JSON instead of nested
		 * @return {Object}
		 */ get_json: function(obj, options, flat) {
            obj = this.get_node(obj || $.jstree.root);
            if (!obj) return false;
            if (options && options.flat && !flat) flat = [];
            var tmp = {
                "id": obj.id,
                "text": obj.text,
                "icon": this.get_icon(obj),
                "li_attr": $.extend(true, {}, obj.li_attr),
                "a_attr": $.extend(true, {}, obj.a_attr),
                "state": {},
                "data": options && options.no_data ? false : $.extend(true, $.vakata.is_array(obj.data) ? [] : {}, obj.data)
            }, i, j;
            if (options && options.flat) tmp.parent = obj.parent;
            else tmp.children = [];
            if (!options || !options.no_state) {
                for(i in obj.state)if (obj.state.hasOwnProperty(i)) tmp.state[i] = obj.state[i];
            } else delete tmp.state;
            if (options && options.no_li_attr) delete tmp.li_attr;
            if (options && options.no_a_attr) delete tmp.a_attr;
            if (options && options.no_id) {
                delete tmp.id;
                if (tmp.li_attr && tmp.li_attr.id) delete tmp.li_attr.id;
                if (tmp.a_attr && tmp.a_attr.id) delete tmp.a_attr.id;
            }
            if (options && options.flat && obj.id !== $.jstree.root) flat.push(tmp);
            if (!options || !options.no_children) {
                for(i = 0, j = obj.children.length; i < j; i++)if (options && options.flat) this.get_json(obj.children[i], options, flat);
                else tmp.children.push(this.get_json(obj.children[i], options));
            }
            return options && options.flat ? flat : obj.id === $.jstree.root ? tmp.children : tmp;
        },
        /**
		 * create a new node (do not confuse with load_node)
		 * @name create_node([par, node, pos, callback, is_loaded])
		 * @param  {mixed}   par       the parent node (to create a root node use either "#" (string) or `null`)
		 * @param  {mixed}   node      the data for the new node (a valid JSON object, or a simple string with the name)
		 * @param  {mixed}   pos       the index at which to insert the node, "first" and "last" are also supported, default is "last"
		 * @param  {Function} callback a function to be called once the node is created
		 * @param  {Boolean} is_loaded internal argument indicating if the parent node was succesfully loaded
		 * @return {String}            the ID of the newly create node
		 * @trigger model.jstree, create_node.jstree
		 */ create_node: function(par, node, pos, callback, is_loaded) {
            if (par === null) par = $.jstree.root;
            par = this.get_node(par);
            if (!par) return false;
            pos = pos === undefined ? "last" : pos;
            if (!pos.toString().match(/^(before|after)$/) && !is_loaded && !this.is_loaded(par)) return this.load_node(par, function() {
                this.create_node(par, node, pos, callback, true);
            });
            if (!node) node = {
                "text": this.get_string("New node")
            };
            if (typeof node === "string") node = {
                "text": node
            };
            else node = $.extend(true, {}, node);
            if (node.text === undefined) node.text = this.get_string("New node");
            var tmp, dpc, i, j;
            if (par.id === $.jstree.root) {
                if (pos === "before") pos = "first";
                if (pos === "after") pos = "last";
            }
            switch(pos){
                case "before":
                    tmp = this.get_node(par.parent);
                    pos = $.inArray(par.id, tmp.children);
                    par = tmp;
                    break;
                case "after":
                    tmp = this.get_node(par.parent);
                    pos = $.inArray(par.id, tmp.children) + 1;
                    par = tmp;
                    break;
                case "inside":
                case "first":
                    pos = 0;
                    break;
                case "last":
                    pos = par.children.length;
                    break;
                default:
                    if (!pos) pos = 0;
                    break;
            }
            if (pos > par.children.length) pos = par.children.length;
            if (node.id === undefined) node.id = true;
            if (!this.check("create_node", node, par, pos)) {
                this.settings.core.error.call(this, this._data.core.last_error);
                return false;
            }
            if (node.id === true) delete node.id;
            node = this._parse_model_from_json(node, par.id, par.parents.concat());
            if (!node) return false;
            tmp = this.get_node(node);
            dpc = [];
            dpc.push(node);
            dpc = dpc.concat(tmp.children_d);
            this.trigger("model", {
                "nodes": dpc,
                "parent": par.id
            });
            par.children_d = par.children_d.concat(dpc);
            for(i = 0, j = par.parents.length; i < j; i++)this._model.data[par.parents[i]].children_d = this._model.data[par.parents[i]].children_d.concat(dpc);
            node = tmp;
            tmp = [];
            for(i = 0, j = par.children.length; i < j; i++)tmp[i >= pos ? i + 1 : i] = par.children[i];
            tmp[pos] = node.id;
            par.children = tmp;
            this.redraw_node(par, true);
            /**
			 * triggered when a node is created
			 * @event
			 * @name create_node.jstree
			 * @param {Object} node
			 * @param {String} parent the parent's ID
			 * @param {Number} position the position of the new node among the parent's children
			 */ this.trigger("create_node", {
                "node": this.get_node(node),
                "parent": par.id,
                "position": pos
            });
            if (callback) callback.call(this, this.get_node(node));
            return node.id;
        },
        /**
		 * set the text value of a node
		 * @name rename_node(obj, val)
		 * @param  {mixed} obj the node, you can pass an array to rename multiple nodes to the same name
		 * @param  {String} val the new text value
		 * @return {Boolean}
		 * @trigger rename_node.jstree
		 */ rename_node: function(obj, val) {
            var t1, t2, old;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.rename_node(obj[t1], val);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            old = obj.text;
            if (!this.check("rename_node", obj, this.get_parent(obj), val)) {
                this.settings.core.error.call(this, this._data.core.last_error);
                return false;
            }
            this.set_text(obj, val); // .apply(this, Array.prototype.slice.call(arguments))
            /**
			 * triggered when a node is renamed
			 * @event
			 * @name rename_node.jstree
			 * @param {Object} node
			 * @param {String} text the new value
			 * @param {String} old the old value
			 */ this.trigger("rename_node", {
                "node": obj,
                "text": val,
                "old": old
            });
            return true;
        },
        /**
		 * remove a node
		 * @name delete_node(obj)
		 * @param  {mixed} obj the node, you can pass an array to delete multiple nodes
		 * @return {Boolean}
		 * @trigger delete_node.jstree, changed.jstree
		 */ delete_node: function(obj) {
            var t1, t2, par, pos, tmp, i, j, k, l, c, top, lft;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.delete_node(obj[t1]);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            par = this.get_node(obj.parent);
            pos = $.inArray(obj.id, par.children);
            c = false;
            if (!this.check("delete_node", obj, par, pos)) {
                this.settings.core.error.call(this, this._data.core.last_error);
                return false;
            }
            if (pos !== -1) par.children = $.vakata.array_remove(par.children, pos);
            tmp = obj.children_d.concat([]);
            tmp.push(obj.id);
            for(i = 0, j = obj.parents.length; i < j; i++)this._model.data[obj.parents[i]].children_d = $.vakata.array_filter(this._model.data[obj.parents[i]].children_d, function(v) {
                return $.inArray(v, tmp) === -1;
            });
            for(k = 0, l = tmp.length; k < l; k++)if (this._model.data[tmp[k]].state.selected) {
                c = true;
                break;
            }
            if (c) this._data.core.selected = $.vakata.array_filter(this._data.core.selected, function(v) {
                return $.inArray(v, tmp) === -1;
            });
            /**
			 * triggered when a node is deleted
			 * @event
			 * @name delete_node.jstree
			 * @param {Object} node
			 * @param {String} parent the parent's ID
			 */ this.trigger("delete_node", {
                "node": obj,
                "parent": par.id
            });
            if (c) this.trigger("changed", {
                "action": "delete_node",
                "node": obj,
                "selected": this._data.core.selected,
                "parent": par.id
            });
            for(k = 0, l = tmp.length; k < l; k++)delete this._model.data[tmp[k]];
            if ($.inArray(this._data.core.focused, tmp) !== -1) {
                this._data.core.focused = null;
                top = this.element[0].scrollTop;
                lft = this.element[0].scrollLeft;
                if (par.id === $.jstree.root) {
                    if (this._model.data[$.jstree.root].children[0]) this.get_node(this._model.data[$.jstree.root].children[0], true).children(".jstree-anchor").trigger("focus");
                } else this.get_node(par, true).children(".jstree-anchor").trigger("focus");
                this.element[0].scrollTop = top;
                this.element[0].scrollLeft = lft;
            }
            this.redraw_node(par, true);
            return true;
        },
        /**
		 * check if an operation is premitted on the tree. Used internally.
		 * @private
		 * @name check(chk, obj, par, pos)
		 * @param  {String} chk the operation to check, can be "create_node", "rename_node", "delete_node", "copy_node" or "move_node"
		 * @param  {mixed} obj the node
		 * @param  {mixed} par the parent
		 * @param  {mixed} pos the position to insert at, or if "rename_node" - the new name
		 * @param  {mixed} more some various additional information, for example if a "move_node" operations is triggered by DND this will be the hovered node
		 * @return {Boolean}
		 */ check: function(chk, obj, par, pos, more) {
            obj = obj && obj.id ? obj : this.get_node(obj);
            par = par && par.id ? par : this.get_node(par);
            var tmp = chk.match(/^(move_node|copy_node|create_node)$/i) ? par : obj, chc = this.settings.core.check_callback;
            if (chk === "move_node" || chk === "copy_node") {
                if ((!more || !more.is_multi) && chk === "move_node" && $.inArray(obj.id, par.children) === pos) {
                    this._data.core.last_error = {
                        "error": "check",
                        "plugin": "core",
                        "id": "core_08",
                        "reason": "Moving node to its current position",
                        "data": JSON.stringify({
                            "chk": chk,
                            "pos": pos,
                            "obj": obj && obj.id ? obj.id : false,
                            "par": par && par.id ? par.id : false
                        })
                    };
                    return false;
                }
                if ((!more || !more.is_multi) && (obj.id === par.id || chk === "move_node" && $.inArray(obj.id, par.children) === pos || $.inArray(par.id, obj.children_d) !== -1)) {
                    this._data.core.last_error = {
                        "error": "check",
                        "plugin": "core",
                        "id": "core_01",
                        "reason": "Moving parent inside child",
                        "data": JSON.stringify({
                            "chk": chk,
                            "pos": pos,
                            "obj": obj && obj.id ? obj.id : false,
                            "par": par && par.id ? par.id : false
                        })
                    };
                    return false;
                }
            }
            if (tmp && tmp.data) tmp = tmp.data;
            if (tmp && tmp.functions && (tmp.functions[chk] === false || tmp.functions[chk] === true)) {
                if (tmp.functions[chk] === false) this._data.core.last_error = {
                    "error": "check",
                    "plugin": "core",
                    "id": "core_02",
                    "reason": "Node data prevents function: " + chk,
                    "data": JSON.stringify({
                        "chk": chk,
                        "pos": pos,
                        "obj": obj && obj.id ? obj.id : false,
                        "par": par && par.id ? par.id : false
                    })
                };
                return tmp.functions[chk];
            }
            if (chc === false || $.vakata.is_function(chc) && chc.call(this, chk, obj, par, pos, more) === false || chc && chc[chk] === false) {
                this._data.core.last_error = {
                    "error": "check",
                    "plugin": "core",
                    "id": "core_03",
                    "reason": "User config for core.check_callback prevents function: " + chk,
                    "data": JSON.stringify({
                        "chk": chk,
                        "pos": pos,
                        "obj": obj && obj.id ? obj.id : false,
                        "par": par && par.id ? par.id : false
                    })
                };
                return false;
            }
            return true;
        },
        /**
		 * get the last error
		 * @name last_error()
		 * @return {Object}
		 */ last_error: function() {
            return this._data.core.last_error;
        },
        /**
		 * move a node to a new parent
		 * @name move_node(obj, par [, pos, callback, is_loaded])
		 * @param  {mixed} obj the node to move, pass an array to move multiple nodes
		 * @param  {mixed} par the new parent
		 * @param  {mixed} pos the position to insert at (besides integer values, "first" and "last" are supported, as well as "before" and "after"), defaults to integer `0`
		 * @param  {function} callback a function to call once the move is completed, receives 3 arguments - the node, the new parent and the position
		 * @param  {Boolean} is_loaded internal parameter indicating if the parent node has been loaded
		 * @param  {Boolean} skip_redraw internal parameter indicating if the tree should be redrawn
		 * @param  {Boolean} instance internal parameter indicating if the node comes from another instance
		 * @trigger move_node.jstree
		 */ move_node: function(obj, par, pos, callback, is_loaded, skip_redraw, origin) {
            var t1, t2, old_par, old_pos, new_par, old_ins, is_multi, dpc, tmp, i, j, k, l, p;
            par = this.get_node(par);
            pos = pos === undefined ? 0 : pos;
            if (!par) return false;
            if (!pos.toString().match(/^(before|after)$/) && !is_loaded && !this.is_loaded(par)) return this.load_node(par, function() {
                this.move_node(obj, par, pos, callback, true, false, origin);
            });
            if ($.vakata.is_array(obj)) {
                if (obj.length === 1) obj = obj[0];
                else {
                    //obj = obj.slice();
                    for(t1 = 0, t2 = obj.length; t1 < t2; t1++)if (tmp = this.move_node(obj[t1], par, pos, callback, is_loaded, false, origin)) {
                        par = tmp;
                        pos = "after";
                    }
                    this.redraw();
                    return true;
                }
            }
            obj = obj && obj.id !== undefined ? obj : this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            old_par = (obj.parent || $.jstree.root).toString();
            new_par = !pos.toString().match(/^(before|after)$/) || par.id === $.jstree.root ? par : this.get_node(par.parent);
            old_ins = origin ? origin : this._model.data[obj.id] ? this : $.jstree.reference(obj.id);
            is_multi = !old_ins || !old_ins._id || this._id !== old_ins._id;
            old_pos = old_ins && old_ins._id && old_par && old_ins._model.data[old_par] && old_ins._model.data[old_par].children ? $.inArray(obj.id, old_ins._model.data[old_par].children) : -1;
            if (old_ins && old_ins._id) obj = old_ins._model.data[obj.id];
            if (is_multi) {
                if (tmp = this.copy_node(obj, par, pos, callback, is_loaded, false, origin)) {
                    if (old_ins) old_ins.delete_node(obj);
                    return tmp;
                }
                return false;
            }
            //var m = this._model.data;
            if (par.id === $.jstree.root) {
                if (pos === "before") pos = "first";
                if (pos === "after") pos = "last";
            }
            switch(pos){
                case "before":
                    pos = $.inArray(par.id, new_par.children);
                    break;
                case "after":
                    pos = $.inArray(par.id, new_par.children) + 1;
                    break;
                case "inside":
                case "first":
                    pos = 0;
                    break;
                case "last":
                    pos = new_par.children.length;
                    break;
                default:
                    if (!pos) pos = 0;
                    break;
            }
            if (pos > new_par.children.length) pos = new_par.children.length;
            if (!this.check("move_node", obj, new_par, pos, {
                "core": true,
                "origin": origin,
                "is_multi": old_ins && old_ins._id && old_ins._id !== this._id,
                "is_foreign": !old_ins || !old_ins._id
            })) {
                this.settings.core.error.call(this, this._data.core.last_error);
                return false;
            }
            if (obj.parent === new_par.id) {
                dpc = new_par.children.concat();
                tmp = $.inArray(obj.id, dpc);
                if (tmp !== -1) {
                    dpc = $.vakata.array_remove(dpc, tmp);
                    if (pos > tmp) pos--;
                }
                tmp = [];
                for(i = 0, j = dpc.length; i < j; i++)tmp[i >= pos ? i + 1 : i] = dpc[i];
                tmp[pos] = obj.id;
                new_par.children = tmp;
                this._node_changed(new_par.id);
                this.redraw(new_par.id === $.jstree.root);
            } else {
                // clean old parent and up
                tmp = obj.children_d.concat();
                tmp.push(obj.id);
                for(i = 0, j = obj.parents.length; i < j; i++){
                    dpc = [];
                    p = old_ins._model.data[obj.parents[i]].children_d;
                    for(k = 0, l = p.length; k < l; k++)if ($.inArray(p[k], tmp) === -1) dpc.push(p[k]);
                    old_ins._model.data[obj.parents[i]].children_d = dpc;
                }
                old_ins._model.data[old_par].children = $.vakata.array_remove_item(old_ins._model.data[old_par].children, obj.id);
                // insert into new parent and up
                for(i = 0, j = new_par.parents.length; i < j; i++)this._model.data[new_par.parents[i]].children_d = this._model.data[new_par.parents[i]].children_d.concat(tmp);
                dpc = [];
                for(i = 0, j = new_par.children.length; i < j; i++)dpc[i >= pos ? i + 1 : i] = new_par.children[i];
                dpc[pos] = obj.id;
                new_par.children = dpc;
                new_par.children_d.push(obj.id);
                new_par.children_d = new_par.children_d.concat(obj.children_d);
                // update object
                obj.parent = new_par.id;
                tmp = new_par.parents.concat();
                tmp.unshift(new_par.id);
                p = obj.parents.length;
                obj.parents = tmp;
                // update object children
                tmp = tmp.concat();
                for(i = 0, j = obj.children_d.length; i < j; i++){
                    this._model.data[obj.children_d[i]].parents = this._model.data[obj.children_d[i]].parents.slice(0, p * -1);
                    Array.prototype.push.apply(this._model.data[obj.children_d[i]].parents, tmp);
                }
                if (old_par === $.jstree.root || new_par.id === $.jstree.root) this._model.force_full_redraw = true;
                if (!this._model.force_full_redraw) {
                    this._node_changed(old_par);
                    this._node_changed(new_par.id);
                }
                if (!skip_redraw) this.redraw();
            }
            if (callback) callback.call(this, obj, new_par, pos);
            /**
			 * triggered when a node is moved
			 * @event
			 * @name move_node.jstree
			 * @param {Object} node
			 * @param {String} parent the parent's ID
			 * @param {Number} position the position of the node among the parent's children
			 * @param {String} old_parent the old parent of the node
			 * @param {Number} old_position the old position of the node
			 * @param {Boolean} is_multi do the node and new parent belong to different instances
			 * @param {jsTree} old_instance the instance the node came from
			 * @param {jsTree} new_instance the instance of the new parent
			 */ this.trigger("move_node", {
                "node": obj,
                "parent": new_par.id,
                "position": pos,
                "old_parent": old_par,
                "old_position": old_pos,
                "is_multi": old_ins && old_ins._id && old_ins._id !== this._id,
                "is_foreign": !old_ins || !old_ins._id,
                "old_instance": old_ins,
                "new_instance": this
            });
            return obj.id;
        },
        /**
		 * copy a node to a new parent
		 * @name copy_node(obj, par [, pos, callback, is_loaded])
		 * @param  {mixed} obj the node to copy, pass an array to copy multiple nodes
		 * @param  {mixed} par the new parent
		 * @param  {mixed} pos the position to insert at (besides integer values, "first" and "last" are supported, as well as "before" and "after"), defaults to integer `0`
		 * @param  {function} callback a function to call once the move is completed, receives 3 arguments - the node, the new parent and the position
		 * @param  {Boolean} is_loaded internal parameter indicating if the parent node has been loaded
		 * @param  {Boolean} skip_redraw internal parameter indicating if the tree should be redrawn
		 * @param  {Boolean} instance internal parameter indicating if the node comes from another instance
		 * @trigger model.jstree copy_node.jstree
		 */ copy_node: function(obj, par, pos, callback, is_loaded, skip_redraw, origin) {
            var t1, t2, dpc, tmp, i, j, node, old_par, new_par, old_ins, is_multi;
            par = this.get_node(par);
            pos = pos === undefined ? 0 : pos;
            if (!par) return false;
            if (!pos.toString().match(/^(before|after)$/) && !is_loaded && !this.is_loaded(par)) return this.load_node(par, function() {
                this.copy_node(obj, par, pos, callback, true, false, origin);
            });
            if ($.vakata.is_array(obj)) {
                if (obj.length === 1) obj = obj[0];
                else {
                    //obj = obj.slice();
                    for(t1 = 0, t2 = obj.length; t1 < t2; t1++)if (tmp = this.copy_node(obj[t1], par, pos, callback, is_loaded, true, origin)) {
                        par = tmp;
                        pos = "after";
                    }
                    this.redraw();
                    return true;
                }
            }
            obj = obj && obj.id !== undefined ? obj : this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            old_par = (obj.parent || $.jstree.root).toString();
            new_par = !pos.toString().match(/^(before|after)$/) || par.id === $.jstree.root ? par : this.get_node(par.parent);
            old_ins = origin ? origin : this._model.data[obj.id] ? this : $.jstree.reference(obj.id);
            is_multi = !old_ins || !old_ins._id || this._id !== old_ins._id;
            if (old_ins && old_ins._id) obj = old_ins._model.data[obj.id];
            if (par.id === $.jstree.root) {
                if (pos === "before") pos = "first";
                if (pos === "after") pos = "last";
            }
            switch(pos){
                case "before":
                    pos = $.inArray(par.id, new_par.children);
                    break;
                case "after":
                    pos = $.inArray(par.id, new_par.children) + 1;
                    break;
                case "inside":
                case "first":
                    pos = 0;
                    break;
                case "last":
                    pos = new_par.children.length;
                    break;
                default:
                    if (!pos) pos = 0;
                    break;
            }
            if (pos > new_par.children.length) pos = new_par.children.length;
            if (!this.check("copy_node", obj, new_par, pos, {
                "core": true,
                "origin": origin,
                "is_multi": old_ins && old_ins._id && old_ins._id !== this._id,
                "is_foreign": !old_ins || !old_ins._id
            })) {
                this.settings.core.error.call(this, this._data.core.last_error);
                return false;
            }
            node = old_ins ? old_ins.get_json(obj, {
                no_id: true,
                no_data: true,
                no_state: true
            }) : obj;
            if (!node) return false;
            if (node.id === true) delete node.id;
            node = this._parse_model_from_json(node, new_par.id, new_par.parents.concat());
            if (!node) return false;
            tmp = this.get_node(node);
            if (obj && obj.state && obj.state.loaded === false) tmp.state.loaded = false;
            dpc = [];
            dpc.push(node);
            dpc = dpc.concat(tmp.children_d);
            this.trigger("model", {
                "nodes": dpc,
                "parent": new_par.id
            });
            // insert into new parent and up
            for(i = 0, j = new_par.parents.length; i < j; i++)this._model.data[new_par.parents[i]].children_d = this._model.data[new_par.parents[i]].children_d.concat(dpc);
            dpc = [];
            for(i = 0, j = new_par.children.length; i < j; i++)dpc[i >= pos ? i + 1 : i] = new_par.children[i];
            dpc[pos] = tmp.id;
            new_par.children = dpc;
            new_par.children_d.push(tmp.id);
            new_par.children_d = new_par.children_d.concat(tmp.children_d);
            if (new_par.id === $.jstree.root) this._model.force_full_redraw = true;
            if (!this._model.force_full_redraw) this._node_changed(new_par.id);
            if (!skip_redraw) this.redraw(new_par.id === $.jstree.root);
            if (callback) callback.call(this, tmp, new_par, pos);
            /**
			 * triggered when a node is copied
			 * @event
			 * @name copy_node.jstree
			 * @param {Object} node the copied node
			 * @param {Object} original the original node
			 * @param {String} parent the parent's ID
			 * @param {Number} position the position of the node among the parent's children
			 * @param {String} old_parent the old parent of the node
			 * @param {Number} old_position the position of the original node
			 * @param {Boolean} is_multi do the node and new parent belong to different instances
			 * @param {jsTree} old_instance the instance the node came from
			 * @param {jsTree} new_instance the instance of the new parent
			 */ this.trigger("copy_node", {
                "node": tmp,
                "original": obj,
                "parent": new_par.id,
                "position": pos,
                "old_parent": old_par,
                "old_position": old_ins && old_ins._id && old_par && old_ins._model.data[old_par] && old_ins._model.data[old_par].children ? $.inArray(obj.id, old_ins._model.data[old_par].children) : -1,
                "is_multi": old_ins && old_ins._id && old_ins._id !== this._id,
                "is_foreign": !old_ins || !old_ins._id,
                "old_instance": old_ins,
                "new_instance": this
            });
            return tmp.id;
        },
        /**
		 * cut a node (a later call to `paste(obj)` would move the node)
		 * @name cut(obj)
		 * @param  {mixed} obj multiple objects can be passed using an array
		 * @trigger cut.jstree
		 */ cut: function(obj) {
            if (!obj) obj = this._data.core.selected.concat();
            if (!$.vakata.is_array(obj)) obj = [
                obj
            ];
            if (!obj.length) return false;
            var tmp = [], o, t1, t2;
            for(t1 = 0, t2 = obj.length; t1 < t2; t1++){
                o = this.get_node(obj[t1]);
                if (o && (o.id || o.id === 0) && o.id !== $.jstree.root) tmp.push(o);
            }
            if (!tmp.length) return false;
            ccp_node = tmp;
            ccp_inst = this;
            ccp_mode = "move_node";
            /**
			 * triggered when nodes are added to the buffer for moving
			 * @event
			 * @name cut.jstree
			 * @param {Array} node
			 */ this.trigger("cut", {
                "node": obj
            });
        },
        /**
		 * copy a node (a later call to `paste(obj)` would copy the node)
		 * @name copy(obj)
		 * @param  {mixed} obj multiple objects can be passed using an array
		 * @trigger copy.jstree
		 */ copy: function(obj) {
            if (!obj) obj = this._data.core.selected.concat();
            if (!$.vakata.is_array(obj)) obj = [
                obj
            ];
            if (!obj.length) return false;
            var tmp = [], o, t1, t2;
            for(t1 = 0, t2 = obj.length; t1 < t2; t1++){
                o = this.get_node(obj[t1]);
                if (o && o.id !== undefined && o.id !== $.jstree.root) tmp.push(o);
            }
            if (!tmp.length) return false;
            ccp_node = tmp;
            ccp_inst = this;
            ccp_mode = "copy_node";
            /**
			 * triggered when nodes are added to the buffer for copying
			 * @event
			 * @name copy.jstree
			 * @param {Array} node
			 */ this.trigger("copy", {
                "node": obj
            });
        },
        /**
		 * get the current buffer (any nodes that are waiting for a paste operation)
		 * @name get_buffer()
		 * @return {Object} an object consisting of `mode` ("copy_node" or "move_node"), `node` (an array of objects) and `inst` (the instance)
		 */ get_buffer: function() {
            return {
                "mode": ccp_mode,
                "node": ccp_node,
                "inst": ccp_inst
            };
        },
        /**
		 * check if there is something in the buffer to paste
		 * @name can_paste()
		 * @return {Boolean}
		 */ can_paste: function() {
            return ccp_mode !== false && ccp_node !== false; // && ccp_inst._model.data[ccp_node];
        },
        /**
		 * copy or move the previously cut or copied nodes to a new parent
		 * @name paste(obj [, pos])
		 * @param  {mixed} obj the new parent
		 * @param  {mixed} pos the position to insert at (besides integer, "first" and "last" are supported), defaults to integer `0`
		 * @trigger paste.jstree
		 */ paste: function(obj, pos) {
            obj = this.get_node(obj);
            if (!obj || !ccp_mode || !ccp_mode.match(/^(copy_node|move_node)$/) || !ccp_node) return false;
            if (this[ccp_mode](ccp_node, obj, pos, false, false, false, ccp_inst)) /**
				 * triggered when paste is invoked
				 * @event
				 * @name paste.jstree
				 * @param {String} parent the ID of the receiving node
				 * @param {Array} node the nodes in the buffer
				 * @param {String} mode the performed operation - "copy_node" or "move_node"
				 */ this.trigger("paste", {
                "parent": obj.id,
                "node": ccp_node,
                "mode": ccp_mode
            });
            ccp_node = false;
            ccp_mode = false;
            ccp_inst = false;
        },
        /**
		 * clear the buffer of previously copied or cut nodes
		 * @name clear_buffer()
		 * @trigger clear_buffer.jstree
		 */ clear_buffer: function() {
            ccp_node = false;
            ccp_mode = false;
            ccp_inst = false;
            /**
			 * triggered when the copy / cut buffer is cleared
			 * @event
			 * @name clear_buffer.jstree
			 */ this.trigger("clear_buffer");
        },
        /**
		 * put a node in edit mode (input field to rename the node)
		 * @name edit(obj [, default_text, callback])
		 * @param  {mixed} obj
		 * @param  {String} default_text the text to populate the input with (if omitted or set to a non-string value the node's text value is used)
		 * @param  {Function} callback a function to be called once the text box is blurred, it is called in the instance's scope and receives the node, a status parameter (true if the rename is successful, false otherwise), a boolean indicating if the user cancelled the edit and the original unescaped value provided by the user. You can also access the node's title using .text
		 */ edit: function(obj, default_text, callback) {
            var rtl, w, a, s, t, h1, h2, fn, tmp, cancel = false;
            obj = this.get_node(obj);
            if (!obj) return false;
            if (!this.check("edit", obj, this.get_parent(obj))) {
                this.settings.core.error.call(this, this._data.core.last_error);
                return false;
            }
            tmp = obj;
            default_text = typeof default_text === "string" ? default_text : obj.text;
            this.set_text(obj, "");
            obj = this._open_to(obj);
            tmp.text = default_text;
            rtl = this._data.core.rtl;
            w = this.element.width();
            this._data.core.focused = tmp.id;
            a = obj.children(".jstree-anchor").trigger("focus");
            s = $("<span></span>");
            /*!
			oi = obj.children("i:visible"),
			ai = a.children("i:visible"),
			w1 = oi.width() * oi.length,
			w2 = ai.width() * ai.length,
			*/ t = default_text;
            h1 = $("<div></div>", {
                css: {
                    "position": "absolute",
                    "top": "-200px",
                    "left": rtl ? "0px" : "-1000px",
                    "visibility": "hidden"
                }
            }).appendTo(document.body);
            h2 = $("<input />", {
                "value": t,
                "class": "jstree-rename-input",
                // "size" : t.length,
                "css": {
                    "padding": "0",
                    "border": "1px solid silver",
                    "box-sizing": "border-box",
                    "display": "inline-block",
                    "height": this._data.core.li_height + "px",
                    "lineHeight": this._data.core.li_height + "px",
                    "width": "150px" // will be set a bit further down
                },
                "blur": (function(e) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    var i = s.children(".jstree-rename-input"), v = i.val(), f = this.settings.core.force_text, nv;
                    if (v === "") v = t;
                    h1.remove();
                    s.replaceWith(a);
                    s.remove();
                    t = f ? t : $("<div></div>").append($.parseHTML(t)).html();
                    obj = this.get_node(obj);
                    this.set_text(obj, t);
                    nv = !!this.rename_node(obj, f ? $("<div></div>").text(v).text() : $("<div></div>").append($.parseHTML(v)).html());
                    if (!nv) this.set_text(obj, t); // move this up? and fix #483
                    this._data.core.focused = tmp.id;
                    setTimeout((function() {
                        var node = this.get_node(tmp.id, true);
                        if (node.length) {
                            this._data.core.focused = tmp.id;
                            node.children(".jstree-anchor").trigger("focus");
                        }
                    }).bind(this), 0);
                    if (callback) callback.call(this, tmp, nv, cancel, v);
                    h2 = null;
                }).bind(this),
                "keydown": function(e) {
                    var key = e.which;
                    if (key === 27) {
                        cancel = true;
                        this.value = t;
                    }
                    if (key === 27 || key === 13 || key === 37 || key === 38 || key === 39 || key === 40 || key === 32) e.stopImmediatePropagation();
                    if (key === 27 || key === 13) {
                        e.preventDefault();
                        this.blur();
                    }
                },
                "click": function(e) {
                    e.stopImmediatePropagation();
                },
                "mousedown": function(e) {
                    e.stopImmediatePropagation();
                },
                "keyup": function(e) {
                    h2.width(Math.min(h1.text("pW" + this.value).width(), w));
                },
                "keypress": function(e) {
                    if (e.which === 13) return false;
                }
            });
            fn = {
                fontFamily: a.css("fontFamily") || "",
                fontSize: a.css("fontSize") || "",
                fontWeight: a.css("fontWeight") || "",
                fontStyle: a.css("fontStyle") || "",
                fontStretch: a.css("fontStretch") || "",
                fontVariant: a.css("fontVariant") || "",
                letterSpacing: a.css("letterSpacing") || "",
                wordSpacing: a.css("wordSpacing") || ""
            };
            s.attr("class", a.attr("class")).append(a.contents().clone()).append(h2);
            a.replaceWith(s);
            h1.css(fn);
            h2.css(fn).width(Math.min(h1.text("pW" + h2[0].value).width(), w))[0].select();
            $(document).one("mousedown.jstree touchstart.jstree dnd_start.vakata", function(e) {
                if (h2 && e.target !== h2) $(h2).trigger("blur");
            });
        },
        /**
		 * changes the theme
		 * @name set_theme(theme_name [, theme_url])
		 * @param {String} theme_name the name of the new theme to apply
		 * @param {mixed} theme_url  the location of the CSS file for this theme. Omit or set to `false` if you manually included the file. Set to `true` to autoload from the `core.themes.dir` directory.
		 * @trigger set_theme.jstree
		 */ set_theme: function(theme_name, theme_url) {
            if (!theme_name) return false;
            if (theme_url === true) {
                var dir = this.settings.core.themes.dir;
                if (!dir) dir = $.jstree.path + "/themes";
                theme_url = dir + "/" + theme_name + "/style.css";
            }
            if (theme_url && $.inArray(theme_url, themes_loaded) === -1) {
                $("head").append('<link rel="stylesheet" href="' + theme_url + '" type="text/css" />');
                themes_loaded.push(theme_url);
            }
            if (this._data.core.themes.name) this.element.removeClass("jstree-" + this._data.core.themes.name);
            this._data.core.themes.name = theme_name;
            this.element.addClass("jstree-" + theme_name);
            this.element[this.settings.core.themes.responsive ? "addClass" : "removeClass"]("jstree-" + theme_name + "-responsive");
            /**
			 * triggered when a theme is set
			 * @event
			 * @name set_theme.jstree
			 * @param {String} theme the new theme
			 */ this.trigger("set_theme", {
                "theme": theme_name
            });
        },
        /**
		 * gets the name of the currently applied theme name
		 * @name get_theme()
		 * @return {String}
		 */ get_theme: function() {
            return this._data.core.themes.name;
        },
        /**
		 * changes the theme variant (if the theme has variants)
		 * @name set_theme_variant(variant_name)
		 * @param {String|Boolean} variant_name the variant to apply (if `false` is used the current variant is removed)
		 */ set_theme_variant: function(variant_name) {
            if (this._data.core.themes.variant) this.element.removeClass("jstree-" + this._data.core.themes.name + "-" + this._data.core.themes.variant);
            this._data.core.themes.variant = variant_name;
            if (variant_name) this.element.addClass("jstree-" + this._data.core.themes.name + "-" + this._data.core.themes.variant);
        },
        /**
		 * gets the name of the currently applied theme variant
		 * @name get_theme()
		 * @return {String}
		 */ get_theme_variant: function() {
            return this._data.core.themes.variant;
        },
        /**
		 * shows a striped background on the container (if the theme supports it)
		 * @name show_stripes()
		 */ show_stripes: function() {
            this._data.core.themes.stripes = true;
            this.get_container_ul().addClass("jstree-striped");
            /**
			 * triggered when stripes are shown
			 * @event
			 * @name show_stripes.jstree
			 */ this.trigger("show_stripes");
        },
        /**
		 * hides the striped background on the container
		 * @name hide_stripes()
		 */ hide_stripes: function() {
            this._data.core.themes.stripes = false;
            this.get_container_ul().removeClass("jstree-striped");
            /**
			 * triggered when stripes are hidden
			 * @event
			 * @name hide_stripes.jstree
			 */ this.trigger("hide_stripes");
        },
        /**
		 * toggles the striped background on the container
		 * @name toggle_stripes()
		 */ toggle_stripes: function() {
            if (this._data.core.themes.stripes) this.hide_stripes();
            else this.show_stripes();
        },
        /**
		 * shows the connecting dots (if the theme supports it)
		 * @name show_dots()
		 */ show_dots: function() {
            this._data.core.themes.dots = true;
            this.get_container_ul().removeClass("jstree-no-dots");
            /**
			 * triggered when dots are shown
			 * @event
			 * @name show_dots.jstree
			 */ this.trigger("show_dots");
        },
        /**
		 * hides the connecting dots
		 * @name hide_dots()
		 */ hide_dots: function() {
            this._data.core.themes.dots = false;
            this.get_container_ul().addClass("jstree-no-dots");
            /**
			 * triggered when dots are hidden
			 * @event
			 * @name hide_dots.jstree
			 */ this.trigger("hide_dots");
        },
        /**
		 * toggles the connecting dots
		 * @name toggle_dots()
		 */ toggle_dots: function() {
            if (this._data.core.themes.dots) this.hide_dots();
            else this.show_dots();
        },
        /**
		 * show the node icons
		 * @name show_icons()
		 */ show_icons: function() {
            this._data.core.themes.icons = true;
            this.get_container_ul().removeClass("jstree-no-icons");
            /**
			 * triggered when icons are shown
			 * @event
			 * @name show_icons.jstree
			 */ this.trigger("show_icons");
        },
        /**
		 * hide the node icons
		 * @name hide_icons()
		 */ hide_icons: function() {
            this._data.core.themes.icons = false;
            this.get_container_ul().addClass("jstree-no-icons");
            /**
			 * triggered when icons are hidden
			 * @event
			 * @name hide_icons.jstree
			 */ this.trigger("hide_icons");
        },
        /**
		 * toggle the node icons
		 * @name toggle_icons()
		 */ toggle_icons: function() {
            if (this._data.core.themes.icons) this.hide_icons();
            else this.show_icons();
        },
        /**
		 * show the node ellipsis
		 * @name show_icons()
		 */ show_ellipsis: function() {
            this._data.core.themes.ellipsis = true;
            this.get_container_ul().addClass("jstree-ellipsis");
            /**
			 * triggered when ellisis is shown
			 * @event
			 * @name show_ellipsis.jstree
			 */ this.trigger("show_ellipsis");
        },
        /**
		 * hide the node ellipsis
		 * @name hide_ellipsis()
		 */ hide_ellipsis: function() {
            this._data.core.themes.ellipsis = false;
            this.get_container_ul().removeClass("jstree-ellipsis");
            /**
			 * triggered when ellisis is hidden
			 * @event
			 * @name hide_ellipsis.jstree
			 */ this.trigger("hide_ellipsis");
        },
        /**
		 * toggle the node ellipsis
		 * @name toggle_icons()
		 */ toggle_ellipsis: function() {
            if (this._data.core.themes.ellipsis) this.hide_ellipsis();
            else this.show_ellipsis();
        },
        /**
		 * set the node icon for a node
		 * @name set_icon(obj, icon)
		 * @param {mixed} obj
		 * @param {String} icon the new icon - can be a path to an icon or a className, if using an image that is in the current directory use a `./` prefix, otherwise it will be detected as a class
		 */ set_icon: function(obj, icon) {
            var t1, t2, dom, old;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.set_icon(obj[t1], icon);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            old = obj.icon;
            obj.icon = icon === true || icon === null || icon === undefined || icon === "" ? true : icon;
            dom = this.get_node(obj, true).children(".jstree-anchor").children(".jstree-themeicon");
            if (icon === false) {
                dom.removeClass("jstree-themeicon-custom " + old).css("background", "").removeAttr("rel");
                this.hide_icon(obj);
            } else if (icon === true || icon === null || icon === undefined || icon === "") {
                dom.removeClass("jstree-themeicon-custom " + old).css("background", "").removeAttr("rel");
                if (old === false) this.show_icon(obj);
            } else if (icon.indexOf("/") === -1 && icon.indexOf(".") === -1) {
                dom.removeClass(old).css("background", "");
                dom.addClass(icon + " jstree-themeicon-custom").attr("rel", icon);
                if (old === false) this.show_icon(obj);
            } else {
                dom.removeClass(old).css("background", "");
                dom.addClass("jstree-themeicon-custom").css("background", "url('" + icon + "') center center no-repeat").attr("rel", icon);
                if (old === false) this.show_icon(obj);
            }
            return true;
        },
        /**
		 * get the node icon for a node
		 * @name get_icon(obj)
		 * @param {mixed} obj
		 * @return {String}
		 */ get_icon: function(obj) {
            obj = this.get_node(obj);
            return !obj || obj.id === $.jstree.root ? false : obj.icon;
        },
        /**
		 * hide the icon on an individual node
		 * @name hide_icon(obj)
		 * @param {mixed} obj
		 */ hide_icon: function(obj) {
            var t1, t2;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.hide_icon(obj[t1]);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj === $.jstree.root) return false;
            obj.icon = false;
            this.get_node(obj, true).children(".jstree-anchor").children(".jstree-themeicon").addClass("jstree-themeicon-hidden");
            return true;
        },
        /**
		 * show the icon on an individual node
		 * @name show_icon(obj)
		 * @param {mixed} obj
		 */ show_icon: function(obj) {
            var t1, t2, dom;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.show_icon(obj[t1]);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj === $.jstree.root) return false;
            dom = this.get_node(obj, true);
            obj.icon = dom.length ? dom.children(".jstree-anchor").children(".jstree-themeicon").attr("rel") : true;
            if (!obj.icon) obj.icon = true;
            dom.children(".jstree-anchor").children(".jstree-themeicon").removeClass("jstree-themeicon-hidden");
            return true;
        }
    };
    // helpers
    $.vakata = {};
    // collect attributes
    $.vakata.attributes = function(node, with_values) {
        node = $(node)[0];
        var attr = with_values ? {} : [];
        if (node && node.attributes) $.each(node.attributes, function(i, v) {
            if ($.inArray(v.name.toLowerCase(), [
                "style",
                "contenteditable",
                "hasfocus",
                "tabindex"
            ]) !== -1) return;
            if (v.value !== null && $.vakata.trim(v.value) !== "") {
                if (with_values) attr[v.name] = v.value;
                else attr.push(v.name);
            }
        });
        return attr;
    };
    $.vakata.array_unique = function(array) {
        var a = [], i, j, l, o = {};
        for(i = 0, l = array.length; i < l; i++)if (o[array[i]] === undefined) {
            a.push(array[i]);
            o[array[i]] = true;
        }
        return a;
    };
    // remove item from array
    $.vakata.array_remove = function(array, from) {
        array.splice(from, 1);
        return array;
    //var rest = array.slice((to || from) + 1 || array.length);
    //array.length = from < 0 ? array.length + from : from;
    //array.push.apply(array, rest);
    //return array;
    };
    // remove item from array
    $.vakata.array_remove_item = function(array, item) {
        var tmp = $.inArray(item, array);
        return tmp !== -1 ? $.vakata.array_remove(array, tmp) : array;
    };
    $.vakata.array_filter = function(c, a, b, d, e) {
        if (c.filter) return c.filter(a, b);
        d = [];
        for(e in c)if (~~e + "" === e + "" && e >= 0 && a.call(b, c[e], +e, c)) d.push(c[e]);
        return d;
    };
    $.vakata.trim = function(text) {
        return String.prototype.trim ? String.prototype.trim.call(text.toString()) : text.toString().replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    };
    $.vakata.is_function = function(obj) {
        return typeof obj === "function" && typeof obj.nodeType !== "number";
    };
    $.vakata.is_array = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_objects/Function/bind#polyfill
    if (!Function.prototype.bind) Function.prototype.bind = function() {
        var thatFunc = this, thatArg = arguments[0];
        var args = Array.prototype.slice.call(arguments, 1);
        if (typeof thatFunc !== "function") // closest thing possible to the ECMAScript 5
        // internal IsCallable function
        throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
        return function() {
            var funcArgs = args.concat(Array.prototype.slice.call(arguments));
            return thatFunc.apply(thatArg, funcArgs);
        };
    };
    /**
 * ### Changed plugin
 *
 * This plugin adds more information to the `changed.jstree` event. The new data is contained in the `changed` event data property, and contains a lists of `selected` and `deselected` nodes.
 */ $.jstree.plugins.changed = function(options, parent) {
        var last = [];
        this.trigger = function(ev, data) {
            var i, j;
            if (!data) data = {};
            if (ev.replace(".jstree", "") === "changed") {
                data.changed = {
                    selected: [],
                    deselected: []
                };
                var tmp = {};
                for(i = 0, j = last.length; i < j; i++)tmp[last[i]] = 1;
                for(i = 0, j = data.selected.length; i < j; i++)if (!tmp[data.selected[i]]) data.changed.selected.push(data.selected[i]);
                else tmp[data.selected[i]] = 2;
                for(i = 0, j = last.length; i < j; i++)if (tmp[last[i]] === 1) data.changed.deselected.push(last[i]);
                last = data.selected.slice();
            }
            /**
			 * triggered when selection changes (the "changed" plugin enhances the original event with more data)
			 * @event
			 * @name changed.jstree
			 * @param {Object} node
			 * @param {Object} action the action that caused the selection to change
			 * @param {Array} selected the current selection
			 * @param {Object} changed an object containing two properties `selected` and `deselected` - both arrays of node IDs, which were selected or deselected since the last changed event
			 * @param {Object} event the event (if any) that triggered this changed event
			 * @plugin changed
			 */ parent.trigger.call(this, ev, data);
        };
        this.refresh = function(skip_loading, forget_state) {
            last = [];
            return parent.refresh.apply(this, arguments);
        };
    };
    /**
 * ### Checkbox plugin
 *
 * This plugin renders checkbox icons in front of each node, making multiple selection much easier.
 * It also supports tri-state behavior, meaning that if a node has a few of its children checked it will be rendered as undetermined, and state will be propagated up.
 */ var _i = document.createElement("I");
    _i.className = "jstree-icon jstree-checkbox";
    _i.setAttribute("role", "presentation");
    /**
	 * stores all defaults for the checkbox plugin
	 * @name $.jstree.defaults.checkbox
	 * @plugin checkbox
	 */ $.jstree.defaults.checkbox = {
        /**
		 * a boolean indicating if checkboxes should be visible (can be changed at a later time using `show_checkboxes()` and `hide_checkboxes`). Defaults to `true`.
		 * @name $.jstree.defaults.checkbox.visible
		 * @plugin checkbox
		 */ visible: true,
        /**
		 * a boolean indicating if checkboxes should cascade down and have an undetermined state. Defaults to `true`.
		 * @name $.jstree.defaults.checkbox.three_state
		 * @plugin checkbox
		 */ three_state: true,
        /**
		 * a boolean indicating if clicking anywhere on the node should act as clicking on the checkbox. Defaults to `true`.
		 * @name $.jstree.defaults.checkbox.whole_node
		 * @plugin checkbox
		 */ whole_node: true,
        /**
		 * a boolean indicating if the selected style of a node should be kept, or removed. Defaults to `true`.
		 * @name $.jstree.defaults.checkbox.keep_selected_style
		 * @plugin checkbox
		 */ keep_selected_style: true,
        /**
		 * This setting controls how cascading and undetermined nodes are applied.
		 * If 'up' is in the string - cascading up is enabled, if 'down' is in the string - cascading down is enabled, if 'undetermined' is in the string - undetermined nodes will be used.
		 * If `three_state` is set to `true` this setting is automatically set to 'up+down+undetermined'. Defaults to ''.
		 * @name $.jstree.defaults.checkbox.cascade
		 * @plugin checkbox
		 */ cascade: "",
        /**
		 * This setting controls if checkbox are bound to the general tree selection or to an internal array maintained by the checkbox plugin. Defaults to `true`, only set to `false` if you know exactly what you are doing.
		 * @name $.jstree.defaults.checkbox.tie_selection
		 * @plugin checkbox
		 */ tie_selection: true,
        /**
		 * This setting controls if cascading down affects disabled checkboxes
		 * @name $.jstree.defaults.checkbox.cascade_to_disabled
		 * @plugin checkbox
		 */ cascade_to_disabled: true,
        /**
		 * This setting controls if cascading down affects hidden checkboxes
		 * @name $.jstree.defaults.checkbox.cascade_to_hidden
		 * @plugin checkbox
		 */ cascade_to_hidden: true
    };
    $.jstree.plugins.checkbox = function(options, parent) {
        this.bind = function() {
            parent.bind.call(this);
            this._data.checkbox.uto = false;
            this._data.checkbox.selected = [];
            if (this.settings.checkbox.three_state) this.settings.checkbox.cascade = "up+down+undetermined";
            this.element.on("init.jstree", (function() {
                this._data.checkbox.visible = this.settings.checkbox.visible;
                if (!this.settings.checkbox.keep_selected_style) this.element.addClass("jstree-checkbox-no-clicked");
                if (this.settings.checkbox.tie_selection) this.element.addClass("jstree-checkbox-selection");
            }).bind(this)).on("loading.jstree", (function() {
                this[this._data.checkbox.visible ? "show_checkboxes" : "hide_checkboxes"]();
            }).bind(this));
            if (this.settings.checkbox.cascade.indexOf("undetermined") !== -1) this.element.on("changed.jstree uncheck_node.jstree check_node.jstree uncheck_all.jstree check_all.jstree move_node.jstree copy_node.jstree redraw.jstree open_node.jstree", (function() {
                // only if undetermined is in setting
                if (this._data.checkbox.uto) clearTimeout(this._data.checkbox.uto);
                this._data.checkbox.uto = setTimeout(this._undetermined.bind(this), 50);
            }).bind(this));
            if (!this.settings.checkbox.tie_selection) this.element.on("model.jstree", (function(e, data) {
                var m = this._model.data, p = m[data.parent], dpc = data.nodes, i, j;
                for(i = 0, j = dpc.length; i < j; i++){
                    m[dpc[i]].state.checked = m[dpc[i]].state.checked || m[dpc[i]].original && m[dpc[i]].original.state && m[dpc[i]].original.state.checked;
                    if (m[dpc[i]].state.checked) this._data.checkbox.selected.push(dpc[i]);
                }
            }).bind(this));
            if (this.settings.checkbox.cascade.indexOf("up") !== -1 || this.settings.checkbox.cascade.indexOf("down") !== -1) this.element.on("model.jstree", (function(e, data) {
                var m = this._model.data, p = m[data.parent], dpc = data.nodes, chd = [], c, i, j, k, l, tmp, s = this.settings.checkbox.cascade, t = this.settings.checkbox.tie_selection;
                if (s.indexOf("down") !== -1) {
                    // apply down
                    if (p.state[t ? "selected" : "checked"]) {
                        for(i = 0, j = dpc.length; i < j; i++)m[dpc[i]].state[t ? "selected" : "checked"] = true;
                        this._data[t ? "core" : "checkbox"].selected = this._data[t ? "core" : "checkbox"].selected.concat(dpc);
                    } else {
                        for(i = 0, j = dpc.length; i < j; i++)if (m[dpc[i]].state[t ? "selected" : "checked"]) {
                            for(k = 0, l = m[dpc[i]].children_d.length; k < l; k++)m[m[dpc[i]].children_d[k]].state[t ? "selected" : "checked"] = true;
                            this._data[t ? "core" : "checkbox"].selected = this._data[t ? "core" : "checkbox"].selected.concat(m[dpc[i]].children_d);
                        }
                    }
                }
                if (s.indexOf("up") !== -1) {
                    // apply up
                    for(i = 0, j = p.children_d.length; i < j; i++)if (!m[p.children_d[i]].children.length) chd.push(m[p.children_d[i]].parent);
                    chd = $.vakata.array_unique(chd);
                    for(k = 0, l = chd.length; k < l; k++){
                        p = m[chd[k]];
                        while(p && p.id !== $.jstree.root){
                            c = 0;
                            for(i = 0, j = p.children.length; i < j; i++)c += m[p.children[i]].state[t ? "selected" : "checked"];
                            if (c === j) {
                                p.state[t ? "selected" : "checked"] = true;
                                this._data[t ? "core" : "checkbox"].selected.push(p.id);
                                tmp = this.get_node(p, true);
                                if (tmp && tmp.length) tmp.children(".jstree-anchor").attr("aria-selected", true).addClass(t ? "jstree-clicked" : "jstree-checked");
                            } else break;
                            p = this.get_node(p.parent);
                        }
                    }
                }
                this._data[t ? "core" : "checkbox"].selected = $.vakata.array_unique(this._data[t ? "core" : "checkbox"].selected);
            }).bind(this)).on(this.settings.checkbox.tie_selection ? "select_node.jstree" : "check_node.jstree", (function(e, data) {
                var self = this, obj = data.node, m = this._model.data, par = this.get_node(obj.parent), i, j, c, tmp, s = this.settings.checkbox.cascade, t = this.settings.checkbox.tie_selection, sel = {}, cur = this._data[t ? "core" : "checkbox"].selected;
                for(i = 0, j = cur.length; i < j; i++)sel[cur[i]] = true;
                // apply down
                if (s.indexOf("down") !== -1) {
                    //this._data[ t ? 'core' : 'checkbox' ].selected = $.vakata.array_unique(this._data[ t ? 'core' : 'checkbox' ].selected.concat(obj.children_d));
                    var selectedIds = this._cascade_new_checked_state(obj.id, true);
                    var temp = obj.children_d.concat(obj.id);
                    for(i = 0, j = temp.length; i < j; i++)if (selectedIds.indexOf(temp[i]) > -1) sel[temp[i]] = true;
                    else delete sel[temp[i]];
                }
                // apply up
                if (s.indexOf("up") !== -1) while(par && par.id !== $.jstree.root){
                    c = 0;
                    for(i = 0, j = par.children.length; i < j; i++)c += m[par.children[i]].state[t ? "selected" : "checked"];
                    if (c === j) {
                        par.state[t ? "selected" : "checked"] = true;
                        sel[par.id] = true;
                        //this._data[ t ? 'core' : 'checkbox' ].selected.push(par.id);
                        tmp = this.get_node(par, true);
                        if (tmp && tmp.length) tmp.children(".jstree-anchor").attr("aria-selected", true).addClass(t ? "jstree-clicked" : "jstree-checked");
                    } else break;
                    par = this.get_node(par.parent);
                }
                cur = [];
                for(i in sel)if (sel.hasOwnProperty(i)) cur.push(i);
                this._data[t ? "core" : "checkbox"].selected = cur;
            }).bind(this)).on(this.settings.checkbox.tie_selection ? "deselect_all.jstree" : "uncheck_all.jstree", (function(e, data) {
                var obj = this.get_node($.jstree.root), m = this._model.data, i, j, tmp;
                for(i = 0, j = obj.children_d.length; i < j; i++){
                    tmp = m[obj.children_d[i]];
                    if (tmp && tmp.original && tmp.original.state && tmp.original.state.undetermined) tmp.original.state.undetermined = false;
                }
            }).bind(this)).on(this.settings.checkbox.tie_selection ? "deselect_node.jstree" : "uncheck_node.jstree", (function(e, data) {
                var self = this, obj = data.node, dom = this.get_node(obj, true), i, j, tmp, s = this.settings.checkbox.cascade, t = this.settings.checkbox.tie_selection, cur = this._data[t ? "core" : "checkbox"].selected, sel = {}, stillSelectedIds = [], allIds = obj.children_d.concat(obj.id);
                // apply down
                if (s.indexOf("down") !== -1) {
                    var selectedIds = this._cascade_new_checked_state(obj.id, false);
                    cur = $.vakata.array_filter(cur, function(id) {
                        return allIds.indexOf(id) === -1 || selectedIds.indexOf(id) > -1;
                    });
                }
                // only apply up if cascade up is enabled and if this node is not selected
                // (if all child nodes are disabled and cascade_to_disabled === false then this node will till be selected).
                if (s.indexOf("up") !== -1 && cur.indexOf(obj.id) === -1) {
                    for(i = 0, j = obj.parents.length; i < j; i++){
                        tmp = this._model.data[obj.parents[i]];
                        tmp.state[t ? "selected" : "checked"] = false;
                        if (tmp && tmp.original && tmp.original.state && tmp.original.state.undetermined) tmp.original.state.undetermined = false;
                        tmp = this.get_node(obj.parents[i], true);
                        if (tmp && tmp.length) tmp.children(".jstree-anchor").attr("aria-selected", false).removeClass(t ? "jstree-clicked" : "jstree-checked");
                    }
                    cur = $.vakata.array_filter(cur, function(id) {
                        return obj.parents.indexOf(id) === -1;
                    });
                }
                this._data[t ? "core" : "checkbox"].selected = cur;
            }).bind(this));
            if (this.settings.checkbox.cascade.indexOf("up") !== -1) this.element.on("delete_node.jstree", (function(e, data) {
                // apply up (whole handler)
                var p = this.get_node(data.parent), m = this._model.data, i, j, c, tmp, t = this.settings.checkbox.tie_selection;
                while(p && p.id !== $.jstree.root && !p.state[t ? "selected" : "checked"]){
                    c = 0;
                    for(i = 0, j = p.children.length; i < j; i++)c += m[p.children[i]].state[t ? "selected" : "checked"];
                    if (j > 0 && c === j) {
                        p.state[t ? "selected" : "checked"] = true;
                        this._data[t ? "core" : "checkbox"].selected.push(p.id);
                        tmp = this.get_node(p, true);
                        if (tmp && tmp.length) tmp.children(".jstree-anchor").attr("aria-selected", true).addClass(t ? "jstree-clicked" : "jstree-checked");
                    } else break;
                    p = this.get_node(p.parent);
                }
            }).bind(this)).on("move_node.jstree", (function(e, data) {
                // apply up (whole handler)
                var is_multi = data.is_multi, old_par = data.old_parent, new_par = this.get_node(data.parent), m = this._model.data, p, c, i, j, tmp, t = this.settings.checkbox.tie_selection;
                if (!is_multi) {
                    p = this.get_node(old_par);
                    while(p && p.id !== $.jstree.root && !p.state[t ? "selected" : "checked"]){
                        c = 0;
                        for(i = 0, j = p.children.length; i < j; i++)c += m[p.children[i]].state[t ? "selected" : "checked"];
                        if (j > 0 && c === j) {
                            p.state[t ? "selected" : "checked"] = true;
                            this._data[t ? "core" : "checkbox"].selected.push(p.id);
                            tmp = this.get_node(p, true);
                            if (tmp && tmp.length) tmp.children(".jstree-anchor").attr("aria-selected", true).addClass(t ? "jstree-clicked" : "jstree-checked");
                        } else break;
                        p = this.get_node(p.parent);
                    }
                }
                p = new_par;
                while(p && p.id !== $.jstree.root){
                    c = 0;
                    for(i = 0, j = p.children.length; i < j; i++)c += m[p.children[i]].state[t ? "selected" : "checked"];
                    if (c === j) {
                        if (!p.state[t ? "selected" : "checked"]) {
                            p.state[t ? "selected" : "checked"] = true;
                            this._data[t ? "core" : "checkbox"].selected.push(p.id);
                            tmp = this.get_node(p, true);
                            if (tmp && tmp.length) tmp.children(".jstree-anchor").attr("aria-selected", true).addClass(t ? "jstree-clicked" : "jstree-checked");
                        }
                    } else {
                        if (p.state[t ? "selected" : "checked"]) {
                            p.state[t ? "selected" : "checked"] = false;
                            this._data[t ? "core" : "checkbox"].selected = $.vakata.array_remove_item(this._data[t ? "core" : "checkbox"].selected, p.id);
                            tmp = this.get_node(p, true);
                            if (tmp && tmp.length) tmp.children(".jstree-anchor").attr("aria-selected", false).removeClass(t ? "jstree-clicked" : "jstree-checked");
                        } else break;
                    }
                    p = this.get_node(p.parent);
                }
            }).bind(this));
        };
        /**
		 * get an array of all nodes whose state is "undetermined"
		 * @name get_undetermined([full])
		 * @param  {boolean} full: if set to `true` the returned array will consist of the full node objects, otherwise - only IDs will be returned
		 * @return {Array}
		 * @plugin checkbox
		 */ this.get_undetermined = function(full) {
            if (this.settings.checkbox.cascade.indexOf("undetermined") === -1) return [];
            var i, j, k, l, o = {}, m = this._model.data, t = this.settings.checkbox.tie_selection, s = this._data[t ? "core" : "checkbox"].selected, p = [], tt = this, r = [];
            for(i = 0, j = s.length; i < j; i++){
                if (m[s[i]] && m[s[i]].parents) for(k = 0, l = m[s[i]].parents.length; k < l; k++){
                    if (o[m[s[i]].parents[k]] !== undefined) break;
                    if (m[s[i]].parents[k] !== $.jstree.root) {
                        o[m[s[i]].parents[k]] = true;
                        p.push(m[s[i]].parents[k]);
                    }
                }
            }
            // attempt for server side undetermined state
            this.element.find(".jstree-closed").not(":has(.jstree-children)").each(function() {
                var tmp = tt.get_node(this), tmp2;
                if (!tmp) return;
                if (!tmp.state.loaded) {
                    if (tmp.original && tmp.original.state && tmp.original.state.undetermined && tmp.original.state.undetermined === true) {
                        if (o[tmp.id] === undefined && tmp.id !== $.jstree.root) {
                            o[tmp.id] = true;
                            p.push(tmp.id);
                        }
                        for(k = 0, l = tmp.parents.length; k < l; k++)if (o[tmp.parents[k]] === undefined && tmp.parents[k] !== $.jstree.root) {
                            o[tmp.parents[k]] = true;
                            p.push(tmp.parents[k]);
                        }
                    }
                } else for(i = 0, j = tmp.children_d.length; i < j; i++){
                    tmp2 = m[tmp.children_d[i]];
                    if (!tmp2.state.loaded && tmp2.original && tmp2.original.state && tmp2.original.state.undetermined && tmp2.original.state.undetermined === true) {
                        if (o[tmp2.id] === undefined && tmp2.id !== $.jstree.root) {
                            o[tmp2.id] = true;
                            p.push(tmp2.id);
                        }
                        for(k = 0, l = tmp2.parents.length; k < l; k++)if (o[tmp2.parents[k]] === undefined && tmp2.parents[k] !== $.jstree.root) {
                            o[tmp2.parents[k]] = true;
                            p.push(tmp2.parents[k]);
                        }
                    }
                }
            });
            for(i = 0, j = p.length; i < j; i++)if (!m[p[i]].state[t ? "selected" : "checked"]) r.push(full ? m[p[i]] : p[i]);
            return r;
        };
        /**
		 * set the undetermined state where and if necessary. Used internally.
		 * @private
		 * @name _undetermined()
		 * @plugin checkbox
		 */ this._undetermined = function() {
            if (this.element === null) return;
            var p = this.get_undetermined(false), i, j, s;
            this.element.find(".jstree-undetermined").removeClass("jstree-undetermined");
            for(i = 0, j = p.length; i < j; i++){
                s = this.get_node(p[i], true);
                if (s && s.length) s.children(".jstree-anchor").children(".jstree-checkbox").addClass("jstree-undetermined");
            }
        };
        this.redraw_node = function(obj, deep, is_callback, force_render) {
            obj = parent.redraw_node.apply(this, arguments);
            if (obj) {
                var i, j, tmp = null, icon = null;
                for(i = 0, j = obj.childNodes.length; i < j; i++)if (obj.childNodes[i] && obj.childNodes[i].className && obj.childNodes[i].className.indexOf("jstree-anchor") !== -1) {
                    tmp = obj.childNodes[i];
                    break;
                }
                if (tmp) {
                    if (!this.settings.checkbox.tie_selection && this._model.data[obj.id].state.checked) tmp.className += " jstree-checked";
                    icon = _i.cloneNode(false);
                    if (this._model.data[obj.id].state.checkbox_disabled) icon.className += " jstree-checkbox-disabled";
                    tmp.insertBefore(icon, tmp.childNodes[0]);
                }
            }
            if (!is_callback && this.settings.checkbox.cascade.indexOf("undetermined") !== -1) {
                if (this._data.checkbox.uto) clearTimeout(this._data.checkbox.uto);
                this._data.checkbox.uto = setTimeout(this._undetermined.bind(this), 50);
            }
            return obj;
        };
        /**
		 * show the node checkbox icons
		 * @name show_checkboxes()
		 * @plugin checkbox
		 */ this.show_checkboxes = function() {
            this._data.core.themes.checkboxes = true;
            this.get_container_ul().removeClass("jstree-no-checkboxes");
        };
        /**
		 * hide the node checkbox icons
		 * @name hide_checkboxes()
		 * @plugin checkbox
		 */ this.hide_checkboxes = function() {
            this._data.core.themes.checkboxes = false;
            this.get_container_ul().addClass("jstree-no-checkboxes");
        };
        /**
		 * toggle the node icons
		 * @name toggle_checkboxes()
		 * @plugin checkbox
		 */ this.toggle_checkboxes = function() {
            if (this._data.core.themes.checkboxes) this.hide_checkboxes();
            else this.show_checkboxes();
        };
        /**
		 * checks if a node is in an undetermined state
		 * @name is_undetermined(obj)
		 * @param  {mixed} obj
		 * @return {Boolean}
		 */ this.is_undetermined = function(obj) {
            obj = this.get_node(obj);
            var s = this.settings.checkbox.cascade, i, j, t = this.settings.checkbox.tie_selection, d = this._data[t ? "core" : "checkbox"].selected, m = this._model.data;
            if (!obj || obj.state[t ? "selected" : "checked"] === true || s.indexOf("undetermined") === -1 || s.indexOf("down") === -1 && s.indexOf("up") === -1) return false;
            if (!obj.state.loaded && obj.original.state.undetermined === true) return true;
            for(i = 0, j = obj.children_d.length; i < j; i++){
                if ($.inArray(obj.children_d[i], d) !== -1 || !m[obj.children_d[i]].state.loaded && m[obj.children_d[i]].original.state.undetermined) return true;
            }
            return false;
        };
        /**
		 * disable a node's checkbox
		 * @name disable_checkbox(obj)
		 * @param {mixed} obj an array can be used too
		 * @trigger disable_checkbox.jstree
		 * @plugin checkbox
		 */ this.disable_checkbox = function(obj) {
            var t1, t2, dom;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.disable_checkbox(obj[t1]);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            dom = this.get_node(obj, true);
            if (!obj.state.checkbox_disabled) {
                obj.state.checkbox_disabled = true;
                if (dom && dom.length) dom.children(".jstree-anchor").children(".jstree-checkbox").addClass("jstree-checkbox-disabled");
                /**
				 * triggered when an node's checkbox is disabled
				 * @event
				 * @name disable_checkbox.jstree
				 * @param {Object} node
				 * @plugin checkbox
				 */ this.trigger("disable_checkbox", {
                    "node": obj
                });
            }
        };
        /**
		 * enable a node's checkbox
		 * @name enable_checkbox(obj)
		 * @param {mixed} obj an array can be used too
		 * @trigger enable_checkbox.jstree
		 * @plugin checkbox
		 */ this.enable_checkbox = function(obj) {
            var t1, t2, dom;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.enable_checkbox(obj[t1]);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            dom = this.get_node(obj, true);
            if (obj.state.checkbox_disabled) {
                obj.state.checkbox_disabled = false;
                if (dom && dom.length) dom.children(".jstree-anchor").children(".jstree-checkbox").removeClass("jstree-checkbox-disabled");
                /**
				 * triggered when an node's checkbox is enabled
				 * @event
				 * @name enable_checkbox.jstree
				 * @param {Object} node
				 * @plugin checkbox
				 */ this.trigger("enable_checkbox", {
                    "node": obj
                });
            }
        };
        this.activate_node = function(obj, e) {
            if ($(e.target).hasClass("jstree-checkbox-disabled")) return false;
            if (this.settings.checkbox.tie_selection && (this.settings.checkbox.whole_node || $(e.target).hasClass("jstree-checkbox"))) e.ctrlKey = true;
            if (this.settings.checkbox.tie_selection || !this.settings.checkbox.whole_node && !$(e.target).hasClass("jstree-checkbox")) return parent.activate_node.call(this, obj, e);
            if (this.is_disabled(obj)) return false;
            if (this.is_checked(obj)) this.uncheck_node(obj, e);
            else this.check_node(obj, e);
            this.trigger("activate_node", {
                "node": this.get_node(obj)
            });
        };
        this.delete_node = function(obj) {
            if (this.settings.checkbox.tie_selection || $.vakata.is_array(obj)) return parent.delete_node.call(this, obj);
            var tmp, k, l, c = false;
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            tmp = obj.children_d.concat([]);
            tmp.push(obj.id);
            for(k = 0, l = tmp.length; k < l; k++)if (this._model.data[tmp[k]].state.checked) {
                c = true;
                break;
            }
            if (c) this._data.checkbox.selected = $.vakata.array_filter(this._data.checkbox.selected, function(v) {
                return $.inArray(v, tmp) === -1;
            });
            return parent.delete_node.call(this, obj);
        };
        /**
		 * Cascades checked state to a node and all its descendants. This function does NOT affect hidden and disabled nodes (or their descendants).
		 * However if these unaffected nodes are already selected their ids will be included in the returned array.
		 * @private
		 * @name _cascade_new_checked_state(id, checkedState)
		 * @param {string} id the node ID
		 * @param {bool} checkedState should the nodes be checked or not
		 * @returns {Array} Array of all node id's (in this tree branch) that are checked.
		 */ this._cascade_new_checked_state = function(id, checkedState) {
            var self = this;
            var t = this.settings.checkbox.tie_selection;
            var node = this._model.data[id];
            var selectedNodeIds = [];
            var selectedChildrenIds = [], i, j, selectedChildIds;
            if ((this.settings.checkbox.cascade_to_disabled || !node.state.disabled) && (this.settings.checkbox.cascade_to_hidden || !node.state.hidden)) {
                //First try and check/uncheck the children
                if (node.children) for(i = 0, j = node.children.length; i < j; i++){
                    var childId = node.children[i];
                    selectedChildIds = self._cascade_new_checked_state(childId, checkedState);
                    selectedNodeIds = selectedNodeIds.concat(selectedChildIds);
                    if (selectedChildIds.indexOf(childId) > -1) selectedChildrenIds.push(childId);
                }
                var dom = self.get_node(node, true);
                //A node's state is undetermined if some but not all of it's children are checked/selected .
                var undetermined = selectedChildrenIds.length > 0 && selectedChildrenIds.length < node.children.length;
                if (node.original && node.original.state && node.original.state.undetermined) node.original.state.undetermined = undetermined;
                //If a node is undetermined then remove selected class
                if (undetermined) {
                    node.state[t ? "selected" : "checked"] = false;
                    dom.children(".jstree-anchor").attr("aria-selected", false).removeClass(t ? "jstree-clicked" : "jstree-checked");
                } else if (checkedState && selectedChildrenIds.length === node.children.length) {
                    node.state[t ? "selected" : "checked"] = checkedState;
                    selectedNodeIds.push(node.id);
                    dom.children(".jstree-anchor").attr("aria-selected", true).addClass(t ? "jstree-clicked" : "jstree-checked");
                } else {
                    node.state[t ? "selected" : "checked"] = false;
                    dom.children(".jstree-anchor").attr("aria-selected", false).removeClass(t ? "jstree-clicked" : "jstree-checked");
                }
            } else {
                selectedChildIds = this.get_checked_descendants(id);
                if (node.state[t ? "selected" : "checked"]) selectedChildIds.push(node.id);
                selectedNodeIds = selectedNodeIds.concat(selectedChildIds);
            }
            return selectedNodeIds;
        };
        /**
		 * Gets ids of nodes selected in branch (of tree) specified by id (does not include the node specified by id)
		 * @name get_checked_descendants(obj)
		 * @param {string} id the node ID
		 * @return {Array} array of IDs
		 * @plugin checkbox
		 */ this.get_checked_descendants = function(id) {
            var self = this;
            var t = self.settings.checkbox.tie_selection;
            var node = self._model.data[id];
            return $.vakata.array_filter(node.children_d, function(_id) {
                return self._model.data[_id].state[t ? "selected" : "checked"];
            });
        };
        /**
		 * check a node (only if tie_selection in checkbox settings is false, otherwise select_node will be called internally)
		 * @name check_node(obj)
		 * @param {mixed} obj an array can be used to check multiple nodes
		 * @trigger check_node.jstree
		 * @plugin checkbox
		 */ this.check_node = function(obj, e) {
            if (this.settings.checkbox.tie_selection) return this.select_node(obj, false, true, e);
            var dom, t1, t2, th;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.check_node(obj[t1], e);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            dom = this.get_node(obj, true);
            if (!obj.state.checked) {
                obj.state.checked = true;
                this._data.checkbox.selected.push(obj.id);
                if (dom && dom.length) dom.children(".jstree-anchor").addClass("jstree-checked");
                /**
				 * triggered when an node is checked (only if tie_selection in checkbox settings is false)
				 * @event
				 * @name check_node.jstree
				 * @param {Object} node
				 * @param {Array} selected the current selection
				 * @param {Object} event the event (if any) that triggered this check_node
				 * @plugin checkbox
				 */ this.trigger("check_node", {
                    "node": obj,
                    "selected": this._data.checkbox.selected,
                    "event": e
                });
            }
        };
        /**
		 * uncheck a node (only if tie_selection in checkbox settings is false, otherwise deselect_node will be called internally)
		 * @name uncheck_node(obj)
		 * @param {mixed} obj an array can be used to uncheck multiple nodes
		 * @trigger uncheck_node.jstree
		 * @plugin checkbox
		 */ this.uncheck_node = function(obj, e) {
            if (this.settings.checkbox.tie_selection) return this.deselect_node(obj, false, e);
            var t1, t2, dom;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.uncheck_node(obj[t1], e);
                return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            dom = this.get_node(obj, true);
            if (obj.state.checked) {
                obj.state.checked = false;
                this._data.checkbox.selected = $.vakata.array_remove_item(this._data.checkbox.selected, obj.id);
                if (dom.length) dom.children(".jstree-anchor").removeClass("jstree-checked");
                /**
				 * triggered when an node is unchecked (only if tie_selection in checkbox settings is false)
				 * @event
				 * @name uncheck_node.jstree
				 * @param {Object} node
				 * @param {Array} selected the current selection
				 * @param {Object} event the event (if any) that triggered this uncheck_node
				 * @plugin checkbox
				 */ this.trigger("uncheck_node", {
                    "node": obj,
                    "selected": this._data.checkbox.selected,
                    "event": e
                });
            }
        };
        /**
		 * checks all nodes in the tree (only if tie_selection in checkbox settings is false, otherwise select_all will be called internally)
		 * @name check_all()
		 * @trigger check_all.jstree, changed.jstree
		 * @plugin checkbox
		 */ this.check_all = function() {
            if (this.settings.checkbox.tie_selection) return this.select_all();
            var tmp = this._data.checkbox.selected.concat([]), i, j;
            this._data.checkbox.selected = this._model.data[$.jstree.root].children_d.concat();
            for(i = 0, j = this._data.checkbox.selected.length; i < j; i++)if (this._model.data[this._data.checkbox.selected[i]]) this._model.data[this._data.checkbox.selected[i]].state.checked = true;
            this.redraw(true);
            /**
			 * triggered when all nodes are checked (only if tie_selection in checkbox settings is false)
			 * @event
			 * @name check_all.jstree
			 * @param {Array} selected the current selection
			 * @plugin checkbox
			 */ this.trigger("check_all", {
                "selected": this._data.checkbox.selected
            });
        };
        /**
		 * uncheck all checked nodes (only if tie_selection in checkbox settings is false, otherwise deselect_all will be called internally)
		 * @name uncheck_all()
		 * @trigger uncheck_all.jstree
		 * @plugin checkbox
		 */ this.uncheck_all = function() {
            if (this.settings.checkbox.tie_selection) return this.deselect_all();
            var tmp = this._data.checkbox.selected.concat([]), i, j;
            for(i = 0, j = this._data.checkbox.selected.length; i < j; i++)if (this._model.data[this._data.checkbox.selected[i]]) this._model.data[this._data.checkbox.selected[i]].state.checked = false;
            this._data.checkbox.selected = [];
            this.element.find(".jstree-checked").removeClass("jstree-checked");
            /**
			 * triggered when all nodes are unchecked (only if tie_selection in checkbox settings is false)
			 * @event
			 * @name uncheck_all.jstree
			 * @param {Object} node the previous selection
			 * @param {Array} selected the current selection
			 * @plugin checkbox
			 */ this.trigger("uncheck_all", {
                "selected": this._data.checkbox.selected,
                "node": tmp
            });
        };
        /**
		 * checks if a node is checked (if tie_selection is on in the settings this function will return the same as is_selected)
		 * @name is_checked(obj)
		 * @param  {mixed}  obj
		 * @return {Boolean}
		 * @plugin checkbox
		 */ this.is_checked = function(obj) {
            if (this.settings.checkbox.tie_selection) return this.is_selected(obj);
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            return obj.state.checked;
        };
        /**
		 * get an array of all checked nodes (if tie_selection is on in the settings this function will return the same as get_selected)
		 * @name get_checked([full])
		 * @param  {mixed}  full if set to `true` the returned array will consist of the full node objects, otherwise - only IDs will be returned
		 * @return {Array}
		 * @plugin checkbox
		 */ this.get_checked = function(full) {
            if (this.settings.checkbox.tie_selection) return this.get_selected(full);
            return full ? $.map(this._data.checkbox.selected, (function(i) {
                return this.get_node(i);
            }).bind(this)) : this._data.checkbox.selected.slice();
        };
        /**
		 * get an array of all top level checked nodes (ignoring children of checked nodes) (if tie_selection is on in the settings this function will return the same as get_top_selected)
		 * @name get_top_checked([full])
		 * @param  {mixed}  full if set to `true` the returned array will consist of the full node objects, otherwise - only IDs will be returned
		 * @return {Array}
		 * @plugin checkbox
		 */ this.get_top_checked = function(full) {
            if (this.settings.checkbox.tie_selection) return this.get_top_selected(full);
            var tmp = this.get_checked(true), obj = {}, i, j, k, l;
            for(i = 0, j = tmp.length; i < j; i++)obj[tmp[i].id] = tmp[i];
            for(i = 0, j = tmp.length; i < j; i++){
                for(k = 0, l = tmp[i].children_d.length; k < l; k++)if (obj[tmp[i].children_d[k]]) delete obj[tmp[i].children_d[k]];
            }
            tmp = [];
            for(i in obj)if (obj.hasOwnProperty(i)) tmp.push(i);
            return full ? $.map(tmp, (function(i) {
                return this.get_node(i);
            }).bind(this)) : tmp;
        };
        /**
		 * get an array of all bottom level checked nodes (ignoring selected parents) (if tie_selection is on in the settings this function will return the same as get_bottom_selected)
		 * @name get_bottom_checked([full])
		 * @param  {mixed}  full if set to `true` the returned array will consist of the full node objects, otherwise - only IDs will be returned
		 * @return {Array}
		 * @plugin checkbox
		 */ this.get_bottom_checked = function(full) {
            if (this.settings.checkbox.tie_selection) return this.get_bottom_selected(full);
            var tmp = this.get_checked(true), obj = [], i, j;
            for(i = 0, j = tmp.length; i < j; i++)if (!tmp[i].children.length) obj.push(tmp[i].id);
            return full ? $.map(obj, (function(i) {
                return this.get_node(i);
            }).bind(this)) : obj;
        };
        this.load_node = function(obj, callback) {
            var k, l, i, j, c, tmp;
            if (!$.vakata.is_array(obj) && !this.settings.checkbox.tie_selection) {
                tmp = this.get_node(obj);
                if (tmp && tmp.state.loaded) {
                    for(k = 0, l = tmp.children_d.length; k < l; k++)if (this._model.data[tmp.children_d[k]].state.checked) {
                        c = true;
                        this._data.checkbox.selected = $.vakata.array_remove_item(this._data.checkbox.selected, tmp.children_d[k]);
                    }
                }
            }
            return parent.load_node.apply(this, arguments);
        };
        this.get_state = function() {
            var state = parent.get_state.apply(this, arguments);
            if (this.settings.checkbox.tie_selection) return state;
            state.checkbox = this._data.checkbox.selected.slice();
            return state;
        };
        this.set_state = function(state, callback) {
            var res = parent.set_state.apply(this, arguments);
            if (res && state.checkbox) {
                if (!this.settings.checkbox.tie_selection) {
                    this.uncheck_all();
                    var _this = this;
                    $.each(state.checkbox, function(i, v) {
                        _this.check_node(v);
                    });
                }
                delete state.checkbox;
                this.set_state(state, callback);
                return false;
            }
            return res;
        };
        this.refresh = function(skip_loading, forget_state) {
            if (this.settings.checkbox.tie_selection) this._data.checkbox.selected = [];
            return parent.refresh.apply(this, arguments);
        };
    };
    // include the checkbox plugin by default
    // $.jstree.defaults.plugins.push("checkbox");
    /**
 * ### Conditionalselect plugin
 *
 * This plugin allows defining a callback to allow or deny node selection by user input (activate node method).
 */ /**
	 * a callback (function) which is invoked in the instance's scope and receives two arguments - the node and the event that triggered the `activate_node` call. Returning false prevents working with the node, returning true allows invoking activate_node. Defaults to returning `true`.
	 * @name $.jstree.defaults.checkbox.visible
	 * @plugin checkbox
	 */ $.jstree.defaults.conditionalselect = function() {
        return true;
    };
    $.jstree.plugins.conditionalselect = function(options, parent) {
        // own function
        this.activate_node = function(obj, e) {
            if (this.settings.conditionalselect.call(this, this.get_node(obj), e)) return parent.activate_node.call(this, obj, e);
        };
    };
    /**
 * ### Contextmenu plugin
 *
 * Shows a context menu when a node is right-clicked.
 */ /**
	 * stores all defaults for the contextmenu plugin
	 * @name $.jstree.defaults.contextmenu
	 * @plugin contextmenu
	 */ $.jstree.defaults.contextmenu = {
        /**
		 * a boolean indicating if the node should be selected when the context menu is invoked on it. Defaults to `true`.
		 * @name $.jstree.defaults.contextmenu.select_node
		 * @plugin contextmenu
		 */ select_node: true,
        /**
		 * a boolean indicating if the menu should be shown aligned with the node. Defaults to `true`, otherwise the mouse coordinates are used.
		 * @name $.jstree.defaults.contextmenu.show_at_node
		 * @plugin contextmenu
		 */ show_at_node: true,
        /**
		 * an object of actions, or a function that accepts a node and a callback function and calls the callback function with an object of actions available for that node (you can also return the items too).
		 *
		 * Each action consists of a key (a unique name) and a value which is an object with the following properties (only label and action are required). Once a menu item is activated the `action` function will be invoked with an object containing the following keys: item - the contextmenu item definition as seen below, reference - the DOM node that was used (the tree node), element - the contextmenu DOM element, position - an object with x/y properties indicating the position of the menu.
		 *
		 * * `separator_before` - a boolean indicating if there should be a separator before this item
		 * * `separator_after` - a boolean indicating if there should be a separator after this item
		 * * `_disabled` - a boolean indicating if this action should be disabled
		 * * `label` - a string - the name of the action (could be a function returning a string)
		 * * `title` - a string - an optional tooltip for the item
		 * * `action` - a function to be executed if this item is chosen, the function will receive 
		 * * `icon` - a string, can be a path to an icon or a className, if using an image that is in the current directory use a `./` prefix, otherwise it will be detected as a class
		 * * `shortcut` - keyCode which will trigger the action if the menu is open (for example `113` for rename, which equals F2)
		 * * `shortcut_label` - shortcut label (like for example `F2` for rename)
		 * * `submenu` - an object with the same structure as $.jstree.defaults.contextmenu.items which can be used to create a submenu - each key will be rendered as a separate option in a submenu that will appear once the current item is hovered
		 *
		 * @name $.jstree.defaults.contextmenu.items
		 * @plugin contextmenu
		 */ items: function(o, cb) {
            return {
                "create": {
                    "separator_before": false,
                    "separator_after": true,
                    "_disabled": false,
                    "label": "Create",
                    "action": function(data) {
                        var inst = $.jstree.reference(data.reference), obj = inst.get_node(data.reference);
                        inst.create_node(obj, {}, "last", function(new_node) {
                            try {
                                inst.edit(new_node);
                            } catch (ex) {
                                setTimeout(function() {
                                    inst.edit(new_node);
                                }, 0);
                            }
                        });
                    }
                },
                "rename": {
                    "separator_before": false,
                    "separator_after": false,
                    "_disabled": false,
                    "label": "Rename",
                    /*!
					"shortcut"			: 113,
					"shortcut_label"	: 'F2',
					"icon"				: "glyphicon glyphicon-leaf",
					*/ "action": function(data) {
                        var inst = $.jstree.reference(data.reference), obj = inst.get_node(data.reference);
                        inst.edit(obj);
                    }
                },
                "remove": {
                    "separator_before": false,
                    "icon": false,
                    "separator_after": false,
                    "_disabled": false,
                    "label": "Delete",
                    "action": function(data) {
                        var inst = $.jstree.reference(data.reference), obj = inst.get_node(data.reference);
                        if (inst.is_selected(obj)) inst.delete_node(inst.get_selected());
                        else inst.delete_node(obj);
                    }
                },
                "ccp": {
                    "separator_before": true,
                    "icon": false,
                    "separator_after": false,
                    "label": "Edit",
                    "action": false,
                    "submenu": {
                        "cut": {
                            "separator_before": false,
                            "separator_after": false,
                            "label": "Cut",
                            "action": function(data) {
                                var inst = $.jstree.reference(data.reference), obj = inst.get_node(data.reference);
                                if (inst.is_selected(obj)) inst.cut(inst.get_top_selected());
                                else inst.cut(obj);
                            }
                        },
                        "copy": {
                            "separator_before": false,
                            "icon": false,
                            "separator_after": false,
                            "label": "Copy",
                            "action": function(data) {
                                var inst = $.jstree.reference(data.reference), obj = inst.get_node(data.reference);
                                if (inst.is_selected(obj)) inst.copy(inst.get_top_selected());
                                else inst.copy(obj);
                            }
                        },
                        "paste": {
                            "separator_before": false,
                            "icon": false,
                            "_disabled": function(data) {
                                return !$.jstree.reference(data.reference).can_paste();
                            },
                            "separator_after": false,
                            "label": "Paste",
                            "action": function(data) {
                                var inst = $.jstree.reference(data.reference), obj = inst.get_node(data.reference);
                                inst.paste(obj);
                            }
                        }
                    }
                }
            };
        }
    };
    $.jstree.plugins.contextmenu = function(options, parent) {
        this.bind = function() {
            parent.bind.call(this);
            var last_ts = 0, cto = null, ex, ey;
            this.element.on("init.jstree loading.jstree ready.jstree", (function() {
                this.get_container_ul().addClass("jstree-contextmenu");
            }).bind(this)).on("contextmenu.jstree", ".jstree-anchor", (function(e, data) {
                if (e.target.tagName.toLowerCase() === "input") return;
                e.preventDefault();
                last_ts = e.ctrlKey ? +new Date() : 0;
                if (data || cto) last_ts = +new Date() + 10000;
                if (cto) clearTimeout(cto);
                if (!this.is_loading(e.currentTarget)) this.show_contextmenu(e.currentTarget, e.pageX, e.pageY, e);
            }).bind(this)).on("click.jstree", ".jstree-anchor", (function(e) {
                if (this._data.contextmenu.visible && (!last_ts || +new Date() - last_ts > 250)) $.vakata.context.hide();
                last_ts = 0;
            }).bind(this)).on("touchstart.jstree", ".jstree-anchor", function(e) {
                if (!e.originalEvent || !e.originalEvent.changedTouches || !e.originalEvent.changedTouches[0]) return;
                ex = e.originalEvent.changedTouches[0].clientX;
                ey = e.originalEvent.changedTouches[0].clientY;
                cto = setTimeout(function() {
                    $(e.currentTarget).trigger("contextmenu", true);
                }, 750);
            }).on("touchmove.vakata.jstree", function(e) {
                if (cto && e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches[0] && (Math.abs(ex - e.originalEvent.changedTouches[0].clientX) > 10 || Math.abs(ey - e.originalEvent.changedTouches[0].clientY) > 10)) {
                    clearTimeout(cto);
                    $.vakata.context.hide();
                }
            }).on("touchend.vakata.jstree", function(e) {
                if (cto) clearTimeout(cto);
            });
            /*!
			if(!('oncontextmenu' in document.body) && ('ontouchstart' in document.body)) {
				var el = null, tm = null;
				this.element
					.on("touchstart", ".jstree-anchor", function (e) {
						el = e.currentTarget;
						tm = +new Date();
						$(document).one("touchend", function (e) {
							e.target = document.elementFromPoint(e.originalEvent.targetTouches[0].pageX - window.pageXOffset, e.originalEvent.targetTouches[0].pageY - window.pageYOffset);
							e.currentTarget = e.target;
							tm = ((+(new Date())) - tm);
							if(e.target === el && tm > 600 && tm < 1000) {
								e.preventDefault();
								$(el).trigger('contextmenu', e);
							}
							el = null;
							tm = null;
						});
					});
			}
			*/ $(document).on("context_hide.vakata.jstree", (function(e, data) {
                this._data.contextmenu.visible = false;
                $(data.reference).removeClass("jstree-context");
            }).bind(this));
        };
        this.teardown = function() {
            if (this._data.contextmenu.visible) $.vakata.context.hide();
            $(document).off("context_hide.vakata.jstree");
            parent.teardown.call(this);
        };
        /**
		 * prepare and show the context menu for a node
		 * @name show_contextmenu(obj [, x, y])
		 * @param {mixed} obj the node
		 * @param {Number} x the x-coordinate relative to the document to show the menu at
		 * @param {Number} y the y-coordinate relative to the document to show the menu at
		 * @param {Object} e the event if available that triggered the contextmenu
		 * @plugin contextmenu
		 * @trigger show_contextmenu.jstree
		 */ this.show_contextmenu = function(obj, x, y, e) {
            obj = this.get_node(obj);
            if (!obj || obj.id === $.jstree.root) return false;
            var s = this.settings.contextmenu, d = this.get_node(obj, true), a = d.children(".jstree-anchor"), o = false, i = false;
            if (s.show_at_node || x === undefined || y === undefined) {
                o = a.offset();
                x = o.left;
                y = o.top + this._data.core.li_height;
            }
            if (this.settings.contextmenu.select_node && !this.is_selected(obj)) this.activate_node(obj, e);
            i = s.items;
            if ($.vakata.is_function(i)) i = i.call(this, obj, (function(i) {
                this._show_contextmenu(obj, x, y, i);
            }).bind(this));
            if ($.isPlainObject(i)) this._show_contextmenu(obj, x, y, i);
        };
        /**
		 * show the prepared context menu for a node
		 * @name _show_contextmenu(obj, x, y, i)
		 * @param {mixed} obj the node
		 * @param {Number} x the x-coordinate relative to the document to show the menu at
		 * @param {Number} y the y-coordinate relative to the document to show the menu at
		 * @param {Number} i the object of items to show
		 * @plugin contextmenu
		 * @trigger show_contextmenu.jstree
		 * @private
		 */ this._show_contextmenu = function(obj, x, y, i) {
            var d = this.get_node(obj, true), a = d.children(".jstree-anchor");
            $(document).one("context_show.vakata.jstree", (function(e, data) {
                var cls = "jstree-contextmenu jstree-" + this.get_theme() + "-contextmenu";
                $(data.element).addClass(cls);
                a.addClass("jstree-context");
            }).bind(this));
            this._data.contextmenu.visible = true;
            $.vakata.context.show(a, {
                "x": x,
                "y": y
            }, i);
            /**
			 * triggered when the contextmenu is shown for a node
			 * @event
			 * @name show_contextmenu.jstree
			 * @param {Object} node the node
			 * @param {Number} x the x-coordinate of the menu relative to the document
			 * @param {Number} y the y-coordinate of the menu relative to the document
			 * @plugin contextmenu
			 */ this.trigger("show_contextmenu", {
                "node": obj,
                "x": x,
                "y": y
            });
        };
    };
    // contextmenu helper
    (function($) {
        var right_to_left = false, vakata_context = {
            element: false,
            reference: false,
            position_x: 0,
            position_y: 0,
            items: [],
            html: "",
            is_visible: false
        };
        $.vakata.context = {
            settings: {
                hide_onmouseleave: 0,
                icons: true
            },
            _trigger: function(event_name) {
                $(document).triggerHandler("context_" + event_name + ".vakata", {
                    "reference": vakata_context.reference,
                    "element": vakata_context.element,
                    "position": {
                        "x": vakata_context.position_x,
                        "y": vakata_context.position_y
                    }
                });
            },
            _execute: function(i) {
                i = vakata_context.items[i];
                return i && (!i._disabled || $.vakata.is_function(i._disabled) && !i._disabled({
                    "item": i,
                    "reference": vakata_context.reference,
                    "element": vakata_context.element
                })) && i.action ? i.action.call(null, {
                    "item": i,
                    "reference": vakata_context.reference,
                    "element": vakata_context.element,
                    "position": {
                        "x": vakata_context.position_x,
                        "y": vakata_context.position_y
                    }
                }) : false;
            },
            _parse: function(o, is_callback) {
                if (!o) return false;
                if (!is_callback) {
                    vakata_context.html = "";
                    vakata_context.items = [];
                }
                var str = "", sep = false, tmp;
                if (is_callback) str += "<ul>";
                $.each(o, function(i, val) {
                    if (!val) return true;
                    vakata_context.items.push(val);
                    if (!sep && val.separator_before) str += "<li class='vakata-context-separator'><a href='#' " + ($.vakata.context.settings.icons ? "" : 'class="vakata-context-no-icons"') + ">&#160;<" + "/a><" + "/li>";
                    sep = false;
                    str += "<li class='" + (val._class || "") + (val._disabled === true || $.vakata.is_function(val._disabled) && val._disabled({
                        "item": val,
                        "reference": vakata_context.reference,
                        "element": vakata_context.element
                    }) ? " vakata-contextmenu-disabled " : "") + "' " + (val.shortcut ? " data-shortcut='" + val.shortcut + "' " : "") + ">";
                    str += "<a href='#' rel='" + (vakata_context.items.length - 1) + "' " + (val.title ? "title='" + val.title + "'" : "") + ">";
                    if ($.vakata.context.settings.icons) {
                        str += "<i ";
                        if (val.icon) {
                            if (val.icon.indexOf("/") !== -1 || val.icon.indexOf(".") !== -1) str += " style='background:url(\"" + val.icon + "\") center center no-repeat' ";
                            else str += " class='" + val.icon + "' ";
                        }
                        str += "></i><span class='vakata-contextmenu-sep'>&#160;</span>";
                    }
                    str += ($.vakata.is_function(val.label) ? val.label({
                        "item": i,
                        "reference": vakata_context.reference,
                        "element": vakata_context.element
                    }) : val.label) + (val.shortcut ? ' <span class="vakata-contextmenu-shortcut vakata-contextmenu-shortcut-' + val.shortcut + '">' + (val.shortcut_label || "") + "</span>" : "") + "<" + "/a>";
                    if (val.submenu) {
                        tmp = $.vakata.context._parse(val.submenu, true);
                        if (tmp) str += tmp;
                    }
                    str += "</li>";
                    if (val.separator_after) {
                        str += "<li class='vakata-context-separator'><a href='#' " + ($.vakata.context.settings.icons ? "" : 'class="vakata-context-no-icons"') + ">&#160;<" + "/a><" + "/li>";
                        sep = true;
                    }
                });
                str = str.replace(/<li class\='vakata-context-separator'\><\/li\>$/, "");
                if (is_callback) str += "</ul>";
                /**
				 * triggered on the document when the contextmenu is parsed (HTML is built)
				 * @event
				 * @plugin contextmenu
				 * @name context_parse.vakata
				 * @param {jQuery} reference the element that was right clicked
				 * @param {jQuery} element the DOM element of the menu itself
				 * @param {Object} position the x & y coordinates of the menu
				 */ if (!is_callback) {
                    vakata_context.html = str;
                    $.vakata.context._trigger("parse");
                }
                return str.length > 10 ? str : false;
            },
            _show_submenu: function(o) {
                o = $(o);
                if (!o.length || !o.children("ul").length) return;
                var e = o.children("ul"), xl = o.offset().left, x = xl + o.outerWidth(), y = o.offset().top, w = e.width(), h = e.height(), dw = $(window).width() + $(window).scrollLeft(), dh = $(window).height() + $(window).scrollTop();
                // може да се спести е една проверка - дали няма някой от класовете вече нагоре
                if (right_to_left) o[x - (w + 10 + o.outerWidth()) < 0 ? "addClass" : "removeClass"]("vakata-context-left");
                else o[x + w > dw && xl > dw - x ? "addClass" : "removeClass"]("vakata-context-right");
                if (y + h + 10 > dh) e.css("bottom", "-1px");
                //if does not fit - stick it to the side
                if (o.hasClass("vakata-context-right")) {
                    if (xl < w) e.css("margin-right", xl - w);
                } else if (dw - x < w) e.css("margin-left", dw - x - w);
                e.show();
            },
            show: function(reference, position, data) {
                var o, e, x, y, w, h, dw, dh, cond = true;
                if (vakata_context.element && vakata_context.element.length) vakata_context.element.width("");
                switch(cond){
                    case !position && !reference:
                        return false;
                    case !!position && !!reference:
                        vakata_context.reference = reference;
                        vakata_context.position_x = position.x;
                        vakata_context.position_y = position.y;
                        break;
                    case !position && !!reference:
                        vakata_context.reference = reference;
                        o = reference.offset();
                        vakata_context.position_x = o.left + reference.outerHeight();
                        vakata_context.position_y = o.top;
                        break;
                    case !!position && !reference:
                        vakata_context.position_x = position.x;
                        vakata_context.position_y = position.y;
                        break;
                }
                if (!!reference && !data && $(reference).data("vakata_contextmenu")) data = $(reference).data("vakata_contextmenu");
                if ($.vakata.context._parse(data)) vakata_context.element.html(vakata_context.html);
                if (vakata_context.items.length) {
                    vakata_context.element.appendTo(document.body);
                    e = vakata_context.element;
                    x = vakata_context.position_x;
                    y = vakata_context.position_y;
                    w = e.width();
                    h = e.height();
                    dw = $(window).width() + $(window).scrollLeft();
                    dh = $(window).height() + $(window).scrollTop();
                    if (right_to_left) {
                        x -= e.outerWidth() - $(reference).outerWidth();
                        if (x < $(window).scrollLeft() + 20) x = $(window).scrollLeft() + 20;
                    }
                    if (x + w + 20 > dw) x = dw - (w + 20);
                    if (y + h + 20 > dh) y = dh - (h + 20);
                    vakata_context.element.css({
                        "left": x,
                        "top": y
                    }).show().find("a").first().trigger("focus").parent().addClass("vakata-context-hover");
                    vakata_context.is_visible = true;
                    /**
					 * triggered on the document when the contextmenu is shown
					 * @event
					 * @plugin contextmenu
					 * @name context_show.vakata
					 * @param {jQuery} reference the element that was right clicked
					 * @param {jQuery} element the DOM element of the menu itself
					 * @param {Object} position the x & y coordinates of the menu
					 */ $.vakata.context._trigger("show");
                }
            },
            hide: function() {
                if (vakata_context.is_visible) {
                    vakata_context.element.hide().find("ul").hide().end().find(":focus").trigger("blur").end().detach();
                    vakata_context.is_visible = false;
                    /**
					 * triggered on the document when the contextmenu is hidden
					 * @event
					 * @plugin contextmenu
					 * @name context_hide.vakata
					 * @param {jQuery} reference the element that was right clicked
					 * @param {jQuery} element the DOM element of the menu itself
					 * @param {Object} position the x & y coordinates of the menu
					 */ $.vakata.context._trigger("hide");
                }
            }
        };
        $(function() {
            right_to_left = $(document.body).css("direction") === "rtl";
            var to = false;
            vakata_context.element = $("<ul class='vakata-context'></ul>");
            vakata_context.element.on("mouseenter", "li", function(e) {
                e.stopImmediatePropagation();
                if ($.contains(this, e.relatedTarget)) // премахнато заради delegate mouseleave по-долу
                // $(this).find(".vakata-context-hover").removeClass("vakata-context-hover");
                return;
                if (to) clearTimeout(to);
                vakata_context.element.find(".vakata-context-hover").removeClass("vakata-context-hover").end();
                $(this).siblings().find("ul").hide().end().end().parentsUntil(".vakata-context", "li").addBack().addClass("vakata-context-hover");
                $.vakata.context._show_submenu(this);
            })// тестово - дали не натоварва?
            .on("mouseleave", "li", function(e) {
                if ($.contains(this, e.relatedTarget)) return;
                $(this).find(".vakata-context-hover").addBack().removeClass("vakata-context-hover");
            }).on("mouseleave", function(e) {
                $(this).find(".vakata-context-hover").removeClass("vakata-context-hover");
                if ($.vakata.context.settings.hide_onmouseleave) to = setTimeout(function(t) {
                    return function() {
                        $.vakata.context.hide();
                    };
                }(this), $.vakata.context.settings.hide_onmouseleave);
            }).on("click", "a", function(e) {
                e.preventDefault();
                //})
                //.on("mouseup", "a", function (e) {
                if (!$(this).trigger("blur").parent().hasClass("vakata-context-disabled") && $.vakata.context._execute($(this).attr("rel")) !== false) $.vakata.context.hide();
            }).on("keydown", "a", function(e) {
                var o = null;
                switch(e.which){
                    case 13:
                    case 32:
                        e.type = "click";
                        e.preventDefault();
                        $(e.currentTarget).trigger(e);
                        break;
                    case 37:
                        if (vakata_context.is_visible) {
                            vakata_context.element.find(".vakata-context-hover").last().closest("li").first().find("ul").hide().find(".vakata-context-hover").removeClass("vakata-context-hover").end().end().children("a").trigger("focus");
                            e.stopImmediatePropagation();
                            e.preventDefault();
                        }
                        break;
                    case 38:
                        if (vakata_context.is_visible) {
                            o = vakata_context.element.find("ul:visible").addBack().last().children(".vakata-context-hover").removeClass("vakata-context-hover").prevAll("li:not(.vakata-context-separator)").first();
                            if (!o.length) o = vakata_context.element.find("ul:visible").addBack().last().children("li:not(.vakata-context-separator)").last();
                            o.addClass("vakata-context-hover").children("a").trigger("focus");
                            e.stopImmediatePropagation();
                            e.preventDefault();
                        }
                        break;
                    case 39:
                        if (vakata_context.is_visible) {
                            vakata_context.element.find(".vakata-context-hover").last().children("ul").show().children("li:not(.vakata-context-separator)").removeClass("vakata-context-hover").first().addClass("vakata-context-hover").children("a").trigger("focus");
                            e.stopImmediatePropagation();
                            e.preventDefault();
                        }
                        break;
                    case 40:
                        if (vakata_context.is_visible) {
                            o = vakata_context.element.find("ul:visible").addBack().last().children(".vakata-context-hover").removeClass("vakata-context-hover").nextAll("li:not(.vakata-context-separator)").first();
                            if (!o.length) o = vakata_context.element.find("ul:visible").addBack().last().children("li:not(.vakata-context-separator)").first();
                            o.addClass("vakata-context-hover").children("a").trigger("focus");
                            e.stopImmediatePropagation();
                            e.preventDefault();
                        }
                        break;
                    case 27:
                        $.vakata.context.hide();
                        e.preventDefault();
                        break;
                    default:
                        break;
                }
            }).on("keydown", function(e) {
                e.preventDefault();
                var a = vakata_context.element.find(".vakata-contextmenu-shortcut-" + e.which).parent();
                if (a.parent().not(".vakata-context-disabled")) a.trigger("click");
            });
            $(document).on("mousedown.vakata.jstree", function(e) {
                if (vakata_context.is_visible && vakata_context.element[0] !== e.target && !$.contains(vakata_context.element[0], e.target)) $.vakata.context.hide();
            }).on("context_show.vakata.jstree", function(e, data) {
                vakata_context.element.find("li:has(ul)").children("a").addClass("vakata-context-parent");
                if (right_to_left) vakata_context.element.addClass("vakata-context-rtl").css("direction", "rtl");
                // also apply a RTL class?
                vakata_context.element.find("ul").hide().end();
            });
        });
    })($);
    // $.jstree.defaults.plugins.push("contextmenu");
    /**
 * ### Drag'n'drop plugin
 *
 * Enables dragging and dropping of nodes in the tree, resulting in a move or copy operations.
 */ /**
	 * stores all defaults for the drag'n'drop plugin
	 * @name $.jstree.defaults.dnd
	 * @plugin dnd
	 */ $.jstree.defaults.dnd = {
        /**
		 * a boolean indicating if a copy should be possible while dragging (by pressint the meta key or Ctrl). Defaults to `true`.
		 * @name $.jstree.defaults.dnd.copy
		 * @plugin dnd
		 */ copy: true,
        /**
		 * a number indicating how long a node should remain hovered while dragging to be opened. Defaults to `500`.
		 * @name $.jstree.defaults.dnd.open_timeout
		 * @plugin dnd
		 */ open_timeout: 500,
        /**
		 * a function invoked each time a node is about to be dragged, invoked in the tree's scope and receives the nodes about to be dragged as an argument (array) and the event that started the drag - return `false` to prevent dragging
		 * @name $.jstree.defaults.dnd.is_draggable
		 * @plugin dnd
		 */ is_draggable: true,
        /**
		 * a boolean indicating if checks should constantly be made while the user is dragging the node (as opposed to checking only on drop), default is `true`
		 * @name $.jstree.defaults.dnd.check_while_dragging
		 * @plugin dnd
		 */ check_while_dragging: true,
        /**
		 * a boolean indicating if nodes from this tree should only be copied with dnd (as opposed to moved), default is `false`
		 * @name $.jstree.defaults.dnd.always_copy
		 * @plugin dnd
		 */ always_copy: false,
        /**
		 * when dropping a node "inside", this setting indicates the position the node should go to - it can be an integer or a string: "first" (same as 0) or "last", default is `0`
		 * @name $.jstree.defaults.dnd.inside_pos
		 * @plugin dnd
		 */ inside_pos: 0,
        /**
		 * when starting the drag on a node that is selected this setting controls if all selected nodes are dragged or only the single node, default is `true`, which means all selected nodes are dragged when the drag is started on a selected node
		 * @name $.jstree.defaults.dnd.drag_selection
		 * @plugin dnd
		 */ drag_selection: true,
        /**
		 * controls whether dnd works on touch devices. If left as boolean true dnd will work the same as in desktop browsers, which in some cases may impair scrolling. If set to boolean false dnd will not work on touch devices. There is a special third option - string "selected" which means only selected nodes can be dragged on touch devices.
		 * @name $.jstree.defaults.dnd.touch
		 * @plugin dnd
		 */ touch: true,
        /**
		 * controls whether items can be dropped anywhere on the node, not just on the anchor, by default only the node anchor is a valid drop target. Works best with the wholerow plugin. If enabled on mobile depending on the interface it might be hard for the user to cancel the drop, since the whole tree container will be a valid drop target.
		 * @name $.jstree.defaults.dnd.large_drop_target
		 * @plugin dnd
		 */ large_drop_target: false,
        /**
		 * controls whether a drag can be initiated from any part of the node and not just the text/icon part, works best with the wholerow plugin. Keep in mind it can cause problems with tree scrolling on mobile depending on the interface - in that case set the touch option to "selected".
		 * @name $.jstree.defaults.dnd.large_drag_target
		 * @plugin dnd
		 */ large_drag_target: false,
        /**
		 * controls whether use HTML5 dnd api instead of classical. That will allow better integration of dnd events with other HTML5 controls.
		 * @reference http://caniuse.com/#feat=dragndrop
		 * @name $.jstree.defaults.dnd.use_html5
		 * @plugin dnd
		 */ use_html5: false,
        /**
		 * controls whether items can be dropped anywhere on the tree.
		 * @name $.jstree.defaults.dnd.blank_space_drop
		 * @plugin dnd
		 */ blank_space_drop: false
    };
    var drg, elm;
    // TODO: now check works by checking for each node individually, how about max_children, unique, etc?
    $.jstree.plugins.dnd = function(options, parent) {
        this.init = function(el, options) {
            parent.init.call(this, el, options);
            this.settings.dnd.use_html5 = this.settings.dnd.use_html5 && "draggable" in document.createElement("span");
        };
        this.bind = function() {
            parent.bind.call(this);
            this.element.on(this.settings.dnd.use_html5 ? "dragstart.jstree" : "mousedown.jstree touchstart.jstree", this.settings.dnd.large_drag_target ? ".jstree-node" : ".jstree-anchor", (function(e) {
                if (this.settings.dnd.large_drag_target && $(e.target).closest(".jstree-node")[0] !== e.currentTarget) return true;
                if (e.type === "touchstart" && (!this.settings.dnd.touch || this.settings.dnd.touch === "selected" && !$(e.currentTarget).closest(".jstree-node").children(".jstree-anchor").hasClass("jstree-clicked"))) return true;
                var obj = this.get_node(e.target), mlt = this.is_selected(obj) && this.settings.dnd.drag_selection ? this.get_top_selected().length : 1, txt = mlt > 1 ? mlt + " " + this.get_string("nodes") : this.get_text(e.currentTarget);
                if (this.settings.core.force_text) txt = $.vakata.html.escape(txt);
                if (obj && (obj.id || obj.id === 0) && obj.id !== $.jstree.root && (e.which === 1 || e.type === "touchstart" || e.type === "dragstart") && (this.settings.dnd.is_draggable === true || $.vakata.is_function(this.settings.dnd.is_draggable) && this.settings.dnd.is_draggable.call(this, mlt > 1 ? this.get_top_selected(true) : [
                    obj
                ], e))) {
                    drg = {
                        "jstree": true,
                        "origin": this,
                        "obj": this.get_node(obj, true),
                        "nodes": mlt > 1 ? this.get_top_selected() : [
                            obj.id
                        ]
                    };
                    elm = e.currentTarget;
                    if (this.settings.dnd.use_html5) $.vakata.dnd._trigger("start", e, {
                        "helper": $(),
                        "element": elm,
                        "data": drg
                    });
                    else {
                        this.element.trigger("mousedown.jstree");
                        return $.vakata.dnd.start(e, drg, '<div id="jstree-dnd" class="jstree-' + this.get_theme() + " jstree-" + this.get_theme() + "-" + this.get_theme_variant() + " " + (this.settings.core.themes.responsive ? " jstree-dnd-responsive" : "") + '"><i class="jstree-icon jstree-er"></i>' + txt + '<ins class="jstree-copy">+</ins></div>');
                    }
                }
            }).bind(this));
            if (this.settings.dnd.use_html5) this.element.on("dragover.jstree", function(e) {
                e.preventDefault();
                $.vakata.dnd._trigger("move", e, {
                    "helper": $(),
                    "element": elm,
                    "data": drg
                });
                return false;
            })//.on('dragenter.jstree', this.settings.dnd.large_drop_target ? '.jstree-node' : '.jstree-anchor', $.proxy(function (e) {
            //		e.preventDefault();
            //		$.vakata.dnd._trigger('move', e, { 'helper': $(), 'element': elm, 'data': drg });
            //		return false;
            //	}, this))
            .on("drop.jstree", (function(e) {
                e.preventDefault();
                $.vakata.dnd._trigger("stop", e, {
                    "helper": $(),
                    "element": elm,
                    "data": drg
                });
                return false;
            }).bind(this));
        };
        this.redraw_node = function(obj, deep, callback, force_render) {
            obj = parent.redraw_node.apply(this, arguments);
            if (obj && this.settings.dnd.use_html5) {
                if (this.settings.dnd.large_drag_target) obj.setAttribute("draggable", true);
                else {
                    var i, j, tmp = null;
                    for(i = 0, j = obj.childNodes.length; i < j; i++)if (obj.childNodes[i] && obj.childNodes[i].className && obj.childNodes[i].className.indexOf("jstree-anchor") !== -1) {
                        tmp = obj.childNodes[i];
                        break;
                    }
                    if (tmp) tmp.setAttribute("draggable", true);
                }
            }
            return obj;
        };
    };
    $(function() {
        // bind only once for all instances
        var lastmv = false, laster = false, lastev = false, opento = false, marker = $('<div id="jstree-marker">&#160;</div>').hide(); //.appendTo('body');
        $(document).on("dragover.vakata.jstree", function(e) {
            if (elm) $.vakata.dnd._trigger("move", e, {
                "helper": $(),
                "element": elm,
                "data": drg
            });
        }).on("drop.vakata.jstree", function(e) {
            if (elm) {
                $.vakata.dnd._trigger("stop", e, {
                    "helper": $(),
                    "element": elm,
                    "data": drg
                });
                elm = null;
                drg = null;
            }
        }).on("dnd_start.vakata.jstree", function(e, data) {
            lastmv = false;
            lastev = false;
            if (!data || !data.data || !data.data.jstree) return;
            marker.appendTo(document.body); //.show();
        }).on("dnd_move.vakata.jstree", function(e, data) {
            var isDifferentNode = data.event.target !== lastev.target;
            if (opento) {
                if (!data.event || data.event.type !== "dragover" || isDifferentNode) clearTimeout(opento);
            }
            if (!data || !data.data || !data.data.jstree) return;
            // if we are hovering the marker image do nothing (can happen on "inside" drags)
            if (data.event.target.id && data.event.target.id === "jstree-marker") return;
            lastev = data.event;
            var ins = $.jstree.reference(data.event.target), ref = false, off = false, rel = false, tmp, l, t, h, p, i, o, ok, t1, t2, op, ps, pr, ip, tm, is_copy, pn, c;
            // if we are over an instance
            if (ins && ins._data && ins._data.dnd) {
                marker.attr("class", "jstree-" + ins.get_theme() + (ins.settings.core.themes.responsive ? " jstree-dnd-responsive" : ""));
                is_copy = data.data.origin && (data.data.origin.settings.dnd.always_copy || data.data.origin.settings.dnd.copy && (data.event.metaKey || data.event.ctrlKey));
                data.helper.children().attr("class", "jstree-" + ins.get_theme() + " jstree-" + ins.get_theme() + "-" + ins.get_theme_variant() + " " + (ins.settings.core.themes.responsive ? " jstree-dnd-responsive" : "")).find(".jstree-copy").first()[is_copy ? "show" : "hide"]();
                // if are hovering the container itself add a new root node
                //console.log(data.event);
                if ((data.event.target === ins.element[0] || data.event.target === ins.get_container_ul()[0]) && (ins.get_container_ul().children().length === 0 || ins.settings.dnd.blank_space_drop)) {
                    ok = true;
                    for(t1 = 0, t2 = data.data.nodes.length; t1 < t2; t1++){
                        ok = ok && ins.check(data.data.origin && (data.data.origin.settings.dnd.always_copy || data.data.origin.settings.dnd.copy && (data.event.metaKey || data.event.ctrlKey)) ? "copy_node" : "move_node", data.data.origin && data.data.origin !== ins ? data.data.origin.get_node(data.data.nodes[t1]) : data.data.nodes[t1], $.jstree.root, "last", {
                            "dnd": true,
                            "ref": ins.get_node($.jstree.root),
                            "pos": "i",
                            "origin": data.data.origin,
                            "is_multi": data.data.origin && data.data.origin !== ins,
                            "is_foreign": !data.data.origin
                        });
                        if (!ok) break;
                    }
                    if (ok) {
                        lastmv = {
                            "ins": ins,
                            "par": $.jstree.root,
                            "pos": "last"
                        };
                        marker.hide();
                        data.helper.find(".jstree-icon").first().removeClass("jstree-er").addClass("jstree-ok");
                        if (data.event.originalEvent && data.event.originalEvent.dataTransfer) data.event.originalEvent.dataTransfer.dropEffect = is_copy ? "copy" : "move";
                        return;
                    }
                } else {
                    // if we are hovering a tree node
                    ref = ins.settings.dnd.large_drop_target ? $(data.event.target).closest(".jstree-node").children(".jstree-anchor") : $(data.event.target).closest(".jstree-anchor");
                    if (ref && ref.length && ref.parent().is(".jstree-closed, .jstree-open, .jstree-leaf")) {
                        off = ref.offset();
                        rel = (data.event.pageY !== undefined ? data.event.pageY : data.event.originalEvent.pageY) - off.top;
                        h = ref.outerHeight();
                        if (rel < h / 3) o = [
                            "b",
                            "i",
                            "a"
                        ];
                        else if (rel > h - h / 3) o = [
                            "a",
                            "i",
                            "b"
                        ];
                        else o = rel > h / 2 ? [
                            "i",
                            "a",
                            "b"
                        ] : [
                            "i",
                            "b",
                            "a"
                        ];
                        $.each(o, function(j, v) {
                            switch(v){
                                case "b":
                                    l = off.left - 6;
                                    t = off.top;
                                    p = ins.get_parent(ref);
                                    i = ref.parent().index();
                                    c = "jstree-below";
                                    break;
                                case "i":
                                    ip = ins.settings.dnd.inside_pos;
                                    tm = ins.get_node(ref.parent());
                                    l = off.left - 2;
                                    t = off.top + h / 2 + 1;
                                    p = tm.id;
                                    i = ip === "first" ? 0 : ip === "last" ? tm.children.length : Math.min(ip, tm.children.length);
                                    c = "jstree-inside";
                                    break;
                                case "a":
                                    l = off.left - 6;
                                    t = off.top + h;
                                    p = ins.get_parent(ref);
                                    i = ref.parent().index() + 1;
                                    c = "jstree-above";
                                    break;
                            }
                            ok = true;
                            for(t1 = 0, t2 = data.data.nodes.length; t1 < t2; t1++){
                                op = data.data.origin && (data.data.origin.settings.dnd.always_copy || data.data.origin.settings.dnd.copy && (data.event.metaKey || data.event.ctrlKey)) ? "copy_node" : "move_node";
                                ps = i;
                                if (op === "move_node" && v === "a" && data.data.origin && data.data.origin === ins && p === ins.get_parent(data.data.nodes[t1])) {
                                    pr = ins.get_node(p);
                                    if (ps > $.inArray(data.data.nodes[t1], pr.children)) ps -= 1;
                                }
                                ok = ok && (ins && ins.settings && ins.settings.dnd && ins.settings.dnd.check_while_dragging === false || ins.check(op, data.data.origin && data.data.origin !== ins ? data.data.origin.get_node(data.data.nodes[t1]) : data.data.nodes[t1], p, ps, {
                                    "dnd": true,
                                    "ref": ins.get_node(ref.parent()),
                                    "pos": v,
                                    "origin": data.data.origin,
                                    "is_multi": data.data.origin && data.data.origin !== ins,
                                    "is_foreign": !data.data.origin
                                }));
                                if (!ok) {
                                    if (ins && ins.last_error) laster = ins.last_error();
                                    break;
                                }
                            }
                            if (v === "i" && ref.parent().is(".jstree-closed") && ins.settings.dnd.open_timeout) {
                                if (!data.event || data.event.type !== "dragover" || isDifferentNode) {
                                    if (opento) clearTimeout(opento);
                                    opento = setTimeout(function(x, z) {
                                        return function() {
                                            x.open_node(z);
                                        };
                                    }(ins, ref), ins.settings.dnd.open_timeout);
                                }
                            }
                            if (ok) {
                                pn = ins.get_node(p, true);
                                if (!pn.hasClass(".jstree-dnd-parent")) {
                                    $(".jstree-dnd-parent").removeClass("jstree-dnd-parent");
                                    pn.addClass("jstree-dnd-parent");
                                }
                                lastmv = {
                                    "ins": ins,
                                    "par": p,
                                    "pos": v === "i" && ip === "last" && i === 0 && !ins.is_loaded(tm) ? "last" : i
                                };
                                marker.css({
                                    "left": l + "px",
                                    "top": t + "px"
                                }).show();
                                marker.removeClass("jstree-above jstree-inside jstree-below").addClass(c);
                                data.helper.find(".jstree-icon").first().removeClass("jstree-er").addClass("jstree-ok");
                                if (data.event.originalEvent && data.event.originalEvent.dataTransfer) data.event.originalEvent.dataTransfer.dropEffect = is_copy ? "copy" : "move";
                                laster = {};
                                o = true;
                                return false;
                            }
                        });
                        if (o === true) return;
                    }
                }
            }
            $(".jstree-dnd-parent").removeClass("jstree-dnd-parent");
            lastmv = false;
            data.helper.find(".jstree-icon").removeClass("jstree-ok").addClass("jstree-er");
            data.event.originalEvent && data.event.originalEvent.dataTransfer;
            marker.hide();
        }).on("dnd_scroll.vakata.jstree", function(e, data) {
            if (!data || !data.data || !data.data.jstree) return;
            marker.hide();
            lastmv = false;
            lastev = false;
            data.helper.find(".jstree-icon").first().removeClass("jstree-ok").addClass("jstree-er");
        }).on("dnd_stop.vakata.jstree", function(e, data) {
            $(".jstree-dnd-parent").removeClass("jstree-dnd-parent");
            if (opento) clearTimeout(opento);
            if (!data || !data.data || !data.data.jstree) return;
            marker.hide().detach();
            var i, j, nodes = [];
            if (lastmv) {
                for(i = 0, j = data.data.nodes.length; i < j; i++)nodes[i] = data.data.origin ? data.data.origin.get_node(data.data.nodes[i]) : data.data.nodes[i];
                lastmv.ins[data.data.origin && (data.data.origin.settings.dnd.always_copy || data.data.origin.settings.dnd.copy && (data.event.metaKey || data.event.ctrlKey)) ? "copy_node" : "move_node"](nodes, lastmv.par, lastmv.pos, false, false, false, data.data.origin);
            } else {
                i = $(data.event.target).closest(".jstree");
                if (i.length && laster && laster.error && laster.error === "check") {
                    i = i.jstree(true);
                    if (i) i.settings.core.error.call(this, laster);
                }
            }
            lastev = false;
            lastmv = false;
        }).on("keyup.jstree keydown.jstree", function(e, data) {
            data = $.vakata.dnd._get();
            if (data && data.data && data.data.jstree) {
                if (e.type === "keyup" && e.which === 27) {
                    if (opento) clearTimeout(opento);
                    lastmv = false;
                    laster = false;
                    lastev = false;
                    opento = false;
                    marker.hide().detach();
                    $.vakata.dnd._clean();
                } else {
                    data.helper.find(".jstree-copy").first()[data.data.origin && (data.data.origin.settings.dnd.always_copy || data.data.origin.settings.dnd.copy && (e.metaKey || e.ctrlKey)) ? "show" : "hide"]();
                    if (lastev) {
                        lastev.metaKey = e.metaKey;
                        lastev.ctrlKey = e.ctrlKey;
                        $.vakata.dnd._trigger("move", lastev);
                    }
                }
            }
        });
    });
    // helpers
    (function($) {
        $.vakata.html = {
            div: $("<div></div>"),
            escape: function(str) {
                return $.vakata.html.div.text(str).html();
            },
            strip: function(str) {
                return $.vakata.html.div.empty().append($.parseHTML(str)).text();
            }
        };
        // private variable
        var vakata_dnd = {
            element: false,
            target: false,
            is_down: false,
            is_drag: false,
            helper: false,
            helper_w: 0,
            data: false,
            init_x: 0,
            init_y: 0,
            scroll_l: 0,
            scroll_t: 0,
            scroll_e: false,
            scroll_i: false,
            is_touch: false
        };
        $.vakata.dnd = {
            settings: {
                scroll_speed: 10,
                scroll_proximity: 20,
                helper_left: 5,
                helper_top: 10,
                threshold: 5,
                threshold_touch: 10
            },
            _trigger: function(event_name, e, data) {
                if (data === undefined) data = $.vakata.dnd._get();
                data.event = e;
                $(document).triggerHandler("dnd_" + event_name + ".vakata", data);
            },
            _get: function() {
                return {
                    "data": vakata_dnd.data,
                    "element": vakata_dnd.element,
                    "helper": vakata_dnd.helper
                };
            },
            _clean: function() {
                if (vakata_dnd.helper) vakata_dnd.helper.remove();
                if (vakata_dnd.scroll_i) {
                    clearInterval(vakata_dnd.scroll_i);
                    vakata_dnd.scroll_i = false;
                }
                vakata_dnd = {
                    element: false,
                    target: false,
                    is_down: false,
                    is_drag: false,
                    helper: false,
                    helper_w: 0,
                    data: false,
                    init_x: 0,
                    init_y: 0,
                    scroll_l: 0,
                    scroll_t: 0,
                    scroll_e: false,
                    scroll_i: false,
                    is_touch: false
                };
                elm = null;
                $(document).off("mousemove.vakata.jstree touchmove.vakata.jstree", $.vakata.dnd.drag);
                $(document).off("mouseup.vakata.jstree touchend.vakata.jstree", $.vakata.dnd.stop);
            },
            _scroll: function(init_only) {
                if (!vakata_dnd.scroll_e || !vakata_dnd.scroll_l && !vakata_dnd.scroll_t) {
                    if (vakata_dnd.scroll_i) {
                        clearInterval(vakata_dnd.scroll_i);
                        vakata_dnd.scroll_i = false;
                    }
                    return false;
                }
                if (!vakata_dnd.scroll_i) {
                    vakata_dnd.scroll_i = setInterval($.vakata.dnd._scroll, 100);
                    return false;
                }
                if (init_only === true) return false;
                var i = vakata_dnd.scroll_e.scrollTop(), j = vakata_dnd.scroll_e.scrollLeft();
                vakata_dnd.scroll_e.scrollTop(i + vakata_dnd.scroll_t * $.vakata.dnd.settings.scroll_speed);
                vakata_dnd.scroll_e.scrollLeft(j + vakata_dnd.scroll_l * $.vakata.dnd.settings.scroll_speed);
                if (i !== vakata_dnd.scroll_e.scrollTop() || j !== vakata_dnd.scroll_e.scrollLeft()) /**
					 * triggered on the document when a drag causes an element to scroll
					 * @event
					 * @plugin dnd
					 * @name dnd_scroll.vakata
					 * @param {Mixed} data any data supplied with the call to $.vakata.dnd.start
					 * @param {DOM} element the DOM element being dragged
					 * @param {jQuery} helper the helper shown next to the mouse
					 * @param {jQuery} event the element that is scrolling
					 */ $.vakata.dnd._trigger("scroll", vakata_dnd.scroll_e);
            },
            start: function(e, data, html) {
                if (e.type === "touchstart" && e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches[0]) {
                    e.pageX = e.originalEvent.changedTouches[0].pageX;
                    e.pageY = e.originalEvent.changedTouches[0].pageY;
                    e.target = document.elementFromPoint(e.originalEvent.changedTouches[0].pageX - window.pageXOffset, e.originalEvent.changedTouches[0].pageY - window.pageYOffset);
                }
                if (vakata_dnd.is_drag) $.vakata.dnd.stop({});
                try {
                    e.currentTarget.unselectable = "on";
                    e.currentTarget.onselectstart = function() {
                        return false;
                    };
                    if (e.currentTarget.style) {
                        e.currentTarget.style.touchAction = "none";
                        e.currentTarget.style.msTouchAction = "none";
                        e.currentTarget.style.MozUserSelect = "none";
                    }
                } catch (ignore) {}
                vakata_dnd.init_x = e.pageX;
                vakata_dnd.init_y = e.pageY;
                vakata_dnd.data = data;
                vakata_dnd.is_down = true;
                vakata_dnd.element = e.currentTarget;
                vakata_dnd.target = e.target;
                vakata_dnd.is_touch = e.type === "touchstart";
                if (html !== false) vakata_dnd.helper = $("<div id='vakata-dnd'></div>").html(html).css({
                    "display": "block",
                    "margin": "0",
                    "padding": "0",
                    "position": "absolute",
                    "top": "-2000px",
                    "lineHeight": "16px",
                    "zIndex": "10000"
                });
                $(document).on("mousemove.vakata.jstree touchmove.vakata.jstree", $.vakata.dnd.drag);
                $(document).on("mouseup.vakata.jstree touchend.vakata.jstree", $.vakata.dnd.stop);
                return false;
            },
            drag: function(e) {
                if (e.type === "touchmove" && e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches[0]) {
                    e.pageX = e.originalEvent.changedTouches[0].pageX;
                    e.pageY = e.originalEvent.changedTouches[0].pageY;
                    e.target = document.elementFromPoint(e.originalEvent.changedTouches[0].pageX - window.pageXOffset, e.originalEvent.changedTouches[0].pageY - window.pageYOffset);
                }
                if (!vakata_dnd.is_down) return;
                if (!vakata_dnd.is_drag) {
                    if (Math.abs(e.pageX - vakata_dnd.init_x) > (vakata_dnd.is_touch ? $.vakata.dnd.settings.threshold_touch : $.vakata.dnd.settings.threshold) || Math.abs(e.pageY - vakata_dnd.init_y) > (vakata_dnd.is_touch ? $.vakata.dnd.settings.threshold_touch : $.vakata.dnd.settings.threshold)) {
                        if (vakata_dnd.helper) {
                            vakata_dnd.helper.appendTo(document.body);
                            vakata_dnd.helper_w = vakata_dnd.helper.outerWidth();
                        }
                        vakata_dnd.is_drag = true;
                        $(vakata_dnd.target).one("click.vakata", false);
                        /**
						 * triggered on the document when a drag starts
						 * @event
						 * @plugin dnd
						 * @name dnd_start.vakata
						 * @param {Mixed} data any data supplied with the call to $.vakata.dnd.start
						 * @param {DOM} element the DOM element being dragged
						 * @param {jQuery} helper the helper shown next to the mouse
						 * @param {Object} event the event that caused the start (probably mousemove)
						 */ $.vakata.dnd._trigger("start", e);
                    } else return;
                }
                var d = false, w = false, dh = false, wh = false, dw = false, ww = false, dt = false, dl = false, ht = false, hl = false;
                vakata_dnd.scroll_t = 0;
                vakata_dnd.scroll_l = 0;
                vakata_dnd.scroll_e = false;
                $($(e.target).parentsUntil("body").addBack().get().reverse()).filter(function() {
                    return this.ownerDocument && /^auto|scroll$/.test($(this).css("overflow")) && (this.scrollHeight > this.offsetHeight || this.scrollWidth > this.offsetWidth);
                }).each(function() {
                    var t = $(this), o = t.offset();
                    if (this.scrollHeight > this.offsetHeight) {
                        if (o.top + t.height() - e.pageY < $.vakata.dnd.settings.scroll_proximity) vakata_dnd.scroll_t = 1;
                        if (e.pageY - o.top < $.vakata.dnd.settings.scroll_proximity) vakata_dnd.scroll_t = -1;
                    }
                    if (this.scrollWidth > this.offsetWidth) {
                        if (o.left + t.width() - e.pageX < $.vakata.dnd.settings.scroll_proximity) vakata_dnd.scroll_l = 1;
                        if (e.pageX - o.left < $.vakata.dnd.settings.scroll_proximity) vakata_dnd.scroll_l = -1;
                    }
                    if (vakata_dnd.scroll_t || vakata_dnd.scroll_l) {
                        vakata_dnd.scroll_e = $(this);
                        return false;
                    }
                });
                if (!vakata_dnd.scroll_e) {
                    d = $(document);
                    w = $(window);
                    dh = d.height();
                    wh = w.height();
                    dw = d.width();
                    ww = w.width();
                    dt = d.scrollTop();
                    dl = d.scrollLeft();
                    if (dh > wh && e.pageY - dt < $.vakata.dnd.settings.scroll_proximity) vakata_dnd.scroll_t = -1;
                    if (dh > wh && wh - (e.pageY - dt) < $.vakata.dnd.settings.scroll_proximity) vakata_dnd.scroll_t = 1;
                    if (dw > ww && e.pageX - dl < $.vakata.dnd.settings.scroll_proximity) vakata_dnd.scroll_l = -1;
                    if (dw > ww && ww - (e.pageX - dl) < $.vakata.dnd.settings.scroll_proximity) vakata_dnd.scroll_l = 1;
                    if (vakata_dnd.scroll_t || vakata_dnd.scroll_l) vakata_dnd.scroll_e = d;
                }
                if (vakata_dnd.scroll_e) $.vakata.dnd._scroll(true);
                if (vakata_dnd.helper) {
                    ht = parseInt(e.pageY + $.vakata.dnd.settings.helper_top, 10);
                    hl = parseInt(e.pageX + $.vakata.dnd.settings.helper_left, 10);
                    if (dh && ht + 25 > dh) ht = dh - 50;
                    if (dw && hl + vakata_dnd.helper_w > dw) hl = dw - (vakata_dnd.helper_w + 2);
                    vakata_dnd.helper.css({
                        left: hl + "px",
                        top: ht + "px"
                    });
                }
                /**
				 * triggered on the document when a drag is in progress
				 * @event
				 * @plugin dnd
				 * @name dnd_move.vakata
				 * @param {Mixed} data any data supplied with the call to $.vakata.dnd.start
				 * @param {DOM} element the DOM element being dragged
				 * @param {jQuery} helper the helper shown next to the mouse
				 * @param {Object} event the event that caused this to trigger (most likely mousemove)
				 */ $.vakata.dnd._trigger("move", e);
                return false;
            },
            stop: function(e) {
                if (e.type === "touchend" && e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches[0]) {
                    e.pageX = e.originalEvent.changedTouches[0].pageX;
                    e.pageY = e.originalEvent.changedTouches[0].pageY;
                    e.target = document.elementFromPoint(e.originalEvent.changedTouches[0].pageX - window.pageXOffset, e.originalEvent.changedTouches[0].pageY - window.pageYOffset);
                }
                if (vakata_dnd.is_drag) {
                    /**
					 * triggered on the document when a drag stops (the dragged element is dropped)
					 * @event
					 * @plugin dnd
					 * @name dnd_stop.vakata
					 * @param {Mixed} data any data supplied with the call to $.vakata.dnd.start
					 * @param {DOM} element the DOM element being dragged
					 * @param {jQuery} helper the helper shown next to the mouse
					 * @param {Object} event the event that caused the stop
					 */ if (e.target !== vakata_dnd.target) $(vakata_dnd.target).off("click.vakata");
                    $.vakata.dnd._trigger("stop", e);
                } else if (e.type === "touchend" && e.target === vakata_dnd.target) {
                    var to = setTimeout(function() {
                        $(e.target).trigger("click");
                    }, 100);
                    $(e.target).one("click", function() {
                        if (to) clearTimeout(to);
                    });
                }
                $.vakata.dnd._clean();
                return false;
            }
        };
    })($);
    // include the dnd plugin by default
    // $.jstree.defaults.plugins.push("dnd");
    /**
 * ### Massload plugin
 *
 * Adds massload functionality to jsTree, so that multiple nodes can be loaded in a single request (only useful with lazy loading).
 */ /**
	 * massload configuration
	 *
	 * It is possible to set this to a standard jQuery-like AJAX config.
	 * In addition to the standard jQuery ajax options here you can supply functions for `data` and `url`, the functions will be run in the current instance's scope and a param will be passed indicating which node IDs need to be loaded, the return value of those functions will be used.
	 *
	 * You can also set this to a function, that function will receive the node IDs being loaded as argument and a second param which is a function (callback) which should be called with the result.
	 *
	 * Both the AJAX and the function approach rely on the same return value - an object where the keys are the node IDs, and the value is the children of that node as an array.
	 *
	 *	{
	 *		"id1" : [{ "text" : "Child of ID1", "id" : "c1" }, { "text" : "Another child of ID1", "id" : "c2" }],
	 *		"id2" : [{ "text" : "Child of ID2", "id" : "c3" }]
	 *	}
	 * 
	 * @name $.jstree.defaults.massload
	 * @plugin massload
	 */ $.jstree.defaults.massload = null;
    $.jstree.plugins.massload = function(options, parent) {
        this.init = function(el, options) {
            this._data.massload = {};
            parent.init.call(this, el, options);
        };
        this._load_nodes = function(nodes, callback, is_callback, force_reload) {
            var s = this.settings.massload, toLoad = [], m = this._model.data, i, j, dom;
            if (!is_callback) {
                for(i = 0, j = nodes.length; i < j; i++)if (!m[nodes[i]] || !m[nodes[i]].state.loaded && !m[nodes[i]].state.failed || force_reload) {
                    toLoad.push(nodes[i]);
                    dom = this.get_node(nodes[i], true);
                    if (dom && dom.length) dom.addClass("jstree-loading").attr("aria-busy", true);
                }
                this._data.massload = {};
                if (toLoad.length) {
                    if ($.vakata.is_function(s)) return s.call(this, toLoad, (function(data) {
                        var i, j;
                        if (data) {
                            for(i in data)if (data.hasOwnProperty(i)) this._data.massload[i] = data[i];
                        }
                        for(i = 0, j = nodes.length; i < j; i++){
                            dom = this.get_node(nodes[i], true);
                            if (dom && dom.length) dom.removeClass("jstree-loading").attr("aria-busy", false);
                        }
                        parent._load_nodes.call(this, nodes, callback, is_callback, force_reload);
                    }).bind(this));
                    if (typeof s === "object" && s && s.url) {
                        s = $.extend(true, {}, s);
                        if ($.vakata.is_function(s.url)) s.url = s.url.call(this, toLoad);
                        if ($.vakata.is_function(s.data)) s.data = s.data.call(this, toLoad);
                        return $.ajax(s).done((function(data, t, x) {
                            var i, j;
                            if (data) {
                                for(i in data)if (data.hasOwnProperty(i)) this._data.massload[i] = data[i];
                            }
                            for(i = 0, j = nodes.length; i < j; i++){
                                dom = this.get_node(nodes[i], true);
                                if (dom && dom.length) dom.removeClass("jstree-loading").attr("aria-busy", false);
                            }
                            parent._load_nodes.call(this, nodes, callback, is_callback, force_reload);
                        }).bind(this)).fail((function(f) {
                            parent._load_nodes.call(this, nodes, callback, is_callback, force_reload);
                        }).bind(this));
                    }
                }
            }
            return parent._load_nodes.call(this, nodes, callback, is_callback, force_reload);
        };
        this._load_node = function(obj, callback) {
            var data = this._data.massload[obj.id], rslt = null, dom;
            if (data) {
                rslt = this[typeof data === "string" ? "_append_html_data" : "_append_json_data"](obj, typeof data === "string" ? $($.parseHTML(data)).filter(function() {
                    return this.nodeType !== 3;
                }) : data, function(status) {
                    callback.call(this, status);
                });
                dom = this.get_node(obj.id, true);
                if (dom && dom.length) dom.removeClass("jstree-loading").attr("aria-busy", false);
                delete this._data.massload[obj.id];
                return rslt;
            }
            return parent._load_node.call(this, obj, callback);
        };
    };
    /**
 * ### Search plugin
 *
 * Adds search functionality to jsTree.
 */ /**
	 * stores all defaults for the search plugin
	 * @name $.jstree.defaults.search
	 * @plugin search
	 */ $.jstree.defaults.search = {
        /**
		 * a jQuery-like AJAX config, which jstree uses if a server should be queried for results.
		 *
		 * A `str` (which is the search string) parameter will be added with the request, an optional `inside` parameter will be added if the search is limited to a node id. The expected result is a JSON array with nodes that need to be opened so that matching nodes will be revealed.
		 * Leave this setting as `false` to not query the server. You can also set this to a function, which will be invoked in the instance's scope and receive 3 parameters - the search string, the callback to call with the array of nodes to load, and the optional node ID to limit the search to
		 * @name $.jstree.defaults.search.ajax
		 * @plugin search
		 */ ajax: false,
        /**
		 * Indicates if the search should be fuzzy or not (should `chnd3` match `child node 3`). Default is `false`.
		 * @name $.jstree.defaults.search.fuzzy
		 * @plugin search
		 */ fuzzy: false,
        /**
		 * Indicates if the search should be case sensitive. Default is `false`.
		 * @name $.jstree.defaults.search.case_sensitive
		 * @plugin search
		 */ case_sensitive: false,
        /**
		 * Indicates if the tree should be filtered (by default) to show only matching nodes (keep in mind this can be a heavy on large trees in old browsers).
		 * This setting can be changed at runtime when calling the search method. Default is `false`.
		 * @name $.jstree.defaults.search.show_only_matches
		 * @plugin search
		 */ show_only_matches: false,
        /**
		 * Indicates if the children of matched element are shown (when show_only_matches is true)
		 * This setting can be changed at runtime when calling the search method. Default is `false`.
		 * @name $.jstree.defaults.search.show_only_matches_children
		 * @plugin search
		 */ show_only_matches_children: false,
        /**
		 * Indicates if all nodes opened to reveal the search result, should be closed when the search is cleared or a new search is performed. Default is `true`.
		 * @name $.jstree.defaults.search.close_opened_onclear
		 * @plugin search
		 */ close_opened_onclear: true,
        /**
		 * Indicates if only leaf nodes should be included in search results. Default is `false`.
		 * @name $.jstree.defaults.search.search_leaves_only
		 * @plugin search
		 */ search_leaves_only: false,
        /**
		 * If set to a function it wil be called in the instance's scope with two arguments - search string and node (where node will be every node in the structure, so use with caution).
		 * If the function returns a truthy value the node will be considered a match (it might not be displayed if search_only_leaves is set to true and the node is not a leaf). Default is `false`.
		 * @name $.jstree.defaults.search.search_callback
		 * @plugin search
		 */ search_callback: false
    };
    $.jstree.plugins.search = function(options, parent) {
        this.bind = function() {
            parent.bind.call(this);
            this._data.search.str = "";
            this._data.search.dom = $();
            this._data.search.res = [];
            this._data.search.opn = [];
            this._data.search.som = false;
            this._data.search.smc = false;
            this._data.search.hdn = [];
            this.element.on("search.jstree", (function(e, data) {
                if (this._data.search.som && data.res.length) {
                    var m = this._model.data, i, j, p = [], k, l;
                    for(i = 0, j = data.res.length; i < j; i++)if (m[data.res[i]] && !m[data.res[i]].state.hidden) {
                        p.push(data.res[i]);
                        p = p.concat(m[data.res[i]].parents);
                        if (this._data.search.smc) {
                            for(k = 0, l = m[data.res[i]].children_d.length; k < l; k++)if (m[m[data.res[i]].children_d[k]] && !m[m[data.res[i]].children_d[k]].state.hidden) p.push(m[data.res[i]].children_d[k]);
                        }
                    }
                    p = $.vakata.array_remove_item($.vakata.array_unique(p), $.jstree.root);
                    this._data.search.hdn = this.hide_all(true);
                    this.show_node(p, true);
                    this.redraw(true);
                }
            }).bind(this)).on("clear_search.jstree", (function(e, data) {
                if (this._data.search.som && data.res.length) {
                    this.show_node(this._data.search.hdn, true);
                    this.redraw(true);
                }
            }).bind(this));
        };
        /**
		 * used to search the tree nodes for a given string
		 * @name search(str [, skip_async])
		 * @param {String} str the search string
		 * @param {Boolean} skip_async if set to true server will not be queried even if configured
		 * @param {Boolean} show_only_matches if set to true only matching nodes will be shown (keep in mind this can be very slow on large trees or old browsers)
		 * @param {mixed} inside an optional node to whose children to limit the search
		 * @param {Boolean} append if set to true the results of this search are appended to the previous search
		 * @plugin search
		 * @trigger search.jstree
		 */ this.search = function(str, skip_async, show_only_matches, inside, append, show_only_matches_children) {
            if (str === false || $.vakata.trim(str.toString()) === "") return this.clear_search();
            inside = this.get_node(inside);
            inside = inside && (inside.id || inside.id === 0) ? inside.id : null;
            str = str.toString();
            var s = this.settings.search, a = s.ajax ? s.ajax : false, m = this._model.data, f = null, r = [], p = [], i, j;
            if (this._data.search.res.length && !append) this.clear_search();
            if (show_only_matches === undefined) show_only_matches = s.show_only_matches;
            if (show_only_matches_children === undefined) show_only_matches_children = s.show_only_matches_children;
            if (!skip_async && a !== false) {
                if ($.vakata.is_function(a)) return a.call(this, str, (function(d) {
                    if (d && d.d) d = d.d;
                    this._load_nodes(!$.vakata.is_array(d) ? [] : $.vakata.array_unique(d), function() {
                        this.search(str, true, show_only_matches, inside, append, show_only_matches_children);
                    });
                }).bind(this), inside);
                else {
                    a = $.extend({}, a);
                    if (!a.data) a.data = {};
                    a.data.str = str;
                    if (inside) a.data.inside = inside;
                    if (this._data.search.lastRequest) this._data.search.lastRequest.abort();
                    this._data.search.lastRequest = $.ajax(a).fail((function() {
                        this._data.core.last_error = {
                            "error": "ajax",
                            "plugin": "search",
                            "id": "search_01",
                            "reason": "Could not load search parents",
                            "data": JSON.stringify(a)
                        };
                        this.settings.core.error.call(this, this._data.core.last_error);
                    }).bind(this)).done((function(d) {
                        if (d && d.d) d = d.d;
                        this._load_nodes(!$.vakata.is_array(d) ? [] : $.vakata.array_unique(d), function() {
                            this.search(str, true, show_only_matches, inside, append, show_only_matches_children);
                        });
                    }).bind(this));
                    return this._data.search.lastRequest;
                }
            }
            if (!append) {
                this._data.search.str = str;
                this._data.search.dom = $();
                this._data.search.res = [];
                this._data.search.opn = [];
                this._data.search.som = show_only_matches;
                this._data.search.smc = show_only_matches_children;
            }
            f = new $.vakata.search(str, true, {
                caseSensitive: s.case_sensitive,
                fuzzy: s.fuzzy
            });
            $.each(m[inside ? inside : $.jstree.root].children_d, function(ii, i) {
                var v = m[i];
                if (v.text && !v.state.hidden && (!s.search_leaves_only || v.state.loaded && v.children.length === 0) && (s.search_callback && s.search_callback.call(this, str, v) || !s.search_callback && f.search(v.text).isMatch)) {
                    r.push(i);
                    p = p.concat(v.parents);
                }
            });
            if (r.length) {
                p = $.vakata.array_unique(p);
                for(i = 0, j = p.length; i < j; i++)if (p[i] !== $.jstree.root && m[p[i]] && this.open_node(p[i], null, 0) === true) this._data.search.opn.push(p[i]);
                if (!append) {
                    this._data.search.dom = $(this.element[0].querySelectorAll("#" + $.map(r, function(v) {
                        return "0123456789".indexOf(v[0]) !== -1 ? "\\3" + v[0] + " " + v.substr(1).replace($.jstree.idregex, "\\$&") : v.replace($.jstree.idregex, "\\$&");
                    }).join(", #")));
                    this._data.search.res = r;
                } else {
                    this._data.search.dom = this._data.search.dom.add($(this.element[0].querySelectorAll("#" + $.map(r, function(v) {
                        return "0123456789".indexOf(v[0]) !== -1 ? "\\3" + v[0] + " " + v.substr(1).replace($.jstree.idregex, "\\$&") : v.replace($.jstree.idregex, "\\$&");
                    }).join(", #"))));
                    this._data.search.res = $.vakata.array_unique(this._data.search.res.concat(r));
                }
                this._data.search.dom.children(".jstree-anchor").addClass("jstree-search");
            }
            /**
			 * triggered after search is complete
			 * @event
			 * @name search.jstree
			 * @param {jQuery} nodes a jQuery collection of matching nodes
			 * @param {String} str the search string
			 * @param {Array} res a collection of objects represeing the matching nodes
			 * @plugin search
			 */ this.trigger("search", {
                nodes: this._data.search.dom,
                str: str,
                res: this._data.search.res,
                show_only_matches: show_only_matches
            });
        };
        /**
		 * used to clear the last search (removes classes and shows all nodes if filtering is on)
		 * @name clear_search()
		 * @plugin search
		 * @trigger clear_search.jstree
		 */ this.clear_search = function() {
            if (this.settings.search.close_opened_onclear) this.close_node(this._data.search.opn, 0);
            /**
			 * triggered after search is complete
			 * @event
			 * @name clear_search.jstree
			 * @param {jQuery} nodes a jQuery collection of matching nodes (the result from the last search)
			 * @param {String} str the search string (the last search string)
			 * @param {Array} res a collection of objects represeing the matching nodes (the result from the last search)
			 * @plugin search
			 */ this.trigger("clear_search", {
                "nodes": this._data.search.dom,
                str: this._data.search.str,
                res: this._data.search.res
            });
            if (this._data.search.res.length) {
                this._data.search.dom = $(this.element[0].querySelectorAll("#" + $.map(this._data.search.res, function(v) {
                    return "0123456789".indexOf(v[0]) !== -1 ? "\\3" + v[0] + " " + v.substr(1).replace($.jstree.idregex, "\\$&") : v.replace($.jstree.idregex, "\\$&");
                }).join(", #")));
                this._data.search.dom.children(".jstree-anchor").removeClass("jstree-search");
            }
            this._data.search.str = "";
            this._data.search.res = [];
            this._data.search.opn = [];
            this._data.search.dom = $();
        };
        this.redraw_node = function(obj, deep, callback, force_render) {
            obj = parent.redraw_node.apply(this, arguments);
            if (obj) {
                if ($.inArray(obj.id, this._data.search.res) !== -1) {
                    var i, j, tmp = null;
                    for(i = 0, j = obj.childNodes.length; i < j; i++)if (obj.childNodes[i] && obj.childNodes[i].className && obj.childNodes[i].className.indexOf("jstree-anchor") !== -1) {
                        tmp = obj.childNodes[i];
                        break;
                    }
                    if (tmp) tmp.className += " jstree-search";
                }
            }
            return obj;
        };
    };
    // helpers
    (function($) {
        // from http://kiro.me/projects/fuse.html
        $.vakata.search = function(pattern, txt, options) {
            options = options || {};
            options = $.extend({}, $.vakata.search.defaults, options);
            if (options.fuzzy !== false) options.fuzzy = true;
            pattern = options.caseSensitive ? pattern : pattern.toLowerCase();
            var MATCH_LOCATION = options.location, MATCH_DISTANCE = options.distance, MATCH_THRESHOLD = options.threshold, patternLen = pattern.length, matchmask, pattern_alphabet, match_bitapScore, search;
            if (patternLen > 32) options.fuzzy = false;
            if (options.fuzzy) {
                matchmask = 1 << patternLen - 1;
                pattern_alphabet = function() {
                    var mask = {}, i = 0;
                    for(i = 0; i < patternLen; i++)mask[pattern.charAt(i)] = 0;
                    for(i = 0; i < patternLen; i++)mask[pattern.charAt(i)] |= 1 << patternLen - i - 1;
                    return mask;
                }();
                match_bitapScore = function(e, x) {
                    var accuracy = e / patternLen, proximity = Math.abs(MATCH_LOCATION - x);
                    if (!MATCH_DISTANCE) return proximity ? 1.0 : accuracy;
                    return accuracy + proximity / MATCH_DISTANCE;
                };
            }
            search = function(text) {
                text = options.caseSensitive ? text.toString() : text.toString().toLowerCase();
                if (pattern === text || text.indexOf(pattern) !== -1) return {
                    isMatch: true,
                    score: 0
                };
                if (!options.fuzzy) return {
                    isMatch: false,
                    score: 1
                };
                var i, j, textLen = text.length, scoreThreshold = MATCH_THRESHOLD, bestLoc = text.indexOf(pattern, MATCH_LOCATION), binMin, binMid, binMax = patternLen + textLen, lastRd, start, finish, rd, charMatch, score = 1, locations = [];
                if (bestLoc !== -1) {
                    scoreThreshold = Math.min(match_bitapScore(0, bestLoc), scoreThreshold);
                    bestLoc = text.lastIndexOf(pattern, MATCH_LOCATION + patternLen);
                    if (bestLoc !== -1) scoreThreshold = Math.min(match_bitapScore(0, bestLoc), scoreThreshold);
                }
                bestLoc = -1;
                for(i = 0; i < patternLen; i++){
                    binMin = 0;
                    binMid = binMax;
                    while(binMin < binMid){
                        if (match_bitapScore(i, MATCH_LOCATION + binMid) <= scoreThreshold) binMin = binMid;
                        else binMax = binMid;
                        binMid = Math.floor((binMax - binMin) / 2 + binMin);
                    }
                    binMax = binMid;
                    start = Math.max(1, MATCH_LOCATION - binMid + 1);
                    finish = Math.min(MATCH_LOCATION + binMid, textLen) + patternLen;
                    rd = new Array(finish + 2);
                    rd[finish + 1] = (1 << i) - 1;
                    for(j = finish; j >= start; j--){
                        charMatch = pattern_alphabet[text.charAt(j - 1)];
                        if (i === 0) rd[j] = (rd[j + 1] << 1 | 1) & charMatch;
                        else rd[j] = (rd[j + 1] << 1 | 1) & charMatch | ((lastRd[j + 1] | lastRd[j]) << 1 | 1) | lastRd[j + 1];
                        if (rd[j] & matchmask) {
                            score = match_bitapScore(i, j - 1);
                            if (score <= scoreThreshold) {
                                scoreThreshold = score;
                                bestLoc = j - 1;
                                locations.push(bestLoc);
                                if (bestLoc > MATCH_LOCATION) start = Math.max(1, 2 * MATCH_LOCATION - bestLoc);
                                else break;
                            }
                        }
                    }
                    if (match_bitapScore(i + 1, MATCH_LOCATION) > scoreThreshold) break;
                    lastRd = rd;
                }
                return {
                    isMatch: bestLoc >= 0,
                    score: score
                };
            };
            return txt === true ? {
                "search": search
            } : search(txt);
        };
        $.vakata.search.defaults = {
            location: 0,
            distance: 100,
            threshold: 0.6,
            fuzzy: false,
            caseSensitive: false
        };
    })($);
    // include the search plugin by default
    // $.jstree.defaults.plugins.push("search");
    /**
 * ### Sort plugin
 *
 * Automatically sorts all siblings in the tree according to a sorting function.
 */ /**
	 * the settings function used to sort the nodes.
	 * It is executed in the tree's context, accepts two nodes as arguments and should return `1` or `-1`.
	 * @name $.jstree.defaults.sort
	 * @plugin sort
	 */ $.jstree.defaults.sort = function(a, b) {
        //return this.get_type(a) === this.get_type(b) ? (this.get_text(a) > this.get_text(b) ? 1 : -1) : this.get_type(a) >= this.get_type(b);
        return this.get_text(a) > this.get_text(b) ? 1 : -1;
    };
    $.jstree.plugins.sort = function(options, parent) {
        this.bind = function() {
            parent.bind.call(this);
            this.element.on("model.jstree", (function(e, data) {
                this.sort(data.parent, true);
            }).bind(this)).on("rename_node.jstree create_node.jstree", (function(e, data) {
                this.sort(data.parent || data.node.parent, false);
                this.redraw_node(data.parent || data.node.parent, true);
            }).bind(this)).on("move_node.jstree copy_node.jstree", (function(e, data) {
                this.sort(data.parent, false);
                this.redraw_node(data.parent, true);
            }).bind(this));
        };
        /**
		 * used to sort a node's children
		 * @private
		 * @name sort(obj [, deep])
		 * @param  {mixed} obj the node
		 * @param {Boolean} deep if set to `true` nodes are sorted recursively.
		 * @plugin sort
		 * @trigger search.jstree
		 */ this.sort = function(obj, deep) {
            var i, j;
            obj = this.get_node(obj);
            if (obj && obj.children && obj.children.length) {
                obj.children.sort(this.settings.sort.bind(this));
                if (deep) for(i = 0, j = obj.children_d.length; i < j; i++)this.sort(obj.children_d[i], false);
            }
        };
    };
    // include the sort plugin by default
    // $.jstree.defaults.plugins.push("sort");
    /**
 * ### State plugin
 *
 * Saves the state of the tree (selected nodes, opened nodes) on the user's computer using available options (localStorage, cookies, etc)
 */ var to = false;
    /**
	 * stores all defaults for the state plugin
	 * @name $.jstree.defaults.state
	 * @plugin state
	 */ $.jstree.defaults.state = {
        /**
		 * A string for the key to use when saving the current tree (change if using multiple trees in your project). Defaults to `jstree`.
		 * @name $.jstree.defaults.state.key
		 * @plugin state
		 */ key: "jstree",
        /**
		 * A space separated list of events that trigger a state save. Defaults to `changed.jstree open_node.jstree close_node.jstree`.
		 * @name $.jstree.defaults.state.events
		 * @plugin state
		 */ events: "changed.jstree open_node.jstree close_node.jstree check_node.jstree uncheck_node.jstree",
        /**
		 * Time in milliseconds after which the state will expire. Defaults to 'false' meaning - no expire.
		 * @name $.jstree.defaults.state.ttl
		 * @plugin state
		 */ ttl: false,
        /**
		 * A function that will be executed prior to restoring state with one argument - the state object. Can be used to clear unwanted parts of the state.
		 * @name $.jstree.defaults.state.filter
		 * @plugin state
		 */ filter: false,
        /**
		 * Should loaded nodes be restored (setting this to true means that it is possible that the whole tree will be loaded for some users - use with caution). Defaults to `false`
		 * @name $.jstree.defaults.state.preserve_loaded
		 * @plugin state
		 */ preserve_loaded: false
    };
    $.jstree.plugins.state = function(options, parent) {
        this.bind = function() {
            parent.bind.call(this);
            var bind = (function() {
                this.element.on(this.settings.state.events, (function() {
                    if (to) clearTimeout(to);
                    to = setTimeout((function() {
                        this.save_state();
                    }).bind(this), 100);
                }).bind(this));
                /**
				 * triggered when the state plugin is finished restoring the state (and immediately after ready if there is no state to restore).
				 * @event
				 * @name state_ready.jstree
				 * @plugin state
				 */ this.trigger("state_ready");
            }).bind(this);
            this.element.on("ready.jstree", (function(e, data) {
                this.element.one("restore_state.jstree", bind);
                if (!this.restore_state()) bind();
            }).bind(this));
        };
        /**
		 * save the state
		 * @name save_state()
		 * @plugin state
		 */ this.save_state = function() {
            var tm = this.get_state();
            if (!this.settings.state.preserve_loaded) delete tm.core.loaded;
            var st = {
                "state": tm,
                "ttl": this.settings.state.ttl,
                "sec": +new Date()
            };
            $.vakata.storage.set(this.settings.state.key, JSON.stringify(st));
        };
        /**
		 * restore the state from the user's computer
		 * @name restore_state()
		 * @plugin state
		 */ this.restore_state = function() {
            var k = $.vakata.storage.get(this.settings.state.key);
            if (!!k) try {
                k = JSON.parse(k);
            } catch (ex) {
                return false;
            }
            if (!!k && k.ttl && k.sec && +new Date() - k.sec > k.ttl) return false;
            if (!!k && k.state) k = k.state;
            if (!!k && $.vakata.is_function(this.settings.state.filter)) k = this.settings.state.filter.call(this, k);
            if (!!k) {
                if (!this.settings.state.preserve_loaded) delete k.core.loaded;
                this.element.one("set_state.jstree", function(e, data) {
                    data.instance.trigger("restore_state", {
                        "state": $.extend(true, {}, k)
                    });
                });
                this.set_state(k);
                return true;
            }
            return false;
        };
        /**
		 * clear the state on the user's computer
		 * @name clear_state()
		 * @plugin state
		 */ this.clear_state = function() {
            return $.vakata.storage.del(this.settings.state.key);
        };
    };
    (function($, undefined) {
        $.vakata.storage = {
            // simply specifying the functions in FF throws an error
            set: function(key, val) {
                return window.localStorage.setItem(key, val);
            },
            get: function(key) {
                return window.localStorage.getItem(key);
            },
            del: function(key) {
                return window.localStorage.removeItem(key);
            }
        };
    })($);
    // include the state plugin by default
    // $.jstree.defaults.plugins.push("state");
    /**
 * ### Types plugin
 *
 * Makes it possible to add predefined types for groups of nodes, which make it possible to easily control nesting rules and icon for each group.
 */ /**
	 * An object storing all types as key value pairs, where the key is the type name and the value is an object that could contain following keys (all optional).
	 *
	 * * `max_children` the maximum number of immediate children this node type can have. Do not specify or set to `-1` for unlimited.
	 * * `max_depth` the maximum number of nesting this node type can have. A value of `1` would mean that the node can have children, but no grandchildren. Do not specify or set to `-1` for unlimited.
	 * * `valid_children` an array of node type strings, that nodes of this type can have as children. Do not specify or set to `-1` for no limits.
	 * * `icon` a string - can be a path to an icon or a className, if using an image that is in the current directory use a `./` prefix, otherwise it will be detected as a class. Omit to use the default icon from your theme.
	 * * `li_attr` an object of values which will be used to add HTML attributes on the resulting LI DOM node (merged with the node's own data)
	 * * `a_attr` an object of values which will be used to add HTML attributes on the resulting A DOM node (merged with the node's own data)
	 *
	 * There are two predefined types:
	 *
	 * * `#` represents the root of the tree, for example `max_children` would control the maximum number of root nodes.
	 * * `default` represents the default node - any settings here will be applied to all nodes that do not have a type specified.
	 *
	 * @name $.jstree.defaults.types
	 * @plugin types
	 */ $.jstree.defaults.types = {
        "default": {}
    };
    $.jstree.defaults.types[$.jstree.root] = {};
    $.jstree.plugins.types = function(options, parent) {
        this.init = function(el, options) {
            var i, j;
            if (options && options.types && options.types["default"]) {
                for(i in options.types)if (i !== "default" && i !== $.jstree.root && options.types.hasOwnProperty(i)) {
                    for(j in options.types["default"])if (options.types["default"].hasOwnProperty(j) && options.types[i][j] === undefined) options.types[i][j] = options.types["default"][j];
                }
            }
            parent.init.call(this, el, options);
            this._model.data[$.jstree.root].type = $.jstree.root;
        };
        this.refresh = function(skip_loading, forget_state) {
            parent.refresh.call(this, skip_loading, forget_state);
            this._model.data[$.jstree.root].type = $.jstree.root;
        };
        this.bind = function() {
            this.element.on("model.jstree", (function(e, data) {
                var m = this._model.data, dpc = data.nodes, t = this.settings.types, i, j, c = "default", k;
                for(i = 0, j = dpc.length; i < j; i++){
                    c = "default";
                    if (m[dpc[i]].original && m[dpc[i]].original.type && t[m[dpc[i]].original.type]) c = m[dpc[i]].original.type;
                    if (m[dpc[i]].data && m[dpc[i]].data.jstree && m[dpc[i]].data.jstree.type && t[m[dpc[i]].data.jstree.type]) c = m[dpc[i]].data.jstree.type;
                    m[dpc[i]].type = c;
                    if (m[dpc[i]].icon === true && t[c].icon !== undefined) m[dpc[i]].icon = t[c].icon;
                    if (t[c].li_attr !== undefined && typeof t[c].li_attr === "object") {
                        for(k in t[c].li_attr)if (t[c].li_attr.hasOwnProperty(k)) {
                            if (k === "id") continue;
                            else if (m[dpc[i]].li_attr[k] === undefined) m[dpc[i]].li_attr[k] = t[c].li_attr[k];
                            else if (k === "class") m[dpc[i]].li_attr["class"] = t[c].li_attr["class"] + " " + m[dpc[i]].li_attr["class"];
                        }
                    }
                    if (t[c].a_attr !== undefined && typeof t[c].a_attr === "object") {
                        for(k in t[c].a_attr)if (t[c].a_attr.hasOwnProperty(k)) {
                            if (k === "id") continue;
                            else if (m[dpc[i]].a_attr[k] === undefined) m[dpc[i]].a_attr[k] = t[c].a_attr[k];
                            else if (k === "href" && m[dpc[i]].a_attr[k] === "#") m[dpc[i]].a_attr["href"] = t[c].a_attr["href"];
                            else if (k === "class") m[dpc[i]].a_attr["class"] = t[c].a_attr["class"] + " " + m[dpc[i]].a_attr["class"];
                        }
                    }
                }
                m[$.jstree.root].type = $.jstree.root;
            }).bind(this));
            parent.bind.call(this);
        };
        this.get_json = function(obj, options, flat) {
            var i, j, m = this._model.data, opt = options ? $.extend(true, {}, options, {
                no_id: false
            }) : {}, tmp = parent.get_json.call(this, obj, opt, flat);
            if (tmp === false) return false;
            if ($.vakata.is_array(tmp)) for(i = 0, j = tmp.length; i < j; i++){
                tmp[i].type = (tmp[i].id || tmp[i].id === 0) && m[tmp[i].id] && m[tmp[i].id].type ? m[tmp[i].id].type : "default";
                if (options && options.no_id) {
                    delete tmp[i].id;
                    if (tmp[i].li_attr && tmp[i].li_attr.id) delete tmp[i].li_attr.id;
                    if (tmp[i].a_attr && tmp[i].a_attr.id) delete tmp[i].a_attr.id;
                }
            }
            else {
                tmp.type = (tmp.id || tmp.id === 0) && m[tmp.id] && m[tmp.id].type ? m[tmp.id].type : "default";
                if (options && options.no_id) tmp = this._delete_ids(tmp);
            }
            return tmp;
        };
        this._delete_ids = function(tmp) {
            if ($.vakata.is_array(tmp)) {
                for(var i = 0, j = tmp.length; i < j; i++)tmp[i] = this._delete_ids(tmp[i]);
                return tmp;
            }
            delete tmp.id;
            if (tmp.li_attr && tmp.li_attr.id) delete tmp.li_attr.id;
            if (tmp.a_attr && tmp.a_attr.id) delete tmp.a_attr.id;
            if (tmp.children && $.vakata.is_array(tmp.children)) tmp.children = this._delete_ids(tmp.children);
            return tmp;
        };
        this.check = function(chk, obj, par, pos, more) {
            if (parent.check.call(this, chk, obj, par, pos, more) === false) return false;
            obj = obj && (obj.id || obj.id === 0) ? obj : this.get_node(obj);
            par = par && (par.id || par.id === 0) ? par : this.get_node(par);
            var m = obj && (obj.id || obj.id === 0) ? more && more.origin ? more.origin : $.jstree.reference(obj.id) : null, tmp, d, i, j;
            m = m && m._model && m._model.data ? m._model.data : null;
            switch(chk){
                case "create_node":
                case "move_node":
                case "copy_node":
                    if (chk !== "move_node" || $.inArray(obj.id, par.children) === -1) {
                        tmp = this.get_rules(par);
                        if (tmp.max_children !== undefined && tmp.max_children !== -1 && tmp.max_children === par.children.length) {
                            this._data.core.last_error = {
                                "error": "check",
                                "plugin": "types",
                                "id": "types_01",
                                "reason": "max_children prevents function: " + chk,
                                "data": JSON.stringify({
                                    "chk": chk,
                                    "pos": pos,
                                    "obj": obj && (obj.id || obj.id === 0) ? obj.id : false,
                                    "par": par && (par.id || par.id === 0) ? par.id : false
                                })
                            };
                            return false;
                        }
                        if (tmp.valid_children !== undefined && tmp.valid_children !== -1 && $.inArray(obj.type || "default", tmp.valid_children) === -1) {
                            this._data.core.last_error = {
                                "error": "check",
                                "plugin": "types",
                                "id": "types_02",
                                "reason": "valid_children prevents function: " + chk,
                                "data": JSON.stringify({
                                    "chk": chk,
                                    "pos": pos,
                                    "obj": obj && (obj.id || obj.id === 0) ? obj.id : false,
                                    "par": par && (par.id || par.id === 0) ? par.id : false
                                })
                            };
                            return false;
                        }
                        if (m && obj.children_d && obj.parents) {
                            d = 0;
                            for(i = 0, j = obj.children_d.length; i < j; i++)d = Math.max(d, m[obj.children_d[i]].parents.length);
                            d = d - obj.parents.length + 1;
                        }
                        if (d <= 0 || d === undefined) d = 1;
                        do {
                            if (tmp.max_depth !== undefined && tmp.max_depth !== -1 && tmp.max_depth < d) {
                                this._data.core.last_error = {
                                    "error": "check",
                                    "plugin": "types",
                                    "id": "types_03",
                                    "reason": "max_depth prevents function: " + chk,
                                    "data": JSON.stringify({
                                        "chk": chk,
                                        "pos": pos,
                                        "obj": obj && (obj.id || obj.id === 0) ? obj.id : false,
                                        "par": par && (par.id || par.id === 0) ? par.id : false
                                    })
                                };
                                return false;
                            }
                            par = this.get_node(par.parent);
                            tmp = this.get_rules(par);
                            d++;
                        }while (par);
                    }
                    break;
            }
            return true;
        };
        /**
		 * used to retrieve the type settings object for a node
		 * @name get_rules(obj)
		 * @param {mixed} obj the node to find the rules for
		 * @return {Object}
		 * @plugin types
		 */ this.get_rules = function(obj) {
            obj = this.get_node(obj);
            if (!obj) return false;
            var tmp = this.get_type(obj, true);
            if (tmp.max_depth === undefined) tmp.max_depth = -1;
            if (tmp.max_children === undefined) tmp.max_children = -1;
            if (tmp.valid_children === undefined) tmp.valid_children = -1;
            return tmp;
        };
        /**
		 * used to retrieve the type string or settings object for a node
		 * @name get_type(obj [, rules])
		 * @param {mixed} obj the node to find the rules for
		 * @param {Boolean} rules if set to `true` instead of a string the settings object will be returned
		 * @return {String|Object}
		 * @plugin types
		 */ this.get_type = function(obj, rules) {
            obj = this.get_node(obj);
            return !obj ? false : rules ? $.extend({
                "type": obj.type
            }, this.settings.types[obj.type]) : obj.type;
        };
        /**
		 * used to change a node's type
		 * @name set_type(obj, type)
		 * @param {mixed} obj the node to change
		 * @param {String} type the new type
		 * @plugin types
		 */ this.set_type = function(obj, type) {
            var m = this._model.data, t, t1, t2, old_type, old_icon, k, d, a;
            if ($.vakata.is_array(obj)) {
                obj = obj.slice();
                for(t1 = 0, t2 = obj.length; t1 < t2; t1++)this.set_type(obj[t1], type);
                return true;
            }
            t = this.settings.types;
            obj = this.get_node(obj);
            if (!t[type] || !obj) return false;
            d = this.get_node(obj, true);
            if (d && d.length) a = d.children(".jstree-anchor");
            old_type = obj.type;
            old_icon = this.get_icon(obj);
            obj.type = type;
            if (old_icon === true || !t[old_type] || t[old_type].icon !== undefined && old_icon === t[old_type].icon) this.set_icon(obj, t[type].icon !== undefined ? t[type].icon : true);
            // remove old type props
            if (t[old_type] && t[old_type].li_attr !== undefined && typeof t[old_type].li_attr === "object") {
                for(k in t[old_type].li_attr)if (t[old_type].li_attr.hasOwnProperty(k)) {
                    if (k === "id") continue;
                    else if (k === "class") {
                        m[obj.id].li_attr["class"] = (m[obj.id].li_attr["class"] || "").replace(t[old_type].li_attr[k], "");
                        if (d) d.removeClass(t[old_type].li_attr[k]);
                    } else if (m[obj.id].li_attr[k] === t[old_type].li_attr[k]) {
                        m[obj.id].li_attr[k] = null;
                        if (d) d.removeAttr(k);
                    }
                }
            }
            if (t[old_type] && t[old_type].a_attr !== undefined && typeof t[old_type].a_attr === "object") {
                for(k in t[old_type].a_attr)if (t[old_type].a_attr.hasOwnProperty(k)) {
                    if (k === "id") continue;
                    else if (k === "class") {
                        m[obj.id].a_attr["class"] = (m[obj.id].a_attr["class"] || "").replace(t[old_type].a_attr[k], "");
                        if (a) a.removeClass(t[old_type].a_attr[k]);
                    } else if (m[obj.id].a_attr[k] === t[old_type].a_attr[k]) {
                        if (k === "href") {
                            m[obj.id].a_attr[k] = "#";
                            if (a) a.attr("href", "#");
                        } else {
                            delete m[obj.id].a_attr[k];
                            if (a) a.removeAttr(k);
                        }
                    }
                }
            }
            // add new props
            if (t[type].li_attr !== undefined && typeof t[type].li_attr === "object") {
                for(k in t[type].li_attr)if (t[type].li_attr.hasOwnProperty(k)) {
                    if (k === "id") continue;
                    else if (m[obj.id].li_attr[k] === undefined) {
                        m[obj.id].li_attr[k] = t[type].li_attr[k];
                        if (d) {
                            if (k === "class") d.addClass(t[type].li_attr[k]);
                            else d.attr(k, t[type].li_attr[k]);
                        }
                    } else if (k === "class") {
                        m[obj.id].li_attr["class"] = t[type].li_attr[k] + " " + m[obj.id].li_attr["class"];
                        if (d) d.addClass(t[type].li_attr[k]);
                    }
                }
            }
            if (t[type].a_attr !== undefined && typeof t[type].a_attr === "object") {
                for(k in t[type].a_attr)if (t[type].a_attr.hasOwnProperty(k)) {
                    if (k === "id") continue;
                    else if (m[obj.id].a_attr[k] === undefined) {
                        m[obj.id].a_attr[k] = t[type].a_attr[k];
                        if (a) {
                            if (k === "class") a.addClass(t[type].a_attr[k]);
                            else a.attr(k, t[type].a_attr[k]);
                        }
                    } else if (k === "href" && m[obj.id].a_attr[k] === "#") {
                        m[obj.id].a_attr["href"] = t[type].a_attr["href"];
                        if (a) a.attr("href", t[type].a_attr["href"]);
                    } else if (k === "class") {
                        m[obj.id].a_attr["class"] = t[type].a_attr["class"] + " " + m[obj.id].a_attr["class"];
                        if (a) a.addClass(t[type].a_attr[k]);
                    }
                }
            }
            return true;
        };
    };
    // include the types plugin by default
    // $.jstree.defaults.plugins.push("types");
    /**
 * ### Unique plugin
 *
 * Enforces that no nodes with the same name can coexist as siblings.
 */ /**
	 * stores all defaults for the unique plugin
	 * @name $.jstree.defaults.unique
	 * @plugin unique
	 */ $.jstree.defaults.unique = {
        /**
		 * Indicates if the comparison should be case sensitive. Default is `false`.
		 * @name $.jstree.defaults.unique.case_sensitive
		 * @plugin unique
		 */ case_sensitive: false,
        /**
		 * Indicates if white space should be trimmed before the comparison. Default is `false`.
		 * @name $.jstree.defaults.unique.trim_whitespace
		 * @plugin unique
		 */ trim_whitespace: false,
        /**
		 * A callback executed in the instance's scope when a new node is created with no name and a node with the default name already exists, the two arguments are the conflicting name and the counter. The default will produce results like `New node (2)`.
		 * @name $.jstree.defaults.unique.duplicate
		 * @plugin unique
		 */ duplicate: function(name, counter) {
            return name + " (" + counter + ")";
        }
    };
    $.jstree.plugins.unique = function(options, parent) {
        this.check = function(chk, obj, par, pos, more) {
            if (parent.check.call(this, chk, obj, par, pos, more) === false) return false;
            obj = obj && (obj.id || obj.id === 0) ? obj : this.get_node(obj);
            par = par && (par.id || par.id === 0) ? par : this.get_node(par);
            if (!par || !par.children) return true;
            var n = chk === "rename_node" ? pos : obj.text, c = [], s = this.settings.unique.case_sensitive, w = this.settings.unique.trim_whitespace, m = this._model.data, i, j, t;
            for(i = 0, j = par.children.length; i < j; i++){
                t = m[par.children[i]].text;
                if (!s) t = t.toLowerCase();
                if (w) t = t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
                c.push(t);
            }
            if (!s) n = n.toLowerCase();
            if (w) n = n.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
            switch(chk){
                case "delete_node":
                    return true;
                case "rename_node":
                    t = obj.text || "";
                    if (!s) t = t.toLowerCase();
                    if (w) t = t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
                    i = $.inArray(n, c) === -1 || obj.text && t === n;
                    if (!i) this._data.core.last_error = {
                        "error": "check",
                        "plugin": "unique",
                        "id": "unique_01",
                        "reason": "Child with name " + n + " already exists. Preventing: " + chk,
                        "data": JSON.stringify({
                            "chk": chk,
                            "pos": pos,
                            "obj": obj && (obj.id || obj.id === 0) ? obj.id : false,
                            "par": par && (par.id || par.id === 0) ? par.id : false
                        })
                    };
                    return i;
                case "create_node":
                    i = $.inArray(n, c) === -1;
                    if (!i) this._data.core.last_error = {
                        "error": "check",
                        "plugin": "unique",
                        "id": "unique_04",
                        "reason": "Child with name " + n + " already exists. Preventing: " + chk,
                        "data": JSON.stringify({
                            "chk": chk,
                            "pos": pos,
                            "obj": obj && (obj.id || obj.id === 0) ? obj.id : false,
                            "par": par && (par.id || par.id === 0) ? par.id : false
                        })
                    };
                    return i;
                case "copy_node":
                    i = $.inArray(n, c) === -1;
                    if (!i) this._data.core.last_error = {
                        "error": "check",
                        "plugin": "unique",
                        "id": "unique_02",
                        "reason": "Child with name " + n + " already exists. Preventing: " + chk,
                        "data": JSON.stringify({
                            "chk": chk,
                            "pos": pos,
                            "obj": obj && (obj.id || obj.id === 0) ? obj.id : false,
                            "par": par && (par.id || par.id === 0) ? par.id : false
                        })
                    };
                    return i;
                case "move_node":
                    i = obj.parent === par.id && (!more || !more.is_multi) || $.inArray(n, c) === -1;
                    if (!i) this._data.core.last_error = {
                        "error": "check",
                        "plugin": "unique",
                        "id": "unique_03",
                        "reason": "Child with name " + n + " already exists. Preventing: " + chk,
                        "data": JSON.stringify({
                            "chk": chk,
                            "pos": pos,
                            "obj": obj && (obj.id || obj.id === 0) ? obj.id : false,
                            "par": par && (par.id || par.id === 0) ? par.id : false
                        })
                    };
                    return i;
            }
            return true;
        };
        this.create_node = function(par, node, pos, callback, is_loaded) {
            if (!node || typeof node === "object" && node.text === undefined) {
                if (par === null) par = $.jstree.root;
                par = this.get_node(par);
                if (!par) return parent.create_node.call(this, par, node, pos, callback, is_loaded);
                pos = pos === undefined ? "last" : pos;
                if (!pos.toString().match(/^(before|after)$/) && !is_loaded && !this.is_loaded(par)) return parent.create_node.call(this, par, node, pos, callback, is_loaded);
                if (!node) node = {};
                var tmp, n, dpc, i, j, m = this._model.data, s = this.settings.unique.case_sensitive, w = this.settings.unique.trim_whitespace, cb = this.settings.unique.duplicate, t;
                n = tmp = this.get_string("New node");
                dpc = [];
                for(i = 0, j = par.children.length; i < j; i++){
                    t = m[par.children[i]].text;
                    if (!s) t = t.toLowerCase();
                    if (w) t = t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
                    dpc.push(t);
                }
                i = 1;
                t = n;
                if (!s) t = t.toLowerCase();
                if (w) t = t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
                while($.inArray(t, dpc) !== -1){
                    n = cb.call(this, tmp, ++i).toString();
                    t = n;
                    if (!s) t = t.toLowerCase();
                    if (w) t = t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
                }
                node.text = n;
            }
            return parent.create_node.call(this, par, node, pos, callback, is_loaded);
        };
    };
    // include the unique plugin by default
    // $.jstree.defaults.plugins.push("unique");
    /**
 * ### Wholerow plugin
 *
 * Makes each node appear block level. Making selection easier. May cause slow down for large trees in old browsers.
 */ var div = document.createElement("DIV");
    div.setAttribute("unselectable", "on");
    div.setAttribute("role", "presentation");
    div.className = "jstree-wholerow";
    div.innerHTML = "&#160;";
    $.jstree.plugins.wholerow = function(options, parent) {
        this.bind = function() {
            parent.bind.call(this);
            this.element.on("ready.jstree set_state.jstree", (function() {
                this.hide_dots();
            }).bind(this)).on("init.jstree loading.jstree ready.jstree", (function() {
                //div.style.height = this._data.core.li_height + 'px';
                this.get_container_ul().addClass("jstree-wholerow-ul");
            }).bind(this)).on("deselect_all.jstree", (function(e, data) {
                this.element.find(".jstree-wholerow-clicked").removeClass("jstree-wholerow-clicked");
            }).bind(this)).on("changed.jstree", (function(e, data) {
                this.element.find(".jstree-wholerow-clicked").removeClass("jstree-wholerow-clicked");
                var tmp = false, i, j;
                for(i = 0, j = data.selected.length; i < j; i++){
                    tmp = this.get_node(data.selected[i], true);
                    if (tmp && tmp.length) tmp.children(".jstree-wholerow").addClass("jstree-wholerow-clicked");
                }
            }).bind(this)).on("open_node.jstree", (function(e, data) {
                this.get_node(data.node, true).find(".jstree-clicked").parent().children(".jstree-wholerow").addClass("jstree-wholerow-clicked");
            }).bind(this)).on("hover_node.jstree dehover_node.jstree", (function(e, data) {
                if (e.type === "hover_node" && this.is_disabled(data.node)) return;
                this.get_node(data.node, true).children(".jstree-wholerow")[e.type === "hover_node" ? "addClass" : "removeClass"]("jstree-wholerow-hovered");
            }).bind(this)).on("contextmenu.jstree", ".jstree-wholerow", (function(e) {
                if (this._data.contextmenu) {
                    e.preventDefault();
                    var tmp = $.Event("contextmenu", {
                        metaKey: e.metaKey,
                        ctrlKey: e.ctrlKey,
                        altKey: e.altKey,
                        shiftKey: e.shiftKey,
                        pageX: e.pageX,
                        pageY: e.pageY
                    });
                    $(e.currentTarget).closest(".jstree-node").children(".jstree-anchor").first().trigger(tmp);
                }
            }).bind(this))/*!
				.on("mousedown.jstree touchstart.jstree", ".jstree-wholerow", function (e) {
						if(e.target === e.currentTarget) {
							var a = $(e.currentTarget).closest(".jstree-node").children(".jstree-anchor");
							e.target = a[0];
							a.trigger(e);
						}
					})
				*/ .on("click.jstree", ".jstree-wholerow", function(e) {
                e.stopImmediatePropagation();
                var tmp = $.Event("click", {
                    metaKey: e.metaKey,
                    ctrlKey: e.ctrlKey,
                    altKey: e.altKey,
                    shiftKey: e.shiftKey
                });
                $(e.currentTarget).closest(".jstree-node").children(".jstree-anchor").first().trigger(tmp).trigger("focus");
            }).on("dblclick.jstree", ".jstree-wholerow", function(e) {
                e.stopImmediatePropagation();
                var tmp = $.Event("dblclick", {
                    metaKey: e.metaKey,
                    ctrlKey: e.ctrlKey,
                    altKey: e.altKey,
                    shiftKey: e.shiftKey
                });
                $(e.currentTarget).closest(".jstree-node").children(".jstree-anchor").first().trigger(tmp).trigger("focus");
            }).on("click.jstree", ".jstree-leaf > .jstree-ocl", (function(e) {
                e.stopImmediatePropagation();
                var tmp = $.Event("click", {
                    metaKey: e.metaKey,
                    ctrlKey: e.ctrlKey,
                    altKey: e.altKey,
                    shiftKey: e.shiftKey
                });
                $(e.currentTarget).closest(".jstree-node").children(".jstree-anchor").first().trigger(tmp).trigger("focus");
            }).bind(this)).on("mouseover.jstree", ".jstree-wholerow, .jstree-icon", (function(e) {
                e.stopImmediatePropagation();
                if (!this.is_disabled(e.currentTarget)) this.hover_node(e.currentTarget);
                return false;
            }).bind(this)).on("mouseleave.jstree", ".jstree-node", (function(e) {
                this.dehover_node(e.currentTarget);
            }).bind(this));
        };
        this.teardown = function() {
            if (this.settings.wholerow) this.element.find(".jstree-wholerow").remove();
            parent.teardown.call(this);
        };
        this.redraw_node = function(obj, deep, callback, force_render) {
            obj = parent.redraw_node.apply(this, arguments);
            if (obj) {
                var tmp = div.cloneNode(true);
                //tmp.style.height = this._data.core.li_height + 'px';
                if ($.inArray(obj.id, this._data.core.selected) !== -1) tmp.className += " jstree-wholerow-clicked";
                if (this._data.core.focused && this._data.core.focused === obj.id) tmp.className += " jstree-wholerow-hovered";
                obj.insertBefore(tmp, obj.childNodes[0]);
            }
            return obj;
        };
    };
    // include the wholerow plugin by default
    // $.jstree.defaults.plugins.push("wholerow");
    if (window.customElements && Object && Object.create) {
        var proto = Object.create(HTMLElement.prototype);
        proto.createdCallback = function() {
            var c = {
                core: {},
                plugins: []
            }, i;
            for(i in $.jstree.plugins)if ($.jstree.plugins.hasOwnProperty(i) && this.attributes[i]) {
                c.plugins.push(i);
                if (this.getAttribute(i) && JSON.parse(this.getAttribute(i))) c[i] = JSON.parse(this.getAttribute(i));
            }
            for(i in $.jstree.defaults.core)if ($.jstree.defaults.core.hasOwnProperty(i) && this.attributes[i]) c.core[i] = JSON.parse(this.getAttribute(i)) || this.getAttribute(i);
            $(this).jstree(c);
        };
        // proto.attributeChangedCallback = function (name, previous, value) { };
        try {
            window.customElements.define("vakata-jstree", function() {}, {
                prototype: proto
            });
        } catch (ignore) {}
    }
});


// Copyright (C) 2006 Google Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @fileoverview
 * some functions for browser-side pretty printing of code contained in html.
 *
 * <p>
 * For a fairly comprehensive set of languages see the
 * <a href="http://google-code-prettify.googlecode.com/svn/trunk/README.html#langs">README</a>
 * file that came with this source.  At a minimum, the lexer should work on a
 * number of languages including C and friends, Java, Python, Bash, SQL, HTML,
 * XML, CSS, Javascript, and Makefiles.  It works passably on Ruby, PHP and Awk
 * and a subset of Perl, but, because of commenting conventions, doesn't work on
 * Smalltalk, Lisp-like, or CAML-like languages without an explicit lang class.
 * <p>
 * Usage: <ol>
 * <li> include this source file in an html page via
 *   {@code <script type="text/javascript" src="/path/to/prettify.js"></script>}
 * <li> define style rules.  See the example page for examples.
 * <li> mark the {@code <pre>} and {@code <code>} tags in your source with
 *    {@code class=prettyprint.}
 *    You can also use the (html deprecated) {@code <xmp>} tag, but the pretty
 *    printer needs to do more substantial DOM manipulations to support that, so
 *    some css styles may not be preserved.
 * </ol>
 * That's it.  I wanted to keep the API as simple as possible, so there's no
 * need to specify which language the code is in, but if you wish, you can add
 * another class to the {@code <pre>} or {@code <code>} element to specify the
 * language, as in {@code <pre class="prettyprint lang-java">}.  Any class that
 * starts with "lang-" followed by a file extension, specifies the file type.
 * See the "lang-*.js" files in this directory for code that implements
 * per-language file handlers.
 * <p>
 * Change log:<br>
 * cbeust, 2006/08/22
 * <blockquote>
 *   Java annotations (start with "@") are now captured as literals ("lit")
 * </blockquote>
 * @requires console
 */ // JSLint declarations
/*global console, document, navigator, setTimeout, window, define */ /** @define {boolean} */ var $064cde56955e6095$var$IN_GLOBAL_SCOPE = true;
/**
 * Split {@code prettyPrint} into multiple timeouts so as not to interfere with
 * UI events.
 * If set to {@code false}, {@code prettyPrint()} is synchronous.
 */ window["PR_SHOULD_USE_CONTINUATION"] = true;
/**
 * Pretty print a chunk of code.
 * @param {string} sourceCodeHtml The HTML to pretty print.
 * @param {string} opt_langExtension The language name to use.
 *     Typically, a filename extension like 'cpp' or 'java'.
 * @param {number|boolean} opt_numberLines True to number lines,
 *     or the 1-indexed number of the first line in sourceCodeHtml.
 * @return {string} code as html, but prettier
 */ var $064cde56955e6095$var$prettyPrintOne;
/**
 * Find all the {@code <pre>} and {@code <code>} tags in the DOM with
 * {@code class=prettyprint} and prettify them.
 *
 * @param {Function} opt_whenDone called when prettifying is done.
 * @param {HTMLElement|HTMLDocument} opt_root an element or document
 *   containing all the elements to pretty print.
 *   Defaults to {@code document.body}.
 */ var $064cde56955e6095$var$prettyPrint;
(function() {
    var win = window;
    // Keyword lists for various languages.
    // We use things that coerce to strings to make them compact when minified
    // and to defeat aggressive optimizers that fold large string constants.
    var FLOW_CONTROL_KEYWORDS = [
        "break,continue,do,else,for,if,return,while"
    ];
    var C_KEYWORDS = [
        FLOW_CONTROL_KEYWORDS,
        "auto,case,char,const,default,double,enum,extern,float,goto,inline,int,long,register,short,signed,sizeof,static,struct,switch,typedef,union,unsigned,void,volatile"
    ];
    var COMMON_KEYWORDS = [
        C_KEYWORDS,
        "catch,class,delete,false,import,new,operator,private,protected,public,this,throw,true,try,typeof"
    ];
    var CPP_KEYWORDS = [
        COMMON_KEYWORDS,
        "alignof,align_union,asm,axiom,bool,concept,concept_map,const_cast,constexpr,decltype,delegate,dynamic_cast,explicit,export,friend,generic,late_check,mutable,namespace,nullptr,property,reinterpret_cast,static_assert,static_cast,template,typeid,typename,using,virtual,where"
    ];
    var JAVA_KEYWORDS = [
        COMMON_KEYWORDS,
        "abstract,assert,boolean,byte,extends,final,finally,implements,import,instanceof,interface,null,native,package,strictfp,super,synchronized,throws,transient"
    ];
    var CSHARP_KEYWORDS = [
        JAVA_KEYWORDS,
        "as,base,by,checked,decimal,delegate,descending,dynamic,event,fixed,foreach,from,group,implicit,in,internal,into,is,let,lock,object,out,override,orderby,params,partial,readonly,ref,sbyte,sealed,stackalloc,string,select,uint,ulong,unchecked,unsafe,ushort,var,virtual,where"
    ];
    var COFFEE_KEYWORDS = "all,and,by,catch,class,else,extends,false,finally,for,if,in,is,isnt,loop,new,no,not,null,of,off,on,or,return,super,then,throw,true,try,unless,until,when,while,yes";
    var JSCRIPT_KEYWORDS = [
        COMMON_KEYWORDS,
        "debugger,eval,export,function,get,null,set,undefined,var,with,Infinity,NaN"
    ];
    var PERL_KEYWORDS = "caller,delete,die,do,dump,elsif,eval,exit,foreach,for,goto,if,import,last,local,my,next,no,our,print,package,redo,require,sub,undef,unless,until,use,wantarray,while,BEGIN,END";
    var PYTHON_KEYWORDS = [
        FLOW_CONTROL_KEYWORDS,
        "and,as,assert,class,def,del,elif,except,exec,finally,from,global,import,in,is,lambda,nonlocal,not,or,pass,print,raise,try,with,yield,False,True,None"
    ];
    var RUBY_KEYWORDS = [
        FLOW_CONTROL_KEYWORDS,
        "alias,and,begin,case,class,def,defined,elsif,end,ensure,false,in,module,next,nil,not,or,redo,rescue,retry,self,super,then,true,undef,unless,until,when,yield,BEGIN,END"
    ];
    var RUST_KEYWORDS = [
        FLOW_CONTROL_KEYWORDS,
        "as,assert,const,copy,drop,enum,extern,fail,false,fn,impl,let,log,loop,match,mod,move,mut,priv,pub,pure,ref,self,static,struct,true,trait,type,unsafe,use"
    ];
    var SH_KEYWORDS = [
        FLOW_CONTROL_KEYWORDS,
        "case,done,elif,esac,eval,fi,function,in,local,set,then,until"
    ];
    var ALL_KEYWORDS = [
        CPP_KEYWORDS,
        CSHARP_KEYWORDS,
        JSCRIPT_KEYWORDS,
        PERL_KEYWORDS,
        PYTHON_KEYWORDS,
        RUBY_KEYWORDS,
        SH_KEYWORDS
    ];
    var C_TYPES = /^(DIR|FILE|vector|(de|priority_)?queue|list|stack|(const_)?iterator|(multi)?(set|map)|bitset|u?(int|float)\d*)\b/;
    // token style names.  correspond to css classes
    /**
   * token style for a string literal
   * @const
   */ var PR_STRING = "str";
    /**
   * token style for a keyword
   * @const
   */ var PR_KEYWORD = "kwd";
    /**
   * token style for a comment
   * @const
   */ var PR_COMMENT = "com";
    /**
   * token style for a type
   * @const
   */ var PR_TYPE = "typ";
    /**
   * token style for a literal value.  e.g. 1, null, true.
   * @const
   */ var PR_LITERAL = "lit";
    /**
   * token style for a punctuation string.
   * @const
   */ var PR_PUNCTUATION = "pun";
    /**
   * token style for plain text.
   * @const
   */ var PR_PLAIN = "pln";
    /**
   * token style for an sgml tag.
   * @const
   */ var PR_TAG = "tag";
    /**
   * token style for a markup declaration such as a DOCTYPE.
   * @const
   */ var PR_DECLARATION = "dec";
    /**
   * token style for embedded source.
   * @const
   */ var PR_SOURCE = "src";
    /**
   * token style for an sgml attribute name.
   * @const
   */ var PR_ATTRIB_NAME = "atn";
    /**
   * token style for an sgml attribute value.
   * @const
   */ var PR_ATTRIB_VALUE = "atv";
    /**
   * A class that indicates a section of markup that is not code, e.g. to allow
   * embedding of line numbers within code listings.
   * @const
   */ var PR_NOCODE = "nocode";
    /**
   * A set of tokens that can precede a regular expression literal in
   * javascript
   * http://web.archive.org/web/20070717142515/http://www.mozilla.org/js/language/js20/rationale/syntax.html
   * has the full list, but I've removed ones that might be problematic when
   * seen in languages that don't support regular expression literals.
   *
   * <p>Specifically, I've removed any keywords that can't precede a regexp
   * literal in a syntactically legal javascript program, and I've removed the
   * "in" keyword since it's not a keyword in many languages, and might be used
   * as a count of inches.
   *
   * <p>The link above does not accurately describe EcmaScript rules since
   * it fails to distinguish between (a=++/b/i) and (a++/b/i) but it works
   * very well in practice.
   *
   * @private
   * @const
   */ var REGEXP_PRECEDER_PATTERN = "(?:^^\\.?|[+-]|[!=]=?=?|\\#|%=?|&&?=?|\\(|\\*=?|[+\\-]=|->|\\/=?|::?|<<?=?|>>?>?=?|,|;|\\?|@|\\[|~|{|\\^\\^?=?|\\|\\|?=?|break|case|continue|delete|do|else|finally|instanceof|return|throw|try|typeof)\\s*";
    // CAVEAT: this does not properly handle the case where a regular
    // expression immediately follows another since a regular expression may
    // have flags for case-sensitivity and the like.  Having regexp tokens
    // adjacent is not valid in any language I'm aware of, so I'm punting.
    // TODO: maybe style special characters inside a regexp as punctuation.
    /**
   * Given a group of {@link RegExp}s, returns a {@code RegExp} that globally
   * matches the union of the sets of strings matched by the input RegExp.
   * Since it matches globally, if the input strings have a start-of-input
   * anchor (/^.../), it is ignored for the purposes of unioning.
   * @param {Array.<RegExp>} regexs non multiline, non-global regexs.
   * @return {RegExp} a global regex.
   */ function combinePrefixPatterns(regexs) {
        var capturedGroupIndex = 0;
        var needToFoldCase = false;
        var ignoreCase = false;
        for(var i = 0, n = regexs.length; i < n; ++i){
            var regex = regexs[i];
            if (regex.ignoreCase) ignoreCase = true;
            else if (/[a-z]/i.test(regex.source.replace(/\\u[0-9a-f]{4}|\\x[0-9a-f]{2}|\\[^ux]/gi, ""))) {
                needToFoldCase = true;
                ignoreCase = false;
                break;
            }
        }
        var escapeCharToCodeUnit = {
            "b": 8,
            "t": 9,
            "n": 0xa,
            "v": 0xb,
            "f": 0xc,
            "r": 0xd
        };
        function decodeEscape(charsetPart) {
            var cc0 = charsetPart.charCodeAt(0);
            if (cc0 !== 92 /* \\ */ ) return cc0;
            var c1 = charsetPart.charAt(1);
            cc0 = escapeCharToCodeUnit[c1];
            if (cc0) return cc0;
            else if ("0" <= c1 && c1 <= "7") return parseInt(charsetPart.substring(1), 8);
            else if (c1 === "u" || c1 === "x") return parseInt(charsetPart.substring(2), 16);
            else return charsetPart.charCodeAt(1);
        }
        function encodeEscape(charCode) {
            if (charCode < 0x20) return (charCode < 0x10 ? "\\x0" : "\\x") + charCode.toString(16);
            var ch = String.fromCharCode(charCode);
            return ch === "\\" || ch === "-" || ch === "]" || ch === "^" ? "\\" + ch : ch;
        }
        function caseFoldCharset(charSet) {
            var charsetParts = charSet.substring(1, charSet.length - 1).match(new RegExp("\\\\u[0-9A-Fa-f]{4}|\\\\x[0-9A-Fa-f]{2}|\\\\[0-3][0-7]{0,2}|\\\\[0-7]{1,2}|\\\\[\\s\\S]|-|[^-\\\\]", "g"));
            var ranges = [];
            var inverse = charsetParts[0] === "^";
            var out = [
                "["
            ];
            if (inverse) out.push("^");
            for(var i = inverse ? 1 : 0, n = charsetParts.length; i < n; ++i){
                var p = charsetParts[i];
                if (/\\[bdsw]/i.test(p)) out.push(p);
                else {
                    var start = decodeEscape(p);
                    var end;
                    if (i + 2 < n && "-" === charsetParts[i + 1]) {
                        end = decodeEscape(charsetParts[i + 2]);
                        i += 2;
                    } else end = start;
                    ranges.push([
                        start,
                        end
                    ]);
                    // If the range might intersect letters, then expand it.
                    // This case handling is too simplistic.
                    // It does not deal with non-latin case folding.
                    // It works for latin source code identifiers though.
                    if (!(end < 65 || start > 122)) {
                        if (!(end < 65 || start > 90)) ranges.push([
                            Math.max(65, start) | 32,
                            Math.min(end, 90) | 32
                        ]);
                        if (!(end < 97 || start > 122)) ranges.push([
                            Math.max(97, start) & -33,
                            Math.min(end, 122) & -33
                        ]);
                    }
                }
            }
            // [[1, 10], [3, 4], [8, 12], [14, 14], [16, 16], [17, 17]]
            // -> [[1, 12], [14, 14], [16, 17]]
            ranges.sort(function(a, b) {
                return a[0] - b[0] || b[1] - a[1];
            });
            var consolidatedRanges = [];
            var lastRange = [];
            for(var i = 0; i < ranges.length; ++i){
                var range = ranges[i];
                if (range[0] <= lastRange[1] + 1) lastRange[1] = Math.max(lastRange[1], range[1]);
                else consolidatedRanges.push(lastRange = range);
            }
            for(var i = 0; i < consolidatedRanges.length; ++i){
                var range = consolidatedRanges[i];
                out.push(encodeEscape(range[0]));
                if (range[1] > range[0]) {
                    if (range[1] + 1 > range[0]) out.push("-");
                    out.push(encodeEscape(range[1]));
                }
            }
            out.push("]");
            return out.join("");
        }
        function allowAnywhereFoldCaseAndRenumberGroups(regex) {
            // Split into character sets, escape sequences, punctuation strings
            // like ('(', '(?:', ')', '^'), and runs of characters that do not
            // include any of the above.
            var parts = regex.source.match(new RegExp("(?:\\[(?:[^\\x5C\\x5D]|\\\\[\\s\\S])*\\]|\\\\u[A-Fa-f0-9]{4}|\\\\x[A-Fa-f0-9]{2}|\\\\[0-9]+|\\\\[^ux0-9]|\\(\\?[:!=]|[\\(\\)\\^]|[^\\x5B\\x5C\\(\\)\\^]+)", "g"));
            var n = parts.length;
            // Maps captured group numbers to the number they will occupy in
            // the output or to -1 if that has not been determined, or to
            // undefined if they need not be capturing in the output.
            var capturedGroups = [];
            // Walk over and identify back references to build the capturedGroups
            // mapping.
            for(var i = 0, groupIndex = 0; i < n; ++i){
                var p = parts[i];
                if (p === "(") // groups are 1-indexed, so max group index is count of '('
                ++groupIndex;
                else if ("\\" === p.charAt(0)) {
                    var decimalValue = +p.substring(1);
                    if (decimalValue) {
                        if (decimalValue <= groupIndex) capturedGroups[decimalValue] = -1;
                        else // Replace with an unambiguous escape sequence so that
                        // an octal escape sequence does not turn into a backreference
                        // to a capturing group from an earlier regex.
                        parts[i] = encodeEscape(decimalValue);
                    }
                }
            }
            // Renumber groups and reduce capturing groups to non-capturing groups
            // where possible.
            for(var i = 1; i < capturedGroups.length; ++i)if (-1 === capturedGroups[i]) capturedGroups[i] = ++capturedGroupIndex;
            for(var i = 0, groupIndex = 0; i < n; ++i){
                var p = parts[i];
                if (p === "(") {
                    ++groupIndex;
                    if (!capturedGroups[groupIndex]) parts[i] = "(?:";
                } else if ("\\" === p.charAt(0)) {
                    var decimalValue = +p.substring(1);
                    if (decimalValue && decimalValue <= groupIndex) parts[i] = "\\" + capturedGroups[decimalValue];
                }
            }
            // Remove any prefix anchors so that the output will match anywhere.
            // ^^ really does mean an anchored match though.
            for(var i = 0; i < n; ++i)if ("^" === parts[i] && "^" !== parts[i + 1]) parts[i] = "";
            // Expand letters to groups to handle mixing of case-sensitive and
            // case-insensitive patterns if necessary.
            if (regex.ignoreCase && needToFoldCase) for(var i = 0; i < n; ++i){
                var p = parts[i];
                var ch0 = p.charAt(0);
                if (p.length >= 2 && ch0 === "[") parts[i] = caseFoldCharset(p);
                else if (ch0 !== "\\") // TODO: handle letters in numeric escapes.
                parts[i] = p.replace(/[a-zA-Z]/g, function(ch) {
                    var cc = ch.charCodeAt(0);
                    return "[" + String.fromCharCode(cc & -33, cc | 32) + "]";
                });
            }
            return parts.join("");
        }
        var rewritten = [];
        for(var i = 0, n = regexs.length; i < n; ++i){
            var regex = regexs[i];
            if (regex.global || regex.multiline) throw new Error("" + regex);
            rewritten.push("(?:" + allowAnywhereFoldCaseAndRenumberGroups(regex) + ")");
        }
        return new RegExp(rewritten.join("|"), ignoreCase ? "gi" : "g");
    }
    /**
   * Split markup into a string of source code and an array mapping ranges in
   * that string to the text nodes in which they appear.
   *
   * <p>
   * The HTML DOM structure:</p>
   * <pre>
   * (Element   "p"
   *   (Element "b"
   *     (Text  "print "))       ; #1
   *   (Text    "'Hello '")      ; #2
   *   (Element "br")            ; #3
   *   (Text    "  + 'World';")) ; #4
   * </pre>
   * <p>
   * corresponds to the HTML
   * {@code <p><b>print </b>'Hello '<br>  + 'World';</p>}.</p>
   *
   * <p>
   * It will produce the output:</p>
   * <pre>
   * {
   *   sourceCode: "print 'Hello '\n  + 'World';",
   *   //                     1          2
   *   //           012345678901234 5678901234567
   *   spans: [0, #1, 6, #2, 14, #3, 15, #4]
   * }
   * </pre>
   * <p>
   * where #1 is a reference to the {@code "print "} text node above, and so
   * on for the other text nodes.
   * </p>
   *
   * <p>
   * The {@code} spans array is an array of pairs.  Even elements are the start
   * indices of substrings, and odd elements are the text nodes (or BR elements)
   * that contain the text for those substrings.
   * Substrings continue until the next index or the end of the source.
   * </p>
   *
   * @param {Node} node an HTML DOM subtree containing source-code.
   * @param {boolean} isPreformatted true if white-space in text nodes should
   *    be considered significant.
   * @return {Object} source code and the text nodes in which they occur.
   */ function extractSourceSpans(node, isPreformatted) {
        var nocode = /(?:^|\s)nocode(?:\s|$)/;
        var chunks = [];
        var length = 0;
        var spans = [];
        var k = 0;
        function walk(node) {
            var type = node.nodeType;
            if (type == 1) {
                if (nocode.test(node.className)) return;
                for(var child = node.firstChild; child; child = child.nextSibling)walk(child);
                var nodeName = node.nodeName.toLowerCase();
                if ("br" === nodeName || "li" === nodeName) {
                    chunks[k] = "\n";
                    spans[k << 1] = length++;
                    spans[k++ << 1 | 1] = node;
                }
            } else if (type == 3 || type == 4) {
                var text = node.nodeValue;
                if (text.length) {
                    if (!isPreformatted) text = text.replace(/[ \t\r\n]+/g, " ");
                    else text = text.replace(/\r\n?/g, "\n"); // Normalize newlines.
                    // TODO: handle tabs here?
                    chunks[k] = text;
                    spans[k << 1] = length;
                    length += text.length;
                    spans[k++ << 1 | 1] = node;
                }
            }
        }
        walk(node);
        return {
            sourceCode: chunks.join("").replace(/\n$/, ""),
            spans: spans
        };
    }
    /**
   * Apply the given language handler to sourceCode and add the resulting
   * decorations to out.
   * @param {number} basePos the index of sourceCode within the chunk of source
   *    whose decorations are already present on out.
   */ function appendDecorations(basePos, sourceCode, langHandler, out) {
        if (!sourceCode) return;
        var job = {
            sourceCode: sourceCode,
            basePos: basePos
        };
        langHandler(job);
        out.push.apply(out, job.decorations);
    }
    var notWs = /\S/;
    /**
   * Given an element, if it contains only one child element and any text nodes
   * it contains contain only space characters, return the sole child element.
   * Otherwise returns undefined.
   * <p>
   * This is meant to return the CODE element in {@code <pre><code ...>} when
   * there is a single child element that contains all the non-space textual
   * content, but not to return anything where there are multiple child elements
   * as in {@code <pre><code>...</code><code>...</code></pre>} or when there
   * is textual content.
   */ function childContentWrapper(element) {
        var wrapper = undefined;
        for(var c = element.firstChild; c; c = c.nextSibling){
            var type = c.nodeType;
            wrapper = type === 1 // Element Node
             ? wrapper ? element : c : type === 3 // Text Node
             ? notWs.test(c.nodeValue) ? element : wrapper : wrapper;
        }
        return wrapper === element ? undefined : wrapper;
    }
    /** Given triples of [style, pattern, context] returns a lexing function,
    * The lexing function interprets the patterns to find token boundaries and
    * returns a decoration list of the form
    * [index_0, style_0, index_1, style_1, ..., index_n, style_n]
    * where index_n is an index into the sourceCode, and style_n is a style
    * constant like PR_PLAIN.  index_n-1 <= index_n, and style_n-1 applies to
    * all characters in sourceCode[index_n-1:index_n].
    *
    * The stylePatterns is a list whose elements have the form
    * [style : string, pattern : RegExp, DEPRECATED, shortcut : string].
    *
    * Style is a style constant like PR_PLAIN, or can be a string of the
    * form 'lang-FOO', where FOO is a language extension describing the
    * language of the portion of the token in $1 after pattern executes.
    * E.g., if style is 'lang-lisp', and group 1 contains the text
    * '(hello (world))', then that portion of the token will be passed to the
    * registered lisp handler for formatting.
    * The text before and after group 1 will be restyled using this decorator
    * so decorators should take care that this doesn't result in infinite
    * recursion.  For example, the HTML lexer rule for SCRIPT elements looks
    * something like ['lang-js', /<[s]cript>(.+?)<\/script>/].  This may match
    * '<script>foo()<\/script>', which would cause the current decorator to
    * be called with '<script>' which would not match the same rule since
    * group 1 must not be empty, so it would be instead styled as PR_TAG by
    * the generic tag rule.  The handler registered for the 'js' extension would
    * then be called with 'foo()', and finally, the current decorator would
    * be called with '<\/script>' which would not match the original rule and
    * so the generic tag rule would identify it as a tag.
    *
    * Pattern must only match prefixes, and if it matches a prefix, then that
    * match is considered a token with the same style.
    *
    * Context is applied to the last non-whitespace, non-comment token
    * recognized.
    *
    * Shortcut is an optional string of characters, any of which, if the first
    * character, gurantee that this pattern and only this pattern matches.
    *
    * @param {Array} shortcutStylePatterns patterns that always start with
    *   a known character.  Must have a shortcut string.
    * @param {Array} fallthroughStylePatterns patterns that will be tried in
    *   order if the shortcut ones fail.  May have shortcuts.
    *
    * @return {function (Object)} a
    *   function that takes source code and returns a list of decorations.
    */ function createSimpleLexer(shortcutStylePatterns, fallthroughStylePatterns) {
        var shortcuts = {};
        var tokenizer;
        (function() {
            var allPatterns = shortcutStylePatterns.concat(fallthroughStylePatterns);
            var allRegexs = [];
            var regexKeys = {};
            for(var i = 0, n = allPatterns.length; i < n; ++i){
                var patternParts = allPatterns[i];
                var shortcutChars = patternParts[3];
                if (shortcutChars) for(var c = shortcutChars.length; --c >= 0;)shortcuts[shortcutChars.charAt(c)] = patternParts;
                var regex = patternParts[1];
                var k = "" + regex;
                if (!regexKeys.hasOwnProperty(k)) {
                    allRegexs.push(regex);
                    regexKeys[k] = null;
                }
            }
            allRegexs.push(/[\0-\uffff]/);
            tokenizer = combinePrefixPatterns(allRegexs);
        })();
        var nPatterns = fallthroughStylePatterns.length;
        /**
     * Lexes job.sourceCode and produces an output array job.decorations of
     * style classes preceded by the position at which they start in
     * job.sourceCode in order.
     *
     * @param {Object} job an object like <pre>{
     *    sourceCode: {string} sourceText plain text,
     *    basePos: {int} position of job.sourceCode in the larger chunk of
     *        sourceCode.
     * }</pre>
     */ var decorate = function(job) {
            var sourceCode = job.sourceCode, basePos = job.basePos;
            /** Even entries are positions in source in ascending order.  Odd enties
        * are style markers (e.g., PR_COMMENT) that run from that position until
        * the end.
        * @type {Array.<number|string>}
        */ var decorations = [
                basePos,
                PR_PLAIN
            ];
            var pos = 0; // index into sourceCode
            var tokens = sourceCode.match(tokenizer) || [];
            var styleCache = {};
            for(var ti = 0, nTokens = tokens.length; ti < nTokens; ++ti){
                var token = tokens[ti];
                var style = styleCache[token];
                var match = void 0;
                var isEmbedded;
                if (typeof style === "string") isEmbedded = false;
                else {
                    var patternParts = shortcuts[token.charAt(0)];
                    if (patternParts) {
                        match = token.match(patternParts[1]);
                        style = patternParts[0];
                    } else {
                        for(var i = 0; i < nPatterns; ++i){
                            patternParts = fallthroughStylePatterns[i];
                            match = token.match(patternParts[1]);
                            if (match) {
                                style = patternParts[0];
                                break;
                            }
                        }
                        if (!match) style = PR_PLAIN;
                    }
                    isEmbedded = style.length >= 5 && "lang-" === style.substring(0, 5);
                    if (isEmbedded && !(match && typeof match[1] === "string")) {
                        isEmbedded = false;
                        style = PR_SOURCE;
                    }
                    if (!isEmbedded) styleCache[token] = style;
                }
                var tokenStart = pos;
                pos += token.length;
                if (!isEmbedded) decorations.push(basePos + tokenStart, style);
                else {
                    var embeddedSource = match[1];
                    var embeddedSourceStart = token.indexOf(embeddedSource);
                    var embeddedSourceEnd = embeddedSourceStart + embeddedSource.length;
                    if (match[2]) {
                        // If embeddedSource can be blank, then it would match at the
                        // beginning which would cause us to infinitely recurse on the
                        // entire token, so we catch the right context in match[2].
                        embeddedSourceEnd = token.length - match[2].length;
                        embeddedSourceStart = embeddedSourceEnd - embeddedSource.length;
                    }
                    var lang = style.substring(5);
                    // Decorate the left of the embedded source
                    appendDecorations(basePos + tokenStart, token.substring(0, embeddedSourceStart), decorate, decorations);
                    // Decorate the embedded source
                    appendDecorations(basePos + tokenStart + embeddedSourceStart, embeddedSource, langHandlerForExtension(lang, embeddedSource), decorations);
                    // Decorate the right of the embedded section
                    appendDecorations(basePos + tokenStart + embeddedSourceEnd, token.substring(embeddedSourceEnd), decorate, decorations);
                }
            }
            job.decorations = decorations;
        };
        return decorate;
    }
    /** returns a function that produces a list of decorations from source text.
    *
    * This code treats ", ', and ` as string delimiters, and \ as a string
    * escape.  It does not recognize perl's qq() style strings.
    * It has no special handling for double delimiter escapes as in basic, or
    * the tripled delimiters used in python, but should work on those regardless
    * although in those cases a single string literal may be broken up into
    * multiple adjacent string literals.
    *
    * It recognizes C, C++, and shell style comments.
    *
    * @param {Object} options a set of optional parameters.
    * @return {function (Object)} a function that examines the source code
    *     in the input job and builds the decoration list.
    */ function sourceDecorator(options) {
        var shortcutStylePatterns = [], fallthroughStylePatterns = [];
        if (options["tripleQuotedStrings"]) // '''multi-line-string''', 'single-line-string', and double-quoted
        shortcutStylePatterns.push([
            PR_STRING,
            /^(?:\'\'\'(?:[^\'\\]|\\[\s\S]|\'{1,2}(?=[^\']))*(?:\'\'\'|$)|\"\"\"(?:[^\"\\]|\\[\s\S]|\"{1,2}(?=[^\"]))*(?:\"\"\"|$)|\'(?:[^\\\']|\\[\s\S])*(?:\'|$)|\"(?:[^\\\"]|\\[\s\S])*(?:\"|$))/,
            null,
            "'\""
        ]);
        else if (options["multiLineStrings"]) // 'multi-line-string', "multi-line-string"
        shortcutStylePatterns.push([
            PR_STRING,
            /^(?:\'(?:[^\\\']|\\[\s\S])*(?:\'|$)|\"(?:[^\\\"]|\\[\s\S])*(?:\"|$)|\`(?:[^\\\`]|\\[\s\S])*(?:\`|$))/,
            null,
            "'\"`"
        ]);
        else // 'single-line-string', "single-line-string"
        shortcutStylePatterns.push([
            PR_STRING,
            /^(?:\'(?:[^\\\'\r\n]|\\.)*(?:\'|$)|\"(?:[^\\\"\r\n]|\\.)*(?:\"|$))/,
            null,
            "\"'"
        ]);
        if (options["verbatimStrings"]) // verbatim-string-literal production from the C# grammar.  See issue 93.
        fallthroughStylePatterns.push([
            PR_STRING,
            /^@\"(?:[^\"]|\"\")*(?:\"|$)/,
            null
        ]);
        var hc = options["hashComments"];
        if (hc) {
            if (options["cStyleComments"]) {
                if (hc > 1) shortcutStylePatterns.push([
                    PR_COMMENT,
                    /^#(?:##(?:[^#]|#(?!##))*(?:###|$)|.*)/,
                    null,
                    "#"
                ]);
                else // Stop C preprocessor declarations at an unclosed open comment
                shortcutStylePatterns.push([
                    PR_COMMENT,
                    /^#(?:(?:define|e(?:l|nd)if|else|error|ifn?def|include|line|pragma|undef|warning)\b|[^\r\n]*)/,
                    null,
                    "#"
                ]);
                // #include <stdio.h>
                fallthroughStylePatterns.push([
                    PR_STRING,
                    /^<(?:(?:(?:\.\.\/)*|\/?)(?:[\w-]+(?:\/[\w-]+)+)?[\w-]+\.h(?:h|pp|\+\+)?|[a-z]\w*)>/,
                    null
                ]);
            } else shortcutStylePatterns.push([
                PR_COMMENT,
                /^#[^\r\n]*/,
                null,
                "#"
            ]);
        }
        if (options["cStyleComments"]) {
            fallthroughStylePatterns.push([
                PR_COMMENT,
                /^\/\/[^\r\n]*/,
                null
            ]);
            fallthroughStylePatterns.push([
                PR_COMMENT,
                /^\/\*[\s\S]*?(?:\*\/|$)/,
                null
            ]);
        }
        var regexLiterals = options["regexLiterals"];
        if (regexLiterals) {
            /**
       * @const
       */ var regexExcls = regexLiterals > 1 ? "" // Multiline regex literals
             : "\n\r";
            /**
       * @const
       */ var regexAny = regexExcls ? "." : "[\\S\\s]";
            /**
       * @const
       */ var REGEX_LITERAL = // A regular expression literal starts with a slash that is
            // not followed by * or / so that it is not confused with
            // comments.
            "/(?=[^/*" + regexExcls + "])" + "(?:[^/\\x5B\\x5C" + regexExcls + "]" + "|\\x5C" + regexAny + "|\\x5B(?:[^\\x5C\\x5D" + regexExcls + "]" + "|\\x5C" + regexAny + ")*(?:\\x5D|$))+" + "/";
            fallthroughStylePatterns.push([
                "lang-regex",
                RegExp("^" + REGEXP_PRECEDER_PATTERN + "(" + REGEX_LITERAL + ")")
            ]);
        }
        var types = options["types"];
        if (types) fallthroughStylePatterns.push([
            PR_TYPE,
            types
        ]);
        var keywords = ("" + options["keywords"]).replace(/^ | $/g, "");
        if (keywords.length) fallthroughStylePatterns.push([
            PR_KEYWORD,
            new RegExp("^(?:" + keywords.replace(/[\s,]+/g, "|") + ")\\b"),
            null
        ]);
        shortcutStylePatterns.push([
            PR_PLAIN,
            /^\s+/,
            null,
            " \r\n	\xa0"
        ]);
        var punctuation = // The Bash man page says
        // A word is a sequence of characters considered as a single
        // unit by GRUB. Words are separated by metacharacters,
        // which are the following plus space, tab, and newline: { }
        // | & $ ; < >
        // ...
        // A word beginning with # causes that word and all remaining
        // characters on that line to be ignored.
        // which means that only a '#' after /(?:^|[{}|&$;<>\s])/ starts a
        // comment but empirically
        // $ echo {#}
        // {#}
        // $ echo \$#
        // $#
        // $ echo }#
        // }#
        // so /(?:^|[|&;<>\s])/ is more appropriate.
        // http://gcc.gnu.org/onlinedocs/gcc-2.95.3/cpp_1.html#SEC3
        // suggests that this definition is compatible with a
        // default mode that tries to use a single token definition
        // to recognize both bash/python style comments and C
        // preprocessor directives.
        // This definition of punctuation does not include # in the list of
        // follow-on exclusions, so # will not be broken before if preceeded
        // by a punctuation character.  We could try to exclude # after
        // [|&;<>] but that doesn't seem to cause many major problems.
        // If that does turn out to be a problem, we should change the below
        // when hc is truthy to include # in the run of punctuation characters
        // only when not followint [|&;<>].
        "^.[^\\s\\w.$@'\"`/\\\\]*";
        if (options["regexLiterals"]) punctuation += "(?!s*/)";
        fallthroughStylePatterns.push(// TODO(mikesamuel): recognize non-latin letters and numerals in idents
        [
            PR_LITERAL,
            /^@[a-z_$][a-z_$@0-9]*/i,
            null
        ], [
            PR_TYPE,
            /^(?:[@_]?[A-Z]+[a-z][A-Za-z_$@0-9]*|\w+_t\b)/,
            null
        ], [
            PR_PLAIN,
            /^[a-z_$][a-z_$@0-9]*/i,
            null
        ], [
            PR_LITERAL,
            new RegExp("^(?:0x[a-f0-9]+|(?:\\d(?:_\\d+)*\\d*(?:\\.\\d*)?|\\.\\d\\+)(?:e[+\\-]?\\d+)?)[a-z]*", "i"),
            null,
            "0123456789"
        ], // Don't treat escaped quotes in bash as starting strings.
        // See issue 144.
        [
            PR_PLAIN,
            /^\\[\s\S]?/,
            null
        ], [
            PR_PUNCTUATION,
            new RegExp(punctuation),
            null
        ]);
        return createSimpleLexer(shortcutStylePatterns, fallthroughStylePatterns);
    }
    var decorateSource = sourceDecorator({
        "keywords": ALL_KEYWORDS,
        "hashComments": true,
        "cStyleComments": true,
        "multiLineStrings": true,
        "regexLiterals": true
    });
    /**
   * Given a DOM subtree, wraps it in a list, and puts each line into its own
   * list item.
   *
   * @param {Node} node modified in place.  Its content is pulled into an
   *     HTMLOListElement, and each line is moved into a separate list item.
   *     This requires cloning elements, so the input might not have unique
   *     IDs after numbering.
   * @param {boolean} isPreformatted true iff white-space in text nodes should
   *     be treated as significant.
   */ function numberLines(node, opt_startLineNum, isPreformatted) {
        var nocode = /(?:^|\s)nocode(?:\s|$)/;
        var lineBreak = /\r\n?|\n/;
        var document1 = node.ownerDocument;
        var li = document1.createElement("li");
        while(node.firstChild)li.appendChild(node.firstChild);
        // An array of lines.  We split below, so this is initialized to one
        // un-split line.
        var listItems = [
            li
        ];
        function walk(node) {
            var type = node.nodeType;
            if (type == 1 && !nocode.test(node.className)) {
                if ("br" === node.nodeName) {
                    breakAfter(node);
                    // Discard the <BR> since it is now flush against a </LI>.
                    if (node.parentNode) node.parentNode.removeChild(node);
                } else for(var child = node.firstChild; child; child = child.nextSibling)walk(child);
            } else if ((type == 3 || type == 4) && isPreformatted) {
                var text = node.nodeValue;
                var match = text.match(lineBreak);
                if (match) {
                    var firstLine = text.substring(0, match.index);
                    node.nodeValue = firstLine;
                    var tail = text.substring(match.index + match[0].length);
                    if (tail) {
                        var parent = node.parentNode;
                        parent.insertBefore(document1.createTextNode(tail), node.nextSibling);
                    }
                    breakAfter(node);
                    if (!firstLine) // Don't leave blank text nodes in the DOM.
                    node.parentNode.removeChild(node);
                }
            }
        }
        // Split a line after the given node.
        function breakAfter(lineEndNode) {
            // If there's nothing to the right, then we can skip ending the line
            // here, and move root-wards since splitting just before an end-tag
            // would require us to create a bunch of empty copies.
            while(!lineEndNode.nextSibling){
                lineEndNode = lineEndNode.parentNode;
                if (!lineEndNode) return;
            }
            function breakLeftOf(limit, copy) {
                // Clone shallowly if this node needs to be on both sides of the break.
                var rightSide = copy ? limit.cloneNode(false) : limit;
                var parent = limit.parentNode;
                if (parent) {
                    // We clone the parent chain.
                    // This helps us resurrect important styling elements that cross lines.
                    // E.g. in <i>Foo<br>Bar</i>
                    // should be rewritten to <li><i>Foo</i></li><li><i>Bar</i></li>.
                    var parentClone = breakLeftOf(parent, 1);
                    // Move the clone and everything to the right of the original
                    // onto the cloned parent.
                    var next = limit.nextSibling;
                    parentClone.appendChild(rightSide);
                    for(var sibling = next; sibling; sibling = next){
                        next = sibling.nextSibling;
                        parentClone.appendChild(sibling);
                    }
                }
                return rightSide;
            }
            var copiedListItem = breakLeftOf(lineEndNode.nextSibling, 0);
            // Walk the parent chain until we reach an unattached LI.
            for(var parent; // Check nodeType since IE invents document fragments.
            (parent = copiedListItem.parentNode) && parent.nodeType === 1;)copiedListItem = parent;
            // Put it on the list of lines for later processing.
            listItems.push(copiedListItem);
        }
        // Split lines while there are lines left to split.
        for(var i = 0; i < listItems.length; ++i)walk(listItems[i]);
        // Make sure numeric indices show correctly.
        if (opt_startLineNum === (opt_startLineNum | 0)) listItems[0].setAttribute("value", opt_startLineNum);
        var ol = document1.createElement("ol");
        ol.className = "linenums";
        var offset = Math.max(0, opt_startLineNum - 1 /* zero index */  | 0) || 0;
        for(var i = 0, n = listItems.length; i < n; ++i){
            li = listItems[i];
            // Stick a class on the LIs so that stylesheets can
            // color odd/even rows, or any other row pattern that
            // is co-prime with 10.
            li.className = "L" + (i + offset) % 10;
            if (!li.firstChild) li.appendChild(document1.createTextNode("\xa0"));
            ol.appendChild(li);
        }
        node.appendChild(ol);
    }
    /**
   * Breaks {@code job.sourceCode} around style boundaries in
   * {@code job.decorations} and modifies {@code job.sourceNode} in place.
   * @param {Object} job like <pre>{
   *    sourceCode: {string} source as plain text,
   *    sourceNode: {HTMLElement} the element containing the source,
   *    spans: {Array.<number|Node>} alternating span start indices into source
   *       and the text node or element (e.g. {@code <BR>}) corresponding to that
   *       span.
   *    decorations: {Array.<number|string} an array of style classes preceded
   *       by the position at which they start in job.sourceCode in order
   * }</pre>
   * @private
   */ function recombineTagsAndDecorations(job) {
        var isIE8OrEarlier = /\bMSIE\s(\d+)/.exec(navigator.userAgent);
        isIE8OrEarlier = isIE8OrEarlier && +isIE8OrEarlier[1] <= 8;
        var newlineRe = /\n/g;
        var source = job.sourceCode;
        var sourceLength = source.length;
        // Index into source after the last code-unit recombined.
        var sourceIndex = 0;
        var spans = job.spans;
        var nSpans = spans.length;
        // Index into spans after the last span which ends at or before sourceIndex.
        var spanIndex = 0;
        var decorations = job.decorations;
        var nDecorations = decorations.length;
        // Index into decorations after the last decoration which ends at or before
        // sourceIndex.
        var decorationIndex = 0;
        // Remove all zero-length decorations.
        decorations[nDecorations] = sourceLength;
        var decPos, i;
        for(i = decPos = 0; i < nDecorations;)if (decorations[i] !== decorations[i + 2]) {
            decorations[decPos++] = decorations[i++];
            decorations[decPos++] = decorations[i++];
        } else i += 2;
        nDecorations = decPos;
        // Simplify decorations.
        for(i = decPos = 0; i < nDecorations;){
            var startPos = decorations[i];
            // Conflate all adjacent decorations that use the same style.
            var startDec = decorations[i + 1];
            var end = i + 2;
            while(end + 2 <= nDecorations && decorations[end + 1] === startDec)end += 2;
            decorations[decPos++] = startPos;
            decorations[decPos++] = startDec;
            i = end;
        }
        nDecorations = decorations.length = decPos;
        var sourceNode = job.sourceNode;
        var oldDisplay;
        if (sourceNode) {
            oldDisplay = sourceNode.style.display;
            sourceNode.style.display = "none";
        }
        try {
            var decoration = null;
            while(spanIndex < nSpans){
                var spanStart = spans[spanIndex];
                var spanEnd = spans[spanIndex + 2] || sourceLength;
                var decEnd = decorations[decorationIndex + 2] || sourceLength;
                var end = Math.min(spanEnd, decEnd);
                var textNode = spans[spanIndex + 1];
                var styledText;
                if (textNode.nodeType !== 1 // Don't muck with <BR>s or <LI>s
                 && (styledText = source.substring(sourceIndex, end))) {
                    // This may seem bizarre, and it is.  Emitting LF on IE causes the
                    // code to display with spaces instead of line breaks.
                    // Emitting Windows standard issue linebreaks (CRLF) causes a blank
                    // space to appear at the beginning of every line but the first.
                    // Emitting an old Mac OS 9 line separator makes everything spiffy.
                    if (isIE8OrEarlier) styledText = styledText.replace(newlineRe, "\r");
                    textNode.nodeValue = styledText;
                    var document1 = textNode.ownerDocument;
                    var span = document1.createElement("span");
                    span.className = decorations[decorationIndex + 1];
                    var parentNode = textNode.parentNode;
                    parentNode.replaceChild(span, textNode);
                    span.appendChild(textNode);
                    if (sourceIndex < spanEnd) {
                        spans[spanIndex + 1] = textNode = document1.createTextNode(source.substring(end, spanEnd));
                        parentNode.insertBefore(textNode, span.nextSibling);
                    }
                }
                sourceIndex = end;
                if (sourceIndex >= spanEnd) spanIndex += 2;
                if (sourceIndex >= decEnd) decorationIndex += 2;
            }
        } finally{
            if (sourceNode) sourceNode.style.display = oldDisplay;
        }
    }
    /** Maps language-specific file extensions to handlers. */ var langHandlerRegistry = {};
    /** Register a language handler for the given file extensions.
    * @param {function (Object)} handler a function from source code to a list
    *      of decorations.  Takes a single argument job which describes the
    *      state of the computation.   The single parameter has the form
    *      {@code {
    *        sourceCode: {string} as plain text.
    *        decorations: {Array.<number|string>} an array of style classes
    *                     preceded by the position at which they start in
    *                     job.sourceCode in order.
    *                     The language handler should assigned this field.
    *        basePos: {int} the position of source in the larger source chunk.
    *                 All positions in the output decorations array are relative
    *                 to the larger source chunk.
    *      } }
    * @param {Array.<string>} fileExtensions
    */ function registerLangHandler(handler, fileExtensions) {
        for(var i = fileExtensions.length; --i >= 0;){
            var ext = fileExtensions[i];
            if (!langHandlerRegistry.hasOwnProperty(ext)) langHandlerRegistry[ext] = handler;
            else if (win["console"]) console["warn"]("cannot override language handler %s", ext);
        }
    }
    function langHandlerForExtension(extension, source) {
        if (!(extension && langHandlerRegistry.hasOwnProperty(extension))) // Treat it as markup if the first non whitespace character is a < and
        // the last non-whitespace character is a >.
        extension = /^\s*</.test(source) ? "default-markup" : "default-code";
        return langHandlerRegistry[extension];
    }
    registerLangHandler(decorateSource, [
        "default-code"
    ]);
    registerLangHandler(createSimpleLexer([], [
        [
            PR_PLAIN,
            /^[^<?]+/
        ],
        [
            PR_DECLARATION,
            /^<!\w[^>]*(?:>|$)/
        ],
        [
            PR_COMMENT,
            /^<\!--[\s\S]*?(?:-\->|$)/
        ],
        // Unescaped content in an unknown language
        [
            "lang-",
            /^<\?([\s\S]+?)(?:\?>|$)/
        ],
        [
            "lang-",
            /^<%([\s\S]+?)(?:%>|$)/
        ],
        [
            PR_PUNCTUATION,
            /^(?:<[%?]|[%?]>)/
        ],
        [
            "lang-",
            /^<xmp\b[^>]*>([\s\S]+?)<\/xmp\b[^>]*>/i
        ],
        // Unescaped content in javascript.  (Or possibly vbscript).
        [
            "lang-js",
            /^<script\b[^>]*>([\s\S]*?)(<\/script\b[^>]*>)/i
        ],
        // Contains unescaped stylesheet content
        [
            "lang-css",
            /^<style\b[^>]*>([\s\S]*?)(<\/style\b[^>]*>)/i
        ],
        [
            "lang-in.tag",
            /^(<\/?[a-z][^<>]*>)/i
        ]
    ]), [
        "default-markup",
        "htm",
        "html",
        "mxml",
        "xhtml",
        "xml",
        "xsl"
    ]);
    registerLangHandler(createSimpleLexer([
        [
            PR_PLAIN,
            /^[\s]+/,
            null,
            " 	\r\n"
        ],
        [
            PR_ATTRIB_VALUE,
            /^(?:\"[^\"]*\"?|\'[^\']*\'?)/,
            null,
            "\"'"
        ]
    ], [
        [
            PR_TAG,
            /^^<\/?[a-z](?:[\w.:-]*\w)?|\/?>$/i
        ],
        [
            PR_ATTRIB_NAME,
            /^(?!style[\s=]|on)[a-z](?:[\w:-]*\w)?/i
        ],
        [
            "lang-uq.val",
            /^=\s*([^>\'\"\s]*(?:[^>\'\"\s\/]|\/(?=\s)))/
        ],
        [
            PR_PUNCTUATION,
            /^[=<>\/]+/
        ],
        [
            "lang-js",
            /^on\w+\s*=\s*\"([^\"]+)\"/i
        ],
        [
            "lang-js",
            /^on\w+\s*=\s*\'([^\']+)\'/i
        ],
        [
            "lang-js",
            /^on\w+\s*=\s*([^\"\'>\s]+)/i
        ],
        [
            "lang-css",
            /^style\s*=\s*\"([^\"]+)\"/i
        ],
        [
            "lang-css",
            /^style\s*=\s*\'([^\']+)\'/i
        ],
        [
            "lang-css",
            /^style\s*=\s*([^\"\'>\s]+)/i
        ]
    ]), [
        "in.tag"
    ]);
    registerLangHandler(createSimpleLexer([], [
        [
            PR_ATTRIB_VALUE,
            /^[\s\S]+/
        ]
    ]), [
        "uq.val"
    ]);
    registerLangHandler(sourceDecorator({
        "keywords": CPP_KEYWORDS,
        "hashComments": true,
        "cStyleComments": true,
        "types": C_TYPES
    }), [
        "c",
        "cc",
        "cpp",
        "cxx",
        "cyc",
        "m"
    ]);
    registerLangHandler(sourceDecorator({
        "keywords": "null,true,false"
    }), [
        "json"
    ]);
    registerLangHandler(sourceDecorator({
        "keywords": CSHARP_KEYWORDS,
        "hashComments": true,
        "cStyleComments": true,
        "verbatimStrings": true,
        "types": C_TYPES
    }), [
        "cs"
    ]);
    registerLangHandler(sourceDecorator({
        "keywords": JAVA_KEYWORDS,
        "cStyleComments": true
    }), [
        "java"
    ]);
    registerLangHandler(sourceDecorator({
        "keywords": SH_KEYWORDS,
        "hashComments": true,
        "multiLineStrings": true
    }), [
        "bash",
        "bsh",
        "csh",
        "sh"
    ]);
    registerLangHandler(sourceDecorator({
        "keywords": PYTHON_KEYWORDS,
        "hashComments": true,
        "multiLineStrings": true,
        "tripleQuotedStrings": true
    }), [
        "cv",
        "py",
        "python"
    ]);
    registerLangHandler(sourceDecorator({
        "keywords": PERL_KEYWORDS,
        "hashComments": true,
        "multiLineStrings": true,
        "regexLiterals": 2 // multiline regex literals
    }), [
        "perl",
        "pl",
        "pm"
    ]);
    registerLangHandler(sourceDecorator({
        "keywords": RUBY_KEYWORDS,
        "hashComments": true,
        "multiLineStrings": true,
        "regexLiterals": true
    }), [
        "rb",
        "ruby"
    ]);
    registerLangHandler(sourceDecorator({
        "keywords": JSCRIPT_KEYWORDS,
        "cStyleComments": true,
        "regexLiterals": true
    }), [
        "javascript",
        "js"
    ]);
    registerLangHandler(sourceDecorator({
        "keywords": COFFEE_KEYWORDS,
        "hashComments": 3,
        "cStyleComments": true,
        "multilineStrings": true,
        "tripleQuotedStrings": true,
        "regexLiterals": true
    }), [
        "coffee"
    ]);
    registerLangHandler(sourceDecorator({
        "keywords": RUST_KEYWORDS,
        "cStyleComments": true,
        "multilineStrings": true
    }), [
        "rc",
        "rs",
        "rust"
    ]);
    registerLangHandler(createSimpleLexer([], [
        [
            PR_STRING,
            /^[\s\S]+/
        ]
    ]), [
        "regex"
    ]);
    function applyDecorator(job) {
        var opt_langExtension = job.langExtension;
        try {
            // Extract tags, and convert the source code to plain text.
            var sourceAndSpans = extractSourceSpans(job.sourceNode, job.pre);
            /** Plain text. @type {string} */ var source = sourceAndSpans.sourceCode;
            job.sourceCode = source;
            job.spans = sourceAndSpans.spans;
            job.basePos = 0;
            // Apply the appropriate language handler
            langHandlerForExtension(opt_langExtension, source)(job);
            // Integrate the decorations and tags back into the source code,
            // modifying the sourceNode in place.
            recombineTagsAndDecorations(job);
        } catch (e) {
            if (win["console"]) console["log"](e && e["stack"] || e);
        }
    }
    /**
   * Pretty print a chunk of code.
   * @param sourceCodeHtml {string} The HTML to pretty print.
   * @param opt_langExtension {string} The language name to use.
   *     Typically, a filename extension like 'cpp' or 'java'.
   * @param opt_numberLines {number|boolean} True to number lines,
   *     or the 1-indexed number of the first line in sourceCodeHtml.
   */ function $prettyPrintOne(sourceCodeHtml, opt_langExtension, opt_numberLines) {
        var container = document.createElement("div");
        // This could cause images to load and onload listeners to fire.
        // E.g. <img onerror="alert(1337)" src="nosuchimage.png">.
        // We assume that the inner HTML is from a trusted source.
        // The pre-tag is required for IE8 which strips newlines from innerHTML
        // when it is injected into a <pre> tag.
        // http://stackoverflow.com/questions/451486/pre-tag-loses-line-breaks-when-setting-innerhtml-in-ie
        // http://stackoverflow.com/questions/195363/inserting-a-newline-into-a-pre-tag-ie-javascript
        container.innerHTML = "<pre>" + sourceCodeHtml + "</pre>";
        container = container.firstChild;
        if (opt_numberLines) numberLines(container, opt_numberLines, true);
        var job = {
            langExtension: opt_langExtension,
            numberLines: opt_numberLines,
            sourceNode: container,
            pre: 1
        };
        applyDecorator(job);
        return container.innerHTML;
    }
    /**
    * Find all the {@code <pre>} and {@code <code>} tags in the DOM with
    * {@code class=prettyprint} and prettify them.
    *
    * @param {Function} opt_whenDone called when prettifying is done.
    * @param {HTMLElement|HTMLDocument} opt_root an element or document
    *   containing all the elements to pretty print.
    *   Defaults to {@code document.body}.
    */ function $prettyPrint(opt_whenDone, opt_root) {
        var root = opt_root || document.body;
        var doc = root.ownerDocument || document;
        function byTagName(tn) {
            return root.getElementsByTagName(tn);
        }
        // fetch a list of nodes to rewrite
        var codeSegments = [
            byTagName("pre"),
            byTagName("code"),
            byTagName("xmp")
        ];
        var elements = [];
        for(var i = 0; i < codeSegments.length; ++i)for(var j = 0, n = codeSegments[i].length; j < n; ++j)elements.push(codeSegments[i][j]);
        codeSegments = null;
        var clock = Date;
        if (!clock["now"]) clock = {
            "now": function() {
                return +new Date;
            }
        };
        // The loop is broken into a series of continuations to make sure that we
        // don't make the browser unresponsive when rewriting a large page.
        var k = 0;
        var prettyPrintingJob;
        var langExtensionRe = /\blang(?:uage)?-([\w.]+)(?!\S)/;
        var prettyPrintRe = /\bprettyprint\b/;
        var prettyPrintedRe = /\bprettyprinted\b/;
        var preformattedTagNameRe = /pre|xmp/i;
        var codeRe = /^code$/i;
        var preCodeXmpRe = /^(?:pre|code|xmp)$/i;
        var EMPTY = {};
        function doWork() {
            var endTime = win["PR_SHOULD_USE_CONTINUATION"] ? clock["now"]() + 250 /* ms */  : Infinity;
            for(; k < elements.length && clock["now"]() < endTime; k++){
                var cs = elements[k];
                // Look for a preceding comment like
                // <?prettify lang="..." linenums="..."?>
                var attrs = EMPTY;
                for(var preceder = cs; preceder = preceder.previousSibling;){
                    var nt = preceder.nodeType;
                    // <?foo?> is parsed by HTML 5 to a comment node (8)
                    // like <!--?foo?-->, but in XML is a processing instruction
                    var value = (nt === 7 || nt === 8) && preceder.nodeValue;
                    if (value ? !/^\??prettify\b/.test(value) : nt !== 3 || /\S/.test(preceder.nodeValue)) break;
                    if (value) {
                        attrs = {};
                        value.replace(/\b(\w+)=([\w:.%+-]+)/g, function(_, name, value) {
                            attrs[name] = value;
                        });
                        break;
                    }
                }
                var className = cs.className;
                if ((attrs !== EMPTY || prettyPrintRe.test(className)) && !prettyPrintedRe.test(className)) {
                    // make sure this is not nested in an already prettified element
                    var nested = false;
                    for(var p = cs.parentNode; p; p = p.parentNode){
                        var tn = p.tagName;
                        if (preCodeXmpRe.test(tn) && p.className && prettyPrintRe.test(p.className)) {
                            nested = true;
                            break;
                        }
                    }
                    if (!nested) {
                        // Mark done.  If we fail to prettyprint for whatever reason,
                        // we shouldn't try again.
                        cs.className += " prettyprinted";
                        // If the classes includes a language extensions, use it.
                        // Language extensions can be specified like
                        //     <pre class="prettyprint lang-cpp">
                        // the language extension "cpp" is used to find a language handler
                        // as passed to PR.registerLangHandler.
                        // HTML5 recommends that a language be specified using "language-"
                        // as the prefix instead.  Google Code Prettify supports both.
                        // http://dev.w3.org/html5/spec-author-view/the-code-element.html
                        var langExtension = attrs["lang"];
                        if (!langExtension) {
                            langExtension = className.match(langExtensionRe);
                            // Support <pre class="prettyprint"><code class="language-c">
                            var wrapper;
                            if (!langExtension && (wrapper = childContentWrapper(cs)) && codeRe.test(wrapper.tagName)) langExtension = wrapper.className.match(langExtensionRe);
                            if (langExtension) langExtension = langExtension[1];
                        }
                        var preformatted;
                        if (preformattedTagNameRe.test(cs.tagName)) preformatted = 1;
                        else {
                            var currentStyle = cs["currentStyle"];
                            var defaultView = doc.defaultView;
                            var whitespace = currentStyle ? currentStyle["whiteSpace"] : defaultView && defaultView.getComputedStyle ? defaultView.getComputedStyle(cs, null).getPropertyValue("white-space") : 0;
                            preformatted = whitespace && "pre" === whitespace.substring(0, 3);
                        }
                        // Look for a class like linenums or linenums:<n> where <n> is the
                        // 1-indexed number of the first line.
                        var lineNums = attrs["linenums"];
                        if (!(lineNums = lineNums === "true" || +lineNums)) {
                            lineNums = className.match(/\blinenums\b(?::(\d+))?/);
                            lineNums = lineNums ? lineNums[1] && lineNums[1].length ? +lineNums[1] : true : false;
                        }
                        if (lineNums) numberLines(cs, lineNums, preformatted);
                        // do the pretty printing
                        prettyPrintingJob = {
                            langExtension: langExtension,
                            sourceNode: cs,
                            numberLines: lineNums,
                            pre: preformatted
                        };
                        applyDecorator(prettyPrintingJob);
                    }
                }
            }
            if (k < elements.length) // finish up in a continuation
            setTimeout(doWork, 250);
            else if ("function" === typeof opt_whenDone) opt_whenDone();
        }
        doWork();
    }
    /**
   * Contains functions for creating and registering new language handlers.
   * @type {Object}
   */ var PR = win["PR"] = {
        "createSimpleLexer": createSimpleLexer,
        "registerLangHandler": registerLangHandler,
        "sourceDecorator": sourceDecorator,
        "PR_ATTRIB_NAME": PR_ATTRIB_NAME,
        "PR_ATTRIB_VALUE": PR_ATTRIB_VALUE,
        "PR_COMMENT": PR_COMMENT,
        "PR_DECLARATION": PR_DECLARATION,
        "PR_KEYWORD": PR_KEYWORD,
        "PR_LITERAL": PR_LITERAL,
        "PR_NOCODE": PR_NOCODE,
        "PR_PLAIN": PR_PLAIN,
        "PR_PUNCTUATION": PR_PUNCTUATION,
        "PR_SOURCE": PR_SOURCE,
        "PR_STRING": PR_STRING,
        "PR_TAG": PR_TAG,
        "PR_TYPE": PR_TYPE,
        "prettyPrintOne": $064cde56955e6095$var$IN_GLOBAL_SCOPE ? win["prettyPrintOne"] = $prettyPrintOne : $064cde56955e6095$var$prettyPrintOne = $prettyPrintOne,
        "prettyPrint": $064cde56955e6095$var$prettyPrint = $064cde56955e6095$var$IN_GLOBAL_SCOPE ? win["prettyPrint"] = $prettyPrint : $064cde56955e6095$var$prettyPrint = $prettyPrint
    };
    // Make PR available via the Asynchronous Module Definition (AMD) API.
    // Per https://github.com/amdjs/amdjs-api/wiki/AMD:
    // The Asynchronous Module Definition (AMD) API specifies a
    // mechanism for defining modules such that the module and its
    // dependencies can be asynchronously loaded.
    // ...
    // To allow a clear indicator that a global define function (as
    // needed for script src browser loading) conforms to the AMD API,
    // any global define function SHOULD have a property called "amd"
    // whose value is an object. This helps avoid conflict with any
    // other existing JavaScript code that could have defined a define()
    // function that does not conform to the AMD API.
    if (typeof define === "function" && define["amd"]) define("google-code-prettify", [], function() {
        return PR;
    });
})();


(function(window1) {
    "use strict";
    var patternfly1 = {
        version: "3.59.4"
    };
    // definition of breakpoint sizes for tablet and desktop modes
    patternfly1.pfBreakpoints = {
        "tablet": 768,
        "desktop": 1200
    };
    window1.patternfly = patternfly1;
})(typeof window !== "undefined" ? window : $parcel$global);
(function(window1) {
    "use strict";
    // Ensure we are assigning these to the patternfly property of the window argument, and not the implicit global patternfly
    var patternfly1 = window1.patternfly;
    // Util: PatternFly Palette colors
    patternfly1.pfPaletteColors = {
        black: "#030303",
        black100: "#fafafa",
        black200: "#ededed",
        black300: "#d1d1d1",
        black400: "#bbbbbb",
        black500: "#8b8d8f",
        black600: "#72767b",
        black700: "#4d5258",
        black800: "#393f44",
        black900: "#292e34",
        blue: "#0088ce",
        blue100: "#bee1f4",
        blue200: "#7dc3e8",
        blue300: "#39a5dc",
        blue400: "#0088ce",
        blue500: "#00659c",
        blue600: "#004368",
        blue700: "#002235",
        gold: "#f0ab00",
        gold100: "#fbeabc",
        gold200: "#f9d67a",
        gold300: "#f5c12e",
        gold400: "#f0ab00",
        gold500: "#b58100",
        gold600: "#795600",
        gold700: "#3d2c00",
        orange: "#ec7a08",
        orange100: "#fbdebf",
        orange200: "#f7bd7f",
        orange300: "#f39d3c",
        orange400: "#ec7a08",
        orange500: "#b35c00",
        orange600: "#773d00",
        orange700: "#3b1f00",
        lightBlue: "#00b9e4",
        lightBlue100: "#beedf9",
        lightBlue200: "#7cdbf3",
        lightBlue300: "#35caed",
        lightBlue400: "#00b9e4",
        lightBlue500: "#008bad",
        lightBlue600: "#005c73",
        lightBlue700: "#002d39",
        green: "#3f9c35",
        green100: "#cfe7cd",
        green200: "#9ecf99",
        green300: "#6ec664",
        green400: "#3f9c35",
        green500: "#2d7623",
        green600: "#1e4f18",
        green700: "#0f280d",
        lightGreen: "#92d400",
        lightGreen100: "#e4f5bc",
        lightGreen200: "#c8eb79",
        lightGreen300: "#ace12e",
        lightGreen400: "#92d400",
        lightGreen500: "#6ca100",
        lightGreen600: "#486b00",
        lightGreen700: "#253600",
        cyan: "#007a87",
        cyan100: "#bedee1",
        cyan200: "#7dbdc3",
        cyan300: "#3a9ca6",
        cyan400: "#007a87",
        cyan500: "#005c66",
        cyan600: "#003d44",
        cyan700: "#001f22",
        purple: "#703fec",
        purple100: "#c7bfff",
        purple200: "#a18fff",
        purple300: "#8461f7",
        purple400: "#703fec",
        purple500: "#582fc0",
        purple600: "#40199a",
        purple700: "#1f0066",
        red: "#cc0000",
        red100: "#cc0000",
        red200: "#a30000",
        red300: "#8b0000",
        red400: "#470000",
        red500: "#2c0000"
    };
})(typeof window !== "undefined" ? window : $parcel$global);
(function(window1) {
    "use strict";
    // Ensure we are assigning these to the patternfly property of the window argument, and not the implicit global patternfly
    var patternfly1 = window1.patternfly;
    // Util: PatternFly C3 Chart Defaults
    patternfly1.pfSetDonutChartTitle = function(selector, primary, secondary) {
        var donutChartRightTitle = window1.d3.select(selector).select("text.c3-chart-arcs-title");
        donutChartRightTitle.text("");
        donutChartRightTitle.insert("tspan").text(primary).classed("donut-title-big-pf", true).attr("y", 0).attr("x", 0);
        donutChartRightTitle.insert("tspan").text(secondary).classed("donut-title-small-pf", true).attr("y", 20).attr("x", 0);
    };
    patternfly1.pfDonutTooltipContents = function(d, defaultTitleFormat, defaultValueFormat, color) {
        return '<table class="c3-tooltip">  <tr>    <td><span style="background-color:' + color(d[0].id) + '"></span>' + "<strong>" + d[0].value + "</strong> " + d[0].name + "</td>" + "    <td>" + Math.round(d[0].ratio * 1000) / 10 + "%</td>" + "  </tr>" + "</table>";
    };
    patternfly1.pfGetUtilizationDonutTooltipContentsFn = function(units) {
        return function(d) {
            return '<span class="donut-tooltip-pf" style="white-space: nowrap;">' + Math.round(d[0].ratio * 1000) / 10 + "%" + " " + units + " " + d[0].name + "</span>";
        };
    };
    patternfly1.pfGetBarChartTooltipContentsFn = function(categories) {
        return function(d) {
            var name = categories ? categories[d[0].index] : d[0].index;
            return '<table class="c3-tooltip">  <tr>    <td><strong>' + name + ":</td>" + "    <td>" + d[0].value + "</td>" + "  </tr>" + "</table>";
        };
    };
    patternfly1.pfSingleLineChartTooltipContentsFn = function(categories) {
        return function(d) {
            var name = categories ? categories[d[0].index] : d[0].index;
            return '<table class="c3-tooltip">  <tr>    <td><strong>' + name + ":</td>" + "    <td>" + d[0].value + "</td>" + "  </tr>" + "</table>";
        };
    };
    patternfly1.pfPieTooltipContents = function(d, defaultTitleFormat, defaultValueFormat, color) {
        return patternfly1.pfDonutTooltipContents(d, defaultTitleFormat, defaultValueFormat, color);
    };
    patternfly1.c3ChartDefaults = function() {
        var getDefaultColors = function() {
            return {
                pattern: [
                    patternfly1.pfPaletteColors.blue,
                    patternfly1.pfPaletteColors.blue300,
                    patternfly1.pfPaletteColors.green,
                    patternfly1.pfPaletteColors.orange,
                    patternfly1.pfPaletteColors.red
                ]
            };
        }, getDefaultBarGrid = function() {
            return {
                y: {
                    show: true
                }
            };
        }, getDefaultBarTooltip = function(categories) {
            return {
                contents: patternfly1.pfGetBarChartTooltipContentsFn(categories)
            };
        }, getDefaultBarLegend = function() {
            return {
                show: false
            };
        }, getDefaultBarConfig = function(categories) {
            return {
                color: this.getDefaultColors(),
                grid: this.getDefaultBarGrid(),
                tooltip: this.getDefaultBarTooltip(categories),
                legend: this.getDefaultBarLegend()
            };
        }, getDefaultGroupedBarGrid = function() {
            return {
                y: {
                    show: true
                }
            };
        }, getDefaultGroupedBarLegend = function() {
            return {
                show: true,
                position: "bottom"
            };
        }, getDefaultGroupedBarConfig = function() {
            return {
                color: this.getDefaultColors(),
                grid: this.getDefaultGroupedBarGrid(),
                legend: this.getDefaultGroupedBarLegend()
            };
        }, getDefaultStackedBarGrid = function() {
            return {
                y: {
                    show: true
                }
            };
        }, getDefaultStackedBarLegend = function() {
            return {
                show: true,
                position: "bottom"
            };
        }, getDefaultStackedBarConfig = function() {
            return {
                color: this.getDefaultColors(),
                grid: this.getDefaultStackedBarGrid(),
                legend: this.getDefaultStackedBarLegend()
            };
        }, getDefaultDonut = function(title) {
            return {
                title: title,
                label: {
                    show: false
                },
                width: 11
            };
        }, getDefaultDonutSize = function() {
            return {
                height: 171 // produces a diameter of 150 and a centered chart when there is no legend
            };
        }, getDefaultDonutColors = function() {
            return {
                pattern: [
                    patternfly1.pfPaletteColors.blue,
                    patternfly1.pfPaletteColors.black300
                ]
            };
        }, getDefaultRelationshipDonutColors = function() {
            return {
                pattern: [
                    patternfly1.pfPaletteColors.blue,
                    patternfly1.pfPaletteColors.red100,
                    patternfly1.pfPaletteColors.orange400,
                    patternfly1.pfPaletteColors.green400,
                    patternfly1.pfPaletteColors.cyan500,
                    patternfly1.pfPaletteColors.gold200
                ]
            };
        }, getDefaultDonutTooltip = function() {
            return {
                show: false
            };
        }, getDefaultDonutLegend = function() {
            return {
                show: false
            };
        }, getDefaultDonutConfig = function(title) {
            return {
                donut: this.getDefaultDonut(title),
                size: this.getDefaultDonutSize(),
                legend: this.getDefaultDonutLegend(),
                color: this.getDefaultDonutColors(),
                tooltip: this.getDefaultDonutTooltip()
            };
        }, getDefaultRelationshipDonutConfig = function(title) {
            return {
                donut: this.getDefaultDonut(title),
                size: this.getDefaultDonutSize(),
                legend: this.getDefaultDonutLegend(),
                color: this.getDefaultRelationshipDonutColors(),
                tooltip: this.getDefaultDonutTooltip()
            };
        }, getDefaultPie = function() {
            return {
                expand: true,
                label: {
                    show: false
                }
            };
        }, getDefaultPieSize = function() {
            return {
                height: 171 // produces a diameter of 150 and a centered chart when there is no legend
            };
        }, getDefaultPieColors = function() {
            return {
                pattern: [
                    patternfly1.pfPaletteColors.blue,
                    patternfly1.pfPaletteColors.black300
                ]
            };
        }, getDefaultPieTooltip = function() {
            return {
                contents: patternfly1.pfPieTooltipContents
            };
        }, getDefaultPieLegend = function() {
            return {
                show: false
            };
        }, getDefaultPieConfig = function() {
            return {
                pie: this.getDefaultPie(),
                size: this.getDefaultPieSize(),
                legend: this.getDefaultPieLegend(),
                color: this.getDefaultPieColors(),
                tooltip: this.getDefaultPieTooltip()
            };
        }, getDefaultSparklineArea = function() {
            return {
                zerobased: true
            };
        }, getDefaultSparklineSize = function() {
            return {
                height: 60
            };
        }, getDefaultSparklineAxis = function() {
            return {
                x: {
                    show: false
                },
                y: {
                    show: false
                }
            };
        }, getDefaultSparklineLegend = function() {
            return {
                show: false
            };
        }, getDefaultSparklinePoint = function() {
            return {
                r: 1,
                focus: {
                    expand: {
                        r: 4
                    }
                }
            };
        }, getDefaultSparklineTooltip = function() {
            return {
                // because a sparkline should only contain a single data column,
                // the tooltip will only work for a single data column
                contents: function(d) {
                    return '<span class="c3-tooltip-sparkline">' + d[0].value + " " + d[0].name + "</span>";
                }
            };
        }, getDefaultSparklineConfig = function() {
            return {
                area: getDefaultSparklineArea(),
                size: getDefaultSparklineSize(),
                axis: getDefaultSparklineAxis(),
                color: getDefaultColors(),
                legend: getDefaultSparklineLegend(),
                point: getDefaultSparklinePoint(),
                tooltip: getDefaultSparklineTooltip()
            };
        }, getDefaultLineAxis = function() {
            return {
                x: {
                    show: true
                },
                y: {
                    show: true
                }
            };
        }, getDefaultLineGrid = function() {
            return {
                x: {
                    show: false
                },
                y: {
                    show: true
                }
            };
        }, getDefaultLineLegend = function() {
            return {
                show: true
            };
        }, getDefaultLinePoint = function() {
            return {
                r: 3,
                focus: {
                    expand: {
                        r: 5
                    }
                }
            };
        }, getDefaultLineConfig = function() {
            return {
                axis: getDefaultLineAxis(),
                grid: getDefaultLineGrid(),
                color: getDefaultColors(),
                legend: getDefaultLineLegend(),
                point: getDefaultLinePoint()
            };
        }, getDefaultSingleLineTooltip = function() {
            return {
                contents: patternfly1.pfGetBarChartTooltipContentsFn()
            };
        }, getDefaultSingleLineLegend = function() {
            return {
                show: false
            };
        }, getDefaultSingleLineConfig = function() {
            return {
                axis: getDefaultLineAxis(),
                grid: getDefaultLineGrid(),
                color: getDefaultColors(),
                legend: getDefaultSingleLineLegend(),
                point: getDefaultLinePoint(),
                tooltip: getDefaultSingleLineTooltip()
            };
        }, getDefaultAreaAxis = function() {
            return getDefaultLineAxis();
        }, getDefaultAreaGrid = function() {
            return getDefaultLineGrid();
        }, getDefaultAreaLegend = function() {
            return getDefaultLineLegend();
        }, getDefaultAreaPoint = function() {
            return getDefaultLinePoint();
        }, getDefaultAreaConfig = function() {
            return {
                axis: getDefaultAreaAxis(),
                grid: getDefaultAreaGrid(),
                color: getDefaultColors(),
                legend: getDefaultAreaLegend(),
                point: getDefaultAreaPoint()
            };
        }, getDefaultSingleAreaTooltip = function() {
            return {
                contents: patternfly1.pfGetBarChartTooltipContentsFn()
            };
        }, getDefaultSingleAreaLegend = function() {
            return getDefaultSingleLineLegend();
        }, getDefaultSingleAreaConfig = function() {
            return {
                axis: getDefaultAreaAxis(),
                grid: getDefaultAreaGrid(),
                color: getDefaultColors(),
                legend: getDefaultSingleAreaLegend(),
                point: getDefaultAreaPoint(),
                tooltip: getDefaultSingleAreaTooltip()
            };
        };
        return {
            getDefaultColors: getDefaultColors,
            getDefaultBarGrid: getDefaultBarGrid,
            getDefaultBarTooltip: getDefaultBarTooltip,
            getDefaultBarLegend: getDefaultBarLegend,
            getDefaultBarConfig: getDefaultBarConfig,
            getDefaultGroupedBarGrid: getDefaultGroupedBarGrid,
            getDefaultGroupedBarLegend: getDefaultGroupedBarLegend,
            getDefaultGroupedBarConfig: getDefaultGroupedBarConfig,
            getDefaultStackedBarGrid: getDefaultStackedBarGrid,
            getDefaultStackedBarLegend: getDefaultStackedBarLegend,
            getDefaultStackedBarConfig: getDefaultStackedBarConfig,
            getDefaultDonut: getDefaultDonut,
            getDefaultDonutSize: getDefaultDonutSize,
            getDefaultDonutColors: getDefaultDonutColors,
            getDefaultDonutTooltip: getDefaultDonutTooltip,
            getDefaultDonutLegend: getDefaultDonutLegend,
            getDefaultDonutConfig: getDefaultDonutConfig,
            getDefaultRelationshipDonutConfig: getDefaultRelationshipDonutConfig,
            getDefaultPie: getDefaultPie,
            getDefaultPieSize: getDefaultPieSize,
            getDefaultPieColors: getDefaultPieColors,
            getDefaultRelationshipDonutColors: getDefaultRelationshipDonutColors,
            getDefaultPieTooltip: getDefaultPieTooltip,
            getDefaultPieLegend: getDefaultPieLegend,
            getDefaultPieConfig: getDefaultPieConfig,
            getDefaultSparklineArea: getDefaultSparklineArea,
            getDefaultSparklineSize: getDefaultSparklineSize,
            getDefaultSparklineAxis: getDefaultSparklineAxis,
            getDefaultSparklineLegend: getDefaultSparklineLegend,
            getDefaultSparklinePoint: getDefaultSparklinePoint,
            getDefaultSparklineTooltip: getDefaultSparklineTooltip,
            getDefaultSparklineConfig: getDefaultSparklineConfig,
            getDefaultLineAxis: getDefaultLineAxis,
            getDefaultLineGrid: getDefaultLineGrid,
            getDefaultLineLegend: getDefaultLineLegend,
            getDefaultLinePoint: getDefaultLinePoint,
            getDefaultLineConfig: getDefaultLineConfig,
            getDefaultSingleLineTooltip: getDefaultSingleLineTooltip,
            getDefaultSingleLineConfig: getDefaultSingleLineConfig,
            getDefaultAreaAxis: getDefaultAreaAxis,
            getDefaultAreaGrid: getDefaultAreaGrid,
            getDefaultAreaLegend: getDefaultAreaLegend,
            getDefaultAreaPoint: getDefaultAreaPoint,
            getDefaultAreaConfig: getDefaultAreaConfig,
            getDefaultSingleAreaTooltip: getDefaultSingleAreaTooltip,
            getDefaultSingleAreaConfig: getDefaultSingleAreaConfig
        };
    };
})(typeof window !== "undefined" ? window : $parcel$global);
// Util: definition of breakpoint sizes for tablet and desktop modes
(function($) {
    "use strict";
    if (patternfly !== undefined) $.pfBreakpoints = patternfly.pfBreakpoints;
})(jQuery);
// PatternFly pf-list
(function($) {
    "use strict";
    $.fn.pfList = function() {
        function init(list) {
            // Ensure the state of the expansion elements is consistent
            list.find("[data-list=expansion], .list-pf-item, .list-pf-expansion").each(function(index, element) {
                var $expansion = $(element), $collapse = $expansion.find(".collapse").first(), expanded = $collapse.hasClass("in");
                updateChevron($expansion, expanded);
                if ($expansion.hasClass("list-pf-item")) updateActive($expansion, expanded);
            });
            list.find(".list-pf-container").each(function(index, element) {
                var $element = $(element);
                // The toggle element is the element with the data-list=toggle attribute
                // or the entire .list-pf-container as a fallback
                var $toggles = $element.find("[data-list=toggle]");
                $toggles.length || ($toggles = $element);
                $toggles.on("keydown", function(event) {
                    if (event.keyCode === 13 || event.keyCode === 32) {
                        toggleCollapse(this);
                        event.stopPropagation();
                        event.preventDefault();
                    }
                });
                $toggles.on("click", function(event) {
                    toggleCollapse(this);
                    event.stopPropagation();
                    event.preventDefault();
                });
            });
        }
        function toggleCollapse(toggle) {
            var $toggle, $expansion, $collapse, expanded, $listItem;
            $toggle = $(toggle);
            // Find the parent expansion of the toggle
            $expansion = $toggle.parentsUntil(".list-pf", "[data-list=expansion]").first();
            $expansion.length || ($expansion = $toggle.closest(".list-pf-item, .list-pf-expansion"));
            // toggle the "in" class of its  first .collapse child
            $collapse = $expansion.find(".collapse").first();
            $collapse.toggleClass("in");
            // update the state of the expansion element
            updateChevron($expansion, $collapse.hasClass("in"));
            $listItem = $expansion.closest(".list-pf-item");
            updateActive($listItem, $listItem.find(".collapse").first().hasClass("in"));
        }
        function updateActive($listItem, expanded) {
            // Find the closest .list-pf-item of the expansion, and set its "active" class
            if (expanded) $listItem.addClass("active");
            else $listItem.removeClass("active");
        }
        function updateChevron($expansion, expanded) {
            var $chevron = $expansion.find(".list-pf-chevron .fa").first();
            if (expanded) {
                $chevron.removeClass("fa-angle-right");
                $chevron.addClass("fa-angle-down");
            } else {
                $chevron.addClass("fa-angle-right");
                $chevron.removeClass("fa-angle-down");
            }
        }
        init(this);
        return this;
    };
})(jQuery);
// Util: PatternFly Sidebar
// Set height of sidebar-pf to height of document minus height of navbar-pf if not mobile
(function($) {
    "use strict";
    $.fn.sidebar = function() {
        var documentHeight = 0, navbarpfHeight = 0, colHeight = 0;
        if ($(".navbar-pf .navbar-toggle").is(":hidden")) {
            documentHeight = $(document).height();
            navbarpfHeight = $(".navbar-pf").outerHeight();
            colHeight = documentHeight - navbarpfHeight;
        }
        $(".sidebar-pf").parent(".row").children('[class*="col-"]').css({
            "min-height": colHeight
        });
    };
    $(document).ready(function() {
        // Call sidebar() on ready if .sidebar-pf exists and .datatable does not exist
        if ($(".sidebar-pf").length > 0 && $(".datatable").length === 0) $.fn.sidebar();
    });
    $(window).on("resize", function() {
        // Call sidebar() on resize if .sidebar-pf exists
        if ($(".sidebar-pf").length > 0) $.fn.sidebar();
    });
})(jQuery);
// Util: PatternFly Popovers
// Add data-close="true" to insert close X icon
(function($) {
    "use strict";
    $.fn.popovers = function() {
        // Initialize
        this.popover();
        // Add close icons
        this.filter("[data-close=true]").each(function(index, element) {
            var $this = $(element), title = $this.attr("data-original-title") + '<button type="button" class="close" aria-hidden="true"><span class="pficon pficon-close"></span></button>';
            $this.attr("data-original-title", title);
        });
        // Bind Close Icon to Toggle Display
        this.on("click", function(e) {
            var $this = $(this), $title = $this.next(".popover").find(".popover-title");
            // Only if data-close is true add class "x" to title for right padding
            $title.find(".close").parent(".popover-title").addClass("closable");
            // Bind x icon to close popover
            $title.find(".close").on("click", function() {
                $this.popover("hide");
            });
            // Prevent href="#" page scroll to top
            e.preventDefault();
        });
        return this;
    };
})(jQuery);
// Util: DataTables Settings
(function($) {
    "use strict";
    if ($.fn.dataTableExt) {
        /* Set the defaults for DataTables initialisation */ $.extend(true, $.fn.dataTable.defaults, {
            "bDestroy": true,
            "bAutoWidth": false,
            "iDisplayLength": 20,
            "sDom": "<'dataTables_header' f i r ><'table-responsive'  t ><'dataTables_footer' p >",
            "oLanguage": {
                "sInfo": "Showing <b>_START_</b> to <b>_END_</b> of <b>_TOTAL_</b> Items",
                "sInfoFiltered": "(of <b>_MAX_</b>)",
                "sInfoEmpty": "Showing <b>0</b> Results",
                "sZeroRecords": "<p>Suggestions</p><ul><li>Check the javascript regular expression syntax of the search term.</li><li>Check that the correct menu option is chosen (token ID vs. user ID).</li><li>Use wildcards (* to match 0 or more characters, + to match 1 or more characters, ? to match 0 or 1 character).</li><li>Clear the search field, then click Search to return to the 20 most recent records.</li></ul>",
                "sSearch": ""
            },
            "sPaginationType": "bootstrap_input",
            "oSearch": {
                "sSearch": "",
                "bRegex": true,
                "bSmart": false
            }
        });
        /* Default class modification */ $.extend($.fn.dataTableExt.oStdClasses, {
            "sWrapper": "dataTables_wrapper"
        });
        /* API method to get paging information */ $.fn.dataTableExt.oApi.fnPagingInfo = function(oSettings) {
            return {
                "iStart": oSettings._iDisplayStart,
                "iEnd": oSettings.fnDisplayEnd(),
                "iLength": oSettings._iDisplayLength,
                "iTotal": oSettings.fnRecordsTotal(),
                "iFilteredTotal": oSettings.fnRecordsDisplay(),
                "iPage": oSettings._iDisplayLength === -1 ? 0 : Math.ceil(oSettings._iDisplayStart / oSettings._iDisplayLength),
                "iTotalPages": oSettings._iDisplayLength === -1 ? 0 : Math.ceil(oSettings.fnRecordsDisplay() / oSettings._iDisplayLength)
            };
        };
        /* Combination of Bootstrap + Input Text style pagination control */ $.extend($.fn.dataTableExt.oPagination, {
            "bootstrap_input": {
                "fnInit": function(oSettings, nPaging, fnDraw) {
                    var fnClickHandler = function(e) {
                        e.preventDefault();
                        if (oSettings.oApi._fnPageChange(oSettings, e.data.action)) fnDraw(oSettings);
                    }, els, nInput;
                    $(nPaging).append('<ul class="pagination">  <li class="first disabled"><span class="i fa fa-angle-double-left"></span></li>  <li class="prev disabled"><span class="i fa fa-angle-left"></span></li></ul><div class="pagination-input">  <input type="text" class="paginate_input">  <span class="paginate_of">of <b>3</b></span></div><ul class="pagination">  <li class="next disabled"><span class="i fa fa-angle-right"></span></li>  <li class="last disabled"><span class="i fa fa-angle-double-right"></span></li></ul>');
                    els = $("li", nPaging);
                    $(els[0]).bind("click.DT", {
                        action: "first"
                    }, fnClickHandler);
                    $(els[1]).bind("click.DT", {
                        action: "previous"
                    }, fnClickHandler);
                    $(els[2]).bind("click.DT", {
                        action: "next"
                    }, fnClickHandler);
                    $(els[3]).bind("click.DT", {
                        action: "last"
                    }, fnClickHandler);
                    nInput = $("input", nPaging);
                    $(nInput).keyup(function(e) {
                        var iNewStart;
                        if (e.which === 38 || e.which === 39) this.value += 1;
                        else if ((e.which === 37 || e.which === 40) && this.value > 1) this.value -= 1;
                        if (this.value === "" || !this.value.match(/[0-9]/)) /* Nothing entered or non-numeric character */ return;
                        iNewStart = oSettings._iDisplayLength * (this.value - 1);
                        if (iNewStart >= oSettings.fnRecordsDisplay()) {
                            /* Display overrun */ oSettings._iDisplayStart = (Math.ceil((oSettings.fnRecordsDisplay() - 1) / oSettings._iDisplayLength) - 1) * oSettings._iDisplayLength;
                            fnDraw(oSettings);
                            return;
                        }
                        oSettings._iDisplayStart = iNewStart;
                        fnDraw(oSettings);
                    });
                },
                "fnUpdate": function(oSettings, fnDraw) {
                    var oPaging = oSettings.oInstance.fnPagingInfo(), an = oSettings.aanFeatures.p, ien = an.length, iPages = Math.ceil(oSettings.fnRecordsDisplay() / oSettings._iDisplayLength), iCurrentPage = Math.ceil(oSettings._iDisplayStart / oSettings._iDisplayLength) + 1, i;
                    for(i = 0; i < ien; i += 1){
                        $(".paginate_input", an[i]).val(iCurrentPage).siblings(".paginate_of").find("b").html(iPages);
                        // Add / remove disabled classes from the static elements
                        if (oPaging.iPage === 0) {
                            $("li.first", an[i]).addClass("disabled");
                            $("li.prev", an[i]).addClass("disabled");
                        } else {
                            $("li.first", an[i]).removeClass("disabled");
                            $("li.prev", an[i]).removeClass("disabled");
                        }
                        if (oPaging.iPage === oPaging.iTotalPages - 1 || oPaging.iTotalPages === 0) {
                            $("li.next", an[i]).addClass("disabled");
                            $("li.last", an[i]).addClass("disabled");
                        } else {
                            $("li.next", an[i]).removeClass("disabled");
                            $("li.last", an[i]).removeClass("disabled");
                        }
                    }
                }
            }
        });
    }
})(jQuery);
// Util: PatternFly Collapsible Left Hand Navigation
// Must have navbar-toggle in navbar-pf-alt for expand/collapse
(function($) {
    "use strict";
    $.fn.navigation = function() {
        var navElement = $(".layout-pf-alt-fixed .nav-pf-vertical-alt"), bodyContentElement = $(".container-pf-alt-nav-pf-vertical-alt"), toggleNavBarButton = $(".navbar-toggle"), explicitCollapse = false, checkNavState = function() {
            var width = $(window).width();
            //Always remove the hidden & peek class
            navElement.removeClass("hidden show-mobile-nav collapsed");
            //Set the body class back to the default
            bodyContentElement.removeClass("collapsed-nav hidden-nav");
            // Check to see if the nav needs to collapse
            if (width < $.pfBreakpoints.desktop || explicitCollapse) {
                navElement.addClass("collapsed");
                bodyContentElement.addClass("collapsed-nav");
            }
            // Check to see if we need to move down to the mobile state
            if (width < $.pfBreakpoints.tablet) {
                //Set the nav to being hidden
                navElement.addClass("hidden");
                //Make sure this is expanded
                navElement.removeClass("collapsed");
                //Set the body class to the correct state
                bodyContentElement.removeClass("collapsed-nav");
                bodyContentElement.addClass("hidden-nav");
            }
        }, collapseMenu = function() {
            //Make sure this is expanded
            navElement.addClass("collapsed");
            //Set the body class to the correct state
            bodyContentElement.addClass("collapsed-nav");
            explicitCollapse = true;
        }, enableTransitions = function() {
            // enable transitions only when toggleNavBarButton is clicked or window is resized
            $("html").addClass("transitions");
        }, expandMenu = function() {
            //Make sure this is expanded
            navElement.removeClass("collapsed");
            //Set the body class to the correct state
            bodyContentElement.removeClass("collapsed-nav");
            explicitCollapse = false;
        }, bindMenuBehavior = function() {
            toggleNavBarButton.on("click", function(e) {
                var inMobileState = bodyContentElement.hasClass("hidden-nav");
                enableTransitions();
                if (inMobileState && navElement.hasClass("show-mobile-nav")) //In mobile state just need to hide the nav
                navElement.removeClass("show-mobile-nav");
                else if (inMobileState) navElement.addClass("show-mobile-nav");
                else if (navElement.hasClass("collapsed")) expandMenu();
                else collapseMenu();
            });
        }, setTooltips = function() {
            $('.nav-pf-vertical-alt [data-toggle="tooltip"]').tooltip({
                "container": "body",
                "delay": {
                    "show": "500",
                    "hide": "200"
                }
            });
            $(".nav-pf-vertical-alt").on("show.bs.tooltip", function(e) {
                return $(this).hasClass("collapsed");
            });
        }, init = function() {
            //Set correct state on load
            checkNavState();
            // Bind Top level hamburger menu with menu behavior;
            bindMenuBehavior();
            //Set tooltips
            setTooltips();
        };
        //Listen for the window resize event and collapse/hide as needed
        $(window).on("resize", function() {
            checkNavState();
            enableTransitions();
        });
        init();
    };
    $(document).ready(function() {
        if ($(".nav-pf-vertical-alt").length > 0) $.fn.navigation();
    });
})(jQuery);
// Count and Display Remaining Characters
(function($) {
    "use strict";
    $.fn.countRemainingChars = function(options) {
        var settings = $.extend({
            // These are the defaults.
            charsMaxLimit: 100,
            charsWarnRemaining: 5,
            blockInputAtMaxLimit: false
        }, options), $taFld = this, $countFld = $("#" + settings.countFld).text(settings.charsMaxLimit), charsRemainingFn = function(charsLength) {
            var charsRemaining = settings.charsMaxLimit - charsLength;
            $countFld.text(charsRemaining);
            $countFld.toggleClass("chars-warn-remaining-pf", charsRemaining <= settings.charsWarnRemaining);
            if (charsRemaining < 0) $taFld.trigger("overCharsMaxLimitEvent", $taFld.attr("id"));
            else $taFld.trigger("underCharsMaxLimitEvent", $taFld.attr("id"));
        };
        this.on("paste", function(event) {
            setTimeout(function() {
                var charsLength = $taFld.val().length, maxTxt;
                if (settings.blockInputAtMaxLimit && charsLength > settings.charsMaxLimit) {
                    maxTxt = $taFld.val();
                    maxTxt = maxTxt.substring(0, settings.charsMaxLimit);
                    $taFld.val(maxTxt);
                    charsLength = $taFld.val().length;
                }
                charsRemainingFn(charsLength);
            }, 100);
        });
        this.keyup(function(event) {
            charsRemainingFn($taFld.val().length);
        });
        this.keydown(function(event) {
            var charsLength = $taFld.val().length;
            if (settings.blockInputAtMaxLimit && charsLength >= settings.charsMaxLimit) // Except backspace
            {
                if (event.keyCode !== 8) event.preventDefault();
            }
        });
        return this;
    };
})(jQuery);
// Util: PatternFly Palette colors
(function($) {
    "use strict";
    if (patternfly !== undefined) $.pfPaletteColors = patternfly.pfPaletteColors;
})(jQuery);
// Util: PatternFly C3 Chart Defaults
(function($) {
    "use strict";
    if (patternfly !== undefined) {
        $.fn.pfSetDonutChartTitle = patternfly.pfSetDonutChartTitle;
        $.fn.pfDonutTooltipContents = patternfly.pfDonutTooltipContents;
        $.fn.pfGetUtilizationDonutTooltipContentsFn = patternfly.pfGetUtilizationDonutTooltipContentsFn;
        $.fn.pfGetBarChartTooltipContentsFn = patternfly.pfGetBarChartTooltipContentsFn;
        $.fn.pfSingleLineChartTooltipContentsFn = patternfly.pfSingleLineChartTooltipContentsFn;
        $.fn.pfPieTooltipContents = patternfly.pfPieTooltipContents;
        $.fn.c3ChartDefaults = patternfly.c3ChartDefaults;
    }
})(jQuery);
// Util: PatternFly Collapse with fixed heights
// Update the max-height of collapse elements based on the parent container's height.
(function($) {
    "use strict";
    $.fn.initCollapseHeights = function(scrollSelector) {
        var parentElement = this, setCollapseHeights, targetScrollSelector = scrollSelector;
        setCollapseHeights = function() {
            var height, openPanel, contentHeight, bodyHeight, overflowY = "hidden";
            height = parentElement.height();
            // Close any open panel
            openPanel = parentElement.find(".collapse.in");
            if (openPanel && openPanel.length > 0) openPanel.removeClass("in");
            // Determine the necessary height for the closed content
            contentHeight = 0;
            parentElement.children().each($.proxy(function(i, element) {
                var $element = $(element);
                contentHeight += $element.outerHeight(true);
            }, parentElement)).end();
            // Determine the height remaining for opened collapse panels
            bodyHeight = height - contentHeight;
            // Make sure we have enough height to be able to scroll the contents if necessary
            if (bodyHeight < 25) {
                bodyHeight = 25;
                // Allow the parent to scroll so the child elements are accessible
                overflowY = "auto";
            }
            // Reopen the initially opened panel
            if (openPanel && openPanel.length > 0) openPanel.addClass("in");
            setTimeout(function() {
                // Set the max-height for the collapse panels
                parentElement.find('[data-toggle="collapse"]').each($.proxy(function(i, element) {
                    var $element, selector, $target, scrollElement, innerHeight = 0;
                    $element = $(element);
                    // Determine the selector to find the target
                    selector = $element.attr("data-target");
                    if (!selector) selector = $element.attr("href");
                    // Determine the scroll element (either the target or the child of the target based on the given selector)
                    $target = $(selector);
                    scrollElement = $target;
                    if (targetScrollSelector) {
                        scrollElement = $target.find(targetScrollSelector);
                        if (scrollElement.length === 1) {
                            innerHeight = 0;
                            $target.children().each($.proxy(function(j, sibling) {
                                var $sibling = $(sibling);
                                if (sibling !== scrollElement[0]) innerHeight += $sibling.outerHeight(true);
                            }, $target)).end();
                            bodyHeight -= innerHeight;
                        } else scrollElement = $target;
                    }
                    // Set the max-height and vertical scroll of the scroll element
                    scrollElement.css({
                        "max-height": bodyHeight - innerHeight + "px",
                        "overflow-y": "auto"
                    });
                }, parentElement)).end();
                parentElement.css({
                    "overflow-y": overflowY
                });
            }, 100);
        };
        setCollapseHeights();
        // Update on window resizing
        $(window).on("resize", setCollapseHeights);
    };
    $.fn.initFixedAccordion = function() {
        var fixedAccordion = this, initOpen;
        fixedAccordion.on("show.bs.collapse", ".collapse", function(event) {
            $(event.target.parentNode).addClass("panel-open");
        });
        fixedAccordion.on("hide.bs.collapse", ".collapse", function(event) {
            $(event.target.parentNode).removeClass("panel-open");
        });
        fixedAccordion.find(".panel").each(function(index, item) {
            $(item).removeClass("panel-open");
        });
        initOpen = $(fixedAccordion.find(".collapse.in"))[0];
        if (initOpen) $(initOpen.parentNode).addClass("panel-open");
    };
})(jQuery);
// Util: PatternFly TreeGrid Tables
(function($) {
    "use strict";
    function getParent(rows, node) {
        var parent = node.attr("data-parent");
        if (typeof parent === "string") {
            if (isNaN(parent)) {
                parent = $(parent);
                if (parent.length > 1) parent = rows.closest(parent);
            } else parent = $(rows[parseInt(parent, 10)]);
            return parent;
        }
        return undefined;
    }
    function renderItem(item, parent) {
        if (parent) {
            parent.find(".treegrid-node > span.expand-icon").toggleClass("fa-angle-right", parent.hasClass("collapsed")).toggleClass("fa-angle-down", !parent.hasClass("collapsed"));
            item.toggleClass("hidden", parent.hasClass("collapsed"));
            if (parent.hasClass("collapsed")) item.addClass("collapsed");
        }
    }
    function reStripe(tree) {
        tree.find("tbody > tr").removeClass("odd");
        tree.find("tbody > tr:not(.hidden):odd").addClass("odd");
    }
    $.fn.treegrid = function(options) {
        var i, rows, _this;
        rows = this.find("tbody > tr");
        _this = this;
        $.each(rows, function() {
            var node, parent;
            node = $(this);
            parent = getParent(rows, node);
            // Append expand icon dummies
            node.children(".treegrid-node").prepend('<span class="icon expand-icon fa"/>');
            // Set up an event listener for the node
            node.children(".treegrid-node").on("click", function(e) {
                var icon = node.find("span.expand-icon");
                if (options && typeof options.callback === "function") options.callback(e);
                if (icon.hasClass("fa-angle-right")) node.removeClass("collapsed");
                if (icon.hasClass("fa-angle-down")) node.addClass("collapsed");
                $.each(rows.slice(rows.index(node) + 1), function() {
                    renderItem($(this), getParent(rows, $(this)));
                });
                reStripe(_this);
            });
            if (parent) {
                // Calculate indentation depth
                i = parent.find(".treegrid-node > span.indent").length + 1;
                for(; i > 0; i -= 1)node.children(".treegrid-node").prepend('<span class="indent"/>');
                // Render expand/collapse icons
                renderItem(node, parent);
            }
        });
        reStripe(_this);
    };
})(jQuery);
// Util: PatternFly Vertical Navigation
// Must have navbar-toggle in navbar-pf-vertical for expand/collapse
(function($) {
    "use strict";
    $.fn.setupVerticalNavigation = function(handleItemSelections, ignoreDrawer, userOptions) {
        var options = $.extend({
            hoverDelay: 500,
            hideDelay: 700,
            rememberOpenState: true,
            storage: "localStorage"
        }, userOptions || {}), navElement = $(".nav-pf-vertical"), bodyContentElement = $(".container-pf-nav-pf-vertical"), toggleNavBarButton = $(".navbar-toggle"), handleResize = true, explicitCollapse = false, subDesktop = false, storageLocation = options.storage === "sessionStorage" ? "sessionStorage" : "localStorage", inMobileState = function() {
            return bodyContentElement.hasClass("hidden-nav");
        }, forceResize = function(delay) {
            setTimeout(function() {
                $(window).trigger("resize");
            }, delay);
        }, showSecondaryMenu = function() {
            if (inMobileState() || !subDesktop) {
                navElement.addClass("secondary-visible-pf");
                bodyContentElement.addClass("secondary-visible-pf");
            }
            // Dispatch a resize event when showing the secondary menu in non-subdesktop state to
            // allow content to adjust to the secondary menu sizing
            if (!subDesktop) forceResize(100);
        }, hideSecondaryMenu = function() {
            navElement.removeClass("secondary-visible-pf");
            bodyContentElement.removeClass("secondary-visible-pf");
            if (navElement.find(".secondary-nav-item-pf.is-hover").length <= 1) navElement.removeClass("hover-secondary-nav-pf");
            navElement.find(".mobile-nav-item-pf").each(function(index, item) {
                $(item).removeClass("mobile-nav-item-pf");
            });
            navElement.find(".is-hover").each(function(index, item) {
                $(item).removeClass("is-hover");
            });
        }, hideTertiaryMenu = function() {
            navElement.removeClass("tertiary-visible-pf");
            bodyContentElement.removeClass("tertiary-visible-pf");
            if (navElement.find(".tertiary-nav-item-pf.is-hover").length <= 1) navElement.removeClass("hover-tertiary-nav-pf");
            navElement.find(".mobile-nav-item-pf").each(function(index, item) {
                $(item).removeClass("mobile-nav-item-pf");
            });
            navElement.find(".is-hover").each(function(index, item) {
                $(item).removeClass("is-hover");
            });
        }, setActiveItem = function(item) {
            // remove all .active
            $(".nav-pf-vertical .list-group-item.active").removeClass("active");
            // add .active to item and its parents
            item.addClass("active").parents(".list-group-item").addClass("active");
        }, updateSecondaryMenuDisplayAfterSelection = function() {
            if (inMobileState()) {
                navElement.removeClass("show-mobile-nav");
                hideSecondaryMenu();
                navElement.find(".mobile-nav-item-pf").each(function(index, item) {
                    $(item).removeClass("mobile-nav-item-pf");
                });
            } else showSecondaryMenu();
        }, updateSecondaryCollapsedState = function(setCollapsed, collapsedItem) {
            if (setCollapsed) {
                collapsedItem.addClass("collapsed");
                navElement.addClass("collapsed-secondary-nav-pf");
                bodyContentElement.addClass("collapsed-secondary-nav-pf");
            } else {
                if (collapsedItem) collapsedItem.removeClass("collapsed");
                else // Remove any collapsed secondary menus
                navElement.find('[data-toggle="collapse-secondary-nav"]').each(function(index, element) {
                    var $e = $(element);
                    $e.removeClass("collapsed");
                });
                navElement.removeClass("collapsed-secondary-nav-pf");
                bodyContentElement.removeClass("collapsed-secondary-nav-pf");
            }
        }, updateTertiaryCollapsedState = function(setCollapsed, collapsedItem) {
            if (setCollapsed) {
                collapsedItem.addClass("collapsed");
                navElement.addClass("collapsed-tertiary-nav-pf");
                bodyContentElement.addClass("collapsed-tertiary-nav-pf");
                updateSecondaryCollapsedState(false);
            } else {
                if (collapsedItem) collapsedItem.removeClass("collapsed");
                else // Remove any collapsed tertiary menus
                navElement.find('[data-toggle="collapse-tertiary-nav"]').each(function(index, element) {
                    var $e = $(element);
                    $e.removeClass("collapsed");
                });
                navElement.removeClass("collapsed-tertiary-nav-pf");
                bodyContentElement.removeClass("collapsed-tertiary-nav-pf");
            }
        }, updateMobileMenu = function(selected, secondaryItem) {
            $(document).find(".list-group-item.mobile-nav-item-pf").each(function(index, item) {
                $(item).removeClass("mobile-nav-item-pf");
            });
            $(document).find(".list-group-item.mobile-secondary-item-pf").each(function(index, item) {
                $(item).removeClass("mobile-secondary-item-pf");
            });
            if (selected) {
                selected.addClass("mobile-nav-item-pf");
                if (secondaryItem) {
                    secondaryItem.addClass("mobile-secondary-item-pf");
                    navElement.removeClass("show-mobile-secondary");
                    navElement.addClass("show-mobile-tertiary");
                } else {
                    navElement.addClass("show-mobile-secondary");
                    navElement.removeClass("show-mobile-tertiary");
                }
            } else {
                navElement.removeClass("show-mobile-secondary");
                navElement.removeClass("show-mobile-tertiary");
            }
        }, enterMobileState = function() {
            if (!navElement.hasClass("hidden")) {
                //Set the nav to being hidden
                navElement.addClass("hidden");
                navElement.removeClass("collapsed");
                //Set the body class to the correct state
                bodyContentElement.removeClass("collapsed-nav");
                bodyContentElement.addClass("hidden-nav");
                // Reset the collapsed states
                updateSecondaryCollapsedState(false);
                updateTertiaryCollapsedState(false);
                explicitCollapse = false;
            }
        }, exitMobileState = function() {
            // Always remove the hidden & peek class
            navElement.removeClass("hidden show-mobile-nav");
            // Set the body class back to the default
            bodyContentElement.removeClass("hidden-nav");
        }, checkNavState = function() {
            var width = $(window).width(), makeSecondaryVisible;
            if (!handleResize) return;
            // Check to see if we need to enter/exit the mobile state
            if (width < $.pfBreakpoints.tablet && !explicitCollapse) enterMobileState();
            else if (navElement.hasClass("hidden")) exitMobileState();
            // Check to see if we need to enter/exit the sub desktop state
            if (width < $.pfBreakpoints.desktop) {
                if (!subDesktop) {
                    // Collapse the navigation bars when entering sub desktop mode
                    navElement.addClass("collapsed");
                    bodyContentElement.addClass("collapsed-nav");
                }
                if (width >= $.pfBreakpoints.tablet) hideSecondaryMenu();
                subDesktop = true;
            } else {
                makeSecondaryVisible = subDesktop && navElement.find(".secondary-nav-item-pf.active").length > 0;
                subDesktop = false;
                if (makeSecondaryVisible) showSecondaryMenu();
            }
            if (explicitCollapse) {
                navElement.addClass("collapsed");
                bodyContentElement.addClass("collapsed-nav");
            } else {
                navElement.removeClass("collapsed");
                bodyContentElement.removeClass("collapsed-nav");
            }
        }, collapseMenu = function() {
            //Make sure this is expanded
            navElement.addClass("collapsed");
            //Set the body class to the correct state
            bodyContentElement.addClass("collapsed-nav");
            if (subDesktop) hideSecondaryMenu();
            explicitCollapse = true;
        }, enableTransitions = function() {
            // enable transitions only when toggleNavBarButton is clicked or window is resized
            $("html").addClass("transitions");
        }, expandMenu = function() {
            //Make sure this is expanded
            navElement.removeClass("collapsed");
            //Set the body class to the correct state
            bodyContentElement.removeClass("collapsed-nav");
            explicitCollapse = false;
            // Dispatch a resize event when showing the expanding then menu to
            // allow content to adjust to the menu sizing
            if (!subDesktop) forceResize(100);
        }, bindMenuBehavior = function() {
            toggleNavBarButton.on("click", function(e) {
                var $drawer;
                enableTransitions();
                if (inMobileState()) {
                    // Toggle the mobile nav
                    if (navElement.hasClass("show-mobile-nav")) navElement.removeClass("show-mobile-nav");
                    else {
                        // Always start at the primary menu
                        updateMobileMenu();
                        navElement.addClass("show-mobile-nav");
                        // If the notification drawer is shown, hide it
                        if (!ignoreDrawer) {
                            $drawer = $(".drawer-pf");
                            if ($drawer.length) {
                                $(".drawer-pf-trigger").removeClass("open");
                                $drawer.addClass("hide");
                            }
                        }
                    }
                } else if (navElement.hasClass("collapsed")) {
                    if (options.rememberOpenState) window[storageLocation].setItem("patternfly-navigation-primary", "expanded");
                    expandMenu();
                } else {
                    if (options.rememberOpenState) window[storageLocation].setItem("patternfly-navigation-primary", "collapsed");
                    collapseMenu();
                }
            });
        }, forceHideSecondaryMenu = function() {
            navElement.addClass("force-hide-secondary-nav-pf");
            setTimeout(function() {
                navElement.removeClass("force-hide-secondary-nav-pf");
            }, 500);
        }, bindMenuItemsBehavior = function(handleSelection) {
            $(document).find(".nav-pf-vertical .list-group-item").each(function(index, item) {
                var onClickFn, $item = $(item), $nav = $item.closest('[class*="nav-pf-"]');
                if ($nav.hasClass("nav-pf-vertical")) // Set main nav active item on click or show secondary nav if it has a secondary nav bar and we are in the mobile state
                onClickFn = function(event) {
                    var $this = $(this), $secondaryItem, $tertiaryItem, $activeItem;
                    if (!$this.hasClass("secondary-nav-item-pf")) {
                        hideSecondaryMenu();
                        if (inMobileState()) {
                            updateMobileMenu();
                            navElement.removeClass("show-mobile-nav");
                        }
                        if (handleSelection) {
                            setActiveItem($this);
                            // Don't process the click on the item
                            event.stopImmediatePropagation();
                        }
                    } else if (inMobileState()) updateMobileMenu($this);
                    else if (handleSelection) {
                        $activeItem = $secondaryItem = $item.find(".nav-pf-secondary-nav > .list-group > .list-group-item").eq(0);
                        if ($secondaryItem.hasClass("tertiary-nav-item-pf")) $activeItem = $secondaryItem.find(".nav-pf-tertiary-nav > .list-group > .list-group-item").eq(0);
                        setActiveItem($activeItem);
                        event.stopImmediatePropagation();
                    }
                };
                else if ($nav.hasClass("nav-pf-secondary-nav")) // Set secondary nav active item on click or show tertiary nav if it has a tertiary nav bar and we are in the mobile state
                onClickFn = function(event) {
                    var $this = $(this), $tertiaryItem, $primaryItem;
                    if (!$this.hasClass("tertiary-nav-item-pf")) {
                        if (inMobileState()) {
                            updateMobileMenu();
                            navElement.removeClass("show-mobile-nav");
                        }
                        updateSecondaryMenuDisplayAfterSelection();
                        if (handleSelection) {
                            setActiveItem($item);
                            hideSecondaryMenu();
                            event.stopImmediatePropagation();
                        }
                    } else if (inMobileState()) {
                        $primaryItem = $item.parents(".list-group-item");
                        updateMobileMenu($this, $primaryItem);
                        event.stopImmediatePropagation();
                    } else if (handleSelection) {
                        $tertiaryItem = $item.find(".nav-pf-tertiary-nav > .list-group > .list-group-item").eq(0);
                        setActiveItem($tertiaryItem);
                        event.stopImmediatePropagation();
                    }
                };
                else if ($nav.hasClass("nav-pf-tertiary-nav")) // Set tertiary nav active item on click
                onClickFn = function(event) {
                    if (inMobileState()) {
                        updateMobileMenu();
                        navElement.removeClass("show-mobile-nav");
                    }
                    updateSecondaryMenuDisplayAfterSelection();
                    if (handleSelection) {
                        setActiveItem($item);
                        hideTertiaryMenu();
                        hideSecondaryMenu();
                        event.stopImmediatePropagation();
                    }
                };
                // register event handler
                $item.on("click.pf.secondarynav.data-api", onClickFn);
            });
            $(document).find(".secondary-nav-item-pf").each(function(index, secondaryItem) {
                var $secondaryItem = $(secondaryItem);
                // Collapse the secondary nav bar when the toggle is clicked
                $secondaryItem.on("click.pf.secondarynav.data-api", '[data-toggle="collapse-secondary-nav"]', function(e) {
                    var $this = $(this);
                    if (inMobileState()) {
                        updateMobileMenu();
                        e.stopImmediatePropagation();
                    } else if ($this.hasClass("collapsed")) {
                        if (options.rememberOpenState) {
                            window[storageLocation].setItem("patternfly-navigation-secondary", "expanded");
                            window[storageLocation].setItem("patternfly-navigation-tertiary", "expanded");
                        }
                        updateSecondaryCollapsedState(false, $this);
                        forceHideSecondaryMenu();
                    } else {
                        if (options.rememberOpenState) window[storageLocation].setItem("patternfly-navigation-secondary", "collapsed");
                        updateSecondaryCollapsedState(true, $this);
                    }
                    navElement.removeClass("hover-secondary-nav-pf");
                    if (handleSelection) // Don't process the click on the parent item
                    e.stopImmediatePropagation();
                });
                $secondaryItem.find(".tertiary-nav-item-pf").each(function(index, primaryItem) {
                    var $primaryItem = $(primaryItem);
                    // Collapse the tertiary nav bar when the toggle is clicked
                    $primaryItem.on("click.pf.tertiarynav.data-api", '[data-toggle="collapse-tertiary-nav"]', function(e) {
                        var $this = $(this);
                        if (inMobileState()) {
                            updateMobileMenu($secondaryItem);
                            e.stopImmediatePropagation();
                        } else if ($this.hasClass("collapsed")) {
                            if (options.rememberOpenState) {
                                window[storageLocation].setItem("patternfly-navigation-secondary", "expanded");
                                window[storageLocation].setItem("patternfly-navigation-tertiary", "expanded");
                            }
                            updateTertiaryCollapsedState(false, $this);
                            forceHideSecondaryMenu();
                        } else {
                            if (options.rememberOpenState) window[storageLocation].setItem("patternfly-navigation-tertiary", "collapsed");
                            updateTertiaryCollapsedState(true, $this);
                        }
                        navElement.removeClass("hover-secondary-nav-pf");
                        navElement.removeClass("hover-tertiary-nav-pf");
                        if (handleSelection) // Don't process the click on the parent item
                        e.stopImmediatePropagation();
                    });
                });
            });
            // Show secondary nav bar on hover of secondary nav items
            $(document).on("mouseenter.pf.tertiarynav.data-api", ".secondary-nav-item-pf", function(e) {
                var $this = $(this);
                if (!inMobileState()) {
                    if ($this[0].navUnHoverTimeout !== undefined) {
                        clearTimeout($this[0].navUnHoverTimeout);
                        $this[0].navUnHoverTimeout = undefined;
                    } else if ($this[0].navHoverTimeout === undefined) $this[0].navHoverTimeout = setTimeout(function() {
                        navElement.addClass("hover-secondary-nav-pf");
                        $this.addClass("is-hover");
                        $this[0].navHoverTimeout = undefined;
                    }, options.hoverDelay);
                }
            });
            $(document).on("mouseleave.pf.tertiarynav.data-api", ".secondary-nav-item-pf", function(e) {
                var $this = $(this);
                if ($this[0].navHoverTimeout !== undefined) {
                    clearTimeout($this[0].navHoverTimeout);
                    $this[0].navHoverTimeout = undefined;
                } else if ($this[0].navUnHoverTimeout === undefined && navElement.find(".secondary-nav-item-pf.is-hover").length > 0) $this[0].navUnHoverTimeout = setTimeout(function() {
                    if (navElement.find(".secondary-nav-item-pf.is-hover").length <= 1) navElement.removeClass("hover-secondary-nav-pf");
                    $this.removeClass("is-hover");
                    $this[0].navUnHoverTimeout = undefined;
                }, options.hideDelay);
            });
            // Show tertiary nav bar on hover of secondary nav items
            $(document).on("mouseover.pf.tertiarynav.data-api", ".tertiary-nav-item-pf", function(e) {
                var $this = $(this);
                if (!inMobileState()) {
                    if ($this[0].navUnHoverTimeout !== undefined) {
                        clearTimeout($this[0].navUnHoverTimeout);
                        $this[0].navUnHoverTimeout = undefined;
                    } else if ($this[0].navHoverTimeout === undefined) $this[0].navHoverTimeout = setTimeout(function() {
                        navElement.addClass("hover-tertiary-nav-pf");
                        $this.addClass("is-hover");
                        $this[0].navHoverTimeout = undefined;
                    }, options.hoverDelay);
                }
            });
            $(document).on("mouseout.pf.tertiarynav.data-api", ".tertiary-nav-item-pf", function(e) {
                var $this = $(this);
                if ($this[0].navHoverTimeout !== undefined) {
                    clearTimeout($this[0].navHoverTimeout);
                    $this[0].navHoverTimeout = undefined;
                } else if ($this[0].navUnHoverTimeout === undefined) $this[0].navUnHoverTimeout = setTimeout(function() {
                    if (navElement.find(".tertiary-nav-item-pf.is-hover").length <= 1) navElement.removeClass("hover-tertiary-nav-pf");
                    $this.removeClass("is-hover");
                    $this[0].navUnHoverTimeout = undefined;
                }, options.hideDelay);
            });
        }, loadFromLocalStorage = function() {
            if (inMobileState()) return;
            if (window[storageLocation].getItem("patternfly-navigation-primary") === "collapsed") collapseMenu();
            if ($(".nav-pf-vertical.nav-pf-vertical-collapsible-menus").length > 0) {
                if (window[storageLocation].getItem("patternfly-navigation-secondary") === "collapsed") updateSecondaryCollapsedState(true, $(".secondary-nav-item-pf.active [data-toggle=collapse-secondary-nav]"));
                if (window[storageLocation].getItem("patternfly-navigation-tertiary") === "collapsed") updateTertiaryCollapsedState(true, $(".tertiary-nav-item-pf.active [data-toggle=collapse-tertiary-nav]"));
            }
        }, setTooltips = function() {
            var tooltipOptions = {
                container: "body",
                placement: "bottom",
                delay: {
                    "show": "500",
                    "hide": "200"
                },
                template: '<div class="nav-pf-vertical-tooltip tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
            };
            $('.nav-pf-vertical [data-toggle="tooltip"]').tooltip(tooltipOptions);
            $(".nav-pf-vertical").on("show.bs.tooltip", function(e) {
                return $(this).hasClass("collapsed");
            });
        }, init = function(handleItemSelections) {
            // Hide the nav menus during initialization
            navElement.addClass("hide-nav-pf");
            bodyContentElement.addClass("hide-nav-pf");
            //Set correct state on load
            checkNavState();
            // Bind Top level hamburger menu with menu behavior;
            bindMenuBehavior();
            // Bind menu items
            bindMenuItemsBehavior(handleItemSelections);
            //Set tooltips
            setTooltips();
            if (options.rememberOpenState) loadFromLocalStorage();
            // Show the nav menus
            navElement.removeClass("hide-nav-pf");
            bodyContentElement.removeClass("hide-nav-pf");
            forceResize(250);
        }, self = {
            hideMenu: function() {
                handleResize = false;
                enterMobileState();
            },
            showMenu: function() {
                handleResize = true;
                exitMobileState();
            },
            isVisible: function() {
                return handleResize;
            }
        };
        if (!$.fn.setupVerticalNavigation.self) {
            $.fn.setupVerticalNavigation.self = self;
            //Listen for the window resize event and collapse/hide as needed
            $(window).on("resize", function() {
                checkNavState();
                enableTransitions();
            });
            init(handleItemSelections);
        }
        return $.fn.setupVerticalNavigation.self;
    };
})(jQuery);


/*
 *  Copyright 2022 Red Hat
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ /*
    JavaScript autoComplete v1.0.4
    Copyright (c) 2014 Simon Steinberger / Pixabay
    GitHub: https://github.com/Pixabay/JavaScript-autoComplete
    License: https://www.opensource.org/licenses/mit-license.php
*/ "use strict";
window.autoComplete = function(options) {
    if (!document.querySelector) return;
    // helpers
    function hasClass(el, className) {
        return el.classList ? el.classList.contains(className) : new RegExp("\\b" + className + "\\b").test(el.className);
    }
    function addEvent(el, type, handler) {
        if (el.attachEvent) el.attachEvent("on" + type, handler);
        else el.addEventListener(type, handler);
    }
    function removeEvent(el, type, handler) {
        // if (el.removeEventListener) not working in IE11
        if (el.detachEvent) el.detachEvent("on" + type, handler);
        else el.removeEventListener(type, handler);
    }
    function live(elClass, event, cb, context) {
        addEvent(context || document, event, function(e) {
            var found, el = e.target || e.srcElement;
            while(el && !(found = hasClass(el, elClass)))el = el.parentElement;
            if (found) cb.call(el, e);
        });
    }
    var o = {
        selector: 0,
        source: 0,
        minChars: 3,
        delay: 150,
        offsetLeft: 0,
        offsetTop: 1,
        cache: 1,
        menuClass: "",
        renderItem: function(item, search) {
            // escape special characters
            search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
            var re = new RegExp("(" + search.split(" ").join("|") + ")", "gi");
            return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>") + "</div>";
        },
        onSelect: function(e, term, item) {}
    };
    for(var k in options)if (options.hasOwnProperty(k)) o[k] = options[k];
    // init
    var elems = typeof o.selector == "object" ? [
        o.selector
    ] : document.querySelectorAll(o.selector);
    for(var i = 0; i < elems.length; i++){
        var that = elems[i];
        // create suggestions container "sc"
        that.sc = document.createElement("div");
        that.sc.className = "autocomplete-suggestions " + o.menuClass;
        that.autocompleteAttr = that.getAttribute("autocomplete");
        that.setAttribute("autocomplete", "off");
        that.cache = {};
        that.last_val = "";
        that.updateSC = function(resize, next) {
            var rect = that.getBoundingClientRect();
            that.sc.style.left = Math.round(rect.left + (window.pageXOffset || document.documentElement.scrollLeft) + o.offsetLeft) + "px";
            that.sc.style.top = Math.round(rect.bottom + (window.pageYOffset || document.documentElement.scrollTop) + o.offsetTop) + "px";
            that.sc.style.width = Math.round(rect.right - rect.left) + "px"; // outerWidth
            if (!resize) {
                that.sc.style.display = "block";
                if (!that.sc.maxHeight) that.sc.maxHeight = parseInt((window.getComputedStyle ? getComputedStyle(that.sc, null) : that.sc.currentStyle).maxHeight);
                if (!that.sc.suggestionHeight) that.sc.suggestionHeight = that.sc.querySelector(".autocomplete-suggestion").offsetHeight;
                if (that.sc.suggestionHeight) {
                    if (!next) that.sc.scrollTop = 0;
                    else {
                        var scrTop = that.sc.scrollTop, selTop = next.getBoundingClientRect().top - that.sc.getBoundingClientRect().top;
                        if (selTop + that.sc.suggestionHeight - that.sc.maxHeight > 0) that.sc.scrollTop = selTop + that.sc.suggestionHeight + scrTop - that.sc.maxHeight;
                        else if (selTop < 0) that.sc.scrollTop = selTop + scrTop;
                    }
                }
            }
        };
        addEvent(window, "resize", that.updateSC);
        document.body.appendChild(that.sc);
        live("autocomplete-suggestion", "mouseleave", function(e) {
            var sel = that.sc.querySelector(".autocomplete-suggestion.selected");
            if (sel) setTimeout(function() {
                sel.className = sel.className.replace("selected", "");
            }, 20);
        }, that.sc);
        live("autocomplete-suggestion", "mouseover", function(e) {
            var sel = that.sc.querySelector(".autocomplete-suggestion.selected");
            if (sel) sel.className = sel.className.replace("selected", "");
            this.className += " selected";
        }, that.sc);
        live("autocomplete-suggestion", "mousedown", function(e) {
            if (hasClass(this, "autocomplete-suggestion")) {
                var v = this.getAttribute("data-val");
                that.value = v;
                o.onSelect(e, v, this);
                that.sc.style.display = "none";
            }
        }, that.sc);
        that.blurHandler = function() {
            try {
                var over_sb = document.querySelector(".autocomplete-suggestions:hover");
            } catch (e) {
                var over_sb = 0;
            }
            if (!over_sb) {
                that.last_val = that.value;
                that.sc.style.display = "none";
                setTimeout(function() {
                    that.sc.style.display = "none";
                }, 350); // hide suggestions on fast input
            } else if (that !== document.activeElement) setTimeout(function() {
                that.focus();
            }, 20);
        };
        addEvent(that, "blur", that.blurHandler);
        var suggest = function(data) {
            var val = that.value;
            that.cache[val] = data;
            if (data.length && val.length >= o.minChars) {
                var s = "";
                for(var i = 0; i < data.length; i++)s += o.renderItem(data[i], val);
                that.sc.innerHTML = s;
                that.updateSC(0);
            } else that.sc.style.display = "none";
        };
        that.keydownHandler = function(e) {
            var key = window.event ? e.keyCode : e.which;
            // down (40), up (38)
            if ((key == 40 || key == 38) && that.sc.innerHTML) {
                var next, sel = that.sc.querySelector(".autocomplete-suggestion.selected");
                if (!sel) {
                    next = key == 40 ? that.sc.querySelector(".autocomplete-suggestion") : that.sc.childNodes[that.sc.childNodes.length - 1]; // first : last
                    next.className += " selected";
                    that.value = next.getAttribute("data-val");
                } else {
                    next = key == 40 ? sel.nextSibling : sel.previousSibling;
                    if (next) {
                        sel.className = sel.className.replace("selected", "");
                        next.className += " selected";
                        that.value = next.getAttribute("data-val");
                    } else {
                        sel.className = sel.className.replace("selected", "");
                        that.value = that.last_val;
                        next = 0;
                    }
                }
                that.updateSC(0, next);
                return false;
            } else if (key == 27) {
                that.value = that.last_val;
                that.sc.style.display = "none";
            } else if (key == 13 || key == 9) {
                var sel = that.sc.querySelector(".autocomplete-suggestion.selected");
                if (sel && that.sc.style.display != "none") {
                    o.onSelect(e, sel.getAttribute("data-val"), sel);
                    setTimeout(function() {
                        that.sc.style.display = "none";
                    }, 20);
                }
            }
        };
        addEvent(that, "keydown", that.keydownHandler);
        that.keyupHandler = function(e) {
            var key = window.event ? e.keyCode : e.which;
            if (!key || (key < 35 || key > 40) && key != 13 && key != 27) {
                var val = that.value;
                if (val.length >= o.minChars) {
                    if (val != that.last_val) {
                        that.last_val = val;
                        clearTimeout(that.timer);
                        if (o.cache) {
                            if (val in that.cache) {
                                suggest(that.cache[val]);
                                return;
                            }
                            // no requests if previous suggestions were empty
                            for(var i = 1; i < val.length - o.minChars; i++){
                                var part = val.slice(0, val.length - i);
                                if (part in that.cache && !that.cache[part].length) {
                                    suggest([]);
                                    return;
                                }
                            }
                        }
                        that.timer = setTimeout(function() {
                            o.source(val, suggest);
                        }, o.delay);
                    }
                } else {
                    that.last_val = val;
                    that.sc.style.display = "none";
                }
            }
        };
        addEvent(that, "keyup", that.keyupHandler);
        that.focusHandler = function(e) {
            that.last_val = "\n";
            that.keyupHandler(e);
        };
        if (!o.minChars) addEvent(that, "focus", that.focusHandler);
    }
    // public destroy method
    this.destroy = function() {
        for(var i = 0; i < elems.length; i++){
            var that = elems[i];
            removeEvent(window, "resize", that.updateSC);
            removeEvent(that, "blur", that.blurHandler);
            removeEvent(that, "focus", that.focusHandler);
            removeEvent(that, "keydown", that.keydownHandler);
            removeEvent(that, "keyup", that.keyupHandler);
            if (that.autocompleteAttr) that.setAttribute("autocomplete", that.autocompleteAttr);
            else that.removeAttribute("autocomplete");
            document.body.removeChild(that.sc);
            that = null;
        }
    };
};


/*
 *  Copyright 2022 Red Hat
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ "use strict";
var $5d4c209795b7d609$var$defaults = {
    prefilled: null,
    CapitalizeFirstLetter: false,
    preventSubmitOnEnter: true,
    isClearInputOnEsc: true,
    externalTagId: false,
    prefillIdFieldName: "Id",
    prefillValueFieldName: "Value",
    AjaxPush: null,
    AjaxPushAllTags: null,
    AjaxPushParameters: null,
    delimiters: [
        9,
        13,
        44
    ],
    backspace: [
        8
    ],
    maxTags: 0,
    hiddenTagListName: null,
    hiddenTagListId: null,
    replace: true,
    output: null,
    deleteTagsOnBackspace: true,
    tagsContainer: null,
    tagCloseIcon: "x",
    tagClass: "",
    validator: null,
    onlyTagList: false,
    tagList: null,
    fillInputOnTagRemove: false
}, $5d4c209795b7d609$var$publicMethods = {
    pushTag: function(tag, ignoreEvents, externalTagId) {
        var $self = $(this), opts = $self.data("opts"), alreadyInList, tlisLowerCase, max, tagId, tlis = $self.data("tlis"), tlid = $self.data("tlid"), idx, newTagId, newTagRemoveId, escaped, html, $el, lastTagId, lastTagObj;
        tag = $5d4c209795b7d609$var$privateMethods.trimTag(tag, opts.delimiterChars);
        if (!tag || tag.length <= 0) return;
        // check if restricted only to the tagList suggestions
        if (opts.onlyTagList && undefined !== opts.tagList) //if the list has been updated by look pushed tag in the tagList. if not found return
        {
            if (opts.tagList) {
                var $tagList = opts.tagList;
                // change each array item to lower case
                $.each($tagList, function(index, item) {
                    $tagList[index] = item.toLowerCase();
                });
                var suggestion = $.inArray(tag.toLowerCase(), $tagList);
                if (-1 === suggestion) //console.log("tag:" + tag + " not in tagList, not adding it");
                return;
            }
        }
        if (opts.CapitalizeFirstLetter && tag.length > 1) tag = tag.charAt(0).toUpperCase() + tag.slice(1).toLowerCase();
        // call the validator (if any) and do not let the tag pass if invalid
        if (opts.validator && !opts.validator(tag)) {
            $self.trigger("tm:invalid", tag);
            return;
        }
        // dont accept new tags beyond the defined maximum
        if (opts.maxTags > 0 && tlis.length >= opts.maxTags) return;
        alreadyInList = false;
        //use jQuery.map to make this work in IE8 (pure JS map is JS 1.6 but IE8 only supports JS 1.5)
        tlisLowerCase = jQuery.map(tlis, function(elem) {
            return elem.toLowerCase();
        });
        idx = $.inArray(tag.toLowerCase(), tlisLowerCase);
        if (-1 !== idx) // console.log("tag:" + tag + " !!already in list!!");
        alreadyInList = true;
        if (alreadyInList) {
            $self.trigger("tm:duplicated", tag);
            if (opts.blinkClass) for(var i = 0; i < 6; ++i)$("#" + $self.data("tm_rndid") + "_" + tlid[idx]).queue(function(next) {
                $(this).toggleClass(opts.blinkClass);
                next();
            }).delay(100);
            else $("#" + $self.data("tm_rndid") + "_" + tlid[idx]).stop().animate({
                backgroundColor: opts.blinkBGColor_1
            }, 100).animate({
                backgroundColor: opts.blinkBGColor_2
            }, 100).animate({
                backgroundColor: opts.blinkBGColor_1
            }, 100).animate({
                backgroundColor: opts.blinkBGColor_2
            }, 100).animate({
                backgroundColor: opts.blinkBGColor_1
            }, 100).animate({
                backgroundColor: opts.blinkBGColor_2
            }, 100);
        } else {
            if (opts.externalTagId === true) {
                if (externalTagId === undefined) $.error("externalTagId is not passed for tag -" + tag);
                tagId = externalTagId;
            } else {
                max = Math.max.apply(null, tlid);
                max = max === -Infinity ? 0 : max;
                tagId = ++max;
            }
            if (!ignoreEvents) $self.trigger("tm:pushing", [
                tag,
                tagId
            ]);
            tlis.push(tag);
            tlid.push(tagId);
            if (!ignoreEvents) {
                if (opts.AjaxPush !== null && opts.AjaxPushAllTags == null) {
                    if ($.inArray(tag, opts.prefilled) === -1) $.post(opts.AjaxPush, $.extend({
                        tag: tag
                    }, opts.AjaxPushParameters));
                }
            }
            // console.log("tagList: " + tlis);
            newTagId = $self.data("tm_rndid") + "_" + tagId;
            newTagRemoveId = $self.data("tm_rndid") + "_Remover_" + tagId;
            escaped = $("<span/>").text(tag).html();
            html = '<span class="' + $5d4c209795b7d609$var$privateMethods.tagClasses.call($self) + '" id="' + newTagId + '">';
            html += "<span>" + escaped + "</span>";
            html += '<a href="#" class="tm-tag-remove" id="' + newTagRemoveId + '" TagIdToRemove="' + tagId + '">';
            html += opts.tagCloseIcon + "</a></span> ";
            $el = $(html);
            if (opts.tagsContainer !== null) $(opts.tagsContainer).append($el);
            else if (tlid.length > 1) {
                lastTagObj = $self.siblings("#" + $self.data("tm_rndid") + "_" + tlid[tlid.length - 2]);
                lastTagObj.after($el);
            } else $self.before($el);
            $el.find("#" + newTagRemoveId).on("click", $self, function(e) {
                e.preventDefault();
                var TagIdToRemove = parseInt($(this).attr("TagIdToRemove"));
                $5d4c209795b7d609$var$privateMethods.spliceTag.call($self, TagIdToRemove, e.data);
            });
            $5d4c209795b7d609$var$privateMethods.refreshHiddenTagList.call($self);
            if (!ignoreEvents) $self.trigger("tm:pushed", [
                tag,
                tagId
            ]);
            $5d4c209795b7d609$var$privateMethods.showOrHide.call($self);
        //if (tagManagerOptions.maxTags > 0 && tlis.length >= tagManagerOptions.maxTags) {
        //  obj.hide();
        //}
        }
        $self.val("");
    },
    popTag: function() {
        var $self = $(this), tagId, tagBeingRemoved, tlis = $self.data("tlis"), tlid = $self.data("tlid");
        if (tlid.length > 0) {
            tagId = tlid.pop();
            tagBeingRemoved = tlis[tlis.length - 1];
            $self.trigger("tm:popping", [
                tagBeingRemoved,
                tagId
            ]);
            tlis.pop();
            // console.log("TagIdToRemove: " + tagId);
            $("#" + $self.data("tm_rndid") + "_" + tagId).remove();
            $5d4c209795b7d609$var$privateMethods.refreshHiddenTagList.call($self);
            $self.trigger("tm:popped", [
                tagBeingRemoved,
                tagId
            ]);
        // console.log(tlis);
        }
    },
    empty: function() {
        var $self = $(this), tlis = $self.data("tlis"), tlid = $self.data("tlid"), tagId;
        while(tlid.length > 0){
            tagId = tlid.pop();
            tlis.pop();
            // console.log("TagIdToRemove: " + tagId);
            $("#" + $self.data("tm_rndid") + "_" + tagId).remove();
            $5d4c209795b7d609$var$privateMethods.refreshHiddenTagList.call($self);
        // console.log(tlis);
        }
        $self.trigger("tm:emptied", null);
        $5d4c209795b7d609$var$privateMethods.showOrHide.call($self);
    //if (tagManagerOptions.maxTags > 0 && tlis.length < tagManagerOptions.maxTags) {
    //  obj.show();
    //}
    },
    tags: function() {
        var $self = this, tlis = $self.data("tlis");
        return tlis;
    }
}, $5d4c209795b7d609$var$privateMethods = {
    showOrHide: function() {
        var $self = this, opts = $self.data("opts"), tlis = $self.data("tlis");
        if (opts.maxTags > 0 && tlis.length < opts.maxTags) {
            $self.show();
            $self.trigger("tm:show");
        }
        if (opts.maxTags > 0 && tlis.length >= opts.maxTags) {
            $self.hide();
            $self.trigger("tm:hide");
        }
    },
    tagClasses: function() {
        var $self = $(this), opts = $self.data("opts"), tagBaseClass = opts.tagBaseClass, inputBaseClass = opts.inputBaseClass, cl;
        // 1) default class (tm-tag)
        cl = tagBaseClass;
        // 2) interpolate from input class: tm-input-xxx --> tm-tag-xxx
        if ($self.attr("class")) $.each($self.attr("class").split(" "), function(index, value) {
            if (value.indexOf(inputBaseClass + "-") !== -1) cl += " " + tagBaseClass + value.substring(inputBaseClass.length);
        });
        // 3) tags from tagClass option
        cl += opts.tagClass ? " " + opts.tagClass : "";
        return cl;
    },
    trimTag: function(tag, delimiterChars) {
        var i;
        tag = $.trim(tag);
        // truncate at the first delimiter char
        i = 0;
        for(i; i < tag.length; i++){
            if ($.inArray(tag.charCodeAt(i), delimiterChars) !== -1) break;
        }
        return tag.substring(0, i);
    },
    refreshHiddenTagList: function() {
        var $self = $(this), tlis = $self.data("tlis"), lhiddenTagList = $self.data("lhiddenTagList");
        if (lhiddenTagList) $(lhiddenTagList).val(tlis.join($self.data("opts").baseDelimiter)).change();
        $self.trigger("tm:refresh", tlis.join($self.data("opts").baseDelimiter));
    },
    killEvent: function(e) {
        e.cancelBubble = true;
        e.returnValue = false;
        e.stopPropagation();
        e.preventDefault();
    },
    keyInArray: function(e, ary) {
        return $.inArray(e.which, ary) !== -1;
    },
    applyDelimiter: function(e) {
        var $self = $(this);
        $5d4c209795b7d609$var$publicMethods.pushTag.call($self, $(this).val());
        e.preventDefault();
    },
    prefill: function(pta) {
        var $self = $(this);
        var opts = $self.data("opts");
        $.each(pta, function(key, val) {
            if (opts.externalTagId === true) $5d4c209795b7d609$var$publicMethods.pushTag.call($self, val[opts.prefillValueFieldName], true, val[opts.prefillIdFieldName]);
            else $5d4c209795b7d609$var$publicMethods.pushTag.call($self, val, true);
        });
    },
    pushAllTags: function(e, tag) {
        var $self = $(this), opts = $self.data("opts"), tlis = $self.data("tlis");
        if (opts.AjaxPushAllTags) {
            if (e.type !== "tm:pushed" || $.inArray(tag, opts.prefilled) === -1) $.post(opts.AjaxPush, $.extend({
                tags: tlis.join(opts.baseDelimiter)
            }, opts.AjaxPushParameters));
        }
    },
    spliceTag: function(tagId) {
        var $self = this, tlis = $self.data("tlis"), tlid = $self.data("tlid"), idx = $.inArray(tagId, tlid), tagBeingRemoved;
        // console.log("TagIdToRemove: " + tagId);
        // console.log("position: " + idx);
        if (-1 !== idx) {
            tagBeingRemoved = tlis[idx];
            $self.trigger("tm:splicing", [
                tagBeingRemoved,
                tagId
            ]);
            $("#" + $self.data("tm_rndid") + "_" + tagId).remove();
            tlis.splice(idx, 1);
            tlid.splice(idx, 1);
            $5d4c209795b7d609$var$privateMethods.refreshHiddenTagList.call($self);
            $self.trigger("tm:spliced", [
                tagBeingRemoved,
                tagId
            ]);
        // console.log(tlis);
        }
        $5d4c209795b7d609$var$privateMethods.showOrHide.call($self);
    //if (tagManagerOptions.maxTags > 0 && tlis.length < tagManagerOptions.maxTags) {
    //  obj.show();
    //}
    },
    init: function(options) {
        var opts = $.extend({}, $5d4c209795b7d609$var$defaults, options), delimiters, keyNums;
        opts.hiddenTagListName = opts.hiddenTagListName === null ? "hidden-" + this.attr("name") : opts.hiddenTagListName;
        delimiters = opts.delimeters || opts.delimiters; // 'delimeter' is deprecated
        keyNums = [
            9,
            13,
            17,
            18,
            19,
            37,
            38,
            39,
            40
        ]; // delimiter values to be handled as key codes
        opts.delimiterChars = [];
        opts.delimiterKeys = [];
        $.each(delimiters, function(i, v) {
            if ($.inArray(v, keyNums) !== -1) opts.delimiterKeys.push(v);
            else opts.delimiterChars.push(v);
        });
        opts.baseDelimiter = String.fromCharCode(opts.delimiterChars[0] || 44);
        opts.tagBaseClass = "tm-tag";
        opts.inputBaseClass = "tm-input";
        if (!$.isFunction(opts.validator)) opts.validator = null;
        this.each(function() {
            var $self = $(this), hiddenObj = "", rndid = "", albet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
            // prevent double-initialization of TagManager
            if ($self.data("tagManager")) return false;
            $self.data("tagManager", true);
            for(var i = 0; i < 5; i++)rndid += albet.charAt(Math.floor(Math.random() * albet.length));
            $self.data("tm_rndid", rndid);
            // store instance-specific data in the DOM object
            $self.data("opts", opts).data("tlis", []) //list of string tags
            .data("tlid", []); //list of ID of the string tags
            if (opts.output === null) {
                hiddenObj = $("<input/>", {
                    type: "hidden",
                    name: opts.hiddenTagListName
                });
                $self.after(hiddenObj);
                $self.data("lhiddenTagList", hiddenObj);
            } else $self.data("lhiddenTagList", $(opts.output));
            if (opts.AjaxPushAllTags) {
                $self.on("tm:spliced", $5d4c209795b7d609$var$privateMethods.pushAllTags);
                $self.on("tm:popped", $5d4c209795b7d609$var$privateMethods.pushAllTags);
                $self.on("tm:pushed", $5d4c209795b7d609$var$privateMethods.pushAllTags);
            }
            // hide popovers on focus and keypress events
            $self.on("focus keypress", function(e) {
                if ($(this).popover) $(this).popover("hide");
            });
            // handle ESC (keyup used for browser compatibility)
            if (opts.isClearInputOnEsc) $self.on("keyup", function(e) {
                if (e.which === 27) {
                    // console.log('esc detected');
                    $(this).val("");
                    $5d4c209795b7d609$var$privateMethods.killEvent(e);
                }
            });
            $self.on("keypress", function(e) {
                // push ASCII-based delimiters
                if ($5d4c209795b7d609$var$privateMethods.keyInArray(e, opts.delimiterChars)) $5d4c209795b7d609$var$privateMethods.applyDelimiter.call($self, e);
            });
            $self.on("keydown", function(e) {
                // disable ENTER
                if (e.which === 13) {
                    if (opts.preventSubmitOnEnter) $5d4c209795b7d609$var$privateMethods.killEvent(e);
                }
                // push key-based delimiters (includes <enter> by default)
                if ($5d4c209795b7d609$var$privateMethods.keyInArray(e, opts.delimiterKeys)) $5d4c209795b7d609$var$privateMethods.applyDelimiter.call($self, e);
            });
            // BACKSPACE (keydown used for browser compatibility)
            if (opts.deleteTagsOnBackspace) $self.on("keydown", function(e) {
                if ($5d4c209795b7d609$var$privateMethods.keyInArray(e, opts.backspace)) // console.log("backspace detected");
                {
                    if ($(this).val().length <= 0) {
                        $5d4c209795b7d609$var$publicMethods.popTag.call($self);
                        $5d4c209795b7d609$var$privateMethods.killEvent(e);
                    }
                }
            });
            // on tag pop fill back the tag's content to the input field
            if (opts.fillInputOnTagRemove) $self.on("tm:popped", function(e, tag) {
                $(this).val(tag);
            });
            $self.change(function(e) {
                if (!/webkit/.test(navigator.userAgent.toLowerCase())) $self.focus();
                 // why?
                /* unimplemented mode to push tag on blur
                     else if (tagManagerOptions.pushTagOnBlur) {
                     console.log('change: pushTagOnBlur ' + tag);
                     pushTag($(this).val());
                     } */ $5d4c209795b7d609$var$privateMethods.killEvent(e);
            });
            if (opts.prefilled !== null) {
                if (typeof opts.prefilled === "object") $5d4c209795b7d609$var$privateMethods.prefill.call($self, opts.prefilled);
                else if (typeof opts.prefilled === "string") $5d4c209795b7d609$var$privateMethods.prefill.call($self, opts.prefilled.split(opts.baseDelimiter));
                else if (typeof opts.prefilled === "function") $5d4c209795b7d609$var$privateMethods.prefill.call($self, opts.prefilled());
            } else if (opts.output !== null) {
                if ($(opts.output) && $(opts.output).val()) var existing_tags = $(opts.output);
                $5d4c209795b7d609$var$privateMethods.prefill.call($self, $(opts.output).val().split(opts.baseDelimiter));
            }
        });
        return this;
    }
};
$.fn.tagsManager = function(method) {
    var $self = $(this);
    if (!(0 in this)) return this;
    if ($5d4c209795b7d609$var$publicMethods[method]) return $5d4c209795b7d609$var$publicMethods[method].apply($self, Array.prototype.slice.call(arguments, 1));
    else if (typeof method === "object" || !method) return $5d4c209795b7d609$var$privateMethods.init.apply(this, arguments);
    else {
        $.error("Method " + method + " does not exist.");
        return false;
    }
};



window.c3 = (parcelRequire("3DC1Q"));

window.d3 = (parcelRequire("8O8mS"));

window.PouchDB = (parcelRequire("bnMSv")).default;

window.ClipboardJS = (parcelRequire("jPR8W"));
var $447c861acb15c5da$exports = {};
var $902f5cabe5153acc$exports = {};
"use strict";
$902f5cabe5153acc$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};



var $aNJCr = parcelRequire("aNJCr");
let $447c861acb15c5da$var$url = $aNJCr.getBundleURL("eGqC9") + "worker.5d934189.js";
$447c861acb15c5da$exports = $902f5cabe5153acc$exports($447c861acb15c5da$var$url, $aNJCr.getOrigin($447c861acb15c5da$var$url), false);


// TODO Web worker
window.metadataChannel = new Worker($447c861acb15c5da$exports);

})();
//# sourceMappingURL=dev.d4b10c94.js.map
